/**
 * @license
 * PlayCanvas Engine v2.21.3 revision b1767d5 (RELEASE)
 * Copyright 2011-2026 PlayCanvas Ltd. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var __require = /* @__PURE__ */ ((x3) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x3, {
	get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x3)(function(x3) {
	if (typeof require !== "undefined") return require.apply(this, arguments);
	throw Error('Dynamic require of "' + x3 + '" is not supported');
});

var TRACEID_RENDER_FRAME = "RenderFrame";
var TRACEID_RENDER_FRAME_TIME = "RenderFrameTime";
var TRACEID_RENDER_PASS = "RenderPass";
var TRACEID_RENDER_PASS_DETAIL = "RenderPassDetail";
var TRACEID_RENDER_ACTION = "RenderAction";
var TRACEID_RENDER_TARGET_ALLOC = "RenderTargetAlloc";
var TRACEID_TEXTURE_ALLOC = "TextureAlloc";
var TRACEID_SHADER_ALLOC = "ShaderAlloc";
var TRACEID_SHADER_COMPILE = "ShaderCompile";
var TRACEID_VRAM_TEXTURE = "VRAM.Texture";
var TRACEID_VRAM_VB = "VRAM.Vb";
var TRACEID_VRAM_IB = "VRAM.Ib";
var TRACEID_VRAM_SB = "VRAM.Sb";
var TRACEID_BINDGROUP_ALLOC = "BindGroupAlloc";
var TRACEID_BINDGROUPFORMAT_ALLOC = "BindGroupFormatAlloc";
var TRACEID_RENDERPIPELINE_ALLOC = "RenderPipelineAlloc";
var TRACEID_COMPUTEPIPELINE_ALLOC = "ComputePipelineAlloc";
var TRACEID_PIPELINELAYOUT_ALLOC = "PipelineLayoutAlloc";
var TRACEID_ELEMENT = "Element";
var TRACEID_TEXTURES = "Textures";
var TRACEID_BUFFERS = "Buffers";
var TRACEID_ASSETS = "Assets";
var TRACEID_RENDER_QUEUE = "RenderQueue";
var TRACEID_OCTREE_RESOURCES = "OctreeResources";
var TRACEID_GPU_TIMINGS = "GpuTimings";

var version = "2.21.3";
var revision = "b1767d5";
function extend(target2, ex) {
	for (const prop in ex) {
		const copy = ex[prop];
		if (Array.isArray(copy)) {
			target2[prop] = extend([], copy);
		} else if (copy && typeof copy === "object") {
			target2[prop] = extend({}, copy);
		} else {
			target2[prop] = copy;
		}
	}
	return target2;
}

var guid = {
	create() {
		return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c2) => {
			const r = Math.random() * 16 | 0;
			const v6 = c2 === "x" ? r : r & 3 | 8;
			return v6.toString(16);
		});
	}
};

var path = {
	delimiter: "/",
	join(...sections) {
		let result = sections[0];
		for (let i2 = 0; i2 < sections.length - 1; i2++) {
			const one = sections[i2];
			const two = sections[i2 + 1];
			if (two[0] === path.delimiter) {
				result = two;
				continue;
			}
			if (one && two && one[one.length - 1] !== path.delimiter && two[0] !== path.delimiter) {
				result += path.delimiter + two;
			} else {
				result += two;
			}
		}
		return result;
	},
	normalize(pathname) {
		const lead = pathname.startsWith(path.delimiter);
		const trail = pathname.endsWith(path.delimiter);
		const parts = pathname.split("/");
		let result = "";
		let cleaned = [];
		for (let i2 = 0; i2 < parts.length; i2++) {
			if (parts[i2] === "") continue;
			if (parts[i2] === ".") continue;
			if (parts[i2] === ".." && cleaned.length > 0) {
				cleaned = cleaned.slice(0, cleaned.length - 2);
				continue;
			}
			if (i2 > 0) cleaned.push(path.delimiter);
			cleaned.push(parts[i2]);
		}
		result = cleaned.join("");
		if (!lead && result[0] === path.delimiter) {
			result = result.slice(1);
		}
		if (trail && result[result.length - 1] !== path.delimiter) {
			result += path.delimiter;
		}
		return result;
	},
	split(pathname) {
		const lastDelimiterIndex = pathname.lastIndexOf(path.delimiter);
		if (lastDelimiterIndex !== -1) {
			return [pathname.substring(0, lastDelimiterIndex), pathname.substring(lastDelimiterIndex + 1)];
		}
		return ["", pathname];
	},
	getBasename(pathname) {
		return path.split(pathname)[1];
	},
	getDirectory(pathname) {
		return path.split(pathname)[0];
	},
	getExtension(pathname) {
		const ext = pathname.split("?")[0].split(".").pop();
		if (ext !== pathname) {
			return `.${ext}`;
		}
		return "";
	},
	isRelativePath(pathname) {
		return pathname.charAt(0) !== "/" && pathname.match(/:\/\//) === null;
	},
	extractPath(pathname) {
		let result = "";
		const parts = pathname.split("/");
		let i2 = 0;
		if (parts.length > 1) {
			if (path.isRelativePath(pathname)) {
				if (parts[0] === ".") {
					for (i2 = 0; i2 < parts.length - 1; ++i2) {
						result += i2 === 0 ? parts[i2] : `/${parts[i2]}`;
					}
				} else if (parts[0] === "..") {
					for (i2 = 0; i2 < parts.length - 1; ++i2) {
						result += i2 === 0 ? parts[i2] : `/${parts[i2]}`;
					}
				} else {
					result = ".";
					for (i2 = 0; i2 < parts.length - 1; ++i2) {
						result += `/${parts[i2]}`;
					}
				}
			} else {
				for (i2 = 0; i2 < parts.length - 1; ++i2) {
					result += i2 === 0 ? parts[i2] : `/${parts[i2]}`;
				}
			}
		}
		return result;
	}
};

var detectPassiveEvents = () => {
	let result = false;
	try {
		const opts = Object.defineProperty({}, "passive", {
			get: function() {
				result = true;
				return false;
			}
		});
		window.addEventListener("testpassive", null, opts);
		window.removeEventListener("testpassive", null, opts);
	} catch (e) {
	}
	return result;
};
var ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
var environment = typeof window !== "undefined" ? "browser" : typeof global !== "undefined" ? "node" : "worker";
var platformName = /android/i.test(ua) ? "android" : /ip(?:[ao]d|hone)/i.test(ua) ? "ios" : /windows/i.test(ua) ? "windows" : /mac os/i.test(ua) ? "osx" : /linux/i.test(ua) ? "linux" : /cros/i.test(ua) ? "cros" : null;
var browserName = environment !== "browser" ? null : /Chrome\/|Chromium\/|Edg.*\//.test(ua) ? "chrome" : (
	// chrome, chromium, edge
	/Safari\//.test(ua) ? "safari" : (
		// safari, ios chrome/firefox
		/Firefox\//.test(ua) ? "firefox" : "other"
	)
);
var xbox = /xbox/i.test(ua);
var visionos = /Macintosh/i.test(ua) && typeof navigator !== "undefined" && navigator.maxTouchPoints > 0 && !/iPhone|iPad|iPod/i.test(ua);
var touch = environment === "browser" && ("ontouchstart" in window || "maxTouchPoints" in navigator && navigator.maxTouchPoints > 0);
var gamepads = environment === "browser" && (!!navigator.getGamepads || !!navigator.webkitGetGamepads);
var workers = typeof Worker !== "undefined";
var passiveEvents = detectPassiveEvents();
var platform = {
	name: platformName,
	environment,
	global: (typeof globalThis !== "undefined" && globalThis) ?? (environment === "browser" && window) ?? (environment === "node" && global) ?? (environment === "worker" && self),
	browser: environment === "browser",
	worker: environment === "worker",
	desktop: ["windows", "osx", "linux", "cros"].includes(platformName),
	mobile: ["android", "ios"].includes(platformName),
	ios: platformName === "ios",
	android: platformName === "android",
	visionos,
	xbox,
	gamepads,
	touch,
	workers,
	passiveEvents,
	browserName
};

var ASCII_LOWERCASE = "abcdefghijklmnopqrstuvwxyz";
var ASCII_UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
var ASCII_LETTERS = ASCII_LOWERCASE + ASCII_UPPERCASE;
var HIGH_SURROGATE_BEGIN = 55296;
var HIGH_SURROGATE_END = 56319;
var LOW_SURROGATE_BEGIN = 56320;
var LOW_SURROGATE_END = 57343;
var ZERO_WIDTH_JOINER = 8205;
var REGIONAL_INDICATOR_BEGIN = 127462;
var REGIONAL_INDICATOR_END = 127487;
var FITZPATRICK_MODIFIER_BEGIN = 127995;
var FITZPATRICK_MODIFIER_END = 127999;
var DIACRITICAL_MARKS_BEGIN = 8400;
var DIACRITICAL_MARKS_END = 8447;
var VARIATION_MODIFIER_BEGIN = 65024;
var VARIATION_MODIFIER_END = 65039;
function getCodePointData(string2, i2 = 0) {
	const size = string2.length;
	if (i2 < 0 || i2 >= size) {
		return null;
	}
	const first = string2.charCodeAt(i2);
	if (size > 1 && first >= HIGH_SURROGATE_BEGIN && first <= HIGH_SURROGATE_END) {
		const second = string2.charCodeAt(i2 + 1);
		if (second >= LOW_SURROGATE_BEGIN && second <= LOW_SURROGATE_END) {
			return {
				code: (first - HIGH_SURROGATE_BEGIN) * 1024 + second - LOW_SURROGATE_BEGIN + 65536,
				long: true
			};
		}
	}
	return {
		code: first,
		long: false
	};
}
function isCodeBetween(string2, begin, end) {
	if (!string2) {
		return false;
	}
	const codeData = getCodePointData(string2);
	if (codeData) {
		const code = codeData.code;
		return code >= begin && code <= end;
	}
	return false;
}
function numCharsToTakeForNextSymbol(string2, index) {
	if (index === string2.length - 1) {
		return 1;
	}
	if (isCodeBetween(string2[index], HIGH_SURROGATE_BEGIN, HIGH_SURROGATE_END)) {
		const first = string2.substring(index, index + 2);
		const second = string2.substring(index + 2, index + 4);
		if (isCodeBetween(second, FITZPATRICK_MODIFIER_BEGIN, FITZPATRICK_MODIFIER_END) || isCodeBetween(first, REGIONAL_INDICATOR_BEGIN, REGIONAL_INDICATOR_END) && isCodeBetween(second, REGIONAL_INDICATOR_BEGIN, REGIONAL_INDICATOR_END)) {
			return 4;
		}
		if (isCodeBetween(second, VARIATION_MODIFIER_BEGIN, VARIATION_MODIFIER_END)) {
			return 3;
		}
		return 2;
	}
	if (isCodeBetween(string2[index + 1], VARIATION_MODIFIER_BEGIN, VARIATION_MODIFIER_END)) {
		return 2;
	}
	return 1;
}
var string = {
	ASCII_LOWERCASE,
	ASCII_UPPERCASE,
	ASCII_LETTERS,
	format(s2, ...args) {
		for (let i2 = 0; i2 < args.length; i2++) {
			s2 = s2.replace(`{${i2}}`, args[i2]);
		}
		return s2;
	},
	getCodePoint(string2, i2) {
		const codePointData = getCodePointData(string2, i2);
		return codePointData && codePointData.code;
	},
	getCodePoints(string2) {
		if (typeof string2 !== "string") {
			throw new TypeError("Not a string");
		}
		let i2 = 0;
		const arr = [];
		let codePoint;
		while (!!(codePoint = getCodePointData(string2, i2))) {
			arr.push(codePoint.code);
			i2 += codePoint.long ? 2 : 1;
		}
		return arr;
	},
	getSymbols(string2) {
		if (typeof string2 !== "string") {
			throw new TypeError("Not a string");
		}
		let index = 0;
		const length = string2.length;
		const output = [];
		let take = 0;
		let ch;
		while (index < length) {
			take += numCharsToTakeForNextSymbol(string2, index + take);
			ch = string2[index + take];
			if (isCodeBetween(ch, DIACRITICAL_MARKS_BEGIN, DIACRITICAL_MARKS_END)) {
				ch = string2[index + take++];
			}
			if (isCodeBetween(ch, VARIATION_MODIFIER_BEGIN, VARIATION_MODIFIER_END)) {
				ch = string2[index + take++];
			}
			if (ch && ch.charCodeAt(0) === ZERO_WIDTH_JOINER) {
				ch = string2[index + take++];
				continue;
			}
			const char = string2.substring(index, index + take);
			output.push(char);
			index += take;
			take = 0;
		}
		return output;
	},
	fromCodePoint(...args) {
		return args.map((codePoint) => {
			if (codePoint > 65535) {
				codePoint -= 65536;
				return String.fromCharCode(
					(codePoint >> 10) + 55296,
					codePoint % 1024 + 56320
				);
			}
			return String.fromCharCode(codePoint);
		}).join("");
	}
};

var Tracing = class _Tracing {
	static _traceChannels = /* @__PURE__ */ new Set();
	static stack = false;
	static set(channel, enabled = true) {
	}
	static get(channel) {
		return _Tracing._traceChannels.has(channel);
	}
};

var EventHandle = class {
	handler;
	name;
	callback;
	scope;
	_once;
	_removed = false;
	constructor(handler, name, callback, scope, once = false) {
		this.handler = handler;
		this.name = name;
		this.callback = callback;
		this.scope = scope;
		this._once = once;
	}
	off() {
		if (this._removed) return;
		this.handler.offByHandle(this);
	}
	on(name, callback, scope = this) {
		return this.handler._addCallback(name, callback, scope, false);
	}
	once(name, callback, scope = this) {
		return this.handler._addCallback(name, callback, scope, true);
	}
	set removed(value) {
		if (!value) return;
		this._removed = true;
	}
	get removed() {
		return this._removed;
	}
	// don't stringify EventHandle to JSON by JSON.stringify
	toJSON(key) {
		return void 0;
	}
};

var EventHandler = class {
	_callbacks = /* @__PURE__ */ new Map();
	_callbackActive = /* @__PURE__ */ new Map();
	initEventHandler() {
		this._callbacks = /* @__PURE__ */ new Map();
		this._callbackActive = /* @__PURE__ */ new Map();
	}
	_addCallback(name, callback, scope, once) {
		if (!this._callbacks.has(name)) {
			this._callbacks.set(name, []);
		}
		if (this._callbackActive.has(name)) {
			const callbackActive = this._callbackActive.get(name);
			if (callbackActive && callbackActive === this._callbacks.get(name)) {
				this._callbackActive.set(name, callbackActive.slice());
			}
		}
		const evt = new EventHandle(this, name, callback, scope, once);
		this._callbacks.get(name).push(evt);
		return evt;
	}
	on(name, callback, scope = this) {
		return this._addCallback(name, callback, scope, false);
	}
	once(name, callback, scope = this) {
		return this._addCallback(name, callback, scope, true);
	}
	off(name, callback, scope) {
		if (name) {
			if (this._callbackActive.has(name) && this._callbackActive.get(name) === this._callbacks.get(name)) {
				this._callbackActive.set(name, this._callbackActive.get(name).slice());
			}
		} else {
			for (const [key, callbacks] of this._callbackActive) {
				if (!this._callbacks.has(key)) {
					continue;
				}
				if (this._callbacks.get(key) !== callbacks) {
					continue;
				}
				this._callbackActive.set(key, callbacks.slice());
			}
		}
		if (!name) {
			for (const callbacks of this._callbacks.values()) {
				for (let i2 = 0; i2 < callbacks.length; i2++) {
					callbacks[i2].removed = true;
				}
			}
			this._callbacks.clear();
		} else if (!callback) {
			const callbacks = this._callbacks.get(name);
			if (callbacks) {
				for (let i2 = 0; i2 < callbacks.length; i2++) {
					callbacks[i2].removed = true;
				}
				this._callbacks.delete(name);
			}
		} else {
			const callbacks = this._callbacks.get(name);
			if (!callbacks) {
				return this;
			}
			for (let i2 = 0; i2 < callbacks.length; i2++) {
				if (callbacks[i2].callback !== callback) {
					continue;
				}
				if (scope && callbacks[i2].scope !== scope) {
					continue;
				}
				callbacks[i2].removed = true;
				callbacks.splice(i2, 1);
				i2--;
			}
			if (callbacks.length === 0) {
				this._callbacks.delete(name);
			}
		}
		return this;
	}
	offByHandle(handle) {
		const name = handle.name;
		handle.removed = true;
		if (this._callbackActive.has(name) && this._callbackActive.get(name) === this._callbacks.get(name)) {
			this._callbackActive.set(name, this._callbackActive.get(name).slice());
		}
		const callbacks = this._callbacks.get(name);
		if (!callbacks) {
			return this;
		}
		const ind = callbacks.indexOf(handle);
		if (ind !== -1) {
			callbacks.splice(ind, 1);
			if (callbacks.length === 0) {
				this._callbacks.delete(name);
			}
		}
		return this;
	}
	fire(name, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8) {
		if (!name) {
			return this;
		}
		const callbacksInitial = this._callbacks.get(name);
		if (!callbacksInitial) {
			return this;
		}
		let callbacks;
		if (!this._callbackActive.has(name)) {
			this._callbackActive.set(name, callbacksInitial);
		} else if (this._callbackActive.get(name) !== callbacksInitial) {
			callbacks = callbacksInitial.slice();
		}
		for (let i2 = 0; (callbacks || this._callbackActive.get(name)) && i2 < (callbacks || this._callbackActive.get(name)).length; i2++) {
			const evt = (callbacks || this._callbackActive.get(name))[i2];
			if (!evt.callback) continue;
			evt.callback.call(evt.scope, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8);
			if (evt._once) {
				const existingCallback = this._callbacks.get(name);
				const ind = existingCallback ? existingCallback.indexOf(evt) : -1;
				if (ind !== -1) {
					if (this._callbackActive.get(name) === existingCallback) {
						this._callbackActive.set(name, this._callbackActive.get(name).slice());
					}
					const callbacks2 = this._callbacks.get(name);
					if (!callbacks2) continue;
					callbacks2[ind].removed = true;
					callbacks2.splice(ind, 1);
					if (callbacks2.length === 0) {
						this._callbacks.delete(name);
					}
				}
			}
		}
		if (!callbacks) {
			this._callbackActive.delete(name);
		}
		return this;
	}
	hasEvent(name) {
		return !!this._callbacks.get(name)?.length;
	}
};

var IndexedList = class {
	_list = [];
	_index = {};
	push(key, item) {
		if (this._index[key]) {
			throw Error(`Key already in index ${key}`);
		}
		const location = this._list.push(item) - 1;
		this._index[key] = location;
	}
	has(key) {
		return this._index[key] !== void 0;
	}
	get(key) {
		const location = this._index[key];
		if (location !== void 0) {
			return this._list[location];
		}
		return null;
	}
	remove(key) {
		const location = this._index[key];
		if (location !== void 0) {
			this._list.splice(location, 1);
			delete this._index[key];
			for (key in this._index) {
				const idx = this._index[key];
				if (idx > location) {
					this._index[key] = idx - 1;
				}
			}
			return true;
		}
		return false;
	}
	list() {
		return this._list;
	}
	clear() {
		this._list.length = 0;
		for (const prop in this._index) {
			delete this._index[prop];
		}
	}
};

var cachedResult = (func) => {
	const uninitToken = {};
	let result = uninitToken;
	return () => {
		if (result === uninitToken) {
			result = func();
		}
		return result;
	};
};
var Impl = class _Impl {
	static modules = {};
	// returns true if the running host supports wasm modules (all browsers except IE)
	static wasmSupported = cachedResult(() => {
		try {
			if (typeof WebAssembly === "object" && typeof WebAssembly.instantiate === "function") {
				const module2 = new WebAssembly.Module(Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0));
				if (module2 instanceof WebAssembly.Module) {
					return new WebAssembly.Instance(module2) instanceof WebAssembly.Instance;
				}
			}
		} catch (e) {
		}
		return false;
	});
	// load a script
	static loadScript(url, callback) {
		const s2 = document.createElement("script");
		s2.setAttribute("src", url);
		s2.onload = () => {
			callback(null);
		};
		s2.onerror = () => {
			callback(`Failed to load script='${url}'`);
		};
		document.body.appendChild(s2);
	}
	// load a wasm module
	static loadWasm(moduleName, config, callback) {
		const loadUrl = _Impl.wasmSupported() && config.glueUrl && config.wasmUrl ? config.glueUrl : config.fallbackUrl;
		if (loadUrl) {
			_Impl.loadScript(loadUrl, (err2) => {
				if (err2) {
					callback(err2, null);
				} else {
					const module2 = window[moduleName];
					window[moduleName] = void 0;
					module2({
						locateFile: () => config.wasmUrl,
						onAbort: () => {
							callback("wasm module aborted.");
						}
					}).then((instance) => {
						callback(null, instance);
					});
				}
			});
		} else {
			callback("No supported wasm modules found.", null);
		}
	}
	// get state object for the named module
	static getModule(name) {
		if (!_Impl.modules.hasOwnProperty(name)) {
			_Impl.modules[name] = {
				config: null,
				initializing: false,
				instance: null,
				callbacks: []
			};
		}
		return _Impl.modules[name];
	}
	static initialize(moduleName, module2) {
		if (module2.initializing) {
			return;
		}
		const config = module2.config;
		if (config.glueUrl || config.wasmUrl || config.fallbackUrl) {
			module2.initializing = true;
			_Impl.loadWasm(moduleName, config, (err2, instance) => {
				if (err2) {
					if (config.errorHandler) {
						config.errorHandler(err2);
					} else {
						console.error(`failed to initialize module=${moduleName} error=${err2}`);
					}
				} else {
					module2.instance = instance;
					module2.callbacks.forEach((callback) => {
						callback(instance);
					});
				}
			});
		}
	}
};
var WasmModule = class {
	static setConfig(moduleName, config) {
		const module2 = Impl.getModule(moduleName);
		module2.config = config;
		if (module2.callbacks.length > 0) {
			Impl.initialize(moduleName, module2);
		}
	}
	static getConfig(moduleName) {
		return Impl.modules?.[moduleName]?.config;
	}
	static getInstance(moduleName, callback) {
		const module2 = Impl.getModule(moduleName);
		if (module2.instance) {
			callback(module2.instance);
		} else {
			module2.callbacks.push(callback);
			if (module2.config) {
				Impl.initialize(moduleName, module2);
			}
		}
	}
};

var ReadStream = class {
	arraybuffer;
	dataView;
	offset = 0;
	constructor(arraybuffer) {
		this.arraybuffer = arraybuffer;
		this.dataView = new DataView(arraybuffer);
	}
	get remainingBytes() {
		return this.dataView.byteLength - this.offset;
	}
	reset(offset3 = 0) {
		this.offset = offset3;
	}
	skip(bytes) {
		this.offset += bytes;
	}
	align(bytes) {
		this.offset = this.offset + bytes - 1 & ~(bytes - 1);
	}
	_inc(amount) {
		this.offset += amount;
		return this.offset - amount;
	}
	readChar() {
		return String.fromCharCode(this.dataView.getUint8(this.offset++));
	}
	readChars(numChars) {
		let result = "";
		for (let i2 = 0; i2 < numChars; ++i2) {
			result += this.readChar();
		}
		return result;
	}
	readU8() {
		return this.dataView.getUint8(this.offset++);
	}
	readU16() {
		return this.dataView.getUint16(this._inc(2), true);
	}
	readU32() {
		return this.dataView.getUint32(this._inc(4), true);
	}
	readU64() {
		return this.readU32() + 2 ** 32 * this.readU32();
	}
	readU32be() {
		return this.dataView.getUint32(this._inc(4), false);
	}
	readArray(result) {
		for (let i2 = 0; i2 < result.length; ++i2) {
			result[i2] = this.readU8();
		}
	}
	readLine() {
		const view = this.dataView;
		let result = "";
		while (true) {
			if (this.offset >= view.byteLength) {
				break;
			}
			const c2 = String.fromCharCode(this.readU8());
			if (c2 === "\n") {
				break;
			}
			result += c2;
		}
		return result;
	}
};

var SortedLoopArray = class {
	items = [];
	length = 0;
	loopIndex = -1;
	_sortBy;
	_sortHandler;
	constructor(args) {
		this._sortBy = args.sortBy;
		this._sortHandler = this._doSort.bind(this);
	}
	_binarySearch(item) {
		let left = 0;
		let right2 = this.items.length - 1;
		const search = item[this._sortBy];
		let middle;
		let current;
		while (left <= right2) {
			middle = Math.floor((left + right2) / 2);
			current = this.items[middle][this._sortBy];
			if (current <= search) {
				left = middle + 1;
			} else if (current > search) {
				right2 = middle - 1;
			}
		}
		return left;
	}
	_doSort(a, b) {
		const sortBy = this._sortBy;
		return a[sortBy] - b[sortBy];
	}
	insert(item) {
		const index = this._binarySearch(item);
		this.items.splice(index, 0, item);
		this.length++;
		if (this.loopIndex >= index) {
			this.loopIndex++;
		}
	}
	append(item) {
		this.items.push(item);
		this.length++;
	}
	remove(item) {
		const idx = this.items.indexOf(item);
		if (idx < 0) return;
		this.items.splice(idx, 1);
		this.length--;
		if (this.loopIndex >= idx) {
			this.loopIndex--;
		}
	}
	sort() {
		const current = this.loopIndex >= 0 ? this.items[this.loopIndex] : null;
		this.items.sort(this._sortHandler);
		if (current !== null) {
			this.loopIndex = this.items.indexOf(current);
		}
	}
};

var Tags = class extends EventHandler {
	static EVENT_ADD = "add";
	static EVENT_REMOVE = "remove";
	static EVENT_CHANGE = "change";
	_index = {};
	_list = [];
	_parent;
	constructor(parent) {
		super();
		this._parent = parent;
	}
	add(...args) {
		let changed = false;
		const tags = this._processArguments(args, true);
		if (!tags.length) {
			return changed;
		}
		for (let i2 = 0; i2 < tags.length; i2++) {
			if (this._index[tags[i2]]) {
				continue;
			}
			changed = true;
			this._index[tags[i2]] = true;
			this._list.push(tags[i2]);
			this.fire("add", tags[i2], this._parent);
		}
		if (changed) {
			this.fire("change", this._parent);
		}
		return changed;
	}
	remove(...args) {
		let changed = false;
		if (!this._list.length) {
			return changed;
		}
		const tags = this._processArguments(args, true);
		if (!tags.length) {
			return changed;
		}
		for (let i2 = 0; i2 < tags.length; i2++) {
			if (!this._index[tags[i2]]) {
				continue;
			}
			changed = true;
			delete this._index[tags[i2]];
			this._list.splice(this._list.indexOf(tags[i2]), 1);
			this.fire("remove", tags[i2], this._parent);
		}
		if (changed) {
			this.fire("change", this._parent);
		}
		return changed;
	}
	clear() {
		if (!this._list.length) {
			return;
		}
		const tags = this._list.slice(0);
		this._list = [];
		this._index = {};
		for (let i2 = 0; i2 < tags.length; i2++) {
			this.fire("remove", tags[i2], this._parent);
		}
		this.fire("change", this._parent);
	}
	has(...query) {
		if (!this._list.length) {
			return false;
		}
		return this._has(this._processArguments(query));
	}
	_has(tags) {
		if (!this._list.length || !tags.length) {
			return false;
		}
		for (let i2 = 0; i2 < tags.length; i2++) {
			if (tags[i2].length === 1) {
				if (this._index[tags[i2][0]]) {
					return true;
				}
			} else {
				let multiple = true;
				for (let t = 0; t < tags[i2].length; t++) {
					if (this._index[tags[i2][t]]) {
						continue;
					}
					multiple = false;
					break;
				}
				if (multiple) {
					return true;
				}
			}
		}
		return false;
	}
	list() {
		return this._list.slice(0);
	}
	_processArguments(args, flat) {
		const tags = [];
		let tmp = [];
		if (!args || !args.length) {
			return tags;
		}
		for (let i2 = 0; i2 < args.length; i2++) {
			if (args[i2] instanceof Array) {
				if (!flat) {
					tmp = [];
				}
				for (let t = 0; t < args[i2].length; t++) {
					if (typeof args[i2][t] !== "string") {
						continue;
					}
					if (flat) {
						tags.push(args[i2][t]);
					} else {
						tmp.push(args[i2][t]);
					}
				}
				if (!flat && tmp.length) {
					tags.push(tmp);
				}
			} else if (typeof args[i2] === "string") {
				if (flat) {
					tags.push(args[i2]);
				} else {
					tags.push([args[i2]]);
				}
			}
		}
		return tags;
	}
	get size() {
		return this._list.length;
	}
};

var now = typeof window !== "undefined" && window.performance && window.performance.now ? performance.now.bind(performance) : Date.now;

function createURI(options2) {
	let s2 = "";
	if ((options2.authority || options2.scheme) && (options2.host || options2.hostpath)) {
		throw new Error("Can't have 'scheme' or 'authority' and 'host' or 'hostpath' option");
	}
	if (options2.host && options2.hostpath) {
		throw new Error("Can't have 'host' and 'hostpath' option");
	}
	if (options2.path && options2.hostpath) {
		throw new Error("Can't have 'path' and 'hostpath' option");
	}
	if (options2.scheme) {
		s2 += `${options2.scheme}:`;
	}
	if (options2.authority) {
		s2 += `//${options2.authority}`;
	}
	if (options2.host) {
		s2 += options2.host;
	}
	if (options2.path) {
		s2 += options2.path;
	}
	if (options2.hostpath) {
		s2 += options2.hostpath;
	}
	if (options2.query) {
		s2 += `?${options2.query}`;
	}
	if (options2.fragment) {
		s2 += `#${options2.fragment}`;
	}
	return s2;
}
var re = /^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
var URI = class {
	scheme;
	authority;
	path;
	query;
	fragment;
	constructor(uri) {
		const result = uri.match(re);
		this.scheme = result[2];
		this.authority = result[4];
		this.path = result[5];
		this.query = result[7];
		this.fragment = result[9];
	}
	toString() {
		let s2 = "";
		if (this.scheme) {
			s2 += `${this.scheme}:`;
		}
		if (this.authority) {
			s2 += `//${this.authority}`;
		}
		s2 += this.path;
		if (this.query) {
			s2 += `?${this.query}`;
		}
		if (this.fragment) {
			s2 += `#${this.fragment}`;
		}
		return s2;
	}
	getQuery() {
		const result = {};
		if (this.query) {
			const queryParams = decodeURIComponent(this.query).split("&");
			for (const queryParam of queryParams) {
				const pair = queryParam.split("=");
				result[pair[0]] = pair[1];
			}
		}
		return result;
	}
	setQuery(params) {
		let q5 = "";
		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				if (q5 !== "") {
					q5 += "&";
				}
				q5 += `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
			}
		}
		this.query = q5;
	}
};

var CURVE_LINEAR = 0;
var CURVE_SMOOTHSTEP = 1;
var CURVE_SPLINE = 4;
var CURVE_STEP = 5;

var math = {
	DEG_TO_RAD: Math.PI / 180,
	RAD_TO_DEG: 180 / Math.PI,
	clamp(value, min, max) {
		if (value >= max) return max;
		if (value <= min) return min;
		return value;
	},
	intToBytes24(i2) {
		const r = i2 >> 16 & 255;
		const g = i2 >> 8 & 255;
		const b = i2 & 255;
		return [r, g, b];
	},
	intToBytes32(i2) {
		const r = i2 >> 24 & 255;
		const g = i2 >> 16 & 255;
		const b = i2 >> 8 & 255;
		const a = i2 & 255;
		return [r, g, b, a];
	},
	bytesToInt24(r, g, b) {
		if (r.length) {
			b = r[2];
			g = r[1];
			r = r[0];
		}
		return r << 16 | g << 8 | b;
	},
	bytesToInt32(r, g, b, a) {
		if (r.length) {
			a = r[3];
			b = r[2];
			g = r[1];
			r = r[0];
		}
		return (r << 24 | g << 16 | b << 8 | a) >>> 0;
	},
	lerp(a, b, alpha) {
		return a + (b - a) * math.clamp(alpha, 0, 1);
	},
	lerpUnclamped(a, b, alpha) {
		return a + (b - a) * alpha;
	},
	lerpAngle(a, b, alpha) {
		if (b - a > 180) {
			b -= 360;
		}
		if (b - a < -180) {
			b += 360;
		}
		return math.lerp(a, b, math.clamp(alpha, 0, 1));
	},
	powerOfTwo(x3) {
		return x3 !== 0 && !(x3 & x3 - 1);
	},
	nextPowerOfTwo(val) {
		val--;
		val |= val >> 1;
		val |= val >> 2;
		val |= val >> 4;
		val |= val >> 8;
		val |= val >> 16;
		val++;
		return val;
	},
	nearestPowerOfTwo(val) {
		return Math.pow(2, Math.round(Math.log2(val)));
	},
	random(min, max) {
		const diff = max - min;
		return Math.random() * diff + min;
	},
	smoothstep(min, max, x3) {
		if (x3 <= min) return 0;
		if (x3 >= max) return 1;
		x3 = (x3 - min) / (max - min);
		return x3 * x3 * (3 - 2 * x3);
	},
	smootherstep(min, max, x3) {
		if (x3 <= min) return 0;
		if (x3 >= max) return 1;
		x3 = (x3 - min) / (max - min);
		return x3 * x3 * x3 * (x3 * (x3 * 6 - 15) + 10);
	},
	roundUp(numToRound, multiple) {
		if (multiple === 0) {
			return numToRound;
		}
		return Math.ceil(numToRound / multiple) * multiple;
	},
	between(num, a, b, inclusive) {
		const min = Math.min(a, b);
		const max = Math.max(a, b);
		return inclusive ? num >= min && num <= max : num > min && num < max;
	}
};

var Color = class _Color {
	r;
	g;
	b;
	a;
	constructor(r = 0, g = 0, b = 0, a = 1) {
		const length = r.length;
		if (length === 3 || length === 4) {
			this.r = r[0];
			this.g = r[1];
			this.b = r[2];
			this.a = r[3] ?? 1;
		} else {
			this.r = r;
			this.g = g;
			this.b = b;
			this.a = a;
		}
	}
	clone() {
		const cstr = this.constructor;
		return new cstr(this.r, this.g, this.b, this.a);
	}
	copy(rhs) {
		this.r = rhs.r;
		this.g = rhs.g;
		this.b = rhs.b;
		this.a = rhs.a;
		return this;
	}
	equals(rhs) {
		return this.r === rhs.r && this.g === rhs.g && this.b === rhs.b && this.a === rhs.a;
	}
	set(r, g, b, a = 1) {
		this.r = r;
		this.g = g;
		this.b = b;
		this.a = a;
		return this;
	}
	lerp(lhs, rhs, alpha) {
		this.r = lhs.r + alpha * (rhs.r - lhs.r);
		this.g = lhs.g + alpha * (rhs.g - lhs.g);
		this.b = lhs.b + alpha * (rhs.b - lhs.b);
		this.a = lhs.a + alpha * (rhs.a - lhs.a);
		return this;
	}
	linear(src = this) {
		this.r = Math.pow(src.r, 2.2);
		this.g = Math.pow(src.g, 2.2);
		this.b = Math.pow(src.b, 2.2);
		this.a = src.a;
		return this;
	}
	gamma(src = this) {
		this.r = Math.pow(src.r, 1 / 2.2);
		this.g = Math.pow(src.g, 1 / 2.2);
		this.b = Math.pow(src.b, 1 / 2.2);
		this.a = src.a;
		return this;
	}
	mulScalar(scalar) {
		this.r *= scalar;
		this.g *= scalar;
		this.b *= scalar;
		return this;
	}
	fromString(hex) {
		const i2 = parseInt(hex.replace("#", "0x"), 16);
		let bytes;
		if (hex.length > 7) {
			bytes = math.intToBytes32(i2);
		} else {
			bytes = math.intToBytes24(i2);
			bytes[3] = 255;
		}
		this.set(bytes[0] / 255, bytes[1] / 255, bytes[2] / 255, bytes[3] / 255);
		return this;
	}
	fromArray(arr, offset3 = 0) {
		this.r = arr[offset3] ?? this.r;
		this.g = arr[offset3 + 1] ?? this.g;
		this.b = arr[offset3 + 2] ?? this.b;
		this.a = arr[offset3 + 3] ?? this.a;
		return this;
	}
	toString(alpha, asArray) {
		const { r, g, b, a } = this;
		if (asArray || r > 1 || g > 1 || b > 1) {
			return `${r.toFixed(3)}, ${g.toFixed(3)}, ${b.toFixed(3)}, ${a.toFixed(3)}`;
		}
		let s2 = `#${((1 << 24) + (Math.round(r * 255) << 16) + (Math.round(g * 255) << 8) + Math.round(b * 255)).toString(16).slice(1)}`;
		if (alpha === true) {
			const aa = Math.round(a * 255).toString(16);
			if (this.a < 16 / 255) {
				s2 += `0${aa}`;
			} else {
				s2 += aa;
			}
		}
		return s2;
	}
	toArray(arr = [], offset3 = 0, alpha = true) {
		arr[offset3] = this.r;
		arr[offset3 + 1] = this.g;
		arr[offset3 + 2] = this.b;
		if (alpha) {
			arr[offset3 + 3] = this.a;
		}
		return arr;
	}
	static BLACK = Object.freeze(new _Color(0, 0, 0, 1));
	static BLUE = Object.freeze(new _Color(0, 0, 1, 1));
	static CYAN = Object.freeze(new _Color(0, 1, 1, 1));
	static GRAY = Object.freeze(new _Color(0.5, 0.5, 0.5, 1));
	static GREEN = Object.freeze(new _Color(0, 1, 0, 1));
	static MAGENTA = Object.freeze(new _Color(1, 0, 1, 1));
	static RED = Object.freeze(new _Color(1, 0, 0, 1));
	static WHITE = Object.freeze(new _Color(1, 1, 1, 1));
	static YELLOW = Object.freeze(new _Color(1, 1, 0, 1));
};

var CurveEvaluator = class {
	_curve;
	_left = -Infinity;
	_right = Infinity;
	_recip = 0;
	_p0 = 0;
	_p1 = 0;
	_m0 = 0;
	_m1 = 0;
	constructor(curve, time = 0) {
		this._curve = curve;
		this._reset(time);
	}
	evaluate(time, forceReset = false) {
		if (forceReset || time < this._left || time >= this._right) {
			this._reset(time);
		}
		let result;
		const type = this._curve.type;
		if (type === CURVE_STEP) {
			result = this._p0;
		} else {
			const t = this._recip === 0 ? 0 : (time - this._left) * this._recip;
			if (type === CURVE_LINEAR) {
				result = math.lerp(this._p0, this._p1, t);
			} else if (type === CURVE_SMOOTHSTEP) {
				result = math.lerp(this._p0, this._p1, t * t * (3 - 2 * t));
			} else {
				result = this._evaluateHermite(this._p0, this._p1, this._m0, this._m1, t);
			}
		}
		return result;
	}
	_reset(time) {
		const keys = this._curve.keys;
		const len = keys.length;
		if (!len) {
			this._left = -Infinity;
			this._right = Infinity;
			this._recip = 0;
			this._p0 = this._p1 = this._m0 = this._m1 = 0;
		} else {
			if (time < keys[0][0]) {
				this._left = -Infinity;
				this._right = keys[0][0];
				this._recip = 0;
				this._p0 = this._p1 = keys[0][1];
				this._m0 = this._m1 = 0;
			} else if (time >= keys[len - 1][0]) {
				this._left = keys[len - 1][0];
				this._right = Infinity;
				this._recip = 0;
				this._p0 = this._p1 = keys[len - 1][1];
				this._m0 = this._m1 = 0;
			} else {
				let index = 0;
				while (time >= keys[index + 1][0]) {
					index++;
				}
				this._left = keys[index][0];
				this._right = keys[index + 1][0];
				const diff = 1 / (this._right - this._left);
				this._recip = isFinite(diff) ? diff : 0;
				this._p0 = keys[index][1];
				this._p1 = keys[index + 1][1];
				if (this._curve.type === CURVE_SPLINE) {
					this._calcTangents(keys, index);
				}
			}
		}
	}
	_calcTangents(keys, index) {
		let a;
		const b = keys[index];
		const c2 = keys[index + 1];
		let d;
		if (index === 0) {
			a = [
				keys[0][0] + (keys[0][0] - keys[1][0]),
				keys[0][1] + (keys[0][1] - keys[1][1])
			];
		} else {
			a = keys[index - 1];
		}
		if (index === keys.length - 2) {
			d = [
				keys[index + 1][0] + (keys[index + 1][0] - keys[index][0]),
				keys[index + 1][1] + (keys[index + 1][1] - keys[index][1])
			];
		} else {
			d = keys[index + 2];
		}
		if (this._curve.type === CURVE_SPLINE) {
			const s1_ = 2 * (c2[0] - b[0]) / (c2[0] - a[0]);
			const s2_ = 2 * (c2[0] - b[0]) / (d[0] - b[0]);
			this._m0 = this._curve.tension * (isFinite(s1_) ? s1_ : 0) * (c2[1] - a[1]);
			this._m1 = this._curve.tension * (isFinite(s2_) ? s2_ : 0) * (d[1] - b[1]);
		} else {
			const s1 = (c2[0] - b[0]) / (b[0] - a[0]);
			const s2 = (c2[0] - b[0]) / (d[0] - c2[0]);
			const a_ = b[1] + (a[1] - b[1]) * (isFinite(s1) ? s1 : 0);
			const d_ = c2[1] + (d[1] - c2[1]) * (isFinite(s2) ? s2 : 0);
			const tension = this._curve.tension;
			this._m0 = tension * (c2[1] - a_);
			this._m1 = tension * (d_ - b[1]);
		}
	}
	_evaluateHermite(p0, p12, m0, m12, t) {
		const t2 = t * t;
		const twot = t + t;
		const omt = 1 - t;
		const omt2 = omt * omt;
		return p0 * ((1 + twot) * omt2) + m0 * (t * omt2) + p12 * (t2 * (3 - twot)) + m12 * (t2 * (t - 1));
	}
};

var Curve = class {
	keys = [];
	type = CURVE_SMOOTHSTEP;
	tension = 0.5;
	_eval = new CurveEvaluator(this);
	constructor(data2) {
		if (data2) {
			for (let i2 = 0; i2 < data2.length - 1; i2 += 2) {
				this.keys.push([data2[i2], data2[i2 + 1]]);
			}
		}
		this.sort();
	}
	get length() {
		return this.keys.length;
	}
	add(time, value) {
		const keys = this.keys;
		const len = keys.length;
		let i2 = 0;
		for (; i2 < len; i2++) {
			if (keys[i2][0] > time) {
				break;
			}
		}
		const key = [time, value];
		this.keys.splice(i2, 0, key);
		return key;
	}
	remove(index) {
		if (index < 0 || index >= this.keys.length) {
			return null;
		}
		return this.keys.splice(index, 1)[0];
	}
	clear() {
		this.keys.length = 0;
		return this;
	}
	get(index) {
		return this.keys[index];
	}
	sort() {
		this.keys.sort((a, b) => a[0] - b[0]);
	}
	value(time) {
		return this._eval.evaluate(time, true);
	}
	closest(time) {
		const keys = this.keys;
		const length = keys.length;
		let min = 2;
		let result = null;
		for (let i2 = 0; i2 < length; i2++) {
			const diff = Math.abs(time - keys[i2][0]);
			if (min >= diff) {
				min = diff;
				result = keys[i2];
			} else {
				break;
			}
		}
		return result;
	}
	clone() {
		const result = new this.constructor();
		result.keys = this.keys.map((key) => [...key]);
		result.type = this.type;
		result.tension = this.tension;
		return result;
	}
	quantize(precision) {
		precision = Math.max(precision, 2);
		const values = new Float32Array(precision);
		const step = 1 / (precision - 1);
		values[0] = this._eval.evaluate(0, true);
		for (let i2 = 1; i2 < precision; i2++) {
			values[i2] = this._eval.evaluate(step * i2);
		}
		return values;
	}
	quantizeClamped(precision, min, max) {
		const result = this.quantize(precision);
		for (let i2 = 0; i2 < result.length; ++i2) {
			result[i2] = Math.min(max, Math.max(min, result[i2]));
		}
		return result;
	}
};

var CurveSet = class {
	curves = [];
	_type = CURVE_SMOOTHSTEP;
	constructor(...args) {
		if (args.length > 1) {
			for (let i2 = 0; i2 < args.length; i2++) {
				this.curves.push(new Curve(args[i2]));
			}
		} else if (args.length === 0) {
			this.curves.push(new Curve());
		} else {
			const arg = args[0];
			if (typeof arg === "number") {
				for (let i2 = 0; i2 < arg; i2++) {
					this.curves.push(new Curve());
				}
			} else {
				for (let i2 = 0; i2 < arg.length; i2++) {
					this.curves.push(new Curve(arg[i2]));
				}
			}
		}
	}
	get length() {
		return this.curves.length;
	}
	set type(value) {
		this._type = value;
		for (let i2 = 0; i2 < this.curves.length; i2++) {
			this.curves[i2].type = value;
		}
	}
	get type() {
		return this._type;
	}
	get(index) {
		return this.curves[index];
	}
	add(data2) {
		const curve = new Curve(data2);
		curve.type = this._type;
		this.curves.push(curve);
		return curve;
	}
	remove(indexOrCurve) {
		const index = typeof indexOrCurve === "number" ? indexOrCurve : this.curves.indexOf(indexOrCurve);
		if (index < 0 || index >= this.curves.length) {
			return null;
		}
		return this.curves.splice(index, 1)[0];
	}
	clearKeys() {
		for (let i2 = 0; i2 < this.curves.length; i2++) {
			this.curves[i2].clear();
		}
		return this;
	}
	clear() {
		this.curves.length = 0;
		return this;
	}
	value(time, result = []) {
		const length = this.curves.length;
		result.length = length;
		for (let i2 = 0; i2 < length; i2++) {
			result[i2] = this.curves[i2].value(time);
		}
		return result;
	}
	clone() {
		const result = new this.constructor();
		result.curves = [];
		for (let i2 = 0; i2 < this.curves.length; i2++) {
			result.curves.push(this.curves[i2].clone());
		}
		result._type = this._type;
		return result;
	}
	quantize(precision) {
		precision = Math.max(precision, 2);
		const numCurves = this.curves.length;
		const values = new Float32Array(precision * numCurves);
		const step = 1 / (precision - 1);
		for (let c2 = 0; c2 < numCurves; c2++) {
			const ev = new CurveEvaluator(this.curves[c2]);
			for (let i2 = 0; i2 < precision; i2++) {
				values[i2 * numCurves + c2] = ev.evaluate(step * i2);
			}
		}
		return values;
	}
	quantizeClamped(precision, min, max) {
		const result = this.quantize(precision);
		for (let i2 = 0; i2 < result.length; ++i2) {
			result[i2] = Math.min(max, Math.max(min, result[i2]));
		}
		return result;
	}
};

var floatView = new Float32Array(1);
var int32View = new Int32Array(floatView.buffer);
var FloatPacking = class {
	static float2Half(value) {
		floatView[0] = value;
		const x3 = int32View[0];
		let bits = x3 >> 16 & 32768;
		let m = x3 >> 12 & 2047;
		const e = x3 >> 23 & 255;
		if (e < 103) {
			return bits;
		}
		if (e > 142) {
			bits |= 31744;
			bits |= (e === 255 ? 0 : 1) && x3 & 8388607;
			return bits;
		}
		if (e < 113) {
			m |= 2048;
			bits |= (m >> 114 - e) + (m >> 113 - e & 1);
			return bits;
		}
		bits |= e - 112 << 10 | m >> 1;
		bits += m & 1;
		return bits;
	}
	static float2RGBA8(value, data2) {
		floatView[0] = value;
		const intBits = int32View[0];
		data2.r = (intBits >> 24 & 255) / 255;
		data2.g = (intBits >> 16 & 255) / 255;
		data2.b = (intBits >> 8 & 255) / 255;
		data2.a = (intBits & 255) / 255;
	}
};

var Kernel = class {
	static concentric(numRings, numPoints) {
		const kernel = [];
		kernel.push(0, 0);
		const spacing = 2 * Math.PI / numRings / numPoints;
		for (let ring = 1; ring <= numRings; ring++) {
			const radius = ring / numRings;
			const circumference = 2 * Math.PI * radius;
			const pointsPerRing = Math.max(1, Math.floor(circumference / spacing));
			const angleStep = 2 * Math.PI / pointsPerRing;
			for (let point5 = 0; point5 < pointsPerRing; point5++) {
				const angle = point5 * angleStep;
				const x3 = radius * Math.cos(angle);
				const y2 = radius * Math.sin(angle);
				kernel.push(x3, y2);
			}
		}
		return kernel;
	}
};

var Vec3 = class _Vec3 {
	x;
	y;
	z;
	constructor(x3 = 0, y2 = 0, z2 = 0) {
		if (x3.length === 3) {
			this.x = x3[0];
			this.y = x3[1];
			this.z = x3[2];
		} else {
			this.x = x3;
			this.y = y2;
			this.z = z2;
		}
	}
	add(rhs) {
		this.x += rhs.x;
		this.y += rhs.y;
		this.z += rhs.z;
		return this;
	}
	add2(lhs, rhs) {
		this.x = lhs.x + rhs.x;
		this.y = lhs.y + rhs.y;
		this.z = lhs.z + rhs.z;
		return this;
	}
	addScalar(scalar) {
		this.x += scalar;
		this.y += scalar;
		this.z += scalar;
		return this;
	}
	addScaled(rhs, scalar) {
		this.x += rhs.x * scalar;
		this.y += rhs.y * scalar;
		this.z += rhs.z * scalar;
		return this;
	}
	clone() {
		const cstr = this.constructor;
		return new cstr(this.x, this.y, this.z);
	}
	copy(rhs) {
		this.x = rhs.x;
		this.y = rhs.y;
		this.z = rhs.z;
		return this;
	}
	cross(lhs, rhs) {
		const lx = lhs.x;
		const ly = lhs.y;
		const lz = lhs.z;
		const rx = rhs.x;
		const ry = rhs.y;
		const rz = rhs.z;
		this.x = ly * rz - ry * lz;
		this.y = lz * rx - rz * lx;
		this.z = lx * ry - rx * ly;
		return this;
	}
	distance(rhs) {
		const x3 = this.x - rhs.x;
		const y2 = this.y - rhs.y;
		const z2 = this.z - rhs.z;
		return Math.sqrt(x3 * x3 + y2 * y2 + z2 * z2);
	}
	div(rhs) {
		this.x /= rhs.x;
		this.y /= rhs.y;
		this.z /= rhs.z;
		return this;
	}
	div2(lhs, rhs) {
		this.x = lhs.x / rhs.x;
		this.y = lhs.y / rhs.y;
		this.z = lhs.z / rhs.z;
		return this;
	}
	divScalar(scalar) {
		this.x /= scalar;
		this.y /= scalar;
		this.z /= scalar;
		return this;
	}
	dot(rhs) {
		return this.x * rhs.x + this.y * rhs.y + this.z * rhs.z;
	}
	equals(rhs) {
		return this.x === rhs.x && this.y === rhs.y && this.z === rhs.z;
	}
	equalsApprox(rhs, epsilon = 1e-6) {
		return Math.abs(this.x - rhs.x) < epsilon && Math.abs(this.y - rhs.y) < epsilon && Math.abs(this.z - rhs.z) < epsilon;
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y + this.z * this.z;
	}
	lerp(lhs, rhs, alpha) {
		this.x = lhs.x + alpha * (rhs.x - lhs.x);
		this.y = lhs.y + alpha * (rhs.y - lhs.y);
		this.z = lhs.z + alpha * (rhs.z - lhs.z);
		return this;
	}
	mul(rhs) {
		this.x *= rhs.x;
		this.y *= rhs.y;
		this.z *= rhs.z;
		return this;
	}
	mul2(lhs, rhs) {
		this.x = lhs.x * rhs.x;
		this.y = lhs.y * rhs.y;
		this.z = lhs.z * rhs.z;
		return this;
	}
	mulScalar(scalar) {
		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;
		return this;
	}
	scale(scalar) {
		return this.mulScalar(scalar);
	}
	normalize(src = this) {
		const lengthSq = src.x * src.x + src.y * src.y + src.z * src.z;
		if (lengthSq > 0) {
			const invLength = 1 / Math.sqrt(lengthSq);
			this.x = src.x * invLength;
			this.y = src.y * invLength;
			this.z = src.z * invLength;
		}
		return this;
	}
	floor(src = this) {
		this.x = Math.floor(src.x);
		this.y = Math.floor(src.y);
		this.z = Math.floor(src.z);
		return this;
	}
	ceil(src = this) {
		this.x = Math.ceil(src.x);
		this.y = Math.ceil(src.y);
		this.z = Math.ceil(src.z);
		return this;
	}
	round(src = this) {
		this.x = Math.round(src.x);
		this.y = Math.round(src.y);
		this.z = Math.round(src.z);
		return this;
	}
	min(rhs) {
		if (rhs.x < this.x) this.x = rhs.x;
		if (rhs.y < this.y) this.y = rhs.y;
		if (rhs.z < this.z) this.z = rhs.z;
		return this;
	}
	max(rhs) {
		if (rhs.x > this.x) this.x = rhs.x;
		if (rhs.y > this.y) this.y = rhs.y;
		if (rhs.z > this.z) this.z = rhs.z;
		return this;
	}
	project(rhs) {
		const a_dot_b = this.x * rhs.x + this.y * rhs.y + this.z * rhs.z;
		const b_dot_b = rhs.x * rhs.x + rhs.y * rhs.y + rhs.z * rhs.z;
		const s2 = a_dot_b / b_dot_b;
		this.x = rhs.x * s2;
		this.y = rhs.y * s2;
		this.z = rhs.z * s2;
		return this;
	}
	set(x3, y2, z2) {
		this.x = x3;
		this.y = y2;
		this.z = z2;
		return this;
	}
	sub(rhs) {
		this.x -= rhs.x;
		this.y -= rhs.y;
		this.z -= rhs.z;
		return this;
	}
	sub2(lhs, rhs) {
		this.x = lhs.x - rhs.x;
		this.y = lhs.y - rhs.y;
		this.z = lhs.z - rhs.z;
		return this;
	}
	subScalar(scalar) {
		this.x -= scalar;
		this.y -= scalar;
		this.z -= scalar;
		return this;
	}
	fromArray(arr, offset3 = 0) {
		this.x = arr[offset3] ?? this.x;
		this.y = arr[offset3 + 1] ?? this.y;
		this.z = arr[offset3 + 2] ?? this.z;
		return this;
	}
	toString() {
		return `[${this.x}, ${this.y}, ${this.z}]`;
	}
	toArray(arr = [], offset3 = 0) {
		arr[offset3] = this.x;
		arr[offset3 + 1] = this.y;
		arr[offset3 + 2] = this.z;
		return arr;
	}
	static ZERO = Object.freeze(new _Vec3(0, 0, 0));
	static HALF = Object.freeze(new _Vec3(0.5, 0.5, 0.5));
	static ONE = Object.freeze(new _Vec3(1, 1, 1));
	static UP = Object.freeze(new _Vec3(0, 1, 0));
	static DOWN = Object.freeze(new _Vec3(0, -1, 0));
	static RIGHT = Object.freeze(new _Vec3(1, 0, 0));
	static LEFT = Object.freeze(new _Vec3(-1, 0, 0));
	static FORWARD = Object.freeze(new _Vec3(0, 0, -1));
	static BACK = Object.freeze(new _Vec3(0, 0, 1));
};

var Mat3 = class _Mat3 {
	data = new Float32Array(9);
	constructor() {
		this.data[0] = this.data[4] = this.data[8] = 1;
	}
	clone() {
		const cstr = this.constructor;
		return new cstr().copy(this);
	}
	copy(rhs) {
		const src = rhs.data;
		const dst = this.data;
		dst[0] = src[0];
		dst[1] = src[1];
		dst[2] = src[2];
		dst[3] = src[3];
		dst[4] = src[4];
		dst[5] = src[5];
		dst[6] = src[6];
		dst[7] = src[7];
		dst[8] = src[8];
		return this;
	}
	set(src) {
		const dst = this.data;
		dst[0] = src[0];
		dst[1] = src[1];
		dst[2] = src[2];
		dst[3] = src[3];
		dst[4] = src[4];
		dst[5] = src[5];
		dst[6] = src[6];
		dst[7] = src[7];
		dst[8] = src[8];
		return this;
	}
	getX(x3 = new Vec3()) {
		return x3.set(this.data[0], this.data[1], this.data[2]);
	}
	getY(y2 = new Vec3()) {
		return y2.set(this.data[3], this.data[4], this.data[5]);
	}
	getZ(z2 = new Vec3()) {
		return z2.set(this.data[6], this.data[7], this.data[8]);
	}
	equals(rhs) {
		const l = this.data;
		const r = rhs.data;
		return l[0] === r[0] && l[1] === r[1] && l[2] === r[2] && l[3] === r[3] && l[4] === r[4] && l[5] === r[5] && l[6] === r[6] && l[7] === r[7] && l[8] === r[8];
	}
	isIdentity() {
		const m = this.data;
		return m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 0 && m[4] === 1 && m[5] === 0 && m[6] === 0 && m[7] === 0 && m[8] === 1;
	}
	setIdentity() {
		const m = this.data;
		m[0] = 1;
		m[1] = 0;
		m[2] = 0;
		m[3] = 0;
		m[4] = 1;
		m[5] = 0;
		m[6] = 0;
		m[7] = 0;
		m[8] = 1;
		return this;
	}
	toString() {
		return `[${this.data.join(", ")}]`;
	}
	transpose(src = this) {
		const s2 = src.data;
		const t = this.data;
		if (s2 === t) {
			let tmp;
			tmp = s2[1];
			t[1] = s2[3];
			t[3] = tmp;
			tmp = s2[2];
			t[2] = s2[6];
			t[6] = tmp;
			tmp = s2[5];
			t[5] = s2[7];
			t[7] = tmp;
		} else {
			t[0] = s2[0];
			t[1] = s2[3];
			t[2] = s2[6];
			t[3] = s2[1];
			t[4] = s2[4];
			t[5] = s2[7];
			t[6] = s2[2];
			t[7] = s2[5];
			t[8] = s2[8];
		}
		return this;
	}
	setFromMat4(m) {
		const src = m.data;
		const dst = this.data;
		dst[0] = src[0];
		dst[1] = src[1];
		dst[2] = src[2];
		dst[3] = src[4];
		dst[4] = src[5];
		dst[5] = src[6];
		dst[6] = src[8];
		dst[7] = src[9];
		dst[8] = src[10];
		return this;
	}
	setFromQuat(r) {
		const qx = r.x;
		const qy = r.y;
		const qz = r.z;
		const qw = r.w;
		const x22 = qx + qx;
		const y2 = qy + qy;
		const z2 = qz + qz;
		const xx = qx * x22;
		const xy = qx * y2;
		const xz = qx * z2;
		const yy = qy * y2;
		const yz = qy * z2;
		const zz = qz * z2;
		const wx = qw * x22;
		const wy = qw * y2;
		const wz = qw * z2;
		const m = this.data;
		m[0] = 1 - (yy + zz);
		m[1] = xy + wz;
		m[2] = xz - wy;
		m[3] = xy - wz;
		m[4] = 1 - (xx + zz);
		m[5] = yz + wx;
		m[6] = xz + wy;
		m[7] = yz - wx;
		m[8] = 1 - (xx + yy);
		return this;
	}
	invertMat4(src) {
		const s2 = src.data;
		const a0 = s2[0];
		const a1 = s2[1];
		const a2 = s2[2];
		const a4 = s2[4];
		const a5 = s2[5];
		const a6 = s2[6];
		const a8 = s2[8];
		const a9 = s2[9];
		const a10 = s2[10];
		const b11 = a10 * a5 - a6 * a9;
		const b21 = -a10 * a1 + a2 * a9;
		const b31 = a6 * a1 - a2 * a5;
		const b12 = -a10 * a4 + a6 * a8;
		const b22 = a10 * a0 - a2 * a8;
		const b32 = -a6 * a0 + a2 * a4;
		const b13 = a9 * a4 - a5 * a8;
		const b23 = -a9 * a0 + a1 * a8;
		const b33 = a5 * a0 - a1 * a4;
		const det = a0 * b11 + a1 * b12 + a2 * b13;
		if (det === 0) {
			this.setIdentity();
		} else {
			const invDet = 1 / det;
			const t = this.data;
			t[0] = b11 * invDet;
			t[1] = b21 * invDet;
			t[2] = b31 * invDet;
			t[3] = b12 * invDet;
			t[4] = b22 * invDet;
			t[5] = b32 * invDet;
			t[6] = b13 * invDet;
			t[7] = b23 * invDet;
			t[8] = b33 * invDet;
		}
		return this;
	}
	transformVector(vec2, res = new Vec3()) {
		const m = this.data;
		const { x: x3, y: y2, z: z2 } = vec2;
		res.x = x3 * m[0] + y2 * m[3] + z2 * m[6];
		res.y = x3 * m[1] + y2 * m[4] + z2 * m[7];
		res.z = x3 * m[2] + y2 * m[5] + z2 * m[8];
		return res;
	}
	static IDENTITY = Object.freeze(new _Mat3());
	static ZERO = Object.freeze(new _Mat3().set([0, 0, 0, 0, 0, 0, 0, 0, 0]));
};

var Vec2 = class _Vec2 {
	x;
	y;
	constructor(x3 = 0, y2 = 0) {
		if (x3.length === 2) {
			this.x = x3[0];
			this.y = x3[1];
		} else {
			this.x = x3;
			this.y = y2;
		}
	}
	add(rhs) {
		this.x += rhs.x;
		this.y += rhs.y;
		return this;
	}
	add2(lhs, rhs) {
		this.x = lhs.x + rhs.x;
		this.y = lhs.y + rhs.y;
		return this;
	}
	addScalar(scalar) {
		this.x += scalar;
		this.y += scalar;
		return this;
	}
	addScaled(rhs, scalar) {
		this.x += rhs.x * scalar;
		this.y += rhs.y * scalar;
		return this;
	}
	clone() {
		const cstr = this.constructor;
		return new cstr(this.x, this.y);
	}
	copy(rhs) {
		this.x = rhs.x;
		this.y = rhs.y;
		return this;
	}
	cross(rhs) {
		return this.x * rhs.y - this.y * rhs.x;
	}
	distance(rhs) {
		const x3 = this.x - rhs.x;
		const y2 = this.y - rhs.y;
		return Math.sqrt(x3 * x3 + y2 * y2);
	}
	div(rhs) {
		this.x /= rhs.x;
		this.y /= rhs.y;
		return this;
	}
	div2(lhs, rhs) {
		this.x = lhs.x / rhs.x;
		this.y = lhs.y / rhs.y;
		return this;
	}
	divScalar(scalar) {
		this.x /= scalar;
		this.y /= scalar;
		return this;
	}
	dot(rhs) {
		return this.x * rhs.x + this.y * rhs.y;
	}
	equals(rhs) {
		return this.x === rhs.x && this.y === rhs.y;
	}
	equalsApprox(rhs, epsilon = 1e-6) {
		return Math.abs(this.x - rhs.x) < epsilon && Math.abs(this.y - rhs.y) < epsilon;
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y);
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y;
	}
	lerp(lhs, rhs, alpha) {
		this.x = lhs.x + alpha * (rhs.x - lhs.x);
		this.y = lhs.y + alpha * (rhs.y - lhs.y);
		return this;
	}
	mul(rhs) {
		this.x *= rhs.x;
		this.y *= rhs.y;
		return this;
	}
	mul2(lhs, rhs) {
		this.x = lhs.x * rhs.x;
		this.y = lhs.y * rhs.y;
		return this;
	}
	mulScalar(scalar) {
		this.x *= scalar;
		this.y *= scalar;
		return this;
	}
	scale(scalar) {
		return this.mulScalar(scalar);
	}
	normalize(src = this) {
		const lengthSq = src.x * src.x + src.y * src.y;
		if (lengthSq > 0) {
			const invLength = 1 / Math.sqrt(lengthSq);
			this.x = src.x * invLength;
			this.y = src.y * invLength;
		}
		return this;
	}
	rotate(degrees) {
		const angle = Math.atan2(this.x, this.y) + degrees * math.DEG_TO_RAD;
		const len = Math.sqrt(this.x * this.x + this.y * this.y);
		this.x = Math.sin(angle) * len;
		this.y = Math.cos(angle) * len;
		return this;
	}
	angle() {
		return Math.atan2(this.x, this.y) * math.RAD_TO_DEG;
	}
	angleTo(rhs) {
		return Math.atan2(this.x * rhs.y + this.y * rhs.x, this.x * rhs.x + this.y * rhs.y) * math.RAD_TO_DEG;
	}
	floor(src = this) {
		this.x = Math.floor(src.x);
		this.y = Math.floor(src.y);
		return this;
	}
	ceil(src = this) {
		this.x = Math.ceil(src.x);
		this.y = Math.ceil(src.y);
		return this;
	}
	round(src = this) {
		this.x = Math.round(src.x);
		this.y = Math.round(src.y);
		return this;
	}
	min(rhs) {
		if (rhs.x < this.x) this.x = rhs.x;
		if (rhs.y < this.y) this.y = rhs.y;
		return this;
	}
	max(rhs) {
		if (rhs.x > this.x) this.x = rhs.x;
		if (rhs.y > this.y) this.y = rhs.y;
		return this;
	}
	set(x3, y2) {
		this.x = x3;
		this.y = y2;
		return this;
	}
	sub(rhs) {
		this.x -= rhs.x;
		this.y -= rhs.y;
		return this;
	}
	sub2(lhs, rhs) {
		this.x = lhs.x - rhs.x;
		this.y = lhs.y - rhs.y;
		return this;
	}
	subScalar(scalar) {
		this.x -= scalar;
		this.y -= scalar;
		return this;
	}
	fromArray(arr, offset3 = 0) {
		this.x = arr[offset3] ?? this.x;
		this.y = arr[offset3 + 1] ?? this.y;
		return this;
	}
	toString() {
		return `[${this.x}, ${this.y}]`;
	}
	toArray(arr = [], offset3 = 0) {
		arr[offset3] = this.x;
		arr[offset3 + 1] = this.y;
		return arr;
	}
	static angleRad(lhs, rhs) {
		return Math.atan2(lhs.x * rhs.y - lhs.y * rhs.x, lhs.x * rhs.x + lhs.y * rhs.y);
	}
	static ZERO = Object.freeze(new _Vec2(0, 0));
	static HALF = Object.freeze(new _Vec2(0.5, 0.5));
	static ONE = Object.freeze(new _Vec2(1, 1));
	static UP = Object.freeze(new _Vec2(0, 1));
	static DOWN = Object.freeze(new _Vec2(0, -1));
	static RIGHT = Object.freeze(new _Vec2(1, 0));
	static LEFT = Object.freeze(new _Vec2(-1, 0));
};

var Vec4 = class _Vec4 {
	x;
	y;
	z;
	w;
	constructor(x3 = 0, y2 = 0, z2 = 0, w = 0) {
		if (x3.length === 4) {
			this.x = x3[0];
			this.y = x3[1];
			this.z = x3[2];
			this.w = x3[3];
		} else {
			this.x = x3;
			this.y = y2;
			this.z = z2;
			this.w = w;
		}
	}
	add(rhs) {
		this.x += rhs.x;
		this.y += rhs.y;
		this.z += rhs.z;
		this.w += rhs.w;
		return this;
	}
	add2(lhs, rhs) {
		this.x = lhs.x + rhs.x;
		this.y = lhs.y + rhs.y;
		this.z = lhs.z + rhs.z;
		this.w = lhs.w + rhs.w;
		return this;
	}
	addScalar(scalar) {
		this.x += scalar;
		this.y += scalar;
		this.z += scalar;
		this.w += scalar;
		return this;
	}
	addScaled(rhs, scalar) {
		this.x += rhs.x * scalar;
		this.y += rhs.y * scalar;
		this.z += rhs.z * scalar;
		this.w += rhs.w * scalar;
		return this;
	}
	clone() {
		const cstr = this.constructor;
		return new cstr(this.x, this.y, this.z, this.w);
	}
	copy(rhs) {
		this.x = rhs.x;
		this.y = rhs.y;
		this.z = rhs.z;
		this.w = rhs.w;
		return this;
	}
	div(rhs) {
		this.x /= rhs.x;
		this.y /= rhs.y;
		this.z /= rhs.z;
		this.w /= rhs.w;
		return this;
	}
	div2(lhs, rhs) {
		this.x = lhs.x / rhs.x;
		this.y = lhs.y / rhs.y;
		this.z = lhs.z / rhs.z;
		this.w = lhs.w / rhs.w;
		return this;
	}
	divScalar(scalar) {
		this.x /= scalar;
		this.y /= scalar;
		this.z /= scalar;
		this.w /= scalar;
		return this;
	}
	dot(rhs) {
		return this.x * rhs.x + this.y * rhs.y + this.z * rhs.z + this.w * rhs.w;
	}
	equals(rhs) {
		return this.x === rhs.x && this.y === rhs.y && this.z === rhs.z && this.w === rhs.w;
	}
	equalsApprox(rhs, epsilon = 1e-6) {
		return Math.abs(this.x - rhs.x) < epsilon && Math.abs(this.y - rhs.y) < epsilon && Math.abs(this.z - rhs.z) < epsilon && Math.abs(this.w - rhs.w) < epsilon;
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
	}
	lerp(lhs, rhs, alpha) {
		this.x = lhs.x + alpha * (rhs.x - lhs.x);
		this.y = lhs.y + alpha * (rhs.y - lhs.y);
		this.z = lhs.z + alpha * (rhs.z - lhs.z);
		this.w = lhs.w + alpha * (rhs.w - lhs.w);
		return this;
	}
	mul(rhs) {
		this.x *= rhs.x;
		this.y *= rhs.y;
		this.z *= rhs.z;
		this.w *= rhs.w;
		return this;
	}
	mul2(lhs, rhs) {
		this.x = lhs.x * rhs.x;
		this.y = lhs.y * rhs.y;
		this.z = lhs.z * rhs.z;
		this.w = lhs.w * rhs.w;
		return this;
	}
	mulScalar(scalar) {
		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;
		this.w *= scalar;
		return this;
	}
	scale(scalar) {
		return this.mulScalar(scalar);
	}
	normalize(src = this) {
		const lengthSq = src.x * src.x + src.y * src.y + src.z * src.z + src.w * src.w;
		if (lengthSq > 0) {
			const invLength = 1 / Math.sqrt(lengthSq);
			this.x = src.x * invLength;
			this.y = src.y * invLength;
			this.z = src.z * invLength;
			this.w = src.w * invLength;
		}
		return this;
	}
	floor(src = this) {
		this.x = Math.floor(src.x);
		this.y = Math.floor(src.y);
		this.z = Math.floor(src.z);
		this.w = Math.floor(src.w);
		return this;
	}
	ceil(src = this) {
		this.x = Math.ceil(src.x);
		this.y = Math.ceil(src.y);
		this.z = Math.ceil(src.z);
		this.w = Math.ceil(src.w);
		return this;
	}
	round(src = this) {
		this.x = Math.round(src.x);
		this.y = Math.round(src.y);
		this.z = Math.round(src.z);
		this.w = Math.round(src.w);
		return this;
	}
	min(rhs) {
		if (rhs.x < this.x) this.x = rhs.x;
		if (rhs.y < this.y) this.y = rhs.y;
		if (rhs.z < this.z) this.z = rhs.z;
		if (rhs.w < this.w) this.w = rhs.w;
		return this;
	}
	max(rhs) {
		if (rhs.x > this.x) this.x = rhs.x;
		if (rhs.y > this.y) this.y = rhs.y;
		if (rhs.z > this.z) this.z = rhs.z;
		if (rhs.w > this.w) this.w = rhs.w;
		return this;
	}
	set(x3, y2, z2, w) {
		this.x = x3;
		this.y = y2;
		this.z = z2;
		this.w = w;
		return this;
	}
	sub(rhs) {
		this.x -= rhs.x;
		this.y -= rhs.y;
		this.z -= rhs.z;
		this.w -= rhs.w;
		return this;
	}
	sub2(lhs, rhs) {
		this.x = lhs.x - rhs.x;
		this.y = lhs.y - rhs.y;
		this.z = lhs.z - rhs.z;
		this.w = lhs.w - rhs.w;
		return this;
	}
	subScalar(scalar) {
		this.x -= scalar;
		this.y -= scalar;
		this.z -= scalar;
		this.w -= scalar;
		return this;
	}
	fromArray(arr, offset3 = 0) {
		this.x = arr[offset3] ?? this.x;
		this.y = arr[offset3 + 1] ?? this.y;
		this.z = arr[offset3 + 2] ?? this.z;
		this.w = arr[offset3 + 3] ?? this.w;
		return this;
	}
	toString() {
		return `[${this.x}, ${this.y}, ${this.z}, ${this.w}]`;
	}
	toArray(arr = [], offset3 = 0) {
		arr[offset3] = this.x;
		arr[offset3 + 1] = this.y;
		arr[offset3 + 2] = this.z;
		arr[offset3 + 3] = this.w;
		return arr;
	}
	static ZERO = Object.freeze(new _Vec4(0, 0, 0, 0));
	static HALF = Object.freeze(new _Vec4(0.5, 0.5, 0.5, 0.5));
	static ONE = Object.freeze(new _Vec4(1, 1, 1, 1));
};

var _halfSize = new Vec2();
var x = new Vec3();
var y = new Vec3();
var z = new Vec3();
var scale = new Vec3();
var Mat4 = class _Mat4 {
	data = new Float32Array(16);
	constructor() {
		this.data[0] = this.data[5] = this.data[10] = this.data[15] = 1;
	}
	// Static function which evaluates perspective projection matrix half size at the near plane
	static _getPerspectiveHalfSize(halfSize, fov, aspect, znear, fovIsHorizontal) {
		if (fovIsHorizontal) {
			halfSize.x = znear * Math.tan(fov * Math.PI / 360);
			halfSize.y = halfSize.x / aspect;
		} else {
			halfSize.y = znear * Math.tan(fov * Math.PI / 360);
			halfSize.x = halfSize.y * aspect;
		}
	}
	add2(lhs, rhs) {
		const a = lhs.data, b = rhs.data, r = this.data;
		r[0] = a[0] + b[0];
		r[1] = a[1] + b[1];
		r[2] = a[2] + b[2];
		r[3] = a[3] + b[3];
		r[4] = a[4] + b[4];
		r[5] = a[5] + b[5];
		r[6] = a[6] + b[6];
		r[7] = a[7] + b[7];
		r[8] = a[8] + b[8];
		r[9] = a[9] + b[9];
		r[10] = a[10] + b[10];
		r[11] = a[11] + b[11];
		r[12] = a[12] + b[12];
		r[13] = a[13] + b[13];
		r[14] = a[14] + b[14];
		r[15] = a[15] + b[15];
		return this;
	}
	add(rhs) {
		return this.add2(this, rhs);
	}
	clone() {
		const cstr = this.constructor;
		return new cstr().copy(this);
	}
	copy(rhs) {
		const src = rhs.data, dst = this.data;
		dst[0] = src[0];
		dst[1] = src[1];
		dst[2] = src[2];
		dst[3] = src[3];
		dst[4] = src[4];
		dst[5] = src[5];
		dst[6] = src[6];
		dst[7] = src[7];
		dst[8] = src[8];
		dst[9] = src[9];
		dst[10] = src[10];
		dst[11] = src[11];
		dst[12] = src[12];
		dst[13] = src[13];
		dst[14] = src[14];
		dst[15] = src[15];
		return this;
	}
	equals(rhs) {
		const l = this.data, r = rhs.data;
		return l[0] === r[0] && l[1] === r[1] && l[2] === r[2] && l[3] === r[3] && l[4] === r[4] && l[5] === r[5] && l[6] === r[6] && l[7] === r[7] && l[8] === r[8] && l[9] === r[9] && l[10] === r[10] && l[11] === r[11] && l[12] === r[12] && l[13] === r[13] && l[14] === r[14] && l[15] === r[15];
	}
	isIdentity() {
		const m = this.data;
		return m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 0 && m[4] === 0 && m[5] === 1 && m[6] === 0 && m[7] === 0 && m[8] === 0 && m[9] === 0 && m[10] === 1 && m[11] === 0 && m[12] === 0 && m[13] === 0 && m[14] === 0 && m[15] === 1;
	}
	mul2(lhs, rhs) {
		const a = lhs.data;
		const b = rhs.data;
		const r = this.data;
		const a00 = a[0];
		const a01 = a[1];
		const a02 = a[2];
		const a03 = a[3];
		const a10 = a[4];
		const a11 = a[5];
		const a12 = a[6];
		const a13 = a[7];
		const a20 = a[8];
		const a21 = a[9];
		const a22 = a[10];
		const a23 = a[11];
		const a30 = a[12];
		const a31 = a[13];
		const a32 = a[14];
		const a33 = a[15];
		let b0, b1, b2, b3;
		b0 = b[0];
		b1 = b[1];
		b2 = b[2];
		b3 = b[3];
		r[0] = a00 * b0 + a10 * b1 + a20 * b2 + a30 * b3;
		r[1] = a01 * b0 + a11 * b1 + a21 * b2 + a31 * b3;
		r[2] = a02 * b0 + a12 * b1 + a22 * b2 + a32 * b3;
		r[3] = a03 * b0 + a13 * b1 + a23 * b2 + a33 * b3;
		b0 = b[4];
		b1 = b[5];
		b2 = b[6];
		b3 = b[7];
		r[4] = a00 * b0 + a10 * b1 + a20 * b2 + a30 * b3;
		r[5] = a01 * b0 + a11 * b1 + a21 * b2 + a31 * b3;
		r[6] = a02 * b0 + a12 * b1 + a22 * b2 + a32 * b3;
		r[7] = a03 * b0 + a13 * b1 + a23 * b2 + a33 * b3;
		b0 = b[8];
		b1 = b[9];
		b2 = b[10];
		b3 = b[11];
		r[8] = a00 * b0 + a10 * b1 + a20 * b2 + a30 * b3;
		r[9] = a01 * b0 + a11 * b1 + a21 * b2 + a31 * b3;
		r[10] = a02 * b0 + a12 * b1 + a22 * b2 + a32 * b3;
		r[11] = a03 * b0 + a13 * b1 + a23 * b2 + a33 * b3;
		b0 = b[12];
		b1 = b[13];
		b2 = b[14];
		b3 = b[15];
		r[12] = a00 * b0 + a10 * b1 + a20 * b2 + a30 * b3;
		r[13] = a01 * b0 + a11 * b1 + a21 * b2 + a31 * b3;
		r[14] = a02 * b0 + a12 * b1 + a22 * b2 + a32 * b3;
		r[15] = a03 * b0 + a13 * b1 + a23 * b2 + a33 * b3;
		return this;
	}
	mulAffine2(lhs, rhs) {
		const a = lhs.data;
		const b = rhs.data;
		const r = this.data;
		const a00 = a[0];
		const a01 = a[1];
		const a02 = a[2];
		const a10 = a[4];
		const a11 = a[5];
		const a12 = a[6];
		const a20 = a[8];
		const a21 = a[9];
		const a22 = a[10];
		const a30 = a[12];
		const a31 = a[13];
		const a32 = a[14];
		let b0, b1, b2;
		b0 = b[0];
		b1 = b[1];
		b2 = b[2];
		r[0] = a00 * b0 + a10 * b1 + a20 * b2;
		r[1] = a01 * b0 + a11 * b1 + a21 * b2;
		r[2] = a02 * b0 + a12 * b1 + a22 * b2;
		r[3] = 0;
		b0 = b[4];
		b1 = b[5];
		b2 = b[6];
		r[4] = a00 * b0 + a10 * b1 + a20 * b2;
		r[5] = a01 * b0 + a11 * b1 + a21 * b2;
		r[6] = a02 * b0 + a12 * b1 + a22 * b2;
		r[7] = 0;
		b0 = b[8];
		b1 = b[9];
		b2 = b[10];
		r[8] = a00 * b0 + a10 * b1 + a20 * b2;
		r[9] = a01 * b0 + a11 * b1 + a21 * b2;
		r[10] = a02 * b0 + a12 * b1 + a22 * b2;
		r[11] = 0;
		b0 = b[12];
		b1 = b[13];
		b2 = b[14];
		r[12] = a00 * b0 + a10 * b1 + a20 * b2 + a30;
		r[13] = a01 * b0 + a11 * b1 + a21 * b2 + a31;
		r[14] = a02 * b0 + a12 * b1 + a22 * b2 + a32;
		r[15] = 1;
		return this;
	}
	mul(rhs) {
		return this.mul2(this, rhs);
	}
	transformPoint(vec2, res = new Vec3()) {
		const m = this.data;
		const { x: x3, y: y2, z: z2 } = vec2;
		res.x = x3 * m[0] + y2 * m[4] + z2 * m[8] + m[12];
		res.y = x3 * m[1] + y2 * m[5] + z2 * m[9] + m[13];
		res.z = x3 * m[2] + y2 * m[6] + z2 * m[10] + m[14];
		return res;
	}
	transformVector(vec2, res = new Vec3()) {
		const m = this.data;
		const { x: x3, y: y2, z: z2 } = vec2;
		res.x = x3 * m[0] + y2 * m[4] + z2 * m[8];
		res.y = x3 * m[1] + y2 * m[5] + z2 * m[9];
		res.z = x3 * m[2] + y2 * m[6] + z2 * m[10];
		return res;
	}
	transformVec4(vec2, res = new Vec4()) {
		const m = this.data;
		const { x: x3, y: y2, z: z2, w } = vec2;
		res.x = x3 * m[0] + y2 * m[4] + z2 * m[8] + w * m[12];
		res.y = x3 * m[1] + y2 * m[5] + z2 * m[9] + w * m[13];
		res.z = x3 * m[2] + y2 * m[6] + z2 * m[10] + w * m[14];
		res.w = x3 * m[3] + y2 * m[7] + z2 * m[11] + w * m[15];
		return res;
	}
	setLookAt(position5, target2, up3) {
		z.sub2(position5, target2).normalize();
		y.copy(up3).normalize();
		x.cross(y, z).normalize();
		y.cross(z, x);
		const r = this.data;
		r[0] = x.x;
		r[1] = x.y;
		r[2] = x.z;
		r[3] = 0;
		r[4] = y.x;
		r[5] = y.y;
		r[6] = y.z;
		r[7] = 0;
		r[8] = z.x;
		r[9] = z.y;
		r[10] = z.z;
		r[11] = 0;
		r[12] = position5.x;
		r[13] = position5.y;
		r[14] = position5.z;
		r[15] = 1;
		return this;
	}
	setFrustum(left, right2, bottom, top, znear, zfar) {
		const temp1 = 2 * znear;
		const temp2 = right2 - left;
		const temp3 = top - bottom;
		const temp4 = zfar - znear;
		const r = this.data;
		r[0] = temp1 / temp2;
		r[1] = 0;
		r[2] = 0;
		r[3] = 0;
		r[4] = 0;
		r[5] = temp1 / temp3;
		r[6] = 0;
		r[7] = 0;
		r[8] = (right2 + left) / temp2;
		r[9] = (top + bottom) / temp3;
		r[10] = (-zfar - znear) / temp4;
		r[11] = -1;
		r[12] = 0;
		r[13] = 0;
		r[14] = -temp1 * zfar / temp4;
		r[15] = 0;
		return this;
	}
	setPerspective(fov, aspect, znear, zfar, fovIsHorizontal) {
		_Mat4._getPerspectiveHalfSize(_halfSize, fov, aspect, znear, fovIsHorizontal);
		return this.setFrustum(-_halfSize.x, _halfSize.x, -_halfSize.y, _halfSize.y, znear, zfar);
	}
	setOrtho(left, right2, bottom, top, near, far) {
		const r = this.data;
		r[0] = 2 / (right2 - left);
		r[1] = 0;
		r[2] = 0;
		r[3] = 0;
		r[4] = 0;
		r[5] = 2 / (top - bottom);
		r[6] = 0;
		r[7] = 0;
		r[8] = 0;
		r[9] = 0;
		r[10] = -2 / (far - near);
		r[11] = 0;
		r[12] = -(right2 + left) / (right2 - left);
		r[13] = -(top + bottom) / (top - bottom);
		r[14] = -(far + near) / (far - near);
		r[15] = 1;
		return this;
	}
	setFromAxisAngle(axis, angle) {
		angle *= math.DEG_TO_RAD;
		const { x: x3, y: y2, z: z2 } = axis;
		const c2 = Math.cos(angle);
		const s2 = Math.sin(angle);
		const t = 1 - c2;
		const tx = t * x3;
		const ty = t * y2;
		const m = this.data;
		m[0] = tx * x3 + c2;
		m[1] = tx * y2 + s2 * z2;
		m[2] = tx * z2 - s2 * y2;
		m[3] = 0;
		m[4] = tx * y2 - s2 * z2;
		m[5] = ty * y2 + c2;
		m[6] = ty * z2 + s2 * x3;
		m[7] = 0;
		m[8] = tx * z2 + s2 * y2;
		m[9] = ty * z2 - x3 * s2;
		m[10] = t * z2 * z2 + c2;
		m[11] = 0;
		m[12] = 0;
		m[13] = 0;
		m[14] = 0;
		m[15] = 1;
		return this;
	}
	setTranslate(x3, y2, z2) {
		const m = this.data;
		m[0] = 1;
		m[1] = 0;
		m[2] = 0;
		m[3] = 0;
		m[4] = 0;
		m[5] = 1;
		m[6] = 0;
		m[7] = 0;
		m[8] = 0;
		m[9] = 0;
		m[10] = 1;
		m[11] = 0;
		m[12] = x3;
		m[13] = y2;
		m[14] = z2;
		m[15] = 1;
		return this;
	}
	setScale(x3, y2, z2) {
		const m = this.data;
		m[0] = x3;
		m[1] = 0;
		m[2] = 0;
		m[3] = 0;
		m[4] = 0;
		m[5] = y2;
		m[6] = 0;
		m[7] = 0;
		m[8] = 0;
		m[9] = 0;
		m[10] = z2;
		m[11] = 0;
		m[12] = 0;
		m[13] = 0;
		m[14] = 0;
		m[15] = 1;
		return this;
	}
	setViewport(x3, y2, width, height) {
		const m = this.data;
		m[0] = width * 0.5;
		m[1] = 0;
		m[2] = 0;
		m[3] = 0;
		m[4] = 0;
		m[5] = height * 0.5;
		m[6] = 0;
		m[7] = 0;
		m[8] = 0;
		m[9] = 0;
		m[10] = 0.5;
		m[11] = 0;
		m[12] = x3 + width * 0.5;
		m[13] = y2 + height * 0.5;
		m[14] = 0.5;
		m[15] = 1;
		return this;
	}
	setReflection(normal, distance) {
		const a = normal.x;
		const b = normal.y;
		const c2 = normal.z;
		const data2 = this.data;
		data2[0] = 1 - 2 * a * a;
		data2[1] = -2 * a * b;
		data2[2] = -2 * a * c2;
		data2[3] = 0;
		data2[4] = -2 * a * b;
		data2[5] = 1 - 2 * b * b;
		data2[6] = -2 * b * c2;
		data2[7] = 0;
		data2[8] = -2 * a * c2;
		data2[9] = -2 * b * c2;
		data2[10] = 1 - 2 * c2 * c2;
		data2[11] = 0;
		data2[12] = -2 * a * distance;
		data2[13] = -2 * b * distance;
		data2[14] = -2 * c2 * distance;
		data2[15] = 1;
		return this;
	}
	invert(src = this) {
		const s2 = src.data;
		const a00 = s2[0];
		const a01 = s2[1];
		const a02 = s2[2];
		const a03 = s2[3];
		const a10 = s2[4];
		const a11 = s2[5];
		const a12 = s2[6];
		const a13 = s2[7];
		const a20 = s2[8];
		const a21 = s2[9];
		const a22 = s2[10];
		const a23 = s2[11];
		const a30 = s2[12];
		const a31 = s2[13];
		const a32 = s2[14];
		const a33 = s2[15];
		const b00 = a00 * a11 - a01 * a10;
		const b01 = a00 * a12 - a02 * a10;
		const b02 = a00 * a13 - a03 * a10;
		const b03 = a01 * a12 - a02 * a11;
		const b04 = a01 * a13 - a03 * a11;
		const b05 = a02 * a13 - a03 * a12;
		const b06 = a20 * a31 - a21 * a30;
		const b07 = a20 * a32 - a22 * a30;
		const b08 = a20 * a33 - a23 * a30;
		const b09 = a21 * a32 - a22 * a31;
		const b10 = a21 * a33 - a23 * a31;
		const b11 = a22 * a33 - a23 * a32;
		const det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
		if (det === 0) {
			this.setIdentity();
		} else {
			const invDet = 1 / det;
			const t = this.data;
			t[0] = (a11 * b11 - a12 * b10 + a13 * b09) * invDet;
			t[1] = (-a01 * b11 + a02 * b10 - a03 * b09) * invDet;
			t[2] = (a31 * b05 - a32 * b04 + a33 * b03) * invDet;
			t[3] = (-a21 * b05 + a22 * b04 - a23 * b03) * invDet;
			t[4] = (-a10 * b11 + a12 * b08 - a13 * b07) * invDet;
			t[5] = (a00 * b11 - a02 * b08 + a03 * b07) * invDet;
			t[6] = (-a30 * b05 + a32 * b02 - a33 * b01) * invDet;
			t[7] = (a20 * b05 - a22 * b02 + a23 * b01) * invDet;
			t[8] = (a10 * b10 - a11 * b08 + a13 * b06) * invDet;
			t[9] = (-a00 * b10 + a01 * b08 - a03 * b06) * invDet;
			t[10] = (a30 * b04 - a31 * b02 + a33 * b00) * invDet;
			t[11] = (-a20 * b04 + a21 * b02 - a23 * b00) * invDet;
			t[12] = (-a10 * b09 + a11 * b07 - a12 * b06) * invDet;
			t[13] = (a00 * b09 - a01 * b07 + a02 * b06) * invDet;
			t[14] = (-a30 * b03 + a31 * b01 - a32 * b00) * invDet;
			t[15] = (a20 * b03 - a21 * b01 + a22 * b00) * invDet;
		}
		return this;
	}
	set(src) {
		const dst = this.data;
		dst[0] = src[0];
		dst[1] = src[1];
		dst[2] = src[2];
		dst[3] = src[3];
		dst[4] = src[4];
		dst[5] = src[5];
		dst[6] = src[6];
		dst[7] = src[7];
		dst[8] = src[8];
		dst[9] = src[9];
		dst[10] = src[10];
		dst[11] = src[11];
		dst[12] = src[12];
		dst[13] = src[13];
		dst[14] = src[14];
		dst[15] = src[15];
		return this;
	}
	setIdentity() {
		const m = this.data;
		m[0] = 1;
		m[1] = 0;
		m[2] = 0;
		m[3] = 0;
		m[4] = 0;
		m[5] = 1;
		m[6] = 0;
		m[7] = 0;
		m[8] = 0;
		m[9] = 0;
		m[10] = 1;
		m[11] = 0;
		m[12] = 0;
		m[13] = 0;
		m[14] = 0;
		m[15] = 1;
		return this;
	}
	setTRS(t, r, s2) {
		const qx = r.x;
		const qy = r.y;
		const qz = r.z;
		const qw = r.w;
		const sx = s2.x;
		const sy = s2.y;
		const sz = s2.z;
		const x22 = qx + qx;
		const y2 = qy + qy;
		const z2 = qz + qz;
		const xx = qx * x22;
		const xy = qx * y2;
		const xz = qx * z2;
		const yy = qy * y2;
		const yz = qy * z2;
		const zz = qz * z2;
		const wx = qw * x22;
		const wy = qw * y2;
		const wz = qw * z2;
		const m = this.data;
		m[0] = (1 - (yy + zz)) * sx;
		m[1] = (xy + wz) * sx;
		m[2] = (xz - wy) * sx;
		m[3] = 0;
		m[4] = (xy - wz) * sy;
		m[5] = (1 - (xx + zz)) * sy;
		m[6] = (yz + wx) * sy;
		m[7] = 0;
		m[8] = (xz + wy) * sz;
		m[9] = (yz - wx) * sz;
		m[10] = (1 - (xx + yy)) * sz;
		m[11] = 0;
		m[12] = t.x;
		m[13] = t.y;
		m[14] = t.z;
		m[15] = 1;
		return this;
	}
	transpose(src = this) {
		const s2 = src.data;
		const t = this.data;
		if (s2 === t) {
			let tmp;
			tmp = s2[1];
			t[1] = s2[4];
			t[4] = tmp;
			tmp = s2[2];
			t[2] = s2[8];
			t[8] = tmp;
			tmp = s2[3];
			t[3] = s2[12];
			t[12] = tmp;
			tmp = s2[6];
			t[6] = s2[9];
			t[9] = tmp;
			tmp = s2[7];
			t[7] = s2[13];
			t[13] = tmp;
			tmp = s2[11];
			t[11] = s2[14];
			t[14] = tmp;
		} else {
			t[0] = s2[0];
			t[1] = s2[4];
			t[2] = s2[8];
			t[3] = s2[12];
			t[4] = s2[1];
			t[5] = s2[5];
			t[6] = s2[9];
			t[7] = s2[13];
			t[8] = s2[2];
			t[9] = s2[6];
			t[10] = s2[10];
			t[11] = s2[14];
			t[12] = s2[3];
			t[13] = s2[7];
			t[14] = s2[11];
			t[15] = s2[15];
		}
		return this;
	}
	getTranslation(t = new Vec3()) {
		return t.set(this.data[12], this.data[13], this.data[14]);
	}
	getX(x3 = new Vec3()) {
		return x3.set(this.data[0], this.data[1], this.data[2]);
	}
	getY(y2 = new Vec3()) {
		return y2.set(this.data[4], this.data[5], this.data[6]);
	}
	getZ(z2 = new Vec3()) {
		return z2.set(this.data[8], this.data[9], this.data[10]);
	}
	getScale(scale2 = new Vec3()) {
		this.getX(x);
		this.getY(y);
		this.getZ(z);
		scale2.set(x.length(), y.length(), z.length());
		return scale2;
	}
	get scaleSign() {
		this.getX(x);
		this.getY(y);
		this.getZ(z);
		x.cross(x, y);
		return x.dot(z) < 0 ? -1 : 1;
	}
	setFromEulerAngles(ex, ey, ez) {
		ex *= math.DEG_TO_RAD;
		ey *= math.DEG_TO_RAD;
		ez *= math.DEG_TO_RAD;
		const s1 = Math.sin(-ex);
		const c1 = Math.cos(-ex);
		const s2 = Math.sin(-ey);
		const c2 = Math.cos(-ey);
		const s3 = Math.sin(-ez);
		const c3 = Math.cos(-ez);
		const m = this.data;
		m[0] = c2 * c3;
		m[1] = -c2 * s3;
		m[2] = s2;
		m[3] = 0;
		m[4] = c1 * s3 + c3 * s1 * s2;
		m[5] = c1 * c3 - s1 * s2 * s3;
		m[6] = -c2 * s1;
		m[7] = 0;
		m[8] = s1 * s3 - c1 * c3 * s2;
		m[9] = c3 * s1 + c1 * s2 * s3;
		m[10] = c1 * c2;
		m[11] = 0;
		m[12] = 0;
		m[13] = 0;
		m[14] = 0;
		m[15] = 1;
		return this;
	}
	getEulerAngles(eulers = new Vec3()) {
		this.getScale(scale);
		const sx = scale.x;
		const sy = scale.y;
		const sz = scale.z;
		if (sx === 0 || sy === 0 || sz === 0) {
			return eulers.set(0, 0, 0);
		}
		const m = this.data;
		const y2 = Math.asin(-m[2] / sx);
		const halfPi = Math.PI * 0.5;
		let x3, z2;
		if (y2 < halfPi) {
			if (y2 > -halfPi) {
				x3 = Math.atan2(m[6] / sy, m[10] / sz);
				z2 = Math.atan2(m[1] / sx, m[0] / sx);
			} else {
				z2 = 0;
				x3 = -Math.atan2(m[4] / sy, m[5] / sy);
			}
		} else {
			z2 = 0;
			x3 = Math.atan2(m[4] / sy, m[5] / sy);
		}
		return eulers.set(x3, y2, z2).mulScalar(math.RAD_TO_DEG);
	}
	toString() {
		return `[${this.data.join(", ")}]`;
	}
	static IDENTITY = Object.freeze(new _Mat4());
	static ZERO = Object.freeze(new _Mat4().set([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]));
};

var Quat = class _Quat {
	x;
	y;
	z;
	w;
	constructor(x3 = 0, y2 = 0, z2 = 0, w = 1) {
		if (x3.length === 4) {
			this.x = x3[0];
			this.y = x3[1];
			this.z = x3[2];
			this.w = x3[3];
		} else {
			this.x = x3;
			this.y = y2;
			this.z = z2;
			this.w = w;
		}
	}
	clone() {
		const cstr = this.constructor;
		return new cstr(this.x, this.y, this.z, this.w);
	}
	conjugate(src = this) {
		this.x = src.x * -1;
		this.y = src.y * -1;
		this.z = src.z * -1;
		this.w = src.w;
		return this;
	}
	copy(rhs) {
		this.x = rhs.x;
		this.y = rhs.y;
		this.z = rhs.z;
		this.w = rhs.w;
		return this;
	}
	dot(other) {
		return this.x * other.x + this.y * other.y + this.z * other.z + this.w * other.w;
	}
	equals(rhs) {
		return this.x === rhs.x && this.y === rhs.y && this.z === rhs.z && this.w === rhs.w;
	}
	equalsApprox(rhs, epsilon = 1e-6) {
		return Math.abs(this.x - rhs.x) < epsilon && Math.abs(this.y - rhs.y) < epsilon && Math.abs(this.z - rhs.z) < epsilon && Math.abs(this.w - rhs.w) < epsilon;
	}
	getAxisAngle(axis) {
		let rad = Math.acos(this.w) * 2;
		const s2 = Math.sin(rad / 2);
		if (s2 !== 0) {
			axis.x = this.x / s2;
			axis.y = this.y / s2;
			axis.z = this.z / s2;
			if (axis.x < 0 || axis.y < 0 || axis.z < 0) {
				axis.x *= -1;
				axis.y *= -1;
				axis.z *= -1;
				rad *= -1;
			}
		} else {
			axis.x = 1;
			axis.y = 0;
			axis.z = 0;
		}
		return rad * math.RAD_TO_DEG;
	}
	getEulerAngles(eulers = new Vec3()) {
		let x3, y2, z2;
		const qx = this.x;
		const qy = this.y;
		const qz = this.z;
		const qw = this.w;
		const a2 = 2 * (qw * qy - qx * qz);
		if (a2 <= -0.99999) {
			x3 = 2 * Math.atan2(qx, qw);
			y2 = -Math.PI / 2;
			z2 = 0;
		} else if (a2 >= 0.99999) {
			x3 = 2 * Math.atan2(qx, qw);
			y2 = Math.PI / 2;
			z2 = 0;
		} else {
			x3 = Math.atan2(2 * (qw * qx + qy * qz), 1 - 2 * (qx * qx + qy * qy));
			y2 = Math.asin(a2);
			z2 = Math.atan2(2 * (qw * qz + qx * qy), 1 - 2 * (qy * qy + qz * qz));
		}
		return eulers.set(x3, y2, z2).mulScalar(math.RAD_TO_DEG);
	}
	invert(src = this) {
		return this.conjugate(src).normalize();
	}
	length() {
		return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
	}
	lengthSq() {
		return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
	}
	lerp(lhs, rhs, alpha) {
		const omt = (1 - alpha) * (lhs.dot(rhs) < 0 ? -1 : 1);
		this.x = lhs.x * omt + rhs.x * alpha;
		this.y = lhs.y * omt + rhs.y * alpha;
		this.z = lhs.z * omt + rhs.z * alpha;
		this.w = lhs.w * omt + rhs.w * alpha;
		return this.normalize();
	}
	mul(rhs) {
		const q1x = this.x;
		const q1y = this.y;
		const q1z = this.z;
		const q1w = this.w;
		const q2x = rhs.x;
		const q2y = rhs.y;
		const q2z = rhs.z;
		const q2w = rhs.w;
		this.x = q1w * q2x + q1x * q2w + q1y * q2z - q1z * q2y;
		this.y = q1w * q2y + q1y * q2w + q1z * q2x - q1x * q2z;
		this.z = q1w * q2z + q1z * q2w + q1x * q2y - q1y * q2x;
		this.w = q1w * q2w - q1x * q2x - q1y * q2y - q1z * q2z;
		return this;
	}
	mulScalar(scalar, src = this) {
		this.x = src.x * scalar;
		this.y = src.y * scalar;
		this.z = src.z * scalar;
		this.w = src.w * scalar;
		return this;
	}
	mul2(lhs, rhs) {
		const q1x = lhs.x;
		const q1y = lhs.y;
		const q1z = lhs.z;
		const q1w = lhs.w;
		const q2x = rhs.x;
		const q2y = rhs.y;
		const q2z = rhs.z;
		const q2w = rhs.w;
		this.x = q1w * q2x + q1x * q2w + q1y * q2z - q1z * q2y;
		this.y = q1w * q2y + q1y * q2w + q1z * q2x - q1x * q2z;
		this.z = q1w * q2z + q1z * q2w + q1x * q2y - q1y * q2x;
		this.w = q1w * q2w - q1x * q2x - q1y * q2y - q1z * q2z;
		return this;
	}
	normalize(src = this) {
		let len = src.length();
		if (len === 0) {
			this.x = this.y = this.z = 0;
			this.w = 1;
		} else {
			len = 1 / len;
			this.x = src.x * len;
			this.y = src.y * len;
			this.z = src.z * len;
			this.w = src.w * len;
		}
		return this;
	}
	set(x3, y2, z2, w) {
		this.x = x3;
		this.y = y2;
		this.z = z2;
		this.w = w;
		return this;
	}
	setFromAxisAngle(axis, angle) {
		angle *= 0.5 * math.DEG_TO_RAD;
		const sa = Math.sin(angle);
		const ca = Math.cos(angle);
		this.x = sa * axis.x;
		this.y = sa * axis.y;
		this.z = sa * axis.z;
		this.w = ca;
		return this;
	}
	setFromEulerAngles(ex, ey, ez) {
		if (ex instanceof Vec3) {
			const vec2 = ex;
			ex = vec2.x;
			ey = vec2.y;
			ez = vec2.z;
		}
		const halfToRad = 0.5 * math.DEG_TO_RAD;
		ex *= halfToRad;
		ey *= halfToRad;
		ez *= halfToRad;
		const sx = Math.sin(ex);
		const cx = Math.cos(ex);
		const sy = Math.sin(ey);
		const cy = Math.cos(ey);
		const sz = Math.sin(ez);
		const cz = Math.cos(ez);
		this.x = sx * cy * cz - cx * sy * sz;
		this.y = cx * sy * cz + sx * cy * sz;
		this.z = cx * cy * sz - sx * sy * cz;
		this.w = cx * cy * cz + sx * sy * sz;
		return this;
	}
	setFromMat4(m) {
		const d = m.data;
		let m00 = d[0];
		let m01 = d[1];
		let m02 = d[2];
		let m10 = d[4];
		let m11 = d[5];
		let m12 = d[6];
		let m20 = d[8];
		let m21 = d[9];
		let m22 = d[10];
		const det = m00 * (m11 * m22 - m12 * m21) - m01 * (m10 * m22 - m12 * m20) + m02 * (m10 * m21 - m11 * m20);
		if (det < 0) {
			m00 = -m00;
			m01 = -m01;
			m02 = -m02;
		}
		let l;
		l = m00 * m00 + m01 * m01 + m02 * m02;
		if (l === 0) return this.set(0, 0, 0, 1);
		l = 1 / Math.sqrt(l);
		m00 *= l;
		m01 *= l;
		m02 *= l;
		l = m10 * m10 + m11 * m11 + m12 * m12;
		if (l === 0) return this.set(0, 0, 0, 1);
		l = 1 / Math.sqrt(l);
		m10 *= l;
		m11 *= l;
		m12 *= l;
		l = m20 * m20 + m21 * m21 + m22 * m22;
		if (l === 0) return this.set(0, 0, 0, 1);
		l = 1 / Math.sqrt(l);
		m20 *= l;
		m21 *= l;
		m22 *= l;
		if (m22 < 0) {
			if (m00 > m11) {
				this.set(1 + m00 - m11 - m22, m01 + m10, m20 + m02, m12 - m21);
			} else {
				this.set(m01 + m10, 1 - m00 + m11 - m22, m12 + m21, m20 - m02);
			}
		} else {
			if (m00 < -m11) {
				this.set(m20 + m02, m12 + m21, 1 - m00 - m11 + m22, m01 - m10);
			} else {
				this.set(m12 - m21, m20 - m02, m01 - m10, 1 + m00 + m11 + m22);
			}
		}
		return this.mulScalar(1 / this.length());
	}
	setFromDirections(from, to) {
		const dotProduct = 1 + from.dot(to);
		if (dotProduct < Number.EPSILON) {
			if (Math.abs(from.x) > Math.abs(from.y)) {
				this.x = -from.z;
				this.y = 0;
				this.z = from.x;
				this.w = 0;
			} else {
				this.x = 0;
				this.y = -from.z;
				this.z = from.y;
				this.w = 0;
			}
		} else {
			this.x = from.y * to.z - from.z * to.y;
			this.y = from.z * to.x - from.x * to.z;
			this.z = from.x * to.y - from.y * to.x;
			this.w = dotProduct;
		}
		return this.normalize();
	}
	slerp(lhs, rhs, alpha) {
		const lx = lhs.x;
		const ly = lhs.y;
		const lz = lhs.z;
		const lw = lhs.w;
		let rx = rhs.x;
		let ry = rhs.y;
		let rz = rhs.z;
		let rw = rhs.w;
		let cosHalfTheta = lw * rw + lx * rx + ly * ry + lz * rz;
		if (cosHalfTheta < 0) {
			rw = -rw;
			rx = -rx;
			ry = -ry;
			rz = -rz;
			cosHalfTheta = -cosHalfTheta;
		}
		if (Math.abs(cosHalfTheta) >= 1) {
			this.w = lw;
			this.x = lx;
			this.y = ly;
			this.z = lz;
			return this;
		}
		const halfTheta = Math.acos(cosHalfTheta);
		const sinHalfTheta = Math.sqrt(1 - cosHalfTheta * cosHalfTheta);
		if (Math.abs(sinHalfTheta) < 1e-3) {
			this.w = lw * 0.5 + rw * 0.5;
			this.x = lx * 0.5 + rx * 0.5;
			this.y = ly * 0.5 + ry * 0.5;
			this.z = lz * 0.5 + rz * 0.5;
			return this;
		}
		const ratioA = Math.sin((1 - alpha) * halfTheta) / sinHalfTheta;
		const ratioB = Math.sin(alpha * halfTheta) / sinHalfTheta;
		this.w = lw * ratioA + rw * ratioB;
		this.x = lx * ratioA + rx * ratioB;
		this.y = ly * ratioA + ry * ratioB;
		this.z = lz * ratioA + rz * ratioB;
		return this;
	}
	transformVector(vec2, res = new Vec3()) {
		const x3 = vec2.x, y2 = vec2.y, z2 = vec2.z;
		const qx = this.x, qy = this.y, qz = this.z, qw = this.w;
		const ix = qw * x3 + qy * z2 - qz * y2;
		const iy = qw * y2 + qz * x3 - qx * z2;
		const iz = qw * z2 + qx * y2 - qy * x3;
		const iw = -qx * x3 - qy * y2 - qz * z2;
		res.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
		res.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
		res.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
		return res;
	}
	fromArray(arr, offset3 = 0) {
		this.x = arr[offset3] ?? this.x;
		this.y = arr[offset3 + 1] ?? this.y;
		this.z = arr[offset3 + 2] ?? this.z;
		this.w = arr[offset3 + 3] ?? this.w;
		return this;
	}
	toString() {
		return `[${this.x}, ${this.y}, ${this.z}, ${this.w}]`;
	}
	toArray(arr = [], offset3 = 0) {
		arr[offset3] = this.x;
		arr[offset3 + 1] = this.y;
		arr[offset3 + 2] = this.z;
		arr[offset3 + 3] = this.w;
		return arr;
	}
	static IDENTITY = Object.freeze(new _Quat(0, 0, 0, 1));
	static ZERO = Object.freeze(new _Quat(0, 0, 0, 0));
};

var tmpVecA = new Vec3();
var tmpVecB = new Vec3();
var tmpVecC = new Vec3();
var tmpVecD = new Vec3();
var tmpVecE = new Vec3();
var BoundingBox = class _BoundingBox {
	center = new Vec3();
	halfExtents = new Vec3(0.5, 0.5, 0.5);
	_min = new Vec3();
	_max = new Vec3();
	constructor(center2, halfExtents) {
		if (center2) {
			this.center.copy(center2);
		}
		if (halfExtents) {
			this.halfExtents.copy(halfExtents);
		}
	}
	add(other) {
		const tc = this.center;
		const tcx = tc.x;
		const tcy = tc.y;
		const tcz = tc.z;
		const th = this.halfExtents;
		const thx = th.x;
		const thy = th.y;
		const thz = th.z;
		let tminx = tcx - thx;
		let tmaxx = tcx + thx;
		let tminy = tcy - thy;
		let tmaxy = tcy + thy;
		let tminz = tcz - thz;
		let tmaxz = tcz + thz;
		const oc = other.center;
		const ocx = oc.x;
		const ocy = oc.y;
		const ocz = oc.z;
		const oh = other.halfExtents;
		const ohx = oh.x;
		const ohy = oh.y;
		const ohz = oh.z;
		const ominx = ocx - ohx;
		const omaxx = ocx + ohx;
		const ominy = ocy - ohy;
		const omaxy = ocy + ohy;
		const ominz = ocz - ohz;
		const omaxz = ocz + ohz;
		if (ominx < tminx) tminx = ominx;
		if (omaxx > tmaxx) tmaxx = omaxx;
		if (ominy < tminy) tminy = ominy;
		if (omaxy > tmaxy) tmaxy = omaxy;
		if (ominz < tminz) tminz = ominz;
		if (omaxz > tmaxz) tmaxz = omaxz;
		tc.x = (tminx + tmaxx) * 0.5;
		tc.y = (tminy + tmaxy) * 0.5;
		tc.z = (tminz + tmaxz) * 0.5;
		th.x = (tmaxx - tminx) * 0.5;
		th.y = (tmaxy - tminy) * 0.5;
		th.z = (tmaxz - tminz) * 0.5;
	}
	copy(src) {
		this.center.copy(src.center);
		this.halfExtents.copy(src.halfExtents);
	}
	clone() {
		return new _BoundingBox(this.center, this.halfExtents);
	}
	intersects(other) {
		const aMax = this.getMax();
		const aMin = this.getMin();
		const bMax2 = other.getMax();
		const bMin2 = other.getMin();
		return aMin.x <= bMax2.x && aMax.x >= bMin2.x && aMin.y <= bMax2.y && aMax.y >= bMin2.y && aMin.z <= bMax2.z && aMax.z >= bMin2.z;
	}
	_intersectsRay(ray3, point5) {
		const tMin = tmpVecA.copy(this.getMin()).sub(ray3.origin);
		const tMax = tmpVecB.copy(this.getMax()).sub(ray3.origin);
		const dir4 = ray3.direction;
		if (dir4.x === 0) {
			tMin.x = tMin.x < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
			tMax.x = tMax.x < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
		} else {
			tMin.x /= dir4.x;
			tMax.x /= dir4.x;
		}
		if (dir4.y === 0) {
			tMin.y = tMin.y < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
			tMax.y = tMax.y < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
		} else {
			tMin.y /= dir4.y;
			tMax.y /= dir4.y;
		}
		if (dir4.z === 0) {
			tMin.z = tMin.z < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
			tMax.z = tMax.z < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
		} else {
			tMin.z /= dir4.z;
			tMax.z /= dir4.z;
		}
		const realMin = tmpVecC.set(Math.min(tMin.x, tMax.x), Math.min(tMin.y, tMax.y), Math.min(tMin.z, tMax.z));
		const realMax = tmpVecD.set(Math.max(tMin.x, tMax.x), Math.max(tMin.y, tMax.y), Math.max(tMin.z, tMax.z));
		const minMax = Math.min(Math.min(realMax.x, realMax.y), realMax.z);
		const maxMin = Math.max(Math.max(realMin.x, realMin.y), realMin.z);
		const intersects = minMax >= maxMin && maxMin >= 0;
		if (intersects) {
			point5.copy(ray3.direction).mulScalar(maxMin).add(ray3.origin);
		}
		return intersects;
	}
	_fastIntersectsRay(ray3) {
		const diff = tmpVecA;
		const cross = tmpVecB;
		const prod = tmpVecC;
		const absDiff = tmpVecD;
		const absDir = tmpVecE;
		const rayDir = ray3.direction;
		diff.sub2(ray3.origin, this.center);
		absDiff.set(Math.abs(diff.x), Math.abs(diff.y), Math.abs(diff.z));
		prod.mul2(diff, rayDir);
		if (absDiff.x > this.halfExtents.x && prod.x >= 0) {
			return false;
		}
		if (absDiff.y > this.halfExtents.y && prod.y >= 0) {
			return false;
		}
		if (absDiff.z > this.halfExtents.z && prod.z >= 0) {
			return false;
		}
		absDir.set(Math.abs(rayDir.x), Math.abs(rayDir.y), Math.abs(rayDir.z));
		cross.cross(rayDir, diff);
		cross.set(Math.abs(cross.x), Math.abs(cross.y), Math.abs(cross.z));
		if (cross.x > this.halfExtents.y * absDir.z + this.halfExtents.z * absDir.y) {
			return false;
		}
		if (cross.y > this.halfExtents.x * absDir.z + this.halfExtents.z * absDir.x) {
			return false;
		}
		if (cross.z > this.halfExtents.x * absDir.y + this.halfExtents.y * absDir.x) {
			return false;
		}
		return true;
	}
	intersectsRay(ray3, point5) {
		if (point5) {
			return this._intersectsRay(ray3, point5);
		}
		return this._fastIntersectsRay(ray3);
	}
	setMinMax(min, max) {
		this.center.add2(max, min).mulScalar(0.5);
		this.halfExtents.sub2(max, min).mulScalar(0.5);
	}
	getMin() {
		return this._min.copy(this.center).sub(this.halfExtents);
	}
	getMax() {
		return this._max.copy(this.center).add(this.halfExtents);
	}
	containsPoint(point5) {
		const c2 = this.center;
		const h2 = this.halfExtents;
		if (point5.x < c2.x - h2.x || point5.x > c2.x + h2.x || point5.y < c2.y - h2.y || point5.y > c2.y + h2.y || point5.z < c2.z - h2.z || point5.z > c2.z + h2.z) {
			return false;
		}
		return true;
	}
	closestPoint(point5, result = new Vec3()) {
		const c2 = this.center;
		const h2 = this.halfExtents;
		return result.set(
			Math.max(c2.x - h2.x, Math.min(point5.x, c2.x + h2.x)),
			Math.max(c2.y - h2.y, Math.min(point5.y, c2.y + h2.y)),
			Math.max(c2.z - h2.z, Math.min(point5.z, c2.z + h2.z))
		);
	}
	setFromTransformedAabb(aabb3, m, ignoreScale = false) {
		const ac = aabb3.center;
		const ar = aabb3.halfExtents;
		const d = m.data;
		let mx0 = d[0];
		let mx1 = d[4];
		let mx2 = d[8];
		let my0 = d[1];
		let my1 = d[5];
		let my2 = d[9];
		let mz0 = d[2];
		let mz1 = d[6];
		let mz2 = d[10];
		if (ignoreScale) {
			let lengthSq = mx0 * mx0 + mx1 * mx1 + mx2 * mx2;
			if (lengthSq > 0) {
				const invLength = 1 / Math.sqrt(lengthSq);
				mx0 *= invLength;
				mx1 *= invLength;
				mx2 *= invLength;
			}
			lengthSq = my0 * my0 + my1 * my1 + my2 * my2;
			if (lengthSq > 0) {
				const invLength = 1 / Math.sqrt(lengthSq);
				my0 *= invLength;
				my1 *= invLength;
				my2 *= invLength;
			}
			lengthSq = mz0 * mz0 + mz1 * mz1 + mz2 * mz2;
			if (lengthSq > 0) {
				const invLength = 1 / Math.sqrt(lengthSq);
				mz0 *= invLength;
				mz1 *= invLength;
				mz2 *= invLength;
			}
		}
		this.center.set(
			d[12] + mx0 * ac.x + mx1 * ac.y + mx2 * ac.z,
			d[13] + my0 * ac.x + my1 * ac.y + my2 * ac.z,
			d[14] + mz0 * ac.x + mz1 * ac.y + mz2 * ac.z
		);
		this.halfExtents.set(
			Math.abs(mx0) * ar.x + Math.abs(mx1) * ar.y + Math.abs(mx2) * ar.z,
			Math.abs(my0) * ar.x + Math.abs(my1) * ar.y + Math.abs(my2) * ar.z,
			Math.abs(mz0) * ar.x + Math.abs(mz1) * ar.y + Math.abs(mz2) * ar.z
		);
	}
	static computeMinMax(vertices, min, max, numVerts = vertices.length / 3) {
		if (numVerts > 0) {
			let minx = vertices[0];
			let miny = vertices[1];
			let minz = vertices[2];
			let maxx = minx;
			let maxy = miny;
			let maxz = minz;
			const n = numVerts * 3;
			for (let i2 = 3; i2 < n; i2 += 3) {
				const x3 = vertices[i2];
				const y2 = vertices[i2 + 1];
				const z2 = vertices[i2 + 2];
				if (x3 < minx) minx = x3;
				if (y2 < miny) miny = y2;
				if (z2 < minz) minz = z2;
				if (x3 > maxx) maxx = x3;
				if (y2 > maxy) maxy = y2;
				if (z2 > maxz) maxz = z2;
			}
			min.set(minx, miny, minz);
			max.set(maxx, maxy, maxz);
		}
	}
	compute(vertices, numVerts) {
		_BoundingBox.computeMinMax(vertices, tmpVecA, tmpVecB, numVerts);
		this.setMinMax(tmpVecA, tmpVecB);
	}
	intersectsBoundingSphere(sphere) {
		const sq = this._distanceToBoundingSphereSq(sphere);
		if (sq <= sphere.radius * sphere.radius) {
			return true;
		}
		return false;
	}
	_distanceToBoundingSphereSq(sphere) {
		const boxMin = this.getMin();
		const boxMax = this.getMax();
		let sq = 0;
		const axis = ["x", "y", "z"];
		for (let i2 = 0; i2 < 3; ++i2) {
			let out = 0;
			const pn = sphere.center[axis[i2]];
			const bMin2 = boxMin[axis[i2]];
			const bMax2 = boxMax[axis[i2]];
			let val = 0;
			if (pn < bMin2) {
				val = bMin2 - pn;
				out += val * val;
			}
			if (pn > bMax2) {
				val = pn - bMax2;
				out += val * val;
			}
			sq += out;
		}
		return sq;
	}
	_expand(expandMin, expandMax) {
		tmpVecA.add2(this.getMin(), expandMin);
		tmpVecB.add2(this.getMax(), expandMax);
		this.setMinMax(tmpVecA, tmpVecB);
	}
};

var tmpVecA2 = new Vec3();
var tmpVecB2 = new Vec3();
var BoundingSphere = class {
	center;
	radius;
	constructor(center2 = new Vec3(), radius = 0.5) {
		this.center = center2;
		this.radius = radius;
	}
	containsPoint(point5) {
		const lenSq = tmpVecA2.sub2(point5, this.center).lengthSq();
		const r = this.radius;
		return lenSq < r * r;
	}
	intersectsRay(ray3, point5) {
		const m = tmpVecA2.copy(ray3.origin).sub(this.center);
		const b = m.dot(tmpVecB2.copy(ray3.direction).normalize());
		const c2 = m.dot(m) - this.radius * this.radius;
		if (c2 > 0 && b > 0) {
			return false;
		}
		const discr = b * b - c2;
		if (discr < 0) {
			return false;
		}
		const t = Math.abs(-b - Math.sqrt(discr));
		if (point5) {
			point5.copy(ray3.direction).mulScalar(t).add(ray3.origin);
		}
		return true;
	}
	intersectsBoundingSphere(sphere) {
		tmpVecA2.sub2(sphere.center, this.center);
		const totalRadius = sphere.radius + this.radius;
		if (tmpVecA2.lengthSq() <= totalRadius * totalRadius) {
			return true;
		}
		return false;
	}
};

var Plane = class {
	normal = new Vec3();
	distance;
	constructor(normal = Vec3.UP, distance = 0) {
		this.normal.copy(normal);
		this.distance = distance;
	}
	clone() {
		const cstr = this.constructor;
		return new cstr().copy(this);
	}
	copy(src) {
		this.normal.copy(src.normal);
		this.distance = src.distance;
		return this;
	}
	intersectsLine(start, end, point5) {
		const d = this.distance;
		const d0 = this.normal.dot(start) + d;
		const d1 = this.normal.dot(end) + d;
		const t = d0 / (d0 - d1);
		const intersects = t >= 0 && t <= 1;
		if (intersects && point5) {
			point5.lerp(start, end, t);
		}
		return intersects;
	}
	intersectsRay(ray3, point5) {
		const denominator = this.normal.dot(ray3.direction);
		if (denominator === 0) {
			return false;
		}
		const t = -(this.normal.dot(ray3.origin) + this.distance) / denominator;
		if (t >= 0 && point5) {
			point5.copy(ray3.direction).mulScalar(t).add(ray3.origin);
		}
		return t >= 0;
	}
	normalize() {
		const invLength = 1 / this.normal.length();
		this.normal.mulScalar(invLength);
		this.distance *= invLength;
		return this;
	}
	set(nx, ny, nz, d) {
		this.normal.set(nx, ny, nz);
		this.distance = d;
		return this;
	}
	setFromPointNormal(point5, normal) {
		this.normal.copy(normal);
		this.distance = -this.normal.dot(point5);
		return this;
	}
};

var _c23 = new Vec3();
var _c31 = new Vec3();
var _c12 = new Vec3();
var _corner = new Vec3();
function intersectPlanes(p12, p22, p32, out) {
	_c23.cross(p22.normal, p32.normal);
	const denom = p12.normal.dot(_c23);
	if (Math.abs(denom) < 1e-6) {
		return false;
	}
	_c31.cross(p32.normal, p12.normal);
	_c12.cross(p12.normal, p22.normal);
	const invDenom = -1 / denom;
	out.set(
		(p12.distance * _c23.x + p22.distance * _c31.x + p32.distance * _c12.x) * invDenom,
		(p12.distance * _c23.y + p22.distance * _c31.y + p32.distance * _c12.y) * invDenom,
		(p12.distance * _c23.z + p22.distance * _c31.z + p32.distance * _c12.z) * invDenom
	);
	return isFinite(out.x) && isFinite(out.y) && isFinite(out.z);
}
var Frustum = class {
	planes = [];
	constructor() {
		for (let i2 = 0; i2 < 6; i2++) {
			this.planes[i2] = new Plane();
		}
	}
	clone() {
		const cstr = this.constructor;
		return new cstr().copy(this);
	}
	copy(src) {
		for (let i2 = 0; i2 < 6; i2++) {
			this.planes[i2].copy(src.planes[i2]);
		}
		return this;
	}
	setFromMat4(matrix2) {
		const d = matrix2.data;
		const m00 = d[0], m01 = d[1], m02 = d[2], m03 = d[3];
		const m10 = d[4], m11 = d[5], m12 = d[6], m13 = d[7];
		const m20 = d[8], m21 = d[9], m22 = d[10], m23 = d[11];
		const m30 = d[12], m31 = d[13], m32 = d[14], m33 = d[15];
		const planes = this.planes;
		planes[0].set(m03 - m00, m13 - m10, m23 - m20, m33 - m30).normalize();
		planes[1].set(m03 + m00, m13 + m10, m23 + m20, m33 + m30).normalize();
		planes[2].set(m03 + m01, m13 + m11, m23 + m21, m33 + m31).normalize();
		planes[3].set(m03 - m01, m13 - m11, m23 - m21, m33 - m31).normalize();
		planes[4].set(m03 - m02, m13 - m12, m23 - m22, m33 - m32).normalize();
		planes[5].set(m03 + m02, m13 + m12, m23 + m22, m33 + m32).normalize();
	}
	containsPoint(point5) {
		for (let p = 0; p < 6; p++) {
			const { normal, distance } = this.planes[p];
			if (normal.dot(point5) + distance <= 0) {
				return false;
			}
		}
		return true;
	}
	add(other) {
		const planes = this.planes;
		const op = other.planes;
		for (let zi = 4; zi <= 5; zi++) {
			for (let xi = 0; xi <= 1; xi++) {
				for (let yi = 2; yi <= 3; yi++) {
					if (intersectPlanes(op[zi], op[xi], op[yi], _corner)) {
						for (let p = 0; p < 6; p++) {
							const plane2 = planes[p];
							const d = plane2.normal.dot(_corner) + plane2.distance;
							if (d < 0) {
								plane2.distance -= d;
							}
						}
					}
				}
			}
		}
		return this;
	}
	containsSphere(sphere) {
		const { center: center2, radius } = sphere;
		let c2 = 0;
		for (let p = 0; p < 6; p++) {
			const { normal, distance } = this.planes[p];
			const d = normal.dot(center2) + distance;
			if (d <= -radius) {
				return 0;
			}
			if (d > radius) {
				c2++;
			}
		}
		return c2 === 6 ? 2 : 1;
	}
};

var Ray = class {
	origin = new Vec3();
	direction = Vec3.FORWARD.clone();
	constructor(origin, direction) {
		if (origin) {
			this.origin.copy(origin);
		}
		if (direction) {
			this.direction.copy(direction);
		}
	}
	set(origin, direction) {
		this.origin.copy(origin);
		this.direction.copy(direction);
		return this;
	}
	copy(src) {
		return this.set(src.origin, src.direction);
	}
	clone() {
		return new this.constructor(this.origin, this.direction);
	}
};

var tmpRay = new Ray();
var tmpVec3 = new Vec3();
var tmpSphere = new BoundingSphere();
var tmpMat4 = new Mat4();
var OrientedBox = class {
	halfExtents = new Vec3(0.5, 0.5, 0.5);
	_modelTransform;
	_worldTransform;
	_aabb;
	constructor(worldTransform = new Mat4(), halfExtents) {
		if (halfExtents) {
			this.halfExtents.copy(halfExtents);
		}
		this._modelTransform = worldTransform.clone().invert();
		this._worldTransform = worldTransform.clone();
		this._aabb = new BoundingBox(new Vec3(), this.halfExtents);
	}
	set worldTransform(value) {
		this._worldTransform.copy(value);
		this._modelTransform.copy(value).invert();
	}
	get worldTransform() {
		return this._worldTransform;
	}
	intersectsRay(ray3, point5) {
		this._modelTransform.transformPoint(ray3.origin, tmpRay.origin);
		this._modelTransform.transformVector(ray3.direction, tmpRay.direction);
		if (point5) {
			const result = this._aabb._intersectsRay(tmpRay, point5);
			tmpMat4.copy(this._modelTransform).invert().transformPoint(point5, point5);
			return result;
		}
		return this._aabb._fastIntersectsRay(tmpRay);
	}
	containsPoint(point5) {
		this._modelTransform.transformPoint(point5, tmpVec3);
		return this._aabb.containsPoint(tmpVec3);
	}
	intersectsBoundingSphere(sphere) {
		this._modelTransform.transformPoint(sphere.center, tmpSphere.center);
		tmpSphere.radius = sphere.radius;
		if (this._aabb.intersectsBoundingSphere(tmpSphere)) {
			return true;
		}
		return false;
	}
};

var e1 = new Vec3();
var e2 = new Vec3();
var h = new Vec3();
var s = new Vec3();
var q = new Vec3();
var EPSILON = 1e-6;
var Tri = class {
	v0 = new Vec3();
	v1 = new Vec3();
	v2 = new Vec3();
	constructor(v0 = Vec3.ZERO, v15 = Vec3.ZERO, v26 = Vec3.ZERO) {
		this.set(v0, v15, v26);
	}
	set(v0, v15, v26) {
		this.v0.copy(v0);
		this.v1.copy(v15);
		this.v2.copy(v26);
		return this;
	}
	intersectsRay(ray3, point5) {
		e1.sub2(this.v1, this.v0);
		e2.sub2(this.v2, this.v0);
		h.cross(ray3.direction, e2);
		const a = e1.dot(h);
		if (a > -EPSILON && a < EPSILON) {
			return false;
		}
		const f = 1 / a;
		s.sub2(ray3.origin, this.v0);
		const u = f * s.dot(h);
		if (u < 0 || u > 1) {
			return false;
		}
		q.cross(s, e1);
		const v6 = f * ray3.direction.dot(q);
		if (v6 < 0 || u + v6 > 1) {
			return false;
		}
		const t = f * e2.dot(q);
		if (t > EPSILON) {
			if (point5 instanceof Vec3) {
				point5.copy(ray3.direction).mulScalar(t).add(ray3.origin);
			}
			return true;
		}
		return false;
	}
	toString() {
		return `[${this.v0.toString()}, ${this.v1.toString()}, ${this.v2.toString()}]`;
	}
};

var ADDRESS_REPEAT = 0;
var ADDRESS_CLAMP_TO_EDGE = 1;
var ADDRESS_MIRRORED_REPEAT = 2;
var BLENDMODE_ZERO = 0;
var BLENDMODE_ONE = 1;
var BLENDMODE_SRC_COLOR = 2;
var BLENDMODE_ONE_MINUS_SRC_COLOR = 3;
var BLENDMODE_DST_COLOR = 4;
var BLENDMODE_ONE_MINUS_DST_COLOR = 5;
var BLENDMODE_SRC_ALPHA = 6;
var BLENDMODE_SRC_ALPHA_SATURATE = 7;
var BLENDMODE_ONE_MINUS_SRC_ALPHA = 8;
var BLENDMODE_DST_ALPHA = 9;
var BLENDMODE_ONE_MINUS_DST_ALPHA = 10;
var BLENDMODE_CONSTANT = 11;
var BLENDMODE_ONE_MINUS_CONSTANT = 12;
var BLENDEQUATION_ADD = 0;
var BLENDEQUATION_SUBTRACT = 1;
var BLENDEQUATION_REVERSE_SUBTRACT = 2;
var BLENDEQUATION_MIN = 3;
var BLENDEQUATION_MAX = 4;
var BUFFERUSAGE_READ = 1;
var BUFFERUSAGE_WRITE = 2;
var BUFFERUSAGE_COPY_SRC = 4;
var BUFFERUSAGE_COPY_DST = 8;
var BUFFERUSAGE_INDEX = 16;
var BUFFERUSAGE_VERTEX = 32;
var BUFFERUSAGE_UNIFORM = 64;
var BUFFERUSAGE_STORAGE = 128;
var BUFFERUSAGE_INDIRECT = 256;
var BUFFER_STATIC = 0;
var BUFFER_DYNAMIC = 1;
var BUFFER_STREAM = 2;
var BUFFER_GPUDYNAMIC = 3;
var CLEARFLAG_COLOR = 1;
var CLEARFLAG_DEPTH = 2;
var CLEARFLAG_STENCIL = 4;
var CUBEFACE_POSX = 0;
var CUBEFACE_NEGX = 1;
var CUBEFACE_POSY = 2;
var CUBEFACE_NEGY = 3;
var CUBEFACE_POSZ = 4;
var CUBEFACE_NEGZ = 5;
var CULLFACE_NONE = 0;
var CULLFACE_BACK = 1;
var CULLFACE_FRONT = 2;
var CULLFACE_FRONTANDBACK = 3;
var FRONTFACE_CCW = 0;
var FRONTFACE_CW = 1;
var FILTER_NEAREST = 0;
var FILTER_LINEAR = 1;
var FILTER_NEAREST_MIPMAP_NEAREST = 2;
var FILTER_NEAREST_MIPMAP_LINEAR = 3;
var FILTER_LINEAR_MIPMAP_NEAREST = 4;
var FILTER_LINEAR_MIPMAP_LINEAR = 5;
var FUNC_NEVER = 0;
var FUNC_LESS = 1;
var FUNC_EQUAL = 2;
var FUNC_LESSEQUAL = 3;
var FUNC_GREATER = 4;
var FUNC_NOTEQUAL = 5;
var FUNC_GREATEREQUAL = 6;
var FUNC_ALWAYS = 7;
var INDEXFORMAT_UINT8 = 0;
var INDEXFORMAT_UINT16 = 1;
var INDEXFORMAT_UINT32 = 2;
var indexFormatByteSize = [1, 2, 4];
var PIXELFORMAT_A8 = 0;
var PIXELFORMAT_L8 = 1;
var PIXELFORMAT_LA8 = 2;
var PIXELFORMAT_RGB565 = 3;
var PIXELFORMAT_RGBA5551 = 4;
var PIXELFORMAT_RGBA4 = 5;
var PIXELFORMAT_RGB8 = 6;
var PIXELFORMAT_RGBA8 = 7;
var PIXELFORMAT_DXT1 = 8;
var PIXELFORMAT_DXT3 = 9;
var PIXELFORMAT_DXT5 = 10;
var PIXELFORMAT_RGB16F = 11;
var PIXELFORMAT_RGBA16F = 12;
var PIXELFORMAT_RGB32F = 13;
var PIXELFORMAT_RGBA32F = 14;
var PIXELFORMAT_R32F = 15;
var PIXELFORMAT_DEPTH = 16;
var PIXELFORMAT_DEPTHSTENCIL = 17;
var PIXELFORMAT_111110F = 18;
var PIXELFORMAT_SRGB8 = 19;
var PIXELFORMAT_SRGBA8 = 20;
var PIXELFORMAT_ETC1 = 21;
var PIXELFORMAT_ETC2_RGB = 22;
var PIXELFORMAT_ETC2_RGBA = 23;
var PIXELFORMAT_PVRTC_2BPP_RGB_1 = 24;
var PIXELFORMAT_PVRTC_2BPP_RGBA_1 = 25;
var PIXELFORMAT_PVRTC_4BPP_RGB_1 = 26;
var PIXELFORMAT_PVRTC_4BPP_RGBA_1 = 27;
var PIXELFORMAT_ASTC_4x4 = 28;
var PIXELFORMAT_ATC_RGB = 29;
var PIXELFORMAT_ATC_RGBA = 30;
var PIXELFORMAT_BGRA8 = 31;
var PIXELFORMAT_R8I = 32;
var PIXELFORMAT_R8U = 33;
var PIXELFORMAT_R16I = 34;
var PIXELFORMAT_R16U = 35;
var PIXELFORMAT_R32I = 36;
var PIXELFORMAT_R32U = 37;
var PIXELFORMAT_RG8I = 38;
var PIXELFORMAT_RG8U = 39;
var PIXELFORMAT_RG16I = 40;
var PIXELFORMAT_RG16U = 41;
var PIXELFORMAT_RG32I = 42;
var PIXELFORMAT_RG32U = 43;
var PIXELFORMAT_RGBA8I = 44;
var PIXELFORMAT_RGBA8U = 45;
var PIXELFORMAT_RGBA16I = 46;
var PIXELFORMAT_RGBA16U = 47;
var PIXELFORMAT_RGBA32I = 48;
var PIXELFORMAT_RGBA32U = 49;
var PIXELFORMAT_R16F = 50;
var PIXELFORMAT_RG16F = 51;
var PIXELFORMAT_R8 = 52;
var PIXELFORMAT_RG8 = 53;
var PIXELFORMAT_DXT1_SRGB = 54;
var PIXELFORMAT_DXT3_SRGBA = 55;
var PIXELFORMAT_DXT5_SRGBA = 56;
var PIXELFORMAT_ETC2_SRGB = 61;
var PIXELFORMAT_ETC2_SRGBA = 62;
var PIXELFORMAT_ASTC_4x4_SRGB = 63;
var PIXELFORMAT_SBGRA8 = 64;
var PIXELFORMAT_BC6F = 65;
var PIXELFORMAT_BC6UF = 66;
var PIXELFORMAT_BC7 = 67;
var PIXELFORMAT_BC7_SRGBA = 68;
var PIXELFORMAT_DEPTH16 = 69;
var PIXELFORMAT_RG32F = 70;
var PIXELFORMAT_RGB9E5 = 71;
var PIXELFORMAT_RG8S = 72;
var PIXELFORMAT_RGBA8S = 73;
var PIXELFORMAT_RGB10A2 = 74;
var PIXELFORMAT_RGB10A2U = 75;
var pixelFormatInfo = /* @__PURE__ */ new Map([
	// float formats
	[PIXELFORMAT_A8, { name: "A8", size: 1, ldr: true }],
	[PIXELFORMAT_R8, { name: "R8", size: 1, ldr: true }],
	[PIXELFORMAT_L8, { name: "L8", size: 1, ldr: true }],
	[PIXELFORMAT_LA8, { name: "LA8", size: 2, ldr: true }],
	[PIXELFORMAT_RG8, { name: "RG8", size: 2, ldr: true }],
	[PIXELFORMAT_RGB565, { name: "RGB565", size: 2, ldr: true }],
	[PIXELFORMAT_RGBA5551, { name: "RGBA5551", size: 2, ldr: true }],
	[PIXELFORMAT_RGBA4, { name: "RGBA4", size: 2, ldr: true }],
	[PIXELFORMAT_RGB8, { name: "RGB8", size: 4, ldr: true }],
	[PIXELFORMAT_RGBA8, { name: "RGBA8", size: 4, ldr: true, srgbFormat: PIXELFORMAT_SRGBA8 }],
	[PIXELFORMAT_R16F, { name: "R16F", size: 2 }],
	[PIXELFORMAT_RG16F, { name: "RG16F", size: 4 }],
	[PIXELFORMAT_RGB16F, { name: "RGB16F", size: 8 }],
	[PIXELFORMAT_RGBA16F, { name: "RGBA16F", size: 8 }],
	[PIXELFORMAT_RGB32F, { name: "RGB32F", size: 16 }],
	[PIXELFORMAT_RGBA32F, { name: "RGBA32F", size: 16 }],
	[PIXELFORMAT_R32F, { name: "R32F", size: 4 }],
	[PIXELFORMAT_RG32F, { name: "RG32F", size: 8 }],
	[PIXELFORMAT_RGB9E5, { name: "RGB9E5", size: 4 }],
	[PIXELFORMAT_RG8S, { name: "RG8S", size: 2 }],
	[PIXELFORMAT_RGBA8S, { name: "RGBA8S", size: 4 }],
	[PIXELFORMAT_RGB10A2, { name: "RGB10A2", size: 4 }],
	[PIXELFORMAT_RGB10A2U, { name: "RGB10A2U", size: 4, isUint: true }],
	[PIXELFORMAT_DEPTH, { name: "DEPTH", size: 4 }],
	[PIXELFORMAT_DEPTH16, { name: "DEPTH16", size: 2 }],
	[PIXELFORMAT_DEPTHSTENCIL, { name: "DEPTHSTENCIL", size: 4 }],
	[PIXELFORMAT_111110F, { name: "111110F", size: 4 }],
	[PIXELFORMAT_SRGB8, { name: "SRGB8", size: 4, ldr: true, srgb: true }],
	[PIXELFORMAT_SRGBA8, { name: "SRGBA8", size: 4, ldr: true, srgb: true }],
	[PIXELFORMAT_BGRA8, { name: "BGRA8", size: 4, ldr: true }],
	[PIXELFORMAT_SBGRA8, { name: "SBGRA8", size: 4, ldr: true, srgb: true }],
	// compressed formats
	[PIXELFORMAT_DXT1, { name: "DXT1", blockSize: 8, ldr: true, srgbFormat: PIXELFORMAT_DXT1_SRGB }],
	[PIXELFORMAT_DXT3, { name: "DXT3", blockSize: 16, ldr: true, srgbFormat: PIXELFORMAT_DXT3_SRGBA }],
	[PIXELFORMAT_DXT5, { name: "DXT5", blockSize: 16, ldr: true, srgbFormat: PIXELFORMAT_DXT5_SRGBA }],
	[PIXELFORMAT_ETC1, { name: "ETC1", blockSize: 8, ldr: true }],
	[PIXELFORMAT_ETC2_RGB, { name: "ETC2_RGB", blockSize: 8, ldr: true, srgbFormat: PIXELFORMAT_ETC2_SRGB }],
	[PIXELFORMAT_ETC2_RGBA, { name: "ETC2_RGBA", blockSize: 16, ldr: true, srgbFormat: PIXELFORMAT_ETC2_SRGBA }],
	[PIXELFORMAT_PVRTC_2BPP_RGB_1, { name: "PVRTC_2BPP_RGB_1", ldr: true, blockSize: 8 }],
	[PIXELFORMAT_PVRTC_2BPP_RGBA_1, { name: "PVRTC_2BPP_RGBA_1", ldr: true, blockSize: 8 }],
	[PIXELFORMAT_PVRTC_4BPP_RGB_1, { name: "PVRTC_4BPP_RGB_1", ldr: true, blockSize: 8 }],
	[PIXELFORMAT_PVRTC_4BPP_RGBA_1, { name: "PVRTC_4BPP_RGBA_1", ldr: true, blockSize: 8 }],
	[PIXELFORMAT_ASTC_4x4, { name: "ASTC_4x4", blockSize: 16, ldr: true, srgbFormat: PIXELFORMAT_ASTC_4x4_SRGB }],
	[PIXELFORMAT_ATC_RGB, { name: "ATC_RGB", blockSize: 8, ldr: true }],
	[PIXELFORMAT_ATC_RGBA, { name: "ATC_RGBA", blockSize: 16, ldr: true }],
	[PIXELFORMAT_BC6F, { name: "BC6H_RGBF", blockSize: 16 }],
	[PIXELFORMAT_BC6UF, { name: "BC6H_RGBUF", blockSize: 16 }],
	[PIXELFORMAT_BC7, { name: "BC7_RGBA", blockSize: 16, ldr: true, srgbFormat: PIXELFORMAT_BC7_SRGBA }],
	// compressed sRGB formats
	[PIXELFORMAT_DXT1_SRGB, { name: "DXT1_SRGB", blockSize: 8, ldr: true, srgb: true }],
	[PIXELFORMAT_DXT3_SRGBA, { name: "DXT3_SRGBA", blockSize: 16, ldr: true, srgb: true }],
	[PIXELFORMAT_DXT5_SRGBA, { name: "DXT5_SRGBA", blockSize: 16, ldr: true, srgb: true }],
	[PIXELFORMAT_ETC2_SRGB, { name: "ETC2_SRGB", blockSize: 8, ldr: true, srgb: true }],
	[PIXELFORMAT_ETC2_SRGBA, { name: "ETC2_SRGBA", blockSize: 16, ldr: true, srgb: true }],
	[PIXELFORMAT_ASTC_4x4_SRGB, { name: "ASTC_4x4_SRGB", blockSize: 16, ldr: true, srgb: true }],
	[PIXELFORMAT_BC7_SRGBA, { name: "BC7_SRGBA", blockSize: 16, ldr: true, srgb: true }],
	// signed integer formats
	[PIXELFORMAT_R8I, { name: "R8I", size: 1, isInt: true }],
	[PIXELFORMAT_R16I, { name: "R16I", size: 2, isInt: true }],
	[PIXELFORMAT_R32I, { name: "R32I", size: 4, isInt: true }],
	[PIXELFORMAT_RG8I, { name: "RG8I", size: 2, isInt: true }],
	[PIXELFORMAT_RG16I, { name: "RG16I", size: 4, isInt: true }],
	[PIXELFORMAT_RG32I, { name: "RG32I", size: 8, isInt: true }],
	[PIXELFORMAT_RGBA8I, { name: "RGBA8I", size: 4, isInt: true }],
	[PIXELFORMAT_RGBA16I, { name: "RGBA16I", size: 8, isInt: true }],
	[PIXELFORMAT_RGBA32I, { name: "RGBA32I", size: 16, isInt: true }],
	// unsigned integer formats
	[PIXELFORMAT_R8U, { name: "R8U", size: 1, isUint: true }],
	[PIXELFORMAT_R16U, { name: "R16U", size: 2, isUint: true }],
	[PIXELFORMAT_R32U, { name: "R32U", size: 4, isUint: true }],
	[PIXELFORMAT_RG8U, { name: "RG8U", size: 2, isUint: true }],
	[PIXELFORMAT_RG16U, { name: "RG16U", size: 4, isUint: true }],
	[PIXELFORMAT_RG32U, { name: "RG32U", size: 8, isUint: true }],
	[PIXELFORMAT_RGBA8U, { name: "RGBA8U", size: 4, isUint: true }],
	[PIXELFORMAT_RGBA16U, { name: "RGBA16U", size: 8, isUint: true }],
	[PIXELFORMAT_RGBA32U, { name: "RGBA32U", size: 16, isUint: true }]
]);
var isCompressedPixelFormat = (format) => {
	return pixelFormatInfo.get(format)?.blockSize !== void 0;
};
var isSrgbPixelFormat = (format) => {
	return pixelFormatInfo.get(format)?.srgb === true;
};
var isIntegerPixelFormat = (format) => {
	const info = pixelFormatInfo.get(format);
	return info?.isInt === true || info?.isUint === true;
};
var GLSL_FLOAT = { sampler: "sampler2D", returnType: "vec4" };
var GLSL_UINT = { sampler: "usampler2D", returnType: "uvec4" };
var GLSL_INT = { sampler: "isampler2D", returnType: "ivec4" };
var WGSL_FLOAT = { textureType: "texture_2d<f32>", returnType: "vec4f" };
var WGSL_UINT = { textureType: "texture_2d<u32>", returnType: "vec4u" };
var WGSL_INT = { textureType: "texture_2d<i32>", returnType: "vec4i" };
var getGlslShaderType = (format) => {
	const info = pixelFormatInfo.get(format);
	if (info?.isUint) return GLSL_UINT;
	if (info?.isInt) return GLSL_INT;
	return GLSL_FLOAT;
};
var getWgslShaderType = (format) => {
	const info = pixelFormatInfo.get(format);
	if (info?.isUint) return WGSL_UINT;
	if (info?.isInt) return WGSL_INT;
	return WGSL_FLOAT;
};
var pixelFormatLinearToGamma = (format) => {
	return pixelFormatInfo.get(format)?.srgbFormat || format;
};
var pixelFormatGammaToLinear = (format) => {
	for (const [key, value] of pixelFormatInfo) {
		if (value.srgbFormat === format) {
			return key;
		}
	}
	return format;
};
var requiresManualGamma = (format) => {
	const info = pixelFormatInfo.get(format);
	return !!(info?.ldr && !info?.srgb);
};
var getPixelFormatArrayType = (format) => {
	switch (format) {
		case PIXELFORMAT_R32F:
		case PIXELFORMAT_RG32F:
		case PIXELFORMAT_RGB32F:
		case PIXELFORMAT_RGBA32F:
			return Float32Array;
		case PIXELFORMAT_R32I:
		case PIXELFORMAT_RG32I:
		case PIXELFORMAT_RGBA32I:
			return Int32Array;
		case PIXELFORMAT_R32U:
		case PIXELFORMAT_RG32U:
		case PIXELFORMAT_RGBA32U:
		case PIXELFORMAT_RGB9E5:
		case PIXELFORMAT_RGB10A2:
		case PIXELFORMAT_RGB10A2U:
			return Uint32Array;
		case PIXELFORMAT_R16I:
		case PIXELFORMAT_RG16I:
		case PIXELFORMAT_RGBA16I:
			return Int16Array;
		case PIXELFORMAT_R16U:
		case PIXELFORMAT_RG16U:
		case PIXELFORMAT_RGBA16U:
		case PIXELFORMAT_RGB565:
		case PIXELFORMAT_RGBA5551:
		case PIXELFORMAT_RGBA4:
		case PIXELFORMAT_R16F:
		case PIXELFORMAT_RG16F:
		case PIXELFORMAT_RGB16F:
		case PIXELFORMAT_RGBA16F:
			return Uint16Array;
		case PIXELFORMAT_R8I:
		case PIXELFORMAT_RG8I:
		case PIXELFORMAT_RGBA8I:
		case PIXELFORMAT_RG8S:
		case PIXELFORMAT_RGBA8S:
			return Int8Array;
		default:
			return Uint8Array;
	}
};
var PRIMITIVE_POINTS = 0;
var PRIMITIVE_LINES = 1;
var PRIMITIVE_LINELOOP = 2;
var PRIMITIVE_LINESTRIP = 3;
var PRIMITIVE_TRIANGLES = 4;
var PRIMITIVE_TRISTRIP = 5;
var PRIMITIVE_TRIFAN = 6;
var SEMANTIC_POSITION = "POSITION";
var SEMANTIC_NORMAL = "NORMAL";
var SEMANTIC_TANGENT = "TANGENT";
var SEMANTIC_BLENDWEIGHT = "BLENDWEIGHT";
var SEMANTIC_BLENDINDICES = "BLENDINDICES";
var SEMANTIC_COLOR = "COLOR";
var SEMANTIC_TEXCOORD = "TEXCOORD";
var SEMANTIC_TEXCOORD0 = "TEXCOORD0";
var SEMANTIC_TEXCOORD1 = "TEXCOORD1";
var SEMANTIC_TEXCOORD2 = "TEXCOORD2";
var SEMANTIC_TEXCOORD3 = "TEXCOORD3";
var SEMANTIC_TEXCOORD4 = "TEXCOORD4";
var SEMANTIC_TEXCOORD5 = "TEXCOORD5";
var SEMANTIC_TEXCOORD6 = "TEXCOORD6";
var SEMANTIC_TEXCOORD7 = "TEXCOORD7";
var SEMANTIC_ATTR0 = "ATTR0";
var SEMANTIC_ATTR1 = "ATTR1";
var SEMANTIC_ATTR2 = "ATTR2";
var SEMANTIC_ATTR3 = "ATTR3";
var SEMANTIC_ATTR4 = "ATTR4";
var SEMANTIC_ATTR5 = "ATTR5";
var SEMANTIC_ATTR6 = "ATTR6";
var SEMANTIC_ATTR7 = "ATTR7";
var SEMANTIC_ATTR8 = "ATTR8";
var SEMANTIC_ATTR9 = "ATTR9";
var SEMANTIC_ATTR10 = "ATTR10";
var SEMANTIC_ATTR11 = "ATTR11";
var SEMANTIC_ATTR12 = "ATTR12";
var SEMANTIC_ATTR13 = "ATTR13";
var SEMANTIC_ATTR14 = "ATTR14";
var SEMANTIC_ATTR15 = "ATTR15";
var SHADERTAG_MATERIAL = 1;
var STENCILOP_KEEP = 0;
var STENCILOP_ZERO = 1;
var STENCILOP_REPLACE = 2;
var STENCILOP_INCREMENT = 3;
var STENCILOP_INCREMENTWRAP = 4;
var STENCILOP_DECREMENT = 5;
var STENCILOP_DECREMENTWRAP = 6;
var STENCILOP_INVERT = 7;
var TEXTURELOCK_NONE = 0;
var TEXTURELOCK_READ = 1;
var TEXTURELOCK_WRITE = 2;
var TEXTURETYPE_DEFAULT = "default";
var TEXTURETYPE_RGBM = "rgbm";
var TEXTURETYPE_RGBE = "rgbe";
var TEXTURETYPE_RGBP = "rgbp";
var TEXTURETYPE_SWIZZLEGGGR = "swizzleGGGR";
var TEXHINT_NONE = 0;
var TEXHINT_SHADOWMAP = 1;
var TEXHINT_ASSET = 2;
var TEXHINT_LIGHTMAP = 3;
var TEXTUREDIMENSION_1D = "1d";
var TEXTUREDIMENSION_2D = "2d";
var TEXTUREDIMENSION_2D_ARRAY = "2d-array";
var TEXTUREDIMENSION_CUBE = "cube";
var TEXTUREDIMENSION_CUBE_ARRAY = "cube-array";
var TEXTUREDIMENSION_3D = "3d";
var SAMPLETYPE_FLOAT = 0;
var SAMPLETYPE_UNFILTERABLE_FLOAT = 1;
var SAMPLETYPE_DEPTH = 2;
var SAMPLETYPE_INT = 3;
var SAMPLETYPE_UINT = 4;
var TEXTUREPROJECTION_NONE = "none";
var TEXTUREPROJECTION_CUBE = "cube";
var TEXTUREPROJECTION_EQUIRECT = "equirect";
var TEXTUREPROJECTION_OCTAHEDRAL = "octahedral";
var SHADERLANGUAGE_GLSL = "glsl";
var SHADERLANGUAGE_WGSL = "wgsl";
var TYPE_INT8 = 0;
var TYPE_UINT8 = 1;
var TYPE_INT16 = 2;
var TYPE_UINT16 = 3;
var TYPE_INT32 = 4;
var TYPE_UINT32 = 5;
var TYPE_FLOAT32 = 6;
var TYPE_FLOAT16 = 7;
var UNIFORMTYPE_BOOL = 0;
var UNIFORMTYPE_INT = 1;
var UNIFORMTYPE_FLOAT = 2;
var UNIFORMTYPE_VEC2 = 3;
var UNIFORMTYPE_VEC3 = 4;
var UNIFORMTYPE_VEC4 = 5;
var UNIFORMTYPE_IVEC2 = 6;
var UNIFORMTYPE_IVEC3 = 7;
var UNIFORMTYPE_IVEC4 = 8;
var UNIFORMTYPE_BVEC2 = 9;
var UNIFORMTYPE_BVEC3 = 10;
var UNIFORMTYPE_BVEC4 = 11;
var UNIFORMTYPE_MAT2 = 12;
var UNIFORMTYPE_MAT3 = 13;
var UNIFORMTYPE_MAT4 = 14;
var UNIFORMTYPE_TEXTURE2D = 15;
var UNIFORMTYPE_TEXTURECUBE = 16;
var UNIFORMTYPE_FLOATARRAY = 17;
var UNIFORMTYPE_TEXTURE2D_SHADOW = 18;
var UNIFORMTYPE_TEXTURECUBE_SHADOW = 19;
var UNIFORMTYPE_TEXTURE3D = 20;
var UNIFORMTYPE_VEC2ARRAY = 21;
var UNIFORMTYPE_VEC3ARRAY = 22;
var UNIFORMTYPE_VEC4ARRAY = 23;
var UNIFORMTYPE_MAT4ARRAY = 24;
var UNIFORMTYPE_TEXTURE2D_ARRAY = 25;
var UNIFORMTYPE_UINT = 26;
var UNIFORMTYPE_UVEC2 = 27;
var UNIFORMTYPE_UVEC3 = 28;
var UNIFORMTYPE_UVEC4 = 29;
var UNIFORMTYPE_INTARRAY = 30;
var UNIFORMTYPE_UINTARRAY = 31;
var UNIFORMTYPE_BOOLARRAY = 32;
var UNIFORMTYPE_IVEC2ARRAY = 33;
var UNIFORMTYPE_UVEC2ARRAY = 34;
var UNIFORMTYPE_BVEC2ARRAY = 35;
var UNIFORMTYPE_IVEC3ARRAY = 36;
var UNIFORMTYPE_UVEC3ARRAY = 37;
var UNIFORMTYPE_BVEC3ARRAY = 38;
var UNIFORMTYPE_IVEC4ARRAY = 39;
var UNIFORMTYPE_UVEC4ARRAY = 40;
var UNIFORMTYPE_BVEC4ARRAY = 41;
var UNIFORMTYPE_ITEXTURE2D = 42;
var UNIFORMTYPE_UTEXTURE2D = 43;
var UNIFORMTYPE_ITEXTURECUBE = 44;
var UNIFORMTYPE_UTEXTURECUBE = 45;
var UNIFORMTYPE_ITEXTURE3D = 46;
var UNIFORMTYPE_UTEXTURE3D = 47;
var UNIFORMTYPE_ITEXTURE2D_ARRAY = 48;
var UNIFORMTYPE_UTEXTURE2D_ARRAY = 49;
var uniformTypeToName = [
	// Uniforms
	"bool",
	"int",
	"float",
	"vec2",
	"vec3",
	"vec4",
	"ivec2",
	"ivec3",
	"ivec4",
	"bvec2",
	"bvec3",
	"bvec4",
	"mat2",
	"mat3",
	"mat4",
	"sampler2D",
	"samplerCube",
	"",
	// not directly handled: UNIFORMTYPE_FLOATARRAY
	"sampler2DShadow",
	"samplerCubeShadow",
	"sampler3D",
	"",
	// not directly handled: UNIFORMTYPE_VEC2ARRAY
	"",
	// not directly handled: UNIFORMTYPE_VEC3ARRAY
	"",
	// not directly handled: UNIFORMTYPE_VEC4ARRAY
	"",
	// not directly handled: UNIFORMTYPE_MAT4ARRAY
	"sampler2DArray",
	"uint",
	"uvec2",
	"uvec3",
	"uvec4",
	"",
	// not directly handled: UNIFORMTYPE_INTARRAY
	"",
	// not directly handled: UNIFORMTYPE_UINTARRAY
	"",
	// not directly handled: UNIFORMTYPE_BOOLARRAY
	"",
	// not directly handled: UNIFORMTYPE_IVEC2ARRAY
	"",
	// not directly handled: UNIFORMTYPE_UVEC2ARRAY
	"",
	// not directly handled: UNIFORMTYPE_BVEC2ARRAY
	"",
	// not directly handled: UNIFORMTYPE_IVEC3ARRAY
	"",
	// not directly handled: UNIFORMTYPE_UVEC3ARRAY
	"",
	// not directly handled: UNIFORMTYPE_BVEC3ARRAY
	"",
	// not directly handled: UNIFORMTYPE_IVEC4ARRAY
	"",
	// not directly handled: UNIFORMTYPE_UVEC4ARRAY
	"",
	// not directly handled: UNIFORMTYPE_BVEC4ARRAY
	"isampler2D",
	"usampler2D",
	"isamplerCube",
	"usamplerCube",
	"isampler3D",
	"usampler3D",
	"isampler2DArray",
	"usampler2DArray"
];
var uniformTypeToNameWGSL = [
	// Uniforms
	["bool"],
	// UNIFORMTYPE_BOOL
	["i32"],
	// UNIFORMTYPE_INT
	["f32"],
	// UNIFORMTYPE_FLOAT
	["vec2f", "vec2<f32>"],
	// UNIFORMTYPE_VEC2
	["vec3f", "vec3<f32>"],
	// UNIFORMTYPE_VEC3
	["vec4f", "vec4<f32>"],
	// UNIFORMTYPE_VEC4
	["vec2i", "vec2<i32>"],
	// UNIFORMTYPE_IVEC2
	["vec3i", "vec3<i32>"],
	// UNIFORMTYPE_IVEC3
	["vec4i", "vec4<i32>"],
	// UNIFORMTYPE_IVEC4
	["vec2<bool>"],
	// UNIFORMTYPE_BVEC2
	["vec3<bool>"],
	// UNIFORMTYPE_BVEC3
	["vec4<bool>"],
	// UNIFORMTYPE_BVEC4
	["mat2x2f", "mat2x2<f32>"],
	// UNIFORMTYPE_MAT2
	["mat3x3f", "mat3x3<f32>"],
	// UNIFORMTYPE_MAT3
	["mat4x4f", "mat4x4<f32>"],
	// UNIFORMTYPE_MAT4
	["texture_2d<f32>"],
	// UNIFORMTYPE_TEXTURE2D
	["texture_cube<f32>"],
	// UNIFORMTYPE_TEXTURECUBE
	["array<f32>"],
	// UNIFORMTYPE_FLOATARRAY
	["texture_depth_2d"],
	// UNIFORMTYPE_TEXTURE2D_SHADOW
	["texture_depth_cube"],
	// UNIFORMTYPE_TEXTURECUBE_SHADOW
	["texture_3d<f32>"],
	// UNIFORMTYPE_TEXTURE3D
	["array<vec2<f32>>"],
	// UNIFORMTYPE_VEC2ARRAY
	["array<vec3<f32>>"],
	// UNIFORMTYPE_VEC3ARRAY
	["array<vec4<f32>>"],
	// UNIFORMTYPE_VEC4ARRAY
	["array<mat4x4<f32>>"],
	// UNIFORMTYPE_MAT4ARRAY
	["texture_2d_array<f32>"],
	// UNIFORMTYPE_TEXTURE2D_ARRAY
	// Unsigned integer uniforms
	["u32"],
	// UNIFORMTYPE_UINT
	["vec2u", "vec2<u32>"],
	// UNIFORMTYPE_UVEC2
	["vec3u", "vec3<u32>"],
	// UNIFORMTYPE_UVEC3
	["vec4u", "vec4<u32>"],
	// UNIFORMTYPE_UVEC4
	// Integer array uniforms
	["array<i32>"],
	// UNIFORMTYPE_INTARRAY
	["array<u32>"],
	// UNIFORMTYPE_UINTARRAY
	["array<bool>"],
	// UNIFORMTYPE_BOOLARRAY
	["array<vec2i>", "array<vec2<i32>>"],
	// UNIFORMTYPE_IVEC2ARRAY
	["array<vec2u>", "array<vec2<u32>>"],
	// UNIFORMTYPE_UVEC2ARRAY
	["array<vec2b>", "array<vec2<bool>>"],
	// UNIFORMTYPE_BVEC2ARRAY
	["array<vec3i>", "array<vec3<i32>>"],
	// UNIFORMTYPE_IVEC3ARRAY
	["array<vec3u>", "array<vec3<u32>>"],
	// UNIFORMTYPE_UVEC3ARRAY
	["array<vec3b>", "array<vec3<bool>>"],
	// UNIFORMTYPE_BVEC3ARRAY
	["array<vec4i>", "array<vec4<i32>>"],
	// UNIFORMTYPE_IVEC4ARRAY
	["array<vec4u>", "array<vec4<u32>>"],
	// UNIFORMTYPE_UVEC4ARRAY
	["array<vec4b>", "array<vec4<bool>>"],
	// UNIFORMTYPE_BVEC4ARRAY
	// Integer texture types
	["texture_2d<i32>"],
	// UNIFORMTYPE_ITEXTURE2D
	["texture_2d<u32>"],
	// UNIFORMTYPE_UTEXTURE2D
	["texture_cube<i32>"],
	// UNIFORMTYPE_ITEXTURECUBE
	["texture_cube<u32>"],
	// UNIFORMTYPE_UTEXTURECUBE
	["texture_3d<i32>"],
	// UNIFORMTYPE_ITEXTURE3D
	["texture_3d<u32>"],
	// UNIFORMTYPE_UTEXTURE3D
	["texture_2d_array<i32>"],
	// UNIFORMTYPE_ITEXTURE2D_ARRAY
	["texture_2d_array<u32>"]
	// UNIFORMTYPE_UTEXTURE2D_ARRAY
];
var uniformTypeToNameMapWGSL = /* @__PURE__ */ new Map();
uniformTypeToNameWGSL.forEach((names, index) => {
	names.forEach((name) => uniformTypeToNameMapWGSL.set(name, index));
});
var uniformTypeToStorage = new Uint8Array([
	TYPE_INT32,
	// UNIFORMTYPE_BOOL
	TYPE_INT32,
	// UNIFORMTYPE_INT
	TYPE_FLOAT32,
	// UNIFORMTYPE_FLOAT
	TYPE_FLOAT32,
	// UNIFORMTYPE_VEC2
	TYPE_FLOAT32,
	// UNIFORMTYPE_VEC3
	TYPE_FLOAT32,
	// UNIFORMTYPE_VEC4
	TYPE_INT32,
	// UNIFORMTYPE_IVEC2
	TYPE_INT32,
	// UNIFORMTYPE_IVEC3
	TYPE_INT32,
	// UNIFORMTYPE_IVEC4
	TYPE_INT32,
	// UNIFORMTYPE_BVEC2
	TYPE_INT32,
	// UNIFORMTYPE_BVEC3
	TYPE_INT32,
	// UNIFORMTYPE_BVEC4
	TYPE_FLOAT32,
	// UNIFORMTYPE_MAT2
	TYPE_FLOAT32,
	// UNIFORMTYPE_MAT3
	TYPE_FLOAT32,
	// UNIFORMTYPE_MAT4
	TYPE_INT32,
	// UNIFORMTYPE_TEXTURE2D
	TYPE_INT32,
	// UNIFORMTYPE_TEXTURECUBE
	TYPE_FLOAT32,
	// UNIFORMTYPE_FLOATARRAY
	TYPE_INT32,
	// UNIFORMTYPE_TEXTURE2D_SHADOW
	TYPE_INT32,
	// UNIFORMTYPE_TEXTURECUBE_SHADOW
	TYPE_INT32,
	// UNIFORMTYPE_TEXTURE3D
	TYPE_FLOAT32,
	// UNIFORMTYPE_VEC2ARRAY
	TYPE_FLOAT32,
	// UNIFORMTYPE_VEC3ARRAY
	TYPE_FLOAT32,
	// UNIFORMTYPE_VEC4ARRAY
	TYPE_FLOAT32,
	// UNIFORMTYPE_MAT4ARRAY
	TYPE_INT32,
	// UNIFORMTYPE_TEXTURE2D_ARRAY
	TYPE_UINT32,
	// UNIFORMTYPE_UINT
	TYPE_UINT32,
	// UNIFORMTYPE_UVEC2
	TYPE_UINT32,
	// UNIFORMTYPE_UVEC3
	TYPE_UINT32,
	// UNIFORMTYPE_UVEC4
	TYPE_INT32,
	// UNIFORMTYPE_INTARRAY
	TYPE_UINT32,
	// UNIFORMTYPE_UINTARRAY
	TYPE_INT32,
	// UNIFORMTYPE_BOOLARRAY
	TYPE_INT32,
	// UNIFORMTYPE_IVEC2ARRAY
	TYPE_UINT32,
	// UNIFORMTYPE_UVEC2ARRAY
	TYPE_INT32,
	// UNIFORMTYPE_BVEC2ARRAY
	TYPE_INT32,
	// UNIFORMTYPE_IVEC3ARRAY
	TYPE_UINT32,
	// UNIFORMTYPE_UVEC3ARRAY
	TYPE_INT32,
	// UNIFORMTYPE_BVEC3ARRAY
	TYPE_INT32,
	// UNIFORMTYPE_IVEC4ARRAY
	TYPE_UINT32,
	// UNIFORMTYPE_UVEC4ARRAY
	TYPE_INT32,
	// UNIFORMTYPE_BVEC4ARRAY
	TYPE_INT32,
	// UNIFORMTYPE_ITEXTURE2D
	TYPE_UINT32,
	// UNIFORMTYPE_UTEXTURE2D
	TYPE_INT32,
	// UNIFORMTYPE_ITEXTURECUBE
	TYPE_UINT32,
	// UNIFORMTYPE_UTEXTURECUBE
	TYPE_INT32,
	// UNIFORMTYPE_ITEXTURE3D
	TYPE_UINT32,
	// UNIFORMTYPE_UTEXTURE3D
	TYPE_INT32,
	// UNIFORMTYPE_ITEXTURE2D_ARRAY
	TYPE_UINT32
	// UNIFORMTYPE_UTEXTURE2D_ARRAY
]);
var DEVICETYPE_WEBGL2 = "webgl2";
var DEVICETYPE_WEBGPU = "webgpu";
var DEVICETYPE_WEBGPU_BARE = "webgpu:bare";
var DEVICETYPE_NULL = "null";
var SHADERSTAGE_VERTEX = 1;
var SHADERSTAGE_FRAGMENT = 2;
var SHADERSTAGE_COMPUTE = 4;
var DISPLAYFORMAT_LDR = "ldr";
var DISPLAYFORMAT_LDR_SRGB = "ldr_srgb";
var DISPLAYFORMAT_HDR = "hdr";
var TEXPROPERTY_MIN_FILTER = 1;
var TEXPROPERTY_MAG_FILTER = 2;
var TEXPROPERTY_ADDRESS_U = 4;
var TEXPROPERTY_ADDRESS_V = 8;
var TEXPROPERTY_ADDRESS_W = 16;
var TEXPROPERTY_COMPARE_ON_READ = 32;
var TEXPROPERTY_COMPARE_FUNC = 64;
var TEXPROPERTY_ANISOTROPY = 128;
var TEXPROPERTY_ALL = 255;
var BINDGROUP_VIEW = 0;
var BINDGROUP_MESH = 1;
var BINDGROUP_MESH_UB = 2;
var bindGroupNames = ["view", "mesh", "mesh_ub"];
var UNIFORM_BUFFER_DEFAULT_SLOT_NAME = "default";
var UNUSED_UNIFORM_NAME = "_unused_float_uniform";
var typedArrayTypes = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Uint16Array];
var typedArrayTypesByteSize = [1, 1, 2, 2, 4, 4, 4, 2];
var vertexTypesNames = ["INT8", "UINT8", "INT16", "UINT16", "INT32", "UINT32", "FLOAT32", "FLOAT16"];
var typedArrayToType = {
	"Int8Array": TYPE_INT8,
	"Uint8Array": TYPE_UINT8,
	"Int16Array": TYPE_INT16,
	"Uint16Array": TYPE_UINT16,
	"Int32Array": TYPE_INT32,
	"Uint32Array": TYPE_UINT32,
	"Float32Array": TYPE_FLOAT32
};
var typedArrayIndexFormats = [Uint8Array, Uint16Array, Uint32Array];
var typedArrayIndexFormatsByteSize = [1, 2, 4];
var primitiveGlslToWgslTypeMap = /* @__PURE__ */ new Map([
	// floating-point
	["float", "f32"],
	["vec2", "vec2f"],
	["vec3", "vec3f"],
	["vec4", "vec4f"],
	// signed integer
	["int", "i32"],
	["ivec2", "vec2i"],
	["ivec3", "vec3i"],
	["ivec4", "vec4i"],
	// unsigned integer
	["uint", "u32"],
	["uvec2", "vec2u"],
	["uvec3", "vec3u"],
	["uvec4", "vec4u"]
]);
var semanticToLocation = {};
semanticToLocation[SEMANTIC_POSITION] = 0;
semanticToLocation[SEMANTIC_NORMAL] = 1;
semanticToLocation[SEMANTIC_BLENDWEIGHT] = 2;
semanticToLocation[SEMANTIC_BLENDINDICES] = 3;
semanticToLocation[SEMANTIC_COLOR] = 4;
semanticToLocation[SEMANTIC_TEXCOORD0] = 5;
semanticToLocation[SEMANTIC_TEXCOORD1] = 6;
semanticToLocation[SEMANTIC_TEXCOORD2] = 7;
semanticToLocation[SEMANTIC_TEXCOORD3] = 8;
semanticToLocation[SEMANTIC_TEXCOORD4] = 9;
semanticToLocation[SEMANTIC_TEXCOORD5] = 10;
semanticToLocation[SEMANTIC_TEXCOORD6] = 11;
semanticToLocation[SEMANTIC_TEXCOORD7] = 12;
semanticToLocation[SEMANTIC_TANGENT] = 13;
semanticToLocation[SEMANTIC_ATTR0] = 0;
semanticToLocation[SEMANTIC_ATTR1] = 1;
semanticToLocation[SEMANTIC_ATTR2] = 2;
semanticToLocation[SEMANTIC_ATTR3] = 3;
semanticToLocation[SEMANTIC_ATTR4] = 4;
semanticToLocation[SEMANTIC_ATTR5] = 5;
semanticToLocation[SEMANTIC_ATTR6] = 6;
semanticToLocation[SEMANTIC_ATTR7] = 7;
semanticToLocation[SEMANTIC_ATTR8] = 8;
semanticToLocation[SEMANTIC_ATTR9] = 9;
semanticToLocation[SEMANTIC_ATTR10] = 10;
semanticToLocation[SEMANTIC_ATTR11] = 11;
semanticToLocation[SEMANTIC_ATTR12] = 12;
semanticToLocation[SEMANTIC_ATTR13] = 13;
semanticToLocation[SEMANTIC_ATTR14] = 14;
semanticToLocation[SEMANTIC_ATTR15] = 15;

var warnInsecureContext = (feature) => {
	if (typeof window === "undefined") return;
	if (window.isSecureContext !== false) return;
};

var id = 0;
var BindBaseFormat = class {
	slot = -1;
	scopeId = null;
	constructor(name, visibility) {
		this.name = name;
		this.visibility = visibility;
	}
};
var BindUniformBufferFormat = class extends BindBaseFormat {
};
var BindStorageBufferFormat = class extends BindBaseFormat {
	format = "";
	constructor(name, visibility, readOnly = false) {
		super(name, visibility);
		this.readOnly = readOnly;
	}
};
var BindTextureFormat = class extends BindBaseFormat {
	constructor(name, visibility, textureDimension = TEXTUREDIMENSION_2D, sampleType = SAMPLETYPE_FLOAT, hasSampler = true, samplerName = null) {
		super(name, visibility);
		this.textureDimension = textureDimension;
		this.sampleType = sampleType;
		this.hasSampler = hasSampler;
		this.samplerName = samplerName ?? `${name}_sampler`;
	}
};
var BindStorageTextureFormat = class extends BindBaseFormat {
	constructor(name, format = PIXELFORMAT_RGBA8, textureDimension = TEXTUREDIMENSION_2D, write = true, read = false) {
		super(name, SHADERSTAGE_COMPUTE);
		this.format = format;
		this.textureDimension = textureDimension;
		this.write = write;
		this.read = read;
	}
};
var BindGroupFormat = class {
	uniformBufferFormats = [];
	textureFormats = [];
	storageTextureFormats = [];
	storageBufferFormats = [];
	constructor(graphicsDevice, formats) {
		this.id = id++;
		let slot = 0;
		formats.forEach((format) => {
			format.slot = slot++;
			if (format instanceof BindTextureFormat && format.hasSampler) {
				slot++;
			}
			if (format instanceof BindUniformBufferFormat) {
				this.uniformBufferFormats.push(format);
			} else if (format instanceof BindTextureFormat) {
				this.textureFormats.push(format);
			} else if (format instanceof BindStorageTextureFormat) {
				this.storageTextureFormats.push(format);
			} else if (format instanceof BindStorageBufferFormat) {
				this.storageBufferFormats.push(format);
			} else {
			}
		});
		this.device = graphicsDevice;
		const scope = graphicsDevice.scope;
		this.bufferFormatsMap = /* @__PURE__ */ new Map();
		this.uniformBufferFormats.forEach((bf, i2) => this.bufferFormatsMap.set(bf.name, i2));
		this.textureFormatsMap = /* @__PURE__ */ new Map();
		this.textureFormats.forEach((tf, i2) => {
			this.textureFormatsMap.set(tf.name, i2);
			tf.scopeId = scope.resolve(tf.name);
		});
		this.storageTextureFormatsMap = /* @__PURE__ */ new Map();
		this.storageTextureFormats.forEach((tf, i2) => {
			this.storageTextureFormatsMap.set(tf.name, i2);
			tf.scopeId = scope.resolve(tf.name);
		});
		this.storageBufferFormatsMap = /* @__PURE__ */ new Map();
		this.storageBufferFormats.forEach((bf, i2) => {
			this.storageBufferFormatsMap.set(bf.name, i2);
			bf.scopeId = scope.resolve(bf.name);
		});
		this.impl = graphicsDevice.createBindGroupFormatImpl(this);
	}
	destroy() {
		this.impl.destroy();
	}
	getTexture(name) {
		const index = this.textureFormatsMap.get(name);
		if (index !== void 0) {
			return this.textureFormats[index];
		}
		return null;
	}
	getStorageTexture(name) {
		const index = this.storageTextureFormatsMap.get(name);
		if (index !== void 0) {
			return this.storageTextureFormats[index];
		}
		return null;
	}
	loseContext() {
	}
};

var DeviceCache = class {
	_cache = /* @__PURE__ */ new Map();
	get(device, onCreate) {
		if (!this._cache.has(device)) {
			this._cache.set(device, onCreate());
			device.on("destroy", () => {
				this.remove(device);
			});
			device.on("devicelost", () => {
				this._cache.get(device)?.loseContext?.(device);
			});
		}
		return this._cache.get(device);
	}
	remove(device) {
		this._cache.get(device)?.destroy?.(device);
		this._cache.delete(device);
	}
};

var TextureUtils = class _TextureUtils {
	static calcLevelDimension(dimension, mipLevel) {
		return Math.max(dimension >> mipLevel, 1);
	}
	static calcMipLevelsCount(width, height, depth = 1) {
		return 1 + Math.floor(Math.log2(Math.max(width, height, depth)));
	}
	static calcLevelGpuSize(width, height, depth, format) {
		const formatInfo = pixelFormatInfo.get(format);
		const pixelSize = pixelFormatInfo.get(format)?.size ?? 0;
		if (pixelSize > 0) {
			return width * height * depth * pixelSize;
		}
		const blockSize = formatInfo.blockSize ?? 0;
		let blockWidth = Math.floor((width + 3) / 4);
		const blockHeight = Math.floor((height + 3) / 4);
		const blockDepth = Math.floor((depth + 3) / 4);
		if (format === PIXELFORMAT_PVRTC_2BPP_RGB_1 || format === PIXELFORMAT_PVRTC_2BPP_RGBA_1) {
			blockWidth = Math.max(Math.floor(blockWidth / 2), 1);
		}
		return blockWidth * blockHeight * blockDepth * blockSize;
	}
	static calcGpuSize(width, height, depth, format, mipmaps, cubemap) {
		let result = 0;
		while (1) {
			result += _TextureUtils.calcLevelGpuSize(width, height, depth, format);
			if (!mipmaps || width === 1 && height === 1 && depth === 1) {
				break;
			}
			width = Math.max(width >> 1, 1);
			height = Math.max(height >> 1, 1);
			depth = Math.max(depth >> 1, 1);
		}
		return result * (cubemap ? 6 : 1);
	}
	static calcTextureSize(count, result, widthMultiple = 1) {
		let width = Math.ceil(Math.sqrt(count));
		if (widthMultiple > 1) {
			width = math.roundUp(width, widthMultiple);
		}
		return result.set(width, Math.ceil(count / width));
	}
};

var StringIds = class {
	map = /* @__PURE__ */ new Map();
	id = 0;
	get(name) {
		let value = this.map.get(name);
		if (value === void 0) {
			value = this.id++;
			this.map.set(name, value);
		}
		return value;
	}
};

var stringIds = new StringIds();
var TextureView = class {
	texture;
	baseMipLevel;
	mipLevelCount;
	baseArrayLayer;
	arrayLayerCount;
	key;
	constructor(texture, baseMipLevel = 0, mipLevelCount = 1, baseArrayLayer = 0, arrayLayerCount = 1) {
		this.texture = texture;
		this.baseMipLevel = baseMipLevel;
		this.mipLevelCount = mipLevelCount;
		this.baseArrayLayer = baseArrayLayer;
		this.arrayLayerCount = arrayLayerCount;
		this.key = stringIds.get(`${baseMipLevel}:${mipLevelCount}:${baseArrayLayer}:${arrayLayerCount}`);
	}
};

var id2 = 0;
var Texture = class _Texture {
	static createDataTexture2D(graphicsDevice, name, width, height, format, levels) {
		return new _Texture(graphicsDevice, {
			name,
			width,
			height,
			format,
			mipmaps: false,
			minFilter: FILTER_NEAREST,
			magFilter: FILTER_NEAREST,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			levels
		});
	}
	name;
	_gpuSize = 0;
	releaseSourceAfterUpload = false;
	id = id2++;
	_invalid = false;
	_lockedLevel = -1;
	_lockedMode = TEXTURELOCK_NONE;
	renderVersionDirty = 0;
	uploadVersion = 0;
	_storage = false;
	_numLevels = 0;
	_numLevelsRequested;
	constructor(graphicsDevice, options2 = {}) {
		this.device = graphicsDevice;
		this.name = options2.name ?? "";
		this._width = Math.floor(options2.width ?? 4);
		this._height = Math.floor(options2.height ?? 4);
		const format = options2.format ?? PIXELFORMAT_RGBA8;
		this._format = options2.srgb ? pixelFormatLinearToGamma(format) : format;
		this._compressed = isCompressedPixelFormat(this._format);
		this._integerFormat = isIntegerPixelFormat(this._format);
		if (this._integerFormat) {
			options2.minFilter = FILTER_NEAREST;
			options2.magFilter = FILTER_NEAREST;
		}
		this._volume = options2.volume ?? false;
		this._depth = Math.floor(options2.depth ?? 1);
		this._arrayLength = Math.floor(options2.arrayLength ?? 0);
		this._storage = options2.storage ?? false;
		this._cubemap = options2.cubemap ?? false;
		this._flipY = options2.flipY ?? false;
		this._premultiplyAlpha = options2.premultiplyAlpha ?? false;
		this._mipmaps = options2.mipmaps ?? true;
		this._numLevelsRequested = options2.numLevels;
		if (options2.numLevels !== void 0) {
			this._numLevels = options2.numLevels;
		}
		this._updateNumLevels();
		this._minFilter = options2.minFilter ?? FILTER_LINEAR_MIPMAP_LINEAR;
		this._magFilter = options2.magFilter ?? FILTER_LINEAR;
		this._anisotropy = options2.anisotropy ?? 1;
		this._addressU = options2.addressU ?? ADDRESS_REPEAT;
		this._addressV = options2.addressV ?? ADDRESS_REPEAT;
		this._addressW = options2.addressW ?? ADDRESS_REPEAT;
		this._compareOnRead = options2.compareOnRead ?? false;
		this._compareFunc = options2.compareFunc ?? FUNC_LESS;
		this._type = options2.type ?? TEXTURETYPE_DEFAULT;
		this.projection = TEXTUREPROJECTION_NONE;
		if (this._cubemap) {
			this.projection = TEXTUREPROJECTION_CUBE;
		} else if (options2.projection && options2.projection !== TEXTUREPROJECTION_CUBE) {
			this.projection = options2.projection;
		}
		this._levels = options2.levels;
		const upload = !!options2.levels;
		if (!this._levels) {
			this._clearLevels();
		}
		this.recreateImpl(upload);
	}
	destroy() {
		const device = this.device;
		if (device) {
			device.onTextureDestroyed(this);
			this.impl.destroy(device);
			this.adjustVramSizeTracking(device._vram, -this._gpuSize);
			if (this.releaseSourceAfterUpload) {
				this.releaseImageSources();
			}
			this._levels = null;
			this.device = null;
		}
	}
	releaseImageSources() {
		this.releaseSourceAfterUpload = false;
		if (typeof ImageBitmap === "undefined" || !this._levels) {
			return;
		}
		for (let i2 = 0; i2 < this._levels.length; i2++) {
			const level = this._levels[i2];
			if (level instanceof ImageBitmap) {
				level.close();
				this._levels[i2] = null;
			} else if (Array.isArray(level)) {
				for (let j = 0; j < level.length; j++) {
					if (level[j] instanceof ImageBitmap) {
						level[j].close();
						level[j] = null;
					}
				}
			}
		}
	}
	setReleaseSourceAfterUpload() {
		this.releaseSourceAfterUpload = true;
		if (!this._needsUpload && !this._needsMipmapsUpload) {
			this.releaseImageSources();
		}
	}
	recreateImpl(upload = true) {
		const { device } = this;
		this.impl?.destroy(device);
		this.impl = null;
		this.impl = device.createTextureImpl(this);
		this.dirtyAll();
		if (upload) {
			this.upload();
		}
	}
	_clearLevels() {
		this._levels = this._cubemap ? [[null, null, null, null, null, null]] : [null];
	}
	resize(width, height, depth = 1) {
		if (this.width !== width || this.height !== height || this.depth !== depth) {
			const device = this.device;
			this.adjustVramSizeTracking(device._vram, -this._gpuSize);
			this._gpuSize = 0;
			this.impl.destroy(device);
			this._clearLevels();
			this._width = Math.floor(width);
			this._height = Math.floor(height);
			this._depth = Math.floor(depth);
			this._updateNumLevels();
			this.impl = device.createTextureImpl(this);
			this.dirtyAll();
		}
	}
	loseContext() {
		this.impl.loseContext();
		this.dirtyAll();
	}
	adjustVramSizeTracking(vram, size) {
		vram.tex += size;
	}
	propertyChanged(flag) {
		this.impl.propertyChanged(flag);
		this.renderVersionDirty = this.device.renderVersion;
	}
	_updateNumLevels() {
		const maxLevels = this.mipmaps ? TextureUtils.calcMipLevelsCount(this.width, this.height) : 1;
		const requestedLevels = this._numLevelsRequested;
		if (requestedLevels !== void 0 && requestedLevels > maxLevels) {
		}
		this._numLevels = Math.min(requestedLevels ?? maxLevels, maxLevels);
		this._mipmaps = this._numLevels > 1;
	}
	get lockedMode() {
		return this._lockedMode;
	}
	set minFilter(v6) {
		if (this._minFilter !== v6) {
			if (isIntegerPixelFormat(this._format)) {
			} else {
				this._minFilter = v6;
				this.propertyChanged(TEXPROPERTY_MIN_FILTER);
			}
		}
	}
	get minFilter() {
		return this._minFilter;
	}
	set magFilter(v6) {
		if (this._magFilter !== v6) {
			if (isIntegerPixelFormat(this._format)) {
			} else {
				this._magFilter = v6;
				this.propertyChanged(TEXPROPERTY_MAG_FILTER);
			}
		}
	}
	get magFilter() {
		return this._magFilter;
	}
	set addressU(v6) {
		if (this._addressU !== v6) {
			this._addressU = v6;
			this.propertyChanged(TEXPROPERTY_ADDRESS_U);
		}
	}
	get addressU() {
		return this._addressU;
	}
	set addressV(v6) {
		if (this._addressV !== v6) {
			this._addressV = v6;
			this.propertyChanged(TEXPROPERTY_ADDRESS_V);
		}
	}
	get addressV() {
		return this._addressV;
	}
	set addressW(addressW) {
		if (!this._volume) {
			return;
		}
		if (addressW !== this._addressW) {
			this._addressW = addressW;
			this.propertyChanged(TEXPROPERTY_ADDRESS_W);
		}
	}
	get addressW() {
		return this._addressW;
	}
	set compareOnRead(v6) {
		if (this._compareOnRead !== v6) {
			this._compareOnRead = v6;
			this.propertyChanged(TEXPROPERTY_COMPARE_ON_READ);
		}
	}
	get compareOnRead() {
		return this._compareOnRead;
	}
	set compareFunc(v6) {
		if (this._compareFunc !== v6) {
			this._compareFunc = v6;
			this.propertyChanged(TEXPROPERTY_COMPARE_FUNC);
		}
	}
	get compareFunc() {
		return this._compareFunc;
	}
	set anisotropy(v6) {
		if (this._anisotropy !== v6) {
			this._anisotropy = v6;
			this.propertyChanged(TEXPROPERTY_ANISOTROPY);
		}
	}
	get anisotropy() {
		return this._anisotropy;
	}
	set mipmaps(v6) {
		if (this._mipmaps !== v6) {
			if (isIntegerPixelFormat(this._format)) {
			} else {
				const oldMipmaps = this._mipmaps;
				const oldNumLevels = this._numLevels;
				this._mipmaps = v6;
				this._updateNumLevels();
				if ((this.array || this.device.isWebGPU) && this._numLevels !== oldNumLevels) {
					this.recreateImpl();
				} else if (this._mipmaps !== oldMipmaps) {
					this.propertyChanged(TEXPROPERTY_MIN_FILTER);
					if (this._mipmaps) {
						this._needsMipmapsUpload = true;
						this.device?.texturesToUpload?.add(this);
					} else {
						this._needsMipmapsUpload = false;
					}
				}
			}
		}
	}
	get mipmaps() {
		return this._mipmaps;
	}
	get numLevels() {
		return this._numLevels;
	}
	get storage() {
		return this._storage;
	}
	get width() {
		return this._width;
	}
	get height() {
		return this._height;
	}
	get depth() {
		return this._depth;
	}
	get format() {
		return this._format;
	}
	get cubemap() {
		return this._cubemap;
	}
	get gpuSize() {
		const mips = this.pot && this._mipmaps && !(this._compressed && this._levels.length === 1);
		return TextureUtils.calcGpuSize(this._width, this._height, this._depth, this._format, mips, this._cubemap);
	}
	get array() {
		return this._arrayLength > 0;
	}
	get arrayLength() {
		return this._arrayLength;
	}
	get volume() {
		return this._volume;
	}
	set type(value) {
		if (this._type !== value) {
			this._type = value;
			this.device._shadersDirty = true;
		}
	}
	get type() {
		return this._type;
	}
	set rgbm(value) {
		this.type = value ? TEXTURETYPE_RGBM : TEXTURETYPE_DEFAULT;
	}
	get rgbm() {
		return this.type === TEXTURETYPE_RGBM;
	}
	set swizzleGGGR(value) {
		this.type = value ? TEXTURETYPE_SWIZZLEGGGR : TEXTURETYPE_DEFAULT;
	}
	get swizzleGGGR() {
		return this.type === TEXTURETYPE_SWIZZLEGGGR;
	}
	get _glTexture() {
		return this.impl._glTexture;
	}
	set srgb(value) {
		const currentSrgb = isSrgbPixelFormat(this.format);
		if (value !== currentSrgb) {
			if (value) {
				const srgbFormat = pixelFormatLinearToGamma(this.format);
				if (this._format !== srgbFormat) {
					this._format = srgbFormat;
					this.recreateImpl();
					this.device._shadersDirty = true;
				}
			} else {
				const linearFormat = pixelFormatGammaToLinear(this.format);
				if (this._format !== linearFormat) {
					this._format = linearFormat;
					this.recreateImpl();
					this.device._shadersDirty = true;
				}
			}
		}
	}
	get srgb() {
		return isSrgbPixelFormat(this.format);
	}
	set flipY(flipY) {
		if (this._flipY !== flipY) {
			this._flipY = flipY;
			this.markForUpload();
		}
	}
	get flipY() {
		return this._flipY;
	}
	set premultiplyAlpha(premultiplyAlpha) {
		if (this._premultiplyAlpha !== premultiplyAlpha) {
			this._premultiplyAlpha = premultiplyAlpha;
			this.markForUpload();
		}
	}
	get premultiplyAlpha() {
		return this._premultiplyAlpha;
	}
	get pot() {
		return math.powerOfTwo(this._width) && math.powerOfTwo(this._height);
	}
	// get the texture's encoding type
	get encoding() {
		switch (this.type) {
			case TEXTURETYPE_RGBM:
				return "rgbm";
			case TEXTURETYPE_RGBE:
				return "rgbe";
			case TEXTURETYPE_RGBP:
				return "rgbp";
		}
		return requiresManualGamma(this.format) ? "srgb" : "linear";
	}
	// Force a full resubmission of the texture to the GPU (used on a context restore event)
	dirtyAll() {
		this._levelsUpdated = this._cubemap ? [[true, true, true, true, true, true]] : [true];
		this.markForUpload();
		this._needsMipmapsUpload = this._mipmaps;
		this._mipmapsUploaded = false;
		this.propertyChanged(TEXPROPERTY_ALL);
	}
	lock(options2 = {}) {
		options2.level ?? (options2.level = 0);
		options2.face ?? (options2.face = 0);
		options2.mode ?? (options2.mode = TEXTURELOCK_WRITE);
		this._lockedMode = options2.mode;
		this._lockedLevel = options2.level;
		const levels = this.cubemap ? this._levels[options2.face] : this._levels;
		if (!levels[options2.level]) {
			const width = Math.max(1, this._width >> options2.level);
			const height = Math.max(1, this._height >> options2.level);
			const depth = Math.max(1, this._depth >> options2.level);
			const data2 = new ArrayBuffer(TextureUtils.calcLevelGpuSize(width, height, depth, this._format));
			levels[options2.level] = new (getPixelFormatArrayType(this._format))(data2);
		}
		return levels[options2.level];
	}
	setSource(source, mipLevel = 0) {
		if (this.device._isHTMLElementInterface(source)) {
			if (!this.device.supportsHtmlTextures) {
				return;
			}
			if (this._cubemap || this._volume) {
				return;
			}
		}
		let invalid = false;
		let width, height;
		if (this._cubemap) {
			if (source[0]) {
				width = source[0].width || 0;
				height = source[0].height || 0;
				for (let i2 = 0; i2 < 6; i2++) {
					const face = source[i2];
					if (!face || // face is missing
					face.width !== width || // face is different width
					face.height !== height || // face is different height
					!this.device._isBrowserInterface(face)) {
						invalid = true;
						break;
					}
				}
			} else {
				invalid = true;
			}
			if (!invalid) {
				for (let i2 = 0; i2 < 6; i2++) {
					if (this._levels[mipLevel][i2] !== source[i2]) {
						this._levelsUpdated[mipLevel][i2] = true;
					}
				}
			}
		} else {
			if (!this.device._isBrowserInterface(source)) {
				invalid = true;
			}
			if (!invalid) {
				if (source !== this._levels[mipLevel]) {
					this._levelsUpdated[mipLevel] = true;
				}
				if (source instanceof HTMLVideoElement) {
					width = source.videoWidth;
					height = source.videoHeight;
				} else if (this.device._isHTMLElementInterface(source)) {
					const rect = source.getBoundingClientRect();
					width = Math.floor(rect.width) || 1;
					height = Math.floor(rect.height) || 1;
				} else {
					width = source.width;
					height = source.height;
				}
			}
		}
		if (invalid) {
			this._width = 4;
			this._height = 4;
			if (this._cubemap) {
				for (let i2 = 0; i2 < 6; i2++) {
					this._levels[mipLevel][i2] = null;
					this._levelsUpdated[mipLevel][i2] = true;
				}
			} else {
				this._levels[mipLevel] = null;
				this._levelsUpdated[mipLevel] = true;
			}
		} else {
			if (mipLevel === 0) {
				this._width = width;
				this._height = height;
			}
			this._levels[mipLevel] = source;
		}
		if (this._invalid !== invalid || !invalid) {
			this._invalid = invalid;
			this.upload();
		}
	}
	getSource(mipLevel = 0) {
		return this._levels[mipLevel];
	}
	unlock() {
		if (this._lockedMode === TEXTURELOCK_NONE) {
		}
		if (this._lockedMode === TEXTURELOCK_WRITE) {
			this.upload();
		}
		this._lockedLevel = -1;
		this._lockedMode = TEXTURELOCK_NONE;
	}
	markForUpload() {
		this._needsUpload = true;
		if (this.device) {
			this.uploadVersion = this.device.renderVersion;
		}
		this.device?.texturesToUpload?.add(this);
	}
	upload() {
		this.markForUpload();
		this._needsMipmapsUpload = this._mipmaps;
		this.impl.uploadImmediate?.(this.device, this);
	}
	read(x3, y2, width, height, options2 = {}) {
		return this.impl.read?.(x3, y2, width, height, options2);
	}
	write(x3, y2, width, height, data2) {
		return this.impl.write?.(x3, y2, width, height, data2);
	}
	_validateCopy(source, options2) {
		return true;
	}
	copy(source, options2 = {}) {
		if (!this._validateCopy(source, options2)) {
			return false;
		}
		return this.impl.copy?.(source, options2) ?? true;
	}
	getView(baseMipLevel = 0, mipLevelCount = 1, baseArrayLayer = 0, arrayLayerCount = 1) {
		return new TextureView(this, baseMipLevel, mipLevelCount, baseArrayLayer, arrayLayerCount);
	}
};

var textureData = {
	white: [255, 255, 255, 255],
	gray: [128, 128, 128, 255],
	black: [0, 0, 0, 255],
	normal: [128, 128, 255, 255],
	pink: [255, 128, 255, 255]
};
var BuiltInTextures = class {
	map = /* @__PURE__ */ new Map();
	destroy() {
		this.map.forEach((texture) => {
			texture.destroy();
		});
	}
};
var deviceCache = new DeviceCache();
var getBuiltInTexture = (device, name) => {
	const cache = deviceCache.get(device, () => {
		return new BuiltInTextures();
	});
	if (!cache.map.has(name)) {
		const texture = new Texture(device, {
			name: `built-in-texture-${name}`,
			width: 1,
			height: 1,
			format: PIXELFORMAT_RGBA8
		});
		const pixels = texture.lock();
		const data2 = textureData[name];
		pixels.set(data2);
		texture.unlock();
		cache.map.set(name, texture);
	}
	return cache.map.get(name);
};

var id3 = 0;
var DynamicBindGroup = class {
	bindGroup;
	offsets = [];
};
var BindGroup = class {
	renderVersionUpdated = -1;
	uniformBuffers;
	uniformBufferOffsets = [];
	_uniformBufferContainers = [];
	_textureImpls = [];
	_storageTextureImpls = [];
	constructor(graphicsDevice, format, defaultUniformBuffer) {
		this.id = id3++;
		this.device = graphicsDevice;
		this.format = format;
		this.dirty = true;
		this.impl = graphicsDevice.createBindGroupImpl(this);
		this.textures = [];
		this.storageTextures = [];
		this.storageBuffers = [];
		this.uniformBuffers = [];
		this.defaultUniformBuffer = defaultUniformBuffer;
		if (defaultUniformBuffer) {
			this.setUniformBuffer(UNIFORM_BUFFER_DEFAULT_SLOT_NAME, defaultUniformBuffer);
		}
	}
	destroy() {
		this.impl.destroy();
		this.impl = null;
		this.format = null;
		this.defaultUniformBuffer = null;
	}
	setUniformBuffer(name, uniformBuffer) {
		const index = this.format.bufferFormatsMap.get(name);
		if (this.uniformBuffers[index] !== uniformBuffer) {
			this.uniformBuffers[index] = uniformBuffer;
			this.dirty = true;
		}
	}
	setStorageBuffer(name, storageBuffer) {
		const index = this.format.storageBufferFormatsMap.get(name);
		if (this.storageBuffers[index] !== storageBuffer) {
			this.storageBuffers[index] = storageBuffer;
			this.dirty = true;
		}
	}
	setTexture(name, value) {
		const index = this.format.textureFormatsMap.get(name);
		const texture = value instanceof TextureView ? value.texture : value;
		if (this.textures[index] !== value) {
			this.textures[index] = value;
			this.dirty = true;
		} else if (this.renderVersionUpdated < texture.renderVersionDirty) {
			this.dirty = true;
		} else if (this._textureImpls[index] !== texture.impl) {
			this.dirty = true;
		}
		this._textureImpls[index] = texture.impl;
	}
	setStorageTexture(name, value) {
		const index = this.format.storageTextureFormatsMap.get(name);
		const texture = value instanceof TextureView ? value.texture : value;
		if (this.storageTextures[index] !== value) {
			this.storageTextures[index] = value;
			this.dirty = true;
		} else if (this.renderVersionUpdated < texture.renderVersionDirty) {
			this.dirty = true;
		} else if (this._storageTextureImpls[index] !== texture.impl) {
			this.dirty = true;
		}
		this._storageTextureImpls[index] = texture.impl;
	}
	updateUniformBuffers() {
		for (let i2 = 0; i2 < this.uniformBuffers.length; i2++) {
			this.uniformBuffers[i2].update();
		}
	}
	update() {
		const { textureFormats, storageTextureFormats, storageBufferFormats } = this.format;
		for (let i2 = 0; i2 < textureFormats.length; i2++) {
			const textureFormat = textureFormats[i2];
			let value = textureFormat.scopeId.value;
			if (!value) {
				if (textureFormat.name === "uSceneDepthMap") {
					value = getBuiltInTexture(this.device, "white");
				}
				if (textureFormat.name === "uSceneColorMap") {
					value = getBuiltInTexture(this.device, "pink");
				}
				if (!value) {
					value = getBuiltInTexture(this.device, "pink");
				}
			}
			this.setTexture(textureFormat.name, value);
		}
		for (let i2 = 0; i2 < storageTextureFormats.length; i2++) {
			const storageTextureFormat = storageTextureFormats[i2];
			const value = storageTextureFormat.scopeId.value;
			this.setStorageTexture(storageTextureFormat.name, value);
		}
		for (let i2 = 0; i2 < storageBufferFormats.length; i2++) {
			const storageBufferFormat = storageBufferFormats[i2];
			const value = storageBufferFormat.scopeId.value;
			this.setStorageBuffer(storageBufferFormat.name, value);
		}
		this.uniformBufferOffsets.length = this.uniformBuffers.length;
		for (let i2 = 0; i2 < this.uniformBuffers.length; i2++) {
			const uniformBuffer = this.uniformBuffers[i2];
			this.uniformBufferOffsets[i2] = uniformBuffer.offset;
			if (!uniformBuffer.persistent) {
				const container = uniformBuffer.allocation.gpuBuffer;
				if (this._uniformBufferContainers[i2] !== container) {
					this._uniformBufferContainers[i2] = container;
					this.dirty = true;
				}
			}
		}
		if (this.dirty) {
			this.dirty = false;
			this.renderVersionUpdated = this.device.renderVersion;
			this.impl.update(this);
		}
	}
};

var BitPacking = {
	set(storage, value, shift, mask = 1) {
		const data2 = storage & ~(mask << shift);
		return data2 | value << shift;
	},
	get(storage, shift, mask = 1) {
		return storage >> shift & mask;
	},
	all(storage, shift, mask = 1) {
		const shifted = mask << shift;
		return (storage & shifted) === shifted;
	},
	any(storage, shift, mask = 1) {
		return (storage & mask << shift) !== 0;
	}
};

var opMask = 7;
var factorMask = 15;
var colorOpShift = 0;
var colorSrcFactorShift = 3;
var colorDstFactorShift = 7;
var alphaOpShift = 11;
var alphaSrcFactorShift = 14;
var alphaDstFactorShift = 18;
var redWriteShift = 22;
var greenWriteShift = 23;
var blueWriteShift = 24;
var alphaWriteShift = 25;
var blendShift = 26;
var allWriteMasks = 15;
var allWriteShift = redWriteShift;
var BlendState = class _BlendState {
	target0 = 0;
	constructor(blend = false, colorOp = BLENDEQUATION_ADD, colorSrcFactor = BLENDMODE_ONE, colorDstFactor = BLENDMODE_ZERO, alphaOp, alphaSrcFactor, alphaDstFactor, redWrite = true, greenWrite = true, blueWrite = true, alphaWrite = true) {
		this.setColorBlend(colorOp, colorSrcFactor, colorDstFactor);
		this.setAlphaBlend(alphaOp ?? colorOp, alphaSrcFactor ?? colorSrcFactor, alphaDstFactor ?? colorDstFactor);
		this.setColorWrite(redWrite, greenWrite, blueWrite, alphaWrite);
		this.blend = blend;
	}
	set blend(value) {
		this.target0 = BitPacking.set(this.target0, value ? 1 : 0, blendShift);
	}
	get blend() {
		return BitPacking.all(this.target0, blendShift);
	}
	setColorBlend(op, srcFactor, dstFactor) {
		this.target0 = BitPacking.set(this.target0, op, colorOpShift, opMask);
		this.target0 = BitPacking.set(this.target0, srcFactor, colorSrcFactorShift, factorMask);
		this.target0 = BitPacking.set(this.target0, dstFactor, colorDstFactorShift, factorMask);
	}
	setAlphaBlend(op, srcFactor, dstFactor) {
		this.target0 = BitPacking.set(this.target0, op, alphaOpShift, opMask);
		this.target0 = BitPacking.set(this.target0, srcFactor, alphaSrcFactorShift, factorMask);
		this.target0 = BitPacking.set(this.target0, dstFactor, alphaDstFactorShift, factorMask);
	}
	setColorWrite(redWrite, greenWrite, blueWrite, alphaWrite) {
		this.redWrite = redWrite;
		this.greenWrite = greenWrite;
		this.blueWrite = blueWrite;
		this.alphaWrite = alphaWrite;
	}
	get colorOp() {
		return BitPacking.get(this.target0, colorOpShift, opMask);
	}
	get colorSrcFactor() {
		return BitPacking.get(this.target0, colorSrcFactorShift, factorMask);
	}
	get colorDstFactor() {
		return BitPacking.get(this.target0, colorDstFactorShift, factorMask);
	}
	get alphaOp() {
		return BitPacking.get(this.target0, alphaOpShift, opMask);
	}
	get alphaSrcFactor() {
		return BitPacking.get(this.target0, alphaSrcFactorShift, factorMask);
	}
	get alphaDstFactor() {
		return BitPacking.get(this.target0, alphaDstFactorShift, factorMask);
	}
	set redWrite(value) {
		this.target0 = BitPacking.set(this.target0, value ? 1 : 0, redWriteShift);
	}
	get redWrite() {
		return BitPacking.all(this.target0, redWriteShift);
	}
	set greenWrite(value) {
		this.target0 = BitPacking.set(this.target0, value ? 1 : 0, greenWriteShift);
	}
	get greenWrite() {
		return BitPacking.all(this.target0, greenWriteShift);
	}
	set blueWrite(value) {
		this.target0 = BitPacking.set(this.target0, value ? 1 : 0, blueWriteShift);
	}
	get blueWrite() {
		return BitPacking.all(this.target0, blueWriteShift);
	}
	set alphaWrite(value) {
		this.target0 = BitPacking.set(this.target0, value ? 1 : 0, alphaWriteShift);
	}
	get alphaWrite() {
		return BitPacking.all(this.target0, alphaWriteShift);
	}
	get allWrite() {
		return BitPacking.get(this.target0, allWriteShift, allWriteMasks);
	}
	copy(rhs) {
		this.target0 = rhs.target0;
		return this;
	}
	clone() {
		const clone = new this.constructor();
		return clone.copy(this);
	}
	get key() {
		return this.target0;
	}
	equals(rhs) {
		return this.target0 === rhs.target0;
	}
	static NOBLEND = Object.freeze(new _BlendState());
	static get DEFAULT() {
		return _BlendState.NOBLEND;
	}
	static NOWRITE = Object.freeze(new _BlendState(void 0, void 0, void 0, void 0, void 0, void 0, void 0, false, false, false, false));
	static ALPHABLEND = Object.freeze(new _BlendState(true, BLENDEQUATION_ADD, BLENDMODE_SRC_ALPHA, BLENDMODE_ONE_MINUS_SRC_ALPHA));
	static ADDBLEND = Object.freeze(new _BlendState(true, BLENDEQUATION_ADD, BLENDMODE_ONE, BLENDMODE_ONE));
};

var stringIds2 = new StringIds();
var funcMask = 7;
var funcShift = 0;
var writeShift = 3;
var DepthState = class _DepthState {
	data = 0;
	_depthBias = 0;
	_depthBiasSlope = 0;
	key = 0;
	constructor(func = FUNC_LESSEQUAL, write = true) {
		this.func = func;
		this.write = write;
	}
	set test(value) {
		this.func = value ? FUNC_LESSEQUAL : FUNC_ALWAYS;
		this.updateKey();
	}
	get test() {
		return this.func !== FUNC_ALWAYS;
	}
	set write(value) {
		this.data = BitPacking.set(this.data, value ? 1 : 0, writeShift);
		this.updateKey();
	}
	get write() {
		return BitPacking.all(this.data, writeShift);
	}
	set func(value) {
		this.data = BitPacking.set(this.data, value, funcShift, funcMask);
		this.updateKey();
	}
	get func() {
		return BitPacking.get(this.data, funcShift, funcMask);
	}
	set depthBias(value) {
		this._depthBias = value;
		this.updateKey();
	}
	get depthBias() {
		return this._depthBias;
	}
	set depthBiasSlope(value) {
		this._depthBiasSlope = value;
		this.updateKey();
	}
	get depthBiasSlope() {
		return this._depthBiasSlope;
	}
	copy(rhs) {
		this.data = rhs.data;
		this._depthBias = rhs._depthBias;
		this._depthBiasSlope = rhs._depthBiasSlope;
		this.key = rhs.key;
		return this;
	}
	clone() {
		const clone = new this.constructor();
		return clone.copy(this);
	}
	updateKey() {
		const { data: data2, _depthBias, _depthBiasSlope } = this;
		const key = `${data2}-${_depthBias}-${_depthBiasSlope}`;
		this.key = stringIds2.get(key);
	}
	equals(rhs) {
		return this.key === rhs.key;
	}
	static DEFAULT = Object.freeze(new _DepthState());
	static NODEPTH = Object.freeze(new _DepthState(FUNC_ALWAYS, false));
	static WRITEDEPTH = Object.freeze(new _DepthState(FUNC_ALWAYS, true));
};

var id4 = 0;
var IndexBuffer = class {
	constructor(graphicsDevice, format, numIndices, usage = BUFFER_STATIC, initialData, options2) {
		this.device = graphicsDevice;
		this.format = format;
		this.numIndices = numIndices;
		this.usage = usage;
		this.id = id4++;
		this.impl = graphicsDevice.createIndexBufferImpl(this, options2);
		const bytesPerIndex = typedArrayIndexFormatsByteSize[format];
		this.bytesPerIndex = bytesPerIndex;
		this.numBytes = this.numIndices * bytesPerIndex;
		if (initialData) {
			this.setData(initialData);
		} else {
			this.storage = new ArrayBuffer(this.numBytes);
		}
		this.adjustVramSizeTracking(graphicsDevice._vram, this.numBytes);
		this.device.buffers.add(this);
	}
	destroy() {
		const device = this.device;
		device.buffers.delete(this);
		if (this.device.indexBuffer === this) {
			this.device.indexBuffer = null;
		}
		if (this.impl.initialized) {
			this.impl.destroy(device);
			this.adjustVramSizeTracking(device._vram, -this.storage.byteLength);
		}
	}
	adjustVramSizeTracking(vram, size) {
		vram.ib += size;
	}
	loseContext() {
		this.impl.loseContext();
	}
	restoreContext() {
		this.unlock();
	}
	getFormat() {
		return this.format;
	}
	getNumIndices() {
		return this.numIndices;
	}
	lock() {
		return this.storage;
	}
	unlock() {
		this.impl.unlock(this);
	}
	setData(data2) {
		if (data2.byteLength !== this.numBytes) {
			return false;
		}
		this.storage = data2;
		this.unlock();
		return true;
	}
	_lockTypedArray() {
		const lock = this.lock();
		const indices = this.format === INDEXFORMAT_UINT32 ? new Uint32Array(lock) : this.format === INDEXFORMAT_UINT16 ? new Uint16Array(lock) : new Uint8Array(lock);
		return indices;
	}
	writeData(data2, count) {
		const indices = this._lockTypedArray();
		if (data2.length > count) {
			if (ArrayBuffer.isView(data2)) {
				data2 = data2.subarray(0, count);
				indices.set(data2);
			} else {
				for (let i2 = 0; i2 < count; i2++) {
					indices[i2] = data2[i2];
				}
			}
		} else {
			indices.set(data2);
		}
		this.unlock();
	}
	readData(data2) {
		const indices = this._lockTypedArray();
		const count = this.numIndices;
		if (ArrayBuffer.isView(data2)) {
			data2.set(indices);
		} else {
			data2.length = 0;
			for (let i2 = 0; i2 < count; i2++) {
				data2[i2] = indices[i2];
			}
		}
		return count;
	}
};

var Version = class {
	globalId = 0;
	revision = 0;
	equals(other) {
		return this.globalId === other.globalId && this.revision === other.revision;
	}
	copy(other) {
		this.globalId = other.globalId;
		this.revision = other.revision;
	}
	reset() {
		this.globalId = 0;
		this.revision = 0;
	}
};

var idCounter = 0;
var VersionedObject = class {
	constructor() {
		idCounter++;
		this.version = new Version();
		this.version.globalId = idCounter;
	}
	increment() {
		this.version.revision++;
	}
};

var ScopeId = class {
	constructor(name) {
		this.name = name;
		this.value = null;
		this.versionObject = new VersionedObject();
	}
	// Don't stringify ScopeId to JSON by JSON.stringify, as this stores 'value'
	// which is not needed. This is used when stringifying a uniform buffer format, which
	// internally stores the scope.
	toJSON(key) {
		return void 0;
	}
	setValue(value) {
		this.value = value;
		this.versionObject.increment();
	}
	getValue() {
		return this.value;
	}
};

var ScopeSpace = class {
	constructor(name) {
		this.name = name;
		this.variables = /* @__PURE__ */ new Map();
	}
	resolve(name) {
		if (!this.variables.has(name)) {
			this.variables.set(name, new ScopeId(name));
		}
		return this.variables.get(name);
	}
	removeValue(value) {
		for (const uniform of this.variables.values()) {
			if (uniform.value === value) {
				uniform.value = null;
			}
		}
	}
};

var id5 = 0;
var VertexBuffer = class {
	usage = BUFFER_STATIC;
	constructor(graphicsDevice, format, numVertices, options2) {
		this.usage = options2?.usage ?? BUFFER_STATIC;
		this.device = graphicsDevice;
		this.format = format;
		this.numVertices = numVertices;
		this.id = id5++;
		this.impl = graphicsDevice.createVertexBufferImpl(this, format, options2);
		this.numBytes = format.verticesByteSize ? format.verticesByteSize : format.size * numVertices;
		this.adjustVramSizeTracking(graphicsDevice._vram, this.numBytes);
		const initialData = options2?.data;
		if (initialData) {
			this.setData(initialData);
		} else {
			this.storage = new ArrayBuffer(this.numBytes);
		}
		this.device.buffers.add(this);
	}
	destroy() {
		const device = this.device;
		device.buffers.delete(this);
		if (this.impl.initialized) {
			this.impl.destroy(device);
			this.adjustVramSizeTracking(device._vram, -this.storage.byteLength);
		}
	}
	adjustVramSizeTracking(vram, size) {
		vram.vb += size;
	}
	loseContext() {
		this.impl.loseContext();
	}
	restoreContext() {
		this.unlock();
	}
	getFormat() {
		return this.format;
	}
	getUsage() {
		return this.usage;
	}
	getNumVertices() {
		return this.numVertices;
	}
	lock() {
		return this.storage;
	}
	unlock() {
		this.impl.unlock(this);
	}
	setData(data2) {
		if (data2.byteLength !== this.numBytes) {
			return false;
		}
		this.storage = data2;
		this.unlock();
		return true;
	}
};

function hashCode(str) {
	if (str === null || str === void 0) {
		return 0;
	}
	let hash = 0;
	for (let i2 = 0, len = str.length; i2 < len; i2++) {
		hash = (hash << 5) - hash + str.charCodeAt(i2);
		hash |= 0;
	}
	return hash;
}
function hash32Fnv1a(array3) {
	const prime = 16777619;
	let hash = 2166136261;
	for (let i2 = 0; i2 < array3.length; i2++) {
		hash ^= array3[i2];
		hash *= prime;
	}
	return hash >>> 0;
}

var stringIds3 = new StringIds();
var webgpuValidElementSizes = [2, 4, 8, 12, 16];
var deviceCache2 = new DeviceCache();
var VertexFormat = class _VertexFormat {
	constructor(graphicsDevice, description, vertexCount) {
		this.device = graphicsDevice;
		this._elements = [];
		this.hasUv0 = false;
		this.hasUv1 = false;
		this.hasColor = false;
		this.hasTangents = false;
		this.verticesByteSize = 0;
		this.vertexCount = vertexCount;
		this.interleaved = vertexCount === void 0;
		this.instancing = false;
		this.size = description.reduce((total, desc) => {
			return total + Math.ceil(desc.components * typedArrayTypesByteSize[desc.type] / 4) * 4;
		}, 0);
		let offset3 = 0, elementSize;
		for (let i2 = 0, len = description.length; i2 < len; i2++) {
			const elementDesc = description[i2];
			elementSize = elementDesc.components * typedArrayTypesByteSize[elementDesc.type];
			if (vertexCount) {
				offset3 = math.roundUp(offset3, elementSize);
			}
			const asInt = elementDesc.asInt ?? false;
			const normalize = asInt ? false : elementDesc.normalize ?? false;
			const element = {
				name: elementDesc.semantic,
				offset: vertexCount ? offset3 : elementDesc.hasOwnProperty("offset") ? elementDesc.offset : offset3,
				stride: vertexCount ? elementSize : elementDesc.hasOwnProperty("stride") ? elementDesc.stride : this.size,
				dataType: elementDesc.type,
				numComponents: elementDesc.components,
				normalize,
				size: elementSize,
				asInt
			};
			this._elements.push(element);
			if (vertexCount) {
				offset3 += elementSize * vertexCount;
			} else {
				offset3 += Math.ceil(elementSize / 4) * 4;
			}
			if (elementDesc.semantic === SEMANTIC_TEXCOORD0) {
				this.hasUv0 = true;
			} else if (elementDesc.semantic === SEMANTIC_TEXCOORD1) {
				this.hasUv1 = true;
			} else if (elementDesc.semantic === SEMANTIC_COLOR) {
				this.hasColor = true;
			} else if (elementDesc.semantic === SEMANTIC_TANGENT) {
				this.hasTangents = true;
			}
		}
		if (vertexCount) {
			this.verticesByteSize = offset3;
		}
		this._evaluateHash();
	}
	get elements() {
		return this._elements;
	}
	static getDefaultInstancingFormat(graphicsDevice) {
		return deviceCache2.get(graphicsDevice, () => {
			return new _VertexFormat(graphicsDevice, [
				{ semantic: SEMANTIC_ATTR11, components: 4, type: TYPE_FLOAT32 },
				{ semantic: SEMANTIC_ATTR12, components: 4, type: TYPE_FLOAT32 },
				{ semantic: SEMANTIC_ATTR14, components: 4, type: TYPE_FLOAT32 },
				{ semantic: SEMANTIC_ATTR15, components: 4, type: TYPE_FLOAT32 }
			]);
		});
	}
	static get defaultInstancingFormat() {
		return null;
	}
	static isElementValid(graphicsDevice, elementDesc) {
		const elementSize = elementDesc.components * typedArrayTypesByteSize[elementDesc.type];
		if (graphicsDevice.isWebGPU && !webgpuValidElementSizes.includes(elementSize)) {
			return false;
		}
		return true;
	}
	update() {
		this._evaluateHash();
	}
	_evaluateHash() {
		const stringElementsBatch = [];
		const stringElementsRender = [];
		const len = this._elements.length;
		for (let i2 = 0; i2 < len; i2++) {
			const { name, dataType, numComponents, normalize, offset: offset3, stride, size, asInt } = this._elements[i2];
			const stringElementBatch = name + dataType + numComponents + normalize + asInt;
			stringElementsBatch.push(stringElementBatch);
			const stringElementRender = stringElementBatch + offset3 + stride + size;
			stringElementsRender.push(stringElementRender);
		}
		stringElementsBatch.sort();
		const batchingString = stringElementsBatch.join();
		this.batchingHash = hashCode(batchingString);
		this.shaderProcessingHashString = batchingString;
		this.renderingHashString = stringElementsRender.join("_");
		this.renderingHash = stringIds3.get(this.renderingHashString);
	}
};

var stringIds4 = new StringIds();
var StencilParameters = class _StencilParameters {
	_func;
	_ref;
	_fail;
	_zfail;
	_zpass;
	_readMask;
	_writeMask;
	_dirty = true;
	_key;
	set func(value) {
		this._func = value;
		this._dirty = true;
	}
	get func() {
		return this._func;
	}
	set ref(value) {
		this._ref = value;
		this._dirty = true;
	}
	get ref() {
		return this._ref;
	}
	set fail(value) {
		this._fail = value;
		this._dirty = true;
	}
	get fail() {
		return this._fail;
	}
	set zfail(value) {
		this._zfail = value;
		this._dirty = true;
	}
	get zfail() {
		return this._zfail;
	}
	set zpass(value) {
		this._zpass = value;
		this._dirty = true;
	}
	get zpass() {
		return this._zpass;
	}
	set readMask(value) {
		this._readMask = value;
		this._dirty = true;
	}
	get readMask() {
		return this._readMask;
	}
	set writeMask(value) {
		this._writeMask = value;
		this._dirty = true;
	}
	get writeMask() {
		return this._writeMask;
	}
	constructor(options2 = {}) {
		this._func = options2.func ?? FUNC_ALWAYS;
		this._ref = options2.ref ?? 0;
		this._readMask = options2.readMask ?? 255;
		this._writeMask = options2.writeMask ?? 255;
		this._fail = options2.fail ?? STENCILOP_KEEP;
		this._zfail = options2.zfail ?? STENCILOP_KEEP;
		this._zpass = options2.zpass ?? STENCILOP_KEEP;
		this._evalKey();
	}
	_evalKey() {
		const { _func, _ref, _fail, _zfail, _zpass, _readMask, _writeMask } = this;
		const key = `${_func},${_ref},${_fail},${_zfail},${_zpass},${_readMask},${_writeMask}`;
		this._key = stringIds4.get(key);
		this._dirty = false;
	}
	get key() {
		if (this._dirty) {
			this._evalKey();
		}
		return this._key;
	}
	copy(rhs) {
		this._func = rhs._func;
		this._ref = rhs._ref;
		this._readMask = rhs._readMask;
		this._writeMask = rhs._writeMask;
		this._fail = rhs._fail;
		this._zfail = rhs._zfail;
		this._zpass = rhs._zpass;
		this._dirty = rhs._dirty;
		this._key = rhs._key;
		return this;
	}
	clone() {
		const clone = new this.constructor();
		return clone.copy(this);
	}
	static DEFAULT = Object.freeze(new _StencilParameters());
};

var id6 = 0;
var StorageBuffer = class {
	id = id6++;
	constructor(graphicsDevice, byteSize, bufferUsage = 0, addStorageUsage = true) {
		this.device = graphicsDevice;
		this.byteSize = byteSize;
		this.bufferUsage = bufferUsage;
		const usage = addStorageUsage ? BUFFERUSAGE_STORAGE | bufferUsage : bufferUsage;
		this.impl = graphicsDevice.createBufferImpl(usage);
		this.impl.allocate(graphicsDevice, byteSize);
		graphicsDevice.buffers.add(this);
		this.adjustVramSizeTracking(graphicsDevice._vram, this.byteSize);
	}
	destroy() {
		const device = this.device;
		device.buffers.delete(this);
		this.impl.destroy(device);
		this.adjustVramSizeTracking(device._vram, -this.byteSize);
	}
	loseContext() {
		this.impl.loseContext();
	}
	restoreContext() {
		this.impl.allocate(this.device, this.byteSize);
	}
	adjustVramSizeTracking(vram, size) {
		vram.sb += size;
	}
	read(offset3 = 0, size = this.byteSize, data2 = null, immediate = false) {
		return this.impl.read(this.device, offset3, size, data2, immediate);
	}
	write(bufferOffset = 0, data2, dataOffset = 0, size) {
		this.impl.write(this.device, bufferOffset, data2, dataOffset, size);
	}
	clear(offset3 = 0, size = this.byteSize) {
		this.impl.clear(this.device, offset3, size);
	}
	copy(srcBuffer, srcOffset = 0, dstOffset = 0, size = srcBuffer.byteSize - srcOffset) {
		const commandEncoder = this.device.getCommandEncoder();
		commandEncoder.copyBufferToBuffer(srcBuffer.impl.buffer, srcOffset, this.impl.buffer, dstOffset, size);
	}
};

var _tempBlendState = new BlendState();
var _tempDepthState = new DepthState();
var GraphicsDevice = class _GraphicsDevice extends EventHandler {
	canvas;
	backBuffer = null;
	backBufferSize = new Vec2();
	backBufferFormat;
	backBufferAntialias = false;
	isWebGPU = false;
	isWebGL2 = false;
	isNull = false;
	isHdr = false;
	scope;
	maxIndirectDrawCount = 1024;
	maxIndirectDispatchCount = 256;
	maxAnisotropy;
	maxCubeMapSize;
	maxTextureSize;
	maxVolumeSize;
	maxColorAttachments = 1;
	precision;
	samples;
	maxSamples = 1;
	supportsStencil;
	supportsMultiDraw = true;
	supportsCompute = false;
	supportsStorageTextureRead = false;
	supportsSubgroups = false;
	supportsSubgroupUniformity = false;
	supportsSubgroupId = false;
	supportsLinearIndexing = false;
	supportsPointerCompositeAccess = false;
	supportsPacked4x8IntegerDotProduct = false;
	supportsTextureAndSamplerLet = false;
	supportsUnrestrictedPointerParameters = false;
	maxSubgroupSize = 0;
	minSubgroupSize = 0;
	renderTarget = null;
	shaders = [];
	textures = /* @__PURE__ */ new Set();
	texturesToUpload = /* @__PURE__ */ new Set();
	targets = /* @__PURE__ */ new Set();
	renderVersion = 0;
	renderPassIndex;
	insideRenderPass = false;
	supportsUniformBuffers = false;
	supportsClipDistances = false;
	supportsTransientAttachments = false;
	supportsTextureFormatTier1 = false;
	supportsTextureFormatTier2 = false;
	supportsPrimitiveIndex = false;
	supportsShaderF16 = false;
	supportsHtmlTextures = false;
	textureFloatRenderable;
	textureHalfFloatRenderable;
	textureRG11B10Renderable = false;
	textureFloatFilterable = false;
	quadVertexBuffer;
	quadIndexBuffer;
	blendState = new BlendState();
	depthState = new DepthState();
	stencilEnabled = false;
	stencilFront = new StencilParameters();
	stencilBack = new StencilParameters();
	dynamicBuffers;
	gpuProfiler;
	_destroyed = false;
	defaultClearOptions = {
		color: [0, 0, 0, 1],
		depth: 1,
		stencil: 0,
		flags: CLEARFLAG_COLOR | CLEARFLAG_DEPTH
	};
	clientRect = {
		width: 0,
		height: 0
	};
	_shadersDirty = false;
	capsDefines = /* @__PURE__ */ new Map();
	mapsToClear = /* @__PURE__ */ new Set();
	static EVENT_RESIZE = "resizecanvas";
	constructor(canvas, options2) {
		var _a2, _b2, _c, _d, _e, _f, _g, _h, _i;
		super();
		this.canvas = canvas;
		if ("setAttribute" in canvas) {
			canvas.setAttribute("data-engine", `PlayCanvas ${version}`);
		}
		this.initOptions = { ...options2 };
		(_a2 = this.initOptions).alpha ?? (_a2.alpha = true);
		(_b2 = this.initOptions).depth ?? (_b2.depth = true);
		(_c = this.initOptions).stencil ?? (_c.stencil = true);
		(_d = this.initOptions).antialias ?? (_d.antialias = true);
		(_e = this.initOptions).powerPreference ?? (_e.powerPreference = "high-performance");
		(_f = this.initOptions).displayFormat ?? (_f.displayFormat = DISPLAYFORMAT_LDR);
		(_g = this.initOptions).transientColor ?? (_g.transientColor = false);
		(_h = this.initOptions).transientDepth ?? (_h.transientDepth = false);
		(_i = this.initOptions).xrCompatible ?? (_i.xrCompatible = platform.browser && !!navigator.xr);
		this._maxPixelRatio = platform.browser ? Math.min(1, window.devicePixelRatio) : 1;
		this.buffers = /* @__PURE__ */ new Set();
		this._vram = {
			tex: 0,
			vb: 0,
			ib: 0,
			ub: 0,
			sb: 0
		};
		this._shaderStats = {
			vsCompiled: 0,
			fsCompiled: 0,
			linked: 0,
			materialShaders: 0,
			compileTime: 0
		};
		this.initializeContextCaches();
		this._drawCallsPerFrame = 0;
		this._shaderSwitchesPerFrame = 0;
		this._primsPerFrame = [];
		for (let i2 = PRIMITIVE_POINTS; i2 <= PRIMITIVE_TRIFAN; i2++) {
			this._primsPerFrame[i2] = 0;
		}
		this._renderTargetCreationTime = 0;
		this.scope = new ScopeSpace("Device");
		this.textureBias = this.scope.resolve("textureBias");
		this.textureBias.setValue(0);
		this.updateClientRect();
	}
	postInit() {
		const vertexFormat = new VertexFormat(this, [
			{ semantic: SEMANTIC_POSITION, components: 2, type: TYPE_FLOAT32 }
		]);
		const positions = new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]);
		this.quadVertexBuffer = new VertexBuffer(this, vertexFormat, 4, {
			data: positions
		});
		const indices = new Uint16Array([0, 1, 2, 2, 1, 3]);
		this.quadIndexBuffer = new IndexBuffer(this, INDEXFORMAT_UINT16, 6, BUFFER_STATIC, indices.buffer);
	}
	initCapsDefines() {
		const { capsDefines } = this;
		capsDefines.clear();
		if (this.textureFloatFilterable) capsDefines.set("CAPS_TEXTURE_FLOAT_FILTERABLE", "");
		if (this.textureFloatRenderable) capsDefines.set("CAPS_TEXTURE_FLOAT_RENDERABLE", "");
		if (this.supportsMultiDraw) capsDefines.set("CAPS_MULTI_DRAW", "");
		if (this.supportsPrimitiveIndex) capsDefines.set("CAPS_PRIMITIVE_INDEX", "");
		if (this.supportsShaderF16) capsDefines.set("CAPS_SHADER_F16", "");
		if (this.supportsSubgroups) capsDefines.set("CAPS_SUBGROUPS", "");
		if (this.supportsSubgroupId) capsDefines.set("CAPS_SUBGROUP_ID", "");
		if (this.supportsLinearIndexing) capsDefines.set("CAPS_LINEAR_INDEXING", "");
		if (this.supportsUnrestrictedPointerParameters) capsDefines.set("CAPS_UNRESTRICTED_POINTER_PARAMETERS", "");
		if (this.supportsPointerCompositeAccess) capsDefines.set("CAPS_POINTER_COMPOSITE_ACCESS", "");
		if (this.supportsPacked4x8IntegerDotProduct) capsDefines.set("CAPS_PACKED_4X8_INTEGER_DOT_PRODUCT", "");
		if (this.supportsTextureAndSamplerLet) capsDefines.set("CAPS_TEXTURE_AND_SAMPLER_LET", "");
		if (this.supportsStorageTextureRead) capsDefines.set("CAPS_STORAGE_TEXTURE_READ", "");
		if (platform.desktop) capsDefines.set("PLATFORM_DESKTOP", "");
		if (platform.mobile) capsDefines.set("PLATFORM_MOBILE", "");
		if (platform.android) capsDefines.set("PLATFORM_ANDROID", "");
		if (platform.ios) capsDefines.set("PLATFORM_IOS", "");
	}
	destroy() {
		this.fire("destroy");
		this.quadVertexBuffer?.destroy();
		this.quadVertexBuffer = null;
		this.quadIndexBuffer?.destroy();
		this.quadIndexBuffer = null;
		this.dynamicBuffers?.destroy();
		this.dynamicBuffers = null;
		this.gpuProfiler?.destroy();
		this.gpuProfiler = null;
		this._destroyed = true;
	}
	onDestroyShader(shader) {
		this.fire("destroy:shader", shader);
		const idx = this.shaders.indexOf(shader);
		if (idx !== -1) {
			this.shaders.splice(idx, 1);
		}
	}
	onTextureDestroyed(texture) {
		this.textures.delete(texture);
		this.texturesToUpload.delete(texture);
		this.scope.removeValue(texture);
	}
	// executes after the extended classes have executed their destroy function
	postDestroy() {
		this.scope = null;
		this.canvas = null;
	}
	loseContext() {
		this.contextLost = true;
		this.backBufferSize.set(-1, -1);
		for (const texture of this.textures) {
			texture.loseContext();
		}
		for (const buffer of this.buffers) {
			buffer.loseContext();
		}
		for (const target2 of this.targets) {
			target2.loseContext();
		}
		this.gpuProfiler?.loseContext();
	}
	restoreContext() {
		this.contextLost = false;
		this.initializeRenderState();
		this.initializeContextCaches();
		for (const buffer of this.buffers) {
			buffer.restoreContext();
		}
		this.gpuProfiler?.restoreContext?.();
	}
	// don't stringify GraphicsDevice to JSON by JSON.stringify
	toJSON(key) {
		return void 0;
	}
	initializeContextCaches() {
		this.vertexBuffers = [];
		this.shader = null;
		this.shaderValid = void 0;
		this.shaderAsyncCompile = false;
		this.renderTarget = null;
	}
	initializeRenderState() {
		this.blendState = new BlendState();
		this.depthState = new DepthState();
		this.cullMode = CULLFACE_BACK;
		this.frontFace = FRONTFACE_CCW;
		this.vx = this.vy = this.vw = this.vh = 0;
		this.sx = this.sy = this.sw = this.sh = 0;
		this.blendColor = new Color(0, 0, 0, 0);
	}
	// ---- deprecated block start ----
	get boneLimit() {
		return 1024;
	}
	get webgl2() {
		return this.isWebGL2;
	}
	get textureFloatHighPrecision() {
		return true;
	}
	get extBlendMinmax() {
		return true;
	}
	get extTextureHalfFloat() {
		return true;
	}
	get extTextureLod() {
		return true;
	}
	get textureHalfFloatFilterable() {
		return true;
	}
	get supportsMrt() {
		return true;
	}
	get supportsVolumeTextures() {
		return true;
	}
	get supportsInstancing() {
		return true;
	}
	get textureHalfFloatUpdatable() {
		return true;
	}
	get extTextureFloat() {
		return true;
	}
	get extStandardDerivatives() {
		return true;
	}
	setBlendFunction(blendSrc, blendDst) {
		const currentBlendState = this.blendState;
		_tempBlendState.copy(currentBlendState);
		_tempBlendState.setColorBlend(currentBlendState.colorOp, blendSrc, blendDst);
		_tempBlendState.setAlphaBlend(currentBlendState.alphaOp, blendSrc, blendDst);
		this.setBlendState(_tempBlendState);
	}
	setBlendFunctionSeparate(blendSrc, blendDst, blendSrcAlpha, blendDstAlpha) {
		const currentBlendState = this.blendState;
		_tempBlendState.copy(currentBlendState);
		_tempBlendState.setColorBlend(currentBlendState.colorOp, blendSrc, blendDst);
		_tempBlendState.setAlphaBlend(currentBlendState.alphaOp, blendSrcAlpha, blendDstAlpha);
		this.setBlendState(_tempBlendState);
	}
	setBlendEquation(blendEquation) {
		const currentBlendState = this.blendState;
		_tempBlendState.copy(currentBlendState);
		_tempBlendState.setColorBlend(blendEquation, currentBlendState.colorSrcFactor, currentBlendState.colorDstFactor);
		_tempBlendState.setAlphaBlend(blendEquation, currentBlendState.alphaSrcFactor, currentBlendState.alphaDstFactor);
		this.setBlendState(_tempBlendState);
	}
	setBlendEquationSeparate(blendEquation, blendAlphaEquation) {
		const currentBlendState = this.blendState;
		_tempBlendState.copy(currentBlendState);
		_tempBlendState.setColorBlend(blendEquation, currentBlendState.colorSrcFactor, currentBlendState.colorDstFactor);
		_tempBlendState.setAlphaBlend(blendAlphaEquation, currentBlendState.alphaSrcFactor, currentBlendState.alphaDstFactor);
		this.setBlendState(_tempBlendState);
	}
	setColorWrite(redWrite, greenWrite, blueWrite, alphaWrite) {
		const currentBlendState = this.blendState;
		_tempBlendState.copy(currentBlendState);
		_tempBlendState.setColorWrite(redWrite, greenWrite, blueWrite, alphaWrite);
		this.setBlendState(_tempBlendState);
	}
	getBlending() {
		return this.blendState.blend;
	}
	setBlending(blending) {
		_tempBlendState.copy(this.blendState);
		_tempBlendState.blend = blending;
		this.setBlendState(_tempBlendState);
	}
	setDepthWrite(write) {
		_tempDepthState.copy(this.depthState);
		_tempDepthState.write = write;
		this.setDepthState(_tempDepthState);
	}
	setDepthFunc(func) {
		_tempDepthState.copy(this.depthState);
		_tempDepthState.func = func;
		this.setDepthState(_tempDepthState);
	}
	setDepthTest(test) {
		_tempDepthState.copy(this.depthState);
		_tempDepthState.test = test;
		this.setDepthState(_tempDepthState);
	}
	getCullMode() {
		return this.cullMode;
	}
	// ---- deprecated block end ----
	setStencilState(stencilFront, stencilBack) {
	}
	setBlendState(blendState) {
	}
	setBlendColor(r, g, b, a) {
	}
	setDepthState(depthState) {
	}
	setCullMode(cullMode) {
	}
	setFrontFace(frontFace) {
	}
	setDrawStates(blendState = BlendState.NOBLEND, depthState = DepthState.NODEPTH, cullMode = CULLFACE_NONE, frontFace = FRONTFACE_CCW, stencilFront, stencilBack) {
		this.setBlendState(blendState);
		this.setDepthState(depthState);
		this.setCullMode(cullMode);
		this.setFrontFace(frontFace);
		this.setStencilState(stencilFront, stencilBack);
	}
	setRenderTarget(renderTarget) {
		this.renderTarget = renderTarget;
	}
	setVertexBuffer(vertexBuffer) {
		if (vertexBuffer) {
			this.vertexBuffers.push(vertexBuffer);
		}
	}
	clearVertexBuffer() {
		this.vertexBuffers.length = 0;
	}
	getIndirectDrawSlot(count = 1) {
		return 0;
	}
	get indirectDrawBuffer() {
		return null;
	}
	getIndirectDispatchSlot(count = 1) {
		return 0;
	}
	get indirectDispatchBuffer() {
		return null;
	}
	getRenderTarget() {
		return this.renderTarget;
	}
	initRenderTarget(target2) {
		if (target2.initialized) return;
		target2.init();
		this.targets.add(target2);
	}
	draw(primitive2, indexBuffer, numInstances, drawCommands, first = true, last = true) {
	}
	_isBrowserInterface(texture) {
		return this._isImageBrowserInterface(texture) || this._isImageCanvasInterface(texture) || this._isImageVideoInterface(texture) || this._isHTMLElementInterface(texture);
	}
	_isImageBrowserInterface(texture) {
		return typeof ImageBitmap !== "undefined" && texture instanceof ImageBitmap || typeof HTMLImageElement !== "undefined" && texture instanceof HTMLImageElement;
	}
	_isImageCanvasInterface(texture) {
		return typeof HTMLCanvasElement !== "undefined" && texture instanceof HTMLCanvasElement;
	}
	_isImageVideoInterface(texture) {
		return typeof HTMLVideoElement !== "undefined" && texture instanceof HTMLVideoElement;
	}
	_isHTMLElementInterface(texture) {
		return typeof HTMLElement !== "undefined" && texture instanceof HTMLElement && !(typeof HTMLImageElement !== "undefined" && texture instanceof HTMLImageElement) && !(typeof HTMLCanvasElement !== "undefined" && texture instanceof HTMLCanvasElement) && !(typeof HTMLVideoElement !== "undefined" && texture instanceof HTMLVideoElement);
	}
	resizeCanvas(width, height) {
		const pixelRatio = Math.min(this._maxPixelRatio, platform.browser ? window.devicePixelRatio : 1);
		const w = Math.floor(width * pixelRatio);
		const h2 = Math.floor(height * pixelRatio);
		if (w !== this.canvas.width || h2 !== this.canvas.height) {
			this.setResolution(w, h2);
		}
	}
	setResolution(width, height) {
		this.canvas.width = width;
		this.canvas.height = height;
		this.fire(_GraphicsDevice.EVENT_RESIZE, width, height);
	}
	update() {
		this.updateClientRect();
	}
	updateClientRect() {
		if (typeof this.canvas.getBoundingClientRect === "function") {
			const rect = this.canvas.getBoundingClientRect();
			this.clientRect.width = rect.width;
			this.clientRect.height = rect.height;
		} else {
			this.clientRect.width = this.canvas.width ?? 0;
			this.clientRect.height = this.canvas.height ?? 0;
		}
	}
	get width() {
		return this.canvas.width;
	}
	get height() {
		return this.canvas.height;
	}
	set fullscreen(fullscreen) {
	}
	get fullscreen() {
		return false;
	}
	set maxPixelRatio(ratio) {
		this._maxPixelRatio = ratio;
	}
	get maxPixelRatio() {
		return this._maxPixelRatio;
	}
	get deviceType() {
		return this._deviceType;
	}
	startRenderPass(renderPass) {
	}
	endRenderPass(renderPass) {
	}
	startComputePass(name) {
	}
	endComputePass() {
	}
	frameStart() {
		this.renderPassIndex = 0;
		this.renderVersion++;
	}
	frameEnd() {
		this.mapsToClear.forEach((map) => map.clear());
		this.mapsToClear.clear();
	}
	computeDispatch(computes, name = "Unnamed") {
	}
	getRenderableHdrFormat(formats = [PIXELFORMAT_111110F, PIXELFORMAT_RGBA16F, PIXELFORMAT_RGBA32F], filterable = true, samples = 1) {
		for (let i2 = 0; i2 < formats.length; i2++) {
			const format = formats[i2];
			switch (format) {
				case PIXELFORMAT_111110F: {
					if (this.textureRG11B10Renderable) {
						return format;
					}
					break;
				}
				case PIXELFORMAT_RGBA16F:
					if (this.textureHalfFloatRenderable) {
						return format;
					}
					break;
				case PIXELFORMAT_RGBA32F:
					if (this.isWebGPU && samples > 1) {
						continue;
					}
					if (this.textureFloatRenderable && (!filterable || this.textureFloatFilterable)) {
						return format;
					}
					break;
			}
		}
		return void 0;
	}
	validateAttributes(shader, vb0Format, vb1Format) {
	}
};

var id7 = 0;
var RenderTarget = class {
	name;
	_device;
	_colorBuffer;
	_colorBuffers;
	_depthBuffer;
	_depth;
	_stencil;
	_samples;
	_transientColor;
	_transientDepth;
	autoResolve;
	_face;
	_mipLevel;
	_mipmaps;
	_width;
	_height;
	flipY;
	constructor(options2 = {}) {
		this.id = id7++;
		const device = options2.colorBuffer?.device ?? options2.colorBuffers?.[0].device ?? options2.depthBuffer?.device ?? options2.graphicsDevice;
		this._device = device;
		const { maxSamples } = this._device;
		this._samples = Math.min(options2.samples ?? 1, maxSamples);
		if (device.isWebGPU) {
			this._samples = this._samples > 1 ? maxSamples : 1;
		}
		this._colorBuffer = options2.colorBuffer;
		if (options2.colorBuffer) {
			this._colorBuffers = [options2.colorBuffer];
		}
		this._depthBuffer = options2.depthBuffer;
		this._face = options2.face ?? 0;
		if (this._depthBuffer) {
			const format = this._depthBuffer._format;
			if (format === PIXELFORMAT_DEPTH || format === PIXELFORMAT_DEPTH16) {
				this._depth = true;
				this._stencil = false;
			} else if (format === PIXELFORMAT_DEPTHSTENCIL) {
				this._depth = true;
				this._stencil = true;
			} else if (format === PIXELFORMAT_R32F && this._depthBuffer.device.isWebGPU && this._samples > 1) {
				this._depth = true;
				this._stencil = false;
			} else {
				this._depth = false;
				this._stencil = false;
			}
		} else {
			this._depth = options2.depth ?? true;
			this._stencil = options2.stencil ?? false;
		}
		if (options2.colorBuffers) {
			if (!this._colorBuffers) {
				this._colorBuffers = [...options2.colorBuffers];
				this._colorBuffer = options2.colorBuffers[0];
			}
		}
		this.autoResolve = options2.autoResolve ?? true;
		this.name = options2.name;
		if (!this.name) {
			this.name = this._colorBuffer?.name;
		}
		if (!this.name) {
			this.name = this._depthBuffer?.name;
		}
		if (!this.name) {
			this.name = "Untitled";
		}
		const transientSupported = !!this._device.supportsTransientAttachments;
		this._transientColor = (options2.transientColor ?? false) && transientSupported && this._samples > 1;
		this._transientDepth = (options2.transientDepth ?? false) && transientSupported && !this._depthBuffer;
		if ((options2.transientDepth ?? false) && this._depthBuffer) {
		}
		this.flipY = options2.flipY ?? false;
		this._mipLevel = options2.mipLevel ?? 0;
		if (this._mipLevel > 0 && this._depth) {
			this._mipLevel = 0;
		}
		this._mipmaps = options2.mipLevel === void 0;
		this.evaluateDimensions();
		this.validateMrt();
		this.impl = device.createRenderTargetImpl(this);
	}
	destroy() {
		const device = this._device;
		if (device) {
			device.targets.delete(this);
			if (device.renderTarget === this) {
				device.setRenderTarget(null);
			}
			this.destroyFrameBuffers();
		}
	}
	destroyFrameBuffers() {
		const device = this._device;
		if (device) {
			this.impl.destroy(device);
		}
	}
	destroyTextureBuffers() {
		this._depthBuffer?.destroy();
		this._depthBuffer = null;
		this._colorBuffers?.forEach((colorBuffer) => {
			colorBuffer.destroy();
		});
		this._colorBuffers = null;
		this._colorBuffer = null;
	}
	resize(width, height) {
		if (this.mipLevel > 0) {
			return;
		}
		this._depthBuffer?.resize(width, height);
		this._colorBuffers?.forEach((colorBuffer) => {
			colorBuffer.resize(width, height);
		});
		if (this._width !== width || this._height !== height) {
			this.destroyFrameBuffers();
			const device = this._device;
			if (device.renderTarget === this) {
				device.setRenderTarget(null);
			}
			this.evaluateDimensions();
			this.validateMrt();
			this.impl = device.createRenderTargetImpl(this);
		}
	}
	validateMrt() {
	}
	evaluateDimensions() {
		const buffer = this._colorBuffer ?? this._depthBuffer;
		if (buffer) {
			this._width = buffer.width;
			this._height = buffer.height;
			if (this._mipLevel > 0) {
				this._width = TextureUtils.calcLevelDimension(this._width, this._mipLevel);
				this._height = TextureUtils.calcLevelDimension(this._height, this._mipLevel);
			}
		}
	}
	init() {
		this.impl.init(this._device, this);
	}
	get initialized() {
		return this.impl.initialized;
	}
	get device() {
		return this._device;
	}
	loseContext() {
		this.impl.loseContext();
	}
	resolve(color3 = true, depth = !!this._depthBuffer) {
		if (this._device && this._samples > 1) {
			this.impl.resolve(this._device, this, color3, depth);
		}
	}
	copy(source, color3, depth) {
		if (!this._device) {
			if (source._device) {
				this._device = source._device;
			} else {
				return false;
			}
		}
		const success = this._device.copyRenderTarget(source, this, color3, depth);
		return success;
	}
	get samples() {
		return this._samples;
	}
	get transientColor() {
		return this._transientColor;
	}
	get transientDepth() {
		return this._transientDepth;
	}
	get depth() {
		return this._depth;
	}
	get stencil() {
		return this._stencil;
	}
	get colorBuffer() {
		return this._colorBuffer;
	}
	getColorBuffer(index) {
		return this._colorBuffers?.[index];
	}
	get depthBuffer() {
		return this._depthBuffer;
	}
	get face() {
		return this._face;
	}
	get mipLevel() {
		return this._mipLevel;
	}
	get mipmaps() {
		return this._mipmaps;
	}
	get width() {
		return this._width ?? this._device.width;
	}
	get height() {
		return this._height ?? this._device.height;
	}
	set _glFrameBuffer(value) {
	}
	get _glFrameBuffer() {
		return this.impl._glFrameBuffer;
	}
	isColorBufferSrgb(index = 0) {
		if (this.device.backBuffer === this) {
			return isSrgbPixelFormat(this.device.backBufferFormat);
		}
		const colorBuffer = this.getColorBuffer(index);
		return colorBuffer ? isSrgbPixelFormat(colorBuffer.format) : false;
	}
};

var WebgpuBindGroup = class {
	bindGroup;
	update(bindGroup) {
		this.destroy();
		const device = bindGroup.device;
		const desc = this.createDescriptor(device, bindGroup);
		this.bindGroup = device.wgpu.createBindGroup(desc);
	}
	destroy() {
		this.bindGroup = null;
	}
	createDescriptor(device, bindGroup) {
		const entries = [];
		const format = bindGroup.format;
		const uniformBufferFormats = bindGroup.format.uniformBufferFormats;
		bindGroup.uniformBuffers.forEach((ub, i2) => {
			const slot = uniformBufferFormats[i2].slot;
			const buffer = ub.persistent ? ub.impl.buffer : ub.allocation.gpuBuffer.buffer;
			entries.push({
				binding: slot,
				resource: {
					buffer,
					offset: 0,
					size: ub.format.byteSize
				}
			});
		});
		const textureFormats = bindGroup.format.textureFormats;
		bindGroup.textures.forEach((value, textureIndex) => {
			const isTextureView = value instanceof TextureView;
			const texture = isTextureView ? value.texture : value;
			const wgpuTexture = texture.impl;
			const textureFormat = format.textureFormats[textureIndex];
			const slot = textureFormats[textureIndex].slot;
			const view = wgpuTexture.getView(device, isTextureView ? value : void 0);
			entries.push({
				binding: slot,
				resource: view
			});
			if (textureFormat.hasSampler) {
				const sampler = wgpuTexture.getSampler(device, textureFormat.sampleType);
				entries.push({
					binding: slot + 1,
					resource: sampler
				});
			}
		});
		const storageTextureFormats = bindGroup.format.storageTextureFormats;
		bindGroup.storageTextures.forEach((value, textureIndex) => {
			const isTextureView = value instanceof TextureView;
			const texture = isTextureView ? value.texture : value;
			const wgpuTexture = texture.impl;
			const slot = storageTextureFormats[textureIndex].slot;
			const view = wgpuTexture.getView(device, isTextureView ? value : void 0);
			entries.push({
				binding: slot,
				resource: view
			});
		});
		const storageBufferFormats = bindGroup.format.storageBufferFormats;
		bindGroup.storageBuffers.forEach((buffer, bufferIndex) => {
			const wgpuBuffer = buffer.impl.buffer;
			const slot = storageBufferFormats[bufferIndex].slot;
			entries.push({
				binding: slot,
				resource: {
					buffer: wgpuBuffer
				}
			});
		});
		const desc = {
			layout: bindGroup.format.impl.bindGroupLayout,
			entries
		};
		return desc;
	}
};

var WebgpuUtils = class {
	// converts a combination of SHADER_STAGE_* into GPUShaderStage.*
	static shaderStage(stage) {
		let ret = 0;
		if (stage & SHADERSTAGE_VERTEX) ret |= GPUShaderStage.VERTEX;
		if (stage & SHADERSTAGE_FRAGMENT) ret |= GPUShaderStage.FRAGMENT;
		if (stage & SHADERSTAGE_COMPUTE) ret |= GPUShaderStage.COMPUTE;
		return ret;
	}
};

var gpuTextureFormats = [];
gpuTextureFormats[PIXELFORMAT_A8] = "";
gpuTextureFormats[PIXELFORMAT_L8] = "";
gpuTextureFormats[PIXELFORMAT_LA8] = "";
gpuTextureFormats[PIXELFORMAT_R8] = "r8unorm";
gpuTextureFormats[PIXELFORMAT_RG8] = "rg8unorm";
gpuTextureFormats[PIXELFORMAT_RGB565] = "";
gpuTextureFormats[PIXELFORMAT_RGBA5551] = "";
gpuTextureFormats[PIXELFORMAT_RGBA4] = "";
gpuTextureFormats[PIXELFORMAT_RGB8] = "rgba8unorm";
gpuTextureFormats[PIXELFORMAT_RGBA8] = "rgba8unorm";
gpuTextureFormats[PIXELFORMAT_DXT1] = "bc1-rgba-unorm";
gpuTextureFormats[PIXELFORMAT_DXT3] = "bc2-rgba-unorm";
gpuTextureFormats[PIXELFORMAT_DXT5] = "bc3-rgba-unorm";
gpuTextureFormats[PIXELFORMAT_RGB16F] = "";
gpuTextureFormats[PIXELFORMAT_RGBA16F] = "rgba16float";
gpuTextureFormats[PIXELFORMAT_R16F] = "r16float";
gpuTextureFormats[PIXELFORMAT_RG16F] = "rg16float";
gpuTextureFormats[PIXELFORMAT_RGB32F] = "";
gpuTextureFormats[PIXELFORMAT_RGBA32F] = "rgba32float";
gpuTextureFormats[PIXELFORMAT_R32F] = "r32float";
gpuTextureFormats[PIXELFORMAT_RG32F] = "rg32float";
gpuTextureFormats[PIXELFORMAT_DEPTH] = "depth32float";
gpuTextureFormats[PIXELFORMAT_DEPTH16] = "depth16unorm";
gpuTextureFormats[PIXELFORMAT_DEPTHSTENCIL] = "depth24plus-stencil8";
gpuTextureFormats[PIXELFORMAT_111110F] = "rg11b10ufloat";
gpuTextureFormats[PIXELFORMAT_SRGB8] = "";
gpuTextureFormats[PIXELFORMAT_SRGBA8] = "rgba8unorm-srgb";
gpuTextureFormats[PIXELFORMAT_ETC1] = "";
gpuTextureFormats[PIXELFORMAT_ETC2_RGB] = "etc2-rgb8unorm";
gpuTextureFormats[PIXELFORMAT_ETC2_RGBA] = "etc2-rgba8unorm";
gpuTextureFormats[PIXELFORMAT_PVRTC_2BPP_RGB_1] = "";
gpuTextureFormats[PIXELFORMAT_PVRTC_2BPP_RGBA_1] = "";
gpuTextureFormats[PIXELFORMAT_PVRTC_4BPP_RGB_1] = "";
gpuTextureFormats[PIXELFORMAT_PVRTC_4BPP_RGBA_1] = "";
gpuTextureFormats[PIXELFORMAT_ASTC_4x4] = "astc-4x4-unorm";
gpuTextureFormats[PIXELFORMAT_ATC_RGB] = "";
gpuTextureFormats[PIXELFORMAT_ATC_RGBA] = "";
gpuTextureFormats[PIXELFORMAT_BGRA8] = "bgra8unorm";
gpuTextureFormats[PIXELFORMAT_SBGRA8] = "bgra8unorm-srgb";
gpuTextureFormats[PIXELFORMAT_R8I] = "r8sint";
gpuTextureFormats[PIXELFORMAT_R8U] = "r8uint";
gpuTextureFormats[PIXELFORMAT_R16I] = "r16sint";
gpuTextureFormats[PIXELFORMAT_R16U] = "r16uint";
gpuTextureFormats[PIXELFORMAT_R32I] = "r32sint";
gpuTextureFormats[PIXELFORMAT_R32U] = "r32uint";
gpuTextureFormats[PIXELFORMAT_RG8I] = "rg8sint";
gpuTextureFormats[PIXELFORMAT_RG8U] = "rg8uint";
gpuTextureFormats[PIXELFORMAT_RG16I] = "rg16sint";
gpuTextureFormats[PIXELFORMAT_RG16U] = "rg16uint";
gpuTextureFormats[PIXELFORMAT_RG32I] = "rg32sint";
gpuTextureFormats[PIXELFORMAT_RG32U] = "rg32uint";
gpuTextureFormats[PIXELFORMAT_RGBA8I] = "rgba8sint";
gpuTextureFormats[PIXELFORMAT_RGBA8U] = "rgba8uint";
gpuTextureFormats[PIXELFORMAT_RGBA16I] = "rgba16sint";
gpuTextureFormats[PIXELFORMAT_RGBA16U] = "rgba16uint";
gpuTextureFormats[PIXELFORMAT_RGBA32I] = "rgba32sint";
gpuTextureFormats[PIXELFORMAT_RGBA32U] = "rgba32uint";
gpuTextureFormats[PIXELFORMAT_BC6F] = "bc6h-rgb-float";
gpuTextureFormats[PIXELFORMAT_BC6UF] = "bc6h-rgb-ufloat";
gpuTextureFormats[PIXELFORMAT_BC7] = "bc7-rgba-unorm";
gpuTextureFormats[PIXELFORMAT_RGB9E5] = "rgb9e5ufloat";
gpuTextureFormats[PIXELFORMAT_RG8S] = "rg8snorm";
gpuTextureFormats[PIXELFORMAT_RGBA8S] = "rgba8snorm";
gpuTextureFormats[PIXELFORMAT_RGB10A2] = "rgb10a2unorm";
gpuTextureFormats[PIXELFORMAT_RGB10A2U] = "rgb10a2uint";
gpuTextureFormats[PIXELFORMAT_DXT1_SRGB] = "bc1-rgba-unorm-srgb";
gpuTextureFormats[PIXELFORMAT_DXT3_SRGBA] = "bc2-rgba-unorm-srgb";
gpuTextureFormats[PIXELFORMAT_DXT5_SRGBA] = "bc3-rgba-unorm-srgb";
gpuTextureFormats[PIXELFORMAT_ETC2_SRGB] = "etc2-rgb8unorm-srgb";
gpuTextureFormats[PIXELFORMAT_ETC2_SRGBA] = "etc2-rgba8unorm-srgb";
gpuTextureFormats[PIXELFORMAT_BC7_SRGBA] = "bc7-rgba-unorm-srgb";
gpuTextureFormats[PIXELFORMAT_ASTC_4x4_SRGB] = "astc-4x4-unorm-srgb";

var samplerTypes = [];
samplerTypes[SAMPLETYPE_FLOAT] = "filtering";
samplerTypes[SAMPLETYPE_UNFILTERABLE_FLOAT] = "non-filtering";
samplerTypes[SAMPLETYPE_DEPTH] = "comparison";
samplerTypes[SAMPLETYPE_INT] = "comparison";
samplerTypes[SAMPLETYPE_UINT] = "comparison";
var sampleTypes = [];
sampleTypes[SAMPLETYPE_FLOAT] = "float";
sampleTypes[SAMPLETYPE_UNFILTERABLE_FLOAT] = "unfilterable-float";
sampleTypes[SAMPLETYPE_DEPTH] = "depth";
sampleTypes[SAMPLETYPE_INT] = "sint";
sampleTypes[SAMPLETYPE_UINT] = "uint";
var stringIds5 = new StringIds();
var WebgpuBindGroupFormat = class {
	constructor(bindGroupFormat) {
		const device = bindGroupFormat.device;
		const { key, desc } = this.createDescriptor(bindGroupFormat);
		this.key = stringIds5.get(key);
		this.bindGroupLayout = device.wgpu.createBindGroupLayout(desc);
	}
	destroy() {
		this.bindGroupLayout = null;
	}
	loseContext() {
	}
	createDescriptor(bindGroupFormat) {
		const entries = [];
		let key = "";
		bindGroupFormat.uniformBufferFormats.forEach((bufferFormat) => {
			const visibility = WebgpuUtils.shaderStage(bufferFormat.visibility);
			key += `#${bufferFormat.slot}U:${visibility}`;
			entries.push({
				binding: bufferFormat.slot,
				visibility,
				buffer: {
					type: "uniform",
					// "uniform", "storage", "read-only-storage"
					// whether this binding requires a dynamic offset
					// currently all UBs are dynamic and need the offset
					hasDynamicOffset: true
					// defaults to 0 meaning no validation, can do early size validation using it
					// minBindingSize
				}
			});
		});
		bindGroupFormat.textureFormats.forEach((textureFormat) => {
			const visibility = WebgpuUtils.shaderStage(textureFormat.visibility);
			const sampleType = textureFormat.sampleType;
			const viewDimension = textureFormat.textureDimension;
			const multisampled = false;
			const gpuSampleType = sampleTypes[sampleType];
			key += `#${textureFormat.slot}T:${visibility}-${gpuSampleType}-${viewDimension}-${multisampled}`;
			entries.push({
				binding: textureFormat.slot,
				visibility,
				texture: {
					// Indicates the type required for texture views bound to this binding.
					// "float", "unfilterable-float", "depth", "sint", "uint",
					sampleType: gpuSampleType,
					// Indicates the required dimension for texture views bound to this binding.
					// "1d", "2d", "2d-array", "cube", "cube-array", "3d"
					viewDimension,
					// Indicates whether or not texture views bound to this binding must be multisampled
					multisampled
				}
			});
			if (textureFormat.hasSampler) {
				const gpuSamplerType = samplerTypes[sampleType];
				key += `#${textureFormat.slot + 1}S:${visibility}-${gpuSamplerType}`;
				entries.push({
					binding: textureFormat.slot + 1,
					visibility,
					sampler: {
						// Indicates the required type of a sampler bound to this bindings
						// 'filtering', 'non-filtering', 'comparison'
						type: gpuSamplerType
					}
				});
			}
		});
		bindGroupFormat.storageTextureFormats.forEach((textureFormat) => {
			const { format, textureDimension } = textureFormat;
			const { read, write } = textureFormat;
			key += `#${textureFormat.slot}ST:${format}-${textureDimension}-${read ? "r1" : "r0"}-${write ? "w1" : "w0"}`;
			entries.push({
				binding: textureFormat.slot,
				visibility: GPUShaderStage.COMPUTE,
				storageTexture: {
					// The access mode for this binding, indicating readability and writability.
					// 'write-only' is always support, 'read-write' and 'read-only' optionally
					access: read ? write ? "read-write" : "read-only" : "write-only",
					// The required format of texture views bound to this binding.
					format: gpuTextureFormats[format],
					// Indicates the required dimension for texture views bound to this binding.
					// "1d", "2d", "2d-array", "cube", "cube-array", "3d"
					viewDimension: textureDimension
				}
			});
		});
		bindGroupFormat.storageBufferFormats.forEach((bufferFormat) => {
			const readOnly = bufferFormat.readOnly;
			const visibility = WebgpuUtils.shaderStage(bufferFormat.visibility);
			key += `#${bufferFormat.slot}SB:${visibility}-${readOnly ? "ro" : "rw"}`;
			entries.push({
				binding: bufferFormat.slot,
				visibility,
				buffer: {
					// "storage", "read-only-storage"
					type: readOnly ? "read-only-storage" : "storage"
				}
			});
		});
		const desc = {
			entries
		};
		return {
			key,
			desc
		};
	}
};

var WebgpuBuffer = class {
	buffer = null;
	usageFlags = 0;
	constructor(usageFlags = 0) {
		this.usageFlags = usageFlags;
	}
	destroy(device) {
		if (this.buffer) {
			device.deferDestroy(this.buffer);
			this.buffer = null;
		}
	}
	get initialized() {
		return !!this.buffer;
	}
	loseContext() {
		this.buffer = null;
	}
	allocate(device, size) {
		this.buffer = device.wgpu.createBuffer({
			size,
			usage: this.usageFlags
		});
	}
	unlock(device, storage) {
		const wgpu = device.wgpu;
		if (!this.buffer) {
			const size = storage.byteLength + 3 & ~3;
			this.usageFlags |= GPUBufferUsage.COPY_DST;
			this.allocate(device, size);
		}
		const srcOffset = storage.byteOffset ?? 0;
		const srcData = new Uint8Array(storage.buffer ?? storage, srcOffset, storage.byteLength);
		const data2 = new Uint8Array(this.buffer.size);
		data2.set(srcData);
		wgpu.queue.writeBuffer(this.buffer, 0, data2, 0, data2.length);
	}
	read(device, offset3, size, data2, immediate) {
		return device.readStorageBuffer(this, offset3, size, data2, immediate);
	}
	write(device, bufferOffset, data2, dataOffset, size) {
		device.writeStorageBuffer(this, bufferOffset, data2, dataOffset, size);
	}
	clear(device, offset3, size) {
		device.clearStorageBuffer(this, offset3, size);
	}
};

var WebgpuIndexBuffer = class extends WebgpuBuffer {
	format = null;
	constructor(indexBuffer, options2) {
		super(BUFFERUSAGE_INDEX | (options2?.storage ? BUFFERUSAGE_STORAGE : 0));
		this.format = indexBuffer.format === INDEXFORMAT_UINT16 ? "uint16" : "uint32";
	}
	unlock(indexBuffer) {
		const device = indexBuffer.device;
		super.unlock(device, indexBuffer.storage);
	}
};

var array = {
	// helper function to compare two arrays for equality
	equals(arr1, arr2) {
		if (arr1.length !== arr2.length) {
			return false;
		}
		for (let i2 = 0; i2 < arr1.length; i2++) {
			if (arr1[i2] !== arr2[i2]) {
				return false;
			}
		}
		return true;
	}
};

var gpuVertexFormats = [];
gpuVertexFormats[TYPE_INT8] = "sint8";
gpuVertexFormats[TYPE_UINT8] = "uint8";
gpuVertexFormats[TYPE_INT16] = "sint16";
gpuVertexFormats[TYPE_UINT16] = "uint16";
gpuVertexFormats[TYPE_INT32] = "sint32";
gpuVertexFormats[TYPE_UINT32] = "uint32";
gpuVertexFormats[TYPE_FLOAT32] = "float32";
gpuVertexFormats[TYPE_FLOAT16] = "float16";
var gpuVertexFormatsNormalized = [];
gpuVertexFormatsNormalized[TYPE_INT8] = "snorm8";
gpuVertexFormatsNormalized[TYPE_UINT8] = "unorm8";
gpuVertexFormatsNormalized[TYPE_INT16] = "snorm16";
gpuVertexFormatsNormalized[TYPE_UINT16] = "unorm16";
gpuVertexFormatsNormalized[TYPE_INT32] = "sint32";
gpuVertexFormatsNormalized[TYPE_UINT32] = "uint32";
gpuVertexFormatsNormalized[TYPE_FLOAT32] = "float32";
gpuVertexFormatsNormalized[TYPE_FLOAT16] = "float16";
var WebgpuVertexBufferLayout = class {
	cache = /* @__PURE__ */ new Map();
	get(vertexFormat0, vertexFormat1 = null) {
		const key = this.getKey(vertexFormat0, vertexFormat1);
		let layout = this.cache.get(key);
		if (!layout) {
			layout = this.create(vertexFormat0, vertexFormat1);
			this.cache.set(key, layout);
		}
		return layout;
	}
	getKey(vertexFormat0, vertexFormat1 = null) {
		return `${vertexFormat0?.renderingHashString}-${vertexFormat1?.renderingHashString}`;
	}
	create(vertexFormat0, vertexFormat1) {
		const layout = [];
		const addFormat = (format) => {
			const interleaved = format.interleaved;
			const stepMode = format.instancing ? "instance" : "vertex";
			let attributes = [];
			const elementCount = format.elements.length;
			for (let i2 = 0; i2 < elementCount; i2++) {
				const element = format.elements[i2];
				const location = semanticToLocation[element.name];
				const formatTable = element.normalize ? gpuVertexFormatsNormalized : gpuVertexFormats;
				attributes.push({
					shaderLocation: location,
					offset: interleaved ? element.offset : 0,
					format: `${formatTable[element.dataType]}${element.numComponents > 1 ? `x${element.numComponents}` : ""}`
				});
				if (!interleaved || i2 === elementCount - 1) {
					layout.push({
						attributes,
						arrayStride: element.stride,
						stepMode
					});
					attributes = [];
				}
			}
		};
		if (vertexFormat0) {
			addFormat(vertexFormat0);
		}
		if (vertexFormat1) {
			addFormat(vertexFormat1);
		}
		return layout;
	}
};

var _layoutId = 0;
var WebgpuPipeline = class {
	constructor(device) {
		this.device = device;
	}
	// TODO: this could be cached using bindGroupKey
	getPipelineLayout(bindGroupFormats) {
		const bindGroupLayouts = [];
		bindGroupFormats.forEach((format) => {
			bindGroupLayouts.push(format.bindGroupLayout);
		});
		const desc = {
			bindGroupLayouts
		};
		_layoutId++;
		const pipelineLayout = this.device.wgpu.createPipelineLayout(desc);
		return pipelineLayout;
	}
};

var _pipelineId = 0;
var _primitiveTopology = [
	"point-list",
	// PRIMITIVE_POINTS
	"line-list",
	// PRIMITIVE_LINES
	void 0,
	// PRIMITIVE_LINELOOP
	"line-strip",
	// PRIMITIVE_LINESTRIP
	"triangle-list",
	// PRIMITIVE_TRIANGLES
	"triangle-strip",
	// PRIMITIVE_TRISTRIP
	void 0
	// PRIMITIVE_TRIFAN
];
var _blendOperation = [
	"add",
	// BLENDEQUATION_ADD
	"subtract",
	// BLENDEQUATION_SUBTRACT
	"reverse-subtract",
	// BLENDEQUATION_REVERSE_SUBTRACT
	"min",
	// BLENDEQUATION_MIN
	"max"
	// BLENDEQUATION_MAX
];
var _blendFactor = [
	"zero",
	// BLENDMODE_ZERO
	"one",
	// BLENDMODE_ONE
	"src",
	// BLENDMODE_SRC_COLOR
	"one-minus-src",
	// BLENDMODE_ONE_MINUS_SRC_COLOR
	"dst",
	// BLENDMODE_DST_COLOR
	"one-minus-dst",
	// BLENDMODE_ONE_MINUS_DST_COLOR
	"src-alpha",
	// BLENDMODE_SRC_ALPHA
	"src-alpha-saturated",
	// BLENDMODE_SRC_ALPHA_SATURATE
	"one-minus-src-alpha",
	// BLENDMODE_ONE_MINUS_SRC_ALPHA
	"dst-alpha",
	// BLENDMODE_DST_ALPHA
	"one-minus-dst-alpha",
	// BLENDMODE_ONE_MINUS_DST_ALPHA
	"constant",
	// BLENDMODE_CONSTANT
	"one-minus-constant"
	// BLENDMODE_ONE_MINUS_CONSTANT
];
var _compareFunction = [
	"never",
	// FUNC_NEVER
	"less",
	// FUNC_LESS
	"equal",
	// FUNC_EQUAL
	"less-equal",
	// FUNC_LESSEQUAL
	"greater",
	// FUNC_GREATER
	"not-equal",
	// FUNC_NOTEQUAL
	"greater-equal",
	// FUNC_GREATEREQUAL
	"always"
	// FUNC_ALWAYS
];
var _cullModes = [
	"none",
	// CULLFACE_NONE
	"back",
	// CULLFACE_BACK
	"front"
	// CULLFACE_FRONT
];
var _frontFace = [
	"ccw",
	// FRONTFACE_CCW
	"cw"
	// FRONTFACE_CW
];
var _stencilOps = [
	"keep",
	// STENCILOP_KEEP
	"zero",
	// STENCILOP_ZERO
	"replace",
	// STENCILOP_REPLACE
	"increment-clamp",
	// STENCILOP_INCREMENT
	"increment-wrap",
	// STENCILOP_INCREMENTWRAP
	"decrement-clamp",
	// STENCILOP_DECREMENT
	"decrement-wrap",
	// STENCILOP_DECREMENTWRAP
	"invert"
	// STENCILOP_INVERT
];
var _indexFormat = [
	"",
	// INDEXFORMAT_UINT8
	"uint16",
	// INDEXFORMAT_UINT16
	"uint32"
	// INDEXFORMAT_UINT32
];
var CacheEntry = class {
	pipeline;
	hashes;
};
var WebgpuRenderPipeline = class extends WebgpuPipeline {
	lookupHashes = new Uint32Array(15);
	constructor(device) {
		super(device);
		this.vertexBufferLayout = new WebgpuVertexBufferLayout();
		this.cache = /* @__PURE__ */ new Map();
	}
	get(primitive2, vertexFormat0, vertexFormat1, ibFormat, shader, renderTarget, bindGroupFormats, blendState, depthState, cullMode, stencilEnabled, stencilFront, stencilBack, frontFace) {
		const primitiveType = primitive2.type;
		if (ibFormat && primitiveType !== PRIMITIVE_LINESTRIP && primitiveType !== PRIMITIVE_TRISTRIP) {
			ibFormat = void 0;
		}
		const lookupHashes2 = this.lookupHashes;
		lookupHashes2[0] = primitiveType;
		lookupHashes2[1] = shader.id;
		lookupHashes2[2] = cullMode;
		lookupHashes2[3] = depthState.key;
		lookupHashes2[4] = blendState.key;
		lookupHashes2[5] = vertexFormat0?.renderingHash ?? 0;
		lookupHashes2[6] = vertexFormat1?.renderingHash ?? 0;
		lookupHashes2[7] = renderTarget.impl.key;
		lookupHashes2[8] = bindGroupFormats[0]?.key ?? 0;
		lookupHashes2[9] = bindGroupFormats[1]?.key ?? 0;
		lookupHashes2[10] = bindGroupFormats[2]?.key ?? 0;
		lookupHashes2[11] = stencilEnabled ? stencilFront.key : 0;
		lookupHashes2[12] = stencilEnabled ? stencilBack.key : 0;
		lookupHashes2[13] = ibFormat ?? 0;
		lookupHashes2[14] = frontFace;
		const hash = hash32Fnv1a(lookupHashes2);
		let cacheEntries = this.cache.get(hash);
		if (cacheEntries) {
			for (let i2 = 0; i2 < cacheEntries.length; i2++) {
				const entry = cacheEntries[i2];
				if (array.equals(entry.hashes, lookupHashes2)) {
					return entry.pipeline;
				}
			}
		}
		const primitiveTopology = _primitiveTopology[primitiveType];
		const pipelineLayout = this.getPipelineLayout(bindGroupFormats);
		const vertexBufferLayout = this.vertexBufferLayout.get(vertexFormat0, vertexFormat1);
		const cacheEntry = new CacheEntry();
		cacheEntry.hashes = new Uint32Array(lookupHashes2);
		cacheEntry.pipeline = this.create(
			primitiveTopology,
			ibFormat,
			shader,
			renderTarget,
			pipelineLayout,
			blendState,
			depthState,
			vertexBufferLayout,
			cullMode,
			stencilEnabled,
			stencilFront,
			stencilBack,
			frontFace
		);
		if (cacheEntries) {
			cacheEntries.push(cacheEntry);
		} else {
			cacheEntries = [cacheEntry];
		}
		this.cache.set(hash, cacheEntries);
		return cacheEntry.pipeline;
	}
	getBlend(blendState) {
		let blend;
		if (blendState.blend) {
			blend = {
				color: {
					operation: _blendOperation[blendState.colorOp],
					srcFactor: _blendFactor[blendState.colorSrcFactor],
					dstFactor: _blendFactor[blendState.colorDstFactor]
				},
				alpha: {
					operation: _blendOperation[blendState.alphaOp],
					srcFactor: _blendFactor[blendState.alphaSrcFactor],
					dstFactor: _blendFactor[blendState.alphaDstFactor]
				}
			};
		}
		return blend;
	}
	getDepthStencil(depthState, renderTarget, stencilEnabled, stencilFront, stencilBack, primitiveTopology) {
		let depthStencil;
		const { depth, stencil } = renderTarget;
		if (depth || stencil) {
			depthStencil = {
				format: renderTarget.impl.depthAttachment.format
			};
			if (depth) {
				depthStencil.depthWriteEnabled = depthState.write;
				depthStencil.depthCompare = _compareFunction[depthState.func];
				const biasAllowed = primitiveTopology === "triangle-list" || primitiveTopology === "triangle-strip";
				depthStencil.depthBias = biasAllowed ? depthState.depthBias : 0;
				depthStencil.depthBiasSlopeScale = biasAllowed ? depthState.depthBiasSlope : 0;
			} else {
				depthStencil.depthWriteEnabled = false;
				depthStencil.depthCompare = "always";
			}
			if (stencil && stencilEnabled) {
				depthStencil.stencilReadMas = stencilFront.readMask;
				depthStencil.stencilWriteMask = stencilFront.writeMask;
				depthStencil.stencilFront = {
					compare: _compareFunction[stencilFront.func],
					failOp: _stencilOps[stencilFront.fail],
					passOp: _stencilOps[stencilFront.zpass],
					depthFailOp: _stencilOps[stencilFront.zfail]
				};
				depthStencil.stencilBack = {
					compare: _compareFunction[stencilBack.func],
					failOp: _stencilOps[stencilBack.fail],
					passOp: _stencilOps[stencilBack.zpass],
					depthFailOp: _stencilOps[stencilBack.zfail]
				};
			}
		}
		return depthStencil;
	}
	create(primitiveTopology, ibFormat, shader, renderTarget, pipelineLayout, blendState, depthState, vertexBufferLayout, cullMode, stencilEnabled, stencilFront, stencilBack, frontFace) {
		const wgpu = this.device.wgpu;
		const webgpuShader = shader.impl;
		const desc = {
			vertex: {
				module: webgpuShader.getVertexShaderModule(),
				entryPoint: webgpuShader.vertexEntryPoint,
				buffers: vertexBufferLayout
			},
			primitive: {
				topology: primitiveTopology,
				frontFace: _frontFace[frontFace],
				cullMode: _cullModes[cullMode]
			},
			depthStencil: this.getDepthStencil(depthState, renderTarget, stencilEnabled, stencilFront, stencilBack, primitiveTopology),
			multisample: {
				count: renderTarget.samples
			},
			// uniform / texture binding layout
			layout: pipelineLayout
		};
		if (ibFormat) {
			desc.primitive.stripIndexFormat = _indexFormat[ibFormat];
		}
		desc.fragment = {
			module: webgpuShader.getFragmentShaderModule(),
			entryPoint: webgpuShader.fragmentEntryPoint,
			targets: []
		};
		const colorAttachments = renderTarget.impl.colorAttachments;
		if (colorAttachments.length > 0) {
			let writeMask = 0;
			if (blendState.redWrite) writeMask |= GPUColorWrite.RED;
			if (blendState.greenWrite) writeMask |= GPUColorWrite.GREEN;
			if (blendState.blueWrite) writeMask |= GPUColorWrite.BLUE;
			if (blendState.alphaWrite) writeMask |= GPUColorWrite.ALPHA;
			const blend = this.getBlend(blendState);
			colorAttachments.forEach((attachment) => {
				desc.fragment.targets.push({
					format: attachment.format,
					writeMask,
					blend
				});
			});
		}
		_pipelineId++;
		const pipeline = wgpu.createRenderPipeline(desc);
		return pipeline;
	}
};

var _pipelineId2 = 0;
var CacheEntry2 = class {
	pipeline = null;
	hashes = null;
};
var WebgpuComputePipeline = class extends WebgpuPipeline {
	// shader compute key + up to 2 bind group format keys (caller group 0 + reflected group)
	lookupHashes = new Uint32Array(3);
	cache = /* @__PURE__ */ new Map();
	get(shader, bindGroupFormats) {
		const lookupHashes2 = this.lookupHashes;
		lookupHashes2[0] = shader.impl.computeKey;
		lookupHashes2[1] = bindGroupFormats[0] ? bindGroupFormats[0].impl.key : 0;
		lookupHashes2[2] = bindGroupFormats[1] ? bindGroupFormats[1].impl.key : 0;
		const hash = hash32Fnv1a(lookupHashes2);
		let cacheEntries = this.cache.get(hash);
		if (cacheEntries) {
			for (let i2 = 0; i2 < cacheEntries.length; i2++) {
				const entry = cacheEntries[i2];
				if (array.equals(entry.hashes, lookupHashes2)) {
					return entry.pipeline;
				}
			}
		}
		const impls = [];
		if (bindGroupFormats[0]) impls.push(bindGroupFormats[0].impl);
		if (bindGroupFormats[1]) impls.push(bindGroupFormats[1].impl);
		const pipelineLayout = this.getPipelineLayout(impls);
		const cacheEntry = new CacheEntry2();
		cacheEntry.hashes = new Uint32Array(lookupHashes2);
		cacheEntry.pipeline = this.create(shader, pipelineLayout);
		if (cacheEntries) {
			cacheEntries.push(cacheEntry);
		} else {
			cacheEntries = [cacheEntry];
		}
		this.cache.set(hash, cacheEntries);
		return cacheEntry.pipeline;
	}
	create(shader, pipelineLayout) {
		const wgpu = this.device.wgpu;
		const webgpuShader = shader.impl;
		const desc = {
			compute: {
				module: webgpuShader.getComputeShaderModule(),
				entryPoint: webgpuShader.computeEntryPoint
			},
			// uniform / texture binding layout
			layout: pipelineLayout
		};
		_pipelineId2++;
		const pipeline = wgpu.createComputePipeline(desc);
		return pipeline;
	}
};

var RefCountedObject = class {
	_refCount = 0;
	incRefCount() {
		this._refCount++;
	}
	decRefCount() {
		this._refCount--;
	}
	get refCount() {
		return this._refCount;
	}
};

var Entry = class extends RefCountedObject {
	object;
	constructor(obj) {
		super();
		this.object = obj;
		this.incRefCount();
	}
};
var RefCountedKeyCache = class {
	cache = /* @__PURE__ */ new Map();
	destroy() {
		this.cache.forEach((entry) => {
			entry.object?.destroy();
		});
		this.cache.clear();
	}
	clear() {
		this.cache.clear();
	}
	get(key) {
		const entry = this.cache.get(key);
		if (entry) {
			entry.incRefCount();
			return entry.object;
		}
		return null;
	}
	set(key, object) {
		this.cache.set(key, new Entry(object));
	}
	release(key) {
		const entry = this.cache.get(key);
		if (entry) {
			entry.decRefCount();
			if (entry.refCount === 0) {
				this.cache.delete(key);
				entry.object?.destroy();
			}
		} else {
		}
	}
};

var MultisampledTextureCache = class extends RefCountedKeyCache {
	loseContext(device) {
		this.clear();
	}
};
var multisampledTextureCache = new DeviceCache();
var getMultisampledTextureCache = (device) => {
	return multisampledTextureCache.get(device, () => {
		return new MultisampledTextureCache();
	});
};

var stringIds6 = new StringIds();
var ColorAttachment = class {
	format;
	multisampledBuffer;
	transient = false;
	destroy(device) {
		device.deferDestroy(this.multisampledBuffer);
		this.multisampledBuffer = null;
	}
};
var DepthAttachment = class {
	format;
	hasStencil;
	depthTexture = null;
	depthTextureInternal = false;
	multisampledDepthBuffer = null;
	multisampledDepthBufferKey;
	transient = false;
	constructor(gpuFormat) {
		this.format = gpuFormat;
		this.hasStencil = gpuFormat === "depth24plus-stencil8";
	}
	destroy(device) {
		if (this.depthTextureInternal) {
			device.deferDestroy(this.depthTexture);
			this.depthTexture = null;
		}
		if (this.multisampledDepthBuffer) {
			this.multisampledDepthBuffer = null;
			getMultisampledTextureCache(device).release(this.multisampledDepthBufferKey);
		}
	}
};
var WebgpuRenderTarget = class {
	initialized = false;
	key;
	colorAttachments = [];
	depthAttachment = null;
	assignedColorTexture = null;
	renderPassDescriptor = {};
	isBackbuffer = false;
	constructor(renderTarget) {
		this.renderTarget = renderTarget;
	}
	destroy(device) {
		this.initialized = false;
		this.assignedColorTexture = null;
		this.colorAttachments.forEach((colorAttachment) => {
			colorAttachment.destroy(device);
		});
		this.colorAttachments.length = 0;
		this.depthAttachment?.destroy(device);
		this.depthAttachment = null;
	}
	updateKey() {
		const rt = this.renderTarget;
		let key = `${rt.samples}:${this.depthAttachment ? this.depthAttachment.format : "nodepth"}`;
		this.colorAttachments.forEach((colorAttachment) => {
			key += `:${colorAttachment.format}`;
		});
		this.key = stringIds6.get(key);
	}
	assignColorTexture(gpuTexture, viewFormat) {
		this.assignedColorTexture = gpuTexture;
		const wgpuDevice = this.renderTarget.device;
		const xrViewDesc = wgpuDevice?.xrColorTextureViewDescriptor;
		const xrSlice = xrViewDesc && gpuTexture === wgpuDevice.xrColorTexture;
		const view = gpuTexture.createView(
			xrSlice ? xrViewDesc : { format: viewFormat }
		);
		const colorAttachment = this.renderPassDescriptor.colorAttachments[0];
		const samples = this.renderTarget.samples;
		if (samples > 1) {
			colorAttachment.resolveTarget = view;
		} else {
			colorAttachment.view = view;
		}
		this.setColorAttachment(0, void 0, viewFormat);
		this.updateKey();
	}
	setColorAttachment(index, multisampledBuffer, format) {
		if (!this.colorAttachments[index]) {
			this.colorAttachments[index] = new ColorAttachment();
		}
		if (multisampledBuffer) {
			this.colorAttachments[index].multisampledBuffer = multisampledBuffer;
		}
		if (format) {
			this.colorAttachments[index].format = format;
		}
	}
	init(device, renderTarget) {
		const wgpu = device.wgpu;
		this.initDepthStencil(device, wgpu, renderTarget);
		if (renderTarget._colorBuffers) {
			renderTarget._colorBuffers.forEach((colorBuffer, index) => {
				this.setColorAttachment(index, void 0, colorBuffer.impl.format);
			});
		}
		this.renderPassDescriptor.colorAttachments = [];
		const count = this.isBackbuffer ? 1 : renderTarget._colorBuffers?.length ?? 0;
		for (let i2 = 0; i2 < count; ++i2) {
			const colorAttachment = this.initColor(device, wgpu, renderTarget, i2);
			const isDefaultFramebuffer = i2 === 0 && this.colorAttachments[0]?.format;
			if (colorAttachment.view || isDefaultFramebuffer) {
				this.renderPassDescriptor.colorAttachments.push(colorAttachment);
			}
		}
		this.updateKey();
		this.initialized = true;
	}
	initDepthStencil(device, wgpu, renderTarget) {
		const { samples, width, height, depth, depthBuffer } = renderTarget;
		if (depth || depthBuffer) {
			let renderingView;
			if (!depthBuffer) {
				this.depthAttachment = new DepthAttachment("depth24plus-stencil8");
				const depthTextureDesc = {
					size: [width, height, 1],
					dimension: "2d",
					sampleCount: samples,
					format: this.depthAttachment.format,
					usage: GPUTextureUsage.RENDER_ATTACHMENT
				};
				const transientDepth = renderTarget.transientDepth;
				if (transientDepth) {
					depthTextureDesc.usage |= GPUTextureUsage.TRANSIENT_ATTACHMENT;
					this.depthAttachment.transient = true;
				} else if (samples > 1) {
					depthTextureDesc.usage |= GPUTextureUsage.TEXTURE_BINDING;
				} else {
					depthTextureDesc.usage |= GPUTextureUsage.COPY_SRC;
				}
				const depthTexture = wgpu.createTexture(depthTextureDesc);
				this.depthAttachment.depthTexture = depthTexture;
				this.depthAttachment.depthTextureInternal = true;
				renderingView = depthTexture.createView();
			} else {
				this.depthAttachment = new DepthAttachment(depthBuffer.impl.format);
				if (samples > 1) {
					const depthFormat = "depth24plus-stencil8";
					this.depthAttachment.format = depthFormat;
					this.depthAttachment.hasStencil = depthFormat === "depth24plus-stencil8";
					const key = `${depthBuffer.id}:${width}:${height}:${samples}:${depthFormat}`;
					const msTextures = getMultisampledTextureCache(device);
					let msDepthTexture = msTextures.get(key);
					if (!msDepthTexture) {
						const multisampledDepthDesc = {
							size: [width, height, 1],
							dimension: "2d",
							sampleCount: samples,
							format: depthFormat,
							usage: GPUTextureUsage.RENDER_ATTACHMENT | // if msaa and resolve targets are different formats, we need to be able to bind the msaa target as a texture for manual shader resolve
							(depthFormat !== depthBuffer.impl.format ? GPUTextureUsage.TEXTURE_BINDING : 0)
						};
						msDepthTexture = wgpu.createTexture(multisampledDepthDesc);
						msTextures.set(key, msDepthTexture);
					}
					this.depthAttachment.multisampledDepthBuffer = msDepthTexture;
					this.depthAttachment.multisampledDepthBufferKey = key;
					renderingView = msDepthTexture.createView();
				} else {
					const depthTexture = depthBuffer.impl.gpuTexture;
					this.depthAttachment.depthTexture = depthTexture;
					renderingView = depthTexture.createView();
				}
			}
			this.renderPassDescriptor.depthStencilAttachment = {
				view: renderingView
			};
		}
	}
	initColor(device, wgpu, renderTarget, index) {
		const colorAttachment = {};
		const { samples, width, height, mipLevel } = renderTarget;
		const colorBuffer = renderTarget.getColorBuffer(index);
		let colorView = null;
		if (colorBuffer) {
			const mipLevelCount = 1;
			if (colorBuffer.cubemap) {
				colorView = colorBuffer.impl.createView({
					dimension: "2d",
					baseArrayLayer: renderTarget.face,
					arrayLayerCount: 1,
					mipLevelCount,
					baseMipLevel: mipLevel
				});
			} else {
				colorView = colorBuffer.impl.createView({
					mipLevelCount,
					baseMipLevel: mipLevel
				});
			}
		}
		if (samples > 1) {
			const format = this.isBackbuffer ? this.colorAttachments[index]?.format ?? device.backBufferViewFormat : colorBuffer.impl.format;
			const transientColor = renderTarget.transientColor;
			const multisampledTextureDesc = {
				size: [width, height, 1],
				dimension: "2d",
				sampleCount: samples,
				format,
				usage: transientColor ? GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TRANSIENT_ATTACHMENT : GPUTextureUsage.RENDER_ATTACHMENT
			};
			const multisampledColorBuffer = wgpu.createTexture(multisampledTextureDesc);
			this.setColorAttachment(index, multisampledColorBuffer, multisampledTextureDesc.format);
			this.colorAttachments[index].transient = transientColor;
			colorAttachment.view = multisampledColorBuffer.createView();
			colorAttachment.resolveTarget = colorView;
		} else {
			colorAttachment.view = colorView;
		}
		return colorAttachment;
	}
	setupForRenderPass(renderPass, renderTarget) {
		const count = this.renderPassDescriptor.colorAttachments?.length ?? 0;
		for (let i2 = 0; i2 < count; ++i2) {
			const colorAttachment = this.renderPassDescriptor.colorAttachments[i2];
			const colorOps = renderPass.colorArrayOps[i2];
			const srgb = renderTarget.isColorBufferSrgb(i2);
			colorAttachment.clearValue = srgb ? colorOps.clearValueLinear : colorOps.clearValue;
			colorAttachment.loadOp = colorOps.clear ? "clear" : "load";
			colorAttachment.storeOp = colorOps.store ? "store" : "discard";
			if (this.colorAttachments[i2]?.transient && (colorAttachment.loadOp !== "clear" || colorAttachment.storeOp !== "discard")) {
				colorAttachment.loadOp = "clear";
				colorAttachment.storeOp = "discard";
			}
		}
		const depthAttachment = this.renderPassDescriptor.depthStencilAttachment;
		if (depthAttachment) {
			depthAttachment.depthClearValue = renderPass.depthStencilOps.clearDepthValue;
			depthAttachment.depthLoadOp = renderPass.depthStencilOps.clearDepth ? "clear" : "load";
			depthAttachment.depthStoreOp = renderPass.depthStencilOps.storeDepth ? "store" : "discard";
			depthAttachment.depthReadOnly = false;
			if (this.depthAttachment.hasStencil) {
				depthAttachment.stencilClearValue = renderPass.depthStencilOps.clearStencilValue;
				depthAttachment.stencilLoadOp = renderPass.depthStencilOps.clearStencil ? "clear" : "load";
				depthAttachment.stencilStoreOp = renderPass.depthStencilOps.storeStencil ? "store" : "discard";
				depthAttachment.stencilReadOnly = false;
			}
			if (this.depthAttachment.transient && (depthAttachment.depthLoadOp !== "clear" || depthAttachment.depthStoreOp !== "discard" || this.depthAttachment.hasStencil && (depthAttachment.stencilLoadOp !== "clear" || depthAttachment.stencilStoreOp !== "discard"))) {
				depthAttachment.depthLoadOp = "clear";
				depthAttachment.depthStoreOp = "discard";
				if (this.depthAttachment.hasStencil) {
					depthAttachment.stencilLoadOp = "clear";
					depthAttachment.stencilStoreOp = "discard";
				}
			}
		}
	}
	loseContext() {
		this.initialized = false;
	}
	resolve(device, target2, color3, depth) {
	}
};

var uniformTypeToNumComponents = [];
uniformTypeToNumComponents[UNIFORMTYPE_FLOAT] = 1;
uniformTypeToNumComponents[UNIFORMTYPE_VEC2] = 2;
uniformTypeToNumComponents[UNIFORMTYPE_VEC3] = 3;
uniformTypeToNumComponents[UNIFORMTYPE_VEC4] = 4;
uniformTypeToNumComponents[UNIFORMTYPE_INT] = 1;
uniformTypeToNumComponents[UNIFORMTYPE_IVEC2] = 2;
uniformTypeToNumComponents[UNIFORMTYPE_IVEC3] = 3;
uniformTypeToNumComponents[UNIFORMTYPE_IVEC4] = 4;
uniformTypeToNumComponents[UNIFORMTYPE_BOOL] = 1;
uniformTypeToNumComponents[UNIFORMTYPE_BVEC2] = 2;
uniformTypeToNumComponents[UNIFORMTYPE_BVEC3] = 3;
uniformTypeToNumComponents[UNIFORMTYPE_BVEC4] = 4;
uniformTypeToNumComponents[UNIFORMTYPE_MAT2] = 8;
uniformTypeToNumComponents[UNIFORMTYPE_MAT3] = 12;
uniformTypeToNumComponents[UNIFORMTYPE_MAT4] = 16;
uniformTypeToNumComponents[UNIFORMTYPE_UINT] = 1;
uniformTypeToNumComponents[UNIFORMTYPE_UVEC2] = 2;
uniformTypeToNumComponents[UNIFORMTYPE_UVEC3] = 3;
uniformTypeToNumComponents[UNIFORMTYPE_UVEC4] = 4;
var UniformFormat = class {
	name;
	// UNIFORMTYPE_***
	type;
	byteSize;
	offset;
	scopeId;
	count;
	numComponents;
	get isArrayType() {
		return this.count > 0;
	}
	constructor(name, type, count = 0) {
		this.shortName = name;
		this.name = count ? `${name}[0]` : name;
		this.type = type;
		this.numComponents = uniformTypeToNumComponents[type];
		this.updateType = type;
		if (count > 0) {
			switch (type) {
				case UNIFORMTYPE_FLOAT:
					this.updateType = UNIFORMTYPE_FLOATARRAY;
					break;
				case UNIFORMTYPE_INT:
					this.updateType = UNIFORMTYPE_INTARRAY;
					break;
				case UNIFORMTYPE_UINT:
					this.updateType = UNIFORMTYPE_UINTARRAY;
					break;
				case UNIFORMTYPE_BOOL:
					this.updateType = UNIFORMTYPE_BOOLARRAY;
					break;
				case UNIFORMTYPE_VEC2:
					this.updateType = UNIFORMTYPE_VEC2ARRAY;
					break;
				case UNIFORMTYPE_IVEC2:
					this.updateType = UNIFORMTYPE_IVEC2ARRAY;
					break;
				case UNIFORMTYPE_UVEC2:
					this.updateType = UNIFORMTYPE_UVEC2ARRAY;
					break;
				case UNIFORMTYPE_BVEC2:
					this.updateType = UNIFORMTYPE_BVEC2ARRAY;
					break;
				case UNIFORMTYPE_VEC3:
					this.updateType = UNIFORMTYPE_VEC3ARRAY;
					break;
				case UNIFORMTYPE_IVEC3:
					this.updateType = UNIFORMTYPE_IVEC3ARRAY;
					break;
				case UNIFORMTYPE_UVEC3:
					this.updateType = UNIFORMTYPE_UVEC3ARRAY;
					break;
				case UNIFORMTYPE_BVEC3:
					this.updateType = UNIFORMTYPE_BVEC3ARRAY;
					break;
				case UNIFORMTYPE_VEC4:
					this.updateType = UNIFORMTYPE_VEC4ARRAY;
					break;
				case UNIFORMTYPE_IVEC4:
					this.updateType = UNIFORMTYPE_IVEC4ARRAY;
					break;
				case UNIFORMTYPE_UVEC4:
					this.updateType = UNIFORMTYPE_UVEC4ARRAY;
					break;
				case UNIFORMTYPE_BVEC4:
					this.updateType = UNIFORMTYPE_BVEC4ARRAY;
					break;
				case UNIFORMTYPE_MAT4:
					this.updateType = UNIFORMTYPE_MAT4ARRAY;
					break;
				default:
					break;
			}
		}
		this.count = count;
		let componentSize = this.numComponents;
		if (count) {
			componentSize = math.roundUp(componentSize, 4);
		}
		this.byteSize = componentSize * 4;
		if (count) {
			this.byteSize *= count;
		}
	}
	// std140 rules: https://registry.khronos.org/OpenGL/specs/gl/glspec45.core.pdf#page=159
	// TODO: this supports limited subset of functionality, arrays and arrays of structs are not supported.
	calculateOffset(offset3) {
		let alignment = this.byteSize <= 8 ? this.byteSize : 16;
		if (this.count) {
			alignment = 16;
		}
		offset3 = math.roundUp(offset3, alignment);
		this.offset = offset3 / 4;
	}
};
var UniformBufferFormat = class {
	byteSize = 0;
	map = /* @__PURE__ */ new Map();
	constructor(graphicsDevice, uniforms) {
		this.scope = graphicsDevice.scope;
		this.uniforms = uniforms;
		let offset3 = 0;
		for (let i2 = 0; i2 < uniforms.length; i2++) {
			const uniform = uniforms[i2];
			uniform.calculateOffset(offset3);
			offset3 = uniform.offset * 4 + uniform.byteSize;
			uniform.scopeId = this.scope.resolve(uniform.name);
			this.map.set(uniform.name, uniform);
		}
		this.byteSize = math.roundUp(offset3, 16);
	}
	get(name) {
		return this.map.get(name);
	}
};

var KEYWORD = /[ \t]*(\battribute\b|\bvarying\b|\buniform\b)/g;
var KEYWORD_LINE = /(\battribute\b|\bvarying\b|\bout\b|\buniform\b)[ \t]*([^;]+)(;+)/g;
var ARRAY_IDENTIFIER = /([\w-]+)\[(.*?)\]/;
var precisionQualifiers = /* @__PURE__ */ new Set(["highp", "mediump", "lowp"]);
var shadowSamplers = /* @__PURE__ */ new Set(["sampler2DShadow", "samplerCubeShadow", "sampler2DArrayShadow"]);
var textureDimensions = {
	sampler2D: TEXTUREDIMENSION_2D,
	sampler3D: TEXTUREDIMENSION_3D,
	samplerCube: TEXTUREDIMENSION_CUBE,
	samplerCubeShadow: TEXTUREDIMENSION_CUBE,
	sampler2DShadow: TEXTUREDIMENSION_2D,
	sampler2DArray: TEXTUREDIMENSION_2D_ARRAY,
	sampler2DArrayShadow: TEXTUREDIMENSION_2D_ARRAY,
	isampler2D: TEXTUREDIMENSION_2D,
	usampler2D: TEXTUREDIMENSION_2D,
	isampler3D: TEXTUREDIMENSION_3D,
	usampler3D: TEXTUREDIMENSION_3D,
	isamplerCube: TEXTUREDIMENSION_CUBE,
	usamplerCube: TEXTUREDIMENSION_CUBE,
	isampler2DArray: TEXTUREDIMENSION_2D_ARRAY,
	usampler2DArray: TEXTUREDIMENSION_2D_ARRAY
};
var textureDimensionInfo = {
	[TEXTUREDIMENSION_2D]: "texture2D",
	[TEXTUREDIMENSION_CUBE]: "textureCube",
	[TEXTUREDIMENSION_3D]: "texture3D",
	[TEXTUREDIMENSION_2D_ARRAY]: "texture2DArray"
};
var UniformLine = class {
	constructor(line, shader) {
		this.line = line;
		const words = line.trim().split(/\s+/);
		if (precisionQualifiers.has(words[0])) {
			this.precision = words.shift();
		}
		this.type = words.shift();
		if (line.includes(",")) {
		}
		if (line.includes("[")) {
			const rest = words.join(" ");
			const match = ARRAY_IDENTIFIER.exec(rest);
			this.name = match[1];
			this.arraySize = Number(match[2]);
			if (isNaN(this.arraySize)) {
				shader.failed = true;
			}
		} else {
			this.name = words.shift();
			this.arraySize = 0;
		}
		this.isSampler = this.type.indexOf("sampler") !== -1;
		this.isSignedInt = this.type.indexOf("isampler") !== -1;
		this.isUnsignedInt = this.type.indexOf("usampler") !== -1;
	}
};
var ShaderProcessorGLSL = class _ShaderProcessorGLSL {
	static MARKER = "@@@";
	static run(device, shaderDefinition, shader) {
		const varyingMap = /* @__PURE__ */ new Map();
		const vertexExtracted = _ShaderProcessorGLSL.extract(shaderDefinition.vshader);
		const fragmentExtracted = _ShaderProcessorGLSL.extract(shaderDefinition.fshader);
		const attributesMap = /* @__PURE__ */ new Map();
		const attributesBlock = _ShaderProcessorGLSL.processAttributes(vertexExtracted.attributes, shaderDefinition.attributes, attributesMap, shaderDefinition.processingOptions);
		const vertexVaryingsBlock = _ShaderProcessorGLSL.processVaryings(vertexExtracted.varyings, varyingMap, true);
		const fragmentVaryingsBlock = _ShaderProcessorGLSL.processVaryings(fragmentExtracted.varyings, varyingMap, false);
		const outBlock = _ShaderProcessorGLSL.processOuts(fragmentExtracted.outs);
		const concatUniforms = vertexExtracted.uniforms.concat(fragmentExtracted.uniforms);
		const uniforms = Array.from(new Set(concatUniforms));
		const parsedUniforms = uniforms.map((line) => new UniformLine(line, shader));
		const uniformsData = _ShaderProcessorGLSL.processUniforms(device, parsedUniforms, shaderDefinition.processingOptions, shader);
		const vBlock = `${attributesBlock}
${vertexVaryingsBlock}
${uniformsData.code}`;
		const vshader = vertexExtracted.src.replace(_ShaderProcessorGLSL.MARKER, vBlock);
		const fBlock = `${fragmentVaryingsBlock}
${outBlock}
${uniformsData.code}`;
		const fshader = fragmentExtracted.src.replace(_ShaderProcessorGLSL.MARKER, fBlock);
		return {
			vshader,
			fshader,
			attributes: attributesMap,
			meshUniformBufferFormat: uniformsData.meshUniformBufferFormat,
			meshBindGroupFormat: uniformsData.meshBindGroupFormat
		};
	}
	// Extract required information from the shader source code. When uniformsOnly is true, only
	// 'uniform' lines are extracted - attributes and varyings are left in the source unchanged (the
	// WebGL2 path relies on the gles3 compatibility macros to handle those).
	static extract(src, uniformsOnly = false) {
		const attributes = [];
		const varyings = [];
		const outs = [];
		const uniforms = [];
		let replacement = `${_ShaderProcessorGLSL.MARKER}
`;
		let match;
		while ((match = KEYWORD.exec(src)) !== null) {
			const keyword = match[1];
			if (uniformsOnly && keyword !== "uniform") {
				continue;
			}
			switch (keyword) {
				case "attribute":
				case "varying":
				case "uniform":
				case "out": {
					KEYWORD_LINE.lastIndex = match.index;
					const lineMatch = KEYWORD_LINE.exec(src);
					if (keyword === "attribute") {
						attributes.push(lineMatch[2]);
					} else if (keyword === "varying") {
						varyings.push(lineMatch[2]);
					} else if (keyword === "out") {
						outs.push(lineMatch[2]);
					} else if (keyword === "uniform") {
						uniforms.push(lineMatch[2]);
					}
					src = _ShaderProcessorGLSL.cutOut(src, match.index, KEYWORD_LINE.lastIndex, replacement);
					KEYWORD.lastIndex = match.index + replacement.length;
					replacement = "";
					break;
				}
			}
		}
		return {
			src,
			attributes,
			varyings,
			outs,
			uniforms
		};
	}
	static parseUniformLines(uniformLines, shader) {
		return uniformLines.map((line) => new UniformLine(line, shader));
	}
	static processUniforms(device, uniforms, processingOptions, shader) {
		const uniformLinesSamplers = [];
		const uniformLinesNonSamplers = [];
		uniforms.forEach((uniform) => {
			if (uniform.isSampler) {
				uniformLinesSamplers.push(uniform);
			} else {
				uniformLinesNonSamplers.push(uniform);
			}
		});
		const meshUniforms = [];
		uniformLinesNonSamplers.forEach((uniform) => {
			if (!processingOptions.hasUniform(uniform.name)) {
				const uniformType = uniformTypeToName.indexOf(uniform.type);
				const uniformFormat = new UniformFormat(uniform.name, uniformType, uniform.arraySize);
				meshUniforms.push(uniformFormat);
			}
		});
		if (meshUniforms.length === 0) {
			meshUniforms.push(new UniformFormat(UNUSED_UNIFORM_NAME, UNIFORMTYPE_FLOAT));
		}
		const meshUniformBufferFormat = meshUniforms.length ? new UniformBufferFormat(device, meshUniforms) : null;
		const textureFormats = [];
		uniformLinesSamplers.forEach((uniform) => {
			if (!processingOptions.hasTexture(uniform.name)) {
				let sampleType = SAMPLETYPE_FLOAT;
				if (uniform.isSignedInt) {
					sampleType = SAMPLETYPE_INT;
				} else if (uniform.isUnsignedInt) {
					sampleType = SAMPLETYPE_UINT;
				} else {
					if (uniform.precision === "highp") {
						sampleType = SAMPLETYPE_UNFILTERABLE_FLOAT;
					}
					if (shadowSamplers.has(uniform.type)) {
						sampleType = SAMPLETYPE_DEPTH;
					}
				}
				const dimension = textureDimensions[uniform.type];
				textureFormats.push(new BindTextureFormat(uniform.name, SHADERSTAGE_VERTEX | SHADERSTAGE_FRAGMENT, dimension, sampleType));
			}
		});
		const meshBindGroupFormat = new BindGroupFormat(device, textureFormats);
		let code = "";
		processingOptions.uniformFormats.forEach((format, bindGroupIndex) => {
			if (format) {
				code += _ShaderProcessorGLSL.getUniformShaderDeclaration(format, bindGroupIndex, 0);
			}
		});
		if (meshUniformBufferFormat) {
			code += _ShaderProcessorGLSL.getUniformShaderDeclaration(meshUniformBufferFormat, BINDGROUP_MESH_UB, 0);
		}
		processingOptions.bindGroupFormats.forEach((format, bindGroupIndex) => {
			if (format) {
				code += _ShaderProcessorGLSL.getTexturesShaderDeclaration(format, bindGroupIndex);
			}
		});
		code += _ShaderProcessorGLSL.getTexturesShaderDeclaration(meshBindGroupFormat, BINDGROUP_MESH);
		return {
			code,
			meshUniformBufferFormat,
			meshBindGroupFormat
		};
	}
	static processVaryings(varyingLines, varyingMap, isVertex) {
		let block = "";
		const op = isVertex ? "out" : "in";
		varyingLines.forEach((line, index) => {
			const words = _ShaderProcessorGLSL.splitToWords(line);
			const type = words.slice(0, -1).join(" ");
			const name = words[words.length - 1];
			if (isVertex) {
				varyingMap.set(name, index);
			} else {
				index = varyingMap.get(name);
			}
			block += `layout(location = ${index}) ${op} ${type} ${name};
`;
		});
		return block;
	}
	static processOuts(outsLines) {
		let block = "";
		outsLines.forEach((line, index) => {
			block += `layout(location = ${index}) out ${line};
`;
		});
		return block;
	}
	// extract count from type ('vec3' => 3, 'float' => 1)
	static getTypeCount(type) {
		const lastChar = type.substring(type.length - 1);
		const num = parseInt(lastChar, 10);
		return isNaN(num) ? 1 : num;
	}
	static processAttributes(attributeLines, shaderDefinitionAttributes, attributesMap, processingOptions) {
		let block = "";
		const usedLocations = {};
		attributeLines.forEach((line) => {
			const words = _ShaderProcessorGLSL.splitToWords(line);
			let type = words[0];
			let name = words[1];
			if (shaderDefinitionAttributes.hasOwnProperty(name)) {
				const semantic = shaderDefinitionAttributes[name];
				const location = semanticToLocation[semantic];
				usedLocations[location] = semantic;
				attributesMap.set(location, name);
				let copyCode;
				const element = processingOptions.getVertexElement(semantic);
				if (element) {
					const dataType = element.dataType;
					if (dataType !== TYPE_FLOAT32 && dataType !== TYPE_FLOAT16 && !element.normalize && !element.asInt) {
						const attribNumElements = _ShaderProcessorGLSL.getTypeCount(type);
						const newName = `_private_${name}`;
						copyCode = `vec${attribNumElements} ${name} = vec${attribNumElements}(${newName});
`;
						name = newName;
						const isSignedType = dataType === TYPE_INT8 || dataType === TYPE_INT16 || dataType === TYPE_INT32;
						if (attribNumElements === 1) {
							type = isSignedType ? "int" : "uint";
						} else {
							type = isSignedType ? `ivec${attribNumElements}` : `uvec${attribNumElements}`;
						}
					}
				}
				block += `layout(location = ${location}) in ${type} ${name};
`;
				if (copyCode) {
					block += copyCode;
				}
			}
		});
		return block;
	}
	static splitToWords(line) {
		line = line.replace(/\s+/g, " ").trim();
		return line.split(" ");
	}
	static cutOut(src, start, end, replacement) {
		return src.substring(0, start) + replacement + src.substring(end);
	}
	static getUniformShaderDeclaration(format, bindGroup, bindIndex) {
		const name = bindGroupNames[bindGroup];
		let code = `layout(set = ${bindGroup}, binding = ${bindIndex}, std140) uniform ub_${name} {
`;
		format.uniforms.forEach((uniform) => {
			const typeString = uniformTypeToName[uniform.type];
			code += `    ${typeString} ${uniform.shortName}${uniform.count ? `[${uniform.count}]` : ""};
`;
		});
		return `${code}};
`;
	}
	static getTexturesShaderDeclaration(bindGroupFormat, bindGroup) {
		let code = "";
		bindGroupFormat.textureFormats.forEach((format) => {
			let textureType = textureDimensionInfo[format.textureDimension];
			const isArray = textureType === "texture2DArray";
			const sampleTypePrefix = format.sampleType === SAMPLETYPE_UINT ? "u" : format.sampleType === SAMPLETYPE_INT ? "i" : "";
			textureType = `${sampleTypePrefix}${textureType}`;
			let namePostfix = "";
			let extraCode = "";
			if (isArray) {
				namePostfix = "_texture";
				extraCode = `#define ${format.name} ${sampleTypePrefix}sampler2DArray(${format.name}${namePostfix}, ${format.name}_sampler)
`;
			}
			code += `layout(set = ${bindGroup}, binding = ${format.slot}) uniform ${textureType} ${format.name}${namePostfix};
`;
			if (format.hasSampler) {
				code += `layout(set = ${bindGroup}, binding = ${format.slot + 1}) uniform sampler ${format.name}_sampler;
`;
			}
			code += extraCode;
		});
		return code;
	}
};

var KEYWORD2 = /^[ \t]*(attribute|varying|uniform)[\t ]+/gm;
var KEYWORD_LINE2 = /^[ \t]*(attribute|varying|uniform)[ \t]*([^;]+)(;+)/gm;
var KEYWORD_RESOURCE = /^[ \t]*var\s*(?:(<storage,[^>]*>)\s*([\w\d_]+)\s*:\s*(.*?)\s*;|(<(?!storage,)[^>]*>)?\s*([\w\d_]+)\s*:\s*(texture_.*|storage_texture_.*|storage\w.*|external_texture|sampler(?:_comparison)?)\s*;)\s*$/gm;
var VARYING = /(?:@interpolate\([^)]*\)\s*)?([\w]+)\s*:\s*([\w<>]+)/;
var MARKER = "@@@";
var ENTRY_FUNCTION = /(@vertex|@fragment)\s*fn\s+\w+\s*\(\s*(\w+)\s*:[\s\S]*?\{/;
var FRAGMENT_BUILTINS = [
	{ wgslName: "position", wgslType: "vec4f", wgslBuiltin: "position", pcName: "pcPosition", isFallback: true },
	{ wgslName: "frontFacing", wgslType: "bool", wgslBuiltin: "front_facing", pcName: "pcFrontFacing" },
	{ wgslName: "sampleIndex", wgslType: "u32", wgslBuiltin: "sample_index", pcName: "pcSampleIndex" },
	{ wgslName: "primitiveIndex", wgslType: "u32", wgslBuiltin: "primitive_index", pcName: "pcPrimitiveIndex", requiresFeature: "supportsPrimitiveIndex" }
];
var VERTEX_BUILTINS = [
	{ wgslName: "vertexIndex", wgslType: "u32", wgslBuiltin: "vertex_index", pcName: "pcVertexIndex", isFallback: true },
	{ wgslName: "instanceIndex", wgslType: "u32", wgslBuiltin: "instance_index", pcName: "pcInstanceIndex" }
];
var detectUsedBuiltins = (builtins, source, entryInputName, device) => {
	return builtins.filter((b) => {
		if (b.requiresFeature && !device[b.requiresFeature]) return false;
		return new RegExp(`\\b(?:${b.pcName}|${entryInputName}\\.${b.wgslName})\\b`).test(source);
	});
};
var ensureNonEmptyStruct = (used, builtins, device, otherFieldsPresent) => {
	if (used.length === 0 && !otherFieldsPresent) {
		const fallback = builtins.find((b) => b.isFallback && (!b.requiresFeature || device[b.requiresFeature]));
		if (fallback) return [fallback];
	}
	return used;
};
var renderBuiltinStructFields = (used) => used.map((b) => `    @builtin(${b.wgslBuiltin}) ${b.wgslName} : ${b.wgslType},
`).join("");
var renderBuiltinPrivates = (used) => used.map((b) => `    var<private> ${b.pcName}: ${b.wgslType};
`).join("");
var renderBuiltinCopies = (used) => used.map((b) => `    ${b.pcName} = input.${b.wgslName};
`).join("");
var textureBaseInfo = {
	"texture_1d": { viewDimension: TEXTUREDIMENSION_1D, baseSampleType: SAMPLETYPE_FLOAT },
	"texture_2d": { viewDimension: TEXTUREDIMENSION_2D, baseSampleType: SAMPLETYPE_FLOAT },
	"texture_2d_array": { viewDimension: TEXTUREDIMENSION_2D_ARRAY, baseSampleType: SAMPLETYPE_FLOAT },
	"texture_3d": { viewDimension: TEXTUREDIMENSION_3D, baseSampleType: SAMPLETYPE_FLOAT },
	"texture_cube": { viewDimension: TEXTUREDIMENSION_CUBE, baseSampleType: SAMPLETYPE_FLOAT },
	"texture_cube_array": { viewDimension: TEXTUREDIMENSION_CUBE_ARRAY, baseSampleType: SAMPLETYPE_FLOAT },
	"texture_multisampled_2d": { viewDimension: TEXTUREDIMENSION_2D, baseSampleType: SAMPLETYPE_FLOAT },
	"texture_depth_2d": { viewDimension: TEXTUREDIMENSION_2D, baseSampleType: SAMPLETYPE_DEPTH },
	"texture_depth_2d_array": { viewDimension: TEXTUREDIMENSION_2D_ARRAY, baseSampleType: SAMPLETYPE_DEPTH },
	"texture_depth_cube": { viewDimension: TEXTUREDIMENSION_CUBE, baseSampleType: SAMPLETYPE_DEPTH },
	"texture_depth_cube_array": { viewDimension: TEXTUREDIMENSION_CUBE_ARRAY, baseSampleType: SAMPLETYPE_DEPTH },
	"texture_external": { viewDimension: TEXTUREDIMENSION_2D, baseSampleType: SAMPLETYPE_UNFILTERABLE_FLOAT }
};
var getTextureInfo = (baseType, componentType) => {
	const baseInfo = textureBaseInfo[baseType];
	let finalSampleType = baseInfo.baseSampleType;
	if (baseInfo.baseSampleType === SAMPLETYPE_FLOAT && baseType !== "texture_multisampled_2d") {
		switch (componentType) {
			case "u32":
				finalSampleType = SAMPLETYPE_UINT;
				break;
			case "i32":
				finalSampleType = SAMPLETYPE_INT;
				break;
			case "f32":
				finalSampleType = SAMPLETYPE_FLOAT;
				break;
			// custom 'uff' type for unfilterable float, allowing us to create correct bind, which is automatically generated based on the shader
			case "uff":
				finalSampleType = SAMPLETYPE_UNFILTERABLE_FLOAT;
				break;
		}
	}
	return {
		viewDimension: baseInfo.viewDimension,
		sampleType: finalSampleType
	};
};
var getTextureDeclarationType = (viewDimension, sampleType) => {
	if (sampleType === SAMPLETYPE_DEPTH) {
		switch (viewDimension) {
			case TEXTUREDIMENSION_2D:
				return "texture_depth_2d";
			case TEXTUREDIMENSION_2D_ARRAY:
				return "texture_depth_2d_array";
			case TEXTUREDIMENSION_CUBE:
				return "texture_depth_cube";
			case TEXTUREDIMENSION_CUBE_ARRAY:
				return "texture_depth_cube_array";
			default:
		}
	}
	let baseTypeString;
	switch (viewDimension) {
		case TEXTUREDIMENSION_1D:
			baseTypeString = "texture_1d";
			break;
		case TEXTUREDIMENSION_2D:
			baseTypeString = "texture_2d";
			break;
		case TEXTUREDIMENSION_2D_ARRAY:
			baseTypeString = "texture_2d_array";
			break;
		case TEXTUREDIMENSION_3D:
			baseTypeString = "texture_3d";
			break;
		case TEXTUREDIMENSION_CUBE:
			baseTypeString = "texture_cube";
			break;
		case TEXTUREDIMENSION_CUBE_ARRAY:
			baseTypeString = "texture_cube_array";
			break;
		default:
	}
	let coreFormatString;
	switch (sampleType) {
		case SAMPLETYPE_FLOAT:
		case SAMPLETYPE_UNFILTERABLE_FLOAT:
			coreFormatString = "f32";
			break;
		case SAMPLETYPE_UINT:
			coreFormatString = "u32";
			break;
		case SAMPLETYPE_INT:
			coreFormatString = "i32";
			break;
		default:
	}
	return `${baseTypeString}<${coreFormatString}>`;
};
var gpuFormatToPixelFormat = /* @__PURE__ */ new Map();
gpuTextureFormats.forEach((str, pixelFormat) => {
	if (str) {
		gpuFormatToPixelFormat.set(str, pixelFormat);
	}
});
var wrappedArrayTypes = {
	"f32": "WrappedF32",
	"i32": "WrappedI32",
	"u32": "WrappedU32",
	"vec2f": "WrappedVec2F",
	"vec2i": "WrappedVec2I",
	"vec2u": "WrappedVec2U"
};
var splitToWords = (line) => {
	line = line.replace(/\s+/g, " ").trim();
	return line.split(/[\s:]+/);
};
var UNIFORM_ARRAY_REGEX = /array<([^,]+),\s*([^>]+)>/;
var UniformLine2 = class {
	ubName = null;
	arraySize = 0;
	constructor(line, shader) {
		this.line = line;
		const parts = splitToWords(line);
		if (parts.length < 2) {
			shader.failed = true;
			return;
		}
		this.name = parts[0];
		this.type = parts.slice(1).join(" ");
		if (this.type.includes("array<")) {
			const match = UNIFORM_ARRAY_REGEX.exec(this.type);
			this.type = match[1].trim();
			this.arraySize = Number(match[2]);
			if (isNaN(this.arraySize)) {
				shader.failed = true;
			}
		}
	}
};
var TEXTURE_REGEX = /^\s*var\s+(\w+)\s*:\s*(texture_\w+)(?:<(\w+)>)?;\s*$/;
var STORAGE_TEXTURE_REGEX = /^\s*var\s+([\w\d_]+)\s*:\s*(texture_storage_2d|texture_storage_2d_array)<([\w\d_]+),\s*(\w+)>\s*;\s*$/;
var STORAGE_BUFFER_REGEX = /^\s*var\s*<storage,\s*(read_write|read)?>\s*([\w\d_]+)\s*:\s*(.*)\s*;\s*$/;
var EXTERNAL_TEXTURE_REGEX = /^\s*var\s+([\w\d_]+)\s*:\s*texture_external;\s*$/;
var SAMPLER_REGEX = /^\s*var\s+([\w\d_]+)\s*:\s*(sampler|sampler_comparison)\s*;\s*$/;
var ResourceLine = class {
	constructor(line, shader) {
		this.originalLine = line;
		this.line = line;
		this.isTexture = false;
		this.isSampler = false;
		this.isStorageTexture = false;
		this.isStorageBuffer = false;
		this.isExternalTexture = false;
		this.type = "";
		this.matchedElements = [];
		const textureMatch = this.line.match(TEXTURE_REGEX);
		if (textureMatch) {
			this.name = textureMatch[1];
			this.type = textureMatch[2];
			this.textureFormat = textureMatch[3];
			this.isTexture = true;
			this.matchedElements.push(...textureMatch);
			const info = getTextureInfo(this.type, this.textureFormat);
			this.textureDimension = info.viewDimension;
			this.sampleType = info.sampleType;
		}
		const storageTextureMatch = this.line.match(STORAGE_TEXTURE_REGEX);
		if (storageTextureMatch) {
			this.isStorageTexture = true;
			this.name = storageTextureMatch[1];
			this.textureType = storageTextureMatch[2];
			this.format = storageTextureMatch[3];
			this.access = storageTextureMatch[4];
			this.matchedElements.push(...storageTextureMatch);
		}
		const storageBufferMatch = this.line.match(STORAGE_BUFFER_REGEX);
		if (storageBufferMatch) {
			this.isStorageBuffer = true;
			this.accessMode = storageBufferMatch[1] || "none";
			this.name = storageBufferMatch[2];
			this.type = storageBufferMatch[3];
			this.matchedElements.push(...storageBufferMatch);
		}
		const externalTextureMatch = this.line.match(EXTERNAL_TEXTURE_REGEX);
		if (externalTextureMatch) {
			this.name = externalTextureMatch[1];
			this.isExternalTexture = true;
			this.matchedElements.push(...storageBufferMatch);
		}
		const samplerMatch = this.line.match(SAMPLER_REGEX);
		if (samplerMatch) {
			this.name = samplerMatch[1];
			this.samplerType = samplerMatch[2];
			this.isSampler = true;
			this.matchedElements.push(...samplerMatch);
		}
		if (this.matchedElements.length === 0) {
			shader.failed = true;
		}
	}
	equals(other) {
		if (this.name !== other.name) return false;
		if (this.type !== other.type) return false;
		if (this.isTexture !== other.isTexture) return false;
		if (this.isSampler !== other.isSampler) return false;
		if (this.isStorageTexture !== other.isStorageTexture) return false;
		if (this.isStorageBuffer !== other.isStorageBuffer) return false;
		if (this.isExternalTexture !== other.isExternalTexture) return false;
		if (this.textureFormat !== other.textureFormat) return false;
		if (this.textureDimension !== other.textureDimension) return false;
		if (this.sampleType !== other.sampleType) return false;
		if (this.textureType !== other.textureType) return false;
		if (this.format !== other.format) return false;
		if (this.access !== other.access) return false;
		if (this.accessMode !== other.accessMode) return false;
		if (this.samplerType !== other.samplerType) return false;
		return true;
	}
};
var WebgpuShaderProcessorWGSL = class _WebgpuShaderProcessorWGSL {
	static run(device, shaderDefinition, shader) {
		const varyingMap = /* @__PURE__ */ new Map();
		const vertexExtracted = _WebgpuShaderProcessorWGSL.extract(shaderDefinition.vshader);
		const fragmentExtracted = _WebgpuShaderProcessorWGSL.extract(shaderDefinition.fshader);
		const vertexInputName = vertexExtracted.src.match(ENTRY_FUNCTION)?.[2] ?? "";
		const fragmentInputName = fragmentExtracted.src.match(ENTRY_FUNCTION)?.[2] ?? "";
		const attributesMap = /* @__PURE__ */ new Map();
		const attributesBlock = _WebgpuShaderProcessorWGSL.processAttributes(vertexExtracted.attributes, shaderDefinition.attributes, attributesMap, shaderDefinition.processingOptions, shader, device, vertexExtracted.src, vertexInputName);
		const vertexVaryingsBlock = _WebgpuShaderProcessorWGSL.processVaryings(vertexExtracted.varyings, varyingMap, true, device);
		const fragmentVaryingsBlock = _WebgpuShaderProcessorWGSL.processVaryings(fragmentExtracted.varyings, varyingMap, false, device, fragmentExtracted.src, fragmentInputName);
		const concatUniforms = vertexExtracted.uniforms.concat(fragmentExtracted.uniforms);
		const uniforms = Array.from(new Set(concatUniforms));
		const parsedUniforms = uniforms.map((line) => new UniformLine2(line, shader));
		const uniformsData = _WebgpuShaderProcessorWGSL.processUniforms(device, parsedUniforms, shaderDefinition.processingOptions, shader);
		vertexExtracted.src = _WebgpuShaderProcessorWGSL.renameUniformAccess(vertexExtracted.src, parsedUniforms);
		fragmentExtracted.src = _WebgpuShaderProcessorWGSL.renameUniformAccess(fragmentExtracted.src, parsedUniforms);
		const parsedResources = _WebgpuShaderProcessorWGSL.mergeResources(vertexExtracted.resources, fragmentExtracted.resources, shader);
		const resourcesData = _WebgpuShaderProcessorWGSL.processResources(device, parsedResources, shaderDefinition.processingOptions, shader);
		const fOutput = _WebgpuShaderProcessorWGSL.generateFragmentOutputStruct(fragmentExtracted.src, device.maxColorAttachments);
		vertexExtracted.src = _WebgpuShaderProcessorWGSL.copyInputs(vertexExtracted.src, shader);
		fragmentExtracted.src = _WebgpuShaderProcessorWGSL.copyInputs(fragmentExtracted.src, shader);
		const vBlock = `${attributesBlock}
${vertexVaryingsBlock}
${uniformsData.code}
${resourcesData.code}
`;
		const vshader = vertexExtracted.src.replace(MARKER, vBlock);
		const fBlock = `${fragmentVaryingsBlock}
${fOutput}
${uniformsData.code}
${resourcesData.code}
`;
		const fshader = fragmentExtracted.src.replace(MARKER, fBlock);
		return {
			vshader,
			fshader,
			attributes: attributesMap,
			meshUniformBufferFormat: uniformsData.meshUniformBufferFormat,
			meshBindGroupFormat: resourcesData.meshBindGroupFormat
		};
	}
	static runCompute(device, source, shaderDefinition, shader, reflectedGroupIndex) {
		const extracted = _WebgpuShaderProcessorWGSL.extract(source);
		const parsedUniforms = extracted.uniforms.map((line) => new UniformLine2(line, shader));
		const meshUniforms = [];
		parsedUniforms.forEach((uniform) => {
			uniform.ubName = "ub_compute";
			const uniformType = uniformTypeToNameMapWGSL.get(uniform.type);
			meshUniforms.push(new UniformFormat(uniform.name, uniformType, uniform.arraySize));
		});
		const computeUniformBufferFormat = meshUniforms.length > 0 ? new UniformBufferFormat(device, meshUniforms) : null;
		const parsedResources = _WebgpuShaderProcessorWGSL.mergeResources(extracted.resources, [], shader);
		const resourceFormats = _WebgpuShaderProcessorWGSL.buildResourceFormats(parsedResources, SHADERSTAGE_COMPUTE, shader);
		const ubBindFormat = computeUniformBufferFormat ? new BindUniformBufferFormat("ub_compute", SHADERSTAGE_COMPUTE) : null;
		const allFormats = ubBindFormat ? [...resourceFormats, ubBindFormat] : resourceFormats;
		let cshader = source;
		let computeBindGroupFormat = null;
		if (allFormats.length > 0) {
			computeBindGroupFormat = new BindGroupFormat(device, allFormats);
			let code = _WebgpuShaderProcessorWGSL.getTextureShaderDeclaration(computeBindGroupFormat, reflectedGroupIndex);
			if (computeUniformBufferFormat) {
				code += _WebgpuShaderProcessorWGSL.getUniformShaderDeclaration(computeUniformBufferFormat, reflectedGroupIndex, ubBindFormat.slot, "compute");
			}
			const src = _WebgpuShaderProcessorWGSL.renameUniformAccess(extracted.src, parsedUniforms);
			cshader = src.includes(MARKER) ? src.replace(MARKER, code) : `${code}
${src}`;
		}
		return {
			cshader,
			computeBindGroupFormat,
			computeUniformBufferFormat
		};
	}
	// Extract required information from the shader source code.
	static extract(src) {
		const attributes = [];
		const varyings = [];
		const uniforms = [];
		const resources = [];
		let replacement = `${MARKER}
`;
		let match;
		while ((match = KEYWORD2.exec(src)) !== null) {
			const keyword = match[1];
			KEYWORD_LINE2.lastIndex = match.index;
			const lineMatch = KEYWORD_LINE2.exec(src);
			if (keyword === "attribute") {
				attributes.push(lineMatch[2]);
			} else if (keyword === "varying") {
				varyings.push(lineMatch[2]);
			} else if (keyword === "uniform") {
				uniforms.push(lineMatch[2]);
			}
			src = _WebgpuShaderProcessorWGSL.cutOut(src, match.index, KEYWORD_LINE2.lastIndex, replacement);
			KEYWORD2.lastIndex = match.index + replacement.length;
			replacement = "";
		}
		while ((match = KEYWORD_RESOURCE.exec(src)) !== null) {
			resources.push(match[0]);
			src = _WebgpuShaderProcessorWGSL.cutOut(src, match.index, KEYWORD_RESOURCE.lastIndex, replacement);
			KEYWORD_RESOURCE.lastIndex = match.index + replacement.length;
			replacement = "";
		}
		return {
			src,
			attributes,
			varyings,
			uniforms,
			resources
		};
	}
	static processUniforms(device, uniforms, processingOptions, shader) {
		const meshUniforms = [];
		uniforms.forEach((uniform) => {
			if (!processingOptions.hasUniform(uniform.name)) {
				uniform.ubName = "ub_mesh_ub";
				const uniformType = uniformTypeToNameMapWGSL.get(uniform.type);
				const uniformFormat = new UniformFormat(uniform.name, uniformType, uniform.arraySize);
				meshUniforms.push(uniformFormat);
			} else {
				uniform.ubName = "ub_view";
			}
		});
		if (meshUniforms.length === 0) {
			meshUniforms.push(new UniformFormat(UNUSED_UNIFORM_NAME, UNIFORMTYPE_FLOAT));
		}
		const meshUniformBufferFormat = new UniformBufferFormat(device, meshUniforms);
		let code = "";
		processingOptions.uniformFormats.forEach((format, bindGroupIndex) => {
			if (format) {
				code += _WebgpuShaderProcessorWGSL.getUniformShaderDeclaration(format, bindGroupIndex, 0);
			}
		});
		if (meshUniformBufferFormat) {
			code += _WebgpuShaderProcessorWGSL.getUniformShaderDeclaration(meshUniformBufferFormat, BINDGROUP_MESH_UB, 0);
		}
		return {
			code,
			meshUniformBufferFormat
		};
	}
	static renameUniformAccess(source, uniforms) {
		uniforms.forEach((uniform) => {
			const srcName = `uniform.${uniform.name}`;
			const dstName = `${uniform.ubName}.${uniform.name}`;
			const regex = new RegExp(`\\b${srcName}\\b`, "g");
			source = source.replace(regex, dstName);
		});
		return source;
	}
	static mergeResources(vertex, fragment, shader) {
		const resources = vertex.map((line) => new ResourceLine(line, shader));
		const fragmentResources = fragment.map((line) => new ResourceLine(line, shader));
		fragmentResources.forEach((fragmentResource) => {
			const existing = resources.find((resource) => resource.name === fragmentResource.name);
			if (existing) {
				if (!existing.equals(fragmentResource)) {
					shader.failed = true;
				}
			} else {
				resources.push(fragmentResource);
			}
		});
		return resources;
	}
	static buildResourceFormats(resources, visibility, shader) {
		const formats = [];
		for (let i2 = 0; i2 < resources.length; i2++) {
			const resource = resources[i2];
			if (resource.isTexture) {
				const sampler = resources[i2 + 1];
				const hasSampler = sampler?.isSampler;
				const sampleType = resource.sampleType;
				const dimension = resource.textureDimension;
				formats.push(new BindTextureFormat(resource.name, visibility, dimension, sampleType, hasSampler, hasSampler ? sampler.name : null));
				if (hasSampler) i2++;
			}
			if (resource.isStorageBuffer) {
				const readOnly = resource.accessMode !== "read_write";
				const bufferFormat = new BindStorageBufferFormat(resource.name, visibility, readOnly);
				bufferFormat.format = resource.type;
				formats.push(bufferFormat);
			}
			if (resource.isStorageTexture) {
				const dimension = resource.textureType === "texture_storage_2d_array" ? TEXTUREDIMENSION_2D_ARRAY : TEXTUREDIMENSION_2D;
				const pixelFormat = gpuFormatToPixelFormat.get(resource.format);
				const write = resource.access === "write" || resource.access === "read_write";
				const read = resource.access === "read" || resource.access === "read_write";
				formats.push(new BindStorageTextureFormat(resource.name, pixelFormat, dimension, write, read));
			}
		}
		return formats;
	}
	static processResources(device, resources, processingOptions, shader, visibility = SHADERSTAGE_VERTEX | SHADERSTAGE_FRAGMENT, bindGroupIndex = BINDGROUP_MESH) {
		const textureFormats = _WebgpuShaderProcessorWGSL.buildResourceFormats(resources, visibility, shader);
		const meshBindGroupFormat = new BindGroupFormat(device, textureFormats);
		let code = "";
		processingOptions?.bindGroupFormats?.forEach((format, index) => {
			if (format) {
				code += _WebgpuShaderProcessorWGSL.getTextureShaderDeclaration(format, index);
			}
		});
		code += _WebgpuShaderProcessorWGSL.getTextureShaderDeclaration(meshBindGroupFormat, bindGroupIndex);
		return {
			code,
			meshBindGroupFormat
		};
	}
	static getUniformShaderDeclaration(ubFormat, bindGroup, bindIndex, name = bindGroupNames[bindGroup]) {
		const structName = `struct_ub_${name}`;
		let code = `struct ${structName} {
`;
		ubFormat.uniforms.forEach((uniform) => {
			let typeString = uniformTypeToNameWGSL[uniform.type][0];
			if (uniform.count > 0) {
				if (wrappedArrayTypes.hasOwnProperty(typeString)) {
					typeString = wrappedArrayTypes[typeString];
				}
				code += `    ${uniform.shortName}: array<${typeString}, ${uniform.count}>,
`;
			} else {
				code += `    ${uniform.shortName}: ${typeString},
`;
			}
		});
		code += "};\n";
		code += `@group(${bindGroup}) @binding(${bindIndex}) var<uniform> ub_${name} : ${structName};

`;
		return code;
	}
	static getTextureShaderDeclaration(format, bindGroup) {
		let code = "";
		format.textureFormats.forEach((format2) => {
			const textureTypeName = getTextureDeclarationType(format2.textureDimension, format2.sampleType);
			code += `@group(${bindGroup}) @binding(${format2.slot}) var ${format2.name}: ${textureTypeName};
`;
			if (format2.hasSampler) {
				const samplerName = format2.sampleType === SAMPLETYPE_DEPTH ? "sampler_comparison" : "sampler";
				code += `@group(${bindGroup}) @binding(${format2.slot + 1}) var ${format2.samplerName}: ${samplerName};
`;
			}
		});
		format.storageBufferFormats.forEach((format2) => {
			const access = format2.readOnly ? "read" : "read_write";
			code += `@group(${bindGroup}) @binding(${format2.slot}) var<storage, ${access}> ${format2.name} : ${format2.format};
`;
		});
		format.storageTextureFormats.forEach((format2) => {
			const storageType = format2.textureDimension === TEXTUREDIMENSION_2D_ARRAY ? "texture_storage_2d_array" : "texture_storage_2d";
			const fmtString = gpuTextureFormats[format2.format];
			const access = format2.read ? format2.write ? "read_write" : "read" : "write";
			code += `@group(${bindGroup}) @binding(${format2.slot}) var ${format2.name}: ${storageType}<${fmtString}, ${access}>;
`;
		});
		return code;
	}
	static processVaryings(varyingLines, varyingMap, isVertex, device, source = "", entryInputName = "") {
		let block = "";
		let blockPrivates = "";
		let blockCopy = "";
		varyingLines.forEach((line, index) => {
			const match = line.match(VARYING);
			if (match) {
				const name = match[1];
				const type = match[2];
				if (isVertex) {
					varyingMap.set(name, index);
				} else {
					index = varyingMap.get(name);
				}
				block += `    @location(${index}) ${line},
`;
				if (!isVertex) {
					blockPrivates += `    var<private> ${name}: ${type};
`;
					blockCopy += `    ${name} = input.${name};
`;
				}
			}
		});
		if (isVertex) {
			block += "    @builtin(position) position : vec4f,\n";
			return `
								struct VertexOutput {
										${block}
								};
						`;
		}
		const usedBuiltins = ensureNonEmptyStruct(
			detectUsedBuiltins(FRAGMENT_BUILTINS, source, entryInputName, device),
			FRAGMENT_BUILTINS,
			device,
			block.length > 0
		);
		block += renderBuiltinStructFields(usedBuiltins);
		return `
						struct FragmentInput {
								${block}
						};

						${renderBuiltinPrivates(usedBuiltins)}
						${blockPrivates}

						// function to copy inputs (varyings) to private global variables
						fn _pcCopyInputs(input: FragmentInput) {
								${blockCopy}
								${renderBuiltinCopies(usedBuiltins)}
						}
				`;
	}
	static generateFragmentOutputStruct(src, numRenderTargets) {
		let structCode = "struct FragmentOutput {\n";
		const colorName = (i2) => `color${i2 > 0 ? i2 : ""}`;
		for (let i2 = 0; i2 < numRenderTargets; i2++) {
			const name = colorName(i2);
			if (src.search(new RegExp(`\\.${name}\\s*=`)) !== -1) {
				structCode += `    @location(${i2}) ${name} : pcOutType${i2},
`;
			}
		}
		const needsFragDepth = src.search(/\.fragDepth\s*=/) !== -1;
		if (needsFragDepth) {
			structCode += "    @builtin(frag_depth) fragDepth : f32\n";
		}
		return `${structCode}};
`;
	}
	// convert a float attribute type to matching signed or unsigned int type
	// for example: vec4f -> vec4u, f32 -> u32
	static floatAttributeToInt(type, signed) {
		const longToShortMap = {
			"f32": "f32",
			"vec2<f32>": "vec2f",
			"vec3<f32>": "vec3f",
			"vec4<f32>": "vec4f"
		};
		const shortType = longToShortMap[type] || type;
		const floatToIntShort = {
			"f32": signed ? "i32" : "u32",
			"vec2f": signed ? "vec2i" : "vec2u",
			"vec3f": signed ? "vec3i" : "vec3u",
			"vec4f": signed ? "vec4i" : "vec4u"
		};
		return floatToIntShort[shortType] || null;
	}
	static processAttributes(attributeLines, shaderDefinitionAttributes = {}, attributesMap, processingOptions, shader, device, source = "", entryInputName = "") {
		let blockAttributes = "";
		let blockPrivates = "";
		let blockCopy = "";
		const usedLocations = {};
		attributeLines.forEach((line) => {
			const words = splitToWords(line);
			const name = words[0];
			let type = words[1];
			const originalType = type;
			if (shaderDefinitionAttributes.hasOwnProperty(name)) {
				const semantic = shaderDefinitionAttributes[name];
				const location = semanticToLocation[semantic];
				usedLocations[location] = semantic;
				attributesMap.set(location, name);
				const element = processingOptions.getVertexElement(semantic);
				if (element) {
					const dataType = element.dataType;
					if (dataType !== TYPE_FLOAT32 && dataType !== TYPE_FLOAT16 && !element.normalize && !element.asInt) {
						const isSignedType = dataType === TYPE_INT8 || dataType === TYPE_INT16 || dataType === TYPE_INT32;
						type = _WebgpuShaderProcessorWGSL.floatAttributeToInt(type, isSignedType);
					}
				}
				blockAttributes += `    @location(${location}) ${name}: ${type},
`;
				blockPrivates += `    var<private> ${line};
`;
				blockCopy += `    ${name} = ${originalType}(input.${name});
`;
			} else {
			}
		});
		const usedBuiltins = ensureNonEmptyStruct(
			detectUsedBuiltins(VERTEX_BUILTINS, source, entryInputName, device),
			VERTEX_BUILTINS,
			device,
			blockAttributes.length > 0
		);
		return `
						struct VertexInput {
								${blockAttributes}
								${renderBuiltinStructFields(usedBuiltins)}
						};

						${blockPrivates}
						${renderBuiltinPrivates(usedBuiltins)}

						fn _pcCopyInputs(input: VertexInput) {
								${blockCopy}
								${renderBuiltinCopies(usedBuiltins)}
						}
				`;
	}
	static copyInputs(src, shader) {
		const match = src.match(ENTRY_FUNCTION);
		if (!match || !match[2]) {
			return src;
		}
		const inputName = match[2];
		const braceIndex = match.index + match[0].length - 1;
		const beginning = src.slice(0, braceIndex + 1);
		const end = src.slice(braceIndex + 1);
		const lineToInject = `
		_pcCopyInputs(${inputName});`;
		return beginning + lineToInject + end;
	}
	static cutOut(src, start, end, replacement) {
		return src.substring(0, start) + replacement + src.substring(end);
	}
};

var computeShaderIds = new StringIds();
var WebgpuShader = class {
	_vertexCode = null;
	_fragmentCode = null;
	_computeCode = null;
	_computeKey;
	computeBindGroupFormat = null;
	computeReflectedBindGroupFormat = null;
	computeReflectedUniformBufferFormat = null;
	computeReflectedGroupIndex = 0;
	vertexEntryPoint = "main";
	fragmentEntryPoint = "main";
	computeEntryPoint = "main";
	constructor(shader) {
		this.shader = shader;
		const definition = shader.definition;
		if (definition.shaderLanguage === SHADERLANGUAGE_WGSL) {
			if (definition.cshader) {
				if (definition.computeEntryPoint) {
					this.computeEntryPoint = definition.computeEntryPoint;
				}
				this.processComputeWGSL();
			} else {
				this.vertexEntryPoint = "vertexMain";
				this.fragmentEntryPoint = "fragmentMain";
				if (definition.processingOptions) {
					this.processWGSL();
				} else {
					this._vertexCode = definition.vshader ?? null;
					this._fragmentCode = definition.fshader ?? null;
					shader.meshUniformBufferFormat = definition.meshUniformBufferFormat;
					shader.meshBindGroupFormat = definition.meshBindGroupFormat;
				}
			}
			shader.ready = true;
		} else {
			if (definition.processingOptions) {
				this.processGLSL();
			}
		}
	}
	destroy(shader) {
		this._vertexCode = null;
		this._fragmentCode = null;
	}
	createShaderModule(code, shaderType) {
		const device = this.shader.device;
		const wgpu = device.wgpu;
		const shaderModule = wgpu.createShaderModule({
			code
		});
		return shaderModule;
	}
	getVertexShaderModule() {
		return this.createShaderModule(this._vertexCode, "Vertex");
	}
	getFragmentShaderModule() {
		return this.createShaderModule(this._fragmentCode, "Fragment");
	}
	getComputeShaderModule() {
		return this.createShaderModule(this._computeCode, "Compute");
	}
	processGLSL() {
		const shader = this.shader;
		const processed = ShaderProcessorGLSL.run(shader.device, shader.definition, shader);
		this._vertexCode = this.transpile(processed.vshader, "vertex", shader.definition.vshader);
		this._fragmentCode = this.transpile(processed.fshader, "fragment", shader.definition.fshader);
		if (!(this._vertexCode && this._fragmentCode)) {
			shader.failed = true;
		} else {
			shader.ready = true;
		}
		shader.meshUniformBufferFormat = processed.meshUniformBufferFormat;
		shader.meshBindGroupFormat = processed.meshBindGroupFormat;
		shader.attributes = processed.attributes;
	}
	processComputeWGSL() {
		const shader = this.shader;
		const definition = shader.definition;
		const callerBindGroupFormat = definition.computeBindGroupFormat ?? null;
		const reflectedGroupIndex = callerBindGroupFormat ? 1 : 0;
		const processed = WebgpuShaderProcessorWGSL.runCompute(shader.device, definition.cshader, definition, shader, reflectedGroupIndex);
		this._computeCode = processed.cshader;
		this.computeBindGroupFormat = callerBindGroupFormat;
		this.computeUniformBufferFormats = definition.computeUniformBufferFormats;
		this.computeReflectedGroupIndex = reflectedGroupIndex;
		this.computeReflectedBindGroupFormat = processed.computeBindGroupFormat;
		this.computeReflectedUniformBufferFormat = processed.computeUniformBufferFormat;
	}
	processWGSL() {
		const shader = this.shader;
		const processed = WebgpuShaderProcessorWGSL.run(shader.device, shader.definition, shader);
		this._vertexCode = processed.vshader;
		this._fragmentCode = processed.fshader;
		shader.meshUniformBufferFormat = processed.meshUniformBufferFormat;
		shader.meshBindGroupFormat = processed.meshBindGroupFormat;
		shader.attributes = processed.attributes;
	}
	transpile(src, shaderType, originalSrc) {
		const device = this.shader.device;
		if (!device.glslang || !device.twgsl) {
			console.error(`Cannot transpile shader [${this.shader.label}] - shader transpilers (glslang/twgsl) are not available. Make sure to provide glslangUrl and twgslUrl when creating the device.`, {
				shader: this.shader
			});
			return null;
		}
		try {
			const spirv = device.glslang.compileGLSL(src, shaderType);
			const wgsl = device.twgsl.convertSpirV2WGSL(spirv);
			return wgsl;
		} catch (err2) {
			console.error(`Failed to transpile webgl ${shaderType} shader [${this.shader.label}] to WebGPU while rendering ${void 0}, error:
 [${err2.stack}]`, {
				processed: src,
				original: originalSrc,
				shader: this.shader,
				error: err2,
				stack: err2.stack
			});
		}
	}
	get vertexCode() {
		return this._vertexCode;
	}
	get fragmentCode() {
		return this._fragmentCode;
	}
	get computeKey() {
		if (this._computeKey === void 0) {
			const keyString = `${this._computeCode}|${this.computeEntryPoint}`;
			this._computeKey = computeShaderIds.get(keyString);
		}
		return this._computeKey;
	}
	loseContext() {
	}
	restoreContext(device, shader) {
	}
};

var gpuAddressModes = [];
gpuAddressModes[ADDRESS_REPEAT] = "repeat";
gpuAddressModes[ADDRESS_CLAMP_TO_EDGE] = "clamp-to-edge";
gpuAddressModes[ADDRESS_MIRRORED_REPEAT] = "mirror-repeat";
var gpuFilterModes = [];
gpuFilterModes[FILTER_NEAREST] = { level: "nearest", mip: "nearest" };
gpuFilterModes[FILTER_LINEAR] = { level: "linear", mip: "nearest" };
gpuFilterModes[FILTER_NEAREST_MIPMAP_NEAREST] = { level: "nearest", mip: "nearest" };
gpuFilterModes[FILTER_NEAREST_MIPMAP_LINEAR] = { level: "nearest", mip: "linear" };
gpuFilterModes[FILTER_LINEAR_MIPMAP_NEAREST] = { level: "linear", mip: "nearest" };
gpuFilterModes[FILTER_LINEAR_MIPMAP_LINEAR] = { level: "linear", mip: "linear" };
var dummyUse = (thingOne) => {
};
var WebgpuTexture = class {
	gpuTexture;
	view;
	samplers = [];
	desc;
	format;
	viewCache = /* @__PURE__ */ new Map();
	constructor(texture) {
		this.texture = texture;
		this.format = gpuTextureFormats[texture.format];
		this.create(texture.device);
	}
	create(device) {
		const texture = this.texture;
		const wgpu = device.wgpu;
		const numLevels = texture.numLevels;
		if (isCompressedPixelFormat(texture.format) && (texture.width % 4 !== 0 || texture.height % 4 !== 0)) {
			texture._width = math.roundUp(texture.width, 4);
			texture._height = math.roundUp(texture.height, 4);
		}
		this.desc = {
			size: {
				width: texture.width,
				height: texture.height,
				depthOrArrayLayers: texture.cubemap ? 6 : texture.array ? texture.arrayLength : 1
			},
			format: this.format,
			mipLevelCount: numLevels,
			sampleCount: 1,
			dimension: texture.volume ? "3d" : "2d",
			// TODO: use only required usage flags
			// COPY_SRC - probably only needed on render target textures, to support copyRenderTarget (grab pass needs it)
			// RENDER_ATTACHMENT - needed for mipmap generation
			usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | (isCompressedPixelFormat(texture.format) ? 0 : GPUTextureUsage.RENDER_ATTACHMENT) | (texture.storage ? GPUTextureUsage.STORAGE_BINDING : 0)
		};
		this.gpuTexture = wgpu.createTexture(this.desc);
		let viewDescr;
		if (this.texture.format === PIXELFORMAT_DEPTHSTENCIL) {
			viewDescr = {
				format: "depth24plus",
				aspect: "depth-only"
			};
		}
		this.view = this.createView(viewDescr);
		this.viewCache.clear();
	}
	destroy(device) {
		device.deferDestroy(this.gpuTexture);
		this.gpuTexture = null;
		this.view = null;
		this.viewCache.clear();
		this.samplers.length = 0;
	}
	propertyChanged(flag) {
		this.samplers.length = 0;
	}
	getView(device, textureView) {
		this.uploadImmediate(device, this.texture);
		if (textureView) {
			let view = this.viewCache.get(textureView.key);
			if (!view) {
				view = this.createView({
					baseMipLevel: textureView.baseMipLevel,
					mipLevelCount: textureView.mipLevelCount,
					baseArrayLayer: textureView.baseArrayLayer,
					arrayLayerCount: textureView.arrayLayerCount
				});
				this.viewCache.set(textureView.key, view);
			}
			return view;
		}
		return this.view;
	}
	createView(viewDescr) {
		const options2 = viewDescr ?? {};
		const textureDescr = this.desc;
		const texture = this.texture;
		const defaultViewDimension = () => {
			if (texture.cubemap) return "cube";
			if (texture.volume) return "3d";
			if (texture.array) return "2d-array";
			return "2d";
		};
		const desc = {
			format: options2.format ?? textureDescr.format,
			dimension: options2.dimension ?? defaultViewDimension(),
			aspect: options2.aspect ?? "all",
			baseMipLevel: options2.baseMipLevel ?? 0,
			mipLevelCount: options2.mipLevelCount ?? textureDescr.mipLevelCount,
			baseArrayLayer: options2.baseArrayLayer ?? 0,
			arrayLayerCount: options2.arrayLayerCount ?? textureDescr.depthOrArrayLayers
		};
		const view = this.gpuTexture.createView(desc);
		return view;
	}
	// TODO: share a global map of samplers. Possibly even use shared samplers for bind group,
	// or maybe even have some attached in view bind group and use globally
	getSampler(device, sampleType) {
		let sampler = this.samplers[sampleType];
		if (!sampler) {
			const texture = this.texture;
			let label;
			const desc = {
				addressModeU: gpuAddressModes[texture.addressU],
				addressModeV: gpuAddressModes[texture.addressV],
				addressModeW: gpuAddressModes[texture.addressW]
			};
			if (!sampleType && texture.compareOnRead) {
				sampleType = SAMPLETYPE_DEPTH;
			}
			if (sampleType === SAMPLETYPE_DEPTH || sampleType === SAMPLETYPE_INT || sampleType === SAMPLETYPE_UINT) {
				desc.compare = "less";
				desc.magFilter = "linear";
				desc.minFilter = "linear";
				label = "Compare";
			} else if (sampleType === SAMPLETYPE_UNFILTERABLE_FLOAT) {
				desc.magFilter = "nearest";
				desc.minFilter = "nearest";
				desc.mipmapFilter = "nearest";
				label = "Unfilterable";
			} else {
				const forceNearest = !device.textureFloatFilterable && (texture.format === PIXELFORMAT_RGBA32F || texture.format === PIXELFORMAT_RGBA16F);
				if (forceNearest || this.texture.format === PIXELFORMAT_DEPTHSTENCIL || isIntegerPixelFormat(this.texture.format)) {
					desc.magFilter = "nearest";
					desc.minFilter = "nearest";
					desc.mipmapFilter = "nearest";
					label = "Nearest";
				} else {
					desc.magFilter = gpuFilterModes[texture.magFilter].level;
					desc.minFilter = gpuFilterModes[texture.minFilter].level;
					desc.mipmapFilter = gpuFilterModes[texture.minFilter].mip;
				}
			}
			const allLinear = desc.minFilter === "linear" && desc.magFilter === "linear" && desc.mipmapFilter === "linear";
			desc.maxAnisotropy = allLinear ? math.clamp(Math.round(texture._anisotropy), 1, device.maxTextureAnisotropy) : 1;
			sampler = device.wgpu.createSampler(desc);
			this.samplers[sampleType] = sampler;
		}
		return sampler;
	}
	loseContext() {
	}
	uploadImmediate(device, texture) {
		if (texture._needsUpload || texture._needsMipmapsUpload) {
			this.uploadData(device);
			texture._needsUpload = false;
			texture._needsMipmapsUpload = false;
		}
	}
	uploadData(device) {
		const texture = this.texture;
		if (this.desc && (this.desc.size.width !== texture.width || this.desc.size.height !== texture.height)) {
			device.deferDestroy(this.gpuTexture);
			this.create(device);
			texture.renderVersionDirty = device.renderVersion;
		}
		if (texture._levels) {
			let anyUploads = false;
			let anyLevelMissing = false;
			const requiredMipLevels = texture.numLevels;
			for (let mipLevel = 0; mipLevel < requiredMipLevels; mipLevel++) {
				const mipObject = texture._levels[mipLevel];
				if (mipObject) {
					if (texture.cubemap) {
						for (let face = 0; face < 6; face++) {
							const faceSource = mipObject[face];
							if (faceSource) {
								if (this.isExternalImage(faceSource)) {
									this.uploadExternalImage(device, faceSource, mipLevel, face);
									anyUploads = true;
								} else if (ArrayBuffer.isView(faceSource)) {
									this.uploadTypedArrayData(device, faceSource, mipLevel, face);
									anyUploads = true;
								} else {
								}
							} else {
								anyLevelMissing = true;
							}
						}
					} else if (texture._volume) {
					} else if (texture.array) {
						if (texture.arrayLength === mipObject.length) {
							for (let index = 0; index < texture._arrayLength; index++) {
								const arraySource = mipObject[index];
								if (this.isExternalImage(arraySource)) {
									this.uploadExternalImage(device, arraySource, mipLevel, index);
									anyUploads = true;
								} else if (ArrayBuffer.isView(arraySource)) {
									this.uploadTypedArrayData(device, arraySource, mipLevel, index);
									anyUploads = true;
								} else {
								}
							}
						} else {
							anyLevelMissing = true;
						}
					} else {
						if (device._isHTMLElementInterface(mipObject) && device.supportsHtmlTextures) {
							this.uploadElementImage(device, mipObject, mipLevel, 0);
							anyUploads = true;
						} else if (this.isExternalImage(mipObject)) {
							this.uploadExternalImage(device, mipObject, mipLevel, 0);
							anyUploads = true;
						} else if (ArrayBuffer.isView(mipObject)) {
							this.uploadTypedArrayData(device, mipObject, mipLevel, 0);
							anyUploads = true;
						} else {
						}
					}
				} else {
					anyLevelMissing = true;
				}
			}
			if (anyUploads && anyLevelMissing && texture.mipmaps && !isCompressedPixelFormat(texture.format) && !isIntegerPixelFormat(texture.format)) {
				device.mipmapRenderer.generate(this);
			}
			if (texture._gpuSize) {
				texture.adjustVramSizeTracking(device._vram, -texture._gpuSize);
			}
			texture._gpuSize = texture.gpuSize;
			texture.adjustVramSizeTracking(device._vram, texture._gpuSize);
			if (texture.releaseSourceAfterUpload) {
				texture.releaseImageSources();
			}
		}
	}
	// image types supported by copyExternalImageToTexture
	isExternalImage(image) {
		return typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap || typeof HTMLVideoElement !== "undefined" && image instanceof HTMLVideoElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof OffscreenCanvas !== "undefined" && image instanceof OffscreenCanvas;
	}
	uploadExternalImage(device, image, mipLevel, index) {
		const src = {
			source: image,
			origin: [0, 0],
			flipY: false
		};
		const dst = {
			texture: this.gpuTexture,
			mipLevel,
			origin: [0, 0, index],
			aspect: "all",
			// can be: "all", "stencil-only", "depth-only"
			premultipliedAlpha: this.texture._premultiplyAlpha
		};
		const copySize = {
			width: this.desc.size.width,
			height: this.desc.size.height,
			depthOrArrayLayers: 1
			// single layer
		};
		device.submit();
		dummyUse(image instanceof HTMLCanvasElement && image.getContext("2d"));
		device.wgpu.queue.copyExternalImageToTexture(src, dst, copySize);
	}
	// upload a generic HTML element via the HTML-in-Canvas API (copyElementImageToTexture)
	uploadElementImage(device, element, mipLevel, index) {
		const dst = {
			texture: this.gpuTexture,
			mipLevel,
			origin: [0, 0, index],
			aspect: "all",
			// can be: "all", "stencil-only", "depth-only"
			premultipliedAlpha: this.texture._premultiplyAlpha
		};
		const width = TextureUtils.calcLevelDimension(this.texture.width, mipLevel);
		const height = TextureUtils.calcLevelDimension(this.texture.height, mipLevel);
		device.submit();
		const source = { source: element };
		const destination = { destination: dst, width, height };
		device.wgpu.queue.copyElementImageToTexture(source, destination);
	}
	uploadTypedArrayData(device, data2, mipLevel, index) {
		const texture = this.texture;
		const wgpu = device.wgpu;
		const dest = {
			texture: this.gpuTexture,
			origin: [0, 0, index],
			mipLevel
		};
		const width = TextureUtils.calcLevelDimension(texture.width, mipLevel);
		const height = TextureUtils.calcLevelDimension(texture.height, mipLevel);
		const byteSize = TextureUtils.calcLevelGpuSize(width, height, 1, texture.format);
		const formatInfo = pixelFormatInfo.get(texture.format);
		let dataLayout;
		let size;
		if (formatInfo.size) {
			dataLayout = {
				offset: 0,
				bytesPerRow: formatInfo.size * width,
				rowsPerImage: height
			};
			size = {
				width,
				height
			};
		} else if (formatInfo.blockSize) {
			const blockDim = (size2) => {
				return Math.floor((size2 + 3) / 4);
			};
			dataLayout = {
				offset: 0,
				bytesPerRow: formatInfo.blockSize * blockDim(width),
				rowsPerImage: blockDim(height)
			};
			size = {
				width: Math.max(4, width),
				height: Math.max(4, height)
			};
		} else {
		}
		device.submit();
		wgpu.queue.writeTexture(dest, data2, dataLayout, size);
	}
	read(x3, y2, width, height, options2) {
		const mipLevel = options2.mipLevel ?? 0;
		const face = options2.face ?? 0;
		const data2 = options2.data ?? null;
		const immediate = options2.immediate ?? false;
		const texture = this.texture;
		const formatInfo = pixelFormatInfo.get(texture.format);
		const bytesPerRow = width * formatInfo.size;
		const paddedBytesPerRow = math.roundUp(bytesPerRow, 256);
		const size = paddedBytesPerRow * height;
		const device = texture.device;
		const stagingBuffer = device.createBufferImpl(BUFFERUSAGE_READ | BUFFERUSAGE_COPY_DST);
		stagingBuffer.allocate(device, size);
		const src = {
			texture: this.gpuTexture,
			mipLevel,
			origin: [x3, y2, face]
		};
		const dst = {
			buffer: stagingBuffer.buffer,
			offset: 0,
			bytesPerRow: paddedBytesPerRow
		};
		const copySize = {
			width,
			height,
			depthOrArrayLayers: 1
			// single layer
		};
		const commandEncoder = device.getCommandEncoder();
		commandEncoder.copyTextureToBuffer(src, dst, copySize);
		return device.readBuffer(stagingBuffer, size, null, immediate).then((temp) => {
			const ArrayType = getPixelFormatArrayType(texture.format);
			const targetBuffer = data2?.buffer ?? new ArrayBuffer(height * bytesPerRow);
			const target2 = new Uint8Array(targetBuffer, data2?.byteOffset ?? 0, height * bytesPerRow);
			for (let i2 = 0; i2 < height; i2++) {
				const srcOffset = i2 * paddedBytesPerRow;
				const dstOffset = i2 * bytesPerRow;
				target2.set(temp.subarray(srcOffset, srcOffset + bytesPerRow), dstOffset);
			}
			return data2 ?? new ArrayType(targetBuffer);
		});
	}
	copy(source, options2) {
		const device = this.texture.device;
		const sourceMipLevel = options2.sourceMipLevel ?? 0;
		const destMipLevel = options2.destMipLevel ?? 0;
		const face = options2.face ?? 0;
		const sx = options2.sourceX ?? 0;
		const sy = options2.sourceY ?? 0;
		const dx = options2.destX ?? 0;
		const dy = options2.destY ?? 0;
		const w = options2.width ?? Math.max(1, source.width >> sourceMipLevel);
		const h2 = options2.height ?? Math.max(1, source.height >> sourceMipLevel);
		device._uploadDirtyTextures();
		const commandEncoder = device.getCommandEncoder();
		commandEncoder.copyTextureToTexture(
			{ texture: source.impl.gpuTexture, mipLevel: sourceMipLevel, origin: [sx, sy, face] },
			{ texture: this.gpuTexture, mipLevel: destMipLevel, origin: [dx, dy, face] },
			{ width: w, height: h2, depthOrArrayLayers: 1 }
		);
		return true;
	}
};

var WebgpuUniformBuffer = class extends WebgpuBuffer {
	constructor(uniformBuffer) {
		super(BUFFERUSAGE_UNIFORM);
	}
	unlock(uniformBuffer) {
		const device = uniformBuffer.device;
		super.unlock(device, uniformBuffer.storageInt32.buffer);
	}
};

var WebgpuVertexBuffer = class extends WebgpuBuffer {
	constructor(vertexBuffer, format, options2) {
		super(BUFFERUSAGE_VERTEX | (options2?.storage ? BUFFERUSAGE_STORAGE : 0));
	}
	unlock(vertexBuffer) {
		const device = vertexBuffer.device;
		super.unlock(device, vertexBuffer.storage);
	}
};

var KEYWORD3 = /[ \t]*#(ifn?def|if|endif|else|elif|define|undef|extension|include)/g;
var DEFINE = /define[ \t]+([^\n]+)\r?(?:\n|$)/g;
var EXTENSION = /extension[ \t]+([\w-]+)[ \t]*:[ \t]*(enable|require)/g;
var UNDEF = /undef[ \t]+([^\n]+)\r?(?:\n|$)/g;
var IF = /(ifdef|ifndef|if)[ \t]*([^\r\n]+)\r?\n/g;
var ENDIF = /(endif|else|elif)(?:[ \t]+([^\r\n]*))?\r?\n?/g;
var IDENTIFIER = /\{?[\w-]+\}?/;
var DEFINED = /(!|\s)?defined\(([\w-]+)\)/;
var DEFINED_PARENS = /!?defined\s*\([^)]*\)/g;
var DEFINED_BEFORE_PAREN = /!?defined\s*$/;
var COMPARISON = /([a-z_]\w*)\s*(==|!=|<|<=|>|>=)\s*([\w"']+)/i;
var INVALID = /[+\-]/g;
var INCLUDE = /include[ \t]+"([\w-]+)(?:\s*,\s*([\w-]+))?"/g;
var LOOP_INDEX = /\{i\}/g;
var FRAGCOLOR = /(pcFragColor[1-8])\b/g;
var NUMERIC_LITERAL = /^\d+(?:\.\d+)?$/;
var Preprocessor = class _Preprocessor {
	static sourceName;
	static run(source, includes = /* @__PURE__ */ new Map(), options2 = {}) {
		_Preprocessor.sourceName = options2.sourceName;
		source = this.stripComments(source);
		source = source.split(/\r?\n/).map((line) => line.trimEnd()).join("\n");
		const defines = /* @__PURE__ */ new Map();
		const injectDefines = /* @__PURE__ */ new Map();
		source = this._preprocess(source, defines, injectDefines, includes, options2.stripDefines);
		if (source === null) return null;
		const intDefines = /* @__PURE__ */ new Map();
		defines.forEach((value, key) => {
			if (Number.isInteger(parseFloat(value)) && !value.includes(".")) {
				intDefines.set(key, value);
			}
		});
		source = this.stripComments(source);
		source = this.stripUnusedColorAttachments(source, options2);
		source = this.RemoveEmptyLines(source);
		source = this.processArraySize(source, intDefines);
		source = this.injectDefines(source, injectDefines);
		return source;
	}
	static stripUnusedColorAttachments(source, options2) {
		if (options2.stripUnusedColorAttachments) {
			const counts = /* @__PURE__ */ new Map();
			const matches = source.match(FRAGCOLOR);
			matches?.forEach((match) => {
				const index = parseInt(match.charAt(match.length - 1), 10);
				counts.set(index, (counts.get(index) ?? 0) + 1);
			});
			const anySingleUse = Array.from(counts.values()).some((count) => count === 1);
			if (anySingleUse) {
				const lines = source.split("\n");
				const keepLines = [];
				for (let i2 = 0; i2 < lines.length; i2++) {
					const match = lines[i2].match(FRAGCOLOR);
					if (match) {
						const index = parseInt(match[0].charAt(match[0].length - 1), 10);
						if (index > 0 && counts.get(index) === 1) {
							continue;
						}
					}
					keepLines.push(lines[i2]);
				}
				source = keepLines.join("\n");
			}
		}
		return source;
	}
	static stripComments(source) {
		return source.replace(/\/\*[\s\S]*?\*\/|([^\\:]|^)\/\/.*$/gm, "$1");
	}
	static processArraySize(source, intDefines) {
		if (source !== null) {
			intDefines.forEach((value, key) => {
				source = source.replace(new RegExp(`\\[${key}\\]`, "g"), `[${value}]`);
			});
		}
		return source;
	}
	static injectDefines(source, injectDefines) {
		if (source !== null && injectDefines.size > 0) {
			const lines = source.split("\n");
			injectDefines.forEach((value, key) => {
				const regex = new RegExp(key, "g");
				for (let i2 = 0; i2 < lines.length; i2++) {
					if (!lines[i2].includes("#")) {
						lines[i2] = lines[i2].replace(regex, value);
					}
				}
			});
			source = lines.join("\n");
		}
		return source;
	}
	static RemoveEmptyLines(source) {
		if (source !== null) {
			source = source.split(/\r?\n/).map((line) => line.trim() === "" ? "" : line).join("\n");
			source = source.replace(/(\n\n){3,}/g, "\n\n");
		}
		return source;
	}
	static _preprocess(source, defines = /* @__PURE__ */ new Map(), injectDefines, includes, stripDefines) {
		const originalSource = source;
		const stack = [];
		let error = false;
		let match;
		while ((match = KEYWORD3.exec(source)) !== null && !error) {
			const keyword = match[1];
			switch (keyword) {
				case "define": {
					DEFINE.lastIndex = match.index;
					const define = DEFINE.exec(source);
					error || (error = define === null);
					const expression = define[1];
					IDENTIFIER.lastIndex = define.index;
					const identifierValue = IDENTIFIER.exec(expression);
					const identifier = identifierValue[0];
					let value = expression.substring(identifier.length).trim();
					if (value === "") value = "true";
					const keep = _Preprocessor._keep(stack);
					let stripThisDefine = stripDefines;
					if (keep) {
						const replacementDefine = identifier.startsWith("{") && identifier.endsWith("}");
						if (replacementDefine) {
							stripThisDefine = true;
						}
						if (replacementDefine) {
							injectDefines.set(identifier, value);
						} else {
							defines.set(identifier, value);
						}
						if (stripThisDefine) {
							source = source.substring(0, define.index - 1) + source.substring(DEFINE.lastIndex);
							KEYWORD3.lastIndex = define.index - 1;
						}
					}
					if (!stripThisDefine) {
						KEYWORD3.lastIndex = define.index + define[0].length;
					}
					break;
				}
				case "undef": {
					UNDEF.lastIndex = match.index;
					const undef = UNDEF.exec(source);
					const identifier = undef[1].trim();
					const keep = _Preprocessor._keep(stack);
					if (keep) {
						defines.delete(identifier);
						if (stripDefines) {
							source = source.substring(0, undef.index - 1) + source.substring(UNDEF.lastIndex);
							KEYWORD3.lastIndex = undef.index - 1;
						}
					}
					if (!stripDefines) {
						KEYWORD3.lastIndex = undef.index + undef[0].length;
					}
					break;
				}
				case "extension": {
					EXTENSION.lastIndex = match.index;
					const extension = EXTENSION.exec(source);
					error || (error = extension === null);
					if (extension) {
						const identifier = extension[1];
						const keep = _Preprocessor._keep(stack);
						if (keep) {
							defines.set(identifier, "true");
						}
					}
					KEYWORD3.lastIndex = extension.index + extension[0].length;
					break;
				}
				case "ifdef":
				case "ifndef":
				case "if": {
					IF.lastIndex = match.index;
					const iff = IF.exec(source);
					const expression = iff[2];
					const evaluated = _Preprocessor.evaluate(expression, defines);
					error || (error = evaluated.error);
					let result = evaluated.result;
					if (keyword === "ifndef") {
						result = !result;
					}
					stack.push({
						anyKeep: result,
						// true if any branch was already accepted
						keep: result,
						// true if this branch is being taken
						start: match.index,
						// start index if IF line
						end: IF.lastIndex
						// end index of IF line
					});
					KEYWORD3.lastIndex = iff.index + iff[0].length;
					break;
				}
				case "endif":
				case "else":
				case "elif": {
					ENDIF.lastIndex = match.index;
					const endif = ENDIF.exec(source);
					const blockInfo = stack.pop();
					if (!blockInfo) {
						console.error(`Shader preprocessing encountered "#${endif[1]}" without a preceding #if #ifdef #ifndef while preprocessing ${_Preprocessor.sourceName} on line:
 ${source.substring(match.index, match.index + 100)}...`, { source: originalSource });
						error = true;
						continue;
					}
					const blockCode = blockInfo.keep ? source.substring(blockInfo.end, match.index) : "";
					source = source.substring(0, blockInfo.start) + blockCode + source.substring(ENDIF.lastIndex);
					KEYWORD3.lastIndex = blockInfo.start + blockCode.length;
					const endifCommand = endif[1];
					if (endifCommand === "else" || endifCommand === "elif") {
						let result = false;
						if (!blockInfo.anyKeep) {
							if (endifCommand === "else") {
								result = !blockInfo.keep;
							} else {
								const evaluated = _Preprocessor.evaluate(endif[2], defines);
								result = evaluated.result;
								error || (error = evaluated.error);
							}
						}
						stack.push({
							anyKeep: blockInfo.anyKeep || result,
							keep: result,
							start: KEYWORD3.lastIndex,
							end: KEYWORD3.lastIndex
						});
					}
					break;
				}
				case "include": {
					INCLUDE.lastIndex = match.index;
					const include = INCLUDE.exec(source);
					error || (error = include === null);
					if (!include) {
						error = true;
						continue;
					}
					const identifier = include[1].trim();
					const countIdentifier = include[2]?.trim();
					const keep = _Preprocessor._keep(stack);
					if (keep) {
						let includeSource = includes?.get(identifier);
						if (includeSource !== void 0) {
							includeSource = this.stripComments(includeSource);
							if (countIdentifier) {
								const countString = defines.get(countIdentifier);
								const count = parseFloat(countString);
								if (Number.isInteger(count)) {
									let result = "";
									for (let i2 = 0; i2 < count; i2++) {
										result += includeSource.replace(LOOP_INDEX, String(i2));
									}
									includeSource = result;
								} else {
									console.error(`Include Count identifier "${countIdentifier}" not resolved while preprocessing ${_Preprocessor.sourceName} on line:
 ${source.substring(match.index, match.index + 100)}...`, { originalSource, source });
									error = true;
								}
							}
							source = source.substring(0, include.index - 1) + includeSource + source.substring(INCLUDE.lastIndex);
							KEYWORD3.lastIndex = include.index - 1;
						} else {
							console.error(`Include "${identifier}" not resolved while preprocessing ${_Preprocessor.sourceName}`, { originalSource, source });
							error = true;
							continue;
						}
					}
					break;
				}
			}
		}
		if (stack.length > 0) {
			console.error(`Shader preprocessing reached the end of the file without encountering the necessary #endif to close a preceding #if, #ifdef, or #ifndef block. ${_Preprocessor.sourceName}`);
			error = true;
		}
		if (error) {
			console.error("Failed to preprocess shader: ", { source: originalSource });
			return null;
		}
		return source;
	}
	// function returns true if the evaluation is inside keep branches
	static _keep(stack) {
		for (let i2 = 0; i2 < stack.length; i2++) {
			if (!stack[i2].keep) {
				return false;
			}
		}
		return true;
	}
	static evaluateAtomicExpression(expr, defines) {
		let error = false;
		expr = expr.trim();
		let invert = false;
		if (expr === "true") {
			return { result: true, error };
		}
		if (expr === "false") {
			return { result: false, error };
		}
		if (NUMERIC_LITERAL.test(expr)) {
			return { result: parseFloat(expr) !== 0, error };
		}
		const definedMatch = DEFINED.exec(expr);
		if (definedMatch) {
			invert = definedMatch[1] === "!";
			expr = definedMatch[2].trim();
			const exists = defines.has(expr);
			return { result: invert ? !exists : exists, error };
		}
		const comparisonMatch = COMPARISON.exec(expr);
		if (comparisonMatch) {
			const left = defines.get(comparisonMatch[1].trim()) ?? comparisonMatch[1].trim();
			const right2 = defines.get(comparisonMatch[3].trim()) ?? comparisonMatch[3].trim();
			const operator = comparisonMatch[2].trim();
			let result2 = false;
			switch (operator) {
				case "==":
					result2 = left === right2;
					break;
				case "!=":
					result2 = left !== right2;
					break;
				case "<":
					result2 = left < right2;
					break;
				case "<=":
					result2 = left <= right2;
					break;
				case ">":
					result2 = left > right2;
					break;
				case ">=":
					result2 = left >= right2;
					break;
				default:
					error = true;
			}
			return { result: result2, error };
		}
		const result = defines.has(expr);
		return { result, error };
	}
	static processParentheses(expression, defines) {
		let error = false;
		let processed = expression.trim();
		while (processed.startsWith("(") && processed.endsWith(")")) {
			let depth = 0;
			let wrapsEntire = true;
			for (let i2 = 0; i2 < processed.length - 1; i2++) {
				if (processed[i2] === "(") depth++;
				else if (processed[i2] === ")") {
					depth--;
					if (depth === 0) {
						wrapsEntire = false;
						break;
					}
				}
			}
			if (wrapsEntire) {
				processed = processed.slice(1, -1).trim();
			} else {
				break;
			}
		}
		while (true) {
			let foundParen = false;
			let depth = 0;
			let maxDepth = 0;
			let deepestStart = -1;
			let deepestEnd = -1;
			let inDefinedParen = 0;
			for (let i2 = 0; i2 < processed.length; i2++) {
				if (processed[i2] === "(") {
					const beforeParen = processed.substring(0, i2);
					if (DEFINED_BEFORE_PAREN.test(beforeParen)) {
						inDefinedParen++;
					} else if (inDefinedParen === 0) {
						depth++;
						if (depth > maxDepth) {
							maxDepth = depth;
							deepestStart = i2;
						}
						foundParen = true;
					}
				} else if (processed[i2] === ")") {
					if (inDefinedParen > 0) {
						inDefinedParen--;
					} else if (depth > 0) {
						if (depth === maxDepth && deepestStart !== -1) {
							deepestEnd = i2;
						}
						depth--;
					}
				}
			}
			if (!foundParen || deepestStart === -1 || deepestEnd === -1) {
				break;
			}
			const subExpr = processed.substring(deepestStart + 1, deepestEnd);
			const { result, error: subError } = _Preprocessor.evaluate(subExpr, defines);
			error = error || subError;
			processed = processed.substring(0, deepestStart) + (result ? "true" : "false") + processed.substring(deepestEnd + 1);
		}
		return { expression: processed, error };
	}
	static evaluate(expression, defines) {
		const correct = INVALID.exec(expression) === null;
		let processedExpr = expression;
		let parenError = false;
		const withoutDefined = expression.replace(DEFINED_PARENS, "");
		if (withoutDefined.indexOf("(") !== -1) {
			const processed = _Preprocessor.processParentheses(expression, defines);
			processedExpr = processed.expression;
			parenError = processed.error;
		}
		if (parenError) {
			return { result: false, error: true };
		}
		const orSegments = processedExpr.split("||");
		for (const orSegment of orSegments) {
			const andSegments = orSegment.split("&&");
			let andResult = true;
			for (const andSegment of andSegments) {
				const { result, error } = _Preprocessor.evaluateAtomicExpression(andSegment.trim(), defines);
				if (!result || error) {
					andResult = false;
					break;
				}
			}
			if (andResult) {
				return { result: true, error: !correct };
			}
		}
		return { result: false, error: !correct };
	}
};

var gles3_default = `
#ifndef outType_0
#define outType_0 vec4
#endif
layout(location = 0) out highp outType_0 pcFragColor0;
#if COLOR_ATTACHMENT_1
layout(location = 1) out highp outType_1 pcFragColor1;
#endif
#if COLOR_ATTACHMENT_2
layout(location = 2) out highp outType_2 pcFragColor2;
#endif
#if COLOR_ATTACHMENT_3
layout(location = 3) out highp outType_3 pcFragColor3;
#endif
#if COLOR_ATTACHMENT_4
layout(location = 4) out highp outType_4 pcFragColor4;
#endif
#if COLOR_ATTACHMENT_5
layout(location = 5) out highp outType_5 pcFragColor5;
#endif
#if COLOR_ATTACHMENT_6
layout(location = 6) out highp outType_6 pcFragColor6;
#endif
#if COLOR_ATTACHMENT_7
layout(location = 7) out highp outType_7 pcFragColor7;
#endif
#define gl_FragColor pcFragColor0
#define varying in
#define texture2D texture
#define texture2DBias texture
#define textureCube texture
#define texture2DProj textureProj
#define texture2DLod textureLod
#define texture2DProjLod textureProjLod
#define textureCubeLod textureLod
#define texture2DGrad textureGrad
#define texture2DProjGrad textureProjGrad
#define textureCubeGrad textureGrad
#define utexture2D texture
#define itexture2D texture
#define texture2DLodEXT texture2DLodEXT_is_no_longer_supported_use_texture2DLod_instead
#define texture2DProjLodEXT texture2DProjLodEXT_is_no_longer_supported_use_texture2DProjLod
#define textureCubeLodEXT textureCubeLodEXT_is_no_longer_supported_use_textureCubeLod_instead
#define texture2DGradEXT texture2DGradEXT_is_no_longer_supported_use_texture2DGrad_instead
#define texture2DProjGradEXT texture2DProjGradEXT_is_no_longer_supported_use_texture2DProjGrad_instead
#define textureCubeGradEXT textureCubeGradEXT_is_no_longer_supported_use_textureCubeGrad_instead
#define textureShadow(res, uv) textureGrad(res, uv, vec2(1, 1), vec2(1, 1))
#define SHADOWMAP_PASS(name) name
#define SHADOWMAP_ACCEPT(name) sampler2DShadow name
#define TEXTURE_PASS(name) name
#define TEXTURE_ACCEPT(name) sampler2D name
#define TEXTURE_ACCEPT_HIGHP(name) highp sampler2D name
#define GL2
`;

var gles3_default2 = `
#extension GL_ANGLE_multi_draw : enable
#define attribute in
#define varying out
#define texture2D texture
#define utexture2D texture
#define itexture2D texture
#define GL2
#define VERTEXSHADER
#define TEXTURE_PASS(name) name
#define TEXTURE_ACCEPT(name) sampler2D name
#define TEXTURE_ACCEPT_HIGHP(name) highp sampler2D name
`;

var webgpu_default = `
#extension GL_EXT_samplerless_texture_functions : require
#ifndef outType_0
#define outType_0 vec4
#endif
#ifndef outType_1
#define outType_1 vec4
#endif
#ifndef outType_2
#define outType_2 vec4
#endif
#ifndef outType_3
#define outType_3 vec4
#endif
#ifndef outType_4
#define outType_4 vec4
#endif
#ifndef outType_5
#define outType_5 vec4
#endif
#ifndef outType_6
#define outType_6 vec4
#endif
#ifndef outType_7
#define outType_7 vec4
#endif
layout(location = 0) out highp outType_0 pcFragColor0;
layout(location = 1) out highp outType_1 pcFragColor1;
layout(location = 2) out highp outType_2 pcFragColor2;
layout(location = 3) out highp outType_3 pcFragColor3;
layout(location = 4) out highp outType_4 pcFragColor4;
layout(location = 5) out highp outType_5 pcFragColor5;
layout(location = 6) out highp outType_6 pcFragColor6;
layout(location = 7) out highp outType_7 pcFragColor7;
#define gl_FragColor pcFragColor0
#define texture2D(res, uv) texture(sampler2D(res, res ## _sampler), uv)
#define texture2DBias(res, uv, bias) texture(sampler2D(res, res ## _sampler), uv, bias)
#define texture2DLod(res, uv, lod) textureLod(sampler2D(res, res ## _sampler), uv, lod)
#define textureCube(res, uv) texture(samplerCube(res, res ## _sampler), uv)
#define textureCubeLod(res, uv, lod) textureLod(samplerCube(res, res ## _sampler), uv, lod)
#define textureShadow(res, uv) textureLod(sampler2DShadow(res, res ## _sampler), uv, 0.0)
#define itexture2D(res, uv) texture(isampler2D(res, res ## _sampler), uv)
#define utexture2D(res, uv) texture(usampler2D(res, res ## _sampler), uv)
#define texture2DLodEXT texture2DLodEXT_is_no_longer_supported_use_texture2DLod_instead
#define texture2DProjLodEXT texture2DProjLodEXT_is_no_longer_supported_use_texture2DProjLod
#define textureCubeLodEXT textureCubeLodEXT_is_no_longer_supported_use_textureCubeLod_instead
#define texture2DGradEXT texture2DGradEXT_is_no_longer_supported_use_texture2DGrad_instead
#define texture2DProjGradEXT texture2DProjGradEXT_is_no_longer_supported_use_texture2DProjGrad_instead
#define textureCubeGradEXT textureCubeGradEXT_is_no_longer_supported_use_textureCubeGrad_instead
#define SHADOWMAP_PASS(name) name, name ## _sampler
#define SHADOWMAP_ACCEPT(name) texture2D name, sampler name ## _sampler
#define TEXTURE_PASS(name) name, name ## _sampler
#define TEXTURE_ACCEPT(name) texture2D name, sampler name ## _sampler
#define TEXTURE_ACCEPT_HIGHP TEXTURE_ACCEPT
#define GL2
#define WEBGPU
`;

var webgpu_default2 = `
#extension GL_EXT_samplerless_texture_functions : require
#define texture2D(res, uv) texture(sampler2D(res, res ## _sampler), uv)
#define itexture2D(res, uv) texture(isampler2D(res, res ## _sampler), uv)
#define utexture2D(res, uv) texture(usampler2D(res, res ## _sampler), uv)
#define TEXTURE_PASS(name) name, name ## _sampler
#define TEXTURE_ACCEPT(name) texture2D name, sampler name ## _sampler
#define TEXTURE_ACCEPT_HIGHP TEXTURE_ACCEPT
#define GL2
#define WEBGPU
#define VERTEXSHADER
#define gl_VertexID gl_VertexIndex
#define gl_InstanceID gl_InstanceIndex
`;

var webgpu_wgsl_default = `
`;

var webgpu_wgsl_default2 = `
#define VERTEXSHADER
`;

var shared_default = `
vec2 getGrabScreenPos(vec4 clipPos) {
	vec2 uv = (clipPos.xy / clipPos.w) * 0.5 + 0.5;
	#ifdef WEBGPU
		uv.y = 1.0 - uv.y;
	#endif
	return uv;
}
vec2 getImageEffectUV(vec2 uv) {
	#ifdef WEBGPU
		uv.y = 1.0 - uv.y;
	#endif
	return uv;
}
`;

var shared_wgsl_default = `
#define WEBGPU
fn getGrabScreenPos(clipPos: vec4<f32>) -> vec2<f32> {
	var uv: vec2<f32> = (clipPos.xy / clipPos.w) * 0.5 + vec2<f32>(0.5);
	uv.y = 1.0 - uv.y;
	return uv;
}
fn getImageEffectUV(uv: vec2<f32>) -> vec2<f32> {
	var modifiedUV: vec2<f32> = uv;
	modifiedUV.y = 1.0 - modifiedUV.y;
	return modifiedUV;
}
struct WrappedF32 { @size(16) element: f32 }
struct WrappedI32 { @size(16) element: i32 }
struct WrappedU32 { @size(16) element: u32 }
struct WrappedVec2F { @size(16) element: vec2f }
struct WrappedVec2I { @size(16) element: vec2i }
struct WrappedVec2U { @size(16) element: vec2u }
`;

var half_types_default = `
#ifdef CAPS_SHADER_F16
	alias half = f16;
	alias half2 = vec2<f16>;
	alias half3 = vec3<f16>;
	alias half4 = vec4<f16>;
	alias half2x2 = mat2x2<f16>;
	alias half3x3 = mat3x3<f16>;
	alias half4x4 = mat4x4<f16>;
#else
	alias half = f32;
	alias half2 = vec2f;
	alias half3 = vec3f;
	alias half4 = vec4f;
	alias half2x2 = mat2x2f;
	alias half3x3 = mat3x3f;
	alias half4x4 = mat4x4f;
#endif
`;

var _attrib2Semantic = {
	vertex_position: SEMANTIC_POSITION,
	vertex_normal: SEMANTIC_NORMAL,
	vertex_tangent: SEMANTIC_TANGENT,
	vertex_texCoord0: SEMANTIC_TEXCOORD0,
	vertex_texCoord1: SEMANTIC_TEXCOORD1,
	vertex_texCoord2: SEMANTIC_TEXCOORD2,
	vertex_texCoord3: SEMANTIC_TEXCOORD3,
	vertex_texCoord4: SEMANTIC_TEXCOORD4,
	vertex_texCoord5: SEMANTIC_TEXCOORD5,
	vertex_texCoord6: SEMANTIC_TEXCOORD6,
	vertex_texCoord7: SEMANTIC_TEXCOORD7,
	vertex_color: SEMANTIC_COLOR,
	vertex_boneIndices: SEMANTIC_BLENDINDICES,
	vertex_boneWeights: SEMANTIC_BLENDWEIGHT
};
var ShaderDefinitionUtils = class _ShaderDefinitionUtils {
	static createDefinition(device, options2) {
		const normalizedOutputTypes = (options3) => {
			let fragmentOutputTypes = options3.fragmentOutputTypes ?? "vec4";
			if (!Array.isArray(fragmentOutputTypes)) {
				fragmentOutputTypes = [fragmentOutputTypes];
			}
			return fragmentOutputTypes;
		};
		const getDefines = (gpu, gl2, isVertex, options3) => {
			const deviceIntro = device.isWebGPU ? gpu : gl2;
			let attachmentsDefine = "";
			if (!isVertex) {
				const fragmentOutputTypes = normalizedOutputTypes(options3);
				for (let i2 = 0; i2 < device.maxColorAttachments; i2++) {
					attachmentsDefine += `#define COLOR_ATTACHMENT_${i2}
`;
					const outType = fragmentOutputTypes[i2] ?? "vec4";
					attachmentsDefine += `#define outType_${i2} ${outType}
`;
				}
			}
			return attachmentsDefine + deviceIntro;
		};
		const getDefinesWgsl = (isVertex, options3) => {
			let code = _ShaderDefinitionUtils.getWGSLEnables(device, isVertex ? "vertex" : "fragment");
			if (!isVertex) {
				const fragmentOutputTypes = normalizedOutputTypes(options3);
				for (let i2 = 0; i2 < device.maxColorAttachments; i2++) {
					const glslOutType = fragmentOutputTypes[i2] ?? "vec4";
					const wgslOutType = primitiveGlslToWgslTypeMap.get(glslOutType);
					code += `alias pcOutType${i2} = ${wgslOutType};
`;
				}
			}
			return code;
		};
		const name = options2.name ?? "Untitled";
		let vertCode;
		let fragCode;
		const vertexDefinesCode = _ShaderDefinitionUtils.getDefinesCode(device, options2.vertexDefines);
		const fragmentDefinesCode = _ShaderDefinitionUtils.getDefinesCode(device, options2.fragmentDefines);
		const wgsl = options2.shaderLanguage === SHADERLANGUAGE_WGSL;
		if (wgsl) {
			vertCode = `
								${getDefinesWgsl(true, options2)}
								${vertexDefinesCode}
								${half_types_default}
								${webgpu_wgsl_default2}
								${shared_wgsl_default}
								${options2.vertexCode}
						`;
			fragCode = `
								${getDefinesWgsl(false, options2)}
								${fragmentDefinesCode}
								${half_types_default}
								${webgpu_wgsl_default}
								${shared_wgsl_default}
								${options2.fragmentCode}
						`;
		} else {
			vertCode = `${_ShaderDefinitionUtils.versionCode(device) + getDefines(webgpu_default2, gles3_default2, true, options2) + vertexDefinesCode + _ShaderDefinitionUtils.precisionCode(device)}
								${shared_default}
								${_ShaderDefinitionUtils.getShaderNameCode(name)}
								${options2.vertexCode}`;
			fragCode = `${(options2.fragmentPreamble || "") + _ShaderDefinitionUtils.versionCode(device) + getDefines(webgpu_default, gles3_default, false, options2) + fragmentDefinesCode + _ShaderDefinitionUtils.precisionCode(device)}
								${shared_default}
								${_ShaderDefinitionUtils.getShaderNameCode(name)}
								${options2.fragmentCode}`;
		}
		return {
			name,
			shaderLanguage: options2.shaderLanguage ?? SHADERLANGUAGE_GLSL,
			attributes: options2.attributes,
			vshader: vertCode,
			vincludes: options2.vertexIncludes,
			fincludes: options2.fragmentIncludes,
			fshader: fragCode,
			feedbackVaryings: options2.feedbackVaryings,
			useTransformFeedback: options2.useTransformFeedback,
			meshUniformBufferFormat: options2.meshUniformBufferFormat,
			meshBindGroupFormat: options2.meshBindGroupFormat
		};
	}
	static getWGSLEnables(device, shaderType) {
		let code = "";
		if (device.supportsShaderF16) {
			code += "enable f16;\n";
		}
		if (shaderType === "fragment" && device.supportsPrimitiveIndex) {
			code += "enable primitive_index;\n";
		}
		if (device.supportsSubgroups) {
			code += "enable subgroups;\n";
		}
		if (device.supportsSubgroupId) {
			code += "requires subgroup_id;\n";
		}
		if (shaderType === "compute" && device.supportsLinearIndexing) {
			code += "requires linear_indexing;\n";
		}
		if (device.supportsUnrestrictedPointerParameters) {
			code += "requires unrestricted_pointer_parameters;\n";
		}
		if (device.supportsPointerCompositeAccess) {
			code += "requires pointer_composite_access;\n";
		}
		if (device.supportsPacked4x8IntegerDotProduct) {
			code += "requires packed_4x8_integer_dot_product;\n";
		}
		if (device.supportsTextureAndSamplerLet) {
			code += "requires texture_and_sampler_let;\n";
		}
		return code;
	}
	static getDefinesCode(device, defines) {
		let code = "";
		device.capsDefines.forEach((value, key) => {
			code += `#define ${key} ${value}
`;
		});
		code += "\n";
		defines?.forEach((value, key) => {
			code += `#define ${key} ${value}
`;
		});
		code += "\n";
		return code;
	}
	// SpectorJS integration
	static getShaderNameCode(name) {
		return `#define SHADER_NAME ${name}
`;
	}
	static versionCode(device) {
		return device.isWebGPU ? "#version 450\n" : "#version 300 es\n";
	}
	static precisionCode(device, forcePrecision) {
		if (forcePrecision && forcePrecision !== "highp" && forcePrecision !== "mediump" && forcePrecision !== "lowp") {
			forcePrecision = null;
		}
		if (forcePrecision) {
			if (forcePrecision === "highp" && device.maxPrecision !== "highp") {
				forcePrecision = "mediump";
			}
			if (forcePrecision === "mediump" && device.maxPrecision === "lowp") {
				forcePrecision = "lowp";
			}
		}
		const precision = forcePrecision ? forcePrecision : device.precision;
		const code = `
						precision ${precision} float;
						precision ${precision} int;
						precision ${precision} usampler2D;
						precision ${precision} isampler2D;
						precision ${precision} sampler2DShadow;
						precision ${precision} samplerCubeShadow;
						precision ${precision} sampler2DArray;
				`;
		return code;
	}
	static collectAttributes(vsCode) {
		const attribs = {};
		let attrs = 0;
		let found = vsCode.indexOf("attribute");
		while (found >= 0) {
			if (found > 0 && vsCode[found - 1] === "/") break;
			let ignore = false;
			if (found > 0) {
				let startOfLine = vsCode.lastIndexOf("\n", found);
				startOfLine = startOfLine !== -1 ? startOfLine + 1 : 0;
				const lineStartString = vsCode.substring(startOfLine, found);
				if (lineStartString.includes("#")) {
					ignore = true;
				}
			}
			if (!ignore) {
				const endOfLine = vsCode.indexOf(";", found);
				const startOfAttribName = vsCode.lastIndexOf(" ", endOfLine);
				const attribName = vsCode.substring(startOfAttribName + 1, endOfLine);
				if (attribs[attribName]) {
				} else {
					const semantic = _attrib2Semantic[attribName];
					if (semantic !== void 0) {
						attribs[attribName] = semantic;
					} else {
						attribs[attribName] = `ATTR${attrs}`;
						attrs++;
					}
				}
			}
			found = vsCode.indexOf("attribute", found + 1);
		}
		return attribs;
	}
};

var id8 = 0;
var Shader = class {
	meshUniformBufferFormat;
	meshBindGroupFormat;
	attributes = /* @__PURE__ */ new Map();
	constructor(graphicsDevice, definition) {
		this.id = id8++;
		this.device = graphicsDevice;
		this.definition = definition;
		this.name = definition.name || "Untitled";
		this.init();
		if (definition.cshader) {
			const enablesCode = ShaderDefinitionUtils.getWGSLEnables(graphicsDevice, "compute");
			const definesCode = ShaderDefinitionUtils.getDefinesCode(graphicsDevice, definition.cdefines);
			const cshader = enablesCode + definesCode + definition.cshader;
			const cincludes = definition.cincludes ?? /* @__PURE__ */ new Map();
			if (!cincludes.has("halfTypesCS")) {
				cincludes.set("halfTypesCS", half_types_default);
			}
			definition.cshader = Preprocessor.run(cshader, cincludes, {
				sourceName: `compute shader for ${this.label}`,
				stripDefines: true
			});
		} else {
			const wgsl = definition.shaderLanguage === SHADERLANGUAGE_WGSL;
			definition.vshader = Preprocessor.run(definition.vshader, definition.vincludes, {
				sourceName: `vertex shader for ${this.label}`,
				stripDefines: wgsl
			});
			if (definition.shaderLanguage === SHADERLANGUAGE_GLSL) {
				definition.attributes ?? (definition.attributes = ShaderDefinitionUtils.collectAttributes(definition.vshader));
			}
			const stripUnusedColorAttachments = graphicsDevice.isWebGL2 && (platform.name === "osx" || platform.name === "ios");
			definition.fshader = Preprocessor.run(definition.fshader, definition.fincludes, {
				stripUnusedColorAttachments,
				stripDefines: wgsl,
				sourceName: `fragment shader for ${this.label}`
			});
			if (!definition.vshader || !definition.fshader) {
				this.failed = true;
				return;
			}
		}
		this.impl = graphicsDevice.createShaderImpl(this);
	}
	init() {
		this.ready = false;
		this.failed = false;
	}
	get label() {
		return `Shader Id ${this.id} (${this.definition.shaderLanguage === SHADERLANGUAGE_WGSL ? "WGSL" : "GLSL"}) ${this.name}`;
	}
	destroy() {
		this.device.onDestroyShader(this);
		this.impl.destroy(this);
	}
	loseContext() {
		this.init();
		this.impl.loseContext();
	}
	restoreContext() {
		this.impl.restoreContext(this.device, this);
	}
};

var UsedBuffer = class {
	gpuBuffer;
	stagingBuffer;
	offset;
	size;
};
var DynamicBufferAllocation = class {
	storage;
	gpuBuffer;
	offset;
};
var DynamicBuffers = class {
	bufferSize;
	gpuBuffers = [];
	stagingBuffers = [];
	usedBuffers = [];
	activeBuffer = null;
	constructor(device, bufferSize, bufferAlignment) {
		this.device = device;
		this.bufferSize = bufferSize;
		this.bufferAlignment = bufferAlignment;
	}
	destroy() {
		this.gpuBuffers.forEach((gpuBuffer) => {
			gpuBuffer.destroy(this.device);
		});
		this.gpuBuffers = null;
		this.stagingBuffers.forEach((stagingBuffer) => {
			stagingBuffer.destroy(this.device);
		});
		this.stagingBuffers = null;
		this.usedBuffers = null;
		this.activeBuffer = null;
	}
	alloc(allocation, size) {
		if (this.activeBuffer) {
			const alignedStart2 = math.roundUp(this.activeBuffer.size, this.bufferAlignment);
			const space = this.bufferSize - alignedStart2;
			if (space < size) {
				this.scheduleSubmit();
			}
		}
		if (!this.activeBuffer) {
			let gpuBuffer = this.gpuBuffers.pop();
			if (!gpuBuffer) {
				gpuBuffer = this.createBuffer(this.device, this.bufferSize, false);
			}
			let stagingBuffer = this.stagingBuffers.pop();
			if (!stagingBuffer) {
				stagingBuffer = this.createBuffer(this.device, this.bufferSize, true);
			}
			this.activeBuffer = new UsedBuffer();
			this.activeBuffer.stagingBuffer = stagingBuffer;
			this.activeBuffer.gpuBuffer = gpuBuffer;
			this.activeBuffer.offset = 0;
			this.activeBuffer.size = 0;
		}
		const activeBuffer = this.activeBuffer;
		const alignedStart = math.roundUp(activeBuffer.size, this.bufferAlignment);
		allocation.gpuBuffer = activeBuffer.gpuBuffer;
		allocation.offset = alignedStart;
		allocation.storage = activeBuffer.stagingBuffer.alloc(alignedStart, size);
		activeBuffer.size = alignedStart + size;
	}
	scheduleSubmit() {
		if (this.activeBuffer) {
			this.usedBuffers.push(this.activeBuffer);
			this.activeBuffer = null;
		}
	}
	submit() {
		this.scheduleSubmit();
	}
};

var _updateFunctions = [];
_updateFunctions[UNIFORMTYPE_FLOAT] = function(uniformBuffer, value, offset3) {
	const dst = uniformBuffer.storageFloat32;
	dst[offset3] = value;
};
_updateFunctions[UNIFORMTYPE_VEC2] = (uniformBuffer, value, offset3) => {
	const dst = uniformBuffer.storageFloat32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
};
_updateFunctions[UNIFORMTYPE_VEC3] = (uniformBuffer, value, offset3) => {
	const dst = uniformBuffer.storageFloat32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
	dst[offset3 + 2] = value[2];
};
_updateFunctions[UNIFORMTYPE_VEC4] = (uniformBuffer, value, offset3) => {
	const dst = uniformBuffer.storageFloat32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
	dst[offset3 + 2] = value[2];
	dst[offset3 + 3] = value[3];
};
_updateFunctions[UNIFORMTYPE_INT] = function(uniformBuffer, value, offset3) {
	const dst = uniformBuffer.storageInt32;
	dst[offset3] = value;
};
_updateFunctions[UNIFORMTYPE_IVEC2] = function(uniformBuffer, value, offset3) {
	const dst = uniformBuffer.storageInt32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
};
_updateFunctions[UNIFORMTYPE_IVEC3] = function(uniformBuffer, value, offset3) {
	const dst = uniformBuffer.storageInt32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
	dst[offset3 + 2] = value[2];
};
_updateFunctions[UNIFORMTYPE_IVEC4] = function(uniformBuffer, value, offset3) {
	const dst = uniformBuffer.storageInt32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
	dst[offset3 + 2] = value[2];
	dst[offset3 + 3] = value[3];
};
_updateFunctions[UNIFORMTYPE_MAT2] = (uniformBuffer, value, offset3) => {
	const dst = uniformBuffer.storageFloat32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
	dst[offset3 + 4] = value[2];
	dst[offset3 + 5] = value[3];
	dst[offset3 + 8] = value[4];
	dst[offset3 + 9] = value[5];
};
_updateFunctions[UNIFORMTYPE_MAT3] = (uniformBuffer, value, offset3) => {
	const dst = uniformBuffer.storageFloat32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
	dst[offset3 + 2] = value[2];
	dst[offset3 + 4] = value[3];
	dst[offset3 + 5] = value[4];
	dst[offset3 + 6] = value[5];
	dst[offset3 + 8] = value[6];
	dst[offset3 + 9] = value[7];
	dst[offset3 + 10] = value[8];
};
_updateFunctions[UNIFORMTYPE_FLOATARRAY] = function(uniformBuffer, value, offset3, count) {
	const dst = uniformBuffer.storageFloat32;
	for (let i2 = 0; i2 < count; i2++) {
		dst[offset3 + i2 * 4] = value[i2];
	}
};
_updateFunctions[UNIFORMTYPE_VEC2ARRAY] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageFloat32;
	for (let i2 = 0; i2 < count; i2++) {
		dst[offset3 + i2 * 4] = value[i2 * 2];
		dst[offset3 + i2 * 4 + 1] = value[i2 * 2 + 1];
	}
};
_updateFunctions[UNIFORMTYPE_VEC3ARRAY] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageFloat32;
	for (let i2 = 0; i2 < count; i2++) {
		dst[offset3 + i2 * 4] = value[i2 * 3];
		dst[offset3 + i2 * 4 + 1] = value[i2 * 3 + 1];
		dst[offset3 + i2 * 4 + 2] = value[i2 * 3 + 2];
	}
};
_updateFunctions[UNIFORMTYPE_UINT] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageUint32;
	dst[offset3] = value;
};
_updateFunctions[UNIFORMTYPE_UVEC2] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageUint32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
};
_updateFunctions[UNIFORMTYPE_UVEC3] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageUint32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
	dst[offset3 + 2] = value[2];
};
_updateFunctions[UNIFORMTYPE_UVEC4] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageUint32;
	dst[offset3] = value[0];
	dst[offset3 + 1] = value[1];
	dst[offset3 + 2] = value[2];
	dst[offset3 + 3] = value[3];
};
_updateFunctions[UNIFORMTYPE_INTARRAY] = function(uniformBuffer, value, offset3, count) {
	const dst = uniformBuffer.storageInt32;
	for (let i2 = 0; i2 < count; i2++) {
		dst[offset3 + i2 * 4] = value[i2];
	}
};
_updateFunctions[UNIFORMTYPE_BOOLARRAY] = _updateFunctions[UNIFORMTYPE_INTARRAY];
_updateFunctions[UNIFORMTYPE_UINTARRAY] = function(uniformBuffer, value, offset3, count) {
	const dst = uniformBuffer.storageUint32;
	for (let i2 = 0; i2 < count; i2++) {
		dst[offset3 + i2 * 4] = value[i2];
	}
};
_updateFunctions[UNIFORMTYPE_IVEC2ARRAY] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageInt32;
	for (let i2 = 0; i2 < count; i2++) {
		dst[offset3 + i2 * 4] = value[i2 * 2];
		dst[offset3 + i2 * 4 + 1] = value[i2 * 2 + 1];
	}
};
_updateFunctions[UNIFORMTYPE_BVEC2ARRAY] = _updateFunctions[UNIFORMTYPE_IVEC2ARRAY];
_updateFunctions[UNIFORMTYPE_UVEC2ARRAY] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageUint32;
	for (let i2 = 0; i2 < count; i2++) {
		dst[offset3 + i2 * 4] = value[i2 * 2];
		dst[offset3 + i2 * 4 + 1] = value[i2 * 2 + 1];
	}
};
_updateFunctions[UNIFORMTYPE_IVEC3ARRAY] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageInt32;
	for (let i2 = 0; i2 < count; i2++) {
		dst[offset3 + i2 * 4] = value[i2 * 3];
		dst[offset3 + i2 * 4 + 1] = value[i2 * 3 + 1];
		dst[offset3 + i2 * 4 + 2] = value[i2 * 3 + 2];
	}
};
_updateFunctions[UNIFORMTYPE_BVEC3ARRAY] = _updateFunctions[UNIFORMTYPE_IVEC3ARRAY];
_updateFunctions[UNIFORMTYPE_UVEC3ARRAY] = (uniformBuffer, value, offset3, count) => {
	const dst = uniformBuffer.storageUint32;
	for (let i2 = 0; i2 < count; i2++) {
		dst[offset3 + i2 * 4] = value[i2 * 3];
		dst[offset3 + i2 * 4 + 1] = value[i2 * 3 + 1];
		dst[offset3 + i2 * 4 + 2] = value[i2 * 3 + 2];
	}
};
var UniformBuffer = class {
	device;
	persistent;
	allocation;
	storageFloat32;
	storageInt32;
	storageUint32;
	constructor(graphicsDevice, format, persistent = true) {
		this.device = graphicsDevice;
		this.format = format;
		this.persistent = persistent;
		if (persistent) {
			this.impl = graphicsDevice.createUniformBufferImpl(this);
			const storage = new ArrayBuffer(format.byteSize);
			this.assignStorage(new Int32Array(storage));
			graphicsDevice._vram.ub += this.format.byteSize;
			this.device.buffers.add(this);
		} else {
			this.allocation = new DynamicBufferAllocation();
		}
	}
	destroy() {
		if (this.persistent) {
			const device = this.device;
			device.buffers.delete(this);
			this.impl.destroy(device);
			device._vram.ub -= this.format.byteSize;
		}
	}
	get offset() {
		return this.persistent ? 0 : this.allocation.offset;
	}
	assignStorage(storage) {
		this.storageInt32 = storage;
		this.storageUint32 = new Uint32Array(storage.buffer, storage.byteOffset, storage.byteLength / 4);
		this.storageFloat32 = new Float32Array(storage.buffer, storage.byteOffset, storage.byteLength / 4);
	}
	loseContext() {
		this.impl?.loseContext();
	}
	restoreContext() {
		this.impl?.unlock(this);
	}
	setUniform(uniformFormat, value) {
		const offset3 = uniformFormat.offset;
		if (value !== null && value !== void 0) {
			const updateFunction = _updateFunctions[uniformFormat.updateType];
			if (updateFunction) {
				updateFunction(this, value, offset3, uniformFormat.count);
			} else {
				this.storageFloat32.set(value, offset3);
			}
		} else {
		}
	}
	set(name, value) {
		const uniformFormat = this.format.map.get(name);
		if (uniformFormat) {
			this.setUniform(uniformFormat, value);
		}
	}
	startUpdate(dynamicBindGroup) {
		if (!this.persistent) {
			const allocation = this.allocation;
			this.device.dynamicBuffers.alloc(allocation, this.format.byteSize);
			this.assignStorage(allocation.storage);
			if (dynamicBindGroup) {
				dynamicBindGroup.bindGroup = allocation.gpuBuffer.getBindGroup(this);
				dynamicBindGroup.offsets[0] = allocation.offset;
			}
		}
	}
	endUpdate() {
		if (this.persistent) {
			this.impl.unlock(this);
		} else {
			this.allocation.gpuBuffer.upload();
			this.storageFloat32 = null;
			this.storageInt32 = null;
		}
	}
	update(dynamicBindGroup) {
		this.startUpdate(dynamicBindGroup);
		const uniforms = this.format.uniforms;
		for (let i2 = 0; i2 < uniforms.length; i2++) {
			const value = uniforms[i2].scopeId.value;
			this.setUniform(uniforms[i2], value);
		}
		this.endUpdate();
	}
};

var primitive = {
	type: PRIMITIVE_TRISTRIP,
	base: 0,
	baseVertex: 0,
	count: 4,
	indexed: false
};
var WebgpuClearRenderer = class {
	constructor(device) {
		const code = `

						struct ub_mesh {
								color : vec4f,
								depth: f32
						}

						@group(2) @binding(0) var<uniform> ubMesh : ub_mesh;

						var<private> pos : array<vec2f, 4> = array<vec2f, 4>(
								vec2(-1.0, 1.0), vec2(1.0, 1.0),
								vec2(-1.0, -1.0), vec2(1.0, -1.0)
						);

						struct VertexOutput {
								@builtin(position) position : vec4f
						}

						@vertex
						fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
								var output : VertexOutput;
								output.position = vec4(pos[vertexIndex], ubMesh.depth, 1.0);
								return output;
						}

						@fragment
						fn fragmentMain() -> @location(0) vec4f {
								return ubMesh.color;
						}
				`;
		this.shader = new Shader(device, {
			name: "WebGPUClearRendererShader",
			shaderLanguage: SHADERLANGUAGE_WGSL,
			vshader: code,
			fshader: code
		});
		this.uniformBuffer = new UniformBuffer(device, new UniformBufferFormat(device, [
			new UniformFormat("color", UNIFORMTYPE_VEC4),
			new UniformFormat("depth", UNIFORMTYPE_FLOAT)
		]), false);
		this.dynamicBindGroup = new DynamicBindGroup();
		this.colorData = new Float32Array(4);
	}
	destroy() {
		this.shader.destroy();
		this.shader = null;
		this.uniformBuffer.destroy();
		this.uniformBuffer = null;
	}
	clear(device, renderTarget, options2, defaultOptions) {
		options2 = options2 || defaultOptions;
		const flags = options2.flags ?? defaultOptions.flags;
		if (flags !== 0) {
			const { uniformBuffer, dynamicBindGroup } = this;
			uniformBuffer.startUpdate(dynamicBindGroup);
			device.setBindGroup(BINDGROUP_MESH_UB, dynamicBindGroup.bindGroup, dynamicBindGroup.offsets);
			device.setBindGroup(BINDGROUP_MESH, device.emptyBindGroup);
			let blendState;
			if (flags & CLEARFLAG_COLOR && (renderTarget.colorBuffer || renderTarget.impl.assignedColorTexture)) {
				const color3 = options2.color ?? defaultOptions.color;
				this.colorData.set(color3);
				blendState = BlendState.NOBLEND;
			} else {
				blendState = BlendState.NOWRITE;
			}
			uniformBuffer.set("color", this.colorData);
			let depthState;
			if (flags & CLEARFLAG_DEPTH && renderTarget.depth) {
				const depth = options2.depth ?? defaultOptions.depth;
				uniformBuffer.set("depth", depth);
				depthState = DepthState.WRITEDEPTH;
			} else {
				uniformBuffer.set("depth", 1);
				depthState = DepthState.NODEPTH;
			}
			if (flags & CLEARFLAG_STENCIL && renderTarget.stencil) {
			}
			uniformBuffer.endUpdate();
			device.setDrawStates(blendState, depthState);
			device.setShader(this.shader);
			device.draw(primitive);
		}
	}
};

var WebgpuMipmapRenderer = class {
	device;
	pipelineCache = /* @__PURE__ */ new Map();
	constructor(device) {
		this.device = device;
		const code = `
 
						var<private> pos : array<vec2f, 4> = array<vec2f, 4>(
								vec2(-1.0, 1.0), vec2(1.0, 1.0),
								vec2(-1.0, -1.0), vec2(1.0, -1.0)
						);

						struct VertexOutput {
								@builtin(position) position : vec4f,
								@location(0) texCoord : vec2f
						};

						@vertex
						fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
							var output : VertexOutput;
							output.texCoord = pos[vertexIndex] * vec2f(0.5, -0.5) + vec2f(0.5);
							output.position = vec4f(pos[vertexIndex], 0, 1);
							return output;
						}

						@group(0) @binding(0) var imgSampler : sampler;
						@group(0) @binding(1) var img : texture_2d<f32>;

						@fragment
						fn fragmentMain(@location(0) texCoord : vec2f) -> @location(0) vec4f {
							return textureSample(img, imgSampler, texCoord);
						}
				`;
		this.shader = new Shader(device, {
			name: "WebGPUMipmapRendererShader",
			shaderLanguage: SHADERLANGUAGE_WGSL,
			vshader: code,
			fshader: code
		});
		this.minSampler = device.wgpu.createSampler({ minFilter: "linear" });
	}
	destroy() {
		this.shader.destroy();
		this.shader = null;
		this.pipelineCache.clear();
	}
	generate(webgpuTexture) {
		const textureDescr = webgpuTexture.desc;
		if (textureDescr.mipLevelCount <= 1) {
			return;
		}
		if (webgpuTexture.texture.volume) {
			return;
		}
		const device = this.device;
		const wgpu = device.wgpu;
		const format = textureDescr.format;
		let pipeline = this.pipelineCache.get(format);
		if (!pipeline) {
			const webgpuShader = this.shader.impl;
			pipeline = wgpu.createRenderPipeline({
				layout: "auto",
				vertex: {
					module: webgpuShader.getVertexShaderModule(),
					entryPoint: webgpuShader.vertexEntryPoint
				},
				fragment: {
					module: webgpuShader.getFragmentShaderModule(),
					entryPoint: webgpuShader.fragmentEntryPoint,
					targets: [{
						format
					}]
				},
				primitive: {
					topology: "triangle-strip"
				}
			});
			this.pipelineCache.set(format, pipeline);
		}
		const texture = webgpuTexture.texture;
		const numFaces = texture.cubemap ? 6 : texture.array ? texture.arrayLength : 1;
		const srcViews = [];
		for (let face = 0; face < numFaces; face++) {
			srcViews.push(webgpuTexture.createView({
				dimension: "2d",
				baseMipLevel: 0,
				mipLevelCount: 1,
				baseArrayLayer: face
			}));
		}
		const commandEncoder = device.getCommandEncoder();
		for (let i2 = 1; i2 < textureDescr.mipLevelCount; i2++) {
			for (let face = 0; face < numFaces; face++) {
				const dstView = webgpuTexture.createView({
					dimension: "2d",
					baseMipLevel: i2,
					mipLevelCount: 1,
					baseArrayLayer: face
				});
				const passEncoder = commandEncoder.beginRenderPass({
					colorAttachments: [{
						view: dstView,
						loadOp: "clear",
						storeOp: "store"
					}]
				});
				const bindGroup = wgpu.createBindGroup({
					layout: pipeline.getBindGroupLayout(0),
					entries: [{
						binding: 0,
						resource: this.minSampler
					}, {
						binding: 1,
						resource: srcViews[face]
					}]
				});
				passEncoder.setPipeline(pipeline);
				passEncoder.setBindGroup(0, bindGroup);
				passEncoder.draw(4);
				passEncoder.end();
				srcViews[face] = dstView;
			}
		}
		device.pipeline = null;
	}
};

var DynamicBuffer = class {
	device;
	bindGroupCache = /* @__PURE__ */ new Map();
	constructor(device) {
		this.device = device;
		this.bindGroupFormat = new BindGroupFormat(this.device, [
			new BindUniformBufferFormat(UNIFORM_BUFFER_DEFAULT_SLOT_NAME, SHADERSTAGE_VERTEX | SHADERSTAGE_FRAGMENT)
		]);
	}
	upload() {
	}
	getBindGroup(ub) {
		const ubSize = ub.format.byteSize;
		let bindGroup = this.bindGroupCache.get(ubSize);
		if (!bindGroup) {
			bindGroup = new BindGroup(this.device, this.bindGroupFormat, ub);
			bindGroup.update();
			this.bindGroupCache.set(ubSize, bindGroup);
		}
		return bindGroup;
	}
};

var WebgpuDynamicBuffer = class extends DynamicBuffer {
	buffer = null;
	mappedRange = null;
	constructor(device, size, isStaging) {
		super(device);
		this.buffer = device.wgpu.createBuffer({
			size,
			usage: isStaging ? GPUBufferUsage.MAP_WRITE | GPUBufferUsage.COPY_SRC : GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
			mappedAtCreation: isStaging
		});
		if (isStaging) {
			this.onAvailable();
		}
		device._vram.ub += size;
	}
	destroy(device) {
		device._vram.ub -= this.buffer.size;
		this.buffer.destroy();
		this.buffer = null;
	}
	onAvailable() {
		this.mappedRange = this.buffer.getMappedRange();
	}
	alloc(offset3, size) {
		return new Int32Array(this.mappedRange, offset3, size / 4);
	}
};

var WebgpuDynamicBuffers = class extends DynamicBuffers {
	pendingStagingBuffers = [];
	createBuffer(device, size, isStaging) {
		return new WebgpuDynamicBuffer(device, size, isStaging);
	}
	submit() {
		super.submit();
		const count = this.usedBuffers.length;
		if (count) {
			const device = this.device;
			const gpuBuffers = this.gpuBuffers;
			const commandEncoder = device.wgpu.createCommandEncoder();
			for (let i2 = count - 1; i2 >= 0; i2--) {
				const usedBuffer = this.usedBuffers[i2];
				const { stagingBuffer, gpuBuffer, offset: offset3, size } = usedBuffer;
				const src = stagingBuffer.buffer;
				src.unmap();
				commandEncoder.copyBufferToBuffer(src, offset3, gpuBuffer.buffer, offset3, size);
				gpuBuffers.push(gpuBuffer);
			}
			const cb = commandEncoder.finish();
			device.addCommandBuffer(cb, true);
			for (let i2 = 0; i2 < count; i2++) {
				const stagingBuffer = this.usedBuffers[i2].stagingBuffer;
				this.pendingStagingBuffers.push(stagingBuffer);
			}
			this.usedBuffers.length = 0;
		}
	}
	onCommandBuffersSubmitted() {
		const count = this.pendingStagingBuffers.length;
		if (count) {
			for (let i2 = 0; i2 < count; i2++) {
				const stagingBuffer = this.pendingStagingBuffers[i2];
				stagingBuffer.buffer.mapAsync(GPUMapMode.WRITE).then(() => {
					if (this.stagingBuffers) {
						stagingBuffer.onAvailable();
						this.stagingBuffers.push(stagingBuffer);
					}
				});
			}
			this.pendingStagingBuffers.length = 0;
		}
	}
};

var GpuProfiler = class {
	frameAllocations = [];
	pastFrameAllocations = /* @__PURE__ */ new Map();
	_enabled = false;
	_enableRequest = false;
	_frameTime = 0;
	_passTimings = /* @__PURE__ */ new Map();
	_nameCache = /* @__PURE__ */ new Map();
	maxCount = 9999;
	loseContext() {
		this.pastFrameAllocations.clear();
	}
	set enabled(value) {
		this._enableRequest = value;
	}
	get enabled() {
		return this._enableRequest;
	}
	get passTimings() {
		return this._passTimings;
	}
	processEnableRequest() {
		if (this._enableRequest !== this._enabled) {
			this._enabled = this._enableRequest;
			if (!this._enabled) {
				this._frameTime = 0;
			}
		}
	}
	request(renderVersion) {
		this.pastFrameAllocations.set(renderVersion, this.frameAllocations);
		this.frameAllocations = [];
	}
	_parsePassName(name) {
		let parsedName = this._nameCache.get(name);
		if (parsedName === void 0) {
			if (name.startsWith("RenderPass")) {
				parsedName = name.substring(10);
			} else {
				parsedName = name;
			}
			this._nameCache.set(name, parsedName);
		}
		return parsedName;
	}
	report(renderVersion, timings, frameTime) {
		if (timings) {
			const allocations = this.pastFrameAllocations.get(renderVersion);
			if (!allocations) {
				return;
			}
			if (timings.length > 0) {
				this._frameTime = frameTime ?? timings.reduce((sum, t) => sum + t, 0);
			}
			this._passTimings.clear();
			for (let i2 = 0; i2 < allocations.length; ++i2) {
				const name = allocations[i2];
				const timing = timings[i2];
				const parsedName = this._parsePassName(name);
				this._passTimings.set(parsedName, (this._passTimings.get(parsedName) || 0) + timing);
			}
			if (Tracing.get(TRACEID_GPU_TIMINGS)) {
				let total = 0;
				for (let i2 = 0; i2 < allocations.length; ++i2) {
					const name = allocations[i2];
					total += timings[i2];
				}
			}
		}
		this.pastFrameAllocations.delete(renderVersion);
	}
	getSlot(name) {
		if (this.frameAllocations.length >= this.maxCount) {
			return -1;
		}
		const slot = this.frameAllocations.length;
		this.frameAllocations.push(name);
		return slot;
	}
	get slotCount() {
		return this.frameAllocations.length;
	}
};

var WebgpuQuerySet = class {
	querySet;
	stagingBuffers = [];
	activeStagingBuffer = null;
	bytesPerSlot;
	constructor(device, isTimestamp, capacity) {
		this.device = device;
		this.capacity = capacity;
		this.bytesPerSlot = isTimestamp ? 8 : 4;
		const wgpu = device.wgpu;
		this.querySet = wgpu.createQuerySet({
			type: isTimestamp ? "timestamp" : "occlusion",
			count: capacity
		});
		this.queryBuffer = wgpu.createBuffer({
			size: this.bytesPerSlot * capacity,
			usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST
		});
	}
	destroy() {
		this.device.deferDestroy(this.querySet);
		this.querySet = null;
		this.device.deferDestroy(this.queryBuffer);
		this.queryBuffer = null;
		this.activeStagingBuffer = null;
		this.stagingBuffers.forEach((stagingBuffer) => {
			stagingBuffer.destroy();
		});
		this.stagingBuffers = null;
	}
	getStagingBuffer() {
		let stagingBuffer = this.stagingBuffers.pop();
		if (!stagingBuffer) {
			stagingBuffer = this.device.wgpu.createBuffer({
				size: this.queryBuffer.size,
				usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
			});
		}
		return stagingBuffer;
	}
	resolve(count) {
		const device = this.device;
		const commandEncoder = device.getCommandEncoder();
		commandEncoder.resolveQuerySet(this.querySet, 0, count, this.queryBuffer, 0);
		const activeStagingBuffer = this.getStagingBuffer();
		this.activeStagingBuffer = activeStagingBuffer;
		commandEncoder.copyBufferToBuffer(this.queryBuffer, 0, activeStagingBuffer, 0, this.bytesPerSlot * count);
	}
	request(count, renderVersion) {
		const stagingBuffer = this.activeStagingBuffer;
		this.activeStagingBuffer = null;
		return stagingBuffer.mapAsync(GPUMapMode.READ).then(() => {
			const srcTimings = new BigInt64Array(stagingBuffer.getMappedRange());
			const timings = [];
			let minTime = null;
			let maxTime = null;
			for (let i2 = 0; i2 < count; i2++) {
				const begin = srcTimings[i2 * 2];
				const end = srcTimings[i2 * 2 + 1];
				timings.push(Math.max(0, Number(end - begin) * 1e-6));
				if (minTime === null || begin < minTime) minTime = begin;
				if (end < minTime) minTime = end;
				if (maxTime === null || end > maxTime) maxTime = end;
				if (begin > maxTime) maxTime = begin;
			}
			const frameTime = count > 0 ? Number(maxTime - minTime) * 1e-6 : 0;
			stagingBuffer.unmap();
			this.stagingBuffers?.push(stagingBuffer);
			return {
				renderVersion,
				timings,
				frameTime
			};
		});
	}
};

var WebgpuGpuProfiler = class extends GpuProfiler {
	device;
	frameGPUMarkerSlot;
	constructor(device) {
		super();
		this.device = device;
		this.maxCount = 1024;
		this.timestampQueriesSet = device.supportsTimestampQuery ? new WebgpuQuerySet(device, true, 2 * this.maxCount) : null;
	}
	destroy() {
		this.timestampQueriesSet?.destroy();
		this.timestampQueriesSet = null;
	}
	frameStart() {
		this.processEnableRequest();
	}
	frameEnd() {
		if (this._enabled) {
			this.timestampQueriesSet?.resolve(this.slotCount * 2);
		}
	}
	request() {
		if (this._enabled) {
			const renderVersion = this.device.renderVersion;
			this.timestampQueriesSet?.request(this.slotCount, renderVersion).then((results) => {
				this.report(results.renderVersion, results.timings, results.frameTime);
			});
			super.request(renderVersion);
		}
	}
};

var WebgpuResolver = class {
	device;
	pipelineCache = /* @__PURE__ */ new Map();
	constructor(device) {
		this.device = device;
		const code = `
 
						var<private> pos : array<vec2f, 4> = array<vec2f, 4>(
								vec2(-1.0, 1.0), vec2(1.0, 1.0), vec2(-1.0, -1.0), vec2(1.0, -1.0)
						);

						struct VertexOutput {
								@builtin(position) position : vec4f,
						};

						@vertex
						fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
							var output : VertexOutput;
							output.position = vec4f(pos[vertexIndex], 0, 1);
							return output;
						}

						@group(0) @binding(0) var img : texture_depth_multisampled_2d;

						@fragment
						fn fragmentMain(@builtin(position) fragColor: vec4f) -> @location(0) vec4f {
								// load th depth value from sample index 0
								var depth = textureLoad(img, vec2i(fragColor.xy), 0u);
								return vec4f(depth, 0.0, 0.0, 0.0);
						}
				`;
		this.shader = new Shader(device, {
			name: "WebGPUResolverDepthShader",
			shaderLanguage: SHADERLANGUAGE_WGSL,
			vshader: code,
			fshader: code
		});
	}
	destroy() {
		this.shader.destroy();
		this.shader = null;
		this.pipelineCache = null;
	}
	getPipeline(format) {
		let pipeline = this.pipelineCache.get(format);
		if (!pipeline) {
			pipeline = this.createPipeline(format);
			this.pipelineCache.set(format, pipeline);
		}
		return pipeline;
	}
	createPipeline(format) {
		const webgpuShader = this.shader.impl;
		const pipeline = this.device.wgpu.createRenderPipeline({
			layout: "auto",
			vertex: {
				module: webgpuShader.getVertexShaderModule(),
				entryPoint: webgpuShader.vertexEntryPoint
			},
			fragment: {
				module: webgpuShader.getFragmentShaderModule(),
				entryPoint: webgpuShader.fragmentEntryPoint,
				targets: [{
					format
				}]
			},
			primitive: {
				topology: "triangle-strip"
			}
		});
		return pipeline;
	}
	resolveDepth(commandEncoder, sourceTexture, destinationTexture) {
		const device = this.device;
		const wgpu = device.wgpu;
		const pipeline = this.getPipeline(destinationTexture.format);
		const numFaces = sourceTexture.depthOrArrayLayers;
		for (let face = 0; face < numFaces; face++) {
			const srcView = sourceTexture.createView({
				dimension: "2d",
				aspect: "depth-only",
				baseMipLevel: 0,
				mipLevelCount: 1,
				baseArrayLayer: face
			});
			const dstView = destinationTexture.createView({
				dimension: "2d",
				baseMipLevel: 0,
				mipLevelCount: 1,
				baseArrayLayer: face
			});
			const passEncoder = commandEncoder.beginRenderPass({
				colorAttachments: [{
					view: dstView,
					loadOp: "clear",
					storeOp: "store"
				}]
			});
			const bindGroup = wgpu.createBindGroup({
				layout: pipeline.getBindGroupLayout(0),
				entries: [{
					binding: 0,
					resource: srcView
				}]
			});
			passEncoder.setPipeline(pipeline);
			passEncoder.setBindGroup(0, bindGroup);
			passEncoder.draw(4);
			passEncoder.end();
		}
		device.pipeline = null;
	}
};

var _indirectDispatchEntryByteSize = 3 * 4;
var WebgpuCompute = class {
	uniformBuffers = [];
	bindGroups = [];
	constructor(compute) {
		this.compute = compute;
		const { device, shader } = compute;
		const {
			computeBindGroupFormat,
			computeUniformBufferFormats,
			computeReflectedBindGroupFormat,
			computeReflectedUniformBufferFormat,
			computeReflectedGroupIndex
		} = shader.impl;
		const formats = [];
		if (computeBindGroupFormat) {
			const bindGroup = new BindGroup(device, computeBindGroupFormat);
			if (computeUniformBufferFormats) {
				for (const name in computeUniformBufferFormats) {
					if (computeUniformBufferFormats.hasOwnProperty(name)) {
						const ub = new UniformBuffer(device, computeUniformBufferFormats[name], true);
						this.uniformBuffers.push(ub);
						bindGroup.setUniformBuffer(name, ub);
					}
				}
			}
			formats[0] = computeBindGroupFormat;
			this.bindGroups[0] = bindGroup;
		}
		if (computeReflectedBindGroupFormat) {
			const reflectedBindGroup = new BindGroup(device, computeReflectedBindGroupFormat);
			if (computeReflectedUniformBufferFormat) {
				const ub = new UniformBuffer(device, computeReflectedUniformBufferFormat, true);
				this.uniformBuffers.push(ub);
				reflectedBindGroup.setUniformBuffer("ub_compute", ub);
			}
			formats[computeReflectedGroupIndex] = computeReflectedBindGroupFormat;
			this.bindGroups[computeReflectedGroupIndex] = reflectedBindGroup;
		}
		this.pipeline = device.computePipeline.get(shader, formats);
	}
	destroy() {
		this.uniformBuffers.forEach((ub) => ub.destroy());
		this.uniformBuffers.length = 0;
		this.bindGroups.forEach((bindGroup) => bindGroup.destroy());
		this.bindGroups.length = 0;
	}
	updateBindGroup() {
		for (let i2 = 0; i2 < this.bindGroups.length; i2++) {
			const bindGroup = this.bindGroups[i2];
			bindGroup.updateUniformBuffers();
			bindGroup.update();
		}
	}
	dispatch(x3, y2, z2) {
		const device = this.compute.device;
		for (let i2 = 0; i2 < this.bindGroups.length; i2++) {
			device.setBindGroup(i2, this.bindGroups[i2]);
		}
		const passEncoder = device.passEncoder;
		passEncoder.setPipeline(this.pipeline);
		const { indirectSlotIndex, indirectBuffer, indirectFrameStamp } = this.compute;
		if (indirectSlotIndex >= 0) {
			let gpuBuffer;
			if (indirectBuffer) {
				gpuBuffer = indirectBuffer.impl.buffer;
			} else {
				gpuBuffer = device.indirectDispatchBuffer.impl.buffer;
			}
			const offset3 = indirectSlotIndex * _indirectDispatchEntryByteSize;
			passEncoder.dispatchWorkgroupsIndirect(gpuBuffer, offset3);
		} else {
			passEncoder.dispatchWorkgroups(x3, y2, z2);
		}
	}
};

var WebgpuDrawCommands = class {
	device;
	gpuIndirect = null;
	gpuIndirectSigned = null;
	storage = null;
	constructor(device) {
		this.device = device;
	}
	allocate(maxCount) {
		if (this.gpuIndirect && this.gpuIndirect.length === 5 * maxCount) {
			return;
		}
		this.storage?.destroy();
		this.gpuIndirect = new Uint32Array(5 * maxCount);
		this.gpuIndirectSigned = new Int32Array(this.gpuIndirect.buffer);
		this.storage = new StorageBuffer(this.device, this.gpuIndirect.byteLength, BUFFERUSAGE_INDIRECT | BUFFERUSAGE_COPY_DST);
	}
	add(i2, indexOrVertexCount, instanceCount, firstIndexOrVertex, baseVertex = 0, firstInstance = 0) {
		const o = i2 * 5;
		this.gpuIndirect[o + 0] = indexOrVertexCount;
		this.gpuIndirect[o + 1] = instanceCount;
		this.gpuIndirect[o + 2] = firstIndexOrVertex;
		this.gpuIndirectSigned[o + 3] = baseVertex;
		this.gpuIndirect[o + 4] = firstInstance;
	}
	update(count) {
		if (this.storage && count > 0) {
			const used = count * 5;
			this.storage.write(0, this.gpuIndirect, 0, used);
		}
		let totalPrimitives = 0;
		return totalPrimitives;
	}
	destroy() {
		this.storage?.destroy();
		this.storage = null;
	}
};

var WebgpuUploadStream = class {
	availableStagingBuffers = [];
	pendingStagingBuffers = [];
	_destroyed = false;
	_lastUploadSubmitVersion = -1;
	constructor(uploadStream) {
		this.uploadStream = uploadStream;
		this.useSingleBuffer = uploadStream.useSingleBuffer;
	}
	_onDeviceLost() {
	}
	destroy() {
		this._destroyed = true;
		this.availableStagingBuffers.forEach((buffer) => buffer.destroy());
		this.pendingStagingBuffers.forEach((buffer) => buffer.destroy());
	}
	update(minByteSize) {
		const pending = this.pendingStagingBuffers;
		for (let i2 = 0; i2 < pending.length; i2++) {
			const buffer = pending[i2];
			buffer.mapAsync(GPUMapMode.WRITE).then(() => {
				if (!this._destroyed) {
					this.availableStagingBuffers.push(buffer);
				} else {
					buffer.destroy();
				}
			});
		}
		pending.length = 0;
		const available = this.availableStagingBuffers;
		for (let i2 = available.length - 1; i2 >= 0; i2--) {
			if (available[i2].size < minByteSize) {
				available[i2].destroy();
				available.splice(i2, 1);
			}
		}
	}
	upload(data2, target2, offset3, size) {
		if (this.useSingleBuffer) {
			this.uploadDirect(data2, target2, offset3, size);
		} else {
			this.uploadStaging(data2, target2, offset3, size);
		}
	}
	uploadDirect(data2, target2, offset3, size) {
		const byteOffset = offset3 * data2.BYTES_PER_ELEMENT;
		const byteSize = size * data2.BYTES_PER_ELEMENT;
		target2.write(byteOffset, data2, 0, size);
	}
	uploadStaging(data2, target2, offset3, size) {
		const device = this.uploadStream.device;
		const byteOffset = offset3 * data2.BYTES_PER_ELEMENT;
		const byteSize = size * data2.BYTES_PER_ELEMENT;
		if (this.pendingStagingBuffers.length > 0) {
		}
		this.update(byteSize);
		const buffer = this.availableStagingBuffers.pop() ?? (() => {
			const newBuffer = this.uploadStream.device.wgpu.createBuffer({
				size: byteSize,
				usage: GPUBufferUsage.MAP_WRITE | GPUBufferUsage.COPY_SRC,
				mappedAtCreation: true
			});
			return newBuffer;
		})();
		const mappedRange = buffer.getMappedRange();
		new Uint8Array(mappedRange).set(new Uint8Array(data2.buffer, data2.byteOffset, byteSize));
		buffer.unmap();
		device.getCommandEncoder().copyBufferToBuffer(
			buffer,
			0,
			target2.impl.buffer,
			byteOffset,
			byteSize
		);
		this.pendingStagingBuffers.push(buffer);
		this._lastUploadSubmitVersion = device.submitVersion;
	}
};

var WebgpuXrBridge = class {
	_binding = null;
	_layer = null;
	_cachedFramebufferSize = new Vec2();
	constructor(xrBridge) {
		this.xrBridge = xrBridge;
	}
	destroy(device) {
		this._binding = null;
		this._layer = null;
		this._cachedFramebufferSize.set(0, 0);
		device._clearXrState();
	}
	beginFrame(frame, referenceSpace) {
		const device = this.xrBridge.device;
		device._clearXrState();
		if (!this._binding || !this._layer || !referenceSpace) {
			return;
		}
		const pose = frame.getViewerPose(referenceSpace);
		if (!pose || !pose.views?.length) {
			return;
		}
		const subImages = device.xrSubImages;
		for (let i2 = 0; i2 < pose.views.length; i2++) {
			let sub;
			try {
				sub = this._binding.getViewSubImage(this._layer, pose.views[i2]);
			} catch (e) {
				this.xrBridge._onBindingError?.(e);
				return;
			}
			const colorTexture = sub?.colorTexture;
			if (!colorTexture) continue;
			let viewDescriptor = null;
			if (typeof sub.getViewDescriptor === "function") {
				try {
					const desc = sub.getViewDescriptor();
					if (desc) {
						viewDescriptor = { ...desc };
					}
				} catch (e) {
				}
			}
			subImages.push({
				colorTexture,
				viewDescriptor,
				viewport: sub.viewport,
				viewFormat: viewDescriptor?.format ?? colorTexture.format
			});
		}
		const first = subImages[0];
		if (first) {
			device.xrColorTexture = first.colorTexture;
			device.xrColorTextureViewFormat = first.viewFormat;
			device.setXrBackBufferFormat(first.viewFormat);
			this._cachedFramebufferSize.set(first.colorTexture.width, first.colorTexture.height);
		}
	}
	endFrame() {
		const device = this.xrBridge.device;
		device?._clearXrState();
	}
	get presentationLayer() {
		return this._layer;
	}
	get graphicsBinding() {
		return this._binding;
	}
	getFramebufferSize(_frame, out) {
		const layer = this._layer;
		if (layer) {
			const lw = layer.textureWidth ?? layer.width;
			const lh = layer.textureHeight ?? layer.height;
			if (lw > 0 && lh > 0) {
				out.set(lw, lh);
				return;
			}
		}
		if (this._cachedFramebufferSize.x > 0 && this._cachedFramebufferSize.y > 0) {
			out.copy(this._cachedFramebufferSize);
			return;
		}
		out.set(0, 0);
	}
	getViewport(_frame, xrView) {
		if (this._binding && this._layer) {
			try {
				const sub = this._binding.getViewSubImage(this._layer, xrView);
				if (sub?.viewport) {
					return sub.viewport;
				}
			} catch {
			}
		}
		return { x: 0, y: 0, width: 0, height: 0 };
	}
	attachPresentation(session, options2) {
		const XRGPUBindingCtor = globalThis.XRGPUBinding;
		if (typeof XRGPUBindingCtor === "undefined") {
			this.xrBridge._onBindingError?.(new Error("XRGPUBinding is not available in this browser."));
			return;
		}
		const device = this.xrBridge.device;
		const wgpu = device.wgpu;
		try {
			this._binding = new XRGPUBindingCtor(session, wgpu);
		} catch (ex) {
			this.xrBridge._onBindingError?.(ex);
			return;
		}
		const colorFormat = this._binding.getPreferredColorFormat();
		const layerOpts = {
			colorFormat,
			scaleFactor: options2.framebufferScaleFactor
		};
		try {
			this._layer = this._binding.createProjectionLayer({
				...layerOpts,
				textureType: "texture-array"
			});
		} catch {
			this._layer = this._binding.createProjectionLayer({
				...layerOpts,
				textureType: "texture"
			});
		}
		session.updateRenderState({
			layers: [this._layer],
			depthNear: options2.depthNear,
			depthFar: options2.depthFar
		});
	}
	syncCameraColorTexture(xrCamera, texture) {
		if (!this._binding?.getCameraImage) {
			return;
		}
		const src = this._binding.getCameraImage(xrCamera);
		if (!src) {
			return;
		}
		const dst = texture.impl?.gpuTexture;
		if (!dst) {
			return;
		}
		const device = this.xrBridge.device;
		const encoder = device.getCommandEncoder();
		const width = xrCamera.width;
		const height = xrCamera.height;
		encoder.copyTextureToTexture(
			{ texture: src },
			{ texture: dst },
			[width, height, 1]
		);
	}
	syncCameraDepthTexture(depthInfo, _texture, _depthPixelFormat) {
		if (depthInfo?.texture) {
		}
	}
	releasePresentation() {
		this._binding = null;
	}
	onGraphicsDeviceLost() {
		const bridge = this.xrBridge;
		const session = bridge._session;
		if (!session) {
			return;
		}
		const rs = session.renderState;
		const device = bridge.device;
		this._binding = null;
		this._layer = null;
		this._cachedFramebufferSize.set(0, 0);
		device._clearXrState();
		session.updateRenderState({
			layers: [],
			depthNear: rs.depthNear,
			depthFar: rs.depthFar
		});
	}
	onGraphicsDeviceRestored() {
		const bridge = this.xrBridge;
		if (!bridge._session) {
			return;
		}
		const eventHandler = bridge.eventHandler;
		setTimeout(() => {
			if (!bridge._session) {
				return;
			}
			try {
				const rs = bridge._session.renderState;
				bridge.attachPresentation(bridge._session, {
					framebufferScaleFactor: bridge._framebufferScaleFactor,
					depthNear: rs.depthNear,
					depthFar: rs.depthFar,
					onBindingError: bridge._onBindingError
				});
			} catch (ex) {
				eventHandler.fire("error", ex);
			}
		}, 0);
	}
};

var _uniqueLocations = /* @__PURE__ */ new Map();
var _indirectEntryByteSize = 5 * 4;
var _indirectDispatchEntryByteSize2 = 3 * 4;
var _gpuFormatToPixelFormat = {
	"rgba8unorm": PIXELFORMAT_RGBA8,
	"rgba8unorm-srgb": PIXELFORMAT_SRGBA8,
	"bgra8unorm": PIXELFORMAT_BGRA8,
	"bgra8unorm-srgb": PIXELFORMAT_SBGRA8,
	"rgba16float": PIXELFORMAT_RGBA16F
};
var WebgpuGraphicsDevice = class extends GraphicsDevice {
	_deferredDestroys = [];
	renderPipeline = new WebgpuRenderPipeline(this);
	computePipeline = new WebgpuComputePipeline(this);
	_indirectDrawBuffer = null;
	_indirectDrawBufferCount = 0;
	_indirectDrawNextIndex = 0;
	_indirectDispatchBuffer = null;
	_indirectDispatchBufferCount = 0;
	_indirectDispatchNextIndex = 0;
	clearRenderer;
	mipmapRenderer;
	pipeline = null;
	bindGroupFormats = [];
	emptyBindGroup;
	submitVersion = 0;
	_canvasBackBufferFormat;
	xrColorTexture = null;
	xrColorTextureViewFormat = null;
	xrColorTextureViewDescriptor = null;
	xrSubImages = [];
	xrCurrentViewIndex = -1;
	externalBackbuffer = null;
	commandEncoder = null;
	commandBuffers = [];
	limits;
	glslang = null;
	twgsl = null;
	constructor(canvas, options2 = {}) {
		super(canvas, options2);
		options2 = this.initOptions;
		options2.alpha = options2.alpha ?? true;
		this.backBufferAntialias = options2.antialias ?? false;
		this.isWebGPU = true;
		this._deviceType = DEVICETYPE_WEBGPU;
		this.featureLevel = options2.featureLevel;
		this.scope.resolve(UNUSED_UNIFORM_NAME).setValue(0);
	}
	destroy() {
		this.clearRenderer.destroy();
		this.clearRenderer = null;
		this.mipmapRenderer.destroy();
		this.mipmapRenderer = null;
		this.resolver.destroy();
		this.resolver = null;
		this._clearXrState();
		this.externalBackbuffer = null;
		super.destroy();
	}
	_clearXrState() {
		this.xrColorTexture = null;
		this.xrColorTextureViewFormat = null;
		this.xrColorTextureViewDescriptor = null;
		this.xrSubImages.length = 0;
		this.xrCurrentViewIndex = -1;
		if (this._canvasBackBufferFormat !== void 0) {
			this.backBufferFormat = this._canvasBackBufferFormat;
		}
	}
	setXrBackBufferFormat(viewFormat) {
		const format = _gpuFormatToPixelFormat[viewFormat];
		if (format !== void 0) {
			this.backBufferFormat = format;
		}
	}
	initDeviceCaps() {
		const limits = this.wgpu?.limits;
		this.limits = limits;
		this.precision = "highp";
		this.maxPrecision = "highp";
		this.maxSamples = 4;
		this.maxTextures = limits.maxSampledTexturesPerShaderStage;
		this.maxTextureSize = limits.maxTextureDimension2D;
		this.maxCubeMapSize = limits.maxTextureDimension2D;
		this.maxVolumeSize = limits.maxTextureDimension3D;
		this.maxColorAttachments = limits.maxColorAttachments;
		this.maxPixelRatio = 1;
		this.maxAnisotropy = 16;
		this.fragmentUniformsCount = limits.maxUniformBufferBindingSize / 16;
		this.vertexUniformsCount = limits.maxUniformBufferBindingSize / 16;
		this.supportsUniformBuffers = true;
		this.supportsAreaLights = true;
		this.supportsGpuParticles = true;
		this.supportsCompute = true;
		this.textureFloatRenderable = true;
		this.textureHalfFloatRenderable = true;
		this.supportsImageBitmap = true;
		this.samples = this.backBufferAntialias ? 4 : 1;
		const wgslFeatures = window.navigator.gpu.wgslLanguageFeatures;
		this.supportsStorageTextureRead = wgslFeatures?.has("readonly_and_readwrite_storage_textures");
		this.supportsSubgroupUniformity = wgslFeatures?.has("subgroup_uniformity");
		this.supportsSubgroupId = wgslFeatures?.has("subgroup_id");
		this.supportsLinearIndexing = wgslFeatures?.has("linear_indexing");
		this.supportsUnrestrictedPointerParameters = wgslFeatures?.has("unrestricted_pointer_parameters");
		this.supportsPointerCompositeAccess = wgslFeatures?.has("pointer_composite_access");
		this.supportsPacked4x8IntegerDotProduct = wgslFeatures?.has("packed_4x8_integer_dot_product");
		this.supportsTextureAndSamplerLet = wgslFeatures?.has("texture_and_sampler_let");
		this.initCapsDefines();
	}
	async initWebGpu(glslangUrl, twgslUrl) {
		if (!window.navigator.gpu) {
			warnInsecureContext("WebGPU");
			throw new Error("Unable to retrieve GPU. Ensure you are using a browser that supports WebGPU rendering.");
		}
		if (glslangUrl && twgslUrl) {
			const baseUrl = window.document?.baseURI ?? window.location.href;
			const buildUrl = (srcPath) => {
				return new URL(srcPath, baseUrl).toString();
			};
			const twgslScriptUrl = buildUrl(twgslUrl);
			const twgslWasmUrl = buildUrl(twgslUrl.replace(".js", ".wasm"));
			const glslangScriptUrl = buildUrl(glslangUrl);
			const results = await Promise.all([
				import(
					/* @vite-ignore */
					/* webpackIgnore: true */
					`${twgslScriptUrl}`
				).then(() => twgsl(twgslWasmUrl)),
				import(
					/* @vite-ignore */
					/* webpackIgnore: true */
					`${glslangScriptUrl}`
				).then((module2) => module2.default())
			]);
			this.twgsl = results[0];
			this.glslang = results[1];
		}
		return this.createDevice();
	}
	async createDevice() {
		const adapterOptions = {
			powerPreference: this.initOptions.powerPreference !== "default" ? this.initOptions.powerPreference : void 0,
			// Required for WebXR sessions using WebGPU
			xrCompatible: !!this.initOptions.xrCompatible
		};
		this.gpuAdapter = await window.navigator.gpu.requestAdapter(adapterOptions);
		if (this.gpuAdapter?.info?.vendor === "img-tec") {
			return null;
		}
		const featureLevel = this.initOptions.featureLevel;
		const bare = featureLevel === "bare";
		const requiredFeatures = [];
		const requireFeature = bare ? () => false : (feature) => {
			const supported = this.gpuAdapter.features.has(feature);
			if (supported) {
				requiredFeatures.push(feature);
			}
			return supported;
		};
		this.textureFloatFilterable = requireFeature("float32-filterable");
		this.textureFloatBlendable = requireFeature("float32-blendable");
		this.extCompressedTextureS3TC = requireFeature("texture-compression-bc");
		this.extCompressedTextureS3TCSliced3D = requireFeature("texture-compression-bc-sliced-3d");
		this.extCompressedTextureETC = requireFeature("texture-compression-etc2");
		this.extCompressedTextureASTC = requireFeature("texture-compression-astc");
		this.extCompressedTextureASTCSliced3D = requireFeature("texture-compression-astc-sliced-3d");
		this.supportsTimestampQuery = requireFeature("timestamp-query");
		this.supportsDepthClip = requireFeature("depth-clip-control");
		this.supportsDepth32Stencil = requireFeature("depth32float-stencil8");
		this.supportsIndirectFirstInstance = requireFeature("indirect-first-instance");
		this.supportsShaderF16 = requireFeature("shader-f16");
		this.supportsStorageRGBA8 = requireFeature("bgra8unorm-storage");
		this.textureRG11B10Renderable = requireFeature("rg11b10ufloat-renderable");
		this.supportsClipDistances = requireFeature("clip-distances");
		this.supportsTextureFormatTier1 = requireFeature("texture-format-tier1");
		this.supportsTextureFormatTier2 = requireFeature("texture-format-tier2");
		this.supportsTextureFormatTier1 || (this.supportsTextureFormatTier1 = this.supportsTextureFormatTier2);
		this.supportsPrimitiveIndex = requireFeature("primitive-index");
		this.supportsSubgroups = requireFeature("subgroups");
		this.maxSubgroupSize = this.supportsSubgroups ? this.gpuAdapter?.info?.subgroupMaxSize ?? 0 : 0;
		this.minSubgroupSize = this.supportsSubgroups ? this.gpuAdapter?.info?.subgroupMinSize ?? 0 : 0;
		const wgslFeatureNames = window.navigator.gpu.wgslLanguageFeatures ? Array.from(window.navigator.gpu.wgslLanguageFeatures) : [];
		const requiredLimits = {};
		if (!bare) {
			const adapterLimits = this.gpuAdapter?.limits;
			if (adapterLimits) {
				for (const limitName in adapterLimits) {
					if (limitName === "minSubgroupSize" || limitName === "maxSubgroupSize") {
						continue;
					}
					requiredLimits[limitName] = adapterLimits[limitName];
				}
			}
		}
		const deviceDescr = {
			requiredFeatures,
			requiredLimits,
			defaultQueue: {
				label: "Default Queue"
			}
		};
		this.wgpu = await this.gpuAdapter.requestDevice(deviceDescr);
		this.supportsHtmlTextures = typeof this.wgpu.queue?.copyElementImageToTexture === "function";
		this.supportsTransientAttachments = typeof GPUTextureUsage !== "undefined" && "TRANSIENT_ATTACHMENT" in GPUTextureUsage;
		this.wgpu.lost?.then(this.handleDeviceLost.bind(this));
		this.wgpu.addEventListener?.("uncapturederror", (ev) => {
			const e = ev.error;
		});
		this.initDeviceCaps();
		this.gpuContext = this.canvas.getContext("webgpu");
		let canvasToneMapping = "standard";
		let preferredCanvasFormat = window.navigator.gpu.getPreferredCanvasFormat();
		const displayFormat = this.initOptions.displayFormat;
		this.backBufferFormat = preferredCanvasFormat === "rgba8unorm" ? displayFormat === DISPLAYFORMAT_LDR_SRGB ? PIXELFORMAT_SRGBA8 : PIXELFORMAT_RGBA8 : (
			// (S)RGBA
			displayFormat === DISPLAYFORMAT_LDR_SRGB ? PIXELFORMAT_SBGRA8 : PIXELFORMAT_BGRA8
		);
		this.backBufferViewFormat = displayFormat === DISPLAYFORMAT_LDR_SRGB ? `${preferredCanvasFormat}-srgb` : preferredCanvasFormat;
		if (displayFormat === DISPLAYFORMAT_HDR && this.textureFloatFilterable) {
			const hdrMediaQuery = window.matchMedia("(dynamic-range: high)");
			if (hdrMediaQuery?.matches) {
				this.backBufferFormat = PIXELFORMAT_RGBA16F;
				this.backBufferViewFormat = "rgba16float";
				preferredCanvasFormat = "rgba16float";
				this.isHdr = true;
				canvasToneMapping = "extended";
			}
		}
		this.canvasConfig = {
			device: this.wgpu,
			colorSpace: "srgb",
			alphaMode: this.initOptions.alpha ? "premultiplied" : "opaque",
			// use preferred format for optimal performance on mobile
			format: preferredCanvasFormat,
			toneMapping: { mode: canvasToneMapping },
			// RENDER_ATTACHMENT is required, COPY_SRC allows scene grab to copy out from it
			usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST,
			// formats that views created from textures returned by getCurrentTexture may use
			// (this allows us to view the preferred format as srgb)
			viewFormats: displayFormat === DISPLAYFORMAT_LDR_SRGB ? [this.backBufferViewFormat] : []
		};
		this.gpuContext?.configure(this.canvasConfig);
		this._canvasBackBufferFormat = this.backBufferFormat;
		this.createBackbuffer();
		this.clearRenderer = new WebgpuClearRenderer(this);
		this.mipmapRenderer = new WebgpuMipmapRenderer(this);
		this.resolver = new WebgpuResolver(this);
		this.postInit();
		return this;
	}
	async handleDeviceLost(info) {
		if (info.reason !== "destroyed") {
			super.loseContext();
			this.fire("devicelost");
			await this.createDevice();
			super.restoreContext();
			this.fire("devicerestored");
		}
	}
	postInit() {
		super.postInit();
		this.initializeRenderState();
		this.setupPassEncoderDefaults();
		this.gpuProfiler = new WebgpuGpuProfiler(this);
		this.dynamicBuffers = new WebgpuDynamicBuffers(this, 100 * 1024, this.limits.minUniformBufferOffsetAlignment);
		this.emptyBindGroup = new BindGroup(this, new BindGroupFormat(this, []));
		this.emptyBindGroup.update();
	}
	createBackbuffer() {
		this.supportsStencil = this.initOptions.stencil;
		this.backBuffer = new RenderTarget({
			name: "WebgpuFramebuffer",
			graphicsDevice: this,
			depth: this.initOptions.depth,
			stencil: this.supportsStencil,
			samples: this.samples,
			transientColor: this.initOptions.transientColor,
			transientDepth: this.initOptions.transientDepth
		});
		this.backBuffer.impl.isBackbuffer = true;
	}
	frameStart() {
		super.frameStart();
		this.gpuProfiler.frameStart();
		this.submit();
		const outColorBuffer = this.xrColorTexture ?? this.gpuContext?.getCurrentTexture?.() ?? this.externalBackbuffer?.impl.gpuTexture;
		if (this.backBufferSize.x !== outColorBuffer.width || this.backBufferSize.y !== outColorBuffer.height) {
			this.backBufferSize.set(outColorBuffer.width, outColorBuffer.height);
			this.backBuffer.destroy();
			this.backBuffer = null;
			this.createBackbuffer();
		}
		const rt = this.backBuffer;
		const wrt = rt.impl;
		const attachmentViewFormat = outColorBuffer === this.xrColorTexture && this.xrColorTextureViewFormat ? this.xrColorTextureViewFormat : this.backBufferViewFormat;
		wrt.setColorAttachment(0, void 0, attachmentViewFormat);
		rt._width = outColorBuffer.width;
		rt._height = outColorBuffer.height;
		this.initRenderTarget(rt);
		wrt.assignColorTexture(outColorBuffer, attachmentViewFormat);
	}
	frameEnd() {
		super.frameEnd();
		this.gpuProfiler.frameEnd();
		this.submit();
		if (!this.contextLost) {
			this.gpuProfiler.request();
		}
		this._indirectDrawNextIndex = 0;
		this._indirectDispatchNextIndex = 0;
	}
	createBufferImpl(usageFlags) {
		return new WebgpuBuffer(usageFlags);
	}
	createUniformBufferImpl(uniformBuffer) {
		return new WebgpuUniformBuffer(uniformBuffer);
	}
	createVertexBufferImpl(vertexBuffer, format, options2) {
		return new WebgpuVertexBuffer(vertexBuffer, format, options2);
	}
	createIndexBufferImpl(indexBuffer, options2) {
		return new WebgpuIndexBuffer(indexBuffer, options2);
	}
	createShaderImpl(shader) {
		return new WebgpuShader(shader);
	}
	createDrawCommandImpl(drawCommands) {
		return new WebgpuDrawCommands(this);
	}
	createTextureImpl(texture) {
		this.textures.add(texture);
		return new WebgpuTexture(texture);
	}
	createXrBridgeImpl(xrBridge) {
		return new WebgpuXrBridge(xrBridge);
	}
	createRenderTargetImpl(renderTarget) {
		return new WebgpuRenderTarget(renderTarget);
	}
	createUploadStreamImpl(uploadStream) {
		return new WebgpuUploadStream(uploadStream);
	}
	createBindGroupFormatImpl(bindGroupFormat) {
		return new WebgpuBindGroupFormat(bindGroupFormat);
	}
	createBindGroupImpl(bindGroup) {
		return new WebgpuBindGroup();
	}
	createComputeImpl(compute) {
		return new WebgpuCompute(compute);
	}
	get indirectDrawBuffer() {
		this.allocateIndirectDrawBuffer();
		return this._indirectDrawBuffer;
	}
	allocateIndirectDrawBuffer() {
		if (this._indirectDrawNextIndex === 0 && this._indirectDrawBufferCount < this.maxIndirectDrawCount) {
			this._indirectDrawBuffer?.destroy();
			this._indirectDrawBuffer = null;
		}
		if (this._indirectDrawBuffer === null) {
			this._indirectDrawBuffer = new StorageBuffer(this, this.maxIndirectDrawCount * _indirectEntryByteSize, BUFFERUSAGE_INDIRECT | BUFFERUSAGE_COPY_DST);
			this._indirectDrawBufferCount = this.maxIndirectDrawCount;
		}
	}
	getIndirectDrawSlot(count = 1) {
		this.allocateIndirectDrawBuffer();
		const slot = this._indirectDrawNextIndex;
		const nextIndex = this._indirectDrawNextIndex + count;
		this._indirectDrawNextIndex = nextIndex;
		return slot;
	}
	get indirectDispatchBuffer() {
		this.allocateIndirectDispatchBuffer();
		return this._indirectDispatchBuffer;
	}
	allocateIndirectDispatchBuffer() {
		if (this._indirectDispatchNextIndex === 0 && this._indirectDispatchBufferCount < this.maxIndirectDispatchCount) {
			this._indirectDispatchBuffer?.destroy();
			this._indirectDispatchBuffer = null;
		}
		if (this._indirectDispatchBuffer === null) {
			this._indirectDispatchBuffer = new StorageBuffer(this, this.maxIndirectDispatchCount * _indirectDispatchEntryByteSize2, BUFFERUSAGE_INDIRECT | BUFFERUSAGE_COPY_DST);
			this._indirectDispatchBufferCount = this.maxIndirectDispatchCount;
		}
	}
	getIndirectDispatchSlot(count = 1) {
		this.allocateIndirectDispatchBuffer();
		const slot = this._indirectDispatchNextIndex;
		const nextIndex = this._indirectDispatchNextIndex + count;
		this._indirectDispatchNextIndex = nextIndex;
		return slot;
	}
	setBindGroup(index, bindGroup, offsets) {
		if (this.passEncoder) {
			this.passEncoder.setBindGroup(index, bindGroup.impl.bindGroup, offsets ?? bindGroup.uniformBufferOffsets);
			this.bindGroupFormats[index] = bindGroup.format.impl;
		}
	}
	submitVertexBuffer(vertexBuffer, slot) {
		const format = vertexBuffer.format;
		const { interleaved, elements } = format;
		const elementCount = elements.length;
		const vbBuffer = vertexBuffer.impl.buffer;
		if (interleaved) {
			this.passEncoder.setVertexBuffer(slot, vbBuffer);
			return 1;
		}
		for (let i2 = 0; i2 < elementCount; i2++) {
			this.passEncoder.setVertexBuffer(slot + i2, vbBuffer, elements[i2].offset);
		}
		return elementCount;
	}
	validateVBLocations(vb0, vb1) {
		const validateVB = (vb) => {
			const { elements } = vb.format;
			for (let i2 = 0; i2 < elements.length; i2++) {
				const name = elements[i2].name;
				const location = semanticToLocation[name];
				if (_uniqueLocations.has(location)) {
				}
				_uniqueLocations.set(location, name);
			}
		};
		validateVB(vb0);
		validateVB(vb1);
		_uniqueLocations.clear();
	}
	draw(primitive2, indexBuffer, numInstances = 1, drawCommands, first = true, last = true) {
		if (this.shader.ready && !this.shader.failed) {
			const passEncoder = this.passEncoder;
			let pipeline = this.pipeline;
			const vb0 = this.vertexBuffers[0];
			const vb1 = this.vertexBuffers[1];
			if (first) {
				if (vb0) {
					const vbSlot = this.submitVertexBuffer(vb0, 0);
					if (vb1) {
						this.submitVertexBuffer(vb1, vbSlot);
					}
				}
				pipeline = this.renderPipeline.get(
					primitive2,
					vb0?.format,
					vb1?.format,
					indexBuffer?.format,
					this.shader,
					this.renderTarget,
					this.bindGroupFormats,
					this.blendState,
					this.depthState,
					this.cullMode,
					this.stencilEnabled,
					this.stencilFront,
					this.stencilBack,
					this.frontFace
				);
				if (this.pipeline !== pipeline) {
					this.pipeline = pipeline;
					passEncoder.setPipeline(pipeline);
				}
			}
			if (indexBuffer) {
				passEncoder.setIndexBuffer(indexBuffer.impl.buffer, indexBuffer.impl.format);
			}
			if (drawCommands) {
				const storage = drawCommands.impl?.storage ?? this.indirectDrawBuffer;
				const indirectBuffer = storage.impl.buffer;
				const drawsCount = drawCommands.count;
				for (let d = 0; d < drawsCount; d++) {
					const indirectOffset = (drawCommands.slotIndex + d) * _indirectEntryByteSize;
					if (indexBuffer) {
						passEncoder.drawIndexedIndirect(indirectBuffer, indirectOffset);
					} else {
						passEncoder.drawIndirect(indirectBuffer, indirectOffset);
					}
				}
			} else {
				if (indexBuffer) {
					passEncoder.drawIndexed(primitive2.count, numInstances, primitive2.base, primitive2.baseVertex ?? 0, 0);
				} else {
					passEncoder.draw(primitive2.count, numInstances, primitive2.base, 0);
				}
			}
			this._drawCallsPerFrame++;
		}
		if (last) {
			this.clearVertexBuffer();
			this.pipeline = null;
		}
	}
	setShader(shader, asyncCompile = false) {
		if (shader !== this.shader) {
			this.shader = shader;
		}
	}
	setBlendState(blendState) {
		this.blendState.copy(blendState);
	}
	setDepthState(depthState) {
		this.depthState.copy(depthState);
	}
	setStencilState(stencilFront, stencilBack) {
		if (stencilFront || stencilBack) {
			this.stencilEnabled = true;
			this.stencilFront.copy(stencilFront ?? StencilParameters.DEFAULT);
			this.stencilBack.copy(stencilBack ?? StencilParameters.DEFAULT);
			const ref = this.stencilFront.ref;
			if (this.stencilRef !== ref) {
				this.stencilRef = ref;
				this.passEncoder.setStencilReference(ref);
			}
		} else {
			this.stencilEnabled = false;
		}
	}
	setBlendColor(r, g, b, a) {
		const c2 = this.blendColor;
		if (r !== c2.r || g !== c2.g || b !== c2.b || a !== c2.a) {
			c2.set(r, g, b, a);
			this.passEncoder.setBlendConstant(c2);
		}
	}
	setCullMode(cullMode) {
		this.cullMode = cullMode;
	}
	setFrontFace(frontFace) {
		this.frontFace = frontFace;
	}
	setAlphaToCoverage(state) {
	}
	initializeContextCaches() {
		super.initializeContextCaches();
	}
	setupPassEncoderDefaults() {
		this.pipeline = null;
		this.stencilRef = 0;
		this.blendColor.set(0, 0, 0, 0);
	}
	_uploadDirtyTextures() {
		this.texturesToUpload.forEach((texture) => {
			if (texture._needsUpload || texture._needsMipmapsUpload) {
				texture.upload();
			}
		});
		this.texturesToUpload.clear();
	}
	setupTimeStampWrites(passDesc, name) {
		if (this.gpuProfiler._enabled) {
			if (this.gpuProfiler.timestampQueriesSet) {
				const slot = this.gpuProfiler.getSlot(name);
				if (slot === -1) {
				} else {
					passDesc = passDesc ?? {};
					passDesc.timestampWrites = {
						querySet: this.gpuProfiler.timestampQueriesSet.querySet,
						beginningOfPassWriteIndex: slot * 2,
						endOfPassWriteIndex: slot * 2 + 1
					};
				}
			}
		}
		return passDesc;
	}
	startRenderPass(renderPass) {
		this._uploadDirtyTextures();
		const rt = renderPass.renderTarget || this.backBuffer;
		this.renderTarget = rt;
		const wrt = rt.impl;
		if (rt !== this.backBuffer) {
			this.initRenderTarget(rt);
		}
		wrt.setupForRenderPass(renderPass, rt);
		const renderPassDesc = wrt.renderPassDescriptor;
		this.setupTimeStampWrites(renderPassDesc, renderPass.name);
		const commandEncoder = this.getCommandEncoder();
		this.passEncoder = commandEncoder.beginRenderPass(renderPassDesc);
		this.passEncoder.label = `${renderPass.name}-PassEncoder RT:${rt.name}`;
		this.setupPassEncoderDefaults();
		const { width, height } = rt;
		this.setViewport(0, 0, width, height);
		this.setScissor(0, 0, width, height);
		this.insideRenderPass = true;
	}
	endRenderPass(renderPass) {
		this.passEncoder.end();
		this.passEncoder = null;
		this.insideRenderPass = false;
		this.bindGroupFormats.length = 0;
		const target2 = this.renderTarget;
		if (target2) {
			if (target2.depthBuffer && renderPass.depthStencilOps.resolveDepth) {
				if (renderPass.samples > 1 && target2.autoResolve) {
					const depthAttachment = target2.impl.depthAttachment;
					const destTexture = target2.depthBuffer.impl.gpuTexture;
					if (depthAttachment?.transient) {
					} else if (depthAttachment && destTexture) {
						this.resolver.resolveDepth(this.commandEncoder, depthAttachment.multisampledDepthBuffer, destTexture);
					}
				}
			}
		}
		for (let i2 = 0; i2 < renderPass.colorArrayOps.length; i2++) {
			const colorOps = renderPass.colorArrayOps[i2];
			if (colorOps.genMipmaps) {
				this.mipmapRenderer.generate(renderPass.renderTarget._colorBuffers[i2].impl);
			}
		}
	}
	startComputePass(name) {
		this._uploadDirtyTextures();
		this.pipeline = null;
		const computePassDesc = this.setupTimeStampWrites(void 0, name);
		const commandEncoder = this.getCommandEncoder();
		this.passEncoder = commandEncoder.beginComputePass(computePassDesc);
		this.insideRenderPass = true;
	}
	endComputePass() {
		this.passEncoder.end();
		this.passEncoder = null;
		this.insideRenderPass = false;
		this.bindGroupFormats.length = 0;
	}
	computeDispatch(computes, name = "Unnamed") {
		this.startComputePass(name);
		for (let i2 = 0; i2 < computes.length; i2++) {
			const compute = computes[i2];
			compute.applyParameters();
			compute.impl.updateBindGroup();
		}
		for (let i2 = 0; i2 < computes.length; i2++) {
			const compute = computes[i2];
			compute.impl.dispatch(compute.countX, compute.countY, compute.countZ);
		}
		this.endComputePass();
	}
	getCommandEncoder() {
		let commandEncoder = this.commandEncoder;
		if (!commandEncoder) {
			commandEncoder = this.wgpu.createCommandEncoder();
			this.commandEncoder = commandEncoder;
		}
		return commandEncoder;
	}
	endCommandEncoder() {
		const { commandEncoder } = this;
		if (commandEncoder) {
			const cb = commandEncoder.finish();
			this.addCommandBuffer(cb);
			this.commandEncoder = null;
		}
	}
	addCommandBuffer(commandBuffer, front = false) {
		if (front) {
			this.commandBuffers.unshift(commandBuffer);
		} else {
			this.commandBuffers.push(commandBuffer);
		}
	}
	submit() {
		this.endCommandEncoder();
		if (this.commandBuffers.length > 0) {
			this.dynamicBuffers.submit();
			this.wgpu.queue.submit(this.commandBuffers);
			this.commandBuffers.length = 0;
			this.submitVersion++;
			this.dynamicBuffers.onCommandBuffersSubmitted();
		}
		const deferredDestroys = this._deferredDestroys;
		if (deferredDestroys.length > 0) {
			for (let i2 = 0; i2 < deferredDestroys.length; i2++) {
				deferredDestroys[i2].destroy();
			}
			deferredDestroys.length = 0;
		}
	}
	deferDestroy(gpuResource) {
		if (gpuResource) {
			this._deferredDestroys.push(gpuResource);
		}
	}
	clear(options2) {
		if (options2.flags) {
			this.clearRenderer.clear(this, this.renderTarget, options2, this.defaultClearOptions);
		}
	}
	setViewport(x3, y2, w, h2) {
		if (this.passEncoder) {
			if (this.xrColorTexture) {
				return;
			}
			if (!this.renderTarget.flipY) {
				y2 = this.renderTarget.height - y2 - h2;
			}
			this.vx = x3;
			this.vy = y2;
			this.vw = w;
			this.vh = h2;
			this.passEncoder.setViewport(x3, y2, w, h2, 0, 1);
		}
	}
	setScissor(x3, y2, w, h2) {
		if (this.passEncoder) {
			if (this.xrColorTexture) {
				return;
			}
			if (!this.renderTarget.flipY) {
				y2 = this.renderTarget.height - y2 - h2;
			}
			this.sx = x3;
			this.sy = y2;
			this.sw = w;
			this.sh = h2;
			this.passEncoder.setScissorRect(x3, y2, w, h2);
		}
	}
	clearStorageBuffer(storageBuffer, offset3 = 0, size = storageBuffer.byteSize) {
		const commandEncoder = this.getCommandEncoder();
		commandEncoder.clearBuffer(storageBuffer.buffer, offset3, size);
	}
	readStorageBuffer(storageBuffer, offset3 = 0, size = storageBuffer.byteSize - offset3, data2 = null, immediate = false) {
		const stagingBuffer = this.createBufferImpl(BUFFERUSAGE_READ | BUFFERUSAGE_COPY_DST);
		stagingBuffer.allocate(this, size);
		const destBuffer = stagingBuffer.buffer;
		const commandEncoder = this.getCommandEncoder();
		commandEncoder.copyBufferToBuffer(storageBuffer.buffer, offset3, destBuffer, 0, size);
		return this.readBuffer(stagingBuffer, size, data2, immediate);
	}
	readBuffer(stagingBuffer, size, data2 = null, immediate = false) {
		const destBuffer = stagingBuffer.buffer;
		return new Promise((resolve2, reject) => {
			const read = () => {
				destBuffer?.mapAsync(GPUMapMode.READ).then(() => {
					data2 ?? (data2 = new Uint8Array(size));
					const copySrc = destBuffer.getMappedRange(0, size);
					const srcType = data2.constructor;
					data2.set(new srcType(copySrc));
					destBuffer.unmap();
					stagingBuffer.destroy(this);
					resolve2(data2);
				});
			};
			if (immediate) {
				this.submit();
				read();
			} else {
				setTimeout(() => {
					read();
				});
			}
		});
	}
	writeStorageBuffer(storageBuffer, bufferOffset = 0, data2, dataOffset = 0, size) {
		this.wgpu.queue.writeBuffer(storageBuffer.buffer, bufferOffset, data2, dataOffset, size);
	}
	copyRenderTarget(source, dest, color3, depth) {
		const copySize = {
			width: source ? source.width : dest.width,
			height: source ? source.height : dest.height,
			depthOrArrayLayers: 1
		};
		const commandEncoder = this.getCommandEncoder();
		if (color3) {
			const copySrc = {
				texture: source ? source.colorBuffer.impl.gpuTexture : this.backBuffer.impl.assignedColorTexture,
				mipLevel: source ? source.mipLevel : 0
			};
			const copyDst = {
				texture: dest ? dest.colorBuffer.impl.gpuTexture : this.backBuffer.impl.assignedColorTexture,
				mipLevel: dest ? dest.mipLevel : 0
			};
			commandEncoder.copyTextureToTexture(copySrc, copyDst, copySize);
		}
		if (depth) {
			const sourceRT = source ? source : this.renderTarget;
			if (sourceRT.impl.depthAttachment?.transient) {
				return false;
			}
			const sourceTexture = sourceRT.impl.depthAttachment.depthTexture;
			const sourceMipLevel = sourceRT.mipLevel;
			if (sourceRT.samples > 1) {
				const destTexture = dest.colorBuffer.impl.gpuTexture;
				this.resolver.resolveDepth(commandEncoder, sourceTexture, destTexture);
			} else {
				const destTexture = dest ? dest.depthBuffer.impl.gpuTexture : this.renderTarget.impl.depthAttachment.depthTexture;
				const destMipLevel = dest ? dest.mipLevel : this.renderTarget.mipLevel;
				const copySrc = {
					texture: sourceTexture,
					mipLevel: sourceMipLevel
				};
				const copyDst = {
					texture: destTexture,
					mipLevel: destMipLevel
				};
				commandEncoder.copyTextureToTexture(copySrc, copyDst, copySize);
			}
		}
		return true;
	}
	get hasTranspilers() {
		return this.glslang && this.twgsl;
	}
};

var WebglBuffer = class {
	bufferId = null;
	destroy(device) {
		if (this.bufferId) {
			device.gl.deleteBuffer(this.bufferId);
			this.bufferId = null;
		}
	}
	get initialized() {
		return !!this.bufferId;
	}
	loseContext() {
		this.bufferId = null;
	}
	unlock(device, usage, target2, storage) {
		const gl = device.gl;
		if (!this.bufferId) {
			let glUsage;
			switch (usage) {
				case BUFFER_STATIC:
					glUsage = gl.STATIC_DRAW;
					break;
				case BUFFER_DYNAMIC:
					glUsage = gl.DYNAMIC_DRAW;
					break;
				case BUFFER_STREAM:
					glUsage = gl.STREAM_DRAW;
					break;
				case BUFFER_GPUDYNAMIC:
					glUsage = gl.DYNAMIC_COPY;
					break;
			}
			this.bufferId = gl.createBuffer();
			gl.bindBuffer(target2, this.bufferId);
			gl.bufferData(target2, storage, glUsage);
		} else {
			gl.bindBuffer(target2, this.bufferId);
			gl.bufferSubData(target2, 0, storage);
		}
	}
};

var WebglVertexBuffer = class extends WebglBuffer {
	// vertex array object
	vao = null;
	destroy(device) {
		super.destroy(device);
		device.unbindVertexArray();
	}
	loseContext() {
		super.loseContext();
		this.vao = null;
	}
	unlock(vertexBuffer) {
		const device = vertexBuffer.device;
		super.unlock(device, vertexBuffer.usage, device.gl.ARRAY_BUFFER, vertexBuffer.storage);
	}
};

var WebglIndexBuffer = class extends WebglBuffer {
	constructor(indexBuffer) {
		super();
		const gl = indexBuffer.device.gl;
		const format = indexBuffer.format;
		if (format === INDEXFORMAT_UINT8) {
			this.glFormat = gl.UNSIGNED_BYTE;
		} else if (format === INDEXFORMAT_UINT16) {
			this.glFormat = gl.UNSIGNED_SHORT;
		} else if (format === INDEXFORMAT_UINT32) {
			this.glFormat = gl.UNSIGNED_INT;
		}
	}
	unlock(indexBuffer) {
		const device = indexBuffer.device;
		super.unlock(device, indexBuffer.usage, device.gl.ELEMENT_ARRAY_BUFFER, indexBuffer.storage);
	}
};

var WebglShaderInput = class {
	constructor(graphicsDevice, name, type, locationId) {
		this.locationId = locationId;
		this.scopeId = graphicsDevice.scope.resolve(name);
		this.version = new Version();
		if (name.substring(name.length - 3) === "[0]") {
			switch (type) {
				case UNIFORMTYPE_FLOAT:
					type = UNIFORMTYPE_FLOATARRAY;
					break;
				case UNIFORMTYPE_INT:
					type = UNIFORMTYPE_INTARRAY;
					break;
				case UNIFORMTYPE_UINT:
					type = UNIFORMTYPE_UINTARRAY;
					break;
				case UNIFORMTYPE_BOOL:
					type = UNIFORMTYPE_BOOLARRAY;
					break;
				case UNIFORMTYPE_VEC2:
					type = UNIFORMTYPE_VEC2ARRAY;
					break;
				case UNIFORMTYPE_IVEC2:
					type = UNIFORMTYPE_IVEC2ARRAY;
					break;
				case UNIFORMTYPE_UVEC2:
					type = UNIFORMTYPE_UVEC2ARRAY;
					break;
				case UNIFORMTYPE_BVEC2:
					type = UNIFORMTYPE_BVEC2ARRAY;
					break;
				case UNIFORMTYPE_VEC3:
					type = UNIFORMTYPE_VEC3ARRAY;
					break;
				case UNIFORMTYPE_IVEC3:
					type = UNIFORMTYPE_IVEC3ARRAY;
					break;
				case UNIFORMTYPE_UVEC3:
					type = UNIFORMTYPE_UVEC3ARRAY;
					break;
				case UNIFORMTYPE_BVEC3:
					type = UNIFORMTYPE_BVEC3ARRAY;
					break;
				case UNIFORMTYPE_VEC4:
					type = UNIFORMTYPE_VEC4ARRAY;
					break;
				case UNIFORMTYPE_IVEC4:
					type = UNIFORMTYPE_IVEC4ARRAY;
					break;
				case UNIFORMTYPE_UVEC4:
					type = UNIFORMTYPE_UVEC4ARRAY;
					break;
				case UNIFORMTYPE_BVEC4:
					type = UNIFORMTYPE_BVEC4ARRAY;
					break;
			}
		}
		this.dataType = type;
		this.value = [null, null, null, null];
		this.array = [];
	}
};

var WebglShaderProcessorGLSL = class _WebglShaderProcessorGLSL extends ShaderProcessorGLSL {
	static run(device, shaderDefinition, shader) {
		const vertexExtracted = _WebglShaderProcessorGLSL.extract(shaderDefinition.vshader, true);
		const fragmentExtracted = _WebglShaderProcessorGLSL.extract(shaderDefinition.fshader, true);
		const concatUniforms = vertexExtracted.uniforms.concat(fragmentExtracted.uniforms);
		const uniforms = Array.from(new Set(concatUniforms));
		const parsedUniforms = _WebglShaderProcessorGLSL.parseUniformLines(uniforms, shader);
		const code = _WebglShaderProcessorGLSL.processUniformsGL2(parsedUniforms, shaderDefinition.processingOptions);
		const vshader = vertexExtracted.src.replace(ShaderProcessorGLSL.MARKER, code);
		const fshader = fragmentExtracted.src.replace(ShaderProcessorGLSL.MARKER, code);
		return { vshader, fshader };
	}
	static processUniformsGL2(uniforms, processingOptions) {
		let code = "";
		const viewFormat = processingOptions.uniformFormats[BINDGROUP_VIEW];
		if (viewFormat) {
			code += _WebglShaderProcessorGLSL.getUniformShaderDeclarationGL2(viewFormat, BINDGROUP_VIEW);
		}
		uniforms.forEach((uniform) => {
			if (!processingOptions.hasUniform(uniform.name)) {
				code += `uniform ${uniform.line};
`;
			}
		});
		return code;
	}
	static getUniformShaderDeclarationGL2(format, bindGroup) {
		const name = bindGroupNames[bindGroup];
		let code = `layout(std140) uniform ub_${name} {
`;
		format.uniforms.forEach((uniform) => {
			const typeString = uniformTypeToName[uniform.type];
			code += `    ${typeString} ${uniform.shortName}${uniform.count ? `[${uniform.count}]` : ""};
`;
		});
		return `${code}};
`;
	}
};

var _vertexShaderBuiltins = /* @__PURE__ */ new Set([
	"gl_VertexID",
	"gl_InstanceID",
	"gl_DrawID",
	"gl_BaseVertex",
	"gl_BaseInstance"
]);
var CompiledShaderCache = class {
	// maps shader source to a compiled WebGL shader
	map = /* @__PURE__ */ new Map();
	// destroy all created shaders when the device is destroyed
	destroy(device) {
		this.map.forEach((shader) => {
			device.gl.deleteShader(shader);
		});
	}
	// just empty the cache when the context is lost
	loseContext(device) {
		this.map.clear();
	}
};
var _vertexShaderCache = new DeviceCache();
var _fragmentShaderCache = new DeviceCache();
var WebglShader = class {
	compileDuration = 0;
	constructor(shader) {
		this.init();
		this.compile(shader.device, shader);
		this.link(shader.device, shader);
		shader.device.shaders.push(shader);
	}
	destroy(shader) {
		if (this.glProgram) {
			shader.device.gl.deleteProgram(this.glProgram);
			this.glProgram = null;
		}
	}
	init() {
		this.uniforms = [];
		this.samplers = [];
		this.attributes = [];
		this.glProgram = null;
		this.glVertexShader = null;
		this.glFragmentShader = null;
		this._vsource = null;
		this._fsource = null;
	}
	loseContext() {
		this.init();
	}
	restoreContext(device, shader) {
		this.compile(device, shader);
		this.link(device, shader);
	}
	compile(device, shader) {
		const definition = shader.definition;
		let vsource = definition.vshader;
		let fsource = definition.fshader;
		if (definition.processingOptions) {
			const processed = WebglShaderProcessorGLSL.run(device, definition, shader);
			vsource = processed.vshader;
			fsource = processed.fshader;
		}
		this._vsource = vsource;
		this._fsource = fsource;
		this.glVertexShader = this._compileShaderSource(device, vsource, true);
		this.glFragmentShader = this._compileShaderSource(device, fsource, false);
	}
	link(device, shader) {
		if (this.glProgram) {
			return;
		}
		const gl = device.gl;
		if (gl.isContextLost()) {
			return;
		}
		let startTime = 0;
		const glProgram = gl.createProgram();
		this.glProgram = glProgram;
		gl.attachShader(glProgram, this.glVertexShader);
		gl.attachShader(glProgram, this.glFragmentShader);
		const definition = shader.definition;
		const attrs = definition.attributes;
		if (definition.useTransformFeedback) {
			let outNames = definition.feedbackVaryings;
			if (!outNames) {
				outNames = [];
				for (const attr in attrs) {
					if (attrs.hasOwnProperty(attr)) {
						outNames.push(`out_${attr}`);
					}
				}
			}
			gl.transformFeedbackVaryings(glProgram, outNames, gl.INTERLEAVED_ATTRIBS);
		}
		const locations = {};
		for (const attr in attrs) {
			if (attrs.hasOwnProperty(attr)) {
				const semantic = attrs[attr];
				const loc = semanticToLocation[semantic];
				locations[loc] = attr;
				gl.bindAttribLocation(glProgram, loc, attr);
			}
		}
		gl.linkProgram(glProgram);
	}
	_compileShaderSource(device, src, isVertexShader) {
		const gl = device.gl;
		if (gl.isContextLost()) {
			return null;
		}
		const shaderDeviceCache = isVertexShader ? _vertexShaderCache : _fragmentShaderCache;
		const shaderCache = shaderDeviceCache.get(device, () => {
			return new CompiledShaderCache();
		});
		let glShader = shaderCache.map.get(src);
		if (!glShader) {
			glShader = gl.createShader(isVertexShader ? gl.VERTEX_SHADER : gl.FRAGMENT_SHADER);
			gl.shaderSource(glShader, src);
			gl.compileShader(glShader);
			shaderCache.map.set(src, glShader);
		}
		return glShader;
	}
	finalize(device, shader) {
		const gl = device.gl;
		if (gl.isContextLost()) {
			return true;
		}
		const glProgram = this.glProgram;
		const definition = shader.definition;
		let linkStartTime = 0;
		const linkStatus = gl.getProgramParameter(glProgram, gl.LINK_STATUS);
		if (!linkStatus) {
			if (!this._isCompiled(device, shader, this.glVertexShader, this._vsource, "vertex")) {
				return false;
			}
			if (!this._isCompiled(device, shader, this.glFragmentShader, this._fsource, "fragment")) {
				return false;
			}
			const message = `Failed to link shader program. Error: ${gl.getProgramInfoLog(glProgram)}`;
			console.error(message);
			return false;
		}
		const numAttributes = gl.getProgramParameter(glProgram, gl.ACTIVE_ATTRIBUTES);
		shader.attributes.clear();
		for (let i2 = 0; i2 < numAttributes; i2++) {
			const info = gl.getActiveAttrib(glProgram, i2);
			const location = gl.getAttribLocation(glProgram, info.name);
			if (_vertexShaderBuiltins.has(info.name)) {
				continue;
			}
			if (definition.attributes[info.name] === void 0) {
				console.error(`Vertex shader attribute "${info.name}" is not mapped to a semantic in shader definition, shader [${shader.label}]`, shader);
				shader.failed = true;
			} else {
				shader.attributes.set(location, info.name);
			}
		}
		const samplerTypes2 = device._samplerTypes;
		const numUniforms = gl.getProgramParameter(glProgram, gl.ACTIVE_UNIFORMS);
		for (let i2 = 0; i2 < numUniforms; i2++) {
			const info = gl.getActiveUniform(glProgram, i2);
			const location = gl.getUniformLocation(glProgram, info.name);
			if (_vertexShaderBuiltins.has(info.name)) {
				continue;
			}
			if (location === null) {
				continue;
			}
			const shaderInput = new WebglShaderInput(device, info.name, device.pcUniformType[info.type], location);
			if (samplerTypes2.has(info.type)) {
				this.samplers.push(shaderInput);
			} else {
				this.uniforms.push(shaderInput);
			}
		}
		const numBlocks = gl.getProgramParameter(glProgram, gl.ACTIVE_UNIFORM_BLOCKS);
		for (let i2 = 0; i2 < numBlocks; i2++) {
			const blockName = gl.getActiveUniformBlockName(glProgram, i2);
			const shortName = blockName.startsWith("ub_") ? blockName.substring(3) : blockName;
			const bindGroupIndex = bindGroupNames.indexOf(shortName);
			const bindingPoint = bindGroupIndex >= 0 ? bindGroupIndex : i2;
			gl.uniformBlockBinding(glProgram, i2, bindingPoint);
		}
		shader.ready = true;
		return true;
	}
	_isCompiled(device, shader, glShader, source, shaderType) {
		const gl = device.gl;
		if (!gl.getShaderParameter(glShader, gl.COMPILE_STATUS)) {
			const infoLog = gl.getShaderInfoLog(glShader);
			const [code, error] = this._processError(source, infoLog);
			const message = `Failed to compile ${shaderType} shader:

${infoLog}
${code} while rendering ${void 0}`;
			console.error(message);
			return false;
		}
		return true;
	}
	isLinked(device) {
		const { extParallelShaderCompile } = device;
		if (extParallelShaderCompile) {
			return device.gl.getProgramParameter(this.glProgram, extParallelShaderCompile.COMPLETION_STATUS_KHR);
		}
		return true;
	}
	_processError(src, infoLog) {
		const error = {};
		let code = "";
		if (src) {
			const lines = src.split("\n");
			let from = 0;
			let to = lines.length;
			if (infoLog && infoLog.startsWith("ERROR:")) {
				const match = infoLog.match(/^ERROR:\s(\d+):(\d+):\s*(.+)/);
				if (match) {
					error.message = match[3];
					error.line = parseInt(match[2], 10);
					from = Math.max(0, error.line - 6);
					to = Math.min(lines.length, error.line + 5);
				}
			}
			for (let i2 = from; i2 < to; i2++) {
				const linePrefix = i2 + 1 === error.line ? "> " : "  ";
				code += `${linePrefix}${i2 + 1}:	${lines[i2]}
`;
			}
			error.source = src;
		}
		return [code, error];
	}
};

var WebglUniformBuffer = class extends WebglBuffer {
	unlock(uniformBuffer) {
		const device = uniformBuffer.device;
		const gl = device.gl;
		super.unlock(device, BUFFER_DYNAMIC, gl.UNIFORM_BUFFER, uniformBuffer.storageInt32);
	}
};

var WebglBindGroup = class {
	buffers = [];
	update(bindGroup) {
		const uniformBuffers = bindGroup.uniformBuffers;
		this.buffers.length = uniformBuffers.length;
		for (let i2 = 0; i2 < uniformBuffers.length; i2++) {
			const uniformBuffer = uniformBuffers[i2];
			this.buffers[i2] = uniformBuffer.persistent ? uniformBuffer.impl : uniformBuffer.allocation.gpuBuffer;
		}
	}
	destroy() {
		this.buffers.length = 0;
	}
};

var WebglBindGroupFormat = class {
	destroy() {
	}
};

var WebglDynamicBuffer = class extends DynamicBuffer {
	bufferId = null;
	storage;
	size;
	constructor(device, size) {
		super(device);
		this.size = size;
		this.storage = new Int32Array(size / 4);
		device._vram.ub += size;
	}
	destroy(device) {
		if (this.bufferId) {
			device.gl.deleteBuffer(this.bufferId);
			this.bufferId = null;
		}
		device._vram.ub -= this.size;
	}
	loseContext() {
		this.bufferId = null;
	}
	upload() {
		const gl = this.device.gl;
		if (!this.bufferId) {
			this.bufferId = gl.createBuffer();
		}
		gl.bindBuffer(gl.UNIFORM_BUFFER, this.bufferId);
		gl.bufferData(gl.UNIFORM_BUFFER, this.storage, gl.STREAM_DRAW);
	}
};

var WebglDynamicBuffers = class extends DynamicBuffers {
	free = /* @__PURE__ */ new Map();
	used = [];
	constructor(device) {
		super(device, 0, 0);
	}
	destroy() {
		this.used.forEach((buffer) => buffer.destroy(this.device));
		this.free.forEach((buffers) => buffers.forEach((buffer) => buffer.destroy(this.device)));
		this.used = null;
		this.free = null;
	}
	alloc(allocation, size) {
		let buffer = this.free.get(size)?.pop();
		if (!buffer) {
			buffer = new WebglDynamicBuffer(this.device, size);
		}
		this.used.push(buffer);
		allocation.gpuBuffer = buffer;
		allocation.offset = 0;
		allocation.storage = buffer.storage;
	}
	onFrameEnd() {
		const used = this.used;
		for (let i2 = 0; i2 < used.length; i2++) {
			const buffer = used[i2];
			let pool = this.free.get(buffer.size);
			if (!pool) {
				pool = [];
				this.free.set(buffer.size, pool);
			}
			pool.push(buffer);
		}
		used.length = 0;
	}
	loseContext() {
		this.onFrameEnd();
		this.free.forEach((buffers) => {
			buffers.forEach((buffer) => buffer.loseContext());
		});
	}
};

var WebglDrawCommands = class {
	indexSizeBytes;
	glCounts = null;
	glOffsetsBytes = null;
	glInstanceCounts = null;
	constructor(indexSizeBytes) {
		this.indexSizeBytes = indexSizeBytes;
	}
	allocate(maxCount) {
		if (this.glCounts && this.glCounts.length === maxCount) {
			return;
		}
		this.glCounts = new Int32Array(maxCount);
		this.glOffsetsBytes = new Int32Array(maxCount);
		this.glInstanceCounts = new Int32Array(maxCount);
	}
	add(i2, indexOrVertexCount, instanceCount, firstIndexOrVertex) {
		this.glCounts[i2] = indexOrVertexCount;
		this.glOffsetsBytes[i2] = firstIndexOrVertex * this.indexSizeBytes;
		this.glInstanceCounts[i2] = instanceCount;
	}
	update(count) {
		let totalPrimitives = 0;
		return totalPrimitives;
	}
};

function downsampleImage(image, size) {
	const srcW = image.width;
	const srcH = image.height;
	if (srcW > size || srcH > size) {
		const scale2 = size / Math.max(srcW, srcH);
		const dstW = Math.floor(srcW * scale2);
		const dstH = Math.floor(srcH * scale2);
		const canvas = document.createElement("canvas");
		canvas.width = dstW;
		canvas.height = dstH;
		const context = canvas.getContext("2d");
		context.drawImage(image, 0, 0, srcW, srcH, 0, 0, dstW, dstH);
		return canvas;
	}
	return image;
}
var WebglTexture = class {
	_glTexture = null;
	_glTarget;
	_glFormat;
	_glInternalFormat;
	_glPixelType;
	_glCreated;
	dirtyParameterFlags = 0;
	constructor(texture) {
		this.texture = texture;
	}
	destroy(device) {
		if (this._glTexture) {
			for (let i2 = 0; i2 < device.textureUnits.length; i2++) {
				const textureUnit = device.textureUnits[i2];
				for (let j = 0; j < textureUnit.length; j++) {
					if (textureUnit[j] === this._glTexture) {
						textureUnit[j] = null;
					}
				}
			}
			device.gl.deleteTexture(this._glTexture);
			this._glTexture = null;
		}
	}
	loseContext() {
		this._glTexture = null;
	}
	propertyChanged(flag) {
		this.dirtyParameterFlags |= flag;
	}
	initialize(device, texture) {
		const gl = device.gl;
		this._glTexture = gl.createTexture();
		this._glTarget = texture._cubemap ? gl.TEXTURE_CUBE_MAP : texture._volume ? gl.TEXTURE_3D : texture.array ? gl.TEXTURE_2D_ARRAY : gl.TEXTURE_2D;
		switch (texture._format) {
			case PIXELFORMAT_A8:
				this._glFormat = gl.ALPHA;
				this._glInternalFormat = gl.ALPHA;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_L8:
				this._glFormat = gl.LUMINANCE;
				this._glInternalFormat = gl.LUMINANCE;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_LA8:
				this._glFormat = gl.LUMINANCE_ALPHA;
				this._glInternalFormat = gl.LUMINANCE_ALPHA;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_R8:
				this._glFormat = gl.RED;
				this._glInternalFormat = gl.R8;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_RG8:
				this._glFormat = gl.RG;
				this._glInternalFormat = gl.RG8;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_RGB565:
				this._glFormat = gl.RGB;
				this._glInternalFormat = gl.RGB565;
				this._glPixelType = gl.UNSIGNED_SHORT_5_6_5;
				break;
			case PIXELFORMAT_RGBA5551:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = gl.RGB5_A1;
				this._glPixelType = gl.UNSIGNED_SHORT_5_5_5_1;
				break;
			case PIXELFORMAT_RGBA4:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = gl.RGBA4;
				this._glPixelType = gl.UNSIGNED_SHORT_4_4_4_4;
				break;
			case PIXELFORMAT_RGB8:
				this._glFormat = gl.RGB;
				this._glInternalFormat = gl.RGB8;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_RGBA8:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = gl.RGBA8;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_BGRA8:
			case PIXELFORMAT_SBGRA8:
				break;
			case PIXELFORMAT_RG32F:
				break;
			case PIXELFORMAT_RGB9E5:
				this._glFormat = gl.RGB;
				this._glInternalFormat = gl.RGB9_E5;
				this._glPixelType = gl.UNSIGNED_INT_5_9_9_9_REV;
				break;
			case PIXELFORMAT_RG8S:
				this._glFormat = gl.RG;
				this._glInternalFormat = gl.RG8_SNORM;
				this._glPixelType = gl.BYTE;
				break;
			case PIXELFORMAT_RGBA8S:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = gl.RGBA8_SNORM;
				this._glPixelType = gl.BYTE;
				break;
			case PIXELFORMAT_RGB10A2:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = gl.RGB10_A2;
				this._glPixelType = gl.UNSIGNED_INT_2_10_10_10_REV;
				break;
			case PIXELFORMAT_RGB10A2U:
				this._glFormat = gl.RGBA_INTEGER;
				this._glInternalFormat = gl.RGB10_A2UI;
				this._glPixelType = gl.UNSIGNED_INT_2_10_10_10_REV;
				break;
			// compressed formats ----
			case PIXELFORMAT_DXT1:
				this._glFormat = gl.RGB;
				this._glInternalFormat = device.extCompressedTextureS3TC.COMPRESSED_RGB_S3TC_DXT1_EXT;
				break;
			case PIXELFORMAT_DXT3:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = device.extCompressedTextureS3TC.COMPRESSED_RGBA_S3TC_DXT3_EXT;
				break;
			case PIXELFORMAT_DXT5:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = device.extCompressedTextureS3TC.COMPRESSED_RGBA_S3TC_DXT5_EXT;
				break;
			case PIXELFORMAT_ETC1:
				this._glFormat = gl.RGB;
				this._glInternalFormat = device.extCompressedTextureETC1.COMPRESSED_RGB_ETC1_WEBGL;
				break;
			case PIXELFORMAT_PVRTC_2BPP_RGB_1:
				this._glFormat = gl.RGB;
				this._glInternalFormat = device.extCompressedTexturePVRTC.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
				break;
			case PIXELFORMAT_PVRTC_2BPP_RGBA_1:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = device.extCompressedTexturePVRTC.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
				break;
			case PIXELFORMAT_PVRTC_4BPP_RGB_1:
				this._glFormat = gl.RGB;
				this._glInternalFormat = device.extCompressedTexturePVRTC.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
				break;
			case PIXELFORMAT_PVRTC_4BPP_RGBA_1:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = device.extCompressedTexturePVRTC.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
				break;
			case PIXELFORMAT_ETC2_RGB:
				this._glFormat = gl.RGB;
				this._glInternalFormat = device.extCompressedTextureETC.COMPRESSED_RGB8_ETC2;
				break;
			case PIXELFORMAT_ETC2_RGBA:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = device.extCompressedTextureETC.COMPRESSED_RGBA8_ETC2_EAC;
				break;
			case PIXELFORMAT_ASTC_4x4:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = device.extCompressedTextureASTC.COMPRESSED_RGBA_ASTC_4x4_KHR;
				break;
			case PIXELFORMAT_ATC_RGB:
				this._glFormat = gl.RGB;
				this._glInternalFormat = device.extCompressedTextureATC.COMPRESSED_RGB_ATC_WEBGL;
				break;
			case PIXELFORMAT_ATC_RGBA:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = device.extCompressedTextureATC.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL;
				break;
			case PIXELFORMAT_BC6F:
				this._glFormat = gl.RGB;
				this._glInternalFormat = device.extTextureCompressionBPTC.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
				break;
			case PIXELFORMAT_BC6UF:
				this._glFormat = gl.RGB;
				this._glInternalFormat = device.extTextureCompressionBPTC.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
				break;
			case PIXELFORMAT_BC7:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = device.extTextureCompressionBPTC.COMPRESSED_RGBA_BPTC_UNORM_EXT;
				break;
			// compressed sRGB formats ----
			case PIXELFORMAT_DXT1_SRGB:
				this._glFormat = gl.SRGB;
				this._glInternalFormat = device.extCompressedTextureS3TC_SRGB.COMPRESSED_SRGB_S3TC_DXT1_EXT;
				break;
			case PIXELFORMAT_DXT3_SRGBA:
				this._glFormat = gl.SRGB_ALPHA;
				this._glInternalFormat = device.extCompressedTextureS3TC_SRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
				break;
			case PIXELFORMAT_DXT5_SRGBA:
				this._glFormat = gl.SRGB_ALPHA;
				this._glInternalFormat = device.extCompressedTextureS3TC_SRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
				break;
			case PIXELFORMAT_ETC2_SRGB:
				this._glFormat = gl.SRGB;
				this._glInternalFormat = device.extCompressedTextureETC.COMPRESSED_SRGB8_ETC2;
				break;
			case PIXELFORMAT_ETC2_SRGBA:
				this._glFormat = gl.SRGB_ALPHA;
				this._glInternalFormat = device.extCompressedTextureETC.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC;
				break;
			case PIXELFORMAT_ASTC_4x4_SRGB:
				this._glFormat = gl.SRGB_ALPHA;
				this._glInternalFormat = device.extCompressedTextureASTC.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR;
				break;
			case PIXELFORMAT_BC7_SRGBA:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = device.extTextureCompressionBPTC.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT;
				break;
			// ------------------
			case PIXELFORMAT_R16F:
				this._glFormat = gl.RED;
				this._glInternalFormat = gl.R16F;
				this._glPixelType = gl.HALF_FLOAT;
				break;
			case PIXELFORMAT_RG16F:
				this._glFormat = gl.RG;
				this._glInternalFormat = gl.RG16F;
				this._glPixelType = gl.HALF_FLOAT;
				break;
			case PIXELFORMAT_RGB16F:
				this._glFormat = gl.RGB;
				this._glInternalFormat = gl.RGB16F;
				this._glPixelType = gl.HALF_FLOAT;
				break;
			case PIXELFORMAT_RGBA16F:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = gl.RGBA16F;
				this._glPixelType = gl.HALF_FLOAT;
				break;
			case PIXELFORMAT_RGB32F:
				this._glFormat = gl.RGB;
				this._glInternalFormat = gl.RGB32F;
				this._glPixelType = gl.FLOAT;
				break;
			case PIXELFORMAT_RGBA32F:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = gl.RGBA32F;
				this._glPixelType = gl.FLOAT;
				break;
			case PIXELFORMAT_R32F:
				this._glFormat = gl.RED;
				this._glInternalFormat = gl.R32F;
				this._glPixelType = gl.FLOAT;
				break;
			case PIXELFORMAT_DEPTH:
				this._glFormat = gl.DEPTH_COMPONENT;
				this._glInternalFormat = gl.DEPTH_COMPONENT32F;
				this._glPixelType = gl.FLOAT;
				break;
			case PIXELFORMAT_DEPTH16:
				this._glFormat = gl.DEPTH_COMPONENT;
				this._glInternalFormat = gl.DEPTH_COMPONENT16;
				this._glPixelType = gl.UNSIGNED_SHORT;
				break;
			case PIXELFORMAT_DEPTHSTENCIL:
				this._glFormat = gl.DEPTH_STENCIL;
				this._glInternalFormat = gl.DEPTH24_STENCIL8;
				this._glPixelType = gl.UNSIGNED_INT_24_8;
				break;
			case PIXELFORMAT_111110F:
				this._glFormat = gl.RGB;
				this._glInternalFormat = gl.R11F_G11F_B10F;
				this._glPixelType = gl.UNSIGNED_INT_10F_11F_11F_REV;
				break;
			case PIXELFORMAT_SRGB8:
				this._glFormat = gl.RGB;
				this._glInternalFormat = gl.SRGB8;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_SRGBA8:
				this._glFormat = gl.RGBA;
				this._glInternalFormat = gl.SRGB8_ALPHA8;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			// Integer texture formats (R)
			case PIXELFORMAT_R8I:
				this._glFormat = gl.RED_INTEGER;
				this._glInternalFormat = gl.R8I;
				this._glPixelType = gl.BYTE;
				break;
			case PIXELFORMAT_R8U:
				this._glFormat = gl.RED_INTEGER;
				this._glInternalFormat = gl.R8UI;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_R16I:
				this._glFormat = gl.RED_INTEGER;
				this._glInternalFormat = gl.R16I;
				this._glPixelType = gl.SHORT;
				break;
			case PIXELFORMAT_R16U:
				this._glFormat = gl.RED_INTEGER;
				this._glInternalFormat = gl.R16UI;
				this._glPixelType = gl.UNSIGNED_SHORT;
				break;
			case PIXELFORMAT_R32I:
				this._glFormat = gl.RED_INTEGER;
				this._glInternalFormat = gl.R32I;
				this._glPixelType = gl.INT;
				break;
			case PIXELFORMAT_R32U:
				this._glFormat = gl.RED_INTEGER;
				this._glInternalFormat = gl.R32UI;
				this._glPixelType = gl.UNSIGNED_INT;
				break;
			// Integer texture formats (RG)
			case PIXELFORMAT_RG8I:
				this._glFormat = gl.RG_INTEGER;
				this._glInternalFormat = gl.RG8I;
				this._glPixelType = gl.BYTE;
				break;
			case PIXELFORMAT_RG8U:
				this._glFormat = gl.RG_INTEGER;
				this._glInternalFormat = gl.RG8UI;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_RG16I:
				this._glFormat = gl.RG_INTEGER;
				this._glInternalFormat = gl.RG16I;
				this._glPixelType = gl.SHORT;
				break;
			case PIXELFORMAT_RG16U:
				this._glFormat = gl.RG_INTEGER;
				this._glInternalFormat = gl.RG16UI;
				this._glPixelType = gl.UNSIGNED_SHORT;
				break;
			case PIXELFORMAT_RG32I:
				this._glFormat = gl.RG_INTEGER;
				this._glInternalFormat = gl.RG32I;
				this._glPixelType = gl.INT;
				break;
			case PIXELFORMAT_RG32U:
				this._glFormat = gl.RG_INTEGER;
				this._glInternalFormat = gl.RG32UI;
				this._glPixelType = gl.UNSIGNED_INT;
				break;
			// Integer texture formats (RGBA)
			case PIXELFORMAT_RGBA8I:
				this._glFormat = gl.RGBA_INTEGER;
				this._glInternalFormat = gl.RGBA8I;
				this._glPixelType = gl.BYTE;
				break;
			case PIXELFORMAT_RGBA8U:
				this._glFormat = gl.RGBA_INTEGER;
				this._glInternalFormat = gl.RGBA8UI;
				this._glPixelType = gl.UNSIGNED_BYTE;
				break;
			case PIXELFORMAT_RGBA16I:
				this._glFormat = gl.RGBA_INTEGER;
				this._glInternalFormat = gl.RGBA16I;
				this._glPixelType = gl.SHORT;
				break;
			case PIXELFORMAT_RGBA16U:
				this._glFormat = gl.RGBA_INTEGER;
				this._glInternalFormat = gl.RGBA16UI;
				this._glPixelType = gl.UNSIGNED_SHORT;
				break;
			case PIXELFORMAT_RGBA32I:
				this._glFormat = gl.RGBA_INTEGER;
				this._glInternalFormat = gl.RGBA32I;
				this._glPixelType = gl.INT;
				break;
			case PIXELFORMAT_RGBA32U:
				this._glFormat = gl.RGBA_INTEGER;
				this._glInternalFormat = gl.RGBA32UI;
				this._glPixelType = gl.UNSIGNED_INT;
				break;
		}
		this._glCreated = false;
	}
	upload(device, texture) {
		const gl = device.gl;
		if (!texture._needsUpload && (texture._needsMipmapsUpload && texture._mipmapsUploaded || !texture.pot)) {
			return;
		}
		let mipLevel = 0;
		let mipObject;
		let resMult;
		const requiredMipLevels = texture.numLevels;
		if (texture.array && !this._glCreated) {
			gl.texStorage3D(
				gl.TEXTURE_2D_ARRAY,
				requiredMipLevels,
				this._glInternalFormat,
				texture._width,
				texture._height,
				texture._arrayLength
			);
		}
		while (texture._levels[mipLevel] || mipLevel === 0) {
			if (!texture._needsUpload && mipLevel === 0) {
				mipLevel++;
				continue;
			} else if (mipLevel && (!texture._needsMipmapsUpload || !texture._mipmaps)) {
				break;
			}
			mipObject = texture._levels[mipLevel];
			resMult = 1 / Math.pow(2, mipLevel);
			if (mipLevel === 1 && !texture._compressed && !texture._integerFormat && texture._levels.length < requiredMipLevels) {
				gl.generateMipmap(this._glTarget);
				texture._mipmapsUploaded = true;
			}
			if (texture._cubemap) {
				let face;
				if (device._isBrowserInterface(mipObject[0])) {
					for (face = 0; face < 6; face++) {
						if (!texture._levelsUpdated[0][face]) {
							continue;
						}
						let src = mipObject[face];
						if (device._isImageBrowserInterface(src)) {
							if (src.width > device.maxCubeMapSize || src.height > device.maxCubeMapSize) {
								src = downsampleImage(src, device.maxCubeMapSize);
								if (mipLevel === 0) {
									texture._width = src.width;
									texture._height = src.height;
								}
							}
						}
						device.setUnpackFlipY(false);
						device.setUnpackPremultiplyAlpha(texture._premultiplyAlpha);
						if (this._glCreated) {
							gl.texSubImage2D(
								gl.TEXTURE_CUBE_MAP_POSITIVE_X + face,
								mipLevel,
								0,
								0,
								this._glFormat,
								this._glPixelType,
								src
							);
						} else {
							gl.texImage2D(
								gl.TEXTURE_CUBE_MAP_POSITIVE_X + face,
								mipLevel,
								this._glInternalFormat,
								this._glFormat,
								this._glPixelType,
								src
							);
						}
					}
				} else {
					resMult = 1 / Math.pow(2, mipLevel);
					for (face = 0; face < 6; face++) {
						if (!texture._levelsUpdated[0][face]) {
							continue;
						}
						const texData = mipObject[face];
						if (texture._compressed) {
							if (this._glCreated && texData) {
								gl.compressedTexSubImage2D(
									gl.TEXTURE_CUBE_MAP_POSITIVE_X + face,
									mipLevel,
									0,
									0,
									Math.max(texture._width * resMult, 1),
									Math.max(texture._height * resMult, 1),
									this._glInternalFormat,
									texData
								);
							} else {
								gl.compressedTexImage2D(
									gl.TEXTURE_CUBE_MAP_POSITIVE_X + face,
									mipLevel,
									this._glInternalFormat,
									Math.max(texture._width * resMult, 1),
									Math.max(texture._height * resMult, 1),
									0,
									texData
								);
							}
						} else {
							device.setUnpackFlipY(false);
							device.setUnpackPremultiplyAlpha(texture._premultiplyAlpha);
							device.setUnpackAlignment(1);
							if (this._glCreated && texData) {
								gl.texSubImage2D(
									gl.TEXTURE_CUBE_MAP_POSITIVE_X + face,
									mipLevel,
									0,
									0,
									Math.max(texture._width * resMult, 1),
									Math.max(texture._height * resMult, 1),
									this._glFormat,
									this._glPixelType,
									texData
								);
							} else {
								gl.texImage2D(
									gl.TEXTURE_CUBE_MAP_POSITIVE_X + face,
									mipLevel,
									this._glInternalFormat,
									Math.max(texture._width * resMult, 1),
									Math.max(texture._height * resMult, 1),
									0,
									this._glFormat,
									this._glPixelType,
									texData
								);
							}
						}
					}
				}
			} else if (texture._volume) {
				if (texture._compressed) {
					gl.compressedTexImage3D(
						gl.TEXTURE_3D,
						mipLevel,
						this._glInternalFormat,
						Math.max(texture._width * resMult, 1),
						Math.max(texture._height * resMult, 1),
						Math.max(texture._depth * resMult, 1),
						0,
						mipObject
					);
				} else {
					device.setUnpackFlipY(false);
					device.setUnpackPremultiplyAlpha(texture._premultiplyAlpha);
					device.setUnpackAlignment(1);
					gl.texImage3D(
						gl.TEXTURE_3D,
						mipLevel,
						this._glInternalFormat,
						Math.max(texture._width * resMult, 1),
						Math.max(texture._height * resMult, 1),
						Math.max(texture._depth * resMult, 1),
						0,
						this._glFormat,
						this._glPixelType,
						mipObject
					);
				}
			} else if (texture.array) {
				if (Array.isArray(mipObject) && texture._arrayLength === mipObject.length) {
					if (texture._compressed) {
						for (let index = 0; index < texture._arrayLength; index++) {
							gl.compressedTexSubImage3D(
								gl.TEXTURE_2D_ARRAY,
								mipLevel,
								0,
								0,
								index,
								Math.max(Math.floor(texture._width * resMult), 1),
								Math.max(Math.floor(texture._height * resMult), 1),
								1,
								this._glInternalFormat,
								mipObject[index]
							);
						}
					} else {
						device.setUnpackAlignment(1);
						for (let index = 0; index < texture._arrayLength; index++) {
							gl.texSubImage3D(
								gl.TEXTURE_2D_ARRAY,
								mipLevel,
								0,
								0,
								index,
								Math.max(Math.floor(texture._width * resMult), 1),
								Math.max(Math.floor(texture._height * resMult), 1),
								1,
								this._glFormat,
								this._glPixelType,
								mipObject[index]
							);
						}
					}
				}
			} else {
				if (device._isBrowserInterface(mipObject)) {
					if (device._isHTMLElementInterface(mipObject) && device.supportsHtmlTextures) {
						device.setUnpackFlipY(texture._flipY);
						device.setUnpackPremultiplyAlpha(texture._premultiplyAlpha);
						const rect = mipObject.getBoundingClientRect();
						const w = Math.floor(rect.width) || texture._width;
						const h2 = Math.floor(rect.height) || texture._height;
						gl.texElementImage2D(
							gl.TEXTURE_2D,
							this._glInternalFormat,
							mipObject
						);
						if (mipLevel === 0) {
							texture._width = w;
							texture._height = h2;
						}
					} else {
						if (device._isImageBrowserInterface(mipObject)) {
							if (mipObject.width > device.maxTextureSize || mipObject.height > device.maxTextureSize) {
								mipObject = downsampleImage(mipObject, device.maxTextureSize);
								if (mipLevel === 0) {
									texture._width = mipObject.width;
									texture._height = mipObject.height;
								}
							}
						}
						const w = mipObject.width || mipObject.videoWidth;
						const h2 = mipObject.height || mipObject.videoHeight;
						device.setUnpackFlipY(texture._flipY);
						device.setUnpackPremultiplyAlpha(texture._premultiplyAlpha);
						if (this._glCreated && texture._width === w && texture._height === h2 && !device._isImageVideoInterface(mipObject)) {
							gl.texSubImage2D(
								gl.TEXTURE_2D,
								mipLevel,
								0,
								0,
								this._glFormat,
								this._glPixelType,
								mipObject
							);
						} else {
							gl.texImage2D(
								gl.TEXTURE_2D,
								mipLevel,
								this._glInternalFormat,
								this._glFormat,
								this._glPixelType,
								mipObject
							);
							if (mipLevel === 0) {
								texture._width = w;
								texture._height = h2;
							}
						}
					}
				} else {
					resMult = 1 / Math.pow(2, mipLevel);
					if (texture._compressed) {
						if (this._glCreated && mipObject) {
							gl.compressedTexSubImage2D(
								gl.TEXTURE_2D,
								mipLevel,
								0,
								0,
								Math.max(Math.floor(texture._width * resMult), 1),
								Math.max(Math.floor(texture._height * resMult), 1),
								this._glInternalFormat,
								mipObject
							);
						} else {
							gl.compressedTexImage2D(
								gl.TEXTURE_2D,
								mipLevel,
								this._glInternalFormat,
								Math.max(Math.floor(texture._width * resMult), 1),
								Math.max(Math.floor(texture._height * resMult), 1),
								0,
								mipObject
							);
						}
					} else {
						device.setUnpackFlipY(false);
						device.setUnpackPremultiplyAlpha(texture._premultiplyAlpha);
						device.setUnpackAlignment(1);
						if (this._glCreated && mipObject) {
							gl.texSubImage2D(
								gl.TEXTURE_2D,
								mipLevel,
								0,
								0,
								Math.max(texture._width * resMult, 1),
								Math.max(texture._height * resMult, 1),
								this._glFormat,
								this._glPixelType,
								mipObject
							);
						} else {
							gl.texImage2D(
								gl.TEXTURE_2D,
								mipLevel,
								this._glInternalFormat,
								Math.max(texture._width * resMult, 1),
								Math.max(texture._height * resMult, 1),
								0,
								this._glFormat,
								this._glPixelType,
								mipObject
							);
						}
					}
				}
				if (mipLevel === 0) {
					texture._mipmapsUploaded = false;
				} else {
					texture._mipmapsUploaded = true;
				}
			}
			mipLevel++;
		}
		if (texture._needsUpload) {
			if (texture._cubemap) {
				for (let i2 = 0; i2 < 6; i2++) {
					texture._levelsUpdated[0][i2] = false;
				}
			} else {
				texture._levelsUpdated[0] = false;
			}
		}
		if (!texture._compressed && !texture._integerFormat && texture._mipmaps && texture._needsMipmapsUpload && texture._levels.length === 1) {
			gl.generateMipmap(this._glTarget);
			texture._mipmapsUploaded = true;
		}
		if (texture._gpuSize) {
			texture.adjustVramSizeTracking(device._vram, -texture._gpuSize);
		}
		texture._gpuSize = texture.gpuSize;
		texture.adjustVramSizeTracking(device._vram, texture._gpuSize);
		if (texture.releaseSourceAfterUpload) {
			texture.releaseImageSources();
		}
		this._glCreated = true;
	}
	uploadImmediate(device, texture) {
		if (texture._needsUpload || texture._needsMipmapsUpload) {
			device.setTexture(texture, 0);
			texture._needsUpload = false;
			texture._needsMipmapsUpload = false;
		}
	}
	read(x3, y2, width, height, options2) {
		const texture = this.texture;
		const device = texture.device;
		return device.readTextureAsync(texture, x3, y2, width, height, options2);
	}
	write(x3, y2, width, height, data2) {
		const { texture } = this;
		const { device } = texture;
		device.setTexture(texture, 0);
		return device.writeTextureAsync(texture, x3, y2, width, height, data2);
	}
	copy(source, options2) {
		return this.texture.device.copyTextureToTexture(source, this.texture, options2);
	}
};

var _validatedFboConfigs = new DeviceCache();
var FramebufferPair = class {
	msaaFB;
	resolveFB;
	constructor(msaaFB, resolveFB) {
		this.msaaFB = msaaFB;
		this.resolveFB = resolveFB;
	}
	destroy(gl) {
		if (this.msaaFB) {
			gl.deleteRenderbuffer(this.msaaFB);
			this.msaaFB = null;
		}
		if (this.resolveFB) {
			gl.deleteRenderbuffer(this.resolveFB);
			this.resolveFB = null;
		}
	}
};
var WebglRenderTarget = class {
	_glFrameBuffer = null;
	_glDepthBuffer = null;
	_glResolveFrameBuffer = null;
	colorMrtFramebuffers = null;
	_glMsaaColorBuffers = [];
	_glMsaaDepthBuffer = null;
	msaaDepthBufferKey;
	suppliedColorFramebuffer;
	_isInitialized = false;
	destroy(device) {
		const gl = device.gl;
		this._isInitialized = false;
		if (this._glFrameBuffer) {
			if (this._glFrameBuffer !== this.suppliedColorFramebuffer) {
				gl.deleteFramebuffer(this._glFrameBuffer);
			}
			this._glFrameBuffer = null;
		}
		if (this._glDepthBuffer) {
			gl.deleteRenderbuffer(this._glDepthBuffer);
			this._glDepthBuffer = null;
		}
		if (this._glResolveFrameBuffer) {
			if (this._glResolveFrameBuffer !== this.suppliedColorFramebuffer) {
				gl.deleteFramebuffer(this._glResolveFrameBuffer);
			}
			this._glResolveFrameBuffer = null;
		}
		this._glMsaaColorBuffers.forEach((buffer) => {
			gl.deleteRenderbuffer(buffer);
		});
		this._glMsaaColorBuffers.length = 0;
		this.colorMrtFramebuffers?.forEach((framebuffer) => {
			framebuffer.destroy(gl);
		});
		this.colorMrtFramebuffers = null;
		if (this._glMsaaDepthBuffer) {
			this._glMsaaDepthBuffer = null;
			if (this.msaaDepthBufferKey) {
				getMultisampledTextureCache(device).release(this.msaaDepthBufferKey);
			}
		}
		this.suppliedColorFramebuffer = void 0;
	}
	get initialized() {
		return this._isInitialized;
	}
	init(device, target2) {
		const gl = device.gl;
		this._isInitialized = true;
		const buffers = [];
		if (this.suppliedColorFramebuffer !== void 0) {
			this._glFrameBuffer = this.suppliedColorFramebuffer;
		} else {
			this._glFrameBuffer = gl.createFramebuffer();
			device.setFramebuffer(this._glFrameBuffer);
			const colorBufferCount = target2._colorBuffers?.length ?? 0;
			const attachmentBaseConstant = gl.COLOR_ATTACHMENT0;
			for (let i2 = 0; i2 < colorBufferCount; ++i2) {
				const colorBuffer = target2.getColorBuffer(i2);
				if (colorBuffer) {
					if (!colorBuffer.impl._glTexture) {
						colorBuffer._width = Math.min(colorBuffer.width, device.maxRenderBufferSize);
						colorBuffer._height = Math.min(colorBuffer.height, device.maxRenderBufferSize);
						device.setTexture(colorBuffer, 0);
					}
					gl.framebufferTexture2D(
						gl.FRAMEBUFFER,
						attachmentBaseConstant + i2,
						colorBuffer._cubemap ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + target2._face : gl.TEXTURE_2D,
						colorBuffer.impl._glTexture,
						target2.mipLevel
					);
					buffers.push(attachmentBaseConstant + i2);
				}
			}
			gl.drawBuffers(buffers);
			const depthBuffer = target2._depthBuffer;
			if (depthBuffer || target2._depth) {
				const attachmentPoint = target2._stencil ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
				if (depthBuffer) {
					if (!depthBuffer.impl._glTexture) {
						depthBuffer._width = Math.min(depthBuffer.width, device.maxRenderBufferSize);
						depthBuffer._height = Math.min(depthBuffer.height, device.maxRenderBufferSize);
						device.setTexture(depthBuffer, 0);
					}
					gl.framebufferTexture2D(
						gl.FRAMEBUFFER,
						attachmentPoint,
						depthBuffer._cubemap ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + target2._face : gl.TEXTURE_2D,
						target2._depthBuffer.impl._glTexture,
						target2.mipLevel
					);
				} else {
					const willRenderMsaa = target2._samples > 1;
					if (!willRenderMsaa) {
						if (!this._glDepthBuffer) {
							this._glDepthBuffer = gl.createRenderbuffer();
						}
						const internalFormat = target2._stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT32F;
						gl.bindRenderbuffer(gl.RENDERBUFFER, this._glDepthBuffer);
						gl.renderbufferStorage(gl.RENDERBUFFER, internalFormat, target2.width, target2.height);
						gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachmentPoint, gl.RENDERBUFFER, this._glDepthBuffer);
						gl.bindRenderbuffer(gl.RENDERBUFFER, null);
					}
				}
			}
		}
		if (target2._samples > 1) {
			this._glResolveFrameBuffer = this._glFrameBuffer;
			this._glFrameBuffer = gl.createFramebuffer();
			device.setFramebuffer(this._glFrameBuffer);
			const colorBufferCount = target2._colorBuffers?.length ?? 0;
			if (this.suppliedColorFramebuffer !== void 0) {
				const buffer = gl.createRenderbuffer();
				this._glMsaaColorBuffers.push(buffer);
				const internalFormat = device.backBufferFormat === PIXELFORMAT_RGBA8 ? gl.RGBA8 : gl.RGB8;
				gl.bindRenderbuffer(gl.RENDERBUFFER, buffer);
				gl.renderbufferStorageMultisample(gl.RENDERBUFFER, target2._samples, internalFormat, target2.width, target2.height);
				gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, buffer);
			} else {
				for (let i2 = 0; i2 < colorBufferCount; ++i2) {
					const colorBuffer = target2.getColorBuffer(i2);
					if (colorBuffer) {
						const buffer = gl.createRenderbuffer();
						this._glMsaaColorBuffers.push(buffer);
						gl.bindRenderbuffer(gl.RENDERBUFFER, buffer);
						gl.renderbufferStorageMultisample(gl.RENDERBUFFER, target2._samples, colorBuffer.impl._glInternalFormat, target2.width, target2.height);
						gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i2, gl.RENDERBUFFER, buffer);
					}
				}
			}
			if (target2._depth) {
				const internalFormat = target2._stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT32F;
				const attachmentPoint = target2._stencil ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
				let key;
				const depthBuffer = target2._depthBuffer;
				if (depthBuffer) {
					key = `${depthBuffer.id}:${target2.width}:${target2.height}:${target2._samples}:${internalFormat}:${attachmentPoint}`;
					this._glMsaaDepthBuffer = getMultisampledTextureCache(device).get(key);
				}
				if (!this._glMsaaDepthBuffer) {
					this._glMsaaDepthBuffer = gl.createRenderbuffer();
					gl.bindRenderbuffer(gl.RENDERBUFFER, this._glMsaaDepthBuffer);
					gl.renderbufferStorageMultisample(gl.RENDERBUFFER, target2._samples, internalFormat, target2.width, target2.height);
					this._glMsaaDepthBuffer.destroy = function() {
						gl.deleteRenderbuffer(this);
					};
					if (depthBuffer) {
						getMultisampledTextureCache(device).set(key, this._glMsaaDepthBuffer);
					}
				}
				this.msaaDepthBufferKey = key;
				gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachmentPoint, gl.RENDERBUFFER, this._glMsaaDepthBuffer);
			}
			if (colorBufferCount > 1) {
				this._createMsaaMrtFramebuffers(device, target2, colorBufferCount);
				device.setFramebuffer(this._glFrameBuffer);
				gl.drawBuffers(buffers);
			}
		}
	}
	_createMsaaMrtFramebuffers(device, target2, colorBufferCount) {
		const gl = device.gl;
		this.colorMrtFramebuffers = [];
		for (let i2 = 0; i2 < colorBufferCount; ++i2) {
			const colorBuffer = target2.getColorBuffer(i2);
			const srcFramebuffer = gl.createFramebuffer();
			device.setFramebuffer(srcFramebuffer);
			const buffer = this._glMsaaColorBuffers[i2];
			gl.bindRenderbuffer(gl.RENDERBUFFER, buffer);
			gl.renderbufferStorageMultisample(gl.RENDERBUFFER, target2._samples, colorBuffer.impl._glInternalFormat, target2.width, target2.height);
			gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, buffer);
			gl.drawBuffers([gl.COLOR_ATTACHMENT0]);
			const dstFramebuffer = gl.createFramebuffer();
			device.setFramebuffer(dstFramebuffer);
			gl.framebufferTexture2D(
				gl.FRAMEBUFFER,
				gl.COLOR_ATTACHMENT0,
				colorBuffer._cubemap ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + target2._face : gl.TEXTURE_2D,
				colorBuffer.impl._glTexture,
				0
			);
			this.colorMrtFramebuffers[i2] = new FramebufferPair(srcFramebuffer, dstFramebuffer);
		}
	}
	_checkFbo(device, target2, type = "") {
		const colorFormats = target2._colorBuffers?.map((b) => b?.format ?? -1).join(",") ?? "";
		const depthInfo = target2._depth ? target2._depthBuffer ? `dt${target2._depthBuffer.format}` : target2._stencil ? "ds" : "d" : "";
		const key = `${type}:${colorFormats}:${depthInfo}:${target2._samples}`;
		const validated = _validatedFboConfigs.get(device, () => {
			const set = /* @__PURE__ */ new Set();
			set.loseContext = () => set.clear();
			return set;
		});
		if (validated.has(key)) {
			return;
		}
		const gl = device.gl;
		const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
		let errorCode;
		switch (status) {
			case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
				errorCode = "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
				break;
			case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
				errorCode = "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
				break;
			case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
				errorCode = "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
				break;
			case gl.FRAMEBUFFER_UNSUPPORTED:
				errorCode = "FRAMEBUFFER_UNSUPPORTED";
				break;
		}
		if (status === gl.FRAMEBUFFER_COMPLETE) {
			validated.add(key);
		}
	}
	loseContext() {
		this._glFrameBuffer = null;
		this._glDepthBuffer = null;
		this._glResolveFrameBuffer = null;
		this._glMsaaColorBuffers.length = 0;
		this._glMsaaDepthBuffer = null;
		this.msaaDepthBufferKey = void 0;
		this.colorMrtFramebuffers = null;
		this.suppliedColorFramebuffer = void 0;
		this._isInitialized = false;
	}
	internalResolve(device, src, dst, target2, mask) {
		device.setScissor(0, 0, target2.width, target2.height);
		const gl = device.gl;
		gl.bindFramebuffer(gl.READ_FRAMEBUFFER, src);
		gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, dst);
		gl.blitFramebuffer(
			0,
			0,
			target2.width,
			target2.height,
			0,
			0,
			target2.width,
			target2.height,
			mask,
			gl.NEAREST
		);
	}
	resolve(device, target2, color3, depth) {
		const gl = device.gl;
		if (this.colorMrtFramebuffers) {
			if (color3) {
				for (let i2 = 0; i2 < this.colorMrtFramebuffers.length; i2++) {
					const fbPair = this.colorMrtFramebuffers[i2];
					this.internalResolve(device, fbPair.msaaFB, fbPair.resolveFB, target2, gl.COLOR_BUFFER_BIT);
				}
			}
			if (depth) {
				this.internalResolve(device, this._glFrameBuffer, this._glResolveFrameBuffer, target2, gl.DEPTH_BUFFER_BIT);
			}
		} else {
			const isXrFramebuffer = !!device.defaultFramebuffer && this._glResolveFrameBuffer === device.defaultFramebuffer;
			const xrColorQuad = color3 && isXrFramebuffer && platform.visionos;
			if (xrColorQuad) {
				device.resolveMsaaColorToXrFramebufferViaQuads(
					this._glFrameBuffer,
					this._glResolveFrameBuffer,
					target2.width,
					target2.height
				);
				color3 = false;
			}
			if (color3 || depth) {
				this.internalResolve(
					device,
					this._glFrameBuffer,
					this._glResolveFrameBuffer,
					target2,
					(color3 ? gl.COLOR_BUFFER_BIT : 0) | (depth ? gl.DEPTH_BUFFER_BIT : 0)
				);
			}
		}
		gl.bindFramebuffer(gl.FRAMEBUFFER, this._glFrameBuffer);
	}
};

var WebglUploadStream = class {
	availablePBOs = [];
	pendingPBOs = [];
	constructor(uploadStream) {
		this.uploadStream = uploadStream;
		this.useSingleBuffer = uploadStream.useSingleBuffer;
	}
	destroy() {
		const gl = this.uploadStream.device.gl;
		this.availablePBOs.forEach((info) => gl.deleteBuffer(info.pbo));
		this.pendingPBOs.forEach((item) => {
			if (item.sync) gl.deleteSync(item.sync);
			gl.deleteBuffer(item.pbo);
		});
	}
	_onDeviceLost() {
		this.availablePBOs.length = 0;
		this.pendingPBOs.length = 0;
	}
	update(minByteSize) {
		const gl = this.uploadStream.device.gl;
		const pending = this.pendingPBOs;
		for (let i2 = pending.length - 1; i2 >= 0; i2--) {
			const item = pending[i2];
			const result = gl.clientWaitSync(item.sync, 0, 0);
			if (result === gl.CONDITION_SATISFIED || result === gl.ALREADY_SIGNALED) {
				gl.deleteSync(item.sync);
				this.availablePBOs.push({ pbo: item.pbo, size: item.size });
				pending.splice(i2, 1);
			}
		}
		const available = this.availablePBOs;
		for (let i2 = available.length - 1; i2 >= 0; i2--) {
			if (available[i2].size < minByteSize) {
				gl.deleteBuffer(available[i2].pbo);
				available.splice(i2, 1);
			}
		}
	}
	upload(data2, target2, offset3, size) {
		if (this.useSingleBuffer) {
			this.uploadDirect(data2, target2, offset3, size);
		} else {
			this.uploadPBO(data2, target2, offset3, size);
		}
	}
	uploadDirect(data2, target2, offset3, size) {
		const device = this.uploadStream.device;
		const gl = device.gl;
		const impl = target2.impl;
		device.setTexture(target2, 0);
		device.activeTexture(0);
		device.bindTexture(target2);
		device.setUnpackFlipY(false);
		device.setUnpackPremultiplyAlpha(false);
		device.setUnpackAlignment(data2.BYTES_PER_ELEMENT);
		let src = data2;
		if (impl._glPixelType === gl.UNSIGNED_BYTE && data2.BYTES_PER_ELEMENT !== 1) {
			const byteSize = size * data2.BYTES_PER_ELEMENT;
			src = new Uint8Array(data2.buffer, data2.byteOffset, byteSize);
		}
		gl.texImage2D(
			gl.TEXTURE_2D,
			0,
			impl._glInternalFormat,
			target2.width,
			target2.height,
			0,
			impl._glFormat,
			impl._glPixelType,
			src
		);
		impl._glCreated = true;
	}
	uploadPBO(data2, target2, offset3, size) {
		const device = this.uploadStream.device;
		const gl = device.gl;
		const width = target2.width;
		const byteSize = size * data2.BYTES_PER_ELEMENT;
		this.update(byteSize);
		const startY = offset3 / width;
		const height = size / width;
		const pboInfo = this.availablePBOs.pop() ?? (() => {
			const pbo = gl.createBuffer();
			return { pbo, size: byteSize };
		})();
		gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, pboInfo.pbo);
		gl.bufferData(gl.PIXEL_UNPACK_BUFFER, byteSize, gl.STREAM_DRAW);
		gl.bufferSubData(gl.PIXEL_UNPACK_BUFFER, 0, new Uint8Array(data2.buffer, data2.byteOffset, byteSize));
		gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, null);
		device.setTexture(target2, 0);
		device.activeTexture(0);
		device.bindTexture(target2);
		gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, pboInfo.pbo);
		device.setUnpackFlipY(false);
		device.setUnpackPremultiplyAlpha(false);
		device.setUnpackAlignment(data2.BYTES_PER_ELEMENT);
		gl.pixelStorei(gl.UNPACK_ROW_LENGTH, 0);
		gl.pixelStorei(gl.UNPACK_SKIP_ROWS, 0);
		gl.pixelStorei(gl.UNPACK_SKIP_PIXELS, 0);
		const impl = target2.impl;
		gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, startY, width, height, impl._glFormat, impl._glPixelType, 0);
		gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, null);
		const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
		this.pendingPBOs.push({ pbo: pboInfo.pbo, size: byteSize, sync });
		gl.flush();
	}
};

var WebglXrBridge = class {
	_presentationLayer = null;
	_graphicsBinding = null;
	_cameraFbSource = null;
	_cameraFbDest = null;
	constructor(xrBridge) {
		this.xrBridge = xrBridge;
	}
	destroy(device) {
		this._graphicsBinding = null;
		this._presentationLayer = null;
		this._deleteCameraFramebuffers(device);
	}
	_deleteCameraFramebuffers(device) {
		if (this._cameraFbSource) {
			const gl = device.gl;
			gl.deleteFramebuffer(this._cameraFbSource);
			this._cameraFbSource = null;
			gl.deleteFramebuffer(this._cameraFbDest);
			this._cameraFbDest = null;
		}
	}
	beginFrame(frame, _referenceSpace) {
		const baseLayer = frame.session.renderState.baseLayer;
		this.xrBridge.device.defaultFramebuffer = baseLayer ? baseLayer.framebuffer : null;
	}
	endFrame() {
		this.xrBridge.device.defaultFramebuffer = null;
	}
	get presentationLayer() {
		return this._presentationLayer;
	}
	get graphicsBinding() {
		return this._graphicsBinding;
	}
	getFramebufferSize(frame, out) {
		const baseLayer = frame.session.renderState.baseLayer;
		if (!baseLayer) {
			out.set(0, 0);
			return;
		}
		out.set(baseLayer.framebufferWidth, baseLayer.framebufferHeight);
	}
	getViewport(frame, xrView) {
		const baseLayer = frame.session.renderState.baseLayer;
		if (!baseLayer) {
			return { x: 0, y: 0, width: 0, height: 0 };
		}
		return baseLayer.getViewport(xrView);
	}
	attachPresentation(session, options2) {
		const device = this.xrBridge.device;
		this._presentationLayer = new XRWebGLLayer(session, device.gl, {
			alpha: true,
			depth: true,
			stencil: true,
			framebufferScaleFactor: options2.framebufferScaleFactor,
			antialias: false
		});
		if (window.XRWebGLBinding) {
			try {
				this._graphicsBinding = new XRWebGLBinding(session, device.gl);
			} catch (ex) {
				this.xrBridge._onBindingError?.(ex);
			}
		}
		session.updateRenderState({
			baseLayer: this._presentationLayer,
			depthNear: options2.depthNear,
			depthFar: options2.depthFar
		});
	}
	releasePresentation() {
		this._graphicsBinding = null;
	}
	syncCameraColorTexture(xrCamera, texture) {
		if (!this._graphicsBinding) {
			return;
		}
		const device = this.xrBridge.device;
		const gl = device.gl;
		const src = this._graphicsBinding.getCameraImage(xrCamera);
		if (!src) {
			return;
		}
		if (!this._cameraFbSource) {
			this._cameraFbSource = gl.createFramebuffer();
			this._cameraFbDest = gl.createFramebuffer();
		}
		const width = xrCamera.width;
		const height = xrCamera.height;
		device.setFramebuffer(this._cameraFbSource);
		gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, src, 0);
		device.setFramebuffer(this._cameraFbDest);
		gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture.impl._glTexture, 0);
		gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this._cameraFbSource);
		gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this._cameraFbDest);
		gl.blitFramebuffer(0, height, width, 0, 0, 0, width, height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
		device.setFramebuffer(device.defaultFramebuffer);
	}
	syncCameraDepthTexture(depthInfo, texture, depthPixelFormat) {
		if (!depthInfo?.texture) {
			return;
		}
		const gl = this.xrBridge.device.gl;
		texture.impl._glTexture = depthInfo.texture;
		if (depthInfo.textureType === "texture-array") {
			texture.impl._glTarget = gl.TEXTURE_2D_ARRAY;
		} else {
			texture.impl._glTarget = gl.TEXTURE_2D;
		}
		switch (depthPixelFormat) {
			case PIXELFORMAT_R32F:
				texture.impl._glInternalFormat = gl.R32F;
				texture.impl._glPixelType = gl.FLOAT;
				texture.impl._glFormat = gl.RED;
				break;
			case PIXELFORMAT_DEPTH:
				texture.impl._glInternalFormat = gl.DEPTH_COMPONENT16;
				texture.impl._glPixelType = gl.UNSIGNED_SHORT;
				texture.impl._glFormat = gl.DEPTH_COMPONENT;
				break;
		}
		texture.impl._glCreated = true;
	}
	onGraphicsDeviceLost() {
		const session = this.xrBridge._session;
		if (!session) {
			return;
		}
		const rs = session.renderState;
		this._graphicsBinding = null;
		this._presentationLayer = null;
		this._cameraFbSource = null;
		this._cameraFbDest = null;
		session.updateRenderState({
			baseLayer: this._presentationLayer,
			depthNear: rs.depthNear,
			depthFar: rs.depthFar
		});
	}
	onGraphicsDeviceRestored() {
		const bridge = this.xrBridge;
		if (!bridge._session) {
			return;
		}
		const device = bridge.device;
		const eventHandler = bridge.eventHandler;
		setTimeout(() => {
			if (!bridge._session) {
				return;
			}
			device.gl.makeXRCompatible().then(() => {
				if (!bridge._session) {
					return;
				}
				const rs = bridge._session.renderState;
				bridge.attachPresentation(bridge._session, {
					framebufferScaleFactor: bridge._framebufferScaleFactor,
					depthNear: rs.depthNear,
					depthFar: rs.depthFar,
					onBindingError: bridge._onBindingError
				});
			}).catch((ex) => {
				eventHandler.fire("error", ex);
			});
		}, 0);
	}
};

var _quadPrimitive = {
	type: PRIMITIVE_TRIANGLES,
	base: 0,
	count: 6,
	indexed: true
};
var vsSrc = `
	attribute vec2 vertex_position;
	varying vec2 pcTexCoord;
	void main() {
		gl_Position = vec4(vertex_position, 0.0, 1.0);
		pcTexCoord = vertex_position * 0.5 + 0.5;
	}
`;
var fsSrc = `
	uniform sampler2D pcSource;
	varying vec2 pcTexCoord;
	void main() {
		gl_FragColor = texture2D(pcSource, pcTexCoord);
	}
`;
var WebglXrMsaaCopy = class {
	_device;
	_shader = null;
	_scratchTex = null;
	_scratchRt = null;
	_sourceId = null;
	constructor(device) {
		this._device = device;
	}
	_getShader() {
		if (!this._shader) {
			const device = this._device;
			this._shader = new Shader(device, ShaderDefinitionUtils.createDefinition(device, {
				name: "XrMsaaCopy",
				attributes: { vertex_position: SEMANTIC_POSITION },
				vertexCode: vsSrc,
				fragmentCode: fsSrc
			}));
			this._sourceId = device.scope.resolve("pcSource");
		}
		return this._shader;
	}
	_ensureScratch(width, height) {
		const device = this._device;
		if (this._scratchTex && (this._scratchTex.width !== width || this._scratchTex.height !== height)) {
			this._scratchRt.destroy();
			this._scratchRt = null;
			this._scratchTex.destroy();
			this._scratchTex = null;
		}
		if (!this._scratchTex) {
			this._scratchTex = Texture.createDataTexture2D(device, "XrMsaaScratch", width, height, device.backBufferFormat);
			this._scratchRt = new RenderTarget({
				colorBuffer: this._scratchTex,
				depth: false,
				stencil: false
			});
		}
		if (!this._scratchRt.impl.initialized) {
			this._scratchRt.impl.init(device, this._scratchRt);
		}
	}
	copy(msaaReadFbo, xrDrawFbo, width, height) {
		this._ensureScratch(width, height);
		const device = this._device;
		const gl = device.gl;
		gl.bindFramebuffer(gl.READ_FRAMEBUFFER, msaaReadFbo);
		gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this._scratchRt.impl._glFrameBuffer);
		gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
		device.setDrawStates(BlendState.NOBLEND, DepthState.NODEPTH);
		device.setFramebuffer(xrDrawFbo);
		device.setShader(this._getShader());
		device.clearVertexBuffer();
		device.setVertexBuffer(device.quadVertexBuffer);
		this._sourceId.setValue(this._scratchTex);
		const { vx, vy, vw, vh, sx, sy, sw, sh } = device;
		device.setViewport(0, 0, width, height);
		device.setScissor(0, 0, width, height);
		device.draw(_quadPrimitive, device.quadIndexBuffer);
		device.setViewport(vx, vy, vw, vh);
		device.setScissor(sx, sy, sw, sh);
		device.setFramebuffer(msaaReadFbo);
	}
	destroy() {
		this._shader?.destroy();
		this._shader = null;
		this._scratchRt?.destroy();
		this._scratchRt = null;
		this._scratchTex?.destroy();
		this._scratchTex = null;
		this._sourceId = null;
	}
};

var FrameQueriesInfo = class {
	renderVersion;
	queries = [];
	destroy(gl) {
		this.queries.forEach((query) => gl.deleteQuery(query));
		this.queries = null;
	}
};
var WebglGpuProfiler = class extends GpuProfiler {
	device;
	freeQueries = [];
	frameQueries = [];
	previousFrameQueries = [];
	timings = [];
	constructor(device) {
		super();
		this.device = device;
		this.ext = device.extDisjointTimerQuery;
	}
	destroy() {
		this.freeQueries.forEach((query) => this.device.gl.deleteQuery(query));
		this.frameQueries.forEach((query) => this.device.gl.deleteQuery(query));
		this.previousFrameQueries.forEach((frameQueriesInfo) => frameQueriesInfo.destroy(this.device.gl));
		this.freeQueries = null;
		this.frameQueries = null;
		this.previousFrameQueries = null;
	}
	loseContext() {
		super.loseContext();
		this.freeQueries = [];
		this.frameQueries = [];
		this.previousFrameQueries = [];
	}
	restoreContext() {
		this.ext = this.device.extDisjointTimerQuery;
	}
	getQuery() {
		return this.freeQueries.pop() ?? this.device.gl.createQuery();
	}
	start(name) {
		if (this.ext) {
			const slot = this.getSlot(name);
			const query = this.getQuery();
			this.frameQueries[slot] = query;
			this.device.gl.beginQuery(this.ext.TIME_ELAPSED_EXT, query);
			return slot;
		}
		return void 0;
	}
	end(slot) {
		if (slot !== void 0) {
			this.device.gl.endQuery(this.ext.TIME_ELAPSED_EXT);
		}
	}
	frameStart() {
		this.processEnableRequest();
		if (this._enabled) {
			this.frameGPUMarkerSlot = this.start("GpuFrame");
		}
	}
	frameEnd() {
		if (this._enabled) {
			this.end(this.frameGPUMarkerSlot);
		}
	}
	request() {
		if (this._enabled) {
			const ext = this.ext;
			const gl = this.device.gl;
			const renderVersion = this.device.renderVersion;
			const frameQueries = this.frameQueries;
			if (frameQueries.length > 0) {
				this.frameQueries = [];
				const frameQueriesInfo = new FrameQueriesInfo();
				frameQueriesInfo.queries = frameQueries;
				frameQueriesInfo.renderVersion = renderVersion;
				this.previousFrameQueries.push(frameQueriesInfo);
			}
			if (this.previousFrameQueries.length > 0) {
				const previousQueriesInfo = this.previousFrameQueries[0];
				const previousQueries = previousQueriesInfo.queries;
				const lastQuery = previousQueries[previousQueries.length - 1];
				const available = gl.getQueryParameter(lastQuery, gl.QUERY_RESULT_AVAILABLE);
				const disjoint = gl.getParameter(ext.GPU_DISJOINT_EXT);
				if (available && !disjoint) {
					this.previousFrameQueries.shift();
					const timings = this.timings;
					timings.length = 0;
					for (let i2 = 0; i2 < previousQueries.length; i2++) {
						const query = previousQueries[i2];
						const duration = gl.getQueryParameter(query, gl.QUERY_RESULT);
						timings[i2] = duration * 1e-6;
						this.freeQueries.push(query);
					}
					this.report(previousQueriesInfo.renderVersion, timings);
				}
				if (disjoint) {
					this.previousFrameQueries.forEach((frameQueriesInfo) => {
						this.report(frameQueriesInfo.renderVersion, null);
						frameQueriesInfo.destroy(gl);
					});
					this.previousFrameQueries.length = 0;
				}
			}
			super.request(renderVersion);
		}
	}
};

var getPixelFormatChannelsForRgbaReadback = (format) => {
	switch (format) {
		case PIXELFORMAT_R8:
			return 1;
		case PIXELFORMAT_RG8:
			return 2;
		default:
			return 0;
	}
};
var invalidateAttachments = [];
var WebglGraphicsDevice = class extends GraphicsDevice {
	gl;
	_defaultFramebuffer = null;
	_defaultFramebufferChanged = false;
	_xrMsaaCopy = null;
	constructor(canvas, options2 = {}) {
		super(canvas, options2);
		options2 = this.initOptions;
		this.initTextureUnits();
		this.contextLost = false;
		this._contextLostHandler = (event) => {
			event.preventDefault();
			this.loseContext();
		};
		this._contextRestoredHandler = () => {
			this.restoreContext();
		};
		const ua2 = typeof navigator !== "undefined" && navigator.userAgent;
		this.forceDisableMultisampling = ua2 && ua2.includes("AppleWebKit") && (ua2.includes("15.4") || ua2.includes("15_4"));
		if (this.forceDisableMultisampling) {
			options2.antialias = false;
		}
		if (platform.browserName === "firefox") {
			const ua3 = typeof navigator !== "undefined" ? navigator.userAgent : "";
			const match = ua3.match(/Firefox\/(\d+(\.\d+)*)/);
			const firefoxVersion = match ? match[1] : null;
			if (firefoxVersion) {
				const version2 = parseFloat(firefoxVersion);
				const disableAntialias = platform.name === "windows" && (version2 >= 120 || version2 === 115) || platform.name === "android" && version2 >= 132;
				if (disableAntialias) {
					options2.antialias = false;
				}
			}
		}
		this.backBufferAntialias = options2.antialias ?? false;
		options2.antialias = false;
		const gl = options2.gl ?? canvas.getContext("webgl2", options2);
		if (!gl) {
			throw new Error("WebGL not supported");
		}
		this.gl = gl;
		this.isWebGL2 = true;
		this._deviceType = DEVICETYPE_WEBGL2;
		this.updateBackbufferFormat(null);
		const isChrome = platform.browserName === "chrome";
		const isSafari = platform.browserName === "safari";
		const isMac = platform.browser && navigator.appVersion.indexOf("Mac") !== -1;
		this._tempEnableSafariTextureUnitWorkaround = isSafari;
		this._tempMacChromeBlitFramebufferWorkaround = isMac && isChrome && !options2.alpha;
		canvas.addEventListener("webglcontextlost", this._contextLostHandler, false);
		canvas.addEventListener("webglcontextrestored", this._contextRestoredHandler, false);
		this.initializeExtensions();
		this.initializeCapabilities();
		this.initializeRenderState();
		this.initializeContextCaches();
		this.createBackbuffer(null);
		this.dynamicBuffers = new WebglDynamicBuffers(this);
		this.supportsImageBitmap = !isSafari && typeof ImageBitmap !== "undefined";
		this._samplerTypes = /* @__PURE__ */ new Set([
			gl.SAMPLER_2D,
			gl.SAMPLER_CUBE,
			gl.UNSIGNED_INT_SAMPLER_2D,
			gl.INT_SAMPLER_2D,
			gl.SAMPLER_2D_SHADOW,
			gl.SAMPLER_CUBE_SHADOW,
			gl.SAMPLER_3D,
			gl.INT_SAMPLER_3D,
			gl.UNSIGNED_INT_SAMPLER_3D,
			gl.SAMPLER_2D_ARRAY,
			gl.INT_SAMPLER_2D_ARRAY,
			gl.UNSIGNED_INT_SAMPLER_2D_ARRAY
		]);
		this.glAddress = [
			gl.REPEAT,
			gl.CLAMP_TO_EDGE,
			gl.MIRRORED_REPEAT
		];
		this.glBlendEquation = [
			gl.FUNC_ADD,
			gl.FUNC_SUBTRACT,
			gl.FUNC_REVERSE_SUBTRACT,
			gl.MIN,
			gl.MAX
		];
		this.glBlendFunctionColor = [
			gl.ZERO,
			gl.ONE,
			gl.SRC_COLOR,
			gl.ONE_MINUS_SRC_COLOR,
			gl.DST_COLOR,
			gl.ONE_MINUS_DST_COLOR,
			gl.SRC_ALPHA,
			gl.SRC_ALPHA_SATURATE,
			gl.ONE_MINUS_SRC_ALPHA,
			gl.DST_ALPHA,
			gl.ONE_MINUS_DST_ALPHA,
			gl.CONSTANT_COLOR,
			gl.ONE_MINUS_CONSTANT_COLOR
		];
		this.glBlendFunctionAlpha = [
			gl.ZERO,
			gl.ONE,
			gl.SRC_COLOR,
			gl.ONE_MINUS_SRC_COLOR,
			gl.DST_COLOR,
			gl.ONE_MINUS_DST_COLOR,
			gl.SRC_ALPHA,
			gl.SRC_ALPHA_SATURATE,
			gl.ONE_MINUS_SRC_ALPHA,
			gl.DST_ALPHA,
			gl.ONE_MINUS_DST_ALPHA,
			gl.CONSTANT_ALPHA,
			gl.ONE_MINUS_CONSTANT_ALPHA
		];
		this.glComparison = [
			gl.NEVER,
			gl.LESS,
			gl.EQUAL,
			gl.LEQUAL,
			gl.GREATER,
			gl.NOTEQUAL,
			gl.GEQUAL,
			gl.ALWAYS
		];
		this.glStencilOp = [
			gl.KEEP,
			gl.ZERO,
			gl.REPLACE,
			gl.INCR,
			gl.INCR_WRAP,
			gl.DECR,
			gl.DECR_WRAP,
			gl.INVERT
		];
		this.glClearFlag = [
			0,
			gl.COLOR_BUFFER_BIT,
			gl.DEPTH_BUFFER_BIT,
			gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT,
			gl.STENCIL_BUFFER_BIT,
			gl.STENCIL_BUFFER_BIT | gl.COLOR_BUFFER_BIT,
			gl.STENCIL_BUFFER_BIT | gl.DEPTH_BUFFER_BIT,
			gl.STENCIL_BUFFER_BIT | gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT
		];
		this.glCull = [
			0,
			gl.BACK,
			gl.FRONT,
			gl.FRONT_AND_BACK
		];
		this.glFrontFace = [
			gl.CCW,
			gl.CW
		];
		this.glFilter = [
			gl.NEAREST,
			gl.LINEAR,
			gl.NEAREST_MIPMAP_NEAREST,
			gl.NEAREST_MIPMAP_LINEAR,
			gl.LINEAR_MIPMAP_NEAREST,
			gl.LINEAR_MIPMAP_LINEAR
		];
		this.glPrimitive = [
			gl.POINTS,
			gl.LINES,
			gl.LINE_LOOP,
			gl.LINE_STRIP,
			gl.TRIANGLES,
			gl.TRIANGLE_STRIP,
			gl.TRIANGLE_FAN
		];
		this.glType = [
			gl.BYTE,
			gl.UNSIGNED_BYTE,
			gl.SHORT,
			gl.UNSIGNED_SHORT,
			gl.INT,
			gl.UNSIGNED_INT,
			gl.FLOAT,
			gl.HALF_FLOAT
		];
		this.pcUniformType = {};
		this.pcUniformType[gl.BOOL] = UNIFORMTYPE_BOOL;
		this.pcUniformType[gl.INT] = UNIFORMTYPE_INT;
		this.pcUniformType[gl.FLOAT] = UNIFORMTYPE_FLOAT;
		this.pcUniformType[gl.FLOAT_VEC2] = UNIFORMTYPE_VEC2;
		this.pcUniformType[gl.FLOAT_VEC3] = UNIFORMTYPE_VEC3;
		this.pcUniformType[gl.FLOAT_VEC4] = UNIFORMTYPE_VEC4;
		this.pcUniformType[gl.INT_VEC2] = UNIFORMTYPE_IVEC2;
		this.pcUniformType[gl.INT_VEC3] = UNIFORMTYPE_IVEC3;
		this.pcUniformType[gl.INT_VEC4] = UNIFORMTYPE_IVEC4;
		this.pcUniformType[gl.BOOL_VEC2] = UNIFORMTYPE_BVEC2;
		this.pcUniformType[gl.BOOL_VEC3] = UNIFORMTYPE_BVEC3;
		this.pcUniformType[gl.BOOL_VEC4] = UNIFORMTYPE_BVEC4;
		this.pcUniformType[gl.FLOAT_MAT2] = UNIFORMTYPE_MAT2;
		this.pcUniformType[gl.FLOAT_MAT3] = UNIFORMTYPE_MAT3;
		this.pcUniformType[gl.FLOAT_MAT4] = UNIFORMTYPE_MAT4;
		this.pcUniformType[gl.SAMPLER_2D] = UNIFORMTYPE_TEXTURE2D;
		this.pcUniformType[gl.SAMPLER_CUBE] = UNIFORMTYPE_TEXTURECUBE;
		this.pcUniformType[gl.UNSIGNED_INT] = UNIFORMTYPE_UINT;
		this.pcUniformType[gl.UNSIGNED_INT_VEC2] = UNIFORMTYPE_UVEC2;
		this.pcUniformType[gl.UNSIGNED_INT_VEC3] = UNIFORMTYPE_UVEC3;
		this.pcUniformType[gl.UNSIGNED_INT_VEC4] = UNIFORMTYPE_UVEC4;
		this.pcUniformType[gl.SAMPLER_2D_SHADOW] = UNIFORMTYPE_TEXTURE2D_SHADOW;
		this.pcUniformType[gl.SAMPLER_CUBE_SHADOW] = UNIFORMTYPE_TEXTURECUBE_SHADOW;
		this.pcUniformType[gl.SAMPLER_2D_ARRAY] = UNIFORMTYPE_TEXTURE2D_ARRAY;
		this.pcUniformType[gl.SAMPLER_3D] = UNIFORMTYPE_TEXTURE3D;
		this.pcUniformType[gl.INT_SAMPLER_2D] = UNIFORMTYPE_ITEXTURE2D;
		this.pcUniformType[gl.UNSIGNED_INT_SAMPLER_2D] = UNIFORMTYPE_UTEXTURE2D;
		this.pcUniformType[gl.INT_SAMPLER_CUBE] = UNIFORMTYPE_ITEXTURECUBE;
		this.pcUniformType[gl.UNSIGNED_INT_SAMPLER_2D] = UNIFORMTYPE_UTEXTURECUBE;
		this.pcUniformType[gl.INT_SAMPLER_3D] = UNIFORMTYPE_ITEXTURE3D;
		this.pcUniformType[gl.UNSIGNED_INT_SAMPLER_3D] = UNIFORMTYPE_UTEXTURE3D;
		this.pcUniformType[gl.INT_SAMPLER_2D_ARRAY] = UNIFORMTYPE_ITEXTURE2D_ARRAY;
		this.pcUniformType[gl.UNSIGNED_INT_SAMPLER_2D_ARRAY] = UNIFORMTYPE_UTEXTURE2D_ARRAY;
		this.targetToSlot = {};
		this.targetToSlot[gl.TEXTURE_2D] = 0;
		this.targetToSlot[gl.TEXTURE_CUBE_MAP] = 1;
		this.targetToSlot[gl.TEXTURE_3D] = 2;
		let scopeX, scopeY, scopeZ, scopeW;
		let uniformValue;
		this.commitFunction = [];
		this.commitFunction[UNIFORMTYPE_BOOL] = function(uniform, value) {
			if (uniform.value !== value) {
				gl.uniform1i(uniform.locationId, value);
				uniform.value = value;
			}
		};
		this.commitFunction[UNIFORMTYPE_INT] = this.commitFunction[UNIFORMTYPE_BOOL];
		this.commitFunction[UNIFORMTYPE_FLOAT] = function(uniform, value) {
			if (uniform.value !== value) {
				gl.uniform1f(uniform.locationId, value);
				uniform.value = value;
			}
		};
		this.commitFunction[UNIFORMTYPE_VEC2] = function(uniform, value) {
			uniformValue = uniform.value;
			scopeX = value[0];
			scopeY = value[1];
			if (uniformValue[0] !== scopeX || uniformValue[1] !== scopeY) {
				gl.uniform2fv(uniform.locationId, value);
				uniformValue[0] = scopeX;
				uniformValue[1] = scopeY;
			}
		};
		this.commitFunction[UNIFORMTYPE_VEC3] = function(uniform, value) {
			uniformValue = uniform.value;
			scopeX = value[0];
			scopeY = value[1];
			scopeZ = value[2];
			if (uniformValue[0] !== scopeX || uniformValue[1] !== scopeY || uniformValue[2] !== scopeZ) {
				gl.uniform3fv(uniform.locationId, value);
				uniformValue[0] = scopeX;
				uniformValue[1] = scopeY;
				uniformValue[2] = scopeZ;
			}
		};
		this.commitFunction[UNIFORMTYPE_VEC4] = function(uniform, value) {
			uniformValue = uniform.value;
			scopeX = value[0];
			scopeY = value[1];
			scopeZ = value[2];
			scopeW = value[3];
			if (uniformValue[0] !== scopeX || uniformValue[1] !== scopeY || uniformValue[2] !== scopeZ || uniformValue[3] !== scopeW) {
				gl.uniform4fv(uniform.locationId, value);
				uniformValue[0] = scopeX;
				uniformValue[1] = scopeY;
				uniformValue[2] = scopeZ;
				uniformValue[3] = scopeW;
			}
		};
		this.commitFunction[UNIFORMTYPE_IVEC2] = function(uniform, value) {
			uniformValue = uniform.value;
			scopeX = value[0];
			scopeY = value[1];
			if (uniformValue[0] !== scopeX || uniformValue[1] !== scopeY) {
				gl.uniform2iv(uniform.locationId, value);
				uniformValue[0] = scopeX;
				uniformValue[1] = scopeY;
			}
		};
		this.commitFunction[UNIFORMTYPE_BVEC2] = this.commitFunction[UNIFORMTYPE_IVEC2];
		this.commitFunction[UNIFORMTYPE_IVEC3] = function(uniform, value) {
			uniformValue = uniform.value;
			scopeX = value[0];
			scopeY = value[1];
			scopeZ = value[2];
			if (uniformValue[0] !== scopeX || uniformValue[1] !== scopeY || uniformValue[2] !== scopeZ) {
				gl.uniform3iv(uniform.locationId, value);
				uniformValue[0] = scopeX;
				uniformValue[1] = scopeY;
				uniformValue[2] = scopeZ;
			}
		};
		this.commitFunction[UNIFORMTYPE_BVEC3] = this.commitFunction[UNIFORMTYPE_IVEC3];
		this.commitFunction[UNIFORMTYPE_IVEC4] = function(uniform, value) {
			uniformValue = uniform.value;
			scopeX = value[0];
			scopeY = value[1];
			scopeZ = value[2];
			scopeW = value[3];
			if (uniformValue[0] !== scopeX || uniformValue[1] !== scopeY || uniformValue[2] !== scopeZ || uniformValue[3] !== scopeW) {
				gl.uniform4iv(uniform.locationId, value);
				uniformValue[0] = scopeX;
				uniformValue[1] = scopeY;
				uniformValue[2] = scopeZ;
				uniformValue[3] = scopeW;
			}
		};
		this.commitFunction[UNIFORMTYPE_BVEC4] = this.commitFunction[UNIFORMTYPE_IVEC4];
		this.commitFunction[UNIFORMTYPE_MAT2] = function(uniform, value) {
			gl.uniformMatrix2fv(uniform.locationId, false, value);
		};
		this.commitFunction[UNIFORMTYPE_MAT3] = function(uniform, value) {
			gl.uniformMatrix3fv(uniform.locationId, false, value);
		};
		this.commitFunction[UNIFORMTYPE_MAT4] = function(uniform, value) {
			gl.uniformMatrix4fv(uniform.locationId, false, value);
		};
		this.commitFunction[UNIFORMTYPE_FLOATARRAY] = function(uniform, value) {
			gl.uniform1fv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_VEC2ARRAY] = function(uniform, value) {
			gl.uniform2fv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_VEC3ARRAY] = function(uniform, value) {
			gl.uniform3fv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_VEC4ARRAY] = function(uniform, value) {
			gl.uniform4fv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_UINT] = function(uniform, value) {
			if (uniform.value !== value) {
				gl.uniform1ui(uniform.locationId, value);
				uniform.value = value;
			}
		};
		this.commitFunction[UNIFORMTYPE_UVEC2] = function(uniform, value) {
			uniformValue = uniform.value;
			scopeX = value[0];
			scopeY = value[1];
			if (uniformValue[0] !== scopeX || uniformValue[1] !== scopeY) {
				gl.uniform2uiv(uniform.locationId, value);
				uniformValue[0] = scopeX;
				uniformValue[1] = scopeY;
			}
		};
		this.commitFunction[UNIFORMTYPE_UVEC3] = function(uniform, value) {
			uniformValue = uniform.value;
			scopeX = value[0];
			scopeY = value[1];
			scopeZ = value[2];
			if (uniformValue[0] !== scopeX || uniformValue[1] !== scopeY || uniformValue[2] !== scopeZ) {
				gl.uniform3uiv(uniform.locationId, value);
				uniformValue[0] = scopeX;
				uniformValue[1] = scopeY;
				uniformValue[2] = scopeZ;
			}
		};
		this.commitFunction[UNIFORMTYPE_UVEC4] = function(uniform, value) {
			uniformValue = uniform.value;
			scopeX = value[0];
			scopeY = value[1];
			scopeZ = value[2];
			scopeW = value[3];
			if (uniformValue[0] !== scopeX || uniformValue[1] !== scopeY || uniformValue[2] !== scopeZ || uniformValue[3] !== scopeW) {
				gl.uniform4uiv(uniform.locationId, value);
				uniformValue[0] = scopeX;
				uniformValue[1] = scopeY;
				uniformValue[2] = scopeZ;
				uniformValue[3] = scopeW;
			}
		};
		this.commitFunction[UNIFORMTYPE_INTARRAY] = function(uniform, value) {
			gl.uniform1iv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_UINTARRAY] = function(uniform, value) {
			gl.uniform1uiv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_BOOLARRAY] = this.commitFunction[UNIFORMTYPE_INTARRAY];
		this.commitFunction[UNIFORMTYPE_IVEC2ARRAY] = function(uniform, value) {
			gl.uniform2iv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_UVEC2ARRAY] = function(uniform, value) {
			gl.uniform2uiv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_BVEC2ARRAY] = this.commitFunction[UNIFORMTYPE_IVEC2ARRAY];
		this.commitFunction[UNIFORMTYPE_IVEC3ARRAY] = function(uniform, value) {
			gl.uniform3iv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_UVEC3ARRAY] = function(uniform, value) {
			gl.uniform3uiv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_BVEC3ARRAY] = this.commitFunction[UNIFORMTYPE_IVEC3ARRAY];
		this.commitFunction[UNIFORMTYPE_IVEC4ARRAY] = function(uniform, value) {
			gl.uniform4iv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_UVEC4ARRAY] = function(uniform, value) {
			gl.uniform4uiv(uniform.locationId, value);
		};
		this.commitFunction[UNIFORMTYPE_BVEC4ARRAY] = this.commitFunction[UNIFORMTYPE_IVEC4ARRAY];
		this.commitFunction[UNIFORMTYPE_MAT4ARRAY] = function(uniform, value) {
			gl.uniformMatrix4fv(uniform.locationId, false, value);
		};
		this.constantTexSource = this.scope.resolve("source");
		this.postInit();
	}
	postInit() {
		super.postInit();
		this.gpuProfiler = new WebglGpuProfiler(this);
	}
	destroy() {
		super.destroy();
		const gl = this.gl;
		if (this.feedback) {
			gl.deleteTransformFeedback(this.feedback);
		}
		this.clearVertexArrayObjectCache();
		this._xrMsaaCopy?.destroy();
		this._xrMsaaCopy = null;
		this.canvas.removeEventListener("webglcontextlost", this._contextLostHandler, false);
		this.canvas.removeEventListener("webglcontextrestored", this._contextRestoredHandler, false);
		this._contextLostHandler = null;
		this._contextRestoredHandler = null;
		this.gl = null;
		super.postDestroy();
	}
	createBackbuffer(frameBuffer) {
		this.supportsStencil = this.initOptions.stencil;
		this.backBuffer = new RenderTarget({
			name: "WebglFramebuffer",
			graphicsDevice: this,
			depth: this.initOptions.depth,
			stencil: this.supportsStencil,
			samples: this.samples
		});
		this.backBuffer.impl.suppliedColorFramebuffer = frameBuffer;
	}
	// Update framebuffer format based on the current framebuffer, as this is use to create matching multi-sampled framebuffer
	updateBackbufferFormat(framebuffer) {
		const gl = this.gl;
		gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
		const alphaBits = this.gl.getParameter(this.gl.ALPHA_BITS);
		this.backBufferFormat = alphaBits ? PIXELFORMAT_RGBA8 : PIXELFORMAT_RGB8;
	}
	updateBackbuffer() {
		const resolutionChanged = this.canvas.width !== this.backBufferSize.x || this.canvas.height !== this.backBufferSize.y;
		if (this._defaultFramebufferChanged || resolutionChanged) {
			if (this._defaultFramebufferChanged) {
				this.updateBackbufferFormat(this._defaultFramebuffer);
			}
			this._defaultFramebufferChanged = false;
			this.backBufferSize.set(this.canvas.width, this.canvas.height);
			this.backBuffer.destroy();
			this.createBackbuffer(this._defaultFramebuffer);
		}
	}
	// provide webgl implementation for the vertex buffer
	createVertexBufferImpl(vertexBuffer, format) {
		return new WebglVertexBuffer();
	}
	// provide webgl implementation for the index buffer
	createIndexBufferImpl(indexBuffer) {
		return new WebglIndexBuffer(indexBuffer);
	}
	createShaderImpl(shader) {
		return new WebglShader(shader);
	}
	createUniformBufferImpl(uniformBuffer) {
		return new WebglUniformBuffer();
	}
	createBindGroupFormatImpl(bindGroupFormat) {
		return new WebglBindGroupFormat();
	}
	createBindGroupImpl(bindGroup) {
		return new WebglBindGroup();
	}
	setBindGroup(index, bindGroup, offsets) {
		const gl = this.gl;
		const buffers = bindGroup.impl.buffers;
		for (let i2 = 0; i2 < buffers.length; i2++) {
			gl.bindBufferBase(gl.UNIFORM_BUFFER, index, buffers[i2].bufferId);
		}
	}
	createDrawCommandImpl(drawCommands) {
		return new WebglDrawCommands(drawCommands.indexSizeBytes);
	}
	createTextureImpl(texture) {
		this.textures.add(texture);
		return new WebglTexture(texture);
	}
	createXrBridgeImpl(xrBridge) {
		return new WebglXrBridge(xrBridge);
	}
	createRenderTargetImpl(renderTarget) {
		return new WebglRenderTarget();
	}
	createUploadStreamImpl(uploadStream) {
		return new WebglUploadStream(uploadStream);
	}
	getPrecision() {
		const gl = this.gl;
		let precision = "highp";
		if (gl.getShaderPrecisionFormat) {
			const vertexShaderPrecisionHighpFloat = gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT);
			const vertexShaderPrecisionMediumpFloat = gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT);
			const fragmentShaderPrecisionHighpFloat = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
			const fragmentShaderPrecisionMediumpFloat = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT);
			if (vertexShaderPrecisionHighpFloat && vertexShaderPrecisionMediumpFloat && fragmentShaderPrecisionHighpFloat && fragmentShaderPrecisionMediumpFloat) {
				const highpAvailable = vertexShaderPrecisionHighpFloat.precision > 0 && fragmentShaderPrecisionHighpFloat.precision > 0;
				const mediumpAvailable = vertexShaderPrecisionMediumpFloat.precision > 0 && fragmentShaderPrecisionMediumpFloat.precision > 0;
				if (!highpAvailable) {
					if (mediumpAvailable) {
						precision = "mediump";
					} else {
						precision = "lowp";
					}
				}
			}
		}
		return precision;
	}
	getExtension() {
		for (let i2 = 0; i2 < arguments.length; i2++) {
			if (this.supportedExtensions.indexOf(arguments[i2]) !== -1) {
				return this.gl.getExtension(arguments[i2]);
			}
		}
		return null;
	}
	get extDisjointTimerQuery() {
		if (!this._extDisjointTimerQuery) {
			this._extDisjointTimerQuery = this.getExtension("EXT_disjoint_timer_query_webgl2", "EXT_disjoint_timer_query");
		}
		return this._extDisjointTimerQuery;
	}
	initializeExtensions() {
		const gl = this.gl;
		this.supportedExtensions = gl.getSupportedExtensions() ?? [];
		this._extDisjointTimerQuery = null;
		this.textureRG11B10Renderable = true;
		this.extColorBufferFloat = this.getExtension("EXT_color_buffer_float");
		this.textureFloatRenderable = !!this.extColorBufferFloat;
		this.extColorBufferHalfFloat = this.getExtension("EXT_color_buffer_half_float");
		this.textureHalfFloatRenderable = !!this.extColorBufferHalfFloat || !!this.extColorBufferFloat;
		this.extDebugRendererInfo = this.getExtension("WEBGL_debug_renderer_info");
		this.extTextureFloatLinear = this.getExtension("OES_texture_float_linear");
		this.textureFloatFilterable = !!this.extTextureFloatLinear;
		this.extFloatBlend = this.getExtension("EXT_float_blend");
		this.extTextureFilterAnisotropic = this.getExtension("EXT_texture_filter_anisotropic", "WEBKIT_EXT_texture_filter_anisotropic");
		this.extParallelShaderCompile = this.getExtension("KHR_parallel_shader_compile");
		this.extMultiDraw = this.getExtension("WEBGL_multi_draw");
		this.supportsMultiDraw = !!this.extMultiDraw;
		this.extCompressedTextureETC1 = this.getExtension("WEBGL_compressed_texture_etc1");
		this.extCompressedTextureETC = this.getExtension("WEBGL_compressed_texture_etc");
		this.extCompressedTexturePVRTC = this.getExtension("WEBGL_compressed_texture_pvrtc", "WEBKIT_WEBGL_compressed_texture_pvrtc");
		this.extCompressedTextureS3TC = this.getExtension("WEBGL_compressed_texture_s3tc", "WEBKIT_WEBGL_compressed_texture_s3tc");
		this.extCompressedTextureS3TC_SRGB = this.getExtension("WEBGL_compressed_texture_s3tc_srgb");
		this.extCompressedTextureATC = this.getExtension("WEBGL_compressed_texture_atc");
		this.extCompressedTextureASTC = this.getExtension("WEBGL_compressed_texture_astc");
		this.extTextureCompressionBPTC = this.getExtension("EXT_texture_compression_bptc");
		this.supportsHtmlTextures = typeof gl.texElementImage2D === "function";
	}
	initializeCapabilities() {
		const gl = this.gl;
		let ext;
		const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
		this.maxPrecision = this.precision = this.getPrecision();
		const contextAttribs = gl.getContextAttributes();
		this.supportsMsaa = contextAttribs?.antialias ?? false;
		this.supportsStencil = contextAttribs?.stencil ?? false;
		this.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
		this.maxCubeMapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
		this.maxRenderBufferSize = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE);
		this.maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
		this.maxCombinedTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
		this.maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
		this.vertexUniformsCount = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
		this.fragmentUniformsCount = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
		this.maxColorAttachments = gl.getParameter(gl.MAX_COLOR_ATTACHMENTS);
		this.maxVolumeSize = gl.getParameter(gl.MAX_3D_TEXTURE_SIZE);
		ext = this.extDebugRendererInfo;
		this.unmaskedRenderer = ext ? gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) : "";
		this.unmaskedVendor = ext ? gl.getParameter(ext.UNMASKED_VENDOR_WEBGL) : "";
		const maliRendererRegex = /\bMali-G52+/;
		const samsungModelRegex = /SM-[a-zA-Z0-9]+/;
		this.supportsGpuParticles = !(this.unmaskedVendor === "ARM" && userAgent.match(samsungModelRegex)) && !this.unmaskedRenderer.match(maliRendererRegex);
		ext = this.extTextureFilterAnisotropic;
		this.maxAnisotropy = ext ? gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 1;
		const antialiasSupported = !this.forceDisableMultisampling;
		this.maxSamples = antialiasSupported ? gl.getParameter(gl.MAX_SAMPLES) : 1;
		this.maxSamples = Math.min(this.maxSamples, 4);
		this.samples = antialiasSupported && this.backBufferAntialias ? this.maxSamples : 1;
		this.supportsAreaLights = !platform.android;
		if (this.maxTextures <= 8) {
			this.supportsAreaLights = false;
		}
		this.initCapsDefines();
	}
	initializeRenderState() {
		super.initializeRenderState();
		const gl = this.gl;
		gl.disable(gl.BLEND);
		gl.blendFunc(gl.ONE, gl.ZERO);
		gl.blendEquation(gl.FUNC_ADD);
		gl.colorMask(true, true, true, true);
		gl.blendColor(0, 0, 0, 0);
		gl.enable(gl.CULL_FACE);
		this.cullFace = gl.BACK;
		gl.cullFace(gl.BACK);
		gl.enable(gl.DEPTH_TEST);
		gl.depthFunc(gl.LEQUAL);
		gl.depthMask(true);
		this.stencil = false;
		gl.disable(gl.STENCIL_TEST);
		this.stencilFuncFront = this.stencilFuncBack = FUNC_ALWAYS;
		this.stencilRefFront = this.stencilRefBack = 0;
		this.stencilMaskFront = this.stencilMaskBack = 255;
		gl.stencilFunc(gl.ALWAYS, 0, 255);
		this.stencilFailFront = this.stencilFailBack = STENCILOP_KEEP;
		this.stencilZfailFront = this.stencilZfailBack = STENCILOP_KEEP;
		this.stencilZpassFront = this.stencilZpassBack = STENCILOP_KEEP;
		this.stencilWriteMaskFront = 255;
		this.stencilWriteMaskBack = 255;
		gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
		gl.stencilMask(255);
		this.alphaToCoverage = false;
		this.raster = true;
		gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
		gl.disable(gl.RASTERIZER_DISCARD);
		this.depthBiasEnabled = false;
		gl.disable(gl.POLYGON_OFFSET_FILL);
		this.clearDepth = 1;
		gl.clearDepth(1);
		this.clearColor = new Color(0, 0, 0, 0);
		gl.clearColor(0, 0, 0, 0);
		this.clearStencil = 0;
		gl.clearStencil(0);
		gl.hint(gl.FRAGMENT_SHADER_DERIVATIVE_HINT, gl.NICEST);
		gl.enable(gl.SCISSOR_TEST);
		this.textureUnit = 0;
		gl.activeTexture(gl.TEXTURE0);
		gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
		this.unpackFlipY = false;
		gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
		this.unpackPremultiplyAlpha = false;
		gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
		this.unpackAlignment = 1;
		gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
	}
	initTextureUnits(count = 16) {
		this.textureUnits = [];
		for (let i2 = 0; i2 < count; i2++) {
			this.textureUnits.push([null, null, null]);
		}
	}
	initializeContextCaches() {
		super.initializeContextCaches();
		this._vaoMap = /* @__PURE__ */ new Map();
		this.boundVao = null;
		this.activeFramebuffer = null;
		this.feedback = null;
		this.transformFeedbackBuffer = null;
		this.textureUnit = 0;
		this.initTextureUnits(this.maxCombinedTextures);
	}
	loseContext() {
		super.loseContext();
		for (const shader of this.shaders) {
			shader.loseContext();
		}
		this.dynamicBuffers.loseContext();
		this.fire("devicelost");
	}
	restoreContext() {
		this.initializeExtensions();
		this.initializeCapabilities();
		super.restoreContext();
		for (const shader of this.shaders) {
			shader.restoreContext();
		}
		this.fire("devicerestored");
	}
	setViewport(x3, y2, w, h2) {
		if (this.vx !== x3 || this.vy !== y2 || this.vw !== w || this.vh !== h2) {
			this.gl.viewport(x3, y2, w, h2);
			this.vx = x3;
			this.vy = y2;
			this.vw = w;
			this.vh = h2;
		}
	}
	setScissor(x3, y2, w, h2) {
		if (this.sx !== x3 || this.sy !== y2 || this.sw !== w || this.sh !== h2) {
			this.gl.scissor(x3, y2, w, h2);
			this.sx = x3;
			this.sy = y2;
			this.sw = w;
			this.sh = h2;
		}
	}
	setFramebuffer(fb) {
		if (this.activeFramebuffer !== fb) {
			const gl = this.gl;
			gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
			this.activeFramebuffer = fb;
		}
	}
	resolveMsaaColorToXrFramebufferViaQuads(msaaReadFbo, xrDrawFbo, width, height) {
		this._xrMsaaCopy ?? (this._xrMsaaCopy = new WebglXrMsaaCopy(this));
		this._xrMsaaCopy.copy(msaaReadFbo, xrDrawFbo, width, height);
	}
	copyRenderTarget(source, dest, color3, depth) {
		const gl = this.gl;
		if (source === this.backBuffer) {
			source = null;
		}
		if (color3) {
			if (!dest) {
				if (!source._colorBuffer) {
					return false;
				}
			} else if (source) {
				if (!source._colorBuffer || !dest._colorBuffer) {
					return false;
				}
				if (source._colorBuffer._format !== dest._colorBuffer._format) {
					return false;
				}
			}
		}
		if (depth && source) {
			if (!source._depth) {
				if (!source._depthBuffer || !dest._depthBuffer) {
					return false;
				}
				if (source._depthBuffer._format !== dest._depthBuffer._format) {
					return false;
				}
			}
		}
		const prevRt = this.renderTarget;
		this.renderTarget = dest;
		this.updateBegin();
		const src = source ? source.impl._glFrameBuffer : this.backBuffer?.impl._glFrameBuffer;
		const dst = dest ? dest.impl._glFrameBuffer : this.backBuffer?.impl._glFrameBuffer;
		gl.bindFramebuffer(gl.READ_FRAMEBUFFER, src);
		gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, dst);
		const w = source ? source.width : dest ? dest.width : this.width;
		const h2 = source ? source.height : dest ? dest.height : this.height;
		gl.blitFramebuffer(
			0,
			0,
			w,
			h2,
			0,
			0,
			w,
			h2,
			(color3 ? gl.COLOR_BUFFER_BIT : 0) | (depth ? gl.DEPTH_BUFFER_BIT : 0),
			gl.NEAREST
		);
		this.renderTarget = prevRt;
		gl.bindFramebuffer(gl.FRAMEBUFFER, prevRt ? prevRt.impl._glFrameBuffer : null);
		return true;
	}
	copyTextureToTexture(source, dest, options2 = {}) {
		const gl = this.gl;
		const sourceMipLevel = options2.sourceMipLevel ?? 0;
		const destMipLevel = options2.destMipLevel ?? 0;
		const face = options2.face ?? 0;
		const sx = options2.sourceX ?? 0;
		const sy = options2.sourceY ?? 0;
		const dx = options2.destX ?? 0;
		const dy = options2.destY ?? 0;
		const w = options2.width ?? Math.max(1, source.width >> sourceMipLevel);
		const h2 = options2.height ?? Math.max(1, source.height >> sourceMipLevel);
		const sourceRenderTarget = options2.sourceRenderTarget ?? new RenderTarget({
			name: "TextureCopySource",
			colorBuffer: source,
			depth: false,
			face,
			mipLevel: sourceMipLevel
		});
		const prevRt = this.renderTarget;
		this.setRenderTarget(sourceRenderTarget);
		this.initRenderTarget(sourceRenderTarget);
		this.setFramebuffer(sourceRenderTarget.impl._glFrameBuffer);
		this.setTexture(dest, 0);
		const destTarget = dest.cubemap ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + face : gl.TEXTURE_2D;
		gl.copyTexSubImage2D(destTarget, destMipLevel, dx, dy, sx, sy, w, h2);
		if (!options2.sourceRenderTarget) {
			sourceRenderTarget.destroy();
		}
		this.setRenderTarget(prevRt);
		this.setFramebuffer(prevRt ? prevRt.impl._glFrameBuffer : this.backBuffer?.impl._glFrameBuffer);
		return true;
	}
	frameStart() {
		super.frameStart();
		this.updateBackbuffer();
		this.gpuProfiler.frameStart();
	}
	frameEnd() {
		super.frameEnd();
		this.gpuProfiler.frameEnd();
		this.gpuProfiler.request();
		this.dynamicBuffers.onFrameEnd();
	}
	startRenderPass(renderPass) {
		const rt = renderPass.renderTarget ?? this.backBuffer;
		this.renderTarget = rt;
		this.updateBegin();
		const { width, height } = rt;
		this.setViewport(0, 0, width, height);
		this.setScissor(0, 0, width, height);
		const colorOps = renderPass.colorOps;
		const depthStencilOps = renderPass.depthStencilOps;
		if (colorOps?.clear || depthStencilOps.clearDepth || depthStencilOps.clearStencil) {
			let clearFlags = 0;
			const clearOptions = {};
			if (colorOps?.clear) {
				clearFlags |= CLEARFLAG_COLOR;
				clearOptions.color = [colorOps.clearValue.r, colorOps.clearValue.g, colorOps.clearValue.b, colorOps.clearValue.a];
			}
			if (depthStencilOps.clearDepth) {
				clearFlags |= CLEARFLAG_DEPTH;
				clearOptions.depth = depthStencilOps.clearDepthValue;
			}
			if (depthStencilOps.clearStencil) {
				clearFlags |= CLEARFLAG_STENCIL;
				clearOptions.stencil = depthStencilOps.clearStencilValue;
			}
			clearOptions.flags = clearFlags;
			this.clear(clearOptions);
		}
		this.insideRenderPass = true;
	}
	endRenderPass(renderPass) {
		this.unbindVertexArray();
		const target2 = this.renderTarget;
		const colorBufferCount = renderPass.colorArrayOps.length;
		if (target2) {
			invalidateAttachments.length = 0;
			const gl = this.gl;
			for (let i2 = 0; i2 < colorBufferCount; i2++) {
				const colorOps = renderPass.colorArrayOps[i2];
				if (!(colorOps.store || colorOps.resolve)) {
					invalidateAttachments.push(gl.COLOR_ATTACHMENT0 + i2);
				}
			}
			if (target2 !== this.backBuffer) {
				if (!renderPass.depthStencilOps.storeDepth) {
					invalidateAttachments.push(gl.DEPTH_ATTACHMENT);
				}
				if (!renderPass.depthStencilOps.storeStencil) {
					invalidateAttachments.push(gl.STENCIL_ATTACHMENT);
				}
			}
			if (invalidateAttachments.length > 0) {
				if (renderPass.fullSizeClearRect) {
					gl.invalidateFramebuffer(gl.DRAW_FRAMEBUFFER, invalidateAttachments);
				}
			}
			if (colorBufferCount && renderPass.colorOps?.resolve) {
				if (renderPass.samples > 1 && target2.autoResolve) {
					target2.resolve(true, false);
				}
			}
			if (target2.depthBuffer && renderPass.depthStencilOps.resolveDepth) {
				if (renderPass.samples > 1 && target2.autoResolve) {
					target2.resolve(false, true);
				}
			}
			for (let i2 = 0; i2 < colorBufferCount; i2++) {
				const colorOps = renderPass.colorArrayOps[i2];
				if (colorOps.genMipmaps) {
					const colorBuffer = target2._colorBuffers[i2];
					if (colorBuffer && colorBuffer.impl._glTexture && colorBuffer.mipmaps) {
						this.activeTexture(this.maxCombinedTextures - 1);
						this.bindTexture(colorBuffer);
						this.gl.generateMipmap(colorBuffer.impl._glTarget);
					}
				}
			}
		}
		this.insideRenderPass = false;
	}
	set defaultFramebuffer(value) {
		if (this._defaultFramebuffer !== value) {
			this._defaultFramebuffer = value;
			this._defaultFramebufferChanged = true;
		}
	}
	get defaultFramebuffer() {
		return this._defaultFramebuffer;
	}
	updateBegin() {
		this.boundVao = null;
		if (this._tempEnableSafariTextureUnitWorkaround) {
			for (let unit = 0; unit < this.textureUnits.length; ++unit) {
				for (let slot = 0; slot < 3; ++slot) {
					this.textureUnits[unit][slot] = null;
				}
			}
		}
		const target2 = this.renderTarget ?? this.backBuffer;
		const targetImpl = target2.impl;
		if (!targetImpl.initialized) {
			this.initRenderTarget(target2);
		}
		this.setFramebuffer(targetImpl._glFrameBuffer);
	}
	updateEnd() {
		this.unbindVertexArray();
		const target2 = this.renderTarget;
		if (target2 && target2 !== this.backBuffer) {
			if (target2._samples > 1 && target2.autoResolve) {
				target2.resolve();
			}
			const colorBuffer = target2._colorBuffer;
			if (colorBuffer && colorBuffer.impl._glTexture && colorBuffer.mipmaps) {
				this.activeTexture(this.maxCombinedTextures - 1);
				this.bindTexture(colorBuffer);
				this.gl.generateMipmap(colorBuffer.impl._glTarget);
			}
		}
	}
	setUnpackFlipY(flipY) {
		if (this.unpackFlipY !== flipY) {
			this.unpackFlipY = flipY;
			const gl = this.gl;
			gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
		}
	}
	setUnpackPremultiplyAlpha(premultiplyAlpha) {
		if (this.unpackPremultiplyAlpha !== premultiplyAlpha) {
			this.unpackPremultiplyAlpha = premultiplyAlpha;
			const gl = this.gl;
			gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, premultiplyAlpha);
		}
	}
	setUnpackAlignment(alignment) {
		if (this.unpackAlignment !== alignment) {
			this.unpackAlignment = alignment;
			this.gl.pixelStorei(this.gl.UNPACK_ALIGNMENT, alignment);
		}
	}
	activeTexture(textureUnit) {
		if (this.textureUnit !== textureUnit) {
			this.gl.activeTexture(this.gl.TEXTURE0 + textureUnit);
			this.textureUnit = textureUnit;
		}
	}
	bindTexture(texture) {
		const impl = texture.impl;
		const textureTarget = impl._glTarget;
		const textureObject = impl._glTexture;
		const textureUnit = this.textureUnit;
		const slot = this.targetToSlot[textureTarget];
		if (this.textureUnits[textureUnit][slot] !== textureObject) {
			this.gl.bindTexture(textureTarget, textureObject);
			this.textureUnits[textureUnit][slot] = textureObject;
		}
	}
	bindTextureOnUnit(texture, textureUnit) {
		const impl = texture.impl;
		const textureTarget = impl._glTarget;
		const textureObject = impl._glTexture;
		const slot = this.targetToSlot[textureTarget];
		if (this.textureUnits[textureUnit][slot] !== textureObject) {
			this.activeTexture(textureUnit);
			this.gl.bindTexture(textureTarget, textureObject);
			this.textureUnits[textureUnit][slot] = textureObject;
		}
	}
	setTextureParameters(texture) {
		const gl = this.gl;
		const flags = texture.impl.dirtyParameterFlags;
		const target2 = texture.impl._glTarget;
		if (flags & TEXPROPERTY_MIN_FILTER) {
			let filter = texture._minFilter;
			if (!texture._mipmaps || texture._compressed && texture._levels.length === 1) {
				if (filter === FILTER_NEAREST_MIPMAP_NEAREST || filter === FILTER_NEAREST_MIPMAP_LINEAR) {
					filter = FILTER_NEAREST;
				} else if (filter === FILTER_LINEAR_MIPMAP_NEAREST || filter === FILTER_LINEAR_MIPMAP_LINEAR) {
					filter = FILTER_LINEAR;
				}
			}
			gl.texParameteri(target2, gl.TEXTURE_MIN_FILTER, this.glFilter[filter]);
		}
		if (flags & TEXPROPERTY_MAG_FILTER) {
			gl.texParameteri(target2, gl.TEXTURE_MAG_FILTER, this.glFilter[texture._magFilter]);
		}
		if (flags & TEXPROPERTY_ADDRESS_U) {
			gl.texParameteri(target2, gl.TEXTURE_WRAP_S, this.glAddress[texture._addressU]);
		}
		if (flags & TEXPROPERTY_ADDRESS_V) {
			gl.texParameteri(target2, gl.TEXTURE_WRAP_T, this.glAddress[texture._addressV]);
		}
		if (flags & TEXPROPERTY_ADDRESS_W) {
			gl.texParameteri(target2, gl.TEXTURE_WRAP_R, this.glAddress[texture._addressW]);
		}
		if (flags & TEXPROPERTY_COMPARE_ON_READ) {
			gl.texParameteri(target2, gl.TEXTURE_COMPARE_MODE, texture._compareOnRead ? gl.COMPARE_REF_TO_TEXTURE : gl.NONE);
		}
		if (flags & TEXPROPERTY_COMPARE_FUNC) {
			gl.texParameteri(target2, gl.TEXTURE_COMPARE_FUNC, this.glComparison[texture._compareFunc]);
		}
		if (flags & TEXPROPERTY_ANISOTROPY) {
			const ext = this.extTextureFilterAnisotropic;
			if (ext) {
				gl.texParameterf(target2, ext.TEXTURE_MAX_ANISOTROPY_EXT, math.clamp(Math.round(texture._anisotropy), 1, this.maxAnisotropy));
			}
		}
	}
	setTexture(texture, textureUnit) {
		const impl = texture.impl;
		if (!impl._glTexture) {
			impl.initialize(this, texture);
		}
		if (impl.dirtyParameterFlags > 0 || texture._needsUpload || texture._needsMipmapsUpload) {
			this.activeTexture(textureUnit);
			this.bindTexture(texture);
			if (impl.dirtyParameterFlags) {
				this.setTextureParameters(texture);
				impl.dirtyParameterFlags = 0;
			}
			if (texture._needsUpload || texture._needsMipmapsUpload) {
				impl.upload(this, texture);
				texture._needsUpload = false;
				texture._needsMipmapsUpload = false;
			}
		} else {
			this.bindTextureOnUnit(texture, textureUnit);
		}
	}
	// function creates VertexArrayObject from list of vertex buffers
	createVertexArray(vertexBuffers) {
		let key, vao;
		const useCache = vertexBuffers.length > 1;
		if (useCache) {
			key = "";
			for (let i2 = 0; i2 < vertexBuffers.length; i2++) {
				const vertexBuffer = vertexBuffers[i2];
				key += vertexBuffer.id + vertexBuffer.format.renderingHash;
			}
			vao = this._vaoMap.get(key);
		}
		if (!vao) {
			const gl = this.gl;
			vao = gl.createVertexArray();
			gl.bindVertexArray(vao);
			gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
			let locZero = false;
			for (let i2 = 0; i2 < vertexBuffers.length; i2++) {
				const vertexBuffer = vertexBuffers[i2];
				gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer.impl.bufferId);
				const elements = vertexBuffer.format.elements;
				for (let j = 0; j < elements.length; j++) {
					const e = elements[j];
					const loc = semanticToLocation[e.name];
					if (loc === 0) {
						locZero = true;
					}
					if (e.asInt) {
						gl.vertexAttribIPointer(loc, e.numComponents, this.glType[e.dataType], e.stride, e.offset);
					} else {
						gl.vertexAttribPointer(loc, e.numComponents, this.glType[e.dataType], e.normalize, e.stride, e.offset);
					}
					gl.enableVertexAttribArray(loc);
					if (vertexBuffer.format.instancing) {
						gl.vertexAttribDivisor(loc, 1);
					}
				}
			}
			gl.bindVertexArray(null);
			gl.bindBuffer(gl.ARRAY_BUFFER, null);
			if (useCache) {
				this._vaoMap.set(key, vao);
			}
			if (!locZero) {
			}
		}
		return vao;
	}
	unbindVertexArray() {
		if (this.boundVao) {
			this.boundVao = null;
			this.gl.bindVertexArray(null);
		}
	}
	setBuffers(indexBuffer) {
		const gl = this.gl;
		let vao;
		if (this.vertexBuffers.length === 1) {
			const vertexBuffer = this.vertexBuffers[0];
			if (!vertexBuffer.impl.vao) {
				vertexBuffer.impl.vao = this.createVertexArray(this.vertexBuffers);
			}
			vao = vertexBuffer.impl.vao;
		} else {
			vao = this.createVertexArray(this.vertexBuffers);
		}
		if (this.boundVao !== vao) {
			this.boundVao = vao;
			gl.bindVertexArray(vao);
		}
		const bufferId = indexBuffer ? indexBuffer.impl.bufferId : null;
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, bufferId);
	}
	_multiDrawLoopFallback(mode, primitive2, indexBuffer, numInstances, drawCommands) {
		const gl = this.gl;
		if (primitive2.indexed) {
			const format = indexBuffer.impl.glFormat;
			const { glCounts, glOffsetsBytes, glInstanceCounts, count } = drawCommands.impl;
			if (numInstances > 0) {
				for (let i2 = 0; i2 < count; i2++) {
					gl.drawElementsInstanced(mode, glCounts[i2], format, glOffsetsBytes[i2], glInstanceCounts[i2]);
				}
			} else {
				for (let i2 = 0; i2 < count; i2++) {
					gl.drawElements(mode, glCounts[i2], format, glOffsetsBytes[i2]);
				}
			}
		} else {
			const { glCounts, glOffsetsBytes, glInstanceCounts, count } = drawCommands.impl;
			if (numInstances > 0) {
				for (let i2 = 0; i2 < count; i2++) {
					gl.drawArraysInstanced(mode, glOffsetsBytes[i2], glCounts[i2], glInstanceCounts[i2]);
				}
			} else {
				for (let i2 = 0; i2 < count; i2++) {
					gl.drawArrays(mode, glOffsetsBytes[i2], glCounts[i2]);
				}
			}
		}
	}
	draw(primitive2, indexBuffer, numInstances, drawCommands, first = true, last = true) {
		const shader = this.shader;
		if (shader) {
			this.activateShader();
			if (this.shaderValid) {
				const gl = this.gl;
				if (first) {
					this.setBuffers(indexBuffer);
				}
				let textureUnit = 0;
				const samplers = shader.impl.samplers;
				for (let i2 = 0, len = samplers.length; i2 < len; i2++) {
					const sampler = samplers[i2];
					let samplerValue = sampler.scopeId.value;
					if (!samplerValue) {
						const samplerName = sampler.scopeId.name;
						if (samplerName === "uSceneDepthMap") {
							samplerValue = getBuiltInTexture(this, "white");
						}
						if (samplerName === "uSceneColorMap") {
							samplerValue = getBuiltInTexture(this, "pink");
						}
						if (!samplerValue) {
							samplerValue = getBuiltInTexture(this, "pink");
						}
					}
					if (samplerValue instanceof Texture) {
						const texture = samplerValue;
						this.setTexture(texture, textureUnit);
						if (sampler.slot !== textureUnit) {
							gl.uniform1i(sampler.locationId, textureUnit);
							sampler.slot = textureUnit;
						}
						textureUnit++;
					} else {
						sampler.array.length = 0;
						const numTextures = samplerValue.length;
						for (let j = 0; j < numTextures; j++) {
							const texture = samplerValue[j];
							this.setTexture(texture, textureUnit);
							sampler.array[j] = textureUnit;
							textureUnit++;
						}
						gl.uniform1iv(sampler.locationId, sampler.array);
					}
				}
				const uniforms = shader.impl.uniforms;
				for (let i2 = 0, len = uniforms.length; i2 < len; i2++) {
					const uniform = uniforms[i2];
					const scopeId = uniform.scopeId;
					const uniformVersion = uniform.version;
					const programVersion = scopeId.versionObject.version;
					if (uniformVersion.globalId !== programVersion.globalId || uniformVersion.revision !== programVersion.revision) {
						uniformVersion.globalId = programVersion.globalId;
						uniformVersion.revision = programVersion.revision;
						const value = scopeId.value;
						if (value !== null && value !== void 0) {
							this.commitFunction[uniform.dataType](uniform, value);
						} else {
						}
					}
				}
				if (this.transformFeedbackBuffer) {
					gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, 0, this.transformFeedbackBuffer.impl.bufferId);
					gl.beginTransformFeedback(gl.POINTS);
				}
				const mode = this.glPrimitive[primitive2.type];
				const count = primitive2.count;
				if (drawCommands) {
					if (this.extMultiDraw) {
						const impl = drawCommands.impl;
						if (primitive2.indexed) {
							const format = indexBuffer.impl.glFormat;
							if (numInstances > 0) {
								this.extMultiDraw.multiDrawElementsInstancedWEBGL(mode, impl.glCounts, 0, format, impl.glOffsetsBytes, 0, impl.glInstanceCounts, 0, drawCommands.count);
							} else {
								this.extMultiDraw.multiDrawElementsWEBGL(mode, impl.glCounts, 0, format, impl.glOffsetsBytes, 0, drawCommands.count);
							}
						} else {
							if (numInstances > 0) {
								this.extMultiDraw.multiDrawArraysInstancedWEBGL(mode, impl.glOffsetsBytes, 0, impl.glCounts, 0, impl.glInstanceCounts, 0, drawCommands.count);
							} else {
								this.extMultiDraw.multiDrawArraysWEBGL(mode, impl.glOffsetsBytes, 0, impl.glCounts, 0, drawCommands.count);
							}
						}
					} else {
						this._multiDrawLoopFallback(mode, primitive2, indexBuffer, numInstances, drawCommands);
					}
				} else {
					if (primitive2.indexed) {
						const format = indexBuffer.impl.glFormat;
						const offset3 = primitive2.base * indexBuffer.bytesPerIndex;
						if (numInstances > 0) {
							gl.drawElementsInstanced(mode, count, format, offset3, numInstances);
						} else {
							gl.drawElements(mode, count, format, offset3);
						}
					} else {
						const first2 = primitive2.base;
						if (numInstances > 0) {
							gl.drawArraysInstanced(mode, first2, count, numInstances);
						} else {
							gl.drawArrays(mode, first2, count);
						}
					}
				}
				if (this.transformFeedbackBuffer) {
					gl.endTransformFeedback();
					gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, 0, null);
				}
				this._drawCallsPerFrame++;
			}
		}
		if (last) {
			this.clearVertexBuffer();
		}
	}
	clear(options2) {
		const defaultOptions = this.defaultClearOptions;
		options2 = options2 || defaultOptions;
		const flags = options2.flags ?? defaultOptions.flags;
		if (flags !== 0) {
			const gl = this.gl;
			if (flags & CLEARFLAG_COLOR) {
				const color3 = options2.color ?? defaultOptions.color;
				const r = color3[0];
				const g = color3[1];
				const b = color3[2];
				const a = color3[3];
				const c2 = this.clearColor;
				if (r !== c2.r || g !== c2.g || b !== c2.b || a !== c2.a) {
					this.gl.clearColor(r, g, b, a);
					this.clearColor.set(r, g, b, a);
				}
				this.setBlendState(BlendState.NOBLEND);
			}
			if (flags & CLEARFLAG_DEPTH) {
				const depth = options2.depth ?? defaultOptions.depth;
				if (depth !== this.clearDepth) {
					this.gl.clearDepth(depth);
					this.clearDepth = depth;
				}
				this.setDepthState(DepthState.WRITEDEPTH);
			}
			if (flags & CLEARFLAG_STENCIL) {
				const stencil = options2.stencil ?? defaultOptions.stencil;
				if (stencil !== this.clearStencil) {
					this.gl.clearStencil(stencil);
					this.clearStencil = stencil;
				}
				gl.stencilMask(255);
				this.stencilWriteMaskFront = 255;
				this.stencilWriteMaskBack = 255;
			}
			gl.clear(this.glClearFlag[flags]);
		}
	}
	submit() {
		this.gl.flush();
	}
	readPixels(x3, y2, w, h2, pixels) {
		const gl = this.gl;
		gl.readPixels(x3, y2, w, h2, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
	}
	clientWaitAsync(flags, interval_ms) {
		const gl = this.gl;
		const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
		this.submit();
		return new Promise((resolve2, reject) => {
			function test() {
				const res = gl.clientWaitSync(sync, flags, 0);
				if (res === gl.TIMEOUT_EXPIRED) {
					setTimeout(test, interval_ms);
				} else {
					gl.deleteSync(sync);
					if (res === gl.WAIT_FAILED) {
						reject(new Error("webgl clientWaitSync sync failed"));
					} else {
						resolve2();
					}
				}
			}
			test();
		});
	}
	async readPixelsAsync(x3, y2, w, h2, pixels, forceRgba = false) {
		const gl = this.gl;
		let format, pixelType;
		if (forceRgba) {
			format = gl.RGBA;
			pixelType = gl.UNSIGNED_BYTE;
		} else {
			const impl = this.renderTarget.colorBuffer?.impl;
			format = impl?._glFormat ?? gl.RGBA;
			pixelType = impl?._glPixelType ?? gl.UNSIGNED_BYTE;
		}
		const buf = gl.createBuffer();
		gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buf);
		gl.bufferData(gl.PIXEL_PACK_BUFFER, pixels.byteLength, gl.STREAM_READ);
		gl.readPixels(x3, y2, w, h2, format, pixelType, 0);
		gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
		await this.clientWaitAsync(0, 16);
		gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buf);
		gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, pixels);
		gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
		gl.deleteBuffer(buf);
		return pixels;
	}
	readTextureAsync(texture, x3, y2, width, height, options2) {
		const face = options2.face ?? 0;
		const mipLevel = options2.mipLevel ?? 0;
		const renderTarget = options2.renderTarget ?? new RenderTarget({
			colorBuffer: texture,
			depth: false,
			face,
			mipLevel
		});
		const rgbaChannels = getPixelFormatChannelsForRgbaReadback(texture._format);
		const needsRgbaReadback = rgbaChannels > 0;
		const ArrayType = getPixelFormatArrayType(texture._format);
		const outputData = options2.data ?? new ArrayType(
			TextureUtils.calcLevelGpuSize(width, height, 1, texture._format) / ArrayType.BYTES_PER_ELEMENT
		);
		const readBuffer = needsRgbaReadback ? new Uint8Array(width * height * 4) : outputData;
		this.setRenderTarget(renderTarget);
		this.initRenderTarget(renderTarget);
		this.setFramebuffer(renderTarget.impl._glFrameBuffer);
		if (options2.immediate) {
			this.gl.flush();
		}
		return new Promise((resolve2, reject) => {
			const readPromise = this.readPixelsAsync(x3, y2, width, height, readBuffer, needsRgbaReadback);
			readPromise.then((data2) => {
				if (this._destroyed) return;
				if (!options2.renderTarget) {
					renderTarget.destroy();
				}
				if (needsRgbaReadback) {
					const pixelCount = width * height;
					for (let i2 = 0; i2 < pixelCount; i2++) {
						for (let c2 = 0; c2 < rgbaChannels; c2++) {
							outputData[i2 * rgbaChannels + c2] = data2[i2 * 4 + c2];
						}
					}
					resolve2(outputData);
				} else {
					resolve2(data2);
				}
			}).catch(reject);
		});
	}
	async writeTextureAsync(texture, x3, y2, width, height, data2) {
		const gl = this.gl;
		const impl = texture.impl;
		const format = impl?._glFormat ?? gl.RGBA;
		const pixelType = impl?._glPixelType ?? gl.UNSIGNED_BYTE;
		const buf = gl.createBuffer();
		gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, buf);
		gl.bufferData(gl.PIXEL_UNPACK_BUFFER, data2, gl.STREAM_DRAW);
		gl.bindTexture(gl.TEXTURE_2D, impl._glTexture);
		gl.texSubImage2D(gl.TEXTURE_2D, 0, x3, y2, width, height, format, pixelType, 0);
		gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, null);
		texture._needsUpload = false;
		texture._mipmapsUploaded = false;
		await this.clientWaitAsync(0, 16);
	}
	setAlphaToCoverage(state) {
		if (this.alphaToCoverage !== state) {
			this.alphaToCoverage = state;
			if (state) {
				this.gl.enable(this.gl.SAMPLE_ALPHA_TO_COVERAGE);
			} else {
				this.gl.disable(this.gl.SAMPLE_ALPHA_TO_COVERAGE);
			}
		}
	}
	setTransformFeedbackBuffer(tf) {
		if (this.transformFeedbackBuffer !== tf) {
			this.transformFeedbackBuffer = tf;
			const gl = this.gl;
			if (tf) {
				if (!this.feedback) {
					this.feedback = gl.createTransformFeedback();
				}
				gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, this.feedback);
			} else {
				gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
			}
		}
	}
	setRaster(on) {
		if (this.raster !== on) {
			this.raster = on;
			if (on) {
				this.gl.disable(this.gl.RASTERIZER_DISCARD);
			} else {
				this.gl.enable(this.gl.RASTERIZER_DISCARD);
			}
		}
	}
	setStencilTest(enable) {
		if (this.stencil !== enable) {
			const gl = this.gl;
			if (enable) {
				gl.enable(gl.STENCIL_TEST);
			} else {
				gl.disable(gl.STENCIL_TEST);
			}
			this.stencil = enable;
		}
	}
	setStencilFunc(func, ref, mask) {
		if (this.stencilFuncFront !== func || this.stencilRefFront !== ref || this.stencilMaskFront !== mask || this.stencilFuncBack !== func || this.stencilRefBack !== ref || this.stencilMaskBack !== mask) {
			this.gl.stencilFunc(this.glComparison[func], ref, mask);
			this.stencilFuncFront = this.stencilFuncBack = func;
			this.stencilRefFront = this.stencilRefBack = ref;
			this.stencilMaskFront = this.stencilMaskBack = mask;
		}
	}
	setStencilFuncFront(func, ref, mask) {
		if (this.stencilFuncFront !== func || this.stencilRefFront !== ref || this.stencilMaskFront !== mask) {
			const gl = this.gl;
			gl.stencilFuncSeparate(gl.FRONT, this.glComparison[func], ref, mask);
			this.stencilFuncFront = func;
			this.stencilRefFront = ref;
			this.stencilMaskFront = mask;
		}
	}
	setStencilFuncBack(func, ref, mask) {
		if (this.stencilFuncBack !== func || this.stencilRefBack !== ref || this.stencilMaskBack !== mask) {
			const gl = this.gl;
			gl.stencilFuncSeparate(gl.BACK, this.glComparison[func], ref, mask);
			this.stencilFuncBack = func;
			this.stencilRefBack = ref;
			this.stencilMaskBack = mask;
		}
	}
	setStencilOperation(fail, zfail, zpass, writeMask) {
		if (this.stencilFailFront !== fail || this.stencilZfailFront !== zfail || this.stencilZpassFront !== zpass || this.stencilFailBack !== fail || this.stencilZfailBack !== zfail || this.stencilZpassBack !== zpass) {
			this.gl.stencilOp(this.glStencilOp[fail], this.glStencilOp[zfail], this.glStencilOp[zpass]);
			this.stencilFailFront = this.stencilFailBack = fail;
			this.stencilZfailFront = this.stencilZfailBack = zfail;
			this.stencilZpassFront = this.stencilZpassBack = zpass;
		}
		if (this.stencilWriteMaskFront !== writeMask || this.stencilWriteMaskBack !== writeMask) {
			this.gl.stencilMask(writeMask);
			this.stencilWriteMaskFront = writeMask;
			this.stencilWriteMaskBack = writeMask;
		}
	}
	setStencilOperationFront(fail, zfail, zpass, writeMask) {
		if (this.stencilFailFront !== fail || this.stencilZfailFront !== zfail || this.stencilZpassFront !== zpass) {
			this.gl.stencilOpSeparate(this.gl.FRONT, this.glStencilOp[fail], this.glStencilOp[zfail], this.glStencilOp[zpass]);
			this.stencilFailFront = fail;
			this.stencilZfailFront = zfail;
			this.stencilZpassFront = zpass;
		}
		if (this.stencilWriteMaskFront !== writeMask) {
			this.gl.stencilMaskSeparate(this.gl.FRONT, writeMask);
			this.stencilWriteMaskFront = writeMask;
		}
	}
	setStencilOperationBack(fail, zfail, zpass, writeMask) {
		if (this.stencilFailBack !== fail || this.stencilZfailBack !== zfail || this.stencilZpassBack !== zpass) {
			this.gl.stencilOpSeparate(this.gl.BACK, this.glStencilOp[fail], this.glStencilOp[zfail], this.glStencilOp[zpass]);
			this.stencilFailBack = fail;
			this.stencilZfailBack = zfail;
			this.stencilZpassBack = zpass;
		}
		if (this.stencilWriteMaskBack !== writeMask) {
			this.gl.stencilMaskSeparate(this.gl.BACK, writeMask);
			this.stencilWriteMaskBack = writeMask;
		}
	}
	setBlendState(blendState) {
		const currentBlendState = this.blendState;
		if (!currentBlendState.equals(blendState)) {
			const gl = this.gl;
			const { blend, colorOp, alphaOp, colorSrcFactor, colorDstFactor, alphaSrcFactor, alphaDstFactor } = blendState;
			if (currentBlendState.blend !== blend) {
				if (blend) {
					gl.enable(gl.BLEND);
				} else {
					gl.disable(gl.BLEND);
				}
			}
			if (currentBlendState.colorOp !== colorOp || currentBlendState.alphaOp !== alphaOp) {
				const glBlendEquation = this.glBlendEquation;
				gl.blendEquationSeparate(glBlendEquation[colorOp], glBlendEquation[alphaOp]);
			}
			if (currentBlendState.colorSrcFactor !== colorSrcFactor || currentBlendState.colorDstFactor !== colorDstFactor || currentBlendState.alphaSrcFactor !== alphaSrcFactor || currentBlendState.alphaDstFactor !== alphaDstFactor) {
				gl.blendFuncSeparate(
					this.glBlendFunctionColor[colorSrcFactor],
					this.glBlendFunctionColor[colorDstFactor],
					this.glBlendFunctionAlpha[alphaSrcFactor],
					this.glBlendFunctionAlpha[alphaDstFactor]
				);
			}
			if (currentBlendState.allWrite !== blendState.allWrite) {
				this.gl.colorMask(blendState.redWrite, blendState.greenWrite, blendState.blueWrite, blendState.alphaWrite);
			}
			currentBlendState.copy(blendState);
		}
	}
	setBlendColor(r, g, b, a) {
		const c2 = this.blendColor;
		if (r !== c2.r || g !== c2.g || b !== c2.b || a !== c2.a) {
			this.gl.blendColor(r, g, b, a);
			c2.set(r, g, b, a);
		}
	}
	setStencilState(stencilFront, stencilBack) {
		if (stencilFront || stencilBack) {
			this.setStencilTest(true);
			if (stencilFront === stencilBack) {
				this.setStencilFunc(stencilFront.func, stencilFront.ref, stencilFront.readMask);
				this.setStencilOperation(stencilFront.fail, stencilFront.zfail, stencilFront.zpass, stencilFront.writeMask);
			} else {
				stencilFront ?? (stencilFront = StencilParameters.DEFAULT);
				this.setStencilFuncFront(stencilFront.func, stencilFront.ref, stencilFront.readMask);
				this.setStencilOperationFront(stencilFront.fail, stencilFront.zfail, stencilFront.zpass, stencilFront.writeMask);
				stencilBack ?? (stencilBack = StencilParameters.DEFAULT);
				this.setStencilFuncBack(stencilBack.func, stencilBack.ref, stencilBack.readMask);
				this.setStencilOperationBack(stencilBack.fail, stencilBack.zfail, stencilBack.zpass, stencilBack.writeMask);
			}
		} else {
			this.setStencilTest(false);
		}
	}
	setDepthState(depthState) {
		const currentDepthState = this.depthState;
		if (!currentDepthState.equals(depthState)) {
			const gl = this.gl;
			const write = depthState.write;
			if (currentDepthState.write !== write) {
				gl.depthMask(write);
			}
			let { func, test } = depthState;
			if (!test && write) {
				test = true;
				func = FUNC_ALWAYS;
			}
			if (currentDepthState.func !== func) {
				gl.depthFunc(this.glComparison[func]);
			}
			if (currentDepthState.test !== test) {
				if (test) {
					gl.enable(gl.DEPTH_TEST);
				} else {
					gl.disable(gl.DEPTH_TEST);
				}
			}
			const { depthBias, depthBiasSlope } = depthState;
			if (depthBias || depthBiasSlope) {
				if (!this.depthBiasEnabled) {
					this.depthBiasEnabled = true;
					this.gl.enable(this.gl.POLYGON_OFFSET_FILL);
				}
				gl.polygonOffset(depthBiasSlope, depthBias);
			} else {
				if (this.depthBiasEnabled) {
					this.depthBiasEnabled = false;
					this.gl.disable(this.gl.POLYGON_OFFSET_FILL);
				}
			}
			currentDepthState.copy(depthState);
		}
	}
	setCullMode(cullMode) {
		if (this.cullMode !== cullMode) {
			if (cullMode === CULLFACE_NONE) {
				this.gl.disable(this.gl.CULL_FACE);
			} else {
				if (this.cullMode === CULLFACE_NONE) {
					this.gl.enable(this.gl.CULL_FACE);
				}
				const mode = this.glCull[cullMode];
				if (this.cullFace !== mode) {
					this.gl.cullFace(mode);
					this.cullFace = mode;
				}
			}
			this.cullMode = cullMode;
		}
	}
	setFrontFace(frontFace) {
		if (this.frontFace !== frontFace) {
			const mode = this.glFrontFace[frontFace];
			this.gl.frontFace(mode);
			this.frontFace = frontFace;
		}
	}
	setShader(shader, asyncCompile = false) {
		if (shader !== this.shader) {
			this.shader = shader;
			this.shaderAsyncCompile = asyncCompile;
			this.shaderValid = void 0;
		}
	}
	activateShader() {
		const { shader } = this;
		const { impl } = shader;
		if (this.shaderValid === void 0) {
			if (shader.failed) {
				this.shaderValid = false;
			} else if (!shader.ready) {
				if (this.shaderAsyncCompile) {
					if (impl.isLinked(this)) {
						if (!impl.finalize(this, shader)) {
							shader.failed = true;
							this.shaderValid = false;
						}
					} else {
						this.shaderValid = false;
					}
				} else {
					if (!impl.finalize(this, shader)) {
						shader.failed = true;
						this.shaderValid = false;
					}
				}
			}
		}
		if (this.shaderValid === void 0) {
			this.gl.useProgram(impl.glProgram);
			this.shaderValid = true;
		}
	}
	clearVertexArrayObjectCache() {
		const gl = this.gl;
		this._vaoMap.forEach((item, key, mapObj) => {
			gl.deleteVertexArray(item);
		});
		this._vaoMap.clear();
	}
	set fullscreen(fullscreen) {
		if (fullscreen) {
			const canvas = this.gl.canvas;
			canvas.requestFullscreen();
		} else {
			document.exitFullscreen();
		}
	}
	get fullscreen() {
		return !!document.fullscreenElement;
	}
};

var NullIndexBuffer = class {
	unlock(indexBuffer) {
	}
};

var NullRenderTarget = class {
	destroy(device) {
	}
	init(device, renderTarget) {
	}
	loseContext() {
	}
	resolve(device, target2, color3, depth) {
	}
};

var NullShader = class {
	destroy(shader) {
	}
	loseContext() {
	}
	restoreContext(device, shader) {
	}
};

var NullTexture = class {
	destroy(device) {
	}
	propertyChanged(flag) {
	}
	loseContext() {
	}
	copy(source, options2) {
		return true;
	}
};

var NullVertexBuffer = class {
	destroy(device) {
	}
	unlock(vertexBuffer) {
	}
};

var NullDrawCommands = class {
	add(i2, indexOrVertexCount, instanceCount, firstIndexOrVertex) {
	}
};

var NullUniformBuffer = class {
	destroy(device) {
	}
	loseContext() {
	}
	unlock(uniformBuffer) {
	}
};

var NullBindGroup = class {
	update(bindGroup) {
	}
	destroy() {
	}
};

var NullBindGroupFormat = class {
	destroy() {
	}
};

var NullDynamicBuffers = class extends DynamicBuffers {
	buffer;
	constructor(device) {
		super(device, 0, 0);
		this.buffer = new DynamicBuffer(device);
	}
	alloc(allocation, size) {
		allocation.gpuBuffer = this.buffer;
		allocation.offset = 0;
		allocation.storage = new Int32Array(size / 4);
	}
};

var NullGraphicsDevice = class extends GraphicsDevice {
	constructor(canvas, options2 = {}) {
		super(canvas, options2);
		options2 = this.initOptions;
		this.isNull = true;
		this._deviceType = DEVICETYPE_NULL;
		this.samples = 1;
		this.backBuffer = new RenderTarget({
			name: "Framebuffer",
			graphicsDevice: this,
			depth: this.initOptions.depth,
			stencil: this.supportsStencil,
			samples: this.samples
		});
		this.initDeviceCaps();
		this.dynamicBuffers = new NullDynamicBuffers(this);
	}
	destroy() {
		super.destroy();
	}
	initDeviceCaps() {
		this.disableParticleSystem = true;
		this.precision = "highp";
		this.maxPrecision = "highp";
		this.maxSamples = 4;
		this.maxTextures = 16;
		this.maxTextureSize = 4096;
		this.maxCubeMapSize = 4096;
		this.maxVolumeSize = 4096;
		this.maxColorAttachments = 8;
		this.maxPixelRatio = 1;
		this.maxAnisotropy = 16;
		this.supportsUniformBuffers = false;
		this.supportsAreaLights = true;
		this.supportsGpuParticles = false;
		this.textureFloatRenderable = true;
		this.textureHalfFloatRenderable = true;
		this.supportsImageBitmap = false;
	}
	postInit() {
		super.postInit();
	}
	frameStart() {
		super.frameStart();
	}
	frameEnd() {
		super.frameEnd();
	}
	updateBegin() {
	}
	updateEnd() {
	}
	readPixels(x3, y2, w, h2, pixels) {
	}
	createVertexBufferImpl(vertexBuffer, format) {
		return new NullVertexBuffer(vertexBuffer, format);
	}
	createIndexBufferImpl(indexBuffer) {
		return new NullIndexBuffer(indexBuffer);
	}
	createShaderImpl(shader) {
		return new NullShader(shader);
	}
	createUniformBufferImpl(uniformBuffer) {
		return new NullUniformBuffer();
	}
	createBindGroupImpl(bindGroup) {
		return new NullBindGroup();
	}
	createBindGroupFormatImpl(bindGroupFormat) {
		return new NullBindGroupFormat();
	}
	setBindGroup(index, bindGroup, offsets) {
	}
	createTextureImpl(texture) {
		return new NullTexture(texture);
	}
	createRenderTargetImpl(renderTarget) {
		return new NullRenderTarget(renderTarget);
	}
	createDrawCommandImpl(drawCommands) {
		return new NullDrawCommands();
	}
	createUploadStreamImpl(uploadStream) {
		return null;
	}
	draw(primitive2, indexBuffer, numInstances, drawCommands, first = true, last = true) {
	}
	setShader(shader, asyncCompile = false) {
	}
	setBlendState(blendState) {
	}
	setDepthState(depthState) {
	}
	setStencilState(stencilFront, stencilBack) {
	}
	setBlendColor(r, g, b, a) {
	}
	setCullMode(cullMode) {
	}
	setFrontFace(frontFace) {
	}
	setAlphaToCoverage(state) {
	}
	initializeContextCaches() {
		super.initializeContextCaches();
	}
	clear(options2) {
	}
	setViewport(x3, y2, w, h2) {
	}
	setScissor(x3, y2, w, h2) {
	}
	copyRenderTarget(source, dest, color3, depth) {
		return true;
	}
};

function createGraphicsDevice(canvas, options2 = {}) {
	const deviceTypes = options2.deviceTypes ?? [];
	if (!deviceTypes.includes(DEVICETYPE_WEBGL2)) {
		deviceTypes.push(DEVICETYPE_WEBGL2);
	}
	if (!deviceTypes.includes(DEVICETYPE_NULL)) {
		deviceTypes.push(DEVICETYPE_NULL);
	}
	const deviceCreateFuncs = [];
	for (let i2 = 0; i2 < deviceTypes.length; i2++) {
		const deviceType = deviceTypes[i2];
		if ((deviceType === DEVICETYPE_WEBGPU || deviceType === DEVICETYPE_WEBGPU_BARE) && window?.navigator?.gpu) {
			const featureLevel = deviceType === DEVICETYPE_WEBGPU_BARE ? "bare" : void 0;
			deviceCreateFuncs.push(() => {
				const device = new WebgpuGraphicsDevice(canvas, { ...options2, featureLevel });
				return device.initWebGpu(options2.glslangUrl, options2.twgslUrl);
			});
		}
		if (deviceType === DEVICETYPE_WEBGL2) {
			deviceCreateFuncs.push(() => {
				return new WebglGraphicsDevice(canvas, options2);
			});
		}
		if (deviceType === DEVICETYPE_NULL) {
			deviceCreateFuncs.push(() => {
				return new NullGraphicsDevice(canvas, options2);
			});
		}
	}
	return new Promise((resolve2, reject) => {
		let attempt = 0;
		const next = () => {
			if (attempt >= deviceCreateFuncs.length) {
				reject(new Error("Failed to create a graphics device"));
			} else {
				Promise.resolve(deviceCreateFuncs[attempt++]()).then((device) => {
					if (device) {
						resolve2(device);
					} else {
						next();
					}
				}).catch((err2) => {
					console.log(err2);
					next();
				});
			}
		};
		next();
	});
}

var ComputeParameter = class {
	value;
	scopeId = null;
};
var Compute = class {
	shader = null;
	name;
	parameters = /* @__PURE__ */ new Map();
	countX = 1;
	countY;
	countZ;
	indirectSlotIndex = -1;
	indirectBuffer = null;
	indirectFrameStamp = 0;
	constructor(graphicsDevice, shader, name = "Unnamed") {
		this.device = graphicsDevice;
		this.shader = shader;
		this.name = name;
		if (graphicsDevice.supportsCompute) {
			this.impl = graphicsDevice.createComputeImpl(this);
		}
	}
	setParameter(name, value) {
		let param = this.parameters.get(name);
		if (!param) {
			param = new ComputeParameter();
			param.scopeId = this.device.scope.resolve(name);
			this.parameters.set(name, param);
		}
		param.value = value;
	}
	getParameter(name) {
		return this.parameters.get(name)?.value;
	}
	deleteParameter(name) {
		this.parameters.delete(name);
	}
	destroy() {
		this.impl?.destroy();
		this.impl = null;
	}
	applyParameters() {
		for (const [, param] of this.parameters) {
			param.scopeId.setValue(param.value);
		}
	}
	setupDispatch(x3, y2, z2) {
		this.countX = x3;
		this.countY = y2;
		this.countZ = z2;
		this.indirectSlotIndex = -1;
		this.indirectBuffer = null;
	}
	setupIndirectDispatch(slotIndex, buffer = null) {
		this.indirectSlotIndex = slotIndex;
		this.indirectBuffer = buffer;
		this.indirectFrameStamp = this.device.renderVersion;
	}
	static calcDispatchSize(count, result, maxDimension = 65535) {
		if (count <= maxDimension) {
			return result.set(count, 1);
		}
		const y2 = Math.ceil(count / maxDimension);
		return result.set(Math.ceil(count / y2), y2);
	}
};

var DrawCommands = class {
	device;
	indexSizeBytes;
	_maxCount = 0;
	get maxCount() {
		return this._maxCount;
	}
	impl = null;
	_count = 1;
	get count() {
		return this._count;
	}
	slotIndex = 0;
	primitiveCount = 0;
	constructor(device, indexSizeBytes = 0) {
		this.device = device;
		this.indexSizeBytes = indexSizeBytes;
		this.impl = device.createDrawCommandImpl(this);
	}
	destroy() {
		this.impl?.destroy?.();
		this.impl = null;
	}
	allocate(maxCount) {
		this._maxCount = maxCount;
		this.impl.allocate?.(maxCount);
	}
	add(i2, indexOrVertexCount, instanceCount, firstIndexOrVertex, baseVertex = 0, firstInstance = 0) {
		this.impl.add(i2, indexOrVertexCount, instanceCount, firstIndexOrVertex, baseVertex, firstInstance);
	}
	update(count) {
		this._count = count;
		this.primitiveCount = this.impl.update?.(count) ?? 0;
	}
};

var FramePass = class {
	_name;
	device;
	_enabled = true;
	_skipStart = false;
	_skipEnd = false;
	executeEnabled = true;
	requiresCubemaps = false;
	beforePasses = [];
	afterPasses = [];
	constructor(graphicsDevice) {
		this.device = graphicsDevice;
	}
	set name(value) {
		this._name = value;
	}
	get name() {
		if (!this._name) {
			this._name = this.constructor.name;
		}
		return this._name;
	}
	set enabled(value) {
		if (this._enabled !== value) {
			this._enabled = value;
			if (value) {
				this.onEnable();
			} else {
				this.onDisable();
			}
		}
	}
	get enabled() {
		return this._enabled;
	}
	onEnable() {
	}
	onDisable() {
	}
	frameUpdate() {
	}
	before() {
	}
	execute() {
	}
	after() {
	}
	destroy() {
	}
	render() {
		if (this.enabled) {
			this.before();
			if (this.executeEnabled) {
				this.execute();
			}
			this.after();
			this.device.renderPassIndex++;
		}
	}
};

var ColorAttachmentOps = class {
	clearValue = new Color(0, 0, 0, 1);
	clearValueLinear = new Color(0, 0, 0, 1);
	clear = false;
	store = false;
	resolve = true;
	genMipmaps = false;
};
var DepthStencilAttachmentOps = class {
	clearDepthValue = 1;
	clearStencilValue = 0;
	clearDepth = false;
	clearStencil = false;
	storeDepth = false;
	resolveDepth = false;
	storeStencil = false;
};
var RenderPass = class extends FramePass {
	renderTarget;
	_options;
	samples = 0;
	colorArrayOps = [];
	get colorOps() {
		return this.colorArrayOps[0];
	}
	depthStencilOps;
	requiresCubemaps = true;
	fullSizeClearRect = true;
	set scaleX(value) {
		this._options.scaleX = value;
	}
	get scaleX() {
		return this._options.scaleX;
	}
	set scaleY(value) {
		this._options.scaleY = value;
	}
	get scaleY() {
		return this._options.scaleY;
	}
	set options(value) {
		this._options = value;
		if (value) {
			this.scaleX = this.scaleX ?? 1;
			this.scaleY = this.scaleY ?? 1;
		}
	}
	get options() {
		return this._options;
	}
	init(renderTarget = null, options2) {
		this.options = options2;
		this.renderTarget = renderTarget;
		this.samples = Math.max(this.renderTarget ? this.renderTarget.samples : this.device.samples, 1);
		this.allocateAttachments();
		this.postInit();
	}
	allocateAttachments() {
		const rt = this.renderTarget;
		this.depthStencilOps = new DepthStencilAttachmentOps();
		if (rt?.depthBuffer) {
			this.depthStencilOps.storeDepth = true;
		}
		const numColorOps = rt ? rt._colorBuffers?.length ?? 0 : 1;
		this.colorArrayOps.length = 0;
		for (let i2 = 0; i2 < numColorOps; i2++) {
			const colorOps = new ColorAttachmentOps();
			this.colorArrayOps[i2] = colorOps;
			if (this.samples === 1) {
				colorOps.store = true;
				colorOps.resolve = false;
			}
			const colorBuffer = this.renderTarget?._colorBuffers?.[i2];
			if (this.renderTarget?.mipmaps && colorBuffer?.mipmaps) {
				const intFormat = isIntegerPixelFormat(colorBuffer._format);
				colorOps.genMipmaps = !intFormat;
			}
		}
	}
	postInit() {
	}
	frameUpdate() {
		if (this._options && this.renderTarget) {
			const resizeSource = this._options.resizeSource ?? this.device.backBuffer;
			const width = Math.floor(resizeSource.width * this.scaleX);
			const height = Math.floor(resizeSource.height * this.scaleY);
			this.renderTarget.resize(width, height);
		}
	}
	setClearColor(color3) {
		const count = this.colorArrayOps.length;
		for (let i2 = 0; i2 < count; i2++) {
			const colorOps = this.colorArrayOps[i2];
			if (color3) {
				colorOps.clearValue.copy(color3);
				colorOps.clearValueLinear.linear(color3);
			}
			colorOps.clear = !!color3;
		}
	}
	setClearDepth(depthValue) {
		if (depthValue !== void 0) {
			this.depthStencilOps.clearDepthValue = depthValue;
		}
		this.depthStencilOps.clearDepth = depthValue !== void 0;
	}
	setClearStencil(stencilValue) {
		if (stencilValue !== void 0) {
			this.depthStencilOps.clearStencilValue = stencilValue;
		}
		this.depthStencilOps.clearStencil = stencilValue !== void 0;
	}
	render() {
		if (this.enabled) {
			const device = this.device;
			const realPass = this.renderTarget !== void 0;
			this.before();
			if (this.executeEnabled) {
				if (realPass && !this._skipStart) {
					device.startRenderPass(this);
				}
				this.execute();
				if (realPass && !this._skipEnd) {
					device.endRenderPass(this);
				}
			}
			this.after();
			device.renderPassIndex++;
		}
	}
};

var TransformFeedback = class {
	constructor(inputBuffer, outputBuffer, usage = BUFFER_GPUDYNAMIC) {
		if (outputBuffer !== void 0 && !(outputBuffer instanceof VertexBuffer)) {
			usage = outputBuffer;
			outputBuffer = void 0;
		}
		this.device = inputBuffer.device;
		const gl = this.device.gl;
		const outVB = outputBuffer ?? inputBuffer;
		if (usage === BUFFER_GPUDYNAMIC && outVB.usage !== usage) {
			gl.bindBuffer(gl.ARRAY_BUFFER, outVB.impl.bufferId);
			gl.bufferData(gl.ARRAY_BUFFER, outVB.storage, gl.DYNAMIC_COPY);
		}
		this._inputBuffer = inputBuffer;
		this._destroyOutputBuffer = !outputBuffer;
		this._outputBuffer = outputBuffer ?? new VertexBuffer(inputBuffer.device, inputBuffer.format, inputBuffer.numVertices, {
			usage,
			data: inputBuffer.storage
		});
	}
	static createShader(graphicsDevice, vertexCode, name, feedbackVaryings) {
		return new Shader(graphicsDevice, ShaderDefinitionUtils.createDefinition(graphicsDevice, {
			name,
			vertexCode,
			feedbackVaryings,
			useTransformFeedback: true,
			fragmentCode: "void main(void) {gl_FragColor = vec4(0.0);}"
		}));
	}
	destroy() {
		if (this._destroyOutputBuffer) {
			this._outputBuffer.destroy();
		}
	}
	process(shader, swap = true) {
		const device = this.device;
		const oldRt = device.getRenderTarget();
		device.setRenderTarget(null);
		device.updateBegin();
		device.setVertexBuffer(this._inputBuffer);
		device.setRaster(false);
		device.setTransformFeedbackBuffer(this._outputBuffer);
		device.setShader(shader);
		device.draw({
			type: PRIMITIVE_POINTS,
			base: 0,
			baseVertex: 0,
			count: this._inputBuffer.numVertices,
			indexed: false
		});
		device.setTransformFeedbackBuffer(null);
		device.setRaster(true);
		device.updateEnd();
		device.setRenderTarget(oldRt);
		if (swap) {
			let tmp = this._inputBuffer.impl.bufferId;
			this._inputBuffer.impl.bufferId = this._outputBuffer.impl.bufferId;
			this._outputBuffer.impl.bufferId = tmp;
			tmp = this._inputBuffer.impl.vao;
			this._inputBuffer.impl.vao = this._outputBuffer.impl.vao;
			this._outputBuffer.impl.vao = tmp;
		}
	}
	get inputBuffer() {
		return this._inputBuffer;
	}
	get outputBuffer() {
		return this._outputBuffer;
	}
};

function set1(a) {
	this.array[this.index] = a;
}
function set2(a, b) {
	this.array[this.index] = a;
	this.array[this.index + 1] = b;
}
function set3(a, b, c2) {
	this.array[this.index] = a;
	this.array[this.index + 1] = b;
	this.array[this.index + 2] = c2;
}
function set4(a, b, c2, d) {
	this.array[this.index] = a;
	this.array[this.index + 1] = b;
	this.array[this.index + 2] = c2;
	this.array[this.index + 3] = d;
}
function arraySet1(index, inputArray, inputIndex) {
	this.array[index] = inputArray[inputIndex];
}
function arraySet2(index, inputArray, inputIndex) {
	this.array[index] = inputArray[inputIndex];
	this.array[index + 1] = inputArray[inputIndex + 1];
}
function arraySet3(index, inputArray, inputIndex) {
	this.array[index] = inputArray[inputIndex];
	this.array[index + 1] = inputArray[inputIndex + 1];
	this.array[index + 2] = inputArray[inputIndex + 2];
}
function arraySet4(index, inputArray, inputIndex) {
	this.array[index] = inputArray[inputIndex];
	this.array[index + 1] = inputArray[inputIndex + 1];
	this.array[index + 2] = inputArray[inputIndex + 2];
	this.array[index + 3] = inputArray[inputIndex + 3];
}
function arrayGet1(offset3, outputArray, outputIndex) {
	outputArray[outputIndex] = this.array[offset3];
}
function arrayGet2(offset3, outputArray, outputIndex) {
	outputArray[outputIndex] = this.array[offset3];
	outputArray[outputIndex + 1] = this.array[offset3 + 1];
}
function arrayGet3(offset3, outputArray, outputIndex) {
	outputArray[outputIndex] = this.array[offset3];
	outputArray[outputIndex + 1] = this.array[offset3 + 1];
	outputArray[outputIndex + 2] = this.array[offset3 + 2];
}
function arrayGet4(offset3, outputArray, outputIndex) {
	outputArray[outputIndex] = this.array[offset3];
	outputArray[outputIndex + 1] = this.array[offset3 + 1];
	outputArray[outputIndex + 2] = this.array[offset3 + 2];
	outputArray[outputIndex + 3] = this.array[offset3 + 3];
}
var VertexIteratorAccessor = class {
	constructor(buffer, vertexElement, vertexFormat) {
		this.index = 0;
		this.numComponents = vertexElement.numComponents;
		if (vertexFormat.interleaved) {
			this.array = new typedArrayTypes[vertexElement.dataType](buffer, vertexElement.offset);
		} else {
			this.array = new typedArrayTypes[vertexElement.dataType](buffer, vertexElement.offset, vertexFormat.vertexCount * vertexElement.numComponents);
		}
		this.stride = vertexElement.stride / this.array.constructor.BYTES_PER_ELEMENT;
		switch (vertexElement.numComponents) {
			case 1:
				this.set = set1;
				this.getToArray = arrayGet1;
				this.setFromArray = arraySet1;
				break;
			case 2:
				this.set = set2;
				this.getToArray = arrayGet2;
				this.setFromArray = arraySet2;
				break;
			case 3:
				this.set = set3;
				this.getToArray = arrayGet3;
				this.setFromArray = arraySet3;
				break;
			case 4:
				this.set = set4;
				this.getToArray = arrayGet4;
				this.setFromArray = arraySet4;
				break;
		}
	}
	get(offset3) {
		return this.array[this.index + offset3];
	}
	set(a, b, c2, d) {
	}
	getToArray(offset3, outputArray, outputIndex) {
	}
	setFromArray(index, inputArray, inputIndex) {
	}
};
var VertexIterator = class {
	constructor(vertexBuffer) {
		this.vertexBuffer = vertexBuffer;
		this.vertexFormatSize = vertexBuffer.getFormat().size;
		this.buffer = this.vertexBuffer.lock();
		this.accessors = [];
		this.element = {};
		const vertexFormat = this.vertexBuffer.getFormat();
		for (let i2 = 0; i2 < vertexFormat.elements.length; i2++) {
			const vertexElement = vertexFormat.elements[i2];
			this.accessors[i2] = new VertexIteratorAccessor(this.buffer, vertexElement, vertexFormat);
			this.element[vertexElement.name] = this.accessors[i2];
		}
	}
	next(count = 1) {
		let i2 = 0;
		const accessors = this.accessors;
		const numAccessors = this.accessors.length;
		while (i2 < numAccessors) {
			const accessor = accessors[i2++];
			accessor.index += count * accessor.stride;
		}
	}
	end() {
		this.vertexBuffer.unlock();
	}
	writeData(semantic, data2, numVertices) {
		const element = this.element[semantic];
		if (element) {
			if (numVertices > this.vertexBuffer.numVertices) {
				numVertices = this.vertexBuffer.numVertices;
			}
			const numComponents = element.numComponents;
			if (this.vertexBuffer.getFormat().interleaved) {
				let index = 0;
				for (let i2 = 0; i2 < numVertices; i2++) {
					element.setFromArray(index, data2, i2 * numComponents);
					index += element.stride;
				}
			} else {
				if (data2.length > numVertices * numComponents) {
					const copyCount = numVertices * numComponents;
					if (ArrayBuffer.isView(data2)) {
						data2 = data2.subarray(0, copyCount);
						element.array.set(data2);
					} else {
						for (let i2 = 0; i2 < copyCount; i2++) {
							element.array[i2] = data2[i2];
						}
					}
				} else {
					element.array.set(data2);
				}
			}
		}
	}
	readData(semantic, data2) {
		const element = this.element[semantic];
		let count = 0;
		if (element) {
			count = this.vertexBuffer.numVertices;
			let i2;
			const numComponents = element.numComponents;
			if (this.vertexBuffer.getFormat().interleaved) {
				if (Array.isArray(data2)) {
					data2.length = 0;
				}
				element.index = 0;
				let offset3 = 0;
				for (i2 = 0; i2 < count; i2++) {
					element.getToArray(offset3, data2, i2 * numComponents);
					offset3 += element.stride;
				}
			} else {
				if (ArrayBuffer.isView(data2)) {
					data2.set(element.array);
				} else {
					data2.length = 0;
					const copyCount = count * numComponents;
					for (i2 = 0; i2 < copyCount; i2++) {
						data2[i2] = element.array[i2];
					}
				}
			}
		}
		return count;
	}
};

var ACTION_MOUSE = "mouse";
var ACTION_KEYBOARD = "keyboard";
var ACTION_GAMEPAD = "gamepad";
var AXIS_MOUSE_X = "mousex";
var AXIS_MOUSE_Y = "mousey";
var AXIS_PAD_L_X = "padlx";
var AXIS_PAD_L_Y = "padly";
var AXIS_PAD_R_X = "padrx";
var AXIS_PAD_R_Y = "padry";
var AXIS_KEY = "key";
var KEY_BACKSPACE = 8;
var KEY_TAB = 9;
var KEY_RETURN = 13;
var KEY_ENTER = 13;
var KEY_SHIFT = 16;
var KEY_CONTROL = 17;
var KEY_ALT = 18;
var KEY_PAUSE = 19;
var KEY_CAPS_LOCK = 20;
var KEY_ESCAPE = 27;
var KEY_SPACE = 32;
var KEY_PAGE_UP = 33;
var KEY_PAGE_DOWN = 34;
var KEY_END = 35;
var KEY_HOME = 36;
var KEY_LEFT = 37;
var KEY_UP = 38;
var KEY_RIGHT = 39;
var KEY_DOWN = 40;
var KEY_PRINT_SCREEN = 44;
var KEY_INSERT = 45;
var KEY_DELETE = 46;
var KEY_0 = 48;
var KEY_1 = 49;
var KEY_2 = 50;
var KEY_3 = 51;
var KEY_4 = 52;
var KEY_5 = 53;
var KEY_6 = 54;
var KEY_7 = 55;
var KEY_8 = 56;
var KEY_9 = 57;
var KEY_SEMICOLON = 59;
var KEY_EQUAL = 61;
var KEY_A = 65;
var KEY_B = 66;
var KEY_C = 67;
var KEY_D = 68;
var KEY_E = 69;
var KEY_F = 70;
var KEY_G = 71;
var KEY_H = 72;
var KEY_I = 73;
var KEY_J = 74;
var KEY_K = 75;
var KEY_L = 76;
var KEY_M = 77;
var KEY_N = 78;
var KEY_O = 79;
var KEY_P = 80;
var KEY_Q = 81;
var KEY_R = 82;
var KEY_S = 83;
var KEY_T = 84;
var KEY_U = 85;
var KEY_V = 86;
var KEY_W = 87;
var KEY_X = 88;
var KEY_Y = 89;
var KEY_Z = 90;
var KEY_WINDOWS = 91;
var KEY_CONTEXT_MENU = 93;
var KEY_NUMPAD_0 = 96;
var KEY_NUMPAD_1 = 97;
var KEY_NUMPAD_2 = 98;
var KEY_NUMPAD_3 = 99;
var KEY_NUMPAD_4 = 100;
var KEY_NUMPAD_5 = 101;
var KEY_NUMPAD_6 = 102;
var KEY_NUMPAD_7 = 103;
var KEY_NUMPAD_8 = 104;
var KEY_NUMPAD_9 = 105;
var KEY_MULTIPLY = 106;
var KEY_ADD = 107;
var KEY_SEPARATOR = 108;
var KEY_SUBTRACT = 109;
var KEY_DECIMAL = 110;
var KEY_DIVIDE = 111;
var KEY_F1 = 112;
var KEY_F2 = 113;
var KEY_F3 = 114;
var KEY_F4 = 115;
var KEY_F5 = 116;
var KEY_F6 = 117;
var KEY_F7 = 118;
var KEY_F8 = 119;
var KEY_F9 = 120;
var KEY_F10 = 121;
var KEY_F11 = 122;
var KEY_F12 = 123;
var KEY_COMMA = 188;
var KEY_PERIOD = 190;
var KEY_SLASH = 191;
var KEY_OPEN_BRACKET = 219;
var KEY_BACK_SLASH = 220;
var KEY_CLOSE_BRACKET = 221;
var KEY_META = 224;
var MOUSEBUTTON_NONE = -1;
var MOUSEBUTTON_LEFT = 0;
var MOUSEBUTTON_MIDDLE = 1;
var MOUSEBUTTON_RIGHT = 2;
var PAD_1 = 0;
var PAD_2 = 1;
var PAD_3 = 2;
var PAD_4 = 3;
var PAD_FACE_1 = 0;
var PAD_FACE_2 = 1;
var PAD_FACE_3 = 2;
var PAD_FACE_4 = 3;
var PAD_L_SHOULDER_1 = 4;
var PAD_R_SHOULDER_1 = 5;
var PAD_L_SHOULDER_2 = 6;
var PAD_R_SHOULDER_2 = 7;
var PAD_SELECT = 8;
var PAD_START = 9;
var PAD_L_STICK_BUTTON = 10;
var PAD_R_STICK_BUTTON = 11;
var PAD_UP = 12;
var PAD_DOWN = 13;
var PAD_LEFT = 14;
var PAD_RIGHT = 15;
var PAD_VENDOR = 16;
var PAD_L_STICK_X = 0;
var PAD_L_STICK_Y = 1;
var PAD_R_STICK_X = 2;
var PAD_R_STICK_Y = 3;
var XRPAD_TOUCHPAD_X = 0;
var XRPAD_TOUCHPAD_Y = 1;
var XRPAD_STICK_X = 2;
var XRPAD_STICK_Y = 3;
var XRPAD_TOUCHPAD_BUTTON = 2;
var XRPAD_TRIGGER = 0;
var XRPAD_SQUEEZE = 1;
var XRPAD_STICK_BUTTON = 3;
var XRPAD_A = 4;
var XRPAD_B = 5;

var KeyboardEvent = class {
	key = null;
	element = null;
	event = null;
	constructor(keyboard, event) {
		if (event) {
			this.key = event.keyCode;
			this.element = event.target;
			this.event = event;
		}
	}
};

var _keyboardEvent = new KeyboardEvent();
function makeKeyboardEvent(event) {
	_keyboardEvent.key = event.keyCode;
	_keyboardEvent.element = event.target;
	_keyboardEvent.event = event;
	return _keyboardEvent;
}
function toKeyCode(s2) {
	if (typeof s2 === "string") {
		return s2.toUpperCase().charCodeAt(0);
	}
	return s2;
}
var _keyCodeToKeyIdentifier = {
	"9": "Tab",
	"13": "Enter",
	"16": "Shift",
	"17": "Control",
	"18": "Alt",
	"27": "Escape",
	"37": "Left",
	"38": "Up",
	"39": "Right",
	"40": "Down",
	"46": "Delete",
	"91": "Win"
};
var Keyboard = class extends EventHandler {
	static EVENT_KEYDOWN = "keydown";
	static EVENT_KEYUP = "keyup";
	_element = null;
	_keymap = {};
	_lastmap = {};
	_keyDownHandler;
	_keyUpHandler;
	_keyPressHandler;
	_visibilityChangeHandler;
	_windowBlurHandler;
	preventDefault;
	stopPropagation;
	constructor(element, options2 = {}) {
		super();
		this._keyDownHandler = this._handleKeyDown.bind(this);
		this._keyUpHandler = this._handleKeyUp.bind(this);
		this._keyPressHandler = this._handleKeyPress.bind(this);
		this._visibilityChangeHandler = this._handleVisibilityChange.bind(this);
		this._windowBlurHandler = this._handleWindowBlur.bind(this);
		if (element) {
			this.attach(element);
		}
		this.preventDefault = options2.preventDefault || false;
		this.stopPropagation = options2.stopPropagation || false;
	}
	attach(element) {
		if (this._element) {
			this.detach();
		}
		this._element = element;
		this._element.addEventListener("keydown", this._keyDownHandler, false);
		this._element.addEventListener("keypress", this._keyPressHandler, false);
		this._element.addEventListener("keyup", this._keyUpHandler, false);
		document.addEventListener("visibilitychange", this._visibilityChangeHandler, false);
		window.addEventListener("blur", this._windowBlurHandler, false);
	}
	detach() {
		if (!this._element) {
			return;
		}
		this._element.removeEventListener("keydown", this._keyDownHandler);
		this._element.removeEventListener("keypress", this._keyPressHandler);
		this._element.removeEventListener("keyup", this._keyUpHandler);
		this._element = null;
		document.removeEventListener("visibilitychange", this._visibilityChangeHandler, false);
		window.removeEventListener("blur", this._windowBlurHandler, false);
	}
	toKeyIdentifier(keyCode) {
		keyCode = toKeyCode(keyCode);
		const id14 = _keyCodeToKeyIdentifier[keyCode.toString()];
		if (id14) {
			return id14;
		}
		let hex = keyCode.toString(16).toUpperCase();
		const length = hex.length;
		for (let count = 0; count < 4 - length; count++) {
			hex = `0${hex}`;
		}
		return `U+${hex}`;
	}
	_handleKeyDown(event) {
		const code = event.keyCode || event.charCode;
		if (code === void 0) return;
		const id14 = this.toKeyIdentifier(code);
		this._keymap[id14] = true;
		this.fire("keydown", makeKeyboardEvent(event));
		if (this.preventDefault) {
			event.preventDefault();
		}
		if (this.stopPropagation) {
			event.stopPropagation();
		}
	}
	_handleKeyUp(event) {
		const code = event.keyCode || event.charCode;
		if (code === void 0) return;
		const id14 = this.toKeyIdentifier(code);
		delete this._keymap[id14];
		this.fire("keyup", makeKeyboardEvent(event));
		if (this.preventDefault) {
			event.preventDefault();
		}
		if (this.stopPropagation) {
			event.stopPropagation();
		}
	}
	_handleKeyPress(event) {
		this.fire("keypress", makeKeyboardEvent(event));
		if (this.preventDefault) {
			event.preventDefault();
		}
		if (this.stopPropagation) {
			event.stopPropagation();
		}
	}
	_handleVisibilityChange() {
		if (document.visibilityState === "hidden") {
			this._handleWindowBlur();
		}
	}
	_handleWindowBlur() {
		this._keymap = {};
		this._lastmap = {};
	}
	update() {
		for (const prop in this._lastmap) {
			delete this._lastmap[prop];
		}
		for (const prop in this._keymap) {
			if (this._keymap.hasOwnProperty(prop)) {
				this._lastmap[prop] = this._keymap[prop];
			}
		}
	}
	isPressed(key) {
		const keyCode = toKeyCode(key);
		const id14 = this.toKeyIdentifier(keyCode);
		return !!this._keymap[id14];
	}
	wasPressed(key) {
		const keyCode = toKeyCode(key);
		const id14 = this.toKeyIdentifier(keyCode);
		return !!this._keymap[id14] && !!!this._lastmap[id14];
	}
	wasReleased(key) {
		const keyCode = toKeyCode(key);
		const id14 = this.toKeyIdentifier(keyCode);
		return !!!this._keymap[id14] && !!this._lastmap[id14];
	}
};

function isMousePointerLocked() {
	return !!(document.pointerLockElement || document.mozPointerLockElement || document.webkitPointerLockElement);
}
var MouseEvent = class _MouseEvent {
	x = 0;
	y = 0;
	dx = 0;
	dy = 0;
	button = MOUSEBUTTON_NONE;
	buttons;
	wheelDelta = 0;
	element;
	ctrlKey = false;
	altKey = false;
	shiftKey = false;
	metaKey = false;
	event;
	constructor(mouse, event) {
		let coords = {
			x: 0,
			y: 0
		};
		if (event) {
			if (event instanceof _MouseEvent) {
				throw Error("Expected MouseEvent");
			}
			coords = mouse._getTargetCoords(event);
		} else {
			event = {};
		}
		if (coords) {
			this.x = coords.x;
			this.y = coords.y;
		} else if (isMousePointerLocked()) {
			this.x = 0;
			this.y = 0;
		} else {
			return;
		}
		if (event.type === "wheel") {
			if (event.deltaY > 0) {
				this.wheelDelta = 1;
			} else if (event.deltaY < 0) {
				this.wheelDelta = -1;
			}
		}
		if (isMousePointerLocked()) {
			this.dx = event.movementX || event.webkitMovementX || event.mozMovementX || 0;
			this.dy = event.movementY || event.webkitMovementY || event.mozMovementY || 0;
		} else {
			this.dx = this.x - mouse._lastX;
			this.dy = this.y - mouse._lastY;
		}
		if (event.type === "mousedown" || event.type === "mouseup") {
			this.button = event.button;
		}
		this.buttons = mouse._buttons.slice(0);
		this.element = event.target;
		this.ctrlKey = event.ctrlKey ?? false;
		this.altKey = event.altKey ?? false;
		this.shiftKey = event.shiftKey ?? false;
		this.metaKey = event.metaKey ?? false;
		this.event = event;
	}
};

var Mouse = class extends EventHandler {
	static EVENT_MOUSEMOVE = "mousemove";
	static EVENT_MOUSEDOWN = "mousedown";
	static EVENT_MOUSEUP = "mouseup";
	static EVENT_MOUSEWHEEL = "mousewheel";
	_lastX = 0;
	_lastY = 0;
	_buttons = [false, false, false];
	_lastbuttons = [false, false, false];
	_target = null;
	_attached = false;
	_upHandler;
	_downHandler;
	_moveHandler;
	_wheelHandler;
	_contextMenuHandler;
	constructor(element) {
		super();
		this._upHandler = this._handleUp.bind(this);
		this._downHandler = this._handleDown.bind(this);
		this._moveHandler = this._handleMove.bind(this);
		this._wheelHandler = this._handleWheel.bind(this);
		this._contextMenuHandler = (event) => {
			event.preventDefault();
		};
		this.attach(element);
	}
	static isPointerLocked() {
		return isMousePointerLocked();
	}
	attach(element) {
		this._target = element;
		if (this._attached) return;
		this._attached = true;
		const passiveOptions = { passive: false };
		const options2 = platform.passiveEvents ? passiveOptions : false;
		window.addEventListener("mouseup", this._upHandler, options2);
		window.addEventListener("mousedown", this._downHandler, options2);
		window.addEventListener("mousemove", this._moveHandler, options2);
		window.addEventListener("wheel", this._wheelHandler, options2);
	}
	detach() {
		if (!this._attached) return;
		this._attached = false;
		this._target = null;
		const passiveOptions = { passive: false };
		const options2 = platform.passiveEvents ? passiveOptions : false;
		window.removeEventListener("mouseup", this._upHandler, options2);
		window.removeEventListener("mousedown", this._downHandler, options2);
		window.removeEventListener("mousemove", this._moveHandler, options2);
		window.removeEventListener("wheel", this._wheelHandler, options2);
	}
	disableContextMenu() {
		if (!this._target) return;
		this._target.addEventListener("contextmenu", this._contextMenuHandler);
	}
	enableContextMenu() {
		if (!this._target) return;
		this._target.removeEventListener("contextmenu", this._contextMenuHandler);
	}
	enablePointerLock(success, error) {
		if (!document.body.requestPointerLock) {
			if (error) {
				error();
			}
			return;
		}
		const s2 = () => {
			success();
			document.removeEventListener("pointerlockchange", s2);
		};
		const e = () => {
			error();
			document.removeEventListener("pointerlockerror", e);
		};
		if (success) {
			document.addEventListener("pointerlockchange", s2, false);
		}
		if (error) {
			document.addEventListener("pointerlockerror", e, false);
		}
		document.body.requestPointerLock();
	}
	disablePointerLock(success) {
		if (!document.exitPointerLock) {
			return;
		}
		const s2 = () => {
			success();
			document.removeEventListener("pointerlockchange", s2);
		};
		if (success) {
			document.addEventListener("pointerlockchange", s2, false);
		}
		document.exitPointerLock();
	}
	update() {
		this._lastbuttons[0] = this._buttons[0];
		this._lastbuttons[1] = this._buttons[1];
		this._lastbuttons[2] = this._buttons[2];
	}
	isPressed(button) {
		return this._buttons[button];
	}
	wasPressed(button) {
		return this._buttons[button] && !this._lastbuttons[button];
	}
	wasReleased(button) {
		return !this._buttons[button] && this._lastbuttons[button];
	}
	_handleUp(event) {
		this._buttons[event.button] = false;
		const e = new MouseEvent(this, event);
		if (!e.event) return;
		this.fire("mouseup", e);
	}
	_handleDown(event) {
		this._buttons[event.button] = true;
		const e = new MouseEvent(this, event);
		if (!e.event) return;
		this.fire("mousedown", e);
	}
	_handleMove(event) {
		const e = new MouseEvent(this, event);
		if (!e.event) return;
		this.fire("mousemove", e);
		this._lastX = e.x;
		this._lastY = e.y;
	}
	_handleWheel(event) {
		const e = new MouseEvent(this, event);
		if (!e.event) return;
		this.fire("mousewheel", e);
	}
	_getTargetCoords(event) {
		const rect = this._target.getBoundingClientRect();
		const left = Math.floor(rect.left);
		const top = Math.floor(rect.top);
		if (event.clientX < left || event.clientX >= left + this._target.clientWidth || event.clientY < top || event.clientY >= top + this._target.clientHeight) {
			return null;
		}
		return {
			x: event.clientX - left,
			y: event.clientY - top
		};
	}
};

var Controller = class {
	_keyboard;
	_mouse;
	_gamepads;
	_element = null;
	_actions = {};
	_axes = {};
	_axesValues = {};
	constructor(element, options2 = {}) {
		this._keyboard = options2.keyboard || null;
		this._mouse = options2.mouse || null;
		this._gamepads = options2.gamepads || null;
		if (element) {
			this.attach(element);
		}
	}
	attach(element) {
		this._element = element;
		if (this._keyboard) {
			this._keyboard.attach(element);
		}
		if (this._mouse) {
			this._mouse.attach(element);
		}
	}
	detach() {
		if (this._keyboard) {
			this._keyboard.detach();
		}
		if (this._mouse) {
			this._mouse.detach();
		}
		this._element = null;
	}
	disableContextMenu() {
		if (!this._mouse) {
			this._enableMouse();
		}
		this._mouse.disableContextMenu();
	}
	enableContextMenu() {
		if (!this._mouse) {
			this._enableMouse();
		}
		this._mouse.enableContextMenu();
	}
	update(dt) {
		if (this._keyboard) {
			this._keyboard.update();
		}
		if (this._mouse) {
			this._mouse.update();
		}
		if (this._gamepads) {
			this._gamepads.update();
		}
		this._axesValues = {};
		for (const key in this._axes) {
			this._axesValues[key] = [];
		}
	}
	appendAction(action_name, action) {
		this._actions[action_name] = this._actions[action_name] || [];
		this._actions[action_name].push(action);
	}
	registerKeys(action, keys) {
		if (!this._keyboard) {
			this._enableKeyboard();
		}
		if (this._actions[action]) {
			throw new Error(`Action: ${action} already registered`);
		}
		if (keys === void 0) {
			throw new Error("Invalid button");
		}
		if (!keys.length) {
			keys = [keys];
		}
		this.appendAction(action, {
			type: ACTION_KEYBOARD,
			keys
		});
	}
	registerMouse(action, button) {
		if (!this._mouse) {
			this._enableMouse();
		}
		if (button === void 0) {
			throw new Error("Invalid button");
		}
		this.appendAction(action, {
			type: ACTION_MOUSE,
			button
		});
	}
	registerPadButton(action, pad, button) {
		if (button === void 0) {
			throw new Error("Invalid button");
		}
		this.appendAction(action, {
			type: ACTION_GAMEPAD,
			button,
			pad
		});
	}
	registerAxis(options2) {
		const name = options2.name;
		if (!this._axes[name]) {
			this._axes[name] = [];
		}
		const i2 = this._axes[name].push(name);
		options2 = options2 || {};
		options2.pad = options2.pad || PAD_1;
		const bind = function(controller, source, value, key) {
			switch (source) {
				case "mousex":
					controller._mouse.on("mousemove", (e) => {
						controller._axesValues[name][i2] = e.dx / 10;
					});
					break;
				case "mousey":
					controller._mouse.on("mousemove", (e) => {
						controller._axesValues[name][i2] = e.dy / 10;
					});
					break;
				case "key":
					controller._axes[name].push(() => {
						return controller._keyboard.isPressed(key) ? value : 0;
					});
					break;
				case "padrx":
					controller._axes[name].push(() => {
						return controller._gamepads.getAxis(options2.pad, PAD_R_STICK_X);
					});
					break;
				case "padry":
					controller._axes[name].push(() => {
						return controller._gamepads.getAxis(options2.pad, PAD_R_STICK_Y);
					});
					break;
				case "padlx":
					controller._axes[name].push(() => {
						return controller._gamepads.getAxis(options2.pad, PAD_L_STICK_X);
					});
					break;
				case "padly":
					controller._axes[name].push(() => {
						return controller._gamepads.getAxis(options2.pad, PAD_L_STICK_Y);
					});
					break;
				default:
					throw new Error("Unknown axis");
			}
		};
		bind(this, options2.positive, 1, options2.positiveKey);
		if (options2.negativeKey || options2.negative !== options2.positive) {
			bind(this, options2.negative, -1, options2.negativeKey);
		}
	}
	isPressed(actionName) {
		if (!this._actions[actionName]) {
			return false;
		}
		const length = this._actions[actionName].length;
		for (let index = 0; index < length; ++index) {
			const action = this._actions[actionName][index];
			switch (action.type) {
				case ACTION_KEYBOARD:
					if (this._keyboard) {
						const len = action.keys.length;
						for (let i2 = 0; i2 < len; i2++) {
							if (this._keyboard.isPressed(action.keys[i2])) {
								return true;
							}
						}
					}
					break;
				case ACTION_MOUSE:
					if (this._mouse && this._mouse.isPressed(action.button)) {
						return true;
					}
					break;
				case ACTION_GAMEPAD:
					if (this._gamepads && this._gamepads.isPressed(action.pad, action.button)) {
						return true;
					}
					break;
			}
		}
		return false;
	}
	wasPressed(actionName) {
		if (!this._actions[actionName]) {
			return false;
		}
		const length = this._actions[actionName].length;
		for (let index = 0; index < length; ++index) {
			const action = this._actions[actionName][index];
			switch (action.type) {
				case ACTION_KEYBOARD:
					if (this._keyboard) {
						const len = action.keys.length;
						for (let i2 = 0; i2 < len; i2++) {
							if (this._keyboard.wasPressed(action.keys[i2])) {
								return true;
							}
						}
					}
					break;
				case ACTION_MOUSE:
					if (this._mouse && this._mouse.wasPressed(action.button)) {
						return true;
					}
					break;
				case ACTION_GAMEPAD:
					if (this._gamepads && this._gamepads.wasPressed(action.pad, action.button)) {
						return true;
					}
					break;
			}
		}
		return false;
	}
	getAxis(name) {
		let value = 0;
		if (this._axes[name]) {
			const len = this._axes[name].length;
			for (let i2 = 0; i2 < len; i2++) {
				if (typeof this._axes[name][i2] === "function") {
					const v6 = this._axes[name][i2]();
					if (Math.abs(v6) > Math.abs(value)) {
						value = v6;
					}
				} else if (this._axesValues[name]) {
					if (Math.abs(this._axesValues[name][i2]) > Math.abs(value)) {
						value = this._axesValues[name][i2];
					}
				}
			}
		}
		return value;
	}
	_enableMouse() {
		this._mouse = new Mouse();
		if (!this._element) {
			throw new Error("Controller must be attached to an Element");
		}
		this._mouse.attach(this._element);
	}
	_enableKeyboard() {
		this._keyboard = new Keyboard();
		if (!this._element) {
			throw new Error("Controller must be attached to an Element");
		}
		this._keyboard.attach(this._element);
	}
};

var dummyArray = Object.freeze([]);
var getGamepads = function() {
	return dummyArray;
};
if (typeof navigator !== "undefined") {
	getGamepads = (navigator.getGamepads || navigator.webkitGetGamepads || getGamepads).bind(navigator);
}
var MAPS_INDEXES = {
	buttons: {
		PAD_FACE_1,
		PAD_FACE_2,
		PAD_FACE_3,
		PAD_FACE_4,
		PAD_L_SHOULDER_1,
		PAD_R_SHOULDER_1,
		PAD_L_SHOULDER_2,
		PAD_R_SHOULDER_2,
		PAD_SELECT,
		PAD_START,
		PAD_L_STICK_BUTTON,
		PAD_R_STICK_BUTTON,
		PAD_UP,
		PAD_DOWN,
		PAD_LEFT,
		PAD_RIGHT,
		PAD_VENDOR,
		XRPAD_TRIGGER,
		XRPAD_SQUEEZE,
		XRPAD_TOUCHPAD_BUTTON,
		XRPAD_STICK_BUTTON,
		XRPAD_A,
		XRPAD_B
	},
	axes: {
		PAD_L_STICK_X,
		PAD_L_STICK_Y,
		PAD_R_STICK_X,
		PAD_R_STICK_Y,
		XRPAD_TOUCHPAD_X,
		XRPAD_TOUCHPAD_Y,
		XRPAD_STICK_X,
		XRPAD_STICK_Y
	}
};
var MAPS = {
	DEFAULT: {
		buttons: [
			// Face buttons
			"PAD_FACE_1",
			"PAD_FACE_2",
			"PAD_FACE_3",
			"PAD_FACE_4",
			// Shoulder buttons
			"PAD_L_SHOULDER_1",
			"PAD_R_SHOULDER_1",
			"PAD_L_SHOULDER_2",
			"PAD_R_SHOULDER_2",
			// Other buttons
			"PAD_SELECT",
			"PAD_START",
			"PAD_L_STICK_BUTTON",
			"PAD_R_STICK_BUTTON",
			// D Pad
			"PAD_UP",
			"PAD_DOWN",
			"PAD_LEFT",
			"PAD_RIGHT",
			// Vendor specific button
			"PAD_VENDOR"
		],
		axes: [
			// Analog Sticks
			"PAD_L_STICK_X",
			"PAD_L_STICK_Y",
			"PAD_R_STICK_X",
			"PAD_R_STICK_Y"
		]
	},
	DEFAULT_DUAL: {
		buttons: [
			// Face buttons
			"PAD_FACE_1",
			"PAD_FACE_2",
			"PAD_FACE_3",
			"PAD_FACE_4",
			// Shoulder buttons
			"PAD_L_SHOULDER_1",
			"PAD_R_SHOULDER_1",
			"PAD_L_SHOULDER_2",
			"PAD_R_SHOULDER_2",
			// Other buttons
			"PAD_SELECT",
			"PAD_START",
			"PAD_L_STICK_BUTTON",
			"PAD_R_STICK_BUTTON",
			// Vendor specific button
			"PAD_VENDOR"
		],
		axes: [
			// Analog Sticks
			"PAD_L_STICK_X",
			"PAD_L_STICK_Y",
			"PAD_R_STICK_X",
			"PAD_R_STICK_Y"
		],
		synthesizedButtons: {
			PAD_UP: { axis: 0, min: 0, max: 1 },
			PAD_DOWN: { axis: 0, min: -1, max: 0 },
			PAD_LEFT: { axis: 0, min: -1, max: 0 },
			PAD_RIGHT: { axis: 0, min: 0, max: 1 }
		}
	},
	PS3: {
		buttons: [
			// X, O, TRI, SQ
			"PAD_FACE_1",
			"PAD_FACE_2",
			"PAD_FACE_4",
			"PAD_FACE_3",
			// Shoulder buttons
			"PAD_L_SHOULDER_1",
			"PAD_R_SHOULDER_1",
			"PAD_L_SHOULDER_2",
			"PAD_R_SHOULDER_2",
			// Other buttons
			"PAD_SELECT",
			"PAD_START",
			"PAD_L_STICK_BUTTON",
			"PAD_R_STICK_BUTTON",
			// D Pad
			"PAD_UP",
			"PAD_DOWN",
			"PAD_LEFT",
			"PAD_RIGHT",
			"PAD_VENDOR"
		],
		axes: [
			// Analog Sticks
			"PAD_L_STICK_X",
			"PAD_L_STICK_Y",
			"PAD_R_STICK_X",
			"PAD_R_STICK_Y"
		],
		mapping: "standard"
	},
	DEFAULT_XR: {
		buttons: [
			// Back buttons
			"XRPAD_TRIGGER",
			"XRPAD_SQUEEZE",
			// Axes buttons
			"XRPAD_TOUCHPAD_BUTTON",
			"XRPAD_STICK_BUTTON",
			// Face buttons
			"XRPAD_A",
			"XRPAD_B"
		],
		axes: [
			// Analog Sticks
			"XRPAD_TOUCHPAD_X",
			"XRPAD_TOUCHPAD_Y",
			"XRPAD_STICK_X",
			"XRPAD_STICK_Y"
		],
		mapping: "xr-standard"
	}
};
var PRODUCT_CODES = {
	"Product: 0268": "PS3"
};
var custom_maps = {};
function getMap(pad) {
	const custom = custom_maps[pad.id];
	if (custom) {
		return custom;
	}
	for (const code in PRODUCT_CODES) {
		if (pad.id.indexOf(code) !== -1) {
			const product = PRODUCT_CODES[code];
			if (!pad.mapping) {
				const raw = MAPS[`RAW_${product}`];
				if (raw) {
					return raw;
				}
			}
			return MAPS[product];
		}
	}
	if (pad.mapping === "xr-standard") {
		return MAPS.DEFAULT_XR;
	}
	const defaultmap = MAPS.DEFAULT;
	const map = pad.buttons.length < defaultmap.buttons.length ? MAPS.DEFAULT_DUAL : defaultmap;
	map.mapping = pad.mapping;
	return map;
}
var deadZone = 0.25;
function sleep(ms) {
	return new Promise((resolve2) => {
		setTimeout(resolve2, ms);
	});
}
var GamePadButton = class {
	value = 0;
	pressed = false;
	touched = false;
	wasPressed = false;
	wasReleased = false;
	wasTouched = false;
	constructor(current, previous) {
		if (typeof current === "number") {
			this.value = current;
			this.pressed = current === 1;
			this.touched = current > 0;
		} else {
			this.value = current.value;
			this.pressed = current.pressed;
			this.touched = current.touched ?? current.value > 0;
		}
		if (previous) {
			if (typeof previous === "number") {
				this.wasPressed = previous !== 1 && this.pressed;
				this.wasReleased = previous === 1 && !this.pressed;
				this.wasTouched = previous === 0 && this.touched;
			} else {
				this.wasPressed = !previous.pressed && this.pressed;
				this.wasReleased = previous.pressed && !this.pressed;
				this.wasTouched = !(previous.touched ?? previous.value > 0) && this.touched;
			}
		}
	}
	update(button) {
		const { value, pressed } = button;
		const touched = button.touched ?? value > 0;
		this.wasPressed = !this.pressed && pressed;
		this.wasReleased = this.pressed && !pressed;
		this.wasTouched = !this.touched && touched;
		this.value = value;
		this.pressed = pressed;
		this.touched = touched;
	}
};
var dummyButton = Object.freeze(new GamePadButton(0));
var GamePad = class {
	_compiledMapping = {
		buttons: [],
		axes: []
	};
	id;
	index;
	_buttons;
	_axes;
	_previousAxes;
	mapping;
	map;
	hand;
	pad;
	constructor(gamepad, map) {
		this.id = gamepad.id;
		this.index = gamepad.index;
		this._buttons = gamepad.buttons.map((b) => new GamePadButton(b));
		this._axes = [...gamepad.axes];
		this._previousAxes = [...gamepad.axes];
		this.mapping = map.mapping;
		this.map = map;
		this.hand = gamepad.hand || "none";
		this.pad = gamepad;
		this._compileMapping();
	}
	get connected() {
		return this.pad.connected;
	}
	_compileMapping() {
		const { axes, buttons } = this._compiledMapping;
		const axesIndexes = MAPS_INDEXES.axes;
		const buttonsIndexes = MAPS_INDEXES.buttons;
		axes.length = 0;
		buttons.length = 0;
		const axesMap = this.map.axes;
		if (axesMap) {
			this.map.axes.forEach((axis, i2) => {
				axes[axesIndexes[axis]] = () => this.pad.axes[i2] || 0;
			});
		}
		for (let i2 = 0, l = axes.length; i2 < l; i2++) {
			if (!axes[i2]) {
				axes[i2] = () => 0;
			}
		}
		const buttonsMap = this.map.buttons;
		if (buttonsMap) {
			buttonsMap.forEach((button, i2) => {
				buttons[buttonsIndexes[button]] = () => this._buttons[i2] || dummyButton;
			});
		}
		const synthesizedButtonsMap = this.map.synthesizedButtons;
		if (synthesizedButtonsMap) {
			Object.entries(synthesizedButtonsMap).forEach((button) => {
				const { axis, max, min } = button[1];
				buttons[buttonsIndexes[button[0]]] = () => new GamePadButton(
					Math.abs(math.clamp(this._axes[axis] ?? 0, min, max)),
					Math.abs(math.clamp(this._previousAxes[axis] ?? 0, min, max))
				);
			});
		}
		for (let i2 = 0, l = buttons.length; i2 < l; i2++) {
			if (!buttons[i2]) {
				buttons[i2] = () => dummyButton;
			}
		}
	}
	update(gamepad) {
		this.pad = gamepad;
		const previousAxes = this._previousAxes;
		const axes = this._axes;
		previousAxes.length = 0;
		previousAxes.push(...axes);
		axes.length = 0;
		axes.push(...gamepad.axes);
		const buttons = this._buttons;
		for (let i2 = 0, l = buttons.length; i2 < l; i2++) {
			buttons[i2].update(gamepad.buttons[i2]);
		}
		return this;
	}
	updateMap(map) {
		map.mapping = "custom";
		custom_maps[this.id] = map;
		this.map = map;
		this.mapping = "custom";
		this._compileMapping();
	}
	resetMap() {
		if (custom_maps[this.id]) {
			delete custom_maps[this.id];
			const map = getMap(this.pad);
			this.map = map;
			this.mapping = map.mapping;
			this._compileMapping();
		}
	}
	get axes() {
		return this._compiledMapping.axes.map((a) => a());
	}
	get buttons() {
		return this._compiledMapping.buttons.map((b) => b());
	}
	async pulse(intensity, duration, options2) {
		const actuators = this.pad.vibrationActuator ? [this.pad.vibrationActuator] : this.pad.hapticActuators || dummyArray;
		if (actuators.length) {
			const startDelay = options2?.startDelay ?? 0;
			const strongMagnitude = options2?.strongMagnitude ?? intensity;
			const weakMagnitude = options2?.weakMagnitude ?? intensity;
			const results = await Promise.all(
				actuators.map(async (actuator) => {
					if (!actuator) {
						return true;
					}
					if (actuator.playEffect) {
						return actuator.playEffect(actuator.type, {
							duration,
							startDelay,
							strongMagnitude,
							weakMagnitude
						});
					} else if (actuator.pulse) {
						await sleep(startDelay);
						return actuator.pulse(intensity, duration);
					}
					return false;
				})
			);
			return results.some((r) => r === true || r === "complete");
		}
		return false;
	}
	getButton(index) {
		const button = this._compiledMapping.buttons[index];
		return button ? button() : dummyButton;
	}
	isPressed(button) {
		return this.getButton(button).pressed;
	}
	wasPressed(button) {
		return this.getButton(button).wasPressed;
	}
	wasReleased(button) {
		return this.getButton(button).wasReleased;
	}
	isTouched(button) {
		return this.getButton(button).touched;
	}
	wasTouched(button) {
		return this.getButton(button).wasTouched;
	}
	getValue(button) {
		return this.getButton(button).value;
	}
	getAxis(axis) {
		const a = this.axes[axis];
		return a && Math.abs(a) > deadZone ? a : 0;
	}
};
var GamePads = class extends EventHandler {
	static EVENT_GAMEPADCONNECTED = "gamepadconnected";
	static EVENT_GAMEPADDISCONNECTED = "gamepaddisconnected";
	gamepadsSupported;
	current = [];
	_ongamepadconnectedHandler;
	_ongamepaddisconnectedHandler;
	constructor() {
		super();
		this.gamepadsSupported = platform.gamepads;
		this._ongamepadconnectedHandler = this._ongamepadconnected.bind(this);
		this._ongamepaddisconnectedHandler = this._ongamepaddisconnected.bind(this);
		window.addEventListener("gamepadconnected", this._ongamepadconnectedHandler, false);
		window.addEventListener("gamepaddisconnected", this._ongamepaddisconnectedHandler, false);
		this.poll();
	}
	set deadZone(value) {
		deadZone = value;
	}
	get deadZone() {
		return deadZone;
	}
	_ongamepadconnected(event) {
		const pad = new GamePad(event.gamepad, this.getMap(event.gamepad));
		const current = this.current;
		let padIndex = current.findIndex((gp) => gp.index === pad.index);
		while (padIndex !== -1) {
			current.splice(padIndex, 1);
			padIndex = current.findIndex((gp) => gp.index === pad.index);
		}
		current.push(pad);
		this.fire("gamepadconnected", pad);
	}
	_ongamepaddisconnected(event) {
		const current = this.current;
		const padIndex = current.findIndex((gp) => gp.index === event.gamepad.index);
		if (padIndex !== -1) {
			this.fire("gamepaddisconnected", current[padIndex]);
			current.splice(padIndex, 1);
		}
	}
	update() {
		this.poll();
	}
	poll(pads = []) {
		if (pads.length > 0) {
			pads.length = 0;
		}
		const padDevices = getGamepads();
		for (let i2 = 0, len = padDevices.length; i2 < len; i2++) {
			if (padDevices[i2]) {
				const pad = this.findByIndex(padDevices[i2].index);
				if (pad) {
					pads.push(pad.update(padDevices[i2]));
				} else {
					const nPad = new GamePad(padDevices[i2], this.getMap(padDevices[i2]));
					this.current.push(nPad);
					pads.push(nPad);
				}
			}
		}
		return pads;
	}
	destroy() {
		window.removeEventListener("gamepadconnected", this._ongamepadconnectedHandler, false);
		window.removeEventListener("gamepaddisconnected", this._ongamepaddisconnectedHandler, false);
	}
	getMap(pad) {
		return getMap(pad);
	}
	isPressed(orderIndex, button) {
		return this.current[orderIndex]?.isPressed(button) || false;
	}
	wasPressed(orderIndex, button) {
		return this.current[orderIndex]?.wasPressed(button) || false;
	}
	wasReleased(orderIndex, button) {
		return this.current[orderIndex]?.wasReleased(button) || false;
	}
	getAxis(orderIndex, axis) {
		return this.current[orderIndex]?.getAxis(axis) || 0;
	}
	pulse(orderIndex, intensity, duration, options2) {
		const pad = this.current[orderIndex];
		return pad ? pad.pulse(intensity, duration, options2) : Promise.resolve(false);
	}
	pulseAll(intensity, duration, options2) {
		return Promise.all(
			this.current.map((pad) => pad.pulse(intensity, duration, options2))
		);
	}
	findById(id14) {
		return this.current.find((gp) => gp && gp.id === id14) || null;
	}
	findByIndex(index) {
		return this.current.find((gp) => gp && gp.index === index) || null;
	}
};

function getTouchTargetCoords(touch2) {
	let totalOffsetX = 0;
	let totalOffsetY = 0;
	let target2 = touch2.target;
	while (!(target2 instanceof HTMLElement) && target2) {
		target2 = target2.parentNode;
	}
	while (target2) {
		totalOffsetX += target2.offsetLeft - target2.scrollLeft;
		totalOffsetY += target2.offsetTop - target2.scrollTop;
		target2 = target2.offsetParent;
	}
	return {
		x: touch2.pageX - totalOffsetX,
		y: touch2.pageY - totalOffsetY
	};
}
var Touch = class {
	id;
	x;
	y;
	target;
	touch;
	constructor(touch2) {
		const coords = getTouchTargetCoords(touch2);
		this.id = touch2.identifier;
		this.x = coords.x;
		this.y = coords.y;
		this.target = touch2.target;
		this.touch = touch2;
	}
};
var TouchEvent = class {
	element;
	event;
	touches = [];
	changedTouches = [];
	constructor(device, event) {
		this.element = event.target;
		this.event = event;
		this.touches = Array.from(event.touches).map((touch2) => new Touch(touch2));
		this.changedTouches = Array.from(event.changedTouches).map((touch2) => new Touch(touch2));
	}
	getTouchById(id14, list) {
		return list.find((touch2) => touch2.id === id14) || null;
	}
};

var TouchDevice = class extends EventHandler {
	static EVENT_TOUCHSTART = "touchstart";
	static EVENT_TOUCHEND = "touchend";
	static EVENT_TOUCHMOVE = "touchmove";
	static EVENT_TOUCHCANCEL = "touchcancel";
	_element = null;
	_startHandler;
	_endHandler;
	_moveHandler;
	_cancelHandler;
	constructor(element) {
		super();
		this._startHandler = this._handleTouchStart.bind(this);
		this._endHandler = this._handleTouchEnd.bind(this);
		this._moveHandler = this._handleTouchMove.bind(this);
		this._cancelHandler = this._handleTouchCancel.bind(this);
		this.attach(element);
	}
	attach(element) {
		if (this._element) {
			this.detach();
		}
		this._element = element;
		this._element.addEventListener("touchstart", this._startHandler, false);
		this._element.addEventListener("touchend", this._endHandler, false);
		this._element.addEventListener("touchmove", this._moveHandler, false);
		this._element.addEventListener("touchcancel", this._cancelHandler, false);
	}
	detach() {
		if (this._element) {
			this._element.removeEventListener("touchstart", this._startHandler, false);
			this._element.removeEventListener("touchend", this._endHandler, false);
			this._element.removeEventListener("touchmove", this._moveHandler, false);
			this._element.removeEventListener("touchcancel", this._cancelHandler, false);
		}
		this._element = null;
	}
	_handleTouchStart(e) {
		this.fire("touchstart", new TouchEvent(this, e));
	}
	_handleTouchEnd(e) {
		this.fire("touchend", new TouchEvent(this, e));
	}
	_handleTouchMove(e) {
		e.preventDefault();
		this.fire("touchmove", new TouchEvent(this, e));
	}
	_handleTouchCancel(e) {
		this.fire("touchcancel", new TouchEvent(this, e));
	}
};

var Http = class _Http {
	static ContentType = {
		AAC: "audio/aac",
		BASIS: "image/basis",
		BIN: "application/octet-stream",
		DDS: "image/dds",
		FORM_URLENCODED: "application/x-www-form-urlencoded",
		GIF: "image/gif",
		GLB: "model/gltf-binary",
		JPEG: "image/jpeg",
		JSON: "application/json",
		MP3: "audio/mpeg",
		MP4: "audio/mp4",
		OGG: "audio/ogg",
		OPUS: 'audio/ogg; codecs="opus"',
		PNG: "image/png",
		TEXT: "text/plain",
		WAV: "audio/x-wav",
		XML: "application/xml"
	};
	static ResponseType = {
		TEXT: "text",
		ARRAY_BUFFER: "arraybuffer",
		BLOB: "blob",
		DOCUMENT: "document",
		JSON: "json"
	};
	static binaryExtensions = [
		".model",
		".wav",
		".ogg",
		".mp3",
		".mp4",
		".m4a",
		".aac",
		".dds",
		".basis",
		".glb",
		".opus"
	];
	static retryDelay = 100;
	withCredentials = false;
	_maxConcurrentRequests = 128;
	_activeRequests = 0;
	_sendQueue = [];
	_sendQueueHead = 0;
	set maxConcurrentRequests(value) {
		this._maxConcurrentRequests = value;
		this._pump();
	}
	get maxConcurrentRequests() {
		return this._maxConcurrentRequests;
	}
	get(url, options2, callback) {
		if (typeof options2 === "function") {
			callback = options2;
			options2 = {};
		}
		const result = this.request("GET", url, options2, callback);
		const { progress } = options2;
		if (progress) {
			const handler = (event) => {
				if (event.lengthComputable) {
					progress.fire("progress", event.loaded, event.total);
				}
			};
			const endHandler = (event) => {
				handler(event);
				result.removeEventListener("loadstart", handler);
				result.removeEventListener("progress", handler);
				result.removeEventListener("loadend", endHandler);
			};
			result.addEventListener("loadstart", handler);
			result.addEventListener("progress", handler);
			result.addEventListener("loadend", endHandler);
		}
		return result;
	}
	post(url, data2, options2, callback) {
		if (typeof options2 === "function") {
			callback = options2;
			options2 = {};
		}
		options2.postdata = data2;
		return this.request("POST", url, options2, callback);
	}
	put(url, data2, options2, callback) {
		if (typeof options2 === "function") {
			callback = options2;
			options2 = {};
		}
		options2.postdata = data2;
		return this.request("PUT", url, options2, callback);
	}
	del(url, options2, callback) {
		if (typeof options2 === "function") {
			callback = options2;
			options2 = {};
		}
		return this.request("DELETE", url, options2, callback);
	}
	request(method, url, options2, callback) {
		let uri, query, postdata;
		let errored = false;
		if (typeof options2 === "function") {
			callback = options2;
			options2 = {};
		}
		if (options2.retry) {
			options2 = Object.assign({
				retries: 0,
				maxRetries: 5
			}, options2);
		}
		options2.callback = callback;
		if (options2.async == null) {
			options2.async = true;
		}
		if (options2.headers == null) {
			options2.headers = {};
		}
		if (options2.postdata != null) {
			if (options2.postdata instanceof Document) {
				postdata = options2.postdata;
			} else if (options2.postdata instanceof FormData) {
				postdata = options2.postdata;
			} else if (options2.postdata instanceof Object) {
				let contentType = options2.headers["Content-Type"];
				if (contentType === void 0) {
					options2.headers["Content-Type"] = _Http.ContentType.FORM_URLENCODED;
					contentType = options2.headers["Content-Type"];
				}
				switch (contentType) {
					case _Http.ContentType.FORM_URLENCODED: {
						postdata = "";
						let bFirstItem = true;
						for (const key in options2.postdata) {
							if (options2.postdata.hasOwnProperty(key)) {
								if (bFirstItem) {
									bFirstItem = false;
								} else {
									postdata += "&";
								}
								const encodedKey = encodeURIComponent(key);
								const encodedValue = encodeURIComponent(options2.postdata[key]);
								postdata += `${encodedKey}=${encodedValue}`;
							}
						}
						break;
					}
					default:
					case _Http.ContentType.JSON:
						if (contentType == null) {
							options2.headers["Content-Type"] = _Http.ContentType.JSON;
						}
						postdata = JSON.stringify(options2.postdata);
						break;
				}
			} else {
				postdata = options2.postdata;
			}
		}
		if (options2.cache === false) {
			const timestamp = now();
			uri = new URI(url);
			if (!uri.query) {
				uri.query = `ts=${timestamp}`;
			} else {
				uri.query = `${uri.query}&ts=${timestamp}`;
			}
			url = uri.toString();
		}
		if (options2.query) {
			uri = new URI(url);
			query = extend(uri.getQuery(), options2.query);
			uri.setQuery(query);
			url = uri.toString();
		}
		const xhr = new XMLHttpRequest();
		xhr.open(method, url, options2.async);
		xhr.withCredentials = options2.withCredentials !== void 0 ? options2.withCredentials : this.withCredentials;
		xhr.responseType = options2.responseType || this._guessResponseType(url);
		for (const header2 in options2.headers) {
			if (options2.headers.hasOwnProperty(header2)) {
				xhr.setRequestHeader(header2, options2.headers[header2]);
			}
		}
		xhr.onreadystatechange = () => {
			this._onReadyStateChange(method, url, options2, xhr);
		};
		xhr.onerror = () => {
			this._onError(method, url, options2, xhr);
			errored = true;
		};
		const send = () => {
			try {
				xhr.send(postdata);
			} catch (e) {
				this._releaseSlot(xhr);
				if (!errored && typeof options2.error === "function") {
					options2.error(xhr.status, xhr, e);
				}
			}
		};
		this._acquire(xhr, options2, send);
		return xhr;
	}
	_guessResponseType(url) {
		const uri = new URI(url);
		const ext = path.getExtension(uri.path).toLowerCase();
		if (_Http.binaryExtensions.indexOf(ext) >= 0) {
			return _Http.ResponseType.ARRAY_BUFFER;
		} else if (ext === ".json") {
			return _Http.ResponseType.JSON;
		} else if (ext === ".xml") {
			return _Http.ResponseType.DOCUMENT;
		}
		return _Http.ResponseType.TEXT;
	}
	_isBinaryContentType(contentType) {
		const binTypes = [
			_Http.ContentType.BASIS,
			_Http.ContentType.BIN,
			_Http.ContentType.DDS,
			_Http.ContentType.GLB,
			_Http.ContentType.MP3,
			_Http.ContentType.MP4,
			_Http.ContentType.OGG,
			_Http.ContentType.OPUS,
			_Http.ContentType.WAV
		];
		if (binTypes.indexOf(contentType) >= 0) {
			return true;
		}
		return false;
	}
	_isBinaryResponseType(responseType) {
		return responseType === _Http.ResponseType.ARRAY_BUFFER || responseType === _Http.ResponseType.BLOB || responseType === _Http.ResponseType.JSON;
	}
	_onReadyStateChange(method, url, options2, xhr) {
		if (xhr.readyState === 4) {
			switch (xhr.status) {
				case 0: {
					if (xhr.responseURL && xhr.responseURL.startsWith("file:///")) {
						this._onSuccess(method, url, options2, xhr);
					} else {
						this._onError(method, url, options2, xhr);
					}
					break;
				}
				case 200:
				case 201:
				case 206:
				case 304: {
					this._onSuccess(method, url, options2, xhr);
					break;
				}
				default: {
					this._onError(method, url, options2, xhr);
					break;
				}
			}
		}
	}
	_onSuccess(method, url, options2, xhr) {
		this._releaseSlot(xhr);
		let response;
		let contentType;
		const header2 = xhr.getResponseHeader("Content-Type");
		if (header2) {
			const parts = header2.split(";");
			contentType = parts[0].trim();
		}
		try {
			if (this._isBinaryContentType(contentType) || this._isBinaryResponseType(xhr.responseType)) {
				response = xhr.response;
			} else if (contentType === _Http.ContentType.JSON || url.split("?")[0].endsWith(".json")) {
				response = JSON.parse(xhr.responseText);
			} else if (xhr.responseType === _Http.ResponseType.DOCUMENT || contentType === _Http.ContentType.XML) {
				response = xhr.responseXML;
			} else {
				response = xhr.responseText;
			}
			options2.callback(null, response);
		} catch (err2) {
			options2.callback(err2);
		}
	}
	_onError(method, url, options2, xhr) {
		this._releaseSlot(xhr);
		if (options2.retrying) {
			return;
		}
		if (options2.retry && options2.retries < options2.maxRetries) {
			options2.retries++;
			options2.retrying = true;
			const retryDelay = math.clamp(Math.pow(2, options2.retries) * _Http.retryDelay, 0, options2.maxRetryDelay || 5e3);
			console.log(`${method}: ${url} - Error ${xhr.status}. Retrying in ${retryDelay} ms`);
			setTimeout(() => {
				options2.retrying = false;
				this.request(method, url, options2, options2.callback);
			}, retryDelay);
		} else {
			options2.callback(xhr.status === 0 ? "Network error" : xhr.status, null);
		}
	}
	_acquire(xhr, options2, send) {
		const limit = this._maxConcurrentRequests;
		const throttled = limit > 0 && Number.isFinite(limit) && options2.async !== false;
		if (!throttled || this._activeRequests < limit) {
			if (throttled) {
				this._activeRequests++;
				xhr._slotHeld = true;
			}
			send();
		} else {
			this._sendQueue.push({ xhr, send });
		}
	}
	_releaseSlot(xhr) {
		if (xhr._slotHeld) {
			xhr._slotHeld = false;
			this._activeRequests--;
			this._pump();
		}
	}
	_pump() {
		const limit = this._maxConcurrentRequests;
		const throttled = limit > 0 && Number.isFinite(limit);
		if (!throttled) {
			while (this._sendQueueHead < this._sendQueue.length) {
				this._sendQueue[this._sendQueueHead++].send();
			}
		} else {
			while (this._sendQueueHead < this._sendQueue.length && this._activeRequests < limit) {
				const { xhr, send } = this._sendQueue[this._sendQueueHead++];
				this._activeRequests++;
				xhr._slotHeld = true;
				send();
			}
		}
		if (this._sendQueueHead === this._sendQueue.length) {
			this._sendQueue.length = 0;
			this._sendQueueHead = 0;
		} else if (this._sendQueueHead > 256) {
			this._sendQueue = this._sendQueue.slice(this._sendQueueHead);
			this._sendQueueHead = 0;
		}
	}
};
var http = new Http();

var DISTANCE_LINEAR = "linear";
var DISTANCE_INVERSE = "inverse";
var DISTANCE_EXPONENTIAL = "exponential";

var Listener = class {
	_manager;
	position = new Vec3();
	orientation = new Mat4();
	constructor(manager) {
		this._manager = manager;
	}
	getPosition() {
		return this.position;
	}
	setPosition(position5) {
		this.position.copy(position5);
		const listener = this.listener;
		if (listener) {
			if ("positionX" in listener) {
				listener.positionX.value = position5.x;
				listener.positionY.value = position5.y;
				listener.positionZ.value = position5.z;
			} else if (listener.setPosition) {
				listener.setPosition(position5.x, position5.y, position5.z);
			}
		}
	}
	setOrientation(orientation) {
		this.orientation.copy(orientation);
		const listener = this.listener;
		if (listener) {
			const m = orientation.data;
			if ("forwardX" in listener) {
				listener.forwardX.value = -m[8];
				listener.forwardY.value = -m[9];
				listener.forwardZ.value = -m[10];
				listener.upX.value = m[4];
				listener.upY.value = m[5];
				listener.upZ.value = m[6];
			} else if (listener.setOrientation) {
				listener.setOrientation(-m[8], -m[9], -m[10], m[4], m[5], m[6]);
			}
		}
	}
	getOrientation() {
		return this.orientation;
	}
	get listener() {
		const context = this._manager.context;
		return context ? context.listener : null;
	}
};

var CONTEXT_STATE_RUNNING = "running";
var USER_INPUT_EVENTS = [
	"click",
	"touchstart",
	"mousedown"
];
var SoundManager = class extends EventHandler {
	_context = null;
	_unlockHandlerFunc;
	_userSuspended = false;
	listener;
	_volume = 1;
	constructor() {
		super();
		this._unlockHandlerFunc = this._unlockHandler.bind(this);
		this.listener = new Listener(this);
	}
	set volume(volume) {
		volume = math.clamp(volume, 0, 1);
		this._volume = volume;
		this.fire("volumechange", volume);
	}
	get volume() {
		return this._volume;
	}
	get suspended() {
		return this._userSuspended;
	}
	get context() {
		if (!this._context) {
			const AudioContextCtor = typeof AudioContext !== "undefined" && AudioContext || typeof webkitAudioContext !== "undefined" && webkitAudioContext;
			if (!AudioContextCtor) {
				return null;
			}
			this._context = new AudioContextCtor();
			if (this._context.state !== CONTEXT_STATE_RUNNING) {
				this._registerUnlockListeners();
			}
		}
		return this._context;
	}
	suspend() {
		if (!this._userSuspended) {
			this._userSuspended = true;
			if (this._context && this._context.state === CONTEXT_STATE_RUNNING) {
				this._suspend();
			}
		}
	}
	resume() {
		if (this._userSuspended) {
			this._userSuspended = false;
			if (this._context && this._context.state !== CONTEXT_STATE_RUNNING) {
				this._resume();
			}
		}
	}
	destroy() {
		this.fire("destroy");
		const context = this._context;
		if (context) {
			this._removeUnlockListeners();
			context.close();
			this._context = null;
		}
	}
	// resume the sound context
	_resume() {
		const context = this._context;
		if (!context) return;
		context.resume().then(() => {
			const source = context.createBufferSource();
			source.buffer = context.createBuffer(1, 1, context.sampleRate);
			source.connect(context.destination);
			source.start(0);
			source.onended = (event) => {
				source.disconnect(0);
				this.fire("resume");
			};
		}, (e) => {
		}).catch((e) => {
		});
	}
	// resume the sound context and fire suspend event if it succeeds
	_suspend() {
		const context = this._context;
		if (!context) return;
		context.suspend().then(() => {
			this.fire("suspend");
		}, (e) => {
		}).catch((e) => {
		});
	}
	_unlockHandler() {
		this._removeUnlockListeners();
		if (!this._userSuspended && this._context && this._context.state !== CONTEXT_STATE_RUNNING) {
			this._resume();
		}
	}
	_registerUnlockListeners() {
		USER_INPUT_EVENTS.forEach((eventName) => {
			window.addEventListener(eventName, this._unlockHandlerFunc, false);
		});
	}
	_removeUnlockListeners() {
		USER_INPUT_EVENTS.forEach((eventName) => {
			window.removeEventListener(eventName, this._unlockHandlerFunc, false);
		});
	}
};

var Sound = class {
	buffer;
	constructor(buffer) {
		this.buffer = buffer;
	}
	get duration() {
		return this.buffer && this.buffer.duration || 0;
	}
};

var STATE_PLAYING = 0;
var STATE_PAUSED = 1;
var STATE_STOPPED = 2;
function capTime(time, duration) {
	return time % duration || 0;
}
var SoundInstance = class extends EventHandler {
	static EVENT_PLAY = "play";
	static EVENT_PAUSE = "pause";
	static EVENT_RESUME = "resume";
	static EVENT_STOP = "stop";
	static EVENT_END = "end";
	source = null;
	constructor(manager, sound, options2) {
		super();
		this._manager = manager;
		this._volume = options2.volume !== void 0 ? math.clamp(Number(options2.volume) || 0, 0, 1) : 1;
		this._pitch = options2.pitch !== void 0 ? Math.max(0.01, Number(options2.pitch) || 0) : 1;
		this._loop = !!(options2.loop !== void 0 ? options2.loop : false);
		this._sound = sound;
		this._state = STATE_STOPPED;
		this._suspended = false;
		this._suspendEndEvent = 0;
		this._suspendInstanceEvents = false;
		this._playWhenLoaded = true;
		this._startTime = Math.max(0, Number(options2.startTime) || 0);
		this._duration = Math.max(0, Number(options2.duration) || 0);
		this._startOffset = null;
		this._onPlayCallback = options2.onPlay;
		this._onPauseCallback = options2.onPause;
		this._onResumeCallback = options2.onResume;
		this._onStopCallback = options2.onStop;
		this._onEndCallback = options2.onEnd;
		this._startedAt = 0;
		this._currentTime = 0;
		this._currentOffset = 0;
		this._inputNode = null;
		this._connectorNode = null;
		this._firstNode = null;
		this._lastNode = null;
		this._waitingContextSuspension = false;
		if (!this._manager.context) {
			return;
		}
		this._initializeNodes();
		this._endedHandler = this._onEnded.bind(this);
	}
	set currentTime(value) {
		if (value < 0) return;
		if (this._state === STATE_PLAYING) {
			const suspend = this._suspendInstanceEvents;
			this._suspendInstanceEvents = true;
			this.stop();
			this._startOffset = value;
			this.play();
			this._suspendInstanceEvents = suspend;
		} else {
			this._startOffset = value;
			this._currentTime = value;
		}
	}
	get currentTime() {
		if (this._startOffset !== null) {
			return this._startOffset;
		}
		if (this._state === STATE_PAUSED) {
			return this._currentTime;
		}
		if (this._state === STATE_STOPPED || !this.source) {
			return 0;
		}
		this._updateCurrentTime();
		return this._currentTime;
	}
	set duration(value) {
		this._duration = Math.max(0, Number(value) || 0);
		const isPlaying = this._state === STATE_PLAYING;
		this.stop();
		if (isPlaying) {
			this.play();
		}
	}
	get duration() {
		if (!this._sound) {
			return 0;
		}
		if (this._duration) {
			return capTime(this._duration, this._sound.duration);
		}
		return this._sound.duration;
	}
	get isPaused() {
		return this._state === STATE_PAUSED;
	}
	get isPlaying() {
		return this._state === STATE_PLAYING;
	}
	get isStopped() {
		return this._state === STATE_STOPPED;
	}
	get isSuspended() {
		return this._suspended;
	}
	set loop(value) {
		this._loop = !!value;
		if (this.source) {
			this.source.loop = this._loop;
		}
	}
	get loop() {
		return this._loop;
	}
	set pitch(pitch) {
		if (this._manager.context) {
			this._currentOffset = this.currentTime;
			this._startedAt = this._manager.context.currentTime;
		}
		this._pitch = Math.max(Number(pitch) || 0, 0.01);
		if (this.source) {
			this.source.playbackRate.value = this._pitch;
		}
	}
	get pitch() {
		return this._pitch;
	}
	set sound(value) {
		this._sound = value;
		if (this._state !== STATE_STOPPED) {
			this.stop();
		} else {
			this._createSource();
		}
	}
	get sound() {
		return this._sound;
	}
	set startTime(value) {
		this._startTime = Math.max(0, Number(value) || 0);
		const isPlaying = this._state === STATE_PLAYING;
		this.stop();
		if (isPlaying) {
			this.play();
		}
	}
	get startTime() {
		return this._startTime;
	}
	set volume(volume) {
		volume = math.clamp(volume, 0, 1);
		this._volume = volume;
		if (this.gain) {
			this.gain.gain.value = volume * this._manager.volume;
		}
	}
	get volume() {
		return this._volume;
	}
	_onPlay() {
		this.fire("play");
		if (this._onPlayCallback) {
			this._onPlayCallback(this);
		}
	}
	_onPause() {
		this.fire("pause");
		if (this._onPauseCallback) {
			this._onPauseCallback(this);
		}
	}
	_onResume() {
		this.fire("resume");
		if (this._onResumeCallback) {
			this._onResumeCallback(this);
		}
	}
	_onStop() {
		this.fire("stop");
		if (this._onStopCallback) {
			this._onStopCallback(this);
		}
	}
	_onEnded() {
		if (this._suspendEndEvent > 0) {
			this._suspendEndEvent--;
			return;
		}
		this.fire("end");
		if (this._onEndCallback) {
			this._onEndCallback(this);
		}
		this.stop();
	}
	_onManagerVolumeChange() {
		this.volume = this._volume;
	}
	_onManagerSuspend() {
		if (this._state === STATE_PLAYING && !this._suspended) {
			this._suspended = true;
			this.pause();
		}
	}
	_onManagerResume() {
		if (this._suspended) {
			this._suspended = false;
			this.resume();
		}
	}
	_initializeNodes() {
		this.gain = this._manager.context.createGain();
		this._inputNode = this.gain;
		this._connectorNode = this.gain;
		this._connectorNode.connect(this._manager.context.destination);
	}
	play() {
		if (!this._manager.context) {
			return false;
		}
		if (this._state !== STATE_STOPPED) {
			this.stop();
		}
		this._state = STATE_PLAYING;
		this._playWhenLoaded = false;
		if (this._waitingContextSuspension) {
			return false;
		}
		if (this._manager.suspended) {
			this._manager.once("resume", this._playAudioImmediate, this);
			this._waitingContextSuspension = true;
			return false;
		}
		this._playAudioImmediate();
		return true;
	}
	_playAudioImmediate() {
		this._waitingContextSuspension = false;
		if (this._state !== STATE_PLAYING) {
			return;
		}
		if (!this.source) {
			this._createSource();
		}
		let offset3 = capTime(this._startOffset, this.duration);
		offset3 = capTime(this._startTime + offset3, this._sound.duration);
		this._startOffset = null;
		if (this._duration) {
			this.source.start(0, offset3, this._duration);
		} else {
			this.source.start(0, offset3);
		}
		this._startedAt = this._manager.context.currentTime;
		this._currentTime = 0;
		this._currentOffset = offset3;
		this.volume = this._volume;
		this.loop = this._loop;
		this.pitch = this._pitch;
		this._manager.on("volumechange", this._onManagerVolumeChange, this);
		this._manager.on("suspend", this._onManagerSuspend, this);
		this._manager.on("resume", this._onManagerResume, this);
		this._manager.on("destroy", this._onManagerDestroy, this);
		if (!this._suspendInstanceEvents) {
			this._onPlay();
		}
	}
	pause() {
		this._playWhenLoaded = false;
		if (this._state !== STATE_PLAYING) {
			return false;
		}
		this._state = STATE_PAUSED;
		if (this._waitingContextSuspension) {
			return true;
		}
		this._updateCurrentTime();
		this._suspendEndEvent++;
		this.source.stop(0);
		this.source = null;
		this._startOffset = null;
		if (!this._suspendInstanceEvents) {
			this._onPause();
		}
		return true;
	}
	resume() {
		if (this._state !== STATE_PAUSED) {
			return false;
		}
		let offset3 = this.currentTime;
		this._state = STATE_PLAYING;
		if (this._waitingContextSuspension) {
			return true;
		}
		if (!this.source) {
			this._createSource();
		}
		if (this._startOffset !== null) {
			offset3 = capTime(this._startOffset, this.duration);
			offset3 = capTime(this._startTime + offset3, this._sound.duration);
			this._startOffset = null;
		}
		if (this._duration) {
			this.source.start(0, offset3, this._duration);
		} else {
			this.source.start(0, offset3);
		}
		this._startedAt = this._manager.context.currentTime;
		this._currentOffset = offset3;
		this.volume = this._volume;
		this.loop = this._loop;
		this.pitch = this._pitch;
		this._playWhenLoaded = false;
		if (!this._suspendInstanceEvents) {
			this._onResume();
		}
		return true;
	}
	stop() {
		this._playWhenLoaded = false;
		if (this._state === STATE_STOPPED) {
			return false;
		}
		const wasPlaying = this._state === STATE_PLAYING;
		this._state = STATE_STOPPED;
		if (this._waitingContextSuspension) {
			return true;
		}
		this._manager.off("volumechange", this._onManagerVolumeChange, this);
		this._manager.off("suspend", this._onManagerSuspend, this);
		this._manager.off("resume", this._onManagerResume, this);
		this._manager.off("destroy", this._onManagerDestroy, this);
		this._startedAt = 0;
		this._currentTime = 0;
		this._currentOffset = 0;
		this._startOffset = null;
		this._suspendEndEvent++;
		if (wasPlaying && this.source) {
			this.source.stop(0);
		}
		this.source = null;
		if (!this._suspendInstanceEvents) {
			this._onStop();
		}
		return true;
	}
	setExternalNodes(firstNode, lastNode) {
		if (!firstNode) {
			console.error("The firstNode must be a valid Audio Node");
			return;
		}
		if (!this._connectorNode) {
			return;
		}
		if (!lastNode) {
			lastNode = firstNode;
		}
		const speakers = this._manager.context.destination;
		if (this._firstNode !== firstNode) {
			if (this._firstNode) {
				this._connectorNode.disconnect(this._firstNode);
			} else {
				this._connectorNode.disconnect(speakers);
			}
			this._firstNode = firstNode;
			this._connectorNode.connect(firstNode);
		}
		if (this._lastNode !== lastNode) {
			if (this._lastNode) {
				this._lastNode.disconnect(speakers);
			}
			this._lastNode = lastNode;
			this._lastNode.connect(speakers);
		}
	}
	clearExternalNodes() {
		if (!this._connectorNode) {
			return;
		}
		const speakers = this._manager.context.destination;
		if (this._firstNode) {
			this._connectorNode.disconnect(this._firstNode);
			this._firstNode = null;
		}
		if (this._lastNode) {
			this._lastNode.disconnect(speakers);
			this._lastNode = null;
		}
		this._connectorNode.connect(speakers);
	}
	getExternalNodes() {
		return [this._firstNode, this._lastNode];
	}
	_createSource() {
		if (!this._sound) {
			return null;
		}
		const context = this._manager.context;
		if (!context) {
			return null;
		}
		if (this._sound.buffer) {
			this.source = context.createBufferSource();
			this.source.buffer = this._sound.buffer;
			this.source.connect(this._inputNode);
			this.source.onended = this._endedHandler;
			this.source.loopStart = capTime(this._startTime, this.source.buffer.duration);
			if (this._duration) {
				this.source.loopEnd = Math.max(this.source.loopStart, capTime(this._startTime + this._duration, this.source.buffer.duration));
			}
		}
		return this.source;
	}
	_updateCurrentTime() {
		this._currentTime = capTime((this._manager.context.currentTime - this._startedAt) * this._pitch + this._currentOffset, this.duration);
	}
	_onManagerDestroy() {
		if (this.source && this._state === STATE_PLAYING) {
			this.source.stop(0);
			this.source = null;
		}
	}
};

var MAX_DISTANCE = 1e4;
var SoundInstance3d = class extends SoundInstance {
	_position = new Vec3();
	_velocity = new Vec3();
	constructor(manager, sound, options2 = {}) {
		super(manager, sound, options2);
		if (!manager.context) {
			return;
		}
		if (options2.position) {
			this.position = options2.position;
		}
		this.maxDistance = options2.maxDistance !== void 0 ? Number(options2.maxDistance) : MAX_DISTANCE;
		this.refDistance = options2.refDistance !== void 0 ? Number(options2.refDistance) : 1;
		this.rollOffFactor = options2.rollOffFactor !== void 0 ? Number(options2.rollOffFactor) : 1;
		this.distanceModel = options2.distanceModel !== void 0 ? options2.distanceModel : DISTANCE_LINEAR;
	}
	_initializeNodes() {
		this.gain = this._manager.context.createGain();
		this.panner = this._manager.context.createPanner();
		this.panner.connect(this.gain);
		this._inputNode = this.panner;
		this._connectorNode = this.gain;
		this._connectorNode.connect(this._manager.context.destination);
	}
	set position(value) {
		this._position.copy(value);
		const panner = this.panner;
		if (!panner) {
			return;
		}
		if ("positionX" in panner) {
			panner.positionX.value = value.x;
			panner.positionY.value = value.y;
			panner.positionZ.value = value.z;
		} else if (panner.setPosition) {
			panner.setPosition(value.x, value.y, value.z);
		}
	}
	get position() {
		return this._position;
	}
	set velocity(velocity) {
		this._velocity.copy(velocity);
	}
	get velocity() {
		return this._velocity;
	}
	set maxDistance(value) {
		if (this.panner) {
			this.panner.maxDistance = value;
		}
	}
	get maxDistance() {
		return this.panner ? this.panner.maxDistance : 0;
	}
	set refDistance(value) {
		if (this.panner) {
			this.panner.refDistance = value;
		}
	}
	get refDistance() {
		return this.panner ? this.panner.refDistance : 0;
	}
	set rollOffFactor(value) {
		if (this.panner) {
			this.panner.rolloffFactor = value;
		}
	}
	get rollOffFactor() {
		return this.panner ? this.panner.rolloffFactor : 0;
	}
	set distanceModel(value) {
		if (this.panner) {
			this.panner.distanceModel = value;
		}
	}
	get distanceModel() {
		return this.panner ? this.panner.distanceModel : DISTANCE_LINEAR;
	}
};

var BLEND_SUBTRACTIVE = 0;
var BLEND_ADDITIVE = 1;
var BLEND_NORMAL = 2;
var BLEND_NONE = 3;
var BLEND_PREMULTIPLIED = 4;
var BLEND_MULTIPLICATIVE = 5;
var BLEND_ADDITIVEALPHA = 6;
var BLEND_MULTIPLICATIVE2X = 7;
var BLEND_SCREEN = 8;
var BLEND_MIN = 9;
var BLEND_MAX = 10;
var blendNames = {
	[BLEND_SUBTRACTIVE]: "SUBTRACTIVE",
	[BLEND_ADDITIVE]: "ADDITIVE",
	[BLEND_NORMAL]: "NORMAL",
	[BLEND_NONE]: "NONE",
	[BLEND_PREMULTIPLIED]: "PREMULTIPLIED",
	[BLEND_MULTIPLICATIVE]: "MULTIPLICATIVE",
	[BLEND_ADDITIVEALPHA]: "ADDITIVEALPHA",
	[BLEND_MULTIPLICATIVE2X]: "MULTIPLICATIVE2X",
	[BLEND_SCREEN]: "SCREEN",
	[BLEND_MIN]: "MIN",
	[BLEND_MAX]: "MAX"
};
var FOG_NONE = "none";
var FOG_LINEAR = "linear";
var FOG_EXP = "exp";
var FOG_EXP2 = "exp2";
var FRESNEL_NONE = 0;
var FRESNEL_SCHLICK = 2;
var fresnelNames = {
	[FRESNEL_NONE]: "NONE",
	[FRESNEL_SCHLICK]: "SCHLICK"
};
var LAYER_HUD = 0;
var LAYER_GIZMO = 1;
var LAYER_WORLD = 15;
var LAYERID_WORLD = 0;
var LAYERID_DEPTH = 1;
var LAYERID_SKYBOX = 2;
var LAYERID_IMMEDIATE = 3;
var LAYERID_UI = 4;
var LIGHTTYPE_DIRECTIONAL = 0;
var LIGHTTYPE_OMNI = 1;
var LIGHTTYPE_POINT = LIGHTTYPE_OMNI;
var LIGHTTYPE_SPOT = 2;
var LIGHTTYPE_COUNT = 3;
var lightTypeNames = {
	[LIGHTTYPE_DIRECTIONAL]: "DIRECTIONAL",
	[LIGHTTYPE_OMNI]: "OMNI",
	[LIGHTTYPE_SPOT]: "SPOT"
};
var LIGHT_COLOR_DIVIDER = 100;
var LIGHTSHAPE_PUNCTUAL = 0;
var LIGHTSHAPE_RECT = 1;
var LIGHTSHAPE_DISK = 2;
var LIGHTSHAPE_SPHERE = 3;
var lightShapeNames = {
	[LIGHTSHAPE_PUNCTUAL]: "PUNCTUAL",
	[LIGHTSHAPE_RECT]: "RECT",
	[LIGHTSHAPE_DISK]: "DISK",
	[LIGHTSHAPE_SPHERE]: "SPHERE"
};
var LIGHTFALLOFF_LINEAR = 0;
var LIGHTFALLOFF_INVERSESQUARED = 1;
var lightFalloffNames = {
	[LIGHTFALLOFF_LINEAR]: "LINEAR",
	[LIGHTFALLOFF_INVERSESQUARED]: "INVERSESQUARED"
};
var SHADOW_PCF3_32F = 0;
var SHADOW_PCF3 = 0;
var SHADOW_VSM_16F = 2;
var SHADOW_VSM16 = 2;
var SHADOW_VSM_32F = 3;
var SHADOW_VSM32 = 3;
var SHADOW_PCF5_32F = 4;
var SHADOW_PCF5 = 4;
var SHADOW_PCF1_32F = 5;
var SHADOW_PCF1 = 5;
var SHADOW_PCSS_32F = 6;
var SHADOW_PCF1_16F = 7;
var SHADOW_PCF3_16F = 8;
var SHADOW_PCF5_16F = 9;
var shadowTypeInfo = /* @__PURE__ */ new Map([
	[SHADOW_PCF1_32F, { name: "PCF1_32F", kind: "PCF1", format: PIXELFORMAT_DEPTH, pcf: true }],
	[SHADOW_PCF3_32F, { name: "PCF3_32F", kind: "PCF3", format: PIXELFORMAT_DEPTH, pcf: true }],
	[SHADOW_PCF5_32F, { name: "PCF5_32F", kind: "PCF5", format: PIXELFORMAT_DEPTH, pcf: true }],
	[SHADOW_PCF1_16F, { name: "PCF1_16F", kind: "PCF1", format: PIXELFORMAT_DEPTH16, pcf: true }],
	[SHADOW_PCF3_16F, { name: "PCF3_16F", kind: "PCF3", format: PIXELFORMAT_DEPTH16, pcf: true }],
	[SHADOW_PCF5_16F, { name: "PCF5_16F", kind: "PCF5", format: PIXELFORMAT_DEPTH16, pcf: true }],
	[SHADOW_VSM_16F, { name: "VSM_16F", kind: "VSM", format: PIXELFORMAT_RGBA16F, vsm: true }],
	[SHADOW_VSM_32F, { name: "VSM_32F", kind: "VSM", format: PIXELFORMAT_RGBA32F, vsm: true }],
	[SHADOW_PCSS_32F, { name: "PCSS_32F", kind: "PCSS", format: PIXELFORMAT_R32F, pcss: true }]
]);
var SHADOW_CASCADE_0 = 1;
var SHADOW_CASCADE_1 = 2;
var SHADOW_CASCADE_2 = 4;
var SHADOW_CASCADE_3 = 8;
var SHADOW_CASCADE_ALL = 255;
var BLUR_BOX = 0;
var BLUR_GAUSSIAN = 1;
var PARTICLESORT_NONE = 0;
var PARTICLESORT_DISTANCE = 1;
var PARTICLESORT_NEWER_FIRST = 2;
var PARTICLESORT_OLDER_FIRST = 3;
var PARTICLEMODE_GPU = 0;
var PARTICLEMODE_CPU = 1;
var EMITTERSHAPE_BOX = 0;
var EMITTERSHAPE_SPHERE = 1;
var PARTICLEORIENTATION_SCREEN = 0;
var PARTICLEORIENTATION_WORLD = 1;
var PARTICLEORIENTATION_EMITTER = 2;
var PROJECTION_PERSPECTIVE = 0;
var PROJECTION_ORTHOGRAPHIC = 1;
var RENDERSTYLE_SOLID = 0;
var RENDERSTYLE_WIREFRAME = 1;
var RENDERSTYLE_POINTS = 2;
var CUBEPROJ_NONE = 0;
var CUBEPROJ_BOX = 1;
var cubemaProjectionNames = {
	[CUBEPROJ_NONE]: "NONE",
	[CUBEPROJ_BOX]: "BOX"
};
var DETAILMODE_MUL = "mul";
var DETAILMODE_ADD = "add";
var DETAILMODE_SCREEN = "screen";
var DETAILMODE_OVERLAY = "overlay";
var DETAILMODE_MIN = "min";
var DETAILMODE_MAX = "max";
var GAMMA_NONE = 0;
var GAMMA_SRGB = 1;
var gammaNames = {
	[GAMMA_NONE]: "NONE",
	[GAMMA_SRGB]: "SRGB"
};
var TONEMAP_LINEAR = 0;
var TONEMAP_FILMIC = 1;
var TONEMAP_HEJL = 2;
var TONEMAP_ACES = 3;
var TONEMAP_ACES2 = 4;
var TONEMAP_NEUTRAL = 5;
var TONEMAP_NONE = 6;
var tonemapNames = [
	"LINEAR",
	"FILMIC",
	"HEJL",
	"ACES",
	"ACES2",
	"NEUTRAL",
	"NONE"
];
var SPECOCC_NONE = 0;
var SPECOCC_AO = 1;
var SPECOCC_GLOSSDEPENDENT = 2;
var specularOcclusionNames = {
	[SPECOCC_NONE]: "NONE",
	[SPECOCC_AO]: "AO",
	[SPECOCC_GLOSSDEPENDENT]: "GLOSSDEPENDENT"
};
var REFLECTIONSRC_NONE = "none";
var REFLECTIONSRC_ENVATLAS = "envAtlas";
var REFLECTIONSRC_ENVATLASHQ = "envAtlasHQ";
var REFLECTIONSRC_CUBEMAP = "cubeMap";
var REFLECTIONSRC_SPHEREMAP = "sphereMap";
var reflectionSrcNames = {
	[REFLECTIONSRC_NONE]: "NONE",
	[REFLECTIONSRC_ENVATLAS]: "ENVATLAS",
	[REFLECTIONSRC_ENVATLASHQ]: "ENVATLASHQ",
	[REFLECTIONSRC_CUBEMAP]: "CUBEMAP",
	[REFLECTIONSRC_SPHEREMAP]: "SPHEREMAP"
};
var AMBIENTSRC_AMBIENTSH = "ambientSH";
var AMBIENTSRC_ENVALATLAS = "envAtlas";
var AMBIENTSRC_CONSTANT = "constant";
var ambientSrcNames = {
	[AMBIENTSRC_AMBIENTSH]: "AMBIENTSH",
	[AMBIENTSRC_ENVALATLAS]: "ENVALATLAS",
	[AMBIENTSRC_CONSTANT]: "CONSTANT"
};
var SHADERDEF_NOSHADOW = 1;
var SHADERDEF_SKIN = 2;
var SHADERDEF_UV0 = 4;
var SHADERDEF_UV1 = 8;
var SHADERDEF_VCOLOR = 16;
var SHADERDEF_INSTANCING = 32;
var SHADERDEF_LM = 64;
var SHADERDEF_DIRLM = 128;
var SHADERDEF_SCREENSPACE = 256;
var SHADERDEF_TANGENTS = 512;
var SHADERDEF_MORPH_POSITION = 1024;
var SHADERDEF_MORPH_NORMAL = 2048;
var SHADERDEF_LMAMBIENT = 4096;
var SHADERDEF_MORPH_TEXTURE_BASED_INT = 8192;
var SHADERDEF_BATCH = 16384;
var SHADOWUPDATE_NONE = 0;
var SHADOWUPDATE_THISFRAME = 1;
var SHADOWUPDATE_REALTIME = 2;
var MASK_AFFECT_DYNAMIC = 1;
var MASK_AFFECT_LIGHTMAPPED = 2;
var MASK_BAKE = 4;
var SHADER_FORWARD = 0;
var SHADER_PREPASS = 1;
var SHADER_SHADOW = 2;
var SHADER_PICK = 3;
var SHADER_DEPTH_PICK = 4;
var SHADERPASS_FORWARD = "forward";
var SHADERPASS_ALBEDO = "debug_albedo";
var SHADERPASS_WORLDNORMAL = "debug_world_normal";
var SHADERPASS_OPACITY = "debug_opacity";
var SHADERPASS_SPECULARITY = "debug_specularity";
var SHADERPASS_GLOSS = "debug_gloss";
var SHADERPASS_METALNESS = "debug_metalness";
var SHADERPASS_AO = "debug_ao";
var SHADERPASS_EMISSION = "debug_emission";
var SHADERPASS_LIGHTING = "debug_lighting";
var SHADERPASS_UV0 = "debug_uv0";
var SPRITE_RENDERMODE_SIMPLE = 0;
var SPRITE_RENDERMODE_SLICED = 1;
var SPRITE_RENDERMODE_TILED = 2;
var spriteRenderModeNames = {
	[SPRITE_RENDERMODE_SIMPLE]: "SIMPLE",
	[SPRITE_RENDERMODE_SLICED]: "SLICED",
	[SPRITE_RENDERMODE_TILED]: "TILED"
};
var BAKE_COLOR = 0;
var BAKE_COLORDIR = 1;
var VIEW_CENTER = 0;
var VIEW_LEFT = 1;
var VIEW_RIGHT = 2;
var SORTMODE_NONE = 0;
var SORTMODE_MANUAL = 1;
var SORTMODE_MATERIALMESH = 2;
var SORTMODE_BACK2FRONT = 3;
var SORTMODE_FRONT2BACK = 4;
var SORTMODE_CUSTOM = 5;
var ASPECT_AUTO = 0;
var ASPECT_MANUAL = 1;
var ORIENTATION_HORIZONTAL = 0;
var ORIENTATION_VERTICAL = 1;
var SKYTYPE_INFINITE = "infinite";
var SKYTYPE_BOX = "box";
var SKYTYPE_DOME = "dome";
var DITHER_NONE = "none";
var DITHER_BAYER8 = "bayer8";
var DITHER_BLUENOISE = "bluenoise";
var DITHER_IGNNOISE = "ignnoise";
var ditherNames = {
	[DITHER_NONE]: "NONE",
	[DITHER_BAYER8]: "BAYER8",
	[DITHER_BLUENOISE]: "BLUENOISE",
	[DITHER_IGNNOISE]: "IGNNOISE"
};
var EVENT_PRERENDER = "prerender";
var EVENT_POSTRENDER = "postrender";
var EVENT_PRERENDER_LAYER = "prerender:layer";
var EVENT_POSTRENDER_LAYER = "postrender:layer";
var EVENT_PRECULL = "precull";
var EVENT_POSTCULL = "postcull";
var EVENT_CULL_END = "cull:end";
var GSPLAT_FORWARD = 1;
var GSPLAT_SHADOW = 2;
var SHADOWCAMERA_NAME = "pcShadowCamera";
var WORKBUFFER_UPDATE_AUTO = 0;
var WORKBUFFER_UPDATE_ONCE = 1;
var WORKBUFFER_UPDATE_ALWAYS = 2;
var GSPLAT_STREAM_RESOURCE = 0;
var GSPLAT_STREAM_INSTANCE = 1;
var GSPLATDATA_LARGE = "large";
var GSPLATDATA_COMPACT = "compact";
var GSPLAT_RENDERER_AUTO = 0;
var GSPLAT_RENDERER_RASTER_CPU_SORT = 1;
var GSPLAT_RENDERER_RASTER_GPU_SORT = 2;
var GSPLAT_RENDERER_COMPUTE = 3;
var GSPLAT_DEBUG_NONE = 0;
var GSPLAT_DEBUG_LOD = 1;
var GSPLAT_DEBUG_SH_UPDATE = 2;
var GSPLAT_DEBUG_HEATMAP = 3;
var GSPLAT_DEBUG_AABBS = 4;
var GSPLAT_DEBUG_NODE_AABBS = 5;
var RADIX_SORT_AUTO = 0;
var RADIX_SORT_PORTABLE = 1;
var RADIX_SORT_ONESWEEP = 2;

var ShaderProcessorOptions = class {
	uniformFormats = [];
	bindGroupFormats = [];
	vertexFormat;
	constructor(viewUniformFormat, vertexFormat) {
		this.uniformFormats[BINDGROUP_VIEW] = viewUniformFormat;
		this.vertexFormat = vertexFormat;
	}
	hasUniform(name) {
		for (let i2 = 0; i2 < this.uniformFormats.length; i2++) {
			const uniformFormat = this.uniformFormats[i2];
			if (uniformFormat?.get(name)) {
				return true;
			}
		}
		return false;
	}
	hasTexture(name) {
		for (let i2 = 0; i2 < this.bindGroupFormats.length; i2++) {
			const groupFormat = this.bindGroupFormats[i2];
			if (groupFormat?.getTexture(name)) {
				return true;
			}
		}
		return false;
	}
	getVertexElement(semantic) {
		return this.vertexFormat?.elements.find((element) => element.name === semantic);
	}
	generateKey(device) {
		let key = JSON.stringify(this.uniformFormats) + JSON.stringify(this.bindGroupFormats);
		if (device.isWebGPU) {
			key += this.vertexFormat?.shaderProcessingHashString;
		}
		return key;
	}
};

var programLibraryDeviceCache = new DeviceCache();
function getProgramLibrary(device) {
	const library = programLibraryDeviceCache.get(device);
	return library;
}
function setProgramLibrary(device, library) {
	programLibraryDeviceCache.get(device, () => {
		return library;
	});
}

var ShaderGenerator = class {
	static definesHash(defines) {
		const sortedArray = Array.from(defines).sort((a, b) => a[0] > b[0] ? 1 : -1);
		return hashCode(JSON.stringify(sortedArray));
	}
};

var shaderPassDeviceCache = new DeviceCache();
var ShaderPassInfo = class {
	index;
	name;
	defines = /* @__PURE__ */ new Map();
	constructor(name, index, options2 = {}) {
		this.name = name;
		this.index = index;
		Object.assign(this, options2);
		this.buildShaderDefines();
	}
	buildShaderDefines() {
		let keyword;
		if (this.isShadow) {
			keyword = "SHADOW";
		} else if (this.isForward) {
			keyword = "FORWARD";
		} else if (this.index === SHADER_PICK) {
			keyword = "PICK";
		} else if (this.index === SHADER_DEPTH_PICK) {
			keyword = "PICK";
			this.defines.set("DEPTH_PICK_PASS", "");
		}
		this.defines.set(`${keyword}_PASS`, "");
		this.defines.set(`${this.name.toUpperCase()}_PASS`, "");
	}
};
var ShaderPass = class _ShaderPass {
	passesNamed = /* @__PURE__ */ new Map();
	passesIndexed = [];
	nextIndex = 0;
	constructor() {
		const add = (name, index, options2) => {
			const info = this.allocate(name, options2);
		};
		add("forward", SHADER_FORWARD, { isForward: true });
		add("prepass", SHADER_PREPASS);
		add("shadow", SHADER_SHADOW);
		add("pick", SHADER_PICK);
		add("depth_pick", SHADER_DEPTH_PICK);
	}
	static get(device) {
		return shaderPassDeviceCache.get(device, () => {
			return new _ShaderPass();
		});
	}
	allocate(name, options2) {
		let info = this.passesNamed.get(name);
		if (info === void 0) {
			info = new ShaderPassInfo(name, this.nextIndex, options2);
			this.passesNamed.set(info.name, info);
			this.passesIndexed[info.index] = info;
			this.nextIndex++;
		}
		return info;
	}
	getByIndex(index) {
		const info = this.passesIndexed[index];
		return info;
	}
	getByName(name) {
		return this.passesNamed.get(name);
	}
};

var ShaderChunkMap = class extends Map {
	_validations;
	_keyDirty = false;
	_key = "";
	constructor(validations) {
		super();
		this._validations = validations;
	}
	set(name, code) {
		if (!this.has(name) || this.get(name) !== code) {
			this.markDirty();
		}
		return super.set(name, code);
	}
	add(object, override = true) {
		for (const [key, value] of Object.entries(object)) {
			if (override || !this.has(key)) {
				this.set(key, value);
			}
		}
		return this;
	}
	delete(name) {
		const existed = this.has(name);
		const result = super.delete(name);
		if (existed && result) {
			this.markDirty();
		}
		return result;
	}
	clear() {
		if (this.size > 0) {
			this.markDirty();
		}
		super.clear();
	}
	markDirty() {
		this._dirty = true;
		this._keyDirty = true;
	}
	isDirty() {
		return this._dirty;
	}
	resetDirty() {
		this._dirty = false;
	}
	get key() {
		if (this._keyDirty) {
			this._keyDirty = false;
			this._key = Array.from(this.entries()).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0).map(([k, v6]) => `${k}=${hashCode(v6)}`).join(",");
		}
		return this._key;
	}
	copy(source) {
		for (const key of this.keys()) {
			if (!source.has(key)) {
				this.delete(key);
			}
		}
		for (const [key, value] of source) {
			this.set(key, value);
		}
		return this;
	}
};

var _chunksCache = new DeviceCache();
var ShaderChunks = class _ShaderChunks {
	static _validations = /* @__PURE__ */ new Map();
	glsl = new ShaderChunkMap(_ShaderChunks._validations);
	wgsl = new ShaderChunkMap(_ShaderChunks._validations);
	static get(device, shaderLanguage = SHADERLANGUAGE_GLSL) {
		const cache = _chunksCache.get(device, () => {
			return new _ShaderChunks();
		});
		return shaderLanguage === SHADERLANGUAGE_GLSL ? cache.glsl : cache.wgsl;
	}
	static registerValidation(name, options2) {
	}
	version = "";
	get useWGSL() {
		return this.glsl.size === 0 || this.wgsl.size > 0;
	}
	get key() {
		return `GLSL:${this.glsl.key}|WGSL:${this.wgsl.key}|API:${this.version}`;
	}
	isDirty() {
		return this.glsl.isDirty() || this.wgsl.isDirty();
	}
	resetDirty() {
		this.glsl.resetDirty();
		this.wgsl.resetDirty();
	}
	copy(source) {
		this.version = source.version;
		this.glsl.copy(source.glsl);
		this.wgsl.copy(source.wgsl);
		return this;
	}
};

var MapUtils = class {
	static merge(...maps) {
		const result = new Map(maps[0] ?? []);
		for (let i2 = 1; i2 < maps.length; i2++) {
			const map = maps[i2];
			if (map) {
				for (const [key, value] of map) {
					result.set(key, value);
				}
			}
		}
		return result;
	}
};

var ShaderGeneratorPassThrough = class extends ShaderGenerator {
	constructor(key, shaderDefinition) {
		super();
		this.key = key;
		this.shaderDefinition = shaderDefinition;
	}
	generateKey(options2) {
		return this.key;
	}
	createShaderDefinition(device, options2) {
		return this.shaderDefinition;
	}
};
var ShaderUtils = class {
	static createShader(device, options2) {
		const programLibrary = getProgramLibrary(device);
		let shader = programLibrary.getCachedShader(options2.uniqueName);
		if (!shader) {
			const wgsl = device.isWebGPU && (!!options2.vertexWGSL || !!options2.vertexChunk) && (!!options2.fragmentWGSL || !!options2.fragmentChunk);
			const chunksMap = ShaderChunks.get(device, wgsl ? SHADERLANGUAGE_WGSL : SHADERLANGUAGE_GLSL);
			const vertexCode = options2.vertexChunk ? chunksMap.get(options2.vertexChunk) : wgsl ? options2.vertexWGSL : options2.vertexGLSL;
			const fragmentCode = options2.fragmentChunk ? chunksMap.get(options2.fragmentChunk) : wgsl ? options2.fragmentWGSL : options2.fragmentGLSL;
			const fragmentIncludes = MapUtils.merge(chunksMap, options2.fragmentIncludes);
			const vertexIncludes = MapUtils.merge(chunksMap, options2.vertexIncludes);
			shader = new Shader(device, ShaderDefinitionUtils.createDefinition(device, {
				name: options2.uniqueName,
				shaderLanguage: wgsl ? SHADERLANGUAGE_WGSL : SHADERLANGUAGE_GLSL,
				attributes: options2.attributes,
				vertexCode,
				fragmentCode,
				useTransformFeedback: options2.useTransformFeedback,
				vertexIncludes,
				vertexDefines: options2.vertexDefines,
				fragmentIncludes,
				fragmentDefines: options2.fragmentDefines,
				fragmentOutputTypes: options2.fragmentOutputTypes
			}));
			programLibrary.setCachedShader(options2.uniqueName, shader);
		}
		return shader;
	}
	static getCoreDefines(material, params) {
		const defines = new Map(material.defines);
		params.cameraShaderParams.defines.forEach((value, key) => defines.set(key, value));
		const shaderPassInfo = ShaderPass.get(params.device).getByIndex(params.pass);
		shaderPassInfo.defines.forEach((value, key) => defines.set(key, value));
		return defines;
	}
	static processShader(shader, processingOptions) {
		const shaderDefinition = shader.definition;
		const name = shaderDefinition.name ?? "shader";
		const key = `${name}-id-${shader.id}`;
		const materialGenerator = new ShaderGeneratorPassThrough(key, shaderDefinition);
		const libraryModuleName = "shader";
		const library = getProgramLibrary(shader.device);
		library.register(libraryModuleName, materialGenerator);
		const variant = library.getProgram(libraryModuleName, {}, processingOptions);
		library.unregister(libraryModuleName);
		return variant;
	}
	static addScreenDepthChunkDefines(cameraShaderParams, defines) {
		if (cameraShaderParams.sceneDepthMapLinear) {
			defines.set("SCENE_DEPTHMAP_LINEAR", "");
		}
	}
};
function createShader(device, vsName, fsName, useTransformFeedback = false, shaderDefinitionOptions = {}) {
}
function createShaderFromCode(device, vsCode, fsCode, uniqueName, attributes, useTransformFeedback = false, shaderDefinitionOptions = {}) {
	if (typeof useTransformFeedback === "boolean") {
		shaderDefinitionOptions.useTransformFeedback = useTransformFeedback;
	} else if (typeof useTransformFeedback === "object") {
		shaderDefinitionOptions = {
			...shaderDefinitionOptions,
			...useTransformFeedback
		};
	}
	const programLibrary = getProgramLibrary(device);
	let shader = programLibrary.getCachedShader(uniqueName);
	if (!shader) {
		shader = new Shader(device, ShaderDefinitionUtils.createDefinition(device, {
			...shaderDefinitionOptions,
			name: uniqueName,
			vertexCode: vsCode,
			fragmentCode: fsCode,
			attributes
		}));
		programLibrary.setCachedShader(uniqueName, shader);
	}
	return shader;
}

var _quadPrimitive2 = {
	type: PRIMITIVE_TRIANGLES,
	base: 0,
	count: 6,
	indexed: true
};
var _tempViewport = new Vec4();
var _tempScissor = new Vec4();
var _dynamicBindGroup = new DynamicBindGroup();
var QuadRender = class {
	uniformBuffer;
	bindGroup;
	constructor(shader) {
		const device = shader.device;
		this.shader = shader;
		if (device.supportsUniformBuffers) {
			const processingOptions = new ShaderProcessorOptions();
			this.shader = ShaderUtils.processShader(shader, processingOptions);
			const ubFormat = this.shader.meshUniformBufferFormat;
			if (ubFormat) {
				this.uniformBuffer = new UniformBuffer(device, ubFormat, false);
			}
			const bindGroupFormat = this.shader.meshBindGroupFormat;
			this.bindGroup = new BindGroup(device, bindGroupFormat);
		}
	}
	destroy() {
		this.uniformBuffer?.destroy();
		this.uniformBuffer = null;
		this.bindGroup?.destroy();
		this.bindGroup = null;
	}
	render(viewport, scissor, numInstances) {
		const device = this.shader.device;
		if (viewport) {
			_tempViewport.set(device.vx, device.vy, device.vw, device.vh);
			_tempScissor.set(device.sx, device.sy, device.sw, device.sh);
			scissor = scissor ?? viewport;
			device.setViewport(viewport.x, viewport.y, viewport.z, viewport.w);
			device.setScissor(scissor.x, scissor.y, scissor.z, scissor.w);
		}
		device.setVertexBuffer(device.quadVertexBuffer);
		const shader = this.shader;
		device.setShader(shader);
		if (device.supportsUniformBuffers) {
			device.setBindGroup(BINDGROUP_VIEW, device.emptyBindGroup);
			const bindGroup = this.bindGroup;
			bindGroup.update();
			device.setBindGroup(BINDGROUP_MESH, bindGroup);
			const uniformBuffer = this.uniformBuffer;
			if (uniformBuffer) {
				uniformBuffer.update(_dynamicBindGroup);
				device.setBindGroup(BINDGROUP_MESH_UB, _dynamicBindGroup.bindGroup, _dynamicBindGroup.offsets);
			} else {
				device.setBindGroup(BINDGROUP_MESH_UB, device.emptyBindGroup);
			}
		}
		device.draw(_quadPrimitive2, device.quadIndexBuffer, numInstances);
		if (viewport) {
			device.setViewport(_tempViewport.x, _tempViewport.y, _tempViewport.z, _tempViewport.w);
			device.setScissor(_tempScissor.x, _tempScissor.y, _tempScissor.z, _tempScissor.w);
		}
	}
};

var RenderPassQuad = class extends RenderPass {
	constructor(device, quad, rect, scissorRect) {
		super(device);
		this.quad = quad;
		this.rect = rect;
		this.scissorRect = scissorRect;
	}
	execute() {
		const { device } = this;
		device.setDrawStates(device.blendState);
		this.quad.render(this.rect, this.scissorRect);
	}
};

var _tempRect = new Vec4();
function drawQuadWithShader(device, target2, shader, rect, scissorRect) {
	const useBlend = arguments[5];
	const quad = new QuadRender(shader);
	if (!rect) {
		rect = _tempRect;
		rect.x = 0;
		rect.y = 0;
		rect.z = target2 ? target2.width : device.width;
		rect.w = target2 ? target2.height : device.height;
	}
	const renderPass = new RenderPassQuad(device, quad, rect, scissorRect);
	renderPass.init(target2);
	renderPass.colorOps.clear = false;
	renderPass.depthStencilOps.clearDepth = false;
	if (device.isWebGPU && target2 === null && device.samples > 1) {
		renderPass.colorOps.store = true;
	}
	renderPass.render();
	quad.destroy();
}

var Batch = class {
	_aabb = new BoundingBox();
	origMeshInstances;
	meshInstance = null;
	dynamic;
	batchGroupId;
	constructor(meshInstances, dynamic, batchGroupId) {
		this.origMeshInstances = meshInstances;
		this.dynamic = dynamic;
		this.batchGroupId = batchGroupId;
	}
	destroy(scene, layers) {
		if (this.meshInstance) {
			this.removeFromLayers(scene, layers);
			this.meshInstance.destroy();
			this.meshInstance = null;
		}
	}
	addToLayers(scene, layers) {
		for (let i2 = 0; i2 < layers.length; i2++) {
			const layer = scene.layers.getLayerById(layers[i2]);
			if (layer) {
				layer.addMeshInstances([this.meshInstance]);
			}
		}
	}
	removeFromLayers(scene, layers) {
		for (let i2 = 0; i2 < layers.length; i2++) {
			const layer = scene.layers.getLayerById(layers[i2]);
			if (layer) {
				layer.removeMeshInstances([this.meshInstance]);
			}
		}
	}
	// Updates bounding box for a batch
	updateBoundingBox() {
		this._aabb.copy(this.origMeshInstances[0].aabb);
		for (let i2 = 1; i2 < this.origMeshInstances.length; i2++) {
			this._aabb.add(this.origMeshInstances[i2].aabb);
		}
		this.meshInstance.aabb = this._aabb;
		this.meshInstance._aabbVer = 0;
	}
	get model() {
		return void 0;
	}
};

var BatchGroup = class {
	_ui = false;
	_sprite = false;
	_obj = {
		model: [],
		element: [],
		sprite: [],
		render: []
	};
	id;
	name;
	dynamic;
	maxAabbSize;
	layers;
	constructor(id14, name, dynamic, maxAabbSize, layers = [LAYERID_WORLD]) {
		this.id = id14;
		this.name = name;
		this.dynamic = dynamic;
		this.maxAabbSize = maxAabbSize;
		this.layers = layers;
	}
	static MODEL = "model";
	static ELEMENT = "element";
	static SPRITE = "sprite";
	static RENDER = "render";
};

var _invMatrix = new Mat4();
var SkinInstance = class {
	bones;
	constructor(skin) {
		this._dirty = true;
		this._rootBone = null;
		this._skinUpdateIndex = -1;
		this._updateBeforeCull = true;
		if (skin) {
			this.initSkin(skin);
		}
	}
	set rootBone(rootBone) {
		this._rootBone = rootBone;
	}
	get rootBone() {
		return this._rootBone;
	}
	init(device, numBones) {
		const numPixels = numBones * 3;
		let width = Math.ceil(Math.sqrt(numPixels));
		width = math.roundUp(width, 3);
		const height = Math.ceil(numPixels / width);
		this.boneTexture = new Texture(device, {
			width,
			height,
			format: PIXELFORMAT_RGBA32F,
			mipmaps: false,
			minFilter: FILTER_NEAREST,
			magFilter: FILTER_NEAREST,
			name: "skin"
		});
		this.matrixPalette = this.boneTexture.lock({ mode: TEXTURELOCK_READ });
		this.boneTexture.unlock();
	}
	destroy() {
		if (this.boneTexture) {
			this.boneTexture.destroy();
			this.boneTexture = null;
		}
	}
	resolve(rootBone, entity) {
		this.rootBone = rootBone;
		const skin = this.skin;
		const bones = [];
		for (let j = 0; j < skin.boneNames.length; j++) {
			const boneName = skin.boneNames[j];
			let bone = rootBone.findByName(boneName);
			if (!bone) {
				bone = entity;
			}
			bones.push(bone);
		}
		this.bones = bones;
	}
	initSkin(skin) {
		this.skin = skin;
		this.bones = [];
		const numBones = skin.inverseBindPose.length;
		this.init(skin.device, numBones);
		this.matrices = [];
		for (let i2 = 0; i2 < numBones; i2++) {
			this.matrices[i2] = new Mat4();
		}
	}
	uploadBones(device) {
		this.boneTexture.upload();
	}
	_updateMatrices(rootNode, skinUpdateIndex) {
		if (this._skinUpdateIndex !== skinUpdateIndex) {
			this._skinUpdateIndex = skinUpdateIndex;
			_invMatrix.copy(rootNode.getWorldTransform()).invert();
			for (let i2 = this.bones.length - 1; i2 >= 0; i2--) {
				this.matrices[i2].mulAffine2(_invMatrix, this.bones[i2].getWorldTransform());
				this.matrices[i2].mulAffine2(this.matrices[i2], this.skin.inverseBindPose[i2]);
			}
		}
	}
	updateMatrices(rootNode, skinUpdateIndex) {
		if (this._updateBeforeCull) {
			this._updateMatrices(rootNode, skinUpdateIndex);
		}
	}
	updateMatrixPalette(rootNode, skinUpdateIndex) {
		this._updateMatrices(rootNode, skinUpdateIndex);
		const mp = this.matrixPalette;
		const count = this.bones.length;
		for (let i2 = 0; i2 < count; i2++) {
			const pe = this.matrices[i2].data;
			const base = i2 * 12;
			mp[base] = pe[0];
			mp[base + 1] = pe[4];
			mp[base + 2] = pe[8];
			mp[base + 3] = pe[12];
			mp[base + 4] = pe[1];
			mp[base + 5] = pe[5];
			mp[base + 6] = pe[9];
			mp[base + 7] = pe[13];
			mp[base + 8] = pe[2];
			mp[base + 9] = pe[6];
			mp[base + 10] = pe[10];
			mp[base + 11] = pe[14];
		}
		this.uploadBones(this.skin.device);
	}
};

var SkinBatchInstance = class extends SkinInstance {
	constructor(device, nodes, rootNode) {
		super();
		const numBones = nodes.length;
		this.init(device, numBones);
		this.device = device;
		this.rootNode = rootNode;
		this.bones = nodes;
	}
	updateMatrices(rootNode, skinUpdateIndex) {
	}
	updateMatrixPalette(rootNode, skinUpdateIndex) {
		const mp = this.matrixPalette;
		const count = this.bones.length;
		for (let i2 = 0; i2 < count; i2++) {
			const pe = this.bones[i2].getWorldTransform().data;
			const base = i2 * 12;
			mp[base] = pe[0];
			mp[base + 1] = pe[4];
			mp[base + 2] = pe[8];
			mp[base + 3] = pe[12];
			mp[base + 4] = pe[1];
			mp[base + 5] = pe[5];
			mp[base + 6] = pe[9];
			mp[base + 7] = pe[13];
			mp[base + 8] = pe[2];
			mp[base + 9] = pe[6];
			mp[base + 10] = pe[10];
			mp[base + 11] = pe[14];
		}
		this.uploadBones(this.device);
	}
};

var id9 = 0;
var GeometryData = class {
	constructor() {
		this.initDefaults();
	}
	initDefaults() {
		this.recreate = false;
		this.verticesUsage = BUFFER_STATIC;
		this.indicesUsage = BUFFER_STATIC;
		this.maxVertices = 0;
		this.maxIndices = 0;
		this.vertexCount = 0;
		this.indexCount = 0;
		this.vertexStreamsUpdated = false;
		this.indexStreamUpdated = false;
		this.vertexStreamDictionary = {};
		this.indices = null;
	}
	// function called when vertex stream is requested to be updated, and validates / updates currently used vertex count
	_changeVertexCount(count, semantic) {
		if (!this.vertexCount) {
			this.vertexCount = count;
		} else {
		}
	}
	// default counts for vertex components
	static DEFAULT_COMPONENTS_POSITION = 3;
	static DEFAULT_COMPONENTS_NORMAL = 3;
	static DEFAULT_COMPONENTS_UV = 2;
	static DEFAULT_COMPONENTS_COLORS = 4;
};
var GeometryVertexStream = class {
	constructor(data2, componentCount, dataType, dataTypeNormalize, asInt) {
		this.data = data2;
		this.componentCount = componentCount;
		this.dataType = dataType;
		this.dataTypeNormalize = dataTypeNormalize;
		this.asInt = asInt;
	}
};
var Mesh = class _Mesh extends RefCountedObject {
	indexBuffer = [null];
	vertexBuffer = null;
	primitive = [{
		type: 0,
		base: 0,
		baseVertex: 0,
		count: 0
	}];
	skin = null;
	boneAabb = null;
	_aabbVer = 0;
	_aabb = new BoundingBox();
	_geometryData = null;
	_morph = null;
	_storageIndex = false;
	_storageVertex = false;
	constructor(graphicsDevice, options2) {
		super();
		this.id = id9++;
		this.device = graphicsDevice;
		this._storageIndex = options2?.storageIndex || false;
		this._storageVertex = options2?.storageVertex || false;
	}
	static fromGeometry(graphicsDevice, geometry, options2 = {}) {
		const mesh = new _Mesh(graphicsDevice, options2);
		const { positions, normals, tangents, colors, uvs, uvs1, blendIndices, blendWeights, indices } = geometry;
		if (positions) {
			mesh.setPositions(positions);
		}
		if (normals) {
			mesh.setNormals(normals);
		}
		if (tangents) {
			mesh.setVertexStream(SEMANTIC_TANGENT, tangents, 4);
		}
		if (colors) {
			mesh.setColors32(colors);
		}
		if (uvs) {
			mesh.setUvs(0, uvs);
		}
		if (uvs1) {
			mesh.setUvs(1, uvs1);
		}
		if (blendIndices) {
			mesh.setVertexStream(SEMANTIC_BLENDINDICES, blendIndices, 4, blendIndices.length / 4, TYPE_UINT8);
		}
		if (blendWeights) {
			mesh.setVertexStream(SEMANTIC_BLENDWEIGHT, blendWeights, 4);
		}
		if (indices) {
			mesh.setIndices(indices);
		}
		mesh.update();
		return mesh;
	}
	set morph(morph) {
		if (morph !== this._morph) {
			if (this._morph) {
				this._morph.decRefCount();
			}
			this._morph = morph;
			if (morph) {
				morph.incRefCount();
			}
		}
	}
	get morph() {
		return this._morph;
	}
	set aabb(aabb3) {
		this._aabb = aabb3;
		this._aabbVer++;
	}
	get aabb() {
		return this._aabb;
	}
	destroy() {
		const morph = this.morph;
		if (morph) {
			this.morph = null;
			if (morph.refCount < 1) {
				morph.destroy();
			}
		}
		if (this.vertexBuffer) {
			this.vertexBuffer.destroy();
			this.vertexBuffer = null;
		}
		for (let j = 0; j < this.indexBuffer.length; j++) {
			this._destroyIndexBuffer(j);
		}
		this.indexBuffer.length = 0;
		this._geometryData = null;
	}
	_destroyIndexBuffer(index) {
		if (this.indexBuffer[index]) {
			this.indexBuffer[index].destroy();
			this.indexBuffer[index] = null;
		}
	}
	// initializes local bounding boxes for each bone based on vertices affected by the bone
	// if morph targets are provided, it also adjusts local bone bounding boxes by maximum morph displacement
	_initBoneAabbs(morphTargets) {
		this.boneAabb = [];
		this.boneUsed = [];
		let x3, y2, z2;
		let bMax2, bMin2;
		const boneMin = [];
		const boneMax = [];
		const boneUsed = this.boneUsed;
		const numBones = this.skin.boneNames.length;
		let maxMorphX, maxMorphY, maxMorphZ;
		for (let i2 = 0; i2 < numBones; i2++) {
			boneMin[i2] = new Vec3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
			boneMax[i2] = new Vec3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
		}
		const iterator = new VertexIterator(this.vertexBuffer);
		const posElement = iterator.element[SEMANTIC_POSITION];
		const weightsElement = iterator.element[SEMANTIC_BLENDWEIGHT];
		const indicesElement = iterator.element[SEMANTIC_BLENDINDICES];
		const numVerts = this.vertexBuffer.numVertices;
		for (let j = 0; j < numVerts; j++) {
			for (let k = 0; k < 4; k++) {
				const boneWeight = weightsElement.array[weightsElement.index + k];
				if (boneWeight > 0) {
					const boneIndex = indicesElement.array[indicesElement.index + k];
					boneUsed[boneIndex] = true;
					x3 = posElement.array[posElement.index];
					y2 = posElement.array[posElement.index + 1];
					z2 = posElement.array[posElement.index + 2];
					bMax2 = boneMax[boneIndex];
					bMin2 = boneMin[boneIndex];
					if (bMin2.x > x3) bMin2.x = x3;
					if (bMin2.y > y2) bMin2.y = y2;
					if (bMin2.z > z2) bMin2.z = z2;
					if (bMax2.x < x3) bMax2.x = x3;
					if (bMax2.y < y2) bMax2.y = y2;
					if (bMax2.z < z2) bMax2.z = z2;
					if (morphTargets) {
						let minMorphX = maxMorphX = x3;
						let minMorphY = maxMorphY = y2;
						let minMorphZ = maxMorphZ = z2;
						for (let l = 0; l < morphTargets.length; l++) {
							const target2 = morphTargets[l];
							const dx = target2.deltaPositions[j * 3];
							const dy = target2.deltaPositions[j * 3 + 1];
							const dz = target2.deltaPositions[j * 3 + 2];
							if (dx < 0) {
								minMorphX += dx;
							} else {
								maxMorphX += dx;
							}
							if (dy < 0) {
								minMorphY += dy;
							} else {
								maxMorphY += dy;
							}
							if (dz < 0) {
								minMorphZ += dz;
							} else {
								maxMorphZ += dz;
							}
						}
						if (bMin2.x > minMorphX) bMin2.x = minMorphX;
						if (bMin2.y > minMorphY) bMin2.y = minMorphY;
						if (bMin2.z > minMorphZ) bMin2.z = minMorphZ;
						if (bMax2.x < maxMorphX) bMax2.x = maxMorphX;
						if (bMax2.y < maxMorphY) bMax2.y = maxMorphY;
						if (bMax2.z < maxMorphZ) bMax2.z = maxMorphZ;
					}
				}
			}
			iterator.next();
		}
		const positionElement = this.vertexBuffer.getFormat().elements.find((e) => e.name === SEMANTIC_POSITION);
		if (positionElement && positionElement.normalize) {
			const func = (() => {
				switch (positionElement.dataType) {
					case TYPE_INT8:
						return (x4) => Math.max(x4 / 127, -1);
					case TYPE_UINT8:
						return (x4) => x4 / 255;
					case TYPE_INT16:
						return (x4) => Math.max(x4 / 32767, -1);
					case TYPE_UINT16:
						return (x4) => x4 / 65535;
					default:
						return (x4) => x4;
				}
			})();
			for (let i2 = 0; i2 < numBones; i2++) {
				if (boneUsed[i2]) {
					const min = boneMin[i2];
					const max = boneMax[i2];
					min.set(func(min.x), func(min.y), func(min.z));
					max.set(func(max.x), func(max.y), func(max.z));
				}
			}
		}
		for (let i2 = 0; i2 < numBones; i2++) {
			const aabb3 = new BoundingBox();
			aabb3.setMinMax(boneMin[i2], boneMax[i2]);
			this.boneAabb.push(aabb3);
		}
	}
	// when mesh API to modify vertex / index data are used, this allocates structure to store the data
	_initGeometryData() {
		if (!this._geometryData) {
			this._geometryData = new GeometryData();
			if (this.vertexBuffer) {
				this._geometryData.vertexCount = this.vertexBuffer.numVertices;
				this._geometryData.maxVertices = this.vertexBuffer.numVertices;
			}
			if (this.indexBuffer.length > 0 && this.indexBuffer[0]) {
				this._geometryData.indexCount = this.indexBuffer[0].numIndices;
				this._geometryData.maxIndices = this.indexBuffer[0].numIndices;
			}
		}
	}
	clear(verticesDynamic, indicesDynamic, maxVertices = 0, maxIndices = 0) {
		this._initGeometryData();
		this._geometryData.initDefaults();
		this._geometryData.recreate = true;
		this._geometryData.maxVertices = maxVertices;
		this._geometryData.maxIndices = maxIndices;
		this._geometryData.verticesUsage = verticesDynamic ? BUFFER_DYNAMIC : BUFFER_STATIC;
		this._geometryData.indicesUsage = indicesDynamic ? BUFFER_DYNAMIC : BUFFER_STATIC;
	}
	setVertexStream(semantic, data2, componentCount, numVertices, dataType = TYPE_FLOAT32, dataTypeNormalize = false, asInt = false) {
		this._initGeometryData();
		const vertexCount = numVertices || data2.length / componentCount;
		this._geometryData._changeVertexCount(vertexCount, semantic);
		this._geometryData.vertexStreamsUpdated = true;
		this._geometryData.vertexStreamDictionary[semantic] = new GeometryVertexStream(
			data2,
			componentCount,
			dataType,
			dataTypeNormalize,
			asInt
		);
	}
	getVertexStream(semantic, data2) {
		let count = 0;
		let done = false;
		if (this._geometryData) {
			const stream = this._geometryData.vertexStreamDictionary[semantic];
			if (stream) {
				done = true;
				count = this._geometryData.vertexCount;
				if (ArrayBuffer.isView(data2)) {
					data2.set(stream.data);
				} else {
					data2.length = 0;
					data2.push(stream.data);
				}
			}
		}
		if (!done) {
			if (this.vertexBuffer) {
				const iterator = new VertexIterator(this.vertexBuffer);
				count = iterator.readData(semantic, data2);
			}
		}
		return count;
	}
	setPositions(positions, componentCount = GeometryData.DEFAULT_COMPONENTS_POSITION, numVertices) {
		this.setVertexStream(SEMANTIC_POSITION, positions, componentCount, numVertices, TYPE_FLOAT32, false);
	}
	setNormals(normals, componentCount = GeometryData.DEFAULT_COMPONENTS_NORMAL, numVertices) {
		this.setVertexStream(SEMANTIC_NORMAL, normals, componentCount, numVertices, TYPE_FLOAT32, false);
	}
	setUvs(channel, uvs, componentCount = GeometryData.DEFAULT_COMPONENTS_UV, numVertices) {
		this.setVertexStream(SEMANTIC_TEXCOORD + channel, uvs, componentCount, numVertices, TYPE_FLOAT32, false);
	}
	setColors(colors, componentCount = GeometryData.DEFAULT_COMPONENTS_COLORS, numVertices) {
		this.setVertexStream(SEMANTIC_COLOR, colors, componentCount, numVertices, TYPE_FLOAT32, false);
	}
	setColors32(colors, numVertices) {
		this.setVertexStream(SEMANTIC_COLOR, colors, GeometryData.DEFAULT_COMPONENTS_COLORS, numVertices, TYPE_UINT8, true);
	}
	setIndices(indices, numIndices) {
		this._initGeometryData();
		this._geometryData.indexStreamUpdated = true;
		this._geometryData.indices = indices;
		this._geometryData.indexCount = numIndices || indices.length;
	}
	getPositions(positions) {
		return this.getVertexStream(SEMANTIC_POSITION, positions);
	}
	getNormals(normals) {
		return this.getVertexStream(SEMANTIC_NORMAL, normals);
	}
	getUvs(channel, uvs) {
		return this.getVertexStream(SEMANTIC_TEXCOORD + channel, uvs);
	}
	getColors(colors) {
		return this.getVertexStream(SEMANTIC_COLOR, colors);
	}
	getIndices(indices) {
		let count = 0;
		if (this._geometryData && this._geometryData.indices) {
			const streamIndices = this._geometryData.indices;
			count = this._geometryData.indexCount;
			if (ArrayBuffer.isView(indices)) {
				indices.set(streamIndices);
			} else {
				indices.length = 0;
				for (let i2 = 0, il = streamIndices.length; i2 < il; i2++) {
					indices.push(streamIndices[i2]);
				}
			}
		} else {
			if (this.indexBuffer.length > 0 && this.indexBuffer[0]) {
				const indexBuffer = this.indexBuffer[0];
				count = indexBuffer.readData(indices);
			}
		}
		return count;
	}
	update(primitiveType = PRIMITIVE_TRIANGLES, updateBoundingBox = true) {
		if (this._geometryData) {
			if (updateBoundingBox) {
				const stream = this._geometryData.vertexStreamDictionary[SEMANTIC_POSITION];
				if (stream) {
					if (stream.componentCount === 3) {
						this._aabb.compute(stream.data, this._geometryData.vertexCount);
						this._aabbVer++;
					}
				}
			}
			let destroyVB = this._geometryData.recreate;
			if (this._geometryData.vertexCount > this._geometryData.maxVertices) {
				destroyVB = true;
				this._geometryData.maxVertices = this._geometryData.vertexCount;
			}
			if (destroyVB) {
				if (this.vertexBuffer) {
					this.vertexBuffer.destroy();
					this.vertexBuffer = null;
				}
			}
			let destroyIB = this._geometryData.recreate;
			if (this._geometryData.indexCount > this._geometryData.maxIndices) {
				destroyIB = true;
				this._geometryData.maxIndices = this._geometryData.indexCount;
			}
			if (destroyIB) {
				if (this.indexBuffer.length > 0 && this.indexBuffer[0]) {
					this.indexBuffer[0].destroy();
					this.indexBuffer[0] = null;
				}
			}
			if (this._geometryData.vertexStreamsUpdated) {
				this._updateVertexBuffer();
			}
			if (this._geometryData.indexStreamUpdated) {
				this._updateIndexBuffer();
			}
			this.primitive[0].type = primitiveType;
			if (this.indexBuffer.length > 0 && this.indexBuffer[0]) {
				if (this._geometryData.indexStreamUpdated) {
					this.primitive[0].count = this._geometryData.indexCount;
					this.primitive[0].indexed = true;
				}
			} else {
				if (this._geometryData.vertexStreamsUpdated) {
					this.primitive[0].count = this._geometryData.vertexCount;
					this.primitive[0].indexed = false;
				}
			}
			this._geometryData.vertexCount = 0;
			this._geometryData.indexCount = 0;
			this._geometryData.vertexStreamsUpdated = false;
			this._geometryData.indexStreamUpdated = false;
			this._geometryData.recreate = false;
			this.updateRenderStates();
		}
	}
	// builds vertex format based on attached vertex streams
	_buildVertexFormat(vertexCount) {
		const vertexDesc = [];
		for (const semantic in this._geometryData.vertexStreamDictionary) {
			const stream = this._geometryData.vertexStreamDictionary[semantic];
			vertexDesc.push({
				semantic,
				components: stream.componentCount,
				type: stream.dataType,
				normalize: stream.dataTypeNormalize,
				asInt: stream.asInt
			});
		}
		return new VertexFormat(this.device, vertexDesc, vertexCount);
	}
	// copy attached data into vertex buffer
	_updateVertexBuffer() {
		if (!this.vertexBuffer) {
			const allocateVertexCount = this._geometryData.maxVertices;
			const format = this._buildVertexFormat(allocateVertexCount);
			this.vertexBuffer = new VertexBuffer(this.device, format, allocateVertexCount, {
				usage: this._geometryData.verticesUsage,
				storage: this._storageVertex
			});
		}
		const iterator = new VertexIterator(this.vertexBuffer);
		const numVertices = this._geometryData.vertexCount;
		for (const semantic in this._geometryData.vertexStreamDictionary) {
			const stream = this._geometryData.vertexStreamDictionary[semantic];
			iterator.writeData(semantic, stream.data, numVertices);
			delete this._geometryData.vertexStreamDictionary[semantic];
		}
		iterator.end();
	}
	// copy attached data into index buffer
	_updateIndexBuffer() {
		if (this.indexBuffer.length <= 0 || !this.indexBuffer[0]) {
			const maxVertices = this._geometryData.maxVertices;
			const createFormat = maxVertices > 65535 || maxVertices === 0 ? INDEXFORMAT_UINT32 : INDEXFORMAT_UINT16;
			const options2 = this._storageIndex ? { storage: true } : void 0;
			this.indexBuffer[0] = new IndexBuffer(this.device, createFormat, this._geometryData.maxIndices, this._geometryData.indicesUsage, void 0, options2);
		}
		const srcIndices = this._geometryData.indices;
		if (srcIndices) {
			const indexBuffer = this.indexBuffer[0];
			indexBuffer.writeData(srcIndices, this._geometryData.indexCount);
			this._geometryData.indices = null;
		}
	}
	// prepares the mesh to be rendered with specific render style
	prepareRenderState(renderStyle) {
		if (renderStyle === RENDERSTYLE_WIREFRAME) {
			this.generateWireframe();
		} else if (renderStyle === RENDERSTYLE_POINTS) {
			this.primitive[RENDERSTYLE_POINTS] = {
				type: PRIMITIVE_POINTS,
				base: 0,
				baseVertex: 0,
				count: this.vertexBuffer ? this.vertexBuffer.numVertices : 0,
				indexed: false
			};
		}
	}
	// updates existing render states with changes to solid render state
	updateRenderStates() {
		if (this.primitive[RENDERSTYLE_POINTS]) {
			this.prepareRenderState(RENDERSTYLE_POINTS);
		}
		if (this.primitive[RENDERSTYLE_WIREFRAME]) {
			this.prepareRenderState(RENDERSTYLE_WIREFRAME);
		}
	}
	generateWireframe() {
		this._destroyIndexBuffer(RENDERSTYLE_WIREFRAME);
		const numVertices = this.vertexBuffer.numVertices;
		let lines;
		let format;
		if (this.indexBuffer.length > 0 && this.indexBuffer[0]) {
			const offsets = [[0, 1], [1, 2], [2, 0]];
			const base = this.primitive[RENDERSTYLE_SOLID].base;
			const count = this.primitive[RENDERSTYLE_SOLID].count;
			const baseVertex = this.primitive[RENDERSTYLE_SOLID].baseVertex || 0;
			const indexBuffer = this.indexBuffer[RENDERSTYLE_SOLID];
			const indicesArrayType = typedArrayIndexFormats[indexBuffer.format];
			const srcIndices = new indicesArrayType(indexBuffer.storage);
			const tmpIndices = new indicesArrayType(count * 2);
			const seen = /* @__PURE__ */ new Set();
			let len = 0;
			for (let j = base; j < base + count; j += 3) {
				for (let k = 0; k < 3; k++) {
					const i1 = srcIndices[j + offsets[k][0]] + baseVertex;
					const i2 = srcIndices[j + offsets[k][1]] + baseVertex;
					const hash = i1 > i2 ? i2 * numVertices + i1 : i1 * numVertices + i2;
					if (!seen.has(hash)) {
						seen.add(hash);
						tmpIndices[len++] = i1;
						tmpIndices[len++] = i2;
					}
				}
			}
			seen.clear();
			format = indexBuffer.format;
			lines = tmpIndices.slice(0, len);
		} else {
			const safeNumVertices = numVertices - numVertices % 3;
			const count = safeNumVertices / 3 * 6;
			format = count > 65535 ? INDEXFORMAT_UINT32 : INDEXFORMAT_UINT16;
			lines = count > 65535 ? new Uint32Array(count) : new Uint16Array(count);
			let idx = 0;
			for (let i2 = 0; i2 < safeNumVertices; i2 += 3) {
				lines[idx++] = i2;
				lines[idx++] = i2 + 1;
				lines[idx++] = i2 + 1;
				lines[idx++] = i2 + 2;
				lines[idx++] = i2 + 2;
				lines[idx++] = i2;
			}
		}
		const wireBuffer = new IndexBuffer(this.vertexBuffer.device, format, lines.length, BUFFER_STATIC, lines.buffer);
		this.primitive[RENDERSTYLE_WIREFRAME] = {
			type: PRIMITIVE_LINES,
			base: 0,
			baseVertex: 0,
			count: lines.length,
			indexed: true
		};
		this.indexBuffer[RENDERSTYLE_WIREFRAME] = wireBuffer;
	}
};

var scaleCompensatePosTransform = new Mat4();
var scaleCompensatePos = new Vec3();
var scaleCompensateRot = new Quat();
var scaleCompensateRot2 = new Quat();
var scaleCompensateScale = new Vec3();
var scaleCompensateScaleForParent = new Vec3();
var tmpMat42 = new Mat4();
var tmpQuat = new Quat();
var position = new Vec3();
var invParentWtm = new Mat4();
var rotation = new Quat();
var invParentRot = new Quat();
var matrix = new Mat4();
var target = new Vec3();
var up = new Vec3();
function createTest(attr, value) {
	if (attr instanceof Function) {
		return attr;
	}
	return (node) => {
		let x3 = node[attr];
		if (x3 instanceof Function) {
			x3 = x3();
		}
		return x3 === value;
	};
}
function findNode(node, test) {
	if (test(node)) {
		return node;
	}
	const children = node._children;
	const len = children.length;
	for (let i2 = 0; i2 < len; ++i2) {
		const result = findNode(children[i2], test);
		if (result) {
			return result;
		}
	}
	return null;
}
var GraphNode = class extends EventHandler {
	name;
	tags = new Tags(this);
	// Local space properties of transform (only first 3 are settable by the user)
	localPosition = new Vec3();
	localRotation = new Quat();
	localScale = new Vec3(1, 1, 1);
	localEulerAngles = new Vec3();
	// Only calculated on request
	// World space properties of transform
	position = new Vec3();
	rotation = new Quat();
	eulerAngles = new Vec3();
	_scale = null;
	localTransform = new Mat4();
	_dirtyLocal = false;
	_aabbVer = 0;
	_frozen = false;
	worldTransform = new Mat4();
	_dirtyWorld = false;
	_worldScaleSign = 0;
	_normalMatrix = new Mat3();
	_dirtyNormal = true;
	_right = null;
	_up = null;
	_forward = null;
	_parent = null;
	_children = [];
	_graphDepth = 0;
	_enabled = true;
	_enabledInHierarchy = false;
	scaleCompensation = false;
	constructor(name = "Untitled") {
		super();
		this.name = name;
	}
	get right() {
		if (!this._right) {
			this._right = new Vec3();
		}
		return this.getWorldTransform().getX(this._right).normalize();
	}
	get up() {
		if (!this._up) {
			this._up = new Vec3();
		}
		return this.getWorldTransform().getY(this._up).normalize();
	}
	get forward() {
		if (!this._forward) {
			this._forward = new Vec3();
		}
		return this.getWorldTransform().getZ(this._forward).normalize().mulScalar(-1);
	}
	get normalMatrix() {
		const normalMat = this._normalMatrix;
		if (this._dirtyNormal) {
			normalMat.invertMat4(this.getWorldTransform()).transpose();
			this._dirtyNormal = false;
		}
		return normalMat;
	}
	set enabled(enabled) {
		if (this._enabled !== enabled) {
			this._enabled = enabled;
			if (enabled && this._parent?.enabled || !enabled) {
				this._notifyHierarchyStateChanged(this, enabled);
			}
		}
	}
	get enabled() {
		return this._enabled && this._enabledInHierarchy;
	}
	get parent() {
		return this._parent;
	}
	get path() {
		let node = this._parent;
		if (!node) {
			return "";
		}
		let result = this.name;
		while (node && node._parent) {
			result = `${node.name}/${result}`;
			node = node._parent;
		}
		return result;
	}
	get root() {
		let result = this;
		while (result._parent) {
			result = result._parent;
		}
		return result;
	}
	get children() {
		return this._children;
	}
	// ---- deprecated block start ----
	getChildren() {
		return this.children;
	}
	getName() {
		return this.name;
	}
	getPath() {
		return this.path;
	}
	getRoot() {
		return this.root;
	}
	getParent() {
		return this.parent;
	}
	setName(name) {
		this.name = name;
	}
	// ---- deprecated block end ----
	get graphDepth() {
		return this._graphDepth;
	}
	_notifyHierarchyStateChanged(node, enabled) {
		node._onHierarchyStateChanged(enabled);
		const c2 = node._children;
		for (let i2 = 0, len = c2.length; i2 < len; i2++) {
			if (c2[i2]._enabled) {
				this._notifyHierarchyStateChanged(c2[i2], enabled);
			}
		}
	}
	_onHierarchyStateChanged(enabled) {
		this._enabledInHierarchy = enabled;
		if (enabled && !this._frozen) {
			this._unfreezeParentToRoot();
		}
	}
	_cloneInternal(clone) {
		clone.name = this.name;
		const tags = this.tags._list;
		clone.tags.clear();
		for (let i2 = 0; i2 < tags.length; i2++) {
			clone.tags.add(tags[i2]);
		}
		clone.localPosition.copy(this.localPosition);
		clone.localRotation.copy(this.localRotation);
		clone.localScale.copy(this.localScale);
		clone.localEulerAngles.copy(this.localEulerAngles);
		clone.position.copy(this.position);
		clone.rotation.copy(this.rotation);
		clone.eulerAngles.copy(this.eulerAngles);
		clone.localTransform.copy(this.localTransform);
		clone._dirtyLocal = this._dirtyLocal;
		clone.worldTransform.copy(this.worldTransform);
		clone._dirtyWorld = this._dirtyWorld;
		clone._dirtyNormal = this._dirtyNormal;
		clone._aabbVer = this._aabbVer + 1;
		clone._enabled = this._enabled;
		clone.scaleCompensation = this.scaleCompensation;
		clone._enabledInHierarchy = false;
	}
	clone() {
		const clone = new this.constructor();
		this._cloneInternal(clone);
		return clone;
	}
	copy(source) {
		source._cloneInternal(this);
		return this;
	}
	destroy() {
		this.remove();
		const children = this._children;
		while (children.length) {
			const child = children.pop();
			child._parent = null;
			child.destroy();
		}
		this.fire("destroy", this);
		this.off();
	}
	find(attr, value) {
		const results = [];
		const test = createTest(attr, value);
		this.forEach((node) => {
			if (test(node)) {
				results.push(node);
			}
		});
		return results;
	}
	findOne(attr, value) {
		const test = createTest(attr, value);
		return findNode(this, test);
	}
	findByTag(...query) {
		const results = [];
		const queryNode = (node, checkNode) => {
			if (checkNode && node.tags.has(...query)) {
				results.push(node);
			}
			for (let i2 = 0; i2 < node._children.length; i2++) {
				queryNode(node._children[i2], true);
			}
		};
		queryNode(this, false);
		return results;
	}
	findByName(name) {
		return this.findOne("name", name);
	}
	findByPath(path2) {
		const parts = Array.isArray(path2) ? path2 : path2.split("/");
		let result = this;
		for (let i2 = 0, imax = parts.length; i2 < imax; ++i2) {
			result = result.children.find((c2) => c2.name === parts[i2]);
			if (!result) {
				return null;
			}
		}
		return result;
	}
	forEach(callback, thisArg) {
		callback.call(thisArg, this);
		const children = this._children;
		const len = children.length;
		for (let i2 = 0; i2 < len; ++i2) {
			children[i2].forEach(callback, thisArg);
		}
	}
	isDescendantOf(node) {
		let parent = this._parent;
		while (parent) {
			if (parent === node) {
				return true;
			}
			parent = parent._parent;
		}
		return false;
	}
	isAncestorOf(node) {
		return node.isDescendantOf(this);
	}
	getEulerAngles() {
		this.getWorldTransform().getEulerAngles(this.eulerAngles);
		return this.eulerAngles;
	}
	getLocalEulerAngles() {
		this.localRotation.getEulerAngles(this.localEulerAngles);
		return this.localEulerAngles;
	}
	getLocalPosition() {
		return this.localPosition;
	}
	getLocalRotation() {
		return this.localRotation;
	}
	getLocalScale() {
		return this.localScale;
	}
	getLocalTransform() {
		if (this._dirtyLocal) {
			this.localTransform.setTRS(this.localPosition, this.localRotation, this.localScale);
			this._dirtyLocal = false;
		}
		return this.localTransform;
	}
	getPosition() {
		this.getWorldTransform().getTranslation(this.position);
		return this.position;
	}
	getRotation() {
		this.rotation.setFromMat4(this.getWorldTransform());
		return this.rotation;
	}
	getScale() {
		if (!this._scale) {
			this._scale = new Vec3();
		}
		return this.getWorldTransform().getScale(this._scale);
	}
	getWorldTransform() {
		if (!this._dirtyLocal && !this._dirtyWorld) {
			return this.worldTransform;
		}
		if (this._parent) {
			this._parent.getWorldTransform();
		}
		this._sync();
		return this.worldTransform;
	}
	get worldScaleSign() {
		if (this._worldScaleSign === 0) {
			this._worldScaleSign = this.getWorldTransform().scaleSign;
		}
		return this._worldScaleSign;
	}
	remove() {
		this._parent?.removeChild(this);
	}
	reparent(parent, index) {
		this.remove();
		if (parent) {
			if (index >= 0) {
				parent.insertChild(this, index);
			} else {
				parent.addChild(this);
			}
		}
	}
	setLocalEulerAngles(x3, y2, z2) {
		this.localRotation.setFromEulerAngles(x3, y2, z2);
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	setLocalPosition(x3, y2, z2) {
		if (x3 instanceof Vec3) {
			this.localPosition.copy(x3);
		} else {
			this.localPosition.set(x3, y2, z2);
		}
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	setLocalRotation(x3, y2, z2, w) {
		if (x3 instanceof Quat) {
			this.localRotation.copy(x3);
		} else {
			this.localRotation.set(x3, y2, z2, w);
		}
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	setLocalScale(x3, y2, z2) {
		if (x3 instanceof Vec3) {
			this.localScale.copy(x3);
		} else {
			this.localScale.set(x3, y2, z2);
		}
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	_dirtifyLocal() {
		if (!this._dirtyLocal) {
			this._dirtyLocal = true;
			if (!this._dirtyWorld) {
				this._dirtifyWorld();
			}
		}
	}
	_unfreezeParentToRoot() {
		let p = this._parent;
		while (p) {
			p._frozen = false;
			p = p._parent;
		}
	}
	_dirtifyWorld() {
		if (!this._dirtyWorld) {
			this._unfreezeParentToRoot();
		}
		this._dirtifyWorldInternal();
	}
	_dirtifyWorldInternal() {
		if (!this._dirtyWorld) {
			this._frozen = false;
			this._dirtyWorld = true;
			for (let i2 = 0; i2 < this._children.length; i2++) {
				if (!this._children[i2]._dirtyWorld) {
					this._children[i2]._dirtifyWorldInternal();
				}
			}
		}
		this._dirtyNormal = true;
		this._worldScaleSign = 0;
		this._aabbVer++;
	}
	setPosition(x3, y2, z2) {
		if (x3 instanceof Vec3) {
			position.copy(x3);
		} else {
			position.set(x3, y2, z2);
		}
		if (this._parent === null) {
			this.localPosition.copy(position);
		} else {
			invParentWtm.copy(this._parent.getWorldTransform()).invert();
			invParentWtm.transformPoint(position, this.localPosition);
		}
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	setRotation(x3, y2, z2, w) {
		if (x3 instanceof Quat) {
			rotation.copy(x3);
		} else {
			rotation.set(x3, y2, z2, w);
		}
		if (this._parent === null) {
			this.localRotation.copy(rotation);
		} else {
			const parentRot = this._parent.getRotation();
			invParentRot.copy(parentRot).invert();
			this.localRotation.copy(invParentRot).mul(rotation);
		}
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	setPositionAndRotation(position5, rotation7) {
		if (this._parent === null) {
			this.localPosition.copy(position5);
			this.localRotation.copy(rotation7);
		} else {
			const parentWtm = this._parent.getWorldTransform();
			invParentWtm.copy(parentWtm).invert();
			invParentWtm.transformPoint(position5, this.localPosition);
			this.localRotation.setFromMat4(invParentWtm).mul(rotation7);
		}
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	setEulerAngles(x3, y2, z2) {
		this.localRotation.setFromEulerAngles(x3, y2, z2);
		if (this._parent !== null) {
			const parentRot = this._parent.getRotation();
			invParentRot.copy(parentRot).invert();
			this.localRotation.mul2(invParentRot, this.localRotation);
		}
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	addChild(node) {
		this._prepareInsertChild(node);
		this._children.push(node);
		this._onInsertChild(node);
	}
	addChildAndSaveTransform(node) {
		const wPos = node.getPosition();
		const wRot = node.getRotation();
		this._prepareInsertChild(node);
		node.setPosition(tmpMat42.copy(this.worldTransform).invert().transformPoint(wPos));
		node.setRotation(tmpQuat.copy(this.getRotation()).invert().mul(wRot));
		this._children.push(node);
		this._onInsertChild(node);
	}
	insertChild(node, index) {
		this._prepareInsertChild(node);
		this._children.splice(index, 0, node);
		this._onInsertChild(node);
	}
	_prepareInsertChild(node) {
		node.remove();
	}
	_fireOnHierarchy(name, nameHierarchy, parent) {
		this.fire(name, parent);
		for (let i2 = 0; i2 < this._children.length; i2++) {
			this._children[i2]._fireOnHierarchy(nameHierarchy, nameHierarchy, parent);
		}
	}
	_onInsertChild(node) {
		node._parent = this;
		const enabledInHierarchy = node._enabled && this.enabled;
		if (node._enabledInHierarchy !== enabledInHierarchy) {
			node._enabledInHierarchy = enabledInHierarchy;
			node._notifyHierarchyStateChanged(node, enabledInHierarchy);
		}
		node._updateGraphDepth();
		node._dirtifyWorld();
		if (this._frozen) {
			node._unfreezeParentToRoot();
		}
		node._fireOnHierarchy("insert", "inserthierarchy", this);
		if (this.fire) this.fire("childinsert", node);
	}
	_updateGraphDepth() {
		this._graphDepth = this._parent ? this._parent._graphDepth + 1 : 0;
		for (let i2 = 0, len = this._children.length; i2 < len; i2++) {
			this._children[i2]._updateGraphDepth();
		}
	}
	removeChild(child) {
		const index = this._children.indexOf(child);
		if (index === -1) {
			return;
		}
		this._children.splice(index, 1);
		child._parent = null;
		child._fireOnHierarchy("remove", "removehierarchy", this);
		this.fire("childremove", child);
	}
	_sync() {
		if (this._dirtyLocal) {
			this.localTransform.setTRS(this.localPosition, this.localRotation, this.localScale);
			this._dirtyLocal = false;
		}
		if (this._dirtyWorld) {
			if (this._parent === null) {
				this.worldTransform.copy(this.localTransform);
			} else {
				if (this.scaleCompensation) {
					let parentWorldScale;
					const parent = this._parent;
					let scale2 = this.localScale;
					let parentToUseScaleFrom = parent;
					if (parentToUseScaleFrom) {
						while (parentToUseScaleFrom && parentToUseScaleFrom.scaleCompensation) {
							parentToUseScaleFrom = parentToUseScaleFrom._parent;
						}
						if (parentToUseScaleFrom) {
							parentToUseScaleFrom = parentToUseScaleFrom._parent;
							if (parentToUseScaleFrom) {
								parentWorldScale = parentToUseScaleFrom.worldTransform.getScale();
								scaleCompensateScale.mul2(parentWorldScale, this.localScale);
								scale2 = scaleCompensateScale;
							}
						}
					}
					scaleCompensateRot2.setFromMat4(parent.worldTransform);
					scaleCompensateRot.mul2(scaleCompensateRot2, this.localRotation);
					let tmatrix = parent.worldTransform;
					if (parent.scaleCompensation) {
						scaleCompensateScaleForParent.mul2(parentWorldScale, parent.getLocalScale());
						scaleCompensatePosTransform.setTRS(
							parent.worldTransform.getTranslation(scaleCompensatePos),
							scaleCompensateRot2,
							scaleCompensateScaleForParent
						);
						tmatrix = scaleCompensatePosTransform;
					}
					tmatrix.transformPoint(this.localPosition, scaleCompensatePos);
					this.worldTransform.setTRS(scaleCompensatePos, scaleCompensateRot, scale2);
				} else {
					this.worldTransform.mulAffine2(this._parent.worldTransform, this.localTransform);
				}
			}
			this._dirtyWorld = false;
		}
	}
	syncHierarchy() {
		if (!this._enabled) {
			return;
		}
		if (this._frozen) {
			return;
		}
		this._frozen = true;
		if (this._dirtyLocal || this._dirtyWorld) {
			this._sync();
		}
		const children = this._children;
		for (let i2 = 0, len = children.length; i2 < len; i2++) {
			children[i2].syncHierarchy();
		}
	}
	lookAt(x3, y2, z2, ux = 0, uy = 1, uz = 0) {
		if (x3 instanceof Vec3) {
			target.copy(x3);
			if (y2 instanceof Vec3) {
				up.copy(y2);
			} else {
				up.copy(Vec3.UP);
			}
		} else if (z2 === void 0) {
			return;
		} else {
			target.set(x3, y2, z2);
			up.set(ux, uy, uz);
		}
		matrix.setLookAt(this.getPosition(), target, up);
		rotation.setFromMat4(matrix);
		this.setRotation(rotation);
	}
	translate(x3, y2, z2) {
		if (x3 instanceof Vec3) {
			position.copy(x3);
		} else {
			position.set(x3, y2, z2);
		}
		position.add(this.getPosition());
		this.setPosition(position);
	}
	translateLocal(x3, y2, z2) {
		if (x3 instanceof Vec3) {
			position.copy(x3);
		} else {
			position.set(x3, y2, z2);
		}
		this.localRotation.transformVector(position, position);
		this.localPosition.add(position);
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	rotate(x3, y2, z2) {
		rotation.setFromEulerAngles(x3, y2, z2);
		if (this._parent === null) {
			this.localRotation.mul2(rotation, this.localRotation);
		} else {
			const rot = this.getRotation();
			const parentRot = this._parent.getRotation();
			invParentRot.copy(parentRot).invert();
			rotation.mul2(invParentRot, rotation);
			this.localRotation.mul2(rotation, rot);
		}
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	rotateLocal(x3, y2, z2) {
		rotation.setFromEulerAngles(x3, y2, z2);
		this.localRotation.mul(rotation);
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
};

var defaultMaterialDeviceCache = new DeviceCache();
function getDefaultMaterial(device) {
	const material = defaultMaterialDeviceCache.get(device);
	return material;
}
function setDefaultMaterial(device, material) {
	defaultMaterialDeviceCache.get(device, () => {
		return material;
	});
}

var RefCountedCache = class {
	cache = /* @__PURE__ */ new Map();
	destroy() {
		this.cache.forEach((refCount, object) => {
			object.destroy();
		});
		this.cache.clear();
	}
	incRef(object) {
		const refCount = (this.cache.get(object) || 0) + 1;
		this.cache.set(object, refCount);
	}
	decRef(object) {
		if (object) {
			let refCount = this.cache.get(object);
			if (refCount) {
				refCount--;
				if (refCount === 0) {
					this.cache.delete(object);
					object.destroy();
				} else {
					this.cache.set(object, refCount);
				}
			}
		}
	}
};

var LightmapCache = class {
	static cache = new RefCountedCache();
	// add texture reference to lightmap cache
	static incRef(texture) {
		this.cache.incRef(texture);
	}
	// remove texture reference from lightmap cache
	static decRef(texture) {
		this.cache.decRef(texture);
	}
	static destroy() {
		this.cache.destroy();
	}
};

var NumericIds = class {
	_counter = 0;
	get() {
		return this._counter++;
	}
};

var PickerId = new NumericIds();

var _tmpAabb = new BoundingBox();
var _tempBoneAabb = new BoundingBox();
var _tempSphere = new BoundingSphere();
var _meshSet = /* @__PURE__ */ new Set();
var lookupHashes = new Uint32Array(4);
var InstancingData = class {
	vertexBuffer = null;
	_destroyVertexBuffer = false;
	constructor(numObjects) {
		this.count = numObjects;
	}
	destroy() {
		if (this._destroyVertexBuffer) {
			this.vertexBuffer?.destroy();
		}
		this.vertexBuffer = null;
	}
};
var ShaderInstance = class {
	shader;
	bindGroup = null;
	uniformBuffer = null;
	hashes;
	getBindGroup(device) {
		if (!this.bindGroup) {
			const shader = this.shader;
			const bindGroupFormat = shader.meshBindGroupFormat;
			this.bindGroup = new BindGroup(device, bindGroupFormat);
		}
		return this.bindGroup;
	}
	getUniformBuffer(device) {
		if (!this.uniformBuffer) {
			const shader = this.shader;
			const ubFormat = shader.meshUniformBufferFormat;
			this.uniformBuffer = new UniformBuffer(device, ubFormat, false);
		}
		return this.uniformBuffer;
	}
	destroy() {
		this.bindGroup?.destroy();
		this.bindGroup = null;
		this.uniformBuffer?.destroy();
		this.uniformBuffer = null;
	}
};
var MeshInstance = class _MeshInstance {
	castShadow = false;
	shadowCascadeMask = SHADOW_CASCADE_ALL;
	cull = true;
	drawOrder = 0;
	_drawBucket = 127;
	node;
	visible = true;
	shaderPassMask = 4294967295;
	visibleThisFrame = false;
	flipFacesFactor = 1;
	gsplatInstance = null;
	id = PickerId.get();
	isVisibleFunc = null;
	instancingData = null;
	indirectData = null;
	drawCommands = null;
	meshMetaData = null;
	parameters = {};
	pick = true;
	stencilFront = null;
	stencilBack = null;
	transparent = false;
	_aabb = new BoundingBox();
	_aabbVer = -1;
	_aabbMeshVer = -1;
	_customAabb = null;
	_updateAabb = true;
	_updateAabbFunc = null;
	_sortKeyShadow = 0;
	_sortKeyForward = 0;
	_sortKeyDynamic = 0;
	_layer = LAYER_WORLD;
	_material = null;
	_skinInstance = null;
	_morphInstance = null;
	_receiveShadow = true;
	_renderStyle = RENDERSTYLE_SOLID;
	_screenSpace = false;
	_shaderCache = /* @__PURE__ */ new Map();
	_shaderDefs = MASK_AFFECT_DYNAMIC << 16;
	_calculateSortDistance = null;
	constructor(mesh, material, node = null) {
		this.node = node;
		this._mesh = mesh;
		mesh.incRefCount();
		this.material = material;
		if (mesh.vertexBuffer) {
			const format = mesh.vertexBuffer.format;
			this._shaderDefs |= format.hasUv0 ? SHADERDEF_UV0 : 0;
			this._shaderDefs |= format.hasUv1 ? SHADERDEF_UV1 : 0;
			this._shaderDefs |= format.hasColor ? SHADERDEF_VCOLOR : 0;
			this._shaderDefs |= format.hasTangents ? SHADERDEF_TANGENTS : 0;
		}
		this.updateKey();
	}
	set drawBucket(bucket) {
		this._drawBucket = Math.floor(bucket) & 255;
		this.updateKey();
	}
	get drawBucket() {
		return this._drawBucket;
	}
	set renderStyle(renderStyle) {
		this._renderStyle = renderStyle;
		this.mesh.prepareRenderState(renderStyle);
	}
	get renderStyle() {
		return this._renderStyle;
	}
	set mesh(mesh) {
		if (mesh === this._mesh) {
			return;
		}
		if (this._mesh) {
			this._mesh.decRefCount();
		}
		this._mesh = mesh;
		if (mesh) {
			mesh.incRefCount();
		}
	}
	get mesh() {
		return this._mesh;
	}
	set aabb(aabb3) {
		this._aabb = aabb3;
	}
	get aabb() {
		if (!this._updateAabb) {
			return this._aabb;
		}
		if (this._updateAabbFunc) {
			return this._updateAabbFunc(this._aabb);
		}
		let localAabb = this._customAabb;
		let toWorldSpace = !!localAabb;
		if (!localAabb) {
			localAabb = _tmpAabb;
			if (this.skinInstance) {
				if (!this.mesh.boneAabb) {
					const morphTargets = this._morphInstance ? this._morphInstance.morph._targets : null;
					this.mesh._initBoneAabbs(morphTargets);
				}
				const boneUsed = this.mesh.boneUsed;
				let first = true;
				for (let i2 = 0; i2 < this.mesh.boneAabb.length; i2++) {
					if (boneUsed[i2]) {
						_tempBoneAabb.setFromTransformedAabb(this.mesh.boneAabb[i2], this.skinInstance.matrices[i2]);
						if (first) {
							first = false;
							localAabb.center.copy(_tempBoneAabb.center);
							localAabb.halfExtents.copy(_tempBoneAabb.halfExtents);
						} else {
							localAabb.add(_tempBoneAabb);
						}
					}
				}
				toWorldSpace = true;
			} else if (this.node._aabbVer !== this._aabbVer || this.mesh._aabbVer !== this._aabbMeshVer) {
				if (this.mesh) {
					localAabb.center.copy(this.mesh.aabb.center);
					localAabb.halfExtents.copy(this.mesh.aabb.halfExtents);
				} else {
					localAabb.center.set(0, 0, 0);
					localAabb.halfExtents.set(0, 0, 0);
				}
				if (this.mesh && this.mesh.morph) {
					const morphAabb = this.mesh.morph.aabb;
					localAabb._expand(morphAabb.getMin(), morphAabb.getMax());
				}
				toWorldSpace = true;
				this._aabbVer = this.node._aabbVer;
				this._aabbMeshVer = this.mesh._aabbVer;
			}
		}
		if (toWorldSpace) {
			this._aabb.setFromTransformedAabb(localAabb, this.node.getWorldTransform());
		}
		return this._aabb;
	}
	clearShaders() {
		this._shaderCache.forEach((shaderInstance) => {
			shaderInstance.destroy();
		});
		this._shaderCache.clear();
	}
	getShaderInstance(shaderPass, lightHash, scene, cameraShaderParams, viewUniformFormat, sortedLights) {
		const shaderDefs = this._shaderDefs;
		lookupHashes[0] = shaderPass;
		lookupHashes[1] = lightHash;
		lookupHashes[2] = shaderDefs;
		lookupHashes[3] = cameraShaderParams.hash;
		const hash = hash32Fnv1a(lookupHashes);
		let shaderInstance = this._shaderCache.get(hash);
		if (!shaderInstance) {
			const mat2 = this._material;
			shaderInstance = new ShaderInstance();
			shaderInstance.shader = mat2.variants.get(hash);
			shaderInstance.hashes = new Uint32Array(lookupHashes);
			if (!shaderInstance.shader) {
				const shader = mat2.getShaderVariant({
					device: this.mesh.device,
					scene,
					objDefs: shaderDefs,
					cameraShaderParams,
					pass: shaderPass,
					sortedLights,
					viewUniformFormat,
					vertexFormat: this.mesh.vertexBuffer?.format
				});
				mat2.variants.set(hash, shader);
				shaderInstance.shader = shader;
			}
			this._shaderCache.set(hash, shaderInstance);
		}
		return shaderInstance;
	}
	set material(material) {
		this.clearShaders();
		const prevMat = this._material;
		if (prevMat) {
			prevMat.removeMeshInstanceRef(this);
		}
		this._material = material;
		if (material) {
			material.addMeshInstanceRef(this);
			this.transparent = material.transparent;
			this.updateKey();
		}
	}
	get material() {
		return this._material;
	}
	_updateShaderDefs(shaderDefs) {
		if (shaderDefs !== this._shaderDefs) {
			this._shaderDefs = shaderDefs;
			this.clearShaders();
		}
	}
	set calculateSortDistance(calculateSortDistance) {
		this._calculateSortDistance = calculateSortDistance;
	}
	get calculateSortDistance() {
		return this._calculateSortDistance;
	}
	set receiveShadow(val) {
		if (this._receiveShadow !== val) {
			this._receiveShadow = val;
			this._updateShaderDefs(val ? this._shaderDefs & ~SHADERDEF_NOSHADOW : this._shaderDefs | SHADERDEF_NOSHADOW);
		}
	}
	get receiveShadow() {
		return this._receiveShadow;
	}
	set batching(val) {
		this._updateShaderDefs(val ? this._shaderDefs | SHADERDEF_BATCH : this._shaderDefs & ~SHADERDEF_BATCH);
	}
	get batching() {
		return (this._shaderDefs & SHADERDEF_BATCH) !== 0;
	}
	set skinInstance(val) {
		this._skinInstance = val;
		this._updateShaderDefs(val ? this._shaderDefs | SHADERDEF_SKIN : this._shaderDefs & ~SHADERDEF_SKIN);
		this._setupSkinUpdate();
	}
	get skinInstance() {
		return this._skinInstance;
	}
	set morphInstance(val) {
		this._morphInstance?.destroy();
		this._morphInstance = val;
		let shaderDefs = this._shaderDefs;
		shaderDefs = val && val.morph.morphPositions ? shaderDefs | SHADERDEF_MORPH_POSITION : shaderDefs & ~SHADERDEF_MORPH_POSITION;
		shaderDefs = val && val.morph.morphNormals ? shaderDefs | SHADERDEF_MORPH_NORMAL : shaderDefs & ~SHADERDEF_MORPH_NORMAL;
		shaderDefs = val && val.morph.intRenderFormat ? shaderDefs | SHADERDEF_MORPH_TEXTURE_BASED_INT : shaderDefs & ~SHADERDEF_MORPH_TEXTURE_BASED_INT;
		this._updateShaderDefs(shaderDefs);
	}
	get morphInstance() {
		return this._morphInstance;
	}
	set screenSpace(val) {
		if (this._screenSpace !== val) {
			this._screenSpace = val;
			this._updateShaderDefs(val ? this._shaderDefs | SHADERDEF_SCREENSPACE : this._shaderDefs & ~SHADERDEF_SCREENSPACE);
		}
	}
	get screenSpace() {
		return this._screenSpace;
	}
	set key(val) {
		this._sortKeyForward = val;
	}
	get key() {
		return this._sortKeyForward;
	}
	set mask(val) {
		const toggles = this._shaderDefs & 65535;
		this._updateShaderDefs(toggles | val << 16);
	}
	get mask() {
		return this._shaderDefs >> 16;
	}
	set instancingCount(value) {
		if (this.instancingData) {
			this.instancingData.count = value;
		}
	}
	get instancingCount() {
		return this.instancingData ? this.instancingData.count : 0;
	}
	destroy() {
		const mesh = this.mesh;
		if (mesh) {
			this.mesh = null;
			if (mesh.refCount < 1) {
				mesh.destroy();
			}
		}
		this.setRealtimeLightmap(_MeshInstance.lightmapParamNames[0], null);
		this.setRealtimeLightmap(_MeshInstance.lightmapParamNames[1], null);
		this._skinInstance?.destroy();
		this._skinInstance = null;
		this.morphInstance?.destroy();
		this.morphInstance = null;
		this.clearShaders();
		this.material = null;
		this.instancingData?.destroy();
		this.destroyDrawCommands();
	}
	destroyDrawCommands() {
		if (this.drawCommands) {
			for (const cmd of this.drawCommands.values()) {
				cmd?.destroy();
			}
			this.drawCommands = null;
		}
	}
	// shader uniform names for lightmaps
	static lightmapParamNames = ["texture_lightMap", "texture_dirLightMap"];
	static _prepareRenderStyleForArray(meshInstances, renderStyle) {
		if (meshInstances) {
			for (let i2 = 0; i2 < meshInstances.length; i2++) {
				meshInstances[i2]._renderStyle = renderStyle;
				const mesh = meshInstances[i2].mesh;
				if (!_meshSet.has(mesh)) {
					_meshSet.add(mesh);
					mesh.prepareRenderState(renderStyle);
				}
			}
			_meshSet.clear();
		}
	}
	_isVisible(camera) {
		if (this.visible) {
			if (this.isVisibleFunc) {
				return this.isVisibleFunc(camera);
			}
			_tempSphere.center = this.aabb.center;
			_tempSphere.radius = this._aabb.halfExtents.length();
			return camera.frustum.containsSphere(_tempSphere) > 0;
		}
		return false;
	}
	updateKey() {
		const { material } = this;
		this._sortKeyForward = this._drawBucket << 23 | (material.alphaToCoverage || material.alphaTest ? 4194304 : 0) | material.id & 4194303;
	}
	setInstancing(vertexBuffer, cull = false) {
		if (vertexBuffer) {
			if (vertexBuffer === true) {
				this.instancingData = new InstancingData(0);
			} else {
				this.instancingData = new InstancingData(vertexBuffer.numVertices);
				this.instancingData.vertexBuffer = vertexBuffer;
				vertexBuffer.format.instancing = true;
			}
			this.cull = cull;
		} else {
			this.instancingData = null;
			this.cull = true;
		}
		this._updateShaderDefs(vertexBuffer instanceof VertexBuffer ? this._shaderDefs | SHADERDEF_INSTANCING : this._shaderDefs & ~SHADERDEF_INSTANCING);
	}
	setIndirect(camera, slot, count = 1) {
		const key = camera?.camera ?? null;
		if (slot === -1) {
			this._deleteDrawCommandsKey(key);
		} else {
			this.drawCommands ?? (this.drawCommands = /* @__PURE__ */ new Map());
			const cmd = this.drawCommands.get(key) ?? new DrawCommands(this.mesh.device);
			cmd.slotIndex = slot;
			cmd.update(count);
			this.drawCommands.set(key, cmd);
			const device = this.mesh.device;
			device.mapsToClear.add(this.drawCommands);
		}
	}
	setMultiDraw(camera, maxCount = 1) {
		const key = camera?.camera ?? null;
		let cmd;
		if (maxCount === 0) {
			this._deleteDrawCommandsKey(key);
		} else {
			this.drawCommands ?? (this.drawCommands = /* @__PURE__ */ new Map());
			cmd = this.drawCommands.get(key);
			if (!cmd) {
				const indexBuffer = this.mesh.indexBuffer?.[0];
				const indexFormat = indexBuffer?.format;
				const indexSizeBytes = indexFormat !== void 0 ? indexFormatByteSize[indexFormat] : 0;
				cmd = new DrawCommands(this.mesh.device, indexSizeBytes);
				this.drawCommands.set(key, cmd);
			}
			cmd.allocate(maxCount);
		}
		return cmd;
	}
	_deleteDrawCommandsKey(key) {
		const cmds = this.drawCommands;
		if (cmds) {
			const cmd = cmds.get(key);
			cmd?.destroy();
			cmds.delete(key);
			if (cmds.size === 0) {
				this.destroyDrawCommands();
			}
		}
	}
	getDrawCommands(camera) {
		const cmds = this.drawCommands;
		if (!cmds) return void 0;
		return cmds.get(camera) ?? cmds.get(null);
	}
	getIndirectMetaData() {
		const prim = this.mesh?.primitive[this.renderStyle];
		const data2 = this.meshMetaData ?? (this.meshMetaData = new Int32Array(4));
		data2[0] = prim.count;
		data2[1] = prim.base;
		data2[2] = prim.baseVertex;
		return data2;
	}
	ensureMaterial(device) {
		if (!this.material) {
			this.material = getDefaultMaterial(device);
		}
	}
	// Parameter management
	clearParameters() {
		this.parameters = {};
	}
	getParameters() {
		return this.parameters;
	}
	getParameter(name) {
		return this.parameters[name];
	}
	setParameter(name, data2) {
		const param = this.parameters[name];
		if (param) {
			param.data = data2;
		} else {
			this.parameters[name] = {
				scopeId: null,
				data: data2
			};
		}
	}
	setRealtimeLightmap(name, texture) {
		const old = this.getParameter(name);
		if (old === texture) {
			return;
		}
		if (old) {
			LightmapCache.decRef(old.data);
		}
		if (texture) {
			LightmapCache.incRef(texture);
			this.setParameter(name, texture);
		} else {
			this.deleteParameter(name);
		}
	}
	deleteParameter(name) {
		if (this.parameters[name]) {
			delete this.parameters[name];
		}
	}
	setParameters(device) {
		const parameters = this.parameters;
		for (const paramName in parameters) {
			const parameter = parameters[paramName];
			if (!parameter.scopeId) {
				parameter.scopeId = device.scope.resolve(paramName);
			}
			parameter.scopeId.setValue(parameter.data);
		}
	}
	setLightmapped(value) {
		if (value) {
			this.mask = (this.mask | MASK_AFFECT_LIGHTMAPPED) & ~(MASK_AFFECT_DYNAMIC | MASK_BAKE);
		} else {
			this.setRealtimeLightmap(_MeshInstance.lightmapParamNames[0], null);
			this.setRealtimeLightmap(_MeshInstance.lightmapParamNames[1], null);
			this._shaderDefs &= ~(SHADERDEF_LM | SHADERDEF_DIRLM | SHADERDEF_LMAMBIENT);
			this.mask = (this.mask | MASK_AFFECT_DYNAMIC) & ~(MASK_AFFECT_LIGHTMAPPED | MASK_BAKE);
		}
	}
	setCustomAabb(aabb3) {
		if (aabb3) {
			if (this._customAabb) {
				this._customAabb.copy(aabb3);
			} else {
				this._customAabb = aabb3.clone();
			}
		} else {
			this._customAabb = null;
			this._aabbVer = -1;
		}
		this._setupSkinUpdate();
	}
	_setupSkinUpdate() {
		if (this._skinInstance) {
			this._skinInstance._updateBeforeCull = !this._customAabb;
		}
	}
};

var _triFanIndices = [0, 1, 3, 2, 3, 1];
var _triStripIndices = [0, 1, 3, 0, 3, 2];
var mat3 = new Mat3();
function paramsIdentical(a, b) {
	if (a && !b) return false;
	if (!a && b) return false;
	a = a.data;
	b = b.data;
	if (a === b) return true;
	if (a instanceof Float32Array && b instanceof Float32Array) {
		if (a.length !== b.length) return false;
		for (let i2 = 0; i2 < a.length; i2++) {
			if (a[i2] !== b[i2]) return false;
		}
		return true;
	}
	return false;
}
function equalParamSets(params1, params2) {
	for (const param in params1) {
		if (params1.hasOwnProperty(param) && !paramsIdentical(params1[param], params2[param])) {
			return false;
		}
	}
	for (const param in params2) {
		if (params2.hasOwnProperty(param) && !paramsIdentical(params2[param], params1[param])) {
			return false;
		}
	}
	return true;
}
function getScaleSign(mi) {
	return mi.node.worldTransform.scaleSign;
}
var BatchManager = class {
	constructor(device, root, scene) {
		this.device = device;
		this.rootNode = root;
		this.scene = scene;
		this._init = false;
		this._batchGroups = {};
		this._batchGroupCounter = 0;
		this._batchList = [];
		this._dirtyGroups = [];
	}
	destroy() {
		this.device = null;
		this.rootNode = null;
		this.scene = null;
		this._batchGroups = {};
		this._batchList = [];
		this._dirtyGroups = [];
	}
	addGroup(name, dynamic, maxAabbSize, id14, layers) {
		if (id14 === void 0) {
			id14 = this._batchGroupCounter;
			this._batchGroupCounter++;
		}
		if (this._batchGroups[id14]) {
			return void 0;
		}
		const group = new BatchGroup(id14, name, dynamic, maxAabbSize, layers);
		this._batchGroups[id14] = group;
		return group;
	}
	removeGroup(id14) {
		if (!this._batchGroups[id14]) {
			return;
		}
		const newBatchList = [];
		for (let i2 = 0; i2 < this._batchList.length; i2++) {
			if (this._batchList[i2].batchGroupId === id14) {
				this.destroyBatch(this._batchList[i2]);
			} else {
				newBatchList.push(this._batchList[i2]);
			}
		}
		this._batchList = newBatchList;
		this._removeModelsFromBatchGroup(this.rootNode, id14);
		delete this._batchGroups[id14];
	}
	markGroupDirty(id14) {
		if (this._dirtyGroups.indexOf(id14) < 0) {
			this._dirtyGroups.push(id14);
		}
	}
	getGroupByName(name) {
		const groups = this._batchGroups;
		for (const group in groups) {
			if (!groups.hasOwnProperty(group)) continue;
			if (groups[group].name === name) {
				return groups[group];
			}
		}
		return null;
	}
	getGroupById(id14) {
		return this._batchGroups[id14] ?? null;
	}
	getBatches(batchGroupId) {
		const results = [];
		const len = this._batchList.length;
		for (let i2 = 0; i2 < len; i2++) {
			const batch = this._batchList[i2];
			if (batch.batchGroupId === batchGroupId) {
				results.push(batch);
			}
		}
		return results;
	}
	// traverse full hierarchy and clear the batch group id from all model, element and sprite components
	_removeModelsFromBatchGroup(node, id14) {
		if (!node.enabled) return;
		if (node.model && node.model.batchGroupId === id14) {
			node.model.batchGroupId = -1;
		}
		if (node.render && node.render.batchGroupId === id14) {
			node.render.batchGroupId = -1;
		}
		if (node.element && node.element.batchGroupId === id14) {
			node.element.batchGroupId = -1;
		}
		if (node.sprite && node.sprite.batchGroupId === id14) {
			node.sprite.batchGroupId = -1;
		}
		for (let i2 = 0; i2 < node._children.length; i2++) {
			this._removeModelsFromBatchGroup(node._children[i2], id14);
		}
	}
	insert(type, groupId, node) {
		const group = this._batchGroups[groupId];
		if (group) {
			if (group._obj[type].indexOf(node) < 0) {
				group._obj[type].push(node);
				this.markGroupDirty(groupId);
			}
		}
	}
	remove(type, groupId, node) {
		const group = this._batchGroups[groupId];
		if (group) {
			const idx = group._obj[type].indexOf(node);
			if (idx >= 0) {
				group._obj[type].splice(idx, 1);
				this.markGroupDirty(groupId);
			}
		}
	}
	_filterBatchableInstances(meshInstances, nodeName) {
		let hasUnsupported = false;
		let hasSupported = false;
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			if (meshInstances[i2].skinInstance || meshInstances[i2].morphInstance) {
				hasUnsupported = true;
			} else {
				hasSupported = true;
			}
		}
		if (hasUnsupported) {
			if (hasSupported) {
			}
			return null;
		}
		return meshInstances;
	}
	_extractRender(node, arr, group, groupMeshInstances) {
		if (node.render) {
			const valid = this._filterBatchableInstances(node.render.meshInstances, node.name);
			if (valid) {
				arr = groupMeshInstances[node.render.batchGroupId] = arr.concat(valid);
				node.render.removeFromLayers();
			}
		}
		return arr;
	}
	_extractModel(node, arr, group, groupMeshInstances) {
		if (node.model && node.model.model) {
			const valid = this._filterBatchableInstances(node.model.meshInstances, node.name);
			if (valid) {
				arr = groupMeshInstances[node.model.batchGroupId] = arr.concat(valid);
				node.model.removeModelFromLayers();
			}
		}
		return arr;
	}
	_extractElement(node, arr, group) {
		if (!node.element) return;
		let valid = false;
		if (node.element._text && node.element._text._model.meshInstances.length > 0) {
			arr.push(node.element._text._model.meshInstances[0]);
			node.element.removeModelFromLayers(node.element._text._model);
			valid = true;
		} else if (node.element._image) {
			arr.push(node.element._image._renderable.meshInstance);
			node.element.removeModelFromLayers(node.element._image._renderable.model);
			if (node.element._image._renderable.unmaskMeshInstance) {
				arr.push(node.element._image._renderable.unmaskMeshInstance);
				if (!node.element._image._renderable.unmaskMeshInstance.stencilFront || !node.element._image._renderable.unmaskMeshInstance.stencilBack) {
					node.element._dirtifyMask();
					node.element._onPrerender();
				}
			}
			valid = true;
		}
		if (valid) {
			group._ui = true;
		}
	}
	// traverse scene hierarchy down from `node` and collect all components that are marked
	// with a batch group id. Remove from layers any models that these components contains.
	// Fill the `groupMeshInstances` with all the mesh instances to be included in the batch groups,
	// indexed by batch group id.
	_collectAndRemoveMeshInstances(groupMeshInstances, groupIds) {
		for (let g = 0; g < groupIds.length; g++) {
			const id14 = groupIds[g];
			const group = this._batchGroups[id14];
			if (!group) continue;
			let arr = groupMeshInstances[id14];
			if (!arr) arr = groupMeshInstances[id14] = [];
			for (let m = 0; m < group._obj.model.length; m++) {
				arr = this._extractModel(group._obj.model[m], arr, group, groupMeshInstances);
			}
			for (let r = 0; r < group._obj.render.length; r++) {
				arr = this._extractRender(group._obj.render[r], arr, group, groupMeshInstances);
			}
			for (let e = 0; e < group._obj.element.length; e++) {
				this._extractElement(group._obj.element[e], arr, group);
			}
			for (let s2 = 0; s2 < group._obj.sprite.length; s2++) {
				const node = group._obj.sprite[s2];
				if (node.sprite && node.sprite._meshInstance && (group.dynamic || node.sprite.sprite._renderMode === SPRITE_RENDERMODE_SIMPLE)) {
					arr.push(node.sprite._meshInstance);
					node.sprite.removeFromLayers();
					group._sprite = true;
				}
			}
		}
	}
	generate(groupIds) {
		const groupMeshInstances = {};
		if (!groupIds) {
			groupIds = Object.keys(this._batchGroups);
		}
		const newBatchList = [];
		for (let i2 = 0; i2 < this._batchList.length; i2++) {
			if (groupIds.indexOf(this._batchList[i2].batchGroupId) < 0) {
				newBatchList.push(this._batchList[i2]);
				continue;
			}
			this.destroyBatch(this._batchList[i2]);
		}
		this._batchList = newBatchList;
		this._collectAndRemoveMeshInstances(groupMeshInstances, groupIds);
		if (groupIds === this._dirtyGroups) {
			this._dirtyGroups.length = 0;
		} else {
			const newDirtyGroups = [];
			for (let i2 = 0; i2 < this._dirtyGroups.length; i2++) {
				if (groupIds.indexOf(this._dirtyGroups[i2]) < 0) newDirtyGroups.push(this._dirtyGroups[i2]);
			}
			this._dirtyGroups = newDirtyGroups;
		}
		let group, lists, groupData, batch;
		for (const groupId in groupMeshInstances) {
			if (!groupMeshInstances.hasOwnProperty(groupId)) continue;
			group = groupMeshInstances[groupId];
			groupData = this._batchGroups[groupId];
			if (!groupData) {
				continue;
			}
			lists = this.prepare(group, groupData.dynamic, groupData.maxAabbSize, groupData._ui || groupData._sprite);
			for (let i2 = 0; i2 < lists.length; i2++) {
				batch = this.create(lists[i2], groupData.dynamic, parseInt(groupId, 10));
				if (batch) {
					batch.addToLayers(this.scene, groupData.layers);
				}
			}
		}
	}
	prepare(meshInstances, dynamic, maxAabbSize = Number.POSITIVE_INFINITY, translucent) {
		if (meshInstances.length === 0) return [];
		const halfMaxAabbSize = maxAabbSize * 0.5;
		const maxInstanceCount = 1024;
		const maxNumVertices = 4294967295;
		const aabb3 = new BoundingBox();
		const testAabb = new BoundingBox();
		let skipTranslucentAabb = null;
		let sf;
		const lists = [];
		let j = 0;
		if (translucent) {
			meshInstances.sort((a, b) => {
				return a.drawOrder - b.drawOrder;
			});
		}
		let meshInstancesLeftA = meshInstances;
		let meshInstancesLeftB;
		const skipMesh = translucent ? function(mi) {
			if (skipTranslucentAabb) {
				skipTranslucentAabb.add(mi.aabb);
			} else {
				skipTranslucentAabb = mi.aabb.clone();
			}
			meshInstancesLeftB.push(mi);
		} : function(mi) {
			meshInstancesLeftB.push(mi);
		};
		while (meshInstancesLeftA.length > 0) {
			lists[j] = [meshInstancesLeftA[0]];
			meshInstancesLeftB = [];
			const material = meshInstancesLeftA[0].material;
			const layer = meshInstancesLeftA[0].layer;
			const defs = meshInstancesLeftA[0]._shaderDefs;
			const params = meshInstancesLeftA[0].parameters;
			const stencil = meshInstancesLeftA[0].stencilFront;
			let vertCount = meshInstancesLeftA[0].mesh.vertexBuffer.getNumVertices();
			const drawOrder = meshInstancesLeftA[0].drawOrder;
			aabb3.copy(meshInstancesLeftA[0].aabb);
			const scaleSign = getScaleSign(meshInstancesLeftA[0]);
			const vertexFormatBatchingHash = meshInstancesLeftA[0].mesh.vertexBuffer.format.batchingHash;
			const indexed = meshInstancesLeftA[0].mesh.primitive[0].indexed;
			const castShadow = meshInstancesLeftA[0].castShadow;
			const shadowCascadeMask = meshInstancesLeftA[0].shadowCascadeMask;
			skipTranslucentAabb = null;
			for (let i2 = 1; i2 < meshInstancesLeftA.length; i2++) {
				const mi = meshInstancesLeftA[i2];
				if (dynamic && lists[j].length >= maxInstanceCount) {
					meshInstancesLeftB = meshInstancesLeftB.concat(meshInstancesLeftA.slice(i2));
					break;
				}
				if (material !== mi.material || layer !== mi.layer || vertexFormatBatchingHash !== mi.mesh.vertexBuffer.format.batchingHash || indexed !== mi.mesh.primitive[0].indexed || defs !== mi._shaderDefs || vertCount + mi.mesh.vertexBuffer.getNumVertices() > maxNumVertices) {
					skipMesh(mi);
					continue;
				}
				testAabb.copy(aabb3);
				testAabb.add(mi.aabb);
				if (testAabb.halfExtents.x > halfMaxAabbSize || testAabb.halfExtents.y > halfMaxAabbSize || testAabb.halfExtents.z > halfMaxAabbSize) {
					skipMesh(mi);
					continue;
				}
				if (stencil) {
					if (!(sf = mi.stencilFront) || stencil.func !== sf.func || stencil.zpass !== sf.zpass) {
						skipMesh(mi);
						continue;
					}
				}
				if (scaleSign !== getScaleSign(mi)) {
					skipMesh(mi);
					continue;
				}
				if (castShadow !== mi.castShadow || shadowCascadeMask !== mi.shadowCascadeMask) {
					skipMesh(mi);
					continue;
				}
				if (!equalParamSets(params, mi.parameters)) {
					skipMesh(mi);
					continue;
				}
				if (translucent && skipTranslucentAabb && skipTranslucentAabb.intersects(mi.aabb) && mi.drawOrder !== drawOrder) {
					skipMesh(mi);
					continue;
				}
				aabb3.add(mi.aabb);
				vertCount += mi.mesh.vertexBuffer.getNumVertices();
				lists[j].push(mi);
			}
			j++;
			meshInstancesLeftA = meshInstancesLeftB;
		}
		return lists;
	}
	collectBatchedMeshData(meshInstances, dynamic) {
		let streams = null;
		let batchNumVerts = 0;
		let batchNumIndices = 0;
		let material = null;
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			if (meshInstances[i2].visible) {
				const mesh = meshInstances[i2].mesh;
				const numVerts = mesh.vertexBuffer.numVertices;
				batchNumVerts += numVerts;
				if (mesh.primitive[0].indexed) {
					batchNumIndices += mesh.primitive[0].count;
				} else {
					const primitiveType = mesh.primitive[0].type;
					if (primitiveType === PRIMITIVE_TRIFAN || primitiveType === PRIMITIVE_TRISTRIP) {
						if (mesh.primitive[0].count === 4) {
							batchNumIndices += 6;
						}
					}
				}
				if (!streams) {
					material = meshInstances[i2].material;
					streams = {};
					const elems = mesh.vertexBuffer.format.elements;
					for (let j = 0; j < elems.length; j++) {
						const semantic = elems[j].name;
						streams[semantic] = {
							numComponents: elems[j].numComponents,
							dataType: elems[j].dataType,
							normalize: elems[j].normalize,
							count: 0
						};
					}
					if (dynamic) {
						streams[SEMANTIC_BLENDINDICES] = {
							numComponents: 1,
							dataType: TYPE_FLOAT32,
							normalize: false,
							count: 0
						};
					}
				}
			}
		}
		return {
			streams,
			batchNumVerts,
			batchNumIndices,
			material
		};
	}
	create(meshInstances, dynamic, batchGroupId) {
		if (!this._init) {
			this.vertexFormats = {};
			this._init = true;
		}
		let stream = null;
		let semantic;
		let mesh, numVerts;
		let batch = null;
		const batchData = this.collectBatchedMeshData(meshInstances, dynamic);
		if (batchData.streams) {
			const streams = batchData.streams;
			let material = batchData.material;
			const batchNumVerts = batchData.batchNumVerts;
			const batchNumIndices = batchData.batchNumIndices;
			batch = new Batch(meshInstances, dynamic, batchGroupId);
			this._batchList.push(batch);
			let indexBase, indexBaseVertex, numIndices, indexData;
			let verticesOffset = 0;
			let indexOffset = 0;
			let transform;
			const indexArrayType = batchNumVerts <= 65535 ? Uint16Array : Uint32Array;
			const indices = new indexArrayType(batchNumIndices);
			for (semantic in streams) {
				stream = streams[semantic];
				stream.typeArrayType = typedArrayTypes[stream.dataType];
				stream.elementByteSize = typedArrayTypesByteSize[stream.dataType];
				stream.buffer = new stream.typeArrayType(batchNumVerts * stream.numComponents);
			}
			for (let i2 = 0; i2 < meshInstances.length; i2++) {
				if (!meshInstances[i2].visible) {
					continue;
				}
				mesh = meshInstances[i2].mesh;
				numVerts = mesh.vertexBuffer.numVertices;
				if (!dynamic) {
					transform = meshInstances[i2].node.getWorldTransform();
				}
				for (semantic in streams) {
					if (semantic !== SEMANTIC_BLENDINDICES) {
						stream = streams[semantic];
						const subarray = new stream.typeArrayType(stream.buffer.buffer, stream.elementByteSize * stream.count);
						const totalComponents = mesh.getVertexStream(semantic, subarray) * stream.numComponents;
						stream.count += totalComponents;
						if (!dynamic && stream.numComponents >= 3) {
							if (semantic === SEMANTIC_POSITION) {
								const m = transform.data;
								const m0 = m[0];
								const m12 = m[1];
								const m22 = m[2];
								const m4 = m[4];
								const m5 = m[5];
								const m6 = m[6];
								const m8 = m[8];
								const m9 = m[9];
								const m10 = m[10];
								const m122 = m[12];
								const m13 = m[13];
								const m14 = m[14];
								let x3, y2, z2;
								for (let j = 0; j < totalComponents; j += stream.numComponents) {
									x3 = subarray[j];
									y2 = subarray[j + 1];
									z2 = subarray[j + 2];
									subarray[j] = x3 * m0 + y2 * m4 + z2 * m8 + m122;
									subarray[j + 1] = x3 * m12 + y2 * m5 + z2 * m9 + m13;
									subarray[j + 2] = x3 * m22 + y2 * m6 + z2 * m10 + m14;
								}
							} else if (semantic === SEMANTIC_NORMAL || semantic === SEMANTIC_TANGENT) {
								mat3.invertMat4(transform).transpose();
								const [m0, m12, m22, m3, m4, m5, m6, m7, m8] = mat3.data;
								let x3, y2, z2;
								for (let j = 0; j < totalComponents; j += stream.numComponents) {
									x3 = subarray[j];
									y2 = subarray[j + 1];
									z2 = subarray[j + 2];
									subarray[j] = x3 * m0 + y2 * m3 + z2 * m6;
									subarray[j + 1] = x3 * m12 + y2 * m4 + z2 * m7;
									subarray[j + 2] = x3 * m22 + y2 * m5 + z2 * m8;
								}
							}
						}
					}
				}
				if (dynamic) {
					stream = streams[SEMANTIC_BLENDINDICES];
					for (let j = 0; j < numVerts; j++) {
						stream.buffer[stream.count++] = i2;
					}
				}
				if (mesh.primitive[0].indexed) {
					indexBase = mesh.primitive[0].base;
					indexBaseVertex = mesh.primitive[0].baseVertex || 0;
					numIndices = mesh.primitive[0].count;
					const srcFormat = mesh.indexBuffer[0].getFormat();
					indexData = new typedArrayIndexFormats[srcFormat](mesh.indexBuffer[0].storage);
				} else {
					indexBaseVertex = 0;
					const primitiveType = mesh.primitive[0].type;
					if (primitiveType === PRIMITIVE_TRIFAN || primitiveType === PRIMITIVE_TRISTRIP) {
						if (mesh.primitive[0].count === 4) {
							indexBase = 0;
							numIndices = 6;
							indexData = primitiveType === PRIMITIVE_TRIFAN ? _triFanIndices : _triStripIndices;
						} else {
							numIndices = 0;
							continue;
						}
					}
				}
				for (let j = 0; j < numIndices; j++) {
					indices[j + indexOffset] = indexData[indexBase + j] + indexBaseVertex + verticesOffset;
				}
				indexOffset += numIndices;
				verticesOffset += numVerts;
			}
			mesh = new Mesh(this.device);
			for (semantic in streams) {
				stream = streams[semantic];
				mesh.setVertexStream(semantic, stream.buffer, stream.numComponents, void 0, stream.dataType, stream.normalize);
			}
			if (indices.length > 0) {
				mesh.setIndices(indices);
			}
			mesh.update(PRIMITIVE_TRIANGLES, false);
			if (dynamic) {
				material = material.clone();
				material.update();
			}
			const meshInstance = new MeshInstance(mesh, material, this.rootNode);
			meshInstance.castShadow = batch.origMeshInstances[0].castShadow;
			meshInstance.parameters = batch.origMeshInstances[0].parameters;
			meshInstance.layer = batch.origMeshInstances[0].layer;
			meshInstance._shaderDefs = batch.origMeshInstances[0]._shaderDefs;
			meshInstance.batching = true;
			meshInstance.cull = batch.origMeshInstances[0].cull;
			const batchGroup = this._batchGroups[batchGroupId];
			if (batchGroup && batchGroup._ui) {
				meshInstance.cull = false;
			}
			if (dynamic) {
				const nodes = [];
				for (let i2 = 0; i2 < batch.origMeshInstances.length; i2++) {
					nodes.push(batch.origMeshInstances[i2].node);
				}
				meshInstance.skinInstance = new SkinBatchInstance(this.device, nodes, this.rootNode);
			}
			meshInstance._updateAabb = false;
			meshInstance.drawOrder = batch.origMeshInstances[0].drawOrder;
			meshInstance.stencilFront = batch.origMeshInstances[0].stencilFront;
			meshInstance.stencilBack = batch.origMeshInstances[0].stencilBack;
			meshInstance.flipFacesFactor = getScaleSign(batch.origMeshInstances[0]);
			meshInstance.castShadow = batch.origMeshInstances[0].castShadow;
			meshInstance.shadowCascadeMask = batch.origMeshInstances[0].shadowCascadeMask;
			batch.meshInstance = meshInstance;
			batch.updateBoundingBox();
		}
		return batch;
	}
	updateAll() {
		if (this._dirtyGroups.length > 0) {
			this.generate(this._dirtyGroups);
		}
		for (let i2 = 0; i2 < this._batchList.length; i2++) {
			if (!this._batchList[i2].dynamic) continue;
			this._batchList[i2].updateBoundingBox();
		}
	}
	clone(batch, clonedMeshInstances) {
		const batch2 = new Batch(clonedMeshInstances, batch.dynamic, batch.batchGroupId);
		this._batchList.push(batch2);
		const nodes = [];
		for (let i2 = 0; i2 < clonedMeshInstances.length; i2++) {
			nodes.push(clonedMeshInstances[i2].node);
		}
		batch2.meshInstance = new MeshInstance(batch.meshInstance.mesh, batch.meshInstance.material, batch.meshInstance.node);
		batch2.meshInstance._updateAabb = false;
		batch2.meshInstance.parameters = clonedMeshInstances[0].parameters;
		batch2.meshInstance.cull = clonedMeshInstances[0].cull;
		batch2.meshInstance.layer = clonedMeshInstances[0].layer;
		if (batch.dynamic) {
			batch2.meshInstance.skinInstance = new SkinBatchInstance(this.device, nodes, this.rootNode);
		}
		batch2.meshInstance.castShadow = batch.meshInstance.castShadow;
		return batch2;
	}
	destroyBatch(batch) {
		batch.destroy(this.scene, this._batchGroups[batch.batchGroupId].layers);
	}
};

var _colorUniformName = "uSceneColorMap";
var FramePassColorGrab = class extends FramePass {
	colorRenderTarget = null;
	source = null;
	destroy() {
		super.destroy();
		this.releaseRenderTarget(this.colorRenderTarget);
	}
	shouldReallocate(targetRT, sourceTexture, sourceFormat) {
		const targetFormat = targetRT?.colorBuffer.format;
		if (targetFormat !== sourceFormat) {
			return true;
		}
		const width = sourceTexture?.width || this.device.width;
		const height = sourceTexture?.height || this.device.height;
		return !targetRT || width !== targetRT.width || height !== targetRT.height;
	}
	allocateRenderTarget(renderTarget, sourceRenderTarget, device, format) {
		const texture = new Texture(device, {
			name: _colorUniformName,
			format,
			width: sourceRenderTarget ? sourceRenderTarget.colorBuffer.width : device.width,
			height: sourceRenderTarget ? sourceRenderTarget.colorBuffer.height : device.height,
			mipmaps: true,
			minFilter: FILTER_LINEAR_MIPMAP_LINEAR,
			magFilter: FILTER_LINEAR,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE
		});
		if (renderTarget) {
			renderTarget.destroyFrameBuffers();
			renderTarget._colorBuffer = texture;
			renderTarget._colorBuffers = [texture];
			renderTarget.evaluateDimensions();
		} else {
			renderTarget = new RenderTarget({
				name: "ColorGrabRT",
				colorBuffer: texture,
				depth: false,
				stencil: false,
				autoResolve: false
			});
		}
		return renderTarget;
	}
	releaseRenderTarget(rt) {
		if (rt) {
			rt.destroyTextureBuffers();
			rt.destroy();
		}
	}
	frameUpdate() {
		const device = this.device;
		const sourceRt = this.source;
		const sourceFormat = sourceRt?.colorBuffer.format ?? this.device.backBufferFormat;
		if (this.shouldReallocate(this.colorRenderTarget, sourceRt?.colorBuffer, sourceFormat)) {
			this.releaseRenderTarget(this.colorRenderTarget);
			this.colorRenderTarget = this.allocateRenderTarget(this.colorRenderTarget, sourceRt, device, sourceFormat);
		}
		const colorBuffer = this.colorRenderTarget.colorBuffer;
		device.scope.resolve(_colorUniformName).setValue(colorBuffer);
	}
	execute() {
		const device = this.device;
		const sourceRt = this.source;
		const colorBuffer = this.colorRenderTarget.colorBuffer;
		if (device.isWebGPU) {
			device.copyRenderTarget(sourceRt, this.colorRenderTarget, true, false);
			device.mipmapRenderer.generate(this.colorRenderTarget.colorBuffer.impl);
		} else {
			device.copyRenderTarget(sourceRt, this.colorRenderTarget, true, false);
			device.activeTexture(device.maxCombinedTextures - 1);
			device.bindTexture(colorBuffer);
			device.gl.generateMipmap(colorBuffer.impl._glTarget);
		}
	}
};

var _depthUniformName = "uSceneDepthMap";
var FramePassDepthGrab = class extends FramePass {
	depthRenderTarget = null;
	camera = null;
	constructor(device, camera) {
		super(device);
		this.camera = camera;
	}
	destroy() {
		super.destroy();
		this.releaseRenderTarget(this.depthRenderTarget);
	}
	shouldReallocate(targetRT, sourceTexture) {
		const width = sourceTexture?.width || this.device.width;
		const height = sourceTexture?.height || this.device.height;
		return !targetRT || width !== targetRT.width || height !== targetRT.height;
	}
	allocateRenderTarget(renderTarget, sourceRenderTarget, device, format, isDepth) {
		const texture = Texture.createDataTexture2D(
			device,
			_depthUniformName,
			sourceRenderTarget ? sourceRenderTarget.colorBuffer.width : device.width,
			sourceRenderTarget ? sourceRenderTarget.colorBuffer.height : device.height,
			format
		);
		if (renderTarget) {
			renderTarget.destroyFrameBuffers();
			if (isDepth) {
				renderTarget._depthBuffer = texture;
			} else {
				renderTarget._colorBuffer = texture;
				renderTarget._colorBuffers = [texture];
			}
			renderTarget.evaluateDimensions();
		} else {
			renderTarget = new RenderTarget({
				name: "DepthGrabRT",
				colorBuffer: isDepth ? null : texture,
				depthBuffer: isDepth ? texture : null,
				depth: !isDepth,
				stencil: device.supportsStencil,
				autoResolve: false
			});
		}
		return renderTarget;
	}
	releaseRenderTarget(rt) {
		if (rt) {
			rt.destroyTextureBuffers();
			rt.destroy();
		}
	}
	before() {
		const camera = this.camera;
		const device = this.device;
		const destinationRt = camera?.renderTarget ?? device.backBuffer;
		let useDepthBuffer = true;
		let format = destinationRt.stencil ? PIXELFORMAT_DEPTHSTENCIL : PIXELFORMAT_DEPTH;
		if (device.isWebGPU) {
			const numSamples = destinationRt.samples;
			if (numSamples > 1) {
				format = PIXELFORMAT_R32F;
				useDepthBuffer = false;
			}
		}
		const sourceTexture = camera.renderTarget?.depthBuffer ?? camera.renderTarget?.colorBuffer;
		if (this.shouldReallocate(this.depthRenderTarget, sourceTexture)) {
			this.releaseRenderTarget(this.depthRenderTarget);
			this.depthRenderTarget = this.allocateRenderTarget(this.depthRenderTarget, camera.renderTarget, device, format, useDepthBuffer);
		}
		const colorBuffer = useDepthBuffer ? this.depthRenderTarget.depthBuffer : this.depthRenderTarget.colorBuffer;
		device.scope.resolve(_depthUniformName).setValue(colorBuffer);
	}
	execute() {
		const device = this.device;
		if (device.isWebGL2 && device.renderTarget.samples > 1) {
			const src = device.renderTarget.impl._glFrameBuffer;
			const dest = this.depthRenderTarget;
			device.renderTarget = dest;
			device.updateBegin();
			this.depthRenderTarget.impl.internalResolve(device, src, dest.impl._glFrameBuffer, this.depthRenderTarget, device.gl.DEPTH_BUFFER_BIT);
		} else {
			device.copyRenderTarget(device.renderTarget, this.depthRenderTarget, false, true);
		}
	}
};

var CameraShaderParams = class {
	_gammaCorrection = GAMMA_SRGB;
	_toneMapping = TONEMAP_LINEAR;
	_srgbRenderTarget = false;
	_ssaoEnabled = false;
	_fog = FOG_NONE;
	_sceneDepthMapLinear = false;
	_hash;
	_defines = /* @__PURE__ */ new Map();
	_definesDirty = true;
	get hash() {
		if (this._hash === void 0) {
			const key = `${this.gammaCorrection}_${this.toneMapping}_${this.srgbRenderTarget}_${this.fog}_${this.ssaoEnabled}_${this.sceneDepthMapLinear}`;
			this._hash = hashCode(key);
		}
		return this._hash;
	}
	get defines() {
		const defines = this._defines;
		if (this._definesDirty) {
			this._definesDirty = false;
			defines.clear();
			if (this._sceneDepthMapLinear) defines.set("SCENE_DEPTHMAP_LINEAR", "");
			if (this.shaderOutputGamma === GAMMA_SRGB) defines.set("SCENE_COLORMAP_GAMMA", "");
			defines.set("FOG", this._fog.toUpperCase());
			defines.set("TONEMAP", tonemapNames[this._toneMapping]);
			defines.set("GAMMA", gammaNames[this.shaderOutputGamma]);
		}
		return defines;
	}
	markDirty() {
		this._hash = void 0;
		this._definesDirty = true;
	}
	set fog(type) {
		if (this._fog !== type) {
			this._fog = type;
			this.markDirty();
		}
	}
	get fog() {
		return this._fog;
	}
	set ssaoEnabled(value) {
		if (this._ssaoEnabled !== value) {
			this._ssaoEnabled = value;
			this.markDirty();
		}
	}
	get ssaoEnabled() {
		return this._ssaoEnabled;
	}
	set gammaCorrection(value) {
		this._gammaCorrectionAssigned = true;
		if (this._gammaCorrection !== value) {
			this._gammaCorrection = value;
			this.markDirty();
		}
	}
	get gammaCorrection() {
		return this._gammaCorrection;
	}
	set toneMapping(value) {
		if (this._toneMapping !== value) {
			this._toneMapping = value;
			this.markDirty();
		}
	}
	get toneMapping() {
		return this._toneMapping;
	}
	set srgbRenderTarget(value) {
		if (this._srgbRenderTarget !== value) {
			this._srgbRenderTarget = value;
			this.markDirty();
		}
	}
	get srgbRenderTarget() {
		return this._srgbRenderTarget;
	}
	set sceneDepthMapLinear(value) {
		if (this._sceneDepthMapLinear !== value) {
			this._sceneDepthMapLinear = value;
			this.markDirty();
		}
	}
	get sceneDepthMapLinear() {
		return this._sceneDepthMapLinear;
	}
	get shaderOutputGamma() {
		const gammaOutput = this._gammaCorrection === GAMMA_SRGB && !this._srgbRenderTarget;
		return gammaOutput ? GAMMA_SRGB : GAMMA_NONE;
	}
};

var _deviceCoord = new Vec3();
var _halfSize2 = new Vec3();
var _point = new Vec3();
var _invViewProjMat = new Mat4();
var _xrViewProjMat = new Mat4();
var _xrViewFrustum = new Frustum();
var _frustumViewInvMat = new Mat4();
var _frustumViewMat = new Mat4();
var _frustumViewProjMat = new Mat4();
var _frustumPoints = [new Vec3(), new Vec3(), new Vec3(), new Vec3(), new Vec3(), new Vec3(), new Vec3(), new Vec3()];
var Camera = class _Camera {
	static _flipYProjectionMatrix = new Mat4().setScale(1, -1, 1);
	static _webGpuDepthRangeMatrix = new Mat4().set([
		1,
		0,
		0,
		0,
		0,
		1,
		0,
		0,
		0,
		0,
		0.5,
		0,
		0,
		0,
		0.5,
		1
	]);
	static _applyShaderProjectionScratch = new Mat4();
	static applyShaderProjectionTransform(projection, out, flipY, applyWebGpuDepthRange) {
		if (!flipY && !applyWebGpuDepthRange) {
			out.copy(projection);
			return out;
		}
		if (flipY && applyWebGpuDepthRange) {
			const scratch = _Camera._applyShaderProjectionScratch;
			scratch.mul2(_Camera._flipYProjectionMatrix, projection);
			out.mul2(_Camera._webGpuDepthRangeMatrix, scratch);
			return out;
		}
		if (flipY) {
			out.mul2(_Camera._flipYProjectionMatrix, projection);
			return out;
		}
		out.mul2(_Camera._webGpuDepthRangeMatrix, projection);
		return out;
	}
	shaderPassInfo = null;
	renderPassColorGrab = null;
	renderPassDepthGrab = null;
	fogParams = null;
	shaderParams = new CameraShaderParams();
	framePasses = [];
	beforePasses = [];
	jitter = 0;
	device;
	constructor(graphicsDevice) {
		this.device = graphicsDevice;
		this._aspectRatio = 16 / 9;
		this._aspectRatioMode = ASPECT_AUTO;
		this._calculateProjection = null;
		this._calculateTransform = null;
		this._clearColor = new Color(0.75, 0.75, 0.75, 1);
		this._clearColorBuffer = true;
		this._clearDepth = 1;
		this._clearDepthBuffer = true;
		this._clearStencil = 0;
		this._clearStencilBuffer = true;
		this._cullFaces = true;
		this._farClip = 1e3;
		this._flipFaces = false;
		this._fov = 45;
		this._frustumCulling = true;
		this._horizontalFov = false;
		this._layers = [LAYERID_WORLD, LAYERID_DEPTH, LAYERID_SKYBOX, LAYERID_UI, LAYERID_IMMEDIATE];
		this._layersSet = new Set(this._layers);
		this._nearClip = 0.1;
		this._node = null;
		this._orthoHeight = 10;
		this._projection = PROJECTION_PERSPECTIVE;
		this._rect = new Vec4(0, 0, 1, 1);
		this._renderTarget = null;
		this._scissorRect = new Vec4(0, 0, 1, 1);
		this._scissorRectClear = false;
		this._aperture = 16;
		this._shutter = 1 / 1e3;
		this._sensitivity = 1e3;
		this._projMat = new Mat4();
		this._projMatDirty = true;
		this._projMatSkybox = new Mat4();
		this._viewMat = new Mat4();
		this._viewMatDirty = true;
		this._viewProjMat = new Mat4();
		this._viewProjMatDirty = true;
		this._shaderMatricesVersion = 0;
		this._viewProjInverse = new Mat4();
		this._viewProjCurrent = null;
		this._viewProjPrevious = new Mat4();
		this._jitters = [0, 0, 0, 0];
		this.frustum = new Frustum();
		this._cullLayers = /* @__PURE__ */ new Set();
		this._xrViews = null;
		this._xrProperties = {
			horizontalFov: this._horizontalFov,
			fov: this._fov,
			aspectRatio: this._aspectRatio,
			farClip: this._farClip,
			nearClip: this._nearClip
		};
	}
	destroy() {
		this.renderPassColorGrab?.destroy();
		this.renderPassColorGrab = null;
		this.renderPassDepthGrab?.destroy();
		this.renderPassDepthGrab = null;
		this.framePasses.length = 0;
		this.beforePasses.length = 0;
	}
	_storeShaderMatrices(viewProjMat2, jitterX, jitterY, renderVersion) {
		if (this._shaderMatricesVersion !== renderVersion) {
			this._shaderMatricesVersion = renderVersion;
			this._viewProjPrevious.copy(this._viewProjCurrent ?? viewProjMat2);
			this._viewProjCurrent ?? (this._viewProjCurrent = new Mat4());
			this._viewProjCurrent.copy(viewProjMat2);
			this._viewProjInverse.invert(viewProjMat2);
			this._jitters[2] = this._jitters[0];
			this._jitters[3] = this._jitters[1];
			this._jitters[0] = jitterX;
			this._jitters[1] = jitterY;
		}
	}
	get fullSizeClearRect() {
		const rect = this._scissorRectClear ? this.scissorRect : this._rect;
		return rect.x === 0 && rect.y === 0 && rect.z === 1 && rect.w === 1;
	}
	set aspectRatio(newValue) {
		if (this._aspectRatio !== newValue) {
			this._aspectRatio = newValue;
			this._projMatDirty = true;
		}
	}
	get aspectRatio() {
		if (this.xrActive) return this._xrProperties.aspectRatio;
		if (this._aspectRatioMode === ASPECT_AUTO) {
			const newValue = this.calculateAspectRatio();
			if (this._aspectRatio !== newValue) {
				this._aspectRatio = newValue;
				this._projMatDirty = true;
			}
		}
		return this._aspectRatio;
	}
	set aspectRatioMode(newValue) {
		if (this._aspectRatioMode !== newValue) {
			this._aspectRatioMode = newValue;
			this._projMatDirty = true;
		}
	}
	get aspectRatioMode() {
		return this._aspectRatioMode;
	}
	set calculateProjection(newValue) {
		this._calculateProjection = newValue;
		this._projMatDirty = true;
	}
	get calculateProjection() {
		return this._calculateProjection;
	}
	set calculateTransform(newValue) {
		this._calculateTransform = newValue;
	}
	get calculateTransform() {
		return this._calculateTransform;
	}
	set clearColor(newValue) {
		this._clearColor.copy(newValue);
	}
	get clearColor() {
		return this._clearColor;
	}
	set clearColorBuffer(newValue) {
		this._clearColorBuffer = newValue;
	}
	get clearColorBuffer() {
		return this._clearColorBuffer;
	}
	set clearDepth(newValue) {
		this._clearDepth = newValue;
	}
	get clearDepth() {
		return this._clearDepth;
	}
	set clearDepthBuffer(newValue) {
		this._clearDepthBuffer = newValue;
	}
	get clearDepthBuffer() {
		return this._clearDepthBuffer;
	}
	set clearStencil(newValue) {
		this._clearStencil = newValue;
	}
	get clearStencil() {
		return this._clearStencil;
	}
	set clearStencilBuffer(newValue) {
		this._clearStencilBuffer = newValue;
	}
	get clearStencilBuffer() {
		return this._clearStencilBuffer;
	}
	set cullFaces(newValue) {
		this._cullFaces = newValue;
	}
	get cullFaces() {
		return this._cullFaces;
	}
	set farClip(newValue) {
		if (this._farClip !== newValue) {
			this._farClip = newValue;
			this._projMatDirty = true;
		}
	}
	get farClip() {
		return this.xrActive ? this._xrProperties.farClip : this._farClip;
	}
	set flipFaces(newValue) {
		this._flipFaces = newValue;
	}
	get flipFaces() {
		return this._flipFaces;
	}
	set fov(newValue) {
		if (this._fov !== newValue) {
			this._fov = newValue;
			this._projMatDirty = true;
		}
	}
	get fov() {
		return this.xrActive ? this._xrProperties.fov : this._fov;
	}
	set frustumCulling(newValue) {
		this._frustumCulling = newValue;
	}
	get frustumCulling() {
		return this._frustumCulling;
	}
	set horizontalFov(newValue) {
		if (this._horizontalFov !== newValue) {
			this._horizontalFov = newValue;
			this._projMatDirty = true;
		}
	}
	get horizontalFov() {
		return this.xrActive ? this._xrProperties.horizontalFov : this._horizontalFov;
	}
	set layers(newValue) {
		this._layers = newValue.slice(0);
		this._layersSet = new Set(this._layers);
	}
	get layers() {
		return this._layers;
	}
	get layersSet() {
		return this._layersSet;
	}
	set nearClip(newValue) {
		if (this._nearClip !== newValue) {
			this._nearClip = newValue;
			this._projMatDirty = true;
		}
	}
	get nearClip() {
		return this.xrActive ? this._xrProperties.nearClip : this._nearClip;
	}
	set node(newValue) {
		this._node = newValue;
	}
	get node() {
		return this._node;
	}
	set orthoHeight(newValue) {
		if (this._orthoHeight !== newValue) {
			this._orthoHeight = newValue;
			this._projMatDirty = true;
		}
	}
	get orthoHeight() {
		return this._orthoHeight;
	}
	set projection(newValue) {
		if (this._projection !== newValue) {
			this._projection = newValue;
			this._projMatDirty = true;
		}
	}
	get projection() {
		return this._projection;
	}
	get projectionMatrix() {
		this._evaluateProjectionMatrix();
		return this._projMat;
	}
	set rect(newValue) {
		this._rect.copy(newValue);
		this._projMatDirty = true;
	}
	get rect() {
		return this._rect;
	}
	set renderTarget(newValue) {
		this._renderTarget = newValue;
		this._projMatDirty = true;
	}
	get renderTarget() {
		return this._renderTarget;
	}
	set scissorRect(newValue) {
		this._scissorRect.copy(newValue);
	}
	get scissorRect() {
		return this._scissorRect;
	}
	get viewMatrix() {
		if (this._viewMatDirty) {
			const wtm = this._node.getWorldTransform();
			this._viewMat.copy(wtm).invert();
			this._viewMatDirty = false;
		}
		return this._viewMat;
	}
	set aperture(newValue) {
		this._aperture = newValue;
	}
	get aperture() {
		return this._aperture;
	}
	set sensitivity(newValue) {
		this._sensitivity = newValue;
	}
	get sensitivity() {
		return this._sensitivity;
	}
	set shutter(newValue) {
		this._shutter = newValue;
	}
	get shutter() {
		return this._shutter;
	}
	set xrViews(value) {
		if (value !== null !== (this._xrViews !== null)) {
			this._projMatDirty = true;
		}
		this._xrViews = value;
	}
	get xrViews() {
		return this._xrViews;
	}
	get xrActive() {
		return this._xrViews !== null;
	}
	addCullLayer(layer) {
		const first = this._cullLayers.size === 0;
		this._cullLayers.add(layer);
		return first;
	}
	get cullLayers() {
		return this._cullLayers;
	}
	clearCullLayers() {
		this._cullLayers.clear();
	}
	calculateAspectRatio(rt) {
		const target2 = rt ?? this._renderTarget;
		const width = target2 ? target2.width : this.device.width;
		const height = target2 ? target2.height : this.device.height;
		return width * this._rect.z / (height * this._rect.w);
	}
	clone() {
		return new _Camera(this.device).copy(this);
	}
	copy(other) {
		this._aspectRatio = other._aspectRatio;
		this._farClip = other._farClip;
		this._fov = other._fov;
		this._horizontalFov = other._horizontalFov;
		this._nearClip = other._nearClip;
		this._xrProperties.aspectRatio = other._xrProperties.aspectRatio;
		this._xrProperties.farClip = other._xrProperties.farClip;
		this._xrProperties.fov = other._xrProperties.fov;
		this._xrProperties.horizontalFov = other._xrProperties.horizontalFov;
		this._xrProperties.nearClip = other._xrProperties.nearClip;
		this.aspectRatioMode = other.aspectRatioMode;
		this.calculateProjection = other.calculateProjection;
		this.calculateTransform = other.calculateTransform;
		this.clearColor = other.clearColor;
		this.clearColorBuffer = other.clearColorBuffer;
		this.clearDepth = other.clearDepth;
		this.clearDepthBuffer = other.clearDepthBuffer;
		this.clearStencil = other.clearStencil;
		this.clearStencilBuffer = other.clearStencilBuffer;
		this.cullFaces = other.cullFaces;
		this.flipFaces = other.flipFaces;
		this.frustumCulling = other.frustumCulling;
		this.layers = other.layers;
		this.orthoHeight = other.orthoHeight;
		this.projection = other.projection;
		this.rect = other.rect;
		this.renderTarget = other.renderTarget;
		this.scissorRect = other.scissorRect;
		this.aperture = other.aperture;
		this.shutter = other.shutter;
		this.sensitivity = other.sensitivity;
		this.shaderPassInfo = other.shaderPassInfo;
		this.jitter = other.jitter;
		this._projMatDirty = true;
		return this;
	}
	_enableRenderPassColorGrab(device, enable) {
		if (enable) {
			if (!this.renderPassColorGrab) {
				this.renderPassColorGrab = new FramePassColorGrab(device);
			}
		} else {
			this.renderPassColorGrab?.destroy();
			this.renderPassColorGrab = null;
		}
	}
	_enableRenderPassDepthGrab(device, renderer, enable) {
		if (enable) {
			if (!this.renderPassDepthGrab) {
				this.renderPassDepthGrab = new FramePassDepthGrab(device, this);
			}
		} else {
			this.renderPassDepthGrab?.destroy();
			this.renderPassDepthGrab = null;
		}
	}
	_updateViewProjMat() {
		if (this._projMatDirty || this._viewMatDirty || this._viewProjMatDirty) {
			this._viewProjMat.mul2(this.projectionMatrix, this.viewMatrix);
			this._viewProjMatDirty = false;
		}
	}
	updateViewTransforms() {
		const views = this.xrViews;
		if (!views) {
			return;
		}
		const parentWorldTransform = this._node?.parent?.getWorldTransform() ?? null;
		for (let i2 = 0; i2 < views.length; i2++) {
			views[i2].updateTransforms(parentWorldTransform);
		}
	}
	updateXrFrustum() {
		const views = this.xrViews;
		if (!views?.length) {
			return false;
		}
		_xrViewProjMat.mul2(views[0].projMat, views[0].viewOffMat);
		this.frustum.setFromMat4(_xrViewProjMat);
		for (let v6 = 1; v6 < views.length; v6++) {
			_xrViewProjMat.mul2(views[v6].projMat, views[v6].viewOffMat);
			_xrViewFrustum.setFromMat4(_xrViewProjMat);
			this.frustum.add(_xrViewFrustum);
		}
		return true;
	}
	updateFrustum() {
		if (this.updateXrFrustum()) {
			return;
		}
		const projMat = this.projectionMatrix;
		if (this.calculateProjection) {
			this.calculateProjection(projMat, VIEW_CENTER);
		}
		if (this.calculateTransform) {
			this.calculateTransform(_frustumViewInvMat, VIEW_CENTER);
		} else {
			const pos = this._node.getPosition();
			const rot = this._node.getRotation();
			_frustumViewInvMat.setTRS(pos, rot, Vec3.ONE);
		}
		_frustumViewMat.copy(_frustumViewInvMat).invert();
		_frustumViewProjMat.mul2(projMat, _frustumViewMat);
		this.frustum.setFromMat4(_frustumViewProjMat);
	}
	worldToScreen(worldCoord, cw, ch, screenCoord = new Vec3()) {
		this._updateViewProjMat();
		this._viewProjMat.transformPoint(worldCoord, screenCoord);
		const vpm = this._viewProjMat.data;
		const w = worldCoord.x * vpm[3] + worldCoord.y * vpm[7] + worldCoord.z * vpm[11] + 1 * vpm[15];
		screenCoord.x = (screenCoord.x / w + 1) * 0.5;
		screenCoord.y = (1 - screenCoord.y / w) * 0.5;
		const { x: rx, y: ry, z: rw, w: rh } = this._rect;
		screenCoord.x = screenCoord.x * rw * cw + rx * cw;
		screenCoord.y = screenCoord.y * rh * ch + (1 - ry - rh) * ch;
		return screenCoord;
	}
	screenToWorld(x3, y2, z2, cw, ch, worldCoord = new Vec3()) {
		const { x: rx, y: ry, z: rw, w: rh } = this._rect;
		const range = this.farClip - this.nearClip;
		_deviceCoord.set(
			(x3 - rx * cw) / (rw * cw),
			1 - (y2 - (1 - ry - rh) * ch) / (rh * ch),
			z2 / range
		);
		_deviceCoord.mulScalar(2);
		_deviceCoord.sub(Vec3.ONE);
		if (this._projection === PROJECTION_PERSPECTIVE) {
			Mat4._getPerspectiveHalfSize(_halfSize2, this.fov, this.aspectRatio, this.nearClip, this.horizontalFov);
			_halfSize2.x *= _deviceCoord.x;
			_halfSize2.y *= _deviceCoord.y;
			const invView = this._node.getWorldTransform();
			_halfSize2.z = -this.nearClip;
			invView.transformPoint(_halfSize2, _point);
			const cameraPos = this._node.getPosition();
			worldCoord.sub2(_point, cameraPos);
			worldCoord.normalize();
			worldCoord.mulScalar(z2);
			worldCoord.add(cameraPos);
		} else {
			this._updateViewProjMat();
			_invViewProjMat.copy(this._viewProjMat).invert();
			_invViewProjMat.transformPoint(_deviceCoord, worldCoord);
		}
		return worldCoord;
	}
	_evaluateProjectionMatrix() {
		const aspect = this.aspectRatio;
		if (this._projMatDirty) {
			if (this._projection === PROJECTION_PERSPECTIVE) {
				this._projMat.setPerspective(this.fov, aspect, this.nearClip, this.farClip, this.horizontalFov);
				this._projMatSkybox.copy(this._projMat);
			} else {
				const y2 = this._orthoHeight;
				const x3 = y2 * aspect;
				this._projMat.setOrtho(-x3, x3, -y2, y2, this.nearClip, this.farClip);
				this._projMatSkybox.setPerspective(this.fov, aspect, this.nearClip, this.farClip);
			}
			this._projMatDirty = false;
		}
	}
	getProjectionMatrixSkybox() {
		this._evaluateProjectionMatrix();
		return this._projMatSkybox;
	}
	getExposure() {
		const ev100 = Math.log2(this._aperture * this._aperture / this._shutter * 100 / this._sensitivity);
		return 1 / (Math.pow(2, ev100) * 1.2);
	}
	// returns estimated size of the sphere on the screen in range of [0..1]
	// 0 - infinitely small, 1 - full screen or larger
	getScreenSize(sphere) {
		if (this._projection === PROJECTION_PERSPECTIVE) {
			const distance = this._node.getPosition().distance(sphere.center);
			if (distance < sphere.radius) {
				return 1;
			}
			const viewAngle = Math.asin(sphere.radius / distance);
			const sphereViewHeight = Math.tan(viewAngle);
			const screenViewHeight = Math.tan(this.fov / 2 * math.DEG_TO_RAD);
			return Math.min(sphereViewHeight / screenViewHeight, 1);
		}
		return math.clamp(sphere.radius / this._orthoHeight, 0, 1);
	}
	getFrustumCorners(near = this.nearClip, far = this.farClip) {
		const fov = this.fov * math.DEG_TO_RAD;
		let x3, y2;
		if (this.projection === PROJECTION_PERSPECTIVE) {
			if (this.horizontalFov) {
				x3 = near * Math.tan(fov / 2);
				y2 = x3 / this.aspectRatio;
			} else {
				y2 = near * Math.tan(fov / 2);
				x3 = y2 * this.aspectRatio;
			}
		} else {
			y2 = this._orthoHeight;
			x3 = y2 * this.aspectRatio;
		}
		const points = _frustumPoints;
		points[0].x = x3;
		points[0].y = -y2;
		points[0].z = -near;
		points[1].x = x3;
		points[1].y = y2;
		points[1].z = -near;
		points[2].x = -x3;
		points[2].y = y2;
		points[2].z = -near;
		points[3].x = -x3;
		points[3].y = -y2;
		points[3].z = -near;
		if (this._projection === PROJECTION_PERSPECTIVE) {
			if (this.horizontalFov) {
				x3 = far * Math.tan(fov / 2);
				y2 = x3 / this.aspectRatio;
			} else {
				y2 = far * Math.tan(fov / 2);
				x3 = y2 * this.aspectRatio;
			}
		}
		points[4].x = x3;
		points[4].y = -y2;
		points[4].z = -far;
		points[5].x = x3;
		points[5].y = y2;
		points[5].z = -far;
		points[6].x = -x3;
		points[6].y = y2;
		points[6].z = -far;
		points[7].x = -x3;
		points[7].y = -y2;
		points[7].z = -far;
		return points;
	}
	setXrProperties(properties) {
		Object.assign(this._xrProperties, properties);
		this._projMatDirty = true;
	}
	fillShaderParams(output) {
		const f = this._farClip;
		output[0] = 1 / f;
		output[1] = f;
		output[2] = this._nearClip;
		output[3] = this._projection === PROJECTION_ORTHOGRAPHIC ? 1 : 0;
		return output;
	}
};

var RenderView = class extends EventHandler {
	_positionData = new Float32Array(3);
	_viewport = new Vec4();
	_projMat = new Mat4();
	_projViewOffMat = new Mat4();
	_viewMat = new Mat4();
	_viewOffMat = new Mat4();
	_viewMat3 = new Mat3();
	_viewInvMat = new Mat4();
	_viewInvOffMat = new Mat4();
	get viewport() {
		return this._viewport;
	}
	get projMat() {
		return this._projMat;
	}
	get projViewOffMat() {
		return this._projViewOffMat;
	}
	get viewOffMat() {
		return this._viewOffMat;
	}
	get viewInvOffMat() {
		return this._viewInvOffMat;
	}
	get viewMat3() {
		return this._viewMat3;
	}
	get positionData() {
		return this._positionData;
	}
	setView(projMat, viewInvMat2, viewMat2) {
		this._projMat.set(projMat);
		this._viewInvMat.set(viewInvMat2);
		if (viewMat2) {
			this._viewMat.set(viewMat2);
		} else {
			this._viewMat.copy(this._viewInvMat).invert();
		}
	}
	setViewport(x3, y2, width, height) {
		this._viewport.set(x3, y2, width, height);
	}
	updateTransforms(parentWorldTransform) {
		if (parentWorldTransform) {
			this._viewInvOffMat.mul2(parentWorldTransform, this._viewInvMat);
			this._viewOffMat.copy(this._viewInvOffMat).invert();
		} else {
			this._viewInvOffMat.copy(this._viewInvMat);
			this._viewOffMat.copy(this._viewMat);
		}
		this._viewMat3.setFromMat4(this._viewOffMat);
		this._projViewOffMat.mul2(this._projMat, this._viewOffMat);
		this._positionData[0] = this._viewInvOffMat.data[12];
		this._positionData[1] = this._viewInvOffMat.data[13];
		this._positionData[2] = this._viewInvOffMat.data[14];
	}
};

var _viewMat = new Mat4();
var _viewProjMat = new Mat4();
var _viewportMatrix = new Mat4();
var LightCamera = class _LightCamera {
	// camera rotation angles used when rendering cubemap faces
	static pointLightRotations = [
		new Quat().setFromEulerAngles(0, 90, 180),
		new Quat().setFromEulerAngles(0, -90, 180),
		new Quat().setFromEulerAngles(90, 0, 0),
		new Quat().setFromEulerAngles(-90, 0, 0),
		new Quat().setFromEulerAngles(0, 180, 180),
		new Quat().setFromEulerAngles(0, 0, 180)
	];
	static create(device, name, lightType, face) {
		const camera = new Camera(device);
		camera.node = new GraphNode(name);
		camera.aspectRatio = 1;
		camera.aspectRatioMode = ASPECT_MANUAL;
		camera._scissorRectClear = true;
		switch (lightType) {
			case LIGHTTYPE_OMNI:
				camera.node.setRotation(_LightCamera.pointLightRotations[face]);
				camera.fov = 90;
				camera.projection = PROJECTION_PERSPECTIVE;
				break;
			case LIGHTTYPE_SPOT:
				camera.projection = PROJECTION_PERSPECTIVE;
				break;
			case LIGHTTYPE_DIRECTIONAL:
				camera.projection = PROJECTION_ORTHOGRAPHIC;
				break;
		}
		return camera;
	}
	static _spotCookieCamera = null;
	// temporary camera to calculate spot light cookie view-projection matrix when shadow matrix is not available
	// todo - unify the code with the shadow spot camera
	static evalSpotCookieMatrix(light) {
		let cookieCamera = _LightCamera._spotCookieCamera;
		if (!cookieCamera) {
			cookieCamera = _LightCamera.create(light.device, "SpotCookieCamera", LIGHTTYPE_SPOT);
			_LightCamera._spotCookieCamera = cookieCamera;
		}
		cookieCamera.fov = light._outerConeAngle * 2;
		const cookieNode = cookieCamera._node;
		cookieNode.setPosition(light._node.getPosition());
		cookieNode.setRotation(light._node.getRotation());
		cookieNode.rotateLocal(-90, 0, 0);
		_viewMat.setTRS(cookieNode.getPosition(), cookieNode.getRotation(), Vec3.ONE).invert();
		_viewProjMat.mul2(cookieCamera.projectionMatrix, _viewMat);
		const cookieMatrix = light.cookieMatrix;
		const rectViewport = light.atlasViewport;
		_viewportMatrix.setViewport(rectViewport.x, rectViewport.y, rectViewport.z, rectViewport.w);
		cookieMatrix.mul2(_viewportMatrix, _viewProjMat);
		return cookieMatrix;
	}
};

var tempVec3 = new Vec3();
var tempAreaLightSizes = new Float32Array(6);
var areaHalfAxisWidth = new Vec3(-0.5, 0, 0);
var areaHalfAxisHeight = new Vec3(0, 0, 0.5);
var TextureIndexFloat = {
	POSITION_RANGE: 0,
	// positions.xyz, range
	DIRECTION_FLAGS: 1,
	// spot direction.xyz, 32bit flags
	COLOR_ANGLES_BIAS: 2,
	// x: color.rg, y: color.b & angle flags, z: cone angles, w: biases (all packed as 16-bit values)
	PROJ_MAT_0: 3,
	// projection matrix row 0 (spot light)
	ATLAS_VIEWPORT: 3,
	// atlas viewport data (omni light)
	PROJ_MAT_1: 4,
	// projection matrix row 1 (spot light)
	PROJ_MAT_2: 5,
	// projection matrix row 2 (spot light)
	PROJ_MAT_3: 6,
	// projection matrix row 3 (spot light)
	AREA_DATA_WIDTH: 7,
	// area light half-width.xyz, -
	AREA_DATA_HEIGHT: 8,
	// area light half-height.xyz, -
	// leave last
	COUNT: 9
};
var enums = {
	"LIGHTSHAPE_PUNCTUAL": `${LIGHTSHAPE_PUNCTUAL}u`,
	"LIGHTSHAPE_RECT": `${LIGHTSHAPE_RECT}u`,
	"LIGHTSHAPE_DISK": `${LIGHTSHAPE_DISK}u`,
	"LIGHTSHAPE_SPHERE": `${LIGHTSHAPE_SPHERE}u`,
	"LIGHT_COLOR_DIVIDER": `${LIGHT_COLOR_DIVIDER}.0`
};
var buildShaderDefines = (object, prefix) => {
	return Object.keys(object).map((key) => `#define {${prefix}${key}} ${object[key]}`).join("\n");
};
var lightBufferDefines = `

		${buildShaderDefines(TextureIndexFloat, "CLUSTER_TEXTURE_")}
		${buildShaderDefines(enums, "")}
`;
var LightsBuffer = class {
	areaLightsEnabled = false;
	constructor(device) {
		this.device = device;
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("lightBufferDefinesPS", lightBufferDefines);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("lightBufferDefinesPS", lightBufferDefines);
		this.cookiesEnabled = false;
		this.shadowsEnabled = false;
		this.areaLightsEnabled = false;
		this.maxLights = 255;
		const pixelsPerLightFloat = TextureIndexFloat.COUNT;
		this.lightsFloat = new Float32Array(4 * pixelsPerLightFloat * this.maxLights);
		this.lightsUint = new Uint32Array(this.lightsFloat.buffer);
		this.lightsTexture = this.createTexture(this.device, pixelsPerLightFloat, this.maxLights, PIXELFORMAT_RGBA32F, "LightsTexture");
		this._lightsTextureId = this.device.scope.resolve("lightsTexture");
		this.invMaxColorValue = 0;
		this.invMaxAttenuation = 0;
		this.boundsMin = new Vec3();
		this.boundsDelta = new Vec3();
	}
	destroy() {
		this.lightsTexture?.destroy();
		this.lightsTexture = null;
	}
	createTexture(device, width, height, format, name) {
		const tex = new Texture(device, {
			name,
			width,
			height,
			mipmaps: false,
			format,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			type: TEXTURETYPE_DEFAULT,
			magFilter: FILTER_NEAREST,
			minFilter: FILTER_NEAREST,
			anisotropy: 1
		});
		return tex;
	}
	setBounds(min, delta3) {
		this.boundsMin.copy(min);
		this.boundsDelta.copy(delta3);
	}
	uploadTextures() {
		this.lightsTexture.lock().set(this.lightsFloat);
		this.lightsTexture.unlock();
	}
	updateUniforms() {
		this._lightsTextureId.setValue(this.lightsTexture);
	}
	getSpotDirection(direction, spot) {
		const mat2 = spot._node.getWorldTransform();
		mat2.getY(direction).mulScalar(-1);
		direction.normalize();
	}
	// half sizes of area light in world space, returned as an array of 6 floats
	getLightAreaSizes(light) {
		const mat2 = light._node.getWorldTransform();
		mat2.transformVector(areaHalfAxisWidth, tempVec3);
		tempAreaLightSizes[0] = tempVec3.x;
		tempAreaLightSizes[1] = tempVec3.y;
		tempAreaLightSizes[2] = tempVec3.z;
		mat2.transformVector(areaHalfAxisHeight, tempVec3);
		tempAreaLightSizes[3] = tempVec3.x;
		tempAreaLightSizes[4] = tempVec3.y;
		tempAreaLightSizes[5] = tempVec3.z;
		return tempAreaLightSizes;
	}
	// fill up both float and 8bit texture data with light properties
	addLightData(light, lightIndex) {
		const isSpot = light._type === LIGHTTYPE_SPOT;
		const hasAtlasViewport = light.atlasViewportAllocated;
		const isCookie = this.cookiesEnabled && !!light._cookie && hasAtlasViewport;
		const isArea = this.areaLightsEnabled && light.shape !== LIGHTSHAPE_PUNCTUAL;
		const castShadows = this.shadowsEnabled && light.castShadows && hasAtlasViewport;
		const pos = light._node.getPosition();
		let lightProjectionMatrix = null;
		let atlasViewport = null;
		if (isSpot) {
			if (castShadows) {
				const lightRenderData = light.getRenderData(null, 0);
				lightProjectionMatrix = lightRenderData.shadowMatrix;
			} else if (isCookie) {
				lightProjectionMatrix = LightCamera.evalSpotCookieMatrix(light);
			}
		} else {
			if (castShadows || isCookie) {
				atlasViewport = light.atlasViewport;
			}
		}
		const dataFloat = this.lightsFloat;
		const dataUint = this.lightsUint;
		const dataFloatStart = lightIndex * this.lightsTexture.width * 4;
		dataFloat[dataFloatStart + 4 * TextureIndexFloat.POSITION_RANGE + 0] = pos.x;
		dataFloat[dataFloatStart + 4 * TextureIndexFloat.POSITION_RANGE + 1] = pos.y;
		dataFloat[dataFloatStart + 4 * TextureIndexFloat.POSITION_RANGE + 2] = pos.z;
		dataFloat[dataFloatStart + 4 * TextureIndexFloat.POSITION_RANGE + 3] = light.attenuationEnd;
		const clusteredData = light.clusteredData;
		dataUint[dataFloatStart + 4 * TextureIndexFloat.COLOR_ANGLES_BIAS + 0] = clusteredData[0];
		dataUint[dataFloatStart + 4 * TextureIndexFloat.COLOR_ANGLES_BIAS + 1] = clusteredData[1];
		dataUint[dataFloatStart + 4 * TextureIndexFloat.COLOR_ANGLES_BIAS + 2] = clusteredData[2];
		if (light.castShadows) {
			const lightRenderData = light.getRenderData(null, 0);
			const biases = light._getUniformBiasValues(lightRenderData);
			const biasHalf = FloatPacking.float2Half(biases.bias);
			const normalBiasHalf = FloatPacking.float2Half(biases.normalBias);
			dataUint[dataFloatStart + 4 * TextureIndexFloat.COLOR_ANGLES_BIAS + 3] = biasHalf | normalBiasHalf << 16;
		}
		if (isSpot) {
			this.getSpotDirection(tempVec3, light);
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.DIRECTION_FLAGS + 0] = tempVec3.x;
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.DIRECTION_FLAGS + 1] = tempVec3.y;
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.DIRECTION_FLAGS + 2] = tempVec3.z;
		}
		dataUint[dataFloatStart + 4 * TextureIndexFloat.DIRECTION_FLAGS + 3] = light.getClusteredFlags(castShadows, isCookie);
		if (lightProjectionMatrix) {
			const matData = lightProjectionMatrix.data;
			for (let m = 0; m < 16; m++) {
				dataFloat[dataFloatStart + 4 * TextureIndexFloat.PROJ_MAT_0 + m] = matData[m];
			}
		}
		if (atlasViewport) {
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.ATLAS_VIEWPORT + 0] = atlasViewport.x;
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.ATLAS_VIEWPORT + 1] = atlasViewport.y;
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.ATLAS_VIEWPORT + 2] = atlasViewport.z / 3;
		}
		if (isArea) {
			const areaSizes = this.getLightAreaSizes(light);
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.AREA_DATA_WIDTH + 0] = areaSizes[0];
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.AREA_DATA_WIDTH + 1] = areaSizes[1];
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.AREA_DATA_WIDTH + 2] = areaSizes[2];
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.AREA_DATA_HEIGHT + 0] = areaSizes[3];
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.AREA_DATA_HEIGHT + 1] = areaSizes[4];
			dataFloat[dataFloatStart + 4 * TextureIndexFloat.AREA_DATA_HEIGHT + 2] = areaSizes[5];
		}
	}
};

var tmpSize = new Vec2();
var tempVec32 = new Vec3();
var tempMin3 = new Vec3();
var tempMax3 = new Vec3();
var tempBox = new BoundingBox();
var ClusterLight = class {
	constructor() {
		this.light = null;
		this.min = new Vec3();
		this.max = new Vec3();
	}
};
var WorldClusters = class {
	clusterTexture;
	constructor(device) {
		this.device = device;
		this.name = "Untitled";
		this.reportCount = 0;
		this.boundsMin = new Vec3();
		this.boundsMax = new Vec3();
		this.boundsDelta = new Vec3();
		this._cells = new Vec3(1, 1, 1);
		this._cellsLimit = new Vec3();
		this.cells = this._cells;
		this.maxCellLightCount = 4;
		this._usedLights = [];
		this._usedLights.push(new ClusterLight());
		this.lightsBuffer = new LightsBuffer(device);
		this.registerUniforms(device);
	}
	set maxCellLightCount(count) {
		if (count !== this._maxCellLightCount) {
			this._maxCellLightCount = count;
			this._cellsDirty = true;
		}
	}
	get maxCellLightCount() {
		return this._maxCellLightCount;
	}
	set cells(value) {
		tempVec32.copy(value).floor();
		if (!this._cells.equals(tempVec32)) {
			this._cells.copy(tempVec32);
			this._cellsLimit.copy(tempVec32).sub(Vec3.ONE);
			this._cellsDirty = true;
		}
	}
	get cells() {
		return this._cells;
	}
	destroy() {
		this.lightsBuffer.destroy();
		this.releaseClusterTexture();
	}
	releaseClusterTexture() {
		if (this.clusterTexture) {
			this.clusterTexture.destroy();
			this.clusterTexture = null;
		}
	}
	registerUniforms(device) {
		this._numClusteredLightsId = device.scope.resolve("numClusteredLights");
		this._clusterMaxCellsId = device.scope.resolve("clusterMaxCells");
		this._clusterWorldTextureId = device.scope.resolve("clusterWorldTexture");
		this._clusterBoundsMinId = device.scope.resolve("clusterBoundsMin");
		this._clusterBoundsMinData = new Float32Array(3);
		this._clusterBoundsDeltaId = device.scope.resolve("clusterBoundsDelta");
		this._clusterBoundsDeltaData = new Float32Array(3);
		this._clusterCellsCountByBoundsSizeId = device.scope.resolve("clusterCellsCountByBoundsSize");
		this._clusterCellsCountByBoundsSizeData = new Float32Array(3);
		this._clusterCellsDotId = device.scope.resolve("clusterCellsDot");
		this._clusterCellsDotData = new Int32Array(3);
		this._clusterCellsMaxId = device.scope.resolve("clusterCellsMax");
		this._clusterCellsMaxData = new Int32Array(3);
		this._clusterTextureWidthId = device.scope.resolve("clusterTextureWidth");
	}
	// updates itself based on parameters stored in the scene
	updateParams(lightingParams) {
		if (lightingParams) {
			this.cells = lightingParams.cells;
			this.maxCellLightCount = lightingParams.maxLightsPerCell;
			this.lightsBuffer.cookiesEnabled = lightingParams.cookiesEnabled;
			this.lightsBuffer.shadowsEnabled = lightingParams.shadowsEnabled;
			this.lightsBuffer.areaLightsEnabled = lightingParams.areaLightsEnabled;
		}
	}
	updateCells() {
		if (this._cellsDirty) {
			this._cellsDirty = false;
			const cx = this._cells.x;
			const cy = this._cells.y;
			const cz = this._cells.z;
			const numCells = cx * cy * cz;
			const totalPixels = this.maxCellLightCount * numCells;
			const { x: width, y: height } = TextureUtils.calcTextureSize(totalPixels, tmpSize, this.maxCellLightCount);
			this._clusterCellsMaxData[0] = cx;
			this._clusterCellsMaxData[1] = cy;
			this._clusterCellsMaxData[2] = cz;
			this._clusterCellsDotData[0] = this.maxCellLightCount;
			this._clusterCellsDotData[1] = cx * cz * this.maxCellLightCount;
			this._clusterCellsDotData[2] = cx * this.maxCellLightCount;
			this.clusters = new Uint8ClampedArray(totalPixels);
			this.counts = new Int32Array(numCells);
			this.releaseClusterTexture();
			this.clusterTexture = this.lightsBuffer.createTexture(this.device, width, height, PIXELFORMAT_R8U, "ClusterTexture");
		}
	}
	uploadTextures() {
		this.clusterTexture.lock().set(this.clusters);
		this.clusterTexture.unlock();
		this.lightsBuffer.uploadTextures();
	}
	updateUniforms() {
		this._numClusteredLightsId.setValue(this._usedLights.length);
		this.lightsBuffer.updateUniforms();
		this._clusterWorldTextureId.setValue(this.clusterTexture);
		this._clusterMaxCellsId.setValue(this.maxCellLightCount);
		const boundsDelta = this.boundsDelta;
		this._clusterCellsCountByBoundsSizeData[0] = this._cells.x / boundsDelta.x;
		this._clusterCellsCountByBoundsSizeData[1] = this._cells.y / boundsDelta.y;
		this._clusterCellsCountByBoundsSizeData[2] = this._cells.z / boundsDelta.z;
		this._clusterCellsCountByBoundsSizeId.setValue(this._clusterCellsCountByBoundsSizeData);
		this._clusterBoundsMinData[0] = this.boundsMin.x;
		this._clusterBoundsMinData[1] = this.boundsMin.y;
		this._clusterBoundsMinData[2] = this.boundsMin.z;
		this._clusterBoundsDeltaData[0] = boundsDelta.x;
		this._clusterBoundsDeltaData[1] = boundsDelta.y;
		this._clusterBoundsDeltaData[2] = boundsDelta.z;
		this._clusterBoundsMinId.setValue(this._clusterBoundsMinData);
		this._clusterBoundsDeltaId.setValue(this._clusterBoundsDeltaData);
		this._clusterCellsDotId.setValue(this._clusterCellsDotData);
		this._clusterCellsMaxId.setValue(this._clusterCellsMaxData);
		this._clusterTextureWidthId.setValue(this.clusterTexture.width);
	}
	// evaluates min and max coordinates of AABB of the light in the cell space
	evalLightCellMinMax(clusteredLight, min, max) {
		min.copy(clusteredLight.min);
		min.sub(this.boundsMin);
		min.div(this.boundsDelta);
		min.mul2(min, this.cells);
		min.floor();
		max.copy(clusteredLight.max);
		max.sub(this.boundsMin);
		max.div(this.boundsDelta);
		max.mul2(max, this.cells);
		max.ceil();
		min.max(Vec3.ZERO);
		max.min(this._cellsLimit);
	}
	collectLights(lights2) {
		const maxLights = this.lightsBuffer.maxLights;
		const usedLights = this._usedLights;
		let lightIndex = 1;
		lights2.forEach((light) => {
			const runtimeLight = !!(light.mask & (MASK_AFFECT_DYNAMIC | MASK_AFFECT_LIGHTMAPPED));
			const zeroAngleSpotlight = light.type === LIGHTTYPE_SPOT && light._outerConeAngle === 0;
			if (light.enabled && light.type !== LIGHTTYPE_DIRECTIONAL && light.visibleThisFrame && light.intensity > 0 && runtimeLight && !zeroAngleSpotlight) {
				if (lightIndex < maxLights) {
					let clusteredLight;
					if (lightIndex < usedLights.length) {
						clusteredLight = usedLights[lightIndex];
					} else {
						clusteredLight = new ClusterLight();
						usedLights.push(clusteredLight);
					}
					clusteredLight.light = light;
					light.getBoundingBox(tempBox);
					clusteredLight.min.copy(tempBox.getMin());
					clusteredLight.max.copy(tempBox.getMax());
					lightIndex++;
				} else {
				}
			}
		});
		usedLights.length = lightIndex;
	}
	// evaluate the area all lights cover
	evaluateBounds() {
		const usedLights = this._usedLights;
		const min = this.boundsMin;
		const max = this.boundsMax;
		if (usedLights.length > 1) {
			min.copy(usedLights[1].min);
			max.copy(usedLights[1].max);
			for (let i2 = 2; i2 < usedLights.length; i2++) {
				min.min(usedLights[i2].min);
				max.max(usedLights[i2].max);
			}
		} else {
			min.set(0, 0, 0);
			max.set(1, 1, 1);
		}
		this.boundsDelta.sub2(max, min);
		this.lightsBuffer.setBounds(min, this.boundsDelta);
	}
	updateClusters(lightingParams) {
		this.counts.fill(0);
		this.clusters.fill(0);
		this.lightsBuffer.areaLightsEnabled = lightingParams ? lightingParams.areaLightsEnabled : false;
		const divX = this._cells.x;
		const divZ = this._cells.z;
		const counts = this.counts;
		const limit = this._maxCellLightCount;
		const clusters = this.clusters;
		const pixelsPerCellCount = this.maxCellLightCount;
		let tooManyLights = false;
		const usedLights = this._usedLights;
		for (let i2 = 1; i2 < usedLights.length; i2++) {
			const clusteredLight = usedLights[i2];
			const light = clusteredLight.light;
			this.lightsBuffer.addLightData(light, i2);
			this.evalLightCellMinMax(clusteredLight, tempMin3, tempMax3);
			const xStart = tempMin3.x;
			const xEnd = tempMax3.x;
			const yStart = tempMin3.y;
			const yEnd = tempMax3.y;
			const zStart = tempMin3.z;
			const zEnd = tempMax3.z;
			for (let x3 = xStart; x3 <= xEnd; x3++) {
				for (let z2 = zStart; z2 <= zEnd; z2++) {
					for (let y2 = yStart; y2 <= yEnd; y2++) {
						const clusterIndex = x3 + divX * (z2 + y2 * divZ);
						const count = counts[clusterIndex];
						if (count < limit) {
							clusters[pixelsPerCellCount * clusterIndex + count] = i2;
							counts[clusterIndex] = count + 1;
						} else {
							tooManyLights = true;
						}
					}
				}
			}
		}
	}
	// internal update of the cluster data, executes once per frame
	update(lights2, lightingParams = null) {
		this.updateParams(lightingParams);
		this.updateCells();
		this.collectLights(lights2);
		this.evaluateBounds();
		this.updateClusters(lightingParams);
		this.uploadTextures();
	}
	// called on already updated clusters, activates for rendering by setting up uniforms / textures on the device
	activate() {
		this.updateUniforms();
	}
};

var _goldenAngle = 2.399963229728653;
var random = {
	circlePoint(point5) {
		const r = Math.sqrt(Math.random());
		const theta = Math.random() * 2 * Math.PI;
		point5.x = r * Math.cos(theta);
		point5.y = r * Math.sin(theta);
	},
	circlePointDeterministic(point5, index, numPoints) {
		const theta = index * _goldenAngle;
		const r = Math.sqrt(index / numPoints);
		point5.x = r * Math.cos(theta);
		point5.y = r * Math.sin(theta);
	},
	spherePointDeterministic(point5, index, numPoints, start = 0, end = 1) {
		start = 1 - 2 * start;
		end = 1 - 2 * end;
		const y2 = math.lerp(start, end, index / numPoints);
		const radius = Math.sqrt(1 - y2 * y2);
		const theta = _goldenAngle * index;
		point5.x = Math.cos(theta) * radius;
		point5.y = y2;
		point5.z = Math.sin(theta) * radius;
	},
	radicalInverse(i2) {
		let bits = (i2 << 16 | i2 >>> 16) >>> 0;
		bits = ((bits & 1431655765) << 1 | (bits & 2863311530) >>> 1) >>> 0;
		bits = ((bits & 858993459) << 2 | (bits & 3435973836) >>> 2) >>> 0;
		bits = ((bits & 252645135) << 4 | (bits & 4042322160) >>> 4) >>> 0;
		bits = ((bits & 16711935) << 8 | (bits & 4278255360) >>> 8) >>> 0;
		return bits * 23283064365386963e-26;
	}
};

var decodeTable = {
	"linear": "decodeLinear",
	"srgb": "decodeGamma",
	"rgbm": "decodeRGBM",
	"rgbe": "decodeRGBE",
	"rgbp": "decodeRGBP",
	"xy": "unpackNormalXY",
	"xyz": "unpackNormalXYZ"
};
var encodeTable = {
	"linear": "encodeLinear",
	"srgb": "encodeGamma",
	"rgbm": "encodeRGBM",
	"rgbe": "encodeRGBE",
	"rgbp": "encodeRGBP"
};
var ChunkUtils = class {
	// returns the name of the decode function for the texture encoding
	static decodeFunc(encoding) {
		return decodeTable[encoding] ?? "decodeGamma";
	}
	static encodeFunc(encoding) {
		return encodeTable[encoding] ?? "encodeGamma";
	}
};

var getProjectionName = (projection) => {
	switch (projection) {
		case TEXTUREPROJECTION_CUBE:
			return "Cubemap";
		case TEXTUREPROJECTION_OCTAHEDRAL:
			return "Octahedral";
		default:
			return "Equirect";
	}
};
var packFloat32ToRGBA8 = (value, array3, offset3) => {
	if (value <= 0) {
		array3[offset3 + 0] = 0;
		array3[offset3 + 1] = 0;
		array3[offset3 + 2] = 0;
		array3[offset3 + 3] = 0;
	} else if (value >= 1) {
		array3[offset3 + 0] = 255;
		array3[offset3 + 1] = 0;
		array3[offset3 + 2] = 0;
		array3[offset3 + 3] = 0;
	} else {
		let encX = 1 * value % 1;
		let encY = 255 * value % 1;
		let encZ = 65025 * value % 1;
		const encW = 16581375 * value % 1;
		encX -= encY / 255;
		encY -= encZ / 255;
		encZ -= encW / 255;
		array3[offset3 + 0] = Math.min(255, Math.floor(encX * 256));
		array3[offset3 + 1] = Math.min(255, Math.floor(encY * 256));
		array3[offset3 + 2] = Math.min(255, Math.floor(encZ * 256));
		array3[offset3 + 3] = Math.min(255, Math.floor(encW * 256));
	}
};
var packSamples = (samples) => {
	const numSamples = samples.length;
	const w = Math.min(numSamples, 512);
	const h2 = Math.ceil(numSamples / w);
	const data2 = new Uint8Array(w * h2 * 4);
	let off = 0;
	for (let i2 = 0; i2 < numSamples; i2 += 4) {
		packFloat32ToRGBA8(samples[i2 + 0] * 0.5 + 0.5, data2, off + 0);
		packFloat32ToRGBA8(samples[i2 + 1] * 0.5 + 0.5, data2, off + 4);
		packFloat32ToRGBA8(samples[i2 + 2] * 0.5 + 0.5, data2, off + 8);
		packFloat32ToRGBA8(samples[i2 + 3] / 8, data2, off + 12);
		off += 16;
	}
	return {
		width: w,
		height: h2,
		data: data2
	};
};
var hemisphereSamplePhong = (dstVec, x3, y2, specularPower) => {
	const phi = y2 * 2 * Math.PI;
	const cosTheta = Math.pow(1 - x3, 1 / (specularPower + 1));
	const sinTheta = Math.sqrt(1 - cosTheta * cosTheta);
	dstVec.set(Math.cos(phi) * sinTheta, Math.sin(phi) * sinTheta, cosTheta).normalize();
};
var hemisphereSampleLambert = (dstVec, x3, y2) => {
	const phi = y2 * 2 * Math.PI;
	const cosTheta = Math.sqrt(1 - x3);
	const sinTheta = Math.sqrt(x3);
	dstVec.set(Math.cos(phi) * sinTheta, Math.sin(phi) * sinTheta, cosTheta).normalize();
};
var hemisphereSampleGGX = (dstVec, x3, y2, a) => {
	const phi = y2 * 2 * Math.PI;
	const cosTheta = Math.sqrt((1 - x3) / (1 + (a * a - 1) * x3));
	const sinTheta = Math.sqrt(1 - cosTheta * cosTheta);
	dstVec.set(Math.cos(phi) * sinTheta, Math.sin(phi) * sinTheta, cosTheta).normalize();
};
var D_GGX = (NoH, linearRoughness) => {
	const a = NoH * linearRoughness;
	const k = linearRoughness / (1 - NoH * NoH + a * a);
	return k * k * (1 / Math.PI);
};
var generatePhongSamples = (numSamples, specularPower) => {
	const H = new Vec3();
	const result = [];
	for (let i2 = 0; i2 < numSamples; ++i2) {
		hemisphereSamplePhong(H, i2 / numSamples, random.radicalInverse(i2), specularPower);
		result.push(H.x, H.y, H.z, 0);
	}
	return result;
};
var generateLambertSamples = (numSamples, sourceTotalPixels) => {
	const pixelsPerSample = sourceTotalPixels / numSamples;
	const H = new Vec3();
	const result = [];
	for (let i2 = 0; i2 < numSamples; ++i2) {
		hemisphereSampleLambert(H, i2 / numSamples, random.radicalInverse(i2));
		const pdf = H.z / Math.PI;
		const mipLevel = 0.5 * Math.log2(pixelsPerSample / pdf);
		result.push(H.x, H.y, H.z, mipLevel);
	}
	return result;
};
var requiredSamplesGGX = {
	"16": {
		"2": 26,
		"8": 20,
		"32": 17,
		"128": 16,
		"512": 16
	},
	"32": {
		"2": 53,
		"8": 40,
		"32": 34,
		"128": 32,
		"512": 32
	},
	"128": {
		"2": 214,
		"8": 163,
		"32": 139,
		"128": 130,
		"512": 128
	},
	"1024": {
		"2": 1722,
		"8": 1310,
		"32": 1114,
		"128": 1041,
		"512": 1025
	}
};
var getRequiredSamplesGGX = (numSamples, specularPower) => {
	const table = requiredSamplesGGX[numSamples];
	return table && table[specularPower] || numSamples;
};
var generateGGXSamples = (numSamples, specularPower, sourceTotalPixels) => {
	const pixelsPerSample = sourceTotalPixels / numSamples;
	const roughness = 1 - Math.log2(specularPower) / 11;
	const a = roughness * roughness;
	const H = new Vec3();
	const L = new Vec3();
	const N = new Vec3(0, 0, 1);
	const result = [];
	const requiredSamples = getRequiredSamplesGGX(numSamples, specularPower);
	for (let i2 = 0; i2 < requiredSamples; ++i2) {
		hemisphereSampleGGX(H, i2 / requiredSamples, random.radicalInverse(i2), a);
		const NoH = H.z;
		L.set(H.x, H.y, H.z).mulScalar(2 * NoH).sub(N);
		if (L.z > 0) {
			const pdf = D_GGX(Math.min(1, NoH), a) / 4 + 1e-3;
			const mipLevel = 0.5 * Math.log2(pixelsPerSample / pdf);
			result.push(L.x, L.y, L.z, mipLevel);
		}
	}
	while (result.length < numSamples * 4) {
		result.push(0, 0, 0, 0);
	}
	return result;
};
var createSamplesTex = (device, name, samples) => {
	const packedSamples = packSamples(samples);
	return new Texture(device, {
		name,
		width: packedSamples.width,
		height: packedSamples.height,
		mipmaps: false,
		minFilter: FILTER_NEAREST,
		magFilter: FILTER_NEAREST,
		levels: [packedSamples.data]
	});
};
var SimpleCache = class {
	constructor(destroyContent = true) {
		this.destroyContent = destroyContent;
	}
	map = /* @__PURE__ */ new Map();
	destroy() {
		if (this.destroyContent) {
			this.map.forEach((value, key) => {
				value.destroy();
			});
		}
	}
	get(key, missFunc) {
		if (!this.map.has(key)) {
			const result = missFunc();
			this.map.set(key, result);
			return result;
		}
		return this.map.get(key);
	}
};
var samplesCache = new SimpleCache(false);
var deviceCache3 = new DeviceCache();
var getCachedTexture = (device, key, getSamplesFnc) => {
	const cache = deviceCache3.get(device, () => {
		return new SimpleCache();
	});
	return cache.get(key, () => {
		return createSamplesTex(device, key, samplesCache.get(key, getSamplesFnc));
	});
};
var generateLambertSamplesTex = (device, numSamples, sourceTotalPixels) => {
	const key = `lambert-samples-${numSamples}-${sourceTotalPixels}`;
	return getCachedTexture(device, key, () => {
		return generateLambertSamples(numSamples, sourceTotalPixels);
	});
};
var generatePhongSamplesTex = (device, numSamples, specularPower) => {
	const key = `phong-samples-${numSamples}-${specularPower}`;
	return getCachedTexture(device, key, () => {
		return generatePhongSamples(numSamples, specularPower);
	});
};
var generateGGXSamplesTex = (device, numSamples, specularPower, sourceTotalPixels) => {
	const key = `ggx-samples-${numSamples}-${specularPower}-${sourceTotalPixels}`;
	return getCachedTexture(device, key, () => {
		return generateGGXSamples(numSamples, specularPower, sourceTotalPixels);
	});
};
function reprojectTexture(source, target2, options2 = {}) {
	const seamPixels = options2.seamPixels ?? 0;
	const innerWidth = (options2.rect?.z ?? target2.width) - seamPixels * 2;
	const innerHeight = (options2.rect?.w ?? target2.height) - seamPixels * 2;
	if (innerWidth < 1 || innerHeight < 1) {
		return false;
	}
	const funcNames = {
		"none": "reproject",
		"lambert": "prefilterSamplesUnweighted",
		"phong": "prefilterSamplesUnweighted",
		"ggx": "prefilterSamples"
	};
	const specularPower = options2.hasOwnProperty("specularPower") ? options2.specularPower : 1;
	const face = options2.hasOwnProperty("face") ? options2.face : null;
	const distribution = options2.hasOwnProperty("distribution") ? options2.distribution : specularPower === 1 ? "none" : "phong";
	const processFunc = funcNames[distribution] || "reproject";
	const prefilterSamples = processFunc.startsWith("prefilterSamples");
	const decodeFunc = ChunkUtils.decodeFunc(source.encoding);
	const encodeFunc = ChunkUtils.encodeFunc(target2.encoding);
	const sourceFunc = `sample${getProjectionName(source.projection)}`;
	const targetFunc = `getDirection${getProjectionName(target2.projection)}`;
	const numSamples = options2.hasOwnProperty("numSamples") ? options2.numSamples : 1024;
	const shaderKey = `ReprojectShader:${processFunc}_${decodeFunc}_${encodeFunc}_${sourceFunc}_${targetFunc}_${numSamples}`;
	const device = source.device;
	let shader = getProgramLibrary(device).getCachedShader(shaderKey);
	if (!shader) {
		const defines = /* @__PURE__ */ new Map();
		if (prefilterSamples) defines.set("USE_SAMPLES_TEX", "");
		if (source.cubemap) defines.set("CUBEMAP_SOURCE", "");
		defines.set("{PROCESS_FUNC}", processFunc);
		defines.set("{DECODE_FUNC}", decodeFunc);
		defines.set("{ENCODE_FUNC}", encodeFunc);
		defines.set("{SOURCE_FUNC}", sourceFunc);
		defines.set("{TARGET_FUNC}", targetFunc);
		defines.set("{NUM_SAMPLES}", numSamples);
		defines.set("{NUM_SAMPLES_SQRT}", Math.round(Math.sqrt(numSamples)).toFixed(1));
		shader = ShaderUtils.createShader(device, {
			uniqueName: shaderKey,
			attributes: { vertex_position: SEMANTIC_POSITION },
			vertexChunk: "reprojectVS",
			fragmentChunk: "reprojectPS",
			fragmentDefines: defines
		});
	}
	device.setBlendState(BlendState.NOBLEND);
	const constantSource = device.scope.resolve(source.cubemap ? "sourceCube" : "sourceTex");
	constantSource.setValue(source);
	const constantParams = device.scope.resolve("params");
	const uvModParam = device.scope.resolve("uvMod");
	if (seamPixels > 0) {
		uvModParam.setValue([
			(innerWidth + seamPixels * 2) / innerWidth,
			(innerHeight + seamPixels * 2) / innerHeight,
			-seamPixels / innerWidth,
			-seamPixels / innerHeight
		]);
	} else {
		uvModParam.setValue([1, 1, 0, 0]);
	}
	const params = [
		0,
		target2.width * target2.height * (target2.cubemap ? 6 : 1),
		source.width * source.height * (source.cubemap ? 6 : 1)
	];
	if (prefilterSamples) {
		const sourceTotalPixels = source.width * source.height * (source.cubemap ? 6 : 1);
		const samplesTex = distribution === "ggx" ? generateGGXSamplesTex(device, numSamples, specularPower, sourceTotalPixels) : distribution === "lambert" ? generateLambertSamplesTex(device, numSamples, sourceTotalPixels) : generatePhongSamplesTex(device, numSamples, specularPower);
		device.scope.resolve("samplesTex").setValue(samplesTex);
		device.scope.resolve("samplesTexInverseSize").setValue([1 / samplesTex.width, 1 / samplesTex.height]);
	}
	for (let f = 0; f < (target2.cubemap ? 6 : 1); f++) {
		if (face === null || f === face) {
			const renderTarget = new RenderTarget({
				colorBuffer: target2,
				face: f,
				depth: false,
				flipY: device.isWebGPU
			});
			params[0] = f;
			constantParams.setValue(params);
			drawQuadWithShader(device, renderTarget, shader, options2?.rect);
			renderTarget.destroy();
		}
	}
	return true;
}

var calcLevels = (width, height = 0) => {
	return 1 + Math.floor(Math.log2(Math.max(width, height)));
};
var supportsFloat16 = (device) => {
	return device.textureHalfFloatRenderable;
};
var supportsFloat32 = (device) => {
	return device.textureFloatRenderable;
};
var lightingSourcePixelFormat = (device) => {
	return supportsFloat16(device) ? PIXELFORMAT_RGBA16F : supportsFloat32(device) ? PIXELFORMAT_RGBA32F : PIXELFORMAT_RGBA8;
};
var lightingPixelFormat = (device) => {
	return PIXELFORMAT_RGBA8;
};
var createCubemap = (device, size, format, mipmaps) => {
	return new Texture(device, {
		name: `lighting-${size}`,
		cubemap: true,
		width: size,
		height: size,
		format,
		type: format === PIXELFORMAT_RGBA8 ? TEXTURETYPE_RGBP : TEXTURETYPE_DEFAULT,
		addressU: ADDRESS_CLAMP_TO_EDGE,
		addressV: ADDRESS_CLAMP_TO_EDGE,
		mipmaps: !!mipmaps
	});
};
var EnvLighting = class {
	static generateSkyboxCubemap(source, size) {
		const device = source.device;
		const result = createCubemap(device, size || (source.cubemap ? source.width : source.width / 4), PIXELFORMAT_RGBA8, false);
		reprojectTexture(source, result, {
			numSamples: 1024
		});
		return result;
	}
	static generateLightingSource(source, options2) {
		const device = source.device;
		const format = lightingSourcePixelFormat(device);
		const result = options2?.target || new Texture(device, {
			name: "lighting-source",
			cubemap: true,
			width: options2?.size || 128,
			height: options2?.size || 128,
			format,
			type: format === PIXELFORMAT_RGBA8 ? TEXTURETYPE_RGBP : TEXTURETYPE_DEFAULT,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			mipmaps: true
		});
		reprojectTexture(source, result, {
			numSamples: source.mipmaps ? 1 : 1024
		});
		return result;
	}
	static generateAtlas(source, options2) {
		const device = source.device;
		const format = lightingPixelFormat(device);
		const result = options2?.target || new Texture(device, {
			name: "envAtlas",
			width: options2?.size || 512,
			height: options2?.size || 512,
			format,
			type: format === PIXELFORMAT_RGBA8 ? TEXTURETYPE_RGBP : TEXTURETYPE_DEFAULT,
			projection: TEXTUREPROJECTION_EQUIRECT,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			mipmaps: false
		});
		const s2 = result.width / 512;
		const rect = new Vec4(0, 0, 512 * s2, 256 * s2);
		const levels = calcLevels(256) - calcLevels(4);
		for (let i2 = 0; i2 < levels; ++i2) {
			reprojectTexture(source, result, {
				numSamples: 1,
				rect,
				seamPixels: s2
			});
			rect.x += rect.w;
			rect.y += rect.w;
			rect.z = Math.max(1, Math.floor(rect.z * 0.5));
			rect.w = Math.max(1, Math.floor(rect.w * 0.5));
		}
		rect.set(0, 256 * s2, 256 * s2, 128 * s2);
		for (let i2 = 1; i2 < 7; ++i2) {
			reprojectTexture(source, result, {
				numSamples: options2?.numReflectionSamples || 1024,
				distribution: options2?.distribution || "ggx",
				specularPower: Math.max(1, 2048 >> i2 * 2),
				rect,
				seamPixels: s2
			});
			rect.y += rect.w;
			rect.z = Math.max(1, Math.floor(rect.z * 0.5));
			rect.w = Math.max(1, Math.floor(rect.w * 0.5));
		}
		rect.set(128 * s2, (256 + 128) * s2, 64 * s2, 32 * s2);
		reprojectTexture(source, result, {
			numSamples: options2?.numAmbientSamples || 2048,
			distribution: "lambert",
			rect,
			seamPixels: s2
		});
		return result;
	}
	static generatePrefilteredAtlas(sources, options2) {
		const device = sources[0].device;
		const format = sources[0].format;
		const type = sources[0].type;
		const result = options2?.target || new Texture(device, {
			name: "envPrefilteredAtlas",
			width: options2?.size || 512,
			height: options2?.size || 512,
			format,
			type,
			projection: TEXTUREPROJECTION_EQUIRECT,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			mipmaps: false
		});
		const s2 = result.width / 512;
		const rect = new Vec4(0, 0, 512 * s2, 256 * s2);
		const levels = calcLevels(512);
		for (let i2 = 0; i2 < levels; ++i2) {
			reprojectTexture(sources[0], result, {
				numSamples: 1,
				rect,
				seamPixels: s2
			});
			rect.x += rect.w;
			rect.y += rect.w;
			rect.z = Math.max(1, Math.floor(rect.z * 0.5));
			rect.w = Math.max(1, Math.floor(rect.w * 0.5));
		}
		rect.set(0, 256 * s2, 256 * s2, 128 * s2);
		for (let i2 = 1; i2 < sources.length; ++i2) {
			reprojectTexture(sources[i2], result, {
				numSamples: 1,
				rect,
				seamPixels: s2
			});
			rect.y += rect.w;
			rect.z = Math.max(1, Math.floor(rect.z * 0.5));
			rect.w = Math.max(1, Math.floor(rect.w * 0.5));
		}
		rect.set(128 * s2, (256 + 128) * s2, 64 * s2, 32 * s2);
		if (options2?.legacyAmbient) {
			reprojectTexture(sources[5], result, {
				numSamples: 1,
				rect,
				seamPixels: s2
			});
		} else {
			reprojectTexture(sources[0], result, {
				numSamples: options2?.numSamples || 2048,
				distribution: "lambert",
				rect,
				seamPixels: s2
			});
		}
		return result;
	}
};

var builtinAttributes = {
	vertex_normal: SEMANTIC_NORMAL,
	vertex_tangent: SEMANTIC_TANGENT,
	vertex_texCoord0: SEMANTIC_TEXCOORD0,
	vertex_texCoord1: SEMANTIC_TEXCOORD1,
	vertex_color: SEMANTIC_COLOR,
	vertex_boneWeights: SEMANTIC_BLENDWEIGHT,
	vertex_boneIndices: SEMANTIC_BLENDINDICES
};
var LitShader = class {
	varyingsCode = "";
	device;
	options;
	shaderLanguage;
	vDefines = /* @__PURE__ */ new Map();
	fDefines = /* @__PURE__ */ new Map();
	includes = /* @__PURE__ */ new Map();
	chunks = null;
	constructor(device, options2, allowWGSL = true) {
		this.device = device;
		this.options = options2;
		const userChunks = options2.shaderChunks;
		this.shaderLanguage = device.isWebGPU && allowWGSL && (!userChunks || userChunks.useWGSL) ? SHADERLANGUAGE_WGSL : SHADERLANGUAGE_GLSL;
		if (device.isWebGPU && this.shaderLanguage === SHADERLANGUAGE_GLSL) {
			if (!device.hasTranspilers) {
			}
		}
		this.attributes = {
			vertex_position: SEMANTIC_POSITION
		};
		if (options2.userAttributes) {
			for (const [semantic, name] of Object.entries(options2.userAttributes)) {
				this.attributes[name] = semantic;
			}
		}
		const engineChunks = ShaderChunks.get(device, this.shaderLanguage);
		this.chunks = new Map(engineChunks);
		if (userChunks) {
			const userChunkMap = this.shaderLanguage === SHADERLANGUAGE_GLSL ? userChunks.glsl : userChunks.wgsl;
			userChunkMap.forEach((chunk, chunkName) => {
				for (const a in builtinAttributes) {
					if (builtinAttributes.hasOwnProperty(a) && chunk.indexOf(a) >= 0) {
						this.attributes[a] = builtinAttributes[a];
					}
				}
				this.chunks.set(chunkName, chunk);
			});
		}
		this.shaderPassInfo = ShaderPass.get(this.device).getByIndex(options2.pass);
		this.shadowPass = this.shaderPassInfo.isShadow;
		this.lighting = options2.lights.length > 0 || options2.dirLightMapEnabled || options2.clusteredLightingEnabled;
		this.reflections = options2.reflectionSource !== REFLECTIONSRC_NONE;
		this.needsNormal = this.lighting || this.reflections || options2.useSpecular || options2.ambientSH || options2.useHeights || options2.enableGGXSpecular || options2.clusteredLightingEnabled && !this.shadowPass || options2.useClearCoatNormals;
		this.needsNormal = this.needsNormal && !this.shadowPass;
		this.needsSceneColor = options2.useDynamicRefraction;
		this.needsScreenSize = options2.useDynamicRefraction;
		this.needsTransforms = options2.useDynamicRefraction;
		this.vshader = null;
		this.fshader = null;
	}
	fDefineSet(condition, name, value = "") {
		if (condition) {
			this.fDefines.set(name, value);
		}
	}
	sharedDefineSet(condition, name, value = "") {
		if (condition) {
			this.vDefines.set(name, value);
			this.fDefines.set(name, value);
		}
	}
	generateVertexShader(useUv, useUnmodifiedUv, mapTransforms) {
		const { options: options2, vDefines, attributes } = this;
		const varyings = /* @__PURE__ */ new Map();
		varyings.set("vPositionW", "vec3");
		if (options2.nineSlicedMode === SPRITE_RENDERMODE_SLICED || options2.nineSlicedMode === SPRITE_RENDERMODE_TILED) {
			vDefines.set("NINESLICED", true);
		}
		if (this.options.linearDepth) {
			vDefines.set("LINEAR_DEPTH", true);
			varyings.set("vLinearDepth", "float");
		}
		if (this.needsNormal) vDefines.set("NORMALS", true);
		if (this.options.useInstancing) {
			const languageChunks = ShaderChunks.get(this.device, this.shaderLanguage);
			if (this.chunks.get("transformInstancingVS") === languageChunks.get("transformInstancingVS")) {
				attributes.instance_line1 = SEMANTIC_ATTR11;
				attributes.instance_line2 = SEMANTIC_ATTR12;
				attributes.instance_line3 = SEMANTIC_ATTR14;
				attributes.instance_line4 = SEMANTIC_ATTR15;
			}
		}
		if (this.needsNormal) {
			attributes.vertex_normal = SEMANTIC_NORMAL;
			varyings.set("vNormalW", "vec3");
			if (options2.hasTangents && (options2.useHeights || options2.useNormals || options2.useClearCoatNormals || options2.enableGGXSpecular)) {
				vDefines.set("TANGENTS", true);
				attributes.vertex_tangent = SEMANTIC_TANGENT;
				varyings.set("vTangentW", "vec3");
				varyings.set("vBinormalW", "vec3");
			} else if (options2.enableGGXSpecular) {
				vDefines.set("GGX_SPECULAR", true);
				varyings.set("vObjectSpaceUpW", "vec3");
			}
		}
		const maxUvSets = 2;
		for (let i2 = 0; i2 < maxUvSets; i2++) {
			if (useUv[i2]) {
				vDefines.set(`UV${i2}`, true);
				attributes[`vertex_texCoord${i2}`] = `TEXCOORD${i2}`;
			}
			if (useUnmodifiedUv[i2]) {
				vDefines.set(`UV${i2}_UNMODIFIED`, true);
				varyings.set(`vUv${i2}`, "vec2");
			}
		}
		let numTransforms = 0;
		const transformDone = /* @__PURE__ */ new Set();
		mapTransforms.forEach((mapTransform) => {
			const { id: id14, uv, name } = mapTransform;
			const checkId = id14 + uv * 100;
			if (!transformDone.has(checkId)) {
				transformDone.add(checkId);
				varyings.set(`vUV${uv}_${id14}`, "vec2");
				const varName = `texture_${name}MapTransform`;
				vDefines.set(`{TRANSFORM_NAME_${numTransforms}}`, varName);
				vDefines.set(`{TRANSFORM_UV_${numTransforms}}`, uv);
				vDefines.set(`{TRANSFORM_ID_${numTransforms}}`, id14);
				numTransforms++;
			}
		});
		vDefines.set("UV_TRANSFORMS_COUNT", numTransforms);
		if (options2.vertexColors) {
			attributes.vertex_color = SEMANTIC_COLOR;
			vDefines.set("VERTEX_COLOR", true);
			varyings.set("vVertexColor", "vec4");
			if (options2.useVertexColorGamma) {
				vDefines.set("STD_VERTEX_COLOR_GAMMA", "");
			}
		}
		if (options2.useMsdf && options2.msdfTextAttribute) {
			attributes.vertex_outlineParameters = SEMANTIC_ATTR8;
			attributes.vertex_shadowParameters = SEMANTIC_ATTR9;
			vDefines.set("MSDF", true);
		}
		if (options2.useMorphPosition || options2.useMorphNormal) {
			this.sharedDefineSet(true, "MORPHING", true);
			this.sharedDefineSet(options2.useMorphTextureBasedInt, "MORPHING_INT", true);
			this.sharedDefineSet(options2.useMorphPosition, "MORPHING_POSITION", true);
			this.sharedDefineSet(options2.useMorphNormal, "MORPHING_NORMAL", true);
			attributes.morph_vertex_id = SEMANTIC_ATTR15;
		}
		if (options2.skin) {
			attributes.vertex_boneIndices = SEMANTIC_BLENDINDICES;
			if (options2.batch) {
				this.sharedDefineSet(true, "BATCH", true);
			} else {
				attributes.vertex_boneWeights = SEMANTIC_BLENDWEIGHT;
				this.sharedDefineSet(true, "SKIN", true);
			}
		}
		this.sharedDefineSet(options2.useInstancing, "INSTANCING", true);
		this.sharedDefineSet(options2.screenSpace, "SCREENSPACE", true);
		if (options2.pixelSnap) vDefines.set("PIXELSNAP", true);
		varyings.forEach((type, name) => {
			this.varyingsCode += `#define VARYING_${name.toUpperCase()}
`;
			this.varyingsCode += this.shaderLanguage === SHADERLANGUAGE_WGSL ? `varying ${name}: ${primitiveGlslToWgslTypeMap.get(type)};
` : `varying ${type} ${name};
`;
		});
		this.includes.set("varyingsVS", this.varyingsCode);
		this.includes.set("varyingsPS", this.varyingsCode);
		this.vshader = `
						#include "litMainVS"
				`;
	}
	_setupLightingDefines(hasAreaLights, clusteredLightingEnabled) {
		const fDefines = this.fDefines;
		const options2 = this.options;
		this.fDefines.set("LIGHT_COUNT", options2.lights.length);
		if (hasAreaLights) fDefines.set("AREA_LIGHTS", true);
		if (clusteredLightingEnabled && this.lighting) {
			fDefines.set("LIT_CLUSTERED_LIGHTS", true);
			if (options2.clusteredLightingCookiesEnabled) fDefines.set("CLUSTER_COOKIES", true);
			if (options2.clusteredLightingAreaLightsEnabled) fDefines.set("CLUSTER_AREALIGHTS", true);
			if (options2.lightMaskDynamic) fDefines.set("CLUSTER_MESH_DYNAMIC_LIGHTS", true);
			if (options2.clusteredLightingShadowsEnabled && !options2.noShadow) {
				const clusteredShadowInfo = shadowTypeInfo.get(options2.clusteredLightingShadowType);
				fDefines.set("CLUSTER_SHADOWS", true);
				fDefines.set(`SHADOW_KIND_${clusteredShadowInfo.kind}`, true);
				fDefines.set(`CLUSTER_SHADOW_TYPE_${clusteredShadowInfo.kind}`, true);
			}
		}
		for (let i2 = 0; i2 < options2.lights.length; i2++) {
			const light = options2.lights[i2];
			const lightType = light._type;
			if (clusteredLightingEnabled && lightType !== LIGHTTYPE_DIRECTIONAL) {
				continue;
			}
			const lightShape = hasAreaLights && light._shape ? light._shape : LIGHTSHAPE_PUNCTUAL;
			const shadowType = light._shadowType;
			const castShadow = light.castShadows && !options2.noShadow;
			const shadowInfo = shadowTypeInfo.get(shadowType);
			fDefines.set(`LIGHT${i2}`, true);
			fDefines.set(`LIGHT${i2}TYPE`, `${lightTypeNames[lightType]}`);
			fDefines.set(`LIGHT${i2}SHADOWTYPE`, `${shadowInfo.name}`);
			fDefines.set(`LIGHT${i2}SHAPE`, `${lightShapeNames[lightShape]}`);
			fDefines.set(`LIGHT${i2}FALLOFF`, `${lightFalloffNames[light._falloffMode]}`);
			if (light.affectSpecularity) fDefines.set(`LIGHT${i2}AFFECT_SPECULARITY`, true);
			if (light._cookie) {
				if (lightType === LIGHTTYPE_SPOT && !light._cookie._cubemap || lightType === LIGHTTYPE_OMNI && light._cookie._cubemap) {
					fDefines.set(`LIGHT${i2}COOKIE`, true);
					fDefines.set(`{LIGHT${i2}COOKIE_CHANNEL}`, light._cookieChannel);
					if (lightType === LIGHTTYPE_SPOT) {
						if (light._cookieTransform) fDefines.set(`LIGHT${i2}COOKIE_TRANSFORM`, true);
						if (light._cookieFalloff) fDefines.set(`LIGHT${i2}COOKIE_FALLOFF`, true);
					}
				}
			}
			if (castShadow) {
				fDefines.set(`LIGHT${i2}CASTSHADOW`, true);
				if (shadowInfo.pcf) fDefines.set(`LIGHT${i2}SHADOW_PCF`, true);
				if (light._normalOffsetBias && !light._isVsm) fDefines.set(`LIGHT${i2}_SHADOW_SAMPLE_NORMAL_OFFSET`, true);
				if (lightType === LIGHTTYPE_DIRECTIONAL) {
					fDefines.set(`LIGHT${i2}_SHADOW_SAMPLE_ORTHO`, true);
					if (light.cascadeBlend > 0) fDefines.set(`LIGHT${i2}_SHADOW_CASCADE_BLEND`, true);
					if (light.numCascades > 1) fDefines.set(`LIGHT${i2}_SHADOW_CASCADES`, true);
				}
				if (shadowInfo.pcf || shadowInfo.pcss || this.device.isWebGPU) fDefines.set(`LIGHT${i2}_SHADOW_SAMPLE_SOURCE_ZBUFFER`, true);
				if (lightType === LIGHTTYPE_OMNI) fDefines.set(`LIGHT${i2}_SHADOW_SAMPLE_POINT`, true);
			}
			if (castShadow) {
				fDefines.set(`SHADOW_KIND_${shadowInfo.kind}`, true);
				if (lightType === LIGHTTYPE_DIRECTIONAL) fDefines.set("SHADOW_DIRECTIONAL", true);
			}
		}
	}
	prepareForwardPass(lightingUv) {
		const { options: options2 } = this;
		const clusteredAreaLights = options2.clusteredLightingEnabled && options2.clusteredLightingAreaLightsEnabled;
		const hasAreaLights = clusteredAreaLights || options2.lights.some((light) => {
			return light._shape && light._shape !== LIGHTSHAPE_PUNCTUAL;
		});
		const addAmbient = !options2.lightMapEnabled || options2.lightMapWithoutAmbient;
		const hasTBN = this.needsNormal && (options2.useNormals || options2.useClearCoatNormals || options2.enableGGXSpecular && !options2.useHeights);
		if (options2.useSpecular) {
			this.fDefineSet(true, "LIT_SPECULAR");
			this.fDefineSet(this.reflections, "LIT_REFLECTIONS");
			this.fDefineSet(options2.useClearCoat, "LIT_CLEARCOAT");
			this.fDefineSet(options2.fresnelModel > 0, "LIT_SPECULAR_FRESNEL");
			this.fDefineSet(options2.useSheen, "LIT_SHEEN");
			this.fDefineSet(options2.useIridescence, "LIT_IRIDESCENCE");
		}
		this.fDefineSet(this.lighting && options2.useSpecular || this.reflections, "LIT_SPECULAR_OR_REFLECTION");
		this.fDefineSet(this.needsSceneColor, "LIT_SCENE_COLOR");
		this.fDefineSet(this.needsScreenSize, "LIT_SCREEN_SIZE");
		this.fDefineSet(this.needsTransforms, "LIT_TRANSFORMS");
		this.fDefineSet(this.needsNormal, "LIT_NEEDS_NORMAL");
		this.fDefineSet(this.lighting, "LIT_LIGHTING");
		this.fDefineSet(options2.useMetalness, "LIT_METALNESS");
		this.fDefineSet(options2.enableGGXSpecular, "LIT_GGX_SPECULAR");
		this.fDefineSet(options2.useAnisotropy, "LIT_ANISOTROPY");
		this.fDefineSet(options2.useSpecularityFactor, "LIT_SPECULARITY_FACTOR");
		this.fDefineSet(options2.useCubeMapRotation, "CUBEMAP_ROTATION");
		this.fDefineSet(options2.occludeSpecularFloat, "LIT_OCCLUDE_SPECULAR_FLOAT");
		this.fDefineSet(options2.separateAmbient, "LIT_SEPARATE_AMBIENT");
		this.fDefineSet(options2.twoSidedLighting, "LIT_TWO_SIDED_LIGHTING");
		this.fDefineSet(options2.lightMapEnabled, "LIT_LIGHTMAP");
		this.fDefineSet(options2.dirLightMapEnabled, "LIT_DIR_LIGHTMAP");
		this.fDefineSet(options2.skyboxIntensity > 0, "LIT_SKYBOX_INTENSITY");
		this.fDefineSet(options2.clusteredLightingShadowsEnabled, "LIT_CLUSTERED_SHADOWS");
		this.fDefineSet(options2.clusteredLightingAreaLightsEnabled, "LIT_CLUSTERED_AREA_LIGHTS");
		this.fDefineSet(hasTBN, "LIT_TBN");
		this.fDefineSet(addAmbient, "LIT_ADD_AMBIENT");
		this.fDefineSet(options2.hasTangents, "LIT_TANGENTS");
		this.fDefineSet(options2.useNormals, "LIT_USE_NORMALS");
		this.fDefineSet(options2.useClearCoatNormals, "LIT_USE_CLEARCOAT_NORMALS");
		this.fDefineSet(options2.useRefraction, "LIT_REFRACTION");
		this.fDefineSet(options2.useDynamicRefraction, "LIT_DYNAMIC_REFRACTION");
		this.fDefineSet(options2.dispersion, "LIT_DISPERSION");
		this.fDefineSet(options2.useHeights, "LIT_HEIGHTS");
		this.fDefineSet(options2.opacityFadesSpecular, "LIT_OPACITY_FADES_SPECULAR");
		this.fDefineSet(options2.alphaToCoverage, "LIT_ALPHA_TO_COVERAGE");
		this.fDefineSet(options2.alphaTest, "LIT_ALPHA_TEST");
		this.fDefineSet(options2.useMsdf, "LIT_MSDF");
		this.fDefineSet(options2.ssao, "LIT_SSAO");
		this.fDefineSet(options2.useAo, "LIT_AO");
		this.fDefineSet(options2.occludeDirect, "LIT_OCCLUDE_DIRECT");
		this.fDefineSet(options2.msdfTextAttribute, "LIT_MSDF_TEXT_ATTRIBUTE");
		this.fDefineSet(options2.diffuseMapEnabled, "LIT_DIFFUSE_MAP");
		this.fDefineSet(options2.shadowCatcher, "LIT_SHADOW_CATCHER");
		this.fDefineSet(true, "LIT_FRESNEL_MODEL", fresnelNames[options2.fresnelModel]);
		this.fDefineSet(true, "LIT_NONE_SLICE_MODE", spriteRenderModeNames[options2.nineSlicedMode]);
		this.fDefineSet(true, "LIT_BLEND_TYPE", blendNames[options2.blendType]);
		this.fDefineSet(true, "LIT_CUBEMAP_PROJECTION", cubemaProjectionNames[options2.cubeMapProjection]);
		this.fDefineSet(true, "LIT_OCCLUDE_SPECULAR", specularOcclusionNames[options2.occludeSpecular]);
		this.fDefineSet(true, "LIT_REFLECTION_SOURCE", reflectionSrcNames[options2.reflectionSource]);
		this.fDefineSet(true, "LIT_AMBIENT_SOURCE", ambientSrcNames[options2.ambientSource]);
		this.fDefineSet(true, "{lightingUv}", lightingUv ?? "");
		this.fDefineSet(true, "{reflectionDecode}", ChunkUtils.decodeFunc(options2.reflectionEncoding));
		this.fDefineSet(true, "{reflectionCubemapDecode}", ChunkUtils.decodeFunc(options2.reflectionCubemapEncoding));
		this.fDefineSet(true, "{ambientDecode}", ChunkUtils.decodeFunc(options2.ambientEncoding));
		this._setupLightingDefines(hasAreaLights, options2.clusteredLightingEnabled);
	}
	preparePrepassPass() {
		const { options: options2 } = this;
		this.fDefineSet(options2.alphaTest, "LIT_ALPHA_TEST");
		this.fDefineSet(true, "STD_OPACITY_DITHER", ditherNames[options2.opacityShadowDither]);
	}
	prepareShadowPass() {
		const { options: options2 } = this;
		const lightType = this.shaderPassInfo.lightType;
		const shadowType = this.shaderPassInfo.shadowType;
		const shadowInfo = shadowTypeInfo.get(shadowType);
		const usePerspectiveDepth = lightType === LIGHTTYPE_DIRECTIONAL || !shadowInfo.vsm && lightType === LIGHTTYPE_SPOT;
		this.fDefineSet(usePerspectiveDepth, "PERSPECTIVE_DEPTH");
		this.fDefineSet(true, "LIGHT_TYPE", `${lightTypeNames[lightType]}`);
		this.fDefineSet(true, "SHADOW_TYPE", `${shadowInfo.name}`);
		this.fDefineSet(options2.alphaTest, "LIT_ALPHA_TEST");
	}
	generateFragmentShader(frontendDecl, frontendCode, lightingUv) {
		const options2 = this.options;
		this.includes.set("frontendDeclPS", frontendDecl ?? "");
		this.includes.set("frontendCodePS", frontendCode ?? "");
		if (options2.pass === SHADER_PICK) {
		} else if (options2.pass === SHADER_PREPASS) {
			this.preparePrepassPass();
		} else if (this.shadowPass) {
			this.prepareShadowPass();
		} else {
			this.prepareForwardPass(lightingUv);
		}
		this.fshader = `
						#include "litMainPS"
				`;
	}
};

var LitShaderOptions = class {
	hasTangents = false;
	shaderChunks = null;
	// one of the SHADER_ constants
	pass = 0;
	alphaTest = false;
	blendType = BLEND_NONE;
	separateAmbient = false;
	screenSpace = false;
	skin = false;
	batch = false;
	useInstancing = false;
	useMorphPosition = false;
	useMorphNormal = false;
	useMorphTextureBasedInt = false;
	nineSlicedMode = 0;
	clusteredLightingEnabled = true;
	clusteredLightingCookiesEnabled = false;
	clusteredLightingShadowsEnabled = false;
	clusteredLightingShadowType = 0;
	clusteredLightingAreaLightsEnabled = false;
	vertexColors = false;
	useVertexColorGamma = false;
	lightMapEnabled = false;
	dirLightMapEnabled = false;
	useHeights = false;
	useNormals = false;
	useClearCoatNormals = false;
	useAo = false;
	diffuseMapEnabled = false;
	pixelSnap = false;
	ambientSH = false;
	ssao = false;
	twoSidedLighting = false;
	occludeDirect = false;
	occludeSpecular = 0;
	occludeSpecularFloat = false;
	useMsdf = false;
	msdfTextAttribute = false;
	alphaToCoverage = false;
	opacityFadesSpecular = false;
	opacityDither = DITHER_NONE;
	opacityShadowDither = DITHER_NONE;
	cubeMapProjection = 0;
	useSpecular = false;
	useSpecularityFactor = false;
	enableGGXSpecular = false;
	fresnelModel = 0;
	useRefraction = false;
	useClearCoat = false;
	useSheen = false;
	useIridescence = false;
	useMetalness = false;
	useDynamicRefraction = false;
	dispersion = false;
	fog = FOG_NONE;
	gamma = GAMMA_NONE;
	toneMap = -1;
	reflectionSource = REFLECTIONSRC_NONE;
	reflectionEncoding = null;
	reflectionCubemapEncoding = null;
	ambientSource = "constant";
	ambientEncoding = null;
	// TODO: add a test for if non skybox cubemaps have rotation (when this is supported) - for now
	// assume no non-skybox cubemap rotation
	skyboxIntensity = 1;
	useCubeMapRotation = false;
	lightMapWithoutAmbient = false;
	lights = [];
	noShadow = false;
	lightMaskDynamic = 0;
	userAttributes = {};
	linearDepth = false;
	shadowCatcher = false;
};

var StandardMaterialOptions = class {
	defines = /* @__PURE__ */ new Map();
	forceUv1 = false;
	specularTint = false;
	metalnessTint = false;
	glossTint = false;
	emissiveEncoding = "linear";
	lightMapEncoding = "linear";
	vertexColorGamma = false;
	packedNormal = false;
	normalDetailPackedNormal = false;
	clearCoatPackedNormal = false;
	glossInvert = false;
	sheenGlossInvert = false;
	clearCoatGlossInvert = false;
	useAO = false;
	litOptions = new LitShaderOptions();
	// program-library assumes material options has a pass property
	get pass() {
		return this.litOptions.pass;
	}
};

var LitOptionsUtils = {
	// generate a key for the lit options
	generateKey(options2) {
		return `lit${Object.keys(options2).sort().map((key) => {
			if (key === "shaderChunks") {
				return options2.shaderChunks?.key ?? "";
			} else if (key === "lights") {
				return LitOptionsUtils.generateLightsKey(options2);
			}
			return key + options2[key];
		}).join("\n")}`;
	},
	generateLightsKey(options2) {
		return `lights:${options2.lights.map((light) => {
			return !options2.clusteredLightingEnabled || light._type === LIGHTTYPE_DIRECTIONAL ? `${light.key},` : "";
		}).join("")}`;
	}
};

var _matTex2D = [];
var buildPropertiesList = (options2) => {
	return Object.keys(options2).filter((key) => key !== "litOptions").sort();
};
var ShaderGeneratorStandard = class extends ShaderGenerator {
	// Shared Standard Material option structures
	optionsContext = new StandardMaterialOptions();
	optionsContextMin = new StandardMaterialOptions();
	generateKey(options2) {
		let props;
		if (options2 === this.optionsContextMin) {
			if (!this.propsMin) this.propsMin = buildPropertiesList(options2);
			props = this.propsMin;
		} else if (options2 === this.optionsContext) {
			if (!this.props) this.props = buildPropertiesList(options2);
			props = this.props;
		} else {
			props = buildPropertiesList(options2);
		}
		const definesHash = ShaderGenerator.definesHash(options2.defines);
		const key = `standard:
${definesHash}
${props.map((prop) => prop + options2[prop]).join("\n")}${LitOptionsUtils.generateKey(options2.litOptions)}`;
		return key;
	}
	_getUvSourceExpression(transformPropName, uVPropName, options2) {
		const transformId = options2[transformPropName];
		const uvChannel = options2[uVPropName];
		const isMainPass = options2.litOptions.pass === SHADER_FORWARD;
		let expression;
		if (isMainPass && options2.litOptions.nineSlicedMode === SPRITE_RENDERMODE_SLICED) {
			expression = "nineSlicedUv";
		} else if (isMainPass && options2.litOptions.nineSlicedMode === SPRITE_RENDERMODE_TILED) {
			expression = "nineSlicedUv";
		} else {
			if (transformId === 0) {
				expression = `vUv${uvChannel}`;
			} else {
				expression = `vUV${uvChannel}_${transformId}`;
			}
			if (options2.heightMap && transformPropName !== "heightMapTransform") {
				expression += " + dUvOffset";
			}
		}
		return expression;
	}
	_validateMapChunk(code, propName, chunkName, chunks) {
	}
	_addMapDefines(fDefines, propName, chunkName, options2, chunks, mapping, encoding = null) {
		const mapPropName = `${propName}Map`;
		const propNameCaps = propName.toUpperCase();
		const uVPropName = `${mapPropName}Uv`;
		const identifierPropName = `${mapPropName}Identifier`;
		const transformPropName = `${mapPropName}Transform`;
		const channelPropName = `${mapPropName}Channel`;
		const vertexColorChannelPropName = `${propName}VertexColorChannel`;
		const tintPropName = `${propName}Tint`;
		const vertexColorPropName = `${propName}VertexColor`;
		const detailModePropName = `${propName}Mode`;
		const invertName = `${propName}Invert`;
		const tintOption = options2[tintPropName];
		const vertexColorOption = options2[vertexColorPropName];
		const textureOption = options2[mapPropName];
		const textureIdentifier = options2[identifierPropName];
		const detailModeOption = options2[detailModePropName];
		const chunkCode = chunks.get(chunkName);
		if (textureOption) {
			fDefines.set(`STD_${propNameCaps}_TEXTURE`, "");
			const uv = this._getUvSourceExpression(transformPropName, uVPropName, options2);
			fDefines.set(`{STD_${propNameCaps}_TEXTURE_UV}`, uv);
			fDefines.set(`{STD_${propNameCaps}_TEXTURE_CHANNEL}`, options2[channelPropName]);
			const textureId = `{STD_${propNameCaps}_TEXTURE_NAME}`;
			if (chunkCode.includes(textureId)) {
				let samplerName = `texture_${mapPropName}`;
				const alias = mapping[textureIdentifier];
				if (alias) {
					samplerName = alias;
				} else {
					mapping[textureIdentifier] = samplerName;
					fDefines.set(`STD_${propNameCaps}_TEXTURE_ALLOCATE`, "");
				}
				fDefines.set(textureId, samplerName);
			}
			if (encoding) {
				const textureDecode = options2[channelPropName] === "aaa" ? "passThrough" : ChunkUtils.decodeFunc(encoding);
				fDefines.set(`{STD_${propNameCaps}_TEXTURE_DECODE}`, textureDecode);
			}
		}
		if (vertexColorOption) {
			fDefines.set(`STD_${propNameCaps}_VERTEX`, "");
			fDefines.set(`{STD_${propNameCaps}_VERTEX_CHANNEL}`, options2[vertexColorChannelPropName]);
		}
		if (detailModeOption) {
			fDefines.set(`{STD_${propNameCaps}_DETAILMODE}`, detailModeOption);
		}
		if (tintOption) {
			fDefines.set(`STD_${propNameCaps}_CONSTANT`, "");
		}
		if (!!options2[invertName]) {
			fDefines.set(`STD_${propNameCaps}_INVERT`, "");
		}
	}
	_correctChannel(p, chan, _matTex2D2) {
		if (_matTex2D2[p] > 0) {
			if (_matTex2D2[p] < chan.length) {
				return chan.substring(0, _matTex2D2[p]);
			} else if (_matTex2D2[p] > chan.length) {
				let str = chan;
				const chr = str.charAt(str.length - 1);
				const addLen = _matTex2D2[p] - str.length;
				for (let i2 = 0; i2 < addLen; i2++) str += chr;
				return str;
			}
			return chan;
		}
	}
	createVertexShader(litShader, options2) {
		const useUv = [];
		const useUnmodifiedUv = [];
		const mapTransforms = [];
		const maxUvSets = 2;
		for (const p in _matTex2D) {
			const mapName = `${p}Map`;
			if (options2[`${p}VertexColor`]) {
				const colorChannelName = `${p}VertexColorChannel`;
				options2[colorChannelName] = this._correctChannel(p, options2[colorChannelName], _matTex2D);
			}
			if (options2[mapName]) {
				const channelName = `${mapName}Channel`;
				const transformName = `${mapName}Transform`;
				const uvName = `${mapName}Uv`;
				options2[uvName] = Math.min(options2[uvName], maxUvSets - 1);
				options2[channelName] = this._correctChannel(p, options2[channelName], _matTex2D);
				const uvSet = options2[uvName];
				useUv[uvSet] = true;
				useUnmodifiedUv[uvSet] = useUnmodifiedUv[uvSet] || options2[mapName] && !options2[transformName];
				if (options2[transformName]) {
					mapTransforms.push({
						name: p,
						id: options2[transformName],
						uv: options2[uvName]
					});
				}
			}
		}
		if (options2.forceUv1) {
			useUv[1] = true;
			useUnmodifiedUv[1] = useUnmodifiedUv[1] !== void 0 ? useUnmodifiedUv[1] : true;
		}
		litShader.generateVertexShader(useUv, useUnmodifiedUv, mapTransforms);
	}
	prepareFragmentDefines(options2, fDefines, shaderPassInfo) {
		const fDefineSet = (condition, name, value = "") => {
			if (condition) {
				fDefines.set(name, value);
			}
		};
		fDefineSet(options2.lightMap, "STD_LIGHTMAP", "");
		fDefineSet(options2.lightVertexColor, "STD_LIGHT_VERTEX_COLOR", "");
		fDefineSet(options2.dirLightMap && options2.litOptions.useSpecular, "STD_LIGHTMAP_DIR", "");
		fDefineSet(options2.heightMap, "STD_HEIGHT_MAP", "");
		fDefineSet(options2.useSpecularColor, "STD_SPECULAR_COLOR", "");
		fDefineSet(options2.aoMap || options2.aoVertexColor || options2.useAO, "STD_AO", "");
		fDefineSet(true, "STD_OPACITY_DITHER", ditherNames[shaderPassInfo.isForward ? options2.litOptions.opacityDither : options2.litOptions.opacityShadowDither]);
	}
	createShaderDefinition(device, options2) {
		const shaderPassInfo = ShaderPass.get(device).getByIndex(options2.litOptions.pass);
		const isForwardPass = shaderPassInfo.isForward;
		const litShader = new LitShader(device, options2.litOptions);
		this.createVertexShader(litShader, options2);
		const textureMapping = {};
		options2.litOptions.fresnelModel = options2.litOptions.fresnelModel === 0 ? FRESNEL_SCHLICK : options2.litOptions.fresnelModel;
		const fDefines = litShader.fDefines;
		this.prepareFragmentDefines(options2, fDefines, shaderPassInfo);
		let lightingUv = "";
		if (isForwardPass) {
			if (options2.heightMap) {
				this._addMapDefines(fDefines, "height", "parallaxPS", options2, litShader.chunks, textureMapping);
			}
			if (options2.litOptions.blendType !== BLEND_NONE || options2.litOptions.alphaTest || options2.litOptions.alphaToCoverage || options2.litOptions.opacityDither !== DITHER_NONE) {
				this._addMapDefines(fDefines, "opacity", "opacityPS", options2, litShader.chunks, textureMapping);
			}
			if (litShader.needsNormal) {
				if (options2.normalMap || options2.clearCoatNormalMap) {
					if (!options2.litOptions.hasTangents) {
						const baseName = options2.normalMap ? "normalMap" : "clearCoatNormalMap";
						lightingUv = this._getUvSourceExpression(`${baseName}Transform`, `${baseName}Uv`, options2);
					}
				}
				this._addMapDefines(fDefines, "normalDetail", "normalMapPS", options2, litShader.chunks, textureMapping, options2.normalDetailPackedNormal ? "xy" : "xyz");
				this._addMapDefines(fDefines, "normal", "normalMapPS", options2, litShader.chunks, textureMapping, options2.packedNormal ? "xy" : "xyz");
			}
			if (options2.diffuseDetail) {
				this._addMapDefines(fDefines, "diffuseDetail", "diffusePS", options2, litShader.chunks, textureMapping, options2.diffuseDetailEncoding);
			}
			this._addMapDefines(fDefines, "diffuse", "diffusePS", options2, litShader.chunks, textureMapping, options2.diffuseEncoding);
			if (options2.litOptions.useRefraction) {
				this._addMapDefines(fDefines, "refraction", "transmissionPS", options2, litShader.chunks, textureMapping);
				this._addMapDefines(fDefines, "thickness", "thicknessPS", options2, litShader.chunks, textureMapping);
			}
			if (options2.litOptions.useIridescence) {
				this._addMapDefines(fDefines, "iridescence", "iridescencePS", options2, litShader.chunks, textureMapping);
				this._addMapDefines(fDefines, "iridescenceThickness", "iridescenceThicknessPS", options2, litShader.chunks, textureMapping);
			}
			if (litShader.lighting && options2.litOptions.useSpecular || litShader.reflections) {
				if (options2.litOptions.useSheen) {
					this._addMapDefines(fDefines, "sheen", "sheenPS", options2, litShader.chunks, textureMapping, options2.sheenEncoding);
					this._addMapDefines(fDefines, "sheenGloss", "sheenGlossPS", options2, litShader.chunks, textureMapping);
				}
				if (options2.litOptions.useMetalness) {
					this._addMapDefines(fDefines, "metalness", "metalnessPS", options2, litShader.chunks, textureMapping);
					this._addMapDefines(fDefines, "ior", "iorPS", options2, litShader.chunks, textureMapping);
				}
				if (options2.litOptions.useSpecularityFactor) {
					this._addMapDefines(fDefines, "specularityFactor", "specularityFactorPS", options2, litShader.chunks, textureMapping);
				}
				if (options2.useSpecularColor) {
					this._addMapDefines(fDefines, "specular", "specularPS", options2, litShader.chunks, textureMapping, options2.specularEncoding);
				}
				this._addMapDefines(fDefines, "gloss", "glossPS", options2, litShader.chunks, textureMapping);
			}
			if (options2.aoDetail) {
				this._addMapDefines(fDefines, "aoDetail", "aoPS", options2, litShader.chunks, textureMapping);
			}
			if (options2.aoMap || options2.aoVertexColor || options2.useAO) {
				this._addMapDefines(fDefines, "ao", "aoPS", options2, litShader.chunks, textureMapping);
			}
			this._addMapDefines(fDefines, "emissive", "emissivePS", options2, litShader.chunks, textureMapping, options2.emissiveEncoding);
			if (options2.litOptions.useClearCoat) {
				this._addMapDefines(fDefines, "clearCoat", "clearCoatPS", options2, litShader.chunks, textureMapping);
				this._addMapDefines(fDefines, "clearCoatGloss", "clearCoatGlossPS", options2, litShader.chunks, textureMapping);
				this._addMapDefines(fDefines, "clearCoatNormal", "clearCoatNormalPS", options2, litShader.chunks, textureMapping, options2.clearCoatPackedNormal ? "xy" : "xyz");
			}
			if (options2.litOptions.enableGGXSpecular) {
				this._addMapDefines(fDefines, "anisotropy", "anisotropyPS", options2, litShader.chunks, textureMapping);
			}
			if (options2.lightMap || options2.lightVertexColor) {
				this._addMapDefines(fDefines, "light", "lightmapPS", options2, litShader.chunks, textureMapping, options2.lightMapEncoding);
			}
		} else {
			const opacityShadowDither = options2.litOptions.opacityShadowDither;
			if (options2.litOptions.alphaTest || opacityShadowDither) {
				this._addMapDefines(fDefines, "opacity", "opacityPS", options2, litShader.chunks, textureMapping);
			}
		}
		litShader.generateFragmentShader(litShader.chunks.get("stdDeclarationPS"), litShader.chunks.get("stdFrontEndPS"), lightingUv);
		const includes = MapUtils.merge(litShader.chunks, litShader.includes);
		const vDefines = litShader.vDefines;
		options2.defines.forEach((value, key) => vDefines.set(key, value));
		options2.defines.forEach((value, key) => fDefines.set(key, value));
		const definition = ShaderDefinitionUtils.createDefinition(device, {
			name: "StandardShader",
			attributes: litShader.attributes,
			shaderLanguage: litShader.shaderLanguage,
			vertexCode: litShader.vshader,
			fragmentCode: litShader.fshader,
			vertexIncludes: includes,
			fragmentIncludes: includes,
			fragmentDefines: fDefines,
			vertexDefines: vDefines
		});
		if (litShader.shaderPassInfo.isForward) {
			definition.tag = SHADERTAG_MATERIAL;
		}
		return definition;
	}
};
var standard = new ShaderGeneratorStandard();

var blendModes = [];
blendModes[BLEND_SUBTRACTIVE] = { src: BLENDMODE_ONE, dst: BLENDMODE_ONE, op: BLENDEQUATION_REVERSE_SUBTRACT };
blendModes[BLEND_NONE] = { src: BLENDMODE_ONE, dst: BLENDMODE_ZERO, op: BLENDEQUATION_ADD };
blendModes[BLEND_NORMAL] = { src: BLENDMODE_SRC_ALPHA, dst: BLENDMODE_ONE_MINUS_SRC_ALPHA, op: BLENDEQUATION_ADD, alphaSrc: BLENDMODE_ONE };
blendModes[BLEND_PREMULTIPLIED] = { src: BLENDMODE_ONE, dst: BLENDMODE_ONE_MINUS_SRC_ALPHA, op: BLENDEQUATION_ADD };
blendModes[BLEND_ADDITIVE] = { src: BLENDMODE_ONE, dst: BLENDMODE_ONE, op: BLENDEQUATION_ADD };
blendModes[BLEND_ADDITIVEALPHA] = { src: BLENDMODE_SRC_ALPHA, dst: BLENDMODE_ONE, op: BLENDEQUATION_ADD };
blendModes[BLEND_MULTIPLICATIVE2X] = { src: BLENDMODE_DST_COLOR, dst: BLENDMODE_SRC_COLOR, op: BLENDEQUATION_ADD };
blendModes[BLEND_SCREEN] = { src: BLENDMODE_ONE_MINUS_DST_COLOR, dst: BLENDMODE_ONE, op: BLENDEQUATION_ADD };
blendModes[BLEND_MULTIPLICATIVE] = { src: BLENDMODE_DST_COLOR, dst: BLENDMODE_ZERO, op: BLENDEQUATION_ADD };
blendModes[BLEND_MIN] = { src: BLENDMODE_ONE, dst: BLENDMODE_ONE, op: BLENDEQUATION_MIN };
blendModes[BLEND_MAX] = { src: BLENDMODE_ONE, dst: BLENDMODE_ONE, op: BLENDEQUATION_MAX };
var id10 = 0;
var Material = class _Material {
	meshInstances = /* @__PURE__ */ new Set();
	name = "Untitled";
	userId = "";
	id = id10++;
	variants = /* @__PURE__ */ new Map();
	defines = /* @__PURE__ */ new Map();
	_definesDirty = false;
	_definesKey = null;
	parameters = {};
	alphaTest = 0;
	alphaToCoverage = false;
	_blendState = new BlendState();
	_depthState = new DepthState();
	cull = CULLFACE_BACK;
	frontFace = FRONTFACE_CCW;
	stencilFront = null;
	stencilBack = null;
	_shaderChunks = null;
	// this is deprecated, keeping for backwards compatibility
	_oldChunks = {};
	_dirtyShader = true;
	constructor() {
		if (new.target === _Material) {
		}
	}
	get hasShaderChunks() {
		return this._shaderChunks != null;
	}
	get shaderChunks() {
		if (!this._shaderChunks) {
			this._shaderChunks = new ShaderChunks();
		}
		return this._shaderChunks;
	}
	getShaderChunks(shaderLanguage = SHADERLANGUAGE_GLSL) {
		const chunks = this.shaderChunks;
		return shaderLanguage === SHADERLANGUAGE_GLSL ? chunks.glsl : chunks.wgsl;
	}
	set shaderChunksVersion(value) {
		this.shaderChunks.version = value;
	}
	get shaderChunksVersion() {
		return this.shaderChunks.version;
	}
	set chunks(value) {
		this._oldChunks = value;
	}
	get chunks() {
		Object.assign(this._oldChunks, Object.fromEntries(this.shaderChunks.glsl));
		return this._oldChunks;
	}
	set depthBias(value) {
		this._depthState.depthBias = value;
	}
	get depthBias() {
		return this._depthState.depthBias;
	}
	set slopeDepthBias(value) {
		this._depthState.depthBiasSlope = value;
	}
	get slopeDepthBias() {
		return this._depthState.depthBiasSlope;
	}
	_shaderVersion = 0;
	_scene = null;
	dirty = true;
	set redWrite(value) {
		this._blendState.redWrite = value;
	}
	get redWrite() {
		return this._blendState.redWrite;
	}
	set greenWrite(value) {
		this._blendState.greenWrite = value;
	}
	get greenWrite() {
		return this._blendState.greenWrite;
	}
	set blueWrite(value) {
		this._blendState.blueWrite = value;
	}
	get blueWrite() {
		return this._blendState.blueWrite;
	}
	set alphaWrite(value) {
		this._blendState.alphaWrite = value;
	}
	get alphaWrite() {
		return this._blendState.alphaWrite;
	}
	// returns boolean depending on material being transparent
	get transparent() {
		return this._blendState.blend;
	}
	_updateTransparency() {
		for (const meshInstance of this.meshInstances) {
			meshInstance.transparent = this.transparent;
		}
	}
	set blendState(value) {
		this._blendState.copy(value);
		this._updateTransparency();
	}
	get blendState() {
		return this._blendState;
	}
	set blendType(type) {
		const blendMode = blendModes[type];
		this._blendState.setColorBlend(blendMode.op, blendMode.src, blendMode.dst);
		this._blendState.setAlphaBlend(blendMode.alphaOp ?? blendMode.op, blendMode.alphaSrc ?? blendMode.src, blendMode.alphaDst ?? blendMode.dst);
		const blend = type !== BLEND_NONE;
		if (this._blendState.blend !== blend) {
			this._blendState.blend = blend;
			this._updateTransparency();
		}
		this._updateMeshInstanceKeys();
	}
	get blendType() {
		if (!this.transparent) {
			return BLEND_NONE;
		}
		const { colorOp, colorSrcFactor, colorDstFactor, alphaOp, alphaSrcFactor, alphaDstFactor } = this._blendState;
		for (let i2 = 0; i2 < blendModes.length; i2++) {
			const blendMode = blendModes[i2];
			if (blendMode.src === colorSrcFactor && blendMode.dst === colorDstFactor && blendMode.op === colorOp && blendMode.src === alphaSrcFactor && blendMode.dst === alphaDstFactor && blendMode.op === alphaOp) {
				return i2;
			}
		}
		return BLEND_NORMAL;
	}
	set depthState(value) {
		this._depthState.copy(value);
	}
	get depthState() {
		return this._depthState;
	}
	set depthTest(value) {
		this._depthState.test = value;
	}
	get depthTest() {
		return this._depthState.test;
	}
	set depthFunc(value) {
		this._depthState.func = value;
	}
	get depthFunc() {
		return this._depthState.func;
	}
	set depthWrite(value) {
		this._depthState.write = value;
	}
	get depthWrite() {
		return this._depthState.write;
	}
	copy(source) {
		this.name = source.name;
		this.alphaTest = source.alphaTest;
		this.alphaToCoverage = source.alphaToCoverage;
		this._blendState.copy(source._blendState);
		this._depthState.copy(source._depthState);
		this.cull = source.cull;
		this.frontFace = source.frontFace;
		this.stencilFront = source.stencilFront?.clone();
		if (source.stencilBack) {
			this.stencilBack = source.stencilFront === source.stencilBack ? this.stencilFront : source.stencilBack.clone();
		}
		this.clearParameters();
		for (const name in source.parameters) {
			if (source.parameters.hasOwnProperty(name)) {
				this._setParameterSimple(name, source.parameters[name].data);
			}
		}
		this.defines.clear();
		source.defines.forEach((value, key) => this.defines.set(key, value));
		this._definesKey = null;
		this._shaderChunks = source.hasShaderChunks ? new ShaderChunks() : null;
		this._shaderChunks?.copy(source._shaderChunks);
		return this;
	}
	clone() {
		const clone = new this.constructor();
		return clone.copy(this);
	}
	_updateMeshInstanceKeys() {
		for (const meshInstance of this.meshInstances) {
			meshInstance.updateKey();
		}
	}
	updateUniforms(device, scene) {
		if (this._dirtyShader) {
			this.clearVariants();
			this._dirtyShader = false;
		}
	}
	getShaderVariant(params) {
	}
	update() {
		if (Object.keys(this._oldChunks).length > 0) {
			for (const [key, value] of Object.entries(this._oldChunks)) {
				this.shaderChunks.glsl.set(key, value);
				delete this._oldChunks[key];
			}
		}
		if (this._definesDirty || this._shaderChunks?.isDirty()) {
			this._definesDirty = false;
			this._shaderChunks?.resetDirty();
			this.clearVariants();
		}
		this.dirty = true;
	}
	// Parameter management
	clearParameters() {
		this.parameters = {};
	}
	getParameters() {
		return this.parameters;
	}
	clearVariants() {
		this.variants.clear();
		for (const meshInstance of this.meshInstances) {
			meshInstance.clearShaders();
		}
	}
	getParameter(name) {
		return this.parameters[name];
	}
	_setParameterSimple(name, data2) {
		const param = this.parameters[name];
		if (param) {
			param.data = data2;
		} else {
			this.parameters[name] = {
				scopeId: null,
				data: data2
			};
		}
	}
	setParameter(name, data2) {
		if (data2 === void 0 && typeof name === "object") {
			const uniformObject = name;
			if (uniformObject.length) {
				for (let i2 = 0; i2 < uniformObject.length; i2++) {
					this.setParameter(uniformObject[i2]);
				}
				return;
			}
			name = uniformObject.name;
			data2 = uniformObject.value;
		}
		this._setParameterSimple(name, data2);
	}
	deleteParameter(name) {
		if (this.parameters[name]) {
			delete this.parameters[name];
		}
	}
	// used to apply parameters from this material into scope of uniforms, called internally by forward-renderer
	// optional list of parameter names to be set can be specified, otherwise all parameters are set
	setParameters(device, names) {
		const parameters = this.parameters;
		if (names === void 0) names = parameters;
		for (const paramName in names) {
			const parameter = parameters[paramName];
			if (parameter) {
				if (!parameter.scopeId) {
					parameter.scopeId = device.scope.resolve(paramName);
				}
				parameter.scopeId.setValue(parameter.data);
			}
		}
	}
	setDefine(name, value) {
		let modified = false;
		const { defines } = this;
		if (value !== void 0 && value !== false) {
			modified = !defines.has(name) || defines.get(name) !== value;
			defines.set(name, value);
		} else {
			modified = defines.has(name);
			defines.delete(name);
		}
		this._definesDirty || (this._definesDirty = modified);
		if (modified) {
			this._definesKey = null;
		}
	}
	get definesKey() {
		if (this._definesKey === null) {
			this._definesKey = Array.from(this.defines).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0).map(([k, v6]) => `${k}=${v6}`).join(",");
		}
		return this._definesKey;
	}
	getDefine(name) {
		return this.defines.has(name);
	}
	destroy() {
		this.variants.clear();
		for (const meshInstance of this.meshInstances) {
			meshInstance.clearShaders();
			meshInstance._material = null;
			if (meshInstance.mesh) {
				const defaultMaterial = getDefaultMaterial(meshInstance.mesh.device);
				if (this !== defaultMaterial) {
					meshInstance.material = defaultMaterial;
				}
			} else {
			}
		}
		this.meshInstances.clear();
	}
	addMeshInstanceRef(meshInstance) {
		this.meshInstances.add(meshInstance);
	}
	removeMeshInstanceRef(meshInstance) {
		this.meshInstances.delete(meshInstance);
	}
};

var LitMaterialOptionsBuilder = class _LitMaterialOptionsBuilder {
	static update(litOptions, material, scene, renderParams, objDefs, pass, sortedLights) {
		_LitMaterialOptionsBuilder.updateSharedOptions(litOptions, material, scene, objDefs, pass);
		_LitMaterialOptionsBuilder.updateMaterialOptions(litOptions, material);
		_LitMaterialOptionsBuilder.updateEnvOptions(litOptions, material, scene, renderParams);
		_LitMaterialOptionsBuilder.updateLightingOptions(litOptions, material, scene, objDefs, sortedLights);
	}
	static updateSharedOptions(litOptions, material, scene, objDefs, pass) {
		litOptions.shaderChunks = material.shaderChunks;
		litOptions.pass = pass;
		litOptions.alphaTest = material.alphaTest > 0;
		litOptions.blendType = material.blendType;
		litOptions.screenSpace = objDefs && (objDefs & SHADERDEF_SCREENSPACE) !== 0;
		litOptions.skin = objDefs && (objDefs & SHADERDEF_SKIN) !== 0;
		litOptions.useInstancing = objDefs && (objDefs & SHADERDEF_INSTANCING) !== 0;
		litOptions.useMorphPosition = objDefs && (objDefs & SHADERDEF_MORPH_POSITION) !== 0;
		litOptions.useMorphNormal = objDefs && (objDefs & SHADERDEF_MORPH_NORMAL) !== 0;
		litOptions.useMorphTextureBasedInt = objDefs && (objDefs & SHADERDEF_MORPH_TEXTURE_BASED_INT) !== 0;
		litOptions.hasTangents = objDefs && (objDefs & SHADERDEF_TANGENTS) !== 0;
		litOptions.nineSlicedMode = material.nineSlicedMode || SPRITE_RENDERMODE_SIMPLE;
		if (material.useLighting && scene.clusteredLightingEnabled) {
			litOptions.clusteredLightingEnabled = true;
			litOptions.clusteredLightingCookiesEnabled = scene.lighting.cookiesEnabled;
			litOptions.clusteredLightingShadowsEnabled = scene.lighting.shadowsEnabled;
			litOptions.clusteredLightingShadowType = scene.lighting.shadowType;
			litOptions.clusteredLightingAreaLightsEnabled = scene.lighting.areaLightsEnabled;
		} else {
			litOptions.clusteredLightingEnabled = false;
			litOptions.clusteredLightingCookiesEnabled = false;
			litOptions.clusteredLightingShadowsEnabled = false;
			litOptions.clusteredLightingAreaLightsEnabled = false;
		}
	}
	static updateMaterialOptions(litOptions, material) {
		litOptions.separateAmbient = false;
		litOptions.pixelSnap = material.pixelSnap;
		litOptions.ambientSH = material.ambientSH;
		litOptions.twoSidedLighting = material.twoSidedLighting;
		litOptions.occludeDirect = material.occludeDirect;
		litOptions.occludeSpecular = material.occludeSpecular;
		litOptions.occludeSpecularFloat = material.occludeSpecularIntensity !== 1;
		litOptions.useMsdf = false;
		litOptions.msdfTextAttribute = false;
		litOptions.alphaToCoverage = material.alphaToCoverage;
		litOptions.opacityFadesSpecular = material.opacityFadesSpecular;
		litOptions.opacityDither = material.opacityDither;
		litOptions.cubeMapProjection = CUBEPROJ_NONE;
		litOptions.useSpecular = material.hasSpecular;
		litOptions.useSpecularityFactor = material.hasSpecularityFactor;
		litOptions.enableGGXSpecular = material.ggxSpecular;
		litOptions.useAnisotropy = false;
		litOptions.fresnelModel = material.fresnelModel;
		litOptions.useRefraction = material.hasRefraction;
		litOptions.useClearCoat = material.hasClearCoat;
		litOptions.useSheen = material.hasSheen;
		litOptions.useIridescence = material.hasIrridescence;
		litOptions.useMetalness = material.hasMetalness;
		litOptions.useDynamicRefraction = material.dynamicRefraction;
		litOptions.dispersion = material.dispersion > 0;
		litOptions.vertexColors = false;
		litOptions.lightMapEnabled = material.hasLighting;
		litOptions.dirLightMapEnabled = material.dirLightMap;
		litOptions.useHeights = material.hasHeights;
		litOptions.useNormals = material.hasNormals;
		litOptions.useClearCoatNormals = material.hasClearCoatNormals;
		litOptions.useAo = material.hasAo;
		litOptions.diffuseMapEnabled = material.hasDiffuseMap;
	}
	static updateEnvOptions(litOptions, material, scene, renderParams) {
		litOptions.fog = material.useFog ? renderParams.fog : FOG_NONE;
		litOptions.gamma = renderParams.shaderOutputGamma;
		litOptions.toneMap = material.useTonemap ? renderParams.toneMapping : TONEMAP_NONE;
		if (material.useSkybox && scene.envAtlas && scene.skybox) {
			litOptions.reflectionSource = REFLECTIONSRC_ENVATLASHQ;
			litOptions.reflectionEncoding = scene.envAtlas.encoding;
			litOptions.reflectionCubemapEncoding = scene.skybox.encoding;
		} else if (material.useSkybox && scene.envAtlas) {
			litOptions.reflectionSource = REFLECTIONSRC_ENVATLAS;
			litOptions.reflectionEncoding = scene.envAtlas.encoding;
		} else if (material.useSkybox && scene.skybox) {
			litOptions.reflectionSource = REFLECTIONSRC_CUBEMAP;
			litOptions.reflectionEncoding = scene.skybox.encoding;
		} else {
			litOptions.reflectionSource = REFLECTIONSRC_NONE;
			litOptions.reflectionEncoding = null;
		}
		if (material.ambientSH) {
			litOptions.ambientSource = AMBIENTSRC_AMBIENTSH;
			litOptions.ambientEncoding = null;
		} else if (litOptions.reflectionSource !== REFLECTIONSRC_NONE && scene.envAtlas) {
			litOptions.ambientSource = AMBIENTSRC_ENVALATLAS;
			litOptions.ambientEncoding = scene.envAtlas.encoding;
		} else {
			litOptions.ambientSource = AMBIENTSRC_CONSTANT;
			litOptions.ambientEncoding = null;
		}
		const hasSkybox = litOptions.reflectionSource !== REFLECTIONSRC_NONE;
		litOptions.skyboxIntensity = hasSkybox;
		litOptions.useCubeMapRotation = hasSkybox && scene._skyboxRotationShaderInclude;
	}
	static updateLightingOptions(litOptions, material, scene, objDefs, sortedLights) {
		litOptions.lightMapWithoutAmbient = false;
		if (material.useLighting) {
			const lightsFiltered = [];
			const mask = objDefs ? objDefs >> 16 : MASK_AFFECT_DYNAMIC;
			litOptions.lightMaskDynamic = !!(mask & MASK_AFFECT_DYNAMIC);
			litOptions.lightMapWithoutAmbient = false;
			if (sortedLights) {
				_LitMaterialOptionsBuilder.collectLights(LIGHTTYPE_DIRECTIONAL, sortedLights[LIGHTTYPE_DIRECTIONAL], lightsFiltered, mask);
				if (!scene.clusteredLightingEnabled) {
					_LitMaterialOptionsBuilder.collectLights(LIGHTTYPE_OMNI, sortedLights[LIGHTTYPE_OMNI], lightsFiltered, mask);
					_LitMaterialOptionsBuilder.collectLights(LIGHTTYPE_SPOT, sortedLights[LIGHTTYPE_SPOT], lightsFiltered, mask);
				}
			}
			litOptions.lights = lightsFiltered;
		} else {
			litOptions.lights = [];
		}
		if (litOptions.lights.length === 0 && !scene.clusteredLightingEnabled || (objDefs & SHADERDEF_NOSHADOW) !== 0) {
			litOptions.noShadow = true;
		}
	}
	static collectLights(lType, lights2, lightsFiltered, mask) {
		for (let i2 = 0; i2 < lights2.length; i2++) {
			const light = lights2[i2];
			if (light.enabled) {
				if (light.mask & mask) {
					lightsFiltered.push(light);
				}
			}
		}
	}
};

var arraysEqual = (a, b) => {
	if (a.length !== b.length) {
		return false;
	}
	for (let i2 = 0; i2 < a.length; ++i2) {
		if (a[i2] !== b[i2]) {
			return false;
		}
	}
	return true;
};
var notWhite = (color3) => {
	return color3.r !== 1 || color3.g !== 1 || color3.b !== 1;
};
var notBlack = (color3) => {
	return color3.r !== 0 || color3.g !== 0 || color3.b !== 0;
};
var StandardMaterialOptionsBuilder = class {
	constructor() {
		this._mapXForms = null;
	}
	// Minimal options for Depth and Shadow passes
	updateMinRef(options2, scene, stdMat, objDefs, pass, sortedLights) {
		this._updateSharedOptions(options2, scene, stdMat, objDefs, pass);
		this._updateMinOptions(options2, stdMat, pass);
		this._updateUVOptions(options2, stdMat, objDefs, true);
	}
	updateRef(options2, scene, cameraShaderParams, stdMat, objDefs, pass, sortedLights) {
		this._updateSharedOptions(options2, scene, stdMat, objDefs, pass);
		this._updateEnvOptions(options2, stdMat, scene, cameraShaderParams);
		this._updateMaterialOptions(options2, stdMat, scene);
		options2.litOptions.hasTangents = objDefs && (objDefs & SHADERDEF_TANGENTS) !== 0;
		this._updateLightOptions(options2, scene, stdMat, objDefs, sortedLights);
		this._updateUVOptions(options2, stdMat, objDefs, false, cameraShaderParams);
	}
	_updateSharedOptions(options2, scene, stdMat, objDefs, pass) {
		options2.forceUv1 = stdMat.forceUv1;
		if (stdMat.userAttributes) {
			options2.litOptions.userAttributes = Object.fromEntries(stdMat.userAttributes.entries());
		}
		options2.litOptions.shaderChunks = stdMat.shaderChunks;
		options2.litOptions.pass = pass;
		options2.litOptions.alphaTest = stdMat.alphaTest > 0;
		options2.litOptions.blendType = stdMat.blendType;
		options2.litOptions.screenSpace = objDefs && (objDefs & SHADERDEF_SCREENSPACE) !== 0;
		options2.litOptions.skin = objDefs && (objDefs & SHADERDEF_SKIN) !== 0;
		options2.litOptions.batch = objDefs && (objDefs & SHADERDEF_BATCH) !== 0;
		options2.litOptions.useInstancing = objDefs && (objDefs & SHADERDEF_INSTANCING) !== 0;
		options2.litOptions.useMorphPosition = objDefs && (objDefs & SHADERDEF_MORPH_POSITION) !== 0;
		options2.litOptions.useMorphNormal = objDefs && (objDefs & SHADERDEF_MORPH_NORMAL) !== 0;
		options2.litOptions.useMorphTextureBasedInt = objDefs && (objDefs & SHADERDEF_MORPH_TEXTURE_BASED_INT) !== 0;
		options2.litOptions.nineSlicedMode = stdMat.nineSlicedMode || 0;
		if (scene.clusteredLightingEnabled && stdMat.useLighting) {
			options2.litOptions.clusteredLightingEnabled = true;
			options2.litOptions.clusteredLightingCookiesEnabled = scene.lighting.cookiesEnabled;
			options2.litOptions.clusteredLightingShadowsEnabled = scene.lighting.shadowsEnabled;
			options2.litOptions.clusteredLightingShadowType = scene.lighting.shadowType;
			options2.litOptions.clusteredLightingAreaLightsEnabled = scene.lighting.areaLightsEnabled;
		} else {
			options2.litOptions.clusteredLightingEnabled = false;
			options2.litOptions.clusteredLightingCookiesEnabled = false;
			options2.litOptions.clusteredLightingShadowsEnabled = false;
			options2.litOptions.clusteredLightingAreaLightsEnabled = false;
		}
	}
	_updateUVOptions(options2, stdMat, objDefs, minimalOptions, cameraShaderParams) {
		let hasUv0 = false;
		let hasUv1 = false;
		let hasVcolor = false;
		if (objDefs) {
			hasUv0 = (objDefs & SHADERDEF_UV0) !== 0;
			hasUv1 = (objDefs & SHADERDEF_UV1) !== 0;
			hasVcolor = (objDefs & SHADERDEF_VCOLOR) !== 0;
		}
		options2.litOptions.vertexColors = false;
		this._mapXForms = [];
		const uniqueTextureMap = {};
		for (const p in _matTex2D) {
			this._updateTexOptions(options2, stdMat, p, hasUv0, hasUv1, hasVcolor, minimalOptions, uniqueTextureMap);
		}
		this._mapXForms = null;
		options2.litOptions.ssao = cameraShaderParams?.ssaoEnabled;
		options2.useAO = options2.litOptions.ssao;
		options2.litOptions.lightMapEnabled = options2.lightMap;
		options2.litOptions.dirLightMapEnabled = options2.dirLightMap;
		options2.litOptions.useHeights = options2.heightMap;
		options2.litOptions.useNormals = options2.normalMap;
		options2.litOptions.useClearCoatNormals = options2.clearCoatNormalMap;
		options2.litOptions.useAo = options2.aoMap || options2.aoVertexColor || options2.litOptions.ssao;
		options2.litOptions.diffuseMapEnabled = options2.diffuseMap;
	}
	_updateTexOptions(options2, stdMat, p, hasUv0, hasUv1, hasVcolor, minimalOptions, uniqueTextureMap) {
		const isOpacity = p === "opacity";
		if (!minimalOptions || isOpacity) {
			const mname = `${p}Map`;
			const vname = `${p}VertexColor`;
			const vcname = `${p}VertexColorChannel`;
			const cname = `${mname}Channel`;
			const tname = `${mname}Transform`;
			const uname = `${mname}Uv`;
			const iname = `${mname}Identifier`;
			if (p !== "light") {
				options2[mname] = false;
				options2[iname] = void 0;
				options2[cname] = "";
				options2[tname] = 0;
				options2[uname] = 0;
			}
			options2[vname] = false;
			options2[vcname] = "";
			if (isOpacity && stdMat.blendType === BLEND_NONE && stdMat.alphaTest === 0 && !stdMat.alphaToCoverage && stdMat.opacityDither === DITHER_NONE) {
				return;
			}
			if (p !== "height" && stdMat[vname]) {
				if (hasVcolor) {
					options2[vname] = stdMat[vname];
					options2[vcname] = stdMat[vcname];
					options2.litOptions.vertexColors = true;
				}
			}
			if (stdMat[mname]) {
				let allow = true;
				if (stdMat[uname] === 0 && !hasUv0) allow = false;
				if (stdMat[uname] === 1 && !hasUv1) allow = false;
				if (allow) {
					const mapId = stdMat[mname].id;
					let identifier = uniqueTextureMap[mapId];
					if (identifier === void 0) {
						uniqueTextureMap[mapId] = p;
						identifier = p;
					}
					options2[mname] = !!stdMat[mname];
					options2[iname] = identifier;
					options2[tname] = this._getMapTransformID(stdMat.getUniform(tname), stdMat[uname]);
					options2[cname] = stdMat[cname];
					options2[uname] = stdMat[uname];
				}
			}
		}
	}
	_updateMinOptions(options2, stdMat, pass) {
		const isPrepass = pass === SHADER_PREPASS;
		options2.litOptions.opacityShadowDither = isPrepass ? stdMat.opacityDither : stdMat.opacityShadowDither;
		options2.litOptions.linearDepth = isPrepass;
		options2.litOptions.lights = [];
	}
	_updateMaterialOptions(options2, stdMat, scene) {
		const useSpecular = !!(stdMat.useMetalness || stdMat.specularMap || stdMat.sphereMap || stdMat.cubeMap || notBlack(stdMat.specular) || stdMat.specularityFactor > 0 && stdMat.useMetalness || stdMat.enableGGXSpecular || stdMat.clearCoat > 0);
		const useSpecularColor = !stdMat.useMetalness || stdMat.useMetalnessSpecularColor;
		const specularTint = useSpecular && (stdMat.specularTint || notWhite(stdMat.specular));
		const specularityFactorTint = useSpecular && stdMat.useMetalnessSpecularColor && (stdMat.specularityFactorTint || stdMat.specularityFactor !== 1);
		const isPackedNormalMap = (texture) => texture ? texture.format === PIXELFORMAT_DXT5 || texture.type === TEXTURETYPE_SWIZZLEGGGR : false;
		const equalish = (a, b) => Math.abs(a - b) < 1e-4;
		options2.specularTint = specularTint;
		options2.specularityFactorTint = specularityFactorTint;
		options2.metalnessTint = stdMat.useMetalness && stdMat.metalness < 1;
		options2.glossTint = true;
		options2.diffuseEncoding = stdMat.diffuseMap?.encoding;
		options2.diffuseDetailEncoding = stdMat.diffuseDetailMap?.encoding;
		options2.emissiveEncoding = stdMat.emissiveMap?.encoding;
		options2.lightMapEncoding = stdMat.lightMap?.encoding;
		options2.packedNormal = isPackedNormalMap(stdMat.normalMap);
		options2.refractionTint = !equalish(stdMat.refraction, 1);
		options2.refractionIndexTint = !equalish(stdMat.refractionIndex, 1 / 1.5);
		options2.thicknessTint = stdMat.useDynamicRefraction && stdMat.thickness !== 1;
		options2.specularEncoding = stdMat.specularMap?.encoding;
		options2.sheenEncoding = stdMat.sheenMap?.encoding;
		options2.aoMapUv = stdMat.aoUvSet;
		options2.aoDetail = !!stdMat.aoDetailMap;
		options2.diffuseDetail = !!stdMat.diffuseDetailMap;
		options2.normalDetail = !!stdMat.normalMap;
		options2.normalDetailPackedNormal = isPackedNormalMap(stdMat.normalDetailMap);
		options2.diffuseDetailMode = stdMat.diffuseDetailMode;
		options2.aoDetailMode = stdMat.aoDetailMode;
		options2.clearCoatGloss = !!stdMat.clearCoatGloss;
		options2.clearCoatPackedNormal = isPackedNormalMap(stdMat.clearCoatNormalMap);
		options2.iorTint = !equalish(stdMat.refractionIndex, 1 / 1.5);
		if (scene.forcePassThroughSpecular) {
			options2.specularEncoding = "linear";
			options2.sheenEncoding = "linear";
		}
		options2.iridescenceTint = stdMat.iridescence !== 1;
		options2.glossInvert = stdMat.glossInvert;
		options2.sheenGlossInvert = stdMat.sheenGlossInvert;
		options2.clearCoatGlossInvert = stdMat.clearCoatGlossInvert;
		options2.useSpecularColor = useSpecularColor;
		options2.litOptions.separateAmbient = false;
		options2.litOptions.pixelSnap = stdMat.pixelSnap;
		options2.litOptions.ambientSH = !!stdMat.ambientSH;
		options2.litOptions.twoSidedLighting = stdMat.twoSidedLighting;
		options2.litOptions.occludeSpecular = stdMat.occludeSpecular;
		options2.litOptions.occludeSpecularFloat = stdMat.occludeSpecularIntensity !== 1;
		options2.litOptions.useMsdf = !!stdMat.msdfMap;
		options2.litOptions.msdfTextAttribute = !!stdMat.msdfTextAttribute;
		options2.litOptions.alphaToCoverage = stdMat.alphaToCoverage;
		options2.litOptions.opacityFadesSpecular = stdMat.opacityFadesSpecular;
		options2.litOptions.opacityDither = stdMat.opacityDither;
		options2.litOptions.cubeMapProjection = stdMat.cubeMapProjection;
		options2.litOptions.occludeDirect = stdMat.occludeDirect;
		options2.litOptions.useSpecular = useSpecular;
		options2.litOptions.useSpecularityFactor = (specularityFactorTint || !!stdMat.specularityFactorMap) && stdMat.useMetalnessSpecularColor;
		options2.litOptions.enableGGXSpecular = stdMat.enableGGXSpecular;
		options2.litOptions.useAnisotropy = stdMat.enableGGXSpecular && (stdMat.anisotropyIntensity > 0 || !!stdMat.anisotropyMap);
		options2.litOptions.fresnelModel = stdMat.fresnelModel;
		options2.litOptions.useRefraction = (stdMat.refraction || !!stdMat.refractionMap) && (stdMat.useDynamicRefraction || options2.litOptions.reflectionSource !== REFLECTIONSRC_NONE);
		options2.litOptions.useClearCoat = !!stdMat.clearCoat;
		options2.litOptions.useSheen = stdMat.useSheen;
		options2.litOptions.useIridescence = stdMat.useIridescence && stdMat.iridescence !== 0;
		options2.litOptions.useMetalness = stdMat.useMetalness;
		options2.litOptions.useDynamicRefraction = stdMat.useDynamicRefraction;
		options2.litOptions.dispersion = stdMat.dispersion > 0;
		options2.litOptions.shadowCatcher = stdMat.shadowCatcher;
		options2.litOptions.useVertexColorGamma = stdMat.vertexColorGamma;
	}
	_updateEnvOptions(options2, stdMat, scene, cameraShaderParams) {
		options2.litOptions.fog = stdMat.useFog ? cameraShaderParams.fog : FOG_NONE;
		options2.litOptions.gamma = cameraShaderParams.shaderOutputGamma;
		options2.litOptions.toneMap = stdMat.useTonemap ? cameraShaderParams.toneMapping : TONEMAP_NONE;
		let usingSceneEnv = false;
		if (stdMat.envAtlas && stdMat.cubeMap) {
			options2.litOptions.reflectionSource = REFLECTIONSRC_ENVATLASHQ;
			options2.litOptions.reflectionEncoding = stdMat.envAtlas.encoding;
			options2.litOptions.reflectionCubemapEncoding = stdMat.cubeMap.encoding;
		} else if (stdMat.envAtlas) {
			options2.litOptions.reflectionSource = REFLECTIONSRC_ENVATLAS;
			options2.litOptions.reflectionEncoding = stdMat.envAtlas.encoding;
		} else if (stdMat.cubeMap) {
			options2.litOptions.reflectionSource = REFLECTIONSRC_CUBEMAP;
			options2.litOptions.reflectionEncoding = stdMat.cubeMap.encoding;
		} else if (stdMat.sphereMap) {
			options2.litOptions.reflectionSource = REFLECTIONSRC_SPHEREMAP;
			options2.litOptions.reflectionEncoding = stdMat.sphereMap.encoding;
		} else if (stdMat.useSkybox && scene.envAtlas && scene.skybox) {
			options2.litOptions.reflectionSource = REFLECTIONSRC_ENVATLASHQ;
			options2.litOptions.reflectionEncoding = scene.envAtlas.encoding;
			options2.litOptions.reflectionCubemapEncoding = scene.skybox.encoding;
			usingSceneEnv = true;
		} else if (stdMat.useSkybox && scene.envAtlas) {
			options2.litOptions.reflectionSource = REFLECTIONSRC_ENVATLAS;
			options2.litOptions.reflectionEncoding = scene.envAtlas.encoding;
			usingSceneEnv = true;
		} else if (stdMat.useSkybox && scene.skybox) {
			options2.litOptions.reflectionSource = REFLECTIONSRC_CUBEMAP;
			options2.litOptions.reflectionEncoding = scene.skybox.encoding;
			usingSceneEnv = true;
		} else {
			options2.litOptions.reflectionSource = REFLECTIONSRC_NONE;
			options2.litOptions.reflectionEncoding = null;
		}
		if (stdMat.ambientSH) {
			options2.litOptions.ambientSource = AMBIENTSRC_AMBIENTSH;
			options2.litOptions.ambientEncoding = null;
		} else {
			const envAtlas = stdMat.envAtlas || (stdMat.useSkybox && scene.envAtlas ? scene.envAtlas : null);
			if (envAtlas && !stdMat.sphereMap) {
				options2.litOptions.ambientSource = AMBIENTSRC_ENVALATLAS;
				options2.litOptions.ambientEncoding = envAtlas.encoding;
			} else {
				options2.litOptions.ambientSource = AMBIENTSRC_CONSTANT;
				options2.litOptions.ambientEncoding = null;
			}
		}
		options2.litOptions.skyboxIntensity = usingSceneEnv;
		options2.litOptions.useCubeMapRotation = usingSceneEnv && scene._skyboxRotationShaderInclude;
	}
	_updateLightOptions(options2, scene, stdMat, objDefs, sortedLights) {
		options2.lightMap = false;
		options2.lightMapChannel = "";
		options2.lightMapUv = 0;
		options2.lightMapTransform = 0;
		options2.litOptions.lightMapWithoutAmbient = false;
		options2.dirLightMap = false;
		if (objDefs) {
			options2.litOptions.noShadow = (objDefs & SHADERDEF_NOSHADOW) !== 0;
			if ((objDefs & SHADERDEF_LM) !== 0) {
				options2.lightMapEncoding = scene.lightmapPixelFormat === PIXELFORMAT_RGBA8 ? "rgbm" : "linear";
				options2.lightMap = true;
				options2.lightMapChannel = "rgb";
				options2.lightMapUv = 1;
				options2.lightMapTransform = 0;
				options2.litOptions.lightMapWithoutAmbient = !stdMat.lightMap;
				if ((objDefs & SHADERDEF_DIRLM) !== 0) {
					options2.dirLightMap = true;
				}
				if ((objDefs & SHADERDEF_LMAMBIENT) !== 0) {
					options2.litOptions.lightMapWithoutAmbient = false;
				}
			}
		}
		if (stdMat.useLighting) {
			const lightsFiltered = [];
			const mask = objDefs ? objDefs >> 16 : MASK_AFFECT_DYNAMIC;
			options2.litOptions.lightMaskDynamic = !!(mask & MASK_AFFECT_DYNAMIC);
			if (sortedLights) {
				LitMaterialOptionsBuilder.collectLights(LIGHTTYPE_DIRECTIONAL, sortedLights[LIGHTTYPE_DIRECTIONAL], lightsFiltered, mask);
				if (!scene.clusteredLightingEnabled) {
					LitMaterialOptionsBuilder.collectLights(LIGHTTYPE_OMNI, sortedLights[LIGHTTYPE_OMNI], lightsFiltered, mask);
					LitMaterialOptionsBuilder.collectLights(LIGHTTYPE_SPOT, sortedLights[LIGHTTYPE_SPOT], lightsFiltered, mask);
				}
			}
			options2.litOptions.lights = lightsFiltered;
		} else {
			options2.litOptions.lights = [];
		}
		if (options2.litOptions.lights.length === 0 && !scene.clusteredLightingEnabled) {
			options2.litOptions.noShadow = true;
		}
	}
	_getMapTransformID(xform, uv) {
		if (!xform) return 0;
		let xforms = this._mapXForms[uv];
		if (!xforms) {
			xforms = [];
			this._mapXForms[uv] = xforms;
		}
		for (let i2 = 0; i2 < xforms.length; i2++) {
			if (arraysEqual(xforms[i2][0].value, xform[0].value) && arraysEqual(xforms[i2][1].value, xform[1].value)) {
				return i2 + 1;
			}
		}
		return xforms.push(xform);
	}
};

function _textureParameter(name, channel = true, vertexColor = true) {
	const result = {};
	result[`${name}Map`] = "texture";
	result[`${name}MapTiling`] = "vec2";
	result[`${name}MapOffset`] = "vec2";
	result[`${name}MapRotation`] = "number";
	result[`${name}MapUv`] = "number";
	if (channel) {
		result[`${name}MapChannel`] = "string";
		if (vertexColor) {
			result[`${name}VertexColor`] = "boolean";
			result[`${name}VertexColorChannel`] = "string";
		}
	}
	return result;
}
var standardMaterialParameterTypes = {
	name: "string",
	chunks: "chunks",
	mappingFormat: "string",
	_engine: "boolean",
	// internal param for engine-only loading
	ambient: "rgb",
	..._textureParameter("ao"),
	..._textureParameter("aoDetail", true, false),
	aoDetailMode: "string",
	aoIntensity: "number",
	diffuse: "rgb",
	..._textureParameter("diffuse"),
	..._textureParameter("diffuseDetail", true, false),
	diffuseDetailMode: "string",
	vertexColorGamma: "boolean",
	specular: "rgb",
	specularTint: "boolean",
	..._textureParameter("specular"),
	occludeSpecular: "enum:occludeSpecular",
	specularityFactor: "number",
	specularityFactorTint: "boolean",
	..._textureParameter("specularityFactor"),
	useMetalness: "boolean",
	metalness: "number",
	enableGGXSpecular: "boolean",
	metalnessTint: "boolean",
	..._textureParameter("metalness"),
	useMetalnessSpecularColor: "boolean",
	anisotropyIntensity: "number",
	anisotropyRotation: "number",
	..._textureParameter("anisotropy"),
	shininess: "number",
	gloss: "number",
	glossInvert: "boolean",
	..._textureParameter("gloss"),
	clearCoat: "number",
	..._textureParameter("clearCoat"),
	clearCoatGloss: "number",
	clearCoatGlossInvert: "boolean",
	..._textureParameter("clearCoatGloss"),
	clearCoatBumpiness: "number",
	..._textureParameter("clearCoatNormal", false),
	useSheen: "boolean",
	sheen: "rgb",
	..._textureParameter("sheen"),
	sheenGloss: "number",
	sheenGlossInvert: "boolean",
	..._textureParameter("sheenGloss"),
	fresnelModel: "number",
	emissive: "rgb",
	..._textureParameter("emissive"),
	emissiveIntensity: "number",
	..._textureParameter("normal", false),
	bumpiness: "number",
	// normalMapFactor: 'number', // TODO rename bumpiness to normalMapFactor
	..._textureParameter("normalDetail", false),
	normalDetailMapBumpiness: "number",
	..._textureParameter("height", true, false),
	heightMapFactor: "number",
	alphaToCoverage: "boolean",
	alphaTest: "number",
	alphaFade: "number",
	alphaDither: "number",
	opacity: "number",
	..._textureParameter("opacity"),
	opacityFadesSpecular: "boolean",
	opacityDither: "string",
	opacityShadowDither: "string",
	reflectivity: "number",
	refraction: "number",
	refractionTint: "boolean",
	..._textureParameter("refraction"),
	refractionIndex: "number",
	dispersion: "number",
	thickness: "number",
	thicknessTint: "boolean",
	..._textureParameter("thickness"),
	attenuation: "rgb",
	attenuationDistance: "number",
	useDynamicRefraction: "boolean",
	sphereMap: "texture",
	cubeMap: "cubemap",
	cubeMapProjection: "number",
	cubeMapProjectionBox: "boundingbox",
	useIridescence: "boolean",
	iridescence: "number",
	iridescenceTint: "boolean",
	..._textureParameter("iridescence"),
	iridescenceThicknessTint: "boolean",
	iridescenceThicknessMin: "number",
	iridescenceThicknessMax: "number",
	iridescenceRefractionIndex: "number",
	..._textureParameter("iridescenceThickness"),
	..._textureParameter("light"),
	depthTest: "boolean",
	depthFunc: "enum:depthFunc",
	depthWrite: "boolean",
	depthBias: "number",
	slopeDepthBias: "number",
	cull: "enum:cull",
	blendType: "enum:blendType",
	useFog: "boolean",
	useLighting: "boolean",
	useSkybox: "boolean",
	useTonemap: "boolean",
	envAtlas: "texture",
	twoSidedLighting: "boolean",
	shadowCatcher: "boolean"
	// nineSlicedMode
	// pixelSnap
	// forceUv1
	// occludeDirect
	// occludeSpecularIntensity
	// msdfMap
	// msdfMapChannel
	// msdfMapUv
	// msdfMapTiling
	// msdfMapOffset
	// msdfTextAttribute
	// msdfVertexColor
	// msdfVertexColorChannel
};
var standardMaterialTextureParameters = [];
for (const key in standardMaterialParameterTypes) {
	const type = standardMaterialParameterTypes[key];
	if (type === "texture") {
		standardMaterialTextureParameters.push(key);
	}
}
var standardMaterialCubemapParameters = [];
for (const key in standardMaterialParameterTypes) {
	const type = standardMaterialParameterTypes[key];
	if (type === "cubemap") {
		standardMaterialCubemapParameters.push(key);
	}
}
var standardMaterialRemovedParameters = {
	aoMapVertexColor: "boolean",
	diffuseMapTint: "boolean",
	diffuseMapVertexColor: "boolean",
	emissiveMapTint: "boolean",
	emissiveMapVertexColor: "boolean",
	glossMapVertexColor: "boolean",
	metalnessMapVertexColor: "boolean",
	opacityMapVertexColor: "boolean",
	specularAntialias: "boolean",
	specularMapTint: "boolean",
	specularMapVertexColor: "boolean",
	ambientTint: "boolean",
	emissiveTint: "boolean",
	diffuseTint: "boolean",
	sheenTint: "boolean",
	conserveEnergy: "boolean",
	useGamma: "boolean",
	useGammaTonemap: "boolean",
	sheenGlossTint: "boolean",
	anisotropy: "boolean"
};

var _props = {};
var _uniforms = {};
var _params = /* @__PURE__ */ new Set();
var _tempColor = new Color();
var StandardMaterial = class extends Material {
	static TEXTURE_PARAMETERS = standardMaterialTextureParameters;
	static CUBEMAP_PARAMETERS = standardMaterialCubemapParameters;
	userAttributes = /* @__PURE__ */ new Map();
	onUpdateShader;
	constructor() {
		super();
		this._assetReferences = {};
		this._activeParams = /* @__PURE__ */ new Set();
		this._activeLightingParams = /* @__PURE__ */ new Set();
		this.shaderOptBuilder = new StandardMaterialOptionsBuilder();
		this.reset();
	}
	reset() {
		Object.keys(_props).forEach((name) => {
			this[`_${name}`] = _props[name].value();
		});
		this._uniformCache = {};
	}
	copy(source) {
		super.copy(source);
		Object.keys(_props).forEach((k) => {
			this[k] = source[k];
		});
		this._alphaDither = source._alphaDither;
		this.userAttributes = new Map(source.userAttributes);
		return this;
	}
	setAttribute(name, semantic) {
		this.userAttributes.set(semantic, name);
	}
	_setParameter(name, value) {
		_params.add(name);
		this.setParameter(name, value);
	}
	_setParameters(parameters) {
		parameters.forEach((v6) => {
			this._setParameter(v6.name, v6.value);
		});
	}
	_processParameters(paramsName) {
		const prevParams = this[paramsName];
		prevParams.forEach((param) => {
			if (!_params.has(param)) {
				delete this.parameters[param];
			}
		});
		this[paramsName] = _params;
		_params = prevParams;
		_params.clear();
	}
	_updateMap(p) {
		const mname = `${p}Map`;
		const map = this[mname];
		if (map) {
			this._setParameter(`texture_${mname}`, map);
			const tname = `${mname}Transform`;
			const uniform = this.getUniform(tname);
			if (uniform) {
				this._setParameters(uniform);
			}
		}
	}
	// allocate a uniform if it doesn't already exist in the uniform cache
	_allocUniform(name, allocFunc) {
		let uniform = this._uniformCache[name];
		if (!uniform) {
			uniform = allocFunc();
			this._uniformCache[name] = uniform;
		}
		return uniform;
	}
	getUniform(name, device, scene) {
		return _uniforms[name](this, device, scene);
	}
	updateUniforms(device, scene) {
		const getUniform = (name) => {
			return this.getUniform(name, device, scene);
		};
		this._setParameter("material_ambient", getUniform("ambient"));
		this._setParameter("material_diffuse", getUniform("diffuse"));
		this._setParameter("material_aoIntensity", this.aoIntensity);
		const specularNotWhite = this.specular.r !== 1 || this.specular.g !== 1 || this.specular.b !== 1;
		const useSpecularConstant = !this.specularMap || this.specularTint || specularNotWhite;
		if (this.useMetalness) {
			if (!this.metalnessMap || this.metalness < 1) {
				this._setParameter("material_metalness", this.metalness);
			}
			if (useSpecularConstant) {
				this._setParameter("material_specular", getUniform("specular"));
			}
			if (!this.specularityFactorMap || this.specularityFactorTint || this.specularityFactor !== 1) {
				this._setParameter("material_specularityFactor", this.specularityFactor);
			}
			this._setParameter("material_sheen", getUniform("sheen"));
			this._setParameter("material_sheenGloss", this.sheenGloss);
			this._setParameter("material_refractionIndex", this.refractionIndex);
		} else {
			if (useSpecularConstant) {
				this._setParameter("material_specular", getUniform("specular"));
			}
		}
		if (this.enableGGXSpecular) {
			this._setParameter("material_anisotropyIntensity", this.anisotropyIntensity);
			this._setParameter("material_anisotropyRotation", [Math.cos(this.anisotropyRotation * math.DEG_TO_RAD), Math.sin(this.anisotropyRotation * math.DEG_TO_RAD)]);
		}
		if (this.clearCoat > 0) {
			this._setParameter("material_clearCoat", this.clearCoat);
			this._setParameter("material_clearCoatGloss", this.clearCoatGloss);
			this._setParameter("material_clearCoatBumpiness", this.clearCoatBumpiness);
		}
		this._setParameter("material_gloss", this.gloss);
		this._setParameter("material_emissive", getUniform("emissive"));
		this._setParameter("material_emissiveIntensity", this.emissiveIntensity);
		if (this.refraction > 0) {
			this._setParameter("material_refraction", this.refraction);
		}
		if (this.dispersion > 0) {
			this._setParameter("material_dispersion", this.dispersion);
		}
		if (this.useDynamicRefraction) {
			this._setParameter("material_thickness", this.thickness);
			this._setParameter("material_attenuation", getUniform("attenuation"));
			this._setParameter("material_invAttenuationDistance", this.attenuationDistance === 0 ? 0 : 1 / this.attenuationDistance);
		}
		if (this.useIridescence) {
			this._setParameter("material_iridescence", this.iridescence);
			this._setParameter("material_iridescenceRefractionIndex", this.iridescenceRefractionIndex);
			this._setParameter("material_iridescenceThicknessMin", this.iridescenceThicknessMin);
			this._setParameter("material_iridescenceThicknessMax", this.iridescenceThicknessMax);
		}
		this._setParameter("material_opacity", this.opacity);
		const ditherScale = this._opacity > 0 ? this.alphaDither / this._opacity : 1;
		this._setParameter("material_alphaDitherScale", ditherScale);
		if (this.opacityFadesSpecular === false) {
			this._setParameter("material_alphaFade", this.alphaFade);
		}
		if (this.occludeSpecular) {
			this._setParameter("material_occludeSpecularIntensity", this.occludeSpecularIntensity);
		}
		if (this.cubeMapProjection === CUBEPROJ_BOX) {
			this._setParameter(getUniform("cubeMapProjectionBox"));
		}
		for (const p in _matTex2D) {
			this._updateMap(p);
		}
		if (this.ambientSH) {
			this._setParameter("ambientSH[0]", this.ambientSH);
		}
		if (this.normalMap) {
			this._setParameter("material_bumpiness", this.bumpiness);
		}
		if (this.normalMap && this.normalDetailMap) {
			this._setParameter("material_normalDetailMapBumpiness", this.normalDetailMapBumpiness);
		}
		if (this.heightMap) {
			this._setParameter("material_heightMapFactor", getUniform("heightMapFactor"));
		}
		if (this.envAtlas && this.cubeMap) {
			this._setParameter("texture_envAtlas", this.envAtlas);
			this._setParameter("texture_cubeMap", this.cubeMap);
		} else if (this.envAtlas) {
			this._setParameter("texture_envAtlas", this.envAtlas);
		} else if (this.cubeMap) {
			this._setParameter("texture_cubeMap", this.cubeMap);
		} else if (this.sphereMap) {
			this._setParameter("texture_sphereMap", this.sphereMap);
		}
		this._setParameter("material_reflectivity", this.reflectivity);
		this._processParameters("_activeParams");
		super.updateUniforms(device, scene);
	}
	updateEnvUniforms(device, scene) {
		const hasLocalEnvOverride = this.envAtlas || this.cubeMap || this.sphereMap;
		if (!hasLocalEnvOverride && this.useSkybox) {
			if (scene.envAtlas && scene.skybox) {
				this._setParameter("texture_envAtlas", scene.envAtlas);
				this._setParameter("texture_cubeMap", scene.skybox);
			} else if (scene.envAtlas) {
				this._setParameter("texture_envAtlas", scene.envAtlas);
			} else if (scene.skybox) {
				this._setParameter("texture_cubeMap", scene.skybox);
			}
		}
		this._processParameters("_activeLightingParams");
	}
	getShaderVariant(params) {
		const { device, scene, pass, objDefs, sortedLights, cameraShaderParams } = params;
		this.updateEnvUniforms(device, scene);
		const shaderPassInfo = ShaderPass.get(device).getByIndex(pass);
		const minimalOptions = pass === SHADER_PICK || pass === SHADER_PREPASS || shaderPassInfo.isShadow;
		let options2 = minimalOptions ? standard.optionsContextMin : standard.optionsContext;
		options2.defines = ShaderUtils.getCoreDefines(this, params);
		if (minimalOptions) {
			this.shaderOptBuilder.updateMinRef(options2, scene, this, objDefs, pass, sortedLights);
		} else {
			this.shaderOptBuilder.updateRef(options2, scene, cameraShaderParams, this, objDefs, pass, sortedLights);
		}
		if (!this.useFog) options2.defines.set("FOG", "NONE");
		options2.defines.set("TONEMAP", tonemapNames[options2.litOptions.toneMap]);
		if (this.onUpdateShader) {
			options2 = this.onUpdateShader(options2);
		}
		const processingOptions = new ShaderProcessorOptions(params.viewUniformFormat, params.vertexFormat);
		const library = getProgramLibrary(device);
		library.register("standard", standard);
		const shader = library.getProgram("standard", options2, processingOptions, this.userId);
		return shader;
	}
	destroy() {
		for (const asset in this._assetReferences) {
			this._assetReferences[asset]._unbind();
		}
		this._assetReferences = null;
		super.destroy();
	}
};
var defineUniform = (name, getUniformFunc) => {
	_uniforms[name] = getUniformFunc;
};
var definePropInternal = (name, constructorFunc, setterFunc, getterFunc) => {
	Object.defineProperty(StandardMaterial.prototype, name, {
		get: getterFunc || function() {
			return this[`_${name}`];
		},
		set: setterFunc
	});
	_props[name] = {
		value: constructorFunc
	};
};
var defineValueProp = (prop) => {
	const internalName = `_${prop.name}`;
	const dirtyShaderFunc = prop.dirtyShaderFunc || (() => true);
	const setterFunc = function(value) {
		const oldValue = this[internalName];
		if (oldValue !== value) {
			this._dirtyShader = this._dirtyShader || dirtyShaderFunc(oldValue, value);
			this[internalName] = value;
		}
	};
	definePropInternal(prop.name, () => prop.defaultValue, setterFunc, prop.getterFunc);
};
var defineAggProp = (prop) => {
	const internalName = `_${prop.name}`;
	const dirtyShaderFunc = prop.dirtyShaderFunc || (() => true);
	const setterFunc = function(value) {
		const oldValue = this[internalName];
		if (!oldValue.equals(value)) {
			this._dirtyShader = this._dirtyShader || dirtyShaderFunc(oldValue, value);
			this[internalName] = oldValue.copy(value);
		}
	};
	definePropInternal(prop.name, () => prop.defaultValue.clone(), setterFunc, prop.getterFunc);
};
var defineProp = (prop) => {
	return prop.defaultValue && prop.defaultValue.clone ? defineAggProp(prop) : defineValueProp(prop);
};
function _defineTex2D(name, channel = "rgb", vertexColor = true, uv = 0) {
	_matTex2D[name] = channel.length || -1;
	defineProp({
		name: `${name}Map`,
		defaultValue: null,
		dirtyShaderFunc: (oldValue, newValue) => {
			return !!oldValue !== !!newValue || oldValue && (oldValue.type !== newValue.type || oldValue.format !== newValue.format);
		}
	});
	defineProp({
		name: `${name}MapTiling`,
		defaultValue: new Vec2(1, 1)
	});
	defineProp({
		name: `${name}MapOffset`,
		defaultValue: new Vec2(0, 0)
	});
	defineProp({
		name: `${name}MapRotation`,
		defaultValue: 0
	});
	defineProp({
		name: `${name}MapUv`,
		defaultValue: uv
	});
	if (channel) {
		defineProp({
			name: `${name}MapChannel`,
			defaultValue: channel
		});
		if (vertexColor) {
			defineProp({
				name: `${name}VertexColor`,
				defaultValue: false
			});
			defineProp({
				name: `${name}VertexColorChannel`,
				defaultValue: channel
			});
		}
	}
	const mapTiling = `${name}MapTiling`;
	const mapOffset = `${name}MapOffset`;
	const mapRotation = `${name}MapRotation`;
	const mapTransform = `${name}MapTransform`;
	defineUniform(mapTransform, (material, device, scene) => {
		const tiling = material[mapTiling];
		const offset3 = material[mapOffset];
		const rotation7 = material[mapRotation];
		if (tiling.x === 1 && tiling.y === 1 && offset3.x === 0 && offset3.y === 0 && rotation7 === 0) {
			return null;
		}
		const uniform = material._allocUniform(mapTransform, () => {
			return [{
				name: `texture_${mapTransform}0`,
				value: new Float32Array(3)
			}, {
				name: `texture_${mapTransform}1`,
				value: new Float32Array(3)
			}];
		});
		const cr = Math.cos(rotation7 * math.DEG_TO_RAD);
		const sr = Math.sin(rotation7 * math.DEG_TO_RAD);
		const uniform0 = uniform[0].value;
		uniform0[0] = cr * tiling.x;
		uniform0[1] = -sr * tiling.y;
		uniform0[2] = offset3.x;
		const uniform1 = uniform[1].value;
		uniform1[0] = sr * tiling.x;
		uniform1[1] = cr * tiling.y;
		uniform1[2] = 1 - tiling.y - offset3.y;
		return uniform;
	});
}
function _defineColor(name, defaultValue) {
	defineProp({
		name,
		defaultValue,
		getterFunc: function() {
			this._dirtyShader = true;
			return this[`_${name}`];
		}
	});
	defineUniform(name, (material, device, scene) => {
		const uniform = material._allocUniform(name, () => new Float32Array(3));
		const color3 = material[name];
		_tempColor.linear(color3);
		uniform[0] = _tempColor.r;
		uniform[1] = _tempColor.g;
		uniform[2] = _tempColor.b;
		return uniform;
	});
}
function _defineFloat(name, defaultValue, getUniformFunc) {
	defineProp({
		name,
		defaultValue,
		dirtyShaderFunc: (oldValue, newValue) => {
			return (oldValue === 0 || oldValue === 1) !== (newValue === 0 || newValue === 1);
		}
	});
	defineUniform(name, getUniformFunc);
}
function _defineObject(name, getUniformFunc) {
	defineProp({
		name,
		defaultValue: null,
		dirtyShaderFunc: (oldValue, newValue) => {
			return !!oldValue === !!newValue;
		}
	});
	defineUniform(name, getUniformFunc);
}
function _defineFlag(name, defaultValue) {
	defineProp({
		name,
		defaultValue
	});
}
function _defineMaterialProps() {
	_defineColor("ambient", new Color(1, 1, 1));
	_defineColor("diffuse", new Color(1, 1, 1));
	_defineColor("specular", new Color(0, 0, 0));
	_defineColor("emissive", new Color(0, 0, 0));
	_defineColor("sheen", new Color(1, 1, 1));
	_defineColor("attenuation", new Color(1, 1, 1));
	_defineFloat("emissiveIntensity", 1);
	_defineFloat("specularityFactor", 1);
	_defineFloat("sheenGloss", 0);
	_defineFloat("gloss", 0.25);
	_defineFloat("aoIntensity", 1);
	_defineFloat("heightMapFactor", 1, (material, device, scene) => {
		return material.heightMapFactor * 0.025;
	});
	_defineFloat("opacity", 1);
	_defineFloat("alphaFade", 1);
	defineProp({
		name: "alphaDither",
		defaultValue: null,
		dirtyShaderFunc: () => false,
		getterFunc: function() {
			return this._alphaDither ?? this._opacity;
		}
	});
	_defineFloat("alphaTest", 0);
	_defineFloat("bumpiness", 1);
	_defineFloat("normalDetailMapBumpiness", 1);
	_defineFloat("reflectivity", 1);
	_defineFloat("occludeSpecularIntensity", 1);
	_defineFloat("refraction", 0);
	_defineFloat("refractionIndex", 1 / 1.5, (material, device, scene) => {
		return Math.max(1e-3, material.refractionIndex);
	});
	_defineFloat("dispersion", 0);
	_defineFloat("thickness", 0);
	_defineFloat("attenuationDistance", 0);
	_defineFloat("metalness", 1);
	_defineFloat("anisotropyIntensity", 0);
	_defineFloat("anisotropyRotation", 0);
	_defineFloat("clearCoat", 0);
	_defineFloat("clearCoatGloss", 1);
	_defineFloat("clearCoatBumpiness", 1);
	_defineFloat("aoUvSet", 0, null);
	_defineFloat("iridescence", 0);
	_defineFloat("iridescenceRefractionIndex", 1 / 1.5);
	_defineFloat("iridescenceThicknessMin", 0);
	_defineFloat("iridescenceThicknessMax", 0);
	_defineObject("ambientSH");
	_defineObject("cubeMapProjectionBox", (material, device, scene) => {
		const uniform = material._allocUniform("cubeMapProjectionBox", () => {
			return [{
				name: "envBoxMin",
				value: new Float32Array(3)
			}, {
				name: "envBoxMax",
				value: new Float32Array(3)
			}];
		});
		const bboxMin = material.cubeMapProjectionBox.getMin();
		const minUniform = uniform[0].value;
		minUniform[0] = bboxMin.x;
		minUniform[1] = bboxMin.y;
		minUniform[2] = bboxMin.z;
		const bboxMax = material.cubeMapProjectionBox.getMax();
		const maxUniform = uniform[1].value;
		maxUniform[0] = bboxMax.x;
		maxUniform[1] = bboxMax.y;
		maxUniform[2] = bboxMax.z;
		return uniform;
	});
	_defineFlag("specularTint", false);
	_defineFlag("specularityFactorTint", false);
	_defineFlag("useMetalness", false);
	_defineFlag("useMetalnessSpecularColor", false);
	_defineFlag("useSheen", false);
	_defineFlag("enableGGXSpecular", false);
	_defineFlag("occludeDirect", false);
	_defineFlag("opacityFadesSpecular", true);
	_defineFlag("occludeSpecular", SPECOCC_AO);
	_defineFlag("fresnelModel", FRESNEL_SCHLICK);
	_defineFlag("useDynamicRefraction", false);
	_defineFlag("cubeMapProjection", CUBEPROJ_NONE);
	_defineFlag("useFog", true);
	_defineFlag("useLighting", true);
	_defineFlag("useTonemap", true);
	_defineFlag("useSkybox", true);
	_defineFlag("forceUv1", false);
	_defineFlag("pixelSnap", false);
	_defineFlag("twoSidedLighting", false);
	_defineFlag("nineSlicedMode", void 0);
	_defineFlag("msdfTextAttribute", false);
	_defineFlag("useIridescence", false);
	_defineFlag("glossInvert", false);
	_defineFlag("sheenGlossInvert", false);
	_defineFlag("clearCoatGlossInvert", false);
	_defineFlag("opacityDither", DITHER_NONE);
	_defineFlag("opacityShadowDither", DITHER_NONE);
	_defineFlag("shadowCatcher", false);
	_defineFlag("vertexColorGamma", false);
	_defineTex2D("diffuse");
	_defineTex2D("specular");
	_defineTex2D("emissive");
	_defineTex2D("thickness", "g");
	_defineTex2D("specularityFactor", "g");
	_defineTex2D("normal", "");
	_defineTex2D("metalness", "g");
	_defineTex2D("gloss", "g");
	_defineTex2D("opacity", "a");
	_defineTex2D("refraction", "g");
	_defineTex2D("height", "g", false);
	_defineTex2D("ao", "g");
	_defineTex2D("light", "rgb", true, 1);
	_defineTex2D("msdf", "");
	_defineTex2D("diffuseDetail", "rgb", false);
	_defineTex2D("normalDetail", "");
	_defineTex2D("aoDetail", "g", false);
	_defineTex2D("clearCoat", "g");
	_defineTex2D("clearCoatGloss", "g");
	_defineTex2D("clearCoatNormal", "");
	_defineTex2D("sheen", "rgb");
	_defineTex2D("sheenGloss", "g");
	_defineTex2D("iridescence", "g");
	_defineTex2D("iridescenceThickness", "g");
	_defineTex2D("anisotropy", "");
	_defineFlag("diffuseDetailMode", DETAILMODE_MUL);
	_defineFlag("aoDetailMode", DETAILMODE_MUL);
	_defineObject("cubeMap");
	_defineObject("sphereMap");
	_defineObject("envAtlas");
	const getterFunc = function() {
		return this._prefilteredCubemaps;
	};
	const setterFunc = function(value) {
		const cubemaps = this._prefilteredCubemaps;
		value = value || [];
		let changed = false;
		let complete = true;
		for (let i2 = 0; i2 < 6; ++i2) {
			const v6 = value[i2] || null;
			if (cubemaps[i2] !== v6) {
				cubemaps[i2] = v6;
				changed = true;
			}
			complete = complete && !!cubemaps[i2];
		}
		if (changed) {
			if (complete) {
				this.envAtlas = EnvLighting.generatePrefilteredAtlas(cubemaps, {
					target: this.envAtlas
				});
			} else {
				if (this.envAtlas) {
					this.envAtlas.destroy();
					this.envAtlas = null;
				}
			}
			this._dirtyShader = true;
		}
	};
	const empty = [null, null, null, null, null, null];
	definePropInternal("prefilteredCubemaps", () => empty.slice(), setterFunc, getterFunc);
}
_defineMaterialProps();

var base64String = "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";
var data = null;
var initData = () => {
	if (!data) {
		const binaryString = atob(base64String);
		data = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
	}
};
var blueNoiseData = () => {
	initData();
	return data;
};
var BlueNoise = class {
	seed = 0;
	constructor(seed = 0) {
		this.seed = seed * 4;
		initData();
	}
	_next() {
		this.seed = (this.seed + 4) % data.length;
	}
	value() {
		this._next();
		return data[this.seed] / 255;
	}
	vec4(dest = new Vec4()) {
		this._next();
		return dest.set(data[this.seed], data[this.seed + 1], data[this.seed + 2], data[this.seed + 3]).mulScalar(1 / 255);
	}
};

var lightCubeDir = [
	new Vec3(-1, 0, 0),
	new Vec3(1, 0, 0),
	new Vec3(0, -1, 0),
	new Vec3(0, 1, 0),
	new Vec3(0, 0, -1),
	new Vec3(0, 0, 1)
];
var LightCube = class {
	colors = new Float32Array(6 * 3);
	update(ambientLight, lights2) {
		const colors = this.colors;
		const { r, g, b } = ambientLight;
		for (let j = 0; j < 6; j++) {
			colors[j * 3] = r;
			colors[j * 3 + 1] = g;
			colors[j * 3 + 2] = b;
		}
		for (let j = 0; j < lights2.length; j++) {
			const light = lights2[j];
			if (light._type === LIGHTTYPE_DIRECTIONAL) {
				for (let c2 = 0; c2 < 6; c2++) {
					const weight = Math.max(lightCubeDir[c2].dot(light._direction), 0) * light._intensity;
					const lightColor = light._color;
					colors[c2 * 3] += lightColor.r * weight;
					colors[c2 * 3 + 1] += lightColor.g * weight;
					colors[c2 * 3 + 2] += lightColor.b * weight;
				}
			}
		}
	}
};

var createTexture = (device, namePrefix, size, data2) => {
	const texture = new Texture(device, {
		name: `${namePrefix}${size}`,
		width: size,
		height: size,
		format: PIXELFORMAT_RGBA8,
		addressU: ADDRESS_REPEAT,
		addressV: ADDRESS_REPEAT,
		type: TEXTURETYPE_DEFAULT,
		magFilter: FILTER_NEAREST,
		minFilter: FILTER_NEAREST,
		anisotropy: 1,
		mipmaps: false
	});
	texture.lock().set(data2);
	texture.unlock();
	return texture;
};
var deviceCacheBlueNoise = new DeviceCache();
var getBlueNoiseTexture = (device) => {
	return deviceCacheBlueNoise.get(device, () => {
		const data2 = blueNoiseData();
		const size = Math.sqrt(data2.length / 4);
		return createTexture(device, "BlueNoise", size, data2);
	});
};

var ShadowMap = class _ShadowMap {
	constructor(texture, targets) {
		this.texture = texture;
		this.cached = false;
		this.renderTargets = targets;
	}
	destroy() {
		if (this.texture) {
			this.texture.destroy();
			this.texture = null;
		}
		const targets = this.renderTargets;
		for (let i2 = 0; i2 < targets.length; i2++) {
			targets[i2].destroy();
		}
		this.renderTargets.length = 0;
	}
	static create(device, light) {
		let shadowMap = null;
		if (light._type === LIGHTTYPE_OMNI) {
			shadowMap = this.createCubemap(device, light._shadowResolution, light._shadowType);
		} else {
			shadowMap = this.create2dMap(device, light._shadowResolution, light._shadowType);
		}
		return shadowMap;
	}
	// creates a shadow map which is used by the light texture atlas for clustered lighting
	static createAtlas(device, resolution, shadowType) {
		const shadowMap = this.create2dMap(device, resolution, shadowType);
		const targets = shadowMap.renderTargets;
		const rt = targets[0];
		for (let i2 = 0; i2 < 5; i2++) {
			targets.push(rt);
		}
		return shadowMap;
	}
	static create2dMap(device, size, shadowType) {
		const shadowInfo = shadowTypeInfo.get(shadowType);
		let format = shadowInfo.format;
		if (format === PIXELFORMAT_R32F && !device.textureFloatRenderable && device.textureHalfFloatRenderable) {
			format = PIXELFORMAT_R16F;
		}
		const formatName = pixelFormatInfo.get(format)?.name;
		let filter = FILTER_LINEAR;
		if (shadowType === SHADOW_VSM_32F) {
			filter = device.extTextureFloatLinear ? FILTER_LINEAR : FILTER_NEAREST;
		}
		if (shadowType === SHADOW_PCSS_32F) {
			filter = FILTER_NEAREST;
		}
		const texture = new Texture(device, {
			format,
			width: size,
			height: size,
			mipmaps: false,
			minFilter: filter,
			magFilter: filter,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			name: `ShadowMap2D_${formatName}`
		});
		let target2 = null;
		if (shadowInfo?.pcf) {
			texture.compareOnRead = true;
			texture.compareFunc = FUNC_LESS;
			target2 = new RenderTarget({
				depthBuffer: texture
			});
		} else {
			target2 = new RenderTarget({
				colorBuffer: texture,
				depth: true
			});
		}
		if (device.isWebGPU) {
			target2.flipY = true;
		}
		return new _ShadowMap(texture, [target2]);
	}
	static createCubemap(device, size, shadowType) {
		const shadowInfo = shadowTypeInfo.get(shadowType);
		const formatName = pixelFormatInfo.get(shadowInfo.format)?.name;
		const isPcss = shadowType === SHADOW_PCSS_32F;
		const filter = isPcss ? FILTER_NEAREST : FILTER_LINEAR;
		const cubemap = new Texture(device, {
			format: shadowInfo?.format,
			width: size,
			height: size,
			cubemap: true,
			mipmaps: false,
			minFilter: filter,
			magFilter: filter,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			name: `ShadowMapCube_${formatName}`
		});
		if (!isPcss) {
			cubemap.compareOnRead = true;
			cubemap.compareFunc = FUNC_LESS;
		}
		const targets = [];
		for (let i2 = 0; i2 < 6; i2++) {
			if (isPcss) {
				targets.push(new RenderTarget({
					colorBuffer: cubemap,
					face: i2,
					depth: true
				}));
			} else {
				targets.push(new RenderTarget({
					depthBuffer: cubemap,
					face: i2
				}));
			}
		}
		return new _ShadowMap(cubemap, targets);
	}
};

var _tempArray = [];
var _tempArray2 = [];
var _viewport = new Vec4();
var _scissor = new Vec4();
var Slot = class {
	constructor(rect) {
		this.size = Math.floor(rect.w * 1024);
		this.used = false;
		this.lightId = -1;
		this.rect = rect;
	}
};
var LightTextureAtlas = class {
	constructor(device) {
		this.device = device;
		this.version = 1;
		this.shadowAtlasResolution = 2048;
		this.shadowAtlas = null;
		this.shadowEdgePixels = 3;
		this.cookieAtlasResolution = 4;
		this.cookieAtlas = Texture.createDataTexture2D(this.device, "CookieAtlas", this.cookieAtlasResolution, this.cookieAtlasResolution, PIXELFORMAT_SRGBA8);
		this.cookieRenderTarget = new RenderTarget({
			colorBuffer: this.cookieAtlas,
			depth: false,
			flipY: true
		});
		this.slots = [];
		this.atlasSplit = [];
		this.cubeSlotsOffsets = [
			new Vec2(0, 0),
			new Vec2(0, 1),
			new Vec2(1, 0),
			new Vec2(1, 1),
			new Vec2(2, 0),
			new Vec2(2, 1)
		];
		this.scissorVec = new Vec4();
		this.allocateShadowAtlas(1);
		this.allocateCookieAtlas(1);
		this.allocateUniforms();
	}
	destroy() {
		this.destroyShadowAtlas();
		this.destroyCookieAtlas();
	}
	destroyShadowAtlas() {
		this.shadowAtlas?.destroy();
		this.shadowAtlas = null;
	}
	destroyCookieAtlas() {
		this.cookieAtlas?.destroy();
		this.cookieAtlas = null;
		this.cookieRenderTarget?.destroy();
		this.cookieRenderTarget = null;
	}
	allocateShadowAtlas(resolution, shadowType = SHADOW_PCF3_32F) {
		const existingFormat = this.shadowAtlas?.texture.format;
		const requiredFormat = shadowTypeInfo.get(shadowType).format;
		if (!this.shadowAtlas || this.shadowAtlas.texture.width !== resolution || existingFormat !== requiredFormat) {
			this.version++;
			this.destroyShadowAtlas();
			this.shadowAtlas = ShadowMap.createAtlas(this.device, resolution, shadowType);
			this.shadowAtlas.cached = true;
			const scissorOffset = 4 / this.shadowAtlasResolution;
			this.scissorVec.set(scissorOffset, scissorOffset, -2 * scissorOffset, -2 * scissorOffset);
		}
	}
	allocateCookieAtlas(resolution) {
		if (this.cookieAtlas.width !== resolution) {
			this.cookieRenderTarget.resize(resolution, resolution);
			this.version++;
		}
	}
	allocateUniforms() {
		this._shadowAtlasTextureId = this.device.scope.resolve("shadowAtlasTexture");
		this._shadowAtlasParamsId = this.device.scope.resolve("shadowAtlasParams");
		this._shadowAtlasParams = new Float32Array(2);
		this._cookieAtlasTextureId = this.device.scope.resolve("cookieAtlasTexture");
	}
	updateUniforms() {
		const rt = this.shadowAtlas.renderTargets[0];
		const shadowBuffer = rt.depthBuffer;
		this._shadowAtlasTextureId.setValue(shadowBuffer);
		this._shadowAtlasParams[0] = this.shadowAtlasResolution;
		this._shadowAtlasParams[1] = this.shadowEdgePixels;
		this._shadowAtlasParamsId.setValue(this._shadowAtlasParams);
		this._cookieAtlasTextureId.setValue(this.cookieAtlas);
	}
	subdivide(numLights, lightingParams) {
		let atlasSplit = lightingParams.atlasSplit;
		if (!atlasSplit) {
			const gridSize = Math.ceil(Math.sqrt(numLights));
			atlasSplit = _tempArray2;
			atlasSplit[0] = gridSize;
			atlasSplit.length = 1;
		}
		const arraysEqual2 = (a, b) => a.length === b.length && a.every((v6, i2) => v6 === b[i2]);
		if (!arraysEqual2(atlasSplit, this.atlasSplit)) {
			this.version++;
			this.slots.length = 0;
			this.atlasSplit.length = 0;
			this.atlasSplit.push(...atlasSplit);
			const splitCount = this.atlasSplit[0];
			if (splitCount > 1) {
				const invSize = 1 / splitCount;
				for (let i2 = 0; i2 < splitCount; i2++) {
					for (let j = 0; j < splitCount; j++) {
						const rect = new Vec4(i2 * invSize, j * invSize, invSize, invSize);
						const nextLevelSplit = this.atlasSplit[1 + i2 * splitCount + j];
						if (nextLevelSplit > 1) {
							for (let x3 = 0; x3 < nextLevelSplit; x3++) {
								for (let y2 = 0; y2 < nextLevelSplit; y2++) {
									const invSizeNext = invSize / nextLevelSplit;
									const rectNext = new Vec4(rect.x + x3 * invSizeNext, rect.y + y2 * invSizeNext, invSizeNext, invSizeNext);
									this.slots.push(new Slot(rectNext));
								}
							}
						} else {
							this.slots.push(new Slot(rect));
						}
					}
				}
			} else {
				this.slots.push(new Slot(new Vec4(0, 0, 1, 1)));
			}
			this.slots.sort((a, b) => {
				return b.size - a.size;
			});
		}
	}
	collectLights(localLights, lightingParams) {
		const cookiesEnabled = lightingParams.cookiesEnabled;
		const shadowsEnabled = lightingParams.shadowsEnabled;
		let needsShadowAtlas = false;
		let needsCookieAtlas = false;
		const lights2 = _tempArray;
		lights2.length = 0;
		const processLights = (list) => {
			for (let i2 = 0; i2 < list.length; i2++) {
				const light = list[i2];
				if (light.visibleThisFrame) {
					const lightShadow = shadowsEnabled && light.castShadows;
					const lightCookie = cookiesEnabled && !!light.cookie;
					needsShadowAtlas || (needsShadowAtlas = lightShadow);
					needsCookieAtlas || (needsCookieAtlas = lightCookie);
					if (lightShadow || lightCookie) {
						lights2.push(light);
					}
				}
			}
		};
		if (cookiesEnabled || shadowsEnabled) {
			processLights(localLights);
		}
		lights2.sort((a, b) => {
			return b.maxScreenSize - a.maxScreenSize;
		});
		if (needsShadowAtlas) {
			this.allocateShadowAtlas(this.shadowAtlasResolution, lightingParams.shadowType);
		}
		if (needsCookieAtlas) {
			this.allocateCookieAtlas(this.cookieAtlasResolution);
		}
		if (needsShadowAtlas || needsCookieAtlas) {
			this.subdivide(lights2.length, lightingParams);
		}
		return lights2;
	}
	// configure light to use assigned slot
	setupSlot(light, rect) {
		light.atlasViewport.copy(rect);
		const faceCount = light.numShadowFaces;
		for (let face = 0; face < faceCount; face++) {
			if (light.castShadows || light._cookie) {
				_viewport.copy(rect);
				_scissor.copy(rect);
				if (light._type === LIGHTTYPE_SPOT) {
					_viewport.add(this.scissorVec);
				}
				if (light._type === LIGHTTYPE_OMNI) {
					const smallSize = _viewport.z / 3;
					const offset3 = this.cubeSlotsOffsets[face];
					_viewport.x += smallSize * offset3.x;
					_viewport.y += smallSize * offset3.y;
					_viewport.z = smallSize;
					_viewport.w = smallSize;
					_scissor.copy(_viewport);
				}
				if (light.castShadows) {
					const lightRenderData = light.getRenderData(null, face);
					lightRenderData.shadowViewport.copy(_viewport);
					lightRenderData.shadowScissor.copy(_scissor);
				}
			}
		}
	}
	// assign a slot to the light
	assignSlot(light, slotIndex, slotReassigned) {
		light.atlasViewportAllocated = true;
		const slot = this.slots[slotIndex];
		slot.lightId = light.id;
		slot.used = true;
		if (slotReassigned) {
			light.atlasSlotUpdated = true;
			light.atlasVersion = this.version;
			light.atlasSlotIndex = slotIndex;
		}
	}
	// update texture atlas for a list of lights
	update(localLights, lightingParams) {
		this.shadowAtlasResolution = lightingParams.shadowAtlasResolution;
		this.cookieAtlasResolution = lightingParams.cookieAtlasResolution;
		const lights2 = this.collectLights(localLights, lightingParams);
		if (lights2.length > 0) {
			const slots = this.slots;
			for (let i2 = 0; i2 < slots.length; i2++) {
				slots[i2].used = false;
			}
			const assignCount = Math.min(lights2.length, slots.length);
			for (let i2 = 0; i2 < assignCount; i2++) {
				const light = lights2[i2];
				if (light.castShadows) {
					light._shadowMap = this.shadowAtlas;
				}
				const previousSlot = slots[light.atlasSlotIndex];
				if (light.atlasVersion === this.version && light.id === previousSlot?.lightId) {
					const previousSlot2 = slots[light.atlasSlotIndex];
					if (previousSlot2.size === slots[i2].size && !previousSlot2.used) {
						this.assignSlot(light, light.atlasSlotIndex, false);
					}
				}
			}
			let usedCount = 0;
			for (let i2 = 0; i2 < assignCount; i2++) {
				while (usedCount < slots.length && slots[usedCount].used) {
					usedCount++;
				}
				const light = lights2[i2];
				if (!light.atlasViewportAllocated) {
					this.assignSlot(light, usedCount, true);
				}
				const slot = slots[light.atlasSlotIndex];
				this.setupSlot(light, slot.rect);
			}
		}
		this.updateUniforms();
	}
};

var ShadowMapCache = class {
	constructor() {
		this.cache = /* @__PURE__ */ new Map();
	}
	destroy() {
		this.clear();
		this.cache = null;
	}
	// remove all shadowmaps from the cache
	clear() {
		this.cache.forEach((shadowMaps) => {
			shadowMaps.forEach((shadowMap) => {
				shadowMap.destroy();
			});
		});
		this.cache.clear();
	}
	// generates a string key for the shadow map required by the light
	getKey(light) {
		const isCubeMap = light._type === LIGHTTYPE_OMNI;
		const shadowType = light._shadowType;
		const resolution = light._shadowResolution;
		return `${isCubeMap}-${shadowType}-${resolution}`;
	}
	// returns shadow map from the cache, or creates a new one if none available
	get(device, light) {
		const key = this.getKey(light);
		const shadowMaps = this.cache.get(key);
		if (shadowMaps && shadowMaps.length) {
			return shadowMaps.pop();
		}
		const shadowMap = ShadowMap.create(device, light);
		shadowMap.cached = true;
		return shadowMap;
	}
	// returns shadow map for the light back to the cache
	add(light, shadowMap) {
		const key = this.getKey(light);
		const shadowMaps = this.cache.get(key);
		if (shadowMaps) {
			shadowMaps.push(shadowMap);
		} else {
			this.cache.set(key, [shadowMap]);
		}
	}
};

var RenderPassShadowLocalNonClustered = class extends RenderPass {
	constructor(device, shadowRenderer, light, face, applyVsm) {
		super(device);
		this.requiresCubemaps = false;
		this.shadowRenderer = shadowRenderer;
		this.light = light;
		this.face = face;
		this.applyVsm = applyVsm;
		this.shadowCamera = shadowRenderer.prepareFace(light, null, face);
		shadowRenderer.setupRenderPass(this, this.shadowCamera, true);
	}
	execute() {
		this.shadowRenderer.renderFace(this.light, null, this.face, false);
	}
	after() {
		if (this.applyVsm) {
			this.shadowRenderer.renderVsm(this.light, this.shadowCamera);
		}
	}
};

var ShadowRendererLocal = class {
	// temporary list to collect lights to render shadows for
	shadowLights = [];
	renderer;
	shadowRenderer;
	device;
	constructor(renderer, shadowRenderer) {
		this.renderer = renderer;
		this.shadowRenderer = shadowRenderer;
		this.device = renderer.device;
	}
	// Minimal prerequisite for local shadow-pass creation: ensure the shadow map exists. This is
	// caster- and camera-independent, so it can run early in the frame (before the frame graph is
	// built and before mesh culling), mirroring ShadowRendererDirectional#prepareShadowMap, so the
	// map exists when the frame graph build and the forward pass reference it. Clustered lighting
	// uses the shadow atlas, so no per-light map is allocated.
	prepareShadowMap(light) {
		if (!this.renderer.scene.clusteredLightingEnabled && !light._shadowMap) {
			light._shadowMap = ShadowMap.create(this.device, light);
		}
	}
	// cull local shadow map
	cull(light, comp, casters = null) {
		const isClustered = this.renderer.scene.clusteredLightingEnabled;
		light.visibleThisFrame = true;
		this.prepareShadowMap(light);
		const type = light._type;
		const faceCount = type === LIGHTTYPE_SPOT ? 1 : 6;
		for (let face = 0; face < faceCount; face++) {
			const lightRenderData = light.getRenderData(null, face);
			const shadowCam = lightRenderData.shadowCamera;
			shadowCam.nearClip = light.attenuationEnd / 1e3;
			shadowCam.farClip = light.attenuationEnd;
			const shadowCamNode = shadowCam._node;
			const lightNode = light._node;
			shadowCamNode.setPosition(lightNode.getPosition());
			if (type === LIGHTTYPE_SPOT) {
				shadowCam.fov = light._outerConeAngle * 2;
				shadowCamNode.setRotation(lightNode.getRotation());
				shadowCamNode.rotateLocal(-90, 0, 0);
			} else if (type === LIGHTTYPE_OMNI) {
				if (isClustered) {
					const tileSize = this.shadowRenderer.lightTextureAtlas.shadowAtlasResolution * light.atlasViewport.z / 3;
					const texelSize = 2 / tileSize;
					const filterSize = texelSize * this.shadowRenderer.lightTextureAtlas.shadowEdgePixels;
					shadowCam.fov = Math.atan(1 + filterSize) * math.RAD_TO_DEG * 2;
				} else {
					shadowCam.fov = 90;
				}
			}
			shadowCam.updateFrustum();
			this.shadowRenderer.cullShadowCasters(comp, light, lightRenderData.visibleCasters, shadowCam, casters);
		}
	}
	prepareLights(shadowLights, lights2) {
		let shadowCamera;
		for (let i2 = 0; i2 < lights2.length; i2++) {
			const light = lights2[i2];
			if (this.shadowRenderer.needsShadowRendering(light) && light.atlasViewportAllocated) {
				shadowLights.push(light);
				for (let face = 0; face < light.numShadowFaces; face++) {
					shadowCamera = this.shadowRenderer.prepareFace(light, null, face);
				}
			}
		}
		return shadowCamera;
	}
	buildNonClusteredRenderPasses(frameGraph, localLights) {
		for (let i2 = 0; i2 < localLights.length; i2++) {
			const light = localLights[i2];
			if (this.shadowRenderer.needsShadowRendering(light)) {
				const applyVsm = light._type === LIGHTTYPE_SPOT;
				const faceCount = light.numShadowFaces;
				for (let face = 0; face < faceCount; face++) {
					const renderPass = new RenderPassShadowLocalNonClustered(this.device, this.shadowRenderer, light, face, applyVsm);
					frameGraph.addRenderPass(renderPass);
				}
			}
		}
	}
};

var RenderPassShadowDirectional = class extends RenderPass {
	constructor(device, shadowRenderer, light, camera, allCascadesRendering) {
		super(device);
		this.shadowRenderer = shadowRenderer;
		this.light = light;
		this.camera = camera;
		this.allCascadesRendering = allCascadesRendering;
	}
	execute() {
		const { light, camera, shadowRenderer, allCascadesRendering } = this;
		const faceCount = light.numShadowFaces;
		const shadowUpdateOverrides = light.shadowUpdateOverrides;
		for (let face = 0; face < faceCount; face++) {
			if (shadowUpdateOverrides?.[face] !== SHADOWUPDATE_NONE) {
				shadowRenderer.renderFace(light, camera, face, !allCascadesRendering);
			}
			if (shadowUpdateOverrides?.[face] === SHADOWUPDATE_THISFRAME) {
				shadowUpdateOverrides[face] = SHADOWUPDATE_NONE;
			}
		}
	}
	after() {
		this.shadowRenderer.renderVsm(this.light, this.camera);
	}
};

var _unionSceneAabb = new BoundingBox();
var _cascadeAabbs = [new BoundingBox(), new BoundingBox(), new BoundingBox(), new BoundingBox()];
var _cascadeAabbValid = [false, false, false, false];
var _cascadeRadii = [0, 0, 0, 0];
var center = new Vec3();
var shadowCamView = new Mat4();
var aabbPoints = [
	new Vec3(),
	new Vec3(),
	new Vec3(),
	new Vec3(),
	new Vec3(),
	new Vec3(),
	new Vec3(),
	new Vec3()
];
var _depthRange = { min: 0, max: 0 };
function getDepthRange(cameraViewMatrix, aabbMin, aabbMax) {
	aabbPoints[0].x = aabbPoints[1].x = aabbPoints[2].x = aabbPoints[3].x = aabbMin.x;
	aabbPoints[1].y = aabbPoints[3].y = aabbPoints[7].y = aabbPoints[5].y = aabbMin.y;
	aabbPoints[2].z = aabbPoints[3].z = aabbPoints[6].z = aabbPoints[7].z = aabbMin.z;
	aabbPoints[4].x = aabbPoints[5].x = aabbPoints[6].x = aabbPoints[7].x = aabbMax.x;
	aabbPoints[0].y = aabbPoints[2].y = aabbPoints[4].y = aabbPoints[6].y = aabbMax.y;
	aabbPoints[0].z = aabbPoints[1].z = aabbPoints[4].z = aabbPoints[5].z = aabbMax.z;
	let minz = 9999999999;
	let maxz = -9999999999;
	for (let i2 = 0; i2 < 8; ++i2) {
		cameraViewMatrix.transformPoint(aabbPoints[i2], aabbPoints[i2]);
		const z2 = aabbPoints[i2].z;
		if (z2 < minz) minz = z2;
		if (z2 > maxz) maxz = z2;
	}
	_depthRange.min = minz;
	_depthRange.max = maxz;
	return _depthRange;
}
var ShadowRendererDirectional = class {
	renderer;
	shadowRenderer;
	device;
	constructor(renderer, shadowRenderer) {
		this.renderer = renderer;
		this.shadowRenderer = shadowRenderer;
		this.device = renderer.device;
	}
	// Minimal prerequisite for directional shadow-pass creation: ensure the shadow map exists
	// and the light is marked visible. This is caster- and camera-independent, so it can run
	// early in the frame (before mesh culling), unlike cull() which sets up the per-cascade
	// shadow cameras and culls casters.
	prepareShadowMap(light) {
		light.visibleThisFrame = true;
		if (!light._shadowMap) {
			light._shadowMap = ShadowMap.create(this.device, light);
		}
	}
	// cull directional shadow map. prepareShadowMap(light) must have been called first.
	cull(light, comp, camera, casters = null) {
		const nearDist = camera._nearClip;
		this.generateSplitDistances(light, nearDist, Math.min(camera._farClip, light.shadowDistance));
		const shadowUpdateOverrides = light.shadowUpdateOverrides;
		let numActiveCascades = 0;
		for (let cascade = 0; cascade < light.numCascades; cascade++) {
			if (shadowUpdateOverrides?.[cascade] === SHADOWUPDATE_NONE) {
				break;
			}
			const lightRenderData = light.getRenderData(camera, cascade);
			const shadowCam = lightRenderData.shadowCamera;
			shadowCam.renderTarget = light._shadowMap.renderTargets[0];
			lightRenderData.shadowViewport.copy(light.cascades[cascade]);
			lightRenderData.shadowScissor.copy(light.cascades[cascade]);
			const shadowCamNode = shadowCam._node;
			const lightNode = light._node;
			shadowCamNode.setPosition(lightNode.getPosition());
			shadowCamNode.setRotation(lightNode.getRotation());
			shadowCamNode.rotateLocal(-90, 0, 0);
			const frustumNearDist = cascade === 0 ? nearDist : light._shadowCascadeDistances[cascade - 1];
			const frustumFarDist = light._shadowCascadeDistances[cascade];
			const frustumPoints = camera.getFrustumCorners(frustumNearDist, frustumFarDist);
			center.set(0, 0, 0);
			const cameraWorldMat = camera.node.getWorldTransform();
			for (let i2 = 0; i2 < 8; i2++) {
				cameraWorldMat.transformPoint(frustumPoints[i2], frustumPoints[i2]);
				center.add(frustumPoints[i2]);
			}
			center.mulScalar(1 / 8);
			let radius = 0;
			for (let i2 = 0; i2 < 8; i2++) {
				const dist = frustumPoints[i2].sub(center).length();
				if (dist > radius) {
					radius = dist;
				}
			}
			const right2 = shadowCamNode.right;
			const up3 = shadowCamNode.up;
			const lightDir = shadowCamNode.forward;
			const sizeRatio = 0.25 * light._shadowResolution / radius;
			const x3 = Math.ceil(center.dot(up3) * sizeRatio) / sizeRatio;
			const y2 = Math.ceil(center.dot(right2) * sizeRatio) / sizeRatio;
			const scaledUp = up3.mulScalar(x3);
			const scaledRight = right2.mulScalar(y2);
			const dot = center.dot(lightDir);
			const scaledDir = lightDir.mulScalar(dot);
			center.add2(scaledUp, scaledRight).add(scaledDir);
			shadowCamNode.setPosition(center);
			shadowCamNode.translateLocal(0, 0, 1e6);
			shadowCam.nearClip = 0.01;
			shadowCam.farClip = 2e6;
			shadowCam.orthoHeight = radius;
			shadowCam.updateFrustum();
			this.shadowRenderer.cullShadowCasters(comp, light, lightRenderData.visibleCasters, shadowCam, casters);
			const cascadeFlag = 1 << cascade;
			const visibleCasters = lightRenderData.visibleCasters;
			const origNumVisibleCasters = visibleCasters.length;
			let numVisibleCasters = 0;
			const cascadeAabb = _cascadeAabbs[cascade];
			for (let i2 = 0; i2 < origNumVisibleCasters; i2++) {
				const meshInstance = visibleCasters[i2];
				if (meshInstance.shadowCascadeMask & cascadeFlag) {
					visibleCasters[numVisibleCasters++] = meshInstance;
					if (numVisibleCasters === 1) {
						cascadeAabb.copy(meshInstance.aabb);
					} else {
						cascadeAabb.add(meshInstance.aabb);
					}
				}
			}
			if (origNumVisibleCasters !== numVisibleCasters) {
				visibleCasters.length = numVisibleCasters;
			}
			_cascadeAabbValid[cascade] = numVisibleCasters > 0;
			_cascadeRadii[cascade] = radius;
			numActiveCascades++;
		}
		let useUnion = false;
		if (light._isPcss) {
			for (let cascade = 0; cascade < numActiveCascades; cascade++) {
				if (!_cascadeAabbValid[cascade]) continue;
				if (!useUnion) {
					_unionSceneAabb.copy(_cascadeAabbs[cascade]);
					useUnion = true;
				} else {
					_unionSceneAabb.add(_cascadeAabbs[cascade]);
				}
			}
		}
		for (let cascade = 0; cascade < numActiveCascades; cascade++) {
			let aabbSource;
			if (useUnion) {
				aabbSource = _unionSceneAabb;
			} else if (_cascadeAabbValid[cascade]) {
				aabbSource = _cascadeAabbs[cascade];
			} else {
				continue;
			}
			const lightRenderData = light.getRenderData(camera, cascade);
			const shadowCam = lightRenderData.shadowCamera;
			const shadowCamNode = shadowCam._node;
			shadowCamView.copy(shadowCamNode.getWorldTransform()).invert();
			const depthRange = getDepthRange(shadowCamView, aabbSource.getMin(), aabbSource.getMax());
			shadowCamNode.translateLocal(0, 0, depthRange.max + 0.1);
			shadowCam.farClip = depthRange.max - depthRange.min + 0.2;
			lightRenderData.projectionCompensation = _cascadeRadii[cascade];
		}
	}
	// function to generate frustum split distances
	generateSplitDistances(light, nearDist, farDist) {
		light._shadowCascadeDistances.fill(farDist);
		for (let i2 = 1; i2 < light.numCascades; i2++) {
			const fraction = i2 / light.numCascades;
			const linearDist = nearDist + (farDist - nearDist) * fraction;
			const logDist = nearDist * (farDist / nearDist) ** fraction;
			const dist = math.lerp(linearDist, logDist, light.cascadeDistribution);
			light._shadowCascadeDistances[i2 - 1] = dist;
		}
	}
	getLightRenderPass(light, camera) {
		let renderPass = null;
		if (this.shadowRenderer.needsShadowRendering(light)) {
			const faceCount = light.numShadowFaces;
			const shadowUpdateOverrides = light.shadowUpdateOverrides;
			let allCascadesRendering = true;
			let shadowCamera;
			for (let face = 0; face < faceCount; face++) {
				if (shadowUpdateOverrides?.[face] === SHADOWUPDATE_NONE) {
					allCascadesRendering = false;
				}
				shadowCamera = this.shadowRenderer.prepareFace(light, camera, face);
			}
			renderPass = new RenderPassShadowDirectional(this.device, this.shadowRenderer, light, camera, allCascadesRendering);
			this.shadowRenderer.setupRenderPass(renderPass, shadowCamera, allCascadesRendering);
		}
		return renderPass;
	}
};

var tempSet = /* @__PURE__ */ new Set();
var shadowCamView2 = new Mat4();
var shadowCamViewProj = new Mat4();
var pixelOffset = new Float32Array(2);
var blurScissorRect = new Vec4(1, 1, 0, 0);
var viewportMatrix = new Mat4();
function gauss(x3, sigma) {
	return Math.exp(-(x3 * x3) / (2 * sigma * sigma));
}
function gaussWeights(kernelSize) {
	const sigma = (kernelSize - 1) / (2 * 3);
	const halfWidth = (kernelSize - 1) * 0.5;
	const values = new Array(kernelSize);
	let sum = 0;
	for (let i2 = 0; i2 < kernelSize; ++i2) {
		values[i2] = gauss(i2 - halfWidth, sigma);
		sum += values[i2];
	}
	for (let i2 = 0; i2 < kernelSize; ++i2) {
		values[i2] /= sum;
	}
	return values;
}
var ShadowRenderer = class {
	shadowPassCache = [];
	constructor(renderer, lightTextureAtlas) {
		this.device = renderer.device;
		this.renderer = renderer;
		this.lightTextureAtlas = lightTextureAtlas;
		const scope = this.device.scope;
		this.sourceId = scope.resolve("source");
		this.pixelOffsetId = scope.resolve("pixelOffset");
		this.weightId = scope.resolve("weight[0]");
		this.blurVsmShader = [{}, {}];
		this.blurVsmWeights = {};
		this.shadowMapLightRadiusId = scope.resolve("light_radius");
		this.viewUniformFormat = null;
		this.blendStateWrite = new BlendState();
		this.blendStateNoWrite = new BlendState();
		this.blendStateNoWrite.setColorWrite(false, false, false, false);
	}
	// creates shadow camera for a light and sets up its constant properties
	static createShadowCamera(device, shadowType, type, face) {
		const shadowCam = LightCamera.create(device, SHADOWCAMERA_NAME, type, face);
		const shadowInfo = shadowTypeInfo.get(shadowType);
		const isVsm = shadowInfo?.vsm ?? false;
		const isPcf = shadowInfo?.pcf ?? false;
		if (isVsm) {
			shadowCam.clearColor = new Color(0, 0, 0, 0);
		} else {
			shadowCam.clearColor = new Color(1, 1, 1, 1);
		}
		shadowCam.clearDepthBuffer = true;
		shadowCam.clearStencilBuffer = false;
		shadowCam.clearColorBuffer = !isPcf;
		return shadowCam;
	}
	_cullShadowCastersInternal(meshInstances, visible, camera) {
		const numInstances = meshInstances.length;
		for (let i2 = 0; i2 < numInstances; i2++) {
			const meshInstance = meshInstances[i2];
			if (meshInstance.castShadow) {
				if (!meshInstance.cull || meshInstance._isVisible(camera)) {
					meshInstance.visibleThisFrame = true;
					visible.push(meshInstance);
				}
			}
		}
	}
	cullShadowCasters(comp, light, visible, camera, casters) {
		this.renderer.scene?.fire(EVENT_PRECULL, null);
		visible.length = 0;
		if (casters) {
			this._cullShadowCastersInternal(casters, visible, camera);
		} else {
			const layers = comp.layerList;
			const len = layers.length;
			for (let i2 = 0; i2 < len; i2++) {
				const layer = layers[i2];
				if (layer._lightsSet.has(light)) {
					if (!tempSet.has(layer)) {
						tempSet.add(layer);
						this._cullShadowCastersInternal(layer.shadowCasters, visible, camera);
					}
				}
			}
			tempSet.clear();
		}
		visible.sort(this.sortCompareShader);
		this.renderer.scene?.fire(EVENT_POSTCULL, null);
	}
	sortCompareShader(drawCallA, drawCallB) {
		const keyA = drawCallA._sortKeyShadow;
		const keyB = drawCallB._sortKeyShadow;
		if (keyA === keyB) {
			return drawCallB.mesh.id - drawCallA.mesh.id;
		}
		return keyB - keyA;
	}
	setupRenderState(device, light) {
		const isClustered = this.renderer.scene.clusteredLightingEnabled;
		const useShadowSampler = isClustered ? light._isPcf : (
			// both spot and omni light are using shadow sampler when clustered
			light._isPcf && light._type !== LIGHTTYPE_OMNI
		);
		device.setBlendState(useShadowSampler ? this.blendStateNoWrite : this.blendStateWrite);
		device.setDepthState(light.shadowDepthState);
		device.setStencilState(null, null);
	}
	dispatchUniforms(light, shadowCam, lightRenderData, face) {
		const shadowCamNode = shadowCam._node;
		if (light._type !== LIGHTTYPE_DIRECTIONAL) {
			this.renderer.dispatchViewPos(shadowCamNode.getPosition());
			this.shadowMapLightRadiusId.setValue(light.attenuationEnd);
		}
		shadowCamView2.setTRS(shadowCamNode.getPosition(), shadowCamNode.getRotation(), Vec3.ONE).invert();
		shadowCamViewProj.mul2(shadowCam.projectionMatrix, shadowCamView2);
		const rectViewport = lightRenderData.shadowViewport;
		shadowCam.rect = rectViewport;
		shadowCam.scissorRect = lightRenderData.shadowScissor;
		viewportMatrix.setViewport(rectViewport.x, rectViewport.y, rectViewport.z, rectViewport.w);
		lightRenderData.shadowMatrix.mul2(viewportMatrix, shadowCamViewProj);
		if (light._type === LIGHTTYPE_DIRECTIONAL) {
			light._shadowMatrixPalette.set(lightRenderData.shadowMatrix.data, face * 16);
		}
	}
	getShadowPass(light) {
		const lightType = light._type;
		const shadowType = light._shadowType;
		let shadowPassInfo = this.shadowPassCache[lightType]?.[shadowType];
		if (!shadowPassInfo) {
			const shadowPassName = `ShadowPass_${lightType}_${shadowType}`;
			shadowPassInfo = ShaderPass.get(this.device).allocate(shadowPassName, {
				isShadow: true,
				lightType,
				shadowType
			});
			if (!this.shadowPassCache[lightType]) {
				this.shadowPassCache[lightType] = [];
			}
			this.shadowPassCache[lightType][shadowType] = shadowPassInfo;
		}
		return shadowPassInfo.index;
	}
	submitCasters(visibleCasters, light, camera) {
		const device = this.device;
		const renderer = this.renderer;
		const scene = renderer.scene;
		const shadowPass = this.getShadowPass(light);
		const cameraShaderParams = camera.shaderParams;
		const flipFactor = camera.renderTarget.flipY ? -1 : 1;
		const count = visibleCasters.length;
		for (let i2 = 0; i2 < count; i2++) {
			const meshInstance = visibleCasters[i2];
			const mesh = meshInstance.mesh;
			const instancingData = meshInstance.instancingData;
			if (instancingData && instancingData.count <= 0) {
				continue;
			}
			meshInstance.ensureMaterial(device);
			const material = meshInstance.material;
			renderer.setBaseConstants(device, material);
			renderer.setSkinning(device, meshInstance);
			if (material.dirty) {
				material.updateUniforms(device, scene);
				material.dirty = false;
			}
			renderer.setupCullModeAndFrontFace(true, flipFactor, meshInstance);
			material.setParameters(device);
			meshInstance.setParameters(device);
			const shaderInstance = meshInstance.getShaderInstance(shadowPass, 0, scene, cameraShaderParams, this.viewUniformFormat);
			const shadowShader = shaderInstance.shader;
			if (shadowShader.failed) continue;
			meshInstance._sortKeyShadow = shadowShader.id;
			device.setShader(shadowShader);
			renderer.setVertexBuffers(device, mesh);
			renderer.setMorphing(device, meshInstance.morphInstance);
			if (instancingData) {
				device.setVertexBuffer(instancingData.vertexBuffer);
			}
			renderer.setMeshInstanceMatrices(meshInstance);
			renderer.setupMeshUniformBuffers(shaderInstance);
			const style = meshInstance.renderStyle;
			const indirectData = meshInstance.getDrawCommands(camera);
			device.draw(mesh.primitive[style], mesh.indexBuffer[style], instancingData?.count, indirectData);
			renderer._shadowDrawCalls++;
			if (instancingData) {
				renderer._instancedDrawCalls++;
			}
		}
	}
	// Pure predicate - whether the light needs its shadow rendered this frame. Has no side effects:
	// the SHADOWUPDATE_THISFRAME -> SHADOWUPDATE_NONE consume and the shadow-map-update stat are
	// applied once per frame in Renderer#consumeOneShotShadows, after the frame graph is built and
	// shadow casters are culled (so build and cull can both read shadowUpdateMode before it changes).
	needsShadowRendering(light) {
		return light.enabled && light.castShadows && light.shadowUpdateMode !== SHADOWUPDATE_NONE && light.visibleThisFrame;
	}
	getLightRenderData(light, camera, face) {
		return light.getRenderData(light._type === LIGHTTYPE_DIRECTIONAL ? camera : null, face);
	}
	setupRenderPass(renderPass, shadowCamera, clearRenderTarget) {
		const rt = shadowCamera.renderTarget;
		renderPass.init(rt);
		renderPass.depthStencilOps.clearDepthValue = 1;
		renderPass.depthStencilOps.clearDepth = clearRenderTarget;
		if (rt.depthBuffer) {
			renderPass.depthStencilOps.storeDepth = true;
		} else {
			renderPass.colorOps.clearValue.copy(shadowCamera.clearColor);
			renderPass.colorOps.clear = clearRenderTarget;
			renderPass.depthStencilOps.storeDepth = false;
		}
		renderPass.requiresCubemaps = false;
	}
	// prepares render target / render target settings to allow render pass to be set up
	prepareFace(light, camera, face) {
		const type = light._type;
		const lightRenderData = this.getLightRenderData(light, camera, face);
		const shadowCam = lightRenderData.shadowCamera;
		const renderTargetIndex = type === LIGHTTYPE_DIRECTIONAL ? 0 : face;
		shadowCam.renderTarget = light._shadowMap.renderTargets[renderTargetIndex];
		return shadowCam;
	}
	renderFace(light, camera, face, clear) {
		const device = this.device;
		const lightRenderData = this.getLightRenderData(light, camera, face);
		const shadowCam = lightRenderData.shadowCamera;
		this.dispatchUniforms(light, shadowCam, lightRenderData, face);
		const rt = shadowCam.renderTarget;
		const renderer = this.renderer;
		renderer.setCameraUniforms(shadowCam, rt);
		renderer.setupViewUniformBuffers(this.viewUniformFormat, null);
		renderer.setupViewport(shadowCam, rt);
		if (clear) {
			renderer.clear(shadowCam);
		}
		this.setupRenderState(device, light);
		this.submitCasters(lightRenderData.visibleCasters, light, shadowCam);
	}
	renderVsm(light, camera) {
		if (light._isVsm && light._vsmBlurSize > 1) {
			const isClustered = this.renderer.scene.clusteredLightingEnabled;
			if (!isClustered || light._type === LIGHTTYPE_DIRECTIONAL) {
				this.applyVsmBlur(light, camera);
			}
		}
	}
	getVsmBlurShader(blurMode, filterSize) {
		const cache = this.blurVsmShader;
		let blurShader = cache[blurMode][filterSize];
		if (!blurShader) {
			this.blurVsmWeights[filterSize] = gaussWeights(filterSize);
			const defines = /* @__PURE__ */ new Map();
			defines.set("{SAMPLES}", filterSize);
			if (blurMode === 1) defines.set("GAUSS", "");
			blurShader = ShaderUtils.createShader(this.device, {
				uniqueName: `blurVsm${blurMode}${filterSize}`,
				attributes: { vertex_position: SEMANTIC_POSITION },
				vertexChunk: "fullscreenQuadVS",
				fragmentChunk: "blurVSMPS",
				fragmentDefines: defines
			});
			cache[blurMode][filterSize] = blurShader;
		}
		return blurShader;
	}
	applyVsmBlur(light, camera) {
		const device = this.device;
		device.setBlendState(BlendState.NOBLEND);
		const lightRenderData = light.getRenderData(light._type === LIGHTTYPE_DIRECTIONAL ? camera : null, 0);
		const shadowCam = lightRenderData.shadowCamera;
		const origShadowMap = shadowCam.renderTarget;
		const tempShadowMap = this.renderer.shadowMapCache.get(device, light);
		const tempRt = tempShadowMap.renderTargets[0];
		const blurMode = light.vsmBlurMode;
		const filterSize = light._vsmBlurSize;
		const blurShader = this.getVsmBlurShader(blurMode, filterSize);
		blurScissorRect.z = light._shadowResolution - 2;
		blurScissorRect.w = blurScissorRect.z;
		this.sourceId.setValue(origShadowMap.colorBuffer);
		pixelOffset[0] = 1 / light._shadowResolution;
		pixelOffset[1] = 0;
		this.pixelOffsetId.setValue(pixelOffset);
		if (blurMode === BLUR_GAUSSIAN) this.weightId.setValue(this.blurVsmWeights[filterSize]);
		drawQuadWithShader(device, tempRt, blurShader, null, blurScissorRect);
		this.sourceId.setValue(tempRt.colorBuffer);
		pixelOffset[1] = pixelOffset[0];
		pixelOffset[0] = 0;
		this.pixelOffsetId.setValue(pixelOffset);
		drawQuadWithShader(device, origShadowMap, blurShader, null, blurScissorRect);
		this.renderer.shadowMapCache.add(light, tempShadowMap);
	}
	initViewUniformFormat() {
		if (!this.viewUniformFormat) {
			this.viewUniformFormat = new UniformBufferFormat(this.device, [
				new UniformFormat("matrix_viewProjection", UNIFORMTYPE_MAT4)
			]);
		}
	}
	frameUpdate() {
		this.initViewUniformFormat();
	}
};

var FramePassMultiView = class extends FramePass {
	children = [];
	constructor(graphicsDevice) {
		super(graphicsDevice);
		this.name = "FramePassMultiView";
	}
	addChild(pass) {
		this.children.push(pass);
	}
	render() {
		if (!this.enabled) return;
		const device = this.device;
		const subs = device.xrSubImages;
		const numViews = subs?.length ?? 0;
		const children = this.children;
		const childCount = children.length;
		if (numViews === 0) {
			for (let c2 = 0; c2 < childCount; c2++) {
				children[c2].render();
			}
			return;
		}
		const backBufferImpl = device.backBuffer?.impl;
		const savedXrColorTexture = device.xrColorTexture;
		const savedColorTexture = backBufferImpl?.assignedColorTexture ?? null;
		const savedViewFormat = backBufferImpl?.colorAttachments?.[0]?.format ?? null;
		for (let v6 = 0; v6 < numViews; v6++) {
			const sub = subs[v6];
			device.xrCurrentViewIndex = v6;
			device.xrColorTexture = sub.colorTexture;
			device.xrColorTextureViewDescriptor = sub.viewDescriptor;
			backBufferImpl?.assignColorTexture?.(sub.colorTexture, sub.viewFormat);
			for (let c2 = 0; c2 < childCount; c2++) {
				children[c2].render();
			}
		}
		device.xrCurrentViewIndex = -1;
		device.xrColorTextureViewDescriptor = null;
		device.xrColorTexture = savedXrColorTexture ?? null;
		if (backBufferImpl && savedColorTexture && savedViewFormat && backBufferImpl.assignedColorTexture !== savedColorTexture) {
			backBufferImpl.assignColorTexture(savedColorTexture, savedViewFormat);
		}
	}
};

var tempClusterArray = [];
var WorldClustersAllocator = class {
	_empty = null;
	_allocated = [];
	_clusters = /* @__PURE__ */ new Map();
	constructor(graphicsDevice) {
		this.device = graphicsDevice;
	}
	destroy() {
		if (this._empty) {
			this._empty.destroy();
			this._empty = null;
		}
		this._allocated.forEach((cluster) => {
			cluster.destroy();
		});
		this._allocated.length = 0;
	}
	get count() {
		return this._allocated.length;
	}
	// returns an empty light cluster object to be used when no lights are used
	get empty() {
		if (!this._empty) {
			const empty = new WorldClusters(this.device);
			empty.name = "ClusterEmpty";
			empty.update([]);
			this._empty = empty;
		}
		return this._empty;
	}
	_assignClustersForPass(renderPass) {
		const layerRenderSteps = renderPass.layerRenderSteps;
		if (!layerRenderSteps) {
			return;
		}
		const count = layerRenderSteps.length;
		for (let i2 = 0; i2 < count; i2++) {
			const step = layerRenderSteps[i2];
			step.lightClusters = null;
			const layer = step.layer;
			if (layer.hasClusteredLights && layer.meshInstances.length) {
				const hash = layer.getLightIdHash();
				const existingStep = this._clusters.get(hash);
				let clusters = existingStep?.lightClusters;
				if (!clusters) {
					clusters = tempClusterArray.pop() ?? new WorldClusters(this.device);
					this._allocated.push(clusters);
					this._clusters.set(hash, step);
				}
				step.lightClusters = clusters;
			}
			if (!step.lightClusters) {
				step.lightClusters = this.empty;
			}
		}
	}
	// assign light clusters to layer render steps that need it
	assign(renderPasses) {
		tempClusterArray.push(...this._allocated);
		this._allocated.length = 0;
		this._clusters.clear();
		const passCount = renderPasses.length;
		for (let p = 0; p < passCount; p++) {
			const pass = renderPasses[p];
			if (pass instanceof FramePassMultiView) {
				const children = pass.children;
				for (let c2 = 0; c2 < children.length; c2++) {
					this._assignClustersForPass(children[c2]);
				}
			} else {
				this._assignClustersForPass(pass);
			}
		}
		tempClusterArray.forEach((item) => item.destroy());
		tempClusterArray.length = 0;
	}
	update(renderPasses, lighting) {
		this.assign(renderPasses);
		this._clusters.forEach((step) => {
			const layer = step.layer;
			const cluster = step.lightClusters;
			cluster.update(layer.clusteredLightsSet, lighting);
		});
	}
};

var _viewport2 = new Vec4();
var _invViewProjMatrices = [];
var RenderPassCookieRenderer = class _RenderPassCookieRenderer extends RenderPass {
	_quadRenderer2D = null;
	_quadRendererCube = null;
	_filteredLights = [];
	_forceCopy = false;
	_evtDeviceRestored = null;
	constructor(device, cubeSlotsOffsets) {
		super(device);
		this._cubeSlotsOffsets = cubeSlotsOffsets;
		this.requiresCubemaps = false;
		this.blitTextureId = device.scope.resolve("blitTexture");
		this.invViewProjId = device.scope.resolve("invViewProj");
		this._evtDeviceRestored = device.on("devicerestored", this.onDeviceRestored, this);
	}
	destroy() {
		this._quadRenderer2D?.destroy();
		this._quadRenderer2D = null;
		this._quadRendererCube?.destroy();
		this._quadRendererCube = null;
		this._evtDeviceRestored?.off();
		this._evtDeviceRestored = null;
	}
	static create(renderTarget, cubeSlotsOffsets) {
		const renderPass = new _RenderPassCookieRenderer(renderTarget.device, cubeSlotsOffsets);
		renderPass.init(renderTarget);
		renderPass.colorOps.clear = false;
		renderPass.depthStencilOps.clearDepth = false;
		return renderPass;
	}
	onDeviceRestored() {
		this._forceCopy = true;
	}
	update(lights2) {
		const filteredLights = this._filteredLights;
		this.filter(lights2, filteredLights);
		this.executeEnabled = filteredLights.length > 0;
	}
	filter(lights2, filteredLights) {
		for (let i2 = 0; i2 < lights2.length; i2++) {
			const light = lights2[i2];
			if (light._type === LIGHTTYPE_DIRECTIONAL) {
				continue;
			}
			if (!light.atlasViewportAllocated) {
				continue;
			}
			const cookieUpdated = light.cookie && light.cookie.uploadVersion !== light.cookieRenderVersion;
			if (!light.atlasSlotUpdated && !cookieUpdated && !this._forceCopy) {
				continue;
			}
			if (light.enabled && light.cookie && light.visibleThisFrame) {
				filteredLights.push(light);
			}
		}
		this._forceCopy = false;
	}
	initInvViewProjMatrices() {
		if (!_invViewProjMatrices.length) {
			for (let face = 0; face < 6; face++) {
				const camera = LightCamera.create(this.device, null, LIGHTTYPE_OMNI, face);
				const projMat = camera.projectionMatrix;
				const viewMat2 = camera.node.getLocalTransform().clone().invert();
				_invViewProjMatrices[face] = new Mat4().mul2(projMat, viewMat2).invert();
			}
		}
	}
	get quadRenderer2D() {
		if (!this._quadRenderer2D) {
			const shader = ShaderUtils.createShader(this.device, {
				uniqueName: "cookieRenderer2d",
				attributes: { vertex_position: SEMANTIC_POSITION },
				vertexChunk: "cookieBlitVS",
				fragmentChunk: "cookieBlit2DPS"
			});
			this._quadRenderer2D = new QuadRender(shader);
		}
		return this._quadRenderer2D;
	}
	get quadRendererCube() {
		if (!this._quadRendererCube) {
			const shader = ShaderUtils.createShader(this.device, {
				uniqueName: "cookieRendererCube",
				attributes: { vertex_position: SEMANTIC_POSITION },
				vertexChunk: "cookieBlitVS",
				fragmentChunk: "cookieBlitCubePS"
			});
			this._quadRendererCube = new QuadRender(shader);
		}
		return this._quadRendererCube;
	}
	execute() {
		const device = this.device;
		device.setDrawStates();
		const renderTargetWidth = this.renderTarget.colorBuffer.width;
		const cubeSlotsOffsets = this._cubeSlotsOffsets;
		const filteredLights = this._filteredLights;
		for (let i2 = 0; i2 < filteredLights.length; i2++) {
			const light = filteredLights[i2];
			const faceCount = light.numShadowFaces;
			const quad = faceCount > 1 ? this.quadRendererCube : this.quadRenderer2D;
			if (faceCount > 1) {
				this.initInvViewProjMatrices();
			}
			this.blitTextureId.setValue(light.cookie);
			light.cookieRenderVersion = light.cookie.uploadVersion;
			for (let face = 0; face < faceCount; face++) {
				_viewport2.copy(light.atlasViewport);
				if (faceCount > 1) {
					const smallSize = _viewport2.z / 3;
					const offset3 = cubeSlotsOffsets[face];
					_viewport2.x += smallSize * offset3.x;
					_viewport2.y += smallSize * offset3.y;
					_viewport2.z = smallSize;
					_viewport2.w = smallSize;
					this.invViewProjId.setValue(_invViewProjMatrices[face].data);
				}
				_viewport2.mulScalar(renderTargetWidth);
				quad.render(_viewport2);
			}
		}
		filteredLights.length = 0;
	}
};

var RenderPassShadowLocalClustered = class extends RenderPass {
	constructor(device, shadowRenderer, shadowRendererLocal) {
		super(device);
		this.requiresCubemaps = false;
		this.shadowRenderer = shadowRenderer;
		this.shadowRendererLocal = shadowRendererLocal;
	}
	update(localLights) {
		const shadowLights = this.shadowRendererLocal.shadowLights;
		const shadowCamera = this.shadowRendererLocal.prepareLights(shadowLights, localLights);
		const count = shadowLights.length;
		this.enabled = count > 0;
		if (count) {
			this.shadowRenderer.setupRenderPass(this, shadowCamera, false);
		}
	}
	execute() {
		const shadowLights = this.shadowRendererLocal.shadowLights;
		const count = shadowLights.length;
		for (let i2 = 0; i2 < count; i2++) {
			const light = shadowLights[i2];
			for (let face = 0; face < light.numShadowFaces; face++) {
				this.shadowRenderer.renderFace(light, null, face, true);
			}
		}
		shadowLights.length = 0;
	}
};

var FramePassUpdateClustered = class extends FramePass {
	constructor(device, renderer, shadowRenderer, shadowRendererLocal, lightTextureAtlas) {
		super(device);
		this.renderer = renderer;
		this.frameGraph = null;
		this.cookiesRenderPass = RenderPassCookieRenderer.create(lightTextureAtlas.cookieRenderTarget, lightTextureAtlas.cubeSlotsOffsets);
		this.beforePasses.push(this.cookiesRenderPass);
		this.shadowRenderPass = new RenderPassShadowLocalClustered(device, shadowRenderer, shadowRendererLocal);
		this.beforePasses.push(this.shadowRenderPass);
	}
	update(frameGraph, shadowsEnabled, cookiesEnabled, lights2, localLights) {
		this.frameGraph = frameGraph;
		this.cookiesRenderPass.enabled = cookiesEnabled;
		if (cookiesEnabled) {
			this.cookiesRenderPass.update(lights2);
		}
		this.shadowRenderPass.enabled = shadowsEnabled;
		if (shadowsEnabled) {
			this.shadowRenderPass.update(localLights);
		}
	}
	destroy() {
		this.cookiesRenderPass.destroy();
		this.cookiesRenderPass = null;
	}
	execute() {
		const { renderer } = this;
		const { scene } = renderer;
		renderer.worldClustersAllocator.update(this.frameGraph.renderPasses, scene.lighting);
	}
};

var tempSphere = new BoundingSphere();
var _tempSet = /* @__PURE__ */ new Set();
var Culler = class {
	processingMeshInstances = /* @__PURE__ */ new Set();
	_cullCameras = [];
	cameraDirShadowLights = /* @__PURE__ */ new Map();
	dirLightShadows = /* @__PURE__ */ new Map();
	constructor(renderer) {
		this.renderer = renderer;
	}
	cullMeshInstances(camera, drawCalls, culledInstances) {
		const opaque = culledInstances.opaque;
		opaque.length = 0;
		const transparent = culledInstances.transparent;
		transparent.length = 0;
		const doCull = camera.frustumCulling;
		const count = drawCalls.length;
		for (let i2 = 0; i2 < count; i2++) {
			const drawCall = drawCalls[i2];
			if (drawCall.visible) {
				const visible = !doCull || !drawCall.cull || drawCall._isVisible(camera);
				if (visible) {
					drawCall.visibleThisFrame = true;
					const bucket = drawCall.transparent ? transparent : opaque;
					bucket.push(drawCall);
					if (drawCall.skinInstance || drawCall.morphInstance || drawCall.gsplatInstance) {
						this.processingMeshInstances.add(drawCall);
						if (drawCall.gsplatInstance) {
							drawCall.gsplatInstance.cameras.push(camera);
						}
					}
				}
			}
		}
	}
	cullLights(camera, lights2) {
		const { scene } = this.renderer;
		const clusteredLightingEnabled = scene.clusteredLightingEnabled;
		const physicalUnits = scene.physicalUnits;
		for (let i2 = 0; i2 < lights2.length; i2++) {
			const light = lights2[i2];
			if (light.enabled) {
				if (light._type !== LIGHTTYPE_DIRECTIONAL) {
					light.getBoundingSphere(tempSphere);
					if (camera.frustum.containsSphere(tempSphere)) {
						light.visibleThisFrame = true;
						light.usePhysicalUnits = physicalUnits;
						const screenSize = camera.getScreenSize(tempSphere);
						light.maxScreenSize = Math.max(light.maxScreenSize, screenSize);
					} else {
						if (!clusteredLightingEnabled) {
							if (light.castShadows && !light.shadowMap) {
								light.visibleThisFrame = true;
							}
						}
					}
				} else {
					light.usePhysicalUnits = scene.physicalUnits;
				}
			}
		}
	}
	cullShadowmaps(comp) {
		const { renderer } = this;
		const localLights = renderer.localLights;
		for (let i2 = 0; i2 < localLights.length; i2++) {
			const light = localLights[i2];
			if (light._type !== LIGHTTYPE_DIRECTIONAL) {
				if (light.visibleThisFrame && light.castShadows && light.shadowUpdateMode !== SHADOWUPDATE_NONE) {
					renderer._shadowRendererLocal.cull(light, comp);
				}
			}
		}
		this.cameraDirShadowLights.forEach((lightList, camera) => {
			for (let i2 = 0; i2 < lightList.length; i2++) {
				renderer._shadowRendererDirectional.cull(lightList[i2], comp, camera);
			}
		});
	}
	consumeOneShotShadows() {
		const { renderer } = this;
		const clustered = renderer.scene.clusteredLightingEnabled;
		const shadowRenderer = renderer.shadowRenderer;
		const localLights = renderer.localLights;
		for (let i2 = 0; i2 < localLights.length; i2++) {
			const light = localLights[i2];
			if (shadowRenderer.needsShadowRendering(light) && (!clustered || light.atlasViewportAllocated)) {
				renderer._shadowMapUpdates += light.numShadowFaces;
				if (light.shadowUpdateMode === SHADOWUPDATE_THISFRAME) {
					light.shadowUpdateMode = SHADOWUPDATE_NONE;
				}
			}
		}
		this.cameraDirShadowLights.forEach((lightList) => {
			for (let i2 = 0; i2 < lightList.length; i2++) {
				const light = lightList[i2];
				if (shadowRenderer.needsShadowRendering(light)) {
					renderer._shadowMapUpdates += light.numShadowFaces;
					if (light.shadowUpdateMode === SHADOWUPDATE_THISFRAME) {
						light.shadowUpdateMode = SHADOWUPDATE_NONE;
					}
				}
			}
		});
	}
	collectDirectionalShadowLights(comp) {
		const { renderer } = this;
		this.cameraDirShadowLights.clear();
		const cameras = comp.cameras;
		for (let i2 = 0; i2 < cameras.length; i2++) {
			const cameraComponent = cameras[i2];
			if (cameraComponent.enabled) {
				const camera = cameraComponent.camera;
				let lightList;
				const cameraLayers = camera.layers;
				for (let l = 0; l < cameraLayers.length; l++) {
					const cameraLayer = comp.getLayerById(cameraLayers[l]);
					if (cameraLayer) {
						const layerDirLights = cameraLayer.splitLights[LIGHTTYPE_DIRECTIONAL];
						for (let j = 0; j < layerDirLights.length; j++) {
							const light = layerDirLights[j];
							if (light.castShadows && !_tempSet.has(light)) {
								_tempSet.add(light);
								lightList = lightList ?? [];
								lightList.push(light);
								renderer._shadowRendererDirectional.prepareShadowMap(light);
							}
						}
					}
				}
				if (lightList) {
					this.cameraDirShadowLights.set(camera, lightList);
				}
				_tempSet.clear();
			}
		}
	}
	updateLightVisibility(comp) {
		const { renderer } = this;
		const { scene } = renderer;
		const lights2 = renderer.lights;
		for (let i2 = 0; i2 < lights2.length; i2++) {
			lights2[i2].beginFrame();
		}
		const numCameras = comp.cameras.length;
		for (let i2 = 0; i2 < numCameras; i2++) {
			const camera = comp.cameras[i2];
			camera.camera.updateFrustum();
			const layerIds = camera.layers;
			for (let j = 0; j < layerIds.length; j++) {
				const layer = comp.getLayerById(layerIds[j]);
				if (layer && layer.enabled) {
					this.cullLights(camera.camera, layer._lights);
				}
			}
		}
		const isClustered = scene.clusteredLightingEnabled;
		if (isClustered) {
			renderer.updateLightTextureAtlas();
		}
		const localLights = renderer.localLights;
		for (let i2 = 0; i2 < localLights.length; i2++) {
			const light = localLights[i2];
			if (light._type !== LIGHTTYPE_DIRECTIONAL) {
				if (isClustered) {
					if (light.atlasSlotUpdated && light.shadowUpdateMode === SHADOWUPDATE_NONE) {
						light.shadowUpdateMode = SHADOWUPDATE_THISFRAME;
					}
				} else {
					if (light.castShadows && light.visibleThisFrame && !light._shadowMap) {
						renderer._shadowRendererLocal.prepareShadowMap(light);
						if (light.shadowUpdateMode === SHADOWUPDATE_NONE) {
							light.shadowUpdateMode = SHADOWUPDATE_THISFRAME;
						}
					}
				}
			}
		}
		this.collectDirectionalShadowLights(comp);
	}
	requestMeshInstanceCull(camera, layer) {
		if (camera.addCullLayer(layer)) {
			this._cullCameras.push(camera);
		}
	}
	executeMeshInstanceCull() {
		const { renderer } = this;
		const { scene } = renderer;
		const cameras = this._cullCameras;
		for (let i2 = 0; i2 < cameras.length; i2++) {
			const camera = cameras[i2];
			const cameraComponent = camera.node?.camera ?? null;
			scene?.fire(EVENT_PRECULL, cameraComponent);
			camera.updateFrustum();
			for (const layer of camera.cullLayers) {
				this.cullMeshInstances(camera, layer.meshInstances, layer.getCulledInstances(camera));
			}
			scene?.fire(EVENT_POSTCULL, cameraComponent);
			camera.clearCullLayers();
		}
		cameras.length = 0;
	}
	cullComposition(comp) {
		const { renderer } = this;
		const { scene } = renderer;
		this.processingMeshInstances.clear();
		renderer._camerasRendered += comp.cameras.length;
		this.executeMeshInstanceCull();
		this.cullShadowmaps(comp);
		scene?.fire(EVENT_CULL_END);
	}
};

var _skinUpdateIndex = 0;
var viewProjMat = new Mat4();
var viewInvMat = new Mat4();
var viewMat = new Mat4();
var viewMat3 = new Mat3();
var _tempLightSet = /* @__PURE__ */ new Set();
var _tempLayerSet = /* @__PURE__ */ new Set();
var _dynamicBindGroup2 = new DynamicBindGroup();
var _tempClearColor = [0, 0, 0, 1];
var _tempClearOptions = {
	color: _tempClearColor,
	depth: 1,
	stencil: 0,
	flags: 0
};
var _haltonSequence = [
	new Vec2(0.5, 0.333333),
	new Vec2(0.25, 0.666667),
	new Vec2(0.75, 0.111111),
	new Vec2(0.125, 0.444444),
	new Vec2(0.625, 0.777778),
	new Vec2(0.375, 0.222222),
	new Vec2(0.875, 0.555556),
	new Vec2(0.0625, 0.888889),
	new Vec2(0.5625, 0.037037),
	new Vec2(0.3125, 0.37037),
	new Vec2(0.8125, 0.703704),
	new Vec2(0.1875, 0.148148),
	new Vec2(0.6875, 0.481481),
	new Vec2(0.4375, 0.814815),
	new Vec2(0.9375, 0.259259),
	new Vec2(0.03125, 0.592593)
];
var _tempProjMat0 = new Mat4();
var _tempProjMat1 = new Mat4();
var _tempProjMat4 = new Mat4();
var _tempProjMat5 = new Mat4();
var _tempSet2 = /* @__PURE__ */ new Set();
var _tempMeshInstances = [];
var _tempMeshInstancesSkinned = [];
var Renderer = class {
	clustersDebugRendered = false;
	scene;
	culler;
	worldClustersAllocator;
	lights = [];
	localLights = [];
	_viewUniformBuffers = /* @__PURE__ */ new WeakMap();
	_dynamicViewBindGroup = new DynamicBindGroup();
	_viewBindGroups = [];
	_viewBindGroupOffsets = [];
	_viewOffsetScratch = [0];
	blueNoise = new BlueNoise(123);
	gsplatDirector = null;
	constructor(graphicsDevice, scene) {
		this.device = graphicsDevice;
		this.scene = scene;
		this.worldClustersAllocator = new WorldClustersAllocator(graphicsDevice);
		this.lightTextureAtlas = new LightTextureAtlas(graphicsDevice);
		this.shadowMapCache = new ShadowMapCache();
		this.shadowRenderer = new ShadowRenderer(this, this.lightTextureAtlas);
		this._shadowRendererLocal = new ShadowRendererLocal(this, this.shadowRenderer);
		this._shadowRendererDirectional = new ShadowRendererDirectional(this, this.shadowRenderer);
		this.culler = new Culler(this);
		if (this.scene.clusteredLightingEnabled) {
			this._renderPassUpdateClustered = new FramePassUpdateClustered(
				this.device,
				this,
				this.shadowRenderer,
				this._shadowRendererLocal,
				this.lightTextureAtlas
			);
		}
		this.viewUniformFormat = null;
		this._skinTime = 0;
		this._morphTime = 0;
		this._cullTime = 0;
		this._shadowMapTime = 0;
		this._lightClustersTime = 0;
		this._layerCompositionUpdateTime = 0;
		this._shadowDrawCalls = 0;
		this._skinDrawCalls = 0;
		this._instancedDrawCalls = 0;
		this._shadowMapUpdates = 0;
		this._numDrawCallsCulled = 0;
		this._camerasRendered = 0;
		this._lightClusters = 0;
		this._gsplatCount = 0;
		const scope = graphicsDevice.scope;
		this.boneTextureId = scope.resolve("texture_poseMap");
		this.modelMatrixId = scope.resolve("matrix_model");
		this.normalMatrixId = scope.resolve("matrix_normal");
		this.viewInvId = scope.resolve("matrix_viewInverse");
		this.viewPos = new Float32Array(3);
		this.viewPosId = scope.resolve("view_position");
		this.projId = scope.resolve("matrix_projection");
		this.projSkyboxId = scope.resolve("matrix_projectionSkybox");
		this.viewId = scope.resolve("matrix_view");
		this.viewId3 = scope.resolve("matrix_view3");
		this.viewProjId = scope.resolve("matrix_viewProjection");
		this.flipYId = scope.resolve("projectionFlipY");
		this.tbnBasis = scope.resolve("tbnBasis");
		this.cameraParams = new Float32Array(4);
		this.cameraParamsId = scope.resolve("camera_params");
		this.viewportSize = new Float32Array(4);
		this.viewportSizeId = scope.resolve("viewport_size");
		this.viewIndexId = scope.resolve("view_index");
		this.viewIndexId.setValue(0);
		this.blueNoiseJitterVersion = 0;
		this.blueNoiseJitterVec = new Vec4();
		this.blueNoiseJitterData = new Float32Array(4);
		this.blueNoiseJitterId = scope.resolve("blueNoiseJitter");
		this.blueNoiseTextureId = scope.resolve("blueNoiseTex32");
		this.alphaTestId = scope.resolve("alpha_ref");
		this.opacityMapId = scope.resolve("texture_opacityMap");
		this.exposureId = scope.resolve("exposure");
		this.morphPositionTex = scope.resolve("morphPositionTex");
		this.morphNormalTex = scope.resolve("morphNormalTex");
		this.morphTexParams = scope.resolve("morph_tex_params");
		this.lightCube = new LightCube();
		this.constantLightCube = scope.resolve("lightCube[0]");
	}
	destroy() {
		this.shadowRenderer = null;
		this._shadowRendererLocal = null;
		this._shadowRendererDirectional = null;
		this.shadowMapCache.destroy();
		this.shadowMapCache = null;
		this._renderPassUpdateClustered?.destroy();
		this._renderPassUpdateClustered = null;
		this.lightTextureAtlas.destroy();
		this.lightTextureAtlas = null;
		this.gsplatDirector?.destroy();
		this.gsplatDirector = null;
	}
	setupViewport(camera, renderTarget) {
		const device = this.device;
		const pixelWidth = renderTarget ? renderTarget.width : device.width;
		const pixelHeight = renderTarget ? renderTarget.height : device.height;
		const rect = camera.rect;
		let x3 = Math.floor(rect.x * pixelWidth);
		let y2 = Math.floor(rect.y * pixelHeight);
		let w = Math.floor(rect.z * pixelWidth);
		let h2 = Math.floor(rect.w * pixelHeight);
		device.setViewport(x3, y2, w, h2);
		if (camera._scissorRectClear) {
			const scissorRect = camera.scissorRect;
			x3 = Math.floor(scissorRect.x * pixelWidth);
			y2 = Math.floor(scissorRect.y * pixelHeight);
			w = Math.floor(scissorRect.z * pixelWidth);
			h2 = Math.floor(scissorRect.w * pixelHeight);
		}
		device.setScissor(x3, y2, w, h2);
	}
	setCameraUniforms(camera, target2) {
		const flipY = target2?.flipY;
		let viewList = null;
		if (camera.xrActive) {
			viewList = camera.xrViews;
			camera.updateViewTransforms();
		} else {
			let projMat = camera.projectionMatrix;
			if (camera.calculateProjection) {
				camera.calculateProjection(projMat, VIEW_CENTER);
			}
			let projMatSkybox = camera.getProjectionMatrixSkybox();
			const webgpu = this.device.isWebGPU;
			projMat = Camera.applyShaderProjectionTransform(projMat, _tempProjMat0, flipY, webgpu);
			projMatSkybox = Camera.applyShaderProjectionTransform(projMatSkybox, _tempProjMat1, flipY, webgpu);
			const { jitter } = camera;
			let jitterX = 0;
			let jitterY = 0;
			if (jitter > 0) {
				const targetWidth = target2 ? target2.width : this.device.width;
				const targetHeight = target2 ? target2.height : this.device.height;
				const offset3 = _haltonSequence[this.device.renderVersion % _haltonSequence.length];
				jitterX = jitter * (offset3.x * 2 - 1) / targetWidth;
				jitterY = jitter * (offset3.y * 2 - 1) / targetHeight;
				projMat = _tempProjMat4.copy(projMat);
				projMat.data[8] = jitterX;
				projMat.data[9] = jitterY;
				projMatSkybox = _tempProjMat5.copy(projMatSkybox);
				projMatSkybox.data[8] = jitterX;
				projMatSkybox.data[9] = jitterY;
				if (this.blueNoiseJitterVersion !== this.device.renderVersion) {
					this.blueNoiseJitterVersion = this.device.renderVersion;
					this.blueNoise.vec4(this.blueNoiseJitterVec);
				}
			}
			const jitterVec = jitter > 0 ? this.blueNoiseJitterVec : Vec4.ZERO;
			this.blueNoiseJitterData[0] = jitterVec.x;
			this.blueNoiseJitterData[1] = jitterVec.y;
			this.blueNoiseJitterData[2] = jitterVec.z;
			this.blueNoiseJitterData[3] = jitterVec.w;
			this.blueNoiseJitterId.setValue(this.blueNoiseJitterData);
			this.projId.setValue(projMat.data);
			this.projSkyboxId.setValue(projMatSkybox.data);
			if (camera.calculateTransform) {
				camera.calculateTransform(viewInvMat, VIEW_CENTER);
			} else {
				const pos = camera._node.getPosition();
				const rot = camera._node.getRotation();
				viewInvMat.setTRS(pos, rot, Vec3.ONE);
			}
			this.viewInvId.setValue(viewInvMat.data);
			viewMat.copy(viewInvMat).invert();
			this.viewId.setValue(viewMat.data);
			viewMat3.setFromMat4(viewMat);
			this.viewId3.setValue(viewMat3.data);
			viewProjMat.mul2(projMat, viewMat);
			this.viewProjId.setValue(viewProjMat.data);
			camera._storeShaderMatrices(viewProjMat, jitterX, jitterY, this.device.renderVersion);
			this.flipYId.setValue(flipY ? -1 : 1);
			this.dispatchViewPos(camera._node.getPosition());
			camera.frustum.setFromMat4(viewProjMat);
		}
		this.tbnBasis.setValue(this.device.isWebGPU !== !!flipY ? -1 : 1);
		this.cameraParamsId.setValue(camera.fillShaderParams(this.cameraParams));
		const xrView = camera.xrActive ? camera.xrViews[0] ?? null : null;
		let viewportWidth = xrView ? xrView.viewport.z : target2 ? target2.width : this.device.width;
		let viewportHeight = xrView ? xrView.viewport.w : target2 ? target2.height : this.device.height;
		viewportWidth *= camera.rect.z;
		viewportHeight *= camera.rect.w;
		this.viewportSize[0] = viewportWidth;
		this.viewportSize[1] = viewportHeight;
		this.viewportSize[2] = 1 / viewportWidth;
		this.viewportSize[3] = 1 / viewportHeight;
		this.viewportSizeId.setValue(this.viewportSize);
		this.exposureId.setValue(this.scene.physicalUnits ? camera.getExposure() : this.scene.exposure);
		return viewList;
	}
	clear(camera, clearColor, clearDepth, clearStencil) {
		const flags = (clearColor ?? camera._clearColorBuffer ? CLEARFLAG_COLOR : 0) | (clearDepth ?? camera._clearDepthBuffer ? CLEARFLAG_DEPTH : 0) | (clearStencil ?? camera._clearStencilBuffer ? CLEARFLAG_STENCIL : 0);
		if (flags) {
			const device = this.device;
			const c2 = camera._clearColor;
			_tempClearColor[0] = c2.r;
			_tempClearColor[1] = c2.g;
			_tempClearColor[2] = c2.b;
			_tempClearColor[3] = c2.a;
			_tempClearOptions.depth = camera._clearDepth;
			_tempClearOptions.stencil = camera._clearStencil;
			_tempClearOptions.flags = flags;
			device.clear(_tempClearOptions);
		}
	}
	setupCullModeAndFrontFace(cullFaces, flipFactor, drawCall) {
		const material = drawCall.material;
		const flipFaces = flipFactor * drawCall.flipFacesFactor * drawCall.node.worldScaleSign;
		let frontFace = material.frontFace;
		if (flipFaces < 0) {
			frontFace = frontFace === FRONTFACE_CCW ? FRONTFACE_CW : FRONTFACE_CCW;
		}
		this.device.setCullMode(cullFaces ? material.cull : CULLFACE_NONE);
		this.device.setFrontFace(frontFace);
	}
	setupCullMode(cullFaces, flipFactor, drawCall) {
		this.setupCullModeAndFrontFace(cullFaces, flipFactor, drawCall);
	}
	setBaseConstants(device, material) {
		device.setCullMode(material.cull);
		device.setFrontFace(material.frontFace);
		if (material.opacityMap) {
			this.opacityMapId.setValue(material.opacityMap);
		}
		if (material.opacityMap || material.alphaTest > 0) {
			this.alphaTestId.setValue(material.alphaTest);
		}
	}
	updateCpuSkinMatrices(drawCalls) {
		_skinUpdateIndex++;
		const drawCallsCount = drawCalls.length;
		if (drawCallsCount === 0) return;
		for (let i2 = 0; i2 < drawCallsCount; i2++) {
			const si = drawCalls[i2].skinInstance;
			if (si) {
				si.updateMatrices(drawCalls[i2].node, _skinUpdateIndex);
				si._dirty = true;
			}
		}
	}
	updateGpuSkinMatrices(drawCalls) {
		for (const drawCall of drawCalls) {
			const skin = drawCall.skinInstance;
			if (skin && skin._dirty) {
				skin.updateMatrixPalette(drawCall.node, _skinUpdateIndex);
				skin._dirty = false;
			}
		}
	}
	updateMorphing(drawCalls) {
		for (const drawCall of drawCalls) {
			const morphInst = drawCall.morphInstance;
			if (morphInst && morphInst._dirty) {
				morphInst.update();
			}
		}
	}
	updateGSplats(drawCalls) {
		for (const drawCall of drawCalls) {
			drawCall.gsplatInstance?.update();
		}
	}
	gpuUpdate(drawCalls) {
		this.updateGpuSkinMatrices(drawCalls);
		this.updateMorphing(drawCalls);
		this.updateGSplats(drawCalls);
	}
	setVertexBuffers(device, mesh) {
		device.setVertexBuffer(mesh.vertexBuffer);
	}
	setMorphing(device, morphInstance) {
		if (morphInstance) {
			morphInstance.prepareRendering(device);
			device.setVertexBuffer(morphInstance.morph.vertexBufferIds);
			this.morphPositionTex.setValue(morphInstance.texturePositions);
			this.morphNormalTex.setValue(morphInstance.textureNormals);
			this.morphTexParams.setValue(morphInstance._textureParams);
		}
	}
	setSkinning(device, meshInstance) {
		const skinInstance = meshInstance.skinInstance;
		if (skinInstance) {
			this._skinDrawCalls++;
			const boneTexture = skinInstance.boneTexture;
			this.boneTextureId.setValue(boneTexture);
		}
	}
	// sets Vec3 camera position uniform
	dispatchViewPos(position5) {
		const vp = this.viewPos;
		vp[0] = position5.x;
		vp[1] = position5.y;
		vp[2] = position5.z;
		this.viewPosId.setValue(vp);
	}
	initViewUniformFormat(isClustered) {
		if (!this.viewUniformFormat) {
			const uniforms = [
				new UniformFormat("matrix_view", UNIFORMTYPE_MAT4),
				new UniformFormat("matrix_viewInverse", UNIFORMTYPE_MAT4),
				new UniformFormat("matrix_projection", UNIFORMTYPE_MAT4),
				new UniformFormat("matrix_projectionSkybox", UNIFORMTYPE_MAT4),
				new UniformFormat("matrix_viewProjection", UNIFORMTYPE_MAT4),
				new UniformFormat("matrix_view3", UNIFORMTYPE_MAT3),
				new UniformFormat("cubeMapRotationMatrix", UNIFORMTYPE_MAT3),
				new UniformFormat("view_position", UNIFORMTYPE_VEC3),
				new UniformFormat("viewport_size", UNIFORMTYPE_VEC4),
				new UniformFormat("skyboxIntensity", UNIFORMTYPE_FLOAT),
				new UniformFormat("exposure", UNIFORMTYPE_FLOAT),
				new UniformFormat("view_index", UNIFORMTYPE_UINT)
			];
			if (isClustered) {
				uniforms.push(...[
					new UniformFormat("clusterCellsCountByBoundsSize", UNIFORMTYPE_VEC3),
					new UniformFormat("clusterBoundsMin", UNIFORMTYPE_VEC3),
					new UniformFormat("clusterBoundsDelta", UNIFORMTYPE_VEC3),
					new UniformFormat("clusterCellsDot", UNIFORMTYPE_IVEC3),
					new UniformFormat("clusterCellsMax", UNIFORMTYPE_IVEC3),
					new UniformFormat("shadowAtlasParams", UNIFORMTYPE_VEC2),
					new UniformFormat("clusterMaxCells", UNIFORMTYPE_INT),
					new UniformFormat("numClusteredLights", UNIFORMTYPE_INT),
					new UniformFormat("clusterTextureWidth", UNIFORMTYPE_INT)
				]);
			}
			this.viewUniformFormat = new UniformBufferFormat(this.device, uniforms);
		}
	}
	setupViewUniforms(view, index) {
		this.projId.setValue(view.projMat.data);
		this.projSkyboxId.setValue(view.projMat.data);
		this.viewId.setValue(view.viewOffMat.data);
		this.viewInvId.setValue(view.viewInvOffMat.data);
		this.viewId3.setValue(view.viewMat3.data);
		this.viewProjId.setValue(view.projViewOffMat.data);
		this.viewPosId.setValue(view.positionData);
		this.viewIndexId.setValue(index);
	}
	getViewUniformBuffer(viewUniformFormat) {
		let ub = this._viewUniformBuffers.get(viewUniformFormat);
		if (!ub) {
			ub = new UniformBuffer(this.device, viewUniformFormat, false);
			this._viewUniformBuffers.set(viewUniformFormat, ub);
		}
		return ub;
	}
	setupViewUniformBuffers(viewUniformFormat, viewList) {
		const { device } = this;
		const ub = this.getViewUniformBuffer(viewUniformFormat);
		if (viewList) {
			const viewCount = viewList.length;
			for (let i2 = 0; i2 < viewCount; i2++) {
				this.setupViewUniforms(viewList[i2], i2);
				ub.update(this._dynamicViewBindGroup);
				this._viewBindGroups[i2] = this._dynamicViewBindGroup.bindGroup;
				this._viewBindGroupOffsets[i2] = this._dynamicViewBindGroup.offsets[0];
			}
		} else {
			ub.update(this._dynamicViewBindGroup);
			device.setBindGroup(BINDGROUP_VIEW, this._dynamicViewBindGroup.bindGroup, this._dynamicViewBindGroup.offsets);
		}
	}
	setupMeshUniformBuffers(shaderInstance) {
		const device = this.device;
		if (device.supportsUniformBuffers) {
			const meshBindGroup = shaderInstance.getBindGroup(device);
			meshBindGroup.update();
			device.setBindGroup(BINDGROUP_MESH, meshBindGroup);
			const meshUniformBuffer = shaderInstance.getUniformBuffer(device);
			meshUniformBuffer.update(_dynamicBindGroup2);
			device.setBindGroup(BINDGROUP_MESH_UB, _dynamicBindGroup2.bindGroup, _dynamicBindGroup2.offsets);
		}
	}
	setMeshInstanceMatrices(meshInstance, setNormalMatrix = false) {
		const modelMatrix = meshInstance.node.worldTransform;
		this.modelMatrixId.setValue(modelMatrix.data);
		if (setNormalMatrix) {
			this.normalMatrixId.setValue(meshInstance.node.normalMatrix.data);
		}
	}
	collectLights(comp) {
		this.lights.length = 0;
		this.localLights.length = 0;
		const stats = this.scene._stats;
		const count = comp.layerList.length;
		for (let i2 = 0; i2 < count; i2++) {
			const layer = comp.layerList[i2];
			if (!_tempLayerSet.has(layer)) {
				_tempLayerSet.add(layer);
				const lights2 = layer._lights;
				for (let j = 0; j < lights2.length; j++) {
					const light = lights2[j];
					if (!_tempLightSet.has(light)) {
						_tempLightSet.add(light);
						this.lights.push(light);
						if (light._type !== LIGHTTYPE_DIRECTIONAL) {
							this.localLights.push(light);
						}
					}
				}
			}
		}
		stats.lights = this.lights.length;
		_tempLightSet.clear();
		_tempLayerSet.clear();
	}
	updateShaders(drawCalls, onlyLitShaders) {
		const count = drawCalls.length;
		for (let i2 = 0; i2 < count; i2++) {
			const mat2 = drawCalls[i2].material;
			if (mat2) {
				if (!_tempSet2.has(mat2)) {
					_tempSet2.add(mat2);
					if (mat2.getShaderVariant !== Material.prototype.getShaderVariant) {
						if (onlyLitShaders) {
							if (!mat2.useLighting || mat2.emitter && !mat2.emitter.lighting) {
								continue;
							}
						}
						mat2.clearVariants();
					}
				}
			}
		}
		_tempSet2.clear();
	}
	updateFrameUniforms() {
		this.blueNoiseTextureId.setValue(getBlueNoiseTexture(this.device));
	}
	beginFrame(comp) {
		const scene = this.scene;
		const updateShaders = scene.updateShaders || this.device._shadersDirty;
		let totalMeshInstances = 0;
		const layers = comp.layerList;
		const layerCount = layers.length;
		for (let i2 = 0; i2 < layerCount; i2++) {
			const layer = layers[i2];
			const meshInstances = layer.meshInstances;
			const count = meshInstances.length;
			totalMeshInstances += count;
			for (let j = 0; j < count; j++) {
				const meshInst = meshInstances[j];
				meshInst.visibleThisFrame = false;
				if (updateShaders) {
					_tempMeshInstances.push(meshInst);
				}
				if (meshInst.skinInstance) {
					_tempMeshInstancesSkinned.push(meshInst);
				}
			}
		}
		if (updateShaders) {
			const onlyLitShaders = !scene.updateShaders || !this.device._shadersDirty;
			this.updateShaders(_tempMeshInstances, onlyLitShaders);
			scene.updateShaders = false;
			this.device._shadersDirty = false;
			scene._shaderVersion++;
		}
		this.updateFrameUniforms();
		this.updateCpuSkinMatrices(_tempMeshInstancesSkinned);
		_tempMeshInstances.length = 0;
		_tempMeshInstancesSkinned.length = 0;
	}
	updateLightTextureAtlas() {
		this.lightTextureAtlas.update(this.localLights, this.scene.lighting);
	}
	updateLayerComposition(comp) {
		const len = comp.layerList.length;
		const scene = this.scene;
		const shaderVersion = scene._shaderVersion;
		for (let i2 = 0; i2 < len; i2++) {
			const layer = comp.layerList[i2];
			layer._shaderVersion = shaderVersion;
		}
		comp._update();
	}
	frameUpdate() {
		this.clustersDebugRendered = false;
		this.initViewUniformFormat(this.scene.clusteredLightingEnabled);
		this.culler.dirLightShadows.clear();
	}
};

var LayerRenderStep = class {
	cameraComponent;
	layer;
	transparent;
	renderTarget;
	lightClusters = null;
	// clear flags
	clearColor = false;
	clearDepth = false;
	clearStencil = false;
	// true if this is the first render step using its camera
	firstCameraUse = false;
	// true if this is the last render step using its camera
	lastCameraUse = false;
	constructor(cameraComponent, layer, transparent, renderTarget) {
		this.cameraComponent = cameraComponent;
		this.layer = layer;
		this.transparent = transparent;
		this.renderTarget = renderTarget;
	}
	setupClears(cameraComponent, layer) {
		this.clearColor = cameraComponent?.clearColorBuffer || layer.clearColorBuffer;
		this.clearDepth = cameraComponent?.clearDepthBuffer || layer.clearDepthBuffer;
		this.clearStencil = cameraComponent?.clearStencilBuffer || layer.clearStencilBuffer;
	}
};

var RenderPassForward = class extends RenderPass {
	layerComposition;
	scene;
	renderer;
	layerRenderSteps = [];
	gammaCorrection;
	toneMapping;
	noDepthClear = false;
	constructor(device, layerComposition, scene, renderer) {
		super(device);
		this.layerComposition = layerComposition;
		this.scene = scene;
		this.renderer = renderer;
	}
	get rendersAnything() {
		return this.layerRenderSteps.length > 0;
	}
	addLayerRenderStep(layerRenderStep) {
		this.layerRenderSteps.push(layerRenderStep);
	}
	addLayer(cameraComponent, layer, transparent, autoClears = true) {
		const step = new LayerRenderStep(cameraComponent, layer, transparent, this.renderTarget);
		if (autoClears) {
			const firstStep = this.layerRenderSteps.length === 0;
			step.setupClears(firstStep ? cameraComponent : void 0, layer);
		}
		this.addLayerRenderStep(step);
	}
	updateDirectionalShadows() {
		const { renderer, layerRenderSteps } = this;
		for (let i2 = 0; i2 < layerRenderSteps.length; i2++) {
			const step = layerRenderSteps[i2];
			const cameraComponent = step.cameraComponent;
			const camera = cameraComponent.camera;
			const shadowDirLights = this.renderer.culler.cameraDirShadowLights.get(camera);
			if (shadowDirLights) {
				for (let l = 0; l < shadowDirLights.length; l++) {
					const light = shadowDirLights[l];
					if (renderer.culler.dirLightShadows.get(light) !== camera) {
						renderer.culler.dirLightShadows.set(light, camera);
						const shadowPass = renderer._shadowRendererDirectional.getLightRenderPass(light, camera);
						if (shadowPass) {
							this.beforePasses.push(shadowPass);
						}
					}
				}
			}
		}
	}
	// Collect before-passes from cameras whose first render step lives in this
	// RenderPassForward. Uses the existing firstCameraUse flag (set by LayerComposition)
	// to guarantee each camera's before-passes are scheduled exactly once, even when
	// multiple RenderPassForward instances reference the same camera (e.g. CameraFrame's
	// scenePass vs afterPass). Called after updateDirectionalShadows, so camera
	// before-passes execute after the directional shadow passes and can render into the
	// freshly updated shadow maps.
	updateCameraBeforePasses() {
		for (let i2 = 0; i2 < this.layerRenderSteps.length; i2++) {
			const step = this.layerRenderSteps[i2];
			if (step.firstCameraUse) {
				const camera = step.cameraComponent?.camera;
				if (camera) {
					const { beforePasses } = camera;
					for (let j = 0; j < beforePasses.length; j++) {
						this.beforePasses.push(beforePasses[j]);
					}
				}
			}
		}
	}
	updateClears() {
		const step = this.layerRenderSteps[0];
		if (step) {
			const cameraComponent = step.cameraComponent;
			const camera = cameraComponent.camera;
			const fullSizeClearRect = camera.fullSizeClearRect;
			this.setClearColor(fullSizeClearRect && step.clearColor ? camera.clearColor : void 0);
			this.setClearDepth(fullSizeClearRect && step.clearDepth && !this.noDepthClear ? camera.clearDepth : void 0);
			this.setClearStencil(fullSizeClearRect && step.clearStencil ? camera.clearStencil : void 0);
		}
	}
	frameUpdate() {
		super.frameUpdate();
		this.updateDirectionalShadows();
		this.updateCameraBeforePasses();
		this.updateClears();
		const { renderer, layerComposition, layerRenderSteps } = this;
		for (let i2 = 0; i2 < layerRenderSteps.length; i2++) {
			const step = layerRenderSteps[i2];
			if (layerComposition.isEnabled(step.layer, step.transparent)) {
				renderer.culler.requestMeshInstanceCull(step.cameraComponent.camera, step.layer);
			}
		}
	}
	before() {
		const { layerRenderSteps } = this;
		for (let i2 = 0; i2 < layerRenderSteps.length; i2++) {
			const step = layerRenderSteps[i2];
			if (step.firstCameraUse) {
				this.scene.fire(EVENT_PRERENDER, step.cameraComponent);
			}
		}
	}
	execute() {
		const { layerComposition, layerRenderSteps } = this;
		for (let i2 = 0; i2 < layerRenderSteps.length; i2++) {
			const step = layerRenderSteps[i2];
			const layer = step.layer;
			if (layerComposition.isEnabled(layer, step.transparent)) {
				this.renderLayerRenderStep(step, i2 === 0);
			}
		}
	}
	after() {
		for (let i2 = 0; i2 < this.layerRenderSteps.length; i2++) {
			const step = this.layerRenderSteps[i2];
			if (step.lastCameraUse) {
				this.scene.fire(EVENT_POSTRENDER, step.cameraComponent);
			}
		}
		this.beforePasses.length = 0;
	}
	renderLayerRenderStep(step, firstStep) {
		const { renderer, scene } = this;
		const device = renderer.device;
		const { layer, transparent, cameraComponent } = step;
		if (cameraComponent) {
			const originalGammaCorrection = cameraComponent.gammaCorrection;
			const originalToneMapping = cameraComponent.toneMapping;
			if (this.gammaCorrection !== void 0) cameraComponent.gammaCorrection = this.gammaCorrection;
			if (this.toneMapping !== void 0) cameraComponent.toneMapping = this.toneMapping;
			scene.fire(EVENT_PRERENDER_LAYER, cameraComponent, layer, transparent);
			const options2 = {
				lightClusters: step.lightClusters
			};
			const shaderPass = cameraComponent.camera.shaderPassInfo?.index ?? SHADER_FORWARD;
			if (!firstStep || !cameraComponent.camera.fullSizeClearRect) {
				options2.clearColor = step.clearColor;
				options2.clearDepth = step.clearDepth;
				options2.clearStencil = step.clearStencil;
			}
			const renderTarget = step.renderTarget ?? device.backBuffer;
			renderer.renderForwardLayer(
				cameraComponent.camera,
				renderTarget,
				layer,
				transparent,
				shaderPass,
				options2
			);
			device.setBlendState(BlendState.NOBLEND);
			device.setStencilState(null, null);
			device.setAlphaToCoverage(false);
			scene.fire(EVENT_POSTRENDER_LAYER, cameraComponent, layer, transparent);
			if (this.gammaCorrection !== void 0) cameraComponent.gammaCorrection = originalGammaCorrection;
			if (this.toneMapping !== void 0) cameraComponent.toneMapping = originalToneMapping;
		}
	}
};

var FramePassPostprocessing = class extends FramePass {
	constructor(device, renderer, renderAction) {
		super(device);
		this.renderer = renderer;
		this.renderAction = renderAction;
	}
	execute() {
		const renderAction = this.renderAction;
		const camera = renderAction.camera;
		camera.onPostprocessing();
	}
};

var _noLights = [[], [], []];
var tmpColor = new Color();
var _drawCallList = {
	drawCalls: [],
	shaderInstances: [],
	isNewMaterial: [],
	lightMaskChanged: [],
	clear: function() {
		this.drawCalls.length = 0;
		this.shaderInstances.length = 0;
		this.isNewMaterial.length = 0;
		this.lightMaskChanged.length = 0;
	}
};
function vogelDiskPrecalculationSamples(numSamples) {
	const samples = [];
	for (let i2 = 0; i2 < numSamples; ++i2) {
		const r = Math.sqrt(i2 + 0.5) / Math.sqrt(numSamples);
		samples.push(r);
	}
	return samples;
}
function vogelSpherePrecalculationSamples(numSamples) {
	const samples = [];
	for (let i2 = 0; i2 < numSamples; i2++) {
		const weight = i2 / numSamples;
		const radius = Math.sqrt(weight * weight);
		samples.push(radius);
	}
	return samples;
}
var ForwardRenderer = class extends Renderer {
	constructor(graphicsDevice, scene) {
		super(graphicsDevice, scene);
		const device = this.device;
		this._forwardDrawCalls = 0;
		this._materialSwitches = 0;
		this._depthMapTime = 0;
		this._forwardTime = 0;
		this._sortTime = 0;
		const scope = device.scope;
		this.fogColorId = scope.resolve("fog_color");
		this.fogStartId = scope.resolve("fog_start");
		this.fogEndId = scope.resolve("fog_end");
		this.fogDensityId = scope.resolve("fog_density");
		this.ambientId = scope.resolve("light_globalAmbient");
		this.skyboxIntensityId = scope.resolve("skyboxIntensity");
		this.cubeMapRotationMatrixId = scope.resolve("cubeMapRotationMatrix");
		this.pcssDiskSamplesId = scope.resolve("pcssDiskSamples[0]");
		this.pcssSphereSamplesId = scope.resolve("pcssSphereSamples[0]");
		this.lightColorId = [];
		this.lightDir = [];
		this.lightDirId = [];
		this.lightShadowMapId = [];
		this.lightShadowMatrixId = [];
		this.lightShadowParamsId = [];
		this.lightShadowIntensity = [];
		this.lightRadiusId = [];
		this.lightPos = [];
		this.lightPosId = [];
		this.lightWidth = [];
		this.lightWidthId = [];
		this.lightHeight = [];
		this.lightHeightId = [];
		this.lightInAngleId = [];
		this.lightOutAngleId = [];
		this.lightCookieId = [];
		this.lightCookieIntId = [];
		this.lightCookieMatrixId = [];
		this.lightCookieOffsetId = [];
		this.lightShadowSearchAreaId = [];
		this.lightCameraParamsId = [];
		this.lightSoftShadowParamsId = [];
		this.shadowMatrixPaletteId = [];
		this.shadowCascadeDistancesId = [];
		this.shadowCascadeCountId = [];
		this.shadowCascadeBlendId = [];
		this.shadowCascadeRadiiId = [];
		this.screenSizeId = scope.resolve("uScreenSize");
		this._screenSize = new Float32Array(4);
		this.fogColor = new Float32Array(3);
		this.ambientColor = new Float32Array(3);
		this.pcssDiskSamples = vogelDiskPrecalculationSamples(16);
		this.pcssSphereSamples = vogelSpherePrecalculationSamples(16);
	}
	destroy() {
		super.destroy();
	}
	dispatchGlobalLights(scene) {
		const ambientUniform = this.ambientColor;
		tmpColor.linear(scene.ambientLight);
		ambientUniform[0] = tmpColor.r;
		ambientUniform[1] = tmpColor.g;
		ambientUniform[2] = tmpColor.b;
		if (scene.physicalUnits) {
			for (let i2 = 0; i2 < 3; i2++) {
				ambientUniform[i2] *= scene.ambientLuminance;
			}
		}
		this.ambientId.setValue(ambientUniform);
		this.skyboxIntensityId.setValue(scene.physicalUnits ? scene.skyboxLuminance : scene.skyboxIntensity);
		this.cubeMapRotationMatrixId.setValue(scene._skyboxRotationMat3.data);
	}
	_resolveLight(scope, i2) {
		const light = `light${i2}`;
		this.lightColorId[i2] = scope.resolve(`${light}_color`);
		this.lightDir[i2] = new Float32Array(3);
		this.lightDirId[i2] = scope.resolve(`${light}_direction`);
		this.lightShadowMapId[i2] = scope.resolve(`${light}_shadowMap`);
		this.lightShadowMatrixId[i2] = scope.resolve(`${light}_shadowMatrix`);
		this.lightShadowParamsId[i2] = scope.resolve(`${light}_shadowParams`);
		this.lightShadowIntensity[i2] = scope.resolve(`${light}_shadowIntensity`);
		this.lightShadowSearchAreaId[i2] = scope.resolve(`${light}_shadowSearchArea`);
		this.lightRadiusId[i2] = scope.resolve(`${light}_radius`);
		this.lightPos[i2] = new Float32Array(3);
		this.lightPosId[i2] = scope.resolve(`${light}_position`);
		this.lightWidth[i2] = new Float32Array(3);
		this.lightWidthId[i2] = scope.resolve(`${light}_halfWidth`);
		this.lightHeight[i2] = new Float32Array(3);
		this.lightHeightId[i2] = scope.resolve(`${light}_halfHeight`);
		this.lightInAngleId[i2] = scope.resolve(`${light}_innerConeAngle`);
		this.lightOutAngleId[i2] = scope.resolve(`${light}_outerConeAngle`);
		this.lightCookieId[i2] = scope.resolve(`${light}_cookie`);
		this.lightCookieIntId[i2] = scope.resolve(`${light}_cookieIntensity`);
		this.lightCookieMatrixId[i2] = scope.resolve(`${light}_cookieMatrix`);
		this.lightCookieOffsetId[i2] = scope.resolve(`${light}_cookieOffset`);
		this.lightCameraParamsId[i2] = scope.resolve(`${light}_cameraParams`);
		this.lightSoftShadowParamsId[i2] = scope.resolve(`${light}_softShadowParams`);
		this.shadowMatrixPaletteId[i2] = scope.resolve(`${light}_shadowMatrixPalette[0]`);
		this.shadowCascadeDistancesId[i2] = scope.resolve(`${light}_shadowCascadeDistances`);
		this.shadowCascadeCountId[i2] = scope.resolve(`${light}_shadowCascadeCount`);
		this.shadowCascadeBlendId[i2] = scope.resolve(`${light}_shadowCascadeBlend`);
		this.shadowCascadeRadiiId[i2] = scope.resolve(`${light}_shadowCascadeRadii`);
	}
	setLTCDirectionalLight(wtm, cnt, dir4, campos, far) {
		this.lightPos[cnt][0] = campos.x - dir4.x * far;
		this.lightPos[cnt][1] = campos.y - dir4.y * far;
		this.lightPos[cnt][2] = campos.z - dir4.z * far;
		this.lightPosId[cnt].setValue(this.lightPos[cnt]);
		const hWidth = wtm.transformVector(new Vec3(-0.5, 0, 0));
		this.lightWidth[cnt][0] = hWidth.x * far;
		this.lightWidth[cnt][1] = hWidth.y * far;
		this.lightWidth[cnt][2] = hWidth.z * far;
		this.lightWidthId[cnt].setValue(this.lightWidth[cnt]);
		const hHeight = wtm.transformVector(new Vec3(0, 0, 0.5));
		this.lightHeight[cnt][0] = hHeight.x * far;
		this.lightHeight[cnt][1] = hHeight.y * far;
		this.lightHeight[cnt][2] = hHeight.z * far;
		this.lightHeightId[cnt].setValue(this.lightHeight[cnt]);
	}
	dispatchDirectLights(dirs, mask, camera) {
		let cnt = 0;
		const scope = this.device.scope;
		for (let i2 = 0; i2 < dirs.length; i2++) {
			if (!(dirs[i2].mask & mask)) continue;
			const directional = dirs[i2];
			const wtm = directional._node.getWorldTransform();
			if (!this.lightColorId[cnt]) {
				this._resolveLight(scope, cnt);
			}
			this.lightColorId[cnt].setValue(directional._colorLinear);
			wtm.getY(directional._direction).mulScalar(-1);
			directional._direction.normalize();
			this.lightDir[cnt][0] = directional._direction.x;
			this.lightDir[cnt][1] = directional._direction.y;
			this.lightDir[cnt][2] = directional._direction.z;
			this.lightDirId[cnt].setValue(this.lightDir[cnt]);
			if (directional.shape !== LIGHTSHAPE_PUNCTUAL) {
				this.setLTCDirectionalLight(wtm, cnt, directional._direction, camera._node.getPosition(), camera.farClip);
			}
			if (directional.castShadows) {
				const lightRenderData = directional.getRenderData(camera, 0);
				const biases = directional._getUniformBiasValues(lightRenderData);
				this.lightShadowMapId[cnt].setValue(lightRenderData.shadowBuffer);
				this.lightShadowMatrixId[cnt].setValue(lightRenderData.shadowMatrix.data);
				this.shadowMatrixPaletteId[cnt].setValue(directional._shadowMatrixPalette);
				this.shadowCascadeDistancesId[cnt].setValue(directional._shadowCascadeDistances);
				this.shadowCascadeCountId[cnt].setValue(directional.numCascades);
				this.shadowCascadeBlendId[cnt].setValue(1 - directional.cascadeBlend);
				this.lightShadowIntensity[cnt].setValue(directional.shadowIntensity);
				if (directional._isPcss) {
					this.lightSoftShadowParamsId[cnt].setValue(directional._softShadowParams);
					const shadowRT = lightRenderData.shadowCamera.renderTarget;
					if (shadowRT) {
						this.lightShadowSearchAreaId[cnt].setValue(directional.penumbraSize / lightRenderData.shadowCamera.renderTarget.width * lightRenderData.projectionCompensation);
					}
					const cameraParams = directional._shadowCameraParams;
					cameraParams.length = 4;
					cameraParams[0] = lightRenderData.projectionCompensation;
					cameraParams[1] = lightRenderData.shadowCamera._farClip;
					cameraParams[2] = lightRenderData.shadowCamera._nearClip;
					cameraParams[3] = 1;
					this.lightCameraParamsId[cnt].setValue(cameraParams);
					const radii = directional._shadowCascadeRadii ?? (directional._shadowCascadeRadii = new Float32Array(4));
					for (let c2 = 0; c2 < 4; c2++) {
						const r = c2 < directional.numCascades ? directional.getRenderData(camera, c2).projectionCompensation : 0;
						radii[c2] = r > 0 ? r : lightRenderData.projectionCompensation;
					}
					this.shadowCascadeRadiiId[cnt].setValue(radii);
				}
				const params = directional._shadowRenderParams;
				params.length = 4;
				params[0] = directional._shadowResolution;
				params[1] = biases.normalBias;
				params[2] = biases.bias;
				params[3] = 0;
				this.lightShadowParamsId[cnt].setValue(params);
			}
			cnt++;
		}
		return cnt;
	}
	setLTCPositionalLight(wtm, cnt) {
		const hWidth = wtm.transformVector(new Vec3(-0.5, 0, 0));
		this.lightWidth[cnt][0] = hWidth.x;
		this.lightWidth[cnt][1] = hWidth.y;
		this.lightWidth[cnt][2] = hWidth.z;
		this.lightWidthId[cnt].setValue(this.lightWidth[cnt]);
		const hHeight = wtm.transformVector(new Vec3(0, 0, 0.5));
		this.lightHeight[cnt][0] = hHeight.x;
		this.lightHeight[cnt][1] = hHeight.y;
		this.lightHeight[cnt][2] = hHeight.z;
		this.lightHeightId[cnt].setValue(this.lightHeight[cnt]);
	}
	dispatchOmniLight(scope, omni, cnt) {
		const wtm = omni._node.getWorldTransform();
		if (!this.lightColorId[cnt]) {
			this._resolveLight(scope, cnt);
		}
		this.lightRadiusId[cnt].setValue(omni.attenuationEnd);
		this.lightColorId[cnt].setValue(omni._colorLinear);
		wtm.getTranslation(omni._position);
		this.lightPos[cnt][0] = omni._position.x;
		this.lightPos[cnt][1] = omni._position.y;
		this.lightPos[cnt][2] = omni._position.z;
		this.lightPosId[cnt].setValue(this.lightPos[cnt]);
		if (omni.shape !== LIGHTSHAPE_PUNCTUAL) {
			this.setLTCPositionalLight(wtm, cnt);
		}
		if (omni.castShadows) {
			const lightRenderData = omni.getRenderData(null, 0);
			this.lightShadowMapId[cnt].setValue(lightRenderData.shadowBuffer);
			const biases = omni._getUniformBiasValues(lightRenderData);
			const params = omni._shadowRenderParams;
			params.length = 4;
			params[0] = omni._shadowResolution;
			params[1] = biases.normalBias;
			params[2] = biases.bias;
			params[3] = 1 / omni.attenuationEnd;
			this.lightShadowParamsId[cnt].setValue(params);
			this.lightShadowIntensity[cnt].setValue(omni.shadowIntensity);
			const pixelsPerMeter = omni.penumbraSize / lightRenderData.shadowCamera.renderTarget.width;
			this.lightShadowSearchAreaId[cnt].setValue(pixelsPerMeter);
			const cameraParams = omni._shadowCameraParams;
			cameraParams.length = 4;
			cameraParams[0] = 0;
			cameraParams[1] = lightRenderData.shadowCamera._farClip;
			cameraParams[2] = lightRenderData.shadowCamera._nearClip;
			cameraParams[3] = 0;
			this.lightCameraParamsId[cnt].setValue(cameraParams);
		}
		if (omni._cookie) {
			this.lightCookieId[cnt].setValue(omni._cookie);
			this.lightShadowMatrixId[cnt].setValue(wtm.data);
			this.lightCookieIntId[cnt].setValue(omni.cookieIntensity);
		}
	}
	dispatchSpotLight(scope, spot, cnt) {
		const wtm = spot._node.getWorldTransform();
		if (!this.lightColorId[cnt]) {
			this._resolveLight(scope, cnt);
		}
		this.lightInAngleId[cnt].setValue(spot._innerConeAngleCos);
		this.lightOutAngleId[cnt].setValue(spot._outerConeAngleCos);
		this.lightRadiusId[cnt].setValue(spot.attenuationEnd);
		this.lightColorId[cnt].setValue(spot._colorLinear);
		wtm.getTranslation(spot._position);
		this.lightPos[cnt][0] = spot._position.x;
		this.lightPos[cnt][1] = spot._position.y;
		this.lightPos[cnt][2] = spot._position.z;
		this.lightPosId[cnt].setValue(this.lightPos[cnt]);
		if (spot.shape !== LIGHTSHAPE_PUNCTUAL) {
			this.setLTCPositionalLight(wtm, cnt);
		}
		wtm.getY(spot._direction).mulScalar(-1);
		spot._direction.normalize();
		this.lightDir[cnt][0] = spot._direction.x;
		this.lightDir[cnt][1] = spot._direction.y;
		this.lightDir[cnt][2] = spot._direction.z;
		this.lightDirId[cnt].setValue(this.lightDir[cnt]);
		if (spot.castShadows) {
			const lightRenderData = spot.getRenderData(null, 0);
			this.lightShadowMapId[cnt].setValue(lightRenderData.shadowBuffer);
			this.lightShadowMatrixId[cnt].setValue(lightRenderData.shadowMatrix.data);
			const biases = spot._getUniformBiasValues(lightRenderData);
			const params = spot._shadowRenderParams;
			params.length = 4;
			params[0] = spot._shadowResolution;
			params[1] = biases.normalBias;
			params[2] = biases.bias;
			params[3] = 1 / spot.attenuationEnd;
			this.lightShadowParamsId[cnt].setValue(params);
			this.lightShadowIntensity[cnt].setValue(spot.shadowIntensity);
			const pixelsPerMeter = spot.penumbraSize / lightRenderData.shadowCamera.renderTarget.width;
			const fov = lightRenderData.shadowCamera._fov * math.DEG_TO_RAD;
			const fovRatio = 1 / Math.tan(fov / 2);
			this.lightShadowSearchAreaId[cnt].setValue(pixelsPerMeter * fovRatio);
			const cameraParams = spot._shadowCameraParams;
			cameraParams.length = 4;
			cameraParams[0] = 0;
			cameraParams[1] = lightRenderData.shadowCamera._farClip;
			cameraParams[2] = lightRenderData.shadowCamera._nearClip;
			cameraParams[3] = 0;
			this.lightCameraParamsId[cnt].setValue(cameraParams);
		}
		if (spot._cookie) {
			if (!spot.castShadows) {
				const cookieMatrix = LightCamera.evalSpotCookieMatrix(spot);
				this.lightShadowMatrixId[cnt].setValue(cookieMatrix.data);
			}
			this.lightCookieId[cnt].setValue(spot._cookie);
			this.lightCookieIntId[cnt].setValue(spot.cookieIntensity);
			if (spot._cookieTransform) {
				spot._cookieTransformUniform[0] = spot._cookieTransform.x;
				spot._cookieTransformUniform[1] = spot._cookieTransform.y;
				spot._cookieTransformUniform[2] = spot._cookieTransform.z;
				spot._cookieTransformUniform[3] = spot._cookieTransform.w;
				this.lightCookieMatrixId[cnt].setValue(spot._cookieTransformUniform);
				spot._cookieOffsetUniform[0] = spot._cookieOffset.x;
				spot._cookieOffsetUniform[1] = spot._cookieOffset.y;
				this.lightCookieOffsetId[cnt].setValue(spot._cookieOffsetUniform);
			}
		}
	}
	dispatchLocalLights(sortedLights, mask, usedDirLights) {
		let cnt = usedDirLights;
		const scope = this.device.scope;
		const omnis = sortedLights[LIGHTTYPE_OMNI];
		const numOmnis = omnis.length;
		for (let i2 = 0; i2 < numOmnis; i2++) {
			const omni = omnis[i2];
			if (!(omni.mask & mask)) continue;
			this.dispatchOmniLight(scope, omni, cnt);
			cnt++;
		}
		const spts = sortedLights[LIGHTTYPE_SPOT];
		const numSpts = spts.length;
		for (let i2 = 0; i2 < numSpts; i2++) {
			const spot = spts[i2];
			if (!(spot.mask & mask)) continue;
			this.dispatchSpotLight(scope, spot, cnt);
			cnt++;
		}
	}
	// execute first pass over draw calls, in order to update materials / shaders
	renderForwardPrepareMaterials(camera, renderTarget, drawCalls, sortedLights, layer, pass, viewUniformFormat) {
		const fogParams = camera.fogParams ?? this.scene.fog;
		const shaderParams = camera.shaderParams;
		shaderParams.fog = fogParams.type;
		shaderParams.srgbRenderTarget = renderTarget?.isColorBufferSrgb(0) ?? false;
		const addCall = (drawCall, shaderInstance, isNewMaterial, lightMaskChanged) => {
			_drawCallList.drawCalls.push(drawCall);
			_drawCallList.shaderInstances.push(shaderInstance);
			_drawCallList.isNewMaterial.push(isNewMaterial);
			_drawCallList.lightMaskChanged.push(lightMaskChanged);
		};
		_drawCallList.clear();
		const device = this.device;
		const scene = this.scene;
		const clusteredLightingEnabled = scene.clusteredLightingEnabled;
		const lightHash = layer?.getLightHash(clusteredLightingEnabled) ?? 0;
		let prevMaterial = null, prevObjDefs, prevLightMask;
		const drawCallsCount = drawCalls.length;
		for (let i2 = 0; i2 < drawCallsCount; i2++) {
			const drawCall = drawCalls[i2];
			if ((drawCall.shaderPassMask & 1 << pass) === 0) {
				continue;
			}
			const instancingData = drawCall.instancingData;
			if (instancingData && instancingData.count <= 0) {
				continue;
			}
			drawCall.ensureMaterial(device);
			const material = drawCall.material;
			const objDefs = drawCall._shaderDefs;
			const lightMask = drawCall.mask;
			if (material && material === prevMaterial && objDefs !== prevObjDefs) {
				prevMaterial = null;
			}
			if (material !== prevMaterial) {
				this._materialSwitches++;
				material._scene = scene;
				if (material.dirty) {
					material.updateUniforms(device, scene);
					material.dirty = false;
				}
			}
			const shaderInstance = drawCall.getShaderInstance(pass, lightHash, scene, shaderParams, viewUniformFormat, sortedLights);
			addCall(drawCall, shaderInstance, material !== prevMaterial, !prevMaterial || lightMask !== prevLightMask);
			prevMaterial = material;
			prevObjDefs = objDefs;
			prevLightMask = lightMask;
		}
		return _drawCallList;
	}
	renderForwardInternal(camera, preparedCalls, sortedLights, pass, drawCallback, flipFaces) {
		const device = this.device;
		const scene = this.scene;
		const flipFactor = flipFaces ? -1 : 1;
		const clusteredLightingEnabled = scene.clusteredLightingEnabled;
		const viewList = camera.xrActive && camera.xrViews.length ? camera.xrViews : null;
		const activeView = device.xrCurrentViewIndex ?? -1;
		const viewListStart = viewList && activeView >= 0 ? activeView : 0;
		const viewListEnd = viewList && activeView >= 0 ? activeView + 1 : viewList ? viewList.length : 0;
		const preparedCallsCount = preparedCalls.drawCalls.length;
		for (let i2 = 0; i2 < preparedCallsCount; i2++) {
			const drawCall = preparedCalls.drawCalls[i2];
			const newMaterial = preparedCalls.isNewMaterial[i2];
			const lightMaskChanged = preparedCalls.lightMaskChanged[i2];
			const shaderInstance = preparedCalls.shaderInstances[i2];
			const material = drawCall.material;
			const lightMask = drawCall.mask;
			if (shaderInstance.shader.failed) continue;
			if (newMaterial) {
				const asyncCompile = false;
				device.setShader(shaderInstance.shader, asyncCompile);
				material.setParameters(device);
				if (lightMaskChanged) {
					const usedDirLights = this.dispatchDirectLights(sortedLights[LIGHTTYPE_DIRECTIONAL], lightMask, camera);
					if (!clusteredLightingEnabled) {
						this.dispatchLocalLights(sortedLights, lightMask, usedDirLights);
					}
				}
				this.alphaTestId.setValue(material.alphaTest);
				device.setBlendState(material.blendState);
				device.setDepthState(material.depthState);
				device.setAlphaToCoverage(material.alphaToCoverage);
			}
			this.setupCullModeAndFrontFace(camera._cullFaces, flipFactor, drawCall);
			const stencilFront = drawCall.stencilFront ?? material.stencilFront;
			const stencilBack = drawCall.stencilBack ?? material.stencilBack;
			device.setStencilState(stencilFront, stencilBack);
			drawCall.setParameters(device);
			device.scope.resolve("meshInstanceId").setValue(drawCall.id);
			const mesh = drawCall.mesh;
			this.setVertexBuffers(device, mesh);
			this.setMorphing(device, drawCall.morphInstance);
			this.setSkinning(device, drawCall);
			const instancingData = drawCall.instancingData;
			if (instancingData) {
				device.setVertexBuffer(instancingData.vertexBuffer);
			}
			this.setMeshInstanceMatrices(drawCall, true);
			this.setupMeshUniformBuffers(shaderInstance);
			const style = drawCall.renderStyle;
			const indexBuffer = mesh.indexBuffer[style];
			drawCallback?.(drawCall, i2);
			const indirectData = drawCall.getDrawCommands(camera);
			if (viewList) {
				for (let v6 = viewListStart; v6 < viewListEnd; v6++) {
					const view = viewList[v6];
					device.setViewport(view.viewport.x, view.viewport.y, view.viewport.z, view.viewport.w);
					this._viewOffsetScratch[0] = this._viewBindGroupOffsets[v6];
					device.setBindGroup(BINDGROUP_VIEW, this._viewBindGroups[v6], this._viewOffsetScratch);
					const first = v6 === viewListStart;
					const last = v6 === viewListEnd - 1;
					device.draw(mesh.primitive[style], indexBuffer, instancingData?.count, indirectData, first, last);
					this._forwardDrawCalls++;
					if (drawCall.instancingData) {
						this._instancedDrawCalls++;
					}
				}
			} else {
				device.draw(mesh.primitive[style], indexBuffer, instancingData?.count, indirectData);
				this._forwardDrawCalls++;
				if (drawCall.instancingData) {
					this._instancedDrawCalls++;
				}
			}
			if (i2 < preparedCallsCount - 1 && !preparedCalls.isNewMaterial[i2 + 1]) {
				material.setParameters(device, drawCall.parameters);
			}
		}
	}
	renderForward(camera, renderTarget, allDrawCalls, sortedLights, pass, drawCallback, layer, flipFaces, viewUniformFormat) {
		const preparedCalls = this.renderForwardPrepareMaterials(camera, renderTarget, allDrawCalls, sortedLights, layer, pass, viewUniformFormat);
		this.renderForwardInternal(camera, preparedCalls, sortedLights, pass, drawCallback, flipFaces);
		_drawCallList.clear();
	}
	renderForwardLayer(camera, renderTarget, layer, transparent, shaderPass, options2 = {}) {
		const { scene } = this;
		const clusteredLightingEnabled = scene.clusteredLightingEnabled;
		this.setupViewport(camera, renderTarget);
		let visible, splitLights;
		if (layer) {
			layer.sortVisible(camera, transparent);
			const culledInstances = layer.getCulledInstances(camera);
			visible = transparent ? culledInstances.transparent : culledInstances.opaque;
			scene.immediate.onPreRenderLayer(layer, visible, transparent);
			if (layer.requiresLightCube) {
				this.lightCube.update(scene.ambientLight, layer._lights);
				this.constantLightCube.setValue(this.lightCube.colors);
			}
			splitLights = layer.splitLights;
		} else {
			visible = options2.meshInstances;
			splitLights = options2.splitLights ?? _noLights;
		}
		if (clusteredLightingEnabled) {
			const lightClusters = options2.lightClusters ?? this.worldClustersAllocator.empty;
			lightClusters.activate();
			if (layer) {
				if (!this.clustersDebugRendered && scene.lighting.debugLayer === layer.id) {
					this.clustersDebugRendered = true;
				}
			}
		}
		scene._activeCamera = camera;
		const fogParams = camera.fogParams ?? this.scene.fog;
		this.setFogConstants(fogParams);
		const viewList = this.setCameraUniforms(camera, renderTarget);
		this.initViewUniformFormat(scene.clusteredLightingEnabled);
		const viewUniformFormat = options2.viewUniformFormat ?? this.viewUniformFormat;
		this.setupViewUniformBuffers(viewUniformFormat, viewList);
		const clearColor = options2.clearColor ?? false;
		const clearDepth = options2.clearDepth ?? false;
		const clearStencil = options2.clearStencil ?? false;
		if (clearColor || clearDepth || clearStencil) {
			this.clear(camera, clearColor, clearDepth, clearStencil);
		}
		const flipFaces = !!(camera._flipFaces ^ renderTarget?.flipY);
		const forwardDrawCalls = this._forwardDrawCalls;
		this.renderForward(
			camera,
			renderTarget,
			visible,
			splitLights,
			shaderPass,
			options2.drawCallback ?? null,
			layer,
			flipFaces,
			viewUniformFormat
		);
		if (layer) {
			layer._forwardDrawCalls += this._forwardDrawCalls - forwardDrawCalls;
		}
	}
	setFogConstants(fogParams) {
		if (fogParams.type !== FOG_NONE) {
			tmpColor.linear(fogParams.color);
			const fogUniform = this.fogColor;
			fogUniform[0] = tmpColor.r;
			fogUniform[1] = tmpColor.g;
			fogUniform[2] = tmpColor.b;
			this.fogColorId.setValue(fogUniform);
			if (fogParams.type === FOG_LINEAR) {
				this.fogStartId.setValue(fogParams.start);
				this.fogEndId.setValue(fogParams.end);
			} else {
				this.fogDensityId.setValue(fogParams.density);
			}
		}
	}
	setSceneConstants() {
		const scene = this.scene;
		this.dispatchGlobalLights(scene);
		const device = this.device;
		this._screenSize[0] = device.width;
		this._screenSize[1] = device.height;
		this._screenSize[2] = 1 / device.width;
		this._screenSize[3] = 1 / device.height;
		this.screenSizeId.setValue(this._screenSize);
		this.pcssDiskSamplesId.setValue(this.pcssDiskSamples);
		this.pcssSphereSamplesId.setValue(this.pcssSphereSamples);
	}
	buildFrameGraph(frameGraph, layerComposition) {
		const scene = this.scene;
		frameGraph.reset();
		if (scene.clusteredLightingEnabled) {
			const { shadowsEnabled, cookiesEnabled } = scene.lighting;
			this._renderPassUpdateClustered.update(frameGraph, shadowsEnabled, cookiesEnabled, this.lights, this.localLights);
			frameGraph.addRenderPass(this._renderPassUpdateClustered);
		} else {
			this._shadowRendererLocal.buildNonClusteredRenderPasses(frameGraph, this.localLights);
		}
		let startIndex = 0;
		let newStart = true;
		let renderTarget = null;
		const renderActions = layerComposition._renderActions;
		for (let i2 = startIndex; i2 < renderActions.length; i2++) {
			const renderAction = renderActions[i2];
			const { layer, camera } = renderAction;
			const mv = this._isMultiview(camera);
			if (renderAction.useCameraPasses) {
				if (mv) frameGraph.beginMultiView(this.device);
				camera.camera.framePasses.forEach((renderPass) => {
					frameGraph.addRenderPass(renderPass);
				});
				if (mv) frameGraph.endMultiView();
			} else {
				const isDepthLayer = layer.id === LAYERID_DEPTH;
				const isGrabPass = isDepthLayer && (camera.renderSceneColorMap || camera.renderSceneDepthMap);
				if (newStart) {
					newStart = false;
					startIndex = i2;
					renderTarget = renderAction.renderTarget;
				}
				const nextRenderAction = renderActions[i2 + 1];
				const isNextLayerDepth = nextRenderAction ? !nextRenderAction.useCameraPasses && nextRenderAction.layer.id === LAYERID_DEPTH : false;
				const isNextLayerGrabPass = isNextLayerDepth && (camera.renderSceneColorMap || camera.renderSceneDepthMap);
				const nextNeedDirShadows = nextRenderAction ? nextRenderAction.firstCameraUse && this.culler.cameraDirShadowLights.has(nextRenderAction.camera.camera) : false;
				if (!nextRenderAction || nextRenderAction.renderTarget !== renderTarget || nextRenderAction.camera !== camera || nextNeedDirShadows || isNextLayerGrabPass || isGrabPass) {
					const isDepthOnly = isDepthLayer && startIndex === i2;
					if (mv && (camera.renderSceneColorMap || camera.renderSceneDepthMap || renderAction.triggerPostprocess && camera?.onPostprocessing)) {
					}
					if (mv) frameGraph.beginMultiView(this.device);
					if (!isDepthOnly) {
						this.addMainRenderPass(frameGraph, layerComposition, renderTarget, startIndex, i2);
					}
					if (isDepthLayer) {
						if (camera.renderSceneColorMap) {
							const colorGrabPass = camera.camera.renderPassColorGrab;
							colorGrabPass.source = camera.renderTarget;
							frameGraph.addRenderPass(colorGrabPass);
						}
						if (camera.renderSceneDepthMap) {
							frameGraph.addRenderPass(camera.camera.renderPassDepthGrab);
						}
					}
					if (renderAction.triggerPostprocess && camera?.onPostprocessing) {
						const renderPass = new FramePassPostprocessing(this.device, this, renderAction);
						frameGraph.addRenderPass(renderPass);
					}
					if (mv) frameGraph.endMultiView();
					newStart = true;
				}
			}
		}
	}
	_isMultiview(camera) {
		const sceneCamera = camera.camera;
		return this.device.isWebGPU && !!sceneCamera?.xrActive && sceneCamera.xrViews.length >= 2;
	}
	addMainRenderPass(frameGraph, layerComposition, renderTarget, startIndex, endIndex) {
		const renderPass = new RenderPassForward(this.device, layerComposition, this.scene, this);
		renderPass.init(renderTarget);
		const renderActions = layerComposition._renderActions;
		for (let i2 = startIndex; i2 <= endIndex; i2++) {
			renderPass.addLayerRenderStep(this._layerRenderStepFromRenderAction(renderActions[i2]));
		}
		frameGraph.addRenderPass(renderPass);
	}
	_layerRenderStepFromRenderAction(renderAction) {
		const step = new LayerRenderStep(renderAction.camera, renderAction.layer, renderAction.transparent, renderAction.renderTarget);
		step.clearColor = renderAction.clearColor;
		step.clearDepth = renderAction.clearDepth;
		step.clearStencil = renderAction.clearStencil;
		step.firstCameraUse = renderAction.firstCameraUse;
		step.lastCameraUse = renderAction.lastCameraUse;
		return step;
	}
	update(comp) {
		this.frameUpdate();
		this.shadowRenderer.frameUpdate();
		this.scene._updateSkyMesh();
		this.updateLayerComposition(comp);
		this.collectLights(comp);
		this.beginFrame(comp);
		this.setSceneConstants();
		this.gsplatDirector?.update(comp);
		this.culler.updateLightVisibility(comp);
	}
	cull(comp) {
		this.culler.cullComposition(comp);
		this.gsplatDirector?.updateShadows();
		this.gpuUpdate(this.culler.processingMeshInstances);
		this.culler.consumeOneShotShadows();
	}
};

var layerCounter = 0;
var lightKeys = [];
var _tempMaterials = /* @__PURE__ */ new Set();
function sortManual(drawCallA, drawCallB) {
	return drawCallA.drawOrder - drawCallB.drawOrder;
}
function sortMaterialMesh(drawCallA, drawCallB) {
	const keyA = drawCallA._sortKeyForward;
	const keyB = drawCallB._sortKeyForward;
	if (keyA === keyB) {
		return drawCallB.mesh.id - drawCallA.mesh.id;
	}
	return keyB - keyA;
}
function sortBackToFront(drawCallA, drawCallB) {
	return drawCallB._sortKeyDynamic - drawCallA._sortKeyDynamic;
}
function sortFrontToBack(drawCallA, drawCallB) {
	return drawCallA._sortKeyDynamic - drawCallB._sortKeyDynamic;
}
var sortCallbacks = [null, sortManual, sortMaterialMesh, sortBackToFront, sortFrontToBack];
var CulledInstances = class {
	opaque = [];
	transparent = [];
};
var Layer = class {
	// --- Identity ---
	id;
	name;
	// --- Enabled state & ref counting ---
	_enabled = true;
	_refCounter = 1;
	// --- Sorting ---
	opaqueSortMode = SORTMODE_MATERIALMESH;
	transparentSortMode = SORTMODE_BACK2FRONT;
	customSortCallback = null;
	customCalculateSortValues = null;
	// --- Clear flags ---
	_clearColorBuffer = false;
	_clearDepthBuffer = false;
	_clearStencilBuffer = false;
	// --- Enable / disable callbacks ---
	onEnable;
	onDisable;
	// --- Mesh instances & shadow casters ---
	meshInstances = [];
	meshInstancesSet = /* @__PURE__ */ new Set();
	shadowCasters = [];
	shadowCastersSet = /* @__PURE__ */ new Set();
	_visibleInstances = /* @__PURE__ */ new WeakMap();
	// --- Lights ---
	_lights = [];
	_lightsSet = /* @__PURE__ */ new Set();
	_clusteredLightsSet = /* @__PURE__ */ new Set();
	_splitLights = [[], [], []];
	_splitLightsDirty = true;
	_lightHash = 0;
	_lightHashDirty = false;
	_lightIdHash = 0;
	_lightIdHashDirty = false;
	requiresLightCube = false;
	// --- Cameras ---
	cameras = [];
	camerasSet = /* @__PURE__ */ new Set();
	// --- GSplat ---
	gsplatPlacements = [];
	gsplatPlacementsSet = /* @__PURE__ */ new Set();
	gsplatShadowCasters = [];
	gsplatShadowCastersSet = /* @__PURE__ */ new Set();
	gsplatPlacementsDirty = true;
	// --- Composition / shader versioning ---
	_dirtyComposition = false;
	_shaderVersion = -1;
	// --- Profiler ---
	constructor(options2 = {}) {
		if (options2.id !== void 0) {
			this.id = options2.id;
			layerCounter = Math.max(this.id + 1, layerCounter);
		} else {
			this.id = layerCounter++;
		}
		this.name = options2.name;
		this._enabled = options2.enabled ?? true;
		this._refCounter = this._enabled ? 1 : 0;
		this.opaqueSortMode = options2.opaqueSortMode ?? SORTMODE_MATERIALMESH;
		this.transparentSortMode = options2.transparentSortMode ?? SORTMODE_BACK2FRONT;
		this._clearColorBuffer = !!options2.clearColorBuffer;
		this._clearDepthBuffer = !!options2.clearDepthBuffer;
		this._clearStencilBuffer = !!options2.clearStencilBuffer;
		this.onEnable = options2.onEnable;
		this.onDisable = options2.onDisable;
		if (this._enabled && this.onEnable) {
			this.onEnable();
		}
	}
	set enabled(val) {
		if (val !== this._enabled) {
			this._dirtyComposition = true;
			this.gsplatPlacementsDirty = true;
			this._enabled = val;
			if (val) {
				this.incrementCounter();
				if (this.onEnable) this.onEnable();
			} else {
				this.decrementCounter();
				if (this.onDisable) this.onDisable();
			}
		}
	}
	get enabled() {
		return this._enabled;
	}
	set clearColorBuffer(val) {
		this._clearColorBuffer = val;
		this._dirtyComposition = true;
	}
	get clearColorBuffer() {
		return this._clearColorBuffer;
	}
	set clearDepthBuffer(val) {
		this._clearDepthBuffer = val;
		this._dirtyComposition = true;
	}
	get clearDepthBuffer() {
		return this._clearDepthBuffer;
	}
	set clearStencilBuffer(val) {
		this._clearStencilBuffer = val;
		this._dirtyComposition = true;
	}
	get clearStencilBuffer() {
		return this._clearStencilBuffer;
	}
	get hasClusteredLights() {
		return this._clusteredLightsSet.size > 0;
	}
	get clusteredLightsSet() {
		return this._clusteredLightsSet;
	}
	incrementCounter() {
		if (this._refCounter === 0) {
			this._enabled = true;
			if (this.onEnable) this.onEnable();
		}
		this._refCounter++;
	}
	decrementCounter() {
		if (this._refCounter === 1) {
			this._enabled = false;
			if (this.onDisable) this.onDisable();
		} else if (this._refCounter === 0) {
			return;
		}
		this._refCounter--;
	}
	addGSplatPlacement(placement) {
		if (!this.gsplatPlacementsSet.has(placement)) {
			this.gsplatPlacements.push(placement);
			this.gsplatPlacementsSet.add(placement);
			this.gsplatPlacementsDirty = true;
		}
	}
	removeGSplatPlacement(placement) {
		const index = this.gsplatPlacements.indexOf(placement);
		if (index >= 0) {
			this.gsplatPlacements.splice(index, 1);
			this.gsplatPlacementsSet.delete(placement);
			this.gsplatPlacementsDirty = true;
		}
	}
	addGSplatShadowCaster(placement) {
		if (!this.gsplatShadowCastersSet.has(placement)) {
			this.gsplatShadowCasters.push(placement);
			this.gsplatShadowCastersSet.add(placement);
			this.gsplatPlacementsDirty = true;
		}
	}
	removeGSplatShadowCaster(placement) {
		const index = this.gsplatShadowCasters.indexOf(placement);
		if (index >= 0) {
			this.gsplatShadowCasters.splice(index, 1);
			this.gsplatShadowCastersSet.delete(placement);
			this.gsplatPlacementsDirty = true;
		}
	}
	addMeshInstances(meshInstances, skipShadowCasters) {
		const destMeshInstances = this.meshInstances;
		const destMeshInstancesSet = this.meshInstancesSet;
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			const mi = meshInstances[i2];
			if (!destMeshInstancesSet.has(mi)) {
				destMeshInstances.push(mi);
				destMeshInstancesSet.add(mi);
				_tempMaterials.add(mi.material);
			}
		}
		if (!skipShadowCasters) {
			this.addShadowCasters(meshInstances);
		}
		if (_tempMaterials.size > 0) {
			const sceneShaderVer = this._shaderVersion;
			_tempMaterials.forEach((mat2) => {
				if (sceneShaderVer >= 0 && mat2._shaderVersion !== sceneShaderVer) {
					if (mat2.getShaderVariant !== Material.prototype.getShaderVariant) {
						mat2.clearVariants();
					}
					mat2._shaderVersion = sceneShaderVer;
				}
			});
			_tempMaterials.clear();
		}
	}
	removeMeshInstances(meshInstances, skipShadowCasters) {
		const destMeshInstances = this.meshInstances;
		const destMeshInstancesSet = this.meshInstancesSet;
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			const mi = meshInstances[i2];
			if (destMeshInstancesSet.has(mi)) {
				destMeshInstancesSet.delete(mi);
				const j = destMeshInstances.indexOf(mi);
				if (j >= 0) {
					destMeshInstances.splice(j, 1);
				}
			}
		}
		if (!skipShadowCasters) {
			this.removeShadowCasters(meshInstances);
		}
	}
	addShadowCasters(meshInstances) {
		const shadowCasters = this.shadowCasters;
		const shadowCastersSet = this.shadowCastersSet;
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			const mi = meshInstances[i2];
			if (mi.castShadow && !shadowCastersSet.has(mi)) {
				shadowCastersSet.add(mi);
				shadowCasters.push(mi);
			}
		}
	}
	removeShadowCasters(meshInstances) {
		const shadowCasters = this.shadowCasters;
		const shadowCastersSet = this.shadowCastersSet;
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			const mi = meshInstances[i2];
			if (shadowCastersSet.has(mi)) {
				shadowCastersSet.delete(mi);
				const j = shadowCasters.indexOf(mi);
				if (j >= 0) {
					shadowCasters.splice(j, 1);
				}
			}
		}
	}
	clearMeshInstances(skipShadowCasters = false) {
		this.meshInstances.length = 0;
		this.meshInstancesSet.clear();
		if (!skipShadowCasters) {
			this.shadowCasters.length = 0;
			this.shadowCastersSet.clear();
		}
	}
	markLightsDirty() {
		this._lightHashDirty = true;
		this._lightIdHashDirty = true;
		this._splitLightsDirty = true;
	}
	hasLight(light) {
		return this._lightsSet.has(light);
	}
	addLight(light) {
		const l = light.light;
		if (!this._lightsSet.has(l)) {
			this._lightsSet.add(l);
			this._lights.push(l);
			this.markLightsDirty();
		}
		if (l.type !== LIGHTTYPE_DIRECTIONAL) {
			this._clusteredLightsSet.add(l);
		}
	}
	removeLight(light) {
		const l = light.light;
		if (this._lightsSet.has(l)) {
			this._lightsSet.delete(l);
			this._lights.splice(this._lights.indexOf(l), 1);
			this.markLightsDirty();
		}
		if (l.type !== LIGHTTYPE_DIRECTIONAL) {
			this._clusteredLightsSet.delete(l);
		}
	}
	clearLights() {
		this._lightsSet.forEach((light) => light.removeLayer(this));
		this._lightsSet.clear();
		this._clusteredLightsSet.clear();
		this._lights.length = 0;
		this.markLightsDirty();
	}
	get splitLights() {
		if (this._splitLightsDirty) {
			this._splitLightsDirty = false;
			const splitLights = this._splitLights;
			for (let i2 = 0; i2 < splitLights.length; i2++) {
				splitLights[i2].length = 0;
			}
			const lights2 = this._lights;
			for (let i2 = 0; i2 < lights2.length; i2++) {
				const light = lights2[i2];
				if (light.enabled) {
					splitLights[light._type].push(light);
				}
			}
			for (let i2 = 0; i2 < splitLights.length; i2++) {
				splitLights[i2].sort((a, b) => a.key - b.key);
			}
		}
		return this._splitLights;
	}
	evaluateLightHash(localLights, directionalLights, useIds) {
		let hash = 0;
		const lights2 = this._lights;
		for (let i2 = 0; i2 < lights2.length; i2++) {
			const isLocalLight = lights2[i2].type !== LIGHTTYPE_DIRECTIONAL;
			if (localLights && isLocalLight || directionalLights && !isLocalLight) {
				lightKeys.push(useIds ? lights2[i2].id : lights2[i2].key);
			}
		}
		if (lightKeys.length > 0) {
			lightKeys.sort();
			hash = hash32Fnv1a(lightKeys);
			lightKeys.length = 0;
		}
		return hash;
	}
	getLightHash(isClustered) {
		if (this._lightHashDirty) {
			this._lightHashDirty = false;
			this._lightHash = this.evaluateLightHash(!isClustered, true, false);
		}
		return this._lightHash;
	}
	// This is only used in clustered lighting mode
	getLightIdHash() {
		if (this._lightIdHashDirty) {
			this._lightIdHashDirty = false;
			this._lightIdHash = this.evaluateLightHash(true, false, true);
		}
		return this._lightIdHash;
	}
	addCamera(camera) {
		if (!this.camerasSet.has(camera.camera)) {
			this.camerasSet.add(camera.camera);
			this.cameras.push(camera);
			this._dirtyComposition = true;
		}
	}
	removeCamera(camera) {
		if (this.camerasSet.has(camera.camera)) {
			this.camerasSet.delete(camera.camera);
			const index = this.cameras.indexOf(camera);
			this.cameras.splice(index, 1);
			this._dirtyComposition = true;
		}
	}
	clearCameras() {
		this.cameras.length = 0;
		this.camerasSet.clear();
		this._dirtyComposition = true;
	}
	_calculateSortDistances(drawCalls, camPos, camFwd) {
		const count = drawCalls.length;
		const { x: px, y: py, z: pz } = camPos;
		const { x: fx, y: fy, z: fz } = camFwd;
		for (let i2 = 0; i2 < count; i2++) {
			const drawCall = drawCalls[i2];
			let zDist;
			if (drawCall.calculateSortDistance) {
				zDist = drawCall.calculateSortDistance(drawCall, camPos, camFwd);
			} else {
				const meshPos = drawCall.aabb.center;
				zDist = (meshPos.x - px) * fx + (meshPos.y - py) * fy + (meshPos.z - pz) * fz;
			}
			const bucket = drawCall._drawBucket * 1e9;
			drawCall._sortKeyDynamic = bucket + zDist;
		}
	}
	getCulledInstances(camera) {
		let instances = this._visibleInstances.get(camera);
		if (!instances) {
			instances = new CulledInstances();
			this._visibleInstances.set(camera, instances);
		}
		return instances;
	}
	sortVisible(camera, transparent) {
		const sortMode = transparent ? this.transparentSortMode : this.opaqueSortMode;
		if (sortMode === SORTMODE_NONE) {
			return;
		}
		const culledInstances = this.getCulledInstances(camera);
		const instances = transparent ? culledInstances.transparent : culledInstances.opaque;
		const cameraNode = camera.node;
		if (sortMode === SORTMODE_CUSTOM) {
			const sortPos = cameraNode.getPosition();
			const sortDir = cameraNode.forward;
			if (this.customCalculateSortValues) {
				this.customCalculateSortValues(instances, instances.length, sortPos, sortDir);
			}
			if (this.customSortCallback) {
				instances.sort(this.customSortCallback);
			}
		} else {
			if (sortMode === SORTMODE_BACK2FRONT || sortMode === SORTMODE_FRONT2BACK) {
				const sortPos = cameraNode.getPosition();
				const sortDir = cameraNode.forward;
				this._calculateSortDistances(instances, sortPos, sortDir);
			}
			instances.sort(sortCallbacks[sortMode]);
		}
	}
};

var cmpPriority = (a, b) => a.priority - b.priority;
var sortPriority = (arr) => arr.sort(cmpPriority);

var RenderAction = class {
	// {CameraComponent|null}
	camera = null;
	constructor() {
		this.layer = null;
		this.transparent = false;
		this.renderTarget = null;
		this.clearColor = false;
		this.clearDepth = false;
		this.clearStencil = false;
		this.triggerPostprocess = false;
		this.firstCameraUse = false;
		this.lastCameraUse = false;
		this.useCameraPasses = false;
	}
	setupClears(camera, layer) {
		this.clearColor = camera?.clearColorBuffer || layer.clearColorBuffer;
		this.clearDepth = camera?.clearDepthBuffer || layer.clearDepthBuffer;
		this.clearStencil = camera?.clearStencilBuffer || layer.clearStencilBuffer;
	}
};

var LayerComposition = class extends EventHandler {
	// Composition can hold only 2 sublayers of each layer
	layerList = [];
	layerIdMap = /* @__PURE__ */ new Map();
	layerNameMap = /* @__PURE__ */ new Map();
	layerOpaqueIndexMap = /* @__PURE__ */ new Map();
	layerTransparentIndexMap = /* @__PURE__ */ new Map();
	subLayerList = [];
	subLayerEnabled = [];
	// more granular control on top of layer.enabled (ANDed)
	cameras = [];
	camerasSet = /* @__PURE__ */ new Set();
	_renderActions = [];
	_dirty = false;
	constructor(name = "Untitled") {
		super();
		this.name = name;
		this._opaqueOrder = {};
		this._transparentOrder = {};
	}
	markDirty() {
		this._dirty = true;
	}
	_update() {
		const len = this.layerList.length;
		if (!this._dirty) {
			for (let i2 = 0; i2 < len; i2++) {
				if (this.layerList[i2]._dirtyComposition) {
					this._dirty = true;
					break;
				}
			}
		}
		if (this._dirty) {
			this._dirty = false;
			this.cameras.length = 0;
			this.camerasSet.clear();
			for (let i2 = 0; i2 < len; i2++) {
				const layer = this.layerList[i2];
				layer._dirtyComposition = false;
				for (let j = 0; j < layer.cameras.length; j++) {
					const cameraComponent = layer.cameras[j];
					if (!this.camerasSet.has(cameraComponent.camera)) {
						this.camerasSet.add(cameraComponent.camera);
						this.cameras.push(cameraComponent);
					}
				}
			}
			if (this.cameras.length > 1) {
				sortPriority(this.cameras);
			}
			const cameraLayers = [];
			let renderActionCount = 0;
			this._renderActions.length = 0;
			for (let i2 = 0; i2 < this.cameras.length; i2++) {
				const camera = this.cameras[i2];
				cameraLayers.length = 0;
				if (camera.camera.framePasses.length > 0) {
					this.addDummyRenderAction(renderActionCount, camera);
					renderActionCount++;
					continue;
				}
				let cameraFirstRenderAction = true;
				const cameraFirstRenderActionIndex = renderActionCount;
				let lastRenderAction = null;
				let postProcessMarked = false;
				for (let j = 0; j < len; j++) {
					const layer = this.layerList[j];
					const isLayerEnabled = layer.enabled && this.subLayerEnabled[j];
					if (isLayerEnabled) {
						if (layer.cameras.length > 0) {
							if (camera.layers.indexOf(layer.id) >= 0) {
								cameraLayers.push(layer);
								if (!postProcessMarked && layer.id === camera.disablePostEffectsLayer) {
									postProcessMarked = true;
									if (lastRenderAction) {
										lastRenderAction.triggerPostprocess = true;
									}
								}
								const isTransparent = this.subLayerList[j];
								lastRenderAction = this.addRenderAction(
									renderActionCount,
									layer,
									isTransparent,
									camera,
									cameraFirstRenderAction,
									postProcessMarked
								);
								renderActionCount++;
								cameraFirstRenderAction = false;
							}
						}
					}
				}
				if (cameraFirstRenderActionIndex < renderActionCount) {
					lastRenderAction.lastCameraUse = true;
				}
				if (!postProcessMarked && lastRenderAction) {
					lastRenderAction.triggerPostprocess = true;
				}
				if (camera.renderTarget && camera.postEffectsEnabled) {
					this.propagateRenderTarget(cameraFirstRenderActionIndex - 1, camera);
				}
			}
			this._logRenderActions();
		}
	}
	getNextRenderAction(renderActionIndex) {
		const renderAction = new RenderAction();
		this._renderActions.push(renderAction);
		return renderAction;
	}
	addDummyRenderAction(renderActionIndex, camera) {
		const renderAction = this.getNextRenderAction(renderActionIndex);
		renderAction.camera = camera;
		renderAction.useCameraPasses = true;
	}
	// function adds new render action to a list, while trying to limit allocation and reuse already allocated objects
	addRenderAction(renderActionIndex, layer, isTransparent, camera, cameraFirstRenderAction, postProcessMarked) {
		let rt = layer.id !== LAYERID_DEPTH ? camera.renderTarget : null;
		let used = false;
		const renderActions = this._renderActions;
		for (let i2 = renderActionIndex - 1; i2 >= 0; i2--) {
			if (renderActions[i2].camera === camera && renderActions[i2].renderTarget === rt) {
				used = true;
				break;
			}
		}
		if (postProcessMarked && camera.postEffectsEnabled) {
			rt = null;
		}
		const renderAction = this.getNextRenderAction(renderActionIndex);
		renderAction.triggerPostprocess = false;
		renderAction.layer = layer;
		renderAction.transparent = isTransparent;
		renderAction.camera = camera;
		renderAction.renderTarget = rt;
		renderAction.firstCameraUse = cameraFirstRenderAction;
		renderAction.lastCameraUse = false;
		const needsCameraClear = cameraFirstRenderAction || !used;
		const needsLayerClear = layer.clearColorBuffer || layer.clearDepthBuffer || layer.clearStencilBuffer;
		if (needsCameraClear || needsLayerClear) {
			renderAction.setupClears(needsCameraClear ? camera : void 0, layer);
		}
		return renderAction;
	}
	// executes when post-processing camera's render actions were created to propagate rendering to
	// render targets to previous camera as needed
	propagateRenderTarget(startIndex, fromCamera) {
		for (let a = startIndex; a >= 0; a--) {
			const ra = this._renderActions[a];
			const layer = ra.layer;
			if (ra.renderTarget && layer.id !== LAYERID_DEPTH) {
				break;
			}
			if (layer.id === LAYERID_DEPTH) {
				continue;
			}
			if (ra.useCameraPasses) {
				break;
			}
			const thisCamera = ra?.camera.camera;
			if (thisCamera) {
				if (!fromCamera.camera.rect.equals(thisCamera.rect) || !fromCamera.camera.scissorRect.equals(thisCamera.scissorRect)) {
					break;
				}
			}
			ra.renderTarget = fromCamera.renderTarget;
		}
	}
	// logs render action and their properties
	_logRenderActions() {
	}
	_isLayerAdded(layer) {
		const found = this.layerIdMap.get(layer.id) === layer;
		return found;
	}
	_isSublayerAdded(layer, transparent) {
		const map = transparent ? this.layerTransparentIndexMap : this.layerOpaqueIndexMap;
		if (map.get(layer) !== void 0) {
			return true;
		}
		return false;
	}
	// Whole layer API
	push(layer) {
		if (this._isLayerAdded(layer)) return;
		this.layerList.push(layer);
		this.layerList.push(layer);
		this._opaqueOrder[layer.id] = this.subLayerList.push(false) - 1;
		this._transparentOrder[layer.id] = this.subLayerList.push(true) - 1;
		this.subLayerEnabled.push(true);
		this.subLayerEnabled.push(true);
		this._updateLayerMaps();
		this._dirty = true;
		this.fire("add", layer);
	}
	insert(layer, index) {
		if (this._isLayerAdded(layer)) return;
		this.layerList.splice(index, 0, layer, layer);
		this.subLayerList.splice(index, 0, false, true);
		const count = this.layerList.length;
		this._updateOpaqueOrder(index, count - 1);
		this._updateTransparentOrder(index, count - 1);
		this.subLayerEnabled.splice(index, 0, true, true);
		this._updateLayerMaps();
		this._dirty = true;
		this.fire("add", layer);
	}
	remove(layer) {
		let id14 = this.layerList.indexOf(layer);
		delete this._opaqueOrder[id14];
		delete this._transparentOrder[id14];
		while (id14 >= 0) {
			this.layerList.splice(id14, 1);
			this.subLayerList.splice(id14, 1);
			this.subLayerEnabled.splice(id14, 1);
			id14 = this.layerList.indexOf(layer);
			this._dirty = true;
			this.fire("remove", layer);
		}
		const count = this.layerList.length;
		this._updateOpaqueOrder(0, count - 1);
		this._updateTransparentOrder(0, count - 1);
		this._updateLayerMaps();
	}
	// Sublayer API
	pushOpaque(layer) {
		if (this._isSublayerAdded(layer, false)) return;
		this.layerList.push(layer);
		this._opaqueOrder[layer.id] = this.subLayerList.push(false) - 1;
		this.subLayerEnabled.push(true);
		this._updateLayerMaps();
		this._dirty = true;
		this.fire("add", layer);
	}
	insertOpaque(layer, index) {
		if (this._isSublayerAdded(layer, false)) return;
		this.layerList.splice(index, 0, layer);
		this.subLayerList.splice(index, 0, false);
		const count = this.subLayerList.length;
		this._updateOpaqueOrder(index, count - 1);
		this.subLayerEnabled.splice(index, 0, true);
		this._updateLayerMaps();
		this._dirty = true;
		this.fire("add", layer);
	}
	removeOpaque(layer) {
		for (let i2 = 0, len = this.layerList.length; i2 < len; i2++) {
			if (this.layerList[i2] === layer && !this.subLayerList[i2]) {
				this.layerList.splice(i2, 1);
				this.subLayerList.splice(i2, 1);
				len--;
				this._updateOpaqueOrder(i2, len - 1);
				this.subLayerEnabled.splice(i2, 1);
				this._dirty = true;
				if (this.layerList.indexOf(layer) < 0) {
					this.fire("remove", layer);
				}
				break;
			}
		}
		this._updateLayerMaps();
	}
	pushTransparent(layer) {
		if (this._isSublayerAdded(layer, true)) return;
		this.layerList.push(layer);
		this._transparentOrder[layer.id] = this.subLayerList.push(true) - 1;
		this.subLayerEnabled.push(true);
		this._updateLayerMaps();
		this._dirty = true;
		this.fire("add", layer);
	}
	insertTransparent(layer, index) {
		if (this._isSublayerAdded(layer, true)) return;
		this.layerList.splice(index, 0, layer);
		this.subLayerList.splice(index, 0, true);
		const count = this.subLayerList.length;
		this._updateTransparentOrder(index, count - 1);
		this.subLayerEnabled.splice(index, 0, true);
		this._updateLayerMaps();
		this._dirty = true;
		this.fire("add", layer);
	}
	removeTransparent(layer) {
		for (let i2 = 0, len = this.layerList.length; i2 < len; i2++) {
			if (this.layerList[i2] === layer && this.subLayerList[i2]) {
				this.layerList.splice(i2, 1);
				this.subLayerList.splice(i2, 1);
				len--;
				this._updateTransparentOrder(i2, len - 1);
				this.subLayerEnabled.splice(i2, 1);
				this._dirty = true;
				if (this.layerList.indexOf(layer) < 0) {
					this.fire("remove", layer);
				}
				break;
			}
		}
		this._updateLayerMaps();
	}
	getOpaqueIndex(layer) {
		return this.layerOpaqueIndexMap.get(layer) ?? -1;
	}
	getTransparentIndex(layer) {
		return this.layerTransparentIndexMap.get(layer) ?? -1;
	}
	isEnabled(layer, transparent) {
		if (layer.enabled) {
			const index = transparent ? this.getTransparentIndex(layer) : this.getOpaqueIndex(layer);
			if (index >= 0) {
				return this.subLayerEnabled[index];
			}
		}
		return false;
	}
	isSubLayerRenderedByCamera(index, camera) {
		const layer = this.layerList[index];
		return layer.enabled && this.subLayerEnabled[index] && layer.camerasSet.has(camera);
	}
	_updateLayerMaps() {
		this.layerIdMap.clear();
		this.layerNameMap.clear();
		this.layerOpaqueIndexMap.clear();
		this.layerTransparentIndexMap.clear();
		for (let i2 = 0; i2 < this.layerList.length; i2++) {
			const layer = this.layerList[i2];
			this.layerIdMap.set(layer.id, layer);
			this.layerNameMap.set(layer.name, layer);
			const subLayerIndexMap = this.subLayerList[i2] ? this.layerTransparentIndexMap : this.layerOpaqueIndexMap;
			subLayerIndexMap.set(layer, i2);
		}
	}
	getLayerById(id14) {
		return this.layerIdMap.get(id14) ?? null;
	}
	getLayerByName(name) {
		return this.layerNameMap.get(name) ?? null;
	}
	_updateOpaqueOrder(startIndex, endIndex) {
		for (let i2 = startIndex; i2 <= endIndex; i2++) {
			if (this.subLayerList[i2] === false) {
				this._opaqueOrder[this.layerList[i2].id] = i2;
			}
		}
	}
	_updateTransparentOrder(startIndex, endIndex) {
		for (let i2 = startIndex; i2 <= endIndex; i2++) {
			if (this.subLayerList[i2] === true) {
				this._transparentOrder[this.layerList[i2].id] = i2;
			}
		}
	}
	// Used to determine which array of layers has any sublayer that is
	// on top of all the sublayers in the other array. The order is a dictionary
	// of <layerId, index>.
	_sortLayersDescending(layersA, layersB, order) {
		let topLayerA = -1;
		let topLayerB = -1;
		for (let i2 = 0, len = layersA.length; i2 < len; i2++) {
			const id14 = layersA[i2];
			if (order.hasOwnProperty(id14)) {
				topLayerA = Math.max(topLayerA, order[id14]);
			}
		}
		for (let i2 = 0, len = layersB.length; i2 < len; i2++) {
			const id14 = layersB[i2];
			if (order.hasOwnProperty(id14)) {
				topLayerB = Math.max(topLayerB, order[id14]);
			}
		}
		if (topLayerA === -1 && topLayerB !== -1) {
			return 1;
		} else if (topLayerB === -1 && topLayerA !== -1) {
			return -1;
		}
		return topLayerB - topLayerA;
	}
	sortTransparentLayers(layersA, layersB) {
		return this._sortLayersDescending(layersA, layersB, this._transparentOrder);
	}
	sortOpaqueLayers(layersA, layersB) {
		return this._sortLayersDescending(layersA, layersB, this._opaqueOrder);
	}
};

var tmpVec = new Vec3();
var tmpBiases = {
	bias: 0,
	normalBias: 0
};
var tmpColor2 = new Color();
var chanId = { r: 0, g: 1, b: 2, a: 3 };
var lightTypes = {
	"directional": LIGHTTYPE_DIRECTIONAL,
	"omni": LIGHTTYPE_OMNI,
	"point": LIGHTTYPE_OMNI,
	"spot": LIGHTTYPE_SPOT
};
var directionalCascades = [
	[new Vec4(0, 0, 1, 1)],
	[new Vec4(0, 0, 0.5, 0.5), new Vec4(0, 0.5, 0.5, 0.5)],
	[new Vec4(0, 0, 0.5, 0.5), new Vec4(0, 0.5, 0.5, 0.5), new Vec4(0.5, 0, 0.5, 0.5)],
	[new Vec4(0, 0, 0.5, 0.5), new Vec4(0, 0.5, 0.5, 0.5), new Vec4(0.5, 0, 0.5, 0.5), new Vec4(0.5, 0.5, 0.5, 0.5)]
];
var channelMap = {
	"rrr": 1,
	"ggg": 2,
	"bbb": 4,
	"aaa": 8,
	"rgb": 7
};
var id11 = 0;
var LightRenderData = class {
	constructor(camera, face, light) {
		this.light = light;
		this.camera = camera;
		this.shadowCamera = ShadowRenderer.createShadowCamera(light.device, light._shadowType, light._type, face);
		this.shadowMatrix = new Mat4();
		this.shadowViewport = new Vec4(0, 0, 1, 1);
		this.shadowScissor = new Vec4(0, 0, 1, 1);
		this.projectionCompensation = 0;
		this.face = face;
		this.visibleCasters = [];
	}
	// returns shadow buffer currently attached to the shadow camera
	get shadowBuffer() {
		const rt = this.shadowCamera.renderTarget;
		if (rt) {
			return this.light._isPcf ? rt.depthBuffer : rt.colorBuffer;
		}
		return null;
	}
};
var Light = class _Light {
	layers = /* @__PURE__ */ new Set();
	clusteredLighting;
	shadowDepthState = DepthState.DEFAULT.clone();
	clusteredFlags = 0;
	clusteredData = new Uint32Array(3);
	clusteredData16 = new Uint16Array(this.clusteredData.buffer);
	_evtDeviceRestored = null;
	constructor(graphicsDevice, clusteredLighting) {
		this.device = graphicsDevice;
		this.clusteredLighting = clusteredLighting;
		this.id = id11++;
		this._evtDeviceRestored = graphicsDevice.on("devicerestored", this.onDeviceRestored, this);
		this._type = LIGHTTYPE_DIRECTIONAL;
		this._color = new Color(0.8, 0.8, 0.8);
		this._intensity = 1;
		this._affectSpecularity = true;
		this._luminance = 0;
		this._castShadows = false;
		this._enabled = false;
		this._mask = MASK_AFFECT_DYNAMIC;
		this.isStatic = false;
		this.key = 0;
		this.bakeDir = true;
		this.bakeNumSamples = 1;
		this.bakeArea = 0;
		this.attenuationStart = 10;
		this.attenuationEnd = 10;
		this._falloffMode = LIGHTFALLOFF_LINEAR;
		this._shadowType = SHADOW_PCF3_32F;
		this._vsmBlurSize = 11;
		this.vsmBlurMode = BLUR_GAUSSIAN;
		this.vsmBias = 0.01 * 0.25;
		this._cookie = null;
		this.cookieIntensity = 1;
		this._cookieFalloff = true;
		this._cookieChannel = "rgb";
		this._cookieTransform = null;
		this._cookieTransformUniform = new Float32Array(4);
		this._cookieOffset = null;
		this._cookieOffsetUniform = new Float32Array(2);
		this._cookieTransformSet = false;
		this._cookieOffsetSet = false;
		this._innerConeAngle = 40;
		this._outerConeAngle = 45;
		this.cascades = null;
		this._shadowMatrixPalette = null;
		this._shadowCascadeDistances = null;
		this.numCascades = 1;
		this._cascadeBlend = 0;
		this.cascadeDistribution = 0.5;
		this._shape = LIGHTSHAPE_PUNCTUAL;
		this._colorLinear = new Float32Array(3);
		this._updateLinearColor();
		this._position = new Vec3(0, 0, 0);
		this._direction = new Vec3(0, 0, 0);
		this._innerConeAngleCos = Math.cos(this._innerConeAngle * math.DEG_TO_RAD);
		this._updateOuterAngle(this._outerConeAngle);
		this._usePhysicalUnits = void 0;
		this._shadowMap = null;
		this._shadowRenderParams = [];
		this._shadowCameraParams = [];
		this._shadowCascadeRadii = null;
		this.shadowDistance = 40;
		this._shadowResolution = 1024;
		this._shadowBias = -5e-4;
		this._shadowIntensity = 1;
		this._normalOffsetBias = 0;
		this.shadowUpdateMode = SHADOWUPDATE_REALTIME;
		this.shadowUpdateOverrides = null;
		this._isVsm = false;
		this._isPcf = true;
		this._isPcss = false;
		this._softShadowParams = new Float32Array(4);
		this.shadowSamples = 16;
		this.shadowBlockerSamples = 16;
		this.penumbraSize = 1;
		this.penumbraFalloff = 1;
		this._cookieMatrix = null;
		this._atlasViewport = null;
		this.atlasViewportAllocated = false;
		this.atlasVersion = 0;
		this.atlasSlotIndex = 0;
		this.atlasSlotUpdated = false;
		this.cookieRenderVersion = -1;
		this._node = null;
		this._renderData = [];
		this.visibleThisFrame = false;
		this.maxScreenSize = 0;
		this._updateShadowBias();
	}
	destroy() {
		this._evtDeviceRestored?.off();
		this._evtDeviceRestored = null;
		this._destroyShadowMap();
		this.releaseRenderData();
		this._renderData = null;
	}
	onDeviceRestored() {
		if (this.shadowUpdateMode === SHADOWUPDATE_NONE) {
			this.shadowUpdateMode = SHADOWUPDATE_THISFRAME;
		}
	}
	releaseRenderData() {
		if (this._renderData) {
			this._renderData.length = 0;
		}
	}
	addLayer(layer) {
		this.layers.add(layer);
	}
	removeLayer(layer) {
		this.layers.delete(layer);
	}
	set shadowSamples(value) {
		this._softShadowParams[0] = value;
	}
	get shadowSamples() {
		return this._softShadowParams[0];
	}
	set shadowBlockerSamples(value) {
		this._softShadowParams[1] = value;
	}
	get shadowBlockerSamples() {
		return this._softShadowParams[1];
	}
	set shadowBias(value) {
		if (this._shadowBias !== value) {
			this._shadowBias = value;
			this._updateShadowBias();
		}
	}
	get shadowBias() {
		return this._shadowBias;
	}
	set numCascades(value) {
		if (!this.cascades || this.numCascades !== value) {
			this.cascades = directionalCascades[value - 1];
			this._shadowMatrixPalette = new Float32Array(4 * 16);
			this._shadowCascadeDistances = new Float32Array(4);
			this._destroyShadowMap();
			this.updateKey();
		}
	}
	get numCascades() {
		return this.cascades.length;
	}
	set cascadeBlend(value) {
		if (this._cascadeBlend !== value) {
			this._cascadeBlend = value;
			this.updateKey();
		}
	}
	get cascadeBlend() {
		return this._cascadeBlend;
	}
	set shadowMap(shadowMap) {
		if (this._shadowMap !== shadowMap) {
			this._destroyShadowMap();
			this._shadowMap = shadowMap;
		}
	}
	get shadowMap() {
		return this._shadowMap;
	}
	set mask(value) {
		if (this._mask !== value) {
			this._mask = value;
			this.updateKey();
			this.updateClusteredFlags();
		}
	}
	get mask() {
		return this._mask;
	}
	// returns number of render targets to render the shadow map
	get numShadowFaces() {
		const type = this._type;
		if (type === LIGHTTYPE_DIRECTIONAL) {
			return this.numCascades;
		} else if (type === LIGHTTYPE_OMNI) {
			return 6;
		}
		return 1;
	}
	set type(value) {
		if (this._type === value) {
			return;
		}
		this._type = value;
		this._destroyShadowMap();
		this._updateShadowBias();
		this.updateKey();
		this.updateClusteredFlags();
		const stype = this._shadowType;
		this._shadowType = null;
		this.shadowUpdateOverrides = null;
		this.shadowType = stype;
	}
	get type() {
		return this._type;
	}
	set shape(value) {
		if (this._shape === value) {
			return;
		}
		this._shape = value;
		this._destroyShadowMap();
		this.updateKey();
		this.updateClusteredFlags();
		const stype = this._shadowType;
		this._shadowType = null;
		this.shadowType = stype;
	}
	get shape() {
		return this._shape;
	}
	set usePhysicalUnits(value) {
		if (this._usePhysicalUnits !== value) {
			this._usePhysicalUnits = value;
			this._updateLinearColor();
		}
	}
	get usePhysicalUnits() {
		return this._usePhysicalUnits;
	}
	set shadowType(value) {
		if (this._shadowType === value) {
			return;
		}
		let shadowInfo = shadowTypeInfo.get(value);
		if (!shadowInfo) {
			value = SHADOW_PCF3_32F;
		}
		const device = this.device;
		if (value === SHADOW_PCSS_32F && (!device.textureFloatRenderable || !device.textureFloatFilterable)) {
			value = SHADOW_PCF3_32F;
		}
		if (this._type === LIGHTTYPE_OMNI && value !== SHADOW_PCF1_32F && value !== SHADOW_PCF3_32F && value !== SHADOW_PCF1_16F && value !== SHADOW_PCF3_16F && value !== SHADOW_PCSS_32F) {
			value = SHADOW_PCF3_32F;
		}
		if (value === SHADOW_VSM_32F && (!device.textureFloatRenderable || !device.textureFloatFilterable)) {
			value = SHADOW_VSM_16F;
		}
		if (value === SHADOW_VSM_16F && !device.textureHalfFloatRenderable) {
			value = SHADOW_PCF3_32F;
		}
		shadowInfo = shadowTypeInfo.get(value);
		this._isVsm = shadowInfo?.vsm ?? false;
		this._isPcf = shadowInfo?.pcf ?? false;
		this._isPcss = shadowInfo?.pcss ?? false;
		this._shadowType = value;
		this._updateShadowBias();
		this._destroyShadowMap();
		this.updateKey();
	}
	get shadowType() {
		return this._shadowType;
	}
	set enabled(value) {
		if (this._enabled !== value) {
			this._enabled = value;
			this.layersDirty();
		}
	}
	get enabled() {
		return this._enabled;
	}
	set castShadows(value) {
		if (this._castShadows !== value) {
			this._castShadows = value;
			this._destroyShadowMap();
			this.layersDirty();
			this.updateKey();
		}
	}
	get castShadows() {
		return this._castShadows && this._mask !== MASK_BAKE && this._mask !== 0;
	}
	set shadowIntensity(value) {
		if (this._shadowIntensity !== value) {
			this._shadowIntensity = value;
			this.updateKey();
		}
	}
	get shadowIntensity() {
		return this._shadowIntensity;
	}
	get bakeShadows() {
		return this._castShadows && this._mask === MASK_BAKE;
	}
	set shadowResolution(value) {
		if (this._shadowResolution !== value) {
			if (this._type === LIGHTTYPE_OMNI) {
				value = Math.min(value, this.device.maxCubeMapSize);
			} else {
				value = Math.min(value, this.device.maxTextureSize);
			}
			this._shadowResolution = value;
			this._destroyShadowMap();
		}
	}
	get shadowResolution() {
		return this._shadowResolution;
	}
	set vsmBlurSize(value) {
		if (this._vsmBlurSize === value) {
			return;
		}
		if (value % 2 === 0) value++;
		this._vsmBlurSize = value;
	}
	get vsmBlurSize() {
		return this._vsmBlurSize;
	}
	set normalOffsetBias(value) {
		if (this._normalOffsetBias !== value) {
			const dirty = !this._normalOffsetBias && value || this._normalOffsetBias && !value;
			this._normalOffsetBias = value;
			if (dirty) {
				this.updateKey();
			}
		}
	}
	get normalOffsetBias() {
		return this._normalOffsetBias;
	}
	set falloffMode(value) {
		if (this._falloffMode === value) {
			return;
		}
		this._falloffMode = value;
		this.updateKey();
		this.updateClusteredFlags();
	}
	get falloffMode() {
		return this._falloffMode;
	}
	set innerConeAngle(value) {
		if (this._innerConeAngle === value) {
			return;
		}
		this._innerConeAngle = value;
		this._innerConeAngleCos = Math.cos(value * math.DEG_TO_RAD);
		this.updateClusterData(false, true);
		if (this._usePhysicalUnits) {
			this._updateLinearColor();
		}
	}
	get innerConeAngle() {
		return this._innerConeAngle;
	}
	set outerConeAngle(value) {
		if (this._outerConeAngle === value) {
			return;
		}
		this._outerConeAngle = value;
		this._updateOuterAngle(value);
		if (this._usePhysicalUnits) {
			this._updateLinearColor();
		}
	}
	get outerConeAngle() {
		return this._outerConeAngle;
	}
	set penumbraSize(value) {
		this._penumbraSize = value;
		this._softShadowParams[2] = value;
	}
	get penumbraSize() {
		return this._penumbraSize;
	}
	set penumbraFalloff(value) {
		this._softShadowParams[3] = value;
	}
	get penumbraFalloff() {
		return this._softShadowParams[3];
	}
	_updateOuterAngle(angle) {
		const radAngle = angle * math.DEG_TO_RAD;
		this._outerConeAngleCos = Math.cos(radAngle);
		this._outerConeAngleSin = Math.sin(radAngle);
		this.updateClusterData(false, true);
	}
	set intensity(value) {
		if (this._intensity !== value) {
			this._intensity = value;
			this._updateLinearColor();
		}
	}
	get intensity() {
		return this._intensity;
	}
	set affectSpecularity(value) {
		if (this._type === LIGHTTYPE_DIRECTIONAL) {
			this._affectSpecularity = value;
			this.updateKey();
		}
	}
	get affectSpecularity() {
		return this._affectSpecularity;
	}
	set luminance(value) {
		if (this._luminance !== value) {
			this._luminance = value;
			this._updateLinearColor();
		}
	}
	get luminance() {
		return this._luminance;
	}
	get cookieMatrix() {
		if (!this._cookieMatrix) {
			this._cookieMatrix = new Mat4();
		}
		return this._cookieMatrix;
	}
	get atlasViewport() {
		if (!this._atlasViewport) {
			this._atlasViewport = new Vec4(0, 0, 1, 1);
		}
		return this._atlasViewport;
	}
	set cookie(value) {
		if (this._cookie === value) {
			return;
		}
		this._cookie = value;
		this.updateKey();
	}
	get cookie() {
		return this._cookie;
	}
	set cookieFalloff(value) {
		if (this._cookieFalloff === value) {
			return;
		}
		this._cookieFalloff = value;
		this.updateKey();
	}
	get cookieFalloff() {
		return this._cookieFalloff;
	}
	set cookieChannel(value) {
		if (this._cookieChannel === value) {
			return;
		}
		if (value.length < 3) {
			const chr = value.charAt(value.length - 1);
			const addLen = 3 - value.length;
			for (let i2 = 0; i2 < addLen; i2++) {
				value += chr;
			}
		}
		this._cookieChannel = value;
		this.updateKey();
		this.updateClusteredFlags();
	}
	get cookieChannel() {
		return this._cookieChannel;
	}
	set cookieTransform(value) {
		if (this._cookieTransform === value) {
			return;
		}
		this._cookieTransform = value;
		this._cookieTransformSet = !!value;
		if (value && !this._cookieOffset) {
			this.cookieOffset = new Vec2();
			this._cookieOffsetSet = false;
		}
		this.updateKey();
	}
	get cookieTransform() {
		return this._cookieTransform;
	}
	set cookieOffset(value) {
		if (this._cookieOffset === value) {
			return;
		}
		const xformNew = !!(this._cookieTransformSet || value);
		if (xformNew && !value && this._cookieOffset) {
			this._cookieOffset.set(0, 0);
		} else {
			this._cookieOffset = value;
		}
		this._cookieOffsetSet = !!value;
		if (value && !this._cookieTransform) {
			this.cookieTransform = new Vec4(1, 1, 0, 0);
			this._cookieTransformSet = false;
		}
		this.updateKey();
	}
	get cookieOffset() {
		return this._cookieOffset;
	}
	// prepares light for the frame rendering
	beginFrame() {
		this.visibleThisFrame = this._type === LIGHTTYPE_DIRECTIONAL && this._enabled;
		this.maxScreenSize = 0;
		this.atlasViewportAllocated = false;
		this.atlasSlotUpdated = false;
	}
	// destroys shadow map related resources, called when shadow properties change and resources
	// need to be recreated
	_destroyShadowMap() {
		this.releaseRenderData();
		if (this._shadowMap) {
			if (!this._shadowMap.cached) {
				this._shadowMap.destroy();
			}
			this._shadowMap = null;
		}
		if (this.shadowUpdateMode === SHADOWUPDATE_NONE) {
			this.shadowUpdateMode = SHADOWUPDATE_THISFRAME;
		}
		if (this.shadowUpdateOverrides) {
			for (let i2 = 0; i2 < this.shadowUpdateOverrides.length; i2++) {
				if (this.shadowUpdateOverrides[i2] === SHADOWUPDATE_NONE) {
					this.shadowUpdateOverrides[i2] = SHADOWUPDATE_THISFRAME;
				}
			}
		}
	}
	// returns LightRenderData with matching camera and face
	getRenderData(camera, face) {
		for (let i2 = 0; i2 < this._renderData.length; i2++) {
			const current = this._renderData[i2];
			if (current.camera === camera && current.face === face) {
				return current;
			}
		}
		const rd = new LightRenderData(camera, face, this);
		this._renderData.push(rd);
		return rd;
	}
	clone() {
		const clone = new _Light(this.device, this.clusteredLighting);
		clone.type = this._type;
		clone.setColor(this._color);
		clone.intensity = this._intensity;
		clone.affectSpecularity = this._affectSpecularity;
		clone.luminance = this._luminance;
		clone.castShadows = this.castShadows;
		clone._enabled = this._enabled;
		clone.attenuationStart = this.attenuationStart;
		clone.attenuationEnd = this.attenuationEnd;
		clone.falloffMode = this._falloffMode;
		clone.shadowType = this._shadowType;
		clone.vsmBlurSize = this._vsmBlurSize;
		clone.vsmBlurMode = this.vsmBlurMode;
		clone.vsmBias = this.vsmBias;
		clone.shadowUpdateMode = this.shadowUpdateMode;
		clone.mask = this.mask;
		if (this.shadowUpdateOverrides) {
			clone.shadowUpdateOverrides = this.shadowUpdateOverrides.slice();
		}
		clone.innerConeAngle = this._innerConeAngle;
		clone.outerConeAngle = this._outerConeAngle;
		clone.numCascades = this.numCascades;
		clone.cascadeDistribution = this.cascadeDistribution;
		clone.cascadeBlend = this._cascadeBlend;
		clone.shape = this._shape;
		clone.shadowDepthState.copy(this.shadowDepthState);
		clone.shadowBias = this.shadowBias;
		clone.normalOffsetBias = this._normalOffsetBias;
		clone.shadowResolution = this._shadowResolution;
		clone.shadowDistance = this.shadowDistance;
		clone.shadowIntensity = this.shadowIntensity;
		clone.shadowSamples = this.shadowSamples;
		clone.shadowBlockerSamples = this.shadowBlockerSamples;
		clone.penumbraSize = this.penumbraSize;
		clone.penumbraFalloff = this.penumbraFalloff;
		return clone;
	}
	static getLightUnitConversion(type, outerAngle = Math.PI / 4, innerAngle = 0) {
		switch (type) {
			case LIGHTTYPE_SPOT: {
				const falloffEnd = Math.cos(outerAngle);
				const falloffStart = Math.cos(innerAngle);
				return 2 * Math.PI * (1 - falloffStart + (falloffStart - falloffEnd) / 2);
			}
			case LIGHTTYPE_OMNI:
				return 4 * Math.PI;
			case LIGHTTYPE_DIRECTIONAL:
				return 1;
		}
	}
	// returns the bias (.x) and normalBias (.y) value for lights as passed to shaders by uniforms
	// Note: this needs to be revisited and simplified
	// Note: vsmBias is not used at all for omni light, even though it is editable in the Editor
	_getUniformBiasValues(lightRenderData) {
		const farClip = lightRenderData.shadowCamera._farClip;
		switch (this._type) {
			case LIGHTTYPE_OMNI:
				tmpBiases.bias = this.shadowBias;
				tmpBiases.normalBias = this._normalOffsetBias;
				break;
			case LIGHTTYPE_SPOT:
				if (this._isVsm) {
					tmpBiases.bias = -1e-5 * 20;
				} else {
					tmpBiases.bias = this.shadowBias * 20;
				}
				tmpBiases.normalBias = this._isVsm ? this.vsmBias / (this.attenuationEnd / 7) : this._normalOffsetBias;
				break;
			case LIGHTTYPE_DIRECTIONAL:
				if (this._isVsm) {
					tmpBiases.bias = -1e-5 * 20;
				} else {
					tmpBiases.bias = this.shadowBias / farClip * 100;
				}
				tmpBiases.normalBias = this._isVsm ? this.vsmBias / (farClip / 7) : this._normalOffsetBias;
				break;
		}
		return tmpBiases;
	}
	getColor() {
		return this._color;
	}
	getBoundingSphere(sphere) {
		if (this._type === LIGHTTYPE_SPOT) {
			const size = this.attenuationEnd;
			const angle = this._outerConeAngle;
			const cosAngle = this._outerConeAngleCos;
			const node = this._node;
			tmpVec.copy(node.up);
			if (angle > 45) {
				sphere.radius = size * this._outerConeAngleSin;
				tmpVec.mulScalar(-size * cosAngle);
			} else {
				sphere.radius = size / (2 * cosAngle);
				tmpVec.mulScalar(-sphere.radius);
			}
			sphere.center.add2(node.getPosition(), tmpVec);
		} else if (this._type === LIGHTTYPE_OMNI) {
			sphere.center = this._node.getPosition();
			sphere.radius = this.attenuationEnd;
		}
	}
	getBoundingBox(box) {
		if (this._type === LIGHTTYPE_SPOT) {
			const range = this.attenuationEnd;
			const angle = this._outerConeAngle;
			const node = this._node;
			const scl = Math.abs(Math.sin(angle * math.DEG_TO_RAD) * range);
			box.center.set(0, -range * 0.5, 0);
			box.halfExtents.set(scl, range * 0.5, scl);
			box.setFromTransformedAabb(box, node.getWorldTransform(), true);
		} else if (this._type === LIGHTTYPE_OMNI) {
			box.center.copy(this._node.getPosition());
			box.halfExtents.set(this.attenuationEnd, this.attenuationEnd, this.attenuationEnd);
		}
	}
	_updateShadowBias() {
		if (this._type === LIGHTTYPE_OMNI && !this.clusteredLighting || this._isPcss) {
			this.shadowDepthState.depthBias = 0;
			this.shadowDepthState.depthBiasSlope = 0;
		} else {
			const bias = this.shadowBias * -1e3;
			this.shadowDepthState.depthBias = bias;
			this.shadowDepthState.depthBiasSlope = bias;
		}
	}
	_updateLinearColor() {
		let intensity = this._intensity;
		if (this._usePhysicalUnits) {
			intensity = this._luminance / _Light.getLightUnitConversion(this._type, this._outerConeAngle * math.DEG_TO_RAD, this._innerConeAngle * math.DEG_TO_RAD);
		}
		const color3 = this._color;
		const colorLinear = this._colorLinear;
		if (intensity >= 1) {
			tmpColor2.linear(color3).mulScalar(intensity);
		} else {
			tmpColor2.copy(color3).mulScalar(intensity).linear();
		}
		colorLinear[0] = tmpColor2.r;
		colorLinear[1] = tmpColor2.g;
		colorLinear[2] = tmpColor2.b;
		this.updateClusterData(true);
	}
	setColor() {
		if (arguments.length === 1) {
			this._color.set(arguments[0].r, arguments[0].g, arguments[0].b);
		} else if (arguments.length === 3) {
			this._color.set(arguments[0], arguments[1], arguments[2]);
		}
		this._updateLinearColor();
	}
	layersDirty() {
		this.layers.forEach((layer) => {
			if (layer.hasLight(this)) {
				layer.markLightsDirty();
			}
		});
	}
	updateKey() {
		let key = this._type << 29 | this._shadowType << 25 | this._falloffMode << 23 | (this._normalOffsetBias !== 0 ? 1 : 0) << 22 | (this._cookie ? 1 : 0) << 21 | (this._cookieFalloff ? 1 : 0) << 20 | chanId[this._cookieChannel.charAt(0)] << 18 | (this._cookieTransform ? 1 : 0) << 12 | this._shape << 10 | (this.numCascades > 0 ? 1 : 0) << 9 | (this._cascadeBlend > 0 ? 1 : 0) << 8 | (this.affectSpecularity ? 1 : 0) << 7 | this.mask << 6 | (this._castShadows ? 1 : 0) << 3;
		if (this._cookieChannel.length === 3) {
			key |= chanId[this._cookieChannel.charAt(1)] << 16;
			key |= chanId[this._cookieChannel.charAt(2)] << 14;
		}
		if (key !== this.key) {
			this.layersDirty();
		}
		this.key = key;
	}
	updateClusteredFlags() {
		const isDynamic = !!(this.mask & MASK_AFFECT_DYNAMIC);
		const isLightmapped = !!(this.mask & MASK_AFFECT_LIGHTMAPPED);
		this.clusteredFlags = (this.type === LIGHTTYPE_SPOT ? 1 : 0) << 30 | // bits 30
		(this._shape & 3) << 28 | // bits 29 - 28
		(this._falloffMode & 1) << 27 | // bits 27
		(channelMap[this._cookieChannel] ?? 0) << 23 | // bits 26 - 23
		(isDynamic ? 1 : 0) << 22 | // bits 22
		(isLightmapped ? 1 : 0) << 21;
	}
	getClusteredFlags(castShadows, useCookie) {
		return this.clusteredFlags | ((castShadows ? Math.floor(this.shadowIntensity * 255) : 0) & 255) << 0 | // bits 7 - 0
		((useCookie ? Math.floor(this.cookieIntensity * 255) : 0) & 255) << 8;
	}
	updateClusterData(updateColor, updateAngles) {
		const { clusteredData16 } = this;
		const float2Half = FloatPacking.float2Half;
		if (updateColor) {
			clusteredData16[0] = float2Half(math.clamp(this._colorLinear[0] / LIGHT_COLOR_DIVIDER, 0, 65504));
			clusteredData16[1] = float2Half(math.clamp(this._colorLinear[1] / LIGHT_COLOR_DIVIDER, 0, 65504));
			clusteredData16[2] = float2Half(math.clamp(this._colorLinear[2] / LIGHT_COLOR_DIVIDER, 0, 65504));
		}
		if (updateAngles) {
			const cosThreshold = 0.5;
			let flags = 0;
			const angleShrinkFactor = 0.99;
			let innerCos = Math.cos(this._innerConeAngle * angleShrinkFactor * math.DEG_TO_RAD);
			if (innerCos > cosThreshold) {
				innerCos = 1 - innerCos;
				flags |= 1;
			}
			let outerCos = Math.cos(this._outerConeAngle * angleShrinkFactor * math.DEG_TO_RAD);
			if (outerCos > cosThreshold) {
				outerCos = 1 - outerCos;
				flags |= 2;
			}
			clusteredData16[3] = flags;
			clusteredData16[4] = float2Half(innerCos);
			clusteredData16[5] = float2Half(outerCos);
		}
	}
};

var LightingParams = class {
	_areaLightsEnabled = false;
	_cells = new Vec3(10, 3, 10);
	_maxLightsPerCell = 255;
	_shadowsEnabled = true;
	_shadowType = SHADOW_PCF3_32F;
	_shadowAtlasResolution = 2048;
	_cookiesEnabled = false;
	_cookieAtlasResolution = 2048;
	debugLayer;
	atlasSplit = null;
	constructor(supportsAreaLights, maxTextureSize, dirtyLightsFnc) {
		this._supportsAreaLights = supportsAreaLights;
		this._maxTextureSize = maxTextureSize;
		this._dirtyLightsFnc = dirtyLightsFnc;
	}
	applySettings(render) {
		this.shadowsEnabled = render.lightingShadowsEnabled ?? this.shadowsEnabled;
		this.cookiesEnabled = render.lightingCookiesEnabled ?? this.cookiesEnabled;
		this.areaLightsEnabled = render.lightingAreaLightsEnabled ?? this.areaLightsEnabled;
		this.shadowAtlasResolution = render.lightingShadowAtlasResolution ?? this.shadowAtlasResolution;
		this.cookieAtlasResolution = render.lightingCookieAtlasResolution ?? this.cookieAtlasResolution;
		this.maxLightsPerCell = render.lightingMaxLightsPerCell ?? this.maxLightsPerCell;
		this.shadowType = render.lightingShadowType ?? this.shadowType;
		if (render.lightingCells) {
			this.cells = new Vec3(render.lightingCells);
		}
	}
	set cells(value) {
		this._cells.copy(value);
	}
	get cells() {
		return this._cells;
	}
	set maxLightsPerCell(value) {
		this._maxLightsPerCell = math.clamp(value, 1, 255);
	}
	get maxLightsPerCell() {
		return this._maxLightsPerCell;
	}
	set cookieAtlasResolution(value) {
		this._cookieAtlasResolution = math.clamp(value, 32, this._maxTextureSize);
	}
	get cookieAtlasResolution() {
		return this._cookieAtlasResolution;
	}
	set shadowAtlasResolution(value) {
		this._shadowAtlasResolution = math.clamp(value, 32, this._maxTextureSize);
	}
	get shadowAtlasResolution() {
		return this._shadowAtlasResolution;
	}
	set shadowType(value) {
		if (this._shadowType !== value) {
			this._shadowType = value;
			this._dirtyLightsFnc();
		}
	}
	get shadowType() {
		return this._shadowType;
	}
	set cookiesEnabled(value) {
		if (this._cookiesEnabled !== value) {
			this._cookiesEnabled = value;
			this._dirtyLightsFnc();
		}
	}
	get cookiesEnabled() {
		return this._cookiesEnabled;
	}
	set areaLightsEnabled(value) {
		if (this._supportsAreaLights) {
			if (this._areaLightsEnabled !== value) {
				this._areaLightsEnabled = value;
				this._dirtyLightsFnc();
			}
		}
	}
	get areaLightsEnabled() {
		return this._areaLightsEnabled;
	}
	set shadowsEnabled(value) {
		if (this._shadowsEnabled !== value) {
			this._shadowsEnabled = value;
			this._dirtyLightsFnc();
		}
	}
	get shadowsEnabled() {
		return this._shadowsEnabled;
	}
};

var MorphInstance = class _MorphInstance {
	constructor(morph) {
		this.morph = morph;
		morph.incRefCount();
		this.device = morph.device;
		const maxNumTargets = morph._targets.length;
		this.shader = this._createShader(maxNumTargets);
		this._weights = [];
		this._weightMap = /* @__PURE__ */ new Map();
		for (let v6 = 0; v6 < morph._targets.length; v6++) {
			const target2 = morph._targets[v6];
			if (target2.name) {
				this._weightMap.set(target2.name, v6);
			}
			this.setWeight(v6, target2.defaultWeight);
		}
		this._shaderMorphWeights = new Float32Array(maxNumTargets);
		this._shaderMorphIndex = new Uint32Array(maxNumTargets);
		const createRT = (name, textureVar) => {
			this[textureVar] = morph._createTexture(name, morph._renderTextureFormat);
			return new RenderTarget({
				colorBuffer: this[textureVar],
				depth: false
			});
		};
		if (morph.morphPositions) {
			this.rtPositions = createRT("MorphRTPos", "texturePositions");
		}
		if (morph.morphNormals) {
			this.rtNormals = createRT("MorphRTNrm", "textureNormals");
		}
		this._textureParams = new Float32Array([morph.morphTextureWidth, morph.morphTextureHeight]);
		const halfSize = morph.aabb.halfExtents;
		this._aabbSize = new Float32Array([halfSize.x * 4, halfSize.y * 4, halfSize.z * 4]);
		const min = morph.aabb.getMin();
		this._aabbMin = new Float32Array([min.x * 2, min.y * 2, min.z * 2]);
		this._aabbNrmSize = new Float32Array([2, 2, 2]);
		this._aabbNrmMin = new Float32Array([-1, -1, -1]);
		this.aabbSizeId = this.device.scope.resolve("aabbSize");
		this.aabbMinId = this.device.scope.resolve("aabbMin");
		this.morphTextureId = this.device.scope.resolve("morphTexture");
		this.morphFactor = this.device.scope.resolve("morphFactor[0]");
		this.morphIndex = this.device.scope.resolve("morphIndex[0]");
		this.countId = this.device.scope.resolve("count");
		this.zeroTextures = false;
	}
	destroy() {
		this.shader = null;
		const morph = this.morph;
		if (morph) {
			this.morph = null;
			morph.decRefCount();
			if (morph.refCount < 1) {
				morph.destroy();
			}
		}
		this.rtPositions?.destroy();
		this.rtPositions = null;
		this.texturePositions?.destroy();
		this.texturePositions = null;
		this.rtNormals?.destroy();
		this.rtNormals = null;
		this.textureNormals?.destroy();
		this.textureNormals = null;
	}
	clone() {
		return new _MorphInstance(this.morph);
	}
	_getWeightIndex(key) {
		if (typeof key === "string") {
			const index = this._weightMap.get(key);
			if (index === void 0) {
			}
			return index;
		}
		return key;
	}
	getWeight(key) {
		const index = this._getWeightIndex(key);
		return this._weights[index];
	}
	setWeight(key, weight) {
		const index = this._getWeightIndex(key);
		this._weights[index] = weight;
		this._dirty = true;
	}
	_createShader(maxCount) {
		const defines = /* @__PURE__ */ new Map();
		defines.set("{MORPH_TEXTURE_MAX_COUNT}", maxCount);
		if (this.morph.intRenderFormat) defines.set("MORPH_INT", "");
		const outputType = this.morph.intRenderFormat ? "uvec4" : "vec4";
		return ShaderUtils.createShader(this.device, {
			uniqueName: `TextureMorphShader_${maxCount}-${this.morph.intRenderFormat ? "int" : "float"}`,
			attributes: { vertex_position: SEMANTIC_POSITION },
			vertexChunk: "morphVS",
			fragmentChunk: "morphPS",
			fragmentDefines: defines,
			fragmentOutputTypes: [outputType]
		});
	}
	_updateTextureRenderTarget(renderTarget, activeCount, isPos) {
		const { morph, device } = this;
		this.setAabbUniforms(isPos);
		this.morphTextureId.setValue(isPos ? morph.targetsTexturePositions : morph.targetsTextureNormals);
		device.setBlendState(BlendState.NOBLEND);
		this.countId.setValue(activeCount);
		this.morphFactor.setValue(this._shaderMorphWeights);
		this.morphIndex.setValue(this._shaderMorphIndex);
		drawQuadWithShader(device, renderTarget, this.shader);
	}
	_updateTextureMorph(activeCount) {
		const device = this.device;
		if (activeCount > 0 || !this.zeroTextures) {
			if (this.rtPositions) {
				this._updateTextureRenderTarget(this.rtPositions, activeCount, true);
			}
			if (this.rtNormals) {
				this._updateTextureRenderTarget(this.rtNormals, activeCount, false);
			}
			this.zeroTextures = activeCount === 0;
		}
	}
	setAabbUniforms(isPos = true) {
		this.aabbSizeId.setValue(isPos ? this._aabbSize : this._aabbNrmSize);
		this.aabbMinId.setValue(isPos ? this._aabbMin : this._aabbNrmMin);
	}
	prepareRendering(device) {
		this.setAabbUniforms();
	}
	update() {
		this._dirty = false;
		const targets = this.morph._targets;
		const epsilon = 1e-5;
		const weights = this._shaderMorphWeights;
		const indices = this._shaderMorphIndex;
		let activeCount = 0;
		for (let i2 = 0; i2 < targets.length; i2++) {
			if (Math.abs(this.getWeight(i2)) > epsilon) {
				weights[activeCount] = this.getWeight(i2);
				indices[activeCount] = i2;
				activeCount++;
			}
		}
		this._updateTextureMorph(activeCount);
	}
};

var Model = class _Model {
	graph = null;
	meshInstances = [];
	skinInstances = [];
	morphInstances = [];
	constructor() {
		this.cameras = [];
		this.lights = [];
		this._shadersVersion = 0;
		this._immutable = false;
	}
	getGraph() {
		return this.graph;
	}
	setGraph(graph) {
		this.graph = graph;
	}
	getCameras() {
		return this.cameras;
	}
	setCameras(cameras) {
		this.cameras = cameras;
	}
	getLights() {
		return this.lights;
	}
	setLights(lights2) {
		this.lights = lights2;
	}
	getMaterials() {
		const materials = [];
		for (let i2 = 0; i2 < this.meshInstances.length; i2++) {
			const meshInstance = this.meshInstances[i2];
			if (materials.indexOf(meshInstance.material) === -1) {
				materials.push(meshInstance.material);
			}
		}
		return materials;
	}
	clone() {
		const srcNodes = [];
		const cloneNodes = [];
		const _duplicate = function(node) {
			const newNode = node.clone();
			srcNodes.push(node);
			cloneNodes.push(newNode);
			for (let idx = 0; idx < node._children.length; idx++) {
				newNode.addChild(_duplicate(node._children[idx]));
			}
			return newNode;
		};
		const cloneGraph = _duplicate(this.graph);
		const cloneMeshInstances = [];
		const cloneSkinInstances = [];
		const cloneMorphInstances = [];
		for (let i2 = 0; i2 < this.skinInstances.length; i2++) {
			const skin = this.skinInstances[i2].skin;
			const cloneSkinInstance = new SkinInstance(skin);
			const bones = [];
			for (let j = 0; j < skin.boneNames.length; j++) {
				const boneName = skin.boneNames[j];
				const bone = cloneGraph.findByName(boneName);
				bones.push(bone);
			}
			cloneSkinInstance.bones = bones;
			cloneSkinInstances.push(cloneSkinInstance);
		}
		for (let i2 = 0; i2 < this.morphInstances.length; i2++) {
			const morph = this.morphInstances[i2].morph;
			const cloneMorphInstance = new MorphInstance(morph);
			cloneMorphInstances.push(cloneMorphInstance);
		}
		for (let i2 = 0; i2 < this.meshInstances.length; i2++) {
			const meshInstance = this.meshInstances[i2];
			const nodeIndex = srcNodes.indexOf(meshInstance.node);
			const cloneMeshInstance = new MeshInstance(meshInstance.mesh, meshInstance.material, cloneNodes[nodeIndex]);
			if (meshInstance.skinInstance) {
				const skinInstanceIndex = this.skinInstances.indexOf(meshInstance.skinInstance);
				cloneMeshInstance.skinInstance = cloneSkinInstances[skinInstanceIndex];
			}
			if (meshInstance.morphInstance) {
				const morphInstanceIndex = this.morphInstances.indexOf(meshInstance.morphInstance);
				cloneMeshInstance.morphInstance = cloneMorphInstances[morphInstanceIndex];
			}
			cloneMeshInstances.push(cloneMeshInstance);
		}
		const clone = new _Model();
		clone.graph = cloneGraph;
		clone.meshInstances = cloneMeshInstances;
		clone.skinInstances = cloneSkinInstances;
		clone.morphInstances = cloneMorphInstances;
		clone.getGraph().syncHierarchy();
		return clone;
	}
	destroy() {
		const meshInstances = this.meshInstances;
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			meshInstances[i2].destroy();
		}
		this.meshInstances.length = 0;
	}
	generateWireframe() {
		MeshInstance._prepareRenderStyleForArray(this.meshInstances, RENDERSTYLE_WIREFRAME);
	}
};

var Morph = class extends RefCountedObject {
	_aabb;
	preferHighPrecision;
	constructor(targets, graphicsDevice, { preferHighPrecision = false } = {}) {
		super();
		this.device = graphicsDevice;
		const device = graphicsDevice;
		this.preferHighPrecision = preferHighPrecision;
		this._targets = targets.slice();
		const renderableHalf = device.textureHalfFloatRenderable ? PIXELFORMAT_RGBA16F : void 0;
		const renderableFloat = device.textureFloatRenderable ? PIXELFORMAT_RGBA32F : void 0;
		this._renderTextureFormat = this.preferHighPrecision ? renderableFloat ?? renderableHalf : renderableHalf ?? renderableFloat;
		this._renderTextureFormat = this._renderTextureFormat ?? PIXELFORMAT_RGBA16U;
		this.intRenderFormat = isIntegerPixelFormat(this._renderTextureFormat);
		this._textureFormat = this.preferHighPrecision ? PIXELFORMAT_RGBA32F : PIXELFORMAT_RGBA16F;
		this._init();
		this._updateMorphFlags();
	}
	destroy() {
		this.vertexBufferIds?.destroy();
		this.vertexBufferIds = null;
		this.targetsTexturePositions?.destroy();
		this.targetsTexturePositions = null;
		this.targetsTextureNormals?.destroy();
		this.targetsTextureNormals = null;
	}
	get aabb() {
		if (!this._aabb) {
			const min = new Vec3();
			const max = new Vec3();
			for (let i2 = 0; i2 < this._targets.length; i2++) {
				const targetAabb = this._targets[i2].aabb;
				min.min(targetAabb.getMin());
				max.max(targetAabb.getMax());
			}
			this._aabb = new BoundingBox();
			this._aabb.setMinMax(min, max);
		}
		return this._aabb;
	}
	get morphPositions() {
		return this._morphPositions;
	}
	get morphNormals() {
		return this._morphNormals;
	}
	_init() {
		this._initTextureBased();
		for (let i2 = 0; i2 < this._targets.length; i2++) {
			this._targets[i2]._postInit();
		}
	}
	_findSparseSet(deltaArrays, ids3, usedDataIndices) {
		let freeIndex = 1;
		const dataCount = deltaArrays[0].length;
		for (let v6 = 0; v6 < dataCount; v6 += 3) {
			let vertexUsed = false;
			for (let i2 = 0; i2 < deltaArrays.length; i2++) {
				const data2 = deltaArrays[i2];
				if (data2[v6] !== 0 || data2[v6 + 1] !== 0 || data2[v6 + 2] !== 0) {
					vertexUsed = true;
					break;
				}
			}
			if (vertexUsed) {
				ids3.push(freeIndex);
				usedDataIndices.push(v6 / 3);
				freeIndex++;
			} else {
				ids3.push(0);
			}
		}
		return freeIndex;
	}
	_initTextureBased() {
		const deltaArrays = [], deltaInfos = [];
		const targets = this._targets;
		for (let i2 = 0; i2 < targets.length; i2++) {
			const target2 = targets[i2];
			if (target2.options.deltaPositions) {
				deltaArrays.push(target2.options.deltaPositions);
				deltaInfos.push(true);
			}
			if (target2.options.deltaNormals) {
				deltaArrays.push(target2.options.deltaNormals);
				deltaInfos.push(false);
			}
		}
		const ids3 = [], usedDataIndices = [];
		const freeIndex = this._findSparseSet(deltaArrays, ids3, usedDataIndices);
		const maxTextureSize = this.device.maxTextureSize;
		let morphTextureWidth = Math.ceil(Math.sqrt(freeIndex));
		morphTextureWidth = Math.min(morphTextureWidth, maxTextureSize);
		const morphTextureHeight = Math.ceil(freeIndex / morphTextureWidth);
		if (morphTextureHeight > maxTextureSize) {
			return;
		}
		this.morphTextureWidth = morphTextureWidth;
		this.morphTextureHeight = morphTextureHeight;
		let halfFloat = false;
		const float2Half = FloatPacking.float2Half;
		if (this._textureFormat === PIXELFORMAT_RGBA16F) {
			halfFloat = true;
		}
		const texturesDataPositions = [];
		const texturesDataNormals = [];
		const textureDataSize = morphTextureWidth * morphTextureHeight * 4;
		for (let i2 = 0; i2 < deltaArrays.length; i2++) {
			const data2 = deltaArrays[i2];
			const textureData2 = this._textureFormat === PIXELFORMAT_RGBA16F ? new Uint16Array(textureDataSize) : new Float32Array(textureDataSize);
			(deltaInfos[i2] ? texturesDataPositions : texturesDataNormals).push(textureData2);
			if (halfFloat) {
				for (let v6 = 0; v6 < usedDataIndices.length; v6++) {
					const index = usedDataIndices[v6] * 3;
					const dstIndex = v6 * 4 + 4;
					textureData2[dstIndex] = float2Half(data2[index]);
					textureData2[dstIndex + 1] = float2Half(data2[index + 1]);
					textureData2[dstIndex + 2] = float2Half(data2[index + 2]);
				}
			} else {
				for (let v6 = 0; v6 < usedDataIndices.length; v6++) {
					const index = usedDataIndices[v6] * 3;
					const dstIndex = v6 * 4 + 4;
					textureData2[dstIndex] = data2[index];
					textureData2[dstIndex + 1] = data2[index + 1];
					textureData2[dstIndex + 2] = data2[index + 2];
				}
			}
		}
		if (texturesDataPositions.length > 0) {
			this.targetsTexturePositions = this._createTexture("MorphPositionsTexture", this._textureFormat, targets.length, [texturesDataPositions]);
		}
		if (texturesDataNormals.length > 0) {
			this.targetsTextureNormals = this._createTexture("MorphNormalsTexture", this._textureFormat, targets.length, [texturesDataNormals]);
		}
		const formatDesc = [{ semantic: SEMANTIC_ATTR15, components: 1, type: TYPE_UINT32, asInt: true }];
		this.vertexBufferIds = new VertexBuffer(this.device, new VertexFormat(this.device, formatDesc, ids3.length), ids3.length, {
			data: new Uint32Array(ids3)
		});
		return true;
	}
	get targets() {
		return this._targets;
	}
	// ---- deprecated block start ----
	getTarget(index) {
		return this.targets[index];
	}
	// ---- deprecated block end ----
	_updateMorphFlags() {
		this._morphPositions = false;
		this._morphNormals = false;
		for (let i2 = 0; i2 < this._targets.length; i2++) {
			const target2 = this._targets[i2];
			if (target2.morphPositions) {
				this._morphPositions = true;
			}
			if (target2.morphNormals) {
				this._morphNormals = true;
			}
		}
	}
	_createTexture(name, format, arrayLength, levels) {
		return new Texture(this.device, {
			levels,
			arrayLength,
			width: this.morphTextureWidth,
			height: this.morphTextureHeight,
			format,
			cubemap: false,
			mipmaps: false,
			minFilter: FILTER_NEAREST,
			magFilter: FILTER_NEAREST,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			name
		});
	}
};

var MorphTarget = class _MorphTarget {
	used = false;
	constructor(options2) {
		this.options = options2;
		this._name = options2.name;
		this._defaultWeight = options2.defaultWeight || 0;
		this._aabb = options2.aabb;
		this.deltaPositions = options2.deltaPositions;
		this.morphPositions = !!options2.deltaPositions;
		this.morphNormals = !!options2.deltaNormals;
	}
	get name() {
		return this._name;
	}
	get defaultWeight() {
		return this._defaultWeight;
	}
	get aabb() {
		if (!this._aabb) {
			this._aabb = new BoundingBox();
			if (this.deltaPositions) {
				this._aabb.compute(this.deltaPositions);
			}
		}
		return this._aabb;
	}
	clone() {
		return new _MorphTarget(this.options);
	}
	_postInit() {
		if (!this.options.preserveData) {
			this.options = null;
		}
		this.used = true;
	}
};

var nonUniformScale;
var uniformScale = 1;
var particleTexChannels = 4;
var rotMat = new Mat4();
var rotMatInv = new Mat4();
var randomPosTformed = new Vec3();
var randomPos = new Vec3();
var rndFactor3Vec = new Vec3();
var particlePosPrev = new Vec3();
var velocityVec = new Vec3();
var localVelocityVec = new Vec3();
var velocityVec2 = new Vec3();
var localVelocityVec2 = new Vec3();
var radialVelocityVec = new Vec3();
var particlePos = new Vec3();
var particleFinalPos = new Vec3();
var moveDirVec = new Vec3();
var tmpVec32 = new Vec3();
function saturate(x3) {
	return Math.max(Math.min(x3, 1), 0);
}
function glMod(x3, y2) {
	return x3 - y2 * Math.floor(x3 / y2);
}
var ParticleCPUUpdater = class {
	constructor(emitter) {
		this._emitter = emitter;
	}
	calcSpawnPosition(particleTex, spawnMatrix2, extentsInnerRatioUniform2, emitterPos, i2) {
		const emitter = this._emitter;
		const rX = Math.random();
		const rY = Math.random();
		const rZ = Math.random();
		const rW = Math.random();
		if (emitter.useCpu) {
			particleTex[i2 * particleTexChannels + 0 + emitter.numParticlesPot * 2 * particleTexChannels] = rX;
			particleTex[i2 * particleTexChannels + 1 + emitter.numParticlesPot * 2 * particleTexChannels] = rY;
			particleTex[i2 * particleTexChannels + 2 + emitter.numParticlesPot * 2 * particleTexChannels] = rZ;
		}
		randomPos.x = rX - 0.5;
		randomPos.y = rY - 0.5;
		randomPos.z = rZ - 0.5;
		if (emitter.emitterShape === EMITTERSHAPE_BOX) {
			const max = Math.max(Math.abs(randomPos.x), Math.max(Math.abs(randomPos.y), Math.abs(randomPos.z)));
			const edgeX = max + (0.5 - max) * extentsInnerRatioUniform2[0];
			const edgeY = max + (0.5 - max) * extentsInnerRatioUniform2[1];
			const edgeZ = max + (0.5 - max) * extentsInnerRatioUniform2[2];
			randomPos.x = edgeX * (max === Math.abs(randomPos.x) ? Math.sign(randomPos.x) : 2 * randomPos.x);
			randomPos.y = edgeY * (max === Math.abs(randomPos.y) ? Math.sign(randomPos.y) : 2 * randomPos.y);
			randomPos.z = edgeZ * (max === Math.abs(randomPos.z) ? Math.sign(randomPos.z) : 2 * randomPos.z);
			if (!emitter.localSpace) {
				randomPosTformed.copy(emitterPos).add(spawnMatrix2.transformPoint(randomPos));
			} else {
				randomPosTformed.copy(spawnMatrix2.transformPoint(randomPos));
			}
		} else {
			randomPos.normalize();
			const spawnBoundsSphereInnerRatio = emitter.emitterRadius === 0 ? 0 : emitter.emitterRadiusInner / emitter.emitterRadius;
			const r = rW * (1 - spawnBoundsSphereInnerRatio) + spawnBoundsSphereInnerRatio;
			if (!emitter.localSpace) {
				randomPosTformed.copy(emitterPos).add(randomPos.mulScalar(r * emitter.emitterRadius));
			} else {
				randomPosTformed.copy(randomPos.mulScalar(r * emitter.emitterRadius));
			}
		}
		const particleRate = math.lerp(emitter.rate, emitter.rate2, rX);
		const startSpawnTime = -particleRate * i2;
		particleTex[i2 * particleTexChannels] = randomPosTformed.x;
		particleTex[i2 * particleTexChannels + 1] = randomPosTformed.y;
		particleTex[i2 * particleTexChannels + 2] = randomPosTformed.z;
		particleTex[i2 * particleTexChannels + 3] = math.lerp(emitter.startAngle * math.DEG_TO_RAD, emitter.startAngle2 * math.DEG_TO_RAD, rX);
		particleTex[i2 * particleTexChannels + 3 + emitter.numParticlesPot * particleTexChannels] = startSpawnTime;
	}
	// This should only change emitter state via in-params like data, vbToSort, etc.
	update(data2, vbToSort, particleTex, spawnMatrix2, extentsInnerRatioUniform2, emitterPos, delta3, isOnStop) {
		let a, b, c2;
		const emitter = this._emitter;
		if (emitter.meshInstance.node) {
			const fullMat = emitter.meshInstance.node.worldTransform;
			for (let j = 0; j < 12; j++) {
				rotMat.data[j] = fullMat.data[j];
			}
			rotMatInv.copy(rotMat);
			rotMatInv.invert();
			nonUniformScale = emitter.meshInstance.node.localScale;
			uniformScale = Math.max(Math.max(nonUniformScale.x, nonUniformScale.y), nonUniformScale.z);
		}
		emitterPos = emitter.meshInstance.node === null || emitter.localSpace ? Vec3.ZERO : emitter.meshInstance.node.getPosition();
		const posCam = emitter.camera ? emitter.camera._node.getPosition() : Vec3.ZERO;
		const vertSize = !emitter.useMesh ? 15 : 17;
		let cf, cc;
		let rotSpeed, rotSpeed2, scale2, alpha, alpha2, radialSpeed, radialSpeed2;
		const precision1 = emitter.precision - 1;
		for (let i2 = 0; i2 < emitter.numParticles; i2++) {
			const id14 = Math.floor(emitter.vbCPU[i2 * emitter.numParticleVerts * (emitter.useMesh ? 6 : 4) + 3]);
			const rndFactor = particleTex[id14 * particleTexChannels + 0 + emitter.numParticlesPot * 2 * particleTexChannels];
			rndFactor3Vec.x = rndFactor;
			rndFactor3Vec.y = particleTex[id14 * particleTexChannels + 1 + emitter.numParticlesPot * 2 * particleTexChannels];
			rndFactor3Vec.z = particleTex[id14 * particleTexChannels + 2 + emitter.numParticlesPot * 2 * particleTexChannels];
			const particleRate = emitter.rate + (emitter.rate2 - emitter.rate) * rndFactor;
			const particleLifetime = emitter.lifetime;
			let life = particleTex[id14 * particleTexChannels + 3 + emitter.numParticlesPot * particleTexChannels] + delta3;
			const nlife = saturate(life / particleLifetime);
			let scale3 = 0;
			let alphaDiv = 0;
			const angle = 0;
			const respawn = life - delta3 <= 0 || life >= particleLifetime;
			if (respawn) {
				this.calcSpawnPosition(particleTex, spawnMatrix2, extentsInnerRatioUniform2, emitterPos, id14);
			}
			let particleEnabled = life > 0 && life < particleLifetime;
			if (particleEnabled) {
				c2 = nlife * precision1;
				cf = Math.floor(c2);
				cc = Math.ceil(c2);
				c2 %= 1;
				a = emitter.qRotSpeed[cf];
				b = emitter.qRotSpeed[cc];
				rotSpeed = a + (b - a) * c2;
				a = emitter.qRotSpeed2[cf];
				b = emitter.qRotSpeed2[cc];
				rotSpeed2 = a + (b - a) * c2;
				a = emitter.qScale[cf];
				b = emitter.qScale[cc];
				scale3 = a + (b - a) * c2;
				a = emitter.qScale2[cf];
				b = emitter.qScale2[cc];
				scale2 = a + (b - a) * c2;
				a = emitter.qAlpha[cf];
				b = emitter.qAlpha[cc];
				alpha = a + (b - a) * c2;
				a = emitter.qAlpha2[cf];
				b = emitter.qAlpha2[cc];
				alpha2 = a + (b - a) * c2;
				a = emitter.qRadialSpeed[cf];
				b = emitter.qRadialSpeed[cc];
				radialSpeed = a + (b - a) * c2;
				a = emitter.qRadialSpeed2[cf];
				b = emitter.qRadialSpeed2[cc];
				radialSpeed2 = a + (b - a) * c2;
				radialSpeed += (radialSpeed2 - radialSpeed) * (rndFactor * 100 % 1);
				particlePosPrev.x = particleTex[id14 * particleTexChannels];
				particlePosPrev.y = particleTex[id14 * particleTexChannels + 1];
				particlePosPrev.z = particleTex[id14 * particleTexChannels + 2];
				if (!emitter.localSpace) {
					radialVelocityVec.copy(particlePosPrev).sub(emitterPos);
				} else {
					radialVelocityVec.copy(particlePosPrev);
				}
				radialVelocityVec.normalize().mulScalar(radialSpeed);
				cf *= 3;
				cc *= 3;
				a = emitter.qLocalVelocity[cf];
				b = emitter.qLocalVelocity[cc];
				localVelocityVec.x = a + (b - a) * c2;
				a = emitter.qLocalVelocity[cf + 1];
				b = emitter.qLocalVelocity[cc + 1];
				localVelocityVec.y = a + (b - a) * c2;
				a = emitter.qLocalVelocity[cf + 2];
				b = emitter.qLocalVelocity[cc + 2];
				localVelocityVec.z = a + (b - a) * c2;
				a = emitter.qLocalVelocity2[cf];
				b = emitter.qLocalVelocity2[cc];
				localVelocityVec2.x = a + (b - a) * c2;
				a = emitter.qLocalVelocity2[cf + 1];
				b = emitter.qLocalVelocity2[cc + 1];
				localVelocityVec2.y = a + (b - a) * c2;
				a = emitter.qLocalVelocity2[cf + 2];
				b = emitter.qLocalVelocity2[cc + 2];
				localVelocityVec2.z = a + (b - a) * c2;
				a = emitter.qVelocity[cf];
				b = emitter.qVelocity[cc];
				velocityVec.x = a + (b - a) * c2;
				a = emitter.qVelocity[cf + 1];
				b = emitter.qVelocity[cc + 1];
				velocityVec.y = a + (b - a) * c2;
				a = emitter.qVelocity[cf + 2];
				b = emitter.qVelocity[cc + 2];
				velocityVec.z = a + (b - a) * c2;
				a = emitter.qVelocity2[cf];
				b = emitter.qVelocity2[cc];
				velocityVec2.x = a + (b - a) * c2;
				a = emitter.qVelocity2[cf + 1];
				b = emitter.qVelocity2[cc + 1];
				velocityVec2.y = a + (b - a) * c2;
				a = emitter.qVelocity2[cf + 2];
				b = emitter.qVelocity2[cc + 2];
				velocityVec2.z = a + (b - a) * c2;
				localVelocityVec.x += (localVelocityVec2.x - localVelocityVec.x) * rndFactor3Vec.x;
				localVelocityVec.y += (localVelocityVec2.y - localVelocityVec.y) * rndFactor3Vec.y;
				localVelocityVec.z += (localVelocityVec2.z - localVelocityVec.z) * rndFactor3Vec.z;
				if (emitter.initialVelocity > 0) {
					if (emitter.emitterShape === EMITTERSHAPE_SPHERE) {
						randomPos.copy(rndFactor3Vec).mulScalar(2).sub(Vec3.ONE).normalize();
						localVelocityVec.add(randomPos.mulScalar(emitter.initialVelocity));
					} else {
						localVelocityVec.add(Vec3.FORWARD.mulScalar(emitter.initialVelocity));
					}
				}
				velocityVec.x += (velocityVec2.x - velocityVec.x) * rndFactor3Vec.x;
				velocityVec.y += (velocityVec2.y - velocityVec.y) * rndFactor3Vec.y;
				velocityVec.z += (velocityVec2.z - velocityVec.z) * rndFactor3Vec.z;
				rotSpeed += (rotSpeed2 - rotSpeed) * rndFactor3Vec.y;
				scale3 = (scale3 + (scale2 - scale3) * (rndFactor * 1e4 % 1)) * uniformScale;
				alphaDiv = (alpha2 - alpha) * (rndFactor * 1e3 % 1);
				if (emitter.meshInstance.node) {
					if (!emitter.localSpace) {
						rotMat.transformPoint(localVelocityVec, localVelocityVec);
					} else {
						localVelocityVec.x /= nonUniformScale.x;
						localVelocityVec.y /= nonUniformScale.y;
						localVelocityVec.z /= nonUniformScale.z;
					}
				}
				if (!emitter.localSpace) {
					localVelocityVec.add(velocityVec.mul(nonUniformScale));
					localVelocityVec.add(radialVelocityVec.mul(nonUniformScale));
				} else {
					rotMatInv.transformPoint(velocityVec, velocityVec);
					localVelocityVec.add(velocityVec).add(radialVelocityVec);
				}
				moveDirVec.copy(localVelocityVec);
				particlePos.copy(particlePosPrev).add(localVelocityVec.mulScalar(delta3));
				particleFinalPos.copy(particlePos);
				particleTex[id14 * particleTexChannels] = particleFinalPos.x;
				particleTex[id14 * particleTexChannels + 1] = particleFinalPos.y;
				particleTex[id14 * particleTexChannels + 2] = particleFinalPos.z;
				particleTex[id14 * particleTexChannels + 3] += rotSpeed * delta3;
				if (emitter.wrap && emitter.wrapBounds) {
					if (!emitter.localSpace) {
						particleFinalPos.sub(emitterPos);
					}
					particleFinalPos.x = glMod(particleFinalPos.x, emitter.wrapBounds.x) - emitter.wrapBounds.x * 0.5;
					particleFinalPos.y = glMod(particleFinalPos.y, emitter.wrapBounds.y) - emitter.wrapBounds.y * 0.5;
					particleFinalPos.z = glMod(particleFinalPos.z, emitter.wrapBounds.z) - emitter.wrapBounds.z * 0.5;
					if (!emitter.localSpace) {
						particleFinalPos.add(emitterPos);
					}
				}
				if (emitter.sort > 0) {
					if (emitter.sort === 1) {
						tmpVec32.copy(particleFinalPos).sub(posCam);
						emitter.particleDistance[id14] = -(tmpVec32.x * tmpVec32.x + tmpVec32.y * tmpVec32.y + tmpVec32.z * tmpVec32.z);
					} else if (emitter.sort === 2) {
						emitter.particleDistance[id14] = life;
					} else if (emitter.sort === 3) {
						emitter.particleDistance[id14] = -life;
					}
				}
			}
			if (isOnStop) {
				if (life < 0) {
					particleTex[id14 * particleTexChannels + 3 + emitter.numParticlesPot * 2 * particleTexChannels] = -1;
				}
			} else {
				if (life >= particleLifetime) {
					life -= Math.max(particleLifetime, emitter.numParticles * particleRate);
					particleTex[id14 * particleTexChannels + 3 + emitter.numParticlesPot * 2 * particleTexChannels] = emitter.loop ? 1 : -1;
				}
				if (life < 0 && emitter.loop) {
					particleTex[id14 * particleTexChannels + 3 + emitter.numParticlesPot * 2 * particleTexChannels] = 1;
				}
			}
			if (particleTex[id14 * particleTexChannels + 3 + emitter.numParticlesPot * 2 * particleTexChannels] < 0) {
				particleEnabled = false;
			}
			particleTex[id14 * particleTexChannels + 3 + emitter.numParticlesPot * particleTexChannels] = life;
			for (let v6 = 0; v6 < emitter.numParticleVerts; v6++) {
				const vbOffset = (i2 * emitter.numParticleVerts + v6) * (emitter.useMesh ? 6 : 4);
				let quadX = emitter.vbCPU[vbOffset];
				let quadY = emitter.vbCPU[vbOffset + 1];
				let quadZ = emitter.vbCPU[vbOffset + 2];
				if (!particleEnabled) {
					quadX = quadY = quadZ = 0;
				}
				const w = i2 * emitter.numParticleVerts * vertSize + v6 * vertSize;
				data2[w] = particleFinalPos.x;
				data2[w + 1] = particleFinalPos.y;
				data2[w + 2] = particleFinalPos.z;
				data2[w + 3] = nlife;
				data2[w + 4] = emitter.alignToMotion ? angle : particleTex[id14 * particleTexChannels + 3];
				data2[w + 5] = scale3;
				data2[w + 6] = alphaDiv;
				data2[w + 7] = moveDirVec.x;
				data2[w + 8] = quadX;
				data2[w + 9] = quadY;
				data2[w + 10] = quadZ;
				data2[w + 11] = moveDirVec.y;
				data2[w + 12] = id14;
				data2[w + 13] = moveDirVec.z;
				data2[w + 14] = emitter.vbCPU[vbOffset + 3];
				if (emitter.useMesh) {
					data2[w + 15] = emitter.vbCPU[vbOffset + 4];
					data2[w + 16] = emitter.vbCPU[vbOffset + 5];
				}
			}
		}
		if (emitter.sort > PARTICLESORT_NONE && emitter.camera) {
			const vbStride = emitter.useMesh ? 6 : 4;
			const particleDistance = emitter.particleDistance;
			for (let i2 = 0; i2 < emitter.numParticles; i2++) {
				vbToSort[i2][0] = i2;
				vbToSort[i2][1] = particleDistance[Math.floor(emitter.vbCPU[i2 * emitter.numParticleVerts * vbStride + 3])];
			}
			emitter.vbOld.set(emitter.vbCPU);
			vbToSort.sort((p12, p22) => {
				return p12[1] - p22[1];
			});
			for (let i2 = 0; i2 < emitter.numParticles; i2++) {
				const src = vbToSort[i2][0] * emitter.numParticleVerts * vbStride;
				const dest = i2 * emitter.numParticleVerts * vbStride;
				for (let j = 0; j < emitter.numParticleVerts * vbStride; j++) {
					emitter.vbCPU[dest + j] = emitter.vbOld[src + j];
				}
			}
		}
	}
};

var spawnMatrix3 = new Mat3();
var emitterMatrix3 = new Mat3();
var emitterMatrix3Inv = new Mat3();
var ParticleGPUUpdater = class {
	constructor(emitter, gd) {
		this._emitter = emitter;
		this.frameRandomUniform = new Float32Array(3);
		this.emitterPosUniform = new Float32Array(3);
		this.emitterScaleUniform = new Float32Array([1, 1, 1]);
		this.constantParticleTexIN = gd.scope.resolve("particleTexIN");
		this.constantParticleTexOUT = gd.scope.resolve("particleTexOUT");
		this.constantEmitterPos = gd.scope.resolve("emitterPos");
		this.constantEmitterScale = gd.scope.resolve("emitterScale");
		this.constantSpawnBounds = gd.scope.resolve("spawnBounds");
		this.constantSpawnPosInnerRatio = gd.scope.resolve("spawnPosInnerRatio");
		this.constantSpawnBoundsSphere = gd.scope.resolve("spawnBoundsSphere");
		this.constantSpawnBoundsSphereInnerRatio = gd.scope.resolve("spawnBoundsSphereInnerRatio");
		this.constantInitialVelocity = gd.scope.resolve("initialVelocity");
		this.constantFrameRandom = gd.scope.resolve("frameRandom");
		this.constantDelta = gd.scope.resolve("delta");
		this.constantRate = gd.scope.resolve("rate");
		this.constantRateDiv = gd.scope.resolve("rateDiv");
		this.constantLifetime = gd.scope.resolve("lifetime");
		this.constantGraphSampleSize = gd.scope.resolve("graphSampleSize");
		this.constantGraphNumSamples = gd.scope.resolve("graphNumSamples");
		this.constantInternalTex0 = gd.scope.resolve("internalTex0");
		this.constantInternalTex1 = gd.scope.resolve("internalTex1");
		this.constantInternalTex2 = gd.scope.resolve("internalTex2");
		this.constantInternalTex3 = gd.scope.resolve("internalTex3");
		this.constantEmitterMatrix = gd.scope.resolve("emitterMatrix");
		this.constantEmitterMatrixInv = gd.scope.resolve("emitterMatrixInv");
		this.constantNumParticles = gd.scope.resolve("numParticles");
		this.constantNumParticlesPot = gd.scope.resolve("numParticlesPot");
		this.constantLocalVelocityDivMult = gd.scope.resolve("localVelocityDivMult");
		this.constantVelocityDivMult = gd.scope.resolve("velocityDivMult");
		this.constantRotSpeedDivMult = gd.scope.resolve("rotSpeedDivMult");
		this.constantSeed = gd.scope.resolve("seed");
		this.constantStartAngle = gd.scope.resolve("startAngle");
		this.constantStartAngle2 = gd.scope.resolve("startAngle2");
		this.constantFaceTangent = gd.scope.resolve("faceTangent");
		this.constantFaceBinorm = gd.scope.resolve("faceBinorm");
		this.constantRadialSpeedDivMult = gd.scope.resolve("radialSpeedDivMult");
	}
	randomize() {
		this.frameRandomUniform[0] = Math.random();
		this.frameRandomUniform[1] = Math.random();
		this.frameRandomUniform[2] = Math.random();
	}
	// This shouldn't change emitter state, only read from it
	update(device, spawnMatrix2, extentsInnerRatioUniform2, delta3, isOnStop) {
		const emitter = this._emitter;
		device.setDrawStates();
		this.randomize();
		this.constantRadialSpeedDivMult.setValue(emitter.material.getParameter("radialSpeedDivMult").data);
		this.constantGraphSampleSize.setValue(1 / emitter.precision);
		this.constantGraphNumSamples.setValue(emitter.precision);
		this.constantNumParticles.setValue(emitter.numParticles);
		this.constantNumParticlesPot.setValue(emitter.numParticlesPot);
		this.constantInternalTex0.setValue(emitter.internalTex0);
		this.constantInternalTex1.setValue(emitter.internalTex1);
		this.constantInternalTex2.setValue(emitter.internalTex2);
		this.constantInternalTex3.setValue(emitter.internalTex3);
		const node = emitter.meshInstance.node;
		const emitterScale = node === null ? Vec3.ONE : node.localScale;
		const emitterPos = node === null || emitter.localSpace ? Vec3.ZERO : node.getPosition();
		const emitterMatrix = node === null ? Mat4.IDENTITY : node.getWorldTransform();
		if (emitter.emitterShape === EMITTERSHAPE_BOX) {
			spawnMatrix3.setFromMat4(spawnMatrix2);
			this.constantSpawnBounds.setValue(spawnMatrix3.data);
			this.constantSpawnPosInnerRatio.setValue(extentsInnerRatioUniform2);
		} else {
			this.constantSpawnBoundsSphere.setValue(emitter.emitterRadius);
			this.constantSpawnBoundsSphereInnerRatio.setValue(emitter.emitterRadius === 0 ? 0 : emitter.emitterRadiusInner / emitter.emitterRadius);
		}
		this.constantInitialVelocity.setValue(emitter.initialVelocity);
		emitterMatrix3.setFromMat4(emitterMatrix);
		emitterMatrix3Inv.invertMat4(emitterMatrix);
		this.emitterPosUniform[0] = emitterPos.x;
		this.emitterPosUniform[1] = emitterPos.y;
		this.emitterPosUniform[2] = emitterPos.z;
		this.constantEmitterPos.setValue(this.emitterPosUniform);
		this.constantFrameRandom.setValue(this.frameRandomUniform);
		this.constantDelta.setValue(delta3);
		this.constantRate.setValue(emitter.rate);
		this.constantRateDiv.setValue(emitter.rate2 - emitter.rate);
		this.constantStartAngle.setValue(emitter.startAngle * math.DEG_TO_RAD);
		this.constantStartAngle2.setValue(emitter.startAngle2 * math.DEG_TO_RAD);
		this.constantSeed.setValue(emitter.seed);
		this.constantLifetime.setValue(emitter.lifetime);
		this.emitterScaleUniform[0] = emitterScale.x;
		this.emitterScaleUniform[1] = emitterScale.y;
		this.emitterScaleUniform[2] = emitterScale.z;
		this.constantEmitterScale.setValue(this.emitterScaleUniform);
		this.constantEmitterMatrix.setValue(emitterMatrix3.data);
		this.constantEmitterMatrixInv.setValue(emitterMatrix3Inv.data);
		this.constantLocalVelocityDivMult.setValue(emitter.localVelocityUMax);
		this.constantVelocityDivMult.setValue(emitter.velocityUMax);
		this.constantRotSpeedDivMult.setValue(emitter.rotSpeedUMax[0]);
		let texIN = emitter.swapTex ? emitter.particleTexOUT : emitter.particleTexIN;
		texIN = emitter.beenReset ? emitter.particleTexStart : texIN;
		const texOUT = emitter.swapTex ? emitter.particleTexIN : emitter.particleTexOUT;
		this.constantParticleTexIN.setValue(texIN);
		drawQuadWithShader(
			device,
			emitter.swapTex ? emitter.rtParticleTexIN : emitter.rtParticleTexOUT,
			!isOnStop ? emitter.loop ? emitter.shaderParticleUpdateRespawn : emitter.shaderParticleUpdateNoRespawn : emitter.shaderParticleUpdateOnStop
		);
		emitter.material.setParameter("particleTexOUT", texIN);
		emitter.material.setParameter("particleTexIN", texOUT);
		emitter.beenReset = false;
		emitter.swapTex = !emitter.swapTex;
		emitter.prevWorldBoundsSize.copy(emitter.worldBoundsSize);
		emitter.prevWorldBoundsCenter.copy(emitter.worldBounds.center);
	}
};

var normalTypeNames = [
	"NONE",
	"VERTEX",
	"MAP"
];
var ShaderGeneratorParticle = class extends ShaderGenerator {
	generateKey(options2) {
		const definesHash = ShaderGenerator.definesHash(options2.defines);
		let key = `particle_${definesHash}_`;
		for (const prop in options2) {
			if (options2.hasOwnProperty(prop)) {
				key += options2[prop];
			}
		}
		return key;
	}
	createVertexDefines(options2, attributes) {
		const vDefines = new Map(options2.defines);
		if (options2.mesh) vDefines.set("USE_MESH", "");
		if (options2.meshUv) vDefines.set("USE_MESH_UV", "");
		if (options2.localSpace) vDefines.set("LOCAL_SPACE", "");
		if (options2.screenSpace) vDefines.set("SCREEN_SPACE", "");
		if (options2.animTex) vDefines.set("ANIMTEX", "");
		if (options2.soft > 0) vDefines.set("SOFT", "");
		if (options2.stretch > 0) vDefines.set("STRETCH", "");
		if (options2.customFace) vDefines.set("CUSTOM_FACE", "");
		if (options2.localSpace) vDefines.set("LOCAL_SPACE", "");
		if (options2.animTexLoop) vDefines.set("ANIMTEX_LOOP", "");
		if (options2.wrap) vDefines.set("WRAP", "");
		if (options2.alignToMotion) vDefines.set("ALIGN_TO_MOTION", "");
		vDefines.set("NORMAL", normalTypeNames[options2.normal]);
		attributes.particle_vertexData = SEMANTIC_POSITION;
		if (options2.mesh && options2.meshUv) {
			attributes.particle_uv = SEMANTIC_TEXCOORD0;
		}
		if (options2.useCpu) {
			attributes.particle_vertexData2 = SEMANTIC_ATTR1;
			attributes.particle_vertexData3 = SEMANTIC_ATTR2;
			attributes.particle_vertexData4 = SEMANTIC_ATTR3;
			attributes.particle_vertexData5 = SEMANTIC_ATTR4;
		}
		return vDefines;
	}
	createFragmentDefines(options2) {
		const fDefines = new Map(options2.defines);
		if (options2.soft > 0) fDefines.set("SOFT", "");
		if (options2.halflambert) fDefines.set("HALF_LAMBERT", "");
		fDefines.set("NORMAL", normalTypeNames[options2.normal]);
		fDefines.set("BLEND", blendNames[options2.blend]);
		return fDefines;
	}
	createShaderDefinition(device, options2) {
		const shaderLanguage = device.isWebGPU ? SHADERLANGUAGE_WGSL : SHADERLANGUAGE_GLSL;
		const engineChunks = ShaderChunks.get(device, shaderLanguage);
		const attributes = {};
		const vDefines = this.createVertexDefines(options2, attributes);
		const fDefines = this.createFragmentDefines(options2);
		const executionDefine = `PARTICLE_${options2.useCpu ? "CPU" : "GPU"}
`;
		vDefines.set(executionDefine, "");
		fDefines.set(executionDefine, "");
		const includes = new Map(engineChunks);
		return ShaderDefinitionUtils.createDefinition(device, {
			name: "ParticleShader",
			shaderLanguage,
			attributes,
			vertexCode: engineChunks.get("particle_shaderVS"),
			fragmentCode: engineChunks.get("particle_shaderPS"),
			fragmentDefines: fDefines,
			fragmentIncludes: includes,
			vertexIncludes: includes,
			vertexDefines: vDefines
		});
	}
};
var particle = new ShaderGeneratorParticle();

var ParticleMaterial = class extends Material {
	emitter = null;
	constructor(emitter) {
		super();
		this.emitter = emitter;
	}
	getShaderVariant(params) {
		const { device, scene, cameraShaderParams, objDefs } = params;
		const { emitter } = this;
		const options2 = {
			defines: ShaderUtils.getCoreDefines(this, params),
			pass: SHADER_FORWARD,
			useCpu: this.emitter.useCpu,
			normal: emitter.lighting ? emitter.normalMap !== null ? 2 : 1 : 0,
			halflambert: this.emitter.halfLambert,
			stretch: this.emitter.stretch,
			alignToMotion: this.emitter.alignToMotion,
			soft: this.emitter.depthSoftening,
			mesh: this.emitter.useMesh,
			meshUv: objDefs & SHADERDEF_UV0,
			gamma: cameraShaderParams?.shaderOutputGamma ?? GAMMA_NONE,
			toneMap: cameraShaderParams?.toneMapping ?? TONEMAP_LINEAR,
			fog: scene && !this.emitter.noFog ? scene.fog.type : "none",
			wrap: this.emitter.wrap && this.emitter.wrapBounds,
			localSpace: this.emitter.localSpace,
			// in Editor, screen space particles (children of 2D Screen) are still rendered in 3d space
			screenSpace: emitter.inTools ? false : this.emitter.screenSpace,
			blend: this.emitter.blendType,
			animTex: this.emitter._isAnimated(),
			animTexLoop: this.emitter.animLoop,
			customFace: this.emitter.orientation !== PARTICLEORIENTATION_SCREEN
		};
		const processingOptions = new ShaderProcessorOptions(params.viewUniformFormat, params.vertexFormat);
		const library = getProgramLibrary(device);
		library.register("particle", particle);
		return library.getProgram("particle", options2, processingOptions, this.userId);
	}
};

var particleVerts = [
	[-1, -1],
	[1, -1],
	[1, 1],
	[-1, 1]
];
function _createTexture(device, width, height, pixelData, format = PIXELFORMAT_RGBA32F, mult8Bit, filter) {
	let mipFilter = FILTER_NEAREST;
	if (filter && (format === PIXELFORMAT_RGBA8 || format === PIXELFORMAT_SRGBA8)) {
		mipFilter = FILTER_LINEAR;
	}
	const texture = new Texture(device, {
		width,
		height,
		format,
		cubemap: false,
		mipmaps: false,
		minFilter: mipFilter,
		magFilter: mipFilter,
		addressU: ADDRESS_CLAMP_TO_EDGE,
		addressV: ADDRESS_CLAMP_TO_EDGE,
		name: "ParticleSystemTexture"
	});
	const pixels = texture.lock();
	if (format === PIXELFORMAT_RGBA8 || format === PIXELFORMAT_SRGBA8) {
		const temp = new Uint8Array(pixelData.length);
		for (let i2 = 0; i2 < pixelData.length; i2++) {
			temp[i2] = pixelData[i2] * mult8Bit * 255;
		}
		pixelData = temp;
	} else if (isIntegerPixelFormat(format)) {
		pixelData = new Uint32Array(pixelData.buffer, pixelData.byteOffset, pixelData.length);
	}
	pixels.set(pixelData);
	texture.unlock();
	return texture;
}
function saturate2(x3) {
	return Math.max(Math.min(x3, 1), 0);
}
var default0Curve = new Curve([0, 0, 1, 0]);
var default1Curve = new Curve([0, 1, 1, 1]);
var default0Curve3 = new CurveSet([0, 0, 1, 0], [0, 0, 1, 0], [0, 0, 1, 0]);
var default1Curve3 = new CurveSet([0, 1, 1, 1], [0, 1, 1, 1], [0, 1, 1, 1]);
var particleTexHeight = 2;
var particleTexChannels2 = 4;
var extentsInnerRatioUniform = new Float32Array(3);
var spawnMatrix = new Mat4();
var tmpVec33 = new Vec3();
var bMin = new Vec3();
var bMax = new Vec3();
var setPropertyTarget;
var setPropertyOptions;
function setProperty(pName, defaultVal) {
	if (setPropertyOptions[pName] !== void 0 && setPropertyOptions[pName] !== null) {
		setPropertyTarget[pName] = setPropertyOptions[pName];
	} else {
		setPropertyTarget[pName] = defaultVal;
	}
}
function pack3NFloats(a, b, c2) {
	const packed = a * 255 << 16 | b * 255 << 8 | c2 * 255;
	return packed / (1 << 24);
}
function packTextureXYZ_NXYZ(qXYZ, qXYZ2) {
	const num = qXYZ.length / 3;
	const colors = new Array(num * 4);
	for (let i2 = 0; i2 < num; i2++) {
		colors[i2 * 4] = qXYZ[i2 * 3];
		colors[i2 * 4 + 1] = qXYZ[i2 * 3 + 1];
		colors[i2 * 4 + 2] = qXYZ[i2 * 3 + 2];
		colors[i2 * 4 + 3] = pack3NFloats(qXYZ2[i2 * 3], qXYZ2[i2 * 3 + 1], qXYZ2[i2 * 3 + 2]);
	}
	return colors;
}
function packTextureRGBA(qRGB, qA) {
	const colors = new Array(qA.length * 4);
	for (let i2 = 0; i2 < qA.length; i2++) {
		colors[i2 * 4] = qRGB[i2 * 3];
		colors[i2 * 4 + 1] = qRGB[i2 * 3 + 1];
		colors[i2 * 4 + 2] = qRGB[i2 * 3 + 2];
		colors[i2 * 4 + 3] = qA[i2];
	}
	return colors;
}
function packTexture5Floats(qA, qB, qC, qD, qE) {
	const colors = new Array(qA.length * 4);
	for (let i2 = 0; i2 < qA.length; i2++) {
		colors[i2 * 4] = qA[i2];
		colors[i2 * 4 + 1] = qB[i2];
		colors[i2 * 4 + 2] = 0;
		colors[i2 * 4 + 3] = pack3NFloats(qC[i2], qD[i2], qE[i2]);
	}
	return colors;
}
function packTexture2Floats(qA, qB) {
	const colors = new Array(qA.length * 4);
	for (let i2 = 0; i2 < qA.length; i2++) {
		colors[i2 * 4] = qA[i2];
		colors[i2 * 4 + 1] = qB[i2];
		colors[i2 * 4 + 2] = 0;
		colors[i2 * 4 + 3] = 0;
	}
	return colors;
}
function calcSpawnDuration(emitter) {
	return Math.max(emitter.rate, emitter.rate2) * emitter.numParticles + emitter.lifetime;
}
function subGraph(A, B) {
	const r = new Float32Array(A.length);
	for (let i2 = 0; i2 < A.length; i2++) {
		r[i2] = A[i2] - B[i2];
	}
	return r;
}
function maxUnsignedGraphValue(A, outUMax) {
	const chans = outUMax.length;
	const values = A.length / chans;
	for (let i2 = 0; i2 < values; i2++) {
		for (let j = 0; j < chans; j++) {
			const a = Math.abs(A[i2 * chans + j]);
			outUMax[j] = Math.max(outUMax[j], a);
		}
	}
}
function normalizeGraph(A, uMax) {
	const chans = uMax.length;
	const values = A.length / chans;
	for (let i2 = 0; i2 < values; i2++) {
		for (let j = 0; j < chans; j++) {
			A[i2 * chans + j] /= uMax[j] === 0 ? 1 : uMax[j];
			A[i2 * chans + j] *= 0.5;
			A[i2 * chans + j] += 0.5;
		}
	}
}
function divGraphFrom2Curves(curve1, curve2, outUMax) {
	const sub = subGraph(curve2, curve1);
	maxUnsignedGraphValue(sub, outUMax);
	normalizeGraph(sub, outUMax);
	return sub;
}
var particleEmitterDeviceCache = new DeviceCache();
var ParticleEmitter = class {
	material = null;
	internalTex0 = null;
	internalTex1 = null;
	internalTex2 = null;
	colorParam = null;
	constructor(graphicsDevice, options2) {
		this.graphicsDevice = graphicsDevice;
		const gd = graphicsDevice;
		const precision = 32;
		this.precision = precision;
		this._addTimeTime = 0;
		setPropertyTarget = this;
		setPropertyOptions = options2;
		setProperty("numParticles", 1);
		if (this.numParticles > graphicsDevice.maxTextureSize) {
			this.numParticles = graphicsDevice.maxTextureSize;
		}
		setProperty("rate", 1);
		setProperty("rate2", this.rate);
		setProperty("lifetime", 50);
		setProperty("emitterExtents", new Vec3(0, 0, 0));
		setProperty("emitterExtentsInner", new Vec3(0, 0, 0));
		setProperty("emitterRadius", 0);
		setProperty("emitterRadiusInner", 0);
		setProperty("emitterShape", EMITTERSHAPE_BOX);
		setProperty("initialVelocity", 1);
		setProperty("wrap", false);
		setProperty("localSpace", false);
		setProperty("screenSpace", false);
		setProperty("wrapBounds", null);
		setProperty("colorMap", this.defaultParamTexture);
		setProperty("normalMap", null);
		setProperty("loop", true);
		setProperty("preWarm", false);
		setProperty("sort", PARTICLESORT_NONE);
		setProperty("mode", PARTICLEMODE_GPU);
		setProperty("scene", null);
		setProperty("lighting", false);
		setProperty("halfLambert", false);
		setProperty("intensity", 1);
		setProperty("stretch", 0);
		setProperty("alignToMotion", false);
		setProperty("depthSoftening", 0);
		setProperty("mesh", null);
		setProperty("particleNormal", new Vec3(0, 1, 0));
		setProperty("orientation", PARTICLEORIENTATION_SCREEN);
		setProperty("depthWrite", false);
		setProperty("noFog", false);
		setProperty("blendType", BLEND_NORMAL);
		setProperty("node", null);
		setProperty("startAngle", 0);
		setProperty("startAngle2", this.startAngle);
		setProperty("animTilesX", 1);
		setProperty("animTilesY", 1);
		setProperty("animStartFrame", 0);
		setProperty("animNumFrames", 1);
		setProperty("animNumAnimations", 1);
		setProperty("animIndex", 0);
		setProperty("randomizeAnimIndex", false);
		setProperty("animSpeed", 1);
		setProperty("animLoop", true);
		this._gpuUpdater = new ParticleGPUUpdater(this, gd);
		this._cpuUpdater = new ParticleCPUUpdater(this);
		this.emitterPosUniform = new Float32Array(3);
		this.wrapBoundsUniform = new Float32Array(3);
		this.emitterScaleUniform = new Float32Array([1, 1, 1]);
		setProperty("colorGraph", default1Curve3);
		setProperty("colorGraph2", this.colorGraph);
		setProperty("scaleGraph", default1Curve);
		setProperty("scaleGraph2", this.scaleGraph);
		setProperty("alphaGraph", default1Curve);
		setProperty("alphaGraph2", this.alphaGraph);
		setProperty("localVelocityGraph", default0Curve3);
		setProperty("localVelocityGraph2", this.localVelocityGraph);
		setProperty("velocityGraph", default0Curve3);
		setProperty("velocityGraph2", this.velocityGraph);
		setProperty("rotationSpeedGraph", default0Curve);
		setProperty("rotationSpeedGraph2", this.rotationSpeedGraph);
		setProperty("radialSpeedGraph", default0Curve);
		setProperty("radialSpeedGraph2", this.radialSpeedGraph);
		setPropertyTarget = null;
		setPropertyOptions = null;
		this.animTilesParams = new Float32Array(2);
		this.animParams = new Float32Array(4);
		this.animIndexParams = new Float32Array(2);
		this.vbToSort = null;
		this.vbOld = null;
		this.particleDistance = null;
		this.camera = null;
		this.swapTex = false;
		this.useMesh = true;
		this.useCpu = !graphicsDevice.supportsGpuParticles;
		this.localBounds = new BoundingBox();
		this.worldBoundsNoTrail = new BoundingBox();
		this.worldBoundsTrail = [new BoundingBox(), new BoundingBox()];
		this.worldBounds = new BoundingBox();
		this.worldBoundsSize = new Vec3();
		this.prevWorldBoundsSize = new Vec3();
		this.prevWorldBoundsCenter = new Vec3();
		this.prevEmitterExtents = this.emitterExtents;
		this.prevEmitterRadius = this.emitterRadius;
		this.timeToSwitchBounds = 0;
		this.shaderParticleUpdateRespawn = null;
		this.shaderParticleUpdateNoRespawn = null;
		this.shaderParticleUpdateOnStop = null;
		this.numParticleVerts = 0;
		this.numParticleIndices = 0;
		this.material = null;
		this.meshInstance = null;
		this.drawOrder = 0;
		this.seed = Math.random();
		this.fixedTimeStep = 1 / 60;
		this.maxSubSteps = 10;
		this.simTime = 0;
		this.simTimeTotal = 0;
		this.beenReset = false;
		this._layer = null;
		this.rebuild();
	}
	get defaultParamTexture() {
		return particleEmitterDeviceCache.get(this.graphicsDevice, () => {
			const resolution = 16;
			const centerPoint = resolution * 0.5 + 0.5;
			const dtex = new Float32Array(resolution * resolution * 4);
			for (let y2 = 0; y2 < resolution; y2++) {
				for (let x3 = 0; x3 < resolution; x3++) {
					const xgrad = x3 + 1 - centerPoint;
					const ygrad = y2 + 1 - centerPoint;
					const c2 = saturate2(1 - saturate2(Math.sqrt(xgrad * xgrad + ygrad * ygrad) / resolution) - 0.5);
					const p = y2 * resolution + x3;
					dtex[p * 4] = 1;
					dtex[p * 4 + 1] = 1;
					dtex[p * 4 + 2] = 1;
					dtex[p * 4 + 3] = c2;
				}
			}
			const texture = _createTexture(this.graphicsDevice, resolution, resolution, dtex, PIXELFORMAT_SRGBA8, 1, true);
			texture.minFilter = FILTER_LINEAR;
			texture.magFilter = FILTER_LINEAR;
			return texture;
		});
	}
	calculateWorldBounds() {
		if (!this.node) return;
		this.prevWorldBoundsSize.copy(this.worldBoundsSize);
		this.prevWorldBoundsCenter.copy(this.worldBounds.center);
		if (!this.useCpu) {
			let recalculateLocalBounds = false;
			if (this.emitterShape === EMITTERSHAPE_BOX) {
				recalculateLocalBounds = !this.emitterExtents.equals(this.prevEmitterExtents);
			} else {
				recalculateLocalBounds = !(this.emitterRadius === this.prevEmitterRadius);
			}
			if (recalculateLocalBounds) {
				this.calculateLocalBounds();
			}
		}
		const nodeWT = this.node.getWorldTransform();
		if (this.localSpace) {
			this.worldBoundsNoTrail.copy(this.localBounds);
		} else {
			this.worldBoundsNoTrail.setFromTransformedAabb(this.localBounds, nodeWT);
		}
		this.worldBoundsTrail[0].add(this.worldBoundsNoTrail);
		this.worldBoundsTrail[1].add(this.worldBoundsNoTrail);
		const now2 = this.simTimeTotal;
		if (now2 >= this.timeToSwitchBounds) {
			this.worldBoundsTrail[0].copy(this.worldBoundsTrail[1]);
			this.worldBoundsTrail[1].copy(this.worldBoundsNoTrail);
			this.timeToSwitchBounds = now2 + this.lifetime;
		}
		this.worldBounds.copy(this.worldBoundsTrail[0]);
		this.worldBoundsSize.copy(this.worldBounds.halfExtents).mulScalar(2);
		if (this.localSpace) {
			this.meshInstance.aabb.setFromTransformedAabb(this.worldBounds, nodeWT);
			this.meshInstance.mesh.aabb.setFromTransformedAabb(this.worldBounds, nodeWT);
		} else {
			this.meshInstance.aabb.copy(this.worldBounds);
			this.meshInstance.mesh.aabb.copy(this.worldBounds);
		}
		this.meshInstance._aabbVer = 1 - this.meshInstance._aabbVer;
	}
	resetWorldBounds() {
		if (!this.node) return;
		this.worldBoundsNoTrail.setFromTransformedAabb(
			this.localBounds,
			this.localSpace ? Mat4.IDENTITY : this.node.getWorldTransform()
		);
		this.worldBoundsTrail[0].copy(this.worldBoundsNoTrail);
		this.worldBoundsTrail[1].copy(this.worldBoundsNoTrail);
		this.worldBounds.copy(this.worldBoundsTrail[0]);
		this.worldBoundsSize.copy(this.worldBounds.halfExtents).mulScalar(2);
		this.prevWorldBoundsSize.copy(this.worldBoundsSize);
		this.prevWorldBoundsCenter.copy(this.worldBounds.center);
		this.simTimeTotal = 0;
		this.timeToSwitchBounds = 0;
	}
	calculateLocalBounds() {
		let minx = Number.MAX_VALUE;
		let miny = Number.MAX_VALUE;
		let minz = Number.MAX_VALUE;
		let maxx = -Number.MAX_VALUE;
		let maxy = -Number.MAX_VALUE;
		let maxz = -Number.MAX_VALUE;
		let maxR = 0;
		let maxScale = 0;
		const stepWeight = this.lifetime / this.precision;
		const wVels = [this.qVelocity, this.qVelocity2];
		const lVels = [this.qLocalVelocity, this.qLocalVelocity2];
		const accumX = [0, 0];
		const accumY = [0, 0];
		const accumZ = [0, 0];
		const accumR = [0, 0];
		const accumW = [0, 0];
		let x3, y2, z2;
		for (let i2 = 0; i2 < this.precision + 1; i2++) {
			const index = Math.min(i2, this.precision - 1);
			for (let j = 0; j < 2; j++) {
				x3 = lVels[j][index * 3 + 0] * stepWeight + accumX[j];
				y2 = lVels[j][index * 3 + 1] * stepWeight + accumY[j];
				z2 = lVels[j][index * 3 + 2] * stepWeight + accumZ[j];
				minx = Math.min(x3, minx);
				miny = Math.min(y2, miny);
				minz = Math.min(z2, minz);
				maxx = Math.max(x3, maxx);
				maxy = Math.max(y2, maxy);
				maxz = Math.max(z2, maxz);
				accumX[j] = x3;
				accumY[j] = y2;
				accumZ[j] = z2;
			}
			for (let j = 0; j < 2; j++) {
				accumW[j] += stepWeight * Math.sqrt(
					wVels[j][index * 3 + 0] * wVels[j][index * 3 + 0] + wVels[j][index * 3 + 1] * wVels[j][index * 3 + 1] + wVels[j][index * 3 + 2] * wVels[j][index * 3 + 2]
				);
			}
			accumR[0] += this.qRadialSpeed[index] * stepWeight;
			accumR[1] += this.qRadialSpeed2[index] * stepWeight;
			maxR = Math.max(maxR, Math.max(Math.abs(accumR[0]), Math.abs(accumR[1])));
			maxScale = Math.max(maxScale, this.qScale[index]);
		}
		if (this.emitterShape === EMITTERSHAPE_BOX) {
			x3 = this.emitterExtents.x * 0.5;
			y2 = this.emitterExtents.y * 0.5;
			z2 = this.emitterExtents.z * 0.5;
		} else {
			x3 = this.emitterRadius;
			y2 = this.emitterRadius;
			z2 = this.emitterRadius;
		}
		const w = Math.max(accumW[0], accumW[1]);
		bMin.x = minx - maxScale - x3 - maxR - w;
		bMin.y = miny - maxScale - y2 - maxR - w;
		bMin.z = minz - maxScale - z2 - maxR - w;
		bMax.x = maxx + maxScale + x3 + maxR + w;
		bMax.y = maxy + maxScale + y2 + maxR + w;
		bMax.z = maxz + maxScale + z2 + maxR + w;
		this.localBounds.setMinMax(bMin, bMax);
	}
	rebuild() {
		const gd = this.graphicsDevice;
		if (this.colorMap === null) this.colorMap = this.defaultParamTexture;
		this.spawnBounds = this.emitterShape === EMITTERSHAPE_BOX ? this.emitterExtents : this.emitterRadius;
		this.useCpu = this.useCpu || this.sort > PARTICLESORT_NONE || // force CPU if desirable by user or sorting is enabled
		gd.forceCpuParticles;
		const wasVisible = this._destroyResources();
		particleTexHeight = this.useCpu ? 4 : 2;
		this.useMesh = !!this.mesh;
		this.numParticlesPot = math.nextPowerOfTwo(this.numParticles);
		this.rebuildGraphs();
		this.calculateLocalBounds();
		this.resetWorldBounds();
		if (this.node) {
			this.worldBounds.setFromTransformedAabb(
				this.localBounds,
				this.localSpace ? Mat4.IDENTITY : this.node.getWorldTransform()
			);
			this.worldBoundsTrail[0].copy(this.worldBounds);
			this.worldBoundsTrail[1].copy(this.worldBounds);
			this.worldBoundsSize.copy(this.worldBounds.halfExtents).mulScalar(2);
			this.prevWorldBoundsSize.copy(this.worldBoundsSize);
			this.prevWorldBoundsCenter.copy(this.worldBounds.center);
		}
		this.vbToSort = new Array(this.numParticles);
		for (let iSort = 0; iSort < this.numParticles; iSort++) this.vbToSort[iSort] = [0, 0];
		this.particleDistance = new Float32Array(this.numParticles);
		this._gpuUpdater.randomize();
		this.particleTex = new Float32Array(this.numParticlesPot * particleTexHeight * particleTexChannels2);
		const emitterPos = this.node === null || this.localSpace ? Vec3.ZERO : this.node.getPosition();
		if (this.emitterShape === EMITTERSHAPE_BOX) {
			if (this.node === null || this.localSpace) {
				spawnMatrix.setTRS(Vec3.ZERO, Quat.IDENTITY, this.spawnBounds);
			} else {
				spawnMatrix.setTRS(Vec3.ZERO, this.node.getRotation(), tmpVec33.copy(this.spawnBounds).mul(this.node.localScale));
			}
			extentsInnerRatioUniform[0] = this.emitterExtents.x !== 0 ? this.emitterExtentsInner.x / this.emitterExtents.x : 0;
			extentsInnerRatioUniform[1] = this.emitterExtents.y !== 0 ? this.emitterExtentsInner.y / this.emitterExtents.y : 0;
			extentsInnerRatioUniform[2] = this.emitterExtents.z !== 0 ? this.emitterExtentsInner.z / this.emitterExtents.z : 0;
		}
		for (let i2 = 0; i2 < this.numParticles; i2++) {
			this._cpuUpdater.calcSpawnPosition(this.particleTex, spawnMatrix, extentsInnerRatioUniform, emitterPos, i2);
			if (this.useCpu) this.particleTex[i2 * particleTexChannels2 + 3 + this.numParticlesPot * 2 * particleTexChannels2] = 1;
		}
		this.particleTexStart = new Float32Array(this.numParticlesPot * particleTexHeight * particleTexChannels2);
		for (let i2 = 0; i2 < this.particleTexStart.length; i2++) {
			this.particleTexStart[i2] = this.particleTex[i2];
		}
		if (!this.useCpu) {
			const particleFormat = gd.textureFloatRenderable ? PIXELFORMAT_RGBA32F : PIXELFORMAT_RGBA32U;
			this.particleTexIN = _createTexture(gd, this.numParticlesPot, particleTexHeight, this.particleTex, particleFormat);
			this.particleTexOUT = _createTexture(gd, this.numParticlesPot, particleTexHeight, this.particleTex, particleFormat);
			this.particleTexStart = _createTexture(gd, this.numParticlesPot, particleTexHeight, this.particleTexStart, particleFormat);
			this.rtParticleTexIN = new RenderTarget({
				colorBuffer: this.particleTexIN,
				depth: false
			});
			this.rtParticleTexOUT = new RenderTarget({
				colorBuffer: this.particleTexOUT,
				depth: false
			});
			this.swapTex = false;
		}
		const defines = /* @__PURE__ */ new Map();
		if (this.localSpace) defines.set("LOCAL_SPACE", "");
		if (this.emitterShape === EMITTERSHAPE_BOX) defines.set("EMITTERSHAPE_BOX", "");
		const shaderUniqueId = `Shape:${this.emitterShape}-Local:${this.localSpace}`;
		const shaderOptions = {
			attributes: { vertex_position: SEMANTIC_POSITION },
			vertexChunk: "fullscreenQuadVS",
			fragmentChunk: "particle_simulationPS",
			fragmentDefines: defines,
			fragmentOutputTypes: gd.textureFloatRenderable ? "vec4" : "uvec4"
		};
		shaderOptions.uniqueName = `ParticleUpdateRespawn-${shaderUniqueId}`;
		defines.set("RESPAWN", "");
		this.shaderParticleUpdateRespawn = ShaderUtils.createShader(gd, shaderOptions);
		defines.delete("RESPAWN");
		shaderOptions.uniqueName = `ParticleUpdateNoRespawn-${shaderUniqueId}`;
		defines.set("NO_RESPAWN", "");
		this.shaderParticleUpdateNoRespawn = ShaderUtils.createShader(gd, shaderOptions);
		defines.delete("NO_RESPAWN");
		shaderOptions.uniqueName = `ParticleUpdateStop-${shaderUniqueId}`;
		defines.set("ON_STOP", "");
		this.shaderParticleUpdateOnStop = ShaderUtils.createShader(gd, shaderOptions);
		this.numParticleVerts = this.useMesh ? this.mesh.vertexBuffer.numVertices : 4;
		this.numParticleIndices = this.useMesh ? this.mesh.indexBuffer[0].numIndices : 6;
		this._allocate(this.numParticles);
		const mesh = new Mesh(gd);
		mesh.vertexBuffer = this.vertexBuffer;
		mesh.indexBuffer[0] = this.indexBuffer;
		mesh.primitive[0].type = PRIMITIVE_TRIANGLES;
		mesh.primitive[0].base = 0;
		mesh.primitive[0].count = this.numParticles * this.numParticleIndices;
		mesh.primitive[0].indexed = true;
		this.material = this._createMaterial();
		this.resetMaterial();
		this.meshInstance = new MeshInstance(mesh, this.material, this.node);
		this.meshInstance.pick = false;
		this.meshInstance.updateKey();
		this.meshInstance.cull = true;
		if (this.localSpace) {
			this.meshInstance.aabb.setFromTransformedAabb(this.worldBounds, this.node.getWorldTransform());
		} else {
			this.meshInstance.aabb.copy(this.worldBounds);
		}
		this.meshInstance._updateAabb = false;
		this.meshInstance.visible = wasVisible;
		this._setMaterialTextures();
		this.resetTime();
		this.addTime(0, false);
		if (this.preWarm) this.prewarm(this.lifetime);
		this.finishFrame();
	}
	_isAnimated() {
		return this.animNumFrames >= 1 && (this.animTilesX > 1 || this.animTilesY > 1) && (this.colorMap && this.colorMap !== this.defaultParamTexture || this.normalMap);
	}
	rebuildGraphs() {
		const precision = this.precision;
		const gd = this.graphicsDevice;
		this.qLocalVelocity = this.localVelocityGraph.quantize(precision);
		this.qVelocity = this.velocityGraph.quantize(precision);
		this.qColor = this.colorGraph.quantizeClamped(precision, 0, 1);
		this.qRotSpeed = this.rotationSpeedGraph.quantize(precision);
		this.qScale = this.scaleGraph.quantize(precision);
		this.qAlpha = this.alphaGraph.quantize(precision);
		this.qRadialSpeed = this.radialSpeedGraph.quantize(precision);
		this.qLocalVelocity2 = this.localVelocityGraph2.quantize(precision);
		this.qVelocity2 = this.velocityGraph2.quantize(precision);
		this.qColor2 = this.colorGraph2.quantizeClamped(precision, 0, 1);
		this.qRotSpeed2 = this.rotationSpeedGraph2.quantize(precision);
		this.qScale2 = this.scaleGraph2.quantize(precision);
		this.qAlpha2 = this.alphaGraph2.quantize(precision);
		this.qRadialSpeed2 = this.radialSpeedGraph2.quantize(precision);
		for (let i2 = 0; i2 < precision; i2++) {
			this.qRotSpeed[i2] *= math.DEG_TO_RAD;
			this.qRotSpeed2[i2] *= math.DEG_TO_RAD;
		}
		this.localVelocityUMax = new Float32Array(3);
		this.velocityUMax = new Float32Array(3);
		this.colorUMax = new Float32Array(3);
		this.rotSpeedUMax = [0];
		this.scaleUMax = [0];
		this.alphaUMax = [0];
		this.radialSpeedUMax = [0];
		this.qLocalVelocityDiv = divGraphFrom2Curves(this.qLocalVelocity, this.qLocalVelocity2, this.localVelocityUMax);
		this.qVelocityDiv = divGraphFrom2Curves(this.qVelocity, this.qVelocity2, this.velocityUMax);
		this.qColorDiv = divGraphFrom2Curves(this.qColor, this.qColor2, this.colorUMax);
		this.qRotSpeedDiv = divGraphFrom2Curves(this.qRotSpeed, this.qRotSpeed2, this.rotSpeedUMax);
		this.qScaleDiv = divGraphFrom2Curves(this.qScale, this.qScale2, this.scaleUMax);
		this.qAlphaDiv = divGraphFrom2Curves(this.qAlpha, this.qAlpha2, this.alphaUMax);
		this.qRadialSpeedDiv = divGraphFrom2Curves(this.qRadialSpeed, this.qRadialSpeed2, this.radialSpeedUMax);
		if (!this.useCpu) {
			this.internalTex0 = _createTexture(gd, precision, 1, packTextureXYZ_NXYZ(this.qLocalVelocity, this.qLocalVelocityDiv));
			this.internalTex1 = _createTexture(gd, precision, 1, packTextureXYZ_NXYZ(this.qVelocity, this.qVelocityDiv));
			this.internalTex2 = _createTexture(gd, precision, 1, packTexture5Floats(this.qRotSpeed, this.qScale, this.qScaleDiv, this.qRotSpeedDiv, this.qAlphaDiv));
			this.internalTex3 = _createTexture(gd, precision, 1, packTexture2Floats(this.qRadialSpeed, this.qRadialSpeedDiv));
		}
		this.colorParam = _createTexture(gd, precision, 1, packTextureRGBA(this.qColor, this.qAlpha), PIXELFORMAT_SRGBA8, 1, true);
	}
	_setMaterialTextures() {
		if (this.colorMap) {
			this.material.setParameter("colorMap", this.colorMap);
			if (this.lighting && this.normalMap) {
				this.material.setParameter("normalMap", this.normalMap);
			}
		}
	}
	_createMaterial() {
		const material = new ParticleMaterial(this);
		material.name = `EmitterMaterial:${this.node.name}`;
		material.cull = CULLFACE_NONE;
		material.alphaWrite = false;
		material.blendType = this.blendType;
		material.depthWrite = this.depthWrite;
		return material;
	}
	resetMaterial() {
		const material = this.material;
		material.setParameter("stretch", this.stretch);
		if (this._isAnimated()) {
			material.setParameter("animTexTilesParams", this.animTilesParams);
			material.setParameter("animTexParams", this.animParams);
			material.setParameter("animTexIndexParams", this.animIndexParams);
		}
		material.setParameter("colorMult", this.intensity);
		if (!this.useCpu) {
			material.setParameter("internalTex0", this.internalTex0);
			material.setParameter("internalTex1", this.internalTex1);
			material.setParameter("internalTex2", this.internalTex2);
			material.setParameter("internalTex3", this.internalTex3);
		}
		material.setParameter("colorParam", this.colorParam);
		material.setParameter("numParticles", this.numParticles);
		material.setParameter("numParticlesPot", this.numParticlesPot);
		material.setParameter("lifetime", this.lifetime);
		material.setParameter("rate", this.rate);
		material.setParameter("rateDiv", this.rate2 - this.rate);
		material.setParameter("seed", this.seed);
		material.setParameter("scaleDivMult", this.scaleUMax[0]);
		material.setParameter("alphaDivMult", this.alphaUMax[0]);
		material.setParameter("radialSpeedDivMult", this.radialSpeedUMax[0]);
		material.setParameter("graphNumSamples", this.precision);
		material.setParameter("graphSampleSize", 1 / this.precision);
		material.setParameter("emitterScale", new Float32Array([1, 1, 1]));
		if (this.wrap && this.wrapBounds) {
			this.wrapBoundsUniform[0] = this.wrapBounds.x;
			this.wrapBoundsUniform[1] = this.wrapBounds.y;
			this.wrapBoundsUniform[2] = this.wrapBounds.z;
			material.setParameter("wrapBounds", this.wrapBoundsUniform);
		}
		this._setMaterialTextures();
		if (this.depthSoftening > 0) {
			material.setParameter("softening", 1 / (this.depthSoftening * this.depthSoftening * 100));
		}
		if (this.stretch > 0) material.cull = CULLFACE_NONE;
		this._compParticleFaceParams();
	}
	_compParticleFaceParams() {
		let tangent, binormal;
		if (this.orientation === PARTICLEORIENTATION_SCREEN) {
			tangent = new Float32Array([1, 0, 0]);
			binormal = new Float32Array([0, 0, 1]);
		} else {
			let n;
			if (this.orientation === PARTICLEORIENTATION_WORLD) {
				n = this.particleNormal.normalize();
			} else {
				const emitterMat = this.node === null ? Mat4.IDENTITY : this.node.getWorldTransform();
				n = emitterMat.transformVector(this.particleNormal).normalize();
			}
			const t = new Vec3(1, 0, 0);
			if (Math.abs(t.dot(n)) === 1) {
				t.set(0, 0, 1);
			}
			const b = new Vec3().cross(n, t).normalize();
			t.cross(b, n).normalize();
			tangent = new Float32Array([t.x, t.y, t.z]);
			binormal = new Float32Array([b.x, b.y, b.z]);
		}
		this.material.setParameter("faceTangent", tangent);
		this.material.setParameter("faceBinorm", binormal);
	}
	getVertexInfo() {
		const elements = [];
		if (!this.useCpu) {
			elements.push({ semantic: SEMANTIC_ATTR0, components: 4, type: TYPE_FLOAT32 });
			if (this.useMesh) {
				elements.push({ semantic: SEMANTIC_TEXCOORD0, components: 2, type: TYPE_FLOAT32 });
			}
		} else {
			elements.push(
				{ semantic: SEMANTIC_ATTR0, components: 4, type: TYPE_FLOAT32 },
				{ semantic: SEMANTIC_ATTR1, components: 4, type: TYPE_FLOAT32 },
				{ semantic: SEMANTIC_ATTR2, components: 4, type: TYPE_FLOAT32 },
				{ semantic: SEMANTIC_ATTR3, components: 1, type: TYPE_FLOAT32 },
				{ semantic: SEMANTIC_ATTR4, components: this.useMesh ? 4 : 2, type: TYPE_FLOAT32 }
			);
		}
		return elements;
	}
	// Declares vertex format, creates VB and IB
	_allocate(numParticles) {
		const psysVertCount = numParticles * this.numParticleVerts;
		const psysIndexCount = numParticles * this.numParticleIndices;
		if (this.vertexBuffer === void 0 || this.vertexBuffer.getNumVertices() !== psysVertCount) {
			const elements = this.getVertexInfo();
			const vertexFormat = new VertexFormat(this.graphicsDevice, elements);
			this.vertexBuffer = new VertexBuffer(this.graphicsDevice, vertexFormat, psysVertCount, {
				usage: BUFFER_DYNAMIC
			});
			this.indexBuffer = new IndexBuffer(this.graphicsDevice, INDEXFORMAT_UINT32, psysIndexCount);
			const data2 = new Float32Array(this.vertexBuffer.lock());
			let meshData, posOffset, posStride, uvOffset, uvStride;
			if (this.useMesh) {
				meshData = new Float32Array(this.mesh.vertexBuffer.lock());
				const elements2 = this.mesh.vertexBuffer.format.elements;
				const posElement = elements2.find((el) => el.name === SEMANTIC_POSITION);
				const uvElement = elements2.find((el) => el.name === SEMANTIC_TEXCOORD0);
				posOffset = posElement.offset / 4;
				posStride = posElement.stride / 4;
				uvOffset = uvElement ? uvElement.offset / 4 : -1;
				uvStride = uvElement ? uvElement.stride / 4 : 0;
			}
			for (let i2 = 0; i2 < psysVertCount; i2++) {
				const id14 = Math.floor(i2 / this.numParticleVerts);
				if (!this.useMesh) {
					const vertID = i2 % 4;
					data2[i2 * 4] = particleVerts[vertID][0];
					data2[i2 * 4 + 1] = particleVerts[vertID][1];
					data2[i2 * 4 + 2] = 0;
					data2[i2 * 4 + 3] = id14;
				} else {
					const vert = i2 % this.numParticleVerts;
					const posIndex = vert * posStride + posOffset;
					data2[i2 * 6] = meshData[posIndex];
					data2[i2 * 6 + 1] = meshData[posIndex + 1];
					data2[i2 * 6 + 2] = meshData[posIndex + 2];
					data2[i2 * 6 + 3] = id14;
					if (uvOffset >= 0) {
						const uvIndex = vert * uvStride + uvOffset;
						data2[i2 * 6 + 4] = meshData[uvIndex];
						data2[i2 * 6 + 5] = 1 - meshData[uvIndex + 1];
					} else {
						data2[i2 * 6 + 4] = 0;
						data2[i2 * 6 + 5] = 0;
					}
				}
			}
			if (this.useCpu) {
				this.vbCPU = new Float32Array(data2);
				this.vbOld = new Float32Array(this.vbCPU.length);
			}
			this.vertexBuffer.unlock();
			if (this.useMesh) {
				this.mesh.vertexBuffer.unlock();
			}
			let dst = 0;
			const indices = new Uint32Array(this.indexBuffer.lock());
			if (this.useMesh) {
				const ib = this.mesh.indexBuffer[0];
				meshData = new typedArrayIndexFormats[ib.format](ib.lock());
			}
			for (let i2 = 0; i2 < numParticles; i2++) {
				if (!this.useMesh) {
					const baseIndex = i2 * 4;
					indices[dst++] = baseIndex;
					indices[dst++] = baseIndex + 1;
					indices[dst++] = baseIndex + 2;
					indices[dst++] = baseIndex;
					indices[dst++] = baseIndex + 2;
					indices[dst++] = baseIndex + 3;
				} else {
					for (let j = 0; j < this.numParticleIndices; j++) {
						indices[i2 * this.numParticleIndices + j] = meshData[j] + i2 * this.numParticleVerts;
					}
				}
			}
			this.indexBuffer.unlock();
			if (this.useMesh) this.mesh.indexBuffer[0].unlock();
		}
	}
	reset() {
		this.beenReset = true;
		this.seed = Math.random();
		this.material.setParameter("seed", this.seed);
		if (this.useCpu) {
			for (let i2 = 0; i2 < this.particleTexStart.length; i2++) {
				this.particleTex[i2] = this.particleTexStart[i2];
			}
		} else {
			this._setMaterialTextures();
		}
		this.resetWorldBounds();
		this.resetTime();
		const origLoop = this.loop;
		this.loop = true;
		this.addTime(0, false);
		this.loop = origLoop;
		if (this.preWarm) {
			this.prewarm(this.lifetime);
		}
		this.finishFrame();
	}
	prewarm(time) {
		const lifetimeFraction = time / this.lifetime;
		const iterations = Math.min(Math.floor(lifetimeFraction * this.precision), this.precision);
		const stepDelta = time / iterations;
		for (let i2 = 0; i2 < iterations; i2++) {
			this.addTime(stepDelta, false);
		}
	}
	resetTime(duration = calcSpawnDuration(this)) {
		this.endTime = this.simTimeTotal + duration;
	}
	finishFrame() {
		if (this.useCpu) this.vertexBuffer.unlock();
	}
	addTime(delta3, isOnStop) {
		const device = this.graphicsDevice;
		this.simTimeTotal += delta3;
		this.calculateWorldBounds();
		if (this._isAnimated()) {
			const tilesParams = this.animTilesParams;
			tilesParams[0] = 1 / this.animTilesX;
			tilesParams[1] = 1 / this.animTilesY;
			const params = this.animParams;
			params[0] = this.animStartFrame;
			params[1] = this.animNumFrames * this.animSpeed;
			params[2] = this.animNumFrames - 1;
			params[3] = this.animNumAnimations - 1;
			const animIndexParams = this.animIndexParams;
			animIndexParams[0] = this.animIndex;
			animIndexParams[1] = this.randomizeAnimIndex;
		}
		if (this.scene) {
			this.camera = this.scene._activeCamera;
		}
		if (this.emitterShape === EMITTERSHAPE_BOX) {
			extentsInnerRatioUniform[0] = this.emitterExtents.x !== 0 ? this.emitterExtentsInner.x / this.emitterExtents.x : 0;
			extentsInnerRatioUniform[1] = this.emitterExtents.y !== 0 ? this.emitterExtentsInner.y / this.emitterExtents.y : 0;
			extentsInnerRatioUniform[2] = this.emitterExtents.z !== 0 ? this.emitterExtentsInner.z / this.emitterExtents.z : 0;
			if (this.meshInstance.node === null) {
				spawnMatrix.setTRS(Vec3.ZERO, Quat.IDENTITY, this.emitterExtents);
			} else {
				spawnMatrix.setTRS(Vec3.ZERO, this.meshInstance.node.getRotation(), tmpVec33.copy(this.emitterExtents).mul(this.meshInstance.node.localScale));
			}
		}
		let emitterPos;
		const emitterScale = this.meshInstance.node === null ? Vec3.ONE : this.meshInstance.node.localScale;
		this.emitterScaleUniform[0] = emitterScale.x;
		this.emitterScaleUniform[1] = emitterScale.y;
		this.emitterScaleUniform[2] = emitterScale.z;
		this.material.setParameter("emitterScale", this.emitterScaleUniform);
		if (this.localSpace && this.meshInstance.node) {
			emitterPos = this.meshInstance.node.getPosition();
			this.emitterPosUniform[0] = emitterPos.x;
			this.emitterPosUniform[1] = emitterPos.y;
			this.emitterPosUniform[2] = emitterPos.z;
			this.material.setParameter("emitterPos", this.emitterPosUniform);
		}
		this._compParticleFaceParams();
		if (!this.useCpu) {
			this._gpuUpdater.update(device, spawnMatrix, extentsInnerRatioUniform, delta3, isOnStop);
		} else {
			const data2 = new Float32Array(this.vertexBuffer.lock());
			this._cpuUpdater.update(data2, this.vbToSort, this.particleTex, spawnMatrix, extentsInnerRatioUniform, emitterPos, delta3, isOnStop);
		}
		if (!this.loop) {
			if (this.simTimeTotal > this.endTime) {
				if (this.onFinished) this.onFinished();
				this.meshInstance.visible = false;
			}
		}
		if (this.meshInstance) {
			this.meshInstance.drawOrder = this.drawOrder;
		}
	}
	_destroyResources() {
		this.particleTexIN?.destroy();
		this.particleTexIN = null;
		this.particleTexOUT?.destroy();
		this.particleTexOUT = null;
		if (this.particleTexStart && this.particleTexStart.destroy) {
			this.particleTexStart.destroy();
			this.particleTexStart = null;
		}
		this.rtParticleTexIN?.destroy();
		this.rtParticleTexIN = null;
		this.rtParticleTexOUT?.destroy();
		this.rtParticleTexOUT = null;
		this.internalTex0?.destroy();
		this.internalTex0 = null;
		this.internalTex1?.destroy();
		this.internalTex1 = null;
		this.internalTex2?.destroy();
		this.internalTex2 = null;
		this.internalTex3?.destroy();
		this.internalTex3 = null;
		this.colorParam?.destroy();
		this.colorParam = null;
		this.vertexBuffer = void 0;
		this.indexBuffer = void 0;
		const wasVisible = this.meshInstance?.visible ?? true;
		this.meshInstance?.destroy();
		this.meshInstance = null;
		this.material?.destroy();
		this.material = null;
		return wasVisible;
	}
	destroy() {
		this.camera = null;
		this._destroyResources();
	}
};

var ShaderGeneratorShader = class extends ShaderGenerator {
	generateKey(options2) {
		const desc = options2.shaderDesc;
		const vsHashGLSL = desc.vertexGLSL ? hashCode(desc.vertexGLSL) : 0;
		const fsHashGLSL = desc.fragmentGLSL ? hashCode(desc.fragmentGLSL) : 0;
		const vsHashWGSL = desc.vertexWGSL ? hashCode(desc.vertexWGSL) : 0;
		const fsHashWGSL = desc.fragmentWGSL ? hashCode(desc.fragmentWGSL) : 0;
		const definesHash = ShaderGenerator.definesHash(options2.defines);
		const chunksKey = options2.shaderChunks?.key ?? "";
		let key = `${desc.uniqueName}_${definesHash}_${vsHashGLSL}_${fsHashGLSL}_${vsHashWGSL}_${fsHashWGSL}_${chunksKey}`;
		if (options2.skin) key += "_skin";
		if (options2.useInstancing) key += "_inst";
		if (options2.useMorphPosition) key += "_morphp";
		if (options2.useMorphNormal) key += "_morphn";
		if (options2.useMorphTextureBasedInt) key += "_morphi";
		return key;
	}
	createAttributesDefinition(definitionOptions, options2) {
		const srcAttributes = options2.shaderDesc.attributes;
		const attributes = srcAttributes ? { ...srcAttributes } : void 0;
		if (options2.skin) {
			attributes.vertex_boneWeights = SEMANTIC_BLENDWEIGHT;
			attributes.vertex_boneIndices = SEMANTIC_BLENDINDICES;
		}
		if (options2.useMorphPosition || options2.useMorphNormal) {
			attributes.morph_vertex_id = SEMANTIC_ATTR15;
		}
		definitionOptions.attributes = attributes;
	}
	addSharedDefines(defines, options2) {
		if (options2.skin) defines.set("SKIN", true);
		if (options2.useInstancing) defines.set("INSTANCING", true);
		if (options2.useMorphPosition || options2.useMorphNormal) {
			defines.set("MORPHING", true);
			if (options2.useMorphTextureBasedInt) defines.set("MORPHING_INT", true);
			if (options2.useMorphPosition) defines.set("MORPHING_POSITION", true);
			if (options2.useMorphNormal) defines.set("MORPHING_NORMAL", true);
		}
	}
	createVertexDefinition(definitionOptions, options2, sharedIncludes, wgsl) {
		const desc = options2.shaderDesc;
		const includes = new Map(sharedIncludes);
		includes.set("transformInstancingVS", "");
		const defines = new Map(options2.defines);
		this.addSharedDefines(defines, options2);
		definitionOptions.vertexCode = wgsl ? desc.vertexWGSL : desc.vertexGLSL;
		definitionOptions.vertexIncludes = includes;
		definitionOptions.vertexDefines = defines;
	}
	createFragmentDefinition(definitionOptions, options2, sharedIncludes, wgsl) {
		const desc = options2.shaderDesc;
		const includes = new Map(sharedIncludes);
		const defines = new Map(options2.defines);
		this.addSharedDefines(defines, options2);
		definitionOptions.fragmentCode = wgsl ? desc.fragmentWGSL : desc.fragmentGLSL;
		definitionOptions.fragmentIncludes = includes;
		definitionOptions.fragmentDefines = defines;
	}
	createShaderDefinition(device, options2) {
		const desc = options2.shaderDesc;
		const wgsl = device.isWebGPU && !!desc.vertexWGSL && !!desc.fragmentWGSL && (options2.shaderChunks?.useWGSL ?? true);
		const definitionOptions = {
			name: `ShaderMaterial-${desc.uniqueName}`,
			shaderLanguage: wgsl ? SHADERLANGUAGE_WGSL : SHADERLANGUAGE_GLSL,
			fragmentOutputTypes: desc.fragmentOutputTypes,
			meshUniformBufferFormat: desc.meshUniformBufferFormat,
			meshBindGroupFormat: desc.meshBindGroupFormat
		};
		const shaderLanguage = wgsl ? SHADERLANGUAGE_WGSL : SHADERLANGUAGE_GLSL;
		const sharedIncludes = MapUtils.merge(
			ShaderChunks.get(device, shaderLanguage),
			options2.shaderChunks[shaderLanguage]
		);
		this.createAttributesDefinition(definitionOptions, options2);
		this.createVertexDefinition(definitionOptions, options2, sharedIncludes, wgsl);
		this.createFragmentDefinition(definitionOptions, options2, sharedIncludes, wgsl);
		return ShaderDefinitionUtils.createDefinition(device, definitionOptions);
	}
};
var shaderGeneratorShader = new ShaderGeneratorShader();

var ShaderMaterial = class extends Material {
	_shaderDesc;
	constructor(shaderDesc) {
		super();
		this.shaderDesc = shaderDesc;
	}
	set shaderDesc(value) {
		this._shaderDesc = void 0;
		if (value) {
			this._shaderDesc = {
				uniqueName: value.uniqueName,
				attributes: value.attributes,
				fragmentOutputTypes: value.fragmentOutputTypes,
				vertexGLSL: value.vertexGLSL,
				fragmentGLSL: value.fragmentGLSL,
				vertexWGSL: value.vertexWGSL,
				fragmentWGSL: value.fragmentWGSL
			};
			if (value.vertexCode || value.fragmentCode || value.shaderLanguage) {
				const language = value.shaderLanguage ?? SHADERLANGUAGE_GLSL;
				if (language === SHADERLANGUAGE_GLSL) {
					this._shaderDesc.vertexGLSL = value.vertexCode;
					this._shaderDesc.fragmentGLSL = value.fragmentCode;
				} else if (language === SHADERLANGUAGE_WGSL) {
					this._shaderDesc.vertexWGSL = value.vertexCode;
					this._shaderDesc.fragmentWGSL = value.fragmentCode;
				}
			}
		}
		this.clearVariants();
	}
	get shaderDesc() {
		return this._shaderDesc;
	}
	copy(source) {
		super.copy(source);
		this.shaderDesc = source.shaderDesc;
		return this;
	}
	getShaderVariant(params) {
		const { objDefs } = params;
		const options2 = {
			defines: ShaderUtils.getCoreDefines(this, params),
			skin: (objDefs & SHADERDEF_SKIN) !== 0,
			useInstancing: (objDefs & SHADERDEF_INSTANCING) !== 0,
			useMorphPosition: (objDefs & SHADERDEF_MORPH_POSITION) !== 0,
			useMorphNormal: (objDefs & SHADERDEF_MORPH_NORMAL) !== 0,
			useMorphTextureBasedInt: (objDefs & SHADERDEF_MORPH_TEXTURE_BASED_INT) !== 0,
			pass: params.pass,
			gamma: params.cameraShaderParams.shaderOutputGamma,
			toneMapping: params.cameraShaderParams.toneMapping,
			fog: params.cameraShaderParams.fog,
			shaderDesc: this.shaderDesc,
			shaderChunks: this.shaderChunks
			// override chunks from the material
		};
		const processingOptions = new ShaderProcessorOptions(params.viewUniformFormat, params.vertexFormat);
		const library = getProgramLibrary(params.device);
		library.register("shader-material", shaderGeneratorShader);
		return library.getProgram("shader-material", options2, processingOptions, this.userId);
	}
};

var gsplatStreamDecl_default = `
uniform highp {sampler} {name};
{returnType} load{funcName}() { return texelFetch({name}, splat.uv, 0); }
{returnType} load{funcName}WithIndex(uint index) { return texelFetch({name}, ivec2(index % splatTextureSize, index / splatTextureSize), 0); }
`;

var gsplatStreamDecl_default2 = `
var {name}: {textureType};
fn load{funcName}() -> {returnType} { return textureLoad({name}, splat.uv, 0); }
fn load{funcName}WithIndex(index: u32) -> {returnType} { return textureLoad({name}, vec2i(i32(index % uniform.splatTextureSize), i32(index / uniform.splatTextureSize)), 0); }
`;

var gsplatComputeStreamDecl_default = `
@group(0) @binding({binding}) var {name}: {textureType};
fn load{funcName}() -> {returnType} { return textureLoad({name}, splat.uv, 0); }
fn load{funcName}WithIndex(index: u32) -> {returnType} { return textureLoad({name}, vec2i(i32(index % uniforms.splatTextureSize), i32(index / uniforms.splatTextureSize)), 0); }
`;

var gsplatStreamOutput_default = `
void write{funcName}({returnType} value) {
#if {defineGuard}
	pcFragColor{index} = value;
#endif
}
`;

var gsplatStreamOutput_default2 = `
fn write{funcName}(value: {returnType}) {
#if {defineGuard}
	processOutput.{colorSlot} = value;
#endif
}
`;

var containerFloatRead_default = `
vec3 getCenter() { return loadDataCenter().xyz; }
vec4 getColor() { return loadDataColor(); }
vec3 getScale() { return loadDataScale().xyz; }
vec4 getRotation() { return loadDataRotation(); }
`;

var containerFloatRead_default2 = `
fn getCenter() -> vec3f { return loadDataCenter().xyz; }
fn getColor() -> vec4f { return loadDataColor(); }
fn getScale() -> vec3f { return loadDataScale().xyz; }
fn getRotation() -> vec4f { return loadDataRotation(); }
`;

var containerSimpleRead_default = `
	vec3 getCenter() { return loadDataCenter().xyz; }
	vec4 getColor() { return loadDataColor(); }
	vec3 getScale() { return vec3(loadDataCenter().w); }
	vec4 getRotation() { return vec4(0.0, 0.0, 0.0, 1.0); }
`;

var containerSimpleRead_default2 = `
	fn getCenter() -> vec3f { return loadDataCenter().xyz; }
	fn getColor() -> vec4f { return loadDataColor(); }
	fn getScale() -> vec3f { return vec3f(loadDataCenter().w); }
	fn getRotation() -> vec4f { return vec4f(0.0, 0.0, 0.0, 1.0); }
`;

var serializeStreams = (streams) => streams.map((s2) => `${s2.name}:${s2.format}:${s2.storage}`).join(",");
var RE_NAME = /\{name\}/g;
var RE_SAMPLER = /\{sampler\}/g;
var RE_TEXTURE_TYPE = /\{textureType\}/g;
var RE_RETURN_TYPE = /\{returnType\}/g;
var RE_FUNC_NAME = /\{funcName\}/g;
var RE_BINDING = /\{binding\}/g;
var RE_INDEX = /\{index\}/g;
var RE_COLOR_SLOT = /\{colorSlot\}/g;
var RE_DEFINE_GUARD = /\{defineGuard\}/g;
var GSplatFormat = class _GSplatFormat {
	_device;
	streams;
	_read;
	allowStreamRemoval = false;
	dataFormat = null;
	_extraStreams = [];
	_streamNames = /* @__PURE__ */ new Set();
	_extraStreamsVersion = 0;
	_hash;
	_resourceStreams = null;
	_instanceStreams = null;
	constructor(device, streams, options2) {
		this._device = device;
		this.streams = [...streams];
		this._streamNames = new Set(this.streams.map((s2) => s2.name));
		const isWebGPU = device.isWebGPU;
		this._read = isWebGPU ? options2.readWGSL : options2.readGLSL;
	}
	get hash() {
		if (this._hash === void 0) {
			const streamsStr = serializeStreams(this.streams);
			const extraStr = serializeStreams(this._extraStreams);
			this._hash = hashCode(
				streamsStr + extraStr + this._read
			);
		}
		return this._hash;
	}
	get extraStreamsVersion() {
		return this._extraStreamsVersion;
	}
	get extraStreams() {
		return this._extraStreams;
	}
	get resourceStreams() {
		if (this._resourceStreams === null) {
			this._resourceStreams = [
				...this.streams.filter((s2) => s2.storage !== GSPLAT_STREAM_INSTANCE),
				...this._extraStreams.filter((s2) => s2.storage !== GSPLAT_STREAM_INSTANCE)
			];
		}
		return this._resourceStreams;
	}
	get instanceStreams() {
		if (this._instanceStreams === null) {
			this._instanceStreams = this._extraStreams.filter((s2) => s2.storage === GSPLAT_STREAM_INSTANCE);
		}
		return this._instanceStreams;
	}
	addExtraStreams(streams) {
		if (!streams || streams.length === 0) return;
		let added = false;
		for (const s2 of streams) {
			if (this._streamNames.has(s2.name)) {
				continue;
			}
			this._extraStreams.push({
				name: s2.name,
				format: s2.format,
				storage: s2.storage ?? GSPLAT_STREAM_RESOURCE
			});
			this._streamNames.add(s2.name);
			added = true;
		}
		if (added) {
			this._extraStreamsVersion++;
			this._invalidateCaches();
		}
	}
	removeExtraStreams(names) {
		if (!this.allowStreamRemoval) {
			return;
		}
		let removed = false;
		for (const name of names) {
			const idx = this._extraStreams.findIndex((s2) => s2.name === name);
			if (idx !== -1) {
				this._extraStreams.splice(idx, 1);
				this._streamNames.delete(name);
				removed = true;
			}
		}
		if (removed) {
			this._extraStreamsVersion++;
			this._invalidateCaches();
		}
	}
	getInputDeclarations(streamNames) {
		const isWebGPU = this._device.isWebGPU;
		const template = isWebGPU ? gsplatStreamDecl_default2 : gsplatStreamDecl_default;
		const getShaderType = isWebGPU ? getWgslShaderType : getGlslShaderType;
		const lines = [];
		let streams = [...this.streams, ...this._extraStreams];
		if (streamNames) {
			streams = streams.filter((s2) => streamNames.includes(s2.name));
		}
		for (const stream of streams) {
			const info = getShaderType(stream.format);
			const funcName = stream.name.charAt(0).toUpperCase() + stream.name.slice(1);
			let textureType = info.textureType ?? "";
			if (isWebGPU && stream.format === PIXELFORMAT_RGBA32F) {
				textureType = "texture_2d<uff>";
			}
			const decl = template.replace(RE_NAME, stream.name).replace(RE_SAMPLER, info.sampler ?? "").replace(RE_TEXTURE_TYPE, textureType).replace(RE_RETURN_TYPE, info.returnType).replace(RE_FUNC_NAME, funcName);
			lines.push(decl);
		}
		return lines.join("\n");
	}
	getReadCode() {
		return this._read;
	}
	getComputeInputDeclarations(startBinding, streamNames) {
		const lines = [];
		let streams = [...this.streams, ...this._extraStreams];
		if (streamNames) {
			streams = streams.filter((s2) => streamNames.includes(s2.name));
		}
		for (let i2 = 0; i2 < streams.length; i2++) {
			const stream = streams[i2];
			const info = getWgslShaderType(stream.format);
			const funcName = stream.name.charAt(0).toUpperCase() + stream.name.slice(1);
			let textureType = info.textureType ?? "";
			if (stream.format === PIXELFORMAT_RGBA32F) {
				textureType = "texture_2d<uff>";
			}
			const decl = gsplatComputeStreamDecl_default.replace(RE_BINDING, String(startBinding + i2)).replace(RE_NAME, stream.name).replace(RE_TEXTURE_TYPE, textureType).replace(RE_RETURN_TYPE, info.returnType).replace(RE_FUNC_NAME, funcName);
			lines.push(decl);
		}
		return lines.join("\n");
	}
	getComputeBindFormats(streamNames) {
		let streams = [...this.streams, ...this._extraStreams];
		if (streamNames) {
			streams = streams.filter((s2) => streamNames.includes(s2.name));
		}
		return streams.map((stream) => {
			const info = pixelFormatInfo.get(stream.format);
			let sampleType = SAMPLETYPE_FLOAT;
			if (info?.isUint) sampleType = SAMPLETYPE_UINT;
			else if (info?.isInt) sampleType = SAMPLETYPE_INT;
			return new BindTextureFormat(stream.name, SHADERSTAGE_COMPUTE, void 0, sampleType, false);
		});
	}
	setWriteCode(writeGLSL, writeWGSL) {
		this._write = this._device.isWebGPU ? writeWGSL : writeGLSL;
	}
	getWriteCode() {
		return this._write;
	}
	getOutputDeclarations(outputStreams) {
		const isWebGPU = this._device.isWebGPU;
		const lines = [];
		const template = isWebGPU ? gsplatStreamOutput_default2 : gsplatStreamOutput_default;
		const getShaderType = isWebGPU ? getWgslShaderType : getGlslShaderType;
		for (let i2 = 0; i2 < outputStreams.length; i2++) {
			const stream = outputStreams[i2];
			const info = getShaderType(stream.format);
			const funcName = stream.name.charAt(0).toUpperCase() + stream.name.slice(1);
			const colorSlot = i2 === 0 ? "color" : `color${i2}`;
			const decl = template.replace(RE_FUNC_NAME, funcName).replace(RE_RETURN_TYPE, info.returnType).replace(RE_INDEX, String(i2)).replace(RE_COLOR_SLOT, colorSlot).replace(RE_DEFINE_GUARD, "1");
			lines.push(decl);
		}
		return lines.join("\n");
	}
	getOutputStubs(streams) {
		const isWebGPU = this._device.isWebGPU;
		const lines = [];
		const template = isWebGPU ? gsplatStreamOutput_default2 : gsplatStreamOutput_default;
		const getShaderType = isWebGPU ? getWgslShaderType : getGlslShaderType;
		for (const stream of streams) {
			const info = getShaderType(stream.format);
			const funcName = stream.name.charAt(0).toUpperCase() + stream.name.slice(1);
			const stub = template.replace(RE_FUNC_NAME, funcName).replace(RE_RETURN_TYPE, info.returnType).replace(RE_DEFINE_GUARD, "0");
			lines.push(stub);
		}
		return lines.join("\n");
	}
	getStream(name) {
		let stream = this.streams.find((s2) => s2.name === name);
		if (!stream) {
			stream = this._extraStreams.find((s2) => s2.name === name);
		}
		return stream;
	}
	_invalidateCaches() {
		this._hash = void 0;
		this._resourceStreams = null;
		this._instanceStreams = null;
	}
	static createDefaultFormat(device) {
		return new _GSplatFormat(device, [
			{ name: "dataColor", format: PIXELFORMAT_RGBA16F },
			{ name: "dataCenter", format: PIXELFORMAT_RGBA32F },
			{ name: "dataScale", format: PIXELFORMAT_RGBA16F },
			{ name: "dataRotation", format: PIXELFORMAT_RGBA16F }
		], {
			readGLSL: containerFloatRead_default,
			readWGSL: containerFloatRead_default2
		});
	}
	static createSimpleFormat(device) {
		return new _GSplatFormat(device, [
			{ name: "dataCenter", format: PIXELFORMAT_RGBA32F },
			{ name: "dataColor", format: PIXELFORMAT_RGBA16F }
		], {
			readGLSL: containerSimpleRead_default,
			readWGSL: containerSimpleRead_default2
		});
	}
};

var CACHE_STRIDE = 8;

var gsplatVaryingDeclVS_default = `
flat varying {type} user_{name};
void set{funcName}({type} value) { user_{name} = value; }
`;

var gsplatVaryingDeclPS_default = `
flat varying {type} user_{name};
{type} get{funcName}() { return user_{name}; }
`;

var gsplatVaryingDeclVS_default2 = `
varying @interpolate(flat) user_{name}: {type};
var<private> _user_{name}: {type};
fn set{funcName}(value: {type}) { _user_{name} = value; }
`;

var gsplatVaryingFlushVS_default = `
output.user_{name} = _user_{name};
`;

var gsplatVaryingDeclCS_default = `
var<private> _user_{name}: {type};
fn set{funcName}(value: {type}) { _user_{name} = value; }
`;

var gsplatVaryingDeclPS_default2 = `
varying @interpolate(flat) user_{name}: {type};
fn get{funcName}() -> {type} { return user_{name}; }
`;

var gsplatVaryingCacheWriteCS_default = `
projCache[base + {word}u] = {value};
`;

var gsplatVaryingCacheReadVS_default = `
output.user_{name} = {value};
`;

var GLSL_TYPES = {
	[TYPE_FLOAT32]: ["float", "vec2", "vec3", "vec4"],
	[TYPE_INT32]: ["int", "ivec2", "ivec3", "ivec4"],
	[TYPE_UINT32]: ["uint", "uvec2", "uvec3", "uvec4"]
};
var WGSL_TYPES = {
	[TYPE_FLOAT32]: ["f32", "vec2f", "vec3f", "vec4f"],
	[TYPE_INT32]: ["i32", "vec2i", "vec3i", "vec4i"],
	[TYPE_UINT32]: ["u32", "vec2u", "vec3u", "vec4u"]
};
var COMPONENT_SWIZZLE = ["x", "y", "z", "w"];
var RE_NAME2 = /\{name\}/g;
var RE_TYPE = /\{type\}/g;
var RE_FUNC_NAME2 = /\{funcName\}/g;
var RE_WORD = /\{word\}/g;
var RE_VALUE = /\{value\}/g;
var GLSL_CHUNK_NAMES = ["gsplatUserVaryingsVS", "gsplatUserVaryingsPS"];
var WGSL_CHUNK_NAMES = [
	"gsplatUserVaryingsVS",
	"gsplatUserVaryingsFlushVS",
	"gsplatUserVaryingsCS",
	"gsplatUserVaryingsPS",
	"gsplatUserCacheWriteCS",
	"gsplatUserCacheReadVS"
];
var pascal = (name) => name.charAt(0).toUpperCase() + name.slice(1);
var encodeWord = (type, expr) => {
	return type === TYPE_UINT32 ? expr : `bitcast<u32>(${expr})`;
};
var decodeWord = (type, expr) => {
	if (type === TYPE_UINT32) return expr;
	return type === TYPE_INT32 ? `bitcast<i32>(${expr})` : `bitcast<f32>(${expr})`;
};
var GSplatVaryings = class {
	_device;
	_streams = [];
	_words = 0;
	_version = 0;
	constructor(device) {
		this._device = device;
	}
	get streams() {
		return this._streams;
	}
	get words() {
		return this._words;
	}
	get version() {
		return this._version;
	}
	add(streams) {
		for (const s2 of streams) {
			this._streams.push({ name: s2.name, type: s2.type, components: s2.components });
		}
		this._changed();
	}
	remove(names) {
		const count = this._streams.length;
		this._streams = this._streams.filter((v6) => !names.includes(v6.name));
		if (this._streams.length !== count) {
			this._changed();
		}
	}
	_changed() {
		this._words = this._streams.reduce((sum, s2) => sum + s2.components, 0);
		this._version++;
	}
	_generateChunks() {
		const isWebGPU = this._device.isWebGPU;
		const types = isWebGPU ? WGSL_TYPES : GLSL_TYPES;
		const declVSTemplate = isWebGPU ? gsplatVaryingDeclVS_default2 : gsplatVaryingDeclVS_default;
		const declPSTemplate = isWebGPU ? gsplatVaryingDeclPS_default2 : gsplatVaryingDeclPS_default;
		const vs = [];
		const ps = [];
		const flush = [];
		const cs = [];
		const cacheWrite = [];
		const cacheRead = [];
		let wordOffset = 0;
		for (const s2 of this._streams) {
			const { name, type, components: components2 } = s2;
			const shaderType = types[type][components2 - 1];
			const funcName = pascal(name);
			const sub = (template) => template.replace(RE_NAME2, name).replace(RE_TYPE, shaderType).replace(RE_FUNC_NAME2, funcName);
			vs.push(sub(declVSTemplate));
			ps.push(sub(declPSTemplate));
			if (isWebGPU) {
				flush.push(sub(gsplatVaryingFlushVS_default));
				cs.push(sub(gsplatVaryingDeclCS_default));
				const words = [];
				for (let c2 = 0; c2 < components2; c2++) {
					const component = components2 === 1 ? `_user_${name}` : `_user_${name}.${COMPONENT_SWIZZLE[c2]}`;
					cacheWrite.push(gsplatVaryingCacheWriteCS_default.replace(RE_WORD, String(CACHE_STRIDE + wordOffset + c2)).replace(RE_VALUE, encodeWord(type, component)));
					words.push(decodeWord(type, `projCache[base + ${CACHE_STRIDE + wordOffset + c2}u]`));
				}
				cacheRead.push(gsplatVaryingCacheReadVS_default.replace(RE_NAME2, name).replace(RE_VALUE, components2 === 1 ? words[0] : `${shaderType}(${words.join(", ")})`));
			}
			wordOffset += components2;
		}
		const chunks = {
			gsplatUserVaryingsVS: vs.join(""),
			gsplatUserVaryingsPS: ps.join("")
		};
		if (isWebGPU) {
			chunks.gsplatUserVaryingsFlushVS = flush.join("");
			chunks.gsplatUserVaryingsCS = cs.join("");
			chunks.gsplatUserCacheWriteCS = cacheWrite.join("");
			chunks.gsplatUserCacheReadVS = cacheRead.join("");
		}
		return chunks;
	}
	apply(material) {
		const isWebGPU = this._device.isWebGPU;
		const chunks = material.getShaderChunks(isWebGPU ? SHADERLANGUAGE_WGSL : SHADERLANGUAGE_GLSL);
		material.setDefine("GSPLAT_USER_VARYINGS", this._streams.length > 0);
		if (this._streams.length > 0) {
			const sources = this._generateChunks();
			for (const name in sources) {
				chunks.set(name, sources[name]);
			}
		} else {
			const names = isWebGPU ? WGSL_CHUNK_NAMES : GLSL_CHUNK_NAMES;
			names.forEach((name) => chunks.delete(name));
		}
		material.update();
	}
};

var containerCompactRead_default = `
uvec4 cachedTransformA;
vec3 getCenter() {
	cachedTransformA = loadDataTransformA();
	return vec3(uintBitsToFloat(cachedTransformA.r), uintBitsToFloat(cachedTransformA.g), uintBitsToFloat(cachedTransformA.b));
}
float getOpacity() {
	return float(cachedTransformA.a >> 24u) / 255.0;
}
vec3 getColor() {
	uint data = loadDataColor().x;
	float r = float(data & 0x7FFu) * (4.0 / 2047.0);
	float g = float((data >> 11u) & 0x7FFu) * (4.0 / 2047.0);
	float b = float((data >> 22u) & 0x3FFu) * (4.0 / 1023.0);
	return vec3(r, g, b);
}
vec4 getRotation() {
	uint data = loadDataTransformB().x;
	vec3 p = vec3(
		float(data & 0x7FFu) / 2047.0 * 2.0 - 1.0,
		float((data >> 11u) & 0x7FFu) / 2047.0 * 2.0 - 1.0,
		float((data >> 22u) & 0x3FFu) / 1023.0 * 2.0 - 1.0
	);
	float d = dot(p, p);
	return vec4(1.0 - d, sqrt(max(0.0, 2.0 - d)) * p);
}
vec3 getScale() {
	uint data = cachedTransformA.a;
	float sx = float(data & 0xFFu);
	float sy = float((data >> 8u) & 0xFFu);
	float sz = float((data >> 16u) & 0xFFu);
	const float logRange = 21.0 / 255.0;
	const float logMin = -12.0;
	return vec3(
		sx == 0.0 ? 0.0 : exp(sx * logRange + logMin),
		sy == 0.0 ? 0.0 : exp(sy * logRange + logMin),
		sz == 0.0 ? 0.0 : exp(sz * logRange + logMin)
	);
}
`;

var containerCompactWrite_default = `
void writeSplat(vec3 center, vec4 rotation, vec3 scale, vec4 color) {
	vec3 rgb = clamp(color.rgb, 0.0, 4.0);
	uint rBits = uint(rgb.r * (2047.0 / 4.0) + 0.5);
	uint gBits = uint(rgb.g * (2047.0 / 4.0) + 0.5);
	uint bBits = uint(rgb.b * (1023.0 / 4.0) + 0.5);
	writeDataColor(uvec4(rBits | (gBits << 11u) | (bBits << 22u), 0u, 0u, 0u));
	#ifndef GSPLAT_COLOR_ONLY
		vec4 q = rotation;
		if (q.w < 0.0) q = -q;
		vec3 p = q.xyz * inversesqrt(1.0 + q.w);
		uint aBitsQ = uint(clamp((p.x * 0.5 + 0.5) * 2047.0 + 0.5, 0.0, 2047.0));
		uint bBitsQ = uint(clamp((p.y * 0.5 + 0.5) * 2047.0 + 0.5, 0.0, 2047.0));
		uint cBitsQ = uint(clamp((p.z * 0.5 + 0.5) * 1023.0 + 0.5, 0.0, 1023.0));
		uint packedQuat = aBitsQ | (bBitsQ << 11u) | (cBitsQ << 22u);
		const float invLogRange = 255.0 / 21.0;
		const float logMin = -12.0;
		uint sxBits = scale.x < 1e-10 ? 0u : uint(clamp((log(scale.x) - logMin) * invLogRange + 0.5, 1.0, 255.0));
		uint syBits = scale.y < 1e-10 ? 0u : uint(clamp((log(scale.y) - logMin) * invLogRange + 0.5, 1.0, 255.0));
		uint szBits = scale.z < 1e-10 ? 0u : uint(clamp((log(scale.z) - logMin) * invLogRange + 0.5, 1.0, 255.0));
		uint alphaBits = uint(clamp(color.a, 0.0, 1.0) * 255.0 + 0.5);
		uint packedScaleAlpha = sxBits | (syBits << 8u) | (szBits << 16u) | (alphaBits << 24u);
		writeDataTransformA(uvec4(floatBitsToUint(center.x), floatBitsToUint(center.y), floatBitsToUint(center.z), packedScaleAlpha));
		writeDataTransformB(uvec4(packedQuat, 0u, 0u, 0u));
	#endif
}
`;

var containerPackedRead_default = `
uvec4 cachedTransformA;
uvec2 cachedTransformB;
vec4 cachedColor;
vec3 getCenter() {
	cachedTransformA = loadDataTransformA();
	cachedTransformB = loadDataTransformB().xy;
	return vec3(uintBitsToFloat(cachedTransformA.r), uintBitsToFloat(cachedTransformA.g), uintBitsToFloat(cachedTransformA.b));
}
float getOpacity() {
	#ifdef GSPLAT_COLOR_FLOAT
		cachedColor = loadDataColor();
	#else
		uvec4 packedColor = loadDataColor();
		uint packed_rg = packedColor.r | (packedColor.g << 16u);
		uint packed_ba = packedColor.b | (packedColor.a << 16u);
		cachedColor = vec4(unpackHalf2x16(packed_rg), unpackHalf2x16(packed_ba));
	#endif
	return cachedColor.a;
}
vec3 getColor() {
	return cachedColor.rgb;
}
vec4 getRotation() {
	vec2 rotXY = unpackHalf2x16(cachedTransformA.a);
	vec2 rotZscaleX = unpackHalf2x16(cachedTransformB.x);
	vec3 rotXYZ = vec3(rotXY, rotZscaleX.x);
	return vec4(rotXYZ, sqrt(max(0.0, 1.0 - dot(rotXYZ, rotXYZ)))).wxyz;
}
vec3 getScale() {
	vec2 rotZscaleX = unpackHalf2x16(cachedTransformB.x);
	vec2 scaleYZ = unpackHalf2x16(cachedTransformB.y);
	return vec3(rotZscaleX.y, scaleYZ);
}
`;

var containerPackedWrite_default = `
void writeSplat(vec3 center, vec4 rotation, vec3 scale, vec4 color) {
	#ifdef GSPLAT_COLOR_UINT
		uint packed_rg = packHalf2x16(color.rg);
		uint packed_ba = packHalf2x16(color.ba);
		writeDataColor(uvec4(
			packed_rg & 0xFFFFu,
			packed_rg >> 16u,
			packed_ba & 0xFFFFu,
			packed_ba >> 16u
		));
	#else
		writeDataColor(color);
	#endif
	#ifndef GSPLAT_COLOR_ONLY
		writeDataTransformA(uvec4(floatBitsToUint(center.x), floatBitsToUint(center.y), floatBitsToUint(center.z), packHalf2x16(rotation.xy)));
		writeDataTransformB(uvec4(packHalf2x16(vec2(rotation.z, scale.x)), packHalf2x16(scale.yz), 0u, 0u));
	#endif
}
`;

var containerCompactRead_default2 = `
var<private> cachedTransformA: vec4u;
fn getCenter() -> vec3f {
	cachedTransformA = loadDataTransformA();
	return vec3f(bitcast<f32>(cachedTransformA.r), bitcast<f32>(cachedTransformA.g), bitcast<f32>(cachedTransformA.b));
}
fn getOpacity() -> f32 {
	return f32(cachedTransformA.a >> 24u) / 255.0;
}
fn getColor() -> vec3f {
	let data = loadDataColor().x;
	let r = f32(data & 0x7FFu) * (4.0 / 2047.0);
	let g = f32((data >> 11u) & 0x7FFu) * (4.0 / 2047.0);
	let b = f32((data >> 22u) & 0x3FFu) * (4.0 / 1023.0);
	return vec3f(r, g, b);
}
fn getRotation() -> vec4f {
	let data = loadDataTransformB().x;
	let p = vec3f(
		f32(data & 0x7FFu) / 2047.0 * 2.0 - 1.0,
		f32((data >> 11u) & 0x7FFu) / 2047.0 * 2.0 - 1.0,
		f32((data >> 22u) & 0x3FFu) / 1023.0 * 2.0 - 1.0
	);
	let d = dot(p, p);
	return vec4f(1.0 - d, sqrt(max(0.0, 2.0 - d)) * p);
}
fn getScale() -> vec3f {
	let data = cachedTransformA.a;
	let sx = f32(data & 0xFFu);
	let sy = f32((data >> 8u) & 0xFFu);
	let sz = f32((data >> 16u) & 0xFFu);
	let logRange = 21.0 / 255.0;
	let logMin = -12.0;
	return vec3f(
		select(exp(sx * logRange + logMin), 0.0, sx == 0.0),
		select(exp(sy * logRange + logMin), 0.0, sy == 0.0),
		select(exp(sz * logRange + logMin), 0.0, sz == 0.0)
	);
}
`;

var containerCompactWrite_default2 = `
fn writeSplat(center: vec3f, rotation: vec4f, scale: vec3f, color: vec4f) {
	let rgb = clamp(color.rgb, vec3f(0.0), vec3f(4.0));
	let rBits = u32(rgb.r * (2047.0 / 4.0) + 0.5);
	let gBits = u32(rgb.g * (2047.0 / 4.0) + 0.5);
	let bBits = u32(rgb.b * (1023.0 / 4.0) + 0.5);
	writeDataColor(vec4u(rBits | (gBits << 11u) | (bBits << 22u), 0u, 0u, 0u));
	#ifndef GSPLAT_COLOR_ONLY
		var q = rotation;
		if (q.w < 0.0) { q = -q; }
		let p = q.xyz * inverseSqrt(1.0 + q.w);
		let aBitsQ = u32(clamp(p.x * 0.5 + 0.5, 0.0, 1.0) * 2047.0 + 0.5);
		let bBitsQ = u32(clamp(p.y * 0.5 + 0.5, 0.0, 1.0) * 2047.0 + 0.5);
		let cBitsQ = u32(clamp(p.z * 0.5 + 0.5, 0.0, 1.0) * 1023.0 + 0.5);
		let packedQuat = aBitsQ | (bBitsQ << 11u) | (cBitsQ << 22u);
		let invLogRange = 255.0 / 21.0;
		let logMin = -12.0;
		let sxBits = select(u32(clamp((log(scale.x) - logMin) * invLogRange + 0.5, 1.0, 255.0)), 0u, scale.x < 1e-10);
		let syBits = select(u32(clamp((log(scale.y) - logMin) * invLogRange + 0.5, 1.0, 255.0)), 0u, scale.y < 1e-10);
		let szBits = select(u32(clamp((log(scale.z) - logMin) * invLogRange + 0.5, 1.0, 255.0)), 0u, scale.z < 1e-10);
		let alphaBits = u32(clamp(color.a, 0.0, 1.0) * 255.0 + 0.5);
		let packedScaleAlpha = sxBits | (syBits << 8u) | (szBits << 16u) | (alphaBits << 24u);
		writeDataTransformA(vec4u(bitcast<u32>(center.x), bitcast<u32>(center.y), bitcast<u32>(center.z), packedScaleAlpha));
		writeDataTransformB(vec4u(packedQuat, 0u, 0u, 0u));
	#endif
}
`;

var containerPackedRead_default2 = `
var<private> cachedTransformA: vec4u;
var<private> cachedTransformB: vec2u;
var<private> cachedColor: vec4f;
fn getCenter() -> vec3f {
	cachedTransformA = loadDataTransformA();
	cachedTransformB = loadDataTransformB().xy;
	return vec3f(bitcast<f32>(cachedTransformA.r), bitcast<f32>(cachedTransformA.g), bitcast<f32>(cachedTransformA.b));
}
fn getOpacity() -> f32 {
	#ifdef GSPLAT_COLOR_FLOAT
		cachedColor = loadDataColor();
	#else
		let packedColor = loadDataColor();
		let packed_rg = packedColor.r | (packedColor.g << 16u);
		let packed_ba = packedColor.b | (packedColor.a << 16u);
		cachedColor = vec4f(unpack2x16float(packed_rg), unpack2x16float(packed_ba));
	#endif
	return cachedColor.a;
}
fn getColor() -> vec3f {
	return cachedColor.rgb;
}
fn getRotation() -> vec4f {
	let rotXY = unpack2x16float(cachedTransformA.a);
	let rotZscaleX = unpack2x16float(cachedTransformB.x);
	let rotXYZ = vec3f(rotXY, rotZscaleX.x);
	return vec4f(rotXYZ, sqrt(max(0.0, 1.0 - dot(rotXYZ, rotXYZ)))).wxyz;
}
fn getScale() -> vec3f {
	let rotZscaleX = unpack2x16float(cachedTransformB.x);
	let scaleYZ = unpack2x16float(cachedTransformB.y);
	return vec3f(rotZscaleX.y, scaleYZ);
}
`;

var containerPackedWrite_default2 = `
fn writeSplat(center: vec3f, rotation: vec4f, scale: vec3f, color: vec4f) {
	writeDataColor(color);
	#ifndef GSPLAT_COLOR_ONLY
		writeDataTransformA(vec4u(bitcast<u32>(center.x), bitcast<u32>(center.y), bitcast<u32>(center.z), pack2x16float(rotation.xy)));
		writeDataTransformB(vec4u(pack2x16float(vec2f(rotation.z, scale.x)), pack2x16float(scale.yz), 0u, 0u));
	#endif
}
`;

var GSplatParams = class {
	_material = new ShaderMaterial();
	_format;
	_device;
	_dataFormat = GSPLATDATA_COMPACT;
	constructor(device) {
		this._device = device;
		this._currentRenderer = this._resolveRenderer(this._renderer);
		this._format = this._createFormat(GSPLATDATA_COMPACT);
		this._varyings = new GSplatVaryings(device);
		this._material.setParameter("alphaClip", 0.3);
		this._material.setParameter("alphaClipForward", 1 / 255);
		this._material.setParameter("minPixelSize", 2);
		this._material.setParameter("minContribution", 3);
		this._material.setParameter("foveationStrength", 0);
		this._material.setParameter("foveationCenter", 0.3);
	}
	_createFormat(dataFormat) {
		let format;
		if (dataFormat === GSPLATDATA_COMPACT) {
			format = new GSplatFormat(this._device, [
				{ name: "dataColor", format: PIXELFORMAT_R32U },
				{ name: "dataTransformA", format: PIXELFORMAT_RGBA32U },
				{ name: "dataTransformB", format: PIXELFORMAT_R32U }
			], {
				readGLSL: containerCompactRead_default,
				readWGSL: containerCompactRead_default2
			});
			format.setWriteCode(containerCompactWrite_default, containerCompactWrite_default2);
		} else {
			const colorFormat = this._device.getRenderableHdrFormat([PIXELFORMAT_RGBA16F]) || PIXELFORMAT_RGBA16U;
			format = new GSplatFormat(this._device, [
				{ name: "dataColor", format: colorFormat },
				{ name: "dataTransformA", format: PIXELFORMAT_RGBA32U },
				{ name: "dataTransformB", format: PIXELFORMAT_RG32U }
			], {
				readGLSL: containerPackedRead_default,
				readWGSL: containerPackedRead_default2
			});
			format.setWriteCode(containerPackedWrite_default, containerPackedWrite_default2);
		}
		format.allowStreamRemoval = true;
		format.dataFormat = dataFormat;
		return format;
	}
	radialSorting = false;
	_renderer = GSPLAT_RENDERER_AUTO;
	_currentRenderer = GSPLAT_RENDERER_RASTER_CPU_SORT;
	_resolveRenderer(value) {
		if (value === GSPLAT_RENDERER_AUTO) {
			return this._device.isWebGPU ? GSPLAT_RENDERER_RASTER_GPU_SORT : GSPLAT_RENDERER_RASTER_CPU_SORT;
		}
		if (value === GSPLAT_RENDERER_RASTER_GPU_SORT && !this._device.isWebGPU) {
			return GSPLAT_RENDERER_RASTER_CPU_SORT;
		}
		return value;
	}
	set renderer(value) {
		if (value === GSPLAT_RENDERER_COMPUTE) {
			value = GSPLAT_RENDERER_AUTO;
		}
		if (this._renderer !== value) {
			this._renderer = value;
			this._currentRenderer = this._resolveRenderer(value);
		}
	}
	get renderer() {
		return this._renderer;
	}
	get currentRenderer() {
		return this._currentRenderer;
	}
	dirty = false;
	_debug = GSPLAT_DEBUG_NONE;
	set debug(value) {
		if (value === GSPLAT_DEBUG_HEATMAP) {
			return;
		}
		if (this._debug !== value) {
			const prev = this._debug;
			this._debug = value;
			if (value === GSPLAT_DEBUG_LOD || prev === GSPLAT_DEBUG_LOD) {
				this.dirty = true;
			}
		}
	}
	get debug() {
		return this._debug;
	}
	set colorizeLod(value) {
		this.debug = value ? GSPLAT_DEBUG_LOD : GSPLAT_DEBUG_NONE;
	}
	get colorizeLod() {
		return this._debug === GSPLAT_DEBUG_LOD;
	}
	set debugAabbs(value) {
		this.debug = value ? GSPLAT_DEBUG_AABBS : GSPLAT_DEBUG_NONE;
	}
	get debugAabbs() {
		return this._debug === GSPLAT_DEBUG_AABBS;
	}
	set debugNodeAabbs(value) {
		this.debug = value ? GSPLAT_DEBUG_NODE_AABBS : GSPLAT_DEBUG_NONE;
	}
	get debugNodeAabbs() {
		return this._debug === GSPLAT_DEBUG_NODE_AABBS;
	}
	_enableIds = false;
	set enableIds(value) {
		if (value && !this._enableIds) {
			this._enableIds = true;
			if (!this._format.getStream("pcId")) {
				this._format.addExtraStreams([
					{ name: "pcId", format: PIXELFORMAT_R32U }
				]);
			}
		} else if (!value && this._enableIds) {
			this._enableIds = false;
			this._format.removeExtraStreams(["pcId"]);
		}
	}
	get enableIds() {
		return this._enableIds;
	}
	lodUpdateDistance = 1;
	lodUpdateAngle = 0;
	_lodBehindPenalty = 1;
	set lodBehindPenalty(value) {
		if (this._lodBehindPenalty !== value) {
			this._lodBehindPenalty = value;
			this.dirty = true;
		}
	}
	get lodBehindPenalty() {
		return this._lodBehindPenalty;
	}
	set lodRangeMin(value) {
	}
	get lodRangeMin() {
		return 0;
	}
	set lodRangeMax(value) {
	}
	get lodRangeMax() {
		return 99;
	}
	_lodUnderfillLimit = 0;
	set lodUnderfillLimit(value) {
		if (this._lodUnderfillLimit !== value) {
			this._lodUnderfillLimit = value;
			this.dirty = true;
		}
	}
	get lodUnderfillLimit() {
		return this._lodUnderfillLimit;
	}
	_splatBudget = 0;
	set splatBudget(value) {
		if (this._splatBudget !== value) {
			this._splatBudget = value;
			this.dirty = true;
		}
	}
	get splatBudget() {
		return this._splatBudget;
	}
	_colorRamp = null;
	set colorRamp(value) {
		if (this._colorRamp !== value) {
			this._colorRamp = value;
			this.dirty = true;
		}
	}
	get colorRamp() {
		return this._colorRamp;
	}
	colorRampIntensity = 1;
	useFog = true;
	set colorizeColorUpdate(value) {
		this.debug = value ? GSPLAT_DEBUG_SH_UPDATE : GSPLAT_DEBUG_NONE;
	}
	get colorizeColorUpdate() {
		return this._debug === GSPLAT_DEBUG_SH_UPDATE;
	}
	colorUpdateAngle = 10;
	set colorUpdateDistance(value) {
	}
	get colorUpdateDistance() {
		return 0;
	}
	set colorUpdateDistanceLodScale(value) {
	}
	get colorUpdateDistanceLodScale() {
		return 0;
	}
	set colorUpdateAngleLodScale(value) {
	}
	get colorUpdateAngleLodScale() {
		return 0;
	}
	set alphaClip(value) {
		this._material.setParameter("alphaClip", value);
		this._material.update();
	}
	get alphaClip() {
		return this._material.getParameter("alphaClip")?.data ?? 0.3;
	}
	set alphaClipForward(value) {
		this._material.setParameter("alphaClipForward", value);
		this._material.update();
	}
	get alphaClipForward() {
		return this._material.getParameter("alphaClipForward")?.data ?? 1 / 255;
	}
	set minPixelSize(value) {
		this._material.setParameter("minPixelSize", value);
		this._material.update();
	}
	get minPixelSize() {
		return this._material.getParameter("minPixelSize")?.data ?? 2;
	}
	set minContribution(value) {
		this._material.setParameter("minContribution", value);
		this._material.update();
	}
	get minContribution() {
		return this._material.getParameter("minContribution")?.data ?? 3;
	}
	set foveationStrength(value) {
		this._material.setParameter("foveationStrength", value);
		this._material.update();
	}
	get foveationStrength() {
		return this._material.getParameter("foveationStrength")?.data ?? 0;
	}
	set foveationCenter(value) {
		this._material.setParameter("foveationCenter", value);
		this._material.update();
	}
	get foveationCenter() {
		return this._material.getParameter("foveationCenter")?.data ?? 0.3;
	}
	set antiAlias(value) {
		this._material.setDefine("GSPLAT_AA", value);
		this._material.update();
	}
	get antiAlias() {
		return !!this._material.getDefine("GSPLAT_AA");
	}
	set twoDimensional(value) {
		this._material.setDefine("GSPLAT_2DGS", value);
		this._material.update();
	}
	get twoDimensional() {
		return !!this._material.getDefine("GSPLAT_2DGS");
	}
	_fisheye = 0;
	set fisheye(value) {
		if (this._fisheye !== value) {
			const wasEnabled = this._fisheye > 0;
			this._fisheye = value;
			const isEnabled = value > 0;
			if (wasEnabled !== isEnabled) {
				this._material.setDefine("GSPLAT_FISHEYE", isEnabled);
				this._material.update();
			}
		}
	}
	get fisheye() {
		return this._fisheye;
	}
	cooldownTicks = 100;
	set dataFormat(value) {
		if (this._dataFormat !== value) {
			this._dataFormat = value;
			const extraStreams = this._format.extraStreams.map((s2) => ({
				name: s2.name,
				format: s2.format,
				storage: s2.storage
			}));
			this._format = this._createFormat(value);
			if (extraStreams.length > 0) {
				this._format.addExtraStreams(extraStreams);
			}
			this.dirty = true;
		}
	}
	get dataFormat() {
		return this._dataFormat;
	}
	get material() {
		return this._material;
	}
	get format() {
		return this._format;
	}
	_varyings;
	_appliedVaryingsVersion = 0;
	get varyings() {
		return this._varyings;
	}
	applySettings(render) {
		this.radialSorting = render.gsplatRadialSorting ?? this.radialSorting;
		this.lodUpdateDistance = render.gsplatLodUpdateDistance ?? this.lodUpdateDistance;
		this.lodUpdateAngle = render.gsplatLodUpdateAngle ?? this.lodUpdateAngle;
		this.lodBehindPenalty = render.gsplatLodBehindPenalty ?? this.lodBehindPenalty;
		this.lodUnderfillLimit = render.gsplatLodUnderfillLimit ?? this.lodUnderfillLimit;
		this.splatBudget = render.gsplatSplatBudget ?? this.splatBudget;
		this.alphaClip = render.gsplatAlphaClip ?? this.alphaClip;
		this.alphaClipForward = render.gsplatAlphaClipForward ?? this.alphaClipForward;
		this.minPixelSize = render.gsplatMinPixelSize ?? this.minPixelSize;
		this.minContribution = render.gsplatMinContribution ?? this.minContribution;
		this.foveationStrength = render.gsplatFoveationStrength ?? this.foveationStrength;
		this.foveationCenter = render.gsplatFoveationCenter ?? this.foveationCenter;
		this.antiAlias = render.gsplatAntiAlias ?? this.antiAlias;
		this.useFog = render.gsplatUseFog ?? this.useFog;
		this.colorUpdateAngle = render.gsplatColorUpdateAngle ?? this.colorUpdateAngle;
		this.cooldownTicks = render.gsplatCooldownTicks ?? this.cooldownTicks;
		this.dataFormat = render.gsplatDataFormat ?? this.dataFormat;
		this.enableIds = render.gsplatEnableIds ?? this.enableIds;
	}
	frameEnd() {
		this._material.dirty = false;
		this.dirty = false;
	}
	frameUpdate() {
		if (this._appliedVaryingsVersion !== this._varyings.version) {
			this._appliedVaryingsVersion = this._varyings.version;
			this._varyings.apply(this._material);
		}
	}
};

var FisheyeProjection = class {
	enabled = false;
	k = 1;
	invK = 1;
	cornerScale = 1;
	projMat00 = 1;
	projMat11 = 1;
	maxTheta = Math.PI;
	// Cached inputs for short-circuit check
	_lastT = -1;
	_lastFov = -1;
	_lastP00 = 0;
	_lastP11 = 0;
	update(t, fov, projMatrix) {
		if (projMatrix.data[15] === 1) {
			t = 0;
		}
		const p00 = projMatrix.data[0];
		const p11 = projMatrix.data[5];
		if (t === this._lastT && fov === this._lastFov && p00 === this._lastP00 && p11 === this._lastP11) {
			return;
		}
		this._lastT = t;
		this._lastFov = fov;
		this._lastP00 = p00;
		this._lastP11 = p11;
		if (t <= 0) {
			this.enabled = false;
			this.k = 1;
			this.invK = 1;
			this.cornerScale = 1;
			this.maxTheta = Math.PI;
			return;
		}
		this.enabled = true;
		const kMin = fov / 180 + 0.15;
		const kStart = Math.max(1, fov / 180 + 0.05);
		const k = kStart * Math.pow(kMin / kStart, t);
		this.k = k;
		this.invK = 1 / k;
		this.cornerScale = 1 + (Math.SQRT2 - 1) * t;
		const maxTheta = Math.min(k * Math.PI / 2, 3.13);
		const cs = this.cornerScale;
		const halfFovX = Math.atan2(1, p00);
		const effHalfFovX = Math.min(halfFovX, maxTheta - 0.01);
		this.projMat00 = cs / (k * Math.tan(effHalfFovX / k));
		const halfFovY = Math.atan2(1, p11);
		const effHalfFovY = Math.min(halfFovY, maxTheta - 0.01);
		this.projMat11 = cs / (k * Math.tan(effHalfFovY / k));
		this.maxTheta = maxTheta;
	}
};

var calculateNormals = (positions, indices) => {
	const triangleCount = indices.length / 3;
	const vertexCount = positions.length / 3;
	const p12 = new Vec3();
	const p22 = new Vec3();
	const p32 = new Vec3();
	const p1p2 = new Vec3();
	const p1p3 = new Vec3();
	const faceNormal = new Vec3();
	const normals = [];
	for (let i2 = 0; i2 < positions.length; i2++) {
		normals[i2] = 0;
	}
	for (let i2 = 0; i2 < triangleCount; i2++) {
		const i1 = indices[i2 * 3];
		const i22 = indices[i2 * 3 + 1];
		const i3 = indices[i2 * 3 + 2];
		p12.set(positions[i1 * 3], positions[i1 * 3 + 1], positions[i1 * 3 + 2]);
		p22.set(positions[i22 * 3], positions[i22 * 3 + 1], positions[i22 * 3 + 2]);
		p32.set(positions[i3 * 3], positions[i3 * 3 + 1], positions[i3 * 3 + 2]);
		p1p2.sub2(p22, p12);
		p1p3.sub2(p32, p12);
		faceNormal.cross(p1p2, p1p3).normalize();
		normals[i1 * 3] += faceNormal.x;
		normals[i1 * 3 + 1] += faceNormal.y;
		normals[i1 * 3 + 2] += faceNormal.z;
		normals[i22 * 3] += faceNormal.x;
		normals[i22 * 3 + 1] += faceNormal.y;
		normals[i22 * 3 + 2] += faceNormal.z;
		normals[i3 * 3] += faceNormal.x;
		normals[i3 * 3 + 1] += faceNormal.y;
		normals[i3 * 3 + 2] += faceNormal.z;
	}
	for (let i2 = 0; i2 < vertexCount; i2++) {
		const nx = normals[i2 * 3];
		const ny = normals[i2 * 3 + 1];
		const nz = normals[i2 * 3 + 2];
		const invLen = 1 / Math.sqrt(nx * nx + ny * ny + nz * nz);
		normals[i2 * 3] *= invLen;
		normals[i2 * 3 + 1] *= invLen;
		normals[i2 * 3 + 2] *= invLen;
	}
	return normals;
};
var calculateTangents = (positions, normals, uvs, indices) => {
	const triangleCount = indices.length / 3;
	const vertexCount = positions.length / 3;
	const v15 = new Vec3();
	const v26 = new Vec3();
	const v33 = new Vec3();
	const w1 = new Vec2();
	const w2 = new Vec2();
	const w3 = new Vec2();
	const sdir = new Vec3();
	const tdir = new Vec3();
	const tan1 = new Float32Array(vertexCount * 3);
	const tan2 = new Float32Array(vertexCount * 3);
	const tangents = [];
	for (let i2 = 0; i2 < triangleCount; i2++) {
		const i1 = indices[i2 * 3];
		const i22 = indices[i2 * 3 + 1];
		const i3 = indices[i2 * 3 + 2];
		v15.set(positions[i1 * 3], positions[i1 * 3 + 1], positions[i1 * 3 + 2]);
		v26.set(positions[i22 * 3], positions[i22 * 3 + 1], positions[i22 * 3 + 2]);
		v33.set(positions[i3 * 3], positions[i3 * 3 + 1], positions[i3 * 3 + 2]);
		w1.set(uvs[i1 * 2], uvs[i1 * 2 + 1]);
		w2.set(uvs[i22 * 2], uvs[i22 * 2 + 1]);
		w3.set(uvs[i3 * 2], uvs[i3 * 2 + 1]);
		const x1 = v26.x - v15.x;
		const x22 = v33.x - v15.x;
		const y1 = v26.y - v15.y;
		const y2 = v33.y - v15.y;
		const z1 = v26.z - v15.z;
		const z2 = v33.z - v15.z;
		const s1 = w2.x - w1.x;
		const s2 = w3.x - w1.x;
		const t12 = w2.y - w1.y;
		const t22 = w3.y - w1.y;
		const area = s1 * t22 - s2 * t12;
		if (area === 0) {
			sdir.set(0, 1, 0);
			tdir.set(1, 0, 0);
		} else {
			const r = 1 / area;
			sdir.set(
				(t22 * x1 - t12 * x22) * r,
				(t22 * y1 - t12 * y2) * r,
				(t22 * z1 - t12 * z2) * r
			);
			tdir.set(
				(s1 * x22 - s2 * x1) * r,
				(s1 * y2 - s2 * y1) * r,
				(s1 * z2 - s2 * z1) * r
			);
		}
		tan1[i1 * 3 + 0] += sdir.x;
		tan1[i1 * 3 + 1] += sdir.y;
		tan1[i1 * 3 + 2] += sdir.z;
		tan1[i22 * 3 + 0] += sdir.x;
		tan1[i22 * 3 + 1] += sdir.y;
		tan1[i22 * 3 + 2] += sdir.z;
		tan1[i3 * 3 + 0] += sdir.x;
		tan1[i3 * 3 + 1] += sdir.y;
		tan1[i3 * 3 + 2] += sdir.z;
		tan2[i1 * 3 + 0] += tdir.x;
		tan2[i1 * 3 + 1] += tdir.y;
		tan2[i1 * 3 + 2] += tdir.z;
		tan2[i22 * 3 + 0] += tdir.x;
		tan2[i22 * 3 + 1] += tdir.y;
		tan2[i22 * 3 + 2] += tdir.z;
		tan2[i3 * 3 + 0] += tdir.x;
		tan2[i3 * 3 + 1] += tdir.y;
		tan2[i3 * 3 + 2] += tdir.z;
	}
	const t1 = new Vec3();
	const t2 = new Vec3();
	const n = new Vec3();
	const temp = new Vec3();
	for (let i2 = 0; i2 < vertexCount; i2++) {
		n.set(normals[i2 * 3], normals[i2 * 3 + 1], normals[i2 * 3 + 2]);
		t1.set(tan1[i2 * 3], tan1[i2 * 3 + 1], tan1[i2 * 3 + 2]);
		t2.set(tan2[i2 * 3], tan2[i2 * 3 + 1], tan2[i2 * 3 + 2]);
		const ndott = n.dot(t1);
		temp.copy(n).mulScalar(ndott);
		temp.sub2(t1, temp).normalize();
		tangents[i2 * 4] = temp.x;
		tangents[i2 * 4 + 1] = temp.y;
		tangents[i2 * 4 + 2] = temp.z;
		temp.cross(n, t1);
		tangents[i2 * 4 + 3] = temp.dot(t2) < 0 ? -1 : 1;
	}
	return tangents;
};

var Geometry = class {
	positions;
	normals;
	colors;
	uvs;
	uvs1;
	blendIndices;
	blendWeights;
	tangents;
	indices;
	calculateNormals() {
		this.normals = calculateNormals(this.positions, this.indices);
	}
	calculateTangents() {
		this.tangents = calculateTangents(this.positions, this.normals, this.uvs, this.indices);
	}
};

var primitiveUv1Padding = 8 / 64;
var primitiveUv1PaddingScale = 1 - primitiveUv1Padding * 2;
var BoxGeometry = class extends Geometry {
	constructor(opts = {}) {
		super();
		const he = opts.halfExtents ?? new Vec3(0.5, 0.5, 0.5);
		const ws = opts.widthSegments ?? 1;
		const ls = opts.lengthSegments ?? 1;
		const hs = opts.heightSegments ?? 1;
		const yOffset = opts.yOffset ?? 0;
		const minY = -he.y + yOffset;
		const maxY = he.y + yOffset;
		const corners = [
			new Vec3(-he.x, minY, he.z),
			new Vec3(he.x, minY, he.z),
			new Vec3(he.x, maxY, he.z),
			new Vec3(-he.x, maxY, he.z),
			new Vec3(he.x, minY, -he.z),
			new Vec3(-he.x, minY, -he.z),
			new Vec3(-he.x, maxY, -he.z),
			new Vec3(he.x, maxY, -he.z)
		];
		const faceAxes = [
			[0, 1, 3],
			// FRONT
			[4, 5, 7],
			// BACK
			[3, 2, 6],
			// TOP
			[1, 0, 4],
			// BOTTOM
			[1, 4, 2],
			// RIGHT
			[5, 0, 6]
			// LEFT
		];
		const faceNormals = [
			[0, 0, 1],
			// FRONT
			[0, 0, -1],
			// BACK
			[0, 1, 0],
			// TOP
			[0, -1, 0],
			// BOTTOM
			[1, 0, 0],
			// RIGHT
			[-1, 0, 0]
			// LEFT
		];
		const sides = {
			FRONT: 0,
			BACK: 1,
			TOP: 2,
			BOTTOM: 3,
			RIGHT: 4,
			LEFT: 5
		};
		const positions = [];
		const normals = [];
		const uvs = [];
		const uvs1 = [];
		const indices = [];
		let vcounter = 0;
		const generateFace = (side, uSegments, vSegments) => {
			const temp1 = new Vec3();
			const temp2 = new Vec3();
			const temp3 = new Vec3();
			const r = new Vec3();
			for (let i2 = 0; i2 <= uSegments; i2++) {
				for (let j = 0; j <= vSegments; j++) {
					temp1.lerp(corners[faceAxes[side][0]], corners[faceAxes[side][1]], i2 / uSegments);
					temp2.lerp(corners[faceAxes[side][0]], corners[faceAxes[side][2]], j / vSegments);
					temp3.sub2(temp2, corners[faceAxes[side][0]]);
					r.add2(temp1, temp3);
					let u = i2 / uSegments;
					let v6 = j / vSegments;
					positions.push(r.x, r.y, r.z);
					normals.push(faceNormals[side][0], faceNormals[side][1], faceNormals[side][2]);
					uvs.push(u, 1 - v6);
					u = u * primitiveUv1PaddingScale + primitiveUv1Padding;
					v6 = v6 * primitiveUv1PaddingScale + primitiveUv1Padding;
					u /= 3;
					v6 /= 3;
					u += side % 3 / 3;
					v6 += Math.floor(side / 3) / 3;
					uvs1.push(u, 1 - v6);
					if (i2 < uSegments && j < vSegments) {
						indices.push(vcounter + vSegments + 1, vcounter + 1, vcounter);
						indices.push(vcounter + vSegments + 1, vcounter + vSegments + 2, vcounter + 1);
					}
					vcounter++;
				}
			}
		};
		generateFace(sides.FRONT, ws, hs);
		generateFace(sides.BACK, ws, hs);
		generateFace(sides.TOP, ws, ls);
		generateFace(sides.BOTTOM, ws, ls);
		generateFace(sides.RIGHT, ls, hs);
		generateFace(sides.LEFT, ls, hs);
		this.positions = positions;
		this.normals = normals;
		this.uvs = uvs;
		this.uvs1 = uvs1;
		this.indices = indices;
		if (opts.calculateTangents) {
			this.tangents = calculateTangents(positions, normals, uvs, indices);
		}
	}
};

var SphereGeometry = class extends Geometry {
	constructor(opts = {}) {
		super();
		const radius = opts.radius ?? 0.5;
		const latitudeBands = opts.latitudeBands ?? 16;
		const longitudeBands = opts.longitudeBands ?? 16;
		const positions = [];
		const normals = [];
		const uvs = [];
		const indices = [];
		for (let lat = 0; lat <= latitudeBands; lat++) {
			const theta = lat * Math.PI / latitudeBands;
			const sinTheta = Math.sin(theta);
			const cosTheta = Math.cos(theta);
			for (let lon = 0; lon <= longitudeBands; lon++) {
				const phi = lon * 2 * Math.PI / longitudeBands - Math.PI / 2;
				const sinPhi = Math.sin(phi);
				const cosPhi = Math.cos(phi);
				const x3 = cosPhi * sinTheta;
				const y2 = cosTheta;
				const z2 = sinPhi * sinTheta;
				const u = 1 - lon / longitudeBands;
				const v6 = 1 - lat / latitudeBands;
				positions.push(x3 * radius, y2 * radius, z2 * radius);
				normals.push(x3, y2, z2);
				uvs.push(u, 1 - v6);
			}
		}
		for (let lat = 0; lat < latitudeBands; ++lat) {
			for (let lon = 0; lon < longitudeBands; ++lon) {
				const first = lat * (longitudeBands + 1) + lon;
				const second = first + longitudeBands + 1;
				indices.push(first + 1, second, first);
				indices.push(first + 1, second + 1, second);
			}
		}
		this.positions = positions;
		this.normals = normals;
		this.uvs = uvs;
		this.uvs1 = uvs;
		this.indices = indices;
		if (opts.calculateTangents) {
			this.tangents = calculateTangents(positions, normals, uvs, indices);
		}
	}
};

var DomeGeometry = class extends SphereGeometry {
	constructor(opts = {}) {
		const radius = 0.5;
		const latitudeBands = opts.latitudeBands ?? 16;
		const longitudeBands = opts.longitudeBands ?? 16;
		super({
			radius,
			latitudeBands,
			longitudeBands
		});
		const bottomLimit = 0.1;
		const curvatureRadius = 0.95;
		const curvatureRadiusSq = curvatureRadius * curvatureRadius;
		const positions = this.positions;
		for (let i2 = 0; i2 < positions.length; i2 += 3) {
			const x3 = positions[i2] / radius;
			let y2 = positions[i2 + 1] / radius;
			const z2 = positions[i2 + 2] / radius;
			if (y2 < 0) {
				y2 *= 0.3;
				if (x3 * x3 + z2 * z2 < curvatureRadiusSq) {
					y2 = -bottomLimit;
				}
			}
			y2 += bottomLimit;
			y2 *= radius;
			positions[i2 + 1] = y2;
		}
	}
};

var SkyGeometry = class _SkyGeometry {
	static create(device, type) {
		switch (type) {
			case SKYTYPE_BOX:
				return _SkyGeometry.box(device);
			case SKYTYPE_DOME:
				return _SkyGeometry.dome(device);
		}
		return _SkyGeometry.infinite(device);
	}
	static infinite(device) {
		return Mesh.fromGeometry(device, new BoxGeometry(device));
	}
	static box(device) {
		return Mesh.fromGeometry(device, new BoxGeometry({ yOffset: 0.5 }));
	}
	static dome(device) {
		const geom = new DomeGeometry({
			latitudeBands: 50,
			longitudeBands: 50
		});
		geom.normals = void 0;
		geom.uvs = void 0;
		return Mesh.fromGeometry(device, geom);
	}
};

var SkyMesh = class {
	meshInstance = null;
	_depthWrite = false;
	constructor(device, scene, node, texture, type) {
		const material = new ShaderMaterial({
			uniqueName: "SkyMaterial",
			vertexGLSL: ShaderChunks.get(device, SHADERLANGUAGE_GLSL).get("skyboxVS"),
			fragmentGLSL: ShaderChunks.get(device, SHADERLANGUAGE_GLSL).get("skyboxPS"),
			vertexWGSL: ShaderChunks.get(device, SHADERLANGUAGE_WGSL).get("skyboxVS"),
			fragmentWGSL: ShaderChunks.get(device, SHADERLANGUAGE_WGSL).get("skyboxPS"),
			attributes: {
				aPosition: SEMANTIC_POSITION
			}
		});
		material.setDefine("{SKYBOX_DECODE_FNC}", ChunkUtils.decodeFunc(texture.encoding));
		if (type !== SKYTYPE_INFINITE) material.setDefine("SKYMESH", "");
		if (texture.cubemap) material.setDefine("SKY_CUBEMAP", "");
		material.setParameter("skyboxHighlightMultiplier", scene.skyboxHighlightMultiplier);
		if (texture.cubemap) {
			material.setParameter("texture_cubeMap", texture);
		} else {
			material.setParameter("texture_envAtlas", texture);
			material.setParameter("mipLevel", scene.skyboxMip);
		}
		material.cull = CULLFACE_FRONT;
		material.depthWrite = this._depthWrite;
		const skyLayer = scene.layers.getLayerById(LAYERID_SKYBOX);
		if (skyLayer) {
			const mesh = SkyGeometry.create(device, type);
			const meshInstance = new MeshInstance(mesh, material, node);
			this.meshInstance = meshInstance;
			meshInstance.cull = false;
			meshInstance.pick = false;
			skyLayer.addMeshInstances([meshInstance]);
			this.skyLayer = skyLayer;
		}
	}
	destroy() {
		if (this.meshInstance) {
			if (this.skyLayer) {
				this.skyLayer.removeMeshInstances([this.meshInstance]);
			}
			this.meshInstance.destroy();
			this.meshInstance = null;
		}
	}
	set depthWrite(value) {
		this._depthWrite = value;
		if (this.meshInstance) {
			this.meshInstance.material.depthWrite = value;
		}
	}
	get depthWrite() {
		return this._depthWrite;
	}
};

var Sky = class {
	_type = SKYTYPE_INFINITE;
	_center = new Vec3(0, 1, 0);
	skyMesh = null;
	_depthWrite = false;
	_fisheye = 0;
	_fisheyeProj = null;
	node = new GraphNode("SkyMeshNode");
	constructor(scene) {
		this.device = scene.device;
		this.scene = scene;
		this.center = new Vec3(0, 1, 0);
		this.centerArray = new Float32Array(3);
		this.projectedSkydomeCenterId = this.device.scope.resolve("projectedSkydomeCenter");
		this._preRenderEvt = scene.on("prerender", this._onPreRender, this);
	}
	destroy() {
		this._preRenderEvt.off();
		this.resetSkyMesh();
	}
	applySettings(render) {
		this.type = render.skyType ?? SKYTYPE_INFINITE;
		this.node.setLocalPosition(new Vec3(render.skyMeshPosition ?? [0, 0, 0]));
		this.node.setLocalEulerAngles(new Vec3(render.skyMeshRotation ?? [0, 0, 0]));
		this.node.setLocalScale(new Vec3(render.skyMeshScale ?? [1, 1, 1]));
		if (render.skyCenter) {
			this._center = new Vec3(render.skyCenter);
		}
	}
	set type(value) {
		if (this._type !== value) {
			this._type = value;
			this.scene.updateShaders = true;
			this.updateSkyMesh();
		}
	}
	get type() {
		return this._type;
	}
	set center(value) {
		this._center.copy(value);
	}
	get center() {
		return this._center;
	}
	set depthWrite(value) {
		if (this._depthWrite !== value) {
			this._depthWrite = value;
			if (this.skyMesh) {
				this.skyMesh.depthWrite = value;
			}
		}
	}
	get depthWrite() {
		return this._depthWrite;
	}
	set fisheye(value) {
		if (this._fisheye !== value) {
			const wasEnabled = this._fisheye > 0;
			this._fisheye = value;
			const isEnabled = value > 0;
			if (wasEnabled !== isEnabled) {
				this._fisheyeProj ?? (this._fisheyeProj = new FisheyeProjection());
				if (this._type === SKYTYPE_INFINITE) {
					this._setFisheyeDefine(isEnabled);
				}
			}
		}
	}
	get fisheye() {
		return this._fisheye;
	}
	updateSkyMesh() {
		const texture = this.scene._getSkyboxTex();
		if (texture) {
			this.resetSkyMesh();
			this.skyMesh = new SkyMesh(this.device, this.scene, this.node, texture, this.type);
			this.skyMesh.depthWrite = this._depthWrite;
			if (this._fisheye > 0 && this.type === SKYTYPE_INFINITE) {
				this._setFisheyeDefine(true);
			}
			this.scene.fire("set:skybox", texture);
		}
	}
	resetSkyMesh() {
		this.skyMesh?.destroy();
		this.skyMesh = null;
	}
	update() {
		if (this.type !== SKYTYPE_INFINITE) {
			const { center: center2, centerArray } = this;
			const temp = new Vec3();
			this.node.getWorldTransform().transformPoint(center2, temp);
			centerArray[0] = temp.x;
			centerArray[1] = temp.y;
			centerArray[2] = temp.z;
			this.projectedSkydomeCenterId.setValue(centerArray);
		}
	}
	_setFisheyeDefine(enabled) {
		if (this.skyMesh?.meshInstance) {
			const material = this.skyMesh.meshInstance.material;
			material.setDefine("SKY_FISHEYE", enabled);
			material.update();
		}
	}
	_onPreRender(cameraComponent) {
		if (this._fisheye > 0 && this._fisheyeProj && this.skyMesh?.meshInstance) {
			const camera = cameraComponent.camera;
			const proj = this._fisheyeProj;
			proj.update(this._fisheye, camera.fov, camera.projectionMatrix);
			const material = this.skyMesh.meshInstance.material;
			material.setParameter("fisheye_k", proj.k);
			material.setParameter("fisheye_invK", proj.invK);
			material.setParameter("fisheye_projMat00", proj.projMat00);
			material.setParameter("fisheye_projMat11", proj.projMat11);
		}
	}
};

var identityGraphNode = new GraphNode();
identityGraphNode.worldTransform = Mat4.IDENTITY;
identityGraphNode._dirtyWorld = identityGraphNode._dirtyNormal = false;
var ImmediateBatch = class {
	constructor(device, material, layer) {
		this.material = material;
		this.layer = layer;
		this.positions = [];
		this.colors = [];
		this.mesh = new Mesh(device);
		this.meshInstance = null;
	}
	// add line positions and colors to the batch
	// this function expects position in Vec3 and colors in Color format
	addLines(positions, color3) {
		const destPos = this.positions;
		const count = positions.length;
		for (let i2 = 0; i2 < count; i2++) {
			const pos = positions[i2];
			destPos.push(pos.x, pos.y, pos.z);
		}
		const destCol = this.colors;
		if (color3.length) {
			for (let i2 = 0; i2 < count; i2++) {
				const col = color3[i2];
				destCol.push(col.r, col.g, col.b, col.a);
			}
		} else {
			for (let i2 = 0; i2 < count; i2++) {
				destCol.push(color3.r, color3.g, color3.b, color3.a);
			}
		}
	}
	// add line positions and colors to the batch
	// this function expects positions as arrays of numbers
	// and color as instance of Color or array of number specifying the same number of vertices as positions
	addLinesArrays(positions, color3) {
		const destPos = this.positions;
		for (let i2 = 0; i2 < positions.length; i2 += 3) {
			destPos.push(positions[i2], positions[i2 + 1], positions[i2 + 2]);
		}
		const destCol = this.colors;
		if (color3.length) {
			for (let i2 = 0; i2 < color3.length; i2 += 4) {
				destCol.push(color3[i2], color3[i2 + 1], color3[i2 + 2], color3[i2 + 3]);
			}
		} else {
			const count = positions.length / 3;
			for (let i2 = 0; i2 < count; i2++) {
				destCol.push(color3.r, color3.g, color3.b, color3.a);
			}
		}
	}
	onPreRender(visibleList, transparent) {
		if (this.positions.length > 0 && this.material.transparent === transparent) {
			this.mesh.setPositions(this.positions);
			this.mesh.setColors(this.colors);
			this.mesh.update(PRIMITIVE_LINES, false);
			if (!this.meshInstance) {
				this.meshInstance = new MeshInstance(this.mesh, this.material, identityGraphNode);
			}
			visibleList.push(this.meshInstance);
		}
	}
	clear() {
		this.positions.length = 0;
		this.colors.length = 0;
	}
};

var ImmediateBatches = class {
	constructor(device) {
		this.device = device;
		this.map = /* @__PURE__ */ new Map();
	}
	getBatch(material, layer) {
		let batch = this.map.get(material);
		if (!batch) {
			batch = new ImmediateBatch(this.device, material, layer);
			this.map.set(material, batch);
		}
		return batch;
	}
	onPreRender(visibleList, transparent) {
		this.map.forEach((batch) => {
			batch.onPreRender(visibleList, transparent);
		});
	}
	clear() {
		this.map.forEach((batch) => batch.clear());
	}
};

var tempPoints = [];
var vec = new Vec3();
var Immediate = class {
	shaderDescs = /* @__PURE__ */ new Map();
	constructor(device) {
		this.device = device;
		this.quadMesh = null;
		this.textureShader = null;
		this.depthTextureShader = null;
		this.cubeLocalPos = null;
		this.cubeWorldPos = null;
		this.batchesMap = /* @__PURE__ */ new Map();
		this.allBatches = /* @__PURE__ */ new Set();
		this.updatedLayers = /* @__PURE__ */ new Set();
		this._materialDepth = null;
		this._materialNoDepth = null;
		this.layerMeshInstances = /* @__PURE__ */ new Map();
	}
	// creates material for line rendering
	createMaterial(depthTest) {
		const material = new ShaderMaterial({
			uniqueName: "ImmediateLine",
			vertexGLSL: ShaderChunks.get(this.device, SHADERLANGUAGE_GLSL).get("immediateLineVS"),
			fragmentGLSL: ShaderChunks.get(this.device, SHADERLANGUAGE_GLSL).get("immediateLinePS"),
			vertexWGSL: ShaderChunks.get(this.device, SHADERLANGUAGE_WGSL).get("immediateLineVS"),
			fragmentWGSL: ShaderChunks.get(this.device, SHADERLANGUAGE_WGSL).get("immediateLinePS"),
			attributes: {
				vertex_position: SEMANTIC_POSITION,
				vertex_color: SEMANTIC_COLOR
			}
		});
		material.blendType = BLEND_NORMAL;
		material.depthTest = depthTest;
		material.update();
		return material;
	}
	// material for line rendering with depth testing on
	get materialDepth() {
		if (!this._materialDepth) {
			this._materialDepth = this.createMaterial(true);
		}
		return this._materialDepth;
	}
	// material for line rendering with depth testing off
	get materialNoDepth() {
		if (!this._materialNoDepth) {
			this._materialNoDepth = this.createMaterial(false);
		}
		return this._materialNoDepth;
	}
	// returns a batch for rendering lines to a layer with required depth testing state
	getBatch(layer, depthTest) {
		let batches = this.batchesMap.get(layer);
		if (!batches) {
			batches = new ImmediateBatches(this.device);
			this.batchesMap.set(layer, batches);
		}
		this.allBatches.add(batches);
		const material = depthTest ? this.materialDepth : this.materialNoDepth;
		return batches.getBatch(material, layer);
	}
	getShaderDesc(id14, fragmentGLSL2, fragmentWGSL2) {
		if (!this.shaderDescs.has(id14)) {
			this.shaderDescs.set(id14, {
				uniqueName: `DebugShader:${id14}`,
				// shared vertex shader for textured quad rendering
				vertexGLSL: `
					attribute vec2 vertex_position;
					uniform mat4 matrix_model;
					varying vec2 uv0;
					void main(void) {
						gl_Position = matrix_model * vec4(vertex_position, 0, 1);
						uv0 = vertex_position.xy + 0.5;
					}
				`,
				vertexWGSL: `
					attribute vertex_position: vec2f;
					uniform matrix_model: mat4x4f;
					varying uv0: vec2f;
					@vertex fn vertexMain(input: VertexInput) -> VertexOutput {
						var output: VertexOutput;
						output.position = uniform.matrix_model * vec4f(input.vertex_position, 0.0, 1.0);
						output.uv0 = input.vertex_position.xy + vec2f(0.5);
						return output;
					}
				`,
				fragmentGLSL: fragmentGLSL2,
				fragmentWGSL: fragmentWGSL2,
				attributes: { vertex_position: SEMANTIC_POSITION }
			});
		}
		return this.shaderDescs.get(id14);
	}
	// shader used to display texture
	getTextureShaderDesc(encoding) {
		const decodeFunc = ChunkUtils.decodeFunc(encoding);
		return this.getShaderDesc(
			`textureShader-${encoding}`,
			`
			#include "gammaPS"
			varying vec2 uv0;
			uniform sampler2D colorMap;
			void main (void) {
				vec3 linearColor = ${decodeFunc}(texture2D(colorMap, uv0));
				gl_FragColor = vec4(gammaCorrectOutput(linearColor), 1);
			}
		`,
			`
			#include "gammaPS"
			varying uv0: vec2f;
			var colorMap: texture_2d<f32>;
			var colorMapSampler: sampler;
			@fragment fn fragmentMain(input : FragmentInput) -> FragmentOutput {
				var output: FragmentOutput;
				let sampledTex = textureSample(colorMap, colorMapSampler, input.uv0);
				let linearColor: vec3f = ${decodeFunc}(sampledTex);
				output.color = vec4f(gammaCorrectOutput(linearColor), 1.0);
				return output;
			}
		`
		);
	}
	// shader used to display infilterable texture sampled using texelFetch
	getUnfilterableTextureShaderDesc() {
		return this.getShaderDesc(
			"textureShaderUnfilterable",
			`
			varying vec2 uv0;
			uniform highp sampler2D colorMap;
			void main (void) {
				ivec2 uv = ivec2(uv0 * textureSize(colorMap, 0));
				gl_FragColor = vec4(texelFetch(colorMap, uv, 0).xyz, 1);
			}
		`,
			`
			varying uv0: vec2f;
			var colorMap: texture_2d<uff>;
			@fragment fn fragmentMain(input : FragmentInput) -> FragmentOutput {
				var output: FragmentOutput;
				let uv : vec2<i32> = vec2<i32>(input.uv0 * vec2f(textureDimensions(colorMap, 0)));
				let fetchedColor : vec4f = textureLoad(colorMap, uv, 0);
				output.color = vec4f(fetchedColor.xyz, 1.0);
				return output;
			}
		`
		);
	}
	// shader used to display depth texture
	getDepthTextureShaderDesc() {
		return this.getShaderDesc(
			"depthTextureShader",
			`
			#include "screenDepthPS"
			#include "gammaPS"
			varying vec2 uv0;
			void main() {
				float depth = getLinearScreenDepth(getImageEffectUV(uv0)) * camera_params.x;
				gl_FragColor = vec4(gammaCorrectOutput(vec3(depth)), 1.0);
			}
		`,
			`
			#include "screenDepthPS"
			#include "gammaPS"
			varying uv0: vec2f;
			@fragment fn fragmentMain(input: FragmentInput) -> FragmentOutput {
				var output: FragmentOutput;
				let depth: f32 = getLinearScreenDepth(getImageEffectUV(input.uv0)) * uniform.camera_params.x;
				output.color = vec4f(gammaCorrectOutput(vec3f(depth)), 1.0);
				return output;
			}
		`
		);
	}
	// creates mesh used to render a quad
	getQuadMesh() {
		if (!this.quadMesh) {
			this.quadMesh = new Mesh(this.device);
			this.quadMesh.setPositions([
				-0.5,
				-0.5,
				0,
				0.5,
				-0.5,
				0,
				-0.5,
				0.5,
				0,
				0.5,
				0.5,
				0
			]);
			this.quadMesh.update(PRIMITIVE_TRISTRIP);
		}
		return this.quadMesh;
	}
	// Draw mesh at this frame
	drawMesh(material, matrix2, mesh, meshInstance, layer) {
		if (!meshInstance) {
			const graphNode = this.getGraphNode(matrix2);
			meshInstance = new MeshInstance(mesh, material, graphNode);
		}
		let layerMeshInstances = this.layerMeshInstances.get(layer);
		if (!layerMeshInstances) {
			layerMeshInstances = [];
			this.layerMeshInstances.set(layer, layerMeshInstances);
		}
		layerMeshInstances.push(meshInstance);
	}
	drawWireAlignedBox(min, max, color3, depthTest, layer, mat2) {
		if (mat2) {
			const mulPoint = (x3, y2, z2) => {
				vec.set(x3, y2, z2);
				mat2.transformPoint(vec, vec);
				tempPoints.push(vec.x, vec.y, vec.z);
			};
			mulPoint(min.x, min.y, min.z);
			mulPoint(min.x, max.y, min.z);
			mulPoint(min.x, max.y, min.z);
			mulPoint(max.x, max.y, min.z);
			mulPoint(max.x, max.y, min.z);
			mulPoint(max.x, min.y, min.z);
			mulPoint(max.x, min.y, min.z);
			mulPoint(min.x, min.y, min.z);
			mulPoint(min.x, min.y, max.z);
			mulPoint(min.x, max.y, max.z);
			mulPoint(min.x, max.y, max.z);
			mulPoint(max.x, max.y, max.z);
			mulPoint(max.x, max.y, max.z);
			mulPoint(max.x, min.y, max.z);
			mulPoint(max.x, min.y, max.z);
			mulPoint(min.x, min.y, max.z);
			mulPoint(min.x, min.y, min.z);
			mulPoint(min.x, min.y, max.z);
			mulPoint(min.x, max.y, min.z);
			mulPoint(min.x, max.y, max.z);
			mulPoint(max.x, max.y, min.z);
			mulPoint(max.x, max.y, max.z);
			mulPoint(max.x, min.y, min.z);
			mulPoint(max.x, min.y, max.z);
		} else {
			tempPoints.push(
				min.x,
				min.y,
				min.z,
				min.x,
				max.y,
				min.z,
				min.x,
				max.y,
				min.z,
				max.x,
				max.y,
				min.z,
				max.x,
				max.y,
				min.z,
				max.x,
				min.y,
				min.z,
				max.x,
				min.y,
				min.z,
				min.x,
				min.y,
				min.z,
				min.x,
				min.y,
				max.z,
				min.x,
				max.y,
				max.z,
				min.x,
				max.y,
				max.z,
				max.x,
				max.y,
				max.z,
				max.x,
				max.y,
				max.z,
				max.x,
				min.y,
				max.z,
				max.x,
				min.y,
				max.z,
				min.x,
				min.y,
				max.z,
				min.x,
				min.y,
				min.z,
				min.x,
				min.y,
				max.z,
				min.x,
				max.y,
				min.z,
				min.x,
				max.y,
				max.z,
				max.x,
				max.y,
				min.z,
				max.x,
				max.y,
				max.z,
				max.x,
				min.y,
				min.z,
				max.x,
				min.y,
				max.z
			);
		}
		const batch = this.getBatch(layer, depthTest);
		batch.addLinesArrays(tempPoints, color3);
		tempPoints.length = 0;
	}
	drawWireSphere(center2, radius, color3, numSegments, depthTest, layer) {
		const step = 2 * Math.PI / numSegments;
		let angle = 0;
		for (let i2 = 0; i2 < numSegments; i2++) {
			const sin0 = Math.sin(angle);
			const cos0 = Math.cos(angle);
			angle += step;
			const sin1 = Math.sin(angle);
			const cos1 = Math.cos(angle);
			tempPoints.push(center2.x + radius * sin0, center2.y, center2.z + radius * cos0);
			tempPoints.push(center2.x + radius * sin1, center2.y, center2.z + radius * cos1);
			tempPoints.push(center2.x + radius * sin0, center2.y + radius * cos0, center2.z);
			tempPoints.push(center2.x + radius * sin1, center2.y + radius * cos1, center2.z);
			tempPoints.push(center2.x, center2.y + radius * sin0, center2.z + radius * cos0);
			tempPoints.push(center2.x, center2.y + radius * sin1, center2.z + radius * cos1);
		}
		const batch = this.getBatch(layer, depthTest);
		batch.addLinesArrays(tempPoints, color3);
		tempPoints.length = 0;
	}
	getGraphNode(matrix2) {
		const graphNode = new GraphNode("ImmediateDebug");
		graphNode.worldTransform = matrix2;
		graphNode._dirtyWorld = graphNode._dirtyNormal = false;
		return graphNode;
	}
	// This is called just before the layer is rendered to allow lines for the layer to be added from inside
	// the frame getting rendered
	onPreRenderLayer(layer, visibleList, transparent) {
		this.batchesMap.forEach((batches, batchLayer) => {
			if (batchLayer === layer) {
				batches.onPreRender(visibleList, transparent);
			}
		});
		if (!this.updatedLayers.has(layer)) {
			this.updatedLayers.add(layer);
			const meshInstances = this.layerMeshInstances.get(layer);
			if (meshInstances) {
				for (let i2 = 0; i2 < meshInstances.length; i2++) {
					visibleList.push(meshInstances[i2]);
				}
				meshInstances.length = 0;
			}
		}
	}
	// called after the frame was rendered, clears data
	onPostRender() {
		this.allBatches.forEach((batch) => batch.clear());
		this.allBatches.clear();
		this.updatedLayers.clear();
	}
};

var FogParams = class {
	type = FOG_NONE;
	color = new Color(0, 0, 0);
	density = 0;
	start = 1;
	end = 1e3;
};

var Scene = class extends EventHandler {
	static EVENT_SETLAYERS = "set:layers";
	static EVENT_SETSKYBOX = "set:skybox";
	static EVENT_PRERENDER = "prerender";
	static EVENT_POSTRENDER = "postrender";
	static EVENT_PRERENDER_LAYER = "prerender:layer";
	static EVENT_POSTRENDER_LAYER = "postrender:layer";
	static EVENT_PRECULL = "precull";
	static EVENT_POSTCULL = "postcull";
	ambientBake = false;
	ambientBakeOcclusionBrightness = 0;
	ambientBakeOcclusionContrast = 0;
	ambientLight = new Color(0, 0, 0);
	ambientLuminance = 0;
	exposure = 1;
	lightmapSizeMultiplier = 1;
	lightmapMaxResolution = 2048;
	lightmapMode = BAKE_COLORDIR;
	lightmapFilterEnabled = false;
	lightmapHDR = false;
	root = null;
	physicalUnits = false;
	_envAtlas = null;
	_skyboxCubeMap = null;
	_fogParams = new FogParams();
	forcePassThroughSpecular = false;
	constructor(graphicsDevice) {
		super();
		this.device = graphicsDevice;
		this._gravity = new Vec3(0, -9.8, 0);
		this._layers = null;
		this._prefilteredCubemaps = [];
		this._internalEnvAtlas = null;
		this._skyboxIntensity = 1;
		this._skyboxLuminance = 0;
		this._skyboxMip = 0;
		this._skyboxHighlightMultiplier = 1;
		this._skyboxRotationShaderInclude = false;
		this._skyboxRotation = new Quat();
		this._skyboxRotationMat3 = new Mat3();
		this._skyboxRotationMat4 = new Mat4();
		this._ambientBakeNumSamples = 1;
		this._ambientBakeSpherePart = 0.4;
		this._lightmapFilterRange = 10;
		this._lightmapFilterSmoothness = 0.2;
		this._clusteredLightingEnabled = true;
		this._lightingParams = new LightingParams(this.device.supportsAreaLights, this.device.maxTextureSize, () => {
			this.updateShaders = true;
		});
		this.gsplatCentersEnabled = true;
		this._gsplatParams = new GSplatParams(this.device);
		this._sky = new Sky(this);
		this._stats = {
			meshInstances: 0,
			lights: 0,
			dynamicLights: 0,
			bakedLights: 0,
			updateShadersTime: 0
			// deprecated
		};
		this.updateShaders = true;
		this._shaderVersion = 0;
		this.immediate = new Immediate(this.device);
	}
	get defaultDrawLayer() {
		return this.layers.getLayerById(LAYERID_IMMEDIATE);
	}
	set ambientBakeNumSamples(value) {
		this._ambientBakeNumSamples = math.clamp(Math.floor(value), 1, 255);
	}
	get ambientBakeNumSamples() {
		return this._ambientBakeNumSamples;
	}
	set ambientBakeSpherePart(value) {
		this._ambientBakeSpherePart = math.clamp(value, 1e-3, 1);
	}
	get ambientBakeSpherePart() {
		return this._ambientBakeSpherePart;
	}
	set clusteredLightingEnabled(value) {
		if (this.device.isWebGPU && !value) {
			return;
		}
		if (!this._clusteredLightingEnabled && value) {
			console.error("Turning on disabled clustered lighting is not currently supported");
			return;
		}
		this._clusteredLightingEnabled = value;
	}
	get clusteredLightingEnabled() {
		return this._clusteredLightingEnabled;
	}
	set envAtlas(value) {
		if (value !== this._envAtlas) {
			this._envAtlas = value;
			if (value) {
				value.addressU = ADDRESS_CLAMP_TO_EDGE;
				value.addressV = ADDRESS_CLAMP_TO_EDGE;
				value.minFilter = FILTER_LINEAR;
				value.magFilter = FILTER_LINEAR;
				value.mipmaps = false;
			}
			this._prefilteredCubemaps = [];
			if (this._internalEnvAtlas) {
				this._internalEnvAtlas.destroy();
				this._internalEnvAtlas = null;
			}
			this._resetSkyMesh();
		}
	}
	get envAtlas() {
		return this._envAtlas;
	}
	set layers(layers) {
		const prev = this._layers;
		this._layers = layers;
		this.fire("set:layers", prev, layers);
	}
	get layers() {
		return this._layers;
	}
	get sky() {
		return this._sky;
	}
	get lighting() {
		return this._lightingParams;
	}
	get gsplat() {
		return this._gsplatParams;
	}
	get fog() {
		return this._fogParams;
	}
	set lightmapFilterRange(value) {
		this._lightmapFilterRange = Math.max(value, 1e-3);
	}
	get lightmapFilterRange() {
		return this._lightmapFilterRange;
	}
	set lightmapFilterSmoothness(value) {
		this._lightmapFilterSmoothness = Math.max(value, 1e-3);
	}
	get lightmapFilterSmoothness() {
		return this._lightmapFilterSmoothness;
	}
	set prefilteredCubemaps(value) {
		value = value || [];
		const cubemaps = this._prefilteredCubemaps;
		const changed = cubemaps.length !== value.length || cubemaps.some((c2, i2) => c2 !== value[i2]);
		if (changed) {
			const complete = value.length === 6 && value.every((c2) => !!c2);
			if (complete) {
				this._internalEnvAtlas = EnvLighting.generatePrefilteredAtlas(value, {
					target: this._internalEnvAtlas
				});
				this._envAtlas = this._internalEnvAtlas;
			} else {
				if (this._internalEnvAtlas) {
					this._internalEnvAtlas.destroy();
					this._internalEnvAtlas = null;
				}
				this._envAtlas = null;
			}
			this._prefilteredCubemaps = value.slice();
			this._resetSkyMesh();
		}
	}
	get prefilteredCubemaps() {
		return this._prefilteredCubemaps;
	}
	set skybox(value) {
		if (value !== this._skyboxCubeMap) {
			this._skyboxCubeMap = value;
			this._resetSkyMesh();
		}
	}
	get skybox() {
		return this._skyboxCubeMap;
	}
	set skyboxIntensity(value) {
		if (value !== this._skyboxIntensity) {
			this._skyboxIntensity = value;
			this._resetSkyMesh();
		}
	}
	get skyboxIntensity() {
		return this._skyboxIntensity;
	}
	set skyboxLuminance(value) {
		if (value !== this._skyboxLuminance) {
			this._skyboxLuminance = value;
			this._resetSkyMesh();
		}
	}
	get skyboxLuminance() {
		return this._skyboxLuminance;
	}
	set skyboxMip(value) {
		if (value !== this._skyboxMip) {
			this._skyboxMip = value;
			this._resetSkyMesh();
		}
	}
	get skyboxMip() {
		return this._skyboxMip;
	}
	set skyboxHighlightMultiplier(value) {
		if (value !== this._skyboxHighlightMultiplier) {
			this._skyboxHighlightMultiplier = value;
			this._resetSkyMesh();
		}
	}
	get skyboxHighlightMultiplier() {
		return this._skyboxHighlightMultiplier;
	}
	set skyboxRotation(value) {
		if (!this._skyboxRotation.equals(value)) {
			const isIdentity = value.equals(Quat.IDENTITY);
			this._skyboxRotation.copy(value);
			if (isIdentity) {
				this._skyboxRotationMat3.setIdentity();
			} else {
				this._skyboxRotationMat4.setTRS(Vec3.ZERO, value, Vec3.ONE);
				this._skyboxRotationMat3.invertMat4(this._skyboxRotationMat4);
			}
			if (!this._skyboxRotationShaderInclude && !isIdentity) {
				this._skyboxRotationShaderInclude = true;
				this._resetSkyMesh();
			}
		}
	}
	get skyboxRotation() {
		return this._skyboxRotation;
	}
	destroy() {
		this._sky.destroy();
		this.root = null;
		this.off();
	}
	drawLine(start, end, color3 = Color.WHITE, depthTest = true, layer = this.defaultDrawLayer) {
		const batch = this.immediate.getBatch(layer, depthTest);
		batch.addLines([start, end], [color3, color3]);
	}
	drawLines(positions, colors, depthTest = true, layer = this.defaultDrawLayer) {
		const batch = this.immediate.getBatch(layer, depthTest);
		batch.addLines(positions, colors);
	}
	drawLineArrays(positions, colors, depthTest = true, layer = this.defaultDrawLayer) {
		const batch = this.immediate.getBatch(layer, depthTest);
		batch.addLinesArrays(positions, colors);
	}
	applySettings(settings) {
		const physics = settings.physics;
		const render = settings.render;
		this._gravity.set(physics.gravity[0], physics.gravity[1], physics.gravity[2]);
		this.ambientLight.set(render.global_ambient[0], render.global_ambient[1], render.global_ambient[2]);
		this.ambientLuminance = render.ambientLuminance;
		this.fog.type = render.fog;
		this.fog.color.set(render.fog_color[0], render.fog_color[1], render.fog_color[2]);
		this.fog.start = render.fog_start;
		this.fog.end = render.fog_end;
		this.fog.density = render.fog_density;
		this.lightmapSizeMultiplier = render.lightmapSizeMultiplier;
		this.lightmapMaxResolution = render.lightmapMaxResolution;
		this.lightmapMode = render.lightmapMode;
		this.exposure = render.exposure;
		this._skyboxIntensity = render.skyboxIntensity ?? 1;
		this._skyboxLuminance = render.skyboxLuminance ?? 2e4;
		this._skyboxMip = render.skyboxMip ?? 0;
		if (render.skyboxRotation) {
			this.skyboxRotation = new Quat().setFromEulerAngles(render.skyboxRotation[0], render.skyboxRotation[1], render.skyboxRotation[2]);
		}
		this.sky.applySettings(render);
		this.clusteredLightingEnabled = render.clusteredLightingEnabled ?? false;
		this.lighting.applySettings(render);
		this.gsplat.applySettings(render);
		[
			"lightmapFilterEnabled",
			"lightmapFilterRange",
			"lightmapFilterSmoothness",
			"ambientBake",
			"ambientBakeNumSamples",
			"ambientBakeSpherePart",
			"ambientBakeOcclusionBrightness",
			"ambientBakeOcclusionContrast"
		].forEach((setting) => {
			if (render.hasOwnProperty(setting)) {
				this[setting] = render[setting];
			}
		});
		this._resetSkyMesh();
	}
	// get the actual texture to use for skybox rendering
	_getSkyboxTex() {
		const cubemaps = this._prefilteredCubemaps;
		if (this._skyboxMip) {
			const skyboxMapping = [
				0,
				1,
				/* 2 */
				3,
				4,
				5,
				6
			];
			return cubemaps[skyboxMapping[this._skyboxMip]] || this._envAtlas || cubemaps[0] || this._skyboxCubeMap;
		}
		return this._skyboxCubeMap || cubemaps[0] || this._envAtlas;
	}
	_updateSkyMesh() {
		if (!this.sky.skyMesh) {
			this.sky.updateSkyMesh();
		}
		this.sky.update();
	}
	_resetSkyMesh() {
		this.sky.resetSkyMesh();
		this.updateShaders = true;
	}
	setSkybox(cubemaps) {
		if (!cubemaps) {
			this.skybox = null;
			this.envAtlas = null;
		} else {
			this.skybox = cubemaps[0] || null;
			if (cubemaps[1] && !cubemaps[1].cubemap) {
				this.envAtlas = cubemaps[1];
			} else {
				this.prefilteredCubemaps = cubemaps.slice(1);
			}
		}
	}
	get lightmapPixelFormat() {
		return this.lightmapHDR && this.device.getRenderableHdrFormat() || PIXELFORMAT_RGBA8;
	}
	// ---- deprecated block start ----
	get defaultMaterial() {
		return getDefaultMaterial(this.device);
	}
	set fogColor(value) {
		this.fog.color = value;
	}
	get fogColor() {
		return this.fog.color;
	}
	set fogEnd(value) {
		this.fog.end = value;
	}
	get fogEnd() {
		return this.fog.end;
	}
	set fogStart(value) {
		this.fog.start = value;
	}
	get fogStart() {
		return this.fog.start;
	}
	set fogDensity(value) {
		this.fog.density = value;
	}
	get fogDensity() {
		return this.fog.density;
	}
	set skyboxPrefiltered128(value) {
		this._prefilteredCubemaps[0] = value;
		this.updateShaders = true;
	}
	get skyboxPrefiltered128() {
		return this._prefilteredCubemaps[0];
	}
	set skyboxPrefiltered64(value) {
		this._prefilteredCubemaps[1] = value;
		this.updateShaders = true;
	}
	get skyboxPrefiltered64() {
		return this._prefilteredCubemaps[1];
	}
	set skyboxPrefiltered32(value) {
		this._prefilteredCubemaps[2] = value;
		this.updateShaders = true;
	}
	get skyboxPrefiltered32() {
		return this._prefilteredCubemaps[2];
	}
	set skyboxPrefiltered16(value) {
		this._prefilteredCubemaps[3] = value;
		this.updateShaders = true;
	}
	get skyboxPrefiltered16() {
		return this._prefilteredCubemaps[3];
	}
	set skyboxPrefiltered8(value) {
		this._prefilteredCubemaps[4] = value;
		this.updateShaders = true;
	}
	get skyboxPrefiltered8() {
		return this._prefilteredCubemaps[4];
	}
	set skyboxPrefiltered4(value) {
		this._prefilteredCubemaps[5] = value;
		this.updateShaders = true;
	}
	get skyboxPrefiltered4() {
		return this._prefilteredCubemaps[5];
	}
	get models() {
		this._models ?? (this._models = []);
		return this._models;
	}
	// ---- deprecated block end ----
};

var Skin = class {
	constructor(graphicsDevice, ibp, boneNames) {
		this.device = graphicsDevice;
		this.inverseBindPose = ibp;
		this.boneNames = boneNames;
	}
};

var spriteNormals = [
	0,
	0,
	1,
	0,
	0,
	1,
	0,
	0,
	1,
	0,
	0,
	1
];
var spriteIndices = [
	0,
	1,
	3,
	2,
	3,
	1
];
var Sprite = class extends EventHandler {
	constructor(device, options2) {
		super();
		this._device = device;
		this._pixelsPerUnit = options2 && options2.pixelsPerUnit !== void 0 ? options2.pixelsPerUnit : 1;
		this._renderMode = options2 && options2.renderMode !== void 0 ? options2.renderMode : SPRITE_RENDERMODE_SIMPLE;
		this._atlas = options2 && options2.atlas !== void 0 ? options2.atlas : null;
		this._frameKeys = options2 && options2.frameKeys !== void 0 ? options2.frameKeys : null;
		this._meshes = [];
		this._updatingProperties = false;
		this._meshesDirty = false;
		if (this._atlas && this._frameKeys) {
			this._createMeshes();
		}
	}
	set frameKeys(value) {
		this._frameKeys = value;
		if (this._atlas && this._frameKeys) {
			if (this._updatingProperties) {
				this._meshesDirty = true;
			} else {
				this._createMeshes();
			}
		}
		this.fire("set:frameKeys", value);
	}
	get frameKeys() {
		return this._frameKeys;
	}
	set atlas(value) {
		if (value === this._atlas) return;
		if (this._atlas) {
			this._atlas.off("set:frames", this._onSetFrames, this);
			this._atlas.off("set:frame", this._onFrameChanged, this);
			this._atlas.off("remove:frame", this._onFrameRemoved, this);
		}
		this._atlas = value;
		if (this._atlas && this._frameKeys) {
			this._atlas.on("set:frames", this._onSetFrames, this);
			this._atlas.on("set:frame", this._onFrameChanged, this);
			this._atlas.on("remove:frame", this._onFrameRemoved, this);
			if (this._updatingProperties) {
				this._meshesDirty = true;
			} else {
				this._createMeshes();
			}
		}
		this.fire("set:atlas", value);
	}
	get atlas() {
		return this._atlas;
	}
	set pixelsPerUnit(value) {
		if (this._pixelsPerUnit === value) return;
		this._pixelsPerUnit = value;
		this.fire("set:pixelsPerUnit", value);
		if (this._atlas && this._frameKeys && this.renderMode === SPRITE_RENDERMODE_SIMPLE) {
			if (this._updatingProperties) {
				this._meshesDirty = true;
			} else {
				this._createMeshes();
			}
		}
	}
	get pixelsPerUnit() {
		return this._pixelsPerUnit;
	}
	set renderMode(value) {
		if (this._renderMode === value) {
			return;
		}
		const prev = this._renderMode;
		this._renderMode = value;
		this.fire("set:renderMode", value);
		if (prev === SPRITE_RENDERMODE_SIMPLE || value === SPRITE_RENDERMODE_SIMPLE) {
			if (this._atlas && this._frameKeys) {
				if (this._updatingProperties) {
					this._meshesDirty = true;
				} else {
					this._createMeshes();
				}
			}
		}
	}
	get renderMode() {
		return this._renderMode;
	}
	get meshes() {
		return this._meshes;
	}
	_createMeshes() {
		const len = this._meshes.length;
		for (let i2 = 0; i2 < len; i2++) {
			const mesh = this._meshes[i2];
			if (mesh) {
				mesh.destroy();
			}
		}
		const count = this._frameKeys.length;
		this._meshes = new Array(count);
		const createMeshFunc = this.renderMode === SPRITE_RENDERMODE_SLICED || this._renderMode === SPRITE_RENDERMODE_TILED ? this._create9SliceMesh : this._createSimpleMesh;
		for (let i2 = 0; i2 < count; i2++) {
			const frame = this._atlas.frames[this._frameKeys[i2]];
			this._meshes[i2] = frame ? createMeshFunc.call(this, frame) : null;
		}
		this.fire("set:meshes");
	}
	_createSimpleMesh(frame) {
		const rect = frame.rect;
		const texWidth = this._atlas.texture.width;
		const texHeight = this._atlas.texture.height;
		const w = rect.z / this._pixelsPerUnit;
		const h2 = rect.w / this._pixelsPerUnit;
		const hp = frame.pivot.x;
		const vp = frame.pivot.y;
		const positions = [
			-hp * w,
			-vp * h2,
			0,
			(1 - hp) * w,
			-vp * h2,
			0,
			(1 - hp) * w,
			(1 - vp) * h2,
			0,
			-hp * w,
			(1 - vp) * h2,
			0
		];
		const lu = rect.x / texWidth;
		const bv = 1 - rect.y / texHeight;
		const ru = (rect.x + rect.z) / texWidth;
		const tv = 1 - (rect.y + rect.w) / texHeight;
		const uvs = [
			lu,
			bv,
			ru,
			bv,
			ru,
			tv,
			lu,
			tv
		];
		const geom = new Geometry();
		geom.positions = positions;
		geom.normals = spriteNormals;
		geom.uvs = uvs;
		geom.indices = spriteIndices;
		return Mesh.fromGeometry(this._device, geom);
	}
	_create9SliceMesh() {
		const he = Vec2.ONE;
		const ws = 3;
		const ls = 3;
		const positions = [];
		const normals = [];
		const uvs = [];
		const indices = [];
		let vcounter = 0;
		for (let i2 = 0; i2 <= ws; i2++) {
			const u = i2 === 0 || i2 === ws ? 0 : 1;
			for (let j = 0; j <= ls; j++) {
				const x3 = -he.x + 2 * he.x * (i2 <= 1 ? 0 : 3) / ws;
				const y2 = 0;
				const z2 = -(-he.y + 2 * he.y * (j <= 1 ? 0 : 3) / ls);
				const v6 = j === 0 || j === ls ? 0 : 1;
				positions.push(-x3, y2, z2);
				normals.push(0, 1, 0);
				uvs.push(u, v6);
				if (i2 < ws && j < ls) {
					indices.push(vcounter + ls + 1, vcounter + 1, vcounter);
					indices.push(vcounter + ls + 1, vcounter + ls + 2, vcounter + 1);
				}
				vcounter++;
			}
		}
		const geom = new Geometry();
		geom.positions = positions;
		geom.normals = normals;
		geom.uvs = uvs;
		geom.indices = indices;
		return Mesh.fromGeometry(this._device, geom);
	}
	_onSetFrames(frames) {
		if (this._updatingProperties) {
			this._meshesDirty = true;
		} else {
			this._createMeshes();
		}
	}
	_onFrameChanged(frameKey, frame) {
		const idx = this._frameKeys.indexOf(frameKey);
		if (idx < 0) return;
		if (frame) {
			if (this.renderMode === SPRITE_RENDERMODE_SIMPLE) {
				this._meshes[idx] = this._createSimpleMesh(frame);
			}
		} else {
			this._meshes[idx] = null;
		}
		this.fire("set:meshes");
	}
	_onFrameRemoved(frameKey) {
		const idx = this._frameKeys.indexOf(frameKey);
		if (idx < 0) return;
		this._meshes[idx] = null;
		this.fire("set:meshes");
	}
	startUpdate() {
		this._updatingProperties = true;
		this._meshesDirty = false;
	}
	endUpdate() {
		this._updatingProperties = false;
		if (this._meshesDirty && this._atlas && this._frameKeys) {
			this._createMeshes();
		}
		this._meshesDirty = false;
	}
	destroy() {
		for (const mesh of this._meshes) {
			if (mesh) {
				mesh.destroy();
			}
		}
		this._meshes.length = 0;
	}
};

var TextureAtlas = class extends EventHandler {
	constructor() {
		super();
		this._texture = null;
		this._frames = null;
	}
	set texture(value) {
		this._texture = value;
		this.fire("set:texture", value);
	}
	get texture() {
		return this._texture;
	}
	set frames(value) {
		this._frames = value;
		this.fire("set:frames", value);
	}
	get frames() {
		return this._frames;
	}
	setFrame(key, data2) {
		let frame = this._frames[key];
		if (!frame) {
			frame = {
				rect: data2.rect.clone(),
				pivot: data2.pivot.clone(),
				border: data2.border.clone()
			};
			this._frames[key] = frame;
		} else {
			frame.rect.copy(data2.rect);
			frame.pivot.copy(data2.pivot);
			frame.border.copy(data2.border);
		}
		this.fire("set:frame", key.toString(), frame);
	}
	removeFrame(key) {
		const frame = this._frames[key];
		if (frame) {
			delete this._frames[key];
			this.fire("remove:frame", key.toString(), frame);
		}
	}
	destroy() {
		if (this._texture) {
			this._texture.destroy();
		}
	}
};

var AnimationKey = class {
	constructor(time, position5, rotation7, scale2) {
		this.time = time;
		this.position = position5;
		this.rotation = rotation7;
		this.scale = scale2;
	}
};
var AnimationNode = class {
	constructor() {
		this._name = "";
		this._keys = [];
	}
};
var Animation = class {
	name = "";
	duration = 0;
	constructor() {
		this._nodes = [];
		this._nodeDict = {};
	}
	getNode(name) {
		return this._nodeDict[name];
	}
	addNode(node) {
		this._nodes.push(node);
		this._nodeDict[node._name] = node;
	}
	get nodes() {
		return this._nodes;
	}
};

var InterpolatedKey = class {
	constructor() {
		this._written = false;
		this._name = "";
		this._keyFrames = [];
		this._quat = new Quat();
		this._pos = new Vec3();
		this._scale = new Vec3();
		this._targetNode = null;
	}
	getTarget() {
		return this._targetNode;
	}
	setTarget(node) {
		this._targetNode = node;
	}
};
var Skeleton = class {
	looping = true;
	constructor(graph) {
		this._animation = null;
		this._time = 0;
		this._interpolatedKeys = [];
		this._interpolatedKeyDict = {};
		this._currKeyIndices = {};
		this.graph = null;
		const addInterpolatedKeys = (node) => {
			const interpKey = new InterpolatedKey();
			interpKey._name = node.name;
			this._interpolatedKeys.push(interpKey);
			this._interpolatedKeyDict[node.name] = interpKey;
			this._currKeyIndices[node.name] = 0;
			for (let i2 = 0; i2 < node._children.length; i2++) {
				addInterpolatedKeys(node._children[i2]);
			}
		};
		addInterpolatedKeys(graph);
	}
	set animation(value) {
		this._animation = value;
		this.currentTime = 0;
	}
	get animation() {
		return this._animation;
	}
	set currentTime(value) {
		this._time = value;
		const numNodes = this._interpolatedKeys.length;
		for (let i2 = 0; i2 < numNodes; i2++) {
			const node = this._interpolatedKeys[i2];
			const nodeName = node._name;
			this._currKeyIndices[nodeName] = 0;
		}
		this.addTime(0);
		this.updateGraph();
	}
	get currentTime() {
		return this._time;
	}
	get numNodes() {
		return this._interpolatedKeys.length;
	}
	addTime(delta3) {
		if (this._animation !== null) {
			const nodes = this._animation._nodes;
			const duration = this._animation.duration;
			if (this._time === duration && !this.looping) {
				return;
			}
			this._time += delta3;
			if (this._time > duration) {
				this._time = this.looping ? 0 : duration;
				for (let i2 = 0; i2 < nodes.length; i2++) {
					const node = nodes[i2];
					const nodeName = node._name;
					this._currKeyIndices[nodeName] = 0;
				}
			} else if (this._time < 0) {
				this._time = this.looping ? duration : 0;
				for (let i2 = 0; i2 < nodes.length; i2++) {
					const node = nodes[i2];
					const nodeName = node._name;
					this._currKeyIndices[nodeName] = node._keys.length - 2;
				}
			}
			const offset3 = delta3 >= 0 ? 1 : -1;
			for (let i2 = 0; i2 < nodes.length; i2++) {
				const node = nodes[i2];
				const nodeName = node._name;
				const keys = node._keys;
				const interpKey = this._interpolatedKeyDict[nodeName];
				if (interpKey === void 0) {
					continue;
				}
				let foundKey = false;
				if (keys.length !== 1) {
					for (let currKeyIndex = this._currKeyIndices[nodeName]; currKeyIndex < keys.length - 1 && currKeyIndex >= 0; currKeyIndex += offset3) {
						const k1 = keys[currKeyIndex];
						const k2 = keys[currKeyIndex + 1];
						if (k1.time <= this._time && k2.time >= this._time) {
							const alpha = (this._time - k1.time) / (k2.time - k1.time);
							interpKey._pos.lerp(k1.position, k2.position, alpha);
							interpKey._quat.slerp(k1.rotation, k2.rotation, alpha);
							interpKey._scale.lerp(k1.scale, k2.scale, alpha);
							interpKey._written = true;
							this._currKeyIndices[nodeName] = currKeyIndex;
							foundKey = true;
							break;
						}
					}
				}
				if (keys.length === 1 || !foundKey && this._time === 0 && this.looping) {
					interpKey._pos.copy(keys[0].position);
					interpKey._quat.copy(keys[0].rotation);
					interpKey._scale.copy(keys[0].scale);
					interpKey._written = true;
				}
			}
		}
	}
	blend(skel1, skel2, alpha) {
		const numNodes = this._interpolatedKeys.length;
		for (let i2 = 0; i2 < numNodes; i2++) {
			const key1 = skel1._interpolatedKeys[i2];
			const key2 = skel2._interpolatedKeys[i2];
			const dstKey = this._interpolatedKeys[i2];
			if (key1._written && key2._written) {
				dstKey._quat.slerp(key1._quat, skel2._interpolatedKeys[i2]._quat, alpha);
				dstKey._pos.lerp(key1._pos, skel2._interpolatedKeys[i2]._pos, alpha);
				dstKey._scale.lerp(key1._scale, key2._scale, alpha);
				dstKey._written = true;
			} else if (key1._written) {
				dstKey._quat.copy(key1._quat);
				dstKey._pos.copy(key1._pos);
				dstKey._scale.copy(key1._scale);
				dstKey._written = true;
			} else if (key2._written) {
				dstKey._quat.copy(key2._quat);
				dstKey._pos.copy(key2._pos);
				dstKey._scale.copy(key2._scale);
				dstKey._written = true;
			}
		}
	}
	setGraph(graph) {
		this.graph = graph;
		if (graph) {
			for (let i2 = 0; i2 < this._interpolatedKeys.length; i2++) {
				const interpKey = this._interpolatedKeys[i2];
				const graphNode = graph.findByName(interpKey._name);
				this._interpolatedKeys[i2].setTarget(graphNode);
			}
		} else {
			for (let i2 = 0; i2 < this._interpolatedKeys.length; i2++) {
				this._interpolatedKeys[i2].setTarget(null);
			}
		}
	}
	updateGraph() {
		if (this.graph) {
			for (let i2 = 0; i2 < this._interpolatedKeys.length; i2++) {
				const interpKey = this._interpolatedKeys[i2];
				if (interpKey._written) {
					const transform = interpKey.getTarget();
					transform.localPosition.copy(interpKey._pos);
					transform.localRotation.copy(interpKey._quat);
					transform.localScale.copy(interpKey._scale);
					if (!transform._dirtyLocal) {
						transform._dirtifyLocal();
					}
					interpKey._written = false;
				}
			}
		}
	}
};

var prefixSumSource = `
@group(0) @binding(0) var<storage, read_write> items: array<u32>;
@group(0) @binding(1) var<storage, read_write> blockSums: array<u32>;
struct PrefixSumUniforms {
	elementCount: u32
};
@group(0) @binding(2) var<uniform> uniforms: PrefixSumUniforms;
const WORKGROUP_SIZE_X: u32 = {WORKGROUP_SIZE_X}u;
const WORKGROUP_SIZE_Y: u32 = {WORKGROUP_SIZE_Y}u;
const THREADS_PER_WORKGROUP: u32 = {THREADS_PER_WORKGROUP}u;
const ITEMS_PER_WORKGROUP: u32 = {ITEMS_PER_WORKGROUP}u;
var<workgroup> temp: array<u32, ITEMS_PER_WORKGROUP * 2>;
@compute @workgroup_size(WORKGROUP_SIZE_X, WORKGROUP_SIZE_Y, 1)
fn reduce_downsweep(
	@builtin(workgroup_id) w_id: vec3<u32>,
	@builtin(num_workgroups) w_dim: vec3<u32>,
	@builtin(local_invocation_index) TID: u32,
) {
	let WORKGROUP_ID = w_id.x + w_id.y * w_dim.x;
	let WID = WORKGROUP_ID * THREADS_PER_WORKGROUP;
	let GID = WID + TID;
	
	let ELM_TID = TID * 2;
	let ELM_GID = GID * 2;
	
	temp[ELM_TID] = select(items[ELM_GID], 0u, ELM_GID >= uniforms.elementCount);
	temp[ELM_TID + 1u] = select(items[ELM_GID + 1u], 0u, ELM_GID + 1u >= uniforms.elementCount);
	var offset: u32 = 1u;
	for (var d: u32 = ITEMS_PER_WORKGROUP >> 1u; d > 0u; d >>= 1u) {
		workgroupBarrier();
		if (TID < d) {
			var ai: u32 = offset * (ELM_TID + 1u) - 1u;
			var bi: u32 = offset * (ELM_TID + 2u) - 1u;
			temp[bi] += temp[ai];
		}
		offset *= 2u;
	}
	if (TID == 0u) {
		let last_offset = ITEMS_PER_WORKGROUP - 1u;
		blockSums[WORKGROUP_ID] = temp[last_offset];
		temp[last_offset] = 0u;
	}
	for (var d: u32 = 1u; d < ITEMS_PER_WORKGROUP; d *= 2u) {
		offset >>= 1u;
		workgroupBarrier();
		if (TID < d) {
			var ai: u32 = offset * (ELM_TID + 1u) - 1u;
			var bi: u32 = offset * (ELM_TID + 2u) - 1u;
			let t: u32 = temp[ai];
			temp[ai] = temp[bi];
			temp[bi] += t;
		}
	}
	workgroupBarrier();
	if (ELM_GID < uniforms.elementCount) {
		items[ELM_GID] = temp[ELM_TID];
	}
	if (ELM_GID + 1u < uniforms.elementCount) {
		items[ELM_GID + 1u] = temp[ELM_TID + 1u];
	}
}
@compute @workgroup_size(WORKGROUP_SIZE_X, WORKGROUP_SIZE_Y, 1)
fn add_block_sums(
	@builtin(workgroup_id) w_id: vec3<u32>,
	@builtin(num_workgroups) w_dim: vec3<u32>,
	@builtin(local_invocation_index) TID: u32,
) {
	let WORKGROUP_ID = w_id.x + w_id.y * w_dim.x;
	let WID = WORKGROUP_ID * THREADS_PER_WORKGROUP;
	let GID = WID + TID;
	let ELM_ID = GID * 2u;
	if (ELM_ID >= uniforms.elementCount) {
		return;
	}
	let blockSum = blockSums[WORKGROUP_ID];
	items[ELM_ID] += blockSum;
	if (ELM_ID + 1u >= uniforms.elementCount) {
		return;
	}
	items[ELM_ID + 1u] += blockSum;
}
`;

var WORKGROUP_SIZE_X = 16;
var WORKGROUP_SIZE_Y = 16;
var THREADS_PER_WORKGROUP = WORKGROUP_SIZE_X * WORKGROUP_SIZE_Y;
var ITEMS_PER_WORKGROUP = 2 * THREADS_PER_WORKGROUP;
var PrefixSumKernel = class {
	device;
	passes = [];
	_uniformBufferFormat = null;
	_bindGroupFormat = null;
	_scanShader = null;
	_addBlockShader = null;
	constructor(device) {
		this.device = device;
		this._createFormatsAndShaders();
	}
	destroy() {
		this.destroyPasses();
		this._scanShader?.destroy();
		this._addBlockShader?.destroy();
		this._bindGroupFormat?.destroy();
		this._scanShader = null;
		this._addBlockShader = null;
		this._bindGroupFormat = null;
		this._uniformBufferFormat = null;
	}
	_createFormatsAndShaders() {
		this._uniformBufferFormat = new UniformBufferFormat(this.device, [
			new UniformFormat("elementCount", UNIFORMTYPE_UINT)
		]);
		this._bindGroupFormat = new BindGroupFormat(this.device, [
			new BindStorageBufferFormat("items", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("blockSums", SHADERSTAGE_COMPUTE, false),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		]);
		this._scanShader = this._createShader("PrefixSumScan", "reduce_downsweep");
		this._addBlockShader = this._createShader("PrefixSumAddBlock", "add_block_sums");
	}
	createPassesRecursive(dataBuffer, count) {
		const workgroupCount = Math.ceil(count / ITEMS_PER_WORKGROUP);
		const { x: dispatchX, y: dispatchY } = this.findOptimalDispatchSize(workgroupCount);
		const blockSumBuffer = new StorageBuffer(this.device, workgroupCount * 4);
		const scanCompute = new Compute(this.device, this._scanShader, "PrefixSumScan");
		scanCompute.setParameter("items", dataBuffer);
		scanCompute.setParameter("blockSums", blockSumBuffer);
		const pass = {
			scanCompute,
			addBlockCompute: null,
			blockSumBuffer,
			dispatchX,
			dispatchY,
			count,
			allocatedCount: count
		};
		this.passes.push(pass);
		if (workgroupCount > 1) {
			this.createPassesRecursive(blockSumBuffer, workgroupCount);
			const addBlockCompute = new Compute(this.device, this._addBlockShader, "PrefixSumAddBlock");
			addBlockCompute.setParameter("items", dataBuffer);
			addBlockCompute.setParameter("blockSums", blockSumBuffer);
			pass.addBlockCompute = addBlockCompute;
		}
	}
	_createShader(name, entryPoint) {
		const cdefines = /* @__PURE__ */ new Map();
		cdefines.set("{WORKGROUP_SIZE_X}", WORKGROUP_SIZE_X);
		cdefines.set("{WORKGROUP_SIZE_Y}", WORKGROUP_SIZE_Y);
		cdefines.set("{THREADS_PER_WORKGROUP}", THREADS_PER_WORKGROUP);
		cdefines.set("{ITEMS_PER_WORKGROUP}", ITEMS_PER_WORKGROUP);
		return new Shader(this.device, {
			name,
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: prefixSumSource,
			cdefines,
			computeEntryPoint: entryPoint,
			computeBindGroupFormat: this._bindGroupFormat,
			computeUniformBufferFormats: { uniforms: this._uniformBufferFormat }
		});
	}
	findOptimalDispatchSize(workgroupCount) {
		const maxDimension = this.device.limits.maxComputeWorkgroupsPerDimension || 65535;
		if (workgroupCount <= maxDimension) {
			return { x: workgroupCount, y: 1 };
		}
		const x3 = Math.floor(Math.sqrt(workgroupCount));
		const y2 = Math.ceil(workgroupCount / x3);
		return { x: x3, y: y2 };
	}
	resize(dataBuffer, count) {
		const requiredPasses = this._countPassesNeeded(count);
		const currentPasses = this.passes.length;
		if (requiredPasses > currentPasses) {
			this.destroyPasses();
			this.createPassesRecursive(dataBuffer, count);
			return;
		}
		let levelCount = count;
		for (let i2 = 0; i2 < this.passes.length; i2++) {
			const workgroupCount = Math.ceil(levelCount / ITEMS_PER_WORKGROUP);
			const { x: dispatchX, y: dispatchY } = this.findOptimalDispatchSize(workgroupCount);
			this.passes[i2].count = levelCount;
			this.passes[i2].dispatchX = dispatchX;
			this.passes[i2].dispatchY = dispatchY;
			levelCount = workgroupCount;
			if (workgroupCount <= 1) {
				break;
			}
		}
	}
	destroyPasses() {
		for (const pass of this.passes) {
			pass.blockSumBuffer?.destroy();
		}
		this.passes.length = 0;
	}
	_countPassesNeeded(count) {
		let passes = 0;
		let levelCount = count;
		while (levelCount > 0) {
			passes++;
			const workgroupCount = Math.ceil(levelCount / ITEMS_PER_WORKGROUP);
			if (workgroupCount <= 1) break;
			levelCount = workgroupCount;
		}
		return passes;
	}
	dispatch(device) {
		for (let i2 = 0; i2 < this.passes.length; i2++) {
			const pass = this.passes[i2];
			pass.scanCompute.setParameter("elementCount", pass.count);
			pass.scanCompute.setupDispatch(pass.dispatchX, pass.dispatchY, 1);
			device.computeDispatch([pass.scanCompute], "PrefixSumScan");
		}
		for (let i2 = this.passes.length - 1; i2 >= 0; i2--) {
			const pass = this.passes[i2];
			if (pass.addBlockCompute) {
				pass.addBlockCompute.setParameter("elementCount", pass.count);
				pass.addBlockCompute.setupDispatch(pass.dispatchX, pass.dispatchY, 1);
				device.computeDispatch([pass.addBlockCompute], "PrefixSumAddBlock");
			}
		}
	}
};

var radixSort4bitSource = `
@group(0) @binding(0) var<storage, read> input: array<u32>;
@group(0) @binding(1) var<storage, read_write> block_sums: array<u32>;
struct RadixSortUniforms {
	workgroupCount: u32,
	elementCount: u32
};
@group(0) @binding(2) var<uniform> uniforms: RadixSortUniforms;
#ifdef USE_INDIRECT_SORT
	@group(0) @binding(3) var<storage, read> sortElementCount: array<u32>;
#endif
const THREADS_PER_WORKGROUP: u32 = {THREADS_PER_WORKGROUP}u;
const WORKGROUP_SIZE_X: u32 = {WORKGROUP_SIZE_X}u;
const WORKGROUP_SIZE_Y: u32 = {WORKGROUP_SIZE_Y}u;
const CURRENT_BIT: u32 = {CURRENT_BIT}u;
const ELEMENTS_PER_THREAD: u32 = {ELEMENTS_PER_THREAD}u;
const ELEMENTS_PER_WORKGROUP: u32 = THREADS_PER_WORKGROUP * ELEMENTS_PER_THREAD;
var<workgroup> histogram: array<atomic<u32>, 16>;
@compute @workgroup_size(WORKGROUP_SIZE_X, WORKGROUP_SIZE_Y, 1)
fn main(
	@builtin(workgroup_id) w_id: vec3<u32>,
	@builtin(num_workgroups) w_dim: vec3<u32>,
	@builtin(local_invocation_index) TID: u32,
) {
	let WORKGROUP_ID = w_id.x + w_id.y * w_dim.x;
	let WID = WORKGROUP_ID * ELEMENTS_PER_WORKGROUP;
	if (TID < 16u) {
		atomicStore(&histogram[TID], 0u);
	}
	workgroupBarrier();
	#ifdef USE_INDIRECT_SORT
		let elementCount = sortElementCount[0];
	#else
		let elementCount = uniforms.elementCount;
	#endif
	for (var r = 0u; r < ELEMENTS_PER_THREAD; r++) {
		let GID = WID + r * THREADS_PER_WORKGROUP + TID;
		let is_valid = GID < elementCount && WORKGROUP_ID < uniforms.workgroupCount;
		if (is_valid) {
			let elm = input[GID];
			let digit = (elm >> CURRENT_BIT) & 0xFu;
			atomicAdd(&histogram[digit], 1u);
		}
	}
	workgroupBarrier();
	if (TID < 16u && WORKGROUP_ID < uniforms.workgroupCount) {
		block_sums[TID * uniforms.workgroupCount + WORKGROUP_ID] = atomicLoad(&histogram[TID]);
	}
}
`;

var radixSortReorderSource = `
@group(0) @binding(0) var<storage, read> inputKeys: array<u32>;
@group(0) @binding(1) var<storage, read_write> outputKeys: array<u32>;
@group(0) @binding(2) var<storage, read> prefix_block_sum: array<u32>;
@group(0) @binding(3) var<storage, read> inputValues: array<u32>;
@group(0) @binding(4) var<storage, read_write> outputValues: array<u32>;
struct RadixSortUniforms {
	workgroupCount: u32,
	elementCount: u32
};
@group(0) @binding(5) var<uniform> uniforms: RadixSortUniforms;
#ifdef USE_INDIRECT_SORT
	@group(0) @binding(6) var<storage, read> sortElementCount: array<u32>;
#endif
const THREADS_PER_WORKGROUP: u32 = {THREADS_PER_WORKGROUP}u;
const WORKGROUP_SIZE_X: u32 = {WORKGROUP_SIZE_X}u;
const WORKGROUP_SIZE_Y: u32 = {WORKGROUP_SIZE_Y}u;
const CURRENT_BIT: u32 = {CURRENT_BIT}u;
const IS_FIRST_PASS: u32 = {IS_FIRST_PASS}u;
const IS_LAST_PASS: u32 = {IS_LAST_PASS}u;
const ELEMENTS_PER_THREAD: u32 = {ELEMENTS_PER_THREAD}u;
const ELEMENTS_PER_WORKGROUP: u32 = THREADS_PER_WORKGROUP * ELEMENTS_PER_THREAD;
var<workgroup> digit_masks: array<atomic<u32>, 128>;
var<workgroup> digit_offsets: array<u32, 16>;
@compute @workgroup_size(WORKGROUP_SIZE_X, WORKGROUP_SIZE_Y, 1)
fn main(
	@builtin(workgroup_id) w_id: vec3<u32>,
	@builtin(num_workgroups) w_dim: vec3<u32>,
	@builtin(local_invocation_index) TID: u32,
) {
	let WORKGROUP_ID = w_id.x + w_id.y * w_dim.x;
	let WID = WORKGROUP_ID * ELEMENTS_PER_WORKGROUP;
	let word_idx = TID >> 5u;
	let bit_idx = TID & 31u;
	if (TID < 16u) {
		digit_offsets[TID] = 0u;
	}
	if (TID < 128u) {
		atomicStore(&digit_masks[TID], 0u);
	}
	workgroupBarrier();
	#ifdef USE_INDIRECT_SORT
		let elementCount = sortElementCount[0];
	#else
		let elementCount = uniforms.elementCount;
	#endif
	for (var round = 0u; round < ELEMENTS_PER_THREAD; round++) {
		let GID = WID + round * THREADS_PER_WORKGROUP + TID;
		let is_valid = GID < elementCount;
		let k = select(0u, inputKeys[GID], is_valid);
		let digit = select(16u, (k >> CURRENT_BIT) & 0xFu, is_valid);
		let v = select(0u, select(inputValues[GID], GID, IS_FIRST_PASS == 1u), is_valid);
		if (is_valid) {
			atomicOr(&digit_masks[digit * 8u + word_idx], 1u << bit_idx);
		}
		workgroupBarrier();
		if (is_valid) {
			let base = digit * 8u;
			var local_prefix = digit_offsets[digit];
			for (var w = 0u; w < word_idx; w++) {
				local_prefix += countOneBits(atomicLoad(&digit_masks[base + w]));
			}
			local_prefix += countOneBits(atomicLoad(&digit_masks[base + word_idx]) & ((1u << bit_idx) - 1u));
			let pid = digit * uniforms.workgroupCount + WORKGROUP_ID;
			let sorted_position = prefix_block_sum[pid] + local_prefix;
			if (IS_LAST_PASS == 0u) {
				outputKeys[sorted_position] = k;
			}
			outputValues[sorted_position] = v;
		}
		if (round < ELEMENTS_PER_THREAD - 1u) {
			workgroupBarrier();
			if (TID < 16u) {
				var count = 0u;
				for (var w = 0u; w < 8u; w++) {
					let idx = TID * 8u + w;
					count += countOneBits(atomicLoad(&digit_masks[idx]));
					atomicStore(&digit_masks[idx], 0u);
				}
				digit_offsets[TID] += count;
			}
			workgroupBarrier();
		}
	}
}
`;

var ComputeRadixSortBase = class {
	device;
	_indirect = false;
	constructor(device, indirect = false) {
		this.device = device;
		this._indirect = indirect;
	}
	capacity = 0;
	_elementCount = 0;
	_numBits = 0;
	_hasInitialValues = false;
	_skipLastPassKeyWrite = false;
	_destructiveKeys = false;
	_keys0 = null;
	_keys1 = null;
	_values0 = null;
	_values1 = null;
	_indirectInfo = new Uint32Array(4);
	get sortedIndices() {
		if (!this._values0) return null;
		const numPasses = this._numBits / this.radixBits;
		return numPasses % 2 === 1 ? this._values1 : this._values0;
	}
	get sortedKeys() {
		if (!this._keys0) {
			return null;
		}
		const radix = this.radixBits;
		const numPasses = this._numBits / radix;
		return numPasses % 2 === 0 ? this._keys1 : this._keys0;
	}
	get radixBits() {
		return 0;
	}
	sort(keysBuffer, elementCount, numBits, initialValues, skipLastPassKeyWrite, destructiveKeys) {
		return null;
	}
	sortIndirect(keysBuffer, maxElementCount, numBits, sortSlotBase, sortElementCountBuffer, initialValues, skipLastPassKeyWrite, destructiveKeys) {
		return null;
	}
	prepareIndirect() {
		return this._indirectInfo;
	}
	_allocatePingPongElementBuffers(effectiveCount) {
		const elementSize = effectiveCount * 4;
		const usage = BUFFERUSAGE_COPY_SRC | BUFFERUSAGE_COPY_DST;
		const device = this.device;
		this._keys0 = new StorageBuffer(device, elementSize, usage);
		if (!this._destructiveKeys) {
			this._keys1 = new StorageBuffer(device, elementSize, usage);
		}
		this._values0 = new StorageBuffer(device, elementSize, usage);
		this._values1 = new StorageBuffer(device, elementSize, usage);
	}
	_destroyPingPongBuffers() {
		this._keys0?.destroy();
		if (!this._destructiveKeys) this._keys1?.destroy();
		this._values0?.destroy();
		this._values1?.destroy();
		this._keys0 = null;
		this._keys1 = null;
		this._values0 = null;
		this._values1 = null;
	}
	destroy() {
	}
};

var WORKGROUP_SIZE_X2 = 16;
var WORKGROUP_SIZE_Y2 = 16;
var THREADS_PER_WORKGROUP2 = WORKGROUP_SIZE_X2 * WORKGROUP_SIZE_Y2;
var ELEMENTS_PER_THREAD = 8;
var ELEMENTS_PER_WORKGROUP = THREADS_PER_WORKGROUP2 * ELEMENTS_PER_THREAD;
var BITS_PER_PASS = 4;
var BUCKET_COUNT = 16;
var ComputeRadixSortMultipass = class extends ComputeRadixSortBase {
	_workgroupCount = 0;
	_allocatedWorkgroupCount = 0;
	_blockSums = null;
	_prefixSumKernel = null;
	_dispatchSize = new Vec2(1, 1);
	_histogramBindGroupFormat = null;
	_reorderBindGroupFormat = null;
	_uniformBufferFormat = null;
	_passes = [];
	constructor(device, indirect = false) {
		super(device, indirect);
		const info = this._indirectInfo;
		info[0] = 1;
		info[1] = ELEMENTS_PER_WORKGROUP;
		this._uniformBufferFormat = new UniformBufferFormat(device, [
			new UniformFormat("workgroupCount", UNIFORMTYPE_UINT),
			new UniformFormat("elementCount", UNIFORMTYPE_UINT)
		]);
		const histogramEntries = [
			new BindStorageBufferFormat("input", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("block_sums", SHADERSTAGE_COMPUTE, false),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		];
		const reorderEntries = [
			new BindStorageBufferFormat("inputKeys", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("outputKeys", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("prefix_block_sum", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("inputValues", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("outputValues", SHADERSTAGE_COMPUTE, false),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		];
		if (indirect) {
			histogramEntries.push(new BindStorageBufferFormat("sortElementCount", SHADERSTAGE_COMPUTE, true));
			reorderEntries.push(new BindStorageBufferFormat("sortElementCount", SHADERSTAGE_COMPUTE, true));
		}
		this._histogramBindGroupFormat = new BindGroupFormat(device, histogramEntries);
		this._reorderBindGroupFormat = new BindGroupFormat(device, reorderEntries);
	}
	destroy() {
		this._destroyBuffers();
		this._destroyPasses();
		this._histogramBindGroupFormat?.destroy();
		this._reorderBindGroupFormat?.destroy();
		this._histogramBindGroupFormat = null;
		this._reorderBindGroupFormat = null;
		this._uniformBufferFormat = null;
		super.destroy();
	}
	_destroyPasses() {
		for (const pass of this._passes) {
			pass.histogramCompute.shader?.destroy();
			pass.reorderCompute.shader?.destroy();
		}
		this._passes.length = 0;
		this._numBits = 0;
	}
	_destroyBuffers() {
		this._destroyPingPongBuffers();
		this._blockSums?.destroy();
		this._prefixSumKernel?.destroy();
		this._blockSums = null;
		this._prefixSumKernel = null;
		this._workgroupCount = 0;
		this._allocatedWorkgroupCount = 0;
	}
	get radixBits() {
		return BITS_PER_PASS;
	}
	_createPasses(numBits, hasInitialValues, skipLastPassKeyWrite) {
		this._destroyPasses();
		this._numBits = numBits;
		this._hasInitialValues = hasInitialValues;
		this._skipLastPassKeyWrite = skipLastPassKeyWrite;
		const numPasses = numBits / BITS_PER_PASS;
		const suffix = this._indirect ? "-Indirect" : "";
		for (let pass = 0; pass < numPasses; pass++) {
			const bitOffset = pass * BITS_PER_PASS;
			const isFirstPass = pass === 0 && !hasInitialValues;
			const isLastPass = skipLastPassKeyWrite && pass === numPasses - 1;
			const histogramShader = this._createShader(
				`RadixSort4bit-Histogram${suffix}-${bitOffset}`,
				radixSort4bitSource,
				bitOffset,
				false,
				false,
				this._histogramBindGroupFormat
			);
			const reorderShader = this._createShader(
				`RadixSort4bit-Reorder${suffix}-${bitOffset}`,
				radixSortReorderSource,
				bitOffset,
				isFirstPass,
				isLastPass,
				this._reorderBindGroupFormat
			);
			const histogramCompute = new Compute(this.device, histogramShader, `RadixSort4bit-Histogram${suffix}-${bitOffset}`);
			const reorderCompute = new Compute(this.device, reorderShader, `RadixSort4bit-Reorder${suffix}-${bitOffset}`);
			this._passes.push({ histogramCompute, reorderCompute });
		}
	}
	_allocateBuffers(elementCount, numBits, hasInitialValues, skipLastPassKeyWrite, forceRealloc = false) {
		const effectiveCount = Math.max(elementCount, this.capacity);
		const allocWorkgroupCount = Math.ceil(effectiveCount / ELEMENTS_PER_WORKGROUP);
		const currentWorkgroupCount = Math.max(1, Math.ceil(elementCount / ELEMENTS_PER_WORKGROUP));
		const buffersNeedRealloc = forceRealloc || allocWorkgroupCount !== this._allocatedWorkgroupCount || !this._keys0;
		const passesNeedRecreate = numBits !== this._numBits || hasInitialValues !== this._hasInitialValues || skipLastPassKeyWrite !== this._skipLastPassKeyWrite;
		if (buffersNeedRealloc) {
			this._destroyBuffers();
			this._allocatedWorkgroupCount = allocWorkgroupCount;
			this.capacity = effectiveCount;
			const blockSumSize = BUCKET_COUNT * allocWorkgroupCount * 4;
			this._allocatePingPongElementBuffers(effectiveCount);
			this._blockSums = new StorageBuffer(this.device, blockSumSize, BUFFERUSAGE_COPY_SRC | BUFFERUSAGE_COPY_DST);
			this._prefixSumKernel = new PrefixSumKernel(this.device);
		}
		this._workgroupCount = currentWorkgroupCount;
		Compute.calcDispatchSize(currentWorkgroupCount, this._dispatchSize, this.device.limits.maxComputeWorkgroupsPerDimension || 65535);
		this._prefixSumKernel.resize(this._blockSums, BUCKET_COUNT * currentWorkgroupCount);
		if (passesNeedRecreate) {
			this._createPasses(numBits, hasInitialValues, skipLastPassKeyWrite);
		}
	}
	_createShader(name, source, currentBit, isFirstPass, isLastPass, bindGroupFormat) {
		const cdefines = /* @__PURE__ */ new Map();
		cdefines.set("{WORKGROUP_SIZE_X}", WORKGROUP_SIZE_X2);
		cdefines.set("{WORKGROUP_SIZE_Y}", WORKGROUP_SIZE_Y2);
		cdefines.set("{THREADS_PER_WORKGROUP}", THREADS_PER_WORKGROUP2);
		cdefines.set("{ELEMENTS_PER_THREAD}", ELEMENTS_PER_THREAD);
		cdefines.set("{CURRENT_BIT}", currentBit);
		cdefines.set("{IS_FIRST_PASS}", isFirstPass ? 1 : 0);
		cdefines.set("{IS_LAST_PASS}", isLastPass ? 1 : 0);
		if (this._indirect) {
			cdefines.set("USE_INDIRECT_SORT", "");
		}
		return new Shader(this.device, {
			name,
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: source,
			cdefines,
			computeBindGroupFormat: bindGroupFormat,
			computeUniformBufferFormats: { uniforms: this._uniformBufferFormat }
		});
	}
	sort(keysBuffer, elementCount, numBits = 16, initialValues, skipLastPassKeyWrite = false, destructiveKeys = false) {
		return this._execute(keysBuffer, elementCount, numBits, -1, null, initialValues, skipLastPassKeyWrite, destructiveKeys);
	}
	sortIndirect(keysBuffer, maxElementCount, numBits, sortSlotBase, sortElementCountBuffer, initialValues, skipLastPassKeyWrite = false, destructiveKeys = false) {
		return this._execute(keysBuffer, maxElementCount, numBits, sortSlotBase, sortElementCountBuffer, initialValues, skipLastPassKeyWrite, destructiveKeys);
	}
	_execute(keysBuffer, elementCount, numBits, sortSlotBase, sortElementCountBuffer, initialValues, skipLastPassKeyWrite = false, destructiveKeys = false) {
		this._elementCount = elementCount;
		const hasInitialValues = !!initialValues;
		const prevDestructiveKeys = this._destructiveKeys;
		this._destructiveKeys = destructiveKeys;
		this._allocateBuffers(elementCount, numBits, hasInitialValues, skipLastPassKeyWrite, destructiveKeys !== prevDestructiveKeys);
		if (destructiveKeys) {
			this._keys1 = keysBuffer;
		}
		const device = this.device;
		const numPasses = numBits / BITS_PER_PASS;
		const suffix = this._indirect ? "-Indirect" : "";
		let currentKeys = keysBuffer;
		let currentValues = initialValues ?? this._values0;
		let nextKeys = this._keys0;
		let nextValues = this._values1;
		for (let pass = 0; pass < numPasses; pass++) {
			const { histogramCompute, reorderCompute } = this._passes[pass];
			const isLastPass = pass === numPasses - 1;
			if (this._indirect) {
				this._blockSums.clear();
			}
			histogramCompute.setParameter("input", currentKeys);
			histogramCompute.setParameter("block_sums", this._blockSums);
			histogramCompute.setParameter("workgroupCount", this._workgroupCount);
			histogramCompute.setParameter("elementCount", elementCount);
			if (this._indirect) {
				histogramCompute.setParameter("sortElementCount", sortElementCountBuffer);
				histogramCompute.setupIndirectDispatch(sortSlotBase);
			} else {
				histogramCompute.setupDispatch(this._dispatchSize.x, this._dispatchSize.y, 1);
			}
			device.computeDispatch([histogramCompute], `RadixSort4bit-Histogram${suffix}`);
			this._prefixSumKernel.dispatch(device);
			reorderCompute.setParameter("inputKeys", currentKeys);
			reorderCompute.setParameter("outputKeys", nextKeys);
			reorderCompute.setParameter("prefix_block_sum", this._blockSums);
			reorderCompute.setParameter("inputValues", currentValues);
			reorderCompute.setParameter("outputValues", nextValues);
			reorderCompute.setParameter("workgroupCount", this._workgroupCount);
			reorderCompute.setParameter("elementCount", elementCount);
			if (this._indirect) {
				reorderCompute.setParameter("sortElementCount", sortElementCountBuffer);
				reorderCompute.setupIndirectDispatch(sortSlotBase);
			} else {
				reorderCompute.setupDispatch(this._dispatchSize.x, this._dispatchSize.y, 1);
			}
			device.computeDispatch([reorderCompute], `RadixSort4bit-Reorder${suffix}`);
			if (!isLastPass) {
				currentKeys = nextKeys;
				nextKeys = currentKeys === this._keys0 ? this._keys1 : this._keys0;
				const tempValues = currentValues;
				currentValues = nextValues;
				nextValues = tempValues;
			}
		}
		return this.sortedIndices;
	}
};

var onesweepGlobalHistSource = `
@group(0) @binding(0) var<storage, read> b_sort: array<vec4<u32>>;
@group(0) @binding(1) var<storage, read_write> b_globalHist: array<atomic<u32>>;
struct OneSweepUniforms {
	numKeys: u32,
	threadBlocks: u32,
	numPasses: u32,
	_pad: u32
};
@group(0) @binding(2) var<uniform> uniforms: OneSweepUniforms;
#ifdef USE_INDIRECT_SORT
@group(0) @binding(3) var<storage, read> b_sortElementCount: array<u32>;
#endif
const RADIX: u32 = 256u;
const MAX_PASSES: u32 = 4u;
const G_HIST_DIM: u32 = {G_HIST_DIM}u;
const G_HIST_PART_SIZE: u32 = {G_HIST_PART_SIZE}u;
const G_HIST_PART_SIZE_VEC: u32 = G_HIST_PART_SIZE / 4u;
const SHARED_HIST_SIZE: u32 = 2u * MAX_PASSES * RADIX;
var<workgroup> g_gHist: array<atomic<u32>, SHARED_HIST_SIZE>;
fn histOffset(row: u32, pass_: u32) -> u32 {
	return row * RADIX + pass_ * 2u * RADIX;
}
@compute @workgroup_size(G_HIST_DIM, 1, 1)
fn main(
	@builtin(local_invocation_index) gtid: u32,
	@builtin(workgroup_id) gid: vec3<u32>,
	@builtin(num_workgroups) nwg: vec3<u32>,
) {
	let flatGid = gid.x + gid.y * nwg.x;
	let numPasses = uniforms.numPasses;
	#ifdef USE_INDIRECT_SORT
		let numKeys = b_sortElementCount[0];
	#else
		let numKeys = uniforms.numKeys;
	#endif
	let sharedEnd = 2u * numPasses * RADIX;
	for (var i = gtid; i < sharedEnd; i = i + G_HIST_DIM) {
		atomicStore(&g_gHist[i], 0u);
	}
	workgroupBarrier();
	let row = gtid / 64u;
	let numKeysVecFull = numKeys >> 2u;
	let partitionStartVec = flatGid * G_HIST_PART_SIZE_VEC;
	let partitionEndVec = min(partitionStartVec + G_HIST_PART_SIZE_VEC, numKeysVecFull);
	for (var i = partitionStartVec + gtid; i < partitionEndVec; i = i + G_HIST_DIM) {
		let q = b_sort[i];
		if (numPasses >= 1u) {
			let off = histOffset(row, 0u);
			atomicAdd(&g_gHist[(q.x		 & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[(q.y		 & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[(q.z		 & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[(q.w		 & 0xFFu) + off], 1u);
		}
		if (numPasses >= 2u) {
			let off = histOffset(row, 1u);
			atomicAdd(&g_gHist[((q.x >>  8u) & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[((q.y >>  8u) & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[((q.z >>  8u) & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[((q.w >>  8u) & 0xFFu) + off], 1u);
		}
		if (numPasses >= 3u) {
			let off = histOffset(row, 2u);
			atomicAdd(&g_gHist[((q.x >> 16u) & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[((q.y >> 16u) & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[((q.z >> 16u) & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[((q.w >> 16u) & 0xFFu) + off], 1u);
		}
		if (numPasses >= 4u) {
			let off = histOffset(row, 3u);
			atomicAdd(&g_gHist[((q.x >> 24u) & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[((q.y >> 24u) & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[((q.z >> 24u) & 0xFFu) + off], 1u);
			atomicAdd(&g_gHist[((q.w >> 24u) & 0xFFu) + off], 1u);
		}
	}
	let tailIdx = numKeysVecFull;
	if ((numKeys & 3u) != 0u &&
		tailIdx >= partitionStartVec &&
		tailIdx <  partitionStartVec + G_HIST_PART_SIZE_VEC &&
		(tailIdx - partitionStartVec) % G_HIST_DIM == gtid) {
		let q = b_sort[tailIdx];
		let base = tailIdx << 2u;
		if (numPasses >= 1u) {
			let off = histOffset(row, 0u);
			if (base + 0u < numKeys) { atomicAdd(&g_gHist[(q.x & 0xFFu) + off], 1u); }
			if (base + 1u < numKeys) { atomicAdd(&g_gHist[(q.y & 0xFFu) + off], 1u); }
			if (base + 2u < numKeys) { atomicAdd(&g_gHist[(q.z & 0xFFu) + off], 1u); }
		}
		if (numPasses >= 2u) {
			let off = histOffset(row, 1u);
			if (base + 0u < numKeys) { atomicAdd(&g_gHist[((q.x >>  8u) & 0xFFu) + off], 1u); }
			if (base + 1u < numKeys) { atomicAdd(&g_gHist[((q.y >>  8u) & 0xFFu) + off], 1u); }
			if (base + 2u < numKeys) { atomicAdd(&g_gHist[((q.z >>  8u) & 0xFFu) + off], 1u); }
		}
		if (numPasses >= 3u) {
			let off = histOffset(row, 2u);
			if (base + 0u < numKeys) { atomicAdd(&g_gHist[((q.x >> 16u) & 0xFFu) + off], 1u); }
			if (base + 1u < numKeys) { atomicAdd(&g_gHist[((q.y >> 16u) & 0xFFu) + off], 1u); }
			if (base + 2u < numKeys) { atomicAdd(&g_gHist[((q.z >> 16u) & 0xFFu) + off], 1u); }
		}
		if (numPasses >= 4u) {
			let off = histOffset(row, 3u);
			if (base + 0u < numKeys) { atomicAdd(&g_gHist[((q.x >> 24u) & 0xFFu) + off], 1u); }
			if (base + 1u < numKeys) { atomicAdd(&g_gHist[((q.y >> 24u) & 0xFFu) + off], 1u); }
			if (base + 2u < numKeys) { atomicAdd(&g_gHist[((q.z >> 24u) & 0xFFu) + off], 1u); }
		}
	}
	workgroupBarrier();
	for (var i = gtid; i < RADIX; i = i + G_HIST_DIM) {
		for (var p = 0u; p < numPasses; p = p + 1u) {
			let row0 = atomicLoad(&g_gHist[i + histOffset(0u, p)]);
			let row1 = atomicLoad(&g_gHist[i + histOffset(1u, p)]);
			let total = row0 + row1;
			if (total != 0u) {
				atomicAdd(&b_globalHist[i + p * RADIX], total);
			}
		}
	}
}
`;

var onesweepScanSource = `
@group(0) @binding(0) var<storage, read> b_globalHist: array<u32>;
@group(0) @binding(1) var<storage, read_write> b_passHist: array<atomic<u32>>;
struct OneSweepScanUniforms {
	threadBlocks: u32,
	_pad0: u32,
	_pad1: u32,
	_pad2: u32
};
@group(0) @binding(2) var<uniform> uniforms: OneSweepScanUniforms;
#ifdef USE_INDIRECT_SORT
@group(0) @binding(3) var<storage, read> b_sortElementCount: array<u32>;
#endif
const RADIX: u32 = 256u;
const FLAG_INCLUSIVE: u32 = 2u;
const PART_SIZE: u32 = {PART_SIZE}u;
const MAX_SUBGROUPS: u32 = {MAX_SUBGROUPS}u;
var<workgroup> g_scan: array<u32, RADIX>;
var<workgroup> sg_totals: array<u32, MAX_SUBGROUPS>;
@compute @workgroup_size(RADIX, 1, 1)
fn main(
	@builtin(local_invocation_index) gtid: u32,
	@builtin(workgroup_id) gid: vec3<u32>,
	@builtin(subgroup_invocation_id) sgInvId: u32,
	@builtin(subgroup_size) sgSize: u32,
) {
	let pass_ = gid.x;
	#ifdef USE_INDIRECT_SORT
	let numKeys = b_sortElementCount[0];
	let threadBlocks = (numKeys + PART_SIZE - 1u) / PART_SIZE;
	#else
	let threadBlocks = uniforms.threadBlocks;
	#endif
	let waveIndex = gtid / sgSize;
	let t = b_globalHist[gtid + pass_ * RADIX];
	let sgExcl = subgroupExclusiveAdd(t);
	let sgTotal = subgroupAdd(t);
	if (sgInvId == 0u) {
		sg_totals[waveIndex] = sgTotal;
	}
	workgroupBarrier();
	if (gtid == 0u) {
		var acc: u32 = 0u;
		for (var i = 0u; i < MAX_SUBGROUPS; i = i + 1u) {
			let v = sg_totals[i];
			sg_totals[i] = acc;
			acc = acc + v;
		}
	}
	workgroupBarrier();
	let excl = sgExcl + sg_totals[waveIndex];
	g_scan[gtid] = excl;
	let dst = pass_ * threadBlocks * RADIX + gtid;
	atomicStore(&b_passHist[dst], (excl << 2u) | FLAG_INCLUSIVE);
}
`;

var onesweepBinningSource = `
@group(0) @binding(0) var<storage, read> inputKeys: array<u32>;
@group(0) @binding(1) var<storage, read_write> outputKeys: array<u32>;
@group(0) @binding(2) var<storage, read> inputValues: array<u32>;
@group(0) @binding(3) var<storage, read_write> outputValues: array<u32>;
@group(0) @binding(4) var<storage, read_write> b_passHist: array<atomic<u32>>;
@group(0) @binding(5) var<storage, read_write> b_index: array<atomic<u32>>;
struct OneSweepBinningUniforms {
	numKeys: u32,
	threadBlocks: u32,
	pass_: u32,
	flags: u32
};
@group(0) @binding(6) var<uniform> uniforms: OneSweepBinningUniforms;
#ifdef USE_INDIRECT_SORT
@group(0) @binding(7) var<storage, read> b_sortElementCount: array<u32>;
#endif
const RADIX: u32 = 256u;
const RADIX_MASK: u32 = 255u;
const RADIX_LOG: u32 = 8u;
const D_DIM: u32 = {D_DIM}u;
const KEYS_PER_THREAD: u32 = {KEYS_PER_THREAD}u;
const PART_SIZE: u32 = D_DIM * KEYS_PER_THREAD;
const MAX_SUBGROUPS: u32 = {MAX_SUBGROUPS}u;
const WAVE_HISTS_SIZE: u32 = MAX_SUBGROUPS * RADIX;
const G_D_SIZE: u32 = max(PART_SIZE, WAVE_HISTS_SIZE);
const FLAG_NOT_READY: u32 = 0u;
const FLAG_REDUCTION: u32 = 1u;
const FLAG_INCLUSIVE: u32 = 2u;
const FLAG_MASK: u32 = 3u;
var<workgroup> g_d: array<atomic<u32>, G_D_SIZE>;
var<workgroup> digit_base: array<u32, RADIX>;
var<workgroup> sg_totals: array<u32, MAX_SUBGROUPS>;
var<workgroup> wg_partIndex: u32;
fn passHistOffset(tb: u32, pass_: u32, partitionIdx: u32) -> u32 {
	return pass_ * tb * RADIX + partitionIdx * RADIX;
}
@compute @workgroup_size(D_DIM, 1, 1)
fn main(
	@builtin(local_invocation_index) TID: u32,
	@builtin(subgroup_invocation_id) sgInvId: u32,
	@builtin(subgroup_size) sgSize: u32,
) {
	let waveIndex = TID / sgSize;
	let ltMask = (1u << sgInvId) - 1u;
	let activeMask = select(0xFFFFFFFFu, (1u << sgSize) - 1u, sgSize < 32u);
	let pass_ = uniforms.pass_;
	let currentBit = pass_ << 3u;
	#ifdef USE_INDIRECT_SORT
	let numKeys = b_sortElementCount[0];
	let threadBlocks = (numKeys + PART_SIZE - 1u) / PART_SIZE;
	#else
	let numKeys = uniforms.numKeys;
	let threadBlocks = uniforms.threadBlocks;
	#endif
	let isFirstPass = (uniforms.flags & 1u) != 0u;
	let isLastPass = (uniforms.flags & 2u) != 0u;
	if (TID == 0u) {
		wg_partIndex = atomicAdd(&b_index[pass_], 1u);
	}
	let partitionIndex = workgroupUniformLoad(&wg_partIndex);
	for (var i = TID; i < WAVE_HISTS_SIZE; i = i + D_DIM) {
		atomicStore(&g_d[i], 0u);
	}
	workgroupBarrier();
	let tileStart = partitionIndex * PART_SIZE;
	let validInBlock = select(
		0u,
		min(PART_SIZE, numKeys - tileStart),
		tileStart < numKeys
	);
	let subPartSize = sgSize * KEYS_PER_THREAD;
	let waveBase = tileStart + waveIndex * subPartSize;
	var keys: array<u32, {KEYS_PER_THREAD}>;
	var values: array<u32, {KEYS_PER_THREAD}>;
	var validMask: u32 = 0u;
	for (var i = 0u; i < KEYS_PER_THREAD; i = i + 1u) {
		let gid = waveBase + sgInvId + i * sgSize;
		let is_valid = gid < numKeys;
		keys[i] = select(0xFFFFFFFFu, inputKeys[gid], is_valid);
		values[i] = select(
			select(0u, inputValues[gid], is_valid),
			gid,
			isFirstPass
		);
		if (is_valid) {
			validMask = validMask | (1u << i);
		}
	}
	var offsets: array<u32, {KEYS_PER_THREAD}>;
	for (var i = 0u; i < KEYS_PER_THREAD; i = i + 1u) {
		let k = keys[i];
		let isValid = ((validMask >> i) & 1u) == 1u;
		let digit = (k >> currentBit) & RADIX_MASK;
		var waveFlag: u32 = activeMask;
		for (var b = 0u; b < 8u; b = b + 1u) {
			let t = ((digit >> b) & 1u) == 1u;
			let ballot = subgroupBallot(t).x;
			waveFlag = waveFlag & select(~ballot, ballot, t);
		}
		let validBallot = subgroupBallot(isValid).x;
		waveFlag = waveFlag & validBallot;
		let peerBits = countOneBits(waveFlag & ltMask);
		let totalBits = countOneBits(waveFlag);
		let lowestRankPeer = firstTrailingBit(waveFlag);
		var preIncrementVal: u32 = 0u;
		if (isValid && peerBits == 0u) {
			preIncrementVal = atomicAdd(&g_d[waveIndex * RADIX + digit], totalBits);
		}
		offsets[i] = subgroupShuffle(preIncrementVal, lowestRankPeer) + peerBits;
		workgroupBarrier();
	}
	var myHistRed: u32 = 0u;
	{
		var histReduction = atomicLoad(&g_d[TID]);
		for (var w = 1u; w < MAX_SUBGROUPS; w = w + 1u) {
			let idx = TID + w * RADIX;
			let cnt = atomicLoad(&g_d[idx]);
			histReduction = histReduction + cnt;
			atomicStore(&g_d[idx], histReduction - cnt);
		}
		myHistRed = histReduction;
	}
	if (partitionIndex + 1u < threadBlocks) {
		let dst = passHistOffset(threadBlocks, pass_, partitionIndex + 1u) + TID;
		atomicAdd(&b_passHist[dst], FLAG_REDUCTION | (myHistRed << 2u));
	}
	let warpExcl = subgroupExclusiveAdd(myHistRed);
	let warpTotal = subgroupAdd(myHistRed);
	if (sgInvId == 0u) {
		sg_totals[waveIndex] = warpTotal;
	}
	workgroupBarrier();
	if (TID == 0u) {
		var acc: u32 = 0u;
		for (var w = 0u; w < MAX_SUBGROUPS; w = w + 1u) {
			let t = sg_totals[w];
			sg_totals[w] = acc;
			acc = acc + t;
		}
	}
	workgroupBarrier();
	let myDigitBase = warpExcl + sg_totals[waveIndex];
	var scatterPos: array<u32, {KEYS_PER_THREAD}>;
	for (var i = 0u; i < KEYS_PER_THREAD; i = i + 1u) {
		let k = keys[i];
		let digit = (k >> currentBit) & RADIX_MASK;
		let warpBase = select(0u, atomicLoad(&g_d[waveIndex * RADIX + digit]), waveIndex > 0u);
		scatterPos[i] = offsets[i] + warpBase;
	}
	digit_base[TID] = myDigitBase;
	workgroupBarrier();
	for (var i = 0u; i < KEYS_PER_THREAD; i = i + 1u) {
		let k = keys[i];
		let digit = (k >> currentBit) & RADIX_MASK;
		scatterPos[i] = scatterPos[i] + digit_base[digit];
	}
	workgroupBarrier();
	if (TID < RADIX) {
		var lookbackReduction: u32 = 0u;
		var k: u32 = partitionIndex;
		var done: bool = false;
		loop {
			if (done) { break; }
			let flagPayload = atomicLoad(&b_passHist[passHistOffset(threadBlocks, pass_, k) + TID]);
			let flag = flagPayload & FLAG_MASK;
			if (flag == FLAG_INCLUSIVE) {
				lookbackReduction = lookbackReduction + (flagPayload >> 2u);
				if (partitionIndex + 1u < threadBlocks) {
					let dst = passHistOffset(threadBlocks, pass_, partitionIndex + 1u) + TID;
					atomicAdd(&b_passHist[dst], 1u | (lookbackReduction << 2u));
				}
				digit_base[TID] = lookbackReduction - myDigitBase;
				done = true;
			} else if (flag == FLAG_REDUCTION) {
				lookbackReduction = lookbackReduction + (flagPayload >> 2u);
				if (k == 0u) { done = true; }
				else { k = k - 1u; }
			}
		}
	}
	for (var i = 0u; i < KEYS_PER_THREAD; i = i + 1u) {
		if (((validMask >> i) & 1u) == 1u) {
			atomicStore(&g_d[scatterPos[i]], keys[i]);
		}
	}
	workgroupBarrier();
	var linearDigits: array<u32, {KEYS_PER_THREAD}>;
	for (var r = 0u; r < KEYS_PER_THREAD; r = r + 1u) {
		let linearIdx = TID + r * D_DIM;
		if (linearIdx < validInBlock) {
			let k = atomicLoad(&g_d[linearIdx]);
			let digit = (k >> currentBit) & RADIX_MASK;
			linearDigits[r] = digit;
			let globalPos = digit_base[digit] + linearIdx;
			if (!isLastPass) {
				outputKeys[globalPos] = k;
			}
		}
	}
	workgroupBarrier();
	for (var i = 0u; i < KEYS_PER_THREAD; i = i + 1u) {
		if (((validMask >> i) & 1u) == 1u) {
			atomicStore(&g_d[scatterPos[i]], values[i]);
		}
	}
	workgroupBarrier();
	for (var r = 0u; r < KEYS_PER_THREAD; r = r + 1u) {
		let linearIdx = TID + r * D_DIM;
		if (linearIdx < validInBlock) {
			let v = atomicLoad(&g_d[linearIdx]);
			let digit = linearDigits[r];
			let globalPos = digit_base[digit] + linearIdx;
			outputValues[globalPos] = v;
		}
	}
}
`;

var D_DIM = 256;
var KEYS_PER_THREAD = 15;
var PART_SIZE = D_DIM * KEYS_PER_THREAD;
var G_HIST_DIM = 128;
var G_HIST_PART_SIZE = 32768;
var RADIX = 256;
var MAX_PASSES = 4;
var ComputeRadixSortOneSweep = class extends ComputeRadixSortBase {
	_threadBlocks = 0;
	_allocatedThreadBlocks = 0;
	_globalHist = null;
	_passHist = null;
	_index = null;
	_binningDispatchSize = new Vec2(1, 1);
	_globalHistDispatchSize = new Vec2(1, 1);
	_globalHistBindGroupFormat = null;
	_scanBindGroupFormat = null;
	_binningBindGroupFormat = null;
	_globalHistUniformFormat = null;
	_scanUniformFormat = null;
	_binningUniformFormat = null;
	_globalHistShader = null;
	_scanShader = null;
	_binningShader = null;
	_globalHistCompute = null;
	_scanCompute = null;
	_binningComputes = [];
	constructor(device, indirect = false) {
		super(device, indirect);
		const info = this._indirectInfo;
		info[0] = 2;
		info[1] = PART_SIZE;
		info[2] = G_HIST_PART_SIZE;
		this._globalHistUniformFormat = new UniformBufferFormat(device, [
			new UniformFormat("numKeys", UNIFORMTYPE_UINT),
			new UniformFormat("threadBlocks", UNIFORMTYPE_UINT),
			new UniformFormat("numPasses", UNIFORMTYPE_UINT),
			new UniformFormat("_pad", UNIFORMTYPE_UINT)
		]);
		this._scanUniformFormat = new UniformBufferFormat(device, [
			new UniformFormat("threadBlocks", UNIFORMTYPE_UINT),
			new UniformFormat("_pad0", UNIFORMTYPE_UINT),
			new UniformFormat("_pad1", UNIFORMTYPE_UINT),
			new UniformFormat("_pad2", UNIFORMTYPE_UINT)
		]);
		this._binningUniformFormat = new UniformBufferFormat(device, [
			new UniformFormat("numKeys", UNIFORMTYPE_UINT),
			new UniformFormat("threadBlocks", UNIFORMTYPE_UINT),
			new UniformFormat("pass_", UNIFORMTYPE_UINT),
			new UniformFormat("flags", UNIFORMTYPE_UINT)
		]);
		const minSubgroupSize = device.minSubgroupSize || device.maxSubgroupSize || 32;
		const maxSubgroups = Math.max(1, Math.ceil(256 / minSubgroupSize));
		const suffix = indirect ? "Indirect" : "";
		const histGroupEntries = [
			new BindStorageBufferFormat("b_sort", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("b_globalHist", SHADERSTAGE_COMPUTE, false),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		];
		const scanGroupEntries = [
			new BindStorageBufferFormat("b_globalHist", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("b_passHist", SHADERSTAGE_COMPUTE, false),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		];
		const binGroupEntries = [
			new BindStorageBufferFormat("inputKeys", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("outputKeys", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("inputValues", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("outputValues", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("b_passHist", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("b_index", SHADERSTAGE_COMPUTE, false),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		];
		if (indirect) {
			histGroupEntries.push(new BindStorageBufferFormat("b_sortElementCount", SHADERSTAGE_COMPUTE, true));
			scanGroupEntries.push(new BindStorageBufferFormat("b_sortElementCount", SHADERSTAGE_COMPUTE, true));
			binGroupEntries.push(new BindStorageBufferFormat("b_sortElementCount", SHADERSTAGE_COMPUTE, true));
		}
		this._globalHistBindGroupFormat = new BindGroupFormat(device, histGroupEntries);
		this._scanBindGroupFormat = new BindGroupFormat(device, scanGroupEntries);
		this._binningBindGroupFormat = new BindGroupFormat(device, binGroupEntries);
		const histDefines = /* @__PURE__ */ new Map();
		histDefines.set("{G_HIST_DIM}", G_HIST_DIM);
		histDefines.set("{G_HIST_PART_SIZE}", G_HIST_PART_SIZE);
		if (indirect) histDefines.set("USE_INDIRECT_SORT", "");
		this._globalHistShader = new Shader(device, {
			name: `OneSweepGlobalHist${suffix}`,
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: onesweepGlobalHistSource,
			cdefines: histDefines,
			computeBindGroupFormat: this._globalHistBindGroupFormat,
			computeUniformBufferFormats: { uniforms: this._globalHistUniformFormat }
		});
		const scanDefines = /* @__PURE__ */ new Map();
		scanDefines.set("{MAX_SUBGROUPS}", maxSubgroups);
		scanDefines.set("{PART_SIZE}", PART_SIZE);
		if (indirect) scanDefines.set("USE_INDIRECT_SORT", "");
		this._scanShader = new Shader(device, {
			name: `OneSweepScan${suffix}`,
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: onesweepScanSource,
			cdefines: scanDefines,
			computeBindGroupFormat: this._scanBindGroupFormat,
			computeUniformBufferFormats: { uniforms: this._scanUniformFormat }
		});
		const binDefines = /* @__PURE__ */ new Map();
		binDefines.set("{D_DIM}", D_DIM);
		binDefines.set("{KEYS_PER_THREAD}", KEYS_PER_THREAD);
		binDefines.set("{MAX_SUBGROUPS}", maxSubgroups);
		if (indirect) binDefines.set("USE_INDIRECT_SORT", "");
		this._binningShader = new Shader(device, {
			name: `OneSweepBinning${suffix}`,
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: onesweepBinningSource,
			cdefines: binDefines,
			computeBindGroupFormat: this._binningBindGroupFormat,
			computeUniformBufferFormats: { uniforms: this._binningUniformFormat }
		});
		this._globalHistCompute = new Compute(device, this._globalHistShader, this._globalHistShader.name);
		this._scanCompute = new Compute(device, this._scanShader, this._scanShader.name);
	}
	destroy() {
		this._destroyBuffers();
		this._globalHistShader?.destroy();
		this._scanShader?.destroy();
		this._binningShader?.destroy();
		this._globalHistBindGroupFormat?.destroy();
		this._scanBindGroupFormat?.destroy();
		this._binningBindGroupFormat?.destroy();
		this._globalHistShader = null;
		this._scanShader = null;
		this._binningShader = null;
		this._globalHistCompute = null;
		this._scanCompute = null;
		this._binningComputes.length = 0;
		this._globalHistBindGroupFormat = null;
		this._scanBindGroupFormat = null;
		this._binningBindGroupFormat = null;
		this._globalHistUniformFormat = null;
		this._scanUniformFormat = null;
		this._binningUniformFormat = null;
		super.destroy();
	}
	_destroyBuffers() {
		this._destroyPingPongBuffers();
		this._globalHist?.destroy();
		this._passHist?.destroy();
		this._index?.destroy();
		this._globalHist = null;
		this._passHist = null;
		this._index = null;
		this._allocatedThreadBlocks = 0;
		this._threadBlocks = 0;
	}
	get radixBits() {
		return 8;
	}
	_ensureBinningComputes(numPasses) {
		while (this._binningComputes.length < numPasses) {
			this._binningComputes.push(new Compute(this.device, this._binningShader, `OneSweepBinning-${this._binningComputes.length}`));
		}
	}
	_allocateBuffers(elementCount, forceRealloc = false) {
		const effectiveCount = Math.max(elementCount, this.capacity);
		const allocThreadBlocks = Math.max(1, Math.ceil(effectiveCount / PART_SIZE));
		const currentThreadBlocks = Math.max(1, Math.ceil(elementCount / PART_SIZE));
		const needRealloc = forceRealloc || allocThreadBlocks !== this._allocatedThreadBlocks || !this._keys0;
		if (needRealloc) {
			this._destroyBuffers();
			this._allocatedThreadBlocks = allocThreadBlocks;
			this.capacity = effectiveCount;
			const device = this.device;
			this._allocatePingPongElementBuffers(effectiveCount);
			this._globalHist = new StorageBuffer(device, MAX_PASSES * RADIX * 4, BUFFERUSAGE_COPY_DST);
			this._passHist = new StorageBuffer(device, MAX_PASSES * allocThreadBlocks * RADIX * 4, BUFFERUSAGE_COPY_DST);
			this._index = new StorageBuffer(device, MAX_PASSES * 4, BUFFERUSAGE_COPY_DST);
		}
		this._threadBlocks = currentThreadBlocks;
		const maxPerDim = this.device.limits.maxComputeWorkgroupsPerDimension || 65535;
		Compute.calcDispatchSize(currentThreadBlocks, this._binningDispatchSize, maxPerDim);
		const histBlocks = Math.max(1, Math.ceil(elementCount / G_HIST_PART_SIZE));
		Compute.calcDispatchSize(histBlocks, this._globalHistDispatchSize, maxPerDim);
	}
	sort(keysBuffer, elementCount, numBits = 16, initialValues, skipLastPassKeyWrite = false, destructiveKeys = false) {
		const numPasses = numBits / 8;
		const hasInitialValues = !!initialValues;
		this._elementCount = elementCount;
		this._numBits = numBits;
		this._hasInitialValues = hasInitialValues;
		this._skipLastPassKeyWrite = skipLastPassKeyWrite;
		const prevDestructiveKeys = this._destructiveKeys;
		this._destructiveKeys = destructiveKeys;
		this._allocateBuffers(elementCount, destructiveKeys !== prevDestructiveKeys);
		this._ensureBinningComputes(numPasses);
		if (destructiveKeys) {
			this._keys1 = keysBuffer;
		}
		const device = this.device;
		this._globalHist.clear();
		this._passHist.clear(0, MAX_PASSES * this._threadBlocks * RADIX * 4);
		this._index.clear();
		const histCompute = this._globalHistCompute;
		histCompute.setParameter("b_sort", keysBuffer);
		histCompute.setParameter("b_globalHist", this._globalHist);
		histCompute.setParameter("numKeys", elementCount);
		histCompute.setParameter("threadBlocks", this._threadBlocks);
		histCompute.setParameter("numPasses", numPasses);
		histCompute.setParameter("_pad", 0);
		histCompute.setupDispatch(this._globalHistDispatchSize.x, this._globalHistDispatchSize.y, 1);
		device.computeDispatch([histCompute], "OneSweep-GlobalHist");
		const scanCompute = this._scanCompute;
		scanCompute.setParameter("b_globalHist", this._globalHist);
		scanCompute.setParameter("b_passHist", this._passHist);
		scanCompute.setParameter("threadBlocks", this._threadBlocks);
		scanCompute.setParameter("_pad0", 0);
		scanCompute.setParameter("_pad1", 0);
		scanCompute.setParameter("_pad2", 0);
		scanCompute.setupDispatch(numPasses, 1, 1);
		device.computeDispatch([scanCompute], "OneSweep-Scan");
		let currentKeys = keysBuffer;
		let currentValues = initialValues ?? this._values0;
		let nextKeys = this._keys0;
		let nextValues = this._values1;
		for (let pass = 0; pass < numPasses; pass++) {
			const isFirstPass = pass === 0 && !hasInitialValues;
			const isLastPass = pass === numPasses - 1;
			const flags = (isFirstPass ? 1 : 0) | (isLastPass && skipLastPassKeyWrite ? 2 : 0);
			const binCompute = this._binningComputes[pass];
			binCompute.setParameter("inputKeys", currentKeys);
			binCompute.setParameter("outputKeys", nextKeys);
			binCompute.setParameter("inputValues", currentValues);
			binCompute.setParameter("outputValues", nextValues);
			binCompute.setParameter("b_passHist", this._passHist);
			binCompute.setParameter("b_index", this._index);
			binCompute.setParameter("numKeys", elementCount);
			binCompute.setParameter("threadBlocks", this._threadBlocks);
			binCompute.setParameter("pass_", pass);
			binCompute.setParameter("flags", flags);
			binCompute.setupDispatch(this._binningDispatchSize.x, this._binningDispatchSize.y, 1);
			device.computeDispatch([binCompute], `OneSweep-Binning-${pass}`);
			if (!isLastPass) {
				currentKeys = nextKeys;
				nextKeys = currentKeys === this._keys0 ? this._keys1 : this._keys0;
				const t = currentValues;
				currentValues = nextValues;
				nextValues = t;
			}
		}
		return this.sortedIndices;
	}
	sortIndirect(keysBuffer, maxElementCount, numBits, sortSlotBase, sortElementCountBuffer, initialValues, skipLastPassKeyWrite = false, destructiveKeys = false) {
		const numPasses = numBits / 8;
		const hasInitialValues = !!initialValues;
		this._elementCount = maxElementCount;
		this._numBits = numBits;
		this._hasInitialValues = hasInitialValues;
		this._skipLastPassKeyWrite = skipLastPassKeyWrite;
		const prevDestructiveKeys = this._destructiveKeys;
		this._destructiveKeys = destructiveKeys;
		this._allocateBuffers(maxElementCount, destructiveKeys !== prevDestructiveKeys);
		this._ensureBinningComputes(numPasses);
		if (destructiveKeys) {
			this._keys1 = keysBuffer;
		}
		const device = this.device;
		this._globalHist.clear();
		this._passHist.clear(0, MAX_PASSES * this._allocatedThreadBlocks * RADIX * 4);
		this._index.clear();
		const histCompute = this._globalHistCompute;
		histCompute.setParameter("b_sort", keysBuffer);
		histCompute.setParameter("b_globalHist", this._globalHist);
		histCompute.setParameter("b_sortElementCount", sortElementCountBuffer);
		histCompute.setParameter("numKeys", 0);
		histCompute.setParameter("threadBlocks", 0);
		histCompute.setParameter("numPasses", numPasses);
		histCompute.setParameter("_pad", 0);
		histCompute.setupIndirectDispatch(sortSlotBase + 1);
		device.computeDispatch([histCompute], "OneSweep-GlobalHistIndirect");
		const scanCompute = this._scanCompute;
		scanCompute.setParameter("b_globalHist", this._globalHist);
		scanCompute.setParameter("b_passHist", this._passHist);
		scanCompute.setParameter("b_sortElementCount", sortElementCountBuffer);
		scanCompute.setParameter("threadBlocks", 0);
		scanCompute.setParameter("_pad0", 0);
		scanCompute.setParameter("_pad1", 0);
		scanCompute.setParameter("_pad2", 0);
		scanCompute.setupDispatch(numPasses, 1, 1);
		device.computeDispatch([scanCompute], "OneSweep-ScanIndirect");
		let currentKeys = keysBuffer;
		let currentValues = initialValues ?? this._values0;
		let nextKeys = this._keys0;
		let nextValues = this._values1;
		for (let pass = 0; pass < numPasses; pass++) {
			const isFirstPass = pass === 0 && !hasInitialValues;
			const isLastPass = pass === numPasses - 1;
			const flags = (isFirstPass ? 1 : 0) | (isLastPass && skipLastPassKeyWrite ? 2 : 0);
			const binCompute = this._binningComputes[pass];
			binCompute.setParameter("inputKeys", currentKeys);
			binCompute.setParameter("outputKeys", nextKeys);
			binCompute.setParameter("inputValues", currentValues);
			binCompute.setParameter("outputValues", nextValues);
			binCompute.setParameter("b_passHist", this._passHist);
			binCompute.setParameter("b_index", this._index);
			binCompute.setParameter("b_sortElementCount", sortElementCountBuffer);
			binCompute.setParameter("numKeys", 0);
			binCompute.setParameter("threadBlocks", 0);
			binCompute.setParameter("pass_", pass);
			binCompute.setParameter("flags", flags);
			binCompute.setupIndirectDispatch(sortSlotBase);
			device.computeDispatch([binCompute], `OneSweep-BinningIndirect-${pass}`);
			if (!isLastPass) {
				currentKeys = nextKeys;
				nextKeys = currentKeys === this._keys0 ? this._keys1 : this._keys0;
				const t = currentValues;
				currentValues = nextValues;
				nextValues = t;
			}
		}
		return this.sortedIndices;
	}
};

var ComputeRadixSort = class {
	_impl;
	constructor(device, options2 = {}) {
		const kind = options2.kind ?? RADIX_SORT_AUTO;
		const indirect = options2.indirect ?? false;
		let chosen = kind;
		if (kind === RADIX_SORT_AUTO) {
			chosen = this._canUseOneSweep(device) ? RADIX_SORT_ONESWEEP : RADIX_SORT_PORTABLE;
		}
		if (chosen === RADIX_SORT_ONESWEEP) {
			if (!this._canUseOneSweep(device)) {
			}
			this._impl = new ComputeRadixSortOneSweep(device, indirect);
		} else {
			this._impl = new ComputeRadixSortMultipass(device, indirect);
		}
	}
	_canUseOneSweep(device) {
		if (!device.supportsCompute || !device.supportsSubgroups) return false;
		const vendor = device.gpuAdapter?.info?.vendor?.toLowerCase?.();
		if (vendor !== "nvidia") return false;
		if (device.minSubgroupSize > 32) return false;
		return true;
	}
	get sortedIndices() {
		return this._impl.sortedIndices;
	}
	get sortedKeys() {
		return this._impl.sortedKeys;
	}
	get radixBits() {
		return this._impl.radixBits;
	}
	set capacity(value) {
		this._impl.capacity = value;
	}
	get capacity() {
		return this._impl.capacity;
	}
	sort(keysBuffer, elementCount, numBits = 16, initialValues, skipLastPassKeyWrite, destructiveKeys = false) {
		return this._impl.sort(keysBuffer, elementCount, numBits, initialValues, skipLastPassKeyWrite, destructiveKeys);
	}
	sortIndirect(keysBuffer, maxElementCount, numBits, sortSlotBase, sortElementCountBuffer, initialValues, skipLastPassKeyWrite, destructiveKeys = false) {
		return this._impl.sortIndirect(keysBuffer, maxElementCount, numBits, sortSlotBase, sortElementCountBuffer, initialValues, skipLastPassKeyWrite, destructiveKeys);
	}
	prepareIndirect() {
		return this._impl.prepareIndirect();
	}
	destroy() {
		this._impl.destroy();
	}
};

var _viewport3 = new Vec4();
var PostEffect = class {
	constructor(graphicsDevice) {
		this.device = graphicsDevice;
		this.needsDepthBuffer = false;
	}
	static quadVertexShader = `
				attribute vec2 aPosition;
				varying vec2 vUv0;
				void main(void)
				{
						gl_Position = vec4(aPosition, 0.0, 1.0);
						vUv0 = getImageEffectUV((aPosition.xy + 1.0) * 0.5);
				}
		`;
	render(inputTarget, outputTarget, rect) {
	}
	drawQuad(target2, shader, rect) {
		let viewport;
		if (rect) {
			const w = target2 ? target2.width : this.device.width;
			const h2 = target2 ? target2.height : this.device.height;
			viewport = _viewport3.set(rect.x * w, rect.y * h2, rect.z * w, rect.w * h2);
		}
		this.device.setBlendState(BlendState.NOBLEND);
		drawQuadWithShader(this.device, target2, shader, viewport);
	}
};

var RenderPassShaderQuad = class extends RenderPass {
	_shader = null;
	quadRender = null;
	cullMode = CULLFACE_NONE;
	frontFace = FRONTFACE_CCW;
	blendState = BlendState.NOBLEND;
	depthState = DepthState.NODEPTH;
	stencilFront = null;
	stencilBack = null;
	viewport;
	scissor;
	set shader(shader) {
		this.quadRender?.destroy();
		this.quadRender = null;
		this._shader = shader;
		if (shader) {
			this.quadRender = new QuadRender(shader);
		}
	}
	get shader() {
		return this._shader;
	}
	execute() {
		this.device.setDrawStates(this.blendState, this.depthState, this.cullMode, this.frontFace, this.stencilFront, this.stencilBack);
		this.quadRender?.render(this.viewport, this.scissor);
	}
};

var LitMaterialOptions = class {
	// array of booleans indicating which UV channels are used by the material
	usedUvs;
	// custom GLSL shader chunk to be added to the shader
	shaderChunkGLSL;
	// custom WGSL shader chunk to be added to the shader
	shaderChunkWGSL;
	// lit options
	litOptions = new LitShaderOptions();
};

var dummyUvs = [0, 1, 2, 3, 4, 5, 6, 7];
var ShaderGeneratorLit = class extends ShaderGenerator {
	generateKey(options2) {
		const definesHash = ShaderGenerator.definesHash(options2.defines);
		const glslHash = hashCode(options2.shaderChunkGLSL ?? "");
		const wgslHash = hashCode(options2.shaderChunkWGSL ?? "");
		const loHash = LitOptionsUtils.generateKey(options2.litOptions);
		const uvOptions = `${dummyUvs.map((dummy, index) => {
			return options2.usedUvs[index] ? "1" : "0";
		}).join("")}`;
		return `lit_${definesHash}_${uvOptions}_${glslHash}_${wgslHash}_${loHash}`;
	}
	createShaderDefinition(device, options2) {
		const allowWGSL = !!options2.shaderChunkWGSL;
		const litShader = new LitShader(device, options2.litOptions, allowWGSL);
		const definitionOptions = {
			name: "LitShader",
			shaderLanguage: litShader.shaderLanguage,
			tag: litShader.shaderPassInfo.isForward ? SHADERTAG_MATERIAL : void 0
		};
		const usedUvSets = options2.usedUvs || [true];
		const mapTransforms = [];
		litShader.generateVertexShader(usedUvSets, usedUvSets, mapTransforms);
		litShader.generateFragmentShader("", litShader.shaderLanguage === SHADERLANGUAGE_WGSL ? options2.shaderChunkWGSL : options2.shaderChunkGLSL, "vUv0");
		const includes = MapUtils.merge(litShader.chunks, litShader.includes);
		const vDefines = litShader.vDefines;
		options2.defines.forEach((value, key) => vDefines.set(key, value));
		const fDefines = litShader.fDefines;
		options2.defines.forEach((value, key) => fDefines.set(key, value));
		definitionOptions.attributes = litShader.attributes;
		definitionOptions.vertexCode = litShader.vshader;
		definitionOptions.vertexIncludes = includes;
		definitionOptions.vertexDefines = vDefines;
		definitionOptions.fragmentCode = litShader.fshader;
		definitionOptions.fragmentIncludes = includes;
		definitionOptions.fragmentDefines = fDefines;
		return ShaderDefinitionUtils.createDefinition(device, definitionOptions);
	}
};
var lit = new ShaderGeneratorLit();

var options = new LitMaterialOptions();
var LitMaterial = class extends Material {
	usedUvs = [true];
	shaderChunkGLSL = null;
	shaderChunkWGSL = null;
	useLighting = true;
	useFog = true;
	useTonemap = true;
	useSkybox = true;
	ambientSH = null;
	pixelSnap = false;
	nineSlicedMode = null;
	twoSidedLighting = false;
	occludeDirect = false;
	occludeSpecular = SPECOCC_AO;
	occludeSpecularIntensity = 1;
	opacityFadesSpecular = true;
	opacityDither = DITHER_NONE;
	opacityShadowDither = DITHER_NONE;
	shadowCatcher = false;
	ggxSpecular = false;
	fresnelModel = FRESNEL_SCHLICK;
	dynamicRefraction = false;
	// has members
	hasAo = false;
	hasSpecular = false;
	hasSpecularityFactor = false;
	hasLighting = false;
	hasHeights = false;
	hasNormals = false;
	hasSheen = false;
	hasRefraction = false;
	hasIrridescence = false;
	hasMetalness = false;
	hasClearCoat = false;
	hasClearCoatNormals = false;
	getShaderVariant(params) {
		options.usedUvs = this.usedUvs.slice();
		options.shaderChunkGLSL = this.shaderChunkGLSL;
		options.shaderChunkWGSL = this.shaderChunkWGSL;
		options.defines = ShaderUtils.getCoreDefines(this, params);
		LitMaterialOptionsBuilder.update(options.litOptions, this, params.scene, params.cameraShaderParams, params.objDefs, params.pass, params.sortedLights);
		const processingOptions = new ShaderProcessorOptions(params.viewUniformFormat, params.vertexFormat);
		const library = getProgramLibrary(params.device);
		library.register("lit", lit);
		const shader = library.getProgram("lit", options, processingOptions, this.userId);
		return shader;
	}
};

var primitiveUv1Padding2 = 8 / 64;
var primitiveUv1PaddingScale2 = 1 - primitiveUv1Padding2 * 2;
var ConeBaseGeometry = class extends Geometry {
	constructor(baseRadius, peakRadius, height, heightSegments, capSegments, roundedCaps) {
		super();
		const pos = new Vec3();
		const bottomToTop = new Vec3();
		const norm = new Vec3();
		const top = new Vec3();
		const bottom = new Vec3();
		const tangent = new Vec3();
		const positions = [];
		const normals = [];
		const uvs = [];
		const uvs1 = [];
		const indices = [];
		let offset3;
		if (height > 0) {
			for (let i2 = 0; i2 <= heightSegments; i2++) {
				for (let j = 0; j <= capSegments; j++) {
					const theta = j / capSegments * 2 * Math.PI - Math.PI;
					const sinTheta = Math.sin(theta);
					const cosTheta = Math.cos(theta);
					bottom.set(sinTheta * baseRadius, -height / 2, cosTheta * baseRadius);
					top.set(sinTheta * peakRadius, height / 2, cosTheta * peakRadius);
					pos.lerp(bottom, top, i2 / heightSegments);
					bottomToTop.sub2(top, bottom).normalize();
					tangent.set(cosTheta, 0, -sinTheta);
					norm.cross(tangent, bottomToTop).normalize();
					positions.push(pos.x, pos.y, pos.z);
					normals.push(norm.x, norm.y, norm.z);
					let u = j / capSegments;
					let v6 = i2 / heightSegments;
					uvs.push(u, 1 - v6);
					const _v = v6;
					v6 = u;
					u = _v;
					u = u * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					v6 = v6 * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					u /= 3;
					uvs1.push(u, 1 - v6);
					if (i2 < heightSegments && j < capSegments) {
						const first = i2 * (capSegments + 1) + j;
						const second = i2 * (capSegments + 1) + (j + 1);
						const third = (i2 + 1) * (capSegments + 1) + j;
						const fourth = (i2 + 1) * (capSegments + 1) + (j + 1);
						indices.push(first, second, third);
						indices.push(second, fourth, third);
					}
				}
			}
		}
		if (roundedCaps) {
			const latitudeBands = Math.floor(capSegments / 2);
			const longitudeBands = capSegments;
			const capOffset = height / 2;
			for (let lat = 0; lat <= latitudeBands; lat++) {
				const theta = lat * Math.PI * 0.5 / latitudeBands;
				const sinTheta = Math.sin(theta);
				const cosTheta = Math.cos(theta);
				for (let lon = 0; lon <= longitudeBands; lon++) {
					const phi = lon * 2 * Math.PI / longitudeBands - Math.PI / 2;
					const sinPhi = Math.sin(phi);
					const cosPhi = Math.cos(phi);
					const x3 = cosPhi * sinTheta;
					const y2 = cosTheta;
					const z2 = sinPhi * sinTheta;
					let u = 1 - lon / longitudeBands;
					let v6 = 1 - lat / latitudeBands;
					positions.push(x3 * peakRadius, y2 * peakRadius + capOffset, z2 * peakRadius);
					normals.push(x3, y2, z2);
					uvs.push(u, 1 - v6);
					u = u * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					v6 = v6 * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					u /= 3;
					v6 /= 3;
					u += 1 / 3;
					uvs1.push(u, 1 - v6);
				}
			}
			offset3 = (heightSegments + 1) * (capSegments + 1);
			for (let lat = 0; lat < latitudeBands; ++lat) {
				for (let lon = 0; lon < longitudeBands; ++lon) {
					const first = lat * (longitudeBands + 1) + lon;
					const second = first + longitudeBands + 1;
					indices.push(offset3 + first + 1, offset3 + second, offset3 + first);
					indices.push(offset3 + first + 1, offset3 + second + 1, offset3 + second);
				}
			}
			for (let lat = 0; lat <= latitudeBands; lat++) {
				const theta = Math.PI * 0.5 + lat * Math.PI * 0.5 / latitudeBands;
				const sinTheta = Math.sin(theta);
				const cosTheta = Math.cos(theta);
				for (let lon = 0; lon <= longitudeBands; lon++) {
					const phi = lon * 2 * Math.PI / longitudeBands - Math.PI / 2;
					const sinPhi = Math.sin(phi);
					const cosPhi = Math.cos(phi);
					const x3 = cosPhi * sinTheta;
					const y2 = cosTheta;
					const z2 = sinPhi * sinTheta;
					let u = 1 - lon / longitudeBands;
					let v6 = 1 - lat / latitudeBands;
					positions.push(x3 * peakRadius, y2 * peakRadius - capOffset, z2 * peakRadius);
					normals.push(x3, y2, z2);
					uvs.push(u, 1 - v6);
					u = u * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					v6 = v6 * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					u /= 3;
					v6 /= 3;
					u += 2 / 3;
					uvs1.push(u, 1 - v6);
				}
			}
			offset3 = (heightSegments + 1) * (capSegments + 1) + (longitudeBands + 1) * (latitudeBands + 1);
			for (let lat = 0; lat < latitudeBands; ++lat) {
				for (let lon = 0; lon < longitudeBands; ++lon) {
					const first = lat * (longitudeBands + 1) + lon;
					const second = first + longitudeBands + 1;
					indices.push(offset3 + first + 1, offset3 + second, offset3 + first);
					indices.push(offset3 + first + 1, offset3 + second + 1, offset3 + second);
				}
			}
		} else {
			offset3 = (heightSegments + 1) * (capSegments + 1);
			if (baseRadius > 0) {
				for (let i2 = 0; i2 < capSegments; i2++) {
					const theta = i2 / capSegments * 2 * Math.PI;
					const x3 = Math.sin(theta);
					const y2 = -height / 2;
					const z2 = Math.cos(theta);
					let u = 1 - (x3 + 1) / 2;
					let v6 = (z2 + 1) / 2;
					positions.push(x3 * baseRadius, y2, z2 * baseRadius);
					normals.push(0, -1, 0);
					uvs.push(u, 1 - v6);
					u = u * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					v6 = v6 * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					u /= 3;
					v6 /= 3;
					u += 1 / 3;
					uvs1.push(u, 1 - v6);
					if (i2 > 1) {
						indices.push(offset3, offset3 + i2, offset3 + i2 - 1);
					}
				}
			}
			offset3 += capSegments;
			if (peakRadius > 0) {
				for (let i2 = 0; i2 < capSegments; i2++) {
					const theta = i2 / capSegments * 2 * Math.PI;
					const x3 = Math.sin(theta);
					const y2 = height / 2;
					const z2 = Math.cos(theta);
					let u = 1 - (x3 + 1) / 2;
					let v6 = (z2 + 1) / 2;
					positions.push(x3 * peakRadius, y2, z2 * peakRadius);
					normals.push(0, 1, 0);
					uvs.push(u, 1 - v6);
					u = u * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					v6 = v6 * primitiveUv1PaddingScale2 + primitiveUv1Padding2;
					u /= 3;
					v6 /= 3;
					u += 2 / 3;
					uvs1.push(u, 1 - v6);
					if (i2 > 1) {
						indices.push(offset3, offset3 + i2 - 1, offset3 + i2);
					}
				}
			}
		}
		this.positions = positions;
		this.normals = normals;
		this.uvs = uvs;
		this.uvs1 = uvs1;
		this.indices = indices;
	}
};

var CapsuleGeometry = class extends ConeBaseGeometry {
	constructor(opts = {}) {
		const radius = opts.radius ?? 0.3;
		const height = opts.height ?? 1;
		const heightSegments = opts.heightSegments ?? 1;
		const sides = opts.sides ?? 20;
		super(radius, radius, height - 2 * radius, heightSegments, sides, true);
		if (opts.calculateTangents) {
			this.tangents = calculateTangents(this.positions, this.normals, this.uvs, this.indices);
		}
	}
};

var CircleGeometry = class extends Geometry {
	constructor(opts = {}) {
		super();
		const radius = opts.radius ?? 0.5;
		const sectors = Math.max(Math.floor(opts.sectors ?? 64), 3);
		const rings = Math.max(Math.floor(opts.rings ?? 8), 1);
		const ringExponent = opts.ringExponent ?? 1;
		const positions = [];
		const normals = [];
		const uvs = [];
		const indices = [];
		positions.push(0, 0, 0);
		normals.push(0, 1, 0);
		uvs.push(0.5, 0.5);
		for (let r = 1; r <= rings; r++) {
			const ringRadius = radius * Math.pow(r / rings, ringExponent);
			for (let j = 0; j < sectors; j++) {
				const angle = 2 * Math.PI * j / sectors;
				const x3 = ringRadius * Math.cos(angle);
				const z2 = ringRadius * Math.sin(angle);
				positions.push(x3, 0, z2);
				normals.push(0, 1, 0);
				uvs.push(0.5 + x3 / (2 * radius), 0.5 + z2 / (2 * radius));
			}
		}
		const ringVertex = (r, j) => 1 + (r - 1) * sectors + j % sectors;
		for (let j = 0; j < sectors; j++) {
			indices.push(0, ringVertex(1, j + 1), ringVertex(1, j));
		}
		for (let r = 1; r < rings; r++) {
			for (let j = 0; j < sectors; j++) {
				const inner = ringVertex(r, j);
				const innerNext = ringVertex(r, j + 1);
				const outer = ringVertex(r + 1, j);
				const outerNext = ringVertex(r + 1, j + 1);
				indices.push(inner, outerNext, outer);
				indices.push(inner, innerNext, outerNext);
			}
		}
		this.positions = positions;
		this.normals = normals;
		this.uvs = uvs;
		this.uvs1 = uvs;
		this.indices = indices;
		if (opts.calculateTangents) {
			this.tangents = calculateTangents(positions, normals, uvs, indices);
		}
	}
};

var ConeGeometry = class extends ConeBaseGeometry {
	constructor(opts = {}) {
		const baseRadius = opts.baseRadius ?? 0.5;
		const peakRadius = opts.peakRadius ?? 0;
		const height = opts.height ?? 1;
		const heightSegments = opts.heightSegments ?? 5;
		const capSegments = opts.capSegments ?? 18;
		super(baseRadius, peakRadius, height, heightSegments, capSegments, false);
		if (opts.calculateTangents) {
			this.tangents = calculateTangents(this.positions, this.normals, this.uvs, this.indices);
		}
	}
};

var CylinderGeometry = class extends ConeBaseGeometry {
	constructor(opts = {}) {
		const radius = opts.radius ?? 0.5;
		const height = opts.height ?? 1;
		const heightSegments = opts.heightSegments ?? 5;
		const capSegments = opts.capSegments ?? 20;
		super(radius, radius, height, heightSegments, capSegments, false);
		if (opts.calculateTangents) {
			this.tangents = calculateTangents(this.positions, this.normals, this.uvs, this.indices);
		}
	}
};

var PlaneGeometry = class extends Geometry {
	constructor(opts = {}) {
		super();
		const he = opts.halfExtents ?? new Vec2(0.5, 0.5);
		const ws = opts.widthSegments ?? 5;
		const ls = opts.lengthSegments ?? 5;
		const positions = [];
		const normals = [];
		const uvs = [];
		const indices = [];
		let vcounter = 0;
		for (let i2 = 0; i2 <= ws; i2++) {
			for (let j = 0; j <= ls; j++) {
				const x3 = -he.x + 2 * he.x * i2 / ws;
				const y2 = 0;
				const z2 = -(-he.y + 2 * he.y * j / ls);
				const u = i2 / ws;
				const v6 = j / ls;
				positions.push(x3, y2, z2);
				normals.push(0, 1, 0);
				uvs.push(u, 1 - v6);
				if (i2 < ws && j < ls) {
					indices.push(vcounter + ls + 1, vcounter + 1, vcounter);
					indices.push(vcounter + ls + 1, vcounter + ls + 2, vcounter + 1);
				}
				vcounter++;
			}
		}
		this.positions = positions;
		this.normals = normals;
		this.uvs = uvs;
		this.uvs1 = uvs;
		this.indices = indices;
		if (opts.calculateTangents) {
			this.tangents = calculateTangents(positions, normals, uvs, indices);
		}
	}
};

var TorusGeometry = class extends Geometry {
	constructor(opts = {}) {
		super();
		const rc = opts.tubeRadius ?? 0.2;
		const rt = opts.ringRadius ?? 0.3;
		const sectorAngle = (opts.sectorAngle ?? 360) * math.DEG_TO_RAD;
		const segments = opts.segments ?? 30;
		const sides = opts.sides ?? 20;
		const positions = [];
		const normals = [];
		const uvs = [];
		const indices = [];
		for (let i2 = 0; i2 <= sides; i2++) {
			for (let j = 0; j <= segments; j++) {
				const x3 = Math.cos(sectorAngle * j / segments) * (rt + rc * Math.cos(2 * Math.PI * i2 / sides));
				const y2 = Math.sin(2 * Math.PI * i2 / sides) * rc;
				const z2 = Math.sin(sectorAngle * j / segments) * (rt + rc * Math.cos(2 * Math.PI * i2 / sides));
				const nx = Math.cos(sectorAngle * j / segments) * Math.cos(2 * Math.PI * i2 / sides);
				const ny = Math.sin(2 * Math.PI * i2 / sides);
				const nz = Math.sin(sectorAngle * j / segments) * Math.cos(2 * Math.PI * i2 / sides);
				const u = i2 / sides;
				const v6 = 1 - j / segments;
				positions.push(x3, y2, z2);
				normals.push(nx, ny, nz);
				uvs.push(u, 1 - v6);
				if (i2 < sides && j < segments) {
					const first = i2 * (segments + 1) + j;
					const second = (i2 + 1) * (segments + 1) + j;
					const third = i2 * (segments + 1) + (j + 1);
					const fourth = (i2 + 1) * (segments + 1) + (j + 1);
					indices.push(first, second, third);
					indices.push(second, fourth, third);
				}
			}
		}
		this.positions = positions;
		this.normals = normals;
		this.uvs = uvs;
		this.uvs1 = uvs;
		this.indices = indices;
		if (opts.calculateTangents) {
			this.tangents = calculateTangents(positions, normals, uvs, indices);
		}
	}
};

var ProgramLibrary = class {
	processedCache = /* @__PURE__ */ new Map();
	definitionsCache = /* @__PURE__ */ new Map();
	_generators = /* @__PURE__ */ new Map();
	constructor(device, standardMaterial) {
		this._device = device;
		this._isClearingCache = false;
		this._precached = false;
		this._programsCollection = [];
		this._defaultStdMatOption = new StandardMaterialOptions();
		this._defaultStdMatOptionMin = new StandardMaterialOptions();
		const defaultCameraShaderParams = new CameraShaderParams();
		standardMaterial.shaderOptBuilder.updateRef(
			this._defaultStdMatOption,
			{},
			defaultCameraShaderParams,
			standardMaterial,
			null,
			[],
			SHADER_FORWARD,
			null
		);
		standardMaterial.shaderOptBuilder.updateMinRef(
			this._defaultStdMatOptionMin,
			{},
			standardMaterial,
			null,
			SHADER_SHADOW,
			null
		);
		device.on("destroy:shader", (shader) => {
			this.removeFromCache(shader);
		});
	}
	destroy() {
		this.clearCache();
	}
	register(name, generator) {
		if (!this._generators.has(name)) {
			this._generators.set(name, generator);
		}
	}
	unregister(name) {
		if (this._generators.has(name)) {
			this._generators.delete(name);
		}
	}
	isRegistered(name) {
		return this._generators.has(name);
	}
	generateShaderDefinition(generator, name, key, options2) {
		let def = this.definitionsCache.get(key);
		if (!def) {
			let lights2;
			if (options2.litOptions?.lights) {
				lights2 = options2.litOptions.lights;
				options2.litOptions.lights = lights2.map((l) => {
					const lcopy = l.clone ? l.clone() : l;
					lcopy.key = l.key;
					return lcopy;
				});
			}
			this.storeNewProgram(name, options2);
			if (options2.litOptions?.lights) {
				options2.litOptions.lights = lights2;
			}
			if (this._precached) {
			}
			const device = this._device;
			def = generator.createShaderDefinition(device, options2);
			def.name = def.name ?? (options2.pass ? `${name}-pass:${options2.pass}` : name);
			this.definitionsCache.set(key, def);
		}
		return def;
	}
	getCachedShader(key) {
		return this.processedCache.get(key);
	}
	setCachedShader(key, shader) {
		this.processedCache.set(key, shader);
	}
	getProgram(name, options2, processingOptions, userMaterialId) {
		const generator = this._generators.get(name);
		if (!generator) {
			return null;
		}
		const generationKeyString = generator.generateKey(options2);
		const generationKey = hashCode(generationKeyString);
		const processingKeyString = processingOptions.generateKey(this._device);
		const processingKey = hashCode(processingKeyString);
		const totalKey = `${generationKey}#${processingKey}`;
		let processedShader = this.getCachedShader(totalKey);
		if (!processedShader) {
			const generatedShaderDef = this.generateShaderDefinition(generator, name, generationKey, options2);
			let passName = "";
			let shaderPassInfo;
			if (options2.pass !== void 0) {
				shaderPassInfo = ShaderPass.get(this._device).getByIndex(options2.pass);
				passName = `-${shaderPassInfo.name}`;
			}
			this._device.fire("shader:generate", {
				userMaterialId,
				shaderPassInfo,
				definition: generatedShaderDef
			});
			const shaderDefinition = {
				name: `${generatedShaderDef.name}${passName}-proc`,
				attributes: generatedShaderDef.attributes,
				vshader: generatedShaderDef.vshader,
				vincludes: generatedShaderDef.vincludes,
				fincludes: generatedShaderDef.fincludes,
				fshader: generatedShaderDef.fshader,
				processingOptions,
				shaderLanguage: generatedShaderDef.shaderLanguage,
				meshUniformBufferFormat: generatedShaderDef.meshUniformBufferFormat,
				meshBindGroupFormat: generatedShaderDef.meshBindGroupFormat
			};
			processedShader = new Shader(this._device, shaderDefinition);
			this.setCachedShader(totalKey, processedShader);
		}
		return processedShader;
	}
	storeNewProgram(name, options2) {
		let opt = {};
		if (name === "standard") {
			const defaultMat = this._getDefaultStdMatOptions(options2.pass);
			for (const p in options2) {
				if (options2.hasOwnProperty(p) && defaultMat[p] !== options2[p] || p === "pass") {
					opt[p] = options2[p];
				}
			}
			for (const p in options2.litOptions) {
				opt[p] = options2.litOptions[p];
			}
		} else {
			opt = options2;
		}
		this._programsCollection.push(JSON.stringify({ name, options: opt }));
	}
	// run pc.getProgramLibrary(device).dumpPrograms(); from browser console to build shader options script
	dumpPrograms() {
		let text = "let device = pc.app ? pc.app.graphicsDevice : pc.Application.getApplication().graphicsDevice;\n";
		text += "let shaders = [";
		if (this._programsCollection[0]) {
			text += `
	${this._programsCollection[0]}`;
		}
		for (let i2 = 1; i2 < this._programsCollection.length; ++i2) {
			text += `,
	${this._programsCollection[i2]}`;
		}
		text += "\n];\n";
		text += "pc.getProgramLibrary(device).precompile(shaders);\n";
		text += `if (pc.version != "${version}" || pc.revision != "${revision}")
`;
		text += '	console.warn("precompile-shaders.js: engine version mismatch, rebuild shaders lib with current engine");';
		const element = document.createElement("a");
		element.setAttribute("href", `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
		element.setAttribute("download", "precompile-shaders.js");
		element.style.display = "none";
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}
	clearCache() {
		this._isClearingCache = true;
		this.processedCache.forEach((shader) => {
			shader.destroy();
		});
		this.processedCache.clear();
		this._isClearingCache = false;
	}
	removeFromCache(shader) {
		if (this._isClearingCache) {
			return;
		}
		this.processedCache.forEach((cachedShader, key) => {
			if (shader === cachedShader) {
				this.processedCache.delete(key);
			}
		});
	}
	_getDefaultStdMatOptions(pass) {
		const shaderPassInfo = ShaderPass.get(this._device).getByIndex(pass);
		return pass === SHADER_PICK || pass === SHADER_PREPASS || shaderPassInfo.isShadow ? this._defaultStdMatOptionMin : this._defaultStdMatOption;
	}
	precompile(cache) {
		if (cache) {
			const shaders = new Array(cache.length);
			for (let i2 = 0; i2 < cache.length; i2++) {
				if (cache[i2].name === "standard") {
					const opt = cache[i2].options;
					const defaultMat = this._getDefaultStdMatOptions(opt.pass);
					for (const p in defaultMat) {
						if (defaultMat.hasOwnProperty(p) && opt[p] === void 0) {
							opt[p] = defaultMat[p];
						}
					}
				}
				shaders[i2] = this.getProgram(cache[i2].name, cache[i2].options);
			}
		}
		this._precached = true;
	}
};

var UploadStream = class {
	_deviceLostEvent = null;
	constructor(device, useSingleBuffer = false) {
		this.device = device;
		this.useSingleBuffer = useSingleBuffer;
		this.impl = device.createUploadStreamImpl(this);
		this._deviceLostEvent = this.device.on("devicelost", this._onDeviceLost, this);
	}
	destroy() {
		this._deviceLostEvent?.off();
		this._deviceLostEvent = null;
		this.impl?.destroy();
		this.impl = null;
	}
	upload(data2, target2, offset3 = 0, size = data2.length) {
		this.impl?.upload(data2, target2, offset3, size);
	}
	_onDeviceLost() {
		this.impl?._onDeviceLost?.();
	}
};

var gsplatCopyToWorkbuffer_default = `
#define GSPLAT_CENTER_NOPROJ
uniform vec3 model_scale;
uniform vec4 model_rotation;
#include "gsplatHelpersVS"
#include "gsplatFormatVS"
#include "gsplatStructsVS"
#include "gsplatDeclarationsVS"
#include "gsplatCenterVS"
#include "gsplatEvalSHVS"
#include "gsplatQuatToMat3VS"
#include "gsplatReadVS"
#include "gsplatWorkBufferGeometryPS"
#include "gsplatWorkBufferOutputVS"
#include "gsplatWriteVS"
#include "gsplatModifyVS"
flat varying ivec4 vSubDraw;
uniform vec3 uColorMultiply;
#ifdef GSPLAT_ID
	uniform uint uId;
#endif
void main(void) {
	int localRow = int(gl_FragCoord.y) - vSubDraw.w;
	int localCol = int(gl_FragCoord.x) - vSubDraw.y;
	uint originalIndex = uint(vSubDraw.x + localRow * vSubDraw.z + localCol);
	setSplat(originalIndex);
	vec3 worldCenter;
	vec4 worldRotation = vec4(0.0, 0.0, 0.0, 1.0);
	vec3 worldScale = vec3(1.0);
	#if SH_BANDS > 0
		vec3 dir;
	#endif
	#ifdef GSPLAT_WORKBUFFER_GEOMETRY
		initWorkBufferGeometry(ivec2(gl_FragCoord.xy));
		worldCenter = workBufferWorldCenter();
		#if SH_BANDS > 0
			dir = normalize(quatRotateInv(model_rotation, worldCenter - uCameraPosition));
		#endif
	#else
		vec3 modelCenter = getCenter();
		worldCenter = (matrix_model * vec4(modelCenter, 1.0)).xyz;
		SplatCenter center;
		initCenter(modelCenter, center);
		vec4 srcRotation = getRotation().yzwx;
		vec3 srcScale = getScale();
		worldRotation = quatMul(model_rotation, srcRotation);
		if (worldRotation.w < 0.0) {
			worldRotation = -worldRotation;
		}
		worldScale = model_scale * srcScale;
		vec3 originalCenter = worldCenter;
		modifySplatCenter(worldCenter);
		modifySplatRotationScale(originalCenter, worldCenter, worldRotation, worldScale);
		#if SH_BANDS > 0
			dir = normalize(center.view * mat3(center.modelView));
		#endif
	#endif
	vec4 color = getColor();
	#if SH_BANDS > 0
		vec3 sh[SH_COEFFS];
		float scale;
		readSHData(sh, scale);
		color.xyz += evalSH(sh, dir) * scale;
	#endif
	modifySplatColor(worldCenter, color);
	color.xyz *= uColorMultiply;
	writeSplat(worldCenter, worldRotation, worldScale, color);
	#ifdef GSPLAT_ID
		writePcId(uvec4(uId, 0u, 0u, 0u));
	#endif
}
`;

var gsplatCopyToWorkbuffer_default2 = `
#define GSPLAT_CENTER_NOPROJ
uniform model_scale: vec3f;
uniform model_rotation: vec4f;
#include "gsplatHelpersVS"
#include "gsplatFormatVS"
#include "gsplatStructsVS"
#include "gsplatDeclarationsVS"
#include "gsplatCenterVS"
#include "gsplatEvalSHVS"
#include "gsplatQuatToMat3VS"
#include "gsplatReadVS"
#include "gsplatWorkBufferGeometryPS"
var<private> processOutput: FragmentOutput;
#include "gsplatWorkBufferOutputVS"
#include "gsplatWriteVS"
#include "gsplatModifyVS"
varying @interpolate(flat) vSubDraw: vec4i;
uniform uColorMultiply: vec3f;
#ifdef GSPLAT_ID
	uniform uId: u32;
#endif
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	let localRow = i32(input.position.y) - input.vSubDraw.w;
	let localCol = i32(input.position.x) - input.vSubDraw.y;
	let originalIndex = u32(input.vSubDraw.x + localRow * input.vSubDraw.z + localCol);
	setSplat(originalIndex);
	var worldCenter: vec3f;
	var worldRotation = vec4f(0.0, 0.0, 0.0, 1.0);
	var worldScale = vec3f(1.0);
	#if SH_BANDS > 0
		var dir: vec3f;
	#endif
	#ifdef GSPLAT_WORKBUFFER_GEOMETRY
		initWorkBufferGeometry(vec2i(input.position.xy));
		worldCenter = workBufferWorldCenter();
		#if SH_BANDS > 0
			dir = normalize(quatRotateInv(uniform.model_rotation, worldCenter - uniform.uCameraPosition));
		#endif
	#else
		var modelCenter = getCenter();
		worldCenter = (uniform.matrix_model * vec4f(modelCenter, 1.0)).xyz;
		var center: SplatCenter;
		initCenter(modelCenter, &center);
		let srcRotation = getRotation().yzwx;
		let srcScale = getScale();
		worldRotation = vec4f(quatMul(half4(uniform.model_rotation), half4(srcRotation)));
		if (worldRotation.w < 0.0) {
			worldRotation = -worldRotation;
		}
		worldScale = uniform.model_scale * srcScale;
		let originalCenter = worldCenter;
		modifySplatCenter(&worldCenter);
		modifySplatRotationScale(originalCenter, worldCenter, &worldRotation, &worldScale);
		#if SH_BANDS > 0
			dir = normalize(center.view * mat3x3f(center.modelView[0].xyz, center.modelView[1].xyz, center.modelView[2].xyz));
		#endif
	#endif
	var color = getColor();
	#if SH_BANDS > 0
		var sh: array<half3, SH_COEFFS>;
		var scale: f32;
		readSHData(&sh, &scale);
		color = vec4f(color.xyz + vec3f(evalSH(&sh, dir) * half(scale)), color.w);
	#endif
	modifySplatColor(worldCenter, &color);
	color = vec4f(color.xyz * uniform.uColorMultiply, color.w);
	writeSplat(worldCenter, worldRotation, worldScale, color);
	#ifdef GSPLAT_ID
		writePcId(vec4u(uniform.uId, 0u, 0u, 0u));
	#endif
	return processOutput;
}
`;

var gsplatCopyInstancedQuad_default = `
attribute vec2 vertex_position;
precision highp usampler2D;
uniform usampler2D uSubDrawData;
uniform ivec2 uTextureSize;
uniform int uSubDrawBase;
flat varying ivec4 vSubDraw;
void main(void) {
	int subDrawWidth = textureSize(uSubDrawData, 0).x;
	int idx = gl_InstanceID + uSubDrawBase;
	uvec4 data = texelFetch(uSubDrawData, ivec2(idx % subDrawWidth, idx / subDrawWidth), 0);
	int rowStart = int(data.r & 0xFFFFu);
	int numRows = int(data.r >> 16u);
	int colStart = int(data.g);
	int colEnd = int(data.b);
	int sourceBase = int(data.a);
	float u = float(gl_VertexID & 1);
	float v = float(gl_VertexID >> 1);
	vec4 ndc = vec4(colStart, colEnd, rowStart, rowStart + numRows) / vec4(uTextureSize.x, uTextureSize.x, uTextureSize.y, uTextureSize.y) * 2.0 - 1.0;
	gl_Position = vec4(mix(ndc.x, ndc.y, u), mix(ndc.z, ndc.w, v), 0.5, 1.0);
	vSubDraw = ivec4(sourceBase, colStart, colEnd - colStart, rowStart);
}
`;

var gsplatCopyInstancedQuad_default2 = `
attribute vertex_position: vec2f;
var uSubDrawData: texture_2d<u32>;
uniform uTextureSize: vec2i;
uniform uSubDrawBase: i32;
varying @interpolate(flat) vSubDraw: vec4i;
@vertex
fn vertexMain(input: VertexInput) -> VertexOutput {
	var output: VertexOutput;
	let subDrawWidth = i32(textureDimensions(uSubDrawData, 0).x);
	let instIdx = i32(input.instanceIndex) + uniform.uSubDrawBase;
	let data = textureLoad(uSubDrawData, vec2i(instIdx % subDrawWidth, instIdx / subDrawWidth), 0);
	let rowStart = i32(data.r & 0xFFFFu);
	let numRows = i32(data.r >> 16u);
	let colStart = i32(data.g);
	let colEnd = i32(data.b);
	let sourceBase = i32(data.a);
	let u = f32(i32(input.vertexIndex) & 1);
	let v = f32(i32(input.vertexIndex) >> 1u);
	let ndc = vec4f(f32(colStart), f32(colEnd), f32(rowStart), f32(rowStart + numRows)) / vec4f(f32(uniform.uTextureSize.x), f32(uniform.uTextureSize.x), f32(uniform.uTextureSize.y), f32(uniform.uTextureSize.y)) * 2.0 - 1.0;
	output.position = vec4f(mix(ndc.x, ndc.y, u), mix(-ndc.z, -ndc.w, v), 0.5, 1.0);
	output.vSubDraw = vec4i(sourceBase, colStart, colEnd - colStart, rowStart);
	return output;
}
`;

var _viewProjMat2 = new Mat4();
var _frustum = new Frustum();
var BOUNDS_ENTRY_FLOATS = 8;
var GSplatFrustumCuller = class {
	device;
	boundsBuffer = null;
	totalBoundsEntries = 0;
	_allocatedBoundsEntries = 0;
	_boundsFloatView = null;
	_boundsUintView = null;
	_tmpSpheres = null;
	transformsBuffer = null;
	_allocatedTransformCount = 0;
	_transformsData = null;
	frustumPlanes = new Float32Array(24);
	fisheyeCameraPos = new Float32Array(3);
	fisheyeCameraForward = new Float32Array(3);
	fisheyeMaxTheta = Math.PI;
	constructor(device) {
		this.device = device;
	}
	destroy() {
		this.boundsBuffer?.destroy();
		this.transformsBuffer?.destroy();
	}
	updateBoundsData(boundsGroups) {
		let totalEntries = 0;
		for (let i2 = 0; i2 < boundsGroups.length; i2++) {
			totalEntries += boundsGroups[i2].numBoundsEntries;
		}
		this.totalBoundsEntries = totalEntries;
		if (totalEntries === 0) return;
		if (totalEntries > this._allocatedBoundsEntries) {
			this.boundsBuffer?.destroy();
			this._allocatedBoundsEntries = totalEntries;
			this.boundsBuffer = new StorageBuffer(this.device, totalEntries * BOUNDS_ENTRY_FLOATS * 4, BUFFERUSAGE_COPY_DST);
			const ab = new ArrayBuffer(totalEntries * BOUNDS_ENTRY_FLOATS * 4);
			this._boundsFloatView = new Float32Array(ab);
			this._boundsUintView = new Uint32Array(ab);
			this._tmpSpheres = new Float32Array(totalEntries * 4);
		}
		const floatView2 = this._boundsFloatView;
		const uintView = this._boundsUintView;
		const tmpSpheres = this._tmpSpheres;
		for (let i2 = 0; i2 < boundsGroups.length; i2++) {
			const group = boundsGroups[i2];
			const base = group.boundsBaseIndex;
			const count = group.numBoundsEntries;
			group.splat.writeBoundsSpheres(tmpSpheres, base * 4);
			for (let j = 0; j < count; j++) {
				const src = (base + j) * 4;
				const dst = (base + j) * BOUNDS_ENTRY_FLOATS;
				floatView2[dst + 0] = tmpSpheres[src + 0];
				floatView2[dst + 1] = tmpSpheres[src + 1];
				floatView2[dst + 2] = tmpSpheres[src + 2];
				floatView2[dst + 3] = tmpSpheres[src + 3];
				uintView[dst + 4] = i2;
			}
		}
		this.boundsBuffer.write(0, floatView2);
	}
	updateTransformsData(boundsGroups) {
		const numMatrices = boundsGroups.length;
		if (numMatrices === 0) return;
		if (numMatrices > this._allocatedTransformCount) {
			this.transformsBuffer?.destroy();
			this._allocatedTransformCount = numMatrices;
			this.transformsBuffer = new StorageBuffer(this.device, numMatrices * 12 * 4, BUFFERUSAGE_COPY_DST);
			this._transformsData = new Float32Array(numMatrices * 12);
		}
		const data2 = this._transformsData;
		let offset3 = 0;
		for (let i2 = 0; i2 < boundsGroups.length; i2++) {
			const m = boundsGroups[i2].splat.node.getWorldTransform().data;
			data2[offset3++] = m[0];
			data2[offset3++] = m[4];
			data2[offset3++] = m[8];
			data2[offset3++] = m[12];
			data2[offset3++] = m[1];
			data2[offset3++] = m[5];
			data2[offset3++] = m[9];
			data2[offset3++] = m[13];
			data2[offset3++] = m[2];
			data2[offset3++] = m[6];
			data2[offset3++] = m[10];
			data2[offset3++] = m[14];
		}
		this.transformsBuffer.write(0, data2);
	}
	setFrustumPlanes(frustum) {
		const planes = this.frustumPlanes;
		for (let p = 0; p < 6; p++) {
			const plane2 = frustum.planes[p];
			planes[p * 4 + 0] = plane2.normal.x;
			planes[p * 4 + 1] = plane2.normal.y;
			planes[p * 4 + 2] = plane2.normal.z;
			planes[p * 4 + 3] = plane2.distance;
		}
	}
	computeFrustumPlanes(projectionMatrix, viewMatrix) {
		_viewProjMat2.mul2(projectionMatrix, viewMatrix);
		_frustum.setFromMat4(_viewProjMat2);
		this.setFrustumPlanes(_frustum);
	}
	setFisheyeData(cameraPos, cameraForward, maxTheta) {
		this.fisheyeCameraPos[0] = cameraPos.x;
		this.fisheyeCameraPos[1] = cameraPos.y;
		this.fisheyeCameraPos[2] = cameraPos.z;
		this.fisheyeCameraForward[0] = cameraForward.x;
		this.fisheyeCameraForward[1] = cameraForward.y;
		this.fisheyeCameraForward[2] = cameraForward.z;
		this.fisheyeMaxTheta = maxTheta;
	}
};

var _viewMat2 = new Mat4();
var _invModelMat = new Mat4();
var _modelScale = new Vec3();
var _modelRotation = new Quat();
var _tmpSize = new Vec2();
var _whiteColor = [1, 1, 1];
var GSplatWorkBufferRenderPass = class extends RenderPass {
	splats = [];
	colorsByLod = void 0;
	cameraNode = null;
	workBuffer;
	colorOnly;
	_usesWorkBufferGeometry = false;
	_modelScaleData = new Float32Array(3);
	_modelRotationData = new Float32Array(4);
	_cameraPositionData = new Float32Array(3);
	_textureSize = new Int32Array(2);
	_subDrawTexture;
	_partialData = [];
	constructor(device, workBuffer, colorOnly = false) {
		super(device);
		this.workBuffer = workBuffer;
		this.colorOnly = colorOnly;
		this._subDrawTexture = Texture.createDataTexture2D(device, "GsplatSubDrawData", 1, 1, PIXELFORMAT_RGBA32U);
	}
	destroy() {
		this.splats.length = 0;
		this._subDrawTexture.destroy();
		super.destroy();
	}
	init(renderTarget) {
		super.init(renderTarget);
		this.colorOps.clear = false;
		this.depthStencilOps.clearDepth = false;
	}
	update(splats, cameraNode, colorsByLod, changedAllocIds = null) {
		this.splats.length = 0;
		this._partialData.length = 0;
		this.colorsByLod = colorsByLod;
		const textureWidth = this.workBuffer.textureSize;
		if (changedAllocIds) {
			const requiredCapacity = changedAllocIds.size * 3;
			if (this._subDrawTexture.width * this._subDrawTexture.height < requiredCapacity) {
				TextureUtils.calcTextureSize(requiredCapacity, _tmpSize);
				this._subDrawTexture.resize(_tmpSize.x, _tmpSize.y);
			}
			const texData = this._subDrawTexture.lock();
			let writeOffset = 0;
			for (let i2 = 0; i2 < splats.length; i2++) {
				const splatInfo = splats[i2];
				if (splatInfo.activeSplats <= 0) continue;
				const intervals = splatInfo.intervals;
				const numIntervals = intervals.length / 2;
				if (numIntervals === 0) {
					if (changedAllocIds.has(splatInfo.allocId)) {
						this.splats.push(splatInfo);
						this._partialData.push(0, 0);
					}
				} else {
					const baseOffset = writeOffset;
					const allocIds = splatInfo.intervalAllocIds;
					for (let j = 0; j < numIntervals; j++) {
						if (changedAllocIds.has(allocIds[j])) {
							writeOffset = splatInfo.appendSubDraws(
								texData,
								writeOffset,
								intervals[j * 2],
								intervals[j * 2 + 1] - intervals[j * 2],
								splatInfo.intervalOffsets[j],
								textureWidth
							);
						}
					}
					const count = writeOffset - baseOffset;
					if (count > 0) {
						this.splats.push(splatInfo);
						this._partialData.push(baseOffset, count);
					}
				}
			}
			this._subDrawTexture.unlock();
		} else {
			for (let i2 = 0; i2 < splats.length; i2++) {
				const splatInfo = splats[i2];
				if (splatInfo.activeSplats > 0) {
					this.splats.push(splatInfo);
					this._partialData.push(0, 0);
				}
			}
		}
		let usesWorkBufferGeometry = false;
		for (let i2 = 0; i2 < this.splats.length; i2++) {
			if (this._partialData[i2 * 2 + 1] === 0) {
				this.splats[i2].ensureSubDrawTexture(textureWidth);
			}
			usesWorkBufferGeometry || (usesWorkBufferGeometry = this.splats[i2].resource.supportsWorkBufferGeometry);
		}
		this._usesWorkBufferGeometry = usesWorkBufferGeometry;
		this.cameraNode = cameraNode;
		return this.splats.length > 0;
	}
	execute() {
		const { device, splats, cameraNode, _partialData } = this;
		device.setDrawStates();
		const viewInvMat2 = cameraNode.getWorldTransform();
		const viewMat2 = _viewMat2.copy(viewInvMat2).invert();
		device.scope.resolve("matrix_view").setValue(viewMat2.data);
		if (this.colorOnly && this._usesWorkBufferGeometry) {
			device.scope.resolve("uWorkBufferTransformA").setValue(this.workBuffer.getTexture("dataTransformA"));
			device.scope.resolve("uWorkBufferTransformB").setValue(this.workBuffer.getTexture("dataTransformB"));
			const cameraPos = cameraNode.getPosition();
			this._cameraPositionData[0] = cameraPos.x;
			this._cameraPositionData[1] = cameraPos.y;
			this._cameraPositionData[2] = cameraPos.z;
			device.scope.resolve("uCameraPosition").setValue(this._cameraPositionData);
		}
		for (let i2 = 0; i2 < splats.length; i2++) {
			const count = _partialData[i2 * 2 + 1];
			if (count > 0) {
				this.renderSplat(splats[i2], this._subDrawTexture, count, _partialData[i2 * 2]);
			} else {
				this.renderSplat(splats[i2]);
			}
		}
	}
	renderSplat(splatInfo, overrideSubDrawTexture, overrideSubDrawCount, subDrawBase = 0) {
		const { device, resource } = splatInfo;
		const scope = device.scope;
		const subDrawTexture = overrideSubDrawTexture ?? splatInfo.subDrawTexture;
		const subDrawCount = overrideSubDrawCount ?? splatInfo.subDrawCount;
		const workBufferModifier = splatInfo.getWorkBufferModifier?.() ?? null;
		const formatHash = resource.format.hash;
		const formatDeclarations = resource.format.getInputDeclarations();
		const workBufferRenderInfo = resource.getWorkBufferRenderInfo(
			this.colorOnly,
			workBufferModifier,
			formatHash,
			formatDeclarations,
			this.workBuffer.format
		);
		workBufferRenderInfo.material.setParameters(device);
		const color3 = this.colorsByLod?.[splatInfo.lodIndex] ?? this.colorsByLod?.[0] ?? _whiteColor;
		scope.resolve("uColorMultiply").setValue(color3);
		const worldTransform = splatInfo.node.getWorldTransform();
		worldTransform.getScale(_modelScale);
		_modelRotation.setFromMat4(worldTransform);
		if (_modelRotation.w < 0) {
			_modelRotation.mulScalar(-1);
		}
		this._modelScaleData[0] = _modelScale.x;
		this._modelScaleData[1] = _modelScale.y;
		this._modelScaleData[2] = _modelScale.z;
		this._modelRotationData[0] = _modelRotation.x;
		this._modelRotationData[1] = _modelRotation.y;
		this._modelRotationData[2] = _modelRotation.z;
		this._modelRotationData[3] = _modelRotation.w;
		scope.resolve("matrix_model").setValue(worldTransform.data);
		scope.resolve("model_scale").setValue(this._modelScaleData);
		scope.resolve("model_rotation").setValue(this._modelRotationData);
		if (this.colorOnly && resource.supportsWorkBufferGeometry) {
			_invModelMat.copy(worldTransform).invert();
			scope.resolve("matrix_model_inverse").setValue(_invModelMat.data);
		}
		scope.resolve("uId").setValue(splatInfo.placementId);
		if (splatInfo.parameters) {
			for (const param of splatInfo.parameters.values()) {
				param.scopeId.setValue(param.data);
			}
		}
		const instanceStreams = splatInfo.getInstanceStreams?.();
		if (instanceStreams) {
			instanceStreams.syncWithFormat(splatInfo.resource.format);
			for (const [name, texture] of instanceStreams.textures) {
				scope.resolve(name).setValue(texture);
			}
		}
		scope.resolve("uSubDrawData").setValue(subDrawTexture);
		scope.resolve("uSubDrawBase").setValue(subDrawBase);
		const ts = this.workBuffer.textureSize;
		this._textureSize[0] = ts;
		this._textureSize[1] = ts;
		scope.resolve("uTextureSize").setValue(this._textureSize);
		workBufferRenderInfo.quadRender.render(void 0, void 0, subDrawCount);
	}
};

var GSplatStreams = class {
	device;
	format = null;
	textures = /* @__PURE__ */ new Map();
	_textureDimensions = new Vec2();
	_isInstance = false;
	_formatVersion = -1;
	get textureDimensions() {
		return this._textureDimensions;
	}
	constructor(device, isInstance = false) {
		this.device = device;
		this._isInstance = isInstance;
	}
	destroy() {
		for (const texture of this.textures.values()) {
			texture.destroy();
		}
		this.textures.clear();
	}
	init(format, numElements) {
		this.format = format;
		this._textureDimensions = TextureUtils.calcTextureSize(numElements, new Vec2());
		const streams = this._isInstance ? format.instanceStreams : format.resourceStreams;
		for (const stream of streams) {
			const texture = this.createTexture(stream.name, stream.format, this._textureDimensions);
			this.textures.set(stream.name, texture);
		}
		this._formatVersion = format.extraStreamsVersion;
	}
	getTexture(name) {
		this.syncWithFormat(this.format);
		return this.textures.get(name);
	}
	getTexturesInOrder() {
		const result = [];
		if (this.format) {
			const allStreams = this._isInstance ? this.format.instanceStreams : this.format.resourceStreams;
			for (const stream of allStreams) {
				const texture = this.textures.get(stream.name);
				if (texture) {
					result.push(texture);
				}
			}
		}
		return result;
	}
	syncWithFormat(format) {
		if (format) {
			if (this.format === format && this._formatVersion === format.extraStreamsVersion) {
				return;
			}
			this.format = format;
			const streams = this._isInstance ? format.instanceStreams : format.resourceStreams;
			for (const stream of streams) {
				if (!this.textures.has(stream.name)) {
					const texture = this.createTexture(stream.name, stream.format, this._textureDimensions);
					this.textures.set(stream.name, texture);
				}
			}
			this._formatVersion = format.extraStreamsVersion;
		}
	}
	resize(width, height) {
		this._textureDimensions.set(width, height);
		for (const texture of this.textures.values()) {
			texture.resize(width, height);
		}
	}
	createTexture(name, format, size, data2) {
		return Texture.createDataTexture2D(this.device, name, size.x, size.y, format, data2 ? [data2] : void 0);
	}
};

var id12 = 0;
var WorkBufferRenderInfo = class {
	material;
	quadRender;
	constructor(device, key, material, colorOnly, format) {
		this.material = material;
		const clonedDefines = new Map(material.defines);
		const colorStream = format.getStream("dataColor");
		if (colorStream.format === PIXELFORMAT_RGBA16U) {
			clonedDefines.set("GSPLAT_COLOR_UINT", "");
		}
		if (colorOnly) {
			clonedDefines.set("GSPLAT_COLOR_ONLY", "");
		}
		if (format.getStream("pcId")) {
			clonedDefines.set("GSPLAT_ID", "");
		}
		const fragmentIncludes = material.hasShaderChunks ? device.isWebGPU ? material.shaderChunks.wgsl : material.shaderChunks.glsl : void 0;
		const outputStreams = colorOnly ? [colorStream] : [...format.streams, ...format.extraStreams];
		const fragmentOutputTypes = [];
		for (const stream of outputStreams) {
			const info = getGlslShaderType(stream.format);
			fragmentOutputTypes.push(info.returnType);
		}
		const useInstanced = clonedDefines.has("GSPLAT_LOD");
		const shaderOptions = {
			uniqueName: `SplatCopyToWorkBuffer:${key}`,
			attributes: { vertex_position: SEMANTIC_POSITION },
			vertexDefines: clonedDefines,
			fragmentDefines: clonedDefines,
			fragmentGLSL: gsplatCopyToWorkbuffer_default,
			fragmentWGSL: gsplatCopyToWorkbuffer_default2,
			fragmentIncludes,
			fragmentOutputTypes
		};
		if (useInstanced) {
			shaderOptions.vertexGLSL = gsplatCopyInstancedQuad_default;
			shaderOptions.vertexWGSL = gsplatCopyInstancedQuad_default2;
		} else {
			shaderOptions.vertexChunk = "fullscreenQuadVS";
		}
		const shader = ShaderUtils.createShader(device, shaderOptions);
		this.quadRender = new QuadRender(shader);
	}
	destroy() {
		this.material?.destroy();
		this.quadRender?.destroy();
	}
};
var GSplatWorkBuffer = class {
	device;
	format;
	id = id12++;
	streams;
	renderTarget;
	colorRenderTarget;
	orderTexture;
	orderBuffer;
	uploadStream;
	renderPass;
	colorRenderPass;
	frustumCuller;
	constructor(device, format) {
		this.device = device;
		this.format = format;
		this.frustumCuller = new GSplatFrustumCuller(device);
		this.streams = new GSplatStreams(device);
		this.streams.init(format, 1);
		this._createRenderTargets();
		this.uploadStream = new UploadStream(device, !device.isWebGPU);
		if (device.isWebGPU) {
			this.orderBuffer = new StorageBuffer(device, 4, BUFFERUSAGE_COPY_DST);
		} else {
			this.orderTexture = new Texture(device, {
				name: "SplatGlobalOrder",
				width: 1,
				height: 1,
				format: PIXELFORMAT_R32U,
				mipmaps: false,
				addressU: ADDRESS_CLAMP_TO_EDGE,
				addressV: ADDRESS_CLAMP_TO_EDGE
			});
		}
		this.renderPass = new GSplatWorkBufferRenderPass(device, this);
		this.renderPass.init(this.renderTarget);
		this.colorRenderPass = new GSplatWorkBufferRenderPass(device, this, true);
		this.colorRenderPass.init(this.colorRenderTarget);
	}
	_createRenderTargets() {
		this.renderTarget?.destroy();
		this.colorRenderTarget?.destroy();
		const colorBuffers = this.streams.getTexturesInOrder();
		this.renderTarget = new RenderTarget({
			name: `GsplatWorkBuffer-MRT-${this.id}`,
			colorBuffers,
			depth: false,
			flipY: true
		});
		const colorTexture = this.streams.getTexture("dataColor");
		this.colorRenderTarget = new RenderTarget({
			name: `GsplatWorkBuffer-Color-${this.id}`,
			colorBuffer: colorTexture,
			depth: false,
			flipY: true
		});
		this.renderPass?.init(this.renderTarget);
		this.colorRenderPass?.init(this.colorRenderTarget);
	}
	syncWithFormat() {
		const prevVersion = this.streams._formatVersion;
		this.streams.syncWithFormat(this.format);
		if (prevVersion !== this.streams._formatVersion) {
			this._createRenderTargets();
		}
	}
	getTexture(name) {
		return this.streams.getTexture(name);
	}
	destroy() {
		this.renderPass?.destroy();
		this.colorRenderPass?.destroy();
		this.streams.destroy();
		this.orderTexture?.destroy();
		this.orderBuffer?.destroy();
		this.renderTarget?.destroy();
		this.colorRenderTarget?.destroy();
		this.uploadStream.destroy();
		this.frustumCuller.destroy();
	}
	get textureSize() {
		return this.streams.textureDimensions.x;
	}
	setOrderData(data2) {
		const size = this.textureSize;
		if (this.device.isWebGPU) {
			this.uploadStream.upload(data2, this.orderBuffer, 0, data2.length);
		} else {
			this.uploadStream.upload(data2, this.orderTexture, 0, data2.length);
		}
	}
	resize(textureSize) {
		this.renderTarget.resize(textureSize, textureSize);
		this.colorRenderTarget.resize(textureSize, textureSize);
		this.streams.resize(textureSize, textureSize);
		if (this.device.isWebGPU) {
			const newByteSize = textureSize * textureSize * 4;
			if (this.orderBuffer.byteSize < newByteSize) {
				this.orderBuffer.destroy();
				this.orderBuffer = new StorageBuffer(this.device, newByteSize, BUFFERUSAGE_COPY_DST);
			}
		} else {
			this.orderTexture.resize(textureSize, textureSize);
		}
	}
	render(splats, cameraNode, colorsByLod, changedAllocIds = null) {
		if (this.renderPass.update(splats, cameraNode, colorsByLod, changedAllocIds)) {
			this.renderPass.render();
		}
	}
	renderColor(splats, cameraNode, colorsByLod, changedAllocIds = null) {
		if (this.colorRenderPass.update(splats, cameraNode, colorsByLod, changedAllocIds)) {
			this.colorRenderPass.render();
		}
	}
};

var GSplatResourceCleanup = class _GSplatResourceCleanup {
	static _cache = new DeviceCache();
	_pendingDestroy = /* @__PURE__ */ new Set();
	static queueDestroy(device, resource) {
		this._cache.get(device, () => new _GSplatResourceCleanup())._pendingDestroy.add(resource);
	}
	static process(device) {
		const pending = this._cache.get(device, () => new _GSplatResourceCleanup())._pendingDestroy;
		for (const resource of pending) {
			if (resource.refCount === 0) {
				resource._actualDestroy();
				pending.delete(resource);
			}
		}
	}
	destroy() {
		this._pendingDestroy.clear();
	}
};

var id13 = 0;
var tempMap = /* @__PURE__ */ new Map();
var GSplatResourceBase = class _GSplatResourceBase {
	device;
	gsplatData;
	set centers(value) {
		this._centers = value;
	}
	get centers() {
		return this._centers;
	}
	get hasCenters() {
		return this._centers != null;
	}
	_centers = null;
	centersVersion = 0;
	aabb;
	mesh = null;
	id = id13++;
	workBufferRenderInfos = /* @__PURE__ */ new Map();
	_format = null;
	streams;
	parameters = /* @__PURE__ */ new Map();
	_refCount = 0;
	_meshRefCount = 0;
	constructor(device, gsplatData, options2 = {}) {
		this.device = device;
		this.gsplatData = gsplatData;
		this.streams = new GSplatStreams(device);
		if (options2.prepareCenters !== false) {
			this._centers = gsplatData.getCenters();
		} else {
			this._centers = null;
		}
		this.aabb = new BoundingBox();
		gsplatData.calcAabb(this.aabb);
	}
	destroy() {
		if (this.refCount > 0) {
			GSplatResourceCleanup.queueDestroy(this.device, this);
			return;
		}
		this._actualDestroy();
	}
	_actualDestroy() {
		this.streams.destroy();
		this.mesh?.destroy();
		this.workBufferRenderInfos.forEach((info) => info.destroy());
		this.workBufferRenderInfos.clear();
	}
	incRefCount() {
		this._refCount++;
	}
	decRefCount() {
		this._refCount--;
	}
	get refCount() {
		return this._refCount;
	}
	ensureMesh() {
		if (!this.mesh) {
			this.mesh = _GSplatResourceBase.createMesh(this.device);
			this.mesh.aabb.copy(this.aabb);
		}
		this._meshRefCount++;
	}
	releaseMesh() {
		this._meshRefCount--;
		if (this._meshRefCount < 1) {
			this.mesh = null;
		}
	}
	get supportsWorkBufferGeometry() {
		return false;
	}
	getWorkBufferRenderInfo(colorOnly, workBufferModifier, formatHash, formatDeclarations, workBufferFormat) {
		this.configureMaterialDefines(tempMap);
		tempMap.set("GSPLAT_LOD", "");
		if (colorOnly) {
			tempMap.set("GSPLAT_COLOR_ONLY", "");
			if (this.supportsWorkBufferGeometry) {
				tempMap.set("GSPLAT_WORKBUFFER_GEOMETRY", "");
				if (workBufferFormat.dataFormat === GSPLATDATA_COMPACT) {
					tempMap.set("GSPLAT_WORKBUFFER_COMPACT", "");
				}
			}
		}
		let definesKey = "";
		for (const [k, v6] of tempMap) {
			if (definesKey) definesKey += ";";
			definesKey += `${k}=${v6}`;
		}
		const key = `${formatHash};${workBufferFormat.hash};${workBufferModifier?.hash ?? 0};${definesKey}`;
		let info = this.workBufferRenderInfos.get(key);
		if (!info) {
			const material = new ShaderMaterial();
			this.configureMaterial(material, workBufferModifier, formatDeclarations);
			const chunks = this.device.isWebGPU ? material.shaderChunks.wgsl : material.shaderChunks.glsl;
			const outputStreams = colorOnly ? [workBufferFormat.getStream("dataColor")] : [...workBufferFormat.streams, ...workBufferFormat.extraStreams];
			let outputCode = workBufferFormat.getOutputDeclarations(outputStreams);
			if (colorOnly && workBufferFormat.extraStreams.length > 0) {
				outputCode += `
${workBufferFormat.getOutputStubs(workBufferFormat.extraStreams)}`;
			}
			chunks.set("gsplatWorkBufferOutputVS", outputCode);
			const writeCode = workBufferFormat.getWriteCode();
			if (writeCode) {
				chunks.set("gsplatWriteVS", writeCode);
			}
			tempMap.forEach((v6, k) => material.setDefine(k, v6));
			info = new WorkBufferRenderInfo(this.device, key, material, colorOnly, workBufferFormat);
			this.workBufferRenderInfos.set(key, info);
		}
		tempMap.clear();
		return info;
	}
	static createMesh(device) {
		const splatInstanceSize = _GSplatResourceBase.instanceSize;
		const meshPositions = new Float32Array(12 * splatInstanceSize);
		const meshIndices = new Uint32Array(6 * splatInstanceSize);
		for (let i2 = 0; i2 < splatInstanceSize; ++i2) {
			meshPositions.set([
				-1,
				-1,
				i2,
				1,
				-1,
				i2,
				1,
				1,
				i2,
				-1,
				1,
				i2
			], i2 * 12);
			const b = i2 * 4;
			meshIndices.set([
				0 + b,
				1 + b,
				2 + b,
				0 + b,
				2 + b,
				3 + b
			], i2 * 6);
		}
		const mesh = new Mesh(device);
		mesh.setPositions(meshPositions, 3);
		mesh.setIndices(meshIndices);
		mesh.update();
		return mesh;
	}
	static get instanceSize() {
		return 128;
	}
	get numSplats() {
		return this.gsplatData.numSplats;
	}
	get format() {
		return this._format;
	}
	getTexture(name) {
		return this.streams.getTexture(name) ?? null;
	}
	get textureDimensions() {
		return this.streams.textureDimensions;
	}
	configureMaterial(material, workBufferModifier, formatDeclarations) {
		this.configureMaterialDefines(material.defines);
		this.streams.syncWithFormat(this.format);
		const chunks = this.device.isWebGPU ? material.shaderChunks.wgsl : material.shaderChunks.glsl;
		chunks.set("gsplatDeclarationsVS", formatDeclarations);
		chunks.set("gsplatReadVS", this.format.getReadCode());
		if (workBufferModifier?.code) {
			chunks.set("gsplatModifyVS", workBufferModifier.code);
		}
		for (const [name, texture] of this.streams.textures) {
			material.setParameter(name, texture);
		}
		for (const [name, value] of this.parameters) {
			material.setParameter(name, value);
		}
		if (this.textureDimensions.x > 0) {
			material.setParameter("splatTextureSize", this.textureDimensions.x);
		}
	}
	configureMaterialDefines(defines) {
	}
	instantiate() {
	}
};

var GSplatContainer = class extends GSplatResourceBase {
	_maxSplats = 0;
	_numSplats = 0;
	constructor(device, maxSplats, format) {
		const aabb3 = new BoundingBox();
		const gsplatData = {
			numSplats: maxSplats,
			getCenters: () => null,
			calcAabb: (box) => box.copy(aabb3)
		};
		super(device, gsplatData, { prepareCenters: false });
		this._format = format;
		this._maxSplats = maxSplats;
		this._numSplats = maxSplats;
		this.streams.init(this._format, maxSplats);
	}
	set centers(value) {
		this._centers = value;
	}
	get centers() {
		if (this._centers === null) {
			this._centers = new Float32Array(this._maxSplats * 3);
			this.centersVersion++;
		}
		return this._centers;
	}
	get maxSplats() {
		return this._maxSplats;
	}
	get numSplats() {
		return this._numSplats;
	}
	update(numSplats = this._numSplats, centersUpdated = true) {
		this._numSplats = math.clamp(numSplats, 0, this._maxSplats);
		if (centersUpdated) {
			this.centersVersion++;
		}
	}
	configureMaterialDefines(defines) {
		defines.set("SH_BANDS", "0");
	}
	configureMaterial(material, workBufferModifier = null, formatDeclarations) {
		super.configureMaterial(material, workBufferModifier, formatDeclarations);
		const chunks = this.device.isWebGPU ? material.shaderChunks.wgsl : material.shaderChunks.glsl;
		chunks.set("gsplatContainerDeclarationsVS", this.format.getInputDeclarations());
		chunks.set("gsplatDeclarationsVS", '#include "gsplatContainerDeclVS"');
		chunks.set("gsplatReadVS", this.format.getReadCode());
	}
};

var mat4 = new Mat4();
var quat = new Quat();
var aabb = new BoundingBox();
var aabb2 = new BoundingBox();
var debugColor = new Color(1, 1, 0, 0.4);
var SH_C0 = 0.28209479177387814;
var SplatIterator = class {
	constructor(gsplatData, p, r, s2, c2) {
		const activated = gsplatData.activated;
		const x3 = gsplatData.getProp("x");
		const y2 = gsplatData.getProp("y");
		const z2 = gsplatData.getProp("z");
		const rx = gsplatData.getProp("rot_1");
		const ry = gsplatData.getProp("rot_2");
		const rz = gsplatData.getProp("rot_3");
		const rw = gsplatData.getProp("rot_0");
		const sx = gsplatData.getProp("scale_0");
		const sy = gsplatData.getProp("scale_1");
		const sz = gsplatData.getProp("scale_2");
		const cr = gsplatData.getProp("f_dc_0");
		const cg = gsplatData.getProp("f_dc_1");
		const cb = gsplatData.getProp("f_dc_2");
		const ca = gsplatData.getProp("opacity");
		const sigmoid = (v6) => {
			if (v6 > 0) {
				return 1 / (1 + Math.exp(-v6));
			}
			const t = Math.exp(v6);
			return t / (1 + t);
		};
		this.read = (i2) => {
			if (p) {
				p.x = x3[i2];
				p.y = y2[i2];
				p.z = z2[i2];
			}
			if (r) {
				r.set(rx[i2], ry[i2], rz[i2], rw[i2]);
			}
			if (s2) {
				if (activated) {
					s2.set(sx[i2], sy[i2], sz[i2]);
				} else {
					s2.set(Math.exp(sx[i2]), Math.exp(sy[i2]), Math.exp(sz[i2]));
				}
			}
			if (c2) {
				c2.set(
					0.5 + cr[i2] * SH_C0,
					0.5 + cg[i2] * SH_C0,
					0.5 + cb[i2] * SH_C0,
					activated ? ca[i2] : sigmoid(ca[i2])
				);
			}
		};
	}
};
var calcSplatMat = (result, p, r) => {
	quat.set(r.x, r.y, r.z, r.w).normalize();
	result.setTRS(p, quat, Vec3.ONE);
};
var GSplatData = class _GSplatData {
	elements;
	numSplats;
	comments;
	activated = false;
	constructor(elements, comments = []) {
		this.elements = elements;
		this.numSplats = this.getElement("vertex").count;
		this.comments = comments;
	}
	static calcSplatAabb(result, p, r, s2) {
		calcSplatMat(mat4, p, r);
		aabb.center.set(0, 0, 0);
		aabb.halfExtents.set(s2.x * 2, s2.y * 2, s2.z * 2);
		result.setFromTransformedAabb(aabb, mat4);
	}
	// access a named property
	getProp(name, elementName = "vertex") {
		return this.getElement(elementName)?.properties.find((p) => p.name === name)?.storage;
	}
	// access the named element
	getElement(name) {
		return this.elements.find((e) => e.name === name);
	}
	// add a new property
	addProp(name, storage) {
		this.getElement("vertex").properties.push({
			type: "float",
			name,
			storage,
			byteSize: 4
		});
	}
	createIter(p, r, s2, c2) {
		return new SplatIterator(this, p, r, s2, c2);
	}
	calcAabb(result, pred) {
		let mx, my, mz, Mx, My, Mz;
		let first = true;
		const x3 = this.getProp("x");
		const y2 = this.getProp("y");
		const z2 = this.getProp("z");
		const sx = this.getProp("scale_0");
		const sy = this.getProp("scale_1");
		const sz = this.getProp("scale_2");
		for (let i2 = 0; i2 < this.numSplats; ++i2) {
			if (pred && !pred(i2)) {
				continue;
			}
			const px = x3[i2];
			const py = y2[i2];
			const pz = z2[i2];
			const scale2 = Math.max(sx[i2], sy[i2], sz[i2]);
			if (!isFinite(px) || !isFinite(py) || !isFinite(pz) || !isFinite(scale2)) {
				continue;
			}
			const scaleVal = 2 * (this.activated ? scale2 : Math.exp(scale2));
			if (first) {
				first = false;
				mx = px - scaleVal;
				my = py - scaleVal;
				mz = pz - scaleVal;
				Mx = px + scaleVal;
				My = py + scaleVal;
				Mz = pz + scaleVal;
			} else {
				mx = Math.min(mx, px - scaleVal);
				my = Math.min(my, py - scaleVal);
				mz = Math.min(mz, pz - scaleVal);
				Mx = Math.max(Mx, px + scaleVal);
				My = Math.max(My, py + scaleVal);
				Mz = Math.max(Mz, pz + scaleVal);
			}
		}
		if (!first) {
			result.center.set((mx + Mx) * 0.5, (my + My) * 0.5, (mz + Mz) * 0.5);
			result.halfExtents.set((Mx - mx) * 0.5, (My - my) * 0.5, (Mz - mz) * 0.5);
		}
		return !first;
	}
	calcAabbExact(result, pred) {
		const p = new Vec3();
		const r = new Quat();
		const s2 = new Vec3();
		const iter = this.createIter(p, r, s2);
		let first = true;
		for (let i2 = 0; i2 < this.numSplats; ++i2) {
			if (pred && !pred(i2)) {
				continue;
			}
			iter.read(i2);
			if (first) {
				first = false;
				_GSplatData.calcSplatAabb(result, p, r, s2);
			} else {
				_GSplatData.calcSplatAabb(aabb2, p, r, s2);
				result.add(aabb2);
			}
		}
		return !first;
	}
	getCenters() {
		const x3 = this.getProp("x");
		const y2 = this.getProp("y");
		const z2 = this.getProp("z");
		const result = new Float32Array(this.numSplats * 3);
		for (let i2 = 0; i2 < this.numSplats; ++i2) {
			result[i2 * 3 + 0] = x3[i2];
			result[i2 * 3 + 1] = y2[i2];
			result[i2 * 3 + 2] = z2[i2];
		}
		return result;
	}
	calcFocalPoint(result, pred) {
		const x3 = this.getProp("x");
		const y2 = this.getProp("y");
		const z2 = this.getProp("z");
		const sx = this.getProp("scale_0");
		const sy = this.getProp("scale_1");
		const sz = this.getProp("scale_2");
		result.x = 0;
		result.y = 0;
		result.z = 0;
		let sum = 0;
		for (let i2 = 0; i2 < this.numSplats; ++i2) {
			if (pred && !pred(i2)) {
				continue;
			}
			const px = x3[i2];
			const py = y2[i2];
			const pz = z2[i2];
			if (!isFinite(px) || !isFinite(py) || !isFinite(pz)) {
				continue;
			}
			const maxScale = Math.max(sx[i2], sy[i2], sz[i2]);
			const weight = 1 / (1 + (this.activated ? maxScale : Math.exp(maxScale)));
			result.x += px * weight;
			result.y += py * weight;
			result.z += pz * weight;
			sum += weight;
		}
		result.mulScalar(1 / sum);
	}
	renderWireframeBounds(scene, worldMat) {
		const p = new Vec3();
		const r = new Quat();
		const s2 = new Vec3();
		const min = new Vec3();
		const max = new Vec3();
		const iter = this.createIter(p, r, s2);
		for (let i2 = 0; i2 < this.numSplats; ++i2) {
			iter.read(i2);
			calcSplatMat(mat4, p, r);
			mat4.mul2(worldMat, mat4);
			min.set(s2.x * -2, s2.y * -2, s2.z * -2);
			max.set(s2.x * 2, s2.y * 2, s2.z * 2);
			scene.immediate.drawWireAlignedBox(min, max, debugColor, true, scene.defaultDrawLayer, mat4);
		}
	}
	get isCompressed() {
		return false;
	}
	// return the number of spherical harmonic bands present. value will be between 0 and 3 inclusive.
	get shBands() {
		const numProps = () => {
			for (let i2 = 0; i2 < 45; ++i2) {
				if (!this.getProp(`f_rest_${i2}`)) {
					return i2;
				}
			}
			return 45;
		};
		const sizes = {
			9: 1,
			24: 2,
			45: 3
		};
		return sizes[numProps()] ?? 0;
	}
	calcMortonOrder() {
		const calcMinMax = (arr) => {
			let min = arr[0];
			let max = arr[0];
			for (let i2 = 1; i2 < arr.length; i2++) {
				if (arr[i2] < min) min = arr[i2];
				if (arr[i2] > max) max = arr[i2];
			}
			return { min, max };
		};
		const encodeMorton3 = (x4, y3, z3) => {
			const Part1By2 = (x5) => {
				x5 &= 1023;
				x5 = (x5 ^ x5 << 16) & 4278190335;
				x5 = (x5 ^ x5 << 8) & 50393103;
				x5 = (x5 ^ x5 << 4) & 51130563;
				x5 = (x5 ^ x5 << 2) & 153391689;
				return x5;
			};
			return (Part1By2(z3) << 2) + (Part1By2(y3) << 1) + Part1By2(x4);
		};
		const x3 = this.getProp("x");
		const y2 = this.getProp("y");
		const z2 = this.getProp("z");
		const { min: minX, max: maxX } = calcMinMax(x3);
		const { min: minY, max: maxY } = calcMinMax(y2);
		const { min: minZ, max: maxZ } = calcMinMax(z2);
		const sizeX = minX === maxX ? 0 : 1024 / (maxX - minX);
		const sizeY = minY === maxY ? 0 : 1024 / (maxY - minY);
		const sizeZ = minZ === maxZ ? 0 : 1024 / (maxZ - minZ);
		const codes = /* @__PURE__ */ new Map();
		for (let i2 = 0; i2 < this.numSplats; i2++) {
			const ix = Math.min(1023, Math.floor((x3[i2] - minX) * sizeX));
			const iy = Math.min(1023, Math.floor((y2[i2] - minY) * sizeY));
			const iz = Math.min(1023, Math.floor((z2[i2] - minZ) * sizeZ));
			const code = encodeMorton3(ix, iy, iz);
			const val = codes.get(code);
			if (val) {
				val.push(i2);
			} else {
				codes.set(code, [i2]);
			}
		}
		const keys = Array.from(codes.keys()).sort((a, b) => a - b);
		const indices = new Uint32Array(this.numSplats);
		let idx = 0;
		for (let i2 = 0; i2 < keys.length; ++i2) {
			const val = codes.get(keys[i2]);
			for (let j = 0; j < val.length; ++j) {
				indices[idx++] = val[j];
			}
		}
		return indices;
	}
	// reorder the splat data to aid in better gpu memory access at render time
	reorder(order) {
		const cache = /* @__PURE__ */ new Map();
		const getStorage = (size) => {
			if (cache.has(size)) {
				const buffer = cache.get(size);
				cache.delete(size);
				return buffer;
			}
			return new ArrayBuffer(size);
		};
		const returnStorage = (buffer) => {
			cache.set(buffer.byteLength, buffer);
		};
		const reorder = (data2) => {
			const result = new data2.constructor(getStorage(data2.byteLength));
			for (let i2 = 0; i2 < order.length; i2++) {
				result[i2] = data2[order[i2]];
			}
			returnStorage(data2.buffer);
			return result;
		};
		this.elements.forEach((element) => {
			element.properties.forEach((property) => {
				if (property.storage) {
					property.storage = reorder(property.storage);
				}
			});
		});
	}
	// reorder the splat data to aid in better gpu memory access at render time
	reorderData() {
		this.reorder(this.calcMortonOrder());
	}
};

function SortWorker() {
	const myself = typeof self !== "undefined" && self || __require("node:worker_threads").parentPort;
	let order;
	let centers;
	let chunks;
	let mapping;
	let cameraPosition4;
	let cameraDirection3;
	let forceUpdate = false;
	const lastCameraPosition = { x: 0, y: 0, z: 0 };
	const lastCameraDirection = { x: 0, y: 0, z: 0 };
	const boundMin = { x: 0, y: 0, z: 0 };
	const boundMax = { x: 0, y: 0, z: 0 };
	let distances;
	let countBuffer;
	const numBins = 32;
	const binCount = new Array(numBins).fill(0);
	const binBase = new Array(numBins).fill(0);
	const binDivider = new Array(numBins).fill(0);
	const binarySearch = (m, n, compare_fn) => {
		while (m <= n) {
			const k = n + m >> 1;
			const cmp = compare_fn(k);
			if (cmp > 0) {
				m = k + 1;
			} else if (cmp < 0) {
				n = k - 1;
			} else {
				return k;
			}
		}
		return ~m;
	};
	const update = () => {
		if (!order || !centers || centers.length === 0 || !cameraPosition4 || !cameraDirection3) return;
		const sortStartTime = performance.now();
		const px = cameraPosition4.x;
		const py = cameraPosition4.y;
		const pz = cameraPosition4.z;
		const dx = cameraDirection3.x;
		const dy = cameraDirection3.y;
		const dz = cameraDirection3.z;
		const epsilon = 1e-3;
		if (!forceUpdate && Math.abs(px - lastCameraPosition.x) < epsilon && Math.abs(py - lastCameraPosition.y) < epsilon && Math.abs(pz - lastCameraPosition.z) < epsilon && Math.abs(dx - lastCameraDirection.x) < epsilon && Math.abs(dy - lastCameraDirection.y) < epsilon && Math.abs(dz - lastCameraDirection.z) < epsilon) {
			return;
		}
		forceUpdate = false;
		lastCameraPosition.x = px;
		lastCameraPosition.y = py;
		lastCameraPosition.z = pz;
		lastCameraDirection.x = dx;
		lastCameraDirection.y = dy;
		lastCameraDirection.z = dz;
		let minDist;
		let maxDist;
		for (let i2 = 0; i2 < 8; ++i2) {
			const x3 = i2 & 1 ? boundMin.x : boundMax.x;
			const y2 = i2 & 2 ? boundMin.y : boundMax.y;
			const z2 = i2 & 4 ? boundMin.z : boundMax.z;
			const d = x3 * dx + y2 * dy + z2 * dz;
			if (i2 === 0) {
				minDist = maxDist = d;
			} else {
				minDist = Math.min(minDist, d);
				maxDist = Math.max(maxDist, d);
			}
		}
		const numVertices = centers.length / 3;
		const compareBits = Math.max(10, Math.min(20, Math.round(Math.log2(numVertices / 4))));
		const bucketCount = 2 ** compareBits + 1;
		if (distances?.length !== numVertices) {
			distances = new Uint32Array(numVertices);
		}
		if (!countBuffer || countBuffer.length !== bucketCount) {
			countBuffer = new Uint32Array(bucketCount);
		} else {
			countBuffer.fill(0);
		}
		const range = maxDist - minDist;
		if (range < 1e-6) {
			for (let i2 = 0; i2 < numVertices; ++i2) {
				distances[i2] = 0;
				countBuffer[0]++;
			}
		} else {
			const numChunks = chunks.length / 4;
			binCount.fill(0);
			for (let i2 = 0; i2 < numChunks; ++i2) {
				const x3 = chunks[i2 * 4 + 0];
				const y2 = chunks[i2 * 4 + 1];
				const z2 = chunks[i2 * 4 + 2];
				const r = chunks[i2 * 4 + 3];
				const d = x3 * dx + y2 * dy + z2 * dz - minDist;
				const binMin = Math.max(0, Math.floor((d - r) * numBins / range));
				const binMax = Math.min(numBins, Math.ceil((d + r) * numBins / range));
				for (let j = binMin; j < binMax; ++j) {
					binCount[j]++;
				}
			}
			const binTotal = binCount.reduce((a, b) => a + b, 0);
			for (let i2 = 0; i2 < numBins; ++i2) {
				binDivider[i2] = binCount[i2] / binTotal * bucketCount >>> 0;
			}
			for (let i2 = 0; i2 < numBins; ++i2) {
				binBase[i2] = i2 === 0 ? 0 : binBase[i2 - 1] + binDivider[i2 - 1];
			}
			const binRange = range / numBins;
			let ii = 0;
			for (let i2 = 0; i2 < numVertices; ++i2) {
				const x3 = centers[ii++];
				const y2 = centers[ii++];
				const z2 = centers[ii++];
				const d = (x3 * dx + y2 * dy + z2 * dz - minDist) / binRange;
				const bin = d >>> 0;
				const sortKey = binBase[bin] + binDivider[bin] * (d - bin) >>> 0;
				distances[i2] = sortKey;
				countBuffer[sortKey]++;
			}
		}
		for (let i2 = 1; i2 < bucketCount; i2++) {
			countBuffer[i2] += countBuffer[i2 - 1];
		}
		for (let i2 = 0; i2 < numVertices; i2++) {
			const distance = distances[i2];
			const destIndex = --countBuffer[distance];
			order[destIndex] = i2;
		}
		const cameraDist = px * dx + py * dy + pz * dz;
		const dist = (i2) => {
			let o = order[i2] * 3;
			return centers[o++] * dx + centers[o++] * dy + centers[o] * dz - cameraDist;
		};
		const findZero = () => {
			const result = binarySearch(0, numVertices - 1, (i2) => -dist(i2));
			return Math.min(numVertices, Math.abs(result));
		};
		const count = dist(numVertices - 1) >= 0 ? findZero() : numVertices;
		if (mapping) {
			for (let i2 = 0; i2 < numVertices; ++i2) {
				order[i2] = mapping[order[i2]];
			}
		}
		myself.postMessage({
			order: order.buffer,
			count,
			sortTime: performance.now() - sortStartTime
		}, [order.buffer]);
		order = null;
	};
	myself.addEventListener("message", (message) => {
		const msgData = message.data ?? message;
		if (msgData.order) {
			order = new Uint32Array(msgData.order);
		}
		if (msgData.centers) {
			centers = new Float32Array(msgData.centers);
			forceUpdate = true;
			if (msgData.chunks) {
				const chunksSrc = new Float32Array(msgData.chunks);
				chunks = new Float32Array(msgData.chunks, 0, chunksSrc.length * 4 / 6);
				boundMin.x = chunksSrc[0];
				boundMin.y = chunksSrc[1];
				boundMin.z = chunksSrc[2];
				boundMax.x = chunksSrc[3];
				boundMax.y = chunksSrc[4];
				boundMax.z = chunksSrc[5];
				for (let i2 = 0; i2 < chunksSrc.length / 6; ++i2) {
					const mx = chunksSrc[i2 * 6 + 0];
					const my = chunksSrc[i2 * 6 + 1];
					const mz = chunksSrc[i2 * 6 + 2];
					const Mx = chunksSrc[i2 * 6 + 3];
					const My = chunksSrc[i2 * 6 + 4];
					const Mz = chunksSrc[i2 * 6 + 5];
					chunks[i2 * 4 + 0] = (mx + Mx) * 0.5;
					chunks[i2 * 4 + 1] = (my + My) * 0.5;
					chunks[i2 * 4 + 2] = (mz + Mz) * 0.5;
					chunks[i2 * 4 + 3] = Math.sqrt((Mx - mx) ** 2 + (My - my) ** 2 + (Mz - mz) ** 2) * 0.5;
					if (mx < boundMin.x) boundMin.x = mx;
					if (my < boundMin.y) boundMin.y = my;
					if (mz < boundMin.z) boundMin.z = mz;
					if (Mx > boundMax.x) boundMax.x = Mx;
					if (My > boundMax.y) boundMax.y = My;
					if (Mz > boundMax.z) boundMax.z = Mz;
				}
			} else {
				const numVertices = centers.length / 3;
				const numChunks = Math.ceil(numVertices / 256);
				chunks = new Float32Array(numChunks * 4);
				boundMin.x = boundMin.y = boundMin.z = Infinity;
				boundMax.x = boundMax.y = boundMax.z = -Infinity;
				let mx, my, mz, Mx, My, Mz;
				for (let c2 = 0; c2 < numChunks; ++c2) {
					mx = my = mz = Infinity;
					Mx = My = Mz = -Infinity;
					const start = c2 * 256;
					const end = Math.min(numVertices, (c2 + 1) * 256);
					for (let i2 = start; i2 < end; ++i2) {
						const x3 = centers[i2 * 3 + 0];
						const y2 = centers[i2 * 3 + 1];
						const z2 = centers[i2 * 3 + 2];
						const validX = Number.isFinite(x3);
						const validY = Number.isFinite(y2);
						const validZ = Number.isFinite(z2);
						if (!validX) centers[i2 * 3 + 0] = 0;
						if (!validY) centers[i2 * 3 + 1] = 0;
						if (!validZ) centers[i2 * 3 + 2] = 0;
						if (!validX || !validY || !validZ) {
							continue;
						}
						if (x3 < mx) mx = x3;
						else if (x3 > Mx) Mx = x3;
						if (y2 < my) my = y2;
						else if (y2 > My) My = y2;
						if (z2 < mz) mz = z2;
						else if (z2 > Mz) Mz = z2;
						if (x3 < boundMin.x) boundMin.x = x3;
						else if (x3 > boundMax.x) boundMax.x = x3;
						if (y2 < boundMin.y) boundMin.y = y2;
						else if (y2 > boundMax.y) boundMax.y = y2;
						if (z2 < boundMin.z) boundMin.z = z2;
						else if (z2 > boundMax.z) boundMax.z = z2;
					}
					chunks[c2 * 4 + 0] = (mx + Mx) * 0.5;
					chunks[c2 * 4 + 1] = (my + My) * 0.5;
					chunks[c2 * 4 + 2] = (mz + Mz) * 0.5;
					chunks[c2 * 4 + 3] = Math.sqrt((Mx - mx) ** 2 + (My - my) ** 2 + (Mz - mz) ** 2) * 0.5;
				}
			}
		}
		if (msgData.hasOwnProperty("mapping")) {
			mapping = msgData.mapping ? new Uint32Array(msgData.mapping) : null;
			forceUpdate = true;
		}
		if (msgData.cameraPosition) cameraPosition4 = msgData.cameraPosition;
		if (msgData.cameraDirection) cameraDirection3 = msgData.cameraDirection;
		update();
	});
}

var GSplatSorter = class extends EventHandler {
	worker;
	target;
	orderData;
	centers;
	scene;
	uploadStream;
	pendingSorted = null;
	constructor(device, scene) {
		super();
		this.scene = scene ?? null;
		this.uploadStream = new UploadStream(device, !device.isWebGPU);
		const messageHandler = (message) => {
			const msgData = message.data ?? message;
			if (this.scene && msgData.sortTime !== void 0) {
				this.scene.fire("gsplat:sorted", msgData.sortTime);
			}
			const newOrder = msgData.order;
			const oldOrder = this.orderData;
			this.worker.postMessage({
				order: oldOrder
			}, [oldOrder]);
			this.orderData = newOrder;
			this.pendingSorted = {
				count: msgData.count,
				data: new Uint32Array(newOrder)
			};
			this.fire("updated");
		};
		const workerSource = `(${SortWorker.toString()})()`;
		if (platform.environment === "node") {
			this.worker = new Worker(workerSource, {
				eval: true
			});
			this.worker.on("message", messageHandler);
		} else {
			this.worker = new Worker(URL.createObjectURL(new Blob([workerSource], {
				type: "application/javascript"
			})));
			this.worker.addEventListener("message", messageHandler);
		}
	}
	destroy() {
		this.worker.terminate();
		this.worker = null;
		this.uploadStream.destroy();
		this.uploadStream = null;
	}
	init(target2, numSplats, centers, chunks) {
		this.target = target2;
		this.centers = centers.slice();
		const orderBuffer = new Uint32Array(numSplats);
		for (let i2 = 0; i2 < numSplats; ++i2) {
			orderBuffer[i2] = i2;
		}
		this.orderData = new ArrayBuffer(numSplats * 4);
		const obj = {
			order: orderBuffer.buffer,
			centers: centers.buffer,
			chunks: chunks?.buffer
		};
		const transfer = [orderBuffer.buffer, centers.buffer].concat(chunks ? [chunks.buffer] : []);
		this.worker.postMessage(obj, transfer);
	}
	applyPendingSorted() {
		if (this.pendingSorted) {
			const { count, data: data2 } = this.pendingSorted;
			this.pendingSorted = null;
			this.uploadStream.upload(data2, this.target);
			return count;
		}
		return -1;
	}
	setMapping(mapping) {
		if (mapping) {
			const centers = new Float32Array(mapping.length * 3);
			for (let i2 = 0; i2 < mapping.length; ++i2) {
				const src = mapping[i2] * 3;
				const dst = i2 * 3;
				centers[dst + 0] = this.centers[src + 0];
				centers[dst + 1] = this.centers[src + 1];
				centers[dst + 2] = this.centers[src + 2];
			}
			this.worker.postMessage({
				centers: centers.buffer,
				mapping: mapping.buffer
			}, [centers.buffer, mapping.buffer]);
		} else {
			const centers = this.centers.slice();
			this.worker.postMessage({
				centers: centers.buffer,
				mapping: null
			}, [centers.buffer]);
		}
	}
	setCamera(pos, dir4) {
		this.worker.postMessage({
			cameraPosition: { x: pos.x, y: pos.y, z: pos.z },
			cameraDirection: { x: dir4.x, y: dir4.y, z: dir4.z }
		});
	}
};

var mat = new Mat4();
var cameraPosition = new Vec3();
var cameraDirection = new Vec3();
var GSplatInstance = class {
	resource;
	orderTexture;
	orderBuffer;
	_material;
	meshInstance;
	options = {};
	sorter = null;
	lastCameraPosition = new Vec3();
	lastCameraDirection = new Vec3();
	cameras = [];
	constructor(resource, options2 = {}) {
		this.resource = resource;
		const device = resource.device;
		const dims = resource.streams.textureDimensions;
		const numSplats = dims.x * dims.y;
		if (device.isWebGPU) {
			this.orderBuffer = new StorageBuffer(device, numSplats * 4, BUFFERUSAGE_COPY_DST);
		} else {
			this.orderTexture = resource.streams.createTexture(
				"splatOrder",
				PIXELFORMAT_R32U,
				dims
			);
		}
		if (options2.material) {
			this._material = options2.material;
			this._material.setDefine("{GSPLAT_INSTANCE_SIZE}", String(GSplatResourceBase.instanceSize));
			this.setMaterialOrderData(this._material);
			this._material.setParameter("alphaClipForward", 1 / 255);
		} else {
			this._material = new ShaderMaterial({
				uniqueName: "SplatMaterial",
				vertexGLSL: '#include "gsplatVS"',
				fragmentGLSL: '#include "gsplatPS"',
				vertexWGSL: '#include "gsplatVS"',
				fragmentWGSL: '#include "gsplatPS"',
				attributes: {
					vertex_position: SEMANTIC_POSITION
				}
			});
			this.configureMaterial(this._material);
			this._material.update();
		}
		resource.ensureMesh();
		this.meshInstance = new MeshInstance(resource.mesh, this._material);
		this.meshInstance.setInstancing(true, true);
		this.meshInstance.gsplatInstance = this;
		this.meshInstance.instancingCount = 0;
		if (resource.hasCenters) {
			const centers = resource.centers.slice();
			const chunks = resource.chunks?.slice();
			const orderTarget = this.orderBuffer ?? this.orderTexture;
			this.sorter = new GSplatSorter(device, options2.scene);
			this.sorter.init(orderTarget, numSplats, centers, chunks);
		} else {
		}
	}
	destroy() {
		this.resource?.releaseMesh();
		this.orderTexture?.destroy();
		this.orderBuffer?.destroy();
		this.material?.destroy();
		this.meshInstance?.destroy();
		this.sorter?.destroy();
	}
	setMaterialOrderData(material) {
		if (this.orderBuffer) {
			material.setParameter("splatOrder", this.orderBuffer);
		} else {
			material.setParameter("splatOrder", this.orderTexture);
			material.setParameter("splatTextureSize", this.orderTexture.width);
		}
	}
	set material(value) {
		if (this._material !== value) {
			this._material = value;
			this._material.setDefine("{GSPLAT_INSTANCE_SIZE}", String(GSplatResourceBase.instanceSize));
			this.setMaterialOrderData(this._material);
			this._material.setParameter("alphaClipForward", 1 / 255);
			if (this.meshInstance) {
				this.meshInstance.material = value;
			}
		}
	}
	get material() {
		return this._material;
	}
	configureMaterial(material, options2 = {}) {
		this.resource.configureMaterial(material, null, this.resource.format.getInputDeclarations());
		material.setDefine("{GSPLAT_INSTANCE_SIZE}", GSplatResourceBase.instanceSize);
		material.setParameter("numSplats", 0);
		this.setMaterialOrderData(material);
		material.setParameter("alphaClip", 0.3);
		material.setParameter("alphaClipForward", 1 / 255);
		material.setParameter("minPixelSize", 2);
		material.setDefine(`DITHER_${options2.dither ? "BLUENOISE" : "NONE"}`, "");
		material.cull = CULLFACE_NONE;
		material.blendType = options2.dither ? BLEND_NONE : BLEND_PREMULTIPLIED;
		material.depthWrite = !!options2.dither;
	}
	sort(cameraNode) {
		if (this.sorter) {
			const cameraMat = cameraNode.getWorldTransform();
			cameraMat.getTranslation(cameraPosition);
			cameraMat.getZ(cameraDirection);
			const modelMat = this.meshInstance.node.getWorldTransform();
			const invModelMat3 = mat.invert(modelMat);
			invModelMat3.transformPoint(cameraPosition, cameraPosition);
			invModelMat3.transformVector(cameraDirection, cameraDirection);
			if (!cameraPosition.equalsApprox(this.lastCameraPosition) || !cameraDirection.equalsApprox(this.lastCameraDirection)) {
				this.lastCameraPosition.copy(cameraPosition);
				this.lastCameraDirection.copy(cameraDirection);
				this.sorter.setCamera(cameraPosition, cameraDirection);
			}
		}
	}
	update() {
		const count = this.sorter?.applyPendingSorted() ?? -1;
		if (count >= 0) {
			this.meshInstance.instancingCount = Math.ceil(count / GSplatResourceBase.instanceSize);
			this.material.setParameter("numSplats", count);
		}
		if (this.cameras.length > 0) {
			const camera = this.cameras[0];
			this.sort(camera._node);
			this.cameras.length = 0;
		}
	}
};

var gsplatProcess_default = `
uniform uint splatTextureSize;
uniform uint dstTextureSize;
uniform uint srcNumSplats;
uniform uint dstNumSplats;
#include "gsplatSplatVS"
#include "gsplatProcessInputVS"
#include "gsplatProcessOutputVS"
#include "gsplatProcessReadVS"
#include "gsplatProcessChunk"
void main(void) {
	ivec2 fragCoords = ivec2(gl_FragCoord.xy);
	
	uint splatIndex = uint(fragCoords.y * int(dstTextureSize) + fragCoords.x);
	
	if (splatIndex >= dstNumSplats) discard;
	
	setSplat(splatIndex);
	
	process();
}
`;

var gsplatProcess_default2 = `
uniform splatTextureSize: u32;
uniform dstTextureSize: u32;
uniform srcNumSplats: u32;
uniform dstNumSplats: u32;
#include "gsplatSplatVS"
#include "gsplatProcessInputVS"
var<private> processOutput: FragmentOutput;
#include "gsplatProcessOutputVS"
#include "gsplatProcessReadVS"
#include "gsplatProcessChunk"
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	let fragCoords = vec2i(input.position.xy);
	
	let splatIndex = u32(fragCoords.y * i32(uniform.dstTextureSize) + fragCoords.x);
	
	if (splatIndex >= uniform.dstNumSplats) {
		discard;
	}
	
	setSplat(splatIndex);
	
	process();
	
	return processOutput;
}
`;

var GSplatProcessor = class {
	_device;
	_source;
	_destination;
	_srcResource;
	_dstResource;
	_dstStreamDescriptors;
	_dstStreamNames;
	_useAllInputStreams;
	_srcTextures = [];
	_renderTarget = null;
	_quadRender = null;
	_renderPass = null;
	_parameters = /* @__PURE__ */ new Map();
	blendState = BlendState.NOBLEND;
	constructor(device, source, destination, options2) {
		this._device = device;
		this._source = source;
		this._destination = destination;
		this._srcResource = source.resource ?? source.component?.resource;
		this._dstResource = destination.resource ?? destination.component?.resource;
		this._dstStreamDescriptors = [];
		this._dstStreamNames = /* @__PURE__ */ new Set();
		for (const streamName of destination.streams) {
			const stream = this._dstResource.format.getStream(streamName);
			if (stream) {
				this._dstStreamDescriptors.push(stream);
				this._dstStreamNames.add(stream.name);
			}
		}
		this._useAllInputStreams = !source.streams?.length;
		const srcFormat = this._srcResource.format;
		const srcStreams = this._useAllInputStreams ? [...srcFormat.streams, ...srcFormat.extraStreams] : source.streams.map((name) => ({ name }));
		for (const stream of srcStreams) {
			const texture = this._resolveTexture(source, stream.name, this._srcResource);
			this._srcTextures.push({ name: stream.name, texture });
		}
		this._createRenderTarget();
		this._createShader(options2);
		this._renderPass = new RenderPassShaderQuad(device);
		this._renderPass.quadRender = this._quadRender;
		this._renderPass.init(this._renderTarget);
		this._renderPass.colorOps.clear = false;
		this._renderPass.depthStencilOps.clearDepth = false;
	}
	destroy() {
		this._renderTarget?.destroy();
		this._renderTarget = null;
		this._quadRender?.destroy();
		this._quadRender = null;
		this._renderPass?.destroy();
		this._renderPass = null;
		this._parameters.clear();
	}
	_resolveTexture(binding, name, resource) {
		if (binding.component) {
			const stream = resource.format.getStream(name);
			if (stream?.storage === GSPLAT_STREAM_INSTANCE) {
				const texture2 = binding.component.getInstanceTexture(name);
				if (texture2) {
					return texture2;
				}
			}
		}
		const texture = resource.getTexture(name);
		if (!texture) {
		}
		return texture;
	}
	_createRenderTarget() {
		const colorBuffers = [];
		for (const stream of this._dstStreamDescriptors) {
			const texture = this._resolveTexture(this._destination, stream.name, this._dstResource);
			if (texture) {
				colorBuffers.push(texture);
			} else {
			}
		}
		if (colorBuffers.length > 0) {
			this._renderTarget = new RenderTarget({
				name: "GSplatProcessor-MRT",
				colorBuffers,
				depth: false,
				flipY: true
			});
		}
	}
	_createShader(options2) {
		const { processGLSL = "", processWGSL = "" } = options2;
		const device = this._device;
		const srcFormat = this._srcResource.format;
		const dstFormat = this._dstResource.format;
		let inputDeclarations = "";
		let readCode = "";
		if (this._useAllInputStreams) {
			const allStreams = [...srcFormat.streams, ...srcFormat.extraStreams];
			const sameResource = this._srcResource === this._dstResource;
			const inputStreamNames = allStreams.filter((s2) => !sameResource || !this._dstStreamNames.has(s2.name)).map((s2) => s2.name);
			inputDeclarations = srcFormat.getInputDeclarations(inputStreamNames);
			readCode = srcFormat.getReadCode();
		} else {
			inputDeclarations = srcFormat.getInputDeclarations(this._source.streams);
		}
		const outputDeclarations = dstFormat.getOutputDeclarations(this._dstStreamDescriptors);
		const fragmentOutputTypes = this._dstStreamDescriptors.map((stream) => {
			const info = getGlslShaderType(stream.format);
			return info.returnType;
		});
		const defines = /* @__PURE__ */ new Map();
		this._srcResource.configureMaterialDefines(defines);
		defines.set("SH_BANDS", "0");
		const isWebGPU = device.isWebGPU;
		const includes = /* @__PURE__ */ new Map();
		includes.set("gsplatProcessInputVS", inputDeclarations);
		includes.set("gsplatProcessOutputVS", outputDeclarations);
		includes.set("gsplatProcessReadVS", readCode);
		includes.set("gsplatProcessChunk", isWebGPU ? processWGSL : processGLSL);
		const hash = hashCode([
			isWebGPU ? processWGSL : processGLSL,
			this._useAllInputStreams ? "1" : "0"
		].join("|"));
		const outputStreams = this._dstStreamDescriptors.map((s2) => s2.name).join(",");
		const shader = ShaderUtils.createShader(device, {
			uniqueName: `GSplatProcessor:${srcFormat.hash};${hash};out=${outputStreams}`,
			attributes: { vertex_position: SEMANTIC_POSITION },
			vertexDefines: defines,
			fragmentDefines: defines,
			vertexChunk: "fullscreenQuadVS",
			fragmentGLSL: gsplatProcess_default,
			fragmentWGSL: gsplatProcess_default2,
			fragmentIncludes: includes,
			fragmentOutputTypes
		});
		this._quadRender = new QuadRender(shader);
	}
	setParameter(name, data2) {
		const scopeId = this._device.scope.resolve(name);
		this._parameters.set(name, { scopeId, data: data2 });
	}
	getParameter(name) {
		return this._parameters.get(name)?.data;
	}
	deleteParameter(name) {
		this._parameters.delete(name);
	}
	process() {
		if (!this._renderPass) {
			return;
		}
		const device = this._device;
		for (const { name, texture } of this._srcTextures) {
			device.scope.resolve(name).setValue(texture);
		}
		device.scope.resolve("splatTextureSize").setValue(this._srcResource.textureDimensions.x);
		device.scope.resolve("dstTextureSize").setValue(this._dstResource.textureDimensions.x);
		device.scope.resolve("srcNumSplats").setValue(this._srcResource.numSplats);
		device.scope.resolve("dstNumSplats").setValue(this._dstResource.numSplats);
		for (const [name, value] of this._srcResource.parameters) {
			device.scope.resolve(name).setValue(value);
		}
		for (const [, param] of this._parameters) {
			param.scopeId.setValue(param.data);
		}
		this._renderPass.blendState = this.blendState;
		this._renderPass.render();
	}
};

var getSHData = (gsplatData, numCoeffs) => {
	const result = [];
	for (let i2 = 0; i2 < numCoeffs; ++i2) {
		result.push(gsplatData.getProp(`f_rest_${i2}`));
	}
	return result;
};
var GSplatResource = class extends GSplatResourceBase {
	shBands;
	constructor(device, gsplatData, options2 = {}) {
		super(device, gsplatData, options2);
		const numSplats = gsplatData.numSplats;
		this.shBands = gsplatData.shBands;
		const streams = [
			{ name: "splatColor", format: PIXELFORMAT_RGBA16F },
			{ name: "transformA", format: PIXELFORMAT_RGBA32U },
			{ name: "transformB", format: PIXELFORMAT_RGBA16F }
		];
		if (this.shBands > 0) {
			streams.push({ name: "splatSH_1to3", format: PIXELFORMAT_RGBA32U });
			if (this.shBands > 1) {
				streams.push({ name: "splatSH_4to7", format: PIXELFORMAT_RGBA32U });
				if (this.shBands > 2) {
					streams.push({ name: "splatSH_8to11", format: PIXELFORMAT_RGBA32U });
					streams.push({ name: "splatSH_12to15", format: PIXELFORMAT_RGBA32U });
				} else {
					streams.push({ name: "splatSH_8to11", format: PIXELFORMAT_R32U });
				}
			}
		}
		this._format = new GSplatFormat(device, streams, {
			readGLSL: '#include "gsplatUncompressedVS"',
			readWGSL: '#include "gsplatUncompressedVS"'
		});
		this.streams.init(this.format, numSplats);
		this.updateColorData(gsplatData);
		this.updateTransformData(gsplatData);
		if (this.shBands > 0) {
			this.updateSHData(gsplatData);
		}
	}
	configureMaterialDefines(defines) {
		defines.set("SH_BANDS", this.shBands);
	}
	updateColorData(gsplatData) {
		const texture = this.streams.getTexture("splatColor");
		if (!texture) {
			return;
		}
		const float2Half = FloatPacking.float2Half;
		const data2 = texture.lock();
		const cr = gsplatData.getProp("f_dc_0");
		const cg = gsplatData.getProp("f_dc_1");
		const cb = gsplatData.getProp("f_dc_2");
		const ca = gsplatData.getProp("opacity");
		const activated = gsplatData.activated;
		const SH_C04 = 0.28209479177387814;
		for (let i2 = 0; i2 < this.numSplats; ++i2) {
			const r = cr[i2] * SH_C04 + 0.5;
			const g = cg[i2] * SH_C04 + 0.5;
			const b = cb[i2] * SH_C04 + 0.5;
			const a = activated ? ca[i2] : 1 / (1 + Math.exp(-ca[i2]));
			data2[i2 * 4 + 0] = float2Half(r);
			data2[i2 * 4 + 1] = float2Half(g);
			data2[i2 * 4 + 2] = float2Half(b);
			data2[i2 * 4 + 3] = float2Half(a);
		}
		texture.unlock();
	}
	updateTransformData(gsplatData) {
		const float2Half = FloatPacking.float2Half;
		const transformA = this.streams.getTexture("transformA");
		const transformB = this.streams.getTexture("transformB");
		if (!transformA) {
			return;
		}
		const dataA = transformA.lock();
		const dataAFloat32 = new Float32Array(dataA.buffer);
		const dataB = transformB.lock();
		const p = new Vec3();
		const r = new Quat();
		const s2 = new Vec3();
		const iter = gsplatData.createIter(p, r, s2);
		for (let i2 = 0; i2 < this.numSplats; i2++) {
			iter.read(i2);
			r.normalize();
			if (r.w < 0) {
				r.mulScalar(-1);
			}
			dataAFloat32[i2 * 4 + 0] = p.x;
			dataAFloat32[i2 * 4 + 1] = p.y;
			dataAFloat32[i2 * 4 + 2] = p.z;
			dataA[i2 * 4 + 3] = float2Half(r.x) | float2Half(r.y) << 16;
			dataB[i2 * 4 + 0] = float2Half(s2.x);
			dataB[i2 * 4 + 1] = float2Half(s2.y);
			dataB[i2 * 4 + 2] = float2Half(s2.z);
			dataB[i2 * 4 + 3] = float2Half(r.z);
		}
		transformA.unlock();
		transformB.unlock();
	}
	updateSHData(gsplatData) {
		const sh1to3Texture = this.streams.getTexture("splatSH_1to3");
		const sh4to7Texture = this.streams.getTexture("splatSH_4to7");
		const sh8to11Texture = this.streams.getTexture("splatSH_8to11");
		const sh12to15Texture = this.streams.getTexture("splatSH_12to15");
		const sh1to3Data = sh1to3Texture.lock();
		const sh4to7Data = sh4to7Texture?.lock();
		const sh8to11Data = sh8to11Texture?.lock();
		const sh12to15Data = sh12to15Texture?.lock();
		const numCoeffs = {
			1: 3,
			2: 8,
			3: 15
		}[this.shBands];
		const src = getSHData(gsplatData, numCoeffs * 3);
		const t11 = (1 << 11) - 1;
		const t10 = (1 << 10) - 1;
		const float32 = new Float32Array(1);
		const uint32 = new Uint32Array(float32.buffer);
		const c2 = new Array(numCoeffs * 3).fill(0);
		for (let i2 = 0; i2 < gsplatData.numSplats; ++i2) {
			for (let j = 0; j < numCoeffs; ++j) {
				c2[j * 3] = src[j][i2];
				c2[j * 3 + 1] = src[j + numCoeffs][i2];
				c2[j * 3 + 2] = src[j + numCoeffs * 2][i2];
			}
			let max = c2[0];
			for (let j = 1; j < numCoeffs * 3; ++j) {
				max = Math.max(max, Math.abs(c2[j]));
			}
			if (max === 0) {
				continue;
			}
			for (let j = 0; j < numCoeffs; ++j) {
				c2[j * 3 + 0] = Math.max(0, Math.min(t11, Math.floor((c2[j * 3 + 0] / max * 0.5 + 0.5) * t11 + 0.5)));
				c2[j * 3 + 1] = Math.max(0, Math.min(t10, Math.floor((c2[j * 3 + 1] / max * 0.5 + 0.5) * t10 + 0.5)));
				c2[j * 3 + 2] = Math.max(0, Math.min(t11, Math.floor((c2[j * 3 + 2] / max * 0.5 + 0.5) * t11 + 0.5)));
			}
			float32[0] = max;
			sh1to3Data[i2 * 4 + 0] = uint32[0];
			sh1to3Data[i2 * 4 + 1] = c2[0] << 21 | c2[1] << 11 | c2[2];
			sh1to3Data[i2 * 4 + 2] = c2[3] << 21 | c2[4] << 11 | c2[5];
			sh1to3Data[i2 * 4 + 3] = c2[6] << 21 | c2[7] << 11 | c2[8];
			if (this.shBands > 1) {
				sh4to7Data[i2 * 4 + 0] = c2[9] << 21 | c2[10] << 11 | c2[11];
				sh4to7Data[i2 * 4 + 1] = c2[12] << 21 | c2[13] << 11 | c2[14];
				sh4to7Data[i2 * 4 + 2] = c2[15] << 21 | c2[16] << 11 | c2[17];
				sh4to7Data[i2 * 4 + 3] = c2[18] << 21 | c2[19] << 11 | c2[20];
				if (this.shBands > 2) {
					sh8to11Data[i2 * 4 + 0] = c2[21] << 21 | c2[22] << 11 | c2[23];
					sh8to11Data[i2 * 4 + 1] = c2[24] << 21 | c2[25] << 11 | c2[26];
					sh8to11Data[i2 * 4 + 2] = c2[27] << 21 | c2[28] << 11 | c2[29];
					sh8to11Data[i2 * 4 + 3] = c2[30] << 21 | c2[31] << 11 | c2[32];
					sh12to15Data[i2 * 4 + 0] = c2[33] << 21 | c2[34] << 11 | c2[35];
					sh12to15Data[i2 * 4 + 1] = c2[36] << 21 | c2[37] << 11 | c2[38];
					sh12to15Data[i2 * 4 + 2] = c2[39] << 21 | c2[40] << 11 | c2[41];
					sh12to15Data[i2 * 4 + 3] = c2[42] << 21 | c2[43] << 11 | c2[44];
				} else {
					sh8to11Data[i2] = c2[21] << 21 | c2[22] << 11 | c2[23];
				}
			}
		}
		sh1to3Texture.unlock();
		sh4to7Texture?.unlock();
		sh8to11Texture?.unlock();
		sh12to15Texture?.unlock();
	}
};

var gsplatSogCenters_default = `
#include "gsplatPackingPS"
uniform highp sampler2D means_l;
uniform highp sampler2D means_u;
uniform highp uint numSplats;
uniform highp vec3 means_mins;
uniform highp vec3 means_maxs;
void main(void) {
	int w = int(textureSize(means_l, 0).x);
	ivec2 uv = ivec2(gl_FragCoord.xy);
	if (uint(uv.x + uv.y * w) >= numSplats) {
		discard;
	}
	vec3 l = texelFetch(means_l, uv, 0).xyz;
	vec3 u = texelFetch(means_u, uv, 0).xyz;
	vec3 n = (l + u * 256.0) / 257.0;
	vec3 v = mix(means_mins, means_maxs, n);
	vec3 center = sign(v) * (exp(abs(v)) - 1.0);
	pcFragColor0 = uvec4(floatBitsToUint(center), 0u);
}
`;

var gsplatSogCenters_default2 = `
var means_l: texture_2d<f32>;
var means_u: texture_2d<f32>;
uniform numSplats: u32;
uniform means_mins: vec3f;
uniform means_maxs: vec3f;
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	let w: u32 = textureDimensions(means_l, 0).x;
	let uv: vec2<i32> = vec2<i32>(input.position.xy);
	if (u32(uv.x + uv.y * i32(w)) >= uniform.numSplats) {
		discard;
		return output;
	}
	let l: vec3f = textureLoad(means_l, uv, 0).xyz;
	let u: vec3f = textureLoad(means_u, uv, 0).xyz;
	let n: vec3f = (l + u * 256.0) / 257.0;
	let v: vec3f = mix(uniform.means_mins, uniform.means_maxs, n);
	let center: vec3f = sign(v) * (exp(abs(v)) - 1.0);
	let packed: vec4<u32> = bitcast<vec4<u32>>(vec4f(center, 0.0));
	output.color = packed;
	return output;
}
`;

var SH_C02 = 0.28209479177387814;
var readImageDataAsync = (texture) => {
	if (texture.device.isNull) {
		return new Promise((resolve2) => {
			resolve2(new Uint8Array(texture.width * texture.height * 4));
		});
	}
	return texture.read(0, 0, texture.width, texture.height, {
		mipLevel: 0,
		face: 0,
		immediate: true
	});
};
var resolve = (scope, values) => {
	for (const key in values) {
		scope.resolve(key).setValue(values[key]);
	}
};
var GSplatSogIterator = class {
	constructor(data2, p, r, s2, c2, sh) {
		const lerp = (a, b, t) => a * (1 - t) + b * t;
		const { meta, shBands } = data2;
		const { means, scales, sh0, shN } = meta;
		const means_l_data = p && data2.means_l._levels[0];
		const means_u_data = p && data2.means_u._levels[0];
		const quats_data = r && data2.quats._levels[0];
		const scales_data = s2 && data2.scales._levels[0];
		const sh0_data = c2 && data2.sh0._levels[0];
		const sh_labels_data = sh && data2.sh_labels._levels[0];
		const sh_centroids_data = sh && data2.sh_centroids._levels[0];
		const norm = Math.SQRT2;
		const coeffs = { 1: 3, 2: 8, 3: 15 }[shBands] ?? 0;
		this.read = (i2) => {
			if (p) {
				const nx = lerp(means.mins[0], means.maxs[0], ((means_u_data[i2 * 4 + 0] << 8) + means_l_data[i2 * 4 + 0]) / 65535);
				const ny = lerp(means.mins[1], means.maxs[1], ((means_u_data[i2 * 4 + 1] << 8) + means_l_data[i2 * 4 + 1]) / 65535);
				const nz = lerp(means.mins[2], means.maxs[2], ((means_u_data[i2 * 4 + 2] << 8) + means_l_data[i2 * 4 + 2]) / 65535);
				p.x = Math.sign(nx) * (Math.exp(Math.abs(nx)) - 1);
				p.y = Math.sign(ny) * (Math.exp(Math.abs(ny)) - 1);
				p.z = Math.sign(nz) * (Math.exp(Math.abs(nz)) - 1);
			}
			if (r) {
				const a = (quats_data[i2 * 4 + 0] / 255 - 0.5) * norm;
				const b = (quats_data[i2 * 4 + 1] / 255 - 0.5) * norm;
				const c3 = (quats_data[i2 * 4 + 2] / 255 - 0.5) * norm;
				const d = Math.sqrt(Math.max(0, 1 - (a * a + b * b + c3 * c3)));
				const mode = quats_data[i2 * 4 + 3] - 252;
				switch (mode) {
					case 0:
						r.set(a, b, c3, d);
						break;
					case 1:
						r.set(d, b, c3, a);
						break;
					case 2:
						r.set(b, d, c3, a);
						break;
					case 3:
						r.set(b, c3, d, a);
						break;
				}
			}
			if (s2) {
				if (meta.version === 2) {
					const sx = scales.codebook[scales_data[i2 * 4 + 0]];
					const sy = scales.codebook[scales_data[i2 * 4 + 1]];
					const sz = scales.codebook[scales_data[i2 * 4 + 2]];
					s2.set(sx, sy, sz);
				} else {
					const sx = lerp(scales.mins[0], scales.maxs[0], scales_data[i2 * 4 + 0] / 255);
					const sy = lerp(scales.mins[1], scales.maxs[1], scales_data[i2 * 4 + 1] / 255);
					const sz = lerp(scales.mins[2], scales.maxs[2], scales_data[i2 * 4 + 2] / 255);
					s2.set(sx, sy, sz);
				}
			}
			if (c2) {
				if (meta.version === 2) {
					const r2 = sh0.codebook[sh0_data[i2 * 4 + 0]];
					const g = sh0.codebook[sh0_data[i2 * 4 + 1]];
					const b = sh0.codebook[sh0_data[i2 * 4 + 2]];
					const a = sh0_data[i2 * 4 + 3] / 255;
					c2.set(
						0.5 + r2 * SH_C02,
						0.5 + g * SH_C02,
						0.5 + b * SH_C02,
						a
					);
				} else {
					const r2 = lerp(sh0.mins[0], sh0.maxs[0], sh0_data[i2 * 4 + 0] / 255);
					const g = lerp(sh0.mins[1], sh0.maxs[1], sh0_data[i2 * 4 + 1] / 255);
					const b = lerp(sh0.mins[2], sh0.maxs[2], sh0_data[i2 * 4 + 2] / 255);
					const a = lerp(sh0.mins[3], sh0.maxs[3], sh0_data[i2 * 4 + 3] / 255);
					c2.set(
						0.5 + r2 * SH_C02,
						0.5 + g * SH_C02,
						0.5 + b * SH_C02,
						1 / (1 + Math.exp(-a))
					);
				}
			}
			if (sh) {
				const n = sh_labels_data[i2 * 4 + 0] + (sh_labels_data[i2 * 4 + 1] << 8);
				const u = n % 64 * coeffs;
				const v6 = Math.floor(n / 64);
				if (meta.version === 2) {
					for (let j = 0; j < 3; ++j) {
						for (let k = 0; k < coeffs; ++k) {
							sh[j * 15 + k] = shN.codebook[sh_centroids_data[(u + k) * 4 + j + v6 * data2.sh_centroids.width * 4]];
						}
					}
				} else {
					for (let j = 0; j < 3; ++j) {
						for (let k = 0; k < coeffs; ++k) {
							sh[j * 15 + k] = lerp(shN.mins, shN.maxs, sh_centroids_data[(u + k) * 4 + j + v6 * data2.sh_centroids.width * 4] / 255);
						}
					}
				}
			}
		};
	}
};
var GSplatSogData = class {
	meta;
	numSplats;
	means_l;
	means_u;
	quats;
	scales;
	sh0;
	sh_centroids;
	sh_labels;
	codebookTexture = null;
	url = "";
	_centers = null;
	// Marked when resource is destroyed, to abort any in-flight async preparation
	destroyed = false;
	shBands = 0;
	_destroyGpuResources() {
		this.means_l?.destroy();
		this.means_u?.destroy();
		this.quats?.destroy();
		this.scales?.destroy();
		this.sh0?.destroy();
		this.sh_centroids?.destroy();
		this.sh_labels?.destroy();
		this.codebookTexture?.destroy();
		this.codebookTexture = null;
	}
	// calculate the number of bands given the centroids texture width
	static calcBands(centroidsWidth) {
		const shBandsWidths = { 192: 1, 512: 2, 960: 3 };
		return shBandsWidths[centroidsWidth] ?? 0;
	}
	destroy() {
		this.destroyed = true;
		this._destroyGpuResources();
	}
	createIter(p, r, s2, c2, sh) {
		return new GSplatSogIterator(this, p, r, s2, c2, sh);
	}
	calcAabb(result) {
		const { mins, maxs } = this.meta.means;
		const map = (v6) => Math.sign(v6) * (Math.exp(Math.abs(v6)) - 1);
		result.center.set(
			(map(mins[0]) + map(maxs[0])) * 0.5,
			(map(mins[1]) + map(maxs[1])) * 0.5,
			(map(mins[2]) + map(maxs[2])) * 0.5
		);
		result.halfExtents.set(
			(map(maxs[0]) - map(mins[0])) * 0.5,
			(map(maxs[1]) - map(mins[1])) * 0.5,
			(map(maxs[2]) - map(mins[2])) * 0.5
		);
	}
	getCenters() {
		const centers = this._centers;
		this._centers = null;
		return centers;
	}
	// use bound center for focal point
	calcFocalPoint(result, pred) {
		const { mins, maxs } = this.meta.means;
		const map = (v6) => Math.sign(v6) * (Math.exp(Math.abs(v6)) - 1);
		result.set(
			(map(mins[0]) + map(maxs[0])) * 0.5,
			(map(mins[1]) + map(maxs[1])) * 0.5,
			(map(mins[2]) + map(maxs[2])) * 0.5
		);
	}
	get isSog() {
		return true;
	}
	async decompress() {
		const members = [
			"x",
			"y",
			"z",
			"f_dc_0",
			"f_dc_1",
			"f_dc_2",
			"opacity",
			"scale_0",
			"scale_1",
			"scale_2",
			"rot_0",
			"rot_1",
			"rot_2",
			"rot_3"
		];
		this._patchCodebooks();
		const { shBands } = this;
		const { means_l, means_u, quats, scales, sh0, sh_labels, sh_centroids } = this;
		means_l._levels[0] = await readImageDataAsync(means_l);
		means_u._levels[0] = await readImageDataAsync(means_u);
		quats._levels[0] = await readImageDataAsync(quats);
		scales._levels[0] = await readImageDataAsync(scales);
		sh0._levels[0] = await readImageDataAsync(sh0);
		if (shBands > 0) {
			sh_labels._levels[0] = await readImageDataAsync(sh_labels);
			sh_centroids._levels[0] = await readImageDataAsync(sh_centroids);
			const shMembers = [];
			for (let i2 = 0; i2 < 45; ++i2) {
				shMembers.push(`f_rest_${i2}`);
			}
			members.splice(members.indexOf("f_dc_0") + 1, 0, ...shMembers);
		}
		const data2 = {};
		members.forEach((name) => {
			data2[name] = new Float32Array(this.numSplats);
		});
		const p = new Vec3();
		const r = new Quat();
		const s2 = new Vec3();
		const c2 = new Vec4();
		const sh = shBands > 0 ? new Float32Array(45) : null;
		const iter = this.createIter(p, r, s2, c2, sh);
		for (let i2 = 0; i2 < this.numSplats; ++i2) {
			iter.read(i2);
			data2.x[i2] = p.x;
			data2.y[i2] = p.y;
			data2.z[i2] = p.z;
			data2.rot_1[i2] = r.x;
			data2.rot_2[i2] = r.y;
			data2.rot_3[i2] = r.z;
			data2.rot_0[i2] = r.w;
			data2.scale_0[i2] = s2.x;
			data2.scale_1[i2] = s2.y;
			data2.scale_2[i2] = s2.z;
			data2.f_dc_0[i2] = (c2.x - 0.5) / SH_C02;
			data2.f_dc_1[i2] = (c2.y - 0.5) / SH_C02;
			data2.f_dc_2[i2] = (c2.z - 0.5) / SH_C02;
			data2.opacity[i2] = c2.w <= 0 ? -40 : c2.w >= 1 ? 40 : -Math.log(1 / c2.w - 1);
			if (sh) {
				for (let c3 = 0; c3 < 45; ++c3) {
					data2[`f_rest_${c3}`][i2] = sh[c3];
				}
			}
		}
		return new GSplatData([{
			name: "vertex",
			count: this.numSplats,
			properties: members.map((name) => {
				return {
					name,
					type: "float",
					byteSize: 4,
					storage: data2[name]
				};
			})
		}]);
	}
	async generateCenters() {
		const { device, width, height } = this.means_l;
		const { scope } = device;
		const centersTexture = new Texture(device, {
			name: "sogCentersTexture",
			width,
			height,
			format: PIXELFORMAT_RGBA32U,
			mipmaps: false
		});
		const shader = ShaderUtils.createShader(device, {
			uniqueName: "GsplatSogCentersShader",
			attributes: { vertex_position: SEMANTIC_POSITION },
			vertexChunk: "fullscreenQuadVS",
			fragmentGLSL: gsplatSogCenters_default,
			fragmentWGSL: gsplatSogCenters_default2,
			fragmentOutputTypes: ["uvec4"]
		});
		const renderTarget = new RenderTarget({
			colorBuffer: centersTexture,
			depth: false,
			mipLevel: 0
		});
		resolve(scope, {
			means_l: this.means_l,
			means_u: this.means_u,
			numSplats: this.numSplats,
			means_mins: this.meta.means.mins,
			means_maxs: this.meta.means.maxs
		});
		const quad = new QuadRender(shader);
		const renderPass = new RenderPassQuad(device, quad);
		renderPass.name = "SogGenerateCenters";
		renderPass.init(renderTarget);
		renderPass.colorOps.clear = false;
		renderPass.depthStencilOps.clearDepth = false;
		renderPass.render();
		quad.destroy();
		renderTarget.destroy();
		const u32 = await readImageDataAsync(centersTexture);
		if (this.destroyed || device._destroyed) {
			centersTexture.destroy();
			return;
		}
		const asFloat = new Float32Array(u32.buffer);
		const result = new Float32Array(this.numSplats * 3);
		for (let i2 = 0; i2 < this.numSplats; i2++) {
			const base = i2 * 4;
			result[i2 * 3 + 0] = asFloat[base + 0];
			result[i2 * 3 + 1] = asFloat[base + 1];
			result[i2 * 3 + 2] = asFloat[base + 2];
		}
		this._centers = result;
		centersTexture.destroy();
	}
	_createCodebookTexture() {
		const device = this.means_l.device;
		const { scales, sh0, shN } = this.meta;
		const scalesCb = scales.codebook;
		const sh0Cb = sh0.codebook;
		const shNCb = shN?.codebook;
		const data2 = new Float32Array(256 * 4);
		for (let i2 = 0; i2 < 256; i2++) data2[i2 * 4] = scalesCb[i2];
		for (let i2 = 0; i2 < 256; i2++) data2[i2 * 4 + 1] = sh0Cb[i2];
		if (shNCb) {
			for (let i2 = 0; i2 < 256; i2++) data2[i2 * 4 + 2] = shNCb[i2];
		}
		const urlSuffix = this.url ? `_${this.url}` : "";
		this.codebookTexture = new Texture(device, {
			name: `sogCodebook${urlSuffix}`,
			width: 256,
			height: 1,
			format: PIXELFORMAT_RGBA32F,
			mipmaps: false,
			minFilter: FILTER_NEAREST,
			magFilter: FILTER_NEAREST,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			levels: [data2]
		});
	}
	_patchCodebooks() {
		["scales", "sh0", "shN"].forEach((name) => {
			const codebook = this.meta[name]?.codebook;
			if (codebook?.[0] === null) {
				codebook[0] = codebook[1] + (codebook[1] - codebook[255]) / 255;
			}
		});
	}
	prepareCodebook() {
		const device = this.means_l?.device;
		if (this.destroyed || !device || device._destroyed) return;
		this._patchCodebooks();
		if (this.meta.version === 2) {
			this._createCodebookTexture();
		}
	}
	async prepareGpuData() {
		const device = this.means_l?.device;
		if (this.destroyed || !device || device._destroyed) return;
		await this.generateCenters();
	}
};

var GSplatSogResource = class extends GSplatResourceBase {
	constructor(device, gsplatData, options2 = {}) {
		super(device, gsplatData, options2);
		const { meta, means_l } = gsplatData;
		const isV2 = meta.version === 2;
		const hasSH = gsplatData.shBands > 0;
		if (means_l) {
			this.streams.textureDimensions.set(means_l.width, means_l.height);
		}
		this.streams.textures.set("means_l", gsplatData.means_l);
		this.streams.textures.set("means_u", gsplatData.means_u);
		this.streams.textures.set("quats", gsplatData.quats);
		this.streams.textures.set("scales", gsplatData.scales);
		this.streams.textures.set("sh0", gsplatData.sh0);
		if (hasSH) {
			this.streams.textures.set("sh_labels", gsplatData.sh_labels);
			this.streams.textures.set("sh_centroids", gsplatData.sh_centroids);
		}
		if (isV2) {
			this.streams.textures.set("sogCodebook", gsplatData.codebookTexture);
		}
		const streams = [
			{ name: "means_l", format: PIXELFORMAT_RGBA8 },
			{ name: "means_u", format: PIXELFORMAT_RGBA8 },
			{ name: "quats", format: PIXELFORMAT_RGBA8 },
			{ name: "scales", format: PIXELFORMAT_RGBA8 },
			{ name: "sh0", format: PIXELFORMAT_RGBA8 }
		];
		if (hasSH) {
			streams.push({ name: "sh_labels", format: PIXELFORMAT_RGBA8 });
			streams.push({ name: "sh_centroids", format: PIXELFORMAT_RGBA8 });
		}
		if (isV2) {
			streams.push({ name: "sogCodebook", format: PIXELFORMAT_RGBA32F });
		}
		this._format = new GSplatFormat(device, streams, {
			readGLSL: '#include "gsplatSogVS"',
			readWGSL: '#include "gsplatSogVS"'
		});
		this._populateParameters();
	}
	releaseTextureSources() {
		const d = this.gsplatData;
		d.means_l?.setReleaseSourceAfterUpload();
		d.means_u?.setReleaseSourceAfterUpload();
		d.quats?.setReleaseSourceAfterUpload();
		d.scales?.setReleaseSourceAfterUpload();
		d.sh0?.setReleaseSourceAfterUpload();
		d.sh_centroids?.setReleaseSourceAfterUpload();
		d.sh_labels?.setReleaseSourceAfterUpload();
	}
	_actualDestroy() {
		this.streams.textures.delete("means_l");
		this.streams.textures.delete("means_u");
		this.streams.textures.delete("quats");
		this.streams.textures.delete("scales");
		this.streams.textures.delete("sh0");
		this.streams.textures.delete("sh_labels");
		this.streams.textures.delete("sh_centroids");
		this.streams.textures.delete("sogCodebook");
		this.gsplatData.destroy();
		super._actualDestroy();
	}
	_populateParameters() {
		const { meta } = this.gsplatData;
		if (meta.means) {
			this.parameters.set("means_mins", meta.means.mins);
			this.parameters.set("means_maxs", meta.means.maxs);
		}
		if (meta.version !== 2) {
			if (meta.scales) {
				this.parameters.set("scales_mins", meta.scales.mins);
				this.parameters.set("scales_maxs", meta.scales.maxs);
			}
			if (meta.sh0) {
				this.parameters.set("sh0_mins", meta.sh0.mins);
				this.parameters.set("sh0_maxs", meta.sh0.maxs);
			}
			if (meta.shN) {
				this.parameters.set("shN_mins", meta.shN.mins);
				this.parameters.set("shN_maxs", meta.shN.maxs);
			}
		}
	}
	configureMaterialDefines(defines) {
		const gsplatData = this.gsplatData;
		defines.set("SH_BANDS", gsplatData.shBands);
		if (gsplatData.meta.version === 2) {
			defines.set("SOG_V2", "");
		}
	}
	// SOG geometry getters compile out under GSPLAT_WORKBUFFER_GEOMETRY (see sog.js chunk),
	// letting color-only (SH) updates skip the means/quats/scales source reads
	get supportsWorkBufferGeometry() {
		return true;
	}
};

var FILLMODE_NONE = "NONE";
var FILLMODE_FILL_WINDOW = "FILL_WINDOW";
var FILLMODE_KEEP_ASPECT = "KEEP_ASPECT";
var RESOLUTION_AUTO = "AUTO";
var RESOLUTION_FIXED = "FIXED";

var currentApplication;
function getApplication() {
	return currentApplication;
}
function setApplication(app2) {
	currentApplication = app2;
}

var _createdLoadingScreen = false;
var script = {
	// set during script load to be used for initializing script
	app: null,
	createLoadingScreen(callback) {
		if (_createdLoadingScreen) {
			return;
		}
		_createdLoadingScreen = true;
		const app2 = getApplication();
		callback(app2);
	}
};

var FrameGraph = class {
	renderPasses = [];
	renderTargetMap = /* @__PURE__ */ new Map();
	multiview = null;
	beginMultiView(device) {
		this.multiview = new FramePassMultiView(device);
	}
	endMultiView() {
		const wrap = this.multiview;
		this.multiview = null;
		if (wrap?.children.length) {
			this.renderPasses.push(wrap);
		}
	}
	addRenderPass(renderPass) {
		renderPass.frameUpdate();
		const beforePasses = renderPass.beforePasses;
		for (let i2 = 0; i2 < beforePasses.length; i2++) {
			const pass = beforePasses[i2];
			if (pass.enabled) {
				this.addRenderPass(pass);
			}
		}
		if (renderPass.enabled) {
			if (this.multiview) {
				this.multiview.addChild(renderPass);
			} else {
				this.renderPasses.push(renderPass);
			}
		}
		const afterPasses = renderPass.afterPasses;
		for (let i2 = 0; i2 < afterPasses.length; i2++) {
			const pass = afterPasses[i2];
			if (pass.enabled) {
				this.addRenderPass(pass);
			}
		}
	}
	reset() {
		this.renderPasses.length = 0;
	}
	compile() {
		this._compilePasses(this.renderPasses);
		for (let i2 = 0; i2 < this.renderPasses.length; i2++) {
			const pass = this.renderPasses[i2];
			if (pass instanceof FramePassMultiView) {
				this._compilePasses(pass.children);
			}
		}
	}
	_compilePasses(passes) {
		const renderTargetMap = this.renderTargetMap;
		for (let i2 = 0; i2 < passes.length; i2++) {
			const renderPass = passes[i2];
			renderPass._skipStart = false;
			renderPass._skipEnd = false;
			const renderTarget = renderPass.renderTarget;
			if (renderTarget !== void 0) {
				const prevPass = renderTargetMap.get(renderTarget);
				if (prevPass) {
					const count = renderPass.colorArrayOps.length;
					for (let j = 0; j < count; j++) {
						const colorOps = renderPass.colorArrayOps[j];
						if (!colorOps.clear) {
							prevPass.colorArrayOps[j].store = true;
						}
					}
					if (!renderPass.depthStencilOps.clearDepth) {
						prevPass.depthStencilOps.storeDepth = true;
					}
					if (!renderPass.depthStencilOps.clearStencil) {
						prevPass.depthStencilOps.storeStencil = true;
					}
				}
				renderTargetMap.set(renderTarget, renderPass);
			}
		}
		for (let i2 = 0; i2 < passes.length - 1; i2++) {
			const firstPass = passes[i2];
			const firstRT = firstPass.renderTarget;
			const secondPass = passes[i2 + 1];
			const secondRT = secondPass.renderTarget;
			if (firstRT !== secondRT || firstRT === void 0) {
				continue;
			}
			if (secondPass.depthStencilOps.clearDepth || secondPass.depthStencilOps.clearStencil || secondPass.colorArrayOps.some((colorOps) => colorOps.clear)) {
				continue;
			}
			if (firstPass.afterPasses.length > 0) {
				continue;
			}
			if (secondPass.beforePasses.length > 0) {
				continue;
			}
			firstPass._skipEnd = true;
			secondPass._skipStart = true;
		}
		let lastCubeTexture = null;
		let lastCubeRenderPass = null;
		for (let i2 = 0; i2 < passes.length; i2++) {
			const renderPass = passes[i2];
			const renderTarget = renderPass.renderTarget;
			const thisTexture = renderTarget?.colorBuffer;
			if (thisTexture?.cubemap) {
				if (lastCubeTexture === thisTexture) {
					const count = lastCubeRenderPass.colorArrayOps.length;
					for (let j = 0; j < count; j++) {
						lastCubeRenderPass.colorArrayOps[j].mipmaps = false;
					}
				}
				lastCubeTexture = renderTarget.colorBuffer;
				lastCubeRenderPass = renderPass;
			} else if (renderPass.requiresCubemaps) {
				lastCubeTexture = null;
				lastCubeRenderPass = null;
			}
		}
		renderTargetMap.clear();
	}
	render(device) {
		this.compile();
		const renderPasses = this.renderPasses;
		for (let i2 = 0; i2 < renderPasses.length; i2++) {
			renderPasses[i2].render();
		}
	}
};

var AreaLightCacheEntry = class {
	constructor(texture0, texture1) {
		this.texture0 = texture0;
		this.texture1 = texture1;
	}
	destroy() {
		this.texture0?.destroy();
		this.texture1?.destroy();
	}
};
var deviceCache4 = new DeviceCache();
var AreaLightLuts = class _AreaLightLuts {
	static createTexture(device, format, size, postfix = "") {
		const tex = new Texture(device, {
			name: `AreaLightLUT${postfix}`,
			width: size,
			height: size,
			format,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			type: TEXTURETYPE_DEFAULT,
			magFilter: FILTER_LINEAR,
			minFilter: FILTER_NEAREST,
			anisotropy: 1,
			mipmaps: false
		});
		return tex;
	}
	static applyTextures(device, texture1, texture2) {
		deviceCache4.remove(device);
		deviceCache4.get(device, () => {
			return new AreaLightCacheEntry(texture1, texture1 === texture2 ? null : texture2);
		});
		device.scope.resolve("areaLightsLutTex1").setValue(texture1);
		device.scope.resolve("areaLightsLutTex2").setValue(texture2);
	}
	// placeholder LUT textures for area light
	static createPlaceholder(device) {
		const texture = _AreaLightLuts.createTexture(device, PIXELFORMAT_RGBA16F, 2, "placeholder");
		const pixels = texture.lock();
		pixels.fill(0);
		texture.unlock();
		_AreaLightLuts.applyTextures(device, texture, texture);
	}
	// creates LUT texture used by area lights
	static set(device, ltcMat1, ltcMat2) {
		function buildTexture(device2, data3, format) {
			const texture = _AreaLightLuts.createTexture(device2, format, 64);
			texture.lock().set(data3);
			texture.unlock();
			return texture;
		}
		function convertToHalfFloat(data3) {
			const count = data3.length;
			const ret = new Uint16Array(count);
			const float2Half = FloatPacking.float2Half;
			for (let i2 = 0; i2 < count; i2++) {
				ret[i2] = float2Half(data3[i2]);
			}
			return ret;
		}
		const srcData1 = ltcMat1;
		const srcData2 = ltcMat2;
		const data1 = convertToHalfFloat(srcData1);
		const data2 = convertToHalfFloat(srcData2);
		const tex1 = buildTexture(device, data1, PIXELFORMAT_RGBA16F);
		const tex2 = buildTexture(device, data2, PIXELFORMAT_RGBA16F);
		_AreaLightLuts.applyTextures(device, tex1, tex2);
	}
};

var DEFAULT_LOCALE = "en-US";
var DEFAULT_LOCALE_FALLBACKS = {
	"en": "en-US",
	"es": "en-ES",
	"zh": "zh-CN",
	"zh-HK": "zh-TW",
	"zh-TW": "zh-HK",
	"zh-MO": "zh-HK",
	"fr": "fr-FR",
	"de": "de-DE",
	"it": "it-IT",
	"ru": "ru-RU",
	"ja": "ja-JP"
};

var PLURALS = {};
function definePluralFn(locales, fn) {
	for (let i2 = 0, len = locales.length; i2 < len; i2++) {
		PLURALS[locales[i2]] = fn;
	}
}
function getLang(locale) {
	const idx = locale.indexOf("-");
	if (idx !== -1) {
		return locale.substring(0, idx);
	}
	return locale;
}
function replaceLang(locale, desiredLang) {
	const idx = locale.indexOf("-");
	if (idx !== -1) {
		return desiredLang + locale.substring(idx);
	}
	return desiredLang;
}
function findAvailableLocale(desiredLocale, availableLocales) {
	if (availableLocales[desiredLocale]) {
		return desiredLocale;
	}
	let fallback = DEFAULT_LOCALE_FALLBACKS[desiredLocale];
	if (fallback && availableLocales[fallback]) {
		return fallback;
	}
	const lang = getLang(desiredLocale);
	fallback = DEFAULT_LOCALE_FALLBACKS[lang];
	if (availableLocales[fallback]) {
		return fallback;
	}
	if (availableLocales[lang]) {
		return lang;
	}
	return DEFAULT_LOCALE;
}
definePluralFn([
	"ja",
	"ko",
	"th",
	"vi",
	"zh",
	"id"
], (n) => {
	return 0;
});
definePluralFn([
	"fa",
	"hi"
], (n) => {
	if (n >= 0 && n <= 1) {
		return 0;
	}
	return 1;
});
definePluralFn([
	"fr",
	"pt"
], (n) => {
	if (n >= 0 && n < 2) {
		return 0;
	}
	return 1;
});
definePluralFn([
	"da"
], (n) => {
	if (n === 1 || !Number.isInteger(n) && n >= 0 && n <= 1) {
		return 0;
	}
	return 1;
});
definePluralFn([
	"de",
	"en",
	"it",
	"el",
	"es",
	"tr",
	"fi",
	"sv",
	"nb",
	"no",
	"ur"
], (n) => {
	if (n === 1) {
		return 0;
	}
	return 1;
});
definePluralFn([
	"ru",
	"uk"
], (n) => {
	if (Number.isInteger(n)) {
		const mod10 = n % 10;
		const mod100 = n % 100;
		if (mod10 === 1 && mod100 !== 11) {
			return 0;
		} else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
			return 1;
		} else if (mod10 === 0 || mod10 >= 5 && mod10 <= 9 || mod100 >= 11 && mod100 <= 14) {
			return 2;
		}
	}
	return 3;
});
definePluralFn([
	"pl"
], (n) => {
	if (Number.isInteger(n)) {
		if (n === 1) {
			return 0;
		}
		const mod10 = n % 10;
		const mod100 = n % 100;
		if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
			return 1;
		} else if (mod10 >= 0 && mod10 <= 1 || mod10 >= 5 && mod10 <= 9 || mod100 >= 12 && mod100 <= 14) {
			return 2;
		}
	}
	return 3;
});
definePluralFn([
	"ar"
], (n) => {
	if (n === 0) {
		return 0;
	} else if (n === 1) {
		return 1;
	} else if (n === 2) {
		return 2;
	}
	if (Number.isInteger(n)) {
		const mod100 = n % 100;
		if (mod100 >= 3 && mod100 <= 10) {
			return 3;
		} else if (mod100 >= 11 && mod100 <= 99) {
			return 4;
		}
	}
	return 5;
});
var DEFAULT_PLURAL_FN = PLURALS[getLang(DEFAULT_LOCALE)];
function getPluralFn(lang) {
	return PLURALS[lang] || DEFAULT_PLURAL_FN;
}

var ABSOLUTE_URL = new RegExp(
	"^\\s*(?:(?:[a-z]+[a-z0-9\\-+.]*:)?//|data:|blob:)",
	"i"
	// non case-sensitive flag
);
var ASSET_ANIMATION = "animation";
var ASSET_AUDIO = "audio";
var ASSET_IMAGE = "image";
var ASSET_JSON = "json";
var ASSET_MODEL = "model";
var ASSET_MATERIAL = "material";
var ASSET_TEXT = "text";
var ASSET_TEXTURE = "texture";
var ASSET_TEXTUREATLAS = "textureatlas";
var ASSET_CUBEMAP = "cubemap";
var ASSET_SHADER = "shader";
var ASSET_CSS = "css";
var ASSET_HTML = "html";
var ASSET_SCRIPT = "script";
var ASSET_CONTAINER = "container";

var AssetFile = class {
	constructor(url = "", filename = "", hash = null, size = null, opt = null, contents = null) {
		this.url = url;
		this.filename = filename;
		this.hash = hash;
		this.size = size;
		this.opt = opt;
		this.contents = contents;
	}
	// Compare this AssetFile with another. Returns true if they have the same data
	// and false otherwise.
	equals(other) {
		return this.url === other.url && this.filename === other.filename && this.hash === other.hash && this.size === other.size && this.opt === other.opt && this.contents === other.contents;
	}
};

var assetIdCounter = -1;
var VARIANT_SUPPORT = {
	pvr: "extCompressedTexturePVRTC",
	dxt: "extCompressedTextureS3TC",
	etc2: "extCompressedTextureETC",
	etc1: "extCompressedTextureETC1",
	basis: "canvas"
	// dummy, basis is always supported
};
var VARIANT_DEFAULT_PRIORITY = ["pvr", "dxt", "etc2", "etc1", "basis"];
var Asset = class extends EventHandler {
	static EVENT_LOAD = "load";
	static EVENT_UNLOAD = "unload";
	static EVENT_REMOVE = "remove";
	static EVENT_ERROR = "error";
	static EVENT_CHANGE = "change";
	static EVENT_PROGRESS = "progress";
	static EVENT_ADDLOCALIZED = "add:localized";
	static EVENT_REMOVELOCALIZED = "remove:localized";
	_file = null;
	_i18n = {};
	_preload = false;
	_resources = [];
	id = assetIdCounter--;
	loaded = false;
	loading = false;
	options = {};
	registry = null;
	tags = new Tags(this);
	type;
	urlObject = null;
	constructor(name, type, file, data2 = {}, options2 = {}) {
		super();
		this._name = name || "";
		this.type = type;
		this._data = data2 || {};
		this.options = options2 || {};
		if (file) this.file = file;
	}
	set name(value) {
		if (this._name === value) {
			return;
		}
		const old = this._name;
		this._name = value;
		this.fire("name", this, this._name, old);
	}
	get name() {
		return this._name;
	}
	set file(value) {
		if (value && value.variants && ["texture", "textureatlas", "bundle"].indexOf(this.type) !== -1) {
			const app2 = this.registry?._loader?._app || getApplication();
			const device = app2?.graphicsDevice;
			if (device) {
				for (let i2 = 0, len = VARIANT_DEFAULT_PRIORITY.length; i2 < len; i2++) {
					const variant = VARIANT_DEFAULT_PRIORITY[i2];
					if (value.variants[variant] && device[VARIANT_SUPPORT[variant]]) {
						value = value.variants[variant];
						break;
					}
					if (app2.enableBundles) {
						const bundles = app2.bundles.listBundlesForAsset(this);
						if (bundles && bundles.find((b) => {
							return b?.file?.variants[variant];
						})) {
							break;
						}
					}
				}
			}
		}
		const oldFile = this._file;
		const newFile = value ? new AssetFile(value.url, value.filename, value.hash, value.size, value.opt, value.contents) : null;
		if (!!newFile !== !!oldFile || newFile && !newFile.equals(oldFile)) {
			this._file = newFile;
			this.fire("change", this, "file", newFile, oldFile);
			this.reload();
		}
	}
	get file() {
		return this._file;
	}
	set data(value) {
		const old = this._data;
		this._data = value;
		if (value !== old) {
			this.fire("change", this, "data", value, old);
			if (this.loaded) {
				this.registry._loader.patch(this, this.registry);
			}
		}
	}
	get data() {
		return this._data;
	}
	set resource(value) {
		const _old = this._resources[0];
		this._resources[0] = value;
		this.fire("change", this, "resource", value, _old);
	}
	get resource() {
		return this._resources[0];
	}
	set resources(value) {
		const _old = this._resources;
		this._resources = value;
		this.fire("change", this, "resources", value, _old);
	}
	get resources() {
		return this._resources;
	}
	set preload(value) {
		value = !!value;
		if (this._preload === value) {
			return;
		}
		this._preload = value;
		if (this._preload && !this.loaded && !this.loading && this.registry) {
			this.registry.load(this);
		}
	}
	get preload() {
		return this._preload;
	}
	set loadFaces(value) {
		value = !!value;
		if (!this.hasOwnProperty("_loadFaces") || value !== this._loadFaces) {
			this._loadFaces = value;
			if (this.loaded) {
				this.registry._loader.patch(this, this.registry);
			}
		}
	}
	get loadFaces() {
		return this._loadFaces;
	}
	getFileUrl() {
		const file = this.file;
		if (!file || !file.url) {
			return null;
		}
		let url = file.url;
		if (this.registry && this.registry.prefix && !ABSOLUTE_URL.test(url)) {
			url = this.registry.prefix + url;
		}
		if (this.type !== "script" && file.hash) {
			const separator = url.indexOf("?") !== -1 ? "&" : "?";
			url += `${separator}t=${file.hash}`;
		}
		return url;
	}
	getAbsoluteUrl(relativePath) {
		if (relativePath.startsWith("blob:") || relativePath.startsWith("data:")) {
			return relativePath;
		}
		const base = path.getDirectory(this.file.url);
		return path.join(base, relativePath);
	}
	getLocalizedAssetId(locale) {
		locale = findAvailableLocale(locale, this._i18n);
		return this._i18n[locale] || null;
	}
	addLocalizedAssetId(locale, assetId) {
		this._i18n[locale] = assetId;
		this.fire("add:localized", locale, assetId);
	}
	removeLocalizedAssetId(locale) {
		const assetId = this._i18n[locale];
		if (assetId) {
			delete this._i18n[locale];
			this.fire("remove:localized", locale, assetId);
		}
	}
	ready(callback, scope) {
		scope = scope || this;
		if (this.loaded) {
			callback.call(scope, this);
		} else {
			this.once("load", (asset) => {
				callback.call(scope, asset);
			});
		}
	}
	reload() {
		if (this.loaded) {
			this.loaded = false;
			this.registry.load(this);
		}
	}
	unload() {
		if (!this.loaded && this._resources.length === 0) {
			return;
		}
		this.fire("unload", this);
		this.registry.fire(`unload:${this.id}`, this);
		const old = this._resources;
		if (this.urlObject) {
			URL.revokeObjectURL(this.urlObject);
			this.urlObject = null;
		}
		this.resources = [];
		this.loaded = false;
		if (this.file) {
			this.registry._loader.clearCache(this.getFileUrl(), this.type);
		}
		for (let i2 = 0; i2 < old.length; ++i2) {
			old[i2]?.destroy?.();
		}
	}
	static fetchArrayBuffer(loadUrl, callback, asset, maxRetries = 0) {
		if (asset?.file?.contents) {
			setTimeout(() => {
				callback(null, asset.file.contents);
			});
		} else {
			http.get(loadUrl, {
				cache: true,
				responseType: "arraybuffer",
				retry: maxRetries > 0,
				maxRetries,
				progress: asset
			}, callback);
		}
	}
};

var TagsCache = class {
	_index = {};
	_key;
	constructor(key = null) {
		this._key = key;
	}
	addItem(item) {
		const tags = item.tags._list;
		for (const tag of tags) {
			this.add(tag, item);
		}
	}
	removeItem(item) {
		const tags = item.tags._list;
		for (const tag of tags) {
			this.remove(tag, item);
		}
	}
	add(tag, item) {
		if (this._index[tag] && this._index[tag].list.indexOf(item) !== -1) {
			return;
		}
		if (!this._index[tag]) {
			this._index[tag] = {
				list: []
			};
			if (this._key) {
				this._index[tag].keys = {};
			}
		}
		this._index[tag].list.push(item);
		if (this._key) {
			this._index[tag].keys[item[this._key]] = item;
		}
	}
	remove(tag, item) {
		if (!this._index[tag]) {
			return;
		}
		if (this._key) {
			if (!this._index[tag].keys[item[this._key]]) {
				return;
			}
		}
		const ind = this._index[tag].list.indexOf(item);
		if (ind === -1) {
			return;
		}
		this._index[tag].list.splice(ind, 1);
		if (this._key) {
			delete this._index[tag].keys[item[this._key]];
		}
		if (this._index[tag].list.length === 0) {
			delete this._index[tag];
		}
	}
	find(args) {
		const index = {};
		const items = [];
		let item, tag, tags, tagsRest, missingIndex;
		const sort = (a, b) => {
			return this._index[a].list.length - this._index[b].list.length;
		};
		for (let i2 = 0; i2 < args.length; i2++) {
			tag = args[i2];
			if (tag instanceof Array) {
				if (tag.length === 0) {
					continue;
				}
				if (tag.length === 1) {
					tag = tag[0];
				} else {
					missingIndex = false;
					for (let t = 0; t < tag.length; t++) {
						if (!this._index[tag[t]]) {
							missingIndex = true;
							break;
						}
					}
					if (missingIndex) {
						continue;
					}
					tags = tag.slice(0).sort(sort);
					tagsRest = tags.slice(1);
					if (tagsRest.length === 1) {
						tagsRest = tagsRest[0];
					}
					for (let n = 0; n < this._index[tags[0]].list.length; n++) {
						item = this._index[tags[0]].list[n];
						if ((this._key ? !index[item[this._key]] : items.indexOf(item) === -1) && item.tags.has(tagsRest)) {
							if (this._key) {
								index[item[this._key]] = true;
							}
							items.push(item);
						}
					}
					continue;
				}
			}
			if (tag && typeof tag === "string" && this._index[tag]) {
				for (let n = 0; n < this._index[tag].list.length; n++) {
					item = this._index[tag].list[n];
					if (this._key) {
						if (!index[item[this._key]]) {
							index[item[this._key]] = true;
							items.push(item);
						}
					} else if (items.indexOf(item) === -1) {
						items.push(item);
					}
				}
			}
		}
		return items;
	}
};

var AssetRegistry = class extends EventHandler {
	static EVENT_LOAD = "load";
	static EVENT_ADD = "add";
	static EVENT_REMOVE = "remove";
	static EVENT_ERROR = "error";
	_assets = /* @__PURE__ */ new Set();
	_loader;
	_idToAsset = /* @__PURE__ */ new Map();
	_urlToAsset = /* @__PURE__ */ new Map();
	_nameToAsset = /* @__PURE__ */ new Map();
	_tags = new TagsCache("id");
	prefix = null;
	bundles = null;
	constructor(loader) {
		super();
		this._loader = loader;
	}
	get loader() {
		return this._loader;
	}
	list(filters = {}) {
		const assets = Array.from(this._assets);
		if (filters.preload !== void 0) {
			return assets.filter((asset) => asset.preload === filters.preload);
		}
		return assets;
	}
	add(asset) {
		if (this._assets.has(asset)) return;
		this._assets.add(asset);
		this._idToAsset.set(asset.id, asset);
		if (asset.file?.url) {
			this._urlToAsset.set(asset.file.url, asset);
		}
		if (!this._nameToAsset.has(asset.name)) {
			this._nameToAsset.set(asset.name, /* @__PURE__ */ new Set());
		}
		this._nameToAsset.get(asset.name).add(asset);
		asset.on("name", this._onNameChange, this);
		asset.registry = this;
		this._tags.addItem(asset);
		asset.tags.on("add", this._onTagAdd, this);
		asset.tags.on("remove", this._onTagRemove, this);
		this.fire("add", asset);
		this.fire(`add:${asset.id}`, asset);
		if (asset.file?.url) {
			this.fire(`add:url:${asset.file.url}`, asset);
		}
		if (asset.preload) {
			this.load(asset);
		}
	}
	remove(asset) {
		if (!this._assets.has(asset)) return false;
		this._assets.delete(asset);
		this._idToAsset.delete(asset.id);
		if (asset.file?.url) {
			this._urlToAsset.delete(asset.file.url);
		}
		asset.off("name", this._onNameChange, this);
		if (this._nameToAsset.has(asset.name)) {
			const items = this._nameToAsset.get(asset.name);
			items.delete(asset);
			if (items.size === 0) {
				this._nameToAsset.delete(asset.name);
			}
		}
		this._tags.removeItem(asset);
		asset.tags.off("add", this._onTagAdd, this);
		asset.tags.off("remove", this._onTagRemove, this);
		asset.fire("remove", asset);
		this.fire("remove", asset);
		this.fire(`remove:${asset.id}`, asset);
		if (asset.file?.url) {
			this.fire(`remove:url:${asset.file.url}`, asset);
		}
		return true;
	}
	get(id14) {
		return this._idToAsset.get(Number(id14));
	}
	getByUrl(url) {
		return this._urlToAsset.get(url);
	}
	load(asset, options2) {
		if ((asset.loading || asset.loaded) && !options2?.force) {
			return;
		}
		const file = asset.file;
		const _fireLoad = () => {
			this.fire("load", asset);
			this.fire(`load:${asset.id}`, asset);
			if (file && file.url) {
				this.fire(`load:url:${file.url}`, asset);
			}
			asset.fire("load", asset);
		};
		const _opened = (resource) => {
			if (resource instanceof Array) {
				asset.resources = resource;
			} else {
				asset.resource = resource;
			}
			this._loader.patch(asset, this);
			if (asset.type === "bundle") {
				const assetIds = asset.data.assets;
				for (let i2 = 0; i2 < assetIds.length; i2++) {
					const assetInBundle = this._idToAsset.get(assetIds[i2]);
					if (assetInBundle && !assetInBundle.loaded) {
						this.load(assetInBundle, { force: true });
					}
				}
				if (asset.resource.loaded) {
					_fireLoad();
				} else {
					this.fire("load:start", asset);
					this.fire(`load:start:${asset.id}`, asset);
					if (file && file.url) {
						this.fire(`load:start:url:${file.url}`, asset);
					}
					asset.fire("load:start", asset);
					asset.resource.on("load", _fireLoad);
				}
			} else {
				_fireLoad();
			}
		};
		const _loaded = (err2, resource, extra) => {
			asset.loaded = true;
			asset.loading = false;
			if (err2) {
				this.fire("error", err2, asset);
				this.fire(`error:${asset.id}`, err2, asset);
				asset.fire("error", err2, asset);
			} else {
				if (asset.type === "script") {
					const handler = this._loader.getHandler("script");
					if (handler._cache[asset.id] && handler._cache[asset.id].parentNode === document.head) {
						document.head.removeChild(handler._cache[asset.id]);
					}
					if (extra) {
						handler._cache[asset.id] = extra;
					}
				}
				_opened(resource);
			}
		};
		if (file || asset.type === "cubemap") {
			this.fire("load:start", asset);
			this.fire(`load:${asset.id}:start`, asset);
			asset.loading = true;
			const fileUrl = asset.getFileUrl();
			if (asset.type === "bundle") {
				const assetIds = asset.data.assets;
				for (let i2 = 0; i2 < assetIds.length; i2++) {
					const assetInBundle = this._idToAsset.get(assetIds[i2]);
					if (!assetInBundle) {
						continue;
					}
					if (assetInBundle.loaded || assetInBundle.resource || assetInBundle.loading) {
						continue;
					}
					assetInBundle.loading = true;
				}
			}
			this._loader.load(fileUrl, asset.type, _loaded, asset, options2);
		} else {
			const resource = this._loader.open(asset.type, asset.data);
			asset.loaded = true;
			_opened(resource);
		}
	}
	loadFromUrl(url, type, callback) {
		this.loadFromUrlAndFilename(url, null, type, callback);
	}
	loadFromUrlAndFilename(url, filename, type, callback) {
		const name = path.getBasename(filename || url);
		const file = {
			filename: filename || name,
			url
		};
		let asset = this.getByUrl(url);
		if (!asset) {
			asset = new Asset(name, type, file);
			this.add(asset);
		} else if (asset.loaded) {
			callback(asset.loadFromUrlError || null, asset);
			return;
		}
		const startLoad = (asset2) => {
			asset2.once("load", (loadedAsset) => {
				if (type === "material") {
					this._loadTextures(loadedAsset, (err2, textures) => {
						callback(err2, loadedAsset);
					});
				} else {
					callback(null, loadedAsset);
				}
			});
			asset2.once("error", (err2) => {
				if (err2) {
					this.loadFromUrlError = err2;
				}
				callback(err2, asset2);
			});
			this.load(asset2);
		};
		if (asset.resource) {
			callback(null, asset);
		} else if (type === "model") {
			this._loadModel(asset, startLoad);
		} else {
			startLoad(asset);
		}
	}
	// private method used for engine-only loading of model data
	_loadModel(modelAsset, continuation) {
		const url = modelAsset.getFileUrl();
		const ext = path.getExtension(url);
		if (ext === ".json" || ext === ".glb") {
			const dir4 = path.getDirectory(url);
			const basename = path.getBasename(url);
			const mappingUrl = path.join(dir4, basename.replace(ext, ".mapping.json"));
			this._loader.load(mappingUrl, "json", (err2, data2) => {
				if (err2) {
					modelAsset.data = { mapping: [] };
					continuation(modelAsset);
				} else {
					this._loadMaterials(modelAsset, data2, (e, materials) => {
						modelAsset.data = data2;
						continuation(modelAsset);
					});
				}
			});
		} else {
			continuation(modelAsset);
		}
	}
	// private method used for engine-only loading of model materials
	_loadMaterials(modelAsset, mapping, callback) {
		const materials = [];
		let count = 0;
		const onMaterialLoaded = (err2, materialAsset) => {
			this._loadTextures(materialAsset, (err3, textures) => {
				materials.push(materialAsset);
				if (materials.length === count) {
					callback(null, materials);
				}
			});
		};
		for (let i2 = 0; i2 < mapping.mapping.length; i2++) {
			const path2 = mapping.mapping[i2].path;
			if (path2) {
				count++;
				const url = modelAsset.getAbsoluteUrl(path2);
				this.loadFromUrl(url, "material", onMaterialLoaded);
			}
		}
		if (count === 0) {
			callback(null, materials);
		}
	}
	// private method used for engine-only loading of the textures referenced by
	// the material asset
	_loadTextures(materialAsset, callback) {
		const textures = [];
		let count = 0;
		const data2 = materialAsset.data;
		if (data2.mappingFormat !== "path") {
			callback(null, textures);
			return;
		}
		const onTextureLoaded = (err2, texture) => {
			if (err2) console.error(`Failed to load material texture for "${materialAsset.name}": ${err2?.message ?? err2}`, err2);
			textures.push(texture);
			if (textures.length === count) {
				callback(null, textures);
			}
		};
		const texParams = standardMaterialTextureParameters;
		for (let i2 = 0; i2 < texParams.length; i2++) {
			const path2 = data2[texParams[i2]];
			if (path2 && typeof path2 === "string") {
				count++;
				const url = materialAsset.getAbsoluteUrl(path2);
				this.loadFromUrl(url, "texture", onTextureLoaded);
			}
		}
		if (count === 0) {
			callback(null, textures);
		}
	}
	_onTagAdd(tag, asset) {
		this._tags.add(tag, asset);
	}
	_onTagRemove(tag, asset) {
		this._tags.remove(tag, asset);
	}
	_onNameChange(asset, name, nameOld) {
		if (this._nameToAsset.has(nameOld)) {
			const items = this._nameToAsset.get(nameOld);
			items.delete(asset);
			if (items.size === 0) {
				this._nameToAsset.delete(nameOld);
			}
		}
		if (!this._nameToAsset.has(asset.name)) {
			this._nameToAsset.set(asset.name, /* @__PURE__ */ new Set());
		}
		this._nameToAsset.get(asset.name).add(asset);
	}
	findByTag(...query) {
		return this._tags.find(query);
	}
	filter(callback) {
		return Array.from(this._assets).filter((asset) => callback(asset));
	}
	find(name, type) {
		const items = this._nameToAsset.get(name);
		if (!items) return null;
		for (const asset of items) {
			if (!type || asset.type === type) {
				return asset;
			}
		}
		return null;
	}
	findAll(name, type) {
		const items = this._nameToAsset.get(name);
		if (!items) return [];
		const results = Array.from(items);
		if (!type) return results;
		return results.filter((asset) => asset.type === type);
	}
	log() {
	}
};

var BundleRegistry = class {
	_idToBundle = /* @__PURE__ */ new Map();
	_assetToBundles = /* @__PURE__ */ new Map();
	_urlsToBundles = /* @__PURE__ */ new Map();
	_fileRequests = /* @__PURE__ */ new Map();
	constructor(assets) {
		this._assets = assets;
		this._assets.bundles = this;
		this._assets.on("add", this._onAssetAdd, this);
		this._assets.on("remove", this._onAssetRemove, this);
	}
	_onAssetAdd(asset) {
		if (asset.type === "bundle") {
			this._idToBundle.set(asset.id, asset);
			this._assets.on(`load:start:${asset.id}`, this._onBundleLoadStart, this);
			this._assets.on(`load:${asset.id}`, this._onBundleLoad, this);
			this._assets.on(`error:${asset.id}`, this._onBundleError, this);
			const assetIds = asset.data.assets;
			for (let i2 = 0; i2 < assetIds.length; i2++) {
				this._indexAssetInBundle(assetIds[i2], asset);
			}
		} else {
			if (this._assetToBundles.has(asset.id)) {
				this._indexAssetFileUrls(asset);
			}
		}
	}
	_unbindAssetEvents(id14) {
		this._assets.off(`load:start:${id14}`, this._onBundleLoadStart, this);
		this._assets.off(`load:${id14}`, this._onBundleLoad, this);
		this._assets.off(`error:${id14}`, this._onBundleError, this);
	}
	// Index the specified asset id and its file URLs so that
	// the registry knows that the asset is in that bundle
	_indexAssetInBundle(id14, bundle) {
		let bundles = this._assetToBundles.get(id14);
		if (!bundles) {
			bundles = /* @__PURE__ */ new Set();
			this._assetToBundles.set(id14, bundles);
		}
		bundles.add(bundle);
		const asset = this._assets.get(id14);
		if (asset) this._indexAssetFileUrls(asset);
	}
	// Index the file URLs of the specified asset
	_indexAssetFileUrls(asset) {
		const urls = this._getAssetFileUrls(asset);
		if (!urls) return;
		for (let i2 = 0; i2 < urls.length; i2++) {
			const bundles = this._assetToBundles.get(asset.id);
			if (!bundles) continue;
			this._urlsToBundles.set(urls[i2], bundles);
		}
	}
	// Get all the possible URLs of an asset
	_getAssetFileUrls(asset) {
		let url = asset.getFileUrl();
		if (!url) return null;
		url = url.split("?")[0];
		const urls = [url];
		if (asset.type === "font") {
			const numFiles = asset.data.info.maps.length;
			for (let i2 = 1; i2 < numFiles; i2++) {
				urls.push(url.replace(".png", `${i2}.png`));
			}
		}
		return urls;
	}
	// Remove asset from internal indexes
	_onAssetRemove(asset) {
		if (asset.type === "bundle") {
			this._idToBundle.delete(asset.id);
			this._unbindAssetEvents(asset.id);
			const assetIds = asset.data.assets;
			for (let i2 = 0; i2 < assetIds.length; i2++) {
				const bundles = this._assetToBundles.get(assetIds[i2]);
				if (!bundles) continue;
				bundles.delete(asset);
				if (bundles.size === 0) {
					this._assetToBundles.delete(assetIds[i2]);
					for (const [url, otherBundles] of this._urlsToBundles) {
						if (otherBundles !== bundles) {
							continue;
						}
						this._urlsToBundles.delete(url);
					}
				}
			}
			this._onBundleError(`Bundle ${asset.id} was removed`);
		} else {
			const bundles = this._assetToBundles.get(asset.id);
			if (!bundles) return;
			this._assetToBundles.delete(asset.id);
			const urls = this._getAssetFileUrls(asset);
			if (!urls) return;
			for (let i2 = 0; i2 < urls.length; i2++) {
				this._urlsToBundles.delete(urls[i2]);
			}
		}
	}
	_onBundleLoadStart(asset) {
		asset.resource.on("add", (url, data2) => {
			const callbacks = this._fileRequests.get(url);
			if (!callbacks) return;
			for (let i2 = 0; i2 < callbacks.length; i2++) {
				callbacks[i2](null, data2);
			}
			this._fileRequests.delete(url);
		});
	}
	// If we have any pending file requests
	// that can be satisfied by the specified bundle
	// then resolve them
	_onBundleLoad(asset) {
		if (!asset.resource) {
			this._onBundleError(`Bundle ${asset.id} failed to load`);
			return;
		}
		if (!this._fileRequests) {
			return;
		}
		for (const [url, requests] of this._fileRequests) {
			const bundles = this._urlsToBundles.get(url);
			if (!bundles || !bundles.has(asset)) continue;
			const decodedUrl = decodeURIComponent(url);
			let err2, data2;
			if (asset.resource.has(decodedUrl)) {
				data2 = asset.resource.get(decodedUrl);
			} else if (asset.resource.loaded) {
				err2 = `Bundle ${asset.id} does not contain URL ${url}`;
			} else {
				continue;
			}
			for (let i2 = 0; i2 < requests.length; i2++) {
				requests[i2](err2, err2 || data2);
			}
			this._fileRequests.delete(url);
		}
	}
	// If we have outstanding file requests for any
	// of the URLs in the specified bundle then search for
	// other bundles that can satisfy these requests.
	// If we do not find any other bundles then fail
	// those pending file requests with the specified error.
	_onBundleError(err2) {
		for (const [url, requests] of this._fileRequests) {
			const bundle = this._findLoadedOrLoadingBundleForUrl(url);
			if (!bundle) {
				for (let i2 = 0; i2 < requests.length; i2++) {
					requests[i2](err2);
				}
				this._fileRequests.delete(url);
			}
		}
	}
	// Finds a bundle that contains the specified URL but
	// only returns the bundle if it's either loaded or being loaded
	_findLoadedOrLoadingBundleForUrl(url) {
		const bundles = this._urlsToBundles.get(url);
		if (!bundles) return null;
		let candidate = null;
		for (const bundle of bundles) {
			if (bundle.loaded && bundle.resource) {
				return bundle;
			} else if (bundle.loading) {
				candidate = bundle;
			}
		}
		return candidate;
	}
	listBundlesForAsset(asset) {
		const bundles = this._assetToBundles.get(asset.id);
		if (bundles) return Array.from(bundles);
		return null;
	}
	list() {
		return Array.from(this._idToBundle.values());
	}
	hasUrl(url) {
		return this._urlsToBundles.has(url);
	}
	urlIsLoadedOrLoading(url) {
		return !!this._findLoadedOrLoadingBundleForUrl(url);
	}
	loadUrl(url, callback) {
		const bundle = this._findLoadedOrLoadingBundleForUrl(url);
		if (!bundle) {
			callback(`URL ${url} not found in any bundles`);
			return;
		}
		if (bundle.loaded) {
			const decodedUrl = decodeURIComponent(url);
			if (bundle.resource.has(decodedUrl)) {
				callback(null, bundle.resource.get(decodedUrl));
				return;
			} else if (bundle.resource.loaded) {
				callback(`Bundle ${bundle.id} does not contain URL ${url}`);
				return;
			}
		}
		let callbacks = this._fileRequests.get(url);
		if (!callbacks) {
			callbacks = [];
			this._fileRequests.set(url, callbacks);
		}
		callbacks.push(callback);
	}
	destroy() {
		this._assets.off("add", this._onAssetAdd, this);
		this._assets.off("remove", this._onAssetRemove, this);
		for (const id14 of this._idToBundle.keys()) {
			this._unbindAssetEvents(id14);
		}
		this._assets = null;
		this._idToBundle.clear();
		this._idToBundle = null;
		this._assetToBundles.clear();
		this._assetToBundles = null;
		this._urlsToBundles.clear();
		this._urlsToBundles = null;
		this._fileRequests.clear();
		this._fileRequests = null;
	}
};

var ComponentSystemRegistry = class extends EventHandler {
	anim;
	animation;
	audiolistener;
	button;
	camera;
	collision;
	element;
	gsplat;
	joint;
	layoutchild;
	layoutgroup;
	light;
	model;
	particlesystem;
	render;
	rigidbody;
	screen;
	script;
	scrollbar;
	scrollview;
	sound;
	sprite;
	zone;
	constructor() {
		super();
		this.list = [];
	}
	add(system) {
		const id14 = system.id;
		if (this[id14]) {
			throw new Error(`ComponentSystem name '${id14}' already registered or not allowed`);
		}
		this[id14] = system;
		this.list.push(system);
	}
	remove(system) {
		const id14 = system.id;
		if (!this[id14]) {
			throw new Error(`No ComponentSystem named '${id14}' registered`);
		}
		delete this[id14];
		const index = this.list.indexOf(this[id14]);
		if (index !== -1) {
			this.list.splice(index, 1);
		}
	}
	destroy() {
		this.off();
		for (let i2 = 0; i2 < this.list.length; i2++) {
			this.list[i2].destroy();
		}
	}
};

var Bundle = class extends EventHandler {
	_index = /* @__PURE__ */ new Map();
	_loaded = false;
	static EVENT_ADD = "add";
	static EVENT_LOAD = "load";
	addFile(url, data2) {
		if (this._index.has(url)) {
			return;
		}
		this._index.set(url, data2);
		this.fire("add", url, data2);
	}
	has(url) {
		return this._index.has(url);
	}
	get(url) {
		return this._index.get(url) || null;
	}
	destroy() {
		this._index.clear();
	}
	set loaded(value) {
		if (!value || this._loaded) {
			return;
		}
		this._loaded = true;
		this.fire("load");
	}
	get loaded() {
		return this._loaded;
	}
};

var Untar = class extends EventHandler {
	headerSize = 512;
	paddingSize = 512;
	bytesRead = 0;
	bytesReceived = 0;
	headerRead = false;
	reader = null;
	data = new Uint8Array(0);
	decoder = null;
	prefix = "";
	fileName = "";
	fileSize = 0;
	fileType = "";
	ustarFormat = "";
	constructor(fetchPromise, assetsPrefix = "") {
		super();
		this.prefix = assetsPrefix || "";
		this.reader = fetchPromise.body.getReader();
		this.reader.read().then((res) => {
			this.pump(res.done, res.value);
		}).catch((err2) => {
			this.fire("error", err2);
		});
	}
	pump(done, value) {
		if (done) {
			this.fire("done");
			return null;
		}
		this.bytesReceived += value.byteLength;
		const data2 = new Uint8Array(this.data.length + value.length);
		data2.set(this.data);
		data2.set(value, this.data.length);
		this.data = data2;
		while (this.readFile()) ;
		return this.reader.read().then((res) => {
			this.pump(res.done, res.value);
		}).catch((err2) => {
			this.fire("error", err2);
		});
	}
	readFile() {
		if (!this.headerRead && this.bytesReceived > this.bytesRead + this.headerSize) {
			this.headerRead = true;
			const view = new DataView(this.data.buffer, this.bytesRead, this.headerSize);
			this.decoder ?? (this.decoder = new TextDecoder("windows-1252"));
			const headers = this.decoder.decode(view);
			this.fileName = headers.substring(0, 100).replace(/\0/g, "");
			this.fileSize = parseInt(headers.substring(124, 136), 8);
			this.fileType = headers.substring(156, 157);
			this.ustarFormat = headers.substring(257, 263);
			if (this.ustarFormat.indexOf("ustar") !== -1) {
				const prefix = headers.substring(345, 500).replace(/\0/g, "");
				if (prefix.length > 0) {
					this.fileName = prefix.trim() + this.fileName.trim();
				}
			}
			this.bytesRead += 512;
		}
		if (this.headerRead) {
			if (this.bytesReceived < this.bytesRead + this.fileSize) {
				return false;
			}
			if (this.fileType === "" || this.fileType === "0") {
				const dataView = new DataView(this.data.buffer, this.bytesRead, this.fileSize);
				const file = {
					name: this.prefix + this.fileName,
					size: this.fileSize,
					data: dataView
				};
				this.fire("file", file);
			}
			this.bytesRead += this.fileSize;
			this.headerRead = false;
			const bytesRemained = this.bytesRead % this.paddingSize;
			if (bytesRemained !== 0) {
				this.bytesRead += this.paddingSize - bytesRemained;
			}
			return true;
		}
		return false;
	}
};

var ResourceHandler = class {
	handlerType = "";
	_app;
	_maxRetries = 0;
	_parsers = [];
	constructor(app2, handlerType) {
		this._app = app2;
		this.handlerType = handlerType;
	}
	get app() {
		return this._app;
	}
	set maxRetries(value) {
		this._maxRetries = value;
	}
	get maxRetries() {
		return this._maxRetries;
	}
	addParser(parser, decider) {
		if (decider !== void 0) {
		}
		if (!parser || typeof parser.canParse !== "function") {
			return;
		}
		parser.handler = this;
		this._parsers.push(parser);
	}
	removeParser(parser) {
		const index = this._parsers.indexOf(parser);
		if (index !== -1) {
			this._parsers.splice(index, 1);
			parser.handler = null;
		}
	}
	get parsers() {
		return this._parsers.slice();
	}
	fetch(url, responseType, callback, asset) {
		if (typeof url === "string") {
			url = { load: url, original: url };
		}
		if (responseType === Http.ResponseType.ARRAY_BUFFER) {
			Asset.fetchArrayBuffer(url.load, callback, asset, this.maxRetries);
			return;
		}
		http.get(url.load, {
			responseType,
			retry: this.maxRetries > 0,
			maxRetries: this.maxRetries
		}, callback);
	}
	_makeContext(url, asset) {
		const original = url && typeof url === "object" ? url.original : url;
		const clean = original ? original.split("?")[0] : "";
		return {
			url: original ?? null,
			ext: original ? path.getExtension(clean).toLowerCase().replace(".", "") : "",
			basename: original ? path.getBasename(clean).toLowerCase() : "",
			asset,
			app: this._app
		};
	}
	_selectParser(context) {
		for (let i2 = this._parsers.length - 1; i2 >= 0; i2--) {
			if (this._parsers[i2].canParse(context)) {
				return this._parsers[i2];
			}
		}
		return null;
	}
	load(url, callback, asset) {
		if (this._parsers.length === 0) {
			return;
		}
		if (typeof url === "string") {
			url = {
				load: url,
				original: url
			};
		}
		const context = this._makeContext(url, asset);
		const parser = this._selectParser(context);
		if (!parser) {
			callback(`No parser found for resource: ${context.url}`);
			return;
		}
		parser.load(url, callback, asset);
	}
	open(url, data2, asset) {
		if (this._parsers.length === 0) {
			return data2;
		}
		const parser = this._selectParser(this._makeContext(url, asset));
		return parser?.open ? parser.open(url, data2, asset) : data2;
	}
	patch(asset, assets) {
	}
};

var BundleHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "bundle");
		this._assets = app2.assets;
	}
	_fetchRetries(url, options2, retries = 0) {
		return new Promise((resolve2, reject) => {
			const tryFetch = () => {
				fetch(url, options2).then(resolve2).catch((err2) => {
					retries++;
					if (retries < this.maxRetries) {
						tryFetch();
					} else {
						reject(err2);
					}
				});
			};
			tryFetch();
		});
	}
	load(url, callback) {
		if (typeof url === "string") {
			url = {
				load: url,
				original: url
			};
		}
		this._fetchRetries(url.load, {
			mode: "cors"
		}, this.maxRetries).then((res) => {
			const bundle = new Bundle();
			callback(null, bundle);
			const untar = new Untar(res, this._assets.prefix);
			untar.on("file", (file) => {
				bundle.addFile(file.name, file.data);
			});
			untar.on("done", () => {
				bundle.loaded = true;
			});
			untar.on("error", (err2) => {
				callback(err2);
			});
		}).catch((err2) => {
			callback(err2);
		});
	}
	open(url, bundle) {
		return bundle;
	}
};

var ResourceLoader = class _ResourceLoader {
	constructor(app2) {
		this._handlers = {};
		this._requests = {};
		this._cache = {};
		this._app = app2;
	}
	addHandler(type, handler) {
		this._handlers[type] = handler;
		handler._loader = this;
	}
	removeHandler(type) {
		delete this._handlers[type];
	}
	getHandler(type) {
		return this._handlers[type];
	}
	static makeKey(url, type) {
		return `${url}-${type}`;
	}
	load(url, type, callback, asset, options2) {
		const handler = this._handlers[type];
		if (!handler) {
			const err2 = `No resource handler for asset type: '${type}' when loading [${url}]`;
			callback(err2);
			return;
		}
		if (!url) {
			this._loadNull(handler, callback, asset);
			return;
		}
		const key = _ResourceLoader.makeKey(url, type);
		if (this._cache[key] !== void 0) {
			callback(null, this._cache[key]);
		} else if (this._requests[key]) {
			this._requests[key].push(callback);
		} else {
			this._requests[key] = [callback];
			const self2 = this;
			const handleLoad = function(err2, urlObj) {
				if (err2) {
					self2._onFailure(key, err2);
					return;
				}
				if (urlObj.load instanceof DataView) {
					if (handler.openBinary) {
						if (!self2._requests[key]) {
							return;
						}
						try {
							const data2 = handler.openBinary(urlObj.load);
							self2._onSuccess(key, data2);
						} catch (err3) {
							self2._onFailure(key, err3);
						}
						return;
					}
					urlObj.load = URL.createObjectURL(new Blob([urlObj.load]));
					if (asset) {
						if (asset.urlObject) {
							URL.revokeObjectURL(asset.urlObject);
						}
						asset.urlObject = urlObj.load;
					}
				}
				handler.load(urlObj, (err3, data2, extra) => {
					if (!self2._requests[key]) {
						return;
					}
					if (err3) {
						self2._onFailure(key, err3);
						return;
					}
					try {
						self2._onSuccess(key, handler.open(urlObj.original, data2, asset), extra);
					} catch (e) {
						self2._onFailure(key, e);
					}
				}, asset);
			};
			const normalizedUrl = url.split("?")[0];
			if (this._app.enableBundles && this._app.bundles.hasUrl(normalizedUrl) && !(options2 && options2.bundlesIgnore)) {
				if (!this._app.bundles.urlIsLoadedOrLoading(normalizedUrl)) {
					const bundles = this._app.bundles.listBundlesForAsset(asset);
					let bundle;
					if (options2 && options2.bundlesFilter) {
						bundle = options2.bundlesFilter(bundles);
					}
					if (!bundle) {
						bundles?.sort((a, b) => {
							return a.file.size - b.file.size;
						});
						bundle = bundles?.[0];
					}
					if (bundle) this._app.assets?.load(bundle);
				}
				this._app.bundles.loadUrl(normalizedUrl, (err2, fileUrlFromBundle) => {
					handleLoad(err2, {
						load: fileUrlFromBundle,
						original: normalizedUrl
					});
				});
			} else {
				handleLoad(null, {
					load: url,
					original: asset && asset.file.filename || url
				});
			}
		}
	}
	// load an asset with no url, skipping bundles and caching
	_loadNull(handler, callback, asset) {
		const onLoad = function(err2, data2, extra) {
			if (err2) {
				callback(err2);
			} else {
				try {
					callback(null, handler.open(null, data2, asset), extra);
				} catch (e) {
					callback(e);
				}
			}
		};
		handler.load(null, onLoad, asset);
	}
	_onSuccess(key, result, extra) {
		if (result !== null) {
			this._cache[key] = result;
		} else {
			delete this._cache[key];
		}
		for (let i2 = 0; i2 < this._requests[key].length; i2++) {
			this._requests[key][i2](null, result, extra);
		}
		delete this._requests[key];
	}
	_onFailure(key, err2) {
		console.error(`Failed to load resource [${key}]: ${err2?.message ?? err2}`, err2);
		if (this._requests[key]) {
			for (let i2 = 0; i2 < this._requests[key].length; i2++) {
				this._requests[key][i2](err2);
			}
			delete this._requests[key];
		}
	}
	open(type, data2) {
		const handler = this._handlers[type];
		if (!handler) {
			console.warn(`No resource handler found for: ${type}`);
			return data2;
		}
		return handler.open(null, data2);
	}
	patch(asset, assets) {
		const handler = this._handlers[asset.type];
		if (!handler) {
			console.warn(`No resource handler found for: ${asset.type}`);
			return;
		}
		if (handler.patch) {
			handler.patch(asset, assets);
		}
	}
	clearCache(url, type) {
		const key = _ResourceLoader.makeKey(url, type);
		delete this._cache[key];
	}
	getFromCache(url, type) {
		const key = _ResourceLoader.makeKey(url, type);
		if (this._cache[key]) {
			return this._cache[key];
		}
		return void 0;
	}
	enableRetry(maxRetries = 5) {
		maxRetries = Math.max(0, Math.floor(maxRetries)) || 0;
		for (const key in this._handlers) {
			this._handlers[key].maxRetries = maxRetries;
		}
	}
	disableRetry() {
		for (const key in this._handlers) {
			this._handlers[key].maxRetries = 0;
		}
	}
	set maxConcurrentRequests(value) {
		http.maxConcurrentRequests = Math.max(0, Math.floor(value)) || 0;
	}
	get maxConcurrentRequests() {
		return http.maxConcurrentRequests;
	}
	set withCredentials(value) {
		http.withCredentials = !!value;
	}
	get withCredentials() {
		return http.withCredentials;
	}
	destroy() {
		this._handlers = {};
		this._requests = {};
		this._cache = {};
	}
};

var I18nParser = class {
	_validate(data2) {
		if (!data2.header) {
			throw new Error('I18n#addData: Missing "header" field');
		}
		if (!data2.header.version) {
			throw new Error('I18n#addData: Missing "header.version" field');
		}
		if (data2.header.version !== 1) {
			throw new Error('I18n#addData: Invalid "header.version" field');
		}
		if (!data2.data) {
			throw new Error('I18n#addData: Missing "data" field');
		} else if (!Array.isArray(data2.data)) {
			throw new Error('I18n#addData: "data" field must be an array');
		}
		for (let i2 = 0, len = data2.data.length; i2 < len; i2++) {
			const entry = data2.data[i2];
			if (!entry.info) {
				throw new Error(`I18n#addData: missing "data[${i2}].info" field`);
			}
			if (!entry.info.locale) {
				throw new Error(`I18n#addData: missing "data[${i2}].info.locale" field`);
			}
			if (typeof entry.info.locale !== "string") {
				throw new Error(`I18n#addData: "data[${i2}].info.locale" must be a string`);
			}
			if (!entry.messages) {
				throw new Error(`I18n#addData: missing "data[${i2}].messages" field`);
			}
		}
	}
	parse(data2) {
		return data2.data;
	}
};

var I18n = class _I18n extends EventHandler {
	static EVENT_CHANGE = "change";
	constructor(app2) {
		super();
		this.locale = DEFAULT_LOCALE;
		this._translations = {};
		this._availableLangs = {};
		this._app = app2;
		this._assets = [];
		this._parser = new I18nParser();
	}
	set assets(value) {
		const index = {};
		for (let i3 = 0, len = value.length; i3 < len; i3++) {
			const id14 = value[i3] instanceof Asset ? value[i3].id : value[i3];
			index[id14] = true;
		}
		let i2 = this._assets.length;
		while (i2--) {
			const id14 = this._assets[i2];
			if (!index[id14]) {
				this._app.assets.off(`add:${id14}`, this._onAssetAdd, this);
				const asset = this._app.assets.get(id14);
				if (asset) {
					this._onAssetRemove(asset);
				}
				this._assets.splice(i2, 1);
			}
		}
		for (const id14 in index) {
			const idNum = parseInt(id14, 10);
			if (this._assets.indexOf(idNum) !== -1) continue;
			this._assets.push(idNum);
			const asset = this._app.assets.get(idNum);
			if (!asset) {
				this._app.assets.once(`add:${idNum}`, this._onAssetAdd, this);
			} else {
				this._onAssetAdd(asset);
			}
		}
	}
	get assets() {
		return this._assets;
	}
	set locale(value) {
		if (this._locale === value) {
			return;
		}
		let lang = getLang(value);
		if (lang === "in") {
			lang = "id";
			value = replaceLang(value, lang);
			if (this._locale === value) {
				return;
			}
		}
		const old = this._locale;
		this._locale = value;
		this._lang = lang;
		this._pluralFn = getPluralFn(this._lang);
		this.fire(_I18n.EVENT_CHANGE, value, old);
	}
	get locale() {
		return this._locale;
	}
	static findAvailableLocale(desiredLocale, availableLocales) {
		return findAvailableLocale(desiredLocale, availableLocales);
	}
	findAvailableLocale(desiredLocale) {
		if (this._translations[desiredLocale]) {
			return desiredLocale;
		}
		const lang = getLang(desiredLocale);
		return this._findFallbackLocale(desiredLocale, lang);
	}
	getText(key, locale) {
		let result = key;
		let lang;
		if (!locale) {
			locale = this._locale;
			lang = this._lang;
		}
		let translations = this._translations[locale];
		if (!translations) {
			if (!lang) {
				lang = getLang(locale);
			}
			locale = this._findFallbackLocale(locale, lang);
			translations = this._translations[locale];
		}
		if (translations && translations.hasOwnProperty(key)) {
			result = translations[key];
			if (Array.isArray(result)) {
				result = result[0];
			}
			if (result === null || result === void 0) {
				result = key;
			}
		}
		return result;
	}
	getPluralText(key, n, locale) {
		let result = key;
		let lang;
		let pluralFn;
		if (!locale) {
			locale = this._locale;
			lang = this._lang;
			pluralFn = this._pluralFn;
		} else {
			lang = getLang(locale);
			pluralFn = getPluralFn(lang);
		}
		let translations = this._translations[locale];
		if (!translations) {
			locale = this._findFallbackLocale(locale, lang);
			lang = getLang(locale);
			pluralFn = getPluralFn(lang);
			translations = this._translations[locale];
		}
		if (translations && translations[key] && pluralFn) {
			const index = pluralFn(n);
			result = translations[key][index];
			if (result === null || result === void 0) {
				result = key;
			}
		}
		return result;
	}
	addData(data2) {
		let parsed;
		try {
			parsed = this._parser.parse(data2);
		} catch (err2) {
			console.error(`I18n.addData: failed to parse localization data: ${err2?.message ?? err2}`, err2);
			return;
		}
		for (let i2 = 0, len = parsed.length; i2 < len; i2++) {
			const entry = parsed[i2];
			const locale = entry.info.locale;
			const messages = entry.messages;
			if (!this._translations[locale]) {
				this._translations[locale] = {};
				const lang = getLang(locale);
				if (!this._availableLangs[lang]) {
					this._availableLangs[lang] = locale;
				}
			}
			Object.assign(this._translations[locale], messages);
			this.fire("data:add", locale, messages);
		}
	}
	removeData(data2) {
		let parsed;
		try {
			parsed = this._parser.parse(data2);
		} catch (err2) {
			console.error(`I18n.removeData: failed to parse localization data: ${err2?.message ?? err2}`, err2);
			return;
		}
		for (let i2 = 0, len = parsed.length; i2 < len; i2++) {
			const entry = parsed[i2];
			const locale = entry.info.locale;
			const translations = this._translations[locale];
			if (!translations) continue;
			const messages = entry.messages;
			for (const key in messages) {
				delete translations[key];
			}
			if (Object.keys(translations).length === 0) {
				delete this._translations[locale];
				delete this._availableLangs[getLang(locale)];
			}
			this.fire("data:remove", locale, messages);
		}
	}
	destroy() {
		this._translations = null;
		this._availableLangs = null;
		this._assets = null;
		this._parser = null;
		this.off();
	}
	// Finds a fallback locale for the specified locale and language.
	// 1) First tries DEFAULT_LOCALE_FALLBACKS
	// 2) If no translation exists for that locale return the first locale available for that language.
	// 3) If no translation exists for that either then return the DEFAULT_LOCALE
	_findFallbackLocale(locale, lang) {
		let result = DEFAULT_LOCALE_FALLBACKS[locale];
		if (result && this._translations[result]) {
			return result;
		}
		result = DEFAULT_LOCALE_FALLBACKS[lang];
		if (result && this._translations[result]) {
			return result;
		}
		result = this._availableLangs[lang];
		if (result && this._translations[result]) {
			return result;
		}
		return DEFAULT_LOCALE;
	}
	_onAssetAdd(asset) {
		asset.on("load", this._onAssetLoad, this);
		asset.on("change", this._onAssetChange, this);
		asset.on("remove", this._onAssetRemove, this);
		asset.on("unload", this._onAssetUnload, this);
		if (asset.resource) {
			this._onAssetLoad(asset);
		}
	}
	_onAssetLoad(asset) {
		this.addData(asset.resource);
	}
	_onAssetChange(asset) {
		if (asset.resource) {
			this.addData(asset.resource);
		}
	}
	_onAssetRemove(asset) {
		asset.off("load", this._onAssetLoad, this);
		asset.off("change", this._onAssetChange, this);
		asset.off("remove", this._onAssetRemove, this);
		asset.off("unload", this._onAssetUnload, this);
		if (asset.resource) {
			this.removeData(asset.resource);
		}
		this._app.assets.once(`add:${asset.id}`, this._onAssetAdd, this);
	}
	_onAssetUnload(asset) {
		if (asset.resource) {
			this.removeData(asset.resource);
		}
	}
};

var SCRIPT_INITIALIZE = "initialize";
var SCRIPT_POST_INITIALIZE = "postInitialize";
var SCRIPT_UPDATE = "update";
var SCRIPT_POST_UPDATE = "postUpdate";
var SCRIPT_SWAP = "swap";
var reservedScriptNames = /* @__PURE__ */ new Set([
	"system",
	"entity",
	"create",
	"destroy",
	"swap",
	"move",
	"data",
	"scripts",
	"_scripts",
	"_scriptsIndex",
	"_scriptsData",
	"enabled",
	"_oldState",
	"onEnable",
	"onDisable",
	"onPostStateChange",
	"_onSetEnabled",
	"_checkState",
	"_onBeforeRemove",
	"_onInitializeAttributes",
	"_onInitialize",
	"_onPostInitialize",
	"_onUpdate",
	"_onPostUpdate",
	"_callbacks",
	"_callbackActive",
	"has",
	"get",
	"on",
	"off",
	"fire",
	"once",
	"hasEvent",
	// 'worker' is reserved to prevent users from overwriting the native Worker constructor
	"worker"
]);

var Script = class extends EventHandler {
	static EVENT_ENABLE = "enable";
	static EVENT_DISABLE = "disable";
	static EVENT_STATE = "state";
	static EVENT_DESTROY = "destroy";
	static EVENT_ATTR = "attr";
	static EVENT_ERROR = "error";
	app;
	entity;
	_enabled;
	_enabledOld;
	_initialized;
	_postInitialized;
	__destroyed;
	__scriptType;
	__executionOrder;
	constructor(args) {
		super();
		this.initScript(args);
	}
	set enabled(value) {
		this._enabled = !!value;
		if (this.enabled === this._enabledOld) return;
		this._enabledOld = this.enabled;
		this.fire(this.enabled ? "enable" : "disable");
		this.fire("state", this.enabled);
		if (!this._initialized && this.enabled) {
			this._initialized = true;
			this.fire("preInitialize");
			if (this.initialize) {
				this.entity.script._scriptMethod(this, SCRIPT_INITIALIZE);
			}
		}
		if (this._initialized && !this._postInitialized && this.enabled && !this.entity.script._beingEnabled) {
			this._postInitialized = true;
			if (this.postInitialize) {
				this.entity.script._scriptMethod(this, SCRIPT_POST_INITIALIZE);
			}
		}
	}
	get enabled() {
		return this._enabled && !this._destroyed && this.entity.script.enabled && this.entity.enabled;
	}
	initScript(args) {
		const script2 = this.constructor;
		this.app = args.app;
		this.entity = args.entity;
		this._enabled = typeof args.enabled === "boolean" ? args.enabled : true;
		this._enabledOld = this.enabled;
		this.__destroyed = false;
		this.__scriptType = script2;
		this.__executionOrder = -1;
	}
	static __name = null;
	// Will be assigned when calling createScript or registerScript.
	static __getScriptName = getScriptName;
	static set scriptName(value) {
		this.__name = value;
	}
	static get scriptName() {
		return this.__name;
	}
};
var funcNameRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s\/]*)\s*/;
var toLowerCamelCase = (str) => str ? str[0].toLowerCase() + str.substring(1) : str;
function getScriptName(constructorFn) {
	if (typeof constructorFn !== "function") return void 0;
	if (Object.prototype.hasOwnProperty.call(constructorFn, "scriptName") && constructorFn.scriptName) {
		return constructorFn.scriptName;
	}
	if ("name" in Function.prototype) return constructorFn.name;
	if (constructorFn === Function || constructorFn === Function.prototype.constructor) return "Function";
	const match = `${constructorFn}`.match(funcNameRegex);
	return match ? match[1] : void 0;
}
function getScriptRegistryName(constructorFn) {
	if (typeof constructorFn !== "function") return void 0;
	if (Object.prototype.hasOwnProperty.call(constructorFn, "__name") && constructorFn.__name) {
		return constructorFn.__name;
	}
	if (Object.prototype.hasOwnProperty.call(constructorFn, "scriptName") && constructorFn.scriptName) {
		return constructorFn.scriptName;
	}
	const name = getScriptName(constructorFn);
	return name ? toLowerCamelCase(name) : void 0;
}

var ScriptRegistry = class extends EventHandler {
	_scripts = /* @__PURE__ */ new Map();
	_list = [];
	_scriptSchemas = /* @__PURE__ */ new Map();
	constructor(app2) {
		super();
		this.app = app2;
	}
	destroy() {
		this.app = null;
		this.off();
	}
	addSchema(id14, schema) {
		if (!schema) return;
		this._scriptSchemas.set(id14, schema);
	}
	getSchema(id14) {
		return this._scriptSchemas.get(id14);
	}
	add(script2) {
		const scriptName = getScriptRegistryName(script2);
		if (!scriptName) {
			return false;
		}
		if (reservedScriptNames.has(scriptName)) {
			return false;
		}
		script2.__name = scriptName;
		if (this._scripts.has(scriptName)) {
			setTimeout(() => {
				if (script2.prototype.swap) {
					const old = this._scripts.get(scriptName);
					const ind = this._list.indexOf(old);
					this._list[ind] = script2;
					this._scripts.set(scriptName, script2);
					this.fire("swap", scriptName, script2);
					this.fire(`swap:${scriptName}`, script2);
				} else {
					console.warn(`script registry already has '${scriptName}' script, define 'swap' method for new script type to enable code hot swapping`);
				}
			});
			return false;
		}
		this._scripts.set(scriptName, script2);
		this._list.push(script2);
		this.fire("add", scriptName, script2);
		this.fire(`add:${scriptName}`, script2);
		setTimeout(() => {
			if (!this._scripts.has(scriptName)) {
				return;
			}
			if (!this.app || !this.app.systems || !this.app.systems.script) {
				return;
			}
			const components2 = this.app.systems.script._components;
			let attributes;
			const scriptInstances = [];
			const scriptInstancesInitialized = [];
			for (components2.loopIndex = 0; components2.loopIndex < components2.length; components2.loopIndex++) {
				const component = components2.items[components2.loopIndex];
				if (component._scriptsIndex[scriptName] && component._scriptsIndex[scriptName].awaiting) {
					if (component._scriptsData && component._scriptsData[scriptName]) {
						attributes = component._scriptsData[scriptName].attributes;
					}
					const scriptInstance = component.create(scriptName, {
						preloading: true,
						ind: component._scriptsIndex[scriptName].ind,
						attributes
					});
					if (scriptInstance) {
						scriptInstances.push(scriptInstance);
					}
					for (const script3 of component.scripts) {
						component.initializeAttributes(script3);
					}
				}
			}
			for (let i2 = 0; i2 < scriptInstances.length; i2++) {
				if (scriptInstances[i2].enabled) {
					scriptInstances[i2]._initialized = true;
					scriptInstancesInitialized.push(scriptInstances[i2]);
					if (scriptInstances[i2].initialize) {
						scriptInstances[i2].initialize();
					}
				}
			}
			for (let i2 = 0; i2 < scriptInstancesInitialized.length; i2++) {
				if (!scriptInstancesInitialized[i2].enabled || scriptInstancesInitialized[i2]._postInitialized) {
					continue;
				}
				scriptInstancesInitialized[i2]._postInitialized = true;
				if (scriptInstancesInitialized[i2].postInitialize) {
					scriptInstancesInitialized[i2].postInitialize();
				}
			}
		});
		return true;
	}
	remove(nameOrType) {
		let scriptType = nameOrType;
		let scriptName = nameOrType;
		if (typeof scriptName !== "string") {
			scriptName = scriptType.__name;
		} else {
			scriptType = this.get(scriptName);
		}
		if (this.get(scriptName) !== scriptType) {
			return false;
		}
		this._scripts.delete(scriptName);
		const ind = this._list.indexOf(scriptType);
		this._list.splice(ind, 1);
		this.fire("remove", scriptName, scriptType);
		this.fire(`remove:${scriptName}`, scriptType);
		return true;
	}
	get(name) {
		return this._scripts.get(name) || null;
	}
	has(nameOrType) {
		if (typeof nameOrType === "string") {
			return this._scripts.has(nameOrType);
		}
		if (!nameOrType) return false;
		const scriptName = nameOrType.__name;
		return this._scripts.get(scriptName) === nameOrType;
	}
	list() {
		return this._list;
	}
};

var cmpStaticOrder = (a, b) => a.constructor.order - b.constructor.order;
var sortStaticOrder = (arr) => arr.sort(cmpStaticOrder);
var _enableList = [];
var tmpPool = [];
var getTempArray = () => {
	return tmpPool.pop() ?? [];
};
var releaseTempArray = (a) => {
	a.length = 0;
	tmpPool.push(a);
};
var Entity = class _Entity extends GraphNode {
	static EVENT_DESTROY = "destroy";
	anim;
	animation;
	audiolistener;
	button;
	camera;
	collision;
	element;
	gsplat;
	layoutchild;
	layoutgroup;
	light;
	model;
	particlesystem;
	render;
	rigidbody;
	screen;
	script;
	scrollbar;
	scrollview;
	sound;
	sprite;
	c = {};
	_app;
	_destroying = false;
	_guid = null;
	_template = false;
	constructor(name, app2 = getApplication()) {
		super(name);
		this._app = app2;
	}
	addComponent(type, data2) {
		const system = this._app.systems[type];
		if (!system) {
			return null;
		}
		if (this.c[type]) {
			return null;
		}
		return system.addComponent(this, data2);
	}
	removeComponent(type) {
		const system = this._app.systems[type];
		if (!system) {
			return;
		}
		if (!this.c[type]) {
			return;
		}
		system.removeComponent(this);
	}
	findComponent(type) {
		const entity = this.findOne((entity2) => entity2.c?.[type]);
		return entity && entity.c[type];
	}
	findComponents(type) {
		return this.find((entity) => entity.c?.[type]).map((entity) => entity.c[type]);
	}
	findScript(nameOrType) {
		const entity = this.findOne((node) => node.c?.script?.has(nameOrType));
		return entity?.c.script.get(nameOrType);
	}
	findScripts(nameOrType) {
		const entities = this.find((node) => node.c?.script?.has(nameOrType));
		return entities.map((entity) => entity.c.script.get(nameOrType));
	}
	set guid(value) {
		const index = this._app._entityIndex;
		if (this._guid) {
			delete index[this._guid];
		}
		this._guid = value;
		index[this._guid] = this;
	}
	get guid() {
		if (!this._guid) {
			this.guid = guid.create();
		}
		return this._guid;
	}
	getGuid() {
		return this.guid;
	}
	setGuid(guid2) {
		this.guid = guid2;
	}
	_notifyHierarchyStateChanged(node, enabled) {
		let enableFirst = false;
		if (node === this && _enableList.length === 0) {
			enableFirst = true;
		}
		node._beingEnabled = true;
		node._onHierarchyStateChanged(enabled);
		if (node._onHierarchyStatePostChanged) {
			_enableList.push(node);
		}
		const c2 = node._children;
		for (let i2 = 0, len = c2.length; i2 < len; i2++) {
			if (c2[i2]._enabled) {
				this._notifyHierarchyStateChanged(c2[i2], enabled);
			}
		}
		node._beingEnabled = false;
		if (enableFirst) {
			for (let i2 = 0; i2 < _enableList.length; i2++) {
				_enableList[i2]._onHierarchyStatePostChanged();
			}
			_enableList.length = 0;
		}
	}
	_onHierarchyStateChanged(enabled) {
		super._onHierarchyStateChanged(enabled);
		const components2 = this._getSortedComponents();
		for (let i2 = 0; i2 < components2.length; i2++) {
			const component = components2[i2];
			if (component.enabled) {
				if (enabled) {
					component.onEnable();
				} else {
					component.onDisable();
				}
			}
		}
		releaseTempArray(components2);
	}
	_onHierarchyStatePostChanged() {
		const components2 = this._getSortedComponents();
		for (let i2 = 0; i2 < components2.length; i2++) {
			components2[i2].onPostStateChange();
		}
		releaseTempArray(components2);
	}
	findByGuid(guid2) {
		if (this._guid === guid2) return this;
		const e = this._app._entityIndex[guid2];
		if (e && (e === this || e.isDescendantOf(this))) {
			return e;
		}
		return null;
	}
	destroy() {
		this._destroying = true;
		for (const name in this.c) {
			this.c[name].enabled = false;
		}
		for (const name in this.c) {
			this.c[name].system.removeComponent(this);
		}
		super.destroy();
		if (this._guid) {
			delete this._app._entityIndex[this._guid];
		}
		this._destroying = false;
	}
	clone() {
		const duplicatedIdsMap = {};
		const clone = this._cloneRecursively(duplicatedIdsMap);
		duplicatedIdsMap[this.guid] = clone;
		resolveDuplicatedEntityReferenceProperties(this, this, clone, duplicatedIdsMap);
		return clone;
	}
	_getSortedComponents() {
		const components2 = this.c;
		const sortedArray = getTempArray();
		let needSort = 0;
		for (const type in components2) {
			if (components2.hasOwnProperty(type)) {
				const component = components2[type];
				needSort |= component.constructor.order !== 0;
				sortedArray.push(component);
			}
		}
		if (needSort && sortedArray.length > 1) {
			sortStaticOrder(sortedArray);
		}
		return sortedArray;
	}
	_cloneRecursively(duplicatedIdsMap) {
		const clone = new this.constructor(void 0, this._app);
		super._cloneInternal(clone);
		for (const type in this.c) {
			const component = this.c[type];
			component.system.cloneComponent(this, clone);
		}
		for (let i2 = 0; i2 < this._children.length; i2++) {
			const oldChild = this._children[i2];
			if (oldChild instanceof _Entity) {
				const newChild = oldChild._cloneRecursively(duplicatedIdsMap);
				clone.addChild(newChild);
				duplicatedIdsMap[oldChild.guid] = newChild;
			}
		}
		return clone;
	}
};
function resolveDuplicatedEntityReferenceProperties(oldSubtreeRoot, oldEntity, newEntity, duplicatedIdsMap) {
	if (oldEntity instanceof Entity) {
		const components2 = oldEntity.c;
		for (const componentName in components2) {
			const component = components2[componentName];
			const entityProperties = component.system.getPropertiesOfType("entity");
			for (let i2 = 0, len = entityProperties.length; i2 < len; i2++) {
				const propertyDescriptor = entityProperties[i2];
				const propertyName = propertyDescriptor.name;
				const oldEntityReferenceId = component[propertyName];
				const entityIsWithinOldSubtree = !!oldSubtreeRoot.findByGuid(oldEntityReferenceId);
				if (entityIsWithinOldSubtree) {
					const newEntityReferenceId = duplicatedIdsMap[oldEntityReferenceId].guid;
					if (newEntityReferenceId) {
						newEntity.c[componentName][propertyName] = newEntityReferenceId;
					} else {
					}
				}
			}
		}
		if (components2.script) {
			newEntity.script.resolveDuplicatedEntityReferenceProperties(components2.script, duplicatedIdsMap);
		}
		if (components2.render) {
			newEntity.render.resolveDuplicatedEntityReferenceProperties(components2.render, duplicatedIdsMap);
		}
		if (components2.button) {
			newEntity.button.resolveDuplicatedEntityReferenceProperties(components2.button, duplicatedIdsMap);
		}
		if (components2.joint) {
			newEntity.joint.resolveDuplicatedEntityReferenceProperties(components2.joint, duplicatedIdsMap);
		}
		if (components2.scrollview) {
			newEntity.scrollview.resolveDuplicatedEntityReferenceProperties(components2.scrollview, duplicatedIdsMap);
		}
		if (components2.scrollbar) {
			newEntity.scrollbar.resolveDuplicatedEntityReferenceProperties(components2.scrollbar, duplicatedIdsMap);
		}
		if (components2.anim) {
			newEntity.anim.resolveDuplicatedEntityReferenceProperties(components2.anim, duplicatedIdsMap);
		}
		const _old = oldEntity.children.filter((e) => e instanceof Entity);
		const _new = newEntity.children.filter((e) => e instanceof Entity);
		for (let i2 = 0, len = _old.length; i2 < len; i2++) {
			resolveDuplicatedEntityReferenceProperties(oldSubtreeRoot, _old[i2], _new[i2], duplicatedIdsMap);
		}
	}
}

var SceneRegistryItem = class {
	name;
	url;
	data = null;
	_loading = false;
	_onLoadedCallbacks = [];
	constructor(name, url) {
		this.name = name;
		this.url = url;
	}
	get loaded() {
		return !!this.data;
	}
	get loading() {
		return this._loading;
	}
};

var SceneRegistry = class {
	_app;
	_list = [];
	_index = {};
	_urlIndex = {};
	constructor(app2) {
		this._app = app2;
	}
	destroy() {
		this._app = null;
	}
	list() {
		return this._list;
	}
	add(name, url) {
		if (this._index.hasOwnProperty(name)) {
			return false;
		}
		const item = new SceneRegistryItem(name, url);
		const i2 = this._list.push(item);
		this._index[item.name] = i2 - 1;
		this._urlIndex[item.url] = i2 - 1;
		return true;
	}
	find(name) {
		if (this._index.hasOwnProperty(name)) {
			return this._list[this._index[name]];
		}
		return null;
	}
	findByUrl(url) {
		if (this._urlIndex.hasOwnProperty(url)) {
			return this._list[this._urlIndex[url]];
		}
		return null;
	}
	remove(name) {
		if (this._index.hasOwnProperty(name)) {
			const idx = this._index[name];
			let item = this._list[idx];
			delete this._urlIndex[item.url];
			delete this._index[name];
			this._list.splice(idx, 1);
			for (let i2 = 0; i2 < this._list.length; i2++) {
				item = this._list[i2];
				this._index[item.name] = i2;
				this._urlIndex[item.url] = i2;
			}
		}
	}
	_loadSceneData(sceneItem, storeInCache, callback) {
		const app2 = this._app;
		let url = sceneItem;
		if (typeof sceneItem === "string") {
			sceneItem = this.findByUrl(url) || this.find(url) || new SceneRegistryItem("Untitled", url);
		}
		url = sceneItem.url;
		if (!url) {
			callback("Cannot find scene to load");
			return;
		}
		if (sceneItem.loaded) {
			callback(null, sceneItem);
			return;
		}
		if (app2.assets && app2.assets.prefix && !ABSOLUTE_URL.test(url)) {
			url = path.join(app2.assets.prefix, url);
		}
		sceneItem._onLoadedCallbacks.push(callback);
		if (!sceneItem._loading) {
			const handler = app2.loader.getHandler("hierarchy");
			handler.load(url, (err2, data2) => {
				sceneItem.data = data2;
				sceneItem._loading = false;
				for (let i2 = 0; i2 < sceneItem._onLoadedCallbacks.length; i2++) {
					sceneItem._onLoadedCallbacks[i2](err2, sceneItem);
				}
				if (!storeInCache) {
					sceneItem.data = null;
				}
				sceneItem._onLoadedCallbacks.length = 0;
			});
		}
		sceneItem._loading = true;
	}
	loadSceneData(sceneItem, callback) {
		this._loadSceneData(sceneItem, true, callback);
	}
	unloadSceneData(sceneItem) {
		if (typeof sceneItem === "string") {
			sceneItem = this.findByUrl(sceneItem);
		}
		if (sceneItem) {
			sceneItem.data = null;
		}
	}
	_loadSceneHierarchy(sceneItem, onBeforeAddHierarchy, callback) {
		this._loadSceneData(sceneItem, false, (err2, sceneItem2) => {
			if (err2) {
				if (callback) {
					callback(err2);
				}
				return;
			}
			if (onBeforeAddHierarchy) {
				onBeforeAddHierarchy(sceneItem2);
			}
			const app2 = this._app;
			const _loaded = () => {
				const handler = app2.loader.getHandler("hierarchy");
				app2.systems.script.preloading = true;
				const entity = handler.open(sceneItem2.url, sceneItem2.data);
				app2.systems.script.preloading = false;
				app2.loader.clearCache(sceneItem2.url, "hierarchy");
				app2.root.addChild(entity);
				app2.systems.fire("initialize", entity);
				app2.systems.fire("postInitialize", entity);
				app2.systems.fire("postPostInitialize", entity);
				if (callback) callback(null, entity);
			};
			app2._preloadScripts(sceneItem2.data, _loaded);
		});
	}
	loadSceneHierarchy(sceneItem, callback) {
		this._loadSceneHierarchy(sceneItem, null, callback);
	}
	loadSceneSettings(sceneItem, callback) {
		this._loadSceneData(sceneItem, false, (err2, sceneItem2) => {
			if (!err2) {
				this._app.applySceneSettings(sceneItem2.data.settings);
				if (callback) {
					callback(null);
				}
			} else {
				if (callback) {
					callback(err2);
				}
			}
		});
	}
	changeScene(sceneItem, callback) {
		const app2 = this._app;
		const onBeforeAddHierarchy = (sceneItem2) => {
			const { children } = app2.root;
			while (children.length) {
				children[0].destroy();
			}
			app2.applySceneSettings(sceneItem2.data.settings);
		};
		this._loadSceneHierarchy(sceneItem, onBeforeAddHierarchy, callback);
	}
	loadScene(url, callback) {
		const app2 = this._app;
		const handler = app2.loader.getHandler("scene");
		if (app2.assets && app2.assets.prefix && !ABSOLUTE_URL.test(url)) {
			url = path.join(app2.assets.prefix, url);
		}
		handler.load(url, (err2, data2) => {
			if (!err2) {
				const _loaded = () => {
					app2.systems.script.preloading = true;
					const scene = handler.open(url, data2);
					const sceneItem = this.findByUrl(url);
					if (sceneItem && !sceneItem.loaded) {
						sceneItem.data = data2;
					}
					app2.systems.script.preloading = false;
					app2.loader.clearCache(url, "scene");
					app2.loader.patch({
						resource: scene,
						type: "scene"
					}, app2.assets);
					app2.root.addChild(scene.root);
					if (app2.systems.rigidbody) {
						app2.systems.rigidbody.gravity.set(scene._gravity.x, scene._gravity.y, scene._gravity.z);
					}
					if (callback) {
						callback(null, scene);
					}
				};
				app2._preloadScripts(data2, _loaded);
			} else {
				if (callback) {
					callback(err2);
				}
			}
		});
	}
};

var ApplicationStats = class {
	constructor(device) {
		this.frame = {
			fps: 0,
			ms: 0,
			dt: 0,
			updateStart: 0,
			updateTime: 0,
			renderStart: 0,
			renderTime: 0,
			physicsStart: 0,
			physicsTime: 0,
			scriptUpdateStart: 0,
			scriptUpdate: 0,
			scriptPostUpdateStart: 0,
			scriptPostUpdate: 0,
			animUpdateStart: 0,
			animUpdate: 0,
			cullTime: 0,
			sortTime: 0,
			skinTime: 0,
			morphTime: 0,
			instancingTime: 0,
			// deprecated
			triangles: 0,
			gsplats: 0,
			gsplatSort: 0,
			gsplatBufferCopy: 0,
			otherPrimitives: 0,
			shaders: 0,
			materials: 0,
			cameras: 0,
			shadowMapUpdates: 0,
			shadowMapTime: 0,
			depthMapTime: 0,
			// deprecated
			forwardTime: 0,
			lightClustersTime: 0,
			lightClusters: 0,
			_timeToCountFrames: 0,
			_fpsAccum: 0
		};
		this.drawCalls = {
			forward: 0,
			depth: 0,
			// deprecated
			shadow: 0,
			immediate: 0,
			// deprecated
			misc: 0,
			// everything that is not forward/depth/shadow (post effect quads etc)
			total: 0,
			// total = forward + depth + shadow + misc
			// Some of forward/depth/shadow/misc draw calls:
			skinned: 0,
			instanced: 0,
			// deprecated
			removedByInstancing: 0
			// deprecated
		};
		this.misc = {
			renderTargetCreationTime: 0
		};
		this.particles = {
			updatesPerFrame: 0,
			_updatesPerFrame: 0,
			frameTime: 0,
			_frameTime: 0
		};
		this.shaders = device._shaderStats;
		this.vram = device._vram;
		this.gpu = device.gpuProfiler?.passTimings ?? /* @__PURE__ */ new Map();
		Object.defineProperty(this.vram, "totalUsed", {
			get: function() {
				return this.tex + this.vb + this.ib + this.ub + this.sb;
			}
		});
		Object.defineProperty(this.vram, "geom", {
			get: function() {
				return this.vb + this.ib;
			}
		});
		Object.defineProperty(this.vram, "buffers", {
			get: function() {
				return this.ub + this.sb;
			}
		});
	}
	get scene() {
		return getApplication().scene._stats;
	}
	get lightmapper() {
		return getApplication().lightmapper?.stats;
	}
	get batcher() {
		const batcher = getApplication()._batcher;
		return batcher ? batcher._stats : null;
	}
	updateBasic(now2, dt, ms, renderer, device) {
		const stats = this.frame;
		stats.dt = dt;
		stats.ms = ms;
		if (now2 > stats._timeToCountFrames) {
			stats.fps = stats._fpsAccum;
			stats._fpsAccum = 0;
			stats._timeToCountFrames = now2 + 1e3;
		} else {
			stats._fpsAccum++;
		}
		this.drawCalls.total = device._drawCallsPerFrame;
		device._drawCallsPerFrame = 0;
		stats.gsplats = renderer._gsplatCount;
		stats.gsplatBufferCopy = renderer._gsplatBufferCopy ?? 0;
	}
	updateDetailed(renderer, device) {
		let stats = this.frame;
		stats.cameras = renderer._camerasRendered;
		stats.materials = renderer._materialSwitches;
		stats.shaders = device._shaderSwitchesPerFrame;
		stats.shadowMapUpdates = renderer._shadowMapUpdates;
		stats.shadowMapTime = renderer._shadowMapTime;
		stats.depthMapTime = renderer._depthMapTime;
		stats.forwardTime = renderer._forwardTime;
		const prims = device._primsPerFrame;
		stats.triangles = prims[PRIMITIVE_TRIANGLES] / 3 + Math.max(prims[PRIMITIVE_TRISTRIP] - 2, 0) + Math.max(prims[PRIMITIVE_TRIFAN] - 2, 0);
		stats.cullTime = renderer._cullTime;
		stats.sortTime = renderer._sortTime;
		stats.skinTime = renderer._skinTime;
		stats.morphTime = renderer._morphTime;
		stats.lightClusters = renderer._lightClusters;
		stats.lightClustersTime = renderer._lightClustersTime;
		stats.otherPrimitives = 0;
		for (let i2 = 0; i2 < prims.length; i2++) {
			if (i2 < PRIMITIVE_TRIANGLES) {
				stats.otherPrimitives += prims[i2];
			}
			prims[i2] = 0;
		}
		renderer._camerasRendered = 0;
		renderer._materialSwitches = 0;
		renderer._shadowMapUpdates = 0;
		device._shaderSwitchesPerFrame = 0;
		renderer._cullTime = 0;
		renderer._layerCompositionUpdateTime = 0;
		renderer._lightClustersTime = 0;
		renderer._sortTime = 0;
		renderer._skinTime = 0;
		renderer._morphTime = 0;
		renderer._shadowMapTime = 0;
		renderer._depthMapTime = 0;
		renderer._forwardTime = 0;
		stats = this.drawCalls;
		stats.forward = renderer._forwardDrawCalls;
		stats.culled = renderer._numDrawCallsCulled;
		stats.depth = 0;
		stats.shadow = renderer._shadowDrawCalls;
		stats.skinned = renderer._skinDrawCalls;
		stats.immediate = 0;
		stats.instanced = 0;
		stats.removedByInstancing = 0;
		stats.misc = stats.total - (stats.forward + stats.shadow);
		renderer._depthDrawCalls = 0;
		renderer._shadowDrawCalls = 0;
		renderer._forwardDrawCalls = 0;
		renderer._numDrawCallsCulled = 0;
		renderer._skinDrawCalls = 0;
		renderer._immediateRendered = 0;
		renderer._instancedDrawCalls = 0;
		this.misc.renderTargetCreationTime = device.renderTargetCreationTime;
		stats = this.particles;
		stats.updatesPerFrame = stats._updatesPerFrame;
		stats.frameTime = stats._frameTime;
		stats._updatesPerFrame = 0;
		stats._frameTime = 0;
	}
	frameEnd() {
		this.frame.gsplatSort = 0;
	}
};

var alphaTest_default = `
uniform float alpha_ref;
void alphaTest(float a) {
	if (a < alpha_ref) discard;
}
`;

var ambient_default = `
#ifdef LIT_AMBIENT_SOURCE == AMBIENTSH
	uniform vec3 ambientSH[9];
#endif
#if LIT_AMBIENT_SOURCE == ENVALATLAS
	#include "envAtlasPS"
	#ifndef ENV_ATLAS
	#define ENV_ATLAS
		uniform sampler2D texture_envAtlas;
	#endif
#endif
void addAmbient(vec3 worldNormal) {
	#ifdef LIT_AMBIENT_SOURCE == AMBIENTSH
		vec3 n = cubeMapRotate(worldNormal);
		vec3 color =
			ambientSH[0] +
			ambientSH[1] * n.x +
			ambientSH[2] * n.y +
			ambientSH[3] * n.z +
			ambientSH[4] * n.x * n.z +
			ambientSH[5] * n.z * n.y +
			ambientSH[6] * n.y * n.x +
			ambientSH[7] * (3.0 * n.z * n.z - 1.0) +
			ambientSH[8] * (n.x * n.x - n.y * n.y);
		dDiffuseLight += processEnvironment(max(color, vec3(0.0)));
	#endif
	#if LIT_AMBIENT_SOURCE == ENVALATLAS
		vec3 dir = normalize(cubeMapRotate(worldNormal) * vec3(-1.0, 1.0, 1.0));
		vec2 uv = mapUv(toSphericalUv(dir), vec4(128.0, 256.0 + 128.0, 64.0, 32.0) / atlasSize);
		vec4 raw = texture2D(texture_envAtlas, uv);
		vec3 linear = {ambientDecode}(raw);
		dDiffuseLight += processEnvironment(linear);
	#endif
	#if LIT_AMBIENT_SOURCE == CONSTANT
		dDiffuseLight += light_globalAmbient;
	#endif
}
`;

var anisotropy_default = `
#ifdef LIT_GGX_SPECULAR
	uniform float material_anisotropyIntensity;
	uniform vec2 material_anisotropyRotation;
#endif
void getAnisotropy() {
	dAnisotropy = 0.0;
	dAnisotropyRotation = vec2(1.0, 0.0);
#ifdef LIT_GGX_SPECULAR
	dAnisotropy = material_anisotropyIntensity;
	dAnisotropyRotation = material_anisotropyRotation;
#endif
	#ifdef STD_ANISOTROPY_TEXTURE
	vec3 anisotropyTex = texture2DBias({STD_ANISOTROPY_TEXTURE_NAME}, {STD_ANISOTROPY_TEXTURE_UV}, textureBias).rgb;
	dAnisotropy *= anisotropyTex.b;
	vec2 anisotropyRotationFromTex = anisotropyTex.rg * 2.0 - vec2(1.0);
	mat2 rotationMatrix = mat2(dAnisotropyRotation.x, dAnisotropyRotation.y, -dAnisotropyRotation.y, dAnisotropyRotation.x);
	dAnisotropyRotation = rotationMatrix * anisotropyRotationFromTex;
	#endif
	
	dAnisotropy = clamp(dAnisotropy, 0.0, 1.0);
}
`;

var ao_default = `
#if defined(STD_AO_TEXTURE) || defined(STD_AO_VERTEX)
	uniform float material_aoIntensity;
#endif
#ifdef STD_AODETAIL_TEXTURE
	#include "detailModesPS"
#endif
void getAO() {
	dAo = 1.0;
	#ifdef STD_AO_TEXTURE
		float aoBase = texture2DBias({STD_AO_TEXTURE_NAME}, {STD_AO_TEXTURE_UV}, textureBias).{STD_AO_TEXTURE_CHANNEL};
		#ifdef STD_AODETAIL_TEXTURE
			float aoDetail = texture2DBias({STD_AODETAIL_TEXTURE_NAME}, {STD_AODETAIL_TEXTURE_UV}, textureBias).{STD_AODETAIL_TEXTURE_CHANNEL};
			aoBase = detailMode_{STD_AODETAIL_DETAILMODE}(vec3(aoBase), vec3(aoDetail)).r;
		#endif
		dAo *= aoBase;
	#endif
	#ifdef STD_AO_VERTEX
		dAo *= saturate(vVertexColor.{STD_AO_VERTEX_CHANNEL});
	#endif
	#if defined(STD_AO_TEXTURE) || defined(STD_AO_VERTEX)
		dAo = mix(1.0, dAo, material_aoIntensity);
	#endif
}
`;

var aoDiffuseOcc_default = `
void occludeDiffuse(float ao) {
	dDiffuseLight *= ao;
}
`;

var aoSpecOcc_default = `
#if LIT_OCCLUDE_SPECULAR != NONE
	#ifdef LIT_OCCLUDE_SPECULAR_FLOAT
		uniform float material_occludeSpecularIntensity;
	#endif
#endif
void occludeSpecular(float gloss, float ao, vec3 worldNormal, vec3 viewDir) {
	#if LIT_OCCLUDE_SPECULAR == AO
		#ifdef LIT_OCCLUDE_SPECULAR_FLOAT
			float specOcc = mix(1.0, ao, material_occludeSpecularIntensity);
		#else
			float specOcc = ao;
		#endif
	#endif
	#if LIT_OCCLUDE_SPECULAR == GLOSSDEPENDENT
		float specPow = exp2(gloss * 11.0);
		float specOcc = saturate(pow(dot(worldNormal, viewDir) + ao, 0.01 * specPow) - 1.0 + ao);
		#ifdef LIT_OCCLUDE_SPECULAR_FLOAT
			specOcc = mix(1.0, specOcc, material_occludeSpecularIntensity);
		#endif
	#endif
	#if LIT_OCCLUDE_SPECULAR != NONE
		dSpecularLight *= specOcc;
		dReflection *= specOcc;
		#ifdef LIT_SHEEN
			sSpecularLight *= specOcc;
			sReflection *= specOcc;
		#endif
	#endif
}
`;

var bakeDirLmEnd_default = `
	vec4 dirLm = texture2D(texture_dirLightMap, vUv1);
	if (bakeDir > 0.5) {
		if (dAtten > 0.00001) {
			dirLm.xyz = dirLm.xyz * 2.0 - vec3(1.0);
			dAtten = saturate(dAtten);
			gl_FragColor.rgb = normalize(dLightDirNormW.xyz*dAtten + dirLm.xyz*dirLm.w) * 0.5 + vec3(0.5);
			gl_FragColor.a = dirLm.w + dAtten;
			gl_FragColor.a = max(gl_FragColor.a, 1.0 / 255.0);
		} else {
			gl_FragColor = dirLm;
		}
	} else {
		gl_FragColor.rgb = dirLm.xyz;
		gl_FragColor.a = max(dirLm.w, dAtten > 0.00001 ? (1.0/255.0) : 0.0);
	}
`;

var bakeLmEnd_default = `
#ifdef LIT_LIGHTMAP_BAKING_ADD_AMBIENT
	dDiffuseLight = ((dDiffuseLight - 0.5) * max(ambientBakeOcclusionContrast + 1.0, 0.0)) + 0.5;
	dDiffuseLight += vec3(ambientBakeOcclusionBrightness);
	dDiffuseLight = saturate(dDiffuseLight);
	dDiffuseLight *= dAmbientLight;
#endif
#ifdef LIGHTMAP_RGBM
	gl_FragColor.rgb = dDiffuseLight;
	gl_FragColor.rgb = pow(gl_FragColor.rgb, vec3(0.5));
	gl_FragColor.rgb /= 8.0;
	gl_FragColor.a = clamp( max( max( gl_FragColor.r, gl_FragColor.g ), max( gl_FragColor.b, 1.0 / 255.0 ) ), 0.0,1.0 );
	gl_FragColor.a = ceil(gl_FragColor.a * 255.0) / 255.0;
	gl_FragColor.rgb /= gl_FragColor.a;
#else
	gl_FragColor = vec4(dDiffuseLight, 1.0);
#endif
`;

var base_default = `
uniform vec3 view_position;
uniform vec3 light_globalAmbient;
float square(float x) {
	return x*x;
}
float saturate(float x) {
	return clamp(x, 0.0, 1.0);
}
vec3 saturate(vec3 x) {
	return clamp(x, vec3(0.0), vec3(1.0));
}
`;

var baseNineSliced_default = `
#define NINESLICED
varying vec2 vMask;
varying vec2 vTiledUv;
uniform mediump vec4 innerOffset;
uniform mediump vec2 outerScale;
uniform mediump vec4 atlasRect;
vec2 nineSlicedUv;
`;

var baseNineSlicedTiled_default = `
#define NINESLICED
#define NINESLICETILED
varying vec2 vMask;
varying vec2 vTiledUv;
uniform mediump vec4 innerOffset;
uniform mediump vec2 outerScale;
uniform mediump vec4 atlasRect;
vec2 nineSlicedUv;
`;

var bayer_default = `
float bayer2(vec2 p) {
	return mod(2.0 * p.y + p.x + 1.0, 4.0);
}
float bayer4(vec2 p) {
	vec2 p1 = mod(p, 2.0);
	vec2 p2 = floor(0.5 * mod(p, 4.0));
	return 4.0 * bayer2(p1) + bayer2(p2);
}
float bayer8(vec2 p) {
	vec2 p1 = mod(p, 2.0);
	vec2 p2 = floor(0.5 * mod(p, 4.0));
	vec2 p4 = floor(0.25 * mod(p, 8.0));
	return 4.0 * (4.0 * bayer2(p1) + bayer2(p2)) + bayer2(p4);
}
`;

var blurVSM_default = `
varying vec2 vUv0;
uniform sampler2D source;
uniform vec2 pixelOffset;
#ifdef GAUSS
	uniform float weight[{SAMPLES}];
#endif
void main(void) {
	vec3 moments = vec3(0.0);
	vec2 uv = vUv0 - pixelOffset * (float({SAMPLES}) * 0.5);
	for (int i = 0; i < {SAMPLES}; i++) {
		vec4 c = texture2D(source, uv + pixelOffset * float(i));
		#ifdef GAUSS
			moments += c.xyz * weight[i];
		#else
			moments += c.xyz;
		#endif
	}
	#ifndef GAUSS
		moments *= 1.0 / float({SAMPLES});
	#endif
	gl_FragColor = vec4(moments.x, moments.y, moments.z, 1.0);
}
`;

var clearCoat_default = `
uniform float material_clearCoat;
void getClearCoat() {
	ccSpecularity = material_clearCoat;
	#ifdef STD_CLEARCOAT_TEXTURE
	ccSpecularity *= texture2DBias({STD_CLEARCOAT_TEXTURE_NAME}, {STD_CLEARCOAT_TEXTURE_UV}, textureBias).{STD_CLEARCOAT_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_CLEARCOAT_VERTEX
	ccSpecularity *= saturate(vVertexColor.{STD_CLEARCOAT_VERTEX_CHANNEL});
	#endif
}
`;

var clearCoatGloss_default = `
uniform float material_clearCoatGloss;
void getClearCoatGlossiness() {
	ccGlossiness = material_clearCoatGloss;
	#ifdef STD_CLEARCOATGLOSS_TEXTURE
	ccGlossiness *= texture2DBias({STD_CLEARCOATGLOSS_TEXTURE_NAME}, {STD_CLEARCOATGLOSS_TEXTURE_UV}, textureBias).{STD_CLEARCOATGLOSS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_CLEARCOATGLOSS_VERTEX
	ccGlossiness *= saturate(vVertexColor.{STD_CLEARCOATGLOSS_VERTEX_CHANNEL});
	#endif
	#ifdef STD_CLEARCOATGLOSS_INVERT
	ccGlossiness = 1.0 - ccGlossiness;
	#endif
	ccGlossiness += 0.0000001;
}
`;

var clearCoatNormal_default = `
#ifdef STD_CLEARCOATNORMAL_TEXTURE
uniform float material_clearCoatBumpiness;
#endif
void getClearCoatNormal() {
#ifdef STD_CLEARCOATNORMAL_TEXTURE
	vec3 normalMap = {STD_CLEARCOATNORMAL_TEXTURE_DECODE}(texture2DBias({STD_CLEARCOATNORMAL_TEXTURE_NAME}, {STD_CLEARCOATNORMAL_TEXTURE_UV}, textureBias));
	normalMap = mix(vec3(0.0, 0.0, 1.0), normalMap, material_clearCoatBumpiness);
	ccNormalW = normalize(dTBN * normalMap);
#else
	ccNormalW = dVertexNormalW;
#endif
}
`;

var clusteredLightUtils_default = `
vec2 getCubemapFaceCoordinates(const vec3 dir, out float faceIndex, out vec2 tileOffset)
{
	vec3 vAbs = abs(dir);
	float ma;
	vec2 uv;
	if (vAbs.z >= vAbs.x && vAbs.z >= vAbs.y) {
		faceIndex = dir.z < 0.0 ? 5.0 : 4.0;
		ma = 0.5 / vAbs.z;
		uv = vec2(dir.z < 0.0 ? -dir.x : dir.x, -dir.y);
		tileOffset.x = 2.0;
		tileOffset.y = dir.z < 0.0 ? 1.0 : 0.0;
	} else if(vAbs.y >= vAbs.x) {
		faceIndex = dir.y < 0.0 ? 3.0 : 2.0;
		ma = 0.5 / vAbs.y;
		uv = vec2(dir.x, dir.y < 0.0 ? -dir.z : dir.z);
		tileOffset.x = 1.0;
		tileOffset.y = dir.y < 0.0 ? 1.0 : 0.0;
	} else {
		faceIndex = dir.x < 0.0 ? 1.0 : 0.0;
		ma = 0.5 / vAbs.x;
		uv = vec2(dir.x < 0.0 ? dir.z : -dir.z, -dir.y);
		tileOffset.x = 0.0;
		tileOffset.y = dir.x < 0.0 ? 1.0 : 0.0;
	}
	return uv * ma + 0.5;
}
vec2 getCubemapAtlasCoordinates(const vec3 omniAtlasViewport, float shadowEdgePixels, float shadowTextureResolution, const vec3 dir) {
	float faceIndex;
	vec2 tileOffset;
	vec2 uv = getCubemapFaceCoordinates(dir, faceIndex, tileOffset);
	float atlasFaceSize = omniAtlasViewport.z;
	float tileSize = shadowTextureResolution * atlasFaceSize;
	float offset = shadowEdgePixels / tileSize;
	uv = uv * vec2(1.0 - offset * 2.0) + vec2(offset * 1.0);
	uv *= atlasFaceSize;
	uv += tileOffset * atlasFaceSize;
	uv += omniAtlasViewport.xy;
	return uv;
}
`;

var clusteredLightCookies_default = `
vec3 _getCookieClustered(TEXTURE_ACCEPT(tex), vec2 uv, float intensity, vec4 cookieChannel) {
	vec4 pixel = mix(vec4(1.0), texture2DLod(tex, uv, 0.0), intensity);
	bool isRgb = dot(cookieChannel.rgb, vec3(1.0)) == 3.0;
	return isRgb ? pixel.rgb : vec3(dot(pixel, cookieChannel));
}
vec3 getCookie2DClustered(TEXTURE_ACCEPT(tex), mat4 transform, vec3 worldPosition, float intensity, vec4 cookieChannel) {
	vec4 projPos = transform * vec4(worldPosition, 1.0);
	return _getCookieClustered(TEXTURE_PASS(tex), projPos.xy / projPos.w, intensity, cookieChannel);
}
vec3 getCookieCubeClustered(TEXTURE_ACCEPT(tex), vec3 dir, float intensity, vec4 cookieChannel, float shadowTextureResolution, float shadowEdgePixels, vec3 omniAtlasViewport) {
	vec2 uv = getCubemapAtlasCoordinates(omniAtlasViewport, shadowEdgePixels, shadowTextureResolution, dir);
	return _getCookieClustered(TEXTURE_PASS(tex), uv, intensity, cookieChannel);
}
`;

var clusteredLightShadows_default = `
vec3 _getShadowCoordPerspZbuffer(mat4 shadowMatrix, vec4 shadowParams, vec3 wPos) {
	vec4 projPos = shadowMatrix * vec4(wPos, 1.0);
	projPos.xyz /= projPos.w;
	return projPos.xyz;
}
vec3 getShadowCoordPerspZbufferNormalOffset(mat4 shadowMatrix, vec4 shadowParams, vec3 normal) {
	vec3 wPos = vPositionW + normal * shadowParams.y;
	return _getShadowCoordPerspZbuffer(shadowMatrix, shadowParams, wPos);
}
vec3 normalOffsetPointShadow(vec4 shadowParams, vec3 lightPos, vec3 lightDir, vec3 lightDirNorm, vec3 normal) {
	float distScale = length(lightDir);
	vec3 wPos = vPositionW + normal * shadowParams.y * clamp(1.0 - dot(normal, -lightDirNorm), 0.0, 1.0) * distScale;
	vec3 dir = wPos - lightPos;
	return dir;
}
#if defined(CLUSTER_SHADOW_TYPE_PCF1)
float getShadowOmniClusteredPCF1(SHADOWMAP_ACCEPT(shadowMap), vec4 shadowParams, vec3 omniAtlasViewport, float shadowEdgePixels, vec3 lightDir) {
	float shadowTextureResolution = shadowParams.x;
	vec2 uv = getCubemapAtlasCoordinates(omniAtlasViewport, shadowEdgePixels, shadowTextureResolution, lightDir);
	float shadowZ = length(lightDir) * shadowParams.w + shadowParams.z;
	return textureShadow(shadowMap, vec3(uv, shadowZ));
}
#endif
#if defined(CLUSTER_SHADOW_TYPE_PCF3)
float getShadowOmniClusteredPCF3(SHADOWMAP_ACCEPT(shadowMap), vec4 shadowParams, vec3 omniAtlasViewport, float shadowEdgePixels, vec3 lightDir) {
	float shadowTextureResolution = shadowParams.x;
	vec2 uv = getCubemapAtlasCoordinates(omniAtlasViewport, shadowEdgePixels, shadowTextureResolution, lightDir);
	float shadowZ = length(lightDir) * shadowParams.w + shadowParams.z;
	vec3 shadowCoord = vec3(uv, shadowZ);
	return getShadowPCF3x3(SHADOWMAP_PASS(shadowMap), shadowCoord, shadowParams);
}
#endif
#if defined(CLUSTER_SHADOW_TYPE_PCF5)
float getShadowOmniClusteredPCF5(SHADOWMAP_ACCEPT(shadowMap), vec4 shadowParams, vec3 omniAtlasViewport, float shadowEdgePixels, vec3 lightDir) {
	float shadowTextureResolution = shadowParams.x;
	vec2 uv = getCubemapAtlasCoordinates(omniAtlasViewport, shadowEdgePixels, shadowTextureResolution, lightDir);
	float shadowZ = length(lightDir) * shadowParams.w + shadowParams.z;
	vec3 shadowCoord = vec3(uv, shadowZ);
	return getShadowPCF5x5(SHADOWMAP_PASS(shadowMap), shadowCoord, shadowParams);
}
#endif
#if defined(CLUSTER_SHADOW_TYPE_PCF1)
float getShadowSpotClusteredPCF1(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams) {
	return textureShadow(shadowMap, shadowCoord);
}
#endif
#if defined(CLUSTER_SHADOW_TYPE_PCF3)
float getShadowSpotClusteredPCF3(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams) {
	return getShadowSpotPCF3x3(SHADOWMAP_PASS(shadowMap), shadowCoord, shadowParams);
}
#endif
#if defined(CLUSTER_SHADOW_TYPE_PCF5)
float getShadowSpotClusteredPCF5(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams) {
	return getShadowPCF5x5(SHADOWMAP_PASS(shadowMap), shadowCoord, shadowParams);
}
#endif
`;

var clusteredLight_default = `
#include "lightBufferDefinesPS"
#include "clusteredLightUtilsPS"
#ifdef CLUSTER_COOKIES
	#include "clusteredLightCookiesPS"
#endif
#ifdef CLUSTER_SHADOWS
	#include "clusteredLightShadowsPS"
#endif
uniform highp usampler2D clusterWorldTexture;
uniform highp sampler2D lightsTexture;
#ifdef CLUSTER_SHADOWS
	uniform sampler2DShadow shadowAtlasTexture;
#endif
#ifdef CLUSTER_COOKIES
	uniform sampler2D cookieAtlasTexture;
#endif
uniform int clusterMaxCells;
uniform int numClusteredLights;
uniform int clusterTextureWidth;
uniform vec3 clusterCellsCountByBoundsSize;
uniform vec3 clusterBoundsMin;
uniform vec3 clusterBoundsDelta;
uniform ivec3 clusterCellsDot;
uniform ivec3 clusterCellsMax;
uniform vec2 shadowAtlasParams;
struct ClusterLightData {
	vec3 position;
	int lightIndex;
	vec3 direction;
	uint shape;
	vec3 color;
	float shadowIntensity;
	float range;
	float biasesData;
	float cookieIntensity;
	bool isSpot;
	bool falloffModeLinear;
	bool isDynamic;
	bool isLightmapped;
};
struct ClusterLightSpotData {
	float innerConeAngleCos;
	float outerConeAngleCos;
};
struct ClusterLightAreaData {
	vec3 halfWidth;
	vec3 halfHeight;
};
struct ClusterLightShadowData {
	float shadowBias;
	float shadowNormalBias;
};
mat4 lightProjectionMatrix;
uint clusterLightData_flags;
float clusterLightData_anglesData;
uint clusterLightData_colorBFlagsData;
vec4 sampleLightTextureF(int lightIndex, int index) {
	return texelFetch(lightsTexture, ivec2(index, lightIndex), 0);
}
ClusterLightData decodeClusterLightCore(int lightIndex) {
	ClusterLightData clusterLightData;
	clusterLightData.lightIndex = lightIndex;
	vec4 halfData = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_COLOR_ANGLES_BIAS});
	clusterLightData_anglesData = halfData.z;
	clusterLightData.biasesData = halfData.w;
	clusterLightData_colorBFlagsData = floatBitsToUint(halfData.y);
	vec2 colorRG = unpackHalf2x16(floatBitsToUint(halfData.x));
	vec2 colorB_flags = unpackHalf2x16(clusterLightData_colorBFlagsData);
	clusterLightData.color = vec3(colorRG, colorB_flags.x) * {LIGHT_COLOR_DIVIDER};
	vec4 lightPosRange = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_POSITION_RANGE});
	clusterLightData.position = lightPosRange.xyz;
	clusterLightData.range = lightPosRange.w;
	vec4 lightDir_Flags = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_DIRECTION_FLAGS});
	clusterLightData.direction = lightDir_Flags.xyz;
	clusterLightData_flags = floatBitsToUint(lightDir_Flags.w);
	clusterLightData.isSpot = (clusterLightData_flags & (1u << 30u)) != 0u;
	clusterLightData.shape = (clusterLightData_flags >> 28u) & 0x3u;
	clusterLightData.falloffModeLinear = (clusterLightData_flags & (1u << 27u)) == 0u;
	clusterLightData.shadowIntensity = float((clusterLightData_flags >> 0u) & 0xFFu) / 255.0;
	clusterLightData.cookieIntensity = float((clusterLightData_flags >> 8u) & 0xFFu) / 255.0;
	clusterLightData.isDynamic = (clusterLightData_flags & (1u << 22u)) != 0u;
	clusterLightData.isLightmapped = (clusterLightData_flags & (1u << 21u)) != 0u;
	return clusterLightData;
}
ClusterLightSpotData decodeClusterLightSpot() {
	uint angleFlags = (clusterLightData_colorBFlagsData >> 16u) & 0xFFFFu;
	vec2 angleValues = unpackHalf2x16(floatBitsToUint(clusterLightData_anglesData));
	float innerVal = angleValues.x;
	float outerVal = angleValues.y;
	float innerIsVersine = float(angleFlags & 1u);
	float outerIsVersine = float((angleFlags >> 1u) & 1u);
	return ClusterLightSpotData(
		mix(innerVal, 1.0 - innerVal, innerIsVersine),
		mix(outerVal, 1.0 - outerVal, outerIsVersine)
	);
}
vec3 decodeClusterLightOmniAtlasViewport(int lightIndex) {
	return sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_0}).xyz;
}
ClusterLightAreaData decodeClusterLightAreaData(int lightIndex) {
	return ClusterLightAreaData(
		sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_AREA_DATA_WIDTH}).xyz,
		sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_AREA_DATA_HEIGHT}).xyz
	);
}
mat4 decodeClusterLightProjectionMatrixData(int lightIndex) {
	vec4 m0 = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_0});
	vec4 m1 = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_1});
	vec4 m2 = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_2});
	vec4 m3 = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_3});
	return mat4(m0, m1, m2, m3);
}
ClusterLightShadowData decodeClusterLightShadowData(float biasesData) {
	vec2 biases = unpackHalf2x16(floatBitsToUint(biasesData));
	return ClusterLightShadowData(biases.x, biases.y);
}
vec4 decodeClusterLightCookieData() {
	uint cookieFlags = (clusterLightData_flags >> 23u) & 0x0Fu;
	vec4 mask = vec4(uvec4(cookieFlags) & uvec4(1u, 2u, 4u, 8u));
	return step(1.0, mask);
}
void evaluateLight(
	ClusterLightData light, 
	vec3 worldNormal, 
	vec3 viewDir, 
	vec3 reflectionDir,
#if defined(LIT_CLEARCOAT)
	vec3 clearcoatReflectionDir,
#endif
	float gloss, 
	vec3 specularity, 
	vec3 geometricNormal, 
	mat3 tbn, 
#if defined(LIT_IRIDESCENCE)
	vec3 iridescenceFresnel,
#endif
	vec3 clearcoat_worldNormal,
	float clearcoat_gloss,
	float sheen_gloss,
	float iridescence_intensity
) {
	vec3 cookieAttenuation = vec3(1.0);
	float diffuseAttenuation = 1.0;
	float falloffAttenuation = 1.0;
	vec3 lightDirW = evalOmniLight(light.position);
	vec3 lightDirNormW = normalize(lightDirW);
	#ifdef CLUSTER_AREALIGHTS
	if (light.shape != {LIGHTSHAPE_PUNCTUAL}) {
		ClusterLightAreaData areaData = decodeClusterLightAreaData(light.lightIndex);
		if (light.shape == {LIGHTSHAPE_RECT}) {
			calcRectLightValues(light.position, areaData.halfWidth, areaData.halfHeight);
		} else if (light.shape == {LIGHTSHAPE_DISK}) {
			calcDiskLightValues(light.position, areaData.halfWidth, areaData.halfHeight);
		} else {
			calcSphereLightValues(light.position, areaData.halfWidth, areaData.halfHeight);
		}
		falloffAttenuation = getFalloffWindow(light.range, lightDirW);
	} else
	#endif
	{
		if (light.falloffModeLinear)
			falloffAttenuation = getFalloffLinear(light.range, lightDirW);
		else
			falloffAttenuation = getFalloffInvSquared(light.range, lightDirW);
	}
	if (falloffAttenuation > 0.00001) {
		#ifdef CLUSTER_AREALIGHTS
		if (light.shape != {LIGHTSHAPE_PUNCTUAL}) {
			if (light.shape == {LIGHTSHAPE_RECT}) {
				diffuseAttenuation = getRectLightDiffuse(worldNormal, viewDir, lightDirW, lightDirNormW) * 16.0;
			} else if (light.shape == {LIGHTSHAPE_DISK}) {
				diffuseAttenuation = getDiskLightDiffuse(worldNormal, viewDir, lightDirW, lightDirNormW) * 16.0;
			} else {
				diffuseAttenuation = getSphereLightDiffuse(worldNormal, viewDir, lightDirW, lightDirNormW) * 16.0;
			}
		} else
		#endif
		{
			falloffAttenuation *= getLightDiffuse(worldNormal, viewDir, lightDirNormW); 
		}
		if (light.isSpot) {
			ClusterLightSpotData spotData = decodeClusterLightSpot();
			falloffAttenuation *= getSpotEffect(light.direction, spotData.innerConeAngleCos, spotData.outerConeAngleCos, lightDirNormW);
		}
		#if defined(CLUSTER_COOKIES) || defined(CLUSTER_SHADOWS)
		if (falloffAttenuation > 0.00001) {
			if (light.shadowIntensity > 0.0 || light.cookieIntensity > 0.0) {
				vec3 omniAtlasViewport = vec3(0.0);
				if (light.isSpot) {
					lightProjectionMatrix = decodeClusterLightProjectionMatrixData(light.lightIndex);
				} else {
					omniAtlasViewport = decodeClusterLightOmniAtlasViewport(light.lightIndex);
				}
				float shadowTextureResolution = shadowAtlasParams.x;
				float shadowEdgePixels = shadowAtlasParams.y;
				#ifdef CLUSTER_COOKIES
				if (light.cookieIntensity > 0.0) {
					vec4 cookieChannelMask = decodeClusterLightCookieData();
					if (light.isSpot) {
						cookieAttenuation = getCookie2DClustered(TEXTURE_PASS(cookieAtlasTexture), lightProjectionMatrix, vPositionW, light.cookieIntensity, cookieChannelMask);
					} else {
						cookieAttenuation = getCookieCubeClustered(TEXTURE_PASS(cookieAtlasTexture), lightDirW, light.cookieIntensity, cookieChannelMask, shadowTextureResolution, shadowEdgePixels, omniAtlasViewport);
					}
				}
				#endif
				#ifdef CLUSTER_SHADOWS
				if (light.shadowIntensity > 0.0) {
					ClusterLightShadowData shadowData = decodeClusterLightShadowData(light.biasesData);
					vec4 shadowParams = vec4(shadowTextureResolution, shadowData.shadowNormalBias, shadowData.shadowBias, 1.0 / light.range);
					if (light.isSpot) {
						vec3 shadowCoord = getShadowCoordPerspZbufferNormalOffset(lightProjectionMatrix, shadowParams, geometricNormal);
						
						#if defined(CLUSTER_SHADOW_TYPE_PCF1)
							float shadow = getShadowSpotClusteredPCF1(SHADOWMAP_PASS(shadowAtlasTexture), shadowCoord, shadowParams);
						#elif defined(CLUSTER_SHADOW_TYPE_PCF3)
							float shadow = getShadowSpotClusteredPCF3(SHADOWMAP_PASS(shadowAtlasTexture), shadowCoord, shadowParams);
						#elif defined(CLUSTER_SHADOW_TYPE_PCF5)
							float shadow = getShadowSpotClusteredPCF5(SHADOWMAP_PASS(shadowAtlasTexture), shadowCoord, shadowParams);
						#elif defined(CLUSTER_SHADOW_TYPE_PCSS)
							float shadow = getShadowSpotClusteredPCSS(SHADOWMAP_PASS(shadowAtlasTexture), shadowCoord, shadowParams);
						#endif
						falloffAttenuation *= mix(1.0, shadow, light.shadowIntensity);
					} else {
						vec3 dir = normalOffsetPointShadow(shadowParams, light.position, lightDirW, lightDirNormW, geometricNormal);
						#if defined(CLUSTER_SHADOW_TYPE_PCF1)
							float shadow = getShadowOmniClusteredPCF1(SHADOWMAP_PASS(shadowAtlasTexture), shadowParams, omniAtlasViewport, shadowEdgePixels, dir);
						#elif defined(CLUSTER_SHADOW_TYPE_PCF3)
							float shadow = getShadowOmniClusteredPCF3(SHADOWMAP_PASS(shadowAtlasTexture), shadowParams, omniAtlasViewport, shadowEdgePixels, dir);
						#elif defined(CLUSTER_SHADOW_TYPE_PCF5)
							float shadow = getShadowOmniClusteredPCF5(SHADOWMAP_PASS(shadowAtlasTexture), shadowParams, omniAtlasViewport, shadowEdgePixels, dir);
						#endif
						falloffAttenuation *= mix(1.0, shadow, light.shadowIntensity);
					}
				}
				#endif
			}
		}
		#endif
		#ifdef CLUSTER_AREALIGHTS
		if (light.shape != {LIGHTSHAPE_PUNCTUAL}) {
			{
				vec3 areaDiffuse = (diffuseAttenuation * falloffAttenuation) * light.color * cookieAttenuation;
				#if defined(LIT_SPECULAR)
					areaDiffuse = mix(areaDiffuse, vec3(0), dLTCSpecFres);
				#endif
				dDiffuseLight += areaDiffuse;
			}
			#ifdef LIT_SPECULAR
				float areaLightSpecular;
				if (light.shape == {LIGHTSHAPE_RECT}) {
					areaLightSpecular = getRectLightSpecular(worldNormal, viewDir);
				} else if (light.shape == {LIGHTSHAPE_DISK}) {
					areaLightSpecular = getDiskLightSpecular(worldNormal, viewDir);
				} else {
					areaLightSpecular = getSphereLightSpecular(worldNormal, viewDir);
				}
				dSpecularLight += dLTCSpecFres * areaLightSpecular * falloffAttenuation * light.color * cookieAttenuation;
				#ifdef LIT_CLEARCOAT
					float areaLightSpecularCC;
					if (light.shape == {LIGHTSHAPE_RECT}) {
						areaLightSpecularCC = getRectLightSpecular(clearcoat_worldNormal, viewDir);
					} else if (light.shape == {LIGHTSHAPE_DISK}) {
						areaLightSpecularCC = getDiskLightSpecular(clearcoat_worldNormal, viewDir);
					} else {
						areaLightSpecularCC = getSphereLightSpecular(clearcoat_worldNormal, viewDir);
					}
					ccSpecularLight += ccLTCSpecFres * areaLightSpecularCC * falloffAttenuation * light.color  * cookieAttenuation;
				#endif
			#endif
		} else
		#endif
		{
			{
				vec3 punctualDiffuse = falloffAttenuation * light.color * cookieAttenuation;
				#if defined(CLUSTER_AREALIGHTS)
				#if defined(LIT_SPECULAR)
					punctualDiffuse = mix(punctualDiffuse, vec3(0), specularity);
				#endif
				#endif
				dDiffuseLight += punctualDiffuse;
			}
	 
			#ifdef LIT_SPECULAR
				vec3 halfDir = normalize(-lightDirNormW + viewDir);
				
				#ifdef LIT_SPECULAR_FRESNEL
					dSpecularLight += 
						getLightSpecular(halfDir, reflectionDir, worldNormal, viewDir, lightDirNormW, gloss, tbn) * falloffAttenuation * light.color * cookieAttenuation * 
						getFresnel(
							dot(viewDir, halfDir), 
							gloss, 
							specularity
						#if defined(LIT_IRIDESCENCE)
							, iridescenceFresnel,
							iridescence_intensity
						#endif
							);
				#else
					dSpecularLight += getLightSpecular(halfDir, reflectionDir, worldNormal, viewDir, lightDirNormW, gloss, tbn) * falloffAttenuation * light.color * cookieAttenuation * specularity;
				#endif
				#ifdef LIT_CLEARCOAT
					#ifdef LIT_SPECULAR_FRESNEL
						ccSpecularLight += getLightSpecular(halfDir, clearcoatReflectionDir, clearcoat_worldNormal, viewDir, lightDirNormW, clearcoat_gloss, tbn) * falloffAttenuation * light.color * cookieAttenuation * getFresnelCC(dot(viewDir, halfDir));
					#else
						ccSpecularLight += getLightSpecular(halfDir, clearcoatReflectionDir, clearcoat_worldNormal, viewDir, lightDirNormW, clearcoat_gloss, tbn) * falloffAttenuation * light.color * cookieAttenuation; 
					#endif
				#endif
				#ifdef LIT_SHEEN
					sSpecularLight += getLightSpecularSheen(halfDir, worldNormal, viewDir, lightDirNormW, sheen_gloss) * falloffAttenuation * light.color * cookieAttenuation;
				#endif
			#endif
		}
	}
	dAtten = falloffAttenuation;
	dLightDirNormW = lightDirNormW;
}
void evaluateClusterLight(
	int lightIndex, 
	vec3 worldNormal, 
	vec3 viewDir, 
	vec3 reflectionDir, 
#if defined(LIT_CLEARCOAT)
	vec3 clearcoatReflectionDir,
#endif
	float gloss, 
	vec3 specularity, 
	vec3 geometricNormal, 
	mat3 tbn, 
#if defined(LIT_IRIDESCENCE)
	vec3 iridescenceFresnel,
#endif
	vec3 clearcoat_worldNormal,
	float clearcoat_gloss,
	float sheen_gloss,
	float iridescence_intensity
) {
	ClusterLightData clusterLightData = decodeClusterLightCore(lightIndex);
	#ifdef CLUSTER_MESH_DYNAMIC_LIGHTS
		bool acceptLightMask = clusterLightData.isDynamic;
	#else
		bool acceptLightMask = clusterLightData.isLightmapped;
	#endif
	if (acceptLightMask)
		evaluateLight(
			clusterLightData, 
			worldNormal, 
			viewDir, 
			reflectionDir, 
#if defined(LIT_CLEARCOAT)
			clearcoatReflectionDir, 
#endif
			gloss, 
			specularity, 
			geometricNormal, 
			tbn, 
#if defined(LIT_IRIDESCENCE)
			iridescenceFresnel,
#endif
			clearcoat_worldNormal,
			clearcoat_gloss,
			sheen_gloss,
			iridescence_intensity
		);
}
void addClusteredLights(
	vec3 worldNormal, 
	vec3 viewDir, 
	vec3 reflectionDir, 
#if defined(LIT_CLEARCOAT)
	vec3 clearcoatReflectionDir,
#endif
	float gloss, 
	vec3 specularity, 
	vec3 geometricNormal, 
	mat3 tbn, 
#if defined(LIT_IRIDESCENCE)
	vec3 iridescenceFresnel,
#endif
	vec3 clearcoat_worldNormal,
	float clearcoat_gloss,
	float sheen_gloss,
	float iridescence_intensity
) {
	if (numClusteredLights <= 1)
		return;
	ivec3 cellCoords = ivec3(floor((vPositionW - clusterBoundsMin) * clusterCellsCountByBoundsSize));
	if (!(any(lessThan(cellCoords, ivec3(0))) || any(greaterThanEqual(cellCoords, clusterCellsMax)))) {
		int cellIndex = cellCoords.x * clusterCellsDot.x + cellCoords.y * clusterCellsDot.y + cellCoords.z * clusterCellsDot.z;
		int clusterV = cellIndex / clusterTextureWidth;
		int clusterU = cellIndex - clusterV * clusterTextureWidth;
		for (int lightCellIndex = 0; lightCellIndex < clusterMaxCells; lightCellIndex++) {
			uint lightIndex = texelFetch(clusterWorldTexture, ivec2(clusterU + lightCellIndex, clusterV), 0).x;
			if (lightIndex == 0u)
				break;
			evaluateClusterLight(
				int(lightIndex), 
				worldNormal, 
				viewDir, 
				reflectionDir,
#if defined(LIT_CLEARCOAT)
				clearcoatReflectionDir,
#endif
				gloss, 
				specularity, 
				geometricNormal, 
				tbn, 
#if defined(LIT_IRIDESCENCE)
				iridescenceFresnel,
#endif
				clearcoat_worldNormal,
				clearcoat_gloss,
				sheen_gloss,
				iridescence_intensity
			); 
		}
	}
}
`;

var combine_default = `
vec3 combineColor(vec3 albedo, vec3 sheenSpecularity, float clearcoatSpecularity) {
	vec3 ret = vec3(0);
#ifdef LIT_OLD_AMBIENT
	ret += (dDiffuseLight - light_globalAmbient) * albedo + material_ambient * light_globalAmbient;
#else
	ret += albedo * dDiffuseLight;
#endif
#ifdef LIT_SPECULAR
	ret += dSpecularLight;
#endif
#ifdef LIT_REFLECTIONS
	ret += dReflection.rgb * dReflection.a;
#endif
#ifdef LIT_SHEEN
	float sheenScaling = 1.0 - max(max(sheenSpecularity.r, sheenSpecularity.g), sheenSpecularity.b) * 0.157;
	ret = ret * sheenScaling + (sSpecularLight + sReflection.rgb) * sheenSpecularity;
#endif
#ifdef LIT_CLEARCOAT
	float clearCoatScaling = 1.0 - ccFresnel * clearcoatSpecularity;
	ret = ret * clearCoatScaling + (ccSpecularLight + ccReflection) * clearcoatSpecularity;
#endif
	return ret;
}
`;

var cookie_blit_2d_default = `
	varying vec2 uv0;
	uniform sampler2D blitTexture;
	void main(void) {
		gl_FragColor = texture2D(blitTexture, uv0);
	}
`;

var cookie_blit_cube_default = `
	varying vec2 uv0;
	uniform samplerCube blitTexture;
	uniform mat4 invViewProj;
	void main(void) {
		vec4 projPos = vec4(uv0 * 2.0 - 1.0, 0.5, 1.0);
		vec4 worldPos = invViewProj * projPos;
		gl_FragColor = textureCube(blitTexture, worldPos.xyz);
	}
`;

var cookie_blit_default = `
	attribute vec2 vertex_position;
	varying vec2 uv0;
	void main(void) {
		gl_Position = vec4(vertex_position, 0.5, 1.0);
		uv0 = vertex_position.xy * 0.5 + 0.5;
		#ifndef WEBGPU
			uv0.y = 1.0 - uv0.y;
		#endif
	}
`;

var cookie_default = `
vec4 getCookie2D(sampler2D tex, mat4 transform, float intensity) {
	vec4 projPos = transform * vec4(vPositionW, 1.0);
	projPos.xy /= projPos.w;
	return mix(vec4(1.0), texture2D(tex, projPos.xy), intensity);
}
vec4 getCookie2DClip(sampler2D tex, mat4 transform, float intensity) {
	vec4 projPos = transform * vec4(vPositionW, 1.0);
	projPos.xy /= projPos.w;
	if (projPos.x < 0.0 || projPos.x > 1.0 || projPos.y < 0.0 || projPos.y > 1.0 || projPos.z < 0.0) return vec4(0.0);
	return mix(vec4(1.0), texture2D(tex, projPos.xy), intensity);
}
vec4 getCookie2DXform(sampler2D tex, mat4 transform, float intensity, vec4 cookieMatrix, vec2 cookieOffset) {
	vec4 projPos = transform * vec4(vPositionW, 1.0);
	projPos.xy /= projPos.w;
	projPos.xy += cookieOffset;
	vec2 uv = mat2(cookieMatrix) * (projPos.xy-vec2(0.5)) + vec2(0.5);
	return mix(vec4(1.0), texture2D(tex, uv), intensity);
}
vec4 getCookie2DClipXform(sampler2D tex, mat4 transform, float intensity, vec4 cookieMatrix, vec2 cookieOffset) {
	vec4 projPos = transform * vec4(vPositionW, 1.0);
	projPos.xy /= projPos.w;
	projPos.xy += cookieOffset;
	if (projPos.x < 0.0 || projPos.x > 1.0 || projPos.y < 0.0 || projPos.y > 1.0 || projPos.z < 0.0) return vec4(0.0);
	vec2 uv = mat2(cookieMatrix) * (projPos.xy-vec2(0.5)) + vec2(0.5);
	return mix(vec4(1.0), texture2D(tex, uv), intensity);
}
vec4 getCookieCube(samplerCube tex, mat4 transform, float intensity) {
	return mix(vec4(1.0), textureCube(tex, dLightDirNormW * mat3(transform)), intensity);
}
`;

var cubeMapProject_default = `
#if LIT_CUBEMAP_PROJECTION == BOX
	uniform vec3 envBoxMin;
	uniform vec3 envBoxMax;
#endif
vec3 cubeMapProject(vec3 nrdir) {
	#if LIT_CUBEMAP_PROJECTION == NONE
		return cubeMapRotate(nrdir);
	#endif
	#if LIT_CUBEMAP_PROJECTION == BOX
		nrdir = cubeMapRotate(nrdir);
		vec3 rbmax = (envBoxMax - vPositionW) / nrdir;
		vec3 rbmin = (envBoxMin - vPositionW) / nrdir;
		vec3 rbminmax = mix(rbmin, rbmax, vec3(greaterThan(nrdir, vec3(0.0))));
		float fa = min(min(rbminmax.x, rbminmax.y), rbminmax.z);
		vec3 posonbox = vPositionW + nrdir * fa;
		vec3 envBoxPos = (envBoxMin + envBoxMax) * 0.5;
		return normalize(posonbox - envBoxPos);
	#endif
}
`;

var cubeMapRotate_default = `
#ifdef CUBEMAP_ROTATION
uniform mat3 cubeMapRotationMatrix;
#endif
vec3 cubeMapRotate(vec3 refDir) {
#ifdef CUBEMAP_ROTATION
	return refDir * cubeMapRotationMatrix;
#else
	return refDir;
#endif
}
`;

var debug_output_default = `
#ifdef DEBUG_ALBEDO_PASS
gl_FragColor = vec4(gammaCorrectOutput(dAlbedo), 1.0);
#endif
#ifdef DEBUG_UV0_PASS
gl_FragColor = vec4(litArgs_albedo , 1.0);
#endif
#ifdef DEBUG_WORLD_NORMAL_PASS
gl_FragColor = vec4(litArgs_worldNormal * 0.5 + 0.5, 1.0);
#endif
#ifdef DEBUG_OPACITY_PASS
gl_FragColor = vec4(vec3(litArgs_opacity) , 1.0);
#endif
#ifdef DEBUG_SPECULARITY_PASS
gl_FragColor = vec4(litArgs_specularity, 1.0);
#endif
#ifdef DEBUG_GLOSS_PASS
gl_FragColor = vec4(vec3(litArgs_gloss) , 1.0);
#endif
#ifdef DEBUG_METALNESS_PASS
gl_FragColor = vec4(vec3(litArgs_metalness) , 1.0);
#endif
#ifdef DEBUG_AO_PASS
gl_FragColor = vec4(vec3(litArgs_ao) , 1.0);
#endif
#ifdef DEBUG_EMISSION_PASS
gl_FragColor = vec4(gammaCorrectOutput(litArgs_emission), 1.0);
#endif
`;

var debug_process_frontend_default = `
#ifdef DEBUG_LIGHTING_PASS
litArgs_albedo = vec3(0.5);
#endif
#ifdef DEBUG_UV0_PASS
#ifdef VARYING_VUV0
litArgs_albedo = vec3(vUv0, 0);
#else
litArgs_albedo = vec3(0);
#endif
#endif
`;

var decode_default = `
#ifndef _DECODE_INCLUDED_
#define _DECODE_INCLUDED_
vec3 decodeLinear(vec4 raw) {
	return raw.rgb;
}
float decodeGamma(float raw) {
	return pow(raw, 2.2);
}
vec3 decodeGamma(vec3 raw) {
	return pow(raw, vec3(2.2));
}
vec3 decodeGamma(vec4 raw) {
	return pow(raw.xyz, vec3(2.2));
}
vec3 decodeRGBM(vec4 raw) {
	vec3 color = (8.0 * raw.a) * raw.rgb;
	return color * color;
}
vec3 decodeRGBP(vec4 raw) {
	vec3 color = raw.rgb * (-raw.a * 7.0 + 8.0);
	return color * color;
}
vec3 decodeRGBE(vec4 raw) {
	if (raw.a == 0.0) {
		return vec3(0.0, 0.0, 0.0);
	} else {
		return raw.xyz * pow(2.0, raw.w * 255.0 - 128.0);
	}
}
vec4 passThrough(vec4 raw) {
	return raw;
}
vec3 unpackNormalXYZ(vec4 nmap) {
	return nmap.xyz * 2.0 - 1.0;
}
vec3 unpackNormalXY(vec4 nmap) {
	vec3 normal;
	normal.xy = nmap.wy * 2.0 - 1.0;
	normal.z = sqrt(1.0 - clamp(dot(normal.xy, normal.xy), 0.0, 1.0));
	return normal;
}
#endif
`;

var detailModes_default = `
#ifndef _DETAILMODES_INCLUDED_
#define _DETAILMODES_INCLUDED_
vec3 detailMode_mul(vec3 c1, vec3 c2) {
	return c1 * c2;
}
vec3 detailMode_add(vec3 c1, vec3 c2) {
	return c1 + c2;
}
vec3 detailMode_screen(vec3 c1, vec3 c2) {
	return 1.0 - (1.0 - c1)*(1.0 - c2);
}
vec3 detailMode_overlay(vec3 c1, vec3 c2) {
	return mix(1.0 - 2.0 * (1.0 - c1)*(1.0 - c2), 2.0 * c1 * c2, step(c1, vec3(0.5)));
}
vec3 detailMode_min(vec3 c1, vec3 c2) {
	return min(c1, c2);
}
vec3 detailMode_max(vec3 c1, vec3 c2) {
	return max(c1, c2);
}
#endif
`;

var diffuse_default = `
uniform vec3 material_diffuse;
#ifdef STD_DIFFUSEDETAIL_TEXTURE
	#include "detailModesPS"
#endif
void getAlbedo() {
	dAlbedo = material_diffuse.rgb;
	#ifdef STD_DIFFUSE_TEXTURE
		vec3 albedoTexture = {STD_DIFFUSE_TEXTURE_DECODE}(texture2DBias({STD_DIFFUSE_TEXTURE_NAME}, {STD_DIFFUSE_TEXTURE_UV}, textureBias)).{STD_DIFFUSE_TEXTURE_CHANNEL};
		#ifdef STD_DIFFUSEDETAIL_TEXTURE
			vec3 albedoDetail = {STD_DIFFUSEDETAIL_TEXTURE_DECODE}(texture2DBias({STD_DIFFUSEDETAIL_TEXTURE_NAME}, {STD_DIFFUSEDETAIL_TEXTURE_UV}, textureBias)).{STD_DIFFUSEDETAIL_TEXTURE_CHANNEL};
			albedoTexture = detailMode_{STD_DIFFUSEDETAIL_DETAILMODE}(albedoTexture, albedoDetail);
		#endif
		dAlbedo *= albedoTexture;
	#endif
	#ifdef STD_DIFFUSE_VERTEX
		dAlbedo *= saturate(vVertexColor.{STD_DIFFUSE_VERTEX_CHANNEL});
	#endif
}
`;

var emissive_default = `
uniform vec3 material_emissive;
uniform float material_emissiveIntensity;
void getEmission() {
	dEmission = material_emissive * material_emissiveIntensity;
	#ifdef STD_EMISSIVE_TEXTURE
	dEmission *= {STD_EMISSIVE_TEXTURE_DECODE}(texture2DBias({STD_EMISSIVE_TEXTURE_NAME}, {STD_EMISSIVE_TEXTURE_UV}, textureBias)).{STD_EMISSIVE_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_EMISSIVE_VERTEX
	dEmission *= saturate(vVertexColor.{STD_EMISSIVE_VERTEX_CHANNEL});
	#endif
}
`;

var encode_default = `
vec4 encodeLinear(vec3 source) {
	return vec4(source, 1.0);
}
vec4 encodeGamma(vec3 source) {
	return vec4(pow(source + 0.0000001, vec3(1.0 / 2.2)), 1.0);
}
vec4 encodeRGBM(vec3 source) {
	vec4 result;
	result.rgb = pow(source.rgb, vec3(0.5));
	result.rgb *= 1.0 / 8.0;
	result.a = saturate( max( max( result.r, result.g ), max( result.b, 1.0 / 255.0 ) ) );
	result.a = ceil(result.a * 255.0) / 255.0;
	result.rgb /= result.a;
	return result;
}
vec4 encodeRGBP(vec3 source) {
	vec3 gamma = pow(source, vec3(0.5));
	float maxVal = min(8.0, max(1.0, max(gamma.x, max(gamma.y, gamma.z))));
	float v = 1.0 - ((maxVal - 1.0) / 7.0);
	v = ceil(v * 255.0) / 255.0;
	return vec4(gamma / (-v * 7.0 + 8.0), v);	
}
vec4 encodeRGBE(vec3 source) {
	float maxVal = max(source.x, max(source.y, source.z));
	if (maxVal < 1e-32) {
		return vec4(0, 0, 0, 0);
	} else {
		float e = ceil(log2(maxVal));
		return vec4(source / pow(2.0, e), (e + 128.0) / 255.0);
	}
}
`;

var end_default = `
	gl_FragColor.rgb = combineColor(litArgs_albedo, litArgs_sheen_specularity, litArgs_clearcoat_specularity);
	gl_FragColor.rgb += litArgs_emission;
	gl_FragColor.rgb = addFog(gl_FragColor.rgb);
	gl_FragColor.rgb = toneMap(gl_FragColor.rgb);
	gl_FragColor.rgb = gammaCorrectOutput(gl_FragColor.rgb);
`;

var envAtlas_default = `
#ifndef _ENVATLAS_INCLUDED_
#define _ENVATLAS_INCLUDED_
const float atlasSize = 512.0;
const float seamSize = 1.0 / atlasSize;
vec2 mapUv(vec2 uv, vec4 rect) {
	return vec2(mix(rect.x + seamSize, rect.x + rect.z - seamSize, uv.x),
				mix(rect.y + seamSize, rect.y + rect.w - seamSize, uv.y));
}
vec2 mapRoughnessUv(vec2 uv, float level) {
	float t = 1.0 / exp2(level);
	return mapUv(uv, vec4(0, 1.0 - t, t, t * 0.5));
}
vec2 mapShinyUv(vec2 uv, float level) {
	float t = 1.0 / exp2(level);
	return mapUv(uv, vec4(1.0 - t, 1.0 - t, t, t * 0.5));
}
#endif
`;

var envProc_default = `
#ifdef LIT_SKYBOX_INTENSITY
	uniform float skyboxIntensity;
#endif
vec3 processEnvironment(vec3 color) {
	#ifdef LIT_SKYBOX_INTENSITY
		return color * skyboxIntensity;
	#else
		return color;
	#endif
}
`;

var falloffInvSquared_default = `
float getFalloffWindow(float lightRadius, vec3 lightDir) {
	float sqrDist = dot(lightDir, lightDir);
	float invRadius = 1.0 / lightRadius;
	return square(saturate(1.0 - square(sqrDist * square(invRadius))));
}
float getFalloffInvSquared(float lightRadius, vec3 lightDir) {
	float sqrDist = dot(lightDir, lightDir);
	float falloff = 1.0 / (sqrDist + 1.0);
	float invRadius = 1.0 / lightRadius;
	falloff *= 16.0;
	falloff *= square(saturate(1.0 - square(sqrDist * square(invRadius))));
	return falloff;
}
`;

var falloffLinear_default = `
float getFalloffLinear(float lightRadius, vec3 lightDir) {
	float d = length(lightDir);
	return max(((lightRadius - d) / lightRadius), 0.0);
}
`;

var float_as_uint_default = `
#ifndef FLOAT_AS_UINT
#define FLOAT_AS_UINT
vec4 float2uint(float value) {
	uint intBits = floatBitsToUint(value);
	return vec4(
		float((intBits >> 24u) & 0xFFu) / 255.0,
		float((intBits >> 16u) & 0xFFu) / 255.0,
		float((intBits >> 8u) & 0xFFu) / 255.0,
		float(intBits & 0xFFu) / 255.0
	);
}
float uint2float(vec4 value) {
	uint intBits = 
		(uint(value.r * 255.0) << 24u) |
		(uint(value.g * 255.0) << 16u) |
		(uint(value.b * 255.0) << 8u) |
		uint(value.a * 255.0);
	return uintBitsToFloat(intBits);
}
vec4 float2vec4(float value) {
	#if defined(CAPS_TEXTURE_FLOAT_RENDERABLE)
		return vec4(value, 1.0, 1.0, 1.0);
	#else
		return float2uint(value);
	#endif
}
#endif
`;

var fog_default = `
float dBlendModeFogFactor = 1.0;
#if (FOG != NONE)
	uniform vec3 fog_color;
	#if (FOG == LINEAR)
		uniform float fog_start;
		uniform float fog_end;
	#else
		uniform float fog_density;
	#endif
#endif
#ifdef VERTEXSHADER
	float getFogFactor(float depth) {
#else
	float getFogFactor() {
		float depth = gl_FragCoord.z / gl_FragCoord.w;
#endif
	float fogFactor = 0.0;
	#if (FOG == LINEAR)
		fogFactor = (fog_end - depth) / (fog_end - fog_start);
	#elif (FOG == EXP)
		fogFactor = exp(-depth * fog_density);
	#elif (FOG == EXP2)
		fogFactor = exp(-depth * depth * fog_density * fog_density);
	#endif
	return clamp(fogFactor, 0.0, 1.0);
}
#ifdef VERTEXSHADER
	vec3 addFog(vec3 color, float depth) {
		#if (FOG != NONE)
			return mix(fog_color * dBlendModeFogFactor, color, getFogFactor(depth));
		#endif
		return color;
	}
#else
	vec3 addFog(vec3 color) {
		#if (FOG != NONE)
			return mix(fog_color * dBlendModeFogFactor, color, getFogFactor());
		#endif
		return color;
	}
#endif
`;

var fresnelSchlick_default = `
float pow5(float x) {
	float x2 = x * x;
	return x2 * x2 * x;
}
vec3 getFresnel(
		float cosTheta, 
		float gloss, 
		vec3 specularity
#if defined(LIT_IRIDESCENCE)
		, vec3 iridescenceFresnel, 
		float iridescenceIntensity
#endif
	) {
	float fresnel = pow5(1.0 - saturate(cosTheta));
	float glossSq = gloss * gloss;
	float specIntensity = max(specularity.r, max(specularity.g, specularity.b));
	vec3 ret = specularity + (max(vec3(glossSq * specIntensity), specularity) - specularity) * fresnel;
#if defined(LIT_IRIDESCENCE)
	return mix(ret, iridescenceFresnel, iridescenceIntensity);
#else
	return ret;
#endif	
}
float getFresnelCC(float cosTheta) {
	float fresnel = pow5(1.0 - saturate(cosTheta));
	return 0.04 + (1.0 - 0.04) * fresnel;
}
`;

var fullscreenQuad_default = `
attribute vec2 vertex_position;
varying vec2 vUv0;
void main(void)
{
	gl_Position = vec4(vertex_position, 0.5, 1.0);
	vUv0 = vertex_position.xy * 0.5 + 0.5;
}
`;

var gamma_default = `
#include "decodePS"
#if (GAMMA == SRGB)
	float gammaCorrectInput(float color) {
		return decodeGamma(color);
	}
	vec3 gammaCorrectInput(vec3 color) {
		return decodeGamma(color);
	}
	vec4 gammaCorrectInput(vec4 color) {
		return vec4(decodeGamma(color.xyz), color.w);
	}
	vec3 gammaCorrectOutput(vec3 color) {
		return pow(color + 0.0000001, vec3(1.0 / 2.2));
	}
#else
	float gammaCorrectInput(float color) {
		return color;
	}
	vec3 gammaCorrectInput(vec3 color) {
		return color;
	}
	vec4 gammaCorrectInput(vec4 color) {
		return color;
	}
	vec3 gammaCorrectOutput(vec3 color) {
		return color;
	}
#endif
`;

var gloss_default = `
#ifdef STD_GLOSS_CONSTANT
uniform float material_gloss;
#endif
void getGlossiness() {
	dGlossiness = 1.0;
	#ifdef STD_GLOSS_CONSTANT
	dGlossiness *= material_gloss;
	#endif
	#ifdef STD_GLOSS_TEXTURE
	dGlossiness *= texture2DBias({STD_GLOSS_TEXTURE_NAME}, {STD_GLOSS_TEXTURE_UV}, textureBias).{STD_GLOSS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_GLOSS_VERTEX
	dGlossiness *= saturate(vVertexColor.{STD_GLOSS_VERTEX_CHANNEL});
	#endif
	#ifdef STD_GLOSS_INVERT
	dGlossiness = 1.0 - dGlossiness;
	#endif
	dGlossiness += 0.0000001;
}
`;

var quad_default = `
	attribute vec2 aPosition;
	varying vec2 uv0;
	void main(void)
	{
		gl_Position = vec4(aPosition, 0.0, 1.0);
		uv0 = getImageEffectUV((aPosition.xy + 1.0) * 0.5);
	}
`;

var immediateLine_default = `
		#include "gammaPS"
		varying vec4 color;
		void main(void) {
			gl_FragColor = vec4(gammaCorrectOutput(decodeGamma(color.rgb)), color.a);
		}
`;

var immediateLine_default2 = `
	attribute vec4 vertex_position;
	attribute vec4 vertex_color;
	uniform mat4 matrix_model;
	uniform mat4 matrix_viewProjection;
	varying vec4 color;
	void main(void) {
		color = vertex_color;
		gl_Position = matrix_viewProjection * matrix_model * vertex_position;
	}
`;

var iridescenceDiffraction_default = `
uniform float material_iridescenceRefractionIndex;
float iridescence_iorToFresnel(float transmittedIor, float incidentIor) {
	return pow((transmittedIor - incidentIor) / (transmittedIor + incidentIor), 2.0);
}
vec3 iridescence_iorToFresnel(vec3 transmittedIor, float incidentIor) {
	return pow((transmittedIor - vec3(incidentIor)) / (transmittedIor + vec3(incidentIor)), vec3(2.0));
}
vec3 iridescence_fresnelToIor(vec3 f0) {
	vec3 sqrtF0 = sqrt(f0);
	return (vec3(1.0) + sqrtF0) / (vec3(1.0) - sqrtF0);
}
vec3 iridescence_sensitivity(float opd, vec3 shift) {
	float PI = 3.141592653589793;
	float phase = 2.0 * PI * opd * 1.0e-9;
	const vec3 val = vec3(5.4856e-13, 4.4201e-13, 5.2481e-13);
	const vec3 pos = vec3(1.6810e+06, 1.7953e+06, 2.2084e+06);
	const vec3 var = vec3(4.3278e+09, 9.3046e+09, 6.6121e+09);
	vec3 xyz = val * sqrt(2.0 * PI * var) * cos(pos * phase + shift) * exp(-pow(phase, 2.0) * var);
	xyz.x += 9.7470e-14 * sqrt(2.0 * PI * 4.5282e+09) * cos(2.2399e+06 * phase + shift[0]) * exp(-4.5282e+09 * pow(phase, 2.0));
	xyz /= vec3(1.0685e-07);
	const mat3 XYZ_TO_REC709 = mat3(
		3.2404542, -0.9692660,  0.0556434,
	   -1.5371385,  1.8760108, -0.2040259,
	   -0.4985314,  0.0415560,  1.0572252
	);
	return XYZ_TO_REC709 * xyz;
}
float iridescence_fresnel(float cosTheta, float f0) {
	float x = clamp(1.0 - cosTheta, 0.0, 1.0);
	float x2 = x * x;
	float x5 = x * x2 * x2;
	return f0 + (1.0 - f0) * x5;
} 
vec3 iridescence_fresnel(float cosTheta, vec3 f0) {
	float x = clamp(1.0 - cosTheta, 0.0, 1.0);
	float x2 = x * x;
	float x5 = x * x2 * x2; 
	return f0 + (vec3(1.0) - f0) * x5;
}
vec3 calcIridescence(float outsideIor, float cosTheta, vec3 base_f0, float iridescenceThickness) {
	float PI = 3.141592653589793;
	float iridescenceIor = mix(outsideIor, material_iridescenceRefractionIndex, smoothstep(0.0, 0.03, iridescenceThickness));
	float sinTheta2Sq = pow(outsideIor / iridescenceIor, 2.0) * (1.0 - pow(cosTheta, 2.0));
	float cosTheta2Sq = 1.0 - sinTheta2Sq;
	if (cosTheta2Sq < 0.0) {
		return vec3(1.0);
	}
	float cosTheta2 = sqrt(cosTheta2Sq);
	float r0 = iridescence_iorToFresnel(iridescenceIor, outsideIor);
	float r12 = iridescence_fresnel(cosTheta, r0);
	float r21 = r12;
	float t121 = 1.0 - r12;
	float phi12 = iridescenceIor < outsideIor ? PI : 0.0;
	float phi21 = PI - phi12;
	vec3 baseIor = iridescence_fresnelToIor(base_f0 + vec3(0.0001));
	vec3 r1 = iridescence_iorToFresnel(baseIor, iridescenceIor);
	vec3 r23 = iridescence_fresnel(cosTheta2, r1);
	vec3 phi23 = vec3(0.0);
	if (baseIor[0] < iridescenceIor) phi23[0] = PI;
	if (baseIor[1] < iridescenceIor) phi23[1] = PI;
	if (baseIor[2] < iridescenceIor) phi23[2] = PI;
	float opd = 2.0 * iridescenceIor * iridescenceThickness * cosTheta2;
	vec3 phi = vec3(phi21) + phi23; 
	vec3 r123Sq = clamp(r12 * r23, 1e-5, 0.9999);
	vec3 r123 = sqrt(r123Sq);
	vec3 rs = pow(t121, 2.0) * r23 / (1.0 - r123Sq);
	vec3 c0 = r12 + rs;
	vec3 i = c0;
	vec3 cm = rs - t121;
	for (int m = 1; m <= 2; m++) {
		cm *= r123;
		vec3 sm = 2.0 * iridescence_sensitivity(float(m) * opd, float(m) * phi);
		i += cm * sm;
	}
	return max(i, vec3(0.0));
}
vec3 getIridescence(float cosTheta, vec3 specularity, float iridescenceThickness) {
	return calcIridescence(1.0, cosTheta, specularity, iridescenceThickness);
}
`;

var iridescence_default = `
#ifdef STD_IRIDESCENCE_CONSTANT
uniform float material_iridescence;
#endif
void getIridescence() {
	float iridescence = 1.0;
	#ifdef STD_IRIDESCENCE_CONSTANT
	iridescence *= material_iridescence;
	#endif
	#ifdef STD_IRIDESCENCE_TEXTURE
	iridescence *= texture2DBias({STD_IRIDESCENCE_TEXTURE_NAME}, {STD_IRIDESCENCE_TEXTURE_UV}, textureBias).{STD_IRIDESCENCE_TEXTURE_CHANNEL};
	#endif
	dIridescence = iridescence; 
}
`;

var iridescenceThickness_default = `
uniform float material_iridescenceThicknessMax;
#ifdef STD_IRIDESCENCETHICKNESS_TEXTURE
uniform float material_iridescenceThicknessMin;
#endif
void getIridescenceThickness() {
	#ifdef STD_IRIDESCENCETHICKNESS_TEXTURE
		float blend = texture2DBias({STD_IRIDESCENCETHICKNESS_TEXTURE_NAME}, {STD_IRIDESCENCETHICKNESS_TEXTURE_UV}, textureBias).{STD_IRIDESCENCETHICKNESS_TEXTURE_CHANNEL};
		float iridescenceThickness = mix(material_iridescenceThicknessMin, material_iridescenceThicknessMax, blend);
	#else
		float iridescenceThickness = material_iridescenceThicknessMax;
	#endif
	dIridescenceThickness = iridescenceThickness; 
}
`;

var ior_default = `
#ifdef STD_IOR_CONSTANT
uniform float material_refractionIndex;
#endif
void getIor() {
#ifdef STD_IOR_CONSTANT
	dIor = material_refractionIndex;
#else
	dIor = 1.0 / 1.5;
#endif
}
`;

var lightDeclaration_default = `
#if defined(LIGHT{i})
	uniform vec3 light{i}_color;
	#if LIGHT{i}TYPE == DIRECTIONAL
		uniform vec3 light{i}_direction;
	#else
		#define LIT_CODE_LIGHTS_POINT
		uniform vec3 light{i}_position;
		uniform float light{i}_radius;
		#if LIGHT{i}TYPE == SPOT
			#define LIT_CODE_LIGHTS_SPOT
			uniform vec3 light{i}_direction;
			uniform float light{i}_innerConeAngle;
			uniform float light{i}_outerConeAngle;
		#endif
	#endif
	#if LIGHT{i}SHAPE != PUNCTUAL
		#define LIT_CODE_FALLOFF_SQUARED
		#if LIGHT{i}TYPE == DIRECTIONAL
			uniform vec3 light{i}_position;
		#endif
		uniform vec3 light{i}_halfWidth;
		uniform vec3 light{i}_halfHeight;
	#else
		#if LIGHT{i}FALLOFF == LINEAR
			#define LIT_CODE_FALLOFF_LINEAR
		#endif
		#if LIGHT{i}FALLOFF == INVERSESQUARED
			#define LIT_CODE_FALLOFF_SQUARED
		#endif
	#endif
	#if defined(LIGHT{i}CASTSHADOW)
		#if LIGHT{i}TYPE != OMNI
			uniform mat4 light{i}_shadowMatrix;
		#endif
		uniform float light{i}_shadowIntensity;
		uniform vec4 light{i}_shadowParams;
		#if LIGHT{i}SHADOWTYPE == PCSS_32F
			uniform float light{i}_shadowSearchArea;
			uniform vec4 light{i}_cameraParams;
			#if LIGHT{i}TYPE == DIRECTIONAL
				uniform vec4 light{i}_softShadowParams;
				uniform vec4 light{i}_shadowCascadeRadii;
			#endif
		#endif
		#if LIGHT{i}TYPE == DIRECTIONAL
			uniform mat4 light{i}_shadowMatrixPalette[4];
			uniform vec4 light{i}_shadowCascadeDistances;
			uniform int light{i}_shadowCascadeCount;
			uniform float light{i}_shadowCascadeBlend;
		#endif
		#if LIGHT{i}TYPE == OMNI
			#if defined(LIGHT{i}SHADOW_PCF)
				uniform samplerCubeShadow light{i}_shadowMap;
			#else
				uniform samplerCube light{i}_shadowMap;
			#endif
		#else
			#if defined(LIGHT{i}SHADOW_PCF)
				uniform sampler2DShadow light{i}_shadowMap;
			#else
				uniform sampler2D light{i}_shadowMap;
			#endif
		#endif
	#endif
	#if defined(LIGHT{i}COOKIE)
		#define LIT_CODE_COOKIE
		#if LIGHT{i}TYPE == OMNI
			uniform samplerCube light{i}_cookie;
			uniform float light{i}_cookieIntensity;
			uniform mat4 light{i}_shadowMatrix;
		#endif
		#if LIGHT{i}TYPE == SPOT
			uniform sampler2D light{i}_cookie;
			uniform float light{i}_cookieIntensity;
			#if !defined(LIGHT{i}CASTSHADOW)
				uniform mat4 light{i}_shadowMatrix;
			#endif
			#if defined(LIGHT{i}COOKIE_TRANSFORM)
				uniform vec4 light{i}_cookieMatrix;
				uniform vec2 light{i}_cookieOffset;
			#endif
		#endif
	#endif
#endif
`;

var lightDiffuseLambert_default = `
float getLightDiffuse(vec3 worldNormal, vec3 viewDir, vec3 lightDirNorm) {
	return max(dot(worldNormal, -lightDirNorm), 0.0);
}
`;

var lightDirPoint_default = `
vec3 evalOmniLight(vec3 lightPosW) {
	return vPositionW - lightPosW;
}
`;

var lightEvaluation_default = `
#if defined(LIGHT{i})
	evaluateLight{i}(
		#if defined(LIT_IRIDESCENCE)
			iridescenceFresnel
		#endif
	);
#endif
`;

var lightFunctionLight_default = `
#if defined(LIGHT{i})
void evaluateLight{i}(
	#if defined(LIT_IRIDESCENCE)
		vec3 iridescenceFresnel
	#endif
) {
	vec3 lightColor = light{i}_color;
	#if LIGHT{i}TYPE == DIRECTIONAL && !defined(LIT_SHADOW_CATCHER)
		if (all(equal(lightColor, vec3(0.0)))) {
			return;
		}
	#endif
	#if LIGHT{i}TYPE == DIRECTIONAL
		dLightDirNormW = light{i}_direction;
		dAtten = 1.0;
	#else
		
		vec3 lightDirW = evalOmniLight(light{i}_position);
		dLightDirNormW = normalize(lightDirW);
		#if defined(LIGHT{i}COOKIE)
			#if LIGHT{i}TYPE == SPOT
				#ifdef LIGHT{i}COOKIE_FALLOFF
					#ifdef LIGHT{i}COOKIE_TRANSFORM
						vec3 cookieAttenuation = getCookie2DXform(light{i}_cookie, light{i}_shadowMatrix, light{i}_cookieIntensity, light{i}_cookieMatrix, light{i}_cookieOffset).{LIGHT{i}COOKIE_CHANNEL};
					#else
						vec3 cookieAttenuation = getCookie2D(light{i}_cookie, light{i}_shadowMatrix, light{i}_cookieIntensity).{LIGHT{i}COOKIE_CHANNEL};
					#endif
				#else
					#ifdef LIGHT{i}COOKIE_TRANSFORM
						vec3 cookieAttenuation = getCookie2DClipXform(light{i}_cookie, light{i}_shadowMatrix, light{i}_cookieIntensity, light{i}_cookieMatrix, light{i}_cookieOffset).{LIGHT{i}COOKIE_CHANNEL};
					#else
						vec3 cookieAttenuation = getCookie2DClip(light{i}_cookie, light{i}_shadowMatrix, light{i}_cookieIntensity).{LIGHT{i}COOKIE_CHANNEL};
					#endif
				#endif
			#endif
			#if LIGHT{i}TYPE == OMNI
				vec3 cookieAttenuation = getCookieCube(light{i}_cookie, light{i}_shadowMatrix, light{i}_cookieIntensity).{LIGHT{i}COOKIE_CHANNEL};
			#endif
			lightColor *= cookieAttenuation;
		#endif
		#if LIGHT{i}SHAPE == PUNCTUAL
			#if LIGHT{i}FALLOFF == LINEAR
				dAtten = getFalloffLinear(light{i}_radius, lightDirW);
			#else
				dAtten = getFalloffInvSquared(light{i}_radius, lightDirW);
			#endif
		#else
			dAtten = getFalloffWindow(light{i}_radius, lightDirW);
		#endif
		#if LIGHT{i}TYPE == SPOT
			#if !defined(LIGHT{i}COOKIE) || defined(LIGHT{i}COOKIE_FALLOFF)
				dAtten *= getSpotEffect(light{i}_direction, light{i}_innerConeAngle, light{i}_outerConeAngle, dLightDirNormW);
			#endif
		#endif
	#endif
	if (dAtten < 0.00001) {
		return;
	}
	#if LIGHT{i}SHAPE != PUNCTUAL
		#if LIGHT{i}SHAPE == RECT
			calcRectLightValues(light{i}_position, light{i}_halfWidth, light{i}_halfHeight);
		#elif LIGHT{i}SHAPE == DISK
			calcDiskLightValues(light{i}_position, light{i}_halfWidth, light{i}_halfHeight);
		#elif LIGHT{i}SHAPE == SPHERE
			calcSphereLightValues(light{i}_position, light{i}_halfWidth, light{i}_halfHeight);
		#endif
	#endif
	#if LIGHT{i}SHAPE != PUNCTUAL
		#if LIGHT{i}TYPE == DIRECTIONAL
			float attenDiffuse = getLightDiffuse(litArgs_worldNormal, dViewDirW, dLightDirNormW);
		#else
			#if LIGHT{i}SHAPE == RECT
				float attenDiffuse = getRectLightDiffuse(litArgs_worldNormal, dViewDirW, lightDirW, dLightDirNormW) * 16.0;
			#elif LIGHT{i}SHAPE == DISK
				float attenDiffuse = getDiskLightDiffuse(litArgs_worldNormal, dViewDirW, lightDirW, dLightDirNormW) * 16.0;
			#elif LIGHT{i}SHAPE == SPHERE
				float attenDiffuse = getSphereLightDiffuse(litArgs_worldNormal, dViewDirW, lightDirW, dLightDirNormW) * 16.0;
			#endif
		#endif
	#else
		dAtten *= getLightDiffuse(litArgs_worldNormal, vec3(0.0), dLightDirNormW);
	#endif
	#ifdef LIGHT{i}CASTSHADOW
		#if LIGHT{i}TYPE == DIRECTIONAL
			float shadow = getShadow{i}(vec3(0.0));
		#else
			float shadow = getShadow{i}(lightDirW);
		#endif
		shadow = mix(1.0, shadow, light{i}_shadowIntensity);
		dAtten *= shadow;
		#if defined(LIT_SHADOW_CATCHER) && LIGHT{i}TYPE == DIRECTIONAL
			dShadowCatcher *= shadow;
		#endif			
	#endif
	#if LIGHT{i}SHAPE != PUNCTUAL
		#ifdef LIT_SPECULAR
			dDiffuseLight += ((attenDiffuse * dAtten) * lightColor) * (1.0 - dLTCSpecFres);
		#else
			dDiffuseLight += (attenDiffuse * dAtten) * lightColor;
		#endif						
	#else
		#if defined(AREA_LIGHTS) && defined(LIT_SPECULAR)
			dDiffuseLight += (dAtten * lightColor) * (1.0 - litArgs_specularity);
		#else
			dDiffuseLight += dAtten * lightColor;
		#endif
	#endif
	#ifdef LIGHT{i}AFFECT_SPECULARITY
		#if LIGHT{i}SHAPE != PUNCTUAL
			#ifdef LIT_CLEARCOAT
				#if LIGHT{i}SHAPE == RECT
					ccSpecularLight += ccLTCSpecFres * getRectLightSpecular(litArgs_clearcoat_worldNormal, dViewDirW) * dAtten * lightColor;
				#elif LIGHT{i}SHAPE == DISK
					ccSpecularLight += ccLTCSpecFres * getDiskLightSpecular(litArgs_clearcoat_worldNormal, dViewDirW) * dAtten * lightColor;
				#elif LIGHT{i}SHAPE == SPHERE
					ccSpecularLight += ccLTCSpecFres * getSphereLightSpecular(litArgs_clearcoat_worldNormal, dViewDirW) * dAtten * lightColor;
				#endif
			#endif
			#ifdef LIT_SPECULAR
				#if LIGHT{i}SHAPE == RECT
					dSpecularLight += dLTCSpecFres * getRectLightSpecular(litArgs_worldNormal, dViewDirW) * dAtten * lightColor;
				#elif LIGHT{i}SHAPE == DISK
					dSpecularLight += dLTCSpecFres * getDiskLightSpecular(litArgs_worldNormal, dViewDirW) * dAtten * lightColor;
				#elif LIGHT{i}SHAPE == SPHERE
					dSpecularLight += dLTCSpecFres * getSphereLightSpecular(litArgs_worldNormal, dViewDirW) * dAtten * lightColor;
				#endif
			#endif
		#else
			#if LIGHT{i}TYPE == DIRECTIONAL && LIT_FRESNEL_MODEL != NONE
				#define LIGHT{i}FRESNEL
			#endif
			#ifdef LIT_SPECULAR
				vec3 halfDirW = normalize(-dLightDirNormW + dViewDirW);
			#endif
			#ifdef LIT_CLEARCOAT
				vec3 lightspecularCC = getLightSpecular(halfDirW, ccReflDirW, litArgs_clearcoat_worldNormal, dViewDirW, dLightDirNormW, litArgs_clearcoat_gloss, dTBN) * dAtten * lightColor;
				#ifdef LIGHT{i}FRESNEL
					lightspecularCC *= getFresnelCC(dot(dViewDirW, halfDirW));
				#endif
				ccSpecularLight += lightspecularCC;
			#endif
			#ifdef LIT_SHEEN
				sSpecularLight += getLightSpecularSheen(halfDirW, litArgs_worldNormal, dViewDirW, dLightDirNormW, litArgs_sheen_gloss) * dAtten * lightColor;
			#endif
			#ifdef LIT_SPECULAR
				vec3 lightSpecular = getLightSpecular(halfDirW, dReflDirW, litArgs_worldNormal, dViewDirW, dLightDirNormW, litArgs_gloss, dTBN) * dAtten * lightColor;
				#ifdef LIGHT{i}FRESNEL
					#if defined(LIT_IRIDESCENCE)
						lightSpecular *= getFresnel(dot(dViewDirW, halfDirW), litArgs_gloss, litArgs_specularity, iridescenceFresnel, litArgs_iridescence_intensity);
					#else
						lightSpecular *= getFresnel(dot(dViewDirW, halfDirW), litArgs_gloss, litArgs_specularity);
					#endif
				#else
					lightSpecular *= litArgs_specularity;
				#endif
				
				dSpecularLight += lightSpecular;
			#endif
		#endif
	#endif
}
#endif
`;

var lightFunctionShadow_default = `
#ifdef LIGHT{i}CASTSHADOW
	#ifdef LIGHT{i}_SHADOW_SAMPLE_POINT
		vec3 getShadowSampleCoordOmni{i}(vec4 shadowParams, vec3 worldPosition, vec3 lightPos, inout vec3 lightDir, vec3 lightDirNorm, vec3 normal) {
			#ifdef LIGHT{i}_SHADOW_SAMPLE_NORMAL_OFFSET
				float distScale = length(lightDir);
				vec3 surfacePosition = worldPosition + normal * shadowParams.y * clamp(1.0 - dot(normal, -lightDirNorm), 0.0, 1.0) * distScale;
				lightDir = surfacePosition - lightPos;
			#endif
			return lightDir;
		}
	#endif
	#ifndef LIGHT{i}_SHADOW_SAMPLE_POINT
		vec3 getShadowSampleCoord{i}(mat4 shadowTransform, vec4 shadowParams, vec3 worldPosition, vec3 lightPos, inout vec3 lightDir, vec3 lightDirNorm, vec3 normal) {
			vec3 surfacePosition = worldPosition;
			#ifdef LIGHT{i}_SHADOW_SAMPLE_SOURCE_ZBUFFER
				#ifdef LIGHT{i}_SHADOW_SAMPLE_NORMAL_OFFSET
					surfacePosition = surfacePosition + normal * shadowParams.y;
				#endif
			#else
				#ifdef LIGHT{i}_SHADOW_SAMPLE_NORMAL_OFFSET
					#ifdef LIGHT{i}_SHADOW_SAMPLE_ORTHO
						float distScale = 1.0;
					#else
						float distScale = abs(dot(vPositionW - lightPos, lightDirNorm));
					#endif
					surfacePosition = surfacePosition + normal * shadowParams.y * clamp(1.0 - dot(normal, -lightDirNorm), 0.0, 1.0) * distScale;
				#endif
			#endif
			vec4 positionInShadowSpace = shadowTransform * vec4(surfacePosition, 1.0);
			#ifdef LIGHT{i}_SHADOW_SAMPLE_ORTHO
				positionInShadowSpace.z = saturate(positionInShadowSpace.z) - 0.0001;
			#else
				#ifdef LIGHT{i}_SHADOW_SAMPLE_SOURCE_ZBUFFER
					positionInShadowSpace.xyz /= positionInShadowSpace.w;
				#else
					positionInShadowSpace.xy /= positionInShadowSpace.w;
					positionInShadowSpace.z = length(lightDir) * shadowParams.w;
				#endif
			#endif
			return positionInShadowSpace.xyz;
		}
	#endif
	float getShadow{i}(vec3 lightDirW) {
		#if LIGHT{i}TYPE == OMNI
			vec3 shadowCoord = getShadowSampleCoordOmni{i}(light{i}_shadowParams, vPositionW, light{i}_position, lightDirW, dLightDirNormW, dVertexNormalW);
		#else
			#ifdef LIGHT{i}_SHADOW_CASCADES
				int cascadeIndex = getShadowCascadeIndex(light{i}_shadowCascadeDistances, light{i}_shadowCascadeCount);
				#ifdef LIGHT{i}_SHADOW_CASCADE_BLEND
					cascadeIndex = ditherShadowCascadeIndex(cascadeIndex, light{i}_shadowCascadeDistances, light{i}_shadowCascadeCount, light{i}_shadowCascadeBlend);
				#endif
				mat4 shadowMatrix = light{i}_shadowMatrixPalette[cascadeIndex];
			#else
				mat4 shadowMatrix = light{i}_shadowMatrix;
			#endif
			#if LIGHT{i}TYPE == DIRECTIONAL
				vec3 shadowCoord = getShadowSampleCoord{i}(shadowMatrix, light{i}_shadowParams, vPositionW, vec3(0.0), lightDirW, dLightDirNormW, dVertexNormalW);
			#else
				vec3 shadowCoord = getShadowSampleCoord{i}(shadowMatrix, light{i}_shadowParams, vPositionW, light{i}_position, lightDirW, dLightDirNormW, dVertexNormalW);
			#endif
		#endif
		#if LIGHT{i}TYPE == DIRECTIONAL
			shadowCoord = fadeShadow(shadowCoord, light{i}_shadowCascadeDistances);
		#endif
		#if LIGHT{i}TYPE == DIRECTIONAL
			#if LIGHT{i}SHADOWTYPE == VSM_16F
				return getShadowVSM16(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, 5.54);
			#endif
			#if LIGHT{i}SHADOWTYPE == VSM_32F
				return getShadowVSM32(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, 15.0);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCSS_32F
				#if LIGHT{i}SHAPE != PUNCTUAL
					vec2 shadowSearchArea = vec2(length(light{i}_halfWidth), length(light{i}_halfHeight)) * light{i}_shadowSearchArea;
					return getShadowPCSS(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, light{i}_cameraParams, shadowSearchArea, lightDirW);
				#else
					vec4 pcssCameraParams = light{i}_cameraParams;
					#ifdef LIGHT{i}_SHADOW_CASCADES
						pcssCameraParams.x = light{i}_shadowCascadeRadii[cascadeIndex];
					#endif
					return getShadowPCSS(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, pcssCameraParams, light{i}_softShadowParams, lightDirW);
				#endif
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF1_16F || LIGHT{i}SHADOWTYPE == PCF1_32F
				return getShadowPCF1x1(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF3_16F || LIGHT{i}SHADOWTYPE == PCF3_32F
				return getShadowPCF3x3(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF5_16F || LIGHT{i}SHADOWTYPE == PCF5_32F
				return getShadowPCF5x5(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams);
			#endif
		#endif
		#if LIGHT{i}TYPE == SPOT
			#if LIGHT{i}SHADOWTYPE == VSM_16F
				return getShadowSpotVSM16(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, 5.54, lightDirW);
			#endif
			#if LIGHT{i}SHADOWTYPE == VSM_32F
				return getShadowSpotVSM32(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, 15.0, lightDirW);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCSS_32F
				#if LIGHT{i}SHAPE != PUNCTUAL
					vec2 shadowSearchArea = vec2(length(light{i}_halfWidth), length(light{i}_halfHeight)) * light{i}_shadowSearchArea;
				#else
					vec2 shadowSearchArea = vec2(light{i}_shadowSearchArea);
				#endif
				return getShadowSpotPCSS(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, light{i}_cameraParams, shadowSearchArea, lightDirW);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF1_16F || LIGHT{i}SHADOWTYPE == PCF1_32F
				return getShadowSpotPCF1x1(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF3_16F || LIGHT{i}SHADOWTYPE == PCF3_32F
				return getShadowSpotPCF3x3(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF5_16F || LIGHT{i}SHADOWTYPE == PCF5_32F
				return getShadowSpotPCF5x5(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams);
			#endif
		#endif
		#if LIGHT{i}TYPE == OMNI
			#if LIGHT{i}SHADOWTYPE == PCSS_32F
				#if LIGHT{i}SHAPE != PUNCTUAL
					vec2 shadowSearchArea = vec2(length(light{i}_halfWidth), length(light{i}_halfHeight)) * light{i}_shadowSearchArea;
				#else
					vec2 shadowSearchArea = vec2(light{i}_shadowSearchArea);
				#endif
				return getShadowOmniPCSS(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, light{i}_cameraParams, shadowSearchArea, lightDirW);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF1_16F || LIGHT{i}SHADOWTYPE == PCF1_32F
				return getShadowOmniPCF1x1(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, lightDirW);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF3_16F || LIGHT{i}SHADOWTYPE == PCF3_32F
				return getShadowOmniPCF3x3(SHADOWMAP_PASS(light{i}_shadowMap), shadowCoord, light{i}_shadowParams, lightDirW);
			#endif
		#endif
	}
#endif
`;

var lighting_default = `
#ifdef LIT_CLUSTERED_LIGHTS
	#define LIT_CODE_FALLOFF_LINEAR
	#define LIT_CODE_FALLOFF_SQUARED
	#define LIT_CODE_LIGHTS_POINT
	#define LIT_CODE_LIGHTS_SPOT
#endif
#ifdef AREA_LIGHTS
	uniform highp sampler2D areaLightsLutTex1;
	uniform highp sampler2D areaLightsLutTex2;
#endif
#ifdef LIT_LIGHTING
	#include "lightDiffuseLambertPS"
	#if defined(AREA_LIGHTS) || defined(LIT_CLUSTERED_AREA_LIGHTS)
		#include "ltcPS"
	#endif
#endif
#ifdef SHADOW_DIRECTIONAL
	#include "shadowCascadesPS"
#endif
#if defined(SHADOW_KIND_PCF1)
	#include "shadowPCF1PS"
#endif
#if defined(SHADOW_KIND_PCF3)
	#include "shadowPCF3PS"
#endif
#if defined(SHADOW_KIND_PCF5)
	#include "shadowPCF5PS"
#endif
#if defined(SHADOW_KIND_PCSS)
	#include "linearizeDepthPS"
	#include "shadowPCSSPS"
	#include "shadowSoftPS"
#endif
#if defined(SHADOW_KIND_VSM)
	#include "shadowEVSMPS"
#endif
#ifdef LIT_CODE_FALLOFF_LINEAR
	#include "falloffLinearPS"
#endif
#ifdef LIT_CODE_FALLOFF_SQUARED
	#include "falloffInvSquaredPS"
#endif
#ifdef LIT_CODE_LIGHTS_POINT
	#include "lightDirPointPS"
#endif
#ifdef LIT_CODE_LIGHTS_SPOT
	#include "spotPS"
#endif
#ifdef LIT_CODE_COOKIE
	#include "cookiePS"
#endif
#ifdef LIT_CLUSTERED_LIGHTS
	#include "clusteredLightPS"
#endif
#ifdef LIGHT_COUNT > 0
	#include "lightFunctionShadowPS, LIGHT_COUNT"
	#include "lightFunctionLightPS, LIGHT_COUNT"
#endif
`;

var lightmapAdd_default = `
void addLightMap(
	vec3 lightmap, 
	vec3 dir, 
	vec3 worldNormal, 
	vec3 viewDir, 
	vec3 reflectionDir, 
	float gloss, 
	vec3 specularity, 
	vec3 vertexNormal, 
	mat3 tbn
#if defined(LIT_IRIDESCENCE)
	vec3 iridescenceFresnel, 
	float iridescenceIntensity
#endif
) {
	#if defined(LIT_SPECULAR) && defined(LIT_DIR_LIGHTMAP)
		if (dot(dir, dir) < 0.0001) {
				dDiffuseLight += lightmap;
		} else {
			float vlight = saturate(dot(dir, -vertexNormal));
			float flight = saturate(dot(dir, -worldNormal));
			float nlight = (flight / max(vlight, 0.01)) * 0.5;
			dDiffuseLight += lightmap * nlight * 2.0;
			vec3 halfDir = normalize(-dir + viewDir);
			vec3 specularLight = lightmap * getLightSpecular(halfDir, reflectionDir, worldNormal, viewDir, dir, gloss, tbn);
			#ifdef LIT_SPECULAR_FRESNEL
				specularLight *= 
					getFresnel(dot(viewDir, halfDir), 
					gloss, 
					specularity
				#if defined(LIT_IRIDESCENCE)
					, iridescenceFresnel,
					iridescenceIntensity
				#endif
					);
			#endif
			dSpecularLight += specularLight;
		}
	#else
		dDiffuseLight += lightmap;
	#endif
}
`;

var lightmap_default = `
#ifdef STD_LIGHTMAP_DIR
	vec3 dLightmapDir;
	uniform sampler2D texture_dirLightMap;
#endif
void getLightMap() {
	dLightmap = vec3(1.0);
	#ifdef STD_LIGHT_TEXTURE
		dLightmap *= {STD_LIGHT_TEXTURE_DECODE}(texture2DBias({STD_LIGHT_TEXTURE_NAME}, {STD_LIGHT_TEXTURE_UV}, textureBias)).{STD_LIGHT_TEXTURE_CHANNEL};
		#ifdef STD_LIGHTMAP_DIR
			vec3 dir = texture2DBias(texture_dirLightMap, {STD_LIGHT_TEXTURE_UV}, textureBias).xyz * 2.0 - 1.0;
			float dirDot = dot(dir, dir);
			dLightmapDir = (dirDot > 0.001) ? dir / sqrt(dirDot) : vec3(0.0);
		#endif
	#endif
	#ifdef STD_LIGHT_VERTEX
		dLightmap *= saturate(vVertexColor.{STD_LIGHT_VERTEX_CHANNEL});
	#endif
}
`;

var lightSpecularAnisoGGX_default = `
float calcLightSpecular(float gloss, vec3 worldNormal, vec3 viewDir, vec3 h, vec3 lightDirNorm, mat3 tbn) {
	float PI = 3.141592653589793;
	float roughness = max((1.0 - gloss) * (1.0 - gloss), 0.001);
	float alphaRoughness = roughness * roughness;
	float anisotropy = dAnisotropy;
	vec2 direction = dAnisotropyRotation;
	float at = mix(alphaRoughness, 1.0, anisotropy * anisotropy);
	float ab = clamp(alphaRoughness, 0.001, 1.0);
	vec3 anisotropicT = normalize(tbn * vec3(direction, 0.0));
	vec3 anisotropicB = normalize(cross(tbn[2], anisotropicT));
	float NoH = dot(worldNormal, h);
	float ToH = dot(anisotropicT, h);
	float BoH = dot(anisotropicB, h);
	float a2 = at * ab;
	vec3 v = vec3(ab * ToH, at * BoH, a2 * NoH);
	float v2 = dot(v, v);
	float w2 = a2 / v2;
	float D = a2 * w2 * w2 * (1.0 / PI);
	float ToV = dot(anisotropicT, viewDir);
	float BoV = dot(anisotropicB, viewDir);
	float ToL = dot(anisotropicT, -lightDirNorm);
	float BoL = dot(anisotropicB, -lightDirNorm);
	float NoV = dot(worldNormal, viewDir);
	float NoL = dot(worldNormal, -lightDirNorm);
	float lambdaV = NoL * length(vec3(at * ToV, ab * BoV, NoV));
	float lambdaL = NoV * length(vec3(at * ToL, ab * BoL, NoL));
	float G = 0.5 / (lambdaV + lambdaL);
	return D * G;
}
float getLightSpecular(vec3 h, vec3 reflDir, vec3 worldNormal, vec3 viewDir, vec3 lightDirNorm, float gloss, mat3 tbn) {
	return calcLightSpecular(gloss, worldNormal, viewDir, h, lightDirNorm, tbn);
}
`;

var lightSpecularGGX_default = `
float calcLightSpecular(float gloss, vec3 worldNormal, vec3 viewDir, vec3 h, vec3 lightDirNorm) {
	const float PI = 3.141592653589793;
	float roughness = max((1.0 - gloss) * (1.0 - gloss), 0.001);
	float alpha = roughness * roughness;
	float NoH = max(dot(worldNormal, h), 0.0);
	float NoV = max(dot(worldNormal, viewDir), 0.0);
	float NoL = max(dot(worldNormal, -lightDirNorm), 0.0);
	float NoH2 = NoH * NoH;
	float denom = NoH2 * (alpha - 1.0) + 1.0;
	float D = alpha / (PI * denom * denom);
	float alpha2 = alpha * alpha;
	float lambdaV = NoL * sqrt(NoV * NoV * (1.0 - alpha2) + alpha2);
	float lambdaL = NoV * sqrt(NoL * NoL * (1.0 - alpha2) + alpha2);
	float G = 0.5 / max(lambdaV + lambdaL, 0.00001);
	return D * G;
}
float getLightSpecular(vec3 h, vec3 reflDir, vec3 worldNormal, vec3 viewDir, vec3 lightDirNorm, float gloss, mat3 tbn) {
	return calcLightSpecular(gloss, worldNormal, viewDir, h, lightDirNorm);
}
`;

var lightSpecularBlinn_default = `
float calcLightSpecular(float gloss, vec3 worldNormal, vec3 h) {
	float nh = max( dot( h, worldNormal ), 0.0 );
	float specPow = exp2(gloss * 11.0);
	specPow = max(specPow, 0.0001);
	return pow(nh, specPow) * (specPow + 2.0) / 8.0;
}
float getLightSpecular(vec3 h, vec3 reflDir, vec3 worldNormal, vec3 viewDir, vec3 lightDirNorm, float gloss, mat3 tbn) {
	return calcLightSpecular(gloss, worldNormal, h);
}
`;

var lightSheen_default = `
float sheenD(vec3 normal, vec3 h, float roughness) {
	const float PI = 3.141592653589793;
	float invR = 1.0 / (roughness * roughness);
	float cos2h = max(dot(normal, h), 0.0);
	cos2h *= cos2h;
	float sin2h = max(1.0 - cos2h, 0.0078125);
	return (2.0 + invR) * pow(sin2h, invR * 0.5) / (2.0 * PI);
}
float sheenV(vec3 normal, vec3 viewDir, vec3 light) {
	float NoV = max(dot(normal, viewDir), 0.000001);
	float NoL = max(dot(normal, light), 0.000001);
	return 1.0 / (4.0 * (NoL + NoV - NoL * NoV));
}
float getLightSpecularSheen(vec3 h, vec3 worldNormal, vec3 viewDir, vec3 lightDirNorm, float sheenGloss) {
	float D = sheenD(worldNormal, h, sheenGloss);
	float V = sheenV(worldNormal, viewDir, -lightDirNorm);
	return D * V;
}
`;

var linearizeDepth_default = `
#ifndef LINEARIZE_DEPTH
#define LINEARIZE_DEPTH
float linearizeDepthWithParams(float z, vec4 cameraParams) {
	if (cameraParams.w == 0.0)
		return (cameraParams.z * cameraParams.y) / (cameraParams.y + z * (cameraParams.z - cameraParams.y));
	else
		return cameraParams.z + z * (cameraParams.y - cameraParams.z);
}
#ifndef CAMERAPLANES
	#define CAMERAPLANES
	uniform vec4 camera_params;
#endif
float linearizeDepth(float z) {
	return linearizeDepthWithParams(z, camera_params);
}
#endif
`;

var litForwardBackend_default = `
void evaluateBackend() {
	#ifdef LIT_SSAO
		litArgs_ao *= texture2DLod(ssaoTexture, gl_FragCoord.xy * ssaoTextureSizeInv, 0.0).r;
	#endif
	#ifdef LIT_NEEDS_NORMAL
		#ifdef LIT_SPECULAR
			getReflDir(litArgs_worldNormal, dViewDirW, litArgs_gloss, dTBN);
		#endif
		#ifdef LIT_CLEARCOAT
			ccReflDirW = normalize(-reflect(dViewDirW, litArgs_clearcoat_worldNormal));
		#endif
	#endif
	#ifdef LIT_SPECULAR_OR_REFLECTION
		#ifdef LIT_METALNESS
			float f0 = 1.0 / litArgs_ior;
			f0 = (f0 - 1.0) / (f0 + 1.0);
			f0 *= f0;
			#ifdef LIT_SPECULARITY_FACTOR
				litArgs_specularity = getSpecularModulate(litArgs_specularity, litArgs_albedo, litArgs_metalness, f0, litArgs_specularityFactor);
			#else
				litArgs_specularity = getSpecularModulate(litArgs_specularity, litArgs_albedo, litArgs_metalness, f0, 1.0);
			#endif
			litArgs_albedo = getAlbedoModulate(litArgs_albedo, litArgs_metalness);
		#endif
		#ifdef LIT_IRIDESCENCE
			vec3 iridescenceFresnel = getIridescence(saturate(dot(dViewDirW, litArgs_worldNormal)), litArgs_specularity, litArgs_iridescence_thickness);
		#endif
	#endif
	#ifdef LIT_ADD_AMBIENT
		addAmbient(litArgs_worldNormal);
		#ifdef LIT_SPECULAR
			dDiffuseLight = dDiffuseLight * (1.0 - litArgs_specularity);
		#endif
		#ifdef LIT_SEPARATE_AMBIENT
			vec3 dAmbientLight = dDiffuseLight;
			dDiffuseLight = vec3(0);
		#endif
	#endif
	#ifndef LIT_OLD_AMBIENT
		dDiffuseLight *= material_ambient;
	#endif
	#ifdef LIT_AO
		#ifndef LIT_OCCLUDE_DIRECT
			occludeDiffuse(litArgs_ao);
		#endif
	#endif
	#ifdef LIT_LIGHTMAP
		addLightMap(
			litArgs_lightmap, 
			litArgs_lightmapDir, 
			litArgs_worldNormal, 
			dViewDirW, 
			dReflDirW, 
			litArgs_gloss, 
			litArgs_specularity, 
			dVertexNormalW,
			dTBN
		#if defined(LIT_IRIDESCENCE)
			, iridescenceFresnel,
			litArgs_iridescence_intensity
		#endif
		);
	#endif
	#ifdef LIT_LIGHTING || LIT_REFLECTIONS
		#ifdef LIT_REFLECTIONS
			#ifdef LIT_CLEARCOAT
				addReflectionCC(ccReflDirW, litArgs_clearcoat_gloss);
			
				#ifdef LIT_SPECULAR_FRESNEL
					ccFresnel = getFresnelCC(dot(dViewDirW, litArgs_clearcoat_worldNormal));
					ccReflection *= ccFresnel;
				#else
					ccFresnel = 0.0;
				#endif
			#endif
			#ifdef LIT_SPECULARITY_FACTOR
				ccReflection *= litArgs_specularityFactor;
			#endif
			#ifdef LIT_SHEEN
				addReflectionSheen(litArgs_worldNormal, dViewDirW, litArgs_sheen_gloss);
			#endif
			addReflection(dReflDirW, litArgs_gloss);
			#ifdef LIT_FRESNEL_MODEL
				dReflection.rgb *= getFresnel(
					dot(dViewDirW, litArgs_worldNormal), 
					litArgs_gloss, 
					litArgs_specularity
				#if defined(LIT_IRIDESCENCE)
					, iridescenceFresnel,
					litArgs_iridescence_intensity
				#endif
					);
			#else
				dReflection.rgb *= litArgs_specularity;
			#endif
		#endif
		#ifdef AREA_LIGHTS
			dSpecularLight *= litArgs_specularity;
			#ifdef LIT_SPECULAR
				calcLTCLightValues(litArgs_gloss, litArgs_worldNormal, dViewDirW, litArgs_specularity, litArgs_clearcoat_gloss, litArgs_clearcoat_worldNormal, litArgs_clearcoat_specularity);
			#endif
		#endif
		
		#ifdef LIGHT_COUNT > 0
			#include "lightEvaluationPS, LIGHT_COUNT"
		#endif
		#ifdef LIT_CLUSTERED_LIGHTS
			addClusteredLights(litArgs_worldNormal, dViewDirW, dReflDirW,
				#if defined(LIT_CLEARCOAT)
						ccReflDirW,
				#endif
						litArgs_gloss, litArgs_specularity, dVertexNormalW, dTBN, 
				#if defined(LIT_IRIDESCENCE)
						iridescenceFresnel,
				#endif
						litArgs_clearcoat_worldNormal, litArgs_clearcoat_gloss, litArgs_sheen_gloss, litArgs_iridescence_intensity
			);
		#endif
		#ifdef AREA_LIGHTS
			#ifdef LIT_CLEARCOAT
				litArgs_clearcoat_specularity = 1.0;
			#endif
			#ifdef LIT_SPECULAR
				litArgs_specularity = vec3(1);
			#endif
		#endif
		#ifdef LIT_REFRACTION
			addRefraction(
				litArgs_worldNormal, 
				dViewDirW, 
				litArgs_thickness, 
				litArgs_gloss, 
				litArgs_specularity, 
				litArgs_albedo, 
				litArgs_transmission,
				litArgs_ior,
				litArgs_dispersion
				#if defined(LIT_IRIDESCENCE)
					, iridescenceFresnel, 
					litArgs_iridescence_intensity
				#endif
			);
		#endif
	#endif
	#ifdef LIT_AO
		#ifdef LIT_OCCLUDE_DIRECT
			occludeDiffuse(litArgs_ao);
		#endif
		#if LIT_OCCLUDE_SPECULAR != NONE
			occludeSpecular(litArgs_gloss, litArgs_ao, litArgs_worldNormal, dViewDirW);
		#endif
	#endif
	#if !defined(LIT_OPACITY_FADES_SPECULAR)
		#if LIT_BLEND_TYPE == NORMAL || LIT_BLEND_TYPE == PREMULTIPLIED
			float specLum = dot((dSpecularLight + dReflection.rgb * dReflection.a), vec3( 0.2126, 0.7152, 0.0722 ));
			#ifdef LIT_CLEARCOAT
				specLum += dot(ccSpecularLight * litArgs_clearcoat_specularity + ccReflection * litArgs_clearcoat_specularity, vec3( 0.2126, 0.7152, 0.0722 ));
			#endif
			litArgs_opacity = clamp(litArgs_opacity + gammaCorrectInput(specLum), 0.0, 1.0);
		#endif
		litArgs_opacity *= material_alphaFade;
	#endif
	#ifdef LIT_LIGHTMAP_BAKING
		#ifdef LIT_LIGHTMAP_BAKING_COLOR
			#include "bakeLmEndPS"
		#endif
		#ifdef LIT_LIGHTMAP_BAKING_DIR
			#include "bakeDirLmEndPS"
		#endif
	#else
		#include "endPS"
		#include "outputAlphaPS"
	#endif
	#ifdef LIT_MSDF
		gl_FragColor = applyMsdf(gl_FragColor);
	#endif
	#include "outputPS"
	#include "debugOutputPS"
	#ifdef LIT_SHADOW_CATCHER
		gl_FragColor.rgb = vec3(dShadowCatcher);
	#endif
	#include "outlineOutputPS"
}
`;

var litForwardDeclaration_default = `
vec3 sReflection;
vec3 dVertexNormalW;
vec3 dTangentW;
vec3 dBinormalW;
vec3 dViewDirW;
vec3 dReflDirW;
vec3 ccReflDirW;
vec3 dLightDirNormW;
float dAtten;
mat3 dTBN;
vec4 dReflection;
vec3 dDiffuseLight;
vec3 dSpecularLight;
float ccFresnel;
vec3 ccReflection;
vec3 ccSpecularLight;
float ccSpecularityNoFres;
vec3 sSpecularLight;
#ifdef LIT_DISPERSION
	uniform float material_dispersion;
#endif
#ifndef LIT_OPACITY_FADES_SPECULAR
	uniform float material_alphaFade;
#endif
#ifdef LIT_SSAO
	uniform sampler2D ssaoTexture;
	uniform vec2 ssaoTextureSizeInv;
#endif
#ifdef LIT_SHADOW_CATCHER
	float dShadowCatcher = 1.0;
#endif
#if LIGHT_COUNT > 0
	#include "lightDeclarationPS, LIGHT_COUNT"
#endif
#ifdef LIT_SPECULAR
	#if LIT_FRESNEL_MODEL == NONE && !defined(LIT_REFLECTIONS) && !defined(LIT_DIFFUSE_MAP) 
		#define LIT_OLD_AMBIENT
	#endif
#endif
#ifdef STD_LIGHTMAP_DIR
	uniform float bakeDir;
#endif
#ifdef LIT_LIGHTMAP_BAKING_ADD_AMBIENT
	uniform float ambientBakeOcclusionContrast;
	uniform float ambientBakeOcclusionBrightness;
#endif
`;

var litForwardMain_default = `
void main(void) {
	#include "litUserMainStartPS"
	dReflection = vec4(0);
	#ifdef LIT_CLEARCOAT
		ccSpecularLight = vec3(0);
		ccReflection = vec3(0);
	#endif
	#if LIT_NONE_SLICE_MODE == SLICED
		#include "startNineSlicedPS"
	#elif LIT_NONE_SLICE_MODE == TILED
		#include "startNineSlicedTiledPS"
	#endif
	#ifdef LIT_NEEDS_NORMAL
		dVertexNormalW = normalize(vNormalW);
		#ifdef LIT_TANGENTS
			#if defined(LIT_HEIGHTS) || defined(LIT_USE_NORMALS) || defined(LIT_USE_CLEARCOAT_NORMALS) || defined(LIT_GGX_SPECULAR)
				dTangentW = vTangentW;
				dBinormalW = vBinormalW;
			#endif
		#endif
		getViewDir();
		#ifdef LIT_TBN
			getTBN(dTangentW, dBinormalW, dVertexNormalW);
			#ifdef LIT_TWO_SIDED_LIGHTING
				handleTwoSidedLighting();
			#endif
		#endif
	#endif
	evaluateFrontend();
	#include "debugProcessFrontendPS"
	evaluateBackend();
	#include "litUserMainEndPS"
}
`;

var litForwardPostCode_default = `
#ifdef LIT_NEEDS_NORMAL
	#include "cubeMapRotatePS"
	#include "cubeMapProjectPS"
	#include "envProcPS"
#endif
#ifdef LIT_SPECULAR_OR_REFLECTION
	#ifdef LIT_METALNESS
		#include "metalnessModulatePS"
	#endif
	#ifdef LIT_IRIDESCENCE
		#include "iridescenceDiffractionPS"
	#endif
#endif
#if defined(LIT_SPECULAR_OR_REFLECTION) || defined(LIT_REFRACTION)
	#if LIT_FRESNEL_MODEL == SCHLICK
		#include "fresnelSchlickPS"
	#endif
#endif
#ifdef LIT_AO
	#include "aoDiffuseOccPS"
	#include "aoSpecOccPS"
#endif
#if LIT_REFLECTION_SOURCE == ENVATLASHQ
	#include "envAtlasPS"
	#include "reflectionEnvHQPS"
#elif LIT_REFLECTION_SOURCE == ENVATLAS
	#include "envAtlasPS"
	#include "reflectionEnvPS"
#elif LIT_REFLECTION_SOURCE == CUBEMAP
	#include "reflectionCubePS"
#elif LIT_REFLECTION_SOURCE == SPHEREMAP
	#include "reflectionSpherePS"
#endif
#ifdef LIT_REFLECTIONS
	#ifdef LIT_CLEARCOAT
		#include "reflectionCCPS"
	#endif
	#ifdef LIT_SHEEN
		#include "reflectionSheenPS"
	#endif
#endif
#ifdef LIT_REFRACTION
	#if defined(LIT_DYNAMIC_REFRACTION)
		#include "refractionDynamicPS"
	#elif defined(LIT_REFLECTIONS)
		#include "refractionCubePS"
	#endif
#endif
#ifdef LIT_SHEEN
	#include "lightSheenPS"
#endif
uniform vec3 material_ambient;
#ifdef LIT_SPECULAR
	#ifdef LIT_LIGHTING
		#ifdef LIT_GGX_SPECULAR
			#ifdef LIT_ANISOTROPY
				#include "lightSpecularAnisoGGXPS"
			#else
				#include "lightSpecularGGXPS"
			#endif
		#else
			#include "lightSpecularBlinnPS"
		#endif
	#endif
#endif
#include "combinePS"
#ifdef LIT_LIGHTMAP
	#include "lightmapAddPS"
#endif
#ifdef LIT_ADD_AMBIENT
	#include "ambientPS"
#endif
#ifdef LIT_MSDF
	#include "msdfPS"
#endif
#ifdef LIT_NEEDS_NORMAL
	#include "viewDirPS"
	#ifdef LIT_SPECULAR
		#ifdef LIT_ANISOTROPY
			#include "reflDirAnisoPS"
		#else
			#include "reflDirPS"
		#endif
	#endif
#endif
#include "lightingPS"
`;

var litForwardPreCode_default = `
#include "basePS"
#include "sphericalPS"
#include "decodePS"
#include "gammaPS"
#include "tonemappingPS"
#include "fogPS"
#if LIT_NONE_SLICE_MODE == SLICED
	#include "baseNineSlicedPS"
#elif LIT_NONE_SLICE_MODE == TILED
	#include "baseNineSlicedTiledPS"
#endif
#ifdef LIT_TBN
	#include "TBNPS"
	#ifdef LIT_TWO_SIDED_LIGHTING
		#include "twoSidedLightingPS"
	#endif
#endif
`;

var litMain_default = `
#include "varyingsPS"
#include "litUserDeclarationPS"
#include "frontendDeclPS"
#include "outlineDeclarationPS"
#if defined(PICK_PASS) || defined(PREPASS_PASS)
	#include "frontendCodePS"
	#include "litUserCodePS"
	#include "litOtherMainPS"
#elif defined(SHADOW_PASS)
	#include "frontendCodePS"
	#include "litUserCodePS"
	#include "litShadowMainPS"
#else
	#include "litForwardDeclarationPS"
	#include "litForwardPreCodePS"
	#include "frontendCodePS"
	#include "litForwardPostCodePS"
	#include "litForwardBackendPS"
	#include "litUserCodePS"
	#include "litForwardMainPS"
#endif
`;

var litMain_default2 = `
#include "varyingsVS"
#include  "litUserDeclarationVS"
#ifdef VERTEX_COLOR
	attribute vec4 vertex_color;
#endif
#ifdef NINESLICED
	varying vec2 vMask;
	varying vec2 vTiledUv;
	uniform mediump vec4 innerOffset;
	uniform mediump vec2 outerScale;
	uniform mediump vec4 atlasRect;
#endif
vec3 dPositionW;
mat4 dModelMatrix;
#include "transformCoreVS"
#ifdef UV0
	attribute vec2 vertex_texCoord0;
	#include "uv0VS"
#endif
#ifdef UV1
	attribute vec2 vertex_texCoord1;
	#include "uv1VS"
#endif
#ifdef LINEAR_DEPTH
	#ifndef VIEWMATRIX
	#define VIEWMATRIX
		uniform mat4 matrix_view;
	#endif
#endif
#include "transformVS"
#ifdef NORMALS
	#include "normalCoreVS"
	#include "normalVS"
#endif
#ifdef TANGENTS
	attribute vec4 vertex_tangent;
#endif
#include "uvTransformUniformsPS, UV_TRANSFORMS_COUNT"
#ifdef MSDF
	#include "msdfVS"
#endif
#include  "litUserCodeVS"
#ifdef VERTEX_COLOR
	vec3 decodeGamma(vec3 raw) {
		return pow(raw, vec3(2.2));
	}
	vec4 gammaCorrectInput(vec4 color) {
		return vec4(decodeGamma(color.xyz), color.w);
	}
#endif
void main(void) {
	#include "litUserMainStartVS"
	gl_PointSize = 1.0;
	gl_Position = getPosition();
	vPositionW = getWorldPosition();
	#ifdef NORMALS
		vNormalW = getNormal();
	#endif
	#ifdef TANGENTS
		vTangentW = normalize(dNormalMatrix * vertex_tangent.xyz);
		vBinormalW = cross(vNormalW, vTangentW) * vertex_tangent.w;
	#elif defined(GGX_SPECULAR)
		vObjectSpaceUpW = normalize(dNormalMatrix * vec3(0, 1, 0));
	#endif
	#ifdef UV0
		vec2 uv0 = getUv0();
		#ifdef UV0_UNMODIFIED
			vUv0 = uv0;
		#endif
	#endif
	#ifdef UV1
		vec2 uv1 = getUv1();
		#ifdef UV1_UNMODIFIED
			vUv1 = uv1;
		#endif
	#endif
	#include "uvTransformVS, UV_TRANSFORMS_COUNT"
	#ifdef VERTEX_COLOR
		#ifdef STD_VERTEX_COLOR_GAMMA
			vVertexColor = gammaCorrectInput(vertex_color);
		#else
			vVertexColor = vertex_color;
		#endif
	#endif
	#ifdef LINEAR_DEPTH
		vLinearDepth = -(matrix_view * vec4(vPositionW, 1.0)).z;
	#endif
	#ifdef MSDF
		unpackMsdfParams();
	#endif
	#include "litUserMainEndVS"
}
`;

var litOtherMain_default = `
#ifdef PICK_PASS
	#include "pickPS"
#endif
#ifdef PREPASS_PASS
	#include "floatAsUintPS"
#endif
void main(void) {
	#include "litUserMainStartPS"
	evaluateFrontend();
	#ifdef PICK_PASS
		pcFragColor0 = getPickOutput();
		#ifdef DEPTH_PICK_PASS
			pcFragColor1 = getPickDepth();
		#endif
	#endif
	#ifdef PREPASS_PASS
		gl_FragColor = float2vec4(vLinearDepth);
	#endif
	#include "litUserMainEndPS"
}
`;

var litShaderArgs_default = `
vec3 litArgs_albedo;
float litArgs_opacity;
vec3 litArgs_emission;
vec3 litArgs_worldNormal;
float litArgs_ao;
vec3 litArgs_lightmap;
vec3 litArgs_lightmapDir;
float litArgs_metalness;
vec3 litArgs_specularity;
float litArgs_specularityFactor;
float litArgs_gloss;
float litArgs_sheen_gloss;
vec3 litArgs_sheen_specularity;
float litArgs_transmission;
float litArgs_thickness;
float litArgs_ior;
float litArgs_dispersion;
float litArgs_iridescence_intensity;
float litArgs_iridescence_thickness;
vec3 litArgs_clearcoat_worldNormal;
float litArgs_clearcoat_specularity;
float litArgs_clearcoat_gloss;
`;

var litShaderCore_default = `
	#if LIT_NONE_SLICE_MODE == TILED
		const float textureBias = -1000.0;
	#else
		uniform float textureBias;
	#endif
	#include "litShaderArgsPS"
`;

var litShadowMain_default = `
#if LIGHT_TYPE != DIRECTIONAL
	uniform vec3 view_position;
	uniform float light_radius;
#endif
#if SHADOW_TYPE == PCSS_32F
	#include "linearizeDepthPS"
#endif
void main(void) {
	#include "litUserMainStartPS"
	evaluateFrontend();
	#ifdef PERSPECTIVE_DEPTH
		float depth = gl_FragCoord.z;
		#if SHADOW_TYPE == PCSS_32F
			#if LIGHT_TYPE != DIRECTIONAL
				depth = linearizeDepthWithParams(depth, camera_params);
			#endif
		#endif
	#else
		float depth = min(distance(view_position, vPositionW) / light_radius, 0.99999);
		#define MODIFIED_DEPTH
	#endif
	#if SHADOW_TYPE == VSM_16F || SHADOW_TYPE == VSM_32F
		#if SHADOW_TYPE == VSM_32F
			float exponent = 15.0;
		#else
			float exponent = 5.54;
		#endif
		depth = 2.0 * depth - 1.0;
		depth =  exp(exponent * depth);
		gl_FragColor = vec4(depth, depth*depth, 1.0, 1.0);
	#else
		#if SHADOW_TYPE == PCSS_32F
			gl_FragColor.r = depth;
		#else
			#ifdef MODIFIED_DEPTH
				gl_FragDepth = depth;
			#endif
			gl_FragColor = vec4(1.0);
		#endif
	#endif
	#include "litUserMainEndPS"
}
`;

var ltc_default = `
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
struct Coords {
	vec3 coord0;
	vec3 coord1;
	vec3 coord2;
	vec3 coord3;
};
float LTC_EvaluateRect( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in Coords rectCoords) {
	vec3 v1 = rectCoords.coord1 - rectCoords.coord0;
	vec3 v2 = rectCoords.coord3 - rectCoords.coord0;
	
	vec3 lightNormal = cross( v1, v2 );
	float factor = sign(-dot( lightNormal, P - rectCoords.coord0 ));
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 =  factor * cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords.coord0 - P );
	coords[ 1 ] = mat * ( rectCoords.coord1 - P );
	coords[ 2 ] = mat * ( rectCoords.coord2 - P );
	coords[ 3 ] = mat * ( rectCoords.coord3 - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return result;
}
Coords dLTCCoords;
Coords getLTCLightCoords(vec3 lightPos, vec3 halfWidth, vec3 halfHeight){
	Coords coords;
	coords.coord0 = lightPos + halfWidth - halfHeight;
	coords.coord1 = lightPos - halfWidth - halfHeight;
	coords.coord2 = lightPos - halfWidth + halfHeight;
	coords.coord3 = lightPos + halfWidth + halfHeight;
	return coords;
}
float dSphereRadius;
Coords getSphereLightCoords(vec3 lightPos, vec3 halfWidth, vec3 halfHeight){
	dSphereRadius = max(length(halfWidth), length(halfHeight));
	vec3 f = reflect(normalize(lightPos - view_position), vNormalW);
	vec3 w = normalize(cross(f, halfHeight));
	vec3 h = normalize(cross(f, w));
	return getLTCLightCoords(lightPos, w * dSphereRadius, h * dSphereRadius);
}
vec2 dLTCUV;
#ifdef LIT_CLEARCOAT
	vec2 ccLTCUV;
#endif
vec2 getLTCLightUV(float gloss, vec3 worldNormal, vec3 viewDir)
{
	float roughness = max((1.0 - gloss) * (1.0 - gloss), 0.001);
	return LTC_Uv( worldNormal, viewDir, roughness );
}
vec3 dLTCSpecFres;
#ifdef LIT_CLEARCOAT
	vec3 ccLTCSpecFres;
#endif
vec3 getLTCLightSpecFres(vec2 uv, vec3 specularity)
{
	vec4 t2 = texture2DLod(areaLightsLutTex2, uv, 0.0);
	return specularity * t2.x + ( vec3( 1.0 ) - specularity) * t2.y;
}
void calcLTCLightValues(float gloss, vec3 worldNormal, vec3 viewDir, vec3 specularity, float clearcoatGloss, vec3 clearcoatWorldNormal, float clearcoatSpecularity)
{
	dLTCUV = getLTCLightUV(gloss, worldNormal, viewDir);
	dLTCSpecFres = getLTCLightSpecFres(dLTCUV, specularity); 
#ifdef LIT_CLEARCOAT
	ccLTCUV = getLTCLightUV(clearcoatGloss, clearcoatWorldNormal, viewDir);
	ccLTCSpecFres = getLTCLightSpecFres(ccLTCUV, vec3(clearcoatSpecularity));
#endif
}
void calcRectLightValues(vec3 lightPos, vec3 halfWidth, vec3 halfHeight) {
	dLTCCoords = getLTCLightCoords(lightPos, halfWidth, halfHeight);
}
void calcDiskLightValues(vec3 lightPos, vec3 halfWidth, vec3 halfHeight) {
	calcRectLightValues(lightPos, halfWidth, halfHeight);
}
void calcSphereLightValues(vec3 lightPos, vec3 halfWidth, vec3 halfHeight) {
	dLTCCoords = getSphereLightCoords(lightPos, halfWidth, halfHeight);
}
vec3 SolveCubic(vec4 Coefficient)
{
	float pi = 3.14159;
	Coefficient.xyz /= Coefficient.w;
	Coefficient.yz /= 3.0;
	float A = Coefficient.w;
	float B = Coefficient.z;
	float C = Coefficient.y;
	float D = Coefficient.x;
	vec3 Delta = vec3(
		-Coefficient.z * Coefficient.z + Coefficient.y,
		-Coefficient.y * Coefficient.z + Coefficient.x,
		dot(vec2(Coefficient.z, -Coefficient.y), Coefficient.xy)
	);
	float Discriminant = dot(vec2(4.0 * Delta.x, -Delta.y), Delta.zy);
	vec2 xlc, xsc;
	{
		float A_a = 1.0;
		float C_a = Delta.x;
		float D_a = -2.0 * B * Delta.x + Delta.y;
		float Theta = atan(sqrt(Discriminant), -D_a) / 3.0;
		float x_1a = 2.0 * sqrt(-C_a) * cos(Theta);
		float x_3a = 2.0 * sqrt(-C_a) * cos(Theta + (2.0 / 3.0) * pi);
		float xl;
		if ((x_1a + x_3a) > 2.0 * B)
			xl = x_1a;
		else
			xl = x_3a;
		xlc = vec2(xl - B, A);
	}
	{
		float A_d = D;
		float C_d = Delta.z;
		float D_d = -D * Delta.y + 2.0 * C * Delta.z;
		float Theta = atan(D * sqrt(Discriminant), -D_d) / 3.0;
		float x_1d = 2.0 * sqrt(-C_d) * cos(Theta);
		float x_3d = 2.0 * sqrt(-C_d) * cos(Theta + (2.0 / 3.0) * pi);
		float xs;
		if (x_1d + x_3d < 2.0 * C)
			xs = x_1d;
		else
			xs = x_3d;
		xsc = vec2(-D, xs + C);
	}
	float E =  xlc.y * xsc.y;
	float F = -xlc.x * xsc.y - xlc.y * xsc.x;
	float G =  xlc.x * xsc.x;
	vec2 xmc = vec2(C * F - B * G, -B * F + C * E);
	vec3 Root = vec3(xsc.x / xsc.y, xmc.x / xmc.y, xlc.x / xlc.y);
	if (Root.x < Root.y && Root.x < Root.z)
		Root.xyz = Root.yxz;
	else if (Root.z < Root.x && Root.z < Root.y)
		Root.xyz = Root.xzy;
	return Root;
}
float LTC_EvaluateDisk(vec3 N, vec3 V, vec3 P, mat3 Minv, Coords points)
{
	vec3 T1 = normalize(V - N * dot(V, N));
	vec3 T2 = cross(N, T1);
	mat3 R = transposeMat3( mat3( T1, T2, N ) );
	vec3 L_[ 3 ];
	L_[ 0 ] = R * ( points.coord0 - P );
	L_[ 1 ] = R * ( points.coord1 - P );
	L_[ 2 ] = R * ( points.coord2 - P );
	vec3 C  = 0.5 * (L_[0] + L_[2]);
	vec3 V1 = 0.5 * (L_[1] - L_[2]);
	vec3 V2 = 0.5 * (L_[1] - L_[0]);
	C  = Minv * C;
	V1 = Minv * V1;
	V2 = Minv * V2;
	float a, b;
	float d11 = dot(V1, V1);
	float d22 = dot(V2, V2);
	float d12 = dot(V1, V2);
	if (abs(d12) / sqrt(d11 * d22) > 0.0001)
	{
		float tr = d11 + d22;
		float det = -d12 * d12 + d11 * d22;
		det = sqrt(det);
		float u = 0.5 * sqrt(tr - 2.0 * det);
		float v = 0.5 * sqrt(tr + 2.0 * det);
		float e_max = (u + v) * (u + v);
		float e_min = (u - v) * (u - v);
		vec3 V1_, V2_;
		if (d11 > d22)
		{
			V1_ = d12 * V1 + (e_max - d11) * V2;
			V2_ = d12 * V1 + (e_min - d11) * V2;
		}
		else
		{
			V1_ = d12*V2 + (e_max - d22)*V1;
			V2_ = d12*V2 + (e_min - d22)*V1;
		}
		a = 1.0 / e_max;
		b = 1.0 / e_min;
		V1 = normalize(V1_);
		V2 = normalize(V2_);
	}
	else
	{
		a = 1.0 / dot(V1, V1);
		b = 1.0 / dot(V2, V2);
		V1 *= sqrt(a);
		V2 *= sqrt(b);
	}
	vec3 V3 = normalize(cross(V1, V2));
	if (dot(C, V3) < 0.0)
		V3 *= -1.0;
	float L  = dot(V3, C);
	float x0 = dot(V1, C) / L;
	float y0 = dot(V2, C) / L;
	float E1 = inversesqrt(a);
	float E2 = inversesqrt(b);
	a *= L * L;
	b *= L * L;
	float c0 = a * b;
	float c1 = a * b * (1.0 + x0 * x0 + y0 * y0) - a - b;
	float c2 = 1.0 - a * (1.0 + x0 * x0) - b * (1.0 + y0 * y0);
	float c3 = 1.0;
	vec3 roots = SolveCubic(vec4(c0, c1, c2, c3));
	float e1 = roots.x;
	float e2 = roots.y;
	float e3 = roots.z;
	vec3 avgDir = vec3(a * x0 / (a - e2), b * y0 / (b - e2), 1.0);
	mat3 rotate = mat3(V1, V2, V3);
	avgDir = rotate * avgDir;
	avgDir = normalize(avgDir);
	float L1 = sqrt(-e2 / e3);
	float L2 = sqrt(-e2 / e1);
	float formFactor = max(0.0, L1 * L2 * inversesqrt((1.0 + L1 * L1) * (1.0 + L2 * L2)));
	
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	vec2 uv = vec2(avgDir.z * 0.5 + 0.5, formFactor);
	uv = uv*LUT_SCALE + LUT_BIAS;
	float scale = texture2DLod(areaLightsLutTex2, uv, 0.0).w;
	return formFactor*scale;
}
float FixNan(float value) {
	#ifdef WEBGPU
		return value != value ? 0.0 : value;
	#else
		return isnan(value) ? 0.0 : value;
	#endif
}
float getRectLightDiffuse(vec3 worldNormal, vec3 viewDir, vec3 lightDir, vec3 lightDirNorm) {
	return LTC_EvaluateRect( worldNormal, viewDir, vPositionW, mat3( 1.0 ), dLTCCoords );
}
float getDiskLightDiffuse(vec3 worldNormal, vec3 viewDir, vec3 lightDir, vec3 lightDirNorm) {
	return FixNan(LTC_EvaluateDisk( worldNormal, viewDir, vPositionW, mat3( 1.0 ), dLTCCoords ));
}
float getSphereLightDiffuse(vec3 worldNormal, vec3 viewDir, vec3 lightDir, vec3 lightDirNorm) {
	float falloff = dSphereRadius / (dot(lightDir, lightDir) + dSphereRadius);
	return FixNan(getLightDiffuse(worldNormal, viewDir, lightDirNorm) * falloff);
}
mat3 getLTCLightInvMat(vec2 uv)
{
	vec4 t1 = texture2DLod(areaLightsLutTex1, uv, 0.0);
	return mat3(
		vec3( t1.x, 0, t1.y ),
		vec3(	0, 1,	0 ),
		vec3( t1.z, 0, t1.w )
	);
}
float calcRectLightSpecular(vec3 worldNormal, vec3 viewDir, vec2 uv) {
	mat3 mInv = getLTCLightInvMat(uv);
	return LTC_EvaluateRect( worldNormal, viewDir, vPositionW, mInv, dLTCCoords );
}
float getRectLightSpecular(vec3 worldNormal, vec3 viewDir) {
	return calcRectLightSpecular(worldNormal, viewDir, dLTCUV);
}
float calcDiskLightSpecular(vec3 worldNormal, vec3 viewDir, vec2 uv) {
	mat3 mInv = getLTCLightInvMat(uv);
	return LTC_EvaluateDisk( worldNormal, viewDir, vPositionW, mInv, dLTCCoords );
}
float getDiskLightSpecular(vec3 worldNormal, vec3 viewDir) {
	return calcDiskLightSpecular(worldNormal, viewDir, dLTCUV);
}
float getSphereLightSpecular(vec3 worldNormal, vec3 viewDir) {
	return calcDiskLightSpecular(worldNormal, viewDir, dLTCUV);
}
`;

var metalness_default = `
#ifdef STD_METALNESS_CONSTANT
uniform float material_metalness;
#endif
void getMetalness() {
	float metalness = 1.0;
	#ifdef STD_METALNESS_CONSTANT
	metalness *= material_metalness;
	#endif
	#ifdef STD_METALNESS_TEXTURE
	metalness *= texture2DBias({STD_METALNESS_TEXTURE_NAME}, {STD_METALNESS_TEXTURE_UV}, textureBias).{STD_METALNESS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_METALNESS_VERTEX
	metalness *= saturate(vVertexColor.{STD_METALNESS_VERTEX_CHANNEL});
	#endif
	dMetalness = metalness;
}
`;

var msdf_default = `
uniform sampler2D texture_msdfMap;
float median(float r, float g, float b) {
	return max(min(r, g), min(max(r, g), b));
}
uniform float font_sdfIntensity;
uniform float font_pxrange;
#ifndef LIT_MSDF_TEXT_ATTRIBUTE
	uniform vec4 outline_color;
	uniform float outline_thickness;
	uniform vec4 shadow_color;
	uniform vec2 shadow_offset;
#else
	varying vec4 outline_color;
	varying float outline_thickness;
	varying vec4 shadow_color;
	varying vec2 shadow_offset;
#endif
vec4 applyMsdf(vec4 color) {
	float srcAlpha = max(color.a, 0.0001);
	color.rgb = gammaCorrectInput(color.rgb / srcAlpha) * srcAlpha;
	vec3 tsample = texture2D(texture_msdfMap, vUv0).rgb;
	vec2 uvShdw = vUv0 - shadow_offset;
	vec3 ssample = texture2D(texture_msdfMap, uvShdw).rgb;
	float sigDist = median(tsample.r, tsample.g, tsample.b);
	float sigDistShdw = median(ssample.r, ssample.g, ssample.b);
	float edge = 0.5 - 0.5 * font_sdfIntensity;
	vec2 unitRange = vec2(font_pxrange) / vec2(textureSize(texture_msdfMap, 0));
	float screenPxRange = max(0.5 * dot(unitRange, 1.0 / max(fwidth(vUv0), vec2(1e-6))), 2.5);
	float inside = clamp(screenPxRange * (sigDist - edge) + 0.5, 0.0, 1.0);
	float outline = clamp(screenPxRange * (sigDist + outline_thickness - edge) + 0.5, 0.0, 1.0);
	float shadow = clamp(screenPxRange * (sigDistShdw + outline_thickness - edge) + 0.5, 0.0, 1.0);
	vec4 tcolor = (outline > inside) ? outline * vec4(outline_color.a * outline_color.rgb, outline_color.a) : vec4(0.0);
	tcolor = mix(tcolor, color, inside);
	vec4 scolor = (shadow > outline) ? shadow * vec4(shadow_color.a * shadow_color.rgb, shadow_color.a) : tcolor;
	tcolor = mix(scolor, tcolor, outline);
	tcolor.rgb = gammaCorrectOutput(tcolor.rgb / max(tcolor.a, 0.0001)) * tcolor.a;
	
	return tcolor;
}
`;

var metalnessModulate_default = `
vec3 getSpecularModulate(in vec3 specularity, in vec3 albedo, in float metalness, in float f0, in float specularityFactor) {
	vec3 dielectricF0 = f0 * specularity * specularityFactor;
	return mix(dielectricF0, albedo, metalness);
}
vec3 getAlbedoModulate(in vec3 albedo, in float metalness) {
	return albedo * (1.0 - metalness);
}
`;

var morph_default = `
	varying vec2 uv0;
	uniform sampler2DArray morphTexture;
	uniform highp float morphFactor[{MORPH_TEXTURE_MAX_COUNT}];
	uniform highp uint morphIndex[{MORPH_TEXTURE_MAX_COUNT}];
	uniform int count;
	#ifdef MORPH_INT
		uniform vec3 aabbSize;
		uniform vec3 aabbMin;
	#endif
	void main (void) {
		highp vec3 color = vec3(0, 0, 0);
		ivec2 pixelCoords = ivec2(uv0 * vec2(textureSize(morphTexture, 0).xy));
		
		for (int i = 0; i < count; i++) {
			uint textureIndex = morphIndex[i];
			vec3 delta = texelFetch(morphTexture, ivec3(pixelCoords, int(textureIndex)), 0).xyz;
			color += morphFactor[i] * delta;
		}
		#ifdef MORPH_INT
			color = (color - aabbMin) / aabbSize * 65535.0;
			gl_FragColor = uvec4(color, 1u);
		#else
			gl_FragColor = vec4(color, 1.0);
		#endif
	}
`;

var morph_default2 = `
	attribute vec2 vertex_position;
	varying vec2 uv0;
	void main(void) {
		gl_Position = vec4(vertex_position, 0.5, 1.0);
		uv0 = vertex_position.xy * 0.5 + 0.5;
	}
`;

var msdf_default2 = `
attribute vec3 vertex_outlineParameters;
attribute vec3 vertex_shadowParameters;
varying vec4 outline_color;
varying float outline_thickness;
varying vec4 shadow_color;
varying vec2 shadow_offset;
void unpackMsdfParams() {
	vec3 little = mod(vertex_outlineParameters, 256.);
	vec3 big = (vertex_outlineParameters - little) / 256.;
	outline_color.rb = little.xy / 255.;
	outline_color.ga = big.xy / 255.;
	outline_thickness = little.z / 255. * 0.2;
	little = mod(vertex_shadowParameters, 256.);
	big = (vertex_shadowParameters - little) / 256.;
	shadow_color.rb = little.xy / 255.;
	shadow_color.ga = big.xy / 255.;
	shadow_offset = (vec2(little.z, big.z) / 127. - 1.) * 0.005;
}
`;

var normal_default = `
mat3 dNormalMatrix;
vec3 getNormal() {
	dNormalMatrix = getNormalMatrix(dModelMatrix);
	vec3 localNormal = getLocalNormal(vertex_normal);
	return normalize(dNormalMatrix * localNormal);
}
`;

var normalCore_default = `
attribute vec3 vertex_normal;
uniform mat3 matrix_normal;
#ifdef MORPHING_NORMAL
	#ifdef MORPHING_INT
		uniform highp usampler2D morphNormalTex;
	#else
		uniform highp sampler2D morphNormalTex;
	#endif
#endif
vec3 getLocalNormal(vec3 vertexNormal) {
	vec3 localNormal = vertex_normal;
	#ifdef MORPHING_NORMAL
		ivec2 morphUV = getTextureMorphCoords();
		#ifdef MORPHING_INT
			vec3 morphNormal = vec3(texelFetch(morphNormalTex, ivec2(morphUV), 0).xyz) / 65535.0 * 2.0 - 1.0;
		#else
			vec3 morphNormal = texelFetch(morphNormalTex, ivec2(morphUV), 0).xyz;
		#endif
		localNormal += morphNormal;
	#endif
	return localNormal;
}
#if defined(SKIN) || defined(BATCH)
	mat3 getNormalMatrix(mat4 modelMatrix) {
		return mat3(modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz);
	}
#elif defined(INSTANCING)
	mat3 getNormalMatrix(mat4 modelMatrix) {
		return mat3(modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz);
	}
#else
	mat3 getNormalMatrix(mat4 modelMatrix) {
		return matrix_normal;
	}
#endif
`;

var normalMap_default = `
#ifdef STD_NORMAL_TEXTURE
	uniform float material_bumpiness;
#endif
#ifdef STD_NORMALDETAIL_TEXTURE
	uniform float material_normalDetailMapBumpiness;
	vec3 blendNormals(vec3 n1, vec3 n2) {
		n1 += vec3(0, 0, 1);
		n2 *= vec3(-1, -1, 1);
		return n1 * dot(n1, n2) / n1.z - n2;
	}
#endif
void getNormal() {
#ifdef STD_NORMAL_TEXTURE
	vec3 normalMap = {STD_NORMAL_TEXTURE_DECODE}(texture2DBias({STD_NORMAL_TEXTURE_NAME}, {STD_NORMAL_TEXTURE_UV}, textureBias));
	normalMap = mix(vec3(0.0, 0.0, 1.0), normalMap, material_bumpiness);
	#ifdef STD_NORMALDETAIL_TEXTURE
		vec3 normalDetailMap = {STD_NORMALDETAIL_TEXTURE_DECODE}(texture2DBias({STD_NORMALDETAIL_TEXTURE_NAME}, {STD_NORMALDETAIL_TEXTURE_UV}, textureBias));
		normalDetailMap = mix(vec3(0.0, 0.0, 1.0), normalDetailMap, material_normalDetailMapBumpiness);
		normalMap = blendNormals(normalMap, normalDetailMap);
	#endif
	dNormalW = normalize(dTBN * normalMap);
#else
	dNormalW = dVertexNormalW;
#endif
}
`;

var opacity_default = `
uniform float material_opacity;
uniform float material_alphaDitherScale;
void getOpacity() {
	dAlpha = material_opacity;
	#ifdef STD_OPACITY_TEXTURE
	dAlpha *= texture2DBias({STD_OPACITY_TEXTURE_NAME}, {STD_OPACITY_TEXTURE_UV}, textureBias).{STD_OPACITY_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_OPACITY_VERTEX
	dAlpha *= clamp(vVertexColor.{STD_OPACITY_VERTEX_CHANNEL}, 0.0, 1.0);
	#endif
}
`;

var opacity_dither_default = `
#if STD_OPACITY_DITHER == BAYER8
	#include "bayerPS"
#endif
uniform vec4 blueNoiseJitter;
#if STD_OPACITY_DITHER == BLUENOISE
	uniform sampler2D blueNoiseTex32;
#endif
void opacityDither(float alpha, float id) {
	if (alpha <= 0.0)
		discard;
	if (alpha >= 1.0)
		return;
	#if STD_OPACITY_DITHER == BAYER8
		float noise = bayer8(floor(mod(gl_FragCoord.xy + blueNoiseJitter.xy + id, 8.0))) / 64.0;
	#else
		#if STD_OPACITY_DITHER == BLUENOISE
			vec2 uv = fract(gl_FragCoord.xy / 32.0 + blueNoiseJitter.xy + id);
			float noise = texture2DLod(blueNoiseTex32, uv, 0.0).y;
		#endif
		#if STD_OPACITY_DITHER == IGNNOISE
			vec3 magic = vec3(0.06711056, 0.00583715, 52.9829189);
			float noise = fract(magic.z * fract(dot(gl_FragCoord.xy + blueNoiseJitter.xy + id, magic.xy)));
		#endif
	#endif
	noise = pow(noise, 2.2);
	if (alpha < noise)
		discard;
}
`;

var outline_declaration_default = `
#ifdef PCOUTLINE_PASS
uniform vec3 pcOutlineColor;
#endif
`;

var outline_output_default = `
#ifdef PCOUTLINE_PASS
gl_FragColor.rgb = gammaCorrectOutput(pcOutlineColor);
#endif
`;

var output_default = `
`;

var outputAlpha_default = `
#if LIT_BLEND_TYPE == NORMAL || LIT_BLEND_TYPE == ADDITIVEALPHA || defined(LIT_ALPHA_TO_COVERAGE)
	gl_FragColor.a = litArgs_opacity;
#elif LIT_BLEND_TYPE == PREMULTIPLIED
	gl_FragColor.rgb *= litArgs_opacity;
	gl_FragColor.a = litArgs_opacity;
#else
	gl_FragColor.a = 1.0;
#endif
`;

var outputTex2D_default = `
varying vec2 vUv0;
uniform sampler2D source;
void main(void) {
	gl_FragColor = texture2D(source, vUv0);
}
`;

var sheen_default = `
uniform vec3 material_sheen;
void getSheen() {
	vec3 sheenColor = material_sheen;
	#ifdef STD_SHEEN_TEXTURE
	sheenColor *= {STD_SHEEN_TEXTURE_DECODE}(texture2DBias({STD_SHEEN_TEXTURE_NAME}, {STD_SHEEN_TEXTURE_UV}, textureBias)).{STD_SHEEN_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_SHEEN_VERTEX
	sheenColor *= saturate(vVertexColor.{STD_SHEEN_VERTEX_CHANNEL});
	#endif
	sSpecularity = sheenColor;
}
`;

var sheenGloss_default = `
uniform float material_sheenGloss;
void getSheenGlossiness() {
	float sheenGlossiness = material_sheenGloss;
	#ifdef STD_SHEENGLOSS_TEXTURE
	sheenGlossiness *= texture2DBias({STD_SHEENGLOSS_TEXTURE_NAME}, {STD_SHEENGLOSS_TEXTURE_UV}, textureBias).{STD_SHEENGLOSS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_SHEENGLOSS_VERTEX
	sheenGlossiness *= saturate(vVertexColor.{STD_SHEENGLOSS_VERTEX_CHANNEL});
	#endif
	#ifdef STD_SHEENGLOSS_INVERT
	sheenGlossiness = 1.0 - sheenGlossiness;
	#endif
	sGlossiness = sheenGlossiness + 0.0000001;
}
`;

var parallax_default = `
uniform float material_heightMapFactor;
void getParallax() {
	float parallaxScale = material_heightMapFactor;
	float height = texture2DBias({STD_HEIGHT_TEXTURE_NAME}, {STD_HEIGHT_TEXTURE_UV}, textureBias).{STD_HEIGHT_TEXTURE_CHANNEL};
	height = height * parallaxScale - parallaxScale * 0.5;
	vec3 viewDirT = dViewDirW * dTBN;
	viewDirT.z += 0.42;
	dUvOffset = height * (viewDirT.xy / viewDirT.z);
}
`;

var pick_default = `
vec4 encodePickOutput(uint id) {
	const vec4 inv = vec4(1.0 / 255.0);
	const uvec4 shifts = uvec4(16, 8, 0, 24);
	uvec4 col = (uvec4(id) >> shifts) & uvec4(0xff);
	return vec4(col) * inv;
}
#ifndef PICK_CUSTOM_ID
	uniform uint meshInstanceId;
	vec4 getPickOutput() {
		return encodePickOutput(meshInstanceId);
	}
#endif
#ifdef DEPTH_PICK_PASS
	#include "floatAsUintPS"
	#ifndef CAMERAPLANES
		#define CAMERAPLANES
		uniform vec4 camera_params;
	#endif
	vec4 getPickDepth() {
		float linearDepth;
		if (camera_params.w > 0.5) {
			linearDepth = gl_FragCoord.z;
		} else {
			float viewDist = 1.0 / gl_FragCoord.w;
			linearDepth = (viewDist - camera_params.z) / (camera_params.y - camera_params.z);
		}
		return float2uint(linearDepth);
	}
#endif
`;

var reflDir_default = `
void getReflDir(vec3 worldNormal, vec3 viewDir, float gloss, mat3 tbn) {
	dReflDirW = normalize(-reflect(viewDir, worldNormal));
}
`;

var reflDirAniso_default = `
void getReflDir(vec3 worldNormal, vec3 viewDir, float gloss, mat3 tbn) {
	float roughness = sqrt(1.0 - min(gloss, 1.0));
	vec2 direction = dAnisotropyRotation;
	vec3 anisotropicT = normalize(tbn * vec3(direction, 0.0));
	vec3 anisotropicB = normalize(cross(tbn[2], anisotropicT));
	float anisotropy = dAnisotropy;
	vec3 anisotropicDirection = anisotropicB;
	vec3 anisotropicTangent = cross(anisotropicDirection, viewDir);
	vec3 anisotropicNormal = cross(anisotropicTangent, anisotropicDirection);
	float bendFactor = 1.0 - anisotropy * (1.0 - roughness);
	float bendFactor4 = bendFactor * bendFactor * bendFactor * bendFactor;
	vec3 bentNormal = normalize(mix(normalize(anisotropicNormal), normalize(worldNormal), bendFactor4));
	dReflDirW = reflect(-viewDir, bentNormal);
}
`;

var reflectionCC_default = `
#ifdef LIT_CLEARCOAT
void addReflectionCC(vec3 reflDir, float gloss) {
	ccReflection += calcReflection(reflDir, gloss);
}
#endif
`;

var reflectionCube_default = `
uniform samplerCube texture_cubeMap;
uniform float material_reflectivity;
vec3 calcReflection(vec3 reflDir, float gloss) {
	vec3 lookupVec = cubeMapProject(reflDir);
	lookupVec.x *= -1.0;
	return {reflectionDecode}(textureCube(texture_cubeMap, lookupVec));
}
void addReflection(vec3 reflDir, float gloss) {   
	dReflection += vec4(calcReflection(reflDir, gloss), material_reflectivity);
}
`;

var reflectionEnvHQ_default = `
#ifndef ENV_ATLAS
	#define ENV_ATLAS
	uniform sampler2D texture_envAtlas;
#endif
uniform samplerCube texture_cubeMap;
uniform float material_reflectivity;
vec3 calcReflection(vec3 reflDir, float gloss) {
	vec3 dir = cubeMapProject(reflDir) * vec3(-1.0, 1.0, 1.0);
	vec2 uv = toSphericalUv(dir);
	float level = saturate(1.0 - gloss) * 5.0;
	float ilevel = floor(level);
	float flevel = level - ilevel;
	vec3 sharp = {reflectionCubemapDecode}(textureCube(texture_cubeMap, dir));
	vec3 roughA = {reflectionDecode}(texture2D(texture_envAtlas, mapRoughnessUv(uv, ilevel)));
	vec3 roughB = {reflectionDecode}(texture2D(texture_envAtlas, mapRoughnessUv(uv, ilevel + 1.0)));
	return processEnvironment(mix(sharp, mix(roughA, roughB, flevel), min(level, 1.0)));
}
void addReflection(vec3 reflDir, float gloss) {   
	dReflection += vec4(calcReflection(reflDir, gloss), material_reflectivity);
}
`;

var reflectionEnv_default = `
#ifndef ENV_ATLAS
#define ENV_ATLAS
	uniform sampler2D texture_envAtlas;
#endif
uniform float material_reflectivity;
float shinyMipLevel(vec2 uv) {
	vec2 dx = dFdx(uv);
	vec2 dy = dFdy(uv);
	vec2 uv2 = vec2(fract(uv.x + 0.5), uv.y);
	vec2 dx2 = dFdx(uv2);
	vec2 dy2 = dFdy(uv2);
	float maxd = min(max(dot(dx, dx), dot(dy, dy)), max(dot(dx2, dx2), dot(dy2, dy2)));
	return clamp(0.5 * log2(maxd) - 1.0 + textureBias, 0.0, 5.0);
}
vec3 calcReflection(vec3 reflDir, float gloss) {
	vec3 dir = cubeMapProject(reflDir) * vec3(-1.0, 1.0, 1.0);
	vec2 uv = toSphericalUv(dir);
	float level = saturate(1.0 - gloss) * 5.0;
	float ilevel = floor(level);
	float level2 = shinyMipLevel(uv * atlasSize);
	float ilevel2 = floor(level2);
	vec2 uv0, uv1;
	float weight;
	if (ilevel == 0.0) {
		uv0 = mapShinyUv(uv, ilevel2);
		uv1 = mapShinyUv(uv, ilevel2 + 1.0);
		weight = level2 - ilevel2;
	} else {
		uv0 = uv1 = mapRoughnessUv(uv, ilevel);
		weight = 0.0;
	}
	vec3 linearA = {reflectionDecode}(texture2D(texture_envAtlas, uv0));
	vec3 linearB = {reflectionDecode}(texture2D(texture_envAtlas, uv1));
	vec3 linear0 = mix(linearA, linearB, weight);
	vec3 linear1 = {reflectionDecode}(texture2D(texture_envAtlas, mapRoughnessUv(uv, ilevel + 1.0)));
	return processEnvironment(mix(linear0, linear1, level - ilevel));
}
void addReflection(vec3 reflDir, float gloss) {   
	dReflection += vec4(calcReflection(reflDir, gloss), material_reflectivity);
}
`;

var reflectionSphere_default = `
#ifndef VIEWMATRIX
	#define VIEWMATRIX
	uniform mat4 matrix_view;
#endif
uniform sampler2D texture_sphereMap;
uniform float material_reflectivity;
vec3 calcReflection(vec3 reflDir, float gloss) {
	vec3 reflDirV = (mat3(matrix_view) * reflDir);
	float m = 2.0 * sqrt(dot(reflDirV.xy, reflDirV.xy) + (reflDirV.z + 1.0) * (reflDirV.z + 1.0));
	vec2 sphereMapUv = reflDirV.xy / m + 0.5;
	return {reflectionDecode}(texture2D(texture_sphereMap, sphereMapUv));
}
void addReflection(vec3 reflDir, float gloss) {   
	dReflection += vec4(calcReflection(reflDir, gloss), material_reflectivity);
}
`;

var reflectionSheen_default = `
void addReflectionSheen(vec3 worldNormal, vec3 viewDir, float gloss) {
	float NoV = dot(worldNormal, viewDir);
	float alphaG = gloss * gloss;
	float a = gloss < 0.25 ? -339.2 * alphaG + 161.4 * gloss - 25.9 : -8.48 * alphaG + 14.3 * gloss - 9.95;
	float b = gloss < 0.25 ? 44.0 * alphaG - 23.7 * gloss + 3.26 : 1.97 * alphaG - 3.27 * gloss + 0.72;
	float DG = exp( a * NoV + b ) + ( gloss < 0.25 ? 0.0 : 0.1 * ( gloss - 0.25 ) );
	sReflection += calcReflection(worldNormal, 0.0) * saturate(DG);
}
`;

var refractionCube_default = `
vec3 refract2(vec3 viewVec, vec3 normal, float IOR) {
	float vn = dot(viewVec, normal);
	float k = 1.0 - IOR * IOR * (1.0 - vn * vn);
	vec3 refrVec = IOR * viewVec - (IOR * vn + sqrt(k)) * normal;
	return refrVec;
}
void addRefraction(
	vec3 worldNormal, 
	vec3 viewDir, 
	float thickness, 
	float gloss, 
	vec3 specularity, 
	vec3 albedo, 
	float transmission,
	float refractionIndex,
	float dispersion
#if defined(LIT_IRIDESCENCE)
	, vec3 iridescenceFresnel,
	float iridescenceIntensity
#endif 
) {
	vec4 tmpRefl = dReflection;
	vec3 reflectionDir = refract2(-viewDir, worldNormal, refractionIndex);
	dReflection = vec4(0);
	addReflection(reflectionDir, gloss);
	dDiffuseLight = mix(dDiffuseLight, dReflection.rgb * albedo, transmission);
	dReflection = tmpRefl;
}
`;

var refractionDynamic_default = `
uniform float material_invAttenuationDistance;
uniform vec3 material_attenuation;
vec3 evalRefractionColor(vec3 refractionVector, float gloss, float refractionIndex) {
	vec4 pointOfRefraction = vec4(vPositionW + refractionVector, 1.0);
	vec4 projectionPoint = matrix_viewProjection * pointOfRefraction;
	vec2 uv = getGrabScreenPos(projectionPoint);
	float iorToRoughness = (1.0 - gloss) * clamp((1.0 / refractionIndex) * 2.0 - 2.0, 0.0, 1.0);
	float refractionLod = log2(uScreenSize.x) * iorToRoughness;
	vec3 refraction = texture2DLod(uSceneColorMap, uv, refractionLod).rgb;
	#ifdef SCENE_COLORMAP_GAMMA
		refraction = decodeGamma(refraction);
	#endif
	return refraction;
}
void addRefraction(
	vec3 worldNormal, 
	vec3 viewDir, 
	float thickness, 
	float gloss, 
	vec3 specularity, 
	vec3 albedo, 
	float transmission,
	float refractionIndex,
	float dispersion
#if defined(LIT_IRIDESCENCE)
	, vec3 iridescenceFresnel,
	float iridescenceIntensity
#endif
) {
	vec3 modelScale;
	modelScale.x = length(vec3(matrix_model[0].xyz));
	modelScale.y = length(vec3(matrix_model[1].xyz));
	modelScale.z = length(vec3(matrix_model[2].xyz));
	vec3 scale = thickness * modelScale;
	vec3 refractionVector = normalize(refract(-viewDir, worldNormal, refractionIndex)) * scale;
	vec3 refraction = evalRefractionColor(refractionVector, gloss, refractionIndex);
	#ifdef LIT_DISPERSION
		float halfSpread = (1.0 / refractionIndex - 1.0) * 0.025 * dispersion;
		float refractionIndexR = refractionIndex - halfSpread;
		refractionVector = normalize(refract(-viewDir, worldNormal, refractionIndexR)) * scale;
		refraction.r = evalRefractionColor(refractionVector, gloss, refractionIndexR).r;
		float refractionIndexB = refractionIndex + halfSpread;
		refractionVector = normalize(refract(-viewDir, worldNormal, refractionIndexB)) * scale;
		refraction.b = evalRefractionColor(refractionVector, gloss, refractionIndexB).b;
	#endif
	vec3 transmittance;
	if (material_invAttenuationDistance != 0.0)
	{
		vec3 attenuation = -log(material_attenuation) * material_invAttenuationDistance;
		transmittance = exp(-attenuation * length(refractionVector));
	}
	else
	{
		transmittance = vec3(1.0);
	}
	vec3 fresnel = vec3(1.0) - 
		getFresnel(
			dot(viewDir, worldNormal), 
			gloss, 
			specularity
		#if defined(LIT_IRIDESCENCE)
			, iridescenceFresnel,
			iridescenceIntensity
		#endif
		);
	dDiffuseLight = mix(dDiffuseLight, refraction * transmittance * fresnel, transmission);
}
`;

var reproject_default = `
varying vec2 vUv0;
#ifdef CUBEMAP_SOURCE
	uniform samplerCube sourceCube;
#else
	uniform sampler2D sourceTex;
#endif
#ifdef USE_SAMPLES_TEX
	uniform sampler2D samplesTex;
	uniform vec2 samplesTexInverseSize;
#endif
uniform vec3 params;
float targetFace() { return params.x; }
float targetTotalPixels() { return params.y; }
float sourceTotalPixels() { return params.z; }
float PI = 3.141592653589793;
float saturate(float x) {
	return clamp(x, 0.0, 1.0);
}
#include "decodePS"
#include "encodePS"
vec3 modifySeams(vec3 dir, float scale) {
	vec3 adir = abs(dir);
	float M = max(max(adir.x, adir.y), adir.z);
	return dir / M * vec3(
		adir.x == M ? 1.0 : scale,
		adir.y == M ? 1.0 : scale,
		adir.z == M ? 1.0 : scale
	);
}
vec2 toSpherical(vec3 dir) {
	return vec2(dir.xz == vec2(0.0) ? 0.0 : atan(dir.x, dir.z), asin(dir.y));
}
vec3 fromSpherical(vec2 uv) {
	return vec3(cos(uv.y) * sin(uv.x),
				sin(uv.y),
				cos(uv.y) * cos(uv.x));
}
vec3 getDirectionEquirect() {
	return fromSpherical((vec2(vUv0.x, 1.0 - vUv0.y) * 2.0 - 1.0) * vec2(PI, PI * 0.5));
}
float signNotZero(float k){
	return(k >= 0.0) ? 1.0 : -1.0;
}
vec2 signNotZero(vec2 v) {
	return vec2(signNotZero(v.x), signNotZero(v.y));
}
vec3 octDecode(vec2 o) {
	vec3 v = vec3(o.x, 1.0 - abs(o.x) - abs(o.y), o.y);
	if (v.y < 0.0) {
		v.xz = (1.0 - abs(v.zx)) * signNotZero(v.xz);
	}
	return normalize(v);
}
vec3 getDirectionOctahedral() {
	return octDecode(vec2(vUv0.x, 1.0 - vUv0.y) * 2.0 - 1.0);
}
vec2 octEncode(in vec3 v) {
	float l1norm = abs(v.x) + abs(v.y) + abs(v.z);
	vec2 result = v.xz * (1.0 / l1norm);
	if (v.y < 0.0) {
		result = (1.0 - abs(result.yx)) * signNotZero(result.xy);
	}
	return result;
}
#ifdef CUBEMAP_SOURCE
	vec4 sampleCubemap(vec3 dir) {
		return textureCube(sourceCube, modifySeams(dir, 1.0));
	}
	vec4 sampleCubemap(vec2 sph) {
		return sampleCubemap(fromSpherical(sph));
	}
	vec4 sampleCubemap(vec3 dir, float mipLevel) {
		return textureCubeLod(sourceCube, modifySeams(dir, 1.0), mipLevel);
	}
	vec4 sampleCubemap(vec2 sph, float mipLevel) {
		return sampleCubemap(fromSpherical(sph), mipLevel);
	}
#else
	vec4 sampleEquirect(vec2 sph) {
		vec2 uv = sph / vec2(PI * 2.0, PI) + 0.5;
		return texture2D(sourceTex, vec2(uv.x, 1.0 - uv.y));
	}
	vec4 sampleEquirect(vec3 dir) {
		return sampleEquirect(toSpherical(dir));
	}
	vec4 sampleEquirect(vec2 sph, float mipLevel) {
		vec2 uv = sph / vec2(PI * 2.0, PI) + 0.5;
		return texture2DLod(sourceTex, vec2(uv.x, 1.0 - uv.y), mipLevel);
	}
	vec4 sampleEquirect(vec3 dir, float mipLevel) {
		return sampleEquirect(toSpherical(dir), mipLevel);
	}
	vec4 sampleOctahedral(vec3 dir) {
		vec2 uv = octEncode(dir) * 0.5 + 0.5;
		return texture2D(sourceTex, vec2(uv.x, 1.0 - uv.y));
	}
	vec4 sampleOctahedral(vec2 sph) {
		return sampleOctahedral(fromSpherical(sph));
	}
	vec4 sampleOctahedral(vec3 dir, float mipLevel) {
		vec2 uv = octEncode(dir) * 0.5 + 0.5;
		return texture2DLod(sourceTex, vec2(uv.x, 1.0 - uv.y), mipLevel);
	}
	vec4 sampleOctahedral(vec2 sph, float mipLevel) {
		return sampleOctahedral(fromSpherical(sph), mipLevel);
	}
#endif
vec3 getDirectionCubemap() {
	vec2 st = vUv0 * 2.0 - 1.0;
	float face = targetFace();
	vec3 vec;
	if (face == 0.0) {
		vec = vec3(1, -st.y, -st.x);
	} else if (face == 1.0) {
		vec = vec3(-1, -st.y, st.x);
	} else if (face == 2.0) {
		vec = vec3(st.x, 1, st.y);
	} else if (face == 3.0) {
		vec = vec3(st.x, -1, -st.y);
	} else if (face == 4.0) {
		vec = vec3(st.x, -st.y, 1);
	} else {
		vec = vec3(-st.x, -st.y, -1);
	}
	return normalize(modifySeams(vec, 1.0));
}
mat3 matrixFromVector(vec3 n) {
	float a = 1.0 / (1.0 + n.z);
	float b = -n.x * n.y * a;
	vec3 b1 = vec3(1.0 - n.x * n.x * a, b, -n.x);
	vec3 b2 = vec3(b, 1.0 - n.y * n.y * a, -n.y);
	return mat3(b1, b2, n);
}
mat3 matrixFromVectorSlow(vec3 n) {
	vec3 up = (1.0 - abs(n.y) <= 0.0000001) ? vec3(0.0, 0.0, n.y > 0.0 ? 1.0 : -1.0) : vec3(0.0, 1.0, 0.0);
	vec3 x = normalize(cross(up, n));
	vec3 y = cross(n, x);
	return mat3(x, y, n);
}
vec4 reproject() {
	if ({NUM_SAMPLES} <= 1) {
		return {ENCODE_FUNC}({DECODE_FUNC}({SOURCE_FUNC}({TARGET_FUNC}())));
	} else {
		vec3 t = {TARGET_FUNC}();
		vec3 tu = dFdx(t);
		vec3 tv = dFdy(t);
		vec3 result = vec3(0.0);
		for (float u = 0.0; u < {NUM_SAMPLES_SQRT}; ++u) {
			for (float v = 0.0; v < {NUM_SAMPLES_SQRT}; ++v) {
				result += {DECODE_FUNC}({SOURCE_FUNC}(normalize(t +
															tu * (u / {NUM_SAMPLES_SQRT} - 0.5) +
															tv * (v / {NUM_SAMPLES_SQRT} - 0.5))));
			}
		}
		return {ENCODE_FUNC}(result / ({NUM_SAMPLES_SQRT} * {NUM_SAMPLES_SQRT}));
	}
}
vec4 unpackFloat = vec4(1.0, 1.0 / 255.0, 1.0 / 65025.0, 1.0 / 16581375.0);
#ifdef USE_SAMPLES_TEX
	void unpackSample(int i, out vec3 L, out float mipLevel) {
		float u = (float(i * 4) + 0.5) * samplesTexInverseSize.x;
		float v = (floor(u) + 0.5) * samplesTexInverseSize.y;
		vec4 raw;
		raw.x = dot(texture2D(samplesTex, vec2(u, v)), unpackFloat); u += samplesTexInverseSize.x;
		raw.y = dot(texture2D(samplesTex, vec2(u, v)), unpackFloat); u += samplesTexInverseSize.x;
		raw.z = dot(texture2D(samplesTex, vec2(u, v)), unpackFloat); u += samplesTexInverseSize.x;
		raw.w = dot(texture2D(samplesTex, vec2(u, v)), unpackFloat);
		L.xyz = raw.xyz * 2.0 - 1.0;
		mipLevel = raw.w * 8.0;
	}
	vec4 prefilterSamples() {
		mat3 vecSpace = matrixFromVectorSlow({TARGET_FUNC}());
		vec3 L;
		float mipLevel;
		vec3 result = vec3(0.0);
		float totalWeight = 0.0;
		for (int i = 0; i < {NUM_SAMPLES}; ++i) {
			unpackSample(i, L, mipLevel);
			result += {DECODE_FUNC}({SOURCE_FUNC}(vecSpace * L, mipLevel)) * L.z;
			totalWeight += L.z;
		}
		return {ENCODE_FUNC}(result / totalWeight);
	}
	vec4 prefilterSamplesUnweighted() {
		mat3 vecSpace = matrixFromVectorSlow({TARGET_FUNC}());
		vec3 L;
		float mipLevel;
		vec3 result = vec3(0.0);
		float totalWeight = 0.0;
		for (int i = 0; i < {NUM_SAMPLES}; ++i) {
			unpackSample(i, L, mipLevel);
			result += {DECODE_FUNC}({SOURCE_FUNC}(vecSpace * L, mipLevel));
		}
		return {ENCODE_FUNC}(result / float({NUM_SAMPLES}));
	}
#endif
void main(void) {
	gl_FragColor = {PROCESS_FUNC}();
}
`;

var reproject_default2 = `
attribute vec2 vertex_position;
uniform vec4 uvMod;
varying vec2 vUv0;
void main(void) {
	gl_Position = vec4(vertex_position, 0.5, 1.0);
	vUv0 = getImageEffectUV((vertex_position.xy * 0.5 + 0.5) * uvMod.xy + uvMod.zw);
}
`;

var screenDepth_default = `
uniform highp sampler2D uSceneDepthMap;
#ifndef SCREENSIZE
	#define SCREENSIZE
	uniform vec4 uScreenSize;
#endif
#ifndef VIEWMATRIX
	#define VIEWMATRIX
	uniform mat4 matrix_view;
#endif
#ifndef LINEARIZE_DEPTH
	#define LINEARIZE_DEPTH
	
	#ifndef CAMERAPLANES
		#define CAMERAPLANES
		uniform vec4 camera_params;
	#endif
	float linearizeDepth(float z) {
		if (camera_params.w == 0.0)
			return (camera_params.z * camera_params.y) / (camera_params.y + z * (camera_params.z - camera_params.y));
		else
			return camera_params.z + z * (camera_params.y - camera_params.z);
	}
#endif
float delinearizeDepth(float linearDepth) {
	if (camera_params.w == 0.0) {
		return (camera_params.y * (camera_params.z - linearDepth)) / (linearDepth * (camera_params.z - camera_params.y));
	} else {
		return (linearDepth - camera_params.z) / (camera_params.y - camera_params.z);
	}
}
float getLinearScreenDepth(vec2 uv) {
	#ifdef SCENE_DEPTHMAP_LINEAR
		#ifdef CAPS_TEXTURE_FLOAT_RENDERABLE
			return texture2D(uSceneDepthMap, uv).r;
		#else
			ivec2 textureSize = textureSize(uSceneDepthMap, 0);
			ivec2 texel = ivec2(uv * vec2(textureSize));
			vec4 data = texelFetch(uSceneDepthMap, texel, 0);
			uint intBits = 
				(uint(data.r * 255.0) << 24u) |
				(uint(data.g * 255.0) << 16u) |
				(uint(data.b * 255.0) << 8u) |
				uint(data.a * 255.0);
			return uintBitsToFloat(intBits);
		#endif
	#else
		return linearizeDepth(texture2D(uSceneDepthMap, uv).r);
	#endif
}
#ifndef VERTEXSHADER
	float getLinearScreenDepth() {
		vec2 uv = gl_FragCoord.xy * uScreenSize.zw;
		return getLinearScreenDepth(uv);
	}
#endif
float getLinearDepth(vec3 pos) {
	return -(matrix_view * vec4(pos, 1.0)).z;
}
`;

var shadowCascades_default = `
int getShadowCascadeIndex(vec4 shadowCascadeDistances, int shadowCascadeCount) {
	float depth = 1.0 / gl_FragCoord.w;
	vec4 comparisons = step(shadowCascadeDistances, vec4(depth));
	int cascadeIndex = int(dot(comparisons, vec4(1.0)));
	return min(cascadeIndex, shadowCascadeCount - 1);
}
int ditherShadowCascadeIndex(int cascadeIndex, vec4 shadowCascadeDistances, int shadowCascadeCount, float blendFactor) {
 
	if (cascadeIndex < shadowCascadeCount - 1) {
		float currentRangeEnd = shadowCascadeDistances[cascadeIndex];
		float transitionStart = blendFactor * currentRangeEnd;
		float depth = 1.0 / gl_FragCoord.w;
		if (depth > transitionStart) {
			float transitionFactor = smoothstep(transitionStart, currentRangeEnd, depth);
			float dither = fract(sin(dot(gl_FragCoord.xy, vec2(12.9898, 78.233))) * 43758.5453);
			if (dither < transitionFactor) {
				cascadeIndex += 1;
			}
		}
	}
	return cascadeIndex;
}
vec3 fadeShadow(vec3 shadowCoord, vec4 shadowCascadeDistances) {				  
	float depth = 1.0 / gl_FragCoord.w;
	if (depth > shadowCascadeDistances.w) {
		shadowCoord.z = -9999999.0;
	}
	return shadowCoord;
}
`;

var shadowEVSM_default = `
float linstep(float a, float b, float v) {
	return saturate((v - a) / (b - a));
}
float reduceLightBleeding(float pMax, float amount) {
	 return linstep(amount, 1.0, pMax);
}
float chebyshevUpperBound(vec2 moments, float mean, float minVariance, float lightBleedingReduction) {
	float variance = moments.y - (moments.x * moments.x);
	variance = max(variance, minVariance);
	float d = mean - moments.x;
	float pMax = variance / (variance + (d * d));
	pMax = reduceLightBleeding(pMax, lightBleedingReduction);
	return (mean <= moments.x ? 1.0 : pMax);
}
float calculateEVSM(vec3 moments, float Z, float vsmBias, float exponent) {
	Z = 2.0 * Z - 1.0;
	float warpedDepth = exp(exponent * Z);
	moments.xy += vec2(warpedDepth, warpedDepth*warpedDepth) * (1.0 - moments.z);
	float VSMBias = vsmBias;
	float depthScale = VSMBias * exponent * warpedDepth;
	float minVariance1 = depthScale * depthScale;
	return chebyshevUpperBound(moments.xy, warpedDepth, minVariance1, 0.1);
}
float VSM16(TEXTURE_ACCEPT(tex), vec2 texCoords, float resolution, float Z, float vsmBias, float exponent) {
	vec3 moments = texture2DLod(tex, texCoords, 0.0).xyz;
	return calculateEVSM(moments, Z, vsmBias, exponent);
}
float getShadowVSM16(TEXTURE_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams, float exponent) {
	return VSM16(TEXTURE_PASS(shadowMap), shadowCoord.xy, shadowParams.x, shadowCoord.z, shadowParams.y, exponent);
}
float getShadowSpotVSM16(TEXTURE_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams, float exponent, vec3 lightDir) {
	return VSM16(TEXTURE_PASS(shadowMap), shadowCoord.xy, shadowParams.x, length(lightDir) * shadowParams.w + shadowParams.z, shadowParams.y, exponent);
}
float VSM32(TEXTURE_ACCEPT(tex), vec2 texCoords, float resolution, float Z, float vsmBias, float exponent) {
	#ifdef CAPS_TEXTURE_FLOAT_FILTERABLE
		vec3 moments = texture2DLod(tex, texCoords, 0.0).xyz;
	#else
		float pixelSize = 1.0 / resolution;
		texCoords -= vec2(pixelSize);
		vec3 s00 = texture2DLod(tex, texCoords, 0.0).xyz;
		vec3 s10 = texture2DLod(tex, texCoords + vec2(pixelSize, 0), 0.0).xyz;
		vec3 s01 = texture2DLod(tex, texCoords + vec2(0, pixelSize), 0.0).xyz;
		vec3 s11 = texture2DLod(tex, texCoords + vec2(pixelSize), 0.0).xyz;
		vec2 fr = fract(texCoords * resolution);
		vec3 h0 = mix(s00, s10, fr.x);
		vec3 h1 = mix(s01, s11, fr.x);
		vec3 moments = mix(h0, h1, fr.y);
	#endif
	return calculateEVSM(moments, Z, vsmBias, exponent);
}
float getShadowVSM32(TEXTURE_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams, float exponent) {
	return VSM32(TEXTURE_PASS(shadowMap), shadowCoord.xy, shadowParams.x, shadowCoord.z, shadowParams.y, exponent);
}
float getShadowSpotVSM32(TEXTURE_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams, float exponent, vec3 lightDir) {
	float Z = length(lightDir) * shadowParams.w + shadowParams.z;
	return VSM32(TEXTURE_PASS(shadowMap), shadowCoord.xy, shadowParams.x, Z, shadowParams.y, exponent);
}
`;

var shadowPCF1_default = `
float getShadowPCF1x1(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams) {
	return textureShadow(shadowMap, shadowCoord);
}
float getShadowSpotPCF1x1(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams) {
	return textureShadow(shadowMap, shadowCoord);
}
#ifndef WEBGPU
float getShadowOmniPCF1x1(samplerCubeShadow shadowMap, vec3 shadowCoord, vec4 shadowParams, vec3 lightDir) {
	float shadowZ = length(lightDir) * shadowParams.w + shadowParams.z;
	return texture(shadowMap, vec4(lightDir, shadowZ));
}
#endif
`;

var shadowPCF3_default = `
float _getShadowPCF3x3(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec3 shadowParams) {
	float z = shadowCoord.z;
	vec2 uv = shadowCoord.xy * shadowParams.x;
	float shadowMapSizeInv = 1.0 / shadowParams.x;
	vec2 base_uv = floor(uv + 0.5);
	float s = (uv.x + 0.5 - base_uv.x);
	float t = (uv.y + 0.5 - base_uv.y); 
	base_uv -= vec2(0.5);
	base_uv *= shadowMapSizeInv;
	float sum = 0.0;
	float uw0 = (3.0 - 2.0 * s);
	float uw1 = (1.0 + 2.0 * s);
	float u0 = (2.0 - s) / uw0 - 1.0;
	float u1 = s / uw1 + 1.0;
	float vw0 = (3.0 - 2.0 * t);
	float vw1 = (1.0 + 2.0 * t);
	float v0 = (2.0 - t) / vw0 - 1.0;
	float v1 = t / vw1 + 1.0;
	u0 = u0 * shadowMapSizeInv + base_uv.x;
	v0 = v0 * shadowMapSizeInv + base_uv.y;
	u1 = u1 * shadowMapSizeInv + base_uv.x;
	v1 = v1 * shadowMapSizeInv + base_uv.y;
	sum += uw0 * vw0 * textureShadow(shadowMap, vec3(u0, v0, z));
	sum += uw1 * vw0 * textureShadow(shadowMap, vec3(u1, v0, z));
	sum += uw0 * vw1 * textureShadow(shadowMap, vec3(u0, v1, z));
	sum += uw1 * vw1 * textureShadow(shadowMap, vec3(u1, v1, z));
	sum *= 1.0f / 16.0;
	return sum;
}
float getShadowPCF3x3(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams) {
	return _getShadowPCF3x3(SHADOWMAP_PASS(shadowMap), shadowCoord, shadowParams.xyz);
}
float getShadowSpotPCF3x3(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams) {
	return _getShadowPCF3x3(SHADOWMAP_PASS(shadowMap), shadowCoord, shadowParams.xyz);
}
#ifndef WEBGPU
float getShadowOmniPCF3x3(samplerCubeShadow shadowMap, vec4 shadowParams, vec3 dir) {
	
	float shadowZ = length(dir) * shadowParams.w + shadowParams.z;
	float z = 1.0 / float(textureSize(shadowMap, 0));
	vec3 tc = normalize(dir);
	mediump vec4 shadows;
	shadows.x = texture(shadowMap, vec4(tc + vec3( z, z, z), shadowZ));
	shadows.y = texture(shadowMap, vec4(tc + vec3(-z,-z, z), shadowZ));
	shadows.z = texture(shadowMap, vec4(tc + vec3(-z, z,-z), shadowZ));
	shadows.w = texture(shadowMap, vec4(tc + vec3( z,-z,-z), shadowZ));
	return dot(shadows, vec4(0.25));
}
float getShadowOmniPCF3x3(samplerCubeShadow shadowMap, vec3 shadowCoord, vec4 shadowParams, vec3 lightDir) {
	return getShadowOmniPCF3x3(shadowMap, shadowParams, lightDir);
}
#endif
`;

var shadowPCF5_default = `
float _getShadowPCF5x5(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec3 shadowParams) {
	float z = shadowCoord.z;
	vec2 uv = shadowCoord.xy * shadowParams.x;
	float shadowMapSizeInv = 1.0 / shadowParams.x;
	vec2 base_uv = floor(uv + 0.5);
	float s = (uv.x + 0.5 - base_uv.x);
	float t = (uv.y + 0.5 - base_uv.y);
	base_uv -= vec2(0.5);
	base_uv *= shadowMapSizeInv;
	float uw0 = (4.0 - 3.0 * s);
	float uw1 = 7.0;
	float uw2 = (1.0 + 3.0 * s);
	float u0 = (3.0 - 2.0 * s) / uw0 - 2.0;
	float u1 = (3.0 + s) / uw1;
	float u2 = s / uw2 + 2.0;
	float vw0 = (4.0 - 3.0 * t);
	float vw1 = 7.0;
	float vw2 = (1.0 + 3.0 * t);
	float v0 = (3.0 - 2.0 * t) / vw0 - 2.0;
	float v1 = (3.0 + t) / vw1;
	float v2 = t / vw2 + 2.0;
	float sum = 0.0;
	u0 = u0 * shadowMapSizeInv + base_uv.x;
	v0 = v0 * shadowMapSizeInv + base_uv.y;
	u1 = u1 * shadowMapSizeInv + base_uv.x;
	v1 = v1 * shadowMapSizeInv + base_uv.y;
	u2 = u2 * shadowMapSizeInv + base_uv.x;
	v2 = v2 * shadowMapSizeInv + base_uv.y;
	sum += uw0 * vw0 * textureShadow(shadowMap, vec3(u0, v0, z));
	sum += uw1 * vw0 * textureShadow(shadowMap, vec3(u1, v0, z));
	sum += uw2 * vw0 * textureShadow(shadowMap, vec3(u2, v0, z));
	sum += uw0 * vw1 * textureShadow(shadowMap, vec3(u0, v1, z));
	sum += uw1 * vw1 * textureShadow(shadowMap, vec3(u1, v1, z));
	sum += uw2 * vw1 * textureShadow(shadowMap, vec3(u2, v1, z));
	sum += uw0 * vw2 * textureShadow(shadowMap, vec3(u0, v2, z));
	sum += uw1 * vw2 * textureShadow(shadowMap, vec3(u1, v2, z));
	sum += uw2 * vw2 * textureShadow(shadowMap, vec3(u2, v2, z));
	sum *= 1.0f / 144.0;
	sum = saturate(sum);
	return sum;
}
float getShadowPCF5x5(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams) {
	return _getShadowPCF5x5(SHADOWMAP_PASS(shadowMap), shadowCoord, shadowParams.xyz);
}
float getShadowSpotPCF5x5(SHADOWMAP_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams) {
	return _getShadowPCF5x5(SHADOWMAP_PASS(shadowMap), shadowCoord, shadowParams.xyz);
}
`;

var shadowPCSS_default = `
#define PCSS_SAMPLE_COUNT 16
uniform float pcssDiskSamples[PCSS_SAMPLE_COUNT];
uniform float pcssSphereSamples[PCSS_SAMPLE_COUNT];
vec2 vogelDisk(int sampleIndex, float count, float phi, float r) {
	const float GoldenAngle = 2.4;
	float theta = float(sampleIndex) * GoldenAngle + phi;
	float sine = sin(theta);
	float cosine = cos(theta);
	return vec2(r * cosine, r * sine);
}
vec3 vogelSphere(int sampleIndex, float count, float phi, float r) {
	const float GoldenAngle = 2.4;
	float theta = float(sampleIndex) * GoldenAngle + phi;
	float weight = float(sampleIndex) / count;
	return vec3(cos(theta) * r, weight, sin(theta) * r);
}
float noise(vec2 screenPos) {
	const float PHI = 1.61803398874989484820459;
	return fract(sin(dot(screenPos * PHI, screenPos)) * screenPos.x);
}
float viewSpaceDepth(float depth, mat4 invProjection) {
	float z = depth * 2.0 - 1.0;
	vec4 clipSpace = vec4(0.0, 0.0, z, 1.0);
	vec4 viewSpace = invProjection * clipSpace;
	return viewSpace.z;
}
float PCSSBlockerDistance(TEXTURE_ACCEPT(shadowMap), vec2 sampleCoords[PCSS_SAMPLE_COUNT], vec2 shadowCoords, vec2 searchSize, float z, vec4 cameraParams) {
	float blockers = 0.0;
	float averageBlocker = 0.0;
	for (int i = 0; i < PCSS_SAMPLE_COUNT; i++) {
		vec2 offset = sampleCoords[i] * searchSize;
		vec2 sampleUV = shadowCoords + offset;
		float blocker = texture2DLod(shadowMap, sampleUV, 0.0).r;
		float isBlocking = step(blocker, z);
		blockers += isBlocking;
		averageBlocker += blocker * isBlocking;
	}
	if (blockers > 0.0)
		return averageBlocker / blockers;
	return -1.0;
}
float PCSS(TEXTURE_ACCEPT(shadowMap), vec3 shadowCoords, vec4 cameraParams, vec2 shadowSearchArea) {
	float receiverDepth = linearizeDepthWithParams(shadowCoords.z, cameraParams);
	vec2 samplePoints[PCSS_SAMPLE_COUNT];
	const float PI = 3.141592653589793;
	float noise = noise( gl_FragCoord.xy ) * 2.0 * PI;
	for (int i = 0; i < PCSS_SAMPLE_COUNT; i++) {
		float pcssPresample = pcssDiskSamples[i];
		samplePoints[i] = vogelDisk(i, float(PCSS_SAMPLE_COUNT), noise, pcssPresample);
	}
	float averageBlocker = PCSSBlockerDistance(TEXTURE_PASS(shadowMap), samplePoints, shadowCoords.xy, shadowSearchArea, receiverDepth, cameraParams);
	if (averageBlocker == -1.0) {
		return 1.0;
	} else {
		float depthDifference = (receiverDepth - averageBlocker) / 3.0;
		vec2 filterRadius = depthDifference * shadowSearchArea;
		float shadow = 0.0;
		for (int i = 0; i < PCSS_SAMPLE_COUNT; i ++)
		{
			vec2 sampleUV = samplePoints[i] * filterRadius;
			sampleUV = shadowCoords.xy + sampleUV;
			float depth = texture2DLod(shadowMap, sampleUV, 0.0).r;
			shadow += step(receiverDepth, depth);
		}
		return shadow / float(PCSS_SAMPLE_COUNT);
	} 
}
#ifndef WEBGPU
float PCSSCubeBlockerDistance(samplerCube shadowMap, vec3 lightDirNorm, vec3 samplePoints[PCSS_SAMPLE_COUNT], float z, float shadowSearchArea) {
	float blockers = 0.0;
	float averageBlocker = 0.0;
	for (int i = 0; i < PCSS_SAMPLE_COUNT; i++) {
		vec3 sampleDir = lightDirNorm + samplePoints[i] * shadowSearchArea;
		sampleDir = normalize(sampleDir);
		float blocker = textureCubeLod(shadowMap, sampleDir, 0.0).r;
		float isBlocking = step(blocker, z);
		blockers += isBlocking;
		averageBlocker += blocker * isBlocking;
	}
	if (blockers > 0.0)
		return averageBlocker / blockers;
	return -1.0;
}
float PCSSCube(samplerCube shadowMap, vec4 shadowParams, vec3 shadowCoords, vec4 cameraParams, float shadowSearchArea, vec3 lightDir) {
	
	vec3 samplePoints[PCSS_SAMPLE_COUNT];
	const float PI = 3.141592653589793;
	float noise = noise( gl_FragCoord.xy ) * 2.0 * PI;
	for (int i = 0; i < PCSS_SAMPLE_COUNT; i++) {
		float r = pcssSphereSamples[i];
		samplePoints[i] = vogelSphere(i, float(PCSS_SAMPLE_COUNT), noise, r);
	}
	float receiverDepth = length(lightDir) * shadowParams.w + shadowParams.z;
	vec3 lightDirNorm = normalize(lightDir);
	
	float averageBlocker = PCSSCubeBlockerDistance(shadowMap, lightDirNorm, samplePoints, receiverDepth, shadowSearchArea);
	if (averageBlocker == -1.0) {
		return 1.0;
	} else {
		float filterRadius = ((receiverDepth - averageBlocker) / averageBlocker) * shadowSearchArea;
		float shadow = 0.0;
		for (int i = 0; i < PCSS_SAMPLE_COUNT; i++)
		{
			vec3 offset = samplePoints[i] * filterRadius;
			vec3 sampleDir = lightDirNorm + offset;
			sampleDir = normalize(sampleDir);
			float depth = textureCubeLod(shadowMap, sampleDir, 0.0).r;
			shadow += step(receiverDepth, depth);
		}
		return shadow / float(PCSS_SAMPLE_COUNT);
	}
}
float getShadowOmniPCSS(samplerCube shadowMap, vec3 shadowCoord, vec4 shadowParams, vec4 cameraParams, vec2 shadowSearchArea, vec3 lightDir) {
	return PCSSCube(shadowMap, shadowParams, shadowCoord, cameraParams, shadowSearchArea.x, lightDir);
}
#endif
float getShadowSpotPCSS(TEXTURE_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams, vec4 cameraParams, vec2 shadowSearchArea, vec3 lightDir) {
	return PCSS(TEXTURE_PASS(shadowMap), shadowCoord, cameraParams, shadowSearchArea);
}
`;

var shadowSoft_default = `
highp float fractSinRand(const in vec2 uv) {
	const float PI = 3.141592653589793;
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot(uv.xy, vec2(a, b)), sn = mod(dt, PI);
	return fract(sin(sn) * c);
}
struct VogelDiskData {
	float invNumSamples;
	float initialAngle;
	float currentPointId;
};
void prepareDiskConstants(out VogelDiskData data, int sampleCount, float randomSeed) {
	const float pi2 = 6.28318530718;
	data.invNumSamples = 1.0 / float(sampleCount);
	data.initialAngle = randomSeed * pi2;
	data.currentPointId = 0.0;
}
vec2 generateDiskSample(inout VogelDiskData data) {
	const float GOLDEN_ANGLE = 2.399963;
	float r = sqrt((data.currentPointId + 0.5) * data.invNumSamples);
	float theta = data.currentPointId * GOLDEN_ANGLE + data.initialAngle;
	vec2 offset = vec2(cos(theta), sin(theta)) * pow(r, 1.33);
	data.currentPointId += 1.0;
	return offset;
}
void PCSSFindBlocker(TEXTURE_ACCEPT(shadowMap), out float avgBlockerDepth, out int numBlockers,
	vec2 shadowCoords, float z, int shadowBlockerSamples, float searchWidthUv, float randomSeed) {
	VogelDiskData diskData;
	prepareDiskConstants(diskData, shadowBlockerSamples, randomSeed);
	float blockerSum = 0.0;
	numBlockers = 0;
	for( int i = 0; i < shadowBlockerSamples; ++i ) {
		vec2 diskUV = generateDiskSample(diskData);
		vec2 sampleUV = shadowCoords + diskUV * searchWidthUv;
		float shadowMapDepth = texture2DLod(shadowMap, sampleUV, 0.0).r;
		if ( shadowMapDepth < z ) {
			blockerSum += shadowMapDepth;
			numBlockers++;
		}
	}
	avgBlockerDepth = blockerSum / float(numBlockers);
}
float PCSSFilter(TEXTURE_ACCEPT(shadowMap), vec2 uv, float receiverDepth, int shadowSamples, float filterRadius, float randomSeed) {
	VogelDiskData diskData;
	prepareDiskConstants(diskData, shadowSamples, randomSeed);
	float sum = 0.0;
	for (int i = 0; i < shadowSamples; i++) {
		vec2 offsetUV = generateDiskSample(diskData) * filterRadius;
		float depth = texture2DLod(shadowMap, uv + offsetUV, 0.0).r;
		sum += step(receiverDepth, depth);
	}
	return sum / float(shadowSamples);
}
float PCSSDirectional(TEXTURE_ACCEPT(shadowMap), vec3 shadowCoords, vec4 cameraParams, vec4 softShadowParams) {
	float receiverDepth = shadowCoords.z;
	float receiverDepthClamped = min(receiverDepth, 0.9999);
	float randomSeed = fractSinRand(gl_FragCoord.xy);
	int shadowSamples = int(softShadowParams.x);
	int shadowBlockerSamples = int(softShadowParams.y);
	float penumbraSize = softShadowParams.z;
	float penumbraFalloff = softShadowParams.w;
	float orthoRadius = cameraParams.x;
	float depthRange = cameraParams.y - cameraParams.z;
	float worldPerUv = 2.0 * orthoRadius;
	float filterRadius;
	if (shadowBlockerSamples > 0) {
		float searchWidthUv = (penumbraSize * depthRange) / worldPerUv;
		float avgBlockerDepth = 0.0;
		int numBlockers = 0;
		PCSSFindBlocker(TEXTURE_PASS(shadowMap), avgBlockerDepth, numBlockers, shadowCoords.xy, receiverDepthClamped, shadowBlockerSamples, searchWidthUv, randomSeed);
		if (numBlockers < 1)
			return 1.0f;
		float worldDist = max((receiverDepth - avgBlockerDepth) * depthRange, 0.0);
		float t = clamp(worldDist / depthRange, 0.0, 1.0);
		float shape = 1.0 - pow(1.0 - t, penumbraFalloff);
		float penumbraWorld = shape * penumbraSize * depthRange;
		filterRadius = penumbraWorld / worldPerUv;
	} else {
		filterRadius = penumbraSize / worldPerUv;
	}
	return PCSSFilter(TEXTURE_PASS(shadowMap), shadowCoords.xy, receiverDepthClamped, shadowSamples, filterRadius, randomSeed);
}
float getShadowPCSS(TEXTURE_ACCEPT(shadowMap), vec3 shadowCoord, vec4 shadowParams, vec4 cameraParams, vec4 softShadowParams, vec3 lightDir) {
	return PCSSDirectional(TEXTURE_PASS(shadowMap), shadowCoord, cameraParams, softShadowParams);
}
`;

var skinBatch_default = `
attribute float vertex_boneIndices;
uniform highp sampler2D texture_poseMap;
mat4 getBoneMatrix(const in float indexFloat) {
	int width = textureSize(texture_poseMap, 0).x;
	int index = int(indexFloat + 0.5) * 3;
	int iy = index / width;
	int ix = index % width;
	vec4 v1 = texelFetch(texture_poseMap, ivec2(ix + 0, iy), 0);
	vec4 v2 = texelFetch(texture_poseMap, ivec2(ix + 1, iy), 0);
	vec4 v3 = texelFetch(texture_poseMap, ivec2(ix + 2, iy), 0);
	return mat4(
		v1.x, v2.x, v3.x, 0,
		v1.y, v2.y, v3.y, 0,
		v1.z, v2.z, v3.z, 0,
		v1.w, v2.w, v3.w, 1
	);
}
`;

var skin_default = `
attribute vec4 vertex_boneWeights;
attribute vec4 vertex_boneIndices;
uniform highp sampler2D texture_poseMap;
void getBoneMatrix(const in int width, const in int index, out vec4 v1, out vec4 v2, out vec4 v3) {
	int v = index / width;
	int u = index % width;
	v1 = texelFetch(texture_poseMap, ivec2(u + 0, v), 0);
	v2 = texelFetch(texture_poseMap, ivec2(u + 1, v), 0);
	v3 = texelFetch(texture_poseMap, ivec2(u + 2, v), 0);
}
mat4 getSkinMatrix(const in vec4 indicesFloat, const in vec4 weights) {
	int width = textureSize(texture_poseMap, 0).x;
	ivec4 indices = ivec4(indicesFloat + 0.5) * 3;
	vec4 a1, a2, a3;
	getBoneMatrix(width, indices.x, a1, a2, a3);
	vec4 b1, b2, b3;
	getBoneMatrix(width, indices.y, b1, b2, b3);
	vec4 c1, c2, c3;
	getBoneMatrix(width, indices.z, c1, c2, c3);
	vec4 d1, d2, d3;
	getBoneMatrix(width, indices.w, d1, d2, d3);
	vec4 v1 = a1 * weights.x + b1 * weights.y + c1 * weights.z + d1 * weights.w;
	vec4 v2 = a2 * weights.x + b2 * weights.y + c2 * weights.z + d2 * weights.w;
	vec4 v3 = a3 * weights.x + b3 * weights.y + c3 * weights.z + d3 * weights.w;
	float one = dot(weights, vec4(1.0));
	return mat4(
		v1.x, v2.x, v3.x, 0,
		v1.y, v2.y, v3.y, 0,
		v1.z, v2.z, v3.z, 0,
		v1.w, v2.w, v3.w, one
	);
}
`;

var skybox_default = `
	#define LIT_SKYBOX_INTENSITY
	#include "envProcPS"
	#include "gammaPS"
	#include "tonemappingPS"
	#ifdef PREPASS_PASS
		varying float vLinearDepth;
		#include "floatAsUintPS"
	#endif
	varying vec3 vViewDir;
	uniform float skyboxHighlightMultiplier;
	#if defined(SKY_FISHEYE) && !defined(SKYMESH)
		uniform float fisheye_k;
		uniform float fisheye_invK;
		uniform float fisheye_projMat00;
		uniform float fisheye_projMat11;
		uniform mat4 matrix_view;
		uniform mat3 cubeMapRotationMatrix;
		varying vec3 vClipXYW;
	#endif
	#ifdef SKY_CUBEMAP
		uniform samplerCube texture_cubeMap;
		#ifdef SKYMESH
			varying vec3 vWorldPos;
			uniform mat3 cubeMapRotationMatrix;
			uniform vec3 projectedSkydomeCenter;
		#endif
	#else
		#include "sphericalPS"
		#include "envAtlasPS"
		uniform sampler2D texture_envAtlas;
		uniform float mipLevel;
	#endif
	void main(void) {
		#ifdef PREPASS_PASS
			gl_FragColor = float2vec4(vLinearDepth);
		#else
			#if defined(SKY_FISHEYE) && !defined(SKYMESH)
				vec2 ndc = vClipXYW.xy / vClipXYW.z;
				float px = ndc.x / fisheye_projMat00;
				float py = ndc.y / fisheye_projMat11;
				float r = sqrt(px * px + py * py);
				float theta = fisheye_k * atan(r * fisheye_invK);
				float sinT = sin(theta);
				float cosT = cos(theta);
				vec3 camDir = (r > 1e-6)
					? vec3(px / r * sinT, py / r * sinT, -cosT)
					: vec3(0.0, 0.0, -1.0);
				vec3 dir = transpose(mat3(matrix_view)) * camDir;
				dir = dir * cubeMapRotationMatrix;
			#elif defined(SKY_CUBEMAP) && defined(SKYMESH)
				vec3 envDir = normalize(vWorldPos - projectedSkydomeCenter);
				vec3 dir = envDir * cubeMapRotationMatrix;
			#else
				vec3 dir = vViewDir;
			#endif
			#ifdef SKY_CUBEMAP
				dir.x *= -1.0;
				vec3 linear = {SKYBOX_DECODE_FNC}(textureCube(texture_cubeMap, dir));
			#else
				dir *= vec3(-1.0, 1.0, 1.0);
				vec2 uv = toSphericalUv(normalize(dir));
				vec3 linear = {SKYBOX_DECODE_FNC}(texture2D(texture_envAtlas, mapRoughnessUv(uv, mipLevel)));
			#endif
			if (any(greaterThanEqual(linear, vec3(64.0)))) {
				linear *= skyboxHighlightMultiplier;
			}
			gl_FragColor = vec4(gammaCorrectOutput(toneMap(processEnvironment(linear))), 1.0);
		#endif
	}
`;

var skybox_default2 = `
attribute vec4 aPosition;
uniform mat4 matrix_view;
uniform mat4 matrix_projectionSkybox;
uniform mat3 cubeMapRotationMatrix;
varying vec3 vViewDir;
#ifdef SKY_FISHEYE
	varying vec3 vClipXYW;
#endif
#ifdef PREPASS_PASS
	varying float vLinearDepth;
#endif
#ifdef SKYMESH
	uniform mat4 matrix_model;
	varying vec3 vWorldPos;
#endif
void main(void) {
	mat4 view = matrix_view;
	#ifdef SKYMESH
		vec4 worldPos = matrix_model * aPosition;
		vWorldPos = worldPos.xyz;
		gl_Position = matrix_projectionSkybox * (view * worldPos);
		#ifdef PREPASS_PASS
			vLinearDepth = -(matrix_view * vec4(vWorldPos, 1.0)).z;
		#endif
	#else
		view[3][0] = view[3][1] = view[3][2] = 0.0;
		vViewDir = aPosition.xyz * cubeMapRotationMatrix;
		#ifdef SKY_FISHEYE
			vec4 viewPos = view * aPosition;
			gl_Position = vec4(viewPos.xy, 0.0, -viewPos.z);
			vClipXYW = vec3(gl_Position.xy, gl_Position.w);
		#else
			gl_Position = matrix_projectionSkybox * (view * aPosition);
		#endif
		#ifdef PREPASS_PASS
			vLinearDepth = -gl_Position.w;
		#endif
	#endif
	gl_Position.z = gl_Position.w - 1.0e-7;
}
`;

var specular_default = `
#ifdef STD_SPECULAR_CONSTANT
uniform vec3 material_specular;
#endif
void getSpecularity() {
	vec3 specularColor = vec3(1,1,1);
	#ifdef STD_SPECULAR_CONSTANT
	specularColor *= material_specular;
	#endif
	#ifdef STD_SPECULAR_TEXTURE
	specularColor *= {STD_SPECULAR_TEXTURE_DECODE}(texture2DBias({STD_SPECULAR_TEXTURE_NAME}, {STD_SPECULAR_TEXTURE_UV}, textureBias)).{STD_SPECULAR_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_SPECULAR_VERTEX
	specularColor *= saturate(vVertexColor.{STD_SPECULAR_VERTEX_CHANNEL});
	#endif
	dSpecularity = specularColor;
}
`;

var spherical_default = `
vec2 toSpherical(vec3 dir) {
	return vec2(dir.xz == vec2(0.0) ? 0.0 : atan(dir.x, dir.z), asin(dir.y));
}
vec2 toSphericalUv(vec3 dir) {
	const float PI = 3.141592653589793;
	vec2 uv = toSpherical(dir) / vec2(PI * 2.0, PI) + 0.5;
	return vec2(uv.x, 1.0 - uv.y);
}
`;

var specularityFactor_default = `
#ifdef STD_SPECULARITYFACTOR_CONSTANT
uniform float material_specularityFactor;
#endif
void getSpecularityFactor() {
	float specularityFactor = 1.0;
	#ifdef STD_SPECULARITYFACTOR_CONSTANT
	specularityFactor *= material_specularityFactor;
	#endif
	#ifdef STD_SPECULARITYFACTOR_TEXTURE
	specularityFactor *= texture2DBias({STD_SPECULARITYFACTOR_TEXTURE_NAME}, {STD_SPECULARITYFACTOR_TEXTURE_UV}, textureBias).{STD_SPECULARITYFACTOR_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_SPECULARITYFACTOR_VERTEX
	specularityFactor *= saturate(vVertexColor.{STD_SPECULARITYFACTOR_VERTEX_CHANNEL});
	#endif
	dSpecularityFactor = specularityFactor;
}
`;

var spot_default = `
float getSpotEffect(vec3 lightSpotDir, float lightInnerConeAngle, float lightOuterConeAngle, vec3 lightDirNorm) {
	float cosAngle = dot(lightDirNorm, lightSpotDir);
	return smoothstep(lightOuterConeAngle, lightInnerConeAngle, cosAngle);
}
`;

var startNineSliced_default = `
	nineSlicedUv = vec2(vUv0.x, 1.0 - vUv0.y);
`;

var startNineSlicedTiled_default = `
	vec2 tileMask = step(vMask, vec2(0.99999));
	vec2 tileSize = 0.5 * (innerOffset.xy + innerOffset.zw);
	vec2 tileScale = vec2(1.0) / (vec2(1.0) - tileSize);
	vec2 clampedUv = mix(innerOffset.xy * 0.5, vec2(1.0) - innerOffset.zw * 0.5, fract((vTiledUv - tileSize) * tileScale));
	clampedUv = clampedUv * atlasRect.zw + atlasRect.xy;
	nineSlicedUv = vUv0 * tileMask + clampedUv * (vec2(1.0) - tileMask);
	nineSlicedUv.y = 1.0 - nineSlicedUv.y;
	
`;

var stdDeclaration_default = `
	float dAlpha = 1.0;
	#if LIT_BLEND_TYPE != NONE || defined(LIT_ALPHA_TEST) || defined(LIT_ALPHA_TO_COVERAGE) || STD_OPACITY_DITHER != NONE
		#ifdef STD_OPACITY_TEXTURE_ALLOCATE
			uniform sampler2D texture_opacityMap;
		#endif
	#endif
	#ifdef FORWARD_PASS
		vec3 dAlbedo;
		vec3 dNormalW;
		vec3 dSpecularity = vec3(0.0);
		float dGlossiness = 0.0;
		#ifdef LIT_REFRACTION
			float dTransmission;
			float dThickness;
		#endif
		#ifdef LIT_SCENE_COLOR
			uniform sampler2D uSceneColorMap;
		#endif
		#ifdef LIT_SCREEN_SIZE
			uniform vec4 uScreenSize;
		#endif
		#ifdef LIT_TRANSFORMS
			uniform mat4 matrix_viewProjection;
			uniform mat4 matrix_model;
		#endif
		#ifdef STD_HEIGHT_MAP
			vec2 dUvOffset;
			#ifdef STD_HEIGHT_TEXTURE_ALLOCATE
				uniform sampler2D texture_heightMap;
			#endif
		#endif
		#ifdef STD_DIFFUSE_TEXTURE_ALLOCATE
			uniform sampler2D texture_diffuseMap;
		#endif
		#ifdef STD_DIFFUSEDETAIL_TEXTURE_ALLOCATE
			uniform sampler2D texture_diffuseDetailMap;
		#endif
		#ifdef STD_NORMAL_TEXTURE_ALLOCATE
			uniform sampler2D texture_normalMap;
		#endif
		#ifdef STD_NORMALDETAIL_TEXTURE_ALLOCATE
			uniform sampler2D texture_normalDetailMap;
		#endif
		#ifdef STD_THICKNESS_TEXTURE_ALLOCATE
			uniform sampler2D texture_thicknessMap;
		#endif
		#ifdef STD_REFRACTION_TEXTURE_ALLOCATE
			uniform sampler2D texture_refractionMap;
		#endif
		#ifdef LIT_IRIDESCENCE
			float dIridescence;
			float dIridescenceThickness;
			#ifdef STD_IRIDESCENCE_THICKNESS_TEXTURE_ALLOCATE
				uniform sampler2D texture_iridescenceThicknessMap;
			#endif
			#ifdef STD_IRIDESCENCE_TEXTURE_ALLOCATE
				uniform sampler2D texture_iridescenceMap;
			#endif
		#endif
		#ifdef LIT_CLEARCOAT
			float ccSpecularity;
			float ccGlossiness;
			vec3 ccNormalW;
		#endif
		#ifdef LIT_GGX_SPECULAR
			float dAnisotropy;
			vec2 dAnisotropyRotation;
		#endif
		#ifdef LIT_SPECULAR_OR_REFLECTION
			#ifdef LIT_SHEEN
				vec3 sSpecularity;
				float sGlossiness;
				#ifdef STD_SHEEN_TEXTURE_ALLOCATE
					uniform sampler2D texture_sheenMap;
				#endif
				#ifdef STD_SHEENGLOSS_TEXTURE_ALLOCATE
					uniform sampler2D texture_sheenGlossMap;
				#endif
			#endif
			#ifdef LIT_METALNESS
				float dMetalness;
				float dIor;
				#ifdef STD_METALNESS_TEXTURE_ALLOCATE
					uniform sampler2D texture_metalnessMap;
				#endif
			#endif
			#ifdef LIT_SPECULARITY_FACTOR
				float dSpecularityFactor;
				#ifdef STD_SPECULARITYFACTOR_TEXTURE_ALLOCATE
					uniform sampler2D texture_specularityFactorMap;
				#endif
			#endif
			#ifdef STD_SPECULAR_COLOR
				#ifdef STD_SPECULAR_TEXTURE_ALLOCATE
					uniform sampler2D texture_specularMap;
				#endif
			#endif
			#ifdef STD_GLOSS_TEXTURE_ALLOCATE
				uniform sampler2D texture_glossMap;
			#endif
		#endif
		#ifdef STD_AO
			float dAo;
			#ifdef STD_AO_TEXTURE_ALLOCATE
				uniform sampler2D texture_aoMap;
			#endif
			#ifdef STD_AODETAIL_TEXTURE_ALLOCATE
				uniform sampler2D texture_aoDetailMap;
			#endif
		#endif
		vec3 dEmission;
		#ifdef STD_EMISSIVE_TEXTURE_ALLOCATE
			uniform sampler2D texture_emissiveMap;
		#endif
		#ifdef LIT_CLEARCOAT
			#ifdef STD_CLEARCOAT_TEXTURE_ALLOCATE
				uniform sampler2D texture_clearCoatMap;
			#endif
			#ifdef STD_CLEARCOATGLOSS_TEXTURE_ALLOCATE
				uniform sampler2D texture_clearCoatGlossMap;
			#endif
			#ifdef STD_CLEARCOATNORMAL_TEXTURE_ALLOCATE
				uniform sampler2D texture_clearCoatNormalMap;
			#endif
		#endif
		
		#ifdef LIT_GGX_SPECULAR
			#ifdef STD_ANISOTROPY_TEXTURE_ALLOCATE
				uniform sampler2D texture_anisotropyMap;
			#endif
		#endif
		#if defined(STD_LIGHTMAP) || defined(STD_LIGHT_VERTEX_COLOR)
			vec3 dLightmap;
			#ifdef STD_LIGHT_TEXTURE_ALLOCATE
				uniform sampler2D texture_lightMap;
			#endif
		#endif
	#endif
	#include "litShaderCorePS"
`;

var stdFrontEnd_default = `
	#if LIT_BLEND_TYPE != NONE || defined(LIT_ALPHA_TEST) || defined(LIT_ALPHA_TO_COVERAGE) || STD_OPACITY_DITHER != NONE
		#include "opacityPS"
		#if defined(LIT_ALPHA_TEST)
			#include "alphaTestPS"
		#endif
		#if STD_OPACITY_DITHER != NONE
			#include "opacityDitherPS"
		#endif
	#endif
	#ifdef FORWARD_PASS
		#ifdef STD_HEIGHT_MAP
			#include "parallaxPS"
		#endif
		#include  "diffusePS"
		#ifdef LIT_NEEDS_NORMAL
			#include "normalMapPS"
		#endif
		#ifdef LIT_REFRACTION
			#include "transmissionPS"
			#include "thicknessPS"
		#endif
		#ifdef LIT_IRIDESCENCE
			#include "iridescencePS"
			#include "iridescenceThicknessPS"
		#endif
		#ifdef LIT_SPECULAR_OR_REFLECTION
			#ifdef LIT_SHEEN
				#include "sheenPS"
				#include "sheenGlossPS"
			#endif
			#ifdef LIT_METALNESS
				#include "metalnessPS"
				#include "iorPS"
			#endif
			#ifdef LIT_SPECULARITY_FACTOR
				#include "specularityFactorPS"
			#endif
			#ifdef STD_SPECULAR_COLOR
				#include "specularPS"
			#else
				void getSpecularity() { 
					dSpecularity = vec3(1);
				}
			#endif
			#include "glossPS"
		#endif
		#ifdef STD_AO
			#include "aoPS"
		#endif
		#include "emissivePS"
		#ifdef LIT_CLEARCOAT
			#include "clearCoatPS"
			#include "clearCoatGlossPS"
			#include "clearCoatNormalPS"
		#endif
		#if defined(LIT_SPECULAR) && defined(LIT_LIGHTING) && defined(LIT_GGX_SPECULAR)
			#include "anisotropyPS"
		#endif
		#if defined(STD_LIGHTMAP) || defined(STD_LIGHT_VERTEX_COLOR)
			#include "lightmapPS"
		#endif
	#endif
	void evaluateFrontend() {
		#if LIT_BLEND_TYPE != NONE || defined(LIT_ALPHA_TEST) || defined(LIT_ALPHA_TO_COVERAGE) || STD_OPACITY_DITHER != NONE
			getOpacity();
			#if defined(LIT_ALPHA_TEST)
				alphaTest(dAlpha);
			#endif
			#if STD_OPACITY_DITHER != NONE
				opacityDither(dAlpha * material_alphaDitherScale, 0.0);
			#endif
			litArgs_opacity = dAlpha;
		#endif
		#ifdef FORWARD_PASS
			#ifdef STD_HEIGHT_MAP
				getParallax();
			#endif
			getAlbedo();
			litArgs_albedo = dAlbedo;
			#ifdef LIT_NEEDS_NORMAL
				getNormal();
				litArgs_worldNormal = dNormalW;
			#endif
			#ifdef LIT_REFRACTION
				getRefraction();
				litArgs_transmission = dTransmission;
				getThickness();
				litArgs_thickness = dThickness;
				#ifdef LIT_DISPERSION
					litArgs_dispersion = material_dispersion;
				#endif
			#endif
			#ifdef LIT_IRIDESCENCE
				getIridescence();
				getIridescenceThickness();
				litArgs_iridescence_intensity = dIridescence;
				litArgs_iridescence_thickness = dIridescenceThickness;
			#endif
			#ifdef LIT_SPECULAR_OR_REFLECTION
				#ifdef LIT_SHEEN
					getSheen();
					litArgs_sheen_specularity = sSpecularity;
					getSheenGlossiness();
					litArgs_sheen_gloss = sGlossiness;
				#endif
				#ifdef LIT_METALNESS
					getMetalness();
					litArgs_metalness = dMetalness;
					getIor();
					litArgs_ior = dIor;
				#endif
				#ifdef LIT_SPECULARITY_FACTOR
					getSpecularityFactor();
					litArgs_specularityFactor = dSpecularityFactor;
				#endif
				getGlossiness();
				getSpecularity();
				litArgs_specularity = dSpecularity;
				litArgs_gloss = dGlossiness;
			#endif
			#ifdef STD_AO
				getAO();
				litArgs_ao = dAo;
			#endif
			getEmission();
			litArgs_emission = dEmission;
			#ifdef LIT_CLEARCOAT
				getClearCoat();
				getClearCoatGlossiness();
				getClearCoatNormal();
				litArgs_clearcoat_specularity = ccSpecularity;
				litArgs_clearcoat_gloss = ccGlossiness;
				litArgs_clearcoat_worldNormal = ccNormalW;
			#endif
			#if defined(LIT_SPECULAR) && defined(LIT_LIGHTING) && defined(LIT_GGX_SPECULAR)
				getAnisotropy();
			#endif
			#if defined(STD_LIGHTMAP) || defined(STD_LIGHT_VERTEX_COLOR)
				getLightMap();
				litArgs_lightmap = dLightmap;
				#ifdef STD_LIGHTMAP_DIR
					litArgs_lightmapDir = dLightmapDir;
				#endif
			#endif
		#endif
	}
`;

var TBN_default = `
#ifdef LIT_TANGENTS
	#define TBN_TANGENTS
#else
	#if defined(LIT_USE_NORMALS) || defined(LIT_USE_CLEARCOAT_NORMALS)
		#define TBN_DERIVATIVES
	#endif
#endif
#if defined(TBN_DERIVATIVES)
	uniform float tbnBasis;
#endif
void getTBN(vec3 tangent, vec3 binormal, vec3 normal) {
	#ifdef TBN_TANGENTS
		dTBN = mat3(normalize(tangent), normalize(binormal), normalize(normal));
	#elif defined(TBN_DERIVATIVES)
		vec2 uv = {lightingUv};
		vec3 dp1 = dFdx( vPositionW );
		vec3 dp2 = dFdy( vPositionW );
		vec2 duv1 = dFdx( uv );
		vec2 duv2 = dFdy( uv );
		vec3 dp2perp = cross( dp2, normal );
		vec3 dp1perp = cross( normal, dp1 );
		vec3 T = dp2perp * duv1.x + dp1perp * duv2.x;
		vec3 B = dp2perp * duv1.y + dp1perp * duv2.y;
		float denom = max( dot(T,T), dot(B,B) );
		float invmax = (denom == 0.0) ? 0.0 : tbnBasis / sqrt( denom );
		dTBN = mat3(T * invmax, -B * invmax, normal );
	#else
		vec3 B = cross(normal, vObjectSpaceUpW);
		vec3 T = cross(normal, B);
		if (dot(B,B)==0.0)
		{
			float major=max(max(normal.x, normal.y), normal.z);
			if (normal.x == major)
			{
				B = cross(normal, vec3(0,1,0));
				T = cross(normal, B);
			}
			else if (normal.y == major)
			{
				B = cross(normal, vec3(0,0,1));
				T = cross(normal, B);
			}
			else if (normal.z == major)
			{
				B = cross(normal, vec3(1,0,0));
				T = cross(normal, B);
			}
		}
		dTBN = mat3(normalize(T), normalize(B), normalize(normal));
	#endif
}
`;

var thickness_default = `
#ifdef STD_THICKNESS_CONSTANT
uniform float material_thickness;
#endif
void getThickness() {
	dThickness = 1.0;
	#ifdef STD_THICKNESS_CONSTANT
	dThickness *= material_thickness;
	#endif
	#ifdef STD_THICKNESS_TEXTURE
	dThickness *= texture2DBias({STD_THICKNESS_TEXTURE_NAME}, {STD_THICKNESS_TEXTURE_UV}, textureBias).{STD_THICKNESS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_THICKNESS_VERTEX
	dThickness *= saturate(vVertexColor.{STD_THICKNESS_VERTEX_CHANNEL});
	#endif
}
`;

var tonemapping_default = `
#ifndef TONEMAP_NO_EXPOSURE_UNIFORM
	#if TONEMAP != NONE
		uniform float exposure;
		float getExposure() { return exposure; }
	#else
		float getExposure() { return 1.0; }
	#endif
#endif
#if (TONEMAP == NONE)
	#include "tonemappingNonePS"
#elif TONEMAP == FILMIC
	#include "tonemappingFilmicPS"
#elif TONEMAP == LINEAR
	#include "tonemappingLinearPS"
#elif TONEMAP == HEJL
	#include "tonemappingHejlPS"
#elif TONEMAP == ACES
	#include "tonemappingAcesPS"
#elif TONEMAP == ACES2
	#include "tonemappingAces2PS"
#elif TONEMAP == NEUTRAL
	#include "tonemappingNeutralPS"
#endif
`;

var tonemappingAces_default = `
vec3 toneMap(vec3 color) {
	float tA = 2.51;
	float tB = 0.03;
	float tC = 2.43;
	float tD = 0.59;
	float tE = 0.14;
	vec3 x = color * getExposure();
	return (x*(tA*x+tB))/(x*(tC*x+tD)+tE);
}
`;

var tonemappingAces2_default = `
const mat3 ACESInputMat = mat3(
	0.59719, 0.35458, 0.04823,
	0.07600, 0.90834, 0.01566,
	0.02840, 0.13383, 0.83777
);
const mat3 ACESOutputMat = mat3(
	 1.60475, -0.53108, -0.07367,
	-0.10208,  1.10813, -0.00605,
	-0.00327, -0.07276,  1.07602
);
vec3 RRTAndODTFit(vec3 v) {
	vec3 a = v * (v + 0.0245786) - 0.000090537;
	vec3 b = v * (0.983729 * v + 0.4329510) + 0.238081;
	return a / b;
}
vec3 toneMap(vec3 color) {
	color *= getExposure() / 0.6;
	color = color * ACESInputMat;
	color = RRTAndODTFit(color);
	color = color * ACESOutputMat;
	color = clamp(color, 0.0, 1.0);
	return color;
}
`;

var tonemappingFilmic_default = `
const float A =  0.15;
const float B =  0.50;
const float C =  0.10;
const float D =  0.20;
const float E =  0.02;
const float F =  0.30;
const float W =  11.2;
vec3 uncharted2Tonemap(vec3 x) {
	 return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;
}
vec3 toneMap(vec3 color) {
	color = uncharted2Tonemap(color * getExposure());
	vec3 whiteScale = 1.0 / uncharted2Tonemap(vec3(W,W,W));
	color = color * whiteScale;
	return color;
}
`;

var tonemappingHejl_default = `
vec3 toneMap(vec3 color) {
	color *= getExposure();
	const float  A = 0.22, B = 0.3, C = .1, D = 0.2, E = .01, F = 0.3;
	const float Scl = 1.25;
	vec3 h = max( vec3(0.0), color - vec3(0.004) );
	return (h*((Scl*A)*h+Scl*vec3(C*B,C*B,C*B))+Scl*vec3(D*E,D*E,D*E)) / (h*(A*h+vec3(B,B,B))+vec3(D*F,D*F,D*F)) - Scl*vec3(E/F,E/F,E/F);
}
`;

var tonemappingLinear_default = `
vec3 toneMap(vec3 color) {
	return color * getExposure();
}
`;

var tonemappingNeutral_default = `
vec3 toneMap(vec3 color) {
	color *= getExposure();
	float startCompression = 0.8 - 0.04;
	float desaturation = 0.15;
	float x = min(color.r, min(color.g, color.b));
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max(color.r, max(color.g, color.b));
	if (peak < startCompression) return color;
	float d = 1. - startCompression;
	float newPeak = 1. - d * d / (peak + d - startCompression);
	color *= newPeak / peak;
	float g = 1. - 1. / (desaturation * (peak - newPeak) + 1.);
	return mix(color, newPeak * vec3(1, 1, 1), g);
}
`;

var tonemappingNone_default = `
vec3 toneMap(vec3 color) {
	return color;
}
`;

var transform_default = `
#ifdef PIXELSNAP
uniform vec4 uScreenSize;
#endif
#ifdef SCREENSPACE
uniform float projectionFlipY;
#endif
vec4 evalWorldPosition(vec3 vertexPosition, mat4 modelMatrix) {
	vec3 localPos = getLocalPosition(vertexPosition);
	#ifdef NINESLICED
		localPos.xz *= outerScale;
		vec2 positiveUnitOffset = clamp(vertexPosition.xz, vec2(0.0), vec2(1.0));
		vec2 negativeUnitOffset = clamp(-vertexPosition.xz, vec2(0.0), vec2(1.0));
		localPos.xz += (-positiveUnitOffset * innerOffset.xy + negativeUnitOffset * innerOffset.zw) * vertex_texCoord0.xy;
		vTiledUv = (localPos.xz - outerScale + innerOffset.xy) * -0.5 + 1.0;
		localPos.xz *= -0.5;
		localPos = localPos.xzy;
	#endif
	vec4 posW = modelMatrix * vec4(localPos, 1.0);
	#ifdef SCREENSPACE
		posW.zw = vec2(0.0, 1.0);
	#endif
	return posW;
}
vec4 getPosition() {
	dModelMatrix = getModelMatrix();
	vec4 posW = evalWorldPosition(vertex_position.xyz, dModelMatrix);
	dPositionW = posW.xyz;
	vec4 screenPos;
	#ifdef UV1LAYOUT
		screenPos = vec4(vertex_texCoord1.xy * 2.0 - 1.0, 0.5, 1);
		#ifdef WEBGPU
			screenPos.y *= -1.0;
		#endif
	#else
		#ifdef SCREENSPACE
			screenPos = posW;
			screenPos.y *= projectionFlipY;
		#else
			screenPos = matrix_viewProjection * posW;
		#endif
		#ifdef PIXELSNAP
			screenPos.xy = (screenPos.xy * 0.5) + 0.5;
			screenPos.xy *= uScreenSize.xy;
			screenPos.xy = floor(screenPos.xy);
			screenPos.xy *= uScreenSize.zw;
			screenPos.xy = (screenPos.xy * 2.0) - 1.0;
		#endif
	#endif
	return screenPos;
}
vec3 getWorldPosition() {
	return dPositionW;
}
`;

var transformCore_default = `
attribute vec4 vertex_position;
uniform mat4 matrix_viewProjection;
uniform mat4 matrix_model;
#ifdef MORPHING
	uniform vec2 morph_tex_params;
	attribute uint morph_vertex_id;
	ivec2 getTextureMorphCoords() {
		ivec2 textureSize = ivec2(morph_tex_params);
		int morphGridV = int(morph_vertex_id) / textureSize.x;
		int morphGridU = int(morph_vertex_id) - (morphGridV * textureSize.x);
		#ifdef WEBGPU
			morphGridV = textureSize.y - morphGridV - 1;
		#endif
		return ivec2(morphGridU, morphGridV);
	}
	#ifdef MORPHING_POSITION
		#ifdef MORPHING_INT
			uniform vec3 aabbSize;
			uniform vec3 aabbMin;
			uniform usampler2D morphPositionTex;
		#else
			uniform highp sampler2D morphPositionTex;
		#endif
	#endif
#endif
#ifdef defined(BATCH)
	#include "skinBatchVS"
	mat4 getModelMatrix() {
		return getBoneMatrix(vertex_boneIndices);
	}
#elif defined(SKIN)
	#include "skinVS"
	mat4 getModelMatrix() {
		return matrix_model * getSkinMatrix(vertex_boneIndices, vertex_boneWeights);
	}
#elif defined(INSTANCING)
	#include "transformInstancingVS"
#else
	mat4 getModelMatrix() {
		return matrix_model;
	}
#endif
vec3 getLocalPosition(vec3 vertexPosition) {
	vec3 localPos = vertexPosition;
	#ifdef MORPHING_POSITION
		ivec2 morphUV = getTextureMorphCoords();
		#ifdef MORPHING_INT
			vec3 morphPos = vec3(texelFetch(morphPositionTex, ivec2(morphUV), 0).xyz) / 65535.0 * aabbSize + aabbMin;
		#else
			vec3 morphPos = texelFetch(morphPositionTex, ivec2(morphUV), 0).xyz;
		#endif
		localPos += morphPos;
	#endif
	return localPos;
}
`;

var transformInstancing_default = `
attribute vec4 instance_line1;
attribute vec4 instance_line2;
attribute vec4 instance_line3;
attribute vec4 instance_line4;
mat4 getModelMatrix() {
	return matrix_model * mat4(instance_line1, instance_line2, instance_line3, instance_line4);
}
`;

var transmission_default = `
#ifdef STD_REFRACTION_CONSTANT
uniform float material_refraction;
#endif
void getRefraction() {
	float refraction = 1.0;
	#ifdef STD_REFRACTION_CONSTANT
	refraction = material_refraction;
	#endif
	#ifdef STD_REFRACTION_TEXTURE
	refraction *= texture2DBias({STD_REFRACTION_TEXTURE_NAME}, {STD_REFRACTION_TEXTURE_UV}, textureBias).{STD_REFRACTION_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_REFRACTION_VERTEX
	refraction *= saturate(vVertexColor.{STD_REFRACTION_VERTEX_CHANNEL});
	#endif
	dTransmission = refraction;
}
`;

var twoSidedLighting_default = `
void handleTwoSidedLighting() {
	if (!gl_FrontFacing) dTBN[2] = -dTBN[2];
}
`;

var uv0_default = `
#ifdef NINESLICED
	vec2 getUv0() {
		vec2 uv = vertex_position.xz;
		vec2 positiveUnitOffset = clamp(vertex_position.xz, vec2(0.0), vec2(1.0));
		vec2 negativeUnitOffset = clamp(-vertex_position.xz, vec2(0.0), vec2(1.0));
		uv += (-positiveUnitOffset * innerOffset.xy + negativeUnitOffset * innerOffset.zw) * vertex_texCoord0.xy;
		uv = uv * -0.5 + 0.5;
		uv = uv * atlasRect.zw + atlasRect.xy;
		vMask = vertex_texCoord0.xy;
		return uv;
	}
#else
	vec2 getUv0() {
		return vertex_texCoord0;
	}
#endif
`;

var uv1_default = `
vec2 getUv1() {
	return vertex_texCoord1;
}
`;

var uvTransform_default = `
vUV{TRANSFORM_UV_{i}}_{TRANSFORM_ID_{i}} = vec2(
	dot(vec3(uv{TRANSFORM_UV_{i}}, 1), {TRANSFORM_NAME_{i}}0),
	dot(vec3(uv{TRANSFORM_UV_{i}}, 1), {TRANSFORM_NAME_{i}}1)
);
`;

var uvTransformUniforms_default = `
	uniform vec3 {TRANSFORM_NAME_{i}}0;
	uniform vec3 {TRANSFORM_NAME_{i}}1;
`;

var viewDir_default = `
void getViewDir() {
	dViewDirW = normalize(view_position - vPositionW);
}
`;

var shaderChunksGLSL = {
	alphaTestPS: alphaTest_default,
	ambientPS: ambient_default,
	anisotropyPS: anisotropy_default,
	aoPS: ao_default,
	aoDiffuseOccPS: aoDiffuseOcc_default,
	aoSpecOccPS: aoSpecOcc_default,
	bakeDirLmEndPS: bakeDirLmEnd_default,
	bakeLmEndPS: bakeLmEnd_default,
	basePS: base_default,
	baseNineSlicedPS: baseNineSliced_default,
	baseNineSlicedTiledPS: baseNineSlicedTiled_default,
	bayerPS: bayer_default,
	blurVSMPS: blurVSM_default,
	clearCoatPS: clearCoat_default,
	clearCoatGlossPS: clearCoatGloss_default,
	clearCoatNormalPS: clearCoatNormal_default,
	clusteredLightCookiesPS: clusteredLightCookies_default,
	clusteredLightShadowsPS: clusteredLightShadows_default,
	clusteredLightUtilsPS: clusteredLightUtils_default,
	clusteredLightPS: clusteredLight_default,
	combinePS: combine_default,
	cookieBlit2DPS: cookie_blit_2d_default,
	cookieBlitCubePS: cookie_blit_cube_default,
	cookieBlitVS: cookie_blit_default,
	cookiePS: cookie_default,
	cubeMapProjectPS: cubeMapProject_default,
	cubeMapRotatePS: cubeMapRotate_default,
	debugOutputPS: debug_output_default,
	debugProcessFrontendPS: debug_process_frontend_default,
	detailModesPS: detailModes_default,
	diffusePS: diffuse_default,
	decodePS: decode_default,
	emissivePS: emissive_default,
	encodePS: encode_default,
	endPS: end_default,
	envAtlasPS: envAtlas_default,
	envProcPS: envProc_default,
	falloffInvSquaredPS: falloffInvSquared_default,
	falloffLinearPS: falloffLinear_default,
	floatAsUintPS: float_as_uint_default,
	fogPS: fog_default,
	fresnelSchlickPS: fresnelSchlick_default,
	frontendCodePS: "",
	// empty chunk, supplied by the shader generator
	frontendDeclPS: "",
	// empty chunk, supplied by the shader generator
	fullscreenQuadVS: fullscreenQuad_default,
	gammaPS: gamma_default,
	gles3PS: gles3_default,
	gles3VS: gles3_default2,
	glossPS: gloss_default,
	quadVS: quad_default,
	immediateLinePS: immediateLine_default,
	immediateLineVS: immediateLine_default2,
	iridescenceDiffractionPS: iridescenceDiffraction_default,
	iridescencePS: iridescence_default,
	iridescenceThicknessPS: iridescenceThickness_default,
	iorPS: ior_default,
	lightDeclarationPS: lightDeclaration_default,
	lightDiffuseLambertPS: lightDiffuseLambert_default,
	lightDirPointPS: lightDirPoint_default,
	lightEvaluationPS: lightEvaluation_default,
	lightFunctionLightPS: lightFunctionLight_default,
	lightFunctionShadowPS: lightFunctionShadow_default,
	lightingPS: lighting_default,
	lightmapAddPS: lightmapAdd_default,
	lightmapPS: lightmap_default,
	lightSpecularAnisoGGXPS: lightSpecularAnisoGGX_default,
	lightSpecularGGXPS: lightSpecularGGX_default,
	lightSpecularBlinnPS: lightSpecularBlinn_default,
	lightSheenPS: lightSheen_default,
	linearizeDepthPS: linearizeDepth_default,
	litForwardBackendPS: litForwardBackend_default,
	litForwardDeclarationPS: litForwardDeclaration_default,
	litForwardMainPS: litForwardMain_default,
	litForwardPostCodePS: litForwardPostCode_default,
	litForwardPreCodePS: litForwardPreCode_default,
	litMainPS: litMain_default,
	litMainVS: litMain_default2,
	litOtherMainPS: litOtherMain_default,
	litShaderArgsPS: litShaderArgs_default,
	litShaderCorePS: litShaderCore_default,
	litShadowMainPS: litShadowMain_default,
	litUserDeclarationPS: "",
	// empty chunk allowing user to add custom code
	litUserDeclarationVS: "",
	// empty chunk allowing user to add custom code
	litUserCodePS: "",
	// empty chunk allowing user to add custom code
	litUserCodeVS: "",
	// empty chunk allowing user to add custom code
	litUserMainStartPS: "",
	// empty chunk allowing user to add custom code
	litUserMainStartVS: "",
	// empty chunk allowing user to add custom code
	litUserMainEndPS: "",
	// empty chunk allowing user to add custom code
	litUserMainEndVS: "",
	// empty chunk allowing user to add custom code
	ltcPS: ltc_default,
	metalnessPS: metalness_default,
	metalnessModulatePS: metalnessModulate_default,
	morphPS: morph_default,
	morphVS: morph_default2,
	msdfPS: msdf_default,
	msdfVS: msdf_default2,
	normalVS: normal_default,
	normalCoreVS: normalCore_default,
	normalMapPS: normalMap_default,
	opacityPS: opacity_default,
	opacityDitherPS: opacity_dither_default,
	outlineDeclarationPS: outline_declaration_default,
	outlineOutputPS: outline_output_default,
	outputPS: output_default,
	outputAlphaPS: outputAlpha_default,
	outputTex2DPS: outputTex2D_default,
	sheenPS: sheen_default,
	sheenGlossPS: sheenGloss_default,
	parallaxPS: parallax_default,
	pickPS: pick_default,
	reflDirPS: reflDir_default,
	reflDirAnisoPS: reflDirAniso_default,
	reflectionCCPS: reflectionCC_default,
	reflectionCubePS: reflectionCube_default,
	reflectionEnvHQPS: reflectionEnvHQ_default,
	reflectionEnvPS: reflectionEnv_default,
	reflectionSpherePS: reflectionSphere_default,
	reflectionSheenPS: reflectionSheen_default,
	refractionCubePS: refractionCube_default,
	refractionDynamicPS: refractionDynamic_default,
	reprojectPS: reproject_default,
	reprojectVS: reproject_default2,
	screenDepthPS: screenDepth_default,
	shadowCascadesPS: shadowCascades_default,
	shadowEVSMPS: shadowEVSM_default,
	shadowPCF1PS: shadowPCF1_default,
	shadowPCF3PS: shadowPCF3_default,
	shadowPCF5PS: shadowPCF5_default,
	shadowPCSSPS: shadowPCSS_default,
	shadowSoftPS: shadowSoft_default,
	skinBatchVS: skinBatch_default,
	skinVS: skin_default,
	skyboxPS: skybox_default,
	skyboxVS: skybox_default2,
	specularPS: specular_default,
	sphericalPS: spherical_default,
	specularityFactorPS: specularityFactor_default,
	spotPS: spot_default,
	startNineSlicedPS: startNineSliced_default,
	startNineSlicedTiledPS: startNineSlicedTiled_default,
	stdDeclarationPS: stdDeclaration_default,
	stdFrontEndPS: stdFrontEnd_default,
	TBNPS: TBN_default,
	thicknessPS: thickness_default,
	tonemappingPS: tonemapping_default,
	tonemappingAcesPS: tonemappingAces_default,
	tonemappingAces2PS: tonemappingAces2_default,
	tonemappingFilmicPS: tonemappingFilmic_default,
	tonemappingHejlPS: tonemappingHejl_default,
	tonemappingLinearPS: tonemappingLinear_default,
	tonemappingNeutralPS: tonemappingNeutral_default,
	tonemappingNonePS: tonemappingNone_default,
	transformVS: transform_default,
	transformCoreVS: transformCore_default,
	transformInstancingVS: transformInstancing_default,
	transmissionPS: transmission_default,
	twoSidedLightingPS: twoSidedLighting_default,
	uv0VS: uv0_default,
	uv1VS: uv1_default,
	uvTransformVS: uvTransform_default,
	uvTransformUniformsPS: uvTransformUniforms_default,
	viewDirPS: viewDir_default,
	webgpuPS: webgpu_default,
	webgpuVS: webgpu_default2
};

var alphaTest_default2 = `
uniform alpha_ref: f32;
fn alphaTest(a: f32) {
	if (a < uniform.alpha_ref) {
		discard;
	}
}
`;

var ambient_default2 = `
#if LIT_AMBIENT_SOURCE == AMBIENTSH
	uniform ambientSH: array<vec3f, 9>;
#endif
#if LIT_AMBIENT_SOURCE == ENVALATLAS
	#include "envAtlasPS"
	#ifndef ENV_ATLAS
		#define ENV_ATLAS
		var texture_envAtlas: texture_2d<f32>;
		var texture_envAtlasSampler: sampler;
	#endif
#endif
fn addAmbient(worldNormal: vec3f) {
	#ifdef LIT_AMBIENT_SOURCE == AMBIENTSH
		let n: vec3f = cubeMapRotate(worldNormal);
		let color: vec3f =
			uniform.ambientSH[0] +
			uniform.ambientSH[1] * n.x +
			uniform.ambientSH[2] * n.y +
			uniform.ambientSH[3] * n.z +
			uniform.ambientSH[4] * n.x * n.z +
			uniform.ambientSH[5] * n.z * n.y +
			uniform.ambientSH[6] * n.y * n.x +
			uniform.ambientSH[7] * (3.0 * n.z * n.z - 1.0) +
			uniform.ambientSH[8] * (n.x * n.x - n.y * n.y);
		dDiffuseLight += processEnvironment(max(color, vec3f(0.0)));
	#endif
	#if LIT_AMBIENT_SOURCE == ENVALATLAS
		let dir: vec3f = normalize(cubeMapRotate(worldNormal) * vec3f(-1.0, 1.0, 1.0));
		let uv: vec2f = mapUv(toSphericalUv(dir), vec4f(128.0, 256.0 + 128.0, 64.0, 32.0) / atlasSize);
		let raw: vec4f = textureSample(texture_envAtlas, texture_envAtlasSampler, uv);
		let linear: vec3f = {ambientDecode}(raw);
		dDiffuseLight += processEnvironment(linear);
	#endif
	#if LIT_AMBIENT_SOURCE == CONSTANT
		dDiffuseLight += uniform.light_globalAmbient;
	#endif
}
`;

var anisotropy_default2 = `
#ifdef LIT_GGX_SPECULAR
	uniform material_anisotropyIntensity: f32;
	uniform material_anisotropyRotation: vec2f;
#endif
fn getAnisotropy() {
	dAnisotropy = 0.0;
	dAnisotropyRotation = vec2f(1.0, 0.0);
#ifdef LIT_GGX_SPECULAR
	dAnisotropy = uniform.material_anisotropyIntensity;
	dAnisotropyRotation = uniform.material_anisotropyRotation;
#endif
#ifdef STD_ANISOTROPY_TEXTURE
	let anisotropyTex: vec3f = textureSampleBias({STD_ANISOTROPY_TEXTURE_NAME}, {STD_ANISOTROPY_TEXTURE_NAME}Sampler, {STD_ANISOTROPY_TEXTURE_UV}, uniform.textureBias).rgb;
	dAnisotropy *= anisotropyTex.b;
	let anisotropyRotationFromTex: vec2f = anisotropyTex.rg * 2.0 - vec2f(1.0);
	let rotationMatrix: mat2x2f = mat2x2f(dAnisotropyRotation.x, dAnisotropyRotation.y, -dAnisotropyRotation.y, dAnisotropyRotation.x);
	dAnisotropyRotation = rotationMatrix * anisotropyRotationFromTex;
#endif
	dAnisotropy = clamp(dAnisotropy, 0.0, 1.0);
}
`;

var ao_default2 = `
#if defined(STD_AO_TEXTURE) || defined(STD_AO_VERTEX)
	uniform material_aoIntensity: f32;
#endif
#ifdef STD_AODETAIL_TEXTURE
	#include "detailModesPS"
#endif
fn getAO() {
	dAo = 1.0;
	#ifdef STD_AO_TEXTURE
		var aoBase: f32 = textureSampleBias({STD_AO_TEXTURE_NAME}, {STD_AO_TEXTURE_NAME}Sampler, {STD_AO_TEXTURE_UV}, uniform.textureBias).{STD_AO_TEXTURE_CHANNEL};
		#ifdef STD_AODETAIL_TEXTURE
			var aoDetail: f32 = textureSampleBias({STD_AODETAIL_TEXTURE_NAME}, {STD_AODETAIL_TEXTURE_NAME}Sampler, {STD_AODETAIL_TEXTURE_UV}, uniform.textureBias).{STD_AODETAIL_TEXTURE_CHANNEL};
			aoBase = detailMode_{STD_AODETAIL_DETAILMODE}(vec3f(aoBase), vec3f(aoDetail)).r;
		#endif
		dAo = dAo * aoBase;
	#endif
	#ifdef STD_AO_VERTEX
		dAo = dAo * saturate(vVertexColor.{STD_AO_VERTEX_CHANNEL});
	#endif
	#if defined(STD_AO_TEXTURE) || defined(STD_AO_VERTEX)
		dAo = mix(1.0, dAo, uniform.material_aoIntensity);
	#endif
}
`;

var aoDiffuseOcc_default2 = `
fn occludeDiffuse(ao: f32) {
	dDiffuseLight = dDiffuseLight * ao;
}
`;

var aoSpecOcc_default2 = `
#if LIT_OCCLUDE_SPECULAR != NONE
	#ifdef LIT_OCCLUDE_SPECULAR_FLOAT
		uniform material_occludeSpecularIntensity: f32;
	#endif
#endif
fn occludeSpecular(gloss: f32, ao: f32, worldNormal: vec3f, viewDir: vec3f) {
	#if LIT_OCCLUDE_SPECULAR == AO
		#ifdef LIT_OCCLUDE_SPECULAR_FLOAT
			var specOcc: f32 = mix(1.0, ao, uniform.material_occludeSpecularIntensity);
		#else
			var specOcc: f32 = ao;
		#endif
	#endif
	#if LIT_OCCLUDE_SPECULAR == GLOSSDEPENDENT
		var specPow: f32 = exp2(gloss * 11.0);
		var specOcc: f32 = saturate(pow(dot(worldNormal, viewDir) + ao, 0.01 * specPow) - 1.0 + ao);
		#ifdef LIT_OCCLUDE_SPECULAR_FLOAT
			specOcc = mix(1.0, specOcc, uniform.material_occludeSpecularIntensity);
		#endif
	#endif
	#if LIT_OCCLUDE_SPECULAR != NONE
		dSpecularLight = dSpecularLight * specOcc;
		dReflection = dReflection * specOcc;
		#ifdef LIT_SHEEN
			sSpecularLight = sSpecularLight * specOcc;
			sReflection = sReflection * specOcc;
		#endif
	#endif
}
`;

var bakeDirLmEnd_default2 = `
	let dirLm = textureSample(texture_dirLightMap, texture_dirLightMapSampler, vUv1);
	if (uniform.bakeDir > 0.5) {
		if (dAtten > 0.00001) {
			let unpacked_dir = dirLm.xyz * 2.0 - vec3f(1.0);
			dAtten = clamp(dAtten, 0.0, 1.0);
			let combined_dir = dLightDirNormW.xyz * dAtten + unpacked_dir * dirLm.w;
			let finalRgb = normalize(combined_dir) * 0.5 + vec3f(0.5);
			let finalA = max(dirLm.w + dAtten, 1.0 / 255.0);
			output.color = vec4f(finalRgb, finalA);
		} else {
			output.color = dirLm;
		}
	} else {
		let alpha_min = select(0.0, 1.0 / 255.0, dAtten > 0.00001);
		let finalA = max(dirLm.w, alpha_min);
		output.color = vec4f(dirLm.rgb, finalA);
	}
`;

var bakeLmEnd_default2 = `
#ifdef LIT_LIGHTMAP_BAKING_ADD_AMBIENT
	dDiffuseLight = ((dDiffuseLight - 0.5) * max(uniform.ambientBakeOcclusionContrast + 1.0, 0.0)) + 0.5;
	dDiffuseLight = dDiffuseLight + vec3f(uniform.ambientBakeOcclusionBrightness);
	dDiffuseLight = saturate3(dDiffuseLight);
	dDiffuseLight = dDiffuseLight * dAmbientLight;
#endif
#ifdef LIGHTMAP_RGBM
	var temp_color_rgbm = vec4f(dDiffuseLight, 1.0);
	temp_color_rgbm = vec4f(pow(temp_color_rgbm.rgb, vec3f(0.5)), temp_color_rgbm.a);
	temp_color_rgbm = vec4f(temp_color_rgbm.rgb / 8.0, temp_color_rgbm.a);
	let max_g_b = max(temp_color_rgbm.g, max(temp_color_rgbm.b, 1.0 / 255.0));
	let max_rgb = max(temp_color_rgbm.r, max_g_b);
	temp_color_rgbm.a = clamp(max_rgb, 0.0, 1.0);
	temp_color_rgbm.a = ceil(temp_color_rgbm.a * 255.0) / 255.0;
	temp_color_rgbm = vec4f(temp_color_rgbm.rgb / temp_color_rgbm.a, temp_color_rgbm.a);
	output.color = temp_color_rgbm;
#else
	output.color = vec4f(dDiffuseLight, 1.0);
#endif
`;

var base_default2 = `
uniform view_position: vec3f;
uniform light_globalAmbient: vec3f;
fn square(x: f32) -> f32 {
	return x*x;
}
fn saturate(x: f32) -> f32 {
	return clamp(x, 0.0, 1.0);
}
fn saturate3(x: vec3f) -> vec3f {
	return clamp(x, vec3f(0.0), vec3f(1.0));
}
`;

var baseNineSliced_default2 = `
#define NINESLICED
varying vMask: vec2f;
varying vTiledUv: vec2f;
uniform innerOffset: vec4f;
uniform outerScale: vec2f;
uniform atlasRect: vec4f;
var<private> nineSlicedUv: vec2f;
`;

var baseNineSlicedTiled_default2 = `
#define NINESLICED
#define NINESLICETILED
varying vMask: vec2f;
varying vTiledUv: vec2f;
uniform innerOffset: vec4f;
uniform outerScale: vec2f;
uniform atlasRect: vec4f;
var<private> nineSlicedUv: vec2f;
`;

var bayer_default2 = `
fn bayer2(p: vec2f) -> f32 {
	return (2.0 * p.y + p.x + 1.0) % 4.0;
}
fn bayer4(p: vec2f) -> f32 {
	let p1: vec2f = p % vec2f(2.0);
	let p2: vec2f = floor(0.5 * (p % vec2f(4.0)));
	return 4.0 * bayer2(p1) + bayer2(p2);
}
fn bayer8(p: vec2f) -> f32 {
	let p1: vec2f = p % vec2f(2.0);
	let p2: vec2f = floor(0.5 * (p % vec2f(4.0)));
	let p4: vec2f = floor(0.25 * (p % vec2f(8.0)));
	return 4.0 * (4.0 * bayer2(p1) + bayer2(p2)) + bayer2(p4);
}
`;

var blurVSM_default2 = `
varying vUv0: vec2f;
var source: texture_2d<f32>;
var sourceSampler: sampler;
#ifdef GAUSS
	uniform weight: array<f32, {SAMPLES}>;
#endif
uniform pixelOffset: vec2f;
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	var moments: vec3f = vec3f(0.0);
	let uv: vec2f = input.vUv0 - uniform.pixelOffset * (f32({SAMPLES}) * 0.5);
	for (var i: i32 = 0; i < {SAMPLES}; i = i + 1) {
		let c: vec4f = textureSample(source, sourceSampler, uv + uniform.pixelOffset * f32(i));
		#ifdef GAUSS
			moments = moments + c.xyz * uniform.weight[i].element;
		#else
			moments = moments + c.xyz;
		#endif
	}
	#ifndef GAUSS
		moments = moments * (1.0 / f32({SAMPLES}));
	#endif
	output.color = vec4f(moments, 1.0);
	return output;
}
`;

var clearCoat_default2 = `
uniform material_clearCoat: f32;
fn getClearCoat() {
	ccSpecularity = uniform.material_clearCoat;
	#ifdef STD_CLEARCOAT_TEXTURE
	ccSpecularity = ccSpecularity * textureSampleBias({STD_CLEARCOAT_TEXTURE_NAME}, {STD_CLEARCOAT_TEXTURE_NAME}Sampler, {STD_CLEARCOAT_TEXTURE_UV}, uniform.textureBias).{STD_CLEARCOAT_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_CLEARCOAT_VERTEX
	ccSpecularity = ccSpecularity * saturate(vVertexColor.{STD_CLEARCOAT_VERTEX_CHANNEL});
	#endif
}
`;

var clearCoatGloss_default2 = `
	uniform material_clearCoatGloss: f32;
fn getClearCoatGlossiness() {
	ccGlossiness = uniform.material_clearCoatGloss;
	#ifdef STD_CLEARCOATGLOSS_TEXTURE
	ccGlossiness = ccGlossiness * textureSampleBias({STD_CLEARCOATGLOSS_TEXTURE_NAME}, {STD_CLEARCOATGLOSS_TEXTURE_NAME}Sampler, {STD_CLEARCOATGLOSS_TEXTURE_UV}, uniform.textureBias).{STD_CLEARCOATGLOSS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_CLEARCOATGLOSS_VERTEX
	ccGlossiness = ccGlossiness * saturate(vVertexColor.{STD_CLEARCOATGLOSS_VERTEX_CHANNEL});
	#endif
	#ifdef STD_CLEARCOATGLOSS_INVERT
	ccGlossiness = 1.0 - ccGlossiness;
	#endif
	ccGlossiness += 0.0000001;
}
`;

var clearCoatNormal_default2 = `
#ifdef STD_CLEARCOATNORMAL_TEXTURE
	uniform material_clearCoatBumpiness: f32;
#endif
fn getClearCoatNormal() {
#ifdef STD_CLEARCOATNORMAL_TEXTURE
	var normalMap: vec3f = {STD_CLEARCOATNORMAL_TEXTURE_DECODE}(textureSampleBias({STD_CLEARCOATNORMAL_TEXTURE_NAME}, {STD_CLEARCOATNORMAL_TEXTURE_NAME}Sampler, {STD_CLEARCOATNORMAL_TEXTURE_UV}, uniform.textureBias));
	normalMap = mix(vec3f(0.0, 0.0, 1.0), normalMap, uniform.material_clearCoatBumpiness);
	ccNormalW = normalize(dTBN * normalMap);
#else
	ccNormalW = dVertexNormalW;
#endif
}
`;

var clusteredLightUtils_default2 = `
struct FaceCoords {
	uv: vec2f,
	faceIndex: f32,
	tileOffset: vec2f,
}
fn getCubemapFaceCoordinates(dir: vec3f) -> FaceCoords {
	var faceIndex: f32;
	var tileOffset: vec2f;
	var uv: vec2f;
	let vAbs: vec3f = abs(dir);
	var ma: f32;
	if (vAbs.z >= vAbs.x && vAbs.z >= vAbs.y) {
		let is_neg_z = dir.z < 0.0;
		faceIndex = select(4.0, 5.0, is_neg_z);
		ma = 0.5 / vAbs.z;
		uv = vec2f(select(dir.x, -dir.x, is_neg_z), -dir.y);
		tileOffset = vec2f(2.0, select(0.0, 1.0, is_neg_z));
	} else if (vAbs.y >= vAbs.x) {
		let is_neg_y = dir.y < 0.0;
		faceIndex = select(2.0, 3.0, is_neg_y);
		ma = 0.5 / vAbs.y;
		uv = vec2f(dir.x, select(dir.z, -dir.z, is_neg_y));
		tileOffset = vec2f(1.0, select(0.0, 1.0, is_neg_y));
	} else {
		let is_neg_x = dir.x < 0.0;
		faceIndex = select(0.0, 1.0, is_neg_x);
		ma = 0.5 / vAbs.x;
		uv = vec2f(select(-dir.z, dir.z, is_neg_x), -dir.y);
		tileOffset = vec2f(0.0, select(0.0, 1.0, is_neg_x));
	}
	uv = uv * ma + 0.5;
	return FaceCoords(uv, faceIndex, tileOffset);
}
fn getCubemapAtlasCoordinates(omniAtlasViewport: vec3f, shadowEdgePixels: f32, shadowTextureResolution: f32, dir: vec3f) -> vec2f {
	let faceData: FaceCoords = getCubemapFaceCoordinates(dir);
	var uv: vec2f = faceData.uv;
	let tileOffset: vec2f = faceData.tileOffset;
	let atlasFaceSize: f32 = omniAtlasViewport.z;
	let tileSize: f32 = shadowTextureResolution * atlasFaceSize;
	var offset: f32 = shadowEdgePixels / tileSize;
	uv = uv * (1.0 - offset * 2.0) + offset;
	uv = uv * atlasFaceSize;
	uv = uv + tileOffset * atlasFaceSize;
	uv = uv + omniAtlasViewport.xy;
	return uv;
}
`;

var clusteredLightCookies_default2 = `
fn _getCookieClustered(tex: texture_2d<f32>, texSampler: sampler, uv: vec2f, intensity: f32, cookieChannel: vec4f) -> vec3f {
	let pixel: vec4f = mix(vec4f(1.0), textureSampleLevel(tex, texSampler, uv, 0.0), intensity);
	let isRgb: bool = dot(cookieChannel.rgb, vec3f(1.0)) == 3.0;
	return select(vec3f(dot(pixel, cookieChannel)), pixel.rgb, isRgb);
}
fn getCookie2DClustered(tex: texture_2d<f32>, texSampler: sampler, transform: mat4x4f, worldPosition: vec3f, intensity: f32, cookieChannel: vec4f) -> vec3f {
	let projPos: vec4f = transform * vec4f(worldPosition, 1.0);
	return _getCookieClustered(tex, texSampler, projPos.xy / projPos.w, intensity, cookieChannel);
}
fn getCookieCubeClustered(tex: texture_2d<f32>, texSampler: sampler, dir: vec3f, intensity: f32, cookieChannel: vec4f, shadowTextureResolution: f32, shadowEdgePixels: f32, omniAtlasViewport: vec3f) -> vec3f {
	let uv: vec2f = getCubemapAtlasCoordinates(omniAtlasViewport, shadowEdgePixels, shadowTextureResolution, dir);
	return _getCookieClustered(tex, texSampler, uv, intensity, cookieChannel);
}
`;

var clusteredLightShadows_default2 = `
fn _getShadowCoordPerspZbuffer(shadowMatrix: mat4x4f, shadowParams: vec4f, wPos: vec3f) -> vec3f {
	var projPos = shadowMatrix * vec4f(wPos, 1.0);
	return projPos.xyz / projPos.w;
}
fn getShadowCoordPerspZbufferNormalOffset(shadowMatrix: mat4x4f, shadowParams: vec4f, normal: vec3f) -> vec3f {
	let wPos: vec3f = vPositionW + normal * shadowParams.y;
	return _getShadowCoordPerspZbuffer(shadowMatrix, shadowParams, wPos);
}
fn normalOffsetPointShadow(shadowParams: vec4f, lightPos: vec3f, lightDir: vec3f, lightDirNorm: vec3f, normal: vec3f) -> vec3f {
	let distScale: f32 = length(lightDir);
	let wPos: vec3f = vPositionW + normal * shadowParams.y * clamp(1.0 - dot(normal, -lightDirNorm), 0.0, 1.0) * distScale;
	let dir: vec3f = wPos - lightPos;
	return dir;
}
#if defined(CLUSTER_SHADOW_TYPE_PCF1)
	fn getShadowOmniClusteredPCF1(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowParams: vec4f, omniAtlasViewport: vec3f, shadowEdgePixels: f32, lightDir: vec3f) -> f32 {
		let shadowTextureResolution: f32 = shadowParams.x;
		let uv: vec2f = getCubemapAtlasCoordinates(omniAtlasViewport, shadowEdgePixels, shadowTextureResolution, lightDir);
		let shadowZ: f32 = length(lightDir) * shadowParams.w + shadowParams.z;
		return textureSampleCompareLevel(shadowMap, shadowMapSampler, uv, shadowZ);
	}
#endif
#if defined(CLUSTER_SHADOW_TYPE_PCF3)
	fn getShadowOmniClusteredPCF3(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowParams: vec4f, omniAtlasViewport: vec3f, shadowEdgePixels: f32, lightDir: vec3f) -> f32 {
		let shadowTextureResolution: f32 = shadowParams.x;
		let uv: vec2f = getCubemapAtlasCoordinates(omniAtlasViewport, shadowEdgePixels, shadowTextureResolution, lightDir);
		let shadowZ: f32 = length(lightDir) * shadowParams.w + shadowParams.z;
		let shadowCoord: vec3f = vec3f(uv, shadowZ);
		return getShadowPCF3x3(shadowMap, shadowMapSampler, shadowCoord, shadowParams);
	}
#endif
#if defined(CLUSTER_SHADOW_TYPE_PCF5)
	fn getShadowOmniClusteredPCF5(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowParams: vec4f, omniAtlasViewport: vec3f, shadowEdgePixels: f32, lightDir: vec3f) -> f32 {
		let shadowTextureResolution: f32 = shadowParams.x;
		let uv: vec2f = getCubemapAtlasCoordinates(omniAtlasViewport, shadowEdgePixels, shadowTextureResolution, lightDir);
		let shadowZ: f32 = length(lightDir) * shadowParams.w + shadowParams.z;
		let shadowCoord: vec3f = vec3f(uv, shadowZ);
		return getShadowPCF5x5(shadowMap, shadowMapSampler, shadowCoord, shadowParams);
	}
#endif
#if defined(CLUSTER_SHADOW_TYPE_PCF1)
	fn getShadowSpotClusteredPCF1(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec4f) -> f32 {
		return textureSampleCompareLevel(shadowMap, shadowMapSampler, shadowCoord.xy, shadowCoord.z);
	}
#endif
	#if defined(CLUSTER_SHADOW_TYPE_PCF3)
	fn getShadowSpotClusteredPCF3(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec4f) -> f32 {
		return getShadowSpotPCF3x3(shadowMap, shadowMapSampler, shadowCoord, shadowParams);
	}
#endif
	#if defined(CLUSTER_SHADOW_TYPE_PCF5)
	fn getShadowSpotClusteredPCF5(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec4f) -> f32 {
		return getShadowPCF5x5(shadowMap, shadowMapSampler, shadowCoord, shadowParams);
	}
#endif
`;

var clusteredLight_default2 = `
#include "lightBufferDefinesPS"
#include "clusteredLightUtilsPS"
#ifdef CLUSTER_COOKIES
	#include "clusteredLightCookiesPS"
#endif
#ifdef CLUSTER_SHADOWS
	#include "clusteredLightShadowsPS"
#endif
var clusterWorldTexture: texture_2d<u32>;
var lightsTexture: texture_2d<uff>;
#ifdef CLUSTER_SHADOWS
	var shadowAtlasTexture: texture_depth_2d;
	var shadowAtlasTextureSampler: sampler_comparison;
#endif
#ifdef CLUSTER_COOKIES
	var cookieAtlasTexture: texture_2d<f32>;
	var cookieAtlasTextureSampler: sampler;
#endif
uniform clusterMaxCells: i32;
uniform numClusteredLights: i32;
uniform clusterTextureWidth: i32;
uniform clusterCellsCountByBoundsSize: vec3f;
uniform clusterBoundsMin: vec3f;
uniform clusterBoundsDelta: vec3f;
uniform clusterCellsDot: vec3i;
uniform clusterCellsMax: vec3i;
uniform shadowAtlasParams: vec2f;
struct ClusterLightData {
	position: vec3f,
	lightIndex: i32,
	direction: vec3f,
	shape: u32,
	color: vec3f,
	shadowIntensity: f32,
	range: f32,
	biasesData: f32,
	cookieIntensity: f32,
	isSpot: bool,
	falloffModeLinear: bool,
	isDynamic: bool,
	isLightmapped: bool
}
struct ClusterLightSpotData {
	innerConeAngleCos: f32,
	outerConeAngleCos: f32
}
struct ClusterLightAreaData {
	halfWidth: vec3f,
	halfHeight: vec3f
}
struct ClusterLightShadowData {
	shadowBias: f32,
	shadowNormalBias: f32
}
var<private> lightProjectionMatrix: mat4x4f;
var<private> clusterLightData_flags: u32;
var<private> clusterLightData_anglesData: f32;
var<private> clusterLightData_colorBFlagsData: u32;
fn sampleLightTextureF(lightIndex: i32, index: i32) -> vec4f {
	return textureLoad(lightsTexture, vec2<i32>(index, lightIndex), 0);
}
fn decodeClusterLightCore(lightIndex: i32) -> ClusterLightData {
	var clusterLightData: ClusterLightData;
	clusterLightData.lightIndex = lightIndex;
	let halfData: vec4f = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_COLOR_ANGLES_BIAS});
	clusterLightData_anglesData = halfData.z;
	clusterLightData.biasesData = halfData.w;
	clusterLightData_colorBFlagsData = bitcast<u32>(halfData.y);
	let colorRG: vec2f = unpack2x16float(bitcast<u32>(halfData.x));
	let colorB_flags: vec2f = unpack2x16float(clusterLightData_colorBFlagsData);
	clusterLightData.color = vec3f(colorRG, colorB_flags.x) * {LIGHT_COLOR_DIVIDER};
	let lightPosRange: vec4f = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_POSITION_RANGE});
	clusterLightData.position = lightPosRange.xyz;
	clusterLightData.range = lightPosRange.w;
	let lightDir_Flags: vec4f = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_DIRECTION_FLAGS});
	clusterLightData.direction = lightDir_Flags.xyz;
	clusterLightData_flags = bitcast<u32>(lightDir_Flags.w);
	clusterLightData.isSpot = (clusterLightData_flags & (1u << 30u)) != 0u;
	clusterLightData.shape = (clusterLightData_flags >> 28u) & 0x3u;
	clusterLightData.falloffModeLinear = (clusterLightData_flags & (1u << 27u)) == 0u;
	clusterLightData.shadowIntensity = f32((clusterLightData_flags >> 0u) & 0xFFu) / 255.0;
	clusterLightData.cookieIntensity = f32((clusterLightData_flags >> 8u) & 0xFFu) / 255.0;
	clusterLightData.isDynamic = (clusterLightData_flags & (1u << 22u)) != 0u;
	clusterLightData.isLightmapped = (clusterLightData_flags & (1u << 21u)) != 0u;
	return clusterLightData;
}
fn decodeClusterLightSpot() -> ClusterLightSpotData {
	let angleFlags: u32 = (clusterLightData_colorBFlagsData >> 16u) & 0xFFFFu;
	let angleValues: vec2f = unpack2x16float(bitcast<u32>(clusterLightData_anglesData));
	let innerVal: f32 = angleValues.x;
	let outerVal: f32 = angleValues.y;
	let innerIsVersine: bool = (angleFlags & 1u) != 0u;
	let outerIsVersine: bool = ((angleFlags >> 1u) & 1u) != 0u;
	return ClusterLightSpotData(
		select(innerVal, 1.0 - innerVal, innerIsVersine),
		select(outerVal, 1.0 - outerVal, outerIsVersine)
	);
}
fn decodeClusterLightOmniAtlasViewport(lightIndex: i32) -> vec3f {
	return sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_0}).xyz;
}
fn decodeClusterLightAreaData(lightIndex: i32) -> ClusterLightAreaData {
	return ClusterLightAreaData(
		sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_AREA_DATA_WIDTH}).xyz,
		sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_AREA_DATA_HEIGHT}).xyz
	);
}
fn decodeClusterLightProjectionMatrixData(lightIndex: i32) -> mat4x4f {
	let m0: vec4f = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_0});
	let m1: vec4f = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_1});
	let m2: vec4f = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_2});
	let m3: vec4f = sampleLightTextureF(lightIndex, {CLUSTER_TEXTURE_PROJ_MAT_3});
	return mat4x4f(m0, m1, m2, m3);
}
fn decodeClusterLightShadowData(biasesData: f32) -> ClusterLightShadowData {
	let biases: vec2f = unpack2x16float(bitcast<u32>(biasesData));
	return ClusterLightShadowData(biases.x, biases.y);
}
fn decodeClusterLightCookieData() -> vec4f {
	let cookieFlags: u32 = (clusterLightData_flags >> 23u) & 0x0Fu;
	let mask_uvec: vec4<u32> = vec4<u32>(cookieFlags) & vec4<u32>(1u, 2u, 4u, 8u);
	return step(vec4f(1.0), vec4f(mask_uvec));
}
fn evaluateLight(
	light: ClusterLightData,
	worldNormal: vec3f,
	viewDir: vec3f,
	reflectionDir: vec3f,
#if defined(LIT_CLEARCOAT)
	clearcoatReflectionDir: vec3f,
#endif
	gloss: f32,
	specularity: vec3f,
	geometricNormal: vec3f,
	tbn: mat3x3f,
#if defined(LIT_IRIDESCENCE)
	iridescenceFresnel: vec3f,
#endif
	clearcoat_worldNormal: vec3f,
	clearcoat_gloss: f32,
	sheen_gloss: f32,
	iridescence_intensity: f32
) {
	var cookieAttenuation: vec3f = vec3f(1.0);
	var diffuseAttenuation: f32 = 1.0;
	var falloffAttenuation: f32 = 1.0;
	let lightDirW: vec3f = evalOmniLight(light.position);
	let lightDirNormW: vec3f = normalize(lightDirW);
	#ifdef CLUSTER_AREALIGHTS
	if (light.shape != {LIGHTSHAPE_PUNCTUAL}) {
		let areaData: ClusterLightAreaData = decodeClusterLightAreaData(light.lightIndex);
		if (light.shape == {LIGHTSHAPE_RECT}) {
			calcRectLightValues(light.position, areaData.halfWidth, areaData.halfHeight);
		} else if (light.shape == {LIGHTSHAPE_DISK}) {
			calcDiskLightValues(light.position, areaData.halfWidth, areaData.halfHeight);
		} else {
			calcSphereLightValues(light.position, areaData.halfWidth, areaData.halfHeight);
		}
		falloffAttenuation = getFalloffWindow(light.range, lightDirW);
	} else
	#endif
	{
		if (light.falloffModeLinear) {
			falloffAttenuation = getFalloffLinear(light.range, lightDirW);
		} else {
			falloffAttenuation = getFalloffInvSquared(light.range, lightDirW);
		}
	}
	if (falloffAttenuation > 0.00001) {
		#ifdef CLUSTER_AREALIGHTS
		if (light.shape != {LIGHTSHAPE_PUNCTUAL}) {
			if (light.shape == {LIGHTSHAPE_RECT}) {
				diffuseAttenuation = getRectLightDiffuse(worldNormal, viewDir, lightDirW, lightDirNormW) * 16.0;
			} else if (light.shape == {LIGHTSHAPE_DISK}) {
				diffuseAttenuation = getDiskLightDiffuse(worldNormal, viewDir, lightDirW, lightDirNormW) * 16.0;
			} else {
				diffuseAttenuation = getSphereLightDiffuse(worldNormal, viewDir, lightDirW, lightDirNormW) * 16.0;
			}
		} else
		#endif
		{
			falloffAttenuation = falloffAttenuation * getLightDiffuse(worldNormal, viewDir, lightDirNormW);
		}
		if (light.isSpot) {
			let spotData: ClusterLightSpotData = decodeClusterLightSpot();
			falloffAttenuation = falloffAttenuation * getSpotEffect(light.direction, spotData.innerConeAngleCos, spotData.outerConeAngleCos, lightDirNormW);
		}
		#if defined(CLUSTER_COOKIES) || defined(CLUSTER_SHADOWS)
		if (falloffAttenuation > 0.00001) {
			if (light.shadowIntensity > 0.0 || light.cookieIntensity > 0.0) {
				var omniAtlasViewport: vec3f = vec3f(0.0);
				if (light.isSpot) {
					lightProjectionMatrix = decodeClusterLightProjectionMatrixData(light.lightIndex);
				} else {
					omniAtlasViewport = decodeClusterLightOmniAtlasViewport(light.lightIndex);
				}
				let shadowTextureResolution: f32 = uniform.shadowAtlasParams.x;
				let shadowEdgePixels: f32 = uniform.shadowAtlasParams.y;
				#ifdef CLUSTER_COOKIES
				if (light.cookieIntensity > 0.0) {
					let cookieChannelMask: vec4f = decodeClusterLightCookieData();
					if (light.isSpot) {
						cookieAttenuation = getCookie2DClustered(cookieAtlasTexture, cookieAtlasTextureSampler, lightProjectionMatrix, vPositionW, light.cookieIntensity, cookieChannelMask);
					} else {
						cookieAttenuation = getCookieCubeClustered(cookieAtlasTexture, cookieAtlasTextureSampler, lightDirW, light.cookieIntensity, cookieChannelMask, shadowTextureResolution, shadowEdgePixels, omniAtlasViewport);
					}
				}
				#endif
				#ifdef CLUSTER_SHADOWS
				if (light.shadowIntensity > 0.0) {
					let shadowData: ClusterLightShadowData = decodeClusterLightShadowData(light.biasesData);
					let shadowParams: vec4f = vec4f(shadowTextureResolution, shadowData.shadowNormalBias, shadowData.shadowBias, 1.0 / light.range);
					if (light.isSpot) {
						let shadowCoord: vec3f = getShadowCoordPerspZbufferNormalOffset(lightProjectionMatrix, shadowParams, geometricNormal);
						#if defined(CLUSTER_SHADOW_TYPE_PCF1)
							let shadow: f32 = getShadowSpotClusteredPCF1(shadowAtlasTexture, shadowAtlasTextureSampler, shadowCoord, shadowParams);
						#elif defined(CLUSTER_SHADOW_TYPE_PCF3)
							let shadow: f32 = getShadowSpotClusteredPCF3(shadowAtlasTexture, shadowAtlasTextureSampler, shadowCoord, shadowParams);
						#elif defined(CLUSTER_SHADOW_TYPE_PCF5)
							let shadow: f32 = getShadowSpotClusteredPCF5(shadowAtlasTexture, shadowAtlasTextureSampler, shadowCoord, shadowParams);
						#elif defined(CLUSTER_SHADOW_TYPE_PCSS)
							let shadow: f32 = getShadowSpotClusteredPCSS(shadowAtlasTexture, shadowAtlasTextureSampler, shadowCoord, shadowParams);
						#endif
						falloffAttenuation = falloffAttenuation * mix(1.0, shadow, light.shadowIntensity);
					} else {
						let dir: vec3f = normalOffsetPointShadow(shadowParams, light.position, lightDirW, lightDirNormW, geometricNormal);
						#if defined(CLUSTER_SHADOW_TYPE_PCF1)
							let shadow: f32 = getShadowOmniClusteredPCF1(shadowAtlasTexture, shadowAtlasTextureSampler, shadowParams, omniAtlasViewport, shadowEdgePixels, dir);
						#elif defined(CLUSTER_SHADOW_TYPE_PCF3)
							let shadow: f32 = getShadowOmniClusteredPCF3(shadowAtlasTexture, shadowAtlasTextureSampler, shadowParams, omniAtlasViewport, shadowEdgePixels, dir);
						#elif defined(CLUSTER_SHADOW_TYPE_PCF5)
							let shadow: f32 = getShadowOmniClusteredPCF5(shadowAtlasTexture, shadowAtlasTextureSampler, shadowParams, omniAtlasViewport, shadowEdgePixels, dir);
						#endif
						falloffAttenuation = falloffAttenuation * mix(1.0, shadow, light.shadowIntensity);
					}
				}
				#endif
			}
		}
		#endif
		#ifdef CLUSTER_AREALIGHTS
		if (light.shape != {LIGHTSHAPE_PUNCTUAL}) {
			{
				var areaDiffuse: vec3f = (diffuseAttenuation * falloffAttenuation) * light.color * cookieAttenuation;
				#if defined(LIT_SPECULAR)
					areaDiffuse = mix(areaDiffuse, vec3f(0.0), dLTCSpecFres);
				#endif
				dDiffuseLight = dDiffuseLight + areaDiffuse;
			}
			#ifdef LIT_SPECULAR
				var areaLightSpecular: f32;
				if (light.shape == {LIGHTSHAPE_RECT}) {
					areaLightSpecular = getRectLightSpecular(worldNormal, viewDir);
				} else if (light.shape == {LIGHTSHAPE_DISK}) {
					areaLightSpecular = getDiskLightSpecular(worldNormal, viewDir);
				} else {
					areaLightSpecular = getSphereLightSpecular(worldNormal, viewDir);
				}
				dSpecularLight = dSpecularLight + dLTCSpecFres * areaLightSpecular * falloffAttenuation * light.color * cookieAttenuation;
				#ifdef LIT_CLEARCOAT
					var areaLightSpecularCC: f32;
					if (light.shape == {LIGHTSHAPE_RECT}) {
						areaLightSpecularCC = getRectLightSpecular(clearcoat_worldNormal, viewDir);
					} else if (light.shape == {LIGHTSHAPE_DISK}) {
						areaLightSpecularCC = getDiskLightSpecular(clearcoat_worldNormal, viewDir);
					} else {
						areaLightSpecularCC = getSphereLightSpecular(clearcoat_worldNormal, viewDir);
					}
					ccSpecularLight = ccSpecularLight + ccLTCSpecFres * areaLightSpecularCC * falloffAttenuation * light.color  * cookieAttenuation;
				#endif
			#endif
		} else
		#endif
		{
			{
				var punctualDiffuse: vec3f = falloffAttenuation * light.color * cookieAttenuation;
				#if defined(CLUSTER_AREALIGHTS)
				#if defined(LIT_SPECULAR)
					punctualDiffuse = mix(punctualDiffuse, vec3f(0.0), specularity);
				#endif
				#endif
				dDiffuseLight = dDiffuseLight + punctualDiffuse;
			}
			#ifdef LIT_SPECULAR
				let halfDir: vec3f = normalize(-lightDirNormW + viewDir);
				#ifdef LIT_SPECULAR_FRESNEL
					dSpecularLight = dSpecularLight +
						getLightSpecular(halfDir, reflectionDir, worldNormal, viewDir, lightDirNormW, gloss, tbn) * falloffAttenuation * light.color * cookieAttenuation *
						getFresnel(
							dot(viewDir, halfDir),
							gloss,
							specularity
						#if defined(LIT_IRIDESCENCE)
							, iridescenceFresnel,
							iridescence_intensity
						#endif
							);
				#else
					dSpecularLight = dSpecularLight + getLightSpecular(halfDir, reflectionDir, worldNormal, viewDir, lightDirNormW, gloss, tbn) * falloffAttenuation * light.color * cookieAttenuation * specularity;
				#endif
				#ifdef LIT_CLEARCOAT
					#ifdef LIT_SPECULAR_FRESNEL
						ccSpecularLight = ccSpecularLight + getLightSpecular(halfDir, clearcoatReflectionDir, clearcoat_worldNormal, viewDir, lightDirNormW, clearcoat_gloss, tbn) * falloffAttenuation * light.color * cookieAttenuation * getFresnelCC(dot(viewDir, halfDir));
					#else
						ccSpecularLight = ccSpecularLight + getLightSpecular(halfDir, clearcoatReflectionDir, clearcoat_worldNormal, viewDir, lightDirNormW, clearcoat_gloss, tbn) * falloffAttenuation * light.color * cookieAttenuation;
					#endif
				#endif
				#ifdef LIT_SHEEN
					sSpecularLight = sSpecularLight + getLightSpecularSheen(halfDir, worldNormal, viewDir, lightDirNormW, sheen_gloss) * falloffAttenuation * light.color * cookieAttenuation;
				#endif
			#endif
		}
	}
	dAtten = falloffAttenuation;
	dLightDirNormW = lightDirNormW;
}
fn evaluateClusterLight(
	lightIndex: i32,
	worldNormal: vec3f,
	viewDir: vec3f,
	reflectionDir: vec3f,
#if defined(LIT_CLEARCOAT)
	clearcoatReflectionDir: vec3f,
#endif
	gloss: f32,
	specularity: vec3f,
	geometricNormal: vec3f,
	tbn: mat3x3f,
#if defined(LIT_IRIDESCENCE)
	iridescenceFresnel: vec3f,
#endif
	clearcoat_worldNormal: vec3f,
	clearcoat_gloss: f32,
	sheen_gloss: f32,
	iridescence_intensity: f32
) {
	let clusterLightData: ClusterLightData = decodeClusterLightCore(lightIndex);
	#ifdef CLUSTER_MESH_DYNAMIC_LIGHTS
		let acceptLightMask: bool = clusterLightData.isDynamic;
	#else
		let acceptLightMask: bool = clusterLightData.isLightmapped;
	#endif
	if (acceptLightMask) {
		evaluateLight(
			clusterLightData,
			worldNormal,
			viewDir,
			reflectionDir,
#if defined(LIT_CLEARCOAT)
			clearcoatReflectionDir,
#endif
			gloss,
			specularity,
			geometricNormal,
			tbn,
#if defined(LIT_IRIDESCENCE)
			iridescenceFresnel,
#endif
			clearcoat_worldNormal,
			clearcoat_gloss,
			sheen_gloss,
			iridescence_intensity
		);
	}
}
fn addClusteredLights(
	worldNormal: vec3f,
	viewDir: vec3f,
	reflectionDir: vec3f,
#if defined(LIT_CLEARCOAT)
	clearcoatReflectionDir: vec3f,
#endif
	gloss: f32,
	specularity: vec3f,
	geometricNormal: vec3f,
	tbn: mat3x3f,
#if defined(LIT_IRIDESCENCE)
	iridescenceFresnel: vec3f,
#endif
	clearcoat_worldNormal: vec3f,
	clearcoat_gloss: f32,
	sheen_gloss: f32,
	iridescence_intensity: f32
) {
	if (uniform.numClusteredLights <= 1) {
		return;
	}
	let cellCoords: vec3i = vec3i(floor((vPositionW - uniform.clusterBoundsMin) * uniform.clusterCellsCountByBoundsSize));
	if (!(any(cellCoords < vec3i(0)) || any(cellCoords >= uniform.clusterCellsMax))) {
		let cellIndex: i32 = cellCoords.x * uniform.clusterCellsDot.x + cellCoords.y * uniform.clusterCellsDot.y + cellCoords.z * uniform.clusterCellsDot.z;
		let clusterV: i32 = cellIndex / uniform.clusterTextureWidth;
		let clusterU: i32 = cellIndex - clusterV * uniform.clusterTextureWidth;
		for (var lightCellIndex: i32 = 0; lightCellIndex < uniform.clusterMaxCells; lightCellIndex = lightCellIndex + 1) {
			let lightIndex: u32 = textureLoad(clusterWorldTexture, vec2<i32>(clusterU + lightCellIndex, clusterV), 0).r;
			if (lightIndex == 0u) {
				break;
			}
			evaluateClusterLight(
				i32(lightIndex),
				worldNormal,
				viewDir,
				reflectionDir,
#if defined(LIT_CLEARCOAT)
				clearcoatReflectionDir,
#endif
				gloss,
				specularity,
				geometricNormal,
				tbn,
#if defined(LIT_IRIDESCENCE)
				iridescenceFresnel,
#endif
				clearcoat_worldNormal,
				clearcoat_gloss,
				sheen_gloss,
				iridescence_intensity
			);
		}
	}
}`;

var combine_default2 = `
fn combineColor(albedo: vec3f, sheenSpecularity: vec3f, clearcoatSpecularity: f32) -> vec3f {
	var ret: vec3f = vec3f(0.0);
	#ifdef LIT_OLD_AMBIENT
		ret = ret + ((dDiffuseLight - uniform.light_globalAmbient) * albedo + uniform.material_ambient * uniform.light_globalAmbient);
	#else
		ret = ret + (albedo * dDiffuseLight);
	#endif
	#ifdef LIT_SPECULAR
		ret = ret + dSpecularLight;
	#endif
	#ifdef LIT_REFLECTIONS
		ret = ret + (dReflection.rgb * dReflection.a);
	#endif
	#ifdef LIT_SHEEN
		let sheenScaling: f32 = 1.0 - max(max(sheenSpecularity.r, sheenSpecularity.g), sheenSpecularity.b) * 0.157;
		ret = ret * sheenScaling + (sSpecularLight + sReflection.rgb) * sheenSpecularity;
	#endif
	#ifdef LIT_CLEARCOAT
		let clearCoatScaling: f32 = 1.0 - ccFresnel * clearcoatSpecularity;
		ret = ret * clearCoatScaling + (ccSpecularLight + ccReflection) * clearcoatSpecularity;
	#endif
	return ret;
}
`;

var cookie_blit_2d_default2 = `
	varying uv0: vec2f;
	var blitTexture: texture_2d<f32>;
	var blitTextureSampler : sampler;
	@fragment
	fn fragmentMain(input : FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		output.color = textureSample(blitTexture, blitTextureSampler, input.uv0);
		return output;
	}
`;

var cookie_blit_cube_default2 = `
	varying uv0: vec2f;
	uniform invViewProj: mat4x4<f32>;
	var blitTexture: texture_cube<f32>;
	var blitTextureSampler : sampler;
	@fragment
	fn fragmentMain(input : FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		var projPos = vec4f(input.uv0 * 2.0 - 1.0, 0.5, 1.0);
		var worldPos = uniform.invViewProj * projPos;
		output.color = textureSample(blitTexture, blitTextureSampler, worldPos.xyz);
		return output;
	}
`;

var cookie_blit_default2 = `
	attribute vertex_position: vec2f;
	varying uv0: vec2f;
	@vertex
	fn vertexMain(input: VertexInput) -> VertexOutput {
		var output: VertexOutput;
		output.position = vec4f(input.vertex_position, 0.5, 1.0);
		output.uv0 = input.vertex_position * 0.5 + vec2f(0.5, 0.5);
		output.uv0.y = 1.0 - output.uv0.y;
		return output;
	}
`;

var cubeMapProject_default2 = `
#if LIT_CUBEMAP_PROJECTION == BOX
	uniform envBoxMin: vec3f;
	uniform envBoxMax: vec3f;
#endif
fn cubeMapProject(nrdir: vec3f) -> vec3f {
	#if LIT_CUBEMAP_PROJECTION == NONE
		return cubeMapRotate(nrdir);
	#endif
	#if LIT_CUBEMAP_PROJECTION == BOX
		let nrdir_rotated: vec3f = cubeMapRotate(nrdir);
		let rbmax: vec3f = (uniform.envBoxMax - vPositionW) / nrdir_rotated;
		let rbmin: vec3f = (uniform.envBoxMin - vPositionW) / nrdir_rotated;
		let rbminmax: vec3f = select(rbmin, rbmax, nrdir_rotated > vec3f(0.0));
		let fa: f32 = min(min(rbminmax.x, rbminmax.y), rbminmax.z);
		let posonbox: vec3f = vPositionW + nrdir_rotated * fa;
		let envBoxPos: vec3f = (uniform.envBoxMin + uniform.envBoxMax) * 0.5;
		return normalize(posonbox - envBoxPos);
	#endif
}
`;

var cubeMapRotate_default2 = `
#ifdef CUBEMAP_ROTATION
uniform cubeMapRotationMatrix: mat3x3f;
#endif
fn cubeMapRotate(refDir: vec3f) -> vec3f {
#ifdef CUBEMAP_ROTATION
	return refDir * uniform.cubeMapRotationMatrix;
#else
	return refDir;
#endif
}
`;

var debug_output_default2 = `
#ifdef DEBUG_ALBEDO_PASS
output.color = vec4(gammaCorrectOutput(dAlbedo), 1.0);
#endif
#ifdef DEBUG_UV0_PASS
output.color = vec4f(litArgs_albedo , 1.0);
#endif
#ifdef DEBUG_WORLD_NORMAL_PASS
output.color = vec4f(litArgs_worldNormal * 0.5 + 0.5, 1.0);
#endif
#ifdef DEBUG_OPACITY_PASS
output.color = vec4f(vec3f(litArgs_opacity) , 1.0);
#endif
#ifdef DEBUG_SPECULARITY_PASS
output.color = vec4f(litArgs_specularity, 1.0);
#endif
#ifdef DEBUG_GLOSS_PASS
output.color = vec4f(vec3f(litArgs_gloss) , 1.0);
#endif
#ifdef DEBUG_METALNESS_PASS
output.color = vec4f(vec3f(litArgs_metalness) , 1.0);
#endif
#ifdef DEBUG_AO_PASS
output.color = vec4f(vec3f(litArgs_ao) , 1.0);
#endif
#ifdef DEBUG_EMISSION_PASS
output.color = vec4f(gammaCorrectOutput(litArgs_emission), 1.0);
#endif
`;

var debug_process_frontend_default2 = `
#ifdef DEBUG_LIGHTING_PASS
	litArgs_albedo = vec3f(0.5);
#endif
#ifdef DEBUG_UV0_PASS
#ifdef VARYING_VUV0
	litArgs_albedo = vec3f(vUv0, 0.0);
#else
	litArgs_albedo = vec3f(0.0);
#endif
#endif
`;

var decode_default2 = `
#ifndef _DECODE_INCLUDED_
#define _DECODE_INCLUDED_
fn decodeLinear(raw: vec4f) -> vec3f {
	return raw.rgb;
}
fn decodeGammaFloat(raw: f32) -> f32 {
	return pow(raw, 2.2);
}
fn decodeGamma3(raw: vec3f) -> vec3f {
	return pow(raw, vec3f(2.2));
}
fn decodeGamma(raw: vec4f) -> vec3f {
	return pow(raw.xyz, vec3f(2.2));
}
fn decodeRGBM(raw: vec4f) -> vec3f {
	let color = (8.0 * raw.a) * raw.rgb;
	return color * color;
}
fn decodeRGBP(raw: vec4f) -> vec3f {
	let color = raw.rgb * (-raw.a * 7.0 + 8.0);
	return color * color;
}
fn decodeRGBE(raw: vec4f) -> vec3f {
	return select(vec3f(0.0), raw.xyz * pow(2.0, raw.w * 255.0 - 128.0), raw.a != 0.0);
}
fn passThrough(raw: vec4f) -> vec4f {
	return raw;
}
fn unpackNormalXYZ(nmap: vec4f) -> vec3f {
	return nmap.xyz * 2.0 - 1.0;
}
fn unpackNormalXY(nmap: vec4f) -> vec3f {
	var xy = nmap.wy * 2.0 - 1.0;
	return vec3f(xy, sqrt(1.0 - clamp(dot(xy, xy), 0.0, 1.0)));
}
#endif
`;

var detailModes_default2 = `
#ifndef _DETAILMODES_INCLUDED_
#define _DETAILMODES_INCLUDED_
fn detailMode_mul(c1: vec3f, c2: vec3f) -> vec3f {
	return c1 * c2;
}
fn detailMode_add(c1: vec3f, c2: vec3f) -> vec3f {
	return c1 + c2;
}
fn detailMode_screen(c1: vec3f, c2: vec3f) -> vec3f {
	return 1.0 - (1.0 - c1)*(1.0 - c2);
}
fn detailMode_overlay(c1: vec3f, c2: vec3f) -> vec3f {
	return mix(1.0 - 2.0 * (1.0 - c1)*(1.0 - c2), 2.0 * c1 * c2, step(c1, vec3f(0.5)));
}
fn detailMode_min(c1: vec3f, c2: vec3f) -> vec3f {
	return min(c1, c2);
}
fn detailMode_max(c1: vec3f, c2: vec3f) -> vec3f {
	return max(c1, c2);
}
#endif
`;

var diffuse_default2 = `
uniform material_diffuse: vec3f;
#ifdef STD_DIFFUSEDETAIL_TEXTURE
	#include "detailModesPS"
#endif
fn getAlbedo() {
	dAlbedo = uniform.material_diffuse.rgb;
	#ifdef STD_DIFFUSE_TEXTURE
		var albedoTexture: vec3f = {STD_DIFFUSE_TEXTURE_DECODE}(textureSampleBias({STD_DIFFUSE_TEXTURE_NAME}, {STD_DIFFUSE_TEXTURE_NAME}Sampler, {STD_DIFFUSE_TEXTURE_UV}, uniform.textureBias)).{STD_DIFFUSE_TEXTURE_CHANNEL};
		#ifdef STD_DIFFUSEDETAIL_TEXTURE
			var albedoDetail: vec3f = {STD_DIFFUSEDETAIL_TEXTURE_DECODE}(textureSampleBias({STD_DIFFUSEDETAIL_TEXTURE_NAME}, {STD_DIFFUSEDETAIL_TEXTURE_NAME}Sampler, {STD_DIFFUSEDETAIL_TEXTURE_UV}, uniform.textureBias)).{STD_DIFFUSEDETAIL_TEXTURE_CHANNEL};
			albedoTexture = detailMode_{STD_DIFFUSEDETAIL_DETAILMODE}(albedoTexture, albedoDetail);
		#endif
		dAlbedo = dAlbedo * albedoTexture;
	#endif
	#ifdef STD_DIFFUSE_VERTEX
		dAlbedo = dAlbedo * saturate3(vVertexColor.{STD_DIFFUSE_VERTEX_CHANNEL});
	#endif
}
`;

var emissive_default2 = `
uniform material_emissive: vec3f;
uniform material_emissiveIntensity: f32;
fn getEmission() {
	dEmission = uniform.material_emissive * uniform.material_emissiveIntensity;
	#ifdef STD_EMISSIVE_TEXTURE
	dEmission *= {STD_EMISSIVE_TEXTURE_DECODE}(textureSampleBias({STD_EMISSIVE_TEXTURE_NAME}, {STD_EMISSIVE_TEXTURE_NAME}Sampler, {STD_EMISSIVE_TEXTURE_UV}, uniform.textureBias)).{STD_EMISSIVE_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_EMISSIVE_VERTEX
	dEmission = dEmission * saturate3(vVertexColor.{STD_EMISSIVE_VERTEX_CHANNEL});
	#endif
}
`;

var encode_default2 = `
fn encodeLinear(source: vec3f) -> vec4f {
	return vec4f(source, 1.0);
}
fn encodeGamma(source: vec3f) -> vec4f {
	return vec4f(pow(source + vec3f(0.0000001), vec3f(1.0 / 2.2)), 1.0);
}
fn encodeRGBM(source: vec3f) -> vec4f {
	var color: vec3f = pow(source, vec3f(0.5));
	color *= 1.0 / 8.0;
	var a: f32 = saturate(max(max(color.r, color.g), max(color.b, 1.0 / 255.0)));
	a = ceil(a * 255.0) / 255.0;
	color /= a;
	return vec4f(color, a);
}
fn encodeRGBP(source: vec3f) -> vec4f {
	var gamma: vec3f = pow(source, vec3f(0.5));
	var maxVal: f32 = min(8.0, max(1.0, max(gamma.x, max(gamma.y, gamma.z))));
	var v: f32 = 1.0 - ((maxVal - 1.0) / 7.0);
	v = ceil(v * 255.0) / 255.0;
	return vec4f(gamma / (-v * 7.0 + 8.0), v);
}
fn encodeRGBE(source: vec3f) -> vec4f {
	var maxVal: f32 = max(source.x, max(source.y, source.z));
	if (maxVal < 1e-32) {
		return vec4f(0.0, 0.0, 0.0, 0.0);
	} else {
		var e: f32 = ceil(log2(maxVal));
		return vec4f(source / pow(2.0, e), (e + 128.0) / 255.0);
	}
}
`;

var end_default2 = `
	var finalRgb: vec3f = combineColor(litArgs_albedo, litArgs_sheen_specularity, litArgs_clearcoat_specularity);
	finalRgb = finalRgb + litArgs_emission;
	finalRgb = addFog(finalRgb);
	finalRgb = toneMap(finalRgb);
	finalRgb = gammaCorrectOutput(finalRgb);
	output.color = vec4f(finalRgb, output.color.a);
`;

var envAtlas_default2 = `
#ifndef _ENVATLAS_INCLUDED_
#define _ENVATLAS_INCLUDED_
const atlasSize : f32 = 512.0;
const seamSize : f32 = 1.0 / atlasSize;
fn mapUv(uv : vec2f, rect : vec4f) -> vec2f {
	return vec2f(mix(rect.x + seamSize, rect.x + rect.z - seamSize, uv.x),
				 mix(rect.y + seamSize, rect.y + rect.w - seamSize, uv.y));
}
fn mapRoughnessUv(uv : vec2f, level : f32) -> vec2f {
	let t : f32 = 1.0 / exp2(level);
	return mapUv(uv, vec4f(0.0, 1.0 - t, t, t * 0.5));
}
fn mapShinyUv(uv : vec2f, level : f32) -> vec2f {
	let t : f32 = 1.0 / exp2(level);
	return mapUv(uv, vec4f(1.0 - t, 1.0 - t, t, t * 0.5));
}
#endif
`;

var envProc_default2 = `
#ifdef LIT_SKYBOX_INTENSITY
	uniform skyboxIntensity : f32;
#endif
fn processEnvironment(color : vec3f) -> vec3f {
	#ifdef LIT_SKYBOX_INTENSITY
		return color * uniform.skyboxIntensity;
	#else
		return color;
	#endif
}
`;

var falloffInvSquared_default2 = `
fn getFalloffWindow(lightRadius: f32, lightDir: vec3f) -> f32 {
	let sqrDist: f32 = dot(lightDir, lightDir);
	let invRadius: f32 = 1.0 / lightRadius;
	return square(saturate(1.0 - square(sqrDist * square(invRadius))));
}
fn getFalloffInvSquared(lightRadius: f32, lightDir: vec3f) -> f32 {
	let sqrDist: f32 = dot(lightDir, lightDir);
	var falloff: f32 = 1.0 / (sqrDist + 1.0);
	let invRadius: f32 = 1.0 / lightRadius;
	falloff = falloff * 16.0;
	falloff = falloff * square(saturate(1.0 - square(sqrDist * square(invRadius))));
	return falloff;
}
`;

var falloffLinear_default2 = `
fn getFalloffLinear(lightRadius: f32, lightDir: vec3f) -> f32 {
	let d: f32 = length(lightDir);
	return max(((lightRadius - d) / lightRadius), 0.0);
}
`;

var float_as_uint_default2 = `
#ifndef FLOAT_AS_UINT
#define FLOAT_AS_UINT
fn float2uint(value: f32) -> vec4f {
	let intBits = bitcast<u32>(value);
	return vec4f(
		f32((intBits >> 24u) & 0xffu),
		f32((intBits >> 16u) & 0xffu),
		f32((intBits >> 8u) & 0xffu),
		f32(intBits & 0xffu)
	) / 255.0;
}
fn uint2float(value: vec4f) -> f32 {
	let rgba_u32 = vec4<u32>(value * 255.0);
	let intBits: u32 =
		(rgba_u32.r << 24u) |
		(rgba_u32.g << 16u) |
		(rgba_u32.b << 8u)  |
		 rgba_u32.a;
	return bitcast<f32>(intBits);
}
fn float2vec4(value: f32) -> vec4f {
	#if defined(CAPS_TEXTURE_FLOAT_RENDERABLE)
		return vec4f(value, 1.0, 1.0, 1.0);
	#else
		return float2uint(value);
	#endif
}
#endif
`;

var fog_default2 = `
#include "fogMathPS"
var<private> dBlendModeFogFactor : f32 = 1.0;
#if (FOG != NONE)
	uniform fog_color : vec3f;
	
	#if (FOG == LINEAR)
		uniform fog_start : f32;
		uniform fog_end : f32;
	#else
		uniform fog_density : f32;
	#endif
#endif
#ifdef VERTEXSHADER
	fn getFogFactor(depth: f32) -> f32 {
#else
	fn getFogFactor() -> f32 {
		let depth = pcPosition.z / pcPosition.w;
#endif
	#if (FOG == LINEAR)
		return evaluateFogFactorLinear(depth, uniform.fog_start, uniform.fog_end);
	#elif (FOG == EXP)
		return evaluateFogFactorExp(depth, uniform.fog_density);
	#elif (FOG == EXP2)
		return evaluateFogFactorExp2(depth, uniform.fog_density);
	#else
		return 1.0;
	#endif
}
#ifdef VERTEXSHADER
	fn addFog(color: vec3f, depth: f32) -> vec3f {
		#if (FOG != NONE)
			return mix(uniform.fog_color * dBlendModeFogFactor, color, getFogFactor(depth));
		#else
			return color;
		#endif
	}
#else
	fn addFog(color: vec3f) -> vec3f {
		#if (FOG != NONE)
			return mix(uniform.fog_color * dBlendModeFogFactor, color, getFogFactor());
		#else
			return color;
		#endif
	}
#endif
`;

var fogMath_default = `
fn evaluateFogFactorLinear(depth: f32, fogStart: f32, fogEnd: f32) -> f32 {
	return clamp((fogEnd - depth) / (fogEnd - fogStart), 0.0, 1.0);
}
fn evaluateFogFactorExp(depth: f32, fogDensity: f32) -> f32 {
	return clamp(exp(-depth * fogDensity), 0.0, 1.0);
}
fn evaluateFogFactorExp2(depth: f32, fogDensity: f32) -> f32 {
	return clamp(exp(-depth * depth * fogDensity * fogDensity), 0.0, 1.0);
}
`;

var fresnelSchlick_default2 = `
fn pow5(x: f32) -> f32 {
	let x2: f32 = x * x;
	return x2 * x2 * x;
}
fn getFresnel(
		cosTheta: f32,
		gloss: f32,
		specularity: vec3f
	#if defined(LIT_IRIDESCENCE)
		, iridescenceFresnel: vec3f,
		iridescenceIntensity: f32
	#endif
) -> vec3f {
	let fresnel: f32 = pow5(1.0 - saturate(cosTheta));
	let glossSq: f32 = gloss * gloss;
	let specIntensity: f32 = max(specularity.r, max(specularity.g, specularity.b));
	let ret: vec3f = specularity + (max(vec3f(glossSq * specIntensity), specularity) - specularity) * fresnel;
	#if defined(LIT_IRIDESCENCE)
		return mix(ret, iridescenceFresnel, iridescenceIntensity);
	#else
		return ret;
	#endif
}
fn getFresnelCC(cosTheta: f32) -> f32 {
	let fresnel: f32 = pow5(1.0 - saturate(cosTheta));
	return 0.04 + (1.0 - 0.04) * fresnel;
}`;

var fullscreenQuad_default2 = `
attribute vertex_position: vec2f;
varying vUv0: vec2f;
@vertex
fn vertexMain(input: VertexInput) -> VertexOutput {
	var output: VertexOutput;
	output.position = vec4f(input.vertex_position, 0.5, 1.0);
	output.vUv0 = input.vertex_position.xy * 0.5 + vec2f(0.5);
	return output;
}
`;

var gamma_default2 = `
#include "decodePS"
#if (GAMMA == SRGB)
	fn gammaCorrectInput(color: f32) -> f32 {
		return decodeGammaFloat(color);
	}
	fn gammaCorrectInputVec3(color: vec3f) -> vec3f {
		return decodeGamma3(color);
	}
	fn gammaCorrectInputVec4(color: vec4f) -> vec4f {
		return vec4f(decodeGamma3(color.xyz), color.w);
	}
	fn gammaCorrectOutput(color: vec3f) -> vec3f {
		return pow(color + 0.0000001, vec3f(1.0 / 2.2));
	}
#else
	fn gammaCorrectInput(color: f32) -> f32 {
		return color;
	}
	fn gammaCorrectInputVec3(color: vec3f) -> vec3f {
		return color;
	}
	fn gammaCorrectInputVec4(color: vec4f) -> vec4f {
		return color;
	}
	fn gammaCorrectOutput(color: vec3f) -> vec3f {
		return color;
	}
#endif
`;

var gloss_default2 = `
#ifdef STD_GLOSS_CONSTANT
	uniform material_gloss: f32;
#endif
fn getGlossiness() {
	dGlossiness = 1.0;
	#ifdef STD_GLOSS_CONSTANT
	dGlossiness = dGlossiness * uniform.material_gloss;
	#endif
	#ifdef STD_GLOSS_TEXTURE
	dGlossiness = dGlossiness * textureSampleBias({STD_GLOSS_TEXTURE_NAME}, {STD_GLOSS_TEXTURE_NAME}Sampler, {STD_GLOSS_TEXTURE_UV}, uniform.textureBias).{STD_GLOSS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_GLOSS_VERTEX
	dGlossiness = dGlossiness * saturate(vVertexColor.{STD_GLOSS_VERTEX_CHANNEL});
	#endif
	#ifdef STD_GLOSS_INVERT
	dGlossiness = 1.0 - dGlossiness;
	#endif
	dGlossiness = dGlossiness + 0.0000001;
}
`;

var quad_default2 = `
	attribute aPosition: vec2f;
	varying uv0: vec2f;
	@vertex fn vertexMain(input: VertexInput) -> VertexOutput {
		var output: VertexOutput;
		output.position = vec4f(input.aPosition, 0.0, 1.0);
		output.uv0 = getImageEffectUV((input.aPosition + 1.0) * 0.5);
		return output;
	}
`;

var indirect_core_default = `
struct DrawIndexedIndirectArgs {
	indexCount: u32,
	instanceCount: u32,
	firstIndex: u32,
	baseVertex: i32,
	firstInstance: u32
};
struct DrawIndirectArgs {
	vertexCount: u32,
	instanceCount: u32,
	firstVertex: u32,
	firstInstance: u32,
	_pad: u32
};
`;

var immediateLine_default3 = `
	#include "gammaPS"
	varying color: vec4f;
	@fragment
	fn fragmentMain(input : FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		output.color = vec4f(gammaCorrectOutput(decodeGamma3(input.color.rgb)), input.color.a);
		return output;
	}
`;

var immediateLine_default4 = `
	attribute vertex_position: vec4f;
	attribute vertex_color: vec4f;
	uniform matrix_model: mat4x4f;
	uniform matrix_viewProjection: mat4x4f;
	varying color: vec4f;
	@vertex
	fn vertexMain(input : VertexInput) -> VertexOutput {
		var output : VertexOutput;
		output.color = input.vertex_color;
		output.position = uniform.matrix_viewProjection * uniform.matrix_model * input.vertex_position;
		return output;
	}
`;

var iridescenceDiffraction_default2 = `
uniform material_iridescenceRefractionIndex: f32;
fn iridescence_iorToFresnelScalar(transmittedIor: f32, incidentIor: f32) -> f32 {
	return pow((transmittedIor - incidentIor) / (transmittedIor + incidentIor), 2.0);
}
fn iridescence_iorToFresnelVec3(transmittedIor: vec3f, incidentIor: f32) -> vec3f {
	return pow((transmittedIor - vec3f(incidentIor)) / (transmittedIor + vec3f(incidentIor)), vec3f(2.0));
}
fn iridescence_fresnelToIor(f0: vec3f) -> vec3f {
	let sqrtF0: vec3f = sqrt(f0);
	return (vec3f(1.0) + sqrtF0) / (vec3f(1.0) - sqrtF0);
}
const XYZ_TO_REC709: mat3x3f = mat3x3f(
	vec3f(3.2404542, -1.5371385, -0.4985314),
	vec3f(-0.9692660,  1.8760108,  0.0415560),
	vec3f(0.0556434, -0.2040259,  1.0572252)
);
fn iridescence_sensitivity(opd: f32, shift: vec3f) -> vec3f {
	let PI: f32 = 3.141592653589793;
	let phase: f32 = 2.0 * PI * opd * 1.0e-9;
	const val: vec3f = vec3f(5.4856e-13, 4.4201e-13, 5.2481e-13);
	const pos: vec3f = vec3f(1.6810e+06, 1.7953e+06, 2.2084e+06);
	const var_: vec3f = vec3f(4.3278e+09, 9.3046e+09, 6.6121e+09);
	var xyz: vec3f = val * sqrt(2.0 * PI * var_) * cos(pos * phase + shift) * exp(-pow(phase, 2.0) * var_);
	xyz.x = xyz.x + 9.7470e-14 * sqrt(2.0 * PI * 4.5282e+09) * cos(2.2399e+06 * phase + shift[0]) * exp(-4.5282e+09 * pow(phase, 2.0));
	xyz = xyz / vec3f(1.0685e-07);
	return XYZ_TO_REC709 * xyz;
}
fn iridescence_fresnelScalar(cosTheta: f32, f0: f32) -> f32 {
	let x: f32 = clamp(1.0 - cosTheta, 0.0, 1.0);
	let x2: f32 = x * x;
	let x5: f32 = x * x2 * x2;
	return f0 + (1.0 - f0) * x5;
}
fn iridescence_fresnelVec3(cosTheta: f32, f0: vec3f) -> vec3f {
	let x: f32 = clamp(1.0 - cosTheta, 0.0, 1.0);
	let x2: f32 = x * x;
	let x5: f32 = x * x2 * x2;
	return f0 + (vec3f(1.0) - f0) * x5;
}
fn calcIridescence(outsideIor: f32, cosTheta: f32, base_f0: vec3f, iridescenceThickness: f32) -> vec3f {
	let PI: f32 = 3.141592653589793;
	let iridescenceIor: f32 = mix(outsideIor, uniform.material_iridescenceRefractionIndex, smoothstep(0.0, 0.03, iridescenceThickness));
	let sinTheta2Sq: f32 = pow(outsideIor / iridescenceIor, 2.0) * (1.0 - pow(cosTheta, 2.0));
	let cosTheta2Sq: f32 = 1.0 - sinTheta2Sq;
	if (cosTheta2Sq < 0.0) {
		return vec3f(1.0);
	}
	let cosTheta2: f32 = sqrt(cosTheta2Sq);
	let r0: f32 = iridescence_iorToFresnelScalar(iridescenceIor, outsideIor);
	let r12: f32 = iridescence_fresnelScalar(cosTheta, r0);
	let r21: f32 = r12;
	let t121: f32 = 1.0 - r12;
	let phi12: f32 = select(0.0, PI, iridescenceIor < outsideIor);
	let phi21: f32 = PI - phi12;
	let baseIor: vec3f = iridescence_fresnelToIor(base_f0 + vec3f(0.0001));
	let r1: vec3f = iridescence_iorToFresnelVec3(baseIor, iridescenceIor);
	let r23: vec3f = iridescence_fresnelVec3(cosTheta2, r1);
	let phi23: vec3f = select(vec3f(0.0), vec3f(PI), baseIor < vec3f(iridescenceIor));
	let opd: f32 = 2.0 * iridescenceIor * iridescenceThickness * cosTheta2;
	let phi: vec3f = vec3f(phi21) + phi23;
	let r123Sq: vec3f = clamp(vec3f(r12) * r23, vec3f(1e-5), vec3f(0.9999));
	let r123: vec3f = sqrt(r123Sq);
	let rs: vec3f = pow(vec3f(t121), vec3f(2.0)) * r23 / (vec3f(1.0) - r123Sq);
	let c0: vec3f = vec3f(r12) + rs;
	var i_irid: vec3f = c0;
	var cm: vec3f = rs - vec3f(t121);
	cm = cm * r123;
	let sm1: vec3f = 2.0 * iridescence_sensitivity(1.0 * opd, 1.0 * phi);
	i_irid = i_irid + cm * sm1;
	cm = cm * r123;
	let sm2: vec3f = 2.0 * iridescence_sensitivity(2.0 * opd, 2.0 * phi);
	i_irid = i_irid + cm * sm2;
	return max(i_irid, vec3f(0.0));
}
fn getIridescenceDiffraction(cosTheta: f32, specularity: vec3f, iridescenceThickness: f32) -> vec3f {
	return calcIridescence(1.0, cosTheta, specularity, iridescenceThickness);
}
`;

var iridescence_default2 = `
#ifdef STD_IRIDESCENCE_CONSTANT
	uniform material_iridescence: f32;
#endif
fn getIridescence() {
	var iridescence = 1.0;
	#ifdef STD_IRIDESCENCE_CONSTANT
	iridescence = iridescence * uniform.material_iridescence;
	#endif
	#ifdef STD_IRIDESCENCE_TEXTURE
	iridescence = iridescence * textureSampleBias({STD_IRIDESCENCE_TEXTURE_NAME}, {STD_IRIDESCENCE_TEXTURE_NAME}Sampler, {STD_IRIDESCENCE_TEXTURE_UV}, uniform.textureBias).{STD_IRIDESCENCE_TEXTURE_CHANNEL};
	#endif
	dIridescence = iridescence; 
}
`;

var iridescenceThickness_default2 = `
uniform material_iridescenceThicknessMax: f32;
#ifdef STD_IRIDESCENCETHICKNESS_TEXTURE
	uniform material_iridescenceThicknessMin: f32;
#endif
fn getIridescenceThickness() {
	#ifdef STD_IRIDESCENCETHICKNESS_TEXTURE
		var blend: f32 = textureSampleBias({STD_IRIDESCENCETHICKNESS_TEXTURE_NAME}, {STD_IRIDESCENCETHICKNESS_TEXTURE_NAME}Sampler, {STD_IRIDESCENCETHICKNESS_TEXTURE_UV}, uniform.textureBias).{STD_IRIDESCENCETHICKNESS_TEXTURE_CHANNEL};
		var iridescenceThickness: f32 = mix(uniform.material_iridescenceThicknessMin, uniform.material_iridescenceThicknessMax, blend);
	#else
		var iridescenceThickness: f32 = uniform.material_iridescenceThicknessMax;
	#endif
	dIridescenceThickness = iridescenceThickness; 
}
`;

var ior_default2 = `
#ifdef STD_IOR_CONSTANT
	uniform material_refractionIndex: f32;
#endif
fn getIor() {
#ifdef STD_IOR_CONSTANT
	dIor = uniform.material_refractionIndex;
#else
	dIor = 1.0 / 1.5;
#endif
}
`;

var lightDeclaration_default2 = `
#if defined(LIGHT{i})
	uniform light{i}_color: vec3f;
	#if LIGHT{i}TYPE == DIRECTIONAL
		uniform light{i}_direction: vec3f;
	#else
		#define LIT_CODE_LIGHTS_POINT
		uniform light{i}_position: vec3f;
		uniform light{i}_radius: f32;
		#if LIGHT{i}TYPE == SPOT
			#define LIT_CODE_LIGHTS_SPOT
			uniform light{i}_direction: vec3f;
			uniform light{i}_innerConeAngle: f32;
			uniform light{i}_outerConeAngle: f32;
		#endif
	#endif
	#if LIGHT{i}SHAPE != PUNCTUAL
		#define LIT_CODE_FALLOFF_SQUARED
		#if LIGHT{i}TYPE == DIRECTIONAL
			uniform light{i}_position: vec3f;
		#endif
		uniform light{i}_halfWidth: vec3f;
		uniform light{i}_halfHeight: vec3f;
	#else
		#if LIGHT{i}FALLOFF == LINEAR
			#define LIT_CODE_FALLOFF_LINEAR
		#endif
		#if LIGHT{i}FALLOFF == INVERSESQUARED
			#define LIT_CODE_FALLOFF_SQUARED
		#endif
	#endif
	#if defined(LIGHT{i}CASTSHADOW)
		#if LIGHT{i}TYPE != OMNI
			uniform light{i}_shadowMatrix: mat4x4f;
		#endif
		uniform light{i}_shadowIntensity: f32;
		uniform light{i}_shadowParams: vec4f;
		#if LIGHT{i}SHADOWTYPE == PCSS_32F
			uniform light{i}_shadowSearchArea: f32;
			uniform light{i}_cameraParams: vec4f;
			#if LIGHT{i}TYPE == DIRECTIONAL
				uniform light{i}_softShadowParams: vec4f;
				uniform light{i}_shadowCascadeRadii: vec4f;
			#endif
		#endif
		#if LIGHT{i}TYPE == DIRECTIONAL
			uniform light{i}_shadowMatrixPalette: array<mat4x4f, 4>;
			uniform light{i}_shadowCascadeDistances: vec4f;
			uniform light{i}_shadowCascadeCount: i32;
			uniform light{i}_shadowCascadeBlend: f32;
		#endif
		#if LIGHT{i}TYPE == OMNI
			NOT SUPPORTED
		#else
			#if defined(LIGHT{i}SHADOW_PCF)
				var light{i}_shadowMap: texture_depth_2d;
				var light{i}_shadowMapSampler: sampler_comparison;
			#else
				var light{i}_shadowMap: texture_2d<f32>;
				var light{i}_shadowMapSampler: sampler;
			#endif
		#endif
	#endif
	#if defined(LIGHT{i}COOKIE)
		#define LIT_CODE_COOKIE
		#if LIGHT{i}TYPE == OMNI
			NOT SUPPORTED
		#endif
		#if LIGHT{i}TYPE == SPOT
			NOT SUPPORTED
		#endif
	#endif
#endif
`;

var lightDiffuseLambert_default2 = `
fn getLightDiffuse(worldNormal: vec3f, viewDir: vec3f, lightDirNorm: vec3f) -> f32 {
	return max(dot(worldNormal, -lightDirNorm), 0.0);
}
`;

var lightDirPoint_default2 = `
fn evalOmniLight(lightPosW: vec3f) -> vec3f {
	return vPositionW - lightPosW;
}
`;

var lightEvaluation_default2 = `
#if defined(LIGHT{i})
	evaluateLight{i}(
		#if defined(LIT_IRIDESCENCE)
			iridescenceFresnel
		#endif
	);
#endif
`;

var lightFunctionLight_default2 = `
#if defined(LIGHT{i})
fn evaluateLight{i}(
	#if defined(LIT_IRIDESCENCE)
		iridescenceFresnel: vec3f
	#endif
) {
	var lightColor: vec3f = uniform.light{i}_color;
	#if LIGHT{i}TYPE == DIRECTIONAL && !defined(LIT_SHADOW_CATCHER)
		if (all(lightColor == vec3f(0.0, 0.0, 0.0))) {
			return;
		}
	#endif
	#if LIGHT{i}TYPE == DIRECTIONAL
		dLightDirNormW = uniform.light{i}_direction;
		dAtten = 1.0;
	#else
		var lightDirW: vec3f = evalOmniLight(uniform.light{i}_position);
		dLightDirNormW = normalize(lightDirW);
		#if defined(LIGHT{i}COOKIE)
			#if LIGHT{i}TYPE == SPOT
				#ifdef LIGHT{i}COOKIE_FALLOFF
					#ifdef LIGHT{i}COOKIE_TRANSFORM
						var cookieAttenuation: vec3f = getCookie2DXform(uniform.light{i}_cookie, uniform.light{i}_shadowMatrix, uniform.light{i}_cookieIntensity, uniform.light{i}_cookieMatrix, uniform.light{i}_cookieOffset).{LIGHT{i}COOKIE_CHANNEL};
					#else
						var cookieAttenuation: vec3f = getCookie2D(uniform.light{i}_cookie, uniform.light{i}_shadowMatrix, uniform.light{i}_cookieIntensity).{LIGHT{i}COOKIE_CHANNEL};
					#endif
				#else
					#ifdef LIGHT{i}COOKIE_TRANSFORM
						var cookieAttenuation: vec3f = getCookie2DClipXform(uniform.light{i}_cookie, uniform.light{i}_shadowMatrix, uniform.light{i}_cookieIntensity, uniform.light{i}_cookieMatrix, uniform.light{i}_cookieOffset).{LIGHT{i}COOKIE_CHANNEL};
					#else
						var cookieAttenuation: vec3f = getCookie2DClip(uniform.light{i}_cookie, uniform.light{i}_shadowMatrix, uniform.light{i}_cookieIntensity).{LIGHT{i}COOKIE_CHANNEL};
					#endif
				#endif
			#endif
			#if LIGHT{i}TYPE == OMNI
				var cookieAttenuation: vec3f = getCookieCube(uniform.light{i}_cookie, uniform.light{i}_shadowMatrix, uniform.light{i}_cookieIntensity).{LIGHT{i}COOKIE_CHANNEL};
			#endif
			lightColor = lightColor * cookieAttenuation;
		#endif
		#if LIGHT{i}SHAPE == PUNCTUAL
			#if LIGHT{i}FALLOFF == LINEAR
				dAtten = getFalloffLinear(uniform.light{i}_radius, lightDirW);
			#else
				dAtten = getFalloffInvSquared(uniform.light{i}_radius, lightDirW);
			#endif
		#else
			dAtten = getFalloffWindow(uniform.light{i}_radius, lightDirW);
		#endif
		#if LIGHT{i}TYPE == SPOT
			#if !defined(LIGHT{i}COOKIE) || defined(LIGHT{i}COOKIE_FALLOFF)
				dAtten = dAtten * getSpotEffect(uniform.light{i}_direction, uniform.light{i}_innerConeAngle, uniform.light{i}_outerConeAngle, dLightDirNormW);
			#endif
		#endif
	#endif
	if (dAtten < 0.00001) {
		return;
	}
	#if LIGHT{i}SHAPE != PUNCTUAL
		#if LIGHT{i}SHAPE == RECT
			calcRectLightValues(uniform.light{i}_position, uniform.light{i}_halfWidth, uniform.light{i}_halfHeight);
		#elif LIGHT{i}SHAPE == DISK
			calcDiskLightValues(uniform.light{i}_position, uniform.light{i}_halfWidth, uniform.light{i}_halfHeight);
		#elif LIGHT{i}SHAPE == SPHERE
			calcSphereLightValues(uniform.light{i}_position, uniform.light{i}_halfWidth, uniform.light{i}_halfHeight);
		#endif
	#endif
	#if LIGHT{i}SHAPE != PUNCTUAL
		#if LIGHT{i}TYPE == DIRECTIONAL
			var attenDiffuse: f32 = getLightDiffuse(litArgs_worldNormal, dViewDirW, dLightDirNormW);
		#else
			#if LIGHT{i}SHAPE == RECT
				var attenDiffuse: f32 = getRectLightDiffuse(litArgs_worldNormal, dViewDirW, lightDirW, dLightDirNormW) * 16.0;
			#elif LIGHT{i}SHAPE == DISK
				var attenDiffuse: f32 = getDiskLightDiffuse(litArgs_worldNormal, dViewDirW, lightDirW, dLightDirNormW) * 16.0;
			#elif LIGHT{i}SHAPE == SPHERE
				var attenDiffuse: f32 = getSphereLightDiffuse(litArgs_worldNormal, dViewDirW, lightDirW, dLightDirNormW) * 16.0;
			#endif
		#endif
	#else
		dAtten = dAtten * getLightDiffuse(litArgs_worldNormal, vec3(0.0), dLightDirNormW);
	#endif
	#ifdef LIGHT{i}CASTSHADOW
		#if LIGHT{i}TYPE == DIRECTIONAL
			var shadow: f32 = getShadow{i}(vec3(0.0));
		#else
			var shadow: f32 = getShadow{i}(lightDirW);
		#endif
		shadow = mix(1.0, shadow, uniform.light{i}_shadowIntensity);
		dAtten = dAtten * shadow;
		#if defined(LIT_SHADOW_CATCHER) && LIGHT{i}TYPE == DIRECTIONAL
			dShadowCatcher = dShadowCatcher * shadow;
		#endif			
	#endif
	#if LIGHT{i}SHAPE != PUNCTUAL
		#ifdef LIT_SPECULAR
			dDiffuseLight = dDiffuseLight + (((attenDiffuse * dAtten) * lightColor) * (1.0 - dLTCSpecFres));
		#else
			dDiffuseLight = dDiffuseLight + ((attenDiffuse * dAtten) * lightColor);
		#endif						
	#else
		#if defined(AREA_LIGHTS) && defined(LIT_SPECULAR)
			dDiffuseLight = dDiffuseLight + ((dAtten * lightColor) * (1.0 - litArgs_specularity));
		#else
			dDiffuseLight = dDiffuseLight + (dAtten * lightColor);
		#endif
	#endif
	#ifdef LIGHT{i}AFFECT_SPECULARITY
		#if LIGHT{i}SHAPE != PUNCTUAL
			#ifdef LIT_CLEARCOAT
				#if LIGHT{i}SHAPE == RECT
					ccSpecularLight = ccSpecularLight + (ccLTCSpecFres * getRectLightSpecular(litArgs_clearcoat_worldNormal, dViewDirW) * dAtten * lightColor);
				#elif LIGHT{i}SHAPE == DISK
					ccSpecularLight = ccSpecularLight + (ccLTCSpecFres * getDiskLightSpecular(litArgs_clearcoat_worldNormal, dViewDirW) * dAtten * lightColor);
				#elif LIGHT{i}SHAPE == SPHERE
					ccSpecularLight = ccSpecularLight + (ccLTCSpecFres * getSphereLightSpecular(litArgs_clearcoat_worldNormal, dViewDirW) * dAtten * lightColor);
				#endif
			#endif
			#ifdef LIT_SPECULAR
				#if LIGHT{i}SHAPE == RECT
					dSpecularLight = dSpecularLight + (dLTCSpecFres * getRectLightSpecular(litArgs_worldNormal, dViewDirW) * dAtten * lightColor);
				#elif LIGHT{i}SHAPE == DISK
					dSpecularLight = dSpecularLight + (dLTCSpecFres * getDiskLightSpecular(litArgs_worldNormal, dViewDirW) * dAtten * lightColor);
				#elif LIGHT{i}SHAPE == SPHERE
					dSpecularLight = dSpecularLight + (dLTCSpecFres * getSphereLightSpecular(litArgs_worldNormal, dViewDirW) * dAtten * lightColor);
				#endif
			#endif
		#else
			#if LIGHT{i}TYPE == DIRECTIONAL && LIT_FRESNEL_MODEL != NONE
				#define LIGHT{i}FRESNEL
			#endif
			#ifdef LIT_SPECULAR
				var halfDirW: vec3f = normalize(-dLightDirNormW + dViewDirW);
			#endif
			#ifdef LIT_CLEARCOAT
				var lightspecularCC: vec3f = getLightSpecular(halfDirW, ccReflDirW, litArgs_clearcoat_worldNormal, dViewDirW, dLightDirNormW, litArgs_clearcoat_gloss, dTBN) * dAtten * lightColor;
				#ifdef LIGHT{i}FRESNEL
					lightspecularCC = lightspecularCC * getFresnelCC(dot(dViewDirW, halfDirW));
				#endif
				ccSpecularLight = ccSpecularLight + lightspecularCC;
			#endif
			#ifdef LIT_SHEEN
				sSpecularLight = sSpecularLight + (getLightSpecularSheen(halfDirW, litArgs_worldNormal, dViewDirW, dLightDirNormW, litArgs_sheen_gloss) * dAtten * lightColor);
			#endif
			#ifdef LIT_SPECULAR
				var lightSpecular: vec3f = getLightSpecular(halfDirW, dReflDirW, litArgs_worldNormal, dViewDirW, dLightDirNormW, litArgs_gloss, dTBN) * dAtten * lightColor;
				#ifdef LIGHT{i}FRESNEL
					#if defined(LIT_IRIDESCENCE)
						lightSpecular = lightSpecular * getFresnel(dot(dViewDirW, halfDirW), litArgs_gloss, litArgs_specularity, iridescenceFresnel, litArgs_iridescence_intensity);
					#else
						lightSpecular = lightSpecular * getFresnel(dot(dViewDirW, halfDirW), litArgs_gloss, litArgs_specularity);
					#endif
				#else
					lightSpecular = lightSpecular * litArgs_specularity;
				#endif
				
				dSpecularLight = dSpecularLight + lightSpecular;
			#endif
		#endif
	#endif
}
#endif
`;

var lightFunctionShadow_default2 = `
#ifdef LIGHT{i}CASTSHADOW
	#ifdef LIGHT{i}_SHADOW_SAMPLE_POINT
		fn getShadowSampleCoordOmni{i}(shadowParams: vec4f, worldPosition: vec3f, lightPos: vec3f, lightDir: ptr<function, vec3f>, lightDirNorm: vec3f, normal: vec3f) -> vec3f {
			#ifdef LIGHT{i}_SHADOW_SAMPLE_NORMAL_OFFSET
				let distScale: f32 = length(*lightDir);
				var surfacePosition = worldPosition + normal * shadowParams.y * clamp(1.0 - dot(normal, -lightDirNorm), 0.0, 1.0) * distScale;
				*lightDir = surfacePosition - lightPos;
			#endif
			return *lightDir;
		}
	#endif
	#ifndef LIGHT{i}_SHADOW_SAMPLE_POINT
		fn getShadowSampleCoord{i}(shadowTransform: mat4x4f, shadowParams: vec4f, worldPosition: vec3f, lightPos: vec3f, lightDir: ptr<function, vec3f>, lightDirNorm: vec3f, normal: vec3f) -> vec3f {
			var surfacePosition = worldPosition;
			#ifdef LIGHT{i}_SHADOW_SAMPLE_SOURCE_ZBUFFER
				#ifdef LIGHT{i}_SHADOW_SAMPLE_NORMAL_OFFSET
					surfacePosition = surfacePosition + normal * shadowParams.y;
				#endif
			#else
				#ifdef LIGHT{i}_SHADOW_SAMPLE_NORMAL_OFFSET
					#ifdef LIGHT{i}_SHADOW_SAMPLE_ORTHO
						var distScale: f32 = 1.0;
					#else
						var distScale: f32 = abs(dot(vPositionW - lightPos, lightDirNorm));
					#endif
					surfacePosition = surfacePosition + normal * shadowParams.y * clamp(1.0 - dot(normal, -lightDirNorm), 0.0, 1.0) * distScale;
				#endif
			#endif
			var positionInShadowSpace: vec4f = shadowTransform * vec4f(surfacePosition, 1.0);
			#ifdef LIGHT{i}_SHADOW_SAMPLE_ORTHO
				positionInShadowSpace.z = saturate(positionInShadowSpace.z) - 0.0001;
			#else
				#ifdef LIGHT{i}_SHADOW_SAMPLE_SOURCE_ZBUFFER
					positionInShadowSpace.xyz = positionInShadowSpace.xyz / positionInShadowSpace.w;
				#else
					positionInShadowSpace.xy = positionInShadowSpace.xy / positionInShadowSpace.w;
					positionInShadowSpace.z = length(*lightDir) * shadowParams.w;
				#endif
			#endif
			return positionInShadowSpace.xyz;
		}
	#endif
	fn getShadow{i}(lightDirW_in: vec3f) -> f32 {
		var lightDirArg = lightDirW_in;
		#if LIGHT{i}TYPE == OMNI
			var shadowCoord: vec3f = getShadowSampleCoordOmni{i}(uniform.light{i}_shadowParams, vPositionW, uniform.light{i}_position, &lightDirArg, dLightDirNormW, dVertexNormalW);
		#else
			#ifdef LIGHT{i}_SHADOW_CASCADES
				var cascadeIndex: i32 = getShadowCascadeIndex(uniform.light{i}_shadowCascadeDistances, uniform.light{i}_shadowCascadeCount);
				#ifdef LIGHT{i}_SHADOW_CASCADE_BLEND
					cascadeIndex = ditherShadowCascadeIndex(cascadeIndex, uniform.light{i}_shadowCascadeDistances, uniform.light{i}_shadowCascadeCount, uniform.light{i}_shadowCascadeBlend);
				#endif
				var shadowMatrix: mat4x4f = uniform.light{i}_shadowMatrixPalette[cascadeIndex];
			#else
				var shadowMatrix: mat4x4f = uniform.light{i}_shadowMatrix;
			#endif
			#if LIGHT{i}TYPE == DIRECTIONAL
				var shadowCoord: vec3f = getShadowSampleCoord{i}(shadowMatrix, uniform.light{i}_shadowParams, vPositionW, vec3f(0.0), &lightDirArg, dLightDirNormW, dVertexNormalW);
			#else
				var shadowCoord: vec3f = getShadowSampleCoord{i}(shadowMatrix, uniform.light{i}_shadowParams, vPositionW, uniform.light{i}_position, &lightDirArg, dLightDirNormW, dVertexNormalW);
			#endif
		#endif
		#if LIGHT{i}TYPE == DIRECTIONAL
			shadowCoord = fadeShadow(shadowCoord, uniform.light{i}_shadowCascadeDistances);
		#endif
		#if LIGHT{i}TYPE == DIRECTIONAL
			#if LIGHT{i}SHADOWTYPE == VSM_16F
				return getShadowVSM16(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, 5.54);
			#endif
			#if LIGHT{i}SHADOWTYPE == VSM_32F
				return getShadowVSM32(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, 15.0);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCSS_32F
				#if LIGHT{i}SHAPE != PUNCTUAL
					let shadowSearchArea = vec2f(length(uniform.light{i}_halfWidth), length(uniform.light{i}_halfHeight)) * uniform.light{i}_shadowSearchArea;
					return getShadowPCSS(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, uniform.light{i}_cameraParams, shadowSearchArea, lightDirW_in);
				#else
					var pcssCameraParams: vec4f = uniform.light{i}_cameraParams;
					#ifdef LIGHT{i}_SHADOW_CASCADES
						var cascadeRadii: vec4f = uniform.light{i}_shadowCascadeRadii;
						pcssCameraParams.x = cascadeRadii[cascadeIndex];
					#endif
					return getShadowPCSS(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, pcssCameraParams, uniform.light{i}_softShadowParams, lightDirW_in);
				#endif
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF1_16F || LIGHT{i}SHADOWTYPE == PCF1_32F
				return getShadowPCF1x1(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF3_16F || LIGHT{i}SHADOWTYPE == PCF3_32F
				return getShadowPCF3x3(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF5_16F || LIGHT{i}SHADOWTYPE == PCF5_32F
				return getShadowPCF5x5(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams);
			#endif
		#endif
		#if LIGHT{i}TYPE == SPOT
			#if LIGHT{i}SHADOWTYPE == VSM_16F
				return getShadowSpotVSM16(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, 5.54, lightDirW_in);
			#endif
			#if LIGHT{i}SHADOWTYPE == VSM_32F
				return getShadowSpotVSM32(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, 15.0, lightDirW_in);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCSS_32F
				#if LIGHT{i}SHAPE != PUNCTUAL
					var shadowSearchArea: vec2f = vec2f(length(uniform.light{i}_halfWidth), length(uniform.light{i}_halfHeight)) * uniform.light{i}_shadowSearchArea;
				#else
					var shadowSearchArea: vec2f = vec2f(uniform.light{i}_shadowSearchArea);
				#endif
				return getShadowSpotPCSS(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, uniform.light{i}_cameraParams, shadowSearchArea, lightDirW_in);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF1_16F || LIGHT{i}SHADOWTYPE == PCF1_32F
				return getShadowSpotPCF1x1(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF3_16F || LIGHT{i}SHADOWTYPE == PCF3_32F
				return getShadowSpotPCF3x3(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF5_16F || LIGHT{i}SHADOWTYPE == PCF5_32F
				return getShadowSpotPCF5x5(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams);
			#endif
		#endif
		#if LIGHT{i}TYPE == OMNI
			#if LIGHT{i}SHADOWTYPE == PCSS_32F
				 var shadowSearchArea: vec2f;
				 #if LIGHT{i}SHAPE != PUNCTUAL
					var shadowSearchArea: vec2f = vec2f(length(uniform.light{i}_halfWidth), length(uniform.light{i}_halfHeight)) * uniform.light{i}_shadowSearchArea;
				#else
					var shadowSearchArea: vec2f = vec2f(uniform.light{i}_shadowSearchArea);
				#endif
				return getShadowOmniPCSS(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, uniform.light{i}_cameraParams, shadowSearchArea, lightDirW_in);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF1_16F || LIGHT{i}SHADOWTYPE == PCF1_32F
				return getShadowOmniPCF1x1(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, lightDirW_in);
			#endif
			#if LIGHT{i}SHADOWTYPE == PCF3_16F || LIGHT{i}SHADOWTYPE == PCF3_32F
				return getShadowOmniPCF3x3(light{i}_shadowMap, light{i}_shadowMapSampler, shadowCoord, uniform.light{i}_shadowParams, lightDirW_in);
			#endif
		#endif
	}
#endif
`;

var lighting_default2 = `
#ifdef LIT_CLUSTERED_LIGHTS
	#define LIT_CODE_FALLOFF_LINEAR
	#define LIT_CODE_FALLOFF_SQUARED
	#define LIT_CODE_LIGHTS_POINT
	#define LIT_CODE_LIGHTS_SPOT
#endif
#ifdef AREA_LIGHTS
	var areaLightsLutTex1: texture_2d<f32>;
	var areaLightsLutTex1Sampler: sampler;
	var areaLightsLutTex2: texture_2d<f32>;
	var areaLightsLutTex2Sampler: sampler;
#endif
#ifdef LIT_LIGHTING
	#include "lightDiffuseLambertPS"
	#if defined(AREA_LIGHTS) || defined(LIT_CLUSTERED_AREA_LIGHTS)
		#include "ltcPS"
	#endif
#endif
#ifdef SHADOW_DIRECTIONAL
	#include "shadowCascadesPS"
#endif
#if defined(SHADOW_KIND_PCF1)
	#include "shadowPCF1PS"
#endif
#if defined(SHADOW_KIND_PCF3)
	#include "shadowPCF3PS"
#endif
#if defined(SHADOW_KIND_PCF5)
	#include "shadowPCF5PS"
#endif
#if defined(SHADOW_KIND_PCSS)
	#include "linearizeDepthPS"
	#include "shadowSoftPS"
#endif
#if defined(SHADOW_KIND_VSM)
	#include "shadowEVSMPS"
#endif
#ifdef LIT_CODE_FALLOFF_LINEAR
	#include "falloffLinearPS"
#endif
#ifdef LIT_CODE_FALLOFF_SQUARED
	#include "falloffInvSquaredPS"
#endif
#ifdef LIT_CODE_LIGHTS_POINT
	#include "lightDirPointPS"
#endif
#ifdef LIT_CODE_LIGHTS_SPOT
	#include "spotPS"
#endif
#ifdef LIT_CODE_COOKIE
	#include "cookiePS"
#endif
#ifdef LIT_CLUSTERED_LIGHTS
	#include "clusteredLightPS"
#endif
#ifdef LIGHT_COUNT > 0
	#include "lightFunctionShadowPS, LIGHT_COUNT"
	#include "lightFunctionLightPS, LIGHT_COUNT"
#endif
`;

var lightmapAdd_default2 = `
fn addLightMap(
	lightmap: vec3f,
	dir: vec3f,
	worldNormal: vec3f,
	viewDir: vec3f,
	reflectionDir: vec3f,
	gloss: f32,
	specularity: vec3f,
	vertexNormal: vec3f,
	tbn: mat3x3f
#if defined(LIT_IRIDESCENCE)
	, iridescenceFresnel: vec3f,
	iridescenceIntensity: f32
#endif
) {
	#if defined(LIT_SPECULAR) && defined(LIT_DIR_LIGHTMAP)
		if (dot(dir, dir) < 0.0001) {
				dDiffuseLight = dDiffuseLight + lightmap;
		} else {
			let vlight: f32 = saturate(dot(dir, -vertexNormal));
			let flight: f32 = saturate(dot(dir, -worldNormal));
			let nlight: f32 = (flight / max(vlight, 0.01)) * 0.5;
			dDiffuseLight = dDiffuseLight + lightmap * nlight * 2.0;
			let halfDir: vec3f = normalize(-dir + viewDir);
			var specularLight: vec3f = lightmap * getLightSpecular(halfDir, reflectionDir, worldNormal, viewDir, dir, gloss, tbn);
			#ifdef LIT_SPECULAR_FRESNEL
				specularLight = specularLight *
					getFresnel(dot(viewDir, halfDir),
					gloss,
					specularity
				#if defined(LIT_IRIDESCENCE)
					, iridescenceFresnel,
					iridescenceIntensity
				#endif
					);
			#endif
			dSpecularLight = dSpecularLight + specularLight;
		}
	#else
		dDiffuseLight = dDiffuseLight + lightmap;
	#endif
}
`;

var lightmap_default2 = `
#ifdef STD_LIGHTMAP_DIR
	var<private> dLightmapDir: vec3f;
	var texture_dirLightMap: texture_2d<f32>;
	var texture_dirLightMapSampler: sampler;
#endif
fn getLightMap() {
	dLightmap = vec3f(1.0);
	#ifdef STD_LIGHT_TEXTURE
		dLightmap = dLightmap * {STD_LIGHT_TEXTURE_DECODE}(textureSampleBias({STD_LIGHT_TEXTURE_NAME}, {STD_LIGHT_TEXTURE_NAME}Sampler, {STD_LIGHT_TEXTURE_UV}, uniform.textureBias)).{STD_LIGHT_TEXTURE_CHANNEL};
		#ifdef STD_LIGHTMAP_DIR
			var dir: vec3f = textureSampleBias(texture_dirLightMap, texture_dirLightMapSampler, {STD_LIGHT_TEXTURE_UV}, uniform.textureBias).xyz * 2.0 - 1.0;
			var dirDot = dot(dir, dir);
			dLightmapDir = select(vec3(0.0), dir / sqrt(dirDot), dirDot > 0.001);
		#endif
	#endif
	#ifdef STD_LIGHT_VERTEX
		dLightmap = dLightmap * saturate(vVertexColor.{STD_LIGHT_VERTEX_CHANNEL});
	#endif
}
`;

var lightSpecularAnisoGGX_default2 = `
fn calcLightSpecular(gloss: f32, worldNormal: vec3f, viewDir: vec3f, h: vec3f, lightDirNorm: vec3f, tbn: mat3x3f) -> f32 {
	let PI: f32 = 3.141592653589793;
	let roughness: f32 = max((1.0 - gloss) * (1.0 - gloss), 0.001);
	let alphaRoughness: f32 = roughness * roughness;
	let anisotropy: f32 = dAnisotropy;
	let direction: vec2f = dAnisotropyRotation;
	let at: f32 = mix(alphaRoughness, 1.0, anisotropy * anisotropy);
	let ab: f32 = clamp(alphaRoughness, 0.001, 1.0);
	let anisotropicT: vec3f = normalize(tbn * vec3f(direction, 0.0));
	let anisotropicB: vec3f = normalize(cross(tbn[2], anisotropicT));
	let NoH: f32 = dot(worldNormal, h);
	let ToH: f32 = dot(anisotropicT, h);
	let BoH: f32 = dot(anisotropicB, h);
	let a2: f32 = at * ab;
	let v: vec3f = vec3f(ab * ToH, at * BoH, a2 * NoH);
	let v2: f32 = dot(v, v);
	let w2: f32 = a2 / v2;
	let D: f32 = a2 * w2 * w2 * (1.0 / PI);
	let ToV: f32 = dot(anisotropicT, viewDir);
	let BoV: f32 = dot(anisotropicB, viewDir);
	let ToL: f32 = dot(anisotropicT, -lightDirNorm);
	let BoL: f32 = dot(anisotropicB, -lightDirNorm);
	let NoV: f32 = dot(worldNormal, viewDir);
	let NoL: f32 = dot(worldNormal, -lightDirNorm);
	let lambdaV: f32 = NoL * length(vec3f(at * ToV, ab * BoV, NoV));
	let lambdaL: f32 = NoV * length(vec3f(at * ToL, ab * BoL, NoL));
	let G: f32 = 0.5 / (lambdaV + lambdaL);
	return D * G;
}
fn getLightSpecular(h: vec3f, reflDir: vec3f, worldNormal: vec3f, viewDir: vec3f, lightDirNorm: vec3f, gloss: f32, tbn: mat3x3f) -> f32 {
	return calcLightSpecular(gloss, worldNormal, viewDir, h, lightDirNorm, tbn);
}
`;

var lightSpecularGGX_default2 = `
fn calcLightSpecular(gloss: f32, worldNormal: vec3f, viewDir: vec3f, h: vec3f, lightDirNorm: vec3f) -> f32 {
	const PI: f32 = 3.141592653589793;
	let roughness: f32 = max((1.0 - gloss) * (1.0 - gloss), 0.001);
	let alpha: f32 = roughness * roughness;
	let NoH: f32 = max(dot(worldNormal, h), 0.0);
	let NoV: f32 = max(dot(worldNormal, viewDir), 0.0);
	let NoL: f32 = max(dot(worldNormal, -lightDirNorm), 0.0);
	let NoH2: f32 = NoH * NoH;
	let denom: f32 = NoH2 * (alpha - 1.0) + 1.0;
	let D: f32 = alpha / (PI * denom * denom);
	let alpha2: f32 = alpha * alpha;
	let lambdaV: f32 = NoL * sqrt(NoV * NoV * (1.0 - alpha2) + alpha2);
	let lambdaL: f32 = NoV * sqrt(NoL * NoL * (1.0 - alpha2) + alpha2);
	let G: f32 = 0.5 / max(lambdaV + lambdaL, 0.00001);
	return D * G;
}
fn getLightSpecular(h: vec3f, reflDir: vec3f, worldNormal: vec3f, viewDir: vec3f, lightDirNorm: vec3f, gloss: f32, tbn: mat3x3f) -> f32 {
	return calcLightSpecular(gloss, worldNormal, viewDir, h, lightDirNorm);
}
`;

var lightSpecularBlinn_default2 = `
fn calcLightSpecular(gloss: f32, worldNormal: vec3f, h: vec3f) -> f32 {
	let nh: f32 = max( dot( h, worldNormal ), 0.0 );
	var specPow: f32 = exp2(gloss * 11.0);
	specPow = max(specPow, 0.0001);
	return pow(nh, specPow) * (specPow + 2.0) / 8.0;
}
fn getLightSpecular(h: vec3f, reflDir: vec3f, worldNormal: vec3f, viewDir: vec3f, lightDirNorm: vec3f, gloss: f32, tbn: mat3x3f) -> f32 {
	return calcLightSpecular(gloss, worldNormal, h);
}
`;

var lightSheen_default2 = `
fn sheenD(normal: vec3f, h: vec3f, roughness: f32) -> f32 {
	let PI: f32 = 3.141592653589793;
	let invR: f32 = 1.0 / (roughness * roughness);
	var cos2h: f32 = max(dot(normal, h), 0.0);
	cos2h = cos2h * cos2h;
	let sin2h: f32 = max(1.0 - cos2h, 0.0078125);
	return (2.0 + invR) * pow(sin2h, invR * 0.5) / (2.0 * PI);
}
fn sheenV(normal: vec3f, viewDir: vec3f, light: vec3f) -> f32 {
	let NoV: f32 = max(dot(normal, viewDir), 0.000001);
	let NoL: f32 = max(dot(normal, light), 0.000001);
	return 1.0 / (4.0 * (NoL + NoV - NoL * NoV));
}
fn getLightSpecularSheen(h: vec3f, worldNormal: vec3f, viewDir: vec3f, lightDirNorm: vec3f, sheenGloss: f32) -> f32 {
	let D: f32 = sheenD(worldNormal, h, sheenGloss);
	let V: f32 = sheenV(worldNormal, viewDir, -lightDirNorm);
	return D * V;
}`;

var linearizeDepth_default2 = `
#ifndef LINEARIZE_DEPTH
#define LINEARIZE_DEPTH
fn linearizeDepthWithParams(z: f32, cameraParams: vec4f) -> f32 {
	if (cameraParams.w == 0.0) {
		return (cameraParams.z * cameraParams.y) / (cameraParams.y + z * (cameraParams.z - cameraParams.y));
	} else {
		return cameraParams.z + z * (cameraParams.y - cameraParams.z);
	}
}
#ifndef CAMERAPLANES
	#define CAMERAPLANES
	uniform camera_params: vec4f;
#endif
fn linearizeDepth(z: f32) -> f32 {
	return linearizeDepthWithParams(z, uniform.camera_params);
}
#endif
`;

var litForwardBackend_default2 = `
fn evaluateBackend() -> FragmentOutput {
	var output: FragmentOutput;
	#ifdef LIT_SSAO
		litArgs_ao = litArgs_ao * textureSampleLevel(ssaoTexture, ssaoTextureSampler, pcPosition.xy * uniform.ssaoTextureSizeInv, 0.0).r;
	#endif
	#ifdef LIT_NEEDS_NORMAL
		#ifdef LIT_SPECULAR
			getReflDir(litArgs_worldNormal, dViewDirW, litArgs_gloss, dTBN);
		#endif
		#ifdef LIT_CLEARCOAT
			ccReflDirW = normalize(-reflect(dViewDirW, litArgs_clearcoat_worldNormal));
		#endif
	#endif
	#ifdef LIT_SPECULAR_OR_REFLECTION
		#ifdef LIT_METALNESS
			var f0: f32 = 1.0 / litArgs_ior;
			f0 = (f0 - 1.0) / (f0 + 1.0);
			f0 = f0 * f0;
			#ifdef LIT_SPECULARITY_FACTOR
				litArgs_specularity = getSpecularModulate(litArgs_specularity, litArgs_albedo, litArgs_metalness, f0, litArgs_specularityFactor);
			#else
				litArgs_specularity = getSpecularModulate(litArgs_specularity, litArgs_albedo, litArgs_metalness, f0, 1.0);
			#endif
			litArgs_albedo = getAlbedoModulate(litArgs_albedo, litArgs_metalness);
		#endif
		#ifdef LIT_IRIDESCENCE
			var iridescenceFresnel: vec3f = getIridescenceDiffraction(saturate(dot(dViewDirW, litArgs_worldNormal)), litArgs_specularity, litArgs_iridescence_thickness);
		#endif
	#endif
	#ifdef LIT_ADD_AMBIENT
		addAmbient(litArgs_worldNormal);
		#ifdef LIT_SPECULAR
			dDiffuseLight = dDiffuseLight * (1.0 - litArgs_specularity);
		#endif
		#ifdef LIT_SEPARATE_AMBIENT
			var dAmbientLight: vec3f = dDiffuseLight;
			dDiffuseLight = vec3(0.0);
		#endif
	#endif
	#ifndef LIT_OLD_AMBIENT
		dDiffuseLight = dDiffuseLight * uniform.material_ambient;
	#endif
	#ifdef LIT_AO
		#ifndef LIT_OCCLUDE_DIRECT
			occludeDiffuse(litArgs_ao);
		#endif
	#endif
	#ifdef LIT_LIGHTMAP
		addLightMap(
			litArgs_lightmap, 
			litArgs_lightmapDir, 
			litArgs_worldNormal, 
			dViewDirW, 
			dReflDirW, 
			litArgs_gloss, 
			litArgs_specularity, 
			dVertexNormalW,
			dTBN
		#if defined(LIT_IRIDESCENCE)
			, iridescenceFresnel,
			litArgs_iridescence_intensity
		#endif
		);
	#endif
	#ifdef LIT_LIGHTING || LIT_REFLECTIONS
		#ifdef LIT_REFLECTIONS
			#ifdef LIT_CLEARCOAT
				addReflectionCC(ccReflDirW, litArgs_clearcoat_gloss);
			
				#ifdef LIT_SPECULAR_FRESNEL
					ccFresnel = getFresnelCC(dot(dViewDirW, litArgs_clearcoat_worldNormal));
					ccReflection = ccReflection * ccFresnel;
				#else
					ccFresnel = 0.0;
				#endif
			#endif
			#ifdef LIT_SPECULARITY_FACTOR
				ccReflection = ccReflection * litArgs_specularityFactor;
			#endif
			#ifdef LIT_SHEEN
				addReflectionSheen(litArgs_worldNormal, dViewDirW, litArgs_sheen_gloss);
			#endif
			addReflection(dReflDirW, litArgs_gloss);
			#ifdef LIT_FRESNEL_MODEL
				dReflection = vec4f(
					dReflection.rgb * getFresnel(
						dot(dViewDirW, litArgs_worldNormal),
						litArgs_gloss,
						litArgs_specularity
					#if defined(LIT_IRIDESCENCE)
						, iridescenceFresnel,
						litArgs_iridescence_intensity
					#endif
						),
					dReflection.a
				);
			#else
				dReflection = vec4f(dReflection.rgb * litArgs_specularity, dReflection.a);
			#endif
		#endif
		#ifdef AREA_LIGHTS
			dSpecularLight = dSpecularLight * litArgs_specularity;
			#ifdef LIT_SPECULAR
				calcLTCLightValues(litArgs_gloss, litArgs_worldNormal, dViewDirW, litArgs_specularity, litArgs_clearcoat_gloss, litArgs_clearcoat_worldNormal, litArgs_clearcoat_specularity);
			#endif
		#endif
		
		#ifdef LIGHT_COUNT > 0
			#include "lightEvaluationPS, LIGHT_COUNT"
		#endif
		#ifdef LIT_CLUSTERED_LIGHTS
			addClusteredLights(litArgs_worldNormal, dViewDirW, dReflDirW,
				#if defined(LIT_CLEARCOAT)
						ccReflDirW,
				#endif
						litArgs_gloss, litArgs_specularity, dVertexNormalW, dTBN, 
				#if defined(LIT_IRIDESCENCE)
						iridescenceFresnel,
				#endif
						litArgs_clearcoat_worldNormal, litArgs_clearcoat_gloss, litArgs_sheen_gloss, litArgs_iridescence_intensity
			);
		#endif
		#ifdef AREA_LIGHTS
			#ifdef LIT_CLEARCOAT
				litArgs_clearcoat_specularity = 1.0;
			#endif
			#ifdef LIT_SPECULAR
				litArgs_specularity = vec3(1.0);
			#endif
		#endif
		#ifdef LIT_REFRACTION
			addRefraction(
				litArgs_worldNormal, 
				dViewDirW, 
				litArgs_thickness, 
				litArgs_gloss, 
				litArgs_specularity, 
				litArgs_albedo, 
				litArgs_transmission,
				litArgs_ior,
				litArgs_dispersion
				#if defined(LIT_IRIDESCENCE)
					, iridescenceFresnel, 
					litArgs_iridescence_intensity
				#endif
			);
		#endif
	#endif
	#ifdef LIT_AO
		#ifdef LIT_OCCLUDE_DIRECT
			occludeDiffuse(litArgs_ao);
		#endif
		#if LIT_OCCLUDE_SPECULAR != NONE
			occludeSpecular(litArgs_gloss, litArgs_ao, litArgs_worldNormal, dViewDirW);
		#endif
	#endif
	#if !defined(LIT_OPACITY_FADES_SPECULAR)
		#if LIT_BLEND_TYPE == NORMAL || LIT_BLEND_TYPE == PREMULTIPLIED
			var specLum: f32 = dot((dSpecularLight + dReflection.rgb * dReflection.a), vec3f( 0.2126, 0.7152, 0.0722 ));
			#ifdef LIT_CLEARCOAT
				specLum = specLum + dot(ccSpecularLight * litArgs_clearcoat_specularity + ccReflection * litArgs_clearcoat_specularity, vec3f( 0.2126, 0.7152, 0.0722 ));
			#endif
			litArgs_opacity = clamp(litArgs_opacity + gammaCorrectInput(specLum), 0.0, 1.0);
		#endif
		litArgs_opacity = litArgs_opacity * uniform.material_alphaFade;
	#endif
	#ifdef LIT_LIGHTMAP_BAKING
		#ifdef LIT_LIGHTMAP_BAKING_COLOR
			#include "bakeLmEndPS"
		#endif
		#ifdef LIT_LIGHTMAP_BAKING_DIR
			#include "bakeDirLmEndPS"
		#endif
	#else
		#include "endPS"
		#include "outputAlphaPS"
	#endif
	#ifdef LIT_MSDF
		output.color = applyMsdf(output.color);
	#endif
	#include "outputPS"
	#include "debugOutputPS"
	#ifdef LIT_SHADOW_CATCHER
		output.color = vec4f(vec3f(dShadowCatcher), output.color.a);
	#endif
	#include "outlineOutputPS"
	return output;
}
`;

var litForwardDeclaration_default2 = `
var<private> sReflection: vec3f;
var<private> dVertexNormalW: vec3f;
var<private> dTangentW: vec3f;
var<private> dBinormalW: vec3f;
var<private> dViewDirW: vec3f;
var<private> dReflDirW: vec3f;
var<private> ccReflDirW: vec3f;
var<private> dLightDirNormW: vec3f;
var<private> dAtten: f32;
var<private> dTBN: mat3x3f;
var<private> dReflection: vec4f;
var<private> dDiffuseLight: vec3f;
var<private> dSpecularLight: vec3f;
var<private> ccFresnel: f32;
var<private> ccReflection: vec3f;
var<private> ccSpecularLight: vec3f;
var<private> ccSpecularityNoFres: f32;
var<private> sSpecularLight: vec3f;
#ifdef LIT_DISPERSION
	uniform material_dispersion: f32;
#endif
#ifndef LIT_OPACITY_FADES_SPECULAR
	uniform material_alphaFade: f32;
#endif
#ifdef LIT_SSAO
	var ssaoTexture : texture_2d<f32>;
	var ssaoTextureSampler : sampler;
	uniform ssaoTextureSizeInv: vec2f;
#endif
#ifdef LIT_SHADOW_CATCHER
	var<private> dShadowCatcher: f32 = 1.0;
#endif
#if LIGHT_COUNT > 0
	#include "lightDeclarationPS, LIGHT_COUNT"
#endif
#ifdef LIT_SPECULAR
	#if LIT_FRESNEL_MODEL == NONE && !defined(LIT_REFLECTIONS) && !defined(LIT_DIFFUSE_MAP) 
		#define LIT_OLD_AMBIENT
	#endif
#endif
#ifdef STD_LIGHTMAP_DIR
	uniform bakeDir: f32;
#endif
#ifdef LIT_LIGHTMAP_BAKING_ADD_AMBIENT
	uniform ambientBakeOcclusionContrast: f32;
	uniform ambientBakeOcclusionBrightness: f32;
#endif
`;

var litForwardMain_default2 = `
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	#include "litUserMainStartPS"
	dReflection = vec4f(0.0);
	#ifdef LIT_CLEARCOAT
		ccSpecularLight = vec3f(0.0);
		ccReflection = vec3f(0.0);
	#endif
	#if LIT_NONE_SLICE_MODE == SLICED
		#include "startNineSlicedPS"
	#elif LIT_NONE_SLICE_MODE == TILED
		#include "startNineSlicedTiledPS"
	#endif
	#ifdef LIT_NEEDS_NORMAL
		dVertexNormalW = normalize(vNormalW);
		#ifdef LIT_TANGENTS
			#if defined(LIT_HEIGHTS) || defined(LIT_USE_NORMALS) || defined(LIT_USE_CLEARCOAT_NORMALS) || defined(LIT_GGX_SPECULAR)
				dTangentW = vTangentW;
				dBinormalW = vBinormalW;
			#endif
		#endif
		getViewDir();
		#ifdef LIT_TBN
			getTBN(dTangentW, dBinormalW, dVertexNormalW);
			#ifdef LIT_TWO_SIDED_LIGHTING
				handleTwoSidedLighting();
			#endif
		#endif
	#endif
	evaluateFrontend();
	#include "debugProcessFrontendPS"
	var output: FragmentOutput = evaluateBackend();
	#include "litUserMainEndPS"
	return output;
}
`;

var litForwardPostCode_default2 = `
#ifdef LIT_NEEDS_NORMAL
	#include "cubeMapRotatePS"
	#include "cubeMapProjectPS"
	#include "envProcPS"
#endif
#ifdef LIT_SPECULAR_OR_REFLECTION
	#ifdef LIT_METALNESS
		#include "metalnessModulatePS"
	#endif
	#ifdef LIT_IRIDESCENCE
		#include "iridescenceDiffractionPS"
	#endif
#endif
#if defined(LIT_SPECULAR_OR_REFLECTION) || defined(LIT_REFRACTION)
	#if LIT_FRESNEL_MODEL == SCHLICK
		#include "fresnelSchlickPS"
	#endif
#endif
#ifdef LIT_AO
	#include "aoDiffuseOccPS"
	#include "aoSpecOccPS"
#endif
#if LIT_REFLECTION_SOURCE == ENVATLASHQ
	#include "envAtlasPS"
	#include "reflectionEnvHQPS"
#elif LIT_REFLECTION_SOURCE == ENVATLAS
	#include "envAtlasPS"
	#include "reflectionEnvPS"
#elif LIT_REFLECTION_SOURCE == CUBEMAP
	#include "reflectionCubePS"
#elif LIT_REFLECTION_SOURCE == SPHEREMAP
	#include "reflectionSpherePS"
#endif
#ifdef LIT_REFLECTIONS
	#ifdef LIT_CLEARCOAT
		#include "reflectionCCPS"
	#endif
	#ifdef LIT_SHEEN
		#include "reflectionSheenPS"
	#endif
#endif
#ifdef LIT_REFRACTION
	#if defined(LIT_DYNAMIC_REFRACTION)
		#include "refractionDynamicPS"
	#elif defined(LIT_REFLECTIONS)
		#include "refractionCubePS"
	#endif
#endif
#ifdef LIT_SHEEN
	#include "lightSheenPS"
#endif
uniform material_ambient: vec3f;
#ifdef LIT_SPECULAR
	#ifdef LIT_LIGHTING
		#ifdef LIT_GGX_SPECULAR
			#ifdef LIT_ANISOTROPY
				#include "lightSpecularAnisoGGXPS"
			#else
				#include "lightSpecularGGXPS"
			#endif
		#else
			#include "lightSpecularBlinnPS"
		#endif
	#endif
#endif
#include "combinePS"
#ifdef LIT_LIGHTMAP
	#include "lightmapAddPS"
#endif
#ifdef LIT_ADD_AMBIENT
	#include "ambientPS"
#endif
#ifdef LIT_MSDF
	#include "msdfPS"
#endif
#ifdef LIT_NEEDS_NORMAL
	#include "viewDirPS"
	#ifdef LIT_SPECULAR
		#ifdef LIT_ANISOTROPY
			#include "reflDirAnisoPS"
		#else
			#include "reflDirPS"
		#endif
	#endif
#endif
#include "lightingPS"
`;

var litForwardPreCode_default2 = `
#include "basePS"
#include "sphericalPS"
#include "decodePS"
#include "gammaPS"
#include "tonemappingPS"
#include "fogPS"
#if LIT_NONE_SLICE_MODE == SLICED
	#include "baseNineSlicedPS"
#elif LIT_NONE_SLICE_MODE == TILED
	#include "baseNineSlicedTiledPS"
#endif
#ifdef LIT_TBN
	#include "TBNPS"
	#ifdef LIT_TWO_SIDED_LIGHTING
		#include "twoSidedLightingPS"
	#endif
#endif
`;

var litMain_default3 = `
#include "varyingsPS"
#include "litUserDeclarationPS"
#include "frontendDeclPS"
#include "outlineDeclarationPS"
#if defined(PICK_PASS) || defined(PREPASS_PASS)
	#include "frontendCodePS"
	#include "litUserCodePS"
	#include "litOtherMainPS"
#elif defined(SHADOW_PASS)
	#include "frontendCodePS"
	#include "litUserCodePS"
	#include "litShadowMainPS"
#else
	#include "litForwardDeclarationPS"
	#include "litForwardPreCodePS"
	#include "frontendCodePS"
	#include "litForwardPostCodePS"
	#include "litForwardBackendPS"
	#include "litUserCodePS"
	#include "litForwardMainPS"
#endif
`;

var litMain_default4 = `
#include "varyingsVS"
#include  "litUserDeclarationVS"
#ifdef VERTEX_COLOR
	attribute vertex_color: vec4f;
#endif
#ifdef NINESLICED
	varying vMask: vec2f;
	varying vTiledUv: vec2f;
	var<private> dMaskGlobal: vec2f;
	var<private> dTiledUvGlobal: vec2f;
	uniform innerOffset: vec4f;
	uniform outerScale: vec2f;
	uniform atlasRect: vec4f;
#endif
var<private> dPositionW: vec3f;
var<private> dModelMatrix: mat4x4f;
#include "transformCoreVS"
#ifdef UV0
	attribute vertex_texCoord0: vec2f;
	#include "uv0VS"
#endif
#ifdef UV1
	attribute vertex_texCoord1: vec2f;
	#include "uv1VS"
#endif
#ifdef LINEAR_DEPTH
	#ifndef VIEWMATRIX
	#define VIEWMATRIX
		uniform matrix_view: mat4x4f;
	#endif
#endif
#include "transformVS"
#ifdef NORMALS
	#include "normalCoreVS"
	#include "normalVS"
#endif
#ifdef TANGENTS
	attribute vertex_tangent: vec4f;
#endif
#include "uvTransformUniformsPS, UV_TRANSFORMS_COUNT"
#ifdef MSDF
	#include "msdfVS"
#endif
#include  "litUserCodeVS"
#ifdef VERTEX_COLOR
	fn decodeGamma3(raw: vec3f) -> vec3f {
		return pow(raw, vec3f(2.2));
	}
	fn gammaCorrectInputVec4(color: vec4f) -> vec4f {
		return vec4f(decodeGamma3(color.xyz), color.w);
	}
#endif
@vertex
fn vertexMain(input : VertexInput) -> VertexOutput {
	#include "litUserMainStartVS"
	var output : VertexOutput;
	output.position = getPosition();
	output.vPositionW = getWorldPosition();
	#ifdef NORMALS
		output.vNormalW = getNormal();
	#endif
	#ifdef TANGENTS
		output.vTangentW = normalize(dNormalMatrix * vertex_tangent.xyz);
		output.vBinormalW = cross(output.vNormalW, output.vTangentW) * vertex_tangent.w;
	#elif defined(GGX_SPECULAR)
		output.vObjectSpaceUpW = normalize(dNormalMatrix * vec3f(0.0, 1.0, 0.0));
	#endif
	#ifdef UV0
		var uv0: vec2f = getUv0();
		#ifdef UV0_UNMODIFIED
			output.vUv0 = uv0;
		#endif
	#endif
	#ifdef UV1
		var uv1: vec2f = getUv1();
		#ifdef UV1_UNMODIFIED
			output.vUv1 = uv1;
		#endif
	#endif
	#include "uvTransformVS, UV_TRANSFORMS_COUNT"
	#ifdef VERTEX_COLOR
		#ifdef STD_VERTEX_COLOR_GAMMA
			output.vVertexColor = gammaCorrectInputVec4(vertex_color);
		#else
			output.vVertexColor = vertex_color;
		#endif
	#endif
	#ifdef LINEAR_DEPTH
		output.vLinearDepth = -(uniform.matrix_view * vec4f(output.vPositionW, 1.0)).z;
	#endif
	#ifdef MSDF
		unpackMsdfParams();
		output.outline_color = dOutlineColor;
		output.outline_thickness = dOutlineThickness;
		output.shadow_color = dShadowColor;
		output.shadow_offset = dShadowOffset;
	#endif
	#ifdef NINESLICED
		output.vMask = dMaskGlobal;
		output.vTiledUv = dTiledUvGlobal;
	#endif
	#include "litUserMainEndVS"
	return output;
}
`;

var litOtherMain_default2 = `
#ifdef PICK_PASS
	#include "pickPS"
#endif
#ifdef PREPASS_PASS
	#include "floatAsUintPS"
#endif
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	#include "litUserMainStartPS"
	var output: FragmentOutput;
	
	evaluateFrontend();
	#ifdef PICK_PASS
		output.color = getPickOutput();
		#ifdef DEPTH_PICK_PASS
			output.color1 = getPickDepth();
		#endif
	#endif
	#ifdef PREPASS_PASS
		output.color = float2vec4(vLinearDepth);
	#endif
	#include "litUserMainEndPS"
	return output;
}
`;

var litShaderArgs_default2 = `
var<private> litArgs_albedo: vec3f;
var<private> litArgs_opacity: f32;
var<private> litArgs_emission: vec3f;
var<private> litArgs_worldNormal: vec3f;
var<private> litArgs_ao: f32;
var<private> litArgs_lightmap: vec3f;
var<private> litArgs_lightmapDir: vec3f;
var<private> litArgs_metalness: f32;
var<private> litArgs_specularity: vec3f;
var<private> litArgs_specularityFactor: f32;
var<private> litArgs_gloss: f32;
var<private> litArgs_sheen_gloss: f32;
var<private> litArgs_sheen_specularity: vec3f;
var<private> litArgs_transmission: f32;
var<private> litArgs_thickness: f32;
var<private> litArgs_ior: f32;
var<private> litArgs_dispersion: f32;
var<private> litArgs_iridescence_intensity: f32;
var<private> litArgs_iridescence_thickness: f32;
var<private> litArgs_clearcoat_worldNormal: vec3f;
var<private> litArgs_clearcoat_specularity: f32;
var<private> litArgs_clearcoat_gloss: f32;
`;

var litShaderCore_default2 = `
	uniform textureBias: f32;
	#include "litShaderArgsPS"
`;

var litShadowMain_default2 = `
#if LIGHT_TYPE != DIRECTIONAL
	uniform view_position: vec3f;
	uniform light_radius: f32;
#endif
#if SHADOW_TYPE == PCSS_32F
	#include "linearizeDepthPS"
#endif
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	#include "litUserMainStartPS"
	var output: FragmentOutput;
	evaluateFrontend();
	#ifdef PERSPECTIVE_DEPTH
		var depth: f32 = input.position.z;
		#if SHADOW_TYPE == PCSS_32F
			#if LIGHT_TYPE != DIRECTIONAL
				depth = linearizeDepthWithParams(depth, camera_params);
			#endif
		#endif
	#else
		var depth: f32 = min(distance(uniform.view_position, input.vPositionW) / uniform.light_radius, 0.99999);
		#define MODIFIED_DEPTH
	#endif
	#if SHADOW_TYPE == VSM_16F || SHADOW_TYPE == VSM_32F
		#if SHADOW_TYPE == VSM_32F
			var exponent: f32 = 15.0;
		#else
			var exponent: f32 = 5.54;
		#endif
		var depth_vsm = 2.0 * depth - 1.0;
		depth_vsm = exp(exponent * depth_vsm);
		output.color = vec4f(depth_vsm, depth_vsm * depth_vsm, 1.0, 1.0);
	#else
		#if SHADOW_TYPE == PCSS_32F
			output.color = vec4f(depth, 0.0, 0.0, 1.0);
		#else
			#ifdef MODIFIED_DEPTH
				output.fragDepth = depth;
			#endif
			output.color = vec4f(1.0);
		#endif
	#endif
	#include "litUserMainEndPS"
	
	return output;
}
`;

var ltc_default2 = `
fn LTC_Uv(N: vec3f, V: vec3f, roughness: f32) -> vec2f {
	const LUT_SIZE: f32 = 64.0;
	const LUT_SCALE: f32 = (LUT_SIZE - 1.0) / LUT_SIZE;
	const LUT_BIAS: f32 = 0.5 / LUT_SIZE;
	let dotNV: f32 = saturate(dot( N, V ));
	let uv: vec2f = vec2f( roughness, sqrt( 1.0 - dotNV ) );
	return uv * LUT_SCALE + LUT_BIAS;
}
fn LTC_ClippedSphereFormFactor( f: vec3f ) -> f32 {
	let l: f32 = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
fn LTC_EdgeVectorFormFactor( v1: vec3f, v2: vec3f ) -> vec3f {
	let x: f32 = dot( v1, v2 );
	let y: f32 = abs( x );
	let a: f32 = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	let b: f32 = 3.4175940 + ( 4.1616724 + y ) * y;
	let v: f32 = a / b;
	let inv_sqrt_term = inverseSqrt( max( 1.0 - x * x, 1e-7f ) );
	let theta_sintheta: f32 = select( (0.5 * inv_sqrt_term - v), v, x > 0.0 );
	return cross( v1, v2 ) * theta_sintheta;
}
struct Coords {
	coord0: vec3f,
	coord1: vec3f,
	coord2: vec3f,
	coord3: vec3f,
}
fn LTC_EvaluateRect( N: vec3f, V: vec3f, P: vec3f, mInv: mat3x3f, rectCoords: Coords) -> f32 {
	let v1: vec3f = rectCoords.coord1 - rectCoords.coord0;
	let v2: vec3f = rectCoords.coord3 - rectCoords.coord0;
	let lightNormal: vec3f = cross( v1, v2 );
	let factor: f32 = sign(-dot( lightNormal, P - rectCoords.coord0 ));
	let T1: vec3f = normalize( V - N * dot( V, N ) );
	let T2: vec3f = factor * cross( N, T1 );
	let mat: mat3x3f = mInv * transpose( mat3x3f( T1, T2, N ) );
	var coords: array<vec3f, 4>;
	coords[0] = mat * ( rectCoords.coord0 - P );
	coords[1] = mat * ( rectCoords.coord1 - P );
	coords[2] = mat * ( rectCoords.coord2 - P );
	coords[3] = mat * ( rectCoords.coord3 - P );
	coords[0] = normalize( coords[0] );
	coords[1] = normalize( coords[1] );
	coords[2] = normalize( coords[2] );
	coords[3] = normalize( coords[3] );
	var vectorFormFactor: vec3f = vec3f( 0.0 );
	vectorFormFactor = vectorFormFactor + LTC_EdgeVectorFormFactor( coords[0], coords[1] );
	vectorFormFactor = vectorFormFactor + LTC_EdgeVectorFormFactor( coords[1], coords[2] );
	vectorFormFactor = vectorFormFactor + LTC_EdgeVectorFormFactor( coords[2], coords[3] );
	vectorFormFactor = vectorFormFactor + LTC_EdgeVectorFormFactor( coords[3], coords[0] );
	let result: f32 = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return result;
}
var<private> dLTCCoords: Coords;
fn getLTCLightCoords(lightPos: vec3f, halfWidth: vec3f, halfHeight: vec3f) -> Coords {
	var coords: Coords;
	coords.coord0 = lightPos + halfWidth - halfHeight;
	coords.coord1 = lightPos - halfWidth - halfHeight;
	coords.coord2 = lightPos - halfWidth + halfHeight;
	coords.coord3 = lightPos + halfWidth + halfHeight;
	return coords;
}
var<private> dSphereRadius: f32;
fn getSphereLightCoords(lightPos: vec3f, halfWidth: vec3f, halfHeight: vec3f) -> Coords {
	dSphereRadius = max(length(halfWidth), length(halfHeight));
	let f: vec3f = reflect(normalize(lightPos - uniform.view_position), vNormalW);
	let w: vec3f = normalize(cross(f, halfHeight));
	let h: vec3f = normalize(cross(f, w));
	return getLTCLightCoords(lightPos, w * dSphereRadius, h * dSphereRadius);
}
var<private> dLTCUV: vec2f;
#ifdef LIT_CLEARCOAT
	var<private> ccLTCUV: vec2f;
#endif
fn getLTCLightUV(gloss: f32, worldNormal: vec3f, viewDir: vec3f) -> vec2f {
	let roughness: f32 = max((1.0 - gloss) * (1.0 - gloss), 0.001);
	return LTC_Uv( worldNormal, viewDir, roughness );
}
var<private> dLTCSpecFres: vec3f;
#ifdef LIT_CLEARCOAT
	var<private> ccLTCSpecFres: vec3f;
#endif
fn getLTCLightSpecFres(uv: vec2f, specularity: vec3f) -> vec3f {
	let t2: vec4f = textureSampleLevel(areaLightsLutTex2, areaLightsLutTex2Sampler, uv, 0.0);
	return specularity * t2.x + ( vec3f( 1.0 ) - specularity) * t2.y;
}
fn calcLTCLightValues(gloss: f32, worldNormal: vec3f, viewDir: vec3f, specularity: vec3f, clearcoatGloss: f32, clearcoatWorldNormal: vec3f, clearcoatSpecularity: f32) {
	dLTCUV = getLTCLightUV(gloss, worldNormal, viewDir);
	dLTCSpecFres = getLTCLightSpecFres(dLTCUV, specularity);
	#ifdef LIT_CLEARCOAT
		ccLTCUV = getLTCLightUV(clearcoatGloss, clearcoatWorldNormal, viewDir);
		ccLTCSpecFres = getLTCLightSpecFres(ccLTCUV, vec3f(clearcoatSpecularity));
	#endif
}
fn calcRectLightValues(lightPos: vec3f, halfWidth: vec3f, halfHeight: vec3f) {
	dLTCCoords = getLTCLightCoords(lightPos, halfWidth, halfHeight);
}
fn calcDiskLightValues(lightPos: vec3f, halfWidth: vec3f, halfHeight: vec3f) {
	calcRectLightValues(lightPos, halfWidth, halfHeight);
}
fn calcSphereLightValues(lightPos: vec3f, halfWidth: vec3f, halfHeight: vec3f) {
	dLTCCoords = getSphereLightCoords(lightPos, halfWidth, halfHeight);
}
fn SolveCubic(Coefficient_in: vec4f) -> vec3f {
	let pi: f32 = 3.14159;
	var Coefficient = Coefficient_in;
	Coefficient = vec4f(Coefficient.xyz / Coefficient.w, Coefficient.w);
	let new_yz: vec2f = Coefficient.yz / 3.0;
	Coefficient = vec4f(Coefficient.x, new_yz.x, new_yz.y, Coefficient.w);
	
	let A: f32 = Coefficient.w;
	let B: f32 = Coefficient.z;
	let C: f32 = Coefficient.y;
	let D: f32 = Coefficient.x;
	let Delta: vec3f = vec3f(
		-Coefficient.z * Coefficient.z + Coefficient.y,
		-Coefficient.y * Coefficient.z + Coefficient.x,
		dot(vec2f(Coefficient.z, -Coefficient.y), Coefficient.xy)
	);
	let Discriminant: f32 = dot(vec2f(4.0 * Delta.x, -Delta.y), Delta.zy);
	var xlc: vec2f;
	var xsc: vec2f;
	{
		let A_a: f32 = 1.0;
		let C_a: f32 = Delta.x;
		let D_a: f32 = -2.0 * B * Delta.x + Delta.y;
		let Theta: f32 = atan2(sqrt(Discriminant), -D_a) / 3.0;
		let sqrt_neg_Ca = sqrt(-C_a);
		let x_1a: f32 = 2.0 * sqrt_neg_Ca * cos(Theta);
		let x_3a: f32 = 2.0 * sqrt_neg_Ca * cos(Theta + (2.0 / 3.0) * pi);
		let xl: f32 = select(x_3a, x_1a, (x_1a + x_3a) > 2.0 * B);
		xlc = vec2f(xl - B, A);
	}
	{
		let A_d: f32 = D;
		let C_d: f32 = Delta.z;
		let D_d: f32 = -D * Delta.y + 2.0 * C * Delta.z;
		let Theta: f32 = atan2(D * sqrt(Discriminant), -D_d) / 3.0;
		let sqrt_neg_Cd = sqrt(-C_d);
		let x_1d: f32 = 2.0 * sqrt_neg_Cd * cos(Theta);
		let x_3d: f32 = 2.0 * sqrt_neg_Cd * cos(Theta + (2.0 / 3.0) * pi);
		let xs: f32 = select(x_3d, x_1d, x_1d + x_3d < 2.0 * C);
		xsc = vec2f(-D, xs + C);
	}
	let E: f32 =  xlc.y * xsc.y;
	let F: f32 = -xlc.x * xsc.y - xlc.y * xsc.x;
	let G: f32 =  xlc.x * xsc.x;
	let xmc: vec2f = vec2f(C * F - B * G, -B * F + C * E);
	var Root: vec3f = vec3f(xsc.x / xsc.y, xmc.x / xmc.y, xlc.x / xlc.y);
	if (Root.x < Root.y && Root.x < Root.z) {
		Root = Root.yxz;
	} else if (Root.z < Root.x && Root.z < Root.y) {
		Root = Root.xzy;
	}
	return Root;
}
fn LTC_EvaluateDisk(N: vec3f, V: vec3f, P: vec3f, Minv: mat3x3f, points: Coords) -> f32 {
	let T1: vec3f = normalize(V - N * dot(V, N));
	let T2: vec3f = cross(N, T1);
	let R: mat3x3f = transpose( mat3x3f( T1, T2, N ) );
	var L_: array<vec3f, 3>;
	L_[0] = R * ( points.coord0 - P );
	L_[1] = R * ( points.coord1 - P );
	L_[2] = R * ( points.coord2 - P );
	let C: vec3f  = 0.5 * (L_[0] + L_[2]);
	var V1: vec3f = 0.5 * (L_[1] - L_[2]);
	var V2: vec3f = 0.5 * (L_[1] - L_[0]);
	let C_Minv: vec3f  = Minv * C;
	let V1_Minv: vec3f = Minv * V1;
	let V2_Minv: vec3f = Minv * V2;
	var a: f32;
	var b: f32;
	let d11: f32 = dot(V1_Minv, V1_Minv);
	let d22: f32 = dot(V2_Minv, V2_Minv);
	let d12: f32 = dot(V1_Minv, V2_Minv);
	if (abs(d12) / sqrt(d11 * d22) > 0.0001) {
		let tr: f32 = d11 + d22;
		let det_inner: f32 = -d12 * d12 + d11 * d22;
		let det: f32 = sqrt(det_inner);
		let u: f32 = 0.5 * sqrt(tr - 2.0 * det);
		let v: f32 = 0.5 * sqrt(tr + 2.0 * det);
		let e_max: f32 = (u + v) * (u + v);
		let e_min: f32 = (u - v) * (u - v);
		var V1_: vec3f;
		var V2_: vec3f;
		if (d11 > d22) {
			V1_ = d12 * V1_Minv + (e_max - d11) * V2_Minv;
			V2_ = d12 * V1_Minv + (e_min - d11) * V2_Minv;
		} else {
			V1_ = d12*V2_Minv + (e_max - d22)*V1_Minv;
			V2_ = d12*V2_Minv + (e_min - d22)*V1_Minv;
		}
		a = 1.0 / e_max;
		b = 1.0 / e_min;
		V1 = normalize(V1_);
		V2 = normalize(V2_);
	} else {
		a = 1.0 / dot(V1_Minv, V1_Minv);
		b = 1.0 / dot(V2_Minv, V2_Minv);
		V1 = V1_Minv * sqrt(a);
		V2 = V2_Minv * sqrt(b);
	}
	var V3: vec3f = normalize(cross(V1, V2));
	if (dot(C_Minv, V3) < 0.0) {
		V3 = V3 * -1.0;
	}
	let L: f32  = dot(V3, C_Minv);
	let x0: f32 = dot(V1, C_Minv) / L;
	let y0: f32 = dot(V2, C_Minv) / L;
	let E1: f32 = inverseSqrt(a);
	let E2: f32 = inverseSqrt(b);
	let a_scaled = a * L * L;
	let b_scaled = b * L * L;
	let c0: f32 = a_scaled * b_scaled;
	let c1: f32 = a_scaled * b_scaled * (1.0 + x0 * x0 + y0 * y0) - a_scaled - b_scaled;
	let c2: f32 = 1.0 - a_scaled * (1.0 + x0 * x0) - b_scaled * (1.0 + y0 * y0);
	let c3: f32 = 1.0;
	let roots: vec3f = SolveCubic(vec4f(c0, c1, c2, c3));
	let e1: f32 = roots.x;
	let e2: f32 = roots.y;
	let e3: f32 = roots.z;
	var avgDir: vec3f = vec3f(a_scaled * x0 / (a_scaled - e2), b_scaled * y0 / (b_scaled - e2), 1.0);
	let rotate: mat3x3f = mat3x3f(V1, V2, V3);
	avgDir = rotate * avgDir;
	avgDir = normalize(avgDir);
	let L1: f32 = sqrt(-e2 / e3);
	let L2: f32 = sqrt(-e2 / e1);
	let formFactor: f32 = max(0.0, L1 * L2 * inverseSqrt((1.0 + L1 * L1) * (1.0 + L2 * L2)));
	const LUT_SIZE_disk: f32 = 64.0;
	const LUT_SCALE_disk: f32 = ( LUT_SIZE_disk - 1.0 ) / LUT_SIZE_disk;
	const LUT_BIAS_disk: f32 = 0.5 / LUT_SIZE_disk;
	var uv: vec2f = vec2f(avgDir.z * 0.5 + 0.5, formFactor);
	uv = uv * LUT_SCALE_disk + LUT_BIAS_disk;
	let scale: f32 = textureSampleLevel(areaLightsLutTex2, areaLightsLutTex2Sampler, uv, 0.0).w;
	return formFactor * scale;
}
fn FixNan(value: f32) -> f32 {
	return select(value, 0.0, value != value);
}
fn getRectLightDiffuse(worldNormal: vec3f, viewDir: vec3f, lightDir: vec3f, lightDirNorm: vec3f) -> f32 {
	let identityMat = mat3x3f(vec3f(1.0, 0.0, 0.0), vec3f(0.0, 1.0, 0.0), vec3f(0.0, 0.0, 1.0));
	return LTC_EvaluateRect( worldNormal, viewDir, vPositionW, identityMat, dLTCCoords );
}
fn getDiskLightDiffuse(worldNormal: vec3f, viewDir: vec3f, lightDir: vec3f, lightDirNorm: vec3f) -> f32 {
	let identityMat = mat3x3f(vec3f(1.0, 0.0, 0.0), vec3f(0.0, 1.0, 0.0), vec3f(0.0, 0.0, 1.0));
	return FixNan(LTC_EvaluateDisk( worldNormal, viewDir, vPositionW, identityMat, dLTCCoords ));
}
fn getSphereLightDiffuse(worldNormal: vec3f, viewDir: vec3f, lightDir: vec3f, lightDirNorm: vec3f) -> f32 {
	let falloff: f32 = dSphereRadius / (dot(lightDir, lightDir) + dSphereRadius);
	return FixNan(getLightDiffuse(worldNormal, viewDir, lightDirNorm) * falloff);
}
fn getLTCLightInvMat(uv: vec2f) -> mat3x3f {
	let t1: vec4f = textureSampleLevel(areaLightsLutTex1, areaLightsLutTex1Sampler, uv, 0.0);
	return mat3x3f(
		vec3f( t1.x, 0.0, t1.y ),
		vec3f( 0.0, 1.0, 0.0 ),
		vec3f( t1.z, 0.0, t1.w )
	);
}
fn calcRectLightSpecular(worldNormal: vec3f, viewDir: vec3f, uv: vec2f) -> f32 {
	let mInv: mat3x3f = getLTCLightInvMat(uv);
	return LTC_EvaluateRect( worldNormal, viewDir, vPositionW, mInv, dLTCCoords );
}
fn getRectLightSpecular(worldNormal: vec3f, viewDir: vec3f) -> f32 {
	return calcRectLightSpecular(worldNormal, viewDir, dLTCUV);
}
fn calcDiskLightSpecular(worldNormal: vec3f, viewDir: vec3f, uv: vec2f) -> f32 {
	let mInv: mat3x3f = getLTCLightInvMat(uv);
	return LTC_EvaluateDisk( worldNormal, viewDir, vPositionW, mInv, dLTCCoords );
}
fn getDiskLightSpecular(worldNormal: vec3f, viewDir: vec3f) -> f32 {
	return calcDiskLightSpecular(worldNormal, viewDir, dLTCUV);
}
fn getSphereLightSpecular(worldNormal: vec3f, viewDir: vec3f) -> f32 {
	return calcDiskLightSpecular(worldNormal, viewDir, dLTCUV);
}
`;

var metalness_default2 = `
#ifdef STD_METALNESS_CONSTANT
uniform material_metalness: f32;
#endif
fn getMetalness() {
	var metalness: f32 = 1.0;
	#ifdef STD_METALNESS_CONSTANT
		metalness = metalness * uniform.material_metalness;
	#endif
	#ifdef STD_METALNESS_TEXTURE
		metalness = metalness * textureSampleBias({STD_METALNESS_TEXTURE_NAME}, {STD_METALNESS_TEXTURE_NAME}Sampler, {STD_METALNESS_TEXTURE_UV}, uniform.textureBias).{STD_METALNESS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_METALNESS_VERTEX
	metalness = metalness * saturate(vVertexColor.{STD_METALNESS_VERTEX_CHANNEL});
	#endif
	dMetalness = metalness;
}
`;

var msdf_default3 = `
var texture_msdfMap: texture_2d<f32>;
var texture_msdfMapSampler: sampler;
fn median(r: f32, g: f32, b: f32) -> f32 {
	return max(min(r, g), min(max(r, g), b));
}
uniform font_sdfIntensity: f32;
uniform font_pxrange: f32;
#ifndef LIT_MSDF_TEXT_ATTRIBUTE
	uniform outline_color: vec4f;
	uniform outline_thickness: f32;
	uniform shadow_color: vec4f;
	uniform shadow_offset: vec2f;
#else
	varying outline_color: vec4f;
	varying outline_thickness: f32;
	varying shadow_color: vec4f;
	varying shadow_offset: vec2f;
#endif
fn applyMsdf(color_in: vec4f) -> vec4f {
	#ifndef LIT_MSDF_TEXT_ATTRIBUTE
		var outline_colorValue = uniform.outline_color;
		var outline_thicknessValue = uniform.outline_thickness;
		var shadow_colorValue = uniform.shadow_color;
		var shadow_offsetValue = uniform.shadow_offset;
	#else
		var outline_colorValue = outline_color;
		var outline_thicknessValue = outline_thickness;
		var shadow_colorValue = shadow_color;
		var shadow_offsetValue = shadow_offset;
	#endif
	let srcAlpha: f32 = max(color_in.a, 0.0001);
	var color = vec4f(gammaCorrectInputVec3(color_in.rgb / srcAlpha) * srcAlpha, color_in.a);
	let tsample: vec3f = textureSample(texture_msdfMap, texture_msdfMapSampler, vUv0).rgb;
	let uvShdw: vec2f = vUv0 - shadow_offsetValue;
	let ssample: vec3f = textureSample(texture_msdfMap, texture_msdfMapSampler, uvShdw).rgb;
	let sigDist: f32 = median(tsample.r, tsample.g, tsample.b);
	let sigDistShdw: f32 = median(ssample.r, ssample.g, ssample.b);
	let edge: f32 = 0.5 - 0.5 * uniform.font_sdfIntensity;
	let unitRange: vec2f = vec2f(uniform.font_pxrange) / vec2f(textureDimensions(texture_msdfMap, 0));
	let uvDeriv: vec2f = max(abs(dpdx(vUv0)) + abs(dpdy(vUv0)), vec2f(1e-6));
	let screenPxRange: f32 = max(0.5 * dot(unitRange, vec2f(1.0) / uvDeriv), 2.5);
	let inside: f32 = clamp(screenPxRange * (sigDist - edge) + 0.5, 0.0, 1.0);
	let outline: f32 = clamp(screenPxRange * (sigDist + outline_thicknessValue - edge) + 0.5, 0.0, 1.0);
	let shadow: f32 = clamp(screenPxRange * (sigDistShdw + outline_thicknessValue - edge) + 0.5, 0.0, 1.0);
	let tcolor_outline: vec4f = outline * vec4f(outline_colorValue.a * outline_colorValue.rgb, outline_colorValue.a);
	var tcolor: vec4f = select(vec4f(0.0), tcolor_outline, outline > inside);
	tcolor = mix(tcolor, color, inside);
	let scolor_shadow: vec4f = shadow * vec4f(shadow_colorValue.a * shadow_colorValue.rgb, shadow_colorValue.a);
	let scolor: vec4f = select(tcolor, scolor_shadow, shadow > outline);
	tcolor = mix(scolor, tcolor, outline);
	tcolor = vec4f(gammaCorrectOutput(tcolor.rgb / max(tcolor.a, 0.0001)) * tcolor.a, tcolor.a);
	return tcolor;
}
`;

var metalnessModulate_default2 = `
fn getSpecularModulate(specularity: vec3f, albedo: vec3f, metalness: f32, f0: f32, specularityFactor: f32) -> vec3f {
	let dielectricF0: vec3f = f0 * specularity * specularityFactor;
	return mix(dielectricF0, albedo, metalness);
}
fn getAlbedoModulate(albedo: vec3f, metalness: f32) -> vec3f {
	return albedo * (1.0 - metalness);
}
`;

var morph_default3 = `
	varying uv0: vec2f;
	var morphTexture: texture_2d_array<f32>;
	uniform morphFactor: array<f32, {MORPH_TEXTURE_MAX_COUNT}>;
	uniform morphIndex: array<u32, {MORPH_TEXTURE_MAX_COUNT}>;
	uniform count: u32;
	@fragment
	fn fragmentMain(input : FragmentInput) -> FragmentOutput {
		var color = vec3f(0, 0, 0);
		let textureDims = textureDimensions(morphTexture);
		let pixelCoords = vec2i(input.uv0 * vec2f(textureDims));
		
		for (var i: u32 = 0; i < uniform.count; i = i + 1) {
			var textureIndex: u32 = uniform.morphIndex[i].element;
			var delta = textureLoad(morphTexture, pixelCoords, textureIndex, 0).xyz;
			color += uniform.morphFactor[i].element * delta;
		}
		var output: FragmentOutput;
		output.color = vec4f(color, 1.0);
		return output;
	}
`;

var morph_default4 = `
	attribute vertex_position: vec2f;
	varying uv0: vec2f;
	@vertex
	fn vertexMain(input: VertexInput) -> VertexOutput {
		var output: VertexOutput;
		output.position = vec4f(input.vertex_position, 0.5, 1.0);
		output.uv0 = input.vertex_position * 0.5 + vec2f(0.5, 0.5);
		return output;
	}
`;

var msdf_default4 = `
attribute vertex_outlineParameters: vec3f;
attribute vertex_shadowParameters: vec3f;
varying outline_color: vec4f;
varying outline_thickness: f32;
varying shadow_color: vec4f;
varying shadow_offset: vec2f;
var<private> dOutlineColor: vec4f;
var<private> dOutlineThickness: f32;
var<private> dShadowColor: vec4f;
var<private> dShadowOffset: vec2f;
fn unpackMsdfParams() {
	let little: vec3f = vertex_outlineParameters % vec3f(256.0);
	let big: vec3f = (vertex_outlineParameters - little) / 256.0;
	dOutlineColor = vec4f(little.x, big.x, little.y, big.y) / 255.0;
	dOutlineThickness = little.z / 255.0 * 0.2;
	let little_shadow = vertex_shadowParameters % vec3f(256.0);
	let big_shadow = (vertex_shadowParameters - little_shadow) / 256.0;
	dShadowColor = vec4f(little_shadow.x, big_shadow.x, little_shadow.y, big_shadow.y) / 255.0;
	dShadowOffset = (vec2f(little_shadow.z, big_shadow.z) / 127.0 - 1.0) * 0.005;
}
`;

var normal_default2 = `
var<private> dNormalMatrix: mat3x3f;
fn getNormal() -> vec3f {
	dNormalMatrix = getNormalMatrix(dModelMatrix);
	let localNormal: vec3f = getLocalNormal(vertex_normal);
	return normalize(dNormalMatrix * localNormal);
}`;

var normalCore_default2 = `
attribute vertex_normal: vec3f;
uniform matrix_normal: mat3x3f;
#ifdef MORPHING_NORMAL
	#ifdef MORPHING_INT
		var morphNormalTex: texture_2d<u32>;
		var morphNormalTexSampler: sampler;
	#else
		var morphNormalTex: texture_2d<f32>;
		var morphNormalTexSampler: sampler;
	#endif
#endif
fn getLocalNormal(vertexNormal: vec3f) -> vec3f {
	var localNormal: vec3f = vertexNormal;
	#ifdef MORPHING_NORMAL
		let morphUV: vec2i = getTextureMorphCoords();
		#ifdef MORPHING_INT
			let morphNormalInt: vec4u = textureLoad(morphNormalTex, morphUV, 0);
			let morphNormalF: vec3f = vec3f(morphNormalInt.xyz) / 65535.0 * 2.0 - 1.0;
			localNormal = localNormal + morphNormalF;
		#else
			let morphNormal: vec3f = textureLoad(morphNormalTex, morphUV, 0).xyz;
			localNormal = localNormal + morphNormal;
		#endif
	#endif
	return localNormal;
}
#if defined(SKIN) || defined(BATCH)
	fn getNormalMatrix(modelMatrix: mat4x4f) -> mat3x3f {
		return mat3x3f(modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz);
	}
#elif defined(INSTANCING)
	fn getNormalMatrix(modelMatrix: mat4x4f) -> mat3x3f {
		return mat3x3f(modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz);
	}
#else
	fn getNormalMatrix(modelMatrix: mat4x4f) -> mat3x3f {
		return uniform.matrix_normal;
	}
#endif
`;

var normalMap_default2 = `
#ifdef STD_NORMAL_TEXTURE
	uniform material_bumpiness: f32;
#endif
#ifdef STD_NORMALDETAIL_TEXTURE
	uniform material_normalDetailMapBumpiness: f32;
	fn blendNormals(inN1: vec3f, inN2: vec3f) -> vec3f {
		let n1: vec3f = inN1 + vec3f(0.0, 0.0, 1.0);
		let n2: vec3f = inN2 * vec3f(-1.0, -1.0, 1.0);
		return n1 * dot(n1, n2) / n1.z - n2;
	}
#endif
fn getNormal() {
#ifdef STD_NORMAL_TEXTURE
	var normalMap: vec3f = {STD_NORMAL_TEXTURE_DECODE}(textureSampleBias({STD_NORMAL_TEXTURE_NAME}, {STD_NORMAL_TEXTURE_NAME}Sampler, {STD_NORMAL_TEXTURE_UV}, uniform.textureBias));
	normalMap = mix(vec3f(0.0, 0.0, 1.0), normalMap, uniform.material_bumpiness);
	#ifdef STD_NORMALDETAIL_TEXTURE
		var normalDetailMap: vec3f = {STD_NORMALDETAIL_TEXTURE_DECODE}(textureSampleBias({STD_NORMALDETAIL_TEXTURE_NAME}, {STD_NORMALDETAIL_TEXTURE_NAME}Sampler, {STD_NORMALDETAIL_TEXTURE_UV}, uniform.textureBias));
		normalDetailMap = mix(vec3f(0.0, 0.0, 1.0), normalDetailMap, uniform.material_normalDetailMapBumpiness);
		normalMap = blendNormals(normalMap, normalDetailMap);
	#endif
	dNormalW = normalize(dTBN * normalMap);
#else
	dNormalW = dVertexNormalW;
#endif
}
`;

var opacity_default2 = `
uniform material_opacity: f32;
uniform material_alphaDitherScale: f32;
fn getOpacity() {
	dAlpha = uniform.material_opacity;
	#ifdef STD_OPACITY_TEXTURE
	dAlpha = dAlpha * textureSampleBias({STD_OPACITY_TEXTURE_NAME}, {STD_OPACITY_TEXTURE_NAME}Sampler, {STD_OPACITY_TEXTURE_UV}, uniform.textureBias).{STD_OPACITY_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_OPACITY_VERTEX
	dAlpha = dAlpha * clamp(vVertexColor.{STD_OPACITY_VERTEX_CHANNEL}, 0.0, 1.0);
	#endif
}
`;

var opacity_dither_default2 = `
#if STD_OPACITY_DITHER == BAYER8
	#include "bayerPS"
#endif
uniform blueNoiseJitter: vec4f;
#if STD_OPACITY_DITHER == BLUENOISE
	var blueNoiseTex32 : texture_2d<f32>;
	var blueNoiseTex32Sampler : sampler;
#endif
fn opacityDither(alpha: f32, id: f32) {
	if (alpha <= 0.0) {
		discard;
	}
	if (alpha >= 1.0) {
		return;
	}
	#if STD_OPACITY_DITHER == BAYER8
		var noise: f32 = bayer8(floor((pcPosition.xy + uniform.blueNoiseJitter.xy + id) % vec2f(8.0))) / 64.0;
	#else
		#if STD_OPACITY_DITHER == BLUENOISE
			var uv = fract(pcPosition.xy / 32.0 + uniform.blueNoiseJitter.xy + id);
			var noise: f32 = textureSampleLevel(blueNoiseTex32, blueNoiseTex32Sampler, uv, 0.0).y;
		#endif
		#if STD_OPACITY_DITHER == IGNNOISE
			var magic = vec3f(0.06711056, 0.00583715, 52.9829189);
			var noise: f32 = fract(magic.z * fract(dot(pcPosition.xy + uniform.blueNoiseJitter.xy + id, magic.xy)));
		#endif
	#endif
	noise = pow(noise, 2.2);
	if (alpha < noise) {
		discard;
	}
}
`;

var outline_declaration_default2 = `
#ifdef PCOUTLINE_PASS
uniform pcOutlineColor: vec3f;
#endif
`;

var outline_output_default2 = `
#ifdef PCOUTLINE_PASS
output.color = vec4f(gammaCorrectOutput(uniform.pcOutlineColor), output.color.a);
#endif
`;

var output_default2 = `
`;

var outputAlpha_default2 = `
#if LIT_BLEND_TYPE == NORMAL || LIT_BLEND_TYPE == ADDITIVEALPHA || defined(LIT_ALPHA_TO_COVERAGE)
	output.color = vec4f(output.color.rgb, litArgs_opacity);
#elif LIT_BLEND_TYPE == PREMULTIPLIED
	output.color = vec4f(output.color.rgb * litArgs_opacity, litArgs_opacity);
#else
	output.color = vec4f(output.color.rgb, 1.0);
#endif
`;

var outputTex2D_default2 = `
varying vUv0: vec2f;
var source: texture_2d<f32>;
var sourceSampler: sampler;
@fragment fn fragmentMain(input : FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	output.color = textureSample(source, sourceSampler, input.vUv0);
	return output;
}
`;

var sheen_default2 = `
uniform material_sheen: vec3f;
fn getSheen() {
	var sheenColor = uniform.material_sheen;
	#ifdef STD_SHEEN_TEXTURE
	sheenColor = sheenColor * {STD_SHEEN_TEXTURE_DECODE}(textureSampleBias({STD_SHEEN_TEXTURE_NAME}, {STD_SHEEN_TEXTURE_NAME}Sampler, {STD_SHEEN_TEXTURE_UV}, uniform.textureBias)).{STD_SHEEN_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_SHEEN_VERTEX
	sheenColor = sheenColor * saturate3(vVertexColor.{STD_SHEEN_VERTEX_CHANNEL});
	#endif
	sSpecularity = sheenColor;
}
`;

var sheenGloss_default2 = `
uniform material_sheenGloss: f32;
fn getSheenGlossiness() {
	var sheenGlossiness = uniform.material_sheenGloss;
	#ifdef STD_SHEENGLOSS_TEXTURE
	sheenGlossiness = sheenGlossiness * textureSampleBias({STD_SHEENGLOSS_TEXTURE_NAME}, {STD_SHEENGLOSS_TEXTURE_NAME}Sampler, {STD_SHEENGLOSS_TEXTURE_UV}, uniform.textureBias).{STD_SHEENGLOSS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_SHEENGLOSS_VERTEX
	sheenGlossiness = sheenGlossiness * saturate(vVertexColor.{STD_SHEENGLOSS_VERTEX_CHANNEL});
	#endif
	#ifdef STD_SHEENGLOSS_INVERT
	sheenGlossiness = 1.0 - sheenGlossiness;
	#endif
	sGlossiness = sheenGlossiness + 0.0000001;
}
`;

var parallax_default2 = `
uniform material_heightMapFactor: f32;
fn getParallax() {
	var parallaxScale = uniform.material_heightMapFactor;
	var height: f32 = textureSampleBias({STD_HEIGHT_TEXTURE_NAME}, {STD_HEIGHT_TEXTURE_NAME}Sampler, {STD_HEIGHT_TEXTURE_UV}, uniform.textureBias).{STD_HEIGHT_TEXTURE_CHANNEL};
	height = height * parallaxScale - parallaxScale * 0.5;
	var viewDirT: vec3f = dViewDirW * dTBN;
	viewDirT.z = viewDirT.z + 0.42;
	dUvOffset = height * (viewDirT.xy / viewDirT.z);
}
`;

var pick_default2 = `
fn encodePickOutput(id: u32) -> vec4f {
	let inv: vec4f = vec4f(1.0 / 255.0);
	let shifts: vec4u = vec4u(16u, 8u, 0u, 24u);
	let col: vec4u = (vec4u(id) >> shifts) & vec4u(0xffu);
	return vec4f(col) * inv;
}
#ifndef PICK_CUSTOM_ID
	uniform meshInstanceId: u32;
	fn getPickOutput() -> vec4f {
		return encodePickOutput(uniform.meshInstanceId);
	}
#endif
#ifdef DEPTH_PICK_PASS
	#include "floatAsUintPS"
	#ifndef CAMERAPLANES
		#define CAMERAPLANES
		uniform camera_params: vec4f;
	#endif
	fn getPickDepth() -> vec4f {
		var linearDepth: f32;
		if (uniform.camera_params.w > 0.5) {
			linearDepth = pcPosition.z;
		} else {
			let viewDist = 1.0 / pcPosition.w;
			linearDepth = (viewDist - uniform.camera_params.z) / (uniform.camera_params.y - uniform.camera_params.z);
		}
		return float2uint(linearDepth);
	}
#endif
`;

var reflDir_default2 = `
fn getReflDir(worldNormal: vec3f, viewDir: vec3f, gloss: f32, tbn: mat3x3f) {
	dReflDirW = normalize(-reflect(viewDir, worldNormal));
}
`;

var reflDirAniso_default2 = `
fn getReflDir(worldNormal: vec3f, viewDir: vec3f, gloss: f32, tbn: mat3x3f) {
	let roughness: f32 = sqrt(1.0 - min(gloss, 1.0));
	let direction: vec2f = dAnisotropyRotation;
	let anisotropicT: vec3f = normalize(tbn * vec3f(direction, 0.0));
	let anisotropicB: vec3f = normalize(cross(tbn[2], anisotropicT));
	let anisotropy: f32 = dAnisotropy;
	let anisotropicDirection: vec3f = anisotropicB;
	let anisotropicTangent: vec3f = cross(anisotropicDirection, viewDir);
	let anisotropicNormal: vec3f = cross(anisotropicTangent, anisotropicDirection);
	let bendFactor: f32 = 1.0 - anisotropy * (1.0 - roughness);
	let bendFactor4: f32 = bendFactor * bendFactor * bendFactor * bendFactor;
	let bentNormal: vec3f = normalize(mix(normalize(anisotropicNormal), normalize(worldNormal), bendFactor4));
	dReflDirW = reflect(-viewDir, bentNormal);
}`;

var reflectionCC_default2 = `
#ifdef LIT_CLEARCOAT
fn addReflectionCC(reflDir: vec3f, gloss: f32) {
	ccReflection = ccReflection + calcReflection(reflDir, gloss);
}
#endif
`;

var reflectionCube_default2 = `
var texture_cubeMap: texture_cube<f32>;
var texture_cubeMapSampler: sampler;
uniform material_reflectivity: f32;
fn calcReflection(reflDir: vec3f, gloss: f32) -> vec3f {
	var lookupVec: vec3f = cubeMapProject(reflDir);
	lookupVec.x = lookupVec.x * -1.0;
	return {reflectionDecode}(textureSample(texture_cubeMap, texture_cubeMapSampler, lookupVec));
}
fn addReflection(reflDir: vec3f, gloss: f32) {
	dReflection = dReflection + vec4f(calcReflection(reflDir, gloss), uniform.material_reflectivity);
}
`;

var reflectionEnvHQ_default2 = `
#ifndef ENV_ATLAS
	#define ENV_ATLAS
	var texture_envAtlas: texture_2d<f32>;
	var texture_envAtlasSampler: sampler;
#endif
var texture_cubeMap: texture_cube<f32>;
var texture_cubeMapSampler: sampler;
uniform material_reflectivity: f32;
fn calcReflection(reflDir: vec3f, gloss: f32) -> vec3f {
	let dir: vec3f = cubeMapProject(reflDir) * vec3f(-1.0, 1.0, 1.0);
	let uv: vec2f = toSphericalUv(dir);
	let level: f32 = saturate(1.0 - gloss) * 5.0;
	let ilevel: f32 = floor(level);
	let flevel: f32 = level - ilevel;
	let sharp: vec3f = {reflectionCubemapDecode}(textureSample(texture_cubeMap, texture_cubeMapSampler, dir));
	let roughA: vec3f = {reflectionDecode}(textureSample(texture_envAtlas, texture_envAtlasSampler, mapRoughnessUv(uv, ilevel)));
	let roughB: vec3f = {reflectionDecode}(textureSample(texture_envAtlas, texture_envAtlasSampler, mapRoughnessUv(uv, ilevel + 1.0)));
	return processEnvironment(mix(sharp, mix(roughA, roughB, flevel), min(level, 1.0)));
}
fn addReflection(reflDir: vec3f, gloss: f32) {
	dReflection = dReflection + vec4f(calcReflection(reflDir, gloss), uniform.material_reflectivity);
}
`;

var reflectionEnv_default2 = `
#ifndef ENV_ATLAS
#define ENV_ATLAS
	var texture_envAtlas: texture_2d<f32>;
	var texture_envAtlasSampler: sampler;
#endif
uniform material_reflectivity: f32;
fn shinyMipLevel(uv: vec2f) -> f32 {
	let dx: vec2f = dpdx(uv);
	let dy: vec2f = dpdy(uv);
	let uv2: vec2f = vec2f(fract(uv.x + 0.5), uv.y);
	let dx2: vec2f = dpdx(uv2);
	let dy2: vec2f = dpdy(uv2);
	let maxd: f32 = min(max(dot(dx, dx), dot(dy, dy)), max(dot(dx2, dx2), dot(dy2, dy2)));
	return clamp(0.5 * log2(maxd) - 1.0 + uniform.textureBias, 0.0, 5.0);
}
fn calcReflection(reflDir: vec3f, gloss: f32) -> vec3f {
	let dir: vec3f = cubeMapProject(reflDir) * vec3f(-1.0, 1.0, 1.0);
	let uv: vec2f = toSphericalUv(dir);
	let level: f32 = saturate(1.0 - gloss) * 5.0;
	let ilevel: f32 = floor(level);
	let level2: f32 = shinyMipLevel(uv * atlasSize);
	let ilevel2: f32 = floor(level2);
	var uv0: vec2f;
	var uv1: vec2f;
	var weight: f32;
	if (ilevel == 0.0) {
		uv0 = mapShinyUv(uv, ilevel2);
		uv1 = mapShinyUv(uv, ilevel2 + 1.0);
		weight = level2 - ilevel2;
	} else {
		uv0 = mapRoughnessUv(uv, ilevel);
		uv1 = uv0;
		weight = 0.0;
	}
	let linearA: vec3f = {reflectionDecode}(textureSample(texture_envAtlas, texture_envAtlasSampler, uv0));
	let linearB: vec3f = {reflectionDecode}(textureSample(texture_envAtlas, texture_envAtlasSampler, uv1));
	let linear0: vec3f = mix(linearA, linearB, weight);
	let linear1: vec3f = {reflectionDecode}(textureSample(texture_envAtlas, texture_envAtlasSampler, mapRoughnessUv(uv, ilevel + 1.0)));
	return processEnvironment(mix(linear0, linear1, level - ilevel));
}
fn addReflection(reflDir: vec3f, gloss: f32) {
	dReflection = dReflection + vec4f(calcReflection(reflDir, gloss), uniform.material_reflectivity);
}
`;

var reflectionSphere_default2 = `
#ifndef VIEWMATRIX
	#define VIEWMATRIX
	uniform matrix_view: mat4x4f;
#endif
var texture_sphereMap: texture_2d<f32>;
var texture_sphereMapSampler: sampler;
uniform material_reflectivity: f32;
fn calcReflection(reflDir: vec3f, gloss: f32) -> vec3f {
	let viewRotationMatrix = mat3x3f(uniform.matrix_view[0].xyz, uniform.matrix_view[1].xyz, uniform.matrix_view[2].xyz);
	let reflDirV: vec3f = viewRotationMatrix * reflDir;
	let m: f32 = 2.0 * sqrt(dot(reflDirV.xy, reflDirV.xy) + (reflDirV.z + 1.0) * (reflDirV.z + 1.0));
	let sphereMapUv: vec2f = reflDirV.xy / m + 0.5;
	return {reflectionDecode}(textureSample(texture_sphereMap, texture_sphereMapSampler, sphereMapUv));
}
fn addReflection(reflDir: vec3f, gloss: f32) {
	dReflection = dReflection + vec4f(calcReflection(reflDir, gloss), uniform.material_reflectivity);
}
`;

var reflectionSheen_default2 = `
fn addReflectionSheen(worldNormal: vec3f, viewDir: vec3f, gloss: f32) {
	let NoV: f32 = dot(worldNormal, viewDir);
	let alphaG: f32 = gloss * gloss;
	let a: f32 = select(
		-8.48 * alphaG + 14.3 * gloss - 9.95,
		-339.2 * alphaG + 161.4 * gloss - 25.9,
		gloss < 0.25
	);
	let b: f32 = select(
		1.97 * alphaG - 3.27 * gloss + 0.72,
		44.0 * alphaG - 23.7 * gloss + 3.26,
		gloss < 0.25
	);
	let dg_add: f32 = select(
		0.1 * ( gloss - 0.25 ),
		0.0,
		gloss < 0.25
	);
	let dg: f32 = exp( a * NoV + b ) + dg_add;
	sReflection = sReflection + (calcReflection(worldNormal, 0.0) * saturate(dg));
}`;

var refractionCube_default2 = `
fn refract2(viewVec: vec3f, normal: vec3f, IOR: f32) -> vec3f {
	let vn: f32 = dot(viewVec, normal);
	let k: f32 = 1.0 - IOR * IOR * (1.0 - vn * vn);
	let refrVec: vec3f = IOR * viewVec - (IOR * vn + sqrt(k)) * normal;
	return refrVec;
}
fn addRefraction(
	worldNormal: vec3f,
	viewDir: vec3f,
	thickness: f32,
	gloss: f32,
	specularity: vec3f,
	albedo: vec3f,
	transmission: f32,
	refractionIndex: f32,
	dispersion: f32
#if defined(LIT_IRIDESCENCE)
	, iridescenceFresnel: vec3f,
	iridescenceIntensity: f32
#endif
) {
	let tmpRefl: vec4f = dReflection;
	let reflectionDir: vec3f = refract2(-viewDir, worldNormal, refractionIndex);
	dReflection = vec4f(0.0);
	addReflection(reflectionDir, gloss);
	dDiffuseLight = mix(dDiffuseLight, dReflection.rgb * albedo, transmission);
	dReflection = tmpRefl;
}
`;

var refractionDynamic_default2 = `
uniform material_invAttenuationDistance: f32;
uniform material_attenuation: vec3f;
fn evalRefractionColor(refractionVector: vec3f, gloss: f32, refractionIndex: f32) -> vec3f {
	let pointOfRefraction: vec4f = vec4f(vPositionW + refractionVector, 1.0);
	let projectionPoint: vec4f = uniform.matrix_viewProjection * pointOfRefraction;
	let uv: vec2f = getGrabScreenPos(projectionPoint);
	let iorToRoughness: f32 = (1.0 - gloss) * clamp((1.0 / refractionIndex) * 2.0 - 2.0, 0.0, 1.0);
	let refractionLod: f32 = log2(uniform.uScreenSize.x) * iorToRoughness;
	var refraction: vec3f = textureSampleLevel(uSceneColorMap, uSceneColorMapSampler, uv, refractionLod).rgb;
	#ifdef SCENE_COLORMAP_GAMMA
		refraction = decodeGamma3(refraction);
	#endif
	return refraction;
}
fn addRefraction(
	worldNormal: vec3f,
	viewDir: vec3f,
	thickness: f32,
	gloss: f32,
	specularity: vec3f,
	albedo: vec3f,
	transmission: f32,
	refractionIndex: f32,
	dispersion: f32,
#if defined(LIT_IRIDESCENCE)
	iridescenceFresnel: vec3f,
	iridescenceIntensity: f32
#endif
) {
	var modelScale: vec3f;
	modelScale.x = length(uniform.matrix_model[0].xyz);
	modelScale.y = length(uniform.matrix_model[1].xyz);
	modelScale.z = length(uniform.matrix_model[2].xyz);
	let scale: vec3f = thickness * modelScale;
	var refractionVector = normalize(refract(-viewDir, worldNormal, refractionIndex)) * scale;
	var refraction = evalRefractionColor(refractionVector, gloss, refractionIndex);
	#ifdef LIT_DISPERSION
		let halfSpread: f32 = (1.0 / refractionIndex - 1.0) * 0.025 * dispersion;
		let refractionIndexR: f32 = refractionIndex - halfSpread;
		refractionVector = normalize(refract(-viewDir, worldNormal, refractionIndexR)) * scale;
		refraction.r = evalRefractionColor(refractionVector, gloss, refractionIndexR).r;
		let refractionIndexB: f32 = refractionIndex + halfSpread;
		refractionVector = normalize(refract(-viewDir, worldNormal, refractionIndexB)) * scale;
		refraction.b = evalRefractionColor(refractionVector, gloss, refractionIndexB).b;
	#endif
	var transmittance: vec3f;
	if (uniform.material_invAttenuationDistance != 0.0)
	{
		let attenuation: vec3f = -log(uniform.material_attenuation) * uniform.material_invAttenuationDistance;
		transmittance = exp(-attenuation * length(refractionVector));
	}
	else
	{
		transmittance = vec3f(1.0);
	}
	let fresnel: vec3f = vec3f(1.0) -
		getFresnel(
			dot(viewDir, worldNormal),
			gloss,
			specularity
		#if defined(LIT_IRIDESCENCE)
			, iridescenceFresnel,
			iridescenceIntensity
		#endif
		);
	dDiffuseLight = mix(dDiffuseLight, refraction * transmittance * fresnel, transmission);
}
`;

var reproject_default3 = `
varying vUv0: vec2f;
#ifdef CUBEMAP_SOURCE
	var sourceCube: texture_cube<f32>;
	var sourceCubeSampler : sampler;
#else
	var sourceTex: texture_2d<f32>;
	var sourceTexSampler : sampler;
#endif
#ifdef USE_SAMPLES_TEX
	var samplesTex: texture_2d<f32>;
	var samplesTexSampler : sampler;
	uniform samplesTexInverseSize: vec2f;
#endif
uniform params: vec3f;
fn targetFace() -> f32 { return uniform.params.x; }
fn targetTotalPixels() -> f32 { return uniform.params.y; }
fn sourceTotalPixels() -> f32 { return uniform.params.z; }
const PI: f32 = 3.141592653589793;
fn saturate(x: f32) -> f32 {
	return clamp(x, 0.0, 1.0);
}
#include "decodePS"
#include "encodePS"
fn modifySeams(dir: vec3f, scale: f32) -> vec3f {
	let adir = abs(dir);
	let M = max(max(adir.x, adir.y), adir.z);
	return dir / M * vec3f(
		select(scale, 1.0, adir.x == M),
		select(scale, 1.0, adir.y == M),
		select(scale, 1.0, adir.z == M)
	);
}
fn toSpherical(dir: vec3f) -> vec2f {
	let nonZeroXZ = any(dir.xz != vec2f(0.0, 0.0));
	return vec2f(select(0.0, atan2(dir.x, dir.z), nonZeroXZ), asin(dir.y));
}
fn fromSpherical(uv: vec2f) -> vec3f {
	return vec3f(cos(uv.y) * sin(uv.x),
				sin(uv.y),
				cos(uv.y) * cos(uv.x));
}
fn getDirectionEquirect(uv: vec2f) -> vec3f {
	return fromSpherical((vec2f(uv.x, 1.0 - uv.y) * 2.0 - 1.0) * vec2f(PI, PI * 0.5));
}
fn signNotZero(k: f32) -> f32 {
	return select(-1.0, 1.0, k >= 0.0);
}
fn signNotZeroVec2(v: vec2f) -> vec2f {
	return vec2f(signNotZero(v.x), signNotZero(v.y));
}
fn octDecode(o: vec2f) -> vec3f {
	var v = vec3f(o.x, 1.0 - abs(o.x) - abs(o.y), o.y);
	if (v.y < 0.0) {
		var temp: vec2f = (1.0 - abs(v.zx)) * signNotZeroVec2(v.xz);
		v = vec3f(temp.x, v.y, temp.y);
	}
	return normalize(v);
}
fn getDirectionOctahedral(uv: vec2f) -> vec3f {
	return octDecode(vec2f(uv.x, 1.0 - uv.y) * 2.0 - 1.0);
}
fn octEncode(v: vec3f) -> vec2f {
	let l1norm = abs(v.x) + abs(v.y) + abs(v.z);
	var result = v.xz * (1.0 / l1norm);
	if (v.y < 0.0) {
		result = (1.0 - abs(result.yx)) * signNotZeroVec2(result.xy);
	}
	return result;
}
#ifdef CUBEMAP_SOURCE
	fn sampleCubemapDir(dir: vec3f) -> vec4f {
		return textureSample(sourceCube, sourceCubeSampler, modifySeams(dir, 1.0));
	}
	fn sampleCubemapSph(sph: vec2f) -> vec4f {
		return sampleCubemapDir(fromSpherical(sph));
	}
	fn sampleCubemapDirLod(dir: vec3f, mipLevel: f32) -> vec4f {
		return textureSampleLevel(sourceCube, sourceCubeSampler, modifySeams(dir, 1.0), mipLevel);
	}
	fn sampleCubemapSphLod(sph: vec2f, mipLevel: f32) -> vec4f {
		return sampleCubemapDirLod(fromSpherical(sph), mipLevel);
	}
#else
	fn sampleEquirectSph(sph: vec2f) -> vec4f {
		let uv = sph / vec2f(PI * 2.0, PI) + 0.5;
		return textureSample(sourceTex, sourceTexSampler, vec2f(uv.x, 1.0 - uv.y));
	}
	fn sampleEquirectDir(dir: vec3f) -> vec4f {
		return sampleEquirectSph(toSpherical(dir));
	}
	fn sampleEquirectSphLod(sph: vec2f, mipLevel: f32) -> vec4f {
		let uv = sph / vec2f(PI * 2.0, PI) + 0.5;
		return textureSampleLevel(sourceTex, sourceTexSampler, vec2f(uv.x, 1.0 - uv.y), mipLevel);
	}
	fn sampleEquirectDirLod(dir: vec3f, mipLevel: f32) -> vec4f {
		return sampleEquirectSphLod(toSpherical(dir), mipLevel);
	}
	fn sampleOctahedralDir(dir: vec3f) -> vec4f {
		let uv = octEncode(dir) * 0.5 + 0.5;
		return textureSample(sourceTex, sourceTexSampler, vec2f(uv.x, 1.0 - uv.y));
	}
	fn sampleOctahedralSph(sph: vec2f) -> vec4f {
		return sampleOctahedralDir(fromSpherical(sph));
	}
	fn sampleOctahedralDirLod(dir: vec3f, mipLevel: f32) -> vec4f {
		let uv = octEncode(dir) * 0.5 + 0.5;
		return textureSampleLevel(sourceTex, sourceTexSampler, vec2f(uv.x, 1.0 - uv.y), mipLevel);
	}
	fn sampleOctahedralSphLod(sph: vec2f, mipLevel: f32) -> vec4f {
		return sampleOctahedralDirLod(fromSpherical(sph), mipLevel);
	}
#endif
fn getDirectionCubemap(uv: vec2f) -> vec3f {
	let st = uv * 2.0 - 1.0;
	let face = targetFace();
	var vec: vec3f;
	if (face == 0.0) {
		vec = vec3f(1, -st.y, -st.x);
	} else if (face == 1.0) {
		vec = vec3f(-1, -st.y, st.x);
	} else if (face == 2.0) {
		vec = vec3f(st.x, 1, st.y);
	} else if (face == 3.0) {
		vec = vec3f(st.x, -1, -st.y);
	} else if (face == 4.0) {
		vec = vec3f(st.x, -st.y, 1);
	} else {
		vec = vec3f(-st.x, -st.y, -1);
	}
	return normalize(modifySeams(vec, 1.0));
}
fn matrixFromVector(n: vec3f) -> mat3x3f {
	let a = 1.0 / (1.0 + n.z);
	let b = -n.x * n.y * a;
	let b1 = vec3f(1.0 - n.x * n.x * a, b, -n.x);
	let b2 = vec3f(b, 1.0 - n.y * n.y * a, -n.y);
	return mat3x3f(b1, b2, n);
}
fn matrixFromVectorSlow(n: vec3f) -> mat3x3f {
	let up = select(vec3f(0.0, 0.0, select(-1.0, 1.0, n.y > 0.0)), vec3f(0.0, 1.0, 0.0), abs(n.y) > 0.0000001);
	let x = normalize(cross(up, n));
	let y = cross(n, x);
	return mat3x3f(x, y, n);
}
fn reproject(uv: vec2f) -> vec4f {
	if ({NUM_SAMPLES} <= 1) {
		return {ENCODE_FUNC}({DECODE_FUNC}({SOURCE_FUNC}Dir({TARGET_FUNC}(uv))));
	} else {
		let t = {TARGET_FUNC}(uv);
		let tu = dpdx(t);
		let tv = dpdy(t);
		var result = vec3f(0.0);
		for (var u = 0.0; u < {NUM_SAMPLES_SQRT}; u += 1.0) {
			for (var v = 0.0; v < {NUM_SAMPLES_SQRT}; v += 1.0) {
				result += {DECODE_FUNC}({SOURCE_FUNC}Dir(normalize(t +
															tu * (u / {NUM_SAMPLES_SQRT} - 0.5) +
															tv * (v / {NUM_SAMPLES_SQRT} - 0.5))));
			}
		}
		return {ENCODE_FUNC}(result / ({NUM_SAMPLES_SQRT} * {NUM_SAMPLES_SQRT}));
	}
}
const unpackFloat: vec4f = vec4f(1.0, 1.0 / 255.0, 1.0 / 65025.0, 1.0 / 16581375.0);
#ifdef USE_SAMPLES_TEX
	fn unpackSample(i: i32, L: ptr<function, vec3f>, mipLevel: ptr<function, f32>) {
		var u = (f32(i * 4) + 0.5) * uniform.samplesTexInverseSize.x;
		var v = (floor(u) + 0.5) * uniform.samplesTexInverseSize.y;
		var raw: vec4f;
		raw.x = dot(textureSample(samplesTex, samplesTexSampler, vec2f(u, v)), unpackFloat); u += uniform.samplesTexInverseSize.x;
		raw.y = dot(textureSample(samplesTex, samplesTexSampler, vec2f(u, v)), unpackFloat); u += uniform.samplesTexInverseSize.x;
		raw.z = dot(textureSample(samplesTex, samplesTexSampler, vec2f(u, v)), unpackFloat); u += uniform.samplesTexInverseSize.x;
		raw.w = dot(textureSample(samplesTex, samplesTexSampler, vec2f(u, v)), unpackFloat);
		*L = raw.xyz * 2.0 - 1.0;
		*mipLevel = raw.w * 8.0;
	}
	fn prefilterSamples(uv: vec2f) -> vec4f {
		let vecSpace = matrixFromVectorSlow({TARGET_FUNC}(uv));
		var L: vec3f;
		var mipLevel: f32;
		var result = vec3f(0.0);
		var totalWeight = 0.0;
		for (var i = 0; i < {NUM_SAMPLES}; i += 1) {
			unpackSample(i, &L, &mipLevel);
			result += {DECODE_FUNC}({SOURCE_FUNC}DirLod(vecSpace * L, mipLevel)) * L.z;
			totalWeight += L.z;
		}
		return {ENCODE_FUNC}(result / totalWeight);
	}
	fn prefilterSamplesUnweighted(uv: vec2f) -> vec4f {
		let vecSpace = matrixFromVectorSlow({TARGET_FUNC}(uv));
		var L: vec3f;
		var mipLevel: f32;
		var result = vec3f(0.0);
		for (var i = 0; i < {NUM_SAMPLES}; i += 1) {
			unpackSample(i, &L, &mipLevel);
			result += {DECODE_FUNC}({SOURCE_FUNC}DirLod(vecSpace * L, mipLevel));
		}
		return {ENCODE_FUNC}(result / f32({NUM_SAMPLES}));
	}
#endif
@fragment
fn fragmentMain(input : FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	output.color = {PROCESS_FUNC}(input.vUv0);
	return output;
}
`;

var reproject_default4 = `
attribute vertex_position: vec2f;
uniform uvMod: vec4f;
varying vUv0: vec2f;
@vertex
fn vertexMain(input: VertexInput) -> VertexOutput {
	var output: VertexOutput;
	output.position = vec4f(input.vertex_position, 0.5, 1.0);
	output.vUv0 = getImageEffectUV((input.vertex_position * 0.5 + vec2f(0.5, 0.5)) * uniform.uvMod.xy + uniform.uvMod.zw);
	return output;
}
`;

var screenDepth_default2 = `
var uSceneDepthMap: texture_2d<uff>;
#ifndef SCREENSIZE
	#define SCREENSIZE
	uniform uScreenSize: vec4f;
#endif
#ifndef VIEWMATRIX
	#define VIEWMATRIX
	uniform matrix_view: mat4x4f;
#endif
#ifndef LINEARIZE_DEPTH
	#define LINEARIZE_DEPTH
	#ifndef CAMERAPLANES
		#define CAMERAPLANES
		uniform camera_params: vec4f;
	#endif
	fn linearizeDepth(z: f32) -> f32 {
		if (uniform.camera_params.w == 0.0) {
			return (uniform.camera_params.z * uniform.camera_params.y) / (uniform.camera_params.y + z * (uniform.camera_params.z - uniform.camera_params.y));
		} else {
			return uniform.camera_params.z + z * (uniform.camera_params.y - uniform.camera_params.z);
		}
	}
#endif
fn delinearizeDepth(linearDepth: f32) -> f32 {
	if (uniform.camera_params.w == 0.0) {
		return (uniform.camera_params.y * (uniform.camera_params.z - linearDepth)) / (linearDepth * (uniform.camera_params.z - uniform.camera_params.y));
	} else {
		return (linearDepth - uniform.camera_params.z) / (uniform.camera_params.y - uniform.camera_params.z);
	}
}
fn getLinearScreenDepth(uv: vec2f) -> f32 {
	let textureSize = textureDimensions(uSceneDepthMap, 0);
	let texel: vec2i = vec2i(uv * vec2f(textureSize));
	#ifdef SCENE_DEPTHMAP_LINEAR
		return textureLoad(uSceneDepthMap, texel, 0).r;
	#else
		return linearizeDepth(textureLoad(uSceneDepthMap, texel, 0).r);
	#endif
}
#ifndef VERTEXSHADER
	fn getLinearScreenDepthFrag() -> f32 {
		let uv: vec2f = pcPosition.xy * uniform.uScreenSize.zw;
		return getLinearScreenDepth(uv);
	}
#endif
fn getLinearDepth(pos: vec3f) -> f32 {
	return -(uniform.matrix_view * vec4f(pos, 1.0)).z;
}
`;

var shadowCascades_default2 = `
fn getShadowCascadeIndex(shadowCascadeDistances: vec4f, shadowCascadeCount: i32) -> i32 {
	let depth: f32 = 1.0 / pcPosition.w;
	let comparisons: vec4f = step(shadowCascadeDistances, vec4f(depth));
	let cascadeIndex: i32 = i32(dot(comparisons, vec4f(1.0)));
	return min(cascadeIndex, shadowCascadeCount - 1);
}
fn ditherShadowCascadeIndex(cascadeIndex_in: i32, shadowCascadeDistances: vec4f, shadowCascadeCount: i32, blendFactor: f32) -> i32 {
	var cascadeIndex: i32 = cascadeIndex_in;
	if (cascadeIndex < shadowCascadeCount - 1) {
		let currentRangeEnd: f32 = shadowCascadeDistances[cascadeIndex];
		let transitionStart: f32 = blendFactor * currentRangeEnd;
		let depth: f32 = 1.0 / pcPosition.w;
		if (depth > transitionStart) {
			let transitionFactor: f32 = smoothstep(transitionStart, currentRangeEnd, depth);
			let dither: f32 = fract(sin(dot(pcPosition.xy, vec2f(12.9898, 78.233))) * 43758.5453);
			if (dither < transitionFactor) {
				cascadeIndex = cascadeIndex + 1;
			}
		}
	}
	return cascadeIndex;
}
fn fadeShadow(shadowCoord_in: vec3f, shadowCascadeDistances: vec4f) -> vec3f {
	var shadowCoord: vec3f = shadowCoord_in;
	let depth: f32 = 1.0 / pcPosition.w;
	if (depth > shadowCascadeDistances.w) {
		shadowCoord.z = -9999999.0;
	}
	return shadowCoord;
}
`;

var shadowEVSM_default2 = `
fn linstep(a: f32, b: f32, v: f32) -> f32 {
	return clamp((v - a) / (b - a), 0.0, 1.0);
}
fn reduceLightBleeding(pMax: f32, amount: f32) -> f32 {
	 return linstep(amount, 1.0, pMax);
}
fn chebyshevUpperBound(moments: vec2f, mean: f32, minVariance: f32, lightBleedingReduction: f32) -> f32 {
	var variance: f32 = moments.y - (moments.x * moments.x);
	variance = max(variance, minVariance);
	let d: f32 = mean - moments.x;
	var pMax: f32 = variance / (variance + (d * d));
	pMax = reduceLightBleeding(pMax, lightBleedingReduction);
	return select(pMax, 1.0, mean <= moments.x);
}
fn calculateEVSM(moments_in: vec3f, Z_in: f32, vsmBias: f32, exponent: f32) -> f32 {
	let Z: f32 = 2.0 * Z_in - 1.0;
	let warpedDepth: f32 = exp(exponent * Z);
	let moments: vec2f = moments_in.xy + vec2f(warpedDepth, warpedDepth*warpedDepth) * (1.0 - moments_in.z);
	let VSMBias: f32 = vsmBias;
	let depthScale: f32 = VSMBias * exponent * warpedDepth;
	let minVariance1: f32 = depthScale * depthScale;
	return chebyshevUpperBound(moments, warpedDepth, minVariance1, 0.1);
}
fn VSM16(tex: texture_2d<f32>, texSampler: sampler, texCoords: vec2f, resolution: f32, Z: f32, vsmBias: f32, exponent: f32) -> f32 {
	let moments: vec3f = textureSampleLevel(tex, texSampler, texCoords, 0.0).xyz;
	return calculateEVSM(moments, Z, vsmBias, exponent);
}
fn getShadowVSM16(shadowMap: texture_2d<f32>, shadowMapSampler: sampler, shadowCoord: vec3f, shadowParams: vec4f, exponent: f32) -> f32 {
	return VSM16(shadowMap, shadowMapSampler, shadowCoord.xy, shadowParams.x, shadowCoord.z, shadowParams.y, exponent);
}
fn getShadowSpotVSM16(shadowMap: texture_2d<f32>, shadowMapSampler: sampler, shadowCoord: vec3f, shadowParams: vec4f, exponent: f32, lightDir: vec3f) -> f32 {
	let Z: f32 = length(lightDir) * shadowParams.w + shadowParams.z;
	return VSM16(shadowMap, shadowMapSampler, shadowCoord.xy, shadowParams.x, Z, shadowParams.y, exponent);
}
fn VSM32(tex: texture_2d<f32>, texSampler: sampler, texCoords_in: vec2f, resolution: f32, Z: f32, vsmBias: f32, exponent: f32) -> f32 {
	#ifdef CAPS_TEXTURE_FLOAT_FILTERABLE
		var moments: vec3f = textureSampleLevel(tex, texSampler, texCoords_in, 0.0).xyz;
	#else
		var pixelSize : f32 = 1.0 / resolution;
		let texCoords: vec2f = texCoords_in - vec2f(pixelSize);
		let s00: vec3f = textureSampleLevel(tex, texSampler, texCoords, 0.0).xyz;
		let s10: vec3f = textureSampleLevel(tex, texSampler, texCoords + vec2f(pixelSize, 0.0), 0.0).xyz;
		let s01: vec3f = textureSampleLevel(tex, texSampler, texCoords + vec2f(0.0, pixelSize), 0.0).xyz;
		let s11: vec3f = textureSampleLevel(tex, texSampler, texCoords + vec2f(pixelSize), 0.0).xyz;
		let fr: vec2f = fract(texCoords * resolution);
		let h0: vec3f = mix(s00, s10, fr.x);
		let h1: vec3f = mix(s01, s11, fr.x);
		var moments: vec3f = mix(h0, h1, fr.y);
	#endif
	return calculateEVSM(moments, Z, vsmBias, exponent);
}
fn getShadowVSM32(shadowMap: texture_2d<f32>, shadowMapSampler: sampler, shadowCoord: vec3f, shadowParams: vec4f, exponent: f32) -> f32 {
	return VSM32(shadowMap, shadowMapSampler, shadowCoord.xy, shadowParams.x, shadowCoord.z, shadowParams.y, exponent);
}
fn getShadowSpotVSM32(shadowMap: texture_2d<f32>, shadowMapSampler: sampler, shadowCoord: vec3f, shadowParams: vec4f, exponent: f32, lightDir: vec3f) -> f32 {
	let Z: f32 = length(lightDir) * shadowParams.w + shadowParams.z;
	return VSM32(shadowMap, shadowMapSampler, shadowCoord.xy, shadowParams.x, Z, shadowParams.y, exponent);
}
`;

var shadowPCF1_default2 = `
fn getShadowPCF1x1(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec4f) -> f32 {
	return textureSampleCompareLevel(shadowMap, shadowMapSampler, shadowCoord.xy, shadowCoord.z);
}
fn getShadowSpotPCF1x1(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec4f) -> f32 {
	return textureSampleCompareLevel(shadowMap, shadowMapSampler, shadowCoord.xy, shadowCoord.z);
}
`;

var shadowPCF3_default2 = `
fn _getShadowPCF3x3(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec3f) -> f32 {
	let z: f32 = shadowCoord.z;
	let uv: vec2f = shadowCoord.xy * shadowParams.x;
	let shadowMapSizeInv: f32 = 1.0 / shadowParams.x;
	let base_uv_temp: vec2f = floor(uv + 0.5);
	let s: f32 = (uv.x + 0.5 - base_uv_temp.x);
	let t: f32 = (uv.y + 0.5 - base_uv_temp.y);
	let base_uv: vec2f = (base_uv_temp - vec2f(0.5)) * shadowMapSizeInv;
	var sum: f32 = 0.0;
	let uw0: f32 = (3.0 - 2.0 * s);
	let uw1: f32 = (1.0 + 2.0 * s);
	let u0_offset: f32 = (2.0 - s) / uw0 - 1.0;
	let u1_offset: f32 = s / uw1 + 1.0;
	let vw0: f32 = (3.0 - 2.0 * t);
	let vw1: f32 = (1.0 + 2.0 * t);
	let v0_offset: f32 = (2.0 - t) / vw0 - 1.0;
	let v1_offset: f32 = t / vw1 + 1.0;
	let u0: f32 = u0_offset * shadowMapSizeInv + base_uv.x;
	let v0: f32 = v0_offset * shadowMapSizeInv + base_uv.y;
	let u1: f32 = u1_offset * shadowMapSizeInv + base_uv.x;
	let v1: f32 = v1_offset * shadowMapSizeInv + base_uv.y;
	sum = sum + uw0 * vw0 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u0, v0), z);
	sum = sum + uw1 * vw0 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u1, v0), z);
	sum = sum + uw0 * vw1 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u0, v1), z);
	sum = sum + uw1 * vw1 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u1, v1), z);
	sum = sum * (1.0 / 16.0);
	return sum;
}
fn getShadowPCF3x3(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec4f) -> f32 {
	return _getShadowPCF3x3(shadowMap, shadowMapSampler, shadowCoord, shadowParams.xyz);
}
fn getShadowSpotPCF3x3(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec4f) -> f32 {
	return _getShadowPCF3x3(shadowMap, shadowMapSampler, shadowCoord, shadowParams.xyz);
}
`;

var shadowPCF5_default2 = `
fn _getShadowPCF5x5(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec3f) -> f32 {
	let z: f32 = shadowCoord.z;
	let uv: vec2f = shadowCoord.xy * shadowParams.x;
	let shadowMapSizeInv: f32 = 1.0 / shadowParams.x;
	let base_uv_temp: vec2f = floor(uv + 0.5);
	let s: f32 = (uv.x + 0.5 - base_uv_temp.x);
	let t: f32 = (uv.y + 0.5 - base_uv_temp.y);
	let base_uv: vec2f = (base_uv_temp - vec2f(0.5)) * shadowMapSizeInv;
	let uw0: f32 = (4.0 - 3.0 * s);
	let uw1: f32 = 7.0;
	let uw2: f32 = (1.0 + 3.0 * s);
	let u0_offset: f32 = (3.0 - 2.0 * s) / uw0 - 2.0;
	let u1_offset: f32 = (3.0 + s) / uw1;
	let u2_offset: f32 = s / uw2 + 2.0;
	let vw0: f32 = (4.0 - 3.0 * t);
	let vw1: f32 = 7.0;
	let vw2: f32 = (1.0 + 3.0 * t);
	let v0_offset: f32 = (3.0 - 2.0 * t) / vw0 - 2.0;
	let v1_offset: f32 = (3.0 + t) / vw1;
	let v2_offset: f32 = t / vw2 + 2.0;
	var sum: f32 = 0.0;
	let u0: f32 = u0_offset * shadowMapSizeInv + base_uv.x;
	let v0: f32 = v0_offset * shadowMapSizeInv + base_uv.y;
	let u1: f32 = u1_offset * shadowMapSizeInv + base_uv.x;
	let v1: f32 = v1_offset * shadowMapSizeInv + base_uv.y;
	let u2: f32 = u2_offset * shadowMapSizeInv + base_uv.x;
	let v2: f32 = v2_offset * shadowMapSizeInv + base_uv.y;
	sum = sum + uw0 * vw0 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u0, v0), z);
	sum = sum + uw1 * vw0 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u1, v0), z);
	sum = sum + uw2 * vw0 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u2, v0), z);
	sum = sum + uw0 * vw1 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u0, v1), z);
	sum = sum + uw1 * vw1 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u1, v1), z);
	sum = sum + uw2 * vw1 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u2, v1), z);
	sum = sum + uw0 * vw2 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u0, v2), z);
	sum = sum + uw1 * vw2 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u1, v2), z);
	sum = sum + uw2 * vw2 * textureSampleCompareLevel(shadowMap, shadowMapSampler, vec2f(u2, v2), z);
	sum = sum * (1.0 / 144.0);
	sum = saturate(sum);
	return sum;
}
fn getShadowPCF5x5(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec4f) -> f32 {
	return _getShadowPCF5x5(shadowMap, shadowMapSampler, shadowCoord, shadowParams.xyz);
}
fn getShadowSpotPCF5x5(shadowMap: texture_depth_2d, shadowMapSampler: sampler_comparison, shadowCoord: vec3f, shadowParams: vec4f) -> f32 {
	return _getShadowPCF5x5(shadowMap, shadowMapSampler, shadowCoord, shadowParams.xyz);
}
`;

var shadowSoft_default2 = `
fn fractSinRand(uv: vec2f) -> f32 {
	let PI: f32 = 3.141592653589793;
	let a: f32 = 12.9898; let b: f32 = 78.233; let c: f32 = 43758.5453;
	let dt: f32 = dot(uv.xy, vec2f(a, b));
	let sn: f32 = dt % PI;
	return fract(sin(sn) * c);
}
struct VogelDiskData {
	invNumSamples: f32,
	initialAngle: f32,
	currentPointId: f32,
}
fn prepareDiskConstants(data: ptr<function, VogelDiskData>, sampleCount: i32, randomSeed: f32) {
	let pi2: f32 = 6.28318530718;
	data.invNumSamples = 1.0 / f32(sampleCount);
	data.initialAngle = randomSeed * pi2;
	data.currentPointId = 0.0;
}
fn generateDiskSample(data: ptr<function, VogelDiskData>) -> vec2f {
	let GOLDEN_ANGLE: f32 = 2.399963;
	let r: f32 = sqrt((data.currentPointId + 0.5) * data.invNumSamples);
	let theta: f32 = data.currentPointId * GOLDEN_ANGLE + data.initialAngle;
	let offset: vec2f = vec2f(cos(theta), sin(theta)) * pow(r, 1.33);
	data.currentPointId = data.currentPointId + 1.0;
	return offset;
}
fn PCSSFindBlocker(shadowMap: texture_2d<f32>, shadowMapSampler: sampler, avgBlockerDepth: ptr<function, f32>, numBlockers: ptr<function, i32>,
	shadowCoords: vec2f, z: f32, shadowBlockerSamples: i32, searchWidthUv: f32, randomSeed: f32) {
	var diskData: VogelDiskData;
	prepareDiskConstants(&diskData, shadowBlockerSamples, randomSeed);
	var blockerSum: f32 = 0.0;
	var numBlockers_local: i32 = 0;
	for( var i: i32 = 0; i < shadowBlockerSamples; i = i + 1 ) {
		let diskUV: vec2f = generateDiskSample(&diskData);
		let sampleUV: vec2f = shadowCoords + diskUV * searchWidthUv;
		let shadowMapDepth: f32 = textureSampleLevel(shadowMap, shadowMapSampler, sampleUV, 0.0).r;
		if ( shadowMapDepth < z ) {
			blockerSum = blockerSum + shadowMapDepth;
			numBlockers_local = numBlockers_local + 1;
		}
	}
	*avgBlockerDepth = blockerSum / f32(numBlockers_local);
	*numBlockers = numBlockers_local;
}
fn PCSSFilter(shadowMap: texture_2d<f32>, shadowMapSampler: sampler, uv: vec2f, receiverDepth: f32, shadowSamples: i32, filterRadius: f32, randomSeed: f32) -> f32 {
	var diskData: VogelDiskData;
	prepareDiskConstants(&diskData, shadowSamples, randomSeed);
	var sum: f32 = 0.0;
	for (var i: i32 = 0; i < shadowSamples; i = i + 1) {
		let offsetUV: vec2f = generateDiskSample(&diskData) * filterRadius;
		let depth: f32 = textureSampleLevel(shadowMap, shadowMapSampler, uv + offsetUV, 0.0).r;
		sum = sum + step(receiverDepth, depth);
	}
	return sum / f32(shadowSamples);
}
fn PCSSDirectional(shadowMap: texture_2d<f32>, shadowMapSampler: sampler, shadowCoords: vec3f, cameraParams: vec4f, softShadowParams: vec4f) -> f32 {
	let receiverDepth: f32 = shadowCoords.z;
	let receiverDepthClamped: f32 = min(receiverDepth, 0.9999);
	let randomSeed: f32 = fractSinRand(pcPosition.xy);
	let shadowSamples: i32 = i32(softShadowParams.x);
	let shadowBlockerSamples: i32 = i32(softShadowParams.y);
	let penumbraSize: f32 = softShadowParams.z;
	let penumbraFalloff: f32 = softShadowParams.w;
	let orthoRadius: f32 = cameraParams.x;
	let depthRange: f32 = cameraParams.y - cameraParams.z;
	let worldPerUv: f32 = 2.0 * orthoRadius;
	var filterRadius: f32;
	if (shadowBlockerSamples > 0) {
		let searchWidthUv: f32 = (penumbraSize * depthRange) / worldPerUv;
		var avgBlockerDepth: f32 = 0.0;
		var numBlockers: i32 = 0;
		PCSSFindBlocker(shadowMap, shadowMapSampler, &avgBlockerDepth, &numBlockers, shadowCoords.xy, receiverDepthClamped, shadowBlockerSamples, searchWidthUv, randomSeed);
		if (numBlockers < 1) {
			return 1.0;
		}
		let worldDist: f32 = max((receiverDepth - avgBlockerDepth) * depthRange, 0.0);
		let t: f32 = clamp(worldDist / depthRange, 0.0, 1.0);
		let shape: f32 = 1.0 - pow(1.0 - t, penumbraFalloff);
		let penumbraWorld: f32 = shape * penumbraSize * depthRange;
		filterRadius = penumbraWorld / worldPerUv;
	} else {
		filterRadius = penumbraSize / worldPerUv;
	}
	return PCSSFilter(shadowMap, shadowMapSampler, shadowCoords.xy, receiverDepthClamped, shadowSamples, filterRadius, randomSeed);
}
fn getShadowPCSS(shadowMap: texture_2d<f32>, shadowMapSampler: sampler, shadowCoord: vec3f, shadowParams: vec4f, cameraParams: vec4f, softShadowParams: vec4f, lightDir: vec3f) -> f32 {
	return PCSSDirectional(shadowMap, shadowMapSampler, shadowCoord, cameraParams, softShadowParams);
}
`;

var skinBatch_default2 = `
attribute vertex_boneIndices: f32;
var texture_poseMap: texture_2d<uff>;
fn getBoneMatrix(indexFloat: f32) -> mat4x4f {
	let width = i32(textureDimensions(texture_poseMap).x);
	let index: i32 = i32(indexFloat + 0.5) * 3;
	let iy: i32 = index / width;
	let ix: i32 = index % width;
	let v1: vec4f = textureLoad(texture_poseMap, vec2i(ix + 0, iy), 0);
	let v2: vec4f = textureLoad(texture_poseMap, vec2i(ix + 1, iy), 0);
	let v3: vec4f = textureLoad(texture_poseMap, vec2i(ix + 2, iy), 0);
	return mat4x4f(
		v1.x, v2.x, v3.x, 0,
		v1.y, v2.y, v3.y, 0,
		v1.z, v2.z, v3.z, 0,
		v1.w, v2.w, v3.w, 1.0
	);
}
`;

var skin_default2 = `
attribute vertex_boneWeights: vec4f;
attribute vertex_boneIndices: vec4f;
var texture_poseMap: texture_2d<uff>;
struct BoneMatrix {
	v1: vec4f,
	v2: vec4f,
	v3: vec4f,
}
fn getBoneMatrix(width: i32, index: i32) -> BoneMatrix {
	let v = index / width;
	let u = index % width;
	var result: BoneMatrix;
	result.v1 = textureLoad(texture_poseMap, vec2i(u + 0, v), 0);
	result.v2 = textureLoad(texture_poseMap, vec2i(u + 1, v), 0);
	result.v3 = textureLoad(texture_poseMap, vec2i(u + 2, v), 0);
	return result;
}
fn getSkinMatrix(indicesFloat: vec4f, weights: vec4f) -> mat4x4f {
	let width = i32(textureDimensions(texture_poseMap).x);
	var indices = vec4i(indicesFloat + 0.5) * 3;
	let boneA = getBoneMatrix(width, indices.x);
	let boneB = getBoneMatrix(width, indices.y);
	let boneC = getBoneMatrix(width, indices.z);
	let boneD = getBoneMatrix(width, indices.w);
	let v1 = boneA.v1 * weights.x + boneB.v1 * weights.y + boneC.v1 * weights.z + boneD.v1 * weights.w;
	let v2 = boneA.v2 * weights.x + boneB.v2 * weights.y + boneC.v2 * weights.z + boneD.v2 * weights.w;
	let v3 = boneA.v3 * weights.x + boneB.v3 * weights.y + boneC.v3 * weights.z + boneD.v3 * weights.w;
	let one = dot(weights, vec4f(1.0, 1.0, 1.0, 1.0));
	return mat4x4f(
		v1.x, v2.x, v3.x, 0,
		v1.y, v2.y, v3.y, 0,
		v1.z, v2.z, v3.z, 0,
		v1.w, v2.w, v3.w, one
	);
}
`;

var skybox_default3 = `
	#define LIT_SKYBOX_INTENSITY
	#include "envProcPS"
	#include "gammaPS"
	#include "tonemappingPS"
	#ifdef PREPASS_PASS
		varying vLinearDepth: f32;
		#include "floatAsUintPS"
	#endif
	varying vViewDir : vec3f;
	uniform skyboxHighlightMultiplier : f32;
	#if defined(SKY_FISHEYE) && !defined(SKYMESH)
		uniform fisheye_k : f32;
		uniform fisheye_invK : f32;
		uniform fisheye_projMat00 : f32;
		uniform fisheye_projMat11 : f32;
		uniform matrix_view : mat4x4f;
		uniform cubeMapRotationMatrix : mat3x3f;
		varying vClipXYW : vec3f;
	#endif
	#ifdef SKY_CUBEMAP
		var texture_cubeMap : texture_cube<f32>;
		var texture_cubeMap_sampler : sampler;
		#ifdef SKYMESH
			varying vWorldPos : vec3f;
			uniform cubeMapRotationMatrix : mat3x3f;
			uniform projectedSkydomeCenter : vec3f;
		#endif
	#else
		#include "sphericalPS"
		#include "envAtlasPS"
		var texture_envAtlas : texture_2d<f32>;
		var texture_envAtlas_sampler : sampler;
		uniform mipLevel : f32;
	#endif
	@fragment
	fn fragmentMain(input : FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		#ifdef PREPASS_PASS
			output.color = float2vec4(vLinearDepth);
		#else
			var linear : vec3f;
			var dir : vec3f;
			#if defined(SKY_FISHEYE) && !defined(SKYMESH)
				let ndc : vec2f = input.vClipXYW.xy / input.vClipXYW.z;
				let px : f32 = ndc.x / uniform.fisheye_projMat00;
				let py : f32 = ndc.y / uniform.fisheye_projMat11;
				let r : f32 = sqrt(px * px + py * py);
				let theta : f32 = uniform.fisheye_k * atan(r * uniform.fisheye_invK);
				let sinT : f32 = sin(theta);
				let cosT : f32 = cos(theta);
				var camDir : vec3f;
				if (r > 1e-6) {
					camDir = vec3f(px / r * sinT, py / r * sinT, -cosT);
				} else {
					camDir = vec3f(0.0, 0.0, -1.0);
				}
				let viewMat3 : mat3x3f = mat3x3f(
					uniform.matrix_view[0].xyz,
					uniform.matrix_view[1].xyz,
					uniform.matrix_view[2].xyz
				);
				dir = transpose(viewMat3) * camDir;
				dir = dir * uniform.cubeMapRotationMatrix;
			#elif defined(SKY_CUBEMAP) && defined(SKYMESH)
				var envDir : vec3f = normalize(input.vWorldPos - uniform.projectedSkydomeCenter);
				dir = envDir * uniform.cubeMapRotationMatrix;
			#else
				dir = input.vViewDir;
			#endif
			#ifdef SKY_CUBEMAP
				dir.x *= -1.0;
				linear = {SKYBOX_DECODE_FNC}(textureSample(texture_cubeMap, texture_cubeMap_sampler, dir));
			#else
				dir *= vec3f(-1.0, 1.0, 1.0);
				let uv : vec2f = toSphericalUv(normalize(dir));
				linear = {SKYBOX_DECODE_FNC}(textureSample(texture_envAtlas, texture_envAtlas_sampler, mapRoughnessUv(uv, uniform.mipLevel)));
			#endif
			if (any(linear >= vec3f(64.0))) {
				linear *= uniform.skyboxHighlightMultiplier;
			}
			
			output.color = vec4f(gammaCorrectOutput(toneMap(processEnvironment(linear))), 1.0);
		#endif
		return output;
	}
`;

var skybox_default4 = `
	attribute aPosition : vec4f;
	uniform matrix_view : mat4x4f;
	uniform matrix_projectionSkybox : mat4x4f;
	uniform cubeMapRotationMatrix : mat3x3f;
	varying vViewDir : vec3f;
	#ifdef SKY_FISHEYE
		varying vClipXYW : vec3f;
	#endif
	#ifdef PREPASS_PASS
		varying vLinearDepth: f32;
	#endif
	#ifdef SKYMESH
		uniform matrix_model : mat4x4f;
		varying vWorldPos : vec3f;
	#endif
	@vertex
	fn vertexMain(input : VertexInput) -> VertexOutput {
		var output : VertexOutput;
		var view : mat4x4f = uniform.matrix_view;
		#ifdef SKYMESH
			var worldPos : vec4f = uniform.matrix_model * input.aPosition;
			output.vWorldPos = worldPos.xyz;
			output.position = uniform.matrix_projectionSkybox * (view * worldPos);
			#ifdef PREPASS_PASS
				output.vLinearDepth = -(uniform.matrix_view * vec4f(worldPos.xyz, 1.0)).z;
			#endif
		#else
			view[3][0] = 0.0;
			view[3][1] = 0.0;
			view[3][2] = 0.0;
			output.vViewDir = input.aPosition.xyz * uniform.cubeMapRotationMatrix;
			#ifdef SKY_FISHEYE
				var viewPos : vec4f = view * input.aPosition;
				output.position = vec4f(viewPos.xy, 0.0, -viewPos.z);
				output.vClipXYW = vec3f(output.position.xy, output.position.w);
			#else
				output.position = uniform.matrix_projectionSkybox * (view * input.aPosition);
			#endif
			#ifdef PREPASS_PASS
				output.vLinearDepth = -pcPosition.w;
			#endif
		#endif
		output.position.z = output.position.w - 1.0e-7;
		return output;
	}
`;

var sort_indirect_args_default = `
fn writeSortIndirectArgs(
	baseSlot: u32,
	count: u32,
	slotInfo: vec4<u32>
) {
	let n = slotInfo.x;
	if (n >= 1u) {
		let g = slotInfo.y;
		let wc = (count + g - 1u) / g;
		let off = baseSlot * 3u;
		indirectDispatchArgs[off + 0u] = wc;
		indirectDispatchArgs[off + 1u] = 1u;
		indirectDispatchArgs[off + 2u] = 1u;
	}
	if (n >= 2u) {
		let g = slotInfo.z;
		let wc = (count + g - 1u) / g;
		let off = (baseSlot + 1u) * 3u;
		indirectDispatchArgs[off + 0u] = wc;
		indirectDispatchArgs[off + 1u] = 1u;
		indirectDispatchArgs[off + 2u] = 1u;
	}
	if (n >= 3u) {
		let g = slotInfo.w;
		let wc = (count + g - 1u) / g;
		let off = (baseSlot + 2u) * 3u;
		indirectDispatchArgs[off + 0u] = wc;
		indirectDispatchArgs[off + 1u] = 1u;
		indirectDispatchArgs[off + 2u] = 1u;
	}
}
`;

var specular_default2 = `
#ifdef STD_SPECULAR_CONSTANT
	uniform material_specular: vec3f;
#endif
fn getSpecularity() {
	var specularColor = vec3f(1.0, 1.0, 1.0);
	#ifdef STD_SPECULAR_CONSTANT
	specularColor = specularColor * uniform.material_specular;
	#endif
	#ifdef STD_SPECULAR_TEXTURE
	specularColor = specularColor * {STD_SPECULAR_TEXTURE_DECODE}(textureSampleBias({STD_SPECULAR_TEXTURE_NAME}, {STD_SPECULAR_TEXTURE_NAME}Sampler, {STD_SPECULAR_TEXTURE_UV}, uniform.textureBias)).{STD_SPECULAR_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_SPECULAR_VERTEX
	specularColor = specularColor * saturate3(vVertexColor.{STD_SPECULAR_VERTEX_CHANNEL});
	#endif
	dSpecularity = specularColor;
}
`;

var spherical_default2 = `
fn toSpherical(dir: vec3f) -> vec2f {
	let angle_xz = select(0.0, atan2(dir.x, dir.z), any(dir.xz != vec2f(0.0)));
	return vec2f(angle_xz, asin(dir.y));
}
fn toSphericalUv(dir : vec3f) -> vec2f {
	const PI : f32 = 3.141592653589793;
	let uv : vec2f = toSpherical(dir) / vec2f(PI * 2.0, PI) + vec2f(0.5, 0.5);
	return vec2f(uv.x, 1.0 - uv.y);
}
`;

var specularityFactor_default2 = `
#ifdef STD_SPECULARITYFACTOR_CONSTANT
	uniform material_specularityFactor: f32;
#endif
fn getSpecularityFactor() {
	var specularityFactor = 1.0;
	#ifdef STD_SPECULARITYFACTOR_CONSTANT
	specularityFactor = specularityFactor * uniform.material_specularityFactor;
	#endif
	#ifdef STD_SPECULARITYFACTOR_TEXTURE
	specularityFactor = specularityFactor * textureSampleBias({STD_SPECULARITYFACTOR_TEXTURE_NAME}, {STD_SPECULARITYFACTOR_TEXTURE_NAME}Sampler, {STD_SPECULARITYFACTOR_TEXTURE_UV}, uniform.textureBias).{STD_SPECULARITYFACTOR_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_SPECULARITYFACTOR_VERTEX
	specularityFactor = specularityFactor * saturate(vVertexColor.{STD_SPECULARITYFACTOR_VERTEX_CHANNEL});
	#endif
	dSpecularityFactor = specularityFactor;
}
`;

var spot_default2 = `
fn getSpotEffect(lightSpotDir: vec3f, lightInnerConeAngle: f32, lightOuterConeAngle: f32, lightDirNorm: vec3f) -> f32 {
	let cosAngle: f32 = dot(lightDirNorm, lightSpotDir);
	return smoothstep(lightOuterConeAngle, lightInnerConeAngle, cosAngle);
}`;

var startNineSliced_default2 = `
	nineSlicedUv = vec2f(vUv0.x, 1.0 - vUv0.y);
`;

var startNineSlicedTiled_default2 = `
	let tileMask: vec2f = step(vMask, vec2f(0.99999));
	let tileSize: vec2f = 0.5 * (uniform.innerOffset.xy + uniform.innerOffset.zw);
	let tileScale: vec2f = vec2f(1.0) / (vec2f(1.0) - tileSize);
	var clampedUv: vec2f = mix(uniform.innerOffset.xy * 0.5, vec2f(1.0) - uniform.innerOffset.zw * 0.5, fract((vTiledUv - tileSize) * tileScale));
	clampedUv = clampedUv * uniform.atlasRect.zw + uniform.atlasRect.xy;
	nineSlicedUv = vUv0 * tileMask + clampedUv * (vec2f(1.0) - tileMask);
	nineSlicedUv.y = 1.0 - nineSlicedUv.y;
`;

var stdDeclaration_default2 = `
	var<private> dAlpha: f32 = 1.0;
	#if LIT_BLEND_TYPE != NONE || defined(LIT_ALPHA_TEST) || defined(LIT_ALPHA_TO_COVERAGE) || STD_OPACITY_DITHER != NONE
		#ifdef STD_OPACITY_TEXTURE_ALLOCATE
			var texture_opacityMap : texture_2d<f32>;
			var texture_opacityMapSampler : sampler;
		#endif
	#endif
	#ifdef FORWARD_PASS
		var<private> dAlbedo: vec3f;
		var<private> dNormalW: vec3f;
		var<private> dSpecularity: vec3f = vec3f(0.0, 0.0, 0.0);
		var<private> dGlossiness: f32 = 0.0;
		#ifdef LIT_REFRACTION
			var<private> dTransmission: f32;
			var<private> dThickness: f32;
		#endif
		#ifdef LIT_SCENE_COLOR
			var uSceneColorMap : texture_2d<f32>;
			var uSceneColorMapSampler : sampler;
		#endif
		#ifdef LIT_SCREEN_SIZE
			uniform uScreenSize: vec4f;
		#endif
		#ifdef LIT_TRANSFORMS
			var<private> matrix_viewProjection: mat4x4f;
			var<private> matrix_model: mat4x4f;
		#endif
		#ifdef STD_HEIGHT_MAP
			var<private> dUvOffset: vec2f;
			#ifdef STD_HEIGHT_TEXTURE_ALLOCATE
				var texture_heightMap : texture_2d<f32>;
				var texture_heightMapSampler : sampler;
			#endif
		#endif
		#ifdef STD_DIFFUSE_TEXTURE_ALLOCATE
			var texture_diffuseMap : texture_2d<f32>;
			var texture_diffuseMapSampler : sampler;
		#endif
		#ifdef STD_DIFFUSEDETAIL_TEXTURE_ALLOCATE
			var texture_diffuseDetailMap : texture_2d<f32>;
			var texture_diffuseDetailMapSampler : sampler;
		#endif
		#ifdef STD_NORMAL_TEXTURE_ALLOCATE
			var texture_normalMap : texture_2d<f32>;
			var texture_normalMapSampler : sampler;
		#endif
		#ifdef STD_NORMALDETAIL_TEXTURE_ALLOCATE
			var texture_normalDetailMap : texture_2d<f32>;
			var texture_normalDetailMapSampler : sampler;
		#endif
		#ifdef STD_THICKNESS_TEXTURE_ALLOCATE
			var texture_thicknessMap : texture_2d<f32>;
			var texture_thicknessMapSampler : sampler;
		#endif
		#ifdef STD_REFRACTION_TEXTURE_ALLOCATE
			var texture_refractionMap : texture_2d<f32>;
			var texture_refractionMapSampler : sampler;
		#endif
		#ifdef LIT_IRIDESCENCE
			var<private> dIridescence: f32;
			var<private> dIridescenceThickness: f32;
			#ifdef STD_IRIDESCENCE_THICKNESS_TEXTURE_ALLOCATE
				var texture_iridescenceThicknessMap : texture_2d<f32>;
				var texture_iridescenceThicknessMapSampler : sampler;
			#endif
			#ifdef STD_IRIDESCENCE_TEXTURE_ALLOCATE
				var texture_iridescenceMap : texture_2d<f32>;
				var texture_iridescenceMapSampler : sampler;
			#endif
		#endif
		#ifdef LIT_CLEARCOAT
			var<private> ccSpecularity: f32;
			var<private> ccGlossiness: f32;
			var<private> ccNormalW: vec3f;
		#endif
		#ifdef LIT_GGX_SPECULAR
			var<private> dAnisotropy: f32;
			var<private> dAnisotropyRotation: vec2f;
		#endif
		#ifdef LIT_SPECULAR_OR_REFLECTION
			#ifdef LIT_SHEEN
				var<private> sSpecularity: vec3f;
				var<private> sGlossiness: f32;
				#ifdef STD_SHEEN_TEXTURE_ALLOCATE
					var texture_sheenMap : texture_2d<f32>;
					var texture_sheenMapSampler : sampler;
				#endif
				#ifdef STD_SHEENGLOSS_TEXTURE_ALLOCATE
					var texture_sheenGlossMap : texture_2d<f32>;
					var texture_sheenGlossMapSampler : sampler;
				#endif
			#endif
			#ifdef LIT_METALNESS
				var<private> dMetalness: f32;
				var<private> dIor: f32;
				#ifdef STD_METALNESS_TEXTURE_ALLOCATE
					var texture_metalnessMap : texture_2d<f32>;
					var texture_metalnessMapSampler : sampler;
				#endif
			#endif
			#ifdef LIT_SPECULARITY_FACTOR
				var<private> dSpecularityFactor: f32;
				#ifdef STD_SPECULARITYFACTOR_TEXTURE_ALLOCATE
					var texture_specularityFactorMap : texture_2d<f32>;
					var texture_specularityFactorMapSampler : sampler;
				#endif
			#endif
			#ifdef STD_SPECULAR_COLOR
				#ifdef STD_SPECULAR_TEXTURE_ALLOCATE
					var texture_specularMap : texture_2d<f32>;
					var texture_specularMapSampler : sampler;
				#endif
			#endif
			#ifdef STD_GLOSS_TEXTURE_ALLOCATE
				var texture_glossMap : texture_2d<f32>;
				var texture_glossMapSampler : sampler;
			#endif
		#endif
		#ifdef STD_AO
			var <private> dAo: f32;
			#ifdef STD_AO_TEXTURE_ALLOCATE
				var texture_aoMap : texture_2d<f32>;
				var texture_aoMapSampler : sampler;
			#endif
			#ifdef STD_AODETAIL_TEXTURE_ALLOCATE
				var texture_aoDetailMap : texture_2d<f32>;
				var texture_aoDetailMapSampler : sampler;
			#endif
		#endif
		var <private> dEmission: vec3f;
		#ifdef STD_EMISSIVE_TEXTURE_ALLOCATE
			var texture_emissiveMap : texture_2d<f32>;
			var texture_emissiveMapSampler : sampler;
		#endif
		#ifdef LIT_CLEARCOAT
			#ifdef STD_CLEARCOAT_TEXTURE_ALLOCATE
				var texture_clearCoatMap : texture_2d<f32>;
				var texture_clearCoatMapSampler : sampler;
			#endif
			#ifdef STD_CLEARCOATGLOSS_TEXTURE_ALLOCATE
				var texture_clearCoatGlossMap : texture_2d<f32>;
				var texture_clearCoatGlossMapSampler : sampler;
			#endif
			#ifdef STD_CLEARCOATNORMAL_TEXTURE_ALLOCATE
				var texture_clearCoatNormalMap : texture_2d<f32>;
				var texture_clearCoatNormalMapSampler : sampler;
			#endif
		#endif
		#ifdef LIT_GGX_SPECULAR
			#ifdef STD_ANISOTROPY_TEXTURE_ALLOCATE
				var texture_anisotropyMap : texture_2d<f32>;
				var texture_anisotropyMapSampler : sampler;
			#endif
		#endif
		#if defined(STD_LIGHTMAP) || defined(STD_LIGHT_VERTEX_COLOR)
			var<private> dLightmap: vec3f;
			#ifdef STD_LIGHT_TEXTURE_ALLOCATE
				var texture_lightMap : texture_2d<f32>;
				var texture_lightMapSampler : sampler;
			#endif
		#endif
	#endif
	#include "litShaderCorePS"
`;

var stdFrontEnd_default2 = `
	#if LIT_BLEND_TYPE != NONE || defined(LIT_ALPHA_TEST) || defined(LIT_ALPHA_TO_COVERAGE) || STD_OPACITY_DITHER != NONE
		#include "opacityPS"
		#if defined(LIT_ALPHA_TEST)
			#include "alphaTestPS"
		#endif
		#if STD_OPACITY_DITHER != NONE
			#include "opacityDitherPS"
		#endif
	#endif
	#ifdef FORWARD_PASS
		#ifdef STD_HEIGHT_MAP
			#include "parallaxPS"
		#endif
		#include  "diffusePS"
		#ifdef LIT_NEEDS_NORMAL
			#include "normalMapPS"
		#endif
		#ifdef LIT_REFRACTION
			#include "transmissionPS"
			#include "thicknessPS"
		#endif
		#ifdef LIT_IRIDESCENCE
			#include "iridescencePS"
			#include "iridescenceThicknessPS"
		#endif
		#ifdef LIT_SPECULAR_OR_REFLECTION
			#ifdef LIT_SHEEN
				#include "sheenPS"
				#include "sheenGlossPS"
			#endif
			#ifdef LIT_METALNESS
				#include "metalnessPS"
				#include "iorPS"
			#endif
			#ifdef LIT_SPECULARITY_FACTOR
				#include "specularityFactorPS"
			#endif
			#ifdef STD_SPECULAR_COLOR
				#include "specularPS"
			#else
				fn getSpecularity() { 
					dSpecularity = vec3f(1.0, 1.0, 1.0);
				}
			#endif
			#include "glossPS"
		#endif
		#ifdef STD_AO
			#include "aoPS"
		#endif
		#include "emissivePS"
		#ifdef LIT_CLEARCOAT
			#include "clearCoatPS"
			#include "clearCoatGlossPS"
			#include "clearCoatNormalPS"
		#endif
		#if defined(LIT_SPECULAR) && defined(LIT_LIGHTING) && defined(LIT_GGX_SPECULAR)
			#include "anisotropyPS"
		#endif
		#if defined(STD_LIGHTMAP) || defined(STD_LIGHT_VERTEX_COLOR)
			#include "lightmapPS"
		#endif
	#endif
	fn evaluateFrontend() {
		#if LIT_BLEND_TYPE != NONE || defined(LIT_ALPHA_TEST) || defined(LIT_ALPHA_TO_COVERAGE) || STD_OPACITY_DITHER != NONE
			getOpacity();
			#if defined(LIT_ALPHA_TEST)
				alphaTest(dAlpha);
			#endif
			#if STD_OPACITY_DITHER != NONE
				opacityDither(dAlpha * uniform.material_alphaDitherScale, 0.0);
			#endif
			litArgs_opacity = dAlpha;
		#endif
		#ifdef FORWARD_PASS
			#ifdef STD_HEIGHT_MAP
				getParallax();
			#endif
			getAlbedo();
			litArgs_albedo = dAlbedo;
			#ifdef LIT_NEEDS_NORMAL
				getNormal();
				litArgs_worldNormal = dNormalW;
			#endif
			#ifdef LIT_REFRACTION
				getRefraction();
				litArgs_transmission = dTransmission;
				getThickness();
				litArgs_thickness = dThickness;
				#ifdef LIT_DISPERSION
					litArgs_dispersion = uniform.material_dispersion;
				#endif
			#endif
			#ifdef LIT_IRIDESCENCE
				getIridescence();
				getIridescenceThickness();
				litArgs_iridescence_intensity = dIridescence;
				litArgs_iridescence_thickness = dIridescenceThickness;
			#endif
			#ifdef LIT_SPECULAR_OR_REFLECTION
				#ifdef LIT_SHEEN
					getSheen();
					litArgs_sheen_specularity = sSpecularity;
					getSheenGlossiness();
					litArgs_sheen_gloss = sGlossiness;
				#endif
				#ifdef LIT_METALNESS
					getMetalness();
					litArgs_metalness = dMetalness;
					getIor();
					litArgs_ior = dIor;
				#endif
				#ifdef LIT_SPECULARITY_FACTOR
					getSpecularityFactor();
					litArgs_specularityFactor = dSpecularityFactor;
				#endif
				getGlossiness();
				getSpecularity();
				litArgs_specularity = dSpecularity;
				litArgs_gloss = dGlossiness;
			#endif
			#ifdef STD_AO
				getAO();
				litArgs_ao = dAo;
			#endif
			getEmission();
			litArgs_emission = dEmission;
			#ifdef LIT_CLEARCOAT
				getClearCoat();
				getClearCoatGlossiness();
				getClearCoatNormal();
				litArgs_clearcoat_specularity = ccSpecularity;
				litArgs_clearcoat_gloss = ccGlossiness;
				litArgs_clearcoat_worldNormal = ccNormalW;
			#endif
			#if defined(LIT_SPECULAR) && defined(LIT_LIGHTING) && defined(LIT_GGX_SPECULAR)
				getAnisotropy();
			#endif
			#if defined(STD_LIGHTMAP) || defined(STD_LIGHT_VERTEX_COLOR)
				getLightMap();
				litArgs_lightmap = dLightmap;
				#ifdef STD_LIGHTMAP_DIR
					litArgs_lightmapDir = dLightmapDir;
				#endif
			#endif
		#endif
	}
`;

var TBN_default2 = `
#ifdef LIT_TANGENTS
	#define TBN_TANGENTS
#else
	#if defined(LIT_USE_NORMALS) || defined(LIT_USE_CLEARCOAT_NORMALS)
		#define TBN_DERIVATIVES
	#endif
#endif
#if defined(TBN_DERIVATIVES)
	uniform tbnBasis: f32;
#endif
fn getTBN(tangent: vec3f, binormal: vec3f, normal: vec3f) {
	#ifdef TBN_TANGENTS
		dTBN = mat3x3f(normalize(tangent), normalize(binormal), normalize(normal));
	#elif defined(TBN_DERIVATIVES)
		let uv: vec2f = {lightingUv};
		let dp1: vec3f = dpdx( vPositionW );
		let dp2: vec3f = dpdy( vPositionW );
		let duv1: vec2f = dpdx( uv );
		let duv2: vec2f = dpdy( uv );
		let dp2perp: vec3f = cross( dp2, normal );
		let dp1perp: vec3f = cross( normal, dp1 );
		let T: vec3f = dp2perp * duv1.x + dp1perp * duv2.x;
		let B: vec3f = dp2perp * duv1.y + dp1perp * duv2.y;
		let denom: f32 = max( dot(T, T), dot(B, B) );
		let invmax: f32 = select(uniform.tbnBasis / sqrt( denom ), 0.0, denom == 0.0);
		dTBN = mat3x3f(T * invmax, -B * invmax, normal );
	#else
		var B: vec3f = cross(normal, vObjectSpaceUpW);
		var T: vec3f = cross(normal, B);
		if (dot(B,B) == 0.0)
		{
			let major: f32 = max(max(normal.x, normal.y), normal.z);
			if (normal.x == major)
			{
				B = cross(normal, vec3f(0.0, 1.0, 0.0));
				T = cross(normal, B);
			}
			else if (normal.y == major)
			{
				B = cross(normal, vec3f(0.0, 0.0, 1.0));
				T = cross(normal, B);
			}
			else
			{
				B = cross(normal, vec3f(1.0, 0.0, 0.0));
				T = cross(normal, B);
			}
		}
		dTBN = mat3x3f(normalize(T), normalize(B), normalize(normal));
	#endif
}`;

var thickness_default2 = `
#ifdef STD_THICKNESS_CONSTANT
uniform material_thickness: f32;
#endif
fn getThickness() {
	dThickness = 1.0;
	#ifdef STD_THICKNESS_CONSTANT
	dThickness = dThickness * uniform.material_thickness;
	#endif
	#ifdef STD_THICKNESS_TEXTURE
	dThickness = dThickness * textureSampleBias({STD_THICKNESS_TEXTURE_NAME}, {STD_THICKNESS_TEXTURE_NAME}Sampler, {STD_THICKNESS_TEXTURE_UV}, uniform.textureBias).{STD_THICKNESS_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_THICKNESS_VERTEX
	dThickness = dThickness * saturate(vVertexColor.{STD_THICKNESS_VERTEX_CHANNEL});
	#endif
}
`;

var tonemapping_default2 = `
#ifndef TONEMAP_NO_EXPOSURE_UNIFORM
	#if TONEMAP != NONE
		uniform exposure: f32;
		fn getExposure() -> f32 { return uniform.exposure; }
	#else
		fn getExposure() -> f32 { return 1.0; }
	#endif
#else
	#if TONEMAP != NONE
		fn getExposure() -> f32 { return uniforms.exposure; }
	#else
		fn getExposure() -> f32 { return 1.0; }
	#endif
#endif
#if (TONEMAP == NONE)
	#include "tonemappingNonePS"
#elif TONEMAP == FILMIC
	#include "tonemappingFilmicPS"
#elif TONEMAP == LINEAR
	#include "tonemappingLinearPS"
#elif TONEMAP == HEJL
	#include "tonemappingHejlPS"
#elif TONEMAP == ACES
	#include "tonemappingAcesPS"
#elif TONEMAP == ACES2
	#include "tonemappingAces2PS"
#elif TONEMAP == NEUTRAL
	#include "tonemappingNeutralPS"
#endif
`;

var tonemappingAces_default2 = `
fn toneMap(color: vec3f) -> vec3f {
	let tA: f32 = 2.51;
	let tB: f32 = 0.03;
	let tC: f32 = 2.43;
	let tD: f32 = 0.59;
	let tE: f32 = 0.14;
	let x: vec3f = color * getExposure();
	return (x * (tA * x + tB)) / (x * (tC * x + tD) + tE);
}
`;

var tonemappingAces2_default2 = `
const ACESInputMat: mat3x3f = mat3x3f(
	vec3f(0.59719, 0.35458, 0.04823),
	vec3f(0.07600, 0.90834, 0.01566),
	vec3f(0.02840, 0.13383, 0.83777)
);
const ACESOutputMat: mat3x3f = mat3x3f(
	vec3f( 1.60475, -0.53108, -0.07367),
	vec3f(-0.10208,  1.10813, -0.00605),
	vec3f(-0.00327, -0.07276,  1.07602)
);
fn RRTAndODTFit(v: vec3f) -> vec3f {
	let a: vec3f = v * (v + vec3f(0.0245786)) - vec3f(0.000090537);
	let b: vec3f = v * (vec3f(0.983729) * v + vec3f(0.4329510)) + vec3f(0.238081);
	return a / b;
}
fn toneMap(color: vec3f) -> vec3f {
	var c: vec3f = color * (getExposure() / 0.6);
	c = c * ACESInputMat;
	c = RRTAndODTFit(c);
	c = c * ACESOutputMat;
	return clamp(c, vec3f(0.0), vec3f(1.0));
}
`;

var tonemappingFilmic_default2 = `
const A: f32 = 0.15;
const B: f32 = 0.50;
const C: f32 = 0.10;
const D: f32 = 0.20;
const E: f32 = 0.02;
const F: f32 = 0.30;
const W: f32 = 11.2;
fn uncharted2Tonemap(x: vec3f) -> vec3f {
	return ((x * (A * x + C * B) + D * E) / (x * (A * x + B) + D * F)) - vec3f(E / F);
}
fn toneMap(color: vec3f) -> vec3f {
	var c: vec3f = uncharted2Tonemap(color * getExposure());
	let whiteScale: vec3f = vec3f(1.0) / uncharted2Tonemap(vec3f(W, W, W));
	c *= whiteScale;
	return c;
}
`;

var tonemappingHejl_default2 = `
fn toneMap(color: vec3f) -> vec3f {
	let A: f32 = 0.22;
	let B: f32 = 0.3;
	let C: f32 = 0.1;
	let D: f32 = 0.2;
	let E: f32 = 0.01;
	let F: f32 = 0.3;
	let Scl: f32 = 1.25;
	let adjusted_color = color * getExposure();
	let h = max(vec3f(0.0), adjusted_color - vec3f(0.004));
	return (h * ((Scl * A) * h + Scl * vec3f(C * B)) + Scl * vec3f(D * E)) /
		   (h * (A * h + vec3f(B)) + vec3f(D * F)) -
		   Scl * vec3f(E / F);
}
`;

var tonemappingLinear_default2 = `
fn toneMap(color: vec3f) -> vec3f {
	return color * getExposure();
}
`;

var tonemappingNeutral_default2 = `
fn toneMap(col: vec3f) -> vec3f {
	var color = col * getExposure();
	let startCompression = 0.8 - 0.04;
	let desaturation = 0.15;
	let x = min(color.r, min(color.g, color.b));
	let offset = select(0.04, x - 6.25 * x * x, x < 0.08);
	color -= vec3f(offset);
	let peak = max(color.r, max(color.g, color.b));
	if (peak < startCompression) {
		return color;
	}
	let d = 1.0 - startCompression;
	let newPeak = 1.0 - d * d / (peak + d - startCompression);
	color *= newPeak / peak;
	let g = 1.0 - 1.0 / (desaturation * (peak - newPeak) + 1.0);
	return mix(color, vec3f(newPeak), vec3f(g));
}
`;

var tonemappingNone_default2 = `
fn toneMap(color: vec3f) -> vec3f {
	return color;
}
`;

var transform_default2 = `
#ifdef PIXELSNAP
	uniform uScreenSize: vec4f;
#endif
#ifdef SCREENSPACE
	uniform projectionFlipY: f32;
#endif
fn evalWorldPosition(vertexPosition: vec3f, modelMatrix: mat4x4f) -> vec4f {
	var localPos: vec3f = getLocalPosition(vertexPosition);
	#ifdef NINESLICED
		var localPosXZ: vec2f = localPos.xz;
		localPosXZ = localPosXZ * uniform.outerScale;
		let positiveUnitOffset: vec2f = clamp(vertexPosition.xz, vec2f(0.0), vec2f(1.0));
		let negativeUnitOffset: vec2f = clamp(-vertexPosition.xz, vec2f(0.0), vec2f(1.0));
		localPosXZ = localPosXZ + (-positiveUnitOffset * uniform.innerOffset.xy + negativeUnitOffset * uniform.innerOffset.zw) * vertex_texCoord0.xy;
		dTiledUvGlobal = (localPosXZ - uniform.outerScale + uniform.innerOffset.xy) * -0.5 + 1.0;
		localPosXZ = localPosXZ * -0.5;
		localPos = vec3f(localPosXZ.x, localPosXZ.y, localPos.y);
	#endif
	var posW: vec4f = modelMatrix * vec4f(localPos, 1.0);
	#ifdef SCREENSPACE
		posW = vec4f(posW.xy, 0.0, 1.0);
	#endif
	return posW;
}
fn getPosition() -> vec4f {
	dModelMatrix = getModelMatrix();
	let posW: vec4f = evalWorldPosition(vertex_position.xyz, dModelMatrix);
	dPositionW = posW.xyz;
	var screenPos: vec4f;
	#ifdef UV1LAYOUT
		screenPos = vec4f(vertex_texCoord1.xy * 2.0 - 1.0, 0.5, 1.0);
		screenPos.y *= -1.0;
	#else
		#ifdef SCREENSPACE
			screenPos = posW;
			screenPos.y *= uniform.projectionFlipY;
		#else
			screenPos = uniform.matrix_viewProjection * posW;
		#endif
		#ifdef PIXELSNAP
			screenPos.xy = (screenPos.xy * 0.5) + 0.5;
			screenPos.xy *= uniforms.uScreenSize.xy;
			screenPos.xy = floor(screenPos.xy);
			screenPos.xy *= uniforms.uScreenSize.zw;
			screenPos.xy = (screenPos.xy * 2.0) - 1.0;
		#endif
	#endif
	return screenPos;
}
fn getWorldPosition() -> vec3f {
	return dPositionW;
}
`;

var transformCore_default2 = `
	attribute vertex_position: vec4f;
	uniform matrix_viewProjection: mat4x4f;
	uniform matrix_model: mat4x4f;
	
	#ifdef MORPHING
		uniform morph_tex_params: vec2f;
		attribute morph_vertex_id: u32;
		fn getTextureMorphCoords() -> vec2i {
			var textureSize: vec2i = vec2i(uniform.morph_tex_params);
			var morphGridV: i32 = i32(morph_vertex_id) / textureSize.x;
			var morphGridU: i32 = i32(morph_vertex_id) - (morphGridV * textureSize.x);
			morphGridV = textureSize.y - morphGridV - 1;
			return vec2i(morphGridU, morphGridV);
		}
		#ifdef MORPHING_POSITION
			#ifdef MORPHING_INT
				uniform aabbSize: vec3f;
				uniform aabbMin: vec3f;
				var morphPositionTex: texture_2d<u32>;
			#else
				var morphPositionTex: texture_2d<f32>;
			#endif
		#endif
	#endif
	#ifdef defined(BATCH)
		#include "skinBatchVS"
		fn getModelMatrix() -> mat4x4f {
			return getBoneMatrix(vertex_boneIndices);
		}
	#elif defined(SKIN)
		#include "skinVS"
		fn getModelMatrix() -> mat4x4f {
			return uniform.matrix_model * getSkinMatrix(vertex_boneIndices, vertex_boneWeights);
		}
	#elif defined(INSTANCING)
		#include "transformInstancingVS"
	#else
		fn getModelMatrix() -> mat4x4f {
			return uniform.matrix_model;
		}
	#endif
	fn getLocalPosition(vertexPosition: vec3f) -> vec3f {
		var localPos: vec3f = vertexPosition;
		#ifdef MORPHING_POSITION
			var morphUV: vec2i = getTextureMorphCoords();
			#ifdef MORPHING_INT
				var morphPos: vec3f = vec3f(textureLoad(morphPositionTex, morphUV, 0).xyz) / 65535.0 * uniform.aabbSize + uniform.aabbMin;
			#else
				var morphPos: vec3f = textureLoad(morphPositionTex, morphUV, 0).xyz;
			#endif
			localPos += morphPos;
		#endif
		return localPos;
	}
`;

var transformInstancing_default2 = `
attribute instance_line1: vec4f;
attribute instance_line2: vec4f;
attribute instance_line3: vec4f;
attribute instance_line4: vec4f;
fn getModelMatrix() -> mat4x4f {
	return uniform.matrix_model * mat4x4f(instance_line1, instance_line2, instance_line3, instance_line4);
}
`;

var transmission_default2 = `
#ifdef STD_REFRACTION_CONSTANT
	uniform material_refraction: f32;
#endif
fn getRefraction() {
	var refraction: f32 = 1.0;
	#ifdef STD_REFRACTION_CONSTANT
	refraction = uniform.material_refraction;
	#endif
	#ifdef STD_REFRACTION_TEXTURE
	refraction = refraction * textureSampleBias({STD_REFRACTION_TEXTURE_NAME}, {STD_REFRACTION_TEXTURE_NAME}Sampler, {STD_REFRACTION_TEXTURE_UV}, uniform.textureBias).{STD_REFRACTION_TEXTURE_CHANNEL};
	#endif
	#ifdef STD_REFRACTION_VERTEX
	refraction = refraction * saturate(vVertexColor.{STD_REFRACTION_VERTEX_CHANNEL});
	#endif
	dTransmission = refraction;
}
`;

var twoSidedLighting_default2 = `
fn handleTwoSidedLighting() {
	if (!pcFrontFacing) { dTBN[2] = -dTBN[2]; }
}
`;

var uv0_default2 = `
#ifdef NINESLICED
	fn getUv0() -> vec2f {
		var uv = vertex_position.xz;
		let positiveUnitOffset = clamp(vertex_position.xz, vec2f(0.0, 0.0), vec2f(1.0, 1.0));
		let negativeUnitOffset = clamp(-vertex_position.xz, vec2f(0.0, 0.0), vec2f(1.0, 1.0));
		uv = uv + ((-positiveUnitOffset * uniform.innerOffset.xy) + (negativeUnitOffset * uniform.innerOffset.zw)) * vertex_texCoord0.xy;
		uv = uv * -0.5 + vec2f(0.5, 0.5);
		uv = uv * uniform.atlasRect.zw + uniform.atlasRect.xy;
		dMaskGlobal = vertex_texCoord0.xy;
		return uv;
	}
#else
	fn getUv0() -> vec2f {
		return vertex_texCoord0;
	}
#endif
`;

var uv1_default2 = `
fn getUv1() -> vec2f {
	return vertex_texCoord1;
}
`;

var uvTransform_default2 = `
output.vUV{TRANSFORM_UV_{i}}_{TRANSFORM_ID_{i}} = vec2f(
	dot(vec3f(uv{TRANSFORM_UV_{i}}, 1), uniform.{TRANSFORM_NAME_{i}}0),
	dot(vec3f(uv{TRANSFORM_UV_{i}}, 1), uniform.{TRANSFORM_NAME_{i}}1)
);
`;

var uvTransformUniforms_default2 = `
	uniform {TRANSFORM_NAME_{i}}0: vec3f;
	uniform {TRANSFORM_NAME_{i}}1: vec3f;
`;

var viewDir_default2 = `
fn getViewDir() {
	dViewDirW = normalize(uniform.view_position - vPositionW);
}
`;

var shaderChunksWGSL = {
	alphaTestPS: alphaTest_default2,
	ambientPS: ambient_default2,
	anisotropyPS: anisotropy_default2,
	aoPS: ao_default2,
	aoDiffuseOccPS: aoDiffuseOcc_default2,
	aoSpecOccPS: aoSpecOcc_default2,
	bakeDirLmEndPS: bakeDirLmEnd_default2,
	bakeLmEndPS: bakeLmEnd_default2,
	basePS: base_default2,
	baseNineSlicedPS: baseNineSliced_default2,
	baseNineSlicedTiledPS: baseNineSlicedTiled_default2,
	bayerPS: bayer_default2,
	blurVSMPS: blurVSM_default2,
	clearCoatPS: clearCoat_default2,
	clearCoatGlossPS: clearCoatGloss_default2,
	clearCoatNormalPS: clearCoatNormal_default2,
	clusteredLightCookiesPS: clusteredLightCookies_default2,
	clusteredLightShadowsPS: clusteredLightShadows_default2,
	clusteredLightUtilsPS: clusteredLightUtils_default2,
	clusteredLightPS: clusteredLight_default2,
	combinePS: combine_default2,
	cookieBlit2DPS: cookie_blit_2d_default2,
	cookieBlitCubePS: cookie_blit_cube_default2,
	cookieBlitVS: cookie_blit_default2,
	// cookiePS,
	cubeMapProjectPS: cubeMapProject_default2,
	cubeMapRotatePS: cubeMapRotate_default2,
	debugOutputPS: debug_output_default2,
	debugProcessFrontendPS: debug_process_frontend_default2,
	detailModesPS: detailModes_default2,
	diffusePS: diffuse_default2,
	decodePS: decode_default2,
	emissivePS: emissive_default2,
	encodePS: encode_default2,
	endPS: end_default2,
	envAtlasPS: envAtlas_default2,
	envProcPS: envProc_default2,
	falloffInvSquaredPS: falloffInvSquared_default2,
	falloffLinearPS: falloffLinear_default2,
	floatAsUintPS: float_as_uint_default2,
	fogPS: fog_default2,
	fogMathPS: fogMath_default,
	fresnelSchlickPS: fresnelSchlick_default2,
	frontendCodePS: "",
	// empty chunk, supplied by the shader generator
	frontendDeclPS: "",
	// empty chunk, supplied by the shader generator
	fullscreenQuadVS: fullscreenQuad_default2,
	gammaPS: gamma_default2,
	glossPS: gloss_default2,
	quadVS: quad_default2,
	indirectCoreCS: indirect_core_default,
	immediateLinePS: immediateLine_default3,
	immediateLineVS: immediateLine_default4,
	iridescenceDiffractionPS: iridescenceDiffraction_default2,
	iridescencePS: iridescence_default2,
	iridescenceThicknessPS: iridescenceThickness_default2,
	iorPS: ior_default2,
	lightDeclarationPS: lightDeclaration_default2,
	lightDiffuseLambertPS: lightDiffuseLambert_default2,
	lightDirPointPS: lightDirPoint_default2,
	lightEvaluationPS: lightEvaluation_default2,
	lightFunctionLightPS: lightFunctionLight_default2,
	lightFunctionShadowPS: lightFunctionShadow_default2,
	lightingPS: lighting_default2,
	lightmapAddPS: lightmapAdd_default2,
	lightmapPS: lightmap_default2,
	lightSpecularAnisoGGXPS: lightSpecularAnisoGGX_default2,
	lightSpecularGGXPS: lightSpecularGGX_default2,
	lightSpecularBlinnPS: lightSpecularBlinn_default2,
	lightSheenPS: lightSheen_default2,
	linearizeDepthPS: linearizeDepth_default2,
	litForwardBackendPS: litForwardBackend_default2,
	litForwardDeclarationPS: litForwardDeclaration_default2,
	litForwardMainPS: litForwardMain_default2,
	litForwardPostCodePS: litForwardPostCode_default2,
	litForwardPreCodePS: litForwardPreCode_default2,
	litMainPS: litMain_default3,
	litMainVS: litMain_default4,
	litOtherMainPS: litOtherMain_default2,
	litShaderArgsPS: litShaderArgs_default2,
	litShaderCorePS: litShaderCore_default2,
	litShadowMainPS: litShadowMain_default2,
	litUserDeclarationPS: "",
	// empty chunk allowing user to add custom code
	litUserDeclarationVS: "",
	// empty chunk allowing user to add custom code
	litUserCodePS: "",
	// empty chunk allowing user to add custom code
	litUserCodeVS: "",
	// empty chunk allowing user to add custom code
	litUserMainStartPS: "",
	// empty chunk allowing user to add custom code
	litUserMainStartVS: "",
	// empty chunk allowing user to add custom code
	litUserMainEndPS: "",
	// empty chunk allowing user to add custom code
	litUserMainEndVS: "",
	// empty chunk allowing user to add custom code
	ltcPS: ltc_default2,
	metalnessPS: metalness_default2,
	metalnessModulatePS: metalnessModulate_default2,
	morphPS: morph_default3,
	morphVS: morph_default4,
	msdfPS: msdf_default3,
	msdfVS: msdf_default4,
	normalVS: normal_default2,
	normalCoreVS: normalCore_default2,
	normalMapPS: normalMap_default2,
	opacityPS: opacity_default2,
	opacityDitherPS: opacity_dither_default2,
	outlineDeclarationPS: outline_declaration_default2,
	outlineOutputPS: outline_output_default2,
	outputPS: output_default2,
	outputAlphaPS: outputAlpha_default2,
	outputTex2DPS: outputTex2D_default2,
	sheenPS: sheen_default2,
	sheenGlossPS: sheenGloss_default2,
	parallaxPS: parallax_default2,
	pickPS: pick_default2,
	reflDirPS: reflDir_default2,
	reflDirAnisoPS: reflDirAniso_default2,
	reflectionCCPS: reflectionCC_default2,
	reflectionCubePS: reflectionCube_default2,
	reflectionEnvHQPS: reflectionEnvHQ_default2,
	reflectionEnvPS: reflectionEnv_default2,
	reflectionSpherePS: reflectionSphere_default2,
	reflectionSheenPS: reflectionSheen_default2,
	refractionCubePS: refractionCube_default2,
	refractionDynamicPS: refractionDynamic_default2,
	reprojectPS: reproject_default3,
	reprojectVS: reproject_default4,
	screenDepthPS: screenDepth_default2,
	shadowCascadesPS: shadowCascades_default2,
	shadowEVSMPS: shadowEVSM_default2,
	shadowPCF1PS: shadowPCF1_default2,
	shadowPCF3PS: shadowPCF3_default2,
	shadowPCF5PS: shadowPCF5_default2,
	// shadowPCSSPS,
	shadowSoftPS: shadowSoft_default2,
	skinBatchVS: skinBatch_default2,
	skinVS: skin_default2,
	skyboxPS: skybox_default3,
	skyboxVS: skybox_default4,
	sortIndirectArgsCS: sort_indirect_args_default,
	specularPS: specular_default2,
	sphericalPS: spherical_default2,
	specularityFactorPS: specularityFactor_default2,
	spotPS: spot_default2,
	startNineSlicedPS: startNineSliced_default2,
	startNineSlicedTiledPS: startNineSlicedTiled_default2,
	stdDeclarationPS: stdDeclaration_default2,
	stdFrontEndPS: stdFrontEnd_default2,
	TBNPS: TBN_default2,
	thicknessPS: thickness_default2,
	tonemappingPS: tonemapping_default2,
	tonemappingAcesPS: tonemappingAces_default2,
	tonemappingAces2PS: tonemappingAces2_default2,
	tonemappingFilmicPS: tonemappingFilmic_default2,
	tonemappingHejlPS: tonemappingHejl_default2,
	tonemappingLinearPS: tonemappingLinear_default2,
	tonemappingNeutralPS: tonemappingNeutral_default2,
	tonemappingNonePS: tonemappingNone_default2,
	transformVS: transform_default2,
	transformCoreVS: transformCore_default2,
	transformInstancingVS: transformInstancing_default2,
	transmissionPS: transmission_default2,
	twoSidedLightingPS: twoSidedLighting_default2,
	uv0VS: uv0_default2,
	uv1VS: uv1_default2,
	uvTransformVS: uvTransform_default2,
	uvTransformUniformsPS: uvTransformUniforms_default2,
	viewDirPS: viewDir_default2,
	webgpuPS: webgpu_wgsl_default,
	webgpuVS: webgpu_wgsl_default2
};

var app = null;
var AppBase = class _AppBase extends EventHandler {
	_batcher = null;
	_destroyRequested = false;
	_inFrameUpdate = false;
	_librariesLoaded = false;
	_fillMode = FILLMODE_KEEP_ASPECT;
	_resolutionMode = RESOLUTION_FIXED;
	_allowResize = true;
	_skyboxAsset = null;
	_soundManager;
	_visibilityChangeHandler;
	_entityIndex = {};
	_inTools = false;
	_scriptPrefix = "";
	_time = 0;
	enableBundles = typeof TextDecoder !== "undefined";
	frameRequestId;
	tick = (timestamp, xrFrame) => {
		if (!this.graphicsDevice) {
			return;
		}
		if (this.frameRequestId) {
			this.xr?.session?.cancelAnimationFrame(this.frameRequestId);
			cancelAnimationFrame(this.frameRequestId);
			this.frameRequestId = null;
		}
		this._inFrameUpdate = true;
		setApplication(this);
		app = this;
		const currentTime = this._processTimestamp(timestamp) || now();
		const ms = currentTime - (this._time || currentTime);
		let dt = ms / 1e3;
		dt = math.clamp(dt, 0, this.maxDeltaTime);
		dt *= this.timeScale;
		this._time = currentTime;
		this.requestAnimationFrame();
		if (this.graphicsDevice.contextLost) {
			return;
		}
		this.stats.updateBasic(currentTime, dt, ms, this.renderer, this.graphicsDevice);
		this.fire("frameupdate", ms);
		let skipUpdate = false;
		if (xrFrame) {
			skipUpdate = !this.xr?.update(xrFrame);
		}
		if (!skipUpdate) {
			this.update(dt);
			this.fire("framerender");
			if (this.autoRender || this.renderNextFrame) {
				this.render();
				this.renderNextFrame = false;
			}
			this.fire("frameend");
			this.stats.frameEnd();
		}
		this._inFrameUpdate = false;
		if (this._destroyRequested) {
			this.destroy();
		}
	};
	timeScale = 1;
	maxDeltaTime = 0.1;
	// Maximum delta is 0.1s or 10 fps.
	frame = 0;
	frameGraph = new FrameGraph();
	renderer;
	scriptsOrder = [];
	stats;
	autoRender = true;
	renderNextFrame = false;
	graphicsDevice;
	root;
	scene;
	lightmapper = null;
	loader = new ResourceLoader(this);
	assets = new AssetRegistry(this.loader);
	bundles;
	scenes = new SceneRegistry(this);
	scripts = new ScriptRegistry(this);
	systems = new ComponentSystemRegistry();
	i18n = new I18n(this);
	keyboard = null;
	mouse = null;
	touch = null;
	gamepads = null;
	elementInput = null;
	xr = null;
	constructor(canvas) {
		super();
		_AppBase._applications[canvas.id] = this;
		setApplication(this);
		app = this;
		this.root = new Entity();
		this.root._enabledInHierarchy = true;
	}
	init(appOptions) {
		const {
			assetPrefix,
			batchManager,
			componentSystems,
			elementInput,
			gamepads: gamepads2,
			graphicsDevice,
			keyboard,
			lightmapper,
			mouse,
			resourceHandlers,
			scriptsOrder,
			scriptPrefix,
			soundManager,
			touch: touch2,
			xr
		} = appOptions;
		this.graphicsDevice = graphicsDevice;
		ShaderChunks.get(graphicsDevice, SHADERLANGUAGE_GLSL).add(shaderChunksGLSL);
		ShaderChunks.get(graphicsDevice, SHADERLANGUAGE_WGSL).add(shaderChunksWGSL);
		this._initDefaultMaterial();
		this._initProgramLibrary();
		this.stats = new ApplicationStats(graphicsDevice);
		this._soundManager = soundManager;
		this.scene = new Scene(graphicsDevice);
		this._registerSceneImmediate(this.scene);
		if (assetPrefix) this.assets.prefix = assetPrefix;
		this.bundles = new BundleRegistry(this.assets);
		this.scriptsOrder = scriptsOrder || [];
		this.defaultLayerWorld = new Layer({ name: "World", id: LAYERID_WORLD });
		this.defaultLayerDepth = new Layer({ name: "Depth", id: LAYERID_DEPTH, enabled: false, opaqueSortMode: SORTMODE_NONE });
		this.defaultLayerSkybox = new Layer({ name: "Skybox", id: LAYERID_SKYBOX, opaqueSortMode: SORTMODE_NONE });
		this.defaultLayerUi = new Layer({ name: "UI", id: LAYERID_UI, transparentSortMode: SORTMODE_MANUAL });
		this.defaultLayerImmediate = new Layer({ name: "Immediate", id: LAYERID_IMMEDIATE, opaqueSortMode: SORTMODE_NONE });
		const defaultLayerComposition = new LayerComposition("default");
		defaultLayerComposition.pushOpaque(this.defaultLayerWorld);
		defaultLayerComposition.pushOpaque(this.defaultLayerDepth);
		defaultLayerComposition.pushOpaque(this.defaultLayerSkybox);
		defaultLayerComposition.pushTransparent(this.defaultLayerWorld);
		defaultLayerComposition.pushOpaque(this.defaultLayerImmediate);
		defaultLayerComposition.pushTransparent(this.defaultLayerImmediate);
		defaultLayerComposition.pushTransparent(this.defaultLayerUi);
		this.scene.layers = defaultLayerComposition;
		AreaLightLuts.createPlaceholder(graphicsDevice);
		this.renderer = new ForwardRenderer(graphicsDevice, this.scene);
		if (lightmapper) {
			this.lightmapper = new lightmapper(graphicsDevice, this.root, this.scene, this.renderer, this.assets);
			this.once("prerender", this._firstBake, this);
		}
		if (batchManager) {
			this._batcher = new batchManager(graphicsDevice, this.root, this.scene);
			this.once("prerender", this._firstBatch, this);
		}
		this.keyboard = keyboard || null;
		this.mouse = mouse || null;
		this.touch = touch2 || null;
		this.gamepads = gamepads2 || null;
		if (elementInput) {
			this.elementInput = elementInput;
			this.elementInput.app = this;
		}
		this.xr = xr ? new xr(this) : null;
		if (this.elementInput) this.elementInput.attachSelectEvents();
		this._scriptPrefix = scriptPrefix || "";
		if (this.enableBundles) {
			this.loader.addHandler("bundle", new BundleHandler(this));
		}
		resourceHandlers.forEach((resourceHandler) => {
			const handler = new resourceHandler(this);
			this.loader.addHandler(handler.handlerType, handler);
		});
		this.loader.enableRetry();
		componentSystems.forEach((componentSystem) => {
			this.systems.add(new componentSystem(this));
		});
		this._visibilityChangeHandler = this.onVisibilityChange.bind(this);
		if (typeof document !== "undefined") {
			document.addEventListener("visibilitychange", this._visibilityChangeHandler, false);
		}
	}
	static _applications = {};
	static getApplication(id14) {
		return id14 ? _AppBase._applications[id14] : getApplication();
	}
	_initDefaultMaterial() {
		const material = new StandardMaterial();
		material.name = "Default Material";
		setDefaultMaterial(this.graphicsDevice, material);
	}
	_initProgramLibrary() {
		const library = new ProgramLibrary(this.graphicsDevice, new StandardMaterial());
		setProgramLibrary(this.graphicsDevice, library);
	}
	get soundManager() {
		return this._soundManager;
	}
	get batcher() {
		return this._batcher;
	}
	get fillMode() {
		return this._fillMode;
	}
	get resolutionMode() {
		return this._resolutionMode;
	}
	configure(url, callback) {
		http.get(url, (err2, response) => {
			if (err2) {
				callback(err2);
				return;
			}
			const props = response.application_properties;
			const scenes = response.scenes;
			const assets = response.assets;
			this._parseApplicationProperties(props, (err3) => {
				this._parseScenes(scenes);
				this._parseAssets(assets);
				if (!err3) {
					callback(null);
				} else {
					callback(err3);
				}
			});
		});
	}
	preload(callback) {
		this.fire("preload:start");
		const assets = this.assets.list({
			preload: true
		});
		if (assets.length === 0) {
			this.fire("preload:end");
			callback();
			return;
		}
		let loadedCount = 0;
		const onAssetLoadOrError = () => {
			loadedCount++;
			this.fire("preload:progress", loadedCount / assets.length);
			if (loadedCount === assets.length) {
				this.fire("preload:end");
				callback();
			}
		};
		assets.forEach((asset) => {
			if (!asset.loaded) {
				asset.once("load", onAssetLoadOrError);
				asset.once("error", onAssetLoadOrError);
				this.assets.load(asset);
			} else {
				onAssetLoadOrError();
			}
		});
	}
	_preloadScripts(sceneData, callback) {
		callback();
	}
	// set application properties from data file
	_parseApplicationProperties(props, callback) {
		if (typeof props.maxAssetRetries === "number" && props.maxAssetRetries > 0) {
			this.loader.enableRetry(props.maxAssetRetries);
		}
		if (typeof props.maxConcurrentRequests === "number" && props.maxConcurrentRequests >= 0) {
			this.loader.maxConcurrentRequests = props.maxConcurrentRequests;
		}
		if (typeof props.withCredentials === "boolean") {
			this.loader.withCredentials = props.withCredentials;
		}
		if (!props.useDevicePixelRatio) {
			props.useDevicePixelRatio = props.use_device_pixel_ratio;
		}
		if (!props.resolutionMode) {
			props.resolutionMode = props.resolution_mode;
		}
		if (!props.fillMode) {
			props.fillMode = props.fill_mode;
		}
		this._width = props.width;
		this._height = props.height;
		if (props.useDevicePixelRatio) {
			this.graphicsDevice.maxPixelRatio = window.devicePixelRatio;
		}
		this.setCanvasResolution(props.resolutionMode, this._width, this._height);
		this.setCanvasFillMode(props.fillMode, this._width, this._height);
		if (props.layers && props.layerOrder) {
			const composition = new LayerComposition("application");
			const layers = {};
			for (const key in props.layers) {
				const data2 = props.layers[key];
				data2.id = parseInt(key, 10);
				data2.enabled = data2.id !== LAYERID_DEPTH;
				layers[key] = new Layer(data2);
			}
			for (let i2 = 0, len = props.layerOrder.length; i2 < len; i2++) {
				const sublayer = props.layerOrder[i2];
				const layer = layers[sublayer.layer];
				if (!layer) continue;
				if (sublayer.transparent) {
					composition.pushTransparent(layer);
				} else {
					composition.pushOpaque(layer);
				}
				composition.subLayerEnabled[i2] = sublayer.enabled;
			}
			this.scene.layers = composition;
		}
		if (props.batchGroups) {
			const batcher = this.batcher;
			if (batcher) {
				for (let i2 = 0, len = props.batchGroups.length; i2 < len; i2++) {
					const grp = props.batchGroups[i2];
					batcher.addGroup(grp.name, grp.dynamic, grp.maxAabbSize, grp.id, grp.layers);
				}
			}
		}
		if (props.i18nAssets) {
			this.i18n.assets = props.i18nAssets;
		}
		this._loadLibraries(props.libraries, callback);
	}
	_loadLibraries(urls, callback) {
		const len = urls.length;
		let count = len;
		const regex = /^https?:\/\//;
		if (len) {
			const onLoad = (err2, script2) => {
				count--;
				if (err2) {
					callback(err2);
				} else if (count === 0) {
					this.onLibrariesLoaded();
					callback(null);
				}
			};
			for (let i2 = 0; i2 < len; ++i2) {
				let url = urls[i2];
				if (!regex.test(url.toLowerCase()) && this._scriptPrefix) {
					url = path.join(this._scriptPrefix, url);
				}
				this.loader.load(url, "script", onLoad);
			}
		} else {
			this.onLibrariesLoaded();
			callback(null);
		}
	}
	_parseScenes(scenes) {
		if (!scenes) return;
		for (let i2 = 0; i2 < scenes.length; i2++) {
			this.scenes.add(scenes[i2].name, scenes[i2].url);
		}
	}
	_parseAssets(assets) {
		const list = [];
		const scriptsIndex = {};
		const bundlesIndex = {};
		for (let i2 = 0; i2 < this.scriptsOrder.length; i2++) {
			const id14 = this.scriptsOrder[i2];
			if (!assets[id14]) {
				continue;
			}
			scriptsIndex[id14] = true;
			list.push(assets[id14]);
		}
		if (this.enableBundles) {
			for (const id14 in assets) {
				if (assets[id14].type === "bundle") {
					bundlesIndex[id14] = true;
					list.push(assets[id14]);
				}
			}
		}
		for (const id14 in assets) {
			if (scriptsIndex[id14] || bundlesIndex[id14]) {
				continue;
			}
			list.push(assets[id14]);
		}
		for (let i2 = 0; i2 < list.length; i2++) {
			const data2 = list[i2];
			const asset = new Asset(data2.name, data2.type, data2.file, data2.data);
			asset.id = parseInt(data2.id, 10);
			asset.preload = data2.preload ? data2.preload : false;
			asset.loaded = data2.type === "script" && data2.data && data2.data.loadingType > 0;
			asset.tags.add(data2.tags);
			if (data2.i18n) {
				for (const locale in data2.i18n) {
					asset.addLocalizedAssetId(locale, data2.i18n[locale]);
				}
			}
			this.assets.add(asset);
		}
	}
	start() {
		this.frame = 0;
		this.fire("start", {
			timestamp: now(),
			target: this
		});
		if (!this._librariesLoaded) {
			this.onLibrariesLoaded();
		}
		this.systems.fire("initialize", this.root);
		this.fire("initialize");
		this.systems.fire("postInitialize", this.root);
		this.systems.fire("postPostInitialize", this.root);
		this.fire("postinitialize");
		this.requestAnimationFrame();
	}
	requestAnimationFrame() {
		if (this.xr?.session) {
			this.frameRequestId = this.xr.session.requestAnimationFrame(this.tick);
		} else {
			this.frameRequestId = platform.browser || platform.worker ? requestAnimationFrame(this.tick) : null;
		}
	}
	inputUpdate(dt) {
		if (this.mouse) {
			this.mouse.update();
		}
		if (this.keyboard) {
			this.keyboard.update();
		}
		if (this.gamepads) {
			this.gamepads.update();
		}
	}
	update(dt) {
		this.frame++;
		this.graphicsDevice.update();
		this.stats.frame.scriptUpdateStart = now();
		this.systems.fire(this._inTools ? "toolsUpdate" : "update", dt);
		this.stats.frame.scriptUpdate = now() - this.stats.frame.scriptUpdateStart;
		this.stats.frame.animUpdateStart = now();
		this.systems.fire("animationUpdate", dt);
		this.stats.frame.animUpdate = now() - this.stats.frame.animUpdateStart;
		this.stats.frame.scriptPostUpdateStart = now();
		this.systems.fire("postUpdate", dt);
		this.stats.frame.scriptPostUpdate = now() - this.stats.frame.scriptPostUpdateStart;
		this.fire("update", dt);
		this.inputUpdate(dt);
	}
	render() {
		this.updateCanvasSize();
		this.graphicsDevice.frameStart();
		this.fire("prerender");
		this.root.syncHierarchy();
		if (this._batcher) {
			this._batcher.updateAll();
		}
		this.renderComposition(this.scene.layers);
		this.fire("postrender");
		this.stats.frame.renderTime = now() - this.stats.frame.renderStart;
		this.graphicsDevice.frameEnd();
	}
	// render a layer composition
	renderComposition(layerComposition) {
		this.renderer.update(layerComposition);
		this.renderer.buildFrameGraph(this.frameGraph, layerComposition);
		this.renderer.cull(layerComposition);
		this.frameGraph.render(this.graphicsDevice);
	}
	setCanvasFillMode(mode, width, height) {
		this._fillMode = mode;
		this.resizeCanvas(width, height);
	}
	setCanvasResolution(mode, width, height) {
		this._resolutionMode = mode;
		if (mode === RESOLUTION_AUTO && width === void 0) {
			width = this.graphicsDevice.canvas.clientWidth;
			height = this.graphicsDevice.canvas.clientHeight;
		}
		this.graphicsDevice.resizeCanvas(width, height);
	}
	isHidden() {
		return document.hidden;
	}
	onVisibilityChange() {
		if (this.isHidden()) {
			if (this._soundManager) {
				this._soundManager.suspend();
			}
		} else {
			if (this._soundManager) {
				this._soundManager.resume();
			}
		}
	}
	resizeCanvas(width, height) {
		if (!this._allowResize) return void 0;
		if (this.xr && this.xr.session) {
			return void 0;
		}
		const windowWidth = window.innerWidth;
		const windowHeight = window.innerHeight;
		if (this._fillMode === FILLMODE_KEEP_ASPECT) {
			const r = this.graphicsDevice.canvas.width / this.graphicsDevice.canvas.height;
			const winR = windowWidth / windowHeight;
			if (r > winR) {
				width = windowWidth;
				height = width / r;
			} else {
				height = windowHeight;
				width = height * r;
			}
		} else if (this._fillMode === FILLMODE_FILL_WINDOW) {
			width = windowWidth;
			height = windowHeight;
		}
		this.graphicsDevice.canvas.style.width = `${width}px`;
		this.graphicsDevice.canvas.style.height = `${height}px`;
		this.updateCanvasSize();
		return {
			width,
			height
		};
	}
	updateCanvasSize() {
		if (!this._allowResize || this.xr?.active) {
			return;
		}
		if (this._resolutionMode === RESOLUTION_AUTO) {
			const canvas = this.graphicsDevice.canvas;
			this.graphicsDevice.resizeCanvas(canvas.clientWidth, canvas.clientHeight);
		}
	}
	onLibrariesLoaded() {
		this._librariesLoaded = true;
		if (this.systems.rigidbody) {
			this.systems.rigidbody.onLibraryLoaded();
		}
	}
	applySceneSettings(settings) {
		let asset;
		if (this.systems.rigidbody) {
			const [x3, y2, z2] = settings.physics.gravity;
			this.systems.rigidbody.gravity.set(x3, y2, z2);
		}
		this.scene.applySettings(settings);
		if (settings.render.hasOwnProperty("skybox")) {
			if (settings.render.skybox) {
				asset = this.assets.get(settings.render.skybox);
				if (asset) {
					this.setSkybox(asset);
				} else {
					this.assets.once(`add:${settings.render.skybox}`, this.setSkybox, this);
				}
			} else {
				this.setSkybox(null);
			}
		}
	}
	setAreaLightLuts(ltcMat1, ltcMat2) {
		if (ltcMat1 && ltcMat2) {
			AreaLightLuts.set(this.graphicsDevice, ltcMat1, ltcMat2);
		} else {
		}
	}
	setSkybox(asset) {
		if (asset !== this._skyboxAsset) {
			if (this._skyboxAsset) {
				this.assets.off(`load:${this._skyboxAsset.id}`, this._onSkyboxChanged, this);
				this.assets.off(`remove:${this._skyboxAsset.id}`, this._onSkyboxRemoved, this);
				this._skyboxAsset.off("change", this._onSkyboxChanged, this);
			}
			this._skyboxAsset = asset;
			if (this._skyboxAsset) {
				this.assets.on(`load:${this._skyboxAsset.id}`, this._onSkyboxChanged, this);
				this.assets.once(`remove:${this._skyboxAsset.id}`, this._onSkyboxRemoved, this);
				this._skyboxAsset.on("change", this._onSkyboxChanged, this);
				if (this.scene.skyboxMip === 0 && !this._skyboxAsset.loadFaces) {
					this._skyboxAsset.loadFaces = true;
				}
				this.assets.load(this._skyboxAsset);
			}
			this._onSkyboxChanged();
		}
	}
	_onSkyboxRemoved() {
		this.setSkybox(null);
	}
	_onSkyboxChanged() {
		this.scene.setSkybox(this._skyboxAsset ? this._skyboxAsset.resources : null);
	}
	_firstBake() {
		this.lightmapper?.bake(null, this.scene.lightmapMode);
	}
	_firstBatch() {
		this.batcher?.generate();
	}
	_processTimestamp(timestamp) {
		return timestamp;
	}
	drawLine(start, end, color3, depthTest, layer) {
		this.scene.drawLine(start, end, color3, depthTest, layer);
	}
	drawLines(positions, colors, depthTest = true, layer = this.scene.defaultDrawLayer) {
		this.scene.drawLines(positions, colors, depthTest, layer);
	}
	drawLineArrays(positions, colors, depthTest = true, layer = this.scene.defaultDrawLayer) {
		this.scene.drawLineArrays(positions, colors, depthTest, layer);
	}
	drawWireSphere(center2, radius, color3 = Color.WHITE, segments = 20, depthTest = true, layer = this.scene.defaultDrawLayer) {
		this.scene.immediate.drawWireSphere(center2, radius, color3, segments, depthTest, layer);
	}
	drawWireAlignedBox(minPoint, maxPoint, color3 = Color.WHITE, depthTest = true, layer = this.scene.defaultDrawLayer, mat2) {
		this.scene.immediate.drawWireAlignedBox(minPoint, maxPoint, color3, depthTest, layer, mat2);
	}
	drawMeshInstance(meshInstance, layer = this.scene.defaultDrawLayer) {
		this.scene.immediate.drawMesh(null, null, null, meshInstance, layer);
	}
	drawMesh(mesh, material, matrix2, layer = this.scene.defaultDrawLayer) {
		this.scene.immediate.drawMesh(material, matrix2, mesh, null, layer);
	}
	drawQuad(matrix2, material, layer = this.scene.defaultDrawLayer) {
		this.scene.immediate.drawMesh(material, matrix2, this.scene.immediate.getQuadMesh(), null, layer);
	}
	drawTexture(x3, y2, width, height, texture, material, layer = this.scene.defaultDrawLayer, filterable = true) {
		if (filterable === false && !this.graphicsDevice.isWebGPU) {
			return;
		}
		const matrix2 = new Mat4();
		matrix2.setTRS(new Vec3(x3, y2, 0), Quat.IDENTITY, new Vec3(width, -height, 0));
		if (!material) {
			material = new ShaderMaterial();
			material.cull = CULLFACE_NONE;
			material.setParameter("colorMap", texture);
			material.shaderDesc = filterable ? this.scene.immediate.getTextureShaderDesc(texture.encoding) : this.scene.immediate.getUnfilterableTextureShaderDesc();
			material.update();
		}
		this.drawQuad(matrix2, material, layer);
	}
	drawDepthTexture(x3, y2, width, height, layer = this.scene.defaultDrawLayer) {
		const material = new ShaderMaterial();
		material.cull = CULLFACE_NONE;
		material.shaderDesc = this.scene.immediate.getDepthTextureShaderDesc();
		material.update();
		this.drawTexture(x3, y2, width, height, null, material, layer);
	}
	destroy() {
		if (this._inFrameUpdate) {
			this._destroyRequested = true;
			return;
		}
		const canvasId = this.graphicsDevice.canvas.id;
		this.fire("destroy", this);
		this.off("librariesloaded");
		this._gsplatSortedEvt?.off();
		this._gsplatSortedEvt = null;
		if (typeof document !== "undefined") {
			document.removeEventListener("visibilitychange", this._visibilityChangeHandler, false);
		}
		this._visibilityChangeHandler = null;
		this.root.destroy();
		this.root = null;
		if (this.mouse) {
			this.mouse.off();
			this.mouse.detach();
			this.mouse = null;
		}
		if (this.keyboard) {
			this.keyboard.off();
			this.keyboard.detach();
			this.keyboard = null;
		}
		if (this.touch) {
			this.touch.off();
			this.touch.detach();
			this.touch = null;
		}
		if (this.elementInput) {
			this.elementInput.detach();
			this.elementInput = null;
		}
		if (this.gamepads) {
			this.gamepads.destroy();
			this.gamepads = null;
		}
		this.systems.destroy();
		this.bundles.destroy();
		this.bundles = null;
		this.i18n.destroy();
		this.i18n = null;
		const scriptHandler = this.loader.getHandler("script");
		scriptHandler?.clearCache();
		this.loader.destroy();
		this.loader = null;
		this.systems = null;
		this.context = null;
		this.scripts.destroy();
		this.scripts = null;
		this.scenes.destroy();
		this.scenes = null;
		this.lightmapper?.destroy();
		this.lightmapper = null;
		if (this._batcher) {
			this._batcher.destroy();
			this._batcher = null;
		}
		this._entityIndex = {};
		this.defaultLayerDepth.onDisable = null;
		this.defaultLayerDepth.onEnable = null;
		this.defaultLayerDepth = null;
		this.defaultLayerWorld = null;
		this.xr?.end();
		this.xr?.destroy();
		this.renderer.destroy();
		this.renderer = null;
		const assets = this.assets.list();
		for (let i2 = 0; i2 < assets.length; i2++) {
			assets[i2].unload();
			assets[i2].off();
		}
		this.assets.off();
		this.scene.destroy();
		this.scene = null;
		this.graphicsDevice.destroy();
		this.graphicsDevice = null;
		this.off();
		this._soundManager?.destroy();
		this._soundManager = null;
		script.app = null;
		_AppBase._applications[canvasId] = null;
		if (getApplication() === this) {
			setApplication(null);
		}
		_AppBase.cancelTick(this);
	}
	static cancelTick(app2) {
		if (app2.frameRequestId) {
			cancelAnimationFrame(app2.frameRequestId);
			app2.frameRequestId = void 0;
		}
	}
	getEntityFromIndex(guid2) {
		return this._entityIndex[guid2];
	}
	_registerSceneImmediate(scene) {
		this.on("postrender", scene.immediate.onPostRender, scene.immediate);
		this._gsplatSortedEvt = scene.on("gsplat:sorted", (sortTime) => {
			this.stats.frame.gsplatSort += sortTime;
		});
	}
};

var AppOptions = class {
	elementInput;
	keyboard;
	mouse;
	touch;
	gamepads;
	scriptPrefix;
	assetPrefix;
	scriptsOrder;
	soundManager;
	graphicsDevice;
	lightmapper;
	batchManager;
	xr;
	componentSystems = [];
	resourceHandlers = [];
};

var tempSphere2 = new BoundingSphere();
var BakeLight = class {
	constructor(scene, light, lightingParams) {
		this.scene = scene;
		this.light = light;
		this.store();
		light.numCascades = 1;
		if (this.scene.clusteredLightingEnabled && !lightingParams.shadowsEnabled) {
			light.castShadows = false;
		}
		if (light.type !== LIGHTTYPE_DIRECTIONAL) {
			light._node.getWorldTransform();
			light.getBoundingSphere(tempSphere2);
			this.lightBounds = new BoundingBox();
			this.lightBounds.center.copy(tempSphere2.center);
			this.lightBounds.halfExtents.set(tempSphere2.radius, tempSphere2.radius, tempSphere2.radius);
		}
	}
	store() {
		this.mask = this.light.mask;
		this.shadowUpdateMode = this.light.shadowUpdateMode;
		this.enabled = this.light.enabled;
		this.intensity = this.light.intensity;
		this.rotation = this.light._node.getLocalRotation().clone();
		this.numCascades = this.light.numCascades;
		this.castShadows = this.light._castShadows;
	}
	restore() {
		const light = this.light;
		light.mask = this.mask;
		light.shadowUpdateMode = this.shadowUpdateMode;
		light.enabled = this.enabled;
		light.intensity = this.intensity;
		light._node.setLocalRotation(this.rotation);
		light.numCascades = this.numCascades;
		light._castShadows = this.castShadows;
	}
	startBake() {
		this.light.enabled = true;
		this.light._destroyShadowMap();
		this.light.beginFrame();
	}
	endBake(shadowMapCache) {
		const light = this.light;
		light.enabled = false;
		if (light.shadowMap) {
			if (light.shadowMap.cached) {
				shadowMapCache.add(light, light.shadowMap);
			}
			light.shadowMap = null;
		}
	}
};

var _tempPoint = new Vec2();
var BakeLightSimple = class extends BakeLight {
	constructor(lightmapper, light) {
		super(lightmapper.scene, light, lightmapper.lightingParams);
	}
	get numVirtualLights() {
		if (this.light.type === LIGHTTYPE_DIRECTIONAL) {
			return this.light.bakeNumSamples;
		}
		return 1;
	}
	prepareVirtualLight(index, numVirtualLights) {
		const light = this.light;
		light._node.setLocalRotation(this.rotation);
		if (index > 0) {
			const directionalSpreadAngle = light.bakeArea;
			random.circlePointDeterministic(_tempPoint, index, numVirtualLights);
			_tempPoint.mulScalar(directionalSpreadAngle * 0.5);
			light._node.rotateLocal(_tempPoint.x, 0, _tempPoint.y);
		}
		light._node.getWorldTransform();
		const gamma = 2.2;
		const linearIntensity = Math.pow(this.intensity, gamma);
		light.intensity = Math.pow(linearIntensity / numVirtualLights, 1 / gamma);
	}
};

var _tempPoint2 = new Vec3();
var BakeLightAmbient = class extends BakeLight {
	constructor(lightmapper) {
		const scene = lightmapper.scene;
		const lightEntity = new Entity("AmbientLight");
		lightEntity.addComponent("light", {
			type: "directional",
			affectDynamic: true,
			affectLightmapped: false,
			bake: true,
			bakeNumSamples: scene.ambientBakeNumSamples,
			castShadows: true,
			normalOffsetBias: 0.05,
			shadowBias: 0.2,
			shadowDistance: 1,
			// this is updated during shadow map rendering
			shadowResolution: 2048,
			shadowType: SHADOW_PCF3_32F,
			color: Color.WHITE,
			intensity: 1,
			bakeDir: false
		});
		super(scene, lightEntity.light.light, lightmapper.lightingParams);
	}
	get numVirtualLights() {
		return this.light.bakeNumSamples;
	}
	prepareVirtualLight(index, numVirtualLights) {
		random.spherePointDeterministic(_tempPoint2, index, numVirtualLights, 0, this.scene.ambientBakeSpherePart);
		this.light._node.lookAt(_tempPoint2.mulScalar(-1));
		this.light._node.rotateLocal(90, 0, 0);
		const gamma = 2.2;
		const fullIntensity = 2 * Math.PI * this.scene.ambientBakeSpherePart;
		const linearIntensity = Math.pow(fullIntensity, gamma);
		this.light.intensity = Math.pow(linearIntensity / numVirtualLights, 1 / gamma);
	}
};

var BakeMeshNode = class {
	constructor(node, meshInstances = null) {
		this.node = node;
		this.component = node.render || node.model;
		meshInstances = meshInstances || this.component.meshInstances;
		this.store();
		this.meshInstances = meshInstances;
		this.bounds = null;
		this.renderTargets = [];
	}
	store() {
		this.castShadows = this.component.castShadows;
	}
	restore() {
		this.component.castShadows = this.castShadows;
	}
};

var bilateralDeNoise_default = `
float normpdf3(in vec3 v, in float sigma) {
	return 0.39894 * exp(-0.5 * dot(v, v) / (sigma * sigma)) / sigma;
}
vec3 decodeRGBM(vec4 rgbm) {
	vec3 color = (8.0 * rgbm.a) * rgbm.rgb;
	return color * color;
}
float saturate(float x) {
	return clamp(x, 0.0, 1.0);
}
vec4 encodeRGBM(vec3 color) {
	vec4 encoded;
	encoded.rgb = pow(color.rgb, vec3(0.5));
	encoded.rgb *= 1.0 / 8.0;
	encoded.a = saturate( max( max( encoded.r, encoded.g ), max( encoded.b, 1.0 / 255.0 ) ) );
	encoded.a = ceil(encoded.a * 255.0) / 255.0;
	encoded.rgb /= encoded.a;
	return encoded;
}
vec3 decode(vec4 pixel) {
	#if HDR
		return pixel.rgb;
	#else
		return decodeRGBM(pixel);
	#endif
}
bool isUsed(vec4 pixel) {
	#if HDR
		return any(greaterThan(pixel.rgb, vec3(0.0)));
	#else
		return pixel.a > 0.0;
	#endif
}
varying vec2 vUv0;
uniform sampler2D source;
uniform vec2 pixelOffset;
uniform vec2 sigmas;
uniform float bZnorm;
uniform float kernel[{MSIZE}];
void main(void) {
	
	vec4 pixel = texture2DLod(source, vUv0, 0.0);
	if (!isUsed(pixel)) {
		gl_FragColor = pixel;
		return ;
	}
	float sigma = sigmas.x;
	float bSigma = sigmas.y;
	vec3 pixelHdr = decode(pixel);
	vec3 accumulatedHdr = vec3(0.0);
	float accumulatedFactor = 0.000001;
	const int kSize = ({MSIZE} - 1) / 2;
	for (int i = -kSize; i <= kSize; ++i) {
		for (int j = -kSize; j <= kSize; ++j) {
			
			vec2 coord = vUv0 + vec2(float(i), float(j)) * pixelOffset;
			vec4 pix = texture2DLod(source, coord, 0.0);
			if (isUsed(pix)) {
				vec3 hdr = decode(pix);
				float factor = kernel[kSize + j] * kernel[kSize + i];
				factor *= normpdf3(hdr - pixelHdr, bSigma) * bZnorm;
				accumulatedHdr += factor * hdr;
				accumulatedFactor += factor;
			}
		}
	}
	vec3 finalHDR = accumulatedHdr / accumulatedFactor;
	#if HDR
		gl_FragColor = vec4(finalHDR, 1.0);
	#else
		gl_FragColor = encodeRGBM(finalHDR);
	#endif
}
`;

var dilate_default = `
varying vec2 vUv0;
uniform sampler2D source;
uniform vec2 pixelOffset;
bool isUsed(vec4 pixel) {
	#if HDR
		return any(greaterThan(pixel.rgb, vec3(0.0)));
	#else
		return pixel.a > 0.0;
	#endif
}
void main(void) {
	vec4 c = texture2DLod(source, vUv0, 0.0);
	c = isUsed(c) ? c : texture2DLod(source, vUv0 - pixelOffset, 0.0);
	c = isUsed(c) ? c : texture2DLod(source, vUv0 + vec2(0, -pixelOffset.y), 0.0);
	c = isUsed(c) ? c : texture2DLod(source, vUv0 + vec2(pixelOffset.x, -pixelOffset.y), 0.0);
	c = isUsed(c) ? c : texture2DLod(source, vUv0 + vec2(-pixelOffset.x, 0), 0.0);
	c = isUsed(c) ? c : texture2DLod(source, vUv0 + vec2(pixelOffset.x, 0), 0.0);
	c = isUsed(c) ? c : texture2DLod(source, vUv0 + vec2(-pixelOffset.x, pixelOffset.y), 0.0);
	c = isUsed(c) ? c : texture2DLod(source, vUv0 + vec2(0, pixelOffset.y), 0.0);
	c = isUsed(c) ? c : texture2DLod(source, vUv0 + pixelOffset, 0.0);
	gl_FragColor = c;
}
`;

var bilateralDeNoise_default2 = `
fn normpdf3(v: vec3f, sigma: f32) -> f32 {
	return 0.39894 * exp(-0.5 * dot(v, v) / (sigma * sigma)) / sigma;
}
fn decodeRGBM(rgbm: vec4f) -> vec3f {
	let color = (8.0 * rgbm.a) * rgbm.rgb;
	return color * color;
}
fn saturate(x: f32) -> f32 {
	return clamp(x, 0.0, 1.0);
}
fn encodeRGBM(color: vec3f) -> vec4f {
	var encoded: vec4f;
	let rgb_processed = pow(color.rgb, vec3f(0.5)) * (1.0 / 8.0);
	encoded = vec4f(rgb_processed, 0.0);
	let max_g_b = max( encoded.g, max( encoded.b, 1.0 / 255.0 ) );
	let max_rgb = max( encoded.r, max_g_b );
	encoded.a = clamp(max_rgb, 0.0, 1.0);
	encoded.a = ceil(encoded.a * 255.0) / 255.0;
	encoded = vec4f(encoded.rgb / encoded.a, encoded.a);
	return encoded;
}
fn decode(pixel: vec4f) -> vec3f {
	#if HDR
		return pixel.rgb;
	#else
		return decodeRGBM(pixel);
	#endif
}
fn isUsed(pixel: vec4f) -> bool {
	#if HDR
		return any(pixel.rgb > vec3f(0.0));
	#else
		return pixel.a > 0.0;
	#endif
}
varying vUv0: vec2f;
var source: texture_2d<f32>;
var sourceSampler: sampler;
uniform kernel: array<f32, {MSIZE}>;
uniform pixelOffset: vec2f;
uniform sigmas: vec2f;
uniform bZnorm: f32;
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	let pixel = textureSampleLevel(source, sourceSampler, input.vUv0, 0.0);
	if (!isUsed(pixel)) {
		output.color = pixel;
		return output;
	}
	let sigma = uniform.sigmas.x;
	let bSigma = uniform.sigmas.y;
	let pixelHdr = decode(pixel);
	var accumulatedHdr = vec3f(0.0);
	var accumulatedFactor = 0.000001;
	const kSize = ({MSIZE} - 1) / 2;
	for (var i: i32 = -kSize; i <= kSize; i = i + 1) {
		for (var j: i32 = -kSize; j <= kSize; j = j + 1) {
			let coord = input.vUv0 + vec2f(f32(i), f32(j)) * uniform.pixelOffset;
			let pix = textureSampleLevel(source, sourceSampler, coord, 0.0);
			if (isUsed(pix)) {
				let hdr = decode(pix);
				var factor = uniform.kernel[u32(kSize + j)].element * uniform.kernel[u32(kSize + i)].element;
				factor = factor * normpdf3(hdr - pixelHdr, bSigma) * uniform.bZnorm;
				accumulatedHdr = accumulatedHdr + factor * hdr;
				accumulatedFactor = accumulatedFactor + factor;
			}
		}
	}
	let finalHDR = accumulatedHdr / accumulatedFactor;
	#if HDR
		output.color = vec4f(finalHDR, 1.0);
	#else
		output.color = encodeRGBM(finalHDR);
	#endif
	return output;
}
`;

var dilate_default2 = `
varying vUv0: vec2f;
var source: texture_2d<f32>;
var sourceSampler: sampler;
uniform pixelOffset: vec2f;
fn isUsed(pixel: vec4f) -> bool {
	#ifdef HDR
		return any(pixel.rgb > vec3f(0.0));
	#else
		return pixel.a > 0.0;
	#endif
}
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var c: vec4f = textureSampleLevel(source, sourceSampler, input.vUv0, 0.0);
	c = select(textureSampleLevel(source, sourceSampler, input.vUv0 - uniform.pixelOffset, 0.0), c, isUsed(c));
	c = select(textureSampleLevel(source, sourceSampler, input.vUv0 + vec2f(0.0, -uniform.pixelOffset.y), 0.0), c, isUsed(c));
	c = select(textureSampleLevel(source, sourceSampler, input.vUv0 + vec2f(uniform.pixelOffset.x, -uniform.pixelOffset.y), 0.0), c, isUsed(c));
	c = select(textureSampleLevel(source, sourceSampler, input.vUv0 + vec2f(-uniform.pixelOffset.x, 0.0), 0.0), c, isUsed(c));
	c = select(textureSampleLevel(source, sourceSampler, input.vUv0 + vec2f(uniform.pixelOffset.x, 0.0), 0.0), c, isUsed(c));
	c = select(textureSampleLevel(source, sourceSampler, input.vUv0 + vec2f(-uniform.pixelOffset.x, uniform.pixelOffset.y), 0.0), c, isUsed(c));
	c = select(textureSampleLevel(source, sourceSampler, input.vUv0 + vec2f(0.0, uniform.pixelOffset.y), 0.0), c, isUsed(c));
	c = select(textureSampleLevel(source, sourceSampler, input.vUv0 + uniform.pixelOffset, 0.0), c, isUsed(c));
	var output: FragmentOutput;
	output.color = c;
	return output;
}
`;

var DENOISE_FILTER_SIZE = 15;
var lightmapFiltersChunksGLSL = {
	glslBilateralDeNoisePS: bilateralDeNoise_default,
	glslDilatePS: dilate_default
};
var lightmapFiltersChunksWLSL = {
	wgslBilateralDeNoisePS: bilateralDeNoise_default2,
	wgslDilatePS: dilate_default2
};
var LightmapFilters = class {
	shaderDilate = [];
	shaderDenoise = [];
	constructor(device) {
		this.device = device;
		ShaderChunks.get(this.device, SHADERLANGUAGE_GLSL).add(lightmapFiltersChunksGLSL);
		ShaderChunks.get(this.device, SHADERLANGUAGE_WGSL).add(lightmapFiltersChunksWLSL);
		this.constantTexSource = device.scope.resolve("source");
		this.constantPixelOffset = device.scope.resolve("pixelOffset");
		this.pixelOffset = new Float32Array(2);
		this.sigmas = null;
		this.constantSigmas = null;
		this.kernel = null;
	}
	setSourceTexture(texture) {
		this.constantTexSource.setValue(texture);
	}
	prepare(textureWidth, textureHeight) {
		this.pixelOffset[0] = 1 / textureWidth;
		this.pixelOffset[1] = 1 / textureHeight;
		this.constantPixelOffset.setValue(this.pixelOffset);
	}
	prepareDenoise(filterRange, filterSmoothness, bakeHDR) {
		const index = bakeHDR ? 0 : 1;
		if (!this.shaderDenoise[index]) {
			const defines = /* @__PURE__ */ new Map();
			defines.set("{MSIZE}", 15);
			if (bakeHDR) defines.set("HDR", "");
			this.shaderDenoise[index] = ShaderUtils.createShader(this.device, {
				uniqueName: `lmBilateralDeNoise-${bakeHDR ? "hdr" : "rgbm"}`,
				attributes: { vertex_position: SEMANTIC_POSITION },
				vertexGLSL: ShaderChunks.get(this.device, SHADERLANGUAGE_GLSL).get("fullscreenQuadVS"),
				vertexWGSL: ShaderChunks.get(this.device, SHADERLANGUAGE_WGSL).get("fullscreenQuadVS"),
				fragmentGLSL: ShaderChunks.get(this.device, SHADERLANGUAGE_GLSL).get("glslBilateralDeNoisePS"),
				fragmentWGSL: ShaderChunks.get(this.device, SHADERLANGUAGE_WGSL).get("wgslBilateralDeNoisePS"),
				fragmentDefines: defines
			});
			this.sigmas = new Float32Array(2);
			this.constantSigmas = this.device.scope.resolve("sigmas");
			this.constantKernel = this.device.scope.resolve("kernel[0]");
			this.bZnorm = this.device.scope.resolve("bZnorm");
		}
		this.sigmas[0] = filterRange;
		this.sigmas[1] = filterSmoothness;
		this.constantSigmas.setValue(this.sigmas);
		this.evaluateDenoiseUniforms(filterRange, filterSmoothness);
	}
	getDenoise(bakeHDR) {
		const index = bakeHDR ? 0 : 1;
		return this.shaderDenoise[index];
	}
	getDilate(device, bakeHDR) {
		const index = bakeHDR ? 0 : 1;
		if (!this.shaderDilate[index]) {
			const define = bakeHDR ? "#define HDR\n" : "";
			this.shaderDilate[index] = ShaderUtils.createShader(device, {
				uniqueName: `lmDilate-${bakeHDR ? "hdr" : "rgbm"}`,
				attributes: { vertex_position: SEMANTIC_POSITION },
				vertexGLSL: ShaderChunks.get(this.device, SHADERLANGUAGE_GLSL).get("fullscreenQuadVS"),
				vertexWGSL: ShaderChunks.get(this.device, SHADERLANGUAGE_WGSL).get("fullscreenQuadVS"),
				fragmentGLSL: define + ShaderChunks.get(this.device, SHADERLANGUAGE_GLSL).get("glslDilatePS"),
				fragmentWGSL: define + ShaderChunks.get(this.device, SHADERLANGUAGE_WGSL).get("wgslDilatePS")
			});
		}
		return this.shaderDilate[index];
	}
	evaluateDenoiseUniforms(filterRange, filterSmoothness) {
		function normpdf(x3, sigma) {
			return 0.39894 * Math.exp(-0.5 * x3 * x3 / (sigma * sigma)) / sigma;
		}
		this.kernel = this.kernel || new Float32Array(DENOISE_FILTER_SIZE);
		const kernel = this.kernel;
		const kSize = Math.floor((DENOISE_FILTER_SIZE - 1) / 2);
		for (let j = 0; j <= kSize; ++j) {
			const value = normpdf(j, filterRange);
			kernel[kSize + j] = value;
			kernel[kSize - j] = value;
		}
		this.constantKernel.setValue(this.kernel);
		const bZnorm = 1 / normpdf(0, filterSmoothness);
		this.bZnorm.setValue(bZnorm);
	}
};

var RenderPassLightmapper = class extends RenderPass {
	constructor(device, renderer, camera, worldClusters, receivers, lightArray) {
		super(device);
		this.renderer = renderer;
		this.camera = camera;
		this.worldClusters = worldClusters;
		this.receivers = receivers;
		this.lightArray = lightArray;
	}
	execute() {
		const device = this.device;
		const { renderer, camera, receivers, renderTarget, worldClusters, lightArray } = this;
		renderer.renderForwardLayer(camera, renderTarget, null, void 0, SHADER_FORWARD, {
			meshInstances: receivers,
			splitLights: lightArray,
			lightClusters: worldClusters
		});
	}
};

var MAX_LIGHTMAP_SIZE = 2048;
var PASS_COLOR = 0;
var PASS_DIR = 1;
var tempVec = new Vec3();
var Lightmapper = class {
	constructor(device, root, scene, renderer, assets) {
		this.device = device;
		this.root = root;
		this.scene = scene;
		this.renderer = renderer;
		this.assets = assets;
		this.shadowMapCache = renderer.shadowMapCache;
		this._tempSet = /* @__PURE__ */ new Set();
		this._initCalled = false;
		this.passMaterials = [];
		this.ambientAOMaterial = null;
		this.fog = "";
		this.ambientLight = new Color();
		this.renderTargets = /* @__PURE__ */ new Map();
		this.stats = {
			renderPasses: 0,
			lightmapCount: 0,
			totalRenderTime: 0,
			forwardTime: 0,
			fboTime: 0,
			shadowMapTime: 0,
			compileTime: 0,
			shadersLinked: 0
		};
	}
	destroy() {
		LightmapCache.decRef(this.blackTex);
		this.blackTex = null;
		LightmapCache.destroy();
		this.device = null;
		this.root = null;
		this.scene = null;
		this.renderer = null;
		this.assets = null;
		this.camera?.destroy();
		this.camera = null;
	}
	initBake(device) {
		this.bakeHDR = this.scene.lightmapPixelFormat !== PIXELFORMAT_RGBA8;
		if (!this._initCalled) {
			this._initCalled = true;
			this.lightmapFilters = new LightmapFilters(device);
			this.constantBakeDir = device.scope.resolve("bakeDir");
			this.materials = [];
			this.blackTex = new Texture(this.device, {
				width: 4,
				height: 4,
				format: PIXELFORMAT_RGBA8,
				type: TEXTURETYPE_RGBM,
				name: "lightmapBlack"
			});
			LightmapCache.incRef(this.blackTex);
			const camera = new Camera(this.device);
			camera.clearColor.set(0, 0, 0, 0);
			camera.clearColorBuffer = true;
			camera.clearDepthBuffer = false;
			camera.clearStencilBuffer = false;
			camera.frustumCulling = false;
			camera.projection = PROJECTION_ORTHOGRAPHIC;
			camera.aspectRatio = 1;
			camera.node = new GraphNode();
			this.camera = camera;
			this.camera.shaderParams.gammaCorrection = GAMMA_NONE;
			this.camera.shaderParams.toneMapping = TONEMAP_LINEAR;
		}
		if (this.scene.clusteredLightingEnabled) {
			const lightingParams = new LightingParams(device.supportsAreaLights, device.maxTextureSize, () => {
			});
			this.lightingParams = lightingParams;
			const srcParams = this.scene.lighting;
			lightingParams.shadowsEnabled = srcParams.shadowsEnabled;
			lightingParams.shadowAtlasResolution = srcParams.shadowAtlasResolution;
			lightingParams.cookiesEnabled = srcParams.cookiesEnabled;
			lightingParams.cookieAtlasResolution = srcParams.cookieAtlasResolution;
			lightingParams.areaLightsEnabled = srcParams.areaLightsEnabled;
			lightingParams.cells = new Vec3(3, 3, 3);
			lightingParams.maxLightsPerCell = 4;
			this.worldClusters = new WorldClusters(device);
			this.worldClusters.name = "ClusterLightmapper";
			this.shadowLocalClusteredPass = new RenderPassShadowLocalClustered(
				device,
				this.renderer.shadowRenderer,
				this.renderer._shadowRendererLocal
			);
		}
	}
	finishBake(bakeNodes) {
		this.materials = [];
		function destroyRT(rt) {
			LightmapCache.decRef(rt.colorBuffer);
			rt.destroy();
		}
		this.renderTargets.forEach((rt) => {
			destroyRT(rt);
		});
		this.renderTargets.clear();
		bakeNodes.forEach((node) => {
			node.renderTargets.forEach((rt) => {
				destroyRT(rt);
			});
			node.renderTargets.length = 0;
		});
		this.ambientAOMaterial = null;
		if (this.worldClusters) {
			this.worldClusters.destroy();
			this.worldClusters = null;
		}
	}
	createMaterialForPass(scene, pass, addAmbient) {
		const material = new StandardMaterial();
		material.name = `lmMaterial-pass:${pass}-ambient:${addAmbient}`;
		material.setDefine("UV1LAYOUT", "");
		material.setDefine("LIT_LIGHTMAP_BAKING", "");
		if (pass === PASS_COLOR) {
			material.setDefine("LIT_LIGHTMAP_BAKING_COLOR", "");
			if (addAmbient) {
				material.setDefine("LIT_LIGHTMAP_BAKING_ADD_AMBIENT", "");
			} else {
				material.ambient = new Color(0, 0, 0);
			}
			if (!this.bakeHDR) material.setDefine("LIGHTMAP_RGBM", "");
			material.lightMap = this.blackTex;
		} else {
			material.setDefine("LIT_LIGHTMAP_BAKING_DIR", "");
			material.setDefine("STD_LIGHTMAP_DIR", "");
		}
		material.cull = CULLFACE_NONE;
		material.forceUv1 = true;
		material.update();
		return material;
	}
	createMaterials(device, scene, passCount) {
		for (let pass = 0; pass < passCount; pass++) {
			if (!this.passMaterials[pass]) {
				this.passMaterials[pass] = this.createMaterialForPass(scene, pass, false);
			}
		}
		if (!this.ambientAOMaterial) {
			this.ambientAOMaterial = this.createMaterialForPass(scene, 0, true);
			this.ambientAOMaterial.onUpdateShader = function(options2) {
				options2.litOptions.lightMapWithoutAmbient = true;
				options2.litOptions.separateAmbient = true;
				return options2;
			};
		}
	}
	createTexture(size, name) {
		return new Texture(this.device, {
			width: size,
			height: size,
			format: this.scene.lightmapPixelFormat,
			mipmaps: false,
			type: this.bakeHDR ? TEXTURETYPE_DEFAULT : TEXTURETYPE_RGBM,
			minFilter: FILTER_NEAREST,
			magFilter: FILTER_NEAREST,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			name
		});
	}
	// recursively walk the hierarchy of nodes starting at the specified node
	// collect all nodes that need to be lightmapped to bakeNodes array
	// collect all nodes with geometry to allNodes array
	collectModels(node, bakeNodes, allNodes) {
		if (!node.enabled) return;
		let meshInstances;
		if (node.model?.model && node.model?.enabled) {
			if (allNodes) allNodes.push(new BakeMeshNode(node));
			if (node.model.lightmapped) {
				if (bakeNodes) {
					meshInstances = node.model.model.meshInstances;
				}
			}
		}
		if (node.render?.enabled) {
			if (allNodes) allNodes.push(new BakeMeshNode(node));
			if (node.render.lightmapped) {
				if (bakeNodes) {
					meshInstances = node.render.meshInstances;
				}
			}
		}
		if (meshInstances) {
			let hasUv1 = true;
			for (let i2 = 0; i2 < meshInstances.length; i2++) {
				if (!meshInstances[i2].mesh.vertexBuffer.format.hasUv1) {
					hasUv1 = false;
					break;
				}
			}
			if (hasUv1) {
				const notInstancedMeshInstances = [];
				for (let i2 = 0; i2 < meshInstances.length; i2++) {
					const mesh = meshInstances[i2].mesh;
					if (this._tempSet.has(mesh)) {
						bakeNodes.push(new BakeMeshNode(node, [meshInstances[i2]]));
					} else {
						notInstancedMeshInstances.push(meshInstances[i2]);
					}
					this._tempSet.add(mesh);
				}
				this._tempSet.clear();
				if (notInstancedMeshInstances.length > 0) {
					bakeNodes.push(new BakeMeshNode(node, notInstancedMeshInstances));
				}
			}
		}
		for (let i2 = 0; i2 < node._children.length; i2++) {
			this.collectModels(node._children[i2], bakeNodes, allNodes);
		}
	}
	// prepare all meshInstances that cast shadows into lightmaps
	prepareShadowCasters(nodes) {
		const casters = [];
		for (let n = 0; n < nodes.length; n++) {
			const component = nodes[n].component;
			component.castShadows = component.castShadowsLightmap;
			if (component.castShadowsLightmap) {
				const meshes = nodes[n].meshInstances;
				for (let i2 = 0; i2 < meshes.length; i2++) {
					meshes[i2].visibleThisFrame = true;
					casters.push(meshes[i2]);
				}
			}
		}
		return casters;
	}
	// updates world transform for nodes
	updateTransforms(nodes) {
		for (let i2 = 0; i2 < nodes.length; i2++) {
			const meshInstances = nodes[i2].meshInstances;
			for (let j = 0; j < meshInstances.length; j++) {
				meshInstances[j].node.getWorldTransform();
			}
		}
	}
	// Note: this function is also called by the Editor to display estimated LM size in the inspector,
	// do not change its signature.
	calculateLightmapSize(node) {
		let data2;
		const sizeMult = this.scene.lightmapSizeMultiplier || 16;
		const scale2 = tempVec;
		let srcArea, lightmapSizeMultiplier;
		if (node.model) {
			lightmapSizeMultiplier = node.model.lightmapSizeMultiplier;
			if (node.model.asset) {
				data2 = this.assets.get(node.model.asset).data;
				if (data2.area) {
					srcArea = data2.area;
				}
			} else if (node.model._area) {
				data2 = node.model;
				if (data2._area) {
					srcArea = data2._area;
				}
			}
		} else if (node.render) {
			lightmapSizeMultiplier = node.render.lightmapSizeMultiplier;
			if (node.render.type !== "asset") {
				if (node.render._area) {
					data2 = node.render;
					if (data2._area) {
						srcArea = data2._area;
					}
				}
			}
		}
		const area = { x: 1, y: 1, z: 1, uv: 1 };
		if (srcArea) {
			area.x = srcArea.x;
			area.y = srcArea.y;
			area.z = srcArea.z;
			area.uv = srcArea.uv;
		}
		const areaMult = lightmapSizeMultiplier || 1;
		area.x *= areaMult;
		area.y *= areaMult;
		area.z *= areaMult;
		const component = node.render || node.model;
		const bounds = this.computeNodeBounds(component.meshInstances);
		scale2.copy(bounds.halfExtents);
		let totalArea = area.x * scale2.y * scale2.z + area.y * scale2.x * scale2.z + area.z * scale2.x * scale2.y;
		totalArea /= area.uv;
		totalArea = Math.sqrt(totalArea);
		const lightmapSize = Math.min(math.nextPowerOfTwo(totalArea * sizeMult), this.scene.lightmapMaxResolution || MAX_LIGHTMAP_SIZE);
		return lightmapSize;
	}
	setLightmapping(nodes, value, passCount, shaderDefs) {
		for (let i2 = 0; i2 < nodes.length; i2++) {
			const node = nodes[i2];
			const meshInstances = node.meshInstances;
			for (let j = 0; j < meshInstances.length; j++) {
				const meshInstance = meshInstances[j];
				meshInstance.setLightmapped(value);
				if (value) {
					if (shaderDefs) {
						meshInstance._shaderDefs |= shaderDefs;
					}
					meshInstance.mask = MASK_AFFECT_LIGHTMAPPED;
					for (let pass = 0; pass < passCount; pass++) {
						const tex = node.renderTargets[pass].colorBuffer;
						tex.minFilter = FILTER_LINEAR;
						tex.magFilter = FILTER_LINEAR;
						meshInstance.setRealtimeLightmap(MeshInstance.lightmapParamNames[pass], tex);
					}
				}
			}
		}
	}
	bake(nodes, mode = BAKE_COLORDIR) {
		const device = this.device;
		const startTime = now();
		this.scene._updateSkyMesh();
		this.stats.renderPasses = 0;
		this.stats.shadowMapTime = 0;
		this.stats.forwardTime = 0;
		const startShaders = device._shaderStats.linked;
		const startFboTime = device._renderTargetCreationTime;
		const startCompileTime = device._shaderStats.compileTime;
		const bakeNodes = [];
		const allNodes = [];
		if (nodes) {
			for (let i2 = 0; i2 < nodes.length; i2++) {
				this.collectModels(nodes[i2], bakeNodes, null);
			}
			this.collectModels(this.root, null, allNodes);
		} else {
			this.collectModels(this.root, bakeNodes, allNodes);
		}
		if (bakeNodes.length > 0) {
			this.renderer.shadowRenderer.frameUpdate();
			const passCount = mode === BAKE_COLORDIR ? 2 : 1;
			this.setLightmapping(bakeNodes, false, passCount);
			this.initBake(device);
			this.bakeInternal(passCount, bakeNodes, allNodes);
			let shaderDefs = SHADERDEF_LM;
			if (mode === BAKE_COLORDIR) {
				shaderDefs |= SHADERDEF_DIRLM;
			}
			if (this.scene.ambientBake) {
				shaderDefs |= SHADERDEF_LMAMBIENT;
			}
			this.setLightmapping(bakeNodes, true, passCount, shaderDefs);
			this.finishBake(bakeNodes);
		}
		const nowTime = now();
		this.stats.totalRenderTime = nowTime - startTime;
		this.stats.shadersLinked = device._shaderStats.linked - startShaders;
		this.stats.compileTime = device._shaderStats.compileTime - startCompileTime;
		this.stats.fboTime = device._renderTargetCreationTime - startFboTime;
		this.stats.lightmapCount = bakeNodes.length;
	}
	// this allocates lightmap textures and render targets.
	allocateTextures(bakeNodes, passCount) {
		for (let i2 = 0; i2 < bakeNodes.length; i2++) {
			const bakeNode = bakeNodes[i2];
			const size = this.calculateLightmapSize(bakeNode.node);
			for (let pass = 0; pass < passCount; pass++) {
				const tex = this.createTexture(size, `lightmapper_lightmap_${i2}`);
				LightmapCache.incRef(tex);
				bakeNode.renderTargets[pass] = new RenderTarget({
					colorBuffer: tex,
					depth: false
				});
			}
			if (!this.renderTargets.has(size)) {
				const tex = this.createTexture(size, `lightmapper_temp_lightmap_${size}`);
				LightmapCache.incRef(tex);
				this.renderTargets.set(size, new RenderTarget({
					colorBuffer: tex,
					depth: false
				}));
			}
		}
	}
	prepareLightsToBake(allLights, bakeLights) {
		if (this.scene.ambientBake) {
			const ambientLight = new BakeLightAmbient(this);
			bakeLights.push(ambientLight);
		}
		const sceneLights = this.renderer.lights;
		for (let i2 = 0; i2 < sceneLights.length; i2++) {
			const light = sceneLights[i2];
			const bakeLight = new BakeLightSimple(this, light);
			allLights.push(bakeLight);
			if (light.enabled && (light.mask & MASK_BAKE) !== 0) {
				light.mask = MASK_BAKE | MASK_AFFECT_LIGHTMAPPED | MASK_AFFECT_DYNAMIC;
				light.shadowUpdateMode = light.type === LIGHTTYPE_DIRECTIONAL ? SHADOWUPDATE_REALTIME : SHADOWUPDATE_THISFRAME;
				bakeLights.push(bakeLight);
			}
		}
		bakeLights.sort();
	}
	restoreLights(allLights) {
		for (let i2 = 0; i2 < allLights.length; i2++) {
			allLights[i2].restore();
		}
	}
	setupScene() {
		this.ambientLight.copy(this.scene.ambientLight);
		if (!this.scene.ambientBake) {
			this.scene.ambientLight.set(0, 0, 0);
		}
		this.renderer.setSceneConstants();
		this.device.scope.resolve("ambientBakeOcclusionContrast").setValue(this.scene.ambientBakeOcclusionContrast);
		this.device.scope.resolve("ambientBakeOcclusionBrightness").setValue(this.scene.ambientBakeOcclusionBrightness);
	}
	restoreScene() {
		this.scene.ambientLight.copy(this.ambientLight);
	}
	// compute bounding box for a single node
	computeNodeBounds(meshInstances) {
		const bounds = new BoundingBox();
		if (meshInstances.length > 0) {
			bounds.copy(meshInstances[0].aabb);
			for (let m = 1; m < meshInstances.length; m++) {
				bounds.add(meshInstances[m].aabb);
			}
		}
		return bounds;
	}
	// compute bounding box for each node
	computeNodesBounds(nodes) {
		for (let i2 = 0; i2 < nodes.length; i2++) {
			const meshInstances = nodes[i2].meshInstances;
			nodes[i2].bounds = this.computeNodeBounds(meshInstances);
		}
	}
	// compute compound bounding box for an array of mesh instances
	computeBounds(meshInstances) {
		const bounds = new BoundingBox();
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			bounds.copy(meshInstances[0].aabb);
			for (let m = 1; m < meshInstances.length; m++) {
				bounds.add(meshInstances[m].aabb);
			}
		}
		return bounds;
	}
	backupMaterials(meshInstances) {
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			this.materials[i2] = meshInstances[i2].material;
		}
	}
	restoreMaterials(meshInstances) {
		for (let i2 = 0; i2 < meshInstances.length; i2++) {
			meshInstances[i2].material = this.materials[i2];
		}
	}
	lightCameraPrepare(device, bakeLight) {
		const light = bakeLight.light;
		let shadowCam;
		if (light.type === LIGHTTYPE_SPOT) {
			const lightRenderData = light.getRenderData(null, 0);
			shadowCam = lightRenderData.shadowCamera;
			shadowCam._node.setPosition(light._node.getPosition());
			shadowCam._node.setRotation(light._node.getRotation());
			shadowCam._node.rotateLocal(-90, 0, 0);
			shadowCam.projection = PROJECTION_PERSPECTIVE;
			shadowCam.nearClip = light.attenuationEnd / 1e3;
			shadowCam.farClip = light.attenuationEnd;
			shadowCam.aspectRatio = 1;
			shadowCam.fov = light._outerConeAngle * 2;
			shadowCam.updateFrustum();
		}
		return shadowCam;
	}
	// prepares camera / frustum of the light for rendering the bakeNode
	// returns true if light affects the bakeNode
	lightCameraPrepareAndCull(bakeLight, bakeNode, shadowCam, casterBounds) {
		const light = bakeLight.light;
		let lightAffectsNode = true;
		if (light.type === LIGHTTYPE_DIRECTIONAL) {
			tempVec.copy(casterBounds.center);
			tempVec.y += casterBounds.halfExtents.y;
			this.camera.node.setPosition(tempVec);
			this.camera.node.setEulerAngles(-90, 0, 0);
			this.camera.nearClip = 0;
			this.camera.farClip = casterBounds.halfExtents.y * 2;
			const frustumSize = Math.max(casterBounds.halfExtents.x, casterBounds.halfExtents.z);
			this.camera.orthoHeight = frustumSize;
		} else {
			if (!bakeLight.lightBounds.intersects(bakeNode.bounds)) {
				lightAffectsNode = false;
			}
		}
		if (light.type === LIGHTTYPE_SPOT) {
			let nodeVisible = false;
			const meshInstances = bakeNode.meshInstances;
			for (let i2 = 0; i2 < meshInstances.length; i2++) {
				if (meshInstances[i2]._isVisible(shadowCam)) {
					nodeVisible = true;
					break;
				}
			}
			if (!nodeVisible) {
				lightAffectsNode = false;
			}
		}
		return lightAffectsNode;
	}
	// set up light array for a single light
	setupLightArray(lightArray, light) {
		lightArray[LIGHTTYPE_DIRECTIONAL].length = 0;
		lightArray[LIGHTTYPE_OMNI].length = 0;
		lightArray[LIGHTTYPE_SPOT].length = 0;
		lightArray[light.type][0] = light;
		light.visibleThisFrame = true;
	}
	renderShadowMap(comp, shadowMapRendered, casters, bakeLight) {
		const light = bakeLight.light;
		const isClustered = this.scene.clusteredLightingEnabled;
		const castShadow = light.castShadows && (!isClustered || this.scene.lighting.shadowsEnabled);
		if (!shadowMapRendered && castShadow) {
			if (!light.shadowMap && !isClustered) {
				light.shadowMap = this.shadowMapCache.get(this.device, light);
			}
			if (light.type === LIGHTTYPE_DIRECTIONAL) {
				this.renderer._shadowRendererDirectional.prepareShadowMap(light);
				this.renderer._shadowRendererDirectional.cull(light, comp, this.camera, casters);
				const shadowPass = this.renderer._shadowRendererDirectional.getLightRenderPass(light, this.camera);
				shadowPass?.render();
			} else {
				this.renderer._shadowRendererLocal.cull(light, comp, casters);
				if (isClustered) {
					this.shadowLocalClusteredPass.update([light]);
					if (this.shadowLocalClusteredPass.enabled) {
						this.shadowLocalClusteredPass.render();
					}
				} else {
					const faceCount = light.numShadowFaces;
					const applyVsm = light._type === LIGHTTYPE_SPOT;
					for (let face = 0; face < faceCount; face++) {
						const renderPass = new RenderPassShadowLocalNonClustered(
							this.device,
							this.renderer.shadowRenderer,
							light,
							face,
							applyVsm
						);
						renderPass.render();
					}
				}
			}
		}
		return true;
	}
	postprocessTextures(device, bakeNodes, passCount) {
		const numDilates2x = 1;
		const dilateShader = this.lightmapFilters.getDilate(device, this.bakeHDR);
		let denoiseShader;
		const filterLightmap = this.scene.lightmapFilterEnabled;
		if (filterLightmap) {
			this.lightmapFilters.prepareDenoise(this.scene.lightmapFilterRange, this.scene.lightmapFilterSmoothness, this.bakeHDR);
			denoiseShader = this.lightmapFilters.getDenoise(this.bakeHDR);
		}
		device.setBlendState(BlendState.NOBLEND);
		device.setDepthState(DepthState.NODEPTH);
		device.setStencilState(null, null);
		for (let node = 0; node < bakeNodes.length; node++) {
			const bakeNode = bakeNodes[node];
			for (let pass = 0; pass < passCount; pass++) {
				const nodeRT = bakeNode.renderTargets[pass];
				const lightmap = nodeRT.colorBuffer;
				const tempRT = this.renderTargets.get(lightmap.width);
				const tempTex = tempRT.colorBuffer;
				this.lightmapFilters.prepare(lightmap.width, lightmap.height);
				for (let i2 = 0; i2 < numDilates2x; i2++) {
					this.lightmapFilters.setSourceTexture(lightmap);
					const bilateralFilterEnabled = filterLightmap && pass === 0 && i2 === 0;
					drawQuadWithShader(device, tempRT, bilateralFilterEnabled ? denoiseShader : dilateShader);
					this.lightmapFilters.setSourceTexture(tempTex);
					drawQuadWithShader(device, nodeRT, dilateShader);
				}
			}
		}
	}
	bakeInternal(passCount, bakeNodes, allNodes) {
		const scene = this.scene;
		const comp = scene.layers;
		const device = this.device;
		const clusteredLightingEnabled = scene.clusteredLightingEnabled;
		this.createMaterials(device, scene, passCount);
		this.setupScene();
		comp._update();
		this.computeNodesBounds(bakeNodes);
		this.allocateTextures(bakeNodes, passCount);
		this.renderer.collectLights(comp);
		const allLights = [], bakeLights = [];
		this.prepareLightsToBake(allLights, bakeLights);
		this.updateTransforms(allNodes);
		const casters = this.prepareShadowCasters(allNodes);
		this.renderer.updateCpuSkinMatrices(casters);
		this.renderer.gpuUpdate(casters);
		const casterBounds = this.computeBounds(casters);
		let i2, j, rcv, m;
		for (i2 = 0; i2 < bakeNodes.length; i2++) {
			const bakeNode = bakeNodes[i2];
			rcv = bakeNode.meshInstances;
			for (j = 0; j < rcv.length; j++) {
				m = rcv[j];
				m.setLightmapped(false);
				m.mask = MASK_BAKE;
				m.setRealtimeLightmap(MeshInstance.lightmapParamNames[0], this.blackTex);
				m.setRealtimeLightmap(MeshInstance.lightmapParamNames[1], this.blackTex);
			}
		}
		for (j = 0; j < bakeLights.length; j++) {
			bakeLights[j].light.enabled = false;
		}
		const lightArray = [[], [], []];
		let pass, node;
		let shadersUpdatedOn1stPass = false;
		for (i2 = 0; i2 < bakeLights.length; i2++) {
			const bakeLight = bakeLights[i2];
			const isAmbientLight = bakeLight instanceof BakeLightAmbient;
			const isDirectional = bakeLight.light.type === LIGHTTYPE_DIRECTIONAL;
			let numVirtualLights = bakeLight.numVirtualLights;
			if (passCount > 1 && numVirtualLights > 1 && bakeLight.light.bakeDir) {
				numVirtualLights = 1;
			}
			for (let virtualLightIndex = 0; virtualLightIndex < numVirtualLights; virtualLightIndex++) {
				if (numVirtualLights > 1) {
					bakeLight.prepareVirtualLight(virtualLightIndex, numVirtualLights);
				}
				bakeLight.startBake();
				let shadowMapRendered = false;
				const shadowCam = this.lightCameraPrepare(device, bakeLight);
				for (node = 0; node < bakeNodes.length; node++) {
					const bakeNode = bakeNodes[node];
					rcv = bakeNode.meshInstances;
					const lightAffectsNode = this.lightCameraPrepareAndCull(bakeLight, bakeNode, shadowCam, casterBounds);
					if (!lightAffectsNode) {
						continue;
					}
					this.setupLightArray(lightArray, bakeLight.light);
					const clusterLights = isDirectional ? [] : [bakeLight.light];
					if (clusteredLightingEnabled) {
						this.renderer.lightTextureAtlas.update(clusterLights, this.lightingParams);
					}
					shadowMapRendered = this.renderShadowMap(comp, shadowMapRendered, casters, bakeLight);
					if (clusteredLightingEnabled) {
						this.worldClusters.update(clusterLights, this.lightingParams);
					}
					this.backupMaterials(rcv);
					for (pass = 0; pass < passCount; pass++) {
						if (pass > 0 && virtualLightIndex > 0) {
							break;
						}
						if (isAmbientLight && pass > 0) {
							break;
						}
						const nodeRT = bakeNode.renderTargets[pass];
						const lightmapSize = bakeNode.renderTargets[pass].colorBuffer.width;
						const tempRT = this.renderTargets.get(lightmapSize);
						const tempTex = tempRT.colorBuffer;
						if (pass === 0) {
							shadersUpdatedOn1stPass = scene.updateShaders;
						} else if (shadersUpdatedOn1stPass) {
							scene.updateShaders = true;
						}
						let passMaterial = this.passMaterials[pass];
						if (isAmbientLight) {
							const lastVirtualLightForPass = virtualLightIndex + 1 === numVirtualLights;
							if (lastVirtualLightForPass && pass === 0) {
								passMaterial = this.ambientAOMaterial;
							}
						}
						for (j = 0; j < rcv.length; j++) {
							rcv[j].material = passMaterial;
						}
						this.renderer.updateShaders(rcv);
						if (pass === PASS_DIR) {
							this.constantBakeDir.setValue(bakeLight.light.bakeDir ? 1 : 0);
						}
						const renderPass = new RenderPassLightmapper(
							device,
							this.renderer,
							this.camera,
							clusteredLightingEnabled ? this.worldClusters : null,
							rcv,
							lightArray
						);
						renderPass.init(tempRT);
						renderPass.colorOps.clear = true;
						renderPass.colorOps.clearValue.copy(this.camera.clearColor);
						renderPass.render();
						renderPass.destroy();
						bakeNode.renderTargets[pass] = tempRT;
						this.renderTargets.set(lightmapSize, nodeRT);
						for (j = 0; j < rcv.length; j++) {
							m = rcv[j];
							m.setRealtimeLightmap(MeshInstance.lightmapParamNames[pass], tempTex);
							m._shaderDefs |= SHADERDEF_LM;
						}
					}
					this.restoreMaterials(rcv);
				}
				bakeLight.endBake(this.shadowMapCache);
			}
		}
		this.postprocessTextures(device, bakeNodes, passCount);
		for (node = 0; node < allNodes.length; node++) {
			allNodes[node].restore();
		}
		this.restoreLights(allLights);
		this.restoreScene();
		if (!clusteredLightingEnabled) {
			this.shadowMapCache.clear();
		}
	}
};

var ComponentSystem = class extends EventHandler {
	id;
	extraDataProperties = [];
	_validProps = null;
	constructor(app2) {
		super();
		this.app = app2;
		this.store = {};
		this.schema = [];
	}
	addComponent(entity, data2 = {}) {
		const component = new this.ComponentType(this, entity);
		const componentData = this.DataType ? new this.DataType() : {};
		this.store[entity.guid] = {
			entity,
			data: componentData
		};
		entity[this.id] = component;
		entity.c[this.id] = component;
		this.initializeComponentData(component, data2);
		this.fire("add", entity, component);
		return component;
	}
	removeComponent(entity) {
		const id14 = this.id;
		const record = this.store[entity.guid];
		const component = entity.c[id14];
		component.fire("beforeremove");
		this.fire("beforeremove", entity, component);
		delete this.store[entity.guid];
		entity[id14] = void 0;
		delete entity.c[id14];
		this.fire("remove", entity, record.data);
	}
	cloneComponent(entity, clone) {
		const src = this.store[entity.guid];
		return this.addComponent(clone, src.data);
	}
	initializeComponentData(component, data2 = {}, properties) {
		if (properties) {
			for (let i2 = 0, len = properties.length; i2 < len; i2++) {
				const descriptor = properties[i2];
				let name, type;
				if (typeof descriptor === "object") {
					name = descriptor.name;
					type = descriptor.type;
				} else {
					name = descriptor;
					type = void 0;
				}
				let value = data2[name];
				if (value !== void 0) {
					if (type !== void 0) {
						value = convertValue(value, type);
					}
					component[name] = value;
				} else if (component.data && name in component.data) {
					component[name] = component.data[name];
				}
			}
		} else if (data2.enabled !== void 0) {
			component.enabled = data2.enabled;
		}
		if (component.enabled && component.entity.enabled) {
			component.onEnable();
		}
	}
	getPropertiesOfType(type) {
		const matchingProperties = [];
		const schema = this.schema || [];
		schema.forEach((descriptor) => {
			if (descriptor && typeof descriptor === "object" && descriptor.type === type) {
				matchingProperties.push(descriptor);
			}
		});
		return matchingProperties;
	}
	destroy() {
		this.off();
	}
};
function convertValue(value, type) {
	if (!value) {
		return value;
	}
	switch (type) {
		case "rgb":
			if (value instanceof Color) {
				return value.clone();
			}
			return new Color(value[0], value[1], value[2]);
		case "rgba":
			if (value instanceof Color) {
				return value.clone();
			}
			return new Color(value[0], value[1], value[2], value[3]);
		case "vec2":
			if (value instanceof Vec2) {
				return value.clone();
			}
			return new Vec2(value[0], value[1]);
		case "vec3":
			if (value instanceof Vec3) {
				return value.clone();
			}
			return new Vec3(value[0], value[1], value[2]);
		case "vec4":
			if (value instanceof Vec4) {
				return value.clone();
			}
			return new Vec4(value[0], value[1], value[2], value[3]);
		case "boolean":
		case "number":
		case "string":
			return value;
		case "entity":
			return value;
		// Entity fields should just be a string guid
		default:
			throw new Error(`Could not convert unhandled type: ${type}`);
	}
}

var INTERPOLATION_STEP = 0;
var INTERPOLATION_LINEAR = 1;
var INTERPOLATION_CUBIC = 2;

var AnimCache = class {
	constructor() {
		this._left = Infinity;
		this._right = -Infinity;
		this._len = 0;
		this._recip = 0;
		this._p0 = 0;
		this._p1 = 0;
		this._t = 0;
		this._hermite = {
			// hermite weights, calculated on demand
			valid: false,
			p0: 0,
			m0: 0,
			p1: 0,
			m1: 0
		};
	}
	update(time, input) {
		if (time < this._left || time >= this._right) {
			const len = input.length;
			if (!len) {
				this._left = -Infinity;
				this._right = Infinity;
				this._len = 0;
				this._recip = 0;
				this._p0 = this._p1 = 0;
			} else {
				if (time < input[0]) {
					this._left = -Infinity;
					this._right = input[0];
					this._len = 0;
					this._recip = 0;
					this._p0 = this._p1 = 0;
				} else if (time >= input[len - 1]) {
					this._left = input[len - 1];
					this._right = Infinity;
					this._len = 0;
					this._recip = 0;
					this._p0 = this._p1 = len - 1;
				} else {
					const index = this._findKey(time, input);
					this._left = input[index];
					this._right = input[index + 1];
					this._len = this._right - this._left;
					const diff = 1 / this._len;
					this._recip = isFinite(diff) ? diff : 0;
					this._p0 = index;
					this._p1 = index + 1;
				}
			}
		}
		this._t = this._recip === 0 ? 0 : (time - this._left) * this._recip;
		this._hermite.valid = false;
	}
	_findKey(time, input) {
		let index = 0;
		while (time >= input[index + 1]) {
			index++;
		}
		return index;
	}
	// evaluate the output anim data at the current time
	eval(result, interpolation, output) {
		const data2 = output._data;
		const comp = output._components;
		const idx0 = this._p0 * comp;
		if (interpolation === INTERPOLATION_STEP) {
			for (let i2 = 0; i2 < comp; ++i2) {
				result[i2] = data2[idx0 + i2];
			}
		} else {
			const t = this._t;
			const idx1 = this._p1 * comp;
			switch (interpolation) {
				case INTERPOLATION_LINEAR:
					for (let i2 = 0; i2 < comp; ++i2) {
						result[i2] = math.lerp(data2[idx0 + i2], data2[idx1 + i2], t);
					}
					break;
				case INTERPOLATION_CUBIC: {
					const hermite = this._hermite;
					if (!hermite.valid) {
						const t2 = t * t;
						const twot = t + t;
						const omt = 1 - t;
						const omt2 = omt * omt;
						hermite.valid = true;
						hermite.p0 = (1 + twot) * omt2;
						hermite.m0 = t * omt2;
						hermite.p1 = t2 * (3 - twot);
						hermite.m1 = t2 * (t - 1);
					}
					const p0 = (this._p0 * 3 + 1) * comp;
					const m0 = (this._p0 * 3 + 2) * comp;
					const p12 = (this._p1 * 3 + 1) * comp;
					const m12 = (this._p1 * 3 + 0) * comp;
					for (let i2 = 0; i2 < comp; ++i2) {
						result[i2] = hermite.p0 * data2[p0 + i2] + hermite.m0 * data2[m0 + i2] * this._len + hermite.p1 * data2[p12 + i2] + hermite.m1 * data2[m12 + i2] * this._len;
					}
					break;
				}
			}
		}
	}
};

var AnimSnapshot = class {
	constructor(animTrack) {
		this._name = `${animTrack.name}Snapshot`;
		this._time = -1;
		this._cache = [];
		this._results = [];
		for (let i2 = 0; i2 < animTrack._inputs.length; ++i2) {
			this._cache[i2] = new AnimCache();
		}
		const curves = animTrack._curves;
		const outputs = animTrack._outputs;
		for (let i2 = 0; i2 < curves.length; ++i2) {
			const curve = curves[i2];
			const output = outputs[curve._output];
			const storage = [];
			for (let j = 0; j < output._components; ++j) {
				storage[j] = 0;
			}
			this._results[i2] = storage;
		}
	}
};

var AnimClip = class _AnimClip {
	static eventFrame = {
		start: 0,
		end: 0,
		residual: 0
	};
	constructor(track, time, speed, playing, loop, eventHandler) {
		this._name = track.name;
		this._track = track;
		this._snapshot = new AnimSnapshot(track);
		this._playing = playing;
		this._time = time;
		this._speed = speed;
		this._loop = loop;
		this._blendWeight = 1;
		this._blendOrder = 0;
		this._eventHandler = eventHandler;
		this.alignCursorToCurrentTime();
	}
	set name(name) {
		this._name = name;
	}
	get name() {
		return this._name;
	}
	set track(track) {
		this._track = track;
		this._snapshot = new AnimSnapshot(track);
	}
	get track() {
		return this._track;
	}
	get snapshot() {
		return this._snapshot;
	}
	set time(time) {
		this._time = time;
		this.alignCursorToCurrentTime();
	}
	get time() {
		return this._time;
	}
	set speed(speed) {
		const signChanged = Math.sign(speed) !== Math.sign(this._speed);
		this._speed = speed;
		if (signChanged) {
			this.alignCursorToCurrentTime();
		}
	}
	get speed() {
		return this._speed;
	}
	set loop(loop) {
		this._loop = loop;
	}
	get loop() {
		return this._loop;
	}
	set blendWeight(blendWeight) {
		this._blendWeight = blendWeight;
	}
	get blendWeight() {
		return this._blendWeight;
	}
	set blendOrder(blendOrder) {
		this._blendOrder = blendOrder;
	}
	get blendOrder() {
		return this._blendOrder;
	}
	set eventCursor(value) {
		this._eventCursor = value;
	}
	get eventCursor() {
		return this._eventCursor;
	}
	get eventCursorEnd() {
		return this.isReverse ? 0 : this._track.events.length - 1;
	}
	get nextEvent() {
		return this._track.events[this._eventCursor];
	}
	get isReverse() {
		return this._speed < 0;
	}
	nextEventAheadOfTime(time) {
		if (!this.nextEvent) return false;
		return this.isReverse ? this.nextEvent.time <= time : this.nextEvent.time >= time;
	}
	nextEventBehindTime(time) {
		if (!this.nextEvent) return false;
		if (time === this.track.duration) {
			return this.isReverse ? this.nextEvent.time >= time : this.nextEvent.time <= time;
		}
		return this.isReverse ? this.nextEvent.time > time : this.nextEvent.time < time;
	}
	resetEventCursor() {
		this._eventCursor = this.isReverse ? this._track.events.length - 1 : 0;
	}
	moveEventCursor() {
		this._eventCursor += this.isReverse ? -1 : 1;
		if (this._eventCursor >= this.track.events.length) {
			this._eventCursor = 0;
		} else if (this._eventCursor < 0) {
			this._eventCursor = this.track.events.length - 1;
		}
	}
	clipFrameTime(frameEndTime) {
		const eventFrame = _AnimClip.eventFrame;
		eventFrame.start = 0;
		eventFrame.end = frameEndTime;
		eventFrame.residual = 0;
		if (this.isReverse) {
			if (frameEndTime < 0) {
				eventFrame.start = this.track.duration;
				eventFrame.end = 0;
				eventFrame.residual = frameEndTime + this.track.duration;
			}
		} else {
			if (frameEndTime > this.track.duration) {
				eventFrame.start = 0;
				eventFrame.end = this.track.duration;
				eventFrame.residual = frameEndTime - this.track.duration;
			}
		}
	}
	alignCursorToCurrentTime() {
		this.resetEventCursor();
		while (this.nextEventBehindTime(this._time) && this._eventCursor !== this.eventCursorEnd) {
			this.moveEventCursor();
		}
	}
	fireNextEvent() {
		this._eventHandler?.fire(this.nextEvent.name, { track: this.track, ...this.nextEvent });
		this.moveEventCursor();
	}
	fireNextEventInFrame(frameStartTime, frameEndTime) {
		if (this.nextEventAheadOfTime(frameStartTime) && this.nextEventBehindTime(frameEndTime)) {
			this.fireNextEvent();
			return true;
		}
		return false;
	}
	activeEventsForFrame(frameStartTime, frameEndTime) {
		const eventFrame = _AnimClip.eventFrame;
		this.clipFrameTime(frameEndTime);
		const initialCursor = this.eventCursor;
		while (this.fireNextEventInFrame(frameStartTime, eventFrame.end)) {
			if (initialCursor === this.eventCursor) {
				break;
			}
		}
		if (this.loop && Math.abs(eventFrame.residual) > 0) {
			this.activeEventsForFrame(eventFrame.start, eventFrame.residual);
		}
	}
	progressForTime(time) {
		return time * this._speed / this._track.duration;
	}
	_update(deltaTime) {
		if (this._playing) {
			let time = this._time;
			const duration = this._track.duration;
			const speed = this._speed;
			const loop = this._loop;
			if (this._track.events.length > 0 && duration > 0) {
				this.activeEventsForFrame(time, time + speed * deltaTime);
			}
			time += speed * deltaTime;
			if (speed >= 0) {
				if (time > duration) {
					if (loop) {
						time = time % duration || 0;
					} else {
						time = this._track.duration;
						this.pause();
					}
				}
			} else {
				if (time < 0) {
					if (loop) {
						time = duration + (time % duration || 0);
					} else {
						time = 0;
						this.pause();
					}
				}
			}
			this._time = time;
		}
		if (this._time !== this._snapshot._time) {
			this._track.eval(this._time, this._snapshot);
		}
	}
	play() {
		this._playing = true;
		this._time = 0;
	}
	stop() {
		this._playing = false;
		this._time = 0;
	}
	pause() {
		this._playing = false;
	}
	resume() {
		this._playing = true;
	}
	reset() {
		this._time = 0;
	}
};

var ANIM_INTERRUPTION_NONE = "NONE";
var ANIM_INTERRUPTION_PREV = "PREV_STATE";
var ANIM_INTERRUPTION_NEXT = "NEXT_STATE";
var ANIM_INTERRUPTION_PREV_NEXT = "PREV_STATE_NEXT_STATE";
var ANIM_INTERRUPTION_NEXT_PREV = "NEXT_STATE_PREV_STATE";
var ANIM_GREATER_THAN = "GREATER_THAN";
var ANIM_LESS_THAN = "LESS_THAN";
var ANIM_GREATER_THAN_EQUAL_TO = "GREATER_THAN_EQUAL_TO";
var ANIM_LESS_THAN_EQUAL_TO = "LESS_THAN_EQUAL_TO";
var ANIM_EQUAL_TO = "EQUAL_TO";
var ANIM_NOT_EQUAL_TO = "NOT_EQUAL_TO";
var ANIM_PARAMETER_INTEGER = "INTEGER";
var ANIM_PARAMETER_FLOAT = "FLOAT";
var ANIM_PARAMETER_BOOLEAN = "BOOLEAN";
var ANIM_PARAMETER_TRIGGER = "TRIGGER";
var ANIM_BLEND_1D = "1D";
var ANIM_BLEND_2D_DIRECTIONAL = "2D_DIRECTIONAL";
var ANIM_BLEND_2D_CARTESIAN = "2D_CARTESIAN";
var ANIM_BLEND_DIRECT = "DIRECT";
var ANIM_STATE_START = "START";
var ANIM_STATE_END = "END";
var ANIM_STATE_ANY = "ANY";
var ANIM_CONTROL_STATES = [ANIM_STATE_START, ANIM_STATE_END, ANIM_STATE_ANY];
var ANIM_LAYER_OVERWRITE = "OVERWRITE";
var ANIM_LAYER_ADDITIVE = "ADDITIVE";

var AnimBlend = class _AnimBlend {
	static dot(a, b) {
		const len = a.length;
		let result = 0;
		for (let i2 = 0; i2 < len; ++i2) {
			result += a[i2] * b[i2];
		}
		return result;
	}
	static normalize(a) {
		let l = _AnimBlend.dot(a, a);
		if (l > 0) {
			l = 1 / Math.sqrt(l);
			const len = a.length;
			for (let i2 = 0; i2 < len; ++i2) {
				a[i2] *= l;
			}
		}
	}
	static set(a, b, type) {
		const len = a.length;
		if (type === "quaternion") {
			let l = _AnimBlend.dot(b, b);
			if (l > 0) {
				l = 1 / Math.sqrt(l);
			}
			for (let i2 = 0; i2 < len; ++i2) {
				a[i2] = b[i2] * l;
			}
		} else {
			for (let i2 = 0; i2 < len; ++i2) {
				a[i2] = b[i2];
			}
		}
	}
	static blendVec(a, b, t, additive) {
		const it = additive ? 1 : 1 - t;
		const len = a.length;
		for (let i2 = 0; i2 < len; ++i2) {
			a[i2] = a[i2] * it + b[i2] * t;
		}
	}
	static blendQuat(a, b, t, additive) {
		const len = a.length;
		const it = additive ? 1 : 1 - t;
		if (_AnimBlend.dot(a, b) < 0) {
			t = -t;
		}
		for (let i2 = 0; i2 < len; ++i2) {
			a[i2] = a[i2] * it + b[i2] * t;
		}
		if (!additive) {
			_AnimBlend.normalize(a);
		}
	}
	static blend(a, b, t, type, additive) {
		if (type === "quaternion") {
			_AnimBlend.blendQuat(a, b, t, additive);
		} else {
			_AnimBlend.blendVec(a, b, t, additive);
		}
	}
	static stableSort(a, lessFunc) {
		const len = a.length;
		for (let i2 = 0; i2 < len - 1; ++i2) {
			for (let j = i2 + 1; j < len; ++j) {
				if (lessFunc(a[j], a[i2])) {
					const tmp = a[i2];
					a[i2] = a[j];
					a[j] = tmp;
				}
			}
		}
	}
};

var AnimTargetValue = class _AnimTargetValue {
	static TYPE_QUAT = "quaternion";
	static TYPE_VEC3 = "vector3";
	static q1 = new Quat();
	static q2 = new Quat();
	static q3 = new Quat();
	static quatArr = [0, 0, 0, 1];
	static vecArr = [0, 0, 0];
	static IDENTITY_QUAT_ARR = [0, 0, 0, 1];
	constructor(component, type) {
		this._component = component;
		this.mask = new Int8Array(component.layers.length);
		this.weights = new Float32Array(component.layers.length);
		this.totalWeight = 0;
		this.counter = 0;
		this.layerCounter = 0;
		this.valueType = type;
		this.dirty = true;
		this.value = type === _AnimTargetValue.TYPE_QUAT ? [0, 0, 0, 1] : [0, 0, 0];
		this.baseValue = null;
		this.setter = null;
	}
	get _normalizeWeights() {
		return this._component.normalizeWeights;
	}
	getWeight(index) {
		if (this.dirty) this.updateWeights();
		if (this._normalizeWeights && this.totalWeight === 0 || !this.mask[index]) {
			return 0;
		} else if (this._normalizeWeights) {
			return this.weights[index] / this.totalWeight;
		}
		return math.clamp(this.weights[index], 0, 1);
	}
	_layerBlendType(index) {
		return this._component.layers[index].blendType;
	}
	setMask(index, value) {
		this.mask[index] = value;
		if (this._normalizeWeights) {
			if (this._component.layers[index].blendType === ANIM_LAYER_OVERWRITE) {
				this.mask = this.mask.fill(0, 0, index);
			}
			this.dirty = true;
		}
	}
	updateWeights() {
		this.totalWeight = 0;
		for (let i2 = 0; i2 < this.weights.length; i2++) {
			this.weights[i2] = this._component.layers[i2].weight;
			this.totalWeight += this.mask[i2] * this.weights[i2];
		}
		this.dirty = false;
	}
	updateValue(index, value) {
		if (this.counter === 0) {
			AnimBlend.set(this.value, _AnimTargetValue.IDENTITY_QUAT_ARR, this.valueType);
			if (!this._normalizeWeights) {
				AnimBlend.blend(this.value, this.baseValue, 1, this.valueType);
			}
		}
		if (!this.mask[index] || this.getWeight(index) === 0) return;
		if (this._layerBlendType(index) === ANIM_LAYER_ADDITIVE && !this._normalizeWeights) {
			if (this.valueType === _AnimTargetValue.TYPE_QUAT) {
				const v6 = _AnimTargetValue.q1.set(this.value[0], this.value[1], this.value[2], this.value[3]);
				const aV1 = _AnimTargetValue.q2.set(this.baseValue[0], this.baseValue[1], this.baseValue[2], this.baseValue[3]);
				const aV2 = _AnimTargetValue.q3.set(value[0], value[1], value[2], value[3]);
				const aV = aV1.invert().mul(aV2);
				aV.slerp(Quat.IDENTITY, aV, this.getWeight(index));
				v6.mul(aV);
				_AnimTargetValue.quatArr[0] = v6.x;
				_AnimTargetValue.quatArr[1] = v6.y;
				_AnimTargetValue.quatArr[2] = v6.z;
				_AnimTargetValue.quatArr[3] = v6.w;
				AnimBlend.set(this.value, _AnimTargetValue.quatArr, this.valueType);
			} else {
				_AnimTargetValue.vecArr[0] = value[0] - this.baseValue[0];
				_AnimTargetValue.vecArr[1] = value[1] - this.baseValue[1];
				_AnimTargetValue.vecArr[2] = value[2] - this.baseValue[2];
				AnimBlend.blend(this.value, _AnimTargetValue.vecArr, this.getWeight(index), this.valueType, true);
			}
		} else {
			AnimBlend.blend(this.value, value, this.getWeight(index), this.valueType);
		}
		if (this.setter) this.setter(this.value);
	}
	unbind() {
		if (this.setter) {
			this.setter(this.baseValue);
		}
	}
};

var AnimEvaluator = class {
	constructor(binder) {
		this._binder = binder;
		this._clips = [];
		this._inputs = [];
		this._outputs = [];
		this._targets = {};
	}
	get clips() {
		return this._clips;
	}
	addClip(clip) {
		const targets = this._targets;
		const binder = this._binder;
		const curves = clip.track.curves;
		const snapshot = clip.snapshot;
		const inputs = [];
		const outputs = [];
		for (let i2 = 0; i2 < curves.length; ++i2) {
			const curve = curves[i2];
			const paths = curve.paths;
			for (let j = 0; j < paths.length; ++j) {
				const path2 = paths[j];
				const resolved = binder.resolve(path2);
				let target2 = targets[resolved && resolved.targetPath || null];
				if (!target2 && resolved) {
					target2 = {
						target: resolved,
						// resolved target instance
						value: [],
						// storage for calculated value
						curves: 0,
						// number of curves driving this target
						blendCounter: 0
						// per-frame number of blends (used to identify first blend)
					};
					for (let k = 0; k < target2.target.components; ++k) {
						target2.value.push(0);
					}
					targets[resolved.targetPath] = target2;
					if (binder.animComponent) {
						if (!binder.animComponent.targets[resolved.targetPath]) {
							let type;
							if (resolved.targetPath.substring(resolved.targetPath.length - 13) === "localRotation") {
								type = AnimTargetValue.TYPE_QUAT;
							} else {
								type = AnimTargetValue.TYPE_VEC3;
							}
							binder.animComponent.targets[resolved.targetPath] = new AnimTargetValue(binder.animComponent, type);
						}
						binder.animComponent.targets[resolved.targetPath].layerCounter++;
						binder.animComponent.targets[resolved.targetPath].setMask(binder.layerIndex, 1);
					}
				}
				if (target2) {
					target2.curves++;
					inputs.push(snapshot._results[i2]);
					outputs.push(target2);
				}
			}
		}
		this._clips.push(clip);
		this._inputs.push(inputs);
		this._outputs.push(outputs);
	}
	removeClip(index) {
		const targets = this._targets;
		const binder = this._binder;
		const clips = this._clips;
		const clip = clips[index];
		const curves = clip.track.curves;
		for (let i2 = 0; i2 < curves.length; ++i2) {
			const curve = curves[i2];
			const paths = curve.paths;
			for (let j = 0; j < paths.length; ++j) {
				const path2 = paths[j];
				const target2 = this._binder.resolve(path2);
				if (target2) {
					target2.curves--;
					if (target2.curves === 0) {
						binder.unresolve(path2);
						delete targets[target2.targetPath];
						if (binder.animComponent) {
							binder.animComponent.targets[target2.targetPath].layerCounter--;
						}
					}
				}
			}
		}
		clips.splice(index, 1);
		this._inputs.splice(index, 1);
		this._outputs.splice(index, 1);
	}
	removeClips() {
		while (this._clips.length > 0) {
			this.removeClip(0);
		}
	}
	updateClipTrack(name, animTrack) {
		this._clips.forEach((clip) => {
			if (clip.name.includes(name)) {
				clip.track = animTrack;
			}
		});
		this.rebind();
	}
	findClip(name) {
		const clips = this._clips;
		for (let i2 = 0; i2 < clips.length; ++i2) {
			const clip = clips[i2];
			if (clip.name === name) {
				return clip;
			}
		}
		return null;
	}
	rebind() {
		this._binder.rebind();
		this._targets = {};
		const clips = [...this.clips];
		this.removeClips();
		clips.forEach((clip) => {
			this.addClip(clip);
		});
	}
	assignMask(mask) {
		return this._binder.assignMask(mask);
	}
	update(deltaTime, outputAnimation = true) {
		const clips = this._clips;
		const order = clips.map((c2, i2) => {
			return i2;
		});
		AnimBlend.stableSort(order, (a, b) => {
			return clips[a].blendOrder < clips[b].blendOrder;
		});
		for (let i2 = 0; i2 < order.length; ++i2) {
			const index = order[i2];
			const clip = clips[index];
			const inputs = this._inputs[index];
			const outputs = this._outputs[index];
			const blendWeight = clip.blendWeight;
			if (blendWeight > 0) {
				clip._update(deltaTime);
			}
			if (!outputAnimation) break;
			let input;
			let output;
			let value;
			if (blendWeight >= 1) {
				for (let j = 0; j < inputs.length; ++j) {
					input = inputs[j];
					output = outputs[j];
					value = output.value;
					AnimBlend.set(value, input, output.target.type);
					output.blendCounter++;
				}
			} else if (blendWeight > 0) {
				for (let j = 0; j < inputs.length; ++j) {
					input = inputs[j];
					output = outputs[j];
					value = output.value;
					if (output.blendCounter === 0) {
						AnimBlend.set(value, input, output.target.type);
					} else {
						AnimBlend.blend(value, input, blendWeight, output.target.type);
					}
					output.blendCounter++;
				}
			}
		}
		const targets = this._targets;
		const binder = this._binder;
		for (const path2 in targets) {
			if (targets.hasOwnProperty(path2)) {
				const target2 = targets[path2];
				if (binder.animComponent && target2.target.usesLayerBlending) {
					const animTarget = binder.animComponent.targets[path2];
					if (animTarget.counter === animTarget.layerCounter) {
						animTarget.counter = 0;
					}
					if (!animTarget.path) {
						animTarget.path = path2;
						animTarget.baseValue = target2.target.get();
						animTarget.setter = target2.target.set;
					}
					animTarget.updateValue(binder.layerIndex, target2.value);
					animTarget.counter++;
				} else {
					target2.target.set(target2.value);
				}
				target2.blendCounter = 0;
			}
		}
		this._binder.update(deltaTime);
	}
};

var AnimEvents = class {
	constructor(events) {
		this._events = [...events];
		this._events.sort((a, b) => a.time - b.time);
	}
	get events() {
		return this._events;
	}
};

var AnimTrack = class _AnimTrack {
	static EMPTY = Object.freeze(new _AnimTrack("empty", Number.MAX_VALUE, [], [], []));
	constructor(name, duration, inputs, outputs, curves, animEvents = new AnimEvents([])) {
		this._name = name;
		this._duration = duration;
		this._inputs = inputs;
		this._outputs = outputs;
		this._curves = curves;
		this._animEvents = animEvents;
	}
	get name() {
		return this._name;
	}
	get duration() {
		return this._duration;
	}
	get inputs() {
		return this._inputs;
	}
	get outputs() {
		return this._outputs;
	}
	get curves() {
		return this._curves;
	}
	set events(animEvents) {
		this._animEvents = animEvents;
	}
	get events() {
		return this._animEvents.events;
	}
	// evaluate all track curves at the specified time and store results
	// in the provided snapshot.
	eval(time, snapshot) {
		snapshot._time = time;
		const inputs = this._inputs;
		const outputs = this._outputs;
		const curves = this._curves;
		const cache = snapshot._cache;
		const results = snapshot._results;
		for (let i2 = 0; i2 < inputs.length; ++i2) {
			cache[i2].update(time, inputs[i2]._data);
		}
		for (let i2 = 0; i2 < curves.length; ++i2) {
			const curve = curves[i2];
			const output = outputs[curve._output];
			const result = results[i2];
			cache[curve._input].eval(result, curve._interpolation, output);
		}
	}
};

var AnimBinder = class {
	// join a list of path segments into a path string using the full stop character. If another character is supplied,
	// it will join using that character instead
	static joinPath(pathSegments, character) {
		character = character || ".";
		const escape2 = function(string2) {
			return string2.replace(/\\/g, "\\\\").replace(new RegExp(`\\${character}`, "g"), `\\${character}`);
		};
		return pathSegments.map(escape2).join(character);
	}
	// split a path string into its segments and resolve character escaping
	static splitPath(path2, character) {
		character = character || ".";
		const result = [];
		let curr = "";
		let i2 = 0;
		while (i2 < path2.length) {
			let c2 = path2[i2++];
			if (c2 === "\\" && i2 < path2.length) {
				c2 = path2[i2++];
				if (c2 === "\\" || c2 === character) {
					curr += c2;
				} else {
					curr += `\\${c2}`;
				}
			} else if (c2 === character) {
				result.push(curr);
				curr = "";
			} else {
				curr += c2;
			}
		}
		if (curr.length > 0) {
			result.push(curr);
		}
		return result;
	}
	static encode(entityPath, component, propertyPath) {
		return `${Array.isArray(entityPath) ? entityPath.join("/") : entityPath}/${component}/${Array.isArray(propertyPath) ? propertyPath.join("/") : propertyPath}`;
	}
	resolve(path2) {
		return null;
	}
	unresolve(path2) {
	}
	update(deltaTime) {
	}
};

var AnimTarget = class {
	constructor(func, type, components2, targetPath) {
		if (func.set) {
			this._set = func.set;
			this._get = func.get;
		} else {
			this._set = func;
		}
		this._type = type;
		this._components = components2;
		this._targetPath = targetPath;
		this._isTransform = this._targetPath.substring(this._targetPath.length - 13) === "localRotation" || this._targetPath.substring(this._targetPath.length - 13) === "localPosition" || this._targetPath.substring(this._targetPath.length - 10) === "localScale";
		this._isWeight = this._targetPath.indexOf("weight.") !== -1;
	}
	get set() {
		return this._set;
	}
	get get() {
		return this._get;
	}
	get type() {
		return this._type;
	}
	get components() {
		return this._components;
	}
	get targetPath() {
		return this._targetPath;
	}
	get isTransform() {
		return this._isTransform;
	}
	get isWeight() {
		return this._isWeight;
	}
	get usesLayerBlending() {
		return this._isTransform || this._isWeight;
	}
};

var DefaultAnimBinder = class _DefaultAnimBinder {
	constructor(graph) {
		this.graph = graph;
		if (!graph) return;
		this._mask = null;
		const nodes = {};
		const flatten = function(node) {
			nodes[node.name] = node;
			for (let i2 = 0; i2 < node.children.length; ++i2) {
				flatten(node.children[i2]);
			}
		};
		flatten(graph);
		this.nodes = nodes;
		this.targetCache = {};
		const findMeshInstances = function(node) {
			let object = node;
			while (object && !(object instanceof Entity)) {
				object = object.parent;
			}
			let meshInstances;
			if (object) {
				if (object.render) {
					meshInstances = object.render.meshInstances;
				} else if (object.model) {
					meshInstances = object.model.meshInstances;
				}
			}
			return meshInstances;
		};
		this.nodeCounts = {};
		this.activeNodes = [];
		this.handlers = {
			"localPosition": function(node) {
				const object = node.localPosition;
				const func = function(value) {
					object.set(...value);
				};
				return _DefaultAnimBinder.createAnimTarget(func, "vector", 3, node, "localPosition");
			},
			"localRotation": function(node) {
				const object = node.localRotation;
				const func = function(value) {
					object.set(...value);
				};
				return _DefaultAnimBinder.createAnimTarget(func, "quaternion", 4, node, "localRotation");
			},
			"localScale": function(node) {
				const object = node.localScale;
				const func = function(value) {
					object.set(...value);
				};
				return _DefaultAnimBinder.createAnimTarget(func, "vector", 3, node, "localScale");
			},
			"weight": function(node, weightName) {
				if (weightName.indexOf("name.") === 0) {
					weightName = weightName.replace("name.", "");
				} else {
					weightName = Number(weightName);
				}
				const meshInstances = findMeshInstances(node);
				const instances = [];
				if (meshInstances) {
					for (let i2 = 0; i2 < meshInstances.length; ++i2) {
						if (meshInstances[i2].node.name === node.name && meshInstances[i2].morphInstance) {
							instances.push(meshInstances[i2].morphInstance);
						}
					}
				}
				if (instances.length > 0) {
					const func = {
						set: (value) => {
							for (let i2 = 0; i2 < instances.length; ++i2) {
								instances[i2].setWeight(weightName, value[0]);
							}
						},
						get: () => {
							return [instances[0].getWeight(weightName)];
						}
					};
					return _DefaultAnimBinder.createAnimTarget(func, "number", 1, node, `weight.${weightName}`);
				}
				return null;
			},
			"materialTexture": (node, textureName) => {
				const meshInstances = findMeshInstances(node);
				if (meshInstances) {
					let meshInstance;
					for (let i2 = 0; i2 < meshInstances.length; ++i2) {
						if (meshInstances[i2].node.name === node.name) {
							meshInstance = meshInstances[i2];
							break;
						}
					}
					if (meshInstance) {
						const func = (value) => {
							const textureAsset = this.animComponent.system.app.assets.get(value[0]);
							if (textureAsset && textureAsset.resource && textureAsset.type === "texture") {
								meshInstance.material[textureName] = textureAsset.resource;
								meshInstance.material.update();
							}
						};
						return _DefaultAnimBinder.createAnimTarget(func, "vector", 1, node, "materialTexture", "material");
					}
				}
				return null;
			}
		};
	}
	_isPathInMask = (path2, checkMaskValue) => {
		const maskItem = this._mask[path2];
		if (!maskItem) return false;
		else if (maskItem.children || checkMaskValue && maskItem.value !== false) return true;
		return false;
	};
	_isPathActive(path2) {
		if (!this._mask) return true;
		const rootNodeNames = [path2.entityPath[0], this.graph.name];
		for (let j = 0; j < rootNodeNames.length; ++j) {
			let currEntityPath = rootNodeNames[j];
			if (this._isPathInMask(currEntityPath, path2.entityPath.length === 1)) return true;
			for (let i2 = 1; i2 < path2.entityPath.length; i2++) {
				currEntityPath += `/${path2.entityPath[i2]}`;
				if (this._isPathInMask(currEntityPath, i2 === path2.entityPath.length - 1)) return true;
			}
		}
		return false;
	}
	findNode(path2) {
		if (!this._isPathActive(path2)) {
			return null;
		}
		let node;
		if (this.graph) {
			node = this.graph.findByPath(path2.entityPath);
			if (!node) {
				node = this.graph.findByPath(path2.entityPath.slice(1));
			}
		}
		if (!node) {
			node = this.nodes[path2.entityPath[path2.entityPath.length - 1] || ""];
		}
		return node;
	}
	static createAnimTarget(func, type, valueCount, node, propertyPath, componentType) {
		const targetPath = AnimBinder.encode(node.path, componentType ? componentType : "entity", propertyPath);
		return new AnimTarget(func, type, valueCount, targetPath);
	}
	resolve(path2) {
		const encodedPath = AnimBinder.encode(path2.entityPath, path2.component, path2.propertyPath);
		let target2 = this.targetCache[encodedPath];
		if (target2) return target2;
		const node = this.findNode(path2);
		if (!node) {
			return null;
		}
		const handler = this.handlers[path2.propertyPath];
		if (!handler) {
			return null;
		}
		target2 = handler(node);
		if (!target2) {
			return null;
		}
		this.targetCache[encodedPath] = target2;
		if (!this.nodeCounts[node.path]) {
			this.activeNodes.push(node);
			this.nodeCounts[node.path] = 1;
		} else {
			this.nodeCounts[node.path]++;
		}
		return target2;
	}
	unresolve(path2) {
		if (path2.component !== "graph") {
			return;
		}
		const node = this.nodes[path2.entityPath[path2.entityPath.length - 1] || ""];
		this.nodeCounts[node.path]--;
		if (this.nodeCounts[node.path] === 0) {
			const activeNodes = this.activeNodes;
			const i2 = activeNodes.indexOf(node.node);
			const len = activeNodes.length;
			if (i2 < len - 1) {
				activeNodes[i2] = activeNodes[len - 1];
			}
			activeNodes.pop();
		}
	}
	// flag animating nodes as dirty
	update(deltaTime) {
		const activeNodes = this.activeNodes;
		for (let i2 = 0; i2 < activeNodes.length; ++i2) {
			activeNodes[i2]._dirtifyLocal();
		}
	}
	assignMask(mask) {
		if (mask !== this._mask) {
			this._mask = mask;
			return true;
		}
		return false;
	}
};

var Component = class _Component extends EventHandler {
	static order = 0;
	system;
	entity;
	_enabled = true;
	constructor(system, entity) {
		super();
		this.system = system;
		this.entity = entity;
		if (this.system.schema?.length && !this._accessorsBuilt) {
			this.buildAccessors(this.system.schema);
		}
		this.on("set", function(name, oldValue, newValue) {
			this.fire(`set_${name}`, name, oldValue, newValue);
		});
		this.on("set_enabled", this.onSetEnabled, this);
	}
	static _buildAccessors(obj, schema) {
		schema.forEach((descriptor) => {
			const name = typeof descriptor === "object" ? descriptor.name : descriptor;
			Object.defineProperty(obj, name, {
				get: function() {
					return this.data[name];
				},
				set: function(value) {
					const data2 = this.data;
					const oldValue = data2[name];
					data2[name] = value;
					this.fire("set", name, oldValue, value);
				},
				configurable: true
			});
		});
		obj._accessorsBuilt = true;
	}
	buildAccessors(schema) {
		_Component._buildAccessors(this, schema);
	}
	onSetEnabled(name, oldValue, newValue) {
		if (oldValue !== newValue) {
			if (this.entity.enabled) {
				if (newValue) {
					this.onEnable();
				} else {
					this.onDisable();
				}
			}
		}
	}
	onEnable() {
	}
	onDisable() {
	}
	onPostStateChange() {
	}
	get data() {
		const record = this.system.store[this.entity.guid];
		return record ? record.data : null;
	}
	set enabled(value) {
		const oldValue = this._enabled;
		this._enabled = value;
		this.fire("set", "enabled", oldValue, value);
	}
	get enabled() {
		return this._enabled;
	}
};

var AnimationComponent = class extends Component {
	_animations = {};
	_assets = [];
	_loop = true;
	animEvaluator = null;
	model = null;
	skeleton = null;
	fromSkel = null;
	toSkel = null;
	animationsIndex = {};
	prevAnim = null;
	currAnim = null;
	blend = 0;
	blending = false;
	blendSpeed = 0;
	activate = true;
	speed = 1;
	set animations(value) {
		this._animations = value;
		this.onSetAnimations();
	}
	get animations() {
		return this._animations;
	}
	set assets(value) {
		const assets = this._assets;
		if (assets && assets.length) {
			for (let i2 = 0; i2 < assets.length; i2++) {
				if (assets[i2]) {
					const asset = this.system.app.assets.get(assets[i2]);
					if (asset) {
						asset.off("change", this.onAssetChanged, this);
						asset.off("remove", this.onAssetRemoved, this);
						const animName = this.animationsIndex[asset.id];
						if (this.currAnim === animName) {
							this._stopCurrentAnimation();
						}
						delete this.animations[animName];
						delete this.animationsIndex[asset.id];
					}
				}
			}
		}
		this._assets = value;
		const assetIds = value.map((value2) => {
			return value2 instanceof Asset ? value2.id : value2;
		});
		this.loadAnimationAssets(assetIds);
	}
	get assets() {
		return this._assets;
	}
	set currentTime(currentTime) {
		if (this.skeleton) {
			this.skeleton.currentTime = currentTime;
			this.skeleton.addTime(0);
			this.skeleton.updateGraph();
		}
		if (this.animEvaluator) {
			const clips = this.animEvaluator.clips;
			for (let i2 = 0; i2 < clips.length; ++i2) {
				clips[i2].time = currentTime;
			}
		}
	}
	get currentTime() {
		if (this.skeleton) {
			return this.skeleton._time;
		}
		if (this.animEvaluator) {
			const clips = this.animEvaluator.clips;
			if (clips.length > 0) {
				return clips[clips.length - 1].time;
			}
		}
		return 0;
	}
	get duration() {
		if (this.currAnim) {
			return this.animations[this.currAnim].duration;
		}
		return 0;
	}
	set loop(value) {
		this._loop = value;
		if (this.skeleton) {
			this.skeleton.looping = value;
		}
		if (this.animEvaluator) {
			for (let i2 = 0; i2 < this.animEvaluator.clips.length; ++i2) {
				this.animEvaluator.clips[i2].loop = value;
			}
		}
	}
	get loop() {
		return this._loop;
	}
	play(name, blendTime = 0) {
		if (!this.enabled || !this.entity.enabled) {
			return;
		}
		if (!this.animations[name]) {
			return;
		}
		this.prevAnim = this.currAnim;
		this.currAnim = name;
		if (this.model) {
			if (!this.skeleton && !this.animEvaluator) {
				this._createAnimationController();
			}
			const prevAnim = this.animations[this.prevAnim];
			const currAnim = this.animations[this.currAnim];
			this.blending = blendTime > 0 && !!this.prevAnim;
			if (this.blending) {
				this.blend = 0;
				this.blendSpeed = 1 / blendTime;
			}
			if (this.skeleton) {
				if (this.blending) {
					this.fromSkel.animation = prevAnim;
					this.fromSkel.addTime(this.skeleton._time);
					this.toSkel.animation = currAnim;
				} else {
					this.skeleton.animation = currAnim;
				}
			}
			if (this.animEvaluator) {
				const animEvaluator = this.animEvaluator;
				if (this.blending) {
					while (animEvaluator.clips.length > 1) {
						animEvaluator.removeClip(0);
					}
				} else {
					this.animEvaluator.removeClips();
				}
				const clip = new AnimClip(this.animations[this.currAnim], 0, 1, true, this.loop, this);
				clip.name = this.currAnim;
				clip.blendWeight = this.blending ? 0 : 1;
				clip.reset();
				this.animEvaluator.addClip(clip);
			}
		}
		this.playing = true;
	}
	getAnimation(name) {
		return this.animations[name];
	}
	setModel(model) {
		if (model !== this.model) {
			this._resetAnimationController();
			this.model = model;
			if (this.animations && this.currAnim && this.animations[this.currAnim]) {
				this.play(this.currAnim);
			}
		}
	}
	onSetAnimations() {
		const modelComponent = this.entity.model;
		if (modelComponent) {
			const m = modelComponent.model;
			if (m && m !== this.model) {
				this.setModel(m);
			}
		}
		if (!this.currAnim && this.activate && this.enabled && this.entity.enabled) {
			const animationNames = Object.keys(this._animations);
			if (animationNames.length > 0) {
				this.play(animationNames[0]);
			}
		}
	}
	_resetAnimationController() {
		this.skeleton = null;
		this.fromSkel = null;
		this.toSkel = null;
		this.animEvaluator = null;
	}
	_createAnimationController() {
		const model = this.model;
		const animations = this.animations;
		let hasJson = false;
		let hasGlb = false;
		for (const animation in animations) {
			if (animations.hasOwnProperty(animation)) {
				const anim = animations[animation];
				if (anim.constructor === AnimTrack) {
					hasGlb = true;
				} else {
					hasJson = true;
				}
			}
		}
		const graph = model.getGraph();
		if (hasJson) {
			this.fromSkel = new Skeleton(graph);
			this.toSkel = new Skeleton(graph);
			this.skeleton = new Skeleton(graph);
			this.skeleton.looping = this.loop;
			this.skeleton.setGraph(graph);
		} else if (hasGlb) {
			this.animEvaluator = new AnimEvaluator(new DefaultAnimBinder(this.entity));
		}
	}
	loadAnimationAssets(ids3) {
		if (!ids3 || !ids3.length) {
			return;
		}
		const assets = this.system.app.assets;
		const onAssetReady = (asset) => {
			if (asset.resources.length > 1) {
				for (let i2 = 0; i2 < asset.resources.length; i2++) {
					this.animations[asset.resources[i2].name] = asset.resources[i2];
					this.animationsIndex[asset.id] = asset.resources[i2].name;
				}
			} else {
				this.animations[asset.name] = asset.resource;
				this.animationsIndex[asset.id] = asset.name;
			}
			this.animations = this.animations;
		};
		const onAssetAdd = (asset) => {
			asset.off("change", this.onAssetChanged, this);
			asset.on("change", this.onAssetChanged, this);
			asset.off("remove", this.onAssetRemoved, this);
			asset.on("remove", this.onAssetRemoved, this);
			if (asset.resource) {
				onAssetReady(asset);
			} else {
				asset.once("load", onAssetReady, this);
				if (this.enabled && this.entity.enabled) {
					assets.load(asset);
				}
			}
		};
		for (let i2 = 0, l = ids3.length; i2 < l; i2++) {
			const asset = assets.get(ids3[i2]);
			if (asset) {
				onAssetAdd(asset);
			} else {
				assets.on(`add:${ids3[i2]}`, onAssetAdd);
			}
		}
	}
	onAssetChanged(asset, attribute, newValue, oldValue) {
		if (attribute === "resource" || attribute === "resources") {
			if (attribute === "resources" && newValue && newValue.length === 0) {
				newValue = null;
			}
			if (newValue) {
				let restarted = false;
				if (newValue.length > 1) {
					if (oldValue && oldValue.length > 1) {
						for (let i2 = 0; i2 < oldValue.length; i2++) {
							delete this.animations[oldValue[i2].name];
						}
					} else {
						delete this.animations[asset.name];
					}
					restarted = false;
					for (let i2 = 0; i2 < newValue.length; i2++) {
						this.animations[newValue[i2].name] = newValue[i2];
						if (!restarted && this.currAnim === newValue[i2].name) {
							if (this.playing && this.enabled && this.entity.enabled) {
								restarted = true;
								this.play(newValue[i2].name);
							}
						}
					}
					if (!restarted) {
						this._stopCurrentAnimation();
						this.onSetAnimations();
					}
				} else {
					if (oldValue && oldValue.length > 1) {
						for (let i2 = 0; i2 < oldValue.length; i2++) {
							delete this.animations[oldValue[i2].name];
						}
					}
					this.animations[asset.name] = newValue[0] || newValue;
					restarted = false;
					if (this.currAnim === asset.name) {
						if (this.playing && this.enabled && this.entity.enabled) {
							restarted = true;
							this.play(asset.name);
						}
					}
					if (!restarted) {
						this._stopCurrentAnimation();
						this.onSetAnimations();
					}
				}
				this.animationsIndex[asset.id] = asset.name;
			} else {
				if (oldValue.length > 1) {
					for (let i2 = 0; i2 < oldValue.length; i2++) {
						delete this.animations[oldValue[i2].name];
						if (this.currAnim === oldValue[i2].name) {
							this._stopCurrentAnimation();
						}
					}
				} else {
					delete this.animations[asset.name];
					if (this.currAnim === asset.name) {
						this._stopCurrentAnimation();
					}
				}
				delete this.animationsIndex[asset.id];
			}
		}
	}
	onAssetRemoved(asset) {
		asset.off("remove", this.onAssetRemoved, this);
		if (this.animations) {
			if (asset.resources.length > 1) {
				for (let i2 = 0; i2 < asset.resources.length; i2++) {
					delete this.animations[asset.resources[i2].name];
					if (this.currAnim === asset.resources[i2].name) {
						this._stopCurrentAnimation();
					}
				}
			} else {
				delete this.animations[asset.name];
				if (this.currAnim === asset.name) {
					this._stopCurrentAnimation();
				}
			}
			delete this.animationsIndex[asset.id];
		}
	}
	_stopCurrentAnimation() {
		this.currAnim = null;
		this.playing = false;
		if (this.skeleton) {
			this.skeleton.currentTime = 0;
			this.skeleton.animation = null;
		}
		if (this.animEvaluator) {
			for (let i2 = 0; i2 < this.animEvaluator.clips.length; ++i2) {
				this.animEvaluator.clips[i2].stop();
			}
			this.animEvaluator.update(0);
			this.animEvaluator.removeClips();
		}
	}
	onEnable() {
		super.onEnable();
		const assets = this.assets;
		const registry = this.system.app.assets;
		if (assets) {
			for (let i2 = 0, len = assets.length; i2 < len; i2++) {
				let asset = assets[i2];
				if (!(asset instanceof Asset)) {
					asset = registry.get(asset);
				}
				if (asset && !asset.resource) {
					registry.load(asset);
				}
			}
		}
		if (this.activate && !this.currAnim) {
			const animationNames = Object.keys(this.animations);
			if (animationNames.length > 0) {
				this.play(animationNames[0]);
			}
		}
	}
	onBeforeRemove() {
		for (let i2 = 0; i2 < this.assets.length; i2++) {
			let asset = this.assets[i2];
			if (typeof asset === "number") {
				asset = this.system.app.assets.get(asset);
			}
			if (!asset) continue;
			asset.off("change", this.onAssetChanged, this);
			asset.off("remove", this.onAssetRemoved, this);
		}
		this.skeleton = null;
		this.fromSkel = null;
		this.toSkel = null;
		this.animEvaluator = null;
	}
	update(dt) {
		if (this.blending) {
			this.blend += dt * this.blendSpeed;
			if (this.blend >= 1) {
				this.blend = 1;
			}
		}
		if (this.playing) {
			const skeleton = this.skeleton;
			if (skeleton !== null && this.model !== null) {
				if (this.blending) {
					skeleton.blend(this.fromSkel, this.toSkel, this.blend);
				} else {
					const delta3 = dt * this.speed;
					skeleton.addTime(delta3);
					if (this.speed > 0 && skeleton._time === skeleton.animation.duration && !this.loop) {
						this.playing = false;
					} else if (this.speed < 0 && skeleton._time === 0 && !this.loop) {
						this.playing = false;
					}
				}
				if (this.blending && this.blend === 1) {
					skeleton.animation = this.toSkel.animation;
				}
				skeleton.updateGraph();
			}
		}
		const animEvaluator = this.animEvaluator;
		if (animEvaluator) {
			for (let i2 = 0; i2 < animEvaluator.clips.length; ++i2) {
				const clip = animEvaluator.clips[i2];
				clip.speed = this.speed;
				if (!this.playing) {
					clip.pause();
				} else {
					clip.resume();
				}
			}
			if (this.blending && animEvaluator.clips.length > 1) {
				animEvaluator.clips[1].blendWeight = this.blend;
			}
			animEvaluator.update(dt);
		}
		if (this.blending && this.blend === 1) {
			this.blending = false;
		}
	}
};

var _properties = ["activate", "enabled", "loop", "speed", "assets"];
var AnimationComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "animation";
		this.ComponentType = AnimationComponent;
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.systems.on("update", this.onUpdate, this);
	}
	initializeComponentData(component, data2) {
		for (const property of _properties) {
			if (data2.hasOwnProperty(property)) {
				component[property] = data2[property];
			}
		}
		super.initializeComponentData(component, data2);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.animation;
		const data2 = {};
		for (const property of _properties) {
			data2[property] = property === "assets" ? c2.assets.slice() : c2[property];
		}
		const component = this.addComponent(clone, data2);
		const clonedAnimations = {};
		const animations = c2.animations;
		for (const key in animations) {
			if (animations.hasOwnProperty(key)) {
				clonedAnimations[key] = animations[key];
			}
		}
		component.animations = clonedAnimations;
		const clonedAnimationsIndex = {};
		const animationsIndex = c2.animationsIndex;
		for (const key in animationsIndex) {
			if (animationsIndex.hasOwnProperty(key)) {
				clonedAnimationsIndex[key] = animationsIndex[key];
			}
		}
		component.animationsIndex = clonedAnimationsIndex;
		return component;
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	onUpdate(dt) {
		const components2 = this.store;
		for (const id14 in components2) {
			if (components2.hasOwnProperty(id14)) {
				const { entity } = components2[id14];
				if (entity.animation.enabled && entity.enabled) {
					entity.animation.update(dt);
				}
			}
		}
	}
	destroy() {
		super.destroy();
		this.app.systems.off("update", this.onUpdate, this);
	}
};

var AnimNode = class {
	constructor(state, parent, name, point5, speed = 1) {
		this._state = state;
		this._parent = parent;
		this._name = name;
		if (Array.isArray(point5)) {
			this._point = new Vec2(point5[0], point5[1]);
			this._pointLength = this._point.length();
		} else {
			this._point = point5;
			this._pointLength = point5;
		}
		this._speed = speed;
		this._weightedSpeed = 1;
		this._weight = 1;
		this._animTrack = null;
	}
	get parent() {
		return this._parent;
	}
	get name() {
		return this._name;
	}
	get path() {
		return this._parent ? `${this._parent.path}.${this._name}` : this._name;
	}
	get point() {
		return this._point;
	}
	get pointLength() {
		return this._pointLength;
	}
	set weight(value) {
		this._weight = value;
	}
	get weight() {
		return this._parent ? this._parent.weight * this._weight : this._weight;
	}
	get normalizedWeight() {
		const totalWeight = this._state.totalWeight;
		if (totalWeight === 0) return 0;
		return this.weight / totalWeight;
	}
	get speed() {
		return this._weightedSpeed * this._speed;
	}
	get absoluteSpeed() {
		return Math.abs(this._speed);
	}
	set weightedSpeed(weightedSpeed) {
		this._weightedSpeed = weightedSpeed;
	}
	get weightedSpeed() {
		return this._weightedSpeed;
	}
	set animTrack(value) {
		this._animTrack = value;
	}
	get animTrack() {
		return this._animTrack;
	}
};

var AnimBlendTree = class _AnimBlendTree extends AnimNode {
	constructor(state, parent, name, point5, parameters, children, syncAnimations, createTree, findParameter) {
		super(state, parent, name, point5);
		this._parameters = parameters;
		this._parameterValues = new Array(parameters.length);
		this._children = [];
		this._findParameter = findParameter;
		this._syncAnimations = syncAnimations !== false;
		this._pointCache = {};
		for (let i2 = 0; i2 < children.length; i2++) {
			const child = children[i2];
			if (child.children) {
				this._children.push(createTree(
					child.type,
					state,
					this,
					child.name,
					1,
					child.parameter ? [child.parameter] : child.parameters,
					child.children,
					child.syncAnimations,
					createTree,
					findParameter
				));
			} else {
				this._children.push(new AnimNode(state, this, child.name, child.point, child.speed));
			}
		}
	}
	get weight() {
		this.calculateWeights();
		return this._parent ? this._parent.weight * this._weight : this._weight;
	}
	get syncAnimations() {
		return this._syncAnimations;
	}
	getChild(name) {
		for (let i2 = 0; i2 < this._children.length; i2++) {
			if (this._children[i2].name === name) return this._children[i2];
		}
		return null;
	}
	updateParameterValues() {
		let paramsEqual = true;
		for (let i2 = 0; i2 < this._parameterValues.length; i2++) {
			const updatedParameter = this._findParameter(this._parameters[i2]).value;
			if (this._parameterValues[i2] !== updatedParameter) {
				this._parameterValues[i2] = updatedParameter;
				paramsEqual = false;
			}
		}
		return paramsEqual;
	}
	getNodeWeightedDuration(i2) {
		return this._children[i2].animTrack.duration / this._children[i2].speedMultiplier * this._children[i2].weight;
	}
	getNodeCount() {
		let count = 0;
		for (let i2 = 0; i2 < this._children.length; i2++) {
			const child = this._children[i2];
			if (child.constructor === _AnimBlendTree) {
				count += this._children[i2].getNodeCount();
			} else {
				count++;
			}
		}
		return count;
	}
};

var AnimBlendTree1D = class extends AnimBlendTree {
	constructor(state, parent, name, point5, parameters, children, syncAnimations, createTree, findParameter) {
		children.sort((a, b) => a.point - b.point);
		super(state, parent, name, point5, parameters, children, syncAnimations, createTree, findParameter);
	}
	calculateWeights() {
		if (this.updateParameterValues()) return;
		let weightedDurationSum = 0;
		this._children[0].weight = 0;
		for (let i2 = 0; i2 < this._children.length; i2++) {
			const c1 = this._children[i2];
			if (i2 !== this._children.length - 1) {
				const c2 = this._children[i2 + 1];
				if (c1.point === c2.point) {
					c1.weight = 0.5;
					c2.weight = 0.5;
				} else if (math.between(this._parameterValues[0], c1.point, c2.point, true)) {
					const child2Distance = Math.abs(c1.point - c2.point);
					const parameterDistance = Math.abs(c1.point - this._parameterValues[0]);
					const weight = (child2Distance - parameterDistance) / child2Distance;
					c1.weight = weight;
					c2.weight = 1 - weight;
				} else {
					c2.weight = 0;
				}
			}
			if (this._syncAnimations) {
				weightedDurationSum += c1.animTrack.duration / c1.absoluteSpeed * c1.weight;
			}
		}
		if (this._syncAnimations) {
			for (let i2 = 0; i2 < this._children.length; i2++) {
				const child = this._children[i2];
				child.weightedSpeed = child.animTrack.duration / child.absoluteSpeed / weightedDurationSum;
			}
		}
	}
};

var AnimBlendTreeCartesian2D = class _AnimBlendTreeCartesian2D extends AnimBlendTree {
	static _p = new Vec2();
	static _pip = new Vec2();
	pointDistanceCache(i2, j) {
		const pointKey = `${i2}${j}`;
		if (!this._pointCache[pointKey]) {
			this._pointCache[pointKey] = this._children[j].point.clone().sub(this._children[i2].point);
		}
		return this._pointCache[pointKey];
	}
	calculateWeights() {
		if (this.updateParameterValues()) return;
		let weightSum, weightedDurationSum;
		_AnimBlendTreeCartesian2D._p.set(...this._parameterValues);
		weightSum = 0;
		weightedDurationSum = 0;
		for (let i2 = 0; i2 < this._children.length; i2++) {
			const child = this._children[i2];
			const pi = child.point;
			_AnimBlendTreeCartesian2D._pip.set(_AnimBlendTreeCartesian2D._p.x, _AnimBlendTreeCartesian2D._p.y).sub(pi);
			let minj = Number.MAX_VALUE;
			for (let j = 0; j < this._children.length; j++) {
				if (i2 === j) continue;
				const pipj = this.pointDistanceCache(i2, j);
				const result = math.clamp(1 - _AnimBlendTreeCartesian2D._pip.dot(pipj) / pipj.lengthSq(), 0, 1);
				if (result < minj) minj = result;
			}
			child.weight = minj;
			weightSum += minj;
			if (this._syncAnimations) {
				weightedDurationSum += child.animTrack.duration / child.absoluteSpeed * child.weight;
			}
		}
		for (let i2 = 0; i2 < this._children.length; i2++) {
			const child = this._children[i2];
			child.weight = child._weight / weightSum;
			if (this._syncAnimations) {
				child.weightedSpeed = child.animTrack.duration / child.absoluteSpeed / weightedDurationSum;
			}
		}
	}
};

var AnimBlendTreeDirectional2D = class _AnimBlendTreeDirectional2D extends AnimBlendTree {
	static _p = new Vec2();
	static _pip = new Vec2();
	pointCache(i2, j) {
		const pointKey = `${i2}${j}`;
		if (!this._pointCache[pointKey]) {
			this._pointCache[pointKey] = new Vec2(
				(this._children[j].pointLength - this._children[i2].pointLength) / ((this._children[j].pointLength + this._children[i2].pointLength) / 2),
				Vec2.angleRad(this._children[i2].point, this._children[j].point) * 2
			);
		}
		return this._pointCache[pointKey];
	}
	calculateWeights() {
		if (this.updateParameterValues()) return;
		let weightSum, weightedDurationSum;
		_AnimBlendTreeDirectional2D._p.set(...this._parameterValues);
		const pLength = _AnimBlendTreeDirectional2D._p.length();
		weightSum = 0;
		weightedDurationSum = 0;
		for (let i2 = 0; i2 < this._children.length; i2++) {
			const child = this._children[i2];
			const pi = child.point;
			const piLength = child.pointLength;
			let minj = Number.MAX_VALUE;
			for (let j = 0; j < this._children.length; j++) {
				if (i2 === j) continue;
				const pipj = this.pointCache(i2, j);
				const pjLength = this._children[j].pointLength;
				_AnimBlendTreeDirectional2D._pip.set((pLength - piLength) / ((pjLength + piLength) / 2), Vec2.angleRad(pi, _AnimBlendTreeDirectional2D._p) * 2);
				const result = math.clamp(1 - Math.abs(_AnimBlendTreeDirectional2D._pip.dot(pipj) / pipj.lengthSq()), 0, 1);
				if (result < minj) minj = result;
			}
			child.weight = minj;
			weightSum += minj;
			if (this._syncAnimations) {
				weightedDurationSum += child.animTrack.duration / child.absoluteSpeed * child.weight;
			}
		}
		for (let i2 = 0; i2 < this._children.length; i2++) {
			const child = this._children[i2];
			child.weight = child._weight / weightSum;
			if (this._syncAnimations) {
				const weightedChildDuration = child.animTrack.duration / weightedDurationSum * weightSum;
				child.weightedSpeed = child.absoluteSpeed * weightedChildDuration;
			}
		}
	}
};

var AnimBlendTreeDirect = class extends AnimBlendTree {
	calculateWeights() {
		if (this.updateParameterValues()) return;
		let weightSum = 0;
		let weightedDurationSum = 0;
		for (let i2 = 0; i2 < this._children.length; i2++) {
			weightSum += Math.max(this._parameterValues[i2], 0);
			if (this._syncAnimations) {
				const child = this._children[i2];
				weightedDurationSum += child.animTrack.duration / child.absoluteSpeed * child.weight;
			}
		}
		for (let i2 = 0; i2 < this._children.length; i2++) {
			const child = this._children[i2];
			const weight = Math.max(this._parameterValues[i2], 0);
			if (weightSum) {
				child.weight = weight / weightSum;
				if (this._syncAnimations) {
					child.weightedSpeed = child.animTrack.duration / child.absoluteSpeed / weightedDurationSum;
				}
			} else {
				child.weight = 0;
				if (this._syncAnimations) {
					child.weightedSpeed = 0;
				}
			}
		}
	}
};

var AnimState = class {
	_animations = {};
	_animationList = [];
	constructor(controller, name, speed = 1, loop = true, blendTree) {
		this._controller = controller;
		this._name = name;
		this._speed = speed;
		this._loop = loop;
		this._hasAnimations = false;
		if (blendTree) {
			this._blendTree = this._createTree(
				blendTree.type,
				this,
				null,
				name,
				1,
				blendTree.parameter ? [blendTree.parameter] : blendTree.parameters,
				blendTree.children,
				blendTree.syncAnimations,
				this._createTree,
				this._controller.findParameter
			);
		} else {
			this._blendTree = new AnimNode(this, null, name, 1, speed);
		}
	}
	_createTree(type, state, parent, name, point5, parameters, children, syncAnimations, createTree, findParameter) {
		switch (type) {
			case ANIM_BLEND_1D:
				return new AnimBlendTree1D(state, parent, name, point5, parameters, children, syncAnimations, createTree, findParameter);
			case ANIM_BLEND_2D_CARTESIAN:
				return new AnimBlendTreeCartesian2D(state, parent, name, point5, parameters, children, syncAnimations, createTree, findParameter);
			case ANIM_BLEND_2D_DIRECTIONAL:
				return new AnimBlendTreeDirectional2D(state, parent, name, point5, parameters, children, syncAnimations, createTree, findParameter);
			case ANIM_BLEND_DIRECT:
				return new AnimBlendTreeDirect(state, parent, name, point5, parameters, children, syncAnimations, createTree, findParameter);
		}
		return void 0;
	}
	_getNodeFromPath(path2) {
		let currNode = this._blendTree;
		for (let i2 = 1; i2 < path2.length; i2++) {
			currNode = currNode.getChild(path2[i2]);
		}
		return currNode;
	}
	addAnimation(path2, animTrack) {
		const pathString = path2.join(".");
		const indexOfAnimation = this._animationList.findIndex((animation) => {
			return animation.path === pathString;
		});
		if (indexOfAnimation >= 0) {
			this._animationList[indexOfAnimation].animTrack = animTrack;
		} else {
			const node = this._getNodeFromPath(path2);
			node.animTrack = animTrack;
			this._animationList.push(node);
		}
		this._updateHasAnimations();
	}
	_updateHasAnimations() {
		this._hasAnimations = this._animationList.length > 0 && this._animationList.every((animation) => animation.animTrack && animation.animTrack !== AnimTrack.EMPTY);
	}
	get name() {
		return this._name;
	}
	set animations(value) {
		this._animationList = value;
		this._updateHasAnimations();
	}
	get animations() {
		return this._animationList;
	}
	get hasAnimations() {
		return this._hasAnimations;
	}
	set speed(value) {
		this._speed = value;
	}
	get speed() {
		return this._speed;
	}
	set loop(value) {
		this._loop = value;
	}
	get loop() {
		return this._loop;
	}
	get nodeCount() {
		if (!this._blendTree || this._blendTree.constructor === AnimNode) return 1;
		return this._blendTree.getNodeCount();
	}
	get playable() {
		return ANIM_CONTROL_STATES.indexOf(this.name) !== -1 || this.animations.length === this.nodeCount;
	}
	get looping() {
		if (this.animations.length > 0) {
			const trackClipName = `${this.name}.${this.animations[0].animTrack.name}`;
			const trackClip = this._controller.animEvaluator.findClip(trackClipName);
			if (trackClip) {
				return trackClip.loop;
			}
		}
		return false;
	}
	get totalWeight() {
		let sum = 0;
		for (let i2 = 0; i2 < this.animations.length; i2++) {
			sum += this.animations[i2].weight;
		}
		return sum;
	}
	get timelineDuration() {
		let duration = 0;
		for (let i2 = 0; i2 < this.animations.length; i2++) {
			const animation = this.animations[i2];
			if (animation.animTrack.duration > duration) {
				duration = animation.animTrack.duration;
			}
		}
		return duration;
	}
};

var AnimTransition = class {
	constructor({ from, to, time = 0, priority = 0, conditions = [], exitTime = null, transitionOffset = null, interruptionSource = ANIM_INTERRUPTION_NONE }) {
		this._from = from;
		this._to = to;
		this._time = time;
		this._priority = priority;
		this._conditions = conditions;
		this._exitTime = exitTime;
		this._transitionOffset = transitionOffset;
		this._interruptionSource = interruptionSource;
	}
	get from() {
		return this._from;
	}
	set to(value) {
		this._to = value;
	}
	get to() {
		return this._to;
	}
	get time() {
		return this._time;
	}
	get priority() {
		return this._priority;
	}
	get conditions() {
		return this._conditions;
	}
	get exitTime() {
		return this._exitTime;
	}
	get transitionOffset() {
		return this._transitionOffset;
	}
	get interruptionSource() {
		return this._interruptionSource;
	}
	get hasExitTime() {
		return !!this.exitTime;
	}
};

var AnimController = class {
	_states = {};
	_stateNames = [];
	_findTransitionsFromStateCache = {};
	_findTransitionsBetweenStatesCache = {};
	_previousStateName = null;
	_activeStateName = ANIM_STATE_START;
	_activeStateDuration = 0;
	_activeStateDurationDirty = true;
	_playing = false;
	_activate;
	_transitions;
	_currTransitionTime = 1;
	_totalTransitionTime = 1;
	_isTransitioning = false;
	_transitionInterruptionSource = ANIM_INTERRUPTION_NONE;
	_transitionPreviousStates = [];
	_timeInState = 0;
	_timeInStateBefore = 0;
	constructor(animEvaluator, states, transitions, activate, eventHandler, findParameter, consumeTrigger) {
		this._animEvaluator = animEvaluator;
		this._eventHandler = eventHandler;
		this._findParameter = findParameter;
		this._consumeTrigger = consumeTrigger;
		for (let i2 = 0; i2 < states.length; i2++) {
			this._states[states[i2].name] = new AnimState(
				this,
				states[i2].name,
				states[i2].speed,
				states[i2].loop,
				states[i2].blendTree
			);
			this._stateNames.push(states[i2].name);
		}
		this._transitions = transitions.map((transition) => {
			return new AnimTransition({
				...transition
			});
		});
		this._activate = activate;
	}
	get animEvaluator() {
		return this._animEvaluator;
	}
	set activeState(stateName) {
		this._activeStateName = stateName;
	}
	get activeState() {
		return this._findState(this._activeStateName);
	}
	get activeStateName() {
		return this._activeStateName;
	}
	get activeStateAnimations() {
		return this.activeState.animations;
	}
	set previousState(stateName) {
		this._previousStateName = stateName;
	}
	get previousState() {
		return this._findState(this._previousStateName);
	}
	get previousStateName() {
		return this._previousStateName;
	}
	get playable() {
		let playable = true;
		for (let i2 = 0; i2 < this._stateNames.length; i2++) {
			if (!this._states[this._stateNames[i2]].playable) {
				playable = false;
			}
		}
		return playable;
	}
	set playing(value) {
		this._playing = value;
	}
	get playing() {
		return this._playing;
	}
	get activeStateProgress() {
		return this._getActiveStateProgressForTime(this._timeInState);
	}
	get activeStateDuration() {
		if (this._activeStateDurationDirty) {
			let maxDuration = 0;
			for (let i2 = 0; i2 < this.activeStateAnimations.length; i2++) {
				const activeClip = this._animEvaluator.findClip(this.activeStateAnimations[i2].name);
				if (activeClip) {
					maxDuration = Math.max(maxDuration, activeClip.track.duration);
				}
			}
			this._activeStateDuration = maxDuration;
			this._activeStateDurationDirty = false;
		}
		return this._activeStateDuration;
	}
	set activeStateCurrentTime(time) {
		this._timeInStateBefore = time;
		this._timeInState = time;
		for (let i2 = 0; i2 < this.activeStateAnimations.length; i2++) {
			const clip = this.animEvaluator.findClip(this.activeStateAnimations[i2].name);
			if (clip) {
				clip.time = time;
			}
		}
	}
	get activeStateCurrentTime() {
		return this._timeInState;
	}
	get transitioning() {
		return this._isTransitioning;
	}
	get transitionProgress() {
		return this._currTransitionTime / this._totalTransitionTime;
	}
	get states() {
		return this._stateNames;
	}
	assignMask(mask) {
		return this._animEvaluator.assignMask(mask);
	}
	_findState(stateName) {
		return this._states[stateName];
	}
	_getActiveStateProgressForTime(time) {
		if (this.activeStateName === ANIM_STATE_START || this.activeStateName === ANIM_STATE_END || this.activeStateName === ANIM_STATE_ANY) {
			return 1;
		}
		const activeClip = this._animEvaluator.findClip(this.activeStateAnimations[0].name);
		if (activeClip) {
			return activeClip.progressForTime(time);
		}
		return null;
	}
	_findTransitionsFromState(stateName) {
		let transitions = this._findTransitionsFromStateCache[stateName];
		if (!transitions) {
			transitions = this._transitions.filter((transition) => {
				return transition.from === stateName;
			});
			sortPriority(transitions);
			this._findTransitionsFromStateCache[stateName] = transitions;
		}
		return transitions;
	}
	_findTransitionsBetweenStates(sourceStateName, destinationStateName) {
		let transitions = this._findTransitionsBetweenStatesCache[`${sourceStateName}->${destinationStateName}`];
		if (!transitions) {
			transitions = this._transitions.filter((transition) => {
				return transition.from === sourceStateName && transition.to === destinationStateName;
			});
			sortPriority(transitions);
			this._findTransitionsBetweenStatesCache[`${sourceStateName}->${destinationStateName}`] = transitions;
		}
		return transitions;
	}
	_transitionHasConditionsMet(transition) {
		const conditions = transition.conditions;
		for (let i2 = 0; i2 < conditions.length; i2++) {
			const condition = conditions[i2];
			const parameter = this._findParameter(condition.parameterName);
			switch (condition.predicate) {
				case ANIM_GREATER_THAN:
					if (!(parameter.value > condition.value)) return false;
					break;
				case ANIM_LESS_THAN:
					if (!(parameter.value < condition.value)) return false;
					break;
				case ANIM_GREATER_THAN_EQUAL_TO:
					if (!(parameter.value >= condition.value)) return false;
					break;
				case ANIM_LESS_THAN_EQUAL_TO:
					if (!(parameter.value <= condition.value)) return false;
					break;
				case ANIM_EQUAL_TO:
					if (!(parameter.value === condition.value)) return false;
					break;
				case ANIM_NOT_EQUAL_TO:
					if (!(parameter.value !== condition.value)) return false;
					break;
			}
		}
		return true;
	}
	_findTransition(from, to) {
		let transitions = [];
		if (from && to) {
			transitions = transitions.concat(this._findTransitionsBetweenStates(from, to));
		} else {
			if (!this._isTransitioning) {
				transitions = transitions.concat(this._findTransitionsFromState(this._activeStateName));
				transitions = transitions.concat(this._findTransitionsFromState(ANIM_STATE_ANY));
			} else {
				switch (this._transitionInterruptionSource) {
					case ANIM_INTERRUPTION_PREV:
						transitions = transitions.concat(this._findTransitionsFromState(this._previousStateName));
						transitions = transitions.concat(this._findTransitionsFromState(ANIM_STATE_ANY));
						break;
					case ANIM_INTERRUPTION_NEXT:
						transitions = transitions.concat(this._findTransitionsFromState(this._activeStateName));
						transitions = transitions.concat(this._findTransitionsFromState(ANIM_STATE_ANY));
						break;
					case ANIM_INTERRUPTION_PREV_NEXT:
						transitions = transitions.concat(this._findTransitionsFromState(this._previousStateName));
						transitions = transitions.concat(this._findTransitionsFromState(this._activeStateName));
						transitions = transitions.concat(this._findTransitionsFromState(ANIM_STATE_ANY));
						break;
					case ANIM_INTERRUPTION_NEXT_PREV:
						transitions = transitions.concat(this._findTransitionsFromState(this._activeStateName));
						transitions = transitions.concat(this._findTransitionsFromState(this._previousStateName));
						transitions = transitions.concat(this._findTransitionsFromState(ANIM_STATE_ANY));
						break;
					case ANIM_INTERRUPTION_NONE:
					default:
				}
			}
		}
		transitions = transitions.filter((transition) => {
			if (transition.to === this.activeStateName) {
				return false;
			}
			if (transition.hasExitTime) {
				let progressBefore = this._getActiveStateProgressForTime(this._timeInStateBefore);
				let progress = this._getActiveStateProgressForTime(this._timeInState);
				if (transition.exitTime < 1 && this.activeState.loop) {
					progressBefore -= Math.floor(progressBefore);
					progress -= Math.floor(progress);
				}
				if (progress === progressBefore) {
					if (progress !== transition.exitTime) {
						return null;
					}
				} else if (!(transition.exitTime > progressBefore && transition.exitTime <= progress)) {
					return null;
				}
			}
			return this._transitionHasConditionsMet(transition);
		});
		if (transitions.length > 0) {
			const transition = transitions[0];
			if (transition.to === ANIM_STATE_END) {
				const startTransition = this._findTransitionsFromState(ANIM_STATE_START)[0];
				transition.to = startTransition.to;
			}
			return transition;
		}
		return null;
	}
	updateStateFromTransition(transition) {
		let state;
		let animation;
		let clip;
		this.previousState = transition.from ? this.activeStateName : null;
		this.activeState = transition.to;
		this._activeStateDurationDirty = true;
		for (let i2 = 0; i2 < transition.conditions.length; i2++) {
			const condition = transition.conditions[i2];
			const parameter = this._findParameter(condition.parameterName);
			if (parameter.type === ANIM_PARAMETER_TRIGGER) {
				this._consumeTrigger(condition.parameterName);
			}
		}
		if (this.previousState) {
			if (!this._isTransitioning) {
				this._transitionPreviousStates = [];
			}
			this._transitionPreviousStates.push({
				name: this._previousStateName,
				weight: 1
			});
			const interpolatedTime = Math.min(this._totalTransitionTime !== 0 ? this._currTransitionTime / this._totalTransitionTime : 1, 1);
			for (let i2 = 0; i2 < this._transitionPreviousStates.length; i2++) {
				if (!this._isTransitioning) {
					this._transitionPreviousStates[i2].weight = 1;
				} else if (i2 !== this._transitionPreviousStates.length - 1) {
					this._transitionPreviousStates[i2].weight *= 1 - interpolatedTime;
				} else {
					this._transitionPreviousStates[i2].weight = interpolatedTime;
				}
				state = this._findState(this._transitionPreviousStates[i2].name);
				for (let j = 0; j < state.animations.length; j++) {
					animation = state.animations[j];
					clip = this._animEvaluator.findClip(`${animation.name}.previous.${i2}`);
					if (!clip) {
						clip = this._animEvaluator.findClip(animation.name);
						clip.name = `${animation.name}.previous.${i2}`;
					}
					if (i2 !== this._transitionPreviousStates.length - 1) {
						clip.pause();
					}
				}
			}
		}
		this._isTransitioning = true;
		this._totalTransitionTime = transition.time;
		this._currTransitionTime = 0;
		this._transitionInterruptionSource = transition.interruptionSource;
		const activeState = this.activeState;
		const hasTransitionOffset = transition.transitionOffset && transition.transitionOffset > 0 && transition.transitionOffset < 1;
		let timeInState = 0;
		let timeInStateBefore = 0;
		if (hasTransitionOffset) {
			const offsetTime = activeState.timelineDuration * transition.transitionOffset;
			timeInState = offsetTime;
			timeInStateBefore = offsetTime;
		}
		this._timeInState = timeInState;
		this._timeInStateBefore = timeInStateBefore;
		for (let i2 = 0; i2 < activeState.animations.length; i2++) {
			clip = this._animEvaluator.findClip(activeState.animations[i2].name);
			if (!clip) {
				const speed = Number.isFinite(activeState.animations[i2].speed) ? activeState.animations[i2].speed : activeState.speed;
				clip = new AnimClip(activeState.animations[i2].animTrack, this._timeInState, speed, true, activeState.loop, this._eventHandler);
				clip.name = activeState.animations[i2].name;
				this._animEvaluator.addClip(clip);
			} else {
				clip.reset();
			}
			if (transition.time > 0) {
				clip.blendWeight = 0;
			} else {
				clip.blendWeight = activeState.animations[i2].normalizedWeight;
			}
			clip.play();
			if (hasTransitionOffset) {
				clip.time = activeState.timelineDuration * transition.transitionOffset;
			} else {
				const startTime = activeState.speed >= 0 ? 0 : this.activeStateDuration;
				clip.time = startTime;
			}
		}
	}
	_transitionToState(newStateName) {
		if (!this._findState(newStateName)) {
			return;
		}
		let transition = this._findTransition(this._activeStateName, newStateName);
		if (!transition) {
			this._animEvaluator.removeClips();
			transition = new AnimTransition({ from: null, to: newStateName });
		}
		this.updateStateFromTransition(transition);
	}
	assignAnimation(pathString, animTrack, speed, loop) {
		const path2 = pathString.split(".");
		let state = this._findState(path2[0]);
		if (!state) {
			state = new AnimState(this, path2[0], speed);
			this._states[path2[0]] = state;
			this._stateNames.push(path2[0]);
		}
		state.addAnimation(path2, animTrack);
		this._animEvaluator.updateClipTrack(state.name, animTrack);
		if (speed !== void 0) {
			state.speed = speed;
		}
		if (loop !== void 0) {
			state.loop = loop;
		}
		if (!this._playing && this._activate && this.playable) {
			this.play();
		}
		this._activeStateDurationDirty = true;
	}
	removeNodeAnimations(nodeName) {
		if (ANIM_CONTROL_STATES.indexOf(nodeName) !== -1) {
			return false;
		}
		const state = this._findState(nodeName);
		if (!state) {
			return false;
		}
		state.animations = [];
		return true;
	}
	play(stateName) {
		if (stateName) {
			this._transitionToState(stateName);
		}
		this._playing = true;
	}
	pause() {
		this._playing = false;
	}
	reset() {
		this._previousStateName = null;
		this._activeStateName = ANIM_STATE_START;
		this._playing = false;
		this._currTransitionTime = 1;
		this._totalTransitionTime = 1;
		this._isTransitioning = false;
		this._timeInState = 0;
		this._timeInStateBefore = 0;
		this._animEvaluator.removeClips();
	}
	rebind() {
		this._animEvaluator.rebind();
	}
	update(dt) {
		if (!this._playing) {
			return;
		}
		let state;
		let animation;
		let clip;
		if (this.activeState.loop || this._timeInState < this.activeStateDuration) {
			this._timeInStateBefore = this._timeInState;
			this._timeInState += dt * this.activeState.speed;
			if (!this.activeState.loop && this._timeInState > this.activeStateDuration) {
				this._timeInState = this.activeStateDuration;
				dt = this.activeStateDuration - this._timeInStateBefore;
			}
		}
		const transition = this._findTransition(this._activeStateName);
		if (transition) {
			this.updateStateFromTransition(transition);
		}
		if (this._isTransitioning) {
			this._currTransitionTime += dt;
			if (this._currTransitionTime <= this._totalTransitionTime) {
				const interpolatedTime = this._totalTransitionTime !== 0 ? this._currTransitionTime / this._totalTransitionTime : 1;
				for (let i2 = 0; i2 < this._transitionPreviousStates.length; i2++) {
					state = this._findState(this._transitionPreviousStates[i2].name);
					const stateWeight = this._transitionPreviousStates[i2].weight;
					for (let j = 0; j < state.animations.length; j++) {
						animation = state.animations[j];
						clip = this._animEvaluator.findClip(`${animation.name}.previous.${i2}`);
						if (clip) {
							clip.blendWeight = (1 - interpolatedTime) * animation.normalizedWeight * stateWeight;
						}
					}
				}
				state = this.activeState;
				for (let i2 = 0; i2 < state.animations.length; i2++) {
					animation = state.animations[i2];
					this._animEvaluator.findClip(animation.name).blendWeight = interpolatedTime * animation.normalizedWeight;
				}
			} else {
				this._isTransitioning = false;
				const activeClips = this.activeStateAnimations.length;
				const totalClips = this._animEvaluator.clips.length;
				for (let i2 = 0; i2 < totalClips - activeClips; i2++) {
					this._animEvaluator.removeClip(0);
				}
				this._transitionPreviousStates = [];
				state = this.activeState;
				for (let i2 = 0; i2 < state.animations.length; i2++) {
					animation = state.animations[i2];
					clip = this._animEvaluator.findClip(animation.name);
					if (clip) {
						clip.blendWeight = animation.normalizedWeight;
					}
				}
			}
		} else {
			if (this.activeState._blendTree.constructor !== AnimNode) {
				state = this.activeState;
				for (let i2 = 0; i2 < state.animations.length; i2++) {
					animation = state.animations[i2];
					clip = this._animEvaluator.findClip(animation.name);
					if (clip) {
						clip.blendWeight = animation.normalizedWeight;
						if (animation.parent.syncAnimations) {
							clip.speed = animation.speed;
						}
					}
				}
			}
		}
		this._animEvaluator.update(dt, this.activeState.hasAnimations);
	}
	findParameter = (name) => {
		return this._findParameter(name);
	};
};

var v2 = new Vec2();
var v3 = new Vec3();
var v4 = new Vec4();
var c = new Color();
var q2 = new Quat();
var AnimComponentBinder = class _AnimComponentBinder extends DefaultAnimBinder {
	constructor(animComponent, graph, layerName, mask, layerIndex) {
		super(graph);
		this.animComponent = animComponent;
		this._mask = mask;
		this.layerName = layerName;
		this.layerIndex = layerIndex;
	}
	static _packFloat(values) {
		return values[0];
	}
	static _packBoolean(values) {
		return !!values[0];
	}
	static _packVec2(values) {
		v2.x = values[0];
		v2.y = values[1];
		return v2;
	}
	static _packVec3(values) {
		v3.x = values[0];
		v3.y = values[1];
		v3.z = values[2];
		return v3;
	}
	static _packVec4(values) {
		v4.x = values[0];
		v4.y = values[1];
		v4.z = values[2];
		v4.w = values[3];
		return v4;
	}
	static _packColor(values) {
		c.r = values[0];
		c.g = values[1];
		c.b = values[2];
		c.a = values[3];
		return c;
	}
	static _packQuat(values) {
		q2.x = values[0];
		q2.y = values[1];
		q2.z = values[2];
		q2.w = values[3];
		return q2;
	}
	resolve(path2) {
		const encodedPath = AnimBinder.encode(path2.entityPath, path2.component, path2.propertyPath);
		let target2 = this.targetCache[encodedPath];
		if (target2) return target2;
		let entity;
		let propertyComponent;
		let targetPath;
		switch (path2.component) {
			case "entity":
				entity = this._getEntityFromHierarchy(path2.entityPath);
				targetPath = AnimBinder.encode(
					entity.path,
					"entity",
					path2.propertyPath
				);
				propertyComponent = entity;
				break;
			case "graph":
				propertyComponent = this.findNode(path2);
				if (!propertyComponent) return null;
				targetPath = AnimBinder.encode(
					propertyComponent.path,
					"graph",
					path2.propertyPath
				);
				break;
			default:
				entity = this._getEntityFromHierarchy(path2.entityPath);
				propertyComponent = entity.findComponent(path2.component);
				if (!propertyComponent) {
					return null;
				}
				targetPath = AnimBinder.encode(
					entity.path,
					path2.component,
					path2.propertyPath
				);
				break;
		}
		target2 = this._createAnimTargetForProperty(propertyComponent, path2.propertyPath, targetPath);
		this.targetCache[encodedPath] = target2;
		return target2;
	}
	update(deltaTime) {
		const activeNodes = this.activeNodes;
		if (activeNodes) {
			for (let i2 = 0; i2 < activeNodes.length; i2++) {
				activeNodes[i2]._dirtifyLocal();
			}
		}
	}
	_getEntityFromHierarchy(entityHierarchy) {
		if (!this.animComponent.entity.name === entityHierarchy[0]) {
			return null;
		}
		const currEntity = this.animComponent.entity;
		if (entityHierarchy.length === 1) {
			return currEntity;
		}
		return currEntity._parent.findByPath(entityHierarchy);
	}
	// resolve an object path
	_resolvePath(object, path2, resolveLeaf) {
		const steps = path2.length - (resolveLeaf ? 0 : 1);
		for (let i2 = 0; i2 < steps; i2++) {
			object = object[path2[i2]];
		}
		return object;
	}
	// construct a setter function for the property located at 'path' from the base object. packFunc
	// is a function which takes the animation values array and packages them for the target property
	// in the correct format (i.e. vec2, quat, color etc).
	_setter(object, path2, packFunc) {
		const obj = this._resolvePath(object, path2);
		const key = path2[path2.length - 1];
		const setterFuncName = `set${key.substring(0, 1).toUpperCase()}${key.substring(1)}`;
		if (obj[setterFuncName]) {
			const getterFunc = obj[`get${key.substring(0, 1).toUpperCase()}${key.substring(1)}`].bind(obj);
			let baseValues = getterFunc();
			baseValues = [baseValues.x, baseValues.y, baseValues.z, baseValues.w];
			const setterFunc = obj[setterFuncName].bind(obj);
			return {
				set: (values) => {
					setterFunc(packFunc(values));
				},
				get: () => baseValues
			};
		}
		const prop = obj[key];
		if (typeof prop === "object" && prop.hasOwnProperty("copy")) {
			return function(values) {
				prop.copy(packFunc(values));
			};
		}
		if ([Vec2, Vec3, Vec4, Color, Quat].indexOf(obj.constructor) !== -1 && path2.length > 1) {
			const parent = path2.length > 2 ? this._resolvePath(object, path2.slice(0, -1)) : object;
			const objKey = path2[path2.length - 2];
			return function(values) {
				obj[key] = packFunc(values);
				parent[objKey] = obj;
			};
		}
		return function(values) {
			obj[key] = packFunc(values);
		};
	}
	_createAnimTargetForProperty(propertyComponent, propertyHierarchy, targetPath) {
		if (this.handlers && propertyHierarchy[0].startsWith("weight.")) {
			return this.handlers.weight(propertyComponent, propertyHierarchy[0].replace("weight.", ""));
		} else if (this.handlers && propertyHierarchy[0] === "material" && propertyHierarchy.length === 2) {
			const materialPropertyName = propertyHierarchy[1];
			if (materialPropertyName.endsWith("Map")) {
				return this.handlers.materialTexture(propertyComponent, materialPropertyName);
			}
		}
		const property = this._resolvePath(propertyComponent, propertyHierarchy, true);
		if (typeof property === "undefined") {
			return null;
		}
		let setter;
		let animDataType;
		let animDataComponents;
		if (typeof property === "number") {
			setter = this._setter(propertyComponent, propertyHierarchy, _AnimComponentBinder._packFloat);
			animDataType = "vector";
			animDataComponents = 1;
		} else if (typeof property === "boolean") {
			setter = this._setter(propertyComponent, propertyHierarchy, _AnimComponentBinder._packBoolean);
			animDataType = "vector";
			animDataComponents = 1;
		} else if (typeof property === "object") {
			switch (property.constructor) {
				case Vec2:
					setter = this._setter(propertyComponent, propertyHierarchy, _AnimComponentBinder._packVec2);
					animDataType = "vector";
					animDataComponents = 2;
					break;
				case Vec3:
					setter = this._setter(propertyComponent, propertyHierarchy, _AnimComponentBinder._packVec3);
					animDataType = "vector";
					animDataComponents = 3;
					break;
				case Vec4:
					setter = this._setter(propertyComponent, propertyHierarchy, _AnimComponentBinder._packVec4);
					animDataType = "vector";
					animDataComponents = 4;
					break;
				case Color:
					setter = this._setter(propertyComponent, propertyHierarchy, _AnimComponentBinder._packColor);
					animDataType = "vector";
					animDataComponents = 4;
					break;
				case Quat:
					setter = this._setter(propertyComponent, propertyHierarchy, _AnimComponentBinder._packQuat);
					animDataType = "quaternion";
					animDataComponents = 4;
					break;
				default:
					return null;
			}
		}
		if (propertyHierarchy.indexOf("material") !== -1) {
			return new AnimTarget((values) => {
				setter(values);
				propertyComponent.material.update();
			}, animDataType, animDataComponents, targetPath);
		}
		return new AnimTarget(setter, animDataType, animDataComponents, targetPath);
	}
	rebind() {
		this.targetCache = {};
		if (this.animComponent.rootBone) {
			this.graph = this.animComponent.rootBone;
		} else {
			this.graph = this.animComponent.entity;
		}
		const nodes = {};
		const flatten = function(node) {
			nodes[node.name] = node;
			for (let i2 = 0; i2 < node.children.length; ++i2) {
				flatten(node.children[i2]);
			}
		};
		flatten(this.graph);
		this.nodes = nodes;
	}
};

var AnimComponentLayer = class {
	_name;
	_controller;
	_component;
	_weight;
	_blendType;
	_mask = null;
	_blendTime = 0;
	_blendTimeElapsed = 0;
	_startingWeight = 0;
	_targetWeight = 0;
	constructor(name, controller, component, weight = 1, blendType = ANIM_LAYER_OVERWRITE) {
		this._name = name;
		this._controller = controller;
		this._component = component;
		this._weight = weight;
		this._blendType = blendType;
	}
	get name() {
		return this._name;
	}
	set playing(value) {
		this._controller.playing = value;
	}
	get playing() {
		return this._controller.playing;
	}
	get playable() {
		return this._controller.playable;
	}
	get activeState() {
		return this._controller.activeStateName;
	}
	get previousState() {
		return this._controller.previousStateName;
	}
	get activeStateProgress() {
		return this._controller.activeStateProgress;
	}
	get activeStateDuration() {
		return this._controller.activeStateDuration;
	}
	set activeStateCurrentTime(time) {
		const controller = this._controller;
		const layerPlaying = controller.playing;
		controller.playing = true;
		controller.activeStateCurrentTime = time;
		if (!layerPlaying) {
			controller.update(0);
		}
		controller.playing = layerPlaying;
	}
	get activeStateCurrentTime() {
		return this._controller.activeStateCurrentTime;
	}
	get transitioning() {
		return this._controller.transitioning;
	}
	get transitionProgress() {
		if (this.transitioning) {
			return this._controller.transitionProgress;
		}
		return null;
	}
	get states() {
		return this._controller.states;
	}
	set weight(value) {
		this._weight = value;
		this._component.dirtifyTargets();
	}
	get weight() {
		return this._weight;
	}
	set blendType(value) {
		if (value !== this._blendType) {
			this._blendType = value;
			if (this._controller.normalizeWeights) {
				this._component.rebind();
			}
		}
	}
	get blendType() {
		return this._blendType;
	}
	set mask(value) {
		if (this._controller.assignMask(value)) {
			this._component.rebind();
		}
		this._mask = value;
	}
	get mask() {
		return this._mask;
	}
	play(name) {
		this._controller.play(name);
	}
	pause() {
		this._controller.pause();
	}
	reset() {
		this._controller.reset();
	}
	rebind() {
		this._controller.rebind();
	}
	update(dt) {
		if (this._blendTime) {
			if (this._blendTimeElapsed < this._blendTime) {
				this.weight = math.lerp(this._startingWeight, this._targetWeight, this._blendTimeElapsed / this._blendTime);
				this._blendTimeElapsed += dt;
			} else {
				this.weight = this._targetWeight;
				this._blendTime = 0;
				this._blendTimeElapsed = 0;
				this._startingWeight = 0;
				this._targetWeight = 0;
			}
		}
		this._controller.update(dt);
	}
	blendToWeight(weight, time) {
		this._startingWeight = this.weight;
		this._targetWeight = weight;
		this._blendTime = Math.max(0, time);
		this._blendTimeElapsed = 0;
	}
	assignAnimation(nodePath, animTrack, speed, loop) {
		if (!(animTrack instanceof AnimTrack)) {
			return;
		}
		this._controller.assignAnimation(nodePath, animTrack, speed, loop);
		if (this._controller._transitions.length === 0) {
			this._controller._transitions.push(new AnimTransition({
				from: "START",
				to: nodePath
			}));
		}
		if (this._component.activate && this._component.playable) {
			this._component.playing = true;
		}
	}
	removeNodeAnimations(nodeName) {
		if (this._controller.removeNodeAnimations(nodeName)) {
			this._component.playing = false;
		}
	}
	getAnimationAsset(stateName) {
		return this._component.animationAssets[`${this.name}:${stateName}`];
	}
	transition(to, time = 0, transitionOffset = null) {
		this._controller.updateStateFromTransition(new AnimTransition({
			from: this._controller.activeStateName,
			to,
			time,
			transitionOffset
		}));
	}
};

var AnimStateGraph = class {
	constructor(data2) {
		this._layers = [];
		this._parameters = {};
		if (!Array.isArray(data2.layers)) {
			for (const layerId in data2.layers) {
				const dataLayer = data2.layers[layerId];
				const layer = {
					name: dataLayer.name,
					blendType: dataLayer.blendType,
					weight: dataLayer.weight,
					states: [],
					transitions: []
				};
				for (let i2 = 0; i2 < dataLayer.states.length; i2++) {
					layer.states.push(data2.states[dataLayer.states[i2]]);
				}
				for (let i2 = 0; i2 < dataLayer.transitions.length; i2++) {
					const dataLayerTransition = data2.transitions[dataLayer.transitions[i2]];
					if (dataLayerTransition.conditions && !Array.isArray(dataLayerTransition.conditions)) {
						const conditionKeys = Object.keys(dataLayerTransition.conditions);
						const conditions = [];
						for (let j = 0; j < conditionKeys.length; j++) {
							const condition = dataLayerTransition.conditions[conditionKeys[j]];
							if (condition.parameterName) {
								conditions.push(condition);
							}
						}
						dataLayerTransition.conditions = conditions;
					}
					if (Number.isInteger(dataLayerTransition.from)) {
						dataLayerTransition.from = data2.states[dataLayerTransition.from].name;
					}
					if (Number.isInteger(dataLayerTransition.to)) {
						dataLayerTransition.to = data2.states[dataLayerTransition.to].name;
					}
					layer.transitions.push(dataLayerTransition);
				}
				this._layers.push(layer);
			}
		} else {
			this._layers = data2.layers;
		}
		for (const paramId in data2.parameters) {
			const param = data2.parameters[paramId];
			this._parameters[param.name] = { type: param.type, value: param.value };
		}
	}
	get parameters() {
		return Object.assign({}, this._parameters);
	}
	get layers() {
		return this._layers;
	}
};

var AnimComponent = class extends Component {
	_stateGraphAsset = null;
	_animationAssets = {};
	_speed = 1;
	_activate = true;
	_playing = false;
	_rootBone = null;
	_stateGraph = null;
	_layers = [];
	_layerIndices = {};
	_parameters = {};
	_targets = {};
	_consumedTriggers = /* @__PURE__ */ new Set();
	_normalizeWeights = false;
	set stateGraphAsset(value) {
		if (value === null) {
			this.removeStateGraph();
			return;
		}
		if (this._stateGraphAsset) {
			const stateGraphAsset = this.system.app.assets.get(this._stateGraphAsset);
			stateGraphAsset.off("change", this._onStateGraphAssetChangeEvent, this);
		}
		let _id;
		let _asset;
		if (value instanceof Asset) {
			_id = value.id;
			_asset = this.system.app.assets.get(_id);
			if (!_asset) {
				this.system.app.assets.add(value);
				_asset = this.system.app.assets.get(_id);
			}
		} else {
			_id = value;
			_asset = this.system.app.assets.get(_id);
		}
		if (!_asset || this._stateGraphAsset === _id) {
			return;
		}
		if (_asset.resource) {
			this._stateGraph = _asset.resource;
			this.loadStateGraph(this._stateGraph);
			_asset.on("change", this._onStateGraphAssetChangeEvent, this);
		} else {
			_asset.once("load", (asset) => {
				this._stateGraph = asset.resource;
				this.loadStateGraph(this._stateGraph);
			});
			_asset.on("change", this._onStateGraphAssetChangeEvent, this);
			this.system.app.assets.load(_asset);
		}
		this._stateGraphAsset = _id;
	}
	get stateGraphAsset() {
		return this._stateGraphAsset;
	}
	set normalizeWeights(value) {
		this._normalizeWeights = value;
		this.unbind();
	}
	get normalizeWeights() {
		return this._normalizeWeights;
	}
	set animationAssets(value) {
		this._animationAssets = value;
		this.loadAnimationAssets();
	}
	get animationAssets() {
		return this._animationAssets;
	}
	set speed(value) {
		this._speed = value;
	}
	get speed() {
		return this._speed;
	}
	set activate(value) {
		this._activate = value;
	}
	get activate() {
		return this._activate;
	}
	set playing(value) {
		this._playing = value;
	}
	get playing() {
		return this._playing;
	}
	set rootBone(value) {
		if (typeof value === "string") {
			const entity = this.entity.root.findByGuid(value);
			this._rootBone = entity;
		} else if (value instanceof Entity) {
			this._rootBone = value;
		} else {
			this._rootBone = null;
		}
		this.rebind();
	}
	get rootBone() {
		return this._rootBone;
	}
	set stateGraph(value) {
		this._stateGraph = value;
	}
	get stateGraph() {
		return this._stateGraph;
	}
	get layers() {
		return this._layers;
	}
	set layerIndices(value) {
		this._layerIndices = value;
	}
	get layerIndices() {
		return this._layerIndices;
	}
	set parameters(value) {
		this._parameters = value;
	}
	get parameters() {
		return this._parameters;
	}
	set targets(value) {
		this._targets = value;
	}
	get targets() {
		return this._targets;
	}
	get playable() {
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			if (!this._layers[i2].playable) {
				return false;
			}
		}
		return true;
	}
	get baseLayer() {
		if (this._layers.length > 0) {
			return this._layers[0];
		}
		return null;
	}
	_onStateGraphAssetChangeEvent(asset) {
		const prevAnimationAssets = this.animationAssets;
		const prevMasks = this.layers.map((layer) => layer.mask);
		this.removeStateGraph();
		this._stateGraph = new AnimStateGraph(asset._data);
		this.loadStateGraph(this._stateGraph);
		this.animationAssets = prevAnimationAssets;
		this.loadAnimationAssets();
		this.layers.forEach((layer, i2) => {
			layer.mask = prevMasks[i2];
		});
		this.rebind();
	}
	dirtifyTargets() {
		const targets = Object.values(this._targets);
		for (let i2 = 0; i2 < targets.length; i2++) {
			targets[i2].dirty = true;
		}
	}
	_addLayer({ name, states, transitions, weight, mask, blendType }) {
		let graph;
		if (this.rootBone) {
			graph = this.rootBone;
		} else {
			graph = this.entity;
		}
		const layerIndex = this._layers.length;
		const animBinder = new AnimComponentBinder(this, graph, name, mask, layerIndex);
		const animEvaluator = new AnimEvaluator(animBinder);
		const controller = new AnimController(
			animEvaluator,
			states,
			transitions,
			this._activate,
			this,
			this.findParameter,
			this.consumeTrigger
		);
		this._layers.push(new AnimComponentLayer(name, controller, this, weight, blendType));
		this._layerIndices[name] = layerIndex;
		return this._layers[layerIndex];
	}
	addLayer(name, weight, mask, blendType) {
		const layer = this.findAnimationLayer(name);
		if (layer) return layer;
		const states = [
			{
				"name": "START",
				"speed": 1
			}
		];
		const transitions = [];
		return this._addLayer({ name, states, transitions, weight, mask, blendType });
	}
	_assignParameters(stateGraph) {
		this._parameters = {};
		const paramKeys = Object.keys(stateGraph.parameters);
		for (let i2 = 0; i2 < paramKeys.length; i2++) {
			const paramKey = paramKeys[i2];
			this._parameters[paramKey] = {
				type: stateGraph.parameters[paramKey].type,
				value: stateGraph.parameters[paramKey].value
			};
		}
	}
	loadStateGraph(stateGraph) {
		this._stateGraph = stateGraph;
		this._assignParameters(stateGraph);
		this._layers = [];
		let containsBlendTree = false;
		for (let i2 = 0; i2 < stateGraph.layers.length; i2++) {
			const layer = stateGraph.layers[i2];
			this._addLayer({ ...layer });
			if (layer.states.some((state) => state.blendTree)) {
				containsBlendTree = true;
			}
		}
		if (!containsBlendTree) {
			this.setupAnimationAssets();
		}
	}
	setupAnimationAssets() {
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = this._layers[i2];
			const layerName = layer.name;
			for (let j = 0; j < layer.states.length; j++) {
				const stateName = layer.states[j];
				if (ANIM_CONTROL_STATES.indexOf(stateName) === -1) {
					const stateKey = `${layerName}:${stateName}`;
					if (!this._animationAssets[stateKey]) {
						this._animationAssets[stateKey] = {
							asset: null
						};
					}
				}
			}
		}
		this.loadAnimationAssets();
	}
	loadAnimationAssets() {
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = this._layers[i2];
			for (let j = 0; j < layer.states.length; j++) {
				const stateName = layer.states[j];
				if (ANIM_CONTROL_STATES.indexOf(stateName) !== -1) continue;
				const animationAsset = this._animationAssets[`${layer.name}:${stateName}`];
				if (!animationAsset || !animationAsset.asset) {
					this.findAnimationLayer(layer.name).assignAnimation(stateName, AnimTrack.EMPTY);
					continue;
				}
				const assetId = animationAsset.asset;
				const asset = this.system.app.assets.get(assetId);
				if (asset) {
					if (asset.resource) {
						this.onAnimationAssetLoaded(layer.name, stateName, asset);
					} else {
						asset.once("load", function(layerName, stateName2) {
							return function(asset2) {
								this.onAnimationAssetLoaded(layerName, stateName2, asset2);
							}.bind(this);
						}.bind(this)(layer.name, stateName));
						this.system.app.assets.load(asset);
					}
				}
			}
		}
	}
	onAnimationAssetLoaded(layerName, stateName, asset) {
		this.findAnimationLayer(layerName).assignAnimation(stateName, asset.resource);
	}
	removeStateGraph() {
		this._stateGraph = null;
		this._stateGraphAsset = null;
		this._animationAssets = {};
		this._layers = [];
		this._layerIndices = {};
		this._parameters = {};
		this._playing = false;
		this.unbind();
		this._targets = {};
	}
	reset() {
		this._assignParameters(this._stateGraph);
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layerPlaying = this._layers[i2].playing;
			this._layers[i2].reset();
			this._layers[i2].playing = layerPlaying;
		}
	}
	unbind() {
		if (!this._normalizeWeights) {
			Object.keys(this._targets).forEach((targetKey) => {
				this._targets[targetKey].unbind();
			});
		}
	}
	rebind() {
		this._targets = {};
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			this._layers[i2].rebind();
		}
	}
	findAnimationLayer(name) {
		const layerIndex = this._layerIndices[name];
		return this._layers[layerIndex] || null;
	}
	addAnimationState(nodeName, animTrack, speed = 1, loop = true, layerName = "Base") {
		if (!this._stateGraph) {
			this.loadStateGraph(new AnimStateGraph({
				"layers": [
					{
						"name": layerName,
						"states": [
							{
								"name": "START",
								"speed": 1
							},
							{
								"name": nodeName,
								"speed": speed,
								"loop": loop,
								"defaultState": true
							}
						],
						"transitions": [
							{
								"from": "START",
								"to": nodeName
							}
						]
					}
				],
				"parameters": {}
			}));
		}
		const layer = this.findAnimationLayer(layerName);
		if (layer) {
			layer.assignAnimation(nodeName, animTrack, speed, loop);
		} else {
			this.addLayer(layerName)?.assignAnimation(nodeName, animTrack, speed, loop);
		}
	}
	assignAnimation(nodePath, animTrack, layerName, speed = 1, loop = true) {
		if (!this._stateGraph && nodePath.indexOf(".") === -1) {
			this.loadStateGraph(new AnimStateGraph({
				"layers": [
					{
						"name": "Base",
						"states": [
							{
								"name": "START",
								"speed": 1
							},
							{
								"name": nodePath,
								"speed": speed,
								"loop": loop,
								"defaultState": true
							}
						],
						"transitions": [
							{
								"from": "START",
								"to": nodePath
							}
						]
					}
				],
				"parameters": {}
			}));
			this.baseLayer.assignAnimation(nodePath, animTrack);
			return;
		}
		const layer = layerName ? this.findAnimationLayer(layerName) : this.baseLayer;
		if (!layer) {
			return;
		}
		layer.assignAnimation(nodePath, animTrack, speed, loop);
	}
	removeNodeAnimations(nodeName, layerName) {
		const layer = layerName ? this.findAnimationLayer(layerName) : this.baseLayer;
		if (!layer) {
			return;
		}
		layer.removeNodeAnimations(nodeName);
	}
	getParameterValue(name, type) {
		const param = this._parameters[name];
		if (param && param.type === type) {
			return param.value;
		}
		return void 0;
	}
	setParameterValue(name, type, value) {
		const param = this._parameters[name];
		if (param && param.type === type) {
			param.value = value;
			return;
		}
	}
	findParameter = (name) => {
		return this._parameters[name];
	};
	consumeTrigger = (name) => {
		this._consumedTriggers.add(name);
	};
	getFloat(name) {
		return this.getParameterValue(name, ANIM_PARAMETER_FLOAT);
	}
	setFloat(name, value) {
		this.setParameterValue(name, ANIM_PARAMETER_FLOAT, value);
	}
	getInteger(name) {
		return this.getParameterValue(name, ANIM_PARAMETER_INTEGER);
	}
	setInteger(name, value) {
		if (typeof value === "number" && value % 1 === 0) {
			this.setParameterValue(name, ANIM_PARAMETER_INTEGER, value);
		} else {
		}
	}
	getBoolean(name) {
		return this.getParameterValue(name, ANIM_PARAMETER_BOOLEAN);
	}
	setBoolean(name, value) {
		this.setParameterValue(name, ANIM_PARAMETER_BOOLEAN, !!value);
	}
	getTrigger(name) {
		return this.getParameterValue(name, ANIM_PARAMETER_TRIGGER);
	}
	setTrigger(name, singleFrame = false) {
		this.setParameterValue(name, ANIM_PARAMETER_TRIGGER, true);
		if (singleFrame) {
			this._consumedTriggers.add(name);
		}
	}
	resetTrigger(name) {
		this.setParameterValue(name, ANIM_PARAMETER_TRIGGER, false);
	}
	onBeforeRemove() {
		if (Number.isFinite(this._stateGraphAsset)) {
			const stateGraphAsset = this.system.app.assets.get(this._stateGraphAsset);
			stateGraphAsset.off("change", this._onStateGraphAssetChangeEvent, this);
		}
	}
	update(dt) {
		for (let i2 = 0; i2 < this.layers.length; i2++) {
			this.layers[i2].update(dt * this.speed);
		}
		this._consumedTriggers.forEach((trigger) => {
			this.parameters[trigger].value = false;
		});
		this._consumedTriggers.clear();
	}
	resolveDuplicatedEntityReferenceProperties(oldAnim, duplicatedIdsMap) {
		if (oldAnim.rootBone && duplicatedIdsMap[oldAnim.rootBone.guid]) {
			this.rootBone = duplicatedIdsMap[oldAnim.rootBone.guid];
		} else {
			this.rebind();
		}
	}
};

var AnimComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "anim";
		this.ComponentType = AnimComponent;
		this.extraDataProperties = ["layers", "masks"];
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.systems.on("animationUpdate", this.onAnimationUpdate, this);
	}
	initializeComponentData(component, data2, properties) {
		super.initializeComponentData(component, data2);
		const complexProperties = ["animationAssets", "stateGraph", "layers", "masks"];
		Object.keys(data2).forEach((key) => {
			if (complexProperties.includes(key)) return;
			component[key] = data2[key];
		});
		if (data2.stateGraph) {
			component.stateGraph = data2.stateGraph;
			component.loadStateGraph(component.stateGraph);
		}
		if (data2.layers) {
			data2.layers.forEach((layer) => {
				const cloneLayer = component.addLayer(layer.name, layer.weight, layer.mask, layer.blendType);
				layer._controller.states.forEach((stateKey) => {
					layer._controller._states[stateKey]._animationList.forEach((node) => {
						if (!node.animTrack || node.animTrack === AnimTrack.EMPTY) {
							const animationAsset = this.app.assets.get(layer._component._animationAssets[`${layer.name}:${node.name}`].asset);
							if (animationAsset && !animationAsset.loaded) {
								animationAsset.once("load", () => {
									cloneLayer.assignAnimation(node.name, animationAsset.resource);
								});
							}
						} else {
							cloneLayer.assignAnimation(node.name, node.animTrack);
						}
					});
				});
			});
		}
		if (data2.animationAssets) {
			component.animationAssets = Object.assign(component.animationAssets, data2.animationAssets);
		}
		if (data2.masks) {
			Object.keys(data2.masks).forEach((key) => {
				if (component.layers[key]) {
					const maskData = data2.masks[key].mask;
					const mask = {};
					Object.keys(maskData).forEach((maskKey) => {
						mask[decodeURI(maskKey)] = maskData[maskKey];
					});
					component.layers[key].mask = mask;
				}
			});
		}
	}
	onAnimationUpdate(dt) {
		const components2 = this.store;
		for (const id14 in components2) {
			if (components2.hasOwnProperty(id14)) {
				const component = components2[id14].entity.anim;
				if (component.enabled && component.entity.enabled && component.playing) {
					component.update(dt);
				}
			}
		}
	}
	cloneComponent(entity, clone) {
		let masks;
		if (!entity.anim.rootBone || entity.anim.rootBone === entity) {
			masks = {};
			entity.anim.layers.forEach((layer, i2) => {
				if (layer.mask) {
					const mask = {};
					Object.keys(layer.mask).forEach((path2) => {
						const pathArr = path2.split("/");
						pathArr.shift();
						const clonePath = [clone.name, ...pathArr].join("/");
						mask[clonePath] = layer.mask[path2];
					});
					masks[i2] = { mask };
				}
			});
		}
		const data2 = {
			enabled: entity.anim.enabled,
			stateGraphAsset: entity.anim.stateGraphAsset,
			animationAssets: entity.anim.animationAssets,
			speed: entity.anim.speed,
			activate: entity.anim.activate,
			playing: entity.anim.playing,
			rootBone: entity.anim.rootBone,
			stateGraph: entity.anim.stateGraph,
			layers: entity.anim.layers,
			layerIndices: entity.anim.layerIndices,
			parameters: entity.anim.parameters,
			normalizeWeights: entity.anim.normalizeWeights,
			masks
		};
		return this.addComponent(clone, data2);
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	destroy() {
		super.destroy();
		this.app.systems.off("animationUpdate", this.onAnimationUpdate, this);
	}
};

var AudioListenerComponent = class extends Component {
	setCurrentListener() {
		if (this.enabled && this.entity.audiolistener && this.entity.enabled) {
			this.system.current = this.entity;
			const position5 = this.system.current.getPosition();
			this.system.manager.listener.setPosition(position5);
		}
	}
	onEnable() {
		this.setCurrentListener();
	}
	onDisable() {
		if (this.system.current === this.entity) {
			this.system.current = null;
		}
	}
};

var AudioListenerComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "audiolistener";
		this.ComponentType = AudioListenerComponent;
		this.manager = app2.soundManager;
		this.current = null;
		this.app.systems.on("update", this.onUpdate, this);
	}
	cloneComponent(entity, clone) {
		return this.addComponent(clone, {
			enabled: entity.audiolistener.enabled
		});
	}
	onUpdate(dt) {
		if (this.current) {
			const position5 = this.current.getPosition();
			this.manager.listener.setPosition(position5);
			const wtm = this.current.getWorldTransform();
			this.manager.listener.setOrientation(wtm);
		}
	}
	destroy() {
		super.destroy();
		this.app.systems.off("update", this.onUpdate, this);
	}
};

var BUTTON_TRANSITION_MODE_TINT = 0;
var BUTTON_TRANSITION_MODE_SPRITE_CHANGE = 1;

var ELEMENTTYPE_GROUP = "group";
var ELEMENTTYPE_IMAGE = "image";
var ELEMENTTYPE_TEXT = "text";
var FITMODE_STRETCH = "stretch";
var FITMODE_CONTAIN = "contain";
var FITMODE_COVER = "cover";

var VisualState = {
	DEFAULT: "DEFAULT",
	HOVER: "HOVER",
	PRESSED: "PRESSED",
	INACTIVE: "INACTIVE"
};
var STATES_TO_TINT_NAMES = {};
STATES_TO_TINT_NAMES[VisualState.DEFAULT] = "_defaultTint";
STATES_TO_TINT_NAMES[VisualState.HOVER] = "hoverTint";
STATES_TO_TINT_NAMES[VisualState.PRESSED] = "pressedTint";
STATES_TO_TINT_NAMES[VisualState.INACTIVE] = "inactiveTint";
var STATES_TO_SPRITE_ASSET_NAMES = {};
STATES_TO_SPRITE_ASSET_NAMES[VisualState.DEFAULT] = "_defaultSpriteAsset";
STATES_TO_SPRITE_ASSET_NAMES[VisualState.HOVER] = "hoverSpriteAsset";
STATES_TO_SPRITE_ASSET_NAMES[VisualState.PRESSED] = "pressedSpriteAsset";
STATES_TO_SPRITE_ASSET_NAMES[VisualState.INACTIVE] = "inactiveSpriteAsset";
var STATES_TO_SPRITE_FRAME_NAMES = {};
STATES_TO_SPRITE_FRAME_NAMES[VisualState.DEFAULT] = "_defaultSpriteFrame";
STATES_TO_SPRITE_FRAME_NAMES[VisualState.HOVER] = "hoverSpriteFrame";
STATES_TO_SPRITE_FRAME_NAMES[VisualState.PRESSED] = "pressedSpriteFrame";
STATES_TO_SPRITE_FRAME_NAMES[VisualState.INACTIVE] = "inactiveSpriteFrame";
var ButtonComponent = class extends Component {
	static EVENT_MOUSEDOWN = "mousedown";
	static EVENT_MOUSEUP = "mouseup";
	static EVENT_MOUSEENTER = "mouseenter";
	static EVENT_MOUSELEAVE = "mouseleave";
	static EVENT_CLICK = "click";
	static EVENT_TOUCHSTART = "touchstart";
	static EVENT_TOUCHEND = "touchend";
	static EVENT_TOUCHCANCEL = "touchcancel";
	static EVENT_TOUCHLEAVE = "touchleave";
	static EVENT_SELECTSTART = "selectstart";
	static EVENT_SELECTEND = "selectend";
	static EVENT_SELECTENTER = "selectenter";
	static EVENT_SELECTLEAVE = "selectleave";
	static EVENT_HOVERSTART = "hoverstart";
	static EVENT_HOVEREND = "hoverend";
	static EVENT_PRESSEDSTART = "pressedstart";
	static EVENT_PRESSEDEND = "pressedend";
	_active = true;
	_hitPadding = new Vec4();
	_transitionMode = BUTTON_TRANSITION_MODE_TINT;
	_hoverTint = new Color(0.75, 0.75, 0.75);
	_pressedTint = new Color(0.5, 0.5, 0.5);
	_inactiveTint = new Color(0.25, 0.25, 0.25);
	_fadeDuration = 0;
	_hoverSpriteAsset = null;
	_hoverSpriteFrame = 0;
	_pressedSpriteAsset = null;
	_pressedSpriteFrame = 0;
	_inactiveSpriteAsset = null;
	_inactiveSpriteFrame = 0;
	_visualState = VisualState.DEFAULT;
	_isHovering = false;
	_hoveringCounter = 0;
	_isPressed = false;
	_hasHitElementListeners = false;
	_isApplyingTint = false;
	_isApplyingSprite = false;
	_tweenInfo = null;
	_defaultTint = new Color(1, 1, 1, 1);
	_defaultSpriteAsset = null;
	_defaultSpriteFrame = 0;
	_imageEntity = null;
	_evtElementAdd = null;
	_evtImageEntityElementAdd = null;
	_evtImageEntityElementRemove = null;
	_evtImageEntityElementColor = null;
	_evtImageEntityElementOpacity = null;
	_evtImageEntityElementSpriteAsset = null;
	_evtImageEntityElementSpriteFrame = null;
	constructor(system, entity) {
		super(system, entity);
		this._evtElementAdd = this.entity.on("element:add", this._onElementComponentAdd, this);
	}
	set active(arg) {
		if (this._active === arg) {
			return;
		}
		this._active = arg;
		this._updateVisualState();
	}
	get active() {
		return this._active;
	}
	set imageEntity(arg) {
		let newEntity;
		if (arg instanceof GraphNode) {
			newEntity = arg;
		} else if (typeof arg === "string") {
			newEntity = this.system.app.getEntityFromIndex(arg) ?? null;
		} else {
			newEntity = null;
		}
		if (this._imageEntity === newEntity) {
			return;
		}
		if (this._imageEntity) {
			this._imageEntityUnsubscribe();
		}
		this._imageEntity = newEntity;
		if (newEntity) {
			this._imageEntitySubscribe();
		}
	}
	get imageEntity() {
		return this._imageEntity;
	}
	set hitPadding(arg) {
		if (!arg) {
			this._hitPadding = arg;
		} else if (arg instanceof Vec4) {
			this._hitPadding = arg.clone();
		} else {
			this._hitPadding = new Vec4(arg[0], arg[1], arg[2], arg[3]);
		}
	}
	get hitPadding() {
		return this._hitPadding;
	}
	set transitionMode(arg) {
		if (this._transitionMode === arg) {
			return;
		}
		const oldMode = this._transitionMode;
		this._transitionMode = arg;
		this._cancelTween();
		this._resetToDefaultVisualState(oldMode);
		this._forceReapplyVisualState();
	}
	get transitionMode() {
		return this._transitionMode;
	}
	set hoverTint(arg) {
		this._setTint("_hoverTint", arg);
	}
	get hoverTint() {
		return this._hoverTint;
	}
	set pressedTint(arg) {
		this._setTint("_pressedTint", arg);
	}
	get pressedTint() {
		return this._pressedTint;
	}
	set inactiveTint(arg) {
		this._setTint("_inactiveTint", arg);
	}
	get inactiveTint() {
		return this._inactiveTint;
	}
	set fadeDuration(arg) {
		this._fadeDuration = arg;
	}
	get fadeDuration() {
		return this._fadeDuration;
	}
	set hoverSpriteAsset(arg) {
		this._setTransitionValue("_hoverSpriteAsset", arg);
	}
	get hoverSpriteAsset() {
		return this._hoverSpriteAsset;
	}
	set hoverSpriteFrame(arg) {
		this._setTransitionValue("_hoverSpriteFrame", arg);
	}
	get hoverSpriteFrame() {
		return this._hoverSpriteFrame;
	}
	set pressedSpriteAsset(arg) {
		this._setTransitionValue("_pressedSpriteAsset", arg);
	}
	get pressedSpriteAsset() {
		return this._pressedSpriteAsset;
	}
	set pressedSpriteFrame(arg) {
		this._setTransitionValue("_pressedSpriteFrame", arg);
	}
	get pressedSpriteFrame() {
		return this._pressedSpriteFrame;
	}
	set inactiveSpriteAsset(arg) {
		this._setTransitionValue("_inactiveSpriteAsset", arg);
	}
	get inactiveSpriteAsset() {
		return this._inactiveSpriteAsset;
	}
	set inactiveSpriteFrame(arg) {
		this._setTransitionValue("_inactiveSpriteFrame", arg);
	}
	get inactiveSpriteFrame() {
		return this._inactiveSpriteFrame;
	}
	_setTint(name, arg) {
		const oldValue = this[name];
		let value;
		if (!arg) {
			value = arg;
		} else if (arg instanceof Color) {
			value = arg.clone();
		} else {
			value = new Color(arg[0], arg[1], arg[2], arg[3]);
		}
		this[name] = value;
		if (oldValue === value || oldValue instanceof Color && value instanceof Color && oldValue.equals(value)) {
			return;
		}
		this._forceReapplyVisualState();
	}
	_setTransitionValue(name, arg) {
		if (this[name] === arg) {
			return;
		}
		this[name] = arg;
		this._forceReapplyVisualState();
	}
	_imageEntitySubscribe() {
		this._evtImageEntityElementAdd = this._imageEntity.on("element:add", this._onImageElementGain, this);
		if (this._imageEntity.element) {
			this._onImageElementGain();
		}
	}
	_imageEntityUnsubscribe() {
		this._evtImageEntityElementAdd?.off();
		this._evtImageEntityElementAdd = null;
		if (this._imageEntity?.element) {
			this._onImageElementLose();
		}
	}
	_imageEntityElementSubscribe() {
		const element = this._imageEntity.element;
		this._evtImageEntityElementRemove = element.once("beforeremove", this._onImageElementLose, this);
		this._evtImageEntityElementColor = element.on("set:color", this._onSetColor, this);
		this._evtImageEntityElementOpacity = element.on("set:opacity", this._onSetOpacity, this);
		this._evtImageEntityElementSpriteAsset = element.on("set:spriteAsset", this._onSetSpriteAsset, this);
		this._evtImageEntityElementSpriteFrame = element.on("set:spriteFrame", this._onSetSpriteFrame, this);
	}
	_imageEntityElementUnsubscribe() {
		this._evtImageEntityElementRemove?.off();
		this._evtImageEntityElementRemove = null;
		this._evtImageEntityElementColor?.off();
		this._evtImageEntityElementColor = null;
		this._evtImageEntityElementOpacity?.off();
		this._evtImageEntityElementOpacity = null;
		this._evtImageEntityElementSpriteAsset?.off();
		this._evtImageEntityElementSpriteAsset = null;
		this._evtImageEntityElementSpriteFrame?.off();
		this._evtImageEntityElementSpriteFrame = null;
	}
	_onElementComponentRemove() {
		this._toggleHitElementListeners("off");
	}
	_onElementComponentAdd() {
		this._toggleHitElementListeners("on");
	}
	_onImageElementLose() {
		this._imageEntityElementUnsubscribe();
		this._cancelTween();
		this._resetToDefaultVisualState(this.transitionMode);
	}
	_onImageElementGain() {
		this._imageEntityElementSubscribe();
		this._storeDefaultVisualState();
		this._forceReapplyVisualState();
	}
	_toggleHitElementListeners(onOrOff) {
		if (this.entity.element) {
			const isAdding = onOrOff === "on";
			if (isAdding && this._hasHitElementListeners) {
				return;
			}
			this.entity.element[onOrOff]("beforeremove", this._onElementComponentRemove, this);
			this.entity.element[onOrOff]("mouseenter", this._onMouseEnter, this);
			this.entity.element[onOrOff]("mouseleave", this._onMouseLeave, this);
			this.entity.element[onOrOff]("mousedown", this._onMouseDown, this);
			this.entity.element[onOrOff]("mouseup", this._onMouseUp, this);
			this.entity.element[onOrOff]("touchstart", this._onTouchStart, this);
			this.entity.element[onOrOff]("touchend", this._onTouchEnd, this);
			this.entity.element[onOrOff]("touchleave", this._onTouchLeave, this);
			this.entity.element[onOrOff]("touchcancel", this._onTouchCancel, this);
			this.entity.element[onOrOff]("selectstart", this._onSelectStart, this);
			this.entity.element[onOrOff]("selectend", this._onSelectEnd, this);
			this.entity.element[onOrOff]("selectenter", this._onSelectEnter, this);
			this.entity.element[onOrOff]("selectleave", this._onSelectLeave, this);
			this.entity.element[onOrOff]("click", this._onClick, this);
			this._hasHitElementListeners = isAdding;
		}
	}
	_storeDefaultVisualState() {
		const element = this._imageEntity?.element;
		if (!element || element.type === ELEMENTTYPE_GROUP) {
			return;
		}
		this._storeDefaultColor(element.color);
		this._storeDefaultOpacity(element.opacity);
		this._storeDefaultSpriteAsset(element.spriteAsset);
		this._storeDefaultSpriteFrame(element.spriteFrame);
	}
	_storeDefaultColor(color3) {
		this._defaultTint.r = color3.r;
		this._defaultTint.g = color3.g;
		this._defaultTint.b = color3.b;
	}
	_storeDefaultOpacity(opacity) {
		this._defaultTint.a = opacity;
	}
	_storeDefaultSpriteAsset(spriteAsset) {
		this._defaultSpriteAsset = spriteAsset;
	}
	_storeDefaultSpriteFrame(spriteFrame) {
		this._defaultSpriteFrame = spriteFrame;
	}
	_onSetColor(color3) {
		if (!this._isApplyingTint) {
			this._storeDefaultColor(color3);
			this._forceReapplyVisualState();
		}
	}
	_onSetOpacity(opacity) {
		if (!this._isApplyingTint) {
			this._storeDefaultOpacity(opacity);
			this._forceReapplyVisualState();
		}
	}
	_onSetSpriteAsset(spriteAsset) {
		if (!this._isApplyingSprite) {
			this._storeDefaultSpriteAsset(spriteAsset);
			this._forceReapplyVisualState();
		}
	}
	_onSetSpriteFrame(spriteFrame) {
		if (!this._isApplyingSprite) {
			this._storeDefaultSpriteFrame(spriteFrame);
			this._forceReapplyVisualState();
		}
	}
	_onMouseEnter(event) {
		this._isHovering = true;
		this._updateVisualState();
		this._fireIfActive("mouseenter", event);
	}
	_onMouseLeave(event) {
		this._isHovering = false;
		this._isPressed = false;
		this._updateVisualState();
		this._fireIfActive("mouseleave", event);
	}
	_onMouseDown(event) {
		this._isPressed = true;
		this._updateVisualState();
		this._fireIfActive("mousedown", event);
	}
	_onMouseUp(event) {
		this._isPressed = false;
		this._updateVisualState();
		this._fireIfActive("mouseup", event);
	}
	_onTouchStart(event) {
		this._isPressed = true;
		this._updateVisualState();
		this._fireIfActive("touchstart", event);
	}
	_onTouchEnd(event) {
		event.event.preventDefault();
		this._isPressed = false;
		this._updateVisualState();
		this._fireIfActive("touchend", event);
	}
	_onTouchLeave(event) {
		this._isPressed = false;
		this._updateVisualState();
		this._fireIfActive("touchleave", event);
	}
	_onTouchCancel(event) {
		this._isPressed = false;
		this._updateVisualState();
		this._fireIfActive("touchcancel", event);
	}
	_onSelectStart(event) {
		this._isPressed = true;
		this._updateVisualState();
		this._fireIfActive("selectstart", event);
	}
	_onSelectEnd(event) {
		this._isPressed = false;
		this._updateVisualState();
		this._fireIfActive("selectend", event);
	}
	_onSelectEnter(event) {
		this._hoveringCounter++;
		if (this._hoveringCounter === 1) {
			this._isHovering = true;
			this._updateVisualState();
		}
		this._fireIfActive("selectenter", event);
	}
	_onSelectLeave(event) {
		this._hoveringCounter--;
		if (this._hoveringCounter === 0) {
			this._isHovering = false;
			this._isPressed = false;
			this._updateVisualState();
		}
		this._fireIfActive("selectleave", event);
	}
	_onClick(event) {
		this._fireIfActive("click", event);
	}
	_fireIfActive(name, event) {
		if (this._active) {
			this.fire(name, event);
		}
	}
	_updateVisualState(force) {
		const oldVisualState = this._visualState;
		const newVisualState = this._determineVisualState();
		if ((oldVisualState !== newVisualState || force) && this.enabled) {
			this._visualState = newVisualState;
			if (oldVisualState === VisualState.HOVER) {
				this._fireIfActive("hoverend");
			}
			if (oldVisualState === VisualState.PRESSED) {
				this._fireIfActive("pressedend");
			}
			if (newVisualState === VisualState.HOVER) {
				this._fireIfActive("hoverstart");
			}
			if (newVisualState === VisualState.PRESSED) {
				this._fireIfActive("pressedstart");
			}
			switch (this.transitionMode) {
				case BUTTON_TRANSITION_MODE_TINT: {
					const tintName = STATES_TO_TINT_NAMES[this._visualState];
					const tintColor = this[tintName];
					this._applyTint(tintColor);
					break;
				}
				case BUTTON_TRANSITION_MODE_SPRITE_CHANGE: {
					const spriteAssetName = STATES_TO_SPRITE_ASSET_NAMES[this._visualState];
					const spriteFrameName = STATES_TO_SPRITE_FRAME_NAMES[this._visualState];
					const spriteAsset = this[spriteAssetName];
					const spriteFrame = this[spriteFrameName];
					this._applySprite(spriteAsset, spriteFrame);
					break;
				}
			}
		}
	}
	// Called when a property changes that mean the visual state must be reapplied,
	// even if the state enum has not changed. Examples of this are when the tint
	// value for one of the states is changed via the editor.
	_forceReapplyVisualState() {
		this._updateVisualState(true);
	}
	// Called before the image entity changes, in order to restore the previous
	// image back to its original tint. Note that this happens immediately, i.e.
	// without any animation.
	_resetToDefaultVisualState(transitionMode) {
		if (!this._imageEntity?.element) {
			return;
		}
		switch (transitionMode) {
			case BUTTON_TRANSITION_MODE_TINT:
				this._cancelTween();
				this._applyTintImmediately(this._defaultTint);
				break;
			case BUTTON_TRANSITION_MODE_SPRITE_CHANGE:
				this._applySprite(this._defaultSpriteAsset, this._defaultSpriteFrame);
				break;
		}
	}
	_determineVisualState() {
		if (!this.active) {
			return VisualState.INACTIVE;
		} else if (this._isPressed) {
			return VisualState.PRESSED;
		} else if (this._isHovering) {
			return VisualState.HOVER;
		}
		return VisualState.DEFAULT;
	}
	_applySprite(spriteAsset, spriteFrame) {
		const element = this._imageEntity?.element;
		if (!element) {
			return;
		}
		spriteFrame = spriteFrame || 0;
		this._isApplyingSprite = true;
		if (element.spriteAsset !== spriteAsset) {
			element.spriteAsset = spriteAsset;
		}
		if (element.spriteFrame !== spriteFrame) {
			element.spriteFrame = spriteFrame;
		}
		this._isApplyingSprite = false;
	}
	_applyTint(tintColor) {
		this._cancelTween();
		if (this.fadeDuration === 0) {
			this._applyTintImmediately(tintColor);
		} else {
			this._applyTintWithTween(tintColor);
		}
	}
	_applyTintImmediately(tintColor) {
		const element = this._imageEntity?.element;
		if (!tintColor || !element || element.type === ELEMENTTYPE_GROUP) {
			return;
		}
		const color3 = toColor3(tintColor);
		this._isApplyingTint = true;
		if (!color3.equals(element.color)) {
			element.color = color3;
		}
		if (element.opacity !== tintColor.a) {
			element.opacity = tintColor.a;
		}
		this._isApplyingTint = false;
	}
	_applyTintWithTween(tintColor) {
		const element = this._imageEntity?.element;
		if (!tintColor || !element || element.type === ELEMENTTYPE_GROUP) {
			return;
		}
		const color3 = toColor3(tintColor);
		const color4 = element.color;
		const opacity = element.opacity;
		if (color3.equals(color4) && tintColor.a === opacity) return;
		this._tweenInfo = {
			startTime: now(),
			from: new Color(color4.r, color4.g, color4.b, opacity),
			to: tintColor.clone(),
			lerpColor: new Color()
		};
	}
	_updateTintTween() {
		const elapsedTime = now() - this._tweenInfo.startTime;
		let elapsedProportion = this.fadeDuration === 0 ? 1 : elapsedTime / this.fadeDuration;
		elapsedProportion = math.clamp(elapsedProportion, 0, 1);
		if (Math.abs(elapsedProportion - 1) > 1e-5) {
			const lerpColor = this._tweenInfo.lerpColor;
			lerpColor.lerp(this._tweenInfo.from, this._tweenInfo.to, elapsedProportion);
			this._applyTintImmediately(
				new Color(lerpColor.r, lerpColor.g, lerpColor.b, lerpColor.a)
			);
		} else {
			this._applyTintImmediately(this._tweenInfo.to);
			this._cancelTween();
		}
	}
	_cancelTween() {
		this._tweenInfo = null;
	}
	onUpdate() {
		if (this._tweenInfo) {
			this._updateTintTween();
		}
	}
	onEnable() {
		this._isHovering = false;
		this._hoveringCounter = 0;
		this._isPressed = false;
		this._toggleHitElementListeners("on");
		this._forceReapplyVisualState();
	}
	onDisable() {
		this._toggleHitElementListeners("off");
		this._resetToDefaultVisualState(this.transitionMode);
	}
	onBeforeRemove() {
		this._imageEntityUnsubscribe();
		this._evtElementAdd?.off();
		this._evtElementAdd = null;
		this.onDisable();
	}
	resolveDuplicatedEntityReferenceProperties(oldButton, duplicatedIdsMap) {
		if (oldButton.imageEntity) {
			this.imageEntity = duplicatedIdsMap[oldButton.imageEntity.guid];
		}
	}
};
function toColor3(color4) {
	return new Color(color4.r, color4.g, color4.b);
}

var _properties2 = [
	"imageEntity",
	"active",
	"hitPadding",
	"transitionMode",
	"hoverTint",
	"pressedTint",
	"inactiveTint",
	"fadeDuration",
	"hoverSpriteAsset",
	"hoverSpriteFrame",
	"pressedSpriteAsset",
	"pressedSpriteFrame",
	"inactiveSpriteAsset",
	"inactiveSpriteFrame"
];
var ButtonComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "button";
		this.ComponentType = ButtonComponent;
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.systems.on("update", this.onUpdate, this);
	}
	initializeComponentData(component, data2, properties) {
		for (let i2 = 0; i2 < _properties2.length; i2++) {
			const property = _properties2[i2];
			if (data2[property] !== void 0) {
				component[property] = data2[property];
			}
		}
		super.initializeComponentData(component, data2);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.button;
		const data2 = {
			enabled: c2.enabled
		};
		for (let i2 = 0; i2 < _properties2.length; i2++) {
			const property = _properties2[i2];
			data2[property] = c2[property];
		}
		return this.addComponent(clone, data2);
	}
	onUpdate(dt) {
		const components2 = this.store;
		for (const id14 in components2) {
			const entity = components2[id14].entity;
			const component = entity.button;
			if (component.enabled && entity.enabled) {
				component.onUpdate();
			}
		}
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	destroy() {
		super.destroy();
		this.app.systems.off("update", this.onUpdate, this);
	}
};

var _vec3 = new Vec3();
var _quat = new Quat();
var CollisionComponent = class extends Component {
	static EVENT_CONTACT = "contact";
	static EVENT_COLLISIONSTART = "collisionstart";
	static EVENT_COLLISIONEND = "collisionend";
	static EVENT_TRIGGERENTER = "triggerenter";
	static EVENT_TRIGGERLEAVE = "triggerleave";
	_type = "box";
	_halfExtents = new Vec3(0.5, 0.5, 0.5);
	_linearOffset = new Vec3();
	_angularOffset = new Quat();
	_radius = 0.5;
	_axis = 1;
	_height = 2;
	_asset = null;
	_renderAsset = null;
	_convexHull = false;
	_shape = null;
	_model = null;
	_render = null;
	_checkVertexDuplicates = true;
	_initialized = false;
	_compoundParent = null;
	_hasOffset = false;
	_builtWorldScale = null;
	constructor(system, entity) {
		super(system, entity);
		this.entity.on("insert", this._onInsert, this);
	}
	set type(arg) {
		if (this._type === arg) {
			return;
		}
		const previous = this._type;
		this._type = arg;
		this.system.changeType(this, previous, arg);
	}
	get type() {
		return this._type;
	}
	set halfExtents(arg) {
		if (arg instanceof Vec3) {
			this._halfExtents.copy(arg);
		} else {
			this._halfExtents.set(arg[0], arg[1], arg[2]);
		}
		if (this._initialized && this._type === "box") {
			this.system.recreatePhysicalShapes(this);
		}
	}
	get halfExtents() {
		return this._halfExtents;
	}
	set linearOffset(arg) {
		if (arg instanceof Vec3) {
			this._linearOffset.copy(arg);
		} else {
			this._linearOffset.set(arg[0], arg[1], arg[2]);
		}
		this._updateHasOffset();
		if (this._initialized) {
			this.system.recreatePhysicalShapes(this);
		}
	}
	get linearOffset() {
		return this._linearOffset;
	}
	set angularOffset(arg) {
		if (arg instanceof Quat) {
			this._angularOffset.copy(arg);
		} else if (arg.length === 3) {
			this._angularOffset.setFromEulerAngles(arg[0], arg[1], arg[2]);
		} else {
			this._angularOffset.set(arg[0], arg[1], arg[2], arg[3]);
		}
		this._updateHasOffset();
		if (this._initialized) {
			this.system.recreatePhysicalShapes(this);
		}
	}
	get angularOffset() {
		return this._angularOffset;
	}
	set radius(arg) {
		this._radius = arg;
		const t = this._type;
		if (this._initialized && (t === "sphere" || t === "capsule" || t === "cylinder" || t === "cone")) {
			this.system.recreatePhysicalShapes(this);
		}
	}
	get radius() {
		return this._radius;
	}
	set axis(arg) {
		this._axis = arg;
		const t = this._type;
		if (this._initialized && (t === "capsule" || t === "cylinder" || t === "cone")) {
			this.system.recreatePhysicalShapes(this);
		}
	}
	get axis() {
		return this._axis;
	}
	set height(arg) {
		this._height = arg;
		const t = this._type;
		if (this._initialized && (t === "capsule" || t === "cylinder" || t === "cone")) {
			this.system.recreatePhysicalShapes(this);
		}
	}
	get height() {
		return this._height;
	}
	set asset(arg) {
		const assets = this.system.app.assets;
		if (this._asset) {
			const asset = assets.get(this._asset);
			if (asset) {
				asset.off("remove", this.onAssetRemoved, this);
			}
		}
		this._asset = arg instanceof Asset ? arg.id : arg;
		if (arg) {
			const asset = assets.get(this._asset);
			if (asset) {
				asset.off("remove", this.onAssetRemoved, this);
				asset.on("remove", this.onAssetRemoved, this);
			}
		}
		if (this._initialized && this._type === "mesh") {
			if (!arg) {
				this._model = null;
			}
			this.system.recreatePhysicalShapes(this);
		}
	}
	get asset() {
		return this._asset;
	}
	set renderAsset(arg) {
		const assets = this.system.app.assets;
		if (this._renderAsset) {
			const asset = assets.get(this._renderAsset);
			if (asset) {
				asset.off("remove", this.onRenderAssetRemoved, this);
			}
		}
		this._renderAsset = arg instanceof Asset ? arg.id : arg;
		if (arg) {
			const asset = assets.get(this._renderAsset);
			if (asset) {
				asset.off("remove", this.onRenderAssetRemoved, this);
				asset.on("remove", this.onRenderAssetRemoved, this);
			}
		}
		if (this._initialized && this._type === "mesh") {
			if (!arg) {
				this._render = null;
			}
			this.system.recreatePhysicalShapes(this);
		}
	}
	get renderAsset() {
		return this._renderAsset;
	}
	set convexHull(arg) {
		this._convexHull = arg;
		if (this._initialized && this._type === "mesh") {
			this.system.doRecreatePhysicalShape(this);
		}
	}
	get convexHull() {
		return this._convexHull;
	}
	set shape(arg) {
		this._shape = arg;
	}
	get shape() {
		return this._shape;
	}
	set model(arg) {
		this._model = arg;
		if (this._initialized && this._type === "mesh") {
			this.system.doRecreatePhysicalShape(this);
		}
	}
	get model() {
		return this._model;
	}
	set render(arg) {
		this._render = arg;
		if (this._initialized && this._type === "mesh") {
			this.system.doRecreatePhysicalShape(this);
		}
	}
	get render() {
		return this._render;
	}
	set checkVertexDuplicates(arg) {
		this._checkVertexDuplicates = arg;
	}
	get checkVertexDuplicates() {
		return this._checkVertexDuplicates;
	}
	_updateHasOffset() {
		this._hasOffset = !this._linearOffset.equals(Vec3.ZERO) || !this._angularOffset.equals(Quat.IDENTITY);
	}
	onAssetRemoved(asset) {
		asset.off("remove", this.onAssetRemoved, this);
		if (this._asset === asset.id) {
			this.asset = null;
		}
	}
	onRenderAssetRemoved(asset) {
		asset.off("remove", this.onRenderAssetRemoved, this);
		if (this._renderAsset === asset.id) {
			this.renderAsset = null;
		}
	}
	_onInsert(parent) {
		const world = this.system.physicsWorld;
		if (!world) {
			return;
		}
		if (this._compoundParent) {
			this.system.recreatePhysicalShapes(this);
		} else if (!this.entity.rigidbody) {
			let ancestor = this.entity.parent;
			while (ancestor) {
				if (ancestor.collision && ancestor.collision.type === "compound") {
					if (world.getCompoundChildCount(ancestor.collision.shape) === 0) {
						this.system.recreatePhysicalShapes(ancestor.collision);
					} else {
						this.system.recreatePhysicalShapes(this);
					}
					break;
				}
				ancestor = ancestor.parent;
			}
		}
	}
	_updateEachDescendantTransform(entity) {
		if (!entity.collision || entity.collision._compoundParent !== this.collision._compoundParent) {
			return;
		}
		this.collision.system.updateCompoundChildTransform(entity, false);
	}
	_updateCompound() {
		const entity = this.entity;
		if (entity._dirtyWorld) {
			let dirty = entity._dirtyLocal;
			let parent = entity;
			while (parent && !dirty) {
				if (parent.collision && parent.collision === this._compoundParent) {
					break;
				}
				if (parent._dirtyLocal) {
					dirty = true;
				}
				parent = parent.parent;
			}
			if (dirty) {
				entity.forEach(this._updateEachDescendantTransform, entity);
				const bodyComponent = this._compoundParent.entity.rigidbody;
				if (bodyComponent) {
					bodyComponent.activate();
				}
			}
		}
	}
	getShapePosition() {
		const pos = this.entity.getPosition();
		if (this._hasOffset) {
			const rot = this.entity.getRotation();
			const lo = this._linearOffset;
			_quat.copy(rot).transformVector(lo, _vec3);
			return _vec3.add(pos);
		}
		return pos;
	}
	getShapeRotation() {
		const rot = this.entity.getRotation();
		if (this._hasOffset) {
			return _quat.copy(rot).mul(this._angularOffset);
		}
		return rot;
	}
	onEnable() {
		if (this._type === "mesh" && (this._asset || this._renderAsset) && this._initialized) {
			const asset = this.system.app.assets.get(this._asset || this._renderAsset);
			if (asset && (!asset.resource || !this._shape)) {
				this.system.recreatePhysicalShapes(this);
				return;
			}
		}
		if (this.entity.rigidbody) {
			if (this.entity.rigidbody.enabled) {
				this.entity.rigidbody.enableSimulation();
			}
		} else if (this._compoundParent && this !== this._compoundParent) {
			if (this.system.physicsWorld.getCompoundChildCount(this._compoundParent.shape) === 0) {
				this.system.recreatePhysicalShapes(this._compoundParent);
			} else {
				this.system.updateCompoundChildTransform(this.entity, true);
				if (this._compoundParent.entity.rigidbody) {
					this._compoundParent.entity.rigidbody.activate();
				}
			}
		} else if (this.entity.trigger) {
			this.entity.trigger.enable();
		}
	}
	onDisable() {
		if (this.entity.rigidbody) {
			this.entity.rigidbody.disableSimulation();
		} else if (this._compoundParent && this !== this._compoundParent) {
			if (!this._compoundParent.entity._destroying) {
				this.system._removeCompoundChild(this._compoundParent, this._shape);
				if (this._compoundParent.entity.rigidbody) {
					this._compoundParent.entity.rigidbody.activate();
				}
			}
		} else if (this.entity.trigger) {
			this.entity.trigger.disable();
		}
	}
	onBeforeRemove() {
		if (this.asset) {
			this.asset = null;
		}
		if (this.renderAsset) {
			this.renderAsset = null;
		}
		this.entity.off("insert", this._onInsert, this);
		this.off();
	}
};

var BODYTYPE_STATIC = "static";
var BODYTYPE_DYNAMIC = "dynamic";
var BODYTYPE_KINEMATIC = "kinematic";
var BODYFLAG_STATIC_OBJECT = 1;
var BODYFLAG_KINEMATIC_OBJECT = 2;
var BODYFLAG_NORESPONSE_OBJECT = 4;
var BODYSTATE_ACTIVE_TAG = 1;
var BODYSTATE_ISLAND_SLEEPING = 2;
var BODYSTATE_WANTS_DEACTIVATION = 3;
var BODYSTATE_DISABLE_DEACTIVATION = 4;
var BODYSTATE_DISABLE_SIMULATION = 5;
var BODYGROUP_NONE = 0;
var BODYGROUP_DEFAULT = 1;
var BODYGROUP_DYNAMIC = 1;
var BODYGROUP_STATIC = 2;
var BODYGROUP_KINEMATIC = 4;
var BODYGROUP_ENGINE_1 = 8;
var BODYGROUP_TRIGGER = 16;
var BODYGROUP_ENGINE_2 = 32;
var BODYGROUP_ENGINE_3 = 64;
var BODYGROUP_USER_1 = 128;
var BODYGROUP_USER_2 = 256;
var BODYGROUP_USER_3 = 512;
var BODYGROUP_USER_4 = 1024;
var BODYGROUP_USER_5 = 2048;
var BODYGROUP_USER_6 = 4096;
var BODYGROUP_USER_7 = 8192;
var BODYGROUP_USER_8 = 16384;
var BODYMASK_NONE = 0;
var BODYMASK_ALL = 65535;
var BODYMASK_STATIC = 2;
var BODYMASK_NOT_STATIC = 65535 ^ 2;
var BODYMASK_NOT_STATIC_KINEMATIC = 65535 ^ (2 | 4);

var _position = new Vec3();
var _rotation = new Quat();
var Trigger = class {
	constructor(app2, component) {
		this.entity = component.entity;
		this.component = component;
		this.app = app2;
		this.initialize();
	}
	initialize() {
		const entity = this.entity;
		const shape = this.component.shape;
		const world = this.app.systems.rigidbody.physicsWorld;
		if (shape && world) {
			if (entity.trigger) {
				entity.trigger.destroy();
			}
			this._getEntityTransform(_position, _rotation);
			const body = world.createBody({
				type: BODYTYPE_DYNAMIC,
				mass: 1,
				shape,
				position: _position,
				rotation: _rotation,
				entity,
				noContactResponse: true
			});
			body.setRestitution(0);
			body.setFriction(0);
			body.setDamping(0, 0);
			body.setLinearFactor(Vec3.ZERO);
			body.setAngularFactor(Vec3.ZERO);
			this.body = body;
			if (this.component.enabled && entity.enabled) {
				this.enable();
			}
		}
	}
	destroy() {
		if (!this.body) return;
		this.disable();
		this.app.systems.rigidbody.physicsWorld.destroyBody(this.body);
		this.body = null;
	}
	_getEntityTransform(position5, rotation7) {
		position5.copy(this.component.getShapePosition());
		rotation7.copy(this.component.getShapeRotation());
	}
	updateTransform() {
		this._getEntityTransform(_position, _rotation);
		this.body.setTransform(_position, _rotation);
	}
	enable() {
		if (!this.body) return;
		this.app.systems.rigidbody.addTrigger(this);
		this.updateTransform();
	}
	disable() {
		if (!this.body) return;
		this.app.systems.rigidbody.removeTrigger(this);
	}
};

var mat42 = new Mat4();
var p1 = new Vec3();
var p2 = new Vec3();
var p3 = new Vec3();
var quat2 = new Quat();
var quat22 = new Quat();
var _properties3 = [
	"halfExtents",
	"radius",
	"axis",
	"height",
	"convexHull",
	"model",
	"asset",
	"render",
	"renderAsset",
	"linearOffset",
	"angularOffset",
	"checkVertexDuplicates"
];
var collisionImpls = {
	box: {
		createPhysicalShape: (system, entity, component) => system.physicsWorld?.createShape({
			type: "box",
			halfExtents: component.halfExtents
		})
	},
	sphere: {
		createPhysicalShape: (system, entity, component) => system.physicsWorld?.createShape({
			type: "sphere",
			radius: component.radius
		})
	},
	capsule: {
		createPhysicalShape: (system, entity, component) => system.physicsWorld?.createShape({
			type: "capsule",
			axis: component.axis,
			radius: component.radius,
			height: component.height
		})
	},
	cylinder: {
		createPhysicalShape: (system, entity, component) => system.physicsWorld?.createShape({
			type: "cylinder",
			axis: component.axis,
			radius: component.radius,
			height: component.height
		})
	},
	cone: {
		createPhysicalShape: (system, entity, component) => system.physicsWorld?.createShape({
			type: "cone",
			axis: component.axis,
			radius: component.radius,
			height: component.height
		})
	},
	mesh: {
		// the model comes from assets - no placeholder is created
		beforeInitialize() {
		},
		createPhysicalShape: createMeshShape,
		recreatePhysicalShapes: recreateMeshShapes,
		updateTransform: updateMeshTransform
	},
	compound: {
		createPhysicalShape: (system, entity, component) => system.physicsWorld?.createShape({
			type: "compound"
		})
	}
};
function getImpl(type) {
	const impl = collisionImpls[type];
	return impl;
}
function beforeInitialize(system, component) {
	component._shape = null;
	const model = new Model();
	model.graph = new GraphNode();
	component._model = model;
}
function afterInitialize(system, component) {
	system.recreatePhysicalShapes(component);
	component._initialized = true;
}
function recreateBody(entity) {
	entity.rigidbody.disableSimulation();
	entity.rigidbody.createBody();
	if (entity.enabled && entity.rigidbody.enabled) {
		entity.rigidbody.enableSimulation();
	}
}
function recreateTrigger(system, entity, component) {
	if (!entity.trigger) {
		entity.trigger = new Trigger(system.app, component);
	} else {
		entity.trigger.initialize();
	}
}
function destroyShape(system, component) {
	if (component._shape) {
		system.physicsWorld.destroyShape(component._shape);
		component._shape = null;
	}
}
function beforeRemove(system, entity, component) {
	if (component._shape) {
		if (component._compoundParent && !component._compoundParent.entity._destroying) {
			system._removeCompoundChild(component._compoundParent, component._shape);
			if (component._compoundParent.entity.rigidbody) {
				component._compoundParent.entity.rigidbody.activate();
			}
		}
		component._compoundParent = null;
		destroyShape(system, component);
	}
}
function recreateShapes(system, component) {
	const entity = component.entity;
	const world = system.physicsWorld;
	if (world) {
		if (entity.trigger) {
			entity.trigger.destroy();
			delete entity.trigger;
		}
		if (component._shape) {
			if (component._compoundParent) {
				if (component !== component._compoundParent) {
					system._removeCompoundChild(component._compoundParent, component._shape);
				}
				if (component._compoundParent.entity.rigidbody) {
					component._compoundParent.entity.rigidbody.activate();
				}
			}
			destroyShape(system, component);
		}
		component._shape = getImpl(component._type).createPhysicalShape(system, entity, component);
		const firstCompoundChild = !component._compoundParent;
		if (component._type === "compound" && (!component._compoundParent || component === component._compoundParent)) {
			component._compoundParent = component;
			entity.forEach(system._addEachDescendant, component);
		} else if (component._type !== "compound") {
			if (!entity.rigidbody) {
				component._compoundParent = null;
				let parent = entity.parent;
				while (parent) {
					if (parent.collision && parent.collision.type === "compound") {
						component._compoundParent = parent.collision;
						break;
					}
					parent = parent.parent;
				}
			}
		}
		if (component._compoundParent) {
			if (component !== component._compoundParent) {
				if (firstCompoundChild && world.getCompoundChildCount(component._compoundParent.shape) === 0) {
					system.recreatePhysicalShapes(component._compoundParent);
				} else {
					system.updateCompoundChildTransform(entity, true);
					if (component._compoundParent.entity.rigidbody) {
						component._compoundParent.entity.rigidbody.activate();
					}
				}
			}
		}
		if (entity.rigidbody) {
			recreateBody(entity);
		} else if (!component._compoundParent) {
			recreateTrigger(system, entity, component);
		}
	}
}
function updateShapeTransform(system, component, position5, rotation7, scale2) {
	if (component.entity.trigger) {
		component.entity.trigger.updateTransform();
	}
}
function createMeshSource(system, mesh, node, bakeScale, convexHull, checkDuplicates) {
	let positions = null;
	let stride = 0;
	let indices = null;
	let extracted = false;
	const extract = () => {
		if (extracted) return;
		extracted = true;
		if (convexHull) {
			positions = [];
			mesh.getPositions(positions);
			stride = 3;
		} else {
			const vb = mesh.vertexBuffer;
			const format = vb.getFormat();
			for (let i2 = 0; i2 < format.elements.length; i2++) {
				const element = format.elements[i2];
				if (element.name === SEMANTIC_POSITION) {
					positions = new Float32Array(vb.lock(), element.offset);
					stride = element.stride / 4;
					break;
				}
			}
			indices = [];
			mesh.getIndices(indices);
		}
	};
	const source = {
		id: mesh.id,
		get positions() {
			extract();
			return positions;
		},
		get stride() {
			extract();
			return stride;
		},
		get indices() {
			extract();
			return indices;
		},
		base: mesh.primitive[0].base,
		count: mesh.primitive[0].count,
		convexHull,
		checkDuplicates,
		bakeScale,
		shapeScale: node ? system._getNodeScaling(node) : null,
		position: new Vec3(),
		rotation: new Quat()
	};
	if (node) {
		system._getNodeTransform(node, null, source.position, source.rotation);
	}
	return source;
}
function createMeshShape(system, entity, component) {
	const world = system.physicsWorld;
	if (!world) return void 0;
	if (component._model || component._render) {
		const entityTransform = entity.getWorldTransform();
		const scale2 = entityTransform.getScale();
		const sources = [];
		let shapeScale = null;
		if (component._render) {
			const meshes = component._render.meshes;
			for (let i2 = 0; i2 < meshes.length; i2++) {
				sources.push(createMeshSource(system, meshes[i2], null, scale2, component._convexHull, component._checkVertexDuplicates));
			}
		} else if (component._model) {
			const meshInstances = component._model.meshInstances;
			for (let i2 = 0; i2 < meshInstances.length; i2++) {
				sources.push(createMeshSource(system, meshInstances[i2].mesh, meshInstances[i2].node, null, false, component._checkVertexDuplicates));
			}
			shapeScale = scale2;
		}
		component._builtWorldScale = scale2;
		return world.createShape({
			type: "mesh",
			sources,
			scale: shapeScale
		});
	}
	return void 0;
}
function doRecreateMeshShape(system, component) {
	const entity = component.entity;
	if (component._model || component._render) {
		destroyShape(system, component);
		component._shape = createMeshShape(system, entity, component);
		if (entity.rigidbody) {
			recreateBody(entity);
		} else {
			recreateTrigger(system, entity, component);
		}
	} else {
		beforeRemove(system, entity, component);
		system.onRemove(entity);
	}
}
function loadMeshAsset(system, component, id14, property) {
	const assets = system.app.assets;
	const privateProperty = `_${property}`;
	const previousPropertyValue = component[privateProperty];
	const onAssetFullyReady = (asset2) => {
		if (component[privateProperty] !== previousPropertyValue) {
			return;
		}
		component[privateProperty] = asset2.resource;
		doRecreateMeshShape(system, component);
	};
	const loadAndHandleAsset = (asset2) => {
		asset2.ready((asset3) => {
			if (asset3.data.containerAsset) {
				const containerAsset = assets.get(asset3.data.containerAsset);
				if (containerAsset.loaded) {
					onAssetFullyReady(asset3);
				} else {
					containerAsset.ready(() => {
						onAssetFullyReady(asset3);
					});
					assets.load(containerAsset);
				}
			} else {
				onAssetFullyReady(asset3);
			}
		});
		assets.load(asset2);
	};
	const asset = assets.get(id14);
	if (asset) {
		loadAndHandleAsset(asset);
	} else {
		assets.once(`add:${id14}`, loadAndHandleAsset);
	}
}
function recreateMeshShapes(system, component) {
	if (component._renderAsset || component._asset) {
		if (component.enabled && component.entity.enabled) {
			loadMeshAsset(
				system,
				component,
				component._renderAsset || component._asset,
				component._renderAsset ? "render" : "model"
			);
			return;
		}
	}
	doRecreateMeshShape(system, component);
}
function updateMeshTransform(system, component, position5, rotation7, scale2) {
	if (component.shape && component._builtWorldScale) {
		const entityTransform = component.entity.getWorldTransform();
		const worldScale = entityTransform.getScale();
		if (!worldScale.equals(component._builtWorldScale)) {
			doRecreateMeshShape(system, component);
		}
	}
	updateShapeTransform(system, component, position5, rotation7, scale2);
}
var CollisionComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "collision";
		this.ComponentType = CollisionComponent;
		this.on("beforeremove", this.onBeforeRemove, this);
		this.on("remove", this.onRemove, this);
	}
	get physicsWorld() {
		return this.app.systems.rigidbody?.physicsWorld ?? null;
	}
	initializeComponentData(component, data2) {
		if (data2.type) {
			component._type = data2.type;
		}
		let properties = _properties3;
		if (data2.asset !== void 0) {
			properties = properties.filter((p) => p !== "model" && p !== "render");
		} else if (data2.model !== void 0) {
			properties = properties.filter((p) => p !== "asset");
		}
		for (const property of properties) {
			if (data2[property] !== void 0) {
				component[property] = data2[property];
			}
		}
		const impl = getImpl(component._type);
		(impl.beforeInitialize ?? beforeInitialize)(this, component);
		super.initializeComponentData(component, data2);
		afterInitialize(this, component);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.collision;
		const data2 = {
			enabled: c2.enabled,
			type: c2.type
		};
		for (const property of _properties3) {
			data2[property] = c2[property];
		}
		return this.addComponent(clone, data2);
	}
	onBeforeRemove(entity, component) {
		beforeRemove(this, entity, component);
		component.onBeforeRemove();
		if (this.app.systems.rigidbody) {
			this.app.systems.rigidbody.clearEntityCollisions(entity);
		}
	}
	onRemove(entity) {
		if (entity.rigidbody && entity.rigidbody._body) {
			entity.rigidbody.disableSimulation();
		}
		if (entity.trigger) {
			entity.trigger.destroy();
			delete entity.trigger;
		}
	}
	updateCompoundChildTransform(entity, forceUpdate) {
		const parentComponent = entity.collision._compoundParent;
		if (parentComponent === entity.collision) return;
		if (entity.enabled && entity.collision.enabled && (entity._dirtyLocal || forceUpdate)) {
			this._getNodeTransform(entity, parentComponent.entity, p3, quat22);
			this.physicsWorld.updateCompoundChild(parentComponent.shape, entity.collision.shape, p3, quat22);
		}
	}
	_removeCompoundChild(collision, shape) {
		this.physicsWorld.removeCompoundChild(collision.shape, shape);
	}
	onTransformChanged(component, position5, rotation7, scale2) {
		const impl = getImpl(component.type);
		(impl.updateTransform ?? updateShapeTransform)(this, component, position5, rotation7, scale2);
	}
	// Destroys the previous collision type and creates a new one based on the new type provided
	changeType(component, previousType, newType) {
		beforeRemove(this, component.entity, component);
		this.onRemove(component.entity);
		const impl = getImpl(newType);
		(impl.beforeInitialize ?? beforeInitialize)(this, component);
		afterInitialize(this, component);
	}
	// Recreates rigid bodies or triggers for the specified component
	recreatePhysicalShapes(component) {
		const impl = getImpl(component.type);
		(impl.recreatePhysicalShapes ?? recreateShapes)(this, component);
	}
	doRecreatePhysicalShape(component) {
		doRecreateMeshShape(this, component);
	}
	_addEachDescendant(entity) {
		if (!entity.collision || entity.rigidbody) {
			return;
		}
		entity.collision._compoundParent = this;
		if (entity !== this.entity) {
			entity.collision.system.recreatePhysicalShapes(entity.collision);
		}
	}
	_calculateNodeRelativeTransform(node, relative) {
		if (node === relative) {
			const scale2 = node.getWorldTransform().getScale();
			mat42.setScale(scale2.x, scale2.y, scale2.z);
		} else {
			this._calculateNodeRelativeTransform(node.parent, relative);
			mat42.mul(node.getLocalTransform());
		}
	}
	_getNodeScaling(node) {
		return node.getWorldTransform().getScale();
	}
	_getNodeTransform(node, relative, position5, rotation7) {
		let pos, rot;
		if (relative) {
			this._calculateNodeRelativeTransform(node, relative);
			pos = p1;
			rot = quat2;
			mat42.getTranslation(pos);
			rot.setFromMat4(mat42);
		} else {
			pos = node.getPosition();
			rot = node.getRotation();
		}
		const component = node.collision;
		if (component && component._hasOffset) {
			const lo = component.linearOffset;
			const ao = component.angularOffset;
			const newOrigin = p2;
			quat2.copy(rot).transformVector(lo, newOrigin);
			newOrigin.add(pos);
			quat2.copy(rot).mul(ao);
			position5.copy(newOrigin);
			rotation7.copy(quat2);
		} else {
			position5.copy(pos);
			rotation7.copy(rot);
		}
	}
};

var _tempColor2 = new Color();
var _vertexFormatDeviceCache = new DeviceCache();
var ImageRenderable = class {
	constructor(entity, mesh, material) {
		this._entity = entity;
		this._element = entity.element;
		this.model = new Model();
		this.node = new GraphNode();
		this.model.graph = this.node;
		this.mesh = mesh;
		this.meshInstance = new MeshInstance(this.mesh, material, this.node);
		this.meshInstance.name = `ImageElement: ${entity.name}`;
		this.meshInstance.castShadow = false;
		this.meshInstance.receiveShadow = false;
		this._meshDirty = false;
		this.model.meshInstances.push(this.meshInstance);
		this._entity.addChild(this.model.graph);
		this.model._entity = this._entity;
		this.unmaskMeshInstance = null;
	}
	destroy() {
		this.setMaterial(null);
		this._element.removeModelFromLayers(this.model);
		this.model.destroy();
		this.model = null;
		this.node = null;
		this.mesh = null;
		this.meshInstance?.destroy();
		this.meshInstance = null;
		this.unmaskMeshInstance?.destroy();
		this.unmaskMeshInstance = null;
		this._entity = null;
		this._element = null;
	}
	setMesh(mesh) {
		if (!this.meshInstance) return;
		this.mesh = mesh;
		this.meshInstance.mesh = mesh;
		this.meshInstance.visible = !!mesh;
		if (this.unmaskMeshInstance) {
			this.unmaskMeshInstance.mesh = mesh;
		}
		this.forceUpdateAabb();
	}
	setMask(mask) {
		if (!this.meshInstance) return;
		if (this._entity.enabled && this._element.enabled) {
			this._element.removeModelFromLayers(this.model);
		}
		if (mask) {
			this.unmaskMeshInstance = new MeshInstance(this.mesh, this.meshInstance.material, this.node);
			this.unmaskMeshInstance.name = `Unmask: ${this._entity.name}`;
			this.unmaskMeshInstance.castShadow = false;
			this.unmaskMeshInstance.receiveShadow = false;
			this.unmaskMeshInstance.pick = false;
			this.model.meshInstances.push(this.unmaskMeshInstance);
			for (const name in this.meshInstance.parameters) {
				this.unmaskMeshInstance.setParameter(name, this.meshInstance.parameters[name].data);
			}
		} else {
			const idx = this.model.meshInstances.indexOf(this.unmaskMeshInstance);
			if (idx >= 0) {
				this.model.meshInstances.splice(idx, 1);
			}
		}
		if (this._entity.enabled && this._element.enabled) {
			this._element.addModelToLayers(this.model);
		}
		if (!mask) {
			this.unmaskMeshInstance?.destroy();
			this.unmaskMeshInstance = null;
		}
	}
	setMaterial(material) {
		if (!this.meshInstance) return;
		this.meshInstance.material = material;
		if (this.unmaskMeshInstance) {
			this.unmaskMeshInstance.material = material;
		}
	}
	setParameter(name, value) {
		if (!this.meshInstance) return;
		this.meshInstance.setParameter(name, value);
		if (this.unmaskMeshInstance) {
			this.unmaskMeshInstance.setParameter(name, value);
		}
	}
	deleteParameter(name) {
		if (!this.meshInstance) return;
		this.meshInstance.deleteParameter(name);
		if (this.unmaskMeshInstance) {
			this.unmaskMeshInstance.deleteParameter(name);
		}
	}
	setUnmaskDrawOrder() {
		if (!this.meshInstance) return;
		const getLastChild = function(e) {
			let last;
			const c2 = e.children;
			const l = c2.length;
			if (l) {
				for (let i2 = 0; i2 < l; i2++) {
					if (c2[i2].element) {
						last = c2[i2];
					}
				}
				if (!last) return null;
				const child = getLastChild(last);
				if (child) {
					return child;
				}
				return last;
			}
			return null;
		};
		if (this.unmaskMeshInstance) {
			const lastChild = getLastChild(this._entity);
			if (lastChild && lastChild.element) {
				this.unmaskMeshInstance.drawOrder = lastChild.element.drawOrder + lastChild.element.getMaskOffset();
			} else {
				this.unmaskMeshInstance.drawOrder = this.meshInstance.drawOrder + this._element.getMaskOffset();
			}
		}
	}
	setDrawOrder(drawOrder) {
		if (!this.meshInstance) {
			return;
		}
		this.meshInstance.drawOrder = drawOrder;
	}
	setCull(cull) {
		if (!this.meshInstance) return;
		const element = this._element;
		let visibleFn = null;
		if (cull && element._isScreenSpace()) {
			visibleFn = function(camera) {
				return element.isVisibleForCamera(camera);
			};
		}
		this.meshInstance.cull = cull;
		this.meshInstance.isVisibleFunc = visibleFn;
		if (this.unmaskMeshInstance) {
			this.unmaskMeshInstance.cull = cull;
			this.unmaskMeshInstance.isVisibleFunc = visibleFn;
		}
	}
	setScreenSpace(screenSpace) {
		if (!this.meshInstance) return;
		this.meshInstance.screenSpace = screenSpace;
		if (this.unmaskMeshInstance) {
			this.unmaskMeshInstance.screenSpace = screenSpace;
		}
	}
	setLayer(layer) {
		if (!this.meshInstance) return;
		this.meshInstance.layer = layer;
		if (this.unmaskMeshInstance) {
			this.unmaskMeshInstance.layer = layer;
		}
	}
	forceUpdateAabb(mask) {
		if (!this.meshInstance) return;
		this.meshInstance._aabbVer = -1;
		if (this.unmaskMeshInstance) {
			this.unmaskMeshInstance._aabbVer = -1;
		}
	}
	setAabbFunc(fn) {
		if (!this.meshInstance) return;
		this.meshInstance._updateAabbFunc = fn;
		if (this.unmaskMeshInstance) {
			this.unmaskMeshInstance._updateAabbFunc = fn;
		}
	}
};
var ImageElement = class {
	_evtSetMeshes = null;
	constructor(element) {
		this._element = element;
		this._entity = element.entity;
		this._system = element.system;
		this._textureAsset = null;
		this._texture = null;
		this._materialAsset = null;
		this._material = null;
		this._spriteAsset = null;
		this._sprite = null;
		this._spriteFrame = 0;
		this._pixelsPerUnit = null;
		this._targetAspectRatio = -1;
		this._rect = new Vec4(0, 0, 1, 1);
		this._mask = false;
		this._maskRef = 0;
		this._outerScale = new Vec2();
		this._outerScaleUniform = new Float32Array(2);
		this._innerOffset = new Vec4();
		this._innerOffsetUniform = new Float32Array(4);
		this._atlasRect = new Vec4();
		this._atlasRectUniform = new Float32Array(4);
		this._defaultMesh = this._createMesh();
		this._renderable = new ImageRenderable(this._entity, this._defaultMesh, this._material);
		this._color = new Color(1, 1, 1, 1);
		this._colorUniform = new Float32Array([1, 1, 1]);
		this._updateRenderableEmissive();
		this._renderable.setParameter("material_opacity", 1);
		this._updateAabbFunc = this._updateAabb.bind(this);
		this._onScreenChange(this._element.screen);
		this._element.on("resize", this._onParentResizeOrPivotChange, this);
		this._element.on("set:pivot", this._onParentResizeOrPivotChange, this);
		this._element.on("screen:set:screenspace", this._onScreenSpaceChange, this);
		this._element.on("set:screen", this._onScreenChange, this);
		this._element.on("set:draworder", this._onDrawOrderChange, this);
		this._element.on("screen:set:resolution", this._onResolutionChange, this);
		if (!element._beingInitialized && element.enabled && element.entity.enabled) {
			this.onEnable();
		}
	}
	destroy() {
		this.textureAsset = null;
		this.spriteAsset = null;
		this.materialAsset = null;
		this._renderable.setMesh(this._defaultMesh);
		this._renderable.destroy();
		this._defaultMesh = null;
		this._element.off("resize", this._onParentResizeOrPivotChange, this);
		this._element.off("set:pivot", this._onParentResizeOrPivotChange, this);
		this._element.off("screen:set:screenspace", this._onScreenSpaceChange, this);
		this._element.off("set:screen", this._onScreenChange, this);
		this._element.off("set:draworder", this._onDrawOrderChange, this);
		this._element.off("screen:set:resolution", this._onResolutionChange, this);
	}
	_onResolutionChange(res) {
	}
	_onParentResizeOrPivotChange() {
		if (this._renderable.mesh) {
			this._updateMesh(this._renderable.mesh);
		}
	}
	_onScreenSpaceChange(value) {
		this._updateMaterial(value);
	}
	_onScreenChange(screen, previous) {
		if (screen) {
			this._updateMaterial(screen.screen.screenSpace);
		} else {
			this._updateMaterial(false);
		}
	}
	_onDrawOrderChange(order) {
		this._renderable.setDrawOrder(order);
		if (this.mask && this._element.screen) {
			this._element.screen.screen.once("syncdraworder", function() {
				this._renderable.setUnmaskDrawOrder();
			}, this);
		}
	}
	// Returns true if we are using a material
	// other than the default materials
	_hasUserMaterial() {
		return !!this._materialAsset || !!this._material && this._system.defaultImageMaterials.indexOf(this._material) === -1;
	}
	_use9Slicing() {
		return this.sprite && (this.sprite.renderMode === SPRITE_RENDERMODE_SLICED || this.sprite.renderMode === SPRITE_RENDERMODE_TILED);
	}
	_updateMaterial(screenSpace) {
		const mask = !!this._mask;
		const nineSliced = !!(this.sprite && this.sprite.renderMode === SPRITE_RENDERMODE_SLICED);
		const nineTiled = !!(this.sprite && this.sprite.renderMode === SPRITE_RENDERMODE_TILED);
		if (!this._hasUserMaterial()) {
			this._material = this._system.getImageElementMaterial(screenSpace, mask, nineSliced, nineTiled);
		}
		if (this._renderable) {
			this._renderable.setCull(!this._element._isScreenSpace() || this._element._isScreenCulled());
			this._renderable.setMaterial(this._material);
			this._renderable.setScreenSpace(screenSpace);
			this._renderable.setLayer(screenSpace ? LAYER_HUD : LAYER_WORLD);
		}
	}
	// build a quad for the image
	_createMesh() {
		const element = this._element;
		const w = element.calculatedWidth;
		const h2 = element.calculatedHeight;
		const r = this._rect;
		const device = this._system.app.graphicsDevice;
		const vertexData = new Float32Array([
			w,
			0,
			0,
			// position
			0,
			0,
			1,
			// normal
			r.x + r.z,
			1 - r.y,
			// uv
			w,
			h2,
			0,
			// position
			0,
			0,
			1,
			// normal
			r.x + r.z,
			1 - (r.y + r.w),
			// uv
			0,
			0,
			0,
			// position
			0,
			0,
			1,
			// normal
			r.x,
			1 - r.y,
			// uv
			0,
			h2,
			0,
			// position
			0,
			0,
			1,
			// normal
			r.x,
			1 - (r.y + r.w)
			// uv
		]);
		const vertexFormat = _vertexFormatDeviceCache.get(device, () => {
			return new VertexFormat(device, [
				{ semantic: SEMANTIC_POSITION, components: 3, type: TYPE_FLOAT32 },
				{ semantic: SEMANTIC_NORMAL, components: 3, type: TYPE_FLOAT32 },
				{ semantic: SEMANTIC_TEXCOORD0, components: 2, type: TYPE_FLOAT32 }
			]);
		});
		const vertexBuffer = new VertexBuffer(device, vertexFormat, 4, {
			data: vertexData.buffer
		});
		const mesh = new Mesh(device);
		mesh.vertexBuffer = vertexBuffer;
		mesh.primitive[0].type = PRIMITIVE_TRISTRIP;
		mesh.primitive[0].base = 0;
		mesh.primitive[0].count = 4;
		mesh.primitive[0].indexed = false;
		mesh.aabb.setMinMax(Vec3.ZERO, new Vec3(w, h2, 0));
		this._updateMesh(mesh);
		return mesh;
	}
	_updateMesh(mesh) {
		const element = this._element;
		let w = element.calculatedWidth;
		let h2 = element.calculatedHeight;
		if (element.fitMode !== FITMODE_STRETCH && this._targetAspectRatio > 0) {
			const actualRatio = element.calculatedWidth / element.calculatedHeight;
			if (element.fitMode === FITMODE_CONTAIN && actualRatio > this._targetAspectRatio || element.fitMode === FITMODE_COVER && actualRatio < this._targetAspectRatio) {
				w = element.calculatedHeight * this._targetAspectRatio;
			} else {
				h2 = element.calculatedWidth / this._targetAspectRatio;
			}
		}
		const screenSpace = element._isScreenSpace();
		this._updateMaterial(screenSpace);
		if (this._renderable) this._renderable.forceUpdateAabb();
		if (this.sprite && (this.sprite.renderMode === SPRITE_RENDERMODE_SLICED || this.sprite.renderMode === SPRITE_RENDERMODE_TILED)) {
			const frameData = this._sprite.atlas.frames[this._sprite.frameKeys[this._spriteFrame]];
			const borderWidthScale = 2 / frameData.rect.z;
			const borderHeightScale = 2 / frameData.rect.w;
			this._innerOffset.set(
				frameData.border.x * borderWidthScale,
				frameData.border.y * borderHeightScale,
				frameData.border.z * borderWidthScale,
				frameData.border.w * borderHeightScale
			);
			const tex = this.sprite.atlas.texture;
			this._atlasRect.set(
				frameData.rect.x / tex.width,
				frameData.rect.y / tex.height,
				frameData.rect.z / tex.width,
				frameData.rect.w / tex.height
			);
			const ppu = this._pixelsPerUnit !== null ? this._pixelsPerUnit : this.sprite.pixelsPerUnit;
			const scaleMulX = frameData.rect.z / ppu;
			const scaleMulY = frameData.rect.w / ppu;
			this._outerScale.set(Math.max(w, this._innerOffset.x * scaleMulX), Math.max(h2, this._innerOffset.y * scaleMulY));
			let scaleX = scaleMulX;
			let scaleY = scaleMulY;
			this._outerScale.x /= scaleMulX;
			this._outerScale.y /= scaleMulY;
			scaleX *= math.clamp(w / (this._innerOffset.x * scaleMulX), 1e-4, 1);
			scaleY *= math.clamp(h2 / (this._innerOffset.y * scaleMulY), 1e-4, 1);
			if (this._renderable) {
				this._innerOffsetUniform[0] = this._innerOffset.x;
				this._innerOffsetUniform[1] = this._innerOffset.y;
				this._innerOffsetUniform[2] = this._innerOffset.z;
				this._innerOffsetUniform[3] = this._innerOffset.w;
				this._renderable.setParameter("innerOffset", this._innerOffsetUniform);
				this._atlasRectUniform[0] = this._atlasRect.x;
				this._atlasRectUniform[1] = this._atlasRect.y;
				this._atlasRectUniform[2] = this._atlasRect.z;
				this._atlasRectUniform[3] = this._atlasRect.w;
				this._renderable.setParameter("atlasRect", this._atlasRectUniform);
				this._outerScaleUniform[0] = this._outerScale.x;
				this._outerScaleUniform[1] = this._outerScale.y;
				this._renderable.setParameter("outerScale", this._outerScaleUniform);
				this._renderable.setAabbFunc(this._updateAabbFunc);
				this._renderable.node.setLocalScale(scaleX, scaleY, 1);
				this._renderable.node.setLocalPosition((0.5 - element.pivot.x) * w, (0.5 - element.pivot.y) * h2, 0);
			}
		} else {
			const vb = mesh.vertexBuffer;
			const vertexDataF32 = new Float32Array(vb.lock());
			const hp = element.pivot.x;
			const vp = element.pivot.y;
			vertexDataF32[0] = w - hp * w;
			vertexDataF32[1] = 0 - vp * h2;
			vertexDataF32[8] = w - hp * w;
			vertexDataF32[9] = h2 - vp * h2;
			vertexDataF32[16] = 0 - hp * w;
			vertexDataF32[17] = 0 - vp * h2;
			vertexDataF32[24] = 0 - hp * w;
			vertexDataF32[25] = h2 - vp * h2;
			let atlasTextureWidth = 1;
			let atlasTextureHeight = 1;
			let rect = this._rect;
			if (this._sprite && this._sprite.frameKeys[this._spriteFrame] && this._sprite.atlas) {
				const frame = this._sprite.atlas.frames[this._sprite.frameKeys[this._spriteFrame]];
				if (frame) {
					rect = frame.rect;
					atlasTextureWidth = this._sprite.atlas.texture.width;
					atlasTextureHeight = this._sprite.atlas.texture.height;
				}
			}
			vertexDataF32[6] = (rect.x + rect.z) / atlasTextureWidth;
			vertexDataF32[7] = 1 - rect.y / atlasTextureHeight;
			vertexDataF32[14] = (rect.x + rect.z) / atlasTextureWidth;
			vertexDataF32[15] = 1 - (rect.y + rect.w) / atlasTextureHeight;
			vertexDataF32[22] = rect.x / atlasTextureWidth;
			vertexDataF32[23] = 1 - rect.y / atlasTextureHeight;
			vertexDataF32[30] = rect.x / atlasTextureWidth;
			vertexDataF32[31] = 1 - (rect.y + rect.w) / atlasTextureHeight;
			vb.unlock();
			const min = new Vec3(0 - hp * w, 0 - vp * h2, 0);
			const max = new Vec3(w - hp * w, h2 - vp * h2, 0);
			mesh.aabb.setMinMax(min, max);
			if (this._renderable) {
				this._renderable.node.setLocalScale(1, 1, 1);
				this._renderable.node.setLocalPosition(0, 0, 0);
				this._renderable.setAabbFunc(null);
			}
		}
		this._meshDirty = false;
	}
	// Gets the mesh from the sprite asset
	// if the sprite is 9-sliced or the default mesh from the
	// image element and calls _updateMesh or sets meshDirty to true
	// if the component is currently being initialized. Also updates
	// aspect ratio. We need to call _updateSprite every time
	// something related to the sprite asset changes
	_updateSprite() {
		let nineSlice = false;
		let mesh = null;
		this._targetAspectRatio = -1;
		if (this._sprite && this._sprite.atlas) {
			mesh = this._sprite.meshes[this.spriteFrame];
			nineSlice = this._sprite.renderMode === SPRITE_RENDERMODE_SLICED || this._sprite.renderMode === SPRITE_RENDERMODE_TILED;
			const frameData = this._sprite.atlas.frames[this._sprite.frameKeys[this._spriteFrame]];
			if (frameData?.rect.w > 0) {
				this._targetAspectRatio = frameData.rect.z / frameData.rect.w;
			}
		}
		this.mesh = nineSlice ? mesh : this._defaultMesh;
		this.refreshMesh();
	}
	refreshMesh() {
		if (this.mesh) {
			if (!this._element._beingInitialized) {
				this._updateMesh(this.mesh);
			} else {
				this._meshDirty = true;
			}
		}
	}
	// updates AABB while 9-slicing
	_updateAabb(aabb3) {
		aabb3.center.set(0, 0, 0);
		aabb3.halfExtents.set(this._outerScale.x * 0.5, this._outerScale.y * 0.5, 1e-3);
		aabb3.setFromTransformedAabb(aabb3, this._renderable.node.getWorldTransform());
		return aabb3;
	}
	_toggleMask() {
		this._element._dirtifyMask();
		const screenSpace = this._element._isScreenSpace();
		this._updateMaterial(screenSpace);
		this._renderable.setMask(!!this._mask);
	}
	_onMaterialLoad(asset) {
		this.material = asset.resource;
	}
	_onMaterialAdded(asset) {
		this._system.app.assets.off(`add:${asset.id}`, this._onMaterialAdded, this);
		if (this._materialAsset === asset.id) {
			this._bindMaterialAsset(asset);
		}
	}
	_bindMaterialAsset(asset) {
		if (!this._entity.enabled) return;
		asset.on("load", this._onMaterialLoad, this);
		asset.on("change", this._onMaterialChange, this);
		asset.on("remove", this._onMaterialRemove, this);
		if (asset.resource) {
			this._onMaterialLoad(asset);
		} else {
			this._system.app.assets.load(asset);
		}
	}
	_unbindMaterialAsset(asset) {
		asset.off("load", this._onMaterialLoad, this);
		asset.off("change", this._onMaterialChange, this);
		asset.off("remove", this._onMaterialRemove, this);
	}
	_onMaterialChange() {
	}
	_onMaterialRemove() {
	}
	_onTextureAdded(asset) {
		this._system.app.assets.off(`add:${asset.id}`, this._onTextureAdded, this);
		if (this._textureAsset === asset.id) {
			this._bindTextureAsset(asset);
		}
	}
	_bindTextureAsset(asset) {
		if (!this._entity.enabled) return;
		asset.on("load", this._onTextureLoad, this);
		asset.on("change", this._onTextureChange, this);
		asset.on("remove", this._onTextureRemove, this);
		if (asset.resource) {
			this._onTextureLoad(asset);
		} else {
			this._system.app.assets.load(asset);
		}
	}
	_unbindTextureAsset(asset) {
		asset.off("load", this._onTextureLoad, this);
		asset.off("change", this._onTextureChange, this);
		asset.off("remove", this._onTextureRemove, this);
	}
	_onTextureLoad(asset) {
		this.texture = asset.resource;
	}
	_onTextureChange(asset) {
	}
	_onTextureRemove(asset) {
	}
	// When sprite asset is added bind it
	_onSpriteAssetAdded(asset) {
		this._system.app.assets.off(`add:${asset.id}`, this._onSpriteAssetAdded, this);
		if (this._spriteAsset === asset.id) {
			this._bindSpriteAsset(asset);
		}
	}
	// Hook up event handlers on sprite asset
	_bindSpriteAsset(asset) {
		if (!this._entity.enabled) return;
		asset.on("load", this._onSpriteAssetLoad, this);
		asset.on("change", this._onSpriteAssetChange, this);
		asset.on("remove", this._onSpriteAssetRemove, this);
		if (asset.resource) {
			this._onSpriteAssetLoad(asset);
		} else {
			this._system.app.assets.load(asset);
		}
	}
	_unbindSpriteAsset(asset) {
		asset.off("load", this._onSpriteAssetLoad, this);
		asset.off("change", this._onSpriteAssetChange, this);
		asset.off("remove", this._onSpriteAssetRemove, this);
		if (asset.data.textureAtlasAsset) {
			this._system.app.assets.off(`load:${asset.data.textureAtlasAsset}`, this._onTextureAtlasLoad, this);
		}
	}
	// When sprite asset is loaded make sure the texture atlas asset is loaded too
	// If so then set the sprite, otherwise wait for the atlas to be loaded first
	_onSpriteAssetLoad(asset) {
		if (!asset || !asset.resource) {
			this.sprite = null;
		} else {
			if (!asset.resource.atlas) {
				const atlasAssetId = asset.data.textureAtlasAsset;
				if (atlasAssetId) {
					const assets = this._system.app.assets;
					assets.off(`load:${atlasAssetId}`, this._onTextureAtlasLoad, this);
					assets.once(`load:${atlasAssetId}`, this._onTextureAtlasLoad, this);
				}
			} else {
				this.sprite = asset.resource;
			}
		}
	}
	// When the sprite asset changes reset it
	_onSpriteAssetChange(asset) {
		this._onSpriteAssetLoad(asset);
	}
	_onSpriteAssetRemove(asset) {
	}
	// Hook up event handlers on sprite asset
	_bindSprite(sprite) {
		this._evtSetMeshes = sprite.on("set:meshes", this._onSpriteMeshesChange, this);
		sprite.on("set:pixelsPerUnit", this._onSpritePpuChange, this);
		sprite.on("set:atlas", this._onAtlasTextureChange, this);
		if (sprite.atlas) {
			sprite.atlas.on("set:texture", this._onAtlasTextureChange, this);
		}
	}
	_unbindSprite(sprite) {
		this._evtSetMeshes?.off();
		this._evtSetMeshes = null;
		sprite.off("set:pixelsPerUnit", this._onSpritePpuChange, this);
		sprite.off("set:atlas", this._onAtlasTextureChange, this);
		if (sprite.atlas) {
			sprite.atlas.off("set:texture", this._onAtlasTextureChange, this);
		}
	}
	_onSpriteMeshesChange() {
		if (this._sprite) {
			this._spriteFrame = math.clamp(this._spriteFrame, 0, this._sprite.frameKeys.length - 1);
		}
		this._updateSprite();
	}
	_onSpritePpuChange() {
		if (this.sprite.renderMode !== SPRITE_RENDERMODE_SIMPLE && this._pixelsPerUnit === null) {
			this._updateSprite();
		}
	}
	_onAtlasTextureChange() {
		if (this.sprite && this.sprite.atlas && this.sprite.atlas.texture) {
			this._renderable.setParameter("texture_emissiveMap", this._sprite.atlas.texture);
			this._renderable.setParameter("texture_opacityMap", this._sprite.atlas.texture);
		} else {
			this._renderable.deleteParameter("texture_emissiveMap");
			this._renderable.deleteParameter("texture_opacityMap");
		}
	}
	// When atlas is loaded try to reset the sprite asset
	_onTextureAtlasLoad(atlasAsset) {
		const spriteAsset = this._spriteAsset;
		if (spriteAsset instanceof Asset) {
			this._onSpriteAssetLoad(spriteAsset);
		} else {
			this._onSpriteAssetLoad(this._system.app.assets.get(spriteAsset));
		}
	}
	onEnable() {
		if (this._materialAsset) {
			const asset = this._system.app.assets.get(this._materialAsset);
			if (asset && asset.resource !== this._material) {
				this._bindMaterialAsset(asset);
			}
		}
		if (this._textureAsset) {
			const asset = this._system.app.assets.get(this._textureAsset);
			if (asset && asset.resource !== this._texture) {
				this._bindTextureAsset(asset);
			}
		}
		if (this._spriteAsset) {
			const asset = this._system.app.assets.get(this._spriteAsset);
			if (asset && asset.resource !== this._sprite) {
				this._bindSpriteAsset(asset);
			}
		}
		this._element.addModelToLayers(this._renderable.model);
	}
	onDisable() {
		this._element.removeModelFromLayers(this._renderable.model);
	}
	_setStencil(stencilParams) {
		this._renderable.meshInstance.stencilFront = stencilParams;
		this._renderable.meshInstance.stencilBack = stencilParams;
		let ref = 0;
		if (this._element.maskedBy) {
			ref = this._element.maskedBy.element._image._maskRef;
		}
		if (this._renderable.unmaskMeshInstance) {
			const sp = new StencilParameters({
				ref: ref + 1,
				func: FUNC_EQUAL,
				zpass: STENCILOP_DECREMENT
			});
			this._renderable.unmaskMeshInstance.stencilFront = sp;
			this._renderable.unmaskMeshInstance.stencilBack = sp;
		}
	}
	_updateRenderableEmissive() {
		_tempColor2.linear(this._color);
		this._colorUniform[0] = _tempColor2.r;
		this._colorUniform[1] = _tempColor2.g;
		this._colorUniform[2] = _tempColor2.b;
		this._renderable.setParameter("material_emissive", this._colorUniform);
	}
	set color(value) {
		const { r, g, b } = value;
		if (this._color.r !== r || this._color.g !== g || this._color.b !== b) {
			this._color.r = r;
			this._color.g = g;
			this._color.b = b;
			this._updateRenderableEmissive();
		}
		if (this._element) {
			this._element.fire("set:color", this._color);
		}
	}
	get color() {
		return this._color;
	}
	set opacity(value) {
		if (value !== this._color.a) {
			this._color.a = value;
			this._renderable.setParameter("material_opacity", value);
		}
		if (this._element) {
			this._element.fire("set:opacity", value);
		}
	}
	get opacity() {
		return this._color.a;
	}
	set rect(value) {
		let x3, y2, z2, w;
		if (value instanceof Vec4) {
			x3 = value.x;
			y2 = value.y;
			z2 = value.z;
			w = value.w;
		} else {
			x3 = value[0];
			y2 = value[1];
			z2 = value[2];
			w = value[3];
		}
		if (x3 === this._rect.x && y2 === this._rect.y && z2 === this._rect.z && w === this._rect.w) {
			return;
		}
		this._rect.set(x3, y2, z2, w);
		if (this._renderable.mesh) {
			if (!this._element._beingInitialized) {
				this._updateMesh(this._renderable.mesh);
			} else {
				this._meshDirty = true;
			}
		}
	}
	get rect() {
		return this._rect;
	}
	_removeMaterialAssetEvents() {
		if (this._materialAsset) {
			const assets = this._system.app.assets;
			assets.off(`add:${this._materialAsset}`, this._onMaterialAdded, this);
			const asset = assets.get(this._materialAsset);
			if (asset) {
				asset.off("load", this._onMaterialLoad, this);
				asset.off("change", this._onMaterialChange, this);
				asset.off("remove", this._onMaterialRemove, this);
			}
		}
	}
	set material(value) {
		if (this._material === value) return;
		if (!value) {
			const screenSpace = this._element._isScreenSpace();
			if (this.mask) {
				value = screenSpace ? this._system.defaultScreenSpaceImageMaskMaterial : this._system.defaultImageMaskMaterial;
			} else {
				value = screenSpace ? this._system.defaultScreenSpaceImageMaterial : this._system.defaultImageMaterial;
			}
		}
		this._material = value;
		if (this._materialAsset) {
			const asset = this._system.app.assets.get(this._materialAsset);
			if (!asset || asset.resource !== value) {
				this._removeMaterialAssetEvents();
				this._materialAsset = null;
			}
		}
		if (value) {
			this._renderable.setMaterial(value);
			if (this._hasUserMaterial()) {
				this._renderable.deleteParameter("material_opacity");
				this._renderable.deleteParameter("material_emissive");
			} else {
				this._updateRenderableEmissive();
				this._renderable.setParameter("material_opacity", this._color.a);
			}
		}
	}
	get material() {
		return this._material;
	}
	set materialAsset(value) {
		const assets = this._system.app.assets;
		let _id = value;
		if (value instanceof Asset) {
			_id = value.id;
		}
		if (this._materialAsset !== _id) {
			this._removeMaterialAssetEvents();
			this._materialAsset = _id;
			if (this._materialAsset) {
				const asset = assets.get(this._materialAsset);
				if (!asset) {
					this._materialAsset = null;
					this.material = null;
					this._materialAsset = _id;
					assets.on(`add:${this._materialAsset}`, this._onMaterialAdded, this);
				} else {
					this._bindMaterialAsset(asset);
				}
			} else {
				this._materialAsset = null;
				this.material = null;
				this._materialAsset = _id;
			}
		}
	}
	get materialAsset() {
		return this._materialAsset;
	}
	set texture(value) {
		if (this._texture === value) return;
		if (this._textureAsset) {
			const textureAsset = this._system.app.assets.get(this._textureAsset);
			if (textureAsset && textureAsset.resource !== value) {
				this.textureAsset = null;
			}
		}
		this._texture = value;
		if (value) {
			if (this._spriteAsset) {
				this.spriteAsset = null;
			}
			this._renderable.setParameter("texture_emissiveMap", this._texture);
			this._renderable.setParameter("texture_opacityMap", this._texture);
			this._updateRenderableEmissive();
			this._renderable.setParameter("material_opacity", this._color.a);
			const newAspectRatio = this._texture.width / this._texture.height;
			if (newAspectRatio !== this._targetAspectRatio) {
				this._targetAspectRatio = newAspectRatio;
				if (this._element.fitMode !== FITMODE_STRETCH) {
					this.refreshMesh();
				}
			}
		} else {
			this._renderable.deleteParameter("texture_emissiveMap");
			this._renderable.deleteParameter("texture_opacityMap");
			this._targetAspectRatio = -1;
			if (this._element.fitMode !== FITMODE_STRETCH) {
				this.refreshMesh();
			}
		}
	}
	get texture() {
		return this._texture;
	}
	set textureAsset(value) {
		const assets = this._system.app.assets;
		let _id = value;
		if (value instanceof Asset) {
			_id = value.id;
		}
		if (this._textureAsset !== _id) {
			if (this._textureAsset) {
				assets.off(`add:${this._textureAsset}`, this._onTextureAdded, this);
				const _prev = assets.get(this._textureAsset);
				if (_prev) {
					_prev.off("load", this._onTextureLoad, this);
					_prev.off("change", this._onTextureChange, this);
					_prev.off("remove", this._onTextureRemove, this);
				}
			}
			this._textureAsset = _id;
			if (this._textureAsset) {
				const asset = assets.get(this._textureAsset);
				if (!asset) {
					this.texture = null;
					assets.on(`add:${this._textureAsset}`, this._onTextureAdded, this);
				} else {
					this._bindTextureAsset(asset);
				}
			} else {
				this.texture = null;
			}
		}
	}
	get textureAsset() {
		return this._textureAsset;
	}
	set spriteAsset(value) {
		const assets = this._system.app.assets;
		let _id = value;
		if (value instanceof Asset) {
			_id = value.id;
		}
		if (this._spriteAsset !== _id) {
			if (this._spriteAsset) {
				assets.off(`add:${this._spriteAsset}`, this._onSpriteAssetAdded, this);
				const _prev = assets.get(this._spriteAsset);
				if (_prev) {
					this._unbindSpriteAsset(_prev);
				}
			}
			this._spriteAsset = _id;
			if (this._spriteAsset) {
				const asset = assets.get(this._spriteAsset);
				if (!asset) {
					this.sprite = null;
					assets.on(`add:${this._spriteAsset}`, this._onSpriteAssetAdded, this);
				} else {
					this._bindSpriteAsset(asset);
				}
			} else {
				this.sprite = null;
			}
		}
		if (this._element) {
			this._element.fire("set:spriteAsset", _id);
		}
	}
	get spriteAsset() {
		return this._spriteAsset;
	}
	set sprite(value) {
		if (this._sprite === value) return;
		if (this._sprite) {
			this._unbindSprite(this._sprite);
		}
		if (this._spriteAsset) {
			const spriteAsset = this._system.app.assets.get(this._spriteAsset);
			if (spriteAsset && spriteAsset.resource !== value) {
				this.spriteAsset = null;
			}
		}
		this._sprite = value;
		if (this._sprite) {
			this._bindSprite(this._sprite);
			if (this._textureAsset) {
				this.textureAsset = null;
			}
		}
		if (this._sprite && this._sprite.atlas && this._sprite.atlas.texture) {
			this._renderable.setParameter("texture_emissiveMap", this._sprite.atlas.texture);
			this._renderable.setParameter("texture_opacityMap", this._sprite.atlas.texture);
		} else {
			this._renderable.deleteParameter("texture_emissiveMap");
			this._renderable.deleteParameter("texture_opacityMap");
		}
		if (this._sprite) {
			this._spriteFrame = math.clamp(this._spriteFrame, 0, this._sprite.frameKeys.length - 1);
		}
		this._updateSprite();
	}
	get sprite() {
		return this._sprite;
	}
	set spriteFrame(value) {
		const oldValue = this._spriteFrame;
		if (this._sprite) {
			this._spriteFrame = math.clamp(value, 0, this._sprite.frameKeys.length - 1);
		} else {
			this._spriteFrame = value;
		}
		if (this._spriteFrame !== oldValue) {
			this._updateSprite();
		}
		if (this._element) {
			this._element.fire("set:spriteFrame", value);
		}
	}
	get spriteFrame() {
		return this._spriteFrame;
	}
	set mesh(value) {
		this._renderable.setMesh(value);
		if (this._defaultMesh === value) {
			this._renderable.setAabbFunc(null);
		} else {
			this._renderable.setAabbFunc(this._updateAabbFunc);
		}
	}
	get mesh() {
		return this._renderable.mesh;
	}
	set mask(value) {
		if (this._mask !== value) {
			this._mask = value;
			this._toggleMask();
		}
	}
	get mask() {
		return this._mask;
	}
	set pixelsPerUnit(value) {
		if (this._pixelsPerUnit === value) return;
		this._pixelsPerUnit = value;
		if (this._sprite && (this._sprite.renderMode === SPRITE_RENDERMODE_SLICED || this._sprite.renderMode === SPRITE_RENDERMODE_TILED)) {
			this._updateSprite();
		}
	}
	get pixelsPerUnit() {
		return this._pixelsPerUnit;
	}
	// private
	get aabb() {
		if (this._renderable.meshInstance) {
			return this._renderable.meshInstance.aabb;
		}
		return null;
	}
};

var LocalizedAsset = class extends EventHandler {
	constructor(app2) {
		super();
		this._app = app2;
		app2.i18n.on(I18n.EVENT_CHANGE, this._onSetLocale, this);
		this._autoLoad = false;
		this._disableLocalization = false;
		this._defaultAsset = null;
		this._localizedAsset = null;
	}
	set defaultAsset(value) {
		const id14 = value instanceof Asset ? value.id : value;
		if (this._defaultAsset === id14) return;
		if (this._defaultAsset) {
			this._unbindDefaultAsset();
		}
		this._defaultAsset = id14;
		if (this._defaultAsset) {
			this._bindDefaultAsset();
		}
		this._onSetLocale(this._app.i18n.locale);
	}
	get defaultAsset() {
		return this._defaultAsset;
	}
	set localizedAsset(value) {
		const id14 = value instanceof Asset ? value.id : value;
		if (this._localizedAsset === id14) {
			return;
		}
		if (this._localizedAsset) {
			this._app.assets.off(`add:${this._localizedAsset}`, this._onLocalizedAssetAdd, this);
			this._unbindLocalizedAsset();
		}
		this._localizedAsset = id14;
		if (this._localizedAsset) {
			const asset = this._app.assets.get(this._localizedAsset);
			if (!asset) {
				this._app.assets.once(`add:${this._localizedAsset}`, this._onLocalizedAssetAdd, this);
			} else {
				this._bindLocalizedAsset();
			}
		}
	}
	get localizedAsset() {
		return this._localizedAsset;
	}
	set autoLoad(value) {
		if (this._autoLoad === value) return;
		this._autoLoad = value;
		if (this._autoLoad && this._localizedAsset) {
			this._unbindLocalizedAsset();
			this._bindLocalizedAsset();
		}
	}
	get autoLoad() {
		return this._autoLoad;
	}
	set disableLocalization(value) {
		if (this._disableLocalization === value) return;
		this._disableLocalization = value;
		this._onSetLocale(this._app.i18n.locale);
	}
	get disableLocalization() {
		return this._disableLocalization;
	}
	_bindDefaultAsset() {
		const asset = this._app.assets.get(this._defaultAsset);
		if (!asset) {
			this._app.assets.once(`add:${this._defaultAsset}`, this._onDefaultAssetAdd, this);
		} else {
			this._onDefaultAssetAdd(asset);
		}
	}
	_unbindDefaultAsset() {
		if (!this._defaultAsset) return;
		this._app.assets.off(`add:${this._defaultAsset}`, this._onDefaultAssetAdd, this);
		const asset = this._app.assets.get(this._defaultAsset);
		if (!asset) return;
		asset.off("add:localized", this._onLocaleAdd, this);
		asset.off("remove:localized", this._onLocaleRemove, this);
		asset.off("remove", this._onDefaultAssetRemove, this);
	}
	_onDefaultAssetAdd(asset) {
		if (this._defaultAsset !== asset.id) return;
		asset.on("add:localized", this._onLocaleAdd, this);
		asset.on("remove:localized", this._onLocaleRemove, this);
		asset.once("remove", this._onDefaultAssetRemove, this);
	}
	_onDefaultAssetRemove(asset) {
		if (this._defaultAsset !== asset.id) return;
		asset.off("add:localized", this._onLocaleAdd, this);
		asset.off("remove:localized", this._onLocaleAdd, this);
		this._app.assets.once(`add:${this._defaultAsset}`, this._onDefaultAssetAdd, this);
	}
	_bindLocalizedAsset() {
		if (!this._autoLoad) return;
		const asset = this._app.assets.get(this._localizedAsset);
		if (!asset) return;
		asset.on("load", this._onLocalizedAssetLoad, this);
		asset.on("change", this._onLocalizedAssetChange, this);
		asset.on("remove", this._onLocalizedAssetRemove, this);
		if (asset.resource) {
			this._onLocalizedAssetLoad(asset);
		} else {
			this._app.assets.load(asset);
		}
	}
	_unbindLocalizedAsset() {
		const asset = this._app.assets.get(this._localizedAsset);
		if (!asset) return;
		asset.off("load", this._onLocalizedAssetLoad, this);
		asset.off("change", this._onLocalizedAssetChange, this);
		asset.off("remove", this._onLocalizedAssetRemove, this);
	}
	_onLocalizedAssetAdd(asset) {
		if (this._localizedAsset !== asset.id) return;
		this._bindLocalizedAsset();
	}
	_onLocalizedAssetLoad(asset) {
		this.fire("load", asset);
	}
	_onLocalizedAssetChange(asset, name, newValue, oldValue) {
		this.fire("change", asset, name, newValue, oldValue);
	}
	_onLocalizedAssetRemove(asset) {
		if (this._localizedAsset === asset.id) {
			this.localizedAsset = this._defaultAsset;
		}
		this.fire("remove", asset);
	}
	_onLocaleAdd(locale, assetId) {
		if (this._app.i18n.locale !== locale) return;
		this._onSetLocale(locale);
	}
	_onLocaleRemove(locale, assetId) {
		if (this._app.i18n.locale !== locale) return;
		this._onSetLocale(locale);
	}
	_onSetLocale(locale) {
		if (!this._defaultAsset) {
			this.localizedAsset = null;
			return;
		}
		const asset = this._app.assets.get(this._defaultAsset);
		if (!asset || this._disableLocalization) {
			this.localizedAsset = this._defaultAsset;
			return;
		}
		const localizedAssetId = asset.getLocalizedAssetId(locale);
		if (!localizedAssetId) {
			this.localizedAsset = this._defaultAsset;
			return;
		}
		this.localizedAsset = localizedAssetId;
	}
	destroy() {
		this.defaultAsset = null;
		this._app.i18n.off(I18n.EVENT_CHANGE, this._onSetLocale, this);
		this.off();
	}
};

var FONT_MSDF = "msdf";
var FONT_BITMAP = "bitmap";

var EOF_TOKEN = 0;
var ERROR_TOKEN = 1;
var TEXT_TOKEN = 2;
var OPEN_BRACKET_TOKEN = 3;
var CLOSE_BRACKET_TOKEN = 4;
var EQUALS_TOKEN = 5;
var STRING_TOKEN = 6;
var IDENTIFIER_TOKEN = 7;
var WHITESPACE_TOKEN = 8;
var WHITESPACE_CHARS = " 	\n\r\v\f";
var IDENTIFIER_REGEX = /[\w|/]/;
var Scanner = class {
	constructor(symbols) {
		this._symbols = symbols;
		this._index = 0;
		this._last = 0;
		this._cur = this._symbols.length > 0 ? this._symbols[0] : null;
		this._buf = [];
		this._mode = "text";
		this._error = null;
	}
	// read the next token, ignore whitespace
	read() {
		let token = this._read();
		while (token === WHITESPACE_TOKEN) {
			token = this._read();
		}
		if (token !== EOF_TOKEN && token !== ERROR_TOKEN) {
			this._last = this._index;
		}
		return token;
	}
	// returns the buffer for the last returned token
	buf() {
		return this._buf;
	}
	// returns the index of end of the last successful token extraction
	last() {
		return this._last;
	}
	// return the error message
	error() {
		return this._error;
	}
	// print the scanner output
	debugPrint() {
		const tokenStrings = ["EOF", "ERROR", "TEXT", "OPEN_BRACKET", "CLOSE_BRACKET", "EQUALS", "STRING", "IDENTIFIER", "WHITESPACE"];
		let token = this.read();
		let result = "";
		while (true) {
			result += `${(result.length > 0 ? "\n" : "") + tokenStrings[token]} '${this.buf().join("")}'`;
			if (token === EOF_TOKEN || token === ERROR_TOKEN) {
				break;
			}
			token = this.read();
		}
		return result;
	}
	// read the next token from the input stream and return the token
	_read() {
		this._buf = [];
		if (this._eof()) {
			return EOF_TOKEN;
		}
		return this._mode === "text" ? this._text() : this._tag();
	}
	// read text block until eof or start of tag
	_text() {
		while (true) {
			switch (this._cur) {
				case null:
					return this._buf.length > 0 ? TEXT_TOKEN : EOF_TOKEN;
				case "[":
					this._mode = "tag";
					return this._buf.length > 0 ? TEXT_TOKEN : this._tag();
				case "\\":
					this._next();
					switch (this._cur) {
						case "[":
							this._store();
							break;
						default:
							this._output("\\");
							break;
					}
					break;
				default:
					this._store();
					break;
			}
		}
	}
	// read tag block
	_tag() {
		switch (this._cur) {
			case null:
				this._error = "unexpected end of input reading tag";
				return ERROR_TOKEN;
			case "[":
				this._store();
				return OPEN_BRACKET_TOKEN;
			case "]":
				this._store();
				this._mode = "text";
				return CLOSE_BRACKET_TOKEN;
			case "=":
				this._store();
				return EQUALS_TOKEN;
			case " ":
			case "	":
			case "\n":
			case "\r":
			case "\v":
			case "\f":
				return this._whitespace();
			case '"':
				return this._string();
			default:
				if (!this._isIdentifierSymbol(this._cur)) {
					this._error = "unrecognized character";
					return ERROR_TOKEN;
				}
				return this._identifier();
		}
	}
	_whitespace() {
		this._store();
		while (WHITESPACE_CHARS.indexOf(this._cur) !== -1) {
			this._store();
		}
		return WHITESPACE_TOKEN;
	}
	_string() {
		this._next();
		while (true) {
			switch (this._cur) {
				case null:
					this._error = "unexpected end of input reading string";
					return ERROR_TOKEN;
				case '"':
					this._next();
					return STRING_TOKEN;
				default:
					this._store();
					break;
			}
		}
	}
	_identifier() {
		this._store();
		while (this._cur !== null && this._isIdentifierSymbol(this._cur)) {
			this._store();
		}
		return IDENTIFIER_TOKEN;
	}
	_isIdentifierSymbol(s2) {
		return s2.length === 1 && s2.match(IDENTIFIER_REGEX) !== null;
	}
	_eof() {
		return this._cur === null;
	}
	_next() {
		if (!this._eof()) {
			this._index++;
			this._cur = this._index < this._symbols.length ? this._symbols[this._index] : null;
		}
		return this._cur;
	}
	_store() {
		this._buf.push(this._cur);
		return this._next();
	}
	_output(c2) {
		this._buf.push(c2);
	}
};
var Parser = class {
	constructor(symbols) {
		this._scanner = new Scanner(symbols);
		this._error = null;
	}
	// parse the incoming symbols placing resulting symbols in symbols
	// and tags in tags
	// tags is an array of the following structure:
	// {
	//     name: string;                    // tag name, for example 'color'
	//     value: string;                   // optional tag value, for example '#ff0000'
	//     attributes: {                    // list of attributes
	//         key: value;                  // optional key/value pairs
	//     }
	//     start: int;                      // first symbol to which this tag applies
	//     end: int;                        // last symbol to which this tag applies
	// }
	parse(symbols, tags) {
		while (true) {
			const token = this._scanner.read();
			switch (token) {
				case EOF_TOKEN:
					return true;
				case ERROR_TOKEN:
					return false;
				case TEXT_TOKEN:
					Array.prototype.push.apply(symbols, this._scanner.buf());
					break;
				case OPEN_BRACKET_TOKEN:
					if (!this._parseTag(symbols, tags)) {
						return false;
					}
					break;
				default:
					return false;
			}
		}
	}
	// access an error message if the parser failed
	error() {
		return `Error evaluating markup at #${this._scanner.last().toString()} (${this._scanner.error() || this._error})`;
	}
	_parseTag(symbols, tags) {
		let token = this._scanner.read();
		if (token !== IDENTIFIER_TOKEN) {
			this._error = "expected identifier";
			return false;
		}
		const name = this._scanner.buf().join("");
		if (name[0] === "/") {
			for (let index = tags.length - 1; index >= 0; --index) {
				if (name === `/${tags[index].name}` && tags[index].end === null) {
					tags[index].end = symbols.length;
					token = this._scanner.read();
					if (token !== CLOSE_BRACKET_TOKEN) {
						this._error = "expected close bracket";
						return false;
					}
					return true;
				}
			}
			this._error = "failed to find matching tag";
			return false;
		}
		const tag = {
			name,
			value: null,
			attributes: {},
			start: symbols.length,
			end: null
		};
		token = this._scanner.read();
		if (token === EQUALS_TOKEN) {
			token = this._scanner.read();
			if (token !== STRING_TOKEN) {
				this._error = "expected string";
				return false;
			}
			tag.value = this._scanner.buf().join("");
			token = this._scanner.read();
		}
		while (true) {
			switch (token) {
				case CLOSE_BRACKET_TOKEN:
					tags.push(tag);
					return true;
				case IDENTIFIER_TOKEN: {
					const identifier = this._scanner.buf().join("");
					token = this._scanner.read();
					if (token !== EQUALS_TOKEN) {
						this._error = "expected equals";
						return false;
					}
					token = this._scanner.read();
					if (token !== STRING_TOKEN) {
						this._error = "expected string";
						return false;
					}
					const value = this._scanner.buf().join("");
					tag.attributes[identifier] = value;
					break;
				}
				default:
					this._error = "expected close bracket or identifier";
					return false;
			}
			token = this._scanner.read();
		}
	}
};
function merge(target2, source) {
	for (const key in source) {
		if (!source.hasOwnProperty(key)) {
			continue;
		}
		const value = source[key];
		if (value instanceof Object) {
			if (!target2.hasOwnProperty(key)) {
				target2[key] = {};
			}
			merge(target2[key], source[key]);
		} else {
			target2[key] = value;
		}
	}
}
function combineTags(tags) {
	if (tags.length === 0) {
		return null;
	}
	const result = {};
	for (let index = 0; index < tags.length; ++index) {
		const tag = tags[index];
		const tmp = {};
		tmp[tag.name] = { value: tag.value, attributes: tag.attributes };
		merge(result, tmp);
	}
	return result;
}
function resolveMarkupTags(tags, numSymbols) {
	if (tags.length === 0) {
		return null;
	}
	const edges = {};
	for (let index = 0; index < tags.length; ++index) {
		const tag = tags[index];
		if (!edges.hasOwnProperty(tag.start)) {
			edges[tag.start] = { open: [tag], close: null };
		} else {
			if (edges[tag.start].open === null) {
				edges[tag.start].open = [tag];
			} else {
				edges[tag.start].open.push(tag);
			}
		}
		if (!edges.hasOwnProperty(tag.end)) {
			edges[tag.end] = { open: null, close: [tag] };
		} else {
			if (edges[tag.end].close === null) {
				edges[tag.end].close = [tag];
			} else {
				edges[tag.end].close.push(tag);
			}
		}
	}
	let tagStack = [];
	function removeTags(tags2) {
		tagStack = tagStack.filter((tag) => {
			return tags2.find((t) => {
				return t === tag;
			}) === void 0;
		});
	}
	function addTags(tags2) {
		for (let index = 0; index < tags2.length; ++index) {
			tagStack.push(tags2[index]);
		}
	}
	const edgeKeys = Object.keys(edges).sort((a, b) => {
		return a - b;
	});
	const resolvedTags = [];
	for (let index = 0; index < edgeKeys.length; ++index) {
		const edge = edges[edgeKeys[index]];
		if (edge.close !== null) {
			removeTags(edge.close);
		}
		if (edge.open !== null) {
			addTags(edge.open);
		}
		resolvedTags.push({
			start: edgeKeys[index],
			tags: combineTags(tagStack)
		});
	}
	const result = [];
	let prevTag = null;
	for (let index = 0; index < resolvedTags.length; ++index) {
		const resolvedTag = resolvedTags[index];
		while (result.length < resolvedTag.start) {
			result.push(prevTag ? prevTag.tags : null);
		}
		prevTag = resolvedTag;
	}
	while (result.length < numSymbols) {
		result.push(null);
	}
	return result;
}
function evaluateMarkup(symbols) {
	const parser = new Parser(symbols);
	const stripped_symbols = [];
	const tags = [];
	if (!parser.parse(stripped_symbols, tags)) {
		console.warn(parser.error());
		return {
			symbols,
			tags: null
		};
	}
	const invalidTag = tags.find((t) => {
		return t.end === null;
	});
	if (invalidTag) {
		console.warn(`Markup error: found unclosed tag='${invalidTag.name}'`);
		return {
			symbols,
			tags: null
		};
	}
	const resolved_tags = resolveMarkupTags(tags, stripped_symbols.length);
	return {
		symbols: stripped_symbols,
		tags: resolved_tags
	};
}
var Markup = class {
	static evaluate(symbols) {
		return evaluateMarkup(symbols);
	}
};

var MeshInfo = class {
	constructor() {
		this.count = 0;
		this.quad = 0;
		this.lines = {};
		this.positions = [];
		this.normals = [];
		this.uvs = [];
		this.colors = [];
		this.indices = [];
		this.outlines = [];
		this.shadows = [];
		this.meshInstance = null;
	}
};
function createTextMesh(device, meshInfo) {
	const mesh = new Mesh(device);
	mesh.setPositions(meshInfo.positions);
	mesh.setNormals(meshInfo.normals);
	mesh.setColors32(meshInfo.colors);
	mesh.setUvs(0, meshInfo.uvs);
	mesh.setIndices(meshInfo.indices);
	mesh.setVertexStream(SEMANTIC_ATTR8, meshInfo.outlines, 3, void 0, TYPE_FLOAT32, false);
	mesh.setVertexStream(SEMANTIC_ATTR9, meshInfo.shadows, 3, void 0, TYPE_FLOAT32, false);
	mesh.update();
	return mesh;
}
var LINE_BREAK_CHAR = /^[\r\n]$/;
var WHITESPACE_CHAR = /^[ \t]$/;
var WORD_BOUNDARY_CHAR = /^[ \t\-]|\u200b$/;
var ALPHANUMERIC_CHAR = /^[a-z0-9]$/i;
var CJK_CHAR = /^[\u1100-\u11ff]|[\u3000-\u9fff\ua960-\ua97f]|[\uac00-\ud7ff]$/;
var NO_LINE_BREAK_CJK_CHAR = /^[〕〉》」』】〙〗〟ヽヾーァィゥェォッャュョヮヵヶぁぃぅぇぉっゃゅょゎゕゖㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ々〻]$/;
var CONTROL_CHARS = [
	"\u200B",
	// zero width space
	"\u061C",
	"\u200E",
	"\u200F",
	"\u202A",
	"\u202B",
	"\u202C",
	"\u202D",
	"\u202E",
	"\u2066",
	"\u2067",
	"\u2068",
	"\u2069"
];
var CONTROL_GLYPH_DATA = {
	width: 0,
	height: 0,
	xadvance: 0,
	xoffset: 0,
	yoffset: 0
};
var colorTmp = new Color();
var vec2Tmp = new Vec2();
var _tempColor3 = new Color();
var TextElement = class {
	constructor(element) {
		this._element = element;
		this._system = element.system;
		this._entity = element.entity;
		this._text = "";
		this._symbols = [];
		this._colorPalette = [];
		this._outlinePalette = [];
		this._shadowPalette = [];
		this._symbolColors = null;
		this._symbolOutlineParams = null;
		this._symbolShadowParams = null;
		this._i18nKey = null;
		this._fontAsset = new LocalizedAsset(this._system.app);
		this._fontAsset.disableLocalization = true;
		this._fontAsset.on("load", this._onFontLoad, this);
		this._fontAsset.on("change", this._onFontChange, this);
		this._fontAsset.on("remove", this._onFontRemove, this);
		this._font = null;
		this._color = new Color(1, 1, 1, 1);
		this._colorUniform = new Float32Array(3);
		this._spacing = 1;
		this._fontSize = 32;
		this._fontMinY = 0;
		this._fontMaxY = 0;
		this._originalFontSize = 32;
		this._maxFontSize = 32;
		this._minFontSize = 8;
		this._autoFitWidth = false;
		this._autoFitHeight = false;
		this._maxLines = -1;
		this._lineHeight = 32;
		this._scaledLineHeight = 32;
		this._wrapLines = false;
		this._drawOrder = 0;
		this._alignment = new Vec2(0.5, 0.5);
		this._autoWidth = true;
		this._autoHeight = true;
		this.width = 0;
		this.height = 0;
		this._node = new GraphNode();
		this._model = new Model();
		this._model.graph = this._node;
		this._entity.addChild(this._node);
		this._meshInfo = [];
		this._material = null;
		this._aabbDirty = true;
		this._aabb = new BoundingBox();
		this._noResize = false;
		this._currentMaterialType = null;
		this._maskedMaterialSrc = null;
		this._rtlReorder = false;
		this._unicodeConverter = false;
		this._rtl = false;
		this._outlineColor = new Color(0, 0, 0, 1);
		this._outlineColorUniform = new Float32Array(4);
		this._outlineThicknessScale = 0.2;
		this._outlineThickness = 0;
		this._shadowColor = new Color(0, 0, 0, 1);
		this._shadowColorUniform = new Float32Array(4);
		this._shadowOffsetScale = 5e-3;
		this._shadowOffset = new Vec2(0, 0);
		this._shadowOffsetUniform = new Float32Array(2);
		this._enableMarkup = false;
		this._onScreenChange(this._element.screen);
		element.on("resize", this._onParentResize, this);
		element.on("set:screen", this._onScreenChange, this);
		element.on("screen:set:screenspace", this._onScreenSpaceChange, this);
		element.on("set:draworder", this._onDrawOrderChange, this);
		element.on("set:pivot", this._onPivotChange, this);
		this._system.app.i18n.on(I18n.EVENT_CHANGE, this._onLocaleSet, this);
		this._system.app.i18n.on("data:add", this._onLocalizationData, this);
		this._system.app.i18n.on("data:remove", this._onLocalizationData, this);
		this._rangeStart = 0;
		this._rangeEnd = 0;
		if (!element._beingInitialized && element.enabled && element.entity.enabled) {
			this.onEnable();
		}
	}
	destroy() {
		this._setMaterial(null);
		if (this._model) {
			this._element.removeModelFromLayers(this._model);
			this._model.destroy();
			this._model = null;
		}
		this._fontAsset.destroy();
		this.font = null;
		this._element.off("resize", this._onParentResize, this);
		this._element.off("set:screen", this._onScreenChange, this);
		this._element.off("screen:set:screenspace", this._onScreenSpaceChange, this);
		this._element.off("set:draworder", this._onDrawOrderChange, this);
		this._element.off("set:pivot", this._onPivotChange, this);
		this._system.app.i18n.off(I18n.EVENT_CHANGE, this._onLocaleSet, this);
		this._system.app.i18n.off("data:add", this._onLocalizationData, this);
		this._system.app.i18n.off("data:remove", this._onLocalizationData, this);
	}
	_onParentResize(width, height) {
		if (this._noResize) return;
		if (this._font) this._updateText();
	}
	_onScreenChange(screen) {
		if (screen) {
			this._updateMaterial(screen.screen.screenSpace);
		} else {
			this._updateMaterial(false);
		}
	}
	_onScreenSpaceChange(value) {
		this._updateMaterial(value);
	}
	_onDrawOrderChange(order) {
		this._drawOrder = order;
		if (this._model) {
			for (let i2 = 0, len = this._model.meshInstances.length; i2 < len; i2++) {
				this._model.meshInstances[i2].drawOrder = order;
			}
		}
	}
	_onPivotChange(pivot) {
		if (this._font) {
			this._updateText();
		}
	}
	_onLocaleSet(locale) {
		if (!this._i18nKey) return;
		if (this.fontAsset) {
			const asset = this._system.app.assets.get(this.fontAsset);
			if (!asset || !asset.resource || asset.resource !== this._font) {
				this.font = null;
			}
		}
		this._resetLocalizedText();
	}
	_onLocalizationData(locale, messages) {
		if (this._i18nKey && messages[this._i18nKey]) {
			this._resetLocalizedText();
		}
	}
	_resetLocalizedText() {
		this._setText(this._system.app.i18n.getText(this._i18nKey));
	}
	_setText(text) {
		if (this.unicodeConverter) {
			const unicodeConverterFunc = this._system.getUnicodeConverter();
			if (unicodeConverterFunc) {
				text = unicodeConverterFunc(text);
			} else {
				console.warn("Element created with unicodeConverter option but no unicodeConverter function registered");
			}
		}
		if (this._text !== text) {
			if (this._font) {
				this._updateText(text);
			}
			this._text = text;
		}
	}
	_updateText(text) {
		let tags;
		if (text === void 0) text = this._text;
		this._symbols = string.getSymbols(text.normalize ? text.normalize("NFC") : text);
		if (this._symbols.length === 0) {
			this._symbols = [" "];
		}
		if (this._enableMarkup) {
			const results = Markup.evaluate(this._symbols);
			this._symbols = results.symbols;
			tags = results.tags || [];
		}
		if (this._rtlReorder) {
			const rtlReorderFunc = this._system.app.systems.element.getRtlReorder();
			if (rtlReorderFunc) {
				const results = rtlReorderFunc(this._symbols);
				this._rtl = results.rtl;
				this._symbols = results.mapping.map(function(v6) {
					return this._symbols[v6];
				}, this);
				if (tags) {
					tags = results.mapping.map((v6) => {
						return tags[v6];
					});
				}
			} else {
				console.warn("Element created with rtlReorder option but no rtlReorder function registered");
			}
		} else {
			this._rtl = false;
		}
		const getColorThicknessHash = (color3, thickness) => {
			return `${color3.toString(true).toLowerCase()}:${thickness.toFixed(2)}`;
		};
		const getColorOffsetHash = (color3, offset3) => {
			return `${color3.toString(true).toLowerCase()}:${offset3.x.toFixed(2)}:${offset3.y.toFixed(2)}`;
		};
		if (tags) {
			const paletteMap = {};
			const outlinePaletteMap = {};
			const shadowPaletteMap = {};
			_tempColor3.linear(this._color);
			this._colorPalette = [
				Math.round(_tempColor3.r * 255),
				Math.round(_tempColor3.g * 255),
				Math.round(_tempColor3.b * 255)
			];
			_tempColor3.linear(this._outlineColor);
			this._outlinePalette = [
				Math.round(_tempColor3.r * 255),
				Math.round(_tempColor3.g * 255),
				Math.round(_tempColor3.b * 255),
				Math.round(_tempColor3.a * 255),
				Math.round(this._outlineThickness * 255)
			];
			_tempColor3.linear(this._shadowColor);
			this._shadowPalette = [
				Math.round(_tempColor3.r * 255),
				Math.round(_tempColor3.g * 255),
				Math.round(_tempColor3.b * 255),
				Math.round(_tempColor3.a * 255),
				Math.round(this._shadowOffset.x * 127),
				Math.round(this._shadowOffset.y * 127)
			];
			this._symbolColors = [];
			this._symbolOutlineParams = [];
			this._symbolShadowParams = [];
			paletteMap[this._color.toString(false).toLowerCase()] = 0;
			outlinePaletteMap[getColorThicknessHash(this._outlineColor, this._outlineThickness)] = 0;
			shadowPaletteMap[getColorOffsetHash(this._shadowColor, this._shadowOffset)] = 0;
			for (let i2 = 0, len = this._symbols.length; i2 < len; ++i2) {
				const tag = tags[i2];
				let color3 = 0;
				if (tag && tag.color && tag.color.value) {
					const c2 = tag.color.value;
					if (c2.length === 7 && c2[0] === "#") {
						const hex = c2.substring(1).toLowerCase();
						if (paletteMap.hasOwnProperty(hex)) {
							color3 = paletteMap[hex];
						} else {
							if (/^[0-9a-f]{6}$/.test(hex)) {
								color3 = this._colorPalette.length / 3;
								paletteMap[hex] = color3;
								colorTmp.fromString(`#${hex}`);
								_tempColor3.linear(colorTmp);
								this._colorPalette.push(Math.round(_tempColor3.r * 255));
								this._colorPalette.push(Math.round(_tempColor3.g * 255));
								this._colorPalette.push(Math.round(_tempColor3.b * 255));
							}
						}
					}
				}
				this._symbolColors.push(color3);
				let outline = 0;
				if (tag && tag.outline && (tag.outline.attributes.color || tag.outline.attributes.thickness)) {
					let color4 = tag.outline.attributes.color ? colorTmp.fromString(tag.outline.attributes.color) : this._outlineColor;
					let thickness = Number(tag.outline.attributes.thickness);
					if (Number.isNaN(color4.r) || Number.isNaN(color4.g) || Number.isNaN(color4.b) || Number.isNaN(color4.a)) {
						color4 = this._outlineColor;
					}
					if (Number.isNaN(thickness)) {
						thickness = this._outlineThickness;
					}
					const outlineHash = getColorThicknessHash(color4, thickness);
					if (outlinePaletteMap.hasOwnProperty(outlineHash)) {
						outline = outlinePaletteMap[outlineHash];
					} else {
						outline = this._outlinePalette.length / 5;
						outlinePaletteMap[outlineHash] = outline;
						_tempColor3.linear(color4);
						this._outlinePalette.push(
							Math.round(_tempColor3.r * 255),
							Math.round(_tempColor3.g * 255),
							Math.round(_tempColor3.b * 255),
							Math.round(_tempColor3.a * 255),
							Math.round(thickness * 255)
						);
					}
				}
				this._symbolOutlineParams.push(outline);
				let shadow = 0;
				if (tag && tag.shadow && (tag.shadow.attributes.color || tag.shadow.attributes.offset || tag.shadow.attributes.offsetX || tag.shadow.attributes.offsetY)) {
					let color4 = tag.shadow.attributes.color ? colorTmp.fromString(tag.shadow.attributes.color) : this._shadowColor;
					const off = Number(tag.shadow.attributes.offset);
					const offX = Number(tag.shadow.attributes.offsetX);
					const offY = Number(tag.shadow.attributes.offsetY);
					if (Number.isNaN(color4.r) || Number.isNaN(color4.g) || Number.isNaN(color4.b) || Number.isNaN(color4.a)) {
						color4 = this._shadowColor;
					}
					const offset3 = vec2Tmp.set(
						!Number.isNaN(offX) ? offX : !Number.isNaN(off) ? off : this._shadowOffset.x,
						!Number.isNaN(offY) ? offY : !Number.isNaN(off) ? off : this._shadowOffset.y
					);
					const shadowHash = getColorOffsetHash(color4, offset3);
					if (shadowPaletteMap.hasOwnProperty(shadowHash)) {
						shadow = shadowPaletteMap[shadowHash];
					} else {
						shadow = this._shadowPalette.length / 6;
						shadowPaletteMap[shadowHash] = shadow;
						_tempColor3.linear(color4);
						this._shadowPalette.push(
							Math.round(_tempColor3.r * 255),
							Math.round(_tempColor3.g * 255),
							Math.round(_tempColor3.b * 255),
							Math.round(_tempColor3.a * 255),
							Math.round(offset3.x * 127),
							Math.round(offset3.y * 127)
						);
					}
				}
				this._symbolShadowParams.push(shadow);
			}
		} else {
			this._colorPalette = [];
			this._symbolColors = null;
			this._symbolOutlineParams = null;
			this._symbolShadowParams = null;
		}
		this._updateMaterialEmissive();
		this._updateMaterialOutline();
		this._updateMaterialShadow();
		const charactersPerTexture = this._calculateCharsPerTexture();
		let removedModel = false;
		const element = this._element;
		const screenSpace = element._isScreenSpace();
		const screenCulled = element._isScreenCulled();
		const visibleFn = function(camera) {
			return element.isVisibleForCamera(camera);
		};
		for (let i2 = 0, len = this._meshInfo.length; i2 < len; i2++) {
			const l = charactersPerTexture[i2] || 0;
			const meshInfo = this._meshInfo[i2];
			if (meshInfo.count !== l) {
				if (!removedModel) {
					element.removeModelFromLayers(this._model);
					removedModel = true;
				}
				meshInfo.count = l;
				meshInfo.positions.length = meshInfo.normals.length = l * 3 * 4;
				meshInfo.indices.length = l * 3 * 2;
				meshInfo.uvs.length = l * 2 * 4;
				meshInfo.colors.length = l * 4 * 4;
				meshInfo.outlines.length = l * 4 * 3;
				meshInfo.shadows.length = l * 4 * 3;
				if (meshInfo.meshInstance) {
					this._removeMeshInstance(meshInfo.meshInstance);
				}
				if (l === 0) {
					meshInfo.meshInstance = null;
					continue;
				}
				for (let v6 = 0; v6 < l; v6++) {
					meshInfo.indices[v6 * 3 * 2 + 0] = v6 * 4;
					meshInfo.indices[v6 * 3 * 2 + 1] = v6 * 4 + 1;
					meshInfo.indices[v6 * 3 * 2 + 2] = v6 * 4 + 3;
					meshInfo.indices[v6 * 3 * 2 + 3] = v6 * 4 + 2;
					meshInfo.indices[v6 * 3 * 2 + 4] = v6 * 4 + 3;
					meshInfo.indices[v6 * 3 * 2 + 5] = v6 * 4 + 1;
					meshInfo.normals[v6 * 4 * 3 + 0] = 0;
					meshInfo.normals[v6 * 4 * 3 + 1] = 0;
					meshInfo.normals[v6 * 4 * 3 + 2] = -1;
					meshInfo.normals[v6 * 4 * 3 + 3] = 0;
					meshInfo.normals[v6 * 4 * 3 + 4] = 0;
					meshInfo.normals[v6 * 4 * 3 + 5] = -1;
					meshInfo.normals[v6 * 4 * 3 + 6] = 0;
					meshInfo.normals[v6 * 4 * 3 + 7] = 0;
					meshInfo.normals[v6 * 4 * 3 + 8] = -1;
					meshInfo.normals[v6 * 4 * 3 + 9] = 0;
					meshInfo.normals[v6 * 4 * 3 + 10] = 0;
					meshInfo.normals[v6 * 4 * 3 + 11] = -1;
				}
				const mesh = createTextMesh(this._system.app.graphicsDevice, meshInfo);
				const mi = new MeshInstance(mesh, this._material, this._node);
				mi.name = `Text Element: ${this._entity.name}`;
				mi.castShadow = false;
				mi.receiveShadow = false;
				mi.cull = !screenSpace;
				mi.screenSpace = screenSpace;
				mi.drawOrder = this._drawOrder;
				if (screenCulled) {
					mi.cull = true;
					mi.isVisibleFunc = visibleFn;
				}
				this._setTextureParams(mi, this._font.textures[i2]);
				mi.setParameter("material_emissive", this._colorUniform);
				mi.setParameter("material_opacity", this._color.a);
				mi.setParameter("font_sdfIntensity", this._font.intensity);
				mi.setParameter("font_pxrange", this._getPxRange(this._font));
				mi.setParameter("outline_color", this._outlineColorUniform);
				mi.setParameter("outline_thickness", this._outlineThicknessScale * this._outlineThickness);
				mi.setParameter("shadow_color", this._shadowColorUniform);
				if (this._symbolShadowParams) {
					this._shadowOffsetUniform[0] = 0;
					this._shadowOffsetUniform[1] = 0;
				} else {
					const ratio = -this._font.data.info.maps[i2].width / this._font.data.info.maps[i2].height;
					this._shadowOffsetUniform[0] = this._shadowOffsetScale * this._shadowOffset.x;
					this._shadowOffsetUniform[1] = ratio * this._shadowOffsetScale * this._shadowOffset.y;
				}
				mi.setParameter("shadow_offset", this._shadowOffsetUniform);
				meshInfo.meshInstance = mi;
				this._model.meshInstances.push(mi);
			}
		}
		if (this._element.maskedBy) {
			this._element._setMaskedBy(this._element.maskedBy);
		}
		if (removedModel && this._element.enabled && this._entity.enabled) {
			this._element.addModelToLayers(this._model);
		}
		this._updateMeshes();
		this._rangeStart = 0;
		this._rangeEnd = this._symbols.length;
		this._updateRenderRange();
	}
	_removeMeshInstance(meshInstance) {
		meshInstance.destroy();
		const idx = this._model.meshInstances.indexOf(meshInstance);
		if (idx !== -1) {
			this._model.meshInstances.splice(idx, 1);
		}
	}
	_setMaterial(material) {
		this._material = material;
		if (this._model) {
			for (let i2 = 0, len = this._model.meshInstances.length; i2 < len; i2++) {
				const mi = this._model.meshInstances[i2];
				mi.material = material;
			}
		}
	}
	_updateMaterial(screenSpace) {
		const element = this._element;
		const screenCulled = element._isScreenCulled();
		const visibleFn = function(camera) {
			return element.isVisibleForCamera(camera);
		};
		const msdf = this._font && this._font.type === FONT_MSDF;
		this._material = this._system.getTextElementMaterial(screenSpace, msdf, this._enableMarkup);
		if (this._model) {
			for (let i2 = 0, len = this._model.meshInstances.length; i2 < len; i2++) {
				const mi = this._model.meshInstances[i2];
				mi.cull = !screenSpace;
				mi.material = this._material;
				mi.screenSpace = screenSpace;
				if (screenCulled) {
					mi.cull = true;
					mi.isVisibleFunc = visibleFn;
				} else {
					mi.isVisibleFunc = null;
				}
			}
		}
	}
	_updateMaterialEmissive() {
		if (this._symbolColors) {
			this._colorUniform[0] = 1;
			this._colorUniform[1] = 1;
			this._colorUniform[2] = 1;
		} else {
			_tempColor3.linear(this._color);
			this._colorUniform[0] = _tempColor3.r;
			this._colorUniform[1] = _tempColor3.g;
			this._colorUniform[2] = _tempColor3.b;
		}
	}
	_updateMaterialOutline() {
		if (this._symbolOutlineParams) {
			this._outlineColorUniform[0] = 0;
			this._outlineColorUniform[1] = 0;
			this._outlineColorUniform[2] = 0;
			this._outlineColorUniform[3] = 1;
		} else {
			_tempColor3.linear(this._outlineColor);
			this._outlineColorUniform[0] = _tempColor3.r;
			this._outlineColorUniform[1] = _tempColor3.g;
			this._outlineColorUniform[2] = _tempColor3.b;
			this._outlineColorUniform[3] = _tempColor3.a;
		}
	}
	_updateMaterialShadow() {
		if (this._symbolOutlineParams) {
			this._shadowColorUniform[0] = 0;
			this._shadowColorUniform[1] = 0;
			this._shadowColorUniform[2] = 0;
			this._shadowColorUniform[3] = 0;
		} else {
			_tempColor3.linear(this._shadowColor);
			this._shadowColorUniform[0] = _tempColor3.r;
			this._shadowColorUniform[1] = _tempColor3.g;
			this._shadowColorUniform[2] = _tempColor3.b;
			this._shadowColorUniform[3] = _tempColor3.a;
		}
	}
	// char is space, tab, or dash
	_isWordBoundary(char) {
		return WORD_BOUNDARY_CHAR.test(char);
	}
	_isValidNextChar(nextchar) {
		return nextchar !== null && !NO_LINE_BREAK_CJK_CHAR.test(nextchar);
	}
	// char is a CJK character and next character is a CJK boundary
	_isNextCJKBoundary(char, nextchar) {
		return CJK_CHAR.test(char) && (WORD_BOUNDARY_CHAR.test(nextchar) || ALPHANUMERIC_CHAR.test(nextchar));
	}
	// next character is a CJK character that can be a whole word
	_isNextCJKWholeWord(nextchar) {
		return CJK_CHAR.test(nextchar);
	}
	_updateMeshes() {
		const json = this._font.data;
		const self2 = this;
		const minFont = Math.min(this._minFontSize, this._maxFontSize);
		const maxFont = this._maxFontSize;
		const autoFit = this._shouldAutoFit();
		if (autoFit) {
			this._fontSize = this._maxFontSize;
		}
		const MAGIC = 32;
		const l = this._symbols.length;
		let _x = 0;
		let _y = 0;
		let _z = 0;
		let _xMinusTrailingWhitespace = 0;
		let lines = 1;
		let wordStartX = 0;
		let wordStartIndex = 0;
		let lineStartIndex = 0;
		let numWordsThisLine = 0;
		let numCharsThisLine = 0;
		let numBreaksThisLine = 0;
		const splitHorizontalAnchors = Math.abs(this._element.anchor.x - this._element.anchor.z) >= 1e-4;
		let maxLineWidth = this._element.calculatedWidth;
		if (this.autoWidth && !splitHorizontalAnchors || !this._wrapLines) {
			maxLineWidth = Number.POSITIVE_INFINITY;
		}
		let fontMinY = 0;
		let fontMaxY = 0;
		let char, data2, quad, nextchar;
		function breakLine(symbols, lineBreakIndex, lineBreakX) {
			self2._lineWidths.push(Math.abs(lineBreakX));
			const sliceStart = lineStartIndex > lineBreakIndex ? lineBreakIndex + 1 : lineStartIndex;
			const sliceEnd = lineStartIndex > lineBreakIndex ? lineStartIndex + 1 : lineBreakIndex;
			const chars = symbols.slice(sliceStart, sliceEnd);
			if (numBreaksThisLine) {
				let i2 = chars.length;
				while (i2-- && numBreaksThisLine > 0) {
					if (LINE_BREAK_CHAR.test(chars[i2])) {
						chars.splice(i2, 1);
						numBreaksThisLine--;
					}
				}
			}
			self2._lineContents.push(chars.join(""));
			_x = 0;
			_y -= self2._scaledLineHeight;
			lines++;
			numWordsThisLine = 0;
			numCharsThisLine = 0;
			numBreaksThisLine = 0;
			wordStartX = 0;
			lineStartIndex = lineBreakIndex;
		}
		let retryUpdateMeshes = true;
		while (retryUpdateMeshes) {
			retryUpdateMeshes = false;
			if (autoFit) {
				this._scaledLineHeight = this._lineHeight * this._fontSize / (this._maxFontSize || 1e-4);
			} else {
				this._scaledLineHeight = this._lineHeight;
			}
			this.width = 0;
			this.height = 0;
			this._lineWidths = [];
			this._lineContents = [];
			_x = 0;
			_y = 0;
			_z = 0;
			_xMinusTrailingWhitespace = 0;
			lines = 1;
			wordStartX = 0;
			wordStartIndex = 0;
			lineStartIndex = 0;
			numWordsThisLine = 0;
			numCharsThisLine = 0;
			numBreaksThisLine = 0;
			const scale2 = this._fontSize / MAGIC;
			fontMinY = this._fontMinY * scale2;
			fontMaxY = this._fontMaxY * scale2;
			for (let i2 = 0; i2 < this._meshInfo.length; i2++) {
				this._meshInfo[i2].quad = 0;
				this._meshInfo[i2].lines = {};
			}
			let color_r = 255;
			let color_g = 255;
			let color_b = 255;
			let outline_color_rg = 255 + 255 * 256;
			let outline_color_ba = 255 + 255 * 256;
			let outline_thickness = 0;
			let shadow_color_rg = 255 + 255 * 256;
			let shadow_color_ba = 255 + 255 * 256;
			let shadow_offset_xy = 127 + 127 * 256;
			for (let i2 = 0; i2 < l; i2++) {
				char = this._symbols[i2];
				nextchar = i2 + 1 >= l ? null : this._symbols[i2 + 1];
				const isLineBreak = LINE_BREAK_CHAR.test(char);
				if (isLineBreak) {
					numBreaksThisLine++;
					if (!this._wrapLines || this._maxLines < 0 || lines < this._maxLines) {
						breakLine(this._symbols, i2, _xMinusTrailingWhitespace);
						wordStartIndex = i2 + 1;
						lineStartIndex = i2 + 1;
					}
					continue;
				}
				let x3 = 0;
				let y2 = 0;
				let advance = 0;
				let quadsize = 1;
				let dataScale, size;
				data2 = json.chars[char];
				if (!data2) {
					if (CONTROL_CHARS.indexOf(char) !== -1) {
						data2 = CONTROL_GLYPH_DATA;
					} else {
						if (json.chars[" "]) {
							data2 = json.chars[" "];
						} else {
							for (const key in json.chars) {
								data2 = json.chars[key];
								break;
							}
						}
					}
				}
				if (data2) {
					let kerning = 0;
					if (numCharsThisLine > 0) {
						const kernTable = this._font.data.kerning;
						if (kernTable) {
							const kernLeft = kernTable[string.getCodePoint(this._symbols[i2 - 1]) || 0];
							if (kernLeft) {
								kerning = kernLeft[string.getCodePoint(this._symbols[i2]) || 0] || 0;
							}
						}
					}
					dataScale = data2.scale || 1;
					size = (data2.width + data2.height) / 2;
					quadsize = scale2 * size / dataScale;
					advance = (data2.xadvance + kerning) * scale2;
					x3 = (data2.xoffset - kerning) * scale2;
					y2 = data2.yoffset * scale2;
				} else {
					console.error(`Couldn't substitute missing character: '${char}'`);
				}
				const isWhitespace = WHITESPACE_CHAR.test(char);
				const meshInfoId = data2 && data2.map || 0;
				const ratio = -this._font.data.info.maps[meshInfoId].width / this._font.data.info.maps[meshInfoId].height;
				const meshInfo = this._meshInfo[meshInfoId];
				const candidateLineWidth = _x + this._spacing * advance;
				if (candidateLineWidth > maxLineWidth && numCharsThisLine > 0 && !isWhitespace) {
					if (this._maxLines < 0 || lines < this._maxLines) {
						if (numWordsThisLine === 0) {
							wordStartIndex = i2;
							breakLine(this._symbols, i2, _xMinusTrailingWhitespace);
						} else {
							const backtrack = Math.max(i2 - wordStartIndex, 0);
							if (this._meshInfo.length <= 1) {
								meshInfo.lines[lines - 1] -= backtrack;
								meshInfo.quad -= backtrack;
							} else {
								const backtrackStart = wordStartIndex;
								const backtrackEnd = i2;
								for (let j = backtrackStart; j < backtrackEnd; j++) {
									const backChar = this._symbols[j];
									const backCharData = json.chars[backChar];
									const backMeshInfo = this._meshInfo[backCharData && backCharData.map || 0];
									backMeshInfo.lines[lines - 1] -= 1;
									backMeshInfo.quad -= 1;
								}
							}
							i2 -= backtrack + 1;
							breakLine(this._symbols, wordStartIndex, wordStartX);
							continue;
						}
					}
				}
				quad = meshInfo.quad;
				meshInfo.lines[lines - 1] = quad;
				let left = _x - x3;
				let right2 = left + quadsize;
				const bottom = _y - y2;
				const top = bottom + quadsize;
				if (this._rtl) {
					const shift = quadsize - x3 - this._spacing * advance - x3;
					left -= shift;
					right2 -= shift;
				}
				meshInfo.positions[quad * 4 * 3 + 0] = left;
				meshInfo.positions[quad * 4 * 3 + 1] = bottom;
				meshInfo.positions[quad * 4 * 3 + 2] = _z;
				meshInfo.positions[quad * 4 * 3 + 3] = right2;
				meshInfo.positions[quad * 4 * 3 + 4] = bottom;
				meshInfo.positions[quad * 4 * 3 + 5] = _z;
				meshInfo.positions[quad * 4 * 3 + 6] = right2;
				meshInfo.positions[quad * 4 * 3 + 7] = top;
				meshInfo.positions[quad * 4 * 3 + 8] = _z;
				meshInfo.positions[quad * 4 * 3 + 9] = left;
				meshInfo.positions[quad * 4 * 3 + 10] = top;
				meshInfo.positions[quad * 4 * 3 + 11] = _z;
				this.width = Math.max(this.width, candidateLineWidth);
				let fontSize;
				if (this._shouldAutoFitWidth() && this.width > this._element.calculatedWidth) {
					fontSize = Math.floor(this._element.fontSize * this._element.calculatedWidth / (this.width || 1e-4));
					fontSize = math.clamp(fontSize, minFont, maxFont);
					if (fontSize !== this._element.fontSize) {
						this._fontSize = fontSize;
						retryUpdateMeshes = true;
						break;
					}
				}
				this.height = Math.max(this.height, fontMaxY - (_y + fontMinY));
				if (this._shouldAutoFitHeight() && this.height > this._element.calculatedHeight) {
					fontSize = math.clamp(this._fontSize - 1, minFont, maxFont);
					if (fontSize !== this._element.fontSize) {
						this._fontSize = fontSize;
						retryUpdateMeshes = true;
						break;
					}
				}
				_x += this._spacing * advance;
				if (!isWhitespace) {
					_xMinusTrailingWhitespace = _x;
				}
				if (this._isWordBoundary(char) || this._isValidNextChar(nextchar) && (this._isNextCJKBoundary(char, nextchar) || this._isNextCJKWholeWord(nextchar))) {
					numWordsThisLine++;
					wordStartX = _xMinusTrailingWhitespace;
					wordStartIndex = i2 + 1;
				}
				numCharsThisLine++;
				const uv = this._getUv(char);
				meshInfo.uvs[quad * 4 * 2 + 0] = uv[0];
				meshInfo.uvs[quad * 4 * 2 + 1] = 1 - uv[1];
				meshInfo.uvs[quad * 4 * 2 + 2] = uv[2];
				meshInfo.uvs[quad * 4 * 2 + 3] = 1 - uv[1];
				meshInfo.uvs[quad * 4 * 2 + 4] = uv[2];
				meshInfo.uvs[quad * 4 * 2 + 5] = 1 - uv[3];
				meshInfo.uvs[quad * 4 * 2 + 6] = uv[0];
				meshInfo.uvs[quad * 4 * 2 + 7] = 1 - uv[3];
				if (this._symbolColors) {
					const colorIdx = this._symbolColors[i2] * 3;
					color_r = this._colorPalette[colorIdx];
					color_g = this._colorPalette[colorIdx + 1];
					color_b = this._colorPalette[colorIdx + 2];
				}
				meshInfo.colors[quad * 4 * 4 + 0] = color_r;
				meshInfo.colors[quad * 4 * 4 + 1] = color_g;
				meshInfo.colors[quad * 4 * 4 + 2] = color_b;
				meshInfo.colors[quad * 4 * 4 + 3] = 255;
				meshInfo.colors[quad * 4 * 4 + 4] = color_r;
				meshInfo.colors[quad * 4 * 4 + 5] = color_g;
				meshInfo.colors[quad * 4 * 4 + 6] = color_b;
				meshInfo.colors[quad * 4 * 4 + 7] = 255;
				meshInfo.colors[quad * 4 * 4 + 8] = color_r;
				meshInfo.colors[quad * 4 * 4 + 9] = color_g;
				meshInfo.colors[quad * 4 * 4 + 10] = color_b;
				meshInfo.colors[quad * 4 * 4 + 11] = 255;
				meshInfo.colors[quad * 4 * 4 + 12] = color_r;
				meshInfo.colors[quad * 4 * 4 + 13] = color_g;
				meshInfo.colors[quad * 4 * 4 + 14] = color_b;
				meshInfo.colors[quad * 4 * 4 + 15] = 255;
				if (this._symbolOutlineParams) {
					const outlineIdx = this._symbolOutlineParams[i2] * 5;
					outline_color_rg = this._outlinePalette[outlineIdx] + this._outlinePalette[outlineIdx + 1] * 256;
					outline_color_ba = this._outlinePalette[outlineIdx + 2] + this._outlinePalette[outlineIdx + 3] * 256;
					outline_thickness = this._outlinePalette[outlineIdx + 4];
				}
				meshInfo.outlines[quad * 4 * 3 + 0] = outline_color_rg;
				meshInfo.outlines[quad * 4 * 3 + 1] = outline_color_ba;
				meshInfo.outlines[quad * 4 * 3 + 2] = outline_thickness;
				meshInfo.outlines[quad * 4 * 3 + 3] = outline_color_rg;
				meshInfo.outlines[quad * 4 * 3 + 4] = outline_color_ba;
				meshInfo.outlines[quad * 4 * 3 + 5] = outline_thickness;
				meshInfo.outlines[quad * 4 * 3 + 6] = outline_color_rg;
				meshInfo.outlines[quad * 4 * 3 + 7] = outline_color_ba;
				meshInfo.outlines[quad * 4 * 3 + 8] = outline_thickness;
				meshInfo.outlines[quad * 4 * 3 + 9] = outline_color_rg;
				meshInfo.outlines[quad * 4 * 3 + 10] = outline_color_ba;
				meshInfo.outlines[quad * 4 * 3 + 11] = outline_thickness;
				if (this._symbolShadowParams) {
					const shadowIdx = this._symbolShadowParams[i2] * 6;
					shadow_color_rg = this._shadowPalette[shadowIdx] + this._shadowPalette[shadowIdx + 1] * 256;
					shadow_color_ba = this._shadowPalette[shadowIdx + 2] + this._shadowPalette[shadowIdx + 3] * 256;
					shadow_offset_xy = this._shadowPalette[shadowIdx + 4] + 127 + Math.round(ratio * this._shadowPalette[shadowIdx + 5] + 127) * 256;
				}
				meshInfo.shadows[quad * 4 * 3 + 0] = shadow_color_rg;
				meshInfo.shadows[quad * 4 * 3 + 1] = shadow_color_ba;
				meshInfo.shadows[quad * 4 * 3 + 2] = shadow_offset_xy;
				meshInfo.shadows[quad * 4 * 3 + 3] = shadow_color_rg;
				meshInfo.shadows[quad * 4 * 3 + 4] = shadow_color_ba;
				meshInfo.shadows[quad * 4 * 3 + 5] = shadow_offset_xy;
				meshInfo.shadows[quad * 4 * 3 + 6] = shadow_color_rg;
				meshInfo.shadows[quad * 4 * 3 + 7] = shadow_color_ba;
				meshInfo.shadows[quad * 4 * 3 + 8] = shadow_offset_xy;
				meshInfo.shadows[quad * 4 * 3 + 9] = shadow_color_rg;
				meshInfo.shadows[quad * 4 * 3 + 10] = shadow_color_ba;
				meshInfo.shadows[quad * 4 * 3 + 11] = shadow_offset_xy;
				meshInfo.quad++;
			}
			if (retryUpdateMeshes) {
				continue;
			}
			if (lineStartIndex < l) {
				breakLine(this._symbols, l, _x);
			}
		}
		this._noResize = true;
		this.autoWidth = this._autoWidth;
		this.autoHeight = this._autoHeight;
		this._noResize = false;
		const hp = this._element.pivot.x;
		const vp = this._element.pivot.y;
		const ha = this._alignment.x;
		const va = this._alignment.y;
		for (let i2 = 0; i2 < this._meshInfo.length; i2++) {
			if (this._meshInfo[i2].count === 0) continue;
			let prevQuad = 0;
			for (const line in this._meshInfo[i2].lines) {
				const index = this._meshInfo[i2].lines[line];
				const lw = this._lineWidths[parseInt(line, 10)];
				const hoffset = -hp * this._element.calculatedWidth + ha * (this._element.calculatedWidth - lw) * (this._rtl ? -1 : 1);
				const voffset = (1 - vp) * this._element.calculatedHeight - fontMaxY - (1 - va) * (this._element.calculatedHeight - this.height);
				for (let quad2 = prevQuad; quad2 <= index; quad2++) {
					this._meshInfo[i2].positions[quad2 * 4 * 3] += hoffset;
					this._meshInfo[i2].positions[quad2 * 4 * 3 + 3] += hoffset;
					this._meshInfo[i2].positions[quad2 * 4 * 3 + 6] += hoffset;
					this._meshInfo[i2].positions[quad2 * 4 * 3 + 9] += hoffset;
					this._meshInfo[i2].positions[quad2 * 4 * 3 + 1] += voffset;
					this._meshInfo[i2].positions[quad2 * 4 * 3 + 4] += voffset;
					this._meshInfo[i2].positions[quad2 * 4 * 3 + 7] += voffset;
					this._meshInfo[i2].positions[quad2 * 4 * 3 + 10] += voffset;
				}
				if (this._rtl) {
					for (let quad2 = prevQuad; quad2 <= index; quad2++) {
						const idx = quad2 * 4 * 3;
						for (let vert = 0; vert < 4; ++vert) {
							this._meshInfo[i2].positions[idx + vert * 3] = this._element.calculatedWidth - this._meshInfo[i2].positions[idx + vert * 3] + hoffset * 2;
						}
						const tmp0 = this._meshInfo[i2].positions[idx + 3];
						const tmp1 = this._meshInfo[i2].positions[idx + 6];
						this._meshInfo[i2].positions[idx + 3] = this._meshInfo[i2].positions[idx + 0];
						this._meshInfo[i2].positions[idx + 6] = this._meshInfo[i2].positions[idx + 9];
						this._meshInfo[i2].positions[idx + 0] = tmp0;
						this._meshInfo[i2].positions[idx + 9] = tmp1;
					}
				}
				prevQuad = index + 1;
			}
			const numVertices = this._meshInfo[i2].count * 4;
			const vertMax = this._meshInfo[i2].quad * 4;
			const it = new VertexIterator(this._meshInfo[i2].meshInstance.mesh.vertexBuffer);
			for (let v6 = 0; v6 < numVertices; v6++) {
				if (v6 >= vertMax) {
					it.element[SEMANTIC_POSITION].set(0, 0, 0);
					it.element[SEMANTIC_TEXCOORD0].set(0, 0);
					it.element[SEMANTIC_COLOR].set(0, 0, 0, 0);
					it.element[SEMANTIC_ATTR8].set(0, 0, 0, 0);
					it.element[SEMANTIC_ATTR9].set(0, 0, 0, 0);
				} else {
					it.element[SEMANTIC_POSITION].set(this._meshInfo[i2].positions[v6 * 3 + 0], this._meshInfo[i2].positions[v6 * 3 + 1], this._meshInfo[i2].positions[v6 * 3 + 2]);
					it.element[SEMANTIC_TEXCOORD0].set(this._meshInfo[i2].uvs[v6 * 2 + 0], this._meshInfo[i2].uvs[v6 * 2 + 1]);
					it.element[SEMANTIC_COLOR].set(
						this._meshInfo[i2].colors[v6 * 4 + 0],
						this._meshInfo[i2].colors[v6 * 4 + 1],
						this._meshInfo[i2].colors[v6 * 4 + 2],
						this._meshInfo[i2].colors[v6 * 4 + 3]
					);
					it.element[SEMANTIC_ATTR8].set(
						this._meshInfo[i2].outlines[v6 * 3 + 0],
						this._meshInfo[i2].outlines[v6 * 3 + 1],
						this._meshInfo[i2].outlines[v6 * 3 + 2]
					);
					it.element[SEMANTIC_ATTR9].set(
						this._meshInfo[i2].shadows[v6 * 3 + 0],
						this._meshInfo[i2].shadows[v6 * 3 + 1],
						this._meshInfo[i2].shadows[v6 * 3 + 2]
					);
				}
				it.next();
			}
			it.end();
			this._meshInfo[i2].meshInstance.mesh.aabb.compute(this._meshInfo[i2].positions);
			this._meshInfo[i2].meshInstance._aabbVer = -1;
		}
		this._aabbDirty = true;
	}
	_onFontRender() {
		this.font = this._font;
	}
	_onFontLoad(asset) {
		if (this.font !== asset.resource) {
			if (this._i18nKey) {
				this._text = this._system.app.i18n.getText(this._i18nKey);
			}
			this.font = asset.resource;
		}
	}
	_onFontChange(asset, name, _new, _old) {
		if (name === "data") {
			this._font.data = _new;
			const maps = this._font.data.info.maps.length;
			for (let i2 = 0; i2 < maps; i2++) {
				if (!this._meshInfo[i2]) continue;
				const mi = this._meshInfo[i2].meshInstance;
				if (mi) {
					mi.setParameter("font_sdfIntensity", this._font.intensity);
					mi.setParameter("font_pxrange", this._getPxRange(this._font));
				}
			}
		}
	}
	_onFontRemove(asset) {
	}
	_setTextureParams(mi, texture) {
		if (this._font) {
			if (this._font.type === FONT_MSDF) {
				mi.deleteParameter("texture_emissiveMap");
				mi.deleteParameter("texture_opacityMap");
				mi.setParameter("texture_msdfMap", texture);
			} else if (this._font.type === FONT_BITMAP) {
				mi.deleteParameter("texture_msdfMap");
				mi.setParameter("texture_emissiveMap", texture);
				mi.setParameter("texture_opacityMap", texture);
			}
		}
	}
	_getPxRange(font) {
		const keys = Object.keys(this._font.data.chars);
		for (let i2 = 0; i2 < keys.length; i2++) {
			const char = this._font.data.chars[keys[i2]];
			if (char.range) {
				return (char.scale || 1) * char.range;
			}
		}
		return 2;
	}
	_getUv(char) {
		const data2 = this._font.data;
		if (!data2.chars[char]) {
			const space = " ";
			if (data2.chars[space]) {
				return this._getUv(space);
			}
			return [0, 0, 0, 0];
		}
		const map = data2.chars[char].map;
		const width = data2.info.maps[map].width;
		const height = data2.info.maps[map].height;
		const x3 = data2.chars[char].x;
		const y2 = data2.chars[char].y;
		const x1 = x3;
		const y1 = y2;
		const x22 = x3 + data2.chars[char].width;
		const y22 = y2 - data2.chars[char].height;
		const edge = 1 - data2.chars[char].height / height;
		return [
			x1 / width,
			edge - y1 / height,
			// bottom left
			x22 / width,
			edge - y22 / height
			// top right
		];
	}
	onEnable() {
		this._fontAsset.autoLoad = true;
		if (this._model) {
			this._element.addModelToLayers(this._model);
		}
	}
	onDisable() {
		this._fontAsset.autoLoad = false;
		if (this._model) {
			this._element.removeModelFromLayers(this._model);
		}
	}
	_setStencil(stencilParams) {
		if (this._model) {
			const instances = this._model.meshInstances;
			for (let i2 = 0; i2 < instances.length; i2++) {
				instances[i2].stencilFront = stencilParams;
				instances[i2].stencilBack = stencilParams;
			}
		}
	}
	_shouldAutoFitWidth() {
		return this._autoFitWidth && !this._autoWidth;
	}
	_shouldAutoFitHeight() {
		return this._autoFitHeight && !this._autoHeight;
	}
	_shouldAutoFit() {
		return this._autoFitWidth && !this._autoWidth || this._autoFitHeight && !this._autoHeight;
	}
	// calculate the number of characters per texture up to, but not including
	// the specified symbolIndex
	_calculateCharsPerTexture(symbolIndex) {
		const charactersPerTexture = {};
		if (symbolIndex === void 0) {
			symbolIndex = this._symbols.length;
		}
		for (let i2 = 0, len = symbolIndex; i2 < len; i2++) {
			const char = this._symbols[i2];
			let info = this._font.data.chars[char];
			if (!info) {
				info = this._font.data.chars[" "];
				if (!info) {
					info = this._font.data.chars[Object.keys(this._font.data.chars)[0]];
				}
			}
			const map = info.map;
			if (!charactersPerTexture[map]) {
				charactersPerTexture[map] = 1;
			} else {
				charactersPerTexture[map]++;
			}
		}
		return charactersPerTexture;
	}
	_updateRenderRange() {
		const startChars = this._rangeStart === 0 ? 0 : this._calculateCharsPerTexture(this._rangeStart);
		const endChars = this._rangeEnd === 0 ? 0 : this._calculateCharsPerTexture(this._rangeEnd);
		for (let i2 = 0, len = this._meshInfo.length; i2 < len; i2++) {
			const start = startChars[i2] || 0;
			const end = endChars[i2] || 0;
			const instance = this._meshInfo[i2].meshInstance;
			if (instance) {
				const mesh = instance.mesh;
				if (mesh) {
					mesh.primitive[0].base = start * 3 * 2;
					mesh.primitive[0].count = (end - start) * 3 * 2;
				}
			}
		}
	}
	set text(value) {
		this._i18nKey = null;
		const str = value != null && value.toString() || "";
		this._setText(str);
	}
	get text() {
		return this._text;
	}
	set key(value) {
		const str = value !== null ? value.toString() : null;
		if (this._i18nKey === str) {
			return;
		}
		this._i18nKey = str;
		if (str) {
			this._fontAsset.disableLocalization = false;
			this._resetLocalizedText();
		} else {
			this._fontAsset.disableLocalization = true;
		}
	}
	get key() {
		return this._i18nKey;
	}
	set color(value) {
		const r = value.r;
		const g = value.g;
		const b = value.b;
		if (this._color.r === r && this._color.g === g && this._color.b === b) {
			return;
		}
		this._color.r = r;
		this._color.g = g;
		this._color.b = b;
		if (!this._model) {
			return;
		}
		if (this._symbolColors) {
			if (this._font) {
				this._updateText();
			}
		} else {
			_tempColor3.linear(this._color);
			this._colorUniform[0] = _tempColor3.r;
			this._colorUniform[1] = _tempColor3.g;
			this._colorUniform[2] = _tempColor3.b;
			for (let i2 = 0, len = this._model.meshInstances.length; i2 < len; i2++) {
				const mi = this._model.meshInstances[i2];
				mi.setParameter("material_emissive", this._colorUniform);
			}
		}
		if (this._element) {
			this._element.fire("set:color", this._color);
		}
	}
	get color() {
		return this._color;
	}
	set opacity(value) {
		if (this._color.a !== value) {
			this._color.a = value;
			if (this._model) {
				for (let i2 = 0, len = this._model.meshInstances.length; i2 < len; i2++) {
					const mi = this._model.meshInstances[i2];
					mi.setParameter("material_opacity", value);
				}
			}
		}
		if (this._element) {
			this._element.fire("set:opacity", value);
		}
	}
	get opacity() {
		return this._color.a;
	}
	set lineHeight(value) {
		const _prev = this._lineHeight;
		this._lineHeight = value;
		this._scaledLineHeight = value;
		if (_prev !== value && this._font) {
			this._updateText();
		}
	}
	get lineHeight() {
		return this._lineHeight;
	}
	set wrapLines(value) {
		const _prev = this._wrapLines;
		this._wrapLines = value;
		if (_prev !== value && this._font) {
			this._updateText();
		}
	}
	get wrapLines() {
		return this._wrapLines;
	}
	get lines() {
		return this._lineContents;
	}
	set spacing(value) {
		const _prev = this._spacing;
		this._spacing = value;
		if (_prev !== value && this._font) {
			this._updateText();
		}
	}
	get spacing() {
		return this._spacing;
	}
	set fontSize(value) {
		const _prev = this._fontSize;
		this._fontSize = value;
		this._originalFontSize = value;
		if (_prev !== value && this._font) {
			this._updateText();
		}
	}
	get fontSize() {
		return this._fontSize;
	}
	set fontAsset(value) {
		this._fontAsset.defaultAsset = value;
	}
	get fontAsset() {
		return this._fontAsset.localizedAsset;
	}
	set font(value) {
		let previousFontType;
		if (this._font) {
			previousFontType = this._font.type;
			if (this._font.off) this._font.off("render", this._onFontRender, this);
		}
		this._font = value;
		this._fontMinY = 0;
		this._fontMaxY = 0;
		if (!value) return;
		const json = this._font.data;
		for (const charId in json.chars) {
			const data2 = json.chars[charId];
			if (data2.bounds) {
				this._fontMinY = Math.min(this._fontMinY, data2.bounds[1]);
				this._fontMaxY = Math.max(this._fontMaxY, data2.bounds[3]);
			}
		}
		if (this._font.on) this._font.on("render", this._onFontRender, this);
		if (this._fontAsset.localizedAsset) {
			const asset = this._system.app.assets.get(this._fontAsset.localizedAsset);
			if (asset.resource !== this._font) {
				this._fontAsset.defaultAsset = null;
			}
		}
		if (value.type !== previousFontType) {
			const screenSpace = this._element._isScreenSpace();
			this._updateMaterial(screenSpace);
		}
		for (let i2 = 0, len = this._font.textures.length; i2 < len; i2++) {
			if (!this._meshInfo[i2]) {
				this._meshInfo[i2] = new MeshInfo();
			} else {
				const mi = this._meshInfo[i2].meshInstance;
				if (mi) {
					mi.setParameter("font_sdfIntensity", this._font.intensity);
					mi.setParameter("font_pxrange", this._getPxRange(this._font));
					this._setTextureParams(mi, this._font.textures[i2]);
				}
			}
		}
		let removedModel = false;
		for (let i2 = this._font.textures.length; i2 < this._meshInfo.length; i2++) {
			if (this._meshInfo[i2].meshInstance) {
				if (!removedModel) {
					this._element.removeModelFromLayers(this._model);
					removedModel = true;
				}
				this._removeMeshInstance(this._meshInfo[i2].meshInstance);
			}
		}
		if (this._meshInfo.length > this._font.textures.length) {
			this._meshInfo.length = this._font.textures.length;
		}
		this._updateText();
	}
	get font() {
		return this._font;
	}
	set alignment(value) {
		if (value instanceof Vec2) {
			this._alignment.set(value.x, value.y);
		} else {
			this._alignment.set(value[0], value[1]);
		}
		if (this._font) {
			this._updateText();
		}
	}
	get alignment() {
		return this._alignment;
	}
	set autoWidth(value) {
		const old = this._autoWidth;
		this._autoWidth = value;
		if (value && Math.abs(this._element.anchor.x - this._element.anchor.z) < 1e-4) {
			this._element.width = this.width;
		}
		if (old !== value) {
			const newFontSize = this._shouldAutoFit() ? this._maxFontSize : this._originalFontSize;
			if (newFontSize !== this._fontSize) {
				this._fontSize = newFontSize;
				if (this._font) {
					this._updateText();
				}
			}
		}
	}
	get autoWidth() {
		return this._autoWidth;
	}
	set autoHeight(value) {
		const old = this._autoHeight;
		this._autoHeight = value;
		if (value && Math.abs(this._element.anchor.y - this._element.anchor.w) < 1e-4) {
			this._element.height = this.height;
		}
		if (old !== value) {
			const newFontSize = this._shouldAutoFit() ? this._maxFontSize : this._originalFontSize;
			if (newFontSize !== this._fontSize) {
				this._fontSize = newFontSize;
				if (this._font) {
					this._updateText();
				}
			}
		}
	}
	get autoHeight() {
		return this._autoHeight;
	}
	set rtlReorder(value) {
		if (this._rtlReorder !== value) {
			this._rtlReorder = value;
			if (this._font) {
				this._updateText();
			}
		}
	}
	get rtlReorder() {
		return this._rtlReorder;
	}
	set unicodeConverter(value) {
		if (this._unicodeConverter !== value) {
			this._unicodeConverter = value;
			this._setText(this._text);
		}
	}
	get unicodeConverter() {
		return this._unicodeConverter;
	}
	// private
	get aabb() {
		if (this._aabbDirty) {
			let initialized = false;
			for (let i2 = 0; i2 < this._meshInfo.length; i2++) {
				if (!this._meshInfo[i2].meshInstance) continue;
				if (!initialized) {
					this._aabb.copy(this._meshInfo[i2].meshInstance.aabb);
					initialized = true;
				} else {
					this._aabb.add(this._meshInfo[i2].meshInstance.aabb);
				}
			}
			this._aabbDirty = false;
		}
		return this._aabb;
	}
	set outlineColor(value) {
		const r = value instanceof Color ? value.r : value[0];
		const g = value instanceof Color ? value.g : value[1];
		const b = value instanceof Color ? value.b : value[2];
		const a = value instanceof Color ? value.a : value[3];
		if (this._outlineColor.r === r && this._outlineColor.g === g && this._outlineColor.b === b && this._outlineColor.a === a) {
			return;
		}
		this._outlineColor.r = r;
		this._outlineColor.g = g;
		this._outlineColor.b = b;
		this._outlineColor.a = a;
		if (!this._model) {
			return;
		}
		if (this._symbolOutlineParams) {
			if (this._font) {
				this._updateText();
			}
		} else {
			_tempColor3.linear(this._outlineColor);
			this._outlineColorUniform[0] = _tempColor3.r;
			this._outlineColorUniform[1] = _tempColor3.g;
			this._outlineColorUniform[2] = _tempColor3.b;
			this._outlineColorUniform[3] = _tempColor3.a;
			for (let i2 = 0, len = this._model.meshInstances.length; i2 < len; i2++) {
				const mi = this._model.meshInstances[i2];
				mi.setParameter("outline_color", this._outlineColorUniform);
			}
		}
		if (this._element) {
			this._element.fire("set:outline", this._color);
		}
	}
	get outlineColor() {
		return this._outlineColor;
	}
	set outlineThickness(value) {
		const _prev = this._outlineThickness;
		this._outlineThickness = value;
		if (_prev !== value && this._font) {
			if (!this._model) {
				return;
			}
			if (this._symbolOutlineParams) {
				if (this._font) {
					this._updateText();
				}
			} else {
				for (let i2 = 0, len = this._model.meshInstances.length; i2 < len; i2++) {
					const mi = this._model.meshInstances[i2];
					mi.setParameter("outline_thickness", this._outlineThicknessScale * this._outlineThickness);
				}
			}
		}
	}
	get outlineThickness() {
		return this._outlineThickness;
	}
	set shadowColor(value) {
		const r = value instanceof Color ? value.r : value[0];
		const g = value instanceof Color ? value.g : value[1];
		const b = value instanceof Color ? value.b : value[2];
		const a = value instanceof Color ? value.a : value[3];
		if (this._shadowColor.r === r && this._shadowColor.g === g && this._shadowColor.b === b && this._shadowColor.a === a) {
			return;
		}
		this._shadowColor.r = r;
		this._shadowColor.g = g;
		this._shadowColor.b = b;
		this._shadowColor.a = a;
		if (!this._model) {
			return;
		}
		if (this._symbolShadowParams) {
			if (this._font) {
				this._updateText();
			}
		} else {
			_tempColor3.linear(this._shadowColor);
			this._shadowColorUniform[0] = _tempColor3.r;
			this._shadowColorUniform[1] = _tempColor3.g;
			this._shadowColorUniform[2] = _tempColor3.b;
			this._shadowColorUniform[3] = _tempColor3.a;
			for (let i2 = 0, len = this._model.meshInstances.length; i2 < len; i2++) {
				const mi = this._model.meshInstances[i2];
				mi.setParameter("shadow_color", this._shadowColorUniform);
			}
		}
	}
	get shadowColor() {
		return this._shadowColor;
	}
	set shadowOffset(value) {
		const x3 = value instanceof Vec2 ? value.x : value[0], y2 = value instanceof Vec2 ? value.y : value[1];
		if (this._shadowOffset.x === x3 && this._shadowOffset.y === y2) {
			return;
		}
		this._shadowOffset.set(x3, y2);
		if (this._font && this._model) {
			if (this._symbolShadowParams) {
				this._updateText();
			} else {
				for (let i2 = 0, len = this._model.meshInstances.length; i2 < len; i2++) {
					const ratio = -this._font.data.info.maps[i2].width / this._font.data.info.maps[i2].height;
					this._shadowOffsetUniform[0] = this._shadowOffsetScale * this._shadowOffset.x;
					this._shadowOffsetUniform[1] = ratio * this._shadowOffsetScale * this._shadowOffset.y;
					const mi = this._model.meshInstances[i2];
					mi.setParameter("shadow_offset", this._shadowOffsetUniform);
				}
			}
		}
	}
	get shadowOffset() {
		return this._shadowOffset;
	}
	set minFontSize(value) {
		if (this._minFontSize === value) return;
		this._minFontSize = value;
		if (this.font && this._shouldAutoFit()) {
			this._updateText();
		}
	}
	get minFontSize() {
		return this._minFontSize;
	}
	set maxFontSize(value) {
		if (this._maxFontSize === value) return;
		this._maxFontSize = value;
		if (this.font && this._shouldAutoFit()) {
			this._updateText();
		}
	}
	get maxFontSize() {
		return this._maxFontSize;
	}
	set autoFitWidth(value) {
		if (this._autoFitWidth === value) return;
		this._autoFitWidth = value;
		this._fontSize = this._shouldAutoFit() ? this._maxFontSize : this._originalFontSize;
		if (this.font) {
			this._updateText();
		}
	}
	get autoFitWidth() {
		return this._autoFitWidth;
	}
	set autoFitHeight(value) {
		if (this._autoFitHeight === value) return;
		this._autoFitHeight = value;
		this._fontSize = this._shouldAutoFit() ? this._maxFontSize : this._originalFontSize;
		if (this.font) {
			this._updateText();
		}
	}
	get autoFitHeight() {
		return this._autoFitHeight;
	}
	set maxLines(value) {
		if (this._maxLines === value) return;
		if (value === null && this._maxLines === -1) return;
		this._maxLines = value === null ? -1 : value;
		if (this.font && this._wrapLines) {
			this._updateText();
		}
	}
	get maxLines() {
		return this._maxLines;
	}
	set enableMarkup(value) {
		value = !!value;
		if (this._enableMarkup === value) return;
		this._enableMarkup = value;
		if (this.font) {
			this._updateText();
		}
		const screenSpace = this._element._isScreenSpace();
		this._updateMaterial(screenSpace);
	}
	get enableMarkup() {
		return this._enableMarkup;
	}
	get symbols() {
		return this._symbols;
	}
	get symbolColors() {
		if (this._symbolColors === null) {
			return null;
		}
		return this._symbolColors.map(function(c2) {
			return this._colorPalette.slice(c2 * 3, c2 * 3 + 3);
		}, this);
	}
	// NOTE: it is used only for tests
	get symbolOutlineParams() {
		if (this._symbolOutlineParams === null) {
			return null;
		}
		return this._symbolOutlineParams.map(function(paramId) {
			return this._outlinePalette.slice(paramId * 5, paramId * 5 + 5);
		}, this);
	}
	// NOTE: it is used only for tests
	get symbolShadowParams() {
		if (this._symbolShadowParams === null) {
			return null;
		}
		return this._symbolShadowParams.map(function(paramId) {
			return this._shadowPalette.slice(paramId * 6, paramId * 6 + 6);
		}, this);
	}
	get rtl() {
		return this._rtl;
	}
	set rangeStart(rangeStart) {
		rangeStart = Math.max(0, Math.min(rangeStart, this._symbols.length));
		if (rangeStart !== this._rangeStart) {
			this._rangeStart = rangeStart;
			this._updateRenderRange();
		}
	}
	get rangeStart() {
		return this._rangeStart;
	}
	set rangeEnd(rangeEnd) {
		rangeEnd = Math.max(this._rangeStart, Math.min(rangeEnd, this._symbols.length));
		if (rangeEnd !== this._rangeEnd) {
			this._rangeEnd = rangeEnd;
			this._updateRenderRange();
		}
	}
	get rangeEnd() {
		return this._rangeEnd;
	}
};

var position2 = new Vec3();
var invParentWtm2 = new Mat4();
var vecA = new Vec3();
var vecB = new Vec3();
var matA = new Mat4();
var matB = new Mat4();
var matC = new Mat4();
var matD = new Mat4();
var tmpCorners = [new Vec3(), new Vec3(), new Vec3(), new Vec3()];
var ElementComponent = class extends Component {
	static EVENT_MOUSEDOWN = "mousedown";
	static EVENT_MOUSEUP = "mouseup";
	static EVENT_MOUSEENTER = "mouseenter";
	static EVENT_MOUSELEAVE = "mouseleave";
	static EVENT_MOUSEMOVE = "mousemove";
	static EVENT_MOUSEWHEEL = "mousewheel";
	static EVENT_CLICK = "click";
	static EVENT_TOUCHSTART = "touchstart";
	static EVENT_TOUCHEND = "touchend";
	static EVENT_TOUCHMOVE = "touchmove";
	static EVENT_TOUCHCANCEL = "touchcancel";
	_evtLayersChanged = null;
	_evtLayerAdded = null;
	_evtLayerRemoved = null;
	constructor(system, entity) {
		super(system, entity);
		this._beingInitialized = false;
		this._anchor = new Vec4();
		this._localAnchor = new Vec4();
		this._pivot = new Vec2();
		this._width = this._calculatedWidth = 32;
		this._height = this._calculatedHeight = 32;
		this._margin = new Vec4(0, 0, -32, -32);
		this._modelTransform = new Mat4();
		this._screenToWorld = new Mat4();
		this._anchorTransform = new Mat4();
		this._anchorDirty = true;
		this._parentWorldTransform = new Mat4();
		this._screenTransform = new Mat4();
		this._screenCorners = [new Vec3(), new Vec3(), new Vec3(), new Vec3()];
		this._canvasCorners = [new Vec2(), new Vec2(), new Vec2(), new Vec2()];
		this._worldCorners = [new Vec3(), new Vec3(), new Vec3(), new Vec3()];
		this._cornersDirty = true;
		this._canvasCornersDirty = true;
		this._worldCornersDirty = true;
		this.entity.on("insert", this._onInsert, this);
		this._patch();
		this.screen = null;
		this._type = ELEMENTTYPE_GROUP;
		this._image = null;
		this._text = null;
		this._group = null;
		this._drawOrder = 0;
		this._fitMode = FITMODE_STRETCH;
		this._useInput = false;
		this._layers = [LAYERID_UI];
		this._addedModels = [];
		this._batchGroupId = -1;
		this._offsetReadAt = 0;
		this._maskOffset = 0.5;
		this._maskedBy = null;
	}
	get _absLeft() {
		return this._localAnchor.x + this._margin.x;
	}
	get _absRight() {
		return this._localAnchor.z - this._margin.z;
	}
	get _absTop() {
		return this._localAnchor.w - this._margin.w;
	}
	get _absBottom() {
		return this._localAnchor.y + this._margin.y;
	}
	get _hasSplitAnchorsX() {
		return Math.abs(this._anchor.x - this._anchor.z) > 1e-3;
	}
	get _hasSplitAnchorsY() {
		return Math.abs(this._anchor.y - this._anchor.w) > 1e-3;
	}
	get aabb() {
		if (this._image) {
			return this._image.aabb;
		}
		if (this._text) {
			return this._text.aabb;
		}
		return null;
	}
	set anchor(value) {
		if (value instanceof Vec4) {
			this._anchor.copy(value);
		} else {
			this._anchor.set(...value);
		}
		if (!this.entity._parent && !this.screen) {
			this._calculateLocalAnchors();
		} else {
			this._calculateSize(this._hasSplitAnchorsX, this._hasSplitAnchorsY);
		}
		this._anchorDirty = true;
		if (!this.entity._dirtyLocal) {
			this.entity._dirtifyLocal();
		}
		this.fire("set:anchor", this._anchor);
	}
	get anchor() {
		return this._anchor;
	}
	set batchGroupId(value) {
		if (this._batchGroupId === value) {
			return;
		}
		if (this.entity.enabled && this._batchGroupId >= 0) {
			this.system.app.batcher?.remove(BatchGroup.ELEMENT, this.batchGroupId, this.entity);
		}
		if (this.entity.enabled && value >= 0) {
			this.system.app.batcher?.insert(BatchGroup.ELEMENT, value, this.entity);
		}
		if (value < 0 && this._batchGroupId >= 0 && this.enabled && this.entity.enabled) {
			if (this._image && this._image._renderable.model) {
				this.addModelToLayers(this._image._renderable.model);
			} else if (this._text && this._text._model) {
				this.addModelToLayers(this._text._model);
			}
		}
		this._batchGroupId = value;
	}
	get batchGroupId() {
		return this._batchGroupId;
	}
	set bottom(value) {
		this._margin.y = value;
		const p = this.entity.getLocalPosition();
		const wt = this._absTop;
		const wb = this._localAnchor.y + value;
		this._setHeight(wt - wb);
		p.y = value + this._calculatedHeight * this._pivot.y;
		this.entity.setLocalPosition(p);
	}
	get bottom() {
		return this._margin.y;
	}
	set calculatedWidth(value) {
		this._setCalculatedWidth(value, true);
	}
	get calculatedWidth() {
		return this._calculatedWidth;
	}
	set calculatedHeight(value) {
		this._setCalculatedHeight(value, true);
	}
	get calculatedHeight() {
		return this._calculatedHeight;
	}
	get canvasCorners() {
		if (!this._canvasCornersDirty || !this.screen || !this.screen.screen.screenSpace) {
			return this._canvasCorners;
		}
		const device = this.system.app.graphicsDevice;
		const screenCorners = this.screenCorners;
		const sx = device.canvas.clientWidth / device.width;
		const sy = device.canvas.clientHeight / device.height;
		for (let i2 = 0; i2 < 4; i2++) {
			this._canvasCorners[i2].set(screenCorners[i2].x * sx, (device.height - screenCorners[i2].y) * sy);
		}
		this._canvasCornersDirty = false;
		return this._canvasCorners;
	}
	set drawOrder(value) {
		let priority = 0;
		if (this.screen) {
			priority = this.screen.screen.priority;
		}
		if (value > 16777215) {
			value = 16777215;
		}
		this._drawOrder = (priority << 24) + value;
		this.fire("set:draworder", this._drawOrder);
	}
	get drawOrder() {
		return this._drawOrder;
	}
	set height(value) {
		this._height = value;
		if (!this._hasSplitAnchorsY) {
			this._setCalculatedHeight(value, true);
		}
		this.fire("set:height", this._height);
	}
	get height() {
		return this._height;
	}
	set layers(value) {
		if (this._addedModels.length) {
			for (let i2 = 0; i2 < this._layers.length; i2++) {
				const layer = this.system.app.scene.layers.getLayerById(this._layers[i2]);
				if (layer) {
					for (let j = 0; j < this._addedModels.length; j++) {
						layer.removeMeshInstances(this._addedModels[j].meshInstances);
					}
				}
			}
		}
		this._layers = value;
		if (!this.enabled || !this.entity.enabled || !this._addedModels.length) {
			return;
		}
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(this._layers[i2]);
			if (layer) {
				for (let j = 0; j < this._addedModels.length; j++) {
					layer.addMeshInstances(this._addedModels[j].meshInstances);
				}
			}
		}
	}
	get layers() {
		return this._layers;
	}
	set left(value) {
		this._margin.x = value;
		const p = this.entity.getLocalPosition();
		const wr = this._absRight;
		const wl = this._localAnchor.x + value;
		this._setWidth(wr - wl);
		p.x = value + this._calculatedWidth * this._pivot.x;
		this.entity.setLocalPosition(p);
	}
	get left() {
		return this._margin.x;
	}
	set margin(value) {
		this._margin.copy(value);
		this._calculateSize(true, true);
		this.fire("set:margin", this._margin);
	}
	get margin() {
		return this._margin;
	}
	get maskedBy() {
		return this._maskedBy;
	}
	set pivot(value) {
		const { pivot, margin } = this;
		const prevX = pivot.x;
		const prevY = pivot.y;
		if (value instanceof Vec2) {
			pivot.copy(value);
		} else {
			pivot.set(...value);
		}
		const mx = margin.x + margin.z;
		const dx = pivot.x - prevX;
		margin.x += mx * dx;
		margin.z -= mx * dx;
		const my = margin.y + margin.w;
		const dy = pivot.y - prevY;
		margin.y += my * dy;
		margin.w -= my * dy;
		this._anchorDirty = true;
		this._cornersDirty = true;
		this._worldCornersDirty = true;
		this._calculateSize(false, false);
		this._flagChildrenAsDirty();
		this.fire("set:pivot", pivot);
	}
	get pivot() {
		return this._pivot;
	}
	set right(value) {
		this._margin.z = value;
		const p = this.entity.getLocalPosition();
		const wl = this._absLeft;
		const wr = this._localAnchor.z - value;
		this._setWidth(wr - wl);
		p.x = this._localAnchor.z - this._localAnchor.x - value - this._calculatedWidth * (1 - this._pivot.x);
		this.entity.setLocalPosition(p);
	}
	get right() {
		return this._margin.z;
	}
	get screenCorners() {
		if (!this._cornersDirty || !this.screen) {
			return this._screenCorners;
		}
		this._calcScreenCorners(this._absLeft, this._absBottom, this._absRight, this._absTop, this._screenCorners);
		this._cornersDirty = false;
		this._canvasCornersDirty = true;
		this._worldCornersDirty = true;
		return this._screenCorners;
	}
	// Transforms an anchor-space rectangle (defined by its left/bottom/right/top edges) into the 4
	// screen-space corners (bottom left, bottom right, top right, top left), populating and
	// returning the supplied array. This is the shared logic behind screenCorners.
	_calcScreenCorners(left, bottom, right2, top, corners) {
		const parentBottomLeft = this.entity.parent && this.entity.parent.element && this.entity.parent.element.screenCorners[0];
		corners[0].set(left, bottom, 0);
		corners[1].set(right2, bottom, 0);
		corners[2].set(right2, top, 0);
		corners[3].set(left, top, 0);
		const screenSpace = this.screen.screen.screenSpace;
		for (let i2 = 0; i2 < 4; i2++) {
			this._screenTransform.transformPoint(corners[i2], corners[i2]);
			if (screenSpace) {
				corners[i2].mulScalar(this.screen.screen.scale);
			}
			if (parentBottomLeft) {
				corners[i2].add(parentBottomLeft);
			}
		}
		return corners;
	}
	get textWidth() {
		return this._text ? this._text.width : 0;
	}
	get textHeight() {
		return this._text ? this._text.height : 0;
	}
	set top(value) {
		this._margin.w = value;
		const p = this.entity.getLocalPosition();
		const wb = this._absBottom;
		const wt = this._localAnchor.w - value;
		this._setHeight(wt - wb);
		p.y = this._localAnchor.w - this._localAnchor.y - value - this._calculatedHeight * (1 - this._pivot.y);
		this.entity.setLocalPosition(p);
	}
	get top() {
		return this._margin.w;
	}
	set type(value) {
		if (value !== this._type) {
			this._type = value;
			if (this._image) {
				this._image.destroy();
				this._image = null;
			}
			if (this._text) {
				this._text.destroy();
				this._text = null;
			}
			if (value === ELEMENTTYPE_IMAGE) {
				this._image = new ImageElement(this);
			} else if (value === ELEMENTTYPE_TEXT) {
				this._text = new TextElement(this);
			}
		}
	}
	get type() {
		return this._type;
	}
	set useInput(value) {
		if (this._useInput === value) {
			return;
		}
		this._useInput = value;
		if (this.system.app.elementInput) {
			if (value) {
				if (this.enabled && this.entity.enabled) {
					this.system.app.elementInput.addElement(this);
				}
			} else {
				this.system.app.elementInput.removeElement(this);
			}
		} else {
			if (this._useInput === true) {
			}
		}
		this.fire("set:useInput", value);
	}
	get useInput() {
		return this._useInput;
	}
	set fitMode(value) {
		this._fitMode = value;
		this._calculateSize(true, true);
		if (this._image) {
			this._image.refreshMesh();
		}
	}
	get fitMode() {
		return this._fitMode;
	}
	set width(value) {
		this._width = value;
		if (!this._hasSplitAnchorsX) {
			this._setCalculatedWidth(value, true);
		}
		this.fire("set:width", this._width);
	}
	get width() {
		return this._width;
	}
	get worldCorners() {
		if (!this._worldCornersDirty) {
			return this._worldCorners;
		}
		if (this.screen) {
			const screenCorners = this.screenCorners;
			if (!this.screen.screen.screenSpace) {
				matA.copy(this.screen.screen._screenMatrix);
				matA.data[13] = -matA.data[13];
				matA.mul2(this.screen.getWorldTransform(), matA);
				for (let i2 = 0; i2 < 4; i2++) {
					matA.transformPoint(screenCorners[i2], this._worldCorners[i2]);
				}
			}
		} else {
			const localPos = this.entity.getLocalPosition();
			matA.setTranslate(-localPos.x, -localPos.y, -localPos.z);
			matB.setTRS(Vec3.ZERO, this.entity.getLocalRotation(), this.entity.getLocalScale());
			matC.setTranslate(localPos.x, localPos.y, localPos.z);
			const entity = this.entity.parent ? this.entity.parent : this.entity;
			matD.copy(entity.getWorldTransform());
			matD.mul(matC).mul(matB).mul(matA);
			vecA.set(localPos.x - this.pivot.x * this.calculatedWidth, localPos.y - this.pivot.y * this.calculatedHeight, localPos.z);
			matD.transformPoint(vecA, this._worldCorners[0]);
			vecA.set(localPos.x + (1 - this.pivot.x) * this.calculatedWidth, localPos.y - this.pivot.y * this.calculatedHeight, localPos.z);
			matD.transformPoint(vecA, this._worldCorners[1]);
			vecA.set(localPos.x + (1 - this.pivot.x) * this.calculatedWidth, localPos.y + (1 - this.pivot.y) * this.calculatedHeight, localPos.z);
			matD.transformPoint(vecA, this._worldCorners[2]);
			vecA.set(localPos.x - this.pivot.x * this.calculatedWidth, localPos.y + (1 - this.pivot.y) * this.calculatedHeight, localPos.z);
			matD.transformPoint(vecA, this._worldCorners[3]);
		}
		this._worldCornersDirty = false;
		return this._worldCorners;
	}
	set fontSize(arg) {
		this._setValue("fontSize", arg);
	}
	get fontSize() {
		if (this._text) {
			return this._text.fontSize;
		}
		return null;
	}
	set minFontSize(arg) {
		this._setValue("minFontSize", arg);
	}
	get minFontSize() {
		if (this._text) {
			return this._text.minFontSize;
		}
		return null;
	}
	set maxFontSize(arg) {
		this._setValue("maxFontSize", arg);
	}
	get maxFontSize() {
		if (this._text) {
			return this._text.maxFontSize;
		}
		return null;
	}
	set maxLines(arg) {
		this._setValue("maxLines", arg);
	}
	get maxLines() {
		if (this._text) {
			return this._text.maxLines;
		}
		return null;
	}
	set autoFitWidth(arg) {
		this._setValue("autoFitWidth", arg);
	}
	get autoFitWidth() {
		if (this._text) {
			return this._text.autoFitWidth;
		}
		return null;
	}
	set autoFitHeight(arg) {
		this._setValue("autoFitHeight", arg);
	}
	get autoFitHeight() {
		if (this._text) {
			return this._text.autoFitHeight;
		}
		return null;
	}
	set color(arg) {
		this._setValue("color", arg);
	}
	get color() {
		if (this._text) {
			return this._text.color;
		}
		if (this._image) {
			return this._image.color;
		}
		return null;
	}
	set font(arg) {
		this._setValue("font", arg);
	}
	get font() {
		if (this._text) {
			return this._text.font;
		}
		return null;
	}
	set fontAsset(arg) {
		this._setValue("fontAsset", arg);
	}
	get fontAsset() {
		if (this._text && typeof this._text.fontAsset === "number") {
			return this._text.fontAsset;
		}
		return null;
	}
	set spacing(arg) {
		this._setValue("spacing", arg);
	}
	get spacing() {
		if (this._text) {
			return this._text.spacing;
		}
		return null;
	}
	set lineHeight(arg) {
		this._setValue("lineHeight", arg);
	}
	get lineHeight() {
		if (this._text) {
			return this._text.lineHeight;
		}
		return null;
	}
	set wrapLines(arg) {
		this._setValue("wrapLines", arg);
	}
	get wrapLines() {
		if (this._text) {
			return this._text.wrapLines;
		}
		return null;
	}
	get lines() {
		if (this._text) {
			return this._text.lines;
		}
		return null;
	}
	set alignment(arg) {
		this._setValue("alignment", arg);
	}
	get alignment() {
		if (this._text) {
			return this._text.alignment;
		}
		return null;
	}
	set autoWidth(arg) {
		this._setValue("autoWidth", arg);
	}
	get autoWidth() {
		if (this._text) {
			return this._text.autoWidth;
		}
		return null;
	}
	set autoHeight(arg) {
		this._setValue("autoHeight", arg);
	}
	get autoHeight() {
		if (this._text) {
			return this._text.autoHeight;
		}
		return null;
	}
	set rtlReorder(arg) {
		this._setValue("rtlReorder", arg);
	}
	get rtlReorder() {
		if (this._text) {
			return this._text.rtlReorder;
		}
		return null;
	}
	set unicodeConverter(arg) {
		this._setValue("unicodeConverter", arg);
	}
	get unicodeConverter() {
		if (this._text) {
			return this._text.unicodeConverter;
		}
		return null;
	}
	set text(arg) {
		this._setValue("text", arg);
	}
	get text() {
		if (this._text) {
			return this._text.text;
		}
		return null;
	}
	set key(arg) {
		this._setValue("key", arg);
	}
	get key() {
		if (this._text) {
			return this._text.key;
		}
		return null;
	}
	set texture(arg) {
		this._setValue("texture", arg);
	}
	get texture() {
		if (this._image) {
			return this._image.texture;
		}
		return null;
	}
	set textureAsset(arg) {
		this._setValue("textureAsset", arg);
	}
	get textureAsset() {
		if (this._image) {
			return this._image.textureAsset;
		}
		return null;
	}
	set material(arg) {
		this._setValue("material", arg);
	}
	get material() {
		if (this._image) {
			return this._image.material;
		}
		return null;
	}
	set materialAsset(arg) {
		this._setValue("materialAsset", arg);
	}
	get materialAsset() {
		if (this._image) {
			return this._image.materialAsset;
		}
		return null;
	}
	set sprite(arg) {
		this._setValue("sprite", arg);
	}
	get sprite() {
		if (this._image) {
			return this._image.sprite;
		}
		return null;
	}
	set spriteAsset(arg) {
		this._setValue("spriteAsset", arg);
	}
	get spriteAsset() {
		if (this._image) {
			return this._image.spriteAsset;
		}
		return null;
	}
	set spriteFrame(arg) {
		this._setValue("spriteFrame", arg);
	}
	get spriteFrame() {
		if (this._image) {
			return this._image.spriteFrame;
		}
		return null;
	}
	set pixelsPerUnit(arg) {
		this._setValue("pixelsPerUnit", arg);
	}
	get pixelsPerUnit() {
		if (this._image) {
			return this._image.pixelsPerUnit;
		}
		return null;
	}
	set opacity(arg) {
		this._setValue("opacity", arg);
	}
	get opacity() {
		if (this._text) {
			return this._text.opacity;
		}
		if (this._image) {
			return this._image.opacity;
		}
		return null;
	}
	set rect(arg) {
		this._setValue("rect", arg);
	}
	get rect() {
		if (this._image) {
			return this._image.rect;
		}
		return null;
	}
	set mask(arg) {
		this._setValue("mask", arg);
	}
	get mask() {
		if (this._image) {
			return this._image.mask;
		}
		return null;
	}
	set outlineColor(arg) {
		this._setValue("outlineColor", arg);
	}
	get outlineColor() {
		if (this._text) {
			return this._text.outlineColor;
		}
		return null;
	}
	set outlineThickness(arg) {
		this._setValue("outlineThickness", arg);
	}
	get outlineThickness() {
		if (this._text) {
			return this._text.outlineThickness;
		}
		return null;
	}
	set shadowColor(arg) {
		this._setValue("shadowColor", arg);
	}
	get shadowColor() {
		if (this._text) {
			return this._text.shadowColor;
		}
		return null;
	}
	set shadowOffset(arg) {
		this._setValue("shadowOffset", arg);
	}
	get shadowOffset() {
		if (this._text) {
			return this._text.shadowOffset;
		}
		return null;
	}
	set enableMarkup(arg) {
		this._setValue("enableMarkup", arg);
	}
	get enableMarkup() {
		if (this._text) {
			return this._text.enableMarkup;
		}
		return null;
	}
	set rangeStart(arg) {
		this._setValue("rangeStart", arg);
	}
	get rangeStart() {
		if (this._text) {
			return this._text.rangeStart;
		}
		return null;
	}
	set rangeEnd(arg) {
		this._setValue("rangeEnd", arg);
	}
	get rangeEnd() {
		if (this._text) {
			return this._text.rangeEnd;
		}
		return null;
	}
	_setValue(name, value) {
		if (this._text) {
			if (this._text[name] !== value) {
				this._dirtyBatch();
			}
			this._text[name] = value;
		} else if (this._image) {
			if (this._image[name] !== value) {
				this._dirtyBatch();
			}
			this._image[name] = value;
		}
	}
	_patch() {
		this.entity._sync = this._sync;
		this.entity.setPosition = this._setPosition;
		this.entity.setLocalPosition = this._setLocalPosition;
	}
	_unpatch() {
		this.entity._sync = Entity.prototype._sync;
		this.entity.setPosition = Entity.prototype.setPosition;
		this.entity.setLocalPosition = Entity.prototype.setLocalPosition;
	}
	_setPosition(x3, y2, z2) {
		if (!this.element.screen) {
			Entity.prototype.setPosition.call(this, x3, y2, z2);
			return;
		}
		if (x3 instanceof Vec3) {
			position2.copy(x3);
		} else {
			position2.set(x3, y2, z2);
		}
		this.getWorldTransform();
		invParentWtm2.copy(this.element._screenToWorld).invert();
		invParentWtm2.transformPoint(position2, this.localPosition);
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	_setLocalPosition(x3, y2, z2) {
		if (x3 instanceof Vec3) {
			this.localPosition.copy(x3);
		} else {
			this.localPosition.set(x3, y2, z2);
		}
		const element = this.element;
		const p = this.localPosition;
		const pvt = element._pivot;
		element._margin.x = p.x - element._calculatedWidth * pvt.x;
		element._margin.z = element._localAnchor.z - element._localAnchor.x - element._calculatedWidth - element._margin.x;
		element._margin.y = p.y - element._calculatedHeight * pvt.y;
		element._margin.w = element._localAnchor.w - element._localAnchor.y - element._calculatedHeight - element._margin.y;
		if (!this._dirtyLocal) {
			this._dirtifyLocal();
		}
	}
	// this method overwrites GraphNode#sync and so operates in scope of the Entity.
	_sync() {
		const element = this.element;
		const screen = element.screen;
		if (screen) {
			if (element._anchorDirty) {
				let resx = 0;
				let resy = 0;
				let px = 0;
				let py = 1;
				if (this._parent && this._parent.element) {
					resx = this._parent.element.calculatedWidth;
					resy = this._parent.element.calculatedHeight;
					px = this._parent.element.pivot.x;
					py = this._parent.element.pivot.y;
				} else {
					const resolution = screen.screen.resolution;
					resx = resolution.x / screen.screen.scale;
					resy = resolution.y / screen.screen.scale;
				}
				element._anchorTransform.setTranslate(resx * (element.anchor.x - px), -(resy * (py - element.anchor.y)), 0);
				element._anchorDirty = false;
				element._calculateLocalAnchors();
			}
			if (element._sizeDirty) {
				element._calculateSize(false, false);
			}
		}
		if (this._dirtyLocal) {
			this.localTransform.setTRS(this.localPosition, this.localRotation, this.localScale);
			const p = this.localPosition;
			const pvt = element._pivot;
			element._margin.x = p.x - element._calculatedWidth * pvt.x;
			element._margin.z = element._localAnchor.z - element._localAnchor.x - element._calculatedWidth - element._margin.x;
			element._margin.y = p.y - element._calculatedHeight * pvt.y;
			element._margin.w = element._localAnchor.w - element._localAnchor.y - element._calculatedHeight - element._margin.y;
			this._dirtyLocal = false;
		}
		if (!screen) {
			if (this._dirtyWorld) {
				element._cornersDirty = true;
				element._canvasCornersDirty = true;
				element._worldCornersDirty = true;
			}
			Entity.prototype._sync.call(this);
			return;
		}
		if (this._dirtyWorld) {
			if (this._parent === null) {
				this.worldTransform.copy(this.localTransform);
			} else {
				if (this._parent.element) {
					element._screenToWorld.mul2(
						this._parent.element._modelTransform,
						element._anchorTransform
					);
				} else {
					element._screenToWorld.copy(element._anchorTransform);
				}
				element._modelTransform.mul2(element._screenToWorld, this.localTransform);
				if (screen) {
					element._screenToWorld.mul2(screen.screen._screenMatrix, element._screenToWorld);
					if (!screen.screen.screenSpace) {
						element._screenToWorld.mul2(screen.worldTransform, element._screenToWorld);
					}
					this.worldTransform.mul2(element._screenToWorld, this.localTransform);
					const parentWorldTransform = element._parentWorldTransform;
					parentWorldTransform.setIdentity();
					const parent = this._parent;
					if (parent && parent.element && parent !== screen) {
						matA.setTRS(Vec3.ZERO, parent.getLocalRotation(), parent.getLocalScale());
						parentWorldTransform.mul2(parent.element._parentWorldTransform, matA);
					}
					const depthOffset = vecA;
					depthOffset.set(0, 0, this.localPosition.z);
					const pivotOffset = vecB;
					pivotOffset.set(
						element._absLeft + element._pivot.x * element.calculatedWidth,
						element._absBottom + element._pivot.y * element.calculatedHeight,
						0
					);
					matA.setTranslate(-pivotOffset.x, -pivotOffset.y, -pivotOffset.z);
					matB.setTRS(depthOffset, this.getLocalRotation(), this.getLocalScale());
					matC.setTranslate(pivotOffset.x, pivotOffset.y, pivotOffset.z);
					element._screenTransform.mul2(element._parentWorldTransform, matC).mul(matB).mul(matA);
					element._cornersDirty = true;
					element._canvasCornersDirty = true;
					element._worldCornersDirty = true;
				} else {
					this.worldTransform.copy(element._modelTransform);
				}
			}
			this._dirtyWorld = false;
		}
	}
	_onInsert(parent) {
		const result = this._parseUpToScreen();
		this.entity._dirtifyWorld();
		this._updateScreen(result.screen);
		this._dirtifyMask();
	}
	_dirtifyMask() {
		let current = this.entity;
		while (current) {
			const next = current.parent;
			if ((next === null || next.screen) && current.element) {
				if (!this.system._prerender || !this.system._prerender.length) {
					this.system._prerender = [];
					this.system.app.once("prerender", this._onPrerender, this);
				}
				const i2 = this.system._prerender.indexOf(this.entity);
				if (i2 >= 0) {
					this.system._prerender.splice(i2, 1);
				}
				const j = this.system._prerender.indexOf(current);
				if (j < 0) {
					this.system._prerender.push(current);
				}
			}
			current = next;
		}
	}
	_onPrerender() {
		for (let i2 = 0; i2 < this.system._prerender.length; i2++) {
			const mask = this.system._prerender[i2];
			if (mask.element) {
				const depth = 1;
				mask.element.syncMask(depth);
			}
		}
		this.system._prerender.length = 0;
	}
	_bindScreen(screen) {
		screen._bindElement(this);
	}
	_unbindScreen(screen) {
		screen._unbindElement(this);
	}
	_updateScreen(screen) {
		if (this.screen && this.screen !== screen) {
			this._unbindScreen(this.screen.screen);
		}
		const previousScreen = this.screen;
		this.screen = screen;
		if (this.screen) {
			this._bindScreen(this.screen.screen);
		}
		this._calculateSize(this._hasSplitAnchorsX, this._hasSplitAnchorsY);
		this.fire("set:screen", this.screen, previousScreen);
		this._anchorDirty = true;
		const children = this.entity.children;
		for (let i2 = 0, l = children.length; i2 < l; i2++) {
			if (children[i2].element) {
				children[i2].element._updateScreen(screen);
			}
		}
		if (this.screen) {
			this.screen.screen.syncDrawOrder();
		}
	}
	syncMask(depth) {
		const result = this._parseUpToScreen();
		this._updateMask(result.mask, depth);
	}
	// set the maskedby property to the entity that is masking this element
	// - set the stencil buffer to check the mask value
	//   so as to only render inside the mask
	//   Note: if this entity is itself a mask the stencil params
	//   will be updated in updateMask to include masking
	_setMaskedBy(mask) {
		const renderableElement = this._image || this._text;
		if (mask) {
			const ref = mask.element._image._maskRef;
			renderableElement?._setStencil(new StencilParameters({
				ref,
				func: FUNC_EQUAL
			}));
			this._maskedBy = mask;
		} else {
			renderableElement?._setStencil(null);
			this._maskedBy = null;
		}
	}
	// recursively update entity's stencil params
	// to render the correct value into the stencil buffer
	_updateMask(currentMask, depth) {
		if (currentMask) {
			this._setMaskedBy(currentMask);
			if (this.mask) {
				const ref = currentMask.element._image._maskRef;
				const sp = new StencilParameters({
					ref,
					func: FUNC_EQUAL,
					zpass: STENCILOP_INCREMENT
				});
				this._image._setStencil(sp);
				this._image._maskRef = depth;
				depth++;
				currentMask = this.entity;
			}
			const children = this.entity.children;
			for (let i2 = 0, l = children.length; i2 < l; i2++) {
				children[i2].element?._updateMask(currentMask, depth);
			}
			if (this.mask) depth--;
		} else {
			this._setMaskedBy(null);
			if (this.mask) {
				const sp = new StencilParameters({
					ref: depth,
					func: FUNC_ALWAYS,
					zpass: STENCILOP_REPLACE
				});
				this._image._setStencil(sp);
				this._image._maskRef = depth;
				depth++;
				currentMask = this.entity;
			}
			const children = this.entity.children;
			for (let i2 = 0, l = children.length; i2 < l; i2++) {
				children[i2].element?._updateMask(currentMask, depth);
			}
			if (this.mask) {
				depth--;
			}
		}
	}
	// search up the parent hierarchy until we reach a screen
	// this screen is the parent screen
	// also searches for masked elements to get the relevant mask
	_parseUpToScreen() {
		const result = {
			screen: null,
			mask: null
		};
		let parent = this.entity._parent;
		while (parent && !parent.screen) {
			if (parent.element && parent.element.mask) {
				if (!result.mask) result.mask = parent;
			}
			parent = parent.parent;
		}
		if (parent && parent.screen) {
			result.screen = parent;
		}
		return result;
	}
	_onScreenResize(res) {
		this._anchorDirty = true;
		this._cornersDirty = true;
		this._worldCornersDirty = true;
		this._calculateSize(this._hasSplitAnchorsX, this._hasSplitAnchorsY);
		this.fire("screen:set:resolution", res);
	}
	_onScreenSpaceChange() {
		this.fire("screen:set:screenspace", this.screen.screen.screenSpace);
	}
	_onScreenRemove() {
		if (this.screen) {
			if (this.screen._destroying) {
				this.screen = null;
			} else {
				this._updateScreen(null);
			}
		}
	}
	// store pixel positions of anchor relative to current parent resolution
	_calculateLocalAnchors() {
		let resx = 1e3;
		let resy = 1e3;
		const parent = this.entity._parent;
		if (parent && parent.element) {
			resx = parent.element.calculatedWidth;
			resy = parent.element.calculatedHeight;
		} else if (this.screen) {
			const res = this.screen.screen.resolution;
			const scale2 = this.screen.screen.scale;
			resx = res.x / scale2;
			resy = res.y / scale2;
		}
		this._localAnchor.set(
			this._anchor.x * resx,
			this._anchor.y * resy,
			this._anchor.z * resx,
			this._anchor.w * resy
		);
	}
	// internal - apply offset x,y to local position and find point in world space
	getOffsetPosition(x3, y2) {
		const p = this.entity.getLocalPosition().clone();
		p.x += x3;
		p.y += y2;
		this._screenToWorld.transformPoint(p, p);
		return p;
	}
	onLayersChanged(oldComp, newComp) {
		this.addModelToLayers(this._image ? this._image._renderable.model : this._text._model);
		oldComp.off("add", this.onLayerAdded, this);
		oldComp.off("remove", this.onLayerRemoved, this);
		newComp.on("add", this.onLayerAdded, this);
		newComp.on("remove", this.onLayerRemoved, this);
	}
	onLayerAdded(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		if (this._image) {
			layer.addMeshInstances(this._image._renderable.model.meshInstances);
		} else if (this._text) {
			layer.addMeshInstances(this._text._model.meshInstances);
		}
	}
	onLayerRemoved(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		if (this._image) {
			layer.removeMeshInstances(this._image._renderable.model.meshInstances);
		} else if (this._text) {
			layer.removeMeshInstances(this._text._model.meshInstances);
		}
	}
	onEnable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		if (this._image) {
			this._image.onEnable();
		}
		if (this._text) {
			this._text.onEnable();
		}
		if (this._group) {
			this._group.onEnable();
		}
		if (this.useInput && this.system.app.elementInput) {
			this.system.app.elementInput.addElement(this);
		}
		this._evtLayersChanged = scene.on("set:layers", this.onLayersChanged, this);
		if (layers) {
			this._evtLayerAdded = layers.on("add", this.onLayerAdded, this);
			this._evtLayerRemoved = layers.on("remove", this.onLayerRemoved, this);
		}
		if (this._batchGroupId >= 0) {
			this.system.app.batcher?.insert(BatchGroup.ELEMENT, this.batchGroupId, this.entity);
		}
		this.fire("enableelement");
	}
	onDisable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		this._evtLayersChanged?.off();
		this._evtLayersChanged = null;
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = null;
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = null;
		}
		if (this._image) this._image.onDisable();
		if (this._text) this._text.onDisable();
		if (this._group) this._group.onDisable();
		if (this.system.app.elementInput && this.useInput) {
			this.system.app.elementInput.removeElement(this);
		}
		if (this._batchGroupId >= 0) {
			this.system.app.batcher?.remove(BatchGroup.ELEMENT, this.batchGroupId, this.entity);
		}
		this.fire("disableelement");
	}
	onBeforeRemove() {
		this.entity.off("insert", this._onInsert, this);
		this._unpatch();
		if (this._image) {
			this._image.destroy();
		}
		if (this._text) {
			this._text.destroy();
		}
		if (this.system.app.elementInput && this.useInput) {
			this.system.app.elementInput.removeElement(this);
		}
		if (this.screen && this.screen.screen) {
			this._unbindScreen(this.screen.screen);
			this.screen.screen.syncDrawOrder();
		}
		this.off();
	}
	_calculateSize(propagateCalculatedWidth, propagateCalculatedHeight) {
		if (!this.entity._parent && !this.screen) {
			return;
		}
		this._calculateLocalAnchors();
		const newWidth = this._absRight - this._absLeft;
		const newHeight = this._absTop - this._absBottom;
		if (propagateCalculatedWidth) {
			this._setWidth(newWidth);
		} else {
			this._setCalculatedWidth(newWidth, false);
		}
		if (propagateCalculatedHeight) {
			this._setHeight(newHeight);
		} else {
			this._setCalculatedHeight(newHeight, false);
		}
		const p = this.entity.getLocalPosition();
		p.x = this._margin.x + this._calculatedWidth * this._pivot.x;
		p.y = this._margin.y + this._calculatedHeight * this._pivot.y;
		this.entity.setLocalPosition(p);
		this._sizeDirty = false;
	}
	_setWidth(w) {
		this._width = w;
		this._setCalculatedWidth(w, false);
		this.fire("set:width", this._width);
	}
	_setHeight(h2) {
		this._height = h2;
		this._setCalculatedHeight(h2, false);
		this.fire("set:height", this._height);
	}
	_setCalculatedWidth(value, updateMargins) {
		if (Math.abs(value - this._calculatedWidth) <= 1e-4) {
			return;
		}
		this._calculatedWidth = value;
		this.entity._dirtifyLocal();
		if (updateMargins) {
			const p = this.entity.getLocalPosition();
			const pvt = this._pivot;
			this._margin.x = p.x - this._calculatedWidth * pvt.x;
			this._margin.z = this._localAnchor.z - this._localAnchor.x - this._calculatedWidth - this._margin.x;
		}
		this._flagChildrenAsDirty();
		this.fire("set:calculatedWidth", this._calculatedWidth);
		this.fire("resize", this._calculatedWidth, this._calculatedHeight);
	}
	_setCalculatedHeight(value, updateMargins) {
		if (Math.abs(value - this._calculatedHeight) <= 1e-4) {
			return;
		}
		this._calculatedHeight = value;
		this.entity._dirtifyLocal();
		if (updateMargins) {
			const p = this.entity.getLocalPosition();
			const pvt = this._pivot;
			this._margin.y = p.y - this._calculatedHeight * pvt.y;
			this._margin.w = this._localAnchor.w - this._localAnchor.y - this._calculatedHeight - this._margin.y;
		}
		this._flagChildrenAsDirty();
		this.fire("set:calculatedHeight", this._calculatedHeight);
		this.fire("resize", this._calculatedWidth, this._calculatedHeight);
	}
	_flagChildrenAsDirty() {
		const c2 = this.entity._children;
		for (let i2 = 0, l = c2.length; i2 < l; i2++) {
			if (c2[i2].element) {
				c2[i2].element._anchorDirty = true;
				c2[i2].element._sizeDirty = true;
			}
		}
	}
	addModelToLayers(model) {
		this._addedModels.push(model);
		for (let i2 = 0; i2 < this.layers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(this.layers[i2]);
			if (!layer) continue;
			layer.addMeshInstances(model.meshInstances);
		}
	}
	removeModelFromLayers(model) {
		const idx = this._addedModels.indexOf(model);
		if (idx >= 0) {
			this._addedModels.splice(idx, 1);
		}
		for (let i2 = 0; i2 < this.layers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(this.layers[i2]);
			if (!layer) {
				continue;
			}
			layer.removeMeshInstances(model.meshInstances);
		}
	}
	getMaskOffset() {
		const frame = this.system.app.frame;
		if (this._offsetReadAt !== frame) {
			this._maskOffset = 0.5;
			this._offsetReadAt = frame;
		}
		const mo = this._maskOffset;
		this._maskOffset -= 1e-3;
		return mo;
	}
	isVisibleForCamera(camera) {
		let clipL, clipR, clipT, clipB;
		if (this.maskedBy) {
			const corners = this.maskedBy.element.screenCorners;
			clipL = Math.min(Math.min(corners[0].x, corners[1].x), Math.min(corners[2].x, corners[3].x));
			clipR = Math.max(Math.max(corners[0].x, corners[1].x), Math.max(corners[2].x, corners[3].x));
			clipB = Math.min(Math.min(corners[0].y, corners[1].y), Math.min(corners[2].y, corners[3].y));
			clipT = Math.max(Math.max(corners[0].y, corners[1].y), Math.max(corners[2].y, corners[3].y));
		} else {
			const sw = this.system.app.graphicsDevice.width;
			const sh = this.system.app.graphicsDevice.height;
			const cameraWidth = camera._rect.z * sw;
			const cameraHeight = camera._rect.w * sh;
			clipL = camera._rect.x * sw;
			clipR = clipL + cameraWidth;
			clipT = (1 - camera._rect.y) * sh;
			clipB = clipT - cameraHeight;
		}
		let hitCorners = this.screenCorners;
		const text = this._text;
		if (text) {
			const overflowX = Math.max(0, text.width - this.calculatedWidth);
			const overflowY = Math.max(0, text.height - this.calculatedHeight);
			if (overflowX > 0 || overflowY > 0) {
				const ha = this.alignment.x;
				const va = this.alignment.y;
				hitCorners = this._calcScreenCorners(
					this._absLeft - ha * overflowX,
					this._absBottom - va * overflowY,
					this._absRight + (1 - ha) * overflowX,
					this._absTop + (1 - va) * overflowY,
					tmpCorners
				);
			}
		}
		const left = Math.min(Math.min(hitCorners[0].x, hitCorners[1].x), Math.min(hitCorners[2].x, hitCorners[3].x));
		const right2 = Math.max(Math.max(hitCorners[0].x, hitCorners[1].x), Math.max(hitCorners[2].x, hitCorners[3].x));
		const bottom = Math.min(Math.min(hitCorners[0].y, hitCorners[1].y), Math.min(hitCorners[2].y, hitCorners[3].y));
		const top = Math.max(Math.max(hitCorners[0].y, hitCorners[1].y), Math.max(hitCorners[2].y, hitCorners[3].y));
		if (right2 < clipL || left > clipR || bottom > clipT || top < clipB) {
			return false;
		}
		return true;
	}
	_isScreenSpace() {
		if (this.screen && this.screen.screen) {
			return this.screen.screen.screenSpace;
		}
		return false;
	}
	_isScreenCulled() {
		if (this.screen && this.screen.screen) {
			return this.screen.screen.cull;
		}
		return false;
	}
	_dirtyBatch() {
		if (this.batchGroupId !== -1) {
			this.system.app.batcher?.markGroupDirty(this.batchGroupId);
		}
	}
};

var ElementComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "element";
		this.ComponentType = ElementComponent;
		this._unicodeConverter = null;
		this._rtlReorder = null;
		this._defaultTexture = new Texture(app2.graphicsDevice, {
			width: 1,
			height: 1,
			format: PIXELFORMAT_SRGBA8,
			name: "element-system"
		});
		const pixels = this._defaultTexture.lock();
		const pixelData = new Uint8Array(4);
		pixelData[0] = 255;
		pixelData[1] = 255;
		pixelData[2] = 255;
		pixelData[3] = 255;
		pixels.set(pixelData);
		this._defaultTexture.unlock();
		this.defaultImageMaterial = null;
		this.defaultImage9SlicedMaterial = null;
		this.defaultImage9TiledMaterial = null;
		this.defaultImageMaskMaterial = null;
		this.defaultImage9SlicedMaskMaterial = null;
		this.defaultImage9TiledMaskMaterial = null;
		this.defaultScreenSpaceImageMaterial = null;
		this.defaultScreenSpaceImage9SlicedMaterial = null;
		this.defaultScreenSpaceImage9TiledMaterial = null;
		this.defaultScreenSpaceImageMask9SlicedMaterial = null;
		this.defaultScreenSpaceImageMask9TiledMaterial = null;
		this.defaultScreenSpaceImageMaskMaterial = null;
		this._defaultTextMaterials = {};
		this.defaultImageMaterials = [];
		this.on("add", this.onAddComponent, this);
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	destroy() {
		super.destroy();
		this._defaultTexture.destroy();
	}
	initializeComponentData(component, data2, properties) {
		component._beingInitialized = true;
		if (data2.anchor !== void 0) {
			if (data2.anchor instanceof Vec4) {
				component.anchor.copy(data2.anchor);
			} else {
				component.anchor.set(data2.anchor[0], data2.anchor[1], data2.anchor[2], data2.anchor[3]);
			}
		}
		if (data2.pivot !== void 0) {
			if (data2.pivot instanceof Vec2) {
				component.pivot.copy(data2.pivot);
			} else {
				component.pivot.set(data2.pivot[0], data2.pivot[1]);
			}
		}
		const splitHorAnchors = Math.abs(component.anchor.x - component.anchor.z) > 1e-3;
		const splitVerAnchors = Math.abs(component.anchor.y - component.anchor.w) > 1e-3;
		let _marginChange = false;
		let color3;
		if (data2.margin !== void 0) {
			if (data2.margin instanceof Vec4) {
				component.margin.copy(data2.margin);
			} else {
				component._margin.set(data2.margin[0], data2.margin[1], data2.margin[2], data2.margin[3]);
			}
			_marginChange = true;
		}
		if (data2.left !== void 0) {
			component._margin.x = data2.left;
			_marginChange = true;
		}
		if (data2.bottom !== void 0) {
			component._margin.y = data2.bottom;
			_marginChange = true;
		}
		if (data2.right !== void 0) {
			component._margin.z = data2.right;
			_marginChange = true;
		}
		if (data2.top !== void 0) {
			component._margin.w = data2.top;
			_marginChange = true;
		}
		if (_marginChange) {
			component.margin = component._margin;
		}
		let shouldForceSetAnchor = false;
		if (data2.width !== void 0 && !splitHorAnchors) {
			component.width = data2.width;
		} else if (splitHorAnchors) {
			shouldForceSetAnchor = true;
		}
		if (data2.height !== void 0 && !splitVerAnchors) {
			component.height = data2.height;
		} else if (splitVerAnchors) {
			shouldForceSetAnchor = true;
		}
		if (shouldForceSetAnchor) {
			component.anchor = component.anchor;
		}
		if (data2.enabled !== void 0) {
			component.enabled = data2.enabled;
		}
		if (data2.useInput !== void 0) {
			component.useInput = data2.useInput;
		}
		if (data2.fitMode !== void 0) {
			component.fitMode = data2.fitMode;
		}
		component.batchGroupId = data2.batchGroupId === void 0 || data2.batchGroupId === null ? -1 : data2.batchGroupId;
		if (data2.layers && Array.isArray(data2.layers)) {
			component.layers = data2.layers.slice(0);
		}
		if (data2.type !== void 0) {
			component.type = data2.type;
		}
		if (component.type === ELEMENTTYPE_IMAGE) {
			if (data2.rect !== void 0) {
				component.rect = data2.rect;
			}
			if (data2.color !== void 0) {
				color3 = data2.color;
				if (!(color3 instanceof Color)) {
					color3 = new Color(data2.color[0], data2.color[1], data2.color[2]);
				}
				component.color = color3;
			}
			if (data2.opacity !== void 0) component.opacity = data2.opacity;
			if (data2.textureAsset !== void 0) component.textureAsset = data2.textureAsset;
			if (data2.texture) component.texture = data2.texture;
			if (data2.spriteAsset !== void 0) component.spriteAsset = data2.spriteAsset;
			if (data2.sprite) component.sprite = data2.sprite;
			if (data2.spriteFrame !== void 0) component.spriteFrame = data2.spriteFrame;
			if (data2.pixelsPerUnit !== void 0 && data2.pixelsPerUnit !== null) component.pixelsPerUnit = data2.pixelsPerUnit;
			if (data2.materialAsset !== void 0) component.materialAsset = data2.materialAsset;
			if (data2.material) component.material = data2.material;
			if (data2.mask !== void 0) {
				component.mask = data2.mask;
			}
		} else if (component.type === ELEMENTTYPE_TEXT) {
			if (data2.autoWidth !== void 0) component.autoWidth = data2.autoWidth;
			if (data2.autoHeight !== void 0) component.autoHeight = data2.autoHeight;
			if (data2.rtlReorder !== void 0) component.rtlReorder = data2.rtlReorder;
			if (data2.unicodeConverter !== void 0) component.unicodeConverter = data2.unicodeConverter;
			if (data2.text !== null && data2.text !== void 0) {
				component.text = data2.text;
			} else if (data2.key !== null && data2.key !== void 0) {
				component.key = data2.key;
			}
			if (data2.color !== void 0) {
				color3 = data2.color;
				if (!(color3 instanceof Color)) {
					color3 = new Color(color3[0], color3[1], color3[2]);
				}
				component.color = color3;
			}
			if (data2.opacity !== void 0) {
				component.opacity = data2.opacity;
			}
			if (data2.spacing !== void 0) component.spacing = data2.spacing;
			if (data2.fontSize !== void 0) {
				component.fontSize = data2.fontSize;
				if (!data2.lineHeight) component.lineHeight = data2.fontSize;
			}
			if (data2.lineHeight !== void 0) component.lineHeight = data2.lineHeight;
			if (data2.maxLines !== void 0) component.maxLines = data2.maxLines;
			if (data2.wrapLines !== void 0) component.wrapLines = data2.wrapLines;
			if (data2.minFontSize !== void 0) component.minFontSize = data2.minFontSize;
			if (data2.maxFontSize !== void 0) component.maxFontSize = data2.maxFontSize;
			if (data2.autoFitWidth) component.autoFitWidth = data2.autoFitWidth;
			if (data2.autoFitHeight) component.autoFitHeight = data2.autoFitHeight;
			if (data2.fontAsset !== void 0) component.fontAsset = data2.fontAsset;
			if (data2.font !== void 0) component.font = data2.font;
			if (data2.alignment !== void 0) component.alignment = data2.alignment;
			if (data2.outlineColor !== void 0) component.outlineColor = data2.outlineColor;
			if (data2.outlineThickness !== void 0) component.outlineThickness = data2.outlineThickness;
			if (data2.shadowColor !== void 0) component.shadowColor = data2.shadowColor;
			if (data2.shadowOffset !== void 0) component.shadowOffset = data2.shadowOffset;
			if (data2.enableMarkup !== void 0) component.enableMarkup = data2.enableMarkup;
		}
		const result = component._parseUpToScreen();
		if (result.screen) {
			component._updateScreen(result.screen);
		}
		super.initializeComponentData(component, data2, []);
		component._beingInitialized = false;
		if (component.type === ELEMENTTYPE_IMAGE && component._image._meshDirty) {
			component._image._updateMesh(component._image.mesh);
		}
	}
	onAddComponent(entity, component) {
		entity.fire("element:add");
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	cloneComponent(entity, clone) {
		const source = entity.element;
		const data2 = {
			enabled: source.enabled,
			width: source.width,
			height: source.height,
			anchor: source.anchor.clone(),
			pivot: source.pivot.clone(),
			margin: source.margin.clone(),
			alignment: source.alignment && source.alignment.clone() || source.alignment,
			autoWidth: source.autoWidth,
			autoHeight: source.autoHeight,
			type: source.type,
			rect: source.rect && source.rect.clone() || source.rect,
			rtlReorder: source.rtlReorder,
			unicodeConverter: source.unicodeConverter,
			materialAsset: source.materialAsset,
			material: source.material,
			color: source.color && source.color.clone() || source.color,
			opacity: source.opacity,
			textureAsset: source.textureAsset,
			texture: source.texture,
			spriteAsset: source.spriteAsset,
			sprite: source.sprite,
			spriteFrame: source.spriteFrame,
			pixelsPerUnit: source.pixelsPerUnit,
			spacing: source.spacing,
			lineHeight: source.lineHeight,
			wrapLines: source.wrapLines,
			layers: source.layers,
			fontSize: source.fontSize,
			minFontSize: source.minFontSize,
			maxFontSize: source.maxFontSize,
			autoFitWidth: source.autoFitWidth,
			autoFitHeight: source.autoFitHeight,
			maxLines: source.maxLines,
			fontAsset: source.fontAsset,
			font: source.font,
			useInput: source.useInput,
			fitMode: source.fitMode,
			batchGroupId: source.batchGroupId,
			mask: source.mask,
			outlineColor: source.outlineColor && source.outlineColor.clone() || source.outlineColor,
			outlineThickness: source.outlineThickness,
			shadowColor: source.shadowColor && source.shadowColor.clone() || source.shadowColor,
			shadowOffset: source.shadowOffset && source.shadowOffset.clone() || source.shadowOffset,
			enableMarkup: source.enableMarkup
		};
		if (source.key !== void 0 && source.key !== null) {
			data2.key = source.key;
		} else {
			data2.text = source.text;
		}
		return this.addComponent(clone, data2);
	}
	getTextElementMaterial(screenSpace, msdf, textAttibutes) {
		const hash = (screenSpace && 1 << 0) | (msdf && 1 << 1) | (textAttibutes && 1 << 2);
		let material = this._defaultTextMaterials[hash];
		if (material) {
			return material;
		}
		let name = "TextMaterial";
		material = new StandardMaterial();
		if (msdf) {
			material.msdfMap = this._defaultTexture;
			material.msdfTextAttribute = textAttibutes;
			material.emissive.set(1, 1, 1);
		} else {
			name = `Bitmap${name}`;
			material.emissive.set(1, 1, 1);
			material.emissiveMap = this._defaultTexture;
			material.opacityMap = this._defaultTexture;
			material.opacityMapChannel = "a";
		}
		if (screenSpace) {
			name = `ScreenSpace${name}`;
			material.depthTest = false;
		}
		material.name = `default${name}`;
		material.useLighting = false;
		material.useTonemap = false;
		material.useFog = false;
		material.useSkybox = false;
		material.diffuse.set(0, 0, 0);
		material.opacity = 0.5;
		material.blendType = BLEND_PREMULTIPLIED;
		material.depthWrite = false;
		material.emissiveVertexColor = true;
		material.update();
		this._defaultTextMaterials[hash] = material;
		return material;
	}
	_createBaseImageMaterial() {
		const material = new StandardMaterial();
		material.diffuse.set(0, 0, 0);
		material.emissive.set(1, 1, 1);
		material.emissiveMap = this._defaultTexture;
		material.opacityMap = this._defaultTexture;
		material.opacityMapChannel = "a";
		material.useLighting = false;
		material.useTonemap = false;
		material.useFog = false;
		material.useSkybox = false;
		material.blendType = BLEND_PREMULTIPLIED;
		material.depthWrite = false;
		return material;
	}
	getImageElementMaterial(screenSpace, mask, nineSliced, nineSliceTiled) {
		if (screenSpace) {
			if (mask) {
				if (nineSliced) {
					if (!this.defaultScreenSpaceImageMask9SlicedMaterial) {
						this.defaultScreenSpaceImageMask9SlicedMaterial = this._createBaseImageMaterial();
						this.defaultScreenSpaceImageMask9SlicedMaterial.name = "defaultScreenSpaceImageMask9SlicedMaterial";
						this.defaultScreenSpaceImageMask9SlicedMaterial.nineSlicedMode = SPRITE_RENDERMODE_SLICED;
						this.defaultScreenSpaceImageMask9SlicedMaterial.depthTest = false;
						this.defaultScreenSpaceImageMask9SlicedMaterial.alphaTest = 1;
						this.defaultScreenSpaceImageMask9SlicedMaterial.redWrite = false;
						this.defaultScreenSpaceImageMask9SlicedMaterial.greenWrite = false;
						this.defaultScreenSpaceImageMask9SlicedMaterial.blueWrite = false;
						this.defaultScreenSpaceImageMask9SlicedMaterial.alphaWrite = false;
						this.defaultScreenSpaceImageMask9SlicedMaterial.update();
						this.defaultImageMaterials.push(this.defaultScreenSpaceImageMask9SlicedMaterial);
					}
					return this.defaultScreenSpaceImageMask9SlicedMaterial;
				} else if (nineSliceTiled) {
					if (!this.defaultScreenSpaceImageMask9TiledMaterial) {
						this.defaultScreenSpaceImageMask9TiledMaterial = this.defaultScreenSpaceImage9TiledMaterial.clone();
						this.defaultScreenSpaceImageMask9TiledMaterial.name = "defaultScreenSpaceImageMask9TiledMaterial";
						this.defaultScreenSpaceImageMask9TiledMaterial.nineSlicedMode = SPRITE_RENDERMODE_TILED;
						this.defaultScreenSpaceImageMask9TiledMaterial.depthTest = false;
						this.defaultScreenSpaceImageMask9TiledMaterial.alphaTest = 1;
						this.defaultScreenSpaceImageMask9TiledMaterial.redWrite = false;
						this.defaultScreenSpaceImageMask9TiledMaterial.greenWrite = false;
						this.defaultScreenSpaceImageMask9TiledMaterial.blueWrite = false;
						this.defaultScreenSpaceImageMask9TiledMaterial.alphaWrite = false;
						this.defaultScreenSpaceImageMask9TiledMaterial.update();
						this.defaultImageMaterials.push(this.defaultScreenSpaceImageMask9TiledMaterial);
					}
					return this.defaultScreenSpaceImageMask9TiledMaterial;
				} else {
					if (!this.defaultScreenSpaceImageMaskMaterial) {
						this.defaultScreenSpaceImageMaskMaterial = this._createBaseImageMaterial();
						this.defaultScreenSpaceImageMaskMaterial.name = "defaultScreenSpaceImageMaskMaterial";
						this.defaultScreenSpaceImageMaskMaterial.depthTest = false;
						this.defaultScreenSpaceImageMaskMaterial.alphaTest = 1;
						this.defaultScreenSpaceImageMaskMaterial.redWrite = false;
						this.defaultScreenSpaceImageMaskMaterial.greenWrite = false;
						this.defaultScreenSpaceImageMaskMaterial.blueWrite = false;
						this.defaultScreenSpaceImageMaskMaterial.alphaWrite = false;
						this.defaultScreenSpaceImageMaskMaterial.update();
						this.defaultImageMaterials.push(this.defaultScreenSpaceImageMaskMaterial);
					}
					return this.defaultScreenSpaceImageMaskMaterial;
				}
			} else {
				if (nineSliced) {
					if (!this.defaultScreenSpaceImage9SlicedMaterial) {
						this.defaultScreenSpaceImage9SlicedMaterial = this._createBaseImageMaterial();
						this.defaultScreenSpaceImage9SlicedMaterial.name = "defaultScreenSpaceImage9SlicedMaterial";
						this.defaultScreenSpaceImage9SlicedMaterial.nineSlicedMode = SPRITE_RENDERMODE_SLICED;
						this.defaultScreenSpaceImage9SlicedMaterial.depthTest = false;
						this.defaultScreenSpaceImage9SlicedMaterial.update();
						this.defaultImageMaterials.push(this.defaultScreenSpaceImage9SlicedMaterial);
					}
					return this.defaultScreenSpaceImage9SlicedMaterial;
				} else if (nineSliceTiled) {
					if (!this.defaultScreenSpaceImage9TiledMaterial) {
						this.defaultScreenSpaceImage9TiledMaterial = this._createBaseImageMaterial();
						this.defaultScreenSpaceImage9TiledMaterial.name = "defaultScreenSpaceImage9TiledMaterial";
						this.defaultScreenSpaceImage9TiledMaterial.nineSlicedMode = SPRITE_RENDERMODE_TILED;
						this.defaultScreenSpaceImage9TiledMaterial.depthTest = false;
						this.defaultScreenSpaceImage9TiledMaterial.update();
						this.defaultImageMaterials.push(this.defaultScreenSpaceImage9TiledMaterial);
					}
					return this.defaultScreenSpaceImage9TiledMaterial;
				} else {
					if (!this.defaultScreenSpaceImageMaterial) {
						this.defaultScreenSpaceImageMaterial = this._createBaseImageMaterial();
						this.defaultScreenSpaceImageMaterial.name = "defaultScreenSpaceImageMaterial";
						this.defaultScreenSpaceImageMaterial.depthTest = false;
						this.defaultScreenSpaceImageMaterial.update();
						this.defaultImageMaterials.push(this.defaultScreenSpaceImageMaterial);
					}
					return this.defaultScreenSpaceImageMaterial;
				}
			}
		} else {
			if (mask) {
				if (nineSliced) {
					if (!this.defaultImage9SlicedMaskMaterial) {
						this.defaultImage9SlicedMaskMaterial = this._createBaseImageMaterial();
						this.defaultImage9SlicedMaskMaterial.name = "defaultImage9SlicedMaskMaterial";
						this.defaultImage9SlicedMaskMaterial.nineSlicedMode = SPRITE_RENDERMODE_SLICED;
						this.defaultImage9SlicedMaskMaterial.alphaTest = 1;
						this.defaultImage9SlicedMaskMaterial.redWrite = false;
						this.defaultImage9SlicedMaskMaterial.greenWrite = false;
						this.defaultImage9SlicedMaskMaterial.blueWrite = false;
						this.defaultImage9SlicedMaskMaterial.alphaWrite = false;
						this.defaultImage9SlicedMaskMaterial.update();
						this.defaultImageMaterials.push(this.defaultImage9SlicedMaskMaterial);
					}
					return this.defaultImage9SlicedMaskMaterial;
				} else if (nineSliceTiled) {
					if (!this.defaultImage9TiledMaskMaterial) {
						this.defaultImage9TiledMaskMaterial = this._createBaseImageMaterial();
						this.defaultImage9TiledMaskMaterial.name = "defaultImage9TiledMaskMaterial";
						this.defaultImage9TiledMaskMaterial.nineSlicedMode = SPRITE_RENDERMODE_TILED;
						this.defaultImage9TiledMaskMaterial.alphaTest = 1;
						this.defaultImage9TiledMaskMaterial.redWrite = false;
						this.defaultImage9TiledMaskMaterial.greenWrite = false;
						this.defaultImage9TiledMaskMaterial.blueWrite = false;
						this.defaultImage9TiledMaskMaterial.alphaWrite = false;
						this.defaultImage9TiledMaskMaterial.update();
						this.defaultImageMaterials.push(this.defaultImage9TiledMaskMaterial);
					}
					return this.defaultImage9TiledMaskMaterial;
				} else {
					if (!this.defaultImageMaskMaterial) {
						this.defaultImageMaskMaterial = this._createBaseImageMaterial();
						this.defaultImageMaskMaterial.name = "defaultImageMaskMaterial";
						this.defaultImageMaskMaterial.alphaTest = 1;
						this.defaultImageMaskMaterial.redWrite = false;
						this.defaultImageMaskMaterial.greenWrite = false;
						this.defaultImageMaskMaterial.blueWrite = false;
						this.defaultImageMaskMaterial.alphaWrite = false;
						this.defaultImageMaskMaterial.update();
						this.defaultImageMaterials.push(this.defaultImageMaskMaterial);
					}
					return this.defaultImageMaskMaterial;
				}
			} else {
				if (nineSliced) {
					if (!this.defaultImage9SlicedMaterial) {
						this.defaultImage9SlicedMaterial = this._createBaseImageMaterial();
						this.defaultImage9SlicedMaterial.name = "defaultImage9SlicedMaterial";
						this.defaultImage9SlicedMaterial.nineSlicedMode = SPRITE_RENDERMODE_SLICED;
						this.defaultImage9SlicedMaterial.update();
						this.defaultImageMaterials.push(this.defaultImage9SlicedMaterial);
					}
					return this.defaultImage9SlicedMaterial;
				} else if (nineSliceTiled) {
					if (!this.defaultImage9TiledMaterial) {
						this.defaultImage9TiledMaterial = this._createBaseImageMaterial();
						this.defaultImage9TiledMaterial.name = "defaultImage9TiledMaterial";
						this.defaultImage9TiledMaterial.nineSlicedMode = SPRITE_RENDERMODE_TILED;
						this.defaultImage9TiledMaterial.update();
						this.defaultImageMaterials.push(this.defaultImage9TiledMaterial);
					}
					return this.defaultImage9TiledMaterial;
				} else {
					if (!this.defaultImageMaterial) {
						this.defaultImageMaterial = this._createBaseImageMaterial();
						this.defaultImageMaterial.name = "defaultImageMaterial";
						this.defaultImageMaterial.update();
						this.defaultImageMaterials.push(this.defaultImageMaterial);
					}
					return this.defaultImageMaterial;
				}
			}
		}
	}
	registerUnicodeConverter(func) {
		this._unicodeConverter = func;
	}
	registerRtlReorder(func) {
		this._rtlReorder = func;
	}
	getUnicodeConverter() {
		return this._unicodeConverter;
	}
	getRtlReorder() {
		return this._rtlReorder;
	}
};

var JOINTTYPE_FIXED = "fixed";
var JOINTTYPE_BALL = "ball";
var JOINTTYPE_HINGE = "hinge";
var JOINTTYPE_SLIDER = "slider";
var JOINTTYPE_6DOF = "6dof";
var MOTION_FREE = "free";
var MOTION_LIMITED = "limited";
var MOTION_LOCKED = "locked";

var _mat = new Mat4();
var _jointMat = new Mat4();
var _frameMatA = new Mat4();
var _frameMatB = new Mat4();
var _vec32 = new Vec3();
var _vec3b = new Vec3();
var _jointTypes = /* @__PURE__ */ new Set([JOINTTYPE_FIXED, JOINTTYPE_BALL, JOINTTYPE_HINGE, JOINTTYPE_SLIDER, JOINTTYPE_6DOF]);
var _breakSeparation = 0.2;
function setVec2(target2, value) {
	const x3 = value instanceof Vec2 ? value.x : value[0];
	const y2 = value instanceof Vec2 ? value.y : value[1];
	if (target2.x !== x3 || target2.y !== y2) {
		target2.set(x3, y2);
		return true;
	}
	return false;
}
function setVec3(target2, value) {
	const x3 = value instanceof Vec3 ? value.x : value[0];
	const y2 = value instanceof Vec3 ? value.y : value[1];
	const z2 = value instanceof Vec3 ? value.z : value[2];
	if (target2.x !== x3 || target2.y !== y2 || target2.z !== z2) {
		target2.set(x3, y2, z2);
		return true;
	}
	return false;
}
var JointComponent = class extends Component {
	static EVENT_BREAK = "break";
	_joint = null;
	_type = JOINTTYPE_FIXED;
	_entityA = null;
	_entityB = null;
	_enableCollision = false;
	_breakImpulse = Infinity;
	_broken = false;
	_initialized = false;
	// hinge, slider and ball
	_enableLimits = false;
	_limits = new Vec2(-45, 45);
	_motorSpeed = 0;
	_maxMotorForce = 0;
	_swingLimitY = 45;
	_swingLimitZ = 45;
	_twistLimit = 20;
	// 6dof
	_linearMotionX = MOTION_LOCKED;
	_linearMotionY = MOTION_LOCKED;
	_linearMotionZ = MOTION_LOCKED;
	_linearLimitsX = new Vec2();
	_linearLimitsY = new Vec2();
	_linearLimitsZ = new Vec2();
	_linearStiffness = new Vec3();
	_linearDamping = new Vec3(1, 1, 1);
	_linearEquilibrium = new Vec3();
	_angularMotionX = MOTION_LOCKED;
	_angularMotionY = MOTION_LOCKED;
	_angularMotionZ = MOTION_LOCKED;
	_angularLimitsX = new Vec2();
	_angularLimitsY = new Vec2();
	_angularLimitsZ = new Vec2();
	_angularStiffness = new Vec3();
	_angularDamping = new Vec3(1, 1, 1);
	_angularEquilibrium = new Vec3();
	// event bookkeeping
	_evtEntityADestroy = null;
	_evtEntityBDestroy = null;
	_evtSimEnabledA = null;
	_evtSimEnabledB = null;
	_evtBodyTeardown = [];
	// joint frame anchors captured at constraint creation, used for break detection on ammo
	// builds that expose no constraint state
	_anchorA = new Vec3();
	_anchorB = new Vec3();
	_axisA = new Vec3();
	set type(type) {
		if (this._type !== type) {
			if (!_jointTypes.has(type)) {
				return;
			}
			this._destroyConstraint();
			this._broken = false;
			this._type = type;
			this._tryCreateConstraint();
		}
	}
	get type() {
		return this._type;
	}
	set entityA(arg) {
		this._setJointEntity("_entityA", "_evtEntityADestroy", arg);
	}
	get entityA() {
		return this._entityA;
	}
	set entityB(arg) {
		this._setJointEntity("_entityB", "_evtEntityBDestroy", arg);
	}
	get entityB() {
		return this._entityB;
	}
	set enableCollision(enableCollision) {
		if (this._enableCollision !== enableCollision) {
			this._destroyConstraint();
			this._enableCollision = enableCollision;
			this._tryCreateConstraint();
		}
	}
	get enableCollision() {
		return this._enableCollision;
	}
	set breakImpulse(impulse) {
		if (this._breakImpulse !== impulse) {
			this._breakImpulse = impulse;
			const joint = this._joint;
			if (joint) {
				joint.setBreakImpulse(impulse);
				if (Number.isFinite(impulse)) {
					this.system._breakable.add(this);
				} else {
					this.system._breakable.delete(this);
				}
			}
		}
	}
	get breakImpulse() {
		return this._breakImpulse;
	}
	get constraint() {
		return this._joint ? this._joint.nativeJoint : null;
	}
	get isBroken() {
		return this._broken;
	}
	set enableLimits(arg) {
		if (this._enableLimits !== arg) {
			this._enableLimits = arg;
			this._updateLimits();
		}
	}
	get enableLimits() {
		return this._enableLimits;
	}
	set limits(arg) {
		if (setVec2(this._limits, arg)) {
			this._updateLimits();
		}
	}
	get limits() {
		return this._limits;
	}
	set motorSpeed(arg) {
		if (this._motorSpeed !== arg) {
			this._motorSpeed = arg;
			this._updateMotor();
		}
	}
	get motorSpeed() {
		return this._motorSpeed;
	}
	set maxMotorForce(arg) {
		if (this._maxMotorForce !== arg) {
			this._maxMotorForce = arg;
			this._updateMotor();
		}
	}
	get maxMotorForce() {
		return this._maxMotorForce;
	}
	set swingLimitY(arg) {
		if (this._swingLimitY !== arg) {
			this._swingLimitY = arg;
			this._updateLimits();
		}
	}
	get swingLimitY() {
		return this._swingLimitY;
	}
	set swingLimitZ(arg) {
		if (this._swingLimitZ !== arg) {
			this._swingLimitZ = arg;
			this._updateLimits();
		}
	}
	get swingLimitZ() {
		return this._swingLimitZ;
	}
	set twistLimit(arg) {
		if (this._twistLimit !== arg) {
			this._twistLimit = arg;
			this._updateLimits();
		}
	}
	get twistLimit() {
		return this._twistLimit;
	}
	set linearMotionX(arg) {
		if (this._linearMotionX !== arg) {
			this._linearMotionX = arg;
			this._updateLimits();
		}
	}
	get linearMotionX() {
		return this._linearMotionX;
	}
	set linearMotionY(arg) {
		if (this._linearMotionY !== arg) {
			this._linearMotionY = arg;
			this._updateLimits();
		}
	}
	get linearMotionY() {
		return this._linearMotionY;
	}
	set linearMotionZ(arg) {
		if (this._linearMotionZ !== arg) {
			this._linearMotionZ = arg;
			this._updateLimits();
		}
	}
	get linearMotionZ() {
		return this._linearMotionZ;
	}
	set linearLimitsX(arg) {
		if (setVec2(this._linearLimitsX, arg)) {
			this._updateLimits();
		}
	}
	get linearLimitsX() {
		return this._linearLimitsX;
	}
	set linearLimitsY(arg) {
		if (setVec2(this._linearLimitsY, arg)) {
			this._updateLimits();
		}
	}
	get linearLimitsY() {
		return this._linearLimitsY;
	}
	set linearLimitsZ(arg) {
		if (setVec2(this._linearLimitsZ, arg)) {
			this._updateLimits();
		}
	}
	get linearLimitsZ() {
		return this._linearLimitsZ;
	}
	set linearStiffness(arg) {
		if (setVec3(this._linearStiffness, arg)) {
			this._updateSpring();
		}
	}
	get linearStiffness() {
		return this._linearStiffness;
	}
	set linearDamping(arg) {
		if (setVec3(this._linearDamping, arg)) {
			this._updateSpring();
		}
	}
	get linearDamping() {
		return this._linearDamping;
	}
	set linearEquilibrium(arg) {
		if (setVec3(this._linearEquilibrium, arg)) {
			this._updateSpring();
		}
	}
	get linearEquilibrium() {
		return this._linearEquilibrium;
	}
	set angularMotionX(arg) {
		if (this._angularMotionX !== arg) {
			this._angularMotionX = arg;
			this._updateLimits();
		}
	}
	get angularMotionX() {
		return this._angularMotionX;
	}
	set angularMotionY(arg) {
		if (this._angularMotionY !== arg) {
			this._angularMotionY = arg;
			this._updateLimits();
		}
	}
	get angularMotionY() {
		return this._angularMotionY;
	}
	set angularMotionZ(arg) {
		if (this._angularMotionZ !== arg) {
			this._angularMotionZ = arg;
			this._updateLimits();
		}
	}
	get angularMotionZ() {
		return this._angularMotionZ;
	}
	set angularLimitsX(arg) {
		if (setVec2(this._angularLimitsX, arg)) {
			this._updateLimits();
		}
	}
	get angularLimitsX() {
		return this._angularLimitsX;
	}
	set angularLimitsY(arg) {
		if (setVec2(this._angularLimitsY, arg)) {
			this._updateLimits();
		}
	}
	get angularLimitsY() {
		return this._angularLimitsY;
	}
	set angularLimitsZ(arg) {
		if (setVec2(this._angularLimitsZ, arg)) {
			this._updateLimits();
		}
	}
	get angularLimitsZ() {
		return this._angularLimitsZ;
	}
	set angularStiffness(arg) {
		if (setVec3(this._angularStiffness, arg)) {
			this._updateSpring();
		}
	}
	get angularStiffness() {
		return this._angularStiffness;
	}
	set angularDamping(arg) {
		if (setVec3(this._angularDamping, arg)) {
			this._updateSpring();
		}
	}
	get angularDamping() {
		return this._angularDamping;
	}
	set angularEquilibrium(arg) {
		if (setVec3(this._angularEquilibrium, arg)) {
			this._updateSpring();
		}
	}
	get angularEquilibrium() {
		return this._angularEquilibrium;
	}
	refreshFrames() {
		this._destroyConstraint();
		this._broken = false;
		this._tryCreateConstraint();
	}
	_setJointEntity(prop, evtProp, arg) {
		let entity;
		if (arg instanceof GraphNode) {
			entity = arg;
		} else if (typeof arg === "string") {
			entity = this.system.app.getEntityFromIndex(arg) ?? null;
		} else {
			entity = null;
		}
		if (this[prop] === entity) {
			return;
		}
		this._destroyConstraint();
		this[evtProp]?.off();
		this[evtProp] = null;
		this[prop] = entity;
		if (entity) {
			this[evtProp] = entity.once("destroy", () => {
				this[evtProp] = null;
				this[prop] = null;
				this._destroyConstraint();
			});
		}
		this._broken = false;
		this._tryCreateConstraint();
	}
	_isBodyReady(entity) {
		const rigidbody = entity.rigidbody;
		return !!(rigidbody && rigidbody._body && rigidbody._simulationEnabled);
	}
	_subscribeBodyAvailable() {
		if (!this._evtSimEnabledA && this._entityA?.rigidbody) {
			this._evtSimEnabledA = this._entityA.rigidbody.once("simulationenabled", this._onBodyAvailable, this);
		}
		if (!this._evtSimEnabledB && this._entityB?.rigidbody) {
			this._evtSimEnabledB = this._entityB.rigidbody.once("simulationenabled", this._onBodyAvailable, this);
		}
	}
	_clearBodyAvailableSubscriptions() {
		this._evtSimEnabledA?.off();
		this._evtSimEnabledA = null;
		this._evtSimEnabledB?.off();
		this._evtSimEnabledB = null;
	}
	_onBodyAvailable() {
		this._clearBodyAvailableSubscriptions();
		this._tryCreateConstraint();
	}
	_onBodyLost() {
		this._destroyConstraint();
		this._tryCreateConstraint();
	}
	_tryCreateConstraint() {
		const system = this.system;
		if (this._joint || !this._initialized || !this.enabled || !this.entity.enabled || this._broken || !this._entityA || this._entityA === this._entityB) {
			system._pending.delete(this);
			this._clearBodyAvailableSubscriptions();
			return;
		}
		if (!this._isBodyReady(this._entityA) || this._entityB && !this._isBodyReady(this._entityB)) {
			system._pending.add(this);
			this._subscribeBodyAvailable();
			return;
		}
		system._pending.delete(this);
		this._clearBodyAvailableSubscriptions();
		this._createConstraint();
	}
	_createFrame(bodyEntity, anchor, axis, frame) {
		_jointMat.setTRS(this.entity.getPosition(), this.entity.getRotation(), Vec3.ONE);
		if (bodyEntity) {
			_mat.setTRS(bodyEntity.getPosition(), bodyEntity.getRotation(), Vec3.ONE);
			_mat.invert();
			_mat.mul(_jointMat);
		} else {
			_mat.copy(_jointMat);
		}
		_mat.getTranslation(_vec32);
		anchor.copy(_vec32);
		_mat.getX(axis).normalize();
		frame.copy(_mat);
	}
	_createConstraint() {
		const entityA = this._entityA;
		const entityB = this._entityB;
		const rigidbodyA = entityA.rigidbody;
		const rigidbodyB = entityB ? entityB.rigidbody : null;
		this._createFrame(entityA, this._anchorA, this._axisA, _frameMatA);
		this._createFrame(entityB, this._anchorB, _vec3b, _frameMatB);
		const world = this.system.app.systems.rigidbody.physicsWorld;
		this._joint = world.createJoint({
			type: this._type,
			bodyA: rigidbodyA._body,
			bodyB: rigidbodyB ? rigidbodyB._body : null,
			frameA: _frameMatA,
			frameB: _frameMatB,
			enableCollision: this._enableCollision,
			settings: this
		});
		if (Number.isFinite(this._breakImpulse)) {
			this.system._breakable.add(this);
		}
		this._evtBodyTeardown.push(
			rigidbodyA.on("simulationdisabled", this._onBodyLost, this),
			rigidbodyA.on("beforeremove", this._onBodyLost, this)
		);
		if (rigidbodyB) {
			this._evtBodyTeardown.push(
				rigidbodyB.on("simulationdisabled", this._onBodyLost, this),
				rigidbodyB.on("beforeremove", this._onBodyLost, this)
			);
		}
	}
	_destroyConstraint() {
		this.system._pending.delete(this);
		this._clearBodyAvailableSubscriptions();
		const joint = this._joint;
		if (joint) {
			this.system._breakable.delete(this);
			for (let i2 = 0; i2 < this._evtBodyTeardown.length; i2++) {
				this._evtBodyTeardown[i2].off();
			}
			this._evtBodyTeardown.length = 0;
			this.system.app.systems.rigidbody.physicsWorld.destroyJoint(joint);
			this._joint = null;
		}
	}
	_isAnchorSeparated() {
		if (this._type === JOINTTYPE_6DOF) {
			return false;
		}
		const entityA = this._entityA;
		_mat.setTRS(entityA.getPosition(), entityA.getRotation(), Vec3.ONE);
		_mat.transformPoint(this._anchorA, _vec32);
		const entityB = this._entityB;
		if (entityB) {
			_jointMat.setTRS(entityB.getPosition(), entityB.getRotation(), Vec3.ONE);
			_jointMat.transformPoint(this._anchorB, _vec3b);
		} else {
			_vec3b.copy(this._anchorB);
		}
		_vec3b.sub(_vec32);
		if (this._type === JOINTTYPE_SLIDER) {
			_mat.transformVector(this._axisA, _vec32);
			const slide = _vec3b.dot(_vec32);
			_vec3b.sub(_vec32.mulScalar(slide));
		}
		return _vec3b.lengthSq() > _breakSeparation * _breakSeparation;
	}
	_checkBroken() {
		const joint = this._joint;
		if (!joint) {
			return;
		}
		let broken = joint.isBroken();
		if (broken === null) {
			broken = this._isAnchorSeparated();
		}
		if (broken) {
			this._broken = true;
			this._destroyConstraint();
			this.fire("break");
		}
	}
	_activateBodies() {
		this._entityA?.rigidbody?.activate();
		this._entityB?.rigidbody?.activate();
	}
	_updateLimits() {
		if (this._joint && this._joint.updateLimits(this)) {
			this._activateBodies();
		}
	}
	_updateMotor() {
		if (this._joint && this._joint.updateMotor(this)) {
			this._activateBodies();
		}
	}
	_updateSpring() {
		if (this._joint && this._joint.updateSpring(this)) {
			this._activateBodies();
		}
	}
	onEnable() {
		this._broken = false;
		this._tryCreateConstraint();
	}
	onDisable() {
		this._destroyConstraint();
	}
	onBeforeRemove() {
		this._destroyConstraint();
		this._evtEntityADestroy?.off();
		this._evtEntityADestroy = null;
		this._evtEntityBDestroy?.off();
		this._evtEntityBDestroy = null;
	}
	resolveDuplicatedEntityReferenceProperties(oldJoint, duplicatedIdsMap) {
		if (oldJoint.entityA) {
			const newEntityA = duplicatedIdsMap[oldJoint.entityA.guid];
			if (newEntityA) {
				this.entityA = newEntityA;
			}
		}
		if (oldJoint.entityB) {
			const newEntityB = duplicatedIdsMap[oldJoint.entityB.guid];
			if (newEntityB) {
				this.entityB = newEntityB;
			}
		}
	}
};

var _properties4 = [
	"type",
	"enableCollision",
	"breakImpulse",
	"enableLimits",
	"limits",
	"motorSpeed",
	"maxMotorForce",
	"swingLimitY",
	"swingLimitZ",
	"twistLimit",
	"linearMotionX",
	"linearMotionY",
	"linearMotionZ",
	"linearLimitsX",
	"linearLimitsY",
	"linearLimitsZ",
	"linearStiffness",
	"linearDamping",
	"linearEquilibrium",
	"angularMotionX",
	"angularMotionY",
	"angularMotionZ",
	"angularLimitsX",
	"angularLimitsY",
	"angularLimitsZ",
	"angularStiffness",
	"angularDamping",
	"angularEquilibrium",
	// entity references are assigned last so the constraint is created with full configuration
	"entityA",
	"entityB"
];
var JointComponentSystem = class extends ComponentSystem {
	_pending = /* @__PURE__ */ new Set();
	_breakable = /* @__PURE__ */ new Set();
	constructor(app2) {
		super(app2);
		this.id = "joint";
		this.ComponentType = JointComponent;
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.systems.on("update", this.onUpdate, this);
		this.app.systems.on("postUpdate", this.onPostUpdate, this);
	}
	initializeComponentData(component, data2, properties) {
		for (let i2 = 0; i2 < _properties4.length; i2++) {
			const property = _properties4[i2];
			if (data2[property] !== void 0) {
				component[property] = data2[property];
			}
		}
		component._initialized = true;
		super.initializeComponentData(component, data2);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.joint;
		const data2 = {
			enabled: c2.enabled
		};
		for (let i2 = 0; i2 < _properties4.length; i2++) {
			const property = _properties4[i2];
			data2[property] = c2[property];
		}
		return this.addComponent(clone, data2);
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	onUpdate(dt) {
		for (const component of this._pending) {
			component._tryCreateConstraint();
		}
	}
	onPostUpdate(dt) {
		for (const component of this._breakable) {
			component._checkBroken();
		}
	}
	destroy() {
		super.destroy();
		this.app.systems.off("update", this.onUpdate, this);
		this.app.systems.off("postUpdate", this.onPostUpdate, this);
	}
};

var LayoutChildComponent = class extends Component {
	_minWidth = 0;
	_minHeight = 0;
	_maxWidth = null;
	_maxHeight = null;
	_fitWidthProportion = 0;
	_fitHeightProportion = 0;
	_excludeFromLayout = false;
	set minWidth(value) {
		if (value !== this._minWidth) {
			this._minWidth = value;
			this.fire("resize");
		}
	}
	get minWidth() {
		return this._minWidth;
	}
	set minHeight(value) {
		if (value !== this._minHeight) {
			this._minHeight = value;
			this.fire("resize");
		}
	}
	get minHeight() {
		return this._minHeight;
	}
	set maxWidth(value) {
		if (value !== this._maxWidth) {
			this._maxWidth = value;
			this.fire("resize");
		}
	}
	get maxWidth() {
		return this._maxWidth;
	}
	set maxHeight(value) {
		if (value !== this._maxHeight) {
			this._maxHeight = value;
			this.fire("resize");
		}
	}
	get maxHeight() {
		return this._maxHeight;
	}
	set fitWidthProportion(value) {
		if (value !== this._fitWidthProportion) {
			this._fitWidthProportion = value;
			this.fire("resize");
		}
	}
	get fitWidthProportion() {
		return this._fitWidthProportion;
	}
	set fitHeightProportion(value) {
		if (value !== this._fitHeightProportion) {
			this._fitHeightProportion = value;
			this.fire("resize");
		}
	}
	get fitHeightProportion() {
		return this._fitHeightProportion;
	}
	set excludeFromLayout(value) {
		if (value !== this._excludeFromLayout) {
			this._excludeFromLayout = value;
			this.fire("resize");
		}
	}
	get excludeFromLayout() {
		return this._excludeFromLayout;
	}
};

var LayoutChildComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "layoutchild";
		this.ComponentType = LayoutChildComponent;
	}
	initializeComponentData(component, data2, properties) {
		if (data2.enabled !== void 0) component.enabled = data2.enabled;
		if (data2.minWidth !== void 0) component.minWidth = data2.minWidth;
		if (data2.minHeight !== void 0) component.minHeight = data2.minHeight;
		if (data2.maxWidth !== void 0) component.maxWidth = data2.maxWidth;
		if (data2.maxHeight !== void 0) component.maxHeight = data2.maxHeight;
		if (data2.fitWidthProportion !== void 0) component.fitWidthProportion = data2.fitWidthProportion;
		if (data2.fitHeightProportion !== void 0) component.fitHeightProportion = data2.fitHeightProportion;
		if (data2.excludeFromLayout !== void 0) component.excludeFromLayout = data2.excludeFromLayout;
		super.initializeComponentData(component, data2, []);
	}
	cloneComponent(entity, clone) {
		const layoutChild = entity.layoutchild;
		return this.addComponent(clone, {
			enabled: layoutChild.enabled,
			minWidth: layoutChild.minWidth,
			minHeight: layoutChild.minHeight,
			maxWidth: layoutChild.maxWidth,
			maxHeight: layoutChild.maxHeight,
			fitWidthProportion: layoutChild.fitWidthProportion,
			fitHeightProportion: layoutChild.fitHeightProportion,
			excludeFromLayout: layoutChild.excludeFromLayout
		});
	}
};

var FITTING_NONE = 0;
var FITTING_STRETCH = 1;
var FITTING_SHRINK = 2;
var FITTING_BOTH = 3;

var AXIS_MAPPINGS = {};
AXIS_MAPPINGS[ORIENTATION_HORIZONTAL] = {
	axis: "x",
	size: "width",
	calculatedSize: "calculatedWidth",
	minSize: "minWidth",
	maxSize: "maxWidth",
	fitting: "widthFitting",
	fittingProportion: "fitWidthProportion"
};
AXIS_MAPPINGS[ORIENTATION_VERTICAL] = {
	axis: "y",
	size: "height",
	calculatedSize: "calculatedHeight",
	minSize: "minHeight",
	maxSize: "maxHeight",
	fitting: "heightFitting",
	fittingProportion: "fitHeightProportion"
};
var OPPOSITE_ORIENTATION = {};
OPPOSITE_ORIENTATION[ORIENTATION_HORIZONTAL] = ORIENTATION_VERTICAL;
OPPOSITE_ORIENTATION[ORIENTATION_VERTICAL] = ORIENTATION_HORIZONTAL;
var PROPERTY_DEFAULTS = {
	minWidth: 0,
	minHeight: 0,
	maxWidth: Number.POSITIVE_INFINITY,
	maxHeight: Number.POSITIVE_INFINITY,
	width: null,
	height: null,
	fitWidthProportion: 0,
	fitHeightProportion: 0
};
var FITTING_ACTION = {
	NONE: "NONE",
	APPLY_STRETCHING: "APPLY_STRETCHING",
	APPLY_SHRINKING: "APPLY_SHRINKING"
};
var availableSpace = new Vec2();
function createCalculator(orientation) {
	let options2;
	const a = AXIS_MAPPINGS[orientation];
	const b = AXIS_MAPPINGS[OPPOSITE_ORIENTATION[orientation]];
	function minExtentA(element, size) {
		return -size[a.size] * element.pivot[a.axis];
	}
	function minExtentB(element, size) {
		return -size[b.size] * element.pivot[b.axis];
	}
	function maxExtentA(element, size) {
		return size[a.size] * (1 - element.pivot[a.axis]);
	}
	function maxExtentB(element, size) {
		return size[b.size] * (1 - element.pivot[b.axis]);
	}
	function calculateAll(allElements, layoutOptions) {
		allElements = allElements.filter(shouldIncludeInLayout);
		options2 = layoutOptions;
		availableSpace.x = options2.containerSize.x - options2.padding.x - options2.padding.z;
		availableSpace.y = options2.containerSize.y - options2.padding.y - options2.padding.w;
		resetAnchors(allElements);
		const lines = reverseLinesIfRequired(splitLines(allElements));
		const sizes = calculateSizesOnAxisB(lines, calculateSizesOnAxisA(lines));
		const positions = calculateBasePositions(lines, sizes);
		applyAlignmentAndPadding(lines, sizes, positions);
		applySizesAndPositions(lines, sizes, positions);
		return createLayoutInfo(lines);
	}
	function shouldIncludeInLayout(element) {
		const layoutChildComponent = element.entity.layoutchild;
		return !layoutChildComponent || !layoutChildComponent.enabled || !layoutChildComponent.excludeFromLayout;
	}
	function resetAnchors(allElements) {
		for (let i2 = 0; i2 < allElements.length; ++i2) {
			const element = allElements[i2];
			const anchor = element.anchor;
			if (anchor.x !== 0 || anchor.y !== 0 || anchor.z !== 0 || anchor.w !== 0) {
				element.anchor = Vec4.ZERO;
			}
		}
	}
	function splitLines(allElements) {
		if (!options2.wrap) {
			return [allElements];
		}
		const lines = [[]];
		const sizes = getElementSizeProperties(allElements);
		let runningSize = 0;
		const allowOverrun = options2[a.fitting] === FITTING_SHRINK;
		for (let i2 = 0; i2 < allElements.length; ++i2) {
			if (lines[lines.length - 1].length > 0) {
				runningSize += options2.spacing[a.axis];
			}
			const idealElementSize = sizes[i2][a.size];
			runningSize += idealElementSize;
			if (!allowOverrun && runningSize > availableSpace[a.axis] && lines[lines.length - 1].length !== 0) {
				runningSize = idealElementSize;
				lines.push([]);
			}
			lines[lines.length - 1].push(allElements[i2]);
			if (allowOverrun && runningSize > availableSpace[a.axis] && i2 !== allElements.length - 1) {
				runningSize = 0;
				lines.push([]);
			}
		}
		return lines;
	}
	function reverseLinesIfRequired(lines) {
		const reverseAxisA = options2.orientation === ORIENTATION_HORIZONTAL && options2.reverseX || options2.orientation === ORIENTATION_VERTICAL && options2.reverseY;
		const reverseAxisB = options2.orientation === ORIENTATION_HORIZONTAL && options2.reverseY || options2.orientation === ORIENTATION_VERTICAL && options2.reverseX;
		if (reverseAxisA) {
			for (let lineIndex = 0; lineIndex < lines.length; ++lineIndex) {
				if (reverseAxisA) {
					lines[lineIndex].reverse();
				}
			}
		}
		if (reverseAxisB) {
			lines.reverse();
		}
		return lines;
	}
	function calculateSizesOnAxisA(lines) {
		const sizesAllLines = [];
		for (let lineIndex = 0; lineIndex < lines.length; ++lineIndex) {
			const line = lines[lineIndex];
			const sizesThisLine = getElementSizeProperties(line);
			const idealRequiredSpace = calculateTotalSpace(sizesThisLine, a);
			const fittingAction = determineFittingAction(options2[a.fitting], idealRequiredSpace, availableSpace[a.axis]);
			if (fittingAction === FITTING_ACTION.APPLY_STRETCHING) {
				stretchSizesToFitContainer(sizesThisLine, idealRequiredSpace, a);
			} else if (fittingAction === FITTING_ACTION.APPLY_SHRINKING) {
				shrinkSizesToFitContainer(sizesThisLine, idealRequiredSpace, a);
			}
			sizesAllLines.push(sizesThisLine);
		}
		return sizesAllLines;
	}
	function calculateSizesOnAxisB(lines, sizesAllLines) {
		const largestElementsForEachLine = [];
		const largestSizesForEachLine = [];
		for (let lineIndex = 0; lineIndex < lines.length; ++lineIndex) {
			const line = lines[lineIndex];
			line.largestElement = null;
			line.largestSize = { width: Number.NEGATIVE_INFINITY, height: Number.NEGATIVE_INFINITY };
			for (let elementIndex = 0; elementIndex < line.length; ++elementIndex) {
				const sizesThisElement = sizesAllLines[lineIndex][elementIndex];
				if (sizesThisElement[b.size] > line.largestSize[b.size]) {
					line.largestElement = line[elementIndex];
					line.largestSize = sizesThisElement;
				}
			}
			largestElementsForEachLine.push(line.largestElement);
			largestSizesForEachLine.push(line.largestSize);
		}
		const idealRequiredSpace = calculateTotalSpace(largestSizesForEachLine, b);
		const fittingAction = determineFittingAction(options2[b.fitting], idealRequiredSpace, availableSpace[b.axis]);
		if (fittingAction === FITTING_ACTION.APPLY_STRETCHING) {
			stretchSizesToFitContainer(largestSizesForEachLine, idealRequiredSpace, b);
		} else if (fittingAction === FITTING_ACTION.APPLY_SHRINKING) {
			shrinkSizesToFitContainer(largestSizesForEachLine, idealRequiredSpace, b);
		}
		for (let lineIndex = 0; lineIndex < lines.length; ++lineIndex) {
			const line = lines[lineIndex];
			for (let elementIndex = 0; elementIndex < line.length; ++elementIndex) {
				const sizesForThisElement = sizesAllLines[lineIndex][elementIndex];
				const currentSize = sizesForThisElement[b.size];
				const availableSize = lines.length === 1 ? availableSpace[b.axis] : line.largestSize[b.size];
				const elementFittingAction = determineFittingAction(options2[b.fitting], currentSize, availableSize);
				if (elementFittingAction === FITTING_ACTION.APPLY_STRETCHING) {
					sizesForThisElement[b.size] = Math.min(availableSize, sizesForThisElement[b.maxSize]);
				} else if (elementFittingAction === FITTING_ACTION.APPLY_SHRINKING) {
					sizesForThisElement[b.size] = Math.max(availableSize, sizesForThisElement[b.minSize]);
				}
			}
		}
		return sizesAllLines;
	}
	function determineFittingAction(fittingMode, currentSize, availableSize) {
		switch (fittingMode) {
			case FITTING_NONE:
				return FITTING_ACTION.NONE;
			case FITTING_STRETCH:
				if (currentSize < availableSize) {
					return FITTING_ACTION.APPLY_STRETCHING;
				}
				return FITTING_ACTION.NONE;
			case FITTING_SHRINK:
				if (currentSize >= availableSize) {
					return FITTING_ACTION.APPLY_SHRINKING;
				}
				return FITTING_ACTION.NONE;
			case FITTING_BOTH:
				if (currentSize < availableSize) {
					return FITTING_ACTION.APPLY_STRETCHING;
				}
				return FITTING_ACTION.APPLY_SHRINKING;
			default:
				throw new Error(`Unrecognized fitting mode: ${fittingMode}`);
		}
	}
	function calculateTotalSpace(sizes, axis) {
		const totalSizes = sumValues(sizes, axis.size);
		const totalSpacing = (sizes.length - 1) * options2.spacing[axis.axis];
		return totalSizes + totalSpacing;
	}
	function stretchSizesToFitContainer(sizesThisLine, idealRequiredSpace, axis) {
		const ascendingMaxSizeOrder = getTraversalOrder(sizesThisLine, axis.maxSize);
		const fittingProportions = getNormalizedValues(sizesThisLine, axis.fittingProportion);
		const fittingProportionSums = createSumArray(fittingProportions, ascendingMaxSizeOrder);
		let remainingUndershoot = availableSpace[axis.axis] - idealRequiredSpace;
		for (let i2 = 0; i2 < sizesThisLine.length; ++i2) {
			const index = ascendingMaxSizeOrder[i2];
			const targetIncrease = calculateAdjustment(index, remainingUndershoot, fittingProportions, fittingProportionSums);
			const targetSize = sizesThisLine[index][axis.size] + targetIncrease;
			const maxSize = sizesThisLine[index][axis.maxSize];
			const actualSize = Math.min(targetSize, maxSize);
			sizesThisLine[index][axis.size] = actualSize;
			const actualIncrease = Math.max(targetSize - actualSize, 0);
			const appliedIncrease = targetIncrease - actualIncrease;
			remainingUndershoot -= appliedIncrease;
		}
	}
	function shrinkSizesToFitContainer(sizesThisLine, idealRequiredSpace, axis) {
		const descendingMinSizeOrder = getTraversalOrder(sizesThisLine, axis.minSize, true);
		const fittingProportions = getNormalizedValues(sizesThisLine, axis.fittingProportion);
		const inverseFittingProportions = invertNormalizedValues(fittingProportions);
		const inverseFittingProportionSums = createSumArray(inverseFittingProportions, descendingMinSizeOrder);
		let remainingOvershoot = idealRequiredSpace - availableSpace[axis.axis];
		for (let i2 = 0; i2 < sizesThisLine.length; ++i2) {
			const index = descendingMinSizeOrder[i2];
			const targetReduction = calculateAdjustment(index, remainingOvershoot, inverseFittingProportions, inverseFittingProportionSums);
			const targetSize = sizesThisLine[index][axis.size] - targetReduction;
			const minSize = sizesThisLine[index][axis.minSize];
			const actualSize = Math.max(targetSize, minSize);
			sizesThisLine[index][axis.size] = actualSize;
			const actualReduction = Math.max(actualSize - targetSize, 0);
			const appliedReduction = targetReduction - actualReduction;
			remainingOvershoot -= appliedReduction;
		}
	}
	function calculateAdjustment(index, remainingAdjustment, fittingProportions, fittingProportionSums) {
		const proportion = fittingProportions[index];
		const sumOfRemainingProportions = fittingProportionSums[index];
		if (Math.abs(proportion) < 1e-5 && Math.abs(sumOfRemainingProportions) < 1e-5) {
			return remainingAdjustment;
		}
		return remainingAdjustment * proportion / sumOfRemainingProportions;
	}
	function calculateBasePositions(lines, sizes) {
		const cursor = {};
		cursor[a.axis] = 0;
		cursor[b.axis] = 0;
		lines[a.size] = Number.NEGATIVE_INFINITY;
		const positionsAllLines = [];
		for (let lineIndex = 0; lineIndex < lines.length; ++lineIndex) {
			const line = lines[lineIndex];
			if (line.length === 0) {
				positionsAllLines.push([]);
				continue;
			}
			const positionsThisLine = [];
			const sizesThisLine = sizes[lineIndex];
			for (let elementIndex = 0; elementIndex < line.length; ++elementIndex) {
				const element = line[elementIndex];
				const sizesThisElement = sizesThisLine[elementIndex];
				cursor[b.axis] -= minExtentB(element, sizesThisElement);
				cursor[a.axis] -= minExtentA(element, sizesThisElement);
				positionsThisLine[elementIndex] = {};
				positionsThisLine[elementIndex][a.axis] = cursor[a.axis];
				positionsThisLine[elementIndex][b.axis] = cursor[b.axis];
				cursor[b.axis] += minExtentB(element, sizesThisElement);
				cursor[a.axis] += maxExtentA(element, sizesThisElement) + options2.spacing[a.axis];
			}
			line[a.size] = cursor[a.axis] - options2.spacing[a.axis];
			line[b.size] = line.largestSize[b.size];
			lines[a.size] = Math.max(lines[a.size], line[a.size]);
			cursor[a.axis] = 0;
			cursor[b.axis] += line[b.size] + options2.spacing[b.axis];
			positionsAllLines.push(positionsThisLine);
		}
		lines[b.size] = cursor[b.axis] - options2.spacing[b.axis];
		return positionsAllLines;
	}
	function applyAlignmentAndPadding(lines, sizes, positions) {
		const alignmentA = options2.alignment[a.axis];
		const alignmentB = options2.alignment[b.axis];
		const paddingA = options2.padding[a.axis];
		const paddingB = options2.padding[b.axis];
		for (let lineIndex = 0; lineIndex < lines.length; ++lineIndex) {
			const line = lines[lineIndex];
			const sizesThisLine = sizes[lineIndex];
			const positionsThisLine = positions[lineIndex];
			const axisAOffset = (availableSpace[a.axis] - line[a.size]) * alignmentA + paddingA;
			const axisBOffset = (availableSpace[b.axis] - lines[b.size]) * alignmentB + paddingB;
			for (let elementIndex = 0; elementIndex < line.length; ++elementIndex) {
				const withinLineAxisBOffset = (line[b.size] - sizesThisLine[elementIndex][b.size]) * options2.alignment[b.axis];
				positionsThisLine[elementIndex][a.axis] += axisAOffset;
				positionsThisLine[elementIndex][b.axis] += axisBOffset + withinLineAxisBOffset;
			}
		}
	}
	function applySizesAndPositions(lines, sizes, positions) {
		for (let lineIndex = 0; lineIndex < lines.length; ++lineIndex) {
			const line = lines[lineIndex];
			const sizesThisLine = sizes[lineIndex];
			const positionsThisLine = positions[lineIndex];
			for (let elementIndex = 0; elementIndex < line.length; ++elementIndex) {
				const element = line[elementIndex];
				element[a.calculatedSize] = sizesThisLine[elementIndex][a.size];
				element[b.calculatedSize] = sizesThisLine[elementIndex][b.size];
				if (options2.orientation === ORIENTATION_HORIZONTAL) {
					element.entity.setLocalPosition(
						positionsThisLine[elementIndex][a.axis],
						positionsThisLine[elementIndex][b.axis],
						element.entity.getLocalPosition().z
					);
				} else {
					element.entity.setLocalPosition(
						positionsThisLine[elementIndex][b.axis],
						positionsThisLine[elementIndex][a.axis],
						element.entity.getLocalPosition().z
					);
				}
			}
		}
	}
	function createLayoutInfo(lines) {
		const layoutWidth = lines.width;
		const layoutHeight = lines.height;
		const xOffset = (availableSpace.x - layoutWidth) * options2.alignment.x + options2.padding.x;
		const yOffset = (availableSpace.y - layoutHeight) * options2.alignment.y + options2.padding.y;
		return {
			bounds: new Vec4(
				xOffset,
				yOffset,
				layoutWidth,
				layoutHeight
			)
		};
	}
	function getElementSizeProperties(elements) {
		const sizeProperties = [];
		for (let i2 = 0; i2 < elements.length; ++i2) {
			const element = elements[i2];
			const minWidth = Math.max(getProperty(element, "minWidth"), 0);
			const minHeight = Math.max(getProperty(element, "minHeight"), 0);
			const maxWidth = Math.max(getProperty(element, "maxWidth"), minWidth);
			const maxHeight = Math.max(getProperty(element, "maxHeight"), minHeight);
			const width = clamp(getProperty(element, "width"), minWidth, maxWidth);
			const height = clamp(getProperty(element, "height"), minHeight, maxHeight);
			const fitWidthProportion = getProperty(element, "fitWidthProportion");
			const fitHeightProportion = getProperty(element, "fitHeightProportion");
			sizeProperties.push({
				minWidth,
				minHeight,
				maxWidth,
				maxHeight,
				width,
				height,
				fitWidthProportion,
				fitHeightProportion
			});
		}
		return sizeProperties;
	}
	function getProperty(element, propertyName) {
		const layoutChildComponent = element.entity.layoutchild;
		if (layoutChildComponent && layoutChildComponent.enabled && layoutChildComponent[propertyName] !== void 0 && layoutChildComponent[propertyName] !== null) {
			return layoutChildComponent[propertyName];
		} else if (element[propertyName] !== void 0) {
			return element[propertyName];
		}
		return PROPERTY_DEFAULTS[propertyName];
	}
	function clamp(value, min, max) {
		return Math.min(Math.max(value, min), max);
	}
	function sumValues(items, propertyName) {
		return items.reduce((accumulator, current) => {
			return accumulator + current[propertyName];
		}, 0);
	}
	function getNormalizedValues(items, propertyName) {
		const sum = sumValues(items, propertyName);
		const normalizedValues = [];
		const numItems = items.length;
		if (sum === 0) {
			for (let i2 = 0; i2 < numItems; ++i2) {
				normalizedValues.push(1 / numItems);
			}
		} else {
			for (let i2 = 0; i2 < numItems; ++i2) {
				normalizedValues.push(items[i2][propertyName] / sum);
			}
		}
		return normalizedValues;
	}
	function invertNormalizedValues(values) {
		if (values.length === 1) {
			return [1];
		}
		const invertedValues = [];
		const numValues = values.length;
		for (let i2 = 0; i2 < numValues; ++i2) {
			invertedValues.push((1 - values[i2]) / (numValues - 1));
		}
		return invertedValues;
	}
	function getTraversalOrder(items, orderBy, descending) {
		items.forEach(assignIndex);
		return items.slice().sort((itemA, itemB) => {
			return descending ? itemB[orderBy] - itemA[orderBy] : itemA[orderBy] - itemB[orderBy];
		}).map(getIndex);
	}
	function assignIndex(item, index) {
		item.index = index;
	}
	function getIndex(item) {
		return item.index;
	}
	function createSumArray(values, order) {
		const sumArray = [];
		sumArray[order[values.length - 1]] = values[order[values.length - 1]];
		for (let i2 = values.length - 2; i2 >= 0; --i2) {
			sumArray[order[i2]] = sumArray[order[i2 + 1]] + values[order[i2]];
		}
		return sumArray;
	}
	return calculateAll;
}
var CALCULATE_FNS = {};
CALCULATE_FNS[ORIENTATION_HORIZONTAL] = createCalculator(ORIENTATION_HORIZONTAL);
CALCULATE_FNS[ORIENTATION_VERTICAL] = createCalculator(ORIENTATION_VERTICAL);
var LayoutCalculator = class {
	calculateLayout(elements, options2) {
		const calculateFn = CALCULATE_FNS[options2.orientation];
		if (!calculateFn) {
			throw new Error(`Unrecognized orientation value: ${options2.orientation}`);
		} else {
			return calculateFn(elements, options2);
		}
	}
};

function getElement(entity) {
	return entity.element;
}
function isEnabledAndHasEnabledElement(entity) {
	return entity.enabled && entity.element && entity.element.enabled;
}
var LayoutGroupComponent = class extends Component {
	_orientation = ORIENTATION_HORIZONTAL;
	_reverseX = false;
	_reverseY = true;
	_alignment = new Vec2(0, 1);
	_padding = new Vec4();
	_spacing = new Vec2();
	_widthFitting = FITTING_NONE;
	_heightFitting = FITTING_NONE;
	_wrap = false;
	_layoutCalculator = new LayoutCalculator();
	constructor(system, entity) {
		super(system, entity);
		this._listenForReflowEvents(this.entity, "on");
		this.entity.children.forEach((child) => {
			this._listenForReflowEvents(child, "on");
		});
		this.entity.on("childinsert", this._onChildInsert, this);
		this.entity.on("childremove", this._onChildRemove, this);
		system.app.systems.element.on("add", this._onElementOrLayoutComponentAdd, this);
		system.app.systems.element.on("beforeremove", this._onElementOrLayoutComponentRemove, this);
		system.app.systems.layoutchild.on("add", this._onElementOrLayoutComponentAdd, this);
		system.app.systems.layoutchild.on("beforeremove", this._onElementOrLayoutComponentRemove, this);
	}
	set orientation(value) {
		if (value !== this._orientation) {
			this._orientation = value;
			this._scheduleReflow();
		}
	}
	get orientation() {
		return this._orientation;
	}
	set reverseX(value) {
		if (value !== this._reverseX) {
			this._reverseX = value;
			this._scheduleReflow();
		}
	}
	get reverseX() {
		return this._reverseX;
	}
	set reverseY(value) {
		if (value !== this._reverseY) {
			this._reverseY = value;
			this._scheduleReflow();
		}
	}
	get reverseY() {
		return this._reverseY;
	}
	set alignment(value) {
		if (!value.equals(this._alignment)) {
			this._alignment.copy(value);
			this._scheduleReflow();
		}
	}
	get alignment() {
		return this._alignment;
	}
	set padding(value) {
		if (!value.equals(this._padding)) {
			this._padding.copy(value);
			this._scheduleReflow();
		}
	}
	get padding() {
		return this._padding;
	}
	set spacing(value) {
		if (!value.equals(this._spacing)) {
			this._spacing.copy(value);
			this._scheduleReflow();
		}
	}
	get spacing() {
		return this._spacing;
	}
	set widthFitting(value) {
		if (value !== this._widthFitting) {
			this._widthFitting = value;
			this._scheduleReflow();
		}
	}
	get widthFitting() {
		return this._widthFitting;
	}
	set heightFitting(value) {
		if (value !== this._heightFitting) {
			this._heightFitting = value;
			this._scheduleReflow();
		}
	}
	get heightFitting() {
		return this._heightFitting;
	}
	set wrap(value) {
		if (value !== this._wrap) {
			this._wrap = value;
			this._scheduleReflow();
		}
	}
	get wrap() {
		return this._wrap;
	}
	_isSelfOrChild(entity) {
		return entity === this.entity || this.entity.children.indexOf(entity) !== -1;
	}
	_listenForReflowEvents(target2, onOff) {
		if (target2.element) {
			target2.element[onOff]("enableelement", this._scheduleReflow, this);
			target2.element[onOff]("disableelement", this._scheduleReflow, this);
			target2.element[onOff]("resize", this._scheduleReflow, this);
			target2.element[onOff]("set:pivot", this._scheduleReflow, this);
		}
		if (target2.layoutchild) {
			target2.layoutchild[onOff]("set_enabled", this._scheduleReflow, this);
			target2.layoutchild[onOff]("resize", this._scheduleReflow, this);
		}
	}
	_onElementOrLayoutComponentAdd(entity) {
		if (this._isSelfOrChild(entity)) {
			this._listenForReflowEvents(entity, "on");
			this._scheduleReflow();
		}
	}
	_onElementOrLayoutComponentRemove(entity) {
		if (this._isSelfOrChild(entity)) {
			this._listenForReflowEvents(entity, "off");
			this._scheduleReflow();
		}
	}
	_onChildInsert(child) {
		this._listenForReflowEvents(child, "on");
		this._scheduleReflow();
	}
	_onChildRemove(child) {
		this._listenForReflowEvents(child, "off");
		this._scheduleReflow();
	}
	_scheduleReflow() {
		if (this.enabled && this.entity && this.entity.enabled && !this._isPerformingReflow) {
			this.system.scheduleReflow(this);
		}
	}
	reflow() {
		const container = getElement(this.entity);
		const elements = this.entity.children.filter(isEnabledAndHasEnabledElement).map(getElement);
		if (!container || elements.length === 0) {
			return;
		}
		const containerWidth = Math.max(container.calculatedWidth, 0);
		const containerHeight = Math.max(container.calculatedHeight, 0);
		const options2 = {
			orientation: this._orientation,
			reverseX: this._reverseX,
			reverseY: this._reverseY,
			alignment: this._alignment,
			padding: this._padding,
			spacing: this._spacing,
			widthFitting: this._widthFitting,
			heightFitting: this._heightFitting,
			wrap: this._wrap,
			containerSize: new Vec2(containerWidth, containerHeight)
		};
		this._isPerformingReflow = true;
		const layoutInfo = this._layoutCalculator.calculateLayout(elements, options2);
		this._isPerformingReflow = false;
		this.fire("reflow", layoutInfo);
	}
	onEnable() {
		this._scheduleReflow();
	}
	onBeforeRemove() {
		this.entity.off("childinsert", this._onChildInsert, this);
		this.entity.off("childremove", this._onChildRemove, this);
		this._listenForReflowEvents(this.entity, "off");
		this.entity.children.forEach((child) => {
			this._listenForReflowEvents(child, "off");
		});
		this.system.app.systems.element.off("add", this._onElementOrLayoutComponentAdd, this);
		this.system.app.systems.element.off("beforeremove", this._onElementOrLayoutComponentRemove, this);
		this.system.app.systems.layoutchild.off("add", this._onElementOrLayoutComponentAdd, this);
		this.system.app.systems.layoutchild.off("beforeremove", this._onElementOrLayoutComponentRemove, this);
	}
};

var MAX_ITERATIONS = 100;
var LayoutGroupComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "layoutgroup";
		this.ComponentType = LayoutGroupComponent;
		this._reflowQueue = [];
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.systems.on("postUpdate", this._onPostUpdate, this);
	}
	initializeComponentData(component, data2, properties) {
		if (data2.enabled !== void 0) component.enabled = data2.enabled;
		if (data2.orientation !== void 0) component.orientation = data2.orientation;
		if (data2.reverseX !== void 0) component.reverseX = data2.reverseX;
		if (data2.reverseY !== void 0) component.reverseY = data2.reverseY;
		if (data2.alignment !== void 0) {
			component.alignment = Array.isArray(data2.alignment) ? new Vec2(data2.alignment) : data2.alignment;
		}
		if (data2.padding !== void 0) {
			component.padding = Array.isArray(data2.padding) ? new Vec4(data2.padding) : data2.padding;
		}
		if (data2.spacing !== void 0) {
			component.spacing = Array.isArray(data2.spacing) ? new Vec2(data2.spacing) : data2.spacing;
		}
		if (data2.widthFitting !== void 0) component.widthFitting = data2.widthFitting;
		if (data2.heightFitting !== void 0) component.heightFitting = data2.heightFitting;
		if (data2.wrap !== void 0) component.wrap = data2.wrap;
		super.initializeComponentData(component, data2, []);
	}
	cloneComponent(entity, clone) {
		const layoutGroup = entity.layoutgroup;
		return this.addComponent(clone, {
			enabled: layoutGroup.enabled,
			orientation: layoutGroup.orientation,
			reverseX: layoutGroup.reverseX,
			reverseY: layoutGroup.reverseY,
			alignment: layoutGroup.alignment,
			padding: layoutGroup.padding,
			spacing: layoutGroup.spacing,
			widthFitting: layoutGroup.widthFitting,
			heightFitting: layoutGroup.heightFitting,
			wrap: layoutGroup.wrap
		});
	}
	scheduleReflow(component) {
		if (this._reflowQueue.indexOf(component) === -1) {
			this._reflowQueue.push(component);
		}
	}
	_onPostUpdate() {
		this._processReflowQueue();
	}
	_processReflowQueue() {
		if (this._reflowQueue.length === 0) {
			return;
		}
		let iterationCount = 0;
		while (this._reflowQueue.length > 0) {
			const queue2 = this._reflowQueue.slice();
			this._reflowQueue.length = 0;
			queue2.sort((componentA, componentB) => {
				return componentA.entity.graphDepth - componentB.entity.graphDepth;
			});
			for (let i2 = 0; i2 < queue2.length; ++i2) {
				queue2[i2].reflow();
			}
			if (++iterationCount >= MAX_ITERATIONS) {
				console.warn("Max reflow iterations limit reached, bailing.");
				break;
			}
		}
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	destroy() {
		super.destroy();
		this.app.systems.off("postUpdate", this._onPostUpdate, this);
	}
};

var PrimitivesCache = class {
	map = /* @__PURE__ */ new Map();
	// destroy all created primitives when the device is destroyed
	destroy(device) {
		this.map.forEach((primData) => primData.mesh.destroy());
	}
};
var _primitivesCache = new DeviceCache();
var getShapePrimitive = (device, type) => {
	const cache = _primitivesCache.get(device, () => {
		return new PrimitivesCache();
	});
	let primData = cache.map.get(type);
	if (!primData) {
		let mesh, area;
		switch (type) {
			case "box":
				mesh = Mesh.fromGeometry(device, new BoxGeometry());
				area = { x: 2, y: 2, z: 2, uv: 2 / 3 };
				break;
			case "capsule":
				mesh = Mesh.fromGeometry(device, new CapsuleGeometry({ radius: 0.5, height: 2 }));
				area = { x: Math.PI * 2, y: Math.PI, z: Math.PI * 2, uv: 1 / 3 + 1 / 3 / 3 * 2 };
				break;
			case "cone":
				mesh = Mesh.fromGeometry(device, new ConeGeometry({ baseRadius: 0.5, peakRadius: 0, height: 1 }));
				area = { x: 2.54, y: 2.54, z: 2.54, uv: 1 / 3 + 1 / 3 / 3 };
				break;
			case "cylinder":
				mesh = Mesh.fromGeometry(device, new CylinderGeometry({ radius: 0.5, height: 1 }));
				area = { x: Math.PI, y: 0.79 * 2, z: Math.PI, uv: 1 / 3 + 1 / 3 / 3 * 2 };
				break;
			case "plane":
				mesh = Mesh.fromGeometry(device, new PlaneGeometry({ halfExtents: new Vec2(0.5, 0.5), widthSegments: 1, lengthSegments: 1 }));
				area = { x: 0, y: 1, z: 0, uv: 1 };
				break;
			case "sphere":
				mesh = Mesh.fromGeometry(device, new SphereGeometry({ radius: 0.5 }));
				area = { x: Math.PI, y: Math.PI, z: Math.PI, uv: 1 };
				break;
			case "torus":
				mesh = Mesh.fromGeometry(device, new TorusGeometry({ tubeRadius: 0.2, ringRadius: 0.3 }));
				area = { x: Math.PI * 0.5 * 0.5 - Math.PI * 0.1 * 0.1, y: 0.4, z: 0.4, uv: 1 };
				break;
			default:
				throw new Error(`Invalid primitive type: ${type}`);
		}
		mesh.incRefCount();
		primData = { mesh, area };
		cache.map.set(type, primData);
	}
	return primData;
};

var ModelComponent = class extends Component {
	_type = "asset";
	_asset = null;
	_model = null;
	_mapping = {};
	_castShadows = true;
	_receiveShadows = true;
	_materialAsset = null;
	_material;
	_castShadowsLightmap = true;
	_lightmapped = false;
	_lightmapSizeMultiplier = 1;
	isStatic = false;
	_layers = [LAYERID_WORLD];
	// assign to the default world layer
	_batchGroupId = -1;
	_customAabb = null;
	_area = null;
	_materialEvents = null;
	_clonedModel = false;
	_evtLayersChanged = null;
	_evtLayerAdded = null;
	_evtLayerRemoved = null;
	constructor(system, entity) {
		super(system, entity);
		this._material = system.defaultMaterial;
		entity.on("remove", this.onRemoveChild, this);
		entity.on("removehierarchy", this.onRemoveChild, this);
		entity.on("insert", this.onInsertChild, this);
		entity.on("inserthierarchy", this.onInsertChild, this);
	}
	set meshInstances(value) {
		if (!this._model) {
			return;
		}
		this._model.meshInstances = value;
	}
	get meshInstances() {
		if (!this._model) {
			return null;
		}
		return this._model.meshInstances;
	}
	set customAabb(value) {
		this._customAabb = value;
		if (this._model) {
			const mi = this._model.meshInstances;
			if (mi) {
				for (let i2 = 0; i2 < mi.length; i2++) {
					mi[i2].setCustomAabb(this._customAabb);
				}
			}
		}
	}
	get customAabb() {
		return this._customAabb;
	}
	set type(value) {
		if (this._type === value) return;
		this._area = null;
		this._type = value;
		if (value === "asset") {
			if (this._asset !== null) {
				this._bindModelAsset(this._asset);
			} else {
				this.model = null;
			}
		} else {
			const primData = getShapePrimitive(this.system.app.graphicsDevice, value);
			this._area = primData.area;
			const mesh = primData.mesh;
			const node = new GraphNode();
			const model = new Model();
			model.graph = node;
			model.meshInstances = [new MeshInstance(mesh, this._material, node)];
			this.model = model;
			this._asset = null;
		}
	}
	get type() {
		return this._type;
	}
	set asset(value) {
		const assets = this.system.app.assets;
		let _id = value;
		if (value instanceof Asset) {
			_id = value.id;
		}
		if (this._asset !== _id) {
			if (this._asset) {
				assets.off(`add:${this._asset}`, this._onModelAssetAdded, this);
				const _prev = assets.get(this._asset);
				if (_prev) {
					this._unbindModelAsset(_prev);
				}
			}
			this._asset = _id;
			if (this._asset) {
				const asset = assets.get(this._asset);
				if (!asset) {
					this.model = null;
					assets.on(`add:${this._asset}`, this._onModelAssetAdded, this);
				} else {
					this._bindModelAsset(asset);
				}
			} else {
				this.model = null;
			}
		}
	}
	get asset() {
		return this._asset;
	}
	set model(value) {
		if (this._model === value) {
			return;
		}
		if (value && value._immutable) {
			return;
		}
		if (this._model) {
			this._model._immutable = false;
			this.removeModelFromLayers();
			this._model.getGraph().destroy();
			delete this._model._entity;
			if (this._clonedModel) {
				this._model.destroy();
				this._clonedModel = false;
			}
		}
		this._model = value;
		if (this._model) {
			this._model._immutable = true;
			const meshInstances = this._model.meshInstances;
			for (let i2 = 0; i2 < meshInstances.length; i2++) {
				meshInstances[i2].castShadow = this._castShadows;
				meshInstances[i2].receiveShadow = this._receiveShadows;
				meshInstances[i2].setCustomAabb(this._customAabb);
			}
			this.lightmapped = this._lightmapped;
			this.entity.addChild(this._model.graph);
			if (this.enabled && this.entity.enabled) {
				this.addModelToLayers();
			}
			this._model._entity = this.entity;
			if (this.entity.animation) {
				this.entity.animation.setModel(this._model);
			}
			if (this.entity.anim) {
				this.entity.anim.rebind();
			}
			if (this.type === "asset") {
				this.mapping = this._mapping;
			} else {
				this._unsetMaterialEvents();
			}
		}
	}
	get model() {
		return this._model;
	}
	set lightmapped(value) {
		if (value !== this._lightmapped) {
			this._lightmapped = value;
			if (this._model) {
				const mi = this._model.meshInstances;
				for (let i2 = 0; i2 < mi.length; i2++) {
					mi[i2].setLightmapped(value);
				}
			}
		}
	}
	get lightmapped() {
		return this._lightmapped;
	}
	set castShadows(value) {
		if (this._castShadows === value) return;
		const model = this._model;
		if (model) {
			const layers = this.layers;
			const scene = this.system.app.scene;
			if (this._castShadows && !value) {
				for (let i2 = 0; i2 < layers.length; i2++) {
					const layer = this.system.app.scene.layers.getLayerById(this.layers[i2]);
					if (!layer) continue;
					layer.removeShadowCasters(model.meshInstances);
				}
			}
			const meshInstances = model.meshInstances;
			for (let i2 = 0; i2 < meshInstances.length; i2++) {
				meshInstances[i2].castShadow = value;
			}
			if (!this._castShadows && value) {
				for (let i2 = 0; i2 < layers.length; i2++) {
					const layer = scene.layers.getLayerById(layers[i2]);
					if (!layer) continue;
					layer.addShadowCasters(model.meshInstances);
				}
			}
		}
		this._castShadows = value;
	}
	get castShadows() {
		return this._castShadows;
	}
	set receiveShadows(value) {
		if (this._receiveShadows === value) return;
		this._receiveShadows = value;
		if (this._model) {
			const meshInstances = this._model.meshInstances;
			for (let i2 = 0, len = meshInstances.length; i2 < len; i2++) {
				meshInstances[i2].receiveShadow = value;
			}
		}
	}
	get receiveShadows() {
		return this._receiveShadows;
	}
	set castShadowsLightmap(value) {
		this._castShadowsLightmap = value;
	}
	get castShadowsLightmap() {
		return this._castShadowsLightmap;
	}
	set lightmapSizeMultiplier(value) {
		this._lightmapSizeMultiplier = value;
	}
	get lightmapSizeMultiplier() {
		return this._lightmapSizeMultiplier;
	}
	set layers(value) {
		const layers = this.system.app.scene.layers;
		if (this.meshInstances) {
			for (let i2 = 0; i2 < this._layers.length; i2++) {
				const layer = layers.getLayerById(this._layers[i2]);
				if (!layer) continue;
				layer.removeMeshInstances(this.meshInstances);
			}
		}
		this._layers.length = 0;
		for (let i2 = 0; i2 < value.length; i2++) {
			this._layers[i2] = value[i2];
		}
		if (!this.enabled || !this.entity.enabled || !this.meshInstances) return;
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = layers.getLayerById(this._layers[i2]);
			if (!layer) continue;
			layer.addMeshInstances(this.meshInstances);
		}
	}
	get layers() {
		return this._layers;
	}
	set batchGroupId(value) {
		if (this._batchGroupId === value) return;
		if (this.entity.enabled && this._batchGroupId >= 0) {
			this.system.app.batcher?.remove(BatchGroup.MODEL, this.batchGroupId, this.entity);
		}
		if (this.entity.enabled && value >= 0) {
			this.system.app.batcher?.insert(BatchGroup.MODEL, value, this.entity);
		}
		if (value < 0 && this._batchGroupId >= 0 && this.enabled && this.entity.enabled) {
			this.addModelToLayers();
		}
		this._batchGroupId = value;
	}
	get batchGroupId() {
		return this._batchGroupId;
	}
	set materialAsset(value) {
		let _id = value;
		if (value instanceof Asset) {
			_id = value.id;
		}
		const assets = this.system.app.assets;
		if (_id !== this._materialAsset) {
			if (this._materialAsset) {
				assets.off(`add:${this._materialAsset}`, this._onMaterialAssetAdd, this);
				const _prev = assets.get(this._materialAsset);
				if (_prev) {
					this._unbindMaterialAsset(_prev);
				}
			}
			this._materialAsset = _id;
			if (this._materialAsset) {
				const asset = assets.get(this._materialAsset);
				if (!asset) {
					this._setMaterial(this.system.defaultMaterial);
					assets.on(`add:${this._materialAsset}`, this._onMaterialAssetAdd, this);
				} else {
					this._bindMaterialAsset(asset);
				}
			} else {
				this._setMaterial(this.system.defaultMaterial);
			}
		}
	}
	get materialAsset() {
		return this._materialAsset;
	}
	set material(value) {
		if (this._material === value) {
			return;
		}
		this.materialAsset = null;
		this._setMaterial(value);
	}
	get material() {
		return this._material;
	}
	set mapping(value) {
		if (this._type !== "asset") {
			return;
		}
		this._unsetMaterialEvents();
		if (!value) {
			value = {};
		}
		this._mapping = value;
		if (!this._model) return;
		const meshInstances = this._model.meshInstances;
		const modelAsset = this.asset ? this.system.app.assets.get(this.asset) : null;
		const assetMapping = modelAsset ? modelAsset.data.mapping : null;
		let asset = null;
		for (let i2 = 0, len = meshInstances.length; i2 < len; i2++) {
			if (value[i2] !== void 0) {
				if (value[i2]) {
					asset = this.system.app.assets.get(value[i2]);
					this._loadAndSetMeshInstanceMaterial(asset, meshInstances[i2], i2);
				} else {
					meshInstances[i2].material = this.system.defaultMaterial;
				}
			} else if (assetMapping) {
				if (assetMapping[i2] && (assetMapping[i2].material || assetMapping[i2].path)) {
					if (assetMapping[i2].material !== void 0) {
						asset = this.system.app.assets.get(assetMapping[i2].material);
					} else if (assetMapping[i2].path !== void 0) {
						const url = this._getMaterialAssetUrl(assetMapping[i2].path);
						if (url) {
							asset = this.system.app.assets.getByUrl(url);
						}
					}
					this._loadAndSetMeshInstanceMaterial(asset, meshInstances[i2], i2);
				} else {
					meshInstances[i2].material = this.system.defaultMaterial;
				}
			}
		}
	}
	get mapping() {
		return this._mapping;
	}
	addModelToLayers() {
		const layers = this.system.app.scene.layers;
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = layers.getLayerById(this._layers[i2]);
			if (layer) {
				layer.addMeshInstances(this.meshInstances);
			}
		}
	}
	removeModelFromLayers() {
		const layers = this.system.app.scene.layers;
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = layers.getLayerById(this._layers[i2]);
			if (!layer) continue;
			layer.removeMeshInstances(this.meshInstances);
		}
	}
	onRemoveChild() {
		if (this._model) {
			this.removeModelFromLayers();
		}
	}
	onInsertChild() {
		if (this._model && this.enabled && this.entity.enabled) {
			this.addModelToLayers();
		}
	}
	onBeforeRemove() {
		this.asset = null;
		this.model = null;
		this.materialAsset = null;
		this._unsetMaterialEvents();
		this.entity.off("remove", this.onRemoveChild, this);
		this.entity.off("insert", this.onInsertChild, this);
	}
	onLayersChanged(oldComp, newComp) {
		this.addModelToLayers();
		oldComp.off("add", this.onLayerAdded, this);
		oldComp.off("remove", this.onLayerRemoved, this);
		newComp.on("add", this.onLayerAdded, this);
		newComp.on("remove", this.onLayerRemoved, this);
	}
	onLayerAdded(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		layer.addMeshInstances(this.meshInstances);
	}
	onLayerRemoved(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		layer.removeMeshInstances(this.meshInstances);
	}
	_setMaterialEvent(index, event, id14, handler) {
		const evt = `${event}:${id14}`;
		this.system.app.assets.on(evt, handler, this);
		if (!this._materialEvents) {
			this._materialEvents = [];
		}
		if (!this._materialEvents[index]) {
			this._materialEvents[index] = {};
		}
		this._materialEvents[index][evt] = {
			id: id14,
			handler
		};
	}
	_unsetMaterialEvents() {
		const assets = this.system.app.assets;
		const events = this._materialEvents;
		if (!events) {
			return;
		}
		for (let i2 = 0, len = events.length; i2 < len; i2++) {
			if (!events[i2]) continue;
			const evt = events[i2];
			for (const key in evt) {
				assets.off(key, evt[key].handler, this);
			}
		}
		this._materialEvents = null;
	}
	_getAssetByIdOrPath(idOrPath) {
		let asset = null;
		const isPath = isNaN(parseInt(idOrPath, 10));
		if (!isPath) {
			asset = this.system.app.assets.get(idOrPath);
		} else if (this.asset) {
			const url = this._getMaterialAssetUrl(idOrPath);
			if (url) {
				asset = this.system.app.assets.getByUrl(url);
			}
		}
		return asset;
	}
	_getMaterialAssetUrl(path2) {
		if (!this.asset) return null;
		const modelAsset = this.system.app.assets.get(this.asset);
		return modelAsset ? modelAsset.getAbsoluteUrl(path2) : null;
	}
	_loadAndSetMeshInstanceMaterial(materialAsset, meshInstance, index) {
		const assets = this.system.app.assets;
		if (!materialAsset) {
			return;
		}
		if (materialAsset.resource) {
			meshInstance.material = materialAsset.resource;
			this._setMaterialEvent(index, "remove", materialAsset.id, function() {
				meshInstance.material = this.system.defaultMaterial;
			});
		} else {
			this._setMaterialEvent(index, "load", materialAsset.id, function(asset) {
				meshInstance.material = asset.resource;
				this._setMaterialEvent(index, "remove", materialAsset.id, function() {
					meshInstance.material = this.system.defaultMaterial;
				});
			});
			if (this.enabled && this.entity.enabled) {
				assets.load(materialAsset);
			}
		}
	}
	onEnable() {
		const app2 = this.system.app;
		const scene = app2.scene;
		const layers = scene?.layers;
		this._evtLayersChanged = scene.on("set:layers", this.onLayersChanged, this);
		if (layers) {
			this._evtLayerAdded = layers.on("add", this.onLayerAdded, this);
			this._evtLayerRemoved = layers.on("remove", this.onLayerRemoved, this);
		}
		const isAsset = this._type === "asset";
		let asset;
		if (this._model) {
			this.addModelToLayers();
		} else if (isAsset && this._asset) {
			asset = app2.assets.get(this._asset);
			if (asset && asset.resource !== this._model) {
				this._bindModelAsset(asset);
			}
		}
		if (this._materialAsset) {
			asset = app2.assets.get(this._materialAsset);
			if (asset && asset.resource !== this._material) {
				this._bindMaterialAsset(asset);
			}
		}
		if (isAsset) {
			if (this._mapping) {
				for (const index in this._mapping) {
					if (this._mapping[index]) {
						asset = this._getAssetByIdOrPath(this._mapping[index]);
						if (asset && !asset.resource) {
							app2.assets.load(asset);
						}
					}
				}
			}
		}
		if (this._batchGroupId >= 0) {
			app2.batcher?.insert(BatchGroup.MODEL, this.batchGroupId, this.entity);
		}
	}
	onDisable() {
		const app2 = this.system.app;
		const scene = app2.scene;
		const layers = scene.layers;
		this._evtLayersChanged?.off();
		this._evtLayersChanged = null;
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = null;
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = null;
		}
		if (this._batchGroupId >= 0) {
			app2.batcher?.remove(BatchGroup.MODEL, this.batchGroupId, this.entity);
		}
		if (this._model) {
			this.removeModelFromLayers();
		}
	}
	hide() {
		if (this._model) {
			const instances = this._model.meshInstances;
			for (let i2 = 0, l = instances.length; i2 < l; i2++) {
				instances[i2].visible = false;
			}
		}
	}
	show() {
		if (this._model) {
			const instances = this._model.meshInstances;
			for (let i2 = 0, l = instances.length; i2 < l; i2++) {
				instances[i2].visible = true;
			}
		}
	}
	_bindMaterialAsset(asset) {
		asset.on("load", this._onMaterialAssetLoad, this);
		asset.on("unload", this._onMaterialAssetUnload, this);
		asset.on("remove", this._onMaterialAssetRemove, this);
		asset.on("change", this._onMaterialAssetChange, this);
		if (asset.resource) {
			this._onMaterialAssetLoad(asset);
		} else {
			if (!this.enabled || !this.entity.enabled) return;
			this.system.app.assets.load(asset);
		}
	}
	_unbindMaterialAsset(asset) {
		asset.off("load", this._onMaterialAssetLoad, this);
		asset.off("unload", this._onMaterialAssetUnload, this);
		asset.off("remove", this._onMaterialAssetRemove, this);
		asset.off("change", this._onMaterialAssetChange, this);
	}
	_onMaterialAssetAdd(asset) {
		this.system.app.assets.off(`add:${asset.id}`, this._onMaterialAssetAdd, this);
		if (this._materialAsset === asset.id) {
			this._bindMaterialAsset(asset);
		}
	}
	_onMaterialAssetLoad(asset) {
		this._setMaterial(asset.resource);
	}
	_onMaterialAssetUnload(asset) {
		this._setMaterial(this.system.defaultMaterial);
	}
	_onMaterialAssetRemove(asset) {
		this._onMaterialAssetUnload(asset);
	}
	_onMaterialAssetChange(asset) {
	}
	_bindModelAsset(asset) {
		this._unbindModelAsset(asset);
		asset.on("load", this._onModelAssetLoad, this);
		asset.on("unload", this._onModelAssetUnload, this);
		asset.on("change", this._onModelAssetChange, this);
		asset.on("remove", this._onModelAssetRemove, this);
		if (asset.resource) {
			this._onModelAssetLoad(asset);
		} else {
			if (!this.enabled || !this.entity.enabled) return;
			this.system.app.assets.load(asset);
		}
	}
	_unbindModelAsset(asset) {
		asset.off("load", this._onModelAssetLoad, this);
		asset.off("unload", this._onModelAssetUnload, this);
		asset.off("change", this._onModelAssetChange, this);
		asset.off("remove", this._onModelAssetRemove, this);
	}
	_onModelAssetAdded(asset) {
		this.system.app.assets.off(`add:${asset.id}`, this._onModelAssetAdded, this);
		if (asset.id === this._asset) {
			this._bindModelAsset(asset);
		}
	}
	_onModelAssetLoad(asset) {
		this.model = asset.resource.clone();
		this._clonedModel = true;
	}
	_onModelAssetUnload(asset) {
		this.model = null;
	}
	_onModelAssetChange(asset, attr, _new, _old) {
		if (attr === "data") {
			this.mapping = this._mapping;
		}
	}
	_onModelAssetRemove(asset) {
		this.model = null;
	}
	_setMaterial(material) {
		if (this._material === material) {
			return;
		}
		this._material = material;
		const model = this._model;
		if (model && this._type !== "asset") {
			const meshInstances = model.meshInstances;
			for (let i2 = 0, len = meshInstances.length; i2 < len; i2++) {
				meshInstances[i2].material = material;
			}
		}
	}
};

var _properties5 = [
	"material",
	"materialAsset",
	"asset",
	"castShadows",
	"receiveShadows",
	"castShadowsLightmap",
	"lightmapped",
	"lightmapSizeMultiplier",
	"type",
	"mapping",
	"layers",
	"isStatic",
	"batchGroupId"
];
var ModelComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "model";
		this.ComponentType = ModelComponent;
		this.extraDataProperties = ["aabbCenter", "aabbHalfExtents"];
		this.defaultMaterial = getDefaultMaterial(app2.graphicsDevice);
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	initializeComponentData(component, _data) {
		if (_data.batchGroupId === null || _data.batchGroupId === void 0) {
			_data.batchGroupId = -1;
		}
		if (_data.layers && _data.layers.length) {
			_data.layers = _data.layers.slice(0);
		}
		for (let i2 = 0; i2 < _properties5.length; i2++) {
			if (_data.hasOwnProperty(_properties5[i2])) {
				component[_properties5[i2]] = _data[_properties5[i2]];
			}
		}
		if (_data.aabbCenter && _data.aabbHalfExtents) {
			component.customAabb = new BoundingBox(new Vec3(_data.aabbCenter), new Vec3(_data.aabbHalfExtents));
		}
		super.initializeComponentData(component, _data);
	}
	cloneComponent(entity, clone) {
		const data2 = {
			enabled: entity.model.enabled
		};
		for (let i2 = 0; i2 < _properties5.length; i2++) {
			const property = _properties5[i2];
			switch (property) {
				// material and materialAsset are handled below, after the
				// appropriate one to clone has been determined
				case "material":
				case "materialAsset":
					break;
				case "mapping":
					data2.mapping = extend({}, entity.model.mapping);
					break;
				default:
					data2[property] = entity.model[property];
					break;
			}
		}
		let materialAsset = entity.model.materialAsset;
		if (!(materialAsset instanceof Asset) && materialAsset != null) {
			materialAsset = this.app.assets.get(materialAsset);
		}
		const material = entity.model.material;
		if (!material || material === this.defaultMaterial || !materialAsset || material === materialAsset.resource) {
			data2.materialAsset = materialAsset;
		}
		const component = this.addComponent(clone, data2);
		if (entity.model.model && entity.model.type === "asset" && !entity.model.asset) {
			component.model = entity.model.model.clone();
			component._clonedModel = true;
		}
		if (!data2.materialAsset) {
			component.material = material;
		}
		if (entity.model.model) {
			const meshInstances = entity.model.model.meshInstances;
			const meshInstancesClone = component.model.meshInstances;
			for (let i2 = 0; i2 < meshInstances.length; i2++) {
				meshInstancesClone[i2].mask = meshInstances[i2].mask;
				meshInstancesClone[i2].material = meshInstances[i2].material;
				meshInstancesClone[i2].layer = meshInstances[i2].layer;
				meshInstancesClone[i2].receiveShadow = meshInstances[i2].receiveShadow;
			}
		}
		if (entity.model.customAabb) {
			component.customAabb = entity.model.customAabb.clone();
		}
		return component;
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
};

var ASSET_PROPERTIES = ["colorMapAsset", "normalMapAsset", "meshAsset", "renderAsset"];
var _properties6 = [
	"autoPlay",
	"numParticles",
	"lifetime",
	"rate",
	"rate2",
	"startAngle",
	"startAngle2",
	"loop",
	"preWarm",
	"lighting",
	"halfLambert",
	"intensity",
	"depthWrite",
	"noFog",
	"depthSoftening",
	"sort",
	"blendType",
	"stretch",
	"alignToMotion",
	"emitterShape",
	"emitterExtents",
	"emitterExtentsInner",
	"emitterRadius",
	"emitterRadiusInner",
	"initialVelocity",
	"wrap",
	"wrapBounds",
	"localSpace",
	"screenSpace",
	"colorMapAsset",
	"normalMapAsset",
	"mesh",
	"meshAsset",
	"renderAsset",
	"orientation",
	"particleNormal",
	"localVelocityGraph",
	"localVelocityGraph2",
	"velocityGraph",
	"velocityGraph2",
	"rotationSpeedGraph",
	"rotationSpeedGraph2",
	"radialSpeedGraph",
	"radialSpeedGraph2",
	"scaleGraph",
	"scaleGraph2",
	"colorGraph",
	"colorGraph2",
	"alphaGraph",
	"alphaGraph2",
	"colorMap",
	"normalMap",
	"animTilesX",
	"animTilesY",
	"animStartFrame",
	"animNumFrames",
	"animNumAnimations",
	"animIndex",
	"randomizeAnimIndex",
	"animSpeed",
	"animLoop",
	"layers"
];
var depthLayer;
var ParticleSystemComponent = class extends Component {
	emitter = null;
	_requestedDepth = false;
	_drawOrder = 0;
	_paused = false;
	_evtLayersChanged = null;
	_evtLayerAdded = null;
	_evtLayerRemoved = null;
	_evtSetMeshes = null;
	_autoPlay = true;
	_numParticles = 1;
	_lifetime = 50;
	_rate = 1;
	_rate2 = null;
	_startAngle = 0;
	_startAngle2 = null;
	_loop = true;
	_preWarm = false;
	_lighting = false;
	_halfLambert = false;
	_intensity = 1;
	_depthWrite = false;
	_noFog = false;
	_depthSoftening = 0;
	_sort = 0;
	_blendType = BLEND_NORMAL;
	_stretch = 0;
	_alignToMotion = false;
	_emitterShape = EMITTERSHAPE_BOX;
	_emitterExtents = new Vec3();
	_emitterExtentsInner = new Vec3();
	_emitterRadius = 0;
	_emitterRadiusInner = 0;
	_initialVelocity = 0;
	_wrap = false;
	_wrapBounds = new Vec3();
	_localSpace = false;
	_screenSpace = false;
	_colorMapAsset = null;
	_normalMapAsset = null;
	_mesh = null;
	_meshAsset = null;
	_renderAsset = null;
	_orientation = PARTICLEORIENTATION_SCREEN;
	_particleNormal = new Vec3(0, 1, 0);
	_localVelocityGraph = null;
	_localVelocityGraph2 = null;
	_velocityGraph = null;
	_velocityGraph2 = null;
	_rotationSpeedGraph = null;
	_rotationSpeedGraph2 = null;
	_radialSpeedGraph = null;
	_radialSpeedGraph2 = null;
	_scaleGraph = null;
	_scaleGraph2 = null;
	_colorGraph = null;
	_colorGraph2 = null;
	_alphaGraph = null;
	_alphaGraph2 = null;
	_colorMap = null;
	_normalMap = null;
	_animTilesX = 1;
	_animTilesY = 1;
	_animStartFrame = 0;
	_animNumFrames = 1;
	_animNumAnimations = 1;
	_animIndex = 0;
	_randomizeAnimIndex = false;
	_animSpeed = 1;
	_animLoop = true;
	_layers = [LAYERID_WORLD];
	set autoPlay(arg) {
		this._autoPlay = arg;
	}
	get autoPlay() {
		return this._autoPlay;
	}
	set numParticles(arg) {
		this._setComplexProperty("numParticles", arg);
	}
	get numParticles() {
		return this._numParticles;
	}
	set lifetime(arg) {
		this._setComplexProperty("lifetime", arg);
	}
	get lifetime() {
		return this._lifetime;
	}
	set rate(arg) {
		this._setComplexProperty("rate", arg);
	}
	get rate() {
		return this._rate;
	}
	set rate2(arg) {
		this._setComplexProperty("rate2", arg);
	}
	get rate2() {
		return this._rate2;
	}
	set startAngle(arg) {
		this._setComplexProperty("startAngle", arg);
	}
	get startAngle() {
		return this._startAngle;
	}
	set startAngle2(arg) {
		this._setComplexProperty("startAngle2", arg);
	}
	get startAngle2() {
		return this._startAngle2;
	}
	set loop(arg) {
		this._loop = arg;
		if (this.emitter) {
			this.emitter.loop = arg;
			this.emitter.resetTime(arg ? void 0 : this.emitter.lifetime);
			this.emitter.resetMaterial();
		}
	}
	get loop() {
		return this._loop;
	}
	set preWarm(arg) {
		this._setComplexProperty("preWarm", arg);
	}
	get preWarm() {
		return this._preWarm;
	}
	set lighting(arg) {
		this._setComplexProperty("lighting", arg);
	}
	get lighting() {
		return this._lighting;
	}
	set halfLambert(arg) {
		this._setComplexProperty("halfLambert", arg);
	}
	get halfLambert() {
		return this._halfLambert;
	}
	set intensity(arg) {
		this._setComplexProperty("intensity", arg);
	}
	get intensity() {
		return this._intensity;
	}
	set depthWrite(arg) {
		this._setComplexProperty("depthWrite", arg);
	}
	get depthWrite() {
		return this._depthWrite;
	}
	set noFog(arg) {
		this._setComplexProperty("noFog", arg);
	}
	get noFog() {
		return this._noFog;
	}
	set depthSoftening(arg) {
		const oldValue = this._depthSoftening;
		if (oldValue !== arg) {
			this._depthSoftening = arg;
			if (arg) {
				if (this.enabled && this.entity.enabled) this._requestDepth();
			} else {
				if (this.enabled && this.entity.enabled) this._releaseDepth();
			}
			if (this.emitter) {
				this.emitter.depthSoftening = arg;
				this.reset();
				this.emitter.resetMaterial();
				this.rebuild();
			}
		}
	}
	get depthSoftening() {
		return this._depthSoftening;
	}
	set sort(arg) {
		this._setComplexProperty("sort", arg);
	}
	get sort() {
		return this._sort;
	}
	set blendType(arg) {
		this._blendType = arg;
		if (this.emitter) {
			this.emitter.blendType = arg;
			this.emitter.material.blendType = arg;
			this.emitter.resetMaterial();
			this.rebuild();
		}
	}
	get blendType() {
		return this._blendType;
	}
	set stretch(arg) {
		this._setComplexProperty("stretch", arg);
	}
	get stretch() {
		return this._stretch;
	}
	set alignToMotion(arg) {
		this._setComplexProperty("alignToMotion", arg);
	}
	get alignToMotion() {
		return this._alignToMotion;
	}
	set emitterShape(arg) {
		this._setComplexProperty("emitterShape", arg);
	}
	get emitterShape() {
		return this._emitterShape;
	}
	set emitterExtents(arg) {
		this._setSimpleProperty("emitterExtents", arg);
	}
	get emitterExtents() {
		return this._emitterExtents;
	}
	set emitterExtentsInner(arg) {
		this._setSimpleProperty("emitterExtentsInner", arg);
	}
	get emitterExtentsInner() {
		return this._emitterExtentsInner;
	}
	set emitterRadius(arg) {
		this._setSimpleProperty("emitterRadius", arg);
	}
	get emitterRadius() {
		return this._emitterRadius;
	}
	set emitterRadiusInner(arg) {
		this._setSimpleProperty("emitterRadiusInner", arg);
	}
	get emitterRadiusInner() {
		return this._emitterRadiusInner;
	}
	set initialVelocity(arg) {
		this._setSimpleProperty("initialVelocity", arg);
	}
	get initialVelocity() {
		return this._initialVelocity;
	}
	set wrap(arg) {
		this._setComplexProperty("wrap", arg);
	}
	get wrap() {
		return this._wrap;
	}
	set wrapBounds(arg) {
		this._setComplexProperty("wrapBounds", arg);
	}
	get wrapBounds() {
		return this._wrapBounds;
	}
	set localSpace(arg) {
		this._setComplexProperty("localSpace", arg);
	}
	get localSpace() {
		return this._localSpace;
	}
	set screenSpace(arg) {
		this._setComplexProperty("screenSpace", arg);
	}
	get screenSpace() {
		return this._screenSpace;
	}
	set colorMapAsset(arg) {
		const assets = this.system.app.assets;
		if (this._colorMapAsset) {
			const asset = assets.get(this._colorMapAsset);
			if (asset) {
				this._unbindColorMapAsset(asset);
			}
		}
		if (arg instanceof Asset) {
			arg = arg.id;
		}
		this._colorMapAsset = arg;
		if (arg) {
			const asset = assets.get(arg);
			if (asset) {
				this._bindColorMapAsset(asset);
			} else {
				assets.once(`add:${arg}`, (asset2) => {
					this._bindColorMapAsset(asset2);
				});
			}
		} else {
			this.colorMap = null;
		}
	}
	get colorMapAsset() {
		return this._colorMapAsset;
	}
	set normalMapAsset(arg) {
		const assets = this.system.app.assets;
		if (this._normalMapAsset) {
			const asset = assets.get(this._normalMapAsset);
			if (asset) {
				this._unbindNormalMapAsset(asset);
			}
		}
		if (arg instanceof Asset) {
			arg = arg.id;
		}
		this._normalMapAsset = arg;
		if (arg) {
			const asset = assets.get(arg);
			if (asset) {
				this._bindNormalMapAsset(asset);
			} else {
				assets.once(`add:${arg}`, (asset2) => {
					this._bindNormalMapAsset(asset2);
				});
			}
		} else {
			this.normalMap = null;
		}
	}
	get normalMapAsset() {
		return this._normalMapAsset;
	}
	set mesh(arg) {
		if (!arg || arg instanceof Asset || typeof arg === "number") {
			this.meshAsset = arg;
		} else {
			this._onMeshChanged(arg);
		}
	}
	get mesh() {
		return this._mesh;
	}
	set meshAsset(arg) {
		const assets = this.system.app.assets;
		if (this._meshAsset) {
			const asset = assets.get(this._meshAsset);
			if (asset) {
				this._unbindMeshAsset(asset);
			}
		}
		if (arg instanceof Asset) {
			arg = arg.id;
		}
		this._meshAsset = arg;
		if (arg) {
			const asset = assets.get(arg);
			if (asset) {
				this._bindMeshAsset(asset);
			}
		} else {
			this._onMeshChanged(null);
		}
	}
	get meshAsset() {
		return this._meshAsset;
	}
	set renderAsset(arg) {
		const assets = this.system.app.assets;
		if (this._renderAsset) {
			const asset = assets.get(this._renderAsset);
			if (asset) {
				this._unbindRenderAsset(asset);
			}
		}
		if (arg instanceof Asset) {
			arg = arg.id;
		}
		this._renderAsset = arg;
		if (arg) {
			const asset = assets.get(arg);
			if (asset) {
				this._bindRenderAsset(asset);
			}
		} else {
			this._onRenderChanged(null);
		}
	}
	get renderAsset() {
		return this._renderAsset;
	}
	set orientation(arg) {
		this._setComplexProperty("orientation", arg);
	}
	get orientation() {
		return this._orientation;
	}
	set particleNormal(arg) {
		this._setSimpleProperty("particleNormal", arg);
	}
	get particleNormal() {
		return this._particleNormal;
	}
	set localVelocityGraph(arg) {
		this._setGraphProperty("localVelocityGraph", arg);
	}
	get localVelocityGraph() {
		return this._localVelocityGraph;
	}
	set localVelocityGraph2(arg) {
		this._setGraphProperty("localVelocityGraph2", arg);
	}
	get localVelocityGraph2() {
		return this._localVelocityGraph2;
	}
	set velocityGraph(arg) {
		this._setGraphProperty("velocityGraph", arg);
	}
	get velocityGraph() {
		return this._velocityGraph;
	}
	set velocityGraph2(arg) {
		this._setGraphProperty("velocityGraph2", arg);
	}
	get velocityGraph2() {
		return this._velocityGraph2;
	}
	set rotationSpeedGraph(arg) {
		this._setGraphProperty("rotationSpeedGraph", arg);
	}
	get rotationSpeedGraph() {
		return this._rotationSpeedGraph;
	}
	set rotationSpeedGraph2(arg) {
		this._setGraphProperty("rotationSpeedGraph2", arg);
	}
	get rotationSpeedGraph2() {
		return this._rotationSpeedGraph2;
	}
	set radialSpeedGraph(arg) {
		this._setGraphProperty("radialSpeedGraph", arg);
	}
	get radialSpeedGraph() {
		return this._radialSpeedGraph;
	}
	set radialSpeedGraph2(arg) {
		this._setGraphProperty("radialSpeedGraph2", arg);
	}
	get radialSpeedGraph2() {
		return this._radialSpeedGraph2;
	}
	set scaleGraph(arg) {
		this._setGraphProperty("scaleGraph", arg);
	}
	get scaleGraph() {
		return this._scaleGraph;
	}
	set scaleGraph2(arg) {
		this._setGraphProperty("scaleGraph2", arg);
	}
	get scaleGraph2() {
		return this._scaleGraph2;
	}
	set colorGraph(arg) {
		this._setGraphProperty("colorGraph", arg);
	}
	get colorGraph() {
		return this._colorGraph;
	}
	set colorGraph2(arg) {
		this._setGraphProperty("colorGraph2", arg);
	}
	get colorGraph2() {
		return this._colorGraph2;
	}
	set alphaGraph(arg) {
		this._setGraphProperty("alphaGraph", arg);
	}
	get alphaGraph() {
		return this._alphaGraph;
	}
	set alphaGraph2(arg) {
		this._setGraphProperty("alphaGraph2", arg);
	}
	get alphaGraph2() {
		return this._alphaGraph2;
	}
	set colorMap(arg) {
		this._setComplexProperty("colorMap", arg);
	}
	get colorMap() {
		return this._colorMap;
	}
	set normalMap(arg) {
		this._setSimpleProperty("normalMap", arg);
	}
	get normalMap() {
		return this._normalMap;
	}
	set animTilesX(arg) {
		this._setComplexProperty("animTilesX", arg);
	}
	get animTilesX() {
		return this._animTilesX;
	}
	set animTilesY(arg) {
		this._setComplexProperty("animTilesY", arg);
	}
	get animTilesY() {
		return this._animTilesY;
	}
	set animStartFrame(arg) {
		this._setComplexProperty("animStartFrame", arg);
	}
	get animStartFrame() {
		return this._animStartFrame;
	}
	set animNumFrames(arg) {
		this._setComplexProperty("animNumFrames", arg);
	}
	get animNumFrames() {
		return this._animNumFrames;
	}
	set animNumAnimations(arg) {
		this._setComplexProperty("animNumAnimations", arg);
	}
	get animNumAnimations() {
		return this._animNumAnimations;
	}
	set animIndex(arg) {
		this._setComplexProperty("animIndex", arg);
	}
	get animIndex() {
		return this._animIndex;
	}
	set randomizeAnimIndex(arg) {
		this._setComplexProperty("randomizeAnimIndex", arg);
	}
	get randomizeAnimIndex() {
		return this._randomizeAnimIndex;
	}
	set animSpeed(arg) {
		this._setSimpleProperty("animSpeed", arg);
	}
	get animSpeed() {
		return this._animSpeed;
	}
	set animLoop(arg) {
		this._setComplexProperty("animLoop", arg);
	}
	get animLoop() {
		return this._animLoop;
	}
	set layers(arg) {
		const oldLayers = this._layers;
		this._layers = arg;
		if (!this.emitter) return;
		for (let i2 = 0; i2 < oldLayers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(oldLayers[i2]);
			if (!layer) continue;
			layer.removeMeshInstances([this.emitter.meshInstance]);
		}
		if (!this.enabled || !this.entity.enabled) return;
		for (let i2 = 0; i2 < arg.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(arg[i2]);
			if (!layer) continue;
			layer.addMeshInstances([this.emitter.meshInstance]);
		}
	}
	get layers() {
		return this._layers;
	}
	set drawOrder(drawOrder) {
		this._drawOrder = drawOrder;
		if (this.emitter) {
			this.emitter.drawOrder = drawOrder;
		}
	}
	get drawOrder() {
		return this._drawOrder;
	}
	_setSimpleProperty(name, arg) {
		this[`_${name}`] = arg;
		if (this.emitter) {
			this.emitter[name] = arg;
			this.emitter.resetMaterial();
		}
	}
	_setComplexProperty(name, arg) {
		this[`_${name}`] = arg;
		if (this.emitter) {
			this.emitter[name] = arg;
			this.emitter.resetMaterial();
			this.rebuild();
			this.reset();
		}
	}
	_setGraphProperty(name, arg) {
		this[`_${name}`] = arg;
		if (this.emitter) {
			this.emitter[name] = arg;
			this.emitter.rebuildGraphs();
			this.emitter.resetMaterial();
		}
	}
	addMeshInstanceToLayers() {
		if (!this.emitter) return;
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(this._layers[i2]);
			if (!layer) continue;
			layer.addMeshInstances([this.emitter.meshInstance]);
			this.emitter._layer = layer;
		}
	}
	removeMeshInstanceFromLayers() {
		if (!this.emitter) return;
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(this._layers[i2]);
			if (!layer) continue;
			layer.removeMeshInstances([this.emitter.meshInstance]);
		}
	}
	onLayersChanged(oldComp, newComp) {
		this.addMeshInstanceToLayers();
		oldComp.off("add", this.onLayerAdded, this);
		oldComp.off("remove", this.onLayerRemoved, this);
		newComp.on("add", this.onLayerAdded, this);
		newComp.on("remove", this.onLayerRemoved, this);
	}
	onLayerAdded(layer) {
		if (!this.emitter) return;
		const index = this._layers.indexOf(layer.id);
		if (index < 0) return;
		layer.addMeshInstances([this.emitter.meshInstance]);
	}
	onLayerRemoved(layer) {
		if (!this.emitter) return;
		const index = this._layers.indexOf(layer.id);
		if (index < 0) return;
		layer.removeMeshInstances([this.emitter.meshInstance]);
	}
	_bindColorMapAsset(asset) {
		asset.on("load", this._onColorMapAssetLoad, this);
		asset.on("unload", this._onColorMapAssetUnload, this);
		asset.on("remove", this._onColorMapAssetRemove, this);
		asset.on("change", this._onColorMapAssetChange, this);
		if (asset.resource) {
			this._onColorMapAssetLoad(asset);
		} else {
			if (!this.enabled || !this.entity.enabled) return;
			this.system.app.assets.load(asset);
		}
	}
	_unbindColorMapAsset(asset) {
		asset.off("load", this._onColorMapAssetLoad, this);
		asset.off("unload", this._onColorMapAssetUnload, this);
		asset.off("remove", this._onColorMapAssetRemove, this);
		asset.off("change", this._onColorMapAssetChange, this);
	}
	_onColorMapAssetLoad(asset) {
		this.colorMap = asset.resource;
	}
	_onColorMapAssetUnload(asset) {
		this.colorMap = null;
	}
	_onColorMapAssetRemove(asset) {
		this._onColorMapAssetUnload(asset);
	}
	_onColorMapAssetChange(asset) {
	}
	_bindNormalMapAsset(asset) {
		asset.on("load", this._onNormalMapAssetLoad, this);
		asset.on("unload", this._onNormalMapAssetUnload, this);
		asset.on("remove", this._onNormalMapAssetRemove, this);
		asset.on("change", this._onNormalMapAssetChange, this);
		if (asset.resource) {
			this._onNormalMapAssetLoad(asset);
		} else {
			if (!this.enabled || !this.entity.enabled) return;
			this.system.app.assets.load(asset);
		}
	}
	_unbindNormalMapAsset(asset) {
		asset.off("load", this._onNormalMapAssetLoad, this);
		asset.off("unload", this._onNormalMapAssetUnload, this);
		asset.off("remove", this._onNormalMapAssetRemove, this);
		asset.off("change", this._onNormalMapAssetChange, this);
	}
	_onNormalMapAssetLoad(asset) {
		this.normalMap = asset.resource;
	}
	_onNormalMapAssetUnload(asset) {
		this.normalMap = null;
	}
	_onNormalMapAssetRemove(asset) {
		this._onNormalMapAssetUnload(asset);
	}
	_onNormalMapAssetChange(asset) {
	}
	_bindMeshAsset(asset) {
		asset.on("load", this._onMeshAssetLoad, this);
		asset.on("unload", this._onMeshAssetUnload, this);
		asset.on("remove", this._onMeshAssetRemove, this);
		asset.on("change", this._onMeshAssetChange, this);
		if (asset.resource) {
			this._onMeshAssetLoad(asset);
		} else {
			if (!this.enabled || !this.entity.enabled) return;
			this.system.app.assets.load(asset);
		}
	}
	_unbindMeshAsset(asset) {
		asset.off("load", this._onMeshAssetLoad, this);
		asset.off("unload", this._onMeshAssetUnload, this);
		asset.off("remove", this._onMeshAssetRemove, this);
		asset.off("change", this._onMeshAssetChange, this);
	}
	_onMeshAssetLoad(asset) {
		this._onMeshChanged(asset.resource);
	}
	_onMeshAssetUnload(asset) {
		this.mesh = null;
	}
	_onMeshAssetRemove(asset) {
		this._onMeshAssetUnload(asset);
	}
	_onMeshAssetChange(asset) {
	}
	_onMeshChanged(mesh) {
		if (mesh && !(mesh instanceof Mesh)) {
			if (mesh.meshInstances[0]) {
				mesh = mesh.meshInstances[0].mesh;
			} else {
				mesh = null;
			}
		}
		this._mesh = mesh;
		if (this.emitter) {
			this.emitter.mesh = mesh;
			this.emitter.resetMaterial();
			this.rebuild();
		}
	}
	_bindRenderAsset(asset) {
		asset.on("load", this._onRenderAssetLoad, this);
		asset.on("unload", this._onRenderAssetUnload, this);
		asset.on("remove", this._onRenderAssetRemove, this);
		if (asset.resource) {
			this._onRenderAssetLoad(asset);
		} else {
			if (!this.enabled || !this.entity.enabled) return;
			this.system.app.assets.load(asset);
		}
	}
	_unbindRenderAsset(asset) {
		asset.off("load", this._onRenderAssetLoad, this);
		asset.off("unload", this._onRenderAssetUnload, this);
		asset.off("remove", this._onRenderAssetRemove, this);
		this._evtSetMeshes?.off();
		this._evtSetMeshes = null;
	}
	_onRenderAssetLoad(asset) {
		this._onRenderChanged(asset.resource);
	}
	_onRenderAssetUnload(asset) {
		this._onRenderChanged(null);
	}
	_onRenderAssetRemove(asset) {
		this._onRenderAssetUnload(asset);
	}
	_onRenderChanged(render) {
		if (!render) {
			this._onMeshChanged(null);
			return;
		}
		this._evtSetMeshes?.off();
		this._evtSetMeshes = render.on("set:meshes", this._onRenderSetMeshes, this);
		if (render.meshes) {
			this._onRenderSetMeshes(render.meshes);
		}
	}
	_onRenderSetMeshes(meshes) {
		this._onMeshChanged(meshes && meshes[0]);
	}
	_requestDepth() {
		if (this._requestedDepth) return;
		if (!depthLayer) depthLayer = this.system.app.scene.layers.getLayerById(LAYERID_DEPTH);
		if (depthLayer) {
			depthLayer.incrementCounter();
			this._requestedDepth = true;
		}
	}
	_releaseDepth() {
		if (!this._requestedDepth) return;
		if (depthLayer) {
			depthLayer.decrementCounter();
			this._requestedDepth = false;
		}
	}
	onEnable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		for (let i2 = 0, len = ASSET_PROPERTIES.length; i2 < len; i2++) {
			let asset = this[`_${ASSET_PROPERTIES[i2]}`];
			if (asset) {
				if (!(asset instanceof Asset)) {
					const id14 = parseInt(asset, 10);
					if (id14 >= 0) {
						asset = this.system.app.assets.get(asset);
					} else {
						continue;
					}
				}
				if (asset && !asset.resource) {
					this.system.app.assets.load(asset);
				}
			}
		}
		if (this.system.app.graphicsDevice.disableParticleSystem) {
			return;
		}
		if (!this.emitter) {
			this.emitter = new ParticleEmitter(this.system.app.graphicsDevice, {
				numParticles: this._numParticles,
				emitterExtents: this._emitterExtents,
				emitterExtentsInner: this._emitterExtentsInner,
				emitterRadius: this._emitterRadius,
				emitterRadiusInner: this._emitterRadiusInner,
				emitterShape: this._emitterShape,
				initialVelocity: this._initialVelocity,
				wrap: this._wrap,
				localSpace: this._localSpace,
				screenSpace: this._screenSpace,
				wrapBounds: this._wrapBounds,
				lifetime: this._lifetime,
				rate: this._rate,
				rate2: this._rate2,
				orientation: this._orientation,
				particleNormal: this._particleNormal,
				animTilesX: this._animTilesX,
				animTilesY: this._animTilesY,
				animStartFrame: this._animStartFrame,
				animNumFrames: this._animNumFrames,
				animNumAnimations: this._animNumAnimations,
				animIndex: this._animIndex,
				randomizeAnimIndex: this._randomizeAnimIndex,
				animSpeed: this._animSpeed,
				animLoop: this._animLoop,
				startAngle: this._startAngle,
				startAngle2: this._startAngle2,
				scaleGraph: this._scaleGraph,
				scaleGraph2: this._scaleGraph2,
				colorGraph: this._colorGraph,
				colorGraph2: this._colorGraph2,
				alphaGraph: this._alphaGraph,
				alphaGraph2: this._alphaGraph2,
				localVelocityGraph: this._localVelocityGraph,
				localVelocityGraph2: this._localVelocityGraph2,
				velocityGraph: this._velocityGraph,
				velocityGraph2: this._velocityGraph2,
				rotationSpeedGraph: this._rotationSpeedGraph,
				rotationSpeedGraph2: this._rotationSpeedGraph2,
				radialSpeedGraph: this._radialSpeedGraph,
				radialSpeedGraph2: this._radialSpeedGraph2,
				colorMap: this._colorMap,
				normalMap: this._normalMap,
				loop: this._loop,
				preWarm: this._preWarm,
				sort: this._sort,
				stretch: this._stretch,
				alignToMotion: this._alignToMotion,
				lighting: this._lighting,
				halfLambert: this._halfLambert,
				intensity: this._intensity,
				depthSoftening: this._depthSoftening,
				scene: this.system.app.scene,
				mesh: this._mesh,
				depthWrite: this._depthWrite,
				noFog: this._noFog,
				node: this.entity,
				blendType: this._blendType
			});
			this.emitter.meshInstance.node = this.entity;
			this.emitter.drawOrder = this._drawOrder;
			if (!this._autoPlay) {
				this.pause();
				this.emitter.meshInstance.visible = false;
			}
		}
		if (this.emitter.colorMap) {
			this.addMeshInstanceToLayers();
		}
		this._evtLayersChanged = scene.on("set:layers", this.onLayersChanged, this);
		if (layers) {
			this._evtLayerAdded = layers.on("add", this.onLayerAdded, this);
			this._evtLayerRemoved = layers.on("remove", this.onLayerRemoved, this);
		}
		if (this.enabled && this.entity.enabled && this._depthSoftening) {
			this._requestDepth();
		}
	}
	onDisable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		this._evtLayersChanged?.off();
		this._evtLayersChanged = null;
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = null;
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = null;
		}
		if (this.emitter) {
			this.removeMeshInstanceFromLayers();
			if (this._depthSoftening) this._releaseDepth();
			this.emitter.camera = null;
		}
	}
	onBeforeRemove() {
		if (this.enabled) {
			this.enabled = false;
		}
		if (this.emitter) {
			this.emitter.destroy();
			this.emitter = null;
		}
		for (let i2 = 0; i2 < ASSET_PROPERTIES.length; i2++) {
			const prop = ASSET_PROPERTIES[i2];
			if (this[`_${prop}`]) {
				this[prop] = null;
			}
		}
		this.off();
	}
	reset() {
		if (this.emitter) {
			this.emitter.reset();
		}
	}
	stop() {
		if (this.emitter) {
			this.emitter.loop = false;
			this.emitter.resetTime(this.emitter.lifetime);
			this.emitter.addTime(0, true);
		}
	}
	pause() {
		this._paused = true;
	}
	unpause() {
		this._paused = false;
	}
	play() {
		this._paused = false;
		if (this.emitter) {
			this.emitter.meshInstance.visible = true;
			this.emitter.loop = this._loop;
			this.emitter.resetTime();
		}
	}
	isPlaying() {
		if (this._paused || !this.emitter) {
			return false;
		}
		if (this.emitter.loop) {
			return true;
		}
		return this.emitter.simTimeTotal <= this.emitter.endTime;
	}
	setInTools() {
		const { emitter } = this;
		if (emitter && !emitter.inTools) {
			emitter.inTools = true;
			this.rebuild();
		}
	}
	rebuild() {
		const enabled = this.enabled;
		this.enabled = false;
		if (this.emitter) {
			this.emitter.rebuild();
		}
		this.enabled = enabled;
	}
};

var particle_default = `
varying vec4 texCoordsAlphaLife;
uniform sampler2D colorMap;
uniform sampler2D colorParam;
uniform float graphSampleSize;
uniform float graphNumSamples;
#ifndef CAMERAPLANES
	#define CAMERAPLANES
	uniform vec4 camera_params;
#endif
#ifdef SOFT
	uniform float softening;
#endif
uniform float colorMult;
float saturate(float x) {
	return clamp(x, 0.0, 1.0);
}
void main(void) {
	vec4 tex  = texture2D(colorMap, vec2(texCoordsAlphaLife.x, 1.0 - texCoordsAlphaLife.y));
	vec4 ramp = texture2D(colorParam, vec2(texCoordsAlphaLife.w, 0.0));
	ramp.rgb *= colorMult;
	ramp.a += texCoordsAlphaLife.z;
	vec3 rgb = tex.rgb * ramp.rgb;
	float a  = tex.a * ramp.a;
`;

var particle_default2 = `
vec3 unpack3NFloats(float src) {
	float r = fract(src);
	float g = fract(src * 256.0);
	float b = fract(src * 65536.0);
	return vec3(r, g, b);
}
float saturate(float x) {
	return clamp(x, 0.0, 1.0);
}
vec4 tex1Dlod_lerp(TEXTURE_ACCEPT_HIGHP(tex), vec2 tc) {
	return mix( texture2D(tex,tc), texture2D(tex,tc + graphSampleSize), fract(tc.x*graphNumSamples) );
}
vec4 tex1Dlod_lerp(TEXTURE_ACCEPT_HIGHP(tex), vec2 tc, out vec3 w) {
	vec4 a = texture2D(tex,tc);
	vec4 b = texture2D(tex,tc + graphSampleSize);
	float c = fract(tc.x*graphNumSamples);
	vec3 unpackedA = unpack3NFloats(a.w);
	vec3 unpackedB = unpack3NFloats(b.w);
	w = mix(unpackedA, unpackedB, c);
	return mix(a, b, c);
}
vec2 rotate(vec2 quadXY, float pRotation, out mat2 rotMatrix) {
	float c = cos(pRotation);
	float s = sin(pRotation);
	mat2 m = mat2(c, -s, s, c);
	rotMatrix = m;
	return m * quadXY;
}
vec3 billboard(vec3 InstanceCoords, vec2 quadXY) {
	#ifdef SCREEN_SPACE
		vec3 pos = vec3(-1, 0, 0) * quadXY.x + vec3(0, -1, 0) * quadXY.y;
	#else
		vec3 pos = -matrix_viewInverse[0].xyz * quadXY.x + -matrix_viewInverse[1].xyz * quadXY.y;
	#endif
	return pos;
}
vec3 customFace(vec3 InstanceCoords, vec2 quadXY) {
	vec3 pos = faceTangent * quadXY.x + faceBinorm * quadXY.y;
	return pos;
}
vec2 safeNormalize(vec2 v) {
	float l = length(v);
	return (l > 1e-06) ? v / l : v;
}
void main(void) {
	vec3 meshLocalPos = particle_vertexData.xyz;
	float id = floor(particle_vertexData.w);
	float rndFactor = fract(sin(id + 1.0 + seed));
	vec3 rndFactor3 = vec3(rndFactor, fract(rndFactor*10.0), fract(rndFactor*100.0));
	float uv = id / numParticlesPot;
	readInput(uv);
#ifdef LOCAL_SPACE
	inVel = mat3(matrix_model) * inVel;
#endif
	vec2 velocityV = safeNormalize((mat3(matrix_view) * inVel).xy);
	float particleLifetime = lifetime;
	if (inLife <= 0.0 || inLife > particleLifetime || !inShow)
		meshLocalPos = vec3(0.0);
	vec2 quadXY = meshLocalPos.xy;
	float nlife = clamp(inLife / particleLifetime, 0.0, 1.0);
	vec3 paramDiv;
	vec4 params = tex1Dlod_lerp(TEXTURE_PASS(internalTex2), vec2(nlife, 0), paramDiv);
	float scale = params.y;
	float scaleDiv = paramDiv.x;
	float alphaDiv = paramDiv.z;
	scale += (scaleDiv * 2.0 - 1.0) * scaleDivMult * fract(rndFactor*10000.0);
#ifndef USE_MESH
	texCoordsAlphaLife = vec4(quadXY * -0.5 + 0.5, (alphaDiv * 2.0 - 1.0) * alphaDivMult * fract(rndFactor*1000.0), nlife);
#else
	texCoordsAlphaLife = vec4(particle_uv, (alphaDiv * 2.0 - 1.0) * alphaDivMult * fract(rndFactor*1000.0), nlife);
#endif
	vec3 particlePos = inPos;
	vec3 particlePosMoved = vec3(0.0);
	mat2 rotMatrix;
`;

var particleAnimFrameClamp_default = `
	float animFrame = min(floor(texCoordsAlphaLife.w * animTexParams.y) + animTexParams.x, animTexParams.z);
`;

var particleAnimFrameLoop_default = `
	float animFrame = floor(mod(texCoordsAlphaLife.w * animTexParams.y + animTexParams.x, animTexParams.z + 1.0));
`;

var particleAnimTex_default = `
	float animationIndex;
	if (animTexIndexParams.y == 1.0) {
		animationIndex = floor((animTexParams.w + 1.0) * rndFactor3.z) * (animTexParams.z + 1.0);
	} else {
		animationIndex = animTexIndexParams.x * (animTexParams.z + 1.0);
	}
	float atlasX = (animationIndex + animFrame) * animTexTilesParams.x;
	float atlasY = 1.0 - floor(atlasX + 1.0) * animTexTilesParams.y;
	atlasX = fract(atlasX);
	texCoordsAlphaLife.xy *= animTexTilesParams.xy;
	texCoordsAlphaLife.xy += vec2(atlasX, atlasY);
`;

var particleInput_default = `
void readInput(float uv) {
	#ifdef CAPS_TEXTURE_FLOAT_RENDERABLE
		vec4 tex = texture2D(particleTexIN, vec2(uv, 0.25));
		vec4 tex2 = texture2D(particleTexIN, vec2(uv, 0.75));
	#else
		vec4 tex = uintBitsToFloat(texture2D(particleTexIN, vec2(uv, 0.25)));
		vec4 tex2 = uintBitsToFloat(texture2D(particleTexIN, vec2(uv, 0.75)));
	#endif
	inPos = tex.xyz;
	inVel = tex2.xyz;
	inAngle = (tex.w < 0.0 ? -tex.w : tex.w) - 1000.0;
	inShow = tex.w >= 0.0;
	inLife = tex2.w;
}
`;

var particleOutput_default = `
void writeOutput() {
	vec4 row = gl_FragCoord.y < 1.0 ?
		vec4(outPos, (outAngle + 1000.0) * visMode) :
		vec4(outVel, outLife);
	#ifdef CAPS_TEXTURE_FLOAT_RENDERABLE
		gl_FragColor = row;
	#else
		gl_FragColor = floatBitsToUint(row);
	#endif
}
`;

var particleUpdaterAABB_default = `
uniform mat3 spawnBounds;
uniform vec3 spawnPosInnerRatio;
vec3 calcSpawnPosition(vec3 inBounds, float rndFactor) {
	vec3 pos = inBounds - vec3(0.5);
	vec3 posAbs = abs(pos);
	vec3 maxPos = vec3(max(posAbs.x, max(posAbs.y, posAbs.z)));
	vec3 edge = maxPos + (vec3(0.5) - maxPos) * spawnPosInnerRatio;
	pos.x = edge.x * (maxPos.x == posAbs.x ? sign(pos.x) : 2.0 * pos.x);
	pos.y = edge.y * (maxPos.y == posAbs.y ? sign(pos.y) : 2.0 * pos.y);
	pos.z = edge.z * (maxPos.z == posAbs.z ? sign(pos.z) : 2.0 * pos.z);
#ifndef LOCAL_SPACE
	return emitterPos + spawnBounds * pos;
#else
	return spawnBounds * pos;
#endif
}
void addInitialVelocity(inout vec3 localVelocity, vec3 inBounds) {
	localVelocity -= vec3(0, 0, initialVelocity);
}
`;

var particleUpdaterEnd_default = `
	writeOutput();
}
`;

var particleUpdaterInit_default = `
varying vec2 vUv0;
#ifdef CAPS_TEXTURE_FLOAT_RENDERABLE
	uniform highp sampler2D particleTexIN;
#else
	uniform highp usampler2D particleTexIN;
#endif
uniform highp sampler2D internalTex0;
uniform highp sampler2D internalTex1;
uniform highp sampler2D internalTex2;
uniform highp sampler2D internalTex3;
uniform mat3 emitterMatrix;
uniform mat3 emitterMatrixInv;
uniform vec3 emitterScale;
uniform vec3 emitterPos;
uniform vec3 frameRandom;
uniform vec3 localVelocityDivMult;
uniform vec3 velocityDivMult;
uniform float delta;
uniform float rate;
uniform float rateDiv;
uniform float lifetime;
uniform float numParticles;
uniform float rotSpeedDivMult;
uniform float radialSpeedDivMult;
uniform float seed;
uniform float startAngle;
uniform float startAngle2;
uniform float initialVelocity;
uniform float graphSampleSize;
uniform float graphNumSamples;
vec3 inPos;
vec3 inVel;
float inAngle;
bool inShow;
float inLife;
float visMode;
vec3 outPos;
vec3 outVel;
float outAngle;
bool outShow;
float outLife;
`;

var particleUpdaterNoRespawn_default = `
	if (outLife >= lifetime) {
		outLife -= max(lifetime, numParticles * particleRate);
		visMode = -1.0;
	}
`;

var particleUpdaterOnStop_default = `
	visMode = outLife < 0.0? -1.0: visMode;
`;

var particleUpdaterRespawn_default = `
	if (outLife >= lifetime) {
		outLife -= max(lifetime, numParticles * particleRate);
		visMode = 1.0;
	}
	visMode = outLife < 0.0? 1.0: visMode;
`;

var particleUpdaterSphere_default = `
uniform float spawnBoundsSphere;
uniform float spawnBoundsSphereInnerRatio;
vec3 calcSpawnPosition(vec3 inBounds, float rndFactor) {
	float rnd4 = fract(rndFactor * 1000.0);
	vec3 norm = normalize(inBounds.xyz - vec3(0.5));
	float r = rnd4 * (1.0 - spawnBoundsSphereInnerRatio) + spawnBoundsSphereInnerRatio;
#ifndef LOCAL_SPACE
	return emitterPos + norm * r * spawnBoundsSphere;
#else
	return norm * r * spawnBoundsSphere;
#endif
}
void addInitialVelocity(inout vec3 localVelocity, vec3 inBounds) {
	localVelocity += normalize(inBounds - vec3(0.5)) * initialVelocity;
}
`;

var particleUpdaterStart_default = `
float saturate(float x) {
	return clamp(x, 0.0, 1.0);
}
vec3 unpack3NFloats(float src) {
	float r = fract(src);
	float g = fract(src * 256.0);
	float b = fract(src * 65536.0);
	return vec3(r, g, b);
}
vec3 tex1Dlod_lerp(TEXTURE_ACCEPT_HIGHP(tex), vec2 tc, out vec3 w) {
	vec4 a = texture2D(tex, tc);
	vec4 b = texture2D(tex, tc + graphSampleSize);
	float c = fract(tc.x * graphNumSamples);
	vec3 unpackedA = unpack3NFloats(a.w);
	vec3 unpackedB = unpack3NFloats(b.w);
	w = mix(unpackedA, unpackedB, c);
	return mix(a.xyz, b.xyz, c);
}
#define HASHSCALE4 vec4(1031, .1030, .0973, .1099)
vec4 hash41(float p) {
	vec4 p4 = fract(vec4(p) * HASHSCALE4);
	p4 += dot(p4, p4.wzxy+19.19);
	return fract(vec4((p4.x + p4.y)*p4.z, (p4.x + p4.z)*p4.y, (p4.y + p4.z)*p4.w, (p4.z + p4.w)*p4.x));
}
void main(void) {
	if (gl_FragCoord.x > numParticles) discard;
	readInput(vUv0.x);
	visMode = inShow? 1.0 : -1.0;
	vec4 rndFactor = hash41(gl_FragCoord.x + seed);
	float particleRate = rate + rateDiv * rndFactor.x;
	outLife = inLife + delta;
	float nlife = clamp(outLife / lifetime, 0.0, 1.0);
	vec3 localVelocityDiv;
	vec3 velocityDiv;
	vec3 paramDiv;
	vec3 localVelocity = tex1Dlod_lerp(TEXTURE_PASS(internalTex0), vec2(nlife, 0), localVelocityDiv);
	vec3 velocity =	  tex1Dlod_lerp(TEXTURE_PASS(internalTex1), vec2(nlife, 0), velocityDiv);
	vec3 params =		tex1Dlod_lerp(TEXTURE_PASS(internalTex2), vec2(nlife, 0), paramDiv);
	float rotSpeed = params.x;
	float rotSpeedDiv = paramDiv.y;
	vec3 radialParams = tex1Dlod_lerp(TEXTURE_PASS(internalTex3), vec2(nlife, 0), paramDiv);
	float radialSpeed = radialParams.x;
	float radialSpeedDiv = radialParams.y;
	bool respawn = inLife <= 0.0 || outLife >= lifetime;
	inPos = respawn ? calcSpawnPosition(rndFactor.xyz, rndFactor.x) : inPos;
	inAngle = respawn ? mix(startAngle, startAngle2, rndFactor.x) : inAngle;
#ifndef LOCAL_SPACE
	vec3 radialVel = inPos - emitterPos;
#else
	vec3 radialVel = inPos;
#endif
	radialVel = (dot(radialVel, radialVel) > 1.0E-8) ? radialSpeed * normalize(radialVel) : vec3(0.0);
	radialVel += (radialSpeedDiv * vec3(2.0) - vec3(1.0)) * radialSpeedDivMult * rndFactor.xyz;
	localVelocity +=	(localVelocityDiv * vec3(2.0) - vec3(1.0)) * localVelocityDivMult * rndFactor.xyz;
	velocity +=		 (velocityDiv * vec3(2.0) - vec3(1.0)) * velocityDivMult * rndFactor.xyz;
	rotSpeed +=		 (rotSpeedDiv * 2.0 - 1.0) * rotSpeedDivMult * rndFactor.y;
	addInitialVelocity(localVelocity, rndFactor.xyz);
#ifndef LOCAL_SPACE
	outVel = emitterMatrix * localVelocity + (radialVel + velocity) * emitterScale;
#else
	outVel = (localVelocity + radialVel) / emitterScale + emitterMatrixInv * velocity;
#endif
	outPos = inPos + outVel * delta;
	outAngle = inAngle + rotSpeed * delta;
`;

var particle_billboard_default = `
	quadXY = rotate(quadXY, inAngle, rotMatrix);
	vec3 localPos = billboard(particlePos, quadXY);
`;

var particle_blendAdd_default = `
	dBlendModeFogFactor = 0.0;
	rgb *= saturate(gammaCorrectInput(max(a, 0.0)));
	if ((rgb.r + rgb.g + rgb.b) < 0.000001) discard;
`;

var particle_blendMultiply_default = `
	rgb = mix(vec3(1.0), rgb, vec3(a));
	if (rgb.r + rgb.g + rgb.b > 2.99) discard;
`;

var particle_blendNormal_default = `
	if (a < 0.01) discard;
`;

var particle_cpu_default = `
attribute vec4 particle_vertexData;
attribute vec4 particle_vertexData2;
attribute vec4 particle_vertexData3;
attribute float particle_vertexData4;
#ifndef USE_MESH
	attribute vec2 particle_vertexData5;
#else
	attribute vec4 particle_vertexData5;
#endif
uniform mat4 matrix_viewProjection;
uniform mat4 matrix_model;
#ifndef VIEWMATRIX
	#define VIEWMATRIX
	uniform mat4 matrix_view;
#endif
uniform mat3 matrix_normal;
uniform mat4 matrix_viewInverse;
uniform float numParticles;
uniform float lifetime;
uniform float stretch;
uniform float seed;
uniform vec3 emitterScale;
uniform vec3 faceTangent;
uniform vec3 faceBinorm;
#ifdef PARTICLE_GPU
	#ifdef WRAP
		uniform vec3 wrapBounds;
	#endif
#endif
#ifdef PARTICLE_GPU
	uniform highp sampler2D internalTex0;
	uniform highp sampler2D internalTex1;
	uniform highp sampler2D internalTex2;
#endif
uniform vec3 emitterPos;
varying vec4 texCoordsAlphaLife;
vec2 rotate(vec2 quadXY, float pRotation, out mat2 rotMatrix)
{
	float c = cos(pRotation);
	float s = sin(pRotation);
	mat2 m = mat2(c, -s, s, c);
	rotMatrix = m;
	return m * quadXY;
}
vec3 billboard(vec3 InstanceCoords, vec2 quadXY)
{
	#ifdef SCREEN_SPACE
		vec3 pos = vec3(-1, 0, 0) * quadXY.x + vec3(0, -1, 0) * quadXY.y;
	#else
		vec3 pos = -matrix_viewInverse[0].xyz * quadXY.x + -matrix_viewInverse[1].xyz * quadXY.y;
	#endif
	return pos;
}
vec3 customFace(vec3 InstanceCoords, vec2 quadXY)
{
	vec3 pos = faceTangent * quadXY.x + faceBinorm * quadXY.y;
	return pos;
}
void main(void)
{
	vec3 particlePos = particle_vertexData.xyz;
	vec3 inPos = particlePos;
	vec3 vertPos = particle_vertexData3.xyz;
	vec3 inVel = vec3(particle_vertexData2.w, particle_vertexData3.w, particle_vertexData5.x);
	float id = floor(particle_vertexData4);
	float rndFactor = fract(sin(id + 1.0 + seed));
	vec3 rndFactor3 = vec3(rndFactor, fract(rndFactor*10.0), fract(rndFactor*100.0));
#ifdef LOCAL_SPACE
	inVel = mat3(matrix_model) * inVel;
#endif
	vec2 velocityV = normalize((mat3(matrix_view) * inVel).xy);
	vec2 quadXY = vertPos.xy;
#ifdef USE_MESH
	texCoordsAlphaLife = vec4(particle_vertexData5.zw, particle_vertexData2.z, particle_vertexData.w);
#else
	texCoordsAlphaLife = vec4(quadXY * -0.5 + 0.5, particle_vertexData2.z, particle_vertexData.w);
#endif
	mat2 rotMatrix;
	float inAngle = particle_vertexData2.x;
	vec3 particlePosMoved = vec3(0.0);
	vec3 meshLocalPos = particle_vertexData3.xyz;
`;

var particle_cpu_end_default = `
	localPos *= particle_vertexData2.y * emitterScale;
	localPos += particlePos;
	#ifdef SCREEN_SPACE
	gl_Position = vec4(localPos.x, localPos.y, 0.0, 1.0);
	#else
	gl_Position = matrix_viewProjection * vec4(localPos, 1.0);
	#endif
`;

var particle_customFace_default = `
	quadXY = rotate(quadXY, inAngle, rotMatrix);
	vec3 localPos = customFace(particlePos, quadXY);
`;

var particle_end_default = `
	rgb = addFog(rgb);
	rgb = toneMap(rgb);
	rgb = gammaCorrectOutput(rgb);
	gl_FragColor = vec4(rgb, a);
}
`;

var particle_end_default2 = `
	localPos *= scale * emitterScale;
	localPos += particlePos;
	#ifdef SCREEN_SPACE
	gl_Position = vec4(localPos.x, localPos.y, 0.0, 1.0);
	#else
	gl_Position = matrix_viewProjection * vec4(localPos.xyz, 1.0);
	#endif
`;

var particle_halflambert_default = `
	vec3 negNormal = normal * 0.5 + 0.5;
	vec3 posNormal = -normal * 0.5 + 0.5;
	negNormal *= negNormal;
	posNormal *= posNormal;
`;

var particle_init_default = `
attribute vec4 particle_vertexData;
#if defined(USE_MESH)
	#if defined(USE_MESH_UV)
		attribute vec2 particle_uv;
	#else
		vec2 particle_uv = vec2(0.0, 0.0);
	#endif
#endif
uniform mat4 matrix_viewProjection;
uniform mat4 matrix_model;
uniform mat3 matrix_normal;
uniform mat4 matrix_viewInverse;
#ifndef VIEWMATRIX
	#define VIEWMATRIX
	uniform mat4 matrix_view;
#endif
uniform float numParticles;
uniform float numParticlesPot;
uniform float graphSampleSize;
uniform float graphNumSamples;
uniform float stretch;
uniform vec3 emitterScale;
uniform vec3 emitterPos;
uniform vec3 faceTangent;
uniform vec3 faceBinorm;
uniform float rate;
uniform float rateDiv;
uniform float lifetime;
uniform float scaleDivMult;
uniform float alphaDivMult;
uniform float seed;
uniform float delta;
#ifdef CAPS_TEXTURE_FLOAT_RENDERABLE
	uniform sampler2D particleTexOUT;
	uniform sampler2D particleTexIN;
#else
	uniform highp usampler2D particleTexOUT;
	uniform highp usampler2D particleTexIN;
#endif
#ifdef PARTICLE_GPU
	#ifdef WRAP
		uniform vec3 wrapBounds;
	#endif
#endif
#ifdef PARTICLE_GPU
	uniform highp sampler2D internalTex0;
	uniform highp sampler2D internalTex1;
	uniform highp sampler2D internalTex2;
#endif
#ifndef CAMERAPLANES
	#define CAMERAPLANES
	uniform vec4 camera_params;
#endif
varying vec4 texCoordsAlphaLife;
vec3 inPos;
vec3 inVel;
float inAngle;
bool inShow;
float inLife;
`;

var particle_lambert_default = `
	vec3 negNormal = max(normal, vec3(0.0));
	vec3 posNormal = max(-normal, vec3(0.0));
`;

var particle_lighting_default = `
	vec3 light = negNormal.x*lightCube[0] + posNormal.x*lightCube[1] +
						negNormal.y*lightCube[2] + posNormal.y*lightCube[3] +
						negNormal.z*lightCube[4] + posNormal.z*lightCube[5];
	rgb *= light;
`;

var particle_localShift_default = `
	particlePos = (matrix_model * vec4(particlePos, 1.0)).xyz;
`;

var particle_mesh_default = `
	vec3 localPos = meshLocalPos;
	localPos.xy = rotate(localPos.xy, inAngle, rotMatrix);
	localPos.yz = rotate(localPos.yz, inAngle, rotMatrix);
	billboard(particlePos, quadXY);
`;

var particle_normal_default = `
	Normal = normalize(localPos + matrix_viewInverse[2].xyz);
`;

var particle_normalMap_default = `
	vec3 normalMap = normalize(texture2D(normalMap, vec2(texCoordsAlphaLife.x, 1.0 - texCoordsAlphaLife.y)).xyz * 2.0 - 1.0);
	vec3 normal = ParticleMat * normalMap;
`;

var particle_pointAlong_default = `
	inAngle = atan(velocityV.x, velocityV.y);
`;

var particle_simulation_default = `
	#include "particleUpdaterInitPS"
	#include "particleInputPS"
	#include "particleOutputPS"
	#ifdef EMITTERSHAPE_BOX
		#include "particleUpdaterAABBPS"
	#else
		#include "particleUpdaterSpherePS"
	#endif
	#include "particleUpdaterStartPS"
	#ifdef RESPAWN
		#include "particleUpdaterRespawnPS"
	#endif
	#ifdef NO_RESPAWN
		#include "particleUpdaterNoRespawnPS"
	#endif
	#ifdef ON_STOP
		#include "particleUpdaterOnStopPS"
	#endif
	#include "particleUpdaterEndPS"
`;

var particle_shader_default = `
	#if NORMAL != NONE
		#if NORMAL == VERTEX
			varying vec3 Normal;
		#endif
		#if NORMAL == MAP
			varying mat3 ParticleMat;
		#endif
		uniform vec3 lightCube[6];
	#endif
	#ifdef SOFT
		varying float vDepth;
		#include "screenDepthPS"
	#endif
	#include "gammaPS"
	#include "tonemappingPS"
	#include "fogPS"
	#if NORMAL == MAP
		uniform sampler2D normalMap;
	#endif
	#include "particlePS"
	#ifdef SOFT
		#include "particle_softPS"
	#endif
	#if NORMAL == VERTEX
		vec3 normal = Normal;
	#endif
	#if NORMAL == MAP
		#include "particle_normalMapPS"
	#endif
	#if NORMAL != NONE
		#ifdef HALF_LAMBERT
			#include "particle_halflambertPS"
		#else
			#include "particle_lambertPS"
		#endif
		#include "particle_lightingPS"
	#endif
	#if BLEND == NORMAL
		#include "particle_blendNormalPS"
	#elif BLEND == ADDITIVE
		#include "particle_blendAddPS"
	#elif BLEND == MULTIPLICATIVE
		#include "particle_blendMultiplyPS"
	#endif
	#include "particle_endPS"
`;

var particle_shader_default2 = `
	#ifdef ANIMTEX
		uniform vec2 animTexTilesParams;
		uniform vec4 animTexParams;
		uniform vec2 animTexIndexParams;
	#endif
	#if NORMAL == MAP
		varying mat3 ParticleMat;
	#endif
	#if NORMAL == VERTEX
		varying vec3 Normal;
	#endif
	#ifdef SOFT
		varying float vDepth;
	#endif
	#ifdef PARTICLE_GPU
		#include "particle_initVS"
		#include "particleInputPS"
		#ifdef SOFT
			#include "screenDepthPS"
		#endif
		#include "particleVS"
	#else
		#ifdef SOFT
			#include "screenDepthPS"
		#endif
		#include "particle_cpuVS"
	#endif
	#ifdef LOCAL_SPACE
		#include "particle_localShiftVS"
	#endif
	#ifdef ANIMTEX
		#ifdef ANIMTEX_LOOP
			#include "particleAnimFrameLoopVS"
		#else
			#include "particleAnimFrameClampVS"
		#endif
		#include "particleAnimTexVS"
	#endif
	#ifdef PARTICLE_GPU
		#ifdef WRAP
			#include "particle_wrapVS"
		#endif
	#endif
	#ifdef ALIGN_TO_MOTION
		#include "particle_pointAlongVS"
	#endif
	#ifdef USE_MESH
		#include "particle_meshVS"
	#else
		#ifdef CUSTOM_FACE
			#include "particle_customFaceVS"
		#else
			#include "particle_billboardVS"
		#endif
	#endif
	#if NORMAL == VERTEX
		#include "particle_normalVS"
	#endif
	#if NORMAL == MAP
		#include "particle_TBNVS"
	#endif
	#ifdef STRETCH
		#include "particle_stretchVS"
	#endif
	#ifdef PARTICLE_GPU
		#include "particle_endVS"
	#else
		#include "particle_cpu_endVS"
	#endif
	#ifdef SOFT
		#include "particle_softVS"
	#endif
	}
`;

var particle_soft_default = `
	float depth = getLinearScreenDepth();
	float particleDepth = vDepth;
	float depthDiff = saturate(abs(particleDepth - depth) * softening);
	a *= depthDiff;
`;

var particle_soft_default2 = `
	vDepth = getLinearDepth(localPos);
`;

var particle_stretch_default = `
	vec3 moveDir = inVel * stretch;
	vec3 posPrev = particlePos - moveDir;
	posPrev += particlePosMoved;
	vec2 centerToVertexV = normalize((mat3(matrix_view) * localPos).xy);
	float interpolation = dot(-velocityV, centerToVertexV) * 0.5 + 0.5;
	particlePos = mix(particlePos, posPrev, interpolation);
`;

var particle_TBN_default = `
	mat3 rot3 = mat3(rotMatrix[0][0], rotMatrix[0][1], 0.0, rotMatrix[1][0], rotMatrix[1][1], 0.0, 0.0, 0.0, 1.0);
	ParticleMat = mat3(-matrix_viewInverse[0].xyz, -matrix_viewInverse[1].xyz, matrix_viewInverse[2].xyz) * rot3;
`;

var particle_wrap_default = `
	vec3 origParticlePos = particlePos;
	particlePos -= matrix_model[3].xyz;
	particlePos = mod(particlePos, wrapBounds) - wrapBounds * 0.5;
	particlePos += matrix_model[3].xyz;
	particlePosMoved = particlePos - origParticlePos;
`;

var particleChunksGLSL = {
	particlePS: particle_default,
	particleVS: particle_default2,
	particleAnimFrameClampVS: particleAnimFrameClamp_default,
	particleAnimFrameLoopVS: particleAnimFrameLoop_default,
	particleAnimTexVS: particleAnimTex_default,
	particleInputPS: particleInput_default,
	particleOutputPS: particleOutput_default,
	particleUpdaterAABBPS: particleUpdaterAABB_default,
	particleUpdaterEndPS: particleUpdaterEnd_default,
	particleUpdaterInitPS: particleUpdaterInit_default,
	particleUpdaterNoRespawnPS: particleUpdaterNoRespawn_default,
	particleUpdaterOnStopPS: particleUpdaterOnStop_default,
	particleUpdaterRespawnPS: particleUpdaterRespawn_default,
	particleUpdaterSpherePS: particleUpdaterSphere_default,
	particleUpdaterStartPS: particleUpdaterStart_default,
	particle_billboardVS: particle_billboard_default,
	particle_blendAddPS: particle_blendAdd_default,
	particle_blendMultiplyPS: particle_blendMultiply_default,
	particle_blendNormalPS: particle_blendNormal_default,
	particle_cpuVS: particle_cpu_default,
	particle_cpu_endVS: particle_cpu_end_default,
	particle_customFaceVS: particle_customFace_default,
	particle_endPS: particle_end_default,
	particle_endVS: particle_end_default2,
	particle_halflambertPS: particle_halflambert_default,
	particle_initVS: particle_init_default,
	particle_lambertPS: particle_lambert_default,
	particle_lightingPS: particle_lighting_default,
	particle_localShiftVS: particle_localShift_default,
	particle_meshVS: particle_mesh_default,
	particle_normalVS: particle_normal_default,
	particle_normalMapPS: particle_normalMap_default,
	particle_pointAlongVS: particle_pointAlong_default,
	particle_simulationPS: particle_simulation_default,
	particle_shaderPS: particle_shader_default,
	particle_shaderVS: particle_shader_default2,
	particle_softPS: particle_soft_default,
	particle_softVS: particle_soft_default2,
	particle_stretchVS: particle_stretch_default,
	particle_TBNVS: particle_TBN_default,
	particle_wrapVS: particle_wrap_default
};

var particle_default3 = `
varying texCoordsAlphaLife: vec4f;
var colorMap: texture_2d<f32>;
var colorMapSampler: sampler;
var colorParam: texture_2d<f32>;
var colorParamSampler: sampler;
uniform graphSampleSize: f32;
uniform graphNumSamples: f32;
#ifndef CAMERAPLANES
	#define CAMERAPLANES
	uniform camera_params: vec4f;
#endif
#ifdef SOFT
	uniform softening: f32;
#endif
uniform colorMult: f32;
fn saturate(x: f32) -> f32 {
	return clamp(x, 0.0, 1.0);
}
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	let tex: vec4f  = textureSample(colorMap, colorMapSampler, vec2f(input.texCoordsAlphaLife.x, 1.0 - input.texCoordsAlphaLife.y));
	var ramp: vec4f = textureSample(colorParam, colorParamSampler, vec2f(input.texCoordsAlphaLife.w, 0.0));
	ramp = vec4f(ramp.rgb * uniform.colorMult, ramp.a);
	ramp.a = ramp.a + input.texCoordsAlphaLife.z;
	var rgb: vec3f = tex.rgb * ramp.rgb;
	var a: f32 = tex.a * ramp.a;
`;

var particle_default4 = `
fn unpack3NFloats(src: f32) -> vec3f {
	let r = fract(src);
	let g = fract(src * 256.0);
	let b = fract(src * 65536.0);
	return vec3f(r, g, b);
}
fn saturate(x: f32) -> f32 {
	return clamp(x, 0.0, 1.0);
}
struct TexLerpUnpackResult {
	result: vec4f,
	unpacked: vec3f
}
fn tex1Dlod_lerp_simple(tex: texture_2d<f32>, textureSize: vec2u, tc: vec2f) -> vec4f {
	let tc_next = tc + vec2f(uniform.graphSampleSize);
	let texelA: vec2i = vec2i(tc * vec2f(textureSize));
	let texelB: vec2i = vec2i(tc_next * vec2f(textureSize));
	return mix( textureLoad(tex, texelA, 0), textureLoad(tex, texelB, 0), fract(tc.x * uniform.graphNumSamples) );
}
fn tex1Dlod_lerp_unpack(tex: texture_2d<f32>, textureSize: vec2u, tc: vec2f) -> TexLerpUnpackResult {
	let tc_next = tc + vec2f(uniform.graphSampleSize);
	let texelA: vec2i = vec2i(tc * vec2f(textureSize));
	let texelB: vec2i = vec2i(tc_next * vec2f(textureSize));
	let a = textureLoad(tex, texelA, 0);
	let b = textureLoad(tex, texelB, 0);
	let c = fract(tc.x * uniform.graphNumSamples);
	let unpackedA = unpack3NFloats(a.w);
	let unpackedB = unpack3NFloats(b.w);
	let w_out = mix(unpackedA, unpackedB, c);
	return TexLerpUnpackResult(mix(a, b, c), w_out);
}
struct RotateResult {
	rotatedVec: vec2f,
	matrix: mat2x2f
}
fn rotateWithMatrix(quadXY: vec2f, pRotation: f32) -> RotateResult {
	let c = cos(pRotation);
	let s = sin(pRotation);
	let m = mat2x2f(vec2f(c, -s), vec2f(s, c));
	return RotateResult(m * quadXY, m);
}
fn billboard(InstanceCoords: vec3f, quadXY: vec2f) -> vec3f {
	var pos: vec3f;
	#ifdef SCREEN_SPACE
		pos = vec3f(-1.0, 0.0, 0.0) * quadXY.x + vec3f(0.0, -1.0, 0.0) * quadXY.y;
	#else
		pos = -uniform.matrix_viewInverse[0].xyz * quadXY.x + -uniform.matrix_viewInverse[1].xyz * quadXY.y;
	#endif
	return pos;
}
fn customFace(InstanceCoords: vec3f, quadXY: vec2f) -> vec3f {
	let pos = uniform.faceTangent * quadXY.x + uniform.faceBinorm * quadXY.y;
	return pos;
}
fn safeNormalize(v: vec2f) -> vec2f {
	let l = length(v);
	return select(v, v / l, l > 1e-06);
}
@vertex
fn vertexMain(input: VertexInput) -> VertexOutput {
	var output: VertexOutput;
	let meshLocalPos_in = input.particle_vertexData.xyz;
	let id = floor(input.particle_vertexData.w);
	let rndFactor = fract(sin(id + 1.0 + uniform.seed));
	let rndFactor3 = vec3f(rndFactor, fract(rndFactor*10.0), fract(rndFactor*100.0));
	let uv = id / uniform.numParticlesPot;
	readInput(uv);
	#ifdef LOCAL_SPACE
		let modelRotation = mat3x3f(uniform.matrix_model[0].xyz, uniform.matrix_model[1].xyz, uniform.matrix_model[2].xyz);
		inVel = modelRotation * inVel;
	#endif
	let viewRotation = mat3x3f(uniform.matrix_view[0].xyz, uniform.matrix_view[1].xyz, uniform.matrix_view[2].xyz);
	let velocityV = safeNormalize((viewRotation * inVel).xy);
	let particleLifetime = uniform.lifetime;
	var meshLocalPos = meshLocalPos_in;
	if (inLife <= 0.0 || inLife > particleLifetime || !inShow) {
		 meshLocalPos = vec3f(0.0);
	}
	let quadXY = meshLocalPos.xy;
	let nlife = clamp(inLife / particleLifetime, 0.0, 1.0);
	let internalTexSize = textureDimensions(internalTex2, 0);
	let lerp_result = tex1Dlod_lerp_unpack(internalTex2, internalTexSize, vec2f(nlife, 0.0));
	let params = lerp_result.result;
	let paramDiv = lerp_result.unpacked;
	var scale = params.y;
	let scaleDiv = paramDiv.x;
	let alphaDiv = paramDiv.z;
	scale = scale + (scaleDiv * 2.0 - 1.0) * uniform.scaleDivMult * fract(rndFactor*10000.0);
	#ifndef USE_MESH
		output.texCoordsAlphaLife = vec4f(quadXY * -0.5 + 0.5, (alphaDiv * 2.0 - 1.0) * uniform.alphaDivMult * fract(rndFactor*1000.0), nlife);
	#else
		output.texCoordsAlphaLife = vec4f(particle_uv, (alphaDiv * 2.0 - 1.0) * uniform.alphaDivMult * fract(rndFactor*1000.0), nlife);
	#endif
	var particlePos = inPos;
	var particlePosMoved = vec3f(0.0);
	var rotMatrix: mat2x2f;
`;

var particleAnimFrameClamp_default2 = `
	let animFrame: f32 = min(floor(input.texCoordsAlphaLife.w * uniform.animTexParams.y) + uniform.animTexParams.x, uniform.animTexParams.z);
`;

var particleAnimFrameLoop_default2 = `
	let animFrame: f32 = floor((output.texCoordsAlphaLife.w * uniform.animTexParams.y + uniform.animTexParams.x) % (uniform.animTexParams.z + 1.0));	
`;

var particleAnimTex_default2 = `
	var animationIndex: f32;
	if (uniform.animTexIndexParams.y == 1.0) {
		animationIndex = floor((uniform.animTexParams.w + 1.0) * rndFactor3.z) * (uniform.animTexParams.z + 1.0);
	} else {
		animationIndex = uniform.animTexIndexParams.x * (uniform.animTexParams.z + 1.0);
	}
	var atlasX: f32 = (animationIndex + animFrame) * uniform.animTexTilesParams.x;
	let atlasY: f32 = 1.0 - floor(atlasX + 1.0) * uniform.animTexTilesParams.y;
	atlasX = fract(atlasX);
	let current_tcal_xy = output.texCoordsAlphaLife.xy;
	let scaled_tcal_xy = current_tcal_xy * uniform.animTexTilesParams.xy;
	let final_tcal_xy = scaled_tcal_xy + vec2f(atlasX, atlasY);
	output.texCoordsAlphaLife = vec4f(final_tcal_xy, output.texCoordsAlphaLife.z, output.texCoordsAlphaLife.w);
`;

var particleInput_default2 = `
fn readInput(uv: f32) {
	let textureSize = textureDimensions(particleTexIN, 0);
	let texel0: vec2i = vec2i(vec2f(uv, 0.25) * vec2f(textureSize));
	let texel1: vec2i = vec2i(vec2f(uv, 0.75) * vec2f(textureSize));
	let tex: vec4f = textureLoad(particleTexIN, texel0, 0);
	let tex2: vec4f = textureLoad(particleTexIN, texel1, 0);
	inPos = tex.xyz;
	inVel = tex2.xyz;
	inAngle = abs(tex.w) - 1000.0;
	inShow = tex.w >= 0.0;
	inLife = tex2.w;
}
`;

var particleOutput_default2 = `
fn getOutput() -> vec4f {
	if (pcPosition.y < 1.0) {
		return vec4f(outPos, (outAngle + 1000.0) * visMode);
	} else {
		return vec4f(outVel, outLife);
	}
}
`;

var particleUpdaterAABB_default2 = `
uniform spawnBounds: mat3x3f;
uniform spawnPosInnerRatio: vec3f;
fn calcSpawnPosition(inBounds: vec3f, rndFactor: f32) -> vec3f {
	var pos = inBounds - vec3f(0.5);
	let posAbs = abs(pos);
	let maxComp = max(posAbs.x, max(posAbs.y, posAbs.z));
	let maxPos = vec3f(maxComp);
	let edge = maxPos + (vec3f(0.5) - maxPos) * uniform.spawnPosInnerRatio;
	pos.x = edge.x * select(2.0 * pos.x, sign(pos.x), maxPos.x == posAbs.x);
	pos.y = edge.y * select(2.0 * pos.y, sign(pos.y), maxPos.y == posAbs.y);
	pos.z = edge.z * select(2.0 * pos.z, sign(pos.z), maxPos.z == posAbs.z);
	#ifndef LOCAL_SPACE
		return uniform.emitterPos + uniform.spawnBounds * pos;
	#else
		return uniform.spawnBounds * pos;
	#endif
}
fn addInitialVelocity(localVelocity: ptr<function, vec3f>, inBounds: vec3f) {
	*localVelocity = *localVelocity - vec3f(0.0, 0.0, uniform.initialVelocity);
}
`;

var particleUpdaterEnd_default2 = `
	output.color = getOutput();
	return output;
}
`;

var particleUpdaterInit_default2 = `
varying vUv0: vec2f;
var particleTexIN: texture_2d<uff>;
var internalTex0: texture_2d<uff>;
var internalTex1: texture_2d<uff>;
var internalTex2: texture_2d<uff>;
var internalTex3: texture_2d<uff>;
uniform emitterMatrix: mat3x3f;
uniform emitterMatrixInv: mat3x3f;
uniform emitterScale: vec3f;
uniform emitterPos: vec3f;
uniform frameRandom: vec3f;
uniform localVelocityDivMult: vec3f;
uniform velocityDivMult: vec3f;
uniform delta: f32;
uniform rate: f32;
uniform rateDiv: f32;
uniform lifetime: f32;
uniform numParticles: f32;
uniform rotSpeedDivMult: f32;
uniform radialSpeedDivMult: f32;
uniform seed: f32;
uniform startAngle: f32;
uniform startAngle2: f32;
uniform initialVelocity: f32;
uniform graphSampleSize: f32;
uniform graphNumSamples: f32;
var<private> inPos: vec3f;
var<private> inVel: vec3f;
var<private> inAngle: f32;
var<private> inShow: bool;
var<private> inLife: f32;
var<private> visMode: f32;
var<private> outPos: vec3f;
var<private> outVel: vec3f;
var<private> outAngle: f32;
var<private> outShow: bool;
var<private> outLife: f32;
`;

var particleUpdaterNoRespawn_default2 = `
	if (outLife >= uniform.lifetime) {
		outLife = outLife - max(uniform.lifetime, uniform.numParticles * particleRate);
		visMode = -1.0;
	}
`;

var particleUpdaterOnStop_default2 = `
	visMode = select(visMode, -1.0, outLife < 0.0);
`;

var particleUpdaterRespawn_default2 = `
	if (outLife >= uniform.lifetime) {
		let subtractAmount = max(uniform.lifetime, uniform.numParticles * particleRate);
		outLife = outLife - subtractAmount;
		visMode = 1.0;
	}
	visMode = select(visMode, 1.0, outLife < 0.0);
`;

var particleUpdaterSphere_default2 = `
uniform spawnBoundsSphere: f32;
uniform spawnBoundsSphereInnerRatio: f32;
fn calcSpawnPosition(inBounds: vec3f, rndFactor: f32) -> vec3f {
	let rnd4: f32 = fract(rndFactor * 1000.0);
	let norm: vec3f = normalize(inBounds.xyz - vec3f(0.5));
	let r: f32 = rnd4 * (1.0 - uniform.spawnBoundsSphereInnerRatio) + uniform.spawnBoundsSphereInnerRatio;
	#ifndef LOCAL_SPACE
		return uniform.emitterPos + norm * r * uniform.spawnBoundsSphere;
	#else
		return norm * r * uniform.spawnBoundsSphere;
	#endif
}
fn addInitialVelocity(localVelocity: ptr<function, vec3f>, inBounds: vec3f) {
	let initialVelOffset: vec3f = normalize(inBounds - vec3f(0.5)) * uniform.initialVelocity;
	*localVelocity = *localVelocity + initialVelOffset;
}
`;

var particleUpdaterStart_default2 = `
fn saturate(x: f32) -> f32 {
	return clamp(x, 0.0, 1.0);
}
fn unpack3NFloats(src: f32) -> vec3f {
	let r = fract(src);
	let g = fract(src * 256.0);
	let b = fract(src * 65536.0);
	return vec3f(r, g, b);
}
struct TexLerpUnpackResult {
	result: vec3f,
	unpacked: vec3f
}
fn tex1Dlod_lerp(tex: texture_2d<f32>, textureSize: vec2u, tc: vec2f) -> TexLerpUnpackResult {
	let tc_next = tc + vec2f(uniform.graphSampleSize);
	let texelA: vec2i = vec2i(tc * vec2f(textureSize));
	let texelB: vec2i = vec2i(tc_next * vec2f(textureSize));
	let a = textureLoad(tex, texelA, 0);
	let b = textureLoad(tex, texelB, 0);
	let c = fract(tc.x * uniform.graphNumSamples);
	let unpackedA = unpack3NFloats(a.w);
	let unpackedB = unpack3NFloats(b.w);
	let w_out = mix(unpackedA, unpackedB, c);
	return TexLerpUnpackResult(mix(a.xyz, b.xyz, c), w_out);
}
const HASHSCALE4: vec4f = vec4f(1031.0, 0.1030, 0.0973, 0.1099);
fn hash41(p: f32) -> vec4f {
	var p4 = fract(vec4f(p) * HASHSCALE4);
	p4 = p4 + dot(p4, p4.wzxy + 19.19);
	return fract(vec4f((p4.x + p4.y)*p4.z, (p4.x + p4.z)*p4.y, (p4.y + p4.z)*p4.w, (p4.z + p4.w)*p4.x));
}
@fragment
fn fragmentMain(input : FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	if (pcPosition.x > uniform.numParticles) {
		discard;
		return output;
	}
	readInput(input.vUv0.x);
	visMode = select(-1.0, 1.0, inShow);
	let rndFactor = hash41(pcPosition.x + uniform.seed);
	let particleRate = uniform.rate + uniform.rateDiv * rndFactor.x;
	outLife = inLife + uniform.delta;
	let nlife = clamp(outLife / uniform.lifetime, 0.0, 1.0);
	let internalTexSize = textureDimensions(internalTex0, 0);
	let lerpResult0 = tex1Dlod_lerp(internalTex0, internalTexSize, vec2f(nlife, 0.0));
	var localVelocity = lerpResult0.result;
	let localVelocityDiv = lerpResult0.unpacked;
	let lerpResult1 = tex1Dlod_lerp(internalTex1, internalTexSize, vec2f(nlife, 0.0));
	var velocity = lerpResult1.result;
	let velocityDiv = lerpResult1.unpacked;
	let lerpResult2 = tex1Dlod_lerp(internalTex2, internalTexSize, vec2f(nlife, 0.0));
	let params = lerpResult2.result;
	let paramDiv = lerpResult2.unpacked;
	var rotSpeed = params.x;
	let rotSpeedDiv = paramDiv.y;
	let lerpResult3 = tex1Dlod_lerp(internalTex3, internalTexSize, vec2f(nlife, 0.0));
	let radialParams = lerpResult3.result;
	let radialParamDiv = lerpResult3.unpacked;
	let radialSpeed = radialParams.x;
	let radialSpeedDiv = radialParamDiv.y;
	let respawn = inLife <= 0.0 || outLife >= uniform.lifetime;
	inPos = select(inPos, calcSpawnPosition(rndFactor.xyz, rndFactor.x), respawn);
	inAngle = select(inAngle, mix(uniform.startAngle, uniform.startAngle2, rndFactor.x), respawn);
	#ifndef LOCAL_SPACE
		var radialVel: vec3f = inPos - uniform.emitterPos;
	#else
		var radialVel: vec3f = inPos;
	#endif
	radialVel = select(vec3f(0.0), radialSpeed * normalize(radialVel), dot(radialVel, radialVel) > 1.0E-8);
	radialVel = radialVel + (radialSpeedDiv * vec3f(2.0) - vec3f(1.0)) * uniform.radialSpeedDivMult * rndFactor.xyz;
	localVelocity = localVelocity + (localVelocityDiv * vec3f(2.0) - vec3f(1.0)) * uniform.localVelocityDivMult * rndFactor.xyz;
	velocity = velocity + (velocityDiv * vec3f(2.0) - vec3f(1.0)) * uniform.velocityDivMult * rndFactor.xyz;
	rotSpeed = rotSpeed + (rotSpeedDiv * 2.0 - 1.0) * uniform.rotSpeedDivMult * rndFactor.y;
	addInitialVelocity(&localVelocity, rndFactor.xyz);
	#ifndef LOCAL_SPACE
		outVel = uniform.emitterMatrix * localVelocity + (radialVel + velocity) * uniform.emitterScale;
	#else
		outVel = (localVelocity + radialVel) / uniform.emitterScale + uniform.emitterMatrixInv * velocity;
	#endif
	outPos = inPos + outVel * uniform.delta;
	outAngle = inAngle + rotSpeed * uniform.delta;
`;

var particle_billboard_default2 = `
	let rotationResult = rotateWithMatrix(quadXY, inAngle);
	let rotatedQuadXY = rotationResult.rotatedVec;
	rotMatrix = rotationResult.matrix;
	var localPos = billboard(particlePos, rotatedQuadXY);
`;

var particle_blendAdd_default2 = `
	dBlendModeFogFactor = 0.0;
	rgb = rgb * saturate(gammaCorrectInput(max(a, 0.0)));
	if ((rgb.r + rgb.g + rgb.b) < 0.000001) {
		discard;
	}	
`;

var particle_blendMultiply_default2 = `
	rgb = mix(vec3f(1.0), rgb, a);
	if ((rgb.r + rgb.g + rgb.b) > 2.99) {
		discard;
	}
`;

var particle_blendNormal_default2 = `
	if (a < 0.01) {
		discard;
	}
`;

var particle_cpu_default2 = `
attribute particle_vertexData: vec4f;
attribute particle_vertexData2: vec4f;
attribute particle_vertexData3: vec4f;
attribute particle_vertexData4: f32;
#ifndef USE_MESH
	attribute particle_vertexData5: vec2f;
#else
	attribute particle_vertexData5: vec4f;
#endif
uniform matrix_viewProjection: mat4x4f;
uniform matrix_model: mat4x4f;
#ifndef VIEWMATRIX
	#define VIEWMATRIX
	uniform matrix_view: mat4x4f;
#endif
uniform matrix_normal: mat3x3f;
uniform matrix_viewInverse: mat4x4f;
uniform numParticles: f32;
uniform lifetime: f32;
uniform stretch: f32;
uniform seed: f32;
uniform emitterScale: vec3f;
uniform faceTangent: vec3f;
uniform faceBinorm: vec3f;
#ifdef PARTICLE_GPU
	#ifdef WRAP
		uniform wrapBounds: vec3f;
	#endif
#endif
#ifdef PARTICLE_GPU
	var internalTex0: texture_2d<uff>;
	var internalTex1: texture_2d<uff>;
	var internalTex2: texture_2d<uff>;
#endif
uniform emitterPos: vec3f;
varying texCoordsAlphaLife: vec4f;
struct RotateResult {
	rotatedVec: vec2f,
	matrix: mat2x2f
}
fn rotateWithMatrix(quadXY: vec2f, pRotation: f32) -> RotateResult {
	let c = cos(pRotation);
	let s = sin(pRotation);
	let m = mat2x2f(vec2f(c, -s), vec2f(s, c));
	return RotateResult(m * quadXY, m);
}
fn billboard(InstanceCoords: vec3f, quadXY: vec2f) -> vec3f {
	var pos: vec3f;
	#ifdef SCREEN_SPACE
		pos = vec3f(-1.0, 0.0, 0.0) * quadXY.x + vec3f(0.0, -1.0, 0.0) * quadXY.y;
	#else
		pos = -uniform.matrix_viewInverse[0].xyz * quadXY.x + -uniform.matrix_viewInverse[1].xyz * quadXY.y;
	#endif
	return pos;
}
fn customFace(InstanceCoords: vec3f, quadXY: vec2f) -> vec3f {
	let pos = uniform.faceTangent * quadXY.x + uniform.faceBinorm * quadXY.y;
	return pos;
}
fn safeNormalize(v: vec2f) -> vec2f {
	let l = length(v);
	return select(v, v / l, l > 1e-06);
}
@vertex
fn vertexMain(input: VertexInput) -> VertexOutput {
	var output: VertexOutput;
	var particlePos = input.particle_vertexData.xyz;
	let inPos = particlePos;
	let vertPos = input.particle_vertexData3.xyz;
	var inVel = vec3f(input.particle_vertexData2.w, input.particle_vertexData3.w, input.particle_vertexData5.x);
	let id = floor(input.particle_vertexData4);
	let rndFactor = fract(sin(id + 1.0 + uniform.seed));
	let rndFactor3 = vec3f(rndFactor, fract(rndFactor*10.0), fract(rndFactor*100.0));
	#ifdef LOCAL_SPACE
		let modelRotation = mat3x3f(uniform.matrix_model[0].xyz, uniform.matrix_model[1].xyz, uniform.matrix_model[2].xyz);
		inVel = modelRotation * inVel;
	#endif
	let velocityV = safeNormalize((mat3x3f(uniform.matrix_view[0].xyz, uniform.matrix_view[1].xyz, uniform.matrix_view[2].xyz) * inVel).xy);
	let quadXY = vertPos.xy;
	#ifdef USE_MESH
		output.texCoordsAlphaLife = vec4f(input.particle_vertexData5.zw, input.particle_vertexData2.z, input.particle_vertexData.w);
	#else
		output.texCoordsAlphaLife = vec4f(quadXY * -0.5 + 0.5, input.particle_vertexData2.z, input.particle_vertexData.w);
	#endif
	var rotMatrix: mat2x2f;
	var inAngle = input.particle_vertexData2.x;
	var particlePosMoved = vec3f(0.0);
	let meshLocalPos = input.particle_vertexData3.xyz;
`;

var particle_cpu_end_default2 = `
	localPos = localPos * input.particle_vertexData2.y * uniform.emitterScale;
	localPos = localPos + particlePos;
	#ifdef SCREEN_SPACE
		output.position = vec4f(localPos.x, localPos.y, 0.0, 1.0);
	#else
		output.position = uniform.matrix_viewProjection * vec4f(localPos, 1.0);
	#endif
`;

var particle_customFace_default2 = `
	let rotationResult = rotateWithMatrix(quadXY, inAngle);
	let rotatedQuadXY = rotationResult.rotatedVec;
	rotMatrix = rotationResult.matrix;
	var localPos = customFace(particlePos, rotatedQuadXY);
`;

var particle_end_default3 = `
	rgb = addFog(rgb);
	rgb = toneMap(rgb);
	rgb = gammaCorrectOutput(rgb);
	output.color = vec4f(rgb, a);
	return output;
}
`;

var particle_end_default4 = `
	localPos = localPos * scale * uniform.emitterScale;
	localPos = localPos + particlePos;
	#ifdef SCREEN_SPACE
		output.position = vec4f(localPos.x, localPos.y, 0.0, 1.0);
	#else
		output.position = uniform.matrix_viewProjection * vec4f(localPos.xyz, 1.0);
	#endif
`;

var particle_halflambert_default2 = `
	var negNormal: vec3f = normal * 0.5 + 0.5;
	var posNormal: vec3f = -normal * 0.5 + 0.5;
	negNormal = negNormal * negNormal;
	posNormal = posNormal * posNormal;
`;

var particle_init_default2 = `
attribute particle_vertexData: vec4f;
#if defined(USE_MESH)
	#if defined(USE_MESH_UV)
		attribute particle_uv: vec2f;
	#else
		var<private> particle_uv: vec2f = vec2f(0.0, 0.0);
	#endif
#endif
uniform matrix_viewProjection: mat4x4f;
uniform matrix_model: mat4x4f;
uniform matrix_normal: mat3x3f;
uniform matrix_viewInverse: mat4x4f;
#ifndef VIEWMATRIX
	#define VIEWMATRIX
	uniform matrix_view: mat4x4f;
#endif
uniform numParticles: f32;
uniform numParticlesPot: f32;
uniform graphSampleSize: f32;
uniform graphNumSamples: f32;
uniform stretch: f32;
uniform emitterScale: vec3f;
uniform emitterPos: vec3f;
uniform faceTangent: vec3f;
uniform faceBinorm: vec3f;
uniform rate: f32;
uniform rateDiv: f32;
uniform lifetime: f32;
uniform scaleDivMult: f32;
uniform alphaDivMult: f32;
uniform seed: f32;
uniform delta: f32;
#ifdef PARTICLE_GPU
	#ifdef WRAP
		uniform wrapBounds: vec3f;
	#endif
#endif
var particleTexOUT: texture_2d<uff>;
var particleTexIN: texture_2d<uff>;
#ifdef PARTICLE_GPU
	var internalTex0: texture_2d<uff>;
	var internalTex1: texture_2d<uff>;
	var internalTex2: texture_2d<uff>;
#endif
#ifndef CAMERAPLANES
	#define CAMERAPLANES
	uniform camera_params: vec4f;
#endif
varying texCoordsAlphaLife: vec4f;
var<private> inPos: vec3f;
var<private> inVel: vec3f;
var<private> inAngle: f32;
var<private> inShow: bool;
var<private> inLife: f32;
`;

var particle_lambert_default2 = `
	var negNormal: vec3f = max(normal, vec3(0.0));
	var posNormal: vec3f = max(-normal, vec3(0.0));
`;

var particle_lighting_default2 = `
	let light: vec3f = negNormal.x * uniform.lightCube[0] + posNormal.x * uniform.lightCube[1] +
					   negNormal.y * uniform.lightCube[2] + posNormal.y * uniform.lightCube[3] +
					   negNormal.z * uniform.lightCube[4] + posNormal.z * uniform.lightCube[5];
	rgb = rgb * light;
`;

var particle_localShift_default2 = `
particlePos = (uniform.matrix_model * vec4f(particlePos, 1.0)).xyz;
`;

var particle_mesh_default2 = `
var localPos = meshLocalPos;
let rotResultXY = rotateWithMatrix(localPos.xy, inAngle);
localPos = vec3f(rotResultXY.rotatedVec, localPos.z);
rotMatrix = rotResultXY.matrix;
let rotResultYZ = rotateWithMatrix(localPos.yz, inAngle);
localPos = vec3f(localPos.x, rotResultYZ.rotatedVec);
rotMatrix = rotResultYZ.matrix;
billboard(particlePos, quadXY);
`;

var particle_normal_default2 = `
output.Normal = normalize(localPos + uniform.matrix_viewInverse[2].xyz);
`;

var particle_normalMap_default2 = `
	let sampledNormal: vec4f = textureSample(normalMap, normalMapSampler, vec2f(input.texCoordsAlphaLife.x, 1.0 - input.texCoordsAlphaLife.y));
	let normalMap: vec3f = normalize(sampledNormal.xyz * 2.0 - 1.0);
	let ParticleMat = mat3x3<f32>(ParticleMat0, ParticleMat1, ParticleMat2);
	let normal: vec3f = ParticleMat * normalMap;
`;

var particle_pointAlong_default2 = `
	inAngle = atan2(velocityV.x, velocityV.y);
`;

var particle_simulation_default2 = `
	#include "particleUpdaterInitPS"
	#include "particleInputPS"
	#include "particleOutputPS"
	#ifdef EMITTERSHAPE_BOX
		#include "particleUpdaterAABBPS"
	#else
		#include "particleUpdaterSpherePS"
	#endif
	#include "particleUpdaterStartPS"
	#ifdef RESPAWN
		#include "particleUpdaterRespawnPS"
	#endif
	#ifdef NO_RESPAWN
		#include "particleUpdaterNoRespawnPS"
	#endif
	#ifdef ON_STOP
		#include "particleUpdaterOnStopPS"
	#endif
	#include "particleUpdaterEndPS"
`;

var particle_shader_default3 = `
	#if NORMAL != NONE
		#if NORMAL == VERTEX
			varying Normal: vec3f;
		#endif
		#if NORMAL == MAP
			varying ParticleMat0: vec3f;
			varying ParticleMat1: vec3f;
			varying ParticleMat2: vec3f;
		#endif
		uniform lightCube: array<vec3f, 6>;
	#endif
	#ifdef SOFT
		varying vDepth: f32;
		#include "screenDepthPS"
	#endif
	#include "gammaPS"
	#include "tonemappingPS"
	#include "fogPS"
	#if NORMAL == MAP
		var normalMap: texture_2d<f32>;
		var normalMapSampler: sampler;
	#endif
	#include "particlePS"
	#ifdef SOFT
		#include "particle_softPS"
	#endif
	#if NORMAL == VERTEX
		var normal: vec3f = Normal;
	#endif
	#if NORMAL == MAP
		#include "particle_normalMapPS"
	#endif
	#if NORMAL != NONE
		#ifdef HALF_LAMBERT
			#include "particle_halflambertPS"
		#else
			#include "particle_lambertPS"
		#endif
		#include "particle_lightingPS"
	#endif
	#if BLEND == NORMAL
		#include "particle_blendNormalPS"
	#elif BLEND == ADDITIVE
		#include "particle_blendAddPS"
	#elif BLEND == MULTIPLICATIVE
		#include "particle_blendMultiplyPS"
	#endif
	#include "particle_endPS"
`;

var particle_shader_default4 = `
	#ifdef ANIMTEX
		uniform animTexTilesParams: vec2f;
		uniform animTexParams: vec4f;
		uniform animTexIndexParams: vec2f;
	#endif
	#if NORMAL == MAP
		varying ParticleMat0: vec3f;
		varying ParticleMat1: vec3f;
		varying ParticleMat2: vec3f;
	#endif
	#if NORMAL == VERTEX
		varying Normal: vec3f;
	#endif
	#ifdef SOFT
		varying vDepth: f32;
	#endif
	#ifdef PARTICLE_GPU
		#include "particle_initVS"
		#include "particleInputPS"
		#ifdef SOFT
			#include "screenDepthPS"
		#endif
		#include "particleVS"
	#else
		#ifdef SOFT
			#include "screenDepthPS"
		#endif
		#include "particle_cpuVS"
	#endif
	#ifdef LOCAL_SPACE
		#include "particle_localShiftVS"
	#endif
	#ifdef ANIMTEX
		#ifdef ANIMTEX_LOOP
			#include "particleAnimFrameLoopVS"
		#else
			#include "particleAnimFrameClampVS"
		#endif
		#include "particleAnimTexVS"
	#endif
	#ifdef PARTICLE_GPU
		#ifdef WRAP
			#include "particle_wrapVS"
		#endif
	#endif
	#ifdef ALIGN_TO_MOTION
		#include "particle_pointAlongVS"
	#endif
	#ifdef USE_MESH
		#include "particle_meshVS"
	#else
		#ifdef CUSTOM_FACE
			#include "particle_customFaceVS"
		#else
			#include "particle_billboardVS"
		#endif
	#endif
	#if NORMAL == VERTEX
		#include "particle_normalVS"
	#endif
	#if NORMAL == MAP
		#include "particle_TBNVS"
	#endif
	#ifdef STRETCH
		#include "particle_stretchVS"
	#endif
	#ifdef PARTICLE_GPU
		#include "particle_endVS"
	#else
		#include "particle_cpu_endVS"
	#endif
	#ifdef SOFT
		#include "particle_softVS"
	#endif
	return output;
}
`;

var particle_soft_default3 = `
	var depth: f32 = getLinearScreenDepthFrag();
	var particleDepth: f32 = vDepth;
	var depthDiff: f32 = saturate(abs(particleDepth - depth) * uniform.softening);
	a = a * depthDiff;
`;

var particle_soft_default4 = `
	output.vDepth = getLinearDepth(localPos);
`;

var particle_stretch_default2 = `
	let moveDir: vec3f = inVel * uniform.stretch;
	var posPrev: vec3f = particlePos - moveDir;
	posPrev = posPrev + particlePosMoved;
	let viewRotationTemp: mat3x3f = mat3x3f(uniform.matrix_view[0].xyz, uniform.matrix_view[1].xyz, uniform.matrix_view[2].xyz);
	let centerToVertexV: vec2f = normalize((viewRotationTemp * localPos).xy);
	let interpolation: f32 = dot(-velocityV, centerToVertexV) * 0.5 + 0.5;
	particlePos = mix(particlePos, posPrev, interpolation);
`;

var particle_TBN_default2 = `
	let rot3 = mat3x3f(
		vec3f(rotMatrix[0][0], rotMatrix[1][0], 0.0),
		vec3f(rotMatrix[0][1], rotMatrix[1][1], 0.0),
		vec3f(0.0, 0.0, 1.0)
	);
	let viewBasis = mat3x3f(
		-uniform.matrix_viewInverse[0].xyz,
		-uniform.matrix_viewInverse[1].xyz,
		uniform.matrix_viewInverse[2].xyz
	);
	let tempMat = viewBasis * rot3;
	output.ParticleMat0 = tempMat[0];
	output.ParticleMat1 = tempMat[1];
	output.ParticleMat2 = tempMat[2];
`;

var particle_wrap_default2 = `
	let origParticlePos: vec3f = particlePos;
	particlePos = particlePos - uniform.matrix_model[3].xyz;
	particlePos = (particlePos % uniform.wrapBounds) - uniform.wrapBounds * 0.5;
	particlePos = particlePos + uniform.matrix_model[3].xyz;
	particlePosMoved = particlePos - origParticlePos;
`;

var particleChunksWGSL = {
	particlePS: particle_default3,
	particleVS: particle_default4,
	particleAnimFrameClampVS: particleAnimFrameClamp_default2,
	particleAnimFrameLoopVS: particleAnimFrameLoop_default2,
	particleAnimTexVS: particleAnimTex_default2,
	particleInputPS: particleInput_default2,
	particleOutputPS: particleOutput_default2,
	particleUpdaterAABBPS: particleUpdaterAABB_default2,
	particleUpdaterEndPS: particleUpdaterEnd_default2,
	particleUpdaterInitPS: particleUpdaterInit_default2,
	particleUpdaterNoRespawnPS: particleUpdaterNoRespawn_default2,
	particleUpdaterOnStopPS: particleUpdaterOnStop_default2,
	particleUpdaterRespawnPS: particleUpdaterRespawn_default2,
	particleUpdaterSpherePS: particleUpdaterSphere_default2,
	particleUpdaterStartPS: particleUpdaterStart_default2,
	particle_billboardVS: particle_billboard_default2,
	particle_blendAddPS: particle_blendAdd_default2,
	particle_blendMultiplyPS: particle_blendMultiply_default2,
	particle_blendNormalPS: particle_blendNormal_default2,
	particle_cpuVS: particle_cpu_default2,
	particle_cpu_endVS: particle_cpu_end_default2,
	particle_customFaceVS: particle_customFace_default2,
	particle_endPS: particle_end_default3,
	particle_endVS: particle_end_default4,
	particle_halflambertPS: particle_halflambert_default2,
	particle_initVS: particle_init_default2,
	particle_lambertPS: particle_lambert_default2,
	particle_lightingPS: particle_lighting_default2,
	particle_localShiftVS: particle_localShift_default2,
	particle_meshVS: particle_mesh_default2,
	particle_normalVS: particle_normal_default2,
	particle_normalMapPS: particle_normalMap_default2,
	particle_pointAlongVS: particle_pointAlong_default2,
	particle_simulationPS: particle_simulation_default2,
	particle_shaderPS: particle_shader_default3,
	particle_shaderVS: particle_shader_default4,
	particle_softPS: particle_soft_default3,
	particle_softVS: particle_soft_default4,
	particle_stretchVS: particle_stretch_default2,
	particle_TBNVS: particle_TBN_default2,
	particle_wrapVS: particle_wrap_default2
};

var _propertyTypes = {
	emitterExtents: "vec3",
	emitterExtentsInner: "vec3",
	particleNormal: "vec3",
	wrapBounds: "vec3",
	localVelocityGraph: "curveset",
	localVelocityGraph2: "curveset",
	velocityGraph: "curveset",
	velocityGraph2: "curveset",
	colorGraph: "curveset",
	colorGraph2: "curveset",
	alphaGraph: "curve",
	alphaGraph2: "curve",
	rotationSpeedGraph: "curve",
	rotationSpeedGraph2: "curve",
	radialSpeedGraph: "curve",
	radialSpeedGraph2: "curve",
	scaleGraph: "curve",
	scaleGraph2: "curve"
};
var ParticleSystemComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "particlesystem";
		this.ComponentType = ParticleSystemComponent;
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.systems.on("update", this.onUpdate, this);
		ShaderChunks.get(app2.graphicsDevice, SHADERLANGUAGE_GLSL).add(particleChunksGLSL);
		ShaderChunks.get(app2.graphicsDevice, SHADERLANGUAGE_WGSL).add(particleChunksWGSL);
	}
	initializeComponentData(component, _data) {
		const data2 = { ..._data };
		if (data2.mesh instanceof Asset || typeof data2.mesh === "number") {
			data2.meshAsset = data2.mesh;
			delete data2.mesh;
		}
		for (const prop in data2) {
			if (data2[prop] === void 0 || data2[prop] === null) continue;
			const type = _propertyTypes[prop];
			if (type === "vec3") {
				if (Array.isArray(data2[prop])) {
					data2[prop] = new Vec3(data2[prop][0], data2[prop][1], data2[prop][2]);
				}
			} else if (type === "curve") {
				if (!(data2[prop] instanceof Curve)) {
					const t = data2[prop].type;
					data2[prop] = new Curve(data2[prop].keys);
					data2[prop].type = t;
				}
			} else if (type === "curveset") {
				if (!(data2[prop] instanceof CurveSet)) {
					const t = data2[prop].type;
					data2[prop] = new CurveSet(data2[prop].keys);
					data2[prop].type = t;
				}
			}
		}
		if (data2.layers && Array.isArray(data2.layers)) {
			data2.layers = data2.layers.slice(0);
		}
		if (data2.enabled !== void 0) {
			component._enabled = data2.enabled;
		}
		for (let i2 = 0; i2 < _properties6.length; i2++) {
			const property = _properties6[i2];
			if (data2[property] !== void 0) {
				component[property] = data2[property];
			}
		}
		super.initializeComponentData(component, data2);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.particlesystem;
		const data2 = {
			enabled: c2.enabled
		};
		for (let i2 = 0; i2 < _properties6.length; i2++) {
			const prop = _properties6[i2];
			const value = c2[prop];
			if (value instanceof Vec3 || value instanceof Curve || value instanceof CurveSet) {
				data2[prop] = value.clone();
			} else if (prop === "layers") {
				data2.layers = value.slice(0);
			} else if (value !== null && value !== void 0) {
				data2[prop] = value;
			}
		}
		return this.addComponent(clone, data2);
	}
	onUpdate(dt) {
		const components2 = this.store;
		const stats = this.app.stats.particles;
		const composition = this.app.scene.layers;
		for (let i2 = 0; i2 < composition.layerList.length; i2++) {
			composition.layerList[i2].requiresLightCube = false;
		}
		for (const id14 in components2) {
			if (components2.hasOwnProperty(id14)) {
				const component = components2[id14].entity.particlesystem;
				const entity = component.entity;
				if (component.enabled && entity.enabled) {
					const emitter = component.emitter;
					if (!emitter?.meshInstance.visible) continue;
					if (emitter.lighting) {
						const layers = component.layers;
						for (let i2 = 0; i2 < layers.length; i2++) {
							const layer = composition.getLayerById(layers[i2]);
							if (layer) {
								layer.requiresLightCube = true;
							}
						}
					}
					if (!component._paused) {
						let numSteps = 0;
						emitter.simTime += dt;
						if (emitter.simTime >= emitter.fixedTimeStep) {
							numSteps = Math.floor(emitter.simTime / emitter.fixedTimeStep);
							emitter.simTime -= numSteps * emitter.fixedTimeStep;
						}
						if (numSteps) {
							numSteps = Math.min(numSteps, emitter.maxSubSteps);
							for (let i2 = 0; i2 < numSteps; i2++) {
								emitter.addTime(emitter.fixedTimeStep, false);
							}
							stats._updatesPerFrame += numSteps;
							stats._frameTime += emitter._addTimeTime;
							emitter._addTimeTime = 0;
						}
						emitter.finishFrame();
					}
				}
			}
		}
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	destroy() {
		super.destroy();
		this.app.systems.off("update", this.onUpdate, this);
	}
};

var SkinInstanceCachedObject = class extends RefCountedObject {
	constructor(skin, skinInstance) {
		super();
		this.skin = skin;
		this.skinInstance = skinInstance;
	}
};
var SkinInstanceCache = class _SkinInstanceCache {
	// map of SkinInstances allowing those to be shared between
	// (specifically a single glb with multiple render components)
	// It maps a rootBone to an array of SkinInstanceCachedObject
	// this allows us to find if a skin instance already exists for a rootbone, and a specific skin
	static _skinInstanceCache = /* @__PURE__ */ new Map();
	// returns cached or creates a skin instance for the skin and a rootBone, to be used by render component
	// on the specified entity
	static createCachedSkinInstance(skin, rootBone, entity) {
		let skinInst = _SkinInstanceCache.getCachedSkinInstance(skin, rootBone);
		if (!skinInst) {
			skinInst = new SkinInstance(skin);
			skinInst.resolve(rootBone, entity);
			_SkinInstanceCache.addCachedSkinInstance(skin, rootBone, skinInst);
		}
		return skinInst;
	}
	// returns already created skin instance from skin, for use on the rootBone
	// ref count of existing skinInstance is increased
	static getCachedSkinInstance(skin, rootBone) {
		let skinInstance = null;
		const cachedObjArray = _SkinInstanceCache._skinInstanceCache.get(rootBone);
		if (cachedObjArray) {
			const cachedObj = cachedObjArray.find((element) => element.skin === skin);
			if (cachedObj) {
				cachedObj.incRefCount();
				skinInstance = cachedObj.skinInstance;
			}
		}
		return skinInstance;
	}
	// adds skin instance to the cache, and increases ref count on it
	static addCachedSkinInstance(skin, rootBone, skinInstance) {
		let cachedObjArray = _SkinInstanceCache._skinInstanceCache.get(rootBone);
		if (!cachedObjArray) {
			cachedObjArray = [];
			_SkinInstanceCache._skinInstanceCache.set(rootBone, cachedObjArray);
		}
		let cachedObj = cachedObjArray.find((element) => element.skin === skin);
		if (!cachedObj) {
			cachedObj = new SkinInstanceCachedObject(skin, skinInstance);
			cachedObjArray.push(cachedObj);
		}
		cachedObj.incRefCount();
	}
	// removes skin instance from the cache. This decreases ref count, and when that reaches 0 it gets destroyed
	static removeCachedSkinInstance(skinInstance) {
		if (skinInstance) {
			const rootBone = skinInstance.rootBone;
			if (rootBone) {
				const cachedObjArray = _SkinInstanceCache._skinInstanceCache.get(rootBone);
				if (cachedObjArray) {
					const cachedObjIndex = cachedObjArray.findIndex((element) => element.skinInstance === skinInstance);
					if (cachedObjIndex >= 0) {
						const cachedObj = cachedObjArray[cachedObjIndex];
						cachedObj.decRefCount();
						if (cachedObj.refCount === 0) {
							cachedObjArray.splice(cachedObjIndex, 1);
							if (!cachedObjArray.length) {
								_SkinInstanceCache._skinInstanceCache.delete(rootBone);
							}
							if (skinInstance) {
								skinInstance.destroy();
								cachedObj.skinInstance = null;
							}
						}
					}
				}
			}
		}
	}
};

var AssetReference = class {
	_evtLoadById = null;
	_evtUnloadById = null;
	_evtAddById = null;
	_evtRemoveById = null;
	_evtLoadByUrl = null;
	_evtAddByUrl = null;
	_evtRemoveByUrl = null;
	constructor(propertyName, parent, registry, callbacks, scope) {
		this.propertyName = propertyName;
		this.parent = parent;
		this._scope = scope;
		this._registry = registry;
		this.id = null;
		this.url = null;
		this.asset = null;
		this._onAssetLoad = callbacks.load;
		this._onAssetAdd = callbacks.add;
		this._onAssetRemove = callbacks.remove;
		this._onAssetUnload = callbacks.unload;
	}
	set id(value) {
		if (this.url) throw Error("Can't set id and url");
		this._unbind();
		this._id = value;
		this.asset = this._registry.get(this._id);
		this._bind();
	}
	get id() {
		return this._id;
	}
	set url(value) {
		if (this.id) throw Error("Can't set id and url");
		this._unbind();
		this._url = value;
		this.asset = this._registry.getByUrl(this._url);
		this._bind();
	}
	get url() {
		return this._url;
	}
	_bind() {
		if (this.id) {
			if (this._onAssetLoad) this._evtLoadById = this._registry.on(`load:${this.id}`, this._onLoad, this);
			if (this._onAssetAdd) this._evtAddById = this._registry.once(`add:${this.id}`, this._onAdd, this);
			if (this._onAssetRemove) this._evtRemoveById = this._registry.on(`remove:${this.id}`, this._onRemove, this);
			if (this._onAssetUnload) this._evtUnloadById = this._registry.on(`unload:${this.id}`, this._onUnload, this);
		}
		if (this.url) {
			if (this._onAssetLoad) this._evtLoadByUrl = this._registry.on(`load:url:${this.url}`, this._onLoad, this);
			if (this._onAssetAdd) this._evtAddByUrl = this._registry.once(`add:url:${this.url}`, this._onAdd, this);
			if (this._onAssetRemove) this._evtRemoveByUrl = this._registry.on(`remove:url:${this.url}`, this._onRemove, this);
		}
	}
	_unbind() {
		if (this.id) {
			this._evtLoadById?.off();
			this._evtLoadById = null;
			this._evtAddById?.off();
			this._evtAddById = null;
			this._evtRemoveById?.off();
			this._evtRemoveById = null;
			this._evtUnloadById?.off();
			this._evtUnloadById = null;
		}
		if (this.url) {
			this._evtLoadByUrl?.off();
			this._evtLoadByUrl = null;
			this._evtAddByUrl?.off();
			this._evtAddByUrl = null;
			this._evtRemoveByUrl?.off();
			this._evtRemoveByUrl = null;
		}
	}
	_onLoad(asset) {
		this._onAssetLoad.call(this._scope, this.propertyName, this.parent, asset);
	}
	_onAdd(asset) {
		this.asset = asset;
		this._onAssetAdd.call(this._scope, this.propertyName, this.parent, asset);
	}
	_onRemove(asset) {
		this._onAssetRemove.call(this._scope, this.propertyName, this.parent, asset);
		this.asset = null;
	}
	_onUnload(asset) {
		this._onAssetUnload.call(this._scope, this.propertyName, this.parent, asset);
	}
};

var RenderComponent = class extends Component {
	_type = "asset";
	_castShadows = true;
	_receiveShadows = true;
	_castShadowsLightmap = true;
	_lightmapped = false;
	_lightmapSizeMultiplier = 1;
	isStatic = false;
	_batchGroupId = -1;
	_layers = [LAYERID_WORLD];
	// assign to the default world layer
	_renderStyle = RENDERSTYLE_SOLID;
	_meshInstances = [];
	_customAabb = null;
	_area = null;
	_assetReference;
	_materialReferences = [];
	_material;
	_rootBone = null;
	_evtLayersChanged = null;
	_evtLayerAdded = null;
	_evtLayerRemoved = null;
	_evtSetMeshes = null;
	constructor(system, entity) {
		super(system, entity);
		this._assetReference = new AssetReference(
			"asset",
			this,
			system.app.assets,
			{
				add: this._onRenderAssetAdded,
				load: this._onRenderAssetLoad,
				remove: this._onRenderAssetRemove,
				unload: this._onRenderAssetUnload
			},
			this
		);
		this._material = system.defaultMaterial;
		entity.on("remove", this.onRemoveChild, this);
		entity.on("removehierarchy", this.onRemoveChild, this);
		entity.on("insert", this.onInsertChild, this);
		entity.on("inserthierarchy", this.onInsertChild, this);
	}
	set renderStyle(renderStyle) {
		if (this._renderStyle !== renderStyle) {
			this._renderStyle = renderStyle;
			MeshInstance._prepareRenderStyleForArray(this._meshInstances, renderStyle);
		}
	}
	get renderStyle() {
		return this._renderStyle;
	}
	set customAabb(value) {
		this._customAabb = value;
		const mi = this._meshInstances;
		if (mi) {
			for (let i2 = 0; i2 < mi.length; i2++) {
				mi[i2].setCustomAabb(this._customAabb);
			}
		}
	}
	get customAabb() {
		return this._customAabb;
	}
	set type(value) {
		if (this._type !== value) {
			this._area = null;
			this._type = value;
			this.destroyMeshInstances();
			if (value !== "asset") {
				let material = this._material;
				if (!material || material === this.system.defaultMaterial) {
					material = this._materialReferences[0] && this._materialReferences[0].asset && this._materialReferences[0].asset.resource;
				}
				const primData = getShapePrimitive(this.system.app.graphicsDevice, value);
				this._area = primData.area;
				this.meshInstances = [new MeshInstance(primData.mesh, material || this.system.defaultMaterial, this.entity)];
			}
		}
	}
	get type() {
		return this._type;
	}
	set meshInstances(value) {
		this.destroyMeshInstances();
		this._meshInstances = value;
		if (this._meshInstances) {
			const mi = this._meshInstances;
			for (let i2 = 0; i2 < mi.length; i2++) {
				if (!mi[i2].node) {
					mi[i2].node = this.entity;
				}
				mi[i2].castShadow = this._castShadows;
				mi[i2].receiveShadow = this._receiveShadows;
				mi[i2].renderStyle = this._renderStyle;
				mi[i2].setLightmapped(this._lightmapped);
				mi[i2].setCustomAabb(this._customAabb);
			}
			if (this.enabled && this.entity.enabled) {
				this.addToLayers();
			}
		}
	}
	get meshInstances() {
		return this._meshInstances;
	}
	set lightmapped(value) {
		if (value !== this._lightmapped) {
			this._lightmapped = value;
			const mi = this._meshInstances;
			if (mi) {
				for (let i2 = 0; i2 < mi.length; i2++) {
					mi[i2].setLightmapped(value);
				}
			}
		}
	}
	get lightmapped() {
		return this._lightmapped;
	}
	set castShadows(value) {
		if (this._castShadows !== value) {
			const mi = this._meshInstances;
			if (mi) {
				const layers = this.layers;
				const scene = this.system.app.scene;
				if (this._castShadows && !value) {
					for (let i2 = 0; i2 < layers.length; i2++) {
						const layer = scene.layers.getLayerById(this.layers[i2]);
						if (layer) {
							layer.removeShadowCasters(mi);
						}
					}
				}
				for (let i2 = 0; i2 < mi.length; i2++) {
					mi[i2].castShadow = value;
				}
				if (!this._castShadows && value) {
					for (let i2 = 0; i2 < layers.length; i2++) {
						const layer = scene.layers.getLayerById(layers[i2]);
						if (layer) {
							layer.addShadowCasters(mi);
						}
					}
				}
			}
			this._castShadows = value;
		}
	}
	get castShadows() {
		return this._castShadows;
	}
	set receiveShadows(value) {
		if (this._receiveShadows !== value) {
			this._receiveShadows = value;
			const mi = this._meshInstances;
			if (mi) {
				for (let i2 = 0; i2 < mi.length; i2++) {
					mi[i2].receiveShadow = value;
				}
			}
		}
	}
	get receiveShadows() {
		return this._receiveShadows;
	}
	set castShadowsLightmap(value) {
		this._castShadowsLightmap = value;
	}
	get castShadowsLightmap() {
		return this._castShadowsLightmap;
	}
	set lightmapSizeMultiplier(value) {
		this._lightmapSizeMultiplier = value;
	}
	get lightmapSizeMultiplier() {
		return this._lightmapSizeMultiplier;
	}
	set layers(value) {
		const layers = this.system.app.scene.layers;
		let layer;
		if (this._meshInstances) {
			for (let i2 = 0; i2 < this._layers.length; i2++) {
				layer = layers.getLayerById(this._layers[i2]);
				if (layer) {
					layer.removeMeshInstances(this._meshInstances);
				}
			}
		}
		this._layers.length = 0;
		for (let i2 = 0; i2 < value.length; i2++) {
			this._layers[i2] = value[i2];
		}
		if (!this.enabled || !this.entity.enabled || !this._meshInstances) return;
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			layer = layers.getLayerById(this._layers[i2]);
			if (layer) {
				layer.addMeshInstances(this._meshInstances);
			}
		}
	}
	get layers() {
		return this._layers;
	}
	set batchGroupId(value) {
		if (this._batchGroupId !== value) {
			if (this.entity.enabled && this._batchGroupId >= 0) {
				this.system.app.batcher?.remove(BatchGroup.RENDER, this.batchGroupId, this.entity);
			}
			if (this.entity.enabled && value >= 0) {
				this.system.app.batcher?.insert(BatchGroup.RENDER, value, this.entity);
			}
			if (value < 0 && this._batchGroupId >= 0 && this.enabled && this.entity.enabled) {
				this.addToLayers();
			}
			this._batchGroupId = value;
		}
	}
	get batchGroupId() {
		return this._batchGroupId;
	}
	set material(value) {
		if (this._material !== value) {
			this._material = value;
			if (this._meshInstances && this._type !== "asset") {
				for (let i2 = 0; i2 < this._meshInstances.length; i2++) {
					this._meshInstances[i2].material = value;
				}
			}
		}
	}
	get material() {
		return this._material;
	}
	set materialAssets(value = []) {
		if (this._materialReferences.length > value.length) {
			for (let i2 = value.length; i2 < this._materialReferences.length; i2++) {
				this._materialReferences[i2].id = null;
			}
			this._materialReferences.length = value.length;
		}
		for (let i2 = 0; i2 < value.length; i2++) {
			if (!this._materialReferences[i2]) {
				this._materialReferences.push(
					new AssetReference(
						i2,
						this,
						this.system.app.assets,
						{
							add: this._onMaterialAdded,
							load: this._onMaterialLoad,
							remove: this._onMaterialRemove,
							unload: this._onMaterialUnload
						},
						this
					)
				);
			}
			if (value[i2]) {
				const id14 = value[i2] instanceof Asset ? value[i2].id : value[i2];
				if (this._materialReferences[i2].id !== id14) {
					this._materialReferences[i2].id = id14;
				}
				if (this._materialReferences[i2].asset) {
					this._onMaterialAdded(i2, this, this._materialReferences[i2].asset);
				}
			} else {
				this._materialReferences[i2].id = null;
				if (this._meshInstances[i2]) {
					this._meshInstances[i2].material = this.system.defaultMaterial;
				}
			}
		}
	}
	get materialAssets() {
		return this._materialReferences.map((ref) => {
			return ref.id;
		});
	}
	set asset(value) {
		const id14 = value instanceof Asset ? value.id : value;
		if (this._assetReference.id === id14) return;
		if (this._assetReference.asset && this._assetReference.asset.resource) {
			this._onRenderAssetRemove();
		}
		this._assetReference.id = id14;
		if (this._assetReference.asset) {
			this._onRenderAssetAdded();
		}
	}
	get asset() {
		return this._assetReference.id;
	}
	assignAsset(asset) {
		const id14 = asset instanceof Asset ? asset.id : asset;
		this._assetReference.id = id14;
	}
	set rootBone(value) {
		if (this._rootBone !== value) {
			const isString = typeof value === "string";
			if (this._rootBone && isString && this._rootBone.guid === value) {
				return;
			}
			if (this._rootBone) {
				this._clearSkinInstances();
			}
			if (value instanceof GraphNode) {
				this._rootBone = value;
			} else if (isString) {
				this._rootBone = this.system.app.getEntityFromIndex(value) || null;
				if (!this._rootBone) {
				}
			} else {
				this._rootBone = null;
			}
			if (this._rootBone) {
				this._cloneSkinInstances();
			}
		}
	}
	get rootBone() {
		return this._rootBone;
	}
	destroyMeshInstances() {
		const meshInstances = this._meshInstances;
		if (meshInstances) {
			this.removeFromLayers();
			this._clearSkinInstances();
			for (let i2 = 0; i2 < meshInstances.length; i2++) {
				meshInstances[i2].destroy();
			}
			this._meshInstances.length = 0;
		}
	}
	addToLayers() {
		const layers = this.system.app.scene.layers;
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = layers.getLayerById(this._layers[i2]);
			if (layer) {
				layer.addMeshInstances(this._meshInstances);
			}
		}
	}
	removeFromLayers() {
		if (this._meshInstances && this._meshInstances.length) {
			const layers = this.system.app.scene.layers;
			for (let i2 = 0; i2 < this._layers.length; i2++) {
				const layer = layers.getLayerById(this._layers[i2]);
				if (layer) {
					layer.removeMeshInstances(this._meshInstances);
				}
			}
		}
	}
	onRemoveChild() {
		this.removeFromLayers();
	}
	onInsertChild() {
		if (this._meshInstances && this.enabled && this.entity.enabled) {
			this.addToLayers();
		}
	}
	onBeforeRemove() {
		this.destroyMeshInstances();
		this.asset = null;
		this.materialAsset = null;
		this._assetReference.id = null;
		for (let i2 = 0; i2 < this._materialReferences.length; i2++) {
			this._materialReferences[i2].id = null;
		}
		this.entity.off("remove", this.onRemoveChild, this);
		this.entity.off("insert", this.onInsertChild, this);
	}
	onLayersChanged(oldComp, newComp) {
		this.addToLayers();
		oldComp.off("add", this.onLayerAdded, this);
		oldComp.off("remove", this.onLayerRemoved, this);
		newComp.on("add", this.onLayerAdded, this);
		newComp.on("remove", this.onLayerRemoved, this);
	}
	onLayerAdded(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		layer.addMeshInstances(this._meshInstances);
	}
	onLayerRemoved(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		layer.removeMeshInstances(this._meshInstances);
	}
	onEnable() {
		const app2 = this.system.app;
		const scene = app2.scene;
		const layers = scene.layers;
		if (this._rootBone) {
			this._cloneSkinInstances();
		}
		this._evtLayersChanged = scene.on("set:layers", this.onLayersChanged, this);
		if (layers) {
			this._evtLayerAdded = layers.on("add", this.onLayerAdded, this);
			this._evtLayerRemoved = layers.on("remove", this.onLayerRemoved, this);
		}
		const isAsset = this._type === "asset";
		if (this._meshInstances && this._meshInstances.length) {
			this.addToLayers();
		} else if (isAsset && this.asset) {
			this._onRenderAssetAdded();
		}
		for (let i2 = 0; i2 < this._materialReferences.length; i2++) {
			if (this._materialReferences[i2].asset) {
				this.system.app.assets.load(this._materialReferences[i2].asset);
			}
		}
		if (this._batchGroupId >= 0) {
			app2.batcher?.insert(BatchGroup.RENDER, this.batchGroupId, this.entity);
		}
	}
	onDisable() {
		const app2 = this.system.app;
		const scene = app2.scene;
		const layers = scene.layers;
		this._evtLayersChanged?.off();
		this._evtLayersChanged = null;
		if (this._rootBone) {
			this._clearSkinInstances();
		}
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = null;
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = null;
		}
		if (this._batchGroupId >= 0) {
			app2.batcher?.remove(BatchGroup.RENDER, this.batchGroupId, this.entity);
		}
		this.removeFromLayers();
	}
	hide() {
		if (this._meshInstances) {
			for (let i2 = 0; i2 < this._meshInstances.length; i2++) {
				this._meshInstances[i2].visible = false;
			}
		}
	}
	show() {
		if (this._meshInstances) {
			for (let i2 = 0; i2 < this._meshInstances.length; i2++) {
				this._meshInstances[i2].visible = true;
			}
		}
	}
	_onRenderAssetAdded() {
		if (!this._assetReference.asset) return;
		if (this._assetReference.asset.resource) {
			this._onRenderAssetLoad();
		} else if (this.enabled && this.entity.enabled) {
			this.system.app.assets.load(this._assetReference.asset);
		}
	}
	_onRenderAssetLoad() {
		this.destroyMeshInstances();
		if (this._assetReference.asset) {
			const render = this._assetReference.asset.resource;
			this._evtSetMeshes?.off();
			this._evtSetMeshes = render.on("set:meshes", this._onSetMeshes, this);
			if (render.meshes) {
				this._onSetMeshes(render.meshes);
			}
		}
	}
	_onSetMeshes(meshes) {
		this._cloneMeshes(meshes);
	}
	_clearSkinInstances() {
		for (let i2 = 0; i2 < this._meshInstances.length; i2++) {
			const meshInstance = this._meshInstances[i2];
			SkinInstanceCache.removeCachedSkinInstance(meshInstance.skinInstance);
			meshInstance.skinInstance = null;
		}
	}
	_cloneSkinInstances() {
		if (this._meshInstances.length && this._rootBone instanceof GraphNode) {
			for (let i2 = 0; i2 < this._meshInstances.length; i2++) {
				const meshInstance = this._meshInstances[i2];
				const mesh = meshInstance.mesh;
				if (mesh.skin && !meshInstance.skinInstance) {
					meshInstance.skinInstance = SkinInstanceCache.createCachedSkinInstance(mesh.skin, this._rootBone, this.entity);
				}
			}
		}
	}
	_cloneMeshes(meshes) {
		if (meshes && meshes.length) {
			const meshInstances = [];
			for (let i2 = 0; i2 < meshes.length; i2++) {
				const mesh = meshes[i2];
				const material = this._materialReferences[i2] && this._materialReferences[i2].asset && this._materialReferences[i2].asset.resource;
				const meshInst = new MeshInstance(mesh, material || this.system.defaultMaterial, this.entity);
				meshInstances.push(meshInst);
				if (mesh.morph) {
					meshInst.morphInstance = new MorphInstance(mesh.morph);
				}
			}
			this.meshInstances = meshInstances;
			this._cloneSkinInstances();
		}
	}
	_onRenderAssetUnload() {
		if (this._type === "asset") {
			this.destroyMeshInstances();
		}
	}
	_onRenderAssetRemove() {
		this._evtSetMeshes?.off();
		this._evtSetMeshes = null;
		this._onRenderAssetUnload();
	}
	_onMaterialAdded(index, component, asset) {
		if (asset.resource) {
			this._onMaterialLoad(index, component, asset);
		} else {
			if (this.enabled && this.entity.enabled) {
				this.system.app.assets.load(asset);
			}
		}
	}
	_updateMainMaterial(index, material) {
		if (index === 0) {
			this.material = material;
		}
	}
	_onMaterialLoad(index, component, asset) {
		if (this._meshInstances[index]) {
			this._meshInstances[index].material = asset.resource;
		}
		this._updateMainMaterial(index, asset.resource);
	}
	_onMaterialRemove(index, component, asset) {
		if (this._meshInstances[index]) {
			this._meshInstances[index].material = this.system.defaultMaterial;
		}
		this._updateMainMaterial(index, this.system.defaultMaterial);
	}
	_onMaterialUnload(index, component, asset) {
		if (this._meshInstances[index]) {
			this._meshInstances[index].material = this.system.defaultMaterial;
		}
		this._updateMainMaterial(index, this.system.defaultMaterial);
	}
	resolveDuplicatedEntityReferenceProperties(oldRender, duplicatedIdsMap) {
		if (oldRender.rootBone) {
			this.rootBone = duplicatedIdsMap[oldRender.rootBone.guid];
		}
	}
};

var _properties7 = [
	"material",
	"meshInstances",
	"asset",
	"materialAssets",
	"castShadows",
	"receiveShadows",
	"castShadowsLightmap",
	"lightmapped",
	"lightmapSizeMultiplier",
	"renderStyle",
	"type",
	"layers",
	"isStatic",
	"batchGroupId",
	"rootBone"
];
var RenderComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "render";
		this.ComponentType = RenderComponent;
		this.extraDataProperties = ["aabbCenter", "aabbHalfExtents"];
		this.defaultMaterial = getDefaultMaterial(app2.graphicsDevice);
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	initializeComponentData(component, _data, properties) {
		if (_data.batchGroupId === null || _data.batchGroupId === void 0) {
			_data.batchGroupId = -1;
		}
		if (_data.layers && _data.layers.length) {
			_data.layers = _data.layers.slice(0);
		}
		for (let i2 = 0; i2 < _properties7.length; i2++) {
			if (_data.hasOwnProperty(_properties7[i2])) {
				component[_properties7[i2]] = _data[_properties7[i2]];
			}
		}
		if (_data.aabbCenter && _data.aabbHalfExtents) {
			component.customAabb = new BoundingBox(new Vec3(_data.aabbCenter), new Vec3(_data.aabbHalfExtents));
		}
		super.initializeComponentData(component, _data);
	}
	cloneComponent(entity, clone) {
		const data2 = {};
		for (let i2 = 0; i2 < _properties7.length; i2++) {
			data2[_properties7[i2]] = entity.render[_properties7[i2]];
		}
		data2.enabled = entity.render.enabled;
		delete data2.meshInstances;
		const component = this.addComponent(clone, data2);
		const srcMeshInstances = entity.render.meshInstances;
		const meshes = srcMeshInstances.map((mi) => mi.mesh);
		component._onSetMeshes(meshes);
		for (let m = 0; m < srcMeshInstances.length; m++) {
			component.meshInstances[m].material = srcMeshInstances[m].material;
		}
		if (entity.render.customAabb) {
			component.customAabb = entity.render.customAabb.clone();
		}
		return component;
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
};

var ObjectPool = class {
	_constructor;
	_pool = [];
	_count = 0;
	constructor(constructorFunc, size) {
		this._constructor = constructorFunc;
		this._resize(size);
	}
	_resize(size) {
		if (size > this._pool.length) {
			for (let i2 = this._pool.length; i2 < size; i2++) {
				this._pool[i2] = new this._constructor();
			}
		}
	}
	allocate() {
		if (this._count >= this._pool.length) {
			this._resize(this._pool.length * 2);
		}
		return this._pool[this._count++];
	}
	freeAll() {
		this._count = 0;
	}
};

var RaycastResult = class {
	entity;
	point;
	normal;
	hitFraction;
	constructor(entity, point5, normal, hitFraction) {
		this.entity = entity;
		this.point = point5;
		this.normal = normal;
		this.hitFraction = hitFraction;
	}
};

var PhysicsBody = class {
	entity = null;
	nativeBody = null;
	setFriction(friction) {
	}
	setRollingFriction(friction) {
	}
	setRestitution(restitution) {
	}
	setDamping(linear, angular) {
	}
	setLinearFactor(factor) {
	}
	setAngularFactor(factor) {
	}
	setLinearVelocity(velocity) {
	}
	getLinearVelocity(velocity) {
	}
	setAngularVelocity(velocity) {
	}
	getAngularVelocity(velocity) {
	}
	setMass(mass) {
	}
	isActive() {
		return false;
	}
	activate() {
	}
	setTransform(position5, rotation7) {
	}
	getTransform(position5, rotation7) {
	}
	setKinematicTarget(position5, rotation7) {
	}
	applyForce(force, relativePoint) {
	}
	applyTorque(torque) {
	}
	applyImpulse(impulse, relativePoint) {
	}
	applyTorqueImpulse(torque) {
	}
};

var PhysicsJoint = class {
	nativeJoint = null;
	updateLimits(settings) {
		return false;
	}
	updateMotor(settings) {
		return false;
	}
	updateSpring(settings) {
		return false;
	}
	setBreakImpulse(impulse) {
	}
	isBroken() {
		return false;
	}
};

var PhysicsWorld = class {
	contactListener = null;
	nativeWorld = null;
	constructor(options2 = {}) {
		this.contactListener = options2.contactListener ?? null;
	}
	destroy() {
	}
	setGravity(gravity) {
	}
	step(dt, maxSubSteps, fixedTimeStep) {
	}
	flushContacts() {
	}
	createBody(desc) {
		const body = new PhysicsBody();
		body.entity = desc.entity ?? null;
		return body;
	}
	destroyBody(body) {
	}
	addBody(body, group, mask) {
	}
	removeBody(body) {
	}
	createShape(desc) {
		return {};
	}
	destroyShape(shape) {
	}
	addCompoundChild(compound, child, position5, rotation7) {
	}
	updateCompoundChild(compound, child, position5, rotation7) {
	}
	removeCompoundChild(compound, child) {
	}
	getCompoundChildCount(compound) {
		return 0;
	}
	createJoint(desc) {
		return new PhysicsJoint();
	}
	destroyJoint(joint) {
	}
	raycastFirst(start, end, options2) {
		return null;
	}
	raycastAll(start, end, options2) {
		return [];
	}
};

var AmmoPhysicsBody = class extends PhysicsBody {
	_world;
	_type;
	_noContactResponse;
	constructor(world, nativeBody, type, noContactResponse) {
		super();
		this._world = world;
		this.nativeBody = nativeBody;
		this._type = type;
		this._noContactResponse = noContactResponse;
	}
	setFriction(friction) {
		this.nativeBody.setFriction(friction);
	}
	setRollingFriction(friction) {
		this.nativeBody.setRollingFriction(friction);
	}
	setRestitution(restitution) {
		this.nativeBody.setRestitution(restitution);
	}
	setDamping(linear, angular) {
		this.nativeBody.setDamping(linear, angular);
	}
	setLinearFactor(factor) {
		const vec2 = this._world._btVec1;
		vec2.setValue(factor.x, factor.y, factor.z);
		this.nativeBody.setLinearFactor(vec2);
	}
	setAngularFactor(factor) {
		const vec2 = this._world._btVec1;
		vec2.setValue(factor.x, factor.y, factor.z);
		this.nativeBody.setAngularFactor(vec2);
	}
	setLinearVelocity(velocity) {
		const vec2 = this._world._btVec1;
		vec2.setValue(velocity.x, velocity.y, velocity.z);
		this.nativeBody.setLinearVelocity(vec2);
	}
	getLinearVelocity(velocity) {
		const vec2 = this.nativeBody.getLinearVelocity();
		velocity.set(vec2.x(), vec2.y(), vec2.z());
	}
	setAngularVelocity(velocity) {
		const vec2 = this._world._btVec1;
		vec2.setValue(velocity.x, velocity.y, velocity.z);
		this.nativeBody.setAngularVelocity(vec2);
	}
	getAngularVelocity(velocity) {
		const vec2 = this.nativeBody.getAngularVelocity();
		velocity.set(vec2.x(), vec2.y(), vec2.z());
	}
	setMass(mass) {
		const vec2 = this._world._btVec1;
		this.nativeBody.getCollisionShape().calculateLocalInertia(mass, vec2);
		this.nativeBody.setMassProps(mass, vec2);
		this.nativeBody.updateInertiaTensor();
	}
	isActive() {
		return this.nativeBody.isActive();
	}
	activate() {
		this.nativeBody.activate();
	}
	setTransform(position5, rotation7) {
		const body = this.nativeBody;
		const transform = this._world._btTransform;
		const vec2 = this._world._btVec1;
		const quat4 = this._world._btQuat;
		vec2.setValue(position5.x, position5.y, position5.z);
		quat4.setValue(rotation7.x, rotation7.y, rotation7.z, rotation7.w);
		transform.setOrigin(vec2);
		transform.setRotation(quat4);
		body.setWorldTransform(transform);
		if (this._type === BODYTYPE_KINEMATIC) {
			const motionState = body.getMotionState();
			if (motionState) {
				motionState.setWorldTransform(transform);
			}
		} else if (this._type === BODYTYPE_DYNAMIC && !this._noContactResponse && body.setInterpolationWorldTransform) {
			body.setInterpolationWorldTransform(transform);
			vec2.setValue(0, 0, 0);
			body.setInterpolationLinearVelocity(vec2);
			body.setInterpolationAngularVelocity(vec2);
		}
		body.activate();
	}
	getTransform(position5, rotation7) {
		const motionState = this.nativeBody.getMotionState();
		if (motionState) {
			const transform = this._world._btTransform;
			motionState.getWorldTransform(transform);
			const p = transform.getOrigin();
			const q5 = transform.getRotation();
			position5.set(p.x(), p.y(), p.z());
			rotation7.set(q5.x(), q5.y(), q5.z(), q5.w());
		}
	}
	setKinematicTarget(position5, rotation7) {
		const motionState = this.nativeBody.getMotionState();
		if (motionState) {
			const transform = this._world._btTransform;
			const vec2 = this._world._btVec1;
			const quat4 = this._world._btQuat;
			vec2.setValue(position5.x, position5.y, position5.z);
			quat4.setValue(rotation7.x, rotation7.y, rotation7.z, rotation7.w);
			transform.setOrigin(vec2);
			transform.setRotation(quat4);
			motionState.setWorldTransform(transform);
		}
	}
	applyForce(force, relativePoint) {
		const vec1 = this._world._btVec1;
		const vec2 = this._world._btVec2;
		vec1.setValue(force.x, force.y, force.z);
		vec2.setValue(relativePoint.x, relativePoint.y, relativePoint.z);
		this.nativeBody.applyForce(vec1, vec2);
	}
	applyTorque(torque) {
		const vec2 = this._world._btVec1;
		vec2.setValue(torque.x, torque.y, torque.z);
		this.nativeBody.applyTorque(vec2);
	}
	applyImpulse(impulse, relativePoint) {
		const vec1 = this._world._btVec1;
		const vec2 = this._world._btVec2;
		vec1.setValue(impulse.x, impulse.y, impulse.z);
		vec2.setValue(relativePoint.x, relativePoint.y, relativePoint.z);
		this.nativeBody.applyImpulse(vec1, vec2);
	}
	applyTorqueImpulse(torque) {
		const vec2 = this._world._btVec1;
		vec2.setValue(torque.x, torque.y, torque.z);
		this.nativeBody.applyTorqueImpulse(vec2);
	}
};

var _frameMat = new Mat4();
var _vec33 = new Vec3();
var _quat2 = new Quat();
var _dof = { lower: 0, upper: 0 };
function dofLimits(motion, limits, scale2) {
	if (motion === MOTION_LIMITED) {
		_dof.lower = limits.x * scale2;
		_dof.upper = limits.y * scale2;
	} else if (motion === MOTION_FREE) {
		_dof.lower = 1;
		_dof.upper = 0;
	} else {
		_dof.lower = 0;
		_dof.upper = 0;
	}
	return _dof;
}
var fixedJoint = {
	create(bodyA, bodyB, frameA, frameB) {
		return new Ammo.btFixedConstraint(bodyA, bodyB, frameA, frameB);
	}
};
var ballJoint = {
	create(bodyA, bodyB, frameA, frameB) {
		return new Ammo.btConeTwistConstraint(bodyA, bodyB, frameA, frameB);
	},
	updateLimits(joint, settings) {
		const constraint = joint.nativeJoint;
		if (settings.enableLimits) {
			constraint.setLimit(5, settings.swingLimitY * math.DEG_TO_RAD);
			constraint.setLimit(4, settings.swingLimitZ * math.DEG_TO_RAD);
			constraint.setLimit(3, settings.twistLimit * math.DEG_TO_RAD);
		} else {
			constraint.setLimit(5, 1e30);
			constraint.setLimit(4, 1e30);
			constraint.setLimit(3, 1e30);
		}
	}
};
var hingeJoint = {
	// bullet hinges rotate about frame Z - map the engine's X axis onto it
	axisCorrection: new Mat4().setFromAxisAngle(Vec3.UP, 90),
	create(bodyA, bodyB, frameA, frameB) {
		return new Ammo.btHingeConstraint(bodyA, bodyB, frameA, frameB, false);
	},
	updateLimits(joint, settings) {
		const constraint = joint.nativeJoint;
		if (settings.enableLimits) {
			const limits = settings.limits;
			constraint.setLimit(limits.x * math.DEG_TO_RAD, limits.y * math.DEG_TO_RAD, 0.9, 0.3, 1);
		} else {
			constraint.setLimit(1, -1, 0.9, 0.3, 1);
		}
	},
	updateMotor(joint, settings) {
		const maxImpulse = settings.maxMotorForce * joint._world._fixedTimeStep;
		joint.nativeJoint.enableAngularMotor(settings.maxMotorForce > 0, settings.motorSpeed * math.DEG_TO_RAD, maxImpulse);
	}
};
var sliderJoint = {
	create(bodyA, bodyB, frameA, frameB) {
		return new Ammo.btSliderConstraint(bodyA, bodyB, frameA, frameB, true);
	},
	updateLimits(joint, settings) {
		const constraint = joint.nativeJoint;
		if (settings.enableLimits) {
			const limits = settings.limits;
			constraint.setLowerLinLimit(limits.x);
			constraint.setUpperLinLimit(limits.y);
		} else {
			constraint.setLowerLinLimit(1);
			constraint.setUpperLinLimit(-1);
		}
		constraint.setLowerAngLimit(0);
		constraint.setUpperAngLimit(0);
	},
	updateMotor(joint, settings) {
		const constraint = joint.nativeJoint;
		constraint.setPoweredLinMotor(settings.maxMotorForce > 0);
		constraint.setTargetLinMotorVelocity(settings.motorSpeed);
		constraint.setMaxLinMotorForce(settings.maxMotorForce);
	}
};
var sixDofJoint = {
	create(bodyA, bodyB, frameA, frameB) {
		return new Ammo.btGeneric6DofSpringConstraint(bodyA, bodyB, frameA, frameB, true);
	},
	updateLimits(joint, settings) {
		const constraint = joint.nativeJoint;
		let dof = dofLimits(settings.linearMotionX, settings.linearLimitsX, 1);
		const lx = dof.lower, ux = dof.upper;
		dof = dofLimits(settings.linearMotionY, settings.linearLimitsY, 1);
		const ly = dof.lower, uy = dof.upper;
		dof = dofLimits(settings.linearMotionZ, settings.linearLimitsZ, 1);
		const lz = dof.lower, uz = dof.upper;
		const limits = joint._world._btVec1;
		limits.setValue(lx, ly, lz);
		constraint.setLinearLowerLimit(limits);
		limits.setValue(ux, uy, uz);
		constraint.setLinearUpperLimit(limits);
		dof = dofLimits(settings.angularMotionX, settings.angularLimitsX, math.DEG_TO_RAD);
		const alx = dof.lower, aux = dof.upper;
		dof = dofLimits(settings.angularMotionY, settings.angularLimitsY, math.DEG_TO_RAD);
		const aly = dof.lower, auy = dof.upper;
		dof = dofLimits(settings.angularMotionZ, settings.angularLimitsZ, math.DEG_TO_RAD);
		const alz = dof.lower, auz = dof.upper;
		limits.setValue(alx, aly, alz);
		constraint.setAngularLowerLimit(limits);
		limits.setValue(aux, auy, auz);
		constraint.setAngularUpperLimit(limits);
	},
	updateSpring(joint, settings) {
		const constraint = joint.nativeJoint;
		const rad = math.DEG_TO_RAD;
		const linStiffness = settings.linearStiffness;
		const linDamping = settings.linearDamping;
		const linEquilibrium = settings.linearEquilibrium;
		const angStiffness = settings.angularStiffness;
		const angDamping = settings.angularDamping;
		const angEquilibrium = settings.angularEquilibrium;
		constraint.enableSpring(0, linStiffness.x > 0);
		constraint.setStiffness(0, linStiffness.x);
		constraint.setDamping(0, linDamping.x);
		constraint.setEquilibriumPoint(0, linEquilibrium.x);
		constraint.enableSpring(1, linStiffness.y > 0);
		constraint.setStiffness(1, linStiffness.y);
		constraint.setDamping(1, linDamping.y);
		constraint.setEquilibriumPoint(1, linEquilibrium.y);
		constraint.enableSpring(2, linStiffness.z > 0);
		constraint.setStiffness(2, linStiffness.z);
		constraint.setDamping(2, linDamping.z);
		constraint.setEquilibriumPoint(2, linEquilibrium.z);
		constraint.enableSpring(3, angStiffness.x > 0);
		constraint.setStiffness(3, angStiffness.x);
		constraint.setDamping(3, angDamping.x);
		constraint.setEquilibriumPoint(3, angEquilibrium.x * rad);
		constraint.enableSpring(4, angStiffness.y > 0);
		constraint.setStiffness(4, angStiffness.y);
		constraint.setDamping(4, angDamping.y);
		constraint.setEquilibriumPoint(4, angEquilibrium.y * rad);
		constraint.enableSpring(5, angStiffness.z > 0);
		constraint.setStiffness(5, angStiffness.z);
		constraint.setDamping(5, angDamping.z);
		constraint.setEquilibriumPoint(5, angEquilibrium.z * rad);
	}
};
var jointImpls = {
	[JOINTTYPE_FIXED]: fixedJoint,
	[JOINTTYPE_BALL]: ballJoint,
	[JOINTTYPE_HINGE]: hingeJoint,
	[JOINTTYPE_SLIDER]: sliderJoint,
	[JOINTTYPE_6DOF]: sixDofJoint
};
var AmmoPhysicsJoint = class extends PhysicsJoint {
	_world;
	_type;
	_breakImpulse = Infinity;
	constructor(world, type) {
		super();
		this._world = world;
		this._type = type;
	}
	updateLimits(settings) {
		const impl = jointImpls[this._type];
		if (impl.updateLimits) {
			impl.updateLimits(this, settings);
			return true;
		}
		return false;
	}
	updateMotor(settings) {
		const impl = jointImpls[this._type];
		if (impl.updateMotor) {
			impl.updateMotor(this, settings);
			return true;
		}
		return false;
	}
	updateSpring(settings) {
		const impl = jointImpls[this._type];
		if (impl.updateSpring) {
			impl.updateSpring(this, settings);
			return true;
		}
		return false;
	}
	setBreakImpulse(impulse) {
		this._breakImpulse = impulse;
		const breakable = Number.isFinite(impulse);
		this.nativeJoint.setBreakingImpulseThreshold(breakable ? impulse : Number.MAX_VALUE);
		this.nativeJoint.enableFeedback(breakable);
	}
	isBroken() {
		const constraint = this.nativeJoint;
		if (typeof constraint.isEnabled === "function") {
			return !constraint.isEnabled();
		}
		if (typeof constraint.getAppliedImpulse === "function") {
			return constraint.getAppliedImpulse() >= this._breakImpulse;
		}
		return null;
	}
};
function createBtFrame(frameMat, axisCorrection) {
	_frameMat.copy(frameMat);
	if (axisCorrection) {
		_frameMat.mul(axisCorrection);
	}
	_frameMat.getTranslation(_vec33);
	_quat2.setFromMat4(_frameMat);
	const frame = new Ammo.btTransform();
	const origin = new Ammo.btVector3(_vec33.x, _vec33.y, _vec33.z);
	const rotation7 = new Ammo.btQuaternion(_quat2.x, _quat2.y, _quat2.z, _quat2.w);
	frame.setOrigin(origin);
	frame.setRotation(rotation7);
	Ammo.destroy(origin);
	Ammo.destroy(rotation7);
	return frame;
}
function getFixedBody(world) {
	if (!world._fixedBody) {
		const transform = new Ammo.btTransform();
		transform.setIdentity();
		const motionState = new Ammo.btDefaultMotionState(transform);
		const shape = new Ammo.btSphereShape(1e-3);
		const inertia = new Ammo.btVector3(0, 0, 0);
		const info = new Ammo.btRigidBodyConstructionInfo(0, motionState, shape, inertia);
		world._fixedBody = new Ammo.btRigidBody(info);
		Ammo.destroy(info);
		Ammo.destroy(inertia);
		Ammo.destroy(transform);
	}
	return world._fixedBody;
}
function createJoint(world, desc) {
	const impl = jointImpls[desc.type];
	const axisCorrection = impl.axisCorrection;
	const settings = desc.settings;
	const frameA = createBtFrame(desc.frameA, axisCorrection);
	const frameB = createBtFrame(desc.frameB, axisCorrection);
	const bodyA = desc.bodyA.nativeBody;
	const bodyB = desc.bodyB ? desc.bodyB.nativeBody : getFixedBody(world);
	const constraint = impl.create(bodyA, bodyB, frameA, frameB);
	Ammo.destroy(frameA);
	Ammo.destroy(frameB);
	const joint = new AmmoPhysicsJoint(world, desc.type);
	joint.nativeJoint = constraint;
	impl.updateLimits?.(joint, settings);
	impl.updateMotor?.(joint, settings);
	impl.updateSpring?.(joint, settings);
	if (Number.isFinite(settings.breakImpulse)) {
		joint.setBreakImpulse(settings.breakImpulse);
	}
	bodyA.activate();
	bodyB.activate();
	world.nativeWorld.addConstraint(constraint, !desc.enableCollision);
	return joint;
}
function destroyJoint(world, joint) {
	world.nativeWorld.removeConstraint(joint.nativeJoint);
	Ammo.destroy(joint.nativeJoint);
	joint.nativeJoint = null;
}
function destroyFixedBody(world) {
	if (world._fixedBody) {
		Ammo.destroy(world._fixedBody.getMotionState());
		Ammo.destroy(world._fixedBody.getCollisionShape());
		Ammo.destroy(world._fixedBody);
		world._fixedBody = null;
	}
}

function getTransform(world, position5, rotation7) {
	const transform = world._btTransform;
	const vec2 = world._btVec1;
	const quat4 = world._btQuat;
	vec2.setValue(position5.x, position5.y, position5.z);
	quat4.setValue(rotation7.x, rotation7.y, rotation7.z, rotation7.w);
	transform.setOrigin(vec2);
	transform.setRotation(quat4);
	return transform;
}
function getTriMesh(world, source) {
	let triMesh = world._triMeshCache.get(source.id);
	if (!triMesh) {
		const positions = source.positions;
		const stride = source.stride;
		const indices = source.indices;
		const base = source.base;
		const numTriangles = source.count / 3;
		const checkDupes = source.checkDuplicates;
		const v15 = new Ammo.btVector3();
		let i1, i2, i3;
		triMesh = new Ammo.btTriangleMesh();
		world._triMeshCache.set(source.id, triMesh);
		const vertexCache = /* @__PURE__ */ new Map();
		const indexedArray = triMesh.getIndexedMeshArray();
		indexedArray.at(0).m_numTriangles = numTriangles;
		const bakeScale = source.bakeScale;
		const sx = bakeScale ? bakeScale.x : 1;
		const sy = bakeScale ? bakeScale.y : 1;
		const sz = bakeScale ? bakeScale.z : 1;
		const addVertex = (index) => {
			const x3 = positions[index * stride] * sx;
			const y2 = positions[index * stride + 1] * sy;
			const z2 = positions[index * stride + 2] * sz;
			let idx;
			if (checkDupes) {
				const str = `${x3}:${y2}:${z2}`;
				idx = vertexCache.get(str);
				if (idx !== void 0) {
					return idx;
				}
				v15.setValue(x3, y2, z2);
				idx = triMesh.findOrAddVertex(v15, false);
				vertexCache.set(str, idx);
			} else {
				v15.setValue(x3, y2, z2);
				idx = triMesh.findOrAddVertex(v15, false);
			}
			return idx;
		};
		for (let i4 = 0; i4 < numTriangles; i4++) {
			i1 = addVertex(indices[base + i4 * 3]);
			i2 = addVertex(indices[base + i4 * 3 + 1]);
			i3 = addVertex(indices[base + i4 * 3 + 2]);
			triMesh.addIndex(i1);
			triMesh.addIndex(i2);
			triMesh.addIndex(i3);
		}
		Ammo.destroy(v15);
	}
	return triMesh;
}
function createHullChild(world, compound, source) {
	const hull = new Ammo.btConvexHullShape();
	const point5 = new Ammo.btVector3();
	const positions = source.positions;
	const stride = source.stride;
	const bakeScale = source.bakeScale;
	const sx = bakeScale ? bakeScale.x : 1;
	const sy = bakeScale ? bakeScale.y : 1;
	const sz = bakeScale ? bakeScale.z : 1;
	for (let i2 = 0; i2 < positions.length; i2 += stride) {
		point5.setValue(positions[i2] * sx, positions[i2 + 1] * sy, positions[i2 + 2] * sz);
		hull.addPoint(point5, false);
	}
	Ammo.destroy(point5);
	hull.recalcLocalAabb();
	hull.setMargin(0.01);
	compound.addChildShape(getTransform(world, source.position, source.rotation), hull);
}
function createTriMeshChild(world, compound, source) {
	const triMesh = getTriMesh(world, source);
	const triMeshShape = new Ammo.btBvhTriangleMeshShape(
		triMesh,
		true
		/* useQuantizedAabbCompression */
	);
	const shapeScale = source.shapeScale;
	if (shapeScale) {
		const vec2 = world._btVec1;
		vec2.setValue(shapeScale.x, shapeScale.y, shapeScale.z);
		triMeshShape.setLocalScaling(vec2);
	}
	compound.addChildShape(getTransform(world, source.position, source.rotation), triMeshShape);
}
var shapeFactories = {
	box: (world, desc) => {
		const he = desc.halfExtents;
		const ammoHe = new Ammo.btVector3(he.x, he.y, he.z);
		const shape = new Ammo.btBoxShape(ammoHe);
		Ammo.destroy(ammoHe);
		return shape;
	},
	sphere: (world, desc) => {
		return new Ammo.btSphereShape(desc.radius);
	},
	capsule: (world, desc) => {
		const radius = desc.radius;
		const height = Math.max(desc.height - 2 * radius, 0);
		switch (desc.axis) {
			case 0:
				return new Ammo.btCapsuleShapeX(radius, height);
			case 2:
				return new Ammo.btCapsuleShapeZ(radius, height);
			default:
				return new Ammo.btCapsuleShape(radius, height);
		}
	},
	cylinder: (world, desc) => {
		const radius = desc.radius;
		const height = desc.height;
		let halfExtents = null;
		let shape = null;
		switch (desc.axis) {
			case 0:
				halfExtents = new Ammo.btVector3(height * 0.5, radius, radius);
				shape = new Ammo.btCylinderShapeX(halfExtents);
				break;
			case 2:
				halfExtents = new Ammo.btVector3(radius, radius, height * 0.5);
				shape = new Ammo.btCylinderShapeZ(halfExtents);
				break;
			default:
				halfExtents = new Ammo.btVector3(radius, height * 0.5, radius);
				shape = new Ammo.btCylinderShape(halfExtents);
				break;
		}
		Ammo.destroy(halfExtents);
		return shape;
	},
	cone: (world, desc) => {
		switch (desc.axis) {
			case 0:
				return new Ammo.btConeShapeX(desc.radius, desc.height);
			case 2:
				return new Ammo.btConeShapeZ(desc.radius, desc.height);
			default:
				return new Ammo.btConeShape(desc.radius, desc.height);
		}
	},
	mesh: (world, desc) => {
		const shape = new Ammo.btCompoundShape();
		const sources = desc.sources;
		for (let i2 = 0; i2 < sources.length; i2++) {
			const source = sources[i2];
			if (source.convexHull) {
				createHullChild(world, shape, source);
			} else {
				createTriMeshChild(world, shape, source);
			}
		}
		if (desc.scale) {
			const vec2 = new Ammo.btVector3(desc.scale.x, desc.scale.y, desc.scale.z);
			shape.setLocalScaling(vec2);
			Ammo.destroy(vec2);
		}
		return shape;
	},
	compound: (world, desc) => {
		return new Ammo.btCompoundShape();
	}
};
function createShape(world, desc) {
	const factory = shapeFactories[desc.type];
	const shape = factory(world, desc);
	shape._shapeType = desc.type;
	return shape;
}
function destroyShape2(shape) {
	if (shape._shapeType === "mesh") {
		const numShapes = shape.getNumChildShapes();
		for (let i2 = 0; i2 < numShapes; i2++) {
			Ammo.destroy(shape.getChildShape(i2));
		}
	}
	Ammo.destroy(shape);
}
function indexOfCompoundChild(compound, child) {
	const childPointer = Ammo.getPointer(child);
	const numShapes = compound.getNumChildShapes();
	for (let i2 = 0; i2 < numShapes; i2++) {
		if (Ammo.getPointer(compound.getChildShape(i2)) === childPointer) {
			return i2;
		}
	}
	return -1;
}
function addCompoundChild(world, compound, child, position5, rotation7) {
	compound.addChildShape(getTransform(world, position5, rotation7), child);
}
function updateCompoundChild(world, compound, child, position5, rotation7) {
	const transform = getTransform(world, position5, rotation7);
	const idx = indexOfCompoundChild(compound, child);
	if (idx < 0) {
		compound.addChildShape(transform, child);
	} else {
		compound.updateChildTransform(idx, transform, true);
	}
}
function removeCompoundChild(compound, child) {
	if (compound.getNumChildShapes() === 0) {
		return;
	}
	if (compound.removeChildShape) {
		compound.removeChildShape(child);
	} else {
		const idx = indexOfCompoundChild(compound, child);
		if (idx >= 0) {
			compound.removeChildShapeByIndex(idx);
		}
	}
}

var AmmoContactPair = class {
	entityA = null;
	entityB = null;
	triggerA = false;
	triggerB = false;
	contactCount = 0;
	_manifold = null;
	readContact(index, out) {
		const contactPoint = this._manifold.getContactPoint(index);
		const localPointA = contactPoint.get_m_localPointA();
		const localPointB = contactPoint.get_m_localPointB();
		const positionWorldOnA = contactPoint.getPositionWorldOnA();
		const positionWorldOnB = contactPoint.getPositionWorldOnB();
		const normalWorldOnB = contactPoint.get_m_normalWorldOnB();
		out.localPoint.set(localPointA.x(), localPointA.y(), localPointA.z());
		out.localPointOther.set(localPointB.x(), localPointB.y(), localPointB.z());
		out.point.set(positionWorldOnA.x(), positionWorldOnA.y(), positionWorldOnA.z());
		out.pointOther.set(positionWorldOnB.x(), positionWorldOnB.y(), positionWorldOnB.z());
		out.normal.set(normalWorldOnB.x(), normalWorldOnB.y(), normalWorldOnB.z());
		out.impulse = contactPoint.getAppliedImpulse();
	}
};
var AmmoPhysicsWorld = class extends PhysicsWorld {
	_gravityFloat32 = new Float32Array(3);
	_triMeshCache = /* @__PURE__ */ new Map();
	_fixedBody = null;
	_fixedTimeStep = 1 / 60;
	constructor(options2 = {}) {
		super(options2);
		this.collisionConfiguration = new Ammo.btDefaultCollisionConfiguration();
		this.dispatcher = new Ammo.btCollisionDispatcher(this.collisionConfiguration);
		this.overlappingPairCache = new Ammo.btDbvtBroadphase();
		this.solver = new Ammo.btSequentialImpulseConstraintSolver();
		this.nativeWorld = new Ammo.btDiscreteDynamicsWorld(this.dispatcher, this.overlappingPairCache, this.solver, this.collisionConfiguration);
		this._useTickCallback = !!this.nativeWorld.setInternalTickCallback;
		if (this._useTickCallback) {
			const checkForCollisionsPointer = Ammo.addFunction(() => this._walkContacts(), "vif");
			this.nativeWorld.setInternalTickCallback(checkForCollisionsPointer);
		} else {
		}
		this._contactPair = new AmmoContactPair();
		this._btVec1 = new Ammo.btVector3();
		this._btVec2 = new Ammo.btVector3();
		this._btQuat = new Ammo.btQuaternion();
		this._btTransform = new Ammo.btTransform();
		this._btRayStart = new Ammo.btVector3();
		this._btRayEnd = new Ammo.btVector3();
	}
	destroy() {
		this._triMeshCache.forEach((triMesh) => Ammo.destroy(triMesh));
		this._triMeshCache.clear();
		destroyFixedBody(this);
		Ammo.destroy(this._btVec1);
		Ammo.destroy(this._btVec2);
		Ammo.destroy(this._btQuat);
		Ammo.destroy(this._btTransform);
		Ammo.destroy(this._btRayStart);
		Ammo.destroy(this._btRayEnd);
		this._btVec1 = null;
		this._btVec2 = null;
		this._btQuat = null;
		this._btTransform = null;
		this._btRayStart = null;
		this._btRayEnd = null;
		Ammo.destroy(this.nativeWorld);
		Ammo.destroy(this.solver);
		Ammo.destroy(this.overlappingPairCache);
		Ammo.destroy(this.dispatcher);
		Ammo.destroy(this.collisionConfiguration);
		this.nativeWorld = null;
		this.solver = null;
		this.overlappingPairCache = null;
		this.dispatcher = null;
		this.collisionConfiguration = null;
	}
	createBody(desc) {
		const { type, mass, shape, position: position5, rotation: rotation7, entity } = desc;
		const noContactResponse = !!desc.noContactResponse;
		this._btVec1.setValue(position5.x, position5.y, position5.z);
		this._btQuat.setValue(rotation7.x, rotation7.y, rotation7.z, rotation7.w);
		this._btTransform.setOrigin(this._btVec1);
		this._btTransform.setRotation(this._btQuat);
		const localInertia = new Ammo.btVector3(0, 0, 0);
		if (mass !== 0) {
			shape.calculateLocalInertia(mass, localInertia);
		}
		const motionState = new Ammo.btDefaultMotionState(this._btTransform);
		const bodyInfo = new Ammo.btRigidBodyConstructionInfo(mass, motionState, shape, localInertia);
		const nativeBody = new Ammo.btRigidBody(bodyInfo);
		Ammo.destroy(bodyInfo);
		Ammo.destroy(localInertia);
		if (type === BODYTYPE_KINEMATIC) {
			nativeBody.setCollisionFlags(nativeBody.getCollisionFlags() | BODYFLAG_KINEMATIC_OBJECT);
			nativeBody.setActivationState(BODYSTATE_DISABLE_DEACTIVATION);
		}
		if (noContactResponse) {
			nativeBody.setCollisionFlags(nativeBody.getCollisionFlags() | BODYFLAG_NORESPONSE_OBJECT);
		}
		nativeBody.entity = entity;
		const body = new AmmoPhysicsBody(this, nativeBody, type, noContactResponse);
		body.entity = entity;
		return body;
	}
	destroyBody(body) {
		const nativeBody = body.nativeBody;
		const motionState = nativeBody.getMotionState();
		if (motionState) {
			Ammo.destroy(motionState);
		}
		Ammo.destroy(nativeBody);
		body.nativeBody = null;
	}
	addBody(body, group, mask) {
		const nativeBody = body.nativeBody;
		if (group !== void 0 && mask !== void 0) {
			this.nativeWorld.addRigidBody(nativeBody, group, mask);
		} else {
			this.nativeWorld.addRigidBody(nativeBody);
		}
		nativeBody.forceActivationState(body._type === BODYTYPE_KINEMATIC ? BODYSTATE_DISABLE_DEACTIVATION : BODYSTATE_ACTIVE_TAG);
	}
	removeBody(body) {
		const nativeBody = body.nativeBody;
		this.nativeWorld.removeRigidBody(nativeBody);
		nativeBody.forceActivationState(BODYSTATE_DISABLE_SIMULATION);
	}
	createShape(desc) {
		return createShape(this, desc);
	}
	destroyShape(shape) {
		destroyShape2(shape);
	}
	addCompoundChild(compound, child, position5, rotation7) {
		addCompoundChild(this, compound, child, position5, rotation7);
	}
	updateCompoundChild(compound, child, position5, rotation7) {
		updateCompoundChild(this, compound, child, position5, rotation7);
	}
	removeCompoundChild(compound, child) {
		removeCompoundChild(compound, child);
	}
	getCompoundChildCount(compound) {
		return compound.getNumChildShapes();
	}
	createJoint(desc) {
		return createJoint(this, desc);
	}
	destroyJoint(joint) {
		destroyJoint(this, joint);
	}
	setGravity(gravity) {
		this._gravityFloat32[0] = gravity.x;
		this._gravityFloat32[1] = gravity.y;
		this._gravityFloat32[2] = gravity.z;
		const current = this.nativeWorld.getGravity();
		if (current.x() !== this._gravityFloat32[0] || current.y() !== this._gravityFloat32[1] || current.z() !== this._gravityFloat32[2]) {
			current.setValue(gravity.x, gravity.y, gravity.z);
			this.nativeWorld.setGravity(current);
		}
	}
	step(dt, maxSubSteps, fixedTimeStep) {
		this._fixedTimeStep = fixedTimeStep;
		this.nativeWorld.stepSimulation(dt, maxSubSteps, fixedTimeStep);
	}
	flushContacts() {
		if (!this._useTickCallback) {
			this._walkContacts();
		}
	}
	_walkContacts() {
		const listener = this.contactListener;
		if (!listener) {
			return;
		}
		listener.onContactsBegin();
		const dispatcher = this.dispatcher;
		const numManifolds = dispatcher.getNumManifolds();
		const pair = this._contactPair;
		for (let i2 = 0; i2 < numManifolds; i2++) {
			const manifold = dispatcher.getManifoldByIndexInternal(i2);
			const wb0 = Ammo.castObject(manifold.getBody0(), Ammo.btRigidBody);
			const wb1 = Ammo.castObject(manifold.getBody1(), Ammo.btRigidBody);
			const e0 = wb0.entity;
			const e12 = wb1.entity;
			if (!e0 || !e12) {
				continue;
			}
			const numContacts = manifold.getNumContacts();
			if (numContacts > 0) {
				pair.entityA = e0;
				pair.entityB = e12;
				pair.triggerA = (wb0.getCollisionFlags() & BODYFLAG_NORESPONSE_OBJECT) !== 0;
				pair.triggerB = (wb1.getCollisionFlags() & BODYFLAG_NORESPONSE_OBJECT) !== 0;
				pair.contactCount = numContacts;
				pair._manifold = manifold;
				listener.onContactPair(pair);
			}
		}
		pair.entityA = null;
		pair.entityB = null;
		pair._manifold = null;
		listener.onContactsEnd();
	}
	raycastFirst(start, end, options2 = {}) {
		let result = null;
		this._btRayStart.setValue(start.x, start.y, start.z);
		this._btRayEnd.setValue(end.x, end.y, end.z);
		const rayCallback = new Ammo.ClosestRayResultCallback(this._btRayStart, this._btRayEnd);
		if (typeof options2.filterCollisionGroup === "number") {
			rayCallback.set_m_collisionFilterGroup(options2.filterCollisionGroup);
		}
		if (typeof options2.filterCollisionMask === "number") {
			rayCallback.set_m_collisionFilterMask(options2.filterCollisionMask);
		}
		this.nativeWorld.rayTest(this._btRayStart, this._btRayEnd, rayCallback);
		if (rayCallback.hasHit()) {
			const collisionObj = rayCallback.get_m_collisionObject();
			const body = Ammo.castObject(collisionObj, Ammo.btRigidBody);
			if (body) {
				const point5 = rayCallback.get_m_hitPointWorld();
				const normal = rayCallback.get_m_hitNormalWorld();
				result = new RaycastResult(
					body.entity,
					new Vec3(point5.x(), point5.y(), point5.z()),
					new Vec3(normal.x(), normal.y(), normal.z()),
					rayCallback.get_m_closestHitFraction()
				);
			}
		}
		Ammo.destroy(rayCallback);
		return result;
	}
	raycastAll(start, end, options2 = {}) {
		const results = [];
		this._btRayStart.setValue(start.x, start.y, start.z);
		this._btRayEnd.setValue(end.x, end.y, end.z);
		const rayCallback = new Ammo.AllHitsRayResultCallback(this._btRayStart, this._btRayEnd);
		if (typeof options2.filterCollisionGroup === "number") {
			rayCallback.set_m_collisionFilterGroup(options2.filterCollisionGroup);
		}
		if (typeof options2.filterCollisionMask === "number") {
			rayCallback.set_m_collisionFilterMask(options2.filterCollisionMask);
		}
		this.nativeWorld.rayTest(this._btRayStart, this._btRayEnd, rayCallback);
		if (rayCallback.hasHit()) {
			const collisionObjs = rayCallback.get_m_collisionObjects();
			const points = rayCallback.get_m_hitPointWorld();
			const normals = rayCallback.get_m_hitNormalWorld();
			const hitFractions = rayCallback.get_m_hitFractions();
			const numHits = collisionObjs.size();
			for (let i2 = 0; i2 < numHits; i2++) {
				const body = Ammo.castObject(collisionObjs.at(i2), Ammo.btRigidBody);
				if (body && body.entity) {
					if (options2.filterTags && !body.entity.tags.has(...options2.filterTags) || options2.filterCallback && !options2.filterCallback(body.entity)) {
						continue;
					}
					const point5 = points.at(i2);
					const normal = normals.at(i2);
					const result = new RaycastResult(
						body.entity,
						new Vec3(point5.x(), point5.y(), point5.z()),
						new Vec3(normal.x(), normal.y(), normal.z()),
						hitFractions.at(i2)
					);
					results.push(result);
				}
			}
		}
		Ammo.destroy(rayCallback);
		return results;
	}
};

var _quat1 = new Quat();
var _quat22 = new Quat();
var _vec34 = new Vec3();
var _position2 = new Vec3();
var _rotation2 = new Quat();
var _vecA = new Vec3();
var _vecB = new Vec3();
var RigidBodyComponent = class extends Component {
	static EVENT_CONTACT = "contact";
	static EVENT_COLLISIONSTART = "collisionstart";
	static EVENT_COLLISIONEND = "collisionend";
	static EVENT_TRIGGERENTER = "triggerenter";
	static EVENT_TRIGGERLEAVE = "triggerleave";
	static order = -1;
	_angularDamping = 0;
	_angularFactor = new Vec3(1, 1, 1);
	_angularVelocity = new Vec3();
	_body = null;
	_friction = 0.5;
	_group = BODYGROUP_STATIC;
	_linearDamping = 0;
	_linearFactor = new Vec3(1, 1, 1);
	_linearVelocity = new Vec3();
	_mask = BODYMASK_NOT_STATIC;
	_mass = 1;
	_restitution = 0;
	_rollingFriction = 0;
	_simulationEnabled = false;
	_type = BODYTYPE_STATIC;
	set angularDamping(damping) {
		if (this._angularDamping !== damping) {
			this._angularDamping = damping;
			if (this._body) {
				this._body.setDamping(this._linearDamping, damping);
			}
		}
	}
	get angularDamping() {
		return this._angularDamping;
	}
	set angularFactor(factor) {
		if (!this._angularFactor.equals(factor)) {
			this._angularFactor.copy(factor);
			if (this._body && this._type === BODYTYPE_DYNAMIC) {
				this._body.setAngularFactor(factor);
			}
		}
	}
	get angularFactor() {
		return this._angularFactor;
	}
	set angularVelocity(velocity) {
		if (this._body && this._type === BODYTYPE_DYNAMIC) {
			this._body.activate();
			this._body.setAngularVelocity(velocity);
			this._angularVelocity.copy(velocity);
		}
	}
	get angularVelocity() {
		if (this._body && this._type === BODYTYPE_DYNAMIC) {
			this._body.getAngularVelocity(this._angularVelocity);
		}
		return this._angularVelocity;
	}
	set body(body) {
		if (this._body !== body) {
			this._body = body;
			if (body && this._simulationEnabled) {
				body.activate();
			}
		}
	}
	get body() {
		return this._body ? this._body.nativeBody : null;
	}
	set friction(friction) {
		if (this._friction !== friction) {
			this._friction = friction;
			if (this._body) {
				this._body.setFriction(friction);
			}
		}
	}
	get friction() {
		return this._friction;
	}
	set group(group) {
		if (this._group !== group) {
			this._group = group;
			if (this.enabled && this.entity.enabled) {
				this.disableSimulation();
				this.enableSimulation();
			}
		}
	}
	get group() {
		return this._group;
	}
	set linearDamping(damping) {
		if (this._linearDamping !== damping) {
			this._linearDamping = damping;
			if (this._body) {
				this._body.setDamping(damping, this._angularDamping);
			}
		}
	}
	get linearDamping() {
		return this._linearDamping;
	}
	set linearFactor(factor) {
		if (!this._linearFactor.equals(factor)) {
			this._linearFactor.copy(factor);
			if (this._body && this._type === BODYTYPE_DYNAMIC) {
				this._body.setLinearFactor(factor);
			}
		}
	}
	get linearFactor() {
		return this._linearFactor;
	}
	set linearVelocity(velocity) {
		if (this._body && this._type === BODYTYPE_DYNAMIC) {
			this._body.activate();
			this._body.setLinearVelocity(velocity);
			this._linearVelocity.copy(velocity);
		}
	}
	get linearVelocity() {
		if (this._body && this._type === BODYTYPE_DYNAMIC) {
			this._body.getLinearVelocity(this._linearVelocity);
		}
		return this._linearVelocity;
	}
	set mask(mask) {
		if (this._mask !== mask) {
			this._mask = mask;
			if (this.enabled && this.entity.enabled) {
				this.disableSimulation();
				this.enableSimulation();
			}
		}
	}
	get mask() {
		return this._mask;
	}
	set mass(mass) {
		if (this._mass !== mass) {
			this._mass = mass;
			if (this._body && this._type === BODYTYPE_DYNAMIC) {
				const enabled = this.enabled && this.entity.enabled;
				if (enabled) {
					this.disableSimulation();
				}
				this._body.setMass(mass);
				if (enabled) {
					this.enableSimulation();
				}
			}
		}
	}
	get mass() {
		return this._mass;
	}
	set restitution(restitution) {
		if (this._restitution !== restitution) {
			this._restitution = restitution;
			if (this._body) {
				this._body.setRestitution(restitution);
			}
		}
	}
	get restitution() {
		return this._restitution;
	}
	set rollingFriction(friction) {
		if (this._rollingFriction !== friction) {
			this._rollingFriction = friction;
			if (this._body) {
				this._body.setRollingFriction(friction);
			}
		}
	}
	get rollingFriction() {
		return this._rollingFriction;
	}
	set type(type) {
		if (this._type !== type) {
			this._type = type;
			this.disableSimulation();
			switch (type) {
				case BODYTYPE_DYNAMIC:
					this._group = BODYGROUP_DYNAMIC;
					this._mask = BODYMASK_ALL;
					break;
				case BODYTYPE_KINEMATIC:
					this._group = BODYGROUP_KINEMATIC;
					this._mask = BODYMASK_ALL;
					break;
				case BODYTYPE_STATIC:
				default:
					this._group = BODYGROUP_STATIC;
					this._mask = BODYMASK_NOT_STATIC;
					break;
			}
			this.createBody();
		}
	}
	get type() {
		return this._type;
	}
	createBody() {
		const entity = this.entity;
		let shape;
		if (entity.collision) {
			shape = entity.collision.shape;
			if (entity.trigger) {
				entity.trigger.destroy();
				delete entity.trigger;
			}
		}
		const world = this.system.physicsWorld;
		if (shape && world) {
			if (this._body) {
				world.removeBody(this._body);
				world.destroyBody(this._body);
				this._body = null;
			}
			const mass = this._type === BODYTYPE_DYNAMIC ? this._mass : 0;
			this._getEntityTransform(_position2, _rotation2);
			const body = world.createBody({
				type: this._type,
				mass,
				shape,
				position: _position2,
				rotation: _rotation2,
				entity
			});
			body.setRestitution(this._restitution);
			body.setFriction(this._friction);
			body.setRollingFriction(this._rollingFriction);
			body.setDamping(this._linearDamping, this._angularDamping);
			if (this._type === BODYTYPE_DYNAMIC) {
				body.setLinearFactor(this._linearFactor);
				body.setAngularFactor(this._angularFactor);
			}
			this.body = body;
			if (this.enabled && entity.enabled) {
				this.enableSimulation();
			}
		}
	}
	isActive() {
		return this._body ? this._body.isActive() : false;
	}
	activate() {
		if (this._body) {
			this._body.activate();
		}
	}
	enableSimulation() {
		this.system.enableSimulation(this);
	}
	disableSimulation() {
		this.system.disableSimulation(this);
	}
	applyForce(x3, y2, z2, px, py, pz) {
		const body = this._body;
		if (body) {
			body.activate();
			if (x3 instanceof Vec3) {
				_vecA.copy(x3);
			} else {
				_vecA.set(x3, y2, z2);
			}
			if (y2 instanceof Vec3) {
				_vecB.copy(y2);
			} else if (px !== void 0) {
				_vecB.set(px, py, pz);
			} else {
				_vecB.set(0, 0, 0);
			}
			body.applyForce(_vecA, _vecB);
		}
	}
	applyTorque(x3, y2, z2) {
		const body = this._body;
		if (body) {
			body.activate();
			if (x3 instanceof Vec3) {
				_vecA.copy(x3);
			} else {
				_vecA.set(x3, y2, z2);
			}
			body.applyTorque(_vecA);
		}
	}
	applyImpulse(x3, y2, z2, px, py, pz) {
		const body = this._body;
		if (body) {
			body.activate();
			if (x3 instanceof Vec3) {
				_vecA.copy(x3);
			} else {
				_vecA.set(x3, y2, z2);
			}
			if (y2 instanceof Vec3) {
				_vecB.copy(y2);
			} else if (px !== void 0) {
				_vecB.set(px, py, pz);
			} else {
				_vecB.set(0, 0, 0);
			}
			body.applyImpulse(_vecA, _vecB);
		}
	}
	applyTorqueImpulse(x3, y2, z2) {
		const body = this._body;
		if (body) {
			body.activate();
			if (x3 instanceof Vec3) {
				_vecA.copy(x3);
			} else {
				_vecA.set(x3, y2, z2);
			}
			body.applyTorqueImpulse(_vecA);
		}
	}
	isStatic() {
		return this._type === BODYTYPE_STATIC;
	}
	isStaticOrKinematic() {
		return this._type === BODYTYPE_STATIC || this._type === BODYTYPE_KINEMATIC;
	}
	isKinematic() {
		return this._type === BODYTYPE_KINEMATIC;
	}
	_getEntityTransform(position5, rotation7) {
		const entity = this.entity;
		const component = entity.collision;
		if (component) {
			position5.copy(component.getShapePosition());
			rotation7.copy(component.getShapeRotation());
		} else {
			position5.copy(entity.getPosition());
			rotation7.copy(entity.getRotation());
		}
	}
	syncEntityToBody() {
		const body = this._body;
		if (body) {
			this._getEntityTransform(_position2, _rotation2);
			body.setTransform(_position2, _rotation2);
		}
	}
	_updateDynamic() {
		const body = this._body;
		if (body.isActive()) {
			const entity = this.entity;
			body.getTransform(_position2, _rotation2);
			const component = entity.collision;
			if (component && component._hasOffset) {
				const lo = component.linearOffset;
				const ao = component.angularOffset;
				const invertedAo = _quat22.copy(ao).invert();
				const entityRot = _quat1.copy(_rotation2).mul(invertedAo);
				entityRot.transformVector(lo, _vec34);
				entity.setPositionAndRotation(_position2.sub(_vec34), entityRot);
			} else {
				entity.setPositionAndRotation(_position2, _rotation2);
			}
		}
	}
	_updateKinematic() {
		this._getEntityTransform(_position2, _rotation2);
		this._body.setKinematicTarget(_position2, _rotation2);
	}
	teleport(x3, y2, z2, rx, ry, rz) {
		if (x3 instanceof Vec3) {
			this.entity.setPosition(x3);
		} else {
			this.entity.setPosition(x3, y2, z2);
		}
		if (y2 instanceof Quat) {
			this.entity.setRotation(y2);
		} else if (y2 instanceof Vec3) {
			this.entity.setEulerAngles(y2);
		} else if (rx !== void 0) {
			this.entity.setEulerAngles(rx, ry, rz);
		}
		this.syncEntityToBody();
	}
	onEnable() {
		if (!this._body) {
			this.createBody();
		}
		this.enableSimulation();
	}
	onDisable() {
		this.disableSimulation();
	}
};

var ContactPoint = class {
	localPoint;
	localPointOther;
	point;
	pointOther;
	normal;
	impulse;
	constructor(localPoint = new Vec3(), localPointOther = new Vec3(), point5 = new Vec3(), pointOther = new Vec3(), normal = new Vec3(), impulse = 0) {
		this.localPoint = localPoint;
		this.localPointOther = localPointOther;
		this.point = point5;
		this.pointOther = pointOther;
		this.normal = normal;
		this.impulse = impulse;
	}
};

var ContactResult = class {
	other;
	contacts;
	constructor(other, contacts) {
		this.other = other;
		this.contacts = contacts;
	}
};

var SingleContactResult = class {
	a;
	b;
	impulse;
	localPointA;
	localPointB;
	pointA;
	pointB;
	normal;
	constructor(a, b, contactPoint) {
		if (arguments.length !== 0) {
			this.a = a;
			this.b = b;
			this.impulse = contactPoint.impulse;
			this.localPointA = contactPoint.localPoint;
			this.localPointB = contactPoint.localPointOther;
			this.pointA = contactPoint.point;
			this.pointB = contactPoint.pointOther;
			this.normal = contactPoint.normal;
		} else {
			this.a = null;
			this.b = null;
			this.impulse = 0;
			this.localPointA = new Vec3();
			this.localPointB = new Vec3();
			this.pointA = new Vec3();
			this.pointB = new Vec3();
			this.normal = new Vec3();
		}
	}
};

var _properties8 = [
	"mass",
	"linearDamping",
	"angularDamping",
	"linearFactor",
	"angularFactor",
	"friction",
	"rollingFriction",
	"restitution",
	"type",
	"group",
	"mask"
];
var RigidBodyComponentSystem = class extends ComponentSystem {
	static EVENT_CONTACT = "contact";
	maxSubSteps = 10;
	fixedTimeStep = 1 / 60;
	gravity = new Vec3(0, -9.81, 0);
	_world = null;
	_dynamic = [];
	_kinematic = [];
	_triggers = [];
	_compounds = [];
	constructor(app2) {
		super(app2);
		this.id = "rigidbody";
		this._stats = app2.stats.frame;
		this.ComponentType = RigidBodyComponent;
		this.contactPointPool = null;
		this.contactResultPool = null;
		this.singleContactResultPool = null;
		this.collisions = {};
		this.frameCollisions = {};
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	onLibraryLoaded() {
		if (!this._world && typeof Ammo !== "undefined") {
			this.setPhysicsWorld(new AmmoPhysicsWorld({ contactListener: this }));
		} else if (!this._world) {
			this.app.systems.off("update", this.onUpdate, this);
		}
	}
	setPhysicsWorld(world) {
		this._world = world;
		this.contactPointPool = new ObjectPool(ContactPoint, 1);
		this.contactResultPool = new ObjectPool(ContactResult, 1);
		this.singleContactResultPool = new ObjectPool(SingleContactResult, 1);
		this.app.systems.on("update", this.onUpdate, this);
	}
	get physicsWorld() {
		return this._world;
	}
	get dynamicsWorld() {
		return this._world?.nativeWorld ?? null;
	}
	get collisionConfiguration() {
		return this._world?.collisionConfiguration ?? null;
	}
	get dispatcher() {
		return this._world?.dispatcher ?? null;
	}
	get overlappingPairCache() {
		return this._world?.overlappingPairCache ?? null;
	}
	get solver() {
		return this._world?.solver ?? null;
	}
	initializeComponentData(component, data2) {
		for (const property of _properties8) {
			if (data2.hasOwnProperty(property)) {
				const value = data2[property];
				if (Array.isArray(value)) {
					component[property] = new Vec3(value[0], value[1], value[2]);
				} else {
					component[property] = value;
				}
			}
		}
		super.initializeComponentData(component, data2);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.rigidbody;
		const data2 = {
			enabled: c2.enabled
		};
		for (const property of _properties8) {
			data2[property] = c2[property];
		}
		return this.addComponent(clone, data2);
	}
	onBeforeRemove(entity, component) {
		if (component.enabled) {
			component.enabled = false;
		}
		if (component._body) {
			this._world.destroyBody(component._body);
			component.body = null;
		}
	}
	addBody(body, group, mask) {
		this._world.addBody(body, group, mask);
	}
	removeBody(body) {
		this._world.removeBody(body);
	}
	enableSimulation(component) {
		const entity = component.entity;
		if (entity.collision && entity.collision.enabled && !component._simulationEnabled) {
			const body = component._body;
			if (body) {
				this.addBody(body, component._group, component._mask);
				switch (component._type) {
					case BODYTYPE_DYNAMIC:
						this._dynamic.push(component);
						component.syncEntityToBody();
						break;
					case BODYTYPE_KINEMATIC:
						this._kinematic.push(component);
						break;
					case BODYTYPE_STATIC:
						component.syncEntityToBody();
						break;
				}
				if (entity.collision.type === "compound") {
					this._compounds.push(entity.collision);
				}
				body.activate();
				component._simulationEnabled = true;
				component.fire("simulationenabled");
			}
		}
	}
	disableSimulation(component) {
		const body = component._body;
		if (body && component._simulationEnabled) {
			let idx = this._compounds.indexOf(component.entity.collision);
			if (idx > -1) {
				this._compounds.splice(idx, 1);
			}
			idx = this._dynamic.indexOf(component);
			if (idx > -1) {
				this._dynamic.splice(idx, 1);
			}
			idx = this._kinematic.indexOf(component);
			if (idx > -1) {
				this._kinematic.splice(idx, 1);
			}
			this.removeBody(body);
			component._simulationEnabled = false;
			component.fire("simulationdisabled");
		}
	}
	addTrigger(trigger) {
		if (this._triggers.indexOf(trigger) < 0) {
			this.addBody(trigger.body, BODYGROUP_TRIGGER, BODYMASK_NOT_STATIC ^ BODYGROUP_TRIGGER);
			this._triggers.push(trigger);
		}
	}
	removeTrigger(trigger) {
		const idx = this._triggers.indexOf(trigger);
		if (idx > -1) {
			this.removeBody(trigger.body);
			this._triggers.splice(idx, 1);
		}
	}
	raycastFirst(start, end, options2 = {}) {
		if (options2.filterTags || options2.filterCallback) {
			options2.sort = true;
			return this.raycastAll(start, end, options2)[0] || null;
		}
		return this._world.raycastFirst(start, end, options2);
	}
	raycastAll(start, end, options2 = {}) {
		const results = this._world.raycastAll(start, end, options2);
		if (options2.sort) {
			results.sort((a, b) => a.hitFraction - b.hitFraction);
		}
		return results;
	}
	_storeCollision(entity, other) {
		let isNewCollision = false;
		const guid2 = entity.guid;
		this.collisions[guid2] = this.collisions[guid2] || { others: [], entity };
		if (this.collisions[guid2].others.indexOf(other) < 0) {
			this.collisions[guid2].others.push(other);
			isNewCollision = true;
		}
		this.frameCollisions[guid2] = this.frameCollisions[guid2] || { others: [], entity };
		this.frameCollisions[guid2].others.push(other);
		return isNewCollision;
	}
	_createReverseContactPoint(forward2) {
		const contact = this.contactPointPool.allocate();
		contact.localPoint.copy(forward2.localPointOther);
		contact.localPointOther.copy(forward2.localPoint);
		contact.point.copy(forward2.pointOther);
		contact.pointOther.copy(forward2.point);
		contact.normal.copy(forward2.normal);
		contact.impulse = forward2.impulse;
		return contact;
	}
	_createSingleContactResult(a, b, contactPoint) {
		const result = this.singleContactResultPool.allocate();
		result.a = a;
		result.b = b;
		result.localPointA = contactPoint.localPoint;
		result.localPointB = contactPoint.localPointOther;
		result.pointA = contactPoint.point;
		result.pointB = contactPoint.pointOther;
		result.normal = contactPoint.normal;
		result.impulse = contactPoint.impulse;
		return result;
	}
	_createContactResult(other, contacts) {
		const result = this.contactResultPool.allocate();
		result.other = other;
		result.contacts = contacts;
		return result;
	}
	_cleanOldCollisions() {
		for (const guid2 in this.collisions) {
			if (this.collisions.hasOwnProperty(guid2)) {
				const frameCollision = this.frameCollisions[guid2];
				const collision = this.collisions[guid2];
				const entity = collision.entity;
				const entityCollision = entity.collision;
				const entityRigidbody = entity.rigidbody;
				const others = collision.others;
				const length = others.length;
				let i2 = length;
				while (i2--) {
					const other = others[i2];
					if (!frameCollision || frameCollision.others.indexOf(other) < 0) {
						others.splice(i2, 1);
						if (entity.trigger) {
							if (entityCollision) {
								entityCollision.fire("triggerleave", other);
							}
							if (other.rigidbody) {
								other.rigidbody.fire("triggerleave", entity);
							}
						} else if (!other.trigger) {
							if (entityRigidbody) {
								entityRigidbody.fire("collisionend", other);
							}
							if (entityCollision) {
								entityCollision.fire("collisionend", other);
							}
						}
					}
				}
				if (others.length === 0) {
					delete this.collisions[guid2];
				}
			}
		}
	}
	clearEntityCollisions(entity) {
		delete this.collisions[entity.guid];
	}
	_hasContactEvent(entity) {
		const c2 = entity.collision;
		if (c2 && (c2.hasEvent("collisionstart") || c2.hasEvent("collisionend") || c2.hasEvent("contact"))) {
			return true;
		}
		const r = entity.rigidbody;
		return r && (r.hasEvent("collisionstart") || r.hasEvent("collisionend") || r.hasEvent("contact"));
	}
	onContactsBegin() {
		this.frameCollisions = {};
	}
	onContactPair(pair) {
		const e0 = pair.entityA;
		const e12 = pair.entityB;
		const forwardContacts = [];
		const reverseContacts = [];
		let newCollision;
		if (pair.triggerA || pair.triggerB) {
			const e0Events = e0.collision && (e0.collision.hasEvent("triggerenter") || e0.collision.hasEvent("triggerleave"));
			const e1Events = e12.collision && (e12.collision.hasEvent("triggerenter") || e12.collision.hasEvent("triggerleave"));
			const e0BodyEvents = e0.rigidbody && (e0.rigidbody.hasEvent("triggerenter") || e0.rigidbody.hasEvent("triggerleave"));
			const e1BodyEvents = e12.rigidbody && (e12.rigidbody.hasEvent("triggerenter") || e12.rigidbody.hasEvent("triggerleave"));
			if (e0Events) {
				newCollision = this._storeCollision(e0, e12);
				if (newCollision && !pair.triggerB) {
					e0.collision.fire("triggerenter", e12);
				}
			}
			if (e1Events) {
				newCollision = this._storeCollision(e12, e0);
				if (newCollision && !pair.triggerA) {
					e12.collision.fire("triggerenter", e0);
				}
			}
			if (e0BodyEvents) {
				if (!newCollision) {
					newCollision = this._storeCollision(e12, e0);
				}
				if (newCollision) {
					e0.rigidbody.fire("triggerenter", e12);
				}
			}
			if (e1BodyEvents) {
				if (!newCollision) {
					newCollision = this._storeCollision(e0, e12);
				}
				if (newCollision) {
					e12.rigidbody.fire("triggerenter", e0);
				}
			}
		} else {
			const e0Events = this._hasContactEvent(e0);
			const e1Events = this._hasContactEvent(e12);
			const globalEvents = this.hasEvent("contact");
			if (globalEvents || e0Events || e1Events) {
				const contactCount = pair.contactCount;
				for (let j = 0; j < contactCount; j++) {
					const contactPoint = this.contactPointPool.allocate();
					pair.readContact(j, contactPoint);
					if (e0Events || e1Events) {
						forwardContacts.push(contactPoint);
						reverseContacts.push(this._createReverseContactPoint(contactPoint));
					}
					if (globalEvents) {
						const result = this._createSingleContactResult(e0, e12, contactPoint);
						this.fire("contact", result);
					}
				}
				if (e0Events) {
					const forwardResult = this._createContactResult(e12, forwardContacts);
					newCollision = this._storeCollision(e0, e12);
					if (e0.collision) {
						e0.collision.fire("contact", forwardResult);
						if (newCollision) {
							e0.collision.fire("collisionstart", forwardResult);
						}
					}
					if (e0.rigidbody) {
						e0.rigidbody.fire("contact", forwardResult);
						if (newCollision) {
							e0.rigidbody.fire("collisionstart", forwardResult);
						}
					}
				}
				if (e1Events) {
					const reverseResult = this._createContactResult(e0, reverseContacts);
					newCollision = this._storeCollision(e12, e0);
					if (e12.collision) {
						e12.collision.fire("contact", reverseResult);
						if (newCollision) {
							e12.collision.fire("collisionstart", reverseResult);
						}
					}
					if (e12.rigidbody) {
						e12.rigidbody.fire("contact", reverseResult);
						if (newCollision) {
							e12.rigidbody.fire("collisionstart", reverseResult);
						}
					}
				}
			}
		}
	}
	onContactsEnd() {
		this._cleanOldCollisions();
		this.contactPointPool.freeAll();
		this.contactResultPool.freeAll();
		this.singleContactResultPool.freeAll();
	}
	onUpdate(dt) {
		let i2, len;
		this._stats.physicsStart = now();
		this._world.setGravity(this.gravity);
		const triggers = this._triggers;
		for (i2 = 0, len = triggers.length; i2 < len; i2++) {
			triggers[i2].updateTransform();
		}
		const compounds = this._compounds;
		for (i2 = 0, len = compounds.length; i2 < len; i2++) {
			compounds[i2]._updateCompound();
		}
		const kinematic = this._kinematic;
		for (i2 = 0, len = kinematic.length; i2 < len; i2++) {
			kinematic[i2]._updateKinematic();
		}
		this._world.step(dt, this.maxSubSteps, this.fixedTimeStep);
		const dynamic = this._dynamic;
		for (i2 = 0, len = dynamic.length; i2 < len; i2++) {
			dynamic[i2]._updateDynamic();
		}
		this._world.flushContacts();
		this._stats.physicsTime = now() - this._stats.physicsStart;
	}
	destroy() {
		super.destroy();
		this.app.systems.off("update", this.onUpdate, this);
		if (this._world) {
			this._world.destroy();
			this._world = null;
		}
	}
};

var SCALEMODE_NONE = "none";
var SCALEMODE_BLEND = "blend";

var _transform = new Mat4();
var ScreenComponent = class extends Component {
	_resolution = new Vec2(640, 320);
	_referenceResolution = new Vec2(640, 320);
	_scaleMode = SCALEMODE_NONE;
	scale = 1;
	_scaleBlend = 0.5;
	_priority = 0;
	_screenSpace = false;
	cull = false;
	_screenMatrix = new Mat4();
	_elements = /* @__PURE__ */ new Set();
	constructor(system, entity) {
		super(system, entity);
		system.app.graphicsDevice.on("resizecanvas", this._onResize, this);
	}
	syncDrawOrder() {
		this.system.queueDrawOrderSync(this.entity.guid, this._processDrawOrderSync, this);
	}
	_recurseDrawOrderSync(e, i2) {
		if (!(e instanceof Entity)) {
			return i2;
		}
		if (e.element) {
			const prevDrawOrder = e.element.drawOrder;
			e.element.drawOrder = i2++;
			if (e.element._batchGroupId >= 0 && prevDrawOrder !== e.element.drawOrder) {
				this.system.app.batcher?.markGroupDirty(e.element._batchGroupId);
			}
		}
		if (e.particlesystem) {
			e.particlesystem.drawOrder = i2++;
		}
		const children = e.children;
		for (let j = 0; j < children.length; j++) {
			i2 = this._recurseDrawOrderSync(children[j], i2);
		}
		return i2;
	}
	_processDrawOrderSync() {
		const i2 = 1;
		this._recurseDrawOrderSync(this.entity, i2);
		this.fire("syncdraworder");
	}
	_calcProjectionMatrix() {
		const w = this._resolution.x / this.scale;
		const h2 = this._resolution.y / this.scale;
		const left = 0;
		const right2 = w;
		const bottom = -h2;
		const top = 0;
		const near = 1;
		const far = -1;
		this._screenMatrix.setOrtho(left, right2, bottom, top, near, far);
		if (!this._screenSpace) {
			_transform.setScale(0.5 * w, 0.5 * h2, 1);
			this._screenMatrix.mul2(_transform, this._screenMatrix);
		}
	}
	_updateScale() {
		this.scale = this._calcScale(this._resolution, this.referenceResolution);
	}
	_calcScale(resolution, referenceResolution) {
		const lx = Math.log2((resolution.x || 1) / referenceResolution.x);
		const ly = Math.log2((resolution.y || 1) / referenceResolution.y);
		return Math.pow(2, lx * (1 - this._scaleBlend) + ly * this._scaleBlend);
	}
	_onResize(width, height) {
		if (this._screenSpace) {
			this._resolution.set(width, height);
			this.resolution = this._resolution;
		}
	}
	_bindElement(element) {
		this._elements.add(element);
	}
	_unbindElement(element) {
		this._elements.delete(element);
	}
	onBeforeRemove() {
		this.system.app.graphicsDevice.off("resizecanvas", this._onResize, this);
		this.fire("remove");
		this._elements.forEach((element) => element._onScreenRemove());
		this._elements.clear();
		this.off();
	}
	set resolution(value) {
		if (!this._screenSpace) {
			this._resolution.set(value.x, value.y);
		} else {
			this._resolution.set(this.system.app.graphicsDevice.width, this.system.app.graphicsDevice.height);
		}
		this._updateScale();
		this._calcProjectionMatrix();
		if (!this.entity._dirtyLocal) {
			this.entity._dirtifyLocal();
		}
		this.fire("set:resolution", this._resolution);
		this._elements.forEach((element) => element._onScreenResize(this._resolution));
	}
	get resolution() {
		return this._resolution;
	}
	set referenceResolution(value) {
		this._referenceResolution.set(value.x, value.y);
		this._updateScale();
		this._calcProjectionMatrix();
		if (!this.entity._dirtyLocal) {
			this.entity._dirtifyLocal();
		}
		this.fire("set:referenceresolution", this._resolution);
		this._elements.forEach((element) => element._onScreenResize(this._resolution));
	}
	get referenceResolution() {
		if (this._scaleMode === SCALEMODE_NONE) {
			return this._resolution;
		}
		return this._referenceResolution;
	}
	set screenSpace(value) {
		this._screenSpace = value;
		if (this._screenSpace) {
			this._resolution.set(this.system.app.graphicsDevice.width, this.system.app.graphicsDevice.height);
		}
		this.resolution = this._resolution;
		if (!this.entity._dirtyLocal) {
			this.entity._dirtifyLocal();
		}
		this.fire("set:screenspace", this._screenSpace);
		this._elements.forEach((element) => element._onScreenSpaceChange());
	}
	get screenSpace() {
		return this._screenSpace;
	}
	set scaleMode(value) {
		if (value !== SCALEMODE_NONE && value !== SCALEMODE_BLEND) {
			value = SCALEMODE_NONE;
		}
		if (!this._screenSpace && value !== SCALEMODE_NONE) {
			value = SCALEMODE_NONE;
		}
		this._scaleMode = value;
		this.resolution = this._resolution;
		this.fire("set:scalemode", this._scaleMode);
	}
	get scaleMode() {
		return this._scaleMode;
	}
	set scaleBlend(value) {
		this._scaleBlend = value;
		this._updateScale();
		this._calcProjectionMatrix();
		if (!this.entity._dirtyLocal) {
			this.entity._dirtifyLocal();
		}
		this.fire("set:scaleblend", this._scaleBlend);
		this._elements.forEach((element) => element._onScreenResize(this._resolution));
	}
	get scaleBlend() {
		return this._scaleBlend;
	}
	set priority(value) {
		value = math.clamp(value, 0, 127);
		if (this._priority === value) {
			return;
		}
		this._priority = value;
		this.syncDrawOrder();
	}
	get priority() {
		return this._priority;
	}
};

var ScreenComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "screen";
		this.ComponentType = ScreenComponent;
		this.windowResolution = new Vec2();
		this._drawOrderSyncQueue = new IndexedList();
		this.app.graphicsDevice.on("resizecanvas", this._onResize, this);
		this.app.systems.on("update", this._onUpdate, this);
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	initializeComponentData(component, data2, properties) {
		if (data2.priority !== void 0) component.priority = data2.priority;
		if (data2.screenSpace !== void 0) component.screenSpace = data2.screenSpace;
		component.cull = component.screenSpace;
		if (data2.scaleMode !== void 0) component.scaleMode = data2.scaleMode;
		if (data2.scaleBlend !== void 0) component.scaleBlend = data2.scaleBlend;
		if (data2.resolution !== void 0) {
			if (data2.resolution instanceof Vec2) {
				component._resolution.copy(data2.resolution);
			} else {
				component._resolution.set(data2.resolution[0], data2.resolution[1]);
			}
			component.resolution = component._resolution;
		}
		if (data2.referenceResolution !== void 0) {
			if (data2.referenceResolution instanceof Vec2) {
				component._referenceResolution.copy(data2.referenceResolution);
			} else {
				component._referenceResolution.set(data2.referenceResolution[0], data2.referenceResolution[1]);
			}
			component.referenceResolution = component._referenceResolution;
		}
		this._updateDescendantElements(component.entity, component.entity);
		component.syncDrawOrder();
		super.initializeComponentData(component, data2);
	}
	_updateDescendantElements(entity, screenEntity) {
		const children = entity.children;
		for (let i2 = 0; i2 < children.length; i2++) {
			const child = children[i2];
			if (child.element && !child.element.screen) {
				child.element._updateScreen(screenEntity);
			}
			if (!child.screen) {
				this._updateDescendantElements(child, screenEntity);
			}
		}
	}
	destroy() {
		super.destroy();
		this.app.graphicsDevice.off("resizecanvas", this._onResize, this);
		this.app.systems.off("update", this._onUpdate, this);
	}
	_onUpdate(dt) {
		const components2 = this.store;
		for (const id14 in components2) {
			if (components2[id14].entity.screen.update) components2[id14].entity.screen.update(dt);
		}
	}
	_onResize(width, height) {
		this.windowResolution.x = width;
		this.windowResolution.y = height;
	}
	cloneComponent(entity, clone) {
		const screen = entity.screen;
		return this.addComponent(clone, {
			enabled: screen.enabled,
			screenSpace: screen.screenSpace,
			scaleMode: screen.scaleMode,
			scaleBlend: screen.scaleBlend,
			priority: screen.priority,
			resolution: screen.resolution.clone(),
			referenceResolution: screen.referenceResolution.clone()
		});
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	processDrawOrderSyncQueue() {
		const list = this._drawOrderSyncQueue.list();
		for (let i2 = 0; i2 < list.length; i2++) {
			const item = list[i2];
			item.callback.call(item.scope);
		}
		this._drawOrderSyncQueue.clear();
	}
	queueDrawOrderSync(id14, fn, scope) {
		if (!this._drawOrderSyncQueue.list().length) {
			this.app.once("prerender", this.processDrawOrderSyncQueue, this);
		}
		if (!this._drawOrderSyncQueue.has(id14)) {
			this._drawOrderSyncQueue.push(id14, {
				callback: fn,
				scope
			});
		}
	}
};

var _inputScreenPosition = new Vec2();
var _inputWorldPosition = new Vec3();
var _ray = new Ray();
var _plane = new Plane();
var _normal = new Vec3();
var _point2 = new Vec3();
var _entityRotation = new Quat();
var OPPOSITE_AXIS = {
	x: "y",
	y: "x"
};
var ElementDragHelper = class extends EventHandler {
	static EVENT_DRAGSTART = "drag:start";
	static EVENT_DRAGEND = "drag:end";
	static EVENT_DRAGMOVE = "drag:move";
	constructor(element, axis) {
		super();
		if (!element || !(element instanceof ElementComponent)) {
			throw new Error("Element was null or not an ElementComponent");
		}
		if (axis && axis !== "x" && axis !== "y") {
			throw new Error(`Unrecognized axis: ${axis}`);
		}
		this._element = element;
		this._app = element.system.app;
		this._axis = axis || null;
		this._enabled = true;
		this._dragScale = new Vec3();
		this._dragStartMousePosition = new Vec3();
		this._dragStartHandlePosition = new Vec3();
		this._deltaMousePosition = new Vec3();
		this._deltaHandlePosition = new Vec3();
		this._isDragging = false;
		this._toggleLifecycleListeners("on");
	}
	_toggleLifecycleListeners(onOrOff) {
		this._element[onOrOff]("mousedown", this._onMouseDownOrTouchStart, this);
		this._element[onOrOff]("touchstart", this._onMouseDownOrTouchStart, this);
		this._element[onOrOff]("selectstart", this._onMouseDownOrTouchStart, this);
	}
	_toggleDragListeners(onOrOff) {
		const isOn = onOrOff === "on";
		if (this._hasDragListeners && isOn) {
			return;
		}
		if (this._app.mouse) {
			this._element[onOrOff]("mousemove", this._onMove, this);
			this._element[onOrOff]("mouseup", this._onMouseUpOrTouchEnd, this);
		}
		if (platform.touch) {
			this._element[onOrOff]("touchmove", this._onMove, this);
			this._element[onOrOff]("touchend", this._onMouseUpOrTouchEnd, this);
			this._element[onOrOff]("touchcancel", this._onMouseUpOrTouchEnd, this);
		}
		this._element[onOrOff]("selectmove", this._onMove, this);
		this._element[onOrOff]("selectend", this._onMouseUpOrTouchEnd, this);
		this._hasDragListeners = isOn;
	}
	_onMouseDownOrTouchStart(event) {
		if (this._element && !this._isDragging && this.enabled) {
			this._dragCamera = event.camera;
			this._calculateDragScale();
			const currentMousePosition = this._screenToLocal(event);
			if (currentMousePosition) {
				this._toggleDragListeners("on");
				this._isDragging = true;
				this._dragStartMousePosition.copy(currentMousePosition);
				this._dragStartHandlePosition.copy(this._element.entity.getLocalPosition());
				this.fire("drag:start");
			}
		}
	}
	_onMouseUpOrTouchEnd() {
		if (this._isDragging) {
			this._isDragging = false;
			this._toggleDragListeners("off");
			this.fire("drag:end");
		}
	}
	_screenToLocal(event) {
		if (event.inputSource) {
			_ray.set(event.inputSource.getOrigin(), event.inputSource.getDirection());
		} else {
			this._determineInputPosition(event);
			this._chooseRayOriginAndDirection();
		}
		_normal.copy(this._element.entity.forward).mulScalar(-1);
		_plane.setFromPointNormal(this._element.entity.getPosition(), _normal);
		if (_plane.intersectsRay(_ray, _point2)) {
			_entityRotation.copy(this._element.entity.getRotation()).invert().transformVector(_point2, _point2);
			_point2.mul(this._dragScale);
			return _point2;
		}
		return null;
	}
	_determineInputPosition(event) {
		const devicePixelRatio = this._app.graphicsDevice.maxPixelRatio;
		if (typeof event.x !== "undefined" && typeof event.y !== "undefined") {
			_inputScreenPosition.x = event.x * devicePixelRatio;
			_inputScreenPosition.y = event.y * devicePixelRatio;
		} else if (event.changedTouches) {
			_inputScreenPosition.x = event.changedTouches[0].x * devicePixelRatio;
			_inputScreenPosition.y = event.changedTouches[0].y * devicePixelRatio;
		} else {
			console.warn("Could not determine position from input event");
		}
	}
	_chooseRayOriginAndDirection() {
		if (this._element.screen && this._element.screen.screen.screenSpace) {
			_ray.origin.set(_inputScreenPosition.x, -_inputScreenPosition.y, 0);
			_ray.direction.copy(Vec3.FORWARD);
		} else {
			_inputWorldPosition.copy(this._dragCamera.screenToWorld(_inputScreenPosition.x, _inputScreenPosition.y, 1));
			_ray.origin.copy(this._dragCamera.entity.getPosition());
			_ray.direction.copy(_inputWorldPosition).sub(_ray.origin).normalize();
		}
	}
	_calculateDragScale() {
		let current = this._element.entity.parent;
		const screen = this._element.screen && this._element.screen.screen;
		const isWithin2DScreen = screen && screen.screenSpace;
		const screenScale = isWithin2DScreen ? screen.scale : 1;
		const dragScale = this._dragScale;
		dragScale.set(screenScale, screenScale, screenScale);
		while (current) {
			dragScale.mul(current.getLocalScale());
			current = current.parent;
			if (isWithin2DScreen && current.screen) {
				break;
			}
		}
		dragScale.x = 1 / dragScale.x;
		dragScale.y = 1 / dragScale.y;
		dragScale.z = 0;
	}
	_onMove(event) {
		const {
			_element: element,
			_deltaMousePosition: deltaMousePosition,
			_deltaHandlePosition: deltaHandlePosition,
			_axis: axis
		} = this;
		if (element && this._isDragging && this.enabled && element.enabled && element.entity.enabled) {
			const currentMousePosition = this._screenToLocal(event);
			if (currentMousePosition) {
				deltaMousePosition.sub2(currentMousePosition, this._dragStartMousePosition);
				deltaHandlePosition.add2(this._dragStartHandlePosition, deltaMousePosition);
				if (axis) {
					const currentPosition = element.entity.getLocalPosition();
					const constrainedAxis = OPPOSITE_AXIS[axis];
					deltaHandlePosition[constrainedAxis] = currentPosition[constrainedAxis];
				}
				element.entity.setLocalPosition(deltaHandlePosition);
				this.fire("drag:move", deltaHandlePosition);
			}
		}
	}
	destroy() {
		this._toggleLifecycleListeners("off");
		this._toggleDragListeners("off");
	}
	set enabled(value) {
		this._enabled = value;
	}
	get enabled() {
		return this._enabled;
	}
	get isDragging() {
		return this._isDragging;
	}
};

var SCROLL_MODE_CLAMP = 0;
var SCROLL_MODE_BOUNCE = 1;
var SCROLL_MODE_INFINITE = 2;
var SCROLLBAR_VISIBILITY_SHOW_ALWAYS = 0;
var SCROLLBAR_VISIBILITY_SHOW_WHEN_REQUIRED = 1;

var _tempScrollValue = new Vec2();
var ScrollViewComponent = class extends Component {
	static EVENT_SETSCROLL = "set:scroll";
	_horizontal;
	_vertical;
	_scrollMode;
	_bounceAmount;
	_friction;
	_dragThreshold = 10;
	_useMouseWheel = true;
	_mouseWheelSensitivity = new Vec2(1, 1);
	_horizontalScrollbarVisibility = 0;
	_verticalScrollbarVisibility = 0;
	_viewportEntity = null;
	_contentEntity = null;
	_horizontalScrollbarEntity = null;
	_verticalScrollbarEntity = null;
	_evtElementAdd = null;
	_evtElementRemove = null;
	_evtViewportEntityElementAdd = null;
	_evtViewportElementRemove = null;
	_evtViewportResize = null;
	_evtContentEntityElementAdd = null;
	_evtContentElementRemove = null;
	_evtContentResize = null;
	_evtHorizontalScrollbarAdd = null;
	_evtHorizontalScrollbarRemove = null;
	_evtHorizontalScrollbarValue = null;
	_evtVerticalScrollbarAdd = null;
	_evtVerticalScrollbarRemove = null;
	_evtVerticalScrollbarValue = null;
	constructor(system, entity) {
		super(system, entity);
		this._scrollbarUpdateFlags = {};
		this._scrollbarEntities = {};
		this._prevContentSizes = {};
		this._prevContentSizes[ORIENTATION_HORIZONTAL] = null;
		this._prevContentSizes[ORIENTATION_VERTICAL] = null;
		this._scroll = new Vec2();
		this._velocity = new Vec3();
		this._dragStartPosition = new Vec3();
		this._disabledContentInput = false;
		this._disabledContentInputEntities = [];
		this._evtElementAdd = this.entity.on("element:add", this._onElementComponentAdd, this);
		this._toggleElementListeners("on");
	}
	set horizontal(arg) {
		if (this._horizontal === arg) {
			return;
		}
		this._horizontal = arg;
		this._syncScrollbarEnabledState(ORIENTATION_HORIZONTAL);
	}
	get horizontal() {
		return this._horizontal;
	}
	set vertical(arg) {
		if (this._vertical === arg) {
			return;
		}
		this._vertical = arg;
		this._syncScrollbarEnabledState(ORIENTATION_VERTICAL);
	}
	get vertical() {
		return this._vertical;
	}
	set scrollMode(arg) {
		this._scrollMode = arg;
	}
	get scrollMode() {
		return this._scrollMode;
	}
	set bounceAmount(arg) {
		this._bounceAmount = arg;
	}
	get bounceAmount() {
		return this._bounceAmount;
	}
	set friction(arg) {
		this._friction = arg;
	}
	get friction() {
		return this._friction;
	}
	set dragThreshold(arg) {
		this._dragThreshold = arg;
	}
	get dragThreshold() {
		return this._dragThreshold;
	}
	set useMouseWheel(arg) {
		this._useMouseWheel = arg;
	}
	get useMouseWheel() {
		return this._useMouseWheel;
	}
	set mouseWheelSensitivity(arg) {
		if (!arg) {
			this._mouseWheelSensitivity = arg;
		} else if (arg instanceof Vec2) {
			this._mouseWheelSensitivity = arg.clone();
		} else {
			this._mouseWheelSensitivity = new Vec2(arg[0], arg[1]);
		}
	}
	get mouseWheelSensitivity() {
		return this._mouseWheelSensitivity;
	}
	set horizontalScrollbarVisibility(arg) {
		this._horizontalScrollbarVisibility = arg;
	}
	get horizontalScrollbarVisibility() {
		return this._horizontalScrollbarVisibility;
	}
	set verticalScrollbarVisibility(arg) {
		this._verticalScrollbarVisibility = arg;
	}
	get verticalScrollbarVisibility() {
		return this._verticalScrollbarVisibility;
	}
	set viewportEntity(arg) {
		if (this._viewportEntity === arg) {
			return;
		}
		const isString = typeof arg === "string";
		if (this._viewportEntity && isString && this._viewportEntity.guid === arg) {
			return;
		}
		if (this._viewportEntity) {
			this._viewportEntityUnsubscribe();
		}
		if (arg instanceof GraphNode) {
			this._viewportEntity = arg;
		} else if (isString) {
			this._viewportEntity = this.system.app.getEntityFromIndex(arg) || null;
		} else {
			this._viewportEntity = null;
		}
		if (this._viewportEntity) {
			this._viewportEntitySubscribe();
		}
	}
	get viewportEntity() {
		return this._viewportEntity;
	}
	set contentEntity(arg) {
		if (this._contentEntity === arg) {
			return;
		}
		const isString = typeof arg === "string";
		if (this._contentEntity && isString && this._contentEntity.guid === arg) {
			return;
		}
		if (this._contentEntity) {
			this._contentEntityUnsubscribe();
		}
		if (arg instanceof GraphNode) {
			this._contentEntity = arg;
		} else if (isString) {
			this._contentEntity = this.system.app.getEntityFromIndex(arg) || null;
		} else {
			this._contentEntity = null;
		}
		if (this._contentEntity) {
			this._contentEntitySubscribe();
		}
	}
	get contentEntity() {
		return this._contentEntity;
	}
	set horizontalScrollbarEntity(arg) {
		if (this._horizontalScrollbarEntity === arg) {
			return;
		}
		const isString = typeof arg === "string";
		if (this._horizontalScrollbarEntity && isString && this._horizontalScrollbarEntity.guid === arg) {
			return;
		}
		if (this._horizontalScrollbarEntity) {
			this._horizontalScrollbarEntityUnsubscribe();
		}
		if (arg instanceof GraphNode) {
			this._horizontalScrollbarEntity = arg;
		} else if (isString) {
			this._horizontalScrollbarEntity = this.system.app.getEntityFromIndex(arg) || null;
		} else {
			this._horizontalScrollbarEntity = null;
		}
		this._scrollbarEntities[ORIENTATION_HORIZONTAL] = this._horizontalScrollbarEntity;
		if (this._horizontalScrollbarEntity) {
			this._horizontalScrollbarEntitySubscribe();
		}
	}
	get horizontalScrollbarEntity() {
		return this._horizontalScrollbarEntity;
	}
	set verticalScrollbarEntity(arg) {
		if (this._verticalScrollbarEntity === arg) {
			return;
		}
		const isString = typeof arg === "string";
		if (this._verticalScrollbarEntity && isString && this._verticalScrollbarEntity.guid === arg) {
			return;
		}
		if (this._verticalScrollbarEntity) {
			this._verticalScrollbarEntityUnsubscribe();
		}
		if (arg instanceof GraphNode) {
			this._verticalScrollbarEntity = arg;
		} else if (isString) {
			this._verticalScrollbarEntity = this.system.app.getEntityFromIndex(arg) || null;
		} else {
			this._verticalScrollbarEntity = null;
		}
		this._scrollbarEntities[ORIENTATION_VERTICAL] = this._verticalScrollbarEntity;
		if (this._verticalScrollbarEntity) {
			this._verticalScrollbarEntitySubscribe();
		}
	}
	get verticalScrollbarEntity() {
		return this._verticalScrollbarEntity;
	}
	set scroll(value) {
		this._onSetScroll(value.x, value.y);
	}
	get scroll() {
		return this._scroll;
	}
	_toggleElementListeners(onOrOff) {
		if (this.entity.element) {
			if (onOrOff === "on" && this._hasElementListeners) {
				return;
			}
			this.entity.element[onOrOff]("resize", this._syncAll, this);
			this.entity.element[onOrOff]("mousewheel", this._onMouseWheel, this);
			this._hasElementListeners = onOrOff === "on";
		}
	}
	_onElementComponentAdd(entity) {
		this._evtElementRemove = this.entity.element.once("beforeremove", this._onElementComponentRemove, this);
		this._toggleElementListeners("on");
	}
	_onElementComponentRemove(entity) {
		this._evtElementRemove?.off();
		this._evtElementRemove = null;
		this._toggleElementListeners("off");
	}
	_viewportEntitySubscribe() {
		this._evtViewportEntityElementAdd = this._viewportEntity.on("element:add", this._onViewportElementGain, this);
		if (this._viewportEntity.element) {
			this._onViewportElementGain();
		}
	}
	_viewportEntityUnsubscribe() {
		this._evtViewportEntityElementAdd?.off();
		this._evtViewportEntityElementAdd = null;
		if (this._viewportEntity?.element) {
			this._onViewportElementLose();
		}
	}
	_viewportEntityElementSubscribe() {
		const element = this._viewportEntity.element;
		this._evtViewportElementRemove = element.once("beforeremove", this._onViewportElementLose, this);
		this._evtViewportResize = element.on("resize", this._syncAll, this);
	}
	_viewportEntityElementUnsubscribe() {
		this._evtViewportElementRemove?.off();
		this._evtViewportElementRemove = null;
		this._evtViewportResize?.off();
		this._evtViewportResize = null;
	}
	_onViewportElementGain() {
		this._viewportEntityElementSubscribe();
		this._syncAll();
	}
	_onViewportElementLose() {
		this._viewportEntityElementUnsubscribe();
	}
	_contentEntitySubscribe() {
		this._evtContentEntityElementAdd = this._contentEntity.on("element:add", this._onContentElementGain, this);
		if (this._contentEntity.element) {
			this._onContentElementGain();
		}
	}
	_contentEntityUnsubscribe() {
		this._evtContentEntityElementAdd?.off();
		this._evtContentEntityElementAdd = null;
		if (this._contentEntity?.element) {
			this._onContentElementLose();
		}
	}
	_contentEntityElementSubscribe() {
		const element = this._contentEntity.element;
		this._evtContentElementRemove = element.once("beforeremove", this._onContentElementLose, this);
		this._evtContentResize = element.on("resize", this._syncAll, this);
	}
	_contentEntityElementUnsubscribe() {
		this._evtContentElementRemove?.off();
		this._evtContentElementRemove = null;
		this._evtContentResize?.off();
		this._evtContentResize = null;
	}
	_onContentElementGain() {
		this._contentEntityElementSubscribe();
		this._destroyDragHelper();
		this._contentDragHelper = new ElementDragHelper(this._contentEntity.element);
		this._contentDragHelper.on("drag:start", this._onContentDragStart, this);
		this._contentDragHelper.on("drag:end", this._onContentDragEnd, this);
		this._contentDragHelper.on("drag:move", this._onContentDragMove, this);
		this._prevContentSizes[ORIENTATION_HORIZONTAL] = null;
		this._prevContentSizes[ORIENTATION_VERTICAL] = null;
		this._syncAll();
	}
	_onContentElementLose() {
		this._contentEntityElementUnsubscribe();
		this._destroyDragHelper();
	}
	_onContentDragStart() {
		if (this._contentEntity && this.enabled && this.entity.enabled) {
			this._dragStartPosition.copy(this._contentEntity.getLocalPosition());
		}
	}
	_onContentDragEnd() {
		this._prevContentDragPosition = null;
		this._enableContentInput();
	}
	_onContentDragMove(position5) {
		if (this._contentEntity && this.enabled && this.entity.enabled) {
			this._wasDragged = true;
			this._setScrollFromContentPosition(position5);
			this._setVelocityFromContentPositionDelta(position5);
			if (!this._disabledContentInput) {
				const dx = position5.x - this._dragStartPosition.x;
				const dy = position5.y - this._dragStartPosition.y;
				if (Math.abs(dx) > this.dragThreshold || Math.abs(dy) > this.dragThreshold) {
					this._disableContentInput();
				}
			}
		}
	}
	_horizontalScrollbarEntitySubscribe() {
		this._evtHorizontalScrollbarAdd = this._horizontalScrollbarEntity.on("scrollbar:add", this._onHorizontalScrollbarGain, this);
		if (this._horizontalScrollbarEntity.scrollbar) {
			this._onHorizontalScrollbarGain();
		}
	}
	_verticalScrollbarEntitySubscribe() {
		this._evtVerticalScrollbarAdd = this._verticalScrollbarEntity.on("scrollbar:add", this._onVerticalScrollbarGain, this);
		if (this._verticalScrollbarEntity.scrollbar) {
			this._onVerticalScrollbarGain();
		}
	}
	_horizontalScrollbarEntityUnsubscribe() {
		this._evtHorizontalScrollbarAdd?.off();
		this._evtHorizontalScrollbarAdd = null;
		if (this._horizontalScrollbarEntity.scrollbar) {
			this._onHorizontalScrollbarLose();
		}
	}
	_verticalScrollbarEntityUnsubscribe() {
		this._evtVerticalScrollbarAdd?.off();
		this._evtVerticalScrollbarAdd = null;
		if (this._verticalScrollbarEntity.scrollbar) {
			this._onVerticalScrollbarLose();
		}
	}
	_onSetHorizontalScrollbarValue(scrollValueX) {
		if (!this._scrollbarUpdateFlags[ORIENTATION_HORIZONTAL] && this.enabled && this.entity.enabled) {
			this._onSetScroll(scrollValueX, null);
		}
	}
	_onSetVerticalScrollbarValue(scrollValueY) {
		if (!this._scrollbarUpdateFlags[ORIENTATION_VERTICAL] && this.enabled && this.entity.enabled) {
			this._onSetScroll(null, scrollValueY);
		}
	}
	_onHorizontalScrollbarGain() {
		const scrollbar = this._horizontalScrollbarEntity?.scrollbar;
		this._evtHorizontalScrollbarRemove = scrollbar.on("beforeremove", this._onHorizontalScrollbarLose, this);
		this._evtHorizontalScrollbarValue = scrollbar.on("set:value", this._onSetHorizontalScrollbarValue, this);
		this._syncScrollbarEnabledState(ORIENTATION_HORIZONTAL);
		this._syncScrollbarPosition(ORIENTATION_HORIZONTAL);
	}
	_onVerticalScrollbarGain() {
		const scrollbar = this._verticalScrollbarEntity?.scrollbar;
		this._evtVerticalScrollbarRemove = scrollbar.on("beforeremove", this._onVerticalScrollbarLose, this);
		this._evtVerticalScrollbarValue = scrollbar.on("set:value", this._onSetVerticalScrollbarValue, this);
		this._syncScrollbarEnabledState(ORIENTATION_VERTICAL);
		this._syncScrollbarPosition(ORIENTATION_VERTICAL);
	}
	_onHorizontalScrollbarLose() {
		this._evtHorizontalScrollbarRemove?.off();
		this._evtHorizontalScrollbarRemove = null;
		this._evtHorizontalScrollbarValue?.off();
		this._evtHorizontalScrollbarValue = null;
	}
	_onVerticalScrollbarLose() {
		this._evtVerticalScrollbarRemove?.off();
		this._evtVerticalScrollbarRemove = null;
		this._evtVerticalScrollbarValue?.off();
		this._evtVerticalScrollbarValue = null;
	}
	_onSetScroll(x3, y2, resetVelocity) {
		if (resetVelocity !== false) {
			this._velocity.set(0, 0, 0);
		}
		const xChanged = this._updateAxis(x3, "x", ORIENTATION_HORIZONTAL);
		const yChanged = this._updateAxis(y2, "y", ORIENTATION_VERTICAL);
		if (xChanged || yChanged) {
			this.fire("set:scroll", this._scroll);
		}
	}
	_updateAxis(scrollValue, axis, orientation) {
		const hasChanged = scrollValue !== null && Math.abs(scrollValue - this._scroll[axis]) > 1e-5;
		if (hasChanged || this._isDragging() || scrollValue === 0) {
			this._scroll[axis] = this._determineNewScrollValue(scrollValue, axis, orientation);
			this._syncContentPosition(orientation);
			this._syncScrollbarPosition(orientation);
		}
		return hasChanged;
	}
	_determineNewScrollValue(scrollValue, axis, orientation) {
		if (!this._getScrollingEnabled(orientation)) {
			return this._scroll[axis];
		}
		switch (this.scrollMode) {
			case SCROLL_MODE_CLAMP:
				return math.clamp(scrollValue, 0, this._getMaxScrollValue(orientation));
			case SCROLL_MODE_BOUNCE:
				this._setVelocityFromOvershoot(scrollValue, axis, orientation);
				return scrollValue;
			case SCROLL_MODE_INFINITE:
				return scrollValue;
			default:
				console.warn(`Unhandled scroll mode:${this.scrollMode}`);
				return scrollValue;
		}
	}
	_syncAll() {
		this._syncContentPosition(ORIENTATION_HORIZONTAL);
		this._syncContentPosition(ORIENTATION_VERTICAL);
		this._syncScrollbarPosition(ORIENTATION_HORIZONTAL);
		this._syncScrollbarPosition(ORIENTATION_VERTICAL);
		this._syncScrollbarEnabledState(ORIENTATION_HORIZONTAL);
		this._syncScrollbarEnabledState(ORIENTATION_VERTICAL);
	}
	_syncContentPosition(orientation) {
		if (!this._contentEntity) {
			return;
		}
		const axis = this._getAxis(orientation);
		const sign = this._getSign(orientation);
		const prevContentSize = this._prevContentSizes[orientation];
		const currContentSize = this._getContentSize(orientation);
		if (prevContentSize !== null && Math.abs(prevContentSize - currContentSize) > 1e-4) {
			const prevMaxOffset = this._getMaxOffset(orientation, prevContentSize);
			const currMaxOffset = this._getMaxOffset(orientation, currContentSize);
			if (currMaxOffset === 0) {
				this._scroll[axis] = 1;
			} else {
				this._scroll[axis] = math.clamp(this._scroll[axis] * prevMaxOffset / currMaxOffset, 0, 1);
			}
		}
		const offset3 = this._scroll[axis] * this._getMaxOffset(orientation);
		const contentPosition = this._contentEntity.getLocalPosition();
		contentPosition[axis] = offset3 * sign;
		this._contentEntity.setLocalPosition(contentPosition);
		this._prevContentSizes[orientation] = currContentSize;
	}
	_syncScrollbarPosition(orientation) {
		const scrollbarEntity = this._scrollbarEntities[orientation];
		if (!scrollbarEntity?.scrollbar) {
			return;
		}
		const axis = this._getAxis(orientation);
		this._scrollbarUpdateFlags[orientation] = true;
		scrollbarEntity.scrollbar.value = this._scroll[axis];
		scrollbarEntity.scrollbar.handleSize = this._getScrollbarHandleSize(axis, orientation);
		this._scrollbarUpdateFlags[orientation] = false;
	}
	// Toggles the scrollbar entities themselves to be enabled/disabled based
	// on whether the user has enabled horizontal/vertical scrolling on the
	// scroll view.
	_syncScrollbarEnabledState(orientation) {
		const entity = this._scrollbarEntities[orientation];
		if (!entity) {
			return;
		}
		const isScrollingEnabled = this._getScrollingEnabled(orientation);
		const requestedVisibility = this._getScrollbarVisibility(orientation);
		switch (requestedVisibility) {
			case SCROLLBAR_VISIBILITY_SHOW_ALWAYS:
				entity.enabled = isScrollingEnabled;
				return;
			case SCROLLBAR_VISIBILITY_SHOW_WHEN_REQUIRED:
				entity.enabled = isScrollingEnabled && this._contentIsLargerThanViewport(orientation);
				return;
			default:
				console.warn(`Unhandled scrollbar visibility:${requestedVisibility}`);
				entity.enabled = isScrollingEnabled;
		}
	}
	_contentIsLargerThanViewport(orientation) {
		return this._getContentSize(orientation) > this._getViewportSize(orientation);
	}
	_contentPositionToScrollValue(contentPosition) {
		const maxOffsetH = this._getMaxOffset(ORIENTATION_HORIZONTAL);
		const maxOffsetV = this._getMaxOffset(ORIENTATION_VERTICAL);
		if (maxOffsetH === 0) {
			_tempScrollValue.x = 0;
		} else {
			_tempScrollValue.x = contentPosition.x / maxOffsetH;
		}
		if (maxOffsetV === 0) {
			_tempScrollValue.y = 0;
		} else {
			_tempScrollValue.y = contentPosition.y / -maxOffsetV;
		}
		return _tempScrollValue;
	}
	_getMaxOffset(orientation, contentSize) {
		contentSize = contentSize === void 0 ? this._getContentSize(orientation) : contentSize;
		const viewportSize = this._getViewportSize(orientation);
		if (contentSize < viewportSize) {
			return -this._getViewportSize(orientation);
		}
		return viewportSize - contentSize;
	}
	_getMaxScrollValue(orientation) {
		return this._contentIsLargerThanViewport(orientation) ? 1 : 0;
	}
	_getScrollbarHandleSize(axis, orientation) {
		const viewportSize = this._getViewportSize(orientation);
		const contentSize = this._getContentSize(orientation);
		if (Math.abs(contentSize) < 1e-3) {
			return 1;
		}
		const handleSize = Math.min(viewportSize / contentSize, 1);
		const overshoot = this._toOvershoot(this._scroll[axis], orientation);
		if (overshoot === 0) {
			return handleSize;
		}
		return handleSize / (1 + Math.abs(overshoot));
	}
	_getViewportSize(orientation) {
		return this._getSize(orientation, this._viewportEntity);
	}
	_getContentSize(orientation) {
		return this._getSize(orientation, this._contentEntity);
	}
	_getSize(orientation, entity) {
		if (entity?.element) {
			return entity.element[this._getCalculatedDimension(orientation)];
		}
		return 0;
	}
	_getScrollingEnabled(orientation) {
		if (orientation === ORIENTATION_HORIZONTAL) {
			return this.horizontal;
		} else if (orientation === ORIENTATION_VERTICAL) {
			return this.vertical;
		}
		return void 0;
	}
	_getScrollbarVisibility(orientation) {
		if (orientation === ORIENTATION_HORIZONTAL) {
			return this.horizontalScrollbarVisibility;
		} else if (orientation === ORIENTATION_VERTICAL) {
			return this.verticalScrollbarVisibility;
		}
		return void 0;
	}
	_getSign(orientation) {
		return orientation === ORIENTATION_HORIZONTAL ? 1 : -1;
	}
	_getAxis(orientation) {
		return orientation === ORIENTATION_HORIZONTAL ? "x" : "y";
	}
	_getCalculatedDimension(orientation) {
		return orientation === ORIENTATION_HORIZONTAL ? "calculatedWidth" : "calculatedHeight";
	}
	_destroyDragHelper() {
		if (this._contentDragHelper) {
			this._contentDragHelper.destroy();
		}
	}
	onUpdate() {
		if (this._contentEntity) {
			this._updateVelocity();
			this._syncScrollbarEnabledState(ORIENTATION_HORIZONTAL);
			this._syncScrollbarEnabledState(ORIENTATION_VERTICAL);
		}
	}
	_updateVelocity() {
		if (!this._isDragging()) {
			if (this.scrollMode === SCROLL_MODE_BOUNCE) {
				if (this._hasOvershoot("x", ORIENTATION_HORIZONTAL)) {
					this._setVelocityFromOvershoot(this.scroll.x, "x", ORIENTATION_HORIZONTAL);
				}
				if (this._hasOvershoot("y", ORIENTATION_VERTICAL)) {
					this._setVelocityFromOvershoot(this.scroll.y, "y", ORIENTATION_VERTICAL);
				}
			}
			if (Math.abs(this._velocity.x) > 1e-4 || Math.abs(this._velocity.y) > 1e-4) {
				const position5 = this._contentEntity.getLocalPosition();
				position5.x += this._velocity.x;
				position5.y += this._velocity.y;
				this._contentEntity.setLocalPosition(position5);
				this._setScrollFromContentPosition(position5);
			}
			this._velocity.x *= 1 - this.friction;
			this._velocity.y *= 1 - this.friction;
		}
	}
	_hasOvershoot(axis, orientation) {
		return Math.abs(this._toOvershoot(this.scroll[axis], orientation)) > 1e-3;
	}
	_toOvershoot(scrollValue, orientation) {
		const maxScrollValue = this._getMaxScrollValue(orientation);
		if (scrollValue < 0) {
			return scrollValue;
		} else if (scrollValue > maxScrollValue) {
			return scrollValue - maxScrollValue;
		}
		return 0;
	}
	_setVelocityFromOvershoot(scrollValue, axis, orientation) {
		const overshootValue = this._toOvershoot(scrollValue, orientation);
		const overshootPixels = overshootValue * this._getMaxOffset(orientation) * this._getSign(orientation);
		if (Math.abs(overshootPixels) > 0) {
			this._velocity[axis] = -overshootPixels / (this.bounceAmount * 50 + 1);
		}
	}
	_setVelocityFromContentPositionDelta(position5) {
		if (this._prevContentDragPosition) {
			this._velocity.sub2(position5, this._prevContentDragPosition);
			this._prevContentDragPosition.copy(position5);
		} else {
			this._velocity.set(0, 0, 0);
			this._prevContentDragPosition = position5.clone();
		}
	}
	_setScrollFromContentPosition(position5) {
		let scrollValue = this._contentPositionToScrollValue(position5);
		if (this._isDragging()) {
			scrollValue = this._applyScrollValueTension(scrollValue);
		}
		this._onSetScroll(scrollValue.x, scrollValue.y, false);
	}
	// Create nice tension effect when dragging past the extents of the viewport
	_applyScrollValueTension(scrollValue) {
		const factor = 1;
		let max = this._getMaxScrollValue(ORIENTATION_HORIZONTAL);
		let overshoot = this._toOvershoot(scrollValue.x, ORIENTATION_HORIZONTAL);
		if (overshoot > 0) {
			scrollValue.x = max + factor * Math.log10(1 + overshoot);
		} else if (overshoot < 0) {
			scrollValue.x = -factor * Math.log10(1 - overshoot);
		}
		max = this._getMaxScrollValue(ORIENTATION_VERTICAL);
		overshoot = this._toOvershoot(scrollValue.y, ORIENTATION_VERTICAL);
		if (overshoot > 0) {
			scrollValue.y = max + factor * Math.log10(1 + overshoot);
		} else if (overshoot < 0) {
			scrollValue.y = -factor * Math.log10(1 - overshoot);
		}
		return scrollValue;
	}
	_isDragging() {
		return this._contentDragHelper && this._contentDragHelper.isDragging;
	}
	_setScrollbarComponentsEnabled(enabled) {
		if (this._horizontalScrollbarEntity?.scrollbar) {
			this._horizontalScrollbarEntity.scrollbar.enabled = enabled;
		}
		if (this._verticalScrollbarEntity?.scrollbar) {
			this._verticalScrollbarEntity.scrollbar.enabled = enabled;
		}
	}
	_setContentDraggingEnabled(enabled) {
		if (this._contentDragHelper) {
			this._contentDragHelper.enabled = enabled;
		}
	}
	_onMouseWheel(event) {
		if (!this.useMouseWheel || !this._contentEntity?.element) {
			return;
		}
		const wheelEvent = event.event;
		const normalizedDeltaX = wheelEvent.deltaX / this._contentEntity.element.calculatedWidth * this.mouseWheelSensitivity.x;
		const normalizedDeltaY = wheelEvent.deltaY / this._contentEntity.element.calculatedHeight * this.mouseWheelSensitivity.y;
		const scrollX = math.clamp(this._scroll.x + normalizedDeltaX, 0, this._getMaxScrollValue(ORIENTATION_HORIZONTAL));
		const scrollY = math.clamp(this._scroll.y + normalizedDeltaY, 0, this._getMaxScrollValue(ORIENTATION_VERTICAL));
		this.scroll = new Vec2(scrollX, scrollY);
	}
	// re-enable useInput flag on any descendant that was disabled
	_enableContentInput() {
		while (this._disabledContentInputEntities.length) {
			const e = this._disabledContentInputEntities.pop();
			if (e.element) {
				e.element.useInput = true;
			}
		}
		this._disabledContentInput = false;
	}
	// disable useInput flag on all descendants of this contentEntity
	_disableContentInput() {
		const _disableInput = (e) => {
			if (e.element && e.element.useInput) {
				this._disabledContentInputEntities.push(e);
				e.element.useInput = false;
			}
			const children = e.children;
			for (let i2 = 0, l = children.length; i2 < l; i2++) {
				_disableInput(children[i2]);
			}
		};
		if (this._contentEntity) {
			const children = this._contentEntity.children;
			for (let i2 = 0, l = children.length; i2 < l; i2++) {
				_disableInput(children[i2]);
			}
		}
		this._disabledContentInput = true;
	}
	onEnable() {
		this._setScrollbarComponentsEnabled(true);
		this._setContentDraggingEnabled(true);
		this._syncAll();
	}
	onDisable() {
		this._setScrollbarComponentsEnabled(false);
		this._setContentDraggingEnabled(false);
	}
	onBeforeRemove() {
		this._evtElementAdd?.off();
		this._evtElementAdd = null;
		this._evtElementRemove?.off();
		this._evtElementRemove = null;
		this.viewportEntity = null;
		this.contentEntity = null;
		this.horizontalScrollbarEntity = null;
		this.verticalScrollbarEntity = null;
		this._toggleElementListeners("off");
		this._destroyDragHelper();
	}
	resolveDuplicatedEntityReferenceProperties(oldScrollView, duplicatedIdsMap) {
		if (oldScrollView.viewportEntity) {
			this.viewportEntity = duplicatedIdsMap[oldScrollView.viewportEntity.guid];
		}
		if (oldScrollView.contentEntity) {
			this.contentEntity = duplicatedIdsMap[oldScrollView.contentEntity.guid];
		}
		if (oldScrollView.horizontalScrollbarEntity) {
			this.horizontalScrollbarEntity = duplicatedIdsMap[oldScrollView.horizontalScrollbarEntity.guid];
		}
		if (oldScrollView.verticalScrollbarEntity) {
			this.verticalScrollbarEntity = duplicatedIdsMap[oldScrollView.verticalScrollbarEntity.guid];
		}
	}
};

var _properties9 = [
	"horizontal",
	"vertical",
	"scrollMode",
	"bounceAmount",
	"friction",
	"dragThreshold",
	"useMouseWheel",
	"mouseWheelSensitivity",
	"horizontalScrollbarVisibility",
	"verticalScrollbarVisibility",
	"viewportEntity",
	"contentEntity",
	"horizontalScrollbarEntity",
	"verticalScrollbarEntity"
];
var ScrollViewComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "scrollview";
		this.ComponentType = ScrollViewComponent;
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.systems.on("update", this.onUpdate, this);
	}
	initializeComponentData(component, data2, properties) {
		for (let i2 = 0; i2 < _properties9.length; i2++) {
			const property = _properties9[i2];
			if (data2[property] !== void 0) {
				component[property] = data2[property];
			}
		}
		super.initializeComponentData(component, data2);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.scrollview;
		const data2 = {
			enabled: c2.enabled
		};
		for (let i2 = 0; i2 < _properties9.length; i2++) {
			const property = _properties9[i2];
			data2[property] = c2[property];
		}
		return this.addComponent(clone, data2);
	}
	onUpdate(dt) {
		const components2 = this.store;
		for (const id14 in components2) {
			const entity = components2[id14].entity;
			const component = entity.scrollview;
			if (component.enabled && entity.enabled) {
				component.onUpdate();
			}
		}
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	destroy() {
		super.destroy();
		this.app.systems.off("update", this.onUpdate, this);
	}
};

var ScrollbarComponent = class extends Component {
	static EVENT_SETVALUE = "set:value";
	_orientation = ORIENTATION_HORIZONTAL;
	_value = 0;
	_handleSize = 0;
	_handleEntity = null;
	_evtHandleEntityElementAdd = null;
	_evtHandleEntityChanges = [];
	_handleDragHelper = null;
	set orientation(arg) {
		if (this._orientation === arg) {
			return;
		}
		this._orientation = arg;
		if (this._handleEntity?.element) {
			this._handleEntity.element[this._getOppositeDimension()] = 0;
			this._rebuildDragHelper();
			this._updateHandlePositionAndSize();
		}
	}
	get orientation() {
		return this._orientation;
	}
	set value(arg) {
		if (Math.abs(arg - this._value) > 1e-5) {
			this._value = math.clamp(arg, 0, 1);
			this._updateHandlePositionAndSize();
			this.fire("set:value", this._value);
		}
	}
	get value() {
		return this._value;
	}
	set handleSize(arg) {
		if (Math.abs(arg - this._handleSize) > 1e-5) {
			this._handleSize = math.clamp(arg, 0, 1);
			this._updateHandlePositionAndSize();
		}
	}
	get handleSize() {
		return this._handleSize;
	}
	set handleEntity(arg) {
		let newEntity;
		if (arg instanceof GraphNode) {
			newEntity = arg;
		} else if (typeof arg === "string") {
			newEntity = this.system.app.getEntityFromIndex(arg) ?? null;
		} else {
			newEntity = null;
		}
		if (this._handleEntity === newEntity) {
			return;
		}
		if (this._handleEntity) {
			this._handleEntityUnsubscribe();
		}
		this._handleEntity = newEntity;
		if (newEntity) {
			this._handleEntitySubscribe();
		}
	}
	get handleEntity() {
		return this._handleEntity;
	}
	_handleEntitySubscribe() {
		this._evtHandleEntityElementAdd = this._handleEntity.on("element:add", this._onHandleElementGain, this);
		if (this._handleEntity.element) {
			this._onHandleElementGain();
		}
	}
	_handleEntityUnsubscribe() {
		this._evtHandleEntityElementAdd?.off();
		this._evtHandleEntityElementAdd = null;
		if (this._handleEntity?.element) {
			this._onHandleElementLose();
		}
	}
	_handleEntityElementSubscribe() {
		const element = this._handleEntity.element;
		const handles = this._evtHandleEntityChanges;
		handles.push(element.once("beforeremove", this._onHandleElementLose, this));
		handles.push(element.on("set:anchor", this._updateHandlePositionAndSize, this));
		handles.push(element.on("set:margin", this._updateHandlePositionAndSize, this));
		handles.push(element.on("set:pivot", this._updateHandlePositionAndSize, this));
	}
	_handleEntityElementUnsubscribe() {
		for (let i2 = 0; i2 < this._evtHandleEntityChanges.length; i2++) {
			this._evtHandleEntityChanges[i2].off();
		}
		this._evtHandleEntityChanges.length = 0;
	}
	_onHandleElementGain() {
		this._handleEntityElementSubscribe();
		this._rebuildDragHelper();
		this._updateHandlePositionAndSize();
	}
	_rebuildDragHelper() {
		this._destroyDragHelper();
		this._handleDragHelper = new ElementDragHelper(this._handleEntity.element, this._getAxis());
		this._handleDragHelper.enabled = this.enabled && this.entity.enabled;
		this._handleDragHelper.on("drag:move", this._onHandleDrag, this);
	}
	_onHandleElementLose() {
		this._handleEntityElementUnsubscribe();
		this._destroyDragHelper();
	}
	_onHandleDrag(position5) {
		if (this._handleEntity && this.enabled && this.entity.enabled) {
			this.value = this._handlePositionToScrollValue(position5[this._getAxis()]);
		}
	}
	_updateHandlePositionAndSize() {
		const handleEntity = this._handleEntity;
		if (!handleEntity) return;
		const position5 = handleEntity.getLocalPosition();
		position5[this._getAxis()] = this._getHandlePosition();
		handleEntity.setLocalPosition(position5);
		if (handleEntity.element) {
			handleEntity.element[this._getDimension()] = this._getHandleLength();
		}
	}
	_handlePositionToScrollValue(handlePosition) {
		return handlePosition * this._getSign() / this._getUsableTrackLength();
	}
	_scrollValueToHandlePosition(value) {
		return value * this._getSign() * this._getUsableTrackLength();
	}
	_getUsableTrackLength() {
		return Math.max(this._getTrackLength() - this._getHandleLength(), 1e-3);
	}
	_getTrackLength() {
		if (this.entity.element) {
			return this._orientation === ORIENTATION_HORIZONTAL ? this.entity.element.calculatedWidth : this.entity.element.calculatedHeight;
		}
		return 0;
	}
	_getHandleLength() {
		return this._getTrackLength() * this._handleSize;
	}
	_getHandlePosition() {
		return this._scrollValueToHandlePosition(this._value);
	}
	_getSign() {
		return this._orientation === ORIENTATION_HORIZONTAL ? 1 : -1;
	}
	_getAxis() {
		return this._orientation === ORIENTATION_HORIZONTAL ? "x" : "y";
	}
	_getDimension() {
		return this._orientation === ORIENTATION_HORIZONTAL ? "width" : "height";
	}
	_getOppositeDimension() {
		return this._orientation === ORIENTATION_HORIZONTAL ? "height" : "width";
	}
	_destroyDragHelper() {
		this._handleDragHelper?.destroy();
		this._handleDragHelper = null;
	}
	onEnable() {
		if (this._handleDragHelper) {
			this._handleDragHelper.enabled = true;
		}
	}
	onDisable() {
		if (this._handleDragHelper) {
			this._handleDragHelper.enabled = false;
		}
	}
	onBeforeRemove() {
		this._destroyDragHelper();
	}
	resolveDuplicatedEntityReferenceProperties(oldScrollbar, duplicatedIdsMap) {
		if (oldScrollbar.handleEntity) {
			this.handleEntity = duplicatedIdsMap[oldScrollbar.handleEntity.guid];
		}
	}
};

var _properties10 = ["orientation", "value", "handleSize", "handleEntity"];
var ScrollbarComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "scrollbar";
		this.ComponentType = ScrollbarComponent;
		this.on("add", this._onAddComponent, this);
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	initializeComponentData(component, data2, properties) {
		for (let i2 = 0; i2 < _properties10.length; i2++) {
			const property = _properties10[i2];
			if (data2.hasOwnProperty(property)) {
				component[property] = data2[property];
			}
		}
		super.initializeComponentData(component, data2);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.scrollbar;
		const data2 = {
			enabled: c2.enabled
		};
		for (let i2 = 0; i2 < _properties10.length; i2++) {
			const property = _properties10[i2];
			data2[property] = c2[property];
		}
		return this.addComponent(clone, data2);
	}
	_onAddComponent(entity) {
		entity.fire("scrollbar:add");
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
};

var instanceOptions = {
	volume: 0,
	pitch: 0,
	loop: false,
	startTime: 0,
	duration: 0,
	position: new Vec3(),
	maxDistance: 0,
	refDistance: 0,
	rollOffFactor: 0,
	distanceModel: 0,
	onPlay: null,
	onPause: null,
	onResume: null,
	onStop: null,
	onEnd: null
};
var SoundSlot = class extends EventHandler {
	static EVENT_PLAY = "play";
	static EVENT_PAUSE = "pause";
	static EVENT_RESUME = "resume";
	static EVENT_STOP = "stop";
	static EVENT_END = "end";
	static EVENT_LOAD = "load";
	name;
	instances = [];
	constructor(component, name = "Untitled", options2 = {}) {
		super();
		this._component = component;
		this._assets = component.system.app.assets;
		this._manager = component.system.manager;
		this.name = name;
		this._volume = options2.volume !== void 0 ? math.clamp(Number(options2.volume) || 0, 0, 1) : 1;
		this._pitch = options2.pitch !== void 0 ? Math.max(0.01, Number(options2.pitch) || 0) : 1;
		this._loop = !!(options2.loop !== void 0 ? options2.loop : false);
		this._duration = options2.duration > 0 ? options2.duration : null;
		this._startTime = Math.max(0, Number(options2.startTime) || 0);
		this._overlap = !!options2.overlap;
		this._autoPlay = !!options2.autoPlay;
		this._firstNode = null;
		this._lastNode = null;
		this._asset = options2.asset;
		if (this._asset instanceof Asset) {
			this._asset = this._asset.id;
		}
		this._onInstancePlayHandler = this._onInstancePlay.bind(this);
		this._onInstancePauseHandler = this._onInstancePause.bind(this);
		this._onInstanceResumeHandler = this._onInstanceResume.bind(this);
		this._onInstanceStopHandler = this._onInstanceStop.bind(this);
		this._onInstanceEndHandler = this._onInstanceEnd.bind(this);
	}
	play() {
		if (!this.overlap) {
			this.stop();
		}
		if (!this.isLoaded && !this._hasAsset()) {
			return void 0;
		}
		const instance = this._createInstance();
		this.instances.push(instance);
		if (!this.isLoaded) {
			const onLoad = function(sound) {
				const playWhenLoaded = instance._playWhenLoaded;
				instance.sound = sound;
				if (playWhenLoaded) {
					instance.play();
				}
			};
			this.off("load", onLoad);
			this.once("load", onLoad);
			this.load();
		} else {
			instance.play();
		}
		return instance;
	}
	pause() {
		let paused = false;
		const instances = this.instances;
		for (let i2 = 0, len = instances.length; i2 < len; i2++) {
			if (instances[i2].pause()) {
				paused = true;
			}
		}
		return paused;
	}
	resume() {
		let resumed = false;
		const instances = this.instances;
		for (let i2 = 0, len = instances.length; i2 < len; i2++) {
			if (instances[i2].resume()) {
				resumed = true;
			}
		}
		return resumed;
	}
	stop() {
		let stopped = false;
		const instances = this.instances;
		let i2 = instances.length;
		while (i2--) {
			instances[i2].stop();
			stopped = true;
		}
		instances.length = 0;
		return stopped;
	}
	load() {
		if (!this._hasAsset()) {
			return;
		}
		const asset = this._assets.get(this._asset);
		if (!asset) {
			this._assets.off(`add:${this._asset}`, this._onAssetAdd, this);
			this._assets.once(`add:${this._asset}`, this._onAssetAdd, this);
			return;
		}
		asset.off("remove", this._onAssetRemoved, this);
		asset.on("remove", this._onAssetRemoved, this);
		if (!asset.resource) {
			asset.off("load", this._onAssetLoad, this);
			asset.once("load", this._onAssetLoad, this);
			this._assets.load(asset);
			return;
		}
		this.fire("load", asset.resource);
	}
	setExternalNodes(firstNode, lastNode) {
		if (!firstNode) {
			console.error("The firstNode must have a valid AudioNode");
			return;
		}
		if (!lastNode) {
			lastNode = firstNode;
		}
		this._firstNode = firstNode;
		this._lastNode = lastNode;
		if (!this._overlap) {
			const instances = this.instances;
			for (let i2 = 0, len = instances.length; i2 < len; i2++) {
				instances[i2].setExternalNodes(firstNode, lastNode);
			}
		}
	}
	clearExternalNodes() {
		this._firstNode = null;
		this._lastNode = null;
		if (!this._overlap) {
			const instances = this.instances;
			for (let i2 = 0, len = instances.length; i2 < len; i2++) {
				instances[i2].clearExternalNodes();
			}
		}
	}
	getExternalNodes() {
		return [this._firstNode, this._lastNode];
	}
	_hasAsset() {
		return this._asset != null;
	}
	_createInstance() {
		let instance = null;
		const component = this._component;
		let sound = null;
		if (this._hasAsset()) {
			const asset = this._assets.get(this._asset);
			if (asset) {
				sound = asset.resource;
			}
		}
		const data2 = instanceOptions;
		data2.volume = this._volume * component.volume;
		data2.pitch = this._pitch * component.pitch;
		data2.loop = this._loop;
		data2.startTime = this._startTime;
		data2.duration = this._duration;
		data2.onPlay = this._onInstancePlayHandler;
		data2.onPause = this._onInstancePauseHandler;
		data2.onResume = this._onInstanceResumeHandler;
		data2.onStop = this._onInstanceStopHandler;
		data2.onEnd = this._onInstanceEndHandler;
		if (component.positional) {
			data2.position.copy(component.entity.getPosition());
			data2.maxDistance = component.maxDistance;
			data2.refDistance = component.refDistance;
			data2.rollOffFactor = component.rollOffFactor;
			data2.distanceModel = component.distanceModel;
			instance = new SoundInstance3d(this._manager, sound, data2);
		} else {
			instance = new SoundInstance(this._manager, sound, data2);
		}
		if (this._firstNode) {
			instance.setExternalNodes(this._firstNode, this._lastNode);
		}
		return instance;
	}
	_onInstancePlay(instance) {
		this.fire("play", instance);
		this._component.fire("play", this, instance);
	}
	_onInstancePause(instance) {
		this.fire("pause", instance);
		this._component.fire("pause", this, instance);
	}
	_onInstanceResume(instance) {
		this.fire("resume", instance);
		this._component.fire("resume", this, instance);
	}
	_onInstanceStop(instance) {
		const idx = this.instances.indexOf(instance);
		if (idx !== -1) {
			this.instances.splice(idx, 1);
		}
		this.fire("stop", instance);
		this._component.fire("stop", this, instance);
	}
	_onInstanceEnd(instance) {
		const idx = this.instances.indexOf(instance);
		if (idx !== -1) {
			this.instances.splice(idx, 1);
		}
		this.fire("end", instance);
		this._component.fire("end", this, instance);
	}
	_onAssetAdd(asset) {
		this.load();
	}
	_onAssetLoad(asset) {
		this.load();
	}
	_onAssetRemoved(asset) {
		asset.off("remove", this._onAssetRemoved, this);
		this._assets.off(`add:${asset.id}`, this._onAssetAdd, this);
		this.stop();
	}
	updatePosition(position5) {
		const instances = this.instances;
		for (let i2 = 0, len = instances.length; i2 < len; i2++) {
			instances[i2].position = position5;
		}
	}
	set asset(value) {
		const old = this._asset;
		if (old) {
			this._assets.off(`add:${old}`, this._onAssetAdd, this);
			const oldAsset = this._assets.get(old);
			if (oldAsset) {
				oldAsset.off("remove", this._onAssetRemoved, this);
			}
		}
		this._asset = value;
		if (this._asset instanceof Asset) {
			this._asset = this._asset.id;
		}
		if (this._hasAsset() && this._component.enabled && this._component.entity.enabled) {
			this.load();
		}
	}
	get asset() {
		return this._asset;
	}
	set autoPlay(value) {
		this._autoPlay = !!value;
	}
	get autoPlay() {
		return this._autoPlay;
	}
	set duration(value) {
		this._duration = Math.max(0, Number(value) || 0) || null;
		if (!this._overlap) {
			const instances = this.instances;
			for (let i2 = 0, len = instances.length; i2 < len; i2++) {
				instances[i2].duration = this._duration;
			}
		}
	}
	get duration() {
		let assetDuration = 0;
		if (this._hasAsset()) {
			const asset = this._assets.get(this._asset);
			assetDuration = asset?.resource ? asset.resource.duration : 0;
		}
		if (this._duration != null) {
			return this._duration % (assetDuration || 1);
		}
		return assetDuration;
	}
	get isLoaded() {
		if (this._hasAsset()) {
			const asset = this._assets.get(this._asset);
			if (asset) {
				return !!asset.resource;
			}
		}
		return false;
	}
	get isPaused() {
		const instances = this.instances;
		const len = instances.length;
		if (len === 0) {
			return false;
		}
		for (let i2 = 0; i2 < len; i2++) {
			if (!instances[i2].isPaused) {
				return false;
			}
		}
		return true;
	}
	get isPlaying() {
		const instances = this.instances;
		for (let i2 = 0, len = instances.length; i2 < len; i2++) {
			if (instances[i2].isPlaying) {
				return true;
			}
		}
		return false;
	}
	get isStopped() {
		const instances = this.instances;
		for (let i2 = 0, len = instances.length; i2 < len; i2++) {
			if (!instances[i2].isStopped) {
				return false;
			}
		}
		return true;
	}
	set loop(value) {
		this._loop = !!value;
		const instances = this.instances;
		for (let i2 = 0, len = instances.length; i2 < len; i2++) {
			instances[i2].loop = this._loop;
		}
	}
	get loop() {
		return this._loop;
	}
	set overlap(value) {
		this._overlap = !!value;
	}
	get overlap() {
		return this._overlap;
	}
	set pitch(value) {
		this._pitch = Math.max(Number(value) || 0, 0.01);
		if (!this._overlap) {
			const instances = this.instances;
			for (let i2 = 0, len = instances.length; i2 < len; i2++) {
				instances[i2].pitch = this.pitch * this._component.pitch;
			}
		}
	}
	get pitch() {
		return this._pitch;
	}
	set startTime(value) {
		this._startTime = Math.max(0, Number(value) || 0);
		if (!this._overlap) {
			const instances = this.instances;
			for (let i2 = 0, len = instances.length; i2 < len; i2++) {
				instances[i2].startTime = this._startTime;
			}
		}
	}
	get startTime() {
		return this._startTime;
	}
	set volume(value) {
		this._volume = math.clamp(Number(value) || 0, 0, 1);
		if (!this._overlap) {
			const instances = this.instances;
			for (let i2 = 0, len = instances.length; i2 < len; i2++) {
				instances[i2].volume = this._volume * this._component.volume;
			}
		}
	}
	get volume() {
		return this._volume;
	}
};

var SoundComponent = class extends Component {
	static EVENT_PLAY = "play";
	static EVENT_PAUSE = "pause";
	static EVENT_RESUME = "resume";
	static EVENT_STOP = "stop";
	static EVENT_END = "end";
	_volume = 1;
	_pitch = 1;
	_positional = true;
	_refDistance = 1;
	_maxDistance = 1e4;
	_rollOffFactor = 1;
	_distanceModel = DISTANCE_LINEAR;
	_slots = {};
	_playingBeforeDisable = {};
	_updateSoundInstances(property, value, isFactor) {
		const slots = this._slots;
		for (const key in slots) {
			const slot = slots[key];
			if (!slot.overlap) {
				const instances = slot.instances;
				for (let i2 = 0, len = instances.length; i2 < len; i2++) {
					instances[i2][property] = isFactor ? slot[property] * value : value;
				}
			}
		}
	}
	set distanceModel(value) {
		this._distanceModel = value;
		this._updateSoundInstances("distanceModel", value, false);
	}
	get distanceModel() {
		return this._distanceModel;
	}
	set maxDistance(value) {
		this._maxDistance = value;
		this._updateSoundInstances("maxDistance", value, false);
	}
	get maxDistance() {
		return this._maxDistance;
	}
	set refDistance(value) {
		this._refDistance = value;
		this._updateSoundInstances("refDistance", value, false);
	}
	get refDistance() {
		return this._refDistance;
	}
	set rollOffFactor(value) {
		this._rollOffFactor = value;
		this._updateSoundInstances("rollOffFactor", value, false);
	}
	get rollOffFactor() {
		return this._rollOffFactor;
	}
	set pitch(value) {
		this._pitch = value;
		this._updateSoundInstances("pitch", value, true);
	}
	get pitch() {
		return this._pitch;
	}
	set volume(value) {
		this._volume = value;
		this._updateSoundInstances("volume", value, true);
	}
	get volume() {
		return this._volume;
	}
	set positional(newValue) {
		this._positional = newValue;
		const slots = this._slots;
		for (const key in slots) {
			const slot = slots[key];
			if (!slot.overlap) {
				const instances = slot.instances;
				const oldLength = instances.length;
				for (let i2 = oldLength - 1; i2 >= 0; i2--) {
					const isPlaying = instances[i2].isPlaying || instances[i2].isSuspended;
					const currentTime = instances[i2].currentTime;
					if (isPlaying) {
						instances[i2].stop();
					}
					const instance = slot._createInstance();
					if (isPlaying) {
						instance.play();
						instance.currentTime = currentTime;
					}
					instances.push(instance);
				}
			}
		}
	}
	get positional() {
		return this._positional;
	}
	set slots(newValue) {
		const oldValue = this._slots;
		if (oldValue) {
			for (const key in oldValue) {
				oldValue[key].stop();
			}
		}
		const slots = {};
		for (const key in newValue) {
			if (!(newValue[key] instanceof SoundSlot)) {
				if (newValue[key].name) {
					slots[newValue[key].name] = new SoundSlot(this, newValue[key].name, newValue[key]);
				}
			} else {
				slots[newValue[key].name] = newValue[key];
			}
		}
		this._slots = slots;
		if (this.enabled && this.entity.enabled) {
			this.onEnable();
		}
	}
	get slots() {
		return this._slots;
	}
	onEnable() {
		if (this.system._inTools) {
			return;
		}
		const slots = this._slots;
		const playingBeforeDisable = this._playingBeforeDisable;
		for (const key in slots) {
			const slot = slots[key];
			if (slot.autoPlay && slot.isStopped) {
				slot.play();
			} else if (playingBeforeDisable[key]) {
				slot.resume();
			} else if (!slot.isLoaded) {
				slot.load();
			}
		}
	}
	onDisable() {
		const slots = this._slots;
		const playingBeforeDisable = {};
		for (const key in slots) {
			if (!slots[key].overlap) {
				if (slots[key].isPlaying) {
					slots[key].pause();
					playingBeforeDisable[key] = true;
				}
			}
		}
		this._playingBeforeDisable = playingBeforeDisable;
	}
	onBeforeRemove() {
		this.off();
	}
	addSlot(name, options2) {
		const slots = this._slots;
		if (slots[name]) {
			return null;
		}
		const slot = new SoundSlot(this, name, options2);
		slots[name] = slot;
		if (slot.autoPlay && this.enabled && this.entity.enabled) {
			slot.play();
		}
		return slot;
	}
	removeSlot(name) {
		const slots = this._slots;
		if (slots[name]) {
			slots[name].stop();
			delete slots[name];
		}
	}
	slot(name) {
		return this._slots[name];
	}
	_getSlotProperty(name, property) {
		if (!this.enabled || !this.entity.enabled) {
			return void 0;
		}
		const slot = this._slots[name];
		if (!slot) {
			return void 0;
		}
		return slot[property];
	}
	isPlaying(name) {
		return this._getSlotProperty(name, "isPlaying") || false;
	}
	isLoaded(name) {
		return this._getSlotProperty(name, "isLoaded") || false;
	}
	isPaused(name) {
		return this._getSlotProperty(name, "isPaused") || false;
	}
	isStopped(name) {
		return this._getSlotProperty(name, "isStopped") || false;
	}
	play(name) {
		if (!this.enabled || !this.entity.enabled) {
			return null;
		}
		const slot = this._slots[name];
		if (!slot) {
			return null;
		}
		return slot.play();
	}
	pause(name) {
		const slots = this._slots;
		if (name) {
			const slot = slots[name];
			if (!slot) {
				return;
			}
			slot.pause();
		} else {
			for (const key in slots) {
				slots[key].pause();
			}
		}
	}
	resume(name) {
		const slots = this._slots;
		if (name) {
			const slot = slots[name];
			if (!slot) {
				return;
			}
			if (slot.isPaused) {
				slot.resume();
			}
		} else {
			for (const key in slots) {
				slots[key].resume();
			}
		}
	}
	stop(name) {
		const slots = this._slots;
		if (name) {
			const slot = slots[name];
			if (!slot) {
				return;
			}
			slot.stop();
		} else {
			for (const key in slots) {
				slots[key].stop();
			}
		}
	}
};

var _properties11 = [
	"volume",
	"pitch",
	"positional",
	"refDistance",
	"maxDistance",
	"rollOffFactor",
	"distanceModel",
	"slots"
];
var SoundComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "sound";
		this.ComponentType = SoundComponent;
		this.manager = app2.soundManager;
		this.app.systems.on("update", this.onUpdate, this);
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	set volume(volume) {
		this.manager.volume = volume;
	}
	get volume() {
		return this.manager.volume;
	}
	get context() {
		return this.manager.context;
	}
	initializeComponentData(component, data2) {
		for (let i2 = 0; i2 < _properties11.length; i2++) {
			if (data2.hasOwnProperty(_properties11[i2])) {
				component[_properties11[i2]] = data2[_properties11[i2]];
			}
		}
		super.initializeComponentData(component, data2);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.sound;
		const data2 = {
			enabled: c2.enabled
		};
		for (let i2 = 0; i2 < _properties11.length; i2++) {
			const property = _properties11[i2];
			if (property === "slots") {
				const slots = {};
				for (const key in c2.slots) {
					const srcSlot = c2.slots[key];
					slots[key] = {
						name: srcSlot.name,
						volume: srcSlot.volume,
						pitch: srcSlot.pitch,
						loop: srcSlot.loop,
						duration: srcSlot.duration,
						startTime: srcSlot.startTime,
						overlap: srcSlot.overlap,
						autoPlay: srcSlot.autoPlay,
						asset: srcSlot.asset
					};
				}
				data2.slots = slots;
			} else {
				data2[property] = c2[property];
			}
		}
		return this.addComponent(clone, data2);
	}
	onUpdate(dt) {
		const store = this.store;
		for (const id14 in store) {
			if (store.hasOwnProperty(id14)) {
				const item = store[id14];
				const entity = item.entity;
				if (entity.enabled) {
					const component = entity.sound;
					if (component.enabled && component.positional) {
						const position5 = entity.getPosition();
						const slots = component.slots;
						for (const key in slots) {
							slots[key].updatePosition(position5);
						}
					}
				}
			}
		}
	}
	onBeforeRemove(entity, component) {
		const slots = component.slots;
		for (const key in slots) {
			if (!slots[key].overlap) {
				slots[key].stop();
			}
		}
		component.onBeforeRemove();
	}
	destroy() {
		super.destroy();
		this.app.systems.off("update", this.onUpdate, this);
	}
};

var SPRITETYPE_SIMPLE = "simple";
var SPRITETYPE_ANIMATED = "animated";

var SpriteAnimationClip = class extends EventHandler {
	static EVENT_PLAY = "play";
	static EVENT_PAUSE = "pause";
	static EVENT_RESUME = "resume";
	static EVENT_STOP = "stop";
	static EVENT_END = "end";
	static EVENT_LOOP = "loop";
	_evtSetMeshes = null;
	_component;
	_frame = 0;
	_sprite = null;
	_spriteAsset = null;
	_playing = false;
	_paused = false;
	_time = 0;
	name;
	fps = 0;
	loop = false;
	constructor(component, data2) {
		super();
		this._component = component;
		this.fps = data2.fps || 0;
		this.loop = data2.loop || false;
		this.name = data2.name;
		this.spriteAsset = data2.spriteAsset;
	}
	get duration() {
		if (this._sprite) {
			const fps = this.fps || Number.MIN_VALUE;
			return this._sprite.frameKeys.length / Math.abs(fps);
		}
		return 0;
	}
	set frame(value) {
		this._setFrame(value);
		const fps = this.fps || Number.MIN_VALUE;
		this._setTime(this._frame / fps);
	}
	get frame() {
		return this._frame;
	}
	get isPaused() {
		return this._paused;
	}
	get isPlaying() {
		return this._playing;
	}
	set sprite(value) {
		if (this._sprite) {
			this._evtSetMeshes?.off();
			this._evtSetMeshes = null;
			this._sprite.off("set:pixelsPerUnit", this._onSpritePpuChanged, this);
			this._sprite.off("set:atlas", this._onSpriteMeshesChange, this);
			if (this._sprite.atlas) {
				this._sprite.atlas.off("set:texture", this._onSpriteMeshesChange, this);
			}
		}
		this._sprite = value;
		if (this._sprite) {
			this._evtSetMeshes = this._sprite.on("set:meshes", this._onSpriteMeshesChange, this);
			this._sprite.on("set:pixelsPerUnit", this._onSpritePpuChanged, this);
			this._sprite.on("set:atlas", this._onSpriteMeshesChange, this);
			if (this._sprite.atlas) {
				this._sprite.atlas.on("set:texture", this._onSpriteMeshesChange, this);
			}
		}
		if (this._component.currentClip === this) {
			let mi;
			if (!value || !value.atlas) {
				mi = this._component._meshInstance;
				if (mi) {
					mi.deleteParameter("texture_emissiveMap");
					mi.deleteParameter("texture_opacityMap");
				}
				this._component.removeFromLayers();
			} else {
				if (value.atlas.texture) {
					mi = this._component._meshInstance;
					if (mi) {
						mi.setParameter("texture_emissiveMap", value.atlas.texture);
						mi.setParameter("texture_opacityMap", value.atlas.texture);
					}
					if (this._component.enabled && this._component.entity.enabled) {
						this._component.addToLayers();
					}
				}
				if (this.time && this.fps) {
					this.time = this.time;
				} else {
					this.frame = this.frame;
				}
			}
		}
	}
	get sprite() {
		return this._sprite;
	}
	set spriteAsset(value) {
		const assets = this._component.system.app.assets;
		let id14 = value;
		if (value instanceof Asset) {
			id14 = value.id;
		}
		if (this._spriteAsset !== id14) {
			if (this._spriteAsset) {
				const prev = assets.get(this._spriteAsset);
				if (prev) {
					this._unbindSpriteAsset(prev);
				}
			}
			this._spriteAsset = id14;
			if (this._spriteAsset) {
				const asset = assets.get(this._spriteAsset);
				if (!asset) {
					this.sprite = null;
					assets.on(`add:${this._spriteAsset}`, this._onSpriteAssetAdded, this);
				} else {
					this._bindSpriteAsset(asset);
				}
			} else {
				this.sprite = null;
			}
		}
	}
	get spriteAsset() {
		return this._spriteAsset;
	}
	set time(value) {
		this._setTime(value);
		if (this._sprite) {
			this.frame = Math.min(this._sprite.frameKeys.length - 1, Math.floor(this._time * Math.abs(this.fps)));
		} else {
			this.frame = 0;
		}
	}
	get time() {
		return this._time;
	}
	// When sprite asset is added bind it
	_onSpriteAssetAdded(asset) {
		this._component.system.app.assets.off(`add:${asset.id}`, this._onSpriteAssetAdded, this);
		if (this._spriteAsset === asset.id) {
			this._bindSpriteAsset(asset);
		}
	}
	// Hook up event handlers on sprite asset
	_bindSpriteAsset(asset) {
		asset.on("load", this._onSpriteAssetLoad, this);
		asset.on("remove", this._onSpriteAssetRemove, this);
		if (asset.resource) {
			this._onSpriteAssetLoad(asset);
		} else {
			this._component.system.app.assets.load(asset);
		}
	}
	_unbindSpriteAsset(asset) {
		if (!asset) {
			return;
		}
		asset.off("load", this._onSpriteAssetLoad, this);
		asset.off("remove", this._onSpriteAssetRemove, this);
		if (asset.resource && !asset.resource.atlas) {
			this._component.system.app.assets.off(`load:${asset.data.textureAtlasAsset}`, this._onTextureAtlasLoad, this);
		}
	}
	// When sprite asset is loaded make sure the texture atlas asset is loaded too
	// If so then set the sprite, otherwise wait for the atlas to be loaded first
	_onSpriteAssetLoad(asset) {
		if (!asset.resource) {
			this.sprite = null;
		} else {
			if (!asset.resource.atlas) {
				const atlasAssetId = asset.data.textureAtlasAsset;
				const assets = this._component.system.app.assets;
				assets.off(`load:${atlasAssetId}`, this._onTextureAtlasLoad, this);
				assets.once(`load:${atlasAssetId}`, this._onTextureAtlasLoad, this);
			} else {
				this.sprite = asset.resource;
			}
		}
	}
	// When atlas is loaded try to reset the sprite asset
	_onTextureAtlasLoad(atlasAsset) {
		const spriteAsset = this._spriteAsset;
		if (spriteAsset instanceof Asset) {
			this._onSpriteAssetLoad(spriteAsset);
		} else {
			this._onSpriteAssetLoad(this._component.system.app.assets.get(spriteAsset));
		}
	}
	_onSpriteAssetRemove(asset) {
		this.sprite = null;
	}
	// If the meshes are re-created make sure
	// we update them in the mesh instance
	_onSpriteMeshesChange() {
		if (this._component.currentClip === this) {
			this._component._showFrame(this.frame);
		}
	}
	// Update frame if ppu changes for 9-sliced sprites
	_onSpritePpuChanged() {
		if (this._component.currentClip === this) {
			if (this.sprite.renderMode !== SPRITE_RENDERMODE_SIMPLE) {
				this._component._showFrame(this.frame);
			}
		}
	}
	_update(dt) {
		if (this.fps === 0) return;
		if (!this._playing || this._paused || !this._sprite) return;
		const dir4 = this.fps < 0 ? -1 : 1;
		const time = this._time + dt * this._component.speed * dir4;
		const duration = this.duration;
		const end = time > duration || time < 0;
		this._setTime(time);
		let frame = this.frame;
		if (this._sprite) {
			frame = Math.floor(this._sprite.frameKeys.length * this._time / duration);
		} else {
			frame = 0;
		}
		if (frame !== this._frame) {
			this._setFrame(frame);
		}
		if (end) {
			if (this.loop) {
				this.fire("loop");
				this._component.fire("loop", this);
			} else {
				this._playing = false;
				this._paused = false;
				this.fire("end");
				this._component.fire("end", this);
			}
		}
	}
	_setTime(value) {
		this._time = value;
		const duration = this.duration;
		if (this._time < 0) {
			if (this.loop) {
				this._time = this._time % duration + duration;
			} else {
				this._time = 0;
			}
		} else if (this._time > duration) {
			if (this.loop) {
				this._time %= duration;
			} else {
				this._time = duration;
			}
		}
	}
	_setFrame(value) {
		if (this._sprite) {
			this._frame = math.clamp(value, 0, this._sprite.frameKeys.length - 1);
		} else {
			this._frame = value;
		}
		if (this._component.currentClip === this) {
			this._component._showFrame(this._frame);
		}
	}
	_destroy() {
		if (this._spriteAsset) {
			const assets = this._component.system.app.assets;
			this._unbindSpriteAsset(assets.get(this._spriteAsset));
		}
		if (this._sprite) {
			this.sprite = null;
		}
		if (this._spriteAsset) {
			this.spriteAsset = null;
		}
	}
	play() {
		if (this._playing) {
			return;
		}
		this._playing = true;
		this._paused = false;
		this.frame = 0;
		this.fire("play");
		this._component.fire("play", this);
	}
	pause() {
		if (!this._playing || this._paused) {
			return;
		}
		this._paused = true;
		this.fire("pause");
		this._component.fire("pause", this);
	}
	resume() {
		if (!this._paused) return;
		this._paused = false;
		this.fire("resume");
		this._component.fire("resume", this);
	}
	stop() {
		if (!this._playing) return;
		this._playing = false;
		this._paused = false;
		this._time = 0;
		this.frame = 0;
		this.fire("stop");
		this._component.fire("stop", this);
	}
};

var PARAM_EMISSIVE_MAP = "texture_emissiveMap";
var PARAM_OPACITY_MAP = "texture_opacityMap";
var PARAM_EMISSIVE = "material_emissive";
var PARAM_OPACITY = "material_opacity";
var PARAM_INNER_OFFSET = "innerOffset";
var PARAM_OUTER_SCALE = "outerScale";
var PARAM_ATLAS_RECT = "atlasRect";
var SpriteComponent = class extends Component {
	static EVENT_PLAY = "play";
	static EVENT_PAUSE = "pause";
	static EVENT_RESUME = "resume";
	static EVENT_STOP = "stop";
	static EVENT_END = "end";
	static EVENT_LOOP = "loop";
	_evtLayersChanged = null;
	_evtLayerAdded = null;
	_evtLayerRemoved = null;
	_type = SPRITETYPE_SIMPLE;
	_material = null;
	_color = new Color(1, 1, 1, 1);
	_colorUniform = new Float32Array(3);
	_speed = 1;
	_flipX = false;
	_flipY = false;
	_width = 1;
	_height = 1;
	_drawOrder = 0;
	_layers = [LAYERID_WORLD];
	// assign to the default world layer
	// 9-slicing
	_outerScale = new Vec2(1, 1);
	_outerScaleUniform = new Float32Array(2);
	_innerOffset = new Vec4();
	_innerOffsetUniform = new Float32Array(4);
	_atlasRect = new Vec4();
	_atlasRectUniform = new Float32Array(4);
	// batch groups
	_batchGroupId = -1;
	// node / mesh instance
	_node = new GraphNode();
	_meshInstance = null;
	_updateAabbFunc = null;
	_inLayers = false;
	// animated sprites
	_autoPlayClip = null;
	_clips = {};
	_defaultClip = null;
	_currentClip = null;
	constructor(system, entity) {
		super(system, entity);
		this._material = system.defaultMaterial;
		entity.addChild(this._node);
		this._updateAabbFunc = this._updateAabb.bind(this);
		this._defaultClip = new SpriteAnimationClip(this, {
			name: this.entity.name,
			fps: 0,
			loop: false,
			spriteAsset: null
		});
		this._currentClip = this._defaultClip;
	}
	set type(value) {
		if (this._type === value) {
			return;
		}
		this._type = value;
		if (this._type === SPRITETYPE_SIMPLE) {
			this.stop();
			this._currentClip = this._defaultClip;
			if (this.enabled && this.entity.enabled) {
				this._currentClip.frame = this.frame;
				if (this._currentClip.sprite) {
					this.addToLayers();
				} else {
					this.removeFromLayers();
				}
			}
		} else if (this._type === SPRITETYPE_ANIMATED) {
			this.stop();
			if (this._autoPlayClip) {
				this._tryAutoPlay();
			}
			if (this._currentClip && this._currentClip.isPlaying && this.enabled && this.entity.enabled) {
				this.addToLayers();
			} else {
				this.removeFromLayers();
			}
		}
	}
	get type() {
		return this._type;
	}
	set frame(value) {
		this._currentClip.frame = value;
	}
	get frame() {
		return this._currentClip.frame;
	}
	set spriteAsset(value) {
		this._defaultClip.spriteAsset = value;
	}
	get spriteAsset() {
		return this._defaultClip._spriteAsset;
	}
	set sprite(value) {
		this._currentClip.sprite = value;
	}
	get sprite() {
		return this._currentClip.sprite;
	}
	// (private) {Material} material The material used to render a sprite.
	set material(value) {
		this._material = value;
		if (this._meshInstance) {
			this._meshInstance.material = value;
		}
	}
	get material() {
		return this._material;
	}
	set color(value) {
		this._color.r = value.r;
		this._color.g = value.g;
		this._color.b = value.b;
		if (this._meshInstance) {
			this._colorUniform[0] = this._color.r;
			this._colorUniform[1] = this._color.g;
			this._colorUniform[2] = this._color.b;
			this._meshInstance.setParameter(PARAM_EMISSIVE, this._colorUniform);
		}
	}
	get color() {
		return this._color;
	}
	set opacity(value) {
		this._color.a = value;
		if (this._meshInstance) {
			this._meshInstance.setParameter(PARAM_OPACITY, value);
		}
	}
	get opacity() {
		return this._color.a;
	}
	set clips(value) {
		if (!value) {
			for (const name in this._clips) {
				this.removeClip(name);
			}
			return;
		}
		for (const name in this._clips) {
			let found = false;
			for (const key in value) {
				if (value[key].name === name) {
					found = true;
					this._clips[name].fps = value[key].fps;
					this._clips[name].loop = value[key].loop;
					if (value[key].hasOwnProperty("sprite")) {
						this._clips[name].sprite = value[key].sprite;
					} else if (value[key].hasOwnProperty("spriteAsset")) {
						this._clips[name].spriteAsset = value[key].spriteAsset;
					}
					break;
				}
			}
			if (!found) {
				this.removeClip(name);
			}
		}
		for (const key in value) {
			if (this._clips[value[key].name]) continue;
			this.addClip(value[key]);
		}
		if (this._autoPlayClip) {
			this._tryAutoPlay();
		}
		if (!this._currentClip || !this._currentClip.sprite) {
			this.removeFromLayers();
		}
	}
	get clips() {
		return this._clips;
	}
	get currentClip() {
		return this._currentClip;
	}
	set speed(value) {
		this._speed = value;
	}
	get speed() {
		return this._speed;
	}
	set flipX(value) {
		if (this._flipX === value) return;
		this._flipX = value;
		this._updateTransform();
	}
	get flipX() {
		return this._flipX;
	}
	set flipY(value) {
		if (this._flipY === value) return;
		this._flipY = value;
		this._updateTransform();
	}
	get flipY() {
		return this._flipY;
	}
	set width(value) {
		if (value === this._width) return;
		this._width = value;
		this._outerScale.x = this._width;
		if (this.sprite && (this.sprite.renderMode === SPRITE_RENDERMODE_TILED || this.sprite.renderMode === SPRITE_RENDERMODE_SLICED)) {
			this._updateTransform();
		}
	}
	get width() {
		return this._width;
	}
	set height(value) {
		if (value === this._height) return;
		this._height = value;
		this._outerScale.y = this.height;
		if (this.sprite && (this.sprite.renderMode === SPRITE_RENDERMODE_TILED || this.sprite.renderMode === SPRITE_RENDERMODE_SLICED)) {
			this._updateTransform();
		}
	}
	get height() {
		return this._height;
	}
	set batchGroupId(value) {
		if (this._batchGroupId === value) {
			return;
		}
		const prev = this._batchGroupId;
		this._batchGroupId = value;
		if (this.entity.enabled && prev >= 0) {
			this.system.app.batcher?.remove(BatchGroup.SPRITE, prev, this.entity);
		}
		if (this.entity.enabled && value >= 0) {
			this.system.app.batcher?.insert(BatchGroup.SPRITE, value, this.entity);
		} else {
			if (prev >= 0) {
				if (this._currentClip && this._currentClip.sprite && this.enabled && this.entity.enabled) {
					this.addToLayers();
				}
			}
		}
	}
	get batchGroupId() {
		return this._batchGroupId;
	}
	set autoPlayClip(value) {
		this._autoPlayClip = value instanceof SpriteAnimationClip ? value.name : value;
		this._tryAutoPlay();
	}
	get autoPlayClip() {
		return this._autoPlayClip;
	}
	set drawOrder(value) {
		this._drawOrder = value;
		if (this._meshInstance) {
			this._meshInstance.drawOrder = value;
		}
	}
	get drawOrder() {
		return this._drawOrder;
	}
	set layers(value) {
		if (this._inLayers) {
			this.removeFromLayers();
		}
		this._layers = value;
		if (!this._meshInstance) {
			return;
		}
		if (this.enabled && this.entity.enabled) {
			this.addToLayers();
		}
	}
	get layers() {
		return this._layers;
	}
	get aabb() {
		if (this._meshInstance) {
			return this._meshInstance.aabb;
		}
		return null;
	}
	onEnable() {
		const app2 = this.system.app;
		const scene = app2.scene;
		const layers = scene.layers;
		this._evtLayersChanged = scene.on("set:layers", this._onLayersChanged, this);
		if (layers) {
			this._evtLayerAdded = layers.on("add", this._onLayerAdded, this);
			this._evtLayerRemoved = layers.on("remove", this._onLayerRemoved, this);
		}
		this.addToLayers();
		if (this._autoPlayClip) {
			this._tryAutoPlay();
		}
		if (this._batchGroupId >= 0) {
			app2.batcher?.insert(BatchGroup.SPRITE, this._batchGroupId, this.entity);
		}
	}
	onDisable() {
		const app2 = this.system.app;
		const scene = app2.scene;
		const layers = scene.layers;
		this._evtLayersChanged?.off();
		this._evtLayersChanged = null;
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = null;
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = null;
		}
		this.stop();
		this.removeFromLayers();
		if (this._batchGroupId >= 0) {
			app2.batcher?.remove(BatchGroup.SPRITE, this._batchGroupId, this.entity);
		}
	}
	onBeforeRemove() {
		this._currentClip = null;
		if (this._defaultClip) {
			this._defaultClip._destroy();
			this._defaultClip = null;
		}
		for (const key in this._clips) {
			this._clips[key]._destroy();
		}
		this._clips = null;
		this.removeFromLayers();
		this._node?.remove();
		this._node = null;
		if (this._meshInstance) {
			this._meshInstance.material = null;
			this._meshInstance.mesh = null;
			this._meshInstance = null;
		}
	}
	addToLayers() {
		if (this._inLayers) return;
		if (!this._meshInstance) return;
		const meshInstances = [this._meshInstance];
		for (let i2 = 0, len = this._layers.length; i2 < len; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(this._layers[i2]);
			if (layer) {
				layer.addMeshInstances(meshInstances);
			}
		}
		this._inLayers = true;
	}
	removeFromLayers() {
		if (!this._inLayers || !this._meshInstance) return;
		const meshInstances = [this._meshInstance];
		for (let i2 = 0, len = this._layers.length; i2 < len; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(this._layers[i2]);
			if (layer) {
				layer.removeMeshInstances(meshInstances);
			}
		}
		this._inLayers = false;
	}
	// Set the desired mesh on the mesh instance
	_showFrame(frame) {
		if (!this.sprite) return;
		const mesh = this.sprite.meshes[frame];
		if (!mesh) {
			if (this._meshInstance) {
				this._meshInstance.mesh = null;
				this._meshInstance.visible = false;
			}
			return;
		}
		let material;
		if (this.sprite.renderMode === SPRITE_RENDERMODE_SLICED) {
			material = this.system.default9SlicedMaterialSlicedMode;
		} else if (this.sprite.renderMode === SPRITE_RENDERMODE_TILED) {
			material = this.system.default9SlicedMaterialTiledMode;
		} else {
			material = this.system.defaultMaterial;
		}
		if (!this._meshInstance) {
			this._meshInstance = new MeshInstance(mesh, this._material, this._node);
			this._meshInstance.castShadow = false;
			this._meshInstance.receiveShadow = false;
			this._meshInstance.drawOrder = this._drawOrder;
			this._colorUniform[0] = this._color.r;
			this._colorUniform[1] = this._color.g;
			this._colorUniform[2] = this._color.b;
			this._meshInstance.setParameter(PARAM_EMISSIVE, this._colorUniform);
			this._meshInstance.setParameter(PARAM_OPACITY, this._color.a);
			if (this.enabled && this.entity.enabled) {
				this.addToLayers();
			}
		}
		if (this._meshInstance.material !== material) {
			this._meshInstance.material = material;
		}
		if (this._meshInstance.mesh !== mesh) {
			this._meshInstance.mesh = mesh;
			this._meshInstance.visible = true;
			this._meshInstance._aabbVer = -1;
		}
		if (this.sprite.atlas && this.sprite.atlas.texture) {
			this._meshInstance.setParameter(PARAM_EMISSIVE_MAP, this.sprite.atlas.texture);
			this._meshInstance.setParameter(PARAM_OPACITY_MAP, this.sprite.atlas.texture);
		} else {
			this._meshInstance.deleteParameter(PARAM_EMISSIVE_MAP);
			this._meshInstance.deleteParameter(PARAM_OPACITY_MAP);
		}
		if (this.sprite.atlas && (this.sprite.renderMode === SPRITE_RENDERMODE_SLICED || this.sprite.renderMode === SPRITE_RENDERMODE_TILED)) {
			this._meshInstance._updateAabbFunc = this._updateAabbFunc;
			const frameData = this.sprite.atlas.frames[this.sprite.frameKeys[frame]];
			if (frameData) {
				const borderWidthScale = 2 / frameData.rect.z;
				const borderHeightScale = 2 / frameData.rect.w;
				this._innerOffset.set(
					frameData.border.x * borderWidthScale,
					frameData.border.y * borderHeightScale,
					frameData.border.z * borderWidthScale,
					frameData.border.w * borderHeightScale
				);
				const tex = this.sprite.atlas.texture;
				this._atlasRect.set(
					frameData.rect.x / tex.width,
					frameData.rect.y / tex.height,
					frameData.rect.z / tex.width,
					frameData.rect.w / tex.height
				);
			} else {
				this._innerOffset.set(0, 0, 0, 0);
			}
			this._innerOffsetUniform[0] = this._innerOffset.x;
			this._innerOffsetUniform[1] = this._innerOffset.y;
			this._innerOffsetUniform[2] = this._innerOffset.z;
			this._innerOffsetUniform[3] = this._innerOffset.w;
			this._meshInstance.setParameter(PARAM_INNER_OFFSET, this._innerOffsetUniform);
			this._atlasRectUniform[0] = this._atlasRect.x;
			this._atlasRectUniform[1] = this._atlasRect.y;
			this._atlasRectUniform[2] = this._atlasRect.z;
			this._atlasRectUniform[3] = this._atlasRect.w;
			this._meshInstance.setParameter(PARAM_ATLAS_RECT, this._atlasRectUniform);
		} else {
			this._meshInstance._updateAabbFunc = null;
		}
		this._updateTransform();
	}
	_updateTransform() {
		let scaleX = this.flipX ? -1 : 1;
		let scaleY = this.flipY ? -1 : 1;
		let posX = 0;
		let posY = 0;
		if (this.sprite && (this.sprite.renderMode === SPRITE_RENDERMODE_SLICED || this.sprite.renderMode === SPRITE_RENDERMODE_TILED)) {
			let w = 1;
			let h2 = 1;
			if (this.sprite.atlas) {
				const frameData = this.sprite.atlas.frames[this.sprite.frameKeys[this.frame]];
				if (frameData) {
					w = frameData.rect.z;
					h2 = frameData.rect.w;
					posX = (0.5 - frameData.pivot.x) * this._width;
					posY = (0.5 - frameData.pivot.y) * this._height;
				}
			}
			const scaleMulX = w / this.sprite.pixelsPerUnit;
			const scaleMulY = h2 / this.sprite.pixelsPerUnit;
			this._outerScale.set(Math.max(this._width, this._innerOffset.x * scaleMulX), Math.max(this._height, this._innerOffset.y * scaleMulY));
			scaleX *= scaleMulX;
			scaleY *= scaleMulY;
			this._outerScale.x /= scaleMulX;
			this._outerScale.y /= scaleMulY;
			scaleX *= math.clamp(this._width / (this._innerOffset.x * scaleMulX), 1e-4, 1);
			scaleY *= math.clamp(this._height / (this._innerOffset.y * scaleMulY), 1e-4, 1);
			if (this._meshInstance) {
				this._outerScaleUniform[0] = this._outerScale.x;
				this._outerScaleUniform[1] = this._outerScale.y;
				this._meshInstance.setParameter(PARAM_OUTER_SCALE, this._outerScaleUniform);
			}
		}
		this._node.setLocalScale(scaleX, scaleY, 1);
		this._node.setLocalPosition(posX, posY, 0);
	}
	// updates AABB while 9-slicing
	_updateAabb(aabb3) {
		aabb3.center.set(0, 0, 0);
		aabb3.halfExtents.set(this._outerScale.x * 0.5, this._outerScale.y * 0.5, 1e-3);
		aabb3.setFromTransformedAabb(aabb3, this._node.getWorldTransform());
		return aabb3;
	}
	_tryAutoPlay() {
		if (!this._autoPlayClip) return;
		if (this.type !== SPRITETYPE_ANIMATED) return;
		const clip = this._clips[this._autoPlayClip];
		if (clip && !clip.isPlaying && (!this._currentClip || !this._currentClip.isPlaying)) {
			if (this.enabled && this.entity.enabled) {
				this.play(clip.name);
			}
		}
	}
	_onLayersChanged(oldComp, newComp) {
		oldComp.off("add", this._onLayerAdded, this);
		oldComp.off("remove", this._onLayerRemoved, this);
		newComp.on("add", this._onLayerAdded, this);
		newComp.on("remove", this._onLayerRemoved, this);
		if (this.enabled && this.entity.enabled) {
			this.addToLayers();
		}
	}
	_onLayerAdded(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		if (this._inLayers && this.enabled && this.entity.enabled && this._meshInstance) {
			layer.addMeshInstances([this._meshInstance]);
		}
	}
	_onLayerRemoved(layer) {
		if (!this._meshInstance) return;
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		layer.removeMeshInstances([this._meshInstance]);
	}
	addClip(data2) {
		const clip = new SpriteAnimationClip(this, {
			name: data2.name,
			fps: data2.fps,
			loop: data2.loop,
			spriteAsset: data2.spriteAsset
		});
		this._clips[data2.name] = clip;
		if (clip.name && clip.name === this._autoPlayClip) {
			this._tryAutoPlay();
		}
		return clip;
	}
	removeClip(name) {
		delete this._clips[name];
	}
	clip(name) {
		return this._clips[name];
	}
	play(name) {
		const clip = this._clips[name];
		const current = this._currentClip;
		if (current && current !== clip) {
			current._playing = false;
		}
		this._currentClip = clip;
		if (this._currentClip) {
			this._currentClip = clip;
			this._currentClip.play();
		} else {
		}
		return clip;
	}
	pause() {
		if (this._currentClip === this._defaultClip) return;
		if (this._currentClip.isPlaying) {
			this._currentClip.pause();
		}
	}
	resume() {
		if (this._currentClip === this._defaultClip) return;
		if (this._currentClip.isPaused) {
			this._currentClip.resume();
		}
	}
	stop() {
		if (this._currentClip === this._defaultClip) return;
		this._currentClip.stop();
	}
};

var SpriteComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "sprite";
		this.ComponentType = SpriteComponent;
		this._defaultTexture = null;
		this._defaultMaterial = null;
		this._default9SlicedMaterialSlicedMode = null;
		this._default9SlicedMaterialTiledMode = null;
		this.app.systems.on("update", this.onUpdate, this);
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	set defaultMaterial(material) {
		this._defaultMaterial = material;
	}
	get defaultMaterial() {
		if (!this._defaultMaterial) {
			const texture = new Texture(this.app.graphicsDevice, {
				width: 1,
				height: 1,
				format: PIXELFORMAT_SRGBA8,
				name: "sprite"
			});
			const pixels = new Uint8Array(texture.lock());
			pixels[0] = pixels[1] = pixels[2] = pixels[3] = 255;
			texture.unlock();
			const material = new StandardMaterial();
			material.diffuse.set(0, 0, 0);
			material.emissive.set(1, 1, 1);
			material.emissiveMap = texture;
			material.opacityMap = texture;
			material.opacityMapChannel = "a";
			material.useLighting = false;
			material.useTonemap = false;
			material.useFog = false;
			material.useSkybox = false;
			material.blendType = BLEND_PREMULTIPLIED;
			material.depthWrite = false;
			material.pixelSnap = false;
			material.cull = CULLFACE_NONE;
			material.update();
			this._defaultTexture = texture;
			this._defaultMaterial = material;
		}
		return this._defaultMaterial;
	}
	set default9SlicedMaterialSlicedMode(material) {
		this._default9SlicedMaterialSlicedMode = material;
	}
	get default9SlicedMaterialSlicedMode() {
		if (!this._default9SlicedMaterialSlicedMode) {
			const material = this.defaultMaterial.clone();
			material.nineSlicedMode = SPRITE_RENDERMODE_SLICED;
			material.update();
			this._default9SlicedMaterialSlicedMode = material;
		}
		return this._default9SlicedMaterialSlicedMode;
	}
	set default9SlicedMaterialTiledMode(material) {
		this._default9SlicedMaterialTiledMode = material;
	}
	get default9SlicedMaterialTiledMode() {
		if (!this._default9SlicedMaterialTiledMode) {
			const material = this.defaultMaterial.clone();
			material.nineSlicedMode = SPRITE_RENDERMODE_TILED;
			material.update();
			this._default9SlicedMaterialTiledMode = material;
		}
		return this._default9SlicedMaterialTiledMode;
	}
	destroy() {
		super.destroy();
		this.app.systems.off("update", this.onUpdate, this);
		if (this._defaultTexture) {
			this._defaultTexture.destroy();
			this._defaultTexture = null;
		}
	}
	initializeComponentData(component, data2, properties) {
		if (data2.enabled !== void 0) {
			component.enabled = data2.enabled;
		}
		component.type = data2.type;
		if (data2.layers && Array.isArray(data2.layers)) {
			component.layers = data2.layers.slice(0);
		}
		if (data2.drawOrder !== void 0) {
			component.drawOrder = data2.drawOrder;
		}
		if (data2.color !== void 0) {
			if (data2.color instanceof Color) {
				component.color.set(data2.color.r, data2.color.g, data2.color.b, data2.opacity ?? 1);
			} else {
				component.color.set(data2.color[0], data2.color[1], data2.color[2], data2.opacity ?? 1);
			}
			component.color = component.color;
		}
		if (data2.opacity !== void 0) {
			component.opacity = data2.opacity;
		}
		if (data2.flipX !== void 0) {
			component.flipX = data2.flipX;
		}
		if (data2.flipY !== void 0) {
			component.flipY = data2.flipY;
		}
		if (data2.width !== void 0) {
			component.width = data2.width;
		}
		if (data2.height !== void 0) {
			component.height = data2.height;
		}
		if (data2.spriteAsset !== void 0) {
			component.spriteAsset = data2.spriteAsset;
		}
		if (data2.sprite) {
			component.sprite = data2.sprite;
		}
		if (data2.frame !== void 0) {
			component.frame = data2.frame;
		}
		if (data2.clips) {
			for (const name in data2.clips) {
				component.addClip(data2.clips[name]);
			}
		}
		if (data2.speed !== void 0) {
			component.speed = data2.speed;
		}
		if (data2.autoPlayClip) {
			component.autoPlayClip = data2.autoPlayClip;
		}
		component.batchGroupId = data2.batchGroupId === void 0 || data2.batchGroupId === null ? -1 : data2.batchGroupId;
		super.initializeComponentData(component, data2, []);
	}
	cloneComponent(entity, clone) {
		const source = entity.sprite;
		return this.addComponent(clone, {
			enabled: source.enabled,
			type: source.type,
			spriteAsset: source.spriteAsset,
			sprite: source.sprite,
			width: source.width,
			height: source.height,
			frame: source.frame,
			color: source.color.clone(),
			opacity: source.opacity,
			flipX: source.flipX,
			flipY: source.flipY,
			speed: source.speed,
			clips: source.clips,
			autoPlayClip: source.autoPlayClip,
			batchGroupId: source.batchGroupId,
			drawOrder: source.drawOrder,
			layers: source.layers.slice(0)
		});
	}
	onUpdate(dt) {
		const components2 = this.store;
		for (const id14 in components2) {
			if (components2.hasOwnProperty(id14)) {
				const { entity } = components2[id14];
				if (entity.sprite.enabled && entity.enabled) {
					const sprite = entity.sprite;
					if (sprite._currentClip) {
						sprite._currentClip._update(dt);
					}
				}
			}
		}
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
};

var ZoneComponent = class extends Component {
	static EVENT_ENABLE = "enable";
	static EVENT_DISABLE = "disable";
	static EVENT_STATE = "state";
	static EVENT_REMOVE = "remove";
	_oldState = true;
	_size = new Vec3();
	constructor(system, entity) {
		super(system, entity);
		this.on("set_enabled", this._onSetEnabled, this);
	}
	set size(data2) {
		if (data2 instanceof Vec3) {
			this._size.copy(data2);
		} else if (data2 instanceof Array && data2.length >= 3) {
			this.size.set(data2[0], data2[1], data2[2]);
		}
	}
	get size() {
		return this._size;
	}
	onEnable() {
		this._checkState();
	}
	onDisable() {
		this._checkState();
	}
	_onSetEnabled(prop, old, value) {
		this._checkState();
	}
	_checkState() {
		const state = this.enabled && this.entity.enabled;
		if (state === this._oldState) {
			return;
		}
		this._oldState = state;
		this.fire("enable");
		this.fire("state", this.enabled);
	}
	onBeforeRemove() {
		this.fire("remove");
	}
};

var ZoneComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "zone";
		this.ComponentType = ZoneComponent;
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	initializeComponentData(component, data2, properties) {
		component.enabled = data2.hasOwnProperty("enabled") ? !!data2.enabled : true;
		if (data2.size) {
			if (data2.size instanceof Vec3) {
				component.size.copy(data2.size);
			} else if (data2.size instanceof Array && data2.size.length >= 3) {
				component.size.set(data2.size[0], data2.size[1], data2.size[2]);
			}
		}
	}
	cloneComponent(entity, clone) {
		const data2 = {
			enabled: entity.zone.enabled,
			size: entity.zone.size
		};
		return this.addComponent(clone, data2);
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
};

var PostEffectEntry = class {
	constructor(effect, inputTarget) {
		this.effect = effect;
		this.inputTarget = inputTarget;
		this.outputTarget = null;
		this.name = effect.constructor.name;
	}
};
var PostEffectQueue = class {
	constructor(app2, camera) {
		this.app = app2;
		this.camera = camera;
		this.destinationRenderTarget = null;
		this.effects = [];
		this.enabled = false;
		this.depthTarget = null;
		camera.on("set:rect", this.onCameraRectChanged, this);
	}
	_allocateColorBuffer(format, name) {
		const rect = this.camera.rect;
		const renderTarget = this.destinationRenderTarget;
		const device = this.app.graphicsDevice;
		const width = Math.floor(rect.z * (renderTarget?.width ?? device.width));
		const height = Math.floor(rect.w * (renderTarget?.height ?? device.height));
		const colorBuffer = Texture.createDataTexture2D(device, name, width, height, format);
		return colorBuffer;
	}
	_createOffscreenTarget(useDepth, hdr) {
		const device = this.app.graphicsDevice;
		const outputRt = this.destinationRenderTarget ?? device.backBuffer;
		const srgb = outputRt.isColorBufferSrgb(0);
		const format = (hdr && device.getRenderableHdrFormat([PIXELFORMAT_RGBA16F, PIXELFORMAT_RGBA32F], true)) ?? (srgb ? PIXELFORMAT_SRGBA8 : PIXELFORMAT_RGBA8);
		const name = `${this.camera.entity.name}-posteffect-${this.effects.length}`;
		const colorBuffer = this._allocateColorBuffer(format, name);
		return new RenderTarget({
			colorBuffer,
			depth: useDepth,
			stencil: useDepth && this.app.graphicsDevice.supportsStencil,
			samples: useDepth ? device.samples : 1
		});
	}
	_resizeOffscreenTarget(rt) {
		const format = rt.colorBuffer.format;
		const name = rt.colorBuffer.name;
		rt.destroyFrameBuffers();
		rt.destroyTextureBuffers();
		rt._colorBuffer = this._allocateColorBuffer(format, name);
		rt._colorBuffers = [rt._colorBuffer];
		rt.evaluateDimensions();
	}
	_destroyOffscreenTarget(rt) {
		rt.destroyTextureBuffers();
		rt.destroy();
	}
	addEffect(effect) {
		const effects = this.effects;
		const isFirstEffect = effects.length === 0;
		const inputTarget = this._createOffscreenTarget(isFirstEffect, effect.hdr);
		const newEntry = new PostEffectEntry(effect, inputTarget);
		effects.push(newEntry);
		this._sourceTarget = newEntry.inputTarget;
		if (effects.length > 1) {
			effects[effects.length - 2].outputTarget = newEntry.inputTarget;
		}
		this._newPostEffect = effect;
		if (effect.needsDepthBuffer) {
			this._requestDepthMap();
		}
		this.enable();
		this._newPostEffect = void 0;
	}
	removeEffect(effect) {
		let index = -1;
		for (let i2 = 0, len = this.effects.length; i2 < len; i2++) {
			if (this.effects[i2].effect === effect) {
				index = i2;
				break;
			}
		}
		if (index >= 0) {
			if (index > 0) {
				this.effects[index - 1].outputTarget = index + 1 < this.effects.length ? this.effects[index + 1].inputTarget : null;
			} else {
				if (this.effects.length > 1) {
					if (!this.effects[1].inputTarget._depth) {
						this._destroyOffscreenTarget(this.effects[1].inputTarget);
						this.effects[1].inputTarget = this._createOffscreenTarget(true, this.effects[1].hdr);
						this._sourceTarget = this.effects[1].inputTarget;
					}
					this.camera.renderTarget = this.effects[1].inputTarget;
				}
			}
			this._destroyOffscreenTarget(this.effects[index].inputTarget);
			this.effects.splice(index, 1);
		}
		if (this.enabled) {
			if (effect.needsDepthBuffer) {
				this._releaseDepthMap();
			}
		}
		if (this.effects.length === 0) {
			this.disable();
		}
	}
	_requestDepthMaps() {
		for (let i2 = 0, len = this.effects.length; i2 < len; i2++) {
			const effect = this.effects[i2].effect;
			if (this._newPostEffect === effect) {
				continue;
			}
			if (effect.needsDepthBuffer) {
				this._requestDepthMap();
			}
		}
	}
	_releaseDepthMaps() {
		for (let i2 = 0, len = this.effects.length; i2 < len; i2++) {
			const effect = this.effects[i2].effect;
			if (effect.needsDepthBuffer) {
				this._releaseDepthMap();
			}
		}
	}
	_requestDepthMap() {
		const depthLayer2 = this.app.scene.layers.getLayerById(LAYERID_DEPTH);
		if (depthLayer2) {
			depthLayer2.incrementCounter();
			this.camera.requestSceneDepthMap(true);
		}
	}
	_releaseDepthMap() {
		const depthLayer2 = this.app.scene.layers.getLayerById(LAYERID_DEPTH);
		if (depthLayer2) {
			depthLayer2.decrementCounter();
			this.camera.requestSceneDepthMap(false);
		}
	}
	destroy() {
		for (let i2 = 0, len = this.effects.length; i2 < len; i2++) {
			this.effects[i2].inputTarget.destroy();
		}
		this.effects.length = 0;
		this.disable();
	}
	enable() {
		if (!this.enabled && this.effects.length) {
			this.enabled = true;
			this._requestDepthMaps();
			this.app.graphicsDevice.on("resizecanvas", this._onCanvasResized, this);
			this.destinationRenderTarget = this.camera.renderTarget;
			this.camera.renderTarget = this.effects[0].inputTarget;
			this.camera.onPostprocessing = () => {
				if (this.enabled) {
					let rect = null;
					const len = this.effects.length;
					if (len) {
						for (let i2 = 0; i2 < len; i2++) {
							const fx = this.effects[i2];
							let destTarget = fx.outputTarget;
							if (i2 === len - 1) {
								rect = this.camera.rect;
								if (this.destinationRenderTarget) {
									destTarget = this.destinationRenderTarget;
								}
							}
							fx.effect.render(fx.inputTarget, destTarget, rect);
						}
					}
				}
			};
		}
	}
	disable() {
		if (this.enabled) {
			this.enabled = false;
			this.app.graphicsDevice.off("resizecanvas", this._onCanvasResized, this);
			this._releaseDepthMaps();
			this._destroyOffscreenTarget(this._sourceTarget);
			this.camera.renderTarget = this.destinationRenderTarget;
			this.camera.onPostprocessing = null;
		}
	}
	_onCanvasResized(width, height) {
		const rect = this.camera.rect;
		const renderTarget = this.destinationRenderTarget;
		width = renderTarget?.width ?? width;
		height = renderTarget?.height ?? height;
		this.camera.camera.aspectRatio = width * rect.z / (height * rect.w);
		this.resizeRenderTargets();
	}
	resizeRenderTargets() {
		const device = this.app.graphicsDevice;
		const renderTarget = this.destinationRenderTarget;
		const width = renderTarget?.width ?? device.width;
		const height = renderTarget?.height ?? device.height;
		const rect = this.camera.rect;
		const desiredWidth = Math.floor(rect.z * width);
		const desiredHeight = Math.floor(rect.w * height);
		const effects = this.effects;
		for (let i2 = 0, len = effects.length; i2 < len; i2++) {
			const fx = effects[i2];
			if (fx.inputTarget.width !== desiredWidth || fx.inputTarget.height !== desiredHeight) {
				this._resizeOffscreenTarget(fx.inputTarget);
			}
		}
	}
	onCameraRectChanged(name, oldValue, newValue) {
		if (this.enabled) {
			this.resizeRenderTargets();
		}
	}
};

var CameraComponent = class extends Component {
	onPostprocessing = null;
	_renderSceneDepthMap = 0;
	_renderSceneColorMap = 0;
	_sceneDepthMapRequested = false;
	_sceneColorMapRequested = false;
	_priority = 0;
	_disablePostEffectsLayer = LAYERID_UI;
	_camera;
	_evtLayersChanged = null;
	_evtLayerAdded = null;
	_evtLayerRemoved = null;
	constructor(system, entity) {
		super(system, entity);
		this._camera = new Camera(system.app.graphicsDevice);
		this._camera.node = entity;
		this._postEffects = new PostEffectQueue(system.app, this);
	}
	setShaderPass(name) {
		const shaderPass = ShaderPass.get(this.system.app.graphicsDevice);
		const shaderPassInfo = name ? shaderPass.allocate(name, {
			isForward: true
		}) : null;
		this._camera.shaderPassInfo = shaderPassInfo;
		return shaderPassInfo.index;
	}
	getShaderPass() {
		return this._camera.shaderPassInfo?.name;
	}
	set framePasses(passes) {
		this._camera.framePasses = passes || [];
		this.dirtyLayerCompositionCameras();
		this.system.app.scene.updateShaders = true;
	}
	get framePasses() {
		return this._camera.framePasses;
	}
	set renderPasses(passes) {
		this.framePasses = passes;
	}
	get renderPasses() {
		return this.framePasses;
	}
	get shaderParams() {
		return this._camera.shaderParams;
	}
	set gammaCorrection(value) {
		this.camera.shaderParams.gammaCorrection = value;
	}
	get gammaCorrection() {
		return this.camera.shaderParams.gammaCorrection;
	}
	set toneMapping(value) {
		this.camera.shaderParams.toneMapping = value;
	}
	get toneMapping() {
		return this.camera.shaderParams.toneMapping;
	}
	set fog(value) {
		this._camera.fogParams = value;
	}
	get fog() {
		return this._camera.fogParams;
	}
	set aperture(value) {
		this._camera.aperture = value;
	}
	get aperture() {
		return this._camera.aperture;
	}
	set aspectRatio(value) {
		this._camera.aspectRatio = value;
	}
	get aspectRatio() {
		return this._camera.aspectRatio;
	}
	set aspectRatioMode(value) {
		this._camera.aspectRatioMode = value;
	}
	get aspectRatioMode() {
		return this._camera.aspectRatioMode;
	}
	set calculateProjection(value) {
		this._camera.calculateProjection = value;
	}
	get calculateProjection() {
		return this._camera.calculateProjection;
	}
	set calculateTransform(value) {
		this._camera.calculateTransform = value;
	}
	get calculateTransform() {
		return this._camera.calculateTransform;
	}
	get camera() {
		return this._camera;
	}
	set clearColor(value) {
		this._camera.clearColor = value;
	}
	get clearColor() {
		return this._camera.clearColor;
	}
	set clearColorBuffer(value) {
		this._camera.clearColorBuffer = value;
		this.dirtyLayerCompositionCameras();
	}
	get clearColorBuffer() {
		return this._camera.clearColorBuffer;
	}
	set clearDepth(value) {
		this._camera.clearDepth = value;
	}
	get clearDepth() {
		return this._camera.clearDepth;
	}
	set clearDepthBuffer(value) {
		this._camera.clearDepthBuffer = value;
		this.dirtyLayerCompositionCameras();
	}
	get clearDepthBuffer() {
		return this._camera.clearDepthBuffer;
	}
	set clearStencilBuffer(value) {
		this._camera.clearStencilBuffer = value;
		this.dirtyLayerCompositionCameras();
	}
	get clearStencilBuffer() {
		return this._camera.clearStencilBuffer;
	}
	set cullFaces(value) {
		this._camera.cullFaces = value;
	}
	get cullFaces() {
		return this._camera.cullFaces;
	}
	set disablePostEffectsLayer(layer) {
		this._disablePostEffectsLayer = layer;
		this.dirtyLayerCompositionCameras();
	}
	get disablePostEffectsLayer() {
		return this._disablePostEffectsLayer;
	}
	set farClip(value) {
		this._camera.farClip = value;
	}
	get farClip() {
		return this._camera.farClip;
	}
	set flipFaces(value) {
		this._camera.flipFaces = value;
	}
	get flipFaces() {
		return this._camera.flipFaces;
	}
	set fov(value) {
		this._camera.fov = value;
	}
	get fov() {
		return this._camera.fov;
	}
	get frustum() {
		return this._camera.frustum;
	}
	set frustumCulling(value) {
		this._camera.frustumCulling = value;
	}
	get frustumCulling() {
		return this._camera.frustumCulling;
	}
	set horizontalFov(value) {
		this._camera.horizontalFov = value;
	}
	get horizontalFov() {
		return this._camera.horizontalFov;
	}
	set layers(newValue) {
		const oldLayers = this._camera.layers;
		const scene = this.system.app.scene;
		oldLayers.forEach((layerId) => {
			const layer = scene.layers.getLayerById(layerId);
			layer?.removeCamera(this);
		});
		this._camera.layers = newValue;
		if (this.enabled && this.entity.enabled) {
			newValue.forEach((layerId) => {
				const layer = scene.layers.getLayerById(layerId);
				layer?.addCamera(this);
			});
		}
		this.fire("set:layers");
	}
	get layers() {
		return this._camera.layers;
	}
	get layersSet() {
		return this._camera.layersSet;
	}
	set jitter(value) {
		this._camera.jitter = value;
	}
	get jitter() {
		return this._camera.jitter;
	}
	set nearClip(value) {
		this._camera.nearClip = value;
	}
	get nearClip() {
		return this._camera.nearClip;
	}
	set orthoHeight(value) {
		this._camera.orthoHeight = value;
	}
	get orthoHeight() {
		return this._camera.orthoHeight;
	}
	get postEffects() {
		return this._postEffects;
	}
	get postEffectsEnabled() {
		return this._postEffects.enabled;
	}
	set priority(newValue) {
		this._priority = newValue;
		this.dirtyLayerCompositionCameras();
	}
	get priority() {
		return this._priority;
	}
	set projection(value) {
		this._camera.projection = value;
	}
	get projection() {
		return this._camera.projection;
	}
	get projectionMatrix() {
		return this._camera.projectionMatrix;
	}
	set rect(value) {
		this._camera.rect = value;
		this.fire("set:rect", this._camera.rect);
	}
	get rect() {
		return this._camera.rect;
	}
	set renderSceneColorMap(value) {
		if (value && !this._sceneColorMapRequested) {
			this.requestSceneColorMap(true);
			this._sceneColorMapRequested = true;
		} else if (!value && this._sceneColorMapRequested) {
			this.requestSceneColorMap(false);
			this._sceneColorMapRequested = false;
		}
	}
	get renderSceneColorMap() {
		return this._renderSceneColorMap > 0;
	}
	set renderSceneDepthMap(value) {
		if (value && !this._sceneDepthMapRequested) {
			this.requestSceneDepthMap(true);
			this._sceneDepthMapRequested = true;
		} else if (!value && this._sceneDepthMapRequested) {
			this.requestSceneDepthMap(false);
			this._sceneDepthMapRequested = false;
		}
	}
	get renderSceneDepthMap() {
		return this._renderSceneDepthMap > 0;
	}
	set renderTarget(value) {
		this._camera.renderTarget = value;
		this.dirtyLayerCompositionCameras();
	}
	get renderTarget() {
		return this._camera.renderTarget;
	}
	set scissorRect(value) {
		this._camera.scissorRect = value;
	}
	get scissorRect() {
		return this._camera.scissorRect;
	}
	set sensitivity(value) {
		this._camera.sensitivity = value;
	}
	get sensitivity() {
		return this._camera.sensitivity;
	}
	set shutter(value) {
		this._camera.shutter = value;
	}
	get shutter() {
		return this._camera.shutter;
	}
	get viewMatrix() {
		return this._camera.viewMatrix;
	}
	_enableDepthLayer(value) {
		const hasDepthLayer = this.layers.find((layerId) => layerId === LAYERID_DEPTH);
		if (hasDepthLayer) {
			const depthLayer2 = this.system.app.scene.layers.getLayerById(LAYERID_DEPTH);
			if (value) {
				depthLayer2?.incrementCounter();
			} else {
				depthLayer2?.decrementCounter();
			}
		} else if (value) {
			return false;
		}
		return true;
	}
	requestSceneColorMap(enabled) {
		this._renderSceneColorMap += enabled ? 1 : -1;
		const ok = this._enableDepthLayer(enabled);
		if (!ok) {
		}
		this.camera._enableRenderPassColorGrab(this.system.app.graphicsDevice, this.renderSceneColorMap);
		this.system.app.scene.layers.markDirty();
	}
	requestSceneDepthMap(enabled) {
		this._renderSceneDepthMap += enabled ? 1 : -1;
		const ok = this._enableDepthLayer(enabled);
		if (!ok) {
		}
		this.camera._enableRenderPassDepthGrab(this.system.app.graphicsDevice, this.system.app.renderer, this.renderSceneDepthMap);
		this.system.app.scene.layers.markDirty();
	}
	dirtyLayerCompositionCameras() {
		const layerComp = this.system.app.scene.layers;
		layerComp._dirty = true;
	}
	screenToWorld(screenx, screeny, cameraz, worldCoord) {
		const device = this.system.app.graphicsDevice;
		const { width, height } = device.clientRect;
		return this._camera.screenToWorld(screenx, screeny, cameraz, width, height, worldCoord);
	}
	worldToScreen(worldCoord, screenCoord) {
		const device = this.system.app.graphicsDevice;
		const { width, height } = device.clientRect;
		return this._camera.worldToScreen(worldCoord, width, height, screenCoord);
	}
	onAppPrerender() {
		this._camera._viewMatDirty = true;
		this._camera._viewProjMatDirty = true;
	}
	addCameraToLayers() {
		const layers = this.layers;
		for (let i2 = 0; i2 < layers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(layers[i2]);
			if (layer) {
				layer.addCamera(this);
			}
		}
	}
	removeCameraFromLayers() {
		const layers = this.layers;
		for (let i2 = 0; i2 < layers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(layers[i2]);
			if (layer) {
				layer.removeCamera(this);
			}
		}
	}
	onLayersChanged(oldComp, newComp) {
		this.addCameraToLayers();
		oldComp.off("add", this.onLayerAdded, this);
		oldComp.off("remove", this.onLayerRemoved, this);
		newComp.on("add", this.onLayerAdded, this);
		newComp.on("remove", this.onLayerRemoved, this);
	}
	onLayerAdded(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		layer.addCamera(this);
	}
	onLayerRemoved(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		layer.removeCamera(this);
	}
	onEnable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		this.system.addCamera(this);
		this._evtLayersChanged?.off();
		this._evtLayersChanged = scene.on("set:layers", this.onLayersChanged, this);
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = layers.on("add", this.onLayerAdded, this);
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = layers.on("remove", this.onLayerRemoved, this);
		}
		if (this.enabled && this.entity.enabled) {
			this.addCameraToLayers();
		}
		this.postEffects.enable();
	}
	onDisable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		this.postEffects.disable();
		this.removeCameraFromLayers();
		this._evtLayersChanged?.off();
		this._evtLayersChanged = null;
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = null;
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = null;
		}
		this.system.removeCamera(this);
	}
	onBeforeRemove() {
		this.onDisable();
		this.off();
		this.camera.destroy();
	}
	calculateAspectRatio(rt) {
		return this._camera.calculateAspectRatio(rt);
	}
	startXr(type, spaceType, options2) {
		this.system.app.xr.start(this, type, spaceType, options2);
	}
	endXr(callback) {
		const xr = this.system.app.xr;
		if (xr?.camera !== this.entity) {
			if (callback) callback(new Error("Camera is not in XR"));
			return;
		}
		xr.end(callback);
	}
	copy(source) {
		this.aperture = source.aperture;
		this.aspectRatio = source.aspectRatio;
		this.aspectRatioMode = source.aspectRatioMode;
		this.calculateProjection = source.calculateProjection;
		this.calculateTransform = source.calculateTransform;
		this.clearColor = source.clearColor;
		this.clearColorBuffer = source.clearColorBuffer;
		this.clearDepthBuffer = source.clearDepthBuffer;
		this.clearStencilBuffer = source.clearStencilBuffer;
		this.cullFaces = source.cullFaces;
		this.disablePostEffectsLayer = source.disablePostEffectsLayer;
		this.farClip = source.farClip;
		this.flipFaces = source.flipFaces;
		this.fov = source.fov;
		this.frustumCulling = source.frustumCulling;
		this.horizontalFov = source.horizontalFov;
		this.layers = source.layers;
		this.nearClip = source.nearClip;
		this.orthoHeight = source.orthoHeight;
		this.priority = source.priority;
		this.projection = source.projection;
		this.rect = source.rect;
		this.renderTarget = source.renderTarget;
		this.scissorRect = source.scissorRect;
		this.sensitivity = source.sensitivity;
		this.shutter = source.shutter;
	}
};

var _properties12 = [
	"aspectRatio",
	"aspectRatioMode",
	"calculateProjection",
	"calculateTransform",
	"clearColor",
	"clearColorBuffer",
	"clearDepth",
	"clearDepthBuffer",
	"clearStencilBuffer",
	"renderSceneColorMap",
	"renderSceneDepthMap",
	"cullFaces",
	"farClip",
	"flipFaces",
	"fog",
	"fov",
	"frustumCulling",
	"horizontalFov",
	"layers",
	"renderTarget",
	"nearClip",
	"orthoHeight",
	"projection",
	"priority",
	"rect",
	"scissorRect",
	"aperture",
	"shutter",
	"sensitivity",
	"gammaCorrection",
	"toneMapping"
];
var CameraComponentSystem = class extends ComponentSystem {
	cameras = [];
	constructor(app2) {
		super(app2);
		this.id = "camera";
		this.ComponentType = CameraComponent;
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.on("prerender", this.onAppPrerender, this);
	}
	initializeComponentData(component, data2) {
		for (let i2 = 0; i2 < _properties12.length; i2++) {
			const property = _properties12[i2];
			if (data2.hasOwnProperty(property)) {
				const value = data2[property];
				switch (property) {
					case "rect":
					case "scissorRect":
						if (Array.isArray(value)) {
							component[property] = new Vec4(value[0], value[1], value[2], value[3]);
						} else {
							component[property] = value;
						}
						break;
					case "clearColor":
						if (Array.isArray(value)) {
							component[property] = new Color(value[0], value[1], value[2], value[3]);
						} else {
							component[property] = value;
						}
						break;
					default:
						component[property] = value;
						break;
				}
			}
		}
		super.initializeComponentData(component, data2);
	}
	cloneComponent(entity, clone) {
		const c2 = entity.camera;
		const data2 = {
			enabled: c2.enabled
		};
		for (let i2 = 0; i2 < _properties12.length; i2++) {
			const property = _properties12[i2];
			data2[property] = c2[property];
		}
		return this.addComponent(clone, data2);
	}
	onBeforeRemove(entity, component) {
		this.removeCamera(component);
		component.onBeforeRemove();
	}
	onAppPrerender() {
		for (let i2 = 0, len = this.cameras.length; i2 < len; i2++) {
			this.cameras[i2].onAppPrerender();
		}
	}
	addCamera(camera) {
		this.cameras.push(camera);
		sortPriority(this.cameras);
	}
	removeCamera(camera) {
		const index = this.cameras.indexOf(camera);
		if (index >= 0) {
			this.cameras.splice(index, 1);
			sortPriority(this.cameras);
		}
	}
	destroy() {
		this.app.off("prerender", this.onAppPrerender, this);
		super.destroy();
	}
};

var _properties13 = [
	"type",
	"color",
	"intensity",
	"luminance",
	"shape",
	"affectSpecularity",
	"castShadows",
	"shadowDistance",
	"shadowIntensity",
	"shadowResolution",
	"shadowBias",
	"numCascades",
	"cascadeBlend",
	"bakeNumSamples",
	"bakeArea",
	"cascadeDistribution",
	"normalOffsetBias",
	"range",
	"innerConeAngle",
	"outerConeAngle",
	"falloffMode",
	"shadowType",
	"vsmBlurSize",
	"vsmBlurMode",
	"vsmBias",
	"cookieAsset",
	"cookie",
	"cookieIntensity",
	"cookieFalloff",
	"cookieChannel",
	"cookieAngle",
	"cookieScale",
	"cookieOffset",
	"shadowUpdateMode",
	"mask",
	"affectDynamic",
	"affectLightmapped",
	"bake",
	"bakeDir",
	"isStatic",
	"layers",
	"penumbraSize",
	"penumbraFalloff",
	"shadowSamples",
	"shadowBlockerSamples"
];
var LightComponent = class extends Component {
	_light;
	_evtLayersChanged = null;
	_evtLayerAdded = null;
	_evtLayerRemoved = null;
	_cookieAsset = null;
	_cookieAssetId = null;
	_cookieAssetAdd = false;
	_cookieMatrix = null;
	_shadowBias = 0.05;
	_cookieAngle = 0;
	_cookieScale = null;
	_castShadows = false;
	_affectSpecularity = true;
	_affectDynamic = true;
	_affectLightmapped = false;
	_bake = false;
	_layers = [LAYERID_WORLD];
	_type = "directional";
	constructor(system, entity) {
		super(system, entity);
		this._light = new Light(system.app.graphicsDevice, system.app.scene.clusteredLightingEnabled);
		this._light._node = entity;
		this._light.setColor(1, 1, 1);
	}
	get light() {
		return this._light;
	}
	set type(value) {
		if (this._type === value) return;
		this.removeLightFromLayers();
		this._type = value;
		this._light.type = lightTypes[value];
		this.refreshProperties();
	}
	get type() {
		return this._type;
	}
	set color(value) {
		this._light.setColor(value);
	}
	get color() {
		return this._light.getColor();
	}
	set intensity(value) {
		this._light.intensity = value;
	}
	get intensity() {
		return this._light.intensity;
	}
	set luminance(value) {
		this._light.luminance = value;
	}
	get luminance() {
		return this._light.luminance;
	}
	set shape(value) {
		this._light.shape = value;
	}
	get shape() {
		return this._light.shape;
	}
	set affectSpecularity(value) {
		this._affectSpecularity = value;
		this._light.affectSpecularity = value;
	}
	get affectSpecularity() {
		return this._affectSpecularity;
	}
	set castShadows(value) {
		this._castShadows = value;
		this._light.castShadows = value;
	}
	get castShadows() {
		return this._castShadows;
	}
	set shadowDistance(value) {
		this._light.shadowDistance = value;
	}
	get shadowDistance() {
		return this._light.shadowDistance;
	}
	set shadowIntensity(value) {
		this._light.shadowIntensity = value;
	}
	get shadowIntensity() {
		return this._light.shadowIntensity;
	}
	set shadowResolution(value) {
		this._light.shadowResolution = value;
	}
	get shadowResolution() {
		return this._light.shadowResolution;
	}
	set shadowBias(value) {
		this._shadowBias = value;
		this._light.shadowBias = -0.01 * math.clamp(value, 0, 1);
	}
	get shadowBias() {
		return this._shadowBias;
	}
	set numCascades(value) {
		this._light.numCascades = math.clamp(Math.floor(value), 1, 4);
	}
	get numCascades() {
		return this._light.numCascades;
	}
	set cascadeBlend(value) {
		this._light.cascadeBlend = math.clamp(value, 0, 1);
	}
	get cascadeBlend() {
		return this._light.cascadeBlend;
	}
	set bakeNumSamples(value) {
		this._light.bakeNumSamples = math.clamp(Math.floor(value), 1, 255);
	}
	get bakeNumSamples() {
		return this._light.bakeNumSamples;
	}
	set bakeArea(value) {
		this._light.bakeArea = math.clamp(value, 0, 180);
	}
	get bakeArea() {
		return this._light.bakeArea;
	}
	set cascadeDistribution(value) {
		this._light.cascadeDistribution = math.clamp(value, 0, 1);
	}
	get cascadeDistribution() {
		return this._light.cascadeDistribution;
	}
	set normalOffsetBias(value) {
		this._light.normalOffsetBias = math.clamp(value, 0, 1);
	}
	get normalOffsetBias() {
		return this._light.normalOffsetBias;
	}
	set range(value) {
		this._light.attenuationEnd = value;
	}
	get range() {
		return this._light.attenuationEnd;
	}
	set innerConeAngle(value) {
		this._light.innerConeAngle = value;
	}
	get innerConeAngle() {
		return this._light.innerConeAngle;
	}
	set outerConeAngle(value) {
		this._light.outerConeAngle = value;
	}
	get outerConeAngle() {
		return this._light.outerConeAngle;
	}
	set falloffMode(value) {
		this._light.falloffMode = value;
	}
	get falloffMode() {
		return this._light.falloffMode;
	}
	set shadowType(value) {
		this._light.shadowType = value;
	}
	get shadowType() {
		return this._light.shadowType;
	}
	set vsmBlurSize(value) {
		this._light.vsmBlurSize = value;
	}
	get vsmBlurSize() {
		return this._light.vsmBlurSize;
	}
	set vsmBlurMode(value) {
		this._light.vsmBlurMode = value;
	}
	get vsmBlurMode() {
		return this._light.vsmBlurMode;
	}
	set vsmBias(value) {
		this._light.vsmBias = math.clamp(value, 0, 1);
	}
	get vsmBias() {
		return this._light.vsmBias;
	}
	set cookieAsset(value) {
		if (this._cookieAssetId && (value instanceof Asset && value.id === this._cookieAssetId || value === this._cookieAssetId)) {
			return;
		}
		this.onCookieAssetRemove();
		this._cookieAssetId = null;
		if (value instanceof Asset) {
			this._cookieAssetId = value.id;
			this.onCookieAssetAdd(value);
		} else if (typeof value === "number") {
			this._cookieAssetId = value;
			const asset = this.system.app.assets.get(value);
			if (asset) {
				this.onCookieAssetAdd(asset);
			} else {
				this._cookieAssetAdd = true;
				this.system.app.assets.on(`add:${this._cookieAssetId}`, this.onCookieAssetAdd, this);
			}
		}
	}
	get cookieAsset() {
		return this._cookieAssetId;
	}
	set cookie(value) {
		this._light.cookie = value;
	}
	get cookie() {
		return this._light.cookie;
	}
	set cookieIntensity(value) {
		this._light.cookieIntensity = math.clamp(value, 0, 1);
	}
	get cookieIntensity() {
		return this._light.cookieIntensity;
	}
	set cookieFalloff(value) {
		this._light.cookieFalloff = value;
	}
	get cookieFalloff() {
		return this._light.cookieFalloff;
	}
	set cookieChannel(value) {
		this._light.cookieChannel = value;
	}
	get cookieChannel() {
		return this._light.cookieChannel;
	}
	set cookieAngle(value) {
		if (this._cookieAngle === value) return;
		this._cookieAngle = value;
		if (value !== 0 || this._cookieScale !== null) {
			if (!this._cookieMatrix) this._cookieMatrix = new Vec4();
			let scx = 1;
			let scy = 1;
			if (this._cookieScale) {
				scx = this._cookieScale.x;
				scy = this._cookieScale.y;
			}
			const c2 = Math.cos(value * math.DEG_TO_RAD);
			const s2 = Math.sin(value * math.DEG_TO_RAD);
			this._cookieMatrix.set(c2 / scx, -s2 / scx, s2 / scy, c2 / scy);
			this._light.cookieTransform = this._cookieMatrix;
		} else {
			this._light.cookieTransform = null;
		}
	}
	get cookieAngle() {
		return this._cookieAngle;
	}
	set cookieScale(value) {
		this._cookieScale = value;
		if (value !== null || this._cookieAngle !== 0) {
			if (!this._cookieMatrix) this._cookieMatrix = new Vec4();
			const scx = value ? value.x : 1;
			const scy = value ? value.y : 1;
			const c2 = Math.cos(this._cookieAngle * math.DEG_TO_RAD);
			const s2 = Math.sin(this._cookieAngle * math.DEG_TO_RAD);
			this._cookieMatrix.set(c2 / scx, -s2 / scx, s2 / scy, c2 / scy);
			this._light.cookieTransform = this._cookieMatrix;
		} else {
			this._light.cookieTransform = null;
		}
	}
	get cookieScale() {
		return this._cookieScale;
	}
	set cookieOffset(value) {
		this._light.cookieOffset = value;
	}
	get cookieOffset() {
		return this._light.cookieOffset;
	}
	set shadowUpdateMode(value) {
		this._light.shadowUpdateMode = value;
	}
	get shadowUpdateMode() {
		return this._light.shadowUpdateMode;
	}
	set mask(value) {
		this._light.mask = value;
	}
	get mask() {
		return this._light.mask;
	}
	set affectDynamic(value) {
		if (this._affectDynamic === value) return;
		this._affectDynamic = value;
		if (value) {
			this._light.mask |= MASK_AFFECT_DYNAMIC;
		} else {
			this._light.mask &= ~MASK_AFFECT_DYNAMIC;
		}
		this._light.layersDirty();
	}
	get affectDynamic() {
		return this._affectDynamic;
	}
	set affectLightmapped(value) {
		if (this._affectLightmapped === value) return;
		this._affectLightmapped = value;
		if (value) {
			this._light.mask |= MASK_AFFECT_LIGHTMAPPED;
			if (this._bake) this._light.mask &= ~MASK_BAKE;
		} else {
			this._light.mask &= ~MASK_AFFECT_LIGHTMAPPED;
			if (this._bake) this._light.mask |= MASK_BAKE;
		}
	}
	get affectLightmapped() {
		return this._affectLightmapped;
	}
	set bake(value) {
		if (this._bake === value) return;
		this._bake = value;
		if (value) {
			this._light.mask |= MASK_BAKE;
			if (this._affectLightmapped) this._light.mask &= ~MASK_AFFECT_LIGHTMAPPED;
		} else {
			this._light.mask &= ~MASK_BAKE;
			if (this._affectLightmapped) this._light.mask |= MASK_AFFECT_LIGHTMAPPED;
		}
		this._light.layersDirty();
	}
	get bake() {
		return this._bake;
	}
	set bakeDir(value) {
		this._light.bakeDir = value;
	}
	get bakeDir() {
		return this._light.bakeDir;
	}
	set isStatic(value) {
		this._light.isStatic = value;
	}
	get isStatic() {
		return this._light.isStatic;
	}
	set layers(value) {
		const oldValue = this._layers;
		for (let i2 = 0; i2 < oldValue.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(oldValue[i2]);
			if (!layer) continue;
			layer.removeLight(this);
			this._light.removeLayer(layer);
		}
		this._layers = value;
		for (let i2 = 0; i2 < value.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(value[i2]);
			if (!layer) continue;
			if (this.enabled && this.entity.enabled) {
				layer.addLight(this);
				this._light.addLayer(layer);
			}
		}
	}
	get layers() {
		return this._layers;
	}
	set shadowUpdateOverrides(values) {
		this._light.shadowUpdateOverrides = values;
	}
	get shadowUpdateOverrides() {
		return this._light.shadowUpdateOverrides;
	}
	set shadowSamples(value) {
		this._light.shadowSamples = value;
	}
	get shadowSamples() {
		return this._light.shadowSamples;
	}
	set shadowBlockerSamples(value) {
		this._light.shadowBlockerSamples = value;
	}
	get shadowBlockerSamples() {
		return this._light.shadowBlockerSamples;
	}
	set penumbraSize(value) {
		this._light.penumbraSize = value;
	}
	get penumbraSize() {
		return this._light.penumbraSize;
	}
	set penumbraFalloff(value) {
		this._light.penumbraFalloff = value;
	}
	get penumbraFalloff() {
		return this._light.penumbraFalloff;
	}
	addLightToLayers() {
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(this._layers[i2]);
			if (layer) {
				layer.addLight(this);
				this._light.addLayer(layer);
			}
		}
	}
	removeLightFromLayers() {
		for (let i2 = 0; i2 < this._layers.length; i2++) {
			const layer = this.system.app.scene.layers.getLayerById(this._layers[i2]);
			if (layer) {
				layer.removeLight(this);
				this._light.removeLayer(layer);
			}
		}
	}
	onLayersChanged(oldComp, newComp) {
		if (this.enabled && this.entity.enabled) {
			this.addLightToLayers();
		}
		oldComp.off("add", this.onLayerAdded, this);
		oldComp.off("remove", this.onLayerRemoved, this);
		newComp.on("add", this.onLayerAdded, this);
		newComp.on("remove", this.onLayerRemoved, this);
	}
	onLayerAdded(layer) {
		const index = this._layers.indexOf(layer.id);
		if (index >= 0 && this.enabled && this.entity.enabled) {
			layer.addLight(this);
			this._light.addLayer(layer);
		}
	}
	onLayerRemoved(layer) {
		const index = this._layers.indexOf(layer.id);
		if (index >= 0) {
			layer.removeLight(this);
			this._light.removeLayer(layer);
		}
	}
	refreshProperties() {
		for (let i2 = 0; i2 < _properties13.length; i2++) {
			const name = _properties13[i2];
			this[name] = this[name];
		}
		if (this.enabled && this.entity.enabled) {
			this.onEnable();
		}
	}
	onCookieAssetSet() {
		let forceLoad = false;
		if (this._cookieAsset.type === "cubemap" && !this._cookieAsset.loadFaces) {
			this._cookieAsset.loadFaces = true;
			forceLoad = true;
		}
		if (!this._cookieAsset.resource || forceLoad) this.system.app.assets.load(this._cookieAsset);
		if (this._cookieAsset.resource) {
			this.onCookieAssetLoad();
		}
	}
	onCookieAssetAdd(asset) {
		if (this._cookieAssetId !== asset.id) return;
		this._cookieAsset = asset;
		if (this._light.enabled) {
			this.onCookieAssetSet();
		}
		this._cookieAsset.on("load", this.onCookieAssetLoad, this);
		this._cookieAsset.on("remove", this.onCookieAssetRemove, this);
	}
	onCookieAssetLoad() {
		if (!this._cookieAsset || !this._cookieAsset.resource) {
			return;
		}
		this.cookie = this._cookieAsset.resource;
	}
	onCookieAssetRemove() {
		if (!this._cookieAssetId) {
			return;
		}
		if (this._cookieAssetAdd) {
			this.system.app.assets.off(`add:${this._cookieAssetId}`, this.onCookieAssetAdd, this);
			this._cookieAssetAdd = false;
		}
		if (this._cookieAsset) {
			this._cookieAsset.off("load", this.onCookieAssetLoad, this);
			this._cookieAsset.off("remove", this.onCookieAssetRemove, this);
			this._cookieAsset = null;
		}
		this.cookie = null;
	}
	onEnable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		this._light.enabled = true;
		this._evtLayersChanged?.off();
		this._evtLayersChanged = scene.on("set:layers", this.onLayersChanged, this);
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = layers.on("add", this.onLayerAdded, this);
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = layers.on("remove", this.onLayerRemoved, this);
		}
		if (this.enabled && this.entity.enabled) {
			this.addLightToLayers();
		}
		if (this._cookieAsset && !this.cookie) {
			this.onCookieAssetSet();
		}
	}
	onDisable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		this._light.enabled = false;
		this._evtLayersChanged?.off();
		this._evtLayersChanged = null;
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = null;
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = null;
		}
		this.removeLightFromLayers();
	}
	onBeforeRemove() {
		this.onDisable();
		this._light.destroy();
		this.cookieAsset = null;
	}
};

var LightComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "light";
		this.ComponentType = LightComponent;
		this.extraDataProperties = ["enable"];
		this.on("beforeremove", this.onBeforeRemove, this);
	}
	initializeComponentData(component, _data) {
		const data2 = { ..._data };
		if (data2.layers && Array.isArray(data2.layers)) {
			data2.layers = data2.layers.slice(0);
		}
		if (data2.color && Array.isArray(data2.color)) {
			data2.color = new Color(data2.color[0], data2.color[1], data2.color[2]);
		}
		if (data2.cookieOffset && data2.cookieOffset instanceof Array) {
			data2.cookieOffset = new Vec2(data2.cookieOffset[0], data2.cookieOffset[1]);
		}
		if (data2.cookieScale && data2.cookieScale instanceof Array) {
			data2.cookieScale = new Vec2(data2.cookieScale[0], data2.cookieScale[1]);
		}
		if (data2.hasOwnProperty("enable")) {
			console.warn("WARNING: enable: Property is deprecated. Set enabled property instead.");
			data2.enabled = data2.enable;
		}
		for (let i2 = 0; i2 < _properties13.length; i2++) {
			const property = _properties13[i2];
			if (data2.hasOwnProperty(property)) {
				component[property] = data2[property];
			}
		}
		super.initializeComponentData(component, data2);
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	cloneComponent(entity, clone) {
		const c2 = entity.light;
		const data2 = {
			enabled: c2.enabled
		};
		for (let i2 = 0; i2 < _properties13.length; i2++) {
			const name = _properties13[i2];
			const value = c2[name];
			if (value && value.clone) {
				data2[name] = value.clone();
			} else {
				data2[name] = value;
			}
		}
		return this.addComponent(clone, data2);
	}
};

var components = ["x", "y", "z", "w"];
var vecLookup = [void 0, void 0, Vec2, Vec3, Vec4];
function rawToValue(app2, args, value, old) {
	switch (args.type) {
		case "boolean":
			return !!value;
		case "number":
			if (typeof value === "number") {
				return value;
			} else if (typeof value === "string") {
				const v6 = parseInt(value, 10);
				if (isNaN(v6)) return null;
				return v6;
			} else if (typeof value === "boolean") {
				return 0 + value;
			}
			return null;
		case "json": {
			const result = {};
			if (Array.isArray(args.schema)) {
				if (!value || typeof value !== "object") {
					value = {};
				}
				for (let i2 = 0; i2 < args.schema.length; i2++) {
					const field = args.schema[i2];
					if (!field.name) continue;
					if (field.array) {
						result[field.name] = [];
						const arr = Array.isArray(value[field.name]) ? value[field.name] : [];
						for (let j = 0; j < arr.length; j++) {
							result[field.name].push(rawToValue(app2, field, arr[j]));
						}
					} else {
						const val = value.hasOwnProperty(field.name) ? value[field.name] : field.default;
						result[field.name] = rawToValue(app2, field, val);
					}
				}
			}
			return result;
		}
		case "asset":
			if (value instanceof Asset) {
				return value;
			} else if (typeof value === "number") {
				return app2.assets.get(value) || null;
			} else if (typeof value === "string") {
				return app2.assets.get(parseInt(value, 10)) || null;
			}
			return null;
		case "entity":
			if (value instanceof GraphNode) {
				return value;
			} else if (typeof value === "string") {
				return app2.getEntityFromIndex(value);
			}
			return null;
		case "rgb":
		case "rgba":
			if (value instanceof Color) {
				if (old instanceof Color) {
					old.copy(value);
					return old;
				}
				return value.clone();
			} else if (value instanceof Array && value.length >= 3 && value.length <= 4) {
				for (let i2 = 0; i2 < value.length; i2++) {
					if (typeof value[i2] !== "number") {
						return null;
					}
				}
				if (!old) old = new Color();
				old.r = value[0];
				old.g = value[1];
				old.b = value[2];
				old.a = value.length === 3 ? 1 : value[3];
				return old;
			} else if (typeof value === "string" && /#(?:[0-9a-f]{2}){3,4}/i.test(value)) {
				if (!old) {
					old = new Color();
				}
				old.fromString(value);
				return old;
			}
			return null;
		case "vec2":
		case "vec3":
		case "vec4": {
			const len = parseInt(args.type.slice(3), 10);
			const vecType = vecLookup[len];
			if (value instanceof vecType) {
				if (old instanceof vecType) {
					old.copy(value);
					return old;
				}
				return value.clone();
			} else if (value instanceof Array && value.length === len) {
				for (let i2 = 0; i2 < value.length; i2++) {
					if (typeof value[i2] !== "number") {
						return null;
					}
				}
				if (!old) old = new vecType();
				for (let i2 = 0; i2 < len; i2++) {
					old[components[i2]] = value[i2];
				}
				return old;
			}
			return null;
		}
		case "curve":
			if (value) {
				let curve;
				if (value instanceof Curve || value instanceof CurveSet) {
					curve = value.clone();
				} else {
					const CurveType = value.keys[0] instanceof Array ? CurveSet : Curve;
					curve = new CurveType(value.keys);
					curve.type = value.type;
				}
				return curve;
			}
			break;
	}
	return value;
}
function attributeToValue(app2, schema, value, current) {
	if (schema.array) {
		return value.map((item, index) => rawToValue(app2, schema, item, current ? current[index] : null));
	}
	return rawToValue(app2, schema, value, current);
}
function assignAttributesToScript(app2, attributeSchemaMap, data2, script2) {
	if (!data2) return;
	for (const attributeName in attributeSchemaMap) {
		const attributeSchema = attributeSchemaMap[attributeName];
		const dataToAssign = data2[attributeName];
		if (dataToAssign === void 0) continue;
		script2[attributeName] = attributeToValue(app2, attributeSchema, dataToAssign, script2[attributeName]);
	}
}
var ScriptAttributes = class _ScriptAttributes {
	static assignAttributesToScript = assignAttributesToScript;
	static attributeToValue = attributeToValue;
	constructor(scriptType) {
		this.scriptType = scriptType;
		this.index = {};
	}
	static reservedNames = /* @__PURE__ */ new Set([
		"app",
		"entity",
		"enabled",
		"_enabled",
		"_enabledOld",
		"_destroyed",
		"__attributes",
		"__attributesRaw",
		"__scriptType",
		"__executionOrder",
		"_callbacks",
		"_callbackActive",
		"has",
		"get",
		"on",
		"off",
		"fire",
		"once",
		"hasEvent"
	]);
	add(name, args) {
		if (!args) {
			return;
		}
		if (!args.type) {
			return;
		}
		if (this.index[name]) {
			return;
		} else if (_ScriptAttributes.reservedNames.has(name)) {
			return;
		}
		this.index[name] = args;
		Object.defineProperty(this.scriptType.prototype, name, {
			get: function() {
				return this.__attributes[name];
			},
			set: function(raw) {
				const evt = "attr";
				const evtName = `attr:${name}`;
				const old = this.__attributes[name];
				let oldCopy = old;
				if (old && args.type !== "json" && args.type !== "entity" && old.clone) {
					if (this.hasEvent(evt) || this.hasEvent(evtName)) {
						oldCopy = old.clone();
					}
				}
				if (args.array) {
					this.__attributes[name] = [];
					if (raw) {
						for (let i2 = 0, len = raw.length; i2 < len; i2++) {
							this.__attributes[name].push(rawToValue(this.app, args, raw[i2], old ? old[i2] : null));
						}
					}
				} else {
					this.__attributes[name] = rawToValue(this.app, args, raw, old);
				}
				this.fire(evt, name, this.__attributes[name], oldCopy);
				this.fire(evtName, this.__attributes[name], oldCopy);
			}
		});
	}
	remove(name) {
		if (!this.index[name]) {
			return false;
		}
		delete this.index[name];
		delete this.scriptType.prototype[name];
		return true;
	}
	has(name) {
		return !!this.index[name];
	}
	get(name) {
		return this.index[name] || null;
	}
};

var ScriptType = class extends Script {
	__attributes;
	__attributesRaw;
	constructor(args) {
		super(args);
		this.initScriptType(args);
	}
	static get attributes() {
		if (!this.hasOwnProperty("__attributes")) this.__attributes = new ScriptAttributes(this);
		return this.__attributes;
	}
	initScript(args) {
		Script.prototype.initScript.call(this, args);
		this.__attributes = {};
		this.__attributesRaw = args.attributes || {};
	}
	initScriptType(args) {
		this.initScript(args);
	}
	__initializeAttributes(force) {
		if (!force && !this.__attributesRaw) {
			return;
		}
		for (const key in this.__scriptType.attributes.index) {
			if (this.__attributesRaw && this.__attributesRaw.hasOwnProperty(key)) {
				this[key] = this.__attributesRaw[key];
			} else if (!this.__attributes.hasOwnProperty(key)) {
				if (this.__scriptType.attributes.index[key].hasOwnProperty("default")) {
					this[key] = this.__scriptType.attributes.index[key].default;
				} else {
					this[key] = null;
				}
			}
		}
		this.__attributesRaw = null;
	}
	static extend(methods) {
		for (const key in methods) {
			if (!methods.hasOwnProperty(key)) {
				continue;
			}
			this.prototype[key] = methods[key];
		}
	}
};

var ScriptComponent = class extends Component {
	_attributeDataMap = /* @__PURE__ */ new Map();
	static EVENT_CREATE = "create";
	static EVENT_DESTROY = "destroy";
	static EVENT_ENABLE = "enable";
	static EVENT_DISABLE = "disable";
	static EVENT_REMOVE = "remove";
	static EVENT_STATE = "state";
	static EVENT_MOVE = "move";
	static EVENT_ERROR = "error";
	constructor(system, entity) {
		super(system, entity);
		this._scripts = [];
		this._updateList = new SortedLoopArray({ sortBy: "__executionOrder" });
		this._postUpdateList = new SortedLoopArray({ sortBy: "__executionOrder" });
		this._scriptsIndex = {};
		this._destroyedScripts = [];
		this._destroyed = false;
		this._scriptsData = null;
		this._oldState = true;
		this._beingEnabled = false;
		this._isLoopingThroughScripts = false;
		this._executionOrder = -1;
		this.on("set_enabled", this._onSetEnabled, this);
	}
	set scripts(value) {
		this._scriptsData = value;
		for (const key in value) {
			if (!value.hasOwnProperty(key)) {
				continue;
			}
			const script2 = this._scriptsIndex[key];
			if (script2) {
				if (typeof value[key].enabled === "boolean") {
					script2.once("preInitialize", () => {
						this.initializeAttributes(script2);
					});
					script2.enabled = !!value[key].enabled;
				}
				if (typeof value[key].attributes === "object") {
					for (const attr in value[key].attributes) {
						if (ScriptAttributes.reservedNames.has(attr)) {
							continue;
						}
						if (!script2.__attributes.hasOwnProperty(attr)) {
							const scriptType = this.system.app.scripts.get(key);
							if (scriptType) {
								scriptType.attributes.add(attr, {});
							}
						}
						script2[attr] = value[key].attributes[attr];
					}
				}
			} else {
				console.log(this.order);
			}
		}
	}
	get scripts() {
		return this._scripts;
	}
	onEnable() {
		this._beingEnabled = true;
		this._checkState();
		if (!this.entity._beingEnabled) {
			this.onPostStateChange();
		}
		this._beingEnabled = false;
	}
	onDisable() {
		this._checkState();
	}
	onPostStateChange() {
		const wasLooping = this._beginLooping();
		for (let i2 = 0, len = this.scripts.length; i2 < len; i2++) {
			const script2 = this.scripts[i2];
			if (script2._initialized && !script2._postInitialized && script2.enabled) {
				script2._postInitialized = true;
				if (script2.postInitialize) {
					this._scriptMethod(script2, SCRIPT_POST_INITIALIZE);
				}
			}
		}
		this._endLooping(wasLooping);
	}
	// Sets isLoopingThroughScripts to false and returns
	// its previous value
	_beginLooping() {
		const looping = this._isLoopingThroughScripts;
		this._isLoopingThroughScripts = true;
		return looping;
	}
	// Restores isLoopingThroughScripts to the specified parameter
	// If all loops are over then remove destroyed scripts form the _scripts array
	_endLooping(wasLoopingBefore) {
		this._isLoopingThroughScripts = wasLoopingBefore;
		if (!this._isLoopingThroughScripts) {
			this._removeDestroyedScripts();
		}
	}
	// We also need this handler because it is fired
	// when value === old instead of onEnable and onDisable
	// which are only fired when value !== old
	_onSetEnabled(prop, old, value) {
		this._beingEnabled = true;
		this._checkState();
		this._beingEnabled = false;
	}
	_checkState() {
		const state = this.enabled && this.entity.enabled;
		if (state === this._oldState) {
			return;
		}
		this._oldState = state;
		this.fire(state ? "enable" : "disable");
		this.fire("state", state);
		if (state) {
			this.system._addComponentToEnabled(this);
		} else {
			this.system._removeComponentFromEnabled(this);
		}
		const wasLooping = this._beginLooping();
		for (let i2 = 0, len = this.scripts.length; i2 < len; i2++) {
			const script2 = this.scripts[i2];
			script2.once("preInitialize", () => {
				this.initializeAttributes(script2);
			});
			script2.enabled = script2._enabled;
		}
		this._endLooping(wasLooping);
	}
	onBeforeRemove() {
		this.fire("remove");
		const wasLooping = this._beginLooping();
		for (let i2 = 0; i2 < this.scripts.length; i2++) {
			const script2 = this.scripts[i2];
			if (!script2) continue;
			this.destroy(script2.__scriptType.__name);
		}
		this._endLooping(wasLooping);
	}
	_removeDestroyedScripts() {
		const len = this._destroyedScripts.length;
		if (!len) return;
		for (let i2 = 0; i2 < len; i2++) {
			const script2 = this._destroyedScripts[i2];
			this._removeScriptInstance(script2);
		}
		this._destroyedScripts.length = 0;
		this._resetExecutionOrder(0, this._scripts.length);
	}
	_onInitializeAttributes() {
		for (let i2 = 0, len = this.scripts.length; i2 < len; i2++) {
			const script2 = this.scripts[i2];
			this.initializeAttributes(script2);
		}
	}
	initializeAttributes(script2) {
		if (script2 instanceof ScriptType) {
			script2.__initializeAttributes();
		} else {
			const name = script2.__scriptType.__name;
			const data2 = this._attributeDataMap.get(name);
			if (!data2) {
				return;
			}
			const schema = this.system.app.scripts?.getSchema(name);
			if (!schema) {
			}
			assignAttributesToScript(this.system.app, schema.attributes, data2, script2);
		}
	}
	_scriptMethod(script2, method, arg) {
		script2[method](arg);
	}
	_onInitialize() {
		const scripts = this._scripts;
		const wasLooping = this._beginLooping();
		for (let i2 = 0, len = scripts.length; i2 < len; i2++) {
			const script2 = scripts[i2];
			if (!script2._initialized && script2.enabled) {
				script2._initialized = true;
				if (script2.initialize) {
					this._scriptMethod(script2, SCRIPT_INITIALIZE);
				}
			}
		}
		this._endLooping(wasLooping);
	}
	_onPostInitialize() {
		this.onPostStateChange();
	}
	_onUpdate(dt) {
		const list = this._updateList;
		if (!list.length) return;
		const wasLooping = this._beginLooping();
		for (list.loopIndex = 0; list.loopIndex < list.length; list.loopIndex++) {
			const script2 = list.items[list.loopIndex];
			if (script2.enabled) {
				this._scriptMethod(script2, SCRIPT_UPDATE, dt);
			}
		}
		this._endLooping(wasLooping);
	}
	_onPostUpdate(dt) {
		const list = this._postUpdateList;
		if (!list.length) return;
		const wasLooping = this._beginLooping();
		for (list.loopIndex = 0; list.loopIndex < list.length; list.loopIndex++) {
			const script2 = list.items[list.loopIndex];
			if (script2.enabled) {
				this._scriptMethod(script2, SCRIPT_POST_UPDATE, dt);
			}
		}
		this._endLooping(wasLooping);
	}
	_insertScriptInstance(scriptInstance, index, scriptsLength) {
		if (index === -1) {
			this._scripts.push(scriptInstance);
			scriptInstance.__executionOrder = scriptsLength;
			if (scriptInstance.update) {
				this._updateList.append(scriptInstance);
			}
			if (scriptInstance.postUpdate) {
				this._postUpdateList.append(scriptInstance);
			}
		} else {
			this._scripts.splice(index, 0, scriptInstance);
			scriptInstance.__executionOrder = index;
			this._resetExecutionOrder(index + 1, scriptsLength + 1);
			if (scriptInstance.update) {
				this._updateList.insert(scriptInstance);
			}
			if (scriptInstance.postUpdate) {
				this._postUpdateList.insert(scriptInstance);
			}
		}
	}
	_removeScriptInstance(scriptInstance) {
		const idx = this._scripts.indexOf(scriptInstance);
		if (idx === -1) return idx;
		this._scripts.splice(idx, 1);
		if (scriptInstance.update) {
			this._updateList.remove(scriptInstance);
		}
		if (scriptInstance.postUpdate) {
			this._postUpdateList.remove(scriptInstance);
		}
		return idx;
	}
	_resetExecutionOrder(startIndex, scriptsLength) {
		for (let i2 = startIndex; i2 < scriptsLength; i2++) {
			this._scripts[i2].__executionOrder = i2;
		}
	}
	_resolveEntityScriptAttribute(attribute, attributeName, oldValue, useGuid, newAttributes, duplicatedIdsMap) {
		if (attribute.array) {
			const len = oldValue.length;
			if (!len) {
				return;
			}
			const newGuidArray = oldValue.slice();
			for (let i2 = 0; i2 < len; i2++) {
				const guid2 = newGuidArray[i2] instanceof Entity ? newGuidArray[i2].guid : newGuidArray[i2];
				if (duplicatedIdsMap[guid2]) {
					newGuidArray[i2] = useGuid ? duplicatedIdsMap[guid2].guid : duplicatedIdsMap[guid2];
				}
			}
			newAttributes[attributeName] = newGuidArray;
		} else {
			if (oldValue instanceof Entity) {
				oldValue = oldValue.guid;
			} else if (typeof oldValue !== "string") {
				return;
			}
			if (duplicatedIdsMap[oldValue]) {
				newAttributes[attributeName] = duplicatedIdsMap[oldValue];
			}
		}
	}
	has(nameOrType) {
		if (typeof nameOrType === "string") {
			return !!this._scriptsIndex[nameOrType];
		}
		if (!nameOrType) return false;
		const scriptType = nameOrType;
		const scriptName = scriptType.__name;
		const scriptData = this._scriptsIndex[scriptName];
		const scriptInstance = scriptData && scriptData.instance;
		return scriptInstance instanceof scriptType;
	}
	get(nameOrType) {
		if (typeof nameOrType === "string") {
			const data2 = this._scriptsIndex[nameOrType];
			return data2 ? data2.instance : null;
		}
		if (!nameOrType) return null;
		const scriptType = nameOrType;
		const scriptName = scriptType.__name;
		const scriptData = this._scriptsIndex[scriptName];
		const scriptInstance = scriptData && scriptData.instance;
		return scriptInstance instanceof scriptType ? scriptInstance : null;
	}
	create(nameOrType, args = {}) {
		const self2 = this;
		let scriptType = nameOrType;
		let scriptName = nameOrType;
		if (typeof scriptType === "string") {
			scriptType = this.system.app.scripts.get(scriptType);
		} else if (scriptType) {
			const inferredScriptName = getScriptName(scriptType);
			const ownScriptName = Object.prototype.hasOwnProperty.call(scriptType, "scriptName") && scriptType.scriptName;
			if (!(scriptType.prototype instanceof ScriptType) && !ownScriptName) {
			}
			if (!Object.prototype.hasOwnProperty.call(scriptType, "__name")) {
				scriptType.__name = getScriptRegistryName(scriptType);
			}
			scriptName = scriptType.__name;
			if (!scriptName) {
				return null;
			}
		}
		if (scriptType) {
			if (!this._scriptsIndex[scriptName] || !this._scriptsIndex[scriptName].instance) {
				const scriptInstance = new scriptType({
					app: this.system.app,
					entity: this.entity,
					enabled: args.hasOwnProperty("enabled") ? args.enabled : true,
					attributes: args.attributes || {}
				});
				if (args.properties && typeof args.properties === "object") {
					Object.assign(scriptInstance, args.properties);
				}
				if (!(scriptInstance instanceof ScriptType) && args.attributes) {
					this._attributeDataMap.set(scriptName, { ...args.attributes });
				}
				const len = this._scripts.length;
				let ind = -1;
				if (typeof args.ind === "number" && args.ind !== -1 && len > args.ind) {
					ind = args.ind;
				}
				this._insertScriptInstance(scriptInstance, ind, len);
				this._scriptsIndex[scriptName] = {
					instance: scriptInstance,
					onSwap: function() {
						self2.swap(scriptName);
					}
				};
				this[scriptName] = scriptInstance;
				if (!args.preloading) {
					this.initializeAttributes(scriptInstance);
				}
				this.fire("create", scriptName, scriptInstance);
				this.fire(`create:${scriptName}`, scriptInstance);
				this.system.app.scripts.on(`swap:${scriptName}`, this._scriptsIndex[scriptName].onSwap);
				if (!args.preloading) {
					if (scriptInstance.enabled && !scriptInstance._initialized) {
						scriptInstance._initialized = true;
						if (scriptInstance.initialize) {
							this._scriptMethod(scriptInstance, SCRIPT_INITIALIZE);
						}
					}
					if (scriptInstance.enabled && !scriptInstance._postInitialized) {
						scriptInstance._postInitialized = true;
						if (scriptInstance.postInitialize) {
							this._scriptMethod(scriptInstance, SCRIPT_POST_INITIALIZE);
						}
					}
				}
				return scriptInstance;
			}
		} else {
			this._scriptsIndex[scriptName] = {
				awaiting: true,
				ind: this._scripts.length
			};
		}
		return null;
	}
	destroy(nameOrType) {
		let scriptName = nameOrType;
		let scriptType = nameOrType;
		if (typeof scriptType === "string") {
			scriptType = this.system.app.scripts.get(scriptType);
		} else if (scriptType) {
			scriptName = scriptType.__name;
		}
		const scriptData = this._scriptsIndex[scriptName];
		delete this._scriptsIndex[scriptName];
		if (!scriptData) return false;
		this._attributeDataMap.delete(scriptName);
		const scriptInstance = scriptData.instance;
		if (scriptInstance && !scriptInstance._destroyed) {
			scriptInstance.enabled = false;
			scriptInstance._destroyed = true;
			if (!this._isLoopingThroughScripts) {
				const ind = this._removeScriptInstance(scriptInstance);
				if (ind >= 0) {
					this._resetExecutionOrder(ind, this._scripts.length);
				}
			} else {
				this._destroyedScripts.push(scriptInstance);
			}
		}
		this.system.app.scripts.off(`swap:${scriptName}`, scriptData.onSwap);
		delete this[scriptName];
		this.fire("destroy", scriptName, scriptInstance || null);
		this.fire(`destroy:${scriptName}`, scriptInstance || null);
		if (scriptInstance) {
			scriptInstance.fire("destroy");
		}
		return true;
	}
	swap(nameOrType) {
		let scriptName = nameOrType;
		let scriptType = nameOrType;
		if (typeof scriptType === "string") {
			scriptType = this.system.app.scripts.get(scriptType);
		} else if (scriptType) {
			scriptName = scriptType.__name;
		}
		const old = this._scriptsIndex[scriptName];
		if (!old || !old.instance) return false;
		const scriptInstanceOld = old.instance;
		const ind = this._scripts.indexOf(scriptInstanceOld);
		const scriptInstance = new scriptType({
			app: this.system.app,
			entity: this.entity,
			enabled: scriptInstanceOld.enabled,
			attributes: scriptInstanceOld.__attributes
		});
		if (!scriptInstance.swap) {
			return false;
		}
		this.initializeAttributes(scriptInstance);
		this._scripts[ind] = scriptInstance;
		this._scriptsIndex[scriptName].instance = scriptInstance;
		this[scriptName] = scriptInstance;
		scriptInstance.__executionOrder = ind;
		if (scriptInstanceOld.update) {
			this._updateList.remove(scriptInstanceOld);
		}
		if (scriptInstanceOld.postUpdate) {
			this._postUpdateList.remove(scriptInstanceOld);
		}
		if (scriptInstance.update) {
			this._updateList.insert(scriptInstance);
		}
		if (scriptInstance.postUpdate) {
			this._postUpdateList.insert(scriptInstance);
		}
		this._scriptMethod(scriptInstance, SCRIPT_SWAP, scriptInstanceOld);
		this.fire("swap", scriptName, scriptInstance);
		this.fire(`swap:${scriptName}`, scriptInstance);
		return true;
	}
	resolveDuplicatedEntityReferenceProperties(oldScriptComponent, duplicatedIdsMap) {
		const newScriptComponent = this.entity.script;
		for (const scriptName in oldScriptComponent._scriptsIndex) {
			const scriptType = this.system.app.scripts.get(scriptName);
			if (!scriptType) {
				continue;
			}
			const script2 = oldScriptComponent._scriptsIndex[scriptName];
			if (!script2 || !script2.instance) {
				continue;
			}
			const newAttributesRaw = newScriptComponent[scriptName].__attributesRaw ?? newScriptComponent._attributeDataMap.get(scriptName);
			const newAttributes = newScriptComponent[scriptName].__attributes;
			if (!newAttributesRaw && !newAttributes) {
				continue;
			}
			const useGuid = !!newAttributesRaw;
			const oldAttributes = script2.instance.__attributes ?? newScriptComponent._attributeDataMap.get(scriptName);
			for (const attributeName in oldAttributes) {
				if (!oldAttributes[attributeName]) {
					continue;
				}
				const attribute = scriptType.attributes?.get(attributeName) ?? this.system.app.scripts.getSchema(scriptName)?.attributes?.[attributeName];
				if (!attribute) {
					continue;
				}
				if (attribute.type === "entity") {
					this._resolveEntityScriptAttribute(
						attribute,
						attributeName,
						oldAttributes[attributeName],
						useGuid,
						newAttributesRaw || newAttributes,
						duplicatedIdsMap
					);
				} else if (attribute.type === "json" && Array.isArray(attribute.schema)) {
					const oldValue = oldAttributes[attributeName];
					const newJsonValue = newAttributesRaw ? newAttributesRaw[attributeName] : newAttributes[attributeName];
					for (let i2 = 0; i2 < attribute.schema.length; i2++) {
						const field = attribute.schema[i2];
						if (field.type !== "entity") {
							continue;
						}
						if (attribute.array) {
							for (let j = 0; j < oldValue.length; j++) {
								this._resolveEntityScriptAttribute(
									field,
									field.name,
									oldValue[j][field.name],
									useGuid,
									newJsonValue[j],
									duplicatedIdsMap
								);
							}
						} else {
							this._resolveEntityScriptAttribute(
								field,
								field.name,
								oldValue[field.name],
								useGuid,
								newJsonValue,
								duplicatedIdsMap
							);
						}
					}
				}
			}
		}
	}
	move(nameOrType, ind) {
		const len = this._scripts.length;
		if (ind >= len || ind < 0) {
			return false;
		}
		let scriptType = nameOrType;
		let scriptName = nameOrType;
		if (typeof scriptName !== "string") {
			scriptName = nameOrType.__name;
		} else {
			scriptType = null;
		}
		const scriptData = this._scriptsIndex[scriptName];
		if (!scriptData || !scriptData.instance) {
			return false;
		}
		const scriptInstance = scriptData.instance;
		if (scriptType && !(scriptInstance instanceof scriptType)) {
			return false;
		}
		const indOld = this._scripts.indexOf(scriptInstance);
		if (indOld === -1 || indOld === ind) {
			return false;
		}
		this._scripts.splice(ind, 0, this._scripts.splice(indOld, 1)[0]);
		this._resetExecutionOrder(0, len);
		this._updateList.sort();
		this._postUpdateList.sort();
		this.fire("move", scriptName, scriptInstance, ind, indOld);
		this.fire(`move:${scriptName}`, scriptInstance, ind, indOld);
		return true;
	}
};

var METHOD_INITIALIZE_ATTRIBUTES = "_onInitializeAttributes";
var METHOD_INITIALIZE = "_onInitialize";
var METHOD_POST_INITIALIZE = "_onPostInitialize";
var METHOD_UPDATE = "_onUpdate";
var METHOD_POST_UPDATE = "_onPostUpdate";
var executionOrderCounter = 0;
var ScriptComponentSystem = class extends ComponentSystem {
	constructor(app2) {
		super(app2);
		this.id = "script";
		this.ComponentType = ScriptComponent;
		this.extraDataProperties = ["order"];
		this._components = new SortedLoopArray({
			sortBy: "_executionOrder"
		});
		this._enabledComponents = new SortedLoopArray({
			sortBy: "_executionOrder"
		});
		this.preloading = true;
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.systems.on("initialize", this._onInitialize, this);
		this.app.systems.on("postInitialize", this._onPostInitialize, this);
		this.app.systems.on("update", this._onUpdate, this);
		this.app.systems.on("postUpdate", this._onPostUpdate, this);
	}
	initializeComponentData(component, data2) {
		component._executionOrder = executionOrderCounter++;
		this._components.append(component);
		if (executionOrderCounter > Number.MAX_SAFE_INTEGER) {
			this._resetExecutionOrder();
		}
		component.enabled = data2.hasOwnProperty("enabled") ? !!data2.enabled : true;
		if (component.enabled && component.entity.enabled) {
			this._enabledComponents.append(component);
		}
		if (data2.hasOwnProperty("order") && data2.hasOwnProperty("scripts")) {
			component._scriptsData = data2.scripts;
			for (let i2 = 0; i2 < data2.order.length; i2++) {
				component.create(data2.order[i2], {
					enabled: data2.scripts[data2.order[i2]].enabled,
					attributes: data2.scripts[data2.order[i2]].attributes,
					preloading: this.preloading
				});
			}
		}
	}
	cloneComponent(entity, clone) {
		const order = [];
		const scripts = {};
		for (let i2 = 0; i2 < entity.script._scripts.length; i2++) {
			const scriptInstance = entity.script._scripts[i2];
			const scriptName = scriptInstance.__scriptType.__name;
			order.push(scriptName);
			const attributes = entity.script._attributeDataMap?.get(scriptName) || {};
			for (const key in scriptInstance.__attributes) {
				attributes[key] = scriptInstance.__attributes[key];
			}
			scripts[scriptName] = {
				enabled: scriptInstance._enabled,
				attributes
			};
		}
		for (const key in entity.script._scriptsIndex) {
			if (key.awaiting) {
				order.splice(key.ind, 0, key);
			}
		}
		const data2 = {
			enabled: entity.script.enabled,
			order,
			scripts
		};
		return this.addComponent(clone, data2);
	}
	_resetExecutionOrder() {
		executionOrderCounter = 0;
		for (let i2 = 0, len = this._components.length; i2 < len; i2++) {
			this._components.items[i2]._executionOrder = executionOrderCounter++;
		}
	}
	_callComponentMethod(components2, name, dt) {
		for (components2.loopIndex = 0; components2.loopIndex < components2.length; components2.loopIndex++) {
			components2.items[components2.loopIndex][name](dt);
		}
	}
	_onInitialize() {
		this.preloading = false;
		this._callComponentMethod(this._components, METHOD_INITIALIZE_ATTRIBUTES);
		this._callComponentMethod(this._enabledComponents, METHOD_INITIALIZE);
	}
	_onPostInitialize() {
		this._callComponentMethod(this._enabledComponents, METHOD_POST_INITIALIZE);
	}
	_onUpdate(dt) {
		this._callComponentMethod(this._enabledComponents, METHOD_UPDATE, dt);
	}
	_onPostUpdate(dt) {
		this._callComponentMethod(this._enabledComponents, METHOD_POST_UPDATE, dt);
	}
	// inserts the component into the enabledComponents array
	// which finds the right slot based on component._executionOrder
	_addComponentToEnabled(component) {
		this._enabledComponents.insert(component);
	}
	// removes the component from the enabledComponents array
	_removeComponentFromEnabled(component) {
		this._enabledComponents.remove(component);
	}
	onBeforeRemove(entity, component) {
		const ind = this._components.items.indexOf(component);
		if (ind >= 0) {
			component.onBeforeRemove();
		}
		this._removeComponentFromEnabled(component);
		this._components.remove(component);
	}
	destroy() {
		super.destroy();
		this.app.systems.off("initialize", this._onInitialize, this);
		this.app.systems.off("postInitialize", this._onPostInitialize, this);
		this.app.systems.off("update", this._onUpdate, this);
		this.app.systems.off("postUpdate", this._onPostUpdate, this);
	}
};

function UnifiedSortWorker() {
	const myself = typeof self !== "undefined" && self || __require("node:worker_threads").parentPort;
	const centersMap = /* @__PURE__ */ new Map();
	let centersData;
	let distances;
	let countBuffer;
	let indexMap;
	let _radialSort = false;
	let _warnedSortKeyOverflow = false;
	const numBins = 32;
	const binBase = new Float32Array(numBins + 1);
	const binDivider = new Float32Array(numBins + 1);
	const binWeightsUtil = new GSplatSortBinWeights();
	const unpackBinWeights = (binWeights) => {
		for (let i2 = 0; i2 < numBins; i2++) {
			binBase[i2] = binWeights[i2 * 2];
			binDivider[i2] = binWeights[i2 * 2 + 1];
		}
		binBase[numBins] = binBase[numBins - 1] + binDivider[numBins - 1];
		binDivider[numBins] = 0;
	};
	const evaluateSortKeysCommon = (sortParams, minDist, range, distances2, countBuffer2, centersData2, processSplatFn) => {
		const { ids: ids3, intervals } = centersData2;
		const invBinRange = numBins / range;
		let compactIdx = 0;
		for (let paramIdx = 0; paramIdx < sortParams.length; paramIdx++) {
			const params = sortParams[paramIdx];
			const id14 = ids3[paramIdx];
			const centers = centersMap.get(id14);
			if (!centers) {
				console.error("UnifiedSortWorker: No centers found for id", id14);
			}
			const intervalsArray = intervals[paramIdx].length > 0 ? intervals[paramIdx] : [0, centers.length / 3];
			for (let i2 = 0; i2 < intervalsArray.length; i2 += 2) {
				const intervalStart = intervalsArray[i2] * 3;
				const intervalEnd = intervalsArray[i2 + 1] * 3;
				compactIdx = processSplatFn(
					centers,
					params,
					intervalStart,
					intervalEnd,
					compactIdx,
					invBinRange,
					minDist,
					range,
					distances2,
					countBuffer2
				);
			}
		}
	};
	const evaluateSortKeysLinear = (sortParams, minDist, range, distances2, countBuffer2, centersData2) => {
		evaluateSortKeysCommon(
			sortParams,
			minDist,
			range,
			distances2,
			countBuffer2,
			centersData2,
			(centers, params, intervalStart, intervalEnd, compactIdx, invBinRange, minDist2, range2, distances3, countBuffer3) => {
				const { transformedDirection, offset: offset3, scale: scale2 } = params;
				const dx = transformedDirection.x;
				const dy = transformedDirection.y;
				const dz = transformedDirection.z;
				const sdx = dx * scale2;
				const sdy = dy * scale2;
				const sdz = dz * scale2;
				const add = offset3 - minDist2;
				for (let srcIndex = intervalStart; srcIndex < intervalEnd; srcIndex += 3) {
					const x3 = centers[srcIndex];
					const y2 = centers[srcIndex + 1];
					const z2 = centers[srcIndex + 2];
					const dist = x3 * sdx + y2 * sdy + z2 * sdz + add;
					const d = dist * invBinRange;
					const bin = d >>> 0;
					const sortKey = binBase[bin] + binDivider[bin] * (d - bin) >>> 0;
					distances3[compactIdx++] = sortKey;
					countBuffer3[sortKey]++;
				}
				return compactIdx;
			}
		);
	};
	const evaluateSortKeysRadial = (sortParams, minDist, range, distances2, countBuffer2, centersData2) => {
		evaluateSortKeysCommon(
			sortParams,
			minDist,
			range,
			distances2,
			countBuffer2,
			centersData2,
			(centers, params, intervalStart, intervalEnd, compactIdx, invBinRange, minDist2, range2, distances3, countBuffer3) => {
				const { transformedPosition, scale: scale2 } = params;
				const cx = transformedPosition.x;
				const cy = transformedPosition.y;
				const cz = transformedPosition.z;
				for (let srcIndex = intervalStart; srcIndex < intervalEnd; srcIndex += 3) {
					const dx = centers[srcIndex] - cx;
					const dy = centers[srcIndex + 1] - cy;
					const dz = centers[srcIndex + 2] - cz;
					const distSq = dx * dx + dy * dy + dz * dz;
					const dist = Math.sqrt(distSq) * scale2;
					const invertedDist = range2 - dist;
					const d = invertedDist * invBinRange;
					const bin = d >>> 0;
					const sortKey = binBase[bin] + binDivider[bin] * (d - bin) >>> 0;
					distances3[compactIdx++] = sortKey;
					countBuffer3[sortKey]++;
				}
				return compactIdx;
			}
		);
	};
	const countingSort = (bucketCount, countBuffer2, numVertices, distances2, order) => {
		for (let i2 = 1; i2 < bucketCount; i2++) {
			countBuffer2[i2] += countBuffer2[i2 - 1];
		}
		const validCount = countBuffer2[bucketCount - 1];
		if (validCount !== numVertices && !_warnedSortKeyOverflow) {
			_warnedSortKeyOverflow = true;
			console.warn(`[SortWorker] ${numVertices - validCount} splats lost due to sortKey overflow. Check resource AABB bounds contain all the splats.`);
		}
		for (let i2 = 0; i2 < numVertices; i2++) {
			const distance = distances2[i2];
			const destIndex = --countBuffer2[distance];
			order[destIndex] = indexMap[i2];
		}
	};
	const computeEffectiveDistanceRangeLinear = (sortParams) => {
		let minDist = Infinity;
		let maxDist = -Infinity;
		for (let paramIdx = 0; paramIdx < sortParams.length; paramIdx++) {
			const params = sortParams[paramIdx];
			const { transformedDirection, offset: offset3, scale: scale2, aabbMin, aabbMax } = params;
			const dx = transformedDirection.x;
			const dy = transformedDirection.y;
			const dz = transformedDirection.z;
			const pxMin = dx >= 0 ? aabbMin[0] : aabbMax[0];
			const pyMin = dy >= 0 ? aabbMin[1] : aabbMax[1];
			const pzMin = dz >= 0 ? aabbMin[2] : aabbMax[2];
			const pxMax = dx >= 0 ? aabbMax[0] : aabbMin[0];
			const pyMax = dy >= 0 ? aabbMax[1] : aabbMin[1];
			const pzMax = dz >= 0 ? aabbMax[2] : aabbMin[2];
			const dMin = pxMin * dx + pyMin * dy + pzMin * dz;
			const dMax = pxMax * dx + pyMax * dy + pzMax * dz;
			const eMin = dMin * scale2 + offset3;
			const eMax = dMax * scale2 + offset3;
			const localMin = Math.min(eMin, eMax);
			const localMax = Math.max(eMin, eMax);
			if (localMin < minDist) minDist = localMin;
			if (localMax > maxDist) maxDist = localMax;
		}
		if (minDist === Infinity) {
			minDist = 0;
			maxDist = 0;
		}
		return { minDist, maxDist };
	};
	const computeEffectiveDistanceRangeRadial = (sortParams) => {
		let maxDist = -Infinity;
		for (let paramIdx = 0; paramIdx < sortParams.length; paramIdx++) {
			const params = sortParams[paramIdx];
			const { transformedPosition, scale: scale2, aabbMin, aabbMax } = params;
			const cx = transformedPosition.x;
			const cy = transformedPosition.y;
			const cz = transformedPosition.z;
			for (let i2 = 0; i2 < 8; i2++) {
				const px = i2 & 1 ? aabbMax[0] : aabbMin[0];
				const py = i2 & 2 ? aabbMax[1] : aabbMin[1];
				const pz = i2 & 4 ? aabbMax[2] : aabbMin[2];
				const dx = px - cx;
				const dy = py - cy;
				const dz = pz - cz;
				const distSq = dx * dx + dy * dy + dz * dz;
				const dist = Math.sqrt(distSq) * scale2;
				if (dist > maxDist) maxDist = dist;
			}
		}
		const minDist = 0;
		if (maxDist < 0) {
			maxDist = 0;
		}
		return { minDist, maxDist };
	};
	const sort = (sortParams, order, centersData2) => {
		const sortStartTime = performance.now();
		const { minDist, maxDist } = _radialSort ? computeEffectiveDistanceRangeRadial(sortParams) : computeEffectiveDistanceRangeLinear(sortParams);
		const numVertices = centersData2.totalActiveSplats;
		const compareBits = Math.max(10, Math.min(20, Math.round(Math.log2(numVertices / 4))));
		const bucketCount = 2 ** compareBits + 1;
		if (distances?.length !== numVertices) {
			distances = new Uint32Array(numVertices);
		}
		if (!countBuffer || countBuffer.length !== bucketCount) {
			countBuffer = new Uint32Array(bucketCount);
		} else {
			countBuffer.fill(0);
		}
		const range = maxDist - minDist;
		const cameraBin = GSplatSortBinWeights.computeCameraBin(_radialSort, minDist, range);
		const binWeights = binWeightsUtil.compute(cameraBin, bucketCount);
		unpackBinWeights(binWeights);
		if (_radialSort) {
			evaluateSortKeysRadial(sortParams, minDist, range, distances, countBuffer, centersData2);
		} else {
			evaluateSortKeysLinear(sortParams, minDist, range, distances, countBuffer, centersData2);
		}
		countingSort(bucketCount, countBuffer, numVertices, distances, order);
		const count = numVertices;
		const sortTime = performance.now() - sortStartTime;
		const transferList = [order.buffer];
		const response = {
			order: order.buffer,
			count,
			version: centersData2.version,
			sortTime
		};
		myself.postMessage(response, transferList);
	};
	const buildIndexMap = (data2) => {
		const { ids: ids3, pixelOffsets, intervals, totalActiveSplats } = data2;
		if (!indexMap || indexMap.length < totalActiveSplats) {
			indexMap = new Uint32Array(totalActiveSplats);
		}
		let compactIdx = 0;
		for (let paramIdx = 0; paramIdx < ids3.length; paramIdx++) {
			const centers = centersMap.get(ids3[paramIdx]);
			const offsets = pixelOffsets[paramIdx];
			const intervalsArray = intervals[paramIdx].length > 0 ? intervals[paramIdx] : [0, centers.length / 3];
			for (let i2 = 0; i2 < intervalsArray.length; i2 += 2) {
				let workBufferIndex = offsets[i2 / 2];
				const count = intervalsArray[i2 + 1] - intervalsArray[i2];
				for (let j = 0; j < count; j++) {
					indexMap[compactIdx++] = workBufferIndex++;
				}
			}
		}
	};
	myself.addEventListener("message", (message) => {
		const msgData = message.data ?? message;
		switch (msgData.command) {
			// add centers to map
			case "addCenters": {
				centersMap.set(msgData.id, new Float32Array(msgData.centers));
				break;
			}
			// remove centers from map
			case "removeCenters": {
				centersMap.delete(msgData.id);
				break;
			}
			// sort
			case "sort": {
				_radialSort = msgData.radialSorting || false;
				const order = new Uint32Array(msgData.order);
				sort(msgData.sortParams, order, centersData);
				break;
			}
			// intervals
			case "intervals": {
				centersData = msgData;
				buildIndexMap(centersData);
				break;
			}
		}
	});
}

var GSplatSortBinWeights2 = class _GSplatSortBinWeights {
	static get NUM_BINS() {
		return 32;
	}
	static get WEIGHT_TIERS() {
		return [
			{ maxDistance: 0, weight: 40 },
			// Camera bin
			{ maxDistance: 2, weight: 20 },
			// Adjacent bins
			{ maxDistance: 5, weight: 8 },
			// Nearby bins
			{ maxDistance: 10, weight: 3 },
			// Medium distance
			{ maxDistance: Infinity, weight: 1 }
			// Far bins
		];
	}
	constructor() {
		const numBins = _GSplatSortBinWeights.NUM_BINS;
		const weightTiers = _GSplatSortBinWeights.WEIGHT_TIERS;
		this.binWeights = new Float32Array(numBins * 2);
		this.bitsPerBin = new Float32Array(numBins);
		this.weightByDistance = new Float32Array(numBins);
		for (let dist = 0; dist < numBins; dist++) {
			let weight = 1;
			for (let j = 0; j < weightTiers.length; j++) {
				if (dist <= weightTiers[j].maxDistance) {
					weight = weightTiers[j].weight;
					break;
				}
			}
			this.weightByDistance[dist] = weight;
		}
		this.lastCameraBin = -1;
		this.lastBucketCount = -1;
	}
	static computeCameraBin(radialSort, minDist, range) {
		const numBins = _GSplatSortBinWeights.NUM_BINS;
		if (radialSort) {
			return numBins - 1;
		}
		const cameraOffsetFromRangeStart = -minDist;
		const cameraBinFloat = cameraOffsetFromRangeStart / range * numBins;
		return Math.max(0, Math.min(numBins - 1, Math.floor(cameraBinFloat)));
	}
	compute(cameraBin, bucketCount) {
		if (cameraBin === this.lastCameraBin && bucketCount === this.lastBucketCount) {
			return this.binWeights;
		}
		this.lastCameraBin = cameraBin;
		this.lastBucketCount = bucketCount;
		const numBins = _GSplatSortBinWeights.NUM_BINS;
		const bitsPerBin = this.bitsPerBin;
		for (let i2 = 0; i2 < numBins; i2++) {
			const distFromCamera = Math.abs(i2 - cameraBin);
			bitsPerBin[i2] = this.weightByDistance[distFromCamera];
		}
		let totalWeight = 0;
		for (let i2 = 0; i2 < numBins; i2++) {
			totalWeight += bitsPerBin[i2];
		}
		let accumulated = 0;
		for (let i2 = 0; i2 < numBins; i2++) {
			const divider = Math.max(1, Math.floor(bitsPerBin[i2] / totalWeight * bucketCount));
			this.binWeights[i2 * 2] = accumulated;
			this.binWeights[i2 * 2 + 1] = divider;
			accumulated += divider;
		}
		if (accumulated > bucketCount) {
			const excess = accumulated - bucketCount;
			const lastDividerIdx = (numBins - 1) * 2 + 1;
			this.binWeights[lastDividerIdx] = Math.max(1, this.binWeights[lastDividerIdx] - excess);
		}
		return this.binWeights;
	}
};

var _neededIds = /* @__PURE__ */ new Set();
var GSplatUnifiedSorter = class extends EventHandler {
	worker;
	bufferLength = 0;
	availableOrderData = [];
	// track how many jobs are in flight
	jobsInFlight = 0;
	// true if we have new version to process
	hasNewVersion = false;
	pendingSorted = null;
	centersSet = /* @__PURE__ */ new Set();
	_destroyed = false;
	scene = null;
	constructor(scene) {
		super();
		this.scene = scene ?? null;
		const workerSource = `
						const GSplatSortBinWeights = ${GSplatSortBinWeights2.toString()};
						(${UnifiedSortWorker.toString()})()
				`;
		if (platform.environment === "node") {
			this.worker = new Worker(workerSource, {
				eval: true
			});
			this.worker.on("message", this.onSorted.bind(this));
		} else {
			this.worker = new Worker(URL.createObjectURL(new Blob([workerSource], {
				type: "application/javascript"
			})));
			this.worker.addEventListener("message", this.onSorted.bind(this));
		}
	}
	onSorted(message) {
		if (this._destroyed) {
			return;
		}
		const msgData = message.data ?? message;
		if (this.scene && msgData.sortTime !== void 0) {
			this.scene.fire("gsplat:sorted", msgData.sortTime);
		}
		const orderData = new Uint32Array(msgData.order);
		this.jobsInFlight--;
		if (this.pendingSorted) {
			this.releaseOrderData(this.pendingSorted.orderData);
		}
		this.pendingSorted = {
			count: msgData.count,
			version: msgData.version,
			orderData
		};
	}
	applyPendingSorted() {
		if (this.pendingSorted) {
			const { count, version: version2, orderData } = this.pendingSorted;
			this.pendingSorted = null;
			this.fire("sorted", count, version2, orderData);
			this.releaseOrderData(orderData);
		}
	}
	releaseOrderData(orderData) {
		if (orderData.length === this.bufferLength) {
			this.availableOrderData.push(orderData);
		}
	}
	destroy() {
		this._destroyed = true;
		this.pendingSorted = null;
		this.worker.terminate();
		this.worker = null;
	}
	setCenters(id14, centers) {
		if (centers) {
			if (!this.centersSet.has(id14)) {
				this.centersSet.add(id14);
				const centersBuffer = centers.buffer.slice();
				this.worker.postMessage({
					command: "addCenters",
					id: id14,
					centers: centersBuffer
				}, [centersBuffer]);
			}
		} else {
			if (this.centersSet.has(id14)) {
				this.centersSet.delete(id14);
				this.worker.postMessage({
					command: "removeCenters",
					id: id14
				});
			}
		}
	}
	updateCentersForSplats(splats) {
		for (const splat of splats) {
			const id14 = splat.resource.id;
			_neededIds.add(id14);
			if (!this.centersSet.has(id14)) {
				this.setCenters(id14, splat.resource.centers);
			}
		}
		for (const id14 of this.centersSet) {
			if (!_neededIds.has(id14)) {
				this.setCenters(id14, null);
			}
		}
		_neededIds.clear();
	}
	setSortParameters(payload) {
		this.hasNewVersion = true;
		const { textureSize } = payload;
		const newLength = textureSize * textureSize;
		if (newLength !== this.bufferLength) {
			this.bufferLength = newLength;
			this.availableOrderData.length = 0;
		}
		this.worker.postMessage(payload);
	}
	setSortParams(params, radialSorting) {
		if (this.hasNewVersion || this.jobsInFlight === 0) {
			let orderData = this.availableOrderData.pop();
			if (!orderData) {
				orderData = new Uint32Array(this.bufferLength);
			}
			this.jobsInFlight++;
			this.hasNewVersion = false;
			this.worker.postMessage({
				command: "sort",
				sortParams: params,
				radialSorting,
				order: orderData.buffer
			}, [
				orderData.buffer
			]);
		}
	}
};

var MemBlock = class {
	_offset = 0;
	_size = 0;
	_free = true;
	_prev = null;
	_next = null;
	_prevFree = null;
	_nextFree = null;
	_bucket = -1;
	get offset() {
		return this._offset;
	}
	get size() {
		return this._size;
	}
};
var BlockAllocator = class {
	_headAll = null;
	_tailAll = null;
	_freeBucketHeads = [];
	_pool = [];
	_capacity = 0;
	_usedSize = 0;
	_freeSize = 0;
	_freeRegionCount = 0;
	_growMultiplier;
	constructor(capacity = 0, growMultiplier = 1.1) {
		this._growMultiplier = growMultiplier;
		if (capacity > 0) {
			this._capacity = capacity;
			this._freeSize = capacity;
			const block = this._obtain(0, capacity, true);
			this._headAll = block;
			this._tailAll = block;
			this._addToBucket(block);
		}
	}
	get capacity() {
		return this._capacity;
	}
	get usedSize() {
		return this._usedSize;
	}
	get freeSize() {
		return this._freeSize;
	}
	get fragmentation() {
		return this._freeSize > 0 ? 1 - 1 / this._freeRegionCount : 0;
	}
	_bucketFor(size) {
		return 31 - Math.clz32(size);
	}
	_addToBucket(block) {
		const b = this._bucketFor(block._size);
		block._bucket = b;
		while (b >= this._freeBucketHeads.length) {
			this._freeBucketHeads.push(null);
		}
		block._prevFree = null;
		block._nextFree = this._freeBucketHeads[b];
		if (this._freeBucketHeads[b]) this._freeBucketHeads[b]._prevFree = block;
		this._freeBucketHeads[b] = block;
		this._freeRegionCount++;
	}
	_removeFromBucket(block) {
		const b = block._bucket;
		if (block._prevFree) block._prevFree._nextFree = block._nextFree;
		else this._freeBucketHeads[b] = block._nextFree;
		if (block._nextFree) block._nextFree._prevFree = block._prevFree;
		block._prevFree = null;
		block._nextFree = null;
		block._bucket = -1;
		this._freeRegionCount--;
	}
	_rebucket(block) {
		const newBucket = this._bucketFor(block._size);
		if (newBucket !== block._bucket) {
			this._removeFromBucket(block);
			this._addToBucket(block);
		}
	}
	_obtain(offset3, size, free) {
		let block;
		if (this._pool.length > 0) {
			block = this._pool.pop();
		} else {
			block = new MemBlock();
		}
		block._offset = offset3;
		block._size = size;
		block._free = free;
		block._prev = null;
		block._next = null;
		block._prevFree = null;
		block._nextFree = null;
		block._bucket = -1;
		return block;
	}
	_release(block) {
		block._prev = null;
		block._next = null;
		block._prevFree = null;
		block._nextFree = null;
		block._bucket = -1;
		this._pool.push(block);
	}
	_insertAfterInMainList(block, after) {
		if (after === null) {
			block._prev = null;
			block._next = this._headAll;
			if (this._headAll) this._headAll._prev = block;
			this._headAll = block;
			if (!this._tailAll) this._tailAll = block;
		} else {
			block._prev = after;
			block._next = after._next;
			if (after._next) after._next._prev = block;
			after._next = block;
			if (this._tailAll === after) this._tailAll = block;
		}
	}
	_removeFromMainList(block) {
		if (block._prev) block._prev._next = block._next;
		else this._headAll = block._next;
		if (block._next) block._next._prev = block._prev;
		else this._tailAll = block._prev;
		block._prev = null;
		block._next = null;
	}
	_findFreeBlock(size) {
		const startBucket = this._bucketFor(size);
		const len = this._freeBucketHeads.length;
		if (startBucket < len) {
			let best = null;
			let node = this._freeBucketHeads[startBucket];
			while (node) {
				if (node._size >= size) {
					if (!best || node._size < best._size) {
						best = node;
						if (node._size === size) break;
					}
				}
				node = node._nextFree;
			}
			if (best) return best;
		}
		for (let b = startBucket + 1; b < len; b++) {
			if (this._freeBucketHeads[b]) {
				return this._freeBucketHeads[b];
			}
		}
		return null;
	}
	allocate(size) {
		const gap = this._findFreeBlock(size);
		if (!gap) return null;
		this._usedSize += size;
		this._freeSize -= size;
		if (gap._size === size) {
			gap._free = false;
			this._removeFromBucket(gap);
			return gap;
		}
		const alloc = this._obtain(gap._offset, size, false);
		gap._offset += size;
		gap._size -= size;
		this._rebucket(gap);
		this._insertAfterInMainList(alloc, gap._prev);
		return alloc;
	}
	free(block) {
		block._free = true;
		this._usedSize -= block._size;
		this._freeSize += block._size;
		const prev = block._prev;
		const next = block._next;
		const prevFree = prev && prev._free;
		const nextFree = next && next._free;
		if (prevFree && nextFree) {
			prev._size += block._size + next._size;
			this._removeFromMainList(block);
			this._removeFromMainList(next);
			this._removeFromBucket(next);
			this._release(block);
			this._release(next);
			this._rebucket(prev);
		} else if (prevFree) {
			prev._size += block._size;
			this._removeFromMainList(block);
			this._release(block);
			this._rebucket(prev);
		} else if (nextFree) {
			block._size += next._size;
			this._removeFromMainList(next);
			this._removeFromBucket(next);
			this._release(next);
			this._addToBucket(block);
		} else {
			this._addToBucket(block);
		}
	}
	grow(newCapacity) {
		if (newCapacity <= this._capacity) return;
		const added = newCapacity - this._capacity;
		this._capacity = newCapacity;
		this._freeSize += added;
		if (this._tailAll && this._tailAll._free) {
			this._tailAll._size += added;
			this._rebucket(this._tailAll);
		} else {
			const block = this._obtain(this._capacity - added, added, true);
			this._insertAfterInMainList(block, this._tailAll);
			this._addToBucket(block);
		}
	}
	defrag(maxMoves = 0, result = /* @__PURE__ */ new Set()) {
		result.clear();
		if (this._freeRegionCount === 0) return result;
		if (maxMoves === 0) {
			this._defragFull(result);
		} else {
			this._defragIncremental(maxMoves, result);
		}
		return result;
	}
	_defragFull(result) {
		for (let b = 0; b < this._freeBucketHeads.length; b++) {
			let node = this._freeBucketHeads[b];
			while (node) {
				const nextFree = node._nextFree;
				this._removeFromMainList(node);
				node._prevFree = null;
				node._nextFree = null;
				node._bucket = -1;
				this._pool.push(node);
				node = nextFree;
			}
			this._freeBucketHeads[b] = null;
		}
		this._freeRegionCount = 0;
		let offset3 = 0;
		let block = this._headAll;
		while (block) {
			if (block._offset !== offset3) {
				block._offset = offset3;
				result.add(block);
			}
			offset3 += block._size;
			block = block._next;
		}
		const remaining = this._capacity - offset3;
		if (remaining > 0) {
			const freeBlock = this._obtain(offset3, remaining, true);
			this._insertAfterInMainList(freeBlock, this._tailAll);
			this._addToBucket(freeBlock);
		}
	}
	_defragIncremental(maxMoves, result) {
		const phase1Moves = Math.ceil(maxMoves / 2);
		const phase2Moves = maxMoves - phase1Moves;
		for (let i2 = 0; i2 < phase1Moves; i2++) {
			let lastAlloc = this._tailAll;
			while (lastAlloc && lastAlloc._free) lastAlloc = lastAlloc._prev;
			if (!lastAlloc) break;
			const gap = this._findFreeBlock(lastAlloc._size);
			if (!gap || gap._offset >= lastAlloc._offset) break;
			this._moveBlock(lastAlloc, gap);
			result.add(lastAlloc);
		}
		let block = this._headAll;
		for (let i2 = 0; i2 < phase2Moves && block; ) {
			const next = block._next;
			if (block._free && next && !next._free) {
				const allocBlock = next;
				const freeBlock = block;
				allocBlock._offset = freeBlock._offset;
				freeBlock._offset = allocBlock._offset + allocBlock._size;
				const a = freeBlock._prev;
				const b = allocBlock._next;
				allocBlock._prev = a;
				allocBlock._next = freeBlock;
				freeBlock._prev = allocBlock;
				freeBlock._next = b;
				if (a) a._next = allocBlock;
				else this._headAll = allocBlock;
				if (b) b._prev = freeBlock;
				else this._tailAll = freeBlock;
				if (freeBlock._next && freeBlock._next._free) {
					const right2 = freeBlock._next;
					freeBlock._size += right2._size;
					this._removeFromMainList(right2);
					this._removeFromBucket(right2);
					this._release(right2);
					this._rebucket(freeBlock);
				}
				result.add(allocBlock);
				i2++;
				block = freeBlock._next;
			} else {
				block = next;
			}
		}
	}
	_moveBlock(block, gap) {
		const blockSize = block._size;
		const newOffset = gap._offset;
		const prev = block._prev;
		this._removeFromMainList(block);
		const freed = this._obtain(block._offset, blockSize, true);
		this._insertAfterInMainList(freed, prev);
		this._addToBucket(freed);
		if (freed._next && freed._next._free) {
			const right2 = freed._next;
			freed._size += right2._size;
			this._removeFromMainList(right2);
			this._removeFromBucket(right2);
			this._release(right2);
			this._rebucket(freed);
		}
		if (freed._prev && freed._prev._free) {
			const left = freed._prev;
			left._size += freed._size;
			this._removeFromMainList(freed);
			this._removeFromBucket(freed);
			this._release(freed);
			this._rebucket(left);
		}
		block._offset = newOffset;
		if (gap._size === blockSize) {
			const gapPrev = gap._prev;
			this._removeFromMainList(gap);
			this._removeFromBucket(gap);
			this._release(gap);
			this._insertAfterInMainList(block, gapPrev);
		} else {
			gap._offset += blockSize;
			gap._size -= blockSize;
			this._rebucket(gap);
			this._insertAfterInMainList(block, gap._prev);
		}
	}
	updateAllocation(toFree, toAllocate) {
		for (let i2 = 0; i2 < toFree.length; i2++) {
			this.free(toFree[i2]);
		}
		for (let i2 = 0; i2 < toAllocate.length; i2++) {
			const size = toAllocate[i2];
			const block = this.allocate(size);
			if (block) {
				toAllocate[i2] = block;
			} else {
				let totalRemaining = size;
				for (let j = i2 + 1; j < toAllocate.length; j++) {
					totalRemaining += toAllocate[j];
				}
				const neededCapacity = this._usedSize + totalRemaining;
				const headroomCapacity = Math.ceil(neededCapacity * this._growMultiplier);
				if (headroomCapacity > this._capacity) {
					this.grow(headroomCapacity);
				}
				this.defrag(0);
				for (let j = i2; j < toAllocate.length; j++) {
					const s2 = toAllocate[j];
					const b = this.allocate(s2);
					toAllocate[j] = b;
				}
				return true;
			}
		}
		return false;
	}
};

var tmpSize2 = new Vec2();
var subDrawDataArray = new Uint32Array(0);
var _fullRangeInterval = [0, 0];
var GSplatInfo = class {
	device;
	resource;
	node;
	lodIndex;
	placementId;
	allocId;
	parentPlacementId;
	numSplats;
	activeSplats = 0;
	intervals = [];
	intervalOffsets = [];
	intervalAllocIds = [];
	intervalNodeIndices = [];
	previousWorldTransform = new Mat4();
	aabb = new BoundingBox();
	subDrawTexture = null;
	subDrawCount = 0;
	numBoundsEntries = 0;
	boundsBaseIndex = 0;
	octreeNodes = null;
	nodeInfos = null;
	colorAccumulatedTranslation = 0;
	parameters = null;
	getWorkBufferModifier = null;
	getInstanceStreams = null;
	_getDirtySource = null;
	_lastDirtyVersion = -1;
	_lastFormatVersion = -1;
	constructor(device, resource, placement, octreeNodes = null, nodeInfos = null) {
		this.device = device;
		this.resource = resource;
		this.node = placement.node;
		this.lodIndex = placement.lodIndex;
		this.placementId = placement.id;
		this.allocId = placement.allocId;
		this.parentPlacementId = octreeNodes && placement.parentPlacement ? placement.parentPlacement.allocId : placement.allocId;
		this.numSplats = resource.numSplats;
		this.aabb.copy(placement.aabb);
		this.parameters = placement.parameters;
		this.getWorkBufferModifier = () => placement.workBufferModifier;
		this.getInstanceStreams = () => placement.streams;
		this._getDirtySource = () => placement.parentPlacement ?? placement;
		this.octreeNodes = octreeNodes;
		this.nodeInfos = nodeInfos;
		this.updateIntervals(placement.intervals);
	}
	destroy() {
		this.intervals.length = 0;
		this.intervalOffsets.length = 0;
		this.intervalAllocIds.length = 0;
		this.intervalNodeIndices.length = 0;
		this.subDrawTexture?.destroy();
		this.subDrawTexture = null;
		this.subDrawCount = 0;
	}
	setLayout(intervalOffsets) {
		this.intervalOffsets = intervalOffsets;
		this.subDrawTexture?.destroy();
		this.subDrawTexture = null;
		this.subDrawCount = 0;
	}
	ensureSubDrawTexture(textureWidth) {
		if (!this.subDrawTexture && textureWidth > 0) {
			this.updateSubDraws(textureWidth);
		}
	}
	updateIntervals(intervals) {
		const resource = this.resource;
		this.intervals.length = 0;
		this.intervalAllocIds.length = 0;
		this.intervalNodeIndices.length = 0;
		this.activeSplats = resource.numSplats;
		if (intervals.size > 0) {
			let totalCount = 0;
			let k = 0;
			this.intervals.length = intervals.size * 2;
			for (const [nodeIndex, interval] of intervals) {
				this.intervals[k++] = interval.x;
				this.intervals[k++] = interval.y + 1;
				totalCount += interval.y - interval.x + 1;
				if (this.nodeInfos) {
					this.intervalAllocIds.push(this.nodeInfos[nodeIndex].allocId);
					this.intervalNodeIndices.push(nodeIndex);
				}
			}
			if (this.octreeNodes) {
				this.activeSplats = totalCount;
				this.numBoundsEntries = this.octreeNodes.length;
			} else if (totalCount === this.numSplats) {
				this.intervals.length = 0;
			} else {
				this.activeSplats = totalCount;
			}
		} else {
			this.numBoundsEntries = 1;
			this.intervalAllocIds.push(this.allocId);
			const totalCapacity = resource.maxSplats;
			if (totalCapacity && this.activeSplats < totalCapacity) {
				this.intervals[0] = 0;
				this.intervals[1] = this.activeSplats;
			}
		}
	}
	appendSubDraws(subDrawData, subDrawCount, sourceBase, size, targetOffset, textureWidth) {
		let remaining = size;
		let row = targetOffset / textureWidth | 0;
		const col = targetOffset % textureWidth;
		if (col > 0) {
			const count = Math.min(remaining, textureWidth - col);
			const idx = subDrawCount * 4;
			subDrawData[idx] = row | 1 << 16;
			subDrawData[idx + 1] = col;
			subDrawData[idx + 2] = col + count;
			subDrawData[idx + 3] = sourceBase;
			subDrawCount++;
			sourceBase += count;
			remaining -= count;
			row++;
		}
		const fullRows = remaining / textureWidth | 0;
		if (fullRows > 0) {
			const idx = subDrawCount * 4;
			subDrawData[idx] = row | fullRows << 16;
			subDrawData[idx + 1] = 0;
			subDrawData[idx + 2] = textureWidth;
			subDrawData[idx + 3] = sourceBase;
			subDrawCount++;
			sourceBase += fullRows * textureWidth;
			remaining -= fullRows * textureWidth;
			row += fullRows;
		}
		if (remaining > 0) {
			const idx = subDrawCount * 4;
			subDrawData[idx] = row | 1 << 16;
			subDrawData[idx + 1] = 0;
			subDrawData[idx + 2] = remaining;
			subDrawData[idx + 3] = sourceBase;
			subDrawCount++;
		}
		return subDrawCount;
	}
	updateSubDraws(textureWidth) {
		let intervals = this.intervals;
		let numIntervals = intervals.length / 2;
		if (numIntervals === 0) {
			_fullRangeInterval[0] = 0;
			_fullRangeInterval[1] = this.activeSplats;
			intervals = _fullRangeInterval;
			numIntervals = 1;
		}
		const maxSubDraws = numIntervals * 3;
		const requiredSize = maxSubDraws * 4;
		if (subDrawDataArray.length < requiredSize) {
			subDrawDataArray = new Uint32Array(requiredSize);
		}
		const subDrawData = subDrawDataArray;
		let subDrawCount = 0;
		for (let i2 = 0; i2 < numIntervals; i2++) {
			subDrawCount = this.appendSubDraws(
				subDrawData,
				subDrawCount,
				intervals[i2 * 2],
				intervals[i2 * 2 + 1] - intervals[i2 * 2],
				this.intervalOffsets[i2],
				textureWidth
			);
		}
		this.subDrawCount = subDrawCount;
		const { x: texWidth, y: texHeight } = TextureUtils.calcTextureSize(subDrawCount, tmpSize2);
		this.subDrawTexture = Texture.createDataTexture2D(this.device, "subDrawData", texWidth, texHeight, PIXELFORMAT_RGBA32U);
		const texData = this.subDrawTexture.lock();
		texData.set(subDrawData.subarray(0, subDrawCount * 4));
		this.subDrawTexture.unlock();
	}
	update() {
		const worldMatrix = this.node.getWorldTransform();
		const worldMatrixChanged = !this.previousWorldTransform.equals(worldMatrix);
		if (worldMatrixChanged) {
			this.previousWorldTransform.copy(worldMatrix);
		}
		let dirty = worldMatrixChanged;
		const source = this._getDirtySource();
		if (this._lastDirtyVersion !== source.dirtyVersion) {
			this._lastDirtyVersion = source.dirtyVersion;
			dirty = true;
		}
		if (source.workBufferUpdate === WORKBUFFER_UPDATE_ALWAYS) {
			dirty = true;
		}
		const format = this.resource?.format;
		if (format && this._lastFormatVersion !== format.extraStreamsVersion) {
			this._lastFormatVersion = format.extraStreamsVersion;
			dirty = true;
		}
		return dirty;
	}
	writeBoundsSpheres(data2, offset3) {
		if (this.octreeNodes) {
			for (let i2 = 0; i2 < this.octreeNodes.length; i2++) {
				const s2 = this.octreeNodes[i2].boundingSphere;
				data2[offset3++] = s2.x;
				data2[offset3++] = s2.y;
				data2[offset3++] = s2.z;
				data2[offset3++] = s2.w;
			}
		} else {
			const aabb3 = this.resource.aabb;
			const he = aabb3.halfExtents;
			const r = Math.sqrt(he.x * he.x + he.y * he.y + he.z * he.z);
			data2[offset3++] = aabb3.center.x;
			data2[offset3++] = aabb3.center.y;
			data2[offset3++] = aabb3.center.z;
			data2[offset3++] = r;
		}
	}
	get hasSphericalHarmonics() {
		return this.resource.gsplatData?.shBands > 0;
	}
};

var GsplatAllocId = new NumericIds();

var GSplatPlacement = class {
	resource;
	node;
	intervals = /* @__PURE__ */ new Map();
	id = 0;
	allocId = GsplatAllocId.get();
	lodIndex = 0;
	_lodBaseDistance = 5;
	_lodMultiplier = 3;
	set lodBaseDistance(value) {
		if (this._lodBaseDistance !== value) {
			this._lodBaseDistance = value;
			this.lodDirty = true;
		}
	}
	get lodBaseDistance() {
		return this._lodBaseDistance;
	}
	set lodMultiplier(value) {
		if (this._lodMultiplier !== value) {
			this._lodMultiplier = value;
			this.lodDirty = true;
		}
	}
	get lodMultiplier() {
		return this._lodMultiplier;
	}
	_lodRangeMin = 0;
	_lodRangeMax = 99;
	set lodRangeMin(value) {
		if (this._lodRangeMin !== value) {
			this._lodRangeMin = value;
			this.lodDirty = true;
		}
	}
	get lodRangeMin() {
		return this._lodRangeMin;
	}
	set lodRangeMax(value) {
		if (this._lodRangeMax !== value) {
			this._lodRangeMax = value;
			this.lodDirty = true;
		}
	}
	get lodRangeMax() {
		return this._lodRangeMax;
	}
	_aabb = null;
	parameters = null;
	_streams = null;
	lodDirty = false;
	dirtyVersion = 0;
	_workBufferUpdate = WORKBUFFER_UPDATE_AUTO;
	_workBufferModifier = null;
	parentPlacement = null;
	constructor(resource, node, lodIndex = 0, parameters = null, parentPlacement = null, id14 = null) {
		this.id = id14 ?? parentPlacement?.id ?? 0;
		this.resource = resource;
		this.node = node;
		this.lodIndex = lodIndex;
		this.parameters = parameters ?? parentPlacement?.parameters ?? null;
		this.parentPlacement = parentPlacement;
	}
	destroy() {
		this._streams?.destroy();
		this._streams = null;
		this.intervals.clear();
		this.resource = null;
	}
	set workBufferModifier(value) {
		this._workBufferModifier = value;
		this.dirtyVersion++;
	}
	get workBufferModifier() {
		return this.parentPlacement?.workBufferModifier ?? this._workBufferModifier;
	}
	set workBufferUpdate(value) {
		if (value === WORKBUFFER_UPDATE_ONCE) {
			this.dirtyVersion++;
		} else {
			this._workBufferUpdate = value;
		}
	}
	get workBufferUpdate() {
		return this._workBufferUpdate;
	}
	markDirty() {
		this.dirtyVersion++;
	}
	set aabb(aabb3) {
		this._aabb = aabb3?.clone() ?? null;
	}
	get aabb() {
		const aabb3 = this._aabb ?? this.resource?.aabb;
		return aabb3;
	}
	getLodDistance(level) {
		return this.lodBaseDistance * Math.pow(this.lodMultiplier, level);
	}
	getInstanceTexture(name, device) {
		const resource = this.resource;
		if (!resource?.format) {
			return void 0;
		}
		if (!this._streams && resource.format.instanceStreams.length > 0) {
			this._streams = new GSplatStreams(device, true);
			this._streams.textureDimensions.copy(resource.streams.textureDimensions);
			this._streams.syncWithFormat(resource.format);
		}
		return this._streams?.getTexture(name);
	}
	get streams() {
		return this.parentPlacement?.streams ?? this._streams;
	}
	ensureInstanceStreams(device) {
		const resource = this.resource;
		if (!resource?.format) {
			return;
		}
		if (!this._streams && resource.format.instanceStreams.length > 0) {
			this._streams = new GSplatStreams(device, true);
			this._streams.textureDimensions.copy(resource.streams.textureDimensions);
			this._streams.syncWithFormat(resource.format);
		}
	}
};

var ALPHA_VISIBILITY_THRESHOLD = 1 / 255;
var NUM_BUCKETS = 64;

var _invWorldMat = new Mat4();
var _localCameraPos = new Vec3();
var _localCameraFwd = new Vec3();
var _tempCompletedUrls = [];
var _tempDebugAabb = new BoundingBox();
var REF_TAN_HALF_FOV = Math.tan(22.5 * math.DEG_TO_RAD);
var _lodColors = [
	new Color(1, 0, 0),
	new Color(0, 1, 0),
	new Color(0, 0, 1),
	new Color(1, 1, 0),
	new Color(1, 0, 1)
];
var NodeInfo = class {
	currentLod = -1;
	optimalLod = -1;
	worldDistance = 0;
	colorAccumulatedTranslation = 0;
	inst = null;
	lods = null;
	budgetBucket = 0;
	allocId = GsplatAllocId.get();
	resetLod() {
		this.currentLod = -1;
		this.optimalLod = -1;
	}
};
var GSplatOctreeInstance = class {
	octree;
	placement;
	activePlacements = /* @__PURE__ */ new Set();
	dirtyModifiedPlacements = false;
	dirtyPlacementSetChanged = false;
	device;
	nodeInfos;
	filePlacements;
	pending = /* @__PURE__ */ new Set();
	pendingDecrements = /* @__PURE__ */ new Map();
	removedCandidates = /* @__PURE__ */ new Set();
	rangeMin = 0;
	rangeMax = 0;
	previousPosition = new Vec3();
	needsLodUpdate = false;
	prefetchPending = /* @__PURE__ */ new Set();
	pendingVisibleAdds = /* @__PURE__ */ new Map();
	get pendingLoadCount() {
		let count = this.pending.size + this.prefetchPending.size;
		if (this.octree.environmentUrl && !this.environmentPlacement) {
			count++;
		}
		return count;
	}
	environmentPlacement = null;
	_deviceLostEvent = null;
	_lodMinDistThresholds = null;
	constructor(device, octree, placement) {
		this.device = device;
		this.octree = octree;
		this.placement = placement;
		this.nodeInfos = new Array(octree.nodes.length);
		for (let i2 = 0; i2 < octree.nodes.length; i2++) {
			const nodeInfo = new NodeInfo();
			nodeInfo.inst = this;
			this.nodeInfos[i2] = nodeInfo;
		}
		const numFiles = octree.files.length;
		this.filePlacements = new Array(numFiles).fill(null);
		if (octree.environmentUrl) {
			octree.incEnvironmentRefCount();
			octree.ensureEnvironmentResource();
		}
		this._deviceLostEvent = device.on("devicelost", this._onDeviceLost, this);
	}
	destroy(skipRefCounting = false) {
		if (!skipRefCounting && this.octree && !this.octree.destroyed) {
			const filesToDecRef = this.getFileDecrements();
			for (const fileIndex of filesToDecRef) {
				this.octree.decRefCount(fileIndex, 0);
			}
			for (const fileIndex of this.pending) {
				if (!this.filePlacements[fileIndex]) {
					this.octree.unloadResource(fileIndex);
				}
			}
			for (const fileIndex of this.prefetchPending) {
				if (!this.filePlacements[fileIndex]) {
					this.octree.unloadResource(fileIndex);
				}
			}
			if (this.environmentPlacement) {
				this.octree.decEnvironmentRefCount();
			}
		}
		this.pending.clear();
		this.pendingDecrements.clear();
		this.filePlacements.length = 0;
		if (this.environmentPlacement) {
			this.activePlacements.delete(this.environmentPlacement);
			this.environmentPlacement = null;
		}
		this._deviceLostEvent?.off();
		this._deviceLostEvent = null;
	}
	_onDeviceLost() {
		for (let i2 = 0; i2 < this.filePlacements.length; i2++) {
			if (this.filePlacements[i2]) {
				this.octree.decRefCount(i2, 0);
			}
		}
		this.filePlacements.fill(null);
		this.activePlacements.clear();
		this.pending.clear();
		this.pendingDecrements.clear();
		this.removedCandidates.clear();
		this.prefetchPending.clear();
		this.pendingVisibleAdds.clear();
		for (const nodeInfo of this.nodeInfos) {
			nodeInfo.resetLod();
		}
		if (this.environmentPlacement) {
			this.activePlacements.delete(this.environmentPlacement);
			this.environmentPlacement = null;
			this.octree.unloadEnvironmentResource();
		}
		this.dirtyModifiedPlacements = true;
		this.dirtyPlacementSetChanged = true;
		this.needsLodUpdate = true;
	}
	getFileDecrements() {
		const toRelease = [];
		for (let i2 = 0; i2 < this.filePlacements.length; i2++) {
			if (this.filePlacements[i2]) {
				toRelease.push(i2);
			}
		}
		return toRelease;
	}
	selectDesiredLodIndex(node, optimalLodIndex, maxLod, lodUnderfillLimit) {
		if (lodUnderfillLimit > 0) {
			const allowedMaxCoarseLod = Math.min(maxLod, optimalLodIndex + lodUnderfillLimit);
			for (let lod = optimalLodIndex; lod <= allowedMaxCoarseLod; lod++) {
				const fi = node.lods[lod].fileIndex;
				if (fi !== -1 && this.octree.getFileResource(fi)) {
					return lod;
				}
			}
			for (let lod = allowedMaxCoarseLod; lod >= optimalLodIndex; lod--) {
				const fi = node.lods[lod].fileIndex;
				if (fi !== -1) {
					return lod;
				}
			}
		}
		return optimalLodIndex;
	}
	prefetchNextLod(node, desiredLodIndex, optimalLodIndex) {
		if (desiredLodIndex === -1 || optimalLodIndex === -1) return;
		if (desiredLodIndex === optimalLodIndex) {
			const fi = node.lods[optimalLodIndex].fileIndex;
			if (fi !== -1) {
				this.octree.ensureFileResource(fi);
				if (!this.octree.getFileResource(fi)) {
					this.prefetchPending.add(fi);
				}
			}
			return;
		}
		const targetLod = Math.max(optimalLodIndex, desiredLodIndex - 1);
		for (let lod = targetLod; lod >= optimalLodIndex; lod--) {
			const fi = node.lods[lod].fileIndex;
			if (fi !== -1) {
				this.octree.ensureFileResource(fi);
				if (!this.octree.getFileResource(fi)) {
					this.prefetchPending.add(fi);
				}
				break;
			}
		}
	}
	updateLod(cameraNode, params) {
		const maxLod = this.octree.lodLevels - 1;
		const { lodBaseDistance, lodMultiplier } = this.placement;
		const { lodRangeMin, lodRangeMax } = this.placement;
		const rangeMin = Math.max(0, Math.min(lodRangeMin ?? 0, maxLod));
		const rangeMax = Math.max(rangeMin, Math.min(lodRangeMax ?? maxLod, maxLod));
		const uniformScale2 = this.placement.node.getWorldTransform().getScale().x;
		this.evaluateNodeLods(cameraNode, maxLod, lodBaseDistance, lodMultiplier, rangeMin, rangeMax, params, uniformScale2, false);
		this.applyLodChanges(maxLod, params);
	}
	_ensureLodMinDistThresholds(maxLod, d0, m) {
		const needLen = maxLod + 1;
		let buf = this._lodMinDistThresholds;
		if (!buf || buf.length < needLen) {
			buf = new Float32Array(needLen);
			this._lodMinDistThresholds = buf;
		}
		let t = d0;
		buf[1] = t;
		for (let k = 2; k <= maxLod; k++) {
			t *= m;
			buf[k] = t;
		}
		return buf;
	}
	evaluateNodeLods(cameraNode, maxLod, lodBaseDistance, lodMultiplier, rangeMin, rangeMax, params, uniformScale2, accumulateSplats = true, globalMaxDistanceForBuckets = 0) {
		const { lodBehindPenalty } = params;
		const camera = cameraNode.camera;
		let tanHalfVFov = Math.tan(camera.fov * 0.5 * math.DEG_TO_RAD);
		if (camera.horizontalFov) {
			tanHalfVFov /= camera.aspectRatio;
		}
		const tanHalfHFov = tanHalfVFov * camera.aspectRatio;
		const fovScale = Math.min(tanHalfVFov, tanHalfHFov) / REF_TAN_HALF_FOV;
		const worldCameraPosition = cameraNode.getPosition();
		const octreeWorldTransform = this.placement.node.getWorldTransform();
		_invWorldMat.copy(octreeWorldTransform).invert();
		const localCameraPosition = _invWorldMat.transformPoint(worldCameraPosition, _localCameraPos);
		const worldCameraForward = cameraNode.forward;
		const localCameraForward = _invWorldMat.transformVector(worldCameraForward, _localCameraFwd).normalize();
		const nodes = this.octree.nodes;
		const nodeInfos = this.nodeInfos;
		const boundsFlat = this.octree.nodeBoundsMinMax;
		const px = localCameraPosition.x;
		const py = localCameraPosition.y;
		const pz = localCameraPosition.z;
		const fwx = localCameraForward.x;
		const fwy = localCameraForward.y;
		const fwz = localCameraForward.z;
		let totalSplats = 0;
		let minDistBuf = null;
		if (maxLod >= 1) {
			minDistBuf = this._ensureLodMinDistThresholds(maxLod, lodBaseDistance, lodMultiplier);
		}
		const bucketScale = globalMaxDistanceForBuckets > 0 ? NUM_BUCKETS / Math.sqrt(globalMaxDistanceForBuckets) : 0;
		for (let nodeIndex = 0; nodeIndex < nodes.length; nodeIndex++) {
			const nodeInfo = nodeInfos[nodeIndex];
			const b = nodeIndex * 6;
			let qx = px;
			const minX = boundsFlat[b];
			const maxX = boundsFlat[b + 3];
			if (qx < minX) qx = minX;
			else if (qx > maxX) qx = maxX;
			let qy = py;
			const minY = boundsFlat[b + 1];
			const maxY = boundsFlat[b + 4];
			if (qy < minY) qy = minY;
			else if (qy > maxY) qy = maxY;
			let qz = pz;
			const minZ = boundsFlat[b + 2];
			const maxZ = boundsFlat[b + 5];
			if (qz < minZ) qz = minZ;
			else if (qz > maxZ) qz = maxZ;
			const dx = qx - px;
			const dy = qy - py;
			const dz = qz - pz;
			const actualDistance = Math.sqrt(dx * dx + dy * dy + dz * dz);
			let penalizedDistance = actualDistance;
			if (lodBehindPenalty > 1 && actualDistance > 0.01) {
				const dotOverDistance = (fwx * dx + fwy * dy + fwz * dz) / actualDistance;
				if (dotOverDistance < 0) {
					const t = -dotOverDistance;
					const factor = 1 + t * (lodBehindPenalty - 1);
					penalizedDistance = actualDistance * factor;
				}
			}
			const fovAdjustedDistance = penalizedDistance * fovScale;
			let optimalLodIndex;
			if (maxLod === 0 || fovAdjustedDistance < lodBaseDistance) {
				optimalLodIndex = 0;
			} else {
				optimalLodIndex = maxLod;
				while (optimalLodIndex > 1 && fovAdjustedDistance < minDistBuf[optimalLodIndex]) {
					optimalLodIndex--;
				}
			}
			if (optimalLodIndex < rangeMin) optimalLodIndex = rangeMin;
			if (optimalLodIndex > rangeMax) optimalLodIndex = rangeMax;
			nodeInfo.optimalLod = optimalLodIndex;
			nodeInfo.worldDistance = fovAdjustedDistance * uniformScale2;
			if (bucketScale > 0 && optimalLodIndex >= 0) {
				const bucket = Math.sqrt(nodeInfo.worldDistance) * bucketScale >>> 0;
				nodeInfo.budgetBucket = bucket < NUM_BUCKETS ? bucket : NUM_BUCKETS - 1;
			}
			if (accumulateSplats) {
				const lod = nodes[nodeIndex].lods[optimalLodIndex];
				if (lod && lod.count) {
					totalSplats += lod.count;
				}
			}
		}
		return totalSplats;
	}
	evaluateOptimalLods(cameraNode, params, budgetScale = 1, globalMaxDistanceForBuckets = 0) {
		const maxLod = this.octree.lodLevels - 1;
		const { lodBaseDistance, lodMultiplier } = this.placement;
		const { lodRangeMin, lodRangeMax } = this.placement;
		const rangeMin = Math.max(0, Math.min(lodRangeMin ?? 0, maxLod));
		const rangeMax = Math.max(rangeMin, Math.min(lodRangeMax ?? maxLod, maxLod));
		this.rangeMin = rangeMin;
		this.rangeMax = rangeMax;
		const uniformScale2 = this.placement.node.getWorldTransform().getScale().x;
		const effectiveBase = lodBaseDistance * budgetScale;
		const effectiveMult = Math.max(1.2, lodMultiplier * Math.pow(budgetScale, -0.2));
		return this.evaluateNodeLods(
			cameraNode,
			maxLod,
			effectiveBase,
			effectiveMult,
			rangeMin,
			rangeMax,
			params,
			uniformScale2,
			true,
			globalMaxDistanceForBuckets
		);
	}
	applyLodChanges(maxLod, params) {
		const nodes = this.octree.nodes;
		const { lodUnderfillLimit = 0 } = params;
		for (let nodeIndex = 0; nodeIndex < nodes.length; nodeIndex++) {
			const node = nodes[nodeIndex];
			const nodeInfo = this.nodeInfos[nodeIndex];
			const optimalLodIndex = nodeInfo.optimalLod;
			const currentLodIndex = nodeInfo.currentLod;
			const desiredLodIndex = this.selectDesiredLodIndex(node, optimalLodIndex, maxLod, lodUnderfillLimit);
			if (desiredLodIndex !== currentLodIndex) {
				const currentFileIndex = currentLodIndex >= 0 ? node.lods[currentLodIndex].fileIndex : -1;
				const desiredFileIndex = desiredLodIndex >= 0 ? node.lods[desiredLodIndex].fileIndex : -1;
				const wasVisible = currentFileIndex !== -1;
				const willBeVisible = desiredFileIndex !== -1;
				const pendingEntry = this.pendingDecrements.get(nodeIndex);
				if (pendingEntry) {
					if (pendingEntry.newFileIndex !== desiredFileIndex) {
						const prevPendingPlacement = this.filePlacements[pendingEntry.newFileIndex];
						if (prevPendingPlacement) {
							this.decrementFileRef(pendingEntry.newFileIndex, nodeIndex);
						}
						if (wasVisible && willBeVisible) {
							this.pendingDecrements.set(nodeIndex, { oldFileIndex: pendingEntry.oldFileIndex, newFileIndex: desiredFileIndex });
						} else {
							this.pendingDecrements.delete(nodeIndex);
						}
					}
				}
				if (!wasVisible && willBeVisible) {
					const prevPendingFi = this.pendingVisibleAdds.get(nodeIndex);
					if (prevPendingFi !== void 0 && prevPendingFi !== desiredFileIndex) {
						this.decrementFileRef(prevPendingFi, nodeIndex);
						this.pendingVisibleAdds.delete(nodeIndex);
					}
					this.incrementFileRef(desiredFileIndex, nodeIndex, desiredLodIndex);
					const newPlacement = this.filePlacements[desiredFileIndex];
					if (newPlacement?.resource) {
						nodeInfo.currentLod = desiredLodIndex;
						this.pendingVisibleAdds.delete(nodeIndex);
					} else {
						this.pendingVisibleAdds.set(nodeIndex, desiredFileIndex);
					}
				} else if (wasVisible && !willBeVisible) {
					const pendingEntry2 = this.pendingDecrements.get(nodeIndex);
					if (pendingEntry2) {
						this.decrementFileRef(pendingEntry2.newFileIndex, nodeIndex);
						this.pendingDecrements.delete(nodeIndex);
					}
					this.decrementFileRef(currentFileIndex, nodeIndex);
					nodeInfo.currentLod = -1;
					this.pendingVisibleAdds.delete(nodeIndex);
				} else if (wasVisible && willBeVisible) {
					this.incrementFileRef(desiredFileIndex, nodeIndex, desiredLodIndex);
					const newPlacement = this.filePlacements[desiredFileIndex];
					if (newPlacement?.resource) {
						this.decrementFileRef(currentFileIndex, nodeIndex);
						this.pendingDecrements.delete(nodeIndex);
						nodeInfo.currentLod = desiredLodIndex;
						this.pendingVisibleAdds.delete(nodeIndex);
					} else {
						this.pendingDecrements.set(nodeIndex, { oldFileIndex: currentFileIndex, newFileIndex: desiredFileIndex });
						this.pendingVisibleAdds.delete(nodeIndex);
					}
				}
			}
			this.prefetchNextLod(node, desiredLodIndex, optimalLodIndex);
		}
	}
	incrementFileRef(fileIndex, nodeIndex, lodIndex) {
		if (fileIndex === -1) return;
		let placement = this.filePlacements[fileIndex];
		if (!placement) {
			placement = new GSplatPlacement(null, this.placement.node, lodIndex, null, this.placement);
			this.filePlacements[fileIndex] = placement;
			const removeScheduled = this.removedCandidates.delete(fileIndex);
			if (!removeScheduled) {
				this.octree.incRefCount(fileIndex);
			}
			if (!this.addFilePlacement(fileIndex)) {
				this.octree.ensureFileResource(fileIndex);
				this.pending.add(fileIndex);
			}
		}
		const nodes = this.octree.nodes;
		const node = nodes[nodeIndex];
		const lod = node.lods[lodIndex];
		const interval = new Vec2(lod.offset, lod.offset + lod.count - 1);
		placement.intervals.set(nodeIndex, interval);
		this.dirtyModifiedPlacements = true;
	}
	decrementFileRef(fileIndex, nodeIndex) {
		if (fileIndex === -1) return;
		const placement = this.filePlacements[fileIndex];
		if (!placement) {
			return;
		}
		if (placement) {
			placement.intervals.delete(nodeIndex);
			this.dirtyModifiedPlacements = true;
			if (placement.intervals.size === 0) {
				if (placement.resource) {
					this.activePlacements.delete(placement);
					if (this.activePlacements.size === 0) {
						this.dirtyPlacementSetChanged = true;
					}
				}
				this.removedCandidates.add(fileIndex);
				this.filePlacements[fileIndex] = null;
				this.pending.delete(fileIndex);
			}
		}
	}
	addFilePlacement(fileIndex) {
		const res = this.octree.getFileResource(fileIndex);
		if (res) {
			const placement = this.filePlacements[fileIndex];
			if (placement) {
				placement.resource = res;
				if (this.activePlacements.size === 0) {
					this.dirtyPlacementSetChanged = true;
				}
				this.activePlacements.add(placement);
				this.dirtyModifiedPlacements = true;
				this.removedCandidates.delete(fileIndex);
				return true;
			}
		}
		return false;
	}
	testMoved(threshold) {
		const position5 = this.placement.node.getPosition();
		const length = position5.distance(this.previousPosition);
		if (length > threshold) {
			return true;
		}
		return false;
	}
	updateMoved() {
		this.previousPosition.copy(this.placement.node.getPosition());
	}
	update() {
		if (this.placement.lodDirty) {
			this.placement.lodDirty = false;
			this.needsLodUpdate = true;
		}
		if (this.pending.size) {
			for (const fileIndex of this.pending) {
				this.octree.ensureFileResource(fileIndex);
				if (this.addFilePlacement(fileIndex)) {
					_tempCompletedUrls.push(fileIndex);
					for (const [nodeIndex, { oldFileIndex, newFileIndex }] of this.pendingDecrements) {
						if (newFileIndex === fileIndex) {
							this.decrementFileRef(oldFileIndex, nodeIndex);
							this.pendingDecrements.delete(nodeIndex);
							let newLodIndex = 0;
							const nodeLods = this.octree.nodes[nodeIndex].lods;
							for (let li = 0; li < nodeLods.length; li++) {
								if (nodeLods[li].fileIndex === newFileIndex) {
									newLodIndex = li;
									break;
								}
							}
							this.nodeInfos[nodeIndex].currentLod = newLodIndex;
						}
					}
				}
			}
			if (_tempCompletedUrls.length > 0) {
				this.needsLodUpdate = true;
			}
			for (const fileIndex of _tempCompletedUrls) {
				this.pending.delete(fileIndex);
			}
			_tempCompletedUrls.length = 0;
		}
		this.pollPrefetchCompletions();
		if (this.octree.environmentUrl && !this.environmentPlacement) {
			this.octree.ensureEnvironmentResource();
			const envResource = this.octree.environmentResource;
			if (envResource) {
				this.environmentPlacement = new GSplatPlacement(envResource, this.placement.node, 0, null, this.placement);
				this.environmentPlacement.aabb.copy(envResource.aabb);
				this.activePlacements.add(this.environmentPlacement);
				this.dirtyModifiedPlacements = true;
				this.dirtyPlacementSetChanged = true;
				envResource.releaseTextureSources?.();
			}
		}
		const dirty = this.dirtyModifiedPlacements;
		this.dirtyModifiedPlacements = false;
		return dirty;
	}
	consumePlacementSetChanged() {
		const changed = this.dirtyPlacementSetChanged;
		this.dirtyPlacementSetChanged = false;
		return changed;
	}
	// debug render world space bounds for octree nodes based on current LOD selection
	debugRender(scene) {
	}
	consumeNeedsLodUpdate() {
		const v6 = this.needsLodUpdate;
		this.needsLodUpdate = false;
		return v6;
	}
	pollPrefetchCompletions() {
		if (this.prefetchPending.size) {
			for (const fileIndex of this.prefetchPending) {
				this.octree.ensureFileResource(fileIndex);
				if (this.octree.getFileResource(fileIndex)) {
					_tempCompletedUrls.push(fileIndex);
				}
			}
			if (_tempCompletedUrls.length > 0) {
				this.needsLodUpdate = true;
			}
			for (const fileIndex of _tempCompletedUrls) {
				this.prefetchPending.delete(fileIndex);
			}
			_tempCompletedUrls.length = 0;
		}
	}
};

var tmpMin = new Vec3();
var tmpMax = new Vec3();
var GSplatOctreeNode = class {
	lods;
	bounds = new BoundingBox();
	boundingSphere = new Vec4();
	constructor(lods, boundData) {
		this.lods = lods;
		tmpMin.set(boundData.min[0], boundData.min[1], boundData.min[2]);
		tmpMax.set(boundData.max[0], boundData.max[1], boundData.max[2]);
		this.bounds.setMinMax(tmpMin, tmpMax);
		const center2 = this.bounds.center;
		const he = this.bounds.halfExtents;
		const radius = Math.sqrt(he.x * he.x + he.y * he.y + he.z * he.z);
		this.boundingSphere.set(center2.x, center2.y, center2.z, radius);
	}
};

var _toDelete = [];
var GSplatOctree = class {
	nodes;
	nodeBoundsMinMax;
	files;
	lodLevels;
	assetFileUrl;
	fileResources = /* @__PURE__ */ new Map();
	fileRefCounts;
	cooldowns = /* @__PURE__ */ new Map();
	environmentUrl = null;
	environmentResource = null;
	environmentRefCount = 0;
	assetLoader = null;
	destroyed = false;
	cooldownTicks = 100;
	constructor(assetFileUrl, data2) {
		this.lodLevels = data2.lodLevels;
		this.assetFileUrl = assetFileUrl;
		const baseDir = path.getDirectory(assetFileUrl);
		this.files = data2.filenames.map((url) => ({
			url: path.isRelativePath(url) ? path.join(baseDir, url) : url,
			lodLevel: -1
		}));
		this.fileRefCounts = new Int32Array(this.files.length);
		if (data2.environment) {
			this.environmentUrl = path.isRelativePath(data2.environment) ? path.join(baseDir, data2.environment) : data2.environment;
		}
		const leafNodes = [];
		this._extractLeafNodes(data2.tree, leafNodes);
		this.nodes = leafNodes.map((nodeData) => {
			const lods = [];
			for (let i2 = 0; i2 < this.lodLevels; i2++) {
				const lodData = nodeData.lods[i2.toString()];
				if (lodData) {
					lods.push({
						file: this.files[lodData.file].url || "",
						fileIndex: lodData.file,
						offset: lodData.offset || 0,
						count: lodData.count || 0
					});
					this.files[lodData.file].lodLevel = i2;
				} else {
					lods.push({
						file: "",
						fileIndex: -1,
						offset: 0,
						count: 0
					});
				}
			}
			return new GSplatOctreeNode(lods, nodeData.bound);
		});
		const nodeCount = this.nodes.length;
		const boundsFlat = new Float32Array(nodeCount * 6);
		for (let i2 = 0; i2 < nodeCount; i2++) {
			const bounds = this.nodes[i2].bounds;
			const mn = bounds.getMin();
			const mx = bounds.getMax();
			const b = i2 * 6;
			boundsFlat[b + 0] = mn.x;
			boundsFlat[b + 1] = mn.y;
			boundsFlat[b + 2] = mn.z;
			boundsFlat[b + 3] = mx.x;
			boundsFlat[b + 4] = mx.y;
			boundsFlat[b + 5] = mx.z;
		}
		this.nodeBoundsMinMax = boundsFlat;
	}
	destroy() {
		this.destroyed = true;
		this.fileResources.clear();
		this.cooldowns.clear();
		this.assetLoader?.destroy();
		this.assetLoader = null;
		this.environmentResource = null;
	}
	_traceLodCounts() {
	}
	_extractLeafNodes(node, leafNodes) {
		if (node.lods) {
			leafNodes.push({
				lods: node.lods,
				bound: node.bound
			});
		} else if (node.children) {
			for (const child of node.children) {
				this._extractLeafNodes(child, leafNodes);
			}
		}
	}
	getFileResource(fileIndex) {
		return this.fileResources.get(fileIndex);
	}
	incRefCount(fileIndex) {
		const count = this.fileRefCounts[fileIndex] + 1;
		this.fileRefCounts[fileIndex] = count;
		this.cooldowns.delete(fileIndex);
	}
	decRefCount(fileIndex, cooldownTicks) {
		const count = this.fileRefCounts[fileIndex] - 1;
		this.fileRefCounts[fileIndex] = count;
		if (count === 0) {
			if (cooldownTicks === 0) {
				this.unloadResource(fileIndex);
			} else {
				this.cooldowns.set(fileIndex, cooldownTicks);
			}
		}
	}
	unloadResource(fileIndex) {
		if (!this.assetLoader) {
			return;
		}
		const fullUrl = this.files[fileIndex].url;
		this.assetLoader.unload(fullUrl);
		if (this.fileResources.has(fileIndex)) {
			this.fileResources.delete(fileIndex);
			this._traceLodCounts();
		}
	}
	updateCooldownTick(cooldownTicks) {
		this.cooldownTicks = cooldownTicks;
		if (this.cooldowns.size > 0) {
			this.cooldowns.forEach((remaining, fileIndex) => {
				if (remaining <= 1) {
					if (this.fileRefCounts[fileIndex] === 0) {
						this.unloadResource(fileIndex);
					}
					_toDelete.push(fileIndex);
				} else {
					this.cooldowns.set(fileIndex, remaining - 1);
				}
			});
			_toDelete.forEach((idx) => this.cooldowns.delete(idx));
			_toDelete.length = 0;
		}
	}
	ensureFileResource(fileIndex) {
		if (!this.assetLoader) {
			return;
		}
		if (this.fileResources.has(fileIndex)) {
			return;
		}
		const fullUrl = this.files[fileIndex].url;
		const res = this.assetLoader?.getResource(fullUrl);
		if (res) {
			this.fileResources.set(fileIndex, res);
			res.releaseTextureSources?.();
			if (this.fileRefCounts[fileIndex] === 0) {
				this.cooldowns.set(fileIndex, this.cooldownTicks);
			}
			this._traceLodCounts();
			return;
		}
		this.assetLoader?.load(fullUrl);
	}
	incEnvironmentRefCount() {
		this.environmentRefCount++;
	}
	decEnvironmentRefCount() {
		this.environmentRefCount--;
		if (this.environmentRefCount === 0) {
			this.unloadEnvironmentResource();
		}
	}
	ensureEnvironmentResource() {
		if (!this.assetLoader) {
			return;
		}
		if (!this.environmentUrl) {
			return;
		}
		if (this.environmentResource) {
			return;
		}
		const res = this.assetLoader.getResource(this.environmentUrl);
		if (res) {
			this.environmentResource = res;
			if (this.environmentRefCount === 0) {
				this.unloadEnvironmentResource();
			}
			return;
		}
		this.assetLoader.load(this.environmentUrl);
	}
	unloadEnvironmentResource() {
		if (!this.assetLoader) {
			return;
		}
		if (this.environmentResource && this.environmentUrl) {
			this.assetLoader.unload(this.environmentUrl);
			this.environmentResource = null;
		}
	}
};

var GSplatOctreeResource = class {
	aabb = new BoundingBox();
	centersVersion = 0;
	octree;
	_numSplats = null;
	data;
	constructor(assetFileUrl, data2, assetLoader) {
		this.octree = new GSplatOctree(assetFileUrl, data2);
		this.octree.assetLoader = assetLoader;
		this.aabb.setMinMax(new Vec3(data2.tree.bound.min), new Vec3(data2.tree.bound.max));
		this.data = data2;
		this.data.tree = null;
	}
	get numSplats() {
		if (this._numSplats === null) {
			let total = 0;
			const nodes = this.octree?.nodes ?? [];
			for (let i2 = 0; i2 < nodes.length; i2++) {
				total += nodes[i2].lods[0]?.count ?? 0;
			}
			this._numSplats = total;
		}
		return this._numSplats;
	}
	destroy() {
		this.octree?.destroy();
		this.octree = null;
	}
};

var _newAllocIds = /* @__PURE__ */ new Set();
var _toAllocateIds = [];
var _toAllocate = [];
var _toFree = [];
var GSplatWorldState = class {
	version = 0;
	sortParametersSet = false;
	sortedBefore = false;
	splats = [];
	textureSize = 0;
	totalActiveSplats = 0;
	totalIntervals = 0;
	boundsGroups = [];
	pendingReleases = [];
	needsUpload = [];
	needsUploadIds = /* @__PURE__ */ new Set();
	allocIdToSplat = /* @__PURE__ */ new Map();
	fullRebuild = false;
	constructor(device, version2, splats, allocator, allocationMap) {
		this.version = version2;
		this.splats = splats;
		if (splats.length === 0) {
			for (const [, block] of allocationMap) {
				allocator.free(block);
			}
			allocationMap.clear();
			this.totalActiveSplats = 0;
			this.totalIntervals = 0;
			this.textureSize = 1;
			return;
		}
		this.computeAllocationDiff(splats, allocationMap);
		const { fullRebuild, changedAllocIds } = this.applyAllocations(device, allocator, allocationMap);
		this.assignSplatOffsets(splats, allocationMap, fullRebuild, changedAllocIds);
		this.buildBoundsGroups(splats);
	}
	destroy() {
		this.splats.forEach((splat) => splat.destroy());
		this.splats.length = 0;
		this.needsUpload.length = 0;
		this.needsUploadIds.clear();
		this.allocIdToSplat.clear();
		this.boundsGroups.length = 0;
	}
	computeAllocationDiff(splats, allocationMap) {
		for (let i2 = 0; i2 < splats.length; i2++) {
			const splat = splats[i2];
			const allocIds = splat.intervalAllocIds;
			const intervals = splat.intervals;
			const numIntervals = intervals.length / 2;
			if (numIntervals > 0 && allocIds.length === numIntervals) {
				for (let j = 0; j < numIntervals; j++) {
					this._diffAlloc(allocIds[j], intervals[j * 2 + 1] - intervals[j * 2], allocationMap);
				}
			} else {
				this._diffAlloc(splat.allocId, splat.activeSplats, allocationMap);
			}
		}
		for (const [allocId, block] of allocationMap) {
			if (!_newAllocIds.has(allocId)) {
				_toFree.push(block);
				allocationMap.delete(allocId);
			}
		}
	}
	_diffAlloc(allocId, size, allocationMap) {
		_newAllocIds.add(allocId);
		const existing = allocationMap.get(allocId);
		if (existing) {
			if (existing.size !== size) {
				_toFree.push(existing);
				allocationMap.delete(allocId);
				if (size > 0) {
					_toAllocateIds.push(allocId);
					_toAllocate.push(size);
				}
			}
		} else if (size > 0) {
			_toAllocateIds.push(allocId);
			_toAllocate.push(size);
		}
	}
	applyAllocations(device, allocator, allocationMap) {
		let fullRebuild = false;
		if (_toFree.length > 0 || _toAllocate.length > 0) {
			fullRebuild = allocator.updateAllocation(_toFree, _toAllocate);
			for (let i2 = 0; i2 < _toAllocateIds.length; i2++) {
				allocationMap.set(_toAllocateIds[i2], _toAllocate[i2]);
			}
		}
		this.fullRebuild = fullRebuild;
		const churn = _toFree.length + _toAllocateIds.length;
		const incrementalDefragMoves = Math.max(50, churn);
		if (!fullRebuild && allocator.fragmentation > 0.3) {
			const moved = allocator.defrag(incrementalDefragMoves);
			if (moved.size > 0) {
				for (const [allocId, block] of allocationMap) {
					if (moved.has(block)) {
						_toAllocateIds.push(allocId);
					}
				}
			}
		}
		const cap = allocator.capacity;
		this.textureSize = cap > 0 ? Math.ceil(Math.sqrt(cap)) : 1;
		const changedAllocIds = _toAllocateIds.length > 0 ? new Set(_toAllocateIds) : null;
		_newAllocIds.clear();
		_toAllocateIds.length = 0;
		_toAllocate.length = 0;
		_toFree.length = 0;
		return { fullRebuild, changedAllocIds };
	}
	assignSplatOffsets(splats, allocationMap, fullRebuild, changedAllocIds) {
		let totalActiveSplats = 0;
		let totalIntervals = 0;
		for (let i2 = 0; i2 < splats.length; i2++) {
			const splat = splats[i2];
			const allocIds = splat.intervalAllocIds;
			const intervals = splat.intervals;
			const numIntervals = intervals.length / 2;
			totalIntervals += numIntervals > 0 ? numIntervals : 1;
			let splatChanged = fullRebuild;
			const intervalOffsets = [];
			if (numIntervals > 0 && allocIds.length === numIntervals) {
				for (let j = 0; j < numIntervals; j++) {
					this.allocIdToSplat.set(allocIds[j], splat);
					const block = allocationMap.get(allocIds[j]);
					if (block) {
						intervalOffsets.push(block.offset);
						totalActiveSplats += intervals[j * 2 + 1] - intervals[j * 2];
						if (changedAllocIds && changedAllocIds.has(allocIds[j])) {
							splatChanged = true;
							this.needsUploadIds.add(allocIds[j]);
						}
					}
				}
			} else {
				this.allocIdToSplat.set(splat.allocId, splat);
				const block = allocationMap.get(splat.allocId);
				if (block) {
					intervalOffsets.push(block.offset);
					totalActiveSplats += splat.activeSplats;
					if (changedAllocIds && changedAllocIds.has(splat.allocId)) {
						splatChanged = true;
						this.needsUploadIds.add(splat.allocId);
					}
				}
			}
			if (intervalOffsets.length > 0) {
				splat.setLayout(intervalOffsets);
				if (splatChanged) {
					this.needsUpload.push(splat);
					if (fullRebuild) {
						for (let j = 0; j < allocIds.length; j++) {
							this.needsUploadIds.add(allocIds[j]);
						}
					}
				}
			}
		}
		this.totalActiveSplats = totalActiveSplats;
		this.totalIntervals = totalIntervals;
	}
	buildBoundsGroups(splats) {
		const groupMap = /* @__PURE__ */ new Map();
		for (let i2 = 0; i2 < splats.length; i2++) {
			const splat = splats[i2];
			const key = splat.parentPlacementId;
			if (!groupMap.has(key)) {
				groupMap.set(key, {
					splat,
					boundsBaseIndex: 0,
					numBoundsEntries: splat.numBoundsEntries
				});
			}
		}
		let boundsIndex = 0;
		for (const group of groupMap.values()) {
			group.boundsBaseIndex = boundsIndex;
			boundsIndex += group.numBoundsEntries;
			this.boundsGroups.push(group);
		}
		for (let i2 = 0; i2 < splats.length; i2++) {
			const group = groupMap.get(splats[i2].parentPlacementId);
			splats[i2].boundsBaseIndex = group.boundsBaseIndex;
		}
	}
};

var GSplatPlacementStateTracker = class {
	_states = /* @__PURE__ */ new WeakMap();
	hasChanges(placements) {
		let changed = false;
		for (const p of placements) {
			if (!p.resource) continue;
			const formatVersion = p.resource.format?.extraStreamsVersion ?? 0;
			const modifierHash = p.workBufferModifier?.hash ?? 0;
			const numSplats = p.resource.numSplats ?? 0;
			const centersVersion = p.resource.centersVersion;
			const state = this._states.get(p);
			if (!state) {
				this._states.set(p, { formatVersion, modifierHash, numSplats, centersVersion });
				changed = true;
			} else if (state.formatVersion !== formatVersion || state.modifierHash !== modifierHash || state.numSplats !== numSplats || state.centersVersion !== centersVersion) {
				state.formatVersion = formatVersion;
				state.modifierHash = modifierHash;
				state.numSplats = numSplats;
				state.centersVersion = centersVersion;
				changed = true;
			}
		}
		return changed;
	}
};

var GSplatBudgetBalancer = class {
	_buckets = null;
	_initBuckets() {
		if (!this._buckets) {
			this._buckets = new Array(NUM_BUCKETS);
			for (let i2 = 0; i2 < NUM_BUCKETS; i2++) {
				this._buckets[i2] = [];
			}
		}
	}
	balance(octreeInstances, budget) {
		this._initBuckets();
		for (let i2 = 0; i2 < NUM_BUCKETS; i2++) {
			this._buckets[i2].length = 0;
		}
		let totalOptimalSplats = 0;
		for (const [, inst] of octreeInstances) {
			const nodes = inst.octree.nodes;
			const nodeInfos = inst.nodeInfos;
			for (let nodeIndex = 0, len = nodes.length; nodeIndex < len; nodeIndex++) {
				const nodeInfo = nodeInfos[nodeIndex];
				const optimalLod = nodeInfo.optimalLod;
				if (optimalLod < 0) continue;
				const lods = nodes[nodeIndex].lods;
				nodeInfo.lods = lods;
				this._buckets[nodeInfo.budgetBucket].push(nodeInfo);
				totalOptimalSplats += lods[optimalLod].count;
			}
		}
		let currentSplats = totalOptimalSplats;
		if (currentSplats === budget) {
			return;
		}
		const isOverBudget = currentSplats > budget;
		let done = false;
		while (!done && (isOverBudget ? currentSplats > budget : currentSplats < budget)) {
			let modified = false;
			if (isOverBudget) {
				for (let b = NUM_BUCKETS - 1; b >= 0 && !done; b--) {
					const bucket = this._buckets[b];
					for (let i2 = 0, len = bucket.length; i2 < len; i2++) {
						const nodeInfo = bucket[i2];
						if (nodeInfo.optimalLod < nodeInfo.inst.rangeMax) {
							const lods = nodeInfo.lods;
							const optimalLod = nodeInfo.optimalLod;
							currentSplats -= lods[optimalLod].count - lods[optimalLod + 1].count;
							nodeInfo.optimalLod = optimalLod + 1;
							modified = true;
							if (currentSplats <= budget) {
								done = true;
								break;
							}
						}
					}
				}
			} else {
				for (let b = 0; b < NUM_BUCKETS && !done; b++) {
					const bucket = this._buckets[b];
					for (let i2 = 0, len = bucket.length; i2 < len; i2++) {
						const nodeInfo = bucket[i2];
						if (nodeInfo.optimalLod > nodeInfo.inst.rangeMin) {
							const lods = nodeInfo.lods;
							const optimalLod = nodeInfo.optimalLod;
							const splatsAdded = lods[optimalLod - 1].count - lods[optimalLod].count;
							if (currentSplats + splatsAdded <= budget) {
								nodeInfo.optimalLod = optimalLod - 1;
								currentSplats += splatsAdded;
								modified = true;
								if (currentSplats >= budget) {
									done = true;
									break;
								}
							} else {
								done = true;
								break;
							}
						}
					}
				}
			}
			if (!modified) {
				break;
			}
		}
	}
};

var cameraPosition2 = new Vec3();
var _tempVec3 = new Vec3();
var invModelMat = new Mat4();
var _localCamPos = new Vec3();
var _closestPt = new Vec3();
var _meshInstanceAabb = new BoundingBox();
var _tempPlacementAabb = new BoundingBox();
var _cameraDeltas = { translationDelta: 0 };
var tempOctreesTicked = /* @__PURE__ */ new Set();
var _queuedSplats = /* @__PURE__ */ new Set();
var _updatedSplats = [];
var _splatsWithSH = [];
var _changedColorAllocIds = /* @__PURE__ */ new Set();
var tempNonOctreePlacements = /* @__PURE__ */ new Set();
var tempOctreePlacements = /* @__PURE__ */ new Set();
var _lodColorsRaw = [
	[1, 0, 0],
	// red
	[0, 1, 0],
	// green
	[0, 0, 1],
	// blue
	[1, 1, 0],
	// yellow
	[1, 0, 1],
	// magenta
	[0, 1, 1],
	// cyan
	[1, 0.5, 0],
	// orange
	[0.5, 0, 1]
	// purple
];
var _randomColorRaw = null;
var ALLOCATOR_GROW_MULTIPLIER = 1.15;
var GSplatWorld = class {
	_device;
	_scene;
	_workBuffer;
	_worldStates = /* @__PURE__ */ new Map();
	_lastWorldStateVersion = 0;
	_currentVersion = 0;
	_worldStateDirty = false;
	_workBufferFormatVersion = -1;
	_workBufferRebuildRequired = false;
	_bufferCopyUploaded = 0;
	_bufferCopyTotal = 0;
	_stateTracker = new GSplatPlacementStateTracker();
	_framesTillFullUpdate = 0;
	_lodUpdateRequested = false;
	_lastLodCameraPos = new Vec3(Infinity, Infinity, Infinity);
	_lastLodCameraFwd = new Vec3(Infinity, Infinity, Infinity);
	_lastLodCameraFov = -1;
	_budgetBalancer = new GSplatBudgetBalancer();
	_budgetScale = 1;
	_allocator;
	_allocationMap = /* @__PURE__ */ new Map();
	_lastColorUpdateCameraPos = new Vec3(Infinity, Infinity, Infinity);
	_layerPlacements = [];
	_layerPlacementsDirty = false;
	_placementSetChanged = false;
	_octreeInstances = /* @__PURE__ */ new Map();
	_octreeInstancesToDestroy = [];
	_hasNewOctreeInstances = false;
	_awaitingLodUpdate = false;
	constructor(device, scene) {
		this._device = device;
		this._scene = scene;
		const budget = scene.gsplat.splatBudget;
		this._allocator = new BlockAllocator(budget > 0 ? Math.ceil(budget * ALLOCATOR_GROW_MULTIPLIER) : 0, ALLOCATOR_GROW_MULTIPLIER);
		this._workBuffer = new GSplatWorkBuffer(device, scene.gsplat.format);
		this._workBufferFormatVersion = this._workBuffer.format.extraStreamsVersion;
	}
	destroy() {
		for (const [, worldState] of this._worldStates) {
			for (const splat of worldState.splats) {
				splat.resource.decRefCount();
			}
			worldState.destroy();
		}
		this._worldStates.clear();
		for (const [, instance] of this._octreeInstances) {
			instance.destroy();
		}
		this._octreeInstances.clear();
		for (const instance of this._octreeInstancesToDestroy) {
			instance.destroy();
		}
		this._octreeInstancesToDestroy.length = 0;
		this._workBuffer.destroy();
	}
	// --- read-only accessors (the one-way contract: manager reads, never reassigns) ---
	get workBuffer() {
		return this._workBuffer;
	}
	get currentVersion() {
		return this._currentVersion;
	}
	get lastWorldStateVersion() {
		return this._lastWorldStateVersion;
	}
	get bufferCopyUploaded() {
		return this._bufferCopyUploaded;
	}
	get bufferCopyTotal() {
		return this._bufferCopyTotal;
	}
	get awaitingLodUpdate() {
		return this._awaitingLodUpdate;
	}
	get hasOctreeInstances() {
		return this._octreeInstances.size > 0;
	}
	get pendingLoadCount() {
		let loadingCount = 0;
		for (const [, inst] of this._octreeInstances) {
			loadingCount += inst.pendingLoadCount;
		}
		return loadingCount;
	}
	get currentState() {
		return this._worldStates.get(this._currentVersion);
	}
	getState(version2) {
		return this._worldStates.get(version2);
	}
	get hasBounds() {
		return this._workBuffer.frustumCuller.totalBoundsEntries > 0;
	}
	// --- mutation entry points (manager-driven) ---
	resetFrameStats() {
		this._bufferCopyUploaded = 0;
		this._bufferCopyTotal = 0;
	}
	invalidate({ worldState = false, workBuffer = false } = {}) {
		if (worldState) this._worldStateDirty = true;
		if (workBuffer) this._workBufferRebuildRequired = true;
	}
	invalidateSortState() {
		const currentState = this._worldStates.get(this._currentVersion);
		if (!currentState) return null;
		currentState.sortParametersSet = false;
		currentState.sortedBefore = false;
		return currentState.splats;
	}
	syncFormat(result) {
		result.bufferRecreated = false;
		result.sortNeeded = false;
		const currentFormat = this._scene.gsplat.format;
		if (this._workBuffer.format !== currentFormat) {
			this._workBuffer.destroy();
			this._workBuffer = new GSplatWorkBuffer(this._device, currentFormat);
			this._workBufferFormatVersion = this._workBuffer.format.extraStreamsVersion;
			this._workBufferRebuildRequired = true;
			result.bufferRecreated = true;
			result.sortNeeded = true;
		}
		const wbFormatVersion = this._workBuffer.format.extraStreamsVersion;
		if (this._workBufferFormatVersion !== wbFormatVersion) {
			this._workBufferFormatVersion = wbFormatVersion;
			this._workBuffer.syncWithFormat();
			this._workBufferRebuildRequired = true;
			result.sortNeeded = true;
		}
		return result;
	}
	reconcile(placements) {
		tempNonOctreePlacements.clear();
		for (const p of placements) {
			if (p.resource instanceof GSplatOctreeResource) {
				if (!this._octreeInstances.has(p)) {
					this._octreeInstances.set(p, new GSplatOctreeInstance(this._device, p.resource.octree, p));
					this._hasNewOctreeInstances = true;
				}
				tempOctreePlacements.add(p);
			} else {
				tempNonOctreePlacements.add(p);
			}
		}
		for (const [placement, inst] of this._octreeInstances) {
			if (!tempOctreePlacements.has(placement)) {
				this._octreeInstances.delete(placement);
				this._layerPlacementsDirty = true;
				this._placementSetChanged = true;
				this._octreeInstancesToDestroy.push(inst);
			}
		}
		this._layerPlacementsDirty || (this._layerPlacementsDirty = this._layerPlacements.length !== tempNonOctreePlacements.size);
		if (!this._layerPlacementsDirty) {
			for (let i2 = 0; i2 < this._layerPlacements.length; i2++) {
				const existing = this._layerPlacements[i2];
				if (!tempNonOctreePlacements.has(existing)) {
					this._layerPlacementsDirty = true;
					break;
				}
			}
		}
		this._placementSetChanged || (this._placementSetChanged = this._layerPlacementsDirty);
		this._layerPlacements.length = 0;
		for (const p of tempNonOctreePlacements) {
			this._layerPlacements.push(p);
		}
		tempNonOctreePlacements.clear();
		tempOctreePlacements.clear();
	}
	update(camera, allowLodUpdate, requireCenters, result) {
		result.newVersion = false;
		result.overdrawDirty = false;
		result.sortNeeded = false;
		for (const [placement, inst] of this._octreeInstances) {
			if (inst.octree.destroyed || !placement.resource) {
				this._octreeInstances.delete(placement);
				this._layerPlacementsDirty = true;
				this._placementSetChanged = true;
				this._octreeInstancesToDestroy.push(inst);
			}
		}
		if (--this._framesTillFullUpdate <= 0) {
			this._framesTillFullUpdate = 10;
			this._lodUpdateRequested = true;
		}
		let fullUpdate = false;
		if (this._lodUpdateRequested && allowLodUpdate) {
			fullUpdate = true;
			this._lodUpdateRequested = false;
		}
		const hasNewInstances = this._hasNewOctreeInstances && allowLodUpdate;
		if (hasNewInstances) this._hasNewOctreeInstances = false;
		let anyInstanceNeedsLodUpdate = false;
		let anyOctreeMoved = false;
		let cameraMovedOrRotatedForLod = false;
		if (fullUpdate) {
			for (const [, inst] of this._octreeInstances) {
				const isDirty = inst.update();
				this._layerPlacementsDirty || (this._layerPlacementsDirty = isDirty);
				this._placementSetChanged || (this._placementSetChanged = inst.consumePlacementSetChanged());
				const instNeeds = inst.consumeNeedsLodUpdate();
				anyInstanceNeedsLodUpdate || (anyInstanceNeedsLodUpdate = instNeeds);
			}
			const threshold = this._scene.gsplat.lodUpdateDistance;
			for (const [, inst] of this._octreeInstances) {
				const moved = inst.testMoved(threshold);
				anyOctreeMoved || (anyOctreeMoved = moved);
			}
			cameraMovedOrRotatedForLod = this.testCameraMovedForLod(camera);
			this._awaitingLodUpdate = false;
		}
		if (this._scene.gsplat.dirty) {
			this._layerPlacementsDirty = true;
			result.overdrawDirty = true;
			this._workBufferRebuildRequired = true;
			result.sortNeeded = true;
			if (this._octreeInstances.size > 0) {
				this._awaitingLodUpdate = true;
			}
		}
		if (cameraMovedOrRotatedForLod || anyOctreeMoved || this._scene.gsplat.dirty || anyInstanceNeedsLodUpdate || hasNewInstances) {
			for (const [, inst] of this._octreeInstances) {
				inst.updateMoved();
			}
			this._lastLodCameraPos.copy(camera.getPosition());
			this._lastLodCameraFwd.copy(camera.forward);
			this._lastLodCameraFov = camera.camera.fov;
			const budget = this._scene.gsplat.splatBudget;
			if (budget > 0) {
				this._enforceBudget(budget, camera);
			} else {
				this._budgetScale = 1;
				for (const [, inst] of this._octreeInstances) {
					inst.updateLod(camera, this._scene.gsplat);
				}
			}
		}
		if (this._updateWorldState(requireCenters)) {
			result.newVersion = true;
			result.sortNeeded = true;
		}
		return result;
	}
	_updateWorldState(requireCenters) {
		let stateChanged = this._stateTracker.hasChanges(this._layerPlacements);
		for (const [, inst] of this._octreeInstances) {
			if (this._stateTracker.hasChanges(inst.activePlacements)) {
				stateChanged = true;
			}
		}
		const placementsChanged = this._layerPlacementsDirty;
		const worldChanged = placementsChanged || stateChanged || this._worldStates.size === 0 || this._worldStateDirty;
		if (!worldChanged) {
			return false;
		}
		this._lastWorldStateVersion++;
		const splats = [];
		for (const p of this._layerPlacements) {
			if (requireCenters && !p.resource.hasCenters) {
				continue;
			}
			p.ensureInstanceStreams(this._device);
			const splatInfo = new GSplatInfo(this._device, p.resource, p);
			splats.push(splatInfo);
		}
		for (const [, inst] of this._octreeInstances) {
			inst.activePlacements.forEach((p) => {
				if (p.resource) {
					const leafResource = p.resource;
					if (requireCenters && !leafResource.hasCenters) {
						return;
					}
					p.ensureInstanceStreams(this._device);
					const octreeNodes = p.intervals.size > 0 ? inst.octree.nodes : null;
					const nodeInfos = octreeNodes ? inst.nodeInfos : null;
					const splatInfo = new GSplatInfo(this._device, p.resource, p, octreeNodes, nodeInfos);
					splats.push(splatInfo);
				}
			});
		}
		const newState = new GSplatWorldState(
			this._device,
			this._lastWorldStateVersion,
			splats,
			this._allocator,
			this._allocationMap
		);
		for (const splat of newState.splats) {
			splat.resource.incRefCount();
		}
		for (const [, inst] of this._octreeInstances) {
			if (inst.removedCandidates && inst.removedCandidates.size) {
				for (const fileIndex of inst.removedCandidates) {
					newState.pendingReleases.push([inst.octree, fileIndex]);
				}
				inst.removedCandidates.clear();
			}
		}
		if (this._octreeInstancesToDestroy.length) {
			for (const inst of this._octreeInstancesToDestroy) {
				if (inst.removedCandidates && inst.removedCandidates.size) {
					for (const fileIndex of inst.removedCandidates) {
						newState.pendingReleases.push([inst.octree, fileIndex]);
					}
					inst.removedCandidates.clear();
				}
				const toRelease = inst.getFileDecrements();
				for (const fileIndex of toRelease) {
					newState.pendingReleases.push([inst.octree, fileIndex]);
				}
				inst.destroy(true);
			}
			this._octreeInstancesToDestroy.length = 0;
		}
		if (this._placementSetChanged) {
			newState.fullRebuild = true;
		}
		this._worldStates.set(this._lastWorldStateVersion, newState);
		this._layerPlacementsDirty = false;
		this._placementSetChanged = false;
		this._worldStateDirty = false;
		return true;
	}
	markSorted(version2, count, camera, updateBounds, result) {
		result.rebuilt = false;
		result.count = 0;
		result.textureSize = 0;
		this.cleanupOldWorldStates(version2);
		this._currentVersion = version2;
		const worldState = this._worldStates.get(version2);
		if (worldState && !worldState.sortedBefore) {
			worldState.sortedBefore = true;
			this.rebuildWorkBuffer(worldState, count, false, camera, updateBounds);
			result.rebuilt = true;
			result.count = count;
			result.textureSize = worldState.textureSize;
		}
		return result;
	}
	onSorted(version2, count, orderData, camera, updateBounds, result) {
		this.markSorted(version2, count, camera, updateBounds, result);
		if (this._worldStates.get(version2)) {
			this._workBuffer.setOrderData(orderData);
		}
		return result;
	}
	bake(version2, camera, updateBounds, result) {
		result.rebuilt = false;
		result.count = 0;
		result.textureSize = 0;
		result.sortNeeded = false;
		const sortedState = this._worldStates.get(version2);
		if (sortedState?.sortedBefore) {
			if (this._workBufferRebuildRequired) {
				const count = sortedState.totalActiveSplats;
				this.rebuildWorkBuffer(sortedState, count, true, camera, updateBounds);
				this._workBufferRebuildRequired = false;
				result.rebuilt = true;
				result.count = count;
				result.textureSize = sortedState.textureSize;
			} else {
				result.sortNeeded = this.applyWorkBufferUpdates(sortedState, camera);
			}
			this.updateColorCameraTracking(camera);
		}
		return result;
	}
	rebuildWorkBuffer(worldState, count, forceFullRebuild, camera, updateBounds) {
		const textureSize = worldState.textureSize;
		if (textureSize !== this._workBuffer.textureSize) {
			this._workBuffer.resize(textureSize);
		}
		if (updateBounds) {
			this._workBuffer.frustumCuller.updateBoundsData(worldState.boundsGroups);
			this._workBuffer.frustumCuller.updateTransformsData(worldState.boundsGroups);
		}
		const renderAll = forceFullRebuild || worldState.fullRebuild;
		const splatsToRender = renderAll ? worldState.splats : worldState.needsUpload;
		const changedAllocIds = renderAll ? null : worldState.needsUploadIds;
		if (splatsToRender.length > 0) {
			const totalBlocks = this._allocationMap.size;
			const uploadBlocks = renderAll ? totalBlocks : worldState.needsUploadIds.size;
			this._bufferCopyUploaded += uploadBlocks;
			this._bufferCopyTotal = totalBlocks;
			this._workBuffer.render(splatsToRender, camera, this.getDebugColors(), changedAllocIds);
		}
		for (let i2 = 0; i2 < worldState.splats.length; i2++) {
			worldState.splats[i2].update();
		}
		this.updateColorCameraTracking(camera);
		if (worldState.pendingReleases && worldState.pendingReleases.length) {
			const cooldownTicks = this._scene.gsplat.cooldownTicks;
			for (const [octree, fileIndex] of worldState.pendingReleases) {
				octree.decRefCount(fileIndex, cooldownTicks);
			}
			worldState.pendingReleases.length = 0;
		}
	}
	cleanupOldWorldStates(newVersion) {
		const activeState = this._worldStates.get(newVersion);
		if (!activeState.fullRebuild) {
			for (let v6 = this._currentVersion + 1; v6 < newVersion; v6++) {
				if (this._worldStates.get(v6)?.fullRebuild) {
					activeState.fullRebuild = true;
					break;
				}
			}
		}
		if (!activeState.fullRebuild) {
			const activeIds = activeState.needsUploadIds;
			const lookup = activeState.allocIdToSplat;
			for (let v6 = this._currentVersion + 1; v6 < newVersion; v6++) {
				const oldState = this._worldStates.get(v6);
				if (oldState) {
					for (const allocId of oldState.needsUploadIds) {
						if (!activeIds.has(allocId)) {
							activeIds.add(allocId);
							const splat = lookup.get(allocId);
							if (splat && !_queuedSplats.has(splat)) {
								activeState.needsUpload.push(splat);
								_queuedSplats.add(splat);
							}
						}
					}
				}
			}
			_queuedSplats.clear();
		}
		for (let v6 = this._currentVersion; v6 < newVersion; v6++) {
			const oldState = this._worldStates.get(v6);
			if (oldState) {
				for (const splat of oldState.splats) {
					splat.resource.decRefCount();
				}
				this._worldStates.delete(v6);
				oldState.destroy();
			}
		}
	}
	applyWorkBufferUpdates(state, camera) {
		const { colorUpdateAngle } = this._scene.gsplat;
		const ratio = Math.tan(colorUpdateAngle * math.DEG_TO_RAD);
		const cameraPos = camera.getPosition();
		const { translationDelta } = this.calculateColorCameraDeltas(camera);
		const hasCameraMovement = translationDelta > 0;
		let movedAny = false;
		let uploadedBlocks = 0;
		state.splats.forEach((splat) => {
			if (splat.update()) {
				_updatedSplats.push(splat);
				uploadedBlocks += splat.intervalAllocIds.length;
				if (splat.nodeInfos) {
					for (const ni of splat.intervalNodeIndices) {
						splat.nodeInfos[ni].colorAccumulatedTranslation = 0;
					}
				} else {
					splat.colorAccumulatedTranslation = 0;
				}
				movedAny = true;
			} else if (hasCameraMovement && splat.hasSphericalHarmonics) {
				_splatsWithSH.push(splat);
				if (splat.nodeInfos) {
					const nodeIndices = splat.intervalNodeIndices;
					for (let j = 0; j < nodeIndices.length; j++) {
						const nodeInfo = splat.nodeInfos[nodeIndices[j]];
						nodeInfo.colorAccumulatedTranslation += translationDelta;
						const threshold = ratio * Math.max(1, nodeInfo.worldDistance);
						if (nodeInfo.colorAccumulatedTranslation >= threshold) {
							_changedColorAllocIds.add(splat.intervalAllocIds[j]);
							nodeInfo.colorAccumulatedTranslation = 0;
							uploadedBlocks++;
						}
					}
				} else {
					splat.colorAccumulatedTranslation += translationDelta;
					invModelMat.copy(splat.node.getWorldTransform()).invert();
					invModelMat.transformPoint(cameraPos, _localCamPos);
					splat.aabb.closestPoint(_localCamPos, _closestPt);
					const dist = _localCamPos.distance(_closestPt) * splat.node.getWorldTransform().getScale().x;
					const threshold = ratio * Math.max(1, dist);
					if (splat.colorAccumulatedTranslation >= threshold) {
						_changedColorAllocIds.add(splat.allocId);
						uploadedBlocks += splat.intervalAllocIds.length;
						splat.colorAccumulatedTranslation = 0;
					}
				}
			}
		});
		this._bufferCopyUploaded += uploadedBlocks;
		this._bufferCopyTotal = this._allocationMap.size;
		if (_updatedSplats.length > 0) {
			this._workBuffer.render(_updatedSplats, camera, this.getDebugColors());
			_updatedSplats.length = 0;
		}
		if (_changedColorAllocIds.size > 0) {
			this._workBuffer.renderColor(
				_splatsWithSH,
				camera,
				this.getDebugColors(),
				_changedColorAllocIds
			);
			_changedColorAllocIds.clear();
		}
		_splatsWithSH.length = 0;
		return movedAny;
	}
	testCameraMovedForLod(camera) {
		const distanceThreshold = this._scene.gsplat.lodUpdateDistance;
		const currentCameraPos = camera.getPosition();
		const cameraMoved = this._lastLodCameraPos.distance(currentCameraPos) > distanceThreshold;
		if (cameraMoved) {
			return true;
		}
		let cameraRotated = false;
		const lodUpdateAngleDeg = this._scene.gsplat.lodUpdateAngle;
		if (lodUpdateAngleDeg > 0) {
			if (Number.isFinite(this._lastLodCameraFwd.x)) {
				const currentCameraFwd = camera.forward;
				const dot = Math.min(1, Math.max(-1, this._lastLodCameraFwd.dot(currentCameraFwd)));
				const angle = Math.acos(dot);
				const rotThreshold = lodUpdateAngleDeg * math.DEG_TO_RAD;
				cameraRotated = angle > rotThreshold;
			} else {
				cameraRotated = true;
			}
		}
		const currentFov = camera.camera.fov;
		const fovChanged = this._lastLodCameraFov < 0 || Math.abs(currentFov - this._lastLodCameraFov) > this._lastLodCameraFov * 0.02;
		return cameraMoved || cameraRotated || fovChanged;
	}
	updateColorCameraTracking(camera) {
		this._lastColorUpdateCameraPos.copy(camera.getPosition());
	}
	getDebugColors() {
		const debug = this._scene.gsplat.debug;
		if (debug === GSPLAT_DEBUG_SH_UPDATE) {
			_randomColorRaw ?? (_randomColorRaw = []);
			const r = Math.random();
			const g = Math.random();
			const b = Math.random();
			for (let i2 = 0; i2 < _lodColorsRaw.length; i2++) {
				_randomColorRaw[i2] ?? (_randomColorRaw[i2] = [0, 0, 0]);
				_randomColorRaw[i2][0] = r;
				_randomColorRaw[i2][1] = g;
				_randomColorRaw[i2][2] = b;
			}
			return _randomColorRaw;
		} else if (debug === GSPLAT_DEBUG_LOD) {
			return _lodColorsRaw;
		}
		return void 0;
	}
	calculateColorCameraDeltas(camera) {
		_cameraDeltas.translationDelta = 0;
		if (isFinite(this._lastColorUpdateCameraPos.x)) {
			const currentCameraPos = camera.getPosition();
			_cameraDeltas.translationDelta = this._lastColorUpdateCameraPos.distance(currentCameraPos);
		}
		return _cameraDeltas;
	}
	computeGlobalMaxDistance(camera) {
		let maxDist = 0;
		cameraPosition2.copy(camera.getPosition());
		for (const [, inst] of this._octreeInstances) {
			const worldTransform = inst.placement.node.getWorldTransform();
			const aabb3 = inst.placement.aabb;
			worldTransform.transformPoint(aabb3.center, _tempVec3);
			const scale2 = worldTransform.getScale().x;
			const dist = _tempVec3.distance(cameraPosition2) + aabb3.halfExtents.length() * scale2;
			if (dist > maxDist) maxDist = dist;
		}
		return Math.max(maxDist, 1);
	}
	_enforceBudget(budget, camera) {
		const textureWidth = this._workBuffer.textureSize;
		let fixedSplats = 0;
		let paddingEstimate = 0;
		for (const p of this._layerPlacements) {
			const resource = p.resource;
			if (resource) {
				const numSplats = resource.numSplats ?? 0;
				fixedSplats += numSplats;
				paddingEstimate += (textureWidth - numSplats % textureWidth) % textureWidth;
			}
		}
		const octreeBudget = Math.max(1, budget - fixedSplats);
		const globalMaxDistance = this.computeGlobalMaxDistance(camera);
		let totalOptimalSplats = 0;
		for (const [, inst] of this._octreeInstances) {
			totalOptimalSplats += inst.evaluateOptimalLods(camera, this._scene.gsplat, this._budgetScale, globalMaxDistance);
			for (const placement of inst.activePlacements) {
				const resource = placement.resource;
				const numSplats = resource?.numSplats ?? 0;
				paddingEstimate += (textureWidth - numSplats % textureWidth) % textureWidth;
			}
		}
		const adjustedBudget = Math.max(1, octreeBudget - paddingEstimate);
		if (totalOptimalSplats > 0) {
			const ratio = totalOptimalSplats / adjustedBudget;
			const budgetScaleDeadZone = 0.4;
			const budgetScaleBlendRate = 0.3;
			if (ratio > 1 + budgetScaleDeadZone || ratio < 1 - budgetScaleDeadZone) {
				const invCorrection = 1 / Math.sqrt(ratio);
				this._budgetScale *= 1 + (invCorrection - 1) * budgetScaleBlendRate;
				this._budgetScale = Math.max(0.01, Math.min(this._budgetScale, 100));
			}
		}
		this._budgetBalancer.balance(this._octreeInstances, adjustedBudget);
		for (const [, inst] of this._octreeInstances) {
			const maxLod = inst.octree.lodLevels - 1;
			inst.applyLodChanges(maxLod, this._scene.gsplat);
		}
	}
	computeAggregateAabb() {
		let initialized = false;
		const layerPlacements = this._layerPlacements;
		for (let i2 = 0; i2 < layerPlacements.length; i2++) {
			initialized = this._accumulatePlacementAabb(layerPlacements[i2], initialized);
		}
		for (const [, inst] of this._octreeInstances) {
			initialized = this._accumulatePlacementAabb(inst.placement, initialized);
		}
		return initialized ? _meshInstanceAabb : null;
	}
	_accumulatePlacementAabb(placement, initialized) {
		const a = placement.aabb;
		if (!a) return initialized;
		_tempPlacementAabb.setFromTransformedAabb(a, placement.node.getWorldTransform());
		if (initialized) {
			_meshInstanceAabb.add(_tempPlacementAabb);
		} else {
			_meshInstanceAabb.copy(_tempPlacementAabb);
		}
		return true;
	}
	tickCooldowns() {
		if (this._octreeInstances.size) {
			const cooldownTicks = this._scene.gsplat.cooldownTicks;
			for (const [, inst] of this._octreeInstances) {
				const octree = inst.octree;
				if (!tempOctreesTicked.has(octree)) {
					tempOctreesTicked.add(octree);
					octree.updateCooldownTick(cooldownTicks);
				}
			}
			tempOctreesTicked.clear();
		}
	}
	markInstancesNeedLodUpdate() {
		for (const [, inst] of this._octreeInstances) {
			inst.needsLodUpdate = true;
		}
	}
	prepareSortParameters(worldState) {
		return {
			command: "intervals",
			textureSize: worldState.textureSize,
			totalActiveSplats: worldState.totalActiveSplats,
			version: worldState.version,
			ids: worldState.splats.map((splat) => splat.resource.id),
			pixelOffsets: worldState.splats.map((splat) => splat.intervalOffsets),
			// TODO: consider storing this in typed array and transfer it to sorter worker
			intervals: worldState.splats.map((splat) => splat.intervals)
		};
	}
};

var GSplatRenderer = class {
	device;
	node;
	cameraNode;
	layer;
	workBuffer;
	renderMode;
	_workBufferFormatVersion = -1;
	fisheyeProj = new FisheyeProjection();
	constructor(device, node, cameraNode, layer, workBuffer) {
		this.device = device;
		this.node = node;
		this.cameraNode = cameraNode;
		this.layer = layer;
		this.workBuffer = workBuffer;
		this._workBufferFormatVersion = workBuffer?.format.extraStreamsVersion ?? -1;
	}
	destroy() {
	}
	resolveFisheye(fisheye) {
		const xrActive = !!this.cameraNode.camera?.camera?.xrActive;
		if (xrActive && fisheye > 0) {
			return 0;
		}
		return fisheye;
	}
	setRenderMode(renderMode) {
		this.renderMode = renderMode;
	}
	get usesGpuSort() {
		return false;
	}
	get requiresBounds() {
		return false;
	}
	get requiresCpuSort() {
		return !this.usesGpuSort;
	}
	get material() {
		return null;
	}
	setDataSource(source) {
		this.workBuffer = source;
		this.onWorkBufferFormatChanged();
	}
	onWorkBufferFormatChanged() {
	}
	update(count, textureSize) {
	}
	setGpuSortedRendering(drawSlot, sortedIds, numSplatsBuffer, textureSize) {
	}
	setCpuSortedRendering() {
	}
	setOrderData() {
	}
	frameUpdate(params, exposure, fogParams) {
	}
	updateOverdrawMode(params) {
	}
	invalidateCullUpload() {
	}
	prepareRenderView(world, worldState, params) {
		return false;
	}
	preparePickingView(world, worldState, pickParams) {
		return null;
	}
};

var GSplatQuadRenderer = class extends GSplatRenderer {
	_material;
	meshInstance;
	originalBlendType = BLEND_ADDITIVE;
	_internalDefines = /* @__PURE__ */ new Set();
	forceCopyMaterial = true;
	_lastFisheyeEnabled = false;
	_lastSourceChunksKey = "";
	constructor(device, node, cameraNode, layer, workBuffer) {
		super(device, node, cameraNode, layer, workBuffer);
		this._material = new ShaderMaterial({
			uniqueName: "UnifiedSplatMaterial",
			vertexGLSL: '#include "gsplatVS"',
			fragmentGLSL: '#include "gsplatPS"',
			vertexWGSL: '#include "gsplatVS"',
			fragmentWGSL: '#include "gsplatPS"',
			attributes: {
				vertex_position: SEMANTIC_POSITION
			}
		});
		this._material.setDefine("{GSPLAT_INSTANCE_SIZE}", GSplatResourceBase.instanceSize);
		this.configureMaterial();
		this._material.defines.forEach((value, key) => {
			this._internalDefines.add(key);
		});
		this._internalDefines.add("{GSPLAT_INSTANCE_SIZE}");
		this._internalDefines.add("GSPLAT_UNIFIED_ID");
		this._internalDefines.add("PICK_CUSTOM_ID");
		this._internalDefines.add("GSPLAT_INDIRECT_DRAW");
		this._internalDefines.add("GSPLAT_SEPARATE_OPACITY");
		this._internalDefines.add("GSPLAT_FISHEYE");
		this.meshInstance = this.createMeshInstance();
	}
	setRenderMode(renderMode) {
		const oldRenderMode = this.renderMode ?? 0;
		const wasForward = (oldRenderMode & GSPLAT_FORWARD) !== 0;
		const wasShadow = (oldRenderMode & GSPLAT_SHADOW) !== 0;
		const isForward = (renderMode & GSPLAT_FORWARD) !== 0;
		const isShadow = (renderMode & GSPLAT_SHADOW) !== 0;
		this.meshInstance.castShadow = isShadow;
		if (wasForward && !isForward) {
			this.layer.removeMeshInstances([this.meshInstance], true);
		}
		if (wasShadow && !isShadow) {
			this.layer.removeShadowCasters([this.meshInstance]);
		}
		if (!wasForward && isForward) {
			this.layer.addMeshInstances([this.meshInstance], true);
		}
		if (!wasShadow && isShadow) {
			this.layer.addShadowCasters([this.meshInstance]);
		}
		super.setRenderMode(renderMode);
	}
	destroy() {
		if (this.renderMode) {
			if (this.renderMode & GSPLAT_FORWARD) {
				this.layer.removeMeshInstances([this.meshInstance], true);
			}
			if (this.renderMode & GSPLAT_SHADOW) {
				this.layer.removeShadowCasters([this.meshInstance]);
			}
		}
		this._material.destroy();
		this.meshInstance.destroy();
		super.destroy();
	}
	get material() {
		return this._material;
	}
	onWorkBufferFormatChanged() {
		this.configureMaterial();
	}
	configureMaterial() {
		const { workBuffer } = this;
		this._injectFormatChunks();
		this._material.setDefine("SH_BANDS", "0");
		this._material.setDefine("GSPLAT_SEPARATE_OPACITY", "");
		const colorStream = workBuffer.format.getStream("dataColor");
		if (colorStream && colorStream.format !== PIXELFORMAT_RGBA16U) {
			this._material.setDefine("GSPLAT_COLOR_FLOAT", "");
		}
		this._updateIdDefines();
		this._bindWorkBufferTextures();
		const dither = false;
		this._material.setParameter("numSplats", 0);
		this.setOrderData();
		this._material.setDefine(`DITHER_${dither ? "BLUENOISE" : "NONE"}`, "");
		this._material.cull = CULLFACE_NONE;
		this._material.blendType = dither ? BLEND_NONE : BLEND_PREMULTIPLIED;
		this._material.depthWrite = !!dither;
		this._material.update();
	}
	_bindWorkBufferTextures() {
		const { workBuffer } = this;
		for (const stream of workBuffer.format.resourceStreams) {
			const texture = workBuffer.getTexture(stream.name);
			if (texture) {
				this._material.setParameter(stream.name, texture);
			}
		}
	}
	_injectFormatChunks() {
		const chunks = this.device.isWebGPU ? this._material.shaderChunks.wgsl : this._material.shaderChunks.glsl;
		const wbFormat = this.workBuffer.format;
		chunks.set("gsplatDeclarationsVS", wbFormat.getInputDeclarations());
		chunks.set("gsplatReadVS", wbFormat.getReadCode());
	}
	update(count, textureSize) {
		this.meshInstance.instancingCount = Math.ceil(count / GSplatResourceBase.instanceSize);
		this._material.setParameter("numSplats", count);
		this._material.setParameter("splatTextureSize", textureSize);
		this.meshInstance.visible = count > 0;
	}
	setGpuSortedRendering(drawSlot, sortedIds, numSplatsBuffer, textureSize) {
		this.meshInstance.setIndirect(null, drawSlot, 1);
		this._material.setParameter("compactedSplatIds", sortedIds);
		this._material.setParameter("numSplatsStorage", numSplatsBuffer);
		if (!this._material.getDefine("GSPLAT_INDIRECT_DRAW")) {
			this._material.setDefine("GSPLAT_INDIRECT_DRAW", true);
			this._material.update();
		}
		this._material.setParameter("splatTextureSize", textureSize);
		this.meshInstance.visible = true;
		if (this.meshInstance.instancingCount <= 0) {
			this.meshInstance.instancingCount = 1;
		}
	}
	setCpuSortedRendering() {
		this.meshInstance.setIndirect(null, -1);
		if (this._material.getDefine("GSPLAT_INDIRECT_DRAW")) {
			this._material.setDefine("GSPLAT_INDIRECT_DRAW", false);
			this._material.update();
		}
		this.setOrderData();
		this.meshInstance.visible = false;
	}
	setOrderData() {
		if (this.device.isWebGPU) {
			this._material.setParameter("splatOrder", this.workBuffer.orderBuffer);
		} else {
			this._material.setParameter("splatOrder", this.workBuffer.orderTexture);
		}
	}
	frameUpdate(params) {
		if (params.colorRamp) {
			this._material.setParameter("colorRampIntensity", params.colorRampIntensity);
		}
		const cam = this.cameraNode.camera;
		this.fisheyeProj.update(this.resolveFisheye(params.fisheye), cam.fov, cam.projectionMatrix);
		const fisheyeEnabled = this.fisheyeProj.enabled;
		if (fisheyeEnabled !== this._lastFisheyeEnabled) {
			this._lastFisheyeEnabled = fisheyeEnabled;
			this._material.setDefine("GSPLAT_FISHEYE", fisheyeEnabled);
			this._material.update();
		}
		if (fisheyeEnabled) {
			const fp = this.fisheyeProj;
			this._material.setParameter("fisheye_k", fp.k);
			this._material.setParameter("fisheye_inv_k", fp.invK);
			this._material.setParameter("fisheye_projMat00", fp.projMat00);
			this._material.setParameter("fisheye_projMat11", fp.projMat11);
		}
		const noFog = !params.useFog;
		if (noFog !== this._lastNoFog) {
			this._lastNoFog = noFog;
			this._material.setDefine("GSPLAT_NO_FOG", noFog);
			this._material.update();
		}
		this._syncWithWorkBufferFormat();
		if (this.forceCopyMaterial || params.material.dirty) {
			this.copyMaterialSettings(params.material);
			this.forceCopyMaterial = false;
		}
	}
	_updateIdDefines() {
		const hasPcId = !!this.workBuffer.format.getStream("pcId");
		this._material.setDefine("GSPLAT_UNIFIED_ID", hasPcId);
		this._material.setDefine("PICK_CUSTOM_ID", hasPcId);
	}
	_syncWithWorkBufferFormat() {
		const wbFormat = this.workBuffer.format;
		if (this._workBufferFormatVersion !== wbFormat.extraStreamsVersion) {
			this._workBufferFormatVersion = wbFormat.extraStreamsVersion;
			this.workBuffer.syncWithFormat();
			this._injectFormatChunks();
			this._bindWorkBufferTextures();
			this._updateIdDefines();
			this._material.update();
		}
	}
	copyMaterialSettings(sourceMaterial) {
		const keysToDelete = [];
		this._material.defines.forEach((value, key) => {
			if (!this._internalDefines.has(key) && !sourceMaterial.defines.has(key)) {
				keysToDelete.push(key);
			}
		});
		keysToDelete.forEach((key) => this._material.setDefine(key, void 0));
		sourceMaterial.defines.forEach((value, key) => {
			this._material.setDefine(key, value);
		});
		const srcParams = sourceMaterial.parameters;
		for (const paramName in srcParams) {
			if (srcParams.hasOwnProperty(paramName)) {
				this._material.setParameter(paramName, srcParams[paramName].data);
			}
		}
		if (sourceMaterial.hasShaderChunks) {
			const sourceChunksKey = sourceMaterial.shaderChunks.key;
			if (sourceChunksKey !== this._lastSourceChunksKey) {
				this._material.shaderChunks.copy(sourceMaterial.shaderChunks);
				this._injectFormatChunks();
				this._lastSourceChunksKey = sourceChunksKey;
			}
		}
		this._material.update();
	}
	updateOverdrawMode(params) {
		const overdrawEnabled = !!params.colorRamp;
		const wasOverdrawEnabled = this._material.getDefine("GSPLAT_OVERDRAW");
		if (overdrawEnabled) {
			this._material.setParameter("colorRamp", params.colorRamp);
			this._material.setParameter("colorRampIntensity", params.colorRampIntensity);
		}
		if (overdrawEnabled !== wasOverdrawEnabled) {
			this._material.setDefine("GSPLAT_OVERDRAW", overdrawEnabled);
			if (overdrawEnabled) {
				this.originalBlendType = this._material.blendType;
				this._material.blendType = BLEND_ADDITIVE;
			} else {
				this._material.blendType = this.originalBlendType;
			}
			this._material.update();
		}
	}
	createMeshInstance() {
		const mesh = GSplatResourceBase.createMesh(this.device);
		const meshInstance = new MeshInstance(mesh, this._material);
		meshInstance.node = this.node;
		meshInstance.setInstancing(true, true);
		meshInstance.instancingCount = 0;
		const thisCamera = this.cameraNode.camera;
		meshInstance.isVisibleFunc = (camera) => {
			const renderMode = this.renderMode ?? 0;
			if (thisCamera.camera === camera && renderMode & GSPLAT_FORWARD) {
				return true;
			}
			if (renderMode & GSPLAT_SHADOW) {
				return camera.node?.name === SHADOWCAMERA_NAME;
			}
			return false;
		};
		return meshInstance;
	}
};

var computeGsplatProjectorSource = `
#include "gsplatCommonCS"
#include "gsplatTileIntersectCS"
@group(0) @binding(0) var<storage, read> compactedSplatIds: array<u32>;
@group(0) @binding(1) var<storage, read> sortElementCount: array<u32>;
@group(0) @binding(2) var<storage, read_write> projCache: array<u32>;
@group(0) @binding(3) var<storage, read_write> sortKeys: array<u32>;
@group(0) @binding(4) var<storage, read_write> renderCounter: array<atomic<u32>>;
struct BinWeight {
	base: f32,
	divider: f32
}
@group(0) @binding(5) var<storage, read> binWeights: array<BinWeight>;
struct ProjectorUniforms {
	splatTextureSize: u32,
	numBins: u32,
	isOrtho: u32,
	pad0: u32,
	viewProj: mat4x4f,
	viewMatrix: mat4x4f,
	cameraPosition: vec3f,
	minPixelSize: f32,
	cameraDirection: vec3f,
	focal: f32,
	viewportWidth: f32,
	viewportHeight: f32,
	nearClip: f32,
	farClip: f32,
	alphaClip: f32,
	minContribution: f32,
	minDist: f32,
	invRange: f32,
	foveationStrength: f32,
	foveationCenter: f32,
	#ifdef GSPLAT_XR
		viewProj1: mat4x4f,
	#endif
	#ifdef GSPLAT_FISHEYE
		fisheye_k: f32,
		fisheye_inv_k: f32,
		fisheye_projMat00: f32,
		fisheye_projMat11: f32,
	#endif
}
@group(0) @binding(6) var<uniform> uniforms: ProjectorUniforms;
#include "gsplatComputeSplatCS"
#include "gsplatFormatDeclCS"
#include "gsplatFormatReadCS"
#include "gsplatHelpersVS"
#ifdef GSPLAT_USER_VARYINGS
	#include "gsplatUserVaryingsCS"
#endif
#include "gsplatModifyVS"
#include "gsplatProjectCommonCS"
var<workgroup> wgCount: atomic<u32>;
var<workgroup> wgBase: u32;
@compute @workgroup_size(256)
fn main(
	@builtin(global_invocation_id) gid: vec3u,
	@builtin(num_workgroups) numWorkgroups: vec3u,
	@builtin(local_invocation_index) localIdx: u32
) {
	if (localIdx == 0u) {
		atomicStore(&wgCount, 0u);
	}
	workgroupBarrier();
	let threadIdx = gid.y * (numWorkgroups.x * 256u) + gid.x;
	let numVisible = sortElementCount[0];
	var valid = false;
	var clipPos: vec4f = vec4f(0.0);
	var v1: vec2f = vec2f(0.0);
	var v2: vec2f = vec2f(0.0);
	var rgb: vec3f = vec3f(0.0);
	var alpha: f32 = 0.0;
	var pcId: u32 = 0u;
	var sortKey: u32 = 0u;
	#ifdef GSPLAT_XR
		var ndc1: vec2f = vec2f(0.0);
	#endif
	let projected = projectSplatCommon(
		threadIdx,
		numVisible,
		uniforms.alphaClip,
		uniforms.minPixelSize,
		uniforms.minContribution,
		uniforms.foveationStrength,
		uniforms.foveationCenter,
		uniforms.viewMatrix,
		uniforms.viewProj,
		uniforms.focal,
		uniforms.viewportWidth,
		uniforms.viewportHeight,
		uniforms.nearClip,
		uniforms.farClip,
		uniforms.isOrtho,
		#ifdef GSPLAT_FISHEYE
			uniforms.fisheye_k,
			uniforms.fisheye_inv_k,
			uniforms.fisheye_projMat00,
			uniforms.fisheye_projMat11,
		#endif
		#ifdef GSPLAT_XR
			uniforms.viewProj1,
		#endif
	);
	if (projected.valid) {
		let center = projected.center;
		let opacity = projected.opacity;
		let proj = projected.proj;
		let mid = 0.5 * (proj.a + proj.c);
		let radius = length(vec2f(0.5 * (proj.a - proj.c), proj.b));
		let lambda1 = mid + radius;
		let lambda2 = max(mid - radius, 0.1);
		let vmin = min(1024.0, min(uniforms.viewportWidth, uniforms.viewportHeight));
		let l1 = 2.0 * min(sqrt(2.0 * lambda1), vmin);
		let l2 = 2.0 * min(sqrt(2.0 * lambda2), vmin);
		let dir = normalize(vec2f(proj.b, lambda1 - proj.a));
		v1 = l1 * dir;
		v2 = l2 * vec2f(dir.y, -dir.x);
		#ifdef GSPLAT_FISHEYE
			let viewCenter = uniforms.viewMatrix * vec4f(center, 1.0);
			let neg_z = -viewCenter.z;
			let ndcX = proj.screen.x / uniforms.viewportWidth * 2.0 - 1.0;
			let ndcY = proj.screen.y / uniforms.viewportHeight * 2.0 - 1.0;
			let depthNdc = clamp(
				(neg_z - uniforms.nearClip) / (uniforms.farClip - uniforms.nearClip),
				0.0, 1.0
			);
			clipPos = vec4f(ndcX, ndcY, depthNdc, 1.0);
		#else
			clipPos = uniforms.viewProj * vec4f(center, 1.0);
			clipPos.z = clamp(clipPos.z, 0.0, abs(clipPos.w));
		#endif
		#ifdef GSPLAT_XR
			ndc1 = proj.ndc1;
		#endif
		#ifdef RADIAL_SORT
			let delta = center - uniforms.cameraPosition;
			let radialDist = length(delta);
			let dist = (1.0 / uniforms.invRange) - radialDist - uniforms.minDist;
		#else
			let toSplat = center - uniforms.cameraPosition;
			let dist = dot(toSplat, uniforms.cameraDirection) - uniforms.minDist;
		#endif
		let d = dist * uniforms.invRange * f32(uniforms.numBins);
		let binFloat = clamp(d, 0.0, f32(uniforms.numBins) - 0.001);
		let bin = u32(binFloat);
		let binFrac = binFloat - f32(bin);
		sortKey = u32(binWeights[bin].base + binWeights[bin].divider * binFrac);
		#ifdef PICK_MODE
			var clr = vec4f(getColor(), opacity);
			modifySplatColor(center, &clr);
			pcId = loadPcId().r;
			alpha = clr.a;
		#else
			var clr = vec4f(getColor(), opacity);
			#if GSPLAT_AA
				clr.a = clr.a * proj.aaFactor;
			#endif
			modifySplatColor(center, &clr);
			rgb = max(clr.rgb, vec3f(0.0));
			alpha = clr.a;
		#endif
		valid = true;
	}
	var localDst: u32 = 0u;
	if (valid) {
		localDst = atomicAdd(&wgCount, 1u);
	}
	workgroupBarrier();
	if (localIdx == 0u) {
		let total = atomicLoad(&wgCount);
		wgBase = atomicAdd(&renderCounter[0], total);
	}
	workgroupBarrier();
	if (valid) {
		let dst = wgBase + localDst;
		let base = dst * {CACHE_STRIDE}u;
		#ifdef GSPLAT_XR
			let ndc0 = clipPos.xy / clipPos.w;
			projCache[base + 0u] = bitcast<u32>(ndc0.x);
			projCache[base + 1u] = bitcast<u32>(ndc0.y);
			projCache[base + 2u] = bitcast<u32>(ndc1.x);
			projCache[base + 3u] = bitcast<u32>(ndc1.y);
			projCache[base + 4u] = bitcast<u32>(clipPos.w);
			projCache[base + 5u] = pack2x16float(v1);
			projCache[base + 6u] = pack2x16float(v2);
			projCache[base + 7u] = pack4x8unorm(vec4f(rgb, alpha));
		#else
			projCache[base + 0u] = bitcast<u32>(clipPos.x);
			projCache[base + 1u] = bitcast<u32>(clipPos.y);
			projCache[base + 2u] = bitcast<u32>(clipPos.z);
			projCache[base + 3u] = bitcast<u32>(clipPos.w);
			projCache[base + 4u] = pack2x16float(v1);
			projCache[base + 5u] = pack2x16float(v2);
			#ifdef PICK_MODE
				projCache[base + 6u] = pcId;
				projCache[base + 7u] = pack2x16float(vec2f(0.0, alpha));
			#else
				projCache[base + 6u] = pack2x16float(vec2f(rgb.x, rgb.y));
				projCache[base + 7u] = pack2x16float(vec2f(rgb.z, alpha));
			#endif
		#endif
		#ifdef GSPLAT_USER_VARYINGS
			#include "gsplatUserCacheWriteCS"
		#endif
		sortKeys[dst] = sortKey;
	}
}
`;

var dispatch_core_default = `
fn calcDispatch2D(count: u32, maxDim: u32) -> vec2u {
	if (count <= maxDim) {
		return vec2u(count, 1u);
	}
	let y = (count + maxDim - 1u) / maxDim;
	let x = (count + y - 1u) / y;
	return vec2u(x, y);
}
`;

var computeGsplatProjectorWriteIndirectArgsSource = `
${indirect_core_default}
${dispatch_core_default}
${sort_indirect_args_default}
@group(0) @binding(0) var<storage, read> renderCounter: array<u32>;
@group(0) @binding(1) var<storage, read_write> indirectDrawArgs: array<DrawIndexedIndirectArgs>;
@group(0) @binding(2) var<storage, read_write> numSplatsBuf: array<u32>;
@group(0) @binding(3) var<storage, read_write> indirectDispatchArgs: array<u32>;
@group(0) @binding(4) var<storage, read_write> sortElementCountBuf: array<u32>;
struct WriteArgsUniforms {
	drawSlot: u32,
	indexCount: u32,
	sortSlotBase: u32,
	pad0: u32,
	sortIndirectInfo: vec4<u32>
};
@group(0) @binding(5) var<uniform> uniforms: WriteArgsUniforms;
@compute @workgroup_size(1)
fn main() {
	let count = renderCounter[0];
	let instanceCount = (count + {INSTANCE_SIZE}u - 1u) / {INSTANCE_SIZE}u;
	indirectDrawArgs[uniforms.drawSlot] = DrawIndexedIndirectArgs(
		uniforms.indexCount,
		instanceCount,
		0u,
		0,
		0u
	);
	numSplatsBuf[0] = count;
	sortElementCountBuf[0] = count;
	writeSortIndirectArgs(uniforms.sortSlotBase, count, uniforms.sortIndirectInfo);
}
`;

var computeGsplatProjectCommonSource = `
struct ProjectedSplatCommon {
	valid: bool,
	splatId: u32,
	center: vec3f,
	opacity: f32,
	proj: SplatCov2D
}
fn invalidProjectedSplatCommon() -> ProjectedSplatCommon {
	var cov: SplatCov2D;
	cov.screen = vec2f(0.0);
	cov.a = 0.0;
	cov.b = 0.0;
	cov.c = 0.0;
	cov.viewDepth = 0.0;
	cov.valid = false;
	return ProjectedSplatCommon(false, 0u, vec3f(0.0), 0.0, cov);
}
fn projectSplatCommon(
	threadIdx: u32,
	numVisible: u32,
	alphaClip: f32,
	minPixelSize: f32,
	minContribution: f32,
	foveationStrength: f32,
	foveationCenter: f32,
	viewMatrix: mat4x4f,
	viewProj: mat4x4f,
	focal: f32,
	viewportWidth: f32,
	viewportHeight: f32,
	nearClip: f32,
	farClip: f32,
	isOrtho: u32,
	#ifdef GSPLAT_FISHEYE
		fisheye_k: f32,
		fisheye_inv_k: f32,
		fisheye_projMat00: f32,
		fisheye_projMat11: f32,
	#endif
	#ifdef GSPLAT_XR
		viewProj1: mat4x4f,
	#endif
) -> ProjectedSplatCommon {
	if (threadIdx >= numVisible) {
		return invalidProjectedSplatCommon();
	}
	let splatId = compactedSplatIds[threadIdx];
	setSplat(splatId);
	let originalCenter = getCenter();
	var center = originalCenter;
	modifySplatCenter(&center);
	let opacity = getOpacity();
	if (opacity <= alphaClip) {
		return invalidProjectedSplatCommon();
	}
	var rotation: vec4f = getRotation().yzwx;
	var scale: vec3f = getScale();
	modifySplatRotationScale(originalCenter, center, &rotation, &scale);
	let proj = computeSplatCov(
		center, half4(rotation.wxyz), half3(scale),
		viewMatrix, viewProj,
		focal, viewportWidth, viewportHeight,
		nearClip, farClip, opacity, minPixelSize,
		isOrtho, alphaClip, minContribution,
		foveationStrength, foveationCenter,
		#ifdef GSPLAT_FISHEYE
			fisheye_k, fisheye_inv_k,
			fisheye_projMat00, fisheye_projMat11,
		#endif
		#ifdef GSPLAT_XR
			viewProj1,
		#endif
	);
	if (!proj.valid) {
		return invalidProjectedSplatCommon();
	}
	return ProjectedSplatCommon(true, splatId, center, opacity, proj);
}
`;

var computeGsplatCommonSource = `
#include "halfTypesCS"
const TILE_SIZE: u32 = 16u;
fn quatToMat3(r: half4) -> half3x3 {
	let r2: half4 = r + r;
	let x: half   = r2.x * r.w;
	let y: half4  = r2.y * r;
	let z: half4  = r2.z * r;
	let w: half   = r2.w * r.w;
	return half3x3(
		half(1.0) - z.z - w,  y.z + x,			  y.w - z.x,
		y.z - x,			  half(1.0) - y.y - w,   z.w + y.x,
		y.w + z.x,			z.w - y.x,			 half(1.0) - y.y - z.z
	);
}
struct SplatCov2D {
	screen: vec2f,
	a: f32,
	b: f32,
	c: f32,
	viewDepth: f32,
	valid: bool,
	#if GSPLAT_AA
		aaFactor: f32,
	#endif
	#ifdef GSPLAT_XR
		ndc1: vec2f,
	#endif
}
fn computeSplatCov(
	worldCenter: vec3f,
	rotation: half4,
	scale: half3,
	viewMatrix: mat4x4f,
	viewProj: mat4x4f,
	focal: f32,
	viewportWidth: f32,
	viewportHeight: f32,
	nearClip: f32,
	farClip: f32,
	opacity: f32,
	minPixelSize: f32,
	isOrtho: u32,
	alphaClip: f32,
	minContribution: f32,
	foveationStrength: f32,
	foveationCenter: f32,
	#ifdef GSPLAT_FISHEYE
		fisheye_k: f32,
		fisheye_inv_k: f32,
		fisheye_projMat00: f32,
		fisheye_projMat11: f32,
	#endif
	#ifdef GSPLAT_XR
		viewProj1: mat4x4f,
	#endif
) -> SplatCov2D {
	var result: SplatCov2D;
	result.valid = false;
	let viewCenter = (viewMatrix * vec4f(worldCenter, 1.0)).xyz;
	#ifdef GSPLAT_FISHEYE
		let fv = viewCenter;
		let r_xy = length(fv.xy);
		let neg_z = -fv.z;
		let theta = atan2(r_xy, neg_z);
		let maxTheta = min(fisheye_k * 1.5707963, 3.13);
		if (theta > maxTheta - 0.01 || dot(fv, fv) < 0.0001) {
			return result;
		}
		let tk = theta * fisheye_inv_k;
		let sin_tk = sin(tk);
		let cos_tk = cos(tk);
		let g_theta = fisheye_k * sin_tk / cos_tk;
		let fisheye_s = select(select(0.0, 1.0 / neg_z, neg_z > 0.0), g_theta / r_xy, r_xy > 1e-4);
		let fndc = vec2f(fisheye_projMat00 * fisheye_s * fv.x, fisheye_projMat11 * fisheye_s * fv.y);
		let screen = vec2f(
			(fndc.x * 0.5 + 0.5) * viewportWidth,
			(fndc.y * 0.5 + 0.5) * viewportHeight
		);
	#else
		if (viewCenter.z > 0.0) {
			return result;
		}
		let clip = viewProj * vec4f(worldCenter, 1.0);
		let ndc = clip.xy / clip.w;
		let screen = vec2f(
			(ndc.x * 0.5 + 0.5) * viewportWidth,
			(ndc.y * 0.5 + 0.5) * viewportHeight
		);
	#endif
	#ifdef GSPLAT_XR
		let clip1 = viewProj1 * vec4f(worldCenter, 1.0);
		let ndc1 = clip1.xy / clip1.w;
		let screen1 = vec2f(
			(ndc1.x * 0.5 + 0.5) * viewportWidth,
			(ndc1.y * 0.5 + 0.5) * viewportHeight
		);
	#endif
	let rot: half3x3 = quatToMat3(rotation);
	let s: vec3f = vec3f(scale);
	let M: mat3x3f = transpose(mat3x3f(
		s.x * vec3f(rot[0]),
		s.y * vec3f(rot[1]),
		s.z * vec3f(rot[2])
	));
	let w0 = vec3f(viewMatrix[0].x, viewMatrix[1].x, viewMatrix[2].x);
	let w1 = vec3f(viewMatrix[0].y, viewMatrix[1].y, viewMatrix[2].y);
	let w2 = vec3f(viewMatrix[0].z, viewMatrix[1].z, viewMatrix[2].z);
	#ifdef GSPLAT_FISHEYE
		let fisheyeFocal = viewportWidth * fisheye_projMat00;
		let g_prime = 1.0 / (cos_tk * cos_tk);
		let d2 = dot(fv, fv);
		let r_sq = max(r_xy * r_xy, 1e-8);
		let K_coeff = select(0.0, (g_prime * neg_z / d2 - fisheye_s) / r_sq, r_xy > 1e-4);
		let Jxx = fisheyeFocal * (fisheye_s + K_coeff * fv.x * fv.x);
		let Jxy = fisheyeFocal * K_coeff * fv.x * fv.y;
		let Jyy = fisheyeFocal * (fisheye_s + K_coeff * fv.y * fv.y);
		let Jzx = fisheyeFocal * g_prime * fv.x / d2;
		let Jzy = fisheyeFocal * g_prime * fv.y / d2;
		let tt0 = Jxx * w0 + Jxy * w1 + Jzx * w2;
		let tt1 = Jxy * w0 + Jyy * w1 + Jzy * w2;
	#else
		let ortho = isOrtho == 1u;
		let v = select(viewCenter.xyz, vec3f(0.0, 0.0, 1.0), ortho);
		let vz = select(min(v.z, -0.001), v.z, ortho);
		let J1 = focal / vz;
		let J2 = -J1 / vz * v.xy;
		let tt0 = J1 * w0 + J2.x * w2;
		let tt1 = J1 * w1 + J2.y * w2;
	#endif
	let b0 = M * tt0;
	let b1 = M * tt1;
	let aRaw = dot(b0, b0);
	let b = dot(b0, b1);
	let cRaw = dot(b1, b1);
	let a = aRaw + 0.3;
	let c = cRaw + 0.3;
	let det = a * c - b * b;
	if (det <= 0.0) {
		return result;
	}
	#if GSPLAT_AA
		let detOrig = aRaw * cRaw - b * b;
		result.aaFactor = sqrt(max(detOrig / det, 0.0));
	#endif
	let fovNdc = screen * vec2f(2.0 / viewportWidth, 2.0 / viewportHeight) - vec2f(1.0);
	#ifdef GSPLAT_XR
		let fovR = min(length(fovNdc), length(ndc1));
	#else
		let fovR = length(fovNdc);
	#endif
	let fovT = saturate((fovR - foveationCenter) / max(1.0 - foveationCenter, 1e-4));
	let effMinContribution = minContribution + foveationStrength * fovT * fovT * (3.0 - 2.0 * fovT);
	let totalContribution = opacity * 6.283185 * sqrt(det);
	if (totalContribution < effMinContribution) {
		return result;
	}
	let radiusFactor = computeRadiusFactor(half(opacity), alphaClip);
	let vmin = min(1024.0, min(viewportWidth, viewportHeight));
	let maxRadius = vmin;
	let radiusXUncapped = sqrt(2.0 * a);
	let radiusYUncapped = sqrt(2.0 * c);
	let radiusX = min(radiusXUncapped, maxRadius);
	let radiusY = min(radiusYUncapped, maxRadius);
	if (max(radiusX, radiusY) < minPixelSize) {
		return result;
	}
	#ifdef GSPLAT_XR
		if ((screen.x + radiusX < 0.0 || screen.x - radiusX > viewportWidth ||
			 screen.y + radiusY < 0.0 || screen.y - radiusY > viewportHeight) &&
			(screen1.x + radiusX < 0.0 || screen1.x - radiusX > viewportWidth ||
			 screen1.y + radiusY < 0.0 || screen1.y - radiusY > viewportHeight)) {
			return result;
		}
	#else
		if (screen.x + radiusX < 0.0 || screen.x - radiusX > viewportWidth ||
			screen.y + radiusY < 0.0 || screen.y - radiusY > viewportHeight) {
			return result;
		}
	#endif
	let capScale = max(1.0, max(radiusXUncapped, radiusYUncapped) / maxRadius);
	let invCapScale2 = 1.0 / (capScale * capScale);
	result.screen = screen;
	let scaledCov = vec3f(a, b, c) * invCapScale2;
	result.a = scaledCov.x;
	result.b = scaledCov.y;
	result.c = scaledCov.z;
	#ifdef GSPLAT_FISHEYE
		result.viewDepth = sqrt(d2);
	#else
		result.viewDepth = -viewCenter.z;
	#endif
	#ifdef GSPLAT_XR
		result.ndc1 = ndc1;
	#endif
	result.valid = true;
	return result;
}
`;

var computeGsplatTileIntersectSource = `
struct SplatTileEval {
	radiusFactor: f32,
	splatMin: vec2f,
	splatMax: vec2f,
}
fn computeRadiusFactor(opacity: half, alphaClip: f32) -> f32 {
	return min(8.0, 2.0 * log(f32(opacity) / alphaClip));
}
fn computeSplatTileEval(
	screen: vec2f,
	cx: f32, cy: f32, cz: f32,
	opacity: half,
	viewportWidth: f32, viewportHeight: f32,
	alphaClip: f32
) -> SplatTileEval {
	let K = cx * cz - cy * cy;
	let a = 4.0 * cz / K;
	let c = 4.0 * cx / K;
	let radiusFactor = computeRadiusFactor(opacity, alphaClip);
	let vmin = min(1024.0, min(viewportWidth, viewportHeight));
	let radius = vec2f(min(sqrt(2.0 * a), vmin), min(sqrt(2.0 * c), vmin));
	var result: SplatTileEval;
	result.radiusFactor = radiusFactor;
	result.splatMin = screen - radius;
	result.splatMax = screen + radius;
	return result;
}
fn segmentIntersectsEllipse(a: f32, b: f32, c: f32, d: f32, l: f32, r: f32) -> bool {
	let delta = b * b - 4.0 * a * c;
	let t1 = (l - d) * (2.0 * a) + b;
	let t2 = (r - d) * (2.0 * a) + b;
	return delta >= 0.0 && (t1 <= 0.0 || t1 * t1 <= delta) && (t2 >= 0.0 || t2 * t2 <= delta);
}
fn tileIntersectsEllipse(
	tileMin: vec2f, tileMax: vec2f, center: vec2f,
	cx: f32, cy: f32, cz: f32,
	radiusFactor: f32
) -> bool {
	if (center.x >= tileMin.x && center.x <= tileMax.x &&
		center.y >= tileMin.y && center.y <= tileMax.y) {
		return true;
	}
	let w = radiusFactor;
	var dx: f32;
	if (center.x * 2.0 < tileMin.x + tileMax.x) {
		dx = center.x - tileMin.x;
	} else {
		dx = center.x - tileMax.x;
	}
	if (segmentIntersectsEllipse(cz, -2.0 * cy * dx, cx * dx * dx - w, center.y, tileMin.y, tileMax.y)) {
		return true;
	}
	var dy: f32;
	if (center.y * 2.0 < tileMin.y + tileMax.y) {
		dy = center.y - tileMin.y;
	} else {
		dy = center.y - tileMax.y;
	}
	if (segmentIntersectsEllipse(cx, -2.0 * cy * dy, cz * dy * dy - w, center.x, tileMin.x, tileMax.x)) {
		return true;
	}
	return false;
}
`;

var gsplatComputeSplat_default = `
struct Splat {
	index: u32,
	uv: vec2i
}
var<private> splat: Splat;
fn setSplat(idx: u32) {
	splat.index = idx;
	splat.uv = vec2i(i32(idx % uniforms.splatTextureSize), i32(idx / uniforms.splatTextureSize));
}
`;

var gsplatModify_default = `
fn modifySplatCenter(center: ptr<function, vec3f>) {
}
fn modifySplatRotationScale(originalCenter: vec3f, modifiedCenter: vec3f, rotation: ptr<function, vec4f>, scale: ptr<function, vec3f>) {
}
fn modifySplatColor(center: vec3f, color: ptr<function, vec4f>) {
}
`;

var gsplatHelpers_default = `
fn gsplatMakeSpherical(scale: ptr<function, vec3f>, size: f32) {
	*scale = vec3f(size);
}
fn gsplatGetSizeFromScale(scale: vec3f) -> f32 {
	return sqrt((scale.x * scale.x + scale.y * scale.y + scale.z * scale.z) / 3.0);
}
`;

var INDEX_COUNT = 6 * GSplatResourceBase.instanceSize;
var PROJECTOR_WORKGROUP_SIZE = 256;
var PROJECTOR_INTERNAL_DEFINES = /* @__PURE__ */ new Set([
	"{CACHE_STRIDE}",
	"RADIAL_SORT",
	"PICK_MODE",
	"GSPLAT_FISHEYE",
	"GSPLAT_AA",
	"GSPLAT_COLOR_FLOAT",
	"GSPLAT_XR"
]);
var _cameraDir = new Vec3();
var _dispatchSize = new Vec2();
var _viewProjMat3 = new Mat4();
var _viewProjData = new Float32Array(16);
var _viewProj1Data = new Float32Array(16);
var _viewData = new Float32Array(16);
var _shaderProjMat = new Mat4();
var GSplatProjector = class {
	device;
	projCache = null;
	sortKeys = null;
	renderCounter = null;
	binWeightsBuffer = null;
	binWeightsUtil;
	_projectorComputes = /* @__PURE__ */ new Map();
	_projectorBindGroupFormat = null;
	_projectorUniformBufferFormat = null;
	_projectorUniformBufferFormatFisheye = null;
	_projectorUniformBufferFormatStereo = null;
	_writeIndirectArgsCompute = null;
	_writeArgsBindGroupFormat = null;
	_writeArgsUniformBufferFormat = null;
	_formatVersion = -1;
	_materialKey = "";
	_userModifySource = null;
	_userVaryingsSource = null;
	_userCacheWriteSource = null;
	_userDefines = null;
	_userCacheWords = 0;
	_allocatedCacheCount = 0;
	_allocatedCacheStride = 0;
	cameraPositionData = new Float32Array(3);
	cameraDirectionData = new Float32Array(3);
	constructor(device) {
		this.device = device;
		this.binWeightsUtil = new GSplatSortBinWeights2();
		this.binWeightsBuffer = new StorageBuffer(
			device,
			GSplatSortBinWeights2.NUM_BINS * 2 * 4,
			BUFFERUSAGE_COPY_SRC | BUFFERUSAGE_COPY_DST
		);
		this.renderCounter = new StorageBuffer(device, 4, BUFFERUSAGE_COPY_SRC | BUFFERUSAGE_COPY_DST);
		this._createUniformBufferFormats();
		this._createWriteIndirectArgsCompute();
	}
	destroy() {
		this.projCache?.destroy();
		this.sortKeys?.destroy();
		this.renderCounter?.destroy();
		this.binWeightsBuffer?.destroy();
		for (const compute of this._projectorComputes.values()) {
			compute.shader?.destroy();
		}
		this._projectorComputes.clear();
		this._projectorBindGroupFormat?.destroy();
		this._writeIndirectArgsCompute?.shader?.destroy();
		this._writeArgsBindGroupFormat?.destroy();
		this.projCache = null;
		this.sortKeys = null;
		this.renderCounter = null;
		this.binWeightsBuffer = null;
		this._projectorBindGroupFormat = null;
		this._projectorUniformBufferFormat = null;
		this._projectorUniformBufferFormatFisheye = null;
		this._projectorUniformBufferFormatStereo = null;
		this._writeIndirectArgsCompute = null;
		this._writeArgsBindGroupFormat = null;
		this._writeArgsUniformBufferFormat = null;
	}
	_createUniformBufferFormats() {
		const device = this.device;
		const baseFields = [
			new UniformFormat("splatTextureSize", UNIFORMTYPE_UINT),
			new UniformFormat("numBins", UNIFORMTYPE_UINT),
			new UniformFormat("isOrtho", UNIFORMTYPE_UINT),
			new UniformFormat("pad0", UNIFORMTYPE_UINT),
			new UniformFormat("viewProj", UNIFORMTYPE_MAT4),
			new UniformFormat("viewMatrix", UNIFORMTYPE_MAT4),
			new UniformFormat("cameraPosition", UNIFORMTYPE_VEC3),
			new UniformFormat("minPixelSize", UNIFORMTYPE_FLOAT),
			new UniformFormat("cameraDirection", UNIFORMTYPE_VEC3),
			new UniformFormat("focal", UNIFORMTYPE_FLOAT),
			new UniformFormat("viewportWidth", UNIFORMTYPE_FLOAT),
			new UniformFormat("viewportHeight", UNIFORMTYPE_FLOAT),
			new UniformFormat("nearClip", UNIFORMTYPE_FLOAT),
			new UniformFormat("farClip", UNIFORMTYPE_FLOAT),
			new UniformFormat("alphaClip", UNIFORMTYPE_FLOAT),
			new UniformFormat("minContribution", UNIFORMTYPE_FLOAT),
			new UniformFormat("minDist", UNIFORMTYPE_FLOAT),
			new UniformFormat("invRange", UNIFORMTYPE_FLOAT),
			new UniformFormat("foveationStrength", UNIFORMTYPE_FLOAT),
			new UniformFormat("foveationCenter", UNIFORMTYPE_FLOAT)
		];
		this._projectorUniformBufferFormat = new UniformBufferFormat(device, baseFields);
		this._projectorUniformBufferFormatFisheye = new UniformBufferFormat(device, [
			...baseFields.map((f) => new UniformFormat(f.name, f.type)),
			new UniformFormat("fisheye_k", UNIFORMTYPE_FLOAT),
			new UniformFormat("fisheye_inv_k", UNIFORMTYPE_FLOAT),
			new UniformFormat("fisheye_projMat00", UNIFORMTYPE_FLOAT),
			new UniformFormat("fisheye_projMat11", UNIFORMTYPE_FLOAT)
		]);
		this._projectorUniformBufferFormatStereo = new UniformBufferFormat(device, [
			...baseFields.map((f) => new UniformFormat(f.name, f.type)),
			new UniformFormat("viewProj1", UNIFORMTYPE_MAT4)
		]);
		this._writeArgsUniformBufferFormat = new UniformBufferFormat(device, [
			new UniformFormat("drawSlot", UNIFORMTYPE_UINT),
			new UniformFormat("indexCount", UNIFORMTYPE_UINT),
			new UniformFormat("sortSlotBase", UNIFORMTYPE_UINT),
			new UniformFormat("pad0", UNIFORMTYPE_UINT),
			new UniformFormat("sortIndirectInfo", UNIFORMTYPE_UVEC4)
		]);
	}
	_createWriteIndirectArgsCompute() {
		const device = this.device;
		this._writeArgsBindGroupFormat = new BindGroupFormat(device, [
			new BindStorageBufferFormat("renderCounter", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("indirectDrawArgs", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("numSplatsBuf", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("indirectDispatchArgs", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("sortElementCountBuf", SHADERSTAGE_COMPUTE, false),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		]);
		const cdefines = /* @__PURE__ */ new Map([
			["{INSTANCE_SIZE}", GSplatResourceBase.instanceSize.toString()]
		]);
		const shader = new Shader(device, {
			name: "GSplatProjectorWriteIndirectArgs",
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: computeGsplatProjectorWriteIndirectArgsSource,
			cdefines,
			computeBindGroupFormat: this._writeArgsBindGroupFormat,
			computeUniformBufferFormats: { uniforms: this._writeArgsUniformBufferFormat }
		});
		this._writeIndirectArgsCompute = new Compute(device, shader, "GSplatProjectorWriteIndirectArgs");
	}
	_destroyProjectorComputes() {
		for (const compute of this._projectorComputes.values()) {
			compute.shader?.destroy();
		}
		this._projectorComputes.clear();
		this._projectorBindGroupFormat?.destroy();
		this._projectorBindGroupFormat = null;
	}
	_projectorKey(radialSort, pickMode, fisheyeMode, antiAlias, stereo) {
		return `${radialSort ? "r" : "l"}${pickMode ? "p" : ""}${fisheyeMode ? "f" : ""}${antiAlias ? "a" : ""}${stereo ? "s" : ""}`;
	}
	_createProjectorCompute(workBuffer, radialSort, pickMode, fisheyeMode, antiAlias, stereo) {
		const device = this.device;
		const wbFormat = workBuffer.format;
		const fixedBindings = [
			new BindStorageBufferFormat("compactedSplatIds", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("sortElementCount", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("projCache", SHADERSTAGE_COMPUTE),
			new BindStorageBufferFormat("sortKeys", SHADERSTAGE_COMPUTE),
			new BindStorageBufferFormat("renderCounter", SHADERSTAGE_COMPUTE),
			new BindStorageBufferFormat("binWeights", SHADERSTAGE_COMPUTE, true),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		];
		if (!this._projectorBindGroupFormat) {
			this._projectorBindGroupFormat = new BindGroupFormat(device, [
				...fixedBindings,
				...wbFormat.getComputeBindFormats()
			]);
		}
		const cincludes = /* @__PURE__ */ new Map();
		cincludes.set("gsplatCommonCS", computeGsplatCommonSource);
		cincludes.set("gsplatTileIntersectCS", computeGsplatTileIntersectSource);
		cincludes.set("gsplatComputeSplatCS", gsplatComputeSplat_default);
		cincludes.set("gsplatFormatDeclCS", wbFormat.getComputeInputDeclarations(fixedBindings.length));
		cincludes.set("gsplatFormatReadCS", wbFormat.getReadCode());
		cincludes.set("gsplatHelpersVS", gsplatHelpers_default);
		cincludes.set("gsplatModifyVS", this._userModifySource ?? gsplatModify_default);
		cincludes.set("gsplatUserVaryingsCS", this._userVaryingsSource ?? "");
		cincludes.set("gsplatUserCacheWriteCS", this._userCacheWriteSource ?? "");
		cincludes.set("gsplatProjectCommonCS", computeGsplatProjectCommonSource);
		const cdefines = /* @__PURE__ */ new Map();
		cdefines.set("{CACHE_STRIDE}", (CACHE_STRIDE + this._userCacheWords).toString());
		if (radialSort) {
			cdefines.set("RADIAL_SORT", "");
		}
		if (pickMode) {
			cdefines.set("PICK_MODE", "");
		}
		if (fisheyeMode) {
			cdefines.set("GSPLAT_FISHEYE", "");
		}
		if (antiAlias) {
			cdefines.set("GSPLAT_AA", "");
		}
		if (stereo) {
			cdefines.set("GSPLAT_XR", "");
		}
		const colorStream = wbFormat.getStream("dataColor");
		if (colorStream && colorStream.format !== PIXELFORMAT_RGBA16U) {
			cdefines.set("GSPLAT_COLOR_FLOAT", "");
		}
		if (this._userDefines) {
			this._userDefines.forEach((value, key) => {
				if (!PROJECTOR_INTERNAL_DEFINES.has(key)) {
					cdefines.set(key, value);
				}
			});
		}
		const name = `GSplatProjector${radialSort ? "Radial" : "Linear"}${pickMode ? "Pick" : ""}${fisheyeMode ? "Fisheye" : ""}${antiAlias ? "Aa" : ""}${stereo ? "Stereo" : ""}`;
		const ubFormat = stereo ? this._projectorUniformBufferFormatStereo : fisheyeMode ? this._projectorUniformBufferFormatFisheye : this._projectorUniformBufferFormat;
		const shader = new Shader(device, {
			name,
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: computeGsplatProjectorSource,
			cincludes,
			cdefines,
			computeBindGroupFormat: this._projectorBindGroupFormat,
			computeUniformBufferFormats: { uniforms: ubFormat }
		});
		return new Compute(device, shader, name);
	}
	_getProjectorCompute(workBuffer, radialSort, pickMode = false, fisheyeMode = false, antiAlias = false, stereo = false) {
		const wbFormat = workBuffer.format;
		if (this._formatVersion !== wbFormat.extraStreamsVersion) {
			this._destroyProjectorComputes();
			this._formatVersion = wbFormat.extraStreamsVersion;
		}
		const key = this._projectorKey(radialSort, pickMode, fisheyeMode, antiAlias, stereo);
		let compute = this._projectorComputes.get(key);
		if (!compute) {
			compute = this._createProjectorCompute(workBuffer, radialSort, pickMode, fisheyeMode, antiAlias, stereo);
			this._projectorComputes.set(key, compute);
		}
		return compute;
	}
	_updateMaterial(material, userCacheWords = 0) {
		const chunksKey = material?.shaderChunks?.key ?? "";
		const definesKey = material?.definesKey ?? "";
		const materialKey = `${chunksKey}|${definesKey}|${userCacheWords}`;
		if (materialKey !== this._materialKey) {
			this._materialKey = materialKey;
			this._userDefines = material?.defines ?? null;
			this._userCacheWords = userCacheWords;
			const wgslChunks = material?.getShaderChunks?.(SHADERLANGUAGE_WGSL);
			this._userModifySource = wgslChunks?.get("gsplatModifyVS") ?? null;
			this._userVaryingsSource = wgslChunks?.get("gsplatUserVaryingsCS") ?? null;
			this._userCacheWriteSource = wgslChunks?.get("gsplatUserCacheWriteCS") ?? null;
			this._destroyProjectorComputes();
		}
	}
	_ensureCapacity(capacity) {
		const cacheStride = CACHE_STRIDE + this._userCacheWords;
		if (capacity > this._allocatedCacheCount || cacheStride !== this._allocatedCacheStride) {
			this.projCache?.destroy();
			this.sortKeys?.destroy();
			this._allocatedCacheCount = capacity;
			this._allocatedCacheStride = cacheStride;
			this.projCache = new StorageBuffer(this.device, capacity * cacheStride * 4);
			this.sortKeys = new StorageBuffer(this.device, capacity * 4, BUFFERUSAGE_COPY_SRC);
		}
	}
	dispatch(params) {
		const {
			workBuffer,
			cameraNode,
			compactedSplatIds,
			sortElementCountBuffer,
			totalCapacity,
			radialSort,
			numBits,
			minDist,
			maxDist,
			alphaClip,
			minPixelSize,
			minContribution,
			foveationStrength = 0,
			foveationCenter = 0.3,
			viewportWidth,
			viewportHeight,
			flipY,
			pickMode = false,
			fisheyeProj,
			antiAlias = false,
			isStereo = false,
			material,
			userCacheWords = 0
		} = params;
		const fisheyeMode = !!fisheyeProj?.enabled;
		const stereoMode = !!isStereo && !pickMode && !fisheyeMode;
		const aaMode = antiAlias && !pickMode;
		this._updateMaterial(material, userCacheWords);
		this._ensureCapacity(totalCapacity);
		this.renderCounter.clear();
		const compute = this._getProjectorCompute(workBuffer, radialSort, pickMode, fisheyeMode, aaMode, stereoMode);
		if (material) {
			const srcParams = material.parameters;
			for (const name in srcParams) {
				if (srcParams.hasOwnProperty(name)) {
					compute.setParameter(name, srcParams[name].data);
				}
			}
		}
		const cameraPos = cameraNode.getPosition();
		const cameraMat = cameraNode.getWorldTransform();
		const cameraDir = cameraMat.getZ(_cameraDir).normalize();
		const range = maxDist - minDist;
		const invRange = range > 0 ? 1 / range : 1;
		const bucketCount = 1 << numBits;
		const cameraBin = GSplatSortBinWeights2.computeCameraBin(radialSort, minDist, range);
		const binWeights = this.binWeightsUtil.compute(cameraBin, bucketCount);
		this.binWeightsBuffer.write(0, binWeights);
		compute.setParameter("compactedSplatIds", compactedSplatIds);
		compute.setParameter("sortElementCount", sortElementCountBuffer);
		compute.setParameter("projCache", this.projCache);
		compute.setParameter("sortKeys", this.sortKeys);
		compute.setParameter("renderCounter", this.renderCounter);
		compute.setParameter("binWeights", this.binWeightsBuffer);
		for (const stream of workBuffer.format.resourceStreams) {
			const texture = workBuffer.getTexture(stream.name);
			if (texture) {
				compute.setParameter(stream.name, texture);
			}
		}
		const cameraComponent = cameraNode.camera;
		const cam = cameraComponent.camera;
		const webgpu = this.device.isWebGPU;
		let focal;
		if (stereoMode) {
			const views = cam.xrViews;
			cam.updateViewTransforms();
			_viewProjData.set(views[0].projViewOffMat.data);
			_viewProj1Data.set(views[1].projViewOffMat.data);
			_viewData.set(views[0].viewOffMat.data);
			focal = viewportWidth * views[0].projMat.data[0];
		} else {
			const view = cam.viewMatrix;
			_viewProjMat3.mul2(Camera.applyShaderProjectionTransform(cam.projectionMatrix, _shaderProjMat, flipY, webgpu), view);
			_viewProjData.set(_viewProjMat3.data);
			_viewData.set(view.data);
			focal = viewportWidth * _shaderProjMat.data[0];
		}
		this.cameraPositionData[0] = cameraPos.x;
		this.cameraPositionData[1] = cameraPos.y;
		this.cameraPositionData[2] = cameraPos.z;
		compute.setParameter("cameraPosition", this.cameraPositionData);
		this.cameraDirectionData[0] = cameraDir.x;
		this.cameraDirectionData[1] = cameraDir.y;
		this.cameraDirectionData[2] = cameraDir.z;
		compute.setParameter("cameraDirection", this.cameraDirectionData);
		compute.setParameter("viewMatrix", _viewData);
		compute.setParameter("viewProj", _viewProjData);
		if (stereoMode) {
			compute.setParameter("viewProj1", _viewProj1Data);
		}
		compute.setParameter("focal", focal);
		compute.setParameter("viewportWidth", viewportWidth);
		compute.setParameter("viewportHeight", viewportHeight);
		compute.setParameter("nearClip", cam.nearClip);
		compute.setParameter("farClip", cam.farClip);
		compute.setParameter("alphaClip", alphaClip);
		compute.setParameter("minPixelSize", minPixelSize);
		compute.setParameter("minContribution", minContribution);
		compute.setParameter("foveationStrength", foveationStrength);
		compute.setParameter("foveationCenter", foveationCenter);
		compute.setParameter("isOrtho", cam.projection === PROJECTION_ORTHOGRAPHIC ? 1 : 0);
		compute.setParameter("splatTextureSize", workBuffer.textureSize);
		compute.setParameter("numBins", GSplatSortBinWeights2.NUM_BINS);
		compute.setParameter("minDist", minDist);
		compute.setParameter("invRange", invRange);
		compute.setParameter("pad0", 0);
		if (fisheyeMode) {
			compute.setParameter("fisheye_k", fisheyeProj.k);
			compute.setParameter("fisheye_inv_k", fisheyeProj.invK);
			compute.setParameter("fisheye_projMat00", fisheyeProj.projMat00);
			compute.setParameter("fisheye_projMat11", fisheyeProj.projMat11);
		}
		const workgroupCount = Math.ceil(totalCapacity / PROJECTOR_WORKGROUP_SIZE);
		Compute.calcDispatchSize(
			workgroupCount,
			_dispatchSize,
			this.device.limits.maxComputeWorkgroupsPerDimension || 65535
		);
		compute.setupDispatch(_dispatchSize.x, _dispatchSize.y, 1);
		this.device.computeDispatch([compute], "GSplatProjector");
	}
	writeIndirectArgs(drawSlot, sortSlotBase, numSplatsBuffer, sortElementCountBuffer, sortIndirectInfo) {
		const compute = this._writeIndirectArgsCompute;
		compute.setParameter("renderCounter", this.renderCounter);
		compute.setParameter("indirectDrawArgs", this.device.indirectDrawBuffer);
		compute.setParameter("numSplatsBuf", numSplatsBuffer);
		compute.setParameter("indirectDispatchArgs", this.device.indirectDispatchBuffer);
		compute.setParameter("sortElementCountBuf", sortElementCountBuffer);
		compute.setParameter("drawSlot", drawSlot);
		compute.setParameter("indexCount", INDEX_COUNT);
		compute.setParameter("sortSlotBase", sortSlotBase);
		compute.setParameter("pad0", 0);
		compute.setParameter("sortIndirectInfo", sortIndirectInfo);
		compute.setupDispatch(1);
		this.device.computeDispatch([compute], "GSplatProjectorWriteIndirectArgs");
	}
};

var computeGsplatIntervalCullSource = `
struct Interval {
	workBufferBase: u32,
	splatCount: u32,
	boundsIndex: u32,
	pad: u32
};
struct BoundsEntry {
	centerX: f32,
	centerY: f32,
	centerZ: f32,
	radius: f32,
	transformIndex: u32,
	pad0: u32,
	pad1: u32,
	pad2: u32
};
struct CullUniforms {
#ifdef GSPLAT_FISHEYE
	cameraWorldPos: vec3f,
	maxTheta: f32,
	cameraForward: vec3f,
	numIntervals: u32,
#else
	frustumPlanes: array<vec4f, 6>,
	numIntervals: u32
#endif
};
@group(0) @binding(0) var<uniform> uniforms: CullUniforms;
@group(0) @binding(1) var<storage, read> intervals: array<Interval>;
@group(0) @binding(2) var<storage, read_write> countBuffer: array<u32>;
@group(0) @binding(3) var<storage, read> boundsBuffer: array<BoundsEntry>;
@group(0) @binding(4) var<storage, read> transformsBuffer: array<vec4f>;
@compute @workgroup_size({WORKGROUP_SIZE})
fn main(@builtin(global_invocation_id) gid: vec3u) {
	let idx = gid.x;
	if (idx < uniforms.numIntervals) {
		let interval = intervals[idx];
		let entry = boundsBuffer[interval.boundsIndex];
		let localCenter = vec3f(entry.centerX, entry.centerY, entry.centerZ);
		let radius = entry.radius;
		let base = entry.transformIndex * 3u;
		let row0 = transformsBuffer[base];
		let row1 = transformsBuffer[base + 1u];
		let row2 = transformsBuffer[base + 2u];
		let worldCenter = vec3f(
			dot(vec4f(localCenter, 1.0), row0),
			dot(vec4f(localCenter, 1.0), row1),
			dot(vec4f(localCenter, 1.0), row2)
		);
		let worldRadius = radius * length(vec3f(row0.x, row1.x, row2.x));
	#ifdef GSPLAT_FISHEYE
		let v = worldCenter - uniforms.cameraWorldPos;
		let d = length(v);
		var visible = true;
		if (d > worldRadius) {
			let cosAngle = dot(v / d, uniforms.cameraForward);
			let theta = acos(clamp(cosAngle, -1.0, 1.0));
			let angularRadius = asin(min(worldRadius / d, 1.0));
			visible = (theta - angularRadius) < uniforms.maxTheta;
		}
	#else
		var visible = true;
		for (var p = 0; p < 6; p++) {
			let plane = uniforms.frustumPlanes[p];
			let dist = dot(plane.xyz, worldCenter) + plane.w;
			if (dist <= -worldRadius) {
				visible = false;
				break;
			}
		}
	#endif
		countBuffer[idx] = select(0u, interval.splatCount, visible);
	}
	if (idx == 0u) {
		countBuffer[uniforms.numIntervals] = 0u;
	}
}
`;

var computeGsplatIntervalScatterSource = `
struct Interval {
	workBufferBase: u32,
	splatCount: u32,
	boundsIndex: u32,
	pad: u32
};
struct ScatterUniforms {
	numIntervals: u32,
	pad0: u32,
	pad1: u32,
	pad2: u32
};
@group(0) @binding(0) var<uniform> uniforms: ScatterUniforms;
@group(0) @binding(1) var<storage, read> intervals: array<Interval>;
@group(0) @binding(2) var<storage, read> prefixSumBuffer: array<u32>;
@group(0) @binding(3) var<storage, read_write> compactedOutput: array<u32>;
@compute @workgroup_size({WORKGROUP_SIZE})
fn main(
	@builtin(workgroup_id) wgId: vec3u,
	@builtin(num_workgroups) numWorkgroups: vec3u,
	@builtin(local_invocation_id) lid: vec3u
) {
	let intervalIdx = wgId.y * numWorkgroups.x + wgId.x;
	if (intervalIdx >= uniforms.numIntervals) { return; }
	let outputOffset = prefixSumBuffer[intervalIdx];
	let nextOffset = prefixSumBuffer[intervalIdx + 1u];
	let count = nextOffset - outputOffset;
	if (count == 0u) { return; }
	let workBufferBase = intervals[intervalIdx].workBufferBase;
	let tid = lid.x;
	for (var j = tid; j < count; j += {WORKGROUP_SIZE}u) {
		compactedOutput[outputOffset + j] = workBufferBase + j;
	}
}
`;

var computeGsplatWriteIndirectArgsSource = `
${indirect_core_default}
${dispatch_core_default}
${sort_indirect_args_default}
@group(0) @binding(0) var<storage, read> prefixSumBuffer: array<u32>;
@group(0) @binding(1) var<storage, read_write> indirectDrawArgs: array<DrawIndexedIndirectArgs>;
@group(0) @binding(2) var<storage, read_write> numSplatsBuf: array<u32>;
@group(0) @binding(3) var<storage, read_write> indirectDispatchArgs: array<u32>;
@group(0) @binding(4) var<storage, read_write> sortElementCountBuf: array<u32>;
struct WriteArgsUniforms {
	drawSlot: u32,
	indexCount: u32,
	dispatchSlotBase: u32,
	totalSplats: u32,
	sortIndirectInfo: vec4<u32>
};
@group(0) @binding(5) var<uniform> uniforms: WriteArgsUniforms;
@compute @workgroup_size(1)
fn main(@builtin(global_invocation_id) gid: vec3u) {
	let count = prefixSumBuffer[uniforms.totalSplats];
	let instanceCount = (count + {INSTANCE_SIZE}u - 1u) / {INSTANCE_SIZE}u;
	indirectDrawArgs[uniforms.drawSlot] = DrawIndexedIndirectArgs(
		uniforms.indexCount,
		instanceCount,
		0u,
		0,
		0u
	);
	numSplatsBuf[0] = count;
	let keygenSlot = uniforms.dispatchSlotBase;
	let keygenOffset = keygenSlot * 3u;
	let keygenWorkgroupCount = (count + {KEYGEN_THREADS_PER_WORKGROUP}u - 1u) / {KEYGEN_THREADS_PER_WORKGROUP}u;
	let keygenDim = calcDispatch2D(keygenWorkgroupCount, {MAX_WORKGROUPS_PER_DIM}u);
	indirectDispatchArgs[keygenOffset + 0u] = keygenDim.x;
	indirectDispatchArgs[keygenOffset + 1u] = keygenDim.y;
	indirectDispatchArgs[keygenOffset + 2u] = 1u;
	writeSortIndirectArgs(keygenSlot + 1u, count, uniforms.sortIndirectInfo);
	sortElementCountBuf[0] = count;
}
`;

var INTERVAL_STRIDE = 4;
function buildGSplatIntervalData(worldState) {
	const splats = worldState.splats;
	const numIntervals = worldState.totalIntervals;
	const data2 = new Uint32Array(numIntervals * INTERVAL_STRIDE);
	let writeIdx = 0;
	for (let s2 = 0; s2 < splats.length; s2++) {
		const splat = splats[s2];
		if (splat.intervals.length > 0) {
			const nodeIndices = splat.intervalNodeIndices;
			for (let i2 = 0; i2 < splat.intervals.length; i2 += 2) {
				const count = splat.intervals[i2 + 1] - splat.intervals[i2];
				data2[writeIdx++] = splat.intervalOffsets[i2 / 2];
				data2[writeIdx++] = count;
				data2[writeIdx++] = splat.boundsBaseIndex + (nodeIndices.length > 0 ? nodeIndices[i2 / 2] : 0);
				data2[writeIdx++] = 0;
			}
		} else {
			data2[writeIdx++] = splat.intervalOffsets[0];
			data2[writeIdx++] = splat.activeSplats;
			data2[writeIdx++] = splat.boundsBaseIndex;
			data2[writeIdx++] = 0;
		}
	}
	return data2;
}

var WORKGROUP_SIZE = 256;
var INDEX_COUNT2 = 6 * GSplatResourceBase.instanceSize;
var GSplatIntervalCompaction = class {
	device;
	_scratch;
	compactedSplatIds = null;
	intervalsBuffer = null;
	countBuffer = null;
	prefixSumKernel = null;
	numSplatsBuffer = null;
	sortElementCountBuffer = null;
	allocatedIntervalCount = 0;
	allocatedCountBufferSize = 0;
	_uploadedVersion = -1;
	_cullComputePerspective = null;
	_cullComputeFisheye = null;
	_scatterCompute = null;
	_scatterDispatchSize = new Vec2(1, 1);
	_writeIndirectArgsCompute = null;
	_cullBindGroupFormatPerspective = null;
	_cullBindGroupFormatFisheye = null;
	_scatterBindGroupFormat = null;
	_writeArgsBindGroupFormat = null;
	_scatterUniformBufferFormat = null;
	_writeArgsUniformBufferFormat = null;
	constructor(device, scratch) {
		this.device = device;
		this._scratch = scratch;
		this.numSplatsBuffer = new StorageBuffer(device, 4, BUFFERUSAGE_COPY_SRC | BUFFERUSAGE_COPY_DST);
		this.sortElementCountBuffer = new StorageBuffer(device, 4, BUFFERUSAGE_COPY_SRC | BUFFERUSAGE_COPY_DST);
		this.prefixSumKernel = new PrefixSumKernel(device);
		this._createUniformBufferFormats();
		this._createScatterCompute();
		this._createWriteIndirectArgsCompute();
	}
	destroy() {
		this.intervalsBuffer?.destroy();
		this.countBuffer?.destroy();
		this.prefixSumKernel?.destroy();
		this.numSplatsBuffer?.destroy();
		this.sortElementCountBuffer?.destroy();
		this._destroyCullPass();
		this._scatterCompute?.shader?.destroy();
		this._scatterBindGroupFormat?.destroy();
		this._writeIndirectArgsCompute?.shader?.destroy();
		this._writeArgsBindGroupFormat?.destroy();
		this.compactedSplatIds = null;
		this.intervalsBuffer = null;
		this.countBuffer = null;
		this.prefixSumKernel = null;
		this.numSplatsBuffer = null;
		this.sortElementCountBuffer = null;
		this._scatterCompute = null;
		this._scatterBindGroupFormat = null;
		this._writeIndirectArgsCompute = null;
		this._writeArgsBindGroupFormat = null;
		this._scatterUniformBufferFormat = null;
		this._writeArgsUniformBufferFormat = null;
	}
	_destroyCullPass() {
		this._cullComputePerspective?.shader?.destroy();
		this._cullBindGroupFormatPerspective?.destroy();
		this._cullComputePerspective = null;
		this._cullBindGroupFormatPerspective = null;
		this._cullComputeFisheye?.shader?.destroy();
		this._cullBindGroupFormatFisheye?.destroy();
		this._cullComputeFisheye = null;
		this._cullBindGroupFormatFisheye = null;
	}
	_createUniformBufferFormats() {
		const device = this.device;
		this._scatterUniformBufferFormat = new UniformBufferFormat(device, [
			new UniformFormat("numIntervals", UNIFORMTYPE_UINT),
			new UniformFormat("pad0", UNIFORMTYPE_UINT),
			new UniformFormat("pad1", UNIFORMTYPE_UINT),
			new UniformFormat("pad2", UNIFORMTYPE_UINT)
		]);
		this._writeArgsUniformBufferFormat = new UniformBufferFormat(device, [
			new UniformFormat("drawSlot", UNIFORMTYPE_UINT),
			new UniformFormat("indexCount", UNIFORMTYPE_UINT),
			new UniformFormat("dispatchSlotBase", UNIFORMTYPE_UINT),
			new UniformFormat("totalSplats", UNIFORMTYPE_UINT),
			new UniformFormat("sortIndirectInfo", UNIFORMTYPE_UVEC4)
		]);
	}
	_createCullPass(fisheye) {
		const device = this.device;
		const suffix = fisheye ? "Fisheye" : "";
		const bindGroupFormat = new BindGroupFormat(device, [
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE),
			new BindStorageBufferFormat("intervals", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("countBuffer", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("boundsBuffer", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("transformsBuffer", SHADERSTAGE_COMPUTE, true)
		]);
		const cdefines = /* @__PURE__ */ new Map([["{WORKGROUP_SIZE}", WORKGROUP_SIZE.toString()]]);
		if (fisheye) {
			cdefines.set("GSPLAT_FISHEYE", "");
		}
		const uniformBufferFormat = fisheye ? new UniformBufferFormat(device, [
			new UniformFormat("cameraWorldPos", UNIFORMTYPE_VEC3),
			new UniformFormat("maxTheta", UNIFORMTYPE_FLOAT),
			new UniformFormat("cameraForward", UNIFORMTYPE_VEC3),
			new UniformFormat("numIntervals", UNIFORMTYPE_UINT)
		]) : new UniformBufferFormat(device, [
			new UniformFormat("frustumPlanes", UNIFORMTYPE_VEC4, 6),
			new UniformFormat("numIntervals", UNIFORMTYPE_UINT)
		]);
		const shader = new Shader(device, {
			name: `GSplatIntervalCull${suffix}`,
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: computeGsplatIntervalCullSource,
			cdefines,
			computeBindGroupFormat: bindGroupFormat,
			computeUniformBufferFormats: { uniforms: uniformBufferFormat }
		});
		const compute = new Compute(device, shader, `GSplatIntervalCull${suffix}`);
		return { compute, bindGroupFormat };
	}
	_getCullCompute(fisheye) {
		if (fisheye) {
			if (!this._cullComputeFisheye) {
				const { compute, bindGroupFormat } = this._createCullPass(true);
				this._cullComputeFisheye = compute;
				this._cullBindGroupFormatFisheye = bindGroupFormat;
			}
			return this._cullComputeFisheye;
		}
		if (!this._cullComputePerspective) {
			const { compute, bindGroupFormat } = this._createCullPass(false);
			this._cullComputePerspective = compute;
			this._cullBindGroupFormatPerspective = bindGroupFormat;
		}
		return this._cullComputePerspective;
	}
	_createScatterCompute() {
		const device = this.device;
		this._scatterBindGroupFormat = new BindGroupFormat(device, [
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE),
			new BindStorageBufferFormat("intervals", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("prefixSumBuffer", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("compactedOutput", SHADERSTAGE_COMPUTE, false)
		]);
		const cdefines = /* @__PURE__ */ new Map([
			["{WORKGROUP_SIZE}", WORKGROUP_SIZE.toString()]
		]);
		const shader = new Shader(device, {
			name: "GSplatIntervalScatter",
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: computeGsplatIntervalScatterSource,
			cdefines,
			computeBindGroupFormat: this._scatterBindGroupFormat,
			computeUniformBufferFormats: { uniforms: this._scatterUniformBufferFormat }
		});
		this._scatterCompute = new Compute(device, shader, "GSplatIntervalScatter");
	}
	_createWriteIndirectArgsCompute() {
		const device = this.device;
		this._writeArgsBindGroupFormat = new BindGroupFormat(device, [
			new BindStorageBufferFormat("prefixSumBuffer", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("indirectDrawArgs", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("numSplatsBuf", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("indirectDispatchArgs", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("sortElementCountBuf", SHADERSTAGE_COMPUTE, false),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		]);
		const cdefines = /* @__PURE__ */ new Map([
			["{INSTANCE_SIZE}", GSplatResourceBase.instanceSize],
			["{KEYGEN_THREADS_PER_WORKGROUP}", 256],
			["{MAX_WORKGROUPS_PER_DIM}", device.limits.maxComputeWorkgroupsPerDimension || 65535]
		]);
		const shader = new Shader(device, {
			name: "GSplatIntervalWriteIndirectArgs",
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: computeGsplatWriteIndirectArgsSource,
			cdefines,
			computeBindGroupFormat: this._writeArgsBindGroupFormat,
			computeUniformBufferFormats: { uniforms: this._writeArgsUniformBufferFormat }
		});
		this._writeIndirectArgsCompute = new Compute(device, shader, "GSplatIntervalWriteIndirectArgs");
	}
	_ensureCapacity(numIntervals, totalActiveSplats) {
		this.compactedSplatIds = this._scratch.ensureCompactedSplatIds(totalActiveSplats);
		const requiredCountSize = numIntervals + 1;
		if (requiredCountSize > this.allocatedCountBufferSize) {
			this.countBuffer?.destroy();
			this.allocatedCountBufferSize = requiredCountSize;
			this.countBuffer = new StorageBuffer(this.device, requiredCountSize * 4);
			if (this.prefixSumKernel) {
				this.prefixSumKernel.destroyPasses();
			}
		}
	}
	invalidateUpload() {
		this._uploadedVersion = -1;
	}
	uploadIntervals(worldState) {
		if (worldState.version === this._uploadedVersion) return;
		this._uploadedVersion = worldState.version;
		const numIntervals = worldState.totalIntervals;
		if (numIntervals === 0) return;
		if (numIntervals > this.allocatedIntervalCount) {
			this.intervalsBuffer?.destroy();
			this.allocatedIntervalCount = numIntervals;
			this.intervalsBuffer = new StorageBuffer(this.device, numIntervals * INTERVAL_STRIDE * 4, BUFFERUSAGE_COPY_DST);
		}
		const data2 = buildGSplatIntervalData(worldState);
		this.intervalsBuffer.write(0, data2, 0, numIntervals * INTERVAL_STRIDE);
	}
	dispatchCompact(frustumCuller, numIntervals, totalActiveSplats, fisheyeEnabled) {
		if (numIntervals === 0) return;
		this._ensureCapacity(numIntervals, totalActiveSplats);
		const cullCompute = this._getCullCompute(fisheyeEnabled);
		cullCompute.setParameter("intervals", this.intervalsBuffer);
		cullCompute.setParameter("countBuffer", this.countBuffer);
		cullCompute.setParameter("boundsBuffer", frustumCuller.boundsBuffer);
		cullCompute.setParameter("transformsBuffer", frustumCuller.transformsBuffer);
		if (fisheyeEnabled) {
			cullCompute.setParameter("cameraWorldPos", frustumCuller.fisheyeCameraPos);
			cullCompute.setParameter("maxTheta", frustumCuller.fisheyeMaxTheta);
			cullCompute.setParameter("cameraForward", frustumCuller.fisheyeCameraForward);
		} else {
			cullCompute.setParameter("frustumPlanes[0]", frustumCuller.frustumPlanes);
		}
		cullCompute.setParameter("numIntervals", numIntervals);
		const cullWorkgroups = Math.ceil(numIntervals / WORKGROUP_SIZE);
		cullCompute.setupDispatch(cullWorkgroups);
		this.device.computeDispatch([cullCompute], "GSplatIntervalCull");
		const prefixCount = numIntervals + 1;
		this.prefixSumKernel.resize(this.countBuffer, prefixCount);
		this.prefixSumKernel.dispatch(this.device);
		const scatterCompute = this._scatterCompute;
		scatterCompute.setParameter("intervals", this.intervalsBuffer);
		scatterCompute.setParameter("prefixSumBuffer", this.countBuffer);
		scatterCompute.setParameter("compactedOutput", this.compactedSplatIds);
		scatterCompute.setParameter("numIntervals", numIntervals);
		scatterCompute.setParameter("pad0", 0);
		scatterCompute.setParameter("pad1", 0);
		scatterCompute.setParameter("pad2", 0);
		Compute.calcDispatchSize(numIntervals, this._scatterDispatchSize, this.device.limits.maxComputeWorkgroupsPerDimension || 65535);
		scatterCompute.setupDispatch(this._scatterDispatchSize.x, this._scatterDispatchSize.y, 1);
		this.device.computeDispatch([scatterCompute], "GSplatIntervalScatter");
	}
	writeIndirectArgs(drawSlot, dispatchSlotBase, numIntervals, sortIndirectInfo) {
		const compute = this._writeIndirectArgsCompute;
		compute.setParameter("prefixSumBuffer", this.countBuffer);
		compute.setParameter("indirectDrawArgs", this.device.indirectDrawBuffer);
		compute.setParameter("numSplatsBuf", this.numSplatsBuffer);
		compute.setParameter("indirectDispatchArgs", this.device.indirectDispatchBuffer);
		compute.setParameter("sortElementCountBuf", this.sortElementCountBuffer);
		compute.setParameter("drawSlot", drawSlot);
		compute.setParameter("indexCount", INDEX_COUNT2);
		compute.setParameter("dispatchSlotBase", dispatchSlotBase);
		compute.setParameter("totalSplats", numIntervals);
		compute.setParameter("sortIndirectInfo", sortIndirectInfo);
		compute.setupDispatch(1);
		this.device.computeDispatch([compute], "GSplatIntervalWriteIndirectArgs");
	}
};

var _invProjMat = new Mat4();
var _shaderProjMat2 = new Mat4();
var _camPos = new Vec3();
var _camDir = new Vec3();
var _tmpV = new Vec3();
var GSplatHybridRenderer = class extends GSplatRenderer {
	_material;
	meshInstance;
	_pickMaterial = null;
	_pickMeshInstance = null;
	_clipToViewZ = new Float32Array(4);
	_clipToViewZPick = null;
	originalBlendType = BLEND_ADDITIVE;
	_internalDefines = /* @__PURE__ */ new Set();
	forceCopyMaterial = true;
	_lastSourceChunksKey = "";
	_cacheStride = CACHE_STRIDE;
	gpuSorter = null;
	projector = null;
	intervalCompaction = null;
	_scratch = null;
	indirectDrawSlot = -1;
	indirectDispatchSlot = -1;
	lastCompactedNumIntervals = 0;
	constructor(device, node, cameraNode, layer, workBuffer, scratch = null) {
		super(device, node, cameraNode, layer, workBuffer);
		this._scratch = scratch;
		this._material = new ShaderMaterial({
			uniqueName: "UnifiedSplatHybridMaterial",
			vertexWGSL: '#include "gsplatHybridVS"',
			fragmentWGSL: '#include "gsplatPS"',
			attributes: {
				vertex_position: SEMANTIC_POSITION
			}
		});
		this._material.setDefine("{GSPLAT_INSTANCE_SIZE}", GSplatResourceBase.instanceSize);
		this._material.setDefine("{CACHE_STRIDE}", CACHE_STRIDE);
		this.configureMaterial();
		this._material.defines.forEach((value, key) => {
			this._internalDefines.add(key);
		});
		this._internalDefines.add("{GSPLAT_INSTANCE_SIZE}");
		this._internalDefines.add("{CACHE_STRIDE}");
		this._internalDefines.add("GSPLAT_UNIFIED_ID");
		this._internalDefines.add("PICK_CUSTOM_ID");
		this._internalDefines.add("GSPLAT_OVERDRAW");
		this._internalDefines.add("GSPLAT_NO_FOG");
		this._internalDefines.add("GSPLAT_XR");
		this.meshInstance = this.createMeshInstance();
	}
	setRenderMode(renderMode) {
		const oldRenderMode = this.renderMode ?? 0;
		const wasForward = (oldRenderMode & GSPLAT_FORWARD) !== 0;
		const isForward = (renderMode & GSPLAT_FORWARD) !== 0;
		if (wasForward && !isForward) {
			this.layer.removeMeshInstances([this.meshInstance], true);
		}
		if (!wasForward && isForward) {
			this.layer.addMeshInstances([this.meshInstance], true);
		}
		super.setRenderMode(renderMode);
	}
	destroy() {
		if (this.renderMode && this.renderMode & GSPLAT_FORWARD) {
			this.layer.removeMeshInstances([this.meshInstance], true);
		}
		this.gpuSorter?.destroy();
		this.gpuSorter = null;
		this.projector?.destroy();
		this.projector = null;
		this.intervalCompaction?.destroy();
		this.intervalCompaction = null;
		this._material.destroy();
		this._pickMaterial?.destroy();
		this.meshInstance.destroy();
		this._pickMeshInstance?.destroy();
		super.destroy();
	}
	get material() {
		return this._material;
	}
	get usesGpuSort() {
		return true;
	}
	get requiresBounds() {
		return true;
	}
	onWorkBufferFormatChanged() {
		this.configureMaterial();
	}
	configureMaterial() {
		this._material.setDefine("SH_BANDS", "0");
		this._material.setDefine("GSPLAT_INDIRECT_DRAW", true);
		this._updateIdDefines(this._material);
		const dither = false;
		this._material.setDefine(`DITHER_${dither ? "BLUENOISE" : "NONE"}`, "");
		this._material.cull = CULLFACE_NONE;
		this._material.blendType = dither ? BLEND_NONE : BLEND_PREMULTIPLIED;
		this._material.depthWrite = !!dither;
		this._material.update();
	}
	setStereo(enabled) {
		if (this._material.getDefine("GSPLAT_XR") !== enabled) {
			this._material.setDefine("GSPLAT_XR", enabled);
			this._material.update();
		}
	}
	update(count, textureSize) {
		if (this.meshInstance.instancingCount <= 0) {
			this.meshInstance.instancingCount = 1;
		}
		this.meshInstance.visible = count > 0;
	}
	invalidateCullUpload() {
		this.intervalCompaction?.invalidateUpload();
	}
	_ensureGpuPipeline() {
		if (!this.gpuSorter) this.gpuSorter = new ComputeRadixSort(this.device, { indirect: true });
		if (!this.projector) this.projector = new GSplatProjector(this.device);
		if (!this.intervalCompaction) this.intervalCompaction = new GSplatIntervalCompaction(this.device, this._scratch);
	}
	prepareRenderView(world, worldState, params) {
		const cameraNode = params.cameraNode;
		const cam = cameraNode.camera;
		const sceneCam = cam.camera;
		const rt = cam.renderTarget;
		const rect = cam.rect;
		const xrView = sceneCam.xrActive ? sceneCam.xrViews[0] ?? null : null;
		const viewportWidth = Math.floor((xrView ? xrView.viewport.z : rt ? rt.width : this.device.width) * rect.z);
		const viewportHeight = Math.floor((xrView ? xrView.viewport.w : rt ? rt.height : this.device.height) * rect.w);
		const xrViewCount = sceneCam.xrActive ? sceneCam.xrViews.length : 0;
		if (xrViewCount > 2) {
		}
		const isStereo = xrViewCount === 2;
		this.setStereo(isStereo);
		const sortedIndices = this.sortAndProjectForCamera(
			world,
			worldState,
			cameraNode,
			viewportWidth,
			viewportHeight,
			Math.max(ALPHA_VISIBILITY_THRESHOLD, params.alphaClipForward),
			false,
			isStereo,
			params
		);
		if (!sortedIndices) return false;
		this.setHybridSortedRendering(
			this.indirectDrawSlot,
			sortedIndices,
			this.projector.projCache,
			this.intervalCompaction.numSplatsBuffer
		);
		return true;
	}
	preparePickingView(world, worldState, pickParams) {
		const pickMode = !!world.workBuffer.format.getStream("pcId");
		const sortedIndices = this.sortAndProjectForCamera(
			world,
			worldState,
			pickParams.cameraNode,
			pickParams.width,
			pickParams.height,
			Math.max(ALPHA_VISIBILITY_THRESHOLD, pickParams.alphaClip),
			pickMode,
			false,
			pickParams
		);
		if (!sortedIndices) return null;
		return this.prepareForPicking(
			this.indirectDrawSlot,
			sortedIndices,
			this.projector.projCache,
			this.intervalCompaction.numSplatsBuffer,
			pickParams.alphaClip,
			pickParams.alphaClipForward,
			pickParams.cameraNode
		);
	}
	sortAndProjectForCamera(world, worldState, cameraNode, viewportWidth, viewportHeight, alphaClip, pickMode, isStereo, params) {
		const elementCount = worldState.totalActiveSplats;
		if (elementCount === 0) return null;
		this._ensureGpuPipeline();
		const gpuSorter = this.gpuSorter;
		const projector = this.projector;
		this.intervalCompaction.uploadIntervals(worldState);
		if (world.hasBounds) {
			const state = world.getState(world.currentVersion);
			if (state) {
				this._runFrustumCulling(world, state, cameraNode, params);
			}
		}
		const fisheyeProj = this.fisheyeProj;
		const numIntervals = worldState.totalIntervals;
		const totalActiveSplats = worldState.totalActiveSplats;
		this.intervalCompaction.dispatchCompact(world.workBuffer.frustumCuller, numIntervals, totalActiveSplats, fisheyeProj.enabled);
		this.allocateAndWriteIntervalIndirectArgs(numIntervals);
		const ic = this.intervalCompaction;
		const compactedSplatIds = ic.compactedSplatIds;
		const numBits = Math.max(10, Math.min(20, Math.round(Math.log2(elementCount / 4))));
		const radixBits = gpuSorter.radixBits;
		const roundedNumBits = Math.ceil(numBits / radixBits) * radixBits;
		const { minDist, maxDist } = this.computeDistanceRange(worldState, cameraNode, params.radialSorting);
		const sortIndirectInfo = gpuSorter.prepareIndirect();
		projector.dispatch({
			workBuffer: world.workBuffer,
			cameraNode,
			compactedSplatIds,
			sortElementCountBuffer: ic.sortElementCountBuffer,
			totalCapacity: elementCount,
			radialSort: params.radialSorting,
			numBits: roundedNumBits,
			minDist,
			maxDist,
			alphaClip,
			minPixelSize: params.minPixelSize * 0.5,
			minContribution: params.minContribution,
			foveationStrength: params.foveationStrength,
			foveationCenter: params.foveationCenter,
			viewportWidth,
			viewportHeight,
			flipY: !!cameraNode.camera.renderTarget?.flipY,
			pickMode,
			fisheyeProj,
			antiAlias: params.antiAlias,
			isStereo,
			material: params.material,
			userCacheWords: params.varyings.words
		});
		projector.writeIndirectArgs(
			this.indirectDrawSlot,
			this.indirectDispatchSlot + 1,
			ic.numSplatsBuffer,
			ic.sortElementCountBuffer,
			sortIndirectInfo
		);
		if (pickMode) {
			this.device.submit();
		}
		return gpuSorter.sortIndirect(
			projector.sortKeys,
			elementCount,
			roundedNumBits,
			this.indirectDispatchSlot + 1,
			ic.sortElementCountBuffer,
			void 0,
			false,
			true
			// destructiveKeys: projector overwrites sortKeys each frame before the sort
		);
	}
	allocateAndWriteIntervalIndirectArgs(numIntervals) {
		const gpuSorter = this.gpuSorter;
		const sortInfo = gpuSorter.prepareIndirect();
		const sortSlotCount = sortInfo[0];
		this.indirectDrawSlot = this.device.getIndirectDrawSlot(1);
		this.indirectDispatchSlot = this.device.getIndirectDispatchSlot(1 + sortSlotCount);
		const ic = this.intervalCompaction;
		ic.writeIndirectArgs(this.indirectDrawSlot, this.indirectDispatchSlot, numIntervals, sortInfo);
		this.lastCompactedNumIntervals = numIntervals;
	}
	_runFrustumCulling(world, worldState, cameraNode, params) {
		world.workBuffer.frustumCuller.updateTransformsData(worldState.boundsGroups);
		const cam = cameraNode.camera;
		const sceneCamera = cam.camera;
		const xrViews = sceneCamera.xrViews;
		if (xrViews?.length) {
			sceneCamera.updateViewTransforms();
			sceneCamera.updateXrFrustum();
			world.workBuffer.frustumCuller.setFrustumPlanes(sceneCamera.frustum);
		} else {
			world.workBuffer.frustumCuller.computeFrustumPlanes(cam.projectionMatrix, cam.viewMatrix);
		}
		const fp = this.fisheyeProj;
		fp.update(this.resolveFisheye(params.fisheye), cam.fov, cam.projectionMatrix);
		if (fp.enabled) {
			world.workBuffer.frustumCuller.setFisheyeData(
				cameraNode.getPosition(),
				cameraNode.forward,
				fp.maxTheta
			);
		}
	}
	computeDistanceRange(worldState, cameraNode, radialSort) {
		const cameraMat = cameraNode.getWorldTransform();
		cameraMat.getTranslation(_camPos);
		cameraMat.getZ(_camDir).normalize();
		let minDist = radialSort ? 0 : Infinity;
		let maxDist = radialSort ? 0 : -Infinity;
		for (const splat of worldState.splats) {
			const modelMat = splat.node.getWorldTransform();
			const aabbMin = splat.aabb.getMin();
			const aabbMax = splat.aabb.getMax();
			for (let i2 = 0; i2 < 8; i2++) {
				_tmpV.x = i2 & 1 ? aabbMax.x : aabbMin.x;
				_tmpV.y = i2 & 2 ? aabbMax.y : aabbMin.y;
				_tmpV.z = i2 & 4 ? aabbMax.z : aabbMin.z;
				modelMat.transformPoint(_tmpV, _tmpV);
				if (radialSort) {
					const dist = _tmpV.distance(_camPos);
					if (dist > maxDist) maxDist = dist;
				} else {
					const dist = _tmpV.sub(_camPos).dot(_camDir);
					if (dist < minDist) minDist = dist;
					if (dist > maxDist) maxDist = dist;
				}
			}
		}
		if (maxDist === 0 || maxDist === -Infinity) {
			return { minDist: 0, maxDist: 1 };
		}
		return { minDist, maxDist };
	}
	setHybridSortedRendering(drawSlot, sortedIndices, projCache, numSplatsBuffer) {
		this.meshInstance.setIndirect(null, drawSlot, 1);
		this._material.setParameter("sortedIndices", sortedIndices);
		this._material.setParameter("projCache", projCache);
		this._material.setParameter("numSplatsStorage", numSplatsBuffer);
		this._computeClipToViewZ(this.cameraNode, this._clipToViewZ);
		this._material.setParameter("clipToViewZ", this._clipToViewZ);
		this.meshInstance.visible = true;
		if (this.meshInstance.instancingCount <= 0) {
			this.meshInstance.instancingCount = 1;
		}
	}
	prepareForPicking(drawSlot, sortedIndices, projCache, numSplatsBuffer, alphaClip, alphaClipForward, cameraNode) {
		if (!this._pickMaterial) {
			this._pickMaterial = new ShaderMaterial({
				uniqueName: "UnifiedSplatHybridPickMaterial",
				vertexWGSL: '#include "gsplatHybridVS"',
				fragmentWGSL: '#include "gsplatPS"',
				attributes: {
					vertex_position: SEMANTIC_POSITION
				}
			});
			this._pickMaterial.setDefine("{GSPLAT_INSTANCE_SIZE}", GSplatResourceBase.instanceSize);
			this._pickMaterial.setDefine("{CACHE_STRIDE}", this._cacheStride);
			this._pickMaterial.setDefine("SH_BANDS", "0");
			this._pickMaterial.setDefine("GSPLAT_INDIRECT_DRAW", true);
			this._pickMaterial.setDefine("DITHER_NONE", "");
			this._updateIdDefines(this._pickMaterial);
			this._pickMaterial.cull = CULLFACE_NONE;
			this._pickMaterial.blendType = BLEND_NONE;
			this._pickMaterial.depthWrite = false;
			this._pickMaterial.update();
			const mesh = GSplatResourceBase.createMesh(this.device);
			this._pickMeshInstance = new MeshInstance(mesh, this._pickMaterial);
			this._pickMeshInstance.node = this.node;
			this._pickMeshInstance.setInstancing(true, true);
			this._pickMeshInstance.instancingCount = 1;
		} else {
			if (this._updateIdDefines(this._pickMaterial)) {
				this._pickMaterial.update();
			}
		}
		const pickMaterial = this._pickMaterial;
		const pickMeshInstance = this._pickMeshInstance;
		pickMeshInstance.setIndirect(null, drawSlot, 1);
		pickMaterial.setParameter("sortedIndices", sortedIndices);
		pickMaterial.setParameter("projCache", projCache);
		pickMaterial.setParameter("numSplatsStorage", numSplatsBuffer);
		pickMaterial.setParameter("alphaClip", alphaClip);
		pickMaterial.setParameter("alphaClipForward", alphaClipForward);
		this._clipToViewZPick ?? (this._clipToViewZPick = new Float32Array(4));
		this._computeClipToViewZ(cameraNode, this._clipToViewZPick);
		pickMaterial.setParameter("clipToViewZ", this._clipToViewZPick);
		return pickMeshInstance;
	}
	_computeClipToViewZ(cameraNode, dst) {
		const camComp = cameraNode.camera;
		const cam = camComp.camera;
		if (this.fisheyeProj.enabled) {
			const near = cam.nearClip;
			const far = cam.farClip;
			dst[0] = 0;
			dst[1] = 0;
			dst[2] = far - near;
			dst[3] = near;
			return;
		}
		const flipY = !!camComp.renderTarget?.flipY;
		_invProjMat.copy(Camera.applyShaderProjectionTransform(cam.projectionMatrix, _shaderProjMat2, flipY, this.device.isWebGPU)).invert();
		const d = _invProjMat.data;
		dst[0] = -d[2];
		dst[1] = -d[6];
		dst[2] = -d[10];
		dst[3] = -d[14];
	}
	setCpuSortedRendering() {
		this.meshInstance.setIndirect(null, -1);
		this.meshInstance.visible = false;
	}
	setOrderData() {
	}
	frameUpdate(params) {
		this._material.setParameter("alphaClip", params.alphaClip);
		this._material.setParameter("alphaClipForward", params.alphaClipForward);
		this._pickMaterial?.setParameter("alphaClip", params.alphaClip);
		this._pickMaterial?.setParameter("alphaClipForward", params.alphaClipForward);
		if (params.colorRamp) {
			this._material.setParameter("colorRampIntensity", params.colorRampIntensity);
		}
		const noFog = !params.useFog;
		if (noFog !== this._lastNoFog) {
			this._lastNoFog = noFog;
			this._material.setDefine("GSPLAT_NO_FOG", noFog);
			this._material.update();
		}
		const cacheStride = CACHE_STRIDE + params.varyings.words;
		if (cacheStride !== this._cacheStride) {
			this._cacheStride = cacheStride;
			this._material.setDefine("{CACHE_STRIDE}", cacheStride);
			this._material.update();
			if (this._pickMaterial) {
				this._pickMaterial.setDefine("{CACHE_STRIDE}", cacheStride);
				this._pickMaterial.update();
			}
		}
		if (this.forceCopyMaterial || params.material.dirty) {
			this.copyMaterialSettings(params.material);
			this.forceCopyMaterial = false;
		}
	}
	copyMaterialSettings(sourceMaterial) {
		const keysToDelete = [];
		this._material.defines.forEach((value, key) => {
			if (!this._internalDefines.has(key) && !sourceMaterial.defines.has(key)) {
				keysToDelete.push(key);
			}
		});
		keysToDelete.forEach((key) => this._material.setDefine(key, void 0));
		sourceMaterial.defines.forEach((value, key) => {
			this._material.setDefine(key, value);
		});
		const srcParams = sourceMaterial.parameters;
		for (const paramName in srcParams) {
			if (srcParams.hasOwnProperty(paramName)) {
				this._material.setParameter(paramName, srcParams[paramName].data);
			}
		}
		if (sourceMaterial.hasShaderChunks) {
			const sourceChunksKey = sourceMaterial.shaderChunks.key;
			if (sourceChunksKey !== this._lastSourceChunksKey) {
				this._material.shaderChunks.copy(sourceMaterial.shaderChunks);
				this._lastSourceChunksKey = sourceChunksKey;
			}
		}
		this._material.update();
	}
	_updateIdDefines(material) {
		const hasPcId = !!this.workBuffer.format.getStream("pcId");
		const changed = material.getDefine("GSPLAT_UNIFIED_ID") !== hasPcId || material.getDefine("PICK_CUSTOM_ID") !== hasPcId;
		material.setDefine("GSPLAT_UNIFIED_ID", hasPcId);
		material.setDefine("PICK_CUSTOM_ID", hasPcId);
		return changed;
	}
	updateOverdrawMode(params) {
		const overdrawEnabled = !!params.colorRamp;
		const wasOverdrawEnabled = this._material.getDefine("GSPLAT_OVERDRAW");
		if (overdrawEnabled) {
			this._material.setParameter("colorRamp", params.colorRamp);
			this._material.setParameter("colorRampIntensity", params.colorRampIntensity);
		}
		if (overdrawEnabled !== wasOverdrawEnabled) {
			this._material.setDefine("GSPLAT_OVERDRAW", overdrawEnabled);
			if (overdrawEnabled) {
				this.originalBlendType = this._material.blendType;
				this._material.blendType = BLEND_ADDITIVE;
			} else {
				this._material.blendType = this.originalBlendType;
			}
			this._material.update();
		}
	}
	createMeshInstance() {
		const mesh = GSplatResourceBase.createMesh(this.device);
		const meshInstance = new MeshInstance(mesh, this._material);
		meshInstance.node = this.node;
		meshInstance.setInstancing(true, true);
		meshInstance.instancingCount = 0;
		meshInstance.pick = false;
		const thisCamera = this.cameraNode.camera;
		meshInstance.isVisibleFunc = (camera) => {
			const renderMode = this.renderMode ?? 0;
			if (thisCamera.camera === camera && renderMode & GSPLAT_FORWARD) {
				return true;
			}
			if (camera.node?.name === SHADOWCAMERA_NAME) {
				return false;
			}
			return false;
		};
		return meshInstance;
	}
};

var GSplatHybridRendererScratch = class {
	device;
	compactedSplatIds = null;
	_allocatedCompacted = 0;
	constructor(device) {
		this.device = device;
	}
	ensureCompactedSplatIds(capacity) {
		if (capacity > this._allocatedCompacted) {
			this.compactedSplatIds?.destroy();
			this._allocatedCompacted = capacity;
			this.compactedSplatIds = new StorageBuffer(this.device, capacity * 4, BUFFERUSAGE_COPY_SRC);
		}
		return this.compactedSplatIds;
	}
	destroy() {
		this.compactedSplatIds?.destroy();
		this.compactedSplatIds = null;
		this._allocatedCompacted = 0;
	}
};

var computeGsplatShadowCullSource = `
const SPLAT_FRUSTUM_SIGMA: f32 = 3.0;
struct CullUniforms {
	frustumPlanes: array<vec4f, 6>,
	numIntervals: u32,
	splatTextureSize: u32,
	alphaClip: f32,
	worldSizeThreshold: f32
};
@group(0) @binding(0) var<uniform> uniforms: CullUniforms;
@group(0) @binding(1) var<storage, read> compactedSplatIds: array<u32>;
@group(0) @binding(2) var<storage, read> candidateCountBuffer: array<u32>;
@group(0) @binding(3) var<storage, read_write> outputIndices: array<u32>;
@group(0) @binding(4) var<storage, read_write> globalCount: array<atomic<u32>>;
#include "gsplatComputeSplatCS"
#include "gsplatFormatDeclCS"
#include "gsplatFormatReadCS"
#include "gsplatHelpersVS"
#include "gsplatModifyVS"
fn fineCull(splatId: u32) -> bool {
	setSplat(splatId);
	let originalCenter = getCenter();
	var center = originalCenter;
	modifySplatCenter(&center);
	let opacity = getOpacity();
	if (opacity <= uniforms.alphaClip) {
		return false;
	}
	var rotation: vec4f = getRotation().yzwx;
	var scale: vec3f = getScale();
	modifySplatRotationScale(originalCenter, center, &rotation, &scale);
	let maxScale = max(scale.x, max(scale.y, scale.z));
	if (maxScale < uniforms.worldSizeThreshold) {
		return false;
	}
	let splatRadius = maxScale * SPLAT_FRUSTUM_SIGMA;
	for (var p = 0; p < 6; p++) {
		let plane = uniforms.frustumPlanes[p];
		if (dot(plane.xyz, center) + plane.w <= -splatRadius) {
			return false;
		}
	}
	return true;
}
var<workgroup> wgCount: atomic<u32>;
var<workgroup> wgBase: u32;
@compute @workgroup_size({WORKGROUP_SIZE})
fn main(
	@builtin(global_invocation_id) gid: vec3u,
	@builtin(num_workgroups) numWorkgroups: vec3u,
	@builtin(local_invocation_index) localIdx: u32
) {
	if (localIdx == 0u) {
		atomicStore(&wgCount, 0u);
	}
	workgroupBarrier();
	let threadIdx = gid.y * (numWorkgroups.x * {WORKGROUP_SIZE}u) + gid.x;
	let candidateCount = candidateCountBuffer[uniforms.numIntervals];
	var valid = false;
	var splatId = 0u;
	if (threadIdx < candidateCount) {
		splatId = compactedSplatIds[threadIdx];
		valid = fineCull(splatId);
	}
	var localSlot = 0u;
	if (valid) {
		localSlot = atomicAdd(&wgCount, 1u);
	}
	workgroupBarrier();
	if (localIdx == 0u) {
		wgBase = atomicAdd(&globalCount[0], atomicLoad(&wgCount));
	}
	workgroupBarrier();
	if (valid) {
		outputIndices[wgBase + localSlot] = splatId;
	}
}
`;

var computeGsplatShadowIndirectArgsSource = `
${indirect_core_default}
@group(0) @binding(0) var<storage, read> countBuffer: array<u32>;
@group(0) @binding(1) var<storage, read_write> indirectDrawArgs: array<DrawIndexedIndirectArgs>;
struct ShadowArgsUniforms {
	drawSlot: u32,
	indexCount: u32,
	pad0: u32,
	pad1: u32
};
@group(0) @binding(2) var<uniform> uniforms: ShadowArgsUniforms;
@compute @workgroup_size(1)
fn main() {
	let count = countBuffer[0];
	let instanceCount = (count + {INSTANCE_SIZE}u - 1u) / {INSTANCE_SIZE}u;
	indirectDrawArgs[uniforms.drawSlot] = DrawIndexedIndirectArgs(
		uniforms.indexCount,
		instanceCount,
		0u,
		0,
		0u
	);
}
`;

var WORKGROUP_SIZE2 = 256;
var INDEX_COUNT3 = 6 * GSplatResourceBase.instanceSize;
var GSplatShadowRenderer = class {
	device;
	node;
	cameraNode;
	layer;
	world;
	entries = /* @__PURE__ */ new Map();
	_desiredLights = /* @__PURE__ */ new Set();
	_compaction = null;
	_cullDispatchSize = new Vec2(1, 1);
	_frustumPlanes = new Float32Array(24);
	_userChunksKey = "";
	_userModifyWgsl = null;
	// The cull/args shaders are shared, but each light entry gets its OWN Compute instances
	// (created in _createEntry). A Compute owns a persistent uniform buffer, so a single shared
	// Compute dispatched once per light per frame would have all dispatches read the last-written
	// uniforms (frustum planes / draw slot) — making all but one light's shadow draw empty.
	_cullShader = null;
	_cullBindGroupFormat = null;
	_cullFormatVersion = -1;
	_cullBuiltChunksKey = null;
	_cullShaderGen = 0;
	_argsShader = null;
	_argsBindGroupFormat = null;
	constructor(device, node, cameraNode, layer, world, scratch = null) {
		this.device = device;
		this.node = node;
		this.cameraNode = cameraNode;
		this.layer = layer;
		this.world = world;
		this._compaction = new GSplatIntervalCompaction(device, scratch);
		this._createArgsShader();
	}
	destroy() {
		this.entries.forEach((entry) => this._destroyEntry(entry));
		this.entries.clear();
		this._compaction?.destroy();
		this._compaction = null;
		this._cullShader?.destroy();
		this._cullBindGroupFormat?.destroy();
		this._argsShader?.destroy();
		this._argsBindGroupFormat?.destroy();
		this._cullShader = null;
		this._argsShader = null;
	}
	_ensureCullShader() {
		const wbFormat = this.world.workBuffer.format;
		const version2 = wbFormat.extraStreamsVersion;
		if (!this._cullShader || version2 !== this._cullFormatVersion || this._userChunksKey !== this._cullBuiltChunksKey) {
			this._cullFormatVersion = version2;
			this._cullBuiltChunksKey = this._userChunksKey;
			this._buildCullShader();
		}
	}
	_buildCullShader() {
		const device = this.device;
		const wbFormat = this.world.workBuffer.format;
		const fixedBindings = [
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE),
			// pass-1 outputs (read): the shared candidate list + its count at [numIntervals]
			new BindStorageBufferFormat("compactedSplatIds", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("candidateCountBuffer", SHADERSTAGE_COMPUTE, true),
			// per-light outputs (read/write): the final visible list + atomic count
			new BindStorageBufferFormat("outputIndices", SHADERSTAGE_COMPUTE, false),
			new BindStorageBufferFormat("globalCount", SHADERSTAGE_COMPUTE, false)
		];
		this._cullBindGroupFormat?.destroy();
		this._cullBindGroupFormat = new BindGroupFormat(device, [
			...fixedBindings,
			...wbFormat.getComputeBindFormats()
		]);
		const uniformBufferFormat = new UniformBufferFormat(device, [
			new UniformFormat("frustumPlanes", UNIFORMTYPE_VEC4, 6),
			new UniformFormat("numIntervals", UNIFORMTYPE_UINT),
			new UniformFormat("splatTextureSize", UNIFORMTYPE_UINT),
			new UniformFormat("alphaClip", UNIFORMTYPE_FLOAT),
			new UniformFormat("worldSizeThreshold", UNIFORMTYPE_FLOAT)
		]);
		const cincludes = /* @__PURE__ */ new Map();
		cincludes.set("gsplatComputeSplatCS", gsplatComputeSplat_default);
		cincludes.set("gsplatFormatDeclCS", wbFormat.getComputeInputDeclarations(fixedBindings.length));
		cincludes.set("gsplatFormatReadCS", wbFormat.getReadCode());
		cincludes.set("gsplatHelpersVS", gsplatHelpers_default);
		cincludes.set("gsplatModifyVS", this._userModifyWgsl ?? gsplatModify_default);
		const cdefines = /* @__PURE__ */ new Map([["{WORKGROUP_SIZE}", WORKGROUP_SIZE2.toString()]]);
		const colorStream = wbFormat.getStream("dataColor");
		if (colorStream && colorStream.format !== PIXELFORMAT_RGBA16U) {
			cdefines.set("GSPLAT_COLOR_FLOAT", "");
		}
		this._cullShader?.destroy();
		this._cullShader = new Shader(device, {
			name: "GSplatShadowCull",
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: computeGsplatShadowCullSource,
			cincludes,
			cdefines,
			computeBindGroupFormat: this._cullBindGroupFormat,
			computeUniformBufferFormats: { uniforms: uniformBufferFormat }
		});
		this._cullShaderGen++;
	}
	_createArgsShader() {
		const device = this.device;
		this._argsBindGroupFormat = new BindGroupFormat(device, [
			new BindStorageBufferFormat("countBuffer", SHADERSTAGE_COMPUTE, true),
			new BindStorageBufferFormat("indirectDrawArgs", SHADERSTAGE_COMPUTE, false),
			new BindUniformBufferFormat("uniforms", SHADERSTAGE_COMPUTE)
		]);
		const uniformBufferFormat = new UniformBufferFormat(device, [
			new UniformFormat("drawSlot", UNIFORMTYPE_UINT),
			new UniformFormat("indexCount", UNIFORMTYPE_UINT),
			new UniformFormat("pad0", UNIFORMTYPE_UINT),
			new UniformFormat("pad1", UNIFORMTYPE_UINT)
		]);
		this._argsShader = new Shader(device, {
			name: "GSplatShadowIndirectArgs",
			shaderLanguage: SHADERLANGUAGE_WGSL,
			cshader: computeGsplatShadowIndirectArgsSource,
			cdefines: /* @__PURE__ */ new Map([["{INSTANCE_SIZE}", GSplatResourceBase.instanceSize.toString()]]),
			computeBindGroupFormat: this._argsBindGroupFormat,
			computeUniformBufferFormats: { uniforms: uniformBufferFormat }
		});
	}
	setDataSource(workBuffer) {
		this._compaction?.invalidateUpload();
		this._cullFormatVersion = -1;
		this.entries.forEach((entry) => {
			this._configureMaterialWorkBuffer(entry.material);
			entry.material.update();
		});
	}
	setCastersAabb(aabb3) {
		if (!aabb3) return;
		this.entries.forEach((entry) => {
			entry.meshInstance.setCustomAabb(aabb3);
		});
	}
	syncLights() {
		const lights2 = this.layer.splitLights[LIGHTTYPE_DIRECTIONAL];
		const desired = this._desiredLights;
		desired.clear();
		for (let i2 = 0; i2 < lights2.length; i2++) {
			const light = lights2[i2];
			if (!light.enabled || !light.castShadows) continue;
			if (light.numCascades !== 1) {
				continue;
			}
			desired.add(light);
		}
		this.entries.forEach((entry, light) => {
			if (!desired.has(light)) {
				this._destroyEntry(entry);
				this.entries.delete(light);
			}
		});
		desired.forEach((light) => {
			if (!this.entries.has(light)) {
				this.entries.set(light, this._createEntry(light));
			}
		});
	}
	cull(gsplatParams) {
		const worldState = this.world.getState(this.world.currentVersion);
		const ready = worldState && worldState.sortedBefore && worldState.totalActiveSplats > 0;
		if (!ready) {
			this.entries.forEach((entry) => {
				entry.meshInstance.visible = false;
			});
			return;
		}
		this._compaction.uploadIntervals(worldState);
		this.world.workBuffer.frustumCuller.updateTransformsData(worldState.boundsGroups);
		this._syncUserModify(gsplatParams);
		this._ensureCullShader();
		const numIntervals = worldState.totalIntervals;
		const totalActiveSplats = worldState.totalActiveSplats;
		const textureSize = this.world.workBuffer.textureSize;
		this.entries.forEach((entry) => {
			this._cullEntry(entry, numIntervals, totalActiveSplats, textureSize, gsplatParams);
		});
	}
	_syncUserModify(gsplatParams) {
		const userMat = gsplatParams.material;
		if (!userMat) return;
		const chunksKey = userMat.shaderChunks?.key ?? "";
		if (chunksKey !== this._userChunksKey) {
			this._userChunksKey = chunksKey;
			this._userModifyWgsl = userMat.getShaderChunks?.("wgsl")?.get("gsplatModifyVS") ?? null;
			this.entries.forEach((entry) => this._applyUserModify(entry));
		}
		const params = userMat.parameters;
		this.entries.forEach((entry) => {
			for (const name in params) {
				if (params.hasOwnProperty(name)) {
					entry.material.setParameter(name, params[name].data);
				}
			}
		});
	}
	_applyUserModify(entry) {
		const wgsl = entry.material.shaderChunks.wgsl;
		if (this._userModifyWgsl) {
			wgsl.set("gsplatModifyVS", this._userModifyWgsl);
		} else {
			wgsl.delete("gsplatModifyVS");
		}
		entry.material.update();
	}
	_cullEntry(entry, numIntervals, totalActiveSplats, textureSize, gsplatParams) {
		const device = this.device;
		const sceneCamera = this.cameraNode.camera?.camera;
		const shadowCamera = sceneCamera && entry.light.getRenderData(sceneCamera, 0).shadowCamera;
		const frustum = shadowCamera && shadowCamera.frustum;
		const frustumCuller = this.world.workBuffer.frustumCuller;
		if (!frustum || !frustumCuller?.boundsBuffer || !frustumCuller?.transformsBuffer) {
			entry.meshInstance.visible = false;
			return;
		}
		this._fillFrustumPlanes(frustum);
		const orthoHeight = shadowCamera.orthoHeight;
		const shadowRes = entry.light._shadowResolution;
		const minPixelSize = gsplatParams.minPixelSize;
		const focal = orthoHeight > 0 && shadowRes > 0 ? shadowRes / orthoHeight : 0;
		const t2 = minPixelSize * minPixelSize * 0.5 - 0.3;
		const worldSizeThreshold = focal > 0 && t2 > 0 ? Math.sqrt(t2) / focal : 0;
		if (totalActiveSplats > entry.allocatedIndexCount) {
			entry.indexBuffer?.destroy();
			entry.allocatedIndexCount = totalActiveSplats;
			entry.indexBuffer = new StorageBuffer(device, totalActiveSplats * 4);
		}
		const compaction = this._compaction;
		compaction.dispatchCompact({
			boundsBuffer: frustumCuller.boundsBuffer,
			transformsBuffer: frustumCuller.transformsBuffer,
			frustumPlanes: this._frustumPlanes
		}, numIntervals, totalActiveSplats, false);
		entry.countBuffer.clear();
		if (!entry.cullCompute || entry.cullComputeGen !== this._cullShaderGen) {
			entry.cullCompute?.destroy();
			entry.cullCompute = new Compute(device, this._cullShader, "GSplatShadowCull");
			entry.cullComputeGen = this._cullShaderGen;
		}
		const cull = entry.cullCompute;
		const userMat = gsplatParams.material;
		if (userMat) {
			const srcParams = userMat.parameters;
			for (const name in srcParams) {
				if (srcParams.hasOwnProperty(name)) {
					cull.setParameter(name, srcParams[name].data);
				}
			}
		}
		cull.setParameter("compactedSplatIds", compaction.compactedSplatIds);
		cull.setParameter("candidateCountBuffer", compaction.countBuffer);
		cull.setParameter("outputIndices", entry.indexBuffer);
		cull.setParameter("globalCount", entry.countBuffer);
		cull.setParameter("frustumPlanes[0]", this._frustumPlanes);
		cull.setParameter("numIntervals", numIntervals);
		cull.setParameter("splatTextureSize", textureSize);
		cull.setParameter("alphaClip", gsplatParams.alphaClip);
		cull.setParameter("worldSizeThreshold", worldSizeThreshold);
		const workBuffer = this.world.workBuffer;
		for (const stream of workBuffer.format.resourceStreams) {
			const texture = workBuffer.getTexture(stream.name);
			if (texture) {
				cull.setParameter(stream.name, texture);
			}
		}
		const workgroupCount = Math.ceil(totalActiveSplats / WORKGROUP_SIZE2);
		Compute.calcDispatchSize(workgroupCount, this._cullDispatchSize, device.limits.maxComputeWorkgroupsPerDimension || 65535);
		cull.setupDispatch(this._cullDispatchSize.x, this._cullDispatchSize.y, 1);
		device.computeDispatch([cull], "GSplatShadowCull");
		const drawSlot = device.getIndirectDrawSlot(1);
		const args = entry.argsCompute;
		args.setParameter("countBuffer", entry.countBuffer);
		args.setParameter("indirectDrawArgs", device.indirectDrawBuffer);
		args.setParameter("drawSlot", drawSlot);
		args.setParameter("indexCount", INDEX_COUNT3);
		args.setParameter("pad0", 0);
		args.setParameter("pad1", 0);
		args.setupDispatch(1);
		device.computeDispatch([args], "GSplatShadowIndirectArgs");
		const material = entry.material;
		entry.meshInstance.setIndirect(null, drawSlot, 1);
		material.setParameter("compactedSplatIds", entry.indexBuffer);
		material.setParameter("numSplatsStorage", entry.countBuffer);
		material.setParameter("splatTextureSize", textureSize);
		material.setParameter("alphaClip", gsplatParams.alphaClip);
		entry.meshInstance.visible = true;
		if (entry.meshInstance.instancingCount <= 0) {
			entry.meshInstance.instancingCount = 1;
		}
	}
	_fillFrustumPlanes(frustum) {
		const p = this._frustumPlanes;
		for (let i2 = 0; i2 < 6; i2++) {
			const plane2 = frustum.planes[i2];
			p[i2 * 4 + 0] = plane2.normal.x;
			p[i2 * 4 + 1] = plane2.normal.y;
			p[i2 * 4 + 2] = plane2.normal.z;
			p[i2 * 4 + 3] = plane2.distance;
		}
	}
	_createEntry(light) {
		const device = this.device;
		const material = this._createMaterial();
		const meshInstance = this._createMeshInstance(light, material);
		meshInstance.castShadow = true;
		this.layer.addShadowCasters([meshInstance]);
		const countBuffer = new StorageBuffer(device, 4, BUFFERUSAGE_COPY_DST);
		const argsCompute = new Compute(device, this._argsShader, "GSplatShadowIndirectArgs");
		const entry = {
			light,
			material,
			meshInstance,
			indexBuffer: null,
			allocatedIndexCount: 0,
			countBuffer,
			cullCompute: null,
			cullComputeGen: -1,
			argsCompute
		};
		this._applyUserModify(entry);
		return entry;
	}
	_destroyEntry(entry) {
		this.layer.removeShadowCasters([entry.meshInstance]);
		entry.meshInstance.destroy();
		entry.material.destroy();
		entry.indexBuffer?.destroy();
		entry.countBuffer.destroy();
		entry.cullCompute?.destroy();
		entry.argsCompute.destroy();
	}
	_createMaterial() {
		const material = new ShaderMaterial({
			uniqueName: "GSplatShadowMaterial",
			vertexGLSL: '#include "gsplatVS"',
			fragmentGLSL: '#include "gsplatPS"',
			vertexWGSL: '#include "gsplatVS"',
			fragmentWGSL: '#include "gsplatPS"',
			attributes: {
				vertex_position: SEMANTIC_POSITION
			}
		});
		material.setDefine("{GSPLAT_INSTANCE_SIZE}", GSplatResourceBase.instanceSize);
		material.setDefine("SH_BANDS", "0");
		material.setDefine("GSPLAT_SEPARATE_OPACITY", "");
		material.setDefine("DITHER_NONE", "");
		material.setDefine("GSPLAT_INDIRECT_DRAW", true);
		this._configureMaterialWorkBuffer(material);
		material.cull = CULLFACE_NONE;
		material.blendType = BLEND_PREMULTIPLIED;
		material.depthWrite = false;
		material.update();
		return material;
	}
	_configureMaterialWorkBuffer(material) {
		const workBuffer = this.world.workBuffer;
		const wbFormat = workBuffer.format;
		const chunks = this.device.isWebGPU ? material.shaderChunks.wgsl : material.shaderChunks.glsl;
		chunks.set("gsplatDeclarationsVS", wbFormat.getInputDeclarations());
		chunks.set("gsplatReadVS", wbFormat.getReadCode());
		const colorStream = wbFormat.getStream("dataColor");
		if (colorStream && colorStream.format !== PIXELFORMAT_RGBA16U) {
			material.setDefine("GSPLAT_COLOR_FLOAT", "");
		}
		const hasPcId = !!wbFormat.getStream("pcId");
		material.setDefine("GSPLAT_UNIFIED_ID", hasPcId);
		material.setDefine("PICK_CUSTOM_ID", hasPcId);
		for (const stream of wbFormat.resourceStreams) {
			const texture = workBuffer.getTexture(stream.name);
			if (texture) {
				material.setParameter(stream.name, texture);
			}
		}
	}
	_createMeshInstance(light, material) {
		const mesh = GSplatResourceBase.createMesh(this.device);
		const meshInstance = new MeshInstance(mesh, material);
		meshInstance.node = this.node;
		meshInstance.setInstancing(true, true);
		meshInstance.instancingCount = 0;
		meshInstance.pick = false;
		const cameraNode = this.cameraNode;
		meshInstance.isVisibleFunc = (camera) => {
			const sceneCamera = cameraNode.camera?.camera;
			if (!sceneCamera) return false;
			return camera === light.getRenderData(sceneCamera, 0).shadowCamera;
		};
		return meshInstance;
	}
};

var cameraPosition3 = new Vec3();
var cameraDirection2 = new Vec3();
var translation = new Vec3();
var invModelMat2 = new Mat4();
var _lodColors2 = [
	new Color(1, 0, 0),
	new Color(0, 1, 0),
	new Color(0, 0, 1),
	new Color(1, 1, 0),
	new Color(1, 0, 1),
	new Color(0, 1, 1),
	new Color(1, 0.5, 0),
	new Color(0.5, 0, 1)
];
var GSplatManager = class {
	device;
	node = new GraphNode("GSplatManager");
	world;
	renderer;
	shadowRenderer = null;
	_hybridScratch = null;
	activeRenderer;
	cpuSorter = null;
	_centersVersions = /* @__PURE__ */ new Map();
	lastSortCameraPos = new Vec3(Infinity, Infinity, Infinity);
	lastSortCameraFwd = new Vec3(Infinity, Infinity, Infinity);
	sortNeeded = true;
	_deviceRestoredEvent = null;
	cameraNode;
	scene;
	renderMode;
	_updateResult = { newVersion: false, overdrawDirty: false, sortNeeded: false };
	_bakeResult = { rebuilt: false, count: 0, textureSize: 0, sortNeeded: false };
	_markResult = { rebuilt: false, count: 0, textureSize: 0 };
	_formatResult = { bufferRecreated: false, sortNeeded: false };
	_lastStreamToken = -1;
	_streamAdvanced = false;
	_renderViewParams = {};
	_pickParams = {};
	constructor(device, director, layer, cameraNode) {
		this.device = device;
		this.scene = director.scene;
		this.director = director;
		this.cameraNode = cameraNode;
		this.world = new GSplatWorld(device, this.scene);
		this.layer = layer;
		this._createRenderer(this.scene.gsplat.currentRenderer);
		this._deviceRestoredEvent = this.device.on("devicerestored", this._onDeviceRestored, this);
	}
	destroy() {
		this._destroyed = true;
		this._deviceRestoredEvent?.off();
		this._deviceRestoredEvent = null;
		this.destroyCpuSorting();
		this.world.destroy();
		this.renderer.destroy();
		this.shadowRenderer?.destroy();
		this.shadowRenderer = null;
		this._hybridScratch?.destroy();
		this._hybridScratch = null;
	}
	_onDeviceRestored() {
		if (this.world.hasOctreeInstances) return;
		this.world.invalidate({ workBuffer: true });
		this.sortNeeded = true;
	}
	destroyCpuSorting() {
		this.cpuSorter?.destroy();
		this.cpuSorter = null;
	}
	initCpuSorting() {
		if (!this.cpuSorter) {
			this.cpuSorter = this.createSorter();
		}
		const splats = this.world.invalidateSortState();
		if (splats) {
			this.cpuSorter.updateCentersForSplats(splats);
		}
		this.renderer.setCpuSortedRendering();
	}
	get material() {
		return this.renderer.material;
	}
	get bufferCopyUploaded() {
		return this.world.bufferCopyUploaded;
	}
	get bufferCopyTotal() {
		return this.world.bufferCopyTotal;
	}
	get hasPendingSort() {
		return !!this.cpuSorter?.pendingSorted;
	}
	prepareForPicking(camera, width, height) {
		if (!this.renderer.usesGpuSort || !camera.node) return null;
		const sortedState = this.world.getState(this.world.currentVersion);
		if (!sortedState?.sortedBefore) return null;
		return this.renderer.preparePickingView(this.world, sortedState, this._fillPickParams(camera, width, height));
	}
	_writeGsplatParams(p) {
		const gsplat = this.scene.gsplat;
		p.radialSorting = gsplat.radialSorting;
		p.alphaClip = gsplat.alphaClip;
		p.alphaClipForward = gsplat.alphaClipForward;
		p.minPixelSize = gsplat.minPixelSize;
		p.minContribution = gsplat.minContribution;
		p.foveationStrength = gsplat.foveationStrength;
		p.foveationCenter = gsplat.foveationCenter;
		p.antiAlias = gsplat.antiAlias;
		p.fisheye = gsplat.fisheye;
		p.material = gsplat.material;
		p.varyings = gsplat.varyings;
	}
	_fillRenderViewParams() {
		const p = this._renderViewParams;
		this._writeGsplatParams(p);
		p.cameraNode = this.cameraNode;
		return p;
	}
	_fillPickParams(camera, width, height) {
		const p = this._pickParams;
		this._writeGsplatParams(p);
		p.cameraNode = camera.node;
		p.width = width;
		p.height = height;
		return p;
	}
	createSorter() {
		const sorter = new GSplatUnifiedSorter(this.scene);
		sorter.on("sorted", (count, version2, orderData) => {
			this.onSorted(count, version2, orderData);
		});
		return sorter;
	}
	setRenderMode(renderMode) {
		this.renderMode = renderMode;
		this.renderer.setRenderMode(renderMode);
		this._syncShadowRenderer();
	}
	_syncShadowRenderer() {
		const wantShadow = !!(this.renderMode & GSPLAT_SHADOW) && this.renderer.usesGpuSort;
		if (wantShadow && !this.shadowRenderer) {
			this.shadowRenderer = new GSplatShadowRenderer(this.device, this.node, this.cameraNode, this.layer, this.world, this._hybridScratch);
		} else if (!wantShadow && this.shadowRenderer) {
			this.shadowRenderer.destroy();
			this.shadowRenderer = null;
		}
		if (!this.renderer.usesGpuSort && this._hybridScratch) {
			this._hybridScratch.destroy();
			this._hybridScratch = null;
		}
	}
	_createRenderer(mode) {
		const workBuffer = this.world.workBuffer;
		if (mode === GSPLAT_RENDERER_RASTER_GPU_SORT) {
			this._hybridScratch ?? (this._hybridScratch = new GSplatHybridRendererScratch(this.device));
			this.renderer = new GSplatHybridRenderer(this.device, this.node, this.cameraNode, this.layer, workBuffer, this._hybridScratch);
		} else {
			this.renderer = new GSplatQuadRenderer(this.device, this.node, this.cameraNode, this.layer, workBuffer);
			this.initCpuSorting();
		}
		this.activeRenderer = mode;
	}
	prepareRendererMode() {
		const requested = this.scene.gsplat.currentRenderer;
		if (requested === this.activeRenderer) return;
		this.world.invalidate({ worldState: true });
		this.destroyCpuSorting();
		this.renderer.destroy();
		this._createRenderer(requested);
		this.renderer.setRenderMode(this.renderMode);
		this._syncShadowRenderer();
		this.world.invalidate({ workBuffer: true });
		this.sortNeeded = true;
	}
	reconcile(placements) {
		this.world.reconcile(placements);
	}
	onSorted(count, version2, orderData) {
		const updateBounds = this.renderer.requiresBounds;
		const result = this.world.onSorted(version2, count, orderData, this.cameraNode, updateBounds, this._markResult);
		if (result.rebuilt) {
			this.renderer.update(result.count, result.textureSize);
		}
		this.renderer.setOrderData();
	}
	_markSortedIfNeeded(worldState) {
		if (!worldState.sortedBefore) {
			this.world.markSorted(worldState.version, worldState.totalActiveSplats, this.cameraNode, true, this._markResult);
			if (this._markResult.rebuilt) {
				this.renderer.update(this._markResult.count, this._markResult.textureSize);
			}
		}
	}
	testCameraMovedForSort() {
		const epsilon = 1e-3;
		if (this.scene.gsplat.radialSorting) {
			const currentCameraPos = this.cameraNode.getPosition();
			return this.lastSortCameraPos.distance(currentCameraPos) > epsilon;
		}
		if (Number.isFinite(this.lastSortCameraFwd.x)) {
			const currentCameraFwd = this.cameraNode.forward;
			const dot = Math.min(1, Math.max(-1, this.lastSortCameraFwd.dot(currentCameraFwd)));
			return Math.acos(dot) > epsilon;
		}
		return true;
	}
	fireFrameReadyEvent() {
		const ready = this.world.currentVersion === this.world.lastWorldStateVersion && !this.world.awaitingLodUpdate;
		const loadingCount = this.world.pendingLoadCount;
		this.director.eventHandler.fire("frame:ready", this.cameraNode.camera, this.renderer.layer, ready, loadingCount);
	}
	updateStreaming(token) {
		if (token === this._lastStreamToken) return this._streamAdvanced;
		this._lastStreamToken = token;
		this.world.syncFormat(this._formatResult);
		if (this._formatResult.bufferRecreated) {
			this.renderer.setDataSource(this.world.workBuffer);
			this.shadowRenderer?.setDataSource(this.world.workBuffer);
		}
		if (this._formatResult.sortNeeded) this.sortNeeded = true;
		this.prepareRendererMode();
		const allowLodUpdate = !this.renderer.requiresCpuSort || this.cpuSorter && this.cpuSorter.jobsInFlight < 3;
		this.world.update(this.cameraNode, allowLodUpdate, !!this.cpuSorter, this._updateResult);
		if (this._updateResult.overdrawDirty) this.renderer.updateOverdrawMode(this.scene.gsplat);
		if (this._updateResult.sortNeeded) this.sortNeeded = true;
		if (this._updateResult.newVersion) this._feedCpuSorterCenters();
		this.world.tickCooldowns();
		this._streamAdvanced = this._updateResult.newVersion || this._formatResult.bufferRecreated;
		return this._streamAdvanced;
	}
	update() {
		this.world.resetFrameStats();
		this.updateStreaming(this.director._streamToken);
		if (this.cpuSorter) {
			this.cpuSorter.applyPendingSorted();
		}
		if (this.testCameraMovedForSort()) {
			this.sortNeeded = true;
		}
		const lastState = this.world.getState(this.world.lastWorldStateVersion);
		if (lastState) {
			if (this.cpuSorter && !lastState.sortParametersSet) {
				lastState.sortParametersSet = true;
				const payload = this.world.prepareSortParameters(lastState);
				this.cpuSorter.setSortParameters(payload);
			}
		}
		const updateBounds = this.renderer.requiresBounds;
		this.world.bake(this.world.currentVersion, this.cameraNode, updateBounds, this._bakeResult);
		if (this._bakeResult.rebuilt) {
			this.renderer.update(this._bakeResult.count, this._bakeResult.textureSize);
			this.renderer.setOrderData();
			this.renderer.invalidateCullUpload();
		}
		if (this._bakeResult.sortNeeded) this.sortNeeded = true;
		if (lastState) {
			if (this.renderer.usesGpuSort) {
				this._markSortedIfNeeded(lastState);
				if (this.renderMode & GSPLAT_FORWARD) {
					this.renderer.prepareRenderView(this.world, lastState, this._fillRenderViewParams());
				}
			} else if (this.sortNeeded) {
				this.sortCpu(lastState);
			}
			if (this.sortNeeded) {
				this.sortNeeded = false;
				this.lastSortCameraPos.copy(this.cameraNode.getPosition());
				this.lastSortCameraFwd.copy(this.cameraNode.forward);
			}
		}
		this.shadowRenderer?.syncLights();
		const aggregateAabb = this.world.computeAggregateAabb();
		this.renderer?.meshInstance?.setCustomAabb(aggregateAabb);
		this.shadowRenderer?.setCastersAabb(aggregateAabb);
		this.fireFrameReadyEvent();
		if (this.scene.gsplat.dirty) {
			this.world.markInstancesNeedLodUpdate();
		}
		const fogParams = this.scene.gsplat.useFog ? this.cameraNode.camera.fogParams ?? this.scene.fog : null;
		this.renderer.frameUpdate(this.scene.gsplat, this.scene.exposure, fogParams);
		const sortedState = this.world.getState(this.world.currentVersion);
		return sortedState ? sortedState.totalActiveSplats : 0;
	}
	updateShadows() {
		this.shadowRenderer?.cull(this.scene.gsplat);
	}
	_feedCpuSorterCenters() {
		if (!this.cpuSorter) return;
		const state = this.world.getState(this.world.lastWorldStateVersion);
		if (!state) return;
		const splats = state.splats;
		for (const splat of splats) {
			const resource = splat.resource;
			const lastVersion = this._centersVersions.get(resource.id);
			if (lastVersion !== resource.centersVersion) {
				this._centersVersions.set(resource.id, resource.centersVersion);
				this.cpuSorter.setCenters(resource.id, null);
				this.cpuSorter.setCenters(resource.id, resource.centers);
			}
		}
		this.cpuSorter.updateCentersForSplats(splats);
	}
	sortCpu(lastState) {
		if (!this.cpuSorter) return;
		const cameraNode = this.cameraNode;
		const cameraMat = cameraNode.getWorldTransform();
		cameraMat.getTranslation(cameraPosition3);
		cameraMat.getZ(cameraDirection2).normalize();
		const sorterRequest = [];
		lastState.splats.forEach((splat) => {
			const modelMat = splat.node.getWorldTransform();
			invModelMat2.copy(modelMat).invert();
			const uniformScale2 = modelMat.getScale().x;
			const transformedDirection = invModelMat2.transformVector(cameraDirection2).normalize();
			const transformedPosition = invModelMat2.transformPoint(cameraPosition3);
			modelMat.getTranslation(translation);
			const offset3 = translation.sub(cameraPosition3).dot(cameraDirection2);
			const aabbMin = splat.aabb.getMin();
			const aabbMax = splat.aabb.getMax();
			sorterRequest.push({
				transformedDirection,
				transformedPosition,
				offset: offset3,
				scale: uniformScale2,
				modelMat: modelMat.data.slice(),
				aabbMin: [aabbMin.x, aabbMin.y, aabbMin.z],
				aabbMax: [aabbMax.x, aabbMax.y, aabbMax.z]
			});
		});
		this.cpuSorter.setSortParams(sorterRequest, this.scene.gsplat.radialSorting);
	}
};

var SetUtils = class {
	static equals(setA, setB) {
		if (setA.size !== setB.size) {
			return false;
		}
		for (const elem of setA) {
			if (!setB.has(elem)) {
				return false;
			}
		}
		return true;
	}
};

var tempLayersToRemove = [];
var GSplatLayerData = class {
	gsplatManager = null;
	gsplatManagerShadow = null;
	constructor(device, director, layer, camera) {
		this.updateConfiguration(device, director, layer, camera);
	}
	createManager(device, director, layer, cameraNode, camera, renderMode) {
		const manager = new GSplatManager(device, director, layer, cameraNode);
		manager.setRenderMode(renderMode);
		if (director.eventHandler) {
			director.eventHandler.fire("material:created", manager.material, camera, layer);
		}
		return manager;
	}
	updateConfiguration(device, director, layer, camera) {
		const cameraNode = camera.node;
		const hasNormalPlacements = layer.gsplatPlacements.length > 0;
		const hasShadowCasters = layer.gsplatShadowCasters.length > 0;
		const setsEqual = SetUtils.equals(layer.gsplatPlacementsSet, layer.gsplatShadowCastersSet);
		const useSharedManager = setsEqual && hasNormalPlacements;
		const desiredMainMode = useSharedManager ? GSPLAT_FORWARD | GSPLAT_SHADOW : hasNormalPlacements ? GSPLAT_FORWARD : 0;
		const desiredShadowMode = useSharedManager ? 0 : hasShadowCasters ? GSPLAT_SHADOW : 0;
		if (desiredMainMode) {
			if (this.gsplatManager) {
				this.gsplatManager.setRenderMode(desiredMainMode);
			} else {
				this.gsplatManager = this.createManager(device, director, layer, cameraNode, camera, desiredMainMode);
			}
		} else if (this.gsplatManager) {
			this.gsplatManager.destroy();
			this.gsplatManager = null;
		}
		if (desiredShadowMode) {
			if (this.gsplatManagerShadow) {
				this.gsplatManagerShadow.setRenderMode(desiredShadowMode);
			} else {
				this.gsplatManagerShadow = this.createManager(device, director, layer, cameraNode, camera, desiredShadowMode);
			}
		} else if (this.gsplatManagerShadow) {
			this.gsplatManagerShadow.destroy();
			this.gsplatManagerShadow = null;
		}
	}
	destroy() {
		this.gsplatManager?.destroy();
		this.gsplatManager = null;
		this.gsplatManagerShadow?.destroy();
		this.gsplatManagerShadow = null;
	}
};
var GSplatCameraData = class {
	layersMap = /* @__PURE__ */ new Map();
	destroy() {
		this.layersMap.forEach((layerData) => layerData.destroy());
		this.layersMap.clear();
	}
	removeLayerData(layer) {
		const layerData = this.layersMap.get(layer);
		if (layerData) {
			layerData.destroy();
			this.layersMap.delete(layer);
		}
	}
	getLayerData(device, director, layer, camera) {
		let layerData = this.layersMap.get(layer);
		if (!layerData) {
			layerData = new GSplatLayerData(device, director, layer, camera);
			this.layersMap.set(layer, layerData);
		}
		return layerData;
	}
};
var GSplatDirector = class {
	device;
	camerasMap = /* @__PURE__ */ new Map();
	scene;
	eventHandler;
	_streamToken = 0;
	constructor(device, renderer, scene, eventHandler) {
		this.device = device;
		this.renderer = renderer;
		this.scene = scene;
		this.eventHandler = eventHandler;
	}
	destroy() {
		this.camerasMap.forEach((cameraData) => cameraData.destroy());
		this.camerasMap.clear();
	}
	getCameraData(camera) {
		let cameraData = this.camerasMap.get(camera);
		if (!cameraData) {
			cameraData = new GSplatCameraData();
			this.camerasMap.set(camera, cameraData);
		}
		return cameraData;
	}
	prepareForPicking(camera, width, height, layer) {
		const cameraData = this.camerasMap.get(camera);
		if (!cameraData) return null;
		const layerData = cameraData.layersMap.get(layer);
		if (!layerData?.gsplatManager) return null;
		return layerData.gsplatManager.prepareForPicking(camera, width, height);
	}
	updateStreaming() {
		this.scene.gsplat.frameUpdate();
		GSplatResourceCleanup.process(this.device);
		const token = ++this._streamToken;
		let needRender = false;
		let streamed = false;
		this.camerasMap.forEach((cameraData) => {
			cameraData.layersMap.forEach((layerData) => {
				const manager = layerData.gsplatManager;
				if (manager) {
					needRender = manager.updateStreaming(token) || needRender;
					needRender = manager.hasPendingSort || needRender;
					streamed = true;
				}
				const shadowManager = layerData.gsplatManagerShadow;
				if (shadowManager) {
					needRender = shadowManager.updateStreaming(token) || needRender;
					needRender = shadowManager.hasPendingSort || needRender;
					streamed = true;
				}
			});
		});
		if (streamed) {
			this.scene.gsplat.dirty = false;
		}
		if (needRender) {
			this.eventHandler.fire("frame:request");
		}
	}
	update(comp) {
		this.camerasMap.forEach((cameraData, camera) => {
			if (!comp.camerasSet.has(camera)) {
				cameraData.destroy();
				this.camerasMap.delete(camera);
			} else {
				cameraData.layersMap.forEach((layerData, layer) => {
					if (!camera.layersSet.has(layer.id) || !layer.enabled) {
						tempLayersToRemove.push(layer);
					}
				});
				for (let i2 = 0; i2 < tempLayersToRemove.length; i2++) {
					const layer = tempLayersToRemove[i2];
					const layerData = cameraData.layersMap.get(layer);
					if (layerData) {
						layerData.destroy();
						cameraData.layersMap.delete(layer);
					}
				}
				tempLayersToRemove.length = 0;
			}
		});
		let gsplatCount = 0;
		let bufferCopyUploaded = 0;
		let bufferCopyTotal = 0;
		const camerasComponents = comp.cameras;
		for (let i2 = 0; i2 < camerasComponents.length; i2++) {
			const camera = camerasComponents[i2].camera;
			let cameraData = this.camerasMap.get(camera);
			const layerIds = camera.layers;
			for (let j = 0; j < layerIds.length; j++) {
				const layer = comp.getLayerById(layerIds[j]);
				if (layer?.enabled) {
					if (layer.gsplatPlacementsDirty || !cameraData) {
						const hasNormalPlacements = layer.gsplatPlacements.length > 0;
						const hasShadowCasters = layer.gsplatShadowCasters.length > 0;
						if (!hasNormalPlacements && !hasShadowCasters) {
							if (cameraData) {
								cameraData.removeLayerData(layer);
							}
						} else {
							cameraData ?? (cameraData = this.getCameraData(camera));
							const layerData = cameraData.getLayerData(this.device, this, layer, camera);
							layerData.updateConfiguration(this.device, this, layer, camera);
							if (layerData.gsplatManager) {
								layerData.gsplatManager.reconcile(layer.gsplatPlacements);
							}
							if (layerData.gsplatManagerShadow) {
								layerData.gsplatManagerShadow.reconcile(layer.gsplatShadowCasters);
							}
						}
					}
				}
			}
			if (cameraData) {
				for (const layerData of cameraData.layersMap.values()) {
					if (layerData.gsplatManager) {
						gsplatCount += layerData.gsplatManager.update();
						bufferCopyUploaded += layerData.gsplatManager.bufferCopyUploaded;
						bufferCopyTotal += layerData.gsplatManager.bufferCopyTotal;
					}
					if (layerData.gsplatManagerShadow) {
						gsplatCount += layerData.gsplatManagerShadow.update();
						bufferCopyUploaded += layerData.gsplatManagerShadow.bufferCopyUploaded;
						bufferCopyTotal += layerData.gsplatManagerShadow.bufferCopyTotal;
					}
				}
			}
		}
		this.renderer._gsplatCount = gsplatCount;
		this.renderer._gsplatBufferCopy = bufferCopyTotal > 0 ? bufferCopyUploaded / bufferCopyTotal * 100 : 0;
		this.scene.gsplat.frameEnd();
		for (let i2 = 0; i2 < comp.layerList.length; i2++) {
			comp.layerList[i2].gsplatPlacementsDirty = false;
		}
	}
	updateShadows() {
		this.camerasMap.forEach((cameraData) => {
			cameraData.layersMap.forEach((layerData) => {
				layerData.gsplatManager?.updateShadows();
				layerData.gsplatManagerShadow?.updateShadows();
			});
		});
	}
};

var GSplatComponent = class extends Component {
	_layers = [LAYERID_WORLD];
	// assign to the default world layer
	_instance = null;
	_placement = null;
	_id = PickerId.get();
	_materialTmp = null;
	_lodBaseDistance = 5;
	_lodMultiplier = 3;
	_lodRangeMin = 0;
	_lodRangeMax = 99;
	_customAabb = null;
	_assetReference;
	_resource = null;
	_evtLayersChanged = null;
	_evtLayerAdded = null;
	_evtLayerRemoved = null;
	_castShadows = false;
	_unified = true;
	_parameters = /* @__PURE__ */ new Map();
	_workBufferUpdate = WORKBUFFER_UPDATE_AUTO;
	_workBufferModifier = null;
	constructor(system, entity) {
		super(system, entity);
		this._assetReference = new AssetReference(
			"asset",
			this,
			system.app.assets,
			{
				add: this._onGSplatAssetAdded,
				load: this._onGSplatAssetLoad,
				remove: this._onGSplatAssetRemove,
				unload: this._onGSplatAssetUnload
			},
			this
		);
		entity.on("remove", this.onRemoveChild, this);
		entity.on("removehierarchy", this.onRemoveChild, this);
		entity.on("insert", this.onInsertChild, this);
		entity.on("inserthierarchy", this.onInsertChild, this);
	}
	set customAabb(value) {
		this._customAabb = value;
		this._instance?.meshInstance?.setCustomAabb(this._customAabb);
		if (this._placement) {
			this._placement.aabb = this._customAabb;
		}
	}
	get customAabb() {
		return this._customAabb ?? this._placement?.aabb ?? this.resource?.aabb ?? null;
	}
	set instance(value) {
		if (this.unified) {
			return;
		}
		this.destroyInstance();
		this._instance = value;
		if (this._instance) {
			const mi = this._instance.meshInstance;
			if (!mi.node) {
				mi.node = this.entity;
			}
			mi.castShadow = this._castShadows;
			mi.setCustomAabb(this._customAabb);
			if (this.enabled && this.entity.enabled) {
				this.addToLayers();
			}
		}
	}
	get instance() {
		if (this.unified) {
		}
		return this._instance;
	}
	set material(value) {
		if (this.unified) {
			return;
		}
		if (this._instance) {
			this._instance.material = value;
		} else {
			this._materialTmp = value;
		}
	}
	get material() {
		if (this.unified) {
			return null;
		}
		return this._instance?.material ?? this._materialTmp ?? null;
	}
	set castShadows(value) {
		if (this._castShadows !== value) {
			const layers = this.layers;
			const scene = this.system.app.scene;
			if (this._placement) {
				if (value) {
					for (let i2 = 0; i2 < layers.length; i2++) {
						const layer = scene.layers.getLayerById(layers[i2]);
						layer?.addGSplatShadowCaster(this._placement);
					}
				} else {
					for (let i2 = 0; i2 < layers.length; i2++) {
						const layer = scene.layers.getLayerById(layers[i2]);
						layer?.removeGSplatShadowCaster(this._placement);
					}
				}
			}
			const mi = this._instance?.meshInstance;
			if (mi) {
				if (this._castShadows && !value) {
					for (let i2 = 0; i2 < layers.length; i2++) {
						const layer = scene.layers.getLayerById(this.layers[i2]);
						layer?.removeShadowCasters([mi]);
					}
				}
				mi.castShadow = value;
				if (!this._castShadows && value) {
					for (let i2 = 0; i2 < layers.length; i2++) {
						const layer = scene.layers.getLayerById(layers[i2]);
						layer?.addShadowCasters([mi]);
					}
				}
			}
			this._castShadows = value;
		}
	}
	get castShadows() {
		return this._castShadows;
	}
	set lodBaseDistance(value) {
		this._lodBaseDistance = Math.max(0.1, value);
		if (this._placement) {
			this._placement.lodBaseDistance = this._lodBaseDistance;
		}
	}
	get lodBaseDistance() {
		return this._lodBaseDistance;
	}
	set lodMultiplier(value) {
		this._lodMultiplier = Math.max(1.2, value);
		if (this._placement) {
			this._placement.lodMultiplier = this._lodMultiplier;
		}
	}
	get lodMultiplier() {
		return this._lodMultiplier;
	}
	set lodRangeMin(value) {
		this._lodRangeMin = value;
		if (this._placement) {
			this._placement.lodRangeMin = value;
		}
	}
	get lodRangeMin() {
		return this._lodRangeMin;
	}
	set lodRangeMax(value) {
		this._lodRangeMax = value;
		if (this._placement) {
			this._placement.lodRangeMax = value;
		}
	}
	get lodRangeMax() {
		return this._lodRangeMax;
	}
	set lodDistances(value) {
		if (Array.isArray(value) && value.length > 0) {
			this.lodBaseDistance = value[0];
			this.lodMultiplier = 3;
		}
	}
	get lodDistances() {
		return [];
	}
	set splatBudget(value) {
	}
	get splatBudget() {
		return 0;
	}
	set unified(value) {
		if (value === false) {
		}
		if (this._unified !== value) {
			this._unified = value;
			this._onGSplatAssetAdded();
		}
	}
	get unified() {
		return this._unified;
	}
	get id() {
		return this._id;
	}
	set workBufferUpdate(value) {
		this._workBufferUpdate = value;
		if (this._placement) {
			this._placement.workBufferUpdate = value;
		}
	}
	get workBufferUpdate() {
		return this._workBufferUpdate;
	}
	setWorkBufferModifier(value) {
		if (value) {
			const device = this.system.app.graphicsDevice;
			const code = (device.isWebGPU ? value.wgsl : value.glsl) ?? null;
			this._workBufferModifier = code ? { code, hash: hashCode(code) } : null;
		} else {
			this._workBufferModifier = null;
		}
		if (this._placement) {
			this._placement.workBufferModifier = this._workBufferModifier;
		}
	}
	set layers(value) {
		this.removeFromLayers();
		this._layers.length = 0;
		for (let i2 = 0; i2 < value.length; i2++) {
			this._layers[i2] = value[i2];
		}
		if (!this.enabled || !this.entity.enabled) {
			return;
		}
		this.addToLayers();
	}
	get layers() {
		return this._layers;
	}
	set asset(value) {
		const id14 = value instanceof Asset ? value.id : value;
		if (this._assetReference.id === id14) return;
		if (this._assetReference.asset && this._assetReference.asset.resource) {
			this._onGSplatAssetRemove();
		}
		this._assetReference.id = id14;
		if (this._assetReference.asset) {
			this._onGSplatAssetAdded();
		}
	}
	get asset() {
		return this._assetReference.id;
	}
	set resource(value) {
		if (this._resource === value) return;
		if (this._resource || this._assetReference.asset?.resource) {
			this._onGSplatAssetRemove();
		}
		if (value && this._assetReference.id) {
			this._assetReference.id = null;
		}
		this._resource = value;
		if (this._resource && this.enabled && this.entity.enabled) {
			this._onGSplatAssetLoad();
		}
	}
	get resource() {
		return this._resource ?? this._assetReference.asset?.resource ?? null;
	}
	destroyInstance() {
		if (this._placement) {
			this.removeFromLayers();
			this._placement.destroy();
			this._placement = null;
		}
		if (this._instance) {
			this.removeFromLayers();
			this._instance?.destroy();
			this._instance = null;
		}
	}
	addToLayers() {
		if (this._placement) {
			const layers = this.system.app.scene.layers;
			for (let i2 = 0; i2 < this._layers.length; i2++) {
				const layer = layers.getLayerById(this._layers[i2]);
				if (layer) {
					layer.addGSplatPlacement(this._placement);
					if (this._castShadows) {
						layer.addGSplatShadowCaster(this._placement);
					}
				}
			}
			return;
		}
		const meshInstance = this._instance?.meshInstance;
		if (meshInstance) {
			const layers = this.system.app.scene.layers;
			for (let i2 = 0; i2 < this._layers.length; i2++) {
				layers.getLayerById(this._layers[i2])?.addMeshInstances([meshInstance]);
			}
		}
	}
	removeFromLayers() {
		if (this._placement) {
			const layers = this.system.app.scene.layers;
			for (let i2 = 0; i2 < this._layers.length; i2++) {
				const layer = layers.getLayerById(this._layers[i2]);
				if (layer) {
					layer.removeGSplatPlacement(this._placement);
					layer.removeGSplatShadowCaster(this._placement);
				}
			}
			return;
		}
		const meshInstance = this._instance?.meshInstance;
		if (meshInstance) {
			const layers = this.system.app.scene.layers;
			for (let i2 = 0; i2 < this._layers.length; i2++) {
				layers.getLayerById(this._layers[i2])?.removeMeshInstances([meshInstance]);
			}
		}
	}
	onRemoveChild() {
		this.removeFromLayers();
	}
	onInsertChild() {
		if (this.enabled && this.entity.enabled) {
			if (this._instance || this._placement) {
				this.addToLayers();
			}
		}
	}
	onBeforeRemove() {
		this.destroyInstance();
		this.asset = null;
		this._assetReference.id = null;
		this.entity.off("remove", this.onRemoveChild, this);
		this.entity.off("insert", this.onInsertChild, this);
	}
	onLayersChanged(oldComp, newComp) {
		this.addToLayers();
		oldComp.off("add", this.onLayerAdded, this);
		oldComp.off("remove", this.onLayerRemoved, this);
		newComp.on("add", this.onLayerAdded, this);
		newComp.on("remove", this.onLayerRemoved, this);
	}
	onLayerAdded(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		if (this.unified) return;
		if (this._instance) {
			layer.addMeshInstances(this._instance.meshInstance);
		}
	}
	onLayerRemoved(layer) {
		const index = this.layers.indexOf(layer.id);
		if (index < 0) return;
		if (this.unified) return;
		if (this._instance) {
			layer.removeMeshInstances(this._instance.meshInstance);
		}
	}
	onEnable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		this._evtLayersChanged = scene.on("set:layers", this.onLayersChanged, this);
		if (layers) {
			this._evtLayerAdded = layers.on("add", this.onLayerAdded, this);
			this._evtLayerRemoved = layers.on("remove", this.onLayerRemoved, this);
		}
		if (this._instance || this._placement) {
			this.addToLayers();
		} else if (this.asset) {
			this._onGSplatAssetAdded();
		} else if (this._resource) {
			this._onGSplatAssetLoad();
		}
	}
	onDisable() {
		const scene = this.system.app.scene;
		const layers = scene.layers;
		this._evtLayersChanged?.off();
		this._evtLayersChanged = null;
		if (layers) {
			this._evtLayerAdded?.off();
			this._evtLayerAdded = null;
			this._evtLayerRemoved?.off();
			this._evtLayerRemoved = null;
		}
		this.removeFromLayers();
	}
	hide() {
		if (this._instance) {
			this._instance.meshInstance.visible = false;
		}
	}
	show() {
		if (this._instance) {
			this._instance.meshInstance.visible = true;
		}
	}
	setParameter(name, data2) {
		const scopeId = this.system.app.graphicsDevice.scope.resolve(name);
		this._parameters.set(name, { scopeId, data: data2 });
		if (this._placement) this._placement.markDirty();
	}
	getParameter(name) {
		return this._parameters.get(name)?.data;
	}
	deleteParameter(name) {
		this._parameters.delete(name);
		if (this._placement) this._placement.markDirty();
	}
	getInstanceTexture(name) {
		if (!this._placement) {
			return null;
		}
		return this._placement.getInstanceTexture(name, this.system.app.graphicsDevice) ?? null;
	}
	_onGSplatAssetAdded() {
		if (!this._assetReference.asset) {
			return;
		}
		if (this._assetReference.asset.resource) {
			this._onGSplatAssetLoad();
		} else if (this.enabled && this.entity.enabled) {
			this.system.app.assets.load(this._assetReference.asset);
		}
	}
	_onGSplatAssetLoad() {
		this.destroyInstance();
		const resource = this._resource ?? this._assetReference.asset?.resource;
		if (!resource) return;
		if (this.unified) {
			this._placement = null;
			this._placement = new GSplatPlacement(resource, this.entity, 0, this._parameters, null, this._id);
			this._placement.lodBaseDistance = this._lodBaseDistance;
			this._placement.lodMultiplier = this._lodMultiplier;
			this._placement.lodRangeMin = this._lodRangeMin;
			this._placement.lodRangeMax = this._lodRangeMax;
			this._placement.workBufferUpdate = this._workBufferUpdate;
			this._placement.workBufferModifier = this._workBufferModifier;
			if (this.enabled && this.entity.enabled) {
				this.addToLayers();
			}
		} else {
			this.instance = new GSplatInstance(resource, {
				material: this._materialTmp,
				scene: this.system.app.scene
			});
			this._materialTmp = null;
		}
	}
	_onGSplatAssetUnload() {
		this.destroyInstance();
	}
	_onGSplatAssetRemove() {
		this._onGSplatAssetUnload();
	}
};

var gsplatCenter_default = `
uniform mat4 matrix_model;
uniform mat4 matrix_view;
#ifndef GSPLAT_CENTER_NOPROJ
	uniform vec4 camera_params;
	uniform mat4 matrix_projection;
	#ifdef GSPLAT_FISHEYE
		uniform float fisheye_k;
		uniform float fisheye_inv_k;
		uniform float fisheye_projMat00;
		uniform float fisheye_projMat11;
	#endif
#endif
bool initCenter(vec3 modelCenter, inout SplatCenter center) {
	mat4 modelView = matrix_view * matrix_model;
	vec4 centerView = modelView * vec4(modelCenter, 1.0);
	#ifndef GSPLAT_CENTER_NOPROJ
		#ifdef GSPLAT_FISHEYE
			vec3 v = centerView.xyz;
			float r_xy = length(v.xy);
			float neg_z = -v.z;
			float theta = atan(r_xy, neg_z);
			float maxTheta = min(fisheye_k * 1.5707963, 3.13);
			if (theta > maxTheta - 0.01 || dot(v, v) < 0.0001) {
				return false;
			}
			float tk = theta * fisheye_inv_k;
			float sin_tk = sin(tk);
			float cos_tk = cos(tk);
			float g_theta = fisheye_k * sin_tk / cos_tk;
			float fisheye_s = (r_xy > 1e-4) ? g_theta / r_xy : (neg_z > 0.0 ? 1.0 / neg_z : 0.0);
			vec2 ndc = vec2(fisheye_projMat00 * fisheye_s * v.x, fisheye_projMat11 * fisheye_s * v.y);
			float near = camera_params.z;
			float far = camera_params.y;
			float linearDepth = neg_z;
			#if WEBGPU
				float depthNdc = clamp((linearDepth - near) / (far - near), 0.0, 1.0);
			#else
				float depthNdc = clamp(2.0 * (linearDepth - near) / (far - near) - 1.0, -1.0, 1.0);
			#endif
			center.proj = vec4(ndc, depthNdc, 1.0);
			center.projMat00 = fisheye_projMat00;
			center.fisheyeSinTK = sin_tk;
			center.fisheyeCosTK = cos_tk;
			center.fisheyeRxy = r_xy;
		#else
			if (camera_params.w != 1.0 && centerView.z > 0.0) {
				return false;
			}
			vec4 centerProj = matrix_projection * centerView;
			#if WEBGPU
				centerProj.z = clamp(centerProj.z, 0, abs(centerProj.w));
			#else
				centerProj.z = clamp(centerProj.z, -abs(centerProj.w), abs(centerProj.w));
			#endif
			center.proj = centerProj;
			center.projMat00 = matrix_projection[0][0];
		#endif
	#endif
	center.view = centerView.xyz / centerView.w;
	center.modelView = modelView;
	return true;
}
`;

var gsplatCommon_default = `
#include "gsplatHelpersVS"
#include "gsplatFormatVS"
#include "gsplatStructsVS"
#include "gsplatDeclarationsVS"
#include "gsplatModifyVS"
#include "gsplatEvalSHVS"
#include "gsplatQuatToMat3VS"
#include "gsplatReadVS"
#include "gsplatSourceVS"
#include "gsplatCenterVS"
#include "gsplatCornerVS"
#include "gsplatOutputVS"
#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
uniform float alphaClip;
#else
uniform float alphaClipForward;
#endif
void clipCorner(inout SplatCorner corner, float alpha) {
	#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
		float alphaClipValue = alphaClip;
	#else
		float alphaClipValue = alphaClipForward;
	#endif
	float clip = min(1.0, sqrt(max(0.0, log(alpha / alphaClipValue))) * 0.5);
	corner.offset *= clip;
	corner.uv *= clip;
}
`;

var gsplatSplat_default = `
struct Splat {
	uint index;
	ivec2 uv;
};
Splat splat;
void setSplat(uint idx) {
	splat.index = idx;
	splat.uv = ivec2(idx % splatTextureSize, idx / splatTextureSize);
}
`;

var gsplatEvalSH_default = `
	#if SH_BANDS == 1
		#define SH_COEFFS 3
	#elif SH_BANDS == 2
		#define SH_COEFFS 8
	#elif SH_BANDS == 3
		#define SH_COEFFS 15
	#else
		#define SH_COEFFS 0
	#endif
	#if SH_BANDS > 0
	const float SH_C1 = 0.4886025119029199f;
	#if SH_BANDS > 1
		const float SH_C2_0 = 1.0925484305920792f;
		const float SH_C2_1 = -1.0925484305920792f;
		const float SH_C2_2 = 0.31539156525252005f;
		const float SH_C2_3 = -1.0925484305920792f;
		const float SH_C2_4 = 0.5462742152960396f;
	#endif
	#if SH_BANDS > 2
		const float SH_C3_0 = -0.5900435899266435f;
		const float SH_C3_1 = 2.890611442640554f;
		const float SH_C3_2 = -0.4570457994644658f;
		const float SH_C3_3 = 0.3731763325901154f;
		const float SH_C3_4 = -0.4570457994644658f;
		const float SH_C3_5 = 1.445305721320277f;
		const float SH_C3_6 = -0.5900435899266435f;
	#endif
	vec3 evalSH(in vec3 sh[SH_COEFFS], in vec3 dir) {
		float x = dir.x;
		float y = dir.y;
		float z = dir.z;
		vec3 result = SH_C1 * (-sh[0] * y + sh[1] * z - sh[2] * x);
		#if SH_BANDS > 1
			float xx = x * x;
			float yy = y * y;
			float zz = z * z;
			float xy = x * y;
			float yz = y * z;
			float xz = x * z;
			result +=
				sh[3] * (SH_C2_0 * xy) +
				sh[4] * (SH_C2_1 * yz) +
				sh[5] * (SH_C2_2 * (2.0 * zz - xx - yy)) +
				sh[6] * (SH_C2_3 * xz) +
				sh[7] * (SH_C2_4 * (xx - yy));
		#endif
		#if SH_BANDS > 2
			result +=
				sh[8]  * (SH_C3_0 * y * (3.0 * xx - yy)) +
				sh[9]  * (SH_C3_1 * xy * z) +
				sh[10] * (SH_C3_2 * y * (4.0 * zz - xx - yy)) +
				sh[11] * (SH_C3_3 * z * (2.0 * zz - 3.0 * xx - 3.0 * yy)) +
				sh[12] * (SH_C3_4 * x * (4.0 * zz - xx - yy)) +
				sh[13] * (SH_C3_5 * z * (xx - yy)) +
				sh[14] * (SH_C3_6 * x * (xx - 3.0 * yy));
		#endif
		return result;
	}
	#endif
`;

var gsplatHelpers_default2 = `
void gsplatMakeSpherical(inout vec3 scale, float size) {
	scale = vec3(size);
}
float gsplatGetSizeFromScale(vec3 scale) {
	return sqrt((scale.x * scale.x + scale.y * scale.y + scale.z * scale.z) / 3.0);
}
`;

var gsplatModify_default2 = `
void modifySplatCenter(inout vec3 center) {
}
void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {
}
void modifySplatColor(vec3 center, inout vec4 color) {
}
`;

var gsplatModify_default3 = `
void modifySplatColor(vec2 gaussianUV, inout vec4 color) {
}
`;

var gsplatWorkBufferGeometry_default = `
#ifdef GSPLAT_WORKBUFFER_GEOMETRY
	uniform highp usampler2D uWorkBufferTransformA;
	uniform highp usampler2D uWorkBufferTransformB;
	uniform mat4 matrix_model_inverse;
	uniform vec3 uCameraPosition;
	ivec2 wbCoord;
	uvec4 wbTransformA;
	void initWorkBufferGeometry(ivec2 coord) {
		wbCoord = coord;
		wbTransformA = texelFetch(uWorkBufferTransformA, coord, 0);
	}
	vec3 workBufferWorldCenter() {
		return vec3(uintBitsToFloat(wbTransformA.x), uintBitsToFloat(wbTransformA.y), uintBitsToFloat(wbTransformA.z));
	}
	vec4 workBufferWorldRotation() {
		#ifdef GSPLAT_WORKBUFFER_COMPACT
			uint data = texelFetch(uWorkBufferTransformB, wbCoord, 0).x;
			vec3 p = vec3(
				float(data & 0x7FFu) / 2047.0 * 2.0 - 1.0,
				float((data >> 11u) & 0x7FFu) / 2047.0 * 2.0 - 1.0,
				float((data >> 22u) & 0x3FFu) / 1023.0 * 2.0 - 1.0
			);
			float d = dot(p, p);
			return vec4(sqrt(max(0.0, 2.0 - d)) * p, 1.0 - d);
		#else
			vec2 rotXY = unpackHalf2x16(wbTransformA.w);
			vec3 r = vec3(rotXY, unpackHalf2x16(texelFetch(uWorkBufferTransformB, wbCoord, 0).x).x);
			return vec4(r, sqrt(max(0.0, 1.0 - dot(r, r))));
		#endif
	}
	vec3 workBufferWorldScale() {
		#ifdef GSPLAT_WORKBUFFER_COMPACT
			uint data = wbTransformA.w;
			float sx = float(data & 0xFFu);
			float sy = float((data >> 8u) & 0xFFu);
			float sz = float((data >> 16u) & 0xFFu);
			const float logRange = 21.0 / 255.0;
			const float logMin = -12.0;
			return vec3(
				sx == 0.0 ? 0.0 : exp(sx * logRange + logMin),
				sy == 0.0 ? 0.0 : exp(sy * logRange + logMin),
				sz == 0.0 ? 0.0 : exp(sz * logRange + logMin)
			);
		#else
			uvec2 b = texelFetch(uWorkBufferTransformB, wbCoord, 0).xy;
			return vec3(unpackHalf2x16(b.x).y, unpackHalf2x16(b.y));
		#endif
	}
	vec3 quatRotateInv(vec4 q, vec3 v) {
		vec3 t = -q.xyz;
		return v + 2.0 * cross(t, cross(t, v) + q.w * v);
	}
	vec3 getCenter() {
		return (matrix_model_inverse * vec4(workBufferWorldCenter(), 1.0)).xyz;
	}
	vec4 getRotation() {
		vec4 worldRotation = workBufferWorldRotation();
		vec4 localRotation = quatMul(vec4(-model_rotation.xyz, model_rotation.w), worldRotation);
		return localRotation.wxyz;
	}
	vec3 getScale() {
		return workBufferWorldScale() / model_scale;
	}
#endif
`;

var gsplatQuatToMat3_default = `
mat3 quatToMat3(vec4 R) {
	vec4 R2 = R + R;
	float X = R2.x * R.w;
	vec4 Y  = R2.y * R;
	vec4 Z  = R2.z * R;
	float W = R2.w * R.w;
	return mat3(
		1.0 - Z.z - W,
			  Y.z + X,
			  Y.w - Z.x,
			  Y.z - X,
		1.0 - Y.y - W,
			  Z.w + Y.x,
			  Y.w + Z.x,
			  Z.w - Y.x,
		1.0 - Y.y - Z.z
	);
}
vec4 quatMul(vec4 a, vec4 b) {
	return vec4(
		a.w * b.x + a.x * b.w + a.y * b.z - a.z * b.y,
		a.w * b.y - a.x * b.z + a.y * b.w + a.z * b.x,
		a.w * b.z + a.x * b.y - a.y * b.x + a.z * b.w,
		a.w * b.w - a.x * b.x - a.y * b.y - a.z * b.z
	);
}
`;

var gsplatStructs_default = `
#include "gsplatSplatVS"
struct SplatSource {
	uint order;
	vec2 cornerUV;
};
struct SplatCenter {
	vec3 view;
	vec4 proj;
	mat4 modelView;
	float projMat00;
	vec3 modelCenterOriginal;
	vec3 modelCenterModified;
	#ifdef GSPLAT_FISHEYE
		float fisheyeSinTK;
		float fisheyeCosTK;
		float fisheyeRxy;
	#endif
};
struct SplatCorner {
	vec3 offset;
	vec2 uv;
	#if GSPLAT_AA
		float aaFactor;
	#endif
	vec2 v;
	float dlen;
};
`;

var gsplatCorner_default = `
uniform vec4 viewport_size;
uniform float minPixelSize;
void computeCovariance(vec4 rotation, vec3 scale, out vec3 covA, out vec3 covB) {
	mat3 rot = quatToMat3(rotation);
	mat3 M = transpose(mat3(
		scale.x * rot[0],
		scale.y * rot[1],
		scale.z * rot[2]
	));
	covA = vec3(dot(M[0], M[0]), dot(M[0], M[1]), dot(M[0], M[2]));
	covB = vec3(dot(M[1], M[1]), dot(M[1], M[2]), dot(M[2], M[2]));
}
bool initCornerCov(SplatSource source, SplatCenter center, out SplatCorner corner, vec3 covA, vec3 covB) {
	mat3 Vrk = mat3(
		covA.x, covA.y, covA.z, 
		covA.y, covB.x, covB.y,
		covA.z, covB.y, covB.z
	);
	float focal = viewport_size.x * center.projMat00;
	vec3 v = center.view.xyz;
	#ifdef GSPLAT_FISHEYE
		float r_sq = max(center.fisheyeRxy * center.fisheyeRxy, 1e-8);
		float d2 = dot(v, v);
		float neg_z = -v.z;
		float g_prime = 1.0 / (center.fisheyeCosTK * center.fisheyeCosTK);
		float g_theta = fisheye_k * center.fisheyeSinTK / center.fisheyeCosTK;
		float sv = (center.fisheyeRxy > 1e-4) ? g_theta / center.fisheyeRxy : (neg_z > 0.0 ? 1.0 / neg_z : 0.0);
		float K = (center.fisheyeRxy > 1e-4) ? (g_prime * neg_z / d2 - sv) / r_sq : 0.0;
		mat3 J = mat3(
			focal * (sv + K * v.x * v.x),  focal * K * v.x * v.y,		 focal * g_prime * v.x / d2,
			focal * K * v.x * v.y,		focal * (sv + K * v.y * v.y),	focal * g_prime * v.y / d2,
			0.0,						   0.0,							0.0
		);
	#else
		vec3 vp = camera_params.w == 1.0 ? vec3(0.0, 0.0, 1.0) : v;
		float J1 = focal / vp.z;
		vec2 J2 = -J1 / vp.z * vp.xy;
		mat3 J = mat3(
			J1, 0.0, J2.x,
			0.0, J1, J2.y,
			0.0, 0.0, 0.0
		);
	#endif
	mat3 W = transpose(mat3(center.modelView));
	mat3 T = W * J;
	mat3 cov = transpose(T) * Vrk * T;
	#if GSPLAT_AA
		float detOrig = cov[0][0] * cov[1][1] - cov[0][1] * cov[0][1];
		float detBlur = (cov[0][0] + 0.3) * (cov[1][1] + 0.3) - cov[0][1] * cov[0][1];
		corner.aaFactor = sqrt(max(detOrig / detBlur, 0.0));
	#endif
	float diagonal1 = cov[0][0] + 0.3;
	float offDiagonal = cov[0][1];
	float diagonal2 = cov[1][1] + 0.3;
	float mid = 0.5 * (diagonal1 + diagonal2);
	float radius = length(vec2((diagonal1 - diagonal2) / 2.0, offDiagonal));
	float lambda1 = mid + radius;
	float lambda2 = max(mid - radius, 0.1);
	float vmin = min(1024.0, min(viewport_size.x, viewport_size.y));
	float l1 = 2.0 * min(sqrt(2.0 * lambda1), vmin);
	float l2 = 2.0 * min(sqrt(2.0 * lambda2), vmin);
	if (max(l1, l2) < minPixelSize) {
		return false;
	}
	vec2 c = center.proj.ww * viewport_size.zw;
	if (any(greaterThan(abs(center.proj.xy) - vec2(max(l1, l2)) * c, center.proj.ww))) {
		return false;
	}
	vec2 diagonalVector = normalize(vec2(offDiagonal, lambda1 - diagonal1));
	vec2 v1 = l1 * diagonalVector;
	vec2 v2 = l2 * vec2(diagonalVector.y, -diagonalVector.x);
	corner.offset = vec3((source.cornerUV.x * v1 + source.cornerUV.y * v2) * c, 0.0);
	corner.uv = source.cornerUV;
	return true;
}
#if GSPLAT_2DGS
void initCorner2DGS(SplatSource source, vec4 rotation, vec3 scale, out SplatCorner corner) {
	vec2 localPos = source.cornerUV * vec2(scale.x, scale.y) * 3.0;
	vec3 v = vec3(localPos, 0.0);
	vec3 t = 2.0 * cross(rotation.xyz, v);
	corner.offset = v + rotation.w * t + cross(rotation.xyz, t);
	corner.uv = source.cornerUV;
}
#endif
bool initCorner(SplatSource source, SplatCenter center, out SplatCorner corner) {
	vec4 rotation = getRotation().yzwx;
	vec3 scale = getScale();
	modifySplatRotationScale(center.modelCenterOriginal, center.modelCenterModified, rotation, scale);
	#if GSPLAT_2DGS
		initCorner2DGS(source, rotation, scale, corner);
		return true;
	#else
		vec3 covA, covB;
		computeCovariance(rotation.wxyz, scale, covA, covB);
		return initCornerCov(source, center, corner, covA, covB);
	#endif
}
`;

var gsplatOutput_default = `
#include "tonemappingPS"
#include "decodePS"
#include "gammaPS"
#include "fogPS"
#if FOG != NONE && !defined(GSPLAT_NO_FOG)
	#define GSPLAT_FOG
#endif
vec3 prepareOutputFromGamma(vec3 gammaColor, float depth) {
	vec3 color = gammaColor;
	#if TONEMAP != NONE || GAMMA == NONE || defined(GSPLAT_FOG)
		color = decodeGamma(color);
	#endif
	#ifdef GSPLAT_FOG
		color = addFog(color, depth);
	#endif
	#if TONEMAP != NONE
		color = toneMap(color);
	#endif
	#if TONEMAP != NONE || (GAMMA != NONE && defined(GSPLAT_FOG))
		color = gammaCorrectOutput(color);
	#endif
	return color;
}
`;

var gsplat_default = `
#ifndef DITHER_NONE
	#include "bayerPS"
	#include "opacityDitherPS"
	varying float id;
#endif
#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
	uniform float alphaClip;
#endif
#ifdef PREPASS_PASS
	varying float vLinearDepth;
	#include "floatAsUintPS"
#endif
#if !defined(SHADOW_PASS) && !defined(PICK_PASS) && !defined(PREPASS_PASS)
	uniform float alphaClipForward;
#endif
varying mediump vec2 gaussianUV;
varying mediump vec4 gaussianColor;
#if defined(GSPLAT_UNIFIED_ID) && defined(PICK_PASS)
	flat varying uint vPickId;
#endif
#ifdef PICK_PASS
	#include "pickPS"
#endif
#ifdef GSPLAT_USER_VARYINGS
	#include "gsplatUserVaryingsPS"
#endif
#include "gsplatModifyPS"
const float EXP4 = exp(-4.0);
const float INV_EXP4 = 1.0 / (1.0 - EXP4);
float normExp(float x) {
	return (exp(x * -4.0) - EXP4) * INV_EXP4;
}
void main(void) {
	mediump float A = dot(gaussianUV, gaussianUV);
	if (A > 1.0) {
		discard;
	}
	mediump float alpha = normExp(A) * gaussianColor.a;
	#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
		if (alpha < alphaClip) {
			discard;
		}
	#endif
	#ifdef PICK_PASS
		#ifdef GSPLAT_UNIFIED_ID
			pcFragColor0 = encodePickOutput(vPickId);
		#else
			pcFragColor0 = getPickOutput();
		#endif
		#ifdef DEPTH_PICK_PASS
			pcFragColor1 = getPickDepth();
		#endif
	#elif SHADOW_PASS
		gl_FragColor = vec4(gl_FragCoord.z, 0.0, 0.0, 1.0);
	#elif PREPASS_PASS
		gl_FragColor = float2vec4(vLinearDepth);
	#else
		if (alpha < alphaClipForward) {
			discard;
		}
		#ifndef DITHER_NONE
			opacityDither(alpha, id * 0.013);
		#endif
		vec4 fragColor = vec4(gaussianColor.xyz, alpha);
		modifySplatColor(gaussianUV, fragColor);
		gl_FragColor = vec4(fragColor.xyz * fragColor.a, fragColor.a);
	#endif
}
`;

var gsplatSource_default = `
attribute vec3 vertex_position;
uniform uint numSplats;
uniform highp usampler2D splatOrder;
bool initSource(out SplatSource source) {
	source.order = uint(gl_InstanceID) * {GSPLAT_INSTANCE_SIZE}u + uint(vertex_position.z);
	if (source.order >= numSplats) {
		return false;
	}
	ivec2 orderUV = ivec2(source.order % splatTextureSize, source.order / splatTextureSize);
	uint splatId = texelFetch(splatOrder, orderUV, 0).r;
	setSplat(splatId);
	source.cornerUV = vertex_position.xy;
	return true;
}
`;

var gsplat_default2 = `
#ifdef GSPLAT_USER_VARYINGS
	#include "gsplatUserVaryingsVS"
#endif
#include "gsplatCommonVS"
varying mediump vec2 gaussianUV;
varying mediump vec4 gaussianColor;
#ifndef DITHER_NONE
	varying float id;
#endif
mediump vec4 discardVec = vec4(0.0, 0.0, 2.0, 1.0);
#ifdef PREPASS_PASS
	varying float vLinearDepth;
#endif
#if defined(GSPLAT_UNIFIED_ID) && defined(PICK_PASS)
	flat varying uint vPickId;
#endif
#ifdef GSPLAT_OVERDRAW
	uniform sampler2D colorRamp;
	uniform float colorRampIntensity;
#endif
void main(void) {
	SplatSource source;
	if (!initSource(source)) {
		gl_Position = discardVec;
		return;
	}
	vec3 modelCenter = getCenter();
	SplatCenter center;
	center.modelCenterOriginal = modelCenter;
	
	modifySplatCenter(modelCenter);
	center.modelCenterModified = modelCenter;
	if (!initCenter(modelCenter, center)) {
		gl_Position = discardVec;
		return;
	}
	SplatCorner corner;
	if (!initCorner(source, center, corner)) {
		gl_Position = discardVec;
		return;
	}
	#ifdef GSPLAT_SEPARATE_OPACITY
		float opacity = getOpacity();
		vec4 clr = vec4(getColor(), opacity);
	#else
		vec4 clr = getColor();
	#endif
	#if GSPLAT_AA
		clr.a *= corner.aaFactor;
	#endif
	#if SH_BANDS > 0
		vec3 dir = normalize(center.view * mat3(center.modelView));
		vec3 sh[SH_COEFFS];
		float scale;
		readSHData(sh, scale);
		clr.xyz += evalSH(sh, dir) * scale;
	#endif
	modifySplatColor(modelCenter, clr);
	#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
		float alphaClipValue = alphaClip;
	#else
		float alphaClipValue = alphaClipForward;
	#endif
	if (clr.w <= alphaClipValue) {
		gl_Position = discardVec;
		return;
	}
	clipCorner(corner, clr.w);
	#if GSPLAT_2DGS
		vec3 modelCorner = center.modelCenterModified + corner.offset;
		gl_Position = matrix_projection * center.modelView * vec4(modelCorner, 1.0);
	#else
		gl_Position = center.proj + vec4(corner.offset.xyz, 0);
	#endif
	gaussianUV = corner.uv;
	#ifdef GSPLAT_OVERDRAW
		float t = clamp(modelCenter.y / 20.0, 0.0, 1.0);
		vec3 rampColor = textureLod(colorRamp, vec2(t, 0.5), 0.0).rgb;
		clr.a *= (1.0 / 32.0) * colorRampIntensity;
		gaussianColor = vec4(rampColor, clr.a);
	#else
		gaussianColor = vec4(prepareOutputFromGamma(max(clr.xyz, 0.0), -center.view.z), clr.w);
	#endif
	#ifndef DITHER_NONE
		id = float(splat.index);
	#endif
	#ifdef PREPASS_PASS
		vLinearDepth = -center.view.z;
	#endif
	#if defined(GSPLAT_UNIFIED_ID) && defined(PICK_PASS)
		vPickId = loadPcId().r;
	#endif
}
`;

var gsplatPacking_default = `
uint pack8888(vec4 v) {
	uvec4 t = uvec4(v * 255.0) << uvec4(24u, 16u, 8u, 0u);
	return t.x | t.y | t.z | t.w;
}
uint pack101010(vec3 v) {
	uvec3 t = uvec3(v * 1023.0) << uvec3(20u, 10u, 0u);
	return t.x | t.y | t.z;
}
uint pack111110(vec3 v) {
	uvec3 t = uvec3(v * vec3(2047.0, 2047.0, 1023.0)) << uvec3(21u, 10u, 0u);
	return t.x | t.y | t.z;
}
vec4 unpack8888(uint v) {
	return vec4((uvec4(v) >> uvec4(24u, 16u, 8u, 0u)) & 0xffu) / 255.0;
}
vec3 unpack101010(uint v) {
	return vec3((uvec3(v) >> uvec3(20u, 10u, 0u)) & 0x3ffu) / 1023.0;
}
vec3 unpack111110(uint v) {
	return vec3((uvec3(v) >> uvec3(21u, 10u, 0u)) & uvec3(0x7ffu, 0x7ffu, 0x3ffu)) / vec3(2047.0, 2047.0, 1023.0);
}
vec3 resolveCodebook(vec3 s, vec4 codebook[64]) {
	uvec3 idx = uvec3(s * 255.0);
	vec3 v = vec3(
		codebook[idx.x >> 2u][idx.x & 3u],
		codebook[idx.y >> 2u][idx.y & 3u],
		codebook[idx.z >> 2u][idx.z & 3u]
	);
	return (v - codebook[0].x) / (codebook[63].w - codebook[0].x);
}
`;

var gsplatFormat_default = `
uniform uint splatTextureSize;
`;

var uncompressed_default = `
uint tAw;
vec4 tBcached;
vec4 unpackRotation(vec3 data) {
	return vec4(data.xyz, sqrt(max(0.0, 1.0 - dot(data, data))));
}
vec3 getCenter() {
	uvec4 tA = loadTransformA();
	tAw = tA.w;
	tBcached = loadTransformB();
	return uintBitsToFloat(tA.xyz);
}
vec4 getColor() {
	return loadSplatColor();
}
vec4 getRotation() {
	return unpackRotation(vec3(unpackHalf2x16(tAw), tBcached.w)).wxyz;
}
vec3 getScale() {
	return tBcached.xyz;
}
#include "gsplatUncompressedSHVS"
`;

var uncompressedSH_default = `
#if SH_BANDS > 0
vec3 unpack111011s(uint bits) {
	return vec3((uvec3(bits) >> uvec3(21u, 11u, 0u)) & uvec3(0x7ffu, 0x3ffu, 0x7ffu)) / vec3(2047.0, 1023.0, 2047.0) * 2.0 - 1.0;
}
void fetchScale(in uvec4 t, out float scale, out vec3 a, out vec3 b, out vec3 c) {
	scale = uintBitsToFloat(t.x);
	a = unpack111011s(t.y);
	b = unpack111011s(t.z);
	c = unpack111011s(t.w);
}
void fetch(in uvec4 t, out vec3 a, out vec3 b, out vec3 c, out vec3 d) {
	a = unpack111011s(t.x);
	b = unpack111011s(t.y);
	c = unpack111011s(t.z);
	d = unpack111011s(t.w);
}
void fetch(in uint t, out vec3 a) {
	a = unpack111011s(t);
}
#if SH_BANDS == 1
	void readSHData(out vec3 sh[3], out float scale) {
		fetchScale(loadSplatSH_1to3(), scale, sh[0], sh[1], sh[2]);
	}
#elif SH_BANDS == 2
	void readSHData(out vec3 sh[8], out float scale) {
		fetchScale(loadSplatSH_1to3(), scale, sh[0], sh[1], sh[2]);
		fetch(loadSplatSH_4to7(), sh[3], sh[4], sh[5], sh[6]);
		fetch(loadSplatSH_8to11().x, sh[7]);
	}
#else
	void readSHData(out vec3 sh[15], out float scale) {
		fetchScale(loadSplatSH_1to3(), scale, sh[0], sh[1], sh[2]);
		fetch(loadSplatSH_4to7(), sh[3], sh[4], sh[5], sh[6]);
		fetch(loadSplatSH_8to11(), sh[7], sh[8], sh[9], sh[10]);
		fetch(loadSplatSH_12to15(), sh[11], sh[12], sh[13], sh[14]);
	}
#endif
#endif
`;

var compressed_default = `
#include "gsplatPackingPS"
uniform highp sampler2D chunkTexture;
vec4 chunkDataA;
vec4 chunkDataB;
vec4 chunkDataC;
vec4 chunkDataD;
vec4 chunkDataE;
uvec4 packedData;
vec3 unpack111011(uint bits) {
	return vec3(
		float(bits >> 21u) / 2047.0,
		float((bits >> 11u) & 0x3ffu) / 1023.0,
		float(bits & 0x7ffu) / 2047.0
	);
}
const float norm = sqrt(2.0);
vec4 unpackRotation(uint bits) {
	float a = (float((bits >> 20u) & 0x3ffu) / 1023.0 - 0.5) * norm;
	float b = (float((bits >> 10u) & 0x3ffu) / 1023.0 - 0.5) * norm;
	float c = (float(bits & 0x3ffu) / 1023.0 - 0.5) * norm;
	float m = sqrt(1.0 - (a * a + b * b + c * c));
	uint mode = bits >> 30u;
	if (mode == 0u) return vec4(m, a, b, c);
	if (mode == 1u) return vec4(a, m, b, c);
	if (mode == 2u) return vec4(a, b, m, c);
	return vec4(a, b, c, m);
}
vec3 getCenter() {
	uint w = uint(textureSize(chunkTexture, 0).x) / 5u;
	uint chunkId = splat.index / 256u;
	ivec2 chunkUV = ivec2((chunkId % w) * 5u, chunkId / w);
	chunkDataA = texelFetch(chunkTexture, chunkUV, 0);
	chunkDataB = texelFetch(chunkTexture, chunkUV + ivec2(1, 0), 0);
	chunkDataC = texelFetch(chunkTexture, chunkUV + ivec2(2, 0), 0);
	chunkDataD = texelFetch(chunkTexture, chunkUV + ivec2(3, 0), 0);
	chunkDataE = texelFetch(chunkTexture, chunkUV + ivec2(4, 0), 0);
	packedData = loadPackedTexture();
	return mix(chunkDataA.xyz, vec3(chunkDataA.w, chunkDataB.xy), unpack111011(packedData.x));
}
vec4 getColor() {
	vec4 r = unpack8888(packedData.w);
	return vec4(mix(chunkDataD.xyz, vec3(chunkDataD.w, chunkDataE.xy), r.rgb), r.w);
}
vec4 getRotation() {
	return unpackRotation(packedData.y);
}
vec3 getScale() {
	return exp(mix(vec3(chunkDataB.zw, chunkDataC.x), chunkDataC.yzw, unpack111011(packedData.z)));
}
#include "gsplatCompressedSHVS"
`;

var compressedSH_default = `
#if SH_BANDS > 0
vec4 unpack8888s(in uint bits) {
	return vec4((uvec4(bits) >> uvec4(0u, 8u, 16u, 24u)) & 0xffu) * (8.0 / 255.0) - 4.0;
}
void readSHData(out vec3 sh[15], out float scale) {
	uvec4 shData0 = loadShTexture0();
	uvec4 shData1 = loadShTexture1();
	uvec4 shData2 = loadShTexture2();
	vec4 r0 = unpack8888s(shData0.x);
	vec4 r1 = unpack8888s(shData0.y);
	vec4 r2 = unpack8888s(shData0.z);
	vec4 r3 = unpack8888s(shData0.w);
	vec4 g0 = unpack8888s(shData1.x);
	vec4 g1 = unpack8888s(shData1.y);
	vec4 g2 = unpack8888s(shData1.z);
	vec4 g3 = unpack8888s(shData1.w);
	vec4 b0 = unpack8888s(shData2.x);
	vec4 b1 = unpack8888s(shData2.y);
	vec4 b2 = unpack8888s(shData2.z);
	vec4 b3 = unpack8888s(shData2.w);
	sh[0] =  vec3(r0.x, g0.x, b0.x);
	sh[1] =  vec3(r0.y, g0.y, b0.y);
	sh[2] =  vec3(r0.z, g0.z, b0.z);
	sh[3] =  vec3(r0.w, g0.w, b0.w);
	sh[4] =  vec3(r1.x, g1.x, b1.x);
	sh[5] =  vec3(r1.y, g1.y, b1.y);
	sh[6] =  vec3(r1.z, g1.z, b1.z);
	sh[7] =  vec3(r1.w, g1.w, b1.w);
	sh[8] =  vec3(r2.x, g2.x, b2.x);
	sh[9] =  vec3(r2.y, g2.y, b2.y);
	sh[10] = vec3(r2.z, g2.z, b2.z);
	sh[11] = vec3(r2.w, g2.w, b2.w);
	sh[12] = vec3(r3.x, g3.x, b3.x);
	sh[13] = vec3(r3.y, g3.y, b3.y);
	sh[14] = vec3(r3.z, g3.z, b3.z);
	scale = 1.0;
}
#endif
`;

var sog_default = `
uniform vec3 means_mins;
uniform vec3 means_maxs;
#ifndef SOG_V2
	uniform vec3 scales_mins;
	uniform vec3 scales_maxs;
	uniform vec4 sh0_mins;
	uniform vec4 sh0_maxs;
#endif
const float SH_C0 = 0.28209479177387814;
const float norm = sqrt(2.0);
#ifdef SOG_V2
	float lutScales(int b) { return texelFetch(sogCodebook, ivec2(b, 0), 0).r; }
	float lutSh0(int b)	{ return texelFetch(sogCodebook, ivec2(b, 0), 0).g; }
	float lutShN(int b)	{ return texelFetch(sogCodebook, ivec2(b, 0), 0).b; }
#endif
#ifndef GSPLAT_WORKBUFFER_GEOMETRY
vec3 getCenter() {
	vec3 l = texelFetch(means_l, splat.uv, 0).xyz;
	vec3 u = texelFetch(means_u, splat.uv, 0).xyz;
	vec3 n = (l + u * 256.0) / 257.0;
	vec3 v = mix(means_mins, means_maxs, n);
	return sign(v) * (exp(abs(v)) - 1.0);
}
vec4 getRotation() {
	vec4 q = texelFetch(quats, splat.uv, 0);
	uint qmode = uint(q.w * 255.0 + 0.5) - 252u;
	vec3 abc = (q.xyz - 0.5) * norm;
	float d = sqrt(max(0.0, 1.0 - dot(abc, abc)));
	return (qmode == 0u) ? vec4(d, abc) :
		   ((qmode == 1u) ? vec4(abc.x, d, abc.yz) :
		   ((qmode == 2u) ? vec4(abc.xy, d, abc.z) : vec4(abc, d)));
}
vec3 getScale() {
	vec3 s = texelFetch(scales, splat.uv, 0).xyz;
	#ifdef SOG_V2
		ivec3 i = ivec3(s * 255.0 + 0.5);
		vec3 logS = vec3(lutScales(i.x), lutScales(i.y), lutScales(i.z));
	#else
		vec3 logS = mix(scales_mins, scales_maxs, s);
	#endif
	return exp(logS);
}
#endif
vec4 getColor() {
	vec4 c = texelFetch(sh0, splat.uv, 0);
	#ifdef SOG_V2
		ivec3 i = ivec3(c.xyz * 255.0 + 0.5);
		vec3 rgb = vec3(lutSh0(i.x), lutSh0(i.y), lutSh0(i.z));
		float alpha = c.w;
	#else
		vec3 rgb = mix(sh0_mins.xyz, sh0_maxs.xyz, c.xyz);
		float logitAlpha = mix(sh0_mins.w, sh0_maxs.w, c.w);
		float alpha = 1.0 / (1.0 + exp(-logitAlpha));
	#endif
	return vec4(vec3(0.5) + rgb * SH_C0, alpha);
}
#include "gsplatSogSHVS"
`;

var sogSH_default = `
#if SH_BANDS > 0
	#ifndef SOG_V2
		uniform float shN_mins;
		uniform float shN_maxs;
	#endif
	void readSHData(out vec3 sh[SH_COEFFS], out float scale) {
		vec4 labels = texelFetch(sh_labels, splat.uv, 0);
		int n = int(labels.x * 255.0 + 0.5) + int(labels.y * 255.0 + 0.5) * 256;
		int u = (n % 64) * SH_COEFFS;
		int v = n / 64;
		for (int i = 0; i < SH_COEFFS; i++) {
			vec4 t = texelFetch(sh_centroids, ivec2(u + i, v), 0);
			#ifdef SOG_V2
				ivec3 idx = ivec3(t.xyz * 255.0 + 0.5);
				sh[i] = vec3(lutShN(idx.x), lutShN(idx.y), lutShN(idx.z));
			#else
				sh[i] = mix(vec3(shN_mins), vec3(shN_maxs), t.xyz);
			#endif
		}
		scale = 1.0;
	}
#endif
`;

var containerDecl_default = `
#include "gsplatContainerDeclarationsVS"
vec3 splatCenter;
vec4 splatColor;
vec3 splatScale;
vec4 splatRotation;
`;

var containerRead_default = `
vec3 getCenter() {
	#include "gsplatContainerUserReadVS"
	return splatCenter;
}
vec4 getRotation() {
	return splatRotation;
}
vec3 getScale() {
	return splatScale;
}
vec4 getColor() {
	return splatColor;
}
`;

var gsplatChunksGLSL = {
	gsplatCenterVS: gsplatCenter_default,
	gsplatCornerVS: gsplatCorner_default,
	gsplatCommonVS: gsplatCommon_default,
	gsplatSplatVS: gsplatSplat_default,
	gsplatEvalSHVS: gsplatEvalSH_default,
	gsplatHelpersVS: gsplatHelpers_default2,
	gsplatModifyVS: gsplatModify_default2,
	gsplatModifyPS: gsplatModify_default3,
	gsplatWorkBufferGeometryPS: gsplatWorkBufferGeometry_default,
	gsplatQuatToMat3VS: gsplatQuatToMat3_default,
	gsplatStructsVS: gsplatStructs_default,
	gsplatOutputVS: gsplatOutput_default,
	gsplatPS: gsplat_default,
	gsplatSourceVS: gsplatSource_default,
	gsplatVS: gsplat_default2,
	gsplatPackingPS: gsplatPacking_default,
	gsplatFormatVS: gsplatFormat_default,
	gsplatUncompressedVS: uncompressed_default,
	gsplatUncompressedSHVS: uncompressedSH_default,
	gsplatCompressedVS: compressed_default,
	gsplatCompressedSHVS: compressedSH_default,
	gsplatSogVS: sog_default,
	gsplatSogSHVS: sogSH_default,
	gsplatContainerDeclVS: containerDecl_default,
	gsplatContainerReadVS: containerRead_default,
	gsplatContainerFloatReadVS: containerFloatRead_default
};

var gsplatCenter_default2 = `
uniform matrix_model: mat4x4f;
uniform matrix_view: mat4x4f;
#ifndef GSPLAT_CENTER_NOPROJ
	uniform camera_params: vec4f;
	uniform matrix_projection: mat4x4f;
	#ifdef GSPLAT_FISHEYE
		uniform fisheye_k: f32;
		uniform fisheye_inv_k: f32;
		uniform fisheye_projMat00: f32;
		uniform fisheye_projMat11: f32;
	#endif
#endif
fn initCenter(modelCenter: vec3f, center: ptr<function, SplatCenter>) -> bool {
	let modelView: mat4x4f = uniform.matrix_view * uniform.matrix_model;
	let centerView: vec4f = modelView * vec4f(modelCenter, 1.0);
	#ifndef GSPLAT_CENTER_NOPROJ
		#ifdef GSPLAT_FISHEYE
			let v: vec3f = centerView.xyz;
			let r_xy: f32 = length(v.xy);
			let neg_z: f32 = -v.z;
			let theta: f32 = atan2(r_xy, neg_z);
			let maxTheta: f32 = min(uniform.fisheye_k * 1.5707963, 3.13);
			if (theta > maxTheta - 0.01 || dot(v, v) < 0.0001) {
				return false;
			}
			let tk: f32 = theta * uniform.fisheye_inv_k;
			let sin_tk: f32 = sin(tk);
			let cos_tk: f32 = cos(tk);
			let g_theta: f32 = uniform.fisheye_k * sin_tk / cos_tk;
			let fisheye_s: f32 = select(select(0.0, 1.0 / neg_z, neg_z > 0.0), g_theta / r_xy, r_xy > 1e-4);
			let ndc: vec2f = vec2f(uniform.fisheye_projMat00 * fisheye_s * v.x, uniform.fisheye_projMat11 * fisheye_s * v.y);
			let near: f32 = uniform.camera_params.z;
			let far: f32 = uniform.camera_params.y;
			let linearDepth: f32 = neg_z;
			let depthNdc: f32 = clamp((linearDepth - near) / (far - near), 0.0, 1.0);
			center.proj = vec4f(ndc, depthNdc, 1.0);
			center.projMat00 = uniform.fisheye_projMat00;
			center.fisheyeSinTK = sin_tk;
			center.fisheyeCosTK = cos_tk;
			center.fisheyeRxy = r_xy;
		#else
			if (uniform.camera_params.w != 1.0 && centerView.z > 0.0) {
				return false;
			}
			var centerProj: vec4f = uniform.matrix_projection * centerView;
			centerProj.z = clamp(centerProj.z, 0.0, abs(centerProj.w));
			center.proj = centerProj;
			center.projMat00 = uniform.matrix_projection[0][0];
		#endif
	#endif
	center.view = centerView.xyz / centerView.w;
	center.modelView = modelView;
	return true;
}
`;

var gsplatCommon_default2 = `
#include "gsplatHelpersVS"
#include "gsplatFormatVS"
#include "gsplatStructsVS"
#include "gsplatDeclarationsVS"
#include "gsplatModifyVS"
#include "gsplatEvalSHVS"
#include "gsplatQuatToMat3VS"
#include "gsplatReadVS"
#include "gsplatSourceVS"
#include "gsplatCenterVS"
#include "gsplatCornerVS"
#include "gsplatOutputVS"
#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
uniform alphaClip: f32;
#else
uniform alphaClipForward: f32;
#endif
fn clipCorner(corner: ptr<function, SplatCorner>, alpha: half) {
	#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
		let alphaClipValue = half(uniform.alphaClip);
	#else
		let alphaClipValue = half(uniform.alphaClipForward);
	#endif
	let clip = min(half(1.0), sqrt(max(half(0.0), log(alpha / alphaClipValue))) * half(0.5));
	corner.offset = corner.offset * f32(clip);
	corner.uv = corner.uv * clip;
}
`;

var gsplatSplat_default2 = `
struct Splat {
	index: u32,
	uv: vec2i
}
var<private> splat: Splat;
fn setSplat(idx: u32) {
	splat.index = idx;
	splat.uv = vec2i(i32(idx % uniform.splatTextureSize), i32(idx / uniform.splatTextureSize));
}
`;

var gsplatEvalSH_default2 = `
	#if SH_BANDS == 1
		const SH_COEFFS: i32 = 3;
	#elif SH_BANDS == 2
		const SH_COEFFS: i32 = 8;
	#elif SH_BANDS == 3
		const SH_COEFFS: i32 = 15;
	#else
		const SH_COEFFS: i32 = 0;
	#endif
	#if SH_BANDS > 0
	const SH_C1: half = half(0.4886025119029199);
	#if SH_BANDS > 1
		const SH_C2_0: half = half(1.0925484305920792);
		const SH_C2_1: half = half(-1.0925484305920792);
		const SH_C2_2: half = half(0.31539156525252005);
		const SH_C2_3: half = half(-1.0925484305920792);
		const SH_C2_4: half = half(0.5462742152960396);
	#endif
	#if SH_BANDS > 2
		const SH_C3_0: half = half(-0.5900435899266435);
		const SH_C3_1: half = half(2.890611442640554);
		const SH_C3_2: half = half(-0.4570457994644658);
		const SH_C3_3: half = half(0.3731763325901154);
		const SH_C3_4: half = half(-0.4570457994644658);
		const SH_C3_5: half = half(1.445305721320277);
		const SH_C3_6: half = half(-0.5900435899266435);
	#endif
	fn evalSH(sh: ptr<function, array<half3, SH_COEFFS>>, dir: vec3f) -> half3 {
		let d: half3 = half3(dir);
		var result: half3 = SH_C1 * (-sh[0] * d.y + sh[1] * d.z - sh[2] * d.x);
		#if SH_BANDS > 1
			let xx: half = d.x * d.x;
			let yy: half = d.y * d.y;
			let zz: half = d.z * d.z;
			let xy: half = d.x * d.y;
			let yz: half = d.y * d.z;
			let xz: half = d.x * d.z;
			result = result + (
				sh[3] * (SH_C2_0 * xy) +
				sh[4] * (SH_C2_1 * yz) +
				sh[5] * (SH_C2_2 * (half(2.0) * zz - xx - yy)) +
				sh[6] * (SH_C2_3 * xz) +
				sh[7] * (SH_C2_4 * (xx - yy))
			);
		#endif
		#if SH_BANDS > 2
			result = result + (
				sh[8]  * (SH_C3_0 * d.y * (half(3.0) * xx - yy)) +
				sh[9]  * (SH_C3_1 * xy * d.z) +
				sh[10] * (SH_C3_2 * d.y * (half(4.0) * zz - xx - yy)) +
				sh[11] * (SH_C3_3 * d.z * (half(2.0) * zz - half(3.0) * xx - half(3.0) * yy)) +
				sh[12] * (SH_C3_4 * d.x * (half(4.0) * zz - xx - yy)) +
				sh[13] * (SH_C3_5 * d.z * (xx - yy)) +
				sh[14] * (SH_C3_6 * d.x * (xx - half(3.0) * yy))
			);
		#endif
		return result;
	}
	#endif
`;

var gsplatModify_default4 = `
fn modifySplatColor(gaussianUV: vec2f, color: ptr<function, vec4f>) {
}
`;

var gsplatWorkBufferGeometry_default2 = `
#ifdef GSPLAT_WORKBUFFER_GEOMETRY
	var uWorkBufferTransformA: texture_2d<u32>;
	var uWorkBufferTransformB: texture_2d<u32>;
	uniform matrix_model_inverse: mat4x4f;
	uniform uCameraPosition: vec3f;
	var<private> wbCoord: vec2i;
	var<private> wbTransformA: vec4u;
	fn initWorkBufferGeometry(coord: vec2i) {
		wbCoord = coord;
		wbTransformA = textureLoad(uWorkBufferTransformA, coord, 0);
	}
	fn workBufferWorldCenter() -> vec3f {
		return vec3f(bitcast<f32>(wbTransformA.x), bitcast<f32>(wbTransformA.y), bitcast<f32>(wbTransformA.z));
	}
	fn workBufferWorldRotation() -> vec4f {
		#ifdef GSPLAT_WORKBUFFER_COMPACT
			let data = textureLoad(uWorkBufferTransformB, wbCoord, 0).x;
			let p = vec3f(
				f32(data & 0x7FFu) / 2047.0 * 2.0 - 1.0,
				f32((data >> 11u) & 0x7FFu) / 2047.0 * 2.0 - 1.0,
				f32((data >> 22u) & 0x3FFu) / 1023.0 * 2.0 - 1.0
			);
			let d = dot(p, p);
			return vec4f(sqrt(max(0.0, 2.0 - d)) * p, 1.0 - d);
		#else
			let rotXY = unpack2x16float(wbTransformA.w);
			let r = vec3f(rotXY, unpack2x16float(textureLoad(uWorkBufferTransformB, wbCoord, 0).x).x);
			return vec4f(r, sqrt(max(0.0, 1.0 - dot(r, r))));
		#endif
	}
	fn workBufferWorldScale() -> vec3f {
		#ifdef GSPLAT_WORKBUFFER_COMPACT
			let data = wbTransformA.w;
			let sx = f32(data & 0xFFu);
			let sy = f32((data >> 8u) & 0xFFu);
			let sz = f32((data >> 16u) & 0xFFu);
			let logRange = 21.0 / 255.0;
			let logMin = -12.0;
			return vec3f(
				select(exp(sx * logRange + logMin), 0.0, sx == 0.0),
				select(exp(sy * logRange + logMin), 0.0, sy == 0.0),
				select(exp(sz * logRange + logMin), 0.0, sz == 0.0)
			);
		#else
			let b = textureLoad(uWorkBufferTransformB, wbCoord, 0).xy;
			return vec3f(unpack2x16float(b.x).y, unpack2x16float(b.y));
		#endif
	}
	fn quatRotateInv(q: vec4f, v: vec3f) -> vec3f {
		let t = -q.xyz;
		return v + 2.0 * cross(t, cross(t, v) + q.w * v);
	}
	fn getCenter() -> vec3f {
		return (uniform.matrix_model_inverse * vec4f(workBufferWorldCenter(), 1.0)).xyz;
	}
	fn getRotation() -> vec4f {
		let worldRotation = workBufferWorldRotation();
		let localRotation = vec4f(quatMul(half4(vec4f(-uniform.model_rotation.xyz, uniform.model_rotation.w)), half4(worldRotation)));
		return localRotation.wxyz;
	}
	fn getScale() -> vec3f {
		return workBufferWorldScale() / uniform.model_scale;
	}
#endif
`;

var gsplatQuatToMat3_default2 = `
fn quatToMat3(r: half4) -> half3x3 {
	let r2: half4 = r + r;
	let x: half   = r2.x * r.w;
	let y: half4  = r2.y * r;
	let z: half4  = r2.z * r;
	let w: half   = r2.w * r.w;
	return half3x3(
		half(1.0) - z.z - w,  y.z + x,			  y.w - z.x,
		y.z - x,			  half(1.0) - y.y - w,   z.w + y.x,
		y.w + z.x,			z.w - y.x,			 half(1.0) - y.y - z.z
	);
}
fn quatMul(a: half4, b: half4) -> half4 {
	return half4(
		a.w * b.x + a.x * b.w + a.y * b.z - a.z * b.y,
		a.w * b.y - a.x * b.z + a.y * b.w + a.z * b.x,
		a.w * b.z + a.x * b.y - a.y * b.x + a.z * b.w,
		a.w * b.w - a.x * b.x - a.y * b.y - a.z * b.z
	);
}
`;

var gsplatStructs_default2 = `
#include "gsplatSplatVS"
struct SplatSource {
	order: u32,
	cornerUV: half2
}
struct SplatCenter {
	view: vec3f,
	proj: vec4f,
	modelView: mat4x4f,
	projMat00: f32,
	modelCenterOriginal: vec3f,
	modelCenterModified: vec3f,
	#ifdef GSPLAT_FISHEYE
		fisheyeSinTK: f32,
		fisheyeCosTK: f32,
		fisheyeRxy: f32,
	#endif
}
struct SplatCorner {
	offset: vec3f,
	uv: half2,
	#if GSPLAT_AA
		aaFactor: half,
	#endif
}
`;

var gsplatCorner_default2 = `
uniform viewport_size: vec4f;
uniform minPixelSize: f32;
fn computeCovariance(rotation: half4, scale: half3, covA_ptr: ptr<function, vec3f>, covB_ptr: ptr<function, vec3f>) {
	let rot: half3x3 = quatToMat3(rotation);
	let s: vec3f = vec3f(scale);
	let M: mat3x3f = transpose(mat3x3f(
		s.x * vec3f(rot[0]),
		s.y * vec3f(rot[1]),
		s.z * vec3f(rot[2])
	));
	*covA_ptr = vec3f(dot(M[0], M[0]), dot(M[0], M[1]), dot(M[0], M[2]));
	*covB_ptr = vec3f(dot(M[1], M[1]), dot(M[1], M[2]), dot(M[2], M[2]));
}
fn initCornerCov(source: ptr<function, SplatSource>, center: ptr<function, SplatCenter>, corner: ptr<function, SplatCorner>, covA: vec3f, covB: vec3f) -> bool {
	let Vrk = mat3x3f(
		vec3f(covA.x, covA.y, covA.z),
		vec3f(covA.y, covB.x, covB.y),
		vec3f(covA.z, covB.y, covB.z)
	);
	let focal = uniform.viewport_size.x * center.projMat00;
	let v = center.view.xyz;
	#ifdef GSPLAT_FISHEYE
		let r_sq = max(center.fisheyeRxy * center.fisheyeRxy, 1e-8);
		let d2 = dot(v, v);
		let neg_z = -v.z;
		let g_prime = 1.0 / (center.fisheyeCosTK * center.fisheyeCosTK);
		let g_theta = uniform.fisheye_k * center.fisheyeSinTK / center.fisheyeCosTK;
		let sv = select(select(0.0, 1.0 / neg_z, neg_z > 0.0), g_theta / center.fisheyeRxy, center.fisheyeRxy > 1e-4);
		let K = select(0.0, (g_prime * neg_z / d2 - sv) / r_sq, center.fisheyeRxy > 1e-4);
		let J = mat3x3f(
			vec3f(focal * (sv + K * v.x * v.x),  focal * K * v.x * v.y,	   focal * g_prime * v.x / d2),
			vec3f(focal * K * v.x * v.y,		 focal * (sv + K * v.y * v.y), focal * g_prime * v.y / d2),
			vec3f(0.0, 0.0, 0.0)
		);
	#else
		let vp = select(center.view.xyz, vec3f(0.0, 0.0, 1.0), uniform.camera_params.w == 1.0);
		let J1 = focal / vp.z;
		let J2 = -J1 / vp.z * vp.xy;
		let J = mat3x3f(
			vec3f(J1, 0.0, J2.x),
			vec3f(0.0, J1, J2.y),
			vec3f(0.0, 0.0, 0.0)
		);
	#endif
	let W = transpose(mat3x3f(center.modelView[0].xyz, center.modelView[1].xyz, center.modelView[2].xyz));
	let T = W * J;
	let cov = transpose(T) * Vrk * T;
	#if GSPLAT_AA
		let detOrig = cov[0][0] * cov[1][1] - cov[0][1] * cov[1][0];
		let detBlur = (cov[0][0] + 0.3) * (cov[1][1] + 0.3) - cov[0][1] * cov[1][0];
		corner.aaFactor = half(sqrt(max(detOrig / detBlur, 0.0)));
	#endif
	let diagonal1 = cov[0][0] + 0.3;
	let offDiagonal = cov[0][1];
	let diagonal2 = cov[1][1] + 0.3;
	let mid = 0.5 * (diagonal1 + diagonal2);
	let radius = length(vec2f((diagonal1 - diagonal2) / 2.0, offDiagonal));
	let lambda1 = mid + radius;
	let lambda2 = max(mid - radius, 0.1);
	let vmin = min(1024.0, min(uniform.viewport_size.x, uniform.viewport_size.y));
	let l1 = 2.0 * min(sqrt(2.0 * lambda1), vmin);
	let l2 = 2.0 * min(sqrt(2.0 * lambda2), vmin);
	if (max(l1, l2) < uniform.minPixelSize) {
		return false;
	}
	let c = center.proj.ww * uniform.viewport_size.zw;
	if (any((abs(center.proj.xy) - vec2f(max(l1, l2)) * c) > center.proj.ww)) {
		return false;
	}
	let diagonalVector = normalize(vec2f(offDiagonal, lambda1 - diagonal1));
	let v1 = l1 * diagonalVector;
	let v2 = l2 * vec2f(diagonalVector.y, -diagonalVector.x);
	corner.offset = vec3f((f32(source.cornerUV.x) * v1 + f32(source.cornerUV.y) * v2) * c, 0.0);
	corner.uv = source.cornerUV;
	return true;
}
#if GSPLAT_2DGS
fn initCorner2DGS(source: ptr<function, SplatSource>, rotation: vec4f, scale: vec3f, corner: ptr<function, SplatCorner>) {
	let localPos: vec2f = vec2f(source.cornerUV) * vec2f(scale.x, scale.y) * 3.0;
	let v: vec3f = vec3f(localPos, 0.0);
	let t: vec3f = 2.0 * cross(rotation.xyz, v);
	corner.offset = v + rotation.w * t + cross(rotation.xyz, t);
	corner.uv = source.cornerUV;
}
#endif
fn initCorner(source: ptr<function, SplatSource>, center: ptr<function, SplatCenter>, corner: ptr<function, SplatCorner>) -> bool {
	var rotation: vec4f = getRotation().yzwx;
	var scale: vec3f = getScale();
	modifySplatRotationScale(center.modelCenterOriginal, center.modelCenterModified, &rotation, &scale);
	#if GSPLAT_2DGS
		initCorner2DGS(source, rotation, scale, corner);
		return true;
	#else
		var covA: vec3f;
		var covB: vec3f;
		computeCovariance(half4(rotation.wxyz), half3(scale), &covA, &covB);
		return initCornerCov(source, center, corner, covA, covB);
	#endif
}
`;

var gsplatOutput_default2 = `
#include "tonemappingPS"
#include "decodePS"
#include "gammaPS"
#include "fogPS"
#if FOG != NONE && !defined(GSPLAT_NO_FOG)
	#define GSPLAT_FOG
#endif
fn prepareOutputFromGamma(gammaColor: vec3f, depth: f32) -> vec3f {
	var color = gammaColor;
	#if TONEMAP != NONE || GAMMA == NONE || defined(GSPLAT_FOG)
		color = decodeGamma3(color);
	#endif
	#ifdef GSPLAT_FOG
		color = addFog(color, depth);
	#endif
	#if TONEMAP != NONE
		color = toneMap(color);
	#endif
	#if TONEMAP != NONE || (GAMMA != NONE && defined(GSPLAT_FOG))
		color = gammaCorrectOutput(color);
	#endif
	return color;
}
`;

var gsplat_default3 = `
#ifndef DITHER_NONE
	#include "bayerPS"
	#include "opacityDitherPS"
	varying id: f32;
#endif
#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
	uniform alphaClip: f32;
#endif
#ifdef PREPASS_PASS
	varying vLinearDepth: f32;
	#include "floatAsUintPS"
#endif
#if !defined(SHADOW_PASS) && !defined(PICK_PASS) && !defined(PREPASS_PASS)
	uniform alphaClipForward: f32;
#endif
const EXP4: half = exp(half(-4.0));
const INV_EXP4: half = half(1.0) / (half(1.0) - EXP4);
fn normExp(x: half) -> half {
	return (exp(x * half(-4.0)) - EXP4) * INV_EXP4;
}
varying gaussianUV: half2;
varying gaussianColor: half4;
#if defined(GSPLAT_UNIFIED_ID) && defined(PICK_PASS)
	varying @interpolate(flat) vPickId: u32;
#endif
#ifdef PICK_PASS
	#include "pickPS"
#endif
#ifdef GSPLAT_USER_VARYINGS
	#include "gsplatUserVaryingsPS"
#endif
#include "gsplatModifyPS"
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	let A: half = dot(gaussianUV, gaussianUV);
	if (A > half(1.0)) {
		discard;
	}
	var alpha: half = normExp(A) * gaussianColor.a;
	#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
		if (alpha < half(uniform.alphaClip)) {
			discard;
			return output;
		}
	#endif
	#ifdef PICK_PASS
		#ifdef GSPLAT_UNIFIED_ID
			output.color = encodePickOutput(vPickId);
		#else
			output.color = getPickOutput();
		#endif
		#ifdef DEPTH_PICK_PASS
			output.color1 = getPickDepth();
		#endif
	#elif SHADOW_PASS
		output.color = vec4f(input.position.z, 0.0, 0.0, 1.0);
	#elif PREPASS_PASS
		output.color = float2vec4(vLinearDepth);
	#else
		if (alpha < half(uniform.alphaClipForward)) {
			discard;
		}
		#ifndef DITHER_NONE
			opacityDither(f32(alpha), id * 0.013);
		#endif
		var fragColor: vec4f = vec4f(vec3f(gaussianColor.xyz), f32(alpha));
		modifySplatColor(vec2f(gaussianUV), &fragColor);
		output.color = vec4f(fragColor.xyz * fragColor.a, fragColor.a);
	#endif
	return output;
}`;

var gsplatSource_default2 = `
attribute vertex_position: vec3f;
#ifdef GSPLAT_INDIRECT_DRAW
	var<storage, read> numSplatsStorage: array<u32>;
	var<storage, read> compactedSplatIds: array<u32>;
#else
	uniform numSplats: u32;
	var<storage, read> splatOrder: array<u32>;
#endif
fn initSource(source: ptr<function, SplatSource>) -> bool {
	source.order = pcInstanceIndex * {GSPLAT_INSTANCE_SIZE}u + u32(vertex_position.z);
	#ifdef GSPLAT_INDIRECT_DRAW
		let numSplats = numSplatsStorage[0];
	#else
		let numSplats = uniform.numSplats;
	#endif
	if (source.order >= numSplats) {
		return false;
	}
	var splatId: u32;
	#ifdef GSPLAT_INDIRECT_DRAW
		splatId = compactedSplatIds[source.order];
	#else
		splatId = splatOrder[source.order];
	#endif
	setSplat(splatId);
	source.cornerUV = half2(vertex_position.xy);
	return true;
}
`;

var gsplat_default4 = `
#ifdef GSPLAT_USER_VARYINGS
	#include "gsplatUserVaryingsVS"
#endif
#include "gsplatCommonVS"
varying gaussianUV: half2;
varying gaussianColor: half4;
#ifndef DITHER_NONE
	varying id: f32;
#endif
const discardVec: vec4f = vec4f(0.0, 0.0, 2.0, 1.0);
#ifdef PREPASS_PASS
	varying vLinearDepth: f32;
#endif
#if defined(GSPLAT_UNIFIED_ID) && defined(PICK_PASS)
	varying @interpolate(flat) vPickId: u32;
#endif
#ifdef GSPLAT_OVERDRAW
	uniform colorRampIntensity: f32;
	var colorRamp: texture_2d<f32>;
	var colorRampSampler: sampler;
#endif
@vertex
fn vertexMain(input: VertexInput) -> VertexOutput {
	var output: VertexOutput;
	var source: SplatSource;
	if (!initSource(&source)) {
		output.position = discardVec;
		return output;
	}
	var modelCenter: vec3f = getCenter();
	var center: SplatCenter;
	center.modelCenterOriginal = modelCenter;
	
	modifySplatCenter(&modelCenter);
	center.modelCenterModified = modelCenter;
	if (!initCenter(modelCenter, &center)) {
		output.position = discardVec;
		return output;
	}
	var corner: SplatCorner;
	if (!initCorner(&source, &center, &corner)) {
		output.position = discardVec;
		return output;
	}
	#ifdef GSPLAT_SEPARATE_OPACITY
		let opacity = getOpacity();
		var clr: half4 = half4(vec4f(getColor(), opacity));
	#else
		var clr: half4 = half4(getColor());
	#endif
	#if GSPLAT_AA
		clr.a = clr.a * corner.aaFactor;
	#endif
	#if SH_BANDS > 0
		let modelView3x3 = mat3x3f(center.modelView[0].xyz, center.modelView[1].xyz, center.modelView[2].xyz);
		let dir = normalize(center.view * modelView3x3);
		var sh: array<half3, SH_COEFFS>;
		var scale: f32;
		readSHData(&sh, &scale);
		clr = half4(clr.xyz + evalSH(&sh, dir) * half(scale), clr.a);
	#endif
	var clrF32 = vec4f(clr);
	modifySplatColor(modelCenter, &clrF32);
	clr = half4(clrF32);
	#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
		let alphaClipValue = half(uniform.alphaClip);
	#else
		let alphaClipValue = half(uniform.alphaClipForward);
	#endif
	if (clr.w <= alphaClipValue) {
		output.position = discardVec;
		return output;
	}
	clipCorner(&corner, clr.w);
	#if GSPLAT_2DGS
		let modelCorner: vec3f = center.modelCenterModified + corner.offset;
		output.position = uniform.matrix_projection * center.modelView * vec4f(modelCorner, 1.0);
	#else
		output.position = center.proj + vec4f(corner.offset.xyz, 0.0);
	#endif
	output.gaussianUV = corner.uv;
	#ifdef GSPLAT_USER_VARYINGS
		#include "gsplatUserVaryingsFlushVS"
	#endif
	#ifdef GSPLAT_OVERDRAW
		let t: f32 = clamp(center.modelCenterOriginal.y / 20.0, 0.0, 1.0);
		let rampColor: vec3f = textureSampleLevel(colorRamp, colorRampSampler, vec2f(t, 0.5), 0.0).rgb;
		clr.a = clr.a * half(1.0 / 32.0) * half(uniform.colorRampIntensity);
		output.gaussianColor = half4(half3(rampColor), clr.a);
	#else
		output.gaussianColor = half4(half3(prepareOutputFromGamma(max(vec3f(clr.xyz), vec3f(0.0)), -center.view.z)), clr.w);
	#endif
	#ifndef DITHER_NONE
		output.id = f32(splat.index);
	#endif
	#ifdef PREPASS_PASS
		output.vLinearDepth = -center.view.z;
	#endif
	#if defined(GSPLAT_UNIFIED_ID) && defined(PICK_PASS)
		output.vPickId = loadPcId().r;
	#endif
	return output;
}
`;

var gsplatHybrid_default = `
#include "gsplatHelpersVS"
#include "gsplatOutputVS"
#ifdef GSPLAT_USER_VARYINGS
	#include "gsplatUserVaryingsVS"
#endif
attribute vertex_position: vec3f;
uniform viewport_size: vec4f;
uniform clipToViewZ: vec4f;
#ifdef GSPLAT_XR
	uniform view_index: u32;
	uniform matrix_projection: mat4x4f;
#endif
#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
	uniform alphaClip: f32;
#else
	uniform alphaClipForward: f32;
#endif
var<storage, read> sortedIndices: array<u32>;
var<storage, read> projCache: array<u32>;
var<storage, read> numSplatsStorage: array<u32>;
varying gaussianUV: half2;
varying gaussianColor: half4;
#ifndef DITHER_NONE
	varying id: f32;
#endif
#ifdef PREPASS_PASS
	varying vLinearDepth: f32;
#endif
#if defined(GSPLAT_UNIFIED_ID) && defined(PICK_PASS)
	varying @interpolate(flat) vPickId: u32;
#endif
#ifdef GSPLAT_OVERDRAW
	uniform colorRampIntensity: f32;
	var colorRamp: texture_2d<f32>;
	var colorRampSampler: sampler;
#endif
const discardVec: vec4f = vec4f(0.0, 0.0, 2.0, 1.0);
@vertex
fn vertexMain(input: VertexInput) -> VertexOutput {
	var output: VertexOutput;
	let order = pcInstanceIndex * {GSPLAT_INSTANCE_SIZE}u + u32(vertex_position.z);
	let numSplats = numSplatsStorage[0];
	if (order >= numSplats) {
		output.position = discardVec;
		return output;
	}
	let cacheIdx = sortedIndices[order];
	let base = cacheIdx * {CACHE_STRIDE}u;
	#ifdef GSPLAT_XR
		let off = uniform.view_index * 2u;
		let ndc = vec2f(
			bitcast<f32>(projCache[base + off + 0u]),
			bitcast<f32>(projCache[base + off + 1u])
		);
		let w = bitcast<f32>(projCache[base + 4u]);
		let pz = (uniform.matrix_projection[2][2] / uniform.matrix_projection[2][3]) * w + uniform.matrix_projection[3][2];
		let proj = vec4f(ndc * w, clamp(pz, 0.0, abs(w)), w);
		let v1 = unpack2x16float(projCache[base + 5u]);
		let v2 = unpack2x16float(projCache[base + 6u]);
		let rgba = unpack4x8unorm(projCache[base + 7u]);
		let alpha = half(rgba.a);
		var clr: half4 = half4(half(rgba.r), half(rgba.g), half(rgba.b), alpha);
	#else
		let proj = vec4f(
			bitcast<f32>(projCache[base + 0u]),
			bitcast<f32>(projCache[base + 1u]),
			bitcast<f32>(projCache[base + 2u]),
			bitcast<f32>(projCache[base + 3u])
		);
		let v1 = unpack2x16float(projCache[base + 4u]);
		let v2 = unpack2x16float(projCache[base + 5u]);
		let ba = unpack2x16float(projCache[base + 7u]);
		let alpha = half(ba.y);
		#if defined(GSPLAT_UNIFIED_ID) && defined(PICK_PASS)
			let pickId = projCache[base + 6u];
		#endif
		#ifdef PICK_PASS
			var clr: half4 = half4(half(0.0), half(0.0), half(0.0), alpha);
		#else
			let rg = unpack2x16float(projCache[base + 6u]);
			var clr: half4 = half4(half(rg.x), half(rg.y), half(ba.x), alpha);
		#endif
	#endif
	let cornerUV = vec2f(vertex_position.xy);
	#if defined(SHADOW_PASS) || defined(PICK_PASS) || defined(PREPASS_PASS)
		let alphaClipValue = half(uniform.alphaClip);
	#else
		let alphaClipValue = half(uniform.alphaClipForward);
	#endif
	let clip = min(half(1.0), sqrt(max(half(0.0), log(alpha / alphaClipValue))) * half(0.5));
	let cornerClipped = cornerUV * f32(clip);
	let c = vec2f(proj.w) * uniform.viewport_size.zw;
	let pixelOffset = cornerClipped.x * v1 + cornerClipped.y * v2;
	let clipOffset = pixelOffset * c;
	output.position = proj + vec4f(clipOffset, 0.0, 0.0);
	output.gaussianUV = half2(cornerClipped);
	#ifdef GSPLAT_USER_VARYINGS
		#include "gsplatUserCacheReadVS"
	#endif
	#ifdef GSPLAT_XR
		let viewDepth = proj.w;
	#else
		let viewDepth = dot(uniform.clipToViewZ, proj);
	#endif
	#ifdef GSPLAT_OVERDRAW
		let t: f32 = clamp(viewDepth / 20.0, 0.0, 1.0);
		let rampColor: vec3f = textureSampleLevel(colorRamp, colorRampSampler, vec2f(t, 0.5), 0.0).rgb;
		let outAlpha = alpha * half(1.0 / 32.0) * half(uniform.colorRampIntensity);
		output.gaussianColor = half4(half3(rampColor), outAlpha);
	#else
		output.gaussianColor = half4(
			half3(prepareOutputFromGamma(max(vec3f(clr.xyz), vec3f(0.0)), viewDepth)),
			alpha
		);
	#endif
	#ifndef DITHER_NONE
		output.id = f32(cacheIdx);
	#endif
	#ifdef PREPASS_PASS
		output.vLinearDepth = viewDepth;
	#endif
	#if defined(GSPLAT_UNIFIED_ID) && defined(PICK_PASS)
		output.vPickId = pickId;
	#endif
	return output;
}
`;

var gsplatPacking_default2 = `
fn pack8888(v: vec4f) -> u32 {
	let t = vec4u(v * 255.0) << vec4u(24u, 16u, 8u, 0u);
	return t.x | t.y | t.z | t.w;
}
fn pack101010(v: vec3f) -> u32 {
	let t = vec3u(v * vec3f(1023.0, 1023.0, 1023.0)) << vec3u(20u, 10u, 0u);
	return t.x | t.y | t.z;
}
fn pack111110(v: vec3f) -> u32 {
	let t = vec3u(v * vec3f(2047.0, 2047.0, 1023.0)) << vec3u(21u, 10u, 0u);
	return t.x | t.y | t.z;
}
fn unpack8888(v: u32) -> vec4f {
	return vec4f((vec4u(v) >> vec4u(24u, 16u, 8u, 0u)) & vec4u(0xffu)) / 255.0;
}
fn unpack101010(v: u32) -> vec3f {
	return vec3f((vec3u(v) >> vec3u(20u, 10u, 0u)) & vec3u(0x3ffu)) / 1023.0;
}
fn unpack111110(v: u32) -> vec3f {
	return vec3f((vec3u(v) >> vec3u(21u, 10u, 0u)) & vec3u(0x7ffu, 0x7ffu, 0x3ffu)) / vec3f(2047.0, 2047.0, 1023.0);
}`;

var gsplatFormat_default2 = `
uniform splatTextureSize: u32;
`;

var uncompressed_default2 = `
var<private> tAw: u32;
var<private> tBcached: vec4f;
fn unpackRotation(data: vec3f) -> vec4f {
	return vec4f(data.xyz, sqrt(max(0.0, 1.0 - dot(data, data))));
}
fn getCenter() -> vec3f {
	let tA: vec4<u32> = loadTransformA();
	tAw = tA.w;
	tBcached = loadTransformB();
	return bitcast<vec3f>(tA.xyz);
}
fn getColor() -> vec4f {
	return loadSplatColor();
}
fn getRotation() -> vec4f {
	return unpackRotation(vec3f(unpack2x16float(tAw), tBcached.w)).wxyz;
}
fn getScale() -> vec3f {
	return tBcached.xyz;
}
#include "gsplatUncompressedSHVS"
`;

var uncompressedSH_default2 = `
#if SH_BANDS > 0
fn unpack111011s(bits: u32) -> vec3f {
	return (vec3f((vec3<u32>(bits) >> vec3<u32>(21u, 11u, 0u)) & vec3<u32>(0x7ffu, 0x3ffu, 0x7ffu)) / vec3f(2047.0, 1023.0, 2047.0)) * 2.0 - 1.0;
}
struct ScaleAndSH {
	scale: f32,
	a: vec3f,
	b: vec3f,
	c: vec3f
};
fn fetchScale(t_in: vec4<u32>) -> ScaleAndSH {
	var result: ScaleAndSH;
	result.scale = bitcast<f32>(t_in.x);
	result.a = unpack111011s(t_in.y);
	result.b = unpack111011s(t_in.z);
	result.c = unpack111011s(t_in.w);
	return result;
}
struct SH {
	a: vec3f,
	b: vec3f,
	c: vec3f,
	d: vec3f
};
fn fetch4(t_in: vec4<u32>) -> SH {
	var result: SH;
	result.a = unpack111011s(t_in.x);
	result.b = unpack111011s(t_in.y);
	result.c = unpack111011s(t_in.z);
	result.d = unpack111011s(t_in.w);
	return result;
}
fn fetch1(t_in: u32) -> vec3f {
	return unpack111011s(t_in);
}
#if SH_BANDS == 1
	fn readSHData(sh: ptr<function, array<half3, 3>>, scale: ptr<function, f32>) {
		let result = fetchScale(loadSplatSH_1to3());
		*scale = result.scale;
		sh[0] = half3(result.a);
		sh[1] = half3(result.b);
		sh[2] = half3(result.c);
	}
#elif SH_BANDS == 2
	fn readSHData(sh: ptr<function, array<half3, 8>>, scale: ptr<function, f32>) {
		let first: ScaleAndSH = fetchScale(loadSplatSH_1to3());
		*scale = first.scale;
		sh[0] = half3(first.a);
		sh[1] = half3(first.b);
		sh[2] = half3(first.c);
		let second: SH = fetch4(loadSplatSH_4to7());
		sh[3] = half3(second.a);
		sh[4] = half3(second.b);
		sh[5] = half3(second.c);
		sh[6] = half3(second.d);
		sh[7] = half3(fetch1(loadSplatSH_8to11().x));
	}
#else
	fn readSHData(sh: ptr<function, array<half3, 15>>, scale: ptr<function, f32>) {
		let first: ScaleAndSH = fetchScale(loadSplatSH_1to3());
		*scale = first.scale;
		sh[0] = half3(first.a);
		sh[1] = half3(first.b);
		sh[2] = half3(first.c);
		let second: SH = fetch4(loadSplatSH_4to7());
		sh[3] = half3(second.a);
		sh[4] = half3(second.b);
		sh[5] = half3(second.c);
		sh[6] = half3(second.d);
		let third: SH = fetch4(loadSplatSH_8to11());
		sh[7] = half3(third.a);
		sh[8] = half3(third.b);
		sh[9] = half3(third.c);
		sh[10] = half3(third.d);
		let fourth: SH = fetch4(loadSplatSH_12to15());
		sh[11] = half3(fourth.a);
		sh[12] = half3(fourth.b);
		sh[13] = half3(fourth.c);
		sh[14] = half3(fourth.d);
	}
#endif
#endif
`;

var compressed_default2 = `
#include "gsplatPackingPS"
var chunkTexture: texture_2d<uff>;
var<private> chunkDataA: vec4f;
var<private> chunkDataB: vec4f;
var<private> chunkDataC: vec4f;
var<private> chunkDataD: vec4f;
var<private> chunkDataE: vec4f;
var<private> packedData: vec4u;
fn unpack111011(bits: u32) -> vec3f {
	return (vec3f((vec3<u32>(bits) >> vec3<u32>(21u, 11u, 0u)) & vec3<u32>(0x7ffu, 0x3ffu, 0x7ffu))) / vec3f(2047.0, 1023.0, 2047.0);
}
const norm_const: f32 = sqrt(2.0);
fn unpackRotation(bits: u32) -> vec4f {
	let a = (f32((bits >> 20u) & 0x3ffu) / 1023.0 - 0.5) * norm_const;
	let b = (f32((bits >> 10u) & 0x3ffu) / 1023.0 - 0.5) * norm_const;
	let c = (f32(bits & 0x3ffu) / 1023.0 - 0.5) * norm_const;
	let m = sqrt(1.0 - (a * a + b * b + c * c));
	let mode = bits >> 30u;
	if (mode == 0u) { return vec4f(m, a, b, c); }
	if (mode == 1u) { return vec4f(a, m, b, c); }
	if (mode == 2u) { return vec4f(a, b, m, c); }
	return vec4f(a, b, c, m);
}
fn getCenter() -> vec3f {
	let tex_size_u = textureDimensions(chunkTexture, 0);
	let w: u32 = tex_size_u.x / 5u;
	let chunkId: u32 = splat.index / 256u;
	let chunkUV: vec2<i32> = vec2<i32>(i32((chunkId % w) * 5u), i32(chunkId / w));
	chunkDataA = textureLoad(chunkTexture, chunkUV + vec2<i32>(0, 0), 0);
	chunkDataB = textureLoad(chunkTexture, chunkUV + vec2<i32>(1, 0), 0);
	chunkDataC = textureLoad(chunkTexture, chunkUV + vec2<i32>(2, 0), 0);
	chunkDataD = textureLoad(chunkTexture, chunkUV + vec2<i32>(3, 0), 0);
	chunkDataE = textureLoad(chunkTexture, chunkUV + vec2<i32>(4, 0), 0);
	packedData = loadPackedTexture();
	return mix(chunkDataA.xyz, vec3f(chunkDataA.w, chunkDataB.xy), unpack111011(packedData.x));
}
fn getColor() -> vec4f {
	let r = unpack8888(packedData.w);
	return vec4f(mix(chunkDataD.xyz, vec3f(chunkDataD.w, chunkDataE.xy), r.rgb), r.w);
}
fn getRotation() -> vec4f {
	return unpackRotation(packedData.y);
}
fn getScale() -> vec3f {
	return exp(mix(vec3f(chunkDataB.zw, chunkDataC.x), chunkDataC.yzw, unpack111011(packedData.z)));
}
#include "gsplatCompressedSHVS"
`;

var compressedSH_default2 = `
#if SH_BANDS > 0
fn unpack8888s(bits: u32) -> half4 {
	let unpacked_u = (vec4<u32>(bits) >> vec4<u32>(0u, 8u, 16u, 24u)) & vec4<u32>(0xffu);
	return half4(vec4f(unpacked_u) * (8.0 / 255.0) - 4.0);
}
fn readSHData(sh: ptr<function, array<half3, 15>>, scale: ptr<function, f32>) {
	let shData0: vec4<u32> = loadShTexture0();
	let shData1: vec4<u32> = loadShTexture1();
	let shData2: vec4<u32> = loadShTexture2();
	let r0: half4 = unpack8888s(shData0.x);
	let r1: half4 = unpack8888s(shData0.y);
	let r2: half4 = unpack8888s(shData0.z);
	let r3: half4 = unpack8888s(shData0.w);
	let g0: half4 = unpack8888s(shData1.x);
	let g1: half4 = unpack8888s(shData1.y);
	let g2: half4 = unpack8888s(shData1.z);
	let g3: half4 = unpack8888s(shData1.w);
	let b0: half4 = unpack8888s(shData2.x);
	let b1: half4 = unpack8888s(shData2.y);
	let b2: half4 = unpack8888s(shData2.z);
	let b3: half4 = unpack8888s(shData2.w);
	sh[0] =  half3(r0.x, g0.x, b0.x);
	sh[1] =  half3(r0.y, g0.y, b0.y);
	sh[2] =  half3(r0.z, g0.z, b0.z);
	sh[3] =  half3(r0.w, g0.w, b0.w);
	sh[4] =  half3(r1.x, g1.x, b1.x);
	sh[5] =  half3(r1.y, g1.y, b1.y);
	sh[6] =  half3(r1.z, g1.z, b1.z);
	sh[7] =  half3(r1.w, g1.w, b1.w);
	sh[8] =  half3(r2.x, g2.x, b2.x);
	sh[9] =  half3(r2.y, g2.y, b2.y);
	sh[10] = half3(r2.z, g2.z, b2.z);
	sh[11] = half3(r2.w, g2.w, b2.w);
	sh[12] = half3(r3.x, g3.x, b3.x);
	sh[13] = half3(r3.y, g3.y, b3.y);
	sh[14] = half3(r3.z, g3.z, b3.z);
	*scale = 1.0;
}
#endif
`;

var sog_default2 = `
uniform means_mins: vec3f;
uniform means_maxs: vec3f;
#ifndef SOG_V2
	uniform scales_mins: vec3f;
	uniform scales_maxs: vec3f;
	uniform sh0_mins: vec4f;
	uniform sh0_maxs: vec4f;
#endif
const SH_C0: f32 = 0.28209479177387814;
const norm: f32 = sqrt(2.0);
#ifdef SOG_V2
	fn lutScales(b: i32) -> f32 { return textureLoad(sogCodebook, vec2i(b, 0), 0).r; }
	fn lutSh0(b: i32) -> f32	{ return textureLoad(sogCodebook, vec2i(b, 0), 0).g; }
	fn lutShN(b: i32) -> f32	{ return textureLoad(sogCodebook, vec2i(b, 0), 0).b; }
#endif
#ifndef GSPLAT_WORKBUFFER_GEOMETRY
fn getCenter() -> vec3f {
	let l = textureLoad(means_l, splat.uv, 0).xyz;
	let u = textureLoad(means_u, splat.uv, 0).xyz;
	let n = (l + u * 256.0) / 257.0;
	let v = mix(uniform.means_mins, uniform.means_maxs, n);
	return sign(v) * (exp(abs(v)) - 1.0);
}
fn getRotation() -> vec4f {
	let q = textureLoad(quats, splat.uv, 0);
	let qmode = u32(q.w * 255.0 + 0.5) - 252u;
	let abc = (q.xyz - 0.5) * norm;
	let d = sqrt(max(0.0, 1.0 - dot(abc, abc)));
	var quat: vec4f;
	if (qmode == 0u) {
		quat = vec4f(d, abc);
	} else if (qmode == 1u) {
		quat = vec4f(abc.x, d, abc.y, abc.z);
	} else if (qmode == 2u) {
		quat = vec4f(abc.x, abc.y, d, abc.z);
	} else {
		quat = vec4f(abc.x, abc.y, abc.z, d);
	}
	return quat;
}
fn getScale() -> vec3f {
	let s = textureLoad(scales, splat.uv, 0).xyz;
	var logS: vec3f;
	#ifdef SOG_V2
		let i = vec3i(s * 255.0 + 0.5);
		logS = vec3f(lutScales(i.x), lutScales(i.y), lutScales(i.z));
	#else
		logS = mix(uniform.scales_mins, uniform.scales_maxs, s);
	#endif
	return exp(logS);
}
#endif
fn getColor() -> vec4f {
	let c = textureLoad(sh0, splat.uv, 0);
	var rgb: vec3f;
	var alpha: f32;
	#ifdef SOG_V2
		let i = vec3i(c.xyz * 255.0 + 0.5);
		rgb = vec3f(lutSh0(i.x), lutSh0(i.y), lutSh0(i.z));
		alpha = c.w;
	#else
		rgb = mix(uniform.sh0_mins.xyz, uniform.sh0_maxs.xyz, c.xyz);
		let logitAlpha = mix(uniform.sh0_mins.w, uniform.sh0_maxs.w, c.w);
		alpha = 1.0 / (1.0 + exp(-logitAlpha));
	#endif
	return vec4f(vec3f(0.5) + rgb * SH_C0, alpha);
}
#include "gsplatSogSHVS"
`;

var sogSH_default2 = `
#if SH_BANDS > 0
	#ifndef SOG_V2
		uniform shN_mins: f32;
		uniform shN_maxs: f32;
	#endif
	fn readSHTexel(u: i32, v: i32) -> half3 {
		let t = textureLoad(sh_centroids, vec2i(u, v), 0);
		#ifdef SOG_V2
			let idx = vec3i(t.xyz * 255.0 + 0.5);
			return half3(vec3f(lutShN(idx.x), lutShN(idx.y), lutShN(idx.z)));
		#else
			return mix(half3(half(uniform.shN_mins)), half3(half(uniform.shN_maxs)), half3(t.xyz));
		#endif
	}
	fn readSHData(sh: ptr<function, array<half3, SH_COEFFS>>, scale: ptr<function, f32>) {
		let labels = textureLoad(sh_labels, splat.uv, 0);
		let n = i32(labels.x * 255.0 + 0.5) + i32(labels.y * 255.0 + 0.5) * 256;
		let u = (n % 64) * SH_COEFFS;
		let v = n / 64;
		sh[0] = readSHTexel(u, v);
		sh[1] = readSHTexel(u + 1, v);
		sh[2] = readSHTexel(u + 2, v);
		#if SH_BANDS > 1
			sh[3] = readSHTexel(u + 3, v);
			sh[4] = readSHTexel(u + 4, v);
			sh[5] = readSHTexel(u + 5, v);
			sh[6] = readSHTexel(u + 6, v);
			sh[7] = readSHTexel(u + 7, v);
		#endif
		#if SH_BANDS > 2
			sh[8]  = readSHTexel(u + 8, v);
			sh[9]  = readSHTexel(u + 9, v);
			sh[10] = readSHTexel(u + 10, v);
			sh[11] = readSHTexel(u + 11, v);
			sh[12] = readSHTexel(u + 12, v);
			sh[13] = readSHTexel(u + 13, v);
			sh[14] = readSHTexel(u + 14, v);
		#endif
		*scale = 1.0;
	}
#endif
`;

var containerDecl_default2 = `
#include "gsplatContainerDeclarationsVS"
var<private> splatCenter: vec3f;
var<private> splatColor: vec4f;
var<private> splatScale: vec3f;
var<private> splatRotation: vec4f;
`;

var containerRead_default2 = `
fn getCenter() -> vec3f {
	#include "gsplatContainerUserReadVS"
	return splatCenter;
}
fn getRotation() -> vec4f {
	return splatRotation;
}
fn getScale() -> vec3f {
	return splatScale;
}
fn getColor() -> vec4f {
	return splatColor;
}
`;

var gsplatChunksWGSL = {
	gsplatCenterVS: gsplatCenter_default2,
	gsplatCornerVS: gsplatCorner_default2,
	gsplatCommonVS: gsplatCommon_default2,
	gsplatSplatVS: gsplatSplat_default2,
	gsplatEvalSHVS: gsplatEvalSH_default2,
	gsplatHelpersVS: gsplatHelpers_default,
	gsplatModifyVS: gsplatModify_default,
	gsplatModifyPS: gsplatModify_default4,
	gsplatWorkBufferGeometryPS: gsplatWorkBufferGeometry_default2,
	gsplatStructsVS: gsplatStructs_default2,
	gsplatQuatToMat3VS: gsplatQuatToMat3_default2,
	gsplatOutputVS: gsplatOutput_default2,
	gsplatPS: gsplat_default3,
	gsplatSourceVS: gsplatSource_default2,
	gsplatVS: gsplat_default4,
	gsplatHybridVS: gsplatHybrid_default,
	gsplatPackingPS: gsplatPacking_default2,
	gsplatFormatVS: gsplatFormat_default2,
	gsplatUncompressedVS: uncompressed_default2,
	gsplatUncompressedSHVS: uncompressedSH_default2,
	gsplatCompressedVS: compressed_default2,
	gsplatCompressedSHVS: compressedSH_default2,
	gsplatSogVS: sog_default2,
	gsplatSogSHVS: sogSH_default2,
	gsplatContainerDeclVS: containerDecl_default2,
	gsplatContainerReadVS: containerRead_default2,
	gsplatContainerFloatReadVS: containerFloatRead_default2
};

var _properties14 = [
	"unified",
	"lodBaseDistance",
	"lodMultiplier",
	"lodRangeMin",
	"lodRangeMax",
	"castShadows",
	"material",
	"asset",
	"resource",
	"layers"
];
var GSplatComponentSystem = class extends ComponentSystem {
	static EVENT_MATERIALCREATED = "material:created";
	static EVENT_FRAMEREADY = "frame:ready";
	static EVENT_FRAMEREQUEST = "frame:request";
	constructor(app2) {
		super(app2);
		this.id = "gsplat";
		this.ComponentType = GSplatComponent;
		this.extraDataProperties = ["aabbCenter", "aabbHalfExtents"];
		app2.renderer.gsplatDirector = new GSplatDirector(app2.graphicsDevice, app2.renderer, app2.scene, this);
		ShaderChunks.get(app2.graphicsDevice, SHADERLANGUAGE_GLSL).add(gsplatChunksGLSL);
		ShaderChunks.get(app2.graphicsDevice, SHADERLANGUAGE_WGSL).add(gsplatChunksWGSL);
		this.on("beforeremove", this.onBeforeRemove, this);
		this.app.on("framerender", this.onFrameRender, this);
	}
	onFrameRender() {
		this.app.renderer.gsplatDirector?.updateStreaming();
	}
	initializeComponentData(component, _data, properties) {
		if (_data.layers && _data.layers.length) {
			_data.layers = _data.layers.slice(0);
		}
		for (let i2 = 0; i2 < _properties14.length; i2++) {
			if (_data.hasOwnProperty(_properties14[i2])) {
				component[_properties14[i2]] = _data[_properties14[i2]];
			}
		}
		if (_data.aabbCenter && _data.aabbHalfExtents) {
			component.customAabb = new BoundingBox(new Vec3(_data.aabbCenter), new Vec3(_data.aabbHalfExtents));
		}
		super.initializeComponentData(component, _data);
	}
	cloneComponent(entity, clone) {
		const gSplatComponent = entity.gsplat;
		const data2 = {};
		_properties14.forEach((prop) => {
			if (prop === "material") {
				if (!gSplatComponent.unified) {
					const srcMaterial = gSplatComponent[prop];
					if (srcMaterial) {
						data2[prop] = srcMaterial.clone();
					}
				}
			} else {
				data2[prop] = gSplatComponent[prop];
			}
		});
		data2.enabled = gSplatComponent.enabled;
		const component = this.addComponent(clone, data2);
		component.customAabb = gSplatComponent.customAabb?.clone() ?? null;
		return component;
	}
	onBeforeRemove(entity, component) {
		component.onBeforeRemove();
	}
	getMaterial(camera, layer) {
		const director = this.app.renderer.gsplatDirector;
		if (!director) return null;
		const cameraData = director.camerasMap.get(camera);
		if (!cameraData) return null;
		const layerData = cameraData.layersMap.get(layer);
		return layerData?.gsplatManager?.material ?? null;
	}
	getGSplatMaterial(camera, layer) {
		return this.getMaterial(camera, layer);
	}
	destroy() {
		super.destroy();
		this.app.off("framerender", this.onFrameRender, this);
	}
};

var Render = class extends EventHandler {
	static EVENT_SETMESHES = "set:meshes";
	_meshes = null;
	set meshes(value) {
		this.decRefMeshes();
		this._meshes = value;
		this.incRefMeshes();
		this.fire("set:meshes", value);
	}
	get meshes() {
		return this._meshes;
	}
	destroy() {
		this.meshes = null;
	}
	decRefMeshes() {
		this._meshes?.forEach((mesh, index) => {
			if (mesh) {
				mesh.decRefCount();
				if (mesh.refCount < 1) {
					mesh.destroy();
					this._meshes[index] = null;
				}
			}
		});
	}
	incRefMeshes() {
		this._meshes?.forEach((mesh) => {
			mesh?.incRefCount();
		});
	}
};

function onContainerAssetLoaded(containerAsset) {
	const renderAsset = this;
	if (!renderAsset.resource) return;
	const containerResource = containerAsset.resource;
	const render = containerResource.renders && containerResource.renders[renderAsset.data.renderIndex];
	if (render) {
		renderAsset.resource.meshes = render.resource.meshes;
	}
}
function onContainerAssetAdded(containerAsset) {
	const renderAsset = this;
	renderAsset.registry.off(`load:${containerAsset.id}`, onContainerAssetLoaded, renderAsset);
	renderAsset.registry.on(`load:${containerAsset.id}`, onContainerAssetLoaded, renderAsset);
	renderAsset.registry.off(`remove:${containerAsset.id}`, onContainerAssetRemoved, renderAsset);
	renderAsset.registry.once(`remove:${containerAsset.id}`, onContainerAssetRemoved, renderAsset);
	if (!containerAsset.resource) {
		renderAsset.registry.load(containerAsset);
	} else {
		onContainerAssetLoaded.call(renderAsset, containerAsset);
	}
}
function onContainerAssetRemoved(containerAsset) {
	const renderAsset = this;
	renderAsset.registry.off(`load:${containerAsset.id}`, onContainerAssetLoaded, renderAsset);
	if (renderAsset.resource) {
		renderAsset.resource.destroy();
	}
}
var RenderHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "render");
		this._registry = app2.assets;
	}
	open(url, data2) {
		return new Render();
	}
	patch(asset, registry) {
		if (!asset.data.containerAsset) {
			return;
		}
		const containerAsset = registry.get(asset.data.containerAsset);
		if (!containerAsset) {
			registry.once(`add:${asset.data.containerAsset}`, onContainerAssetAdded, asset);
			return;
		}
		onContainerAssetAdded.call(asset, containerAsset);
	}
};

var AnimCurve = class {
	constructor(paths, input, output, interpolation) {
		this._paths = paths;
		this._input = input;
		this._output = output;
		this._interpolation = interpolation;
	}
	get paths() {
		return this._paths;
	}
	get input() {
		return this._input;
	}
	get output() {
		return this._output;
	}
	get interpolation() {
		return this._interpolation;
	}
};

var AnimData = class {
	constructor(components2, data2) {
		this._components = components2;
		this._data = data2;
	}
	get components() {
		return this._components;
	}
	get data() {
		return this._data;
	}
};

var gltfToEngineSemanticMap = {
	"POSITION": SEMANTIC_POSITION,
	"NORMAL": SEMANTIC_NORMAL,
	"TANGENT": SEMANTIC_TANGENT,
	"COLOR_0": SEMANTIC_COLOR,
	"JOINTS_0": SEMANTIC_BLENDINDICES,
	"WEIGHTS_0": SEMANTIC_BLENDWEIGHT,
	"TEXCOORD_0": SEMANTIC_TEXCOORD0,
	"TEXCOORD_1": SEMANTIC_TEXCOORD1,
	"TEXCOORD_2": SEMANTIC_TEXCOORD2,
	"TEXCOORD_3": SEMANTIC_TEXCOORD3,
	"TEXCOORD_4": SEMANTIC_TEXCOORD4,
	"TEXCOORD_5": SEMANTIC_TEXCOORD5,
	"TEXCOORD_6": SEMANTIC_TEXCOORD6,
	"TEXCOORD_7": SEMANTIC_TEXCOORD7
};
var getPrimitiveType = (primitive2) => {
	if (!primitive2.hasOwnProperty("mode")) {
		return PRIMITIVE_TRIANGLES;
	}
	switch (primitive2.mode) {
		case 0:
			return PRIMITIVE_POINTS;
		case 1:
			return PRIMITIVE_LINES;
		case 2:
			return PRIMITIVE_LINELOOP;
		case 3:
			return PRIMITIVE_LINESTRIP;
		case 4:
			return PRIMITIVE_TRIANGLES;
		case 5:
			return PRIMITIVE_TRISTRIP;
		case 6:
			return PRIMITIVE_TRIFAN;
		default:
			return PRIMITIVE_TRIANGLES;
	}
};
var getDequantizeFunc = (srcType) => {
	switch (srcType) {
		case TYPE_INT8:
			return (x3) => Math.max(x3 / 127, -1);
		case TYPE_UINT8:
			return (x3) => x3 / 255;
		case TYPE_INT16:
			return (x3) => Math.max(x3 / 32767, -1);
		case TYPE_UINT16:
			return (x3) => x3 / 65535;
		default:
			return (x3) => x3;
	}
};
var dequantizeArray = (dstArray, srcArray, srcType) => {
	const convFunc = getDequantizeFunc(srcType);
	const len = srcArray.length;
	for (let i2 = 0; i2 < len; ++i2) {
		dstArray[i2] = convFunc(srcArray[i2]);
	}
	return dstArray;
};
var GltfAccessor = class _GltfAccessor {
	static getNumComponents(accessorType) {
		switch (accessorType) {
			case "SCALAR":
				return 1;
			case "VEC2":
				return 2;
			case "VEC3":
				return 3;
			case "VEC4":
				return 4;
			case "MAT2":
				return 4;
			case "MAT3":
				return 9;
			case "MAT4":
				return 16;
			default:
				return 3;
		}
	}
	static getComponentType(componentType) {
		switch (componentType) {
			case 5120:
				return TYPE_INT8;
			case 5121:
				return TYPE_UINT8;
			case 5122:
				return TYPE_INT16;
			case 5123:
				return TYPE_UINT16;
			case 5124:
				return TYPE_INT32;
			case 5125:
				return TYPE_UINT32;
			case 5126:
				return TYPE_FLOAT32;
			default:
				return 0;
		}
	}
	static getComponentSizeInBytes(componentType) {
		switch (componentType) {
			case 5120:
				return 1;
			// int8
			case 5121:
				return 1;
			// uint8
			case 5122:
				return 2;
			// int16
			case 5123:
				return 2;
			// uint16
			case 5124:
				return 4;
			// int32
			case 5125:
				return 4;
			// uint32
			case 5126:
				return 4;
			// float32
			default:
				return 0;
		}
	}
	static getComponentDataType(componentType) {
		switch (componentType) {
			case 5120:
				return Int8Array;
			case 5121:
				return Uint8Array;
			case 5122:
				return Int16Array;
			case 5123:
				return Uint16Array;
			case 5124:
				return Int32Array;
			case 5125:
				return Uint32Array;
			case 5126:
				return Float32Array;
			default:
				return null;
		}
	}
	// get accessor data, making a copy and patching in the case of a sparse accessor
	static getData(gltfAccessor, bufferViews, flatten = false) {
		const numComponents = _GltfAccessor.getNumComponents(gltfAccessor.type);
		const dataType = _GltfAccessor.getComponentDataType(gltfAccessor.componentType);
		if (!dataType) {
			return null;
		}
		let result;
		if (gltfAccessor.sparse) {
			const sparse = gltfAccessor.sparse;
			const indicesAccessor = {
				count: sparse.count,
				type: "SCALAR"
			};
			const indices = _GltfAccessor.getData(Object.assign(indicesAccessor, sparse.indices), bufferViews, true);
			const valuesAccessor = {
				count: sparse.count,
				type: gltfAccessor.type,
				componentType: gltfAccessor.componentType
			};
			const values = _GltfAccessor.getData(Object.assign(valuesAccessor, sparse.values), bufferViews, true);
			if (gltfAccessor.hasOwnProperty("bufferView")) {
				const baseAccessor = {
					bufferView: gltfAccessor.bufferView,
					byteOffset: gltfAccessor.byteOffset,
					componentType: gltfAccessor.componentType,
					count: gltfAccessor.count,
					type: gltfAccessor.type
				};
				result = _GltfAccessor.getData(baseAccessor, bufferViews, true).slice();
			} else {
				result = new dataType(gltfAccessor.count * numComponents);
			}
			for (let i2 = 0; i2 < sparse.count; ++i2) {
				const targetIndex = indices[i2];
				for (let j = 0; j < numComponents; ++j) {
					result[targetIndex * numComponents + j] = values[i2 * numComponents + j];
				}
			}
		} else {
			if (gltfAccessor.hasOwnProperty("bufferView")) {
				const bufferView = bufferViews[gltfAccessor.bufferView];
				if (flatten && bufferView.hasOwnProperty("byteStride")) {
					const bytesPerElement = numComponents * dataType.BYTES_PER_ELEMENT;
					const storage = new ArrayBuffer(gltfAccessor.count * bytesPerElement);
					const tmpArray = new Uint8Array(storage);
					let dstOffset = 0;
					for (let i2 = 0; i2 < gltfAccessor.count; ++i2) {
						let srcOffset = (gltfAccessor.byteOffset || 0) + i2 * bufferView.byteStride;
						for (let b = 0; b < bytesPerElement; ++b) {
							tmpArray[dstOffset++] = bufferView[srcOffset++];
						}
					}
					result = new dataType(storage);
				} else {
					result = new dataType(
						bufferView.buffer,
						bufferView.byteOffset + (gltfAccessor.byteOffset || 0),
						gltfAccessor.count * numComponents
					);
				}
			} else {
				result = new dataType(gltfAccessor.count * numComponents);
			}
		}
		return result;
	}
	// extract a single component of an interleaved accessor data array into a new array
	static extractComponent(source, numComponents, component, count) {
		const result = new Float32Array(count);
		for (let i2 = 0; i2 < count; i2++) {
			result[i2] = source[i2 * numComponents + component];
		}
		return result;
	}
	// get accessor data as (unnormalized, unquantized) Float32 data
	static getDataFloat32(gltfAccessor, bufferViews) {
		const data2 = _GltfAccessor.getData(gltfAccessor, bufferViews, true);
		if (data2 instanceof Float32Array || !gltfAccessor.normalized) {
			return data2;
		}
		const float32Data = new Float32Array(data2.length);
		dequantizeArray(float32Data, data2, _GltfAccessor.getComponentType(gltfAccessor.componentType));
		return float32Data;
	}
	// returns a dequantized bounding box for the accessor
	static getBoundingBox(gltfAccessor) {
		let min = gltfAccessor.min;
		let max = gltfAccessor.max;
		if (!min || !max) {
			return null;
		}
		if (gltfAccessor.normalized) {
			const ctype = _GltfAccessor.getComponentType(gltfAccessor.componentType);
			min = dequantizeArray([], min, ctype);
			max = dequantizeArray([], max, ctype);
		}
		return new BoundingBox(
			new Vec3((max[0] + min[0]) * 0.5, (max[1] + min[1]) * 0.5, (max[2] + min[2]) * 0.5),
			new Vec3((max[0] - min[0]) * 0.5, (max[1] - min[1]) * 0.5, (max[2] - min[2]) * 0.5)
		);
	}
};

var createInstancing = (device, gltf, nodeInstancingMap, bufferViews) => {
	const accessors = gltf.accessors;
	nodeInstancingMap.forEach((data2, entity) => {
		const attributes = data2.ext.attributes;
		let translations;
		if (attributes.hasOwnProperty("TRANSLATION")) {
			const accessor = accessors[attributes.TRANSLATION];
			translations = GltfAccessor.getDataFloat32(accessor, bufferViews);
		}
		let rotations;
		if (attributes.hasOwnProperty("ROTATION")) {
			const accessor = accessors[attributes.ROTATION];
			rotations = GltfAccessor.getDataFloat32(accessor, bufferViews);
		}
		let scales;
		if (attributes.hasOwnProperty("SCALE")) {
			const accessor = accessors[attributes.SCALE];
			scales = GltfAccessor.getDataFloat32(accessor, bufferViews);
		}
		const instanceCount = (translations ? translations.length / 3 : 0) || (rotations ? rotations.length / 4 : 0) || (scales ? scales.length / 3 : 0);
		if (instanceCount) {
			const matrices = new Float32Array(instanceCount * 16);
			const pos = new Vec3();
			const rot = new Quat();
			const scl = new Vec3(1, 1, 1);
			const matrix2 = new Mat4();
			let matrixIndex = 0;
			for (let i2 = 0; i2 < instanceCount; i2++) {
				const i3 = i2 * 3;
				if (translations) {
					pos.set(translations[i3], translations[i3 + 1], translations[i3 + 2]);
				}
				if (rotations) {
					const i4 = i2 * 4;
					rot.set(rotations[i4], rotations[i4 + 1], rotations[i4 + 2], rotations[i4 + 3]);
				}
				if (scales) {
					scl.set(scales[i3], scales[i3 + 1], scales[i3 + 2]);
				}
				matrix2.setTRS(pos, rot, scl);
				for (let m = 0; m < 16; m++) {
					matrices[matrixIndex++] = matrix2.data[m];
				}
			}
			data2.matrices = matrices;
		}
	});
};

function DracoWorker(jsUrl, wasmUrl) {
	const myself = typeof self !== "undefined" && self || __require("node:worker_threads").parentPort;
	let draco;
	const POSITION_ATTRIBUTE = 0;
	const NORMAL_ATTRIBUTE = 1;
	const wrap = (typedArray, dataType) => {
		switch (dataType) {
			case draco.DT_INT8:
				return new Int8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
			case draco.DT_INT16:
				return new Int16Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength / 2);
			case draco.DT_INT32:
				return new Int32Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength / 4);
			case draco.DT_UINT8:
				return new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
			case draco.DT_UINT16:
				return new Uint16Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength / 2);
			case draco.DT_UINT32:
				return new Uint32Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength / 4);
			case draco.DT_FLOAT32:
				return new Float32Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength / 4);
		}
		return null;
	};
	const componentSizeInBytes = (dataType) => {
		switch (dataType) {
			case draco.DT_INT8:
				return 1;
			case draco.DT_INT16:
				return 2;
			case draco.DT_INT32:
				return 4;
			case draco.DT_UINT8:
				return 1;
			case draco.DT_UINT16:
				return 2;
			case draco.DT_UINT32:
				return 4;
			case draco.DT_FLOAT32:
				return 4;
		}
		return 1;
	};
	const toEngineDataType = (dataType) => {
		switch (dataType) {
			case draco.DT_INT8:
				return 0;
			case draco.DT_UINT8:
				return 1;
			case draco.DT_INT16:
				return 2;
			case draco.DT_UINT16:
				return 3;
			case draco.DT_INT32:
				return 4;
			case draco.DT_UINT32:
				return 5;
			case draco.DT_FLOAT32:
				return 6;
			default:
				return 6;
		}
	};
	const attributeSizeInBytes = (attribute) => {
		return attribute.num_components() * componentSizeInBytes(attribute.data_type());
	};
	const attributeOrder2 = {
		0: 0,
		// position
		1: 1,
		// normal
		5: 2,
		// tangent
		2: 3,
		// color
		7: 4,
		// joints
		8: 5,
		// weights
		4: 6,
		// generic (used for blend indices and weights)
		3: 7
		// texcoord
	};
	const generateNormals2 = (vertices, indices) => {
		const subtract = (dst, a2, b2) => {
			dst[0] = a2[0] - b2[0];
			dst[1] = a2[1] - b2[1];
			dst[2] = a2[2] - b2[2];
		};
		const cross = (dst, a2, b2) => {
			dst[0] = a2[1] * b2[2] - b2[1] * a2[2];
			dst[1] = a2[2] * b2[0] - b2[2] * a2[0];
			dst[2] = a2[0] * b2[1] - b2[0] * a2[1];
		};
		const normalize = (dst, offset3) => {
			const a2 = dst[offset3 + 0];
			const b2 = dst[offset3 + 1];
			const c3 = dst[offset3 + 2];
			const l = 1 / Math.sqrt(a2 * a2 + b2 * b2 + c3 * c3);
			dst[offset3 + 0] *= l;
			dst[offset3 + 1] *= l;
			dst[offset3 + 2] *= l;
		};
		const copy = (dst, src, srcOffset) => {
			for (let i2 = 0; i2 < 3; ++i2) {
				dst[i2] = src[srcOffset + i2];
			}
		};
		const numTriangles = indices.length / 3;
		const numVertices = vertices.length / 3;
		const result = new Float32Array(vertices.length);
		const a = [0, 0, 0], b = [0, 0, 0], c2 = [0, 0, 0], t1 = [0, 0, 0], t2 = [0, 0, 0], n = [0, 0, 0];
		for (let i2 = 0; i2 < numTriangles; ++i2) {
			const v0 = indices[i2 * 3 + 0] * 3;
			const v15 = indices[i2 * 3 + 1] * 3;
			const v26 = indices[i2 * 3 + 2] * 3;
			copy(a, vertices, v0);
			copy(b, vertices, v15);
			copy(c2, vertices, v26);
			subtract(t1, b, a);
			subtract(t2, c2, a);
			cross(n, t1, t2);
			normalize(n, 0);
			for (let j = 0; j < 3; ++j) {
				result[v0 + j] += n[j];
				result[v15 + j] += n[j];
				result[v26 + j] += n[j];
			}
		}
		for (let i2 = 0; i2 < numVertices; ++i2) {
			normalize(result, i2 * 3);
		}
		return new Uint8Array(result.buffer);
	};
	const decodeMesh = (inputBuffer) => {
		const result = {};
		const buffer = new draco.DecoderBuffer();
		buffer.Init(inputBuffer, inputBuffer.length);
		const decoder = new draco.Decoder();
		if (decoder.GetEncodedGeometryType(buffer) !== draco.TRIANGULAR_MESH) {
			result.error = "Failed to decode draco mesh: not a mesh";
			return result;
		}
		const mesh = new draco.Mesh();
		const status = decoder.DecodeBufferToMesh(buffer, mesh);
		if (!status || !status.ok() || draco.getPointer(mesh) === 0) {
			result.error = "Failed to decode draco asset";
			return result;
		}
		const numIndices = mesh.num_faces() * 3;
		const shortIndices = mesh.num_points() <= 65535;
		const indicesSize = numIndices * (shortIndices ? 2 : 4);
		const indicesPtr = draco._malloc(indicesSize);
		if (shortIndices) {
			decoder.GetTrianglesUInt16Array(mesh, indicesSize, indicesPtr);
			result.indices = new Uint16Array(draco.HEAPU16.buffer, indicesPtr, numIndices).slice().buffer;
		} else {
			decoder.GetTrianglesUInt32Array(mesh, indicesSize, indicesPtr);
			result.indices = new Uint32Array(draco.HEAPU32.buffer, indicesPtr, numIndices).slice().buffer;
		}
		draco._free(indicesPtr);
		const attributes = [];
		for (let i2 = 0; i2 < mesh.num_attributes(); ++i2) {
			attributes.push(decoder.GetAttribute(mesh, i2));
		}
		attributes.sort((a, b) => {
			return (attributeOrder2[a.attribute_type()] ?? attributeOrder2.length) - (attributeOrder2[b.attribute_type()] ?? attributeOrder2.length);
		});
		let totalVertexSize = 0;
		const offsets = attributes.map((a) => {
			const offset3 = totalVertexSize;
			totalVertexSize += Math.ceil(attributeSizeInBytes(a) / 4) * 4;
			return offset3;
		});
		const hasNormals = attributes.some((a) => a.attribute_type() === NORMAL_ATTRIBUTE);
		let normalOffset = offsets[1] ?? 0;
		if (!hasNormals) {
			normalOffset = offsets[0] + Math.ceil(attributeSizeInBytes(attributes[0]) / 4) * 4;
			for (let i2 = 1; i2 < offsets.length; ++i2) {
				offsets[i2] += 12;
			}
			totalVertexSize += 12;
		}
		result.attributes = attributes.map((a, i2) => ({
			id: a.unique_id(),
			dataType: toEngineDataType(a.data_type()),
			numComponents: a.num_components(),
			offset: offsets[i2]
		}));
		if (!hasNormals) {
			result.attributes.splice(1, 0, {
				id: -1,
				// special id to indicate generated normals
				dataType: 6,
				// TYPE_FLOAT32
				numComponents: 3,
				offset: normalOffset
			});
		}
		result.stride = totalVertexSize;
		result.vertices = new ArrayBuffer(mesh.num_points() * totalVertexSize);
		const dst = new Uint8Array(result.vertices);
		for (let i2 = 0; i2 < mesh.num_attributes(); ++i2) {
			const attribute = attributes[i2];
			const sizeInBytes = attributeSizeInBytes(attribute);
			const ptrSize = mesh.num_points() * sizeInBytes;
			const ptr = draco._malloc(ptrSize);
			decoder.GetAttributeDataArrayForAllPoints(mesh, attribute, attribute.data_type(), ptrSize, ptr);
			const src = new Uint8Array(draco.HEAPU8.buffer, ptr, ptrSize);
			for (let j = 0; j < mesh.num_points(); ++j) {
				for (let c2 = 0; c2 < sizeInBytes; ++c2) {
					dst[j * totalVertexSize + offsets[i2] + c2] = src[j * sizeInBytes + c2];
				}
			}
			if (!hasNormals && attribute.attribute_type() === POSITION_ATTRIBUTE) {
				const normals = generateNormals2(
					wrap(src, attribute.data_type()),
					shortIndices ? new Uint16Array(result.indices) : new Uint32Array(result.indices)
				);
				for (let j = 0; j < mesh.num_points(); ++j) {
					for (let c2 = 0; c2 < 12; ++c2) {
						dst[j * totalVertexSize + normalOffset + c2] = normals[j * 12 + c2];
					}
				}
			}
			draco._free(ptr);
		}
		draco.destroy(mesh);
		draco.destroy(decoder);
		draco.destroy(buffer);
		return result;
	};
	const decode = (data2) => {
		const result = decodeMesh(new Uint8Array(data2.buffer));
		myself.postMessage({
			jobId: data2.jobId,
			error: result.error,
			indices: result.indices,
			vertices: result.vertices,
			attributes: result.attributes,
			stride: result.stride
		}, [result.indices, result.vertices].filter((t) => t != null));
	};
	const workQueue = [];
	myself.addEventListener("message", (message) => {
		const data2 = message.data;
		switch (data2.type) {
			case "init": {
				const DracoDecoderModule = myself.DracoDecoderModule || typeof module !== "undefined" && module.exports;
				DracoDecoderModule({
					instantiateWasm: (imports, successCallback) => {
						WebAssembly.instantiate(data2.module, imports).then((result) => successCallback(result)).catch((reason) => console.error(`instantiate failed + ${reason}`));
						return {};
					}
				}).then((instance) => {
					draco = instance;
					workQueue.forEach((data3) => decode(data3));
				});
				break;
			}
			case "decodeMesh":
				if (draco) {
					decode(data2);
				} else {
					workQueue.push(data2);
				}
				break;
		}
	});
}

var downloadMaxRetries = 3;
var JobQueue = class {
	constructor() {
		this.workers = [[], [], []];
		this.jobId = 0;
		this.jobQueue = [];
		this.jobCallbacks = /* @__PURE__ */ new Map();
		this.run = (worker, job) => {
			worker.postMessage({
				type: "decodeMesh",
				jobId: job.jobId,
				buffer: job.buffer
			}, [job.buffer]);
		};
	}
	// initialize the queue with worker instances
	init(workers2) {
		workers2.forEach((worker) => {
			const messageHandler = (message) => {
				const data2 = message.data ?? message;
				const callback = this.jobCallbacks.get(data2.jobId);
				if (callback) {
					callback(data2.error, {
						indices: data2.indices,
						vertices: data2.vertices,
						attributes: data2.attributes,
						stride: data2.stride
					});
				}
				this.jobCallbacks.delete(data2.jobId);
				if (this.jobQueue.length > 0) {
					const job = this.jobQueue.shift();
					this.run(worker, job);
				} else {
					const index2 = this.workers[2].indexOf(worker);
					if (index2 !== -1) {
						this.workers[2].splice(index2, 1);
						this.workers[1].push(worker);
					} else {
						const index1 = this.workers[1].indexOf(worker);
						if (index1 !== -1) {
							this.workers[1].splice(index1, 1);
							this.workers[0].push(worker);
						} else {
						}
					}
				}
			};
			if (platform.environment === "node") {
				worker.on("message", messageHandler);
			} else {
				worker.addEventListener("message", messageHandler);
			}
		});
		this.workers[0] = workers2;
		while (this.jobQueue.length && (this.workers[0].length || this.workers[1].length)) {
			const job = this.jobQueue.shift();
			if (this.workers[0].length > 0) {
				const worker = this.workers[0].shift();
				this.workers[1].push(worker);
				this.run(worker, job);
			} else {
				const worker = this.workers[1].shift();
				this.workers[2].push(worker);
				this.run(worker, job);
			}
		}
	}
	// mark the queue as failed: notify pending jobs and fail any future ones
	fail(error) {
		this.error = error;
		this.jobQueue.length = 0;
		const callbacks = this.jobCallbacks;
		this.jobCallbacks = /* @__PURE__ */ new Map();
		callbacks.forEach((callback) => callback(error));
	}
	enqueueJob(buffer, callback) {
		if (this.error) {
			callback(this.error);
			return;
		}
		const job = {
			jobId: this.jobId++,
			buffer
		};
		this.jobCallbacks.set(job.jobId, callback);
		if (this.workers[0].length > 0) {
			const worker = this.workers[0].shift();
			this.workers[1].push(worker);
			this.run(worker, job);
		} else if (this.workers[1].length > 0) {
			const worker = this.workers[1].shift();
			this.workers[2].push(worker);
			this.run(worker, job);
		} else {
			this.jobQueue.push(job);
		}
	}
};
var downloadScript = (url) => {
	return new Promise((resolve2, reject) => {
		const options2 = {
			cache: true,
			responseType: "text",
			retry: downloadMaxRetries > 0,
			maxRetries: downloadMaxRetries
		};
		http.get(url, options2, (err2, response) => {
			if (err2) {
				reject(err2);
			} else {
				resolve2(response);
			}
		});
	});
};
var compileModule = (url) => {
	const compileManual = () => {
		return fetch(url).then((result) => result.arrayBuffer()).then((buffer) => WebAssembly.compile(buffer));
	};
	const compileStreaming = () => {
		return WebAssembly.compileStreaming(fetch(url)).catch((err2) => {
			return compileManual();
		});
	};
	return WebAssembly.compileStreaming ? compileStreaming() : compileManual();
};
var defaultNumWorkers = 1;
var jobQueue;
var lazyConfig;
var initializeWorkers = (config) => {
	if (jobQueue) {
		return true;
	}
	if (!config) {
		if (lazyConfig) {
			config = lazyConfig;
		} else {
			const moduleConfig = WasmModule.getConfig("DracoDecoderModule");
			if (moduleConfig) {
				config = {
					jsUrl: moduleConfig.glueUrl,
					wasmUrl: moduleConfig.wasmUrl,
					numWorkers: moduleConfig.numWorkers
				};
			} else {
				config = {
					jsUrl: "draco.wasm.js",
					wasmUrl: "draco.wasm.wasm",
					numWorkers: defaultNumWorkers
				};
			}
		}
	}
	if (!config.jsUrl || !config.wasmUrl) {
		return false;
	}
	jobQueue = new JobQueue();
	Promise.all([downloadScript(config.jsUrl), compileModule(config.wasmUrl)]).then(([dracoSource, dracoModule]) => {
		const code = [
			"/* draco */",
			dracoSource,
			"/* worker */",
			`(
${DracoWorker.toString()}
)()

`
		].join("\n");
		const numWorkers = Math.max(1, Math.min(16, config.numWorkers || defaultNumWorkers));
		const isNode = platform.environment === "node";
		const workerUrl = isNode ? null : URL.createObjectURL(new Blob([code], { type: "application/javascript" }));
		const workers2 = [];
		for (let i2 = 0; i2 < numWorkers; ++i2) {
			const worker = isNode ? new Worker(code, { eval: true }) : new Worker(workerUrl);
			worker.postMessage({
				type: "init",
				module: dracoModule
			});
			workers2.push(worker);
		}
		jobQueue.init(workers2);
	}).catch((err2) => {
		jobQueue.fail(err2 instanceof Error ? err2 : new Error(err2));
	});
	return true;
};
var dracoInitialize = (config) => {
	if (config?.lazyInit) {
		lazyConfig = config;
	} else {
		initializeWorkers(config);
	}
};
var dracoDecode = (buffer, callback) => {
	if (!initializeWorkers()) {
		return false;
	}
	jobQueue.enqueueJob(buffer, callback);
	return true;
};

var createVariants = (gltf) => {
	if (!gltf.hasOwnProperty("extensions") || !gltf.extensions.hasOwnProperty("KHR_materials_variants")) {
		return null;
	}
	const data2 = gltf.extensions.KHR_materials_variants.variants;
	const variants = {};
	for (let i2 = 0; i2 < data2.length; i2++) {
		variants[data2[i2].name] = i2;
	}
	return variants;
};
var registerMeshVariants = (primitive2, meshId, meshVariants) => {
	if (primitive2?.extensions?.KHR_materials_variants) {
		const variants = primitive2.extensions.KHR_materials_variants;
		const tempMapping = {};
		variants.mappings.forEach((mapping) => {
			mapping.variants.forEach((variant) => {
				tempMapping[variant] = mapping.material;
			});
		});
		meshVariants[meshId] = tempMapping;
	}
};

var createDracoMesh = (device, primitive2, accessors, bufferViews, meshVariants, meshDefaultMaterials, promises) => {
	const result = new Mesh(device);
	result.aabb = GltfAccessor.getBoundingBox(accessors[primitive2.attributes.POSITION]);
	promises.push(new Promise((resolve2, reject) => {
		const dracoExt = primitive2.extensions.KHR_draco_mesh_compression;
		const initialized = dracoDecode(bufferViews[dracoExt.bufferView].slice().buffer, (err2, decompressedData) => {
			if (err2) {
				console.log(err2);
				reject(err2);
			} else {
				const idToSemantic = {};
				for (const [name, id14] of Object.entries(dracoExt.attributes)) {
					idToSemantic[id14] = gltfToEngineSemanticMap[name];
				}
				idToSemantic[-1] = SEMANTIC_NORMAL;
				const vertexDesc = [];
				for (const attr of decompressedData.attributes) {
					const semantic = idToSemantic[attr.id];
					if (semantic !== void 0) {
						let normalize = false;
						if (attr.id !== -1) {
							for (const [name, id14] of Object.entries(dracoExt.attributes)) {
								if (id14 === attr.id && primitive2.attributes[name] !== void 0) {
									const accessor = accessors[primitive2.attributes[name]];
									normalize = accessor.normalized ?? (semantic === SEMANTIC_COLOR && (attr.dataType === TYPE_UINT8 || attr.dataType === TYPE_UINT16));
									break;
								}
							}
						}
						vertexDesc.push({
							semantic,
							components: attr.numComponents,
							type: attr.dataType,
							normalize,
							// use offset and stride from worker to handle cases where Draco mesh
							// has additional attributes not listed in glTF
							offset: attr.offset,
							stride: decompressedData.stride
						});
					}
				}
				const vertexFormat = new VertexFormat(device, vertexDesc);
				const numVertices = decompressedData.vertices.byteLength / decompressedData.stride;
				const indexFormat = numVertices <= 65535 ? INDEXFORMAT_UINT16 : INDEXFORMAT_UINT32;
				const numIndices = decompressedData.indices.byteLength / (numVertices <= 65535 ? 2 : 4);
				const vertexBuffer = new VertexBuffer(device, vertexFormat, numVertices, {
					data: decompressedData.vertices
				});
				const indexBuffer = new IndexBuffer(device, indexFormat, numIndices, BUFFER_STATIC, decompressedData.indices);
				result.vertexBuffer = vertexBuffer;
				result.indexBuffer[0] = indexBuffer;
				result.primitive[0].type = getPrimitiveType(primitive2);
				result.primitive[0].base = 0;
				result.primitive[0].count = indexBuffer ? numIndices : numVertices;
				result.primitive[0].indexed = !!indexBuffer;
				resolve2();
			}
		});
		if (!initialized) {
			const message = "glTF file contains Draco compressed meshes, but the Draco decoder is not configured. Call dracoInitialize() or WasmModule.setConfig('DracoDecoderModule', ...) before loading the asset.";
			reject(new Error(message));
		}
	}));
	registerMeshVariants(primitive2, result.id, meshVariants);
	meshDefaultMaterials[result.id] = primitive2.material;
	return result;
};

var extensionName = "KHR_gaussian_splatting";
var shDegreeCoefCounts = [3, 5, 7];
var shBandCoefCounts = { 1: 3, 2: 8, 3: 15 };
var hasGSplatExtension = (primitive2) => {
	return !!primitive2?.extensions?.[extensionName];
};
var createGSplatData = (primitive2, accessors, bufferViews) => {
	const extensionData = primitive2.extensions[extensionName];
	const attributes = primitive2.attributes;
	const numSplats = accessors[attributes.POSITION]?.count ?? 0;
	const readAttribute = (name) => {
		const accessor = accessors[attributes[name]];
		if (!accessor || accessor.count !== numSplats) {
			return null;
		}
		return GltfAccessor.getDataFloat32(accessor, bufferViews);
	};
	const positions = readAttribute("POSITION");
	const rotations = readAttribute(`${extensionName}:ROTATION`);
	const scales = readAttribute(`${extensionName}:SCALE`);
	const opacities = readAttribute(`${extensionName}:OPACITY`);
	const sh0 = readAttribute(`${extensionName}:SH_DEGREE_0_COEF_0`);
	if (!numSplats || !positions || !rotations || !scales || !opacities || !sh0) {
		return null;
	}
	const properties = [];
	const addProp = (name, storage) => {
		properties.push({ type: "float", name, storage, byteSize: 4 });
	};
	addProp("x", GltfAccessor.extractComponent(positions, 3, 0, numSplats));
	addProp("y", GltfAccessor.extractComponent(positions, 3, 1, numSplats));
	addProp("z", GltfAccessor.extractComponent(positions, 3, 2, numSplats));
	addProp("rot_0", GltfAccessor.extractComponent(rotations, 4, 3, numSplats));
	addProp("rot_1", GltfAccessor.extractComponent(rotations, 4, 0, numSplats));
	addProp("rot_2", GltfAccessor.extractComponent(rotations, 4, 1, numSplats));
	addProp("rot_3", GltfAccessor.extractComponent(rotations, 4, 2, numSplats));
	addProp("scale_0", GltfAccessor.extractComponent(scales, 3, 0, numSplats));
	addProp("scale_1", GltfAccessor.extractComponent(scales, 3, 1, numSplats));
	addProp("scale_2", GltfAccessor.extractComponent(scales, 3, 2, numSplats));
	addProp("opacity", GltfAccessor.extractComponent(opacities, 1, 0, numSplats));
	addProp("f_dc_0", GltfAccessor.extractComponent(sh0, 3, 0, numSplats));
	addProp("f_dc_1", GltfAccessor.extractComponent(sh0, 3, 1, numSplats));
	addProp("f_dc_2", GltfAccessor.extractComponent(sh0, 3, 2, numSplats));
	let bands = 0;
	for (let d = 1; d <= 3; d++) {
		let complete = true;
		for (let c2 = 0; c2 < shDegreeCoefCounts[d - 1]; c2++) {
			if (attributes[`${extensionName}:SH_DEGREE_${d}_COEF_${c2}`] === void 0) {
				complete = false;
				break;
			}
		}
		if (!complete) {
			break;
		}
		bands = d;
	}
	if (bands > 0) {
		const numCoefs = shBandCoefCounts[bands];
		const rest = new Array(numCoefs * 3);
		let k = 0;
		for (let d = 1; d <= bands; d++) {
			for (let c2 = 0; c2 < shDegreeCoefCounts[d - 1]; c2++) {
				const name = `${extensionName}:SH_DEGREE_${d}_COEF_${c2}`;
				const source = readAttribute(name);
				if (!source) {
					return null;
				}
				rest[k] = GltfAccessor.extractComponent(source, 3, 0, numSplats);
				rest[numCoefs + k] = GltfAccessor.extractComponent(source, 3, 1, numSplats);
				rest[numCoefs * 2 + k] = GltfAccessor.extractComponent(source, 3, 2, numSplats);
				k++;
			}
		}
		for (let i2 = 0; i2 < numCoefs * 3; i2++) {
			addProp(`f_rest_${i2}`, rest[i2]);
		}
	}
	const data2 = new GSplatData([{
		name: "vertex",
		count: numSplats,
		properties
	}]);
	data2.activated = true;
	return data2;
};
var createGSplats = (device, gltf, bufferViews) => {
	if (!gltf.hasOwnProperty("meshes")) {
		return [];
	}
	return gltf.meshes.map((gltfMesh) => {
		let resources = null;
		gltfMesh.primitives.forEach((primitive2) => {
			if (hasGSplatExtension(primitive2)) {
				const gsplatData = createGSplatData(primitive2, gltf.accessors, bufferViews);
				if (gsplatData) {
					gsplatData.reorderData();
					if (!resources) resources = [];
					resources.push(new GSplatResource(device, gsplatData));
				}
			}
		});
		return resources;
	});
};

var createLight = (gltfLight, node) => {
	const lightProps = {
		enabled: false,
		type: gltfLight.type === "point" ? "omni" : gltfLight.type,
		color: gltfLight.hasOwnProperty("color") ? new Color(gltfLight.color) : Color.WHITE,
		// when range is not defined, infinity should be used - but that causes infinity in bounds calculations
		range: gltfLight.hasOwnProperty("range") ? gltfLight.range : 9999,
		falloffMode: LIGHTFALLOFF_INVERSESQUARED,
		// TODO: (engine issue #3252) Set intensity to match glTF specification, which uses physically based values:
		// - Omni and spot lights use luminous intensity in candela (lm/sr)
		// - Directional lights use illuminance in lux (lm/m2).
		// Current implementation: clamps specified intensity to 0..2 range
		intensity: gltfLight.hasOwnProperty("intensity") ? math.clamp(gltfLight.intensity, 0, 2) : 1
	};
	if (gltfLight.hasOwnProperty("spot")) {
		lightProps.innerConeAngle = gltfLight.spot.hasOwnProperty("innerConeAngle") ? gltfLight.spot.innerConeAngle * math.RAD_TO_DEG : 0;
		lightProps.outerConeAngle = gltfLight.spot.hasOwnProperty("outerConeAngle") ? gltfLight.spot.outerConeAngle * math.RAD_TO_DEG : 45;
	}
	if (gltfLight.hasOwnProperty("intensity")) {
		const outerAngleRad = gltfLight.spot?.outerConeAngle ?? Math.PI / 4;
		const innerAngleRad = gltfLight.spot?.innerConeAngle ?? 0;
		lightProps.luminance = gltfLight.intensity * Light.getLightUnitConversion(lightTypes[lightProps.type], outerAngleRad, innerAngleRad);
	}
	const lightEntity = new Entity(node.name);
	lightEntity.rotateLocal(90, 0, 0);
	lightEntity.addComponent("light", lightProps);
	return lightEntity;
};
var createLights = (gltf, nodes, options2) => {
	let lights2 = null;
	if (gltf.hasOwnProperty("nodes") && gltf.hasOwnProperty("extensions") && gltf.extensions.hasOwnProperty("KHR_lights_punctual") && gltf.extensions.KHR_lights_punctual.hasOwnProperty("lights")) {
		const gltfLights = gltf.extensions.KHR_lights_punctual.lights;
		if (gltfLights.length) {
			const preprocess = options2?.light?.preprocess;
			const process = options2?.light?.process ?? createLight;
			const postprocess = options2?.light?.postprocess;
			gltf.nodes.forEach((gltfNode, nodeIndex) => {
				if (gltfNode.hasOwnProperty("extensions") && gltfNode.extensions.hasOwnProperty("KHR_lights_punctual") && gltfNode.extensions.KHR_lights_punctual.hasOwnProperty("light")) {
					const lightIndex = gltfNode.extensions.KHR_lights_punctual.light;
					const gltfLight = gltfLights[lightIndex];
					if (gltfLight) {
						if (preprocess) {
							preprocess(gltfLight);
						}
						const light = process(gltfLight, nodes[nodeIndex]);
						if (postprocess) {
							postprocess(gltfLight, light);
						}
						if (light) {
							if (!lights2) lights2 = /* @__PURE__ */ new Map();
							lights2.set(gltfNode, light);
						}
					}
				}
			});
		}
	}
	return lights2;
};

var getTextureSource = (gltfTexture) => gltfTexture.extensions?.KHR_texture_basisu?.source ?? gltfTexture.extensions?.EXT_texture_webp?.source ?? gltfTexture.source;

var extractTextureTransform = (source, material, maps) => {
	let map;
	const texCoord = source.texCoord;
	if (texCoord) {
		for (map = 0; map < maps.length; ++map) {
			material[`${maps[map]}MapUv`] = texCoord;
		}
	}
	const zeros = [0, 0];
	const ones = [1, 1];
	const textureTransform = source.extensions?.KHR_texture_transform;
	if (textureTransform) {
		const offset3 = textureTransform.offset || zeros;
		const scale2 = textureTransform.scale || ones;
		const rotation7 = textureTransform.rotation ? -textureTransform.rotation * math.RAD_TO_DEG : 0;
		const tilingVec = new Vec2(scale2[0], scale2[1]);
		const offsetVec = new Vec2(offset3[0], 1 - scale2[1] - offset3[1]);
		for (map = 0; map < maps.length; ++map) {
			material[`${maps[map]}MapTiling`] = tilingVec;
			material[`${maps[map]}MapOffset`] = offsetVec;
			material[`${maps[map]}MapRotation`] = rotation7;
		}
	}
};

var KHR_materials_anisotropy = {
	apply(data2, material, textures) {
		material.enableGGXSpecular = true;
		if (data2.hasOwnProperty("anisotropyStrength")) {
			material.anisotropyIntensity = data2.anisotropyStrength;
		} else {
			material.anisotropyIntensity = 0;
		}
		if (data2.hasOwnProperty("anisotropyTexture")) {
			const anisotropyTexture = data2.anisotropyTexture;
			material.anisotropyMap = textures[anisotropyTexture.index];
			extractTextureTransform(anisotropyTexture, material, ["anisotropy"]);
		}
		if (data2.hasOwnProperty("anisotropyRotation")) {
			material.anisotropyRotation = data2.anisotropyRotation * math.RAD_TO_DEG;
		} else {
			material.anisotropyRotation = 0;
		}
	}
};

var KHR_materials_clearcoat = {
	apply(data2, material, textures) {
		if (data2.hasOwnProperty("clearcoatFactor")) {
			material.clearCoat = data2.clearcoatFactor * 0.25;
		} else {
			material.clearCoat = 0;
		}
		if (data2.hasOwnProperty("clearcoatTexture")) {
			const clearcoatTexture = data2.clearcoatTexture;
			material.clearCoatMap = textures[clearcoatTexture.index];
			material.clearCoatMapChannel = "r";
			extractTextureTransform(clearcoatTexture, material, ["clearCoat"]);
		}
		if (data2.hasOwnProperty("clearcoatRoughnessFactor")) {
			material.clearCoatGloss = data2.clearcoatRoughnessFactor;
		} else {
			material.clearCoatGloss = 0;
		}
		if (data2.hasOwnProperty("clearcoatRoughnessTexture")) {
			const clearcoatRoughnessTexture = data2.clearcoatRoughnessTexture;
			material.clearCoatGlossMap = textures[clearcoatRoughnessTexture.index];
			material.clearCoatGlossMapChannel = "g";
			extractTextureTransform(clearcoatRoughnessTexture, material, ["clearCoatGloss"]);
		}
		if (data2.hasOwnProperty("clearcoatNormalTexture")) {
			const clearcoatNormalTexture = data2.clearcoatNormalTexture;
			material.clearCoatNormalMap = textures[clearcoatNormalTexture.index];
			extractTextureTransform(clearcoatNormalTexture, material, ["clearCoatNormal"]);
			if (clearcoatNormalTexture.hasOwnProperty("scale")) {
				material.clearCoatBumpiness = clearcoatNormalTexture.scale;
			} else {
				material.clearCoatBumpiness = 1;
			}
		}
		material.clearCoatGlossInvert = true;
	}
};

var KHR_materials_dispersion = {
	apply(data2, material, textures) {
		if (data2.hasOwnProperty("dispersion")) {
			material.dispersion = data2.dispersion;
		}
	}
};

var KHR_materials_emissive_strength = {
	apply(data2, material, textures) {
		if (data2.hasOwnProperty("emissiveStrength")) {
			material.emissiveIntensity = data2.emissiveStrength;
		}
	}
};

var KHR_materials_ior = {
	apply(data2, material, textures) {
		if (data2.hasOwnProperty("ior")) {
			material.refractionIndex = 1 / data2.ior;
		}
	}
};

var KHR_materials_iridescence = {
	apply(data2, material, textures) {
		material.useIridescence = true;
		if (data2.hasOwnProperty("iridescenceFactor")) {
			material.iridescence = data2.iridescenceFactor;
		}
		if (data2.hasOwnProperty("iridescenceTexture")) {
			material.iridescenceMapChannel = "r";
			material.iridescenceMap = textures[data2.iridescenceTexture.index];
			extractTextureTransform(data2.iridescenceTexture, material, ["iridescence"]);
		}
		if (data2.hasOwnProperty("iridescenceIor")) {
			material.iridescenceRefractionIndex = data2.iridescenceIor;
		}
		if (data2.hasOwnProperty("iridescenceThicknessMinimum")) {
			material.iridescenceThicknessMin = data2.iridescenceThicknessMinimum;
		}
		if (data2.hasOwnProperty("iridescenceThicknessMaximum")) {
			material.iridescenceThicknessMax = data2.iridescenceThicknessMaximum;
		}
		if (data2.hasOwnProperty("iridescenceThicknessTexture")) {
			material.iridescenceThicknessMapChannel = "g";
			material.iridescenceThicknessMap = textures[data2.iridescenceThicknessTexture.index];
			extractTextureTransform(data2.iridescenceThicknessTexture, material, ["iridescenceThickness"]);
		}
	}
};

var KHR_materials_pbrSpecularGlossiness = {
	apply(data2, material, textures) {
		let texture;
		if (data2.hasOwnProperty("diffuseFactor")) {
			const [r, g, b, a] = data2.diffuseFactor;
			material.diffuse.set(r, g, b).gamma();
			material.opacity = a;
		} else {
			material.diffuse.set(1, 1, 1);
			material.opacity = 1;
		}
		if (data2.hasOwnProperty("diffuseTexture")) {
			const diffuseTexture = data2.diffuseTexture;
			texture = textures[diffuseTexture.index];
			material.diffuseMap = texture;
			material.diffuseMapChannel = "rgb";
			material.opacityMap = texture;
			material.opacityMapChannel = "a";
			extractTextureTransform(diffuseTexture, material, ["diffuse", "opacity"]);
		}
		material.useMetalness = false;
		if (data2.hasOwnProperty("specularFactor")) {
			const [r, g, b] = data2.specularFactor;
			material.specular.set(r, g, b).gamma();
		} else {
			material.specular.set(1, 1, 1);
		}
		if (data2.hasOwnProperty("glossinessFactor")) {
			material.gloss = data2.glossinessFactor;
		} else {
			material.gloss = 1;
		}
		if (data2.hasOwnProperty("specularGlossinessTexture")) {
			const specularGlossinessTexture = data2.specularGlossinessTexture;
			material.specularMap = material.glossMap = textures[specularGlossinessTexture.index];
			material.specularMapChannel = "rgb";
			material.glossMapChannel = "a";
			extractTextureTransform(specularGlossinessTexture, material, ["gloss", "metalness"]);
		}
	},
	getColorTextures(data2) {
		const textures = [];
		if (data2.hasOwnProperty("diffuseTexture")) {
			textures.push(data2.diffuseTexture);
		}
		if (data2.hasOwnProperty("specularGlossinessTexture")) {
			textures.push(data2.specularGlossinessTexture);
		}
		return textures;
	}
};

var KHR_materials_sheen = {
	apply(data2, material, textures) {
		material.useSheen = true;
		if (data2.hasOwnProperty("sheenColorFactor")) {
			const [r, g, b] = data2.sheenColorFactor;
			material.sheen.set(r, g, b).gamma();
		} else {
			material.sheen.set(1, 1, 1);
		}
		if (data2.hasOwnProperty("sheenColorTexture")) {
			material.sheenMap = textures[data2.sheenColorTexture.index];
			extractTextureTransform(data2.sheenColorTexture, material, ["sheen"]);
		}
		material.sheenGloss = data2.hasOwnProperty("sheenRoughnessFactor") ? data2.sheenRoughnessFactor : 0;
		if (data2.hasOwnProperty("sheenRoughnessTexture")) {
			material.sheenGlossMap = textures[data2.sheenRoughnessTexture.index];
			material.sheenGlossMapChannel = "a";
			extractTextureTransform(data2.sheenRoughnessTexture, material, ["sheenGloss"]);
		}
		material.sheenGlossInvert = true;
	},
	getColorTextures(data2) {
		return data2.hasOwnProperty("sheenColorTexture") ? [data2.sheenColorTexture] : [];
	}
};

var KHR_materials_specular = {
	apply(data2, material, textures) {
		material.useMetalnessSpecularColor = true;
		if (data2.hasOwnProperty("specularColorTexture")) {
			material.specularMap = textures[data2.specularColorTexture.index];
			material.specularMapChannel = "rgb";
			extractTextureTransform(data2.specularColorTexture, material, ["specular"]);
		}
		if (data2.hasOwnProperty("specularColorFactor")) {
			const [r, g, b] = data2.specularColorFactor;
			material.specular.set(r, g, b).gamma();
		} else {
			material.specular.set(1, 1, 1);
		}
		if (data2.hasOwnProperty("specularFactor")) {
			material.specularityFactor = data2.specularFactor;
		} else {
			material.specularityFactor = 1;
		}
		if (data2.hasOwnProperty("specularTexture")) {
			material.specularityFactorMapChannel = "a";
			material.specularityFactorMap = textures[data2.specularTexture.index];
			extractTextureTransform(data2.specularTexture, material, ["specularityFactor"]);
		}
	},
	getColorTextures(data2) {
		return data2.hasOwnProperty("specularColorTexture") ? [data2.specularColorTexture] : [];
	}
};

var KHR_materials_transmission = {
	apply(data2, material, textures) {
		material.blendType = BLEND_NORMAL;
		material.useDynamicRefraction = true;
		if (data2.hasOwnProperty("transmissionFactor")) {
			material.refraction = data2.transmissionFactor;
		}
		if (data2.hasOwnProperty("transmissionTexture")) {
			material.refractionMapChannel = "r";
			material.refractionMap = textures[data2.transmissionTexture.index];
			extractTextureTransform(data2.transmissionTexture, material, ["refraction"]);
		}
	}
};

var KHR_materials_unlit = {
	apply(data2, material, textures) {
		material.useLighting = false;
		material.emissive.copy(material.diffuse);
		material.emissiveMap = material.diffuseMap;
		material.emissiveMapUv = material.diffuseMapUv;
		material.emissiveMapTiling.copy(material.diffuseMapTiling);
		material.emissiveMapOffset.copy(material.diffuseMapOffset);
		material.emissiveMapRotation = material.diffuseMapRotation;
		material.emissiveMapChannel = material.diffuseMapChannel;
		material.emissiveVertexColor = material.diffuseVertexColor;
		material.emissiveVertexColorChannel = material.diffuseVertexColorChannel;
		material.useLighting = false;
		material.useSkybox = false;
		material.diffuse.set(1, 1, 1);
		material.diffuseMap = null;
		material.diffuseVertexColor = false;
	}
};

var KHR_materials_volume = {
	apply(data2, material, textures) {
		material.blendType = BLEND_NORMAL;
		material.useDynamicRefraction = true;
		if (data2.hasOwnProperty("thicknessFactor")) {
			material.thickness = data2.thicknessFactor;
		}
		if (data2.hasOwnProperty("thicknessTexture")) {
			material.thicknessMap = textures[data2.thicknessTexture.index];
			material.thicknessMapChannel = "g";
			extractTextureTransform(data2.thicknessTexture, material, ["thickness"]);
		}
		if (data2.hasOwnProperty("attenuationDistance")) {
			material.attenuationDistance = data2.attenuationDistance;
		}
		if (data2.hasOwnProperty("attenuationColor")) {
			const [r, g, b] = data2.attenuationColor;
			material.attenuation.set(r, g, b).gamma();
		}
	}
};

var glbMaterialExtensions = {
	KHR_materials_anisotropy,
	KHR_materials_clearcoat,
	KHR_materials_dispersion,
	KHR_materials_emissive_strength,
	KHR_materials_ior,
	KHR_materials_iridescence,
	KHR_materials_pbrSpecularGlossiness,
	KHR_materials_sheen,
	KHR_materials_specular,
	KHR_materials_transmission,
	KHR_materials_unlit,
	KHR_materials_volume
};

var GlbResources = class {
	gltf;
	nodes;
	scenes;
	animations;
	textures;
	materials;
	variants;
	meshVariants;
	meshDefaultMaterials;
	renders;
	gsplats;
	skins;
	lights;
	cameras;
	nodeInstancingMap;
	destroy() {
		if (this.renders) {
			this.renders.forEach((render) => {
				render.meshes = null;
			});
		}
	}
};
var isDataURI = (uri) => {
	return /^data:[^\n\r,\u2028\u2029]*,.*$/i.test(uri);
};
var getDataURIMimeType = (uri) => {
	return uri.substring(uri.indexOf(":") + 1, uri.indexOf(";"));
};
var attributeOrder = {
	[SEMANTIC_POSITION]: 0,
	[SEMANTIC_NORMAL]: 1,
	[SEMANTIC_TANGENT]: 2,
	[SEMANTIC_COLOR]: 3,
	[SEMANTIC_BLENDINDICES]: 4,
	[SEMANTIC_BLENDWEIGHT]: 5,
	[SEMANTIC_TEXCOORD0]: 6,
	[SEMANTIC_TEXCOORD1]: 7,
	[SEMANTIC_TEXCOORD2]: 8,
	[SEMANTIC_TEXCOORD3]: 9,
	[SEMANTIC_TEXCOORD4]: 10,
	[SEMANTIC_TEXCOORD5]: 11,
	[SEMANTIC_TEXCOORD6]: 12,
	[SEMANTIC_TEXCOORD7]: 13
};
var generateIndices = (numVertices) => {
	const dummyIndices = new Uint16Array(numVertices);
	for (let i2 = 0; i2 < numVertices; i2++) {
		dummyIndices[i2] = i2;
	}
	return dummyIndices;
};
var generateNormals = (sourceDesc, indices) => {
	const p = sourceDesc[SEMANTIC_POSITION];
	if (!p || p.components !== 3) {
		return;
	}
	let positions;
	if (p.size !== p.stride) {
		const srcStride = p.stride / typedArrayTypesByteSize[p.type];
		const src = new typedArrayTypes[p.type](p.buffer, p.offset, p.count * srcStride);
		positions = new typedArrayTypes[p.type](p.count * 3);
		for (let i2 = 0; i2 < p.count; ++i2) {
			positions[i2 * 3 + 0] = src[i2 * srcStride + 0];
			positions[i2 * 3 + 1] = src[i2 * srcStride + 1];
			positions[i2 * 3 + 2] = src[i2 * srcStride + 2];
		}
	} else {
		positions = new typedArrayTypes[p.type](p.buffer, p.offset, p.count * 3);
	}
	const numVertices = p.count;
	if (!indices) {
		indices = generateIndices(numVertices);
	}
	const normalsTemp = calculateNormals(positions, indices);
	const normals = new Float32Array(normalsTemp.length);
	normals.set(normalsTemp);
	sourceDesc[SEMANTIC_NORMAL] = {
		buffer: normals.buffer,
		size: 12,
		offset: 0,
		stride: 12,
		count: numVertices,
		components: 3,
		type: TYPE_FLOAT32
	};
};
var cloneTexture = (texture) => {
	const shallowCopyLevels = (texture2) => {
		const result2 = [];
		for (let mip = 0; mip < texture2._levels.length; ++mip) {
			let level = [];
			if (texture2.cubemap) {
				for (let face = 0; face < 6; ++face) {
					level.push(texture2._levels[mip][face]);
				}
			} else {
				level = texture2._levels[mip];
			}
			result2.push(level);
		}
		return result2;
	};
	const result = new Texture(texture.device, texture);
	result._levels = shallowCopyLevels(texture);
	return result;
};
var cloneTextureAsset = (src) => {
	const result = new Asset(
		`${src.name}_clone`,
		src.type,
		src.file,
		src.data,
		src.options
	);
	result.loaded = true;
	result.resource = cloneTexture(src.resource);
	src.registry.add(result);
	return result;
};
var createVertexBufferInternal = (device, sourceDesc) => {
	const positionDesc = sourceDesc[SEMANTIC_POSITION];
	if (!positionDesc) {
		return null;
	}
	const numVertices = positionDesc.count;
	const vertexDesc = [];
	for (const semantic in sourceDesc) {
		if (sourceDesc.hasOwnProperty(semantic)) {
			const element = {
				semantic,
				components: sourceDesc[semantic].components,
				type: sourceDesc[semantic].type,
				normalize: !!sourceDesc[semantic].normalize
			};
			if (!VertexFormat.isElementValid(device, element)) {
				element.components++;
			}
			vertexDesc.push(element);
		}
	}
	vertexDesc.sort((lhs, rhs) => {
		return attributeOrder[lhs.semantic] - attributeOrder[rhs.semantic];
	});
	let i2, j, k;
	let source, target2, sourceOffset;
	const vertexFormat = new VertexFormat(device, vertexDesc);
	let isCorrectlyInterleaved = true;
	for (i2 = 0; i2 < vertexFormat.elements.length; ++i2) {
		target2 = vertexFormat.elements[i2];
		source = sourceDesc[target2.name];
		sourceOffset = source.offset - positionDesc.offset;
		if (source.buffer !== positionDesc.buffer || source.stride !== target2.stride || source.size !== target2.size || sourceOffset !== target2.offset) {
			isCorrectlyInterleaved = false;
			break;
		}
	}
	const vertexBuffer = new VertexBuffer(device, vertexFormat, numVertices);
	const vertexData = vertexBuffer.lock();
	const targetArray = new Uint32Array(vertexData);
	let sourceArray;
	if (isCorrectlyInterleaved) {
		sourceArray = new Uint32Array(
			positionDesc.buffer,
			positionDesc.offset,
			numVertices * vertexBuffer.format.size / 4
		);
		targetArray.set(sourceArray);
	} else {
		let targetStride, sourceStride;
		for (i2 = 0; i2 < vertexBuffer.format.elements.length; ++i2) {
			target2 = vertexBuffer.format.elements[i2];
			targetStride = target2.stride / 4;
			source = sourceDesc[target2.name];
			sourceStride = source.stride / 4;
			sourceArray = new Uint32Array(source.buffer, source.offset, (source.count - 1) * sourceStride + (source.size + 3) / 4);
			let src = 0;
			let dst = target2.offset / 4;
			const kend = Math.floor((source.size + 3) / 4);
			for (j = 0; j < numVertices; ++j) {
				for (k = 0; k < kend; ++k) {
					targetArray[dst + k] = sourceArray[src + k];
				}
				src += sourceStride;
				dst += targetStride;
			}
		}
	}
	vertexBuffer.unlock();
	return vertexBuffer;
};
var createVertexBuffer = (device, attributes, indices, accessors, bufferViews, vertexBufferDict) => {
	const useAttributes = {};
	const attribIds = [];
	for (const attrib in attributes) {
		if (attributes.hasOwnProperty(attrib) && gltfToEngineSemanticMap.hasOwnProperty(attrib)) {
			useAttributes[attrib] = attributes[attrib];
			attribIds.push(`${attrib}:${attributes[attrib]}`);
		}
	}
	attribIds.sort();
	const vbKey = attribIds.join();
	let vb = vertexBufferDict[vbKey];
	if (!vb) {
		const sourceDesc = {};
		for (const attrib in useAttributes) {
			const accessor = accessors[attributes[attrib]];
			const accessorData = GltfAccessor.getData(accessor, bufferViews);
			const bufferView = bufferViews[accessor.bufferView];
			const semantic = gltfToEngineSemanticMap[attrib];
			const size = GltfAccessor.getNumComponents(accessor.type) * GltfAccessor.getComponentSizeInBytes(accessor.componentType);
			const stride = bufferView && bufferView.hasOwnProperty("byteStride") ? bufferView.byteStride : size;
			sourceDesc[semantic] = {
				buffer: accessorData.buffer,
				size,
				offset: accessorData.byteOffset,
				stride,
				count: accessor.count,
				components: GltfAccessor.getNumComponents(accessor.type),
				type: GltfAccessor.getComponentType(accessor.componentType),
				normalize: accessor.normalized
			};
		}
		if (!sourceDesc.hasOwnProperty(SEMANTIC_NORMAL)) {
			generateNormals(sourceDesc, indices);
		}
		vb = createVertexBufferInternal(device, sourceDesc);
		vertexBufferDict[vbKey] = vb;
	}
	return vb;
};
var createSkin = (device, gltfSkin, accessors, bufferViews, nodes, glbSkins) => {
	let i2, j, bindMatrix;
	const joints = gltfSkin.joints;
	const numJoints = joints.length;
	const ibp = [];
	if (gltfSkin.hasOwnProperty("inverseBindMatrices")) {
		const inverseBindMatrices = gltfSkin.inverseBindMatrices;
		const ibmData = GltfAccessor.getData(accessors[inverseBindMatrices], bufferViews, true);
		const ibmValues = [];
		for (i2 = 0; i2 < numJoints; i2++) {
			for (j = 0; j < 16; j++) {
				ibmValues[j] = ibmData[i2 * 16 + j];
			}
			bindMatrix = new Mat4();
			bindMatrix.set(ibmValues);
			ibp.push(bindMatrix);
		}
	} else {
		for (i2 = 0; i2 < numJoints; i2++) {
			bindMatrix = new Mat4();
			ibp.push(bindMatrix);
		}
	}
	const boneNames = [];
	for (i2 = 0; i2 < numJoints; i2++) {
		boneNames[i2] = nodes[joints[i2]].name;
	}
	const key = boneNames.join("#");
	let skin = glbSkins.get(key);
	if (!skin) {
		skin = new Skin(device, ibp, boneNames);
		glbSkins.set(key, skin);
	}
	return skin;
};
var createMesh = (device, gltfMesh, accessors, bufferViews, vertexBufferDict, meshVariants, meshDefaultMaterials, assetOptions, promises) => {
	const meshes = [];
	gltfMesh.primitives.forEach((primitive2) => {
		if (hasGSplatExtension(primitive2)) {
			return;
		}
		if (primitive2.extensions?.KHR_draco_mesh_compression) {
			meshes.push(createDracoMesh(device, primitive2, accessors, bufferViews, meshVariants, meshDefaultMaterials, promises));
		} else {
			let indices = primitive2.hasOwnProperty("indices") ? GltfAccessor.getData(accessors[primitive2.indices], bufferViews, true) : null;
			const vertexBuffer = createVertexBuffer(device, primitive2.attributes, indices, accessors, bufferViews, vertexBufferDict);
			const primitiveType = getPrimitiveType(primitive2);
			const mesh = new Mesh(device);
			mesh.vertexBuffer = vertexBuffer;
			mesh.primitive[0].type = primitiveType;
			mesh.primitive[0].base = 0;
			mesh.primitive[0].indexed = indices !== null;
			if (indices !== null) {
				let indexFormat;
				if (indices instanceof Uint8Array) {
					indexFormat = INDEXFORMAT_UINT8;
				} else if (indices instanceof Uint16Array) {
					indexFormat = INDEXFORMAT_UINT16;
				} else {
					indexFormat = INDEXFORMAT_UINT32;
				}
				if (indexFormat === INDEXFORMAT_UINT8 && device.isWebGPU) {
					indexFormat = INDEXFORMAT_UINT16;
					indices = new Uint16Array(indices);
				}
				const indexBuffer = new IndexBuffer(device, indexFormat, indices.length, BUFFER_STATIC, indices);
				mesh.indexBuffer[0] = indexBuffer;
				mesh.primitive[0].count = indices.length;
			} else {
				mesh.primitive[0].count = vertexBuffer.numVertices;
			}
			registerMeshVariants(primitive2, mesh.id, meshVariants);
			meshDefaultMaterials[mesh.id] = primitive2.material;
			let accessor = accessors[primitive2.attributes.POSITION];
			mesh.aabb = GltfAccessor.getBoundingBox(accessor);
			if (primitive2.hasOwnProperty("targets")) {
				const targets = [];
				primitive2.targets.forEach((target2, index) => {
					const options2 = {};
					if (target2.hasOwnProperty("POSITION")) {
						accessor = accessors[target2.POSITION];
						options2.deltaPositions = GltfAccessor.getDataFloat32(accessor, bufferViews);
						options2.aabb = GltfAccessor.getBoundingBox(accessor);
					}
					if (target2.hasOwnProperty("NORMAL")) {
						accessor = accessors[target2.NORMAL];
						options2.deltaNormals = GltfAccessor.getDataFloat32(accessor, bufferViews);
					}
					if (gltfMesh.hasOwnProperty("extras") && gltfMesh.extras.hasOwnProperty("targetNames")) {
						options2.name = gltfMesh.extras.targetNames[index];
					} else {
						options2.name = index.toString(10);
					}
					if (gltfMesh.hasOwnProperty("weights")) {
						options2.defaultWeight = gltfMesh.weights[index];
					}
					options2.preserveData = assetOptions.morphPreserveData;
					targets.push(new MorphTarget(options2));
				});
				mesh.morph = new Morph(targets, device, {
					preferHighPrecision: assetOptions.morphPreferHighPrecision
				});
			}
			meshes.push(mesh);
		}
	});
	return meshes;
};
var createMaterial = (gltfMaterial, textures) => {
	const material = new StandardMaterial();
	if (gltfMaterial.hasOwnProperty("name")) {
		material.name = gltfMaterial.name;
	}
	material.occludeSpecular = SPECOCC_AO;
	material.diffuseVertexColor = true;
	material.specularTint = true;
	material.specularVertexColor = true;
	material.specular.set(1, 1, 1);
	material.gloss = 1;
	material.glossInvert = true;
	material.useMetalness = true;
	let texture;
	if (gltfMaterial.hasOwnProperty("pbrMetallicRoughness")) {
		const pbrData = gltfMaterial.pbrMetallicRoughness;
		if (pbrData.hasOwnProperty("baseColorFactor")) {
			const [r, g, b, a] = pbrData.baseColorFactor;
			material.diffuse.set(r, g, b).gamma();
			material.opacity = a;
		}
		if (pbrData.hasOwnProperty("baseColorTexture")) {
			const baseColorTexture = pbrData.baseColorTexture;
			texture = textures[baseColorTexture.index];
			material.diffuseMap = texture;
			material.diffuseMapChannel = "rgb";
			material.opacityMap = texture;
			material.opacityMapChannel = "a";
			extractTextureTransform(baseColorTexture, material, ["diffuse", "opacity"]);
		}
		if (pbrData.hasOwnProperty("metallicFactor")) {
			material.metalness = pbrData.metallicFactor;
		}
		if (pbrData.hasOwnProperty("roughnessFactor")) {
			material.gloss = pbrData.roughnessFactor;
		}
		if (pbrData.hasOwnProperty("metallicRoughnessTexture")) {
			const metallicRoughnessTexture = pbrData.metallicRoughnessTexture;
			material.metalnessMap = material.glossMap = textures[metallicRoughnessTexture.index];
			material.metalnessMapChannel = "b";
			material.glossMapChannel = "g";
			extractTextureTransform(metallicRoughnessTexture, material, ["gloss", "metalness"]);
		}
	}
	if (gltfMaterial.hasOwnProperty("normalTexture")) {
		const normalTexture = gltfMaterial.normalTexture;
		material.normalMap = textures[normalTexture.index];
		extractTextureTransform(normalTexture, material, ["normal"]);
		if (normalTexture.hasOwnProperty("scale")) {
			material.bumpiness = normalTexture.scale;
		}
	}
	if (gltfMaterial.hasOwnProperty("occlusionTexture")) {
		const occlusionTexture = gltfMaterial.occlusionTexture;
		material.aoMap = textures[occlusionTexture.index];
		material.aoMapChannel = "r";
		extractTextureTransform(occlusionTexture, material, ["ao"]);
		if (occlusionTexture.hasOwnProperty("strength")) {
			material.aoIntensity = occlusionTexture.strength;
		}
	}
	if (gltfMaterial.hasOwnProperty("emissiveFactor")) {
		const [r, g, b] = gltfMaterial.emissiveFactor;
		material.emissive.set(r, g, b).gamma();
	}
	if (gltfMaterial.hasOwnProperty("emissiveTexture")) {
		const emissiveTexture = gltfMaterial.emissiveTexture;
		material.emissiveMap = textures[emissiveTexture.index];
		extractTextureTransform(emissiveTexture, material, ["emissive"]);
	}
	if (gltfMaterial.hasOwnProperty("alphaMode")) {
		switch (gltfMaterial.alphaMode) {
			case "MASK":
				material.blendType = BLEND_NONE;
				if (gltfMaterial.hasOwnProperty("alphaCutoff")) {
					material.alphaTest = gltfMaterial.alphaCutoff;
				} else {
					material.alphaTest = 0.5;
				}
				break;
			case "BLEND":
				material.blendType = BLEND_NORMAL;
				material.depthWrite = false;
				break;
			default:
			case "OPAQUE":
				material.blendType = BLEND_NONE;
				break;
		}
	} else {
		material.blendType = BLEND_NONE;
	}
	if (gltfMaterial.hasOwnProperty("doubleSided")) {
		material.twoSidedLighting = gltfMaterial.doubleSided;
		material.cull = gltfMaterial.doubleSided ? CULLFACE_NONE : CULLFACE_BACK;
	} else {
		material.twoSidedLighting = false;
		material.cull = CULLFACE_BACK;
	}
	if (gltfMaterial.hasOwnProperty("extensions")) {
		for (const key in gltfMaterial.extensions) {
			const extension = glbMaterialExtensions[key];
			if (extension !== void 0) {
				extension.apply(gltfMaterial.extensions[key], material, textures);
			}
		}
	}
	material.update();
	return material;
};
var createAnimation = (gltfAnimation, animationIndex, gltfAccessors, bufferViews, nodes, meshes, gltfNodes) => {
	const createAnimData = (gltfAccessor) => {
		return new AnimData(GltfAccessor.getNumComponents(gltfAccessor.type), GltfAccessor.getDataFloat32(gltfAccessor, bufferViews));
	};
	const interpMap = {
		"STEP": INTERPOLATION_STEP,
		"LINEAR": INTERPOLATION_LINEAR,
		"CUBICSPLINE": INTERPOLATION_CUBIC
	};
	const inputMap = {};
	const outputMap = {};
	const curveMap = {};
	let outputCounter = 1;
	let i2;
	for (i2 = 0; i2 < gltfAnimation.samplers.length; ++i2) {
		const sampler = gltfAnimation.samplers[i2];
		if (!inputMap.hasOwnProperty(sampler.input)) {
			inputMap[sampler.input] = createAnimData(gltfAccessors[sampler.input]);
		}
		if (!outputMap.hasOwnProperty(sampler.output)) {
			outputMap[sampler.output] = createAnimData(gltfAccessors[sampler.output]);
		}
		const interpolation = sampler.hasOwnProperty("interpolation") && interpMap.hasOwnProperty(sampler.interpolation) ? interpMap[sampler.interpolation] : INTERPOLATION_LINEAR;
		const curve = {
			paths: [],
			input: sampler.input,
			output: sampler.output,
			interpolation
		};
		curveMap[i2] = curve;
	}
	const quatArrays = [];
	const transformSchema = {
		"translation": "localPosition",
		"rotation": "localRotation",
		"scale": "localScale"
	};
	const constructNodePath = (node) => {
		const path2 = [];
		while (node) {
			path2.unshift(node.name);
			node = node.parent;
		}
		return path2;
	};
	const createMorphTargetCurves = (curve, gltfNode, entityPath) => {
		const out = outputMap[curve.output];
		if (!out) {
			return;
		}
		let targetNames;
		if (meshes && meshes[gltfNode.mesh]) {
			const mesh = meshes[gltfNode.mesh];
			if (mesh.hasOwnProperty("extras") && mesh.extras.hasOwnProperty("targetNames")) {
				targetNames = mesh.extras.targetNames;
			}
		}
		const outData = out.data;
		const morphTargetCount = outData.length / inputMap[curve.input].data.length;
		const keyframeCount = outData.length / morphTargetCount;
		const singleBufferSize = keyframeCount * 4;
		const buffer = new ArrayBuffer(singleBufferSize * morphTargetCount);
		for (let j = 0; j < morphTargetCount; j++) {
			const morphTargetOutput = new Float32Array(buffer, singleBufferSize * j, keyframeCount);
			for (let k = 0; k < keyframeCount; k++) {
				morphTargetOutput[k] = outData[k * morphTargetCount + j];
			}
			const output = new AnimData(1, morphTargetOutput);
			const weightName = targetNames?.[j] ? `name.${targetNames[j]}` : j;
			outputMap[-outputCounter] = output;
			const morphCurve = {
				paths: [{
					entityPath,
					component: "graph",
					propertyPath: [`weight.${weightName}`]
				}],
				// each morph target curve input can use the same sampler.input from the channel they were all in
				input: curve.input,
				// but each morph target curve should reference its individual output that was just created
				output: -outputCounter,
				interpolation: curve.interpolation
			};
			outputCounter++;
			curveMap[`morphCurve-${i2}-${j}`] = morphCurve;
		}
	};
	for (i2 = 0; i2 < gltfAnimation.channels.length; ++i2) {
		const channel = gltfAnimation.channels[i2];
		const target2 = channel.target;
		const curve = curveMap[channel.sampler];
		const node = nodes[target2.node];
		const gltfNode = gltfNodes[target2.node];
		const entityPath = constructNodePath(node);
		if (target2.path.startsWith("weights")) {
			createMorphTargetCurves(curve, gltfNode, entityPath);
			curveMap[channel.sampler].morphCurve = true;
		} else {
			curve.paths.push({
				entityPath,
				component: "graph",
				propertyPath: [transformSchema[target2.path]]
			});
		}
	}
	const inputs = [];
	const outputs = [];
	const curves = [];
	for (const inputKey in inputMap) {
		inputs.push(inputMap[inputKey]);
		inputMap[inputKey] = inputs.length - 1;
	}
	for (const outputKey in outputMap) {
		outputs.push(outputMap[outputKey]);
		outputMap[outputKey] = outputs.length - 1;
	}
	for (const curveKey in curveMap) {
		const curveData = curveMap[curveKey];
		if (curveData.morphCurve) {
			continue;
		}
		curves.push(new AnimCurve(
			curveData.paths,
			inputMap[curveData.input],
			outputMap[curveData.output],
			curveData.interpolation
		));
		if (curveData.paths.length > 0 && curveData.paths[0].propertyPath[0] === "localRotation" && curveData.interpolation !== INTERPOLATION_CUBIC) {
			quatArrays.push(curves[curves.length - 1].output);
		}
	}
	quatArrays.sort();
	let prevIndex = null;
	let data2;
	for (i2 = 0; i2 < quatArrays.length; ++i2) {
		const index = quatArrays[i2];
		if (i2 === 0 || index !== prevIndex) {
			data2 = outputs[index];
			if (data2.components === 4) {
				const d = data2.data;
				const len = d.length - 4;
				for (let j = 0; j < len; j += 4) {
					const dp = d[j + 0] * d[j + 4] + d[j + 1] * d[j + 5] + d[j + 2] * d[j + 6] + d[j + 3] * d[j + 7];
					if (dp < 0) {
						d[j + 4] *= -1;
						d[j + 5] *= -1;
						d[j + 6] *= -1;
						d[j + 7] *= -1;
					}
				}
			}
			prevIndex = index;
		}
	}
	let duration = 0;
	for (i2 = 0; i2 < inputs.length; i2++) {
		data2 = inputs[i2]._data;
		duration = Math.max(duration, data2.length === 0 ? 0 : data2[data2.length - 1]);
	}
	return new AnimTrack(
		gltfAnimation.hasOwnProperty("name") ? gltfAnimation.name : `animation_${animationIndex}`,
		duration,
		inputs,
		outputs,
		curves
	);
};
var tempMat = new Mat4();
var tempVec2 = new Vec3();
var tempQuat = new Quat();
var createNode = (gltfNode, nodeIndex, nodeInstancingMap) => {
	const entity = new GraphNode();
	if (gltfNode.hasOwnProperty("name") && gltfNode.name.length > 0) {
		entity.name = gltfNode.name;
	} else {
		entity.name = `node_${nodeIndex}`;
	}
	if (gltfNode.hasOwnProperty("matrix")) {
		tempMat.data.set(gltfNode.matrix);
		tempMat.getTranslation(tempVec2);
		entity.setLocalPosition(tempVec2);
		tempQuat.setFromMat4(tempMat);
		entity.setLocalRotation(tempQuat);
		tempMat.getScale(tempVec2);
		tempVec2.x *= tempMat.scaleSign;
		entity.setLocalScale(tempVec2);
	}
	if (gltfNode.hasOwnProperty("rotation")) {
		const r = gltfNode.rotation;
		entity.setLocalRotation(r[0], r[1], r[2], r[3]);
	}
	if (gltfNode.hasOwnProperty("translation")) {
		const t = gltfNode.translation;
		entity.setLocalPosition(t[0], t[1], t[2]);
	}
	if (gltfNode.hasOwnProperty("scale")) {
		const s2 = gltfNode.scale;
		entity.setLocalScale(s2[0], s2[1], s2[2]);
	}
	if (gltfNode.hasOwnProperty("extensions") && gltfNode.extensions.EXT_mesh_gpu_instancing) {
		nodeInstancingMap.set(gltfNode, {
			ext: gltfNode.extensions.EXT_mesh_gpu_instancing
		});
	}
	return entity;
};
var createCamera = (gltfCamera, node) => {
	const isOrthographic = gltfCamera.type === "orthographic";
	const gltfProperties = isOrthographic ? gltfCamera.orthographic : gltfCamera.perspective;
	const componentData = {
		enabled: false,
		projection: isOrthographic ? PROJECTION_ORTHOGRAPHIC : PROJECTION_PERSPECTIVE,
		nearClip: gltfProperties.znear,
		aspectRatioMode: ASPECT_AUTO
	};
	if (gltfProperties.zfar) {
		componentData.farClip = gltfProperties.zfar;
	}
	if (isOrthographic) {
		componentData.orthoHeight = gltfProperties.ymag;
		if (gltfProperties.xmag && gltfProperties.ymag) {
			componentData.aspectRatioMode = ASPECT_MANUAL;
			componentData.aspectRatio = gltfProperties.xmag / gltfProperties.ymag;
		}
	} else {
		componentData.fov = gltfProperties.yfov * math.RAD_TO_DEG;
		if (gltfProperties.aspectRatio) {
			componentData.aspectRatioMode = ASPECT_MANUAL;
			componentData.aspectRatio = gltfProperties.aspectRatio;
		}
	}
	const cameraEntity = new Entity(gltfCamera.name);
	cameraEntity.addComponent("camera", componentData);
	return cameraEntity;
};
var createSkins = (device, gltf, nodes, bufferViews) => {
	if (!gltf.hasOwnProperty("skins") || gltf.skins.length === 0) {
		return [];
	}
	const glbSkins = /* @__PURE__ */ new Map();
	return gltf.skins.map((gltfSkin) => {
		return createSkin(device, gltfSkin, gltf.accessors, bufferViews, nodes, glbSkins);
	});
};
var createMeshes = (device, gltf, bufferViews, options2) => {
	const vertexBufferDict = {};
	const meshVariants = {};
	const meshDefaultMaterials = {};
	const promises = [];
	const valid = !options2.skipMeshes && gltf?.meshes?.length && gltf?.accessors?.length && gltf?.bufferViews?.length;
	const meshes = valid ? gltf.meshes.map((gltfMesh) => {
		return createMesh(device, gltfMesh, gltf.accessors, bufferViews, vertexBufferDict, meshVariants, meshDefaultMaterials, options2, promises);
	}) : [];
	return {
		meshes,
		meshVariants,
		meshDefaultMaterials,
		promises
	};
};
var createMaterials = (gltf, textures, options2) => {
	if (!gltf.hasOwnProperty("materials") || gltf.materials.length === 0) {
		return [];
	}
	const preprocess = options2?.material?.preprocess;
	const process = options2?.material?.process ?? createMaterial;
	const postprocess = options2?.material?.postprocess;
	return gltf.materials.map((gltfMaterial) => {
		if (preprocess) {
			preprocess(gltfMaterial);
		}
		const material = process(gltfMaterial, textures);
		if (postprocess) {
			postprocess(gltfMaterial, material);
		}
		return material;
	});
};
var createAnimations = (gltf, nodes, bufferViews, options2) => {
	if (!gltf.hasOwnProperty("animations") || gltf.animations.length === 0) {
		return [];
	}
	const preprocess = options2?.animation?.preprocess;
	const postprocess = options2?.animation?.postprocess;
	return gltf.animations.map((gltfAnimation, index) => {
		if (preprocess) {
			preprocess(gltfAnimation);
		}
		const animation = createAnimation(gltfAnimation, index, gltf.accessors, bufferViews, nodes, gltf.meshes, gltf.nodes);
		if (postprocess) {
			postprocess(gltfAnimation, animation);
		}
		return animation;
	});
};
var createNodes = (gltf, options2, nodeInstancingMap) => {
	if (!gltf.hasOwnProperty("nodes") || gltf.nodes.length === 0) {
		return [];
	}
	const preprocess = options2?.node?.preprocess;
	const process = options2?.node?.process ?? createNode;
	const postprocess = options2?.node?.postprocess;
	const nodes = gltf.nodes.map((gltfNode, index) => {
		if (preprocess) {
			preprocess(gltfNode);
		}
		const node = process(gltfNode, index, nodeInstancingMap);
		if (postprocess) {
			postprocess(gltfNode, node);
		}
		return node;
	});
	for (let i2 = 0; i2 < gltf.nodes.length; ++i2) {
		const gltfNode = gltf.nodes[i2];
		if (gltfNode.hasOwnProperty("children")) {
			const parent = nodes[i2];
			const uniqueNames = {};
			for (let j = 0; j < gltfNode.children.length; ++j) {
				const child = nodes[gltfNode.children[j]];
				if (!child.parent) {
					if (uniqueNames.hasOwnProperty(child.name)) {
						child.name += uniqueNames[child.name]++;
					} else {
						uniqueNames[child.name] = 1;
					}
					parent.addChild(child);
				}
			}
		}
	}
	return nodes;
};
var createScenes = (gltf, nodes) => {
	const scenes = [];
	const count = gltf.scenes.length;
	if (count === 1 && gltf.scenes[0].nodes?.length === 1) {
		const nodeIndex = gltf.scenes[0].nodes[0];
		scenes.push(nodes[nodeIndex]);
	} else {
		for (let i2 = 0; i2 < count; i2++) {
			const scene = gltf.scenes[i2];
			if (scene.nodes) {
				const sceneRoot = new GraphNode(scene.name);
				for (let n = 0; n < scene.nodes.length; n++) {
					const childNode = nodes[scene.nodes[n]];
					sceneRoot.addChild(childNode);
				}
				scenes.push(sceneRoot);
			}
		}
	}
	return scenes;
};
var createCameras = (gltf, nodes, options2) => {
	let cameras = null;
	if (gltf.hasOwnProperty("nodes") && gltf.hasOwnProperty("cameras") && gltf.cameras.length > 0) {
		const preprocess = options2?.camera?.preprocess;
		const process = options2?.camera?.process ?? createCamera;
		const postprocess = options2?.camera?.postprocess;
		gltf.nodes.forEach((gltfNode, nodeIndex) => {
			if (gltfNode.hasOwnProperty("camera")) {
				const gltfCamera = gltf.cameras[gltfNode.camera];
				if (gltfCamera) {
					if (preprocess) {
						preprocess(gltfCamera);
					}
					const camera = process(gltfCamera, nodes[nodeIndex]);
					if (postprocess) {
						postprocess(gltfCamera, camera);
					}
					if (camera) {
						if (!cameras) cameras = /* @__PURE__ */ new Map();
						cameras.set(gltfNode, camera);
					}
				}
			}
		});
	}
	return cameras;
};
var linkSkins = (gltf, renders, skins) => {
	gltf.nodes.forEach((gltfNode) => {
		if (gltfNode.hasOwnProperty("mesh") && gltfNode.hasOwnProperty("skin")) {
			const meshGroup = renders[gltfNode.mesh].meshes;
			meshGroup.forEach((mesh) => {
				mesh.skin = skins[gltfNode.skin];
			});
		}
	});
};
var createResources = async (device, gltf, bufferViews, textures, options2) => {
	const preprocess = options2?.global?.preprocess;
	const postprocess = options2?.global?.postprocess;
	if (preprocess) {
		preprocess(gltf);
	}
	if (gltf.asset && gltf.asset.generator === "PlayCanvas") {
	}
	const nodeInstancingMap = /* @__PURE__ */ new Map();
	const nodes = createNodes(gltf, options2, nodeInstancingMap);
	const scenes = createScenes(gltf, nodes);
	const lights2 = createLights(gltf, nodes, options2);
	const cameras = createCameras(gltf, nodes, options2);
	const variants = createVariants(gltf);
	const bufferViewData = await Promise.all(bufferViews);
	const { meshes, meshVariants, meshDefaultMaterials, promises } = createMeshes(device, gltf, bufferViewData, options2);
	const gsplats = options2.skipMeshes ? [] : createGSplats(device, gltf, bufferViewData);
	const animations = createAnimations(gltf, nodes, bufferViewData, options2);
	createInstancing(device, gltf, nodeInstancingMap, bufferViewData);
	const textureAssets = await Promise.all(textures);
	const textureInstances = textureAssets.map((t) => t.resource);
	const materials = createMaterials(gltf, textureInstances, options2);
	const skins = createSkins(device, gltf, nodes, bufferViewData);
	const renders = [];
	for (let i2 = 0; i2 < meshes.length; i2++) {
		renders[i2] = new Render();
		renders[i2].meshes = meshes[i2];
	}
	linkSkins(gltf, renders, skins);
	const result = new GlbResources();
	result.gltf = gltf;
	result.nodes = nodes;
	result.scenes = scenes;
	result.animations = animations;
	result.textures = textureAssets;
	result.materials = materials;
	result.variants = variants;
	result.meshVariants = meshVariants;
	result.meshDefaultMaterials = meshDefaultMaterials;
	result.renders = renders;
	result.gsplats = gsplats;
	result.skins = skins;
	result.lights = lights2;
	result.cameras = cameras;
	result.nodeInstancingMap = nodeInstancingMap;
	if (postprocess) {
		postprocess(gltf, result);
	}
	await Promise.all(promises);
	return result;
};
var applySampler = (texture, gltfSampler) => {
	const getFilter2 = (filter, defaultValue) => {
		switch (filter) {
			case 9728:
				return FILTER_NEAREST;
			case 9729:
				return FILTER_LINEAR;
			case 9984:
				return FILTER_NEAREST_MIPMAP_NEAREST;
			case 9985:
				return FILTER_LINEAR_MIPMAP_NEAREST;
			case 9986:
				return FILTER_NEAREST_MIPMAP_LINEAR;
			case 9987:
				return FILTER_LINEAR_MIPMAP_LINEAR;
			default:
				return defaultValue;
		}
	};
	const getWrap2 = (wrap, defaultValue) => {
		switch (wrap) {
			case 33071:
				return ADDRESS_CLAMP_TO_EDGE;
			case 33648:
				return ADDRESS_MIRRORED_REPEAT;
			case 10497:
				return ADDRESS_REPEAT;
			default:
				return defaultValue;
		}
	};
	if (texture) {
		gltfSampler = gltfSampler ?? {};
		texture.minFilter = getFilter2(gltfSampler.minFilter, FILTER_LINEAR_MIPMAP_LINEAR);
		texture.magFilter = getFilter2(gltfSampler.magFilter, FILTER_LINEAR);
		texture.addressU = getWrap2(gltfSampler.wrapS, ADDRESS_REPEAT);
		texture.addressV = getWrap2(gltfSampler.wrapT, ADDRESS_REPEAT);
	}
};
var gltfTextureUniqueId = 0;
var createImages = (gltf, bufferViews, urlBase, registry, options2) => {
	if (!gltf.images || gltf.images.length === 0) {
		return [];
	}
	const preprocess = options2?.image?.preprocess;
	const processAsync = options2?.image?.processAsync;
	const postprocess = options2?.image?.postprocess;
	const mimeTypeFileExtensions = {
		"image/png": "png",
		"image/jpeg": "jpg",
		"image/basis": "basis",
		"image/ktx": "ktx",
		"image/ktx2": "ktx2",
		"image/vnd-ms.dds": "dds"
	};
	const getGammaTextures = (gltf2) => {
		const set = /* @__PURE__ */ new Set();
		if (gltf2.hasOwnProperty("materials")) {
			gltf2.materials.forEach((gltfMaterial) => {
				if (gltfMaterial.hasOwnProperty("pbrMetallicRoughness")) {
					const pbrData = gltfMaterial.pbrMetallicRoughness;
					if (pbrData.hasOwnProperty("baseColorTexture")) {
						const gltfTexture = gltf2.textures[pbrData.baseColorTexture.index];
						set.add(getTextureSource(gltfTexture));
					}
				}
				if (gltfMaterial.hasOwnProperty("emissiveTexture")) {
					const gltfTexture = gltf2.textures[gltfMaterial.emissiveTexture.index];
					set.add(getTextureSource(gltfTexture));
				}
				if (gltfMaterial.hasOwnProperty("extensions")) {
					for (const key in gltfMaterial.extensions) {
						const extension = glbMaterialExtensions[key];
						if (extension?.getColorTextures) {
							const textureInfos = extension.getColorTextures(gltfMaterial.extensions[key]);
							for (const textureInfo of textureInfos) {
								const gltfTexture = gltf2.textures[textureInfo.index];
								set.add(getTextureSource(gltfTexture));
							}
						}
					}
				}
			});
		}
		return set;
	};
	const loadTexture = (gltfImage, url, bufferView, mimeType, options3, srgb) => {
		return new Promise((resolve2, reject) => {
			const continuation = (bufferViewData) => {
				const name = `${gltfImage.name || "gltf-texture"}-${gltfTextureUniqueId++}`;
				const file = {
					url: url || name
				};
				if (bufferViewData) {
					file.contents = bufferViewData.slice(0).buffer;
				}
				if (mimeType) {
					const extension = mimeTypeFileExtensions[mimeType];
					if (extension) {
						file.filename = `${file.url}.${extension}`;
					}
				}
				const data2 = { srgb };
				const asset = new Asset(name, "texture", file, data2, options3);
				asset.on("load", (asset2) => resolve2(asset2));
				asset.on("error", (err2) => reject(err2));
				registry.add(asset);
				registry.load(asset);
			};
			if (bufferView) {
				bufferView.then((bufferViewData) => continuation(bufferViewData));
			} else {
				continuation(null);
			}
		});
	};
	const gammaTextures = getGammaTextures(gltf);
	return gltf.images.map((gltfImage, i2) => {
		if (preprocess) {
			preprocess(gltfImage);
		}
		let promise;
		if (processAsync) {
			promise = new Promise((resolve2, reject) => {
				processAsync(gltfImage, (err2, textureAsset) => {
					if (err2) {
						reject(err2);
					} else {
						resolve2(textureAsset);
					}
				});
			});
		} else {
			promise = new Promise((resolve2) => {
				resolve2(null);
			});
		}
		promise = promise.then((textureAsset) => {
			const srgb = gammaTextures.has(i2);
			if (textureAsset) {
				return textureAsset;
			} else if (gltfImage.hasOwnProperty("uri")) {
				if (isDataURI(gltfImage.uri)) {
					return loadTexture(gltfImage, gltfImage.uri, null, getDataURIMimeType(gltfImage.uri), null, srgb);
				}
				return loadTexture(gltfImage, ABSOLUTE_URL.test(gltfImage.uri) ? gltfImage.uri : path.join(urlBase, gltfImage.uri), null, null, { crossOrigin: "anonymous" }, srgb);
			} else if (gltfImage.hasOwnProperty("bufferView") && gltfImage.hasOwnProperty("mimeType")) {
				return loadTexture(gltfImage, null, bufferViews[gltfImage.bufferView], gltfImage.mimeType, null, srgb);
			}
			return Promise.reject(new Error(`Invalid image found in gltf (neither uri or bufferView found). index=${i2}`));
		});
		if (postprocess) {
			promise = promise.then((textureAsset) => {
				postprocess(gltfImage, textureAsset);
				return textureAsset;
			});
		}
		return promise;
	});
};
var createTextures = (gltf, images, options2) => {
	if (!gltf?.images?.length || !gltf?.textures?.length) {
		return [];
	}
	const preprocess = options2?.texture?.preprocess;
	const processAsync = options2?.texture?.processAsync;
	const postprocess = options2?.texture?.postprocess;
	const seenImages = /* @__PURE__ */ new Set();
	return gltf.textures.map((gltfTexture) => {
		if (preprocess) {
			preprocess(gltfTexture);
		}
		let promise;
		if (processAsync) {
			promise = new Promise((resolve2, reject) => {
				processAsync(gltfTexture, gltf.images, (err2, gltfImageIndex) => {
					if (err2) {
						reject(err2);
					} else {
						resolve2(gltfImageIndex);
					}
				});
			});
		} else {
			promise = new Promise((resolve2) => {
				resolve2(null);
			});
		}
		promise = promise.then((gltfImageIndex) => {
			gltfImageIndex = gltfImageIndex ?? getTextureSource(gltfTexture);
			const cloneAsset = seenImages.has(gltfImageIndex);
			seenImages.add(gltfImageIndex);
			return images[gltfImageIndex].then((imageAsset) => {
				const asset = cloneAsset ? cloneTextureAsset(imageAsset) : imageAsset;
				applySampler(asset.resource, (gltf.samplers ?? [])[gltfTexture.sampler]);
				return asset;
			});
		});
		if (postprocess) {
			promise = promise.then((textureAsset) => {
				postprocess(gltfTexture, textureAsset);
				return textureAsset;
			});
		}
		return promise;
	});
};
var loadBuffers = (gltf, binaryChunk, urlBase, options2) => {
	if (!gltf.buffers || gltf.buffers.length === 0) {
		return [];
	}
	const preprocess = options2?.buffer?.preprocess;
	const processAsync = options2?.buffer?.processAsync;
	const postprocess = options2?.buffer?.postprocess;
	return gltf.buffers.map((gltfBuffer, i2) => {
		if (preprocess) {
			preprocess(gltfBuffer);
		}
		let promise;
		if (processAsync) {
			promise = new Promise((resolve2, reject) => {
				processAsync(gltfBuffer, (err2, arrayBuffer) => {
					if (err2) {
						reject(err2);
					} else {
						resolve2(arrayBuffer);
					}
				});
			});
		} else {
			promise = new Promise((resolve2) => {
				resolve2(null);
			});
		}
		promise = promise.then((arrayBuffer) => {
			if (arrayBuffer) {
				return arrayBuffer;
			} else if (gltfBuffer.hasOwnProperty("uri")) {
				if (isDataURI(gltfBuffer.uri)) {
					const byteString = atob(gltfBuffer.uri.split(",")[1]);
					const binaryArray = new Uint8Array(byteString.length);
					for (let j = 0; j < byteString.length; j++) {
						binaryArray[j] = byteString.charCodeAt(j);
					}
					return binaryArray;
				}
				return new Promise((resolve2, reject) => {
					http.get(
						ABSOLUTE_URL.test(gltfBuffer.uri) ? gltfBuffer.uri : path.join(urlBase, gltfBuffer.uri),
						{ cache: true, responseType: "arraybuffer", retry: false },
						(err2, result) => {
							if (err2) {
								reject(err2);
							} else {
								resolve2(new Uint8Array(result));
							}
						}
					);
				});
			}
			return binaryChunk;
		});
		if (postprocess) {
			promise = promise.then((buffer) => {
				postprocess(gltf.buffers[i2], buffer);
				return buffer;
			});
		}
		return promise;
	});
};
var parseGltf = (gltfChunk, callback) => {
	const decodeBinaryUtf8 = (array3) => {
		if (typeof TextDecoder !== "undefined") {
			return new TextDecoder().decode(array3);
		}
		let str = "";
		for (let i2 = 0; i2 < array3.length; i2++) {
			str += String.fromCharCode(array3[i2]);
		}
		return decodeURIComponent(escape(str));
	};
	const gltf = JSON.parse(decodeBinaryUtf8(gltfChunk));
	if (gltf.asset && gltf.asset.version && parseFloat(gltf.asset.version) < 2) {
		callback(`Invalid gltf version. Expected version 2.0 or above but found version '${gltf.asset.version}'.`);
		return;
	}
	callback(null, gltf);
};
var parseGlb = (glbData, callback) => {
	const data2 = glbData instanceof ArrayBuffer ? new DataView(glbData) : new DataView(glbData.buffer, glbData.byteOffset, glbData.byteLength);
	const magic = data2.getUint32(0, true);
	const version2 = data2.getUint32(4, true);
	const length = data2.getUint32(8, true);
	if (magic !== 1179937895) {
		callback(`Invalid magic number found in glb header. Expected 0x46546C67, found 0x${magic.toString(16)}`);
		return;
	}
	if (version2 !== 2) {
		callback(`Invalid version number found in glb header. Expected 2, found ${version2}`);
		return;
	}
	if (length <= 0 || length > data2.byteLength) {
		callback(`Invalid length found in glb header. Found ${length}`);
		return;
	}
	const chunks = [];
	let offset3 = 12;
	while (offset3 < length) {
		const chunkLength = data2.getUint32(offset3, true);
		if (offset3 + chunkLength + 8 > data2.byteLength) {
			callback(`Invalid chunk length found in glb. Found ${chunkLength}`);
		}
		const chunkType = data2.getUint32(offset3 + 4, true);
		const chunkData = new Uint8Array(data2.buffer, data2.byteOffset + offset3 + 8, chunkLength);
		chunks.push({ length: chunkLength, type: chunkType, data: chunkData });
		offset3 += chunkLength + 8;
	}
	if (chunks.length !== 1 && chunks.length !== 2) {
		callback("Invalid number of chunks found in glb file.");
		return;
	}
	if (chunks[0].type !== 1313821514) {
		callback(`Invalid chunk type found in glb file. Expected 0x4E4F534A, found 0x${chunks[0].type.toString(16)}`);
		return;
	}
	if (chunks.length > 1 && chunks[1].type !== 5130562) {
		callback(`Invalid chunk type found in glb file. Expected 0x004E4942, found 0x${chunks[1].type.toString(16)}`);
		return;
	}
	callback(null, {
		gltfChunk: chunks[0].data,
		binaryChunk: chunks.length === 2 ? chunks[1].data : null
	});
};
var parseChunk = (filename, data2, callback) => {
	const hasGlbHeader = () => {
		const u82 = new Uint8Array(data2);
		return u82[0] === 103 && u82[1] === 108 && u82[2] === 84 && u82[3] === 70;
	};
	if (filename && filename.toLowerCase().endsWith(".glb") || hasGlbHeader()) {
		parseGlb(data2, callback);
	} else {
		callback(null, {
			gltfChunk: data2,
			binaryChunk: null
		});
	}
};
var createBufferViews = (gltf, buffers, options2) => {
	const result = [];
	const preprocess = options2?.bufferView?.preprocess;
	const processAsync = options2?.bufferView?.processAsync;
	const postprocess = options2?.bufferView?.postprocess;
	if (!gltf.bufferViews?.length) {
		return result;
	}
	for (let i2 = 0; i2 < gltf.bufferViews.length; ++i2) {
		const gltfBufferView = gltf.bufferViews[i2];
		if (preprocess) {
			preprocess(gltfBufferView);
		}
		let promise;
		if (processAsync) {
			promise = new Promise((resolve2, reject) => {
				processAsync(gltfBufferView, buffers, (err2, result2) => {
					if (err2) {
						reject(err2);
					} else {
						resolve2(result2);
					}
				});
			});
		} else {
			promise = new Promise((resolve2) => {
				resolve2(null);
			});
		}
		promise = promise.then((buffer) => {
			if (buffer) {
				return buffer;
			}
			return buffers[gltfBufferView.buffer].then((buffer2) => {
				return new Uint8Array(
					buffer2.buffer,
					buffer2.byteOffset + (gltfBufferView.byteOffset || 0),
					gltfBufferView.byteLength
				);
			});
		});
		if (gltfBufferView.hasOwnProperty("byteStride")) {
			promise = promise.then((typedArray) => {
				typedArray.byteStride = gltfBufferView.byteStride;
				return typedArray;
			});
		}
		if (postprocess) {
			promise = promise.then((typedArray) => {
				postprocess(gltfBufferView, typedArray);
				return typedArray;
			});
		}
		result.push(promise);
	}
	return result;
};
var GlbParser = class {
	// parse the gltf or glb data asynchronously, loading external resources
	static parse(filename, urlBase, data2, device, registry, options2, callback) {
		parseChunk(filename, data2, (err2, chunks) => {
			if (err2) {
				callback(err2);
				return;
			}
			parseGltf(chunks.gltfChunk, (err3, gltf) => {
				if (err3) {
					callback(err3);
					return;
				}
				const buffers = loadBuffers(gltf, chunks.binaryChunk, urlBase, options2);
				const bufferViews = createBufferViews(gltf, buffers, options2);
				const images = createImages(gltf, bufferViews, urlBase, registry, options2);
				const textures = createTextures(gltf, images, options2);
				createResources(device, gltf, bufferViews, textures, options2).then((result) => callback(null, result)).catch((err4) => callback(err4));
			});
		});
	}
	static createDefaultMaterial() {
		return createMaterial({
			name: "defaultGlbMaterial"
		}, []);
	}
};

var GlbAnimationParser = class {
	canParse(context) {
		return context.ext === "glb";
	}
	load(url, callback, asset) {
		const original = typeof url === "string" ? url : url.original;
		this.handler.fetch(url, Http.ResponseType.ARRAY_BUFFER, (err2, response) => {
			if (err2) {
				callback(`Error loading animation resource: ${original} [${err2}]`);
			} else {
				GlbParser.parse("filename.glb", "", response, this.handler.device, this.handler.assets, asset?.options ?? {}, (err3, parseResult) => {
					if (err3) {
						callback(err3);
					} else {
						const animations = parseResult.animations;
						if (asset?.data?.events) {
							for (let i2 = 0; i2 < animations.length; i2++) {
								animations[i2].events = new AnimEvents(Object.values(asset.data.events));
							}
						}
						parseResult.destroy();
						callback(null, animations);
					}
				});
			}
		}, asset);
	}
};

var JsonAnimationParser = class {
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		const original = typeof url === "string" ? url : url.original;
		this.handler.fetch(url, Http.ResponseType.JSON, (err2, response) => {
			if (err2) {
				callback(`Error loading animation resource: ${original} [${err2}]`);
			} else {
				callback(null, this[`_parseAnimationV${response.animation.version}`](response));
			}
		}, asset);
	}
	_parseAnimationV3(data2) {
		const animData = data2.animation;
		const anim = new Animation();
		anim.name = animData.name;
		anim.duration = animData.duration;
		for (let i2 = 0; i2 < animData.nodes.length; i2++) {
			const node = new AnimationNode();
			const n = animData.nodes[i2];
			node._name = n.name;
			for (let j = 0; j < n.keys.length; j++) {
				const k = n.keys[j];
				const t = k.time;
				const p = k.pos;
				const r = k.rot;
				const s2 = k.scale;
				const pos = new Vec3(p[0], p[1], p[2]);
				const rot = new Quat().setFromEulerAngles(r[0], r[1], r[2]);
				const scl = new Vec3(s2[0], s2[1], s2[2]);
				const key = new AnimationKey(t, pos, rot, scl);
				node._keys.push(key);
			}
			anim.addNode(node);
		}
		return anim;
	}
	_parseAnimationV4(data2) {
		const animData = data2.animation;
		const anim = new Animation();
		anim.name = animData.name;
		anim.duration = animData.duration;
		for (let i2 = 0; i2 < animData.nodes.length; i2++) {
			const node = new AnimationNode();
			const n = animData.nodes[i2];
			node._name = n.name;
			const defPos = n.defaults.p;
			const defRot = n.defaults.r;
			const defScl = n.defaults.s;
			for (let j = 0; j < n.keys.length; j++) {
				const k = n.keys[j];
				const t = k.t;
				const p = defPos ? defPos : k.p;
				const r = defRot ? defRot : k.r;
				const s2 = defScl ? defScl : k.s;
				const pos = new Vec3(p[0], p[1], p[2]);
				const rot = new Quat().setFromEulerAngles(r[0], r[1], r[2]);
				const scl = new Vec3(s2[0], s2[1], s2[2]);
				const key = new AnimationKey(t, pos, rot, scl);
				node._keys.push(key);
			}
			anim.addNode(node);
		}
		return anim;
	}
};

var AnimationHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "animation");
		this.device = app2.graphicsDevice;
		this.assets = app2.assets;
		this.addParser(new JsonAnimationParser());
		this.addParser(new GlbAnimationParser());
	}
};

var AnimClipParser = class {
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		const original = typeof url === "string" ? url : url.original;
		this.handler.fetch(url, Http.ResponseType.JSON, (err2, response) => {
			if (err2) {
				callback(`Error loading animation clip resource: ${original} [${err2}]`);
			} else {
				callback(null, response);
			}
		}, asset);
	}
	open(url, data2) {
		const name = data2.name;
		const duration = data2.duration;
		const inputs = data2.inputs.map((input) => {
			return new AnimData(1, input);
		});
		const outputs = data2.outputs.map((output) => {
			return new AnimData(output.components, output.data);
		});
		const curves = data2.curves.map((curve) => {
			return new AnimCurve(
				[curve.path],
				curve.inputIndex,
				curve.outputIndex,
				curve.interpolation
			);
		});
		return new AnimTrack(
			name,
			duration,
			inputs,
			outputs,
			curves
		);
	}
};

var AnimClipHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "animclip");
		this.addParser(new AnimClipParser());
	}
};

var AnimStateGraphParser = class {
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		const original = typeof url === "string" ? url : url.original;
		this.handler.fetch(url, Http.ResponseType.JSON, (err2, response) => {
			if (err2) {
				callback(`Error loading animation state graph resource: ${original} [${err2}]`);
			} else {
				callback(null, response);
			}
		}, asset);
	}
	open(url, data2) {
		return new AnimStateGraph(data2);
	}
};

var AnimStateGraphHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "animstategraph");
		this.addParser(new AnimStateGraphParser());
	}
};

var supportedExtensions = [
	".ogg",
	".mp3",
	".wav",
	".mp4a",
	".m4a",
	".mp4",
	".aac",
	".opus"
];
var AudioParser = class {
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		const original = typeof url === "string" ? url : url.original;
		const success = function(resource) {
			callback(null, new Sound(resource));
		};
		const error = function(err2) {
			let msg = `Error loading audio url: ${original}`;
			if (err2) {
				msg += `: ${err2.message || err2}`;
			}
			console.warn(msg);
			callback(msg);
		};
		if (!this._isSupported(original)) {
			error(`Audio format for ${original} not supported`);
			return;
		}
		const manager = this.handler.manager;
		if (!manager?.context) {
			error("Audio manager has no audio context");
			return;
		}
		this.handler.fetch(url, Http.ResponseType.ARRAY_BUFFER, (err2, response) => {
			if (err2) {
				error(err2);
				return;
			}
			manager.context.decodeAudioData(response, success, error);
		}, asset);
	}
	_isSupported(url) {
		const ext = path.getExtension(url).toLowerCase();
		return supportedExtensions.indexOf(ext) > -1;
	}
};

var AudioHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "audio");
		this.manager = app2.soundManager;
		this.addParser(new AudioParser());
	}
};

var BinaryParser = class {
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		const original = typeof url === "string" ? url : url.original;
		this.handler.fetch(url, Http.ResponseType.ARRAY_BUFFER, (err2, response) => {
			if (err2) {
				callback(`Error loading ${this.handler.handlerType} resource: ${original} [${err2}]`);
			} else {
				callback(null, response);
			}
		}, asset);
	}
};

var BinaryHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "binary");
		this.addParser(new BinaryParser());
	}
	openBinary(data2) {
		return data2.buffer;
	}
};

var GlbContainerResource = class _GlbContainerResource {
	constructor(data2, asset, assets, defaultMaterial) {
		const createAsset = function(type, resource, index) {
			const subAsset = _GlbContainerResource.createAsset(asset.name, type, resource, index);
			assets.add(subAsset);
			return subAsset;
		};
		const renders = [];
		for (let i2 = 0; i2 < data2.renders.length; ++i2) {
			renders.push(createAsset("render", data2.renders[i2], i2));
		}
		const materials = [];
		for (let i2 = 0; i2 < data2.materials.length; ++i2) {
			materials.push(createAsset("material", data2.materials[i2], i2));
		}
		const animations = [];
		for (let i2 = 0; i2 < data2.animations.length; ++i2) {
			animations.push(createAsset("animation", data2.animations[i2], i2));
		}
		const gsplats = [];
		const meshGSplats = [];
		if (data2.gsplats) {
			for (let i2 = 0; i2 < data2.gsplats.length; ++i2) {
				const resources = data2.gsplats[i2];
				meshGSplats.push(resources ? resources.map((resource) => {
					const gsplatAsset = createAsset("gsplat", resource, gsplats.length);
					gsplats.push(gsplatAsset);
					return gsplatAsset;
				}) : null);
			}
		}
		this.data = data2;
		this._model = null;
		this._assetName = asset.name;
		this._assets = assets;
		this._defaultMaterial = defaultMaterial;
		this.renders = renders;
		this.materials = materials;
		this.textures = data2.textures;
		this.animations = animations;
		this.gsplats = gsplats;
		this._meshGSplats = meshGSplats;
	}
	get model() {
		if (!this._model) {
			const model = _GlbContainerResource.createModel(this.data, this._defaultMaterial);
			const modelAsset = _GlbContainerResource.createAsset(this._assetName, "model", model, 0);
			this._assets.add(modelAsset);
			this._model = modelAsset;
		}
		return this._model;
	}
	static createAsset(assetName, type, resource, index) {
		const subAsset = new Asset(`${assetName}/${type}/${index}`, type, {
			url: ""
		});
		subAsset.resource = resource;
		subAsset.loaded = true;
		return subAsset;
	}
	instantiateModelEntity(options2) {
		const entity = new Entity(void 0, this._assets._loader._app);
		entity.addComponent("model", Object.assign({ type: "asset", asset: this.model }, options2));
		return entity;
	}
	instantiateRenderEntity(options2) {
		const defaultMaterial = this._defaultMaterial;
		const skinnedMeshInstances = [];
		const createMeshInstance = function(root, entity, mesh, materials, meshDefaultMaterials, skins, gltfNode, nodeInstancingMap) {
			const materialIndex = meshDefaultMaterials[mesh.id];
			const material = materialIndex === void 0 ? defaultMaterial : materials[materialIndex];
			const meshInstance = new MeshInstance(mesh, material);
			if (mesh.morph) {
				meshInstance.morphInstance = new MorphInstance(mesh.morph);
			}
			if (gltfNode.hasOwnProperty("skin")) {
				skinnedMeshInstances.push({
					meshInstance,
					rootBone: root,
					entity
				});
			}
			const instData = nodeInstancingMap.get(gltfNode);
			if (instData) {
				const matrices = instData.matrices;
				const vbFormat = VertexFormat.getDefaultInstancingFormat(mesh.device);
				const vb = new VertexBuffer(mesh.device, vbFormat, matrices.length / 16, {
					data: matrices
				});
				meshInstance.setInstancing(vb);
				meshInstance.instancingData._destroyVertexBuffer = true;
			}
			return meshInstance;
		};
		const cloneHierarchy = (root, node, glb) => {
			const entity = new Entity(void 0, this._assets._loader._app);
			node._cloneInternal(entity);
			if (!root) root = entity;
			let attachedMi = null;
			let renderAsset = null;
			for (let i2 = 0; i2 < glb.nodes.length; i2++) {
				const glbNode = glb.nodes[i2];
				if (glbNode === node) {
					const gltfNode = glb.gltf.nodes[i2];
					if (gltfNode.hasOwnProperty("mesh")) {
						const meshGroup = glb.renders[gltfNode.mesh].meshes;
						renderAsset = this.renders[gltfNode.mesh];
						for (let mi = 0; mi < meshGroup.length; mi++) {
							const mesh = meshGroup[mi];
							if (mesh) {
								const cloneMi = createMeshInstance(root, entity, mesh, glb.materials, glb.meshDefaultMaterials, glb.skins, gltfNode, glb.nodeInstancingMap);
								if (!attachedMi) {
									attachedMi = [];
								}
								attachedMi.push(cloneMi);
							}
						}
					}
					if (gltfNode.hasOwnProperty("mesh")) {
						const splatAssets = this._meshGSplats[gltfNode.mesh];
						if (splatAssets) {
							for (let sa = 0; sa < splatAssets.length; sa++) {
								let target2 = entity;
								if (sa > 0) {
									target2 = new Entity(`${entity.name}_gsplat_${sa}`, this._assets._loader._app);
									entity.addChild(target2);
								}
								target2.addComponent("gsplat", { asset: splatAssets[sa] });
							}
						}
					}
					if (glb.lights) {
						const lightEntity = glb.lights.get(gltfNode);
						if (lightEntity) {
							entity.addChild(lightEntity.clone());
						}
					}
					if (glb.cameras) {
						const cameraEntity = glb.cameras.get(gltfNode);
						if (cameraEntity) {
							cameraEntity.camera.system.cloneComponent(cameraEntity, entity);
						}
					}
				}
			}
			if (attachedMi) {
				entity.addComponent("render", Object.assign({
					type: "asset",
					meshInstances: attachedMi
				}, options2));
				entity.render.assignAsset(renderAsset);
			}
			const children = node.children;
			for (let i2 = 0; i2 < children.length; i2++) {
				const childClone = cloneHierarchy(root, children[i2], glb);
				entity.addChild(childClone);
			}
			return entity;
		};
		const sceneClones = [];
		for (const scene of this.data.scenes) {
			sceneClones.push(cloneHierarchy(null, scene, this.data));
		}
		skinnedMeshInstances.forEach((data2) => {
			data2.meshInstance.skinInstance = SkinInstanceCache.createCachedSkinInstance(data2.meshInstance.mesh.skin, data2.rootBone, data2.entity);
			data2.meshInstance.node.render.rootBone = data2.rootBone;
		});
		return _GlbContainerResource.createSceneHierarchy(sceneClones, Entity);
	}
	// get material variants
	getMaterialVariants() {
		return this.data.variants ? Object.keys(this.data.variants) : [];
	}
	// apply material variant to entity
	applyMaterialVariant(entity, name) {
		const variant = name ? this.data.variants[name] : null;
		if (variant === void 0) {
			return;
		}
		const renders = entity.findComponents("render");
		for (let i2 = 0; i2 < renders.length; i2++) {
			const renderComponent = renders[i2];
			this._applyMaterialVariant(variant, renderComponent.meshInstances);
		}
	}
	// apply material variant to mesh instances
	applyMaterialVariantInstances(instances, name) {
		const variant = name ? this.data.variants[name] : null;
		if (variant === void 0) {
			return;
		}
		this._applyMaterialVariant(variant, instances);
	}
	// internally apply variant to instances
	_applyMaterialVariant(variant, instances) {
		instances.forEach((instance) => {
			if (variant === null) {
				instance.material = this._defaultMaterial;
			} else {
				const meshVariants = this.data.meshVariants[instance.mesh.id];
				if (meshVariants) {
					instance.material = this.data.materials[meshVariants[variant]];
				}
			}
		});
	}
	// helper function to create a single hierarchy from an array of nodes
	static createSceneHierarchy(sceneNodes, nodeType) {
		let root = null;
		if (sceneNodes.length === 1) {
			root = sceneNodes[0];
		} else {
			root = new nodeType("SceneGroup");
			for (const scene of sceneNodes) {
				root.addChild(scene);
			}
		}
		return root;
	}
	// create a Model from the parsed GLB data structures
	static createModel(glb, defaultMaterial) {
		const createMeshInstance = function(model2, mesh, skins, skinInstances2, materials, node, gltfNode) {
			const materialIndex = glb.meshDefaultMaterials[mesh.id];
			const material = materialIndex === void 0 ? defaultMaterial : materials[materialIndex];
			const meshInstance = new MeshInstance(mesh, material, node);
			if (mesh.morph) {
				const morphInstance = new MorphInstance(mesh.morph);
				meshInstance.morphInstance = morphInstance;
				model2.morphInstances.push(morphInstance);
			}
			if (gltfNode.hasOwnProperty("skin")) {
				const skinIndex = gltfNode.skin;
				const skin = skins[skinIndex];
				mesh.skin = skin;
				const skinInstance = skinInstances2[skinIndex];
				meshInstance.skinInstance = skinInstance;
				model2.skinInstances.push(skinInstance);
			}
			model2.meshInstances.push(meshInstance);
		};
		const model = new Model();
		const skinInstances = [];
		for (const skin of glb.skins) {
			const skinInstance = new SkinInstance(skin);
			skinInstance.bones = skin.bones;
			skinInstances.push(skinInstance);
		}
		model.graph = _GlbContainerResource.createSceneHierarchy(glb.scenes, GraphNode);
		for (let i2 = 0; i2 < glb.nodes.length; i2++) {
			const node = glb.nodes[i2];
			if (node.root === model.graph) {
				const gltfNode = glb.gltf.nodes[i2];
				if (gltfNode.hasOwnProperty("mesh")) {
					const meshGroup = glb.renders[gltfNode.mesh].meshes;
					for (let mi = 0; mi < meshGroup.length; mi++) {
						const mesh = meshGroup[mi];
						if (mesh) {
							createMeshInstance(model, mesh, glb.skins, skinInstances, glb.materials, node, gltfNode);
						}
					}
				}
			}
		}
		return model;
	}
	destroy() {
		const registry = this._assets;
		const destroyAsset = function(asset) {
			registry.remove(asset);
			asset.unload();
		};
		const destroyAssets = function(assets) {
			assets.forEach((asset) => {
				destroyAsset(asset);
			});
		};
		if (this.animations) {
			destroyAssets(this.animations);
			this.animations = null;
		}
		if (this.textures) {
			destroyAssets(this.textures);
			this.textures = null;
		}
		if (this.materials) {
			destroyAssets(this.materials);
			this.materials = null;
		}
		if (this.renders) {
			destroyAssets(this.renders);
			this.renders = null;
		}
		if (this.gsplats) {
			destroyAssets(this.gsplats);
			this.gsplats = null;
			this._meshGSplats = null;
		}
		if (this._model) {
			destroyAsset(this._model);
			this._model = null;
		}
		this.data = null;
		this.assets = null;
	}
};

var GlbContainerParser = class {
	constructor(device, assets) {
		this._device = device;
		this._assets = assets;
		this._defaultMaterial = GlbParser.createDefaultMaterial();
	}
	canParse() {
		return true;
	}
	_getUrlWithoutParams(url) {
		return url.indexOf("?") >= 0 ? url.split("?")[0] : url;
	}
	load(url, callback, asset) {
		Asset.fetchArrayBuffer(url.load, (err2, result) => {
			if (err2) {
				callback(err2);
			} else {
				GlbParser.parse(
					this._getUrlWithoutParams(url.original),
					path.extractPath(url.load),
					result,
					this._device,
					asset.registry,
					asset.options,
					(err3, result2) => {
						if (err3) {
							callback(err3);
						} else {
							callback(null, new GlbContainerResource(result2, asset, this._assets, this._defaultMaterial));
						}
					}
				);
			}
		}, asset, this.handler.maxRetries);
	}
	open(url, data2, asset) {
		return data2;
	}
	patch(asset, assets) {
	}
};

var ContainerResource = class {
	instantiateModelEntity(options2) {
		return null;
	}
	instantiateRenderEntity(options2) {
		return null;
	}
	getMaterialVariants() {
		return null;
	}
	applyMaterialVariant(entity, name) {
	}
	applyMaterialVariantInstances(instances, name) {
	}
};
var ContainerHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "container");
		this.addParser(new GlbContainerParser(app2.graphicsDevice, app2.assets));
	}
};

var TextParser = class {
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		const original = typeof url === "string" ? url : url.original;
		this.handler.fetch(url, Http.ResponseType.TEXT, (err2, response) => {
			if (err2) {
				callback(`Error loading ${this.handler.handlerType} resource: ${original} [${err2}]`);
			} else {
				callback(null, response);
			}
		}, asset);
	}
};

var CssHandler = class extends ResourceHandler {
	decoder = null;
	constructor(app2) {
		super(app2, "css");
		this.addParser(new TextParser());
	}
	openBinary(data2) {
		this.decoder ?? (this.decoder = new TextDecoder("utf-8"));
		return this.decoder.decode(data2);
	}
};

var CubemapHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "cubemap");
		this._device = app2.graphicsDevice;
		this._registry = app2.assets;
		this._loader = app2.loader;
	}
	load(url, callback, asset) {
		this.loadAssets(asset, callback);
	}
	open(url, data2, asset) {
		return asset ? asset.resource : null;
	}
	patch(asset, registry) {
		this.loadAssets(asset, (err2, result) => {
			if (err2) {
				registry.fire("error", asset);
				registry.fire(`error:${asset.id}`, err2, asset);
				asset.fire("error", asset);
			}
		});
	}
	// get the list of dependent asset ids for the cubemap
	getAssetIds(cubemapAsset) {
		const result = [];
		result[0] = cubemapAsset.file;
		if ((cubemapAsset.loadFaces || !cubemapAsset.file) && cubemapAsset.data && cubemapAsset.data.textures) {
			for (let i2 = 0; i2 < 6; ++i2) {
				result[i2 + 1] = cubemapAsset.data.textures[i2];
			}
		} else {
			result[1] = result[2] = result[3] = result[4] = result[5] = result[6] = null;
		}
		return result;
	}
	// test whether two assets ids are the same
	compareAssetIds(assetIdA, assetIdB) {
		if (assetIdA && assetIdB) {
			if (parseInt(assetIdA, 10) === assetIdA || typeof assetIdA === "string") {
				return assetIdA === assetIdB;
			}
			return assetIdA.url === assetIdB.url;
		}
		return assetIdA !== null === (assetIdB !== null);
	}
	// update the cubemap resources given a newly loaded set of assets with their corresponding ids
	update(cubemapAsset, assetIds, assets) {
		const assetData = cubemapAsset.data || {};
		const oldAssets = cubemapAsset._handlerState.assets;
		const oldResources = cubemapAsset._resources;
		let tex, mip, i2;
		const resources = [null, null, null, null, null, null, null];
		const getType = function() {
			if (assetData.hasOwnProperty("type")) {
				return assetData.type;
			}
			if (assetData.hasOwnProperty("rgbm")) {
				return assetData.rgbm ? TEXTURETYPE_RGBM : TEXTURETYPE_DEFAULT;
			}
			return null;
		};
		if (!cubemapAsset.loaded || assets[0] !== oldAssets[0]) {
			if (assets[0]) {
				tex = assets[0].resource;
				if (tex.cubemap) {
					for (i2 = 0; i2 < 6; ++i2) {
						resources[i2 + 1] = new Texture(this._device, {
							name: `${cubemapAsset.name}_prelitCubemap${tex.width >> i2}`,
							cubemap: true,
							// assume prefiltered data has same encoding as the faces asset
							type: getType() || tex.type,
							width: tex.width >> i2,
							height: tex.height >> i2,
							format: tex.format,
							levels: [tex._levels[i2]],
							addressU: ADDRESS_CLAMP_TO_EDGE,
							addressV: ADDRESS_CLAMP_TO_EDGE,
							// generate cubemaps on the top level only
							mipmaps: i2 === 0
						});
					}
				} else {
					resources[1] = tex;
				}
			}
		} else {
			resources[1] = oldResources[1] || null;
			resources[2] = oldResources[2] || null;
			resources[3] = oldResources[3] || null;
			resources[4] = oldResources[4] || null;
			resources[5] = oldResources[5] || null;
			resources[6] = oldResources[6] || null;
		}
		const faceAssets = assets.slice(1);
		if (!cubemapAsset.loaded || !this.cmpArrays(faceAssets, oldAssets.slice(1))) {
			if (faceAssets.indexOf(null) === -1) {
				const faceTextures = faceAssets.map((asset) => {
					return asset.resource;
				});
				const faceLevels = [];
				for (mip = 0; mip < faceTextures[0]._levels.length; ++mip) {
					faceLevels.push(faceTextures.map((faceTexture) => {
						return faceTexture._levels[mip];
					}));
				}
				const format = faceTextures[0].format;
				const faces = new Texture(this._device, {
					name: `${cubemapAsset.name}_faces`,
					cubemap: true,
					type: getType() || faceTextures[0].type,
					width: faceTextures[0].width,
					height: faceTextures[0].height,
					format: format === PIXELFORMAT_RGB8 ? PIXELFORMAT_RGBA8 : format,
					mipmaps: assetData.mipmaps ?? true,
					levels: faceLevels,
					minFilter: assetData.hasOwnProperty("minFilter") ? assetData.minFilter : faceTextures[0].minFilter,
					magFilter: assetData.hasOwnProperty("magFilter") ? assetData.magFilter : faceTextures[0].magFilter,
					anisotropy: assetData.hasOwnProperty("anisotropy") ? assetData.anisotropy : 1,
					addressU: ADDRESS_CLAMP_TO_EDGE,
					addressV: ADDRESS_CLAMP_TO_EDGE
				});
				resources[0] = faces;
			}
		} else {
			resources[0] = oldResources[0] || null;
		}
		if (!this.cmpArrays(resources, oldResources)) {
			cubemapAsset.resources = resources;
			cubemapAsset._handlerState.assetIds = assetIds;
			cubemapAsset._handlerState.assets = assets;
			for (i2 = 0; i2 < oldResources.length; ++i2) {
				if (oldResources[i2] !== null && resources.indexOf(oldResources[i2]) === -1) {
					oldResources[i2].destroy();
				}
			}
		}
		for (i2 = 0; i2 < oldAssets.length; ++i2) {
			if (oldAssets[i2] !== null && assets.indexOf(oldAssets[i2]) === -1) {
				oldAssets[i2].unload();
			}
		}
	}
	cmpArrays(arr1, arr2) {
		if (arr1.length !== arr2.length) {
			return false;
		}
		for (let i2 = 0; i2 < arr1.length; ++i2) {
			if (arr1[i2] !== arr2[i2]) {
				return false;
			}
		}
		return true;
	}
	// convert string id to int
	resolveId(value) {
		const valueInt = parseInt(value, 10);
		return valueInt === value || valueInt.toString() === value ? valueInt : value;
	}
	loadAssets(cubemapAsset, callback) {
		if (!cubemapAsset.hasOwnProperty("_handlerState")) {
			cubemapAsset._handlerState = {
				// the list of requested asset ids in order of [prelit cubemap, 6 faces]
				assetIds: [null, null, null, null, null, null, null],
				// the dependent (loaded, active) texture assets
				assets: [null, null, null, null, null, null, null]
			};
		}
		const self2 = this;
		const assetIds = self2.getAssetIds(cubemapAsset);
		const assets = [null, null, null, null, null, null, null];
		const loadedAssetIds = cubemapAsset._handlerState.assetIds;
		const loadedAssets = cubemapAsset._handlerState.assets;
		const registry = self2._registry;
		let awaiting = 7;
		const onLoad = function(index, asset) {
			assets[index] = asset;
			awaiting--;
			if (awaiting === 0) {
				self2.update(cubemapAsset, assetIds, assets);
				callback(null, cubemapAsset.resources);
			}
		};
		const onError = function(index, err2, asset) {
			callback(err2);
		};
		const processTexAsset = function(index, texAsset2) {
			if (texAsset2.loaded && texAsset2.resource && !texAsset2.resource.device) {
				texAsset2.unload();
			}
			if (texAsset2.loaded) {
				onLoad(index, texAsset2);
			} else {
				registry.once(`load:${texAsset2.id}`, onLoad.bind(self2, index));
				registry.once(`error:${texAsset2.id}`, onError.bind(self2, index));
				if (!texAsset2.loading) {
					registry.load(texAsset2);
				}
			}
		};
		let texAsset;
		for (let i2 = 0; i2 < 7; ++i2) {
			const assetId = this.resolveId(assetIds[i2]);
			if (!assetId) {
				onLoad(i2, null);
			} else if (self2.compareAssetIds(assetId, loadedAssetIds[i2])) {
				processTexAsset(i2, loadedAssets[i2]);
			} else if (parseInt(assetId, 10) === assetId) {
				texAsset = registry.get(assetId);
				if (texAsset) {
					processTexAsset(i2, texAsset);
				} else {
					setTimeout(((index, assetId_) => {
						const texAsset2 = registry.get(assetId_);
						if (texAsset2) {
							processTexAsset(index, texAsset2);
						} else {
							onError(index, `failed to find dependent cubemap asset=${assetId_}`);
						}
					}).bind(null, i2, assetId));
				}
			} else {
				const file = typeof assetId === "string" ? {
					url: assetId,
					filename: assetId
				} : assetId;
				const data2 = file.url.search(".dds") === -1 ? {
					type: "rgbp",
					addressu: "clamp",
					addressv: "clamp",
					mipmaps: false
				} : null;
				texAsset = new Asset(`${cubemapAsset.name}_part_${i2}`, "texture", file, data2);
				registry.add(texAsset);
				processTexAsset(i2, texAsset);
			}
		}
	}
};

var FolderHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "folder");
	}
	load(url, callback) {
		callback(null, null);
	}
};

var Font = class {
	constructor(textures, data2) {
		this.type = data2 ? data2.type || FONT_MSDF : FONT_MSDF;
		this.em = 1;
		this.textures = textures;
		this.intensity = 0;
		this._loader = null;
		this._data = null;
		this.data = data2;
	}
	destroy() {
		const textures = this.textures;
		if (textures) {
			for (let i2 = 0; i2 < textures.length; i2++) {
				const texture = textures[i2];
				this._loader?.clearCache(texture.name, "texture");
				texture.destroy();
			}
			this.textures = null;
		}
		this._loader = null;
		this._data = null;
	}
	set data(value) {
		this._data = value;
		if (!value) {
			return;
		}
		if (this._data.intensity !== void 0) {
			this.intensity = this._data.intensity;
		}
		if (!this._data.info) {
			this._data.info = {};
		}
		if (!this._data.version || this._data.version < 2) {
			this._data.info.maps = [{
				width: this._data.info.width,
				height: this._data.info.height
			}];
			if (this._data.chars) {
				for (const key in this._data.chars) {
					this._data.chars[key].map = 0;
				}
			}
		}
	}
	get data() {
		return this._data;
	}
};

function upgradeDataSchema(data2) {
	if (data2.version < 3) {
		if (data2.version < 2) {
			data2.info.maps = data2.info.maps || [{
				width: data2.info.width,
				height: data2.info.height
			}];
		}
		data2.chars = Object.keys(data2.chars || {}).reduce((newChars, key) => {
			const existing = data2.chars[key];
			const newKey = existing.letter !== void 0 ? existing.letter : string.fromCodePoint(key);
			if (data2.version < 2) {
				existing.map = existing.map || 0;
			}
			newChars[newKey] = existing;
			return newChars;
		}, {});
		data2.version = 3;
	}
	return data2;
}
var FontHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "font");
		this._loader = app2.loader;
		this.maxRetries = 0;
	}
	load(url, callback, asset) {
		if (typeof url === "string") {
			url = {
				load: url,
				original: url
			};
		}
		const self2 = this;
		if (path.getExtension(url.original) === ".json") {
			http.get(url.load, {
				retry: this.maxRetries > 0,
				maxRetries: this.maxRetries
			}, (err2, response) => {
				if (!err2) {
					const data2 = upgradeDataSchema(response);
					self2._loadTextures(url.load.replace(".json", ".png"), data2, (err3, textures) => {
						if (err3) {
							callback(err3);
						} else {
							callback(null, {
								data: data2,
								textures
							});
						}
					});
				} else {
					callback(`Error loading font resource: ${url.original} [${err2}]`);
				}
			});
		} else {
			if (asset && asset.data) {
				asset.data = upgradeDataSchema(asset.data);
			}
			this._loadTextures(url.load, asset && asset.data, callback);
		}
	}
	_loadTextures(url, data2, callback) {
		const numTextures = data2.info.maps.length;
		let numLoaded = 0;
		let error = null;
		const textures = new Array(numTextures);
		const loader = this._loader;
		const isMsdf = !data2.type || data2.type === FONT_MSDF;
		const textureOptions = isMsdf ? { texture: { mipmaps: false, minFilter: FILTER_LINEAR } } : null;
		const loadTexture = function(index) {
			const onLoaded = function(err2, texture) {
				if (error) return;
				if (err2) {
					error = err2;
					callback(err2);
					return;
				}
				texture.upload();
				textures[index] = texture;
				numLoaded++;
				if (numLoaded === numTextures) {
					callback(null, textures);
				}
			};
			const pageUrl = index === 0 ? url : url.replace(".png", `${index}.png`);
			const pageAsset = textureOptions ? new Asset(pageUrl, "texture", { url: pageUrl }, null, textureOptions) : null;
			loader.load(pageUrl, "texture", onLoaded, pageAsset);
		};
		for (let i2 = 0; i2 < numTextures; i2++) {
			loadTexture(i2);
		}
	}
	open(url, data2, asset) {
		let font;
		if (data2.textures) {
			font = new Font(data2.textures, data2.data);
		} else {
			font = new Font(data2, null);
		}
		font._loader = this._loader;
		return font;
	}
	patch(asset, assets) {
		const font = asset.resource;
		if (!font.data && asset.data) {
			font.data = asset.data;
		} else if (!asset.data && font.data) {
			asset.data = font.data;
		}
		if (asset.data) {
			asset.data = upgradeDataSchema(asset.data);
		}
	}
};

var GSplatAssetLoaderBase = class {
	load(url) {
	}
	unload(url) {
	}
	getResource(url) {
	}
	destroy() {
	}
};

var GSplatAssetLoader = class extends GSplatAssetLoaderBase {
	_urlToAsset = /* @__PURE__ */ new Map();
	_registry;
	maxConcurrentLoads = 2;
	maxRetries = 2;
	_currentlyLoading = /* @__PURE__ */ new Set();
	_loadQueue = [];
	_retryCount = /* @__PURE__ */ new Map();
	_failed = /* @__PURE__ */ new Set();
	_destroyed = false;
	constructor(registry) {
		super();
		this._registry = registry;
	}
	destroy() {
		this._destroyed = true;
		for (const asset of this._urlToAsset.values()) {
			asset.fire("unload", asset);
			asset.off("load");
			asset.off("error");
			this._registry.remove(asset);
			asset.unload();
		}
		this._urlToAsset.clear();
		this._loadQueue.length = 0;
		this._currentlyLoading.clear();
		this._retryCount.clear();
		this._failed.clear();
	}
	_canLoad() {
		return !!this._registry.loader?.getHandler("gsplat");
	}
	load(url) {
		const asset = this._urlToAsset.get(url);
		if (asset && asset.loaded && !asset.resource && !this._currentlyLoading.has(url) && !this._failed.has(url)) {
			asset.loaded = false;
		}
		if (asset?.loaded || this._currentlyLoading.has(url)) {
			return;
		}
		if (this._loadQueue.includes(url)) {
			return;
		}
		if (this._currentlyLoading.size < this.maxConcurrentLoads) {
			this._startLoading(url);
		} else {
			this._loadQueue.push(url);
		}
	}
	_startLoading(url) {
		this._currentlyLoading.add(url);
		let asset = this._urlToAsset.get(url);
		if (!asset) {
			asset = new Asset(url, "gsplat", { url });
			this._registry.add(asset);
			this._urlToAsset.set(url, asset);
		}
		asset.once("load", () => this._onAssetLoadSuccess(url, asset));
		asset.once("error", (err2) => this._onAssetLoadError(url, asset, err2));
		if (!asset.loaded && !asset.loading) {
			this._registry.load(asset);
		}
	}
	_onAssetLoadSuccess(url, asset) {
		if (this._destroyed || !this._urlToAsset.has(url)) {
			return;
		}
		this._currentlyLoading.delete(url);
		this._retryCount.delete(url);
		this._processQueue();
	}
	_onAssetLoadError(url, asset, err2) {
		if (this._destroyed || !this._canLoad() || !this._urlToAsset.has(url)) {
			return;
		}
		const retryCount = this._retryCount.get(url) || 0;
		if (retryCount < this.maxRetries) {
			this._retryCount.set(url, retryCount + 1);
			asset.loaded = false;
			asset.loading = false;
			asset.once("error", (retryErr) => this._onAssetLoadError(url, asset, retryErr));
			this._registry.load(asset);
		} else {
			this._currentlyLoading.delete(url);
			this._retryCount.delete(url);
			this._failed.add(url);
			this._processQueue();
		}
	}
	_processQueue() {
		if (this._destroyed || !this._canLoad()) {
			return;
		}
		while (this._currentlyLoading.size < this.maxConcurrentLoads && this._loadQueue.length > 0) {
			const url = this._loadQueue.shift();
			if (url) {
				this._startLoading(url);
			}
		}
	}
	unload(url) {
		this._currentlyLoading.delete(url);
		const queueIndex = this._loadQueue.indexOf(url);
		if (queueIndex !== -1) {
			this._loadQueue.splice(queueIndex, 1);
		}
		this._retryCount.delete(url);
		this._failed.delete(url);
		const asset = this._urlToAsset.get(url);
		if (asset) {
			asset.fire("unload", asset);
			asset.off("load");
			asset.off("error");
			this._registry.remove(asset);
			asset.unload();
			this._urlToAsset.delete(url);
		}
		this._processQueue();
	}
	getResource(url) {
		const asset = this._urlToAsset.get(url);
		return asset?.resource;
	}
	hasFailed(url) {
		return this._failed.has(url);
	}
};

var GSplatOctreeParser = class {
	app;
	constructor(app2) {
		this.app = app2;
	}
	canParse(context) {
		return context.basename === "lod-meta.json";
	}
	load(url, callback, asset) {
		if (typeof url === "string") {
			url = {
				load: url,
				original: url
			};
		}
		const options2 = {
			retry: this.handler.maxRetries > 0,
			maxRetries: this.handler.maxRetries,
			responseType: Http.ResponseType.JSON
		};
		http.get(url.load, options2, (err2, data2) => {
			if (!err2) {
				const assetLoader = new GSplatAssetLoader(this.app.assets);
				const resource = new GSplatOctreeResource(asset.file.url, data2, assetLoader);
				callback(null, resource);
			} else {
				callback(`Error loading gsplat octree: ${url.original} [${err2}]`);
			}
		});
	}
};

var SH_C03 = 0.28209479177387814;
var SplatCompressedIterator = class {
	constructor(gsplatData, p, r, s2, c2, sh) {
		const unpackUnorm = (value, bits) => {
			const t = (1 << bits) - 1;
			return (value & t) / t;
		};
		const unpack111011 = (result, value) => {
			result.x = unpackUnorm(value >>> 21, 11);
			result.y = unpackUnorm(value >>> 11, 10);
			result.z = unpackUnorm(value, 11);
		};
		const unpack8888 = (result, value) => {
			result.x = unpackUnorm(value >>> 24, 8);
			result.y = unpackUnorm(value >>> 16, 8);
			result.z = unpackUnorm(value >>> 8, 8);
			result.w = unpackUnorm(value, 8);
		};
		const unpackRot = (result, value) => {
			const norm = Math.SQRT2;
			const a = (unpackUnorm(value >>> 20, 10) - 0.5) * norm;
			const b = (unpackUnorm(value >>> 10, 10) - 0.5) * norm;
			const c3 = (unpackUnorm(value, 10) - 0.5) * norm;
			const m = Math.sqrt(1 - (a * a + b * b + c3 * c3));
			switch (value >>> 30) {
				case 0:
					result.set(a, b, c3, m);
					break;
				case 1:
					result.set(m, b, c3, a);
					break;
				case 2:
					result.set(b, m, c3, a);
					break;
				case 3:
					result.set(b, c3, m, a);
					break;
			}
		};
		const lerp = (a, b, t) => a * (1 - t) + b * t;
		const { chunkData, chunkSize, vertexData, shData0, shData1, shData2, shBands } = gsplatData;
		const shCoeffs = [3, 8, 15][shBands - 1];
		this.read = (i2) => {
			const ci = Math.floor(i2 / 256) * chunkSize;
			if (p) {
				unpack111011(p, vertexData[i2 * 4 + 0]);
				p.x = lerp(chunkData[ci + 0], chunkData[ci + 3], p.x);
				p.y = lerp(chunkData[ci + 1], chunkData[ci + 4], p.y);
				p.z = lerp(chunkData[ci + 2], chunkData[ci + 5], p.z);
			}
			if (r) {
				unpackRot(r, vertexData[i2 * 4 + 1]);
			}
			if (s2) {
				unpack111011(s2, vertexData[i2 * 4 + 2]);
				s2.x = lerp(chunkData[ci + 6], chunkData[ci + 9], s2.x);
				s2.y = lerp(chunkData[ci + 7], chunkData[ci + 10], s2.y);
				s2.z = lerp(chunkData[ci + 8], chunkData[ci + 11], s2.z);
			}
			if (c2) {
				unpack8888(c2, vertexData[i2 * 4 + 3]);
				if (chunkSize > 12) {
					c2.x = lerp(chunkData[ci + 12], chunkData[ci + 15], c2.x);
					c2.y = lerp(chunkData[ci + 13], chunkData[ci + 16], c2.y);
					c2.z = lerp(chunkData[ci + 14], chunkData[ci + 17], c2.z);
				}
			}
			if (sh && shBands > 0) {
				const shData = [shData0, shData1, shData2];
				for (let j = 0; j < 3; ++j) {
					for (let k = 0; k < 15; ++k) {
						sh[j * 15 + k] = k < shCoeffs ? shData[j][i2 * 16 + k] * (8 / 255) - 4 : 0;
					}
				}
			}
		};
	}
};
var GSplatCompressedData = class {
	numSplats;
	comments;
	chunkData;
	vertexData;
	shData0;
	shData1;
	shData2;
	shBands;
	createIter(p, r, s2, c2, sh) {
		return new SplatCompressedIterator(this, p, r, s2, c2, sh);
	}
	calcAabb(result) {
		const { chunkData, numChunks, chunkSize } = this;
		let s2 = Math.exp(Math.max(chunkData[9], chunkData[10], chunkData[11]));
		let mx = chunkData[0] - s2;
		let my = chunkData[1] - s2;
		let mz = chunkData[2] - s2;
		let Mx = chunkData[3] + s2;
		let My = chunkData[4] + s2;
		let Mz = chunkData[5] + s2;
		for (let i2 = 1; i2 < numChunks; ++i2) {
			const off = i2 * chunkSize;
			s2 = Math.exp(Math.max(chunkData[off + 9], chunkData[off + 10], chunkData[off + 11]));
			mx = Math.min(mx, chunkData[off + 0] - s2);
			my = Math.min(my, chunkData[off + 1] - s2);
			mz = Math.min(mz, chunkData[off + 2] - s2);
			Mx = Math.max(Mx, chunkData[off + 3] + s2);
			My = Math.max(My, chunkData[off + 4] + s2);
			Mz = Math.max(Mz, chunkData[off + 5] + s2);
		}
		result.center.set((mx + Mx) * 0.5, (my + My) * 0.5, (mz + Mz) * 0.5);
		result.halfExtents.set((Mx - mx) * 0.5, (My - my) * 0.5, (Mz - mz) * 0.5);
		return true;
	}
	getCenters() {
		const { vertexData, chunkData, numChunks, chunkSize } = this;
		const result = new Float32Array(this.numSplats * 3);
		let mx, my, mz, Mx, My, Mz;
		for (let c2 = 0; c2 < numChunks; ++c2) {
			const off = c2 * chunkSize;
			mx = chunkData[off + 0];
			my = chunkData[off + 1];
			mz = chunkData[off + 2];
			Mx = chunkData[off + 3];
			My = chunkData[off + 4];
			Mz = chunkData[off + 5];
			const end = Math.min(this.numSplats, (c2 + 1) * 256);
			for (let i2 = c2 * 256; i2 < end; ++i2) {
				const p = vertexData[i2 * 4];
				const px = (p >>> 21) / 2047;
				const py = (p >>> 11 & 1023) / 1023;
				const pz = (p & 2047) / 2047;
				result[i2 * 3 + 0] = (1 - px) * mx + px * Mx;
				result[i2 * 3 + 1] = (1 - py) * my + py * My;
				result[i2 * 3 + 2] = (1 - pz) * mz + pz * Mz;
			}
		}
		return result;
	}
	getChunks(result) {
		const { chunkData, numChunks, chunkSize } = this;
		let mx, my, mz, Mx, My, Mz;
		for (let c2 = 0; c2 < numChunks; ++c2) {
			const off = c2 * chunkSize;
			mx = chunkData[off + 0];
			my = chunkData[off + 1];
			mz = chunkData[off + 2];
			Mx = chunkData[off + 3];
			My = chunkData[off + 4];
			Mz = chunkData[off + 5];
			result[c2 * 6 + 0] = mx;
			result[c2 * 6 + 1] = my;
			result[c2 * 6 + 2] = mz;
			result[c2 * 6 + 3] = Mx;
			result[c2 * 6 + 4] = My;
			result[c2 * 6 + 5] = Mz;
		}
	}
	calcFocalPoint(result) {
		const { chunkData, numChunks, chunkSize } = this;
		result.x = 0;
		result.y = 0;
		result.z = 0;
		for (let i2 = 0; i2 < numChunks; ++i2) {
			const off = i2 * chunkSize;
			result.x += chunkData[off + 0] + chunkData[off + 3];
			result.y += chunkData[off + 1] + chunkData[off + 4];
			result.z += chunkData[off + 2] + chunkData[off + 5];
		}
		result.mulScalar(0.5 / numChunks);
	}
	get isCompressed() {
		return true;
	}
	get numChunks() {
		return Math.ceil(this.numSplats / 256);
	}
	get chunkSize() {
		return this.chunkData.length / this.numChunks;
	}
	// decompress into GSplatData
	decompress() {
		const members = [
			"x",
			"y",
			"z",
			"f_dc_0",
			"f_dc_1",
			"f_dc_2",
			"opacity",
			"scale_0",
			"scale_1",
			"scale_2",
			"rot_0",
			"rot_1",
			"rot_2",
			"rot_3"
		];
		const { shBands } = this;
		if (shBands > 0) {
			const shMembers = [];
			for (let i2 = 0; i2 < 45; ++i2) {
				shMembers.push(`f_rest_${i2}`);
			}
			const location = Math.max(...["f_dc_0", "f_dc_1", "f_dc_2"].map((name) => members.indexOf(name)));
			members.splice(location + 1, 0, ...shMembers);
		}
		const data2 = {};
		members.forEach((name) => {
			data2[name] = new Float32Array(this.numSplats);
		});
		const p = new Vec3();
		const r = new Quat();
		const s2 = new Vec3();
		const c2 = new Vec4();
		const sh = shBands > 0 ? new Float32Array(45) : null;
		const iter = this.createIter(p, r, s2, c2, sh);
		for (let i2 = 0; i2 < this.numSplats; ++i2) {
			iter.read(i2);
			data2.x[i2] = p.x;
			data2.y[i2] = p.y;
			data2.z[i2] = p.z;
			data2.rot_1[i2] = r.x;
			data2.rot_2[i2] = r.y;
			data2.rot_3[i2] = r.z;
			data2.rot_0[i2] = r.w;
			data2.scale_0[i2] = s2.x;
			data2.scale_1[i2] = s2.y;
			data2.scale_2[i2] = s2.z;
			data2.f_dc_0[i2] = (c2.x - 0.5) / SH_C03;
			data2.f_dc_1[i2] = (c2.y - 0.5) / SH_C03;
			data2.f_dc_2[i2] = (c2.z - 0.5) / SH_C03;
			data2.opacity[i2] = c2.w <= 0 ? -40 : c2.w >= 1 ? 40 : -Math.log(1 / c2.w - 1);
			if (sh) {
				for (let c3 = 0; c3 < 45; ++c3) {
					data2[`f_rest_${c3}`][i2] = sh[c3];
				}
			}
		}
		return new GSplatData([{
			name: "vertex",
			count: this.numSplats,
			properties: members.map((name) => {
				return {
					name,
					type: "float",
					byteSize: 4,
					storage: data2[name]
				};
			})
		}], this.comments);
	}
};

var strideCopy = (target2, targetStride, src, srcStride, numEntries) => {
	for (let i2 = 0; i2 < numEntries; ++i2) {
		for (let j = 0; j < srcStride; ++j) {
			target2[i2 * targetStride + j] = src[i2 * srcStride + j];
		}
	}
};
var GSplatCompressedResource = class extends GSplatResourceBase {
	constructor(device, gsplatData, options2 = {}) {
		super(device, gsplatData, options2);
		const { chunkData, chunkSize, numChunks, numSplats, vertexData, shBands } = gsplatData;
		this.chunks = new Float32Array(numChunks * 6);
		gsplatData.getChunks(this.chunks);
		const formatStreams = [
			{ name: "packedTexture", format: PIXELFORMAT_RGBA32U }
		];
		if (shBands > 0) {
			formatStreams.push({ name: "shTexture0", format: PIXELFORMAT_RGBA32U });
			formatStreams.push({ name: "shTexture1", format: PIXELFORMAT_RGBA32U });
			formatStreams.push({ name: "shTexture2", format: PIXELFORMAT_RGBA32U });
		}
		this._format = new GSplatFormat(device, formatStreams, {
			readGLSL: '#include "gsplatCompressedVS"',
			readWGSL: '#include "gsplatCompressedVS"'
		});
		this.streams.init(this.format, numSplats);
		const packedTexture = this.streams.getTexture("packedTexture");
		const packedData = packedTexture.lock();
		packedData.set(vertexData);
		packedTexture.unlock();
		if (shBands > 0) {
			const shTexture0 = this.streams.getTexture("shTexture0");
			const shTexture1 = this.streams.getTexture("shTexture1");
			const shTexture2 = this.streams.getTexture("shTexture2");
			const sh0Data = shTexture0.lock();
			sh0Data.set(new Uint32Array(gsplatData.shData0.buffer));
			shTexture0.unlock();
			const sh1Data = shTexture1.lock();
			sh1Data.set(new Uint32Array(gsplatData.shData1.buffer));
			shTexture1.unlock();
			const sh2Data = shTexture2.lock();
			sh2Data.set(new Uint32Array(gsplatData.shData2.buffer));
			shTexture2.unlock();
		}
		const chunkTextureSize = this.evalChunkTextureSize(numChunks);
		const chunkTexture = this.streams.createTexture("chunkTexture", PIXELFORMAT_RGBA32F, chunkTextureSize);
		this.streams.textures.set("chunkTexture", chunkTexture);
		const chunkTextureData = chunkTexture.lock();
		strideCopy(chunkTextureData, 20, chunkData, chunkSize, numChunks);
		if (chunkSize === 12) {
			for (let i2 = 0; i2 < numChunks; ++i2) {
				chunkTextureData[i2 * 20 + 15] = 1;
				chunkTextureData[i2 * 20 + 16] = 1;
				chunkTextureData[i2 * 20 + 17] = 1;
			}
		}
		chunkTexture.unlock();
	}
	destroy() {
		super.destroy();
	}
	configureMaterialDefines(defines) {
		defines.set("SH_BANDS", this.streams.textures.has("shTexture0") ? 3 : 0);
	}
	evalChunkTextureSize(numChunks) {
		const width = Math.ceil(Math.sqrt(numChunks));
		const height = Math.ceil(numChunks / width);
		return new Vec2(width * 5, height);
	}
};

var magicBytes = new Uint8Array([112, 108, 121, 10]);
var endHeaderBytes = new Uint8Array([10, 101, 110, 100, 95, 104, 101, 97, 100, 101, 114, 10]);
var dataTypeMap = /* @__PURE__ */ new Map([
	["char", Int8Array],
	["uchar", Uint8Array],
	["short", Int16Array],
	["ushort", Uint16Array],
	["int", Int32Array],
	["uint", Uint32Array],
	["float", Float32Array],
	["double", Float64Array]
]);
var StreamBuf = class {
	reader;
	progressFunc;
	data;
	view;
	head = 0;
	tail = 0;
	constructor(reader, progressFunc) {
		this.reader = reader;
		this.progressFunc = progressFunc;
	}
	// read the next chunk of data
	async read() {
		const { value, done } = await this.reader.read();
		if (done) {
			throw new Error("Stream finished before end of header");
		}
		this.push(value);
		this.progressFunc?.(value.byteLength);
	}
	// append data to the buffer
	push(data2) {
		if (!this.data) {
			this.data = data2;
			this.view = new DataView(this.data.buffer);
			this.tail = data2.length;
		} else {
			const remaining = this.tail - this.head;
			const newSize = remaining + data2.length;
			if (this.data.length >= newSize) {
				if (this.head > 0) {
					this.data.copyWithin(0, this.head, this.tail);
					this.data.set(data2, remaining);
					this.head = 0;
					this.tail = newSize;
				} else {
					this.data.set(data2, this.tail);
					this.tail += data2.length;
				}
			} else {
				const tmp = new Uint8Array(newSize);
				if (this.head > 0 || this.tail < this.data.length) {
					tmp.set(this.data.subarray(this.head, this.tail), 0);
				} else {
					tmp.set(this.data, 0);
				}
				tmp.set(data2, remaining);
				this.data = tmp;
				this.view = new DataView(this.data.buffer);
				this.head = 0;
				this.tail = newSize;
			}
		}
	}
	// remove the read data from the head of the buffer
	compact() {
		if (this.head > 0) {
			this.data.copyWithin(0, this.head, this.tail);
			this.tail -= this.head;
			this.head = 0;
		}
	}
	get remaining() {
		return this.tail - this.head;
	}
	// helpers for extracting data from head
	getInt8() {
		const result = this.view.getInt8(this.head);
		this.head++;
		return result;
	}
	getUint8() {
		const result = this.view.getUint8(this.head);
		this.head++;
		return result;
	}
	getInt16() {
		const result = this.view.getInt16(this.head, true);
		this.head += 2;
		return result;
	}
	getUint16() {
		const result = this.view.getUint16(this.head, true);
		this.head += 2;
		return result;
	}
	getInt32() {
		const result = this.view.getInt32(this.head, true);
		this.head += 4;
		return result;
	}
	getUint32() {
		const result = this.view.getUint32(this.head, true);
		this.head += 4;
		return result;
	}
	getFloat32() {
		const result = this.view.getFloat32(this.head, true);
		this.head += 4;
		return result;
	}
	getFloat64() {
		const result = this.view.getFloat64(this.head, true);
		this.head += 8;
		return result;
	}
};
var parseHeader = (lines) => {
	const elements = [];
	const comments = [];
	let format;
	for (let i2 = 1; i2 < lines.length; ++i2) {
		const words = lines[i2].split(" ");
		switch (words[0]) {
			case "comment":
				comments.push(words.slice(1).join(" "));
				break;
			case "format":
				format = words[1];
				break;
			case "element":
				elements.push({
					name: words[1],
					count: parseInt(words[2], 10),
					properties: []
				});
				break;
			case "property": {
				if (!dataTypeMap.has(words[1])) {
					throw new Error(`Unrecognized property data type '${words[1]}' in ply header`);
				}
				const element = elements[elements.length - 1];
				element.properties.push({
					type: words[1],
					name: words[2],
					storage: null,
					byteSize: dataTypeMap.get(words[1]).BYTES_PER_ELEMENT
				});
				break;
			}
			default:
				throw new Error(`Unrecognized header value '${words[0]}' in ply header`);
		}
	}
	return { elements, format, comments };
};
var isCompressedPly = (elements) => {
	const chunkProperties = [
		"min_x",
		"min_y",
		"min_z",
		"max_x",
		"max_y",
		"max_z",
		"min_scale_x",
		"min_scale_y",
		"min_scale_z",
		"max_scale_x",
		"max_scale_y",
		"max_scale_z",
		"min_r",
		"min_g",
		"min_b",
		"max_r",
		"max_g",
		"max_b"
	];
	const vertexProperties = [
		"packed_position",
		"packed_rotation",
		"packed_scale",
		"packed_color"
	];
	const shProperties = new Array(45).fill("").map((_, i2) => `f_rest_${i2}`);
	const hasBaseElements = () => {
		return elements[0].name === "chunk" && elements[0].properties.every((p, i2) => p.name === chunkProperties[i2] && p.type === "float") && elements[1].name === "vertex" && elements[1].properties.every((p, i2) => p.name === vertexProperties[i2] && p.type === "uint");
	};
	const hasSHElements = () => {
		return elements[2].name === "sh" && [9, 24, 45].indexOf(elements[2].properties.length) !== -1 && elements[2].properties.every((p, i2) => p.name === shProperties[i2] && p.type === "uchar");
	};
	return elements.length === 2 && hasBaseElements() || elements.length === 3 && hasBaseElements() && hasSHElements();
};
var isFloatPly = (elements) => {
	return elements.length === 1 && elements[0].name === "vertex" && elements[0].properties.every((p) => p.type === "float");
};
var readCompressedPly = async (streamBuf, elements, comments) => {
	const result = new GSplatCompressedData();
	result.comments = comments;
	const numChunks = elements[0].count;
	const numChunkProperties = elements[0].properties.length;
	const numVertices = elements[1].count;
	const evalStorageSize = (count) => {
		const width = Math.ceil(Math.sqrt(count));
		const height = Math.ceil(count / width);
		return width * height;
	};
	const storageSize = evalStorageSize(numVertices);
	result.numSplats = numVertices;
	result.chunkData = new Float32Array(numChunks * numChunkProperties);
	result.vertexData = new Uint32Array(storageSize * 4);
	const read = async (buffer, length) => {
		const target2 = new Uint8Array(buffer);
		let cursor = 0;
		while (cursor < length) {
			while (streamBuf.remaining === 0) {
				await streamBuf.read();
			}
			const toCopy = Math.min(length - cursor, streamBuf.remaining);
			const src = streamBuf.data;
			for (let i2 = 0; i2 < toCopy; ++i2) {
				target2[cursor++] = src[streamBuf.head++];
			}
		}
	};
	await read(result.chunkData.buffer, numChunks * numChunkProperties * 4);
	await read(result.vertexData.buffer, numVertices * 4 * 4);
	if (elements.length === 3) {
		const texStorageSize = storageSize * 16;
		const shData0 = new Uint8Array(texStorageSize);
		const shData1 = new Uint8Array(texStorageSize);
		const shData2 = new Uint8Array(texStorageSize);
		const chunkSize = 1024;
		const srcCoeffs = elements[2].properties.length / 3;
		const tmpBuf = new Uint8Array(chunkSize * srcCoeffs * 3);
		for (let i2 = 0; i2 < result.numSplats; i2 += chunkSize) {
			const toRead = Math.min(chunkSize, result.numSplats - i2);
			await read(tmpBuf.buffer, toRead * srcCoeffs * 3);
			for (let j = 0; j < toRead; ++j) {
				for (let k = 0; k < 15; ++k) {
					const tidx = (i2 + j) * 16 + k;
					if (k < srcCoeffs) {
						shData0[tidx] = tmpBuf[(j * 3 + 0) * srcCoeffs + k];
						shData1[tidx] = tmpBuf[(j * 3 + 1) * srcCoeffs + k];
						shData2[tidx] = tmpBuf[(j * 3 + 2) * srcCoeffs + k];
					} else {
						shData0[tidx] = 127;
						shData1[tidx] = 127;
						shData2[tidx] = 127;
					}
				}
			}
		}
		result.shData0 = shData0;
		result.shData1 = shData1;
		result.shData2 = shData2;
		result.shBands = { 3: 1, 8: 2, 15: 3 }[srcCoeffs];
	} else {
		result.shBands = 0;
	}
	return result;
};
var readFloatPly = async (streamBuf, elements, comments) => {
	const element = elements[0];
	const properties = element.properties;
	const numProperties = properties.length;
	const storage = properties.map((p) => p.storage);
	const inputSize = properties.reduce((a, p) => a + p.byteSize, 0);
	let vertexIdx = 0;
	let floatData;
	const checkFloatData = () => {
		const buffer = streamBuf.data.buffer;
		if (floatData?.buffer !== buffer) {
			floatData = new Float32Array(buffer, 0, buffer.byteLength / 4);
		}
	};
	checkFloatData();
	while (vertexIdx < element.count) {
		while (streamBuf.remaining < inputSize) {
			await streamBuf.read();
			checkFloatData();
		}
		const toRead = Math.min(element.count - vertexIdx, Math.floor(streamBuf.remaining / inputSize));
		for (let j = 0; j < numProperties; ++j) {
			const s2 = storage[j];
			for (let n = 0; n < toRead; ++n) {
				s2[n + vertexIdx] = floatData[n * numProperties + j];
			}
		}
		vertexIdx += toRead;
		streamBuf.head += toRead * inputSize;
	}
	return new GSplatData(elements, comments);
};
var readGeneralPly = async (streamBuf, elements, comments) => {
	for (let i2 = 0; i2 < elements.length; ++i2) {
		const element = elements[i2];
		const inputSize = element.properties.reduce((a, p) => a + p.byteSize, 0);
		const propertyParsingFunctions = element.properties.map((p) => {
			if (p.storage) {
				switch (p.type) {
					case "char":
						return (streamBuf2, c3) => {
							p.storage[c3] = streamBuf2.getInt8();
						};
					case "uchar":
						return (streamBuf2, c3) => {
							p.storage[c3] = streamBuf2.getUint8();
						};
					case "short":
						return (streamBuf2, c3) => {
							p.storage[c3] = streamBuf2.getInt16();
						};
					case "ushort":
						return (streamBuf2, c3) => {
							p.storage[c3] = streamBuf2.getUint16();
						};
					case "int":
						return (streamBuf2, c3) => {
							p.storage[c3] = streamBuf2.getInt32();
						};
					case "uint":
						return (streamBuf2, c3) => {
							p.storage[c3] = streamBuf2.getUint32();
						};
					case "float":
						return (streamBuf2, c3) => {
							p.storage[c3] = streamBuf2.getFloat32();
						};
					case "double":
						return (streamBuf2, c3) => {
							p.storage[c3] = streamBuf2.getFloat64();
						};
					default:
						throw new Error(`Unsupported property data type '${p.type}' in ply header`);
				}
			} else {
				return (streamBuf2) => {
					streamBuf2.head += p.byteSize;
				};
			}
		});
		let c2 = 0;
		while (c2 < element.count) {
			while (streamBuf.remaining < inputSize) {
				await streamBuf.read();
			}
			const toRead = Math.min(element.count - c2, Math.floor(streamBuf.remaining / inputSize));
			for (let n = 0; n < toRead; ++n) {
				for (let j = 0; j < element.properties.length; ++j) {
					propertyParsingFunctions[j](streamBuf, c2);
				}
				c2++;
			}
		}
	}
	return new GSplatData(elements, comments);
};
var readPly = async (reader, propertyFilter = null, progressFunc = null) => {
	const find = (buf, search) => {
		const endIndex = buf.length - search.length;
		let i2, j;
		for (i2 = 0; i2 <= endIndex; ++i2) {
			for (j = 0; j < search.length; ++j) {
				if (buf[i2 + j] !== search[j]) {
					break;
				}
			}
			if (j === search.length) {
				return i2;
			}
		}
		return -1;
	};
	const startsWith2 = (a, b) => {
		if (a.length < b.length) {
			return false;
		}
		for (let i2 = 0; i2 < b.length; ++i2) {
			if (a[i2] !== b[i2]) {
				return false;
			}
		}
		return true;
	};
	const streamBuf = new StreamBuf(reader, progressFunc);
	let headerLength;
	while (true) {
		await streamBuf.read();
		if (streamBuf.tail >= magicBytes.length && !startsWith2(streamBuf.data, magicBytes)) {
			throw new Error("Invalid ply header");
		}
		headerLength = find(streamBuf.data, endHeaderBytes);
		if (headerLength !== -1) {
			break;
		}
	}
	const lines = new TextDecoder("ascii").decode(streamBuf.data.subarray(0, headerLength)).split("\n");
	const { elements, format, comments } = parseHeader(lines);
	if (format !== "binary_little_endian") {
		throw new Error("Unsupported ply format");
	}
	streamBuf.head = headerLength + endHeaderBytes.length;
	streamBuf.compact();
	const readData = async () => {
		if (isCompressedPly(elements)) {
			return await readCompressedPly(streamBuf, elements, comments);
		}
		elements.forEach((e) => {
			e.properties.forEach((p) => {
				const storageType = dataTypeMap.get(p.type);
				if (storageType) {
					const storage = !propertyFilter || propertyFilter(p.name) ? new storageType(e.count) : null;
					p.storage = storage;
				}
			});
		});
		if (isFloatPly(elements)) {
			return await readFloatPly(streamBuf, elements, comments);
		}
		return await readGeneralPly(streamBuf, elements, comments);
	};
	return await readData();
};
var defaultElementFilter = (val) => true;
var PlyParser = class {
	app;
	constructor(app2) {
		this.app = app2;
	}
	canParse(context) {
		return context.ext === "ply";
	}
	async load(url, callback, asset) {
		const gsplatCentersEnabledAtLoad = this.app.scene?.gsplatCentersEnabled !== false;
		try {
			const response = await (asset.file?.contents ?? fetch(url.load));
			if (!response || !response.body) {
				callback("Error loading resource", null);
			} else {
				const totalLength = parseInt(response.headers.get("content-length") ?? "0", 10);
				let totalReceived = 0;
				const data2 = await readPly(
					response.body.getReader(),
					asset.data.elementFilter ?? defaultElementFilter,
					(bytes) => {
						totalReceived += bytes;
						if (asset) {
							asset.fire("progress", totalReceived, totalLength);
						}
					}
				);
				asset.fire("load:data", data2);
				if (!data2.isCompressed) {
					if (asset.data.reorder ?? true) {
						data2.reorderData();
					}
				}
				const prepareCenters = gsplatCentersEnabledAtLoad;
				const resource = data2.isCompressed && !asset.data.decompress ? new GSplatCompressedResource(this.app.graphicsDevice, data2, { prepareCenters }) : new GSplatResource(this.app.graphicsDevice, data2.isCompressed ? data2.decompress() : data2, { prepareCenters });
				callback(null, resource);
			}
		} catch (err2) {
			callback(err2, null);
		}
	}
	open(url, data2) {
		return data2;
	}
};

var parseZipArchive = (data2) => {
	const dataView = new DataView(data2);
	const u162 = (offset4) => dataView.getUint16(offset4, true);
	const u32 = (offset4) => dataView.getUint32(offset4, true);
	const extractEocd = (offset4) => {
		return {
			magic: u32(offset4),
			numFiles: u162(offset4 + 8),
			cdSizeBytes: u32(offset4 + 12),
			cdOffsetBytes: u32(offset4 + 16)
		};
	};
	const extractCdr = (offset4) => {
		const filenameLength = u162(offset4 + 28);
		const extraFieldLength = u162(offset4 + 30);
		const fileCommentLength = u162(offset4 + 32);
		return {
			magic: u32(offset4),
			compressionMethod: u162(offset4 + 10),
			compressedSizeBytes: u32(offset4 + 20),
			uncompressedSizeBytes: u32(offset4 + 24),
			lfhOffsetBytes: u32(offset4 + 42),
			filename: new TextDecoder().decode(new Uint8Array(data2, offset4 + 46, filenameLength)),
			recordSizeBytes: 46 + filenameLength + extraFieldLength + fileCommentLength
		};
	};
	const extractLfh = (offset4) => {
		const filenameLength = u162(offset4 + 26);
		const extraLength = u162(offset4 + 28);
		return {
			magic: u32(offset4),
			offsetBytes: offset4 + 30 + filenameLength + extraLength
		};
	};
	const eocd = extractEocd(dataView.byteLength - 22);
	if (eocd.magic !== 101010256) {
		throw new Error("Invalid zip file: EOCDR not found");
	}
	if (eocd.cdOffsetBytes === 4294967295 || eocd.cdSizeBytes === 4294967295) {
		throw new Error("Invalid zip file: Zip64 not supported");
	}
	const result = [];
	let offset3 = eocd.cdOffsetBytes;
	for (let i2 = 0; i2 < eocd.numFiles; i2++) {
		const cdr = extractCdr(offset3);
		if (cdr.magic !== 33639248) {
			throw new Error("Invalid zip file: CDR not found");
		}
		const lfh = extractLfh(cdr.lfhOffsetBytes);
		if (lfh.magic !== 67324752) {
			throw new Error("Invalid zip file: LFH not found");
		}
		result.push({
			filename: cdr.filename,
			compression: { 0: "none", 8: "deflate" }[cdr.compressionMethod] ?? "unknown",
			data: new Uint8Array(data2, lfh.offsetBytes, cdr.compressedSizeBytes)
		});
		offset3 += cdr.recordSizeBytes;
	}
	return result;
};
var inflate = async (compressed) => {
	const ds = new DecompressionStream("deflate-raw");
	const out = new Blob([compressed]).stream().pipeThrough(ds);
	const ab = await new Response(out).arrayBuffer();
	return new Uint8Array(ab);
};
var downloadArrayBuffer = async (url, asset) => {
	const response = await (asset.file?.contents ?? fetch(url.load));
	if (!response) {
		throw new Error("Error loading resource");
	}
	if (response instanceof Response) {
		if (!response.ok) {
			throw new Error(`Error loading resource: ${response.status} ${response.statusText}`);
		}
		const totalLength = parseInt(response.headers.get("content-length") ?? "0", 10);
		if (!response.body || !response.body.getReader) {
			const buf = await response.arrayBuffer();
			asset.fire("progress", buf.byteLength, totalLength);
			return buf;
		}
		const reader = response.body.getReader();
		const chunks = [];
		let totalReceived = 0;
		try {
			while (true) {
				const { done, value } = await reader.read();
				if (done) {
					break;
				}
				chunks.push(value);
				totalReceived += value.byteLength;
				asset.fire("progress", totalReceived, totalLength);
			}
		} finally {
			reader.releaseLock();
		}
		return new Blob(chunks).arrayBuffer();
	}
	return response;
};
var SogBundleParser = class {
	app;
	constructor(app2) {
		this.app = app2;
	}
	canParse(context) {
		return context.ext === "sog";
	}
	_shouldAbort(asset, unloaded) {
		if (unloaded || !this.app.assets.get(asset.id)) return true;
		if (!this.app?.graphicsDevice || this.app.graphicsDevice._destroyed) return true;
		return false;
	}
	async load(url, callback, asset) {
		const gsplatCentersEnabledAtLoad = this.app.scene?.gsplatCentersEnabled !== false;
		try {
			const { assets } = this.app;
			let unloaded = false;
			let ownedByResource = false;
			const textures = {};
			asset.once("unload", () => {
				unloaded = true;
				Object.values(textures).forEach((t) => {
					assets.remove(t);
					if (!ownedByResource) {
						t.unload();
					} else {
						assets._loader.clearCache(t.getFileUrl(), t.type);
					}
				});
			});
			const arrayBuffer = await downloadArrayBuffer(url, asset);
			if (this._shouldAbort(asset, unloaded)) {
				callback(null, null);
				return;
			}
			const files = parseZipArchive(arrayBuffer);
			for (const file of files) {
				if (file.compression === "deflate") {
					file.data = await inflate(file.data);
				}
			}
			const metaFile = files.find((f) => f.filename === "meta.json");
			if (!metaFile) {
				callback("Error: meta.json not found");
				return;
			}
			let meta;
			try {
				meta = JSON.parse(new TextDecoder().decode(metaFile.data));
			} catch (err2) {
				callback(`Error parsing meta.json: ${err2}`);
				return;
			}
			const filenames = ["means", "scales", "quats", "sh0", "shN"].map((key) => meta[key]?.files ?? []).flat();
			const promises = [];
			for (const filename of filenames) {
				const file = files.find((f) => f.filename === filename);
				let texture;
				if (file) {
					texture = new Asset(filename, "texture", {
						url: `${url.load}/${filename}`,
						filename,
						contents: file.data
					}, {
						mipmaps: false
					}, {
						crossOrigin: "anonymous"
					});
				} else {
					const url2 = new URL(filename, new URL(filename, window.location.href).toString()).toString();
					texture = new Asset(filename, "texture", {
						url: url2,
						filename
					}, {
						mipmaps: false
					}, {
						crossOrigin: "anonymous"
					});
				}
				const promise = new Promise((resolve2, reject) => {
					texture.on("load", () => resolve2(null));
					texture.on("error", (err2) => reject(err2));
				});
				this.app.assets.add(texture);
				textures[filename] = texture;
				promises.push(promise);
			}
			Object.values(textures).forEach((t) => this.app.assets.load(t));
			await Promise.allSettled(promises);
			if (this._shouldAbort(asset, unloaded)) {
				Object.values(textures).forEach((t) => {
					assets.remove(t);
					t.unload();
				});
				callback(null, null);
				return;
			}
			Object.values(textures).forEach((t) => {
				if (t.file) {
					t.file.contents = null;
				}
			});
			const decompress = asset.data?.decompress;
			const data2 = new GSplatSogData();
			data2.url = url.original;
			data2.meta = meta;
			data2.numSplats = meta.count;
			data2.means_l = textures[meta.means.files[0]].resource;
			data2.means_u = textures[meta.means.files[1]].resource;
			data2.quats = textures[meta.quats.files[0]].resource;
			data2.scales = textures[meta.scales.files[0]].resource;
			data2.sh0 = textures[meta.sh0.files[0]].resource;
			data2.sh_centroids = textures[meta.shN?.files[0]]?.resource;
			data2.sh_labels = textures[meta.shN?.files[1]]?.resource;
			data2.shBands = GSplatSogData.calcBands(data2.sh_centroids?.width);
			if (!decompress) {
				if (this._shouldAbort(asset, unloaded)) {
					data2.destroy();
					callback(null, null);
					return;
				}
				data2.prepareCodebook();
				if (gsplatCentersEnabledAtLoad) {
					await data2.prepareGpuData();
				}
			}
			if (this._shouldAbort(asset, unloaded)) {
				data2.destroy();
				callback(null, null);
				return;
			}
			const prepareCenters = gsplatCentersEnabledAtLoad;
			const resource = decompress ? new GSplatResource(this.app.graphicsDevice, await data2.decompress(), { prepareCenters }) : new GSplatSogResource(this.app.graphicsDevice, data2, { prepareCenters });
			ownedByResource = !decompress;
			if (this._shouldAbort(asset, unloaded)) {
				resource.destroy();
				callback(null, null);
				return;
			}
			callback(null, resource);
		} catch (err2) {
			callback(err2);
		}
	}
};

var combineProgress = (target2, assets) => {
	const map = /* @__PURE__ */ new Map();
	const count = assets.length;
	const fire = () => {
		let loaded = 0;
		let total = 0;
		map.forEach((value) => {
			loaded += value.loaded;
			total += value.total;
		});
		const reporting = map.size;
		if (reporting > 0 && reporting < count) {
			total = Math.ceil(total * count / reporting);
		}
		target2.fire("progress", loaded, total);
	};
	assets.forEach((asset) => {
		const progress = (loaded, total) => {
			map.set(asset, { loaded, total });
			fire();
		};
		const done = () => {
			asset.off("progress", progress);
			asset.off("load", done);
			asset.off("error", done);
		};
		asset.on("progress", progress);
		asset.on("load", done);
		asset.on("error", done);
	});
};
var upgradeMeta = (meta) => {
	const result = {
		version: 1,
		count: meta.means.shape[0],
		means: {
			mins: meta.means.mins,
			maxs: meta.means.maxs,
			files: meta.means.files
		},
		scales: {
			mins: meta.scales.mins,
			maxs: meta.scales.maxs,
			files: meta.scales.files
		},
		quats: {
			files: meta.quats.files
		},
		sh0: {
			mins: meta.sh0.mins,
			maxs: meta.sh0.maxs,
			files: meta.sh0.files
		}
	};
	if (meta.shN) {
		result.shN = {
			mins: meta.shN.mins,
			maxs: meta.shN.maxs,
			files: meta.shN.files
		};
	}
	return result;
};
var SogParser = class {
	app;
	constructor(app2) {
		this.app = app2;
	}
	canParse(context) {
		return context.ext === "json";
	}
	_shouldAbort(asset, unloaded) {
		if (unloaded || !this.app.assets.get(asset.id)) return true;
		if (!this.app?.graphicsDevice || this.app.graphicsDevice._destroyed) return true;
		return false;
	}
	async loadTextures(url, callback, asset, meta) {
		const gsplatCentersEnabledAtLoad = this.app.scene?.gsplatCentersEnabled !== false;
		if (meta.version !== 2) {
			meta = upgradeMeta(meta);
		}
		const { assets } = this.app;
		const subs = ["means", "quats", "scales", "sh0", "shN"];
		const textures = {};
		const promises = [];
		const base = window.document?.baseURI ?? window.location.href;
		subs.forEach((sub) => {
			const files = meta[sub]?.files ?? [];
			textures[sub] = files.map((filename) => {
				const texture = new Asset(filename, "texture", {
					url: asset.options?.mapUrl?.(filename) ?? new URL(filename, new URL(url.load, base).toString()).toString(),
					filename
				}, {
					mipmaps: false
				}, {
					crossOrigin: "anonymous"
				});
				const promise = new Promise((resolve2, reject) => {
					texture.on("load", () => resolve2(null));
					texture.on("error", (err2) => reject(err2));
				});
				assets.add(texture);
				promises.push(promise);
				return texture;
			});
		});
		const textureAssets = subs.map((sub) => textures[sub]).flat();
		let unloaded = false;
		let ownedByResource = false;
		asset.once("unload", () => {
			unloaded = true;
			textureAssets.forEach((t) => {
				assets.remove(t);
				if (!ownedByResource) {
					t.unload();
				} else {
					assets._loader.clearCache(t.getFileUrl(), t.type);
				}
			});
		});
		combineProgress(asset, textureAssets);
		textureAssets.forEach((t) => assets.load(t));
		await Promise.allSettled(promises);
		if (this._shouldAbort(asset, unloaded)) {
			textureAssets.forEach((t) => {
				assets.remove(t);
				t.unload();
			});
			callback(null, null);
			return;
		}
		const data2 = new GSplatSogData();
		data2.url = url.original;
		data2.meta = meta;
		data2.numSplats = meta.count;
		data2.means_l = textures.means[0].resource;
		data2.means_u = textures.means[1].resource;
		data2.quats = textures.quats[0].resource;
		data2.scales = textures.scales[0].resource;
		data2.sh0 = textures.sh0[0].resource;
		data2.sh_centroids = textures.shN?.[0]?.resource;
		data2.sh_labels = textures.shN?.[1]?.resource;
		data2.shBands = GSplatSogData.calcBands(data2.sh_centroids?.width);
		const decompress = asset.data?.decompress;
		if (!decompress) {
			if (this._shouldAbort(asset, unloaded)) {
				data2.destroy();
				callback(null, null);
				return;
			}
			data2.prepareCodebook();
			if (gsplatCentersEnabledAtLoad) {
				await data2.prepareGpuData();
			}
		}
		if (this._shouldAbort(asset, unloaded)) {
			data2.destroy();
			callback(null, null);
			return;
		}
		const prepareCenters = gsplatCentersEnabledAtLoad;
		const resource = decompress ? new GSplatResource(this.app.graphicsDevice, await data2.decompress(), { prepareCenters }) : new GSplatSogResource(this.app.graphicsDevice, data2, { prepareCenters });
		ownedByResource = !decompress;
		if (this._shouldAbort(asset, unloaded)) {
			resource.destroy();
			callback(null, null);
			return;
		}
		callback(null, resource);
	}
	load(url, callback, asset) {
		if (asset.data?.means) {
			this.loadTextures(url, callback, asset, asset.data);
		} else {
			if (typeof url === "string") {
				url = {
					load: url,
					original: url
				};
			}
			const options2 = {
				retry: this.handler.maxRetries > 0,
				maxRetries: this.handler.maxRetries,
				responseType: Http.ResponseType.JSON
			};
			http.get(url.load, options2, (err2, meta) => {
				if (this._shouldAbort(asset, false)) {
					callback(null, null);
					return;
				}
				if (!err2) {
					this.loadTextures(url, callback, asset, meta);
				} else {
					callback(`Error loading gsplat meta: ${url.original} [${err2}]`);
				}
			});
		}
	}
};

var GSplatHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "gsplat");
		this.addParser(new PlyParser(app2));
		this.addParser(new SogBundleParser(app2));
		this.addParser(new SogParser(app2));
		this.addParser(new GSplatOctreeParser(app2));
	}
};

var CompressUtils = class {
	static setCompressedPRS(entity, data2, compressed) {
		const a = compressed.singleVecs;
		let b, i2;
		const v6 = data2.___1;
		if (!v6) {
			b = compressed.tripleVecs;
			i2 = data2.___2;
		}
		let n = v6 ? v6[0] : b[i2];
		entity.setLocalPosition(a[n], a[n + 1], a[n + 2]);
		n = v6 ? v6[1] : b[i2 + 1];
		entity.setLocalEulerAngles(a[n], a[n + 1], a[n + 2]);
		n = v6 ? v6[2] : b[i2 + 2];
		entity.setLocalScale(a[n], a[n + 1], a[n + 2]);
	}
	static oneCharToKey(s2, data2) {
		const i2 = s2.charCodeAt(0) - data2.fieldFirstCode;
		return data2.fieldArray[i2];
	}
	static multCharToKey(s2, data2) {
		let ind = 0;
		for (let i2 = 0; i2 < s2.length; i2++) {
			ind = ind * data2.fieldCodeBase + s2.charCodeAt(i2) - data2.fieldFirstCode;
		}
		return data2.fieldArray[ind];
	}
};

var Decompress = class _Decompress {
	constructor(node, data2) {
		this._node = node;
		this._data = data2;
	}
	run() {
		const type = Object.prototype.toString.call(this._node);
		if (type === "[object Object]") {
			this._handleMap();
		} else if (type === "[object Array]") {
			this._handleArray();
		} else {
			this._result = this._node;
		}
		return this._result;
	}
	_handleMap() {
		this._result = {};
		const a = Object.keys(this._node);
		a.forEach(this._handleKey, this);
	}
	_handleKey(origKey) {
		let newKey = origKey;
		const len = origKey.length;
		if (len === 1) {
			newKey = CompressUtils.oneCharToKey(origKey, this._data);
		} else if (len === 2) {
			newKey = CompressUtils.multCharToKey(origKey, this._data);
		}
		this._result[newKey] = new _Decompress(this._node[origKey], this._data).run();
	}
	_handleArray() {
		this._result = [];
		this._node.forEach(this._handleArElt, this);
	}
	_handleArElt(elt) {
		const v6 = new _Decompress(elt, this._data).run();
		this._result.push(v6);
	}
};

var SceneParser = class {
	constructor(app2, isTemplate) {
		this._app = app2;
		this._isTemplate = isTemplate;
	}
	parse(data2) {
		const entities = {};
		let parent = null;
		const compressed = data2.compressedFormat;
		if (compressed && !data2.entDecompressed) {
			data2.entDecompressed = true;
			data2.entities = new Decompress(data2.entities, compressed).run();
		}
		for (const id14 in data2.entities) {
			const curData = data2.entities[id14];
			const curEnt = this._createEntity(curData, compressed);
			entities[id14] = curEnt;
			if (curData.parent === null) {
				parent = curEnt;
			}
		}
		for (const id14 in data2.entities) {
			const curEnt = entities[id14];
			const children = data2.entities[id14].children;
			const len = children.length;
			for (let i2 = 0; i2 < len; i2++) {
				const childEnt = entities[children[i2]];
				if (childEnt) {
					curEnt.addChild(childEnt);
				}
			}
		}
		this._openComponentData(parent, data2.entities);
		return parent;
	}
	_createEntity(data2, compressed) {
		const entity = new Entity(data2.name, this._app);
		entity.guid = data2.resource_id;
		this._setPosRotScale(entity, data2, compressed);
		entity._enabled = data2.enabled ?? true;
		if (this._isTemplate) {
			entity._template = true;
		} else {
			entity._enabledInHierarchy = entity._enabled;
		}
		entity.template = data2.template;
		if (data2.tags) {
			for (let i2 = 0; i2 < data2.tags.length; i2++) {
				entity.tags.add(data2.tags[i2]);
			}
		}
		return entity;
	}
	_setPosRotScale(entity, data2, compressed) {
		if (compressed) {
			CompressUtils.setCompressedPRS(entity, data2, compressed);
		} else {
			const p = data2.position;
			const r = data2.rotation;
			const s2 = data2.scale;
			entity.setLocalPosition(p[0], p[1], p[2]);
			entity.setLocalEulerAngles(r[0], r[1], r[2]);
			entity.setLocalScale(s2[0], s2[1], s2[2]);
		}
	}
	_openComponentData(entity, entities) {
		const systemsList = this._app.systems.list;
		let len = systemsList.length;
		const entityData = entities[entity.guid];
		for (let i2 = 0; i2 < len; i2++) {
			const system = systemsList[i2];
			const componentData = entityData.components[system.id];
			if (componentData) {
				system.addComponent(entity, componentData);
			}
		}
		len = entityData.children.length;
		const children = entity._children;
		for (let i2 = 0; i2 < len; i2++) {
			if (children[i2]) {
				children[i2] = this._openComponentData(children[i2], entities);
			} else {
			}
		}
		return entity;
	}
};

var SceneUtils = class {
	static load(url, maxRetries, callback) {
		if (typeof url === "string") {
			url = {
				load: url,
				original: url
			};
		}
		http.get(url.load, {
			retry: maxRetries > 0,
			maxRetries
		}, (err2, response) => {
			if (!err2) {
				callback(err2, response);
			} else {
				let errMsg = `Error while loading scene JSON ${url.original}`;
				if (err2.message) {
					errMsg += `: ${err2.message}`;
					if (err2.stack) {
						errMsg += `
${err2.stack}`;
					}
				} else {
					errMsg += `: ${err2}`;
				}
				callback(errMsg);
			}
		});
	}
};

var HierarchyHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "hierarchy");
	}
	load(url, callback) {
		SceneUtils.load(url, this.maxRetries, callback);
	}
	open(url, data2) {
		this._app.systems.script.preloading = true;
		const parser = new SceneParser(this._app, false);
		const parent = parser.parse(data2);
		this._app.systems.script.preloading = false;
		return parent;
	}
};

var HtmlHandler = class extends ResourceHandler {
	decoder = null;
	constructor(app2) {
		super(app2, "html");
		this.addParser(new TextParser());
	}
	openBinary(data2) {
		this.decoder ?? (this.decoder = new TextDecoder("utf-8"));
		return this.decoder.decode(data2);
	}
};

var JsonParser = class {
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		const original = typeof url === "string" ? url : url.original;
		this.handler.fetch(url, Http.ResponseType.JSON, (err2, response) => {
			if (err2) {
				callback(`Error loading JSON resource: ${original} [${err2}]`);
			} else {
				callback(null, response);
			}
		}, asset);
	}
};

var JsonHandler = class extends ResourceHandler {
	decoder = null;
	constructor(app2) {
		super(app2, "json");
		this.addParser(new JsonParser());
	}
	openBinary(data2) {
		this.decoder ?? (this.decoder = new TextDecoder("utf-8"));
		return JSON.parse(this.decoder.decode(data2));
	}
};

var StandardMaterialValidator = class {
	constructor() {
		this.removeInvalid = true;
		this.valid = true;
		this.enumValidators = {
			occludeSpecular: this._createEnumValidator([
				SPECOCC_NONE,
				SPECOCC_AO,
				SPECOCC_GLOSSDEPENDENT
			]),
			cull: this._createEnumValidator([
				CULLFACE_NONE,
				CULLFACE_BACK,
				CULLFACE_FRONT,
				CULLFACE_FRONTANDBACK
			]),
			blendType: this._createEnumValidator([
				BLEND_SUBTRACTIVE,
				BLEND_ADDITIVE,
				BLEND_NORMAL,
				BLEND_NONE,
				BLEND_PREMULTIPLIED,
				BLEND_MULTIPLICATIVE,
				BLEND_ADDITIVEALPHA,
				BLEND_MULTIPLICATIVE2X,
				BLEND_SCREEN,
				BLEND_MIN,
				BLEND_MAX
			]),
			depthFunc: this._createEnumValidator([
				FUNC_NEVER,
				FUNC_LESS,
				FUNC_EQUAL,
				FUNC_LESSEQUAL,
				FUNC_GREATER,
				FUNC_NOTEQUAL,
				FUNC_GREATEREQUAL,
				FUNC_ALWAYS
			])
		};
	}
	setInvalid(key, data2) {
		this.valid = false;
		if (this.removeInvalid) {
			delete data2[key];
		}
	}
	validate(data2) {
		const TYPES = standardMaterialParameterTypes;
		const REMOVED = standardMaterialRemovedParameters;
		const pathMapping = data2.mappingFormat === "path";
		for (const key in data2) {
			const type = TYPES[key];
			if (!type) {
				if (REMOVED[key]) {
					delete data2[key];
				} else {
					this.valid = false;
				}
				continue;
			}
			if (type.startsWith("enum")) {
				const enumType = type.split(":")[1];
				if (this.enumValidators[enumType]) {
					if (!this.enumValidators[enumType](data2[key])) {
						this.setInvalid(key, data2);
					}
				}
			} else if (type === "number") {
				if (typeof data2[key] !== "number") {
					this.setInvalid(key, data2);
				}
			} else if (type === "boolean") {
				if (typeof data2[key] !== "boolean") {
					this.setInvalid(key, data2);
				}
			} else if (type === "string") {
				if (typeof data2[key] !== "string") {
					this.setInvalid(key, data2);
				}
			} else if (type === "vec2") {
				if (!(data2[key] instanceof Array && data2[key].length === 2)) {
					this.setInvalid(key, data2);
				}
			} else if (type === "rgb") {
				if (!(data2[key] instanceof Array && data2[key].length === 3)) {
					this.setInvalid(key, data2);
				}
			} else if (type === "texture") {
				if (!pathMapping) {
					if (!(typeof data2[key] === "number" || data2[key] === null)) {
						if (!(data2[key] instanceof Texture)) {
							this.setInvalid(key, data2);
						}
					}
				} else {
					if (!(typeof data2[key] === "string" || data2[key] === null)) {
						if (!(data2[key] instanceof Texture)) {
							this.setInvalid(key, data2);
						}
					}
				}
			} else if (type === "boundingbox") {
				if (!(data2[key].center && data2[key].center instanceof Array && data2[key].center.length === 3)) {
					this.setInvalid(key, data2);
				}
				if (!(data2[key].halfExtents && data2[key].halfExtents instanceof Array && data2[key].halfExtents.length === 3)) {
					this.setInvalid(key, data2);
				}
			} else if (type === "cubemap") {
				if (!(typeof data2[key] === "number" || data2[key] === null || data2[key] === void 0)) {
					if (!(data2[key] instanceof Texture && data2[key].cubemap)) {
						this.setInvalid(key, data2);
					}
				}
			} else if (type === "chunks") {
				const chunkNames = Object.keys(data2[key]);
				for (let i2 = 0; i2 < chunkNames.length; i2++) {
					if (typeof data2[key][chunkNames[i2]] !== "string") {
						this.setInvalid(chunkNames[i2], data2[key]);
					}
				}
			} else {
				console.error(`Unknown material type: ${type}`);
			}
		}
		data2.validated = true;
		return this.valid;
	}
	_createEnumValidator(values) {
		return function(value) {
			return values.indexOf(value) >= 0;
		};
	}
};

var JsonStandardMaterialParser = class {
	constructor() {
		this._validator = null;
	}
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		this.handler.fetch(url, Http.ResponseType.JSON, (err2, response) => {
			if (err2) {
				callback(`Error loading material: ${url.original} [${err2}]`);
			} else {
				response._engine = true;
				callback(null, response);
			}
		}, asset);
	}
	open(url, data2) {
		const material = this.parse(data2);
		if (data2._engine) {
			material._data = data2;
			delete data2._engine;
		}
		return material;
	}
	parse(input) {
		const migrated = this.migrate(input);
		const validated = this._validate(migrated);
		const material = new StandardMaterial();
		this.initialize(material, validated);
		return material;
	}
	initialize(material, data2) {
		if (!data2.validated) {
			data2 = this._validate(data2);
		}
		if (data2.chunks) {
			if (data2.chunks && Object.keys(data2.chunks).length > 0) {
				const dstMap = material.shaderChunks.glsl;
				Object.entries(data2.chunks).forEach(([key, value]) => dstMap.set(key, value));
			}
		}
		for (const key in data2) {
			const type = standardMaterialParameterTypes[key];
			const value = data2[key];
			if (type === "vec2") {
				material[key] = new Vec2(value[0], value[1]);
			} else if (type === "rgb") {
				material[key] = new Color(value[0], value[1], value[2]);
			} else if (type === "texture") {
				if (value instanceof Texture) {
					material[key] = value;
				} else if (!(material[key] instanceof Texture && typeof value === "number" && value > 0)) {
					material[key] = null;
				}
			} else if (type === "cubemap") {
				if (value instanceof Texture) {
					material[key] = value;
				} else if (!(material[key] instanceof Texture && typeof value === "number" && value > 0)) {
					material[key] = null;
				}
				if (key === "cubeMap" && !value) {
					material.prefilteredCubemaps = null;
				}
			} else if (type === "boundingbox") {
				const center2 = new Vec3(value.center[0], value.center[1], value.center[2]);
				const halfExtents = new Vec3(value.halfExtents[0], value.halfExtents[1], value.halfExtents[2]);
				material[key] = new BoundingBox(center2, halfExtents);
			} else {
				material[key] = data2[key];
			}
		}
		material.update();
	}
	// convert any properties that are out of date
	// or from old versions into current version
	migrate(data2) {
		if (data2.shader) delete data2.shader;
		if (data2.mapping_format) {
			data2.mappingFormat = data2.mapping_format;
			delete data2.mapping_format;
		}
		let i2;
		const RENAMED_PROPERTIES = [
			["bumpMapFactor", "bumpiness"],
			["aoUvSet", "aoMapUv"],
			["aoMapVertexColor", "aoVertexColor"],
			["diffuseMapVertexColor", "diffuseVertexColor"],
			["emissiveMapVertexColor", "emissiveVertexColor"],
			["specularMapVertexColor", "specularVertexColor"],
			["metalnessMapVertexColor", "metalnessVertexColor"],
			["opacityMapVertexColor", "opacityVertexColor"],
			["glossMapVertexColor", "glossVertexColor"],
			["lightMapVertexColor", "lightVertexColor"],
			["specularMapTint", "specularTint"],
			["metalnessMapTint", "metalnessTint"],
			["clearCoatGlossiness", "clearCoatGloss"]
		];
		for (i2 = 0; i2 < RENAMED_PROPERTIES.length; i2++) {
			const _old = RENAMED_PROPERTIES[i2][0];
			const _new = RENAMED_PROPERTIES[i2][1];
			if (data2[_old] !== void 0) {
				if (data2[_new] === void 0) {
					data2[_new] = data2[_old];
				}
				delete data2[_old];
			}
		}
		const DEPRECATED_PROPERTIES = [
			"fresnelFactor",
			"shadowSampleType"
		];
		for (i2 = 0; i2 < DEPRECATED_PROPERTIES.length; i2++) {
			const name = DEPRECATED_PROPERTIES[i2];
			if (data2.hasOwnProperty(name)) {
				delete data2[name];
			}
		}
		return data2;
	}
	// check for invalid properties
	_validate(data2) {
		if (!data2.validated) {
			if (!this._validator) {
				this._validator = new StandardMaterialValidator();
			}
			this._validator.validate(data2);
		}
		return data2;
	}
};

var PLACEHOLDER_MAP = {
	aoMap: "white",
	aoDetailMap: "white",
	diffuseMap: "gray",
	diffuseDetailMap: "gray",
	specularMap: "gray",
	specularityFactorMap: "white",
	metalnessMap: "black",
	glossMap: "gray",
	sheenMap: "black",
	sheenGlossMap: "gray",
	clearCoatMap: "black",
	clearCoatGlossMap: "gray",
	clearCoatNormalMap: "normal",
	refractionMap: "white",
	emissiveMap: "gray",
	normalMap: "normal",
	normalDetailMap: "normal",
	heightMap: "gray",
	opacityMap: "gray",
	sphereMap: "gray",
	lightMap: "white",
	thicknessMap: "black",
	iridescenceMap: "black",
	iridescenceThicknessMap: "black",
	envAtlas: "black",
	anisotropyMap: "black"
};
var MaterialHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "material");
		this._assets = app2.assets;
		this._device = app2.graphicsDevice;
		this._parser = new JsonStandardMaterialParser();
		this.addParser(this._parser);
	}
	patch(asset, assets) {
		if (!(asset.resource instanceof StandardMaterial)) {
			return;
		}
		if (asset.resource._data) {
			asset._data = asset.resource._data;
			delete asset.resource._data;
		}
		asset.data.name = asset.name;
		asset.resource.name = asset.name;
		this._bindAndAssignAssets(asset, assets);
		asset.off("unload", this._onAssetUnload, this);
		asset.on("unload", this._onAssetUnload, this);
	}
	_onAssetUnload(asset) {
		delete asset.data.parameters;
		delete asset.data.chunks;
		delete asset.data.name;
	}
	_assignTexture(parameterName, materialAsset, texture) {
		materialAsset.resource[parameterName] = texture;
	}
	// returns the correct placeholder texture for the texture parameter
	_getPlaceholderTexture(parameterName) {
		const placeholder = PLACEHOLDER_MAP[parameterName];
		return getBuiltInTexture(this._device, placeholder);
	}
	// assign a placeholder texture while waiting for one to load
	_assignPlaceholderTexture(parameterName, materialAsset) {
		materialAsset.resource[parameterName] = this._getPlaceholderTexture(parameterName);
	}
	_onTextureLoad(parameterName, materialAsset, textureAsset) {
		this._assignTexture(parameterName, materialAsset, textureAsset.resource);
		materialAsset.resource.update();
	}
	_onTextureAdd(parameterName, materialAsset, textureAsset) {
		this._assets.load(textureAsset);
	}
	_onTextureRemoveOrUnload(parameterName, materialAsset, textureAsset) {
		const material = materialAsset.resource;
		if (material) {
			if (materialAsset.resource[parameterName] === textureAsset.resource) {
				this._assignPlaceholderTexture(parameterName, materialAsset);
				material.update();
			}
		}
	}
	_assignCubemap(parameterName, materialAsset, textures) {
		materialAsset.resource[parameterName] = textures[0];
		if (parameterName === "cubeMap") {
			const prefiltered = textures.slice(1);
			if (prefiltered.every((t) => t)) {
				materialAsset.resource.prefilteredCubemaps = prefiltered;
			} else if (prefiltered[0]) {
				materialAsset.resource.envAtlas = prefiltered[0];
			}
		}
	}
	_onCubemapLoad(parameterName, materialAsset, cubemapAsset) {
		this._assignCubemap(parameterName, materialAsset, cubemapAsset.resources);
		this._parser.initialize(materialAsset.resource, materialAsset.data);
	}
	_onCubemapAdd(parameterName, materialAsset, cubemapAsset) {
		this._assets.load(cubemapAsset);
	}
	_onCubemapRemoveOrUnload(parameterName, materialAsset, cubemapAsset) {
		const material = materialAsset.resource;
		if (materialAsset.data.prefilteredCubeMap128 === cubemapAsset.resources[1]) {
			this._assignCubemap(parameterName, materialAsset, [null, null, null, null, null, null, null]);
			material.update();
		}
	}
	_bindAndAssignAssets(materialAsset, assets) {
		const data2 = this._parser.migrate(materialAsset.data);
		const material = materialAsset.resource;
		const pathMapping = data2.mappingFormat === "path";
		const TEXTURES = standardMaterialTextureParameters;
		let i2, name, assetReference;
		for (i2 = 0; i2 < TEXTURES.length; i2++) {
			name = TEXTURES[i2];
			assetReference = material._assetReferences[name];
			const dataAssetId = data2[name];
			const materialTexture = material[name];
			const isPlaceHolderTexture = materialTexture === this._getPlaceholderTexture(name);
			const dataValidated = data2.validated;
			if (dataAssetId && (!materialTexture || !dataValidated || isPlaceHolderTexture)) {
				if (!assetReference) {
					assetReference = new AssetReference(name, materialAsset, assets, {
						load: this._onTextureLoad,
						add: this._onTextureAdd,
						remove: this._onTextureRemoveOrUnload,
						unload: this._onTextureRemoveOrUnload
					}, this);
					material._assetReferences[name] = assetReference;
				}
				if (pathMapping) {
					assetReference.url = materialAsset.getAbsoluteUrl(dataAssetId);
				} else {
					assetReference.id = dataAssetId;
				}
				if (assetReference.asset) {
					if (assetReference.asset.resource) {
						this._assignTexture(name, materialAsset, assetReference.asset.resource);
					} else {
						this._assignPlaceholderTexture(name, materialAsset);
					}
					assets.load(assetReference.asset);
				}
			} else {
				if (assetReference) {
					if (pathMapping) {
						assetReference.url = null;
					} else {
						assetReference.id = null;
					}
				} else {
				}
			}
		}
		const CUBEMAPS = standardMaterialCubemapParameters;
		for (i2 = 0; i2 < CUBEMAPS.length; i2++) {
			name = CUBEMAPS[i2];
			assetReference = material._assetReferences[name];
			if (data2[name] && !materialAsset.data.prefilteredCubeMap128) {
				if (!assetReference) {
					assetReference = new AssetReference(name, materialAsset, assets, {
						load: this._onCubemapLoad,
						add: this._onCubemapAdd,
						remove: this._onCubemapRemoveOrUnload,
						unload: this._onCubemapRemoveOrUnload
					}, this);
					material._assetReferences[name] = assetReference;
				}
				if (pathMapping) {
					assetReference.url = data2[name];
				} else {
					assetReference.id = data2[name];
				}
				if (assetReference.asset) {
					if (assetReference.asset.loaded) {
						this._assignCubemap(name, materialAsset, assetReference.asset.resources);
					}
					assets.load(assetReference.asset);
				}
			}
		}
		this._parser.initialize(material, data2);
	}
};

var GlbModelParser = class {
	constructor(modelHandler) {
		this._device = modelHandler.device;
		this._defaultMaterial = modelHandler.defaultMaterial;
		this._assets = modelHandler.assets;
	}
	canParse(context) {
		return context.ext === "glb";
	}
	load(url, callback, asset) {
		this.handler.fetch(url, Http.ResponseType.ARRAY_BUFFER, (err2, data2) => {
			if (err2) {
				callback(err2);
			} else {
				this.parse(data2, callback, asset);
			}
		}, asset);
	}
	parse(data2, callback, asset) {
		GlbParser.parse("filename.glb", "", data2, this._device, this._assets, asset?.options ?? {}, (err2, result) => {
			if (err2) {
				callback(err2);
			} else {
				const model = GlbContainerResource.createModel(result, this._defaultMaterial);
				result.destroy();
				callback(null, model);
			}
		});
	}
};

var JSON_PRIMITIVE_TYPE = {
	"points": PRIMITIVE_POINTS,
	"lines": PRIMITIVE_LINES,
	"lineloop": PRIMITIVE_LINELOOP,
	"linestrip": PRIMITIVE_LINESTRIP,
	"triangles": PRIMITIVE_TRIANGLES,
	"trianglestrip": PRIMITIVE_TRISTRIP,
	"trianglefan": PRIMITIVE_TRIFAN
};
var JSON_VERTEX_ELEMENT_TYPE = {
	"int8": TYPE_INT8,
	"uint8": TYPE_UINT8,
	"int16": TYPE_INT16,
	"uint16": TYPE_UINT16,
	"int32": TYPE_INT32,
	"uint32": TYPE_UINT32,
	"float32": TYPE_FLOAT32
};
var JsonModelParser = class {
	constructor(modelHandler) {
		this._device = modelHandler.device;
		this._defaultMaterial = modelHandler.defaultMaterial;
	}
	canParse(context) {
		return context.ext === "json";
	}
	load(url, callback, asset) {
		this.handler.fetch(url, Http.ResponseType.JSON, (err2, response) => {
			if (err2) {
				callback(err2);
			} else {
				this.parse(response, callback);
			}
		}, asset);
	}
	parse(data2, callback) {
		const modelData = data2.model;
		if (!modelData) {
			callback(null, null);
			return;
		}
		if (modelData.version <= 1) {
			callback("JsonModelParser#parse: Trying to parse unsupported model format.");
			return;
		}
		const nodes = this._parseNodes(data2);
		const skins = this._parseSkins(data2, nodes);
		const vertexBuffers = this._parseVertexBuffers(data2);
		const indices = this._parseIndexBuffers(data2, vertexBuffers);
		const morphs = this._parseMorphs(data2, nodes, vertexBuffers);
		const meshes = this._parseMeshes(data2, skins.skins, morphs.morphs, vertexBuffers, indices.buffer, indices.data);
		const meshInstances = this._parseMeshInstances(data2, nodes, meshes, skins.skins, skins.instances, morphs.morphs, morphs.instances);
		const model = new Model();
		model.graph = nodes[0];
		model.meshInstances = meshInstances;
		model.skinInstances = skins.instances;
		model.morphInstances = morphs.instances;
		model.getGraph().syncHierarchy();
		callback(null, model);
	}
	_parseNodes(data2) {
		const modelData = data2.model;
		const nodes = [];
		let i2;
		for (i2 = 0; i2 < modelData.nodes.length; i2++) {
			const nodeData = modelData.nodes[i2];
			const node = new GraphNode(nodeData.name);
			node.setLocalPosition(nodeData.position[0], nodeData.position[1], nodeData.position[2]);
			node.setLocalEulerAngles(nodeData.rotation[0], nodeData.rotation[1], nodeData.rotation[2]);
			node.setLocalScale(nodeData.scale[0], nodeData.scale[1], nodeData.scale[2]);
			node.scaleCompensation = !!nodeData.scaleCompensation;
			nodes.push(node);
		}
		for (i2 = 1; i2 < modelData.parents.length; i2++) {
			nodes[modelData.parents[i2]].addChild(nodes[i2]);
		}
		return nodes;
	}
	_parseSkins(data2, nodes) {
		const modelData = data2.model;
		const skins = [];
		const skinInstances = [];
		let i2, j;
		for (i2 = 0; i2 < modelData.skins.length; i2++) {
			const skinData = modelData.skins[i2];
			const inverseBindMatrices = [];
			for (j = 0; j < skinData.inverseBindMatrices.length; j++) {
				const ibm = skinData.inverseBindMatrices[j];
				inverseBindMatrices[j] = new Mat4().set(ibm);
			}
			const skin = new Skin(this._device, inverseBindMatrices, skinData.boneNames);
			skins.push(skin);
			const skinInstance = new SkinInstance(skin);
			const bones = [];
			for (j = 0; j < skin.boneNames.length; j++) {
				const boneName = skin.boneNames[j];
				const bone = nodes[0].findByName(boneName);
				bones.push(bone);
			}
			skinInstance.bones = bones;
			skinInstances.push(skinInstance);
		}
		return {
			skins,
			instances: skinInstances
		};
	}
	// find number of vertices used by a mesh that is using morph target with index morphIndex
	_getMorphVertexCount(modelData, morphIndex, vertexBuffers) {
		for (let i2 = 0; i2 < modelData.meshes.length; i2++) {
			const meshData = modelData.meshes[i2];
			if (meshData.morph === morphIndex) {
				const vertexBuffer = vertexBuffers[meshData.vertices];
				return vertexBuffer.numVertices;
			}
		}
		return void 0;
	}
	_parseMorphs(data2, nodes, vertexBuffers) {
		const modelData = data2.model;
		const morphs = [];
		const morphInstances = [];
		let i2, j, vertexCount;
		let targets, morphTarget, morphTargetArray;
		if (modelData.morphs) {
			const sparseToFull = function(data3, indices, totalCount) {
				const full = new Float32Array(totalCount * 3);
				for (let s2 = 0; s2 < indices.length; s2++) {
					const dstIndex = indices[s2] * 3;
					full[dstIndex] = data3[s2 * 3];
					full[dstIndex + 1] = data3[s2 * 3 + 1];
					full[dstIndex + 2] = data3[s2 * 3 + 2];
				}
				return full;
			};
			for (i2 = 0; i2 < modelData.morphs.length; i2++) {
				targets = modelData.morphs[i2].targets;
				morphTargetArray = [];
				vertexCount = this._getMorphVertexCount(modelData, i2, vertexBuffers);
				for (j = 0; j < targets.length; j++) {
					const targetAabb = targets[j].aabb;
					const min = targetAabb.min;
					const max = targetAabb.max;
					const aabb3 = new BoundingBox(
						new Vec3((max[0] + min[0]) * 0.5, (max[1] + min[1]) * 0.5, (max[2] + min[2]) * 0.5),
						new Vec3((max[0] - min[0]) * 0.5, (max[1] - min[1]) * 0.5, (max[2] - min[2]) * 0.5)
					);
					const indices = targets[j].indices;
					let deltaPositions = targets[j].deltaPositions;
					let deltaNormals = targets[j].deltaNormals;
					if (indices) {
						deltaPositions = sparseToFull(deltaPositions, indices, vertexCount);
						deltaNormals = sparseToFull(deltaNormals, indices, vertexCount);
					}
					morphTarget = new MorphTarget({
						deltaPositions,
						deltaNormals,
						name: targets[j].name,
						aabb: aabb3
					});
					morphTargetArray.push(morphTarget);
				}
				const morph = new Morph(morphTargetArray, this._device);
				morphs.push(morph);
				const morphInstance = new MorphInstance(morph);
				morphInstances.push(morphInstance);
			}
		}
		return {
			morphs,
			instances: morphInstances
		};
	}
	_parseVertexBuffers(data2) {
		const modelData = data2.model;
		const vertexBuffers = [];
		const attributeMap = {
			position: SEMANTIC_POSITION,
			normal: SEMANTIC_NORMAL,
			tangent: SEMANTIC_TANGENT,
			blendWeight: SEMANTIC_BLENDWEIGHT,
			blendIndices: SEMANTIC_BLENDINDICES,
			color: SEMANTIC_COLOR,
			texCoord0: SEMANTIC_TEXCOORD0,
			texCoord1: SEMANTIC_TEXCOORD1,
			texCoord2: SEMANTIC_TEXCOORD2,
			texCoord3: SEMANTIC_TEXCOORD3,
			texCoord4: SEMANTIC_TEXCOORD4,
			texCoord5: SEMANTIC_TEXCOORD5,
			texCoord6: SEMANTIC_TEXCOORD6,
			texCoord7: SEMANTIC_TEXCOORD7
		};
		for (let i2 = 0; i2 < modelData.vertices.length; i2++) {
			const vertexData = modelData.vertices[i2];
			const formatDesc = [];
			for (const attributeName in vertexData) {
				const attribute = vertexData[attributeName];
				formatDesc.push({
					semantic: attributeMap[attributeName],
					components: attribute.components,
					type: JSON_VERTEX_ELEMENT_TYPE[attribute.type],
					normalize: attributeMap[attributeName] === SEMANTIC_COLOR
				});
			}
			const vertexFormat = new VertexFormat(this._device, formatDesc);
			const numVertices = vertexData.position.data.length / vertexData.position.components;
			const vertexBuffer = new VertexBuffer(this._device, vertexFormat, numVertices);
			const iterator = new VertexIterator(vertexBuffer);
			for (let j = 0; j < numVertices; j++) {
				for (const attributeName in vertexData) {
					const attribute = vertexData[attributeName];
					switch (attribute.components) {
						case 1:
							iterator.element[attributeMap[attributeName]].set(attribute.data[j]);
							break;
						case 2:
							iterator.element[attributeMap[attributeName]].set(attribute.data[j * 2], 1 - attribute.data[j * 2 + 1]);
							break;
						case 3:
							iterator.element[attributeMap[attributeName]].set(attribute.data[j * 3], attribute.data[j * 3 + 1], attribute.data[j * 3 + 2]);
							break;
						case 4:
							iterator.element[attributeMap[attributeName]].set(attribute.data[j * 4], attribute.data[j * 4 + 1], attribute.data[j * 4 + 2], attribute.data[j * 4 + 3]);
							break;
					}
				}
				iterator.next();
			}
			iterator.end();
			vertexBuffers.push(vertexBuffer);
		}
		return vertexBuffers;
	}
	_parseIndexBuffers(data2, vertexBuffers) {
		const modelData = data2.model;
		let indexBuffer = null;
		let indexData = null;
		let i2;
		let numIndices = 0;
		for (i2 = 0; i2 < modelData.meshes.length; i2++) {
			const meshData = modelData.meshes[i2];
			if (meshData.indices !== void 0) {
				numIndices += meshData.indices.length;
			}
		}
		let maxVerts = 0;
		for (i2 = 0; i2 < vertexBuffers.length; i2++) {
			maxVerts = Math.max(maxVerts, vertexBuffers[i2].numVertices);
		}
		if (numIndices > 0) {
			if (maxVerts > 65535) {
				indexBuffer = new IndexBuffer(this._device, INDEXFORMAT_UINT32, numIndices);
				indexData = new Uint32Array(indexBuffer.lock());
			} else {
				indexBuffer = new IndexBuffer(this._device, INDEXFORMAT_UINT16, numIndices);
				indexData = new Uint16Array(indexBuffer.lock());
			}
		}
		return {
			buffer: indexBuffer,
			data: indexData
		};
	}
	_parseMeshes(data2, skins, morphs, vertexBuffers, indexBuffer, indexData) {
		const modelData = data2.model;
		const meshes = [];
		let indexBase = 0;
		for (let i2 = 0; i2 < modelData.meshes.length; i2++) {
			const meshData = modelData.meshes[i2];
			const meshAabb = meshData.aabb;
			const min = meshAabb.min;
			const max = meshAabb.max;
			const aabb3 = new BoundingBox(
				new Vec3((max[0] + min[0]) * 0.5, (max[1] + min[1]) * 0.5, (max[2] + min[2]) * 0.5),
				new Vec3((max[0] - min[0]) * 0.5, (max[1] - min[1]) * 0.5, (max[2] - min[2]) * 0.5)
			);
			const indexed = meshData.indices !== void 0;
			const mesh = new Mesh(this._device);
			mesh.vertexBuffer = vertexBuffers[meshData.vertices];
			mesh.indexBuffer[0] = indexed ? indexBuffer : null;
			mesh.primitive[0].type = JSON_PRIMITIVE_TYPE[meshData.type];
			mesh.primitive[0].base = indexed ? meshData.base + indexBase : meshData.base;
			mesh.primitive[0].count = meshData.count;
			mesh.primitive[0].indexed = indexed;
			mesh.skin = meshData.skin !== void 0 ? skins[meshData.skin] : null;
			mesh.morph = meshData.morph !== void 0 ? morphs[meshData.morph] : null;
			mesh.aabb = aabb3;
			if (indexed) {
				indexData.set(meshData.indices, indexBase);
				indexBase += meshData.indices.length;
			}
			meshes.push(mesh);
		}
		if (indexBuffer !== null) {
			indexBuffer.unlock();
		}
		return meshes;
	}
	_parseMeshInstances(data2, nodes, meshes, skins, skinInstances, morphs, morphInstances) {
		const modelData = data2.model;
		const meshInstances = [];
		let i2;
		for (i2 = 0; i2 < modelData.meshInstances.length; i2++) {
			const meshInstanceData = modelData.meshInstances[i2];
			const node = nodes[meshInstanceData.node];
			const mesh = meshes[meshInstanceData.mesh];
			const meshInstance = new MeshInstance(mesh, this._defaultMaterial, node);
			if (mesh.skin) {
				const skinIndex = skins.indexOf(mesh.skin);
				meshInstance.skinInstance = skinInstances[skinIndex];
			}
			if (mesh.morph) {
				const morphIndex = morphs.indexOf(mesh.morph);
				meshInstance.morphInstance = morphInstances[morphIndex];
			}
			meshInstances.push(meshInstance);
		}
		return meshInstances;
	}
};

var ModelHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "model");
		this.device = app2.graphicsDevice;
		this.assets = app2.assets;
		this.defaultMaterial = getDefaultMaterial(this.device);
		this.addParser(new JsonModelParser(this));
		this.addParser(new GlbModelParser(this));
	}
	patch(asset, assets) {
		if (!asset.resource) {
			return;
		}
		const data2 = asset.data;
		const self2 = this;
		asset.resource.meshInstances.forEach((meshInstance, i2) => {
			if (data2.mapping) {
				const handleMaterial = function(asset2) {
					if (asset2.resource) {
						meshInstance.material = asset2.resource;
					} else {
						asset2.once("load", handleMaterial);
						assets.load(asset2);
					}
					asset2.once("remove", (asset3) => {
						if (meshInstance.material === asset3.resource) {
							meshInstance.material = self2.defaultMaterial;
						}
					});
				};
				if (!data2.mapping[i2]) {
					meshInstance.material = self2.defaultMaterial;
					return;
				}
				const id14 = data2.mapping[i2].material;
				const url = data2.mapping[i2].path;
				let material;
				if (id14 !== void 0) {
					if (!id14) {
						meshInstance.material = self2.defaultMaterial;
					} else {
						material = assets.get(id14);
						if (material) {
							handleMaterial(material);
						} else {
							assets.once(`add:${id14}`, handleMaterial);
						}
					}
				} else if (url) {
					const path2 = asset.getAbsoluteUrl(data2.mapping[i2].path);
					material = assets.getByUrl(path2);
					if (material) {
						handleMaterial(material);
					} else {
						assets.once(`add:url:${path2}`, handleMaterial);
					}
				}
			}
		});
	}
};

var SceneHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "scene");
	}
	load(url, callback) {
		SceneUtils.load(url, this.maxRetries, callback);
	}
	open(url, data2) {
		this._app.systems.script.preloading = true;
		const parser = new SceneParser(this._app, false);
		const parent = parser.parse(data2);
		const scene = this._app.scene;
		scene.root = parent;
		this._app.applySceneSettings(data2.settings);
		this._app.systems.script.preloading = false;
		return scene;
	}
};

var ScriptTypes = class _ScriptTypes {
	static _types = [];
	static push(Type) {
		_ScriptTypes._types.push(Type);
	}
};

function getReservedScriptNames() {
	return reservedScriptNames;
}
function createScript(name, app2) {
	if (reservedScriptNames.has(name)) {
		throw new Error(`Script name '${name}' is reserved, please rename the script`);
	}
	const scriptType = function(args) {
		EventHandler.prototype.initEventHandler.call(this);
		ScriptType.prototype.initScriptType.call(this, args);
	};
	scriptType.prototype = Object.create(ScriptType.prototype);
	scriptType.prototype.constructor = scriptType;
	scriptType.extend = ScriptType.extend;
	scriptType.attributes = new ScriptAttributes(scriptType);
	registerScript(scriptType, name, app2);
	return scriptType;
}
var reservedAttributes = {};
ScriptAttributes.reservedNames.forEach((value, value2, set) => {
	reservedAttributes[value] = 1;
});
createScript.reservedAttributes = reservedAttributes;
function registerScript(script2, name, app2) {
	if (typeof script2 !== "function") {
		throw new Error(`script class: '${script2}' must be a constructor function (i.e. class).`);
	}
	if (!(script2.prototype instanceof Script)) {
		throw new Error(`script class: '${ScriptType.__getScriptName(script2)}' does not extend Script.`);
	}
	name = name || Object.prototype.hasOwnProperty.call(script2, "__name") && script2.__name || getScriptName(script2);
	if (!name) {
		return;
	}
	if (reservedScriptNames.has(name)) {
		throw new Error(`script name: '${name}' is reserved, please change script name`);
	}
	script2.__name = name;
	const registry = app2 ? app2.scripts : AppBase.getApplication().scripts;
	registry.add(script2);
	ScriptTypes.push(script2);
}

var ScriptHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "script");
		this._scripts = {};
		this._cache = {};
	}
	clearCache() {
		for (const key in this._cache) {
			const element = this._cache[key];
			const parent = element.parentNode;
			if (parent) {
				parent.removeChild(element);
			}
		}
		this._cache = {};
	}
	load(url, callback) {
		if (typeof url === "string") {
			url = {
				load: url,
				original: url
			};
		}
		const self2 = this;
		script.app = this._app;
		const onScriptLoad = (url.load, (err2, url2, extra) => {
			if (!err2) {
				const obj = {};
				for (let i2 = 0; i2 < ScriptTypes._types.length; i2++) {
					obj[ScriptTypes._types[i2].name] = ScriptTypes._types[i2];
				}
				ScriptTypes._types.length = 0;
				callback(null, obj, extra);
				const urlWithoutEndHash = url2.split("&hash=")[0];
				delete self2._loader._cache[ResourceLoader.makeKey(urlWithoutEndHash, "script")];
			} else {
				callback(err2);
			}
		});
		const [basePath] = url.load.split("?");
		const isEsmScript = basePath.endsWith(".mjs");
		if (isEsmScript) {
			this._loadModule(basePath, onScriptLoad);
		} else {
			this._loadScript(url.load, onScriptLoad);
		}
	}
	open(url, data2) {
		return data2;
	}
	patch(asset, assets) {
	}
	_loadScript(url, callback) {
		const head = document.head;
		const element = document.createElement("script");
		this._cache[url] = element;
		element.async = false;
		element.addEventListener("error", (e) => {
			callback(`Script: ${e.target.src} failed to load`);
		}, false);
		let done = false;
		element.onload = element.onreadystatechange = function() {
			if (!done && (!this.readyState || (this.readyState === "loaded" || this.readyState === "complete"))) {
				done = true;
				callback(null, url, element);
			}
		};
		element.src = url;
		head.appendChild(element);
	}
	_loadModule(url, callback) {
		const isBrowserWithOrigin = platform.browser && window.location.origin !== "null";
		const baseUrl = isBrowserWithOrigin ? window.location.origin + window.location.pathname : import.meta.url;
		const importUrl = new URL(url, baseUrl);
		import(
			/* @vite-ignore */
			/* webpackIgnore: true */
			importUrl.toString()
		).then((module2) => {
			const filename = importUrl.pathname.split("/").pop();
			const scriptSchema = this._app.assets.find(filename, "script")?.data?.scripts;
			for (const key in module2) {
				const scriptClass = module2[key];
				const extendsScriptType = scriptClass.prototype instanceof Script;
				if (extendsScriptType) {
					const ownScriptName = Object.prototype.hasOwnProperty.call(scriptClass, "scriptName") && scriptClass.scriptName;
					if (!ownScriptName) {
					}
					const scriptName = getScriptRegistryName(scriptClass);
					if (!scriptName) {
						continue;
					}
					registerScript(scriptClass, scriptName);
					if (scriptSchema) this._app.scripts.addSchema(scriptName, scriptSchema[scriptName]);
				}
			}
			callback(null, url, null);
		}).catch((err2) => {
			callback(err2);
		});
	}
};

var ShaderHandler = class extends ResourceHandler {
	decoder = null;
	constructor(app2) {
		super(app2, "shader");
		this.addParser(new TextParser());
	}
	openBinary(data2) {
		this.decoder ?? (this.decoder = new TextDecoder("utf-8"));
		return this.decoder.decode(data2);
	}
};

function onTextureAtlasLoaded(atlasAsset) {
	const spriteAsset = this;
	if (spriteAsset.resource) {
		spriteAsset.resource.atlas = atlasAsset.resource;
	}
}
function onTextureAtlasAdded(atlasAsset) {
	const spriteAsset = this;
	spriteAsset.registry.load(atlasAsset);
}
var SpriteHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "sprite");
		this._assets = app2.assets;
		this._device = app2.graphicsDevice;
	}
	load(url, callback) {
		if (typeof url === "string") {
			url = {
				load: url,
				original: url
			};
		}
		if (path.getExtension(url.original) === ".json") {
			http.get(url.load, {
				retry: this.maxRetries > 0,
				maxRetries: this.maxRetries
			}, (err2, response) => {
				if (!err2) {
					callback(null, response);
				} else {
					callback(err2);
				}
			});
		}
	}
	// Create sprite resource
	open(url, data2) {
		const sprite = new Sprite(this._device);
		if (url) {
			sprite.__data = data2;
		}
		return sprite;
	}
	// Set sprite data
	patch(asset, assets) {
		const sprite = asset.resource;
		if (sprite.__data) {
			asset.data.pixelsPerUnit = sprite.__data.pixelsPerUnit;
			asset.data.renderMode = sprite.__data.renderMode;
			asset.data.frameKeys = sprite.__data.frameKeys;
			if (sprite.__data.textureAtlasAsset) {
				const atlas = assets.getByUrl(sprite.__data.textureAtlasAsset);
				if (atlas) {
					asset.data.textureAtlasAsset = atlas.id;
				} else {
					console.warn(`Could not find textureatlas with url: ${sprite.__data.textureAtlasAsset}`);
				}
			}
		}
		sprite.startUpdate();
		sprite.renderMode = asset.data.renderMode;
		sprite.pixelsPerUnit = asset.data.pixelsPerUnit;
		sprite.frameKeys = asset.data.frameKeys;
		this._updateAtlas(asset);
		sprite.endUpdate();
		asset.off("change", this._onAssetChange, this);
		asset.on("change", this._onAssetChange, this);
	}
	// Load atlas
	_updateAtlas(asset) {
		const sprite = asset.resource;
		if (!asset.data.textureAtlasAsset) {
			sprite.atlas = null;
			return;
		}
		this._assets.off(`load:${asset.data.textureAtlasAsset}`, onTextureAtlasLoaded, asset);
		this._assets.on(`load:${asset.data.textureAtlasAsset}`, onTextureAtlasLoaded, asset);
		const atlasAsset = this._assets.get(asset.data.textureAtlasAsset);
		if (atlasAsset && atlasAsset.resource) {
			sprite.atlas = atlasAsset.resource;
		} else {
			if (!atlasAsset) {
				this._assets.off(`add:${asset.data.textureAtlasAsset}`, onTextureAtlasAdded, asset);
				this._assets.on(`add:${asset.data.textureAtlasAsset}`, onTextureAtlasAdded, asset);
			} else {
				this._assets.load(atlasAsset);
			}
		}
	}
	_onAssetChange(asset, attribute, value, oldValue) {
		if (attribute === "data") {
			if (value && value.textureAtlasAsset && oldValue && value.textureAtlasAsset !== oldValue.textureAtlasAsset) {
				this._assets.off(`load:${oldValue.textureAtlasAsset}`, onTextureAtlasLoaded, asset);
				this._assets.off(`add:${oldValue.textureAtlasAsset}`, onTextureAtlasAdded, asset);
			}
		}
	}
};

var Template = class {
	_app;
	_data;
	_templateRoot = null;
	constructor(app2, data2) {
		this._app = app2;
		this._data = data2;
	}
	instantiate() {
		if (!this._templateRoot) {
			this._parseTemplate();
		}
		return this._templateRoot.clone();
	}
	_parseTemplate() {
		const parser = new SceneParser(this._app, true);
		this._templateRoot = parser.parse(this._data);
	}
	set data(value) {
		this._data = value;
		this._templateRoot = null;
	}
	get data() {
		return this._data;
	}
};

var TemplateParser = class {
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		const original = typeof url === "string" ? url : url.original;
		this.handler.fetch(url, Http.ResponseType.JSON, (err2, response) => {
			if (err2) {
				callback(`Error requesting template: ${original}`);
			} else {
				callback(null, response);
			}
		}, asset);
	}
	open(url, data2) {
		return new Template(this.handler.app, data2);
	}
};

var TemplateHandler = class extends ResourceHandler {
	decoder = null;
	constructor(app2) {
		super(app2, "template");
		this.addParser(new TemplateParser());
	}
	openBinary(data2) {
		this.decoder ?? (this.decoder = new TextDecoder("utf-8"));
		return new Template(this._app, JSON.parse(this.decoder.decode(data2)));
	}
	patch(asset, registry) {
		if (!asset || !asset.resource || !asset.data || !asset.data.entities) {
			return;
		}
		const template = asset.resource;
		template.data = asset.data;
	}
};

var TextHandler = class extends ResourceHandler {
	decoder = null;
	constructor(app2) {
		super(app2, "text");
		this.addParser(new TextParser());
	}
	openBinary(data2) {
		this.decoder ?? (this.decoder = new TextDecoder("utf-8"));
		return this.decoder.decode(data2);
	}
};

var JSON_ADDRESS_MODE = {
	"repeat": ADDRESS_REPEAT,
	"clamp": ADDRESS_CLAMP_TO_EDGE,
	"mirror": ADDRESS_MIRRORED_REPEAT
};
var JSON_FILTER_MODE = {
	"nearest": FILTER_NEAREST,
	"linear": FILTER_LINEAR,
	"nearest_mip_nearest": FILTER_NEAREST_MIPMAP_NEAREST,
	"linear_mip_nearest": FILTER_LINEAR_MIPMAP_NEAREST,
	"nearest_mip_linear": FILTER_NEAREST_MIPMAP_LINEAR,
	"linear_mip_linear": FILTER_LINEAR_MIPMAP_LINEAR
};
var regexFrame = /^data\.frames\.(\d+)$/;
var TextureAtlasHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "textureatlas");
		this._loader = app2.loader;
	}
	// Load the texture atlas texture using the texture resource loader
	load(url, callback) {
		if (typeof url === "string") {
			url = {
				load: url,
				original: url
			};
		}
		const self2 = this;
		const handler = this._loader.getHandler("texture");
		if (path.getExtension(url.original) === ".json") {
			http.get(url.load, {
				retry: this.maxRetries > 0,
				maxRetries: this.maxRetries
			}, (err2, response) => {
				if (!err2) {
					const textureUrl = url.original.replace(".json", ".png");
					self2._loader.load(textureUrl, "texture", (err3, texture) => {
						if (err3) {
							callback(err3);
						} else {
							callback(null, {
								data: response,
								texture
							});
						}
					});
				} else {
					callback(err2);
				}
			});
		} else {
			handler.load(url, callback);
		}
	}
	// Create texture atlas resource using the texture from the texture loader
	open(url, data2, asset) {
		const resource = new TextureAtlas();
		if (data2.texture && data2.data) {
			resource.texture = data2.texture;
			resource.__data = data2.data;
		} else {
			const handler = this._loader.getHandler("texture");
			const texture = handler.open(url, data2, asset);
			if (!texture) return null;
			resource.texture = texture;
		}
		return resource;
	}
	patch(asset, assets) {
		if (!asset.resource) {
			return;
		}
		if (asset.resource.__data) {
			if (asset.resource.__data.minfilter !== void 0) asset.data.minfilter = asset.resource.__data.minfilter;
			if (asset.resource.__data.magfilter !== void 0) asset.data.magfilter = asset.resource.__data.magfilter;
			if (asset.resource.__data.addressu !== void 0) asset.data.addressu = asset.resource.__data.addressu;
			if (asset.resource.__data.addressv !== void 0) asset.data.addressv = asset.resource.__data.addressv;
			if (asset.resource.__data.mipmaps !== void 0) asset.data.mipmaps = asset.resource.__data.mipmaps;
			if (asset.resource.__data.anisotropy !== void 0) asset.data.anisotropy = asset.resource.__data.anisotropy;
			if (asset.resource.__data.rgbm !== void 0) asset.data.rgbm = !!asset.resource.__data.rgbm;
			asset.data.frames = asset.resource.__data.frames;
			delete asset.resource.__data;
		}
		const texture = asset.resource.texture;
		if (texture) {
			texture.name = asset.name;
			if (asset.data.hasOwnProperty("minfilter") && texture.minFilter !== JSON_FILTER_MODE[asset.data.minfilter]) {
				texture.minFilter = JSON_FILTER_MODE[asset.data.minfilter];
			}
			if (asset.data.hasOwnProperty("magfilter") && texture.magFilter !== JSON_FILTER_MODE[asset.data.magfilter]) {
				texture.magFilter = JSON_FILTER_MODE[asset.data.magfilter];
			}
			if (asset.data.hasOwnProperty("addressu") && texture.addressU !== JSON_ADDRESS_MODE[asset.data.addressu]) {
				texture.addressU = JSON_ADDRESS_MODE[asset.data.addressu];
			}
			if (asset.data.hasOwnProperty("addressv") && texture.addressV !== JSON_ADDRESS_MODE[asset.data.addressv]) {
				texture.addressV = JSON_ADDRESS_MODE[asset.data.addressv];
			}
			if (asset.data.hasOwnProperty("mipmaps") && texture.mipmaps !== asset.data.mipmaps) {
				texture.mipmaps = asset.data.mipmaps;
			}
			if (asset.data.hasOwnProperty("anisotropy") && texture.anisotropy !== asset.data.anisotropy) {
				texture.anisotropy = asset.data.anisotropy;
			}
			if (asset.data.hasOwnProperty("rgbm")) {
				const type = asset.data.rgbm ? TEXTURETYPE_RGBM : TEXTURETYPE_DEFAULT;
				if (texture.type !== type) {
					texture.type = type;
				}
			}
		}
		asset.resource.texture = texture;
		const frames = {};
		for (const key in asset.data.frames) {
			const frame = asset.data.frames[key];
			frames[key] = {
				rect: new Vec4(frame.rect),
				pivot: new Vec2(frame.pivot),
				border: new Vec4(frame.border)
			};
		}
		asset.resource.frames = frames;
		asset.off("change", this._onAssetChange, this);
		asset.on("change", this._onAssetChange, this);
	}
	_onAssetChange(asset, attribute, value) {
		let frame;
		if (attribute === "data" || attribute === "data.frames") {
			const frames = {};
			for (const key in value.frames) {
				frame = value.frames[key];
				frames[key] = {
					rect: new Vec4(frame.rect),
					pivot: new Vec2(frame.pivot),
					border: new Vec4(frame.border)
				};
			}
			asset.resource.frames = frames;
		} else {
			const match = attribute.match(regexFrame);
			if (match) {
				const frameKey = match[1];
				if (value) {
					if (!asset.resource.frames[frameKey]) {
						asset.resource.frames[frameKey] = {
							rect: new Vec4(value.rect),
							pivot: new Vec2(value.pivot),
							border: new Vec4(value.border)
						};
					} else {
						frame = asset.resource.frames[frameKey];
						frame.rect.set(value.rect[0], value.rect[1], value.rect[2], value.rect[3]);
						frame.pivot.set(value.pivot[0], value.pivot[1]);
						frame.border.set(value.border[0], value.border[1], value.border[2], value.border[3]);
					}
					asset.resource.fire("set:frame", frameKey, asset.resource.frames[frameKey]);
				} else {
					if (asset.resource.frames[frameKey]) {
						delete asset.resource.frames[frameKey];
						asset.resource.fire("remove:frame", frameKey);
					}
				}
			}
		}
	}
};

function BasisWorker() {
	const BASIS_FORMAT = {
		cTFETC1: 0,
		// etc1
		cTFETC2: 1,
		// etc2
		cTFBC1: 2,
		// dxt1
		cTFBC3: 3,
		// dxt5
		cTFPVRTC1_4_RGB: 8,
		// PVRTC1 rgb
		cTFPVRTC1_4_RGBA: 9,
		// PVRTC1 rgba
		cTFASTC_4x4: 10,
		// ASTC
		cTFATC_RGB: 11,
		// ATC rgb
		cTFATC_RGBA_INTERPOLATED_ALPHA: 12,
		// ATC rgba
		// uncompressed (fallback) formats
		cTFRGBA32: 13,
		// rgba 8888
		cTFRGB565: 14,
		// rgb 565
		cTFRGBA4444: 16
		// rgba 4444
	};
	const opaqueMapping = {
		astc: BASIS_FORMAT.cTFASTC_4x4,
		dxt: BASIS_FORMAT.cTFBC1,
		etc1: BASIS_FORMAT.cTFETC1,
		etc2: BASIS_FORMAT.cTFETC1,
		pvr: BASIS_FORMAT.cTFPVRTC1_4_RGB,
		atc: BASIS_FORMAT.cTFATC_RGB,
		none: BASIS_FORMAT.cTFRGB565
	};
	const alphaMapping = {
		astc: BASIS_FORMAT.cTFASTC_4x4,
		dxt: BASIS_FORMAT.cTFBC3,
		etc1: BASIS_FORMAT.cTFRGBA4444,
		etc2: BASIS_FORMAT.cTFETC2,
		pvr: BASIS_FORMAT.cTFPVRTC1_4_RGBA,
		atc: BASIS_FORMAT.cTFATC_RGBA_INTERPOLATED_ALPHA,
		none: BASIS_FORMAT.cTFRGBA4444
	};
	const PIXEL_FORMAT = {
		ETC1: 21,
		ETC2_RGB: 22,
		ETC2_RGBA: 23,
		DXT1: 8,
		DXT5: 10,
		PVRTC_4BPP_RGB_1: 26,
		PVRTC_4BPP_RGBA_1: 27,
		ASTC_4x4: 28,
		ATC_RGB: 29,
		ATC_RGBA: 30,
		R8_G8_B8_A8: 7,
		R5_G6_B5: 3,
		R4_G4_B4_A4: 5
	};
	const basisToEngineMapping = (basisFormat, deviceDetails2) => {
		switch (basisFormat) {
			case BASIS_FORMAT.cTFETC1:
				return deviceDetails2.formats.etc2 ? PIXEL_FORMAT.ETC2_RGB : PIXEL_FORMAT.ETC1;
			case BASIS_FORMAT.cTFETC2:
				return PIXEL_FORMAT.ETC2_RGBA;
			case BASIS_FORMAT.cTFBC1:
				return PIXEL_FORMAT.DXT1;
			case BASIS_FORMAT.cTFBC3:
				return PIXEL_FORMAT.DXT5;
			case BASIS_FORMAT.cTFPVRTC1_4_RGB:
				return PIXEL_FORMAT.PVRTC_4BPP_RGB_1;
			case BASIS_FORMAT.cTFPVRTC1_4_RGBA:
				return PIXEL_FORMAT.PVRTC_4BPP_RGBA_1;
			case BASIS_FORMAT.cTFASTC_4x4:
				return PIXEL_FORMAT.ASTC_4x4;
			case BASIS_FORMAT.cTFATC_RGB:
				return PIXEL_FORMAT.ATC_RGB;
			case BASIS_FORMAT.cTFATC_RGBA_INTERPOLATED_ALPHA:
				return PIXEL_FORMAT.ATC_RGBA;
			case BASIS_FORMAT.cTFRGBA32:
				return PIXEL_FORMAT.R8_G8_B8_A8;
			case BASIS_FORMAT.cTFRGB565:
				return PIXEL_FORMAT.R5_G6_B5;
			case BASIS_FORMAT.cTFRGBA4444:
				return PIXEL_FORMAT.R4_G4_B4_A4;
		}
	};
	const unswizzleGGGR = (data2) => {
		const genB = function(R, G) {
			const r = R * (2 / 255) - 1;
			const g = G * (2 / 255) - 1;
			const b = Math.sqrt(1 - Math.min(1, r * r + g * g));
			return Math.max(0, Math.min(255, Math.floor((b + 1) * 0.5 * 255)));
		};
		for (let offset3 = 0; offset3 < data2.length; offset3 += 4) {
			const R = data2[offset3 + 3];
			const G = data2[offset3 + 1];
			data2[offset3 + 0] = R;
			data2[offset3 + 2] = genB(R, G);
			data2[offset3 + 3] = 255;
		}
		return data2;
	};
	const pack565 = (data2) => {
		const result = new Uint16Array(data2.length / 4);
		for (let offset3 = 0; offset3 < data2.length; offset3 += 4) {
			const R = data2[offset3 + 0];
			const G = data2[offset3 + 1];
			const B = data2[offset3 + 2];
			result[offset3 / 4] = (R & 248) << 8 | // 5
			(G & 252) << 3 | // 6
			B >> 3;
		}
		return result;
	};
	const isPOT = (width, height) => {
		return (width & width - 1) === 0 && (height & height - 1) === 0;
	};
	const performanceNow = () => {
		return typeof performance !== "undefined" ? performance.now() : 0;
	};
	let basis;
	let rgbPriority;
	let rgbaPriority;
	const chooseTargetFormat = (deviceDetails2, hasAlpha, isUASTC) => {
		if (isUASTC) {
			if (deviceDetails2.formats.astc) {
				return "astc";
			}
		} else {
			if (hasAlpha) {
				if (deviceDetails2.formats.etc2) {
					return "etc2";
				}
			} else {
				if (deviceDetails2.formats.etc2) {
					return "etc2";
				}
				if (deviceDetails2.formats.etc1) {
					return "etc1";
				}
			}
		}
		const testInOrder = (priority) => {
			for (let i2 = 0; i2 < priority.length; ++i2) {
				const format = priority[i2];
				if (deviceDetails2.formats[format]) {
					return format;
				}
			}
			return "none";
		};
		return testInOrder(hasAlpha ? rgbaPriority : rgbPriority);
	};
	const dimensionsValid = (width, height, format) => {
		switch (format) {
			// etc1, 2
			case BASIS_FORMAT.cTFETC1:
			case BASIS_FORMAT.cTFETC2:
				return true;
			// dxt1, 5
			case BASIS_FORMAT.cTFBC1:
			case BASIS_FORMAT.cTFBC3:
				return (width & 3) === 0 && (height & 3) === 0;
			// pvrtc
			case BASIS_FORMAT.cTFPVRTC1_4_RGB:
			case BASIS_FORMAT.cTFPVRTC1_4_RGBA:
				return isPOT(width, height);
			// astc
			case BASIS_FORMAT.cTFASTC_4x4:
				return true;
			// atc
			case BASIS_FORMAT.cTFATC_RGB:
			case BASIS_FORMAT.cTFATC_RGBA_INTERPOLATED_ALPHA:
				return true;
		}
		return false;
	};
	const transcodeKTX2 = (url, data2, options2) => {
		if (!basis.KTX2File) {
			throw new Error("Basis transcoder module does not include support for KTX2.");
		}
		const funcStart = performanceNow();
		const basisFile = new basis.KTX2File(new Uint8Array(data2));
		const width = basisFile.getWidth();
		const height = basisFile.getHeight();
		const levels = basisFile.getLevels();
		const hasAlpha = !!basisFile.getHasAlpha();
		const isUASTC = basisFile.isUASTC && basisFile.isUASTC();
		const cubemap = !!options2.isCubemap;
		if (!width || !height || !levels) {
			basisFile.close();
			basisFile.delete();
			throw new Error(`Invalid image dimensions url=${url} width=${width} height=${height} levels=${levels}`);
		}
		const format = chooseTargetFormat(options2.deviceDetails, hasAlpha, isUASTC);
		const unswizzle = !cubemap && !!options2.isGGGR && format === "pvr";
		let basisFormat;
		if (unswizzle) {
			basisFormat = BASIS_FORMAT.cTFRGBA32;
		} else {
			basisFormat = hasAlpha ? alphaMapping[format] : opaqueMapping[format];
			if (!dimensionsValid(width, height, basisFormat)) {
				basisFormat = hasAlpha ? BASIS_FORMAT.cTFRGBA32 : BASIS_FORMAT.cTFRGB565;
			}
		}
		if (!basisFile.startTranscoding()) {
			basisFile.close();
			basisFile.delete();
			throw new Error(`Failed to start transcoding url=${url}`);
		}
		const is16BitFormat = basisFormat === BASIS_FORMAT.cTFRGB565 || basisFormat === BASIS_FORMAT.cTFRGBA4444;
		const transcodeImage = (mip, face) => {
			const dstSize = basisFile.getImageTranscodedSizeInBytes(mip, 0, face, basisFormat);
			const dst = new Uint8Array(dstSize);
			if (!basisFile.transcodeImage(dst, mip, 0, face, basisFormat, 0, -1, -1)) {
				basisFile.close();
				basisFile.delete();
				throw new Error(`Failed to transcode image url=${url}`);
			}
			return is16BitFormat ? new Uint16Array(dst.buffer) : dst;
		};
		const levelData = [];
		for (let mip = 0; mip < levels; ++mip) {
			if (cubemap) {
				const faceData = [];
				for (let face = 0; face < 6; ++face) {
					faceData.push(transcodeImage(mip, face));
				}
				levelData.push(faceData);
			} else {
				levelData.push(transcodeImage(mip, 0));
			}
		}
		basisFile.close();
		basisFile.delete();
		if (unswizzle) {
			basisFormat = BASIS_FORMAT.cTFRGB565;
			for (let i2 = 0; i2 < levelData.length; ++i2) {
				levelData[i2] = pack565(unswizzleGGGR(levelData[i2]));
			}
		}
		return {
			format: basisToEngineMapping(basisFormat, options2.deviceDetails),
			width,
			height,
			levels: levelData,
			cubemap,
			transcodeTime: performanceNow() - funcStart,
			url,
			unswizzledGGGR: unswizzle
		};
	};
	const transcodeBasis = (url, data2, options2) => {
		const funcStart = performanceNow();
		const basisFile = new basis.BasisFile(new Uint8Array(data2));
		const width = basisFile.getImageWidth(0, 0);
		const height = basisFile.getImageHeight(0, 0);
		const images = basisFile.getNumImages();
		const levels = basisFile.getNumLevels(0);
		const hasAlpha = !!basisFile.getHasAlpha();
		const isUASTC = basisFile.isUASTC && basisFile.isUASTC();
		if (!width || !height || !images || !levels) {
			basisFile.close();
			basisFile.delete();
			throw new Error(`Invalid image dimensions url=${url} width=${width} height=${height} images=${images} levels=${levels}`);
		}
		const format = chooseTargetFormat(options2.deviceDetails, hasAlpha, isUASTC);
		const unswizzle = !!options2.isGGGR && format === "pvr";
		let basisFormat;
		if (unswizzle) {
			basisFormat = BASIS_FORMAT.cTFRGBA32;
		} else {
			basisFormat = hasAlpha ? alphaMapping[format] : opaqueMapping[format];
			if (!dimensionsValid(width, height, basisFormat)) {
				basisFormat = hasAlpha ? BASIS_FORMAT.cTFRGBA32 : BASIS_FORMAT.cTFRGB565;
			}
		}
		if (!basisFile.startTranscoding()) {
			basisFile.close();
			basisFile.delete();
			throw new Error(`Failed to start transcoding url=${url}`);
		}
		let i2;
		const levelData = [];
		for (let mip = 0; mip < levels; ++mip) {
			const dstSize = basisFile.getImageTranscodedSizeInBytes(0, mip, basisFormat);
			const dst = new Uint8Array(dstSize);
			if (!basisFile.transcodeImage(dst, 0, mip, basisFormat, 0, 0)) {
				if (mip === levels - 1 && dstSize === levelData[mip - 1].buffer.byteLength) {
					dst.set(new Uint8Array(levelData[mip - 1].buffer));
					console.warn(`Failed to transcode last mipmap level, using previous level instead url=${url}`);
				} else {
					basisFile.close();
					basisFile.delete();
					throw new Error(`Failed to transcode image url=${url}`);
				}
			}
			const is16BitFormat = basisFormat === BASIS_FORMAT.cTFRGB565 || basisFormat === BASIS_FORMAT.cTFRGBA4444;
			levelData.push(is16BitFormat ? new Uint16Array(dst.buffer) : dst);
		}
		basisFile.close();
		basisFile.delete();
		if (unswizzle) {
			basisFormat = BASIS_FORMAT.cTFRGB565;
			for (i2 = 0; i2 < levelData.length; ++i2) {
				levelData[i2] = pack565(unswizzleGGGR(levelData[i2]));
			}
		}
		return {
			format: basisToEngineMapping(basisFormat, options2.deviceDetails),
			width,
			height,
			levels: levelData,
			cubemap: false,
			transcodeTime: performanceNow() - funcStart,
			url,
			unswizzledGGGR: unswizzle
		};
	};
	const transcode = (url, data2, options2) => {
		return options2.isKTX2 ? transcodeKTX2(url, data2, options2) : transcodeBasis(url, data2, options2);
	};
	const workerTranscode = (url, data2, options2) => {
		try {
			const result = transcode(url, data2, options2);
			const transfer = [];
			result.levels = result.levels.map((level) => {
				if (Array.isArray(level)) {
					return level.map((face) => {
						transfer.push(face.buffer);
						return face.buffer;
					});
				}
				transfer.push(level.buffer);
				return level.buffer;
			});
			self.postMessage({ url, data: result }, transfer);
		} catch (err2) {
			self.postMessage({ url, err: err2 }, null);
		}
	};
	const workerInit = (config, callback) => {
		const instantiateWasmFunc = (imports, successCallback) => {
			WebAssembly.instantiate(config.module, imports).then((result) => {
				successCallback(result);
			}).catch((reason) => {
				console.error(`instantiate failed + ${reason}`);
			});
			return {};
		};
		self.BASIS(config.module ? { instantiateWasm: instantiateWasmFunc } : null).then((instance) => {
			instance.initializeBasis();
			basis = instance;
			rgbPriority = config.rgbPriority;
			rgbaPriority = config.rgbaPriority;
			callback(null);
		});
	};
	const queue2 = [];
	self.onmessage = (message) => {
		const data2 = message.data;
		switch (data2.type) {
			case "init":
				workerInit(data2.config, () => {
					for (let i2 = 0; i2 < queue2.length; ++i2) {
						workerTranscode(queue2[i2].url, queue2[i2].data, queue2[i2].options);
					}
					queue2.length = 0;
				});
				break;
			case "transcode":
				if (basis) {
					workerTranscode(data2.url, data2.data, data2.options);
				} else {
					queue2.push(data2);
				}
				break;
		}
	};
}

var getCompressionFormats = (device) => {
	return {
		astc: !!device.extCompressedTextureASTC,
		atc: !!device.extCompressedTextureATC,
		dxt: !!device.extCompressedTextureS3TC,
		etc1: !!device.extCompressedTextureETC1,
		etc2: !!device.extCompressedTextureETC,
		pvr: !!device.extCompressedTexturePVRTC
	};
};
var prepareWorkerModules = (config, callback) => {
	const getWorkerBlob = (basisCode) => {
		const code = [
			"/* basis */",
			basisCode,
			"",
			`(${BasisWorker.toString()})()

`
		].join("\n");
		return new Blob([code], { type: "application/javascript" });
	};
	const wasmSupported = () => {
		try {
			if (typeof WebAssembly === "object" && typeof WebAssembly.instantiate === "function") {
				const module2 = new WebAssembly.Module(Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0));
				if (module2 instanceof WebAssembly.Module) {
					return new WebAssembly.Instance(module2) instanceof WebAssembly.Instance;
				}
			}
		} catch (e) {
		}
		return false;
	};
	const sendResponse = (basisCode, module2) => {
		callback(null, {
			workerUrl: URL.createObjectURL(getWorkerBlob(basisCode)),
			module: module2,
			rgbPriority: config.rgbPriority,
			rgbaPriority: config.rgbaPriority
		});
	};
	const options2 = {
		cache: true,
		responseType: "text",
		retry: config.maxRetries > 0,
		maxRetries: config.maxRetries
	};
	if (config.glueUrl && config.wasmUrl && wasmSupported()) {
		let basisCode = null;
		let module2 = null;
		http.get(config.glueUrl, options2, (err2, response) => {
			if (err2) {
				callback(err2);
			} else {
				if (module2) {
					sendResponse(response, module2);
				} else {
					basisCode = response;
				}
			}
		});
		const fetchPromise = fetch(config.wasmUrl);
		const compileManual = () => {
			fetchPromise.then((result) => result.arrayBuffer()).then((buffer) => WebAssembly.compile(buffer)).then((module_) => {
				if (basisCode) {
					sendResponse(basisCode, module_);
				} else {
					module2 = module_;
				}
			}).catch((err2) => {
				callback(err2, null);
			});
		};
		if (WebAssembly.compileStreaming) {
			WebAssembly.compileStreaming(fetchPromise).then((module_) => {
				if (basisCode) {
					sendResponse(basisCode, module_);
				} else {
					module2 = module_;
				}
			}).catch((err2) => {
				compileManual();
			});
		} else {
			compileManual();
		}
	} else {
		http.get(config.fallbackUrl, options2, (err2, response) => {
			if (err2) {
				callback(err2, null);
			} else {
				sendResponse(response, null);
			}
		});
	}
};
var BasisQueue = class {
	constructor() {
		this.callbacks = {};
		this.queue = [];
		this.clients = [];
	}
	enqueueJob(url, data2, callback, options2) {
		if (this.callbacks.hasOwnProperty(url)) {
			this.callbacks[url].push(callback);
		} else {
			this.callbacks[url] = [callback];
			const job = {
				url,
				data: data2,
				options: options2
			};
			if (this.clients.length > 0) {
				this.clients.shift().run(job);
			} else {
				this.queue.push(job);
			}
		}
	}
	enqueueClient(client) {
		if (this.queue.length > 0) {
			client.run(this.queue.shift());
		} else {
			this.clients.push(client);
		}
	}
	handleResponse(url, err2, data2) {
		const callback = this.callbacks[url];
		if (err2) {
			for (let i2 = 0; i2 < callback.length; ++i2) {
				callback[i2](err2);
			}
		} else {
			const TypedArray = data2.format === PIXELFORMAT_RGB565 || data2.format === PIXELFORMAT_RGBA4 ? Uint16Array : Uint8Array;
			data2.levels = data2.levels.map((level) => {
				return Array.isArray(level) ? level.map((face) => new TypedArray(face)) : new TypedArray(level);
			});
			for (let i2 = 0; i2 < callback.length; ++i2) {
				callback[i2](null, data2);
			}
		}
		delete this.callbacks[url];
	}
};
var BasisClient = class {
	constructor(queue2, config, eager) {
		this.queue = queue2;
		this.worker = new Worker(config.workerUrl);
		this.worker.addEventListener("message", (message) => {
			const data2 = message.data;
			this.queue.handleResponse(data2.url, data2.err, data2.data);
			if (!this.eager) {
				this.queue.enqueueClient(this);
			}
		});
		this.worker.postMessage({ type: "init", config });
		this.eager = eager;
	}
	run(job) {
		const transfer = [];
		if (job.data instanceof ArrayBuffer) {
			transfer.push(job.data);
		}
		this.worker.postMessage({
			type: "transcode",
			url: job.url,
			format: job.format,
			data: job.data,
			options: job.options
		}, transfer);
		if (this.eager) {
			this.queue.enqueueClient(this);
		}
	}
};
var defaultNumWorkers2 = 1;
var defaultRgbPriority = ["etc2", "etc1", "astc", "dxt", "pvr", "atc"];
var defaultRgbaPriority = ["astc", "dxt", "etc2", "pvr", "atc"];
var defaultMaxRetries = 5;
var queue = new BasisQueue();
var lazyConfig2 = null;
var initializing = false;
function basisInitialize(config) {
	if (initializing) {
		return;
	}
	if (!config) {
		config = lazyConfig2 || {};
	} else if (config.lazyInit) {
		lazyConfig2 = config;
		return;
	}
	if (!config.glueUrl || !config.wasmUrl || !config.fallbackUrl) {
		const moduleConfig = WasmModule.getConfig("BASIS");
		if (moduleConfig) {
			config = {
				glueUrl: moduleConfig.glueUrl,
				wasmUrl: moduleConfig.wasmUrl,
				fallbackUrl: moduleConfig.fallbackUrl,
				numWorkers: moduleConfig.numWorkers
			};
		}
	}
	if (config.glueUrl || config.wasmUrl || config.fallbackUrl) {
		initializing = true;
		const numWorkers = Math.max(1, Math.min(16, config.numWorkers || defaultNumWorkers2));
		const eagerWorkers = config.numWorkers === 1 || (config.hasOwnProperty("eagerWorkers") ? config.eagerWorkers : true);
		config.rgbPriority = config.rgbPriority || defaultRgbPriority;
		config.rgbaPriority = config.rgbaPriority || defaultRgbaPriority;
		config.maxRetries = config.hasOwnProperty("maxRetries") ? config.maxRetries : defaultMaxRetries;
		prepareWorkerModules(config, (err2, clientConfig) => {
			if (err2) {
				console.error(`failed to initialize basis worker: ${err2}`);
			} else {
				for (let i2 = 0; i2 < numWorkers; ++i2) {
					queue.enqueueClient(new BasisClient(queue, clientConfig, eagerWorkers));
				}
			}
		});
	}
}
var deviceDetails = null;
function basisTranscode(device, url, data2, callback, options2) {
	basisInitialize();
	if (!deviceDetails) {
		deviceDetails = {
			formats: getCompressionFormats(device)
		};
	}
	queue.enqueueJob(url, data2, callback, {
		deviceDetails,
		isGGGR: !!options2?.isGGGR,
		isKTX2: !!options2?.isKTX2,
		isCubemap: !!options2?.isCubemap
	});
	return initializing;
}

var TextureParser = class {
	load(url, callback, asset) {
		throw new Error("not implemented");
	}
	/* eslint-disable jsdoc/require-returns-check */
	open(url, data2, device) {
		throw new Error("not implemented");
	}
	/* eslint-enable jsdoc/require-returns-check */
};

var BasisParser = class extends TextureParser {
	constructor(device) {
		super();
		this.device = device;
	}
	canParse(context) {
		return context.ext === "basis";
	}
	load(url, callback, asset) {
		const device = this.device;
		const transcode = (data2) => {
			const basisModuleFound = basisTranscode(
				device,
				url.load,
				data2,
				callback,
				{ isGGGR: (asset?.file?.variants?.basis?.opt & 8) !== 0 }
			);
			if (!basisModuleFound) {
				callback(`Basis module not found. Asset [${asset.name}](${asset.getFileUrl()}) basis texture variant will not be loaded.`);
			}
		};
		this.handler.fetch(url, Http.ResponseType.ARRAY_BUFFER, (err2, result) => {
			if (err2) {
				callback(err2);
			} else {
				transcode(result);
			}
		}, asset);
	}
	// our async transcode call provides the neat structure we need to create the texture instance
	open(url, data2, device, textureOptions = {}) {
		const texture = new Texture(device, {
			name: url,
			addressU: data2.cubemap ? ADDRESS_CLAMP_TO_EDGE : ADDRESS_REPEAT,
			addressV: data2.cubemap ? ADDRESS_CLAMP_TO_EDGE : ADDRESS_REPEAT,
			width: data2.width,
			height: data2.height,
			format: data2.format,
			cubemap: data2.cubemap,
			levels: data2.levels,
			// derive mipmaps from the actual level count, so a single-level file isn't treated as an
			// incomplete mip chain (which renders black); matches the dds parser
			mipmaps: data2.levels.length > 1,
			...textureOptions
		});
		texture.upload();
		return texture;
	}
};

var ImgParser = class extends TextureParser {
	constructor(registry, device) {
		super();
		this.crossOrigin = registry.prefix ? "anonymous" : null;
		this.device = device;
	}
	canParse() {
		return true;
	}
	load(url, callback, asset) {
		const hasContents = !!asset?.file?.contents;
		if (hasContents) {
			if (this.device.supportsImageBitmap) {
				this._loadImageBitmapFromBlob(new Blob([asset.file.contents]), callback);
				return;
			}
			url = {
				load: URL.createObjectURL(new Blob([asset.file.contents])),
				original: url.original
			};
		}
		const handler = (err2, result) => {
			if (hasContents) {
				URL.revokeObjectURL(url.load);
			}
			callback(err2, result);
		};
		let crossOrigin;
		if (asset && asset.options && asset.options.hasOwnProperty("crossOrigin")) {
			crossOrigin = asset.options.crossOrigin;
		} else if (ABSOLUTE_URL.test(url.load)) {
			crossOrigin = this.crossOrigin;
		}
		if (this.device.supportsImageBitmap) {
			this._loadImageBitmap(url.load, url.original, crossOrigin, handler, asset);
		} else {
			this._loadImage(url.load, url.original, crossOrigin, handler, asset);
		}
	}
	open(url, data2, device, textureOptions = {}) {
		const texture = new Texture(device, {
			name: url,
			width: data2.width,
			height: data2.height,
			format: PIXELFORMAT_RGBA8,
			...textureOptions
		});
		texture.setSource(data2);
		return texture;
	}
	_loadImage(url, originalUrl, crossOrigin, callback, asset) {
		const image = new Image();
		if (http.withCredentials) {
			image.crossOrigin = "use-credentials";
		} else if (crossOrigin) {
			image.crossOrigin = crossOrigin;
		}
		let retries = 0;
		const maxRetries = this.handler.maxRetries;
		let retryTimeout;
		const dummySize = 1024 * 1024;
		asset?.fire("progress", 0, dummySize);
		image.onload = function() {
			asset?.fire("progress", dummySize, dummySize);
			callback(null, image);
		};
		image.onerror = function() {
			if (retryTimeout) return;
			if (maxRetries > 0 && ++retries <= maxRetries) {
				const retryDelay = Math.pow(2, retries) * 100;
				console.log(`Error loading Texture from: '${originalUrl}' - Retrying in ${retryDelay}ms...`);
				const idx = url.indexOf("?");
				const separator = idx >= 0 ? "&" : "?";
				retryTimeout = setTimeout(() => {
					image.src = `${url + separator}retry=${Date.now()}`;
					retryTimeout = null;
				}, retryDelay);
			} else {
				callback(`Error loading Texture from: '${originalUrl}'`);
			}
		};
		image.src = url;
	}
	_loadImageBitmap(url, originalUrl, crossOrigin, callback, asset) {
		const options2 = {
			cache: true,
			responseType: "blob",
			retry: this.handler.maxRetries > 0,
			maxRetries: this.handler.maxRetries,
			progress: asset
		};
		http.get(url, options2, (err2, blob) => {
			if (err2) {
				callback(err2);
			} else {
				this._loadImageBitmapFromBlob(blob, callback);
			}
		});
	}
	_loadImageBitmapFromBlob(blob, callback) {
		createImageBitmap(blob, {
			premultiplyAlpha: "none",
			colorSpaceConversion: "none"
		}).then((imageBitmap) => callback(null, imageBitmap)).catch((e) => callback(e));
	}
};

var IDENTIFIER2 = [1481919403, 3140563232, 169478669];
var KNOWN_FORMATS = {
	// compressed formats
	33776: PIXELFORMAT_DXT1,
	33778: PIXELFORMAT_DXT3,
	33779: PIXELFORMAT_DXT5,
	36196: PIXELFORMAT_ETC1,
	37492: PIXELFORMAT_ETC2_RGB,
	37496: PIXELFORMAT_ETC2_RGBA,
	35840: PIXELFORMAT_PVRTC_4BPP_RGB_1,
	35841: PIXELFORMAT_PVRTC_2BPP_RGB_1,
	35842: PIXELFORMAT_PVRTC_4BPP_RGBA_1,
	35843: PIXELFORMAT_PVRTC_2BPP_RGBA_1,
	// uncompressed formats
	32849: PIXELFORMAT_RGB8,
	// GL_RGB8
	32856: PIXELFORMAT_RGBA8,
	// GL_RGBA8
	35905: PIXELFORMAT_SRGB8,
	// GL_SRGB8
	35907: PIXELFORMAT_SRGBA8,
	// GL_SRGB8_ALPHA8
	35898: PIXELFORMAT_111110F,
	// GL_R11F_G11F_B10F
	34843: PIXELFORMAT_RGB16F,
	// GL_RGB16F
	34842: PIXELFORMAT_RGBA16F
	// GL_RGBA16F
};
function createContainer(pixelFormat, buffer, byteOffset, byteSize) {
	return pixelFormat === PIXELFORMAT_111110F ? new Uint32Array(buffer, byteOffset, byteSize / 4) : new Uint8Array(buffer, byteOffset, byteSize);
}
var KtxParser = class extends TextureParser {
	canParse(context) {
		return context.ext === "ktx";
	}
	load(url, callback, asset) {
		this.handler.fetch(url, Http.ResponseType.ARRAY_BUFFER, callback, asset);
	}
	open(url, data2, device, textureOptions = {}) {
		const textureData2 = this.parse(data2);
		if (!textureData2) {
			return null;
		}
		const texture = new Texture(device, {
			name: url,
			addressU: textureData2.cubemap ? ADDRESS_CLAMP_TO_EDGE : ADDRESS_REPEAT,
			addressV: textureData2.cubemap ? ADDRESS_CLAMP_TO_EDGE : ADDRESS_REPEAT,
			width: textureData2.width,
			height: textureData2.height,
			format: textureData2.format,
			cubemap: textureData2.cubemap,
			levels: textureData2.levels,
			// derive mipmaps from the actual level count, so a single-level file isn't treated as an
			// incomplete mip chain (which renders black); matches the dds parser
			mipmaps: textureData2.levels.length > 1,
			...textureOptions
		});
		texture.upload();
		return texture;
	}
	parse(data2) {
		const dataU32 = new Uint32Array(data2);
		if (IDENTIFIER2[0] !== dataU32[0] || IDENTIFIER2[1] !== dataU32[1] || IDENTIFIER2[2] !== dataU32[2]) {
			return null;
		}
		const header2 = {
			endianness: dataU32[3],
			// todo: Use this information
			glType: dataU32[4],
			glTypeSize: dataU32[5],
			glFormat: dataU32[6],
			glInternalFormat: dataU32[7],
			glBaseInternalFormat: dataU32[8],
			pixelWidth: dataU32[9],
			pixelHeight: dataU32[10],
			pixelDepth: dataU32[11],
			numberOfArrayElements: dataU32[12],
			numberOfFaces: dataU32[13],
			numberOfMipmapLevels: dataU32[14],
			bytesOfKeyValueData: dataU32[15]
		};
		if (header2.pixelDepth > 1) {
			return null;
		}
		if (header2.numberOfArrayElements !== 0) {
			return null;
		}
		const format = KNOWN_FORMATS[header2.glInternalFormat];
		if (format === void 0) {
			return null;
		}
		let offset3 = 16 + header2.bytesOfKeyValueData / 4;
		const isCubemap = header2.numberOfFaces > 1;
		const levels = [];
		for (let mipmapLevel = 0; mipmapLevel < (header2.numberOfMipmapLevels || 1); mipmapLevel++) {
			const imageSizeInBytes = dataU32[offset3++];
			if (isCubemap) {
				levels.push([]);
			}
			const target2 = isCubemap ? levels[mipmapLevel] : levels;
			for (let face = 0; face < (isCubemap ? 6 : 1); ++face) {
				target2.push(createContainer(format, data2, offset3 * 4, imageSizeInBytes));
				offset3 += imageSizeInBytes + 3 >> 2;
			}
		}
		return {
			format,
			width: header2.pixelWidth,
			height: header2.pixelHeight,
			levels,
			cubemap: isCubemap
		};
	}
};

var KHRConstants = {
	KHR_DF_MODEL_ETC1S: 163,
	KHR_DF_MODEL_UASTC: 166
};
var Ktx2Parser = class extends TextureParser {
	constructor(device) {
		super();
		this.device = device;
	}
	canParse(context) {
		return context.ext === "ktx2";
	}
	load(url, callback, asset) {
		this.handler.fetch(url, Http.ResponseType.ARRAY_BUFFER, (err2, result) => {
			if (err2) {
				callback(err2, result);
			} else {
				this.parse(result, url, callback, asset);
			}
		}, asset);
	}
	open(url, data2, device, textureOptions = {}) {
		const texture = new Texture(device, {
			name: url,
			addressU: data2.cubemap ? ADDRESS_CLAMP_TO_EDGE : ADDRESS_REPEAT,
			addressV: data2.cubemap ? ADDRESS_CLAMP_TO_EDGE : ADDRESS_REPEAT,
			width: data2.width,
			height: data2.height,
			format: data2.format,
			cubemap: data2.cubemap,
			levels: data2.levels,
			// derive mipmaps from the actual level count, so a single-level file isn't treated as an
			// incomplete mip chain (which renders black); matches the dds parser
			mipmaps: data2.levels.length > 1,
			...textureOptions
		});
		texture.upload();
		return texture;
	}
	parse(arraybuffer, url, callback, asset) {
		const rs = new ReadStream(arraybuffer);
		const magic = [rs.readU32be(), rs.readU32be(), rs.readU32be()];
		if (magic[0] !== 2873840728 || magic[1] !== 540160187 || magic[2] !== 218765834) {
			return null;
		}
		const header2 = {
			vkFormat: rs.readU32(),
			typeSize: rs.readU32(),
			pixelWidth: rs.readU32(),
			pixelHeight: rs.readU32(),
			pixelDepth: rs.readU32(),
			layerCount: rs.readU32(),
			faceCount: rs.readU32(),
			levelCount: rs.readU32(),
			supercompressionScheme: rs.readU32()
		};
		const index = {
			dfdByteOffset: rs.readU32(),
			dfdByteLength: rs.readU32(),
			kvdByteOffset: rs.readU32(),
			kvdByteLength: rs.readU32(),
			sgdByteOffset: rs.readU64(),
			sgdByteLength: rs.readU64()
		};
		const levels = [];
		for (let i2 = 0; i2 < Math.max(1, header2.levelCount); ++i2) {
			levels.push({
				byteOffset: rs.readU64(),
				byteLength: rs.readU64(),
				uncompressedByteLength: rs.readU64()
			});
		}
		const dfdTotalSize = rs.readU32();
		if (dfdTotalSize !== index.kvdByteOffset - index.dfdByteOffset) {
			return null;
		}
		rs.skip(8);
		const colorModel = rs.readU8();
		rs.skip(index.dfdByteLength - 9);
		rs.skip(index.kvdByteLength);
		if (header2.supercompressionScheme === 1 || colorModel === KHRConstants.KHR_DF_MODEL_UASTC) {
			const basisModuleFound = basisTranscode(
				this.device,
				url.load,
				arraybuffer,
				callback,
				{
					isGGGR: (asset?.file?.variants?.basis?.opt & 8) !== 0,
					isKTX2: true,
					// a six-face ktx2 file is a cubemap
					isCubemap: header2.faceCount === 6
				}
			);
			if (!basisModuleFound) {
				callback(`Basis module not found. Asset [${asset.name}](${asset.getFileUrl()}) basis texture variant will not be loaded.`);
			}
		} else {
			callback("unsupported KTX2 pixel format");
		}
	}
};

var DdsParser = class extends TextureParser {
	canParse(context) {
		return context.ext === "dds";
	}
	load(url, callback, asset) {
		this.handler.fetch(url, Http.ResponseType.ARRAY_BUFFER, callback, asset);
	}
	open(url, data2, device, textureOptions = {}) {
		const header2 = new Uint32Array(data2, 0, 128 / 4);
		const width = header2[4];
		const height = header2[3];
		const mips = Math.max(header2[7], 1);
		const isFourCc = header2[20] === 4;
		const fcc = header2[21];
		const bpp = header2[22];
		const isCubemap = header2[28] === 65024;
		const FCC_DXT1 = 827611204;
		const FCC_DXT5 = 894720068;
		const FCC_FP16 = 113;
		const FCC_FP32 = 116;
		const FCC_ETC1 = 826496069;
		const FCC_PVRTC_2BPP_RGB_1 = 825438800;
		const FCC_PVRTC_2BPP_RGBA_1 = 825504336;
		const FCC_PVRTC_4BPP_RGB_1 = 825439312;
		const FCC_PVRTC_4BPP_RGBA_1 = 825504848;
		let compressed = false;
		let etc1 = false;
		let pvrtc2 = false;
		let pvrtc4 = false;
		let format = null;
		let componentSize = 1;
		let texture;
		if (isFourCc) {
			if (fcc === FCC_DXT1) {
				format = PIXELFORMAT_DXT1;
				compressed = true;
			} else if (fcc === FCC_DXT5) {
				format = PIXELFORMAT_DXT5;
				compressed = true;
			} else if (fcc === FCC_FP16) {
				format = PIXELFORMAT_RGBA16F;
				componentSize = 2;
			} else if (fcc === FCC_FP32) {
				format = PIXELFORMAT_RGBA32F;
				componentSize = 4;
			} else if (fcc === FCC_ETC1) {
				format = PIXELFORMAT_ETC1;
				compressed = true;
				etc1 = true;
			} else if (fcc === FCC_PVRTC_2BPP_RGB_1 || fcc === FCC_PVRTC_2BPP_RGBA_1) {
				format = fcc === FCC_PVRTC_2BPP_RGB_1 ? PIXELFORMAT_PVRTC_2BPP_RGB_1 : PIXELFORMAT_PVRTC_2BPP_RGBA_1;
				compressed = true;
				pvrtc2 = true;
			} else if (fcc === FCC_PVRTC_4BPP_RGB_1 || fcc === FCC_PVRTC_4BPP_RGBA_1) {
				format = fcc === FCC_PVRTC_4BPP_RGB_1 ? PIXELFORMAT_PVRTC_4BPP_RGB_1 : PIXELFORMAT_PVRTC_4BPP_RGBA_1;
				compressed = true;
				pvrtc4 = true;
			}
		} else {
			if (bpp === 32) {
				format = PIXELFORMAT_RGBA8;
			}
		}
		if (!format) {
			texture = new Texture(device, {
				width: 4,
				height: 4,
				format: PIXELFORMAT_RGB8,
				name: "dds-legacy-empty"
			});
			return texture;
		}
		texture = new Texture(device, {
			name: url,
			addressU: isCubemap ? ADDRESS_CLAMP_TO_EDGE : ADDRESS_REPEAT,
			addressV: isCubemap ? ADDRESS_CLAMP_TO_EDGE : ADDRESS_REPEAT,
			width,
			height,
			format,
			cubemap: isCubemap,
			mipmaps: mips > 1,
			...textureOptions
		});
		let offset3 = 128;
		const faces = isCubemap ? 6 : 1;
		let mipSize;
		const DXT_BLOCK_WIDTH = 4;
		const DXT_BLOCK_HEIGHT = 4;
		const blockSize = fcc === FCC_DXT1 ? 8 : 16;
		let numBlocksAcross, numBlocksDown, numBlocks;
		for (let face = 0; face < faces; face++) {
			let mipWidth = width;
			let mipHeight = height;
			for (let i2 = 0; i2 < mips; i2++) {
				if (compressed) {
					if (etc1) {
						mipSize = Math.floor((mipWidth + 3) / 4) * Math.floor((mipHeight + 3) / 4) * 8;
					} else if (pvrtc2) {
						mipSize = Math.max(mipWidth, 16) * Math.max(mipHeight, 8) / 4;
					} else if (pvrtc4) {
						mipSize = Math.max(mipWidth, 8) * Math.max(mipHeight, 8) / 2;
					} else {
						numBlocksAcross = Math.floor((mipWidth + DXT_BLOCK_WIDTH - 1) / DXT_BLOCK_WIDTH);
						numBlocksDown = Math.floor((mipHeight + DXT_BLOCK_HEIGHT - 1) / DXT_BLOCK_HEIGHT);
						numBlocks = numBlocksAcross * numBlocksDown;
						mipSize = numBlocks * blockSize;
					}
				} else {
					mipSize = mipWidth * mipHeight * 4;
				}
				const mipBuff = format === PIXELFORMAT_RGBA32F ? new Float32Array(data2, offset3, mipSize) : format === PIXELFORMAT_RGBA16F ? new Uint16Array(data2, offset3, mipSize) : new Uint8Array(data2, offset3, mipSize);
				if (!isCubemap) {
					texture._levels[i2] = mipBuff;
				} else {
					if (!texture._levels[i2]) texture._levels[i2] = [];
					texture._levels[i2][face] = mipBuff;
				}
				offset3 += mipSize * componentSize;
				mipWidth = Math.max(mipWidth * 0.5, 1);
				mipHeight = Math.max(mipHeight * 0.5, 1);
			}
		}
		texture.upload();
		return texture;
	}
};

var HdrParser = class extends TextureParser {
	canParse(context) {
		return context.ext === "hdr";
	}
	load(url, callback, asset) {
		this.handler.fetch(url, Http.ResponseType.ARRAY_BUFFER, callback, asset);
		if (asset.data && !asset.data.type) {
			asset.data.type = TEXTURETYPE_RGBE;
		}
	}
	open(url, data2, device, textureOptions = {}) {
		const textureData2 = this.parse(data2);
		if (!textureData2) {
			return null;
		}
		const texture = new Texture(device, {
			name: url,
			addressU: ADDRESS_REPEAT,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			minFilter: FILTER_NEAREST,
			magFilter: FILTER_NEAREST,
			width: textureData2.width,
			height: textureData2.height,
			levels: textureData2.levels,
			format: PIXELFORMAT_RGBA8,
			type: TEXTURETYPE_RGBE,
			...textureOptions,
			// requirements of RGBE encoded data, which override any asset-provided options: it
			// must stay in a linear format, and as it can't be filtered, it cannot use mipmaps
			srgb: false,
			mipmaps: false
		});
		texture.upload();
		return texture;
	}
	// https://floyd.lbl.gov/radiance/refer/filefmts.pdf with help from http://www.graphics.cornell.edu/~bjw/rgbe/rgbe.c
	parse(data2) {
		const readStream = new ReadStream(data2);
		const magic = readStream.readLine();
		if (!magic.startsWith("#?RADIANCE")) {
			return null;
		}
		const variables = {};
		while (true) {
			const line = readStream.readLine();
			if (line.length === 0) {
				break;
			} else {
				const parts = line.split("=");
				if (parts.length === 2) {
					variables[parts[0]] = parts[1];
				}
			}
		}
		if (!variables.hasOwnProperty("FORMAT")) {
			return null;
		}
		const resolution = readStream.readLine().split(" ");
		if (resolution.length !== 4) {
			return null;
		}
		const height = parseInt(resolution[1], 10);
		const width = parseInt(resolution[3], 10);
		const pixels = this._readPixels(readStream, width, height, resolution[0] === "-Y");
		if (!pixels) {
			return null;
		}
		return {
			width,
			height,
			levels: [pixels]
		};
	}
	_readPixels(readStream, width, height, flipY) {
		if (width < 8 || width > 32767) {
			return this._readPixelsFlat(readStream, width, height);
		}
		const rgbe = [0, 0, 0, 0];
		readStream.readArray(rgbe);
		if (rgbe[0] !== 2 || rgbe[1] !== 2 || (rgbe[2] & 128) !== 0) {
			readStream.skip(-4);
			return this._readPixelsFlat(readStream, width, height);
		}
		const buffer = new ArrayBuffer(width * height * 4);
		const view = new Uint8Array(buffer);
		let scanstart = flipY ? 0 : width * 4 * (height - 1);
		let x3, y2, i2, channel, count, value;
		for (y2 = 0; y2 < height; ++y2) {
			if (y2) {
				readStream.readArray(rgbe);
			}
			if ((rgbe[2] << 8) + rgbe[3] !== width) {
				return null;
			}
			for (channel = 0; channel < 4; ++channel) {
				x3 = 0;
				while (x3 < width) {
					count = readStream.readU8();
					if (count > 128) {
						count -= 128;
						if (x3 + count > width) {
							return null;
						}
						value = readStream.readU8();
						for (i2 = 0; i2 < count; ++i2) {
							view[scanstart + channel + 4 * x3++] = value;
						}
					} else {
						if (count === 0 || x3 + count > width) {
							return null;
						}
						for (i2 = 0; i2 < count; ++i2) {
							view[scanstart + channel + 4 * x3++] = readStream.readU8();
						}
					}
				}
			}
			scanstart += width * 4 * (flipY ? 1 : -1);
		}
		return view;
	}
	_readPixelsFlat(readStream, width, height) {
		return readStream.remainingBytes === width * height * 4 ? new Uint8Array(readStream.arraybuffer, readStream.offset) : null;
	}
};

var JSON_ADDRESS_MODE2 = {
	"repeat": ADDRESS_REPEAT,
	"clamp": ADDRESS_CLAMP_TO_EDGE,
	"mirror": ADDRESS_MIRRORED_REPEAT
};
var JSON_FILTER_MODE2 = {
	"nearest": FILTER_NEAREST,
	"linear": FILTER_LINEAR,
	"nearest_mip_nearest": FILTER_NEAREST_MIPMAP_NEAREST,
	"linear_mip_nearest": FILTER_LINEAR_MIPMAP_NEAREST,
	"nearest_mip_linear": FILTER_NEAREST_MIPMAP_LINEAR,
	"linear_mip_linear": FILTER_LINEAR_MIPMAP_LINEAR
};
var JSON_TEXTURE_TYPE = {
	"default": TEXTURETYPE_DEFAULT,
	"rgbm": TEXTURETYPE_RGBM,
	"rgbe": TEXTURETYPE_RGBE,
	"rgbp": TEXTURETYPE_RGBP,
	"swizzleGGGR": TEXTURETYPE_SWIZZLEGGGR
};
var _completePartialMipmapChain = function(texture) {
	const requiredMipLevels = TextureUtils.calcMipLevelsCount(texture._width, texture._height);
	const isHtmlElement = function(object) {
		return object instanceof HTMLCanvasElement || object instanceof HTMLImageElement || object instanceof HTMLVideoElement;
	};
	if (!(texture._format === PIXELFORMAT_RGBA8 || texture._format === PIXELFORMAT_RGBA32F) || texture._volume || texture._compressed || texture._levels.length === 1 || texture._levels.length === requiredMipLevels || isHtmlElement(texture._cubemap ? texture._levels[0][0] : texture._levels[0])) {
		return;
	}
	const downsample = function(width, height, data2) {
		const sampledWidth = Math.max(1, width >> 1);
		const sampledHeight = Math.max(1, height >> 1);
		const sampledData = new data2.constructor(sampledWidth * sampledHeight * 4);
		const xs = Math.floor(width / sampledWidth);
		const ys = Math.floor(height / sampledHeight);
		const xsys = xs * ys;
		for (let y2 = 0; y2 < sampledHeight; ++y2) {
			for (let x3 = 0; x3 < sampledWidth; ++x3) {
				for (let e = 0; e < 4; ++e) {
					let sum = 0;
					for (let sy = 0; sy < ys; ++sy) {
						for (let sx = 0; sx < xs; ++sx) {
							sum += data2[(x3 * xs + sx + (y2 * ys + sy) * width) * 4 + e];
						}
					}
					sampledData[(x3 + y2 * sampledWidth) * 4 + e] = sum / xsys;
				}
			}
		}
		return sampledData;
	};
	for (let level = texture._levels.length; level < requiredMipLevels; ++level) {
		const width = Math.max(1, texture._width >> level - 1);
		const height = Math.max(1, texture._height >> level - 1);
		if (texture._cubemap) {
			const mips = [];
			for (let face = 0; face < 6; ++face) {
				mips.push(downsample(width, height, texture._levels[level - 1][face]));
			}
			texture._levels.push(mips);
		} else {
			texture._levels.push(downsample(width, height, texture._levels[level - 1]));
		}
	}
	texture._levelsUpdated = texture._cubemap ? [[true, true, true, true, true, true]] : [true];
};
var TextureHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "texture");
		const device = app2.graphicsDevice;
		this._device = device;
		this.imgParser = new ImgParser(app2.assets, device);
		this.addParser(this.imgParser);
		this.addParser(new DdsParser());
		this.addParser(new KtxParser());
		this.addParser(new Ktx2Parser(device));
		this.addParser(new BasisParser(device));
		this.addParser(new HdrParser());
	}
	set crossOrigin(value) {
		this.imgParser.crossOrigin = value;
	}
	get crossOrigin() {
		return this.imgParser.crossOrigin;
	}
	_getTextureOptions(asset) {
		const options2 = {};
		if (asset) {
			if (asset.name?.length > 0) {
				options2.name = asset.name;
			}
			const assetData = asset.data;
			if (assetData.hasOwnProperty("minfilter")) {
				options2.minFilter = JSON_FILTER_MODE2[assetData.minfilter];
			}
			if (assetData.hasOwnProperty("magfilter")) {
				options2.magFilter = JSON_FILTER_MODE2[assetData.magfilter];
			}
			if (assetData.hasOwnProperty("addressu")) {
				options2.addressU = JSON_ADDRESS_MODE2[assetData.addressu];
			}
			if (assetData.hasOwnProperty("addressv")) {
				options2.addressV = JSON_ADDRESS_MODE2[assetData.addressv];
			}
			if (assetData.hasOwnProperty("mipmaps")) {
				options2.mipmaps = assetData.mipmaps;
			}
			if (assetData.hasOwnProperty("anisotropy")) {
				options2.anisotropy = assetData.anisotropy;
			}
			if (assetData.hasOwnProperty("flipY")) {
				options2.flipY = !!assetData.flipY;
			}
			if (assetData.hasOwnProperty("srgb")) {
				options2.srgb = !!assetData.srgb;
			}
			options2.type = TEXTURETYPE_DEFAULT;
			if (assetData.hasOwnProperty("type")) {
				options2.type = JSON_TEXTURE_TYPE[assetData.type];
			} else if (assetData.hasOwnProperty("rgbm") && assetData.rgbm) {
				options2.type = TEXTURETYPE_RGBM;
			} else if (asset.file && (asset.file.opt & 8) !== 0) {
				options2.type = TEXTURETYPE_SWIZZLEGGGR;
			}
			if (asset.options?.texture) {
				Object.assign(options2, asset.options.texture);
			}
		}
		return options2;
	}
	open(url, data2, asset) {
		if (!url) {
			return void 0;
		}
		const parser = this._selectParser(this._makeContext(url, asset));
		if (!parser) {
			return void 0;
		}
		const textureOptions = this._getTextureOptions(asset);
		let texture = parser.open(url, data2, this._device, textureOptions);
		if (texture === null) {
			texture = new Texture(this._device, {
				width: 4,
				height: 4,
				format: PIXELFORMAT_RGB8
			});
		} else {
			_completePartialMipmapChain(texture);
			if (data2.unswizzledGGGR) {
				asset.file.variants.basis.opt &= ~8;
			}
		}
		return texture;
	}
	patch(asset, assets) {
		const texture = asset.resource;
		if (!texture) {
			return;
		}
		const options2 = this._getTextureOptions(asset);
		for (const key of Object.keys(options2)) {
			texture[key] = options2[key];
		}
	}
};

var XRTYPE_INLINE = "inline";
var XRTYPE_VR = "immersive-vr";
var XRTYPE_AR = "immersive-ar";
var XRSPACE_VIEWER = "viewer";
var XRSPACE_LOCAL = "local";
var XRSPACE_LOCALFLOOR = "local-floor";
var XRSPACE_BOUNDEDFLOOR = "bounded-floor";
var XRSPACE_UNBOUNDED = "unbounded";
var XRTARGETRAY_GAZE = "gaze";
var XRTARGETRAY_SCREEN = "screen";
var XRTARGETRAY_POINTER = "tracked-pointer";
var XREYE_NONE = "none";
var XREYE_LEFT = "left";
var XREYE_RIGHT = "right";
var XRHAND_NONE = "none";
var XRHAND_LEFT = "left";
var XRHAND_RIGHT = "right";
var XRTRACKABLE_POINT = "point";
var XRTRACKABLE_PLANE = "plane";
var XRTRACKABLE_MESH = "mesh";
var XRDEPTHSENSINGUSAGE_CPU = "cpu-optimized";
var XRDEPTHSENSINGUSAGE_GPU = "gpu-optimized";
var XRDEPTHSENSINGFORMAT_L8A8 = "luminance-alpha";
var XRDEPTHSENSINGFORMAT_R16U = "unsigned-short";
var XRDEPTHSENSINGFORMAT_F32 = "float32";

var XrDomOverlay = class {
	_manager;
	_supported = platform.browser && !!window.XRDOMOverlayState;
	_root = null;
	constructor(manager) {
		this._manager = manager;
	}
	get supported() {
		return this._supported;
	}
	get available() {
		return this._supported && this._manager.active && this._manager._session.domOverlayState !== null;
	}
	get state() {
		if (!this._supported || !this._manager.active || !this._manager._session.domOverlayState) {
			return null;
		}
		return this._manager._session.domOverlayState.type;
	}
	set root(value) {
		if (!this._supported || this._manager.active) {
			return;
		}
		this._root = value;
	}
	get root() {
		return this._root;
	}
};

var poolVec3 = [];
var poolQuat = [];
var XrHitTestSource = class extends EventHandler {
	static EVENT_REMOVE = "remove";
	static EVENT_RESULT = "result";
	manager;
	_xrHitTestSource;
	_transient;
	_inputSource;
	constructor(manager, xrHitTestSource, transient, inputSource = null) {
		super();
		this.manager = manager;
		this._xrHitTestSource = xrHitTestSource;
		this._transient = transient;
		this._inputSource = inputSource;
	}
	remove() {
		if (!this._xrHitTestSource) {
			return;
		}
		const sources = this.manager.hitTest.sources;
		const ind = sources.indexOf(this);
		if (ind !== -1) sources.splice(ind, 1);
		this.onStop();
	}
	onStop() {
		this._xrHitTestSource.cancel();
		this._xrHitTestSource = null;
		this.fire("remove");
		this.manager.hitTest.fire("remove", this);
	}
	update(frame) {
		if (this._transient) {
			const transientResults = frame.getHitTestResultsForTransientInput(this._xrHitTestSource);
			for (let i2 = 0; i2 < transientResults.length; i2++) {
				const transientResult = transientResults[i2];
				if (!transientResult.results.length) {
					continue;
				}
				let inputSource;
				if (transientResult.inputSource) {
					inputSource = this.manager.input._getByInputSource(transientResult.inputSource);
				}
				this.updateHitResults(transientResult.results, inputSource);
			}
		} else {
			const results = frame.getHitTestResults(this._xrHitTestSource);
			if (!results.length) {
				return;
			}
			this.updateHitResults(results);
		}
	}
	updateHitResults(results, inputSource) {
		if (this._inputSource && this._inputSource !== inputSource) {
			return;
		}
		const origin = poolVec3.pop() ?? new Vec3();
		if (inputSource) {
			origin.copy(inputSource.getOrigin());
		} else {
			origin.copy(this.manager.camera.getPosition());
		}
		let candidateDistance = Infinity;
		let candidateHitTestResult = null;
		const position5 = poolVec3.pop() ?? new Vec3();
		const rotation7 = poolQuat.pop() ?? new Quat();
		for (let i2 = 0; i2 < results.length; i2++) {
			const pose = results[i2].getPose(this.manager._referenceSpace);
			const distance = origin.distance(pose.transform.position);
			if (distance >= candidateDistance) {
				continue;
			}
			candidateDistance = distance;
			candidateHitTestResult = results[i2];
			position5.copy(pose.transform.position);
			rotation7.copy(pose.transform.orientation);
		}
		this.fire("result", position5, rotation7, inputSource || this._inputSource, candidateHitTestResult);
		this.manager.hitTest.fire("result", this, position5, rotation7, inputSource || this._inputSource, candidateHitTestResult);
		poolVec3.push(origin);
		poolVec3.push(position5);
		poolQuat.push(rotation7);
	}
};

var XrHitTest = class extends EventHandler {
	static EVENT_AVAILABLE = "available";
	static EVENT_UNAVAILABLE = "unavailable";
	static EVENT_ADD = "add";
	static EVENT_REMOVE = "remove";
	static EVENT_RESULT = "result";
	static EVENT_ERROR = "error";
	manager;
	_supported = platform.browser && !!(window.XRSession && window.XRSession.prototype.requestHitTestSource);
	_available = false;
	_checkingAvailability = false;
	sources = [];
	constructor(manager) {
		super();
		this.manager = manager;
		if (this._supported) {
			this.manager.on("start", this._onSessionStart, this);
			this.manager.on("end", this._onSessionEnd, this);
		}
	}
	_onSessionStart() {
		if (this.manager.session.enabledFeatures) {
			const available = this.manager.session.enabledFeatures.indexOf("hit-test") !== -1;
			if (!available) return;
			this._available = available;
			this.fire("available");
		} else if (!this._checkingAvailability) {
			this._checkingAvailability = true;
			this.manager.session.requestReferenceSpace(XRSPACE_VIEWER).then((referenceSpace) => {
				this.manager.session.requestHitTestSource({
					space: referenceSpace
				}).then((hitTestSource) => {
					hitTestSource.cancel();
					if (this.manager.active) {
						this._available = true;
						this.fire("available");
					}
				}).catch(() => {
				});
			}).catch(() => {
			});
		}
	}
	_onSessionEnd() {
		if (!this._available) return;
		this._available = false;
		for (let i2 = 0; i2 < this.sources.length; i2++) {
			this.sources[i2].onStop();
		}
		this.sources = [];
		this.fire("unavailable");
	}
	start(options2 = {}) {
		if (!this._supported) {
			options2.callback?.(new Error("XR HitTest is not supported"), null);
			return;
		}
		if (!this._available) {
			options2.callback?.(new Error("XR HitTest is not available"), null);
			return;
		}
		if (!options2.profile && !options2.spaceType) {
			options2.spaceType = XRSPACE_VIEWER;
		}
		let xrRay;
		const offsetRay = options2.offsetRay;
		if (offsetRay) {
			const origin = new DOMPoint(offsetRay.origin.x, offsetRay.origin.y, offsetRay.origin.z, 1);
			const direction = new DOMPoint(offsetRay.direction.x, offsetRay.direction.y, offsetRay.direction.z, 0);
			xrRay = new XRRay(origin, direction);
		}
		const callback = options2.callback;
		if (options2.spaceType) {
			this.manager.session.requestReferenceSpace(options2.spaceType).then((referenceSpace) => {
				if (!this.manager.session) {
					const err2 = new Error("XR Session is not started (2)");
					if (callback) callback(err2);
					this.fire("error", err2);
					return;
				}
				this.manager.session.requestHitTestSource({
					space: referenceSpace,
					entityTypes: options2.entityTypes || void 0,
					offsetRay: xrRay
				}).then((xrHitTestSource) => {
					this._onHitTestSource(xrHitTestSource, false, options2.inputSource, callback);
				}).catch((ex) => {
					if (callback) callback(ex);
					this.fire("error", ex);
				});
			}).catch((ex) => {
				if (callback) callback(ex);
				this.fire("error", ex);
			});
		} else {
			this.manager.session.requestHitTestSourceForTransientInput({
				profile: options2.profile,
				entityTypes: options2.entityTypes || void 0,
				offsetRay: xrRay
			}).then((xrHitTestSource) => {
				this._onHitTestSource(xrHitTestSource, true, options2.inputSource, callback);
			}).catch((ex) => {
				if (callback) callback(ex);
				this.fire("error", ex);
			});
		}
	}
	_onHitTestSource(xrHitTestSource, transient, inputSource, callback) {
		if (!this.manager.session) {
			xrHitTestSource.cancel();
			const err2 = new Error("XR Session is not started (3)");
			if (callback) callback(err2);
			this.fire("error", err2);
			return;
		}
		const hitTestSource = new XrHitTestSource(this.manager, xrHitTestSource, transient, inputSource ?? null);
		this.sources.push(hitTestSource);
		if (callback) callback(null, hitTestSource);
		this.fire("add", hitTestSource);
	}
	update(frame) {
		if (!this._available) {
			return;
		}
		for (let i2 = 0; i2 < this.sources.length; i2++) {
			this.sources[i2].update(frame);
		}
	}
	get supported() {
		return this._supported;
	}
	get available() {
		return this._available;
	}
};

var XrTrackedImage = class extends EventHandler {
	static EVENT_TRACKED = "tracked";
	static EVENT_UNTRACKED = "untracked";
	_image;
	_width;
	_bitmap = null;
	_measuredWidth = 0;
	_trackable = false;
	_tracking = false;
	_emulated = false;
	_pose = null;
	_position = new Vec3();
	_rotation = new Quat();
	constructor(image, width) {
		super();
		this._image = image;
		this._width = width;
	}
	get image() {
		return this._image;
	}
	set width(value) {
		this._width = value;
	}
	get width() {
		return this._width;
	}
	get trackable() {
		return this._trackable;
	}
	get tracking() {
		return this._tracking;
	}
	get emulated() {
		return this._emulated;
	}
	prepare() {
		if (this._bitmap) {
			return {
				image: this._bitmap,
				widthInMeters: this._width
			};
		}
		return createImageBitmap(this._image).then((bitmap) => {
			this._bitmap = bitmap;
			return {
				image: this._bitmap,
				widthInMeters: this._width
			};
		});
	}
	destroy() {
		this._image = null;
		this._pose = null;
		if (this._bitmap) {
			this._bitmap.close();
			this._bitmap = null;
		}
	}
	getPosition() {
		if (this._pose) this._position.copy(this._pose.transform.position);
		return this._position;
	}
	getRotation() {
		if (this._pose) this._rotation.copy(this._pose.transform.orientation);
		return this._rotation;
	}
};

var XrImageTracking = class extends EventHandler {
	static EVENT_ERROR = "error";
	_manager;
	_supported = platform.browser && !!window.XRImageTrackingResult;
	_available = false;
	_images = [];
	constructor(manager) {
		super();
		this._manager = manager;
		if (this._supported) {
			this._manager.on("start", this._onSessionStart, this);
			this._manager.on("end", this._onSessionEnd, this);
		}
	}
	add(image, width) {
		if (!this._supported || this._manager.active) return null;
		const trackedImage = new XrTrackedImage(image, width);
		this._images.push(trackedImage);
		return trackedImage;
	}
	remove(trackedImage) {
		if (this._manager.active) return;
		const ind = this._images.indexOf(trackedImage);
		if (ind !== -1) {
			trackedImage.destroy();
			this._images.splice(ind, 1);
		}
	}
	_onSessionStart() {
		this._manager.session.getTrackedImageScores().then((images) => {
			this._available = true;
			for (let i2 = 0; i2 < images.length; i2++) {
				this._images[i2]._trackable = images[i2] === "trackable";
			}
		}).catch((err2) => {
			this._available = false;
			this.fire("error", err2);
		});
	}
	_onSessionEnd() {
		this._available = false;
		for (let i2 = 0; i2 < this._images.length; i2++) {
			const image = this._images[i2];
			image._pose = null;
			image._measuredWidth = 0;
			if (image._tracking) {
				image._tracking = false;
				image.fire("untracked");
			}
		}
	}
	prepareImages(callback) {
		if (this._images.length) {
			Promise.all(this._images.map((trackedImage) => {
				return trackedImage.prepare();
			})).then((bitmaps) => {
				callback(null, bitmaps);
			}).catch((err2) => {
				callback(err2, null);
			});
		} else {
			callback(null, null);
		}
	}
	update(frame) {
		if (!this._available) return;
		const results = frame.getImageTrackingResults();
		const index = {};
		for (let i2 = 0; i2 < results.length; i2++) {
			index[results[i2].index] = results[i2];
			const trackedImage = this._images[results[i2].index];
			trackedImage._emulated = results[i2].trackingState === "emulated";
			trackedImage._measuredWidth = results[i2].measuredWidthInMeters;
			trackedImage._pose = frame.getPose(results[i2].imageSpace, this._manager._referenceSpace);
		}
		for (let i2 = 0; i2 < this._images.length; i2++) {
			if (this._images[i2]._tracking && !index[i2]) {
				this._images[i2]._tracking = false;
				this._images[i2].fire("untracked");
			} else if (!this._images[i2]._tracking && index[i2]) {
				this._images[i2]._tracking = true;
				this._images[i2].fire("tracked");
			}
		}
	}
	get supported() {
		return this._supported;
	}
	get available() {
		return this._available;
	}
	get images() {
		return this._images;
	}
};

var XrFinger = class {
	_index;
	_hand;
	_joints = [];
	_tip = null;
	constructor(index, hand) {
		this._index = index;
		this._hand = hand;
		this._hand._fingers.push(this);
	}
	get index() {
		return this._index;
	}
	get hand() {
		return this._hand;
	}
	get joints() {
		return this._joints;
	}
	get tip() {
		return this._tip;
	}
};

var tipJointIds = platform.browser && window.XRHand ? [
	"thumb-tip",
	"index-finger-tip",
	"middle-finger-tip",
	"ring-finger-tip",
	"pinky-finger-tip"
] : [];
var tipJointIdsIndex = {};
for (let i2 = 0; i2 < tipJointIds.length; i2++) {
	tipJointIdsIndex[tipJointIds[i2]] = true;
}
var XrJoint = class {
	_index;
	_id;
	_hand;
	_finger;
	_wrist;
	_tip;
	_radius = null;
	_localTransform = new Mat4();
	_worldTransform = new Mat4();
	_localPosition = new Vec3();
	_localRotation = new Quat();
	_position = new Vec3();
	_rotation = new Quat();
	_dirtyLocal = true;
	constructor(index, id14, hand, finger = null) {
		this._index = index;
		this._id = id14;
		this._hand = hand;
		this._finger = finger;
		this._wrist = id14 === "wrist";
		this._tip = this._finger && !!tipJointIdsIndex[id14];
	}
	update(pose) {
		this._dirtyLocal = true;
		this._radius = pose.radius;
		this._localPosition.copy(pose.transform.position);
		this._localRotation.copy(pose.transform.orientation);
	}
	_updateTransforms() {
		if (this._dirtyLocal) {
			this._dirtyLocal = false;
			this._localTransform.setTRS(this._localPosition, this._localRotation, Vec3.ONE);
		}
		const manager = this._hand._manager;
		const parent = manager.camera.parent;
		if (parent) {
			this._worldTransform.mul2(parent.getWorldTransform(), this._localTransform);
		} else {
			this._worldTransform.copy(this._localTransform);
		}
	}
	getPosition() {
		this._updateTransforms();
		this._worldTransform.getTranslation(this._position);
		return this._position;
	}
	getRotation() {
		this._updateTransforms();
		this._rotation.setFromMat4(this._worldTransform);
		return this._rotation;
	}
	get id() {
		return this._id;
	}
	get index() {
		return this._index;
	}
	get hand() {
		return this._hand;
	}
	get finger() {
		return this._finger;
	}
	get wrist() {
		return this._wrist;
	}
	get tip() {
		return this._tip;
	}
	get radius() {
		return this._radius || 5e-3;
	}
};

var fingerJointIds = [];
var vecA2 = new Vec3();
var vecB2 = new Vec3();
var vecC = new Vec3();
if (platform.browser && window.XRHand) {
	fingerJointIds = [
		["thumb-metacarpal", "thumb-phalanx-proximal", "thumb-phalanx-distal", "thumb-tip"],
		["index-finger-metacarpal", "index-finger-phalanx-proximal", "index-finger-phalanx-intermediate", "index-finger-phalanx-distal", "index-finger-tip"],
		["middle-finger-metacarpal", "middle-finger-phalanx-proximal", "middle-finger-phalanx-intermediate", "middle-finger-phalanx-distal", "middle-finger-tip"],
		["ring-finger-metacarpal", "ring-finger-phalanx-proximal", "ring-finger-phalanx-intermediate", "ring-finger-phalanx-distal", "ring-finger-tip"],
		["pinky-finger-metacarpal", "pinky-finger-phalanx-proximal", "pinky-finger-phalanx-intermediate", "pinky-finger-phalanx-distal", "pinky-finger-tip"]
	];
}
var XrHand = class extends EventHandler {
	static EVENT_TRACKING = "tracking";
	static EVENT_TRACKINGLOST = "trackinglost";
	_manager;
	_inputSource;
	_tracking = false;
	_fingers = [];
	_joints = [];
	_jointsById = {};
	_tips = [];
	_wrist = null;
	constructor(inputSource) {
		super();
		const xrHand = inputSource._xrInputSource.hand;
		this._manager = inputSource._manager;
		this._inputSource = inputSource;
		if (xrHand.get("wrist")) {
			const joint = new XrJoint(0, "wrist", this, null);
			this._wrist = joint;
			this._joints.push(joint);
			this._jointsById.wrist = joint;
		}
		for (let f = 0; f < fingerJointIds.length; f++) {
			const finger = new XrFinger(f, this);
			for (let j = 0; j < fingerJointIds[f].length; j++) {
				const jointId = fingerJointIds[f][j];
				if (!xrHand.get(jointId)) continue;
				const joint = new XrJoint(j, jointId, this, finger);
				this._joints.push(joint);
				this._jointsById[jointId] = joint;
				if (joint.tip) {
					this._tips.push(joint);
					finger._tip = joint;
				}
				finger._joints.push(joint);
			}
		}
	}
	update(frame) {
		const xrInputSource = this._inputSource._xrInputSource;
		for (let j = 0; j < this._joints.length; j++) {
			const joint = this._joints[j];
			const jointSpace = xrInputSource.hand.get(joint._id);
			if (jointSpace) {
				let pose;
				if (frame.session.visibilityState !== "hidden") {
					pose = frame.getJointPose(jointSpace, this._manager._referenceSpace);
				}
				if (pose) {
					joint.update(pose);
					if (joint.wrist && !this._tracking) {
						this._tracking = true;
						this.fire("tracking");
					}
				} else if (joint.wrist) {
					if (this._tracking) {
						this._tracking = false;
						this.fire("trackinglost");
					}
					break;
				}
			}
		}
		const j1 = this._jointsById["thumb-metacarpal"];
		const j4 = this._jointsById["thumb-tip"];
		const j6 = this._jointsById["index-finger-phalanx-proximal"];
		const j9 = this._jointsById["index-finger-tip"];
		const j16 = this._jointsById["ring-finger-phalanx-proximal"];
		const j21 = this._jointsById["pinky-finger-phalanx-proximal"];
		if (j1 && j4 && j6 && j9 && j16 && j21) {
			this._inputSource._dirtyRay = true;
			this._inputSource._rayLocal.origin.lerp(j4._localPosition, j9._localPosition, 0.5);
			let jointL = j1;
			let jointR = j21;
			if (this._inputSource.handedness === XRHAND_LEFT) {
				const t = jointL;
				jointL = jointR;
				jointR = t;
			}
			vecA2.sub2(jointL._localPosition, this._wrist._localPosition);
			vecB2.sub2(jointR._localPosition, this._wrist._localPosition);
			vecC.cross(vecA2, vecB2).normalize();
			vecA2.lerp(j6._localPosition, j16._localPosition, 0.5);
			vecA2.sub(this._wrist._localPosition).normalize();
			this._inputSource._rayLocal.direction.lerp(vecC, vecA2, 0.5).normalize();
		}
		const squeezing = this._fingerIsClosed(1) && this._fingerIsClosed(2) && this._fingerIsClosed(3) && this._fingerIsClosed(4);
		if (squeezing) {
			if (!this._inputSource._squeezing) {
				this._inputSource._squeezing = true;
				this._inputSource.fire("squeezestart");
				this._manager.input.fire("squeezestart", this._inputSource);
			}
		} else {
			if (this._inputSource._squeezing) {
				this._inputSource._squeezing = false;
				this._inputSource.fire("squeeze");
				this._manager.input.fire("squeeze", this._inputSource);
				this._inputSource.fire("squeezeend");
				this._manager.input.fire("squeezeend", this._inputSource);
			}
		}
	}
	_fingerIsClosed(index) {
		const finger = this._fingers[index];
		vecA2.sub2(finger.joints[0]._localPosition, finger.joints[1]._localPosition).normalize();
		vecB2.sub2(finger.joints[2]._localPosition, finger.joints[3]._localPosition).normalize();
		return vecA2.dot(vecB2) < -0.8;
	}
	getJointById(id14) {
		return this._jointsById[id14] || null;
	}
	get fingers() {
		return this._fingers;
	}
	get joints() {
		return this._joints;
	}
	get tips() {
		return this._tips;
	}
	get wrist() {
		return this._wrist;
	}
	get tracking() {
		return this._tracking;
	}
};

var vec3A = new Vec3();
var quat3 = new Quat();
var ids = 0;
var XrInputSource = class extends EventHandler {
	static EVENT_REMOVE = "remove";
	static EVENT_SELECT = "select";
	static EVENT_SELECTSTART = "selectstart";
	static EVENT_SELECTEND = "selectend";
	static EVENT_SQUEEZE = "squeeze";
	static EVENT_SQUEEZESTART = "squeezestart";
	static EVENT_SQUEEZEEND = "squeezeend";
	static EVENT_HITTESTADD = "hittest:add";
	static EVENT_HITTESTREMOVE = "hittest:remove";
	static EVENT_HITTESTRESULT = "hittest:result";
	_id;
	_manager;
	_xrInputSource;
	_ray = new Ray();
	_rayLocal = new Ray();
	_grip = false;
	_hand = null;
	_velocitiesAvailable = false;
	_velocitiesTimestamp = now();
	_localTransform = null;
	_worldTransform = null;
	_position = new Vec3();
	_rotation = new Quat();
	_localPosition = null;
	_localPositionLast = null;
	_localRotation = null;
	_linearVelocity = null;
	_dirtyLocal = true;
	_dirtyRay = false;
	_selecting = false;
	_squeezing = false;
	_elementInput = true;
	_elementEntity = null;
	_hitTestSources = [];
	constructor(manager, xrInputSource) {
		super();
		this._id = ++ids;
		this._manager = manager;
		this._xrInputSource = xrInputSource;
		if (xrInputSource.hand) {
			this._hand = new XrHand(this);
		}
	}
	get id() {
		return this._id;
	}
	get inputSource() {
		return this._xrInputSource;
	}
	get targetRayMode() {
		return this._xrInputSource.targetRayMode;
	}
	get handedness() {
		return this._xrInputSource.handedness;
	}
	get profiles() {
		return this._xrInputSource.profiles;
	}
	get grip() {
		return this._grip;
	}
	get hand() {
		return this._hand;
	}
	get gamepad() {
		return this._xrInputSource.gamepad || null;
	}
	get selecting() {
		return this._selecting;
	}
	get squeezing() {
		return this._squeezing;
	}
	set elementInput(value) {
		if (this._elementInput === value) {
			return;
		}
		this._elementInput = value;
		if (!this._elementInput) {
			this._elementEntity = null;
		}
	}
	get elementInput() {
		return this._elementInput;
	}
	get elementEntity() {
		return this._elementEntity;
	}
	get hitTestSources() {
		return this._hitTestSources;
	}
	update(frame) {
		if (this._hand) {
			this._hand.update(frame);
		} else {
			const gripSpace = this._xrInputSource.gripSpace;
			if (gripSpace) {
				const gripPose = frame.getPose(gripSpace, this._manager._referenceSpace);
				if (gripPose) {
					if (!this._grip) {
						this._grip = true;
						this._localTransform = new Mat4();
						this._worldTransform = new Mat4();
						this._localPositionLast = new Vec3();
						this._localPosition = new Vec3();
						this._localRotation = new Quat();
						this._linearVelocity = new Vec3();
					}
					const timestamp = now();
					const dt = (timestamp - this._velocitiesTimestamp) / 1e3;
					this._velocitiesTimestamp = timestamp;
					this._dirtyLocal = true;
					this._localPositionLast.copy(this._localPosition);
					this._localPosition.copy(gripPose.transform.position);
					this._localRotation.copy(gripPose.transform.orientation);
					this._velocitiesAvailable = true;
					if (this._manager.input.velocitiesSupported && gripPose.linearVelocity) {
						this._linearVelocity.copy(gripPose.linearVelocity);
					} else if (dt > 0) {
						vec3A.sub2(this._localPosition, this._localPositionLast).divScalar(dt);
						this._linearVelocity.lerp(this._linearVelocity, vec3A, 0.15);
					}
				} else {
					this._velocitiesAvailable = false;
				}
			}
			const targetRayPose = frame.getPose(this._xrInputSource.targetRaySpace, this._manager._referenceSpace);
			if (targetRayPose) {
				this._dirtyRay = true;
				this._rayLocal.origin.copy(targetRayPose.transform.position);
				this._rayLocal.direction.set(0, 0, -1);
				quat3.copy(targetRayPose.transform.orientation);
				quat3.transformVector(this._rayLocal.direction, this._rayLocal.direction);
			}
		}
	}
	_updateTransforms() {
		if (this._dirtyLocal) {
			this._dirtyLocal = false;
			this._localTransform.setTRS(this._localPosition, this._localRotation, Vec3.ONE);
		}
		const parent = this._manager.camera.parent;
		if (parent) {
			this._worldTransform.mul2(parent.getWorldTransform(), this._localTransform);
		} else {
			this._worldTransform.copy(this._localTransform);
		}
	}
	_updateRayTransforms() {
		const dirty = this._dirtyRay;
		this._dirtyRay = false;
		const parent = this._manager.camera.parent;
		if (parent) {
			const parentTransform = parent.getWorldTransform();
			parentTransform.getTranslation(this._position);
			this._rotation.setFromMat4(parentTransform);
			this._rotation.transformVector(this._rayLocal.origin, this._ray.origin);
			this._ray.origin.add(this._position);
			this._rotation.transformVector(this._rayLocal.direction, this._ray.direction);
		} else if (dirty) {
			this._ray.origin.copy(this._rayLocal.origin);
			this._ray.direction.copy(this._rayLocal.direction);
		}
	}
	getPosition() {
		if (!this._grip) return null;
		this._updateTransforms();
		this._worldTransform.getTranslation(this._position);
		return this._position;
	}
	getLocalPosition() {
		return this._localPosition;
	}
	getRotation() {
		if (!this._grip) return null;
		this._updateTransforms();
		this._rotation.setFromMat4(this._worldTransform);
		return this._rotation;
	}
	getLocalRotation() {
		return this._localRotation;
	}
	getLinearVelocity() {
		if (!this._velocitiesAvailable) {
			return null;
		}
		return this._linearVelocity;
	}
	getOrigin() {
		this._updateRayTransforms();
		return this._ray.origin;
	}
	getDirection() {
		this._updateRayTransforms();
		return this._ray.direction;
	}
	hitTestStart(options2 = {}) {
		options2.inputSource = this;
		options2.profile = this._xrInputSource.profiles[0];
		const callback = options2.callback;
		options2.callback = (err2, hitTestSource) => {
			if (hitTestSource) this.onHitTestSourceAdd(hitTestSource);
			if (callback) callback(err2, hitTestSource);
		};
		this._manager.hitTest.start(options2);
	}
	onHitTestSourceAdd(hitTestSource) {
		this._hitTestSources.push(hitTestSource);
		this.fire("hittest:add", hitTestSource);
		hitTestSource.on("result", (position5, rotation7, inputSource, hitTestResult) => {
			if (inputSource !== this) return;
			this.fire("hittest:result", hitTestSource, position5, rotation7, hitTestResult);
		});
		hitTestSource.once("remove", () => {
			this.onHitTestSourceRemove(hitTestSource);
			this.fire("hittest:remove", hitTestSource);
		});
	}
	onHitTestSourceRemove(hitTestSource) {
		const ind = this._hitTestSources.indexOf(hitTestSource);
		if (ind !== -1) this._hitTestSources.splice(ind, 1);
	}
};

var XrInput = class extends EventHandler {
	static EVENT_ADD = "add";
	static EVENT_REMOVE = "remove";
	static EVENT_SELECT = "select";
	static EVENT_SELECTSTART = "selectstart";
	static EVENT_SELECTEND = "selectend";
	static EVENT_SQUEEZE = "squeeze";
	static EVENT_SQUEEZESTART = "squeezestart";
	static EVENT_SQUEEZEEND = "squeezeend";
	manager;
	_inputSources = [];
	_onInputSourcesChangeEvt;
	velocitiesSupported = false;
	constructor(manager) {
		super();
		this.manager = manager;
		this.velocitiesSupported = !!(platform.browser && window.XRPose?.prototype?.hasOwnProperty("linearVelocity"));
		this._onInputSourcesChangeEvt = (evt) => {
			this._onInputSourcesChange(evt);
		};
		this.manager.on("start", this._onSessionStart, this);
		this.manager.on("end", this._onSessionEnd, this);
	}
	_onSessionStart() {
		const session = this.manager.session;
		session.addEventListener("inputsourceschange", this._onInputSourcesChangeEvt);
		session.addEventListener("select", (evt) => {
			const inputSource = this._getByInputSource(evt.inputSource);
			inputSource.update(evt.frame);
			inputSource.fire("select", evt);
			this.fire("select", inputSource, evt);
		});
		session.addEventListener("selectstart", (evt) => {
			const inputSource = this._getByInputSource(evt.inputSource);
			inputSource.update(evt.frame);
			inputSource._selecting = true;
			inputSource.fire("selectstart", evt);
			this.fire("selectstart", inputSource, evt);
		});
		session.addEventListener("selectend", (evt) => {
			const inputSource = this._getByInputSource(evt.inputSource);
			inputSource.update(evt.frame);
			inputSource._selecting = false;
			inputSource.fire("selectend", evt);
			this.fire("selectend", inputSource, evt);
		});
		session.addEventListener("squeeze", (evt) => {
			const inputSource = this._getByInputSource(evt.inputSource);
			inputSource.update(evt.frame);
			inputSource.fire("squeeze", evt);
			this.fire("squeeze", inputSource, evt);
		});
		session.addEventListener("squeezestart", (evt) => {
			const inputSource = this._getByInputSource(evt.inputSource);
			inputSource.update(evt.frame);
			inputSource._squeezing = true;
			inputSource.fire("squeezestart", evt);
			this.fire("squeezestart", inputSource, evt);
		});
		session.addEventListener("squeezeend", (evt) => {
			const inputSource = this._getByInputSource(evt.inputSource);
			inputSource.update(evt.frame);
			inputSource._squeezing = false;
			inputSource.fire("squeezeend", evt);
			this.fire("squeezeend", inputSource, evt);
		});
		const inputSources = session.inputSources;
		for (let i2 = 0; i2 < inputSources.length; i2++) {
			this._addInputSource(inputSources[i2]);
		}
	}
	_onSessionEnd() {
		let i2 = this._inputSources.length;
		while (i2--) {
			const inputSource = this._inputSources[i2];
			this._inputSources.splice(i2, 1);
			inputSource.fire("remove");
			this.fire("remove", inputSource);
		}
		const session = this.manager.session;
		session.removeEventListener("inputsourceschange", this._onInputSourcesChangeEvt);
	}
	_onInputSourcesChange(evt) {
		for (let i2 = 0; i2 < evt.removed.length; i2++) {
			this._removeInputSource(evt.removed[i2]);
		}
		for (let i2 = 0; i2 < evt.added.length; i2++) {
			this._addInputSource(evt.added[i2]);
		}
	}
	_getByInputSource(xrInputSource) {
		for (let i2 = 0; i2 < this._inputSources.length; i2++) {
			if (this._inputSources[i2].inputSource === xrInputSource) {
				return this._inputSources[i2];
			}
		}
		return null;
	}
	_addInputSource(xrInputSource) {
		if (this._getByInputSource(xrInputSource)) {
			return;
		}
		const inputSource = new XrInputSource(this.manager, xrInputSource);
		this._inputSources.push(inputSource);
		this.fire("add", inputSource);
	}
	_removeInputSource(xrInputSource) {
		for (let i2 = 0; i2 < this._inputSources.length; i2++) {
			if (this._inputSources[i2].inputSource !== xrInputSource) {
				continue;
			}
			const inputSource = this._inputSources[i2];
			this._inputSources.splice(i2, 1);
			let h2 = inputSource.hitTestSources.length;
			while (h2--) {
				inputSource.hitTestSources[h2].remove();
			}
			inputSource.fire("remove");
			this.fire("remove", inputSource);
			return;
		}
	}
	update(frame) {
		for (let i2 = 0; i2 < this._inputSources.length; i2++) {
			this._inputSources[i2].update(frame);
		}
	}
	get inputSources() {
		return this._inputSources;
	}
};

var vec3A2 = new Vec3();
var vec3B = new Vec3();
var mat4A = new Mat4();
var mat4B = new Mat4();
var XrLightEstimation = class extends EventHandler {
	static EVENT_AVAILABLE = "available";
	static EVENT_ERROR = "error";
	_manager;
	_supported = false;
	_available = false;
	_lightProbeRequested = false;
	_lightProbe = null;
	_intensity = 0;
	_rotation = new Quat();
	_color = new Color();
	_sphericalHarmonics = new Float32Array(27);
	constructor(manager) {
		super();
		this._manager = manager;
		this._manager.on("start", this._onSessionStart, this);
		this._manager.on("end", this._onSessionEnd, this);
	}
	_onSessionStart() {
		const supported = !!this._manager.session.requestLightProbe;
		if (!supported) return;
		this._supported = true;
	}
	_onSessionEnd() {
		this._supported = false;
		this._available = false;
		this._lightProbeRequested = false;
		this._lightProbe = null;
	}
	start() {
		let err2;
		if (!this._manager.session) {
			err2 = new Error("XR session is not running");
		}
		if (!err2 && this._manager.type !== XRTYPE_AR) {
			err2 = new Error("XR session type is not AR");
		}
		if (!err2 && !this._supported) {
			err2 = new Error("light-estimation is not supported");
		}
		if (!err2 && this._lightProbe || this._lightProbeRequested) {
			err2 = new Error("light estimation is already requested");
		}
		if (err2) {
			this.fire("error", err2);
			return;
		}
		this._lightProbeRequested = true;
		this._manager.session.requestLightProbe().then((lightProbe) => {
			const wasRequested = this._lightProbeRequested;
			this._lightProbeRequested = false;
			if (this._manager.active) {
				if (wasRequested) {
					this._lightProbe = lightProbe;
				}
			} else {
				this.fire("error", new Error("XR session is not active"));
			}
		}).catch((ex) => {
			this._lightProbeRequested = false;
			this.fire("error", ex);
		});
	}
	end() {
		this._lightProbeRequested = false;
		this._lightProbe = null;
		this._available = false;
	}
	update(frame) {
		if (!this._lightProbe) return;
		const lightEstimate = frame.getLightEstimate(this._lightProbe);
		if (!lightEstimate) return;
		if (!this._available) {
			this._available = true;
			this.fire("available");
		}
		const pli = lightEstimate.primaryLightIntensity;
		this._intensity = Math.max(1, Math.max(pli.x, Math.max(pli.y, pli.z)));
		vec3A2.copy(pli).mulScalar(1 / this._intensity);
		this._color.set(vec3A2.x, vec3A2.y, vec3A2.z);
		vec3A2.set(0, 0, 0);
		vec3B.copy(lightEstimate.primaryLightDirection);
		mat4A.setLookAt(vec3B, vec3A2, Vec3.UP);
		mat4B.setFromAxisAngle(Vec3.RIGHT, 90);
		mat4A.mul(mat4B);
		this._rotation.setFromMat4(mat4A);
		this._sphericalHarmonics.set(lightEstimate.sphericalHarmonicsCoefficients);
	}
	get supported() {
		return this._supported;
	}
	get available() {
		return this._available;
	}
	get intensity() {
		return this._available ? this._intensity : null;
	}
	get color() {
		return this._available ? this._color : null;
	}
	get rotation() {
		return this._available ? this._rotation : null;
	}
	get sphericalHarmonics() {
		return this._available ? this._sphericalHarmonics : null;
	}
};

var ids2 = 0;
var XrPlane = class extends EventHandler {
	static EVENT_REMOVE = "remove";
	static EVENT_CHANGE = "change";
	_id;
	_planeDetection;
	_xrPlane;
	_lastChangedTime;
	_orientation;
	_position = new Vec3();
	_rotation = new Quat();
	constructor(planeDetection, xrPlane) {
		super();
		this._id = ++ids2;
		this._planeDetection = planeDetection;
		this._xrPlane = xrPlane;
		this._lastChangedTime = xrPlane.lastChangedTime;
		this._orientation = xrPlane.orientation;
	}
	destroy() {
		if (!this._xrPlane) return;
		this._xrPlane = null;
		this.fire("remove");
	}
	update(frame) {
		const manager = this._planeDetection._manager;
		const pose = frame.getPose(this._xrPlane.planeSpace, manager._referenceSpace);
		if (pose) {
			this._position.copy(pose.transform.position);
			this._rotation.copy(pose.transform.orientation);
		}
		if (this._lastChangedTime !== this._xrPlane.lastChangedTime) {
			this._lastChangedTime = this._xrPlane.lastChangedTime;
			this.fire("change");
		}
	}
	getPosition() {
		return this._position;
	}
	getRotation() {
		return this._rotation;
	}
	get id() {
		return this._id;
	}
	get orientation() {
		return this._orientation;
	}
	get points() {
		return this._xrPlane.polygon;
	}
	get label() {
		return this._xrPlane.semanticLabel || "";
	}
};

var XrPlaneDetection = class extends EventHandler {
	static EVENT_AVAILABLE = "available";
	static EVENT_UNAVAILABLE = "unavailable";
	static EVENT_ADD = "add";
	static EVENT_REMOVE = "remove";
	_manager;
	_supported = platform.browser && !!window.XRPlane;
	_available = false;
	_planesIndex = /* @__PURE__ */ new Map();
	_planes = [];
	constructor(manager) {
		super();
		this._manager = manager;
		if (this._supported) {
			this._manager.on("start", this._onSessionStart, this);
			this._manager.on("end", this._onSessionEnd, this);
		}
	}
	_onSessionStart() {
		if (this._manager.session.enabledFeatures) {
			const available = this._manager.session.enabledFeatures.indexOf("plane-detection") !== -1;
			if (available) {
				this._available = true;
				this.fire("available");
			}
		}
	}
	_onSessionEnd() {
		for (let i2 = 0; i2 < this._planes.length; i2++) {
			this._planes[i2].destroy();
			this.fire("remove", this._planes[i2]);
		}
		this._planesIndex.clear();
		this._planes.length = 0;
		if (this._available) {
			this._available = false;
			this.fire("unavailable");
		}
	}
	update(frame) {
		if (!this._available) {
			if (!this._manager.session.enabledFeatures && frame.detectedPlanes.size) {
				this._available = true;
				this.fire("available");
			} else {
				return;
			}
		}
		const detectedPlanes = frame.detectedPlanes;
		for (const [xrPlane, plane2] of this._planesIndex) {
			if (detectedPlanes.has(xrPlane)) {
				continue;
			}
			this._planesIndex.delete(xrPlane);
			this._planes.splice(this._planes.indexOf(plane2), 1);
			plane2.destroy();
			this.fire("remove", plane2);
		}
		for (const xrPlane of detectedPlanes) {
			let plane2 = this._planesIndex.get(xrPlane);
			if (!plane2) {
				plane2 = new XrPlane(this, xrPlane);
				this._planesIndex.set(xrPlane, plane2);
				this._planes.push(plane2);
				plane2.update(frame);
				this.fire("add", plane2);
			} else {
				plane2.update(frame);
			}
		}
	}
	get supported() {
		return this._supported;
	}
	get available() {
		return this._available;
	}
	get planes() {
		return this._planes;
	}
};

var XrAnchor = class extends EventHandler {
	static EVENT_DESTROY = "destroy";
	static EVENT_CHANGE = "change";
	static EVENT_PERSIST = "persist";
	static EVENT_FORGET = "forget";
	_position = new Vec3();
	_rotation = new Quat();
	_uuid = null;
	_uuidRequests = null;
	constructor(anchors, xrAnchor, uuid = null) {
		super();
		this._anchors = anchors;
		this._xrAnchor = xrAnchor;
		this._uuid = uuid;
	}
	destroy() {
		if (!this._xrAnchor) return;
		const xrAnchor = this._xrAnchor;
		this._xrAnchor.delete();
		this._xrAnchor = null;
		this.fire("destroy", xrAnchor, this);
	}
	update(frame) {
		if (!this._xrAnchor) {
			return;
		}
		const pose = frame.getPose(this._xrAnchor.anchorSpace, this._anchors.manager._referenceSpace);
		if (pose) {
			if (this._position.equals(pose.transform.position) && this._rotation.equals(pose.transform.orientation)) {
				return;
			}
			this._position.copy(pose.transform.position);
			this._rotation.copy(pose.transform.orientation);
			this.fire("change");
		}
	}
	getPosition() {
		return this._position;
	}
	getRotation() {
		return this._rotation;
	}
	persist(callback) {
		if (!this._anchors.persistence) {
			callback?.(new Error("Persistent Anchors are not supported"), null);
			return;
		}
		if (this._uuid) {
			callback?.(null, this._uuid);
			return;
		}
		if (this._uuidRequests) {
			if (callback) this._uuidRequests.push(callback);
			return;
		}
		this._uuidRequests = [];
		this._xrAnchor.requestPersistentHandle().then((uuid) => {
			this._uuid = uuid;
			this._anchors._indexByUuid.set(this._uuid, this);
			callback?.(null, uuid);
			for (const uuidRequest of this._uuidRequests) {
				uuidRequest(null, uuid);
			}
			this._uuidRequests = null;
			this.fire("persist", uuid);
		}).catch((ex) => {
			callback?.(ex, null);
			for (const uuidRequest of this._uuidRequests) {
				uuidRequest(ex, null);
			}
			this._uuidRequests = null;
		});
	}
	forget(callback) {
		if (!this._uuid) {
			callback?.(new Error("Anchor is not persistent"));
			return;
		}
		this._anchors.forget(this._uuid, (ex) => {
			this._uuid = null;
			callback?.(ex);
			this.fire("forget");
		});
	}
	get uuid() {
		return this._uuid;
	}
	get persistent() {
		return !!this._uuid;
	}
};

var XrAnchors = class extends EventHandler {
	static EVENT_AVAILABLE = "available";
	static EVENT_UNAVAILABLE = "unavailable";
	static EVENT_ERROR = "error";
	static EVENT_ADD = "add";
	static EVENT_DESTROY = "destroy";
	manager;
	_supported = platform.browser && !!window.XRAnchor;
	_available = false;
	_checkingAvailability = false;
	_persistence = platform.browser && !!window?.XRSession?.prototype.restorePersistentAnchor;
	_creationQueue = [];
	_index = /* @__PURE__ */ new Map();
	_indexByUuid = /* @__PURE__ */ new Map();
	_list = [];
	_callbacksAnchors = /* @__PURE__ */ new Map();
	constructor(manager) {
		super();
		this.manager = manager;
		if (this._supported) {
			this.manager.on("start", this._onSessionStart, this);
			this.manager.on("end", this._onSessionEnd, this);
		}
	}
	_onSessionStart() {
		const available = this.manager.session.enabledFeatures?.indexOf("anchors") >= 0;
		if (!available) return;
		this._available = available;
		this.fire("available");
	}
	_onSessionEnd() {
		if (!this._available) return;
		this._available = false;
		for (let i3 = 0; i3 < this._creationQueue.length; i3++) {
			if (!this._creationQueue[i3].callback) {
				continue;
			}
			this._creationQueue[i3].callback(new Error("session ended"), null);
		}
		this._creationQueue.length = 0;
		this._index.clear();
		this._indexByUuid.clear();
		let i2 = this._list.length;
		while (i2--) {
			this._list[i2].destroy();
		}
		this._list.length = 0;
		this.fire("unavailable");
	}
	_createAnchor(xrAnchor, uuid = null) {
		const anchor = new XrAnchor(this, xrAnchor, uuid);
		this._index.set(xrAnchor, anchor);
		if (uuid) this._indexByUuid.set(uuid, anchor);
		this._list.push(anchor);
		anchor.once("destroy", this._onAnchorDestroy, this);
		return anchor;
	}
	_onAnchorDestroy(xrAnchor, anchor) {
		this._index.delete(xrAnchor);
		if (anchor.uuid) this._indexByUuid.delete(anchor.uuid);
		const ind = this._list.indexOf(anchor);
		if (ind !== -1) this._list.splice(ind, 1);
		this.fire("destroy", anchor);
	}
	create(position5, rotation7, callback) {
		if (!this._available) {
			callback?.(new Error("Anchors API is not available"), null);
			return;
		}
		if (window.XRHitTestResult && position5 instanceof XRHitTestResult) {
			const hitResult = position5;
			callback = rotation7;
			if (!this._supported) {
				callback?.(new Error("Anchors API is not supported"), null);
				return;
			}
			if (!hitResult.createAnchor) {
				callback?.(new Error("Creating Anchor from Hit Test is not supported"), null);
				return;
			}
			hitResult.createAnchor().then((xrAnchor) => {
				const anchor = this._createAnchor(xrAnchor);
				callback?.(null, anchor);
				this.fire("add", anchor);
			}).catch((ex) => {
				callback?.(ex, null);
				this.fire("error", ex);
			});
		} else {
			this._creationQueue.push({
				transform: new XRRigidTransform(position5, rotation7),
				callback
			});
		}
	}
	restore(uuid, callback) {
		if (!this._available) {
			callback?.(new Error("Anchors API is not available"), null);
			return;
		}
		if (!this._persistence) {
			callback?.(new Error("Anchor Persistence is not supported"), null);
			return;
		}
		if (!this.manager.active) {
			callback?.(new Error("WebXR session is not active"), null);
			return;
		}
		this.manager.session.restorePersistentAnchor(uuid).then((xrAnchor) => {
			const anchor = this._createAnchor(xrAnchor, uuid);
			callback?.(null, anchor);
			this.fire("add", anchor);
		}).catch((ex) => {
			callback?.(ex, null);
			this.fire("error", ex);
		});
	}
	forget(uuid, callback) {
		if (!this._available) {
			callback?.(new Error("Anchors API is not available"));
			return;
		}
		if (!this._persistence) {
			callback?.(new Error("Anchor Persistence is not supported"));
			return;
		}
		if (!this.manager.active) {
			callback?.(new Error("WebXR session is not active"));
			return;
		}
		this.manager.session.deletePersistentAnchor(uuid).then(() => {
			callback?.(null);
		}).catch((ex) => {
			callback?.(ex);
			this.fire("error", ex);
		});
	}
	update(frame) {
		if (!this._available) {
			if (!this.manager.session.enabledFeatures && !this._checkingAvailability) {
				this._checkingAvailability = true;
				frame.createAnchor(new XRRigidTransform(), this.manager._referenceSpace).then((xrAnchor) => {
					xrAnchor.delete();
					if (this.manager.active) {
						this._available = true;
						this.fire("available");
					}
				}).catch(() => {
				});
			}
			return;
		}
		if (this._creationQueue.length) {
			for (let i2 = 0; i2 < this._creationQueue.length; i2++) {
				const request = this._creationQueue[i2];
				frame.createAnchor(request.transform, this.manager._referenceSpace).then((xrAnchor) => {
					if (request.callback) {
						this._callbacksAnchors.set(xrAnchor, request.callback);
					}
				}).catch((ex) => {
					if (request.callback) {
						request.callback(ex, null);
					}
					this.fire("error", ex);
				});
			}
			this._creationQueue.length = 0;
		}
		for (const [xrAnchor, anchor] of this._index) {
			if (frame.trackedAnchors.has(xrAnchor)) {
				continue;
			}
			this._index.delete(xrAnchor);
			anchor.destroy();
		}
		for (let i2 = 0; i2 < this._list.length; i2++) {
			this._list[i2].update(frame);
		}
		for (const xrAnchor of frame.trackedAnchors) {
			if (this._index.has(xrAnchor)) {
				continue;
			}
			try {
				const tmp = xrAnchor.anchorSpace;
			} catch (ex) {
				continue;
			}
			const anchor = this._createAnchor(xrAnchor);
			anchor.update(frame);
			const callback = this._callbacksAnchors.get(xrAnchor);
			if (callback) {
				this._callbacksAnchors.delete(xrAnchor);
				callback(null, anchor);
			}
			this.fire("add", anchor);
		}
	}
	get supported() {
		return this._supported;
	}
	get available() {
		return this._available;
	}
	get persistence() {
		return this._persistence;
	}
	get uuids() {
		if (!this._available) {
			return null;
		}
		if (!this._persistence) {
			return null;
		}
		if (!this.manager.active) {
			return null;
		}
		return this.manager.session.persistentAnchors;
	}
	get list() {
		return this._list;
	}
};

var XrMesh = class extends EventHandler {
	static EVENT_REMOVE = "remove";
	static EVENT_CHANGE = "change";
	_meshDetection;
	_xrMesh;
	_lastChanged = 0;
	_position = new Vec3();
	_rotation = new Quat();
	constructor(meshDetection, xrMesh) {
		super();
		this._meshDetection = meshDetection;
		this._xrMesh = xrMesh;
		this._lastChanged = this._xrMesh.lastChangedTime;
	}
	get xrMesh() {
		return this._xrMesh;
	}
	get label() {
		return this._xrMesh.semanticLabel || "";
	}
	get vertices() {
		return this._xrMesh.vertices;
	}
	get indices() {
		return this._xrMesh.indices;
	}
	destroy() {
		if (!this._xrMesh) return;
		this._xrMesh = null;
		this.fire("remove");
	}
	update(frame) {
		const manager = this._meshDetection._manager;
		const pose = frame.getPose(this._xrMesh.meshSpace, manager._referenceSpace);
		if (pose) {
			this._position.copy(pose.transform.position);
			this._rotation.copy(pose.transform.orientation);
		}
		if (this._lastChanged !== this._xrMesh.lastChangedTime) {
			this._lastChanged = this._xrMesh.lastChangedTime;
			this.fire("change");
		}
	}
	getPosition() {
		return this._position;
	}
	getRotation() {
		return this._rotation;
	}
};

var XrMeshDetection = class extends EventHandler {
	static EVENT_AVAILABLE = "available";
	static EVENT_UNAVAILABLE = "unavailable";
	static EVENT_ADD = "add";
	static EVENT_REMOVE = "remove";
	_manager;
	_supported = platform.browser && !!window.XRMesh;
	_available = false;
	_index = /* @__PURE__ */ new Map();
	_list = [];
	constructor(manager) {
		super();
		this._manager = manager;
		if (this._supported) {
			this._manager.on("start", this._onSessionStart, this);
			this._manager.on("end", this._onSessionEnd, this);
		}
	}
	update(frame) {
		if (!this._available) {
			if (!this._manager.session.enabledFeatures && frame.detectedMeshes.size) {
				this._available = true;
				this.fire("available");
			} else {
				return;
			}
		}
		for (const xrMesh of frame.detectedMeshes) {
			let mesh = this._index.get(xrMesh);
			if (!mesh) {
				mesh = new XrMesh(this, xrMesh);
				this._index.set(xrMesh, mesh);
				this._list.push(mesh);
				mesh.update(frame);
				this.fire("add", mesh);
			} else {
				mesh.update(frame);
			}
		}
		for (const mesh of this._index.values()) {
			if (frame.detectedMeshes.has(mesh.xrMesh)) {
				continue;
			}
			this._removeMesh(mesh);
		}
	}
	_removeMesh(mesh) {
		this._index.delete(mesh.xrMesh);
		this._list.splice(this._list.indexOf(mesh), 1);
		mesh.destroy();
		this.fire("remove", mesh);
	}
	_onSessionStart() {
		if (this._manager.session.enabledFeatures) {
			const available = this._manager.session.enabledFeatures.indexOf("mesh-detection") !== -1;
			if (!available) return;
			this._available = available;
			this.fire("available");
		}
	}
	_onSessionEnd() {
		if (!this._available) return;
		this._available = false;
		for (const mesh of this._index.values()) {
			this._removeMesh(mesh);
		}
		this.fire("unavailable");
	}
	get supported() {
		return this._supported;
	}
	get available() {
		return this._available;
	}
	get meshes() {
		return this._list;
	}
};

var XrView = class extends RenderView {
	static EVENT_DEPTHRESIZE = "depth:resize";
	_manager;
	_xrView;
	_xrCamera = null;
	_textureColor = null;
	_textureDepth = null;
	_depthInfo = null;
	_emptyDepthBuffer = new Uint8Array(32);
	_depthMatrix = new Mat4();
	constructor(manager, xrView, viewsCount) {
		super();
		this._manager = manager;
		this._xrView = xrView;
		const device = this._manager.app.graphicsDevice;
		if (this._manager.views.supportedColor) {
			this._xrCamera = this._xrView.camera;
			if (this._manager.views.availableColor && this._xrCamera) {
				this._textureColor = new Texture(device, {
					format: PIXELFORMAT_RGB8,
					mipmaps: false,
					addressU: ADDRESS_CLAMP_TO_EDGE,
					addressV: ADDRESS_CLAMP_TO_EDGE,
					minFilter: FILTER_LINEAR,
					magFilter: FILTER_LINEAR,
					width: this._xrCamera.width,
					height: this._xrCamera.height,
					name: `XrView-${this._xrView.eye}-Color`
				});
			}
		}
		if (this._manager.views.supportedDepth && this._manager.views.availableDepth) {
			const filtering = this._manager.views.depthGpuOptimized ? FILTER_NEAREST : FILTER_LINEAR;
			this._textureDepth = new Texture(device, {
				format: this._manager.views.depthPixelFormat,
				arrayLength: viewsCount === 1 ? 0 : viewsCount,
				mipmaps: false,
				addressU: ADDRESS_CLAMP_TO_EDGE,
				addressV: ADDRESS_CLAMP_TO_EDGE,
				minFilter: filtering,
				magFilter: filtering,
				width: 4,
				height: 4,
				name: `XrView-${this._xrView.eye}-Depth`
			});
			for (let i2 = 0; i2 < this._textureDepth._levels.length; i2++) {
				this._textureDepth._levels[i2] = this._emptyDepthBuffer;
			}
			this._textureDepth.upload();
		}
		if (this._textureColor || this._textureDepth) {
			device.on("devicelost", this._onDeviceLost, this);
		}
	}
	get textureColor() {
		return this._textureColor;
	}
	get textureDepth() {
		return this._textureDepth;
	}
	get depthUvMatrix() {
		return this._depthMatrix;
	}
	get depthValueToMeters() {
		return this._depthInfo?.rawValueToMeters || 0;
	}
	get eye() {
		return this._xrView.eye;
	}
	update(frame, xrView) {
		this._xrView = xrView;
		if (this._manager.views.availableColor) {
			this._xrCamera = this._xrView.camera;
		}
		const viewport = this._manager.xrBridge.getViewport(frame, this._xrView);
		this.setViewport(viewport.x, viewport.y, viewport.width, viewport.height);
		this.setView(
			this._xrView.projectionMatrix,
			this._xrView.transform.matrix,
			this._xrView.transform.inverse.matrix
		);
		this._updateTextureColor();
		this._updateDepth(frame);
	}
	_updateTextureColor() {
		if (!this._manager.views.availableColor || !this._xrCamera || !this._textureColor) {
			return;
		}
		this._manager.xrBridge?.syncCameraColorTexture(this._xrCamera, this._textureColor);
	}
	_updateDepth(frame) {
		if (!this._manager.views.availableDepth || !this._textureDepth) {
			return;
		}
		const gpu = this._manager.views.depthGpuOptimized;
		const infoSource = gpu ? this._manager.graphicsBinding : frame;
		if (!infoSource) {
			this._depthInfo = null;
			return;
		}
		const depthInfo = infoSource.getDepthInformation(this._xrView);
		if (!depthInfo) {
			this._depthInfo = null;
			return;
		}
		let matrixDirty = !this._depthInfo !== !depthInfo;
		this._depthInfo = depthInfo;
		const width = this._depthInfo?.width || 4;
		const height = this._depthInfo?.height || 4;
		let resized = false;
		if (this._textureDepth.width !== width || this._textureDepth.height !== height) {
			this._textureDepth._width = width;
			this._textureDepth._height = height;
			matrixDirty = true;
			resized = true;
		}
		if (matrixDirty) {
			if (this._depthInfo) {
				this._depthMatrix.data.set(this._depthInfo.normDepthBufferFromNormView.matrix);
			} else {
				this._depthMatrix.setIdentity();
			}
		}
		if (this._depthInfo) {
			if (gpu) {
				this._manager.xrBridge?.syncCameraDepthTexture(
					this._depthInfo,
					this._textureDepth,
					this._manager.views.depthPixelFormat ?? PIXELFORMAT_R32F
				);
			} else {
				this._textureDepth._levels[0] = new Uint8Array(this._depthInfo.data);
				this._textureDepth.upload();
			}
		} else {
			this._textureDepth._levels[0] = this._emptyDepthBuffer;
			this._textureDepth.upload();
		}
		if (resized) this.fire("depth:resize", width, height);
	}
	_onDeviceLost() {
		this._depthInfo = null;
	}
	getDepth(u, v6) {
		if (this._manager.views.depthGpuOptimized) {
			return null;
		}
		return this._depthInfo?.getDepthInMeters(u, v6) ?? null;
	}
	destroy() {
		this._depthInfo = null;
		if (this._textureColor) {
			this._textureColor.destroy();
			this._textureColor = null;
		}
		if (this._textureDepth) {
			this._textureDepth.destroy();
			this._textureDepth = null;
		}
	}
};

var XrViews = class extends EventHandler {
	static EVENT_ADD = "add";
	static EVENT_REMOVE = "remove";
	_manager;
	_index = /* @__PURE__ */ new Map();
	_indexTmp = /* @__PURE__ */ new Map();
	_list = [];
	_supportedColor = false;
	_supportedDepth = platform.browser && !!window.XRDepthInformation;
	_availableColor = false;
	_availableDepth = false;
	_depthUsage = "";
	_depthFormat = "";
	_depthFormats = {
		[XRDEPTHSENSINGFORMAT_L8A8]: PIXELFORMAT_LA8,
		[XRDEPTHSENSINGFORMAT_R16U]: PIXELFORMAT_DEPTH,
		[XRDEPTHSENSINGFORMAT_F32]: PIXELFORMAT_R32F
	};
	constructor(manager) {
		super();
		this._manager = manager;
		const gd = manager.app?.graphicsDevice;
		if (platform.browser && !!window.XRCamera) {
			if (gd?.isWebGL2 && !!window.XRWebGLBinding) {
				this._supportedColor = true;
			} else if (gd?.isWebGPU && !!window.XRGPUBinding) {
				this._supportedColor = true;
			}
		}
		this._manager.on("start", this._onSessionStart, this);
		this._manager.on("end", this._onSessionEnd, this);
	}
	get list() {
		return this._list;
	}
	get supportedColor() {
		return this._supportedColor;
	}
	get supportedDepth() {
		return this._supportedDepth;
	}
	get availableColor() {
		return this._availableColor;
	}
	get availableDepth() {
		return this._availableDepth;
	}
	get depthUsage() {
		return this._depthUsage;
	}
	get depthGpuOptimized() {
		return this._depthUsage === XRDEPTHSENSINGUSAGE_GPU;
	}
	get depthFormat() {
		return this._depthFormat;
	}
	get depthPixelFormat() {
		return this._depthFormats[this._depthFormat] ?? null;
	}
	update(frame, xrViews) {
		for (let i2 = 0; i2 < xrViews.length; i2++) {
			this._indexTmp.set(xrViews[i2].eye, xrViews[i2]);
		}
		for (const [eye, xrView] of this._indexTmp) {
			let view = this._index.get(eye);
			if (!view) {
				view = new XrView(this._manager, xrView, xrViews.length);
				this._index.set(eye, view);
				this._list.push(view);
				view.update(frame, xrView);
				this.fire("add", view);
			} else {
				view.update(frame, xrView);
			}
		}
		for (const [eye, view] of this._index) {
			if (this._indexTmp.has(eye)) {
				continue;
			}
			view.destroy();
			this._index.delete(eye);
			const ind = this._list.indexOf(view);
			if (ind !== -1) this._list.splice(ind, 1);
			this.fire("remove", view);
		}
		this._indexTmp.clear();
	}
	get(eye) {
		return this._index.get(eye) || null;
	}
	_onSessionStart() {
		if (this._manager.type !== XRTYPE_AR) {
			return;
		}
		if (!this._manager.session.enabledFeatures) {
			return;
		}
		this._availableColor = this._manager.session.enabledFeatures.indexOf("camera-access") !== -1;
		this._availableDepth = this._manager.session.enabledFeatures.indexOf("depth-sensing") !== -1;
		if (this._availableDepth) {
			const session = this._manager.session;
			this._depthUsage = session.depthUsage;
			this._depthFormat = session.depthDataFormat;
		}
	}
	_onSessionEnd() {
		for (const view of this._index.values()) {
			view.destroy();
		}
		this._index.clear();
		this._availableColor = false;
		this._availableDepth = false;
		this._depthUsage = "";
		this._depthFormat = "";
		this._list.length = 0;
	}
};

var XrBridge = class {
	device;
	eventHandler;
	impl;
	_evtDeviceLost = null;
	_evtDeviceRestored = null;
	_session = null;
	_framebufferScaleFactor = 1;
	_onBindingError;
	constructor(device, eventHandler) {
		this.device = device;
		this.eventHandler = eventHandler;
		this.impl = device.createXrBridgeImpl(this);
		this._evtDeviceLost = device.on("devicelost", this._onDeviceLost, this);
		this._evtDeviceRestored = device.on("devicerestored", this._onDeviceRestored, this);
	}
	destroy() {
		const device = this.device;
		if (device) {
			this._evtDeviceLost?.off();
			this._evtDeviceLost = null;
			this._evtDeviceRestored?.off();
			this._evtDeviceRestored = null;
			this.impl.endFrame();
			this.impl.destroy(device);
			this.impl = null;
			this._session = null;
			this._framebufferScaleFactor = 1;
			this._onBindingError = void 0;
			this.device = null;
			this.eventHandler = null;
		}
	}
	_onDeviceLost() {
		this.impl.onGraphicsDeviceLost();
	}
	_onDeviceRestored() {
		this.impl.onGraphicsDeviceRestored();
	}
	attachPresentation(session, options2) {
		this._session = session;
		this._framebufferScaleFactor = options2.framebufferScaleFactor;
		this._onBindingError = options2.onBindingError;
		this.impl.attachPresentation(session, options2);
	}
	releasePresentation() {
		this.impl.releasePresentation();
	}
	beginFrame(frame, referenceSpace) {
		this.impl.beginFrame(frame, referenceSpace);
	}
	endFrame() {
		this.impl.endFrame();
	}
	getFramebufferSize(frame, out) {
		this.impl.getFramebufferSize(frame, out);
	}
	getViewport(frame, xrView) {
		return this.impl.getViewport(frame, xrView);
	}
	syncCameraColorTexture(xrCamera, texture) {
		this.impl?.syncCameraColorTexture?.(xrCamera, texture);
	}
	syncCameraDepthTexture(depthInfo, texture, depthPixelFormat) {
		this.impl?.syncCameraDepthTexture?.(depthInfo, texture, depthPixelFormat);
	}
	get presentationLayer() {
		return this.impl.presentationLayer ?? null;
	}
	get graphicsBinding() {
		return this.impl.graphicsBinding ?? null;
	}
};

var XrManager = class _XrManager extends EventHandler {
	static EVENT_AVAILABLE = "available";
	static EVENT_START = "start";
	static EVENT_END = "end";
	static EVENT_UPDATE = "update";
	static EVENT_ERROR = "error";
	app;
	_supported = platform.browser && !!navigator.xr;
	_available = {};
	_type = null;
	_spaceType = null;
	_session = null;
	xrBridge = null;
	get graphicsBinding() {
		return this.xrBridge?.graphicsBinding ?? null;
	}
	_referenceSpace = null;
	domOverlay;
	hitTest;
	imageTracking;
	planeDetection;
	meshDetection;
	input;
	lightEstimation;
	views;
	anchors;
	_camera = null;
	_localPosition = new Vec3();
	_localRotation = new Quat();
	_depthNear = 0.1;
	_depthFar = 1e3;
	_supportedFrameRates = null;
	_width = 0;
	_height = 0;
	_framebufferSize = new Vec2();
	_framebufferScaleFactor = 1;
	constructor(app2) {
		super();
		this.app = app2;
		this._available[XRTYPE_INLINE] = false;
		this._available[XRTYPE_VR] = false;
		this._available[XRTYPE_AR] = false;
		this.domOverlay = new XrDomOverlay(this);
		this.hitTest = new XrHitTest(this);
		this.imageTracking = new XrImageTracking(this);
		this.planeDetection = new XrPlaneDetection(this);
		this.meshDetection = new XrMeshDetection(this);
		this.input = new XrInput(this);
		this.lightEstimation = new XrLightEstimation(this);
		this.anchors = new XrAnchors(this);
		this.views = new XrViews(this);
		if (this._supported && _XrManager._allowsSpatialTracking()) {
			navigator.xr.addEventListener("devicechange", () => {
				this._deviceAvailabilityCheck();
			});
			this._deviceAvailabilityCheck();
		}
	}
	static _allowsSpatialTracking() {
		const featurePolicy = platform.browser && document.featurePolicy;
		if (featurePolicy?.allowsFeature) {
			const allowed = featurePolicy.allowsFeature("xr-spatial-tracking");
			if (!allowed) {
			}
			return allowed;
		}
		return true;
	}
	static async isDeviceSupported(deviceType, type) {
		if (!platform.browser || !navigator.xr || !_XrManager._backendSupportsXr(deviceType)) {
			return false;
		}
		try {
			return await navigator.xr.isSessionSupported(type);
		} catch {
			return false;
		}
	}
	static _backendSupportsXr(deviceType) {
		return deviceType !== DEVICETYPE_WEBGPU || typeof globalThis.XRGPUBinding !== "undefined";
	}
	destroy() {
		if (this.xrBridge) {
			this.xrBridge.destroy();
			this.xrBridge = null;
		}
	}
	start(camera, type, spaceType, options2) {
		let callback = options2;
		if (typeof options2 === "object") {
			callback = options2.callback;
		}
		if (!this._available[type]) {
			warnInsecureContext("WebXR");
			if (callback) callback(new Error("XR is not available"));
			return;
		}
		if (this._session) {
			if (callback) callback(new Error("XR session is already started"));
			return;
		}
		this._camera = camera;
		this._type = type;
		this._spaceType = spaceType;
		this._framebufferScaleFactor = options2?.framebufferScaleFactor ?? 1;
		this._setClipPlanes(camera.nearClip, camera.farClip);
		const opts = {
			requiredFeatures: [spaceType],
			optionalFeatures: []
		};
		const device = this.app.graphicsDevice;
		if (device?.isWebGPU) {
			opts.requiredFeatures.push("webgpu");
		}
		if (type === XRTYPE_AR) {
			opts.optionalFeatures.push("light-estimation");
			opts.optionalFeatures.push("hit-test");
			if (options2) {
				if (options2.imageTracking && this.imageTracking.supported) {
					opts.optionalFeatures.push("image-tracking");
				}
				if (options2.planeDetection) {
					opts.optionalFeatures.push("plane-detection");
				}
				if (options2.meshDetection) {
					opts.optionalFeatures.push("mesh-detection");
				}
			}
			if (this.domOverlay.supported && this.domOverlay.root) {
				opts.optionalFeatures.push("dom-overlay");
				opts.domOverlay = { root: this.domOverlay.root };
			}
			if (options2 && options2.anchors && this.anchors.supported) {
				opts.optionalFeatures.push("anchors");
			}
			if (options2 && options2.depthSensing && this.views.supportedDepth) {
				opts.optionalFeatures.push("depth-sensing");
				const usagePreference = [];
				const dataFormatPreference = [];
				usagePreference.push(XRDEPTHSENSINGUSAGE_GPU, XRDEPTHSENSINGUSAGE_CPU);
				dataFormatPreference.push(XRDEPTHSENSINGFORMAT_F32, XRDEPTHSENSINGFORMAT_L8A8, XRDEPTHSENSINGFORMAT_R16U);
				if (options2.depthSensing.usagePreference) {
					const ind = usagePreference.indexOf(options2.depthSensing.usagePreference);
					if (ind !== -1) usagePreference.splice(ind, 1);
					usagePreference.unshift(options2.depthSensing.usagePreference);
				}
				if (options2.depthSensing.dataFormatPreference) {
					const ind = dataFormatPreference.indexOf(options2.depthSensing.dataFormatPreference);
					if (ind !== -1) dataFormatPreference.splice(ind, 1);
					dataFormatPreference.unshift(options2.depthSensing.dataFormatPreference);
				}
				opts.depthSensing = {
					usagePreference,
					dataFormatPreference
				};
			}
			if (options2 && options2.cameraColor && this.views.supportedColor) {
				opts.optionalFeatures.push("camera-access");
			}
		}
		opts.optionalFeatures.push("hand-tracking");
		if (options2 && options2.optionalFeatures) {
			opts.optionalFeatures = opts.optionalFeatures.concat(options2.optionalFeatures);
		}
		if (this.imageTracking.supported && this.imageTracking.images.length) {
			this.imageTracking.prepareImages((err2, trackedImages) => {
				if (err2) {
					if (callback) callback(err2);
					this.fire("error", err2);
					return;
				}
				if (trackedImages !== null) {
					opts.trackedImages = trackedImages;
				}
				this._onStartOptionsReady(type, spaceType, opts, callback);
			});
		} else {
			this._onStartOptionsReady(type, spaceType, opts, callback);
		}
	}
	_onStartOptionsReady(type, spaceType, options2, callback) {
		navigator.xr.requestSession(type, options2).then((session) => {
			this._onSessionStart(session, spaceType, callback);
		}).catch((ex) => {
			this._camera = null;
			this._type = null;
			this._spaceType = null;
			if (callback) callback(ex);
			this.fire("error", ex);
		});
	}
	end(callback) {
		if (!this._session) {
			if (callback) callback(new Error("XR Session is not initialized"));
			return;
		}
		this.xrBridge?.releasePresentation();
		if (callback) this.once("end", callback);
		this._session.end();
	}
	isAvailable(type) {
		return this._available[type];
	}
	_deviceAvailabilityCheck() {
		for (const key in this._available) {
			this._sessionSupportCheck(key);
		}
	}
	initiateRoomCapture(callback) {
		if (!this._session) {
			callback(new Error("Session is not active"));
			return;
		}
		if (!this._session.initiateRoomCapture) {
			callback(new Error("Session does not support manual room capture"));
			return;
		}
		this._session.initiateRoomCapture().then(() => {
			if (callback) callback(null);
		}).catch((err2) => {
			if (callback) callback(err2);
		});
	}
	updateTargetFrameRate(frameRate, callback) {
		if (!this._session?.updateTargetFrameRate) {
			callback?.(new Error("unable to update frameRate"));
			return;
		}
		this._session.updateTargetFrameRate(frameRate).then(() => {
			callback?.();
		}).catch((err2) => {
			callback?.(err2);
		});
	}
	_sessionSupportCheck(type) {
		navigator.xr.isSessionSupported(type).then((available) => {
			if (available && !_XrManager._backendSupportsXr(this.app?.graphicsDevice?.deviceType)) {
				available = false;
			}
			if (this._available[type] === available) {
				return;
			}
			this._available[type] = available;
			this.fire("available", type, available);
			this.fire(`available:${type}`, available);
		}).catch((ex) => {
			this.fire("error", ex);
		});
	}
	_onSessionStart(session, spaceType, callback) {
		let failed = false;
		this._session = session;
		this._camera.camera.xrViews = this.views.list;
		this.xrBridge = new XrBridge(this.app.graphicsDevice, this);
		const onVisibilityChange = () => {
			this.fire("visibility:change", session.visibilityState);
		};
		const onClipPlanesChange = () => {
			this._setClipPlanes(this._camera.nearClip, this._camera.farClip);
		};
		const onFrameRateChange = () => {
			this.fire("frameratechange", this._session?.frameRate);
		};
		const onEnd = () => {
			if (this._camera) {
				this._camera.off("set_nearClip", onClipPlanesChange);
				this._camera.off("set_farClip", onClipPlanesChange);
				this._camera.camera.xrViews = null;
				this._camera = null;
			}
			session.removeEventListener("end", onEnd);
			session.removeEventListener("visibilitychange", onVisibilityChange);
			session.removeEventListener("frameratechange", onFrameRateChange);
			if (!failed) this.fire("end");
			if (this.xrBridge) {
				this.xrBridge.destroy();
				this.xrBridge = null;
			}
			this._session = null;
			this._referenceSpace = null;
			this._width = 0;
			this._height = 0;
			this._type = null;
			this._spaceType = null;
			if (this.app.systems) {
				this.app.requestAnimationFrame();
			}
		};
		session.addEventListener("end", onEnd);
		session.addEventListener("visibilitychange", onVisibilityChange);
		this._camera.on("set_nearClip", onClipPlanesChange);
		this._camera.on("set_farClip", onClipPlanesChange);
		const gd = this.app.graphicsDevice;
		const framebufferScaleFactor = gd.maxPixelRatio / window.devicePixelRatio * this._framebufferScaleFactor;
		this.xrBridge.attachPresentation(this._session, {
			framebufferScaleFactor,
			depthNear: this._depthNear,
			depthFar: this._depthFar,
			onBindingError: (ex) => {
				this.fire("error", ex);
			}
		});
		if (this.session.supportedFrameRates) {
			this._supportedFrameRates = Array.from(this.session.supportedFrameRates);
		} else {
			this._supportedFrameRates = null;
		}
		this._session.addEventListener("frameratechange", onFrameRateChange);
		session.requestReferenceSpace(spaceType).then((referenceSpace) => {
			this._referenceSpace = referenceSpace;
			this.app.requestAnimationFrame();
			if (callback) callback(null);
			this.fire("start");
		}).catch((ex) => {
			failed = true;
			session.end();
			if (callback) callback(ex);
			this.fire("error", ex);
		});
	}
	_setClipPlanes(near, far) {
		if (this._depthNear === near && this._depthFar === far) {
			return;
		}
		this._depthNear = near;
		this._depthFar = far;
		if (!this._session) {
			return;
		}
		this._session.updateRenderState({
			depthNear: this._depthNear,
			depthFar: this._depthFar
		});
	}
	update(frame) {
		if (!this._session) return false;
		this.xrBridge.getFramebufferSize(frame, this._framebufferSize);
		const width = this._framebufferSize.x;
		const height = this._framebufferSize.y;
		if (this._width !== width || this._height !== height) {
			this._width = width;
			this._height = height;
			this.app.graphicsDevice.setResolution(width, height);
		}
		const pose = frame.getViewerPose(this._referenceSpace);
		if (!pose) return false;
		const lengthOld = this.views.list.length;
		this.views.update(frame, pose.views);
		const posePosition = pose.transform.position;
		const poseOrientation = pose.transform.orientation;
		this._localPosition.set(posePosition.x, posePosition.y, posePosition.z);
		this._localRotation.set(poseOrientation.x, poseOrientation.y, poseOrientation.z, poseOrientation.w);
		if (lengthOld === 0 && this.views.list.length > 0) {
			const viewProjMat2 = new Mat4();
			const view = this.views.list[0];
			viewProjMat2.copy(view.projMat);
			const data2 = viewProjMat2.data;
			const fov = 2 * Math.atan(1 / data2[5]) * 180 / Math.PI;
			const aspectRatio = data2[5] / data2[0];
			const farClip = data2[14] / (data2[10] + 1);
			const nearClip = data2[14] / (data2[10] - 1);
			const horizontalFov = false;
			const camera = this._camera.camera;
			camera.setXrProperties({
				aspectRatio,
				farClip,
				fov,
				horizontalFov,
				nearClip
			});
		}
		this._camera.camera._node.setLocalPosition(this._localPosition);
		this._camera.camera._node.setLocalRotation(this._localRotation);
		this.input.update(frame);
		if (this._type === XRTYPE_AR) {
			if (this.hitTest.supported) {
				this.hitTest.update(frame);
			}
			if (this.lightEstimation.supported) {
				this.lightEstimation.update(frame);
			}
			if (this.imageTracking.supported) {
				this.imageTracking.update(frame);
			}
			if (this.anchors.supported) {
				this.anchors.update(frame);
			}
			if (this.planeDetection.supported) {
				this.planeDetection.update(frame);
			}
			if (this.meshDetection.supported) {
				this.meshDetection.update(frame);
			}
		}
		this.fire("update", frame);
		this.xrBridge.beginFrame(frame, this._referenceSpace);
		return true;
	}
	get supported() {
		return this._supported;
	}
	get active() {
		return !!this._session;
	}
	get type() {
		return this._type;
	}
	get spaceType() {
		return this._spaceType;
	}
	get session() {
		return this._session;
	}
	get frameRate() {
		return this._session?.frameRate ?? null;
	}
	get supportedFrameRates() {
		return this._supportedFrameRates;
	}
	get framebufferScaleFactor() {
		return this._framebufferScaleFactor;
	}
	set fixedFoveation(value) {
		const layer = this.xrBridge?.presentationLayer;
		if ((layer?.fixedFoveation ?? null) !== null) {
			if (this.app.graphicsDevice.samples > 1) {
			}
			layer.fixedFoveation = value;
		}
	}
	get fixedFoveation() {
		const layer = this.xrBridge?.presentationLayer;
		return layer?.fixedFoveation ?? null;
	}
	get camera() {
		return this._camera ? this._camera.entity : null;
	}
	get visibilityState() {
		if (!this._session) {
			return null;
		}
		return this._session.visibilityState;
	}
};

var Application = class extends AppBase {
	constructor(canvas, options2 = {}) {
		super(canvas);
		const appOptions = new AppOptions();
		appOptions.graphicsDevice = options2.graphicsDevice ?? this.createDevice(canvas, options2);
		this.addComponentSystems(appOptions);
		this.addResourceHandles(appOptions);
		appOptions.elementInput = options2.elementInput;
		appOptions.keyboard = options2.keyboard;
		appOptions.mouse = options2.mouse;
		appOptions.touch = options2.touch;
		appOptions.gamepads = options2.gamepads;
		appOptions.scriptPrefix = options2.scriptPrefix;
		appOptions.assetPrefix = options2.assetPrefix;
		appOptions.scriptsOrder = options2.scriptsOrder;
		appOptions.soundManager = new SoundManager();
		appOptions.lightmapper = Lightmapper;
		appOptions.batchManager = BatchManager;
		appOptions.xr = XrManager;
		this.init(appOptions);
	}
	createDevice(canvas, options2) {
		if (!options2.graphicsDeviceOptions) {
			options2.graphicsDeviceOptions = {};
		}
		if (platform.browser && !!navigator.xr) {
			options2.graphicsDeviceOptions.xrCompatible = true;
		}
		options2.graphicsDeviceOptions.alpha = options2.graphicsDeviceOptions.alpha || false;
		return new WebglGraphicsDevice(canvas, options2.graphicsDeviceOptions);
	}
	addComponentSystems(appOptions) {
		appOptions.componentSystems = [
			RigidBodyComponentSystem,
			CollisionComponentSystem,
			JointComponentSystem,
			AnimationComponentSystem,
			AnimComponentSystem,
			ModelComponentSystem,
			RenderComponentSystem,
			CameraComponentSystem,
			LightComponentSystem,
			ScriptComponentSystem,
			SoundComponentSystem,
			AudioListenerComponentSystem,
			ParticleSystemComponentSystem,
			ScreenComponentSystem,
			ElementComponentSystem,
			ButtonComponentSystem,
			ScrollViewComponentSystem,
			ScrollbarComponentSystem,
			SpriteComponentSystem,
			LayoutGroupComponentSystem,
			LayoutChildComponentSystem,
			ZoneComponentSystem,
			GSplatComponentSystem
		];
	}
	addResourceHandles(appOptions) {
		appOptions.resourceHandlers = [
			RenderHandler,
			AnimationHandler,
			AnimClipHandler,
			AnimStateGraphHandler,
			ModelHandler,
			MaterialHandler,
			TextureHandler,
			TextHandler,
			JsonHandler,
			AudioHandler,
			ScriptHandler,
			SceneHandler,
			CubemapHandler,
			HtmlHandler,
			CssHandler,
			ShaderHandler,
			HierarchyHandler,
			FolderHandler,
			FontHandler,
			BinaryHandler,
			TextureAtlasHandler,
			SpriteHandler,
			TemplateHandler,
			ContainerHandler,
			GSplatHandler
		];
	}
};

var AssetListLoader = class extends EventHandler {
	_assets = /* @__PURE__ */ new Set();
	_loadingAssets = /* @__PURE__ */ new Set();
	_waitingAssets = /* @__PURE__ */ new Set();
	_loading = false;
	_loaded = false;
	_failed = [];
	constructor(assetList, assetRegistry) {
		super();
		this._registry = assetRegistry;
		assetList.forEach((a) => {
			if (a instanceof Asset) {
				if (!a.registry) {
					a.registry = assetRegistry;
				}
				this._assets.add(a);
			} else {
				const asset = assetRegistry.get(a);
				if (asset) {
					this._assets.add(asset);
				} else {
					this._waitForAsset(a);
				}
			}
		});
	}
	destroy() {
		this._registry.off("load", this._onLoad);
		this._registry.off("error", this._onError);
		this._waitingAssets.forEach((id14) => {
			this._registry.off(`add:${id14}`, this._onAddAsset);
		});
		this.off("progress");
		this.off("load");
	}
	_assetHasDependencies(asset) {
		return asset.type === "model" && asset.file?.url && asset.file.url && asset.file.url.match(/.json$/g);
	}
	load(done, scope) {
		if (this._loading) {
			return;
		}
		this._loading = true;
		this._callback = done;
		this._scope = scope;
		this._registry.on("load", this._onLoad, this);
		this._registry.on("error", this._onError, this);
		let loadingAssets = false;
		this._assets.forEach((asset) => {
			if (!asset.loaded) {
				loadingAssets = true;
				if (this._assetHasDependencies(asset)) {
					this._registry.loadFromUrl(asset.file.url, asset.type, (err2, loadedAsset) => {
						if (err2) {
							this._onError(err2, asset);
							return;
						}
						this._onLoad(asset);
					});
				}
				this._loadingAssets.add(asset);
				this._registry.add(asset);
			}
		});
		this._loadingAssets.forEach((asset) => {
			if (!this._assetHasDependencies(asset)) {
				this._registry.load(asset);
			}
		});
		if (!loadingAssets && this._waitingAssets.size === 0) {
			this._loadingComplete();
		}
	}
	ready(done, scope = this) {
		if (this._loaded) {
			done.call(scope, Array.from(this._assets));
		} else {
			this.once("load", (assets) => {
				done.call(scope, assets);
			});
		}
	}
	// called when all assets are loaded
	_loadingComplete() {
		if (this._loaded) return;
		this._loaded = true;
		this._registry.off("load", this._onLoad, this);
		this._registry.off("error", this._onError, this);
		if (this._failed.length) {
			if (this._callback) {
				this._callback.call(this._scope, "Failed to load some assets", this._failed);
			}
			this.fire("error", this._failed);
		} else {
			if (this._callback) {
				this._callback.call(this._scope);
			}
			this.fire("load", Array.from(this._assets));
		}
	}
	// called when an (any) asset is loaded
	_onLoad(asset) {
		if (this._loadingAssets.has(asset)) {
			this.fire("progress", asset);
			this._loadingAssets.delete(asset);
		}
		if (this._loadingAssets.size === 0) {
			setTimeout(() => {
				this._loadingComplete();
			}, 0);
		}
	}
	// called when an asset fails to load
	_onError(err2, asset) {
		if (this._loadingAssets.has(asset)) {
			this._failed.push(asset);
			this._loadingAssets.delete(asset);
		}
		if (this._loadingAssets.size === 0) {
			setTimeout(() => {
				this._loadingComplete();
			}, 0);
		}
	}
	// called when a expected asset is added to the asset registry
	_onAddAsset(asset) {
		this._waitingAssets.delete(asset);
		this._assets.add(asset);
		if (!asset.loaded) {
			this._loadingAssets.add(asset);
			this._registry.load(asset);
		}
	}
	_waitForAsset(assetId) {
		this._waitingAssets.add(assetId);
		this._registry.once(`add:${assetId}`, this._onAddAsset, this);
	}
};

var MAX_TEXTURE_SIZE = 4096;
var DEFAULT_TEXTURE_SIZE = 512;
var Atlas = class {
	constructor(device, width, height, name) {
		this.canvas = document.createElement("canvas");
		this.canvas.width = width;
		this.canvas.height = height;
		this.texture = new Texture(device, {
			name,
			format: PIXELFORMAT_SRGBA8,
			width,
			height,
			mipmaps: true,
			minFilter: FILTER_LINEAR_MIPMAP_LINEAR,
			magFilter: FILTER_LINEAR,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			levels: [this.canvas]
		});
		this.ctx = this.canvas.getContext("2d", {
			alpha: true
		});
	}
	destroy() {
		this.texture.destroy();
	}
	clear(clearColor) {
		const { width, height } = this.canvas;
		this.ctx.clearRect(0, 0, width, height);
		this.ctx.fillStyle = clearColor;
		this.ctx.fillRect(0, 0, width, height);
	}
};
var CanvasFont = class extends EventHandler {
	constructor(app2, options2 = {}) {
		super();
		this.type = "bitmap";
		this.app = app2;
		this.intensity = 0;
		this.fontWeight = options2.fontWeight || "normal";
		this.fontSize = parseInt(options2.fontSize, 10);
		this.glyphSize = this.fontSize;
		this.fontName = options2.fontName || "Arial";
		this.color = options2.color || new Color(1, 1, 1);
		this.padding = options2.padding || 0;
		this.width = Math.min(MAX_TEXTURE_SIZE, options2.width || DEFAULT_TEXTURE_SIZE);
		this.height = Math.min(MAX_TEXTURE_SIZE, options2.height || DEFAULT_TEXTURE_SIZE);
		this.atlases = [];
		this.chars = "";
		this.data = {};
	}
	createTextures(text) {
		const _chars = this._normalizeCharsSet(text);
		if (_chars.length !== this.chars.length) {
			this._renderAtlas(_chars);
			return;
		}
		for (let i2 = 0; i2 < _chars.length; i2++) {
			if (_chars[i2] !== this.chars[i2]) {
				this._renderAtlas(_chars);
				return;
			}
		}
	}
	updateTextures(text) {
		const _chars = this._normalizeCharsSet(text);
		const newCharsSet = [];
		for (let i2 = 0; i2 < _chars.length; i2++) {
			const char = _chars[i2];
			if (!this.data.chars[char]) {
				newCharsSet.push(char);
			}
		}
		if (newCharsSet.length > 0) {
			this._renderAtlas(this.chars.concat(newCharsSet));
		}
	}
	destroy() {
		this.atlases.forEach((atlas) => atlas.destroy());
		this.chars = null;
		this.color = null;
		this.data = null;
		this.fontName = null;
		this.fontSize = null;
		this.glyphSize = null;
		this.intensity = null;
		this.atlases = null;
		this.type = null;
		this.fontWeight = null;
	}
	_colorToRgbString(color3, alpha) {
		let str;
		const r = Math.round(255 * color3.r);
		const g = Math.round(255 * color3.g);
		const b = Math.round(255 * color3.b);
		if (alpha) {
			str = `rgba(${r}, ${g}, ${b}, ${color3.a})`;
		} else {
			str = `rgb(${r}, ${g}, ${b})`;
		}
		return str;
	}
	renderCharacter(context, char, x3, y2, color3) {
		context.fillStyle = color3;
		context.fillText(char, x3, y2);
	}
	_getAtlas(index) {
		if (index >= this.atlases.length) {
			this.atlases[index] = new Atlas(this.app.graphicsDevice, this.width, this.height, `font-atlas-${this.fontName}-${index}`);
		}
		return this.atlases[index];
	}
	_renderAtlas(charsArray) {
		this.chars = charsArray;
		const w = this.width;
		const h2 = this.height;
		const color3 = this._colorToRgbString(this.color, false);
		const a = this.color.a;
		this.color.a = 1 / 255;
		const transparent = this._colorToRgbString(this.color, true);
		this.color.a = a;
		const TEXT_ALIGN = "center";
		const TEXT_BASELINE = "alphabetic";
		let atlasIndex = 0;
		let atlas = this._getAtlas(atlasIndex++);
		atlas.clear(transparent);
		this.data = this._createJson(this.chars, this.fontName, w, h2);
		const symbols = string.getSymbols(this.chars.join(""));
		let maxHeight = 0;
		let maxDescent = 0;
		const metrics = {};
		for (let i2 = 0; i2 < symbols.length; i2++) {
			const ch = symbols[i2];
			metrics[ch] = this._getTextMetrics(ch);
			maxHeight = Math.max(maxHeight, metrics[ch].height);
			maxDescent = Math.max(maxDescent, metrics[ch].descent);
		}
		this.glyphSize = Math.max(this.glyphSize, maxHeight);
		const sx = this.glyphSize + this.padding * 2;
		const sy = this.glyphSize + this.padding * 2;
		const _xOffset = this.glyphSize / 2 + this.padding;
		const _yOffset = sy - maxDescent - this.padding;
		let _x = 0;
		let _y = 0;
		for (let i2 = 0; i2 < symbols.length; i2++) {
			const ch = symbols[i2];
			const code = string.getCodePoint(symbols[i2]);
			let fs = this.fontSize;
			atlas.ctx.font = `${this.fontWeight} ${fs.toString()}px ${this.fontName}`;
			atlas.ctx.textAlign = TEXT_ALIGN;
			atlas.ctx.textBaseline = TEXT_BASELINE;
			let width = atlas.ctx.measureText(ch).width;
			if (width > fs) {
				fs = this.fontSize * this.fontSize / width;
				atlas.ctx.font = `${this.fontWeight} ${fs.toString()}px ${this.fontName}`;
				width = this.fontSize;
			}
			this.renderCharacter(atlas.ctx, ch, _x + _xOffset, _y + _yOffset, color3);
			const xoffset = this.padding + (this.glyphSize - width) / 2;
			const yoffset = -this.padding + metrics[ch].descent - maxDescent;
			const xadvance = width;
			this._addChar(this.data, ch, code, _x, _y, sx, sy, xoffset, yoffset, xadvance, atlasIndex - 1, w, h2);
			_x += sx;
			if (_x + sx > w) {
				_x = 0;
				_y += sy;
				if (_y + sy > h2) {
					atlas = this._getAtlas(atlasIndex++);
					atlas.clear(transparent);
					_y = 0;
				}
			}
		}
		this.atlases.splice(atlasIndex).forEach((atlas2) => atlas2.destroy());
		this.atlases.forEach((atlas2) => atlas2.texture.upload());
		this.fire("render");
	}
	_createJson(chars, fontName, width, height) {
		const base = {
			"version": 3,
			"intensity": this.intensity,
			"info": {
				"face": fontName,
				"width": width,
				"height": height,
				"maps": [{
					"width": width,
					"height": height
				}]
			},
			"chars": {}
		};
		return base;
	}
	_addChar(json, char, charCode, x3, y2, w, h2, xoffset, yoffset, xadvance, mapNum, mapW, mapH) {
		if (json.info.maps.length < mapNum + 1) {
			json.info.maps.push({ "width": mapW, "height": mapH });
		}
		const scale2 = this.fontSize / 32;
		json.chars[char] = {
			"id": charCode,
			"letter": char,
			"x": x3,
			"y": y2,
			"width": w,
			"height": h2,
			"xadvance": xadvance / scale2,
			"xoffset": xoffset / scale2,
			"yoffset": (yoffset + this.padding) / scale2,
			"scale": scale2,
			"range": 1,
			"map": mapNum,
			"bounds": [0, 0, w / scale2, h2 / scale2]
		};
	}
	_normalizeCharsSet(text) {
		const unicodeConverterFunc = this.app.systems.element.getUnicodeConverter();
		if (unicodeConverterFunc) {
			text = unicodeConverterFunc(text);
		}
		const set = {};
		const symbols = string.getSymbols(text);
		for (let i2 = 0; i2 < symbols.length; i2++) {
			const ch = symbols[i2];
			if (set[ch]) continue;
			set[ch] = ch;
		}
		const chars = Object.keys(set);
		return chars.sort();
	}
	_getTextMetrics(text) {
		const textSpan = document.createElement("span");
		textSpan.id = "content-span";
		textSpan.innerHTML = text;
		const block = document.createElement("div");
		block.id = "content-block";
		block.style.display = "inline-block";
		block.style.width = "1px";
		block.style.height = "0px";
		const div = document.createElement("div");
		div.appendChild(textSpan);
		div.appendChild(block);
		div.style.font = `${this.fontSize}px ${this.fontName}`;
		const body = document.body;
		body.appendChild(div);
		let ascent = -1;
		let descent = -1;
		let height = -1;
		try {
			block.style["vertical-align"] = "baseline";
			ascent = block.offsetTop - textSpan.offsetTop;
			block.style["vertical-align"] = "bottom";
			height = block.offsetTop - textSpan.offsetTop;
			descent = height - ascent;
		} finally {
			document.body.removeChild(div);
		}
		return {
			ascent,
			descent,
			height
		};
	}
	// nasty, other systems are accessing textures directly
	get textures() {
		return this.atlases.map((atlas) => atlas.texture);
	}
};

var tempMeshInstances = [];
var lights = [[], [], []];
var RenderPassPicker = class extends RenderPass {
	blendState = BlendState.NOBLEND;
	camera;
	scene;
	layers;
	mapping;
	depth;
	_qualifiedLayerIndices = [];
	_pickMeshInstances = /* @__PURE__ */ new Map();
	_viewUniformFormat = null;
	constructor(device, renderer) {
		super(device);
		this.renderer = renderer;
	}
	getViewUniformFormat() {
		if (!this._viewUniformFormat) {
			this._viewUniformFormat = new UniformBufferFormat(this.device, [
				new UniformFormat("matrix_viewProjection", UNIFORMTYPE_MAT4),
				new UniformFormat("matrix_view", UNIFORMTYPE_MAT4)
			]);
		}
		return this._viewUniformFormat;
	}
	update(camera, scene, layers, mapping, depth) {
		this.camera = camera;
		this.scene = scene;
		this.layers = layers;
		this.mapping = mapping;
		this.depth = depth;
		if (scene.clusteredLightingEnabled) {
			this.emptyWorldClusters = this.renderer.worldClustersAllocator.empty;
		}
	}
	// Filter qualifying layers and prepare gsplat pick mesh instances for the compute-based
	// renderer. The execute() loop iterates the pre-built list instead of re-filtering.
	before() {
		this._qualifiedLayerIndices.length = 0;
		this._pickMeshInstances.clear();
		const { camera, scene, layers, renderer } = this;
		const srcLayers = scene.layers.layerList;
		const gsplatDirector = renderer.gsplatDirector;
		const pickerWidth = this.renderTarget?.width ?? 1;
		const pickerHeight = this.renderTarget?.height ?? 1;
		for (let i2 = 0; i2 < srcLayers.length; i2++) {
			const srcLayer = srcLayers[i2];
			if (layers && layers.indexOf(srcLayer) < 0) continue;
			if (!scene.layers.isSubLayerRenderedByCamera(i2, camera.camera)) continue;
			this._qualifiedLayerIndices.push(i2);
			renderer.culler.requestMeshInstanceCull(camera.camera, srcLayer);
			if (gsplatDirector) {
				const pickMI = gsplatDirector.prepareForPicking(camera.camera, pickerWidth, pickerHeight, srcLayer);
				if (pickMI) {
					this._pickMeshInstances.set(i2, pickMI);
				}
			}
		}
		renderer.culler.executeMeshInstanceCull();
	}
	execute() {
		const device = this.device;
		const { renderer, camera, scene, mapping, renderTarget } = this;
		const srcLayers = scene.layers.layerList;
		const isTransparent = scene.layers.subLayerList;
		for (const i2 of this._qualifiedLayerIndices) {
			const srcLayer = srcLayers[i2];
			const transparent = isTransparent[i2];
			if (srcLayer._clearDepthBuffer) {
				renderer.clear(camera.camera, false, true, false);
			}
			const culledInstances = srcLayer.getCulledInstances(camera.camera);
			const meshInstances = transparent ? culledInstances.transparent : culledInstances.opaque;
			for (let j = 0; j < meshInstances.length; j++) {
				const meshInstance = meshInstances[j];
				if (meshInstance.pick) {
					tempMeshInstances.push(meshInstance);
					mapping.set(meshInstance.id, meshInstance);
				}
			}
			const pickMI = this._pickMeshInstances.get(i2);
			if (pickMI) {
				tempMeshInstances.push(pickMI);
			}
			if (scene.gsplat.enableIds) {
				const placements = srcLayer.gsplatPlacements;
				for (let j = 0; j < placements.length; j++) {
					const placement = placements[j];
					const component = placement.node?.gsplat;
					if (component) {
						mapping.set(placement.id, component);
					}
				}
			}
			if (tempMeshInstances.length > 0) {
				const shaderPass = this.depth ? SHADER_DEPTH_PICK : SHADER_PICK;
				renderer.renderForwardLayer(camera.camera, renderTarget, null, void 0, shaderPass, {
					meshInstances: tempMeshInstances,
					splitLights: lights,
					lightClusters: this.emptyWorldClusters,
					viewUniformFormat: this.getViewUniformFormat(),
					drawCallback: () => device.setBlendState(this.blendState)
				});
				tempMeshInstances.length = 0;
			}
		}
	}
};

var tempSet2 = /* @__PURE__ */ new Set();
var _rect = new Vec4();
var _floatView = new Float32Array(1);
var _int32View = new Int32Array(_floatView.buffer);
var Picker = class {
	device;
	renderPass;
	depth;
	width;
	height;
	renderTarget = null;
	colorBuffer = null;
	depthBuffer = null;
	renderTargetDepth = null;
	mapping = /* @__PURE__ */ new Map();
	deviceValid = true;
	constructor(app2, width, height, depth = false) {
		this.device = app2.graphicsDevice;
		this.renderPass = new RenderPassPicker(this.device, app2.renderer);
		this.depth = depth;
		this.width = 0;
		this.height = 0;
		this.resize(width, height);
		this.allocateRenderTarget();
		this.device.on("destroy", () => {
			this.deviceValid = false;
		});
	}
	destroy() {
		this.releaseRenderTarget();
		this.renderPass?.destroy();
	}
	getSelection(x3, y2, width = 1, height = 1) {
		const device = this.device;
		if (device.isWebGPU) {
			return [];
		}
		y2 = this.renderTarget.height - (y2 + height);
		const rect = this.sanitizeRect(x3, y2, width, height);
		device.setRenderTarget(this.renderTarget);
		device.updateBegin();
		const pixels = new Uint8Array(4 * rect.z * rect.w);
		device.readPixels(rect.x, rect.y, rect.z, rect.w, pixels);
		device.updateEnd();
		return this.decodePixels(pixels, this.mapping);
	}
	getSelectionAsync(x3, y2, width = 1, height = 1) {
		if (!this.renderTarget || !this.renderTarget.colorBuffer) {
			return Promise.resolve([]);
		}
		return this._readTexture(this.renderTarget.colorBuffer, x3, y2, width, height, this.renderTarget).then((pixels) => {
			return this.decodePixels(pixels, this.mapping);
		});
	}
	_readTexture(texture, x3, y2, width, height, renderTarget) {
		if (this.device?.isWebGL2) {
			y2 = renderTarget.height - (y2 + height);
		}
		const rect = this.sanitizeRect(x3, y2, width, height);
		return texture.read(rect.x, rect.y, rect.z, rect.w, {
			immediate: true,
			renderTarget
		});
	}
	async getWorldPointAsync(x3, y2) {
		const camera = this.renderPass.camera;
		if (!camera) {
			return null;
		}
		const viewProjMat2 = new Mat4().mul2(camera.camera.projectionMatrix, camera.camera.viewMatrix);
		const invViewProj = viewProjMat2.invert();
		const near = camera.nearClip;
		const far = camera.farClip;
		const isOrtho = camera.projection === PROJECTION_ORTHOGRAPHIC;
		const linearDepth = await this.getPointDepthAsync(x3, y2);
		if (linearDepth === null) {
			return null;
		}
		const ndcDepth = isOrtho ? linearDepth : far * linearDepth / (linearDepth * (far - near) + near);
		const deviceCoord = new Vec4(
			x3 / this.width * 2 - 1,
			(1 - y2 / this.height) * 2 - 1,
			ndcDepth * 2 - 1,
			1
		);
		invViewProj.transformVec4(deviceCoord, deviceCoord);
		deviceCoord.mulScalar(1 / deviceCoord.w);
		return new Vec3(deviceCoord.x, deviceCoord.y, deviceCoord.z);
	}
	async getPointDepthAsync(x3, y2) {
		if (!this.depthBuffer) {
			return null;
		}
		const pixels = await this._readTexture(this.depthBuffer, x3, y2, 1, 1, this.renderTargetDepth);
		const intBits = (pixels[0] << 24 | pixels[1] << 16 | pixels[2] << 8 | pixels[3]) >>> 0;
		if (intBits === 4294967295) {
			return null;
		}
		_int32View[0] = intBits;
		return _floatView[0];
	}
	// sanitize the rectangle to make sure it's inside the texture and does not use fractions
	sanitizeRect(x3, y2, width, height) {
		const maxWidth = this.renderTarget.width;
		const maxHeight = this.renderTarget.height;
		x3 = math.clamp(Math.floor(x3), 0, maxWidth - 1);
		y2 = math.clamp(Math.floor(y2), 0, maxHeight - 1);
		width = Math.floor(Math.max(width, 1));
		width = Math.min(width, maxWidth - x3);
		height = Math.floor(Math.max(height, 1));
		height = Math.min(height, maxHeight - y2);
		return _rect.set(x3, y2, width, height);
	}
	decodePixels(pixels, mapping) {
		const selection = [];
		if (this.deviceValid) {
			const count = pixels.length;
			for (let i2 = 0; i2 < count; i2 += 4) {
				const r = pixels[i2 + 0];
				const g = pixels[i2 + 1];
				const b = pixels[i2 + 2];
				const a = pixels[i2 + 3];
				const index = (a << 24 | r << 16 | g << 8 | b) >>> 0;
				if (index !== 4294967295) {
					tempSet2.add(mapping.get(index));
				}
			}
			tempSet2.forEach((meshInstance) => {
				if (meshInstance) {
					selection.push(meshInstance);
				}
			});
			tempSet2.clear();
		}
		return selection;
	}
	createTexture(name) {
		return Texture.createDataTexture2D(this.device, name, this.width, this.height, PIXELFORMAT_RGBA8);
	}
	allocateRenderTarget() {
		this.colorBuffer = this.createTexture("pick");
		const colorBuffers = [this.colorBuffer];
		if (this.depth) {
			this.depthBuffer = this.createTexture("pick-depth");
			colorBuffers.push(this.depthBuffer);
			this.renderTargetDepth = new RenderTarget({
				colorBuffer: this.depthBuffer,
				depth: false
			});
		}
		this.renderTarget = new RenderTarget({
			colorBuffers,
			depth: true
		});
	}
	releaseRenderTarget() {
		this.renderTarget?.destroyTextureBuffers();
		this.renderTarget?.destroy();
		this.renderTarget = null;
		this.renderTargetDepth?.destroy();
		this.renderTargetDepth = null;
		this.colorBuffer = null;
		this.depthBuffer = null;
	}
	prepare(camera, scene, layers) {
		if (layers instanceof Layer) {
			layers = [layers];
		}
		this.renderTarget?.resize(this.width, this.height);
		this.renderTargetDepth?.resize(this.width, this.height);
		this.mapping.clear();
		const renderPass = this.renderPass;
		renderPass.init(this.renderTarget);
		renderPass.setClearColor(Color.WHITE);
		renderPass.depthStencilOps.clearDepth = true;
		renderPass.update(camera, scene, layers, this.mapping, this.depth);
		renderPass.render();
	}
	resize(width, height) {
		this.width = Math.floor(width);
		this.height = Math.floor(height);
	}
};

var SceneSettingsHandler = class extends ResourceHandler {
	constructor(app2) {
		super(app2, "scenesettings");
	}
	load(url, callback) {
		SceneUtils.load(url, this.maxRetries, callback);
	}
	open(url, data2) {
		return data2.settings;
	}
};

var targetX;
var targetY;
var vecA3 = new Vec3();
var vecB3 = new Vec3();
var rayA = new Ray();
var rayB = new Ray();
var rayC = new Ray();
rayA.end = new Vec3();
rayB.end = new Vec3();
rayC.end = new Vec3();
var _pq = new Vec3();
var _pa = new Vec3();
var _pb = new Vec3();
var _pc = new Vec3();
var _pd = new Vec3();
var _m = new Vec3();
var _au = new Vec3();
var _bv = new Vec3();
var _cw = new Vec3();
var _ir = new Vec3();
var _sct = new Vec3();
var _accumulatedScale = new Vec3();
var _paddingTop = new Vec3();
var _paddingBottom = new Vec3();
var _paddingLeft = new Vec3();
var _paddingRight = new Vec3();
var _cornerBottomLeft = new Vec3();
var _cornerBottomRight = new Vec3();
var _cornerTopRight = new Vec3();
var _cornerTopLeft = new Vec3();
var ZERO_VEC4 = new Vec4();
function scalarTriple(p12, p22, p32) {
	return _sct.cross(p12, p22).dot(p32);
}
function intersectLineQuad(p, q5, corners) {
	_pq.sub2(q5, p);
	_pa.sub2(corners[0], p);
	_pb.sub2(corners[1], p);
	_pc.sub2(corners[2], p);
	_m.cross(_pc, _pq);
	let v6 = _pa.dot(_m);
	let u;
	let w;
	if (v6 >= 0) {
		u = -_pb.dot(_m);
		if (u < 0) {
			return -1;
		}
		w = scalarTriple(_pq, _pb, _pa);
		if (w < 0) {
			return -1;
		}
		const denom = 1 / (u + v6 + w);
		_au.copy(corners[0]).mulScalar(u * denom);
		_bv.copy(corners[1]).mulScalar(v6 * denom);
		_cw.copy(corners[2]).mulScalar(w * denom);
		_ir.copy(_au).add(_bv).add(_cw);
	} else {
		_pd.sub2(corners[3], p);
		u = _pd.dot(_m);
		if (u < 0) {
			return -1;
		}
		w = scalarTriple(_pq, _pa, _pd);
		if (w < 0) {
			return -1;
		}
		v6 = -v6;
		const denom = 1 / (u + v6 + w);
		_au.copy(corners[0]).mulScalar(u * denom);
		_bv.copy(corners[3]).mulScalar(v6 * denom);
		_cw.copy(corners[2]).mulScalar(w * denom);
		_ir.copy(_au).add(_bv).add(_cw);
	}
	if (_pq.sub2(corners[0], corners[2]).lengthSq() < 1e-4 * 1e-4) return -1;
	if (_pq.sub2(corners[1], corners[3]).lengthSq() < 1e-4 * 1e-4) return -1;
	return _ir.sub(p).lengthSq();
}
var ElementInputEvent = class {
	constructor(event, element, camera) {
		this.event = event;
		this.element = element;
		this.camera = camera;
		this._stopPropagation = false;
	}
	stopPropagation() {
		this._stopPropagation = true;
		if (this.event) {
			this.event.stopImmediatePropagation();
			this.event.stopPropagation();
		}
	}
};
var ElementMouseEvent = class extends ElementInputEvent {
	constructor(event, element, camera, x3, y2, lastX, lastY) {
		super(event, element, camera);
		this.x = x3;
		this.y = y2;
		this.ctrlKey = event.ctrlKey || false;
		this.altKey = event.altKey || false;
		this.shiftKey = event.shiftKey || false;
		this.metaKey = event.metaKey || false;
		this.button = event.button;
		if (Mouse.isPointerLocked()) {
			this.dx = event.movementX || event.webkitMovementX || event.mozMovementX || 0;
			this.dy = event.movementY || event.webkitMovementY || event.mozMovementY || 0;
		} else {
			this.dx = x3 - lastX;
			this.dy = y2 - lastY;
		}
		this.wheelDelta = 0;
		if (event.type === "wheel") {
			if (event.deltaY > 0) {
				this.wheelDelta = 1;
			} else if (event.deltaY < 0) {
				this.wheelDelta = -1;
			}
		}
	}
};
var ElementTouchEvent = class extends ElementInputEvent {
	constructor(event, element, camera, x3, y2, touch2) {
		super(event, element, camera);
		this.touches = event.touches;
		this.changedTouches = event.changedTouches;
		this.x = x3;
		this.y = y2;
		this.touch = touch2;
	}
};
var ElementSelectEvent = class extends ElementInputEvent {
	constructor(event, element, camera, inputSource) {
		super(event, element, camera);
		this.inputSource = inputSource;
	}
};
var ElementInput = class _ElementInput {
	constructor(domElement, options2) {
		this._app = null;
		this._attached = false;
		this._target = null;
		this._enabled = true;
		this._lastX = 0;
		this._lastY = 0;
		this._upHandler = this._handleUp.bind(this);
		this._downHandler = this._handleDown.bind(this);
		this._moveHandler = this._handleMove.bind(this);
		this._wheelHandler = this._handleWheel.bind(this);
		this._touchstartHandler = this._handleTouchStart.bind(this);
		this._touchendHandler = this._handleTouchEnd.bind(this);
		this._touchcancelHandler = this._touchendHandler;
		this._touchmoveHandler = this._handleTouchMove.bind(this);
		this._sortHandler = this._sortElements.bind(this);
		this._elements = [];
		this._hoveredElement = null;
		this._pressedElement = null;
		this._touchedElements = {};
		this._touchesForWhichTouchLeaveHasFired = {};
		this._selectedElements = {};
		this._selectedPressedElements = {};
		this._useMouse = !options2 || options2.useMouse !== false;
		this._useTouch = !options2 || options2.useTouch !== false;
		this._useXr = !options2 || options2.useXr !== false;
		this._selectEventsAttached = false;
		if (platform.touch) {
			this._clickedEntities = {};
		}
		this.attach(domElement);
	}
	set enabled(value) {
		this._enabled = value;
	}
	get enabled() {
		return this._enabled;
	}
	set app(value) {
		this._app = value;
	}
	get app() {
		return this._app || getApplication();
	}
	attach(domElement) {
		if (this._attached) {
			this._attached = false;
			this.detach();
		}
		this._target = domElement;
		this._attached = true;
		const opts = platform.passiveEvents ? { passive: true } : false;
		if (this._useMouse) {
			window.addEventListener("mouseup", this._upHandler, opts);
			window.addEventListener("mousedown", this._downHandler, opts);
			window.addEventListener("mousemove", this._moveHandler, opts);
			window.addEventListener("wheel", this._wheelHandler, opts);
		}
		if (this._useTouch && platform.touch) {
			this._target.addEventListener("touchstart", this._touchstartHandler, opts);
			this._target.addEventListener("touchend", this._touchendHandler, false);
			this._target.addEventListener("touchmove", this._touchmoveHandler, false);
			this._target.addEventListener("touchcancel", this._touchcancelHandler, false);
		}
		this.attachSelectEvents();
	}
	attachSelectEvents() {
		if (!this._selectEventsAttached && this._useXr && this.app && this.app.xr && this.app.xr.supported) {
			if (!this._clickedEntities) {
				this._clickedEntities = {};
			}
			this._selectEventsAttached = true;
			this.app.xr.on("start", this._onXrStart, this);
		}
	}
	detach() {
		if (!this._attached) return;
		this._attached = false;
		const opts = platform.passiveEvents ? { passive: true } : false;
		if (this._useMouse) {
			window.removeEventListener("mouseup", this._upHandler, opts);
			window.removeEventListener("mousedown", this._downHandler, opts);
			window.removeEventListener("mousemove", this._moveHandler, opts);
			window.removeEventListener("wheel", this._wheelHandler, opts);
		}
		if (this._useTouch) {
			this._target.removeEventListener("touchstart", this._touchstartHandler, opts);
			this._target.removeEventListener("touchend", this._touchendHandler, false);
			this._target.removeEventListener("touchmove", this._touchmoveHandler, false);
			this._target.removeEventListener("touchcancel", this._touchcancelHandler, false);
		}
		if (this._selectEventsAttached) {
			this._selectEventsAttached = false;
			this.app.xr.off("start", this._onXrStart, this);
			this.app.xr.off("end", this._onXrEnd, this);
			this.app.xr.off("update", this._onXrUpdate, this);
			this.app.xr.input.off("selectstart", this._onSelectStart, this);
			this.app.xr.input.off("selectend", this._onSelectEnd, this);
			this.app.xr.input.off("remove", this._onXrInputRemove, this);
		}
		this._target = null;
	}
	addElement(element) {
		if (this._elements.indexOf(element) === -1) {
			this._elements.push(element);
		}
	}
	removeElement(element) {
		const idx = this._elements.indexOf(element);
		if (idx !== -1) {
			this._elements.splice(idx, 1);
		}
	}
	_handleUp(event) {
		if (!this._enabled) return;
		if (Mouse.isPointerLocked()) {
			return;
		}
		this._calcMouseCoords(event);
		this._onElementMouseEvent("mouseup", event);
	}
	_handleDown(event) {
		if (!this._enabled) return;
		if (Mouse.isPointerLocked()) {
			return;
		}
		this._calcMouseCoords(event);
		this._onElementMouseEvent("mousedown", event);
	}
	_handleMove(event) {
		if (!this._enabled) return;
		this._calcMouseCoords(event);
		this._onElementMouseEvent("mousemove", event);
		this._lastX = targetX;
		this._lastY = targetY;
	}
	_handleWheel(event) {
		if (!this._enabled) return;
		this._calcMouseCoords(event);
		this._onElementMouseEvent("mousewheel", event);
	}
	_determineTouchedElements(event) {
		const touchedElements = {};
		const cameras = this.app.systems.camera.cameras;
		for (let i2 = cameras.length - 1; i2 >= 0; i2--) {
			const camera = cameras[i2];
			let done = 0;
			const len = event.changedTouches.length;
			for (let j = 0; j < len; j++) {
				if (touchedElements[event.changedTouches[j].identifier]) {
					done++;
					continue;
				}
				const coords = getTouchTargetCoords(event.changedTouches[j]);
				const element = this._getTargetElementByCoords(camera, coords.x, coords.y);
				if (element) {
					done++;
					touchedElements[event.changedTouches[j].identifier] = {
						element,
						camera,
						x: coords.x,
						y: coords.y
					};
				}
			}
			if (done === len) {
				break;
			}
		}
		return touchedElements;
	}
	_handleTouchStart(event) {
		if (!this._enabled) return;
		const newTouchedElements = this._determineTouchedElements(event);
		for (let i2 = 0, len = event.changedTouches.length; i2 < len; i2++) {
			const touch2 = event.changedTouches[i2];
			const newTouchInfo = newTouchedElements[touch2.identifier];
			const oldTouchInfo = this._touchedElements[touch2.identifier];
			if (newTouchInfo && (!oldTouchInfo || newTouchInfo.element !== oldTouchInfo.element)) {
				this._fireEvent(event.type, new ElementTouchEvent(event, newTouchInfo.element, newTouchInfo.camera, newTouchInfo.x, newTouchInfo.y, touch2));
				this._touchesForWhichTouchLeaveHasFired[touch2.identifier] = false;
			}
		}
		for (const touchId in newTouchedElements) {
			this._touchedElements[touchId] = newTouchedElements[touchId];
		}
	}
	_handleTouchEnd(event) {
		if (!this._enabled) return;
		const cameras = this.app.systems.camera.cameras;
		for (const key in this._clickedEntities) {
			delete this._clickedEntities[key];
		}
		for (let i2 = 0, len = event.changedTouches.length; i2 < len; i2++) {
			const touch2 = event.changedTouches[i2];
			const touchInfo = this._touchedElements[touch2.identifier];
			if (!touchInfo) {
				continue;
			}
			const element = touchInfo.element;
			const camera = touchInfo.camera;
			const x3 = touchInfo.x;
			const y2 = touchInfo.y;
			delete this._touchedElements[touch2.identifier];
			delete this._touchesForWhichTouchLeaveHasFired[touch2.identifier];
			const coords = getTouchTargetCoords(touch2);
			for (let c2 = cameras.length - 1; c2 >= 0; c2--) {
				const hovered = this._getTargetElementByCoords(cameras[c2], coords.x, coords.y);
				if (hovered === element) {
					if (!this._clickedEntities[element.entity.guid]) {
						this._fireEvent("click", new ElementTouchEvent(event, element, camera, x3, y2, touch2));
						this._clickedEntities[element.entity.guid] = Date.now();
					}
				}
			}
			this._fireEvent(event.type, new ElementTouchEvent(event, element, camera, x3, y2, touch2));
		}
	}
	_handleTouchMove(event) {
		event.preventDefault();
		if (!this._enabled) return;
		const newTouchedElements = this._determineTouchedElements(event);
		for (let i2 = 0, len = event.changedTouches.length; i2 < len; i2++) {
			const touch2 = event.changedTouches[i2];
			const newTouchInfo = newTouchedElements[touch2.identifier];
			const oldTouchInfo = this._touchedElements[touch2.identifier];
			if (oldTouchInfo) {
				const coords = getTouchTargetCoords(touch2);
				if ((!newTouchInfo || newTouchInfo.element !== oldTouchInfo.element) && !this._touchesForWhichTouchLeaveHasFired[touch2.identifier]) {
					this._fireEvent("touchleave", new ElementTouchEvent(event, oldTouchInfo.element, oldTouchInfo.camera, coords.x, coords.y, touch2));
					this._touchesForWhichTouchLeaveHasFired[touch2.identifier] = true;
				}
				this._fireEvent("touchmove", new ElementTouchEvent(event, oldTouchInfo.element, oldTouchInfo.camera, coords.x, coords.y, touch2));
			}
		}
	}
	_onElementMouseEvent(eventType, event) {
		let element = null;
		const lastHovered = this._hoveredElement;
		this._hoveredElement = null;
		const cameras = this.app.systems.camera.cameras;
		let camera;
		for (let i2 = cameras.length - 1; i2 >= 0; i2--) {
			camera = cameras[i2];
			element = this._getTargetElementByCoords(camera, targetX, targetY);
			if (element) {
				break;
			}
		}
		this._hoveredElement = element;
		if ((eventType === "mousemove" || eventType === "mouseup") && this._pressedElement) {
			this._fireEvent(eventType, new ElementMouseEvent(event, this._pressedElement, camera, targetX, targetY, this._lastX, this._lastY));
		} else if (element) {
			this._fireEvent(eventType, new ElementMouseEvent(event, element, camera, targetX, targetY, this._lastX, this._lastY));
			if (eventType === "mousedown") {
				this._pressedElement = element;
			}
		}
		if (lastHovered !== this._hoveredElement) {
			if (lastHovered) {
				this._fireEvent("mouseleave", new ElementMouseEvent(event, lastHovered, camera, targetX, targetY, this._lastX, this._lastY));
			}
			if (this._hoveredElement) {
				this._fireEvent("mouseenter", new ElementMouseEvent(event, this._hoveredElement, camera, targetX, targetY, this._lastX, this._lastY));
			}
		}
		if (eventType === "mouseup" && this._pressedElement) {
			if (this._pressedElement === this._hoveredElement) {
				const guid2 = this._hoveredElement.entity.guid;
				let fireClick = !this._clickedEntities;
				if (this._clickedEntities) {
					const lastTouchUp = this._clickedEntities[guid2] || 0;
					const dt = Date.now() - lastTouchUp;
					fireClick = dt > 300;
					delete this._clickedEntities[guid2];
				}
				if (fireClick) {
					this._fireEvent("click", new ElementMouseEvent(event, this._hoveredElement, camera, targetX, targetY, this._lastX, this._lastY));
				}
			}
			this._pressedElement = null;
		}
	}
	_onXrStart() {
		this.app.xr.on("end", this._onXrEnd, this);
		this.app.xr.on("update", this._onXrUpdate, this);
		this.app.xr.input.on("selectstart", this._onSelectStart, this);
		this.app.xr.input.on("selectend", this._onSelectEnd, this);
		this.app.xr.input.on("remove", this._onXrInputRemove, this);
	}
	_onXrEnd() {
		this.app.xr.off("update", this._onXrUpdate, this);
		this.app.xr.input.off("selectstart", this._onSelectStart, this);
		this.app.xr.input.off("selectend", this._onSelectEnd, this);
		this.app.xr.input.off("remove", this._onXrInputRemove, this);
	}
	_onXrUpdate() {
		if (!this._enabled) return;
		const inputSources = this.app.xr.input.inputSources;
		for (let i2 = 0; i2 < inputSources.length; i2++) {
			this._onElementSelectEvent("selectmove", inputSources[i2], null);
		}
	}
	_onXrInputRemove(inputSource) {
		const hovered = this._selectedElements[inputSource.id];
		if (hovered) {
			inputSource._elementEntity = null;
			this._fireEvent("selectleave", new ElementSelectEvent(null, hovered, null, inputSource));
		}
		delete this._selectedElements[inputSource.id];
		delete this._selectedPressedElements[inputSource.id];
	}
	_onSelectStart(inputSource, event) {
		if (!this._enabled) return;
		this._onElementSelectEvent("selectstart", inputSource, event);
	}
	_onSelectEnd(inputSource, event) {
		if (!this._enabled) return;
		this._onElementSelectEvent("selectend", inputSource, event);
	}
	_onElementSelectEvent(eventType, inputSource, event) {
		let element;
		const hoveredBefore = this._selectedElements[inputSource.id];
		let hoveredNow;
		const cameras = this.app.systems.camera.cameras;
		let camera;
		if (inputSource.elementInput) {
			rayC.set(inputSource.getOrigin(), inputSource.getDirection());
			for (let i2 = cameras.length - 1; i2 >= 0; i2--) {
				camera = cameras[i2];
				element = this._getTargetElementByRay(rayC, camera);
				if (element) {
					break;
				}
			}
		}
		inputSource._elementEntity = element || null;
		if (element) {
			this._selectedElements[inputSource.id] = element;
			hoveredNow = element;
		} else {
			delete this._selectedElements[inputSource.id];
		}
		if (hoveredBefore !== hoveredNow) {
			if (hoveredBefore) this._fireEvent("selectleave", new ElementSelectEvent(event, hoveredBefore, camera, inputSource));
			if (hoveredNow) this._fireEvent("selectenter", new ElementSelectEvent(event, hoveredNow, camera, inputSource));
		}
		const pressed = this._selectedPressedElements[inputSource.id];
		if (eventType === "selectmove" && pressed) {
			this._fireEvent("selectmove", new ElementSelectEvent(event, pressed, camera, inputSource));
		}
		if (eventType === "selectstart") {
			this._selectedPressedElements[inputSource.id] = hoveredNow;
			if (hoveredNow) this._fireEvent("selectstart", new ElementSelectEvent(event, hoveredNow, camera, inputSource));
		}
		if (!inputSource.elementInput && pressed) {
			delete this._selectedPressedElements[inputSource.id];
			if (hoveredBefore) {
				this._fireEvent("selectend", new ElementSelectEvent(event, pressed, camera, inputSource));
			}
		}
		if (eventType === "selectend" && inputSource.elementInput) {
			delete this._selectedPressedElements[inputSource.id];
			if (pressed) {
				this._fireEvent("selectend", new ElementSelectEvent(event, pressed, camera, inputSource));
			}
			if (pressed && pressed === hoveredBefore) {
				this._fireEvent("click", new ElementSelectEvent(event, pressed, camera, inputSource));
			}
		}
	}
	_fireEvent(name, evt) {
		let element = evt.element;
		while (true) {
			element.fire(name, evt);
			if (evt._stopPropagation) {
				break;
			}
			if (!element.entity.parent) {
				break;
			}
			element = element.entity.parent.element;
			if (!element) {
				break;
			}
		}
	}
	_calcMouseCoords(event) {
		const rect = this._target.getBoundingClientRect();
		const left = Math.floor(rect.left);
		const top = Math.floor(rect.top);
		targetX = event.clientX - left;
		targetY = event.clientY - top;
	}
	_sortElements(a, b) {
		const layerOrder = this.app.scene.layers.sortTransparentLayers(a.layers, b.layers);
		if (layerOrder !== 0) return layerOrder;
		if (a.screen && !b.screen) {
			return -1;
		}
		if (!a.screen && b.screen) {
			return 1;
		}
		if (!a.screen && !b.screen) {
			return 0;
		}
		if (a.screen.screen.screenSpace && !b.screen.screen.screenSpace) {
			return -1;
		}
		if (b.screen.screen.screenSpace && !a.screen.screen.screenSpace) {
			return 1;
		}
		return b.drawOrder - a.drawOrder;
	}
	_getTargetElementByCoords(camera, x3, y2) {
		const rayScreen = this._calculateRayScreen(x3, y2, camera, rayA) ? rayA : null;
		const ray3d = this._calculateRay3d(x3, y2, camera, rayB) ? rayB : null;
		return this._getTargetElement(camera, rayScreen, ray3d);
	}
	_getTargetElementByRay(ray3, camera) {
		rayA.origin.copy(ray3.origin);
		rayA.direction.copy(ray3.direction);
		rayA.end.copy(rayA.direction).mulScalar(camera.farClip * 2).add(rayA.origin);
		const ray3d = rayA;
		const screenPos = camera.worldToScreen(ray3d.origin, vecA3);
		const rayScreen = this._calculateRayScreen(screenPos.x, screenPos.y, camera, rayB) ? rayB : null;
		return this._getTargetElement(camera, rayScreen, ray3d);
	}
	_getTargetElement(camera, rayScreen, ray3d) {
		let result = null;
		let closestDistance3d = Infinity;
		this._elements.sort(this._sortHandler);
		for (let i2 = 0, len = this._elements.length; i2 < len; i2++) {
			const element = this._elements[i2];
			if (!element.layers.some((v6) => camera.layersSet.has(v6))) {
				continue;
			}
			if (element.screen && element.screen.screen.screenSpace) {
				if (!rayScreen) {
					continue;
				}
				const currentDistance = this._checkElement(rayScreen, element, true);
				if (currentDistance >= 0) {
					result = element;
					break;
				}
			} else {
				if (!ray3d) {
					continue;
				}
				const currentDistance = this._checkElement(ray3d, element, false);
				if (currentDistance >= 0) {
					if (currentDistance < closestDistance3d) {
						result = element;
						closestDistance3d = currentDistance;
					}
					if (element.screen) {
						result = element;
						break;
					}
				}
			}
		}
		return result;
	}
	_calculateRayScreen(x3, y2, camera, ray3) {
		const sw = this.app.graphicsDevice.width;
		const sh = this.app.graphicsDevice.height;
		const cameraWidth = camera.rect.z * sw;
		const cameraHeight = camera.rect.w * sh;
		const cameraLeft = camera.rect.x * sw;
		const cameraRight = cameraLeft + cameraWidth;
		const cameraBottom = (1 - camera.rect.y) * sh;
		const cameraTop = cameraBottom - cameraHeight;
		let _x = x3 * sw / this._target.clientWidth;
		let _y = y2 * sh / this._target.clientHeight;
		if (_x >= cameraLeft && _x <= cameraRight && _y <= cameraBottom && _y >= cameraTop) {
			_x = sw * (_x - cameraLeft) / cameraWidth;
			_y = sh * (_y - cameraTop) / cameraHeight;
			_y = sh - _y;
			ray3.origin.set(_x, _y, 1);
			ray3.direction.set(0, 0, -1);
			ray3.end.copy(ray3.direction).mulScalar(2).add(ray3.origin);
			return true;
		}
		return false;
	}
	_calculateRay3d(x3, y2, camera, ray3) {
		const sw = this._target.clientWidth;
		const sh = this._target.clientHeight;
		const cameraWidth = camera.rect.z * sw;
		const cameraHeight = camera.rect.w * sh;
		const cameraLeft = camera.rect.x * sw;
		const cameraRight = cameraLeft + cameraWidth;
		const cameraBottom = (1 - camera.rect.y) * sh;
		const cameraTop = cameraBottom - cameraHeight;
		let _x = x3;
		let _y = y2;
		if (x3 >= cameraLeft && x3 <= cameraRight && y2 <= cameraBottom && _y >= cameraTop) {
			_x = sw * (_x - cameraLeft) / cameraWidth;
			_y = sh * (_y - cameraTop) / cameraHeight;
			camera.screenToWorld(_x, _y, camera.nearClip, vecA3);
			camera.screenToWorld(_x, _y, camera.farClip, vecB3);
			ray3.origin.copy(vecA3);
			ray3.direction.set(0, 0, -1);
			ray3.end.copy(vecB3);
			return true;
		}
		return false;
	}
	_checkElement(ray3, element, screen) {
		if (element.maskedBy) {
			if (this._checkElement(ray3, element.maskedBy.element, screen) < 0) {
				return -1;
			}
		}
		let scale2;
		if (screen) {
			scale2 = _ElementInput.calculateScaleToScreen(element);
		} else {
			scale2 = _ElementInput.calculateScaleToWorld(element);
		}
		const corners = _ElementInput.buildHitCorners(element, screen ? element.screenCorners : element.worldCorners, scale2);
		return intersectLineQuad(ray3.origin, ray3.end, corners);
	}
	// In most cases the corners used for hit testing will just be the element's
	// screen corners. However, in cases where the element has additional hit
	// padding specified, we need to expand the screenCorners to incorporate the
	// padding.
	// NOTE: Used by Editor for visualization in the viewport
	static buildHitCorners(element, screenOrWorldCorners, scale2) {
		let hitCorners = screenOrWorldCorners;
		const button = element.entity && element.entity.button;
		if (button) {
			const hitPadding = element.entity.button.hitPadding || ZERO_VEC4;
			_paddingTop.copy(element.entity.up);
			_paddingBottom.copy(_paddingTop).mulScalar(-1);
			_paddingRight.copy(element.entity.right);
			_paddingLeft.copy(_paddingRight).mulScalar(-1);
			_paddingTop.mulScalar(hitPadding.w * scale2.y);
			_paddingBottom.mulScalar(hitPadding.y * scale2.y);
			_paddingRight.mulScalar(hitPadding.z * scale2.x);
			_paddingLeft.mulScalar(hitPadding.x * scale2.x);
			_cornerBottomLeft.copy(hitCorners[0]).add(_paddingBottom).add(_paddingLeft);
			_cornerBottomRight.copy(hitCorners[1]).add(_paddingBottom).add(_paddingRight);
			_cornerTopRight.copy(hitCorners[2]).add(_paddingTop).add(_paddingRight);
			_cornerTopLeft.copy(hitCorners[3]).add(_paddingTop).add(_paddingLeft);
			hitCorners = [_cornerBottomLeft, _cornerBottomRight, _cornerTopRight, _cornerTopLeft];
		}
		if (scale2.x < 0) {
			const left = hitCorners[2].x;
			const right2 = hitCorners[0].x;
			hitCorners[0].x = left;
			hitCorners[1].x = right2;
			hitCorners[2].x = right2;
			hitCorners[3].x = left;
		}
		if (scale2.y < 0) {
			const bottom = hitCorners[2].y;
			const top = hitCorners[0].y;
			hitCorners[0].y = bottom;
			hitCorners[1].y = bottom;
			hitCorners[2].y = top;
			hitCorners[3].y = top;
		}
		if (scale2.z < 0) {
			const x3 = hitCorners[2].x;
			const y2 = hitCorners[2].y;
			const z2 = hitCorners[2].z;
			hitCorners[2].x = hitCorners[0].x;
			hitCorners[2].y = hitCorners[0].y;
			hitCorners[2].z = hitCorners[0].z;
			hitCorners[0].x = x3;
			hitCorners[0].y = y2;
			hitCorners[0].z = z2;
		}
		return hitCorners;
	}
	// NOTE: Used by Editor for visualization in the viewport
	static calculateScaleToScreen(element) {
		let current = element.entity;
		const screenScale = element.screen.screen.scale;
		_accumulatedScale.set(screenScale, screenScale, screenScale);
		while (current && !current.screen) {
			_accumulatedScale.mul(current.getLocalScale());
			current = current.parent;
		}
		return _accumulatedScale;
	}
	// NOTE: Used by Editor for visualization in the viewport
	static calculateScaleToWorld(element) {
		let current = element.entity;
		_accumulatedScale.set(1, 1, 1);
		while (current) {
			_accumulatedScale.mul(current.getLocalScale());
			current = current.parent;
		}
		return _accumulatedScale;
	}
};

var PIXELFORMAT_L8_A8 = PIXELFORMAT_LA8;
var PIXELFORMAT_R5_G6_B5 = PIXELFORMAT_RGB565;
var PIXELFORMAT_R5_G5_B5_A1 = PIXELFORMAT_RGBA5551;
var PIXELFORMAT_R4_G4_B4_A4 = PIXELFORMAT_RGBA4;
var PIXELFORMAT_R8_G8_B8 = PIXELFORMAT_RGB8;
var PIXELFORMAT_R8_G8_B8_A8 = PIXELFORMAT_RGBA8;
var PIXELFORMAT_SRGB = PIXELFORMAT_SRGB8;
var PIXELFORMAT_SRGBA = PIXELFORMAT_SRGBA8;
var BLENDMODE_CONSTANT_COLOR = BLENDMODE_CONSTANT;
var BLENDMODE_ONE_MINUS_CONSTANT_COLOR = BLENDMODE_ONE_MINUS_CONSTANT;
var BLENDMODE_CONSTANT_ALPHA = BLENDMODE_CONSTANT;
var BLENDMODE_ONE_MINUS_CONSTANT_ALPHA = BLENDMODE_ONE_MINUS_CONSTANT;
var CHUNKAPI_1_51 = "1.51";
var CHUNKAPI_1_55 = "1.55";
var CHUNKAPI_1_56 = "1.56";
var CHUNKAPI_1_57 = "1.57";
var CHUNKAPI_1_58 = "1.58";
var CHUNKAPI_1_60 = "1.60";
var CHUNKAPI_1_62 = "1.62";
var CHUNKAPI_1_65 = "1.65";
var CHUNKAPI_1_70 = "1.70";
var CHUNKAPI_2_1 = "2.1";
var CHUNKAPI_2_3 = "2.3";
var CHUNKAPI_2_5 = "2.5";
var CHUNKAPI_2_6 = "2.6";
var CHUNKAPI_2_7 = "2.7";
var CHUNKAPI_2_8 = "2.8";
var _viewport4 = new Vec4();
function createSphere(device, opts) {
	return Mesh.fromGeometry(device, new SphereGeometry(opts));
}
function createPlane(device, opts) {
	return Mesh.fromGeometry(device, new PlaneGeometry(opts));
}
function createBox(device, opts) {
	return Mesh.fromGeometry(device, new BoxGeometry(opts));
}
function createTorus(device, opts) {
	return Mesh.fromGeometry(device, new TorusGeometry(opts));
}
function createCapsule(device, opts) {
	return Mesh.fromGeometry(device, new CapsuleGeometry(opts));
}
function createCone(device, opts) {
	return Mesh.fromGeometry(device, new ConeGeometry(opts));
}
function createCylinder(device, opts) {
	return Mesh.fromGeometry(device, new CylinderGeometry(opts));
}
function createMesh2(device, positions, opts = {}) {
	const geom = new Geometry();
	geom.positions = positions;
	geom.normals = opts.normals;
	geom.tangents = opts.tangents;
	geom.colors = opts.colors;
	geom.uvs = opts.uvs;
	geom.uvs1 = opts.uvs1;
	geom.blendIndices = opts.blendIndices;
	geom.blendWeights = opts.blendWeights;
	geom.indices = opts.indices;
	return Mesh.fromGeometry(device, geom, opts);
}
function drawFullscreenQuad(device, target2, vertexBuffer, shader, rect) {
	let viewport;
	if (rect) {
		const w = target2 ? target2.width : device.width;
		const h2 = target2 ? target2.height : device.height;
		viewport = _viewport4.set(rect.x * w, rect.y * h2, rect.z * w, rect.w * h2);
	}
	drawQuadWithShader(device, target2, shader, viewport);
}
var Key = AnimationKey;
var Node = AnimationNode;
var LitOptions = LitShaderOptions;
var shaderChunks = new Proxy({}, {
	get(target2, prop) {
		return ShaderChunks.get(getApplication().graphicsDevice, SHADERLANGUAGE_GLSL).get(prop);
	},
	set(target2, prop, value) {
		ShaderChunks.get(getApplication().graphicsDevice, SHADERLANGUAGE_GLSL).set(prop, value);
		return true;
	}
});
ForwardRenderer.prototype.renderComposition = function(comp) {
	getApplication().renderComposition(comp);
};
Object.defineProperty(Material.prototype, "shader", {
	set: function(value) {
	},
	get: function() {
		return null;
	}
});
Object.defineProperty(Material.prototype, "blend", {
	set: function(value) {
		this.blendState.blend = value;
	},
	get: function() {
		return this.blendState.blend;
	}
});
Object.defineProperty(StandardMaterial.prototype, "shininess", {
	get: function() {
		return this.gloss * 100;
	},
	set: function(value) {
		this.gloss = value * 0.01;
	}
});
Object.defineProperty(StandardMaterial.prototype, "useGammaTonemap", {
	get: function() {
		return this.useTonemap;
	},
	set: function(value) {
		this.useTonemap = value;
	}
});
Object.defineProperty(StandardMaterial.prototype, "anisotropy", {
	get: function() {
		const sign = Math.sign(Math.cos(this.anisotropyRotation * math.DEG_TO_RAD * 2));
		return this.anisotropyIntensity * sign;
	},
	set: function(value) {
		this.anisotropyIntensity = Math.abs(value);
		if (value >= 0) {
			this.anisotropyRotation = 0;
		} else {
			this.anisotropyRotation = 90;
		}
	}
});
function _defineAlias(newName, oldName) {
	Object.defineProperty(StandardMaterial.prototype, oldName, {
		get: function() {
			return this[newName];
		},
		set: function(value) {
			this[newName] = value;
		}
	});
}
function _removeTint(name) {
	Object.defineProperty(StandardMaterial.prototype, name, {
		get: function() {
			return true;
		},
		set: function(value) {
		}
	});
}
_removeTint("sheenTint");
_removeTint("diffuseTint");
_removeTint("emissiveTint");
_removeTint("ambientTint");
_defineAlias("specularTint", "specularMapTint");
_defineAlias("aoVertexColor", "aoMapVertexColor");
_defineAlias("diffuseVertexColor", "diffuseMapVertexColor");
_defineAlias("specularVertexColor", "specularMapVertexColor");
_defineAlias("emissiveVertexColor", "emissiveMapVertexColor");
_defineAlias("metalnessVertexColor", "metalnessMapVertexColor");
_defineAlias("glossVertexColor", "glossMapVertexColor");
_defineAlias("opacityVertexColor", "opacityMapVertexColor");
_defineAlias("lightVertexColor", "lightMapVertexColor");
_defineAlias("sheenGloss", "sheenGlossiness");
_defineAlias("clearCoatGloss", "clearCoatGlossiness");
function _defineOption(name, newName) {
	if (name !== "pass") {
		Object.defineProperty(StandardMaterialOptions.prototype, name, {
			get: function() {
				return this.litOptions[newName || name];
			},
			set: function(value) {
				this.litOptions[newName || name] = value;
			}
		});
	}
}
_defineOption("refraction", "useRefraction");
var tempOptions = new LitShaderOptions();
var litOptionProperties = Object.getOwnPropertyNames(tempOptions);
for (const litOption in litOptionProperties) {
	_defineOption(litOptionProperties[litOption]);
}
AssetRegistry.prototype.getAssetById = function(id14) {
	return this.get(id14);
};
Object.defineProperty(XrInputSource.prototype, "ray", {
	get: function() {
		return this._rayLocal;
	}
});
Object.defineProperty(XrInputSource.prototype, "position", {
	get: function() {
		return this._localPosition;
	}
});
Object.defineProperty(XrInputSource.prototype, "rotation", {
	get: function() {
		return this._localRotation;
	}
});
var EVENT_KEYDOWN = "keydown";
var EVENT_KEYUP = "keyup";
var EVENT_MOUSEDOWN = "mousedown";
var EVENT_MOUSEMOVE = "mousemove";
var EVENT_MOUSEUP = "mouseup";
var EVENT_MOUSEWHEEL = "mousewheel";
var EVENT_TOUCHSTART = "touchstart";
var EVENT_TOUCHEND = "touchend";
var EVENT_TOUCHMOVE = "touchmove";
var EVENT_TOUCHCANCEL = "touchcancel";
var EVENT_GAMEPADCONNECTED = "gamepadconnected";
var EVENT_GAMEPADDISCONNECTED = "gamepaddisconnected";
var EVENT_SELECT = "select";
var EVENT_SELECTSTART = "selectstart";
var EVENT_SELECTEND = "selectend";
Object.defineProperty(ElementInput.prototype, "wheel", {
	get: function() {
		return this.wheelDelta * -2;
	}
});
Object.defineProperty(MouseEvent.prototype, "wheel", {
	get: function() {
		return this.wheelDelta * -2;
	}
});
var RIGIDBODY_TYPE_STATIC = BODYTYPE_STATIC;
var RIGIDBODY_TYPE_DYNAMIC = BODYTYPE_DYNAMIC;
var RIGIDBODY_TYPE_KINEMATIC = BODYTYPE_KINEMATIC;
var RIGIDBODY_CF_STATIC_OBJECT = BODYFLAG_STATIC_OBJECT;
var RIGIDBODY_CF_KINEMATIC_OBJECT = BODYFLAG_KINEMATIC_OBJECT;
var RIGIDBODY_CF_NORESPONSE_OBJECT = BODYFLAG_NORESPONSE_OBJECT;
var RIGIDBODY_ACTIVE_TAG = BODYSTATE_ACTIVE_TAG;
var RIGIDBODY_ISLAND_SLEEPING = BODYSTATE_ISLAND_SLEEPING;
var RIGIDBODY_WANTS_DEACTIVATION = BODYSTATE_WANTS_DEACTIVATION;
var RIGIDBODY_DISABLE_DEACTIVATION = BODYSTATE_DISABLE_DEACTIVATION;
var RIGIDBODY_DISABLE_SIMULATION = BODYSTATE_DISABLE_SIMULATION;
AppBase.prototype.isFullscreen = function() {
	return !!document.fullscreenElement;
};
AppBase.prototype.enableFullscreen = function(element, success, error) {
	element = element || this.graphicsDevice.canvas;
	const s2 = function() {
		success();
		document.removeEventListener("fullscreenchange", s2);
	};
	const e = function() {
		error();
		document.removeEventListener("fullscreenerror", e);
	};
	if (success) {
		document.addEventListener("fullscreenchange", s2, false);
	}
	if (error) {
		document.addEventListener("fullscreenerror", e, false);
	}
	if (element.requestFullscreen) {
		element.requestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
	} else {
		error();
	}
};
AppBase.prototype.disableFullscreen = function(success) {
	const s2 = function() {
		success();
		document.removeEventListener("fullscreenchange", s2);
	};
	if (success) {
		document.addEventListener("fullscreenchange", s2, false);
	}
	document.exitFullscreen();
};
AppBase.prototype.getSceneUrl = function(name) {
	const entry = this.scenes.find(name);
	if (entry) {
		return entry.url;
	}
	return null;
};
AppBase.prototype.loadScene = function(url, callback) {
	this.scenes.loadScene(url, callback);
};
AppBase.prototype.loadSceneHierarchy = function(url, callback) {
	this.scenes.loadSceneHierarchy(url, callback);
};
AppBase.prototype.loadSceneSettings = function(url, callback) {
	this.scenes.loadSceneSettings(url, callback);
};
ModelComponent.prototype.setVisible = function(visible) {
	this.enabled = visible;
};
Object.defineProperty(RigidBodyComponent.prototype, "bodyType", {
	get: function() {
		return this.type;
	},
	set: function(type) {
		this.type = type;
	}
});
RigidBodyComponent.prototype.syncBodyToEntity = function() {
	this._updateDynamic();
};
RigidBodyComponentSystem.prototype.setGravity = function() {
	if (arguments.length === 1) {
		this.gravity.copy(arguments[0]);
	} else {
		this.gravity.set(arguments[0], arguments[1], arguments[2]);
	}
};

var CpuTimer = class {
	constructor(app2) {
		this._frameIndex = 0;
		this._frameTimings = [];
		this._timings = [];
		this._prevTimings = [];
		this.unitsName = "ms";
		this.decimalPlaces = 1;
		this.enabled = true;
		app2.on("frameupdate", this.begin.bind(this, "update"));
		app2.on("framerender", this.mark.bind(this, "render"));
		app2.on("frameend", this.mark.bind(this, "other"));
	}
	// mark the beginning of the frame
	begin(name) {
		if (!this.enabled) {
			return;
		}
		if (this._frameIndex < this._frameTimings.length) {
			this._frameTimings.splice(this._frameIndex);
		}
		const tmp = this._prevTimings;
		this._prevTimings = this._timings;
		this._timings = this._frameTimings;
		this._frameTimings = tmp;
		this._frameIndex = 0;
		this.mark(name);
	}
	// mark
	mark(name) {
		if (!this.enabled) {
			return;
		}
		const timestamp = now();
		if (this._frameIndex > 0) {
			const prev = this._frameTimings[this._frameIndex - 1];
			prev[1] = timestamp - prev[1];
		} else if (this._timings.length > 0) {
			const prev = this._timings[this._timings.length - 1];
			prev[1] = timestamp - prev[1];
		}
		if (this._frameIndex >= this._frameTimings.length) {
			this._frameTimings.push([name, timestamp]);
		} else {
			const timing = this._frameTimings[this._frameIndex];
			timing[0] = name;
			timing[1] = timestamp;
		}
		this._frameIndex++;
	}
	get timings() {
		return this._timings.slice(0, -1).map((v6) => v6[1]);
	}
};

var GpuTimer = class {
	constructor(device) {
		this.device = device;
		if (device.gpuProfiler) {
			device.gpuProfiler.enabled = true;
		}
		this.enabled = true;
		this.unitsName = "ms";
		this.decimalPlaces = 1;
		this._timings = [];
	}
	get timings() {
		this._timings[0] = this.device.gpuProfiler?._frameTime ?? 0;
		return this._timings;
	}
};

var StatsTimer = class {
	constructor(app2, statNames, decimalPlaces, unitsName, multiplier) {
		this.app = app2;
		this.values = [];
		this.statNames = statNames;
		this.unitsName = unitsName;
		this.decimalPlaces = decimalPlaces;
		this.multiplier = multiplier || 1;
		const resolve2 = (path2, obj) => {
			return path2.split(".").reduce((prev, curr) => {
				if (!prev) return null;
				if (prev instanceof Map) {
					return prev.get(curr);
				}
				return prev[curr];
			}, obj || this);
		};
		app2.on("frameupdate", (ms) => {
			for (let i2 = 0; i2 < this.statNames.length; i2++) {
				const value = resolve2(this.statNames[i2], this.app.stats);
				this.values[i2] = (value ?? 0) * this.multiplier;
			}
		});
	}
	get timings() {
		return this.values;
	}
};

var Graph = class {
	constructor(name, app2, watermark, textRefreshRate, timer) {
		this.app = app2;
		this.name = name;
		this.device = app2.graphicsDevice;
		this.timer = timer;
		this.watermark = watermark;
		this.enabled = false;
		this.textRefreshRate = textRefreshRate;
		this.avgTotal = 0;
		this.avgTimer = 0;
		this.avgCount = 0;
		this.maxValue = 0;
		this.timingText = "";
		this.maxText = "";
		this.texture = null;
		this.yOffset = 0;
		this.graphType = 0;
		this.cursor = 0;
		this.sample = new Uint8ClampedArray(4);
		this.sample.set([0, 0, 0, 255]);
		this.needsClear = false;
		this.counter = 0;
		this.app.on("frameupdate", this.update, this);
	}
	destroy() {
		this.app.off("frameupdate", this.update, this);
	}
	// called when context was lost, function releases all context related resources
	loseContext() {
		if (this.timer && typeof this.timer.loseContext === "function") {
			this.timer.loseContext();
		}
	}
	update(ms) {
		const timings = this.timer.timings;
		const total = timings.reduce((a, v6) => a + v6, 0);
		this.avgTotal += total;
		this.avgTimer += ms;
		this.avgCount++;
		this.maxValue = Math.max(this.maxValue, total);
		if (this.avgTimer > this.textRefreshRate) {
			this.timingText = (this.avgTotal / this.avgCount).toFixed(this.timer.decimalPlaces);
			this.maxText = this.maxValue.toFixed(this.timer.decimalPlaces);
			this.avgTimer = 0;
			this.avgTotal = 0;
			this.avgCount = 0;
			this.maxValue = 0;
		}
		if (this.enabled) {
			const range = 1.5 * this.watermark;
			this.sample[0] = Math.floor(total / range * 255);
			this.sample[1] = 0;
			this.sample[2] = 0;
			this.sample[3] = this.watermark / range * 255;
			if (this.yOffset >= this.texture.height) {
				return;
			}
			const data2 = this.texture.lock();
			if (this.needsClear) {
				const rowOffset = this.yOffset * this.texture.width * 4;
				data2.fill(0, rowOffset, rowOffset + this.texture.width * 4);
				this.needsClear = false;
			}
			data2.set(this.sample, (this.cursor + this.yOffset * this.texture.width) * 4);
			this.texture.unlock();
			this.cursor++;
			if (this.cursor === this.texture.width) {
				this.cursor = 0;
			}
		}
	}
	render(render2d, x3, y2, w, h2) {
		render2d.quad(
			x3 + w,
			y2,
			-w,
			h2,
			this.enabled ? this.cursor : 0,
			this.enabled ? 0.5 + this.yOffset : this.texture.height - 1,
			-w,
			0,
			this.texture,
			this.graphType
		);
	}
};

var WordAtlas = class {
	constructor(device, words) {
		const initContext = (context2) => {
			context2.font = '10px "Lucida Console", Monaco, monospace';
			context2.textAlign = "left";
			context2.textBaseline = "alphabetic";
		};
		const isNumber = (word) => {
			return word === "." || word.length === 1 && word.charCodeAt(0) >= 48 && word.charCodeAt(0) <= 57;
		};
		const canvas = document.createElement("canvas");
		const context = canvas.getContext("2d", { alpha: true });
		initContext(context);
		const placements = /* @__PURE__ */ new Map();
		const padding = 5;
		const width = 512;
		let x3 = padding;
		let y2 = padding;
		words.forEach((word) => {
			const measurement = context.measureText(word);
			const l = Math.ceil(-measurement.actualBoundingBoxLeft);
			const r = Math.ceil(measurement.actualBoundingBoxRight);
			const a = Math.ceil(measurement.actualBoundingBoxAscent);
			const d = Math.ceil(measurement.actualBoundingBoxDescent);
			const w = l + r;
			const h2 = a + d;
			if (x3 + w + padding >= width) {
				x3 = padding;
				y2 += 16;
			}
			placements.set(word, { l, r, a, d, w, h: h2, x: x3, y: y2 });
			x3 += w + padding;
		});
		canvas.width = 512;
		canvas.height = math.nextPowerOfTwo(y2 + 16 + padding);
		initContext(context);
		context.fillStyle = "rgb(0, 0, 0)";
		context.fillRect(0, 0, canvas.width, canvas.height);
		placements.forEach((m, word) => {
			context.fillStyle = isNumber(word) ? "rgb(255, 240, 100)" : "rgb(150, 220, 230)";
			context.fillText(word, m.x - m.l, m.y + m.a);
		});
		this.placements = placements;
		const data2 = context.getImageData(0, 0, canvas.width, canvas.height).data;
		for (let i2 = 0; i2 < data2.length; i2 += 4) {
			const maxChannel = Math.max(data2[i2 + 0], data2[i2 + 1], data2[i2 + 2]);
			data2[i2 + 3] = Math.min(maxChannel * 2, 255);
		}
		this.texture = new Texture(device, {
			name: "mini-stats-word-atlas",
			width: canvas.width,
			height: canvas.height,
			mipmaps: false,
			minFilter: FILTER_NEAREST,
			magFilter: FILTER_NEAREST,
			levels: [data2]
		});
	}
	destroy() {
		this.texture.destroy();
		this.texture = null;
	}
	render(render2d, word, x3, y2) {
		const p = this.placements.get(word);
		if (p) {
			const padding = 1;
			render2d.quad(
				x3 + p.l - padding,
				y2 - p.d + padding,
				p.w + padding * 2,
				p.h + padding * 2,
				p.x - padding,
				this.texture.height - p.y - p.h - padding,
				void 0,
				void 0,
				this.texture,
				1
			);
			return p.w;
		}
		let totalWidth = 0;
		for (let i2 = 0; i2 < word.length; i2++) {
			const char = word[i2];
			if (char === " ") {
				totalWidth += 5;
				continue;
			}
			const charPlacement = this.placements.get(char);
			if (charPlacement) {
				const padding = 1;
				render2d.quad(
					x3 + totalWidth + charPlacement.l - padding,
					y2 - charPlacement.d + padding,
					charPlacement.w + padding * 2,
					charPlacement.h + padding * 2,
					charPlacement.x - padding,
					this.texture.height - charPlacement.y - charPlacement.h - padding,
					void 0,
					void 0,
					this.texture,
					1
				);
				totalWidth += charPlacement.w;
			}
		}
		return totalWidth;
	}
};

var graphColorDefault = "1.0, 0.412, 0.380";
var graphColorGpu = "0.467, 0.867, 0.467";
var graphColorCpu = "0.424, 0.627, 0.863";
var mainBackgroundColor = "0.0, 0.0, 0.0";
var gpuBackgroundColor = "0.15, 0.15, 0.0";
var cpuBackgroundColor = "0.15, 0.0, 0.1";
var vertexShaderGLSL = `
	attribute vec3 vertex_position;
	attribute vec4 vertex_texCoord0;
	varying vec4 uv0;
	varying float wordFlag;
	void main(void) {
		gl_Position = vec4(vertex_position.xy * 2.0 - 1.0, 0.5, 1.0);
		uv0 = vertex_texCoord0;
		wordFlag = vertex_position.z;
	}
`;
var vertexShaderWGSL = `
	attribute vertex_position: vec3f;
	attribute vertex_texCoord0: vec4f;
	varying uv0: vec4f;
	varying wordFlag: f32;
	@vertex fn vertexMain(input : VertexInput) -> VertexOutput {
		var output : VertexOutput;
		output.position = vec4(input.vertex_position.xy * 2.0 - 1.0, 0.5, 1.0);
		output.uv0 = input.vertex_texCoord0;
		output.wordFlag = input.vertex_position.z;
		return output;
	}
`;
var fragmentShaderGLSL = `
	varying vec4 uv0;
	varying float wordFlag;
	uniform vec4 clr;
	uniform sampler2D graphTex;
	uniform sampler2D wordsTex;
	void main (void) {
		vec3 graphColor = vec3(${graphColorDefault});
		if (wordFlag > 0.5) {
			graphColor = vec3(${graphColorCpu});
		} else if (wordFlag > 0.2) {
			graphColor = vec3(${graphColorGpu});
		}
		vec4 graphSample = texture2D(graphTex, uv0.xy);
		vec4 graph;
		if (uv0.w < graphSample.r)
			graph = vec4(graphColor, 1.0);
		else {
			vec3 bgColor = vec3(${mainBackgroundColor});
			if (wordFlag > 0.5) {
				bgColor = vec3(${cpuBackgroundColor});
			} else if (wordFlag > 0.2) {
				bgColor = vec3(${gpuBackgroundColor});
			}
			graph = vec4(bgColor, 1.0);
		}
		vec4 words = texture2D(wordsTex, vec2(uv0.x, 1.0 - uv0.y));
		if (wordFlag > 0.99) {
			gl_FragColor = words * clr;
		} else {
			gl_FragColor = graph * clr;
		}
	}
`;
var fragmentShaderWGSL = `
	varying uv0: vec4f;
	varying wordFlag: f32;
	uniform clr: vec4f;
	var graphTex : texture_2d<f32>;
	var graphTex_sampler : sampler;
	var wordsTex : texture_2d<f32>;
	var wordsTex_sampler : sampler;
	@fragment fn fragmentMain(input : FragmentInput) -> FragmentOutput {
		var uv0: vec4f = input.uv0;
		var graphColor: vec3f = vec3f(${graphColorDefault});
		if (input.wordFlag > 0.5) {
			graphColor = vec3f(${graphColorCpu});
		} else if (input.wordFlag > 0.2) {
			graphColor = vec3f(${graphColorGpu});
		}
		var graphSample: vec4f = textureSample(graphTex, graphTex_sampler, uv0.xy);
		var graph: vec4f;
		if (uv0.w < graphSample.r) {
			graph = vec4f(graphColor, 1.0);
		} else {
			var bgColor: vec3f = vec3f(${mainBackgroundColor});
			if (input.wordFlag > 0.5) {
				bgColor = vec3f(${cpuBackgroundColor});
			} else if (input.wordFlag > 0.2) {
				bgColor = vec3f(${gpuBackgroundColor});
			}
			graph = vec4f(bgColor, 1.0);
		}
		var words: vec4f = textureSample(wordsTex, wordsTex_sampler, vec2f(uv0.x, 1.0 - uv0.y));
		var output: FragmentOutput;
		if (input.wordFlag > 0.99) {
			output.color = words * uniform.clr;
		} else {
			output.color = graph * uniform.clr;
		}
		return output;
	}
`;
var Render2d = class {
	constructor(device, maxQuads = 2048) {
		const format = new VertexFormat(device, [
			{ semantic: SEMANTIC_POSITION, components: 3, type: TYPE_FLOAT32 },
			{ semantic: SEMANTIC_TEXCOORD0, components: 4, type: TYPE_FLOAT32 }
		]);
		const indices = new Uint16Array(maxQuads * 6);
		for (let i2 = 0; i2 < maxQuads; ++i2) {
			indices[i2 * 6 + 0] = i2 * 4;
			indices[i2 * 6 + 1] = i2 * 4 + 1;
			indices[i2 * 6 + 2] = i2 * 4 + 2;
			indices[i2 * 6 + 3] = i2 * 4;
			indices[i2 * 6 + 4] = i2 * 4 + 2;
			indices[i2 * 6 + 5] = i2 * 4 + 3;
		}
		this.device = device;
		this.maxQuads = maxQuads;
		this.buffer = new VertexBuffer(device, format, maxQuads * 4, {
			usage: BUFFER_STREAM
		});
		this.data = new Float32Array(this.buffer.numBytes / 4);
		this.indexBuffer = new IndexBuffer(device, INDEXFORMAT_UINT16, maxQuads * 6, BUFFER_STATIC, indices);
		this.prim = {
			type: PRIMITIVE_TRIANGLES,
			indexed: true,
			base: 0,
			baseVertex: 0,
			count: 0
		};
		this.quads = 0;
		this.mesh = new Mesh(device);
		this.mesh.vertexBuffer = this.buffer;
		this.mesh.indexBuffer[0] = this.indexBuffer;
		this.mesh.primitive = [this.prim];
		const material = new ShaderMaterial({
			uniqueName: "MiniStats",
			vertexGLSL: vertexShaderGLSL,
			fragmentGLSL: fragmentShaderGLSL,
			vertexWGSL: vertexShaderWGSL,
			fragmentWGSL: fragmentShaderWGSL,
			attributes: {
				vertex_position: SEMANTIC_POSITION,
				vertex_texCoord0: SEMANTIC_TEXCOORD0
			}
		});
		this.material = material;
		material.cull = CULLFACE_NONE;
		material.depthState = DepthState.NODEPTH;
		material.blendState = new BlendState(
			true,
			BLENDEQUATION_ADD,
			BLENDMODE_SRC_ALPHA,
			BLENDMODE_ONE_MINUS_SRC_ALPHA,
			BLENDEQUATION_ADD,
			BLENDMODE_ONE,
			BLENDMODE_ONE
		);
		material.update();
		this.meshInstance = new MeshInstance(this.mesh, material, new GraphNode("MiniStatsMesh"));
		this.uniforms = {
			clr: new Float32Array(4)
		};
		this.targetSize = {
			width: device.width,
			height: device.height
		};
	}
	quad(x3, y2, w, h2, u, v6, uw, uh, texture, wordFlag = 0) {
		if (this.quads >= this.maxQuads) {
			return;
		}
		const rw = this.targetSize.width;
		const rh = this.targetSize.height;
		const x0 = x3 / rw;
		const y0 = y2 / rh;
		const x1 = (x3 + w) / rw;
		const y1 = (y2 + h2) / rh;
		const tw = texture.width;
		const th = texture.height;
		const u0 = u / tw;
		const v0 = v6 / th;
		const u1 = (u + (uw ?? w)) / tw;
		const v15 = (v6 + (uh ?? h2)) / th;
		this.data.set([
			x0,
			y0,
			wordFlag,
			u0,
			v0,
			0,
			0,
			x1,
			y0,
			wordFlag,
			u1,
			v0,
			1,
			0,
			x1,
			y1,
			wordFlag,
			u1,
			v15,
			1,
			1,
			x0,
			y1,
			wordFlag,
			u0,
			v15,
			0,
			1
		], 4 * 7 * this.quads);
		this.quads++;
		this.prim.count += 6;
	}
	startFrame() {
		this.quads = 0;
		this.prim.count = 0;
		this.targetSize.width = this.device.canvas.scrollWidth;
		this.targetSize.height = this.device.canvas.scrollHeight;
	}
	render(app2, layer, graphTexture, wordsTexture, clr, height) {
		this.buffer.setData(this.data.buffer);
		this.uniforms.clr.set(clr, 0);
		this.material.setParameter("clr", this.uniforms.clr);
		this.material.setParameter("graphTex", graphTexture);
		this.material.setParameter("wordsTex", wordsTexture);
		app2.drawMeshInstance(this.meshInstance, layer);
	}
};

var cpuStatDisplayNames = {
	animUpdate: "anim",
	physicsTime: "physics",
	renderTime: "render",
	gsplatSort: "gsplatSort"
};
var delayedStartStats = /* @__PURE__ */ new Set([
	"physicsTime",
	"animUpdate",
	"gsplatSort"
]);
var MiniStats = class _MiniStats {
	constructor(app2, options2 = _MiniStats.getDefaultOptions()) {
		const device = app2.graphicsDevice;
		this.graphRows = /* @__PURE__ */ new Map();
		this.freeRows = [];
		this.nextRowIndex = 0;
		this.sizes = options2.sizes;
		this.initGraphs(app2, device, options2);
		const words = new Set(
			["", "ms", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "-", " "].concat(this.graphs.map((graph) => graph.name)).concat(options2.stats ? options2.stats.map((stat) => stat.unitsName) : []).filter((item) => !!item)
		);
		for (let i2 = 97; i2 <= 122; i2++) {
			words.add(String.fromCharCode(i2));
		}
		for (let i2 = 65; i2 <= 90; i2++) {
			words.add(String.fromCharCode(i2));
		}
		this.wordAtlas = new WordAtlas(device, words);
		this._activeSizeIndex = options2.startSizeIndex;
		const gpuTimingMinSize = options2.gpuTimingMinSize ?? 1;
		const cpuTimingMinSize = options2.cpuTimingMinSize ?? 1;
		const vramTimingMinSize = options2.vramTimingMinSize ?? 1;
		if (gpuTimingMinSize < this.sizes.length || cpuTimingMinSize < this.sizes.length || vramTimingMinSize < this.sizes.length) {
			const lastWidth = this.sizes[this.sizes.length - 1].width;
			for (let i2 = 1; i2 < this.sizes.length - 1; i2++) {
				this.sizes[i2].width = lastWidth;
			}
		}
		const div = document.createElement("div");
		div.setAttribute("id", "mini-stats");
		div.style.cssText = "position:fixed;bottom:0;left:0;background:transparent;";
		document.body.appendChild(div);
		div.addEventListener("mouseenter", (event) => {
			this.opacity = 1;
		});
		div.addEventListener("mouseleave", (event) => {
			this.opacity = this._activeSizeIndex > 0 ? 0.85 : 0.7;
		});
		div.addEventListener("click", (event) => {
			event.preventDefault();
			if (this._enabled) {
				this.activeSizeIndex = (this.activeSizeIndex + 1) % this.sizes.length;
				this.resize(this.sizes[this.activeSizeIndex].width, this.sizes[this.activeSizeIndex].height, this.sizes[this.activeSizeIndex].graphs);
			}
		});
		device.on("resizecanvas", this.updateDiv, this);
		device.on("losecontext", this.loseContext, this);
		app2.on("postrender", this.postRender, this);
		this.app = app2;
		this.drawLayer = app2.scene.layers.getLayerById(LAYERID_UI);
		this.device = device;
		this.render2d = new Render2d(device);
		this.div = div;
		this.width = 0;
		this.height = 0;
		this.gspacing = 2;
		this.clr = [1, 1, 1, options2.startSizeIndex > 0 ? 0.85 : 0.7];
		this._enabled = true;
		this.gpuTimingMinSize = gpuTimingMinSize;
		this.gpuPassGraphs = /* @__PURE__ */ new Map();
		this.cpuTimingMinSize = cpuTimingMinSize;
		this.cpuGraphs = /* @__PURE__ */ new Map();
		this.vramTimingMinSize = vramTimingMinSize;
		this.vramGraphs = /* @__PURE__ */ new Map();
		this.frameIndex = 0;
		this.textRefreshRate = options2.textRefreshRate;
		this.activeSizeIndex = this._activeSizeIndex;
	}
	destroy() {
		this.device.off("resizecanvas", this.updateDiv, this);
		this.device.off("losecontext", this.loseContext, this);
		this.app.off("postrender", this.postRender, this);
		this.graphs.forEach((graph) => graph.destroy());
		this.gpuPassGraphs.clear();
		this.cpuGraphs.clear();
		this.vramGraphs.clear();
		this.wordAtlas.destroy();
		this.texture.destroy();
		this.div.remove();
	}
	static statPresets = {
		gsplats: [
			{ name: "GSplats", stats: ["frame.gsplats"], decimalPlaces: 3, multiplier: 1 / 1e6, unitsName: "M", watermark: 10 }
		],
		gsplatsCopy: [
			{ name: "GsplatsCopy", stats: ["frame.gsplatBufferCopy"], decimalPlaces: 1, multiplier: 1, unitsName: "%", watermark: 100 }
		]
	};
	static getDefaultOptions(extraStats = []) {
		const options2 = {
			// sizes of area to render individual graphs in and spacing between individual graphs
			sizes: [
				{ width: 100, height: 16, spacing: 0, graphs: false },
				{ width: 128, height: 32, spacing: 2, graphs: true },
				{ width: 256, height: 64, spacing: 2, graphs: true }
			],
			// index into sizes array for initial setting
			startSizeIndex: 0,
			// refresh rate of text stats in ms
			textRefreshRate: 500,
			// cpu graph options
			cpu: {
				enabled: true,
				watermark: 33
			},
			// gpu graph options
			gpu: {
				enabled: true,
				watermark: 33
			},
			// array of options to render additional graphs based on stats collected into Application.stats
			stats: [
				{
					// display name
					name: "Frame",
					// path to data inside Application.stats
					stats: ["frame.ms"],
					// number of decimal places (defaults to none)
					decimalPlaces: 1,
					// units (defaults to "")
					unitsName: "ms",
					// watermark - shown as a line on the graph, useful for displaying a budget
					watermark: 33
				},
				// total number of draw calls
				{
					name: "DrawCalls",
					stats: ["drawCalls.total"],
					watermark: 1e3
				},
				// used VRAM in MB
				{
					name: "VRAM",
					stats: ["vram.totalUsed"],
					decimalPlaces: 1,
					multiplier: 1 / (1024 * 1024),
					unitsName: "MB",
					watermark: 1024
				}
			],
			// minimum size index to show GPU pass timing graphs
			gpuTimingMinSize: 1,
			// minimum size index to show CPU sub-timing graphs
			cpuTimingMinSize: 1,
			// minimum size index to show VRAM subcategory graphs
			vramTimingMinSize: 1
		};
		if (extraStats.length > 0) {
			const frameIndex = options2.stats.findIndex((s2) => s2.name === "Frame");
			const insertIndex = frameIndex !== -1 ? frameIndex + 1 : options2.stats.length;
			const extra = extraStats.flatMap((name) => _MiniStats.statPresets[name] ?? []).reverse();
			options2.stats.splice(insertIndex, 0, ...extra);
		}
		return options2;
	}
	set activeSizeIndex(value) {
		this._activeSizeIndex = value;
		this.gspacing = this.sizes[value].spacing;
		this.resize(this.sizes[value].width, this.sizes[value].height, this.sizes[value].graphs);
		this.opacity = value > 0 ? 0.85 : 0.7;
		if (value < this.gpuTimingMinSize && this.gpuPassGraphs) {
			this.clearSubGraphs(this.gpuPassGraphs, "GPU", 0.33);
		}
		if (value < this.cpuTimingMinSize && this.cpuGraphs) {
			this.clearSubGraphs(this.cpuGraphs, "CPU", 0.66);
		}
		if (value < this.vramTimingMinSize && this.vramGraphs) {
			this.clearSubGraphs(this.vramGraphs);
		}
	}
	get activeSizeIndex() {
		return this._activeSizeIndex;
	}
	set opacity(value) {
		this.clr[3] = value;
	}
	get opacity() {
		return this.clr[3];
	}
	get overallHeight() {
		const graphs = this.graphs;
		const spacing = this.gspacing;
		return this.height * graphs.length + spacing * (graphs.length - 1);
	}
	set enabled(value) {
		if (value !== this._enabled) {
			this._enabled = value;
			for (let i2 = 0; i2 < this.graphs.length; ++i2) {
				this.graphs[i2].enabled = value;
				this.graphs[i2].timer.enabled = value;
			}
		}
	}
	get enabled() {
		return this._enabled;
	}
	initGraphs(app2, device, options2) {
		this.graphs = [];
		if (options2.stats) {
			options2.stats.forEach((entry) => {
				if (entry.name === "VRAM") {
					const timer = new StatsTimer(app2, entry.stats, entry.decimalPlaces, entry.unitsName, entry.multiplier);
					const graph = new Graph(entry.name, app2, entry.watermark, options2.textRefreshRate, timer);
					this.graphs.push(graph);
				}
			});
		}
		if (options2.cpu.enabled) {
			const timer = new CpuTimer(app2);
			const graph = new Graph("CPU", app2, options2.cpu.watermark, options2.textRefreshRate, timer);
			graph.graphType = 0.66;
			this.graphs.push(graph);
		}
		if (options2.gpu.enabled) {
			const timer = new GpuTimer(device);
			const graph = new Graph("GPU", app2, options2.gpu.watermark, options2.textRefreshRate, timer);
			graph.graphType = 0.33;
			this.graphs.push(graph);
		}
		if (options2.stats) {
			options2.stats.forEach((entry) => {
				if (entry.name === "VRAM") {
					return;
				}
				const timer = new StatsTimer(app2, entry.stats, entry.decimalPlaces, entry.unitsName, entry.multiplier);
				const graph = new Graph(entry.name, app2, entry.watermark, options2.textRefreshRate, timer);
				this.graphs.push(graph);
			});
		}
		this.texture = new Texture(device, {
			name: "mini-stats-graph-texture",
			width: 1,
			height: 1,
			mipmaps: false,
			minFilter: FILTER_NEAREST,
			magFilter: FILTER_NEAREST,
			addressU: ADDRESS_REPEAT,
			addressV: ADDRESS_REPEAT
		});
		this.graphs.forEach((graph) => {
			graph.texture = this.texture;
			this.allocateRow(graph);
		});
	}
	render() {
		const graphs = this.graphs;
		const wordAtlas = this.wordAtlas;
		const render2d = this.render2d;
		const width = this.width;
		const height = this.height;
		const gspacing = this.gspacing;
		render2d.startFrame();
		for (let i2 = 0; i2 < graphs.length; ++i2) {
			const graph = graphs[i2];
			let y2 = i2 * (height + gspacing);
			graph.render(render2d, 0, y2, width, height);
			let x3 = 1;
			y2 += height - 13;
			x3 += wordAtlas.render(render2d, graph.name, x3, y2) + 10;
			const timingText = graph.timingText;
			for (let j = 0; j < timingText.length; ++j) {
				x3 += wordAtlas.render(render2d, timingText[j], x3, y2);
			}
			if (graph.maxText && this._activeSizeIndex > 0) {
				x3 += 5;
				x3 += wordAtlas.render(render2d, "max", x3, y2);
				x3 += 5;
				const maxText = graph.maxText;
				for (let j = 0; j < maxText.length; ++j) {
					x3 += wordAtlas.render(render2d, maxText[j], x3, y2);
				}
			}
			if (graph.timer.unitsName) {
				x3 += wordAtlas.render(render2d, graph.timer.unitsName, x3, y2);
			}
		}
		render2d.render(this.app, this.drawLayer, this.texture, this.wordAtlas.texture, this.clr, height);
	}
	resize(width, height, showGraphs) {
		const graphs = this.graphs;
		for (let i2 = 0; i2 < graphs.length; ++i2) {
			graphs[i2].enabled = showGraphs;
		}
		this.width = width;
		this.height = height;
		this.updateDiv();
	}
	updateDiv() {
		const rect = this.device.canvas.getBoundingClientRect();
		this.div.style.left = `${rect.left}px`;
		this.div.style.bottom = `${window.innerHeight - rect.bottom}px`;
		this.div.style.width = `${this.width}px`;
		this.div.style.height = `${this.overallHeight}px`;
	}
	loseContext() {
		this.graphs.forEach((graph) => graph.loseContext());
	}
	updateSubStats(subGraphs, mainGraphName, stats, statPathPrefix, removeAfterFrames) {
		const passesToRemove = [];
		for (const [statName, statData] of subGraphs) {
			const timing = stats instanceof Map ? stats.get(statName) || 0 : stats[statName] || 0;
			if (timing > 0) {
				statData.lastNonZeroFrame = this.frameIndex;
			} else if (removeAfterFrames > 0) {
				const shouldAutoHide = statPathPrefix === "gpu";
				if (shouldAutoHide && this.frameIndex - statData.lastNonZeroFrame > removeAfterFrames) {
					passesToRemove.push(statName);
				}
			}
		}
		for (const statName of passesToRemove) {
			const statData = subGraphs.get(statName);
			if (statData) {
				const index = this.graphs.indexOf(statData.graph);
				if (index !== -1) {
					this.graphs.splice(index, 1);
				}
				this.freeRow(statData.graph);
				statData.graph.destroy();
				subGraphs.delete(statName);
			}
		}
		const statsEntries = stats instanceof Map ? stats : Object.entries(stats);
		const mainGraph = this.graphs.find((g) => g.name === mainGraphName);
		for (const [statName, timing] of statsEntries) {
			if (!subGraphs.has(statName)) {
				const isDelayedStart = statPathPrefix === "gpu" || delayedStartStats.has(statName);
				if (isDelayedStart && timing === 0) {
					continue;
				}
				let displayName = statName;
				if (statPathPrefix === "frame") {
					displayName = cpuStatDisplayNames[statName] || statName;
				}
				const graphName = `  ${displayName}`;
				const watermark = mainGraph?.watermark ?? 10;
				const decimalPlaces = 1;
				const unitsName = statPathPrefix === "vram" ? "MB" : "ms";
				const multiplier = statPathPrefix === "vram" ? 1 / (1024 * 1024) : 1;
				const statPath = `${statPathPrefix}.${statName}`;
				const timer = new StatsTimer(this.app, [statPath], decimalPlaces, unitsName, multiplier);
				const graph = new Graph(graphName, this.app, watermark, this.textRefreshRate, timer);
				if (statPathPrefix === "gpu") {
					graph.graphType = 0.33;
				} else if (statPathPrefix === "frame") {
					graph.graphType = 0.66;
				}
				graph.texture = this.texture;
				this.allocateRow(graph);
				const currentSize = this.sizes[this._activeSizeIndex];
				graph.enabled = currentSize.graphs;
				let mainGraphIndex = this.graphs.findIndex((g) => g.name === mainGraphName);
				if (mainGraphIndex === -1) {
					mainGraphIndex = 0;
				}
				let insertIndex = mainGraphIndex;
				for (let i2 = mainGraphIndex - 1; i2 >= 0; i2--) {
					if (this.graphs[i2].name.startsWith(" ")) {
						insertIndex = i2;
					} else {
						break;
					}
				}
				this.graphs.splice(insertIndex, 0, graph);
				subGraphs.set(statName, {
					graph,
					lastNonZeroFrame: timing > 0 ? this.frameIndex : this.frameIndex - removeAfterFrames - 1
				});
			}
		}
		if (mainGraph) {
			for (const statData of subGraphs.values()) {
				statData.graph.watermark = mainGraph.watermark;
			}
		}
	}
	allocateRow(graph) {
		let row;
		if (this.freeRows.length > 0) {
			row = this.freeRows.pop();
		} else {
			row = this.nextRowIndex++;
			this.ensureTextureHeight(this.nextRowIndex);
		}
		this.graphRows.set(graph, row);
		graph.yOffset = row;
		graph.needsClear = true;
		return row;
	}
	freeRow(graph) {
		const row = this.graphRows.get(graph);
		if (row !== void 0) {
			this.freeRows.push(row);
			this.graphRows.delete(graph);
		}
	}
	clearSubGraphs(subGraphs, mainGraphName, graphType) {
		for (const statData of subGraphs.values()) {
			const index = this.graphs.indexOf(statData.graph);
			if (index !== -1) {
				this.graphs.splice(index, 1);
			}
			this.freeRow(statData.graph);
			statData.graph.destroy();
		}
		subGraphs.clear();
		if (mainGraphName) {
			const mainGraph = this.graphs.find((g) => g.name === mainGraphName);
			if (mainGraph) mainGraph.graphType = graphType;
		}
	}
	ensureTextureHeight(requiredRows) {
		const maxWidth = this.sizes[this.sizes.length - 1].width;
		const requiredWidth = math.nextPowerOfTwo(maxWidth);
		const requiredHeight = math.nextPowerOfTwo(requiredRows);
		if (requiredHeight > this.texture.height) {
			this.texture.resize(requiredWidth, requiredHeight);
		}
	}
	postRender() {
		if (this._enabled) {
			this.render();
			if (this._activeSizeIndex >= this.gpuTimingMinSize) {
				const gpuStats = this.app.stats.gpu;
				if (gpuStats) {
					this.updateSubStats(this.gpuPassGraphs, "GPU", gpuStats, "gpu", 240);
				}
			}
			if (this._activeSizeIndex >= this.cpuTimingMinSize) {
				const cpuStats = {
					scriptUpdate: this.app.stats.frame.scriptUpdate,
					scriptPostUpdate: this.app.stats.frame.scriptPostUpdate,
					animUpdate: this.app.stats.frame.animUpdate,
					physicsTime: this.app.stats.frame.physicsTime,
					renderTime: this.app.stats.frame.renderTime,
					gsplatSort: this.app.stats.frame.gsplatSort
				};
				this.updateSubStats(this.cpuGraphs, "CPU", cpuStats, "frame", 240);
			}
			if (this._activeSizeIndex >= this.vramTimingMinSize) {
				const vram = this.app.stats.vram;
				const vramStats = {
					tex: vram.tex,
					geom: vram.geom
				};
				if (this.device.isWebGPU) {
					vramStats.buffers = vram.buffers;
				}
				this.updateSubStats(this.vramGraphs, "VRAM", vramStats, "vram", 0);
			}
		}
		this.frameIndex++;
	}
};

var shaderOutlineExtendPS = `
	varying vec2 vUv0;
	uniform vec2 uOffset;
	uniform float uSrcMultiplier;
	uniform sampler2D source;
	void main(void)
	{
		vec4 pixel;
		vec4 texel = texture2D(source, vUv0);
		vec4 firstTexel = texel;
		float diff = texel.a * uSrcMultiplier;
		pixel = texture2D(source, vUv0 + uOffset * -2.0);
		texel = max(texel, pixel);
		diff = max(diff, length(firstTexel.rgb - pixel.rgb));
		pixel = texture2D(source, vUv0 + uOffset * -1.0);
		texel = max(texel, pixel);
		diff = max(diff, length(firstTexel.rgb - pixel.rgb));
		pixel = texture2D(source, vUv0 + uOffset * 1.0);
		texel = max(texel, pixel);
		diff = max(diff, length(firstTexel.rgb - pixel.rgb));
		pixel = texture2D(source, vUv0 + uOffset * 2.0);
		texel = max(texel, pixel);
		diff = max(diff, length(firstTexel.rgb - pixel.rgb));
	   gl_FragColor = vec4(texel.rgb, min(diff, 1.0));
	}
`;
var shaderOutlineExtendWGSL = `
	varying vUv0: vec2f;
	uniform uOffset: vec2f;
	uniform uSrcMultiplier: f32;
	var source: texture_2d<f32>;
	var sourceSampler: sampler;
	@fragment
	fn fragmentMain(input: FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		
		var pixel: vec4f;
		var texel = textureSample(source, sourceSampler, input.vUv0);
		let firstTexel = texel;
		var diff = texel.a * uniform.uSrcMultiplier;
		pixel = textureSample(source, sourceSampler, input.vUv0 + uniform.uOffset * -2.0);
		texel = max(texel, pixel);
		diff = max(diff, length(firstTexel.rgb - pixel.rgb));
		pixel = textureSample(source, sourceSampler, input.vUv0 + uniform.uOffset * -1.0);
		texel = max(texel, pixel);
		diff = max(diff, length(firstTexel.rgb - pixel.rgb));
		pixel = textureSample(source, sourceSampler, input.vUv0 + uniform.uOffset * 1.0);
		texel = max(texel, pixel);
		diff = max(diff, length(firstTexel.rgb - pixel.rgb));
		pixel = textureSample(source, sourceSampler, input.vUv0 + uniform.uOffset * 2.0);
		texel = max(texel, pixel);
		diff = max(diff, length(firstTexel.rgb - pixel.rgb));
		output.color = vec4f(texel.rgb, min(diff, 1.0));
		return output;
	}
`;
var _tempFloatArray = new Float32Array(2);
var _tempColor4 = new Color();
var OutlineRenderer = class {
	constructor(app2, renderingLayer, priority = -1) {
		this.app = app2;
		this.renderingLayer = renderingLayer ?? app2.scene.layers.getLayerByName("Immediate");
		this.rt = this.createRenderTarget("OutlineTexture", 1, 1, true);
		this.outlineCameraEntity = new Entity("OutlineCamera");
		this.outlineCameraEntity.addComponent("camera", {
			layers: [this.renderingLayer.id],
			priority,
			clearColor: new Color(0, 0, 0, 0),
			renderTarget: this.rt
		});
		this.outlineShaderPass = this.outlineCameraEntity.camera.setShaderPass("pcOutline");
		this.postRender = (cameraComponent) => {
			if (this.outlineCameraEntity.camera === cameraComponent) {
				this.onPostRender();
			}
		};
		app2.scene.on("postrender", this.postRender);
		this.app.root.addChild(this.outlineCameraEntity);
		this.tempRt = this.createRenderTarget("OutlineTempTexture", 1, 1, false);
		this.blendState = new BlendState(true, BLENDEQUATION_ADD, BLENDMODE_SRC_ALPHA, BLENDMODE_ONE_MINUS_SRC_ALPHA);
		const device = this.app.graphicsDevice;
		this.shaderExtend = ShaderUtils.createShader(device, {
			uniqueName: "OutlineExtendShader",
			attributes: { vertex_position: SEMANTIC_POSITION },
			vertexChunk: "fullscreenQuadVS",
			fragmentGLSL: shaderOutlineExtendPS,
			fragmentWGSL: shaderOutlineExtendWGSL
		});
		this.shaderBlend = ShaderUtils.createShader(device, {
			uniqueName: "OutlineBlendShader",
			attributes: { vertex_position: SEMANTIC_POSITION },
			vertexChunk: "fullscreenQuadVS",
			fragmentChunk: "outputTex2DPS"
		});
		this.quadRenderer = new QuadRender(this.shaderBlend);
	}
	destroy() {
		this.outlineCameraEntity.destroy();
		this.outlineCameraEntity = null;
		this.rt.destroyTextureBuffers();
		this.rt.destroy();
		this.rt = null;
		this.tempRt.destroyTextureBuffers();
		this.tempRt.destroy();
		this.tempRt = null;
		this.app.scene.off("postrender", this.postRender);
		this.quadRenderer?.destroy();
		this.quadRenderer = null;
	}
	getMeshInstances(entity, recursive) {
		const meshInstances = [];
		if (entity) {
			const renders = recursive ? entity.findComponents("render") : entity.render ? [entity.render] : [];
			renders.forEach((render) => {
				if (render.meshInstances) {
					meshInstances.push(...render.meshInstances);
				}
			});
			const models = recursive ? entity.findComponents("model") : entity.model ? [entity.model] : [];
			models.forEach((model) => {
				if (model.meshInstances) {
					meshInstances.push(...model.meshInstances);
				}
			});
		}
		return meshInstances;
	}
	addEntity(entity, color3, recursive = true) {
		const meshInstances = this.getMeshInstances(entity, recursive);
		meshInstances.forEach((meshInstance) => {
			if (meshInstance.material instanceof StandardMaterial) {
				const outlineShaderPass = this.outlineShaderPass;
				meshInstance.material.onUpdateShader = (options2) => {
					if (options2.pass === outlineShaderPass) {
						const opts = new StandardMaterialOptions();
						opts.defines = options2.defines;
						opts.opacityMap = options2.opacityMap;
						opts.opacityMapUv = options2.opacityMapUv;
						opts.opacityMapChannel = options2.opacityMapChannel;
						opts.opacityMapTransform = options2.opacityMapTransform;
						opts.opacityVertexColor = options2.opacityVertexColor;
						opts.opacityVertexColorChannel = options2.opacityVertexColorChannel;
						opts.litOptions.vertexColors = options2.litOptions.vertexColors;
						opts.litOptions.alphaTest = options2.litOptions.alphaTest;
						opts.litOptions.skin = options2.litOptions.skin;
						opts.litOptions.batch = options2.litOptions.batch;
						opts.litOptions.useInstancing = options2.litOptions.useInstancing;
						opts.litOptions.useMorphPosition = options2.litOptions.useMorphPosition;
						opts.litOptions.useMorphNormal = options2.litOptions.useMorphNormal;
						opts.litOptions.useMorphTextureBasedInt = options2.litOptions.useMorphTextureBasedInt;
						opts.litOptions.opacityFadesSpecular = options2.litOptions.opacityFadesSpecular;
						return opts;
					}
					return options2;
				};
				_tempColor4.linear(color3);
				const colArray = new Float32Array([_tempColor4.r, _tempColor4.g, _tempColor4.b]);
				meshInstance.setParameter("pcOutlineColor", colArray);
			}
		});
		this.renderingLayer.addMeshInstances(meshInstances, true);
	}
	removeEntity(entity, recursive = true) {
		const meshInstances = this.getMeshInstances(entity, recursive);
		this.renderingLayer.removeMeshInstances(meshInstances);
		meshInstances.forEach((meshInstance) => {
			if (meshInstance.material instanceof StandardMaterial) {
				meshInstance.material.onUpdateShader = null;
				meshInstance.deleteParameter("pcOutlineColor");
			}
		});
	}
	removeAllEntities() {
		this.renderingLayer.clearMeshInstances();
	}
	blendOutlines() {
		const device = this.app.graphicsDevice;
		device.scope.resolve("source").setValue(this.rt.colorBuffer);
		device.setDrawStates(this.blendState);
		this.quadRenderer.render();
	}
	onPostRender() {
		const device = this.app.graphicsDevice;
		const uOffset = device.scope.resolve("uOffset");
		const uColorBuffer = device.scope.resolve("source");
		const uSrcMultiplier = device.scope.resolve("uSrcMultiplier");
		const { rt, tempRt, shaderExtend } = this;
		const { width, height } = rt;
		_tempFloatArray[0] = 1 / width / 2;
		_tempFloatArray[1] = 0;
		uOffset.setValue(_tempFloatArray);
		uColorBuffer.setValue(rt.colorBuffer);
		uSrcMultiplier.setValue(0);
		drawQuadWithShader(device, tempRt, shaderExtend);
		_tempFloatArray[0] = 0;
		_tempFloatArray[1] = 1 / height / 2;
		uOffset.setValue(_tempFloatArray);
		uColorBuffer.setValue(tempRt.colorBuffer);
		uSrcMultiplier.setValue(1);
		drawQuadWithShader(device, rt, shaderExtend);
	}
	createRenderTarget(name, width, height, depth) {
		const texture = new Texture(this.app.graphicsDevice, {
			name,
			width,
			height,
			format: PIXELFORMAT_SRGBA8,
			mipmaps: false,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE,
			minFilter: FILTER_LINEAR_MIPMAP_LINEAR,
			magFilter: FILTER_LINEAR
		});
		return new RenderTarget({
			colorBuffer: texture,
			depth,
			flipY: this.app.graphicsDevice.isWebGPU
		});
	}
	updateRenderTarget(sceneCamera) {
		const width = sceneCamera.renderTarget?.width ?? this.app.graphicsDevice.width;
		const height = sceneCamera.renderTarget?.height ?? this.app.graphicsDevice.height;
		const outlineCamera = this.outlineCameraEntity.camera;
		if (!outlineCamera.renderTarget || outlineCamera.renderTarget.width !== width || outlineCamera.renderTarget.height !== height) {
			this.rt.resize(width, height);
			this.tempRt.resize(width, height);
		}
	}
	frameUpdate(sceneCameraEntity, blendLayer, blendLayerTransparent) {
		const sceneCamera = sceneCameraEntity.camera;
		this.updateRenderTarget(sceneCamera);
		const evt = this.app.scene.on("prerender:layer", (cameraComponent, layer, transparent) => {
			if (sceneCamera === cameraComponent && transparent === blendLayerTransparent && layer === blendLayer) {
				this.blendOutlines();
				evt.off();
			}
		});
		this.outlineCameraEntity.setLocalPosition(sceneCameraEntity.getPosition());
		this.outlineCameraEntity.setLocalRotation(sceneCameraEntity.getRotation());
		const outlineCamera = this.outlineCameraEntity.camera;
		outlineCamera.projection = sceneCamera.projection;
		outlineCamera.horizontalFov = sceneCamera.horizontalFov;
		outlineCamera.fov = sceneCamera.fov;
		outlineCamera.orthoHeight = sceneCamera.orthoHeight;
		outlineCamera.nearClip = sceneCamera.nearClip;
		outlineCamera.farClip = sceneCamera.farClip;
	}
};

var LINECAP_BUTT = 0;
var LINECAP_SQUARE = 1;
var LINECAP_ROUND = 2;
var LINEJOIN_MITER = 0;
var LINEJOIN_BEVEL = 1;
var LINEJOIN_ROUND = 2;
var validateStyle = (value, min, max, name) => {
	if (!Number.isInteger(value) || value < min || value > max) {
		throw new RangeError(`${name} must be an integer between ${min} and ${max}.`);
	}
};
var validateNumber = (value, min, name) => {
	if (!Number.isFinite(value) || value < min) {
		throw new RangeError(`${name} must be a finite number greater than or equal to ${min}.`);
	}
};
var WideLine = class {
	_positions = new Float32Array(0);
	_colors = new Float32Array([1, 1, 1]);
	_widths = new Float32Array([1]);
	_renderer = null;
	_rendererIndex = -1;
	_join = LINEJOIN_MITER;
	_cap = LINECAP_BUTT;
	_closed = false;
	_dashLength = 0;
	_gapLength = 0;
	_dashOffset = 0;
	set(positions, colors = Color.WHITE, widths = 1) {
		const pointCount = this._validatePositions(positions, 0);
		this._validateColors(colors, pointCount);
		this._validateWidths(widths, pointCount);
		const packedPositions = this._copyPositions(positions, 0, this._positions);
		const packedColors = this._copyColors(colors, pointCount, this._colors);
		const packedWidths = this._copyWidths(widths, pointCount, this._widths);
		this._positions = packedPositions;
		this._colors = packedColors;
		this._widths = packedWidths;
		this._changed();
		return this;
	}
	setPositions(positions) {
		this._positions = this._copyPositions(positions, this.pointCount, this._positions);
		this._changed();
		return this;
	}
	setColors(colors) {
		this._colors = this._copyColors(colors, this.pointCount, this._colors);
		this._changed();
		return this;
	}
	setWidths(widths) {
		this._widths = this._copyWidths(widths, this.pointCount, this._widths);
		this._changed();
		return this;
	}
	get pointCount() {
		return this._positions.length / 3;
	}
	get renderer() {
		return this._renderer;
	}
	set join(value) {
		validateStyle(value, LINEJOIN_MITER, LINEJOIN_ROUND, "join");
		if (this._join !== value) {
			this._join = value;
			this._changed();
		}
	}
	get join() {
		return this._join;
	}
	set cap(value) {
		validateStyle(value, LINECAP_BUTT, LINECAP_ROUND, "cap");
		if (this._cap !== value) {
			this._cap = value;
			this._changed();
		}
	}
	get cap() {
		return this._cap;
	}
	set closed(value) {
		value = !!value;
		if (this._closed !== value) {
			this._closed = value;
			this._changed();
		}
	}
	get closed() {
		return this._closed;
	}
	set dashLength(value) {
		validateNumber(value, 0, "dashLength");
		if (this._dashLength !== value) {
			this._dashLength = value;
			this._changed();
		}
	}
	get dashLength() {
		return this._dashLength;
	}
	set gapLength(value) {
		validateNumber(value, 0, "gapLength");
		if (this._gapLength !== value) {
			this._gapLength = value;
			this._changed();
		}
	}
	get gapLength() {
		return this._gapLength;
	}
	set dashOffset(value) {
		if (!Number.isFinite(value)) {
			throw new RangeError("dashOffset must be a finite number.");
		}
		if (this._dashOffset !== value) {
			this._dashOffset = value;
			this._changed();
		}
	}
	get dashOffset() {
		return this._dashOffset;
	}
	_validatePositions(positions, expectedPointCount) {
		const length = positions?.length;
		if (!Number.isInteger(length) || length % 3 !== 0 || length < 6) {
			throw new RangeError("positions must contain packed xyz values for at least two points.");
		}
		const pointCount = length / 3;
		if (expectedPointCount && pointCount !== expectedPointCount) {
			throw new RangeError(`positions must contain exactly ${expectedPointCount * 3} values.`);
		}
		return pointCount;
	}
	_copyPositions(positions, expectedPointCount, target2) {
		this._validatePositions(positions, expectedPointCount);
		const result = target2.length === positions.length ? target2 : new Float32Array(positions.length);
		result.set(positions);
		return result;
	}
	_validateColors(colors, pointCount) {
		if (colors instanceof Color) {
			return;
		}
		if (colors?.length !== pointCount * 3) {
			throw new RangeError(`colors must contain exactly ${pointCount * 3} values.`);
		}
	}
	_copyColors(colors, pointCount, target2) {
		this._validateColors(colors, pointCount);
		if (colors instanceof Color) {
			const result2 = target2.length === 3 ? target2 : new Float32Array(3);
			result2[0] = colors.r;
			result2[1] = colors.g;
			result2[2] = colors.b;
			return result2;
		}
		const result = target2.length === colors.length ? target2 : new Float32Array(colors.length);
		result.set(colors);
		return result;
	}
	_validateWidths(widths, pointCount) {
		if (typeof widths === "number") {
			validateNumber(widths, 0, "width");
			return;
		}
		if (widths?.length !== pointCount) {
			throw new RangeError(`widths must contain exactly ${pointCount} values.`);
		}
		for (let i2 = 0; i2 < widths.length; i2++) {
			validateNumber(widths[i2], 0, `widths[${i2}]`);
		}
	}
	_copyWidths(widths, pointCount, target2) {
		this._validateWidths(widths, pointCount);
		if (typeof widths === "number") {
			const result2 = target2.length === 1 ? target2 : new Float32Array(1);
			result2[0] = widths;
			return result2;
		}
		const result = target2.length === widths.length ? target2 : new Float32Array(widths.length);
		result.set(widths);
		return result;
	}
	_changed() {
		this._renderer?._lineChanged(this);
	}
};

var LINEWIDTH_SCREEN = 0;
var LINEWIDTH_WORLD = 1;
var FLOATS_PER_INSTANCE = 30;
var ROUND_SEGMENTS = 16;
var vertexGLSL = `
	attribute vec3 vertex_position;
	attribute vec4 instance_prevWidth;
	attribute vec4 instance_startWidth;
	attribute vec4 instance_endDistance;
	attribute vec4 instance_nextDistance;
	attribute vec3 instance_startColor;
	attribute vec3 instance_endColor;
	attribute vec4 instance_style;
	attribute vec4 instance_dashFlags;
	uniform mat4 matrix_viewProjection;
	uniform vec4 uScreenSize;
	#ifdef WIDE_LINE_WORLD_SPACE_WIDTH
		uniform mat4 matrix_projection;
	#endif
	varying vec3 vColor;
	varying vec4 vDash;
	varying vec3 vLineData;
	varying float vDistance;
	vec2 safeNormalize(vec2 value, vec2 fallbackValue) {
		float lengthValue = length(value);
		return lengthValue > 0.00001 ? value / lengthValue : fallbackValue;
	}
	vec2 perpendicular(vec2 value) {
		return vec2(-value.y, value.x);
	}
	vec2 toScreen(vec4 clipPosition) {
		float w = abs(clipPosition.w) > 0.00001 ? clipPosition.w : 0.00001;
		return clipPosition.xy / w * uScreenSize.xy * 0.5;
	}
	vec4 offsetClip(vec4 clipPosition, vec2 pixelOffset) {
		clipPosition.xy += pixelOffset * (2.0 * uScreenSize.zw) * clipPosition.w;
		return clipPosition;
	}
	float resolveHalfWidth(float width, vec4 clipPosition) {
		#ifdef WIDE_LINE_WORLD_SPACE_WIDTH
			float pixelsPerWorldUnit = abs(matrix_projection[1][1]) * uScreenSize.y * 0.5 /
				max(abs(clipPosition.w), 0.00001);
			return width * 0.5 * pixelsPerWorldUnit;
		#else
			return width * 0.5;
		#endif
	}
	vec2 miterOffset(vec2 firstDirection, vec2 secondDirection, float side, float halfWidth) {
		vec2 secondNormal = perpendicular(secondDirection);
		vec2 miter = safeNormalize(perpendicular(firstDirection) + secondNormal, secondNormal);
		float scale = halfWidth / max(dot(miter, secondNormal), 0.25);
		return miter * side * min(scale, halfWidth * 4.0);
	}
	void main(void) {
		vec3 prev = instance_prevWidth.xyz;
		vec3 start = instance_startWidth.xyz;
		vec3 end = instance_endDistance.xyz;
		vec3 next = instance_nextDistance.xyz;
		float startDistance = instance_endDistance.w;
		float endDistance = instance_nextDistance.w;
		vec4 prevClip = matrix_viewProjection * vec4(prev, 1.0);
		vec4 startClip = matrix_viewProjection * vec4(start, 1.0);
		vec4 endClip = matrix_viewProjection * vec4(end, 1.0);
		vec4 nextClip = matrix_viewProjection * vec4(next, 1.0);
		float startHalfWidth = resolveHalfWidth(instance_prevWidth.w, startClip);
		float endHalfWidth = resolveHalfWidth(instance_startWidth.w, endClip);
		vec2 startScreen = toScreen(startClip);
		vec2 endScreen = toScreen(endClip);
		vec2 currentDirection = safeNormalize(endScreen - startScreen, vec2(1.0, 0.0));
		vec2 previousDirection = safeNormalize(startScreen - toScreen(prevClip), currentDirection);
		vec2 nextDirection = safeNormalize(toScreen(nextClip) - endScreen, currentDirection);
		vec2 currentNormal = perpendicular(currentDirection);
		vec2 previousNormal = perpendicular(previousDirection);
		float joinStyle = instance_style.x;
		float capStyle = instance_style.y;
		uint flags = uint(instance_dashFlags.y + 0.5);
		bool startConnected = (flags & 1u) != 0u;
		bool endConnected = (flags & 2u) != 0u;
		float kind = vertex_position.z;
		vec4 clipPosition;
		vLineData = vec3(0.0, startHalfWidth, 0.0);
		if (kind < 0.5) {
			float along = vertex_position.x;
			float side = vertex_position.y;
			bool atStart = along < 0.5;
			float halfWidth = atStart ? startHalfWidth : endHalfWidth;
			vec2 offset;
			if (atStart) {
				if (startConnected && joinStyle < 0.5) {
					offset = miterOffset(previousDirection, currentDirection, side, halfWidth);
				} else {
					offset = currentNormal * side * halfWidth;
					if (!startConnected && capStyle > 0.5 && capStyle < 1.5) {
						offset -= currentDirection * halfWidth;
					}
				}
				clipPosition = offsetClip(startClip, offset);
			} else {
				if (endConnected && joinStyle < 0.5) {
					offset = miterOffset(currentDirection, nextDirection, side, halfWidth);
				} else {
					offset = currentNormal * side * halfWidth;
					if (!endConnected && capStyle > 0.5 && capStyle < 1.5) {
						offset += currentDirection * halfWidth;
					}
				}
				clipPosition = offsetClip(endClip, offset);
			}
			vColor = mix(instance_startColor, instance_endColor, along);
			vDistance = mix(startDistance, endDistance, along);
			vLineData = vec3(side, mix(startHalfWidth, endHalfWidth, along), 1.0);
		} else if (kind < 1.5) {
			bool visible = (startConnected && joinStyle > 1.5) || (!startConnected && capStyle > 1.5);
			float scale = visible ? startHalfWidth : 0.0;
			vec2 offset = (currentDirection * vertex_position.x + currentNormal * vertex_position.y) * scale;
			clipPosition = offsetClip(startClip, offset);
			vColor = instance_startColor;
			vDistance = startDistance;
		} else if (kind < 2.5) {
			bool visible = !endConnected && capStyle > 1.5;
			float scale = visible ? endHalfWidth : 0.0;
			vec2 offset = (currentDirection * vertex_position.x + currentNormal * vertex_position.y) * scale;
			clipPosition = offsetClip(endClip, offset);
			vColor = instance_endColor;
			vDistance = endDistance;
		} else {
			bool visible = startConnected && joinStyle > 0.5 && joinStyle < 1.5;
			float scale = visible ? startHalfWidth : 0.0;
			vec2 offset = vec2(0.0);
			if (kind > 3.5 && kind < 4.5) {
				offset = previousNormal * vertex_position.y * scale;
			} else if (kind > 4.5) {
				offset = currentNormal * vertex_position.y * scale;
			}
			clipPosition = offsetClip(startClip, offset);
			vColor = instance_startColor;
			vDistance = startDistance;
		}
		vDash = vec4(instance_style.z, instance_style.w, instance_dashFlags.x, capStyle);
		gl_Position = clipPosition;
	}
`;
var fragmentGLSL = `
	varying vec3 vColor;
	varying vec4 vDash;
	varying vec3 vLineData;
	varying float vDistance;
	void main(void) {
		float worldPerPixel = length(vec2(dFdx(vDistance), dFdy(vDistance)));
		if (vDash.x > 0.0 && vDash.y > 0.0) {
			float period = vDash.x + vDash.y;
			float phase = mod(vDistance + vDash.z, period);
			if (phase < 0.0) {
				phase += period;
			}
			if (phase > vDash.x) {
				if (vDash.w > 1.5 && vLineData.z > 0.5) {
					float along = min(phase - vDash.x, period - phase) / max(worldPerPixel, 0.00001);
					float across = abs(vLineData.x) * vLineData.y;
					if (length(vec2(along, across)) > vLineData.y) {
						discard;
					}
				} else {
					discard;
				}
			}
		}
		gl_FragColor = vec4(vColor, 1.0);
	}
`;
var vertexWGSL = `
	attribute vertex_position: vec3f;
	attribute instance_prevWidth: vec4f;
	attribute instance_startWidth: vec4f;
	attribute instance_endDistance: vec4f;
	attribute instance_nextDistance: vec4f;
	attribute instance_startColor: vec3f;
	attribute instance_endColor: vec3f;
	attribute instance_style: vec4f;
	attribute instance_dashFlags: vec4f;
	uniform matrix_viewProjection: mat4x4f;
	uniform uScreenSize: vec4f;
	#ifdef WIDE_LINE_WORLD_SPACE_WIDTH
		uniform matrix_projection: mat4x4f;
	#endif
	varying vColor: vec3f;
	varying vDash: vec4f;
	varying vLineData: vec3f;
	varying vDistance: f32;
	fn safeNormalize(value: vec2f, fallbackValue: vec2f) -> vec2f {
		let lengthValue = length(value);
		return select(fallbackValue, value / lengthValue, lengthValue > 0.00001);
	}
	fn perpendicular(value: vec2f) -> vec2f {
		return vec2f(-value.y, value.x);
	}
	fn toScreen(clipPosition: vec4f) -> vec2f {
		let w = select(0.00001, clipPosition.w, abs(clipPosition.w) > 0.00001);
		return clipPosition.xy / w * uniform.uScreenSize.xy * 0.5;
	}
	fn offsetClip(position: vec4f, pixelOffset: vec2f) -> vec4f {
		var clipPosition = position;
		clipPosition.x += pixelOffset.x * (2.0 * uniform.uScreenSize.z) * clipPosition.w;
		clipPosition.y += pixelOffset.y * (2.0 * uniform.uScreenSize.w) * clipPosition.w;
		return clipPosition;
	}
	fn resolveHalfWidth(width: f32, clipPosition: vec4f) -> f32 {
		#ifdef WIDE_LINE_WORLD_SPACE_WIDTH
			let pixelsPerWorldUnit = abs(uniform.matrix_projection[1][1]) * uniform.uScreenSize.y * 0.5 /
				max(abs(clipPosition.w), 0.00001);
			return width * 0.5 * pixelsPerWorldUnit;
		#else
			return width * 0.5;
		#endif
	}
	fn miterOffset(firstDirection: vec2f, secondDirection: vec2f, side: f32, halfWidth: f32) -> vec2f {
		let secondNormal = perpendicular(secondDirection);
		let miter = safeNormalize(perpendicular(firstDirection) + secondNormal, secondNormal);
		let scale = halfWidth / max(dot(miter, secondNormal), 0.25);
		return miter * side * min(scale, halfWidth * 4.0);
	}
	@vertex
	fn vertexMain(input: VertexInput) -> VertexOutput {
		var output: VertexOutput;
		let prev = input.instance_prevWidth.xyz;
		let start = input.instance_startWidth.xyz;
		let end = input.instance_endDistance.xyz;
		let next = input.instance_nextDistance.xyz;
		let startDistance = input.instance_endDistance.w;
		let endDistance = input.instance_nextDistance.w;
		let prevClip = uniform.matrix_viewProjection * vec4f(prev, 1.0);
		let startClip = uniform.matrix_viewProjection * vec4f(start, 1.0);
		let endClip = uniform.matrix_viewProjection * vec4f(end, 1.0);
		let nextClip = uniform.matrix_viewProjection * vec4f(next, 1.0);
		let startHalfWidth = resolveHalfWidth(input.instance_prevWidth.w, startClip);
		let endHalfWidth = resolveHalfWidth(input.instance_startWidth.w, endClip);
		let startScreen = toScreen(startClip);
		let endScreen = toScreen(endClip);
		let currentDirection = safeNormalize(endScreen - startScreen, vec2f(1.0, 0.0));
		let previousDirection = safeNormalize(startScreen - toScreen(prevClip), currentDirection);
		let nextDirection = safeNormalize(toScreen(nextClip) - endScreen, currentDirection);
		let currentNormal = perpendicular(currentDirection);
		let previousNormal = perpendicular(previousDirection);
		let joinStyle = input.instance_style.x;
		let capStyle = input.instance_style.y;
		let flags = u32(input.instance_dashFlags.y + 0.5);
		let startConnected = (flags & 1u) != 0u;
		let endConnected = (flags & 2u) != 0u;
		let kind = input.vertex_position.z;
		var clipPosition: vec4f;
		output.vLineData = vec3f(0.0, startHalfWidth, 0.0);
		if (kind < 0.5) {
			let along = input.vertex_position.x;
			let side = input.vertex_position.y;
			let atStart = along < 0.5;
			let halfWidth = select(endHalfWidth, startHalfWidth, atStart);
			var offset: vec2f;
			if (atStart) {
				if (startConnected && joinStyle < 0.5) {
					offset = miterOffset(previousDirection, currentDirection, side, halfWidth);
				} else {
					offset = currentNormal * side * halfWidth;
					if (!startConnected && capStyle > 0.5 && capStyle < 1.5) {
						offset -= currentDirection * halfWidth;
					}
				}
				clipPosition = offsetClip(startClip, offset);
			} else {
				if (endConnected && joinStyle < 0.5) {
					offset = miterOffset(currentDirection, nextDirection, side, halfWidth);
				} else {
					offset = currentNormal * side * halfWidth;
					if (!endConnected && capStyle > 0.5 && capStyle < 1.5) {
						offset += currentDirection * halfWidth;
					}
				}
				clipPosition = offsetClip(endClip, offset);
			}
			output.vColor = mix(input.instance_startColor, input.instance_endColor, along);
			output.vDistance = mix(startDistance, endDistance, along);
			output.vLineData = vec3f(side, mix(startHalfWidth, endHalfWidth, along), 1.0);
		} else if (kind < 1.5) {
			let visible = (startConnected && joinStyle > 1.5) || (!startConnected && capStyle > 1.5);
			let scale = select(0.0, startHalfWidth, visible);
			let offset = (currentDirection * input.vertex_position.x + currentNormal * input.vertex_position.y) * scale;
			clipPosition = offsetClip(startClip, offset);
			output.vColor = input.instance_startColor;
			output.vDistance = startDistance;
		} else if (kind < 2.5) {
			let visible = !endConnected && capStyle > 1.5;
			let scale = select(0.0, endHalfWidth, visible);
			let offset = (currentDirection * input.vertex_position.x + currentNormal * input.vertex_position.y) * scale;
			clipPosition = offsetClip(endClip, offset);
			output.vColor = input.instance_endColor;
			output.vDistance = endDistance;
		} else {
			let visible = startConnected && joinStyle > 0.5 && joinStyle < 1.5;
			let scale = select(0.0, startHalfWidth, visible);
			var offset = vec2f(0.0);
			if (kind > 3.5 && kind < 4.5) {
				offset = previousNormal * input.vertex_position.y * scale;
			} else if (kind > 4.5) {
				offset = currentNormal * input.vertex_position.y * scale;
			}
			clipPosition = offsetClip(startClip, offset);
			output.vColor = input.instance_startColor;
			output.vDistance = startDistance;
		}
		output.vDash = vec4f(input.instance_style.z, input.instance_style.w, input.instance_dashFlags.x, capStyle);
		output.position = clipPosition;
		return output;
	}
`;
var fragmentWGSL = `
	varying vColor: vec3f;
	varying vDash: vec4f;
	varying vLineData: vec3f;
	varying vDistance: f32;
	@fragment
	fn fragmentMain(input: FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		let worldPerPixel = length(vec2f(dpdx(input.vDistance), dpdy(input.vDistance)));
		if (input.vDash.x > 0.0 && input.vDash.y > 0.0) {
			let period = input.vDash.x + input.vDash.y;
			var phase = input.vDistance + input.vDash.z;
			phase = phase - floor(phase / period) * period;
			if (phase > input.vDash.x) {
				if (input.vDash.w > 1.5 && input.vLineData.z > 0.5) {
					let along = min(phase - input.vDash.x, period - phase) / max(worldPerPixel, 0.00001);
					let across = abs(input.vLineData.x) * input.vLineData.y;
					if (length(vec2f(along, across)) > input.vLineData.y) {
						discard;
						return output;
					}
				} else {
					discard;
					return output;
				}
			}
		}
		output.color = vec4f(input.vColor, 1.0);
		return output;
	}
`;
var createTemplateMesh = (device) => {
	const positions = [
		0,
		-1,
		0,
		0,
		1,
		0,
		1,
		-1,
		0,
		1,
		1,
		0
	];
	const indices = [0, 2, 1, 1, 2, 3];
	const addDisk = (kind) => {
		const center2 = positions.length / 3;
		positions.push(0, 0, kind);
		for (let i2 = 0; i2 <= ROUND_SEGMENTS; i2++) {
			const angle = i2 / ROUND_SEGMENTS * Math.PI * 2;
			positions.push(Math.cos(angle), Math.sin(angle), kind);
		}
		for (let i2 = 0; i2 < ROUND_SEGMENTS; i2++) {
			indices.push(center2, center2 + i2 + 1, center2 + i2 + 2);
		}
	};
	addDisk(1);
	addDisk(2);
	for (let side = -1; side <= 1; side += 2) {
		const base = positions.length / 3;
		positions.push(
			0,
			0,
			3,
			0,
			side,
			4,
			0,
			side,
			5
		);
		indices.push(base, base + 1, base + 2);
	}
	const mesh = new Mesh(device);
	mesh.setPositions(positions);
	mesh.setIndices(indices);
	mesh.update(PRIMITIVE_TRIANGLES, false);
	return mesh;
};
var WideLineRenderer = class {
	_lines = [];
	_layer;
	_depthTest = true;
	_depthWrite = true;
	_enabled = true;
	_widthUnits = LINEWIDTH_SCREEN;
	_capacity = 0;
	_segmentCount = 0;
	_dirty = true;
	_destroyed = false;
	_vertexBuffer = null;
	_instanceData = null;
	constructor(app2) {
		this.app = app2;
		this.device = app2.graphicsDevice;
		this._vertexFormat = new VertexFormat(this.device, [
			{ semantic: SEMANTIC_ATTR8, components: 4, type: TYPE_FLOAT32 },
			{ semantic: SEMANTIC_ATTR9, components: 4, type: TYPE_FLOAT32 },
			{ semantic: SEMANTIC_ATTR10, components: 4, type: TYPE_FLOAT32 },
			{ semantic: SEMANTIC_ATTR11, components: 4, type: TYPE_FLOAT32 },
			{ semantic: SEMANTIC_ATTR12, components: 3, type: TYPE_FLOAT32 },
			{ semantic: SEMANTIC_ATTR13, components: 3, type: TYPE_FLOAT32 },
			{ semantic: SEMANTIC_ATTR14, components: 4, type: TYPE_FLOAT32 },
			{ semantic: SEMANTIC_ATTR15, components: 4, type: TYPE_FLOAT32 }
		]);
		this.material = new ShaderMaterial({
			uniqueName: "WideLineRenderer",
			vertexGLSL,
			fragmentGLSL,
			vertexWGSL,
			fragmentWGSL,
			attributes: {
				vertex_position: SEMANTIC_POSITION,
				instance_prevWidth: SEMANTIC_ATTR8,
				instance_startWidth: SEMANTIC_ATTR9,
				instance_endDistance: SEMANTIC_ATTR10,
				instance_nextDistance: SEMANTIC_ATTR11,
				instance_startColor: SEMANTIC_ATTR12,
				instance_endColor: SEMANTIC_ATTR13,
				instance_style: SEMANTIC_ATTR14,
				instance_dashFlags: SEMANTIC_ATTR15
			}
		});
		this.material.cull = CULLFACE_NONE;
		this.material.alphaToCoverage = true;
		this.material.depthTest = this._depthTest;
		this.material.depthWrite = this._depthWrite;
		this.material.update();
		this.meshInstance = new MeshInstance(
			createTemplateMesh(this.device),
			this.material,
			new GraphNode("WideLineRenderer")
		);
		this.meshInstance.cull = false;
		this.meshInstance.pick = false;
		this.meshInstance.visible = false;
		const layer = app2.scene.layers.getLayerByName("Immediate");
		if (!layer) {
			throw new Error("WideLineRenderer requires an Immediate layer.");
		}
		this._layer = layer;
		this._layer.addMeshInstances([this.meshInstance]);
		app2.on("prerender", this._onPrerender, this);
	}
	add(line) {
		if (!(line instanceof WideLine)) {
			throw new TypeError("line must be a WideLine.");
		}
		if (line._renderer) {
			throw new Error("WideLine is already owned by a WideLineRenderer.");
		}
		line._renderer = this;
		line._rendererIndex = this._lines.length;
		this._lines.push(line);
		this._dirty = true;
	}
	remove(line) {
		if (line?._renderer !== this) {
			return false;
		}
		const index = line._rendererIndex;
		const last = this._lines.pop();
		if (last !== line) {
			this._lines[index] = last;
			last._rendererIndex = index;
		}
		line._renderer = null;
		line._rendererIndex = -1;
		this._dirty = true;
		return true;
	}
	clear() {
		for (let i2 = 0; i2 < this._lines.length; i2++) {
			const line = this._lines[i2];
			line._renderer = null;
			line._rendererIndex = -1;
		}
		this._lines.length = 0;
		this._dirty = true;
	}
	destroy() {
		if (this._destroyed) {
			return;
		}
		this._destroyed = true;
		this.app.off("prerender", this._onPrerender, this);
		this.clear();
		this._layer.removeMeshInstances([this.meshInstance]);
		if (this._vertexBuffer) {
			this.meshInstance.setInstancing(null);
			this._vertexBuffer.destroy();
			this._vertexBuffer = null;
			this._instanceData = null;
		}
		this.meshInstance.destroy();
		this.material.destroy();
	}
	set layer(value) {
		if (!value) {
			throw new TypeError("layer must be a Layer.");
		}
		if (this._layer !== value) {
			this._layer?.removeMeshInstances([this.meshInstance]);
			this._layer = value;
			this._layer.addMeshInstances([this.meshInstance]);
		}
	}
	get layer() {
		return this._layer;
	}
	set depthTest(value) {
		value = !!value;
		if (this._depthTest !== value) {
			this._depthTest = value;
			this.material.depthTest = value;
		}
	}
	get depthTest() {
		return this._depthTest;
	}
	set depthWrite(value) {
		value = !!value;
		if (this._depthWrite !== value) {
			this._depthWrite = value;
			this.material.depthWrite = value;
		}
	}
	get depthWrite() {
		return this._depthWrite;
	}
	set enabled(value) {
		value = !!value;
		if (this._enabled !== value) {
			this._enabled = value;
			this._updateVisibility();
		}
	}
	get enabled() {
		return this._enabled;
	}
	set widthUnits(value) {
		if (value !== LINEWIDTH_SCREEN && value !== LINEWIDTH_WORLD) {
			throw new RangeError("widthUnits must be LINEWIDTH_SCREEN or LINEWIDTH_WORLD.");
		}
		if (this._widthUnits !== value) {
			this._widthUnits = value;
			this.material.setDefine("WIDE_LINE_WORLD_SPACE_WIDTH", value === LINEWIDTH_WORLD);
			this.material.update();
		}
	}
	get widthUnits() {
		return this._widthUnits;
	}
	set capacity(value) {
		if (!Number.isInteger(value) || value < 0) {
			throw new RangeError("capacity must be a non-negative integer.");
		}
		const capacity = Math.max(value, this._requiredSegmentCount());
		if (this._capacity !== capacity) {
			this._resize(capacity);
			this._dirty = true;
		}
	}
	get capacity() {
		return this._capacity;
	}
	_lineChanged(line) {
		if (line._renderer === this) {
			this._dirty = true;
		}
	}
	_onPrerender() {
		if (this._dirty) {
			this._rebuild();
		}
	}
	_requiredSegmentCount() {
		let count = 0;
		for (let i2 = 0; i2 < this._lines.length; i2++) {
			const line = this._lines[i2];
			const pointCount = line.pointCount;
			if (pointCount >= 2) {
				count += line._closed ? pointCount : pointCount - 1;
			}
		}
		return count;
	}
	_resize(capacity) {
		if (this._vertexBuffer) {
			this.meshInstance.setInstancing(null);
			this._vertexBuffer.destroy();
			this._vertexBuffer = null;
			this._instanceData = null;
		}
		this._capacity = capacity;
		if (capacity > 0) {
			this._vertexBuffer = new VertexBuffer(this.device, this._vertexFormat, capacity, {
				usage: BUFFER_DYNAMIC
			});
			this._instanceData = new Float32Array(this._vertexBuffer.lock());
			this.meshInstance.setInstancing(this._vertexBuffer);
			this.meshInstance.instancingCount = 0;
		}
		this._updateVisibility();
	}
	_rebuild() {
		const required = this._requiredSegmentCount();
		if (required > this._capacity) {
			const grownCapacity = Math.max(required, this._capacity > 0 ? this._capacity * 2 : required);
			this._resize(grownCapacity);
		}
		this._segmentCount = required;
		if (required === 0) {
			if (this.meshInstance.instancingData) {
				this.meshInstance.instancingCount = 0;
			}
			this._dirty = false;
			this._updateVisibility();
			return;
		}
		const data2 = this._instanceData;
		let instance = 0;
		for (let i2 = 0; i2 < this._lines.length; i2++) {
			instance = this._writeLine(data2, instance, this._lines[i2]);
		}
		this._vertexBuffer.unlock();
		this.meshInstance.instancingCount = required;
		this._dirty = false;
		this._updateVisibility();
	}
	_writeLine(data2, instance, line) {
		const positions = line._positions;
		const colors = line._colors;
		const widths = line._widths;
		const pointCount = line.pointCount;
		if (pointCount < 2) {
			return instance;
		}
		const segmentCount = line._closed ? pointCount : pointCount - 1;
		let distance = 0;
		for (let segment = 0; segment < segmentCount; segment++) {
			const startIndex = segment;
			const endIndex = (segment + 1) % pointCount;
			const startConnected = line._closed || segment > 0;
			const endConnected = line._closed || segment < segmentCount - 1;
			const prevIndex = startConnected ? (startIndex + pointCount - 1) % pointCount : startIndex;
			const nextIndex = endConnected ? (endIndex + 1) % pointCount : endIndex;
			const startPosition = startIndex * 3;
			const endPosition = endIndex * 3;
			const dx = positions[endPosition] - positions[startPosition];
			const dy = positions[endPosition + 1] - positions[startPosition + 1];
			const dz = positions[endPosition + 2] - positions[startPosition + 2];
			const endDistance = distance + Math.sqrt(dx * dx + dy * dy + dz * dz);
			let offset3 = instance * FLOATS_PER_INSTANCE;
			offset3 = this._writePosition(data2, offset3, positions, prevIndex);
			data2[offset3++] = widths.length === 1 ? widths[0] : widths[startIndex];
			offset3 = this._writePosition(data2, offset3, positions, startIndex);
			data2[offset3++] = widths.length === 1 ? widths[0] : widths[endIndex];
			offset3 = this._writePosition(data2, offset3, positions, endIndex);
			data2[offset3++] = distance;
			offset3 = this._writePosition(data2, offset3, positions, nextIndex);
			data2[offset3++] = endDistance;
			offset3 = this._writeColor(data2, offset3, colors, startIndex);
			offset3 = this._writeColor(data2, offset3, colors, endIndex);
			data2[offset3++] = line._join;
			data2[offset3++] = line._cap;
			data2[offset3++] = line._dashLength;
			data2[offset3++] = line._gapLength;
			data2[offset3++] = line._dashOffset;
			data2[offset3++] = (startConnected ? 1 : 0) | (endConnected ? 2 : 0);
			data2[offset3++] = 0;
			data2[offset3] = 0;
			distance = endDistance;
			instance++;
		}
		return instance;
	}
	_writePosition(data2, offset3, positions, point5) {
		const source = point5 * 3;
		data2[offset3++] = positions[source];
		data2[offset3++] = positions[source + 1];
		data2[offset3++] = positions[source + 2];
		return offset3;
	}
	_writeColor(data2, offset3, colors, point5) {
		const source = colors.length === 3 ? 0 : point5 * 3;
		data2[offset3++] = colors[source];
		data2[offset3++] = colors[source + 1];
		data2[offset3++] = colors[source + 2];
		return offset3;
	}
	_updateVisibility() {
		this.meshInstance.visible = this._enabled && this._segmentCount > 0;
	}
};

var CoreExporter = class {
	// eslint-disable-next-line no-useless-constructor
	constructor() {
	}
	textureToCanvas(texture, options2 = {}) {
		const image = texture.getSource();
		if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof OffscreenCanvas !== "undefined" && image instanceof OffscreenCanvas || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
			const { width: width2, height: height2 } = this.calcTextureSize(image.width, image.height, options2.maxTextureSize);
			const canvas = document.createElement("canvas");
			canvas.width = width2;
			canvas.height = height2;
			const context = canvas.getContext("2d");
			if (context === null) {
				return Promise.resolve(void 0);
			}
			context.drawImage(image, 0, 0, canvas.width, canvas.height);
			if (options2.color) {
				const { r, g, b } = options2.color;
				const imagedata = context.getImageData(0, 0, width2, height2);
				const data2 = imagedata.data;
				for (let i2 = 0; i2 < data2.length; i2 += 4) {
					data2[i2 + 0] = data2[i2 + 0] * r;
					data2[i2 + 1] = data2[i2 + 1] * g;
					data2[i2 + 2] = data2[i2 + 2] * b;
				}
				context.putImageData(imagedata, 0, 0);
			}
			return Promise.resolve(canvas);
		}
		const device = texture.device;
		const { width, height } = this.calcTextureSize(texture.width, texture.height, options2.maxTextureSize);
		const format = isCompressedPixelFormat(texture.format) ? PIXELFORMAT_RGBA8 : texture.format;
		const dstTexture = new Texture(device, {
			name: "ExtractedTexture",
			width,
			height,
			format,
			cubemap: false,
			mipmaps: false,
			minFilter: FILTER_LINEAR,
			magFilter: FILTER_LINEAR,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE
		});
		const renderTarget = new RenderTarget({
			colorBuffer: dstTexture,
			depth: false
		});
		const shader = ShaderUtils.createShader(device, {
			uniqueName: "ShaderCoreExporterBlit",
			attributes: { vertex_position: SEMANTIC_POSITION },
			vertexChunk: "fullscreenQuadVS",
			fragmentChunk: "outputTex2DPS"
		});
		device.scope.resolve("source").setValue(texture);
		device.setBlendState(BlendState.NOBLEND);
		drawQuadWithShader(device, renderTarget, shader);
		return dstTexture.read(0, 0, width, height, {
			renderTarget,
			immediate: true
		}).then((textureData2) => {
			dstTexture.destroy();
			renderTarget.destroy();
			const pixels = new Uint8ClampedArray(width * height * 4);
			pixels.set(textureData2);
			const newImage = new ImageData(pixels, width, height);
			const canvas = document.createElement("canvas");
			canvas.width = width;
			canvas.height = height;
			const newContext = canvas.getContext("2d");
			if (!newContext) {
				return Promise.resolve(void 0);
			}
			newContext.putImageData(newImage, 0, 0);
			return Promise.resolve(canvas);
		});
	}
	calcTextureSize(width, height, maxTextureSize) {
		if (maxTextureSize) {
			const scale2 = Math.min(maxTextureSize / Math.max(width, height), 1);
			width = Math.round(width * scale2);
			height = Math.round(height * scale2);
		}
		return { width, height };
	}
};

var u8 = Uint8Array;
var u16 = Uint16Array;
var i32 = Int32Array;
var fleb = new u8([
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	1,
	1,
	1,
	1,
	2,
	2,
	2,
	2,
	3,
	3,
	3,
	3,
	4,
	4,
	4,
	4,
	5,
	5,
	5,
	5,
	0,
	/* unused */
	0,
	0,
	/* impossible */
	0
]);
var fdeb = new u8([
	0,
	0,
	0,
	0,
	1,
	1,
	2,
	2,
	3,
	3,
	4,
	4,
	5,
	5,
	6,
	6,
	7,
	7,
	8,
	8,
	9,
	9,
	10,
	10,
	11,
	11,
	12,
	12,
	13,
	13,
	/* unused */
	0,
	0
]);
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var freb = function(eb, start) {
	var b = new u16(31);
	for (var i2 = 0; i2 < 31; ++i2) {
		b[i2] = start += 1 << eb[i2 - 1];
	}
	var r = new i32(b[30]);
	for (var i2 = 1; i2 < 30; ++i2) {
		for (var j = b[i2]; j < b[i2 + 1]; ++j) {
			r[j] = j - b[i2] << 5 | i2;
		}
	}
	return { b, r };
};
var _a = freb(fleb, 2);
var fl = _a.b;
var revfl = _a.r;
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0);
var fd = _b.b;
var revfd = _b.r;
var rev = new u16(32768);
for (i = 0; i < 32768; ++i) {
	x2 = (i & 43690) >> 1 | (i & 21845) << 1;
	x2 = (x2 & 52428) >> 2 | (x2 & 13107) << 2;
	x2 = (x2 & 61680) >> 4 | (x2 & 3855) << 4;
	rev[i] = ((x2 & 65280) >> 8 | (x2 & 255) << 8) >> 1;
}
var x2;
var i;
var hMap = (function(cd, mb, r) {
	var s2 = cd.length;
	var i2 = 0;
	var l = new u16(mb);
	for (; i2 < s2; ++i2) {
		if (cd[i2])
			++l[cd[i2] - 1];
	}
	var le = new u16(mb);
	for (i2 = 1; i2 < mb; ++i2) {
		le[i2] = le[i2 - 1] + l[i2 - 1] << 1;
	}
	var co;
	if (r) {
		co = new u16(1 << mb);
		var rvb = 15 - mb;
		for (i2 = 0; i2 < s2; ++i2) {
			if (cd[i2]) {
				var sv = i2 << 4 | cd[i2];
				var r_1 = mb - cd[i2];
				var v6 = le[cd[i2] - 1]++ << r_1;
				for (var m = v6 | (1 << r_1) - 1; v6 <= m; ++v6) {
					co[rev[v6] >> rvb] = sv;
				}
			}
		}
	} else {
		co = new u16(s2);
		for (i2 = 0; i2 < s2; ++i2) {
			if (cd[i2]) {
				co[i2] = rev[le[cd[i2] - 1]++] >> 15 - cd[i2];
			}
		}
	}
	return co;
});
var flt = new u8(288);
for (i = 0; i < 144; ++i)
	flt[i] = 8;
var i;
for (i = 144; i < 256; ++i)
	flt[i] = 9;
var i;
for (i = 256; i < 280; ++i)
	flt[i] = 7;
var i;
for (i = 280; i < 288; ++i)
	flt[i] = 8;
var i;
var fdt = new u8(32);
for (i = 0; i < 32; ++i)
	fdt[i] = 5;
var i;
var flm = /* @__PURE__ */ hMap(flt, 9, 0);
var fdm = /* @__PURE__ */ hMap(fdt, 5, 0);
var shft = function(p) {
	return (p + 7) / 8 | 0;
};
var slc = function(v6, s2, e) {
	if (s2 == null || s2 < 0)
		s2 = 0;
	if (e == null || e > v6.length)
		e = v6.length;
	return new u8(v6.subarray(s2, e));
};
var ec = [
	"unexpected EOF",
	"invalid block type",
	"invalid length/literal",
	"invalid distance",
	"stream finished",
	"no stream handler",
	,
	// determined by compression function
	"no callback",
	"invalid UTF-8 data",
	"extra field too long",
	"date not in range 1980-2099",
	"filename too long",
	"stream finishing",
	"invalid zip data"
	// determined by unknown compression method
];
var err = function(ind, msg, nt) {
	var e = new Error(msg || ec[ind]);
	e.code = ind;
	if (Error.captureStackTrace)
		Error.captureStackTrace(e, err);
	if (!nt)
		throw e;
	return e;
};
var wbits = function(d, p, v6) {
	v6 <<= p & 7;
	var o = p / 8 | 0;
	d[o] |= v6;
	d[o + 1] |= v6 >> 8;
};
var wbits16 = function(d, p, v6) {
	v6 <<= p & 7;
	var o = p / 8 | 0;
	d[o] |= v6;
	d[o + 1] |= v6 >> 8;
	d[o + 2] |= v6 >> 16;
};
var hTree = function(d, mb) {
	var t = [];
	for (var i2 = 0; i2 < d.length; ++i2) {
		if (d[i2])
			t.push({ s: i2, f: d[i2] });
	}
	var s2 = t.length;
	var t2 = t.slice();
	if (!s2)
		return { t: et, l: 0 };
	if (s2 == 1) {
		var v6 = new u8(t[0].s + 1);
		v6[t[0].s] = 1;
		return { t: v6, l: 1 };
	}
	t.sort(function(a, b) {
		return a.f - b.f;
	});
	t.push({ s: -1, f: 25001 });
	var l = t[0], r = t[1], i0 = 0, i1 = 1, i22 = 2;
	t[0] = { s: -1, f: l.f + r.f, l, r };
	while (i1 != s2 - 1) {
		l = t[t[i0].f < t[i22].f ? i0++ : i22++];
		r = t[i0 != i1 && t[i0].f < t[i22].f ? i0++ : i22++];
		t[i1++] = { s: -1, f: l.f + r.f, l, r };
	}
	var maxSym = t2[0].s;
	for (var i2 = 1; i2 < s2; ++i2) {
		if (t2[i2].s > maxSym)
			maxSym = t2[i2].s;
	}
	var tr = new u16(maxSym + 1);
	var mbt = ln(t[i1 - 1], tr, 0);
	if (mbt > mb) {
		var i2 = 0, dt = 0;
		var lft = mbt - mb, cst = 1 << lft;
		t2.sort(function(a, b) {
			return tr[b.s] - tr[a.s] || a.f - b.f;
		});
		for (; i2 < s2; ++i2) {
			var i2_1 = t2[i2].s;
			if (tr[i2_1] > mb) {
				dt += cst - (1 << mbt - tr[i2_1]);
				tr[i2_1] = mb;
			} else
				break;
		}
		dt >>= lft;
		while (dt > 0) {
			var i2_2 = t2[i2].s;
			if (tr[i2_2] < mb)
				dt -= 1 << mb - tr[i2_2]++ - 1;
			else
				++i2;
		}
		for (; i2 >= 0 && dt; --i2) {
			var i2_3 = t2[i2].s;
			if (tr[i2_3] == mb) {
				--tr[i2_3];
				++dt;
			}
		}
		mbt = mb;
	}
	return { t: new u8(tr), l: mbt };
};
var ln = function(n, l, d) {
	return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
var lc = function(c2) {
	var s2 = c2.length;
	while (s2 && !c2[--s2])
		;
	var cl = new u16(++s2);
	var cli = 0, cln = c2[0], cls = 1;
	var w = function(v6) {
		cl[cli++] = v6;
	};
	for (var i2 = 1; i2 <= s2; ++i2) {
		if (c2[i2] == cln && i2 != s2)
			++cls;
		else {
			if (!cln && cls > 2) {
				for (; cls > 138; cls -= 138)
					w(32754);
				if (cls > 2) {
					w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
					cls = 0;
				}
			} else if (cls > 3) {
				w(cln), --cls;
				for (; cls > 6; cls -= 6)
					w(8304);
				if (cls > 2)
					w(cls - 3 << 5 | 8208), cls = 0;
			}
			while (cls--)
				w(cln);
			cls = 1;
			cln = c2[i2];
		}
	}
	return { c: cl.subarray(0, cli), n: s2 };
};
var clen = function(cf, cl) {
	var l = 0;
	for (var i2 = 0; i2 < cl.length; ++i2)
		l += cf[i2] * cl[i2];
	return l;
};
var wfblk = function(out, pos, dat) {
	var s2 = dat.length;
	var o = shft(pos + 2);
	out[o] = s2 & 255;
	out[o + 1] = s2 >> 8;
	out[o + 2] = out[o] ^ 255;
	out[o + 3] = out[o + 1] ^ 255;
	for (var i2 = 0; i2 < s2; ++i2)
		out[o + i2 + 4] = dat[i2];
	return (o + 4 + s2) * 8;
};
var wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
	wbits(out, p++, final);
	++lf[256];
	var _a2 = hTree(lf, 15), dlt = _a2.t, mlb = _a2.l;
	var _b2 = hTree(df, 15), ddt = _b2.t, mdb = _b2.l;
	var _c = lc(dlt), lclt = _c.c, nlc = _c.n;
	var _d = lc(ddt), lcdt = _d.c, ndc = _d.n;
	var lcfreq = new u16(19);
	for (var i2 = 0; i2 < lclt.length; ++i2)
		++lcfreq[lclt[i2] & 31];
	for (var i2 = 0; i2 < lcdt.length; ++i2)
		++lcfreq[lcdt[i2] & 31];
	var _e = hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
	var nlcc = 19;
	for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
		;
	var flen = bl + 5 << 3;
	var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
	var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
	if (bs >= 0 && flen <= ftlen && flen <= dtlen)
		return wfblk(out, p, dat.subarray(bs, bs + bl));
	var lm, ll, dm, dl;
	wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
	if (dtlen < ftlen) {
		lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
		var llm = hMap(lct, mlcb, 0);
		wbits(out, p, nlc - 257);
		wbits(out, p + 5, ndc - 1);
		wbits(out, p + 10, nlcc - 4);
		p += 14;
		for (var i2 = 0; i2 < nlcc; ++i2)
			wbits(out, p + 3 * i2, lct[clim[i2]]);
		p += 3 * nlcc;
		var lcts = [lclt, lcdt];
		for (var it = 0; it < 2; ++it) {
			var clct = lcts[it];
			for (var i2 = 0; i2 < clct.length; ++i2) {
				var len = clct[i2] & 31;
				wbits(out, p, llm[len]), p += lct[len];
				if (len > 15)
					wbits(out, p, clct[i2] >> 5 & 127), p += clct[i2] >> 12;
			}
		}
	} else {
		lm = flm, ll = flt, dm = fdm, dl = fdt;
	}
	for (var i2 = 0; i2 < li; ++i2) {
		var sym = syms[i2];
		if (sym > 255) {
			var len = sym >> 18 & 31;
			wbits16(out, p, lm[len + 257]), p += ll[len + 257];
			if (len > 7)
				wbits(out, p, sym >> 23 & 31), p += fleb[len];
			var dst = sym & 31;
			wbits16(out, p, dm[dst]), p += dl[dst];
			if (dst > 3)
				wbits16(out, p, sym >> 5 & 8191), p += fdeb[dst];
		} else {
			wbits16(out, p, lm[sym]), p += ll[sym];
		}
	}
	wbits16(out, p, lm[256]);
	return p + ll[256];
};
var deo = /* @__PURE__ */ new i32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
var et = /* @__PURE__ */ new u8(0);
var dflt = function(dat, lvl, plvl, pre, post, st) {
	var s2 = st.z || dat.length;
	var o = new u8(pre + s2 + 5 * (1 + Math.ceil(s2 / 7e3)) + post);
	var w = o.subarray(pre, o.length - post);
	var lst = st.l;
	var pos = (st.r || 0) & 7;
	if (lvl) {
		if (pos)
			w[0] = st.r >> 3;
		var opt = deo[lvl - 1];
		var n = opt >> 13, c2 = opt & 8191;
		var msk_1 = (1 << plvl) - 1;
		var prev = st.p || new u16(32768), head = st.h || new u16(msk_1 + 1);
		var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
		var hsh = function(i3) {
			return (dat[i3] ^ dat[i3 + 1] << bs1_1 ^ dat[i3 + 2] << bs2_1) & msk_1;
		};
		var syms = new i32(25e3);
		var lf = new u16(288), df = new u16(32);
		var lc_1 = 0, eb = 0, i2 = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
		for (; i2 + 2 < s2; ++i2) {
			var hv = hsh(i2);
			var imod = i2 & 32767, pimod = head[hv];
			prev[imod] = pimod;
			head[hv] = imod;
			if (wi <= i2) {
				var rem = s2 - i2;
				if ((lc_1 > 7e3 || li > 24576) && (rem > 423 || !lst)) {
					pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i2 - bs, pos);
					li = lc_1 = eb = 0, bs = i2;
					for (var j = 0; j < 286; ++j)
						lf[j] = 0;
					for (var j = 0; j < 30; ++j)
						df[j] = 0;
				}
				var l = 2, d = 0, ch_1 = c2, dif = imod - pimod & 32767;
				if (rem > 2 && hv == hsh(i2 - dif)) {
					var maxn = Math.min(n, rem) - 1;
					var maxd = Math.min(32767, i2);
					var ml = Math.min(258, rem);
					while (dif <= maxd && --ch_1 && imod != pimod) {
						if (dat[i2 + l] == dat[i2 + l - dif]) {
							var nl = 0;
							for (; nl < ml && dat[i2 + nl] == dat[i2 + nl - dif]; ++nl)
								;
							if (nl > l) {
								l = nl, d = dif;
								if (nl > maxn)
									break;
								var mmd = Math.min(dif, nl - 2);
								var md = 0;
								for (var j = 0; j < mmd; ++j) {
									var ti = i2 - dif + j & 32767;
									var pti = prev[ti];
									var cd = ti - pti & 32767;
									if (cd > md)
										md = cd, pimod = ti;
								}
							}
						}
						imod = pimod, pimod = prev[imod];
						dif += imod - pimod & 32767;
					}
				}
				if (d) {
					syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
					var lin = revfl[l] & 31, din = revfd[d] & 31;
					eb += fleb[lin] + fdeb[din];
					++lf[257 + lin];
					++df[din];
					wi = i2 + l;
					++lc_1;
				} else {
					syms[li++] = dat[i2];
					++lf[dat[i2]];
				}
			}
		}
		for (i2 = Math.max(i2, wi); i2 < s2; ++i2) {
			syms[li++] = dat[i2];
			++lf[dat[i2]];
		}
		pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i2 - bs, pos);
		if (!lst) {
			st.r = pos & 7 | w[pos / 8 | 0] << 3;
			pos -= 7;
			st.h = head, st.p = prev, st.i = i2, st.w = wi;
		}
	} else {
		for (var i2 = st.w || 0; i2 < s2 + lst; i2 += 65535) {
			var e = i2 + 65535;
			if (e >= s2) {
				w[pos / 8 | 0] = lst;
				e = s2;
			}
			pos = wfblk(w, pos + 1, dat.subarray(i2, e));
		}
		st.i = s2;
	}
	return slc(o, 0, pre + shft(pos) + post);
};
var crct = /* @__PURE__ */ (function() {
	var t = new Int32Array(256);
	for (var i2 = 0; i2 < 256; ++i2) {
		var c2 = i2, k = 9;
		while (--k)
			c2 = (c2 & 1 && -306674912) ^ c2 >>> 1;
		t[i2] = c2;
	}
	return t;
})();
var crc = function() {
	var c2 = -1;
	return {
		p: function(d) {
			var cr = c2;
			for (var i2 = 0; i2 < d.length; ++i2)
				cr = crct[cr & 255 ^ d[i2]] ^ cr >>> 8;
			c2 = cr;
		},
		d: function() {
			return ~c2;
		}
	};
};
var dopt = function(dat, opt, pre, post, st) {
	if (!st) {
		st = { l: 1 };
		if (opt.dictionary) {
			var dict = opt.dictionary.subarray(-32768);
			var newDat = new u8(dict.length + dat.length);
			newDat.set(dict);
			newDat.set(dat, dict.length);
			dat = newDat;
			st.w = dict.length;
		}
	}
	return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
var mrg = function(a, b) {
	var o = {};
	for (var k in a)
		o[k] = a[k];
	for (var k in b)
		o[k] = b[k];
	return o;
};
var wbytes = function(d, b, v6) {
	for (; v6; ++b)
		d[b] = v6, v6 >>>= 8;
};
function deflateSync(data2, opts) {
	return dopt(data2, opts || {}, 0, 0);
}
var fltn = function(d, p, t, o) {
	for (var k in d) {
		var val = d[k], n = p + k, op = o;
		if (Array.isArray(val))
			op = mrg(o, val[1]), val = val[0];
		if (ArrayBuffer.isView(val))
			t[n] = [val, op];
		else {
			t[n += "/"] = [new u8(0), op];
			fltn(val, n, t, o);
		}
	}
};
var te = typeof TextEncoder != "undefined" && /* @__PURE__ */ new TextEncoder();
var td = typeof TextDecoder != "undefined" && /* @__PURE__ */ new TextDecoder();
var tds = 0;
try {
	td.decode(et, { stream: true });
	tds = 1;
} catch (e) {
}
function strToU8(str, latin1) {
	if (latin1) {
		var ar_1 = new u8(str.length);
		for (var i2 = 0; i2 < str.length; ++i2)
			ar_1[i2] = str.charCodeAt(i2);
		return ar_1;
	}
	if (te)
		return te.encode(str);
	var l = str.length;
	var ar = new u8(str.length + (str.length >> 1));
	var ai = 0;
	var w = function(v6) {
		ar[ai++] = v6;
	};
	for (var i2 = 0; i2 < l; ++i2) {
		if (ai + 5 > ar.length) {
			var n = new u8(ai + 8 + (l - i2 << 1));
			n.set(ar);
			ar = n;
		}
		var c2 = str.charCodeAt(i2);
		if (c2 < 128 || latin1)
			w(c2);
		else if (c2 < 2048)
			w(192 | c2 >> 6), w(128 | c2 & 63);
		else if (c2 > 55295 && c2 < 57344)
			c2 = 65536 + (c2 & 1023 << 10) | str.charCodeAt(++i2) & 1023, w(240 | c2 >> 18), w(128 | c2 >> 12 & 63), w(128 | c2 >> 6 & 63), w(128 | c2 & 63);
		else
			w(224 | c2 >> 12), w(128 | c2 >> 6 & 63), w(128 | c2 & 63);
	}
	return slc(ar, 0, ai);
}
var exfl = function(ex) {
	var le = 0;
	if (ex) {
		for (var k in ex) {
			var l = ex[k].length;
			if (l > 65535)
				err(9);
			le += l + 4;
		}
	}
	return le;
};
var wzh = function(d, b, f, fn, u, c2, ce, co) {
	var fl2 = fn.length, ex = f.extra, col = co && co.length;
	var exl = exfl(ex);
	wbytes(d, b, ce != null ? 33639248 : 67324752), b += 4;
	if (ce != null)
		d[b++] = 20, d[b++] = f.os;
	d[b] = 20, b += 2;
	d[b++] = f.flag << 1 | (c2 < 0 && 8), d[b++] = u && 8;
	d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
	var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y2 = dt.getFullYear() - 1980;
	if (y2 < 0 || y2 > 119)
		err(10);
	wbytes(d, b, y2 << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
	if (c2 != -1) {
		wbytes(d, b, f.crc);
		wbytes(d, b + 4, c2 < 0 ? -c2 - 2 : c2);
		wbytes(d, b + 8, f.size);
	}
	wbytes(d, b + 12, fl2);
	wbytes(d, b + 14, exl), b += 16;
	if (ce != null) {
		wbytes(d, b, col);
		wbytes(d, b + 6, f.attrs);
		wbytes(d, b + 10, ce), b += 14;
	}
	d.set(fn, b);
	b += fl2;
	if (exl) {
		for (var k in ex) {
			var exf = ex[k], l = exf.length;
			wbytes(d, b, +k);
			wbytes(d, b + 2, l);
			d.set(exf, b + 4), b += 4 + l;
		}
	}
	if (col)
		d.set(co, b), b += col;
	return b;
};
var wzf = function(o, b, c2, d, e) {
	wbytes(o, b, 101010256);
	wbytes(o, b + 8, c2);
	wbytes(o, b + 10, c2);
	wbytes(o, b + 12, d);
	wbytes(o, b + 16, e);
};
function zipSync(data2, opts) {
	if (!opts)
		opts = {};
	var r = {};
	var files = [];
	fltn(data2, "", r, opts);
	var o = 0;
	var tot = 0;
	for (var fn in r) {
		var _a2 = r[fn], file = _a2[0], p = _a2[1];
		var compression = p.level == 0 ? 0 : 8;
		var f = strToU8(fn), s2 = f.length;
		var com = p.comment, m = com && strToU8(com), ms = m && m.length;
		var exl = exfl(p.extra);
		if (s2 > 65535)
			err(11);
		var d = compression ? deflateSync(file, p) : file, l = d.length;
		var c2 = crc();
		c2.p(file);
		files.push(mrg(p, {
			size: file.length,
			crc: c2.d(),
			c: d,
			f,
			m,
			u: s2 != fn.length || m && com.length != ms,
			o,
			compression
		}));
		o += 30 + s2 + exl + l;
		tot += 76 + 2 * (s2 + exl) + (ms || 0) + l;
	}
	var out = new u8(tot + 22), oe = o, cdl = tot - o;
	for (var i2 = 0; i2 < files.length; ++i2) {
		var f = files[i2];
		wzh(out, f.o, f, f.f, f.u, f.c.length);
		var badd = 30 + f.f.length + exfl(f.extra);
		out.set(f.c, f.o + badd);
		wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
	}
	wzf(out, o, files.length, cdl, oe);
	return out;
}

var ROOT_FILE_NAME = "root";
var header = `#usda 1.0
(
		customLayerData = {
				string creator = "PlayCanvas UsdzExporter"
		}
		metersPerUnit = 1
		upAxis = "Y"
)
`;
var materialListTemplate = (materials) => `
def "Materials"
{
		${materials.join("\n")}
}
`;
var meshTemplate = (faceVertexCounts, indices, normals, positions, uv0, uv1) => `
def "Mesh"
{
		def Mesh "Mesh"
		{
				int[] faceVertexCounts = [${faceVertexCounts}]
				int[] faceVertexIndices = [${indices}]
				normal3f[] normals = [${normals}] (
						interpolation = "vertex"
				)
				point3f[] points = [${positions}]
				texCoord2f[] primvars:st = [${uv0}] (
						interpolation = "vertex"
				)
				texCoord2f[] primvars:st1 = [${uv1}] (
						interpolation = "vertex"
				)
				uniform token subdivisionScheme = "none"
		}
}
`;
var meshInstanceTemplate = (nodeName, meshRefPath, worldMatrix, materialRefPath) => (
	/* usd */
	`
def Xform "${nodeName}" (
		prepend references = ${meshRefPath}
)
{
		matrix4d xformOp:transform = ${worldMatrix}
		uniform token[] xformOpOrder = ["xformOp:transform"]

		rel material:binding = ${materialRefPath}
}
`
);
var materialValueTemplate = (type, name, value) => `                    ${type} inputs:${name} = ${value}`;
var UsdzExporter = class extends CoreExporter {
	meshMap;
	materialMap;
	materials;
	textureMap;
	nodeNames;
	files;
	init() {
		this.meshMap = /* @__PURE__ */ new Map();
		this.textureMap = /* @__PURE__ */ new Map();
		this.materialMap = /* @__PURE__ */ new Map();
		this.materials = [];
		this.files = {};
		this.nodeNames = /* @__PURE__ */ new Set();
	}
	done() {
		this.meshMap = null;
		this.textureMap = null;
		this.materialMap = null;
		this.materials = null;
		this.files = null;
		this.nodeNames = null;
	}
	build(entity, options2 = {}) {
		this.init();
		this.addFile(null, ROOT_FILE_NAME);
		const allMeshInstances = [];
		if (entity) {
			const renders = entity.findComponents("render");
			renders.forEach((render) => {
				allMeshInstances.push(...render.meshInstances);
			});
		}
		let rootContent = "";
		allMeshInstances.forEach((meshInstance) => {
			rootContent += this.buildMeshInstance(meshInstance);
		});
		rootContent += materialListTemplate(this.materials);
		this.addFile(null, ROOT_FILE_NAME, "", rootContent);
		const textureOptions = {
			maxTextureSize: options2.maxTextureSize
		};
		const textureArray = Array.from(this.textureMap.keys());
		const promises = [];
		for (let i2 = 0; i2 < textureArray.length; i2++) {
			const isRGBA = true;
			const mimeType = isRGBA ? "image/png" : "image/jpeg";
			const texture = textureArray[i2];
			const texturePromise = this.textureToCanvas(texture, textureOptions).then((canvas) => {
				if (canvas) {
					return new Promise((resolve2) => canvas.toBlob(resolve2, mimeType, 1)).then(
						(blob) => blob.arrayBuffer()
					);
				}
				console.warn(`Export of texture ${texture.name} is not currently supported.`);
				return new Promise((resolve2) => resolve2(null));
			});
			promises.push(texturePromise);
		}
		const finalData = Promise.all(promises).then((values) => {
			values.forEach((textureArrayBuffer, index) => {
				const texture = textureArray[index];
				const ids3 = this.getTextureFileIds(texture);
				this.files[ids3.fileName] = new Uint8Array(textureArrayBuffer);
			});
			this.alignFiles();
			const arraybuffer = zipSync(this.files, { level: 0 });
			this.done();
			return arraybuffer;
		});
		return finalData;
	}
	alignFiles() {
		let offset3 = 0;
		for (const filename in this.files) {
			const file = this.files[filename];
			const headerSize = 34 + filename.length;
			offset3 += headerSize;
			const offsetMod64 = offset3 & 63;
			if (offsetMod64 !== 4) {
				const padLength = 64 - offsetMod64;
				const padding = new Uint8Array(padLength);
				this.files[filename] = [file, { extra: { 12345: padding } }];
			}
			offset3 = file.length;
		}
	}
	getFileIds(category, name, ref, extension = "usda") {
		const fileName = `${category ? `${category}/` : ""}${name}.${extension}`;
		const refName = `@./${fileName}@</${ref}>`;
		return { name, fileName, refName };
	}
	getTextureFileIds(texture) {
		return this.getFileIds("texture", `Texture_${texture.id}`, "Texture", "png");
	}
	addFile(category, uniqueId, refName = "", content = "") {
		let contentU8 = null;
		if (content) {
			content = `${header}
${content}`;
			contentU8 = strToU8(content);
		}
		const ids3 = this.getFileIds(category, uniqueId, refName);
		this.files[ids3.fileName] = contentU8;
		return ids3.refName;
	}
	getMaterialRef(material) {
		let materialRef = this.materialMap.get(material);
		if (!materialRef) {
			materialRef = this.buildMaterial(material);
			this.materialMap.set(material, materialRef);
		}
		return materialRef;
	}
	getMeshRef(mesh) {
		let meshRef = this.meshMap.get(mesh);
		if (!meshRef) {
			meshRef = this.buildMesh(mesh);
			this.meshMap.set(mesh, meshRef);
		}
		return meshRef;
	}
	buildArray2(array3) {
		const components2 = [];
		const count = array3.length;
		for (let i2 = 0; i2 < count; i2 += 2) {
			components2.push(`(${array3[i2]}, ${1 - array3[i2 + 1]})`);
		}
		return components2.join(", ");
	}
	buildArray3(array3) {
		const components2 = [];
		const count = array3.length;
		for (let i2 = 0; i2 < count; i2 += 3) {
			components2.push(`(${array3[i2]}, ${array3[i2 + 1]}, ${array3[i2 + 2]})`);
		}
		return components2.join(", ");
	}
	buildMat4(mat2) {
		const data2 = mat2.data;
		const vectors = [];
		for (let i2 = 0; i2 < 16; i2 += 4) {
			vectors.push(`(${data2[i2]}, ${data2[i2 + 1]}, ${data2[i2 + 2]}, ${data2[i2 + 3]})`);
		}
		return `( ${vectors.join(", ")} )`;
	}
	// format: https://graphics.pixar.com/usd/release/spec_usdpreviewsurface.html
	buildMaterial(material) {
		const materialName = `Material_${material.id}`;
		const materialPath = `/Materials/${materialName}`;
		const materialPropertyPath = (property) => `<${materialPath}${property}>`;
		const buildTexture = (texture, textureIds, mapType, uvChannel, tiling, offset3, rotation7, tintColor) => {
			return `
								def Shader "Transform2d_${mapType}" (
										sdrMetadata = {
												string role = "math"
										}
								)
								{
										uniform token info:id = "UsdTransform2d"
										float2 inputs:in.connect = ${materialPropertyPath(`/uvReader_${uvChannel}.outputs:result`)}
										float inputs:rotation = ${rotation7}
										float2 inputs:scale = (${tiling.x}, ${tiling.y})
										float2 inputs:translation = (${offset3.x}, ${offset3.y})
										float2 outputs:result
								}

								def Shader "Texture_${texture.id}_${mapType}"
								{
										uniform token info:id = "UsdUVTexture"
										asset inputs:file = @${textureIds.fileName}@
										float2 inputs:st.connect = ${materialPropertyPath(`/Transform2d_${mapType}.outputs:result`)}
										token inputs:wrapS = "repeat"
										token inputs:wrapT = "repeat"
										float4 inputs:scale = (${tintColor.r}, ${tintColor.g}, ${tintColor.b}, ${tintColor.a})
										float outputs:r
										float outputs:g
										float outputs:b
										float3 outputs:rgb
										float outputs:a
								}
						`;
		};
		const inputs = [];
		const samplers = [];
		const addTexture = (textureSlot, uniform, propType, propName, valueName, handleOpacity = false, tintTexture = false) => {
			const texture = material[textureSlot];
			if (texture) {
				const textureIds = this.getTextureFileIds(texture);
				this.textureMap.set(texture, textureIds.refName);
				const channel = material[`${textureSlot}Channel`] || "rgb";
				const textureValue = materialPropertyPath(`/${textureIds.name}_${valueName}.outputs:${channel}`);
				inputs.push(materialValueTemplate(propType, `${propName}.connect`, textureValue));
				if (handleOpacity) {
					if (material.alphaTest > 0) {
					}
				}
				const tiling = material[`${textureSlot}Tiling`];
				const offset3 = material[`${textureSlot}Offset`];
				const rotation7 = material[`${textureSlot}Rotation`];
				const uvChannel = material[`${textureSlot}Uv`] === 1 ? "st1" : "st";
				const tintColor = tintTexture && uniform ? uniform : Color.WHITE;
				samplers.push(buildTexture(texture, textureIds, valueName, uvChannel, tiling, offset3, rotation7, tintColor));
			} else if (uniform) {
				const value = propType === "float" ? `${uniform}` : `(${uniform.r}, ${uniform.g}, ${uniform.b})`;
				inputs.push(materialValueTemplate(propType, propName, value));
			}
		};
		addTexture("diffuseMap", material.diffuse, "color3f", "diffuseColor", "diffuse", false, true);
		if (material.transparent || material.alphaTest > 0) {
			addTexture("opacityMap", material.opacity, "float", "opacity", "opacity", true);
		}
		addTexture("normalMap", null, "normal3f", "normal", "normal");
		addTexture("emissiveMap", material.emissive, "color3f", "emissiveColor", "emissive", false, true);
		addTexture("aoMap", null, "float", "occlusion", "occlusion");
		const metalness = material.useMetalness ? material.metalness : 0;
		addTexture("metalnessMap", metalness, "float", "metallic", "metallic");
		const roughness = material.glossInvert ? material.gloss : 1 - material.gloss;
		addTexture("glossMap", roughness, "float", "roughness", "roughness");
		const materialObject = `
						def Material "${materialName}"
						{
								def Shader "PreviewSurface"
								{
										uniform token info:id = "UsdPreviewSurface"
${inputs.join("\n")}
										int inputs:useSpecularWorkflow = 0
										token outputs:surface
								}

								token outputs:surface.connect = ${materialPropertyPath("/PreviewSurface.outputs:surface")}

								def Shader "uvReader_st"
								{
										uniform token info:id = "UsdPrimvarReader_float2"
										token inputs:varname = "st"
										float2 inputs:fallback = (0.0, 0.0)
										float2 outputs:result
								}

								def Shader "uvReader_st1"
								{
										uniform token info:id = "UsdPrimvarReader_float2"
										token inputs:varname = "st1"
										float2 inputs:fallback = (0.0, 0.0)
										float2 outputs:result
								}

								${samplers.join("\n")}
						}
				`;
		this.materials.push(materialObject);
		return materialPropertyPath("");
	}
	buildMesh(mesh) {
		let positions = [];
		const indices = [];
		let normals = [];
		let uv0 = [];
		let uv1 = [];
		mesh.getVertexStream(SEMANTIC_POSITION, positions);
		mesh.getVertexStream(SEMANTIC_NORMAL, normals);
		mesh.getVertexStream(SEMANTIC_TEXCOORD0, uv0);
		mesh.getVertexStream(SEMANTIC_TEXCOORD1, uv1);
		mesh.getIndices(indices);
		const indicesCount = indices.length || positions.length;
		const faceVertexCounts = Array(indicesCount / 3).fill(3).join(", ");
		if (!indices.length) {
			for (let i2 = 0; i2 < indicesCount; i2++) {
				indices[i2] = i2;
			}
		}
		const numVerts = positions.length / 3;
		normals = normals.length ? normals : Array(numVerts * 3).fill(0);
		uv0 = uv0.length ? uv0 : Array(numVerts * 2).fill(0);
		uv1 = uv1.length ? uv1 : Array(numVerts * 2).fill(0);
		positions = this.buildArray3(positions);
		normals = this.buildArray3(normals);
		uv0 = this.buildArray2(uv0);
		uv1 = this.buildArray2(uv1);
		const meshObject = meshTemplate(faceVertexCounts, indices, normals, positions, uv0, uv1);
		const refPath = this.addFile("mesh", `Mesh_${mesh.id}`, "Mesh", meshObject);
		return refPath;
	}
	buildMeshInstance(meshInstance) {
		const meshRefPath = this.getMeshRef(meshInstance.mesh);
		const materialRefPath = this.getMaterialRef(meshInstance.material);
		const worldMatrix = this.buildMat4(meshInstance.node.getWorldTransform());
		const name = meshInstance.node.name.replace(/[^a-z0-9]/gi, "_");
		let nodeName = name;
		while (this.nodeNames.has(nodeName)) {
			nodeName = `${name}_${Math.random().toString(36).slice(2, 7)}`;
		}
		this.nodeNames.add(nodeName);
		return meshInstanceTemplate(nodeName, meshRefPath, worldMatrix, materialRefPath);
	}
};

var ARRAY_BUFFER = 34962;
var ELEMENT_ARRAY_BUFFER = 34963;
var getIndexComponentType = (indexFormat) => {
	switch (indexFormat) {
		case INDEXFORMAT_UINT8:
			return 5121;
		case INDEXFORMAT_UINT16:
			return 5123;
		case INDEXFORMAT_UINT32:
			return 5125;
	}
	return 0;
};
var getComponentType = (dataType) => {
	switch (dataType) {
		case TYPE_INT8:
			return 5120;
		case TYPE_UINT8:
			return 5121;
		case TYPE_INT16:
			return 5122;
		case TYPE_UINT16:
			return 5123;
		case TYPE_INT32:
			return 5124;
		case TYPE_UINT32:
			return 5125;
		case TYPE_FLOAT32:
			return 5126;
	}
	return 0;
};
var getAccessorType = (componentCount) => {
	switch (componentCount) {
		case 1:
			return "SCALAR";
		case 2:
			return "VEC2";
		case 3:
			return "VEC3";
		case 4:
			return "VEC4";
	}
	return 0;
};
var getSemantic = (engineSemantic) => {
	switch (engineSemantic) {
		case SEMANTIC_POSITION:
			return "POSITION";
		case SEMANTIC_NORMAL:
			return "NORMAL";
		case SEMANTIC_TANGENT:
			return "TANGENT";
		case SEMANTIC_COLOR:
			return "COLOR_0";
		case SEMANTIC_BLENDINDICES:
			return "JOINTS_0";
		case SEMANTIC_BLENDWEIGHT:
			return "WEIGHTS_0";
		case SEMANTIC_TEXCOORD0:
			return "TEXCOORD_0";
		case SEMANTIC_TEXCOORD1:
			return "TEXCOORD_1";
		case SEMANTIC_TEXCOORD2:
			return "TEXCOORD_2";
		case SEMANTIC_TEXCOORD3:
			return "TEXCOORD_3";
		case SEMANTIC_TEXCOORD4:
			return "TEXCOORD_4";
		case SEMANTIC_TEXCOORD5:
			return "TEXCOORD_5";
		case SEMANTIC_TEXCOORD6:
			return "TEXCOORD_6";
		case SEMANTIC_TEXCOORD7:
			return "TEXCOORD_7";
	}
	return "";
};
var getFilter = function(filter) {
	switch (filter) {
		case FILTER_NEAREST:
			return 9728;
		case FILTER_LINEAR:
			return 9729;
		case FILTER_NEAREST_MIPMAP_NEAREST:
			return 9984;
		case FILTER_LINEAR_MIPMAP_NEAREST:
			return 9985;
		case FILTER_NEAREST_MIPMAP_LINEAR:
			return 9986;
		case FILTER_LINEAR_MIPMAP_LINEAR:
			return 9987;
	}
	return 0;
};
var getWrap = function(wrap) {
	switch (wrap) {
		case ADDRESS_CLAMP_TO_EDGE:
			return 33071;
		case ADDRESS_MIRRORED_REPEAT:
			return 33648;
		case ADDRESS_REPEAT:
			return 10497;
	}
	return 0;
};
function isCanvasTransparent(canvas) {
	const context = canvas.getContext("2d");
	const pixelData = context.getImageData(0, 0, canvas.width, canvas.height).data;
	for (let i2 = 3; i2 < pixelData.length; i2 += 4) {
		if (pixelData[i2] < 255) {
			return true;
		}
	}
	return false;
}
var textureSemantics = [
	"anisotropyMap",
	"aoMap",
	"clearCoatGlossMap",
	"clearCoatMap",
	"clearCoatNormalMap",
	"colorMap",
	"diffuseMap",
	"emissiveMap",
	"iridescenceMap",
	"iridescenceThicknessMap",
	"metalnessMap",
	"normalMap",
	"refractionMap",
	"sheenGlossMap",
	"sheenMap",
	"specularityFactorMap",
	"specularMap",
	"thicknessMap"
];
var GltfExporter = class _GltfExporter extends CoreExporter {
	collectResources(root) {
		const resources = {
			buffers: [],
			cameras: [],
			entities: [],
			materials: [],
			skins: [],
			textures: [],
			// entry: { node, meshInstances}
			entityMeshInstances: [],
			// maps a buffer (vertex or index) to an array of bufferview indices
			bufferViewMap: /* @__PURE__ */ new Map(),
			compressableTexture: /* @__PURE__ */ new Set()
		};
		const { materials, buffers, entityMeshInstances, textures } = resources;
		root.forEach((entity) => {
			resources.entities.push(entity);
		});
		const collectMeshInstances = (meshInstances) => {
			meshInstances.forEach((meshInstance) => {
				const material = meshInstance.material;
				if (materials.indexOf(material) < 0) {
					resources.materials.push(material);
					textureSemantics.forEach((semantic) => {
						const texture = material[semantic];
						if (texture && textures.indexOf(texture) < 0) {
							if (semantic !== "normalMap") {
								resources.compressableTexture.add(texture);
							}
							textures.push(texture);
						}
					});
				}
				const node = meshInstance.node;
				let nodeMeshInstances = entityMeshInstances.find((e) => e.node === node);
				if (!nodeMeshInstances) {
					nodeMeshInstances = { node, meshInstances: [] };
					entityMeshInstances.push(nodeMeshInstances);
				}
				nodeMeshInstances.meshInstances.push(meshInstance);
				const mesh = meshInstance.mesh;
				const vertexBuffer = mesh.vertexBuffer;
				if (buffers.indexOf(vertexBuffer) < 0) {
					buffers.unshift(vertexBuffer);
				}
				const indexBuffer = mesh.indexBuffer[0];
				if (buffers.indexOf(indexBuffer) < 0) {
					buffers.push(indexBuffer);
				}
				if (mesh.skin && resources.skins.indexOf(mesh.skin) < 0) {
					resources.skins.push(mesh.skin);
				}
			});
		};
		resources.entities.forEach((entity) => {
			if (entity.camera) {
				resources.cameras.push(entity.camera);
			}
			if (entity.render && entity.render.enabled) {
				collectMeshInstances(entity.render.meshInstances);
			}
			if (entity.model && entity.model.enabled && entity.model.meshInstances) {
				collectMeshInstances(entity.model.meshInstances);
			}
		});
		return resources;
	}
	writeBufferViews(resources, json) {
		json.bufferViews = [];
		for (const buffer of resources.buffers) {
			_GltfExporter.writeBufferView(resources, json, buffer);
		}
	}
	static writeBufferView(resources, json, buffer) {
		json.buffers = json.buffers ?? [];
		json.buffers[0] = json.buffers[0] ?? { byteLength: 0 };
		const bufferInfo = json.buffers[0];
		bufferInfo.byteLength = math.roundUp(bufferInfo.byteLength, 4);
		const offset3 = bufferInfo.byteLength;
		const addBufferView = (target2, byteLength, byteOffset, byteStride) => {
			const bufferView = {
				buffer: 0,
				byteLength,
				byteOffset
			};
			if (target2 === ARRAY_BUFFER || target2 === ELEMENT_ARRAY_BUFFER) {
				bufferView.target = target2;
			}
			if (byteStride !== void 0) {
				bufferView.byteStride = byteStride;
			}
			return json.bufferViews.push(bufferView) - 1;
		};
		let arrayBuffer;
		if (buffer instanceof VertexBuffer) {
			arrayBuffer = buffer.lock();
			const format = buffer.getFormat();
			if (format.interleaved) {
				const bufferViewIndex = addBufferView(ARRAY_BUFFER, arrayBuffer.byteLength, offset3, format.size);
				resources.bufferViewMap.set(buffer, [bufferViewIndex]);
			} else {
				const bufferViewIndices = [];
				for (const element of format.elements) {
					const bufferViewIndex = addBufferView(
						ARRAY_BUFFER,
						element.size * format.vertexCount,
						offset3 + element.offset,
						element.size
					);
					bufferViewIndices.push(bufferViewIndex);
				}
				resources.bufferViewMap.set(buffer, bufferViewIndices);
			}
		} else if (buffer instanceof IndexBuffer) {
			arrayBuffer = buffer.lock();
			const bufferViewIndex = addBufferView(ELEMENT_ARRAY_BUFFER, arrayBuffer.byteLength, offset3);
			resources.bufferViewMap.set(buffer, [bufferViewIndex]);
		} else {
			arrayBuffer = buffer;
			const bufferViewIndex = addBufferView(void 0, arrayBuffer.byteLength, offset3);
			resources.bufferViewMap.set(buffer, [bufferViewIndex]);
		}
		bufferInfo.byteLength += arrayBuffer.byteLength;
	}
	writeCameras(resources, json) {
		if (resources.cameras.length > 0) {
			json.cameras = resources.cameras.map((cam) => {
				const projection = cam.projection;
				const nearClip = cam.nearClip;
				const farClip = cam.farClip;
				const camera = {};
				if (projection === PROJECTION_ORTHOGRAPHIC) {
					camera.type = "orthographic";
					camera.orthographic = {
						xmag: 1,
						ymag: 1,
						znear: nearClip,
						zfar: farClip
					};
				} else {
					const fov = cam.fov;
					camera.type = "perspective";
					camera.perspective = {
						yfov: fov * math.DEG_TO_RAD,
						znear: nearClip,
						zfar: farClip
					};
				}
				return camera;
			});
		}
	}
	attachTexture(resources, material, destination, name, textureSemantic, json) {
		const texture = material[textureSemantic];
		if (texture) {
			const textureIndex = resources.textures.indexOf(texture);
			if (textureIndex < 0) console.warn(`Texture ${texture.name} wasn't collected.`);
			destination[name] = {
				index: textureIndex
			};
			const textureTexCoord = material[`${textureSemantic}Uv`] ?? 0;
			if (textureTexCoord !== 0) {
				destination[name].texCoord = textureTexCoord;
			}
			const scale2 = material[`${textureSemantic}Tiling`];
			const offset3 = material[`${textureSemantic}Offset`];
			const rotation7 = material[`${textureSemantic}Rotation`];
			if (scale2 && !scale2.equals(Vec2.ONE) || offset3 && !offset3.equals(Vec2.ZERO) || rotation7 !== 0) {
				destination[name].extensions = {
					KHR_texture_transform: {}
				};
				json.extensionsUsed = json.extensionsUsed ?? [];
				if (!json.extensionsUsed.includes("KHR_texture_transform")) {
					json.extensionsUsed.push("KHR_texture_transform");
				}
				json.extensionsRequired = json.extensionsRequired ?? [];
				if (!json.extensionsRequired.includes("KHR_texture_transform")) {
					json.extensionsRequired.push("KHR_texture_transform");
				}
				if (scale2 && !scale2.equals(Vec2.ONE)) {
					destination[name].extensions.KHR_texture_transform.scale = [scale2.x, scale2.y];
				}
				if (offset3 && !offset3.equals(Vec2.ZERO)) {
					destination[name].extensions.KHR_texture_transform.offset = [offset3.x, offset3.y - 1 + scale2.y];
				}
				if (rotation7 !== 0) {
					destination[name].extensions.KHR_texture_transform.rotation = rotation7 * math.DEG_TO_RAD;
				}
			}
		}
	}
	addExtension(json, output, name, data2 = {}) {
		output.extensions = output.extensions || {};
		output.extensions[name] = data2;
		json.extensionsUsed = json.extensionsUsed ?? [];
		if (!json.extensionsUsed.includes(name)) {
			json.extensionsUsed.push(name);
		}
	}
	writeStandardMaterial(resources, mat2, output, json) {
		const { diffuse, emissive, opacity, metalness, gloss, glossInvert } = mat2;
		const pbr = output.pbrMetallicRoughness;
		const baseColor = mat2.useLighting ? diffuse : emissive;
		if (!baseColor.equals(Color.WHITE) || opacity !== 1) {
			const { r, g, b } = baseColor.clone().linear();
			pbr.baseColorFactor = [r, g, b, opacity];
		}
		if (mat2.useMetalness) {
			if (metalness !== 1) {
				pbr.metallicFactor = metalness;
			}
		} else {
			pbr.metallicFactor = 0;
		}
		const roughness = glossInvert ? gloss : 1 - gloss;
		if (roughness !== 1) {
			pbr.roughnessFactor = roughness;
		}
		this.attachTexture(resources, mat2, pbr, "baseColorTexture", mat2.useLighting ? "diffuseMap" : "emissiveMap", json);
		this.attachTexture(resources, mat2, pbr, "metallicRoughnessTexture", "metalnessMap", json);
		if (mat2.useLighting && !emissive.equals(Color.BLACK)) {
			const { r, g, b } = emissive.clone().linear();
			output.emissiveFactor = [r, g, b];
		}
		if (mat2.enableGGXSpecular && (mat2.anisotropyIntensity !== 0 || mat2.anisotropyRotation !== 0 || mat2.anisotropyMap)) {
			const anisotropyExt = {};
			if (mat2.anisotropyIntensity !== 0) {
				anisotropyExt.anisotropyStrength = mat2.anisotropyIntensity;
			}
			if (mat2.anisotropyRotation !== 0) {
				anisotropyExt.anisotropyRotation = mat2.anisotropyRotation * math.DEG_TO_RAD;
			}
			this.attachTexture(resources, mat2, anisotropyExt, "anisotropyTexture", "anisotropyMap", json);
			if (Object.keys(anisotropyExt).length > 0) {
				this.addExtension(json, output, "KHR_materials_anisotropy", anisotropyExt);
			}
		}
		if (mat2.clearCoat > 0) {
			const clearcoatExt = {
				// Parser multiplies by 0.25, so we divide by 0.25 (multiply by 4) to reverse
				clearcoatFactor: Math.min(mat2.clearCoat * 4, 1)
			};
			if (mat2.clearCoatGloss !== 0) {
				clearcoatExt.clearcoatRoughnessFactor = mat2.clearCoatGloss;
			}
			this.attachTexture(resources, mat2, clearcoatExt, "clearcoatTexture", "clearCoatMap", json);
			this.attachTexture(resources, mat2, clearcoatExt, "clearcoatRoughnessTexture", "clearCoatGlossMap", json);
			if (mat2.clearCoatNormalMap) {
				this.attachTexture(resources, mat2, clearcoatExt, "clearcoatNormalTexture", "clearCoatNormalMap", json);
				if (mat2.clearCoatBumpiness !== 1) {
					clearcoatExt.clearcoatNormalTexture.scale = mat2.clearCoatBumpiness;
				}
			}
			this.addExtension(json, output, "KHR_materials_clearcoat", clearcoatExt);
		}
		if (mat2.dispersion !== 0) {
			this.addExtension(json, output, "KHR_materials_dispersion", {
				dispersion: mat2.dispersion
			});
		}
		if (mat2.useLighting && mat2.emissiveIntensity !== 1) {
			this.addExtension(json, output, "KHR_materials_emissive_strength", {
				emissiveStrength: mat2.emissiveIntensity
			});
		}
		const defaultRefractionIndex = 1 / 1.5;
		if (mat2.refractionIndex !== defaultRefractionIndex && mat2.refractionIndex > 0) {
			this.addExtension(json, output, "KHR_materials_ior", {
				ior: 1 / mat2.refractionIndex
			});
		}
		if (mat2.useIridescence) {
			const iridescenceExt = {};
			if (mat2.iridescence !== 0) {
				iridescenceExt.iridescenceFactor = mat2.iridescence;
			}
			if (mat2.iridescenceRefractionIndex !== 1.3) {
				iridescenceExt.iridescenceIor = mat2.iridescenceRefractionIndex;
			}
			if (mat2.iridescenceThicknessMin !== 100) {
				iridescenceExt.iridescenceThicknessMinimum = mat2.iridescenceThicknessMin;
			}
			if (mat2.iridescenceThicknessMax !== 400) {
				iridescenceExt.iridescenceThicknessMaximum = mat2.iridescenceThicknessMax;
			}
			this.attachTexture(resources, mat2, iridescenceExt, "iridescenceTexture", "iridescenceMap", json);
			this.attachTexture(resources, mat2, iridescenceExt, "iridescenceThicknessTexture", "iridescenceThicknessMap", json);
			if (Object.keys(iridescenceExt).length > 0) {
				this.addExtension(json, output, "KHR_materials_iridescence", iridescenceExt);
			}
		}
		if (mat2.useSheen) {
			const sheenExt = {};
			if (!mat2.sheen.equals(Color.BLACK)) {
				const { r, g, b } = mat2.sheen.clone().linear();
				sheenExt.sheenColorFactor = [r, g, b];
			}
			if (mat2.sheenGloss !== 0) {
				sheenExt.sheenRoughnessFactor = mat2.sheenGloss;
			}
			this.attachTexture(resources, mat2, sheenExt, "sheenColorTexture", "sheenMap", json);
			this.attachTexture(resources, mat2, sheenExt, "sheenRoughnessTexture", "sheenGlossMap", json);
			if (Object.keys(sheenExt).length > 0) {
				this.addExtension(json, output, "KHR_materials_sheen", sheenExt);
			}
		}
		if (mat2.useMetalnessSpecularColor || !mat2.useMetalness) {
			const specularExt = {};
			if (!mat2.specular.equals(Color.WHITE)) {
				const { r, g, b } = mat2.specular.clone().linear();
				specularExt.specularColorFactor = [r, g, b];
			}
			if (mat2.specularityFactor !== 1) {
				specularExt.specularFactor = mat2.specularityFactor;
			}
			this.attachTexture(resources, mat2, specularExt, "specularColorTexture", "specularMap", json);
			this.attachTexture(resources, mat2, specularExt, "specularTexture", "specularityFactorMap", json);
			if (Object.keys(specularExt).length > 0) {
				this.addExtension(json, output, "KHR_materials_specular", specularExt);
			}
		}
		if (mat2.useDynamicRefraction && (mat2.refraction !== 0 || mat2.refractionMap)) {
			const transmissionExt = {};
			if (mat2.refraction !== 0) {
				transmissionExt.transmissionFactor = mat2.refraction;
			}
			this.attachTexture(resources, mat2, transmissionExt, "transmissionTexture", "refractionMap", json);
			if (Object.keys(transmissionExt).length > 0) {
				this.addExtension(json, output, "KHR_materials_transmission", transmissionExt);
			}
		}
		if (!mat2.useLighting) {
			this.addExtension(json, output, "KHR_materials_unlit");
		}
		if (mat2.useDynamicRefraction && (mat2.thickness !== 0 || mat2.attenuationDistance !== 0 || !mat2.attenuation.equals(Color.WHITE) || mat2.thicknessMap)) {
			const volumeExt = {};
			if (mat2.thickness !== 0) {
				volumeExt.thicknessFactor = mat2.thickness;
			}
			if (mat2.attenuationDistance !== 0) {
				volumeExt.attenuationDistance = mat2.attenuationDistance;
			}
			if (!mat2.attenuation.equals(Color.WHITE)) {
				const { r, g, b } = mat2.attenuation.clone().linear();
				volumeExt.attenuationColor = [r, g, b];
			}
			this.attachTexture(resources, mat2, volumeExt, "thicknessTexture", "thicknessMap", json);
			if (Object.keys(volumeExt).length > 0) {
				this.addExtension(json, output, "KHR_materials_volume", volumeExt);
			}
		}
	}
	writeMaterials(resources, json) {
		if (resources.materials.length > 0) {
			json.materials = resources.materials.map((mat2) => {
				const { name, blendType, cull, alphaTest } = mat2;
				const material = {
					pbrMetallicRoughness: {}
				};
				if (name && name.length > 0) {
					material.name = name;
				}
				if (mat2 instanceof StandardMaterial) {
					this.writeStandardMaterial(resources, mat2, material, json);
				}
				if (blendType === BLEND_NORMAL) {
					material.alphaMode = "BLEND";
				} else if (blendType === BLEND_NONE) {
					if (alphaTest !== 0) {
						material.alphaMode = "MASK";
						material.alphaCutoff = alphaTest;
					}
				}
				if (cull === CULLFACE_NONE) {
					material.doubleSided = true;
				}
				this.attachTexture(resources, mat2, material, "normalTexture", "normalMap", json);
				this.attachTexture(resources, mat2, material, "occlusionTexture", "aoMap", json);
				if (material.occlusionTexture && mat2.aoIntensity !== 1) {
					material.occlusionTexture.strength = mat2.aoIntensity;
				}
				this.attachTexture(resources, mat2, material, "emissiveTexture", "emissiveMap", json);
				return material;
			});
		}
	}
	writeNodes(resources, json) {
		if (resources.entities.length > 0) {
			json.nodes = resources.entities.map((entity) => {
				const name = entity.name;
				const t = entity.getLocalPosition();
				const r = entity.getLocalRotation();
				const s2 = entity.getLocalScale();
				const node = {};
				if (name && name.length > 0) {
					node.name = name;
				}
				if (!t.equals(Vec3.ZERO)) {
					node.translation = [t.x, t.y, t.z];
				}
				if (!r.equals(Quat.IDENTITY)) {
					node.rotation = [r.x, r.y, r.z, r.w];
				}
				if (!s2.equals(Vec3.ONE)) {
					node.scale = [s2.x, s2.y, s2.z];
				}
				if (entity.camera && entity.camera.enabled) {
					node.camera = resources.cameras.indexOf(entity.camera);
				}
				const entityMeshInstance = resources.entityMeshInstances.find((e) => e.node === entity);
				if (entityMeshInstance) {
					node.mesh = resources.entityMeshInstances.indexOf(entityMeshInstance);
					const meshInstance = entityMeshInstance.meshInstances[0];
					if (meshInstance && meshInstance.mesh.skin) {
						node.skin = resources.skins.indexOf(meshInstance.mesh.skin);
					}
				}
				if (entity.children.length > 0) {
					node.children = [];
					entity.children.forEach((child) => {
						node.children.push(resources.entities.indexOf(child));
					});
				}
				return node;
			});
		}
	}
	writeMeshes(resources, json, options2) {
		if (resources.entityMeshInstances.length > 0) {
			json.accessors = [];
			json.meshes = [];
			resources.entityMeshInstances.forEach((entityMeshInstances) => {
				const mesh = {
					primitives: []
				};
				const meshInstances = entityMeshInstances.meshInstances;
				meshInstances.forEach((meshInstance) => {
					const primitive2 = _GltfExporter.createPrimitive(resources, json, meshInstance.mesh, options2);
					primitive2.material = resources.materials.indexOf(meshInstance.material);
					mesh.primitives.push(primitive2);
				});
				json.meshes.push(mesh);
			});
		}
	}
	static createPrimitive(resources, json, mesh, options2 = {}) {
		const primitive2 = {
			attributes: {}
		};
		const { vertexBuffer } = mesh;
		const { format } = vertexBuffer;
		const { interleaved, elements } = format;
		const numVertices = vertexBuffer.getNumVertices();
		elements.forEach((element, elementIndex) => {
			const semantic = getSemantic(element.name);
			if (options2.stripUnusedAttributes) {
				let isUsed = true;
				if (semantic.startsWith("TEXCOORD_")) {
					const texCoordIndex = parseInt(semantic.split("_")[1], 10);
					isUsed = resources.materials.some((material) => {
						return textureSemantics.some((texSemantic) => {
							const texture = material[texSemantic];
							if (!texture) {
								return false;
							}
							const uv = material[`${texSemantic}Uv`] ?? 0;
							return uv === texCoordIndex;
						});
					});
				}
				if (semantic === "COLOR_0") {
					isUsed = resources.materials.some((material) => material.vertexColors);
				}
				if (semantic === "TANGENT") {
					isUsed = resources.materials.some((material) => material.normalMap);
				}
				if (semantic === "JOINTS_0" || semantic === "WEIGHTS_0") {
					isUsed = resources.entityMeshInstances.some((emi) => emi.meshInstances.some((mi) => mi.mesh.skin));
				}
				if (!isUsed) {
					return;
				}
			}
			let bufferView = resources.bufferViewMap.get(vertexBuffer);
			if (!bufferView) {
				_GltfExporter.writeBufferView(resources, json, vertexBuffer);
				resources.buffers.push(vertexBuffer);
				bufferView = resources.bufferViewMap.get(vertexBuffer);
			}
			const viewIndex = bufferView[interleaved ? 0 : elementIndex];
			const accessor = {
				bufferView: viewIndex,
				byteOffset: interleaved ? element.offset : 0,
				componentType: getComponentType(element.dataType),
				type: getAccessorType(element.numComponents),
				count: numVertices
			};
			const idx = json.accessors.push(accessor) - 1;
			primitive2.attributes[semantic] = idx;
			if (element.name === SEMANTIC_POSITION) {
				const positions = [];
				mesh.getPositions(positions);
				const min = new Vec3();
				const max = new Vec3();
				BoundingBox.computeMinMax(positions, min, max);
				accessor.min = [min.x, min.y, min.z];
				accessor.max = [max.x, max.y, max.z];
			}
		});
		const indexBuffer = mesh.indexBuffer[0];
		if (indexBuffer) {
			let bufferView = resources.bufferViewMap.get(indexBuffer);
			if (!bufferView) {
				_GltfExporter.writeBufferView(resources, json, indexBuffer);
				resources.buffers.push(indexBuffer);
				bufferView = resources.bufferViewMap.get(indexBuffer);
			}
			const viewIndex = bufferView[0];
			const accessor = {
				bufferView: viewIndex,
				componentType: getIndexComponentType(indexBuffer.getFormat()),
				count: indexBuffer.getNumIndices(),
				type: "SCALAR"
			};
			const idx = json.accessors.push(accessor) - 1;
			primitive2.indices = idx;
		}
		return primitive2;
	}
	writeSkins(resources, json) {
		if (resources.skins.length > 0) {
			json.skins = resources.skins.map((skin) => {
				const matrices = new Float32Array(skin.inverseBindPose.length * 16);
				for (let i2 = 0; i2 < skin.inverseBindPose.length; i2++) {
					const ibm = skin.inverseBindPose[i2];
					matrices.set(ibm.data, i2 * 16);
				}
				const matrixBuffer = matrices.buffer;
				_GltfExporter.writeBufferView(resources, json, matrixBuffer);
				resources.buffers.push(matrixBuffer);
				const bufferView = resources.bufferViewMap.get(matrixBuffer);
				const accessor = {
					bufferView: bufferView[0],
					componentType: getComponentType(TYPE_FLOAT32),
					count: skin.inverseBindPose.length,
					type: "MAT4"
				};
				const accessorIndex = json.accessors.push(accessor) - 1;
				const joints = skin.boneNames.map((boneName) => {
					const node = resources.entities.find((entity) => entity.name === boneName);
					return resources.entities.indexOf(node);
				});
				return {
					inverseBindMatrices: accessorIndex,
					joints
				};
			});
		}
	}
	convertTextures(srcTextures, options2) {
		const textureOptions = {
			maxTextureSize: options2.maxTextureSize
		};
		const promises = [];
		srcTextures.forEach((srcTexture) => {
			const promise = this.textureToCanvas(srcTexture, textureOptions);
			promise.then((canvas) => {
				return new Promise((resolve2) => resolve2(canvas));
			});
			promises.push(promise);
		});
		return promises;
	}
	writeTextures(resources, textureCanvases, json, options2) {
		const textures = resources.textures;
		const promises = [];
		for (let i2 = 0; i2 < textureCanvases.length; i2++) {
			const texture = textures[i2];
			const canvas = textureCanvases[i2];
			const isRGBA = isCanvasTransparent(canvas) || !resources.compressableTexture.has(texture);
			const mimeType = isRGBA ? "image/png" : "image/jpeg";
			promises.push(
				this.getBlob(canvas, mimeType).then((blob) => {
					const reader = new FileReader();
					reader.readAsArrayBuffer(blob);
					return new Promise((resolve2) => {
						reader.onloadend = () => {
							resolve2(reader);
						};
					});
				}).then((reader) => {
					const buffer = this.getPaddedArrayBuffer(reader.result);
					_GltfExporter.writeBufferView(resources, json, buffer);
					resources.buffers.push(buffer);
					const bufferView = resources.bufferViewMap.get(buffer);
					json.images[i2] = {
						mimeType,
						bufferView: bufferView[0]
					};
					json.samplers[i2] = {
						minFilter: getFilter(texture.minFilter),
						magFilter: getFilter(texture.magFilter),
						wrapS: getWrap(texture.addressU),
						wrapT: getWrap(texture.addressV)
					};
					json.textures[i2] = {
						sampler: i2,
						source: i2
					};
				})
			);
		}
		return Promise.all(promises);
	}
	getBlob(canvas, mimeType) {
		if (canvas.toBlob !== void 0) {
			return new Promise((resolve2) => {
				canvas.toBlob(resolve2, mimeType);
			});
		}
		let quality = 1;
		if (mimeType === "image/jpeg") {
			quality = 0.92;
		}
		return canvas.convertToBlob({
			type: mimeType,
			quality
		});
	}
	getPaddedArrayBuffer(arrayBuffer, paddingByte = 0) {
		const paddedLength = math.roundUp(arrayBuffer.byteLength, 4);
		if (paddedLength !== arrayBuffer.byteLength) {
			const array3 = new Uint8Array(paddedLength);
			array3.set(new Uint8Array(arrayBuffer));
			if (paddingByte !== 0) {
				for (let i2 = arrayBuffer.byteLength; i2 < paddedLength; i2++) {
					array3[i2] = paddingByte;
				}
			}
			return array3.buffer;
		}
		return arrayBuffer;
	}
	buildJson(resources, options2) {
		const promises = this.convertTextures(resources.textures, options2);
		return Promise.all(promises).then(async (textureCanvases) => {
			const json = {
				asset: {
					version: "2.0",
					generator: "PlayCanvas GltfExporter"
				},
				scenes: [
					{
						nodes: [
							0
						]
					}
				],
				images: [],
				samplers: [],
				textures: [],
				scene: 0
			};
			this.writeBufferViews(resources, json);
			this.writeCameras(resources, json);
			this.writeMeshes(resources, json, options2);
			this.writeMaterials(resources, json);
			this.writeNodes(resources, json, options2);
			this.writeSkins(resources, json);
			await this.writeTextures(resources, textureCanvases, json, options2);
			if (!json.images.length) delete json.images;
			if (!json.samplers.length) delete json.samplers;
			if (!json.textures.length) delete json.textures;
			return json;
		});
	}
	build(entity, options2 = {}) {
		const resources = this.collectResources(entity);
		return this.buildJson(resources, options2).then((json) => {
			const encoder = new TextEncoder();
			const jsonData = encoder.encode(JSON.stringify(json));
			const headerLength = 12;
			const jsonHeaderLength = 8;
			const jsonDataLength = jsonData.length;
			const jsonPaddingLength = 4 - (jsonDataLength & 3) & 3;
			const binaryHeaderLength = 8;
			const binaryDataLength = json.buffers.reduce(
				(total, buffer) => math.roundUp(total + buffer.byteLength, 4),
				0
			);
			let totalLength = headerLength + jsonHeaderLength + jsonDataLength + jsonPaddingLength;
			if (binaryDataLength > 0) {
				totalLength += binaryHeaderLength + binaryDataLength;
			}
			const glbBuffer = new ArrayBuffer(totalLength);
			const glbView = new DataView(glbBuffer);
			glbView.setUint32(0, 1179937895, true);
			glbView.setUint32(4, 2, true);
			glbView.setUint32(8, totalLength, true);
			glbView.setUint32(12, jsonDataLength + jsonPaddingLength, true);
			glbView.setUint32(16, 1313821514, true);
			let offset3 = headerLength + jsonHeaderLength;
			new Uint8Array(glbBuffer, offset3, jsonDataLength).set(jsonData);
			offset3 += jsonDataLength;
			for (let i2 = 0; i2 < jsonPaddingLength; i2++) {
				glbView.setUint8(offset3 + i2, 32);
			}
			offset3 += jsonPaddingLength;
			if (binaryDataLength > 0) {
				glbView.setUint32(offset3, binaryDataLength, true);
				glbView.setUint32(offset3 + 4, 5130562, true);
				offset3 += binaryHeaderLength;
				resources.buffers.forEach((buffer) => {
					let src;
					const bufferViewId = resources.bufferViewMap.get(buffer)[0];
					const bufferOffset = json.bufferViews[bufferViewId].byteOffset;
					if (buffer instanceof ArrayBuffer) {
						src = new Uint8Array(buffer);
					} else {
						const srcBuffer = buffer.lock();
						if (srcBuffer instanceof ArrayBuffer) {
							src = new Uint8Array(srcBuffer);
						} else {
							src = new Uint8Array(srcBuffer.buffer, srcBuffer.byteOffset, srcBuffer.byteLength);
						}
					}
					const dst = new Uint8Array(glbBuffer, offset3 + bufferOffset, src.byteLength);
					dst.set(src);
				});
			}
			return Promise.resolve(glbBuffer);
		});
	}
};

var SSAOTYPE_NONE = "none";
var SSAOTYPE_LIGHTING = "lighting";
var SSAOTYPE_COMBINE = "combine";

var downsample_default = `
uniform sampler2D sourceTexture;
uniform vec2 sourceInvResolution;
varying vec2 uv0;
#ifdef PREMULTIPLY
	uniform sampler2D premultiplyTexture;
#endif
void main()
{
	vec3 e = texture2D (sourceTexture, uv0).rgb;
	#ifdef BOXFILTER
		vec3 value = e;
		#ifdef PREMULTIPLY
			float premultiply = texture2D(premultiplyTexture, uv0).{PREMULTIPLY_SRC_CHANNEL};
			value *= vec3(premultiply);
		#endif
	#else
		float x = sourceInvResolution.x;
		float y = sourceInvResolution.y;
		vec3 a = texture2D(sourceTexture, vec2 (uv0.x - 2.0 * x, uv0.y + 2.0 * y)).rgb;
		vec3 b = texture2D(sourceTexture, vec2 (uv0.x,		   uv0.y + 2.0 * y)).rgb;
		vec3 c = texture2D(sourceTexture, vec2 (uv0.x + 2.0 * x, uv0.y + 2.0 * y)).rgb;
		vec3 d = texture2D(sourceTexture, vec2 (uv0.x - 2.0 * x, uv0.y)).rgb;
		vec3 f = texture2D(sourceTexture, vec2 (uv0.x + 2.0 * x, uv0.y)).rgb;
		vec3 g = texture2D(sourceTexture, vec2 (uv0.x - 2.0 * x, uv0.y - 2.0 * y)).rgb;
		vec3 h = texture2D(sourceTexture, vec2 (uv0.x,		   uv0.y - 2.0 * y)).rgb;
		vec3 i = texture2D(sourceTexture, vec2 (uv0.x + 2.0 * x, uv0.y - 2.0 * y)).rgb;
		vec3 j = texture2D(sourceTexture, vec2 (uv0.x - x, uv0.y + y)).rgb;
		vec3 k = texture2D(sourceTexture, vec2 (uv0.x + x, uv0.y + y)).rgb;
		vec3 l = texture2D(sourceTexture, vec2 (uv0.x - x, uv0.y - y)).rgb;
		vec3 m = texture2D(sourceTexture, vec2 (uv0.x + x, uv0.y - y)).rgb;
		vec3 value = e * 0.125;
		value += (a + c + g + i) * 0.03125;
		value += (b + d + f + h) * 0.0625;
		value += (j + k + l + m) * 0.125;
	#endif
	#ifdef REMOVE_INVALID
		value = max(value, vec3(0.0));
	#endif
	gl_FragColor = vec4(value, 1.0);
}
`;

var downsample_default2 = `
var sourceTexture: texture_2d<f32>;
var sourceTextureSampler: sampler;
uniform sourceInvResolution: vec2f;
varying uv0: vec2f;
#ifdef PREMULTIPLY
	var premultiplyTexture: texture_2d<f32>;
	var premultiplyTextureSampler: sampler;
#endif
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	let e: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, input.uv0).rgb);
	#ifdef BOXFILTER
		var value: half3 = e;
		#ifdef PREMULTIPLY
			let premultiply: half = half(textureSample(premultiplyTexture, premultiplyTextureSampler, input.uv0).{PREMULTIPLY_SRC_CHANNEL});
			value *= premultiply;
		#endif
	#else
		let x: f32 = uniform.sourceInvResolution.x;
		let y: f32 = uniform.sourceInvResolution.y;
		let a: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x - 2.0 * x, input.uv0.y + 2.0 * y)).rgb);
		let b: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x,		   input.uv0.y + 2.0 * y)).rgb);
		let c: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x + 2.0 * x, input.uv0.y + 2.0 * y)).rgb);
		let d: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x - 2.0 * x, input.uv0.y)).rgb);
		let f: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x + 2.0 * x, input.uv0.y)).rgb);
		let g: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x - 2.0 * x, input.uv0.y - 2.0 * y)).rgb);
		let h: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x,		   input.uv0.y - 2.0 * y)).rgb);
		let i: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x + 2.0 * x, input.uv0.y - 2.0 * y)).rgb);
		let j: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x - x, input.uv0.y + y)).rgb);
		let k: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x + x, input.uv0.y + y)).rgb);
		let l: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x - x, input.uv0.y - y)).rgb);
		let m: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x + x, input.uv0.y - y)).rgb);
		var value: half3 = e * half(0.125);
		value += (a + c + g + i) * half(0.03125);
		value += (b + d + f + h) * half(0.0625);
		value += (j + k + l + m) * half(0.125);
	#endif
	#ifdef REMOVE_INVALID
		value = max(value, half3(0.0));
	#endif
	output.color = vec4f(vec3f(value), 1.0);
	return output;
}
`;

var RenderPassDownsample = class extends RenderPassShaderQuad {
	constructor(device, sourceTexture, options2 = {}) {
		super(device);
		this.sourceTexture = sourceTexture;
		this.premultiplyTexture = options2.premultiplyTexture;
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("downsamplePS", downsample_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("downsamplePS", downsample_default2);
		const boxFilter = options2.boxFilter ?? false;
		const key = `${boxFilter ? "Box" : ""}-${options2.premultiplyTexture ? "Premultiply" : ""}-${options2.premultiplySrcChannel ?? ""}-${options2.removeInvalid ? "RemoveInvalid" : ""}`;
		const defines = /* @__PURE__ */ new Map();
		if (boxFilter) defines.set("BOXFILTER", "");
		if (options2.premultiplyTexture) defines.set("PREMULTIPLY", "");
		if (options2.removeInvalid) defines.set("REMOVE_INVALID", "");
		defines.set("{PREMULTIPLY_SRC_CHANNEL}", options2.premultiplySrcChannel ?? "x");
		this.shader = ShaderUtils.createShader(device, {
			uniqueName: `DownSampleShader:${key}`,
			attributes: { aPosition: SEMANTIC_POSITION },
			vertexChunk: "quadVS",
			fragmentChunk: "downsamplePS",
			fragmentDefines: defines
		});
		this.sourceTextureId = device.scope.resolve("sourceTexture");
		this.premultiplyTextureId = device.scope.resolve("premultiplyTexture");
		this.sourceInvResolutionId = device.scope.resolve("sourceInvResolution");
		this.sourceInvResolutionValue = new Float32Array(2);
	}
	setSourceTexture(value) {
		this._sourceTexture = value;
		this.options.resizeSource = value;
	}
	execute() {
		this.sourceTextureId.setValue(this.sourceTexture);
		if (this.premultiplyTexture) {
			this.premultiplyTextureId.setValue(this.premultiplyTexture);
		}
		this.sourceInvResolutionValue[0] = 1 / this.sourceTexture.width;
		this.sourceInvResolutionValue[1] = 1 / this.sourceTexture.height;
		this.sourceInvResolutionId.setValue(this.sourceInvResolutionValue);
		super.execute();
	}
};

var upsample_default = `
	uniform sampler2D sourceTexture;
	uniform vec2 sourceInvResolution;
	varying vec2 uv0;
	void main()
	{
		float x = sourceInvResolution.x;
		float y = sourceInvResolution.y;
		vec3 a = texture2D (sourceTexture, vec2 (uv0.x - x, uv0.y + y)).rgb;
		vec3 b = texture2D (sourceTexture, vec2 (uv0.x,	 uv0.y + y)).rgb;
		vec3 c = texture2D (sourceTexture, vec2 (uv0.x + x, uv0.y + y)).rgb;
		vec3 d = texture2D (sourceTexture, vec2 (uv0.x - x, uv0.y)).rgb;
		vec3 e = texture2D (sourceTexture, vec2 (uv0.x,	 uv0.y)).rgb;
		vec3 f = texture2D (sourceTexture, vec2 (uv0.x + x, uv0.y)).rgb;
		vec3 g = texture2D (sourceTexture, vec2 (uv0.x - x, uv0.y - y)).rgb;
		vec3 h = texture2D (sourceTexture, vec2 (uv0.x,	 uv0.y - y)).rgb;
		vec3 i = texture2D (sourceTexture, vec2 (uv0.x + x, uv0.y - y)).rgb;
		vec3 value = e * 0.25;
		value += (b + d + f + h) * 0.125;
		value += (a + c + g + i) * 0.0625;
		gl_FragColor = vec4(value, 1.0);
	}
`;

var upsample_default2 = `
	var sourceTexture: texture_2d<f32>;
	var sourceTextureSampler: sampler;
	uniform sourceInvResolution: vec2f;
	varying uv0: vec2f;
	@fragment
	fn fragmentMain(input: FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		let x: f32 = uniform.sourceInvResolution.x;
		let y: f32 = uniform.sourceInvResolution.y;
		let a: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x - x, input.uv0.y + y)).rgb);
		let b: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x,	 input.uv0.y + y)).rgb);
		let c: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x + x, input.uv0.y + y)).rgb);
		let d: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x - x, input.uv0.y)).rgb);
		let e: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x,	 input.uv0.y)).rgb);
		let f: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x + x, input.uv0.y)).rgb);
		let g: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x - x, input.uv0.y - y)).rgb);
		let h: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x,	 input.uv0.y - y)).rgb);
		let i: half3 = half3(textureSample(sourceTexture, sourceTextureSampler, vec2f(input.uv0.x + x, input.uv0.y - y)).rgb);
		var value: half3 = e * half(0.25);
		value += (b + d + f + h) * half(0.125);
		value += (a + c + g + i) * half(0.0625);
		output.color = vec4f(vec3f(value), 1.0);
		return output;
	}
`;

var RenderPassUpsample = class extends RenderPassShaderQuad {
	constructor(device, sourceTexture) {
		super(device);
		this.sourceTexture = sourceTexture;
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("upsamplePS", upsample_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("upsamplePS", upsample_default2);
		this.shader = ShaderUtils.createShader(device, {
			uniqueName: "UpSampleShader",
			attributes: { aPosition: SEMANTIC_POSITION },
			vertexChunk: "quadVS",
			fragmentChunk: "upsamplePS"
		});
		this.sourceTextureId = device.scope.resolve("sourceTexture");
		this.sourceInvResolutionId = device.scope.resolve("sourceInvResolution");
		this.sourceInvResolutionValue = new Float32Array(2);
	}
	execute() {
		this.sourceTextureId.setValue(this.sourceTexture);
		this.sourceInvResolutionValue[0] = 1 / this.sourceTexture.width;
		this.sourceInvResolutionValue[1] = 1 / this.sourceTexture.height;
		this.sourceInvResolutionId.setValue(this.sourceInvResolutionValue);
		super.execute();
	}
};

var FramePassBloom = class extends FramePass {
	bloomTexture;
	blurLevel = 16;
	bloomRenderTarget;
	textureFormat;
	renderTargets = [];
	constructor(device, sourceTexture, format) {
		super(device);
		this._sourceTexture = sourceTexture;
		this.textureFormat = format;
		this.bloomRenderTarget = this.createRenderTarget(0);
		this.bloomTexture = this.bloomRenderTarget.colorBuffer;
	}
	destroy() {
		this.destroyRenderPasses();
		this.destroyRenderTargets();
	}
	destroyRenderTargets(startIndex = 0) {
		for (let i2 = startIndex; i2 < this.renderTargets.length; i2++) {
			const rt = this.renderTargets[i2];
			rt.destroyTextureBuffers();
			rt.destroy();
		}
		this.renderTargets.length = 0;
	}
	destroyRenderPasses() {
		for (let i2 = 0; i2 < this.beforePasses.length; i2++) {
			this.beforePasses[i2].destroy();
		}
		this.beforePasses.length = 0;
	}
	createRenderTarget(index) {
		return new RenderTarget({
			depth: false,
			colorBuffer: new Texture(this.device, {
				name: `BloomTexture${index}`,
				width: 1,
				height: 1,
				format: this.textureFormat,
				mipmaps: false,
				minFilter: FILTER_LINEAR,
				magFilter: FILTER_LINEAR,
				addressU: ADDRESS_CLAMP_TO_EDGE,
				addressV: ADDRESS_CLAMP_TO_EDGE
			})
		});
	}
	createRenderTargets(count) {
		for (let i2 = 0; i2 < count; i2++) {
			const rt = i2 === 0 ? this.bloomRenderTarget : this.createRenderTarget(i2);
			this.renderTargets.push(rt);
		}
	}
	// number of levels till hitting min size
	calcMipLevels(width, height, minSize) {
		const min = Math.min(width, height);
		return Math.floor(Math.log2(min) - Math.log2(minSize));
	}
	createRenderPasses(numPasses) {
		const device = this.device;
		let passSourceTexture = this._sourceTexture;
		for (let i2 = 0; i2 < numPasses; i2++) {
			const pass = new RenderPassDownsample(device, passSourceTexture);
			const rt = this.renderTargets[i2];
			pass.init(rt, {
				resizeSource: passSourceTexture,
				scaleX: 0.5,
				scaleY: 0.5
			});
			pass.setClearColor(Color.BLACK);
			this.beforePasses.push(pass);
			passSourceTexture = rt.colorBuffer;
		}
		passSourceTexture = this.renderTargets[numPasses - 1].colorBuffer;
		for (let i2 = numPasses - 2; i2 >= 0; i2--) {
			const pass = new RenderPassUpsample(device, passSourceTexture);
			const rt = this.renderTargets[i2];
			pass.init(rt);
			pass.blendState = BlendState.ADDBLEND;
			this.beforePasses.push(pass);
			passSourceTexture = rt.colorBuffer;
		}
	}
	onDisable() {
		this.renderTargets[0]?.resize(1, 1);
		this.destroyRenderPasses();
		this.destroyRenderTargets(1);
	}
	frameUpdate() {
		super.frameUpdate();
		const maxNumPasses = this.calcMipLevels(this._sourceTexture.width, this._sourceTexture.height, 1);
		const numPasses = math.clamp(maxNumPasses, 1, this.blurLevel);
		if (this.renderTargets.length !== numPasses) {
			this.destroyRenderPasses();
			this.destroyRenderTargets(1);
			this.createRenderTargets(numPasses);
			this.createRenderPasses(numPasses);
		}
	}
};

var compose_default = `
	#include "tonemappingPS"
	#include "gammaPS"
	varying vec2 uv0;
	uniform sampler2D sceneTexture;
	uniform vec2 sceneTextureInvRes;
	#include "composeBloomPS"
	#include "composeDofPS"
	#include "composeSsaoPS"
	#include "composeGradingPS"
	#include "composeColorEnhancePS"
	#include "composeVignettePS"
	#include "composeFringingPS"
	#include "composeCasPS"
	#include "composeColorLutPS"
	#include "composeDeclarationsPS"
	void main() {
		#include "composeMainStartPS"
		vec2 uv = uv0;
		vec4 scene = texture2DLod(sceneTexture, uv, 0.0);
		vec3 result = scene.rgb;
		#ifdef CAS
			result = applyCas(result, uv, sharpness);
		#endif
		#ifdef DOF
			result = applyDof(result, uv0);
		#endif
		#ifdef SSAO_TEXTURE
			result = applySsao(result, uv0);
		#endif
		#ifdef FRINGING
			result = applyFringing(result, uv);
		#endif
		#ifdef BLOOM
			result = applyBloom(result, uv0);
		#endif
		#ifdef COLOR_ENHANCE
			result = applyColorEnhance(result);
		#endif
		#ifdef GRADING
			result = applyGrading(result);
		#endif
		result = toneMap(max(vec3(0.0), result));
		#ifdef COLOR_LUT
			result = applyColorLUT(result);
		#endif
		#ifdef VIGNETTE
			result = applyVignette(result, uv);
		#endif
		#include "composeMainEndPS"
		#ifdef DEBUG_COMPOSE
			#if DEBUG_COMPOSE == scene
				result = scene.rgb;
			#elif defined(BLOOM) && DEBUG_COMPOSE == bloom
				result = dBloom * bloomIntensity;
			#elif defined(DOF) && DEBUG_COMPOSE == dofcoc
				result = vec3(dCoc, 0.0);
			#elif defined(DOF) && DEBUG_COMPOSE == dofblur
				result = dBlur;
			#elif defined(SSAO_TEXTURE) && DEBUG_COMPOSE == ssao
				result = vec3(dSsao);
			#elif defined(VIGNETTE) && DEBUG_COMPOSE == vignette
				result = vec3(dVignette);
			#endif
		#endif
		result = gammaCorrectOutput(result);
		gl_FragColor = vec4(result, scene.a);
	}
`;

var compose_bloom_default = `
	#ifdef BLOOM
		uniform sampler2D bloomTexture;
		uniform float bloomIntensity;
		
		vec3 dBloom;
		
		vec3 applyBloom(vec3 color, vec2 uv) {
			dBloom = texture2DLod(bloomTexture, uv, 0.0).rgb;
			return color + dBloom * bloomIntensity;
		}
	#endif
`;

var compose_dof_default = `
	#ifdef DOF
		uniform sampler2D cocTexture;
		uniform sampler2D blurTexture;
		
		vec2 dCoc;
		vec3 dBlur;
		vec3 getDofBlur(vec2 uv) {
			dCoc = texture2DLod(cocTexture, uv, 0.0).rg;
			#if DOF_UPSCALE
				vec2 blurTexelSize = 1.0 / vec2(textureSize(blurTexture, 0));
				vec3 bilinearBlur = vec3(0.0);
				float totalWeight = 0.0;
				for (int i = -1; i <= 1; i++) {
					for (int j = -1; j <= 1; j++) {
						vec2 offset = vec2(i, j) * blurTexelSize;
						vec2 cocSample = texture2DLod(cocTexture, uv + offset, 0.0).rg;
						vec3 blurSample = texture2DLod(blurTexture, uv + offset, 0.0).rgb;
						float cocWeight = clamp(cocSample.r + cocSample.g, 0.0, 1.0);
						bilinearBlur += blurSample * cocWeight;
						totalWeight += cocWeight;
					}
				}
				if (totalWeight > 0.0) {
					bilinearBlur /= totalWeight;
				}
				dBlur = bilinearBlur;
				return bilinearBlur;
			#else
				dBlur = texture2DLod(blurTexture, uv, 0.0).rgb;
				return dBlur;
			#endif
		}
		vec3 applyDof(vec3 color, vec2 uv) {
			vec3 blur = getDofBlur(uv);
			return mix(color, blur, dCoc.r + dCoc.g);
		}
	#endif
`;

var compose_ssao_default = `
	#ifdef SSAO
		#define SSAO_TEXTURE
	#endif
	#if DEBUG_COMPOSE == ssao
		#define SSAO_TEXTURE
	#endif
	#ifdef SSAO_TEXTURE
		uniform sampler2D ssaoTexture;
		
		float dSsao;
		
		vec3 applySsao(vec3 color, vec2 uv) {
			dSsao = texture2DLod(ssaoTexture, uv, 0.0).r;
			
			#ifdef SSAO
				return color * dSsao;
			#else
				return color;
			#endif
		}
	#endif
`;

var compose_grading_default = `
	#ifdef GRADING
		uniform vec3 brightnessContrastSaturation;
		uniform vec3 tint;
		vec3 colorGradingHDR(vec3 color, float brt, float sat, float con) {
			color *= tint;
			color = color * brt;
			float grey = dot(color, vec3(0.3, 0.59, 0.11));
			grey = grey / max(1.0, max(color.r, max(color.g, color.b)));
			color = mix(vec3(grey), color, sat);
			return mix(vec3(0.5), color, con);
		}
		vec3 applyGrading(vec3 color) {
			return colorGradingHDR(color, 
				brightnessContrastSaturation.x, 
				brightnessContrastSaturation.z, 
				brightnessContrastSaturation.y);
		}
	#endif
`;

var compose_color_enhance_default = `
	#ifdef COLOR_ENHANCE
		uniform vec4 colorEnhanceParams;
		uniform float colorEnhanceMidtones;
		vec3 applyColorEnhance(vec3 color) {
			float maxChannel = max(color.r, max(color.g, color.b));
			float lum = dot(color, vec3(0.2126, 0.7152, 0.0722));
			if (colorEnhanceParams.x != 0.0 || colorEnhanceParams.y != 0.0) {
				float logLum = log2(max(lum, 0.001)) / 10.0 + 0.5;
				logLum = clamp(logLum, 0.0, 1.0);
				float shadowWeight = pow(1.0 - logLum, 2.0);
				float highlightWeight = pow(logLum, 2.0);
				color *= pow(2.0, colorEnhanceParams.x * shadowWeight);
				color *= pow(2.0, colorEnhanceParams.y * highlightWeight);
			}
			if (colorEnhanceMidtones != 0.0) {
				const float pivot = 0.18;
				const float widthStops = 1.25;
				const float maxStops = 2.0;
				float y = max(dot(color, vec3(0.2126, 0.7152, 0.0722)), 1e-6);
				float d = log2(y / pivot);
				float w = exp(-(d * d) / (2.0 * widthStops * widthStops));
				float stops = colorEnhanceMidtones * maxStops * w;
				color *= exp2(stops);
			}
			if (colorEnhanceParams.z != 0.0) {
				float minChannel = min(color.r, min(color.g, color.b));
				maxChannel = max(color.r, max(color.g, color.b));
				float sat = (maxChannel - minChannel) / max(maxChannel, 0.001);
				lum = dot(color, vec3(0.2126, 0.7152, 0.0722));
				float normalizedLum = lum / max(1.0, maxChannel);
				vec3 grey = vec3(normalizedLum) * maxChannel;
				float satBoost = colorEnhanceParams.z * (1.0 - sat);
				color = mix(grey, color, 1.0 + satBoost);
			}
			if (colorEnhanceParams.w != 0.0) {
				maxChannel = max(color.r, max(color.g, color.b));
				float scale = max(1.0, maxChannel);
				vec3 normalized = color / scale;
				float darkChannel = min(normalized.r, min(normalized.g, normalized.b));
				float atmosphericLight = 0.95;
				float t = 1.0 - colorEnhanceParams.w * darkChannel / atmosphericLight;
				t = max(t, 0.1);
				vec3 dehazed = (normalized - atmosphericLight) / t + atmosphericLight;
				color = dehazed * scale;
			}
			return max(vec3(0.0), color);
		}
	#endif
`;

var compose_vignette_default = `
	#ifdef VIGNETTE
		uniform vec4 vignetterParams;
		uniform vec3 vignetteColor;
		
		float dVignette;
		
		float calcVignette(vec2 uv) {
			float inner = vignetterParams.x;
			float outer = vignetterParams.y;
			float curvature = vignetterParams.z;
			float intensity = vignetterParams.w;
			vec2 curve = pow(abs(uv * 2.0 -1.0), vec2(1.0 / curvature));
			float edge = pow(length(curve), curvature);
			dVignette = 1.0 - intensity * smoothstep(inner, outer, edge);
			return dVignette;
		}
		vec3 applyVignette(vec3 color, vec2 uv) {
			return mix(vignetteColor, color, calcVignette(uv));
		}
	#endif
`;

var compose_fringing_default = `
	#ifdef FRINGING
		uniform float fringingIntensity;
		vec3 applyFringing(vec3 color, vec2 uv) {
			vec2 centerDistance = uv - 0.5;
			vec2 offset = fringingIntensity * centerDistance * centerDistance;
			color.r = texture2D(sceneTexture, uv - offset).r;
			color.b = texture2D(sceneTexture, uv + offset).b;
			return color;
		}
	#endif
`;

var compose_cas_default = `
	#ifdef CAS
		uniform float sharpness;
		#ifdef CAS_HDR
			float maxComponent(float x, float y, float z) { return max(x, max(y, z)); }
			vec3 toSDR(vec3 c) { return c / (1.0 + maxComponent(c.r, c.g, c.b)); }
			vec3 toHDR(vec3 c) { return c / max(1.0 - maxComponent(c.r, c.g, c.b), 1e-4); }
		#else
			vec3 toSDR(vec3 c) { return c; }
			vec3 toHDR(vec3 c) { return c; }
		#endif
		vec3 applyCas(vec3 color, vec2 uv, float sharpness) {
			float x = sceneTextureInvRes.x;
			float y = sceneTextureInvRes.y;
			vec3 a = toSDR(texture2DLod(sceneTexture, uv + vec2(0.0, -y), 0.0).rgb);
			vec3 b = toSDR(texture2DLod(sceneTexture, uv + vec2(-x, 0.0), 0.0).rgb);
			vec3 c = toSDR(color.rgb);
			vec3 d = toSDR(texture2DLod(sceneTexture, uv + vec2(x, 0.0), 0.0).rgb);
			vec3 e = toSDR(texture2DLod(sceneTexture, uv + vec2(0.0, y), 0.0).rgb);
			float min_g = min(a.g, min(b.g, min(c.g, min(d.g, e.g))));
			float max_g = max(a.g, max(b.g, max(c.g, max(d.g, e.g))));
			float sharpening_amount = sqrt(min(1.0 - max_g, min_g) / max(max_g, 1e-4));
			float w = sharpening_amount * sharpness;
			vec3 res = (w * (a + b + d + e) + c) / (4.0 * w + 1.0);
			res = max(res, 0.0);
			return toHDR(res);
		}
	#endif
`;

var compose_color_lut_default = `
	#ifdef COLOR_LUT
		const float COLOR_LUT_N = 16.0;
		const float COLOR_LUT_W = 256.0;
		const float COLOR_LUT_MAX = COLOR_LUT_N - 1.0;
		const float COLOR_LUT_HALF_PX_X = 0.5 / COLOR_LUT_W;
		const float COLOR_LUT_HALF_PX_Y = 0.5 / COLOR_LUT_N;
		const float COLOR_LUT_R_SCALE = COLOR_LUT_MAX / COLOR_LUT_W;
		const float COLOR_LUT_G_SCALE = COLOR_LUT_MAX / COLOR_LUT_N;
		const float COLOR_LUT_SLICE = 1.0 / COLOR_LUT_N;
		uniform vec3 colorLUTParams;
		uniform sampler2D colorLUT;
		#ifdef COLOR_LUT2
			uniform sampler2D colorLUT2;
		#endif
		vec3 sampleColorLUT(sampler2D lut, vec2 uv_l, vec2 uv_h, float t) {
			vec3 color_l = texture2DLod(lut, uv_l, 0.0).rgb;
			vec3 color_h = texture2DLod(lut, uv_h, 0.0).rgb;
			return mix(color_l, color_h, t);
		}
		vec3 applyColorLUT(vec3 color) {
			vec3 srgbCoord = pow(max(color, vec3(0.0)) + 0.0000001, vec3(1.0 / 2.2));
			vec3 c = clamp(srgbCoord, 0.0, 1.0);
			float cell = c.b * COLOR_LUT_MAX;
			float cell_l = floor(cell);
			float cell_h = ceil(cell);
			float t = fract(cell);
			float r_offset = COLOR_LUT_HALF_PX_X + c.r * COLOR_LUT_R_SCALE;
			float g_offset = COLOR_LUT_HALF_PX_Y + c.g * COLOR_LUT_G_SCALE;
			vec2 uv_l = vec2(cell_l * COLOR_LUT_SLICE + r_offset, g_offset);
			vec2 uv_h = vec2(cell_h * COLOR_LUT_SLICE + r_offset, g_offset);
			vec3 lut1 = sampleColorLUT(colorLUT, uv_l, uv_h, t);
			#ifdef COLOR_LUT2
				vec3 lut2 = sampleColorLUT(colorLUT2, uv_l, uv_h, t);
				float w1 = colorLUTParams.x * (1.0 - colorLUTParams.z);
				float w2 = colorLUTParams.y * colorLUTParams.z;
				return color + (lut1 - color) * w1 + (lut2 - color) * w2;
			#else
				return mix(color, lut1, colorLUTParams.x);
			#endif
		}
	#endif
`;

var composeChunksGLSL = {
	composePS: compose_default,
	composeBloomPS: compose_bloom_default,
	composeDofPS: compose_dof_default,
	composeSsaoPS: compose_ssao_default,
	composeGradingPS: compose_grading_default,
	composeColorEnhancePS: compose_color_enhance_default,
	composeVignettePS: compose_vignette_default,
	composeFringingPS: compose_fringing_default,
	composeCasPS: compose_cas_default,
	composeColorLutPS: compose_color_lut_default,
	// empty chunks for user customizations
	composeDeclarationsPS: "",
	composeMainStartPS: "",
	composeMainEndPS: ""
};

var compose_default2 = `
	#include "tonemappingPS"
	#include "gammaPS"
	varying uv0: vec2f;
	var sceneTexture: texture_2d<f32>;
	var sceneTextureSampler: sampler;
	uniform sceneTextureInvRes: vec2f;
	#include "composeBloomPS"
	#include "composeDofPS"
	#include "composeSsaoPS"
	#include "composeGradingPS"
	#include "composeColorEnhancePS"
	#include "composeVignettePS"
	#include "composeFringingPS"
	#include "composeCasPS"
	#include "composeColorLutPS"
	#include "composeDeclarationsPS"
	@fragment
	fn fragmentMain(input: FragmentInput) -> FragmentOutput {
		#include "composeMainStartPS"
		var output: FragmentOutput;
		var uv = uv0;
		let scene = textureSampleLevel(sceneTexture, sceneTextureSampler, uv, 0.0);
		var result = scene.rgb;
		#ifdef CAS
			result = applyCas(result, uv, uniform.sharpness);
		#endif
		#ifdef DOF
			result = applyDof(result, uv0);
		#endif
		#ifdef SSAO_TEXTURE
			result = applySsao(result, uv0);
		#endif
		#ifdef FRINGING
			result = applyFringing(result, uv);
		#endif
		#ifdef BLOOM
			result = applyBloom(result, uv0);
		#endif
		#ifdef COLOR_ENHANCE
			result = applyColorEnhance(result);
		#endif
		#ifdef GRADING
			result = applyGrading(result);
		#endif
		result = toneMap(max(vec3f(0.0), result));
		#ifdef COLOR_LUT
			result = applyColorLUT(result);
		#endif
		#ifdef VIGNETTE
			result = applyVignette(result, uv);
		#endif
		#include "composeMainEndPS"
		#ifdef DEBUG_COMPOSE
			#if DEBUG_COMPOSE == scene
				result = scene.rgb;
			#elif defined(BLOOM) && DEBUG_COMPOSE == bloom
				result = dBloom * uniform.bloomIntensity;
			#elif defined(DOF) && DEBUG_COMPOSE == dofcoc
				result = vec3f(dCoc, 0.0);
			#elif defined(DOF) && DEBUG_COMPOSE == dofblur
				result = dBlur;
			#elif defined(SSAO_TEXTURE) && DEBUG_COMPOSE == ssao
				result = vec3f(dSsao);
			#elif defined(VIGNETTE) && DEBUG_COMPOSE == vignette
				result = vec3f(dVignette);
			#endif
		#endif
		result = gammaCorrectOutput(result);
		output.color = vec4f(result, scene.a);
		return output;
	}
`;

var compose_bloom_default2 = `
	#ifdef BLOOM
		var bloomTexture: texture_2d<f32>;
		var bloomTextureSampler: sampler;
		uniform bloomIntensity: f32;
		
		var<private> dBloom: vec3f;
		
		fn applyBloom(color: vec3f, uv: vec2f) -> vec3f {
			dBloom = textureSampleLevel(bloomTexture, bloomTextureSampler, uv, 0.0).rgb;
			return color + dBloom * uniform.bloomIntensity;
		}
	#endif
`;

var compose_dof_default2 = `
	#ifdef DOF
		var cocTexture: texture_2d<f32>;
		var cocTextureSampler: sampler;
		var blurTexture: texture_2d<f32>;
		var blurTextureSampler: sampler;
		
		var<private> dCoc: vec2f;
		var<private> dBlur: vec3f;
		fn getDofBlur(uv: vec2f) -> vec3f {
			dCoc = textureSampleLevel(cocTexture, cocTextureSampler, uv, 0.0).rg;
			#if DOF_UPSCALE
				let blurTexelSize = 1.0 / vec2f(textureDimensions(blurTexture, 0));
				var bilinearBlur = vec3f(0.0);
				var totalWeight = 0.0;
				for (var i = -1; i <= 1; i++) {
					for (var j = -1; j <= 1; j++) {
						let offset = vec2f(f32(i), f32(j)) * blurTexelSize;
						let cocSample = textureSampleLevel(cocTexture, cocTextureSampler, uv + offset, 0.0).rg;
						let blurSample = textureSampleLevel(blurTexture, blurTextureSampler, uv + offset, 0.0).rgb;
						let cocWeight = clamp(cocSample.r + cocSample.g, 0.0, 1.0);
						bilinearBlur += blurSample * cocWeight;
						totalWeight += cocWeight;
					}
				}
				if (totalWeight > 0.0) {
					bilinearBlur /= totalWeight;
				}
				dBlur = bilinearBlur;
				return bilinearBlur;
			#else
				dBlur = textureSampleLevel(blurTexture, blurTextureSampler, uv, 0.0).rgb;
				return dBlur;
			#endif
		}
		fn applyDof(color: vec3f, uv: vec2f) -> vec3f {
			let blur = getDofBlur(uv);
			return mix(color, blur, dCoc.r + dCoc.g);
		}
	#endif
`;

var compose_ssao_default2 = `
	#ifdef SSAO
		#define SSAO_TEXTURE
	#endif
	#if DEBUG_COMPOSE == ssao
		#define SSAO_TEXTURE
	#endif
	#ifdef SSAO_TEXTURE
		var ssaoTexture: texture_2d<f32>;
		var ssaoTextureSampler: sampler;
		
		var<private> dSsao: f32;
		
		fn applySsao(color: vec3f, uv: vec2f) -> vec3f {
			dSsao = textureSampleLevel(ssaoTexture, ssaoTextureSampler, uv, 0.0).r;
			
			#ifdef SSAO
				return color * dSsao;
			#else
				return color;
			#endif
		}
	#endif
`;

var compose_grading_default2 = `
	#ifdef GRADING
		uniform brightnessContrastSaturation: vec3f;
		uniform tint: vec3f;
		fn colorGradingHDR(color: vec3f, brt: f32, sat: f32, con: f32) -> vec3f {
			var colorOut = color * uniform.tint;
			colorOut = colorOut * brt;
			let grey = dot(colorOut, vec3f(0.3, 0.59, 0.11));
			let normalizedGrey = grey / max(1.0, max(colorOut.r, max(colorOut.g, colorOut.b)));
			colorOut = mix(vec3f(normalizedGrey), colorOut, sat);
			return mix(vec3f(0.5), colorOut, con);
		}
		fn applyGrading(color: vec3f) -> vec3f {
			return colorGradingHDR(color, 
				uniform.brightnessContrastSaturation.x, 
				uniform.brightnessContrastSaturation.z, 
				uniform.brightnessContrastSaturation.y);
		}
	#endif
`;

var compose_color_enhance_default2 = `
	#ifdef COLOR_ENHANCE
		uniform colorEnhanceParams: vec4f;
		uniform colorEnhanceMidtones: f32;
		fn applyColorEnhance(color: vec3f) -> vec3f {
			var colorOut = color;
			var maxChannel = max(colorOut.r, max(colorOut.g, colorOut.b));
			var lum = dot(colorOut, vec3f(0.2126, 0.7152, 0.0722));
			if (uniform.colorEnhanceParams.x != 0.0 || uniform.colorEnhanceParams.y != 0.0) {
				var logLum = log2(max(lum, 0.001)) / 10.0 + 0.5;
				logLum = clamp(logLum, 0.0, 1.0);
				let shadowWeight = pow(1.0 - logLum, 2.0);
				let highlightWeight = pow(logLum, 2.0);
				colorOut *= pow(2.0, uniform.colorEnhanceParams.x * shadowWeight);
				colorOut *= pow(2.0, uniform.colorEnhanceParams.y * highlightWeight);
			}
			if (uniform.colorEnhanceMidtones != 0.0) {
				let pivot = 0.18;
				let widthStops = 1.25;
				let maxStops = 2.0;
				let y = max(dot(colorOut, vec3f(0.2126, 0.7152, 0.0722)), 1e-6);
				let d = log2(y / pivot);
				let w = exp(-(d * d) / (2.0 * widthStops * widthStops));
				let stops = uniform.colorEnhanceMidtones * maxStops * w;
				colorOut *= exp2(stops);
			}
			if (uniform.colorEnhanceParams.z != 0.0) {
				let minChannel = min(colorOut.r, min(colorOut.g, colorOut.b));
				maxChannel = max(colorOut.r, max(colorOut.g, colorOut.b));
				let sat = (maxChannel - minChannel) / max(maxChannel, 0.001);
				lum = dot(colorOut, vec3f(0.2126, 0.7152, 0.0722));
				let normalizedLum = lum / max(1.0, maxChannel);
				let grey = vec3f(normalizedLum) * maxChannel;
				let satBoost = uniform.colorEnhanceParams.z * (1.0 - sat);
				colorOut = mix(grey, colorOut, 1.0 + satBoost);
			}
			if (uniform.colorEnhanceParams.w != 0.0) {
				maxChannel = max(colorOut.r, max(colorOut.g, colorOut.b));
				let scale = max(1.0, maxChannel);
				let normalized = colorOut / scale;
				let darkChannel = min(normalized.r, min(normalized.g, normalized.b));
				let atmosphericLight = 0.95;
				var t = 1.0 - uniform.colorEnhanceParams.w * darkChannel / atmosphericLight;
				t = max(t, 0.1);
				let dehazed = (normalized - atmosphericLight) / t + atmosphericLight;
				colorOut = dehazed * scale;
			}
			return max(vec3f(0.0), colorOut);
		}
	#endif
`;

var compose_vignette_default2 = `
	#ifdef VIGNETTE
		uniform vignetterParams: vec4f;
		uniform vignetteColor: vec3f;
		
		var<private> dVignette: f32;
		
		fn calcVignette(uv: vec2f) -> f32 {
			let inner = uniform.vignetterParams.x;
			let outer = uniform.vignetterParams.y;
			let curvature = uniform.vignetterParams.z;
			let intensity = uniform.vignetterParams.w;
			let curve = pow(abs(uv * 2.0 - 1.0), vec2f(1.0 / curvature));
			let edge = pow(length(curve), curvature);
			dVignette = 1.0 - intensity * smoothstep(inner, outer, edge);
			return dVignette;
		}
		fn applyVignette(color: vec3f, uv: vec2f) -> vec3f {
			return mix(uniform.vignetteColor, color, calcVignette(uv));
		}
	#endif
`;

var compose_fringing_default2 = `
	#ifdef FRINGING
		uniform fringingIntensity: f32;
		fn applyFringing(color: vec3f, uv: vec2f) -> vec3f {
			let centerDistance = uv - 0.5;
			let offset = uniform.fringingIntensity * centerDistance * centerDistance;
			var colorOut = color;
			colorOut.r = textureSample(sceneTexture, sceneTextureSampler, uv - offset).r;
			colorOut.b = textureSample(sceneTexture, sceneTextureSampler, uv + offset).b;
			return colorOut;
		}
	#endif
`;

var compose_cas_default2 = `
	#ifdef CAS
		uniform sharpness: f32;
		#ifdef CAS_HDR
			fn maxComponent(x: f32, y: f32, z: f32) -> f32 { return max(x, max(y, z)); }
			fn toSDR(c: vec3f) -> vec3f { return c / (1.0 + maxComponent(c.r, c.g, c.b)); }
			fn toHDR(c: vec3f) -> vec3f { return c / max(1.0 - maxComponent(c.r, c.g, c.b), 1e-4); }
		#else
			fn toSDR(c: vec3f) -> vec3f { return c; }
			fn toHDR(c: vec3f) -> vec3f { return c; }
		#endif
		fn applyCas(color: vec3f, uv: vec2f, sharpness: f32) -> vec3f {
			let x = uniform.sceneTextureInvRes.x;
			let y = uniform.sceneTextureInvRes.y;
			let a: half3 = half3(toSDR(textureSampleLevel(sceneTexture, sceneTextureSampler, uv + vec2f(0.0, -y), 0.0).rgb));
			let b: half3 = half3(toSDR(textureSampleLevel(sceneTexture, sceneTextureSampler, uv + vec2f(-x, 0.0), 0.0).rgb));
			let c: half3 = half3(toSDR(color.rgb));
			let d: half3 = half3(toSDR(textureSampleLevel(sceneTexture, sceneTextureSampler, uv + vec2f(x, 0.0), 0.0).rgb));
			let e: half3 = half3(toSDR(textureSampleLevel(sceneTexture, sceneTextureSampler, uv + vec2f(0.0, y), 0.0).rgb));
			let min_g = min(a.g, min(b.g, min(c.g, min(d.g, e.g))));
			let max_g = max(a.g, max(b.g, max(c.g, max(d.g, e.g))));
			let sharpening_amount = sqrt(min(half(1.0) - max_g, min_g) / max(max_g, half(1e-4)));
			let w = sharpening_amount * half(sharpness);
			var res = (w * (a + b + d + e) + c) / (half(4.0) * w + half(1.0));
			res = max(res, half3(0.0));
			return toHDR(vec3f(res));
		}
	#endif
`;

var compose_color_lut_default2 = `
	#ifdef COLOR_LUT
		const COLOR_LUT_N: f32 = 16.0;
		const COLOR_LUT_W: f32 = 256.0;
		const COLOR_LUT_MAX: f32 = COLOR_LUT_N - 1.0;
		const COLOR_LUT_HALF_PX_X: f32 = 0.5 / COLOR_LUT_W;
		const COLOR_LUT_HALF_PX_Y: f32 = 0.5 / COLOR_LUT_N;
		const COLOR_LUT_R_SCALE: f32 = COLOR_LUT_MAX / COLOR_LUT_W;
		const COLOR_LUT_G_SCALE: f32 = COLOR_LUT_MAX / COLOR_LUT_N;
		const COLOR_LUT_SLICE: f32 = 1.0 / COLOR_LUT_N;
		uniform colorLUTParams: vec3f;
		var colorLUT: texture_2d<f32>;
		var colorLUTSampler: sampler;
		#ifdef COLOR_LUT2
			var colorLUT2: texture_2d<f32>;
			var colorLUT2Sampler: sampler;
		#endif
		fn sampleColorLUT(lut: texture_2d<f32>, lutSampler: sampler, uv_l: vec2f, uv_h: vec2f, t: f32) -> vec3f {
			let color_l: vec3f = textureSampleLevel(lut, lutSampler, uv_l, 0.0).rgb;
			let color_h: vec3f = textureSampleLevel(lut, lutSampler, uv_h, 0.0).rgb;
			return mix(color_l, color_h, vec3f(t));
		}
		fn applyColorLUT(color: vec3f) -> vec3f {
			let srgbCoord: vec3f = pow(max(color, vec3f(0.0)) + vec3f(0.0000001), vec3f(1.0 / 2.2));
			let c: vec3f = clamp(srgbCoord, vec3f(0.0), vec3f(1.0));
			let cell: f32 = c.b * COLOR_LUT_MAX;
			let cell_l: f32 = floor(cell);
			let cell_h: f32 = ceil(cell);
			let t: f32 = fract(cell);
			let r_offset: f32 = COLOR_LUT_HALF_PX_X + c.r * COLOR_LUT_R_SCALE;
			let g_offset: f32 = COLOR_LUT_HALF_PX_Y + c.g * COLOR_LUT_G_SCALE;
			let uv_l: vec2f = vec2f(cell_l * COLOR_LUT_SLICE + r_offset, g_offset);
			let uv_h: vec2f = vec2f(cell_h * COLOR_LUT_SLICE + r_offset, g_offset);
			let lut1: vec3f = sampleColorLUT(colorLUT, colorLUTSampler, uv_l, uv_h, t);
			#ifdef COLOR_LUT2
				let lut2: vec3f = sampleColorLUT(colorLUT2, colorLUT2Sampler, uv_l, uv_h, t);
				let w1: f32 = uniform.colorLUTParams.x * (1.0 - uniform.colorLUTParams.z);
				let w2: f32 = uniform.colorLUTParams.y * uniform.colorLUTParams.z;
				return color + (lut1 - color) * w1 + (lut2 - color) * w2;
			#else
				return mix(color, lut1, vec3f(uniform.colorLUTParams.x));
			#endif
		}
	#endif
`;

var composeChunksWGSL = {
	composePS: compose_default2,
	composeBloomPS: compose_bloom_default2,
	composeDofPS: compose_dof_default2,
	composeSsaoPS: compose_ssao_default2,
	composeGradingPS: compose_grading_default2,
	composeColorEnhancePS: compose_color_enhance_default2,
	composeVignettePS: compose_vignette_default2,
	composeFringingPS: compose_fringing_default2,
	composeCasPS: compose_cas_default2,
	composeColorLutPS: compose_color_lut_default2,
	// empty chunks for user customizations
	composeDeclarationsPS: "",
	composeMainStartPS: "",
	composeMainEndPS: ""
};

var RenderPassCompose = class extends RenderPassShaderQuad {
	sceneTexture = null;
	bloomIntensity = 0.01;
	_bloomTexture = null;
	_cocTexture = null;
	blurTexture = null;
	blurTextureUpscale = false;
	_ssaoTexture = null;
	_toneMapping = TONEMAP_LINEAR;
	_gradingEnabled = false;
	gradingSaturation = 1;
	gradingContrast = 1;
	gradingBrightness = 1;
	gradingTint = new Color(1, 1, 1, 1);
	_shaderDirty = true;
	_vignetteEnabled = false;
	vignetteInner = 0.5;
	vignetteOuter = 1;
	vignetteCurvature = 0.5;
	vignetteIntensity = 0.3;
	vignetteColor = new Color(0, 0, 0);
	_fringingEnabled = false;
	fringingIntensity = 10;
	_colorEnhanceEnabled = false;
	colorEnhanceShadows = 0;
	colorEnhanceHighlights = 0;
	colorEnhanceVibrance = 0;
	colorEnhanceDehaze = 0;
	colorEnhanceMidtones = 0;
	_taaEnabled = false;
	_hdrScene = true;
	_sharpness = 0.5;
	_gammaCorrection = GAMMA_SRGB;
	_colorLUT = null;
	_colorLUT2 = null;
	colorLUTIntensity = 1;
	colorLUT2Intensity = 1;
	colorLUTBlend = 0;
	_key = "";
	_debug = null;
	// track user-provided custom compose chunks
	_customComposeChunks = /* @__PURE__ */ new Map([
		["composeDeclarationsPS", ""],
		["composeMainStartPS", ""],
		["composeMainEndPS", ""]
	]);
	constructor(graphicsDevice) {
		super(graphicsDevice);
		ShaderChunks.get(graphicsDevice, SHADERLANGUAGE_GLSL).add(composeChunksGLSL, false);
		ShaderChunks.get(graphicsDevice, SHADERLANGUAGE_WGSL).add(composeChunksWGSL, false);
		const { scope } = graphicsDevice;
		this.sceneTextureId = scope.resolve("sceneTexture");
		this.bloomTextureId = scope.resolve("bloomTexture");
		this.cocTextureId = scope.resolve("cocTexture");
		this.ssaoTextureId = scope.resolve("ssaoTexture");
		this.blurTextureId = scope.resolve("blurTexture");
		this.bloomIntensityId = scope.resolve("bloomIntensity");
		this.bcsId = scope.resolve("brightnessContrastSaturation");
		this.tintId = scope.resolve("tint");
		this.vignetterParamsId = scope.resolve("vignetterParams");
		this.vignetteColorId = scope.resolve("vignetteColor");
		this.fringingIntensityId = scope.resolve("fringingIntensity");
		this.sceneTextureInvResId = scope.resolve("sceneTextureInvRes");
		this.sceneTextureInvResValue = new Float32Array(2);
		this.sharpnessId = scope.resolve("sharpness");
		this.colorLUTId = scope.resolve("colorLUT");
		this.colorLUT2Id = scope.resolve("colorLUT2");
		this.colorLUTParams = new Float32Array(3);
		this.colorLUTParamsId = scope.resolve("colorLUTParams");
		this.colorEnhanceParamsId = scope.resolve("colorEnhanceParams");
		this.colorEnhanceMidtonesId = scope.resolve("colorEnhanceMidtones");
	}
	set debug(value) {
		if (this._debug !== value) {
			this._debug = value;
			this._shaderDirty = true;
		}
	}
	get debug() {
		return this._debug;
	}
	set colorLUT(value) {
		if (this._colorLUT !== value) {
			this._colorLUT = value;
			this._shaderDirty = true;
			this._validateColorLUT(value, "colorLUT");
		}
	}
	get colorLUT() {
		return this._colorLUT;
	}
	set colorLUT2(value) {
		if (this._colorLUT2 !== value) {
			this._colorLUT2 = value;
			this._shaderDirty = true;
			this._validateColorLUT(value, "colorLUT2");
		}
	}
	get colorLUT2() {
		return this._colorLUT2;
	}
	// Validate that a LUT texture is configured as a 256x16 sRGB strip with no mipmaps and
	// linear filtering. Stripped in release builds.
	_validateColorLUT(value, slotName) {
	}
	set bloomTexture(value) {
		if (this._bloomTexture !== value) {
			this._bloomTexture = value;
			this._shaderDirty = true;
		}
	}
	get bloomTexture() {
		return this._bloomTexture;
	}
	set cocTexture(value) {
		if (this._cocTexture !== value) {
			this._cocTexture = value;
			this._shaderDirty = true;
		}
	}
	get cocTexture() {
		return this._cocTexture;
	}
	set ssaoTexture(value) {
		if (this._ssaoTexture !== value) {
			this._ssaoTexture = value;
			this._shaderDirty = true;
		}
	}
	get ssaoTexture() {
		return this._ssaoTexture;
	}
	set taaEnabled(value) {
		if (this._taaEnabled !== value) {
			this._taaEnabled = value;
			this._shaderDirty = true;
		}
	}
	get taaEnabled() {
		return this._taaEnabled;
	}
	set gradingEnabled(value) {
		if (this._gradingEnabled !== value) {
			this._gradingEnabled = value;
			this._shaderDirty = true;
		}
	}
	get gradingEnabled() {
		return this._gradingEnabled;
	}
	set vignetteEnabled(value) {
		if (this._vignetteEnabled !== value) {
			this._vignetteEnabled = value;
			this._shaderDirty = true;
		}
	}
	get vignetteEnabled() {
		return this._vignetteEnabled;
	}
	set fringingEnabled(value) {
		if (this._fringingEnabled !== value) {
			this._fringingEnabled = value;
			this._shaderDirty = true;
		}
	}
	get fringingEnabled() {
		return this._fringingEnabled;
	}
	set colorEnhanceEnabled(value) {
		if (this._colorEnhanceEnabled !== value) {
			this._colorEnhanceEnabled = value;
			this._shaderDirty = true;
		}
	}
	get colorEnhanceEnabled() {
		return this._colorEnhanceEnabled;
	}
	set toneMapping(value) {
		if (this._toneMapping !== value) {
			this._toneMapping = value;
			this._shaderDirty = true;
		}
	}
	get toneMapping() {
		return this._toneMapping;
	}
	set sharpness(value) {
		if (this._sharpness !== value) {
			this._sharpness = value;
			this._shaderDirty = true;
		}
	}
	get sharpness() {
		return this._sharpness;
	}
	get isSharpnessEnabled() {
		return this._sharpness > 0;
	}
	set hdrScene(value) {
		if (this._hdrScene !== value) {
			this._hdrScene = value;
			this._shaderDirty = true;
		}
	}
	get hdrScene() {
		return this._hdrScene;
	}
	postInit() {
		this.setClearColor(Color.BLACK);
		this.setClearDepth(1);
		this.setClearStencil(0);
	}
	frameUpdate() {
		const rt = this.renderTarget ?? this.device.backBuffer;
		const srgb = rt.isColorBufferSrgb(0);
		const neededGammaCorrection = srgb ? GAMMA_NONE : GAMMA_SRGB;
		if (this._gammaCorrection !== neededGammaCorrection) {
			this._gammaCorrection = neededGammaCorrection;
			this._shaderDirty = true;
		}
		const shaderChunks2 = ShaderChunks.get(this.device, this.device.isWebGPU ? SHADERLANGUAGE_WGSL : SHADERLANGUAGE_GLSL);
		for (const [name, prevValue] of this._customComposeChunks.entries()) {
			const currentValue = shaderChunks2.get(name);
			if (currentValue !== prevValue) {
				this._customComposeChunks.set(name, currentValue);
				this._shaderDirty = true;
			}
		}
		if (this._shaderDirty) {
			this._shaderDirty = false;
			const gammaCorrectionName = gammaNames[this._gammaCorrection];
			const customChunks = this._customComposeChunks;
			const declHash = hashCode(customChunks.get("composeDeclarationsPS") ?? "");
			const startHash = hashCode(customChunks.get("composeMainStartPS") ?? "");
			const endHash = hashCode(customChunks.get("composeMainEndPS") ?? "");
			const key = `${this.toneMapping}-${gammaCorrectionName}-${this.bloomTexture ? "bloom" : "nobloom"}-${this.cocTexture ? "dof" : "nodof"}-${this.blurTextureUpscale ? "dofupscale" : ""}-${this.ssaoTexture ? "ssao" : "nossao"}-${this.gradingEnabled ? "grading" : "nograding"}-${this.colorEnhanceEnabled ? "colorenhance" : "nocolorenhance"}-${this.colorLUT ? "colorlut" : "nocolorlut"}-${this.colorLUT2 ? "colorlut2" : "nocolorlut2"}-${this.vignetteEnabled ? "vignette" : "novignette"}-${this.fringingEnabled ? "fringing" : "nofringing"}-${this.taaEnabled ? "taa" : "notaa"}-${this.isSharpnessEnabled ? this._hdrScene ? "cashdr" : "cas" : "nocas"}-${this._debug ?? ""}-decl${declHash}-start${startHash}-end${endHash}`;
			if (this._key !== key) {
				this._key = key;
				const defines = /* @__PURE__ */ new Map();
				defines.set("TONEMAP", tonemapNames[this.toneMapping]);
				defines.set("GAMMA", gammaCorrectionName);
				if (this.bloomTexture) defines.set("BLOOM", true);
				if (this.cocTexture) defines.set("DOF", true);
				if (this.blurTextureUpscale) defines.set("DOF_UPSCALE", true);
				if (this.ssaoTexture) defines.set("SSAO", true);
				if (this.gradingEnabled) defines.set("GRADING", true);
				if (this.colorEnhanceEnabled) defines.set("COLOR_ENHANCE", true);
				if (this.colorLUT) defines.set("COLOR_LUT", true);
				if (this.colorLUT && this.colorLUT2) defines.set("COLOR_LUT2", true);
				if (this.vignetteEnabled) defines.set("VIGNETTE", true);
				if (this.fringingEnabled) defines.set("FRINGING", true);
				if (this.taaEnabled) defines.set("TAA", true);
				if (this.isSharpnessEnabled) {
					defines.set("CAS", true);
					if (this._hdrScene) defines.set("CAS_HDR", true);
				}
				if (this._debug) defines.set("DEBUG_COMPOSE", this._debug);
				this.shader = ShaderUtils.createShader(this.device, {
					uniqueName: `ComposeShader-${key}`,
					attributes: { aPosition: SEMANTIC_POSITION },
					vertexChunk: "quadVS",
					fragmentChunk: "composePS",
					fragmentDefines: defines
				});
			}
		}
	}
	execute() {
		const sceneTex = this.sceneTexture;
		this.sceneTextureId.setValue(sceneTex);
		this.sceneTextureInvResValue[0] = 1 / sceneTex.width;
		this.sceneTextureInvResValue[1] = 1 / sceneTex.height;
		this.sceneTextureInvResId.setValue(this.sceneTextureInvResValue);
		if (this._bloomTexture) {
			this.bloomTextureId.setValue(this._bloomTexture);
			this.bloomIntensityId.setValue(this.bloomIntensity);
		}
		if (this._cocTexture) {
			this.cocTextureId.setValue(this._cocTexture);
			this.blurTextureId.setValue(this.blurTexture);
		}
		if (this._ssaoTexture) {
			this.ssaoTextureId.setValue(this._ssaoTexture);
		}
		if (this._gradingEnabled) {
			this.bcsId.setValue([this.gradingBrightness, this.gradingContrast, this.gradingSaturation]);
			this.tintId.setValue([this.gradingTint.r, this.gradingTint.g, this.gradingTint.b]);
		}
		if (this._colorEnhanceEnabled) {
			this.colorEnhanceParamsId.setValue([this.colorEnhanceShadows, this.colorEnhanceHighlights, this.colorEnhanceVibrance, this.colorEnhanceDehaze]);
			this.colorEnhanceMidtonesId.setValue(this.colorEnhanceMidtones);
		}
		const lutTexture = this._colorLUT;
		if (lutTexture) {
			this.colorLUTParams[0] = this.colorLUTIntensity;
			this.colorLUTParams[1] = this.colorLUT2Intensity;
			this.colorLUTParams[2] = this.colorLUTBlend;
			this.colorLUTParamsId.setValue(this.colorLUTParams);
			this.colorLUTId.setValue(lutTexture);
			if (this._colorLUT2) {
				this.colorLUT2Id.setValue(this._colorLUT2);
			}
		}
		if (this._vignetteEnabled) {
			this.vignetterParamsId.setValue([this.vignetteInner, this.vignetteOuter, this.vignetteCurvature, this.vignetteIntensity]);
			this.vignetteColorId.setValue([this.vignetteColor.r, this.vignetteColor.g, this.vignetteColor.b]);
		}
		if (this._fringingEnabled) {
			this.fringingIntensityId.setValue(this.fringingIntensity / 1024);
		}
		if (this.isSharpnessEnabled) {
			this.sharpnessId.setValue(math.lerp(-0.125, -0.2, this.sharpness));
		}
		super.execute();
	}
};

var sampleCatmullRom_default = `
vec4 SampleTextureCatmullRom(TEXTURE_ACCEPT(tex), vec2 uv, vec2 texSize) {
	vec2 samplePos = uv * texSize;
	vec2 texPos1 = floor(samplePos - 0.5) + 0.5;
	vec2 f = samplePos - texPos1;
	vec2 w0 = f * (-0.5 + f * (1.0 - 0.5 * f));
	vec2 w1 = 1.0 + f * f * (-2.5 + 1.5 * f);
	vec2 w2 = f * (0.5 + f * (2.0 - 1.5 * f));
	vec2 w3 = f * f * (-0.5 + 0.5 * f);
	vec2 w12 = w1 + w2;
	vec2 offset12 = w2 / (w1 + w2);
	vec2 texPos0 = (texPos1 - 1.0) / texSize;
	vec2 texPos3 = (texPos1 + 2.0) / texSize;
	vec2 texPos12 = (texPos1 + offset12) / texSize;
	vec4 result = vec4(0.0);
	result += texture2DLod(tex, vec2(texPos0.x, texPos0.y), 0.0) * w0.x * w0.y;
	result += texture2DLod(tex, vec2(texPos12.x, texPos0.y), 0.0) * w12.x * w0.y;
	result += texture2DLod(tex, vec2(texPos3.x, texPos0.y), 0.0) * w3.x * w0.y;
	result += texture2DLod(tex, vec2(texPos0.x, texPos12.y), 0.0) * w0.x * w12.y;
	result += texture2DLod(tex, vec2(texPos12.x, texPos12.y), 0.0) * w12.x * w12.y;
	result += texture2DLod(tex, vec2(texPos3.x, texPos12.y), 0.0) * w3.x * w12.y;
	result += texture2DLod(tex, vec2(texPos0.x, texPos3.y), 0.0) * w0.x * w3.y;
	result += texture2DLod(tex, vec2(texPos12.x, texPos3.y), 0.0) * w12.x * w3.y;
	result += texture2DLod(tex, vec2(texPos3.x, texPos3.y), 0.0) * w3.x * w3.y;
	return result;
}
`;

var sampleCatmullRom_default2 = `
fn SampleTextureCatmullRom(tex: texture_2d<f32>, texSampler: sampler, uv: vec2f, texSize: vec2f) -> vec4f {
	let samplePos: vec2f = uv * texSize;
	let texPos1: vec2f = floor(samplePos - 0.5) + 0.5;
	let f: vec2f = samplePos - texPos1;
	let w0: vec2f = f * (-0.5 + f * (1.0 - 0.5 * f));
	let w1: vec2f = 1.0 + f * f * (-2.5 + 1.5 * f);
	let w2: vec2f = f * (0.5 + f * (2.0 - 1.5 * f));
	let w3: vec2f = f * f * (-0.5 + 0.5 * f);
	let w12: vec2f = w1 + w2;
	let offset12: vec2f = w2 / w12;
	let texPos0: vec2f = (texPos1 - 1.0) / texSize;
	let texPos3: vec2f = (texPos1 + 2.0) / texSize;
	let texPos12: vec2f = (texPos1 + offset12) / texSize;
	var result: vec4f = vec4f(0.0);
	result = result + textureSampleLevel(tex, texSampler, vec2f(texPos0.x, texPos0.y), 0.0) * w0.x * w0.y;
	result = result + textureSampleLevel(tex, texSampler, vec2f(texPos12.x, texPos0.y), 0.0) * w12.x * w0.y;
	result = result + textureSampleLevel(tex, texSampler, vec2f(texPos3.x, texPos0.y), 0.0) * w3.x * w0.y;
	result = result + textureSampleLevel(tex, texSampler, vec2f(texPos0.x, texPos12.y), 0.0) * w0.x * w12.y;
	result = result + textureSampleLevel(tex, texSampler, vec2f(texPos12.x, texPos12.y), 0.0) * w12.x * w12.y;
	result = result + textureSampleLevel(tex, texSampler, vec2f(texPos3.x, texPos12.y), 0.0) * w3.x * w12.y;
	result = result + textureSampleLevel(tex, texSampler, vec2f(texPos0.x, texPos3.y), 0.0) * w0.x * w3.y;
	result = result + textureSampleLevel(tex, texSampler, vec2f(texPos12.x, texPos3.y), 0.0) * w12.x * w3.y;
	result = result + textureSampleLevel(tex, texSampler, vec2f(texPos3.x, texPos3.y), 0.0) * w3.x * w3.y;
	return result;
}
`;

var taaResolve_default = `
	#include  "sampleCatmullRomPS"
	#include  "screenDepthPS"
	uniform sampler2D sourceTexture;
	uniform sampler2D historyTexture;
	uniform mat4 matrix_viewProjectionPrevious;
	uniform mat4 matrix_viewProjectionInverse;
	uniform vec4 jitters;
	uniform vec2 textureSize;
	varying vec2 uv0;
	vec2 reproject(vec2 uv, float depth) {
		depth = depth * 2.0 - 1.0;
		vec4 ndc = vec4(uv * 2.0 - 1.0, depth, 1.0);
		ndc.xy -= jitters.xy;
		vec4 worldPosition = matrix_viewProjectionInverse * ndc;
		worldPosition /= worldPosition.w;
		vec4 screenPrevious = matrix_viewProjectionPrevious * worldPosition;
		return (screenPrevious.xy / screenPrevious.w) * 0.5 + 0.5;
	}
	vec3 colorClampPremul(vec2 uv, vec3 historyPremul) {
		vec3 minPremul = vec3(9999.0);
		vec3 maxPremul = vec3(-9999.0);
		for(float x = -1.0; x <= 1.0; ++x) {
			for(float y = -1.0; y <= 1.0; ++y) {
				vec4 s = texture2D(sourceTexture, uv + vec2(x, y) / textureSize);
				vec3 premul = s.rgb * s.a;
				minPremul = min(minPremul, premul);
				maxPremul = max(maxPremul, premul);
			}
		}
		return clamp(historyPremul, minPremul, maxPremul);
	}
	void main()
	{
		vec4 srcColor = texture2D(sourceTexture, uv0);
		float linearDepth = getLinearScreenDepth(uv0);
		float depth = delinearizeDepth(linearDepth);
		vec2 historyUv = reproject(uv0, depth);
		#ifdef QUALITY_HIGH
			vec4 historySample = SampleTextureCatmullRom(TEXTURE_PASS(historyTexture), historyUv, textureSize);
		#else
			vec4 historySample = texture2D(historyTexture, historyUv);
		#endif
		vec3 historyPremul = historySample.rgb * historySample.a;
		vec3 srcPremul = srcColor.rgb * srcColor.a;
		vec3 historyPremulClamped = colorClampPremul(uv0, historyPremul);
		float mixFactor = (historyUv.x < 0.0 || historyUv.x > 1.0 || historyUv.y < 0.0 || historyUv.y > 1.0) ?
			1.0 : 0.05;
		vec3 mixedPremul = mix(historyPremulClamped, srcPremul, mixFactor);
		float a = srcColor.a;
		const float UNPREMUL_EPS = 1.0 / 255.0;
		vec3 rgbStraight = (a > UNPREMUL_EPS) ? (mixedPremul / a) : srcColor.rgb;
		gl_FragColor = vec4(rgbStraight, a);
	}
`;

var taaResolve_default2 = `
	#include "sampleCatmullRomPS"
	#include "screenDepthPS"
	var sourceTexture: texture_2d<f32>;
	var sourceTextureSampler: sampler;
	var historyTexture: texture_2d<f32>;
	var historyTextureSampler: sampler;
	uniform matrix_viewProjectionPrevious: mat4x4f;
	uniform matrix_viewProjectionInverse: mat4x4f;
	uniform jitters: vec4f;
	uniform textureSize: vec2f;
	varying uv0: vec2f;
	fn reproject(uv_in: vec2f, depth: f32) -> vec2f {
		var uv = vec2f(uv_in.x, 1.0 - uv_in.y);
		var ndc = vec4f(uv * 2.0 - 1.0, depth, 1.0);
		ndc = vec4f(ndc.xy - uniform.jitters.xy, ndc.zw);
		var worldPosition = uniform.matrix_viewProjectionInverse * ndc;
		worldPosition = worldPosition / worldPosition.w;
		let screenPrevious = uniform.matrix_viewProjectionPrevious * worldPosition;
		var result = (screenPrevious.xy / screenPrevious.w) * 0.5 + 0.5;
		result.y = 1.0 - result.y;
		return result;
	}
	fn colorClampPremul(uv: vec2f, historyPremul: vec3f) -> vec3f {
		var minPremul = vec3f(9999.0);
		var maxPremul = vec3f(-9999.0);
		for (var ix: i32 = -1; ix <= 1; ix = ix + 1) {
			for (var iy: i32 = -1; iy <= 1; iy = iy + 1) {
				let s = textureSample(sourceTexture, sourceTextureSampler, uv + vec2f(f32(ix), f32(iy)) / uniform.textureSize);
				let premul = s.rgb * s.a;
				minPremul = min(minPremul, premul);
				maxPremul = max(maxPremul, premul);
			}
		}
		return clamp(historyPremul, minPremul, maxPremul);
	}
	@fragment
	fn fragmentMain(input: FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		let srcColor = textureSample(sourceTexture, sourceTextureSampler, uv0);
		let linearDepth = getLinearScreenDepth(uv0);
		let depth = delinearizeDepth(linearDepth);
		let historyUv = reproject(uv0, depth);
		#ifdef QUALITY_HIGH
			var historySample: vec4f = SampleTextureCatmullRom(historyTexture, historyTextureSampler, historyUv, uniform.textureSize);
		#else
			var historySample: vec4f = textureSample(historyTexture, historyTextureSampler, historyUv);
		#endif
		let historyPremul = historySample.rgb * historySample.a;
		let srcPremul = srcColor.rgb * srcColor.a;
		let historyPremulClamped = colorClampPremul(uv0, historyPremul);
		let mixFactor_condition = historyUv.x < 0.0 || historyUv.x > 1.0 || historyUv.y < 0.0 || historyUv.y > 1.0;
		let mixFactor = select(0.05, 1.0, mixFactor_condition);
		let mixedPremul = mix(historyPremulClamped, srcPremul, mixFactor);
		let a = srcColor.a;
		let UNPREMUL_EPS = 1.0 / 255.0;
		let rgbStraight = select(srcColor.rgb, mixedPremul / a, a > UNPREMUL_EPS);
		output.color = vec4f(rgbStraight, a);
		return output;
	}
`;

var RenderPassTAA = class extends RenderPassShaderQuad {
	historyIndex = 0;
	historyTexture = null;
	historyTextures = [];
	historyRenderTargets = [];
	constructor(device, sourceTexture, cameraComponent) {
		super(device);
		this.sourceTexture = sourceTexture;
		this.cameraComponent = cameraComponent;
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("sampleCatmullRomPS", sampleCatmullRom_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("sampleCatmullRomPS", sampleCatmullRom_default2);
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("taaResolvePS", taaResolve_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("taaResolvePS", taaResolve_default2);
		const defines = /* @__PURE__ */ new Map();
		defines.set("QUALITY_HIGH", true);
		ShaderUtils.addScreenDepthChunkDefines(cameraComponent.shaderParams, defines);
		this.shader = ShaderUtils.createShader(device, {
			uniqueName: "TaaResolveShader",
			attributes: { aPosition: SEMANTIC_POSITION },
			vertexChunk: "quadVS",
			fragmentChunk: "taaResolvePS",
			fragmentDefines: defines
		});
		const { scope } = device;
		this.sourceTextureId = scope.resolve("sourceTexture");
		this.textureSizeId = scope.resolve("textureSize");
		this.textureSize = new Float32Array(2);
		this.historyTextureId = scope.resolve("historyTexture");
		this.viewProjPrevId = scope.resolve("matrix_viewProjectionPrevious");
		this.viewProjInvId = scope.resolve("matrix_viewProjectionInverse");
		this.jittersId = scope.resolve("jitters");
		this.cameraParams = new Float32Array(4);
		this.cameraParamsId = scope.resolve("camera_params");
		this.setup();
	}
	destroy() {
		if (this.renderTarget) {
			this.renderTarget.destroyTextureBuffers();
			this.renderTarget.destroy();
			this.renderTarget = null;
		}
	}
	setup() {
		for (let i2 = 0; i2 < 2; ++i2) {
			this.historyTextures[i2] = new Texture(this.device, {
				name: `TAA-History-${i2}`,
				width: 4,
				height: 4,
				format: this.sourceTexture.format,
				mipmaps: false,
				minFilter: FILTER_LINEAR,
				magFilter: FILTER_LINEAR,
				addressU: ADDRESS_CLAMP_TO_EDGE,
				addressV: ADDRESS_CLAMP_TO_EDGE
			});
			this.historyRenderTargets[i2] = new RenderTarget({
				colorBuffer: this.historyTextures[i2],
				depth: false
			});
		}
		this.historyTexture = this.historyTextures[0];
		this.init(this.historyRenderTargets[0], {
			resizeSource: this.sourceTexture
		});
	}
	before() {
		this.sourceTextureId.setValue(this.sourceTexture);
		this.historyTextureId.setValue(this.historyTextures[1 - this.historyIndex]);
		this.textureSize[0] = this.sourceTexture.width;
		this.textureSize[1] = this.sourceTexture.height;
		this.textureSizeId.setValue(this.textureSize);
		const camera = this.cameraComponent.camera;
		this.viewProjPrevId.setValue(camera._viewProjPrevious.data);
		this.viewProjInvId.setValue(camera._viewProjInverse.data);
		this.jittersId.setValue(camera._jitters);
		this.cameraParamsId.setValue(camera.fillShaderParams(this.cameraParams));
	}
	// called when the parent render pass gets added to the frame graph
	update() {
		this.historyIndex = 1 - this.historyIndex;
		this.historyTexture = this.historyTextures[this.historyIndex];
		this.renderTarget = this.historyRenderTargets[this.historyIndex];
		return this.historyTexture;
	}
};

var coc_default = `
	#include "screenDepthPS"
	varying vec2 uv0;
	uniform vec3 params;
	void main()
	{
		float depth = getLinearScreenDepth(uv0);
		float focusDistance = params.x;
		float focusRange = params.y;
		float invRange = params.z;
		float farRange = focusDistance + focusRange * 0.5;
		
		float cocFar = min((depth - farRange) * invRange, 1.0);
		#ifdef NEAR_BLUR
			float nearRange = focusDistance - focusRange * 0.5;
			float cocNear = min((nearRange - depth) * invRange, 1.0);
		#else
			float cocNear = 0.0;
		#endif
		gl_FragColor = vec4(cocFar, cocNear, 0.0, 0.0);
	}
`;

var coc_default2 = `
#include "screenDepthPS"
varying uv0: vec2f;
uniform params: vec3f;
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	let depth: f32 = getLinearScreenDepth(uv0);
	let focusDistance: f32 = uniform.params.x;
	let focusRange: f32 = uniform.params.y;
	let invRange: f32 = uniform.params.z;
	let farRange: f32 = focusDistance + focusRange * 0.5;
	let cocFar: f32 = min((depth - farRange) * invRange, 1.0);
	#ifdef NEAR_BLUR
		let nearRange: f32 = focusDistance - focusRange * 0.5;
		var cocNear: f32 = min((nearRange - depth) * invRange, 1.0);
	#else
		var cocNear: f32 = 0.0;
	#endif
	output.color = vec4f(cocFar, cocNear, 0.0, 0.0);
	return output;
}
`;

var RenderPassCoC = class extends RenderPassShaderQuad {
	focusDistance;
	focusRange;
	constructor(device, cameraComponent, nearBlur) {
		super(device);
		this.cameraComponent = cameraComponent;
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("cocPS", coc_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("cocPS", coc_default2);
		const defines = /* @__PURE__ */ new Map();
		if (nearBlur) defines.set("NEAR_BLUR", "");
		ShaderUtils.addScreenDepthChunkDefines(cameraComponent.shaderParams, defines);
		this.shader = ShaderUtils.createShader(device, {
			uniqueName: `CocShader-${nearBlur}`,
			attributes: { aPosition: SEMANTIC_POSITION },
			vertexChunk: "quadVS",
			fragmentChunk: "cocPS",
			fragmentDefines: defines
		});
		this.paramsId = device.scope.resolve("params");
		this.paramsValue = new Float32Array(3);
		this.cameraParams = new Float32Array(4);
		this.cameraParamsId = device.scope.resolve("camera_params");
	}
	execute() {
		const { paramsValue, focusRange } = this;
		paramsValue[0] = this.focusDistance + 1e-3;
		paramsValue[1] = focusRange;
		paramsValue[2] = 1 / focusRange;
		this.paramsId.setValue(paramsValue);
		const camera = this.cameraComponent.camera;
		this.cameraParamsId.setValue(camera.fillShaderParams(this.cameraParams));
		super.execute();
	}
};

var dofBlur_default = `
	#if defined(NEAR_BLUR)
		uniform sampler2D nearTexture;
	#endif
	uniform sampler2D farTexture;
	uniform sampler2D cocTexture;
	uniform vec2 kernel[{KERNEL_COUNT}];
	uniform float blurRadiusNear;
	uniform float blurRadiusFar;
	varying vec2 uv0;
	void main()
	{
		vec2 coc = texture2D(cocTexture, uv0).rg;
		float cocFar = coc.r;
		vec3 sum = vec3(0.0, 0.0, 0.0);
		#if defined(NEAR_BLUR)
			float cocNear = coc.g;
			if (cocNear > 0.0001) {
				vec2 nearTextureSize = vec2(textureSize(nearTexture, 0));
				vec2 step = cocNear * blurRadiusNear * vec2(nearTextureSize.y / nearTextureSize.x, 1.0);
				for (int i = 0; i < {KERNEL_COUNT}; i++) {
					vec2 uv = uv0 + step * kernel[i];
					vec3 tap = texture2DLod(nearTexture, uv, 0.0).rgb;
					sum += tap.rgb;
				}
				sum *= float({INV_KERNEL_COUNT});
			} else
		#endif
			
			if (cocFar > 0.0001) {
			vec2 farTextureSize = vec2(textureSize(farTexture, 0));
			vec2 step = cocFar * blurRadiusFar * vec2(farTextureSize.y / farTextureSize.x, 1.0);
			float sumCoC = 0.0; 
			for (int i = 0; i < {KERNEL_COUNT}; i++) {
				vec2 uv = uv0 + step * kernel[i];
				vec3 tap = texture2DLod(farTexture, uv, 0.0).rgb;
				float cocThis = texture2DLod(cocTexture, uv, 0.0).r;
				tap *= cocThis;
				sumCoC += cocThis;
				sum += tap;
			}
			if (sumCoC > 0.0)
				sum /= sumCoC;
			sum /= cocFar;
		}
		pcFragColor0 = vec4(sum, 1.0);
	}
`;

var dofBlur_default2 = `
#if defined(NEAR_BLUR)
	var nearTexture: texture_2d<f32>;
	var nearTextureSampler: sampler;
#endif
var farTexture: texture_2d<f32>;
var farTextureSampler: sampler;
var cocTexture: texture_2d<f32>;
var cocTextureSampler: sampler;
uniform kernel: array<vec2f, {KERNEL_COUNT}>;
uniform blurRadiusNear: f32;
uniform blurRadiusFar: f32;
varying uv0: vec2f;
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	let coc: vec2f = textureSample(cocTexture, cocTextureSampler, input.uv0).rg;
	let cocFar: f32 = coc.r;
	var sum: vec3f = vec3f(0.0, 0.0, 0.0);
	#if defined(NEAR_BLUR)
		let cocNear: f32 = coc.g;
		if (cocNear > 0.0001) {
			let nearTextureSize: vec2f = vec2f(textureDimensions(nearTexture, 0));
			let step: vec2f = cocNear * uniform.blurRadiusNear * vec2f(nearTextureSize.y / nearTextureSize.x, 1.0);
			for (var i: i32 = 0; i < {KERNEL_COUNT}; i = i + 1) {
				let uv: vec2f = uv0 + step * uniform.kernel[i].element;
				let tap: vec3f = textureSampleLevel(nearTexture, nearTextureSampler, uv, 0.0).rgb;
				sum = sum + tap;
			}
			sum = sum * f32({INV_KERNEL_COUNT});
		} else
	#endif
		if (cocFar > 0.0001) {
			let farTextureSize: vec2f = vec2f(textureDimensions(farTexture, 0));
			let step: vec2f = cocFar * uniform.blurRadiusFar * vec2f(farTextureSize.y / farTextureSize.x, 1.0);
			var sumCoC: f32 = 0.0;
			for (var i: i32 = 0; i < {KERNEL_COUNT}; i = i + 1) {
				let uv: vec2f = uv0 + step * uniform.kernel[i].element;
				var tap: vec3f = textureSampleLevel(farTexture, farTextureSampler, uv, 0.0).rgb;
				let cocThis: f32 = textureSampleLevel(cocTexture, cocTextureSampler, uv, 0.0).r;
				tap = tap * cocThis;
				sumCoC = sumCoC + cocThis;
				sum = sum + tap;
			}
			if (sumCoC > 0.0) {
				sum = sum / sumCoC;
			}
			sum = sum / cocFar;
		}
	output.color = vec4f(sum, 1.0);
	return output;
}
`;

var RenderPassDofBlur = class extends RenderPassShaderQuad {
	blurRadiusNear = 1;
	blurRadiusFar = 1;
	_blurRings = 3;
	_blurRingPoints = 3;
	referenceHeight = 540;
	constructor(device, nearTexture, farTexture, cocTexture) {
		super(device);
		this.nearTexture = nearTexture;
		this.farTexture = farTexture;
		this.cocTexture = cocTexture;
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("dofBlurPS", dofBlur_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("dofBlurPS", dofBlur_default2);
		const { scope } = device;
		this.kernelId = scope.resolve("kernel[0]");
		this.kernelCountId = scope.resolve("kernelCount");
		this.blurRadiusNearId = scope.resolve("blurRadiusNear");
		this.blurRadiusFarId = scope.resolve("blurRadiusFar");
		this.nearTextureId = scope.resolve("nearTexture");
		this.farTextureId = scope.resolve("farTexture");
		this.cocTextureId = scope.resolve("cocTexture");
	}
	set blurRings(value) {
		if (this._blurRings !== value) {
			this._blurRings = value;
			this.shader = null;
		}
	}
	get blurRings() {
		return this._blurRings;
	}
	set blurRingPoints(value) {
		if (this._blurRingPoints !== value) {
			this._blurRingPoints = value;
			this.shader = null;
		}
	}
	get blurRingPoints() {
		return this._blurRingPoints;
	}
	createShader() {
		this.kernel = new Float32Array(Kernel.concentric(this.blurRings, this.blurRingPoints));
		const kernelCount = this.kernel.length >> 1;
		const nearBlur = this.nearTexture !== null;
		const defines = /* @__PURE__ */ new Map();
		defines.set("{KERNEL_COUNT}", kernelCount);
		defines.set("{INV_KERNEL_COUNT}", 1 / kernelCount);
		if (nearBlur) defines.set("NEAR_BLUR", "");
		this.shader = ShaderUtils.createShader(this.device, {
			uniqueName: `DofBlurShader-${kernelCount}-${nearBlur ? "nearBlur" : "noNearBlur"}`,
			attributes: { aPosition: SEMANTIC_POSITION },
			vertexChunk: "quadVS",
			fragmentChunk: "dofBlurPS",
			fragmentDefines: defines
		});
	}
	execute() {
		if (!this.shader) {
			this.createShader();
		}
		this.nearTextureId.setValue(this.nearTexture);
		this.farTextureId.setValue(this.farTexture);
		this.cocTextureId.setValue(this.cocTexture);
		this.kernelId.setValue(this.kernel);
		this.kernelCountId.setValue(this.kernel.length >> 1);
		const referenceHeight = this.referenceHeight > 0 ? this.referenceHeight : 540;
		const invReferenceHeight = 1 / referenceHeight;
		this.blurRadiusNearId.setValue(this.blurRadiusNear * invReferenceHeight);
		this.blurRadiusFarId.setValue(this.blurRadiusFar * invReferenceHeight);
		super.execute();
	}
};

var FramePassDof = class extends FramePass {
	focusDistance = 100;
	focusRange = 50;
	blurRadius = 1;
	blurRings = 3;
	blurRingPoints = 3;
	highQuality = true;
	cocTexture = null;
	blurTexture = null;
	cocPass = null;
	farPass = null;
	blurPass = null;
	constructor(device, cameraComponent, sceneTexture, sceneTextureHalf, highQuality, nearBlur) {
		super(device);
		this.highQuality = highQuality;
		this.cocPass = this.setupCocPass(device, cameraComponent, sceneTexture, nearBlur);
		this.beforePasses.push(this.cocPass);
		const sourceTexture = highQuality ? sceneTexture : sceneTextureHalf;
		this.farPass = this.setupFarPass(device, sourceTexture, 0.5);
		this.beforePasses.push(this.farPass);
		this.blurPass = this.setupBlurPass(device, sceneTextureHalf, nearBlur, highQuality ? 2 : 0.5);
		this.beforePasses.push(this.blurPass);
	}
	destroy() {
		this.destroyRenderPasses();
		this.cocPass = null;
		this.farPass = null;
		this.blurPass = null;
		this.destroyRT(this.cocRT);
		this.destroyRT(this.farRt);
		this.destroyRT(this.blurRt);
		this.cocRT = null;
		this.farRt = null;
		this.blurRt = null;
	}
	destroyRenderPasses() {
		for (let i2 = 0; i2 < this.beforePasses.length; i2++) {
			this.beforePasses[i2].destroy();
		}
		this.beforePasses.length = 0;
	}
	destroyRT(rt) {
		if (rt) {
			rt.destroyTextureBuffers();
			rt.destroy();
		}
	}
	setupCocPass(device, cameraComponent, sourceTexture, nearBlur) {
		const format = nearBlur ? PIXELFORMAT_RG8 : PIXELFORMAT_R8;
		this.cocRT = this.createRenderTarget("CoCTexture", format);
		this.cocTexture = this.cocRT.colorBuffer;
		const cocPass = new RenderPassCoC(device, cameraComponent, nearBlur);
		cocPass.init(this.cocRT, {
			resizeSource: sourceTexture
		});
		cocPass.setClearColor(Color.BLACK);
		return cocPass;
	}
	setupFarPass(device, sourceTexture, scale2) {
		this.farRt = this.createRenderTarget("FarDofTexture", sourceTexture.format);
		const farPass = new RenderPassDownsample(device, sourceTexture, {
			boxFilter: true,
			premultiplyTexture: this.cocTexture,
			premultiplySrcChannel: "r"
			// far CoC
		});
		farPass.init(this.farRt, {
			resizeSource: sourceTexture,
			scaleX: scale2,
			scaleY: scale2
		});
		farPass.setClearColor(Color.BLACK);
		return farPass;
	}
	setupBlurPass(device, nearTexture, nearBlur, scale2) {
		const farTexture = this.farRt?.colorBuffer;
		this.blurRt = this.createRenderTarget("DofBlurTexture", nearTexture.format);
		this.blurTexture = this.blurRt.colorBuffer;
		const blurPass = new RenderPassDofBlur(device, nearBlur ? nearTexture : null, farTexture, this.cocTexture);
		blurPass.init(this.blurRt, {
			resizeSource: nearTexture,
			scaleX: scale2,
			scaleY: scale2
		});
		blurPass.setClearColor(Color.BLACK);
		return blurPass;
	}
	createTexture(name, format) {
		return new Texture(this.device, {
			name,
			width: 1,
			height: 1,
			format,
			mipmaps: false,
			minFilter: FILTER_LINEAR,
			magFilter: FILTER_LINEAR,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE
		});
	}
	createRenderTarget(name, format) {
		return new RenderTarget({
			colorBuffer: this.createTexture(name, format),
			depth: false,
			stencil: false
		});
	}
	frameUpdate() {
		super.frameUpdate();
		this.cocPass.focusDistance = this.focusDistance;
		this.cocPass.focusRange = this.focusRange;
		this.blurPass.blurRadiusNear = this.blurRadius;
		this.blurPass.blurRadiusFar = this.blurRadius;
		this.blurPass.blurRings = this.blurRings;
		this.blurPass.blurRingPoints = this.blurRingPoints;
	}
};

var volumetricFog_default = `
	#include "screenDepthPS"
	varying vec2 uv0;
	uniform vec3 uFogCameraPos;
	uniform vec3 uFogCameraFwd;
	uniform mat4 uFogInvView;
	uniform vec2 uFogProjScale;
	uniform vec3 uFogTint;
	uniform vec3 uFogLightColor;
	uniform vec3 uFogLightDir;
	uniform vec3 uFogAmbient;
	uniform vec4 uFogParams;
	uniform vec4 uFogScatterParams;
	#ifdef FOG_SHADOWS
		uniform mat4 uFogShadowMatrixPalette[4];
		uniform vec4 uFogShadowCascadeDistances;
		uniform vec4 uFogShadowParams;
		#ifdef FOG_SHADOW_PCF
			uniform sampler2DShadow uFogShadowMap;
		#else
			uniform sampler2D uFogShadowMap;
		#endif
		float sampleFogShadow(vec3 worldPos, float viewDepth) {
			if (viewDepth >= uFogShadowParams.w) return 1.0;
			vec4 comparisons = step(uFogShadowCascadeDistances, vec4(viewDepth));
			int cascadeIndex = int(min(dot(comparisons, vec4(1.0)), uFogShadowParams.x - 1.0));
			vec3 shadowCoord = (uFogShadowMatrixPalette[cascadeIndex] * vec4(worldPos, 1.0)).xyz;
			float z = shadowCoord.z - uFogShadowParams.y;
			#ifdef FOG_SHADOW_PCF
				return textureShadow(uFogShadowMap, vec3(shadowCoord.xy, z));
			#else
				return step(z, texture2D(uFogShadowMap, shadowCoord.xy).r);
			#endif
		}
	#endif
	float fogNoise(vec2 fragCoord) {
		const vec3 magic = vec3(0.06711056, 0.00583715, 52.9829189);
		return fract(magic.z * fract(dot(fragCoord, magic.xy)));
	}
	float fogPhase(float cosTheta, float g) {
		float g2 = g * g;
		float denom = 1.0 + g2 - 2.0 * g * cosTheta;
		return (1.0 - g2) / (12.56637 * denom * sqrt(denom));
	}
	void main() {
		vec2 ndcUV = uv0;
		#ifdef WEBGPU
			ndcUV.y = 1.0 - ndcUV.y;
		#endif
		vec2 ndc = ndcUV * 2.0 - 1.0;
		vec3 rayDir = normalize((uFogInvView * vec4(ndc * uFogProjScale, -1.0, 0.0)).xyz);
		float rayDot = max(dot(rayDir, uFogCameraFwd), 0.001);
		float rayLength = min(getLinearScreenDepth(uv0) / rayDot, uFogParams.w);
		float stepCount = uFogScatterParams.y;
		float dt = rayLength / stepCount;
		float noise = fract(fogNoise(gl_FragCoord.xy) + uFogScatterParams.z);
		vec3 sunLight = uFogLightColor * fogPhase(dot(rayDir, uFogLightDir), uFogScatterParams.x);
		vec3 inscatter = vec3(0.0);
		float transmittance = 1.0;
		for (float i = 0.0; i < stepCount; i += 1.0) {
			float t = (i + noise) * dt;
			vec3 pos = uFogCameraPos + rayDir * t;
			float density = uFogParams.x * exp(-uFogParams.z * max(pos.y - uFogParams.y, 0.0));
			float shadow = 1.0;
			#ifdef FOG_SHADOWS
				shadow = mix(1.0, sampleFogShadow(pos, t * rayDot), uFogScatterParams.w);
			#endif
			vec3 radiance = sunLight * shadow + uFogAmbient;
			inscatter += transmittance * uFogTint * radiance * (density * dt);
			transmittance *= exp(-density * dt);
			if (transmittance < 0.005) break;
		}
		gl_FragColor = vec4(inscatter, transmittance);
	}
`;

var volumetricFog_default2 = `
	#include "screenDepthPS"
	varying uv0: vec2f;
	uniform uFogCameraPos: vec3f;
	uniform uFogCameraFwd: vec3f;
	uniform uFogInvView: mat4x4f;
	uniform uFogProjScale: vec2f;
	uniform uFogTint: vec3f;
	uniform uFogLightColor: vec3f;
	uniform uFogLightDir: vec3f;
	uniform uFogAmbient: vec3f;
	uniform uFogParams: vec4f;
	uniform uFogScatterParams: vec4f;
	#ifdef FOG_SHADOWS
		uniform uFogShadowMatrixPalette: array<mat4x4f, 4>;
		uniform uFogShadowCascadeDistances: vec4f;
		uniform uFogShadowParams: vec4f;
		#ifdef FOG_SHADOW_PCF
			var uFogShadowMap: texture_depth_2d;
			var uFogShadowMapSampler: sampler_comparison;
		#else
			var uFogShadowMap: texture_2d<f32>;
			var uFogShadowMapSampler: sampler;
		#endif
		fn sampleFogShadow(worldPos: vec3f, viewDepth: f32) -> f32 {
			if (viewDepth >= uniform.uFogShadowParams.w) {
				return 1.0;
			}
			let comparisons: vec4f = step(uniform.uFogShadowCascadeDistances, vec4f(viewDepth));
			let cascadeIndex: i32 = i32(min(dot(comparisons, vec4f(1.0)), uniform.uFogShadowParams.x - 1.0));
			let shadowCoord: vec3f = (uniform.uFogShadowMatrixPalette[cascadeIndex] * vec4f(worldPos, 1.0)).xyz;
			let z: f32 = shadowCoord.z - uniform.uFogShadowParams.y;
			#ifdef FOG_SHADOW_PCF
				return textureSampleCompareLevel(uFogShadowMap, uFogShadowMapSampler, shadowCoord.xy, z);
			#else
				return step(z, textureSampleLevel(uFogShadowMap, uFogShadowMapSampler, shadowCoord.xy, 0.0).r);
			#endif
		}
	#endif
	fn fogNoise(fragCoord: vec2f) -> f32 {
		const magic: vec3f = vec3f(0.06711056, 0.00583715, 52.9829189);
		return fract(magic.z * fract(dot(fragCoord, magic.xy)));
	}
	fn fogPhase(cosTheta: f32, g: f32) -> f32 {
		let g2: f32 = g * g;
		let denom: f32 = 1.0 + g2 - 2.0 * g * cosTheta;
		return (1.0 - g2) / (12.56637 * denom * sqrt(denom));
	}
	@fragment
	fn fragmentMain(input: FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		let ndcUV: vec2f = vec2f(input.uv0.x, 1.0 - input.uv0.y);
		let ndc: vec2f = ndcUV * 2.0 - 1.0;
		let rayDir: vec3f = normalize((uniform.uFogInvView * vec4f(ndc * uniform.uFogProjScale, -1.0, 0.0)).xyz);
		let rayDot: f32 = max(dot(rayDir, uniform.uFogCameraFwd), 0.001);
		let rayLength: f32 = min(getLinearScreenDepth(input.uv0) / rayDot, uniform.uFogParams.w);
		let stepCount: f32 = uniform.uFogScatterParams.y;
		let dt: f32 = rayLength / stepCount;
		let noise: f32 = fract(fogNoise(pcPosition.xy) + uniform.uFogScatterParams.z);
		let sunLight: vec3f = uniform.uFogLightColor * fogPhase(dot(rayDir, uniform.uFogLightDir), uniform.uFogScatterParams.x);
		var inscatter: vec3f = vec3f(0.0);
		var transmittance: f32 = 1.0;
		for (var i: f32 = 0.0; i < stepCount; i += 1.0) {
			let t: f32 = (i + noise) * dt;
			let pos: vec3f = uniform.uFogCameraPos + rayDir * t;
			let density: f32 = uniform.uFogParams.x * exp(-uniform.uFogParams.z * max(pos.y - uniform.uFogParams.y, 0.0));
			var shadow: f32 = 1.0;
			#ifdef FOG_SHADOWS
				shadow = mix(1.0, sampleFogShadow(pos, t * rayDot), uniform.uFogScatterParams.w);
			#endif
			let radiance: vec3f = sunLight * shadow + uniform.uFogAmbient;
			inscatter += transmittance * uniform.uFogTint * radiance * (density * dt);
			transmittance *= exp(-density * dt);
			if (transmittance < 0.005) {
				break;
			}
		}
		output.color = vec4f(inscatter, transmittance);
		return output;
	}
`;

var volumetricFogCombine_default = `
	#include "screenDepthPS"
	varying vec2 uv0;
	uniform sampler2D uFogTexture;
	uniform vec4 uFogTextureSize;
	void main() {
		float depth = getLinearScreenDepth(uv0);
		vec2 texel = uv0 * uFogTextureSize.xy - 0.5;
		vec2 base = (floor(texel) + 0.5) * uFogTextureSize.zw;
		vec2 f = fract(texel);
		vec2 uvs[4];
		uvs[0] = base;
		uvs[1] = base + vec2(uFogTextureSize.z, 0.0);
		uvs[2] = base + vec2(0.0, uFogTextureSize.w);
		uvs[3] = base + uFogTextureSize.zw;
		vec4 bilinear = vec4((1.0 - f.x) * (1.0 - f.y), f.x * (1.0 - f.y), (1.0 - f.x) * f.y, f.x * f.y);
		vec4 sum = vec4(0.0);
		float sumWeight = 0.0;
		for (int i = 0; i < 4; i++) {
			float sampleDepth = getLinearScreenDepth(uvs[i]);
			float w = bilinear[i] / (1.0 + 16.0 * abs(sampleDepth - depth) / max(depth, 0.001));
			sum += texture2D(uFogTexture, uvs[i]) * w;
			sumWeight += w;
		}
		gl_FragColor = sum / max(sumWeight, 0.0001);
	}
`;

var volumetricFogCombine_default2 = `
	#include "screenDepthPS"
	varying uv0: vec2f;
	var uFogTexture: texture_2d<f32>;
	var uFogTextureSampler: sampler;
	uniform uFogTextureSize: vec4f;
	@fragment
	fn fragmentMain(input: FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		let depth: f32 = getLinearScreenDepth(input.uv0);
		let texel: vec2f = input.uv0 * uniform.uFogTextureSize.xy - 0.5;
		let base: vec2f = (floor(texel) + 0.5) * uniform.uFogTextureSize.zw;
		let f: vec2f = fract(texel);
		var uvs: array<vec2f, 4>;
		uvs[0] = base;
		uvs[1] = base + vec2f(uniform.uFogTextureSize.z, 0.0);
		uvs[2] = base + vec2f(0.0, uniform.uFogTextureSize.w);
		uvs[3] = base + uniform.uFogTextureSize.zw;
		let bilinear: vec4f = vec4f((1.0 - f.x) * (1.0 - f.y), f.x * (1.0 - f.y), (1.0 - f.x) * f.y, f.x * f.y);
		var sum: vec4f = vec4f(0.0);
		var sumWeight: f32 = 0.0;
		for (var i: i32 = 0; i < 4; i += 1) {
			let sampleDepth: f32 = getLinearScreenDepth(uvs[i]);
			let w: f32 = bilinear[i] / (1.0 + 16.0 * abs(sampleDepth - depth) / max(depth, 0.001));
			sum += textureSampleLevel(uFogTexture, uFogTextureSampler, uvs[i], 0.0) * w;
			sumWeight += w;
		}
		output.color = sum / max(sumWeight, 0.0001);
		return output;
	}
`;

var _tempDir = new Vec3();
var RenderPassVolumetricFog = class extends RenderPassShaderQuad {
	light = null;
	shadowsEnabled = false;
	lightRenderData = null;
	tint = new Color(1, 1, 1);
	density = 0.01;
	heightBase = 0;
	heightFalloff = 0.05;
	anisotropy = 0.6;
	intensity = 1;
	ambientColor = new Color(1, 1, 1);
	ambientIntensity = 0.02;
	maxDistance = 300;
	steps = 24;
	noiseOffset = 0;
	exposure = 1;
	_variantKey = null;
	constructor(device, cameraComponent) {
		super(device);
		this.cameraComponent = cameraComponent;
		const scope = device.scope;
		this.cameraPosId = scope.resolve("uFogCameraPos");
		this.cameraFwdId = scope.resolve("uFogCameraFwd");
		this.invViewId = scope.resolve("uFogInvView");
		this.projScaleId = scope.resolve("uFogProjScale");
		this.tintId = scope.resolve("uFogTint");
		this.lightColorId = scope.resolve("uFogLightColor");
		this.lightDirId = scope.resolve("uFogLightDir");
		this.ambientId = scope.resolve("uFogAmbient");
		this.fogParamsId = scope.resolve("uFogParams");
		this.scatterParamsId = scope.resolve("uFogScatterParams");
		this.shadowMapId = scope.resolve("uFogShadowMap");
		this.shadowMatrixPaletteId = scope.resolve("uFogShadowMatrixPalette[0]");
		this.shadowCascadeDistancesId = scope.resolve("uFogShadowCascadeDistances");
		this.shadowParamsId = scope.resolve("uFogShadowParams");
		this._cameraPos = new Float32Array(3);
		this._cameraFwd = new Float32Array(3);
		this._projScale = new Float32Array(2);
		this._tint = new Float32Array(3);
		this._lightColor = new Float32Array(3);
		this._lightDir = new Float32Array(3);
		this._ambient = new Float32Array(3);
		this._fogParams = new Float32Array(4);
		this._scatterParams = new Float32Array(4);
		this._shadowParams = new Float32Array(4);
	}
	updateShaderVariant(shadows, pcf) {
		const depthMapLinear = this.cameraComponent.shaderParams.sceneDepthMapLinear;
		const key = `${shadows}-${pcf}-${depthMapLinear}`;
		if (this._variantKey !== key) {
			this._variantKey = key;
			const defines = /* @__PURE__ */ new Map();
			ShaderUtils.addScreenDepthChunkDefines(this.cameraComponent.shaderParams, defines);
			if (shadows) defines.set("FOG_SHADOWS", "");
			if (pcf) defines.set("FOG_SHADOW_PCF", "");
			this.shader = ShaderUtils.createShader(this.device, {
				uniqueName: `VolumetricFogShader-${key}`,
				attributes: { aPosition: SEMANTIC_POSITION },
				vertexChunk: "quadVS",
				fragmentChunk: "volumetricFogPS",
				fragmentDefines: defines
			});
		}
	}
	execute() {
		const { light } = this;
		const camera = this.cameraComponent.camera;
		const node = camera._node;
		this.invViewId.setValue(node.getWorldTransform().data);
		const pos = node.getPosition();
		this._cameraPos[0] = pos.x;
		this._cameraPos[1] = pos.y;
		this._cameraPos[2] = pos.z;
		this.cameraPosId.setValue(this._cameraPos);
		const fwd = node.forward;
		this._cameraFwd[0] = fwd.x;
		this._cameraFwd[1] = fwd.y;
		this._cameraFwd[2] = fwd.z;
		this.cameraFwdId.setValue(this._cameraFwd);
		const projData = camera.projectionMatrix.data;
		this._projScale[0] = 1 / projData[0];
		this._projScale[1] = 1 / projData[5];
		this.projScaleId.setValue(this._projScale);
		const lightScale = this.intensity * this.exposure;
		if (light) {
			light._node.getWorldTransform().getY(_tempDir).normalize();
			this._lightDir[0] = _tempDir.x;
			this._lightDir[1] = _tempDir.y;
			this._lightDir[2] = _tempDir.z;
			const color3 = light._colorLinear;
			this._lightColor[0] = color3[0] * lightScale;
			this._lightColor[1] = color3[1] * lightScale;
			this._lightColor[2] = color3[2] * lightScale;
		} else {
			this._lightDir[0] = 0;
			this._lightDir[1] = 1;
			this._lightDir[2] = 0;
			this._lightColor[0] = 0;
			this._lightColor[1] = 0;
			this._lightColor[2] = 0;
		}
		this.lightDirId.setValue(this._lightDir);
		this.lightColorId.setValue(this._lightColor);
		if (this.shadowsEnabled && light && this.lightRenderData) {
			const lightRenderData = this.lightRenderData;
			const biases = light._getUniformBiasValues(lightRenderData);
			this.shadowMapId.setValue(lightRenderData.shadowBuffer);
			this.shadowMatrixPaletteId.setValue(light._shadowMatrixPalette);
			this.shadowCascadeDistancesId.setValue(light._shadowCascadeDistances);
			this._shadowParams[0] = light.numCascades;
			this._shadowParams[1] = biases.bias;
			this._shadowParams[2] = 0;
			this._shadowParams[3] = light.shadowDistance;
			this.shadowParamsId.setValue(this._shadowParams);
		}
		const { tint, ambientColor, ambientIntensity } = this;
		this._tint[0] = tint.r;
		this._tint[1] = tint.g;
		this._tint[2] = tint.b;
		this.tintId.setValue(this._tint);
		const ambientScale = ambientIntensity * this.exposure;
		this._ambient[0] = ambientColor.r * ambientScale;
		this._ambient[1] = ambientColor.g * ambientScale;
		this._ambient[2] = ambientColor.b * ambientScale;
		this.ambientId.setValue(this._ambient);
		this._fogParams[0] = this.density;
		this._fogParams[1] = this.heightBase;
		this._fogParams[2] = this.heightFalloff;
		this._fogParams[3] = this.maxDistance;
		this.fogParamsId.setValue(this._fogParams);
		this._scatterParams[0] = this.anisotropy;
		this._scatterParams[1] = this.steps;
		this._scatterParams[2] = this.noiseOffset;
		this._scatterParams[3] = light ? light.shadowIntensity : 1;
		this.scatterParamsId.setValue(this._scatterParams);
		super.execute();
	}
};
var RenderPassVolumetricFogCombine = class extends RenderPassShaderQuad {
	constructor(device, cameraComponent, fogTexture) {
		super(device);
		this.fogTexture = fogTexture;
		const defines = /* @__PURE__ */ new Map();
		ShaderUtils.addScreenDepthChunkDefines(cameraComponent.shaderParams, defines);
		this.shader = ShaderUtils.createShader(device, {
			uniqueName: `VolumetricFogCombineShader-${cameraComponent.shaderParams.sceneDepthMapLinear}`,
			attributes: { aPosition: SEMANTIC_POSITION },
			vertexChunk: "quadVS",
			fragmentChunk: "volumetricFogCombinePS",
			fragmentDefines: defines
		});
		this.blendState = new BlendState(
			true,
			BLENDEQUATION_ADD,
			BLENDMODE_ONE,
			BLENDMODE_SRC_ALPHA,
			BLENDEQUATION_ADD,
			BLENDMODE_ZERO,
			BLENDMODE_ONE
		);
		this.fogTextureId = device.scope.resolve("uFogTexture");
		this.fogTextureSizeId = device.scope.resolve("uFogTextureSize");
		this._fogTextureSize = new Float32Array(4);
	}
	execute() {
		const { fogTexture } = this;
		this.fogTextureId.setValue(fogTexture);
		this._fogTextureSize[0] = fogTexture.width;
		this._fogTextureSize[1] = fogTexture.height;
		this._fogTextureSize[2] = 1 / fogTexture.width;
		this._fogTextureSize[3] = 1 / fogTexture.height;
		this.fogTextureSizeId.setValue(this._fogTextureSize);
		super.execute();
	}
};
var FramePassVolumetricFog = class extends FramePass {
	light = null;
	tint = new Color(1, 1, 1);
	density = 0.01;
	heightBase = 0;
	heightFalloff = 0.05;
	anisotropy = 0.6;
	intensity = 1;
	ambientColor = new Color(1, 1, 1);
	ambientIntensity = 0.02;
	maxDistance = 300;
	steps = 24;
	temporalDither = false;
	_scale = 0.5;
	_frameIndex = 0;
	constructor(device, cameraComponent, sceneTexture, sceneRenderTarget) {
		super(device);
		this.cameraComponent = cameraComponent;
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("volumetricFogPS", volumetricFog_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("volumetricFogPS", volumetricFog_default2);
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("volumetricFogCombinePS", volumetricFogCombine_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("volumetricFogCombinePS", volumetricFogCombine_default2);
		const format = device.getRenderableHdrFormat([PIXELFORMAT_RGBA16F, PIXELFORMAT_RGBA32F], true, 1) ?? PIXELFORMAT_RGBA8;
		this.fogTexture = new Texture(device, {
			name: "VolumetricFogTexture",
			width: 4,
			height: 4,
			format,
			mipmaps: false,
			minFilter: FILTER_LINEAR,
			magFilter: FILTER_LINEAR,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE
		});
		this.fogRenderTarget = new RenderTarget({
			name: "VolumetricFogRT",
			colorBuffer: this.fogTexture,
			depth: false
		});
		this.fogPass = new RenderPassVolumetricFog(device, cameraComponent);
		this.fogPass.init(this.fogRenderTarget, {
			resizeSource: sceneTexture,
			scaleX: this._scale,
			scaleY: this._scale
		});
		this.fogPass.setClearColor(new Color(0, 0, 0, 1));
		this.beforePasses.push(this.fogPass);
		this.combinePass = new RenderPassVolumetricFogCombine(device, cameraComponent, this.fogTexture);
		this.combinePass.init(sceneRenderTarget);
		this.beforePasses.push(this.combinePass);
	}
	destroy() {
		this.beforePasses.forEach((pass) => pass.destroy());
		this.beforePasses.length = 0;
		this.fogPass = null;
		this.combinePass = null;
		if (this.fogRenderTarget) {
			this.fogRenderTarget.destroyTextureBuffers();
			this.fogRenderTarget.destroy();
			this.fogRenderTarget = null;
			this.fogTexture = null;
		}
	}
	set scale(value) {
		this._scale = value;
		this.fogPass.scaleX = value;
		this.fogPass.scaleY = value;
	}
	get scale() {
		return this._scale;
	}
	frameUpdate() {
		super.frameUpdate();
		const { light, fogPass } = this;
		const camera = this.cameraComponent.camera;
		let shadows = false;
		let pcf = false;
		let lightRenderData = null;
		if (light && light.castShadows && light.shadowIntensity > 0) {
			lightRenderData = light.getRenderData(camera, 0);
			if (lightRenderData.shadowBuffer) {
				shadows = true;
				pcf = !!shadowTypeInfo.get(light._shadowType)?.pcf;
			}
		}
		fogPass.updateShaderVariant(shadows, pcf);
		fogPass.shadowsEnabled = shadows;
		fogPass.lightRenderData = shadows ? lightRenderData : null;
		fogPass.light = light;
		fogPass.tint.copy(this.tint);
		fogPass.density = this.density;
		fogPass.heightBase = this.heightBase;
		fogPass.heightFalloff = this.heightFalloff;
		fogPass.anisotropy = this.anisotropy;
		fogPass.intensity = this.intensity;
		fogPass.ambientColor.copy(this.ambientColor);
		fogPass.ambientIntensity = this.ambientIntensity;
		fogPass.maxDistance = this.maxDistance;
		fogPass.steps = Math.max(1, Math.floor(this.steps));
		fogPass.exposure = this.cameraComponent.system.app.scene.exposure;
		this._frameIndex = (this._frameIndex + 1) % 16;
		fogPass.noiseOffset = this.temporalDither ? this._frameIndex * 0.618034 : 0;
	}
};

var tempMeshInstances2 = [];
var DEPTH_UNIFORM_NAME = "uSceneDepthMap";
var RenderPassPrepass = class extends RenderPass {
	linearDepthTexture;
	linearDepthClearValue = new Color(0, 0, 0, 0);
	_qualifiedLayerIndices = [];
	constructor(device, scene, renderer, camera, options2) {
		super(device);
		this.scene = scene;
		this.renderer = renderer;
		this.camera = camera;
		this.setupRenderTarget(options2);
	}
	destroy() {
		super.destroy();
		this.camera.shaderParams.sceneDepthMapLinear = false;
		this.renderTarget?.destroy();
		this.renderTarget = null;
		this.linearDepthTexture?.destroy();
		this.linearDepthTexture = null;
	}
	setupRenderTarget(options2) {
		const { device } = this;
		this.linearDepthFormat = device.textureFloatRenderable ? PIXELFORMAT_R32F : PIXELFORMAT_RGBA8;
		this.linearDepthTexture = Texture.createDataTexture2D(device, "SceneLinearDepthTexture", 1, 1, this.linearDepthFormat);
		const renderTarget = new RenderTarget({
			name: "PrepassRT",
			colorBuffer: this.linearDepthTexture,
			// use depth buffer, but this can be discarded after the prepass as the depth is stored in the linearDepthTexture
			depth: true,
			// always single sampled
			samples: 1
		});
		this.camera.shaderParams.sceneDepthMapLinear = true;
		this.init(renderTarget, options2);
	}
	after() {
		this.device.scope.resolve(DEPTH_UNIFORM_NAME).setValue(this.linearDepthTexture);
	}
	execute() {
		const { renderer, scene, renderTarget } = this;
		const camera = this.camera.camera;
		const layers = scene.layers.layerList;
		const isTransparent = scene.layers.subLayerList;
		for (const i2 of this._qualifiedLayerIndices) {
			const layer = layers[i2];
			const culledInstances = layer.getCulledInstances(camera);
			const meshInstances = isTransparent[i2] ? culledInstances.transparent : culledInstances.opaque;
			for (let j = 0; j < meshInstances.length; j++) {
				const meshInstance = meshInstances[j];
				if (meshInstance.material?.depthWrite) {
					tempMeshInstances2.push(meshInstance);
				}
			}
			renderer.renderForwardLayer(camera, renderTarget, null, void 0, SHADER_PREPASS, {
				meshInstances: tempMeshInstances2
			});
			tempMeshInstances2.length = 0;
		}
	}
	frameUpdate() {
		super.frameUpdate();
		const { camera } = this;
		this.setClearDepth(camera.clearDepthBuffer ? 1 : void 0);
		let clearValue;
		if (camera.clearDepthBuffer) {
			const farClip = camera.farClip - Number.MIN_VALUE;
			clearValue = this.linearDepthClearValue;
			if (this.linearDepthFormat === PIXELFORMAT_R32F) {
				clearValue.r = farClip;
			} else {
				FloatPacking.float2RGBA8(farClip, clearValue);
			}
		}
		this.setClearColor(clearValue);
		const { renderer, scene } = this;
		const cullCamera = this.camera.camera;
		const composition = scene.layers;
		const layerList = composition.layerList;
		const qualified = this._qualifiedLayerIndices;
		qualified.length = 0;
		for (let i2 = 0; i2 < layerList.length; i2++) {
			if (layerList[i2].id === LAYERID_DEPTH) break;
			if (composition.isSubLayerRenderedByCamera(i2, cullCamera)) {
				qualified.push(i2);
				renderer.culler.requestMeshInstanceCull(cullCamera, layerList[i2]);
			}
		}
	}
};

var depthAwareBlur_default = `
	#include "screenDepthPS"
	varying vec2 uv0;
	uniform sampler2D sourceTexture;
	uniform vec2 sourceInvResolution;
	uniform int filterSize;
	float random(const highp vec2 w) {
		const vec3 m = vec3(0.06711056, 0.00583715, 52.9829189);
		return fract(m.z * fract(dot(w, m.xy)));
	}
	mediump float bilateralWeight(in mediump float depth, in mediump float sampleDepth) {
		mediump float diff = (sampleDepth - depth);
		return max(0.0, 1.0 - diff * diff);
	}
	void tap(inout float sum, inout float totalWeight, float weight, float depth, vec2 position) {
		mediump float color = texture2D(sourceTexture, position).r;
		mediump float textureDepth = -getLinearScreenDepth(position);
	
		mediump float bilateral = bilateralWeight(depth, textureDepth);
		bilateral *= weight;
		sum += color * bilateral;
		totalWeight += bilateral;
	}
	void main() {
		mediump float depth = -getLinearScreenDepth(uv0);
		mediump float totalWeight = 1.0;
		mediump float color = texture2D(sourceTexture, uv0 ).r;
		mediump float sum = color * totalWeight;
		for (mediump int i = -filterSize; i <= filterSize; i++) {
			mediump float weight = 1.0;
			#ifdef HORIZONTAL
				vec2 offset = vec2(i, 0) * sourceInvResolution;
			#else
				vec2 offset = vec2(0, i) * sourceInvResolution;
			#endif
			tap(sum, totalWeight, weight, depth, uv0 + offset);
		}
		mediump float ao = sum / totalWeight;
		gl_FragColor.r = ao;
	}
`;

var depthAwareBlur_default2 = `
#include "screenDepthPS"
varying uv0: vec2f;
var sourceTexture: texture_2d<f32>;
var sourceTextureSampler: sampler;
uniform sourceInvResolution: vec2f;
uniform filterSize: i32;
fn random(w: vec2f) -> f32 {
	const m: vec3f = vec3f(0.06711056, 0.00583715, 52.9829189);
	return fract(m.z * fract(dot(w, m.xy)));
}
fn bilateralWeight(depth: f32, sampleDepth: f32) -> f32 {
	let diff: f32 = (sampleDepth - depth);
	return max(0.0, 1.0 - diff * diff);
}
fn tap(sum_ptr: ptr<function, f32>, totalWeight_ptr: ptr<function, f32>, weight: f32, depth: f32, position: vec2f) {
	let color: f32 = textureSample(sourceTexture, sourceTextureSampler, position).r;
	let textureDepth: f32 = -getLinearScreenDepth(position);
	let bilateral: f32 = bilateralWeight(depth, textureDepth) * weight;
	*sum_ptr = *sum_ptr + color * bilateral;
	*totalWeight_ptr = *totalWeight_ptr + bilateral;
}
@fragment
fn fragmentMain(input: FragmentInput) -> FragmentOutput {
	var output: FragmentOutput;
	let depth: f32 = -getLinearScreenDepth(input.uv0);
	var totalWeight: f32 = 1.0;
	let color: f32 = textureSample(sourceTexture, sourceTextureSampler, input.uv0 ).r;
	var sum: f32 = color * totalWeight;
	for (var i: i32 = -uniform.filterSize; i <= uniform.filterSize; i = i + 1) {
		let weight: f32 = 1.0;
		#ifdef HORIZONTAL
			var offset: vec2f = vec2f(f32(i), 0.0) * uniform.sourceInvResolution;
		#else
			var offset: vec2f = vec2f(0.0, f32(i)) * uniform.sourceInvResolution;
		#endif
		tap(&sum, &totalWeight, weight, depth, input.uv0 + offset);
	}
	let ao: f32 = sum / totalWeight;
	output.color = vec4f(ao, ao, ao, 1.0);
	return output;
}
`;

var RenderPassDepthAwareBlur = class extends RenderPassShaderQuad {
	constructor(device, sourceTexture, cameraComponent, horizontal) {
		super(device);
		this.sourceTexture = sourceTexture;
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("depthAwareBlurPS", depthAwareBlur_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("depthAwareBlurPS", depthAwareBlur_default2);
		const defines = /* @__PURE__ */ new Map();
		if (horizontal) defines.set("HORIZONTAL", "");
		ShaderUtils.addScreenDepthChunkDefines(cameraComponent.shaderParams, defines);
		this.shader = ShaderUtils.createShader(device, {
			uniqueName: `DepthAware${horizontal ? "Horizontal" : "Vertical"}BlurShader`,
			attributes: { aPosition: SEMANTIC_POSITION },
			vertexChunk: "quadVS",
			fragmentChunk: "depthAwareBlurPS",
			fragmentDefines: defines
		});
		const scope = this.device.scope;
		this.sourceTextureId = scope.resolve("sourceTexture");
		this.sourceInvResolutionId = scope.resolve("sourceInvResolution");
		this.sourceInvResolutionValue = new Float32Array(2);
		this.filterSizeId = scope.resolve("filterSize");
	}
	execute() {
		this.filterSizeId.setValue(4);
		this.sourceTextureId.setValue(this.sourceTexture);
		const { width, height } = this.sourceTexture;
		this.sourceInvResolutionValue[0] = 1 / width;
		this.sourceInvResolutionValue[1] = 1 / height;
		this.sourceInvResolutionId.setValue(this.sourceInvResolutionValue);
		super.execute();
	}
};

var ssao_default = `
	#include "screenDepthPS"
	
	varying vec2 uv0;
	uniform vec2 uInvResolution;
	uniform float uAspect;
	#define saturate(x) clamp(x,0.0,1.0)
	highp float getWFromProjectionMatrix(const mat4 p, const vec3 v) {
		return -v.z;
	}
	highp float getViewSpaceZFromW(const mat4 p, const float w) {
		return -w;
	}
	const float kLog2LodRate = 3.0;
	float random(const highp vec2 w) {
		const vec3 m = vec3(0.06711056, 0.00583715, 52.9829189);
		return fract(m.z * fract(dot(w, m.xy)));
	}
	highp vec2 getFragCoord() {
		return gl_FragCoord.xy;
	}
	highp vec3 computeViewSpacePositionFromDepth(highp vec2 uv, highp float linearDepth) {
		return vec3((0.5 - uv) * vec2(uAspect, 1.0) * linearDepth, linearDepth);
	}
	highp vec3 faceNormal(highp vec3 dpdx, highp vec3 dpdy) {
		return normalize(cross(dpdx, dpdy));
	}
	highp vec3 computeViewSpaceNormal(const highp vec3 position) {
		return faceNormal(dFdx(position), dFdy(position));
	}
	highp vec3 computeViewSpaceNormal(const highp vec3 position, const highp vec2 uv) {
		highp vec2 uvdx = uv + vec2(uInvResolution.x, 0.0);
		highp vec2 uvdy = uv + vec2(0.0, uInvResolution.y);
		highp vec3 px = computeViewSpacePositionFromDepth(uvdx, -getLinearScreenDepth(uvdx));
		highp vec3 py = computeViewSpacePositionFromDepth(uvdy, -getLinearScreenDepth(uvdy));
		highp vec3 dpdx = px - position;
		highp vec3 dpdy = py - position;
		return faceNormal(dpdx, dpdy);
	}
	uniform vec2 uSampleCount;
	uniform float uSpiralTurns;
	#define PI (3.14159)
	mediump vec3 tapLocation(mediump float i, const mediump float noise) {
		mediump float offset = ((2.0 * PI) * 2.4) * noise;
		mediump float angle = ((i * uSampleCount.y) * uSpiralTurns) * (2.0 * PI) + offset;
		mediump float radius = (i + noise + 0.5) * uSampleCount.y;
		return vec3(cos(angle), sin(angle), radius * radius);
	}
	highp vec2 startPosition(const float noise) {
		float angle = ((2.0 * PI) * 2.4) * noise;
		return vec2(cos(angle), sin(angle));
	}
	uniform vec2 uAngleIncCosSin;
	highp mat2 tapAngleStep() {
		highp vec2 t = uAngleIncCosSin;
		return mat2(t.x, t.y, -t.y, t.x);
	}
	mediump vec3 tapLocationFast(mediump float i, mediump vec2 p, const mediump float noise) {
		mediump float radius = (i + noise + 0.5) * uSampleCount.y;
		return vec3(p, radius * radius);
	}
	uniform float uMaxLevel;
	uniform float uInvRadiusSquared;
	uniform float uMinHorizonAngleSineSquared;
	uniform float uBias;
	uniform float uPeak2;
	void computeAmbientOcclusionSAO(inout mediump float occlusion, mediump float i, mediump float ssDiskRadius,
			const highp vec2 uv, const highp vec3 origin, const mediump vec3 normal,
			const mediump vec2 tapPosition, const float noise) {
		mediump vec3 tap = tapLocationFast(i, tapPosition, noise);
		mediump float ssRadius = max(1.0, tap.z * ssDiskRadius);
		mediump vec2 uvSamplePos = uv + vec2(ssRadius * tap.xy) * uInvResolution;
		mediump float level = clamp(floor(log2(ssRadius)) - kLog2LodRate, 0.0, float(uMaxLevel));
		highp float occlusionDepth = -getLinearScreenDepth(uvSamplePos);
		highp vec3 p = computeViewSpacePositionFromDepth(uvSamplePos, occlusionDepth);
		vec3 v = p - origin;
		float vv = dot(v, v);
		float vn = dot(v, normal);
		mediump float w = max(0.0, 1.0 - vv * uInvRadiusSquared);
		w = w * w;
		w *= step(vv * uMinHorizonAngleSineSquared, vn * vn);
		occlusion += w * max(0.0, vn + origin.z * uBias) / (vv + uPeak2);
	}
	uniform float uProjectionScaleRadius;
	uniform float uIntensity;
	uniform float uRandomize;
	float scalableAmbientObscurance(highp vec2 uv, highp vec3 origin, vec3 normal) {
		float noise = random(getFragCoord()) + uRandomize;
		highp vec2 tapPosition = startPosition(noise);
		highp mat2 angleStep = tapAngleStep();
		float ssDiskRadius = -(uProjectionScaleRadius / origin.z);
		float occlusion = 0.0;
		for (float i = 0.0; i < uSampleCount.x; i += 1.0) {
			computeAmbientOcclusionSAO(occlusion, i, ssDiskRadius, uv, origin, normal, tapPosition, noise);
			tapPosition = angleStep * tapPosition;
		}
		return occlusion;
	}
	uniform float uPower;
	void main() {
		highp vec2 uv = uv0;
		highp float depth = -getLinearScreenDepth(uv0);
		highp vec3 origin = computeViewSpacePositionFromDepth(uv, depth);
		vec3 normal = computeViewSpaceNormal(origin, uv);
		float occlusion = 0.0;
		if (uIntensity > 0.0) {
			occlusion = scalableAmbientObscurance(uv, origin, normal);
		}
		float ao = max(0.0, 1.0 - occlusion * uIntensity);
		ao = pow(ao, uPower);
		gl_FragColor = vec4(ao, ao, ao, 1.0);
	}
`;

var ssao_default2 = `
	#include "screenDepthPS"
	varying uv0: vec2f;
	uniform uInvResolution: vec2f;
	uniform uAspect: f32;
	fn getWFromProjectionMatrix(p: mat4x4f, v: vec3f) -> f32 {
		return -v.z;
	}
	fn getViewSpaceZFromW(p: mat4x4f, w: f32) -> f32 {
		return -w;
	}
	const kLog2LodRate: f32 = 3.0;
	fn random(w: vec2f) -> f32 {
		const m: vec3f = vec3f(0.06711056, 0.00583715, 52.9829189);
		return fract(m.z * fract(dot(w, m.xy)));
	}
	fn getFragCoord() -> vec2f {
		return pcPosition.xy;
	}
	fn computeViewSpacePositionFromDepth(uv: vec2f, linearDepth: f32) -> vec3f {
		return vec3f((0.5 - uv) * vec2f(uniform.uAspect, 1.0) * linearDepth, linearDepth);
	}
	fn faceNormal(dpdx: vec3f, dpdy: vec3f) -> vec3f {
		return normalize(cross(dpdx, dpdy));
	}
	fn computeViewSpaceNormalDeriv(position: vec3f) -> vec3f {
		return faceNormal(dpdx(position), dpdy(position));
	}
	fn computeViewSpaceNormalDepth(position: vec3f, uv: vec2f) -> vec3f {
		let uvdx: vec2f = uv + vec2f(uniform.uInvResolution.x, 0.0);
		let uvdy: vec2f = uv + vec2f(0.0, uniform.uInvResolution.y);
		let px: vec3f = computeViewSpacePositionFromDepth(uvdx, -getLinearScreenDepth(uvdx));
		let py: vec3f = computeViewSpacePositionFromDepth(uvdy, -getLinearScreenDepth(uvdy));
		let dpdx: vec3f = px - position;
		let dpdy: vec3f = py - position;
		return faceNormal(dpdx, dpdy);
	}
	uniform uSampleCount: vec2f;
	uniform uSpiralTurns: f32;
	const PI: f32 = 3.14159;
	fn tapLocation(i: f32, noise: f32) -> vec3f {
		let offset: f32 = ((2.0 * PI) * 2.4) * noise;
		let angle: f32 = ((i * uniform.uSampleCount.y) * uniform.uSpiralTurns) * (2.0 * PI) + offset;
		let radius: f32 = (i + noise + 0.5) * uniform.uSampleCount.y;
		return vec3f(cos(angle), sin(angle), radius * radius);
	}
	fn startPosition(noise: f32) -> vec2f {
		let angle: f32 = ((2.0 * PI) * 2.4) * noise;
		return vec2f(cos(angle), sin(angle));
	}
	uniform uAngleIncCosSin: vec2f;
	fn tapAngleStep() -> mat2x2f {
		let t: vec2f = uniform.uAngleIncCosSin;
		return mat2x2f(vec2f(t.x, t.y), vec2f(-t.y, t.x));
	}
	fn tapLocationFast(i: f32, p: vec2f, noise_in: f32) -> vec3f {
		let radius: f32 = (i + noise_in + 0.5) * uniform.uSampleCount.y;
		return vec3f(p.x, p.y, radius * radius);
	}
	uniform uMaxLevel: f32;
	uniform uInvRadiusSquared: f32;
	uniform uMinHorizonAngleSineSquared: f32;
	uniform uBias: f32;
	uniform uPeak2: f32;
	fn computeAmbientOcclusionSAO(occlusion_ptr: ptr<function, f32>, i: f32, ssDiskRadius: f32,
			uv: vec2f, origin: vec3f, normal: vec3f,
			tapPosition: vec2f, noise: f32) {
		let tap: vec3f = tapLocationFast(i, tapPosition, noise);
		let ssRadius: f32 = max(1.0, tap.z * ssDiskRadius);
		let uvSamplePos: vec2f = uv + (ssRadius * tap.xy) * uniform.uInvResolution;
		let level: f32 = clamp(floor(log2(ssRadius)) - kLog2LodRate, 0.0, uniform.uMaxLevel);
		let occlusionDepth: f32 = -getLinearScreenDepth(uvSamplePos);
		let p: vec3f = computeViewSpacePositionFromDepth(uvSamplePos, occlusionDepth);
		let v: vec3f = p - origin;
		let vv: f32 = dot(v, v);
		let vn: f32 = dot(v, normal);
		var w_val: f32 = max(0.0, 1.0 - vv * uniform.uInvRadiusSquared);
		w_val = w_val * w_val;
		w_val = w_val * step(vv * uniform.uMinHorizonAngleSineSquared, vn * vn);
		*occlusion_ptr = *occlusion_ptr + w_val * max(0.0, vn + origin.z * uniform.uBias) / (vv + uniform.uPeak2);
	}
	uniform uProjectionScaleRadius: f32;
	uniform uIntensity: f32;
	uniform uRandomize: f32;
	fn scalableAmbientObscurance(uv: vec2f, origin: vec3f, normal: vec3f) -> f32 {
		let noise: f32 = random(getFragCoord()) + uniform.uRandomize;
		var tapPosition: vec2f = startPosition(noise);
		let angleStep: mat2x2f = tapAngleStep();
		let ssDiskRadius: f32 = -(uniform.uProjectionScaleRadius / origin.z);
		var occlusion: f32 = 0.0;
		for (var i: i32 = 0; i < i32(uniform.uSampleCount.x); i = i + 1) {
			computeAmbientOcclusionSAO(&occlusion, f32(i), ssDiskRadius, uv, origin, normal, tapPosition, noise);
			tapPosition = angleStep * tapPosition;
		}
		return occlusion;
	}
	uniform uPower: f32;
	@fragment
	fn fragmentMain(input: FragmentInput) -> FragmentOutput {
		var output: FragmentOutput;
		let uv: vec2f = input.uv0;
		let depth: f32 = -getLinearScreenDepth(input.uv0);
		let origin: vec3f = computeViewSpacePositionFromDepth(uv, depth);
		let normal: vec3f = computeViewSpaceNormalDepth(origin, uv);
		var occlusion: f32 = 0.0;
		if (uniform.uIntensity > 0.0) {
			occlusion = scalableAmbientObscurance(uv, origin, normal);
		}
		var ao: f32 = max(0.0, 1.0 - occlusion * uniform.uIntensity);
		ao = pow(ao, uniform.uPower);
		output.color = vec4f(ao, ao, ao, 1.0);
		return output;
	}
`;

var RenderPassSsao = class extends RenderPassShaderQuad {
	radius = 5;
	intensity = 1;
	power = 1;
	sampleCount = 10;
	minAngle = 5;
	randomize = false;
	ssaoTexture;
	_scale = 1;
	_blueNoise = new BlueNoise(19);
	constructor(device, sourceTexture, cameraComponent, blurEnabled) {
		super(device);
		this.sourceTexture = sourceTexture;
		this.cameraComponent = cameraComponent;
		ShaderChunks.get(device, SHADERLANGUAGE_GLSL).set("ssaoPS", ssao_default);
		ShaderChunks.get(device, SHADERLANGUAGE_WGSL).set("ssaoPS", ssao_default2);
		const defines = /* @__PURE__ */ new Map();
		ShaderUtils.addScreenDepthChunkDefines(cameraComponent.shaderParams, defines);
		this.shader = ShaderUtils.createShader(device, {
			uniqueName: "SsaoShader",
			attributes: { aPosition: SEMANTIC_POSITION },
			vertexChunk: "quadVS",
			fragmentChunk: "ssaoPS",
			fragmentDefines: defines
		});
		const rt = this.createRenderTarget("SsaoFinalTexture");
		this.ssaoTexture = rt.colorBuffer;
		this.init(rt, {
			resizeSource: this.sourceTexture
		});
		const clearColor = new Color(0, 0, 0, 0);
		this.setClearColor(clearColor);
		if (blurEnabled) {
			const blurRT = this.createRenderTarget("SsaoTempTexture");
			const blurPassHorizontal = new RenderPassDepthAwareBlur(device, rt.colorBuffer, cameraComponent, true);
			blurPassHorizontal.init(blurRT, {
				resizeSource: rt.colorBuffer
			});
			blurPassHorizontal.setClearColor(clearColor);
			const blurPassVertical = new RenderPassDepthAwareBlur(device, blurRT.colorBuffer, cameraComponent, false);
			blurPassVertical.init(rt, {
				resizeSource: rt.colorBuffer
			});
			blurPassVertical.setClearColor(clearColor);
			this.afterPasses.push(blurPassHorizontal);
			this.afterPasses.push(blurPassVertical);
		}
		this.ssaoTextureId = device.scope.resolve("ssaoTexture");
		this.ssaoTextureSizeInvId = device.scope.resolve("ssaoTextureSizeInv");
	}
	destroy() {
		this.renderTarget?.destroyTextureBuffers();
		this.renderTarget?.destroy();
		this.renderTarget = null;
		if (this.afterPasses.length > 0) {
			const blurRt = this.afterPasses[0].renderTarget;
			blurRt?.destroyTextureBuffers();
			blurRt?.destroy();
		}
		this.afterPasses.forEach((pass) => pass.destroy());
		this.afterPasses.length = 0;
		super.destroy();
	}
	set scale(value) {
		this._scale = value;
		this.scaleX = value;
		this.scaleY = value;
	}
	get scale() {
		return this._scale;
	}
	createRenderTarget(name) {
		return new RenderTarget({
			depth: false,
			colorBuffer: Texture.createDataTexture2D(this.device, name, 1, 1, PIXELFORMAT_R8)
		});
	}
	execute() {
		const { device, sourceTexture, sampleCount, minAngle, scale: scale2 } = this;
		const { width, height } = this.renderTarget.colorBuffer;
		const scope = device.scope;
		scope.resolve("uAspect").setValue(width / height);
		scope.resolve("uInvResolution").setValue([1 / width, 1 / height]);
		scope.resolve("uSampleCount").setValue([sampleCount, 1 / sampleCount]);
		const minAngleSin = Math.sin(minAngle * math.DEG_TO_RAD);
		scope.resolve("uMinHorizonAngleSineSquared").setValue(minAngleSin * minAngleSin);
		const spiralTurns = 10;
		const step = 1 / (sampleCount - 0.5) * spiralTurns * 2 * 3.141;
		const radius = this.radius / scale2;
		const bias = 1e-3;
		const peak = 0.1 * radius;
		const intensity = 2 * (peak * 2 * 3.141) * this.intensity / sampleCount;
		const projectionScale = 0.5 * sourceTexture.height;
		scope.resolve("uSpiralTurns").setValue(spiralTurns);
		scope.resolve("uAngleIncCosSin").setValue([Math.cos(step), Math.sin(step)]);
		scope.resolve("uMaxLevel").setValue(0);
		scope.resolve("uInvRadiusSquared").setValue(1 / (radius * radius));
		scope.resolve("uBias").setValue(bias);
		scope.resolve("uPeak2").setValue(peak * peak);
		scope.resolve("uIntensity").setValue(intensity);
		scope.resolve("uPower").setValue(this.power);
		scope.resolve("uProjectionScaleRadius").setValue(projectionScale * radius);
		scope.resolve("uRandomize").setValue(this.randomize ? this._blueNoise.value() : 0);
		super.execute();
	}
	after() {
		this.ssaoTextureId.setValue(this.ssaoTexture);
		const srcTexture = this.sourceTexture;
		this.ssaoTextureSizeInvId.setValue([1 / srcTexture.width, 1 / srcTexture.height]);
	}
};

var CameraFrameOptions = class {
	formats;
	stencil = false;
	samples = 1;
	sceneColorMap = false;
	// skybox is the last layer rendered before the grab passes
	lastGrabLayerId = LAYERID_SKYBOX;
	lastGrabLayerIsTransparent = false;
	// immediate layer is the last layer rendered before the post-processing
	lastSceneLayerId = LAYERID_IMMEDIATE;
	lastSceneLayerIsTransparent = true;
	// TAA
	taaEnabled = false;
	// Bloom
	bloomEnabled = false;
	// SSAO
	ssaoType = SSAOTYPE_NONE;
	ssaoBlurEnabled = true;
	prepassEnabled = false;
	// DOF
	dofEnabled = false;
	dofNearBlur = false;
	dofHighQuality = true;
	// Volumetric fog
	volumetricFogEnabled = false;
};
var _defaultOptions = new CameraFrameOptions();
var FramePassCameraFrame = class extends FramePass {
	app;
	prePass;
	scenePass;
	composePass;
	bloomPass;
	ssaoPass;
	taaPass;
	scenePassHalf;
	dofPass;
	volumetricFogPass;
	_renderTargetScale = 1;
	layersDirty = false;
	cameraFrame;
	rt = null;
	constructor(app2, cameraFrame, cameraComponent, options2 = {}) {
		super(app2.graphicsDevice);
		this.app = app2;
		this.cameraComponent = cameraComponent;
		this.cameraFrame = cameraFrame;
		this.options = this.sanitizeOptions(options2);
		this.setupRenderPasses(this.options);
	}
	destroy() {
		this.reset();
	}
	reset() {
		this.sceneTexture = null;
		this.sceneTextureHalf = null;
		if (this.rt) {
			this.rt.destroyTextureBuffers();
			this.rt.destroy();
			this.rt = null;
		}
		if (this.rtHalf) {
			this.rtHalf.destroyTextureBuffers();
			this.rtHalf.destroy();
			this.rtHalf = null;
		}
		this.beforePasses.forEach((pass) => pass.destroy());
		this.beforePasses.length = 0;
		this.prePass = null;
		this.scenePass = null;
		this.scenePassTransparent = null;
		this.colorGrabPass = null;
		this.composePass = null;
		this.bloomPass = null;
		this.ssaoPass = null;
		this.taaPass = null;
		this.afterPass = null;
		this.scenePassHalf = null;
		this.dofPass = null;
		this.volumetricFogPass = null;
	}
	sanitizeOptions(options2) {
		options2 = Object.assign({}, _defaultOptions, options2);
		if (options2.taaEnabled || options2.ssaoType !== SSAOTYPE_NONE || options2.dofEnabled || options2.volumetricFogEnabled) {
			options2.prepassEnabled = true;
		}
		return options2;
	}
	set renderTargetScale(value) {
		this._renderTargetScale = value;
		if (this.scenePass) {
			this.scenePass.scaleX = value;
			this.scenePass.scaleY = value;
		}
	}
	get renderTargetScale() {
		return this._renderTargetScale;
	}
	needsReset(options2) {
		const currentOptions = this.options;
		const arraysNotEqual = (arr1, arr2) => arr1 !== arr2 && (!(Array.isArray(arr1) && Array.isArray(arr2)) || arr1.length !== arr2.length || !arr1.every((value, index) => value === arr2[index]));
		return options2.ssaoType !== currentOptions.ssaoType || options2.ssaoBlurEnabled !== currentOptions.ssaoBlurEnabled || options2.taaEnabled !== currentOptions.taaEnabled || options2.samples !== currentOptions.samples || options2.stencil !== currentOptions.stencil || options2.bloomEnabled !== currentOptions.bloomEnabled || options2.prepassEnabled !== currentOptions.prepassEnabled || options2.sceneColorMap !== currentOptions.sceneColorMap || options2.dofEnabled !== currentOptions.dofEnabled || options2.dofNearBlur !== currentOptions.dofNearBlur || options2.dofHighQuality !== currentOptions.dofHighQuality || options2.volumetricFogEnabled !== currentOptions.volumetricFogEnabled || arraysNotEqual(options2.formats, currentOptions.formats);
	}
	// manually called, applies changes
	update(options2) {
		options2 = this.sanitizeOptions(options2);
		if (this.needsReset(options2) || this.layersDirty) {
			this.layersDirty = false;
			this.reset();
		}
		this.options = options2;
		if (!this.sceneTexture) {
			this.setupRenderPasses(this.options);
		}
	}
	createRenderTarget(name, depth, stencil, samples, flipY) {
		const texture = new Texture(this.device, {
			name,
			width: 4,
			height: 4,
			format: this.hdrFormat,
			mipmaps: false,
			minFilter: FILTER_LINEAR,
			magFilter: FILTER_LINEAR,
			addressU: ADDRESS_CLAMP_TO_EDGE,
			addressV: ADDRESS_CLAMP_TO_EDGE
		});
		return new RenderTarget({
			colorBuffer: texture,
			depth,
			stencil,
			samples,
			flipY
		});
	}
	setupRenderPasses(options2) {
		const { device } = this;
		const cameraComponent = this.cameraComponent;
		const targetRenderTarget = cameraComponent.renderTarget;
		this.hdrFormat = device.getRenderableHdrFormat(options2.formats, true, options2.samples) || PIXELFORMAT_RGBA8;
		this._bloomEnabled = options2.bloomEnabled && this.hdrFormat !== PIXELFORMAT_RGBA8;
		this._sceneHalfEnabled = this._bloomEnabled || options2.dofEnabled;
		cameraComponent.shaderParams.ssaoEnabled = options2.ssaoType === SSAOTYPE_LIGHTING;
		const flipY = !!targetRenderTarget?.flipY;
		this.rt = this.createRenderTarget("SceneColor", true, options2.stencil, options2.samples, flipY);
		this.sceneTexture = this.rt.colorBuffer;
		if (this._sceneHalfEnabled) {
			this.rtHalf = this.createRenderTarget("SceneColorHalf", false, false, 1, flipY);
			this.sceneTextureHalf = this.rtHalf.colorBuffer;
		}
		this.sceneOptions = {
			resizeSource: targetRenderTarget,
			scaleX: this.renderTargetScale,
			scaleY: this.renderTargetScale
		};
		this.createPasses(options2);
		const allPasses = this.collectPasses();
		this.beforePasses = allPasses.filter((element) => element !== void 0 && element !== null);
		this.updateCameraUseFlags();
	}
	updateCameraUseFlags() {
		const firstSeen = /* @__PURE__ */ new Map();
		const lastSeen = /* @__PURE__ */ new Map();
		for (let i2 = 0; i2 < this.beforePasses.length; i2++) {
			const pass = this.beforePasses[i2];
			if (pass instanceof RenderPassForward) {
				const steps = pass.layerRenderSteps;
				for (let j = 0; j < steps.length; j++) {
					const step = steps[j];
					const cam = step.cameraComponent;
					if (cam) {
						if (!firstSeen.has(cam)) {
							firstSeen.set(cam, step);
						}
						lastSeen.set(cam, step);
					}
				}
			}
		}
		firstSeen.forEach((step) => {
			step.firstCameraUse = true;
		});
		lastSeen.forEach((step) => {
			step.lastCameraUse = true;
		});
	}
	collectPasses() {
		return [this.prePass, this.ssaoPass, this.scenePass, this.colorGrabPass, this.scenePassTransparent, this.volumetricFogPass, this.taaPass, this.scenePassHalf, this.bloomPass, this.dofPass, this.composePass, this.afterPass];
	}
	createPasses(options2) {
		this.setupScenePrepass(options2);
		this.setupSsaoPass(options2);
		const scenePassesInfo = this.setupScenePass(options2);
		this.setupVolumetricFogPass(options2);
		const sceneTextureWithTaa = this.setupTaaPass(options2);
		this.setupSceneHalfPass(options2, sceneTextureWithTaa);
		this.setupBloomPass(options2, this.sceneTextureHalf);
		this.setupDofPass(options2, this.sceneTexture, this.sceneTextureHalf);
		this.setupComposePass(options2);
		this.setupAfterPass(options2, scenePassesInfo);
	}
	setupScenePrepass(options2) {
		if (options2.prepassEnabled) {
			const { app: app2, device, cameraComponent } = this;
			const { scene, renderer } = app2;
			this.prePass = new RenderPassPrepass(device, scene, renderer, cameraComponent, this.sceneOptions);
		}
	}
	setupScenePassSettings(pass) {
		pass.gammaCorrection = GAMMA_NONE;
		pass.toneMapping = TONEMAP_NONE;
	}
	addCameraLayers(renderPass, startIndex, firstLayerClears, lastLayerId, lastLayerIsTransparent = true) {
		const cameraComponent = this.cameraComponent;
		const { layerList, subLayerList } = renderPass.layerComposition;
		let clearRenderTarget = firstLayerClears;
		let index = startIndex;
		while (index < layerList.length) {
			const layer = layerList[index];
			const isTransparent = subLayerList[index];
			if (cameraComponent.camera.layersSet.has(layer.id)) {
				renderPass.addLayer(cameraComponent, layer, isTransparent, clearRenderTarget);
				clearRenderTarget = false;
			}
			index++;
			if (layer.id === lastLayerId && isTransparent === lastLayerIsTransparent) {
				break;
			}
		}
		return index;
	}
	setupScenePass(options2) {
		const { app: app2, device } = this;
		const { scene, renderer } = app2;
		const composition = scene.layers;
		this.scenePass = new RenderPassForward(device, composition, scene, renderer);
		this.setupScenePassSettings(this.scenePass);
		this.scenePass.init(this.rt, this.sceneOptions);
		const lastLayerId = options2.sceneColorMap ? options2.lastGrabLayerId : options2.lastSceneLayerId;
		const lastLayerIsTransparent = options2.sceneColorMap ? options2.lastGrabLayerIsTransparent : options2.lastSceneLayerIsTransparent;
		const ret = {
			lastAddedIndex: 0,
			// the last layer index added to the scene pass
			clearRenderTarget: true
			// true if the render target should be cleared
		};
		ret.lastAddedIndex = this.addCameraLayers(this.scenePass, ret.lastAddedIndex, ret.clearRenderTarget, lastLayerId, lastLayerIsTransparent);
		ret.clearRenderTarget = false;
		if (options2.sceneColorMap) {
			this.colorGrabPass = new FramePassColorGrab(device);
			this.colorGrabPass.source = this.rt;
			this.scenePassTransparent = new RenderPassForward(device, composition, scene, renderer);
			this.setupScenePassSettings(this.scenePassTransparent);
			this.scenePassTransparent.init(this.rt);
			ret.lastAddedIndex = this.addCameraLayers(this.scenePassTransparent, ret.lastAddedIndex, ret.clearRenderTarget, options2.lastSceneLayerId, options2.lastSceneLayerIsTransparent);
			if (!this.scenePassTransparent.rendersAnything) {
				this.scenePassTransparent.destroy();
				this.scenePassTransparent = null;
			}
			if (this.scenePassTransparent) {
				if (options2.prepassEnabled) {
					this.scenePassTransparent.depthStencilOps.storeDepth = true;
				}
			}
		}
		return ret;
	}
	setupSsaoPass(options2) {
		const { ssaoBlurEnabled, ssaoType } = options2;
		const { device, cameraComponent } = this;
		if (ssaoType !== SSAOTYPE_NONE) {
			this.ssaoPass = new RenderPassSsao(device, this.sceneTexture, cameraComponent, ssaoBlurEnabled);
		}
	}
	setupSceneHalfPass(options2, sourceTexture) {
		if (this._sceneHalfEnabled) {
			this.scenePassHalf = new RenderPassDownsample(this.device, this.sceneTexture, {
				boxFilter: true,
				removeInvalid: true
				// remove invalid pixels to avoid bloom / dof artifacts
			});
			this.scenePassHalf.name = "RenderPassSceneHalf";
			this.scenePassHalf.init(this.rtHalf, {
				resizeSource: sourceTexture,
				scaleX: 0.5,
				scaleY: 0.5
			});
			this.scenePassHalf.setClearColor(Color.BLACK);
		}
	}
	setupBloomPass(options2, inputTexture) {
		if (this._bloomEnabled) {
			this.bloomPass = new FramePassBloom(this.device, inputTexture, this.hdrFormat);
		}
	}
	setupDofPass(options2, inputTexture, inputTextureHalf) {
		if (options2.dofEnabled) {
			this.dofPass = new FramePassDof(this.device, this.cameraComponent, inputTexture, inputTextureHalf, options2.dofHighQuality, options2.dofNearBlur);
		}
	}
	setupVolumetricFogPass(options2) {
		if (options2.volumetricFogEnabled) {
			this.volumetricFogPass = new FramePassVolumetricFog(this.device, this.cameraComponent, this.sceneTexture, this.rt);
			this.volumetricFogPass.temporalDither = options2.taaEnabled;
		}
	}
	setupTaaPass(options2) {
		let textureWithTaa = this.sceneTexture;
		if (options2.taaEnabled) {
			this.taaPass = new RenderPassTAA(this.device, this.sceneTexture, this.cameraComponent);
			textureWithTaa = this.taaPass.historyTexture;
		}
		return textureWithTaa;
	}
	setupComposePass(options2) {
		this.composePass = new RenderPassCompose(this.device);
		this.composePass.bloomTexture = this.bloomPass?.bloomTexture;
		this.composePass.hdrScene = this.hdrFormat !== PIXELFORMAT_RGBA8;
		this.composePass.taaEnabled = options2.taaEnabled;
		this.composePass.cocTexture = this.dofPass?.cocTexture;
		this.composePass.blurTexture = this.dofPass?.blurTexture;
		this.composePass.blurTextureUpscale = !this.dofPass?.highQuality;
		const cameraComponent = this.cameraComponent;
		const targetRenderTarget = cameraComponent.renderTarget;
		this.composePass.init(targetRenderTarget);
		this.composePass.ssaoTexture = options2.ssaoType === SSAOTYPE_COMBINE ? this.ssaoPass.ssaoTexture : null;
	}
	setupAfterPass(options2, scenePassesInfo) {
		const { app: app2, cameraComponent } = this;
		const { scene, renderer } = app2;
		const composition = scene.layers;
		const targetRenderTarget = cameraComponent.renderTarget;
		this.afterPass = new RenderPassForward(this.device, composition, scene, renderer);
		this.afterPass.init(targetRenderTarget);
		this.addCameraLayers(this.afterPass, scenePassesInfo.lastAddedIndex, scenePassesInfo.clearRenderTarget);
	}
	frameUpdate() {
		if (this.layersDirty) {
			this.cameraFrame.update();
		}
		super.frameUpdate();
		const sceneTexture = this.taaPass?.update() ?? this.rt.colorBuffer;
		this.composePass.sceneTexture = sceneTexture;
		this.scenePassHalf?.setSourceTexture(sceneTexture);
	}
};

var CameraFrame = class {
	_enabled = true;
	rendering = {
		renderFormats: [PIXELFORMAT_111110F, PIXELFORMAT_RGBA16F, PIXELFORMAT_RGBA32F],
		stencil: false,
		renderTargetScale: 1,
		samples: 1,
		sceneColorMap: false,
		sceneDepthMap: false,
		toneMapping: 0,
		sharpness: 0
	};
	ssao = {
		type: SSAOTYPE_NONE,
		blurEnabled: true,
		randomize: false,
		intensity: 0.5,
		radius: 30,
		samples: 12,
		power: 6,
		minAngle: 10,
		scale: 1
	};
	bloom = {
		intensity: 0,
		blurLevel: 16
	};
	grading = {
		enabled: false,
		brightness: 1,
		contrast: 1,
		saturation: 1,
		tint: new Color(1, 1, 1, 1)
	};
	colorLUT = {
		texture: null,
		intensity: 1,
		texture2: null,
		intensity2: 1,
		blend: 0
	};
	vignette = {
		intensity: 0,
		inner: 0.5,
		outer: 1,
		curvature: 0.5,
		color: new Color(0, 0, 0)
	};
	taa = {
		enabled: false,
		jitter: 1
	};
	fringing = {
		intensity: 0
	};
	colorEnhance = {
		enabled: false,
		shadows: 0,
		highlights: 0,
		vibrance: 0,
		midtones: 0,
		dehaze: 0
	};
	dof = {
		enabled: false,
		nearBlur: false,
		focusDistance: 100,
		focusRange: 10,
		blurRadius: 3,
		blurRings: 4,
		blurRingPoints: 5,
		highQuality: true
	};
	volumetricFog = {
		enabled: false,
		light: null,
		tint: new Color(1, 1, 1),
		density: 0.01,
		heightBase: 0,
		heightFalloff: 0.05,
		anisotropy: 0.6,
		intensity: 1,
		ambientColor: new Color(1, 1, 1),
		ambientIntensity: 0.02,
		maxDistance: 300,
		steps: 24,
		scale: 0.5
	};
	debug = null;
	options = new CameraFrameOptions();
	renderPassCamera = null;
	constructor(app2, cameraComponent) {
		this.app = app2;
		this.cameraComponent = cameraComponent;
		this.updateOptions();
		this.enable();
		this.cameraLayersChanged = cameraComponent.on("set:layers", () => {
			if (this.renderPassCamera) this.renderPassCamera.layersDirty = true;
		});
	}
	destroy() {
		this.disable();
		this.cameraLayersChanged.off();
	}
	enable() {
		this.renderPassCamera = this.createRenderPass();
		this.cameraComponent.framePasses = [this.renderPassCamera];
	}
	disable() {
		const cameraComponent = this.cameraComponent;
		cameraComponent.framePasses?.forEach((renderPass) => {
			renderPass.destroy();
		});
		cameraComponent.framePasses = [];
		cameraComponent.rendering = null;
		cameraComponent.jitter = 0;
		cameraComponent.shaderParams.ssaoEnabled = false;
		this.renderPassCamera = null;
	}
	createRenderPass() {
		return new FramePassCameraFrame(this.app, this, this.cameraComponent, this.options);
	}
	set enabled(value) {
		if (this._enabled !== value) {
			if (value) {
				this.enable();
			} else {
				this.disable();
			}
			this._enabled = value;
		}
	}
	get enabled() {
		return this._enabled;
	}
	updateOptions() {
		const { options: options2, rendering, bloom, taa, ssao } = this;
		options2.stencil = rendering.stencil;
		options2.samples = rendering.samples;
		options2.sceneColorMap = rendering.sceneColorMap;
		options2.prepassEnabled = rendering.sceneDepthMap;
		options2.bloomEnabled = bloom.intensity > 0;
		options2.taaEnabled = taa.enabled;
		options2.ssaoType = ssao.type;
		options2.ssaoBlurEnabled = ssao.blurEnabled;
		options2.formats = rendering.renderFormats.slice();
		options2.dofEnabled = this.dof.enabled;
		options2.dofNearBlur = this.dof.nearBlur;
		options2.dofHighQuality = this.dof.highQuality;
		options2.volumetricFogEnabled = this._volumetricFogSupported();
	}
	_volumetricFogSupported() {
		const { volumetricFog, cameraComponent } = this;
		if (!volumetricFog.enabled || !volumetricFog.light) {
			return false;
		}
		if (volumetricFog.light.type !== "directional") {
			return false;
		}
		if (cameraComponent.projection !== PROJECTION_PERSPECTIVE) {
			return false;
		}
		return true;
	}
	update() {
		if (!this._enabled) return;
		const cameraComponent = this.cameraComponent;
		const { options: options2, renderPassCamera, rendering, bloom, grading, colorEnhance, vignette, fringing, taa, ssao } = this;
		this.updateOptions();
		renderPassCamera.update(options2);
		const { composePass, bloomPass, ssaoPass, dofPass, volumetricFogPass } = renderPassCamera;
		renderPassCamera.renderTargetScale = math.clamp(rendering.renderTargetScale, 0.1, 1);
		composePass.toneMapping = rendering.toneMapping;
		composePass.sharpness = rendering.sharpness;
		if (options2.bloomEnabled && bloomPass) {
			composePass.bloomIntensity = bloom.intensity;
			bloomPass.blurLevel = bloom.blurLevel;
		}
		if (options2.dofEnabled) {
			dofPass.focusDistance = this.dof.focusDistance;
			dofPass.focusRange = this.dof.focusRange;
			dofPass.blurRadius = this.dof.blurRadius;
			dofPass.blurRings = this.dof.blurRings;
			dofPass.blurRingPoints = this.dof.blurRingPoints;
		}
		if (options2.volumetricFogEnabled) {
			const { volumetricFog } = this;
			volumetricFogPass.light = volumetricFog.light.light;
			volumetricFogPass.tint.copy(volumetricFog.tint);
			volumetricFogPass.density = volumetricFog.density;
			volumetricFogPass.heightBase = volumetricFog.heightBase;
			volumetricFogPass.heightFalloff = volumetricFog.heightFalloff;
			volumetricFogPass.anisotropy = math.clamp(volumetricFog.anisotropy, 0, 0.95);
			volumetricFogPass.intensity = volumetricFog.intensity;
			volumetricFogPass.ambientColor.copy(volumetricFog.ambientColor);
			volumetricFogPass.ambientIntensity = volumetricFog.ambientIntensity;
			volumetricFogPass.maxDistance = volumetricFog.maxDistance;
			volumetricFogPass.steps = math.clamp(volumetricFog.steps, 4, 128);
			volumetricFogPass.scale = math.clamp(volumetricFog.scale, 0.25, 1);
		}
		if (options2.ssaoType !== SSAOTYPE_NONE) {
			ssaoPass.intensity = ssao.intensity;
			ssaoPass.power = ssao.power;
			ssaoPass.radius = ssao.radius;
			ssaoPass.sampleCount = ssao.samples;
			ssaoPass.minAngle = ssao.minAngle;
			ssaoPass.scale = ssao.scale;
			ssaoPass.randomize = ssao.randomize;
		}
		composePass.gradingEnabled = grading.enabled;
		if (grading.enabled) {
			composePass.gradingSaturation = grading.saturation;
			composePass.gradingBrightness = grading.brightness;
			composePass.gradingContrast = grading.contrast;
			composePass.gradingTint = grading.tint;
		}
		composePass.colorLUT = this.colorLUT.texture;
		composePass.colorLUTIntensity = this.colorLUT.intensity;
		composePass.colorLUT2 = this.colorLUT.texture2;
		composePass.colorLUT2Intensity = this.colorLUT.intensity2;
		composePass.colorLUTBlend = this.colorLUT.blend;
		composePass.vignetteEnabled = vignette.intensity > 0;
		if (composePass.vignetteEnabled) {
			composePass.vignetteInner = vignette.inner;
			composePass.vignetteOuter = vignette.outer;
			composePass.vignetteCurvature = vignette.curvature;
			composePass.vignetteIntensity = vignette.intensity;
			composePass.vignetteColor.copy(vignette.color);
		}
		composePass.fringingEnabled = fringing.intensity > 0;
		if (composePass.fringingEnabled) {
			composePass.fringingIntensity = fringing.intensity;
		}
		composePass.colorEnhanceEnabled = colorEnhance.enabled;
		if (colorEnhance.enabled) {
			composePass.colorEnhanceShadows = colorEnhance.shadows;
			composePass.colorEnhanceHighlights = colorEnhance.highlights;
			composePass.colorEnhanceVibrance = colorEnhance.vibrance;
			composePass.colorEnhanceMidtones = colorEnhance.midtones;
			composePass.colorEnhanceDehaze = colorEnhance.dehaze;
		}
		cameraComponent.jitter = taa.enabled ? taa.jitter : 0;
		composePass.debug = this.debug;
		if (composePass.debug === "ssao" && options2.ssaoType === SSAOTYPE_NONE) composePass.debug = null;
		if (composePass.debug === "vignette" && !composePass.vignetteEnabled) composePass.debug = null;
	}
};

var tmpV1 = new Vec3();
var rotation2 = new Quat();
var Pose = class _Pose {
	position = new Vec3();
	angles = new Vec3();
	distance = 0;
	pitchRange = new Vec2(-Infinity, Infinity);
	yawRange = new Vec2(-Infinity, Infinity);
	xRange = new Vec2(-Infinity, Infinity);
	yRange = new Vec2(-Infinity, Infinity);
	zRange = new Vec2(-Infinity, Infinity);
	constructor(position5 = Vec3.ZERO, angles3 = Vec3.ZERO, distance = 0) {
		this.set(position5, angles3, distance);
	}
	copy(other) {
		return this.set(other.position, other.angles, other.distance);
	}
	clone() {
		return new _Pose(this.position.clone(), this.angles.clone(), this.distance);
	}
	equalsApprox(other, epsilon = 1e-6) {
		return this.position.equalsApprox(other.position, epsilon) && this.angles.equalsApprox(other.angles, epsilon) && Math.abs(this.distance - other.distance) < epsilon;
	}
	lerp(lhs, rhs, alpha1, alpha2 = alpha1, alpha3 = alpha1) {
		this.position.lerp(lhs.position, rhs.position, alpha1);
		this.angles.x = math.lerpAngle(lhs.angles.x, rhs.angles.x, alpha2) % 360;
		this.angles.y = math.lerpAngle(lhs.angles.y, rhs.angles.y, alpha2) % 360;
		this.angles.z = math.lerpAngle(lhs.angles.z, rhs.angles.z, alpha2) % 360;
		this.distance = math.lerp(lhs.distance, rhs.distance, alpha3);
		return this;
	}
	move(offset3) {
		this.position.add(offset3);
		this.position.x = math.clamp(this.position.x, this.xRange.x, this.xRange.y);
		this.position.y = math.clamp(this.position.y, this.yRange.x, this.yRange.y);
		this.position.z = math.clamp(this.position.z, this.zRange.x, this.zRange.y);
		return this;
	}
	rotate(euler) {
		this.angles.add(euler);
		this.angles.x %= 360;
		this.angles.y %= 360;
		this.angles.z %= 360;
		this.angles.x = math.clamp(this.angles.x, this.pitchRange.x, this.pitchRange.y);
		this.angles.y = math.clamp(this.angles.y, this.yawRange.x, this.yawRange.y);
		return this;
	}
	set(position5, angles3, distance) {
		this.position.copy(position5);
		this.angles.copy(angles3);
		this.distance = distance;
		return this;
	}
	look(from, to) {
		this.position.copy(from);
		this.distance = from.distance(to);
		const dir4 = tmpV1.sub2(to, from).normalize();
		const elev = Math.atan2(-dir4.y, Math.sqrt(dir4.x * dir4.x + dir4.z * dir4.z)) * math.RAD_TO_DEG;
		const azim = Math.atan2(-dir4.x, -dir4.z) * math.RAD_TO_DEG;
		this.angles.set(-elev, azim, 0);
		return this;
	}
	getFocus(out) {
		return rotation2.setFromEulerAngles(this.angles).transformVector(Vec3.FORWARD, out).mulScalar(this.distance).add(this.position);
	}
};

var InputDelta = class {
	_value;
	constructor(arg) {
		if (Array.isArray(arg)) {
			this._value = arg.slice();
		} else {
			this._value = new Array(+arg).fill(0);
		}
	}
	add(other) {
		for (let i2 = 0; i2 < this._value.length; i2++) {
			this._value[i2] += other._value[i2] || 0;
		}
		return this;
	}
	append(offsets) {
		for (let i2 = 0; i2 < this._value.length; i2++) {
			this._value[i2] += offsets[i2] || 0;
		}
		return this;
	}
	copy(other) {
		for (let i2 = 0; i2 < this._value.length; i2++) {
			this._value[i2] = other._value[i2] || 0;
		}
		return this;
	}
	length() {
		let sum = 0;
		for (const value of this._value) {
			sum += value * value;
		}
		return Math.sqrt(sum);
	}
	read() {
		const value = this._value.slice();
		this._value.fill(0);
		return value;
	}
};
var InputFrame = class {
	deltas = {};
	constructor(data2) {
		for (const name in data2) {
			this.deltas[name] = new InputDelta(data2[name]);
		}
	}
	read() {
		const frame = {};
		for (const name in this.deltas) {
			frame[name] = this.deltas[name].read();
		}
		return frame;
	}
};
var InputSource = class extends InputFrame {
	_element = null;
	_events = new EventHandler();
	on(event, callback) {
		this._events.on(event, callback);
	}
	off(event, callback) {
		this._events.off(event, callback);
	}
	fire(event, ...args) {
		this._events.fire(event, ...args);
	}
	attach(element) {
		if (this._element) {
			this.detach();
		}
		this._element = element;
	}
	detach() {
		if (!this._element) {
			return;
		}
		this._element = null;
		this.read();
	}
	destroy() {
		this.detach();
		this._events.off();
	}
};
var InputConsumer = class {
	update(frame, dt) {
		frame.read();
	}
};
var InputController = class extends InputConsumer {
	_pose = new Pose();
	attach(pose, smooth = true) {
	}
	detach() {
	}
	update(frame, dt) {
		super.update(frame, dt);
		return this._pose;
	}
	destroy() {
		this.detach();
	}
};

var DOUBLE_TAP_THRESHOLD = 250;
var DOUBLE_TAP_VARIANCE = 100;

var isTouchPointer = (pointerType) => pointerType === "touch" || pointerType === "pen";
var movementState = () => {
	const state = /* @__PURE__ */ new Map();
	return {
		down: (event) => {
			state.set(event.pointerId, [event.screenX, event.screenY]);
		},
		move: (event) => {
			if (!state.has(event.pointerId)) {
				return [0, 0];
			}
			const prev = state.get(event.pointerId);
			const mvX = event.screenX - prev[0];
			const mvY = event.screenY - prev[1];
			prev[0] = event.screenX;
			prev[1] = event.screenY;
			return [mvX, mvY];
		},
		up: (event) => {
			state.delete(event.pointerId);
		}
	};
};

var v = new Vec2();
var VirtualJoystick = class {
	_range = 70;
	_position = new Vec2();
	_value = new Vec2();
	constructor({ range } = {}) {
		this._range = range ?? this._range;
	}
	get value() {
		return this._value;
	}
	down(x3, y2) {
		this._position.set(x3, y2);
		this._value.set(0, 0);
		return [x3, y2, x3, y2];
	}
	move(x3, y2) {
		v.set(x3 - this._position.x, y2 - this._position.y);
		if (v.length() > this._range) {
			v.normalize().mulScalar(this._range);
		}
		this._value.set(
			math.clamp(v.x / this._range, -1, 1),
			math.clamp(v.y / this._range, -1, 1)
		);
		const { x: bx, y: by } = this._position;
		return [bx, by, bx + v.x, by + v.y];
	}
	up() {
		this._position.set(0, 0);
		this._value.set(0, 0);
		return [-1, -1, -1, -1];
	}
};

var SingleGestureSource = class extends InputSource {
	_movementState = movementState();
	_layout = "joystick";
	_pointerData = /* @__PURE__ */ new Map();
	_lastPointer = { x: 0, y: 0, time: 0 };
	_joystick;
	constructor() {
		super({
			input: [0, 0],
			doubleTap: [0]
		});
		this._joystick = new VirtualJoystick();
		this._onPointerDown = this._onPointerDown.bind(this);
		this._onPointerMove = this._onPointerMove.bind(this);
		this._onPointerUp = this._onPointerUp.bind(this);
	}
	set layout(value) {
		if (this._layout === value) {
			return;
		}
		this._layout = value;
		this.read();
		this._pointerData.clear();
	}
	get layout() {
		return this._layout;
	}
	get joystick() {
		return this._joystick;
	}
	_onPointerDown(event) {
		const { pointerType, pointerId, clientX, clientY } = event;
		this._movementState.down(event);
		if (!isTouchPointer(pointerType)) {
			return;
		}
		this._element?.setPointerCapture(pointerId);
		this._pointerData.set(pointerId, {
			x: clientX,
			y: clientY
		});
		const now2 = Date.now();
		const sqrDist = (this._lastPointer.x - clientX) ** 2 + (this._lastPointer.y - clientY) ** 2;
		if (sqrDist < DOUBLE_TAP_VARIANCE && now2 - this._lastPointer.time < DOUBLE_TAP_THRESHOLD) {
			this.deltas.doubleTap.append([1]);
		}
		this._lastPointer.x = clientX;
		this._lastPointer.y = clientY;
		this._lastPointer.time = now2;
		if (this._layout === "joystick") {
			this.fire("joystick:position", this._joystick.down(clientX, clientY));
		}
	}
	_onPointerMove(event) {
		const { pointerType, pointerId, target: target2, clientX, clientY } = event;
		const [movementX, movementY] = this._movementState.move(event);
		if (!isTouchPointer(pointerType)) {
			return;
		}
		if (target2 !== this._element) {
			return;
		}
		const data2 = this._pointerData.get(pointerId);
		if (!data2) {
			return;
		}
		data2.x = clientX;
		data2.y = clientY;
		if (this._layout === "joystick") {
			this.fire("joystick:position", this._joystick.move(clientX, clientY));
		} else {
			this.deltas.input.append([movementX, movementY]);
		}
	}
	_onPointerUp(event) {
		const { pointerType, pointerId } = event;
		this._movementState.up(event);
		if (!isTouchPointer(pointerType)) {
			return;
		}
		this._element?.releasePointerCapture(pointerId);
		const data2 = this._pointerData.get(pointerId);
		if (!data2) {
			return;
		}
		this._pointerData.delete(pointerId);
		if (this._layout === "joystick") {
			this.fire("joystick:position", this._joystick.up());
		}
	}
	attach(element) {
		super.attach(element);
		this._element = element;
		this._element.addEventListener("pointerdown", this._onPointerDown);
		this._element.addEventListener("pointermove", this._onPointerMove);
		this._element.addEventListener("pointerup", this._onPointerUp);
		this._element.addEventListener("pointercancel", this._onPointerUp);
	}
	detach() {
		if (!this._element) {
			return;
		}
		this._element.removeEventListener("pointerdown", this._onPointerDown);
		this._element.removeEventListener("pointermove", this._onPointerMove);
		this._element.removeEventListener("pointerup", this._onPointerUp);
		this._element.removeEventListener("pointercancel", this._onPointerUp);
		this._pointerData.clear();
		super.detach();
	}
	read() {
		this.deltas.input.append([this._joystick.value.x, this._joystick.value.y]);
		return super.read();
	}
	destroy() {
		this._joystick.up();
		super.destroy();
	}
};

var startsWith = (str, prefix) => str.indexOf(prefix) === 0;
var endsWith = (str, suffix) => str.indexOf(suffix, str.length - suffix.length) !== -1;
var DualGestureSource = class extends InputSource {
	_movementState = movementState();
	_layout = "joystick-touch";
	_pointerData = /* @__PURE__ */ new Map();
	_lastPointer = { x: 0, y: 0, time: 0 };
	_leftJoystick;
	_rightJoystick;
	constructor(layout) {
		super({
			leftInput: [0, 0],
			rightInput: [0, 0],
			doubleTap: [0]
		});
		if (layout) {
			this.layout = layout;
		}
		this._leftJoystick = new VirtualJoystick();
		this._rightJoystick = new VirtualJoystick();
		this._onPointerDown = this._onPointerDown.bind(this);
		this._onPointerMove = this._onPointerMove.bind(this);
		this._onPointerUp = this._onPointerUp.bind(this);
	}
	set layout(value) {
		if (this._layout === value) {
			return;
		}
		this._layout = value;
		this.read();
		this._pointerData.clear();
	}
	get layout() {
		return this._layout;
	}
	get leftJoystick() {
		return this._leftJoystick;
	}
	get rightJoystick() {
		return this._rightJoystick;
	}
	_onPointerDown(event) {
		const { pointerType, pointerId, clientX, clientY } = event;
		this._movementState.down(event);
		if (pointerType !== "touch") {
			return;
		}
		this._element?.setPointerCapture(pointerId);
		const left = clientX < window.innerWidth * 0.5;
		this._pointerData.set(pointerId, {
			x: clientX,
			y: clientY,
			left
		});
		const now2 = Date.now();
		const sqrDist = (this._lastPointer.x - clientX) ** 2 + (this._lastPointer.y - clientY) ** 2;
		if (sqrDist < DOUBLE_TAP_VARIANCE && now2 - this._lastPointer.time < DOUBLE_TAP_THRESHOLD) {
			this.deltas.doubleTap.append([1]);
		}
		this._lastPointer.x = clientX;
		this._lastPointer.y = clientY;
		this._lastPointer.time = now2;
		if (left && startsWith(this._layout, "joystick")) {
			this.fire("joystick:position:left", this._leftJoystick.down(clientX, clientY));
		}
		if (!left && endsWith(this._layout, "joystick")) {
			this.fire("joystick:position:right", this._rightJoystick.down(clientX, clientY));
		}
	}
	_onPointerMove(event) {
		const { pointerType, pointerId, target: target2, clientX, clientY } = event;
		const [movementX, movementY] = this._movementState.move(event);
		if (pointerType !== "touch") {
			return;
		}
		if (target2 !== this._element) {
			return;
		}
		const data2 = this._pointerData.get(pointerId);
		if (!data2) {
			return;
		}
		const { left } = data2;
		data2.x = clientX;
		data2.y = clientY;
		if (left) {
			if (startsWith(this._layout, "joystick")) {
				this.fire("joystick:position:left", this._leftJoystick.move(clientX, clientY));
			} else {
				this.deltas.leftInput.append([movementX, movementY]);
			}
		} else {
			if (endsWith(this._layout, "joystick")) {
				this.fire("joystick:position:right", this._rightJoystick.move(clientX, clientY));
			} else {
				this.deltas.rightInput.append([movementX, movementY]);
			}
		}
	}
	_onPointerUp(event) {
		const { pointerType, pointerId } = event;
		this._movementState.up(event);
		if (pointerType !== "touch") {
			return;
		}
		this._element?.releasePointerCapture(pointerId);
		const data2 = this._pointerData.get(pointerId);
		if (!data2) {
			return;
		}
		const { left } = data2;
		this._pointerData.delete(pointerId);
		if (left && startsWith(this._layout, "joystick")) {
			this.fire("joystick:position:left", this._leftJoystick.up());
		}
		if (!left && endsWith(this._layout, "joystick")) {
			this.fire("joystick:position:right", this._rightJoystick.up());
		}
	}
	attach(element) {
		super.attach(element);
		this._element = element;
		this._element.addEventListener("pointerdown", this._onPointerDown);
		this._element.addEventListener("pointermove", this._onPointerMove);
		this._element.addEventListener("pointerup", this._onPointerUp);
		this._element.addEventListener("pointercancel", this._onPointerUp);
	}
	detach() {
		if (!this._element) {
			return;
		}
		this._element.removeEventListener("pointerdown", this._onPointerDown);
		this._element.removeEventListener("pointermove", this._onPointerMove);
		this._element.removeEventListener("pointerup", this._onPointerUp);
		this._element.removeEventListener("pointercancel", this._onPointerUp);
		this._pointerData.clear();
		super.detach();
	}
	read() {
		this.deltas.leftInput.append([this._leftJoystick.value.x, this._leftJoystick.value.y]);
		this.deltas.rightInput.append([this._rightJoystick.value.x, this._rightJoystick.value.y]);
		return super.read();
	}
	destroy() {
		this._leftJoystick.up();
		this._rightJoystick.up();
		super.destroy();
	}
};

var tmpVa = new Vec2();
var MultiTouchSource = class extends InputSource {
	_movementState = movementState();
	_pointerEvents = /* @__PURE__ */ new Map();
	_pointerPos = new Vec2();
	_pinchDist = -1;
	constructor() {
		super({
			touch: [0, 0],
			count: [0],
			pinch: [0]
		});
		this._onPointerDown = this._onPointerDown.bind(this);
		this._onPointerMove = this._onPointerMove.bind(this);
		this._onPointerUp = this._onPointerUp.bind(this);
		this._onContextMenu = this._onContextMenu.bind(this);
	}
	_onPointerDown(event) {
		const { pointerId, pointerType } = event;
		this._movementState.down(event);
		if (!isTouchPointer(pointerType)) {
			return;
		}
		this._element?.setPointerCapture(pointerId);
		this._pointerEvents.set(pointerId, event);
		this.deltas.count.append([1]);
		if (this._pointerEvents.size > 1) {
			this._getMidPoint(this._pointerPos);
			this._pinchDist = this._getPinchDist();
		}
	}
	_onPointerMove(event) {
		const { pointerType, target: target2, pointerId } = event;
		const [movementX, movementY] = this._movementState.move(event);
		if (!isTouchPointer(pointerType)) {
			return;
		}
		if (target2 !== this._element) {
			return;
		}
		if (this._pointerEvents.size === 0) {
			return;
		}
		this._pointerEvents.set(pointerId, event);
		if (this._pointerEvents.size > 1) {
			const mid = this._getMidPoint(tmpVa);
			this.deltas.touch.append([mid.x - this._pointerPos.x, mid.y - this._pointerPos.y]);
			this._pointerPos.copy(mid);
			const pinchDist = this._getPinchDist();
			if (this._pinchDist > 0) {
				this.deltas.pinch.append([this._pinchDist - pinchDist]);
			}
			this._pinchDist = pinchDist;
		} else {
			this.deltas.touch.append([movementX, movementY]);
		}
	}
	_onPointerUp(event) {
		const { pointerType, pointerId } = event;
		this._movementState.up(event);
		if (!isTouchPointer(pointerType)) {
			return;
		}
		this._element?.releasePointerCapture(pointerId);
		this._pointerEvents.delete(pointerId);
		this.deltas.count.append([-1]);
		if (this._pointerEvents.size < 2) {
			this._pinchDist = -1;
		}
		this._pointerPos.set(0, 0);
	}
	_onContextMenu(event) {
		event.preventDefault();
	}
	_getMidPoint(out) {
		if (this._pointerEvents.size < 2) {
			return out.set(0, 0);
		}
		const [a, b] = this._pointerEvents.values();
		const dx = a.clientX - b.clientX;
		const dy = a.clientY - b.clientY;
		return out.set(b.clientX + dx * 0.5, b.clientY + dy * 0.5);
	}
	_getPinchDist() {
		if (this._pointerEvents.size < 2) {
			return 0;
		}
		const [a, b] = this._pointerEvents.values();
		const dx = a.clientX - b.clientX;
		const dy = a.clientY - b.clientY;
		return Math.sqrt(dx * dx + dy * dy);
	}
	attach(element) {
		super.attach(element);
		this._element = element;
		this._element.addEventListener("pointerdown", this._onPointerDown);
		this._element.addEventListener("pointermove", this._onPointerMove);
		this._element.addEventListener("pointerup", this._onPointerUp);
		this._element.addEventListener("pointercancel", this._onPointerUp);
		this._element.addEventListener("contextmenu", this._onContextMenu);
	}
	detach() {
		if (!this._element) {
			return;
		}
		this._element.removeEventListener("pointerdown", this._onPointerDown);
		this._element.removeEventListener("pointermove", this._onPointerMove);
		this._element.removeEventListener("pointerup", this._onPointerUp);
		this._element.removeEventListener("pointercancel", this._onPointerUp);
		this._element.removeEventListener("contextmenu", this._onContextMenu);
		this._pointerEvents.clear();
		super.detach();
	}
};

var PASSIVE = { passive: false };
var KEY_CODES = {
	A: 0,
	B: 1,
	C: 2,
	D: 3,
	E: 4,
	F: 5,
	G: 6,
	H: 7,
	I: 8,
	J: 9,
	K: 10,
	L: 11,
	M: 12,
	N: 13,
	O: 14,
	P: 15,
	Q: 16,
	R: 17,
	S: 18,
	T: 19,
	U: 20,
	V: 21,
	W: 22,
	X: 23,
	Y: 24,
	Z: 25,
	"0": 26,
	"1": 27,
	"2": 28,
	"3": 29,
	"4": 30,
	"5": 31,
	"6": 32,
	"7": 33,
	"8": 34,
	"9": 35,
	UP: 36,
	DOWN: 37,
	LEFT: 38,
	RIGHT: 39,
	SPACE: 40,
	SHIFT: 41,
	CTRL: 42
};
var KEY_COUNT = Object.keys(KEY_CODES).length;
var array2 = Array(KEY_COUNT).fill(0);
var KeyboardMouseSource = class _KeyboardMouseSource extends InputSource {
	_movementState = movementState();
	static keyCode = KEY_CODES;
	_pointerId = -1;
	_pointerLock;
	_keyMap = /* @__PURE__ */ new Map();
	_keyPrev = Array(KEY_COUNT).fill(0);
	_keyNow = Array(KEY_COUNT).fill(0);
	_button = Array(3).fill(0);
	constructor({ pointerLock = false } = {}) {
		super({
			key: Array(KEY_COUNT).fill(0),
			button: [0, 0, 0],
			mouse: [0, 0],
			wheel: [0]
		});
		this._pointerLock = pointerLock ?? false;
		const { keyCode } = _KeyboardMouseSource;
		for (let i2 = 0; i2 < 26; i2++) {
			const code = `Key${String.fromCharCode("A".charCodeAt(0) + i2)}`;
			this._keyMap.set(code, keyCode.A + i2);
		}
		for (let i2 = 0; i2 < 10; i2++) {
			const code = `Digit${i2}`;
			this._keyMap.set(code, keyCode["0"] + i2);
		}
		this._keyMap.set("ArrowUp", keyCode.UP);
		this._keyMap.set("ArrowDown", keyCode.DOWN);
		this._keyMap.set("ArrowLeft", keyCode.LEFT);
		this._keyMap.set("ArrowRight", keyCode.RIGHT);
		this._keyMap.set("Space", keyCode.SPACE);
		this._keyMap.set("ShiftLeft", keyCode.SHIFT);
		this._keyMap.set("ShiftRight", keyCode.SHIFT);
		this._keyMap.set("ControlLeft", keyCode.CTRL);
		this._keyMap.set("ControlRight", keyCode.CTRL);
		this._onWheel = this._onWheel.bind(this);
		this._onPointerDown = this._onPointerDown.bind(this);
		this._onPointerMove = this._onPointerMove.bind(this);
		this._onPointerUp = this._onPointerUp.bind(this);
		this._onContextMenu = this._onContextMenu.bind(this);
		this._onKeyDown = this._onKeyDown.bind(this);
		this._onKeyUp = this._onKeyUp.bind(this);
	}
	_onWheel(event) {
		event.preventDefault();
		this.deltas.wheel.append([event.deltaY]);
	}
	_onPointerDown(event) {
		this._movementState.down(event);
		if (event.pointerType !== "mouse") {
			return;
		}
		if (this._pointerLock) {
			if (document.pointerLockElement !== this._element) {
				this._element?.requestPointerLock();
			}
		} else {
			this._element?.setPointerCapture(event.pointerId);
		}
		this._clearButtons();
		this._button[event.button] = 1;
		this.deltas.button.append(this._button);
		if (this._pointerId !== -1) {
			return;
		}
		this._pointerId = event.pointerId;
	}
	_onPointerMove(event) {
		const [movementX, movementY] = this._pointerLock && document.pointerLockElement === this._element ? [event.movementX, event.movementY] : this._movementState.move(event);
		if (event.pointerType !== "mouse") {
			return;
		}
		if (event.target !== this._element) {
			return;
		}
		if (this._pointerLock) {
			if (document.pointerLockElement !== this._element) {
				return;
			}
		} else {
			if (this._pointerId !== event.pointerId) {
				return;
			}
		}
		this.deltas.mouse.append([movementX, movementY]);
	}
	_onPointerUp(event) {
		this._movementState.up(event);
		if (event.pointerType !== "mouse") {
			return;
		}
		if (!this._pointerLock) {
			this._element?.releasePointerCapture(event.pointerId);
		}
		this._clearButtons();
		this.deltas.button.append(this._button);
		if (this._pointerId !== event.pointerId) {
			return;
		}
		this._pointerId = -1;
	}
	_onContextMenu(event) {
		event.preventDefault();
	}
	_onKeyDown(event) {
		if (this._pointerLock && document.pointerLockElement !== this._element) {
			return;
		}
		event.stopPropagation();
		this._setKey(event.code, 1);
	}
	_onKeyUp(event) {
		event.stopPropagation();
		this._setKey(event.code, 0);
	}
	_clearButtons() {
		for (let i2 = 0; i2 < this._button.length; i2++) {
			if (this._button[i2] === 1) {
				this._button[i2] = -1;
				continue;
			}
			this._button[i2] = 0;
		}
	}
	_setKey(code, value) {
		if (!this._keyMap.has(code)) {
			return;
		}
		this._keyNow[this._keyMap.get(code) ?? 0] = value;
	}
	attach(element) {
		super.attach(element);
		this._element = element;
		this._element.addEventListener("wheel", this._onWheel, PASSIVE);
		this._element.addEventListener("pointerdown", this._onPointerDown);
		this._element.addEventListener("pointermove", this._onPointerMove);
		this._element.addEventListener("pointerup", this._onPointerUp);
		this._element.addEventListener("pointercancel", this._onPointerUp);
		this._element.addEventListener("pointerleave", this._onPointerUp);
		this._element.addEventListener("lostpointercapture", this._onPointerUp);
		this._element.addEventListener("contextmenu", this._onContextMenu);
		window.addEventListener("keydown", this._onKeyDown, false);
		window.addEventListener("keyup", this._onKeyUp, false);
	}
	detach() {
		if (!this._element) {
			return;
		}
		this._element.removeEventListener("wheel", this._onWheel, PASSIVE);
		this._element.removeEventListener("pointerdown", this._onPointerDown);
		this._element.removeEventListener("pointermove", this._onPointerMove);
		this._element.removeEventListener("pointerup", this._onPointerUp);
		this._element.removeEventListener("pointercancel", this._onPointerUp);
		this._element.removeEventListener("pointerleave", this._onPointerUp);
		this._element.removeEventListener("lostpointercapture", this._onPointerUp);
		this._element.removeEventListener("contextmenu", this._onContextMenu);
		window.removeEventListener("keydown", this._onKeyDown, false);
		window.removeEventListener("keyup", this._onKeyUp, false);
		this._keyNow.fill(0);
		this._keyPrev.fill(0);
		super.detach();
	}
	read() {
		for (let i2 = 0; i2 < array2.length; i2++) {
			array2[i2] = this._keyNow[i2] - this._keyPrev[i2];
			this._keyPrev[i2] = this._keyNow[i2];
		}
		this.deltas.key.append(array2);
		return super.read();
	}
};

var BUTTON_CODES = {
	A: 0,
	B: 1,
	X: 2,
	Y: 3,
	LB: 4,
	RB: 5,
	LT: 6,
	RT: 7,
	SELECT: 8,
	START: 9,
	LEFT_STICK: 10,
	RIGHT_STICK: 11
};
var BUTTON_COUNT = Object.keys(BUTTON_CODES).length;
var GamepadSource = class extends InputSource {
	static buttonCode = BUTTON_CODES;
	_buttonPrev = Array(BUTTON_COUNT).fill(0);
	constructor() {
		super({
			buttons: Array(BUTTON_COUNT).fill(0),
			leftStick: [0, 0],
			rightStick: [0, 0]
		});
	}
	read() {
		const gamepads2 = navigator.getGamepads();
		for (let i2 = 0; i2 < gamepads2.length; i2++) {
			const gp = gamepads2[i2];
			if (!gp) {
				continue;
			}
			if (gp.mapping !== "standard") {
				continue;
			}
			if (gp.axes.length < 4) {
				continue;
			}
			if (gp.buttons.length < BUTTON_COUNT) {
				continue;
			}
			const { buttons, axes } = gp;
			for (let j = 0; j < this._buttonPrev.length; j++) {
				const state = +buttons[j].pressed;
				this.deltas.buttons[j] = state - this._buttonPrev[j];
				this._buttonPrev[j] = state;
			}
			this.deltas.leftStick.append([axes[0], axes[1]]);
			this.deltas.rightStick.append([axes[2], axes[3]]);
		}
		return super.read();
	}
};

var damp = (damping, dt) => 1 - Math.pow(damping, dt * 1e3);

var offset = new Vec3();
var angles = new Vec3();
var forward = new Vec3();
var right = new Vec3();
var up2 = new Vec3();
var rotation3 = new Quat();
var FlyController = class extends InputController {
	_targetPose = new Pose();
	rotateDamping = 0.98;
	moveDamping = 0.98;
	set pitchRange(value) {
		this._targetPose.pitchRange.copy(value);
		this._pose.copy(this._targetPose.rotate(Vec3.ZERO));
	}
	get pitchRange() {
		return this._targetPose.pitchRange;
	}
	set yawRange(value) {
		this._targetPose.yawRange.copy(value);
		this._pose.copy(this._targetPose.rotate(Vec3.ZERO));
	}
	get yawRange() {
		return this._targetPose.yawRange;
	}
	attach(pose, smooth = true) {
		this._targetPose.copy(pose);
		if (!smooth) {
			this._pose.copy(this._targetPose);
		}
	}
	detach() {
		this._targetPose.copy(this._pose);
	}
	update(frame, dt) {
		const { move, rotate } = frame.read();
		this._targetPose.rotate(angles.set(-rotate[1], -rotate[0], 0));
		rotation3.setFromEulerAngles(this._pose.angles);
		rotation3.transformVector(Vec3.FORWARD, forward);
		rotation3.transformVector(Vec3.RIGHT, right);
		rotation3.transformVector(Vec3.UP, up2);
		offset.set(0, 0, 0);
		offset.add(forward.mulScalar(move[2]));
		offset.add(right.mulScalar(move[0]));
		offset.add(up2.mulScalar(move[1]));
		this._targetPose.move(offset);
		return this._pose.lerp(
			this._pose,
			this._targetPose,
			damp(this.moveDamping, dt),
			damp(this.rotateDamping, dt)
		);
	}
	destroy() {
		this.detach();
	}
};

var dir = new Vec3();
var offset2 = new Vec3();
var angles2 = new Vec3();
var rotation4 = new Quat();
var OrbitController = class extends InputController {
	_targetRootPose = new Pose();
	_rootPose = new Pose();
	_targetChildPose = new Pose();
	_childPose = new Pose();
	rotateDamping = 0.98;
	moveDamping = 0.98;
	zoomDamping = 0.98;
	set pitchRange(range) {
		this._targetRootPose.pitchRange.copy(range);
		this._rootPose.copy(this._targetRootPose.rotate(Vec3.ZERO));
	}
	get pitchRange() {
		return this._targetRootPose.pitchRange;
	}
	set yawRange(range) {
		this._targetRootPose.yawRange.copy(range);
		this._rootPose.copy(this._targetRootPose.rotate(Vec3.ZERO));
	}
	get yawRange() {
		return this._targetRootPose.yawRange;
	}
	set zoomRange(range) {
		this._targetChildPose.zRange.copy(range);
		this._childPose.copy(this._targetChildPose.move(Vec3.ZERO));
	}
	get zoomRange() {
		return this._targetRootPose.zRange;
	}
	attach(pose, smooth = true) {
		this._targetRootPose.set(pose.getFocus(dir), pose.angles, 0);
		this._targetChildPose.position.set(0, 0, pose.distance);
		if (!smooth) {
			this._rootPose.copy(this._targetRootPose);
			this._childPose.copy(this._targetChildPose);
		}
	}
	detach() {
		this._targetRootPose.copy(this._rootPose);
		this._targetChildPose.copy(this._childPose);
	}
	update(frame, dt) {
		const { move, rotate } = frame.read();
		offset2.set(move[0], move[1], 0);
		rotation4.setFromEulerAngles(this._rootPose.angles).transformVector(offset2, offset2);
		this._targetRootPose.move(offset2);
		const { z: dist } = this._targetChildPose.position;
		this._targetChildPose.move(offset2.set(0, 0, dist * (1 + move[2]) - dist));
		this._targetRootPose.rotate(angles2.set(-rotate[1], -rotate[0], 0));
		this._rootPose.lerp(
			this._rootPose,
			this._targetRootPose,
			damp(this.moveDamping, dt),
			damp(this.rotateDamping, dt),
			1
		);
		this._childPose.lerp(
			this._childPose,
			this._targetChildPose,
			damp(this.zoomDamping, dt),
			1,
			1
		);
		rotation4.setFromEulerAngles(this._rootPose.angles).transformVector(this._childPose.position, offset2).add(this._rootPose.position);
		return this._pose.set(offset2, this._rootPose.angles, this._childPose.position.z);
	}
	destroy() {
		this.detach();
	}
};

var EPSILON2 = 1e-3;
var dir2 = new Vec3();
var position3 = new Vec3();
var rotation5 = new Quat();
var FocusController = class extends InputController {
	_targetRootPose = new Pose();
	_rootPose = new Pose();
	_targetChildPose = new Pose();
	_childPose = new Pose();
	focusDamping = 0.98;
	attach(pose, smooth = true) {
		this._targetRootPose.set(pose.getFocus(dir2), pose.angles, 0);
		this._targetChildPose.position.set(0, 0, pose.distance);
		if (!smooth) {
			this._rootPose.copy(this._targetRootPose);
			this._childPose.copy(this._targetChildPose);
		}
	}
	detach() {
		this._targetRootPose.copy(this._rootPose);
		this._targetChildPose.copy(this._childPose);
	}
	complete() {
		return this._targetRootPose.equalsApprox(this._rootPose, EPSILON2) && this._targetChildPose.equalsApprox(this._childPose, EPSILON2);
	}
	update(frame, dt) {
		frame.read();
		this._rootPose.lerp(
			this._rootPose,
			this._targetRootPose,
			damp(this.focusDamping, dt),
			damp(this.focusDamping, dt),
			1
		);
		this._childPose.lerp(
			this._childPose,
			this._targetChildPose,
			damp(this.focusDamping, dt),
			1,
			1
		);
		rotation5.setFromEulerAngles(this._rootPose.angles).transformVector(this._childPose.position, position3).add(this._rootPose.position);
		return this._pose.set(position3, this._rootPose.angles, this._childPose.position.length());
	}
	destroy() {
		this.detach();
	}
};

var GIZMOSPACE_LOCAL = "local";
var GIZMOSPACE_WORLD = "world";
var GIZMOAXIS_X = "x";
var GIZMOAXIS_Y = "y";
var GIZMOAXIS_Z = "z";
var GIZMOAXIS_YZ = "yz";
var GIZMOAXIS_XZ = "xz";
var GIZMOAXIS_XY = "xy";
var GIZMOAXIS_XYZ = "xyz";
var GIZMOAXIS_FACE = "face";

var v5 = new Vec3();
var position4 = new Vec3();
var dir3 = new Vec3();
var rotation6 = new Quat();
var m1 = new Mat4();
var m2 = new Mat4();
var ray = new Ray();
var MIN_SCALE = 1e-4;
var PERS_SCALE_RATIO = 0.3;
var ORTHO_SCALE_RATIO = 0.32;
var UPDATE_EPSILON = 1e-6;
var DIST_EPSILON = 1e-4;
var Gizmo = class _Gizmo extends EventHandler {
	static EVENT_POINTERDOWN = "pointer:down";
	static EVENT_POINTERMOVE = "pointer:move";
	static EVENT_POINTERUP = "pointer:up";
	static EVENT_POSITIONUPDATE = "position:update";
	static EVENT_ROTATIONUPDATE = "rotation:update";
	static EVENT_SCALEUPDATE = "scale:update";
	static EVENT_NODESATTACH = "nodes:attach";
	static EVENT_NODESDETACH = "nodes:detach";
	static EVENT_RENDERUPDATE = "render:update";
	_size = 1;
	_scale = 1;
	_coordSpace = "world";
	_app;
	_device;
	_handles = [];
	_mouseButtons = [true, true, true];
	_camera;
	_layer;
	_renderUpdate = false;
	nodes = [];
	root;
	intersectShapes = [];
	preventDefault = true;
	static createLayer(app2, layerName = "Gizmo", layerIndex = app2.scene.layers.layerList.length) {
		const layer = new Layer({
			name: layerName,
			clearDepthBuffer: true,
			opaqueSortMode: SORTMODE_NONE,
			transparentSortMode: SORTMODE_NONE
		});
		app2.scene.layers.insert(layer, layerIndex);
		return layer;
	}
	constructor(camera, layer, name = "gizmo") {
		super();
		this._layer = layer;
		this._camera = camera;
		this._camera.layers = this._camera.layers.concat(this._layer.id);
		this._app = this._camera.system.app;
		this._device = this._app.graphicsDevice;
		this.root = new Entity(name);
		this._app.root.addChild(this.root);
		this.root.enabled = false;
		this._updateScale();
		this._onPointerDown = this._onPointerDown.bind(this);
		this._onPointerMove = this._onPointerMove.bind(this);
		this._onPointerUp = this._onPointerUp.bind(this);
		this._device.canvas.addEventListener("pointerdown", this._onPointerDown);
		this._device.canvas.addEventListener("pointermove", this._onPointerMove);
		this._device.canvas.addEventListener("pointerup", this._onPointerUp);
		this._handles.push(this._app.on("prerender", () => this.prerender()));
		this._handles.push(this._app.on("update", () => this.update()));
		this._handles.push(this._app.on("destroy", () => this.destroy()));
	}
	set enabled(state) {
		const cameraDist = this.root.getLocalPosition().distance(this.camera.entity.getPosition());
		const enabled = state ? this.nodes.length > 0 && cameraDist > DIST_EPSILON : false;
		if (enabled !== this.root.enabled) {
			this.root.enabled = enabled;
			this._renderUpdate = true;
		}
	}
	get enabled() {
		return this.root.enabled;
	}
	get mouseButtons() {
		return this._mouseButtons;
	}
	set layer(layer) {
		if (this._layer === layer) {
			return;
		}
		this._camera.layers = this._camera.layers.filter((id14) => id14 !== this._layer.id);
		this._layer = layer;
		this._camera.layers = this._camera.layers.concat(this._layer.id);
		this.enabled = true;
	}
	get layer() {
		return this._layer;
	}
	set camera(camera) {
		if (this._camera === camera) {
			return;
		}
		this._camera.layers = this._camera.layers.filter((id14) => id14 !== this._layer.id);
		this._camera = camera;
		this._camera.layers = this._camera.layers.concat(this._layer.id);
		this.enabled = true;
	}
	get camera() {
		return this._camera;
	}
	set coordSpace(value) {
		this._coordSpace = value ?? this._coordSpace;
		this._updateRotation();
	}
	get coordSpace() {
		return this._coordSpace;
	}
	set size(value) {
		this._size = value;
		this._updateScale();
	}
	get size() {
		return this._size;
	}
	get facingDir() {
		if (this._camera.projection === PROJECTION_PERSPECTIVE) {
			const gizmoPos = this.root.getLocalPosition();
			const cameraPos = this._camera.entity.getPosition();
			return dir3.sub2(cameraPos, gizmoPos).normalize();
		}
		return dir3.copy(this._camera.entity.forward).mulScalar(-1);
	}
	get cameraDir() {
		const cameraPos = this._camera.entity.getPosition();
		const gizmoPos = this.root.getLocalPosition();
		return dir3.sub2(cameraPos, gizmoPos).normalize();
	}
	_onPointerDown(e) {
		if (!this.enabled || document.pointerLockElement) {
			return;
		}
		if (!this.mouseButtons[e.button]) {
			return;
		}
		const selection = this._getSelection(e.offsetX, e.offsetY);
		if (selection[0]) {
			if (this.preventDefault) {
				e.preventDefault();
			}
			e.stopPropagation();
		}
		const { canvas } = this._device;
		canvas.setPointerCapture(e.pointerId);
		this.fire(_Gizmo.EVENT_POINTERDOWN, e.offsetX, e.offsetY, selection[0]);
	}
	_onPointerMove(e) {
		if (!this.enabled || document.pointerLockElement) {
			return;
		}
		const selection = this._getSelection(e.offsetX, e.offsetY);
		if (selection[0]) {
			if (this.preventDefault) {
				e.preventDefault();
			}
			e.stopPropagation();
		}
		this.fire(_Gizmo.EVENT_POINTERMOVE, e.offsetX, e.offsetY, selection[0]);
	}
	_onPointerUp(e) {
		if (!this.enabled || document.pointerLockElement) {
			return;
		}
		if (!this.mouseButtons[e.button]) {
			return;
		}
		const selection = this._getSelection(e.offsetX, e.offsetY);
		if (selection[0]) {
			if (this.preventDefault) {
				e.preventDefault();
			}
			e.stopPropagation();
		}
		const { canvas } = this._device;
		canvas.releasePointerCapture(e.pointerId);
		this.fire(_Gizmo.EVENT_POINTERUP, e.offsetX, e.offsetY, selection[0]);
	}
	_updatePosition() {
		position4.set(0, 0, 0);
		if (this._coordSpace === "local") {
			position4.copy(this.nodes[this.nodes.length - 1].getPosition());
		} else {
			for (let i2 = 0; i2 < this.nodes.length; i2++) {
				const node = this.nodes[i2];
				position4.add(node.getPosition());
			}
			position4.mulScalar(1 / (this.nodes.length || 1));
		}
		if (position4.equalsApprox(this.root.getLocalPosition(), UPDATE_EPSILON)) {
			return;
		}
		this.root.setLocalPosition(position4);
		this.fire(_Gizmo.EVENT_POSITIONUPDATE, position4);
		this._renderUpdate = true;
	}
	_updateRotation() {
		rotation6.set(0, 0, 0, 1);
		if (this._coordSpace === "local" && this.nodes.length !== 0) {
			rotation6.copy(this.nodes[this.nodes.length - 1].getRotation());
		}
		if (rotation6.equalsApprox(this.root.getRotation(), UPDATE_EPSILON)) {
			return;
		}
		this.root.setRotation(rotation6);
		this.fire(_Gizmo.EVENT_ROTATIONUPDATE, rotation6.getEulerAngles());
		this._renderUpdate = true;
	}
	_updateScale() {
		if (this._camera.projection === PROJECTION_PERSPECTIVE) {
			const gizmoPos = this.root.getLocalPosition();
			const cameraPos = this._camera.entity.getPosition();
			const dist = v5.sub2(gizmoPos, cameraPos).dot(this._camera.entity.forward);
			this._scale = Math.tan(0.5 * this._camera.fov * math.DEG_TO_RAD) * dist * PERS_SCALE_RATIO;
		} else {
			this._scale = this._camera.orthoHeight * ORTHO_SCALE_RATIO;
		}
		this._scale = Math.max(this._scale * this._size, MIN_SCALE);
		if (Math.abs(this._scale - this.root.getLocalScale().x) < UPDATE_EPSILON) {
			return;
		}
		this.root.setLocalScale(this._scale, this._scale, this._scale);
		this.fire(_Gizmo.EVENT_SCALEUPDATE, this._scale);
		this._renderUpdate = true;
	}
	_getSelection(x3, y2) {
		const start = this._camera.screenToWorld(x3, y2, 0);
		const end = this._camera.screenToWorld(x3, y2, this._camera.farClip - this._camera.nearClip);
		const dir4 = v5.copy(end).sub(start).normalize();
		const selection = [];
		for (let i2 = 0; i2 < this.intersectShapes.length; i2++) {
			const shape = this.intersectShapes[i2];
			if (shape.disabled || !shape.entity.enabled) {
				continue;
			}
			const parentTM = shape.entity.getWorldTransform();
			for (let j = 0; j < shape.triData.length; j++) {
				const { tris, transform, priority } = shape.triData[j];
				const triWTM = m1.copy(parentTM).mul(transform);
				const invTriWTM = m2.copy(triWTM).invert();
				invTriWTM.transformPoint(start, ray.origin);
				invTriWTM.transformVector(dir4, ray.direction);
				ray.direction.normalize();
				for (let k = 0; k < tris.length; k++) {
					if (tris[k].intersectsRay(ray, v5)) {
						selection.push({
							dist: triWTM.transformPoint(v5).sub(start).length(),
							meshInstances: shape.meshInstances,
							priority
						});
					}
				}
			}
		}
		if (selection.length) {
			selection.sort((s0, s1) => {
				if (s0.priority !== 0 && s1.priority !== 0) {
					return s1.priority - s0.priority;
				}
				return s0.dist - s1.dist;
			});
			return selection[0].meshInstances;
		}
		return [];
	}
	attach(nodes = []) {
		if (Array.isArray(nodes)) {
			if (nodes.length === 0) {
				return;
			}
			this.nodes = nodes;
		} else {
			this.nodes = [nodes];
		}
		this._updatePosition();
		this._updateRotation();
		this._updateScale();
		this.fire(_Gizmo.EVENT_NODESATTACH);
		this.enabled = true;
	}
	detach() {
		this.enabled = false;
		this.fire(_Gizmo.EVENT_NODESDETACH);
		this.nodes = [];
	}
	prerender() {
	}
	update() {
		if (this._renderUpdate) {
			this._renderUpdate = false;
			this.fire(_Gizmo.EVENT_RENDERUPDATE);
		}
		if (!this.enabled) {
			return;
		}
		this._updatePosition();
		this._updateRotation();
		this._updateScale();
	}
	destroy() {
		this.detach();
		this._device.canvas.removeEventListener("pointerdown", this._onPointerDown);
		this._device.canvas.removeEventListener("pointermove", this._onPointerMove);
		this._device.canvas.removeEventListener("pointerup", this._onPointerUp);
		this._handles.forEach((handle) => handle.off());
		this.root.destroy();
	}
};

var COLOR_RED = Object.freeze(new Color(1, 0.3, 0.3));
var COLOR_GREEN = Object.freeze(new Color(0.3, 1, 0.3));
var COLOR_BLUE = Object.freeze(new Color(0.3, 0.3, 1));
var COLOR_YELLOW = Object.freeze(new Color(1, 1, 0.5));
var COLOR_GRAY = Object.freeze(new Color(0.5, 0.5, 0.5, 0.5));
var color4from3 = (color3, a) => {
	return new Color(color3.r, color3.g, color3.b, a);
};

var v1 = new Vec3();
var v22 = new Vec3();
var point = new Vec3();
var ray2 = new Ray();
var plane = new Plane();
var color = new Color();
var AXES = ["x", "y", "z"];
var TransformGizmo = class _TransformGizmo extends Gizmo {
	static EVENT_TRANSFORMSTART = "transform:start";
	static EVENT_TRANSFORMMOVE = "transform:move";
	static EVENT_TRANSFORMEND = "transform:end";
	_theme = {
		shapeBase: {
			x: COLOR_RED.clone(),
			y: COLOR_GREEN.clone(),
			z: COLOR_BLUE.clone(),
			xyz: new Color(0.8, 0.8, 0.8, 1),
			f: new Color(0.8, 0.8, 0.8, 1)
		},
		shapeHover: {
			x: new Color().lerp(COLOR_RED, Color.WHITE, 0.75),
			y: new Color().lerp(COLOR_GREEN, Color.WHITE, 0.75),
			z: new Color().lerp(COLOR_BLUE, Color.WHITE, 0.75),
			xyz: Color.WHITE.clone(),
			f: Color.WHITE.clone()
		},
		guideBase: {
			x: COLOR_RED.clone(),
			y: COLOR_GREEN.clone(),
			z: COLOR_BLUE.clone()
		},
		guideOcclusion: 0.8,
		disabled: COLOR_GRAY.clone()
	};
	_rootStartPos = new Vec3();
	_rootStartRot = new Quat();
	_shapes = {};
	_shapeMap = /* @__PURE__ */ new Map();
	_hovering = /* @__PURE__ */ new Set();
	_hoverAxis = "";
	_hoverIsPlane = false;
	_selectedAxis = "";
	_selectedIsPlane = false;
	_selectionStartPoint = new Vec3();
	snap = false;
	snapIncrement = 1;
	dragMode = "selected";
	constructor(camera, layer, name = "gizmo:transform") {
		super(camera, layer, name);
		this.on(Gizmo.EVENT_POINTERDOWN, (x3, y2, meshInstance) => {
			const shape = this._shapeMap.get(meshInstance);
			if (shape?.disabled) {
				return;
			}
			if (this._dragging) {
				return;
			}
			if (!meshInstance) {
				return;
			}
			this._hoverAxis = "";
			this._hoverIsPlane = false;
			this._selectedAxis = this._getAxis(meshInstance);
			this._selectedIsPlane = this._getIsPlane(meshInstance);
			this._rootStartPos.copy(this.root.getLocalPosition());
			this._rootStartRot.copy(this.root.getRotation());
			const point5 = this._screenToPoint(x3, y2);
			this._selectionStartPoint.copy(point5);
			this.fire(_TransformGizmo.EVENT_TRANSFORMSTART, point5, x3, y2);
		});
		this.on(Gizmo.EVENT_POINTERMOVE, (x3, y2, meshInstance) => {
			const shape = this._shapeMap.get(meshInstance);
			if (shape?.disabled) {
				return;
			}
			this._hover(meshInstance);
			if (!this._dragging) {
				return;
			}
			const point5 = this._screenToPoint(x3, y2);
			this.fire(_TransformGizmo.EVENT_TRANSFORMMOVE, point5, x3, y2);
		});
		this.on(Gizmo.EVENT_POINTERUP, (_x, _y, meshInstance) => {
			this._hover(meshInstance);
			if (!this._dragging) {
				return;
			}
			if (meshInstance) {
				this._hoverAxis = this._selectedAxis;
				this._hoverIsPlane = this._selectedIsPlane;
			}
			this._selectedAxis = "";
			this._selectedIsPlane = false;
			this.fire(_TransformGizmo.EVENT_TRANSFORMEND);
		});
		this.on(Gizmo.EVENT_NODESDETACH, () => {
			this._hoverAxis = "";
			this._hoverIsPlane = false;
			this._hover();
			this.fire(Gizmo.EVENT_POINTERUP);
		});
	}
	get theme() {
		return this._theme;
	}
	set xAxisColor(value) {
		this.setTheme({
			shapeBase: {
				x: value
			},
			shapeHover: {
				x: color4from3(value, this.colorAlpha)
			},
			guideBase: {
				x: value
			},
			guideOcclusion: 1
		});
	}
	get xAxisColor() {
		return this._theme.shapeBase.x;
	}
	set yAxisColor(value) {
		this.setTheme({
			shapeBase: {
				y: value
			},
			shapeHover: {
				y: color4from3(value, this.colorAlpha)
			},
			guideBase: {
				y: value
			},
			guideOcclusion: 1
		});
	}
	get yAxisColor() {
		return this._theme.shapeBase.y;
	}
	set zAxisColor(value) {
		this.setTheme({
			shapeBase: {
				z: value
			},
			shapeHover: {
				z: color4from3(value, this.colorAlpha)
			},
			guideBase: {
				z: value
			},
			guideOcclusion: 1
		});
	}
	get zAxisColor() {
		return this._theme.shapeBase.z;
	}
	set colorAlpha(value) {
		this.setTheme({
			shapeHover: {
				x: color4from3(this._theme.shapeHover.x, value),
				y: color4from3(this._theme.shapeHover.y, value),
				z: color4from3(this._theme.shapeHover.z, value),
				xyz: color4from3(this._theme.shapeHover.xyz, value),
				f: color4from3(this._theme.shapeHover.f, value)
			}
		});
	}
	get colorAlpha() {
		return (this._theme.shapeHover.x.a + this._theme.shapeHover.y.a + this._theme.shapeHover.z.a + this._theme.shapeHover.xyz.a + this._theme.shapeHover.f.a) / 5;
	}
	get _dragging() {
		return !this._hoverAxis && !!this._selectedAxis;
	}
	_getAxis(meshInstance) {
		if (!meshInstance) {
			return "";
		}
		return meshInstance.node.name.split(":")[1];
	}
	_getIsPlane(meshInstance) {
		if (!meshInstance) {
			return false;
		}
		return meshInstance.node.name.indexOf("plane") !== -1;
	}
	_hover(meshInstance) {
		if (this._dragging) {
			return;
		}
		const remove = new Set(this._hovering);
		let changed = false;
		const add = (axis) => {
			if (remove.has(axis)) {
				remove.delete(axis);
			} else {
				this._hovering.add(axis);
				this._shapes[axis]?.hover(true);
				changed = true;
			}
		};
		this._hoverAxis = this._getAxis(meshInstance);
		this._hoverIsPlane = this._getIsPlane(meshInstance);
		if (this._hoverAxis) {
			if (this._hoverAxis === "xyz") {
				add("x");
				add("y");
				add("z");
				add("xyz");
			} else if (this._hoverIsPlane) {
				switch (this._hoverAxis) {
					case "x":
						add("y");
						add("z");
						add("yz");
						break;
					case "y":
						add("x");
						add("z");
						add("xz");
						break;
					case "z":
						add("x");
						add("y");
						add("xy");
						break;
				}
			} else {
				add(this._hoverAxis);
			}
		}
		for (const axis of remove) {
			this._hovering.delete(axis);
			this._shapes[axis]?.hover(false);
			changed = true;
		}
		if (changed) {
			this._renderUpdate = true;
		}
	}
	_createRay(mouseWPos) {
		if (this._camera.projection === PROJECTION_PERSPECTIVE) {
			ray2.origin.copy(this._camera.entity.getPosition());
			ray2.direction.sub2(mouseWPos, ray2.origin).normalize();
			return ray2;
		}
		const orthoDepth = this._camera.farClip - this._camera.nearClip;
		ray2.origin.sub2(mouseWPos, v1.copy(this._camera.entity.forward).mulScalar(orthoDepth));
		ray2.direction.copy(this._camera.entity.forward);
		return ray2;
	}
	_createPlane(axis, isFacing, isLine) {
		const facingDir = v1.copy(this.facingDir);
		const normal = plane.normal.set(0, 0, 0);
		if (isFacing) {
			normal.copy(this._camera.entity.forward).mulScalar(-1);
		} else {
			normal[axis] = 1;
			this._rootStartRot.transformVector(normal, normal);
			if (isLine) {
				v22.cross(normal, facingDir).normalize();
				normal.cross(v22, normal).normalize();
			}
		}
		return plane.setFromPointNormal(this._rootStartPos, normal);
	}
	_dirFromAxis(axis, dir4) {
		if (axis === "f") {
			dir4.copy(this._camera.entity.forward).mulScalar(-1);
		} else {
			dir4.set(0, 0, 0);
			dir4[axis] = 1;
		}
		return dir4;
	}
	_projectToAxis(point5, axis) {
		v1.set(0, 0, 0);
		v1[axis] = 1;
		point5.copy(v1.mulScalar(v1.dot(point5)));
		const v6 = point5[axis];
		point5.set(0, 0, 0);
		point5[axis] = v6;
	}
	_screenToPoint(x3, y2, isFacing = false, isLine = false) {
		const mouseWPos = this._camera.screenToWorld(x3, y2, 1);
		const axis = this._selectedAxis;
		const ray3 = this._createRay(mouseWPos);
		const plane2 = this._createPlane(axis, isFacing, isLine);
		if (!plane2.intersectsRay(ray3, point)) {
			return point;
		}
		return point;
	}
	_drawGuideLines(pos, rot, activeAxis, activeIsPlane) {
		for (const axis of AXES) {
			if (activeAxis === "xyz") {
				this._drawSpanLine(pos, rot, axis);
				continue;
			}
			if (activeIsPlane) {
				if (axis !== activeAxis) {
					this._drawSpanLine(pos, rot, axis);
				}
			} else {
				if (axis === activeAxis) {
					this._drawSpanLine(pos, rot, axis);
				}
			}
		}
	}
	_drawSpanLine(pos, rot, axis) {
		const dir4 = this._dirFromAxis(axis, v1);
		const base = this._theme.guideBase[axis];
		const from = v1.copy(dir4).mulScalar(this._camera.farClip - this._camera.nearClip);
		const to = v22.copy(from).mulScalar(-1);
		rot.transformVector(from, from).add(pos);
		rot.transformVector(to, to).add(pos);
		if (this._theme.guideOcclusion < 1) {
			const occluded = color.copy(base);
			occluded.a *= 1 - this._theme.guideOcclusion;
			this._app.drawLine(from, to, occluded, false, this._layer);
		}
		if (base.a !== 0) {
			this._app.drawLine(from, to, base, true);
		}
	}
	_createTransform() {
		for (const key in this._shapes) {
			const shape = this._shapes[key];
			this.root.addChild(shape.entity);
			this.intersectShapes.push(shape);
			for (let i2 = 0; i2 < shape.meshInstances.length; i2++) {
				this._shapeMap.set(shape.meshInstances[i2], shape);
			}
		}
	}
	enableShape(shapeAxis, enabled) {
		if (shapeAxis === "face") {
			shapeAxis = "f";
		}
		const shape = this._shapes[shapeAxis];
		if (!shape) {
			return;
		}
		shape.disabled = !enabled;
	}
	isShapeEnabled(shapeAxis) {
		if (shapeAxis === "face") {
			shapeAxis = "f";
		}
		const shape = this._shapes[shapeAxis];
		if (!shape) {
			return false;
		}
		return !shape.disabled;
	}
	setTheme(partial) {
		const theme = { ...this._theme, ...partial };
		if (typeof theme !== "object" || typeof theme.shapeBase !== "object" || typeof theme.shapeHover !== "object" || typeof theme.guideBase !== "object") {
			return;
		}
		for (const axis in theme.shapeBase) {
			if (theme.shapeBase[axis] instanceof Color) {
				this._theme.shapeBase[axis].copy(theme.shapeBase[axis]);
			}
		}
		for (const axis in theme.shapeHover) {
			if (theme.shapeHover[axis] instanceof Color) {
				this._theme.shapeHover[axis].copy(theme.shapeHover[axis]);
			}
		}
		for (const axis in theme.guideBase) {
			if (theme.guideBase[axis] instanceof Color) {
				this._theme.guideBase[axis].copy(theme.guideBase[axis]);
			}
		}
		if (typeof theme.guideOcclusion === "number") {
			this._theme.guideOcclusion = math.clamp(theme.guideOcclusion, 0, 1);
		}
		if (theme.disabled instanceof Color) {
			this._theme.disabled.copy(theme.disabled);
		}
		for (const name in this._shapes) {
			this._shapes[name].hover(!!this._hoverAxis);
		}
	}
	prerender() {
		super.prerender();
		if (!this.enabled) {
			return;
		}
		const gizmoPos = this.root.getLocalPosition();
		const gizmoRot = this.root.getRotation();
		const activeAxis = this._hoverAxis || this._selectedAxis;
		const activeIsPlane = this._hoverIsPlane || this._selectedIsPlane;
		this._drawGuideLines(gizmoPos, gizmoRot, activeAxis, activeIsPlane);
	}
	destroy() {
		super.destroy();
		for (const key in this._shapes) {
			this._shapes[key].destroy();
		}
	}
};

var tmpV12 = new Vec3();
var tmpV2 = new Vec3();
var tmpV3 = new Vec3();
var TriData = class {
	_priority = 0;
	_transform = new Mat4();
	tris = [];
	constructor(geometry, priority = 0) {
		this.fromGeometry(geometry);
		this._priority = priority;
	}
	get transform() {
		return this._transform;
	}
	get priority() {
		return this._priority;
	}
	setTransform(pos = new Vec3(), rot = new Quat(), scale2 = new Vec3()) {
		this.transform.setTRS(pos, rot, scale2);
	}
	fromGeometry(geometry) {
		if (!geometry || !(geometry instanceof Geometry)) {
			throw new Error("No geometry provided.");
		}
		const positions = geometry.positions ?? [];
		const indices = geometry.indices ?? [];
		this.tris = [];
		for (let k = 0; k < indices.length; k += 3) {
			const i1 = indices[k];
			const i2 = indices[k + 1];
			const i3 = indices[k + 2];
			tmpV12.set(positions[i1 * 3], positions[i1 * 3 + 1], positions[i1 * 3 + 2]);
			tmpV2.set(positions[i2 * 3], positions[i2 * 3 + 1], positions[i2 * 3 + 2]);
			tmpV3.set(positions[i3 * 3], positions[i3 * 3 + 1], positions[i3 * 3 + 2]);
			const tri = new Tri(tmpV12, tmpV2, tmpV3);
			this.tris.push(tri);
		}
	}
};

var unlitShader = {
	uniqueName: "gizmo-unlit",
	attributes: {
		vertex_position: SEMANTIC_POSITION
	},
	vertexGLSL: `
		attribute vec3 vertex_position;
	
		uniform mat4 matrix_model;
		uniform mat4 matrix_viewProjection;
	
		void main(void) {
			gl_Position = matrix_viewProjection * matrix_model * vec4(vertex_position, 1.0);
			gl_Position.z = clamp(gl_Position.z, -abs(gl_Position.w), abs(gl_Position.w));
		}
	`,
	fragmentGLSL: `
		#include "gammaPS"
	
		precision highp float;
	
		uniform vec4 uColor;
		uniform float uDepth;
		void main(void) {
			if (uColor.a < 1.0 / 255.0) {
				discard;
			}
			gl_FragColor = vec4(gammaCorrectOutput(decodeGamma(uColor)), uColor.a);
			#if DEPTH_WRITE == 1
				gl_FragDepth = uDepth;
			#endif
		}
	`,
	vertexWGSL: `
		attribute vertex_position: vec3f;
		uniform matrix_model: mat4x4f;
		uniform matrix_viewProjection: mat4x4f;
		@vertex
		fn vertexMain(input: VertexInput) -> VertexOutput {
			var output: VertexOutput;
			let pos = vec4f(input.vertex_position, 1.0);
			output.position = uniform.matrix_viewProjection * uniform.matrix_model * pos;
			output.position.z = clamp(output.position.z, -abs(output.position.w), abs(output.position.w));
			return output;
		}
	`,
	fragmentWGSL: `
		#include "gammaPS"
		uniform uColor: vec4f;
		uniform uDepth: f32;
		@fragment
		fn fragmentMain(input: FragmentInput) -> FragmentOutput {
			var output: FragmentOutput;
			if (uniform.uColor.a < 1.0 / 255.0) {
				discard;
			}
			output.color = vec4f(gammaCorrectOutput(decodeGamma(uniform.uColor)), uniform.uColor.a);
			#if DEPTH_WRITE == 1
				output.fragDepth = uniform.uDepth;
			#endif
			return output;
		}
	`
};

var tmpG = new Geometry();
tmpG.positions = [];
tmpG.normals = [];
var Shape = class {
	_position = new Vec3();
	_rotation = new Vec3();
	_scale = new Vec3(1, 1, 1);
	_layers = [];
	_material = new ShaderMaterial(unlitShader);
	_disabled = false;
	_visible = true;
	_defaultColor = Color.WHITE;
	_hoverColor = Color.BLACK;
	_disabledColor = COLOR_GRAY;
	_cull = CULLFACE_BACK;
	_depth = -1;
	device;
	axis;
	entity;
	triData = [];
	meshInstances = [];
	constructor(device, name, args) {
		this.device = device;
		this.axis = args.axis ?? "x";
		if (args.position instanceof Vec3) {
			this._position.copy(args.position);
		}
		if (args.rotation instanceof Vec3) {
			this._rotation.copy(args.rotation);
		}
		if (args.scale instanceof Vec3) {
			this._scale.copy(args.scale);
		}
		this._disabled = args.disabled ?? this._disabled;
		this._visible = args.visible ?? this._visible;
		this._layers = args.layers ?? this._layers;
		if (args.defaultColor instanceof Color) {
			this._defaultColor = args.defaultColor;
		}
		if (args.hoverColor instanceof Color) {
			this._hoverColor = args.hoverColor;
		}
		if (args.disabledColor instanceof Color) {
			this._disabledColor = args.disabledColor;
		}
		this._cull = args.cull ?? this._cull;
		this._depth = args.depth ?? this._depth;
		this.entity = new Entity(`${name}:${this.axis}`);
		this.entity.setLocalPosition(this._position);
		this.entity.setLocalEulerAngles(this._rotation);
		this.entity.setLocalScale(this._scale);
	}
	set disabled(value) {
		this._disabled = value ?? false;
		this.hover(false);
	}
	get disabled() {
		return this._disabled;
	}
	set visible(value) {
		if (value === this._visible) {
			return;
		}
		for (let i2 = 0; i2 < this.meshInstances.length; i2++) {
			this.meshInstances[i2].visible = value;
		}
		this._visible = value;
	}
	get visible() {
		return this._visible;
	}
	_createRenderComponent(entity, meshes) {
		const color3 = this._disabled ? this._disabledColor : this._defaultColor;
		this._material.setDefine("DEPTH_WRITE", this._depth > 0 ? "1" : "0");
		this._material.setParameter("uDepth", this._depth);
		this._material.setParameter("uColor", color3.toArray());
		this._material.cull = this._cull;
		this._material.blendType = BLEND_NORMAL;
		this._material.update();
		const meshInstances = [];
		for (let i2 = 0; i2 < meshes.length; i2++) {
			const mi = new MeshInstance(meshes[i2], this._material);
			mi.cull = false;
			meshInstances.push(mi);
			this.meshInstances.push(mi);
		}
		entity.addComponent("render", {
			meshInstances,
			layers: this._layers,
			castShadows: false
		});
	}
	_update() {
		this.entity.setLocalPosition(this._position);
		this.entity.setLocalEulerAngles(this._rotation);
		this.entity.setLocalScale(this._scale);
	}
	hover(state) {
		const color3 = this._disabled ? this._disabledColor : state ? this._hoverColor : this._defaultColor;
		this._material.setParameter("uColor", color3.toArray());
	}
	destroy() {
		this.entity.destroy();
	}
};

var UPDATE_EPSILON2 = 1e-6;
var PlaneShape = class extends Shape {
	_cull = CULLFACE_NONE;
	_size = 0.16;
	_gap = 0;
	_flipped = new Vec3();
	constructor(device, args = {}) {
		super(device, "plane", args);
		this._size = args.size ?? this._size;
		this._gap = args.gap ?? this._gap;
		this.triData = [
			new TriData(new PlaneGeometry())
		];
		this._createRenderComponent(this.entity, [
			Mesh.fromGeometry(this.device, new PlaneGeometry())
		]);
		this._update();
	}
	set size(value) {
		this._size = value ?? this._size;
		this._update();
	}
	get size() {
		return this._size;
	}
	set gap(value) {
		this._gap = value ?? this._gap;
		this._update();
	}
	get gap() {
		return this._gap;
	}
	set flipped(value) {
		if (this._flipped.distance(value) < UPDATE_EPSILON2) {
			return;
		}
		this._flipped.copy(value);
		this._update();
	}
	get flipped() {
		return this._flipped;
	}
	_update() {
		const offset3 = this._size / 2 + this._gap;
		this._position.set(
			this._flipped.x ? -offset3 : offset3,
			this._flipped.y ? -offset3 : offset3,
			this._flipped.z ? -offset3 : offset3
		);
		this._position[this.axis] = 0;
		this.entity.setLocalPosition(this._position);
		this.entity.setLocalEulerAngles(this._rotation);
		this.entity.setLocalScale(this._size, this._size, this._size);
	}
};

var tmpV13 = new Vec3();
var tmpV22 = new Vec3();
var tmpQ1 = new Quat();
var ArrowShape = class extends Shape {
	_gap = 0;
	_lineThickness = 0.02;
	_lineLength = 0.5;
	_arrowThickness = 0.12;
	_arrowLength = 0.18;
	_tolerance = 0.1;
	_head;
	_line;
	constructor(device, args = {}) {
		super(device, "arrow", args);
		this._gap = args.gap ?? this._gap;
		this._lineThickness = args.lineThickness ?? this._lineThickness;
		this._lineLength = args.lineLength ?? this._lineLength;
		this._arrowThickness = args.arrowThickness ?? this._arrowThickness;
		this._arrowLength = args.arrowLength ?? this._arrowLength;
		this._tolerance = args.tolerance ?? this._tolerance;
		this.triData = [
			new TriData(new ConeGeometry()),
			new TriData(new CylinderGeometry(), 1)
		];
		this._head = new Entity(`head:${this.axis}`);
		this.entity.addChild(this._head);
		this._createRenderComponent(this._head, [
			Mesh.fromGeometry(this.device, new ConeGeometry())
		]);
		this._line = new Entity(`line:${this.axis}`);
		this.entity.addChild(this._line);
		this._createRenderComponent(this._line, [
			Mesh.fromGeometry(this.device, new CylinderGeometry())
		]);
		this._update();
	}
	set gap(value) {
		this._gap = value ?? this._gap;
		this._update();
	}
	get gap() {
		return this._gap;
	}
	set lineThickness(value) {
		this._lineThickness = value ?? this._lineThickness;
		this._update();
	}
	get lineThickness() {
		return this._lineThickness;
	}
	set lineLength(value) {
		this._lineLength = value ?? this._lineLength;
		this._update();
	}
	get lineLength() {
		return this._lineLength;
	}
	set arrowThickness(value) {
		this._arrowThickness = value ?? this._arrowThickness;
		this._update();
	}
	get arrowThickness() {
		return this._arrowThickness;
	}
	set arrowLength(value) {
		this._arrowLength = value ?? this._arrowLength;
		this._update();
	}
	get arrowLength() {
		return this._arrowLength;
	}
	set tolerance(value) {
		this._tolerance = value;
		this._update();
	}
	get tolerance() {
		return this._tolerance;
	}
	_update() {
		tmpV13.set(0, this._gap + this._arrowLength * 0.5 + this._lineLength, 0);
		tmpQ1.set(0, 0, 0, 1);
		tmpV22.set(this._arrowThickness, this._arrowLength, this._arrowThickness);
		this.triData[0].setTransform(tmpV13, tmpQ1, tmpV22);
		tmpV13.set(0, this._gap + this._lineLength * 0.5, 0);
		tmpQ1.set(0, 0, 0, 1);
		tmpV22.set(this._lineThickness + this._tolerance, this._lineLength, this._lineThickness + this._tolerance);
		this.triData[1].setTransform(tmpV13, tmpQ1, tmpV22);
		this._head.setLocalPosition(0, this._gap + this._arrowLength * 0.5 + this._lineLength, 0);
		this._head.setLocalScale(this._arrowThickness, this._arrowLength, this._arrowThickness);
		this._line.setLocalPosition(0, this._gap + this._lineLength * 0.5, 0);
		this._line.setLocalScale(this._lineThickness, this._lineLength, this._lineThickness);
	}
};

var SphereShape = class extends Shape {
	_radius = 0.03;
	constructor(device, args = {}) {
		super(device, "sphereCenter", args);
		this._radius = args.radius ?? this._radius;
		this.triData = [
			new TriData(new SphereGeometry(), 2)
		];
		this._createRenderComponent(this.entity, [
			Mesh.fromGeometry(this.device, new SphereGeometry({
				latitudeBands: 32,
				longitudeBands: 32
			}))
		]);
		this._update();
	}
	set radius(value) {
		this._radius = value ?? this._radius;
		this._update();
	}
	get radius() {
		return this._radius;
	}
	_update() {
		const scale2 = this._radius * 2;
		this.entity.setLocalScale(scale2, scale2, scale2);
	}
};

var v12 = new Vec3();
var v23 = new Vec3();
var point2 = new Vec3();
var delta = new Vec3();
var q3 = new Quat();
var GLANCE_EPSILON = 0.01;
var AXES2 = ["x", "y", "z"];
var TranslateGizmo = class extends TransformGizmo {
	_shapes = {
		xyz: new SphereShape(this._device, {
			axis: "xyz",
			layers: [this._layer.id],
			defaultColor: this._theme.shapeBase.xyz,
			hoverColor: this._theme.shapeHover.xyz,
			disabledColor: this._theme.disabled
		}),
		yz: new PlaneShape(this._device, {
			axis: "x",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, -90),
			defaultColor: this._theme.shapeBase.x,
			hoverColor: this._theme.shapeHover.x,
			disabledColor: this._theme.disabled,
			depth: 1
		}),
		xz: new PlaneShape(this._device, {
			axis: "y",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, 0),
			defaultColor: this._theme.shapeBase.y,
			hoverColor: this._theme.shapeHover.y,
			disabledColor: this._theme.disabled,
			depth: 1
		}),
		xy: new PlaneShape(this._device, {
			axis: "z",
			layers: [this._layer.id],
			rotation: new Vec3(90, 0, 0),
			defaultColor: this._theme.shapeBase.z,
			hoverColor: this._theme.shapeHover.z,
			disabledColor: this._theme.disabled,
			depth: 1
		}),
		x: new ArrowShape(this._device, {
			axis: "x",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, -90),
			defaultColor: this._theme.shapeBase.x,
			hoverColor: this._theme.shapeHover.x,
			disabledColor: this._theme.disabled
		}),
		y: new ArrowShape(this._device, {
			axis: "y",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, 0),
			defaultColor: this._theme.shapeBase.y,
			hoverColor: this._theme.shapeHover.y,
			disabledColor: this._theme.disabled
		}),
		z: new ArrowShape(this._device, {
			axis: "z",
			layers: [this._layer.id],
			rotation: new Vec3(90, 0, 0),
			defaultColor: this._theme.shapeBase.z,
			hoverColor: this._theme.shapeHover.z,
			disabledColor: this._theme.disabled
		})
	};
	_nodeLocalPositions = /* @__PURE__ */ new Map();
	_nodePositions = /* @__PURE__ */ new Map();
	snapIncrement = 1;
	flipPlanes = true;
	constructor(camera, layer) {
		super(camera, layer, "gizmo:translate");
		this._createTransform();
		this.on(TransformGizmo.EVENT_TRANSFORMSTART, () => {
			this._storeNodePositions();
			this._drag(true);
		});
		this.on(TransformGizmo.EVENT_TRANSFORMMOVE, (point5) => {
			const translateDelta = delta.copy(point5).sub(this._selectionStartPoint);
			if (this.snap) {
				translateDelta.mulScalar(1 / this.snapIncrement);
				translateDelta.round();
				translateDelta.mulScalar(this.snapIncrement);
			}
			this._setNodePositions(translateDelta);
		});
		this.on(TransformGizmo.EVENT_TRANSFORMEND, () => {
			this._drag(false);
		});
		this.on(TransformGizmo.EVENT_NODESDETACH, () => {
			this._nodeLocalPositions.clear();
			this._nodePositions.clear();
		});
	}
	set axisGap(value) {
		this._setArrowProp("gap", value);
	}
	get axisGap() {
		return this._shapes.x.gap;
	}
	set axisLineThickness(value) {
		this._setArrowProp("lineThickness", value);
	}
	get axisLineThickness() {
		return this._shapes.x.lineThickness;
	}
	set axisLineLength(value) {
		this._setArrowProp("lineLength", value);
	}
	get axisLineLength() {
		return this._shapes.x.lineLength;
	}
	set axisLineTolerance(value) {
		this._setArrowProp("tolerance", value);
	}
	get axisLineTolerance() {
		return this._shapes.x.tolerance;
	}
	set axisArrowThickness(value) {
		this._setArrowProp("arrowThickness", value);
	}
	get axisArrowThickness() {
		return this._shapes.x.arrowThickness;
	}
	set axisArrowLength(value) {
		this._setArrowProp("arrowLength", value);
	}
	get axisArrowLength() {
		return this._shapes.x.arrowLength;
	}
	set axisPlaneSize(value) {
		this._setPlaneProp("size", value);
	}
	get axisPlaneSize() {
		return this._shapes.yz.size;
	}
	set axisPlaneGap(value) {
		this._setPlaneProp("gap", value);
	}
	get axisPlaneGap() {
		return this._shapes.yz.gap;
	}
	set axisCenterSize(value) {
		this._shapes.xyz.radius = value;
	}
	get axisCenterSize() {
		return this._shapes.xyz.radius;
	}
	set flipShapes(value) {
		this.flipPlanes = value;
	}
	get flipShapes() {
		return this.flipPlanes;
	}
	_setArrowProp(prop, value) {
		this._shapes.x[prop] = value;
		this._shapes.y[prop] = value;
		this._shapes.z[prop] = value;
	}
	_setPlaneProp(prop, value) {
		this._shapes.yz[prop] = value;
		this._shapes.xz[prop] = value;
		this._shapes.xy[prop] = value;
	}
	_shapesLookAtCamera() {
		const cameraDir = this.cameraDir;
		let changed = false;
		let dot, enabled;
		dot = cameraDir.dot(this.root.right);
		enabled = 1 - Math.abs(dot) > GLANCE_EPSILON;
		if (this._shapes.x.entity.enabled !== enabled) {
			this._shapes.x.entity.enabled = enabled;
			changed = true;
		}
		dot = cameraDir.dot(this.root.up);
		enabled = 1 - Math.abs(dot) > GLANCE_EPSILON;
		if (this._shapes.y.entity.enabled !== enabled) {
			this._shapes.y.entity.enabled = enabled;
			changed = true;
		}
		dot = cameraDir.dot(this.root.forward);
		enabled = 1 - Math.abs(dot) > GLANCE_EPSILON;
		if (this._shapes.z.entity.enabled !== enabled) {
			this._shapes.z.entity.enabled = enabled;
			changed = true;
		}
		let flipped;
		v12.cross(cameraDir, this.root.right);
		enabled = 1 - v12.length() > GLANCE_EPSILON;
		if (this._shapes.yz.entity.enabled !== enabled) {
			this._shapes.yz.entity.enabled = enabled;
			changed = true;
		}
		flipped = this.flipPlanes ? v23.set(0, +(v12.dot(this.root.forward) < 0), +(v12.dot(this.root.up) < 0)) : Vec3.ZERO;
		if (!this._shapes.yz.flipped.equals(flipped)) {
			this._shapes.yz.flipped = flipped;
			changed = true;
		}
		v12.cross(cameraDir, this.root.forward);
		enabled = 1 - v12.length() > GLANCE_EPSILON;
		if (this._shapes.xy.entity.enabled !== enabled) {
			this._shapes.xy.entity.enabled = enabled;
			changed = true;
		}
		flipped = this.flipPlanes ? v23.set(+(v12.dot(this.root.up) < 0), +(v12.dot(this.root.right) > 0), 0) : Vec3.ZERO;
		if (!this._shapes.xy.flipped.equals(flipped)) {
			this._shapes.xy.flipped = flipped;
			changed = true;
		}
		v12.cross(cameraDir, this.root.up);
		enabled = 1 - v12.length() > GLANCE_EPSILON;
		if (this._shapes.xz.entity.enabled !== enabled) {
			this._shapes.xz.entity.enabled = enabled;
			changed = true;
		}
		flipped = this.flipPlanes ? v23.set(+(v12.dot(this.root.forward) > 0), 0, +(v12.dot(this.root.right) > 0)) : Vec3.ZERO;
		if (!this._shapes.xz.flipped.equals(flipped)) {
			this._shapes.xz.flipped = flipped;
			changed = true;
		}
		if (changed) {
			this._renderUpdate = true;
		}
	}
	_drag(state) {
		for (const axis in this._shapes) {
			const shape = this._shapes[axis];
			switch (this.dragMode) {
				case "show": {
					continue;
				}
				case "hide": {
					shape.visible = !state;
					continue;
				}
				case "selected": {
					if (this._selectedAxis === "xyz") {
						shape.visible = state ? axis.length === 1 : true;
						continue;
					}
					if (this._selectedIsPlane) {
						shape.visible = state ? axis.length === 1 && !axis.includes(this._selectedAxis) : true;
						continue;
					}
					shape.visible = state ? axis === this._selectedAxis : true;
				}
			}
		}
		this._renderUpdate = true;
	}
	_storeNodePositions() {
		for (let i2 = 0; i2 < this.nodes.length; i2++) {
			const node = this.nodes[i2];
			this._nodeLocalPositions.set(node, node.getLocalPosition().clone());
			this._nodePositions.set(node, node.getPosition().clone());
		}
	}
	_setNodePositions(translateDelta) {
		for (let i2 = 0; i2 < this.nodes.length; i2++) {
			const node = this.nodes[i2];
			if (this._coordSpace === "local") {
				const pos = this._nodeLocalPositions.get(node);
				if (!pos) {
					continue;
				}
				v12.copy(translateDelta);
				node.parent?.getWorldTransform().getScale(v23);
				v23.x = 1 / v23.x;
				v23.y = 1 / v23.y;
				v23.z = 1 / v23.z;
				q3.copy(node.getLocalRotation()).transformVector(v12, v12);
				v12.mul(v23);
				node.setLocalPosition(v12.add(pos));
			} else {
				const pos = this._nodePositions.get(node);
				if (!pos) {
					continue;
				}
				node.setPosition(v12.copy(translateDelta).add(pos));
			}
		}
		this._updatePosition();
	}
	_screenToPoint(x3, y2) {
		const mouseWPos = this._camera.screenToWorld(x3, y2, 1);
		const axis = this._selectedAxis;
		const isPlane = this._selectedIsPlane;
		const ray3 = this._createRay(mouseWPos);
		const plane2 = this._createPlane(axis, axis === "xyz", !isPlane);
		if (!plane2.intersectsRay(ray3, point2)) {
			return point2;
		}
		q3.copy(this._rootStartRot).invert().transformVector(point2, point2);
		if (!isPlane && axis !== "xyz") {
			this._projectToAxis(point2, axis);
		}
		return point2;
	}
	_drawGuideLines(pos, rot, activeAxis, activeIsPlane) {
		for (const axis of AXES2) {
			if (this._dragging || activeAxis === "xyz") {
				this._drawSpanLine(pos, rot, axis);
				continue;
			}
			if (activeIsPlane) {
				if (axis !== activeAxis) {
					this._drawSpanLine(pos, rot, axis);
				}
			} else {
				if (axis === activeAxis) {
					this._drawSpanLine(pos, rot, axis);
				}
			}
		}
	}
	prerender() {
		super.prerender();
		if (!this.enabled) {
			return;
		}
		this._shapesLookAtCamera();
	}
};

var TORUS_RENDER_SEGMENTS = 80;
var TORUS_INTERSECT_SEGMENTS = 20;
var ArcShape = class extends Shape {
	_tubeRadius = 0.01;
	_ringRadius = 0.5;
	_sectorAngle = 360;
	_tolerance = 0.05;
	_triDataCache;
	constructor(device, args = {}) {
		super(device, "disk", args);
		this._tubeRadius = args.tubeRadius ?? this._tubeRadius;
		this._ringRadius = args.ringRadius ?? this._ringRadius;
		this._sectorAngle = args.sectorAngle ?? this._sectorAngle;
		this._triDataCache = [
			new TriData(this._createTorusGeometry(this._sectorAngle)),
			new TriData(this._createTorusGeometry(360))
		];
		this.triData = [this._triDataCache[0]];
		this._createRenderComponent(this.entity, [
			this._createTorusMesh(this._sectorAngle),
			this._createTorusMesh(360)
		]);
		this.show("sector");
		this._update();
	}
	_createTorusGeometry(sectorAngle) {
		return new TorusGeometry({
			tubeRadius: this._tubeRadius + this._tolerance,
			ringRadius: this._ringRadius,
			sectorAngle,
			segments: TORUS_INTERSECT_SEGMENTS
		});
	}
	_createTorusMesh(sectorAngle) {
		const geom = new TorusGeometry({
			tubeRadius: this._tubeRadius,
			ringRadius: this._ringRadius,
			sectorAngle,
			segments: TORUS_RENDER_SEGMENTS
		});
		return Mesh.fromGeometry(this.device, geom);
	}
	set tubeRadius(value) {
		this._tubeRadius = value ?? this._tubeRadius;
		this._update();
	}
	get tubeRadius() {
		return this._tubeRadius;
	}
	set ringRadius(value) {
		this._ringRadius = value ?? this._ringRadius;
		this._update();
	}
	get ringRadius() {
		return this._ringRadius;
	}
	set tolerance(value) {
		this._tolerance = value ?? this._tolerance;
		this._update();
	}
	get tolerance() {
		return this._tolerance;
	}
	_update() {
		this._triDataCache[0].fromGeometry(this._createTorusGeometry(this._sectorAngle));
		this._triDataCache[1].fromGeometry(this._createTorusGeometry(360));
		this.meshInstances[0].mesh = this._createTorusMesh(this._sectorAngle);
		this.meshInstances[1].mesh = this._createTorusMesh(360);
	}
	show(state) {
		switch (state) {
			case "sector": {
				this.triData[0] = this._triDataCache[0];
				this.meshInstances[0].visible = true;
				this.meshInstances[1].visible = false;
				break;
			}
			case "ring": {
				this.triData[0] = this._triDataCache[1];
				this.meshInstances[0].visible = false;
				this.meshInstances[1].visible = true;
				break;
			}
			case "none": {
				this.meshInstances[0].visible = false;
				this.meshInstances[1].visible = false;
				break;
			}
		}
	}
};

var tmpV14 = new Vec3();
var MeshLine = class {
	_thickness = 0.02;
	_material = new ShaderMaterial(unlitShader);
	entity = new Entity("mesh-line");
	constructor(app2, layer, args = {}) {
		this._thickness = args.thickness ?? this._thickness;
		this._material.blendState = BlendState.ALPHABLEND;
		this._material.setDefine("DEPTH_WRITE", "1");
		this._material.setParameter("uDepth", 0);
		this._material.update();
		const mesh = Mesh.fromGeometry(app2.graphicsDevice, new CylinderGeometry());
		const meshInstance = new MeshInstance(mesh, this._material);
		this.entity.addComponent("render", {
			meshInstances: [meshInstance],
			layers: [layer.id]
		});
	}
	set thickness(value) {
		this._thickness = value ?? this._thickness;
	}
	get thickness() {
		return this._thickness;
	}
	draw(from, to, scale2, color3) {
		this._material.setParameter("uColor", color3.toArray());
		const dir4 = tmpV14.sub2(to, from).normalize();
		const elev = Math.atan2(-dir4.y, Math.sqrt(dir4.x * dir4.x + dir4.z * dir4.z)) * math.RAD_TO_DEG;
		const azim = Math.atan2(-dir4.x, -dir4.z) * math.RAD_TO_DEG;
		this.entity.setLocalEulerAngles(-elev + 90, azim, 0);
		const length = from.distance(to) * scale2;
		this.entity.setLocalPosition(dir4.mulScalar(0.5 * length).add(from));
		this.entity.setLocalScale(this._thickness * scale2, length, this._thickness * scale2);
	}
	destroy() {
		this._material.destroy();
		this.entity.destroy();
	}
};

var point3 = new Vec3();
var v13 = new Vec3();
var v24 = new Vec3();
var v32 = new Vec3();
var q1 = new Quat();
var q22 = new Quat();
var color2 = new Color();
var RING_FACING_EPSILON = 1e-4;
var UPDATE_EPSILON3 = 1e-6;
var AXES3 = ["x", "y", "z"];
var RotateGizmo = class extends TransformGizmo {
	_shapes = {
		z: new ArcShape(this._device, {
			axis: "z",
			layers: [this._layer.id],
			rotation: new Vec3(90, 0, 90),
			defaultColor: this._theme.shapeBase.z,
			hoverColor: this._theme.shapeHover.z,
			disabledColor: this._theme.disabled,
			sectorAngle: 180
		}),
		x: new ArcShape(this._device, {
			axis: "x",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, -90),
			defaultColor: this._theme.shapeBase.x,
			hoverColor: this._theme.shapeHover.x,
			disabledColor: this._theme.disabled,
			sectorAngle: 180
		}),
		y: new ArcShape(this._device, {
			axis: "y",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, 0),
			defaultColor: this._theme.shapeBase.y,
			hoverColor: this._theme.shapeHover.y,
			disabledColor: this._theme.disabled,
			sectorAngle: 180
		}),
		f: new ArcShape(this._device, {
			axis: "f",
			layers: [this._layer.id],
			defaultColor: this._theme.shapeBase.f,
			hoverColor: this._theme.shapeHover.f,
			disabledColor: this._theme.disabled,
			ringRadius: 0.55
		}),
		xyz: new SphereShape(this._device, {
			axis: "xyz",
			layers: [this._layer.id],
			defaultColor: this._theme.shapeBase.xyz,
			hoverColor: this._theme.shapeHover.xyz,
			disabledColor: this._theme.disabled,
			radius: 0.5
		})
	};
	_selectionStartAngle = 0;
	_nodeLocalRotations = /* @__PURE__ */ new Map();
	_nodeRotations = /* @__PURE__ */ new Map();
	_nodeOffsets = /* @__PURE__ */ new Map();
	_screenPos = new Vec2();
	_screenStartPos = new Vec2();
	_guideAngleStart = new Vec3();
	_guideAngleEnd = new Vec3();
	_guideAngleLines;
	_facingDir = new Vec3();
	snapIncrement = 5;
	rotationMode = "absolute";
	constructor(camera, layer) {
		super(camera, layer, "gizmo:rotate");
		this.setTheme({
			shapeBase: {
				xyz: new Color(0, 0, 0, 0)
			},
			shapeHover: {
				xyz: new Color(1, 1, 1, 0.2)
			}
		});
		this._createTransform();
		this._guideAngleLines = [
			new MeshLine(this._app, this._layer),
			new MeshLine(this._app, this._layer)
		];
		this._guideAngleLines.forEach((line) => {
			this._app.root.addChild(line.entity);
			line.entity.enabled = false;
		});
		this.on(TransformGizmo.EVENT_TRANSFORMSTART, (point5, x3, y2) => {
			this._screenPos.set(x3, y2);
			this._screenStartPos.set(x3, y2);
			this._selectionStartAngle = this._calculateArcAngle(point5, x3, y2);
			this._storeNodeRotations();
			this._storeGuidePoints();
			this._drag(true);
			this._angleGuide(true);
		});
		this.on(TransformGizmo.EVENT_TRANSFORMMOVE, (point5, x3, y2) => {
			const axis = this._selectedAxis;
			if (!axis) {
				return;
			}
			this._screenPos.set(x3, y2);
			if (axis === "xyz") {
				const facingDir = v13.copy(this.facingDir);
				const delta3 = v24.copy(point5).sub(this._selectionStartPoint);
				const angleAxis = v13.cross(facingDir, delta3).normalize();
				const angleDelta = this._screenPos.distance(this._screenStartPos);
				this._setNodeRotations(axis, angleAxis, angleDelta);
			} else {
				let angleDelta = this._calculateArcAngle(point5, x3, y2) - this._selectionStartAngle;
				if (this.snap) {
					angleDelta = Math.round(angleDelta / this.snapIncrement) * this.snapIncrement;
				}
				const angleAxis = this._dirFromAxis(axis, v13);
				this._setNodeRotations(axis, angleAxis, angleDelta);
				this._updateGuidePoints(angleDelta);
				this._angleGuide(true);
			}
		});
		this.on(TransformGizmo.EVENT_TRANSFORMEND, () => {
			this._drag(false);
			this._angleGuide(false);
		});
		this.on(TransformGizmo.EVENT_NODESDETACH, () => {
			this._nodeLocalRotations.clear();
			this._nodeRotations.clear();
			this._nodeOffsets.clear();
		});
	}
	set xyzTubeRadius(value) {
		this._setDiskProp("tubeRadius", value);
	}
	get xyzTubeRadius() {
		return this._shapes.x.tubeRadius;
	}
	set xyzRingRadius(value) {
		this._setDiskProp("ringRadius", value);
	}
	get xyzRingRadius() {
		return this._shapes.x.ringRadius;
	}
	set faceTubeRadius(value) {
		this._shapes.f.tubeRadius = value;
	}
	get faceTubeRadius() {
		return this._shapes.f.tubeRadius;
	}
	set faceRingRadius(value) {
		this._shapes.f.ringRadius = value;
	}
	get faceRingRadius() {
		return this._shapes.f.ringRadius;
	}
	set centerRadius(value) {
		this._shapes.xyz.radius = value;
	}
	get centerRadius() {
		return this._shapes.xyz.radius;
	}
	set ringTolerance(value) {
		this._setDiskProp("tolerance", value);
		this._shapes.f.tolerance = value;
	}
	get ringTolerance() {
		return this._shapes.x.tolerance;
	}
	set angleGuideThickness(value) {
		this._guideAngleLines[0].thickness = value;
		this._guideAngleLines[1].thickness = value;
	}
	get angleGuideThickness() {
		return this._guideAngleLines[0].thickness;
	}
	set orbitRotation(value) {
		this.rotationMode = value ? "orbit" : "absolute";
	}
	get orbitRotation() {
		return this.rotationMode === "orbit";
	}
	_setDiskProp(prop, value) {
		this._shapes.x[prop] = value;
		this._shapes.y[prop] = value;
		this._shapes.z[prop] = value;
	}
	_storeGuidePoints() {
		const gizmoPos = this.root.getLocalPosition();
		const axis = this._selectedAxis;
		const isFacing = axis === "f";
		const scale2 = isFacing ? this.faceRingRadius : this.xyzRingRadius;
		this._guideAngleStart.copy(this._selectionStartPoint).sub(gizmoPos).normalize();
		this._guideAngleStart.mulScalar(scale2);
		this._guideAngleEnd.copy(this._guideAngleStart);
	}
	_updateGuidePoints(angleDelta) {
		const axis = this._selectedAxis;
		const isFacing = axis === "f";
		if (isFacing) {
			v13.copy(this.facingDir);
		} else {
			v13.set(0, 0, 0);
			v13[axis] = 1;
			this._rootStartRot.transformVector(v13, v13);
		}
		q1.setFromAxisAngle(v13, angleDelta);
		q1.transformVector(this._guideAngleStart, this._guideAngleEnd);
		this._renderUpdate = true;
	}
	_angleGuide(state) {
		const axis = this._selectedAxis;
		if (state && this.dragMode !== "show" && axis !== "xyz") {
			const gizmoPos = this.root.getLocalPosition();
			const baseColor = this._theme.shapeHover[axis];
			const startColor = color2.copy(baseColor);
			startColor.a *= 0.3;
			this._guideAngleLines[0].draw(
				gizmoPos,
				v13.copy(this._guideAngleStart).add(gizmoPos),
				this._scale,
				startColor
			);
			this._guideAngleLines[1].draw(
				gizmoPos,
				v13.copy(this._guideAngleEnd).add(gizmoPos),
				this._scale,
				baseColor
			);
			this._guideAngleLines[0].entity.enabled = true;
			this._guideAngleLines[1].entity.enabled = true;
		} else {
			this._guideAngleLines[0].entity.enabled = false;
			this._guideAngleLines[1].entity.enabled = false;
		}
	}
	_shapesLookAtCamera() {
		if (this._camera.projection === PROJECTION_PERSPECTIVE) {
			const dir4 = this._camera.entity.getPosition().sub(this.root.getPosition()).normalize();
			const elev = Math.atan2(-dir4.y, Math.sqrt(dir4.x * dir4.x + dir4.z * dir4.z)) * math.RAD_TO_DEG;
			const azim = Math.atan2(-dir4.x, -dir4.z) * math.RAD_TO_DEG;
			this._shapes.f.entity.setEulerAngles(-elev + 90, azim, 0);
		} else {
			q1.copy(this._camera.entity.getRotation()).getEulerAngles(v13);
			this._shapes.f.entity.setEulerAngles(v13);
			this._shapes.f.entity.rotateLocal(-90, 0, 0);
		}
		let angle, dot, sector;
		const facingDir = v13.copy(this.facingDir);
		q1.copy(this.root.getRotation()).invert().transformVector(facingDir, facingDir);
		angle = Math.atan2(facingDir.z, facingDir.y) * math.RAD_TO_DEG;
		this._shapes.x.entity.setLocalEulerAngles(0, angle - 90, -90);
		angle = Math.atan2(facingDir.x, facingDir.z) * math.RAD_TO_DEG;
		this._shapes.y.entity.setLocalEulerAngles(0, angle, 0);
		angle = Math.atan2(facingDir.y, facingDir.x) * math.RAD_TO_DEG;
		this._shapes.z.entity.setLocalEulerAngles(90, 0, angle + 90);
		if (!this._dragging) {
			dot = facingDir.dot(this.root.right);
			sector = 1 - Math.abs(dot) > RING_FACING_EPSILON;
			this._shapes.x.show(sector ? "sector" : "ring");
			dot = facingDir.dot(this.root.up);
			sector = 1 - Math.abs(dot) > RING_FACING_EPSILON;
			this._shapes.y.show(sector ? "sector" : "ring");
			dot = facingDir.dot(this.root.forward);
			sector = 1 - Math.abs(dot) > RING_FACING_EPSILON;
			this._shapes.z.show(sector ? "sector" : "ring");
		}
		if (!facingDir.equalsApprox(this._facingDir, UPDATE_EPSILON3)) {
			this._facingDir.copy(facingDir);
			this._renderUpdate = true;
		}
	}
	_drag(state) {
		for (const axis in this._shapes) {
			const shape = this._shapes[axis];
			if (!(shape instanceof ArcShape)) {
				continue;
			}
			switch (this.dragMode) {
				case "show": {
					break;
				}
				case "hide": {
					shape.show(state ? axis === this._selectedAxis ? "ring" : "none" : "sector");
					continue;
				}
				case "selected": {
					shape.show(state ? axis === this._selectedAxis ? "ring" : "sector" : "sector");
					break;
				}
			}
		}
		this._renderUpdate = true;
	}
	_storeNodeRotations() {
		const gizmoPos = this.root.getLocalPosition();
		for (let i2 = 0; i2 < this.nodes.length; i2++) {
			const node = this.nodes[i2];
			this._nodeLocalRotations.set(node, node.getLocalRotation().clone());
			this._nodeRotations.set(node, node.getRotation().clone());
			this._nodeOffsets.set(node, node.getPosition().clone().sub(gizmoPos));
		}
	}
	_setNodeRotations(axis, angleAxis, angleDelta) {
		const gizmoPos = this.root.getLocalPosition();
		q1.setFromAxisAngle(angleAxis, angleDelta);
		for (let i2 = 0; i2 < this.nodes.length; i2++) {
			const node = this.nodes[i2];
			if ((axis === "x" || axis === "y" || axis === "z") && this._coordSpace === "local") {
				const rot = this._nodeLocalRotations.get(node);
				if (!rot) {
					continue;
				}
				q22.copy(rot).mul(q1);
				node.setLocalRotation(q22);
			} else {
				const rot = this._nodeRotations.get(node);
				if (!rot) {
					continue;
				}
				const offset3 = this._nodeOffsets.get(node);
				if (!offset3) {
					continue;
				}
				v13.copy(offset3);
				q1.transformVector(v13, v13);
				q22.copy(q1).mul(rot);
				node.setRotation(q22);
				node.setPosition(v13.add(gizmoPos));
			}
		}
		if (this._coordSpace === "local") {
			this._updateRotation();
		}
	}
	_screenToPoint(x3, y2) {
		const mouseWPos = this._camera.screenToWorld(x3, y2, 1);
		const axis = this._selectedAxis;
		const ray3 = this._createRay(mouseWPos);
		const plane2 = this._createPlane(axis, axis === "f" || axis === "xyz", false);
		if (!plane2.intersectsRay(ray3, point3)) {
			ray3.direction.mulScalar(-1);
			const intersection = plane2.intersectsRay(ray3, point3);
			ray3.direction.mulScalar(-1);
			if (!intersection) {
				return point3.copy(this.root.getLocalPosition());
			}
		}
		return point3;
	}
	_calculateArcAngle(point5, x3, y2) {
		const gizmoPos = this.root.getLocalPosition();
		const axis = this._selectedAxis;
		const plane2 = this._createPlane(axis, axis === "f", false);
		let angle = 0;
		const facingDir = this.facingDir;
		const facingDot = plane2.normal.dot(facingDir);
		switch (this.rotationMode) {
			case "absolute": {
				this._camera.worldToScreen(gizmoPos, v24);
				if (axis === "f" || facingDot > 1 - RING_FACING_EPSILON) {
					v13.set(
						this._screenStartPos.y >= v24.y ? 1 : -1,
						this._screenStartPos.x >= v24.x ? -1 : 1,
						0
					).normalize();
				} else {
					const projDir = v13.cross(plane2.normal, facingDir).normalize();
					this._camera.worldToScreen(projDir.add(gizmoPos), v32);
					v13.sub2(v32, v24).normalize();
				}
				v24.set(x3, y2, 0);
				angle = v13.dot(v24);
				break;
			}
			case "orbit": {
				v13.sub2(point5, gizmoPos);
				switch (axis) {
					case "x": {
						q1.copy(this._rootStartRot).invert().transformVector(v13, v13);
						angle = Math.atan2(v13.z, v13.y) * math.RAD_TO_DEG;
						break;
					}
					case "y": {
						q1.copy(this._rootStartRot).invert().transformVector(v13, v13);
						angle = Math.atan2(v13.x, v13.z) * math.RAD_TO_DEG;
						break;
					}
					case "z": {
						q1.copy(this._rootStartRot).invert().transformVector(v13, v13);
						angle = Math.atan2(v13.y, v13.x) * math.RAD_TO_DEG;
						break;
					}
					case "f": {
						q1.copy(this._camera.entity.getRotation()).invert().transformVector(v13, v13);
						angle = Math.sign(facingDot) * Math.atan2(v13.y, v13.x) * math.RAD_TO_DEG;
						break;
					}
				}
				const dir4 = v13.sub2(point5, this._camera.entity.getPosition()).normalize();
				const dot = dir4.dot(this._camera.entity.forward);
				if (dot < 0) {
					angle += 180;
				}
				break;
			}
		}
		return angle;
	}
	_drawGuideLines(pos, rot, activeAxis, activeIsPlane) {
		for (const axis of AXES3) {
			if (activeAxis === "xyz") {
				continue;
			}
			if (activeIsPlane) {
				if (axis !== activeAxis) {
					this._drawSpanLine(pos, rot, axis);
				}
			} else {
				if (axis === activeAxis) {
					this._drawSpanLine(pos, rot, axis);
				}
			}
		}
	}
	prerender() {
		super.prerender();
		if (!this.enabled) {
			return;
		}
		this._shapesLookAtCamera();
	}
	destroy() {
		this._guideAngleLines.forEach((line) => line.destroy());
		super.destroy();
	}
};

var BoxShape = class extends Shape {
	_size = 0.06;
	constructor(device, args = {}) {
		super(device, "boxCenter", args);
		this._size = args.size ?? this._size;
		this.triData = [
			new TriData(new BoxGeometry(), 2)
		];
		this._createRenderComponent(this.entity, [
			Mesh.fromGeometry(this.device, new BoxGeometry())
		]);
		this._update();
	}
	set size(value) {
		this._size = value ?? this._size;
		this._update();
	}
	get size() {
		return this._size;
	}
	_update() {
		this.entity.setLocalScale(this._size, this._size, this._size);
	}
};

var tmpV15 = new Vec3();
var tmpV23 = new Vec3();
var tmpQ12 = new Quat();
var BoxLineShape = class extends Shape {
	_gap = 0;
	_lineThickness = 0.02;
	_lineLength = 0.5;
	_boxSize = 0.12;
	_tolerance = 0.1;
	_box;
	_line;
	_flipped = false;
	constructor(device, args = {}) {
		super(device, "boxLine", args);
		this._gap = args.gap ?? this._gap;
		this._lineThickness = args.lineThickness ?? this._lineThickness;
		this._lineLength = args.lineLength ?? this._lineLength;
		this._boxSize = args.boxSize ?? this._boxSize;
		this._tolerance = args.tolerance ?? this._tolerance;
		this.triData = [
			new TriData(new BoxGeometry()),
			new TriData(new CylinderGeometry(), 1)
		];
		this._box = new Entity(`box:${this.axis}`);
		this.entity.addChild(this._box);
		this._createRenderComponent(this._box, [
			Mesh.fromGeometry(this.device, new BoxGeometry())
		]);
		this._line = new Entity(`line:${this.axis}`);
		this.entity.addChild(this._line);
		this._createRenderComponent(this._line, [
			Mesh.fromGeometry(this.device, new CylinderGeometry())
		]);
		this._update();
	}
	set gap(value) {
		this._gap = value ?? this._gap;
		this._update();
	}
	get gap() {
		return this._gap;
	}
	set lineThickness(value) {
		this._lineThickness = value ?? this._lineThickness;
		this._update();
	}
	get lineThickness() {
		return this._lineThickness;
	}
	set lineLength(value) {
		this._lineLength = value ?? this._lineLength;
		this._update();
	}
	get lineLength() {
		return this._lineLength;
	}
	set boxSize(value) {
		this._boxSize = value ?? this._boxSize;
		this._update();
	}
	get boxSize() {
		return this._boxSize;
	}
	set tolerance(value) {
		this._tolerance = value;
		this._update();
	}
	get tolerance() {
		return this._tolerance;
	}
	set flipped(value) {
		if (this._flipped === value) {
			return;
		}
		this._flipped = value;
		if (this._rotation.equals(Vec3.ZERO)) {
			tmpV15.set(0, 0, this._flipped ? 180 : 0);
		} else {
			tmpV15.copy(this._rotation).mulScalar(this._flipped ? -1 : 1);
		}
		this._line.enabled = !this._flipped;
		this.entity.setLocalEulerAngles(tmpV15);
	}
	get flipped() {
		return this._flipped;
	}
	_update() {
		tmpV15.set(0, this._gap + this._boxSize * 0.5 + this._lineLength, 0);
		tmpQ12.set(0, 0, 0, 1);
		tmpV23.set(this._boxSize, this._boxSize, this._boxSize);
		this.triData[0].setTransform(tmpV15, tmpQ12, tmpV23);
		tmpV15.set(0, this._gap + this._lineLength * 0.5, 0);
		tmpQ12.set(0, 0, 0, 1);
		tmpV23.set(this._lineThickness + this._tolerance, this._lineLength, this._lineThickness + this._tolerance);
		this.triData[1].setTransform(tmpV15, tmpQ12, tmpV23);
		this._box.setLocalPosition(0, this._gap + this._boxSize * 0.5 + this._lineLength, 0);
		this._box.setLocalScale(this._boxSize, this._boxSize, this._boxSize);
		this._line.setLocalPosition(0, this._gap + this._lineLength * 0.5, 0);
		this._line.setLocalScale(this._lineThickness, this._lineLength, this._lineThickness);
	}
};

var v14 = new Vec3();
var v25 = new Vec3();
var point4 = new Vec3();
var delta2 = new Vec3();
var q4 = new Quat();
var GLANCE_EPSILON2 = 0.01;
var ScaleGizmo = class extends TransformGizmo {
	_shapes = {
		xyz: new BoxShape(this._device, {
			axis: "xyz",
			layers: [this._layer.id],
			defaultColor: this._theme.shapeBase.xyz,
			hoverColor: this._theme.shapeHover.xyz,
			disabledColor: this._theme.disabled
		}),
		yz: new PlaneShape(this._device, {
			axis: "x",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, -90),
			defaultColor: this._theme.shapeBase.x,
			hoverColor: this._theme.shapeHover.x,
			disabledColor: this._theme.disabled,
			depth: 1
		}),
		xz: new PlaneShape(this._device, {
			axis: "y",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, 0),
			defaultColor: this._theme.shapeBase.y,
			hoverColor: this._theme.shapeHover.y,
			disabledColor: this._theme.disabled,
			depth: 1
		}),
		xy: new PlaneShape(this._device, {
			axis: "z",
			layers: [this._layer.id],
			rotation: new Vec3(90, 0, 0),
			defaultColor: this._theme.shapeBase.z,
			hoverColor: this._theme.shapeHover.z,
			disabledColor: this._theme.disabled,
			depth: 1
		}),
		x: new BoxLineShape(this._device, {
			axis: "x",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, -90),
			defaultColor: this._theme.shapeBase.x,
			hoverColor: this._theme.shapeHover.x,
			disabledColor: this._theme.disabled
		}),
		y: new BoxLineShape(this._device, {
			axis: "y",
			layers: [this._layer.id],
			rotation: new Vec3(0, 0, 0),
			defaultColor: this._theme.shapeBase.y,
			hoverColor: this._theme.shapeHover.y,
			disabledColor: this._theme.disabled
		}),
		z: new BoxLineShape(this._device, {
			axis: "z",
			layers: [this._layer.id],
			rotation: new Vec3(90, 0, 0),
			defaultColor: this._theme.shapeBase.z,
			hoverColor: this._theme.shapeHover.z,
			disabledColor: this._theme.disabled
		})
	};
	_coordSpace = "local";
	_nodeScales = /* @__PURE__ */ new Map();
	_uniform = false;
	snapIncrement = 1;
	flipPlanes = true;
	lowerBoundScale = new Vec3(-Infinity, -Infinity, -Infinity);
	constructor(camera, layer) {
		super(camera, layer, "gizmo:scale");
		this._createTransform();
		this.on(TransformGizmo.EVENT_TRANSFORMSTART, () => {
			this._storeNodeScales();
			this._drag(true);
		});
		this.on(TransformGizmo.EVENT_TRANSFORMMOVE, (point5) => {
			const scaleDelta = delta2.copy(point5).sub(this._selectionStartPoint);
			if (this.snap) {
				scaleDelta.mulScalar(1 / this.snapIncrement);
				scaleDelta.round();
				scaleDelta.mulScalar(this.snapIncrement);
			}
			scaleDelta.mulScalar(1 / this._scale);
			this._setNodeScales(scaleDelta.add(Vec3.ONE));
		});
		this.on(TransformGizmo.EVENT_TRANSFORMEND, () => {
			this._drag(false);
		});
		this.on(TransformGizmo.EVENT_NODESDETACH, () => {
			this._nodeScales.clear();
		});
	}
	set coordSpace(value) {
	}
	get coordSpace() {
		return this._coordSpace;
	}
	set uniform(value) {
		this._uniform = value ?? this._uniform;
	}
	get uniform() {
		return this._uniform;
	}
	set axisGap(value) {
		this._setArrowProp("gap", value);
	}
	get axisGap() {
		return this._shapes.x.gap;
	}
	set axisLineThickness(value) {
		this._setArrowProp("lineThickness", value);
	}
	get axisLineThickness() {
		return this._shapes.x.lineThickness;
	}
	set axisLineLength(value) {
		this._setArrowProp("lineLength", value);
	}
	get axisLineLength() {
		return this._shapes.x.lineLength;
	}
	set axisLineTolerance(value) {
		this._setArrowProp("tolerance", value);
	}
	get axisLineTolerance() {
		return this._shapes.x.tolerance;
	}
	set axisBoxSize(value) {
		this._setArrowProp("boxSize", value);
	}
	get axisBoxSize() {
		return this._shapes.x.boxSize;
	}
	set axisPlaneSize(value) {
		this._setPlaneProp("size", value);
	}
	get axisPlaneSize() {
		return this._shapes.yz.size;
	}
	set axisPlaneGap(value) {
		this._setPlaneProp("gap", value);
	}
	get axisPlaneGap() {
		return this._shapes.yz.gap;
	}
	set axisCenterSize(value) {
		this._shapes.xyz.size = value;
	}
	get axisCenterSize() {
		return this._shapes.xyz.size;
	}
	set flipShapes(value) {
		this.flipPlanes = value;
	}
	get flipShapes() {
		return this.flipPlanes;
	}
	_setArrowProp(prop, value) {
		this._shapes.x[prop] = value;
		this._shapes.y[prop] = value;
		this._shapes.z[prop] = value;
	}
	_setPlaneProp(prop, value) {
		this._shapes.yz[prop] = value;
		this._shapes.xz[prop] = value;
		this._shapes.xy[prop] = value;
	}
	_shapesLookAtCamera() {
		const cameraDir = this.cameraDir;
		let changed = false;
		let dot, enabled;
		dot = cameraDir.dot(this.root.right);
		enabled = 1 - Math.abs(dot) > GLANCE_EPSILON2;
		if (this._shapes.x.entity.enabled !== enabled) {
			this._shapes.x.entity.enabled = enabled;
			changed = true;
		}
		dot = cameraDir.dot(this.root.up);
		enabled = 1 - Math.abs(dot) > GLANCE_EPSILON2;
		if (this._shapes.y.entity.enabled !== enabled) {
			this._shapes.y.entity.enabled = enabled;
			changed = true;
		}
		dot = cameraDir.dot(this.root.forward);
		enabled = 1 - Math.abs(dot) > GLANCE_EPSILON2;
		if (this._shapes.z.entity.enabled !== enabled) {
			this._shapes.z.entity.enabled = enabled;
			changed = true;
		}
		let flipped;
		v14.cross(cameraDir, this.root.right);
		enabled = 1 - v14.length() > GLANCE_EPSILON2;
		if (this._shapes.yz.entity.enabled !== enabled) {
			this._shapes.yz.entity.enabled = enabled;
			changed = true;
		}
		flipped = this.flipPlanes ? v25.set(0, +(v14.dot(this.root.forward) < 0), +(v14.dot(this.root.up) < 0)) : Vec3.ZERO;
		if (!this._shapes.yz.flipped.equals(flipped)) {
			this._shapes.yz.flipped = flipped;
			changed = true;
		}
		v14.cross(cameraDir, this.root.forward);
		enabled = 1 - v14.length() > GLANCE_EPSILON2;
		if (this._shapes.xy.entity.enabled !== enabled) {
			this._shapes.xy.entity.enabled = enabled;
			changed = true;
		}
		flipped = this.flipPlanes ? v25.set(+(v14.dot(this.root.up) < 0), +(v14.dot(this.root.right) > 0), 0) : Vec3.ZERO;
		if (!this._shapes.xy.flipped.equals(flipped)) {
			this._shapes.xy.flipped = flipped;
			changed = true;
		}
		v14.cross(cameraDir, this.root.up);
		enabled = 1 - v14.length() > GLANCE_EPSILON2;
		if (this._shapes.xz.entity.enabled !== enabled) {
			this._shapes.xz.entity.enabled = enabled;
			changed = true;
		}
		flipped = this.flipPlanes ? v25.set(+(v14.dot(this.root.forward) > 0), 0, +(v14.dot(this.root.right) > 0)) : Vec3.ZERO;
		if (!this._shapes.xz.flipped.equals(flipped)) {
			this._shapes.xz.flipped = flipped;
			changed = true;
		}
		if (changed) {
			this._renderUpdate = true;
		}
	}
	_drag(state) {
		for (const axis in this._shapes) {
			const shape = this._shapes[axis];
			switch (this.dragMode) {
				case "show": {
					continue;
				}
				case "hide": {
					shape.visible = !state;
					continue;
				}
				case "selected": {
					if (this._selectedAxis === "xyz") {
						shape.visible = state ? axis.length === 1 : true;
						continue;
					}
					if (this._selectedIsPlane) {
						shape.visible = state ? axis.length === 1 && !axis.includes(this._selectedAxis) : true;
						continue;
					}
					shape.visible = state ? axis === this._selectedAxis : true;
					continue;
				}
			}
		}
		this._renderUpdate = true;
	}
	_storeNodeScales() {
		for (let i2 = 0; i2 < this.nodes.length; i2++) {
			const node = this.nodes[i2];
			this._nodeScales.set(node, node.getLocalScale().clone());
		}
	}
	_setNodeScales(scaleDelta) {
		for (let i2 = 0; i2 < this.nodes.length; i2++) {
			const node = this.nodes[i2];
			const scale2 = this._nodeScales.get(node);
			if (!scale2) {
				continue;
			}
			node.setLocalScale(v14.copy(scale2).mul(scaleDelta).max(this.lowerBoundScale));
		}
	}
	_screenToPoint(x3, y2) {
		const gizmoPos = this.root.getLocalPosition();
		const mouseWPos = this._camera.screenToWorld(x3, y2, 1);
		const axis = this._selectedAxis;
		const isPlane = this._selectedIsPlane;
		const ray3 = this._createRay(mouseWPos);
		const plane2 = this._createPlane(axis, axis === "xyz", !isPlane);
		if (!plane2.intersectsRay(ray3, point4)) {
			return point4;
		}
		if (axis === "xyz") {
			const projDir = v25.add2(this._camera.entity.up, this._camera.entity.right).normalize();
			const dir4 = v14.sub2(point4, gizmoPos);
			const v6 = dir4.length() * dir4.normalize().dot(projDir);
			point4.set(v6, v6, v6);
			return point4;
		}
		q4.copy(this._rootStartRot).invert().transformVector(point4, point4);
		if (!isPlane) {
			this._projectToAxis(point4, axis);
		}
		if (this._uniform && isPlane) {
			v14.set(1, 1, 1);
			v14[axis] = 0;
			point4.copy(v14.mulScalar(v14.dot(point4)));
			point4[axis] = 0;
		}
		return point4;
	}
	prerender() {
		super.prerender();
		if (!this.enabled) {
			return;
		}
		this._shapesLookAtCamera();
	}
};

var tmpV16 = new Vec3();
var tmpV24 = new Vec3();
var tmpV32 = new Vec3();
var tmpM1 = new Mat4();
var ViewCube = class _ViewCube extends EventHandler {
	static EVENT_CAMERAALIGN = "camera:align";
	_size = 0;
	_svg;
	_group;
	_anchor = new Vec4(1, 1, 1, 1);
	_colorX = COLOR_RED.clone();
	_colorY = COLOR_GREEN.clone();
	_colorZ = COLOR_BLUE.clone();
	_colorNeg = new Color(0.3, 0.3, 0.3);
	_radius = 10;
	_textSize = 10;
	_lineThickness = 2;
	_lineLength = 40;
	_shapes;
	constructor(anchor) {
		super();
		this.dom = document.createElement("div");
		this.dom.id = "view-cube-container";
		this.dom.style.cssText = [
			"position: absolute",
			"margin: auto",
			"pointer-events: none"
		].join(";");
		document.body.appendChild(this.dom);
		this.anchor = anchor ?? this._anchor;
		this._svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		this._svg.id = "view-cube-svg";
		this._group = document.createElementNS(this._svg.namespaceURI, "g");
		this._svg.appendChild(this._group);
		this._resize();
		const colX = this._colorX.toString(false);
		const colY = this._colorY.toString(false);
		const colZ = this._colorZ.toString(false);
		this._shapes = {
			nx: this._circle(colX),
			ny: this._circle(colY),
			nz: this._circle(colZ),
			px: this._circle(colX, true, "X"),
			py: this._circle(colY, true, "Y"),
			pz: this._circle(colZ, true, "Z"),
			xaxis: this._line(colX),
			yaxis: this._line(colY),
			zaxis: this._line(colZ)
		};
		this._shapes.px.children[0].addEventListener("pointerdown", () => {
			this.fire(_ViewCube.EVENT_CAMERAALIGN, Vec3.RIGHT);
		});
		this._shapes.py.children[0].addEventListener("pointerdown", () => {
			this.fire(_ViewCube.EVENT_CAMERAALIGN, Vec3.UP);
		});
		this._shapes.pz.children[0].addEventListener("pointerdown", () => {
			this.fire(_ViewCube.EVENT_CAMERAALIGN, Vec3.BACK);
		});
		this._shapes.nx.children[0].addEventListener("pointerdown", () => {
			this.fire(_ViewCube.EVENT_CAMERAALIGN, Vec3.LEFT);
		});
		this._shapes.ny.children[0].addEventListener("pointerdown", () => {
			this.fire(_ViewCube.EVENT_CAMERAALIGN, Vec3.DOWN);
		});
		this._shapes.nz.children[0].addEventListener("pointerdown", () => {
			this.fire(_ViewCube.EVENT_CAMERAALIGN, Vec3.FORWARD);
		});
		this.dom.appendChild(this._svg);
	}
	set anchor(value) {
		this._anchor.copy(value);
		this.dom.style.top = this._anchor.x ? "0px" : "auto";
		this.dom.style.right = this._anchor.y ? "0px" : "auto";
		this.dom.style.bottom = this._anchor.z ? "0px" : "auto";
		this.dom.style.left = this._anchor.w ? "0px" : "auto";
	}
	get anchor() {
		return this._anchor;
	}
	set colorX(value) {
		this._colorX.copy(value);
		this._shapes.px.children[0].setAttribute("fill", this._colorX.toString(false));
		this._shapes.px.children[0].setAttribute("stroke", this._colorX.toString(false));
		this._shapes.nx.children[0].setAttribute("stroke", this._colorX.toString(false));
		this._shapes.xaxis.setAttribute("stroke", this._colorX.toString(false));
	}
	get colorX() {
		return this._colorX;
	}
	set colorY(value) {
		this._colorY.copy(value);
		this._shapes.py.children[0].setAttribute("fill", this._colorY.toString(false));
		this._shapes.py.children[0].setAttribute("stroke", this._colorY.toString(false));
		this._shapes.ny.children[0].setAttribute("stroke", this._colorY.toString(false));
		this._shapes.yaxis.setAttribute("stroke", this._colorY.toString(false));
	}
	get colorY() {
		return this._colorY;
	}
	set colorZ(value) {
		this._colorZ.copy(value);
		this._shapes.pz.children[0].setAttribute("fill", this._colorZ.toString(false));
		this._shapes.pz.children[0].setAttribute("stroke", this._colorZ.toString(false));
		this._shapes.nz.children[0].setAttribute("stroke", this._colorZ.toString(false));
		this._shapes.zaxis.setAttribute("stroke", this._colorZ.toString(false));
	}
	get colorZ() {
		return this._colorZ;
	}
	set colorNeg(value) {
		this._colorNeg.copy(value);
		this._shapes.px.children[0].setAttribute("fill", this._colorNeg.toString(false));
		this._shapes.py.children[0].setAttribute("fill", this._colorNeg.toString(false));
		this._shapes.pz.children[0].setAttribute("fill", this._colorNeg.toString(false));
	}
	get colorNeg() {
		return this._colorNeg;
	}
	set radius(value) {
		this._radius = value;
		this._shapes.px.children[0].setAttribute("r", `${value}`);
		this._shapes.py.children[0].setAttribute("r", `${value}`);
		this._shapes.pz.children[0].setAttribute("r", `${value}`);
		this._shapes.nx.children[0].setAttribute("r", `${value}`);
		this._shapes.ny.children[0].setAttribute("r", `${value}`);
		this._shapes.nz.children[0].setAttribute("r", `${value}`);
		this._resize();
	}
	get radius() {
		return this._radius;
	}
	set textSize(value) {
		this._textSize = value;
		this._shapes.px.children[1].setAttribute("font-size", `${value}`);
		this._shapes.py.children[1].setAttribute("font-size", `${value}`);
		this._shapes.pz.children[1].setAttribute("font-size", `${value}`);
	}
	get textSize() {
		return this._textSize;
	}
	set lineThickness(value) {
		this._lineThickness = value;
		this._shapes.xaxis.setAttribute("stroke-width", `${value}`);
		this._shapes.yaxis.setAttribute("stroke-width", `${value}`);
		this._shapes.zaxis.setAttribute("stroke-width", `${value}`);
		this._shapes.px.children[0].setAttribute("stroke-width", `${value}`);
		this._shapes.py.children[0].setAttribute("stroke-width", `${value}`);
		this._shapes.pz.children[0].setAttribute("stroke-width", `${value}`);
		this._shapes.nx.children[0].setAttribute("stroke-width", `${value}`);
		this._shapes.ny.children[0].setAttribute("stroke-width", `${value}`);
		this._shapes.nz.children[0].setAttribute("stroke-width", `${value}`);
		this._resize();
	}
	get lineThickness() {
		return this._lineThickness;
	}
	set lineLength(value) {
		this._lineLength = value;
		this._resize();
	}
	get lineLength() {
		return this._lineLength;
	}
	_resize() {
		this._size = 2 * (this.lineLength + this.radius + this.lineThickness);
		this.dom.style.width = `${this._size}px`;
		this.dom.style.height = `${this._size}px`;
		this._svg.setAttribute("width", `${this._size}`);
		this._svg.setAttribute("height", `${this._size}`);
		this._group.setAttribute("transform", `translate(${this._size * 0.5}, ${this._size * 0.5})`);
	}
	_transform(group, x3, y2) {
		group.setAttribute("transform", `translate(${x3 * this._lineLength}, ${y2 * this._lineLength})`);
	}
	_x2y2(line, x3, y2) {
		line.setAttribute("x2", `${x3 * this._lineLength}`);
		line.setAttribute("y2", `${y2 * this._lineLength}`);
	}
	_line(color3) {
		const result = document.createElementNS(this._svg.namespaceURI, "line");
		result.setAttribute("stroke", color3);
		result.setAttribute("stroke-width", `${this._lineThickness}`);
		this._group.appendChild(result);
		return result;
	}
	_circle(color3, fill = false, text) {
		const group = document.createElementNS(this._svg.namespaceURI, "g");
		const circle = document.createElementNS(this._svg.namespaceURI, "circle");
		circle.setAttribute("fill", fill ? color3 : this._colorNeg.toString(false));
		circle.setAttribute("stroke", color3);
		circle.setAttribute("stroke-width", `${this._lineThickness}`);
		circle.setAttribute("r", `${this._radius}`);
		circle.setAttribute("cx", "0");
		circle.setAttribute("cy", "0");
		circle.setAttribute("pointer-events", "all");
		group.appendChild(circle);
		if (text) {
			const t = document.createElementNS(this._svg.namespaceURI, "text");
			t.setAttribute("font-size", `${this._textSize}`);
			t.setAttribute("font-family", "Arial");
			t.setAttribute("font-weight", "bold");
			t.setAttribute("text-anchor", "middle");
			t.setAttribute("alignment-baseline", "central");
			t.textContent = text;
			group.appendChild(t);
		}
		group.setAttribute("cursor", "pointer");
		this._group.appendChild(group);
		return group;
	}
	update(cameraMatrix) {
		if (!this._size) {
			return;
		}
		tmpM1.invert(cameraMatrix);
		tmpM1.getX(tmpV16);
		tmpM1.getY(tmpV24);
		tmpM1.getZ(tmpV32);
		this._transform(this._shapes.px, tmpV16.x, -tmpV16.y);
		this._transform(this._shapes.nx, -tmpV16.x, tmpV16.y);
		this._transform(this._shapes.py, tmpV24.x, -tmpV24.y);
		this._transform(this._shapes.ny, -tmpV24.x, tmpV24.y);
		this._transform(this._shapes.pz, tmpV32.x, -tmpV32.y);
		this._transform(this._shapes.nz, -tmpV32.x, tmpV32.y);
		this._x2y2(this._shapes.xaxis, tmpV16.x, -tmpV16.y);
		this._x2y2(this._shapes.yaxis, tmpV24.x, -tmpV24.y);
		this._x2y2(this._shapes.zaxis, tmpV32.x, -tmpV32.y);
		const order = [
			{ n: ["xaxis", "px"], value: tmpV16.z },
			{ n: ["yaxis", "py"], value: tmpV24.z },
			{ n: ["zaxis", "pz"], value: tmpV32.z },
			{ n: ["nx"], value: -tmpV16.z },
			{ n: ["ny"], value: -tmpV24.z },
			{ n: ["nz"], value: -tmpV32.z }
		].sort((a, b) => a.value - b.value);
		const fragment = document.createDocumentFragment();
		order.forEach((o) => {
			o.n.forEach((n) => {
				fragment.appendChild(this._shapes[n]);
			});
		});
		this._group.appendChild(fragment);
	}
	destroy() {
		this.dom.remove();
		this.off();
	}
};
export {
	ABSOLUTE_URL,
	ACTION_GAMEPAD,
	ACTION_KEYBOARD,
	ACTION_MOUSE,
	ADDRESS_CLAMP_TO_EDGE,
	ADDRESS_MIRRORED_REPEAT,
	ADDRESS_REPEAT,
	AMBIENTSRC_AMBIENTSH,
	AMBIENTSRC_CONSTANT,
	AMBIENTSRC_ENVALATLAS,
	ANIM_BLEND_1D,
	ANIM_BLEND_2D_CARTESIAN,
	ANIM_BLEND_2D_DIRECTIONAL,
	ANIM_BLEND_DIRECT,
	ANIM_CONTROL_STATES,
	ANIM_EQUAL_TO,
	ANIM_GREATER_THAN,
	ANIM_GREATER_THAN_EQUAL_TO,
	ANIM_INTERRUPTION_NEXT,
	ANIM_INTERRUPTION_NEXT_PREV,
	ANIM_INTERRUPTION_NONE,
	ANIM_INTERRUPTION_PREV,
	ANIM_INTERRUPTION_PREV_NEXT,
	ANIM_LAYER_ADDITIVE,
	ANIM_LAYER_OVERWRITE,
	ANIM_LESS_THAN,
	ANIM_LESS_THAN_EQUAL_TO,
	ANIM_NOT_EQUAL_TO,
	ANIM_PARAMETER_BOOLEAN,
	ANIM_PARAMETER_FLOAT,
	ANIM_PARAMETER_INTEGER,
	ANIM_PARAMETER_TRIGGER,
	ANIM_STATE_ANY,
	ANIM_STATE_END,
	ANIM_STATE_START,
	ASPECT_AUTO,
	ASPECT_MANUAL,
	ASSET_ANIMATION,
	ASSET_AUDIO,
	ASSET_CONTAINER,
	ASSET_CSS,
	ASSET_CUBEMAP,
	ASSET_HTML,
	ASSET_IMAGE,
	ASSET_JSON,
	ASSET_MATERIAL,
	ASSET_MODEL,
	ASSET_SCRIPT,
	ASSET_SHADER,
	ASSET_TEXT,
	ASSET_TEXTURE,
	ASSET_TEXTUREATLAS,
	AXIS_KEY,
	AXIS_MOUSE_X,
	AXIS_MOUSE_Y,
	AXIS_PAD_L_X,
	AXIS_PAD_L_Y,
	AXIS_PAD_R_X,
	AXIS_PAD_R_Y,
	AnimBinder,
	AnimClip,
	AnimClipHandler,
	AnimComponent,
	AnimComponentLayer,
	AnimComponentSystem,
	AnimController,
	AnimCurve,
	AnimData,
	AnimEvaluator,
	AnimEvents,
	AnimSnapshot,
	AnimStateGraph,
	AnimStateGraphHandler,
	AnimTarget,
	AnimTrack,
	Animation,
	AnimationComponent,
	AnimationComponentSystem,
	AnimationHandler,
	AnimationKey,
	AnimationNode,
	AppBase,
	AppOptions,
	Application,
	Asset,
	AssetListLoader,
	AssetReference,
	AssetRegistry,
	AudioHandler,
	AudioListenerComponent,
	AudioListenerComponentSystem,
	BAKE_COLOR,
	BAKE_COLORDIR,
	BINDGROUP_MESH,
	BINDGROUP_MESH_UB,
	BINDGROUP_VIEW,
	BLENDEQUATION_ADD,
	BLENDEQUATION_MAX,
	BLENDEQUATION_MIN,
	BLENDEQUATION_REVERSE_SUBTRACT,
	BLENDEQUATION_SUBTRACT,
	BLENDMODE_CONSTANT,
	BLENDMODE_CONSTANT_ALPHA,
	BLENDMODE_CONSTANT_COLOR,
	BLENDMODE_DST_ALPHA,
	BLENDMODE_DST_COLOR,
	BLENDMODE_ONE,
	BLENDMODE_ONE_MINUS_CONSTANT,
	BLENDMODE_ONE_MINUS_CONSTANT_ALPHA,
	BLENDMODE_ONE_MINUS_CONSTANT_COLOR,
	BLENDMODE_ONE_MINUS_DST_ALPHA,
	BLENDMODE_ONE_MINUS_DST_COLOR,
	BLENDMODE_ONE_MINUS_SRC_ALPHA,
	BLENDMODE_ONE_MINUS_SRC_COLOR,
	BLENDMODE_SRC_ALPHA,
	BLENDMODE_SRC_ALPHA_SATURATE,
	BLENDMODE_SRC_COLOR,
	BLENDMODE_ZERO,
	BLEND_ADDITIVE,
	BLEND_ADDITIVEALPHA,
	BLEND_MAX,
	BLEND_MIN,
	BLEND_MULTIPLICATIVE,
	BLEND_MULTIPLICATIVE2X,
	BLEND_NONE,
	BLEND_NORMAL,
	BLEND_PREMULTIPLIED,
	BLEND_SCREEN,
	BLEND_SUBTRACTIVE,
	BLUR_BOX,
	BLUR_GAUSSIAN,
	BODYFLAG_KINEMATIC_OBJECT,
	BODYFLAG_NORESPONSE_OBJECT,
	BODYFLAG_STATIC_OBJECT,
	BODYGROUP_DEFAULT,
	BODYGROUP_DYNAMIC,
	BODYGROUP_ENGINE_1,
	BODYGROUP_ENGINE_2,
	BODYGROUP_ENGINE_3,
	BODYGROUP_KINEMATIC,
	BODYGROUP_NONE,
	BODYGROUP_STATIC,
	BODYGROUP_TRIGGER,
	BODYGROUP_USER_1,
	BODYGROUP_USER_2,
	BODYGROUP_USER_3,
	BODYGROUP_USER_4,
	BODYGROUP_USER_5,
	BODYGROUP_USER_6,
	BODYGROUP_USER_7,
	BODYGROUP_USER_8,
	BODYMASK_ALL,
	BODYMASK_NONE,
	BODYMASK_NOT_STATIC,
	BODYMASK_NOT_STATIC_KINEMATIC,
	BODYMASK_STATIC,
	BODYSTATE_ACTIVE_TAG,
	BODYSTATE_DISABLE_DEACTIVATION,
	BODYSTATE_DISABLE_SIMULATION,
	BODYSTATE_ISLAND_SLEEPING,
	BODYSTATE_WANTS_DEACTIVATION,
	BODYTYPE_DYNAMIC,
	BODYTYPE_KINEMATIC,
	BODYTYPE_STATIC,
	BUFFERUSAGE_COPY_DST,
	BUFFERUSAGE_COPY_SRC,
	BUFFERUSAGE_INDEX,
	BUFFERUSAGE_INDIRECT,
	BUFFERUSAGE_READ,
	BUFFERUSAGE_STORAGE,
	BUFFERUSAGE_UNIFORM,
	BUFFERUSAGE_VERTEX,
	BUFFERUSAGE_WRITE,
	BUFFER_DYNAMIC,
	BUFFER_GPUDYNAMIC,
	BUFFER_STATIC,
	BUFFER_STREAM,
	BUTTON_TRANSITION_MODE_SPRITE_CHANGE,
	BUTTON_TRANSITION_MODE_TINT,
	Batch,
	BatchGroup,
	BatchManager,
	BinaryHandler,
	BindGroupFormat,
	BindStorageBufferFormat,
	BindStorageTextureFormat,
	BindTextureFormat,
	BindUniformBufferFormat,
	BlendState,
	BoundingBox,
	BoundingSphere,
	BoxGeometry,
	Bundle,
	BundleHandler,
	BundleRegistry,
	ButtonComponent,
	ButtonComponentSystem,
	CHUNKAPI_1_51,
	CHUNKAPI_1_55,
	CHUNKAPI_1_56,
	CHUNKAPI_1_57,
	CHUNKAPI_1_58,
	CHUNKAPI_1_60,
	CHUNKAPI_1_62,
	CHUNKAPI_1_65,
	CHUNKAPI_1_70,
	CHUNKAPI_2_1,
	CHUNKAPI_2_3,
	CHUNKAPI_2_5,
	CHUNKAPI_2_6,
	CHUNKAPI_2_7,
	CHUNKAPI_2_8,
	CLEARFLAG_COLOR,
	CLEARFLAG_DEPTH,
	CLEARFLAG_STENCIL,
	CUBEFACE_NEGX,
	CUBEFACE_NEGY,
	CUBEFACE_NEGZ,
	CUBEFACE_POSX,
	CUBEFACE_POSY,
	CUBEFACE_POSZ,
	CUBEPROJ_BOX,
	CUBEPROJ_NONE,
	CULLFACE_BACK,
	CULLFACE_FRONT,
	CULLFACE_FRONTANDBACK,
	CULLFACE_NONE,
	CURVE_LINEAR,
	CURVE_SMOOTHSTEP,
	CURVE_SPLINE,
	CURVE_STEP,
	Camera,
	CameraComponent,
	CameraComponentSystem,
	CameraFrame,
	CameraFrameOptions,
	CanvasFont,
	CapsuleGeometry,
	ChunkUtils,
	CircleGeometry,
	CollisionComponent,
	CollisionComponentSystem,
	Color,
	Component,
	ComponentSystem,
	ComponentSystemRegistry,
	Compute,
	ComputeRadixSort,
	ConeGeometry,
	ContactPoint,
	ContactResult,
	ContainerHandler,
	ContainerResource,
	Controller,
	CssHandler,
	CubemapHandler,
	Curve,
	CurveSet,
	CylinderGeometry,
	DETAILMODE_ADD,
	DETAILMODE_MAX,
	DETAILMODE_MIN,
	DETAILMODE_MUL,
	DETAILMODE_OVERLAY,
	DETAILMODE_SCREEN,
	DEVICETYPE_NULL,
	DEVICETYPE_WEBGL2,
	DEVICETYPE_WEBGPU,
	DEVICETYPE_WEBGPU_BARE,
	DISPLAYFORMAT_HDR,
	DISPLAYFORMAT_LDR,
	DISPLAYFORMAT_LDR_SRGB,
	DISTANCE_EXPONENTIAL,
	DISTANCE_INVERSE,
	DISTANCE_LINEAR,
	DITHER_BAYER8,
	DITHER_BLUENOISE,
	DITHER_IGNNOISE,
	DITHER_NONE,
	DefaultAnimBinder,
	DepthState,
	DomeGeometry,
	DrawCommands,
	DualGestureSource,
	ELEMENTTYPE_GROUP,
	ELEMENTTYPE_IMAGE,
	ELEMENTTYPE_TEXT,
	EMITTERSHAPE_BOX,
	EMITTERSHAPE_SPHERE,
	EVENT_CULL_END,
	EVENT_GAMEPADCONNECTED,
	EVENT_GAMEPADDISCONNECTED,
	EVENT_KEYDOWN,
	EVENT_KEYUP,
	EVENT_MOUSEDOWN,
	EVENT_MOUSEMOVE,
	EVENT_MOUSEUP,
	EVENT_MOUSEWHEEL,
	EVENT_POSTCULL,
	EVENT_POSTRENDER,
	EVENT_POSTRENDER_LAYER,
	EVENT_PRECULL,
	EVENT_PRERENDER,
	EVENT_PRERENDER_LAYER,
	EVENT_SELECT,
	EVENT_SELECTEND,
	EVENT_SELECTSTART,
	EVENT_TOUCHCANCEL,
	EVENT_TOUCHEND,
	EVENT_TOUCHMOVE,
	EVENT_TOUCHSTART,
	ElementComponent,
	ElementComponentSystem,
	ElementDragHelper,
	ElementInput,
	ElementInputEvent,
	ElementMouseEvent,
	ElementSelectEvent,
	ElementTouchEvent,
	Entity,
	EnvLighting,
	EventHandle,
	EventHandler,
	FILLMODE_FILL_WINDOW,
	FILLMODE_KEEP_ASPECT,
	FILLMODE_NONE,
	FILTER_LINEAR,
	FILTER_LINEAR_MIPMAP_LINEAR,
	FILTER_LINEAR_MIPMAP_NEAREST,
	FILTER_NEAREST,
	FILTER_NEAREST_MIPMAP_LINEAR,
	FILTER_NEAREST_MIPMAP_NEAREST,
	FITMODE_CONTAIN,
	FITMODE_COVER,
	FITMODE_STRETCH,
	FITTING_BOTH,
	FITTING_NONE,
	FITTING_SHRINK,
	FITTING_STRETCH,
	FOG_EXP,
	FOG_EXP2,
	FOG_LINEAR,
	FOG_NONE,
	FONT_BITMAP,
	FONT_MSDF,
	FRESNEL_NONE,
	FRESNEL_SCHLICK,
	FRONTFACE_CCW,
	FRONTFACE_CW,
	FUNC_ALWAYS,
	FUNC_EQUAL,
	FUNC_GREATER,
	FUNC_GREATEREQUAL,
	FUNC_LESS,
	FUNC_LESSEQUAL,
	FUNC_NEVER,
	FUNC_NOTEQUAL,
	FloatPacking,
	FlyController,
	FocusController,
	FogParams,
	FolderHandler,
	Font,
	FontHandler,
	ForwardRenderer,
	FramePass,
	FramePassBloom,
	FramePassCameraFrame,
	FramePassColorGrab,
	FramePassDof,
	Frustum,
	GAMMA_NONE,
	GAMMA_SRGB,
	GIZMOAXIS_FACE,
	GIZMOAXIS_X,
	GIZMOAXIS_XY,
	GIZMOAXIS_XYZ,
	GIZMOAXIS_XZ,
	GIZMOAXIS_Y,
	GIZMOAXIS_YZ,
	GIZMOAXIS_Z,
	GIZMOSPACE_LOCAL,
	GIZMOSPACE_WORLD,
	GSPLATDATA_COMPACT,
	GSPLATDATA_LARGE,
	GSPLAT_DEBUG_AABBS,
	GSPLAT_DEBUG_HEATMAP,
	GSPLAT_DEBUG_LOD,
	GSPLAT_DEBUG_NODE_AABBS,
	GSPLAT_DEBUG_NONE,
	GSPLAT_DEBUG_SH_UPDATE,
	GSPLAT_FORWARD,
	GSPLAT_RENDERER_AUTO,
	GSPLAT_RENDERER_COMPUTE,
	GSPLAT_RENDERER_RASTER_CPU_SORT,
	GSPLAT_RENDERER_RASTER_GPU_SORT,
	GSPLAT_SHADOW,
	GSPLAT_STREAM_INSTANCE,
	GSPLAT_STREAM_RESOURCE,
	GSplatComponent,
	GSplatComponentSystem,
	GSplatContainer,
	GSplatData,
	GSplatFormat,
	GSplatHandler,
	GSplatInstance,
	GSplatProcessor,
	GSplatResource,
	GSplatResourceBase,
	GSplatSogData,
	GSplatSogResource,
	GSplatVaryings,
	GamePads,
	GamepadSource,
	Geometry,
	Gizmo,
	GltfExporter,
	GraphNode,
	GraphicsDevice,
	HierarchyHandler,
	HtmlHandler,
	Http,
	I18n,
	INDEXFORMAT_UINT16,
	INDEXFORMAT_UINT32,
	INDEXFORMAT_UINT8,
	INTERPOLATION_CUBIC,
	INTERPOLATION_LINEAR,
	INTERPOLATION_STEP,
	ImageElement,
	IndexBuffer,
	IndexedList,
	InputConsumer,
	InputController,
	InputDelta,
	InputFrame,
	InputSource,
	JOINTTYPE_6DOF,
	JOINTTYPE_BALL,
	JOINTTYPE_FIXED,
	JOINTTYPE_HINGE,
	JOINTTYPE_SLIDER,
	JointComponent,
	JointComponentSystem,
	JsonHandler,
	JsonStandardMaterialParser,
	KEY_0,
	KEY_1,
	KEY_2,
	KEY_3,
	KEY_4,
	KEY_5,
	KEY_6,
	KEY_7,
	KEY_8,
	KEY_9,
	KEY_A,
	KEY_ADD,
	KEY_ALT,
	KEY_B,
	KEY_BACKSPACE,
	KEY_BACK_SLASH,
	KEY_C,
	KEY_CAPS_LOCK,
	KEY_CLOSE_BRACKET,
	KEY_COMMA,
	KEY_CONTEXT_MENU,
	KEY_CONTROL,
	KEY_D,
	KEY_DECIMAL,
	KEY_DELETE,
	KEY_DIVIDE,
	KEY_DOWN,
	KEY_E,
	KEY_END,
	KEY_ENTER,
	KEY_EQUAL,
	KEY_ESCAPE,
	KEY_F,
	KEY_F1,
	KEY_F10,
	KEY_F11,
	KEY_F12,
	KEY_F2,
	KEY_F3,
	KEY_F4,
	KEY_F5,
	KEY_F6,
	KEY_F7,
	KEY_F8,
	KEY_F9,
	KEY_G,
	KEY_H,
	KEY_HOME,
	KEY_I,
	KEY_INSERT,
	KEY_J,
	KEY_K,
	KEY_L,
	KEY_LEFT,
	KEY_M,
	KEY_META,
	KEY_MULTIPLY,
	KEY_N,
	KEY_NUMPAD_0,
	KEY_NUMPAD_1,
	KEY_NUMPAD_2,
	KEY_NUMPAD_3,
	KEY_NUMPAD_4,
	KEY_NUMPAD_5,
	KEY_NUMPAD_6,
	KEY_NUMPAD_7,
	KEY_NUMPAD_8,
	KEY_NUMPAD_9,
	KEY_O,
	KEY_OPEN_BRACKET,
	KEY_P,
	KEY_PAGE_DOWN,
	KEY_PAGE_UP,
	KEY_PAUSE,
	KEY_PERIOD,
	KEY_PRINT_SCREEN,
	KEY_Q,
	KEY_R,
	KEY_RETURN,
	KEY_RIGHT,
	KEY_S,
	KEY_SEMICOLON,
	KEY_SEPARATOR,
	KEY_SHIFT,
	KEY_SLASH,
	KEY_SPACE,
	KEY_SUBTRACT,
	KEY_T,
	KEY_TAB,
	KEY_U,
	KEY_UP,
	KEY_V,
	KEY_W,
	KEY_WINDOWS,
	KEY_X,
	KEY_Y,
	KEY_Z,
	Kernel,
	Key,
	Keyboard,
	KeyboardEvent,
	KeyboardMouseSource,
	LAYERID_DEPTH,
	LAYERID_IMMEDIATE,
	LAYERID_SKYBOX,
	LAYERID_UI,
	LAYERID_WORLD,
	LAYER_GIZMO,
	LAYER_HUD,
	LAYER_WORLD,
	LIGHTFALLOFF_INVERSESQUARED,
	LIGHTFALLOFF_LINEAR,
	LIGHTSHAPE_DISK,
	LIGHTSHAPE_PUNCTUAL,
	LIGHTSHAPE_RECT,
	LIGHTSHAPE_SPHERE,
	LIGHTTYPE_COUNT,
	LIGHTTYPE_DIRECTIONAL,
	LIGHTTYPE_OMNI,
	LIGHTTYPE_POINT,
	LIGHTTYPE_SPOT,
	LIGHT_COLOR_DIVIDER,
	LINECAP_BUTT,
	LINECAP_ROUND,
	LINECAP_SQUARE,
	LINEJOIN_BEVEL,
	LINEJOIN_MITER,
	LINEJOIN_ROUND,
	LINEWIDTH_SCREEN,
	LINEWIDTH_WORLD,
	Layer,
	LayerComposition,
	LayoutCalculator,
	LayoutChildComponent,
	LayoutChildComponentSystem,
	LayoutGroupComponent,
	LayoutGroupComponentSystem,
	Light,
	LightComponent,
	LightComponentSystem,
	LightingParams,
	Lightmapper,
	LitMaterial,
	LitOptions,
	LitShaderOptions,
	LocalizedAsset,
	MASK_AFFECT_DYNAMIC,
	MASK_AFFECT_LIGHTMAPPED,
	MASK_BAKE,
	MOTION_FREE,
	MOTION_LIMITED,
	MOTION_LOCKED,
	MOUSEBUTTON_LEFT,
	MOUSEBUTTON_MIDDLE,
	MOUSEBUTTON_NONE,
	MOUSEBUTTON_RIGHT,
	Mat3,
	Mat4,
	Material,
	MaterialHandler,
	Mesh,
	MeshInstance,
	MiniStats,
	Model,
	ModelComponent,
	ModelComponentSystem,
	ModelHandler,
	Morph,
	MorphInstance,
	MorphTarget,
	Mouse,
	MouseEvent,
	MultiTouchSource,
	Node,
	NullGraphicsDevice,
	ORIENTATION_HORIZONTAL,
	ORIENTATION_VERTICAL,
	OrbitController,
	OrientedBox,
	OutlineRenderer,
	PAD_1,
	PAD_2,
	PAD_3,
	PAD_4,
	PAD_DOWN,
	PAD_FACE_1,
	PAD_FACE_2,
	PAD_FACE_3,
	PAD_FACE_4,
	PAD_LEFT,
	PAD_L_SHOULDER_1,
	PAD_L_SHOULDER_2,
	PAD_L_STICK_BUTTON,
	PAD_L_STICK_X,
	PAD_L_STICK_Y,
	PAD_RIGHT,
	PAD_R_SHOULDER_1,
	PAD_R_SHOULDER_2,
	PAD_R_STICK_BUTTON,
	PAD_R_STICK_X,
	PAD_R_STICK_Y,
	PAD_SELECT,
	PAD_START,
	PAD_UP,
	PAD_VENDOR,
	PARTICLEMODE_CPU,
	PARTICLEMODE_GPU,
	PARTICLEORIENTATION_EMITTER,
	PARTICLEORIENTATION_SCREEN,
	PARTICLEORIENTATION_WORLD,
	PARTICLESORT_DISTANCE,
	PARTICLESORT_NEWER_FIRST,
	PARTICLESORT_NONE,
	PARTICLESORT_OLDER_FIRST,
	PIXELFORMAT_111110F,
	PIXELFORMAT_A8,
	PIXELFORMAT_ASTC_4x4,
	PIXELFORMAT_ASTC_4x4_SRGB,
	PIXELFORMAT_ATC_RGB,
	PIXELFORMAT_ATC_RGBA,
	PIXELFORMAT_BC6F,
	PIXELFORMAT_BC6UF,
	PIXELFORMAT_BC7,
	PIXELFORMAT_BC7_SRGBA,
	PIXELFORMAT_BGRA8,
	PIXELFORMAT_DEPTH,
	PIXELFORMAT_DEPTH16,
	PIXELFORMAT_DEPTHSTENCIL,
	PIXELFORMAT_DXT1,
	PIXELFORMAT_DXT1_SRGB,
	PIXELFORMAT_DXT3,
	PIXELFORMAT_DXT3_SRGBA,
	PIXELFORMAT_DXT5,
	PIXELFORMAT_DXT5_SRGBA,
	PIXELFORMAT_ETC1,
	PIXELFORMAT_ETC2_RGB,
	PIXELFORMAT_ETC2_RGBA,
	PIXELFORMAT_ETC2_SRGB,
	PIXELFORMAT_ETC2_SRGBA,
	PIXELFORMAT_L8,
	PIXELFORMAT_L8_A8,
	PIXELFORMAT_LA8,
	PIXELFORMAT_PVRTC_2BPP_RGBA_1,
	PIXELFORMAT_PVRTC_2BPP_RGB_1,
	PIXELFORMAT_PVRTC_4BPP_RGBA_1,
	PIXELFORMAT_PVRTC_4BPP_RGB_1,
	PIXELFORMAT_R16F,
	PIXELFORMAT_R16I,
	PIXELFORMAT_R16U,
	PIXELFORMAT_R32F,
	PIXELFORMAT_R32I,
	PIXELFORMAT_R32U,
	PIXELFORMAT_R4_G4_B4_A4,
	PIXELFORMAT_R5_G5_B5_A1,
	PIXELFORMAT_R5_G6_B5,
	PIXELFORMAT_R8,
	PIXELFORMAT_R8I,
	PIXELFORMAT_R8U,
	PIXELFORMAT_R8_G8_B8,
	PIXELFORMAT_R8_G8_B8_A8,
	PIXELFORMAT_RG16F,
	PIXELFORMAT_RG16I,
	PIXELFORMAT_RG16U,
	PIXELFORMAT_RG32F,
	PIXELFORMAT_RG32I,
	PIXELFORMAT_RG32U,
	PIXELFORMAT_RG8,
	PIXELFORMAT_RG8I,
	PIXELFORMAT_RG8S,
	PIXELFORMAT_RG8U,
	PIXELFORMAT_RGB10A2,
	PIXELFORMAT_RGB10A2U,
	PIXELFORMAT_RGB16F,
	PIXELFORMAT_RGB32F,
	PIXELFORMAT_RGB565,
	PIXELFORMAT_RGB8,
	PIXELFORMAT_RGB9E5,
	PIXELFORMAT_RGBA16F,
	PIXELFORMAT_RGBA16I,
	PIXELFORMAT_RGBA16U,
	PIXELFORMAT_RGBA32F,
	PIXELFORMAT_RGBA32I,
	PIXELFORMAT_RGBA32U,
	PIXELFORMAT_RGBA4,
	PIXELFORMAT_RGBA5551,
	PIXELFORMAT_RGBA8,
	PIXELFORMAT_RGBA8I,
	PIXELFORMAT_RGBA8S,
	PIXELFORMAT_RGBA8U,
	PIXELFORMAT_SBGRA8,
	PIXELFORMAT_SRGB,
	PIXELFORMAT_SRGB8,
	PIXELFORMAT_SRGBA,
	PIXELFORMAT_SRGBA8,
	PRIMITIVE_LINELOOP,
	PRIMITIVE_LINES,
	PRIMITIVE_LINESTRIP,
	PRIMITIVE_POINTS,
	PRIMITIVE_TRIANGLES,
	PRIMITIVE_TRIFAN,
	PRIMITIVE_TRISTRIP,
	PROJECTION_ORTHOGRAPHIC,
	PROJECTION_PERSPECTIVE,
	ParticleEmitter,
	ParticleSystemComponent,
	ParticleSystemComponentSystem,
	Picker,
	Plane,
	PlaneGeometry,
	Pose,
	PostEffect,
	PostEffectQueue,
	ProgramLibrary,
	QuadRender,
	Quat,
	RADIX_SORT_AUTO,
	RADIX_SORT_ONESWEEP,
	RADIX_SORT_PORTABLE,
	REFLECTIONSRC_CUBEMAP,
	REFLECTIONSRC_ENVATLAS,
	REFLECTIONSRC_ENVATLASHQ,
	REFLECTIONSRC_NONE,
	REFLECTIONSRC_SPHEREMAP,
	RENDERSTYLE_POINTS,
	RENDERSTYLE_SOLID,
	RENDERSTYLE_WIREFRAME,
	RESOLUTION_AUTO,
	RESOLUTION_FIXED,
	RIGIDBODY_ACTIVE_TAG,
	RIGIDBODY_CF_KINEMATIC_OBJECT,
	RIGIDBODY_CF_NORESPONSE_OBJECT,
	RIGIDBODY_CF_STATIC_OBJECT,
	RIGIDBODY_DISABLE_DEACTIVATION,
	RIGIDBODY_DISABLE_SIMULATION,
	RIGIDBODY_ISLAND_SLEEPING,
	RIGIDBODY_TYPE_DYNAMIC,
	RIGIDBODY_TYPE_KINEMATIC,
	RIGIDBODY_TYPE_STATIC,
	RIGIDBODY_WANTS_DEACTIVATION,
	Ray,
	RaycastResult,
	ReadStream,
	RenderComponent,
	RenderComponentSystem,
	RenderHandler,
	RenderPass,
	RenderPassCompose,
	RenderPassDepthAwareBlur,
	RenderPassDownsample,
	RenderPassForward,
	RenderPassPicker,
	RenderPassPrepass,
	RenderPassShaderQuad,
	RenderPassSsao,
	RenderPassTAA,
	RenderPassUpsample,
	RenderTarget,
	RenderView,
	ResourceHandler,
	ResourceLoader,
	RigidBodyComponent,
	RigidBodyComponentSystem,
	RotateGizmo,
	SAMPLETYPE_DEPTH,
	SAMPLETYPE_FLOAT,
	SAMPLETYPE_INT,
	SAMPLETYPE_UINT,
	SAMPLETYPE_UNFILTERABLE_FLOAT,
	SCALEMODE_BLEND,
	SCALEMODE_NONE,
	SCROLLBAR_VISIBILITY_SHOW_ALWAYS,
	SCROLLBAR_VISIBILITY_SHOW_WHEN_REQUIRED,
	SCROLL_MODE_BOUNCE,
	SCROLL_MODE_CLAMP,
	SCROLL_MODE_INFINITE,
	SEMANTIC_ATTR0,
	SEMANTIC_ATTR1,
	SEMANTIC_ATTR10,
	SEMANTIC_ATTR11,
	SEMANTIC_ATTR12,
	SEMANTIC_ATTR13,
	SEMANTIC_ATTR14,
	SEMANTIC_ATTR15,
	SEMANTIC_ATTR2,
	SEMANTIC_ATTR3,
	SEMANTIC_ATTR4,
	SEMANTIC_ATTR5,
	SEMANTIC_ATTR6,
	SEMANTIC_ATTR7,
	SEMANTIC_ATTR8,
	SEMANTIC_ATTR9,
	SEMANTIC_BLENDINDICES,
	SEMANTIC_BLENDWEIGHT,
	SEMANTIC_COLOR,
	SEMANTIC_NORMAL,
	SEMANTIC_POSITION,
	SEMANTIC_TANGENT,
	SEMANTIC_TEXCOORD,
	SEMANTIC_TEXCOORD0,
	SEMANTIC_TEXCOORD1,
	SEMANTIC_TEXCOORD2,
	SEMANTIC_TEXCOORD3,
	SEMANTIC_TEXCOORD4,
	SEMANTIC_TEXCOORD5,
	SEMANTIC_TEXCOORD6,
	SEMANTIC_TEXCOORD7,
	SHADERDEF_BATCH,
	SHADERDEF_DIRLM,
	SHADERDEF_INSTANCING,
	SHADERDEF_LM,
	SHADERDEF_LMAMBIENT,
	SHADERDEF_MORPH_NORMAL,
	SHADERDEF_MORPH_POSITION,
	SHADERDEF_MORPH_TEXTURE_BASED_INT,
	SHADERDEF_NOSHADOW,
	SHADERDEF_SCREENSPACE,
	SHADERDEF_SKIN,
	SHADERDEF_TANGENTS,
	SHADERDEF_UV0,
	SHADERDEF_UV1,
	SHADERDEF_VCOLOR,
	SHADERLANGUAGE_GLSL,
	SHADERLANGUAGE_WGSL,
	SHADERPASS_ALBEDO,
	SHADERPASS_AO,
	SHADERPASS_EMISSION,
	SHADERPASS_FORWARD,
	SHADERPASS_GLOSS,
	SHADERPASS_LIGHTING,
	SHADERPASS_METALNESS,
	SHADERPASS_OPACITY,
	SHADERPASS_SPECULARITY,
	SHADERPASS_UV0,
	SHADERPASS_WORLDNORMAL,
	SHADERSTAGE_COMPUTE,
	SHADERSTAGE_FRAGMENT,
	SHADERSTAGE_VERTEX,
	SHADERTAG_MATERIAL,
	SHADER_DEPTH_PICK,
	SHADER_FORWARD,
	SHADER_PICK,
	SHADER_PREPASS,
	SHADER_SHADOW,
	SHADOWCAMERA_NAME,
	SHADOWUPDATE_NONE,
	SHADOWUPDATE_REALTIME,
	SHADOWUPDATE_THISFRAME,
	SHADOW_CASCADE_0,
	SHADOW_CASCADE_1,
	SHADOW_CASCADE_2,
	SHADOW_CASCADE_3,
	SHADOW_CASCADE_ALL,
	SHADOW_PCF1,
	SHADOW_PCF1_16F,
	SHADOW_PCF1_32F,
	SHADOW_PCF3,
	SHADOW_PCF3_16F,
	SHADOW_PCF3_32F,
	SHADOW_PCF5,
	SHADOW_PCF5_16F,
	SHADOW_PCF5_32F,
	SHADOW_PCSS_32F,
	SHADOW_VSM16,
	SHADOW_VSM32,
	SHADOW_VSM_16F,
	SHADOW_VSM_32F,
	SKYTYPE_BOX,
	SKYTYPE_DOME,
	SKYTYPE_INFINITE,
	SORTMODE_BACK2FRONT,
	SORTMODE_CUSTOM,
	SORTMODE_FRONT2BACK,
	SORTMODE_MANUAL,
	SORTMODE_MATERIALMESH,
	SORTMODE_NONE,
	SPECOCC_AO,
	SPECOCC_GLOSSDEPENDENT,
	SPECOCC_NONE,
	SPRITETYPE_ANIMATED,
	SPRITETYPE_SIMPLE,
	SPRITE_RENDERMODE_SIMPLE,
	SPRITE_RENDERMODE_SLICED,
	SPRITE_RENDERMODE_TILED,
	SSAOTYPE_COMBINE,
	SSAOTYPE_LIGHTING,
	SSAOTYPE_NONE,
	STENCILOP_DECREMENT,
	STENCILOP_DECREMENTWRAP,
	STENCILOP_INCREMENT,
	STENCILOP_INCREMENTWRAP,
	STENCILOP_INVERT,
	STENCILOP_KEEP,
	STENCILOP_REPLACE,
	STENCILOP_ZERO,
	ScaleGizmo,
	Scene,
	SceneHandler,
	SceneRegistry,
	SceneRegistryItem,
	SceneSettingsHandler,
	ScopeId,
	ScopeSpace,
	ScreenComponent,
	ScreenComponentSystem,
	Script,
	ScriptAttributes,
	ScriptComponent,
	ScriptComponentSystem,
	ScriptHandler,
	ScriptRegistry,
	ScriptType,
	ScrollViewComponent,
	ScrollViewComponentSystem,
	ScrollbarComponent,
	ScrollbarComponentSystem,
	Shader,
	ShaderChunks,
	ShaderHandler,
	ShaderMaterial,
	ShaderPass,
	ShaderUtils,
	SingleContactResult,
	SingleGestureSource,
	Skeleton,
	Skin,
	SkinBatchInstance,
	SkinInstance,
	Sky,
	SortedLoopArray,
	Sound,
	SoundComponent,
	SoundComponentSystem,
	SoundInstance,
	SoundInstance3d,
	SoundManager,
	SoundSlot,
	SphereGeometry,
	Sprite,
	SpriteAnimationClip,
	SpriteComponent,
	SpriteComponentSystem,
	SpriteHandler,
	StandardMaterial,
	StandardMaterialOptions,
	StencilParameters,
	StorageBuffer,
	TEXHINT_ASSET,
	TEXHINT_LIGHTMAP,
	TEXHINT_NONE,
	TEXHINT_SHADOWMAP,
	TEXPROPERTY_ADDRESS_U,
	TEXPROPERTY_ADDRESS_V,
	TEXPROPERTY_ADDRESS_W,
	TEXPROPERTY_ALL,
	TEXPROPERTY_ANISOTROPY,
	TEXPROPERTY_COMPARE_FUNC,
	TEXPROPERTY_COMPARE_ON_READ,
	TEXPROPERTY_MAG_FILTER,
	TEXPROPERTY_MIN_FILTER,
	TEXTUREDIMENSION_1D,
	TEXTUREDIMENSION_2D,
	TEXTUREDIMENSION_2D_ARRAY,
	TEXTUREDIMENSION_3D,
	TEXTUREDIMENSION_CUBE,
	TEXTUREDIMENSION_CUBE_ARRAY,
	TEXTURELOCK_NONE,
	TEXTURELOCK_READ,
	TEXTURELOCK_WRITE,
	TEXTUREPROJECTION_CUBE,
	TEXTUREPROJECTION_EQUIRECT,
	TEXTUREPROJECTION_NONE,
	TEXTUREPROJECTION_OCTAHEDRAL,
	TEXTURETYPE_DEFAULT,
	TEXTURETYPE_RGBE,
	TEXTURETYPE_RGBM,
	TEXTURETYPE_RGBP,
	TEXTURETYPE_SWIZZLEGGGR,
	TONEMAP_ACES,
	TONEMAP_ACES2,
	TONEMAP_FILMIC,
	TONEMAP_HEJL,
	TONEMAP_LINEAR,
	TONEMAP_NEUTRAL,
	TONEMAP_NONE,
	TRACEID_ASSETS,
	TRACEID_BINDGROUPFORMAT_ALLOC,
	TRACEID_BINDGROUP_ALLOC,
	TRACEID_BUFFERS,
	TRACEID_COMPUTEPIPELINE_ALLOC,
	TRACEID_ELEMENT,
	TRACEID_GPU_TIMINGS,
	TRACEID_OCTREE_RESOURCES,
	TRACEID_PIPELINELAYOUT_ALLOC,
	TRACEID_RENDERPIPELINE_ALLOC,
	TRACEID_RENDER_ACTION,
	TRACEID_RENDER_FRAME,
	TRACEID_RENDER_FRAME_TIME,
	TRACEID_RENDER_PASS,
	TRACEID_RENDER_PASS_DETAIL,
	TRACEID_RENDER_QUEUE,
	TRACEID_RENDER_TARGET_ALLOC,
	TRACEID_SHADER_ALLOC,
	TRACEID_SHADER_COMPILE,
	TRACEID_TEXTURES,
	TRACEID_TEXTURE_ALLOC,
	TRACEID_VRAM_IB,
	TRACEID_VRAM_SB,
	TRACEID_VRAM_TEXTURE,
	TRACEID_VRAM_VB,
	TYPE_FLOAT16,
	TYPE_FLOAT32,
	TYPE_INT16,
	TYPE_INT32,
	TYPE_INT8,
	TYPE_UINT16,
	TYPE_UINT32,
	TYPE_UINT8,
	Tags,
	Template,
	TemplateHandler,
	TextElement,
	TextHandler,
	Texture,
	TextureAtlas,
	TextureAtlasHandler,
	TextureHandler,
	TextureUtils,
	TextureView,
	TorusGeometry,
	Touch,
	TouchDevice,
	TouchEvent,
	Tracing,
	TransformFeedback,
	TransformGizmo,
	TranslateGizmo,
	Tri,
	UNIFORMTYPE_BOOL,
	UNIFORMTYPE_BOOLARRAY,
	UNIFORMTYPE_BVEC2,
	UNIFORMTYPE_BVEC2ARRAY,
	UNIFORMTYPE_BVEC3,
	UNIFORMTYPE_BVEC3ARRAY,
	UNIFORMTYPE_BVEC4,
	UNIFORMTYPE_BVEC4ARRAY,
	UNIFORMTYPE_FLOAT,
	UNIFORMTYPE_FLOATARRAY,
	UNIFORMTYPE_INT,
	UNIFORMTYPE_INTARRAY,
	UNIFORMTYPE_ITEXTURE2D,
	UNIFORMTYPE_ITEXTURE2D_ARRAY,
	UNIFORMTYPE_ITEXTURE3D,
	UNIFORMTYPE_ITEXTURECUBE,
	UNIFORMTYPE_IVEC2,
	UNIFORMTYPE_IVEC2ARRAY,
	UNIFORMTYPE_IVEC3,
	UNIFORMTYPE_IVEC3ARRAY,
	UNIFORMTYPE_IVEC4,
	UNIFORMTYPE_IVEC4ARRAY,
	UNIFORMTYPE_MAT2,
	UNIFORMTYPE_MAT3,
	UNIFORMTYPE_MAT4,
	UNIFORMTYPE_MAT4ARRAY,
	UNIFORMTYPE_TEXTURE2D,
	UNIFORMTYPE_TEXTURE2D_ARRAY,
	UNIFORMTYPE_TEXTURE2D_SHADOW,
	UNIFORMTYPE_TEXTURE3D,
	UNIFORMTYPE_TEXTURECUBE,
	UNIFORMTYPE_TEXTURECUBE_SHADOW,
	UNIFORMTYPE_UINT,
	UNIFORMTYPE_UINTARRAY,
	UNIFORMTYPE_UTEXTURE2D,
	UNIFORMTYPE_UTEXTURE2D_ARRAY,
	UNIFORMTYPE_UTEXTURE3D,
	UNIFORMTYPE_UTEXTURECUBE,
	UNIFORMTYPE_UVEC2,
	UNIFORMTYPE_UVEC2ARRAY,
	UNIFORMTYPE_UVEC3,
	UNIFORMTYPE_UVEC3ARRAY,
	UNIFORMTYPE_UVEC4,
	UNIFORMTYPE_UVEC4ARRAY,
	UNIFORMTYPE_VEC2,
	UNIFORMTYPE_VEC2ARRAY,
	UNIFORMTYPE_VEC3,
	UNIFORMTYPE_VEC3ARRAY,
	UNIFORMTYPE_VEC4,
	UNIFORMTYPE_VEC4ARRAY,
	UNIFORM_BUFFER_DEFAULT_SLOT_NAME,
	UNUSED_UNIFORM_NAME,
	URI,
	UniformBufferFormat,
	UniformFormat,
	UsdzExporter,
	VIEW_CENTER,
	VIEW_LEFT,
	VIEW_RIGHT,
	Vec2,
	Vec3,
	Vec4,
	VertexBuffer,
	VertexFormat,
	VertexIterator,
	ViewCube,
	WORKBUFFER_UPDATE_ALWAYS,
	WORKBUFFER_UPDATE_AUTO,
	WORKBUFFER_UPDATE_ONCE,
	WasmModule,
	WebglGraphicsDevice,
	WebgpuGraphicsDevice,
	WideLine,
	WideLineRenderer,
	WorldClusters,
	XRDEPTHSENSINGFORMAT_F32,
	XRDEPTHSENSINGFORMAT_L8A8,
	XRDEPTHSENSINGFORMAT_R16U,
	XRDEPTHSENSINGUSAGE_CPU,
	XRDEPTHSENSINGUSAGE_GPU,
	XREYE_LEFT,
	XREYE_NONE,
	XREYE_RIGHT,
	XRHAND_LEFT,
	XRHAND_NONE,
	XRHAND_RIGHT,
	XRPAD_A,
	XRPAD_B,
	XRPAD_SQUEEZE,
	XRPAD_STICK_BUTTON,
	XRPAD_STICK_X,
	XRPAD_STICK_Y,
	XRPAD_TOUCHPAD_BUTTON,
	XRPAD_TOUCHPAD_X,
	XRPAD_TOUCHPAD_Y,
	XRPAD_TRIGGER,
	XRSPACE_BOUNDEDFLOOR,
	XRSPACE_LOCAL,
	XRSPACE_LOCALFLOOR,
	XRSPACE_UNBOUNDED,
	XRSPACE_VIEWER,
	XRTARGETRAY_GAZE,
	XRTARGETRAY_POINTER,
	XRTARGETRAY_SCREEN,
	XRTRACKABLE_MESH,
	XRTRACKABLE_PLANE,
	XRTRACKABLE_POINT,
	XRTYPE_AR,
	XRTYPE_INLINE,
	XRTYPE_VR,
	XrAnchor,
	XrAnchors,
	XrDomOverlay,
	XrFinger,
	XrHand,
	XrHitTest,
	XrHitTestSource,
	XrImageTracking,
	XrInput,
	XrInputSource,
	XrJoint,
	XrLightEstimation,
	XrManager,
	XrMeshDetection,
	XrPlane,
	XrPlaneDetection,
	XrTrackedImage,
	XrView,
	XrViews,
	ZoneComponent,
	ZoneComponentSystem,
	ambientSrcNames,
	app,
	basisInitialize,
	bindGroupNames,
	blendNames,
	calculateNormals,
	calculateTangents,
	createBox,
	createCapsule,
	createCone,
	createCylinder,
	createGraphicsDevice,
	createMesh2 as createMesh,
	createPlane,
	createScript,
	createShader,
	createShaderFromCode,
	createSphere,
	createTorus,
	createURI,
	cubemaProjectionNames,
	ditherNames,
	dracoDecode,
	dracoInitialize,
	drawFullscreenQuad,
	drawQuadWithShader,
	extend,
	fresnelNames,
	gammaNames,
	getGlslShaderType,
	getPixelFormatArrayType,
	getReservedScriptNames,
	getTouchTargetCoords,
	getWgslShaderType,
	guid,
	http,
	indexFormatByteSize,
	isCompressedPixelFormat,
	isIntegerPixelFormat,
	isSrgbPixelFormat,
	lightFalloffNames,
	lightShapeNames,
	lightTypeNames,
	math,
	now,
	path,
	pixelFormatGammaToLinear,
	pixelFormatInfo,
	pixelFormatLinearToGamma,
	platform,
	primitiveGlslToWgslTypeMap,
	reflectionSrcNames,
	registerScript,
	reprojectTexture,
	requiresManualGamma,
	revision,
	script,
	semanticToLocation,
	shaderChunks,
	shadowTypeInfo,
	specularOcclusionNames,
	spriteRenderModeNames,
	string,
	tonemapNames,
	typedArrayIndexFormats,
	typedArrayIndexFormatsByteSize,
	typedArrayToType,
	typedArrayTypes,
	typedArrayTypesByteSize,
	uniformTypeToName,
	uniformTypeToNameMapWGSL,
	uniformTypeToNameWGSL,
	uniformTypeToStorage,
	version,
	vertexTypesNames
};
